
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("gyDUV", function(module, exports) {
$parcel$export(module.exports, "EditorCardProvider", () => $1990af432565a1d8$export$e4635c0135e1a519);
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $6kMSc = parcelRequire("6kMSc");

var $kSVgB = parcelRequire("kSVgB");

var $jrhh7 = parcelRequire("jrhh7");

var $hzN2E = parcelRequire("hzN2E");

var $jW4zs = parcelRequire("jW4zs");

var $6XuWH = parcelRequire("6XuWH");

var $2vbgR = parcelRequire("2vbgR");

var $dRkX9 = parcelRequire("dRkX9");

var $lO9y8 = parcelRequire("lO9y8");

var $6wiCN = parcelRequire("6wiCN");

var $fSsEE = parcelRequire("fSsEE");

var $aiCY8 = parcelRequire("aiCY8");
const $1990af432565a1d8$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $1990af432565a1d8$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $1990af432565a1d8$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $1990af432565a1d8$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $1990af432565a1d8$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $1990af432565a1d8$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $1990af432565a1d8$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
const $1990af432565a1d8$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = /\/wiki\/spaces\/?.*\/whiteboard\/(?<resourceId>\d+)(\?\/)?/;
// prettier-ignore
const $1990af432565a1d8$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = /\/wiki\/spaces\/?.*\/whiteboard\/(?<resourceId>[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12})(\?\/)?/;
const $1990af432565a1d8$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $1990af432565a1d8$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
const $1990af432565a1d8$var$LOOM_VIDEO_URL_REGEX = /^https:\/\/(.*?\.)?(loom\..*?\/(share|embed))\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})/;
// prettier-ignore
const $1990af432565a1d8$var$LOOM_PLAYLIST_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/(?:playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/view)?|embed\/playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|$)/i;
const $1990af432565a1d8$var$LOOM_SCREENSHOT_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/i\/(?<id>[a-f0-9]{32})/;
const $1990af432565a1d8$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $1990af432565a1d8$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $1990af432565a1d8$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
const $1990af432565a1d8$var$JIRA_PLAN_REGEX = /https:\/\/.*?\/jira\/plans\/(?<resourceId>\d+)/;
// prettier-ignore
const $1990af432565a1d8$var$JIRA_PLAN_WITH_SCENARIO_REGEX = /https:\/\/.*?\/jira\/plans\/(?<resourceId>\d+)\/scenarios\/(?<resourceContext>\d+)\/(timeline|summary|calendar|program\/\d+|dependencies)\/?/;
const $1990af432565a1d8$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $1990af432565a1d8$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $1990af432565a1d8$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $1990af432565a1d8$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $1990af432565a1d8$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
const $1990af432565a1d8$var$CONFLUENCE_TEAM_CALENDARS_REGEX = /\/wiki\/spaces\/(?<resourceContext>[^\/]+)\/calendars\/(?<resourceId>[a-zA-Z0-9-]+)/;
const $1990af432565a1d8$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $1990af432565a1d8$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $1990af432565a1d8$var$ARTIFACT_UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
// Keep in sync with ARTIFACT_URL_PATTERNS in @atlassian/native-embeds-artifacts-experience
const $1990af432565a1d8$var$ARTIFACT_SHARE_REGEX = [
    new RegExp(`/artifacts/${$1990af432565a1d8$var$ARTIFACT_UUID}(?:[/?#].*)?$`),
    new RegExp(`/apps/${$1990af432565a1d8$var$ARTIFACT_UUID}/${$1990af432565a1d8$var$ARTIFACT_UUID}/[^?#]*\\?(?:[^#]*&)?smartlink=artifact`)
];
const $1990af432565a1d8$var$DASHBOARDS_CHART_VIEW_REGEX = /^https:\/\/.*?\/dashboards\/c\/[^\/]+.*/;
const $1990af432565a1d8$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $1990af432565a1d8$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $1990af432565a1d8$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $1990af432565a1d8$var$isJiraRoadmapOrTimeline = (url)=>url.match($1990af432565a1d8$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $1990af432565a1d8$var$isPolarisView = (url)=>url.match($1990af432565a1d8$var$POLARIS_VIEW_REGEX);
const $1990af432565a1d8$var$isJwmView = (url)=>url.match($1990af432565a1d8$var$JWM_VIEW_REGEX);
const $1990af432565a1d8$var$isJiraList = (url)=>url.match($1990af432565a1d8$var$JIRA_LIST_REGEX);
const $1990af432565a1d8$var$isGiphyMedia = (url)=>url.match($1990af432565a1d8$var$GIPHY_MEDIA_REGEX);
const $1990af432565a1d8$var$isProformaView = (url)=>url.match($1990af432565a1d8$var$PROFORMA_VIEW_REGEX);
const $1990af432565a1d8$var$isConfluenceWhiteboard = (url)=>url.match($1990af432565a1d8$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($1990af432565a1d8$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $1990af432565a1d8$var$isConfluenceDatabase = (url)=>url.match($1990af432565a1d8$var$CONFLUENCE_DATABASE_REGEX);
const $1990af432565a1d8$var$isYoutubeVideo = (url)=>url.match($1990af432565a1d8$var$YOUTUBE_VIDEO_REGEX);
const $1990af432565a1d8$var$isLoomVideoUrl = (url)=>{
    return url.match($1990af432565a1d8$var$LOOM_VIDEO_URL_REGEX);
};
const $1990af432565a1d8$var$isLoomPlaylistUrl = (url)=>{
    return url.match($1990af432565a1d8$var$LOOM_PLAYLIST_URL_REGEX);
};
const $1990af432565a1d8$var$isLoomScreenshotUrl = (url)=>{
    return url.match($1990af432565a1d8$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $1990af432565a1d8$var$isJiraDashboard = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_DASHBOARD_REGEX);
};
const $1990af432565a1d8$var$isJiraBacklog = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_BACKLOG_REGEX);
};
const $1990af432565a1d8$var$isJiraBoard = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_BOARD_REGEX);
};
const $1990af432565a1d8$var$isJiraPlan = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_PLAN_REGEX) || url.match($1990af432565a1d8$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $1990af432565a1d8$var$isJiraVersion = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_VERSION_REGEX);
};
const $1990af432565a1d8$var$isJiraForm = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_FORM_REGEX);
};
const $1990af432565a1d8$var$isJiraSummary = (url)=>{
    return url.match($1990af432565a1d8$var$JIRA_SUMMARY_REGEX);
};
const $1990af432565a1d8$var$isRovoAgentProfilePage = (url)=>{
    return url.match($1990af432565a1d8$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $1990af432565a1d8$var$isCustomer360LandingPage = (url)=>url.match($1990af432565a1d8$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $1990af432565a1d8$var$isConfluenceTeamCalendars = (url)=>url.match($1990af432565a1d8$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $1990af432565a1d8$var$isJiraIssueNavigator = (url)=>url.match($1990af432565a1d8$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $1990af432565a1d8$var$isAvpVisualizationView = (url)=>url.match($1990af432565a1d8$var$AVP_VISUALIZATION_VIEW_REGEX) || ((0, $dRkX9.fg)('platform_avp_viz_dashboard_link_embed') ? url.match($1990af432565a1d8$var$DASHBOARDS_CHART_VIEW_REGEX) : null);
const $1990af432565a1d8$var$isArtifactsShareView = (url)=>{
    for (const pattern of $1990af432565a1d8$var$ARTIFACT_SHARE_REGEX){
        const match = url.match(pattern);
        if (match) return match;
    }
    return null;
};
const $1990af432565a1d8$export$6a9668b99d8a1708 = (url)=>$1990af432565a1d8$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $1990af432565a1d8$var$isConfluenceSlide = (url)=>(0, $aiCY8.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $1990af432565a1d8$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $1990af432565a1d8$var$isJiraRoadmapOrTimeline,
    isPolarisView: $1990af432565a1d8$var$isPolarisView,
    isJwmView: $1990af432565a1d8$var$isJwmView,
    isJiraList: $1990af432565a1d8$var$isJiraList,
    isConfluenceWhiteboard: $1990af432565a1d8$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $1990af432565a1d8$var$isConfluenceDatabase,
    isConfluenceSlide: $1990af432565a1d8$var$isConfluenceSlide,
    isJiraDashboard: $1990af432565a1d8$var$isJiraDashboard,
    isJiraBacklog: $1990af432565a1d8$var$isJiraBacklog,
    isJiraBoard: $1990af432565a1d8$var$isJiraBoard,
    isJiraPlan: $1990af432565a1d8$var$isJiraPlan,
    isJiraVersion: $1990af432565a1d8$var$isJiraVersion,
    isJiraForm: $1990af432565a1d8$var$isJiraForm,
    isJiraSummary: $1990af432565a1d8$var$isJiraSummary,
    isRovoAgentProfilePage: $1990af432565a1d8$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $1990af432565a1d8$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $1990af432565a1d8$var$isJiraIssueNavigator
};
function $1990af432565a1d8$export$4006295459a20a0(url) {
    return Object.values($1990af432565a1d8$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $1990af432565a1d8$export$78234eee43b97e81(url) {
    return !$1990af432565a1d8$export$4006295459a20a0(url);
}
function $1990af432565a1d8$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $1990af432565a1d8$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $1990af432565a1d8$export$e4635c0135e1a519 extends (0, $2vbgR.NodeDataProvider) {
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super(), this.smartCardLocalCacheClient = (0, $6wiCN.SmartCardLocalCacheClient).getInstance();
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $hzN2E.getBaseUrl)(envKey);
        this.resolverUrl = (0, $jW4zs.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $fSsEE.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6kMSc)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $1990af432565a1d8$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $jrhh7.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $6XuWH.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the document cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the document cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response !== null && response !== void 0 && response.meta) {
                const status = (0, $6XuWH.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$1990af432565a1d8$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization') ? $1990af432565a1d8$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$1990af432565a1d8$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $6XuWH.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $6XuWH.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $lO9y8.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $1990af432565a1d8$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $1990af432565a1d8$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        var _this$providersData;
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = (_this$providersData = this.providersData) === null || _this$providersData === void 0 ? void 0 : _this$providersData.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        var _this$providersData2;
        if (!this.providersData) await this.loadProviderData();
        return (_this$providersData2 = this.providersData) === null || _this$providersData2 === void 0 ? void 0 : _this$providersData2.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $1990af432565a1d8$var$isJiraPlan(url);
        const isJiraFormEvaluated = $1990af432565a1d8$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $1990af432565a1d8$var$isJiraSummary(url);
        if ($1990af432565a1d8$var$isJiraRoadmapOrTimeline(url) || $1990af432565a1d8$var$isPolarisView(url) || $1990af432565a1d8$var$isJwmView(url) || $1990af432565a1d8$var$isJiraList(url) || $1990af432565a1d8$var$isGiphyMedia(url) || $1990af432565a1d8$var$isProformaView(url) || $1990af432565a1d8$var$isConfluenceWhiteboard(url) || $1990af432565a1d8$var$isConfluenceDatabase(url) || (0, $aiCY8.isConfluenceSlideUrl)(url) || $1990af432565a1d8$var$isYoutubeVideo(url) || $1990af432565a1d8$var$isLoomVideoUrl(url) || $1990af432565a1d8$var$isLoomPlaylistUrl(url) && (0, $dRkX9.fg)('loom-playlist-smartlink-embed-default') || $1990af432565a1d8$var$isLoomScreenshotUrl(url) && (0, $dRkX9.fg)('loom-support-screenshot-sl-resolution') || $1990af432565a1d8$var$isJiraDashboard(url) || $1990af432565a1d8$var$isJiraBacklog(url) || $1990af432565a1d8$var$isJiraBoard(url) || $1990af432565a1d8$var$isRovoAgentProfilePage(url) || $1990af432565a1d8$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $1990af432565a1d8$var$isCustomer360LandingPage(url) || $1990af432565a1d8$var$isJiraIssueNavigator(url) || $1990af432565a1d8$var$isAvpVisualizationView(url) || $1990af432565a1d8$var$isArtifactsShareView(url) && (0, $dRkX9.fg)('platform_forge_ui_artifact_confluence_integration')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $6XuWH.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $kSVgB.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ($1990af432565a1d8$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                const data = await this.fetchDataForResource(url);
                if (data) {
                    const issueAri = this.extractAriFromData(data);
                    if (issueAri) {
                        var _this$onResolve;
                        (_this$onResolve = this.onResolve) === null || _this$onResolve === void 0 || _this$onResolve.call(this, url, issueAri);
                    }
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern === null || matchedProviderPattern === void 0 ? void 0 : matchedProviderPattern.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
}
const $1990af432565a1d8$export$b7c3c9a99f7959f5 = new $1990af432565a1d8$export$e4635c0135e1a519();

});
parcelRegister("lO9y8", function(module, exports) {
$parcel$export(module.exports, "request", () => $c6a8c4ea2ac09909$export$b5fe3f66a567bec0);
const $c6a8c4ea2ac09909$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $c6a8c4ea2ac09909$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $c6a8c4ea2ac09909$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $c6a8c4ea2ac09909$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $c6a8c4ea2ac09909$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("6wiCN", function(module, exports) {
$parcel$export(module.exports, "SmartCardLocalCacheClient", () => $f152a49a084f8c28$export$1987ad1ab31f2528);
const $f152a49a084f8c28$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $f152a49a084f8c28$export$1987ad1ab31f2528 {
    static #_ = this.instance = null;
    constructor(maxItems = $f152a49a084f8c28$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.documentCache = {};
        /**
   * Retrieves the entire cache object from memory
   * @returns The entire cache object
   */ this.getCache = ()=>{
            return this.documentCache;
        };
        /**
   * Caches the SmartLinkResponse against the provided url
   * @param url The url (key) to store the response against
   * @param response The SmartLinkResponse to be cached
   */ this.setItem = (url, response)=>{
            this.documentCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            const cacheKeys = Object.keys(this.documentCache);
            if (cacheKeys.length > this.maxItems) {
                const sortedKeys = cacheKeys.sort((a, b)=>this.documentCache[a].timestamp - this.documentCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.documentCache[key];
                });
            }
        };
        /**
   * Retrieves the cached SmartLinkResponse for the provided url (if it exists)
   * @param url The url (key) to retrieve the cached response for
   * @returns The cached SmartLinkResponse if it exists, else undefined
   */ this.getItem = (url)=>{
            var _this$documentCache$u;
            if (!url) return;
            return (_this$documentCache$u = this.documentCache[url]) === null || _this$documentCache$u === void 0 ? void 0 : _this$documentCache$u.data;
        };
        /**
   * Checks if a cached entry exists for the provided url
   * @param url The url (key) to check for existence in the cache
   * @returns True if a cached entry exists, else false
   */ this.isUrlInCache = (url)=>{
            return url in this.documentCache;
        };
        this.maxItems = maxItems;
    }
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $f152a49a084f8c28$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$f152a49a084f8c28$export$1987ad1ab31f2528.instance) $f152a49a084f8c28$export$1987ad1ab31f2528.instance = new $f152a49a084f8c28$export$1987ad1ab31f2528(maxItems);
        return $f152a49a084f8c28$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $f152a49a084f8c28$export$1987ad1ab31f2528.instance = null;
    }
}

});

parcelRegister("fSsEE", function(module, exports) {
$parcel$export(module.exports, "Transformer", () => $32f14e62e171285b$export$f993aef960936087);
class $32f14e62e171285b$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}

});


parcelRegister("2S4Eb", function(module, exports) {
$parcel$export(module.exports, "annotationPlugin", () => $cd25e6e9113dc746$export$df895cff1a8daaf7);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $eVKpX = parcelRequire("eVKpX");

var $9oAqi = parcelRequire("9oAqi");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $hNBI1 = parcelRequire("hNBI1");

var $e7esA = parcelRequire("e7esA");

var $CFHP6 = parcelRequire("CFHP6");

var $cayfj = parcelRequire("cayfj");

var $7ItCw = parcelRequire("7ItCw");

var $1xTLF = parcelRequire("1xTLF");

var $9179K = parcelRequire("9179K");

var $4SYRO = parcelRequire("4SYRO");

var $9RKIs = parcelRequire("9RKIs");
const $cd25e6e9113dc746$export$df895cff1a8daaf7 = ({ config: annotationProviders, api: api })=>{
    var _api$featureFlags, _api$analytics3;
    const featureFlags = api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState();
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    /**
   * Allows external editor UI, currently AI suggestions, to safely close an inline comment
   * without bypassing the provider's unsaved-content guard.
   */ const requestCloseInlineComment = async ()=>{
        try {
            const requestClose = annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.requestClose;
            if (!requestClose) return true;
            const canClose = await requestClose();
            if (!canClose) return false;
            return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $9179K.inlineCommentPluginKey), {
                    type: (0, $1xTLF.ACTIONS).CLOSE_COMPONENT
                });
                return tr;
            })) ?? false;
        } catch  {
            // Preserve the active comment if its close guard cannot complete.
            return false;
        }
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $9RKIs.getToolbarComponents)(api, annotationProviders));
    }
    return {
        name: 'annotation',
        marks () {
            return [
                {
                    name: 'annotation',
                    mark: (0, $e7esA.annotationWithToDOMFix)
                }
            ];
        },
        actions: {
            isBlockNodeSupported: (node)=>{
                var _annotationProviders$, _annotationProviders$2;
                return (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && (annotationProviders === null || annotationProviders === void 0 || (_annotationProviders$ = (_annotationProviders$2 = annotationProviders.inlineComment).isBlockNodeSupported) === null || _annotationProviders$ === void 0 ? void 0 : _annotationProviders$.call(_annotationProviders$2, node)) === true;
            },
            getAddCommentPermission: ()=>{
                var _annotationProviders$3, _annotationProviders$4;
                return {
                    canAddComments: (annotationProviders === null || annotationProviders === void 0 || (_annotationProviders$3 = (_annotationProviders$4 = annotationProviders.inlineComment).getCanAddComments) === null || _annotationProviders$3 === void 0 ? void 0 : _annotationProviders$3.call(_annotationProviders$4)) ?? true,
                    contentType: annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.contentType
                };
            },
            hasAnyUnResolvedAnnotationInPage: $9179K.hasAnyUnResolvedAnnotationInPage,
            requestCloseInlineComment: requestCloseInlineComment,
            stripNonExistingAnnotations: $9179K.stripNonExistingAnnotations,
            applyInlineCommentDraft: (annotationId)=>{
                var _api$analytics;
                return (0, $hNBI1.createAnnotation)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api)(annotationId, (0, $6DAwh.AnnotationTypes).INLINE_COMMENT, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.supportedBlockNodes, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.isBlockNodeSupported);
            },
            removeInlineCommentAnnotation: (annotationId)=>{
                var _api$analytics2;
                return (0, $hNBI1.removeInlineCommentFromDoc)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)(annotationId, (annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.supportedBlockNodes) ?? [], annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.isBlockNodeSupported);
            },
            setInlineCommentDraftState: (0, $hNBI1.setInlineCommentDraftState)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.supportedBlockNodes, undefined, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.isBlockNodeSupported, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.createCommentExperience),
            showCommentForBlockNode: (0, $hNBI1.showInlineCommentForBlockNode)(annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.supportedBlockNodes, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment.isBlockNodeSupported, annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.annotationManager),
            setSelectedAnnotation: $hNBI1.setSelectedAnnotation,
            setPendingSelectedAnnotation: $hNBI1.setPendingSelectedAnnotation
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $9179K.getPluginState)(editorState) || undefined;
            const clonedPluginState = Object.assign({}, pluginState);
            clonedPluginState === null || clonedPluginState === void 0 || delete clonedPluginState.featureFlagsPluginState;
            return {
                ...clonedPluginState,
                annotationManager: annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.annotationManager
            };
        },
        pmPlugins: ()=>[
                {
                    name: 'annotation',
                    plugin: ({ dispatch: dispatch })=>{
                        if (annotationProviders) {
                            var _api$analytics4;
                            return (0, $CFHP6.inlineCommentPlugin)({
                                dispatch: dispatch,
                                provider: annotationProviders.inlineComment,
                                editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions,
                                featureFlagsPluginState: featureFlags,
                                selectCommentExperience: annotationProviders.selectCommentExperience,
                                viewInlineCommentTraceUFOPress: annotationProviders.viewInlineCommentTraceUFOPress,
                                annotationManager: annotationProviders.annotationManager,
                                api: api
                            });
                        }
                        return;
                    }
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>{
                        if (annotationProviders) return (0, $cayfj.keymapPlugin)(api);
                        return;
                    }
                }
            ],
        pluginsOptions: {
            floatingToolbar (state) {
                const pluginState = (0, $9179K.getPluginState)(state);
                const bookmark = pluginState === null || pluginState === void 0 ? void 0 : pluginState.bookmark;
                if ((0, $7ItCw.shouldSuppressFloatingToolbar)({
                    state: state,
                    bookmark: bookmark
                })) return (0, $7ItCw.buildSuppressedToolbar)(state);
            },
            selectionToolbar (state, intl) {
                if (isToolbarAIFCEnabled) return;
                if (!annotationProviders) return;
                const pluginState = (0, $9179K.getPluginState)(state);
                if (pluginState && pluginState.isVisible && !pluginState.bookmark && !pluginState.mouseData.isSelecting) {
                    var _api$analytics5;
                    const { isToolbarAbove: isToolbarAbove, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments, contentType: contentType } = annotationProviders.inlineComment;
                    const toolbarConfig = (0, $7ItCw.buildToolbar)(api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions)({
                        state: state,
                        intl: intl,
                        isToolbarAbove: isToolbarAbove,
                        api: api,
                        createCommentExperience: annotationProviders.createCommentExperience,
                        annotationManager: annotationProviders.annotationManager,
                        onCommentButtonMount: onCommentButtonMount,
                        getCanAddComments: getCanAddComments,
                        contentType: contentType
                    });
                    if (!toolbarConfig) return undefined;
                    else return {
                        ...toolbarConfig,
                        rank: (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? 1 : undefined
                    };
                }
            }
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!annotationProviders || !editorView || (0, $eVKpX.isSSR)()) return null;
            return /*#__PURE__*/ (0, $3LM7S.jsx)($cd25e6e9113dc746$var$AnnotationContentComponent, {
                api: api,
                editorView: editorView,
                annotationProviders: annotationProviders,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
const $cd25e6e9113dc746$var$selector = (states)=>{
    var _states$annotationSta, _states$annotationSta2, _states$annotationSta3;
    return {
        isVisible: (_states$annotationSta = states.annotationState) === null || _states$annotationSta === void 0 ? void 0 : _states$annotationSta.isVisible,
        selectedAnnotations: (_states$annotationSta2 = states.annotationState) === null || _states$annotationSta2 === void 0 ? void 0 : _states$annotationSta2.selectedAnnotations,
        annotations: (_states$annotationSta3 = states.annotationState) === null || _states$annotationSta3 === void 0 ? void 0 : _states$annotationSta3.annotations
    };
};
function $cd25e6e9113dc746$var$AnnotationContentComponent({ api: api, editorView: editorView, annotationProviders: annotationProviders, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    var _api$analytics6;
    const annotationState = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $cd25e6e9113dc746$var$selector);
    // need to explicitly check for false as undefined is also a valid value to continue
    if ((annotationState === null || annotationState === void 0 ? void 0 : annotationState.isVisible) === false) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-editor-popup": "true",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4SYRO.InlineCommentView), {
            providers: annotationProviders,
            editorView: editorView,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions,
            editorAPI: api
        })
    });
}

});
parcelRegister("hNBI1", function(module, exports) {
$parcel$export(module.exports, "updateInlineCommentResolvedState", () => $ae6f89c6b0d7c007$export$4d8462ca3c146d0e);
$parcel$export(module.exports, "closeComponent", () => $ae6f89c6b0d7c007$export$da26c8d097933b72);
$parcel$export(module.exports, "clearDirtyMark", () => $ae6f89c6b0d7c007$export$ffa869a92c2481c3);
$parcel$export(module.exports, "setInlineCommentsFetched", () => $ae6f89c6b0d7c007$export$a3833f7fc842f6da);
$parcel$export(module.exports, "flushPendingSelections", () => $ae6f89c6b0d7c007$export$940b79a08b19cea6);
$parcel$export(module.exports, "setPendingSelectedAnnotation", () => $ae6f89c6b0d7c007$export$a99e2fe25edc1abd);
$parcel$export(module.exports, "removeInlineCommentNearSelection", () => $ae6f89c6b0d7c007$export$75bee4cee90040);
$parcel$export(module.exports, "removeInlineCommentFromDoc", () => $ae6f89c6b0d7c007$export$d087dc0f7213ba13);
$parcel$export(module.exports, "showInlineCommentForBlockNode", () => $ae6f89c6b0d7c007$export$d80af6562490622d);
$parcel$export(module.exports, "setInlineCommentDraftState", () => $ae6f89c6b0d7c007$export$2a7aec6fc438fa0b);
$parcel$export(module.exports, "updateMouseState", () => $ae6f89c6b0d7c007$export$ef4c42f03863dce9);
$parcel$export(module.exports, "setSelectedAnnotation", () => $ae6f89c6b0d7c007$export$1e715f68ff6f5a2f);
$parcel$export(module.exports, "setHoveredAnnotation", () => $ae6f89c6b0d7c007$export$c1805eee6fd0cf44);
$parcel$export(module.exports, "createAnnotation", () => $ae6f89c6b0d7c007$export$51eda81011da4982);
$parcel$export(module.exports, "setInlineCommentsVisibility", () => $ae6f89c6b0d7c007$export$c6dc86fb1ced7a07);

var $6DAwh = parcelRequire("6DAwh");

var $3LeME = parcelRequire("3LeME");

var $7tbCp = parcelRequire("7tbCp");

var $1fO1j = parcelRequire("1fO1j");

var $801jp = parcelRequire("801jp");

var $dRkX9 = parcelRequire("dRkX9");

var $8Lmfp = parcelRequire("8Lmfp");

var $1xTLF = parcelRequire("1xTLF");

var $9179K = parcelRequire("9179K");

var $5tfXu = parcelRequire("5tfXu");

var $5Wn5E = parcelRequire("5Wn5E");

var $4zRzs = parcelRequire("4zRzs");
const $ae6f89c6b0d7c007$export$4d8462ca3c146d0e = (editorAnalyticsAPI)=>(partialNewState, resolveMethod)=>{
        const command = {
            type: (0, $1xTLF.ACTIONS).UPDATE_INLINE_COMMENT_STATE,
            data: partialNewState
        };
        const allResolved = Object.values(partialNewState).every((state)=>state);
        // TODO: EDF-716 - This is nuking the scroll into view which occurs
        // when a comment is resolved. The problem is this is called when either a collab user or the current user resolves a comment.
        // and the problem is since cc is just dispatching an event through the provider to resolve the comment and this
        // is not comming via NCS, we have not way to know if this is a local or remote transaction.
        // To quickly fix this problem to unblock live pages this will just stop the transaction causing a scroll when the
        // resolve method is set.
        const transformer = (tr, state)=>resolveMethod === (0, $7tbCp.RESOLVE_METHOD).CONSUMER ? tr.setMeta('scrollIntoView', false) : tr;
        if (resolveMethod && allResolved) return (0, $8Lmfp.createCommand)(command, (tr, state)=>transformer((0, $5Wn5E.default).addResolveAnalytics(editorAnalyticsAPI)(resolveMethod)(tr, state), state));
        return (0, $8Lmfp.createCommand)(command, transformer);
    };
const $ae6f89c6b0d7c007$export$da26c8d097933b72 = ()=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).CLOSE_COMPONENT
    });
const $ae6f89c6b0d7c007$export$ffa869a92c2481c3 = ()=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).INLINE_COMMENT_CLEAR_DIRTY_MARK
    });
const $ae6f89c6b0d7c007$export$a3833f7fc842f6da = ()=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).SET_INLINE_COMMENTS_FETCHED
    });
const $ae6f89c6b0d7c007$export$940b79a08b19cea6 = (editorAnalyticsAPI)=>(canSetAsSelectedAnnotations, errorReason)=>{
        const command = {
            type: (0, $1xTLF.ACTIONS).FLUSH_PENDING_SELECTIONS,
            data: {
                canSetAsSelectedAnnotations: canSetAsSelectedAnnotations
            }
        };
        if (!!errorReason) return (0, $8Lmfp.createCommand)(command, (tr, state)=>(0, $5Wn5E.default).addPreemptiveGateErrorAnalytics(editorAnalyticsAPI)(errorReason)(tr, state));
        return (0, $8Lmfp.createCommand)(command);
    };
const $ae6f89c6b0d7c007$export$596a15f1f424d658 = (selectedAnnotations, options)=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).SET_PENDING_SELECTIONS,
        data: {
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: options === null || options === void 0 ? void 0 : options.selectAnnotationMethod,
            isOpeningMediaCommentFromToolbar: options === null || options === void 0 ? void 0 : options.isOpeningMediaCommentFromToolbar
        }
    });
const $ae6f89c6b0d7c007$export$a99e2fe25edc1abd = (id)=>$ae6f89c6b0d7c007$export$596a15f1f424d658([
        {
            id: id,
            type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        }
    ]);
const $ae6f89c6b0d7c007$var$removeInlineCommentFromNode = (id, supportedBlockNodes = [], isBlockNodeSupported, state, dispatch)=>{
    const { tr: tr, selection: selection } = state;
    const selectedNodeIsSupported = selection instanceof (0, $801jp.NodeSelection) && ((0, $9179K.isSupportedBlockNode)(selection.node, supportedBlockNodes, isBlockNodeSupported) || selection.node.type === state.schema.nodes.mediaSingle && !!selection.node.firstChild && (0, $9179K.isSupportedBlockNode)(selection.node.firstChild, supportedBlockNodes, isBlockNodeSupported));
    if (selectedNodeIsSupported) {
        const { $from: $from } = selection;
        let currNode = selection.node;
        let from = $from.start();
        // for media annotation, the selection is on media Single
        if (currNode.type === state.schema.nodes.mediaSingle && currNode.firstChild) {
            currNode = currNode.firstChild;
            from = from + 1;
        }
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = currNode.marks.some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        tr.removeNodeMark(from, annotationMarkType.create({
            id: id,
            type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};
const $ae6f89c6b0d7c007$export$75bee4cee90040 = (id, supportedNodes = [], isBlockNodeSupported)=>(state, dispatch)=>{
        const { tr: tr, selection: { $from: $from } } = state;
        if ($ae6f89c6b0d7c007$var$removeInlineCommentFromNode(id, supportedNodes, isBlockNodeSupported, state, dispatch)) return true;
        const { annotation: annotationMarkType } = state.schema.marks;
        const hasAnnotation = $from.marks().some((mark)=>mark.type === annotationMarkType);
        if (!hasAnnotation) return false;
        // just remove entire mark from around the node
        tr.removeMark($from.start(), $from.end(), annotationMarkType.create({
            id: id,
            type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        }));
        if (dispatch) dispatch(tr);
        return true;
    };
const $ae6f89c6b0d7c007$export$d087dc0f7213ba13 = (editorAnalyticsAPI)=>(id, supportedNodes = [], isBlockNodeSupported)=>(state, dispatch)=>{
            const { tr: tr } = state;
            state.doc.descendants((node, pos)=>{
                // Inline comment on mediaInline is not supported as part of comments on media project
                // Thus, we skip the decoration for mediaInline node
                if (node.type.name === 'mediaInline') return false;
                const isSupportedBlock = node.isBlock && (0, $9179K.isSupportedBlockNode)(node, supportedNodes, isBlockNodeSupported);
                node.marks.filter((mark)=>mark.type === state.schema.marks.annotation && mark.attrs.id === id).forEach((mark)=>{
                    if (isSupportedBlock) tr.removeNodeMark(pos, mark);
                    else tr.removeMark(pos, pos + node.nodeSize, mark);
                });
            });
            if (dispatch) {
                dispatch((0, $5Wn5E.default).addDeleteAnalytics(editorAnalyticsAPI)(tr, state));
                return true;
            }
            return false;
        };
const $ae6f89c6b0d7c007$var$getDraftCommandAction = (drafting, targetType, targetNodeId, supportedBlockNodes, isBlockNodeSupported, isOpeningMediaCommentFromToolbar)=>{
    return (editorState)=>{
        // validate selection only when entering draft mode
        if (drafting && (0, $9179K.isSelectionValid)(editorState, supportedBlockNodes, isBlockNodeSupported) !== (0, $5tfXu.AnnotationSelectionType).VALID) return false;
        return {
            type: (0, $1xTLF.ACTIONS).SET_INLINE_COMMENT_DRAFT_STATE,
            data: {
                drafting: drafting,
                editorState: editorState,
                targetType: targetType,
                supportedBlockNodes: supportedBlockNodes,
                isBlockNodeSupported: isBlockNodeSupported,
                targetNodeId: targetNodeId,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
            }
        };
    };
};
const $ae6f89c6b0d7c007$export$d80af6562490622d = (supportedBlockNodes = [], isBlockNodeSupported, annotationManager)=>(node, viewMethod, isOpeningMediaCommentFromToolbar)=>(state, dispatch)=>{
            const pluginState = (0, $9179K.getPluginState)(state);
            const { annotation: annotation } = state.schema.marks;
            if (node && node.isBlock && (0, $9179K.isSupportedBlockNode)(node, supportedBlockNodes, isBlockNodeSupported)) {
                const unresolvedAnnotationMarks = ((node === null || node === void 0 ? void 0 : node.marks) || []).filter((mark)=>mark.type === annotation && !(pluginState !== null && pluginState !== void 0 && pluginState.annotations[mark.attrs.id])).map((mark)=>({
                        id: mark.attrs.id,
                        type: mark.attrs.annotationType
                    }));
                if (unresolvedAnnotationMarks.length) {
                    if (dispatch) {
                        if (annotationManager) // Selecting directly would bypass the preemptive gate, discarding any unsaved
                        // comment. The plugin's view runs the gate on pending selections and flushes them.
                        $ae6f89c6b0d7c007$export$596a15f1f424d658(unresolvedAnnotationMarks, {
                            selectAnnotationMethod: viewMethod,
                            isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
                        })(state, dispatch);
                        else // bypass createCommand with setMeta
                        // so that external plugins can be aware of if there are active(unresolved) comments associated with the node
                        // i.e. media plugin can use the return result (true/false) to show toggle create comment component
                        dispatch(state.tr.setMeta((0, $9179K.inlineCommentPluginKey), {
                            type: (0, $1xTLF.ACTIONS).SET_SELECTED_ANNOTATION,
                            data: {
                                selectedAnnotations: unresolvedAnnotationMarks,
                                selectAnnotationMethod: viewMethod,
                                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar
                            }
                        }));
                        return true;
                    }
                }
            }
            return false;
        };
const $ae6f89c6b0d7c007$export$2a7aec6fc438fa0b = (editorAnalyticsAPI, supportedBlockNodes = [], api, isBlockNodeSupported, createCommentExperience)=>(drafting, inputMethod = (0, $3LeME.INPUT_METHOD).TOOLBAR, targetType = 'inline', targetNodeId, isOpeningMediaCommentFromToolbar)=>{
        const commandAction = $ae6f89c6b0d7c007$var$getDraftCommandAction(drafting, targetType, targetNodeId, supportedBlockNodes, isBlockNodeSupported, isOpeningMediaCommentFromToolbar);
        const draftCommand = !(api !== null && api !== void 0 && api.toolbar) ? (0, $8Lmfp.createCommand)(commandAction, (0, $5Wn5E.default).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod)) : undefined;
        return (state, dispatch, view)=>{
            // Start tracking only when a valid draft is dispatched, never during dry runs.
            const dispatchDraft = dispatch && drafting && targetType === 'block' && state.selection instanceof (0, $801jp.NodeSelection) && state.selection.node.type.name === 'extension' && state.selection.node.attrs.extensionKey === `${0, $1fO1j.NATIVE_EMBED_EXTENSION_KEY}:maui` && (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') ? (tr)=>{
                createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'block',
                        blockType: 'extension',
                        commentTargetType: 'remixEmbed',
                        entryPoint: 'highlightActions'
                    }
                });
                createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.initExperience.start();
                dispatch(tr);
            } : dispatch;
            if (Boolean(api === null || api === void 0 ? void 0 : api.toolbar)) {
                const newPluginState = commandAction(state);
                if (!newPluginState) return false;
                const tr = (0, $5Wn5E.default).handleDraftState(editorAnalyticsAPI)(drafting, inputMethod)(state.tr, state);
                if (tr && newPluginState) {
                    tr.setMeta((0, $9179K.inlineCommentPluginKey), newPluginState);
                    if (drafting) (0, $4zRzs.setUserIntent)(api, tr);
                    else (0, $4zRzs.resetUserIntent)(api, tr);
                    if (dispatchDraft) dispatchDraft(tr);
                } else return false;
                return true;
            }
            return draftCommand ? draftCommand(state, dispatchDraft, view) : false;
        };
    };
const $ae6f89c6b0d7c007$export$fd78ad47ea0892f4 = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes, isBlockNodeSupported)=>{
        const commandAction = (editorState)=>({
                type: (0, $1xTLF.ACTIONS).ADD_INLINE_COMMENT,
                data: {
                    drafting: false,
                    inlineComments: {
                        [id]: false
                    },
                    // Auto make the newly inserted comment selected.
                    // We move the selection to the head of the comment selection.
                    selectedAnnotations: [
                        {
                            id: id,
                            type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
                        }
                    ],
                    editorState: editorState
                }
            });
        if (Boolean(editorAPI === null || editorAPI === void 0 ? void 0 : editorAPI.toolbar)) return (state, dispatch)=>{
            const tr = (0, $5Wn5E.default).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes, isBlockNodeSupported)(state.tr, state);
            tr.setMeta((0, $9179K.inlineCommentPluginKey), commandAction(state));
            (0, $4zRzs.resetUserIntent)(editorAPI, tr);
            if (dispatch) {
                dispatch(tr);
                return true;
            }
            return false;
        };
        else return (0, $8Lmfp.createCommand)(commandAction, (0, $5Wn5E.default).addInlineComment(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes, isBlockNodeSupported));
    };
const $ae6f89c6b0d7c007$export$ef4c42f03863dce9 = (mouseData)=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).INLINE_COMMENT_UPDATE_MOUSE_STATE,
        data: {
            mouseData: mouseData
        }
    });
const $ae6f89c6b0d7c007$export$1e715f68ff6f5a2f = (id)=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).SET_SELECTED_ANNOTATION,
        data: {
            selectedAnnotations: [
                {
                    id: id,
                    type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $ae6f89c6b0d7c007$export$c1805eee6fd0cf44 = (id)=>(0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).SET_HOVERED_ANNOTATION,
        data: {
            hoveredAnnotations: [
                {
                    id: id,
                    type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
                }
            ]
        }
    });
const $ae6f89c6b0d7c007$export$51eda81011da4982 = (editorAnalyticsAPI, editorAPI)=>(id, annotationType = (0, $6DAwh.AnnotationTypes).INLINE_COMMENT, supportedBlockNodes, isBlockNodeSupported)=>(state, dispatch)=>{
            // don't try to add if there are is no temp highlight bookmarked
            const { bookmark: bookmark } = (0, $9179K.getPluginState)(state) || {};
            if (!bookmark || !dispatch) return false;
            if (annotationType === (0, $6DAwh.AnnotationTypes).INLINE_COMMENT) return $ae6f89c6b0d7c007$export$fd78ad47ea0892f4(editorAnalyticsAPI, editorAPI)(id, supportedBlockNodes, isBlockNodeSupported)(state, dispatch);
            return false;
        };
const $ae6f89c6b0d7c007$export$c6dc86fb1ced7a07 = (isVisible)=>{
    return (0, $8Lmfp.createCommand)({
        type: (0, $1xTLF.ACTIONS).INLINE_COMMENT_SET_VISIBLE,
        data: {
            isVisible: isVisible
        }
    });
};

});
parcelRegister("8Lmfp", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $f8d31e8410541a02$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $f8d31e8410541a02$export$8d4021544bdece00);

var $92jIL = parcelRequire("92jIL");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $eIqYe = parcelRequire("eIqYe");

var $9179K = parcelRequire("9179K");
/**
 * Creates a document-sync handler with a deleted annotations cache in its closure.
 */ const $f8d31e8410541a02$var$createHandleDocChanged = ()=>{
    // Cache for preserving deleted annotation resolved states through delete/undo cycles
    // This stays outside plugin state so the undo cache is not serialized.
    const deletedAnnotationsCache = {};
    return (tr, prevPluginState)=>{
        if (tr.getMeta('replaceDocument')) return {
            ...prevPluginState,
            dirtyAnnotations: true
        };
        const updatedState = $f8d31e8410541a02$var$getSelectionChangedHandler(false)(tr, prevPluginState);
        const legacyContentExperimentEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_fix_lcm_editor_annotations');
        const currentDiscovery = legacyContentExperimentEnabled ? (0, $9179K.getAnnotationDiscovery)(tr.doc) : undefined;
        const previousAnnotationIds = currentDiscovery ? new Set((0, $9179K.getAnnotationDiscovery)(tr.before).annotationIds) : undefined;
        const newNestedAnnotationIds = currentDiscovery ? currentDiscovery.nestedAnnotationIds.filter((id)=>!(previousAnnotationIds !== null && previousAnnotationIds !== void 0 && previousAnnotationIds.has(id)) && prevPluginState.annotations[id] === undefined && deletedAnnotationsCache[id] === undefined) : [];
        // Collect annotation IDs currently in the document
        const annotationIdsInDocument = currentDiscovery ? new Set([
            ...currentDiscovery.rootAnnotationIds,
            ...currentDiscovery.nestedAnnotationIds
        ]) : new Set();
        if (!currentDiscovery) tr.doc.descendants((node)=>{
            node.marks.forEach((mark)=>{
                if (mark.type.name === 'annotation') annotationIdsInDocument.add(mark.attrs.id);
            });
        });
        const annotationIdsInState = Object.keys(prevPluginState.annotations);
        // Early return if annotations haven't changed
        const annotationsHaveChanged = annotationIdsInDocument.size !== annotationIdsInState.length || annotationIdsInState.some((id)=>!annotationIdsInDocument.has(id));
        if (!annotationsHaveChanged) return newNestedAnnotationIds.length > 0 ? {
            ...updatedState,
            dirtyAnnotations: true
        } : updatedState;
        // Cache deleted annotations to be able to restore their resolved states on undo
        const updatedAnnotations = {};
        annotationIdsInState.forEach((id)=>{
            if (!annotationIdsInDocument.has(id)) deletedAnnotationsCache[id] = prevPluginState.annotations[id];
        });
        // Update annotations to match document state, preserving resolved states through delete/undo
        // Only include annotations that have a known resolved state - don't default new annotations to false
        // as this would cause them to briefly appear as unresolved before the provider sets their actual state
        annotationIdsInDocument.forEach((id)=>{
            const knownState = prevPluginState.annotations[id] ?? deletedAnnotationsCache[id];
            if (knownState !== undefined) updatedAnnotations[id] = knownState;
        });
        return {
            ...updatedState,
            annotations: updatedAnnotations,
            ...newNestedAnnotationIds.length > 0 && {
                dirtyAnnotations: true
            }
        };
    };
};
const $f8d31e8410541a02$export$58d7bae3d6fd3076 = (tr, editorState, bookmark)=>{
    if (editorState.selection.empty || !bookmark) return true;
    else if (editorState.selection instanceof (0, $801jp.NodeSelection)) {
        const bookmarkSelection = bookmark === null || bookmark === void 0 ? void 0 : bookmark.resolve(tr.doc);
        if (bookmarkSelection instanceof (0, $801jp.NodeSelection)) {
            const selectionNode = editorState.selection.node;
            const bookmarkNode = bookmarkSelection.node;
            /**
       * Currently, after updating the alt text of a mediaSingle node,
       * the selection moves to the media node.
       * (then will append a transaction to its parent node)
       */ if (selectionNode.type.name === 'media' && bookmarkNode.type.name === 'mediaSingle') {
                var _bookmarkNode$firstCh;
                return !((_bookmarkNode$firstCh = bookmarkNode.firstChild) !== null && _bookmarkNode$firstCh !== void 0 && _bookmarkNode$firstCh.eq(selectionNode));
            } else return !bookmarkNode.eq(selectionNode);
        }
    }
    // by default we discard bookmark
    return true;
};
const $f8d31e8410541a02$var$getSelectionChangeHandlerOld = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        if (// If pluginState.selectedAnnotations is annotations of block node, i.e. when a new comment is created,
        // we keep it as it is so that we can show comment view component with the newly created comment
        (0, $9179K.isBlockNodeAnnotationsSelected)(tr.selection, pluginState.selectedAnnotations)) return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $9179K.findAnnotationsInSelection)(tr.selection, tr.doc);
        if (selectedAnnotations.length === 0) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            isInlineCommentViewClosed: true,
            selectAnnotationMethod: undefined
        };
        if ((0, $9179K.isSelectedAnnotationsChanged)(selectedAnnotations, pluginState.selectedAnnotations)) return {
            ...pluginState,
            selectedAnnotations: selectedAnnotations,
            selectAnnotationMethod: undefined,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $f8d31e8410541a02$var$getSelectionChangeHandlerNew = (reopenCommentView)=>(tr, pluginState)=>{
        if (pluginState.skipSelectionHandling) return {
            ...pluginState,
            skipSelectionHandling: false,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        const selectedAnnotations = (0, $9179K.findAnnotationsInSelection)(tr.selection, tr.doc);
        // NOTE: I've left this commented code here as a reference that the previous old code would reset the selected annotations
        // if the selection is empty. If this is no longer needed, we can remove this code.
        // if (selectedAnnotations.length === 0) {
        // 	return {
        // 		...pluginState,
        // 		pendingSelectedAnnotations: selectedAnnotations,
        // 		pendingSelectedAnnotationsUpdateCount:
        // 			pluginState.pendingSelectedAnnotationsUpdateCount + 1,
        // 		isInlineCommentViewClosed: true,
        // 		selectAnnotationMethod: undefined,
        // 	};
        // }
        if ((0, $9179K.isSelectedAnnotationsChanged)(selectedAnnotations, pluginState.pendingSelectedAnnotations)) return {
            ...pluginState,
            pendingSelectedAnnotations: selectedAnnotations,
            pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            }
        };
        return {
            ...pluginState,
            ...reopenCommentView && {
                isInlineCommentViewClosed: false
            },
            selectAnnotationMethod: undefined
        };
    };
const $f8d31e8410541a02$var$getSelectionChangedHandler = (reopenCommentView)=>(tr, pluginState)=>pluginState.isAnnotationManagerEnabled ? // if platform_editor_comments_api_manager == true
        $f8d31e8410541a02$var$getSelectionChangeHandlerNew(reopenCommentView)(tr, pluginState) : // else if platform_editor_comments_api_manager == false
        $f8d31e8410541a02$var$getSelectionChangeHandlerOld(reopenCommentView)(tr, pluginState);
const $f8d31e8410541a02$var$createAnnotationPluginFactory = (onDocChanged)=>(0, $92jIL.pluginFactory)((0, $9179K.inlineCommentPluginKey), (0, $eIqYe.default), {
        onSelectionChanged: $f8d31e8410541a02$var$getSelectionChangedHandler(true),
        onDocChanged: onDocChanged,
        mapping: (tr, pluginState, editorState)=>{
            const { draftDecorationSet: draftDecorationSet, bookmark: bookmark } = pluginState;
            let mappedDecorationSet = (0, $16ZMX.DecorationSet).empty, mappedBookmark;
            let hasMappedDecorations = false;
            if (draftDecorationSet) mappedDecorationSet = draftDecorationSet.map(tr.mapping, tr.doc);
            hasMappedDecorations = mappedDecorationSet.find(undefined, undefined, (spec)=>Object.values((0, $9179K.decorationKey)).includes(spec.key)).length > 0;
            // When changes to decoration target make decoration invalid (e.g. delete text, add mark to node),
            // we need to reset bookmark to hide create component and to avoid invalid draft being published
            // We only perform this change when document selection has changed.
            if (!hasMappedDecorations && $f8d31e8410541a02$export$58d7bae3d6fd3076(tr, editorState, bookmark)) return {
                ...pluginState,
                draftDecorationSet: mappedDecorationSet,
                bookmark: undefined
            };
            if (bookmark) mappedBookmark = bookmark.map(tr.mapping);
            // return same pluginState if mappings did not change
            if (mappedBookmark === bookmark && mappedDecorationSet === draftDecorationSet) return pluginState;
            return {
                ...pluginState,
                draftDecorationSet: mappedDecorationSet,
                bookmark: mappedBookmark
            };
        }
    });
const $f8d31e8410541a02$var$handleDocChangedWithSync = $f8d31e8410541a02$var$createHandleDocChanged();
// Keep the control cohort's existing module-level cache lifetime unchanged.
const $f8d31e8410541a02$var$legacyDest = $f8d31e8410541a02$var$createAnnotationPluginFactory($f8d31e8410541a02$var$handleDocChangedWithSync);
const $f8d31e8410541a02$var$commandFactory = (0, $92jIL.pluginFactory)((0, $9179K.inlineCommentPluginKey), (0, $eIqYe.default));
const $f8d31e8410541a02$export$656c7661095efe2e = (dispatch, initialState)=>((0, $bcN2K.isExperimentEnabled)('platform_editor_fix_lcm_editor_annotations') ? $f8d31e8410541a02$var$createAnnotationPluginFactory($f8d31e8410541a02$var$createHandleDocChanged()) : $f8d31e8410541a02$var$legacyDest).createPluginState(dispatch, initialState);
const $f8d31e8410541a02$export$8d4021544bdece00 = $f8d31e8410541a02$var$commandFactory.createCommand;

});
parcelRegister("eIqYe", function(module, exports) {
$parcel$export(module.exports, "default", () => $cbff9872ca3ed07e$export$2e2bcd8739ae039);

var $16ZMX = parcelRequire("16ZMX");

var $1xTLF = parcelRequire("1xTLF");

var $9179K = parcelRequire("9179K");
var $cbff9872ca3ed07e$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $1xTLF.ACTIONS).SET_INLINE_COMMENTS_FETCHED:
            return {
                ...pluginState,
                annotationsLoaded: true
            };
        case (0, $1xTLF.ACTIONS).UPDATE_INLINE_COMMENT_STATE:
            return {
                ...pluginState,
                annotationsLoaded: true,
                annotations: {
                    ...pluginState.annotations,
                    ...action.data
                }
            };
        case (0, $1xTLF.ACTIONS).INLINE_COMMENT_UPDATE_MOUSE_STATE:
            const mouseData = Object.assign({}, pluginState.mouseData, action.data.mouseData);
            return {
                ...pluginState,
                mouseData: mouseData
            };
        case (0, $1xTLF.ACTIONS).SET_INLINE_COMMENT_DRAFT_STATE:
            return $cbff9872ca3ed07e$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState, action.data.targetType, action.data.supportedBlockNodes, action.data.isBlockNodeSupported, action.data.targetNodeId, action.data.isOpeningMediaCommentFromToolbar);
        case (0, $1xTLF.ACTIONS).INLINE_COMMENT_CLEAR_DIRTY_MARK:
            return {
                ...pluginState,
                dirtyAnnotations: false,
                annotations: {}
            };
        case (0, $1xTLF.ACTIONS).CLOSE_COMPONENT:
            return {
                ...pluginState,
                isInlineCommentViewClosed: true,
                isDrafting: false,
                isOpeningMediaCommentFromToolbar: false,
                selectedAnnotations: []
            };
        case (0, $1xTLF.ACTIONS).ADD_INLINE_COMMENT:
            const updatedPluginState = $cbff9872ca3ed07e$var$getNewDraftState(pluginState, action.data.drafting, action.data.editorState);
            return {
                ...updatedPluginState,
                selectedAnnotations: [
                    ...updatedPluginState.selectedAnnotations,
                    ...action.data.selectedAnnotations
                ],
                annotations: {
                    ...pluginState.annotations,
                    ...action.data.inlineComments
                },
                isInlineCommentViewClosed: false,
                selectAnnotationMethod: undefined,
                ...pluginState.isAnnotationManagerEnabled && {
                    skipSelectionHandling: true
                }
            };
        case (0, $1xTLF.ACTIONS).INLINE_COMMENT_SET_VISIBLE:
            const { isVisible: isVisible } = action.data;
            if (isVisible === pluginState.isVisible) return pluginState;
            return {
                ...isVisible ? pluginState : $cbff9872ca3ed07e$var$getNewDraftState(pluginState, false),
                isVisible: isVisible
            };
        case (0, $1xTLF.ACTIONS).SET_SELECTED_ANNOTATION:
            return {
                ...pluginState,
                selectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                selectAnnotationMethod: action.data.selectAnnotationMethod,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false,
                isOpeningMediaCommentFromToolbar: action.data.isOpeningMediaCommentFromToolbar
            };
        case (0, $1xTLF.ACTIONS).SET_HOVERED_ANNOTATION:
            return {
                ...pluginState,
                hoveredAnnotations: [
                    ...action.data.hoveredAnnotations
                ],
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        case (0, $1xTLF.ACTIONS).FLUSH_PENDING_SELECTIONS:
            return {
                ...pluginState,
                selectedAnnotations: action.data.canSetAsSelectedAnnotations ? [
                    ...pluginState.pendingSelectedAnnotations
                ] : pluginState.selectedAnnotations,
                ...action.data.canSetAsSelectedAnnotations && {
                    selectAnnotationMethod: pluginState.pendingSelectAnnotationMethod,
                    isOpeningMediaCommentFromToolbar: pluginState.pendingIsOpeningMediaCommentFromToolbar
                },
                pendingSelectedAnnotations: [],
                pendingSelectAnnotationMethod: undefined,
                pendingIsOpeningMediaCommentFromToolbar: undefined,
                isInlineCommentViewClosed: false
            };
        case (0, $1xTLF.ACTIONS).SET_PENDING_SELECTIONS:
            return {
                ...pluginState,
                pendingSelectedAnnotations: [
                    ...action.data.selectedAnnotations
                ],
                pendingSelectAnnotationMethod: action.data.selectAnnotationMethod,
                pendingIsOpeningMediaCommentFromToolbar: action.data.isOpeningMediaCommentFromToolbar,
                pendingSelectedAnnotationsUpdateCount: pluginState.pendingSelectedAnnotationsUpdateCount + 1,
                skipSelectionHandling: true,
                isInlineCommentViewClosed: false
            };
        default:
            return pluginState;
    }
};
function $cbff9872ca3ed07e$var$getNewDraftState(pluginState, drafting, editorState, targetType, supportedBlockNodes, isBlockNodeSupported, targetNodeId, isOpeningMediaCommentFromToolbar) {
    let { draftDecorationSet: draftDecorationSet } = pluginState;
    if (!draftDecorationSet || !drafting) draftDecorationSet = (0, $16ZMX.DecorationSet).empty;
    const newState = {
        ...pluginState,
        draftDecorationSet: draftDecorationSet,
        isDrafting: drafting,
        targetNodeId: targetNodeId
    };
    newState.bookmark = undefined;
    if (drafting && editorState) {
        newState.bookmark = editorState.selection.getBookmark();
        const { from: from, to: to } = (0, $9179K.resolveDraftBookmark)(editorState, newState.bookmark, supportedBlockNodes, isBlockNodeSupported);
        const draftDecoration = (0, $9179K.addDraftDecoration)(from, to, targetType);
        newState.draftDecorationSet = draftDecorationSet.add(editorState.doc, [
            draftDecoration
        ]);
    }
    newState.isOpeningMediaCommentFromToolbar = isOpeningMediaCommentFromToolbar;
    return newState;
}

});
parcelRegister("1xTLF", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $29f3c4f2dbdfca5f$export$92a1a3b7554e9387);
var $29f3c4f2dbdfca5f$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_INLINE_COMMENT_STATE"] = 0] = "UPDATE_INLINE_COMMENT_STATE";
    ACTIONS[ACTIONS["SET_INLINE_COMMENT_DRAFT_STATE"] = 1] = "SET_INLINE_COMMENT_DRAFT_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_UPDATE_MOUSE_STATE"] = 2] = "INLINE_COMMENT_UPDATE_MOUSE_STATE";
    ACTIONS[ACTIONS["INLINE_COMMENT_CLEAR_DIRTY_MARK"] = 3] = "INLINE_COMMENT_CLEAR_DIRTY_MARK";
    ACTIONS[ACTIONS["ADD_INLINE_COMMENT"] = 4] = "ADD_INLINE_COMMENT";
    ACTIONS[ACTIONS["INLINE_COMMENT_SET_VISIBLE"] = 5] = "INLINE_COMMENT_SET_VISIBLE";
    ACTIONS[ACTIONS["CLOSE_COMPONENT"] = 6] = "CLOSE_COMPONENT";
    ACTIONS[ACTIONS["SET_SELECTED_ANNOTATION"] = 7] = "SET_SELECTED_ANNOTATION";
    ACTIONS[ACTIONS["SET_HOVERED_ANNOTATION"] = 8] = "SET_HOVERED_ANNOTATION";
    ACTIONS[ACTIONS["FLUSH_PENDING_SELECTIONS"] = 9] = "FLUSH_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_PENDING_SELECTIONS"] = 10] = "SET_PENDING_SELECTIONS";
    ACTIONS[ACTIONS["SET_INLINE_COMMENTS_FETCHED"] = 11] = "SET_INLINE_COMMENTS_FETCHED";
    return ACTIONS;
}({});

});

parcelRegister("9179K", function(module, exports) {
$parcel$export(module.exports, "getAnnotationDiscovery", () => $bf996096d3c39a56$export$366c2b3983e955a4);
$parcel$export(module.exports, "getAllAnnotations", () => $bf996096d3c39a56$export$2ecc008effaefd6e);
$parcel$export(module.exports, "decorationKey", () => $bf996096d3c39a56$export$824a8ce0be7d4e38);
$parcel$export(module.exports, "addDraftDecoration", () => $bf996096d3c39a56$export$b3b680ab7872fa4c);
$parcel$export(module.exports, "getAnnotationViewKey", () => $bf996096d3c39a56$export$1832a9899106877a);
$parcel$export(module.exports, "shouldHideRemixAnnotation", () => $bf996096d3c39a56$export$4d7cdc53b5238d30);
$parcel$export(module.exports, "findAnnotationsInSelection", () => $bf996096d3c39a56$export$3bf994b39b13856a);
$parcel$export(module.exports, "resolveDraftBookmark", () => $bf996096d3c39a56$export$196f73a7cbac5e80);
$parcel$export(module.exports, "isSupportedBlockNode", () => $bf996096d3c39a56$export$bb7c9ea7da92cd01);
$parcel$export(module.exports, "getSelectionPositions", () => $bf996096d3c39a56$export$31c5af77b755d41f);
$parcel$export(module.exports, "inlineCommentPluginKey", () => $bf996096d3c39a56$export$544b399faf6001b7);
$parcel$export(module.exports, "getPluginState", () => $bf996096d3c39a56$export$f05434c51e3762e);
$parcel$export(module.exports, "getDraftCommandAnalyticsPayload", () => $bf996096d3c39a56$export$a28639698c912d2c);
$parcel$export(module.exports, "isSelectionValid", () => $bf996096d3c39a56$export$af7e6fc08350a63d);
$parcel$export(module.exports, "stripNonExistingAnnotations", () => $bf996096d3c39a56$export$ca9ec32b395faf65);
$parcel$export(module.exports, "isSelectedAnnotationsChanged", () => $bf996096d3c39a56$export$a411569b9111c88e);
$parcel$export(module.exports, "isBlockNodeAnnotationsSelected", () => $bf996096d3c39a56$export$e171deb7d9f0a865);
$parcel$export(module.exports, "hasAnyUnResolvedAnnotationInPage", () => $bf996096d3c39a56$export$98b0a2a6ba343064);

var $6DAwh = parcelRequire("6DAwh");

var $3LeME = parcelRequire("3LeME");

var $ls2OU = parcelRequire("ls2OU");

var $gHA4O = parcelRequire("gHA4O");

var $f1MDe = parcelRequire("f1MDe");

var $cu8Jp = parcelRequire("cu8Jp");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $5tfXu = parcelRequire("5tfXu");
function $bf996096d3c39a56$var$sum(arr, f) {
    return arr.reduce((val, x)=>val + f(x), 0);
}
const $bf996096d3c39a56$export$c023470e9a462982 = ($pos)=>{
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
    const markNodeBefore = nodeBefore && $pos.doc.nodeAt(Math.max(0, $pos.pos - nodeBefore.nodeSize - 1));
    const markNodeAfter = nodeAfter && $pos.doc.nodeAt($pos.pos + nodeAfter.nodeSize);
    return [
        markNodeBefore && markNodeBefore.marks || [],
        markNodeAfter && markNodeAfter.marks || []
    ];
};
/**
 * Finds annotation marks, and returns their IDs.
 * @param marks Array of marks to search in
 */ const $bf996096d3c39a56$var$filterAnnotationIds = (marks)=>{
    if (!marks.length) return [];
    const { annotation: annotation } = marks[0].type.schema.marks;
    return marks.filter((mark)=>mark.type === annotation).map((mark)=>mark.attrs.id);
};
/**
 * Re-orders the annotation array based on the order in the document.
 *
 * This places the marks that do not appear in the surrounding nodes
 * higher in the list. That is, the inner-most one appears first.
 *
 * Undo, for example, can re-order annotation marks in the document.
 * @param annotations annotation metadata
 * @param $from location to look around (usually the selection)
 */ const $bf996096d3c39a56$var$reorderAnnotations = (annotations, $from)=>{
    const idSet = $bf996096d3c39a56$export$c023470e9a462982($from).map($bf996096d3c39a56$var$filterAnnotationIds);
    annotations.sort((a, b)=>$bf996096d3c39a56$var$sum(idSet, (ids)=>ids.indexOf(a.id)) - $bf996096d3c39a56$var$sum(idSet, (ids)=>ids.indexOf(b.id)));
};
const $bf996096d3c39a56$var$legacyContentAnnotationsByDoc = new WeakMap();
const $bf996096d3c39a56$var$legacyContentAnnotationIdsByExtension = new WeakMap();
const $bf996096d3c39a56$var$readNestedContentNodes = (parameters)=>{
    if (!parameters || typeof parameters !== 'object') return undefined;
    const nestedContent = parameters.nestedContent;
    if (!nestedContent || typeof nestedContent !== 'object') return undefined;
    const nestedDocument = nestedContent;
    return nestedDocument.type === 'doc' && Array.isArray(nestedDocument.content) ? nestedDocument.content : undefined;
};
const $bf996096d3c39a56$var$getNestedContentAnnotationIds = (extension)=>{
    const cachedIds = $bf996096d3c39a56$var$legacyContentAnnotationIdsByExtension.get(extension);
    if (cachedIds) return cachedIds;
    const nestedNodes = $bf996096d3c39a56$var$readNestedContentNodes(extension.attrs.parameters);
    if (!nestedNodes) {
        const noIds = Object.freeze([]);
        $bf996096d3c39a56$var$legacyContentAnnotationIdsByExtension.set(extension, noIds);
        return noIds;
    }
    const annotationIds = new Set();
    const visitedAdfNodes = new WeakSet();
    const pending = [
        ...nestedNodes
    ].reverse();
    while(pending.length > 0){
        var _adfNode$attrs;
        const value = pending.pop();
        if (!value || typeof value !== 'object' || visitedAdfNodes.has(value)) continue;
        visitedAdfNodes.add(value);
        const adfNode = value;
        if (Array.isArray(adfNode.marks)) adfNode.marks.forEach((rawMark)=>{
            if (!rawMark || typeof rawMark !== 'object') return;
            const annotationMark = rawMark;
            const attrs = annotationMark.attrs;
            if (annotationMark.type !== 'annotation' || !$bf996096d3c39a56$var$validateAnnotationAttributes(attrs)) return;
            annotationIds.add(attrs.id);
        });
        if (adfNode.type === 'extension' && ((_adfNode$attrs = adfNode.attrs) === null || _adfNode$attrs === void 0 ? void 0 : _adfNode$attrs.extensionType) === 'com.atlassian.confluence.migration' && adfNode.attrs.extensionKey === 'legacy-content') {
            const nestedNodes = $bf996096d3c39a56$var$readNestedContentNodes(adfNode.attrs.parameters);
            if (nestedNodes) for(let i = nestedNodes.length - 1; i >= 0; i--)pending.push(nestedNodes[i]);
        }
        if (Array.isArray(adfNode.content)) for(let i = adfNode.content.length - 1; i >= 0; i--)pending.push(adfNode.content[i]);
    }
    const ids = Object.freeze([
        ...annotationIds
    ]);
    $bf996096d3c39a56$var$legacyContentAnnotationIdsByExtension.set(extension, ids);
    return ids;
};
const $bf996096d3c39a56$export$366c2b3983e955a4 = (doc)=>{
    const cachedDiscovery = $bf996096d3c39a56$var$legacyContentAnnotationsByDoc.get(doc);
    if (cachedDiscovery) return cachedDiscovery;
    const allAnnotationIds = new Set();
    const rootAnnotationIds = new Set();
    const nestedAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation').forEach((mark)=>{
            if ($bf996096d3c39a56$var$validateAnnotationMark(mark)) {
                rootAnnotationIds.add(mark.attrs.id);
                allAnnotationIds.add(mark.attrs.id);
            }
        });
        if (node.type.name === 'extension' && node.attrs.extensionType === 'com.atlassian.confluence.migration' && node.attrs.extensionKey === 'legacy-content') $bf996096d3c39a56$var$getNestedContentAnnotationIds(node).forEach((id)=>{
            nestedAnnotationIds.add(id);
            allAnnotationIds.add(id);
        });
        return true;
    });
    const discovery = {
        annotationIds: Object.freeze([
            ...allAnnotationIds
        ]),
        rootAnnotationIds: Object.freeze([
            ...rootAnnotationIds
        ]),
        nestedAnnotationIds: Object.freeze([
            ...nestedAnnotationIds
        ])
    };
    $bf996096d3c39a56$var$legacyContentAnnotationsByDoc.set(doc, discovery);
    return discovery;
};
const $bf996096d3c39a56$export$2ecc008effaefd6e = (doc)=>{
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_fix_lcm_editor_annotations')) return [
        ...$bf996096d3c39a56$export$366c2b3983e955a4(doc).annotationIds
    ];
    const allAnnotationIds = new Set();
    doc.descendants((node)=>{
        node.marks.filter((mark)=>mark.type.name === 'annotation')// filter out annotations with invalid attributes as they cause errors when interacting with them
        .filter($bf996096d3c39a56$var$validateAnnotationMark).forEach((m)=>allAnnotationIds.add(m.attrs.id));
        return true;
    });
    return Array.from(allAnnotationIds);
};
const $bf996096d3c39a56$var$validateAnnotationId = (id)=>{
    if (!id || typeof id !== 'string') return false;
    const invalidIds = [
        'null',
        'undefined'
    ];
    return !invalidIds.includes(id.toLowerCase());
};
const $bf996096d3c39a56$var$validateAnnotationType = (type)=>{
    if (!type || typeof type !== 'string') return false;
    const allowedTypes = Object.values((0, $6DAwh.AnnotationTypes));
    return allowedTypes.some((allowedType)=>allowedType === type);
};
const $bf996096d3c39a56$var$validateAnnotationAttributes = (attrs)=>{
    if (!attrs || typeof attrs !== 'object') return false;
    return 'id' in attrs && 'annotationType' in attrs && $bf996096d3c39a56$var$validateAnnotationId(attrs.id) && $bf996096d3c39a56$var$validateAnnotationType(attrs.annotationType);
};
const $bf996096d3c39a56$var$validateAnnotationMark = (annotationMark)=>$bf996096d3c39a56$var$validateAnnotationAttributes(annotationMark.attrs);
const $bf996096d3c39a56$export$824a8ce0be7d4e38 = {
    block: 'blockCommentDecoration',
    inline: 'inlineCommentDecoration'
};
const $bf996096d3c39a56$export$b3b680ab7872fa4c = (start, end, targetType = 'inline')=>{
    if (targetType === 'block') return (0, $16ZMX.Decoration).node(start, end, {
        class: `${(0, $gHA4O.BlockAnnotationSharedClassNames).draft}`
    }, {
        key: $bf996096d3c39a56$export$824a8ce0be7d4e38.block
    });
    return (0, $16ZMX.Decoration).inline(start, end, {
        class: `${(0, $gHA4O.AnnotationSharedClassNames).draft}`
    }, {
        key: $bf996096d3c39a56$export$824a8ce0be7d4e38.inline
    });
};
const $bf996096d3c39a56$export$1832a9899106877a = (annotations)=>{
    const keys = annotations.map((mark)=>mark.id).join('_');
    return `view-annotation-wrapper_${keys}`;
};
const $bf996096d3c39a56$var$isRemixExtension = (node)=>node.type.name === 'extension' && node.attrs.extensionKey === 'native-embed:maui';
const $bf996096d3c39a56$export$4d7cdc53b5238d30 = (node)=>$bf996096d3c39a56$var$isRemixExtension(node) && !(0, $dRkX9.fg)('cc_maui_annotations_on_extensions');
const $bf996096d3c39a56$export$3bf994b39b13856a = (selection, doc)=>{
    const { empty: empty, $anchor: $anchor, anchor: anchor } = selection;
    // Only detect annotations on caret selection
    if (!empty || !doc) {
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            if (selection instanceof (0, $801jp.NodeSelection) && [
                'inlineCard',
                'emoji',
                'date',
                'mention',
                'status'
            ].includes(selection.node.type.name)) ;
            else return [];
        } else return [];
    }
    const node = doc.nodeAt(anchor);
    const nodeBefore = $anchor.nodeBefore;
    if (!node && !nodeBefore) return [];
    // Inline comment on mediaInline is not supported as part of comments on media project
    // Hence, we ignore annotations associated with the node when the cursor is right after/before the node
    if ([
        nodeBefore,
        node
    ].some((node)=>(node === null || node === void 0 ? void 0 : node.type.name) === 'mediaInline')) return [];
    const annotationMark = doc.type.schema.marks.annotation;
    // Opening Remix Edit moves the selection beside the chart. Only explicit comment
    // actions should open its threads; a nearby caret must not select its annotations.
    const anchorAnnotationMarks = node && !$bf996096d3c39a56$var$isRemixExtension(node) ? node.marks : [];
    let marks = [];
    if (annotationMark.isInSet(anchorAnnotationMarks)) marks = anchorAnnotationMarks;
    if (nodeBefore && !$bf996096d3c39a56$var$isRemixExtension(nodeBefore) && annotationMark.isInSet(nodeBefore.marks)) {
        const existingMarkIds = marks.map((m)=>m.attrs.id);
        marks = marks.concat(...nodeBefore.marks.filter((m)=>!existingMarkIds.includes(m.attrs.id)));
    }
    const annotations = marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
            id: mark.attrs.id,
            type: mark.attrs.annotationType
        }));
    $bf996096d3c39a56$var$reorderAnnotations(annotations, $anchor);
    return annotations;
};
const $bf996096d3c39a56$export$196f73a7cbac5e80 = (editorState, bookmark, supportedBlockNodes = [], isBlockNodeSupported)=>{
    const { doc: doc } = editorState;
    const resolvedBookmark = bookmark ? bookmark.resolve(doc) : editorState.selection;
    const { from: from, to: to, head: head } = resolvedBookmark;
    let draftBookmark = {
        from: from,
        to: to,
        head: head,
        isBlockNode: false
    };
    if (resolvedBookmark instanceof (0, $801jp.NodeSelection)) {
        // It's possible that annotation is only allowed in child node instead parent (e.g. mediaSingle vs media),
        // thus, we traverse the node to find the first node that supports annotation and return its position
        let nodeFound = false;
        doc.nodesBetween(from, to, (node, pos)=>{
            // if we find the node, breakout the traversal to make sure we always record the first supported node
            if (nodeFound) return false;
            const nodeEndsAt = pos + node.nodeSize;
            const isLegacyMediaSingleWrapper = node.type.name === 'mediaSingle' && supportedBlockNodes.includes('media') && !supportedBlockNodes.includes('mediaSingle');
            if ($bf996096d3c39a56$export$bb7c9ea7da92cd01(node, supportedBlockNodes, isBlockNodeSupported) && !isLegacyMediaSingleWrapper) {
                draftBookmark = {
                    from: pos,
                    to: nodeEndsAt,
                    head: nodeEndsAt,
                    isBlockNode: node.isBlock
                };
                nodeFound = true;
                return false;
            }
        });
    }
    return draftBookmark;
};
function $bf996096d3c39a56$export$31c5af77b755d41f(editorState, bookmark) {
    // get positions via saved bookmark if it is available
    // this is to make comments box positioned relative to temporary highlight rather then current selection
    if (bookmark) return bookmark.resolve(editorState.doc);
    return editorState.selection;
}
const $bf996096d3c39a56$export$544b399faf6001b7 = new (0, $801jp.PluginKey)('inlineCommentPluginKey');
const $bf996096d3c39a56$export$f05434c51e3762e = (state)=>{
    return $bf996096d3c39a56$export$544b399faf6001b7.getState(state);
};
/**
 * get number of unique annotations within current selection
 */ const $bf996096d3c39a56$var$getAnnotationsInSelectionCount = (state)=>{
    const { from: from, to: to } = state.selection;
    const annotations = (0, $f1MDe.getAnnotationIdsFromRange)({
        from: from,
        to: to
    }, state.doc, state.schema);
    return annotations.length;
};
const $bf996096d3c39a56$export$a28639698c912d2c = (drafting, inputMethod)=>{
    const payload = (state)=>{
        let attributes = {};
        if (drafting) {
            var _currentMediaNodeWith;
            const { selection: selection } = state;
            const targetNode = selection instanceof (0, $801jp.NodeSelection) ? selection.node : (_currentMediaNodeWith = (0, $ls2OU.currentMediaNodeWithPos)(state)) === null || _currentMediaNodeWith === void 0 ? void 0 : _currentMediaNodeWith.node;
            let commentTargetType = 'other';
            if ((targetNode === null || targetNode === void 0 ? void 0 : targetNode.type.name) === 'extension') commentTargetType = targetNode.attrs.extensionKey === 'native-embed:maui' ? 'remixEmbed' : 'other';
            else if (targetNode && [
                'media',
                'mediaSingle',
                'mediaInline'
            ].includes(targetNode.type.name)) commentTargetType = 'media';
            else if (selection instanceof (0, $801jp.TextSelection) || selection instanceof (0, $801jp.AllSelection)) commentTargetType = 'text';
            attributes = {
                inputMethod: inputMethod,
                overlap: $bf996096d3c39a56$var$getAnnotationsInSelectionCount(state),
                commentTargetType: commentTargetType
            };
        }
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = $bf996096d3c39a56$export$f05434c51e3762e(state) || {};
            attributes.inlineNodeNames = (0, $f1MDe.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: $bf996096d3c39a56$export$196f73a7cbac5e80(state, bookmark)
            });
        }
        return {
            action: drafting ? (0, $3LeME.ACTION).OPENED : (0, $3LeME.ACTION).CLOSED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: attributes
        };
    };
    return payload;
};
const $bf996096d3c39a56$export$af7e6fc08350a63d = (state, supportedBlockNodes = [], isBlockNodeSupported)=>{
    var _currentMediaNodeWith2;
    const { selection: selection } = state;
    const { disallowOnWhitespace: disallowOnWhitespace } = $bf996096d3c39a56$export$f05434c51e3762e(state) || {};
    const allowedInlineNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const isSelectionEmpty = selection.empty;
    const isTextOrAllSelection = selection instanceof (0, $801jp.TextSelection) || selection instanceof (0, $801jp.AllSelection);
    const isSupportedBlockNodeSelection = selection instanceof (0, $801jp.NodeSelection) && $bf996096d3c39a56$export$bb7c9ea7da92cd01(selection.node, supportedBlockNodes, isBlockNodeSupported);
    const isValidNodeSelection = selection instanceof (0, $801jp.NodeSelection) && (allowedInlineNodes.includes(selection.node.type.name) || isSupportedBlockNodeSelection);
    const isValidSelection = isTextOrAllSelection || isValidNodeSelection;
    // Allow media so that it can enter draft mode
    if ((_currentMediaNodeWith2 = (0, $ls2OU.currentMediaNodeWithPos)(state)) !== null && _currentMediaNodeWith2 !== void 0 && _currentMediaNodeWith2.node) return (0, $5tfXu.AnnotationSelectionType).VALID;
    if (isSelectionEmpty || !isValidSelection) return (0, $5tfXu.AnnotationSelectionType).INVALID;
    const containsInvalidNodes = !isSupportedBlockNodeSelection && $bf996096d3c39a56$export$d454546510357a0(state);
    // A selection that only covers 1 pos, and is an invalid node
    // e.g. a text selection over a mention
    if (containsInvalidNodes && selection.to - selection.from === 1) return (0, $5tfXu.AnnotationSelectionType).INVALID;
    if (containsInvalidNodes) return (0, $5tfXu.AnnotationSelectionType).DISABLED;
    // Extension content lives outside the editor document, so an eligible whole-block
    // selection must not be rejected for having no commentable text descendants.
    const isSupportedExtensionSelection = (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && isSupportedBlockNodeSelection && selection instanceof (0, $801jp.NodeSelection) && selection.node.type.name === 'extension';
    if (disallowOnWhitespace && !isSupportedExtensionSelection && $bf996096d3c39a56$export$6d32268ea00f42b0(selection, state.schema)) return (0, $5tfXu.AnnotationSelectionType).INVALID;
    if (!(selection instanceof (0, $801jp.NodeSelection)) && (0, $f1MDe.isEmptyTextSelection)(selection, state.schema)) return (0, $5tfXu.AnnotationSelectionType).INVALID;
    return (0, $5tfXu.AnnotationSelectionType).VALID;
};
const $bf996096d3c39a56$export$d454546510357a0 = (state)=>{
    const { selection: selection, doc: doc, schema: schema } = state;
    return !(0, $f1MDe.canApplyAnnotationOnRange)({
        from: selection.from,
        to: selection.to
    }, doc, schema);
};
const $bf996096d3c39a56$export$bb7c9ea7da92cd01 = (node, supportedBlockNodes = [], isBlockNodeSupported)=>{
    return supportedBlockNodes.indexOf(node.type.name) >= 0 || node.type.name === 'mediaSingle' && supportedBlockNodes.indexOf('media') >= 0 || (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && (isBlockNodeSupported === null || isBlockNodeSupported === void 0 ? void 0 : isBlockNodeSupported(node)) === true;
};
function $bf996096d3c39a56$export$6d32268ea00f42b0(selection, schema) {
    let foundInvalidWhitespace = false;
    const content = selection.content().content;
    let hasCommentableInlineNodeDescendants = false;
    let hasCommentableTextNodeDescendants = false;
    content.descendants((node)=>{
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            const isAllowedInlineNode = [
                'emoji',
                'status',
                'date',
                'mention',
                'inlineCard'
            ].includes(node.type.name);
            if (isAllowedInlineNode) {
                hasCommentableInlineNodeDescendants = true;
                return false;
            }
        }
        if (node.type === schema.nodes.inlineCard && (0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) return false;
        if ((0, $cu8Jp.isText)(node, schema)) {
            if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
                if (node.textContent.trim() !== '') hasCommentableTextNodeDescendants = true;
            }
            return false;
        }
        if (!(0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            if (node.textContent.trim() === '') {
                // Trailing new lines do not result in the annotation spanning into
                // the trailing new line so can be ignored when looking for invalid
                // whitespace nodes.
                const nodeIsTrailingNewLine = // it is the final node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node.eq(content.lastChild) && // and there are multiple nodes
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                !node.eq(content.firstChild) && // and it is a paragraph node
                (0, $cu8Jp.isParagraph)(node, schema);
                if (!nodeIsTrailingNewLine) foundInvalidWhitespace = true;
            }
        }
        return !foundInvalidWhitespace;
    });
    if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
        if (hasCommentableInlineNodeDescendants) return false;
        return !hasCommentableTextNodeDescendants;
    }
    return foundInvalidWhitespace;
}
function $bf996096d3c39a56$export$5a8abbb22a9cfbef(annotationId, state) {
    const commentsPluginState = $bf996096d3c39a56$export$f05434c51e3762e(state);
    return !!(commentsPluginState !== null && commentsPluginState !== void 0 && commentsPluginState.annotations) && Object.keys(commentsPluginState.annotations).includes(annotationId);
}
function $bf996096d3c39a56$export$ca9ec32b395faf65(slice, state) {
    if (!slice.content.size) return false;
    slice.content.forEach((node)=>{
        $bf996096d3c39a56$var$stripNonExistingAnnotationsFromNode(node, state);
        node.content.descendants((node)=>{
            $bf996096d3c39a56$var$stripNonExistingAnnotationsFromNode(node, state);
            return true;
        });
    });
}
/*
 * remove annotations that dont exsist in plugin state
 * from node
 */ function $bf996096d3c39a56$var$stripNonExistingAnnotationsFromNode(node, state) {
    if ((0, $f1MDe.hasAnnotationMark)(node, state)) node.marks = node.marks.filter((mark)=>{
        if (mark.type.name === 'annotation') return $bf996096d3c39a56$export$5a8abbb22a9cfbef(mark.attrs.id, state);
        return true;
    });
    return node;
}
function $bf996096d3c39a56$export$a411569b9111c88e(oldSelectedAnnotations, newSelectedAnnotations) {
    return newSelectedAnnotations.length !== oldSelectedAnnotations.length || // assuming annotations have unique id's for simplicity
    newSelectedAnnotations.some((annotation)=>!oldSelectedAnnotations.find((pluginStateAnnotation)=>annotation.id === pluginStateAnnotation.id && annotation.type === pluginStateAnnotation.type));
}
const $bf996096d3c39a56$export$e171deb7d9f0a865 = (selection, selectedAnnotations = [])=>{
    if (selectedAnnotations.length && selection instanceof (0, $801jp.NodeSelection)) {
        if ($bf996096d3c39a56$export$4d7cdc53b5238d30(selection.node)) return false;
        const node = selection.node.type.name === 'mediaSingle' ? selection.node.firstChild : selection.node;
        const annotationMarks = (node === null || node === void 0 ? void 0 : node.marks.filter((mark)=>mark.type.name === 'annotation').map((mark)=>({
                id: mark.attrs.id,
                type: mark.attrs.annotationType
            }))) || [];
        return !selectedAnnotations.some((annotation)=>!annotationMarks.find((existingAnnotation)=>existingAnnotation.id === annotation.id && existingAnnotation.type === annotation.type));
    }
    return false;
};
const $bf996096d3c39a56$export$98b0a2a6ba343064 = (state)=>{
    var _getPluginState;
    const annotations = (_getPluginState = $bf996096d3c39a56$export$f05434c51e3762e(state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.annotations;
    if (annotations) {
        /**
     * annotations type is { [key: string]: boolean };
     * Here, key represents mark.attr.id and it is used to find where annotation to be presented in the document.
     * When value is false, it means it is unresolved annotation.
     *
     * But sometimes annotation map has entry with key undefined somehow.
     * And it is not valid mark attribute id, so it won't be presented anywhere in the document.
     */ const unresolvedAnnotationKeys = Object.keys(annotations).filter((key)=>key !== 'undefined' && annotations[key] === false);
        return unresolvedAnnotationKeys.length > 0;
    }
    return false;
};

});
parcelRegister("gHA4O", function(module, exports) {
$parcel$export(module.exports, "AnnotationSharedClassNames", () => $4926d7d8636af926$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $4926d7d8636af926$export$ac15f3ad21fefeac);
const $4926d7d8636af926$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $4926d7d8636af926$export$b0aeb22a160e5b4c = {
    focus: `${$4926d7d8636af926$export$6d0ce11e3a04da25}-focus`,
    blur: `${$4926d7d8636af926$export$6d0ce11e3a04da25}-blur`,
    draft: `${$4926d7d8636af926$export$6d0ce11e3a04da25}-draft`,
    hover: `${$4926d7d8636af926$export$6d0ce11e3a04da25}-hover`
};
const $4926d7d8636af926$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $4926d7d8636af926$export$ac15f3ad21fefeac = {
    focus: `${$4926d7d8636af926$export$3600479d19dfa7a9}-focus`,
    blur: `${$4926d7d8636af926$export$3600479d19dfa7a9}-blur`,
    draft: `${$4926d7d8636af926$export$3600479d19dfa7a9}-draft`
};

});

parcelRegister("5tfXu", function(module, exports) {
$parcel$export(module.exports, "AnnotationSelectionType", () => $f5678a747e17a010$export$ad08e20e7e22e394);
$parcel$export(module.exports, "AnnotationTestIds", () => $f5678a747e17a010$export$711f43d01b7e0019);
var $f5678a747e17a010$export$ad08e20e7e22e394 = /*#__PURE__*/ function(AnnotationSelectionType) {
    AnnotationSelectionType["INVALID"] = "invalid";
    // Annotation should not be created, toolbar should not be shown
    AnnotationSelectionType["DISABLED"] = "disabled";
    // Annotation should not be created, toolbar should be shown, but disabled
    AnnotationSelectionType["VALID"] = "valid";
    return AnnotationSelectionType;
}({});
const $f5678a747e17a010$var$prefix = 'ak-editor-annotation';
const $f5678a747e17a010$export$711f43d01b7e0019 = {
    prefix: $f5678a747e17a010$var$prefix,
    floatingComponent: `${$f5678a747e17a010$var$prefix}-floating-component`,
    floatingToolbarCreateButton: `${$f5678a747e17a010$var$prefix}-toolbar-create-button`,
    componentSave: `${$f5678a747e17a010$var$prefix}-dummy-save-button`,
    componentClose: `${$f5678a747e17a010$var$prefix}-dummy-close-button`
};

});




parcelRegister("5Wn5E", function(module, exports) {
$parcel$export(module.exports, "default", () => $588aa3dc6ae83ea5$export$2e2bcd8739ae039);

var $6DAwh = parcelRequire("6DAwh");

var $3LeME = parcelRequire("3LeME");

var $fdEaZ = parcelRequire("fdEaZ");

var $f1MDe = parcelRequire("f1MDe");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $dRkX9 = parcelRequire("dRkX9");

var $9179K = parcelRequire("9179K");
const $588aa3dc6ae83ea5$var$isAnnotationStep = (step)=>step instanceof (0, $k2WVn.AddMarkStep) && step.mark.type.name === 'annotation';
const $588aa3dc6ae83ea5$var$addAnnotationMark = (id, supportedBlockNodes, isBlockNodeSupported)=>(transaction, state)=>{
        const inlineCommentState = (0, $9179K.getPluginState)(state);
        const { bookmark: bookmark } = inlineCommentState || {};
        const annotationMark = state.schema.marks.annotation.create({
            id: id,
            type: (0, $6DAwh.AnnotationTypes).INLINE_COMMENT
        });
        const { from: from, to: to, head: head, isBlockNode: isBlockNode } = (0, $9179K.resolveDraftBookmark)(state, bookmark, supportedBlockNodes, isBlockNodeSupported);
        let tr = transaction;
        if (isBlockNode) {
            tr = tr.addNodeMark(from, annotationMark);
            // Set selection on the node so that we can display view component
            tr.setSelection((0, $801jp.NodeSelection).create(tr.doc, from));
        } else {
            // Apply the mark only to text node in the range.
            const tr = (0, $fdEaZ.applyMarkOnRange)(from, to, false, annotationMark, transaction);
            // The mark may not be applied to the current "head" of the bookmark so determine what was applied
            // above and use that instead
            const annotationMarkStep = tr.steps.reverse().find($588aa3dc6ae83ea5$var$isAnnotationStep);
            const headBasedOnMark = from === head ? annotationMarkStep === null || annotationMarkStep === void 0 ? void 0 : annotationMarkStep.from : annotationMarkStep === null || annotationMarkStep === void 0 ? void 0 : annotationMarkStep.to;
            tr.setSelection((0, $801jp.TextSelection).create(tr.doc, headBasedOnMark ?? head));
        }
        return tr;
    };
const $588aa3dc6ae83ea5$var$addInlineComment = (editorAnalyticsAPI, editorAPI)=>(id, supportedBlockNodes, isBlockNodeSupported)=>(transaction, state)=>{
            var _editorAPI$editorView, _pluginState$featureF;
            let tr = $588aa3dc6ae83ea5$var$addAnnotationMark(id, supportedBlockNodes, isBlockNodeSupported)(transaction, state);
            editorAPI === null || editorAPI === void 0 || (_editorAPI$editorView = editorAPI.editorViewModeEffects) === null || _editorAPI$editorView === void 0 || _editorAPI$editorView.actions.applyViewModeStepAt(tr);
            // add insert analytics step to transaction
            tr = $588aa3dc6ae83ea5$var$addInsertAnalytics(editorAnalyticsAPI)(tr, state);
            // add close analytics step to transaction
            tr = $588aa3dc6ae83ea5$var$addOpenCloseAnalytics(editorAnalyticsAPI)(false, (0, $3LeME.INPUT_METHOD).TOOLBAR)(tr, state);
            const pluginState = (0, $9179K.getPluginState)(state);
            const isAutoScrollBugFixEnabled = pluginState === null || pluginState === void 0 || (_pluginState$featureF = pluginState.featureFlagsPluginState) === null || _pluginState$featureF === void 0 ? void 0 : _pluginState$featureF.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $588aa3dc6ae83ea5$var$addOpenCloseAnalytics = (editorAnalyticsAPI)=>(drafting, method = (0, $3LeME.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            const draftingPayload = (0, $9179K.getDraftCommandAnalyticsPayload)(drafting, method)(state);
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(draftingPayload)(transaction);
            return transaction;
        };
const $588aa3dc6ae83ea5$var$handleDraftState = (editorAnalyticsAPI)=>(drafting, method = (0, $3LeME.INPUT_METHOD).TOOLBAR)=>(transaction, state)=>{
            var _pluginState$featureF2;
            const tr = $588aa3dc6ae83ea5$var$addOpenCloseAnalytics(editorAnalyticsAPI)(drafting, method)(transaction, state);
            const pluginState = (0, $9179K.getPluginState)(state);
            const isAutoScrollBugFixEnabled = pluginState === null || pluginState === void 0 || (_pluginState$featureF2 = pluginState.featureFlagsPluginState) === null || _pluginState$featureF2 === void 0 ? void 0 : _pluginState$featureF2.commentsOnMediaAutoscrollInEditor;
            if (isAutoScrollBugFixEnabled) // Explicitly disable scrollIntoView as scrolling is handled by CommentSidebar
            tr.setMeta('scrollIntoView', false);
            return tr;
        };
const $588aa3dc6ae83ea5$var$addInsertAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {}
        };
        if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
            const { bookmark: bookmark } = (0, $9179K.getPluginState)(state) || {};
            // When this FF is removed we can move the analytics event creation inside of the
            // attachAnalyticsEvent and get type inference for the attributes.
            // @ts-ignore
            analyticsEvent.attributes.inlineNodeNames = (0, $f1MDe.getRangeInlineNodeNames)({
                doc: state.doc,
                pos: (0, $9179K.resolveDraftBookmark)(state, bookmark)
            });
        }
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $588aa3dc6ae83ea5$var$addResolveAnalytics = (editorAnalyticsAPI)=>(method)=>(transaction, state)=>{
            const resolvedPayload = {
                action: (0, $3LeME.ACTION).RESOLVED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    method: method
                }
            };
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(resolvedPayload)(transaction);
            return transaction;
        };
const $588aa3dc6ae83ea5$var$addPreemptiveGateErrorAnalytics = (editorAnalyticsAPI)=>(errorReason)=>(transaction, state)=>{
            const analyticsEvent = {
                action: (0, $3LeME.ACTION).ERROR,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorReason: errorReason
                }
            };
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(analyticsEvent)(transaction);
            return transaction;
        };
const $588aa3dc6ae83ea5$var$addDeleteAnalytics = (editorAnalyticsAPI)=>(transaction, state)=>{
        const analyticsEvent = {
            action: (0, $3LeME.ACTION).DELETED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {}
        };
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(analyticsEvent)(transaction);
        return transaction;
    };
const $588aa3dc6ae83ea5$var$_default_1 = {
    addAnnotationMark: $588aa3dc6ae83ea5$var$addAnnotationMark,
    addInlineComment: $588aa3dc6ae83ea5$var$addInlineComment,
    handleDraftState: $588aa3dc6ae83ea5$var$handleDraftState,
    addOpenCloseAnalytics: $588aa3dc6ae83ea5$var$addOpenCloseAnalytics,
    addInsertAnalytics: $588aa3dc6ae83ea5$var$addInsertAnalytics,
    addResolveAnalytics: $588aa3dc6ae83ea5$var$addResolveAnalytics,
    addPreemptiveGateErrorAnalytics: $588aa3dc6ae83ea5$var$addPreemptiveGateErrorAnalytics,
    addDeleteAnalytics: $588aa3dc6ae83ea5$var$addDeleteAnalytics
};
var $588aa3dc6ae83ea5$export$2e2bcd8739ae039 = $588aa3dc6ae83ea5$var$_default_1;

});

parcelRegister("4zRzs", function(module, exports) {
$parcel$export(module.exports, "setUserIntent", () => $38421118da8da876$export$2c4e3be4c627582b);
$parcel$export(module.exports, "resetUserIntent", () => $38421118da8da876$export$dc07a25f8edf98a5);
const $38421118da8da876$export$2c4e3be4c627582b = (api, tr)=>{
    var _api$userIntent;
    return api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.commands) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.setCurrentUserIntent('commenting')({
        tr: tr
    });
};
const $38421118da8da876$export$dc07a25f8edf98a5 = (api, tr)=>{
    var _api$userIntent2;
    return api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || (_api$userIntent2 = _api$userIntent2.commands) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.setCurrentUserIntent('default')({
        tr: tr
    });
};

});


parcelRegister("e7esA", function(module, exports) {
$parcel$export(module.exports, "annotationWithToDOMFix", () => $ddf129973f522fcf$export$802ec1d716a6bb1);

var $6DAwh = parcelRequire("6DAwh");
const $ddf129973f522fcf$export$802ec1d716a6bb1 = {
    ...(0, $6DAwh.annotation),
    toDOM: (node)=>{
        return [
            'span',
            {
                // Needs id as a reference point
                id: node.attrs.id,
                // Used to determine if the annotation is active
                annotationType: node.attrs.annotationType,
                // Below are used for prosemirror (ie. copy/paste behaviour)
                'data-mark-type': 'annotation',
                'data-mark-annotation-type': node.attrs.annotationType,
                'data-id': node.attrs.id
            },
            0
        ];
    }
};

});

parcelRegister("CFHP6", function(module, exports) {
$parcel$export(module.exports, "inlineCommentPlugin", () => $32091f4580b5fd0a$export$e4aab3acac8f34b);

var $6DAwh = parcelRequire("6DAwh");

var $7tbCp = parcelRequire("7tbCp");

var $1y7gE = parcelRequire("1y7gE");

var $f1MDe = parcelRequire("f1MDe");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $hNBI1 = parcelRequire("hNBI1");

var $4zRzs = parcelRequire("4zRzs");

var $6vz1f = parcelRequire("6vz1f");

var $2D9yl = parcelRequire("2D9yl");

var $8Lmfp = parcelRequire("8Lmfp");

var $7ItCw = parcelRequire("7ItCw");

var $9179K = parcelRequire("9179K");
const $32091f4580b5fd0a$var$fetchProviderStates = async (provider, annotationIds)=>{
    if (!provider || !provider.getState) return {};
    const data = await provider.getState(annotationIds);
    const result = {};
    data.forEach((annotation)=>{
        if (annotation.annotationType === (0, $6DAwh.AnnotationTypes).INLINE_COMMENT) result[annotation.id] = annotation.state.resolved;
    });
    return result;
};
// fetchState is unable to return a command as it's runs async and may dispatch at a later time
// Requires `editorView` instead of the decomposition as the async means state may end up stale
const $32091f4580b5fd0a$var$fetchState = async (provider, annotationIds, editorView, editorAnalyticsAPI)=>{
    const inlineCommentStates = await $32091f4580b5fd0a$var$fetchProviderStates(provider, annotationIds);
    if (Object.keys(inlineCommentStates).length === 0) {
        const { annotationsLoaded: annotationsLoaded } = (0, $9179K.getPluginState)(editorView.state) || {};
        if (!annotationsLoaded) (0, $hNBI1.setInlineCommentsFetched)()(editorView.state, editorView.dispatch);
        return;
    }
    if (editorView.dispatch) (0, $hNBI1.updateInlineCommentResolvedState)(editorAnalyticsAPI)(inlineCommentStates)(editorView.state, editorView.dispatch);
};
const $32091f4580b5fd0a$var$initialState = (disallowOnWhitespace = false, featureFlagsPluginState, isAnnotationManagerEnabled = false)=>{
    return {
        annotationsLoaded: false,
        annotations: {},
        selectedAnnotations: [],
        hoveredAnnotations: [],
        mouseData: {
            isSelecting: false
        },
        disallowOnWhitespace: disallowOnWhitespace,
        isInlineCommentViewClosed: false,
        isVisible: true,
        skipSelectionHandling: false,
        featureFlagsPluginState: featureFlagsPluginState,
        isDrafting: false,
        pendingSelectedAnnotations: [],
        pendingSelectedAnnotationsUpdateCount: 0,
        isAnnotationManagerEnabled: isAnnotationManagerEnabled
    };
};
const $32091f4580b5fd0a$var$hideToolbar = (state, dispatch)=>()=>{
        (0, $hNBI1.updateMouseState)({
            isSelecting: true
        })(state, dispatch);
    };
// Subscribe to updates from consumer
const $32091f4580b5fd0a$var$onResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $hNBI1.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [annotationId]: true
            }, (0, $7tbCp.RESOLVE_METHOD).CONSUMER)(state, dispatch);
        };
const $32091f4580b5fd0a$var$onUnResolve = (editorAnalyticsAPI)=>(state, dispatch)=>(annotationId)=>{
            (0, $hNBI1.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                [annotationId]: false
            })(state, dispatch);
        };
const $32091f4580b5fd0a$var$onMouseUp = (state, dispatch)=>(e)=>{
        const { mouseData: mouseData } = (0, $9179K.getPluginState)(state) || {};
        if (mouseData !== null && mouseData !== void 0 && mouseData.isSelecting) (0, $hNBI1.updateMouseState)({
            isSelecting: false
        })(state, dispatch);
    };
const $32091f4580b5fd0a$var$onSetVisibility = (view)=>(isVisible)=>{
        const { state: state, dispatch: dispatch } = view;
        (0, $hNBI1.setInlineCommentsVisibility)(isVisible)(state, dispatch);
        if (isVisible) // PM retains focus when we click away from the editor.
        // This will restore the visual aspect of the selection,
        // otherwise it will seem a floating toolbar will appear
        // for no reason.
        view.focus();
    };
const $32091f4580b5fd0a$export$e4aab3acac8f34b = (options)=>{
    const { provider: provider, featureFlagsPluginState: featureFlagsPluginState, annotationManager: annotationManager } = options;
    return new (0, $1y7gE.SafePlugin)({
        key: (0, $9179K.inlineCommentPluginKey),
        state: (0, $8Lmfp.createPluginState)(options.dispatch, $32091f4580b5fd0a$var$initialState(provider.disallowOnWhitespace, featureFlagsPluginState, !!annotationManager)),
        view (editorView) {
            let allowAnnotationFn;
            let startDraftFn;
            let clearDraftFn;
            let applyDraftFn;
            let getDraftFn;
            let setIsAnnotationSelectedFn;
            let setIsAnnotationHoveredFn;
            let clearAnnotationFn;
            if (annotationManager) {
                allowAnnotationFn = (0, $2D9yl.allowAnnotation)(editorView, options);
                startDraftFn = (0, $2D9yl.startDraft)(editorView, options);
                clearDraftFn = (0, $2D9yl.clearDraft)(editorView, options);
                applyDraftFn = (0, $2D9yl.applyDraft)(editorView, options);
                getDraftFn = (0, $2D9yl.getDraft)(editorView, options);
                setIsAnnotationSelectedFn = (0, $2D9yl.setIsAnnotationSelected)(editorView, options);
                setIsAnnotationHoveredFn = (0, $2D9yl.setIsAnnotationHovered)(editorView, options);
                clearAnnotationFn = (0, $2D9yl.clearAnnotation)(editorView, options);
                annotationManager.hook('allowAnnotation', allowAnnotationFn);
                annotationManager.hook('startDraft', startDraftFn);
                annotationManager.hook('clearDraft', clearDraftFn);
                annotationManager.hook('applyDraft', applyDraftFn);
                annotationManager.hook('getDraft', getDraftFn);
                annotationManager.hook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                annotationManager.hook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                annotationManager.hook('clearAnnotation', clearAnnotationFn);
            }
            // Get initial state
            // Need to pass `editorView` to mitigate editor state going stale
            $32091f4580b5fd0a$var$fetchState(provider, (0, $9179K.getAllAnnotations)(editorView.state.doc), editorView, options.editorAnalyticsAPI);
            const resolve = (annotationId)=>$32091f4580b5fd0a$var$onResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const unResolve = (annotationId)=>$32091f4580b5fd0a$var$onUnResolve(options.editorAnalyticsAPI)(editorView.state, editorView.dispatch)(annotationId);
            const mouseUp = (event)=>$32091f4580b5fd0a$var$onMouseUp(editorView.state, editorView.dispatch)(event);
            const setVisibility = (isVisible)=>$32091f4580b5fd0a$var$onSetVisibility(editorView)(isVisible);
            const setSelectedAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $hNBI1.closeComponent)()(editorView.state, editorView.dispatch);
                else (0, $hNBI1.setSelectedAnnotation)(annotationId)(editorView.state, editorView.dispatch);
            };
            const setHoveredAnnotationFn = (annotationId)=>{
                if (!annotationId) (0, $hNBI1.closeComponent)()(editorView.state, editorView.dispatch);
                else (0, $hNBI1.setHoveredAnnotation)(annotationId)(editorView.state, editorView.dispatch);
            };
            const removeHoveredannotationFn = ()=>{
                (0, $hNBI1.setHoveredAnnotation)('')(editorView.state, editorView.dispatch);
            };
            const closeInlineCommentFn = ()=>{
                (0, $hNBI1.closeComponent)()(editorView.state, editorView.dispatch);
            };
            const { updateSubscriber: updateSubscriber } = provider;
            if (updateSubscriber) updateSubscriber.on('resolve', resolve).on('delete', resolve).on('unresolve', unResolve).on('create', unResolve).on('setvisibility', setVisibility).on('setselectedannotation', setSelectedAnnotationFn).on('sethoveredannotation', setHoveredAnnotationFn).on('removehoveredannotation', removeHoveredannotationFn).on('closeinlinecomment', closeInlineCommentFn);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorView.root.addEventListener('mouseup', mouseUp);
            /**
       * This flag is used to prevent the preemptive gate from being called multiple times while a check is in-flight.
       * If a check is still pending then it's most likely because the product is busy and trying to block the
       * selection of an annotation.
       */ let isPreemptiveGateActive = false;
            return {
                update (view, _prevState) {
                    var _prevSelectedAnnotati;
                    const { selectedAnnotations: selectedAnnotations, annotations: annotations, isDrafting: isDrafting, bookmark: bookmark } = (0, $9179K.getPluginState)(view.state) || {};
                    const { selectedAnnotations: prevSelectedAnnotations } = (0, $9179K.getPluginState)(_prevState) || {};
                    const selectedAnnotationId = selectedAnnotations && selectedAnnotations.length !== 0 && selectedAnnotations[0].id ? selectedAnnotations[0].id : undefined;
                    // If the new state has an unresolved selected annotation, and it's different from
                    // the previous one then...
                    if (//This checks the selected annotation is different from the previous one
                    selectedAnnotationId && selectedAnnotationId !== (prevSelectedAnnotations === null || prevSelectedAnnotations === void 0 || (_prevSelectedAnnotati = prevSelectedAnnotations[0]) === null || _prevSelectedAnnotati === void 0 ? void 0 : _prevSelectedAnnotati.id) && // This ensures that the selected annotation is unresolved
                    annotations && annotations[selectedAnnotationId] === false) {
                        var _options$selectCommen, _options$viewInlineCo;
                        // ...we mark the select annotation experience as complete.
                        // The selectComponentExperience is using a simplified object, which is why it's type asserted.
                        (_options$selectCommen = options.selectCommentExperience) === null || _options$selectCommen === void 0 || _options$selectCommen.selectAnnotation.complete(selectedAnnotationId);
                        // ...and start a new UFO press trace since the selected comment is changing
                        (_options$viewInlineCo = options.viewInlineCommentTraceUFOPress) === null || _options$viewInlineCo === void 0 || _options$viewInlineCo.call(options);
                    }
                    const { api: api } = options;
                    if (isDrafting && !view.state.selection.eq(_prevState.selection) && Boolean(api === null || api === void 0 ? void 0 : api.toolbar)) // It is possible that user update selection while having a active draft,
                    // so we need to reset the user intent to allow inline text toolbar to be visible
                    api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                        if ((0, $7ItCw.shouldSuppressFloatingToolbar)({
                            state: view.state,
                            bookmark: bookmark
                        })) (0, $4zRzs.setUserIntent)(api, tr);
                        else (0, $4zRzs.resetUserIntent)(api, tr);
                        return tr;
                    });
                    if (annotationManager) {
                        // In the Editor, Annotations can be selected in three ways:
                        // 1. By clicking on the annotation in the editor
                        // 2. By using the annotation manager to select the annotation
                        // 3. By moving the cursor to the annotation and using the keyboard to select it
                        // Item 1 & 3 need to be protected by the preemptive gate. This is because these actions could be performed by a user
                        // at a time when changing the selection could cause data loss.
                        // The following preemptive check is designed to cover these items.
                        const { pendingSelectedAnnotations: pendingSelectedAnnotations, pendingSelectedAnnotationsUpdateCount: pendingSelectedAnnotationsUpdateCount } = (0, $9179K.getPluginState)(view.state) || {};
                        const { pendingSelectedAnnotationsUpdateCount: prevPendingSelectedAnnotationsUpdateCount } = (0, $9179K.getPluginState)(_prevState) || {};
                        if (!isPreemptiveGateActive && pendingSelectedAnnotationsUpdateCount !== prevPendingSelectedAnnotationsUpdateCount && !!(pendingSelectedAnnotations !== null && pendingSelectedAnnotations !== void 0 && pendingSelectedAnnotations.length)) {
                            // Need to set a lock to avoid calling gate multiple times. The lock will be released
                            // when the preemptive gate is complete.
                            isPreemptiveGateActive = true;
                            annotationManager.checkPreemptiveGate().then((canSelectAnnotation)=>{
                                const { isDrafting: isDrafting, pendingSelectedAnnotations: latestPendingSelectedAnnotations, selectedAnnotations: latestSelectedAnnotations } = (0, $9179K.getPluginState)(view.state) || {};
                                if (canSelectAnnotation) {
                                    if (isDrafting) // The user must have chosen to discard there draft. So before we flush the pending selections
                                    // we need to clear the draft if there is one.
                                    (0, $hNBI1.setInlineCommentDraftState)(options.editorAnalyticsAPI, undefined, options.api)(false)(view.state, view.dispatch);
                                    // Flush the pending selections into the selected annotations list.
                                    (0, $hNBI1.flushPendingSelections)(options.editorAnalyticsAPI)(true)(view.state, view.dispatch);
                                    latestSelectedAnnotations === null || latestSelectedAnnotations === void 0 || latestSelectedAnnotations.filter((annotation)=>(latestPendingSelectedAnnotations === null || latestPendingSelectedAnnotations === void 0 ? void 0 : latestPendingSelectedAnnotations.findIndex((pendingAnnotation)=>pendingAnnotation.id === annotation.id)) === -1).forEach((annotation)=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: annotation.id,
                                                isSelected: false,
                                                inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                                            }
                                        });
                                    });
                                    // Notify the annotation manager that the pending selection has changed.
                                    latestPendingSelectedAnnotations === null || latestPendingSelectedAnnotations === void 0 || latestPendingSelectedAnnotations.forEach(({ id: id })=>{
                                        annotationManager.emit({
                                            name: 'annotationSelectionChanged',
                                            data: {
                                                annotationId: id,
                                                isSelected: true,
                                                inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(view.state, id) ?? []
                                            }
                                        });
                                    });
                                } else // Clears the pending selections if the preemptive gate returns false.
                                // We should need to worry about dispatching change events here because the pending selections
                                // are being aborted and the selections will remain unchanged.
                                (0, $hNBI1.flushPendingSelections)(options.editorAnalyticsAPI)(false)(view.state, view.dispatch);
                            }).catch((error)=>{
                                // If an error has occured we will clear any pending selections to avoid accidentally setting the wrong thing.
                                (0, $hNBI1.flushPendingSelections)(options.editorAnalyticsAPI)(false, 'pending-selection-preemptive-gate-error')(view.state, view.dispatch);
                            }).finally(()=>{
                                isPreemptiveGateActive = false;
                            });
                        }
                    }
                    const { dirtyAnnotations: dirtyAnnotations } = (0, $9179K.getPluginState)(view.state) || {};
                    if (!dirtyAnnotations) return;
                    (0, $hNBI1.clearDirtyMark)()(view.state, view.dispatch);
                    $32091f4580b5fd0a$var$fetchState(provider, (0, $9179K.getAllAnnotations)(view.state.doc), view, options.editorAnalyticsAPI);
                },
                destroy () {
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    editorView.root.removeEventListener('mouseup', mouseUp);
                    if (updateSubscriber) updateSubscriber.off('resolve', resolve).off('delete', resolve).off('unresolve', unResolve).off('create', unResolve).off('setvisibility', setVisibility).off('setselectedannotation', setSelectedAnnotationFn).off('sethoveredannotation', setHoveredAnnotationFn).off('removehoveredannotation', removeHoveredannotationFn).off('closeinlinecomment', closeInlineCommentFn);
                    if (annotationManager) {
                        annotationManager.unhook('allowAnnotation', allowAnnotationFn);
                        annotationManager.unhook('startDraft', startDraftFn);
                        annotationManager.unhook('clearDraft', clearDraftFn);
                        annotationManager.unhook('applyDraft', applyDraftFn);
                        annotationManager.unhook('getDraft', getDraftFn);
                        annotationManager.unhook('setIsAnnotationSelected', setIsAnnotationSelectedFn);
                        annotationManager.unhook('setIsAnnotationHovered', setIsAnnotationHoveredFn);
                        annotationManager.unhook('clearAnnotation', clearAnnotationFn);
                    }
                }
            };
        },
        props: {
            handleDOMEvents: {
                mousedown: (view)=>{
                    const pluginState = (0, $9179K.getPluginState)(view.state);
                    if (!(pluginState !== null && pluginState !== void 0 && pluginState.mouseData.isSelecting)) $32091f4580b5fd0a$var$hideToolbar(view.state, view.dispatch)();
                    return false;
                },
                dragstart: (view, event)=>{
                    // Mouseup won't be triggered after dropping
                    // Hence, update the mouse data to cancel selecting when drag starts
                    return $32091f4580b5fd0a$var$onMouseUp(view.state, view.dispatch)(event);
                },
                click: (view, event)=>{
                    var _event$target$closest, _pluginState$selected;
                    if (!(event.target instanceof HTMLElement)) return false;
                    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_fix_lcm_editor_annotations')) {
                        // The LCM renderer bridge owns selection so its draft-close guard runs first.
                        if (event.target.closest('[data-lcm-annotation-renderer]')) return false;
                    }
                    // Find the nearest ancestor (or self) with the data-id attribute
                    const annotationId = (_event$target$closest = event.target.closest('[data-id]')) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.getAttribute('data-id');
                    if (!annotationId) return false;
                    const pluginState = (0, $9179K.getPluginState)(view.state);
                    const isSelected = pluginState === null || pluginState === void 0 || (_pluginState$selected = pluginState.selectedAnnotations) === null || _pluginState$selected === void 0 ? void 0 : _pluginState$selected.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                    // If the annotation is selected and the inline comment view is open, do nothing
                    // as the user is already in the comment view.
                    if (isSelected && !(pluginState !== null && pluginState !== void 0 && pluginState.isInlineCommentViewClosed)) return false;
                    const { annotations: annotations } = pluginState || {};
                    const isUnresolved = annotations && annotations[annotationId] === false;
                    if (!isUnresolved) return false;
                    if (annotationManager) {
                        var _pluginState$pendingS;
                        // The manager disable setting the selected annotation on click because in the editor this is already
                        // handled by the selection update handler. When the manager is enabled, and a selection changes it's pushed into
                        // the pendingSelectedAnnotations array. This is then used to update the selection when the preemptive gate
                        // is released.
                        const isPendingSelection = pluginState === null || pluginState === void 0 || (_pluginState$pendingS = pluginState.pendingSelectedAnnotations) === null || _pluginState$pendingS === void 0 ? void 0 : _pluginState$pendingS.some((selectedAnnotation)=>selectedAnnotation.id === annotationId);
                        // If the annotation is selected and the inline comment view is open, do nothing
                        // as the user is already in the comment view.
                        if (isPendingSelection) return false;
                        (0, $hNBI1.setPendingSelectedAnnotation)(annotationId)(view.state, view.dispatch);
                    } else (0, $hNBI1.setSelectedAnnotation)(annotationId)(view.state, view.dispatch);
                    return true;
                }
            },
            decorations (state) {
                // highlight comments, depending on state
                const { draftDecorationSet: draftDecorationSet, annotations: annotations, selectedAnnotations: selectedAnnotations, isVisible: isVisible, isInlineCommentViewClosed: isInlineCommentViewClosed, hoveredAnnotations: hoveredAnnotations } = (0, $9179K.getPluginState)(state) || {};
                let decorations = draftDecorationSet ?? (0, $16ZMX.DecorationSet).empty;
                const focusDecorations = [];
                // TODO: EDITOR-760 - This needs to be optimised, it's not a good idea to scan the entire document
                // everytime we need to update the decorations. This handler will be called alot. We should be caching
                // the decorations in plugin state and only updating them when required.
                state.doc.descendants((node, pos)=>{
                    // Do not render saved chart marks as text highlights when annotation support is off.
                    if ((0, $9179K.shouldHideRemixAnnotation)(node)) return false;
                    // Inline comment on mediaInline is not supported as part of comments on media project
                    // Thus, we skip the decoration for mediaInline node
                    if (node.type.name === 'mediaInline') return false;
                    const isSupportedBlock = node.isBlock && (0, $9179K.isSupportedBlockNode)(node, provider.supportedBlockNodes, provider.isBlockNodeSupported);
                    node.marks.filter((mark)=>mark.type === state.schema.marks.annotation).forEach((mark)=>{
                        if (isVisible) {
                            const isUnresolved = !!annotations && annotations[mark.attrs.id] === false;
                            const isSelected = !isInlineCommentViewClosed && !!(selectedAnnotations !== null && selectedAnnotations !== void 0 && selectedAnnotations.some((selectedAnnotation)=>selectedAnnotation.id === mark.attrs.id));
                            const isHovered = !isInlineCommentViewClosed && !!(hoveredAnnotations !== null && hoveredAnnotations !== void 0 && hoveredAnnotations.some((hoveredAnnotation)=>hoveredAnnotation.id === mark.attrs.id));
                            if (isSupportedBlock) focusDecorations.push((0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, {
                                class: `${(0, $6vz1f.getBlockAnnotationViewClassname)(isUnresolved, isSelected)} ${isUnresolved}`
                            }, {
                                key: (0, $9179K.decorationKey).block
                            }));
                            else if ((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes')) {
                                if (node.isText) focusDecorations.push((0, $16ZMX.Decoration).inline(pos, pos + node.nodeSize, {
                                    class: `${(0, $6vz1f.getAnnotationViewClassname)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                    nodeName: 'span'
                                }));
                                else focusDecorations.push((0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, {
                                    class: `${(0, $6vz1f.getAnnotationViewClassname)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`
                                }, {
                                    key: (0, $9179K.decorationKey).block
                                }));
                            } else focusDecorations.push((0, $16ZMX.Decoration).inline(pos, pos + node.nodeSize, {
                                class: `${(0, $6vz1f.getAnnotationViewClassname)(isUnresolved, isSelected, isHovered)} ${isUnresolved}`,
                                nodeName: 'span'
                            }));
                        }
                    });
                });
                decorations = decorations.add(state.doc, focusDecorations);
                return decorations;
            }
        }
    });
};

});
parcelRegister("6vz1f", function(module, exports) {
$parcel$export(module.exports, "getAnnotationViewClassname", () => $fa1f903ace7c9a9e$export$b3ab33741101ad90);
$parcel$export(module.exports, "getBlockAnnotationViewClassname", () => $fa1f903ace7c9a9e$export$bb73203a2b3a63e2);

var $gHA4O = parcelRequire("gHA4O");
const $fa1f903ace7c9a9e$export$b3ab33741101ad90 = (isUnresolved, hasFocus, isHovered)=>{
    if (!isUnresolved) return;
    if (hasFocus) return (0, $gHA4O.AnnotationSharedClassNames).focus;
    if (isHovered) return (0, $gHA4O.AnnotationSharedClassNames).hover;
    return (0, $gHA4O.AnnotationSharedClassNames).blur;
};
const $fa1f903ace7c9a9e$export$bb73203a2b3a63e2 = (isUnresolved, hasFocus)=>{
    if (!isUnresolved) return;
    return hasFocus ? (0, $gHA4O.BlockAnnotationSharedClassNames).focus : (0, $gHA4O.BlockAnnotationSharedClassNames).blur;
};

});

parcelRegister("2D9yl", function(module, exports) {
$parcel$export(module.exports, "allowAnnotation", () => $3a406416cdb16f64$export$86f3258f283eb796);
$parcel$export(module.exports, "startDraft", () => $3a406416cdb16f64$export$768048043e8d2bcd);
$parcel$export(module.exports, "clearDraft", () => $3a406416cdb16f64$export$eeeb486534738631);
$parcel$export(module.exports, "applyDraft", () => $3a406416cdb16f64$export$8bc7b93e04771bda);
$parcel$export(module.exports, "getDraft", () => $3a406416cdb16f64$export$1a473231c51c1d5b);
$parcel$export(module.exports, "setIsAnnotationSelected", () => $3a406416cdb16f64$export$b8ac6bdd928e737c);
$parcel$export(module.exports, "setIsAnnotationHovered", () => $3a406416cdb16f64$export$5ada3da2e2f0701f);
$parcel$export(module.exports, "clearAnnotation", () => $3a406416cdb16f64$export$6baae9b3f0f9bdce);

var $6DAwh = parcelRequire("6DAwh");

var $3LeME = parcelRequire("3LeME");

var $f1MDe = parcelRequire("f1MDe");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $hNBI1 = parcelRequire("hNBI1");

var $5tfXu = parcelRequire("5tfXu");

var $aN6Yq = parcelRequire("aN6Yq");

var $9179K = parcelRequire("9179K");
const $3a406416cdb16f64$var$ERROR_REASON_DRAFT_NOT_STARTED = 'draft-not-started';
const $3a406416cdb16f64$var$ERROR_REASON_DRAFT_IN_PROGRESS = 'draft-in-progress';
const $3a406416cdb16f64$var$ERROR_REASON_RANGE_MISSING = 'range-no-longer-exists';
const $3a406416cdb16f64$var$ERROR_REASON_RANGE_INVALID = 'invalid-range';
const $3a406416cdb16f64$var$ERROR_REASON_ID_INVALID = 'id-not-valid';
const $3a406416cdb16f64$var$ERROR_REASON_INVALID_LOCAL_ID = 'invalid-localId';
const $3a406416cdb16f64$var$domRefFromPos = (view, position)=>{
    let dom;
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = (0, $a4TQr.findDomRefAtPos)(position, view.domAtPos.bind(view));
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        return undefined;
    }
    return dom;
};
const $3a406416cdb16f64$export$86f3258f283eb796 = (editorView, options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        if (isDrafting) return false;
        const decoration = draftDecorationSet === null || draftDecorationSet === void 0 ? void 0 : draftDecorationSet.find();
        // If a draft decoration exists then we should block the user from creating a new one.
        if (!!(decoration !== null && decoration !== void 0 && decoration.length)) return false;
        return (0, $9179K.isSelectionValid)(editorView.state, options.provider.supportedBlockNodes, options.provider.isBlockNodeSupported) === (0, $5tfXu.AnnotationSelectionType).VALID;
    };
const $3a406416cdb16f64$export$768048043e8d2bcd = (editorView, options)=>(localId)=>{
        var _options$annotationMa3;
        const { isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        if (!!(selectedAnnotations !== null && selectedAnnotations !== void 0 && selectedAnnotations.length)) {
            // if there are selected annotations when starting a draft, we need to clear the selected annotations
            // before we start the draft.
            (0, $hNBI1.closeComponent)()(editorView.state, editorView.dispatch);
            // not only that but we need to also deselect any other annotations that are currently selected.
            selectedAnnotations === null || selectedAnnotations === void 0 || selectedAnnotations.forEach((annotation)=>{
                var _options$annotationMa;
                (_options$annotationMa = options.annotationManager) === null || _options$annotationMa === void 0 || _options$annotationMa.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: annotation.id,
                        isSelected: false,
                        inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                    }
                });
            });
        }
        if (localId !== undefined) {
            var _$target$parent, _options$annotationMa2;
            const target = (0, $aN6Yq.resolveAnnotatableTargetFromLocalId)(editorView.state, localId, {
                supportedBlockNodes: options.provider.supportedBlockNodes
            });
            if (!target) return {
                success: false,
                reason: $3a406416cdb16f64$var$ERROR_REASON_INVALID_LOCAL_ID
            };
            // The resolver returns the node accepting the annotation (the inner `media`), but
            // `isSelectionValid` requires the selection to be on the selectable `mediaSingle`.
            const { doc: doc } = editorView.state;
            let selectionPos = target.pos;
            const $target = doc.resolve(target.pos);
            if (target.node.type.name === 'media' && ((_$target$parent = $target.parent) === null || _$target$parent === void 0 ? void 0 : _$target$parent.type.name) === 'mediaSingle') selectionPos = $target.before();
            // A NodeSelection makes resolveDraftBookmark record isBlockNode: true.
            editorView.dispatch(editorView.state.tr.setSelection((0, $801jp.NodeSelection).create(doc, selectionPos)));
            const targetNodeId = target.node.attrs.id ?? target.node.attrs.localId;
            (0, $hNBI1.setInlineCommentDraftState)(options.editorAnalyticsAPI, options.provider.supportedBlockNodes, options.api, options.provider.isBlockNodeSupported)(true, (0, $3LeME.INPUT_METHOD).FLOATING_TB, 'block', targetNodeId, true)(editorView.state, editorView.dispatch);
            const { draftDecorationSet: draftDecorationSet } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
            const decorations = draftDecorationSet === null || draftDecorationSet === void 0 ? void 0 : draftDecorationSet.find();
            if (!(decorations !== null && decorations !== void 0 && decorations.length)) return {
                success: false,
                reason: $3a406416cdb16f64$var$ERROR_REASON_RANGE_INVALID
            };
            const from = decorations[0].from;
            const targetElement = $3a406416cdb16f64$var$domRefFromPos(editorView, from);
            const inlineNodeTypes = (0, $f1MDe.getRangeInlineNodeNames)({
                doc: editorView.state.doc,
                pos: {
                    from: from,
                    to: decorations[decorations.length - 1].to
                }
            }) ?? [];
            const targetNodeType = target.node.type.name;
            (_options$annotationMa2 = options.annotationManager) === null || _options$annotationMa2 === void 0 || _options$annotationMa2.emit({
                name: 'draftAnnotationStarted',
                data: {
                    targetElement: targetElement,
                    actionResult: undefined,
                    inlineNodeTypes: inlineNodeTypes,
                    targetNodeType: targetNodeType
                }
            });
            return {
                success: true,
                targetElement: targetElement,
                // In Editor the action result is undefined, because the editor will perform the transaction on the document.
                actionResult: undefined,
                inlineNodeTypes: inlineNodeTypes,
                targetNodeType: targetNodeType
            };
        }
        (0, $hNBI1.setInlineCommentDraftState)(options.editorAnalyticsAPI, options.provider.supportedBlockNodes, options.api, options.provider.isBlockNodeSupported)(true)(editorView.state, editorView.dispatch);
        const { draftDecorationSet: draftDecorationSet } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        const decorations = draftDecorationSet === null || draftDecorationSet === void 0 ? void 0 : draftDecorationSet.find();
        // If the matching decorations is not found containing the id, it means something went wrong with the draft.
        if (!(decorations !== null && decorations !== void 0 && decorations.length)) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_RANGE_INVALID
        };
        const from = decorations[0].from;
        const targetElement = $3a406416cdb16f64$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $f1MDe.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        (_options$annotationMa3 = options.annotationManager) === null || _options$annotationMa3 === void 0 || _options$annotationMa3.emit({
            name: 'draftAnnotationStarted',
            data: {
                targetElement: targetElement,
                actionResult: undefined,
                inlineNodeTypes: inlineNodeTypes
            }
        });
        return {
            success: true,
            targetElement: targetElement,
            // In Editor the action result is undefined, because the editor will perform the transaction on the document.
            actionResult: undefined,
            inlineNodeTypes: inlineNodeTypes
        };
    };
const $3a406416cdb16f64$export$eeeb486534738631 = (editorView, options)=>()=>{
        var _options$annotationMa4;
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet === null || draftDecorationSet === void 0 ? void 0 : draftDecorationSet.find();
        if (!(decorations !== null && decorations !== void 0 && decorations.length)) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        (0, $hNBI1.setInlineCommentDraftState)(options.editorAnalyticsAPI, undefined, options.api)(false)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        (_options$annotationMa4 = options.annotationManager) === null || _options$annotationMa4 === void 0 || _options$annotationMa4.emit({
            name: 'draftAnnotationCleared'
        });
        return {
            success: true
        };
    };
const $3a406416cdb16f64$export$8bc7b93e04771bda = (editorView, options)=>(id)=>{
        var _options$annotationMa5;
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet, bookmark: bookmark } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet === null || draftDecorationSet === void 0 ? void 0 : draftDecorationSet.find();
        if (!(decorations !== null && decorations !== void 0 && decorations.length) || !bookmark) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_RANGE_MISSING
        };
        const from = decorations[0].from;
        (0, $hNBI1.createAnnotation)(options.editorAnalyticsAPI, options.api)(id, (0, $6DAwh.AnnotationTypes).INLINE_COMMENT, options.provider.supportedBlockNodes, options.provider.isBlockNodeSupported)(editorView.state, editorView.dispatch);
        !editorView.hasFocus() && editorView.focus();
        // Using the original decoration from position we should be able to locate the new target element.
        // This is because the new annotation will be created at the same position as the draft decoration.
        const targetElement = $3a406416cdb16f64$var$domRefFromPos(editorView, from);
        // When a draft is applied it is automatically selected, so we need to set the selected annotation.
        // emit the event for the selected annotation.
        (_options$annotationMa5 = options.annotationManager) === null || _options$annotationMa5 === void 0 || _options$annotationMa5.emit({
            name: 'annotationSelectionChanged',
            data: {
                annotationId: id,
                isSelected: true,
                inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
            }
        });
        return {
            success: true,
            targetElement: // Get the dom element from the newly created annotation and return it here.
            targetElement,
            // In Editor this is undefined, because the editor will update the document.
            actionResult: undefined
        };
    };
const $3a406416cdb16f64$export$1a473231c51c1d5b = (editorView, _options)=>()=>{
        const { isDrafting: isDrafting, draftDecorationSet: draftDecorationSet } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        if (!isDrafting) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const decorations = draftDecorationSet === null || draftDecorationSet === void 0 ? void 0 : draftDecorationSet.find();
        if (!(decorations !== null && decorations !== void 0 && decorations.length)) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_NOT_STARTED
        };
        const from = decorations[0].from;
        const targetElement = $3a406416cdb16f64$var$domRefFromPos(editorView, from);
        const inlineNodeTypes = (0, $f1MDe.getRangeInlineNodeNames)({
            doc: editorView.state.doc,
            pos: {
                from: from,
                to: decorations[decorations.length - 1].to
            }
        }) ?? [];
        return {
            success: true,
            inlineNodeTypes: inlineNodeTypes,
            targetElement: targetElement,
            actionResult: undefined
        };
    };
const $3a406416cdb16f64$export$b8ac6bdd928e737c = (editorView, options)=>(id, isSelected)=>{
        const { annotations: annotations, isDrafting: isDrafting, selectedAnnotations: selectedAnnotations } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        if (isDrafting) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_DRAFT_IN_PROGRESS
        };
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!(annotations !== null && annotations !== void 0 && annotations.hasOwnProperty(id))) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlySelectedIndex = (selectedAnnotations === null || selectedAnnotations === void 0 ? void 0 : selectedAnnotations.findIndex((annotation)=>annotation.id === id)) ?? -1;
        const isCurrentlySelected = isCurrentlySelectedIndex !== -1;
        if (isSelected !== isCurrentlySelected) {
            // the annotation is selection is changing.
            if (isCurrentlySelected && !isSelected) {
                var _options$annotationMa6;
                // the selected annotaion is being unselected, so we need to close the view.
                (0, $hNBI1.closeComponent)()(editorView.state, editorView.dispatch);
                (_options$annotationMa6 = options.annotationManager) === null || _options$annotationMa6 === void 0 || _options$annotationMa6.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: false,
                        inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            } else if (!isCurrentlySelected && isSelected) {
                var _options$annotationMa8;
                // the annotation is currently not selected and is being selected, so we need to open the view.
                (0, $hNBI1.setSelectedAnnotation)(id)(editorView.state, editorView.dispatch);
                // the current annotations are going to be unselected. So we need to notify listeners of this change also.
                selectedAnnotations === null || selectedAnnotations === void 0 || selectedAnnotations.forEach((annotation)=>{
                    if (annotation.id !== id) {
                        var _options$annotationMa7;
                        (_options$annotationMa7 = options.annotationManager) === null || _options$annotationMa7 === void 0 || _options$annotationMa7.emit({
                            name: 'annotationSelectionChanged',
                            data: {
                                annotationId: annotation.id,
                                isSelected: false,
                                inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, annotation.id) ?? []
                            }
                        });
                    }
                });
                // Lastly we need to emit the event for the selected annotation.
                (_options$annotationMa8 = options.annotationManager) === null || _options$annotationMa8 === void 0 || _options$annotationMa8.emit({
                    name: 'annotationSelectionChanged',
                    data: {
                        annotationId: id,
                        isSelected: true,
                        inlineNodeTypes: (0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, id) ?? []
                    }
                });
            }
        }
        return {
            success: true,
            isSelected: isSelected
        };
    };
const $3a406416cdb16f64$export$5ada3da2e2f0701f = (editorView, _options)=>(id, isHovered)=>{
        const { annotations: annotations, hoveredAnnotations: hoveredAnnotations } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!(annotations !== null && annotations !== void 0 && annotations.hasOwnProperty(id))) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_ID_INVALID
        };
        const isCurrentlyHoveredIndex = (hoveredAnnotations === null || hoveredAnnotations === void 0 ? void 0 : hoveredAnnotations.findIndex((annotation)=>annotation.id === id)) ?? -1;
        const isCurrentlyHovered = isCurrentlyHoveredIndex !== -1;
        if (isHovered !== isCurrentlyHovered) {
            // the annotation in hovered is changing.
            if (isCurrentlyHovered && !isHovered) // the hovered annotaion is being unhovered, so we should remove the hover state.
            (0, $hNBI1.setHoveredAnnotation)('')(editorView.state, editorView.dispatch);
            else if (!isCurrentlyHovered && isHovered) // the annotation is currently not hovered and is being hovered.
            (0, $hNBI1.setHoveredAnnotation)(id)(editorView.state, editorView.dispatch);
        }
        return {
            success: true,
            isHovered: isHovered
        };
    };
const $3a406416cdb16f64$export$6baae9b3f0f9bdce = (editorView, options)=>(id)=>{
        const { annotations: annotations } = (0, $9179K.inlineCommentPluginKey).getState(editorView.state) || {};
        // If there is no annotation state with this id then we can assume the annotation is invalid.
        if (!(annotations !== null && annotations !== void 0 && annotations.hasOwnProperty(id))) return {
            success: false,
            reason: $3a406416cdb16f64$var$ERROR_REASON_ID_INVALID
        };
        (0, $hNBI1.removeInlineCommentFromDoc)(options.editorAnalyticsAPI)(id, options.provider.supportedBlockNodes, options.provider.isBlockNodeSupported)(editorView.state, editorView.dispatch);
        return {
            success: true,
            actionResult: undefined
        };
    };

});
parcelRegister("aN6Yq", function(module, exports) {
$parcel$export(module.exports, "resolveAnnotatableTargetFromLocalId", () => $b3b3620c1292ae4b$export$8c0008216cf138af);

var $gC2vY = parcelRequire("gC2vY");

var $9179K = parcelRequire("9179K");
const $b3b3620c1292ae4b$export$8c0008216cf138af = (state, localId, opts)=>{
    const { supportedBlockNodes: supportedBlockNodes } = opts;
    const matches = (0, $gC2vY.findNodePosByLocalIds)(state, [
        localId
    ]);
    if (matches.length === 0) return undefined;
    const annotationMarkType = state.schema.marks.annotation;
    const nodeAcceptsAnnotation = (node)=>node.type.allowsMarkType(annotationMarkType) || (0, $9179K.isSupportedBlockNode)(node, supportedBlockNodes);
    const { node: node, pos: pos } = matches[0];
    if (nodeAcceptsAnnotation(node)) return {
        node: node,
        pos: pos
    };
    // Ancestors only — never descendants.
    const $pos = state.doc.resolve(pos);
    for(let depth = $pos.depth; depth >= 0; depth--){
        const ancestor = $pos.node(depth);
        if (nodeAcceptsAnnotation(ancestor)) return {
            node: ancestor,
            pos: depth === 0 ? 0 : $pos.before(depth)
        };
    }
    return undefined;
};

});


parcelRegister("7ItCw", function(module, exports) {
$parcel$export(module.exports, "shouldSuppressFloatingToolbar", () => $80ac4c58f4526278$export$8921e02ce71849ce);
$parcel$export(module.exports, "buildSuppressedToolbar", () => $80ac4c58f4526278$export$4f0bdd9681380033);
$parcel$export(module.exports, "buildToolbar", () => $80ac4c58f4526278$export$6dd6ab35df8f7f86);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $1H8qk = parcelRequire("1H8qk");

var $5knpG = parcelRequire("5knpG");

var $eUtBU = parcelRequire("eUtBU");

var $ls2OU = parcelRequire("ls2OU");

var $RYyF2 = parcelRequire("RYyF2");

var $f1MDe = parcelRequire("f1MDe");

var $9Q4ru = parcelRequire("9Q4ru");

var $3UAb3 = parcelRequire("3UAb3");

var $dRkX9 = parcelRequire("dRkX9");

var $hNBI1 = parcelRequire("hNBI1");

var $5tfXu = parcelRequire("5tfXu");

var $9179K = parcelRequire("9179K");
const $80ac4c58f4526278$var$getValidNodes = (state)=>{
    const { schema: schema } = state;
    const { annotation: annotation } = schema.marks;
    return Object.keys(schema.nodes).reduce((acc, current)=>{
        const type = schema.nodes[current];
        if (type.allowsMarkType(annotation)) acc.push(type);
        return acc;
    }, []);
};
const $80ac4c58f4526278$export$8921e02ce71849ce = ({ state: state, bookmark: bookmark })=>{
    if (!bookmark) return false;
    const { tr: tr } = state;
    const resolvedBookmark = bookmark.resolve(tr.doc);
    const isSelectionMatchingBookmark = resolvedBookmark.to === tr.selection.to && resolvedBookmark.from === tr.selection.from;
    return isSelectionMatchingBookmark;
};
const $80ac4c58f4526278$export$4f0bdd9681380033 = (state)=>{
    return {
        items: [],
        nodeType: $80ac4c58f4526278$var$getValidNodes(state),
        title: 'Annotation suppressed toolbar'
    };
};
const $80ac4c58f4526278$export$6dd6ab35df8f7f86 = (editorAnalyticsAPI)=>({ state: state, intl: intl, isToolbarAbove: isToolbarAbove = false, _supportedNodes: _supportedNodes = [], api: api, createCommentExperience: createCommentExperience, annotationManager: annotationManager, onCommentButtonMount: onCommentButtonMount, getCanAddComments: getCanAddComments = ()=>true, contentType: contentType })=>{
        var _api$connectivity;
        const selectionValid = (0, $9179K.isSelectionValid)(state);
        const isMediaSelected = (0, $ls2OU.currentMediaNodeWithPos)(state);
        // comments on media can only be added via media floating toolbar
        if (isMediaSelected || selectionValid === (0, $5tfXu.AnnotationSelectionType).INVALID) return undefined;
        const createCommentMessage = intl.formatMessage((0, $RYyF2.annotationMessages).createComment);
        const commentDisabledMessage = intl.formatMessage((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? (0, $RYyF2.annotationMessages).createCommentDisabled : (0, $RYyF2.annotationMessages).createCommentInvalid);
        const canAddComments = getCanAddComments();
        const isCommentButtonDisabled = !canAddComments || selectionValid === (0, $5tfXu.AnnotationSelectionType).DISABLED;
        const disabledTooltipContent = !canAddComments ? intl.formatMessage((0, $RYyF2.annotationMessages).noPermissionToAddComment, {
            contentType: contentType
        }) : commentDisabledMessage;
        const createComment = {
            type: 'button',
            showTitle: true,
            disabled: isCommentButtonDisabled || (0, $5knpG.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode),
            testId: (0, $5tfXu.AnnotationTestIds).floatingToolbarCreateButton,
            interactionName: 'start-inline-comment-action',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))),
            tooltipContent: isCommentButtonDisabled ? disabledTooltipContent : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
                description: createCommentMessage,
                keymap: (0, $eUtBU.addInlineComment)
            }),
            title: createCommentMessage,
            onMount: ()=>{
                onCommentButtonMount && onCommentButtonMount();
                // Check if the selection includes an non-text inline node
                const inlineCommentPluginState = (0, $9179K.getPluginState)(state);
                const inlineNodeNames = (0, $f1MDe.getRangeInlineNodeNames)({
                    doc: state.doc,
                    pos: (0, $9179K.resolveDraftBookmark)(state, inlineCommentPluginState === null || inlineCommentPluginState === void 0 ? void 0 : inlineCommentPluginState.bookmark)
                }) ?? [];
                const isNonTextInlineNodeInludedInComment = inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
                if (editorAnalyticsAPI) editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $3LeME.ACTION).VIEWED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                    eventType: (0, $3LeME.EVENT_TYPE).UI,
                    attributes: {
                        isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
                        isDisabled: selectionValid === (0, $5tfXu.AnnotationSelectionType).DISABLED,
                        inputMethod: (0, $3LeME.INPUT_METHOD).FLOATING_TB,
                        mode: (0, $1H8qk.MODE).EDITOR
                    }
                });
            },
            onClick: (state, dispatch)=>{
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent({
                    action: (0, $3LeME.ACTION).CLICKED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                    eventType: (0, $3LeME.EVENT_TYPE).UI,
                    attributes: {
                        source: 'highlightActionsMenu',
                        pageMode: 'edit'
                    }
                });
                if (annotationManager) {
                    annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
                        if (canStartDraft) {
                            createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.start({
                                attributes: {
                                    pageClass: 'editor',
                                    commentType: 'inline',
                                    entryPoint: 'highlightActions'
                                }
                            });
                            createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.initExperience.start();
                            const result = annotationManager.startDraft();
                            if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                            // but the action was not completed, the result should contain a reason.
                            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent({
                                action: (0, $3LeME.ACTION).ERROR,
                                actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                                attributes: {
                                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                                }
                            });
                        }
                    }).catch(()=>{
                        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent({
                            action: (0, $3LeME.ACTION).ERROR,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
                            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
                            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                errorReason: `toolbar-start-draft-preemptive-gate-error`
                            }
                        });
                    });
                    return true;
                } else {
                    createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.start({
                        attributes: {
                            pageClass: 'editor',
                            commentType: 'inline',
                            entryPoint: 'highlightActions'
                        }
                    });
                    createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.initExperience.start();
                    return (0, $hNBI1.setInlineCommentDraftState)(editorAnalyticsAPI)(true)(state, dispatch);
                }
            },
            supportsViewMode: true // TODO: MODES-3950 - Clean up this floating toolbar view mode logic,
        };
        const toolbarTitle = intl.formatMessage((0, $RYyF2.annotationMessages).toolbar);
        const calcToolbarPosition = isToolbarAbove ? (0, $9Q4ru.calculateToolbarPositionAboveSelection) : (0, $9Q4ru.calculateToolbarPositionTrackHead);
        const onPositionCalculated = calcToolbarPosition(toolbarTitle);
        return {
            title: toolbarTitle,
            nodeType: $80ac4c58f4526278$var$getValidNodes(state),
            items: [
                createComment
            ],
            onPositionCalculated: onPositionCalculated,
            pluginName: 'annotation'
        };
    };

});


parcelRegister("cayfj", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $e964062f0513d642$export$e832373cff8dec22);

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $1O8Lw = parcelRequire("1O8Lw");

var $hNBI1 = parcelRequire("hNBI1");
function $e964062f0513d642$export$e832373cff8dec22(api) {
    var _api$analytics;
    const list = {};
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addInlineComment).common, (0, $hNBI1.setInlineCommentDraftState)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, undefined, api)(true, (0, $3LeME.INPUT_METHOD).SHORTCUT), list);
    return (0, $1O8Lw.keymap)(list);
}

});

parcelRegister("4SYRO", function(module, exports) {
$parcel$export(module.exports, "InlineCommentView", () => $f6f3e5a12e6bd281$export$ce99d9856d415465);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $6DAwh = parcelRequire("6DAwh");

var $3LeME = parcelRequire("3LeME");

var $7tbCp = parcelRequire("7tbCp");

var $5knpG = parcelRequire("5knpG");

var $jnzAA = parcelRequire("jnzAA");

var $9oAqi = parcelRequire("9oAqi");

var $f1MDe = parcelRequire("f1MDe");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $dRkX9 = parcelRequire("dRkX9");

var $hNBI1 = parcelRequire("hNBI1");

var $9179K = parcelRequire("9179K");

var $5tfXu = parcelRequire("5tfXu");

var $5yRJX = parcelRequire("5yRJX");
const $f6f3e5a12e6bd281$var$findPosForDOM = (sel)=>{
    const { $from: $from, from: from } = sel;
    // Retrieve current TextNode
    const index = $from.index();
    const node = index < $from.parent.childCount && $from.parent.child(index);
    // Right edge of a mark.
    if (!node && $from.nodeBefore && $from.nodeBefore.isText && $from.nodeBefore.marks.find((mark)=>mark.type.name === 'annotation')) return from - 1;
    return from;
};
const $f6f3e5a12e6bd281$var$selector = (states)=>{
    var _states$annotationSta, _states$annotationSta2, _states$annotationSta3, _states$annotationSta4, _states$annotationSta5, _states$annotationSta6, _states$annotationSta7;
    return {
        annotations: (_states$annotationSta = states.annotationState) === null || _states$annotationSta === void 0 ? void 0 : _states$annotationSta.annotations,
        bookmark: (_states$annotationSta2 = states.annotationState) === null || _states$annotationSta2 === void 0 ? void 0 : _states$annotationSta2.bookmark,
        isInlineCommentViewClosed: (_states$annotationSta3 = states.annotationState) === null || _states$annotationSta3 === void 0 ? void 0 : _states$annotationSta3.isInlineCommentViewClosed,
        isOpeningMediaCommentFromToolbar: (_states$annotationSta4 = states.annotationState) === null || _states$annotationSta4 === void 0 ? void 0 : _states$annotationSta4.isOpeningMediaCommentFromToolbar,
        selectAnnotationMethod: (_states$annotationSta5 = states.annotationState) === null || _states$annotationSta5 === void 0 ? void 0 : _states$annotationSta5.selectAnnotationMethod,
        selectedAnnotations: (_states$annotationSta6 = states.annotationState) === null || _states$annotationSta6 === void 0 ? void 0 : _states$annotationSta6.selectedAnnotations,
        isAnnotationManagerEnabled: (_states$annotationSta7 = states.annotationState) === null || _states$annotationSta7 === void 0 ? void 0 : _states$annotationSta7.isAnnotationManagerEnabled
    };
};
function $f6f3e5a12e6bd281$export$ce99d9856d415465({ providers: providers, editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    // As inlineComment is the only annotation present, this function is not generic
    const { inlineComment: inlineCommentProvider } = providers;
    const { state: state, dispatch: dispatch } = editorView;
    const { createComponent: CreateComponent, viewComponent: ViewComponent } = inlineCommentProvider;
    const { annotations: annotations, bookmark: bookmark, isInlineCommentViewClosed: isInlineCommentViewClosed, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, selectAnnotationMethod: selectAnnotationMethod, selectedAnnotations: selectedAnnotations, isAnnotationManagerEnabled: isAnnotationManagerEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(editorAPI, [
        'annotation'
    ], $f6f3e5a12e6bd281$var$selector);
    const annotationsList = (0, $9179K.getAllAnnotations)(editorView.state.doc);
    const selection = (0, $9179K.getSelectionPositions)(state, bookmark);
    const position = $f6f3e5a12e6bd281$var$findPosForDOM(selection);
    const isExtensionSelection = selection instanceof (0, $801jp.NodeSelection) && selection.node.type.name === 'extension';
    let dom;
    let domLookupError;
    try {
        const domRef = (0, $a4TQr.findDomRefAtPos)(position, editorView.domAtPos.bind(editorView));
        if ((0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && isExtensionSelection) {
            if (domRef instanceof HTMLElement) dom = domRef;
        } else // Preserve the existing text/media and gate-off anchor lookup.
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        dom = domRef;
    } catch (error) {
        domLookupError = error;
    }
    // Native embed extension nodes are rendered by a node view. Depending on
    // the wrapper, domAtPos can return no element (or throw) even though
    // EditorView.nodeDOM can. Use that direct lookup as a block-comment anchor.
    if ((0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && !dom && isExtensionSelection) {
        const nodeDom = editorView.nodeDOM(selection.from);
        if (nodeDom instanceof HTMLElement) dom = nodeDom;
    }
    if (!dom && domLookupError) {
        // eslint-disable-next-line no-console
        console.warn(domLookupError);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $3LeME.ACTION).ERRORED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $3LeME.CONTENT_COMPONENT).INLINE_COMMENT,
                    selection: selection.toJSON(),
                    position: position,
                    docSize: editorView.state.doc.nodeSize,
                    error: domLookupError.toString()
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
    // Network Status
    const networkStatusSelector = (0, $jnzAA.useSharedPluginStateSelector)(editorAPI, 'connectivity.mode');
    if (!dom) return null;
    // Create Component
    if (bookmark) {
        if (!CreateComponent) return null;
        const inlineNodeTypes = (0, $f1MDe.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: selection
        });
        //getting all text between bookmarked positions
        const textSelection = state.doc.textBetween(selection.from, selection.to);
        return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            "data-testid": (0, $5tfXu.AnnotationTestIds).floatingComponent,
            "data-editor-popup": "true",
            children: /*#__PURE__*/ (0, $3LM7S.jsx)(CreateComponent, {
                dom: dom,
                textSelection: textSelection,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCreate: (id)=>{
                    if (!isAnnotationManagerEnabled) {
                        const createAnnotationResult = (0, $hNBI1.createAnnotation)(editorAnalyticsAPI, editorAPI)(id, (0, $6DAwh.AnnotationTypes).INLINE_COMMENT, inlineCommentProvider.supportedBlockNodes, inlineCommentProvider.isBlockNodeSupported)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                        if (!createAnnotationResult) throw new Error('Failed to create annotation');
                    }
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onCreateError: (id)=>// This is called when optimistic create inline comment encounters an error,
                    // in which case the optimistically added annotation must be removed.
                    (0, $hNBI1.removeInlineCommentNearSelection)(id, inlineCommentProvider.supportedBlockNodes, inlineCommentProvider.isBlockNodeSupported)(editorView.state, editorView.dispatch),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClose: ()=>{
                    if (!isAnnotationManagerEnabled) {
                        (0, $hNBI1.setInlineCommentDraftState)(editorAnalyticsAPI, undefined, editorAPI)(false)(editorView.state, editorView.dispatch);
                        !editorView.hasFocus() && editorView.focus();
                    }
                },
                inlineNodeTypes: inlineNodeTypes,
                isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
                isOffline: (0, $5knpG.isOfflineMode)(networkStatusSelector)
            })
        });
    }
    // View Component
    const activeAnnotations = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    (selectedAnnotations === null || selectedAnnotations === void 0 ? void 0 : selectedAnnotations.filter((mark)=>annotations && annotations[mark.id] === false)) || [];
    if (!ViewComponent || activeAnnotations.length === 0) return null;
    const onAnnotationViewed = ()=>{
        if (!dispatchAnalyticsEvent) return;
        // fire analytics
        const targetNode = editorView.state.doc.nodeAt(position);
        const targetNodeType = targetNode === null || targetNode === void 0 ? void 0 : targetNode.type.name;
        let commentTargetType = targetNode ? 'other' : 'unknown';
        if (targetNodeType === 'extension') commentTargetType = (targetNode === null || targetNode === void 0 ? void 0 : targetNode.attrs.extensionKey) === 'native-embed:maui' ? 'remixEmbed' : 'other';
        else if ([
            'media',
            'mediaSingle',
            'mediaInline'
        ].includes(targetNodeType ?? '')) commentTargetType = 'media';
        else if (targetNode !== null && targetNode !== void 0 && targetNode.isText) commentTargetType = 'text';
        const payload = {
            action: (0, $3LeME.ACTION).VIEWED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                overlap: activeAnnotations.length ? activeAnnotations.length - 1 : 0,
                targetNodeType: targetNodeType,
                commentTargetType: commentTargetType,
                method: selectAnnotationMethod
            }
        };
        dispatchAnalyticsEvent(payload);
    };
    if (isInlineCommentViewClosed || !selectedAnnotations) return null;
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (annotationId)=>(0, $f1MDe.getAnnotationInlineNodeTypes)(editorView.state, annotationId);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5yRJX.AnnotationViewWrapper), {
        "data-editor-popup": "true",
        "data-testid": (0, $5tfXu.AnnotationTestIds).floatingComponent,
        onViewed: onAnnotationViewed,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)(ViewComponent, {
            annotationsList: annotationsList,
            annotations: activeAnnotations,
            getInlineNodeTypes: getInlineNodeTypes,
            dom: dom,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onDelete: (id)=>(0, $hNBI1.removeInlineCommentNearSelection)(id, inlineCommentProvider.supportedBlockNodes, inlineCommentProvider.isBlockNodeSupported)(editorView.state, dispatch),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onResolve: (id)=>(0, $hNBI1.updateInlineCommentResolvedState)(editorAnalyticsAPI)({
                    [id]: true
                }, (0, $7tbCp.RESOLVE_METHOD).COMPONENT)(editorView.state, editorView.dispatch),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClose: ()=>{
                (0, $hNBI1.closeComponent)()(editorView.state, editorView.dispatch);
            },
            isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
            isOffline: (0, $5knpG.isOfflineMode)(networkStatusSelector)
        })
    }, (0, $9179K.getAnnotationViewKey)(activeAnnotations));
}

});
parcelRegister("5yRJX", function(module, exports) {
$parcel$export(module.exports, "AnnotationViewWrapper", () => $f9df5c63881d8fd7$export$1fe5705f230796ba);

var $fc4bM = parcelRequire("fc4bM");
class $f9df5c63881d8fd7$export$1fe5705f230796ba extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    componentDidMount() {
        const { onViewed: onViewed } = this.props;
        if (onViewed) onViewed();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("9RKIs", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $642ee59f1ff060ee$export$a758406ca53b86a5);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cIIZO = parcelRequire("cIIZO");

var $fdhSI = parcelRequire("fdhSI");

var $MaIQd = parcelRequire("MaIQd");
const $642ee59f1ff060ee$export$a758406ca53b86a5 = (api, annotationProviders)=>{
    return [
        {
            type: (0, $cIIZO.COLLAB_SECTION).type,
            key: (0, $cIIZO.COLLAB_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $cIIZO.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $fdhSI.TOOLBAR_RANK)[(0, $cIIZO.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cIIZO.COMMENT_GROUP).type,
            key: (0, $cIIZO.COMMENT_GROUP).key,
            parents: [
                {
                    type: (0, $cIIZO.COLLAB_SECTION).type,
                    key: (0, $cIIZO.COLLAB_SECTION).key,
                    rank: (0, $fdhSI.TOOLBAR_RANK)[(0, $cIIZO.COLLAB_SECTION).key]
                }
            ]
        },
        {
            type: (0, $cIIZO.COMMENT_HERO_BUTTON).type,
            key: (0, $cIIZO.COMMENT_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $cIIZO.COMMENT_GROUP).type,
                    key: (0, $cIIZO.COMMENT_GROUP).key,
                    rank: (0, $fdhSI.COLLAB_SECTION_RANK)[(0, $cIIZO.COMMENT_GROUP).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $MaIQd.CommentButton), {
                    api: api,
                    annotationProviders: annotationProviders
                });
            }
        }
    ];
};

});
parcelRegister("MaIQd", function(module, exports) {
$parcel$export(module.exports, "CommentButton", () => $58294d09f54679d4$export$44a3d5aec3da3e9f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $eUtBU = parcelRequire("eUtBU");

var $RYyF2 = parcelRequire("RYyF2");

var $gBSUv = parcelRequire("gBSUv");

var $9oAqi = parcelRequire("9oAqi");

var $3UAb3 = parcelRequire("3UAb3");

var $gdKam = parcelRequire("gdKam");

var $6K4Zt = parcelRequire("6K4Zt");

var $dRkX9 = parcelRequire("dRkX9");

var $9179K = parcelRequire("9179K");

var $5tfXu = parcelRequire("5tfXu");

var $hFEGX = parcelRequire("hFEGX");

var $iqarL = parcelRequire("iqarL");
const $58294d09f54679d4$export$44a3d5aec3da3e9f = ({ api: api, annotationProviders: annotationProviders })=>{
    const { isVisible: isVisible, bookmark: bookmark } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], (states)=>{
        var _states$annotationSta, _states$annotationSta2;
        return {
            isVisible: (_states$annotationSta = states.annotationState) === null || _states$annotationSta === void 0 ? void 0 : _states$annotationSta.isVisible,
            bookmark: (_states$annotationSta2 = states.annotationState) === null || _states$annotationSta2 === void 0 ? void 0 : _states$annotationSta2.bookmark
        };
    });
    const { editorView: editorView } = (0, $gBSUv.useEditorToolbar)();
    const annotationSelectionType = editorView !== null && editorView !== void 0 && editorView.state ? (0, $9179K.isSelectionValid)(editorView.state) : (0, $5tfXu.AnnotationSelectionType).INVALID;
    const { getCanAddComments: getCanAddComments, contentType: contentType } = (annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.inlineComment) ?? {};
    (0, $hFEGX.useCommentButtonMount)({
        state: editorView === null || editorView === void 0 ? void 0 : editorView.state,
        annotationProviders: annotationProviders,
        api: api,
        annotationSelectionType: annotationSelectionType,
        bookmark: bookmark
    });
    const intl = (0, $gpjDl.default)();
    const onClick = ()=>{
        if (!api || !annotationProviders || !(editorView !== null && editorView !== void 0 && editorView.state) || !(editorView !== null && editorView !== void 0 && editorView.dispatch)) return;
        (0, $iqarL.fireOnClickAnalyticsEvent)({
            api: api
        });
        (0, $iqarL.startCommentExperience)({
            annotationProviders: annotationProviders,
            api: api,
            state: editorView.state,
            dispatch: editorView.dispatch
        });
    };
    if (!(0, $iqarL.shouldShowCommentButton)({
        state: editorView === null || editorView === void 0 ? void 0 : editorView.state,
        isVisible: isVisible,
        annotationSelectionType: annotationSelectionType
    })) return null;
    const canAddComments = getCanAddComments ? getCanAddComments() : true;
    const commentMessage = intl.formatMessage((0, $RYyF2.annotationMessages).createComment);
    const commentDisabledMessage = intl.formatMessage((0, $dRkX9.fg)('editor_inline_comments_on_inline_nodes') ? (0, $RYyF2.annotationMessages).createCommentDisabled : (0, $RYyF2.annotationMessages).createCommentInvalid);
    const noPermissionToAddCommentMessage = intl.formatMessage((0, $RYyF2.annotationMessages).noPermissionToAddComment, {
        contentType: contentType
    });
    const { isDisabled: isDisabled, isAnnotationSelectionInvalid: isAnnotationSelectionInvalid } = (0, $iqarL.isButtonDisabled)({
        state: editorView === null || editorView === void 0 ? void 0 : editorView.state,
        api: api,
        canAddComments: canAddComments
    });
    const tooltipContentWhenDisabled = ()=>{
        if (!canAddComments) return noPermissionToAddCommentMessage;
        else if (isAnnotationSelectionInvalid) return commentDisabledMessage;
        else // i.e. isOffline. No tooltip message needed.
        return undefined;
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6K4Zt.ToolbarTooltip), {
        content: isDisabled ? tooltipContentWhenDisabled() : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
            description: commentMessage,
            keymap: (0, $eUtBU.addInlineComment)
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gdKam.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))), {
                label: "",
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $5tfXu.AnnotationTestIds).floatingToolbarCreateButton,
            isDisabled: isDisabled,
            children: commentMessage
        })
    });
};

});
parcelRegister("hFEGX", function(module, exports) {
$parcel$export(module.exports, "useCommentButtonMount", () => $7600f089b54e73fd$export$b0b121505277a396);

var $fc4bM = parcelRequire("fc4bM");

var $f1MDe = parcelRequire("f1MDe");

var $9179K = parcelRequire("9179K");

var $iqarL = parcelRequire("iqarL");
const $7600f089b54e73fd$export$b0b121505277a396 = ({ state: state, annotationProviders: annotationProviders, api: api, annotationSelectionType: annotationSelectionType, bookmark: bookmark })=>{
    (0, $fc4bM.useEffect)(()=>{
        if (!state) return;
        if (annotationProviders !== null && annotationProviders !== void 0 && annotationProviders.inlineComment) {
            var _annotationProviders$, _annotationProviders$2;
            (_annotationProviders$ = (_annotationProviders$2 = annotationProviders.inlineComment).onCommentButtonMount) === null || _annotationProviders$ === void 0 || _annotationProviders$.call(_annotationProviders$2);
        }
        // Check if the selection includes an non-text inline node
        const inlineNodeNames = (0, $f1MDe.getRangeInlineNodeNames)({
            doc: state.doc,
            pos: (0, $9179K.resolveDraftBookmark)(state, bookmark)
        }) ?? [];
        const isNonTextInlineNodeInludedInComment = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        inlineNodeNames.filter((nodeName)=>nodeName !== 'text').length > 0;
        (0, $iqarL.fireCommentButtonViewedAnalyticsEvent)({
            api: api,
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            annotationSelectionType: annotationSelectionType
        });
    // for now trying to replicate current onMount logic
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("iqarL", function(module, exports) {
$parcel$export(module.exports, "isButtonDisabled", () => $98a442d8c6d493f3$export$7a6737b74121da6f);
$parcel$export(module.exports, "shouldShowCommentButton", () => $98a442d8c6d493f3$export$dd62b022312fd583);
$parcel$export(module.exports, "fireOnClickAnalyticsEvent", () => $98a442d8c6d493f3$export$b5fd00fffbd8948d);
$parcel$export(module.exports, "fireCommentButtonViewedAnalyticsEvent", () => $98a442d8c6d493f3$export$aa79a97671c224b4);
$parcel$export(module.exports, "startCommentExperience", () => $98a442d8c6d493f3$export$c983cfb71edde6e4);

var $3LeME = parcelRequire("3LeME");

var $1H8qk = parcelRequire("1H8qk");

var $5knpG = parcelRequire("5knpG");

var $ls2OU = parcelRequire("ls2OU");

var $hNBI1 = parcelRequire("hNBI1");

var $9179K = parcelRequire("9179K");

var $5tfXu = parcelRequire("5tfXu");
const $98a442d8c6d493f3$export$7a6737b74121da6f = ({ state: state, api: api, canAddComments: canAddComments })=>{
    var _api$connectivity;
    const annotationSelectionType = state ? (0, $9179K.isSelectionValid)(state) : (0, $5tfXu.AnnotationSelectionType).INVALID;
    const isAnnotationSelectionInvalid = annotationSelectionType === (0, $5tfXu.AnnotationSelectionType).DISABLED;
    const isOffline = (0, $5knpG.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode);
    return {
        isAnnotationSelectionInvalid: isAnnotationSelectionInvalid,
        isOffline: isOffline,
        canAddComments: canAddComments,
        isDisabled: !canAddComments || isAnnotationSelectionInvalid || isOffline
    };
};
const $98a442d8c6d493f3$export$dd62b022312fd583 = ({ state: state, isVisible: isVisible, annotationSelectionType: annotationSelectionType })=>{
    const isMediaSelected = state ? (0, $ls2OU.currentMediaNodeWithPos)(state) : false;
    let isDrafting = false;
    if (state) {
        var _inlineCommentPluginK;
        isDrafting = ((_inlineCommentPluginK = (0, $9179K.inlineCommentPluginKey).getState(state)) === null || _inlineCommentPluginK === void 0 ? void 0 : _inlineCommentPluginK.isDrafting) || false;
    }
    // comments on media can only be added via media floating toolbar
    if (isDrafting || isMediaSelected || annotationSelectionType === (0, $5tfXu.AnnotationSelectionType).INVALID || !isVisible) return false;
    return true;
};
const $98a442d8c6d493f3$export$b5fd00fffbd8948d = ({ api: api })=>{
    var _api$analytics;
    (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
        action: (0, $3LeME.ACTION).CLICKED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
        eventType: (0, $3LeME.EVENT_TYPE).UI,
        attributes: {
            source: 'highlightActionsMenu',
            pageMode: 'edit'
        }
    });
};
const $98a442d8c6d493f3$var$fireAnnotationErrorAnalyticsEvent = ({ api: api, errorReason: errorReason })=>{
    var _api$analytics2;
    (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.fireAnalyticsEvent({
        action: (0, $3LeME.ACTION).ERROR,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).ANNOTATION,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorReason: errorReason
        }
    });
};
const $98a442d8c6d493f3$export$aa79a97671c224b4 = ({ api: api, isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment, annotationSelectionType: annotationSelectionType })=>{
    var _api$analytics3;
    api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || _api$analytics3.actions.fireAnalyticsEvent({
        action: (0, $3LeME.ACTION).VIEWED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).INLINE_COMMENT,
        eventType: (0, $3LeME.EVENT_TYPE).UI,
        attributes: {
            isNonTextInlineNodeInludedInComment: isNonTextInlineNodeInludedInComment,
            isDisabled: annotationSelectionType === (0, $5tfXu.AnnotationSelectionType).DISABLED,
            inputMethod: (0, $3LeME.INPUT_METHOD).FLOATING_TB,
            mode: (0, $1H8qk.MODE).EDITOR
        }
    });
};
const $98a442d8c6d493f3$export$c983cfb71edde6e4 = ({ annotationProviders: annotationProviders, api: api, state: state, dispatch: dispatch })=>{
    const annotationManager = annotationProviders === null || annotationProviders === void 0 ? void 0 : annotationProviders.annotationManager;
    if (annotationManager) {
        annotationManager.checkPreemptiveGate().then((canStartDraft)=>{
            if (canStartDraft) {
                var _annotationProviders$, _annotationProviders$2;
                (_annotationProviders$ = annotationProviders.createCommentExperience) === null || _annotationProviders$ === void 0 || _annotationProviders$.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'inline',
                        entryPoint: 'highlightActions'
                    }
                });
                (_annotationProviders$2 = annotationProviders.createCommentExperience) === null || _annotationProviders$2 === void 0 || _annotationProviders$2.initExperience.start();
                const result = annotationManager.startDraft();
                if (!result.success) // Fire an analytics event to indicate that the user has clicked the button
                // but the action was not completed, the result should contain a reason.
                $98a442d8c6d493f3$var$fireAnnotationErrorAnalyticsEvent({
                    api: api,
                    errorReason: `toolbar-start-draft-failed/${result.reason}`
                });
            }
        }).catch(()=>{
            $98a442d8c6d493f3$var$fireAnnotationErrorAnalyticsEvent({
                api: api,
                errorReason: `toolbar-start-draft-preemptive-gate-error`
            });
        });
        return true;
    } else {
        var _annotationProviders$3, _annotationProviders$4, _api$analytics4;
        annotationProviders === null || annotationProviders === void 0 || (_annotationProviders$3 = annotationProviders.createCommentExperience) === null || _annotationProviders$3 === void 0 || _annotationProviders$3.start({
            attributes: {
                pageClass: 'editor',
                commentType: 'inline',
                entryPoint: 'highlightActions'
            }
        });
        annotationProviders === null || annotationProviders === void 0 || (_annotationProviders$4 = annotationProviders.createCommentExperience) === null || _annotationProviders$4 === void 0 || _annotationProviders$4.initExperience.start();
        return (0, $hNBI1.setInlineCommentDraftState)(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, undefined, api)(true)(state, dispatch);
    }
};

});





parcelRegister("69BNl", function(module, exports) {
$parcel$export(module.exports, "avatarGroupPlugin", () => $3e562678b1a9dff7$export$56985cb4934eb626);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2D5Xo = parcelRequire("2D5Xo");

var $hYNp5 = parcelRequire("hYNp5");
const $3e562678b1a9dff7$export$56985cb4934eb626 = ({ config: props, api: api })=>{
    var _api$featureFlags;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const primaryToolbarComponent = ({ editorView: editorView, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        var _api$analytics;
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2D5Xo.default), {
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            editorView: editorView,
            eventDispatcher: eventDispatcher,
            collabEdit: props === null || props === void 0 ? void 0 : props.collabEdit,
            takeFullWidth: props === null || props === void 0 ? void 0 : props.takeFullWidth,
            featureFlags: featureFlags,
            editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions,
            editorAPI: api
        });
    };
    if (props.showAvatarGroup) {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'avatarGroup',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'avatarGroup',
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) && props.showAvatarGroup ? primaryToolbarComponent : undefined,
        actions: {
            getToolbarItem: ({ inviteToEditHandler: inviteToEditHandler, isInviteToEditButtonSelected: isInviteToEditButtonSelected, inviteToEditComponent: inviteToEditComponent })=>{
                var _api$featureFlags2, _api$analytics2;
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hYNp5.default), {
                    featureFlags: (api === null || api === void 0 || (_api$featureFlags2 = api.featureFlags) === null || _api$featureFlags2 === void 0 ? void 0 : _api$featureFlags2.sharedState.currentState()) ?? {},
                    editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions,
                    editorAPI: api,
                    inviteToEditHandler: inviteToEditHandler,
                    isInviteToEditButtonSelected: isInviteToEditButtonSelected,
                    inviteToEditComponent: inviteToEditComponent
                });
            }
        }
    };
};

});
parcelRegister("2D5Xo", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd2a74e4d7b1ac77$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $8B2n0 = parcelRequire("8B2n0");

var $hYNp5 = parcelRequire("hYNp5");
function $bd2a74e4d7b1ac77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $bd2a74e4d7b1ac77$var$toolbarButtonWrapper = {
    name: "gzuwk4",
    styles: "display:flex;justify-content:flex-end;flex-grow:0;align-items:center;& > div{margin-right:0;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $bd2a74e4d7b1ac77$var$toolbarButtonWrapperFullWidth = /*#__PURE__*/ (0, $jctmk.css)($bd2a74e4d7b1ac77$var$toolbarButtonWrapper, "flex-grow:1;");
const $bd2a74e4d7b1ac77$var$AvatarGroupPluginWrapper = (props)=>{
    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent, featureFlags: featureFlags } = props;
    const intl = (0, $gpjDl.default)();
    (0, $fc4bM.useEffect)(()=>{
        if (!dispatchAnalyticsEvent) return;
        dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).VIEWED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).AVATAR_GROUP_PLUGIN,
            eventType: (0, $3LeME.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "aria-label": intl.formatMessage((0, $8B2n0.avatarGroupMessages).editors),
        "data-testid": 'avatar-group-in-plugin',
        css: props.takeFullWidth ? $bd2a74e4d7b1ac77$var$toolbarButtonWrapperFullWidth : $bd2a74e4d7b1ac77$var$toolbarButtonWrapper
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $hYNp5.default), {
        editorView: props.editorView,
        eventDispatcher: props.eventDispatcher,
        inviteToEditComponent: props.collabEdit && props.collabEdit.inviteToEditComponent,
        inviteToEditHandler: props.collabEdit && props.collabEdit.inviteToEditHandler,
        isInviteToEditButtonSelected: props.collabEdit && props.collabEdit.isInviteToEditButtonSelected,
        featureFlags: featureFlags,
        editorAnalyticsAPI: props.editorAnalyticsAPI,
        editorAPI: props.editorAPI
    }));
};
var $bd2a74e4d7b1ac77$export$2e2bcd8739ae039 = $bd2a74e4d7b1ac77$var$AvatarGroupPluginWrapper;

});
parcelRegister("8B2n0", function(module, exports) {
$parcel$export(module.exports, "avatarGroupMessages", () => $e740f50a93e11428$export$8a0e7c3f8f5b8868);

var $8p5Cv = parcelRequire("8p5Cv");
const $e740f50a93e11428$export$8a0e7c3f8f5b8868 = (0, $8p5Cv.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    },
    anonymousCollaborator: {
        id: 'fabric.editor.anonymous-collaborator',
        defaultMessage: 'Anonymous collaborator',
        description: 'The name of an anonymous collaborator, used when the participant name is not specified'
    },
    agentWithUser: {
        id: 'fabric.editor.agent-with-user',
        defaultMessage: '{agentName} with {userName}',
        description: 'Tooltip text for an agent avatar in the editor presence avatar group. The agentName placeholder is the AI agent display name. The userName placeholder is the display name of the user the agent is acting on behalf of.'
    }
});

});

parcelRegister("hYNp5", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a243ffd45d77918$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $3uluy = parcelRequire("3uluy");

var $9oAqi = parcelRequire("9oAqi");

var $46p9z = parcelRequire("46p9z");

var $iS0fk = parcelRequire("iS0fk");
const $0a243ffd45d77918$var$AvatarsWithPluginState = (props)=>{
    const title = props.intl.formatMessage((0, $3uluy.default).inviteToEditButtonTitle);
    const { isInviteToEditButtonSelected: selected, inviteToEditHandler: onClick, inviteToEditComponent: Component, editorView: editorView, featureFlags: featureFlags, editorAnalyticsAPI: editorAnalyticsAPI, editorAPI: editorAPI } = props;
    const { sessionId: sessionId, activeParticipants: activeParticipants, initialised: initialised } = (0, $9oAqi.useSharedPluginStateWithSelector)(editorAPI, [
        'collabEdit'
    ], (states)=>{
        var _states$collabEditSta, _states$collabEditSta2, _states$collabEditSta3;
        return {
            sessionId: (_states$collabEditSta = states.collabEditState) === null || _states$collabEditSta === void 0 ? void 0 : _states$collabEditSta.sessionId,
            activeParticipants: (_states$collabEditSta2 = states.collabEditState) === null || _states$collabEditSta2 === void 0 ? void 0 : _states$collabEditSta2.activeParticipants,
            initialised: (_states$collabEditSta3 = states.collabEditState) === null || _states$collabEditSta3 === void 0 ? void 0 : _states$collabEditSta3.initialised
        };
    });
    if (!initialised) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $46p9z.Avatars), {
        sessionId: sessionId,
        participants: activeParticipants,
        editorView: editorView,
        featureFlags: featureFlags,
        editorAnalyticsAPI: editorAnalyticsAPI,
        editorAPI: editorAPI,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iS0fk.InviteToEditButton), {
            title: title,
            selected: selected,
            onClick: onClick,
            Component: Component
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $0a243ffd45d77918$var$_default_1 = (0, $fcCIH.default)($0a243ffd45d77918$var$AvatarsWithPluginState);
var $0a243ffd45d77918$export$2e2bcd8739ae039 = $0a243ffd45d77918$var$_default_1;

});
parcelRegister("46p9z", function(module, exports) {
$parcel$export(module.exports, "Avatars", () => $6a13e34d38f17466$export$8232a93d94178362);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $gpjDl = parcelRequire("gpjDl");

var $aEADZ = parcelRequire("aEADZ");

var $3LeME = parcelRequire("3LeME");

var $801jp = parcelRequire("801jp");

var $dRkX9 = parcelRequire("dRkX9");

var $kYAQw = parcelRequire("kYAQw");

var $635PK = parcelRequire("635PK");

var $fKqY0 = parcelRequire("fKqY0");
const $6a13e34d38f17466$var$scrollToCollabCursor = (editorAPI, participants, sessionId, index, editorAnalyticsAPI)=>{
    const selectedUser = participants[index];
    const cursorPos = selectedUser.cursorPos;
    if (selectedUser && cursorPos !== undefined && selectedUser.sessionId !== sessionId) {
        var _editorAPI$core, _editorAPI$core2;
        const analyticsPayload = {
            action: (0, $3LeME.ACTION).MATCHED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).SELECTION,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        };
        editorAPI === null || editorAPI === void 0 || (_editorAPI$core = editorAPI.core) === null || _editorAPI$core === void 0 || (_editorAPI$core = _editorAPI$core.actions) === null || _editorAPI$core === void 0 || _editorAPI$core.execute(({ tr: tr })=>{
            tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(cursorPos)));
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(tr);
            tr.scrollIntoView();
            return tr;
        });
        editorAPI === null || editorAPI === void 0 || (_editorAPI$core2 = editorAPI.core) === null || _editorAPI$core2 === void 0 || (_editorAPI$core2 = _editorAPI$core2.actions) === null || _editorAPI$core2 === void 0 || _editorAPI$core2.focus();
    }
};
const $6a13e34d38f17466$var$getMissingActingUserIdsKey = (participants, userNamesById)=>{
    const participantUserIds = new Set();
    const missingActingUserIds = new Set();
    for (const participant of participants)if (participant.userId) participantUserIds.add(participant.userId);
    for (const participant of participants){
        const actingUserId = participant.actingUserId;
        if (actingUserId && !participantUserIds.has(actingUserId) && !userNamesById[actingUserId]) missingActingUserIds.add(actingUserId);
    }
    let missingActingUserIdsKey = '';
    for (const actingUserId of missingActingUserIds)missingActingUserIdsKey = missingActingUserIdsKey ? `${missingActingUserIdsKey}|${actingUserId}` : actingUserId;
    return missingActingUserIdsKey;
};
const $6a13e34d38f17466$export$8232a93d94178362 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    var _props$participants;
    const { sessionId: sessionId, featureFlags: featureFlags, editorAPI: editorAPI } = props;
    const intl = (0, $gpjDl.default)();
    const [userNamesById, setUserNamesById] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState({});
    // .slice() turns ReadonlyArray<CollabParticipant> into a mutable CollabParticipant[]
    const participants = (_props$participants = props.participants) === null || _props$participants === void 0 || (_props$participants = _props$participants.toArray()) === null || _props$participants === void 0 ? void 0 : _props$participants.slice();
    const missingActingUserIdsKey = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (!participants || !(0, $dRkX9.fg)('platform_move_presence_agents')) return '';
        return $6a13e34d38f17466$var$getMissingActingUserIdsKey(participants, userNamesById);
    }, [
        participants,
        userNamesById
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (!missingActingUserIdsKey) return;
        let cancelled = false;
        (0, $kYAQw.fetchUserNames)(missingActingUserIdsKey.split('|')).then((namesById)=>{
            if (cancelled || !Object.keys(namesById).length) return;
            setUserNamesById((currentNamesById)=>({
                    ...currentNamesById,
                    ...namesById
                }));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        missingActingUserIdsKey
    ]);
    if (!participants) return null;
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const avatars = participants.sort((p)=>p.sessionId === sessionId ? -1 : 1).map((participant)=>(0, $fKqY0.default)(participant, editorAPI, intl.formatMessage, participants, userNamesById));
    if (!avatars.length) return null;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $635PK.avatarContainerStyles)
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $aEADZ.default), {
        appearance: "stack",
        size: "medium",
        data: avatars,
        maxCount: 3,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onAvatarClick: (_event, _analytics, index)=>{
            const allowCollabAvatarScroll = featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.collabAvatarScroll;
            // user does not need to scroll to their own position (index 0)
            if (allowCollabAvatarScroll && index > 0) $6a13e34d38f17466$var$scrollToCollabCursor(editorAPI, participants, props.sessionId, index, props.editorAnalyticsAPI);
        }
    }), props.children));
});

});
parcelRegister("kYAQw", function(module, exports) {
$parcel$export(module.exports, "fetchUserNames", () => $7fd51f9e6a096f6e$export$a1160cf07102030);

var $kFIjS = parcelRequire("kFIjS");
const $7fd51f9e6a096f6e$var$AGG_PATH = '/gateway/api/graphql';
const $7fd51f9e6a096f6e$var$USERS_OPERATION_NAME = 'AvatarGroupUsersQuery';
const $7fd51f9e6a096f6e$var$USERS_QUERY = `
	query ${$7fd51f9e6a096f6e$var$USERS_OPERATION_NAME}($accountIds: [ID!]!) {
		users(accountIds: $accountIds) {
			accountId
			name
		}
	}
`;
const $7fd51f9e6a096f6e$export$a1160cf07102030 = async (accountIds)=>{
    if (!accountIds.length) return {};
    try {
        var _json$data;
        const response = await fetch($7fd51f9e6a096f6e$var$AGG_PATH, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                operationName: $7fd51f9e6a096f6e$var$USERS_OPERATION_NAME,
                query: $7fd51f9e6a096f6e$var$USERS_QUERY,
                variables: {
                    accountIds: accountIds
                }
            })
        });
        if (!response.ok) throw new Error(`AGG user request failed: ${response.status}`);
        const json = await response.json();
        return (((_json$data = json.data) === null || _json$data === void 0 ? void 0 : _json$data.users) ?? []).reduce((namesById, user)=>{
            if (user.accountId && user.name) namesById[user.accountId] = user.name;
            return namesById;
        }, {});
    } catch (error) {
        (0, $kFIjS.logException)(error, {
            location: 'editor-plugin-avatar-group/fetchUserNames'
        });
        return {};
    }
};

});

parcelRegister("635PK", function(module, exports) {
$parcel$export(module.exports, "inviteTeamWrapperStyles", () => $d49cd40ed6b89008$export$2755d6ea511694ef);
$parcel$export(module.exports, "avatarContainerStyles", () => $d49cd40ed6b89008$export$84e713f68a1110f7);
$parcel$export(module.exports, "badge", () => $d49cd40ed6b89008$export$4aebd143f31d0c0d);
/* eslint-disable @repo/internal/styles/no-exported-styles, @atlaskit/design-system/no-nested-styles */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");
function $d49cd40ed6b89008$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d49cd40ed6b89008$export$2755d6ea511694ef = {
    name: "1a9lj0e",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-full, 9999px);min-width:var(--ds-space-400, 32px);margin-left:var(--ds-space-negative-050, -4px)"
};
const $d49cd40ed6b89008$export$84e713f68a1110f7 = {
    name: "1g5siac",
    styles: "margin-right:var(--ds-space-100, 8px);display:flex;align-items:center;&& > ul{list-style-type:none;}div:last-child button.invite-to-edit{border-radius:var(--ds-radius-full, 9999px);height:32px;width:32px;padding:var(--ds-space-025, 2px);}"
};
const $d49cd40ed6b89008$export$4aebd143f31d0c0d = (backgroundColor, textColor)=>/*#__PURE__*/ (0, $jctmk.css)({
        display: 'block',
        position: 'absolute',
        right: "var(--ds-space-025, 2px)",
        bottom: "var(--ds-space-025, 2px)",
        width: "var(--ds-space-150, 12px)",
        height: "var(--ds-space-150, 12px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $014x6.akEditorSmallZIndex),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: backgroundColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: textColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $014x6.relativeFontSizeToBase16)(9),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        paddingTop: "var(--ds-space-075, 6px)",
        textAlign: 'center',
        boxShadow: `0 0 1px ${"var(--ds-border-inverse, #FFFFFF)"}`,
        boxSizing: 'border-box'
    });

});

parcelRegister("fKqY0", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0af268423ba9246$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");

var $8B2n0 = parcelRequire("8B2n0");

var $dRkX9 = parcelRequire("dRkX9");

var $9nF5f = parcelRequire("9nF5f");
const $d0af268423ba9246$var$getUserNameForAttribution = (participant, participants, userNamesById = {})=>{
    var _participants$find;
    const actingUserId = participant.actingUserId;
    if (!(0, $dRkX9.fg)('platform_move_presence_agents') || !actingUserId) return undefined;
    const currentParticipantName = (_participants$find = participants.find((user)=>user.sessionId !== participant.sessionId && user.userId === actingUserId && user.isHydrated)) === null || _participants$find === void 0 ? void 0 : _participants$find.name;
    return currentParticipantName ?? userNamesById[actingUserId];
};
const $d0af268423ba9246$var$getAvatarName = (participant, participants, formatMessage, userNamesById)=>{
    const participantName = participant.name || formatMessage((0, $8B2n0.avatarGroupMessages).anonymousCollaborator);
    const userNameForAttribution = $d0af268423ba9246$var$getUserNameForAttribution(participant, participants, userNamesById);
    if (!userNameForAttribution) return participantName;
    return formatMessage((0, $8B2n0.avatarGroupMessages).agentWithUser, {
        agentName: participantName,
        userName: userNameForAttribution
    });
};
const $d0af268423ba9246$var$toAvatar = (participant, api, formatMessage, participants, userNamesById = {})=>({
        name: $d0af268423ba9246$var$getAvatarName(participant, participants, formatMessage, userNamesById),
        src: participant.avatar,
        size: 'medium',
        presence: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9nF5f.ColoredAvatarItem), {
            api: api,
            name: participant.name,
            sessionId: participant.sessionId,
            presenceId: participant.presenceId
        })
    });
const $d0af268423ba9246$var$_default_1 = (0, $jiju3.default)($d0af268423ba9246$var$toAvatar, function participantEquals([a, , , aParticipants, aUserNamesById = {}], [b, , , bParticipants, bUserNamesById = {}]) {
    const actingUserId = a.actingUserId;
    return a.name === b.name && a.avatar === b.avatar && a.sessionId === b.sessionId && actingUserId === b.actingUserId && (!actingUserId || $d0af268423ba9246$var$getUserNameForAttribution(a, aParticipants, aUserNamesById) === $d0af268423ba9246$var$getUserNameForAttribution(b, bParticipants, bUserNamesById));
});
var $d0af268423ba9246$export$2e2bcd8739ae039 = $d0af268423ba9246$var$_default_1;

});
parcelRegister("9nF5f", function(module, exports) {
$parcel$export(module.exports, "ColoredAvatarItem", () => $01fe7d0fbf28c17c$export$1a8ce77350a239fa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $jctmk = parcelRequire("jctmk");

var $dRkX9 = parcelRequire("dRkX9");

var $635PK = parcelRequire("635PK");
const $01fe7d0fbf28c17c$export$1a8ce77350a239fa = (props)=>{
    var _props$api;
    // The fallback mirrors a participant palette slot; red is reserved for deleted content.
    const fallbackColor = (0, $dRkX9.fg)('confluence_ncs_step_diffing_version_history') ? "var(--ds-background-accent-orange-subtle, #FCA700)" : "var(--ds-background-accent-red-subtle, #F87168)";
    const participantColor = ((_props$api = props.api) === null || _props$api === void 0 || (_props$api = _props$api.collabEdit) === null || _props$api === void 0 || (_props$api = _props$api.actions) === null || _props$api === void 0 ? void 0 : _props$api.getAvatarColor(props.presenceId ?? props.sessionId)) ?? {
        backgroundColor: fallbackColor,
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)"
    };
    const avatar = props.name.substr(0, 1).toUpperCase();
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $635PK.badge)(participantColor === null || participantColor === void 0 ? void 0 : participantColor.backgroundColor, participantColor === null || participantColor === void 0 ? void 0 : participantColor.textColor),
        "data-testid": "editor-collab-badge"
    }, avatar);
};

});



parcelRegister("iS0fk", function(module, exports) {
$parcel$export(module.exports, "InviteToEditButton", () => $6ebb6ef09e6f6e45$export$c166df103ee37df9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $7h5CJ = parcelRequire("7h5CJ");

var $jGvkt = parcelRequire("jGvkt");

var $bcN2K = parcelRequire("bcN2K");

var $635PK = parcelRequire("635PK");
const $6ebb6ef09e6f6e45$var$ID = (props)=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, props.children);
const $6ebb6ef09e6f6e45$export$c166df103ee37df9 = (props)=>{
    const { Component: Component, onClick: onClick, selected: selected, title: title } = props;
    const iconBefore = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGvkt))), {
            label: title
        }), [
        title
    ]);
    if (!Component && !onClick) return null;
    const Wrapper = Component ? Component : $6ebb6ef09e6f6e45$var$ID;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $635PK.inviteTeamWrapperStyles)
    }, /*#__PURE__*/ (0, $jctmk.jsx)(Wrapper, null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $7h5CJ.default), {
        "aria-pressed": (0, $bcN2K.isExperimentEnabled)('platform_editor_invite_to_edit_button_aria_pressed') ? selected : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "invite-to-edit",
        onClick: onClick,
        selected: selected,
        title: title,
        titlePosition: "bottom",
        iconBefore: iconBefore
    }))));
};

});




parcelRegister("48fRW", function(module, exports) {
$parcel$export(module.exports, "blockControlsPlugin", () => $742ebb00855dd510$export$7a291905586a23d3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5Amf8 = parcelRequire("5Amf8");

var $eCKpe = parcelRequire("eCKpe");

var $fmnS6 = parcelRequire("fmnS6");

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $1WI6z = parcelRequire("1WI6z");

var $jROJy = parcelRequire("jROJy");

var $28S2Q = parcelRequire("28S2Q");

var $l4e2l = parcelRequire("l4e2l");

var $1Qyd4 = parcelRequire("1Qyd4");

var $kVX7L = parcelRequire("kVX7L");

var $61p1X = parcelRequire("61p1X");

var $9aPvW = parcelRequire("9aPvW");

var $2MmgC = parcelRequire("2MmgC");

var $gyNLa = parcelRequire("gyNLa");

var $mJpT5 = parcelRequire("mJpT5");

var $b8Grq = parcelRequire("b8Grq");

var $jKAmG = parcelRequire("jKAmG");

var $8BsvG = parcelRequire("8BsvG");

var $lE9Q7 = parcelRequire("lE9Q7");

var $7f0FC = parcelRequire("7f0FC");

var $bpuaH = parcelRequire("bpuaH");

var $khyye = parcelRequire("khyye");

var $9lAox = parcelRequire("9lAox");

var $24uL0 = parcelRequire("24uL0");

var $lmsov = parcelRequire("lmsov");

var $8Z9L9 = parcelRequire("8Z9L9");
const $742ebb00855dd510$export$7a291905586a23d3 = ({ api: api, config: config })=>{
    const nodeDecorationRegistry = [];
    const rightSideControlsEnabled = (config === null || config === void 0 ? void 0 : config.rightSideControlsEnabled) ?? false;
    const quickInsertButtonEnabled = (config === null || config === void 0 ? void 0 : config.quickInsertButtonEnabled) ?? true;
    const registryBlockControlsEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration');
    if (registryBlockControlsEnabled) {
        var _api$uiControlRegistr, _api$uiControlRegistr2;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register([
            (0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE),
            {
                ...(0, $5Amf8.BLOCK_CONTROLS_LEFT_SECTION),
                parents: [
                    {
                        ...(0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE),
                        rank: 100
                    }
                ]
            },
            {
                ...(0, $5Amf8.BLOCK_CONTROLS_LEFT_GROUP),
                parents: [
                    {
                        ...(0, $5Amf8.BLOCK_CONTROLS_LEFT_SECTION),
                        rank: 100
                    }
                ]
            },
            ...(0, $24uL0.getBlockControlsSurfaceDragHandleComponents)({
                api: api
            })
        ]);
        // The right surface host stays generic: it only registers the toolbar/section/group
        // hierarchy. Individual features contribute their own buttons into
        // BLOCK_CONTROLS_RIGHT_GROUP from their own plugins, same as the left surface.
        api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 || _api$uiControlRegistr2.actions.register([
            (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE),
            {
                ...(0, $5Amf8.BLOCK_CONTROLS_RIGHT_SECTION),
                parents: [
                    {
                        ...(0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE),
                        rank: 100
                    }
                ]
            },
            {
                ...(0, $5Amf8.BLOCK_CONTROLS_RIGHT_GROUP),
                parents: [
                    {
                        ...(0, $5Amf8.BLOCK_CONTROLS_RIGHT_SECTION),
                        rank: 100
                    }
                ]
            }
        ]);
    }
    return {
        name: 'blockControls',
        actions: {
            notifyBlockHandleClick: (context)=>{
                try {
                    var _config$onBlockHandle;
                    config === null || config === void 0 || (_config$onBlockHandle = config.onBlockHandleClick) === null || _config$onBlockHandle === void 0 || _config$onBlockHandle.call(config, context);
                } catch  {
                // A host callback must not prevent the block menu from opening.
                }
            },
            getTextInfo: (editorView)=>{
                var _api$blockControls, _blockControlsState$m;
                const blockControlsState = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState();
                const preservedSelection = blockControlsState === null || blockControlsState === void 0 ? void 0 : blockControlsState.preservedSelection;
                if (preservedSelection && preservedSelection.from !== preservedSelection.to) {
                    // CellSelection covers a table: collect each selected cell's text joined with spaces
                    // so that adjacent cells are not fused (e.g. 'hello world' + 'foo' must not
                    // become 'hello worldfoo'). Intl.Segmenter word-counting requires correct
                    // word boundaries, which raw textContent fusion breaks.
                    if (preservedSelection instanceof (0, $ev7OZ.CellSelection)) {
                        // Use node(1) to reliably target the table node regardless of $anchorCell depth.
                        // node(-1) would return tableRow if $anchorCell is at tableCell depth.
                        const tableNode = preservedSelection.$anchorCell.node(1);
                        const cellTexts = [];
                        if (tableNode) // forEachCell iterates only the selected cells, not all cells in the table.
                        preservedSelection.forEachCell((cell)=>{
                            cellTexts.push(cell.textContent);
                        });
                        const textContent = cellTexts.filter(Boolean).join(' ');
                        return {
                            textLength: textContent.length,
                            textContent: textContent
                        };
                    }
                    const { from: from, to: to } = preservedSelection;
                    const textContent = editorView.state.doc.textBetween(from, to, '\n');
                    return {
                        textLength: textContent.length,
                        textContent: textContent
                    };
                }
                const pos = blockControlsState === null || blockControlsState === void 0 || (_blockControlsState$m = blockControlsState.menuTriggerByNode) === null || _blockControlsState$m === void 0 ? void 0 : _blockControlsState$m.pos;
                if (pos === null || pos === undefined) return null;
                const node = editorView.state.doc.nodeAt(pos);
                if (!node) return null;
                return {
                    textLength: node.textContent.length,
                    textContent: node.textContent
                };
            },
            registerNodeDecoration: (factory)=>{
                nodeDecorationRegistry.push(factory);
            },
            unregisterNodeDecoration: (type)=>{
                const idx = nodeDecorationRegistry.findIndex((f)=>f.type === type);
                if (idx !== -1) nodeDecorationRegistry.splice(idx, 1);
            }
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'blockControlsPmPlugin',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $gyNLa.createPlugin)(api, getIntl, nodeViewPortalProviderAPI, registryBlockControlsEnabled ? [] : nodeDecorationRegistry, rightSideControlsEnabled, quickInsertButtonEnabled && !registryBlockControlsEnabled)
                }
            ];
            if (registryBlockControlsEnabled) pmPlugins.push({
                name: 'blockControlsSparseSurfaces',
                plugin: ()=>(0, $8BsvG.createSparseSurfacesPlugin)(api)
            });
            if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) pmPlugins.push({
                name: 'blockControlsInteractionTrackingPlugin',
                plugin: ()=>(0, $2MmgC.createInteractionTrackingPlugin)(rightSideControlsEnabled, api)
            });
            pmPlugins.push({
                name: 'blockControlsSelectionPreservationPlugin',
                plugin: (0, $jKAmG.createSelectionPreservationPlugin)(api)
            });
            // platform_editor_controls note: quick insert rendering fixes
            //
            // Not registered under the registry migration: the decoration puts an inline
            // `margin-top: 0` on the first document node, which fights features that render their own
            // content above it — a leading show-diff widget is left flush against the node below.
            if ((0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar)) && !registryBlockControlsEnabled) pmPlugins.push({
                name: 'firstNodeDec',
                plugin: (0, $9aPvW.firstNodeDecPlugin)
            });
            return pmPlugins;
        },
        commands: {
            expandAndUpdateSelection: ({ startPos: startPos, selection: selection, isShiftPressed: isShiftPressed, nodeType: nodeType })=>({ tr: tr })=>{
                    (0, $lE9Q7.expandAndUpdateSelection)({
                        tr: tr,
                        selection: selection,
                        startPos: startPos,
                        isShiftPressed: isShiftPressed,
                        nodeType: nodeType,
                        api: api
                    });
                    return tr;
                },
            moveNode: (0, $28S2Q.moveNode)(api),
            moveToLayout: (0, $1Qyd4.moveToLayout)(api),
            showDragHandleAt: (pos, anchorName, nodeType, handleOptions, rootPos, rootAnchorName, rootNodeType)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $gyNLa.key));
                    tr.setMeta((0, $gyNLa.key), {
                        ...currMeta,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType,
                            handleOptions: handleOptions,
                            rootPos: rootPos,
                            rootAnchorName: rootAnchorName,
                            rootNodeType: rootNodeType
                        }
                    });
                    return tr;
                },
            showControlAtPosition: (pos, control, options)=>({ tr: tr })=>{
                    const node = tr.doc.nodeAt(pos);
                    if (!node) return tr;
                    const anchorName = api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(node, pos);
                    if (!anchorName) return tr;
                    const currMeta = tr.getMeta((0, $gyNLa.key));
                    tr.setMeta((0, $gyNLa.key), {
                        ...currMeta,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            controlKey: control.key,
                            nodeType: (0, $61p1X.getNodeTypeWithLevel)(node),
                            handleOptions: options
                        }
                    });
                    return tr;
                },
            toggleBlockMenu: (options)=>({ tr: tr })=>{
                    var _api$userIntent, _api$blockControls2, _options$triggerByNod, _options$anchorName, _api$blockControls3;
                    const currMeta = tr.getMeta((0, $gyNLa.key));
                    const currentUserIntent = api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent;
                    const isMenuCurrentlyOpen = api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.sharedState.currentState()) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.isMenuOpen;
                    if (options !== null && options !== void 0 && options.closeMenu) {
                        tr.setMeta((0, $gyNLa.key), {
                            ...currMeta,
                            closeMenu: true
                        });
                        if (currentUserIntent === 'blockMenuOpen') {
                            var _api$userIntent2;
                            api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || _api$userIntent2.commands.setCurrentUserIntent('default')({
                                tr: tr
                            });
                        }
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                            var _api$metrics;
                            api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.startActiveSessionTimer()({
                                tr: tr
                            });
                        }
                        return tr;
                    }
                    // Do not open the block menu for layout columns. Anchor resolution can lag behind
                    // a migrated surface click, so prefer the explicit node metadata when available.
                    if ((options === null || options === void 0 || (_options$triggerByNod = options.triggerByNode) === null || _options$triggerByNod === void 0 ? void 0 : _options$triggerByNod.nodeType) === 'layoutColumn' || options !== null && options !== void 0 && (_options$anchorName = options.anchorName) !== null && _options$anchorName !== void 0 && _options$anchorName.includes('layoutColumn')) {
                        if (currentUserIntent === 'blockMenuOpen') {
                            var _api$userIntent3;
                            api === null || api === void 0 || (_api$userIntent3 = api.userIntent) === null || _api$userIntent3 === void 0 || _api$userIntent3.commands.setCurrentUserIntent('default')({
                                tr: tr
                            });
                        }
                        tr.setMeta((0, $gyNLa.key), {
                            ...currMeta,
                            closeMenu: true
                        });
                        // When closing the menu, restart the active session timer
                        if (isMenuCurrentlyOpen && (0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                            var _api$metrics2;
                            api === null || api === void 0 || (_api$metrics2 = api.metrics) === null || _api$metrics2 === void 0 || _api$metrics2.commands.startActiveSessionTimer()({
                                tr: tr
                            });
                        }
                        return tr;
                    }
                    let toggleMenuMeta = {
                        anchorName: options === null || options === void 0 ? void 0 : options.anchorName,
                        triggerByNode: options === null || options === void 0 ? void 0 : options.triggerByNode
                    };
                    const menuTriggerBy = api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || (_api$blockControls3 = _api$blockControls3.sharedState.currentState()) === null || _api$blockControls3 === void 0 ? void 0 : _api$blockControls3.menuTriggerBy;
                    if (options !== null && options !== void 0 && options.anchorName) {
                        const { moveUp: moveUp, moveDown: moveDown } = (0, $kVX7L.canMoveNodeUpOrDown)(tr);
                        toggleMenuMeta = {
                            ...toggleMenuMeta,
                            moveUp: moveUp,
                            moveDown: moveDown,
                            openedViaKeyboard: options === null || options === void 0 ? void 0 : options.openedViaKeyboard
                        };
                    }
                    tr.setMeta((0, $gyNLa.key), {
                        ...currMeta,
                        toggleMenu: toggleMenuMeta
                    });
                    if ((menuTriggerBy === undefined || !!menuTriggerBy && menuTriggerBy === (options === null || options === void 0 ? void 0 : options.anchorName)) && currentUserIntent === 'blockMenuOpen') {
                        const state = api === null || api === void 0 ? void 0 : api.blockControls.sharedState.currentState();
                        if (state !== null && state !== void 0 && state.isSelectedViaDragHandle) {
                            var _api$userIntent4;
                            api === null || api === void 0 || (_api$userIntent4 = api.userIntent) === null || _api$userIntent4 === void 0 || _api$userIntent4.commands.setCurrentUserIntent('dragHandleSelected')({
                                tr: tr
                            });
                        } else {
                            var _api$userIntent5;
                            // Toggled from drag handle
                            api === null || api === void 0 || (_api$userIntent5 = api.userIntent) === null || _api$userIntent5 === void 0 || _api$userIntent5.commands.setCurrentUserIntent('default')({
                                tr: tr
                            });
                        }
                        // When closing the menu, restart the active session timer
                        if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                            var _api$metrics3;
                            api === null || api === void 0 || (_api$metrics3 = api.metrics) === null || _api$metrics3 === void 0 || _api$metrics3.commands.startActiveSessionTimer()({
                                tr: tr
                            });
                        }
                    } else if (!isMenuCurrentlyOpen) // When opening the menu, pause the active session timer
                    {
                        if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                            var _api$metrics4;
                            api === null || api === void 0 || (_api$metrics4 = api.metrics) === null || _api$metrics4 === void 0 || _api$metrics4.commands.handleIntentToStartEdit({
                                shouldStartTimer: false,
                                shouldPersistActiveSession: true
                            })({
                                tr: tr
                            });
                        }
                    }
                    return tr;
                },
            setNodeDragged: (getPos, anchorName, nodeType)=>({ tr: tr })=>{
                    var _api$userIntent6;
                    const pos = getPos();
                    if (pos === undefined) return tr;
                    const currMeta = tr.getMeta((0, $gyNLa.key));
                    tr.setMeta((0, $gyNLa.key), {
                        ...currMeta,
                        isDragging: true,
                        activeNode: {
                            pos: pos,
                            anchorName: anchorName,
                            nodeType: nodeType
                        }
                    });
                    if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                        var _api$metrics5;
                        api === null || api === void 0 || (_api$metrics5 = api.metrics) === null || _api$metrics5 === void 0 || _api$metrics5.commands.handleIntentToStartEdit({
                            shouldStartTimer: false,
                            shouldPersistActiveSession: true
                        })({
                            tr: tr
                        });
                    }
                    api === null || api === void 0 || (_api$userIntent6 = api.userIntent) === null || _api$userIntent6 === void 0 || _api$userIntent6.commands.setCurrentUserIntent('dragging')({
                        tr: tr
                    });
                    return tr;
                },
            setMultiSelectPositions: (anchor, head)=>({ tr: tr })=>{
                    var _api$selection, _$to$nodeBefore, _$from$nodeAfter;
                    const { anchor: userAnchor, head: userHead } = tr.selection;
                    let $expandedAnchor, $expandedHead;
                    if (anchor !== undefined && head !== undefined) {
                        $expandedAnchor = tr.doc.resolve(anchor);
                        $expandedHead = tr.doc.resolve(head);
                    } else {
                        const expandedSelection = (0, $eCKpe.expandSelectionBounds)(tr.selection.$anchor, tr.selection.$head);
                        $expandedAnchor = expandedSelection.$anchor;
                        $expandedHead = expandedSelection.$head;
                    }
                    api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || _api$selection.commands.setManualSelection($expandedAnchor.pos, $expandedHead.pos)({
                        tr: tr
                    });
                    const $from = $expandedAnchor.min($expandedHead);
                    const $to = $expandedAnchor.max($expandedHead);
                    let expandedNormalisedSel;
                    if ($from.nodeAfter && $from.nodeAfter === $to.nodeBefore) {
                        // Single node
                        (0, $7f0FC.selectNode)(tr, $from.pos, $from.nodeAfter.type.name, api);
                        expandedNormalisedSel = tr.selection;
                    } else if ($from.nodeAfter === $to.nodeBefore) {
                        // Single node
                        (0, $7f0FC.selectNode)(tr, $from.pos, $expandedAnchor.node().type.name, api);
                        expandedNormalisedSel = tr.selection;
                    } else if (((_$to$nodeBefore = $to.nodeBefore) === null || _$to$nodeBefore === void 0 ? void 0 : _$to$nodeBefore.type.name) === 'mediaSingle' || ((_$from$nodeAfter = $from.nodeAfter) === null || _$from$nodeAfter === void 0 ? void 0 : _$from$nodeAfter.type.name) === 'mediaSingle') {
                        // Media
                        expandedNormalisedSel = new (0, $801jp.TextSelection)($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    } else {
                        // this is to normalise the selection's boundaries to inline positions, preventing it from collapsing
                        expandedNormalisedSel = (0, $801jp.TextSelection).between($expandedAnchor, $expandedHead);
                        tr.setSelection(expandedNormalisedSel);
                    }
                    const multiSelectDnD = {
                        anchor: $expandedAnchor.pos,
                        head: $expandedHead.pos,
                        textAnchor: expandedNormalisedSel.anchor,
                        textHead: expandedNormalisedSel.head,
                        userAnchor: userAnchor,
                        userHead: userHead
                    };
                    const currMeta = tr.getMeta((0, $gyNLa.key));
                    tr.setMeta((0, $gyNLa.key), {
                        ...currMeta,
                        multiSelectDnD: multiSelectDnD
                    });
                    return tr;
                },
            setSelectedViaDragHandle: (isSelectedViaDragHandle)=>({ tr: tr })=>{
                    const currMeta = tr.getMeta((0, $gyNLa.key));
                    return tr.setMeta((0, $gyNLa.key), {
                        ...currMeta,
                        isSelectedViaDragHandle: isSelectedViaDragHandle
                    });
                },
            mapPreservedSelection: (mapping)=>(0, $jROJy.mapPreservedSelection)(mapping),
            moveNodeWithBlockMenu: (direction)=>(0, $l4e2l.moveNodeWithBlockMenu)(api, direction),
            handleKeyDownWithPreservedSelection: (0, $1WI6z.handleKeyDownWithPreservedSelection)(api),
            startPreservingSelection: ()=>(0, $mJpT5.startPreservingSelection),
            stopPreservingSelection: ()=>(0, $mJpT5.stopPreservingSelection)
        },
        getSharedState (editorState) {
            var _key$getState, _key$getState2, _key$getState3, _key$getState4, _key$getState5, _key$getState6, _key$getState7, _key$getState8, _key$getState9, _key$getState0, _interactionTrackingP, _key$getState1, _selectionPreservatio;
            if (!editorState) return undefined;
            const sharedState = {
                isMenuOpen: ((_key$getState = (0, $gyNLa.key).getState(editorState)) === null || _key$getState === void 0 ? void 0 : _key$getState.isMenuOpen) ?? false,
                menuTriggerBy: ((_key$getState2 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState2 === void 0 ? void 0 : _key$getState2.menuTriggerBy) ?? undefined,
                menuTriggerByNode: ((_key$getState3 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState3 === void 0 ? void 0 : _key$getState3.menuTriggerByNode) ?? undefined,
                blockMenuOptions: ((_key$getState4 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState4 === void 0 ? void 0 : _key$getState4.blockMenuOptions) ?? undefined,
                activeNode: ((_key$getState5 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState5 === void 0 ? void 0 : _key$getState5.activeNode) ?? undefined,
                activeDropTargetNode: ((_key$getState6 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState6 === void 0 ? void 0 : _key$getState6.activeDropTargetNode) ?? undefined,
                isDragging: ((_key$getState7 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState7 === void 0 ? void 0 : _key$getState7.isDragging) ?? false,
                isPMDragging: ((_key$getState8 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState8 === void 0 ? void 0 : _key$getState8.isPMDragging) ?? false,
                multiSelectDnD: ((_key$getState9 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState9 === void 0 ? void 0 : _key$getState9.multiSelectDnD) ?? undefined,
                lastDragCancelled: ((_key$getState0 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState0 === void 0 ? void 0 : _key$getState0.lastDragCancelled) ?? false,
                isEditing: (_interactionTrackingP = (0, $2MmgC.interactionTrackingPluginKey).getState(editorState)) === null || _interactionTrackingP === void 0 ? void 0 : _interactionTrackingP.isEditing,
                isSelectedViaDragHandle: ((_key$getState1 = (0, $gyNLa.key).getState(editorState)) === null || _key$getState1 === void 0 ? void 0 : _key$getState1.isSelectedViaDragHandle) ?? false
            };
            if (registryBlockControlsEnabled) {
                const surfaces = (0, $8BsvG.sparseSurfacesKey).getState(editorState);
                sharedState.surfaceNodePositions = surfaces === null || surfaces === void 0 ? void 0 : surfaces.candidates.positions;
                sharedState.surfaceAnchors = surfaces === null || surfaces === void 0 ? void 0 : surfaces.anchors;
                sharedState.surfaceActiveNodes = surfaces === null || surfaces === void 0 ? void 0 : surfaces.activeNodesByPosition;
            }
            if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) {
                var _interactionTrackingP2, _interactionTrackingP3;
                sharedState.isMouseOut = ((_interactionTrackingP2 = (0, $2MmgC.interactionTrackingPluginKey).getState(editorState)) === null || _interactionTrackingP2 === void 0 ? void 0 : _interactionTrackingP2.isMouseOut) ?? false;
                sharedState.rightSideControlsEnabled = rightSideControlsEnabled;
                sharedState.hoverSide = rightSideControlsEnabled ? (_interactionTrackingP3 = (0, $2MmgC.interactionTrackingPluginKey).getState(editorState)) === null || _interactionTrackingP3 === void 0 ? void 0 : _interactionTrackingP3.hoverSide : undefined;
            }
            sharedState.preservedSelection = (_selectionPreservatio = (0, $b8Grq.selectionPreservationPluginKey).getState(editorState)) === null || _selectionPreservatio === void 0 ? void 0 : _selectionPreservatio.preservedSelection;
            return sharedState;
        },
        contentComponent ({ editorView: editorView }) {
            return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lmsov.GlobalStylesWrapper), {
                        api: api
                    }),
                    registryBlockControlsEnabled && editorView && api ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8Z9L9.SurfaceEditorViewContext).Provider, {
                        value: editorView,
                        children: (0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_cls_fix') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bpuaH.CommittedBlockControlsSurfaces), {
                            api: api,
                            editorView: editorView
                        }) : /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $khyye.BlockControlsLeftSurfaces), {
                                    api: api,
                                    editorView: editorView
                                }),
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9lAox.BlockControlsRightSurfaces), {
                                    api: api,
                                    editorView: editorView
                                })
                            ]
                        })
                    }) : null
                ]
            });
        }
    };
};

});
parcelRegister("1WI6z", function(module, exports) {
$parcel$export(module.exports, "handleKeyDownWithPreservedSelection", () => $b82bb1830424ae61$export$f38920f5272efc06);

var $d1RPX = parcelRequire("d1RPX");

var $mJpT5 = parcelRequire("mJpT5");
const $b82bb1830424ae61$var$getKeyboardEventInfo = (event)=>{
    const key = event.key.toLowerCase();
    const isMetaCtrl = event.metaKey || event.ctrlKey;
    const isDelete = [
        'backspace',
        'delete'
    ].includes(key);
    const isCut = isMetaCtrl && key === 'x';
    const isPaste = isMetaCtrl && key === 'v';
    const isUndo = isMetaCtrl && key === 'z' && !event.shiftKey;
    const isRedo = isMetaCtrl && (key === 'y' || key === 'z' && event.shiftKey);
    const isDestructive = isDelete || isCut || isPaste || isUndo || isRedo;
    const isModifierOnly = [
        'control',
        'meta',
        'alt',
        'shift'
    ].includes(key) && !isMetaCtrl;
    const isCopy = isMetaCtrl && key === 'c';
    const isInert = isModifierOnly || isCopy;
    return {
        isDelete: isDelete,
        isDestructive: isDestructive,
        isInert: isInert
    };
};
const $b82bb1830424ae61$export$f38920f5272efc06 = (api)=>(event)=>({ tr: tr })=>{
            var _api$userIntent;
            if (!api) return tr;
            const { isDelete: isDelete, isDestructive: isDestructive, isInert: isInert } = $b82bb1830424ae61$var$getKeyboardEventInfo(event);
            // Handle delete/backspace key presses with custom logic to ensure preserved selection is used
            if (isDelete) {
                var _api$blockControls;
                tr = (0, $d1RPX.deleteSelectedRange)(tr, (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection);
            }
            const isBlockMenuOpen = ((_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'blockMenuOpen';
            // When selected content is being removed/modified/undo/redo and the block menu is open
            // close the block menu and refocus the editor
            const shouldCloseBlockMenu = isDestructive && isBlockMenuOpen;
            if (shouldCloseBlockMenu) {
                var _api$blockControls2;
                (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.commands.toggleBlockMenu({
                    closeMenu: true
                })({
                    tr: tr
                });
                api.core.actions.focus({
                    scrollIntoView: false
                });
            }
            // Stop preserving when:
            // 1. Content is being removed (delete/cut/paste) OR
            // 2. Menu is closed AND user pressed a non-inert key (i.e. action which modifies selection or content)
            // 3. undo/redo actions
            const shouldStopPreservingSelection = isDestructive || !isBlockMenuOpen && !isInert;
            if (shouldStopPreservingSelection) (0, $mJpT5.stopPreservingSelection)({
                tr: tr
            });
            return tr;
        };

});
parcelRegister("mJpT5", function(module, exports) {
$parcel$export(module.exports, "startPreservingSelection", () => $8e6521dece66b54c$export$4c9c90f81bda40ce);
$parcel$export(module.exports, "stopPreservingSelection", () => $8e6521dece66b54c$export$7ee148889ab74bda);

var $b8Grq = parcelRequire("b8Grq");
const $8e6521dece66b54c$export$4c9c90f81bda40ce = ({ tr: tr })=>{
    const meta = {
        type: 'startPreserving'
    };
    return tr.setMeta((0, $b8Grq.selectionPreservationPluginKey), meta);
};
const $8e6521dece66b54c$export$7ee148889ab74bda = ({ tr: tr })=>{
    const meta = {
        type: 'stopPreserving'
    };
    return tr.setMeta((0, $b8Grq.selectionPreservationPluginKey), meta);
};

});
parcelRegister("b8Grq", function(module, exports) {
$parcel$export(module.exports, "selectionPreservationPluginKey", () => $edd6142bb66316ff$export$4d3f50627e188696);

var $801jp = parcelRequire("801jp");
const $edd6142bb66316ff$export$4d3f50627e188696 = new (0, $801jp.PluginKey)('selectionPreservationPlugin');

});



parcelRegister("jROJy", function(module, exports) {
$parcel$export(module.exports, "mapPreservedSelection", () => $7caf3b9340fe8497$export$e21678cf246ba963);

var $gyNLa = parcelRequire("gyNLa");
const $7caf3b9340fe8497$export$e21678cf246ba963 = (mapping)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $gyNLa.key));
        return tr.setMeta((0, $gyNLa.key), {
            ...currMeta,
            preservedSelectionMapping: mapping
        });
    };

});
parcelRegister("gyNLa", function(module, exports) {
$parcel$export(module.exports, "key", () => $c9fcd5b34a5ec086$export$df61b30b684217c0);
$parcel$export(module.exports, "getDecorations", () => $c9fcd5b34a5ec086$export$968abecb43309c32);
$parcel$export(module.exports, "createPlugin", () => $c9fcd5b34a5ec086$export$ae829ec7b2625219);
$parcel$export(module.exports, "getBlockControlsMeta", () => $c9fcd5b34a5ec086$export$e75bc9902db1596f);

var $6Zi52 = parcelRequire("6Zi52");

var $PIUl3 = parcelRequire("PIUl3");

var $j5N6B = parcelRequire("j5N6B");

var $3LeME = parcelRequire("3LeME");

var $dqFZv = parcelRequire("dqFZv");

var $2sOQK = parcelRequire("2sOQK");

var $1y7gE = parcelRequire("1y7gE");

var $gCPs3 = parcelRequire("gCPs3");

var $fmnS6 = parcelRequire("fmnS6");

var $aqnCQ = parcelRequire("aqnCQ");

var $ljn7y = parcelRequire("ljn7y");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $2LIY4 = parcelRequire("2LIY4");

var $c8sLM = parcelRequire("c8sLM");

var $gXHCV = parcelRequire("gXHCV");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $GIvev = parcelRequire("GIvev");

var $dj84o = parcelRequire("dj84o");

var $2xAfa = parcelRequire("2xAfa");

var $61p1X = parcelRequire("61p1X");

var $50s88 = parcelRequire("50s88");

var $cDvgs = parcelRequire("cDvgs");

var $8bDpq = parcelRequire("8bDpq");

var $gr4E6 = parcelRequire("gr4E6");

var $l09lv = parcelRequire("l09lv");

var $gqrsA = parcelRequire("gqrsA");

var $gUxz5 = parcelRequire("gUxz5");

var $3xl1j = parcelRequire("3xl1j");

var $3TAWV = parcelRequire("3TAWV");

var $atuba = parcelRequire("atuba");

var $7f0FC = parcelRequire("7f0FC");

var $g4us8 = parcelRequire("g4us8");

var $fAWS2 = parcelRequire("fAWS2");
const $c9fcd5b34a5ec086$export$df61b30b684217c0 = new (0, $801jp.PluginKey)('blockControls');
const $c9fcd5b34a5ec086$var$isHTMLElement = (element)=>{
    return element instanceof HTMLElement;
};
const $c9fcd5b34a5ec086$var$destroyFn = (api)=>{
    var _getDocument;
    const scrollable = ((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.querySelector('.fabric-editor-popup-scroll-parent')) ?? null;
    const cleanupFn = [];
    if (scrollable) cleanupFn.push((0, $2LIY4.autoScrollForElements)({
        element: scrollable
    }));
    cleanupFn.push((0, $c8sLM.monitorForElements)({
        canMonitor: ({ source: source })=>source.data.type === 'element',
        onDragStart: ()=>{
            if ($c9fcd5b34a5ec086$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', 'unset');
        },
        onDrop: ({ location: location, source: source })=>{
            var _api$core;
            if ($c9fcd5b34a5ec086$var$isHTMLElement(scrollable)) scrollable.style.setProperty('scroll-behavior', null);
            if (!api) return;
            (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                var _api$blockControls, _api$selection, _api$userIntent;
                const { multiSelectDnD: multiSelectDnD } = ((_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState()) || {};
                // Restore the users initial Editor selection when the drop completes
                if (multiSelectDnD) {
                    // If the TextSelection between the drag start and end has changed, the document has changed, and we should not reapply the last selection
                    const expandedSelectionUnchanged = multiSelectDnD.textAnchor === tr.selection.anchor && multiSelectDnD.textHead === tr.selection.head;
                    if (expandedSelectionUnchanged) {
                        const $anchor = tr.doc.resolve(multiSelectDnD.userAnchor);
                        const $head = tr.doc.resolve(multiSelectDnD.userHead);
                        if ($head.node() === $anchor.node()) {
                            const $from = $anchor.min($head);
                            (0, $7f0FC.selectNode)(tr, $from.pos, $from.node().type.name, api);
                        } else tr.setSelection((0, $801jp.TextSelection).create(tr.doc, multiSelectDnD.userAnchor, multiSelectDnD.userHead));
                    }
                }
                (_api$selection = api.selection) === null || _api$selection === void 0 || _api$selection.commands.clearManualSelection()({
                    tr: tr
                });
                const { start: start } = source.data;
                // if no drop targets are rendered, assume that drop is invalid
                const lastDragCancelled = location.current.dropTargets.length === 0;
                if (lastDragCancelled) {
                    var _api$analytics;
                    const position = (0, $g4us8.getSelectedSlicePosition)(start, tr, api);
                    const attributes = (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, position.from, position.to);
                    const { nodeTypes: nodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                        eventType: (0, $3LeME.EVENT_TYPE).UI,
                        action: (0, $3LeME.ACTION).CANCELLED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).DRAG,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: nodeTypes || '',
                            hasSelectedMultipleNodes: hasSelectedMultipleNodes
                        }
                    })(tr);
                }
                if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                    var _api$metrics;
                    (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                }
                (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                return tr.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                    ...tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0),
                    isDragging: false,
                    isPMDragging: false,
                    lastDragCancelled: lastDragCancelled
                });
            });
        }
    }));
    return (0, $gXHCV.combine)(...cleanupFn);
};
const $c9fcd5b34a5ec086$var$initialState = {
    decorations: (0, $16ZMX.DecorationSet).empty,
    surfaceNodePositions: [],
    activeNode: undefined,
    isDragging: false,
    isMenuOpen: false,
    editorHeight: 0,
    editorWidthLeft: 0,
    editorWidthRight: 0,
    isResizerResizing: false,
    isDocSizeLimitEnabled: null,
    isPMDragging: false,
    multiSelectDnD: undefined,
    lastDragCancelled: false,
    isSelectedViaDragHandle: false
};
const $c9fcd5b34a5ec086$export$968abecb43309c32 = (state)=>{
    var _key$getState;
    return (_key$getState = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(state)) === null || _key$getState === void 0 ? void 0 : _key$getState.decorations;
};
const $c9fcd5b34a5ec086$var$getDecorationAtPos = (state, decorations, pos, to)=>{
    // Find the newly minted node decs that touch the active node
    const findNewNodeDecs = (0, $2xAfa.findNodeDecs)(state, decorations, pos - 1, to);
    // Find the specific dec that the active node corresponds to
    const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>(dec === null || dec === void 0 ? void 0 : dec.from) === pos);
    // If multiple decorations at the active node pos, we want the last one
    const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
    return nodeDecAtActivePos;
};
const $c9fcd5b34a5ec086$export$5635d7ef4b8fee1c = (api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled = false, quickInsertButtonEnabled = true, anchorRectCache, resizeObserverWidth, pragmaticCleanup, limitedModeTeardown)=>{
    var _api$editorViewMode, _activeNode, _activeNode2, _meta$activeNode$hand, _activeNode3, _activeNode4, _meta$toggleMenu, _meta$toggleMenu2, _meta$toggleMenu3, _meta$toggleMenu4, _meta$toggleMenu5, _meta$toggleMenu6, _meta$toggleMenu7, _meta$toggleMenu8;
    let { activeNode: activeNode, decorations: decorations, isResizerResizing: isResizerResizing, multiSelectDnD: multiSelectDnD, isMenuOpen: isMenuOpen, isSelectedViaDragHandle: isSelectedViaDragHandle } = currentState;
    const { surfaceNodePositions: surfaceNodePositions } = currentState;
    const { editorHeight: editorHeight, editorWidthLeft: editorWidthLeft, editorWidthRight: editorWidthRight, isDragging: isDragging, menuTriggerBy: menuTriggerBy, menuTriggerByNode: menuTriggerByNode, blockMenuOptions: blockMenuOptions, isPMDragging: isPMDragging, lastDragCancelled: lastDragCancelled } = currentState;
    let isActiveNodeDeleted = false;
    const { from: from, to: to, numReplaceSteps: numReplaceSteps, isAllText: isAllText, isReplacedWithSameSize: isReplacedWithSameSize } = (0, $fAWS2.getTrMetadata)(tr, flags);
    const meta = tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0);
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
        var _api$limitedMode;
        // Both arms read `newState` — the state this transaction is producing. Deriving `enabled` from
        // `sharedState.currentState()` instead would resolve against `view.state`, which during `apply` is
        // still the *previous* state, delaying the limited-mode teardown by one transaction.
        //
        // Limited mode can now also be latched at runtime by the performance detector, so the treatment
        // arm considers both reasons rather than just the document one. Identical in the control arm, where
        // the runtime latch can never be set.
        const limitedModeState = api === null || api === void 0 || (_api$limitedMode = api.limitedMode) === null || _api$limitedMode === void 0 || (_api$limitedMode = _api$limitedMode.sharedState.currentState()) === null || _api$limitedMode === void 0 ? void 0 : _api$limitedMode.limitedModePluginKey.getState(newState);
        if (!!(limitedModeState !== null && limitedModeState !== void 0 && limitedModeState.enabled)) {
            /**
       * INFO: This is a duplicate of the logic in destroy(). When we enter limited mode we want to
       * trigger the cleanup logic in destroy().
       */ if (!limitedModeTeardown || !limitedModeTeardown.done) {
                var _getDocument2;
                /**
         * Edge-triggered under the experiment: limited mode is a latch, so without this guard the
         * teardown re-runs on every subsequent transaction for the rest of the session — and would
         * re-register the pragmatic monitors if `pragmaticCleanup` ever became re-entrant.
         */ if (limitedModeTeardown) limitedModeTeardown.done = true;
                const editorContentArea = ((_getDocument2 = (0, $j5N6B.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.querySelector('.fabric-editor-popup-scroll-parent')) ?? null;
                if (editorContentArea && resizeObserverWidth) resizeObserverWidth.unobserve(editorContentArea);
                pragmaticCleanup === null || pragmaticCleanup === void 0 || pragmaticCleanup();
            }
            /**
       * Reset rather than freeze. Returning `currentState` here would keep `decorations`,
       * `activeNode` and the multi-select positions from before the latch, while skipping the
       * `tr.mapping` remapping below — so they would silently drift out of sync with the document on
       * every subsequent edit. Nothing renders them in limited mode (`props.decorations` returns
       * early), but stale positions are a latent source of incorrect offsets for anything that reads
       * them, so the safe state is empty.
       */ return {
                ...currentState,
                activeNode: undefined,
                decorations: (0, $16ZMX.DecorationSet).empty,
                multiSelectDnD: undefined
            };
        }
    } else {
        var _api$limitedMode2;
        const hasDocumentSizeBreachedThreshold = api === null || api === void 0 || (_api$limitedMode2 = api.limitedMode) === null || _api$limitedMode2 === void 0 || (_api$limitedMode2 = _api$limitedMode2.sharedState.currentState()) === null || _api$limitedMode2 === void 0 || (_api$limitedMode2 = _api$limitedMode2.limitedModePluginKey.getState(newState)) === null || _api$limitedMode2 === void 0 ? void 0 : _api$limitedMode2.documentSizeBreachesThreshold;
        if (hasDocumentSizeBreachedThreshold) {
            var _getDocument3;
            /**
       * INFO: This if statement is a duplicate of the logic in destroy(). When the threshold is breached and we enter limited mode, we want to trigger the cleanup logic in destroy().
       */ const editorContentArea = ((_getDocument3 = (0, $j5N6B.getDocument)()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.querySelector('.fabric-editor-popup-scroll-parent')) ?? null;
            if (editorContentArea && resizeObserverWidth) resizeObserverWidth.unobserve(editorContentArea);
            pragmaticCleanup === null || pragmaticCleanup === void 0 || pragmaticCleanup();
            return currentState;
        }
    }
    // patch_1: DecorationSet.map() validates node decorations as it maps them — one whose range
    // no longer exactly covers a node (e.g. after a split) is dropped rather than left misplaced.
    // Recording that here lets the active-node decoration blocks below re-add only what actually
    // went away, instead of scanning the whole decoration set on every keystroke (VC90).
    // The active-node decorations only exist under the reliable anchor experiment, so the patch is
    // scoped to it as well. No-exposure check as this runs on every document change; the blocks
    // below that consume these flags are already inside an `expValEquals` guard for the same
    // experiment, so the exposure is fired there.
    let activeHandleDecDropped = false;
    let activeQuickInsertDecDropped = false;
    // When steps exist, remap existing decorations, activeNode and multi select positions
    if (tr.docChanged) {
        if ((0, $3NBIB.expValEqualsNoExposure)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $dRkX9.fg)('platform_editor_controls_reliable_anchor_patch_1')) decorations = decorations.map(tr.mapping, tr.doc, {
            onRemove: (spec)=>{
                if ((spec === null || spec === void 0 ? void 0 : spec.type) === (0, $50s88.TYPE_ACTIVE_HANDLE_DEC)) activeHandleDecDropped = true;
                else if ((spec === null || spec === void 0 ? void 0 : spec.type) === (0, $gr4E6.TYPE_ACTIVE_QUICK_INSERT_NODE)) activeQuickInsertDecDropped = true;
            }
        });
        else decorations = decorations.map(tr.mapping, tr.doc);
        // platform_editor_controls note: enables quick insert
        // don't remap activeNode if it's being dragged
        if (!flags.toolbarFlagsEnabled) {
            if (activeNode) {
                const mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
                activeNode = {
                    pos: mappedPos.pos,
                    anchorName: activeNode.anchorName,
                    nodeType: activeNode.nodeType
                };
            }
        } else if (activeNode && (meta === null || meta === void 0 ? void 0 : meta.isDragging) !== true) {
            var _mappedRootPos;
            let mappedPos;
            const browser = (0, $dqFZv.getBrowserInfo)();
            // In safari, when platform_editor_controls is on,
            // sometimes the drag handle for the layout disppears after you click on the handle for a few times
            // Which caused the drag handle onClick event not firing, then block menu wouldn't be opened
            // This is caused by the mappedPos.deletedAfter sometimes returning true in webkit browsers even though the active node still exists
            // This is likely a prosemirror and safari integration bug, but to unblock the issue, we are going to use mappedPos.deleted in safari for now
            if (browser.webkit) {
                mappedPos = tr.mapping.mapResult(activeNode.pos);
                isActiveNodeDeleted = mappedPos.deleted;
            } else {
                mappedPos = tr.mapping.mapResult(activeNode.pos, -1);
                isActiveNodeDeleted = mappedPos.deletedAfter;
            }
            // for editor controls, remap the rootPos as well
            let mappedRootPos;
            if (activeNode.rootPos !== undefined) mappedRootPos = tr.mapping.mapResult(activeNode.rootPos, -1);
            let mappedNodeType = activeNode.nodeType;
            let mappedRootNodeType = activeNode.rootNodeType;
            // Sparse mode does not redraw the old decorations. A block-type transaction may report
            // a text range that excludes the active block position, so always refresh the already
            // active node and root from the new document (for example, paragraph → heading-1).
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                const mappedNode = newState.doc.nodeAt(mappedPos.pos);
                if (mappedNode !== null && mappedNode !== void 0 && mappedNode.isBlock) mappedNodeType = (0, $61p1X.getNodeTypeWithLevel)(mappedNode);
                const mappedRootNode = mappedRootPos ? mappedRootPos.pos === mappedPos.pos && mappedNode ? mappedNode : newState.doc.nodeAt(mappedRootPos.pos) : undefined;
                if (mappedRootNode !== null && mappedRootNode !== void 0 && mappedRootNode.isBlock) mappedRootNodeType = (0, $61p1X.getNodeTypeWithLevel)(mappedRootNode);
            }
            activeNode = {
                pos: mappedPos.pos,
                anchorName: activeNode.anchorName,
                nodeType: mappedNodeType,
                rootPos: ((_mappedRootPos = mappedRootPos) === null || _mappedRootPos === void 0 ? void 0 : _mappedRootPos.pos) ?? activeNode.rootPos,
                rootAnchorName: activeNode.rootAnchorName,
                rootNodeType: mappedRootNodeType
            };
        }
        if (multiSelectDnD) {
            multiSelectDnD.anchor = tr.mapping.map(multiSelectDnD.anchor);
            multiSelectDnD.head = tr.mapping.map(multiSelectDnD.head);
        }
    }
    const resizerMeta = tr.getMeta('is-resizer-resizing');
    isResizerResizing = resizerMeta ?? isResizerResizing;
    const hasJustFinishedResizing = resizerMeta === false;
    multiSelectDnD = (meta === null || meta === void 0 ? void 0 : meta.multiSelectDnD) ?? multiSelectDnD;
    if (multiSelectDnD) {
        if (((meta === null || meta === void 0 ? void 0 : meta.isDragging) ?? isDragging) && (0, $aEmSo.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // When dragging, we want to keep the multiSelectDnD object unless both document and selection
            // has changed, in which case we want to reset it.
            const shouldResetMultiSelectDnD = tr.docChanged && tr.selectionSet && tr.selection.empty;
            multiSelectDnD = shouldResetMultiSelectDnD ? undefined : multiSelectDnD;
        } else multiSelectDnD = (meta === null || meta === void 0 ? void 0 : meta.isDragging) === false || tr.selection.empty ? undefined : multiSelectDnD;
    }
    const maybeNodeCountChanged = !isAllText && numReplaceSteps > 0;
    let latestActiveNode = meta === null || meta === void 0 ? void 0 : meta.activeNode;
    const isViewMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
    if (!latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) latestActiveNode = activeNode;
    // Re-create node decorations
    const isDecSetEmpty = decorations === (0, $16ZMX.DecorationSet).empty;
    const isNodeDecsMissing = isDecSetEmpty || maybeNodeCountChanged || hasJustFinishedResizing;
    const shouldRedrawNodeDecs = !isResizerResizing && (isNodeDecsMissing || (meta === null || meta === void 0 ? void 0 : meta.isDragging)) && // Skip expensive anchor node decoration recalculations when native anchor support is enabled
    !((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration'));
    let isActiveNodeModified = false;
    if (api && shouldRedrawNodeDecs) {
        const oldNodeDecs = (0, $2xAfa.findNodeDecs)(newState, decorations, from, to);
        decorations = decorations.remove(oldNodeDecs);
        const newNodeDecs = (0, $2xAfa.nodeDecorations)(newState, isDecSetEmpty ? undefined : from, isDecSetEmpty ? undefined : to);
        decorations = decorations.add(newState.doc, newNodeDecs);
        // platform_editor_controls note: enables quick insert
        if (!flags.toolbarFlagsEnabled) {
            if (latestActiveNode && !isActiveNodeDeleted) {
                // Find the newly minted node decs that touch the active node
                const findNewNodeDecs = (0, $2xAfa.findNodeDecs)(newState, decorations, latestActiveNode.pos - 1, to);
                // Find the specific dec that the active node corresponds to
                const nodeDecsAtActivePos = findNewNodeDecs.filter((dec)=>(dec === null || dec === void 0 ? void 0 : dec.from) === latestActiveNode.pos);
                // If multiple decorations at the active node pos, we want the last one
                const nodeDecAtActivePos = nodeDecsAtActivePos.pop();
                // Update the active node anchor-name and type for accurate positioning
                if (nodeDecAtActivePos) {
                    isActiveNodeModified = true;
                    latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                    latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
                }
            }
        } else if (latestActiveNode && (!isActiveNodeDeleted || isReplacedWithSameSize)) {
            const nodeDecAtActivePos = $c9fcd5b34a5ec086$var$getDecorationAtPos(newState, decorations, latestActiveNode.pos, to);
            const rootNodeDecAtActivePos = latestActiveNode.rootPos !== undefined ? $c9fcd5b34a5ec086$var$getDecorationAtPos(newState, decorations, latestActiveNode.rootPos, to) : undefined;
            if (nodeDecAtActivePos || rootNodeDecAtActivePos) isActiveNodeModified = true;
            // Update the active node anchor-name and type for accurate positioning
            if (nodeDecAtActivePos) {
                latestActiveNode.anchorName = nodeDecAtActivePos.spec.anchorName;
                latestActiveNode.nodeType = nodeDecAtActivePos.spec.nodeType;
            }
            if (rootNodeDecAtActivePos) {
                latestActiveNode.rootAnchorName = rootNodeDecAtActivePos.spec.anchorName;
                latestActiveNode.rootNodeType = rootNodeDecAtActivePos.spec.nodeType;
            }
        }
    }
    // Check if editor dimensions have changed
    const editorSizeChanged = (meta === null || meta === void 0 ? void 0 : meta.editorHeight) !== undefined && (meta === null || meta === void 0 ? void 0 : meta.editorHeight) !== editorHeight || (meta === null || meta === void 0 ? void 0 : meta.editorWidthLeft) !== undefined && (meta === null || meta === void 0 ? void 0 : meta.editorWidthLeft) !== editorWidthLeft || (meta === null || meta === void 0 ? void 0 : meta.editorWidthRight) !== undefined && (meta === null || meta === void 0 ? void 0 : meta.editorWidthRight) !== editorWidthRight;
    // Check if there's a new active node, and it differs from the last
    const activeNodeChanged = (meta === null || meta === void 0 ? void 0 : meta.activeNode) && ((meta === null || meta === void 0 ? void 0 : meta.activeNode.pos) !== ((_activeNode = activeNode) === null || _activeNode === void 0 ? void 0 : _activeNode.pos) && (meta === null || meta === void 0 ? void 0 : meta.activeNode.anchorName) !== ((_activeNode2 = activeNode) === null || _activeNode2 === void 0 ? void 0 : _activeNode2.anchorName) || (meta === null || meta === void 0 || (_meta$activeNode$hand = meta.activeNode.handleOptions) === null || _meta$activeNode$hand === void 0 ? void 0 : _meta$activeNode$hand.isFocused));
    const rootActiveNodeChanged = (meta === null || meta === void 0 ? void 0 : meta.activeNode) && (meta === null || meta === void 0 ? void 0 : meta.activeNode.rootPos) !== ((_activeNode3 = activeNode) === null || _activeNode3 === void 0 ? void 0 : _activeNode3.rootPos) && (meta === null || meta === void 0 ? void 0 : meta.activeNode.rootAnchorName) !== ((_activeNode4 = activeNode) === null || _activeNode4 === void 0 ? void 0 : _activeNode4.rootAnchorName);
    // Some browsers don't support anchor positioning, meaning we need to replace the handle when nodes change
    const handleNeedsRedraw = shouldRedrawNodeDecs && !(0, $atuba.isAnchorSupported)();
    // Create/recreate handle dec when the active node is missing/changes, or the editor viewport has changed (non-anchor pos workaround)
    const shouldRecreateHandle = latestActiveNode && (activeNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    const shouldRecreateQuickInsertButton = latestActiveNode && (rootActiveNodeChanged || isActiveNodeModified || editorSizeChanged || handleNeedsRedraw);
    // If the active node is missing, we need to remove the handle
    let shouldRemoveHandle = latestActiveNode ? isResizerResizing || isActiveNodeDeleted && !isReplacedWithSameSize || (meta === null || meta === void 0 ? void 0 : meta.nodeMoved) : true;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) // Remove handle dec when editor is blurred
    shouldRemoveHandle = shouldRemoveHandle || (meta === null || meta === void 0 ? void 0 : meta.editorBlurred);
    // In view mode with right-side controls, remove any lingering drag handle decorations
    // (they may carry over from edit mode). Only remove drag handles specifically, not
    // the remix button decorations (those are managed separately via showInViewMode).
    if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && isViewMode && rightSideControlsEnabled) {
        const allHandleDecs = (0, $50s88.findHandleDec)(decorations, 0, newState.doc.content.size);
        if (allHandleDecs.length > 0) decorations = decorations.remove(allHandleDecs);
    }
    if (shouldRemoveHandle) {
        if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
            var _activeNode5, _activeNode6;
            const oldHandle = (0, $50s88.findHandleDec)(decorations, (_activeNode5 = activeNode) === null || _activeNode5 === void 0 ? void 0 : _activeNode5.pos, (_activeNode6 = activeNode) === null || _activeNode6 === void 0 ? void 0 : _activeNode6.pos);
            decorations = decorations.remove(oldHandle);
        }
        // When removing the handle, also remove the anchor-marker node decorations
        // (data-active-drag-handle / data-active-quick-insert) so the DOM attributes
        // don't linger on nodes that are no longer active.
        // Use full-range search (0..contentSize) rather than a point-range at activeNode.pos/rootPos:
        // after a doc change (e.g. pressing Enter splits a node), DecorationSet.map() can shift the
        // decoration to a different position, so a point-range search would miss it and leave a stale
        // attribute on the wrong DOM node.
        if ((!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') || nodeDecorationRegistry.length > 0) && (0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) {
            const oldActiveNodeDec = (0, $50s88.findActiveDragHandleNodeDec)(decorations, 0, newState.doc.content.size);
            decorations = decorations.remove(oldActiveNodeDec);
            const oldActiveQuickInsertDec = (0, $gr4E6.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
            decorations = decorations.remove(oldActiveQuickInsertDec);
        }
        // nodeDecorationRegistry cleanup (e.g. the legacy Remix button) is independent of the legacy
        // quick-insert button, so this must not be gated by quickInsertButtonEnabled — otherwise a
        // stale decoration is left behind whenever platform_editor_block_control_migration is on.
        if (flags.toolbarFlagsEnabled) {
            // platform_editor_controls note: enables quick insert
            if (quickInsertButtonEnabled) {
                var _activeNode7, _activeNode8;
                const oldQuickInsertButton = (0, $gr4E6.findQuickInsertInsertButtonDecoration)(decorations, (_activeNode7 = activeNode) === null || _activeNode7 === void 0 ? void 0 : _activeNode7.rootPos, (_activeNode8 = activeNode) === null || _activeNode8 === void 0 ? void 0 : _activeNode8.rootPos);
                decorations = decorations.remove(oldQuickInsertButton);
            }
            for (const factory of nodeDecorationRegistry){
                var _activeNode9, _activeNode0;
                const old = decorations.find((_activeNode9 = activeNode) === null || _activeNode9 === void 0 ? void 0 : _activeNode9.rootPos, (_activeNode0 = activeNode) === null || _activeNode0 === void 0 ? void 0 : _activeNode0.rootPos, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
            if (rightSideControlsEnabled && isViewMode) {
                for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                    var _activeNode1, _activeNode10;
                    const old = decorations.find((_activeNode1 = activeNode) === null || _activeNode1 === void 0 ? void 0 : _activeNode1.rootPos, (_activeNode10 = activeNode) === null || _activeNode10 === void 0 ? void 0 : _activeNode10.rootPos, (spec)=>spec.type === factory.type);
                    decorations = decorations.remove(old);
                }
            }
        }
    } else if (api) {
        var _latestActiveNode5, _latestActiveNode10;
        // The registry surface replaces the legacy drag-handle decorations during migration.
        if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && shouldRecreateHandle && (!rightSideControlsEnabled || !isViewMode)) {
            var _activeNode11, _activeNode12, _latestActiveNode, _latestActiveNode2, _latestActiveNode3, _latestActiveNode4;
            const oldHandle = (0, $50s88.findHandleDec)(decorations, (_activeNode11 = activeNode) === null || _activeNode11 === void 0 ? void 0 : _activeNode11.pos, (_activeNode12 = activeNode) === null || _activeNode12 === void 0 ? void 0 : _activeNode12.pos);
            decorations = decorations.remove(oldHandle);
            const handleDec = (0, $50s88.dragHandleDecoration)({
                api: api,
                formatMessage: formatMessage,
                pos: (_latestActiveNode = latestActiveNode) === null || _latestActiveNode === void 0 ? void 0 : _latestActiveNode.pos,
                anchorName: (_latestActiveNode2 = latestActiveNode) === null || _latestActiveNode2 === void 0 ? void 0 : _latestActiveNode2.anchorName,
                nodeType: (_latestActiveNode3 = latestActiveNode) === null || _latestActiveNode3 === void 0 ? void 0 : _latestActiveNode3.nodeType,
                handleOptions: (_latestActiveNode4 = latestActiveNode) === null || _latestActiveNode4 === void 0 ? void 0 : _latestActiveNode4.handleOptions,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                anchorRectCache: anchorRectCache,
                editorState: newState
            });
            decorations = decorations.add(newState.doc, [
                handleDec
            ]);
        }
        if ((!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') || // nodeDecorationRegistry consumers (e.g. the legacy Remix button) rely
        // on that same anchor-name for their own CSS anchor() positioning, so this must still run
        // when such a consumer exists even if the legacy drag handle itself is disabled.
        nodeDecorationRegistry.length > 0) && (0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && latestActiveNode) {
            // patch_1: a plain doc change no longer forces a rescan — map() above has already
            // either kept the decoration correctly positioned or dropped it as invalid, so we
            // only need to act when it was actually dropped.
            const docChangeInvalidatedNodeDec = (0, $dRkX9.fg)('platform_editor_controls_reliable_anchor_patch_1') ? activeHandleDecDropped : tr.docChanged;
            // Recreate the drag handle node decoration when the active node changed,
            // its content was modified, or the document changed.
            // This runs independently of shouldRecreateHandle so that doc changes (like pressing
            // Enter) correctly refresh the decoration even when the handle widget doesn't move.
            // DecorationSet.map() can misplace the decoration after node splits/inserts.
            const needsNodeDecUpdate = activeNodeChanged || isActiveNodeModified || docChangeInvalidatedNodeDec;
            if (needsNodeDecUpdate) {
                var _newState$doc$nodeAt;
                const nodeSize = (_newState$doc$nodeAt = newState.doc.nodeAt(latestActiveNode.pos)) === null || _newState$doc$nodeAt === void 0 ? void 0 : _newState$doc$nodeAt.nodeSize;
                if (nodeSize !== undefined) {
                    // Search the full doc range: after DecorationSet.map(), the decoration may have
                    // shifted away from activeNode?.pos (e.g. a node split moves it to the new paragraph).
                    const oldActiveNodeDec = (0, $50s88.findActiveDragHandleNodeDec)(decorations, 0, newState.doc.content.size);
                    // Skip remove+add if the decoration is already at the correct position.
                    // On pure text keystrokes, DecorationSet.map() keeps the decoration correctly
                    // placed, so we avoid unnecessary churn on every character typed.
                    const dragHandleDecAlreadyCorrect = oldActiveNodeDec.length === 1 && oldActiveNodeDec[0].from === latestActiveNode.pos && oldActiveNodeDec[0].to === latestActiveNode.pos + nodeSize;
                    if (!dragHandleDecAlreadyCorrect) {
                        decorations = decorations.remove(oldActiveNodeDec);
                        decorations = decorations.add(newState.doc, [
                            (0, $50s88.createActiveDragHandleNodeDecoration)(latestActiveNode.pos, nodeSize)
                        ]);
                    }
                }
            }
            // The quick-insert decoration lives on the root node (rootPos), which can change
            // independently of the edit-mode node — e.g. when only editorSizeChanged fires but
            // rootActiveNodeChanged is also true. So we use a separate, broader guard that
            // includes rootActiveNodeChanged to avoid leaving the attribute on a stale root node.
            const needsQuickInsertDecUpdate = activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || ((0, $dRkX9.fg)('platform_editor_controls_reliable_anchor_patch_1') ? activeQuickInsertDecDropped : tr.docChanged);
            if (needsQuickInsertDecUpdate && latestActiveNode.rootPos !== undefined) {
                var _newState$doc$nodeAt2;
                const rootNodeSize = (_newState$doc$nodeAt2 = newState.doc.nodeAt(latestActiveNode.rootPos)) === null || _newState$doc$nodeAt2 === void 0 ? void 0 : _newState$doc$nodeAt2.nodeSize;
                if (rootNodeSize !== undefined) {
                    const oldActiveQuickInsertDec = (0, $gr4E6.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
                    // Skip remove+add if the decoration is already at the correct position.
                    // On pure text keystrokes, DecorationSet.map() keeps the decoration correctly
                    // placed, so we avoid unnecessary churn on every character typed.
                    const quickInsertDecAlreadyCorrect = oldActiveQuickInsertDec.length === 1 && oldActiveQuickInsertDec[0].from === latestActiveNode.rootPos && oldActiveQuickInsertDec[0].to === latestActiveNode.rootPos + rootNodeSize;
                    if (!quickInsertDecAlreadyCorrect) {
                        decorations = decorations.remove(oldActiveQuickInsertDec);
                        decorations = decorations.add(newState.doc, [
                            (0, $gr4E6.createActiveQuickInsertNodeDecoration)(latestActiveNode.rootPos, rootNodeSize)
                        ]);
                    }
                }
            }
        }
        if (shouldRecreateQuickInsertButton && ((_latestActiveNode5 = latestActiveNode) === null || _latestActiveNode5 === void 0 ? void 0 : _latestActiveNode5.rootPos) !== undefined && (quickInsertButtonEnabled || nodeDecorationRegistry.length > 0) && // platform_editor_controls note: enables quick insert
        flags.toolbarFlagsEnabled && (!rightSideControlsEnabled || !isViewMode)) {
            var _latestActiveNode1;
            if (quickInsertButtonEnabled) {
                var _activeNode13, _activeNode14, _latestActiveNode6, _latestActiveNode7, _latestActiveNode8, _latestActiveNode9, _latestActiveNode0;
                const oldQuickInsertButton = (0, $gr4E6.findQuickInsertInsertButtonDecoration)(decorations, (_activeNode13 = activeNode) === null || _activeNode13 === void 0 ? void 0 : _activeNode13.rootPos, (_activeNode14 = activeNode) === null || _activeNode14 === void 0 ? void 0 : _activeNode14.rootPos);
                decorations = decorations.remove(oldQuickInsertButton);
                const quickInsertButton = (0, $gr4E6.quickInsertButtonDecoration)({
                    api: api,
                    formatMessage: formatMessage,
                    anchorName: (_latestActiveNode6 = latestActiveNode) === null || _latestActiveNode6 === void 0 ? void 0 : _latestActiveNode6.anchorName,
                    nodeType: (_latestActiveNode7 = latestActiveNode) === null || _latestActiveNode7 === void 0 ? void 0 : _latestActiveNode7.nodeType,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    rootPos: (_latestActiveNode8 = latestActiveNode) === null || _latestActiveNode8 === void 0 ? void 0 : _latestActiveNode8.rootPos,
                    rootAnchorName: (_latestActiveNode9 = latestActiveNode) === null || _latestActiveNode9 === void 0 ? void 0 : _latestActiveNode9.rootAnchorName,
                    rootNodeType: (_latestActiveNode0 = latestActiveNode) === null || _latestActiveNode0 === void 0 ? void 0 : _latestActiveNode0.rootNodeType,
                    anchorRectCache: anchorRectCache,
                    editorState: newState
                });
                decorations = decorations.add(newState.doc, [
                    quickInsertButton
                ]);
            }
            // Update quick insert node decoration when the quick insert button is recreated but
            // the drag handle was NOT recreated (shouldRecreateHandle was false). When
            // shouldRecreateHandle is true, the block above already handles this.
            // Also skip when the needsQuickInsertDecUpdate block above already handled the update
            // (i.e. activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged)
            // — running both would remove and re-add a duplicate decoration.
            if ((0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !shouldRecreateHandle && !(activeNodeChanged || isActiveNodeModified || rootActiveNodeChanged || tr.docChanged) && ((_latestActiveNode1 = latestActiveNode) === null || _latestActiveNode1 === void 0 ? void 0 : _latestActiveNode1.rootPos) !== undefined) {
                var _newState$doc$nodeAt3;
                // Use full-range search (0..contentSize) rather than a point-range at activeNode.rootPos:
                // after a doc change, DecorationSet.map() can shift the decoration to a different position,
                // so a point-range search would miss it and leave a stale attribute on the wrong DOM node.
                const oldActiveQuickInsertDec = (0, $gr4E6.findActiveQuickInsertNodeDec)(decorations, 0, newState.doc.content.size);
                decorations = decorations.remove(oldActiveQuickInsertDec);
                const rootNodeSize = (_newState$doc$nodeAt3 = newState.doc.nodeAt(latestActiveNode.rootPos)) === null || _newState$doc$nodeAt3 === void 0 ? void 0 : _newState$doc$nodeAt3.nodeSize;
                if (rootNodeSize !== undefined) decorations = decorations.add(newState.doc, [
                    (0, $gr4E6.createActiveQuickInsertNodeDecoration)(latestActiveNode.rootPos, rootNodeSize)
                ]);
            }
            if (rightSideControlsEnabled) for (const factory of nodeDecorationRegistry){
                var _activeNode15, _activeNode16;
                if (!latestActiveNode || latestActiveNode.rootPos === undefined) continue;
                const params = {
                    editorState: newState,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    anchorName: latestActiveNode.anchorName,
                    nodeType: latestActiveNode.nodeType,
                    rootPos: latestActiveNode.rootPos,
                    rootAnchorName: latestActiveNode.rootAnchorName,
                    rootNodeType: latestActiveNode.rootNodeType
                };
                const old = decorations.find((_activeNode15 = activeNode) === null || _activeNode15 === void 0 ? void 0 : _activeNode15.rootPos, (_activeNode16 = activeNode) === null || _activeNode16 === void 0 ? void 0 : _activeNode16.rootPos, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
                // determines whether to show the decorations, see malleableUiPlugin.tsx
                if (factory.shouldCreate && !factory.shouldCreate(params)) continue;
                const dec = factory.create(params);
                decorations = decorations.add(newState.doc, [
                    dec
                ]);
            }
            else for (const factory of nodeDecorationRegistry){
                const old = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
        }
        // In view mode (edit/live pages), show right-side controls on block hover (without drag handle or quick insert)
        const rootPos = (_latestActiveNode10 = latestActiveNode) === null || _latestActiveNode10 === void 0 ? void 0 : _latestActiveNode10.rootPos;
        // rootPos is computed using the same logic as the floating insert menu, so it always points to a top-level (doc child) block when defined.
        const isDocLevel = rootPos !== undefined && !isNaN(rootPos);
        if (isViewMode && isDocLevel && flags.toolbarFlagsEnabled && rightSideControlsEnabled) {
            for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                if (!latestActiveNode || latestActiveNode.rootPos === undefined) continue;
                const params = {
                    editorState: newState,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    anchorName: latestActiveNode.anchorName,
                    nodeType: latestActiveNode.nodeType,
                    rootPos: latestActiveNode.rootPos,
                    rootAnchorName: latestActiveNode.rootAnchorName,
                    rootNodeType: latestActiveNode.rootNodeType
                };
                if (factory.shouldCreate && !factory.shouldCreate(params)) continue;
                const existingAtPos = decorations.find(rootPos, rootPos, (spec)=>spec.type === factory.type);
                // Skip remove/re-add when decoration already exists at correct position - avoids
                // flickering from widget destroy/recreate on every transaction (e.g. on hover).
                if (existingAtPos.length > 0) continue;
                // Remove any stale decoration at a different position (e.g. after moving to another block)
                const stale = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(stale);
                const dec = factory.create(params);
                decorations = decorations.add(newState.doc, [
                    dec
                ]);
            }
        } else if (isViewMode && rightSideControlsEnabled) {
            // Remove view-mode right-side decorations when no active node
            for (const factory of nodeDecorationRegistry)if (factory.showInViewMode) {
                const old = decorations.find(0, newState.doc.nodeSize, (spec)=>spec.type === factory.type);
                decorations = decorations.remove(old);
            }
        }
    }
    // Drop targets may be missing when the node count is being changed during a drag
    const isDropTargetsMissing = ((meta === null || meta === void 0 ? void 0 : meta.isDragging) ?? isDragging) && maybeNodeCountChanged && !(meta !== null && meta !== void 0 && meta.nodeMoved);
    // Remove drop target decorations when dragging stops or they need to be redrawn
    if ((meta === null || meta === void 0 ? void 0 : meta.isDragging) === false || isDropTargetsMissing) {
        const dropTargetDecs = (0, $cDvgs.findDropTargetDecs)(decorations);
        decorations = decorations.remove(dropTargetDecs);
    }
    let currentActiveDropTargetNode = isDragging ? currentState.activeDropTargetNode : undefined;
    if (api) {
        if ((0, $aEmSo.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
            // If page is updated while dragging (likely by remote updates), we simply remove the drop targets
            // and add them back when the user interacts with the editor again
            if (isDropTargetsMissing) {
                const oldDropTargetDecs = (0, $cDvgs.findDropTargetDecs)(decorations);
                decorations = decorations.remove(oldDropTargetDecs);
            }
            if (meta !== null && meta !== void 0 && meta.activeDropTargetNode) {
                currentActiveDropTargetNode = meta === null || meta === void 0 ? void 0 : meta.activeDropTargetNode;
                const oldDropTargetDecs = (0, $cDvgs.findDropTargetDecs)(decorations);
                const { decsToAdd: decsToAdd, decsToRemove: decsToRemove } = (0, $8bDpq.getActiveDropTargetDecorations)(meta.activeDropTargetNode, newState, api, oldDropTargetDecs, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
                decorations = decorations.remove(decsToRemove);
                if (decsToAdd.length > 0) decorations = decorations.add(newState.doc, decsToAdd);
            }
        } else if (meta !== null && meta !== void 0 && meta.isDragging || isDropTargetsMissing) {
            // Add drop targets when dragging starts or some are missing
            const decs = (0, $cDvgs.dropTargetDecorations)(newState, api, formatMessage, nodeViewPortalProviderAPI, latestActiveNode, anchorRectCache);
            decorations = decorations.add(newState.doc, decs);
        }
    }
    const isEmptyDoc = (0, $ljn7y.isEmptyDocument)(newState.doc);
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && (meta === null || meta === void 0 ? void 0 : meta.isDragging) === false) decorations = decorations.remove((0, $2xAfa.findNodeDecs)(newState, decorations));
    if (isEmptyDoc && !((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration'))) {
        const hasNodeDecoration = !!(0, $2xAfa.findNodeDecs)(newState, decorations).length;
        if (!hasNodeDecoration) decorations = decorations.add(newState.doc, [
            (0, $50s88.emptyParagraphNodeDecorations)()
        ]);
    }
    let newActiveNode;
    // platform_editor_controls note: enables quick insert
    if (flags.toolbarFlagsEnabled) {
        var _latestActiveNode11, _latestActiveNode12;
        // remove isEmptyDoc check and let decorations render and determine their own visibility
        // In view mode with right-side controls we render node decorations (right-edge button), not the
        // handle - so findHandleDec is always empty. Don't clear activeNode in that case.
        const hasHandleOrViewModeControls = (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') || isViewMode && rightSideControlsEnabled || (0, $50s88.findHandleDec)(decorations, (_latestActiveNode11 = latestActiveNode) === null || _latestActiveNode11 === void 0 ? void 0 : _latestActiveNode11.pos, (_latestActiveNode12 = latestActiveNode) === null || _latestActiveNode12 === void 0 ? void 0 : _latestActiveNode12.pos).length > 0;
        // Keep the registry surface mounted while its Block Menu owns focus.
        const keepActiveNodeForOpenBlockMenu = (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && isMenuOpen;
        newActiveNode = meta !== null && meta !== void 0 && meta.editorBlurred && !keepActiveNodeForOpenBlockMenu || !(meta !== null && meta !== void 0 && meta.activeNode) && !hasHandleOrViewModeControls ? null : latestActiveNode;
    } else {
        var _latestActiveNode13, _latestActiveNode14;
        newActiveNode = isEmptyDoc || !(meta !== null && meta !== void 0 && meta.activeNode) && !(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && (0, $50s88.findHandleDec)(decorations, (_latestActiveNode13 = latestActiveNode) === null || _latestActiveNode13 === void 0 ? void 0 : _latestActiveNode13.pos, (_latestActiveNode14 = latestActiveNode) === null || _latestActiveNode14 === void 0 ? void 0 : _latestActiveNode14.pos).length === 0 ? null : latestActiveNode;
    }
    let nextMenuTriggerByNode = (meta === null || meta === void 0 || (_meta$toggleMenu = meta.toggleMenu) === null || _meta$toggleMenu === void 0 ? void 0 : _meta$toggleMenu.triggerByNode) || menuTriggerByNode;
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && tr.docChanged && menuTriggerByNode && !(meta !== null && meta !== void 0 && meta.toggleMenu)) {
        var _newState$doc$nodeAt4;
        const mapped = tr.mapping.mapResult(menuTriggerByNode.pos, 1);
        const mappedRoot = tr.mapping.mapResult(menuTriggerByNode.rootPos ?? menuTriggerByNode.pos, 1);
        if (mapped.deleted || mappedRoot.deleted || !((_newState$doc$nodeAt4 = newState.doc.nodeAt(mapped.pos)) !== null && _newState$doc$nodeAt4 !== void 0 && _newState$doc$nodeAt4.isBlock)) {
            nextMenuTriggerByNode = undefined;
            isMenuOpen = false;
        } else nextMenuTriggerByNode = {
            ...menuTriggerByNode,
            pos: mapped.pos,
            rootPos: mappedRoot.pos
        };
    }
    if (meta !== null && meta !== void 0 && meta.closeMenu) isMenuOpen = false;
    else if (meta !== null && meta !== void 0 && meta.toggleMenu) {
        const isSameAnchor = (meta === null || meta === void 0 ? void 0 : meta.toggleMenu.anchorName) === menuTriggerBy;
        isMenuOpen = menuTriggerBy === undefined || isSameAnchor || !isMenuOpen && !isSameAnchor ? !isMenuOpen : isMenuOpen;
    }
    if (flags.toolbarFlagsEnabled) isSelectedViaDragHandle = (meta === null || meta === void 0 ? void 0 : meta.isSelectedViaDragHandle) !== undefined ? meta === null || meta === void 0 ? void 0 : meta.isSelectedViaDragHandle : isSelectedViaDragHandle;
    else isSelectedViaDragHandle = false;
    return {
        decorations: decorations,
        surfaceNodePositions: surfaceNodePositions,
        activeNode: newActiveNode,
        activeDropTargetNode: currentActiveDropTargetNode,
        isDragging: (meta === null || meta === void 0 ? void 0 : meta.isDragging) ?? isDragging,
        isMenuOpen: isMenuOpen,
        menuTriggerBy: (meta === null || meta === void 0 || (_meta$toggleMenu2 = meta.toggleMenu) === null || _meta$toggleMenu2 === void 0 ? void 0 : _meta$toggleMenu2.anchorName) || menuTriggerBy,
        menuTriggerByNode: nextMenuTriggerByNode,
        blockMenuOptions: {
            canMoveUp: (meta === null || meta === void 0 || (_meta$toggleMenu3 = meta.toggleMenu) === null || _meta$toggleMenu3 === void 0 ? void 0 : _meta$toggleMenu3.moveUp) !== undefined ? meta === null || meta === void 0 || (_meta$toggleMenu4 = meta.toggleMenu) === null || _meta$toggleMenu4 === void 0 ? void 0 : _meta$toggleMenu4.moveUp : blockMenuOptions === null || blockMenuOptions === void 0 ? void 0 : blockMenuOptions.canMoveUp,
            canMoveDown: (meta === null || meta === void 0 || (_meta$toggleMenu5 = meta.toggleMenu) === null || _meta$toggleMenu5 === void 0 ? void 0 : _meta$toggleMenu5.moveDown) !== undefined ? meta === null || meta === void 0 || (_meta$toggleMenu6 = meta.toggleMenu) === null || _meta$toggleMenu6 === void 0 ? void 0 : _meta$toggleMenu6.moveDown : blockMenuOptions === null || blockMenuOptions === void 0 ? void 0 : blockMenuOptions.canMoveDown,
            openedViaKeyboard: (meta === null || meta === void 0 || (_meta$toggleMenu7 = meta.toggleMenu) === null || _meta$toggleMenu7 === void 0 ? void 0 : _meta$toggleMenu7.openedViaKeyboard) !== undefined ? meta === null || meta === void 0 || (_meta$toggleMenu8 = meta.toggleMenu) === null || _meta$toggleMenu8 === void 0 ? void 0 : _meta$toggleMenu8.openedViaKeyboard : blockMenuOptions === null || blockMenuOptions === void 0 ? void 0 : blockMenuOptions.openedViaKeyboard
        },
        editorHeight: (meta === null || meta === void 0 ? void 0 : meta.editorHeight) ?? editorHeight,
        editorWidthLeft: (meta === null || meta === void 0 ? void 0 : meta.editorWidthLeft) ?? editorWidthLeft,
        editorWidthRight: (meta === null || meta === void 0 ? void 0 : meta.editorWidthRight) ?? editorWidthRight,
        isResizerResizing: isResizerResizing,
        isDocSizeLimitEnabled: $c9fcd5b34a5ec086$var$initialState.isDocSizeLimitEnabled,
        isPMDragging: (meta === null || meta === void 0 ? void 0 : meta.isPMDragging) ?? isPMDragging,
        multiSelectDnD: multiSelectDnD,
        lastDragCancelled: (meta === null || meta === void 0 ? void 0 : meta.lastDragCancelled) ?? lastDragCancelled,
        isSelectedViaDragHandle: isSelectedViaDragHandle
    };
};
const $c9fcd5b34a5ec086$export$ae829ec7b2625219 = (api, getIntl, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled = false, quickInsertButtonEnabled = true)=>{
    const { formatMessage: formatMessage } = getIntl();
    const isAdvancedLayoutEnabled = (0, $kaRof.editorExperiment)('advanced_layouts', true, {
        exposure: true
    });
    const toolbarFlagsEnabled = (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    const flags = {
        toolbarFlagsEnabled: toolbarFlagsEnabled
    };
    let anchorRectCache;
    if (!(0, $atuba.isAnchorSupported)()) anchorRectCache = new (0, $atuba.AnchorRectCache)();
    let resizeObserverWidth;
    let pragmaticCleanup = null;
    // Limited mode is a one-way latch, so its teardown must only run on the transition.
    const limitedModeTeardown = {
        done: false
    };
    // Edit transition and live-doc load paint the editor under a stationary pointer, which fires
    // mouseover before VC and never a mousemove. Ignore hover until the pointer moves.
    const ignoreRestingPointerHover = !(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && (0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $dRkX9.fg)('platform_editor_controls_reliable_anchor_patch_2');
    // When ignoreRestingPointerHover is false, this is always true, so hover is never suppressed.
    let pointerHasMoved = !ignoreRestingPointerHover;
    const onMouseOver = (view, event)=>{
        var _api$limitedMode3, _getNodeIdProvider;
        if (ignoreRestingPointerHover && !pointerHasMoved) return false;
        // Sparse surfaces handle all hover in bindSparseGutterHover, which also covers the gutters
        // outside view.dom.
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) return false;
        if (api !== null && api !== void 0 && (_api$limitedMode3 = api.limitedMode) !== null && _api$limitedMode3 !== void 0 && (_api$limitedMode3 = _api$limitedMode3.sharedState.currentState()) !== null && _api$limitedMode3 !== void 0 && _api$limitedMode3.enabled) return;
        // another layer of protection to prevent handling mouseover
        // when native anchor with dnd is enabled in limited mode
        // in case there are descripancies between getNodeIdProvider limited mode state
        if ((_getNodeIdProvider = (0, $2sOQK.getNodeIdProvider)(view)) !== null && _getNodeIdProvider !== void 0 && _getNodeIdProvider.isLimitedMode() && (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) return;
        (0, $gqrsA.handleMouseOver)(view, event, api);
        return false;
    };
    return new (0, $1y7gE.SafePlugin)({
        key: $c9fcd5b34a5ec086$export$df61b30b684217c0,
        state: {
            init: ()=>({
                    ...$c9fcd5b34a5ec086$var$initialState
                }),
            apply: (tr, currentState, _, newState)=>$c9fcd5b34a5ec086$export$5635d7ef4b8fee1c(api, formatMessage, tr, currentState, newState, flags, nodeViewPortalProviderAPI, nodeDecorationRegistry, rightSideControlsEnabled, quickInsertButtonEnabled, anchorRectCache, resizeObserverWidth, pragmaticCleanup, limitedModeTeardown)
        },
        props: {
            decorations: (state)=>{
                var _api$limitedMode4, _api$editorDisabled, _key$getState2, _api$editorViewMode3;
                if (api !== null && api !== void 0 && (_api$limitedMode4 = api.limitedMode) !== null && _api$limitedMode4 !== void 0 && (_api$limitedMode4 = _api$limitedMode4.sharedState.currentState()) !== null && _api$limitedMode4 !== void 0 && _api$limitedMode4.enabled) return;
                const isDisabled = api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 || (_api$editorDisabled = _api$editorDisabled.sharedState.currentState()) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.editorDisabled;
                if (isDisabled) {
                    var _api$editorViewMode2;
                    // Hide decorations when disabled, except in view mode when right-side controls are enabled
                    if (!rightSideControlsEnabled || (api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 || (_api$editorViewMode2 = _api$editorViewMode2.sharedState.currentState()) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.mode) !== 'view') return;
                }
                let decorationSet = (_key$getState2 = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(state)) === null || _key$getState2 === void 0 ? void 0 : _key$getState2.decorations;
                // In view mode with right-side controls, remove any lingering drag-handle decorations
                // (created in edit mode) that may not have been cleaned up on mode switch.
                if (decorationSet && !(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && rightSideControlsEnabled && (api === null || api === void 0 || (_api$editorViewMode3 = api.editorViewMode) === null || _api$editorViewMode3 === void 0 || (_api$editorViewMode3 = _api$editorViewMode3.sharedState.currentState()) === null || _api$editorViewMode3 === void 0 ? void 0 : _api$editorViewMode3.mode) === 'view') {
                    const handleDecs = (0, $50s88.findHandleDec)(decorationSet, 0, state.doc.content.size);
                    if (handleDecs.length > 0) decorationSet = decorationSet.remove(handleDecs);
                }
                return decorationSet;
            },
            handleDOMEvents: {
                drop (view, event) {
                    var _pluginState, _pluginState2, _pluginState3, _event$target, _event$target$closest;
                    // Prevent native DnD from triggering if we are in drag
                    const { dispatch: dispatch, dragging: dragging, state: state } = view;
                    const tr = state.tr;
                    let pluginState = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(state);
                    const dndDragCancelled = (_pluginState = pluginState) === null || _pluginState === void 0 ? void 0 : _pluginState.lastDragCancelled;
                    if ((_pluginState2 = pluginState) !== null && _pluginState2 !== void 0 && _pluginState2.isPMDragging || dndDragCancelled) {
                        if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                            var _api$metrics2;
                            api === null || api === void 0 || (_api$metrics2 = api.metrics) === null || _api$metrics2 === void 0 || _api$metrics2.commands.startActiveSessionTimer()({
                                tr: tr
                            });
                        }
                        dispatch(tr.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                            ...tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0),
                            isPMDragging: false,
                            lastDragCancelled: false
                        }));
                    }
                    pluginState = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(view.state);
                    if (!(event.target instanceof HTMLElement) || !((_pluginState3 = pluginState) !== null && _pluginState3 !== void 0 && _pluginState3.activeNode)) return false;
                    // Currently we can only drag one node at a time
                    // so we only need to check first child
                    const draggable = dragging === null || dragging === void 0 ? void 0 : dragging.slice.content.firstChild;
                    if (dndDragCancelled || (draggable === null || draggable === void 0 ? void 0 : draggable.type.name) === 'layoutColumn') {
                        // we prevent native DnD for layoutColumn to prevent single column layout.
                        event.preventDefault();
                        return false;
                    }
                    const nodeElement = (_event$target = event.target) === null || _event$target === void 0 || (_event$target$closest = _event$target.closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, `[${(0, $dj84o.getAnchorAttrName)()}]`);
                    if (!nodeElement) return false;
                    // TODO: ED-26959 - Review usage of posAtDOM here
                    const domPos = Math.max(view.posAtDOM(nodeElement, 0) - 1, 0);
                    const nodeTarget = state.doc.nodeAt(domPos);
                    const isSameNode = !!(nodeTarget && draggable !== null && draggable !== void 0 && draggable.eq(nodeTarget));
                    if (isSameNode) {
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                dragenter (view, event) {
                    var _api$limitedMode5, _key$getState3;
                    if (api !== null && api !== void 0 && (_api$limitedMode5 = api.limitedMode) !== null && _api$limitedMode5 !== void 0 && (_api$limitedMode5 = _api$limitedMode5.sharedState.currentState()) !== null && _api$limitedMode5 !== void 0 && _api$limitedMode5.enabled) return;
                    // Only process dragenter for block control drags.
                    // Other drag types (e.g. table row) should not create
                    // drop target decorations or emit active anchors.
                    if (!((_key$getState3 = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(view.state)) !== null && _key$getState3 !== void 0 && _key$getState3.isDragging)) return;
                    if ($c9fcd5b34a5ec086$var$isHTMLElement(event.target) && (0, $aEmSo.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
                        const targetElement = event.target.closest('[data-prosemirror-node-name]');
                        if (targetElement) {
                            var _api$blockControls$sh;
                            const nodeTypeName = targetElement === null || targetElement === void 0 ? void 0 : targetElement.getAttribute('data-prosemirror-node-name');
                            const pos = view.posAtDOM(targetElement, -1);
                            const currentActiveDropTargetNode = api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.activeDropTargetNode;
                            if ((currentActiveDropTargetNode === null || currentActiveDropTargetNode === void 0 ? void 0 : currentActiveDropTargetNode.pos) !== pos || (currentActiveDropTargetNode === null || currentActiveDropTargetNode === void 0 ? void 0 : currentActiveDropTargetNode.nodeTypeName) !== nodeTypeName) {
                                const activeDropTargetNode = {
                                    pos: pos,
                                    nodeTypeName: nodeTypeName
                                };
                                view.dispatch(view.state.tr.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                                    activeDropTargetNode: activeDropTargetNode
                                }));
                            }
                        }
                    } else if (isAdvancedLayoutEnabled) {
                        if ($c9fcd5b34a5ec086$var$isHTMLElement(event.target)) {
                            const closestParentElement = event.target.closest('[data-drag-handler-anchor-depth="0"]');
                            if (closestParentElement) {
                                const currentAnchor = closestParentElement.getAttribute((0, $dj84o.getAnchorAttrName)());
                                if (currentAnchor) (0, $3xl1j.defaultActiveAnchorTracker).emit(currentAnchor);
                            }
                        }
                    }
                },
                dragstart (view) {
                    var _api$limitedMode6, _anchorRectCache2;
                    if (api !== null && api !== void 0 && (_api$limitedMode6 = api.limitedMode) !== null && _api$limitedMode6 !== void 0 && (_api$limitedMode6 = _api$limitedMode6.sharedState.currentState()) !== null && _api$limitedMode6 !== void 0 && _api$limitedMode6.enabled) return;
                    if (isAdvancedLayoutEnabled) (0, $3xl1j.defaultActiveAnchorTracker).reset();
                    if ((0, $aEmSo.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true)) {
                        var _anchorRectCache;
                        (_anchorRectCache = anchorRectCache) === null || _anchorRectCache === void 0 || _anchorRectCache.clear();
                    }
                    (_anchorRectCache2 = anchorRectCache) === null || _anchorRectCache2 === void 0 || _anchorRectCache2.setEditorView(view);
                    view.dispatch(view.state.tr.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                        ...view.state.tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0),
                        isPMDragging: true
                    }));
                },
                dragend (view) {
                    var _api$limitedMode7, _key$getState4;
                    if (api !== null && api !== void 0 && (_api$limitedMode7 = api.limitedMode) !== null && _api$limitedMode7 !== void 0 && (_api$limitedMode7 = _api$limitedMode7.sharedState.currentState()) !== null && _api$limitedMode7 !== void 0 && _api$limitedMode7.enabled) return;
                    const { state: state, dispatch: dispatch } = view;
                    if ((_key$getState4 = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(state)) !== null && _key$getState4 !== void 0 && _key$getState4.isPMDragging) {
                        const tr = state.tr;
                        tr.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                            ...state.tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0),
                            isPMDragging: false
                        });
                        if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                            var _api$metrics3;
                            api === null || api === void 0 || (_api$metrics3 = api.metrics) === null || _api$metrics3 === void 0 || _api$metrics3.commands.startActiveSessionTimer()({
                                tr: tr
                            });
                        }
                        dispatch(tr);
                    }
                },
                mouseover: onMouseOver,
                mousedown: (view, event)=>{
                    var _api$limitedMode8;
                    if (api !== null && api !== void 0 && (_api$limitedMode8 = api.limitedMode) !== null && _api$limitedMode8 !== void 0 && (_api$limitedMode8 = _api$limitedMode8.sharedState.currentState()) !== null && _api$limitedMode8 !== void 0 && _api$limitedMode8.enabled) return;
                    return (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $l09lv.handleMouseDown)(api)(view, event) : undefined;
                },
                keydown (view, event) {
                    var _api$limitedMode9;
                    if (api !== null && api !== void 0 && (_api$limitedMode9 = api.limitedMode) !== null && _api$limitedMode9 !== void 0 && (_api$limitedMode9 = _api$limitedMode9.sharedState.currentState()) !== null && _api$limitedMode9 !== void 0 && _api$limitedMode9.enabled) return;
                    if (event.shiftKey && event.ctrlKey) //prevent holding down key combo from firing repeatedly
                    {
                        if (!event.repeat && (0, $gUxz5.boundKeydownHandler)(api, formatMessage)(view, event)) {
                            event.preventDefault();
                            return true;
                        }
                    }
                    if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof HTMLElement && (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) {
                        const isDragHandle = event.target.closest((0, $gCPs3.DRAG_HANDLE_SELECTOR)) !== null;
                        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.blockControls.commands.setSelectedViaDragHandle(isDragHandle));
                    }
                    if ((event.key === 'ArrowLeft' || event.key === 'ArrowRight' || event.key === 'ArrowDown' || event.key === 'ArrowUp') && (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) {
                        var _api$blockControls$sh2, _api$blockControls$sh3;
                        const isBlockMenuOpen = api === null || api === void 0 || (_api$blockControls$sh2 = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh2 === void 0 ? void 0 : _api$blockControls$sh2.isMenuOpen;
                        // when block menu is just open, and we press arrow keys, we want to use the arrow keys to navigate the block menu
                        // in this scenario, isSelectedViaDragHandle should not be set to false
                        if (api !== null && api !== void 0 && (_api$blockControls$sh3 = api.blockControls.sharedState.currentState()) !== null && _api$blockControls$sh3 !== void 0 && _api$blockControls$sh3.isSelectedViaDragHandle && !isBlockMenuOpen) api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.blockControls.commands.setSelectedViaDragHandle(false));
                    }
                    return false;
                },
                blur (view, event) {
                    var _api$limitedMode0;
                    if (api !== null && api !== void 0 && (_api$limitedMode0 = api.limitedMode) !== null && _api$limitedMode0 !== void 0 && (_api$limitedMode0 = _api$limitedMode0.sharedState.currentState()) !== null && _api$limitedMode0 !== void 0 && _api$limitedMode0.enabled) return;
                    if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) {
                        var _api$core2;
                        // Focus moving into the registry surface remains inside the editor experience.
                        const isChildOfSurface = (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest((0, $GIvev.BLOCK_CONTROLS_SURFACE_SELECTOR)) !== null;
                        const shouldPreserveRemixInlineDropdownFocus = event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[data-editor-remix-inline-dropdown-preserve-focus]') !== null;
                        const isChildOfEditor = event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest(`#${(0, $aqnCQ.EDIT_AREA_ID)}`) !== null;
                        // don't do anything if the event relatedTarget (the element receiving focus) is a child of the editor
                        // or if the editor has focus
                        if (isChildOfEditor || isChildOfSurface || shouldPreserveRemixInlineDropdownFocus || view.hasFocus()) return false;
                        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
                            const currMeta = tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0);
                            tr.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                                ...currMeta,
                                editorBlurred: true
                            });
                            return tr;
                        });
                        return false;
                    }
                }
            }
        },
        view: (editorView)=>{
            const dom = editorView.dom;
            const editorContentArea = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
            // Use ResizeObserver to observe resizer (scroll-parent typically grows when resizing) and editor width changes
            resizeObserverWidth = new ResizeObserver((0, $PIUl3.default)((entries)=>{
                const pluginState = $c9fcd5b34a5ec086$export$df61b30b684217c0.getState(editorView.state);
                if (!(pluginState !== null && pluginState !== void 0 && pluginState.isDragging)) {
                    const isResizerResizing = !!dom.querySelector('.is-resizing');
                    const transaction = editorView.state.tr;
                    let shouldDispatch = false;
                    if ((pluginState === null || pluginState === void 0 ? void 0 : pluginState.isResizerResizing) !== isResizerResizing) {
                        transaction.setMeta('is-resizer-resizing', isResizerResizing);
                        shouldDispatch = true;
                    }
                    // Registry surfaces have their own ResizeObservers and absolute placement.
                    // Width metadata only drives legacy widget recreation.
                    if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') && !isResizerResizing) {
                        const editorContentArea = entries[0].target;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthRight = editorContentArea.getBoundingClientRect().right;
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const editorWidthLeft = editorContentArea.getBoundingClientRect().left;
                        transaction.setMeta($c9fcd5b34a5ec086$export$df61b30b684217c0, {
                            ...transaction.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0),
                            editorWidthLeft: editorWidthLeft,
                            editorWidthRight: editorWidthRight
                        });
                        shouldDispatch = true;
                    }
                    if (shouldDispatch) editorView.dispatch(transaction);
                }
            }));
            const shouldObserve = !((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) || !(0, $atuba.isAnchorSupported)();
            if (editorContentArea && shouldObserve) resizeObserverWidth.observe(editorContentArea);
            // Start pragmatic monitors
            pragmaticCleanup = $c9fcd5b34a5ec086$var$destroyFn(api);
            let unbindMouseMove;
            // When ignoreRestingPointerHover is false, pointerHasMoved is always true, so we never
            // bind. Once the pointer has moved there is nothing left to un-latch.
            if (!pointerHasMoved) unbindMouseMove = (0, $6Zi52.bind)(editorView.dom, {
                type: 'mousemove',
                listener: (event)=>{
                    var _unbindMouseMove;
                    pointerHasMoved = true;
                    (_unbindMouseMove = unbindMouseMove) === null || _unbindMouseMove === void 0 || _unbindMouseMove();
                    onMouseOver(editorView, event);
                },
                options: {
                    once: true,
                    passive: true
                }
            });
            return {
                destroy () {
                    var _unbindMouseMove2, _pragmaticCleanup;
                    (_unbindMouseMove2 = unbindMouseMove) === null || _unbindMouseMove2 === void 0 || _unbindMouseMove2();
                    if (editorContentArea) resizeObserverWidth.unobserve(editorContentArea);
                    (_pragmaticCleanup = pragmaticCleanup) === null || _pragmaticCleanup === void 0 || _pragmaticCleanup();
                }
            };
        }
    });
};
const $c9fcd5b34a5ec086$export$e75bc9902db1596f = (tr)=>{
    return tr.getMeta($c9fcd5b34a5ec086$export$df61b30b684217c0);
};

});
parcelRegister("GIvev", function(module, exports) {
$parcel$export(module.exports, "ACTIVE_DRAG_HANDLE_ATTR", () => $74a82a6ffdd4b523$export$3c415fc37e843546);
$parcel$export(module.exports, "ACTIVE_QUICK_INSERT_ATTR", () => $74a82a6ffdd4b523$export$e9f85d19bcc65a35);
$parcel$export(module.exports, "BLOCK_CONTROLS_SURFACE_SELECTOR", () => $74a82a6ffdd4b523$export$d2253616b100a50f);
$parcel$export(module.exports, "ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME", () => $74a82a6ffdd4b523$export$2993f0134faf61b5);
$parcel$export(module.exports, "ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME", () => $74a82a6ffdd4b523$export$78e6503524c3440d);
$parcel$export(module.exports, "DRAG_HANDLE_HEIGHT", () => $74a82a6ffdd4b523$export$f373eda827748b3);
$parcel$export(module.exports, "DRAG_HANDLE_BORDER_RADIUS", () => $74a82a6ffdd4b523$export$aa77a5cc2a5f88a7);
$parcel$export(module.exports, "DRAG_HANDLE_ZINDEX", () => $74a82a6ffdd4b523$export$5ad27d778a09d25c);
$parcel$export(module.exports, "DRAG_HANDLE_MAX_WIDTH_PLUS_GAP", () => $74a82a6ffdd4b523$export$f0af6742db040d57);
$parcel$export(module.exports, "DRAG_HANDLE_DIVIDER_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$d2a2373f7346fed2);
$parcel$export(module.exports, "DRAG_HANDLE_H1_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$d5bafa9c4e821a51);
$parcel$export(module.exports, "DRAG_HANDLE_H2_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$1e2b3336ca8c087c);
$parcel$export(module.exports, "DRAG_HANDLE_H4_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$7ca48bd6d02a13e0);
$parcel$export(module.exports, "DRAG_HANDLE_H5_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$40d0d70c288e6373);
$parcel$export(module.exports, "DRAG_HANDLE_H6_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$51dbe10140b62321);
$parcel$export(module.exports, "DRAG_HANDLE_PARAGRAPH_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$2d43c475787cc3b2);
$parcel$export(module.exports, "DRAG_HANDLE_PARAGRAPH_SMALL_TOP_ADJUSTMENT", () => $74a82a6ffdd4b523$export$bd30577e4ba2fc75);
$parcel$export(module.exports, "STICKY_CONTROLS_TOP_MARGIN", () => $74a82a6ffdd4b523$export$acab25f15fd410d6);
$parcel$export(module.exports, "STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER", () => $74a82a6ffdd4b523$export$355f64931df48ac6);
$parcel$export(module.exports, "QUICK_INSERT_HEIGHT", () => $74a82a6ffdd4b523$export$b2fc508ca59eba40);
$parcel$export(module.exports, "QUICK_INSERT_WIDTH", () => $74a82a6ffdd4b523$export$c5ab994ee6fdf098);
$parcel$export(module.exports, "QUICK_INSERT_DIMENSIONS", () => $74a82a6ffdd4b523$export$8b6a8ea78955a3a3);
$parcel$export(module.exports, "QUICK_INSERT_LEFT_OFFSET", () => $74a82a6ffdd4b523$export$37704ab652bb303e);
$parcel$export(module.exports, "dragHandleGap", () => $74a82a6ffdd4b523$export$e5ea166c620fdfb2);
$parcel$export(module.exports, "rootElementGap", () => $74a82a6ffdd4b523$export$5002400b4eb1f7c6);
$parcel$export(module.exports, "getNestedNodeLeftPaddingMargin", () => $74a82a6ffdd4b523$export$5721e547e9b6cc17);
$parcel$export(module.exports, "topPositionAdjustment", () => $74a82a6ffdd4b523$export$403b33ae238c7c59);
$parcel$export(module.exports, "spacingBetweenNodesForPreview", () => $74a82a6ffdd4b523$export$67c6a77242c01faa);
$parcel$export(module.exports, "nodeMargins", () => $74a82a6ffdd4b523$export$ffe7e67ee4ab1502);
$parcel$export(module.exports, "DEFAULT_COLUMN_DISTRIBUTIONS", () => $74a82a6ffdd4b523$export$d77e6458bbcae98b);

var $gCPs3 = parcelRequire("gCPs3");

var $fHKn6 = parcelRequire("fHKn6");
var $4QjyN = parcelRequire("4QjyN");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");
const $74a82a6ffdd4b523$export$3c415fc37e843546 = 'data-active-drag-handle';
const $74a82a6ffdd4b523$export$e9f85d19bcc65a35 = 'data-active-quick-insert';
const $74a82a6ffdd4b523$export$d2253616b100a50f = '[data-editor-block-controls-surface]';
const $74a82a6ffdd4b523$export$2993f0134faf61b5 = '--editor-block-controls-active-drag-handle-anchor';
const $74a82a6ffdd4b523$export$78e6503524c3440d = '--editor-block-controls-active-quick-insert-anchor';
const $74a82a6ffdd4b523$export$f373eda827748b3 = 24;
const $74a82a6ffdd4b523$export$aa77a5cc2a5f88a7 = 4;
const $74a82a6ffdd4b523$export$5ad27d778a09d25c = (0, $014x6.akRichMediaResizeZIndex) + (0, $014x6.akEditorUnitZIndex); //place above legacy resizer
const $74a82a6ffdd4b523$var$LEGACY_DRAG_HANDLE_DEFAULT_GAP = 8;
const $74a82a6ffdd4b523$var$MIGRATED_DRAG_HANDLE_DEFAULT_GAP = 12;
const $74a82a6ffdd4b523$export$afbc9d6595284dfa = 4;
const $74a82a6ffdd4b523$export$28e15aedc0c878e3 = 12;
const $74a82a6ffdd4b523$export$e4842b8390e65360 = 2.5;
const $74a82a6ffdd4b523$export$f0af6742db040d57 = (0, $gCPs3.DRAG_HANDLE_WIDTH) + $74a82a6ffdd4b523$export$28e15aedc0c878e3;
// Non-resizable/default-sized nodes get the same gap as resizable/breakout nodes
// (DRAG_HANDLE_MAX_GAP) once the registry-backed surfaces are on; kept at the legacy value
// otherwise to avoid an unrelated visual change for consumers still on the old decoration path.
const $74a82a6ffdd4b523$var$getDragHandleDefaultGap = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $74a82a6ffdd4b523$var$MIGRATED_DRAG_HANDLE_DEFAULT_GAP : $74a82a6ffdd4b523$var$LEGACY_DRAG_HANDLE_DEFAULT_GAP;
const $74a82a6ffdd4b523$export$d2a2373f7346fed2 = 6; // 4px for the divider vertical padding and 2px for the divider height
const $74a82a6ffdd4b523$export$d5bafa9c4e821a51 = 5;
const $74a82a6ffdd4b523$export$1e2b3336ca8c087c = 2;
const $74a82a6ffdd4b523$export$f8ee0d00a7415eee = 1;
const $74a82a6ffdd4b523$export$7ca48bd6d02a13e0 = 3;
const $74a82a6ffdd4b523$export$40d0d70c288e6373 = 3;
const $74a82a6ffdd4b523$export$51dbe10140b62321 = 3;
const $74a82a6ffdd4b523$export$45051ba26713425e = 8;
const $74a82a6ffdd4b523$export$2d43c475787cc3b2 = 2;
const $74a82a6ffdd4b523$export$bd30577e4ba2fc75 = 0;
const $74a82a6ffdd4b523$export$47dad309b5731d64 = 8;
const $74a82a6ffdd4b523$export$acab25f15fd410d6 = 8;
const $74a82a6ffdd4b523$export$355f64931df48ac6 = 24;
const $74a82a6ffdd4b523$export$b2fc508ca59eba40 = 24;
const $74a82a6ffdd4b523$export$c5ab994ee6fdf098 = 24;
const $74a82a6ffdd4b523$export$8b6a8ea78955a3a3 = {
    width: $74a82a6ffdd4b523$export$c5ab994ee6fdf098,
    height: $74a82a6ffdd4b523$export$b2fc508ca59eba40
};
const $74a82a6ffdd4b523$export$37704ab652bb303e = 16;
const $74a82a6ffdd4b523$var$nodeTypeExcludeList = [
    'embedCard',
    'mediaSingle',
    'table'
];
const $74a82a6ffdd4b523$export$e5ea166c620fdfb2 = (nodeType, parentNodeType)=>{
    if (parentNodeType === 'syncBlock' || parentNodeType === 'bodiedSyncBlock') return $74a82a6ffdd4b523$export$e4842b8390e65360;
    if (parentNodeType && parentNodeType !== 'doc') return $74a82a6ffdd4b523$export$afbc9d6595284dfa;
    let breakoutResizableNodesList = [];
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) breakoutResizableNodesList = (0, $4QjyN.getBreakoutResizableNodes)();
    else breakoutResizableNodesList = (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $fHKn6.breakoutResizableNodes),
        'rule',
        'panel'
    ] : (0, $fHKn6.breakoutResizableNodes);
    if (breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $74a82a6ffdd4b523$export$28e15aedc0c878e3 + 20;
        else return $74a82a6ffdd4b523$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $74a82a6ffdd4b523$var$getDragHandleDefaultGap() + 20;
    if ($74a82a6ffdd4b523$var$nodeTypeExcludeList.includes(nodeType)) return $74a82a6ffdd4b523$export$28e15aedc0c878e3;
    return $74a82a6ffdd4b523$var$getDragHandleDefaultGap();
};
const $74a82a6ffdd4b523$export$5002400b4eb1f7c6 = (nodeType)=>{
    let breakoutResizableNodesList = [];
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) breakoutResizableNodesList = (0, $4QjyN.getBreakoutResizableNodes)();
    else breakoutResizableNodesList = (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) ? [
        ...(0, $fHKn6.breakoutResizableNodes),
        'rule',
        'panel'
    ] : (0, $fHKn6.breakoutResizableNodes);
    if ($74a82a6ffdd4b523$var$nodeTypeExcludeList.includes(nodeType) || breakoutResizableNodesList.includes(nodeType)) {
        if (nodeType === 'layoutSection') return $74a82a6ffdd4b523$export$28e15aedc0c878e3 + 20;
        else return $74a82a6ffdd4b523$export$28e15aedc0c878e3;
    }
    if (nodeType === 'layoutSection') return $74a82a6ffdd4b523$export$28e15aedc0c878e3 + 12;
    return $74a82a6ffdd4b523$var$getDragHandleDefaultGap();
};
const $74a82a6ffdd4b523$export$5721e547e9b6cc17 = (nodeType)=>{
    switch(nodeType){
        case 'bodiedExtension':
            return '28px';
        case 'multiBodiedExtension':
            if ((0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '28px';
            return `${(0, $gCPs3.DRAG_HANDLE_WIDTH) + $74a82a6ffdd4b523$export$afbc9d6595284dfa}px`;
        case 'expand':
        case 'nestedExpand':
            return '24px';
        case 'layoutColumn':
            return '20px';
        case 'panel':
            return '40px';
        case 'tableCell':
            return '8px';
        case 'tableHeader':
            return '8px';
        default:
            return `${(0, $gCPs3.DRAG_HANDLE_WIDTH) + $74a82a6ffdd4b523$export$afbc9d6595284dfa}px`;
    }
};
const $74a82a6ffdd4b523$export$403b33ae238c7c59 = (nodeType, layout)=>{
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) switch(nodeType){
        case 'layoutSection':
            return $74a82a6ffdd4b523$export$45051ba26713425e;
    }
    if ((nodeType === 'mediaSingle' || nodeType === 'embedCard') && layout && [
        'wrap-left',
        'wrap-right'
    ].includes(layout)) return $74a82a6ffdd4b523$export$47dad309b5731d64;
    switch(nodeType){
        case 'rule':
            return -$74a82a6ffdd4b523$export$d2a2373f7346fed2;
        case 'table':
            return $74a82a6ffdd4b523$export$f373eda827748b3;
        case 'paragraph':
            return $74a82a6ffdd4b523$export$2d43c475787cc3b2;
        case 'paragraph-small':
            return $74a82a6ffdd4b523$export$bd30577e4ba2fc75;
        case 'heading-1':
            return $74a82a6ffdd4b523$export$d5bafa9c4e821a51;
        case 'heading-2':
            return $74a82a6ffdd4b523$export$1e2b3336ca8c087c;
        case 'heading-3':
            return -$74a82a6ffdd4b523$export$f8ee0d00a7415eee;
        case 'heading-4':
            return -$74a82a6ffdd4b523$export$7ca48bd6d02a13e0;
        case 'heading-5':
            return -$74a82a6ffdd4b523$export$40d0d70c288e6373;
        case 'heading-6':
            return -$74a82a6ffdd4b523$export$51dbe10140b62321;
        default:
            return 0;
    }
};
const $74a82a6ffdd4b523$export$67c6a77242c01faa = {
    paragraph: {
        top: '0.75rem',
        bottom: '0'
    },
    heading1: {
        top: '1.45833em',
        bottom: '0'
    },
    heading2: {
        top: '1.4em',
        bottom: '0'
    },
    heading3: {
        top: '1.31249em',
        bottom: '0'
    },
    heading4: {
        top: '1.25em',
        bottom: '0'
    },
    heading5: {
        top: '1.45833em',
        bottom: '0'
    },
    heading6: {
        top: '1.59091em',
        bottom: '0'
    },
    table: {
        top: '0',
        bottom: '0'
    },
    bulletList: {
        top: '10px',
        bottom: '0'
    },
    orderedList: {
        top: '10px',
        bottom: '0'
    },
    decisionList: {
        top: '0.5rem',
        bottom: '0'
    },
    taskList: {
        top: '0.75rem',
        bottom: '0'
    },
    codeBlock: {
        top: '0.75rem',
        bottom: '0'
    },
    panel: {
        top: '0.75rem',
        bottom: '0'
    },
    rule: {
        top: '1.5rem',
        bottom: '1.5rem'
    },
    mediaSingle: {
        top: '24px',
        bottom: '24px'
    },
    media: {
        top: '24px',
        bottom: '24px'
    },
    bodiedExtension: {
        top: '0',
        bottom: '0'
    },
    multiBodiedExtension: {
        top: '0',
        bottom: '0'
    },
    extension: {
        top: '0',
        bottom: '0'
    },
    layoutSection: {
        top: '0',
        bottom: '0'
    },
    blockquote: {
        top: '0',
        bottom: '0'
    },
    embedCard: {
        top: '24px',
        bottom: '24px'
    },
    blockCard: {
        top: '0.75rem',
        bottom: '0'
    },
    default: {
        top: '0',
        bottom: '0'
    }
};
const $74a82a6ffdd4b523$export$ffe7e67ee4ab1502 = {
    table: {
        top: 24,
        bottom: 16
    },
    paragraph: {
        top: 12,
        bottom: 6
    },
    bulletList: {
        top: 16,
        bottom: 0
    },
    orderedList: {
        top: 16,
        bottom: 0
    },
    decisionList: {
        top: 12,
        bottom: 0
    },
    taskList: {
        top: 8,
        bottom: 0
    },
    codeBlock: {
        top: 12,
        bottom: 0
    },
    panel: {
        top: 8,
        bottom: 0
    },
    rule: {
        top: 24,
        bottom: 24
    },
    mediaSingle: {
        top: 24,
        bottom: 24
    },
    media: {
        top: 24,
        bottom: 24
    },
    bodiedExtension: {
        top: 0,
        bottom: 0
    },
    multiBodiedExtension: {
        top: 0,
        bottom: 0
    },
    extension: {
        top: 12,
        bottom: 12
    },
    heading1: {
        top: 40,
        bottom: 0
    },
    heading2: {
        top: 40,
        bottom: 0
    },
    heading3: {
        top: 36,
        bottom: 0
    },
    heading4: {
        top: 22,
        bottom: 0
    },
    heading5: {
        top: 22,
        bottom: 0
    },
    heading6: {
        top: 18,
        bottom: 0
    },
    layoutSection: {
        top: 8,
        bottom: 0
    },
    blockquote: {
        top: 12,
        bottom: 0
    },
    expand: {
        top: 4,
        bottom: 0
    },
    nestedExpand: {
        top: 1,
        bottom: 0
    },
    default: {
        top: 0,
        bottom: 0
    }
};
const $74a82a6ffdd4b523$export$d77e6458bbcae98b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};

});

parcelRegister("dj84o", function(module, exports) {
$parcel$export(module.exports, "NODE_ANCHOR_ATTR_NAME", () => $59e51e689e2a69de$export$ea34df48337a3b78);
$parcel$export(module.exports, "NODE_NODE_TYPE_ATTR_NAME", () => $59e51e689e2a69de$export$195bd9e1fd438938);
$parcel$export(module.exports, "getAnchorAttrName", () => $59e51e689e2a69de$export$684dbfb461b166c3);
$parcel$export(module.exports, "getTypeNameAttrName", () => $59e51e689e2a69de$export$916bc5085eed228a);
$parcel$export(module.exports, "getTypeNameFromDom", () => $59e51e689e2a69de$export$374251d21964e516);

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");
const $59e51e689e2a69de$export$ea34df48337a3b78 = 'data-node-anchor';
const $59e51e689e2a69de$export$195bd9e1fd438938 = 'data-prosemirror-node-name';
const $59e51e689e2a69de$export$684dbfb461b166c3 = ()=>{
    if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) return $59e51e689e2a69de$export$ea34df48337a3b78;
    return 'data-drag-handler-anchor-name';
};
const $59e51e689e2a69de$export$916bc5085eed228a = ()=>{
    if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) return $59e51e689e2a69de$export$195bd9e1fd438938;
    return 'data-drag-handler-node-type';
};
const $59e51e689e2a69de$var$isHeadingElement = (element)=>{
    const headingTags = [
        'H1',
        'H2',
        'H3',
        'H4',
        'H5',
        'H6'
    ];
    return headingTags.includes(element.tagName);
};
const $59e51e689e2a69de$export$374251d21964e516 = (element)=>{
    if (!element) return '';
    const nodeType = element === null || element === void 0 ? void 0 : element.getAttribute($59e51e689e2a69de$export$195bd9e1fd438938);
    if (!nodeType) return '';
    if ($59e51e689e2a69de$var$isHeadingElement(element)) switch(element.tagName){
        case 'H1':
            return 'heading-1';
        case 'H2':
            return 'heading-2';
        case 'H3':
            return 'heading-3';
        case 'H4':
            return 'heading-4';
        case 'H5':
            return 'heading-5';
        case 'H6':
            return 'heading-6';
    }
    return nodeType;
};

});

parcelRegister("2xAfa", function(module, exports) {
$parcel$export(module.exports, "IGNORE_NODES_NEXT", () => $d026a6a2400259e8$export$4b59c90449151b37);
$parcel$export(module.exports, "IGNORE_NODE_DESCENDANTS_ADVANCED_LAYOUT", () => $d026a6a2400259e8$export$9cba0273af9f9727);
$parcel$export(module.exports, "findNodeDecs", () => $d026a6a2400259e8$export$562fc95beb8a58d3);
$parcel$export(module.exports, "nodeDecorations", () => $d026a6a2400259e8$export$a3bb13b1e97d70c7);

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $61p1X = parcelRequire("61p1X");
const $d026a6a2400259e8$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption',
    'layoutColumn'
];
const $d026a6a2400259e8$export$4b59c90449151b37 = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'listItem',
    'caption'
];
const $d026a6a2400259e8$var$IGNORE_NODE_DESCENDANTS = [
    'listItem',
    'taskList',
    'decisionList',
    'mediaSingle'
];
const $d026a6a2400259e8$export$9cba0273af9f9727 = [
    'listItem',
    'taskList',
    'decisionList'
];
const $d026a6a2400259e8$export$d43a1c4953e0600e = (node)=>{
    // Optimisation to avoid drawing node decorations for empty table cells
    if ([
        'tableCell',
        'tableHeader'
    ].includes(node.type.name)) {
        var _node$firstChild;
        if (node.childCount === 1 && ((_node$firstChild = node.firstChild) === null || _node$firstChild === void 0 ? void 0 : _node$firstChild.type.name) === 'paragraph' && node.firstChild.childCount === 0) return false;
    }
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) return !$d026a6a2400259e8$export$9cba0273af9f9727.includes(node.type.name);
    return !$d026a6a2400259e8$var$IGNORE_NODE_DESCENDANTS.includes(node.type.name);
};
const $d026a6a2400259e8$var$shouldIgnoreNode = (node, ignore_nodes, depth, parent)=>{
    var _nodeTypes$table, _node$attrs, _node$attrs2;
    const nodeTypes = node.type.schema.nodes;
    const isTable = node.type.name === (nodeTypes === null || nodeTypes === void 0 || (_nodeTypes$table = nodeTypes.table) === null || _nodeTypes$table === void 0 ? void 0 : _nodeTypes$table.name);
    const parentIsTable = parent && [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
    const isNestedTable = isTable && parentIsTable;
    if (isNestedTable) return true;
    const isFirstTableRow = (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'table' && depth === 1 && node === parent.firstChild && 'tableRow' === node.type.name && (0, $kaRof.editorExperiment)('advanced_layouts', true);
    if (isFirstTableRow) return false;
    const isLegacyContentMacroExtension = node.type.name === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === 'com.atlassian.confluence.migration' && ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === 'legacy-content';
    if (isLegacyContentMacroExtension) return true;
    return ignore_nodes.includes(node.type.name);
};
const $d026a6a2400259e8$export$562fc95beb8a58d3 = (state, decorations, from, to)=>{
    let newFrom = from;
    let newTo = to;
    // make it non-inclusive
    if (newFrom !== undefined) newFrom++;
    // make it non-inclusive
    if (newTo !== undefined) newTo--;
    // return empty array if range reversed
    if (newFrom !== undefined && newTo !== undefined && newFrom > newTo) return [];
    return decorations.find(newFrom, newTo, (spec)=>spec.type === (0, $61p1X.TYPE_NODE_DEC));
};
const $d026a6a2400259e8$export$a3bb13b1e97d70c7 = (newState, from, to)=>{
    const decs = [];
    if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) return [];
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > newState.doc.nodeSize - 2 ? newState.doc.nodeSize - 2 : to;
    const ignore_nodes = (0, $kaRof.editorExperiment)('advanced_layouts', true) ? $d026a6a2400259e8$export$4b59c90449151b37 : $d026a6a2400259e8$var$IGNORE_NODES;
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, _)=>{
        let depth = 0;
        const shouldDescend = $d026a6a2400259e8$export$d43a1c4953e0600e(node);
        const anchorName = (0, $61p1X.getNodeAnchor)(node);
        const nodeTypeWithLevel = (0, $61p1X.getNodeTypeWithLevel)(node);
        // Doesn't descend into a node
        if (node.isInline) return false;
        depth = newState.doc.resolve(pos).depth;
        if ($d026a6a2400259e8$var$shouldIgnoreNode(node, ignore_nodes, depth, parent)) return shouldDescend; //skip over, don't consider it a valid depth
        const anchorStyles = `anchor-name: ${anchorName};`;
        decs.push((0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, {
            style: anchorStyles,
            ['data-drag-handler-anchor-name']: anchorName,
            ['data-drag-handler-node-type']: nodeTypeWithLevel,
            ['data-drag-handler-anchor-depth']: `${depth}`
        }, {
            type: (0, $61p1X.TYPE_NODE_DEC),
            anchorName: anchorName,
            nodeType: node.type.name,
            nodeTypeWithLevel: nodeTypeWithLevel
        }));
        return shouldDescend && depth < (0, $61p1X.NESTED_DEPTH);
    });
    return decs;
};

});
parcelRegister("61p1X", function(module, exports) {
$parcel$export(module.exports, "TYPE_DROP_TARGET_DEC", () => $b598970f26bcfad9$export$4a66a44681ab4c77);
$parcel$export(module.exports, "TYPE_HANDLE_DEC", () => $b598970f26bcfad9$export$eac9eb77d42744c8);
$parcel$export(module.exports, "TYPE_NODE_DEC", () => $b598970f26bcfad9$export$ab0e97a1d4f97633);
$parcel$export(module.exports, "NESTED_DEPTH", () => $b598970f26bcfad9$export$4a19606d812406a7);
$parcel$export(module.exports, "getNodeAnchor", () => $b598970f26bcfad9$export$20dcf6d6c6a1b068);
$parcel$export(module.exports, "getNodeTypeWithLevel", () => $b598970f26bcfad9$export$b0da2ac7a61aa72c);
$parcel$export(module.exports, "unmountDecorations", () => $b598970f26bcfad9$export$ad2994468d2cac1a);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eUgRu = parcelRequire("eUgRu");

var $e8CsO = parcelRequire("e8CsO");

var $aEmSo = parcelRequire("aEmSo");

var $5x24z = parcelRequire("5x24z");

var $8MRTx = parcelRequire("8MRTx");
const $b598970f26bcfad9$export$4a66a44681ab4c77 = 'drop-target-decoration';
const $b598970f26bcfad9$export$eac9eb77d42744c8 = 'drag-handle';
const $b598970f26bcfad9$export$ab0e97a1d4f97633 = 'node-decoration';
const $b598970f26bcfad9$export$4a19606d812406a7 = 100;
const $b598970f26bcfad9$export$20dcf6d6c6a1b068 = (node)=>{
    const handleId = $b598970f26bcfad9$var$ObjHash.getForNode(node);
    return `--node-anchor-${node.type.name}-${handleId}`;
};
const $b598970f26bcfad9$var$getSubType = (node)=>{
    if (node.attrs.level) return `-${node.attrs.level}`;
    if ((0, $8MRTx.isFontSizeMarkActive)(node)) return '-small';
    return '';
};
const $b598970f26bcfad9$export$b0da2ac7a61aa72c = (node)=>{
    const subType = $b598970f26bcfad9$var$getSubType(node);
    const typeName = (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $e8CsO.getBaseNodeTypeName)(node.type) : node.type.name;
    return typeName + subType;
};
class $b598970f26bcfad9$var$ObjHash {
    static #_ = this.caching = new WeakMap();
    static getForNode(node) {
        if (this.caching.has(node)) return this.caching.get(node);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const uniqueId = (0, $eUgRu.default)();
        this.caching.set(node, uniqueId);
        return uniqueId;
    }
}
const $b598970f26bcfad9$export$ad2994468d2cac1a = (nodeViewPortalProviderAPI, selector, key)=>{
    // Removing decorations manually instead of using native destroy function in prosemirror API
    // as it was more responsive and causes less re-rendering
    const decorationsToRemove = document.querySelectorAll(`[${selector}="true"]`);
    decorationsToRemove.forEach((el)=>{
        (0, $5x24z.unmountFromMountPoint)(el);
    });
};

});
parcelRegister("5x24z", function(module, exports) {
$parcel$export(module.exports, "renderToMountPoint", () => $471de6100f7810b6$export$1e102deeee8fa6ca);
$parcel$export(module.exports, "unmountFromMountPoint", () => $471de6100f7810b6$export$41348551f2ac3828);

var $bTkYf = parcelRequire("bTkYf");

var $dQotp = parcelRequire("dQotp");
/**
 * Shared registry of React roots created via `createRoot`.
 *
 * Both `decorations-drag-handle.ts` (render) and `decorations-common.ts`
 * (unmount) must operate on the **same** root for a given DOM element, so
 * the WeakMap lives here and is imported by both modules.
 */ const $471de6100f7810b6$var$reactRoots = new WeakMap();
const $471de6100f7810b6$export$1e102deeee8fa6ca = (element, mountPoint)=>{
    let root = $471de6100f7810b6$var$reactRoots.get(mountPoint);
    if (!root) {
        root = (0, $dQotp.createRoot)(mountPoint);
        $471de6100f7810b6$var$reactRoots.set(mountPoint, root);
    }
    const activeRoot = root;
    (0, $bTkYf.flushSync)(()=>activeRoot.render(element));
};
const $471de6100f7810b6$export$41348551f2ac3828 = (mountPoint)=>{
    const root = $471de6100f7810b6$var$reactRoots.get(mountPoint);
    if (root) {
        root.unmount();
        $471de6100f7810b6$var$reactRoots.delete(mountPoint);
    }
};

});

parcelRegister("8MRTx", function(module, exports) {
$parcel$export(module.exports, "isInsideTable", () => $51ebc5031c8c643c$export$199dae4875feadcd);
$parcel$export(module.exports, "isFontSizeMarkActive", () => $51ebc5031c8c643c$export$7787d47a1b8939d0);
$parcel$export(module.exports, "isInSameLayout", () => $51ebc5031c8c643c$export$9d5fcdcf2394fab8);
$parcel$export(module.exports, "transformFragmentExpandToNestedExpand", () => $51ebc5031c8c643c$export$ca1d8e12fb5b3277);
$parcel$export(module.exports, "transformSliceNodeType", () => $51ebc5031c8c643c$export$805d193712b3b932);
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $51ebc5031c8c643c$export$447e90e618548243);
$parcel$export(module.exports, "canMoveNodeToIndex", () => $51ebc5031c8c643c$export$918b4fd27bccdab5);
$parcel$export(module.exports, "canMoveSliceToIndex", () => $51ebc5031c8c643c$export$35c44269895720b6);

var $jiju3 = parcelRequire("jiju3");

var $5DGsr = parcelRequire("5DGsr");
var $knIPH = parcelRequire("knIPH");

var $e8CsO = parcelRequire("e8CsO");

var $7H6Cr = parcelRequire("7H6Cr");

var $a4TQr = parcelRequire("a4TQr");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");
const $51ebc5031c8c643c$export$199dae4875feadcd = (nodeType)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = nodeType.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].indexOf(nodeType) >= 0;
};
const $51ebc5031c8c643c$export$51b69e9dc2d60fca = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.layoutColumn;
};
const $51ebc5031c8c643c$export$a528a4f84f239e18 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.doc;
};
const $51ebc5031c8c643c$export$a1d4506bfd61c0e4 = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.expand;
};
const $51ebc5031c8c643c$export$174a46ad1de68ba = (nodeType)=>{
    return nodeType === nodeType.schema.nodes.nestedExpand;
};
const $51ebc5031c8c643c$export$7787d47a1b8939d0 = (node)=>{
    return node.type.name === 'paragraph' && node.marks.some((mark)=>mark.type.name === 'fontSize');
};
const $51ebc5031c8c643c$export$9d5fcdcf2394fab8 = ($from, $to)=>{
    const fromNode = $from.nodeAfter;
    const toNode = $to.nodeAfter;
    return !!(fromNode && toNode && fromNode.type.name === 'layoutColumn' && [
        'layoutSection',
        'layoutColumn'
    ].includes(toNode.type.name) && // fromNode can either be in the same layoutSection as toNode or is a layoutColumn inside the toNode (type layoutSection)
    ($from.sameParent($to) || $from.parent === toNode));
};
const $51ebc5031c8c643c$export$c78c24bf7f1a36c2 = (expandNode)=>{
    const { expand: expand, nestedExpand: nestedExpand } = expandNode.type.schema.nodes;
    if (expandNode.type === expand) return nestedExpand.createChecked(expandNode.attrs, expandNode.content, expandNode.marks);
    return null;
};
const $51ebc5031c8c643c$export$ca1d8e12fb5b3277 = (fragment)=>{
    const children = [];
    try {
        fragment.forEach((node)=>{
            if ($51ebc5031c8c643c$export$a1d4506bfd61c0e4(node.type)) {
                const nestedExpandNode = $51ebc5031c8c643c$export$c78c24bf7f1a36c2(node);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $7H6Cr.Fragment).fromArray(children);
};
const $51ebc5031c8c643c$export$ce4d3d0e85e5e737 = (fragment, schema, fromType, toType)=>{
    const children = [];
    const targetType = schema.nodes[toType];
    if (!targetType) return null;
    try {
        fragment.forEach((node)=>{
            if (node.type.name === fromType) children.push(targetType.create(node.attrs, node.content, node.marks));
            else children.push(node);
        });
    } catch (e) {
        return null;
    }
    return (0, $7H6Cr.Fragment).fromArray(children);
};
const $51ebc5031c8c643c$export$805d193712b3b932 = (slice, schema, fromType, toType)=>{
    const fragment = $51ebc5031c8c643c$export$ce4d3d0e85e5e737(slice.content, schema, fromType, toType);
    if (!fragment) return null;
    return new (0, $7H6Cr.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $51ebc5031c8c643c$export$447e90e618548243 = (slice)=>{
    const fragment = $51ebc5031c8c643c$export$ca1d8e12fb5b3277(slice.content);
    if (!fragment) return null;
    return new (0, $7H6Cr.Slice)(fragment, slice.openStart, slice.openEnd);
};
const $51ebc5031c8c643c$export$e639988f4c2f87a3 = (0, $jiju3.default)((node)=>{
    try {
        return $51ebc5031c8c643c$export$c78c24bf7f1a36c2(node);
    } catch (e) {
        return null;
    }
});
const $51ebc5031c8c643c$export$bfcc41199ff04884 = (nodeTypesToCreate, nodeWithTargetFragment)=>{
    try {
        return !!nodeTypesToCreate.every((nodeTypeToCreate)=>nodeTypeToCreate.createChecked({}, nodeWithTargetFragment));
    } catch (e) {
        return false;
    }
};
function $51ebc5031c8c643c$export$918b4fd27bccdab5(destParent, indexIntoParent, srcNode, $destNodePos, destNode) {
    let srcNodeType = srcNode.type;
    const schema = srcNodeType.schema;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader, expand: expand, nestedExpand: nestedExpand, doc: doc, panel: panel, panel_c1: panel_c1, layoutColumn: layoutColumn, layoutSection: layoutSection } = schema.nodes;
    const destParentNodeType = destParent === null || destParent === void 0 ? void 0 : destParent.type;
    const activeNodeType = srcNode === null || srcNode === void 0 ? void 0 : srcNode.type;
    const layoutColumnContent = srcNode.content;
    const isNestingTablesSupported = (0, $knIPH.isNestedTablesSupported)(schema);
    if (activeNodeType === layoutColumn && (0, $kaRof.editorExperiment)('advanced_layouts', true)) {
        // Allow drag layout column and drop into layout section
        if ((destNode === null || destNode === void 0 ? void 0 : destNode.type) === layoutSection || destParentNodeType === doc) return true;
        if (destParentNodeType === tableCell || destParentNodeType === tableHeader) {
            const contentContainsExpand = (0, $a4TQr.findChildrenByType)(srcNode, expand).length > 0;
            //convert expand to nestedExpand if there are expands inside the layout column
            // otherwise, the createChecked will fail as expand is not a valid child of tableCell/tableHeader, but nestedExpand is
            const convertedFragment = contentContainsExpand ? $51ebc5031c8c643c$export$ca1d8e12fb5b3277(layoutColumnContent) : layoutColumnContent;
            if (!convertedFragment) return false;
            return $51ebc5031c8c643c$export$bfcc41199ff04884([
                tableCell,
                tableHeader
            ], convertedFragment);
        }
        if (destParentNodeType === panel || (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && destParentNodeType === panel_c1) return $51ebc5031c8c643c$export$bfcc41199ff04884([
            panel
        ], layoutColumnContent);
        if (destParentNodeType === expand) return $51ebc5031c8c643c$export$bfcc41199ff04884([
            expand
        ], layoutColumnContent);
        if (destParentNodeType === nestedExpand) return $51ebc5031c8c643c$export$bfcc41199ff04884([
            nestedExpand
        ], layoutColumnContent);
    }
    // NOTE: this will block drop targets from showing for dragging a table into another table
    // unless nested tables are supported and the nesting depth does not exceed 1
    if ((destParentNodeType === tableCell || destParentNodeType === tableHeader) && activeNodeType === table) {
        const nestingDepth = (0, $5DGsr.getParentOfTypeCount)(table)($destNodePos);
        if (!isNestingTablesSupported || isNestingTablesSupported && nestingDepth > 1) return false;
    }
    if ($51ebc5031c8c643c$export$199dae4875feadcd(destParent.type) && $51ebc5031c8c643c$export$a1d4506bfd61c0e4(srcNodeType)) {
        if ($51ebc5031c8c643c$export$e639988f4c2f87a3(srcNode)) srcNodeType = nestedExpand;
        else return false;
    } else if (($51ebc5031c8c643c$export$a528a4f84f239e18(destParent.type) || $51ebc5031c8c643c$export$51b69e9dc2d60fca(destParent.type)) && $51ebc5031c8c643c$export$174a46ad1de68ba(srcNodeType)) srcNodeType = expand;
    // Downgrade variant node (e.g. panel_c1 → panel) when dest doesn't support it
    if ((0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
        const baseName = (0, $e8CsO.getBaseNodeTypeName)(srcNodeType);
        if (baseName !== srcNodeType.name && !destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType)) {
            const baseType = schema.nodes[baseName];
            // Check if the node's content is valid in the base type (e.g. panel with table can't be downgraded)
            if (!baseType || !baseType.validContent(srcNode.content)) return false;
            srcNodeType = baseType;
        }
    }
    return destParent.canReplaceWith(indexIntoParent, indexIntoParent, srcNodeType);
}
function $51ebc5031c8c643c$export$35c44269895720b6(slice, sliceFromPos, sliceToPos, destParent, indexIntoParent, $destNodePos, destNode) {
    var _slice$content$firstC;
    let canMoveNodes = true;
    const doc = $destNodePos.doc;
    const nodesPos = [];
    // Drag multiple nodes to be inside themselves not allowed
    if ($destNodePos.pos < sliceToPos && $destNodePos.pos >= sliceFromPos) return false;
    // Multiple layout columns do not drop correctly.
    if (((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type.name) === 'layoutColumn') return false;
    for(let i = 0; i < slice.content.childCount; i++){
        const node = slice.content.maybeChild(i);
        if (i === 0) nodesPos[i] = sliceFromPos;
        else {
            var _slice$content$maybeC;
            nodesPos[i] = nodesPos[i - 1] + (((_slice$content$maybeC = slice.content.maybeChild(i - 1)) === null || _slice$content$maybeC === void 0 ? void 0 : _slice$content$maybeC.nodeSize) || 0);
        }
        if (node && node.isInline) {
            // If the node is an inline node, we need to find the parent node
            // as passing in them into canMoveNodeToIndex will return false
            const $nodePos = doc.resolve(nodesPos[i]);
            const parentNode = $nodePos.parent;
            if (!parentNode || parentNode && !$51ebc5031c8c643c$export$918b4fd27bccdab5(destParent, indexIntoParent, parentNode, $destNodePos, destNode)) {
                canMoveNodes = false;
                break;
            }
        } else if (node && !$51ebc5031c8c643c$export$918b4fd27bccdab5(destParent, indexIntoParent, node, $destNodePos, destNode)) {
            canMoveNodes = false;
            break;
        }
    }
    return canMoveNodes;
}

});



parcelRegister("50s88", function(module, exports) {
$parcel$export(module.exports, "TYPE_ACTIVE_HANDLE_DEC", () => $f89ca72eb6dbefcf$export$cfa5d510bf083f43);
$parcel$export(module.exports, "createActiveDragHandleNodeDecoration", () => $f89ca72eb6dbefcf$export$4a4d976428c4c181);
$parcel$export(module.exports, "findActiveDragHandleNodeDec", () => $f89ca72eb6dbefcf$export$88c77bebe4a56da8);
$parcel$export(module.exports, "emptyParagraphNodeDecorations", () => $f89ca72eb6dbefcf$export$613641ee4757989);
$parcel$export(module.exports, "findHandleDec", () => $f89ca72eb6dbefcf$export$3ec2b0df4b056a96);
$parcel$export(module.exports, "dragHandleDecoration", () => $f89ca72eb6dbefcf$export$38a5c9b9faf26cd8);

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $GIvev = parcelRequire("GIvev");

var $38VwC = parcelRequire("38VwC");

var $61p1X = parcelRequire("61p1X");

var $5x24z = parcelRequire("5x24z");

var $6TMRn = parcelRequire("6TMRn");
const $f89ca72eb6dbefcf$export$cfa5d510bf083f43 = 'active-drag-handle-node';
const $f89ca72eb6dbefcf$export$4a4d976428c4c181 = (pos, nodeSize)=>(0, $16ZMX.Decoration).node(pos, pos + nodeSize, {
        [(0, $GIvev.ACTIVE_DRAG_HANDLE_ATTR)]: 'true'
    }, {
        type: $f89ca72eb6dbefcf$export$cfa5d510bf083f43
    });
const $f89ca72eb6dbefcf$export$88c77bebe4a56da8 = (decorations, from, to)=>decorations.find(from, to, (spec)=>spec.type === $f89ca72eb6dbefcf$export$cfa5d510bf083f43);
const $f89ca72eb6dbefcf$export$613641ee4757989 = ()=>{
    const anchorName = `--node-anchor-paragraph-0`;
    const style = `anchor-name: ${anchorName}; margin-top: 0px;`;
    return (0, $16ZMX.Decoration).node(0, 2, {
        style: style,
        ['data-drag-handler-anchor-name']: anchorName
    }, {
        type: (0, $61p1X.TYPE_NODE_DEC)
    });
};
const $f89ca72eb6dbefcf$export$3ec2b0df4b056a96 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $61p1X.TYPE_HANDLE_DEC));
};
// Unmounting a focused handle runs its effect cleanup (view.focus()), which steals focus from the
// open block menu. The root is left mounted in that case.
const $f89ca72eb6dbefcf$var$unmountUnlessMenuOpen = (api, element)=>{
    var _api$blockControls;
    if (!(api !== null && api !== void 0 && (_api$blockControls = api.blockControls) !== null && _api$blockControls !== void 0 && (_api$blockControls = _api$blockControls.sharedState.currentState()) !== null && _api$blockControls !== void 0 && _api$blockControls.isMenuOpen)) (0, $5x24z.unmountFromMountPoint)(element);
};
const $f89ca72eb6dbefcf$export$38a5c9b9faf26cd8 = ({ api: api, formatMessage: formatMessage, pos: pos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, handleOptions: handleOptions, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    (0, $61p1X.unmountDecorations)(nodeViewPortalProviderAPI, 'data-blocks-drag-handle-container', 'data-blocks-drag-handle-key');
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $eUgRu.default)();
    const widgetSpec = {
        side: -1,
        type: (0, $61p1X.TYPE_HANDLE_DEC),
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        testid: `${(0, $61p1X.TYPE_HANDLE_DEC)}-${(0, $eUgRu.default)()}`,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $6TMRn.getMatchingBlockMarks)(editorState, pos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ]),
        ...(0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks') && {
            destroy: (node)=>{
                // Deferred: unmounting a root during a React render warns
                queueMicrotask(()=>$f89ca72eb6dbefcf$var$unmountUnlessMenuOpen(api, node));
            }
        }
    };
    return (0, $16ZMX.Decoration).widget(pos, (view, getPosUnsafe)=>{
        const element = document.createElement('span');
        // inline decoration causes focus issues when refocusing Editor into first line
        element.style.display = 'block';
        element.setAttribute('data-blocks-decorator-widget', 'true');
        element.setAttribute('data-testid', 'block-ctrl-decorator-widget');
        element.setAttribute('data-blocks-drag-handle-container', 'true');
        element.setAttribute('data-blocks-drag-handle-key', key);
        let isTopLevelNode = true;
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch  {
                // Ignore errors from getPosUnsafe
                return undefined;
            }
        };
        const newPos = getPos();
        if (typeof newPos === 'number') {
            const $pos = view.state.doc.resolve(newPos);
            isTopLevelNode = ($pos === null || $pos === void 0 ? void 0 : $pos.parent.type.name) === 'doc';
        }
        /*
     * We disable mouseover event to fix flickering issue on hover
     * However, the tooltip for nested drag handle is no long working.
     */ if (newPos === undefined || !isTopLevelNode) element.onmouseover = (e)=>{
            e.stopPropagation();
        };
        // There are times when global clear: "both" styles are applied to this decoration causing jumpiness
        // due to margins applied to other nodes eg. Headings
        element.style.clear = 'unset';
        // temporarily re-instating ReactDOM.render to fix drag handle focus issue, fix to
        // follow via ED-26546
        // previous under platform_editor_react18_plugin_portalprovider
        // 	nodeViewPortalProviderAPI.render(
        // 		() =>
        // 			createElement(DragHandle, {
        // 				view,
        // 				api,
        // 				formatMessage,
        // 				getPos,
        // 				anchorName,
        // 				nodeType,
        // 				handleOptions,
        // 				isTopLevelNode,
        // 			}),
        // 		element,
        // 		key,
        // 	);
        if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) (0, $5x24z.renderToMountPoint)((0, $fc4bM.createElement)((0, $38VwC.DragHandleWithVisibility), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        else (0, $5x24z.renderToMountPoint)((0, $fc4bM.createElement)((0, $38VwC.DragHandle), {
            view: view,
            api: api,
            formatMessage: formatMessage,
            getPos: getPos,
            anchorName: anchorName,
            nodeType: nodeType,
            handleOptions: handleOptions,
            isTopLevelNode: isTopLevelNode,
            anchorRectCache: anchorRectCache
        }), element);
        return element;
    }, widgetSpec);
};

});
parcelRegister("38VwC", function(module, exports) {
$parcel$export(module.exports, "DragHandle", () => $dd72adccc70159c7$export$a0c24614540b0efb);
$parcel$export(module.exports, "DragHandleWithVisibility", () => $dd72adccc70159c7$export$c3c91925cdbf4b0b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");

var $3LeME = parcelRequire("3LeME");

var $dqFZv = parcelRequire("dqFZv");

var $eUtBU = parcelRequire("eUtBU");

var $7u4Lo = parcelRequire("7u4Lo");

var $gCPs3 = parcelRequire("gCPs3");

var $jd8X7 = parcelRequire("jd8X7");

var $9oAqi = parcelRequire("9oAqi");

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $kzYZ0 = parcelRequire("kzYZ0");

var $dRkX9 = parcelRequire("dRkX9");

var $c8sLM = parcelRequire("c8sLM");

var $l2xrI = parcelRequire("l2xrI");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $bcTS3 = parcelRequire("bcTS3");

var $61p1X = parcelRequire("61p1X");

var $gyNLa = parcelRequire("gyNLa");

var $b8Grq = parcelRequire("b8Grq");

var $3TAWV = parcelRequire("3TAWV");

var $iZXVC = parcelRequire("iZXVC");

var $lE9Q7 = parcelRequire("lE9Q7");

var $7f0FC = parcelRequire("7f0FC");

var $GIvev = parcelRequire("GIvev");

var $yOdik = parcelRequire("yOdik");

var $fghja = parcelRequire("fghja");

var $fcDy5 = parcelRequire("fcDy5");

var $dp5ck = parcelRequire("dp5ck");

var $dj84o = parcelRequire("dj84o");

var $5wcYI = parcelRequire("5wcYI");
function $dd72adccc70159c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dd72adccc70159c7$var$iconWrapperStyles = (0, $kig2V.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $dd72adccc70159c7$var$buttonWrapperStylesNoBackground = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        marginBottom: "var(--ds-space-negative-200, -16px)",
        paddingBottom: "var(--ds-space-200, 16px)",
        marginTop: "var(--ds-space-negative-400, -32px)",
        paddingTop: `calc(${"var(--ds-space-400, 32px)"} - 1px)`,
        marginRight: "var(--ds-space-negative-150, -12px)",
        paddingRight: "var(--ds-space-150, 12px)",
        boxSizing: 'border-box'
    }
});
const $dd72adccc70159c7$var$buttonWrapperStylesPatch = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $014x6.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $014x6.akEditorTableToolbarSize)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls [data-number-column="true"] tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        marginRight: -(0, $014x6.akEditorTableToolbarSize),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        paddingRight: (0, $014x6.akEditorTableToolbarSize)
    }
});
// update color to match quick insert button for new editor controls
const $dd72adccc70159c7$var$dragHandleColor = {
    name: "101f0nf",
    styles: "color:var(--ds-icon-subtle, #505258)"
};
const $dd72adccc70159c7$var$dragHandleButtonStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    boxSizing: 'border-box',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $GIvev.DRAG_HANDLE_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $gCPs3.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $GIvev.DRAG_HANDLE_BORDER_RADIUS),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #292A2E)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $GIvev.DRAG_HANDLE_ZINDEX),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #080F214A)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24h x 12w, Dense: 13px -> 18h x 9w, Jira: 14px -> 21h x 12w
const $dd72adccc70159c7$var$dragHandleButtonScaledStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $014x6.relativeSizeToBaseFontSize)((0, $GIvev.DRAG_HANDLE_HEIGHT)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $014x6.relativeSizeToBaseFontSize)((0, $gCPs3.DRAG_HANDLE_WIDTH))
});
const $dd72adccc70159c7$var$dragHandleButtonSmallScreenStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $014x6.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $dd72adccc70159c7$var$dragHandleButtonStylesOld = /*#__PURE__*/ (0, $jctmk.css)({
    position: 'absolute',
    paddingTop: `${"var(--ds-space-025, 2px)"}`,
    paddingBottom: `${"var(--ds-space-025, 2px)"}`,
    paddingLeft: '0',
    paddingRight: '0',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $GIvev.DRAG_HANDLE_HEIGHT),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $gCPs3.DRAG_HANDLE_WIDTH),
    border: 'none',
    background: 'transparent',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $GIvev.DRAG_HANDLE_BORDER_RADIUS),
    // when platform_editor_controls is enabled, the drag handle color is overridden. Update color here when experiment is cleaned up.
    color: "var(--ds-icon, #292A2E)",
    cursor: 'grab',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $GIvev.DRAG_HANDLE_ZINDEX),
    outline: 'none',
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    },
    '&:disabled': {
        color: "var(--ds-icon-disabled, #080F214A)",
        backgroundColor: 'transparent'
    },
    '&:hover:disabled': {
        backgroundColor: "var(--ds-background-disabled, #0515240F)"
    }
});
const $dd72adccc70159c7$var$focusedStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '&:focus-visible': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $dd72adccc70159c7$var$keyboardFocusedDragHandleStyles = /*#__PURE__*/ (0, $jctmk.css)({
    outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
});
const $dd72adccc70159c7$var$dragHandleContainerStyles = (0, $kig2V.xcss)({
    position: 'absolute',
    boxSizing: 'border-box'
});
const $dd72adccc70159c7$var$tooltipContainerStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    bottom: `-${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN)}px`,
    position: 'sticky',
    display: 'block',
    zIndex: 100 // card = 100
});
const $dd72adccc70159c7$var$tooltipContainerStylesImprovedStickyHeaderWithMask = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        top: '0'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-mark-name="fragment"] > [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $dd72adccc70159c7$var$tooltipContainerStylesStickyHeaderWithoutMask = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-drag-handle-container]:has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-drag-handle-container]):has(+ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    }
});
const $dd72adccc70159c7$var$dragHandleMultiLineSelectionFixFirefox = {
    name: "ut0e3u",
    styles: "&::selection{background-color:transparent;}"
};
const $dd72adccc70159c7$var$layoutColumnDragHandleStyles = {
    name: "jbgpyq",
    styles: "transform:rotate(90deg)"
};
const $dd72adccc70159c7$var$selectedStyles = {
    name: "1qq3fmc",
    styles: "background-color:var(--ds-background-selected, #E9F2FE);color:var(--ds-icon-selected, #1868DB)"
};
// [Chrome only] When selection contains multiple nodes and then drag a drag handle that is within the selection range,
// icon span receives dragStart event, instead of button, and since it is not registered as a draggable element
// with pragmatic DnD and pragmatic DnD is not triggered
const $dd72adccc70159c7$var$handleIconDragStart = (e)=>{
    const browser = (0, $dqFZv.getBrowserInfo)();
    if (!browser.chrome) return;
    // prevent dragStart handler triggered by icon
    e.stopPropagation();
    const dragEvent = new DragEvent('dragstart', {
        bubbles: true,
        cancelable: true,
        dataTransfer: e.dataTransfer
    });
    if (e.target instanceof HTMLElement) {
        var _e$target$closest;
        // re-dispatch drag event on button so that pragmatic DnD can be triggered properly
        (_e$target$closest = e.target.closest('button')) === null || _e$target$closest === void 0 || _e$target$closest.dispatchEvent(dragEvent);
    }
};
const $dd72adccc70159c7$var$getNodeSpacingForPreview = (node)=>{
    if (!node) return (0, $GIvev.spacingBetweenNodesForPreview)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $GIvev.spacingBetweenNodesForPreview)[`heading${node.attrs.level}`] || (0, $GIvev.spacingBetweenNodesForPreview)['default'];
    return (0, $GIvev.spacingBetweenNodesForPreview)[nodeTypeName] || (0, $GIvev.spacingBetweenNodesForPreview)['default'];
};
const $dd72adccc70159c7$var$getNodeMargins = (node)=>{
    if (!node) return (0, $GIvev.nodeMargins)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $GIvev.nodeMargins)[`heading${node.attrs.level}`] || (0, $GIvev.nodeMargins)['default'];
    return (0, $GIvev.nodeMargins)[nodeTypeName] || (0, $GIvev.nodeMargins)['default'];
};
// Omit `isOpen` so the reducer toggles the menu for a re-clicked layout column.
const $dd72adccc70159c7$var$buildToggleLayoutColumnMenuMeta = (anchorPos, openedViaKeyboard)=>({
        anchorPos: anchorPos,
        openedViaKeyboard: openedViaKeyboard
    });
const $dd72adccc70159c7$var$getDragHandleAnchorReference = ({ edge: edge, safeAnchorName: safeAnchorName })=>{
    if ((0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) return `anchor(${safeAnchorName} ${edge}, anchor(${0, $GIvev.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME} ${edge}))`;
    return `anchor(${safeAnchorName} ${edge})`;
};
const $dd72adccc70159c7$export$a0c24614540b0efb = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, anchorRectCache: anchorRectCache })=>{
    const buttonRef = (0, $fc4bM.useRef)(null);
    const mouseDownRef = (0, $fc4bM.useRef)(false);
    const [dragHandleSelected, setDragHandleSelected] = (0, $fc4bM.useState)(false);
    const [blockCardWidth, setBlockCardWidth] = (0, $fc4bM.useState)(768);
    const [positionStylesOld, setPositionStylesOld] = (0, $fc4bM.useState)({
        display: 'none'
    });
    // Tracks whether the initial position calculation has been performed at least once.
    // The reliable-anchor early-return optimisation must not fire before the first calculation,
    // otherwise positionStylesOld stays as { display: 'none' } and the handle is never shown.
    const hasCalculatedInitialPosition = (0, $fc4bM.useRef)(false);
    const [isFocused, setIsFocused] = (0, $fc4bM.useState)(Boolean(handleOptions === null || handleOptions === void 0 ? void 0 : handleOptions.isFocused));
    const { macroInteractionUpdates: macroInteractionUpdates, selection: selection, interactionState: interactionState, currentUserIntent: currentUserIntent } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'featureFlags',
        'selection',
        'blockControls',
        'interaction',
        'userIntent'
    ], (states)=>{
        var _states$featureFlagsS, _states$selectionStat, _states$interactionSt, _states$userIntentSta;
        return {
            macroInteractionUpdates: (_states$featureFlagsS = states.featureFlagsState) === null || _states$featureFlagsS === void 0 ? void 0 : _states$featureFlagsS.macroInteractionUpdates,
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection,
            interactionState: (_states$interactionSt = states.interactionState) === null || _states$interactionSt === void 0 ? void 0 : _states$interactionSt.interactionState,
            currentUserIntent: (_states$userIntentSta = states.userIntentState) === null || _states$userIntentSta === void 0 ? void 0 : _states$userIntentSta.currentUserIntent
        };
    });
    const start = getPos();
    const isLayoutColumn = nodeType === 'layoutColumn';
    // Dynamically calculate if node is top-level based on current position
    const isTopLevelNodeValue = (0, $fc4bM.useMemo)(()=>{
        const pos = getPos();
        if (typeof pos === 'number') {
            const $pos = view.state.doc.resolve(pos);
            return ($pos === null || $pos === void 0 ? void 0 : $pos.parent.type.name) === 'doc';
        }
        return true;
    }, [
        getPos,
        view.state.doc
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // blockCard/datasource width is rendered correctly after this decoraton does. We need to observe for changes.
        if (nodeType === 'blockCard') {
            const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${anchorName}"]`);
            const container = dom === null || dom === void 0 ? void 0 : dom.querySelector('.datasourceView-content-inner-wrap');
            if (container) {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const width = entries[0].contentBoxSize[0].inlineSize;
                    setBlockCardWidth(width);
                });
                resizeObserver.observe(container);
                return ()=>resizeObserver.unobserve(container);
            }
        }
    }, [
        anchorName,
        nodeType,
        view.dom
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!(0, $3NBIB.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true)) return;
        const unbind = (0, $6Zi52.bind)(window, {
            type: 'mouseUp',
            listener: ()=>mouseDownRef.current = false
        });
        return ()=>unbind();
    }, []);
    const handleMouseDown = (0, $fc4bM.useCallback)(()=>{
        mouseDownRef.current = true;
    }, []);
    const handleMouseUp = (0, $fc4bM.useCallback)((e)=>{
        // Stop propagation so that for drag handles in nested scenarios the click is captured
        // and doesn't propagate to the edge of the element and trigger a node selection
        // on the parent element
        if (!(0, $3NBIB.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true)) e.stopPropagation();
        // Fixes bug where selection toolbar is blocked when mouse is released on drag handle
        if (mouseDownRef.current) e.stopPropagation();
    }, []);
    const handleOnClickNew = (0, $fc4bM.useCallback)((e)=>{
        var _api$core;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
            var _selectionPreservatio, _api$analytics, _resolvedStartPos$nod, _api$blockControls2, _api$blockControls3;
            const startPos = getPos();
            if (startPos === undefined) return tr;
            if (nodeType === 'layoutColumn') tr.setMeta('toggleLayoutColumnMenu', $dd72adccc70159c7$var$buildToggleLayoutColumnMenuMeta(startPos, false));
            const resolvedStartPos = tr.doc.resolve(startPos);
            if (resolvedStartPos.nodeAfter) {
                var _api$blockControls;
                api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || _api$blockControls.actions.notifyBlockHandleClick({
                    node: resolvedStartPos.nodeAfter
                });
            }
            const selection = ((_selectionPreservatio = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state)) === null || _selectionPreservatio === void 0 ? void 0 : _selectionPreservatio.preservedSelection) || tr.selection;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                eventType: (0, $3LeME.EVENT_TYPE).UI,
                action: (0, $3LeME.ACTION).CLICKED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedStartPos.depth,
                    nodeTypes: ((_resolvedStartPos$nod = resolvedStartPos.nodeAfter) === null || _resolvedStartPos$nod === void 0 ? void 0 : _resolvedStartPos$nod.type.name) || ''
                }
            })(tr);
            (0, $lE9Q7.expandAndUpdateSelection)({
                tr: tr,
                selection: selection,
                startPos: startPos,
                isShiftPressed: e.shiftKey,
                nodeType: nodeType,
                api: api
            });
            api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.commands.startPreservingSelection()({
                tr: tr
            });
            api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || _api$blockControls3.commands.toggleBlockMenu({
                anchorName: anchorName,
                openedViaKeyboard: false,
                triggerByNode: {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: tr.doc.resolve(startPos).before(1)
                }
            })({
                tr: tr
            });
            tr.setMeta('scrollIntoView', false);
            return tr;
        });
        view.focus();
    }, [
        api,
        view,
        getPos,
        nodeType,
        anchorName
    ]);
    const handleKeyDownNew = (0, $fc4bM.useCallback)((e)=>{
        // allow user to use spacebar to select the node
        if (e.key === 'Enter' || !e.repeat && e.key === ' ') {
            var _getDocument, _api$core2;
            if (((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement) !== buttonRef.current) return;
            e.preventDefault();
            e.stopPropagation();
            const startPos = getPos();
            api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
                var _selectionPreservatio2, _api$blockControls5, _api$blockControls6, _api$userIntent;
                if (startPos === undefined) return tr;
                const node = tr.doc.resolve(startPos).nodeAfter;
                if (node) {
                    var _api$blockControls4;
                    api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || _api$blockControls4.actions.notifyBlockHandleClick({
                        node: node
                    });
                }
                const selection = ((_selectionPreservatio2 = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state)) === null || _selectionPreservatio2 === void 0 ? void 0 : _selectionPreservatio2.preservedSelection) || tr.selection;
                (0, $lE9Q7.expandAndUpdateSelection)({
                    tr: tr,
                    selection: selection,
                    startPos: startPos,
                    isShiftPressed: e.shiftKey,
                    nodeType: nodeType,
                    api: api
                });
                api === null || api === void 0 || (_api$blockControls5 = api.blockControls) === null || _api$blockControls5 === void 0 || _api$blockControls5.commands.startPreservingSelection()({
                    tr: tr
                });
                if (nodeType === 'layoutColumn') tr.setMeta('toggleLayoutColumnMenu', $dd72adccc70159c7$var$buildToggleLayoutColumnMenuMeta(startPos, true));
                const triggerByNode = {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: tr.doc.resolve(startPos).before(1)
                };
                api === null || api === void 0 || (_api$blockControls6 = api.blockControls) === null || _api$blockControls6 === void 0 || _api$blockControls6.commands.toggleBlockMenu({
                    anchorName: anchorName,
                    triggerByNode: triggerByNode,
                    openedViaKeyboard: true
                })({
                    tr: tr
                });
                api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('blockMenuOpen')({
                    tr: tr
                });
                return tr;
            });
            view.focus();
        } else if (![
            e.altKey,
            e.ctrlKey,
            e.shiftKey
        ].some((pressed)=>pressed)) // If not trying to press shortcut keys,
        // return focus to editor to resume editing from caret position
        view.focus();
    }, [
        getPos,
        api,
        nodeType,
        anchorName,
        view
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const element = buttonRef.current;
        if (!element) return;
        return (0, $c8sLM.draggable)({
            element: element,
            getInitialData: ()=>({
                    type: 'element',
                    start: start
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                var _api$core3, _api$blockControls$sh;
                api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(({ tr: tr })=>{
                    const handlePos = getPos();
                    if (typeof handlePos !== 'number') return tr;
                    const newHandlePosCheck = (0, $7f0FC.isHandleCorrelatedToSelection)(view.state, tr.selection, handlePos);
                    if (!tr.selection.empty && newHandlePosCheck) {
                        var _api$blockControls7;
                        api === null || api === void 0 || (_api$blockControls7 = api.blockControls) === null || _api$blockControls7 === void 0 || _api$blockControls7.commands.setMultiSelectPositions()({
                            tr: tr
                        });
                    } else tr = (0, $7f0FC.selectNode)(tr, handlePos, nodeType, api);
                    return tr;
                });
                const startPos = getPos();
                const state = view.state;
                const { doc: doc, selection: selection } = state;
                let sliceFrom = selection.from;
                let sliceTo = selection.to;
                const mSelect = api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.multiSelectDnD;
                if (mSelect) {
                    const { anchor: anchor, head: head } = mSelect;
                    sliceFrom = Math.min(anchor, head);
                    sliceTo = Math.max(anchor, head);
                }
                const expandedSlice = doc.slice(sliceFrom, sliceTo);
                const isDraggingMultiLine = startPos !== undefined && startPos >= sliceFrom && startPos < sliceTo && expandedSlice.content.childCount > 1;
                (0, $l2xrI.setCustomNativeDragPreview)({
                    getOffset: ()=>{
                        if (!isDraggingMultiLine) return {
                            x: 0,
                            y: 0
                        };
                        else {
                            // Calculate the offset of the preview container,
                            // So when drag multiple nodes, the preview align with the position of the selected nodes
                            const domAtPos = view.domAtPos.bind(view);
                            let domElementsHeightBeforeHandle = 0;
                            const nodesStartPos = [];
                            const nodesEndPos = [];
                            let activeNodeMarginTop = 0;
                            for(let i = 0; i < expandedSlice.content.childCount; i++){
                                if (i === 0) {
                                    var _expandedSlice$conten;
                                    nodesStartPos[i] = sliceFrom;
                                    nodesEndPos[i] = sliceFrom + (((_expandedSlice$conten = expandedSlice.content.maybeChild(i)) === null || _expandedSlice$conten === void 0 ? void 0 : _expandedSlice$conten.nodeSize) || 0);
                                } else {
                                    var _expandedSlice$conten2;
                                    nodesStartPos[i] = nodesEndPos[i - 1];
                                    nodesEndPos[i] = nodesStartPos[i] + (((_expandedSlice$conten2 = expandedSlice.content.maybeChild(i)) === null || _expandedSlice$conten2 === void 0 ? void 0 : _expandedSlice$conten2.nodeSize) || 0);
                                }
                                // when the node is before the handle, calculate the height of the node
                                if (nodesEndPos[i] <= startPos) {
                                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                                    const currentNodeElement = (0, $a4TQr.findDomRefAtPos)(nodesStartPos[i], domAtPos);
                                    const maybeCurrentNode = expandedSlice.content.maybeChild(i);
                                    const currentNodeSpacing = maybeCurrentNode ? $dd72adccc70159c7$var$getNodeMargins(maybeCurrentNode).top + $dd72adccc70159c7$var$getNodeMargins(maybeCurrentNode).bottom : 0;
                                    domElementsHeightBeforeHandle = domElementsHeightBeforeHandle + currentNodeElement.offsetHeight + currentNodeSpacing;
                                } else {
                                    // when the node is after the handle, calculate the top margin of the active node
                                    const maybeNextNode = expandedSlice.content.maybeChild(i);
                                    activeNodeMarginTop = maybeNextNode ? $dd72adccc70159c7$var$getNodeMargins(maybeNextNode).top : 0;
                                    break;
                                }
                            }
                            return {
                                x: 0,
                                y: domElementsHeightBeforeHandle + activeNodeMarginTop
                            };
                        }
                    },
                    render: ({ container: container })=>{
                        const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${anchorName}"]`);
                        if (!dom) return;
                        if (!isDraggingMultiLine) return (0, $fghja.dragPreview)(container, {
                            dom: dom,
                            nodeType: nodeType
                        });
                        else {
                            const domAtPos = view.domAtPos.bind(view);
                            const previewContent = [];
                            expandedSlice.content.descendants((node, pos)=>{
                                // Get the dom element of the node
                                //eslint-disable-next-line @atlaskit/editor/no-as-casting
                                const nodeDomElement = (0, $a4TQr.findDomRefAtPos)(sliceFrom + pos, domAtPos);
                                const currentNodeSpacing = $dd72adccc70159c7$var$getNodeSpacingForPreview(node);
                                previewContent.push({
                                    dom: nodeDomElement,
                                    nodeType: node.type.name,
                                    nodeSpacing: currentNodeSpacing
                                });
                                return false; // Only iterate through the first level of nodes
                            });
                            return (0, $fghja.dragPreview)(container, previewContent);
                        }
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart () {
                var _api$core4;
                if (start === undefined) return;
                api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(({ tr: tr })=>{
                    var _api$blockControls$sh2, _api$blockControls8, _api$analytics2;
                    let nodeTypes, hasSelectedMultipleNodes;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const maybeNode = resolvedMovingNode.nodeAfter;
                    const mSelect = api === null || api === void 0 || (_api$blockControls$sh2 = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh2 === void 0 ? void 0 : _api$blockControls$sh2.multiSelectDnD;
                    if (mSelect) {
                        const attributes = (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, mSelect.anchor, mSelect.head);
                        nodeTypes = attributes.nodeTypes;
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                    } else {
                        nodeTypes = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.type.name;
                        hasSelectedMultipleNodes = false;
                    }
                    api === null || api === void 0 || (_api$blockControls8 = api.blockControls) === null || _api$blockControls8 === void 0 || _api$blockControls8.commands.setNodeDragged(getPos, anchorName, nodeType)({
                        tr: tr
                    });
                    tr.setMeta('scrollIntoView', false);
                    api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent({
                        eventType: (0, $3LeME.EVENT_TYPE).UI,
                        action: (0, $3LeME.ACTION).DRAGGED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: nodeTypes || '',
                            hasSelectedMultipleNodes: hasSelectedMultipleNodes
                        }
                    })(tr);
                    return tr;
                });
                view.focus();
            }
        });
    }, [
        anchorName,
        api,
        getPos,
        nodeType,
        start,
        view
    ]);
    const calculatePositionOld = (0, $fc4bM.useCallback)(()=>{
        var _$pos$nodeAfter;
        const pos = getPos();
        const $pos = typeof pos === 'number' ? view.state.doc.resolve(pos) : undefined;
        const parentPos = $pos && $pos.depth ? $pos.before() : undefined;
        const node = parentPos !== undefined ? view.state.doc.nodeAt(parentPos) : undefined;
        const nodeTypeWithLevel = $pos !== null && $pos !== void 0 && (_$pos$nodeAfter = $pos.nodeAfter) !== null && _$pos$nodeAfter !== void 0 && _$pos$nodeAfter.isBlock ? (0, $61p1X.getNodeTypeWithLevel)($pos.nodeAfter) : nodeType;
        const parentNodeType = node === null || node === void 0 ? void 0 : node.type.name;
        const supportsAnchor = CSS.supports('top', `anchor(${anchorName} start)`) && CSS.supports('left', `anchor(${anchorName} start)`);
        const safeAnchorName = (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $dp5ck.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: anchorName
        }) : anchorName;
        const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Defence-in-depth guard: since the node decoration sets data-active-drag-handle on the
        // active node, we check for it directly. This is a cheap DOM attribute read (no reflow,
        // no style recalculation) and hides the control if the decoration hasn't been applied yet.
        if ((0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !(dom !== null && dom !== void 0 && dom.hasAttribute((0, $GIvev.ACTIVE_DRAG_HANDLE_ATTR)))) return {
            display: 'none'
        };
        const hasResizer = nodeType === 'table' || nodeType === 'mediaSingle';
        const isExtension = nodeType === 'extension' || nodeType === 'bodiedExtension' || nodeType === 'multiBodiedExtension' && (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true);
        const isBlockCard = nodeType === 'blockCard' && !!blockCardWidth;
        const isEmbedCard = nodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $iZXVC.shouldBeSticky)(nodeType);
        if (supportsAnchor) {
            const anchorStart = $dd72adccc70159c7$var$getDragHandleAnchorReference({
                edge: 'start',
                safeAnchorName: safeAnchorName
            });
            const anchorTop = $dd72adccc70159c7$var$getDragHandleAnchorReference({
                edge: 'top',
                safeAnchorName: safeAnchorName
            });
            const anchorLeft = $dd72adccc70159c7$var$getDragHandleAnchorReference({
                edge: 'left',
                safeAnchorName: safeAnchorName
            });
            const anchorRight = $dd72adccc70159c7$var$getDragHandleAnchorReference({
                edge: 'right',
                safeAnchorName: safeAnchorName
            });
            const bottom = (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $iZXVC.getControlBottomCSSValue)(safeAnchorName, isSticky, isTopLevelNodeValue, isLayoutColumn, (0, $GIvev.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME)) : {};
            return {
                left: isEdgeCase ? `calc(${anchorStart} + ${(0, $iZXVC.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc((${anchorRight} + ${anchorLeft})/2 - ${(0, $GIvev.DRAG_HANDLE_HEIGHT) / 2}px)` : `calc(${anchorStart} - ${0, $gCPs3.DRAG_HANDLE_WIDTH}px - ${(0, $GIvev.dragHandleGap)(nodeType, parentNodeType)}px)`,
                top: (0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutColumn ? `calc(${anchorTop} - ${0, $gCPs3.DRAG_HANDLE_WIDTH}px)` : `calc(${anchorStart} + ${(0, $GIvev.topPositionAdjustment)(nodeTypeWithLevel, (dom === null || dom === void 0 ? void 0 : dom.getAttribute('layout')) || '')}px)`,
                ...bottom
            };
        }
        const height = (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $iZXVC.getControlHeightCSSValue)((0, $iZXVC.getNodeHeight)(dom, safeAnchorName, anchorRectCache) || 0, isSticky, isTopLevelNodeValue, `${(0, $GIvev.DRAG_HANDLE_HEIGHT)}`, isLayoutColumn) : {};
        return {
            left: isEdgeCase ? `calc(${(dom === null || dom === void 0 ? void 0 : dom.offsetLeft) || 0}px + ${(0, $iZXVC.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType)})` : (0, $iZXVC.getLeftPosition)(dom, nodeType, innerContainer, isMacroInteractionUpdates, parentNodeType),
            top: (0, $iZXVC.getTopPosition)(dom, nodeTypeWithLevel),
            ...height
        };
    }, [
        anchorName,
        getPos,
        view,
        nodeType,
        blockCardWidth,
        macroInteractionUpdates,
        anchorRectCache,
        isTopLevelNodeValue,
        isLayoutColumn
    ]);
    const isReliableAnchorEnabled = (0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true);
    const docDepForReliableAnchor = isReliableAnchorEnabled ? view.state.doc : undefined;
    // Effect 1 (reliable-anchor ON): fires when non-doc deps change (e.g. blockCardWidth,
    // anchorRectCache, macroInteractionUpdates, isTopLevelNodeValue, isLayoutColumn via
    // calculatePositionOld) — always recalculates without the doc guard, so non-doc position
    // changes are never incorrectly skipped.
    (0, $fc4bM.useEffect)(()=>{
        if (!isReliableAnchorEnabled) return;
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $6Zi52.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
            hasCalculatedInitialPosition.current = true;
        });
        return ()=>{
            var _cleanUpTransitionLis;
            cancelAnimationFrame(calcPos);
            (_cleanUpTransitionLis = cleanUpTransitionListener) === null || _cleanUpTransitionLis === void 0 || _cleanUpTransitionLis();
        };
    }, [
        isReliableAnchorEnabled,
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType
    ]);
    // Effect 2 (reliable-anchor ON): fires when the doc changes — carries the DOM-attribute
    // guard to skip recalc when a drag handle is active (pure keystroke during drag).
    // Effect (reliable-anchor OFF): single combined effect, original behaviour.
    (0, $fc4bM.useEffect)(()=>{
        if (isReliableAnchorEnabled) {
            // Doc-change only effect: apply the DOM-attribute guard.
            // React's dep comparison already ensures this only runs when docDepForReliableAnchor
            // (i.e. view.state.doc) changed, so no manual ref tracking is needed.
            if (!hasCalculatedInitialPosition.current) return;
            const calcPos = requestAnimationFrame(()=>{
                const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${anchorName}"]`);
                if (dom !== null && dom !== void 0 && dom.hasAttribute((0, $GIvev.ACTIVE_DRAG_HANDLE_ATTR))) return;
                setPositionStylesOld(calculatePositionOld());
            });
            return ()=>{
                cancelAnimationFrame(calcPos);
            };
        }
        // reliable-anchor OFF: original single-effect behaviour (no guard).
        let cleanUpTransitionListener;
        if (nodeType === 'extension' || nodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${anchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $6Zi52.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStylesOld(calculatePositionOld());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStylesOld(calculatePositionOld());
            hasCalculatedInitialPosition.current = true;
        });
        return ()=>{
            var _cleanUpTransitionLis2;
            cancelAnimationFrame(calcPos);
            (_cleanUpTransitionLis2 = cleanUpTransitionListener) === null || _cleanUpTransitionLis2 === void 0 || _cleanUpTransitionLis2();
        };
    }, [
        isReliableAnchorEnabled,
        calculatePositionOld,
        view.dom,
        anchorName,
        nodeType,
        docDepForReliableAnchor
    ]);
    const isHandleShown = positionStylesOld.display !== 'none';
    (0, $fc4bM.useEffect)(()=>{
        if (!(handleOptions !== null && handleOptions !== void 0 && handleOptions.isFocused && isHandleShown && buttonRef.current)) return;
        // isHandleShown means the handle has been positioned, but an ancestor can still be
        // visibility:hidden or display:none for a frame, in which case focus() is a silent no-op.
        // Focus now, and if activeElement shows it did not land, retry on the next few frames.
        let rafId;
        let attempts = 0;
        const MAX_ATTEMPTS = 5;
        const focusHandle = ()=>{
            var _getDocument2;
            const button = buttonRef.current;
            if (!button) return;
            button.focus();
            // getDocument() is the same document handleKeyDownNew reads activeElement from, so
            // this confirms Space/Enter will act on the handle rather than silently no-op.
            if (((_getDocument2 = (0, $j5N6B.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.activeElement) === button || attempts >= MAX_ATTEMPTS) return;
            attempts++;
            rafId = requestAnimationFrame(focusHandle);
        };
        focusHandle();
        return ()=>{
            if (rafId !== undefined) cancelAnimationFrame(rafId);
            view.focus();
        };
    }, [
        buttonRef,
        handleOptions === null || handleOptions === void 0 ? void 0 : handleOptions.isFocused,
        view,
        isHandleShown
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (typeof start !== 'number' || !selection) return;
        setDragHandleSelected((0, $7f0FC.isHandleCorrelatedToSelection)(view.state, selection, start));
    }, [
        start,
        selection,
        view
    ]);
    const dragHandleMessage = formatMessage((0, $7u4Lo.messages).dragToMoveClickToOpen, {
        br: /*#__PURE__*/ (0, $jctmk.jsx)("br", null)
    });
    // Create a string version for aria-label
    const dragHandleAriaLabel = formatMessage((0, $7u4Lo.messages).dragToMoveClickToOpen, {
        br: ' '
    });
    let helpDescriptors = isTopLevelNodeValue ? [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveUp),
            keymap: (0, $eUtBU.dragToMoveUp)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveDown),
            keymap: (0, $eUtBU.dragToMoveDown)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveLeft),
            keymap: (0, $eUtBU.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveRight),
            keymap: (0, $eUtBU.dragToMoveRight)
        }
    ] : [
        {
            description: dragHandleMessage
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveUp),
            keymap: (0, $eUtBU.dragToMoveUp)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveDown),
            keymap: (0, $eUtBU.dragToMoveDown)
        }
    ];
    let isParentNodeOfTypeLayout;
    if (!isTopLevelNodeValue) {
        const pos = getPos();
        if (typeof pos === 'number') {
            var _$pos$parent;
            const $pos = view.state.doc.resolve(pos);
            isParentNodeOfTypeLayout = ($pos === null || $pos === void 0 || (_$pos$parent = $pos.parent) === null || _$pos$parent === void 0 ? void 0 : _$pos$parent.type.name) === 'layoutColumn';
        }
        if (isParentNodeOfTypeLayout) helpDescriptors = [
            ...helpDescriptors,
            {
                description: formatMessage((0, $7u4Lo.messages).moveLeft),
                keymap: (0, $eUtBU.dragToMoveLeft)
            },
            {
                description: formatMessage((0, $7u4Lo.messages).moveRight),
                keymap: (0, $eUtBU.dragToMoveRight)
            }
        ];
    }
    // When advanced layout is on, layout column drag handle show only show 'Drag to move', no shortcuts
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true) && nodeType === 'layoutColumn') helpDescriptors = [
        {
            description: formatMessage((0, $7u4Lo.messages).dragToRearrange)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveUp),
            keymap: (0, $eUtBU.dragToMoveUp)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveDown),
            keymap: (0, $eUtBU.dragToMoveDown)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveLeft),
            keymap: (0, $eUtBU.dragToMoveLeft)
        },
        {
            description: formatMessage((0, $7u4Lo.messages).moveRight),
            keymap: (0, $eUtBU.dragToMoveRight)
        }
    ];
    if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) helpDescriptors = [
        {
            description: dragHandleMessage
        }
    ];
    const message = helpDescriptors.map((descriptor)=>{
        return descriptor.keymap ? [
            descriptor.description,
            (0, $eUtBU.getAriaKeyshortcuts)(descriptor.keymap)
        ] : [
            descriptor.description
        ];
    }).join('. ');
    const handleOnDrop = (event)=>{
        event.stopPropagation();
    };
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    const browser = (0, $dqFZv.getBrowserInfo)();
    const renderButton = ()=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $jctmk.jsx)("button", {
            type: "button",
            css: [
                (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? $dd72adccc70159c7$var$dragHandleButtonStyles : $dd72adccc70159c7$var$dragHandleButtonStylesOld,
                (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') && $dd72adccc70159c7$var$dragHandleColor,
                // ED-26266: Fixed the drag handle highlight when selecting multiple line in Firefox
                // See https://product-fabric.atlassian.net/browse/ED-26266
                browser.gecko && $dd72adccc70159c7$var$dragHandleMultiLineSelectionFixFirefox,
                (0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutColumn && $dd72adccc70159c7$var$layoutColumnDragHandleStyles,
                dragHandleSelected && hasHadInteraction && $dd72adccc70159c7$var$selectedStyles,
                (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && (0, $kaRof.editorExperiment)('platform_editor_controls', 'control') && $dd72adccc70159c7$var$dragHandleButtonSmallScreenStyles,
                isFocused && $dd72adccc70159c7$var$keyboardFocusedDragHandleStyles,
                $dd72adccc70159c7$var$focusedStyles,
                $dd72adccc70159c7$var$dragHandleButtonScaledStyles
            ],
            ref: buttonRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: !(0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? positionStylesOld : {},
            onMouseDown: (0, $3NBIB.expValEqualsNoExposure)('platform_editor_selection_toolbar_block_handle', 'isEnabled', true) ? handleMouseDown : undefined,
            onMouseUp: handleMouseUp,
            onClick: handleOnClickNew,
            onKeyDown: handleKeyDownNew,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDrop: handleOnDrop,
            "data-editor-block-ctrl-drag-handle": true,
            "data-blocks-drag-handle": true,
            "data-testid": "block-ctrl-drag-handle",
            "aria-label": dragHandleAriaLabel,
            onBlur: ()=>{
                setIsFocused(false);
                const pos = getPos();
                if (pos !== undefined) {
                    var _api$core5;
                    api === null || api === void 0 || (_api$core5 = api.core) === null || _api$core5 === void 0 || _api$core5.actions.execute(({ tr: tr })=>{
                        tr.setMeta((0, $gyNLa.key), {
                            activeNode: {
                                pos: pos,
                                anchorName: anchorName,
                                nodeType: nodeType,
                                handleOptions: {
                                    isFocused: false
                                }
                            }
                        });
                        return tr;
                    });
                }
            }
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
            xcss: $dd72adccc70159c7$var$iconWrapperStyles,
            // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop
            onDragStart: $dd72adccc70159c7$var$handleIconDragStart
        }, (0, $fcDy5.shouldUseNestedDragHandleIcon)(isTopLevelNodeValue, isLayoutColumn) ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $yOdik.DragHandleNestedIcon), null) : /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kzYZ0))), {
            spacing: "spacious",
            label: "",
            size: "small"
        })));
    const stickyWithTooltip = ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: positionStylesOld,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $dd72adccc70159c7$var$dragHandleContainerStyles
            ],
            as: "span",
            testId: "block-ctrl-drag-handle-container"
        }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
            css: [
                $dd72adccc70159c7$var$tooltipContainerStyles,
                (0, $iZXVC.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $dd72adccc70159c7$var$tooltipContainerStylesImprovedStickyHeaderWithMask,
                !(0, $iZXVC.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $dd72adccc70159c7$var$tooltipContainerStylesStickyHeaderWithoutMask
            ]
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
            content: tooltipContent,
            ignoreTooltipPointerEvents: true,
            position: 'top',
            tag: (0, $dRkX9.fg)('platform-dst-top-layer-tooltip') ? 'span' : 'div',
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onShow: ()=>{
                var _api$accessibilityUti;
                api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 || _api$accessibilityUti.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
            css: [
                (0, $iZXVC.shouldMaskNodeControls)(nodeType, isTopLevelNodeValue) && $dd72adccc70159c7$var$buttonWrapperStylesNoBackground,
                $dd72adccc70159c7$var$buttonWrapperStylesPatch
            ]
        }, renderButton()))));
    const buttonWithTooltip = ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
            content: tooltipContent,
            ignoreTooltipPointerEvents: true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onShow: ()=>{
                var _api$accessibilityUti2;
                api === null || api === void 0 || (_api$accessibilityUti2 = api.accessibilityUtils) === null || _api$accessibilityUti2 === void 0 || _api$accessibilityUti2.actions.ariaNotify(message, {
                    priority: 'important'
                });
            }
        }, renderButton());
    const tooltipContent = isLayoutColumn && currentUserIntent === 'layoutColumnMenuPopupOpen' ? null : /*#__PURE__*/ (0, $jctmk.jsx)((0, $eUtBU.TooltipContentWithMultipleShortcuts), {
        helpDescriptors: helpDescriptors
    });
    return (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? stickyWithTooltip() : buttonWithTooltip();
};
const $dd72adccc70159c7$export$c3c91925cdbf4b0b = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, nodeType: nodeType, handleOptions: handleOptions, isTopLevelNode: isTopLevelNode, anchorRectCache: anchorRectCache })=>{
    const rightSideControlsEnabled = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>{
        var _states$blockControls;
        return {
            rightSideControlsEnabled: ((_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.rightSideControlsEnabled) ?? false
        };
    }).rightSideControlsEnabled;
    // Layout column drag handles sit at the top-centre of each column, not on a left/right edge.
    // Don't restrict by hoverSide for layout columns — the drag handle should always be visible
    // when hovering anywhere over the column, regardless of which side of the layoutSection the
    // column is on. (The right-side remix button is a separate node decoration and is unaffected.)
    const isLayoutColumn = nodeType === 'layoutColumn';
    // Skip the right-side controlSide restriction for non-top-level nodes. The restriction exists
    // to avoid showing the drag handle and remix button simultaneously — but remix only applies to
    // top-level nodes, so non-top-level nodes should never be restricted.
    // Gated behind platform_editor_controls_reliable_anchor.
    const skipControlSideRestriction = (0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && isTopLevelNode === false;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5wcYI.VisibilityContainer), {
        api: api,
        controlSide: !isLayoutColumn && !skipControlSideRestriction && rightSideControlsEnabled ? 'left' : undefined,
        forceVisibleOnMouseOut: !!(handleOptions !== null && handleOptions !== void 0 && handleOptions.isFocused),
        shouldUseDisplayContents: isLayoutColumn && (0, $dRkX9.fg)('platform-dst-top-layer-tooltip')
    }, /*#__PURE__*/ (0, $jctmk.jsx)($dd72adccc70159c7$export$a0c24614540b0efb, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        anchorName: anchorName,
        nodeType: nodeType,
        handleOptions: handleOptions,
        anchorRectCache: anchorRectCache
    }));
};

});
parcelRegister("3TAWV", function(module, exports) {
$parcel$export(module.exports, "attachMoveNodeAnalytics", () => $7a2d232e32cc912e$export$991fd708287269fd);
$parcel$export(module.exports, "fireInsertLayoutAnalytics", () => $7a2d232e32cc912e$export$9d441c3a20655711);
$parcel$export(module.exports, "getMultiSelectAnalyticsAttributes", () => $7a2d232e32cc912e$export$9f4024dd9bfa7336);

var $3LeME = parcelRequire("3LeME");
const $7a2d232e32cc912e$export$991fd708287269fd = (tr, inputMethod, fromDepth, fromNodeTypes, toDepth, toNodeType, isSameParent, api, hasSelectedMultipleNodes)=>{
    var _api$analytics;
    return api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.attachAnalyticsEvent({
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        action: (0, $3LeME.ACTION).MOVED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
        attributes: {
            nodeDepth: fromDepth,
            nodeTypes: fromNodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            destinationNodeDepth: toDepth,
            destinationNodeType: toNodeType,
            isSameParent: isSameParent,
            inputMethod: inputMethod
        }
    })(tr);
};
const $7a2d232e32cc912e$export$9d441c3a20655711 = (tr, api, nodeTypes, hasSelectedMultipleNodes, columnCount)=>{
    var _api$analytics2;
    api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.attachAnalyticsEvent({
        action: (0, $3LeME.ACTION).INSERTED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT,
        attributes: {
            inputMethod: (0, $3LeME.INPUT_METHOD).DRAG_AND_DROP,
            nodeTypes: nodeTypes,
            hasSelectedMultipleNodes: hasSelectedMultipleNodes,
            columnCount: columnCount
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    })(tr);
};
const $7a2d232e32cc912e$export$9f4024dd9bfa7336 = (tr, anchor, head)=>{
    const nodeTypes = [];
    const from = Math.min(anchor, head);
    const to = Math.max(anchor, head);
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (pos < from) // ignore parent node
        return true;
        nodeTypes.push(node.type.name);
        // only care about the top level (relatively in the range) nodes
        return false;
    });
    return {
        nodeTypes: [
            ...new Set(nodeTypes)
        ].sort().join(','),
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};

});

parcelRegister("iZXVC", function(module, exports) {
$parcel$export(module.exports, "getTopPosition", () => $fc73ea95a59bca14$export$3c9c03fbeb71a88);
$parcel$export(module.exports, "getLeftPosition", () => $fc73ea95a59bca14$export$c3d34436f1edd9bd);
$parcel$export(module.exports, "getNodeHeight", () => $fc73ea95a59bca14$export$d106346a0f891cc2);
$parcel$export(module.exports, "shouldBeSticky", () => $fc73ea95a59bca14$export$f988e74eefbc47fc);
$parcel$export(module.exports, "getControlBottomCSSValue", () => $fc73ea95a59bca14$export$cc6777b6e60d5179);
$parcel$export(module.exports, "getControlHeightCSSValue", () => $fc73ea95a59bca14$export$738fa80805cb522c);
$parcel$export(module.exports, "shouldMaskNodeControls", () => $fc73ea95a59bca14$export$9a1c84c70b9df34);

var $jiju3 = parcelRequire("jiju3");

var $gCPs3 = parcelRequire("gCPs3");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $GIvev = parcelRequire("GIvev");
const $fc73ea95a59bca14$var$STICKY_NODES = [
    'panel',
    'table',
    'expand',
    'layoutSection',
    'bodiedExtension'
];
const $fc73ea95a59bca14$export$3c9c03fbeb71a88 = (dom, type)=>{
    if (!dom) return 'auto';
    const table = dom.querySelector('table');
    const isTable = table && (!type || type === 'table');
    if (isTable) return `${dom.offsetTop + ((table === null || table === void 0 ? void 0 : table.offsetTop) || 0)}px`;
    else if (type === 'rule') return `${dom.offsetTop - (0, $GIvev.DRAG_HANDLE_DIVIDER_TOP_ADJUSTMENT)}px`;
    else if (type === 'layoutColumn') return `${-dom.offsetTop / 2}px`;
    else if (type === 'heading-1') return `${dom.offsetTop + (0, $GIvev.DRAG_HANDLE_H1_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-2') return `${dom.offsetTop + (0, $GIvev.DRAG_HANDLE_H2_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-3') return `${dom.offsetTop}px`;
    else if (type === 'heading-4') return `${dom.offsetTop - (0, $GIvev.DRAG_HANDLE_H4_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-5') return `${dom.offsetTop - (0, $GIvev.DRAG_HANDLE_H5_TOP_ADJUSTMENT)}px`;
    else if (type === 'heading-6') return `${dom.offsetTop - (0, $GIvev.DRAG_HANDLE_H6_TOP_ADJUSTMENT)}px`;
    else if (type === 'paragraph-small') return `${dom.offsetTop + (0, $GIvev.DRAG_HANDLE_PARAGRAPH_SMALL_TOP_ADJUSTMENT)}px`;
    else if (type === 'paragraph') return `${dom.offsetTop + (0, $GIvev.DRAG_HANDLE_PARAGRAPH_TOP_ADJUSTMENT)}px`;
    else return `${dom.offsetTop}px`;
};
const $fc73ea95a59bca14$export$c3d34436f1edd9bd = (dom, type, innerContainer, macroInteractionUpdates, parentType)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return type === 'layoutColumn' ? `${dom.offsetLeft + dom.clientWidth / 2 - (0, $GIvev.DRAG_HANDLE_HEIGHT) / 2}px` : `${dom.offsetLeft - (0, $GIvev.dragHandleGap)(type, parentType) - (0, $gCPs3.DRAG_HANDLE_WIDTH)}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $GIvev.dragHandleGap)(type, parentType) - (0, $gCPs3.DRAG_HANDLE_WIDTH)}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $GIvev.dragHandleGap)(type, parentType) - (0, $gCPs3.DRAG_HANDLE_WIDTH)}px`;
};
const $fc73ea95a59bca14$export$d106346a0f891cc2 = (dom, anchor, anchorRectCache)=>(anchorRectCache === null || anchorRectCache === void 0 ? void 0 : anchorRectCache.getHeight(anchor)) || (dom === null || dom === void 0 ? void 0 : dom.offsetHeight);
const $fc73ea95a59bca14$var$getStickyNodes = (0, $jiju3.default)(()=>[
        ...$fc73ea95a59bca14$var$STICKY_NODES,
        ...(0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : []
    ]);
const $fc73ea95a59bca14$export$f988e74eefbc47fc = (nodeType)=>{
    return (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') && $fc73ea95a59bca14$var$getStickyNodes().includes(nodeType);
};
const $fc73ea95a59bca14$export$cc6777b6e60d5179 = (anchor, isSticky, isTopLevelNode, isLayoutColumn, fallbackAnchor)=>{
    if ((0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) return (0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        bottom: 'unset'
    } : {
        bottom: fallbackAnchor ? `anchor(${anchor} end, anchor(${fallbackAnchor} end))` : `anchor(${anchor} end)`
    };
    return (0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        bottom: 'unset'
    } : {
        bottom: `anchor(${anchor} end)`
    };
};
const $fc73ea95a59bca14$export$738fa80805cb522c = (nodeHeight, isSticky, isTopLevelNode, fallbackPxHeight, isLayoutColumn)=>{
    return (0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutColumn || !isSticky || !isTopLevelNode ? {
        height: 'unset'
    } : {
        height: `${nodeHeight || fallbackPxHeight}px`
    };
};
const $fc73ea95a59bca14$export$9a1c84c70b9df34 = (nodeType, isTopLevelNode)=>{
    return(// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    isTopLevelNode && [
        'table'
    ].includes(nodeType) && (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1'));
};

});

parcelRegister("lE9Q7", function(module, exports) {
$parcel$export(module.exports, "expandAndUpdateSelection", () => $f85d6e2e1695a68c$export$35df69b489f451a1);

var $khZ46 = parcelRequire("khZ46");

var $6Irkk = parcelRequire("6Irkk");

var $d1RPX = parcelRequire("d1RPX");

var $801jp = parcelRequire("801jp");

var $8gqHt = parcelRequire("8gqHt");

var $dRkX9 = parcelRequire("dRkX9");

var $7f0FC = parcelRequire("7f0FC");

var $g4us8 = parcelRequire("g4us8");
const $f85d6e2e1695a68c$var$isPosWithinRange = (pos, range)=>{
    return range.start <= pos && range.end >= pos + 1;
};
/**
 * Expands the current selection to encompass the full block range
 * starting from the given resolved position.
 */ const $f85d6e2e1695a68c$var$getExpandedSelectionRange = ({ selection: selection, doc: doc, resolvedStartPos: resolvedStartPos, isShiftPressed: isShiftPressed })=>{
    // When not pressing shift, expand the current selection
    // When shift selecting upwards, expand from start of node to selection end
    // When shift selecting downwards, expand from selection start to end of node
    const selectUp = resolvedStartPos.pos < selection.from;
    const $from = isShiftPressed && selectUp ? resolvedStartPos : selection.$from;
    const $to = isShiftPressed && !selectUp ? doc.resolve(resolvedStartPos.pos + 1) : selection.$to;
    const adjusted = isShiftPressed ? {
        $from: $from,
        $to: $to
    } : (0, $g4us8.adjustSelectionBoundsForEdgePositions)($from, $to);
    return (0, $d1RPX.expandToBlockRange)(adjusted.$from, adjusted.$to);
};
const $f85d6e2e1695a68c$export$35df69b489f451a1 = ({ tr: tr, selection: selection, startPos: startPos, isShiftPressed: isShiftPressed, nodeType: nodeType, api: api })=>{
    const resolvedStartPos = tr.doc.resolve(startPos);
    const expandedRange = $f85d6e2e1695a68c$var$getExpandedSelectionRange({
        doc: tr.doc,
        selection: selection,
        resolvedStartPos: resolvedStartPos,
        isShiftPressed: isShiftPressed
    });
    // Set selection to expanded selection range if it encompasses the clicked drag handle
    if (expandedRange.range && $f85d6e2e1695a68c$var$isPosWithinRange(startPos, expandedRange.range) && (0, $6Irkk.isMultiBlockRange)(expandedRange.range)) // Then create a selection from the start of the first node to the end of the last node
    tr.setSelection((0, $801jp.TextSelection).create(tr.doc, Math.min(selection.from, expandedRange.$from.pos), Math.max(selection.to, expandedRange.$to.pos)));
    else if ((0, $dRkX9.fg)('platform_editor_maui_jira_updates')) // Under the gate (and when on the simplified newGetSelection path), use
    // the platform-level composer — same path as open-remix-modal, no drift.
    (0, $khZ46.selectNodeAtPos)(tr, startPos, nodeType);
    else if (nodeType === 'table') (0, $8gqHt.selectTableClosestToPos)(tr, tr.doc.resolve(startPos + 1));
    else // Select the clicked drag handle's node only
    (0, $7f0FC.selectNode)(tr, startPos, nodeType, api);
};

});
parcelRegister("khZ46", function(module, exports) {
$parcel$export(module.exports, "getNodeSelectionForPos", () => $8f25509aa48c7d81$export$f4b94aaa3c88263b);
$parcel$export(module.exports, "selectNodeAtPos", () => $8f25509aa48c7d81$export$a35518af0efc77c7);

var $801jp = parcelRequire("801jp");

var $8gqHt = parcelRequire("8gqHt");
const $8f25509aa48c7d81$export$f4b94aaa3c88263b = (doc, start)=>{
    const node = doc.nodeAt(start);
    if (!node) return false;
    if (node.type.name === 'mediaGroup' && node.childCount === 1) return new (0, $801jp.NodeSelection)(doc.resolve(start + 1));
    return new (0, $801jp.NodeSelection)(doc.resolve(start));
};
const $8f25509aa48c7d81$export$301ee8a09bc7f6dc = (tr, tableNodePos)=>{
    (0, $8gqHt.selectTableClosestToPos)(tr, tr.doc.resolve(tableNodePos + 1));
    return tr;
};
const $8f25509aa48c7d81$export$a35518af0efc77c7 = (tr, nodePos, nodeType)=>{
    if (nodeType === 'table') return $8f25509aa48c7d81$export$301ee8a09bc7f6dc(tr, nodePos);
    const selection = $8f25509aa48c7d81$export$f4b94aaa3c88263b(tr.doc, nodePos);
    if (selection) tr.setSelection(selection);
    return tr;
};

});
parcelRegister("8gqHt", function(module, exports) {
$parcel$export(module.exports, "selectTableClosestToPos", () => $0128bc7c4c05950b$export$3e7c4d16b1cc1be3);

var $dXesv = parcelRequire("dXesv");

var $1quqk = parcelRequire("1quqk");
const $0128bc7c4c05950b$export$3e7c4d16b1cc1be3 = (tr, $pos)=>{
    const tableSelection = (0, $1quqk.getTableSelectionClosesToPos)($pos);
    if (tableSelection) return (0, $dXesv.cloneTr)(tr.setSelection(tableSelection));
    return tr;
};

});
parcelRegister("dXesv", function(module, exports) {
$parcel$export(module.exports, "cloneTr", () => $277747f5e67bbf99$export$5add988076756575);
const $277747f5e67bbf99$export$5add988076756575 = (tr)=>Object.assign(Object.create(tr), tr).setTime(Date.now());

});

parcelRegister("1quqk", function(module, exports) {
$parcel$export(module.exports, "getTableSelectionClosesToPos", () => $df18e8faaf6f7f10$export$cec96519863940d);

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $5JFXS = parcelRequire("5JFXS");
const $df18e8faaf6f7f10$export$cec96519863940d = ($pos)=>{
    const table = (0, $5JFXS.findTableClosestToPos)($pos);
    if (table) {
        const { map: map } = (0, $dpooP.TableMap).get(table.node);
        if (map && map.length) {
            const head = table.start + map[0];
            const anchor = table.start + map[map.length - 1];
            const $head = $pos.doc.resolve(head);
            const $anchor = $pos.doc.resolve(anchor);
            return new (0, $ev7OZ.CellSelection)($anchor, $head);
        }
    }
};

});



parcelRegister("7f0FC", function(module, exports) {
$parcel$export(module.exports, "newGetSelection", () => $218329d13193b0f0$export$2ad544f897362d62);
$parcel$export(module.exports, "selectNode", () => $218329d13193b0f0$export$cbcb4f775d907a9e);
$parcel$export(module.exports, "setCursorPositionAtMovedNode", () => $218329d13193b0f0$export$4b5c09668d5b4e01);
$parcel$export(module.exports, "isHandleCorrelatedToSelection", () => $218329d13193b0f0$export$e89bc339b843c7b);

var $khZ46 = parcelRequire("khZ46");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $fmnS6 = parcelRequire("fmnS6");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $8gqHt = parcelRequire("8gqHt");

var $dRkX9 = parcelRequire("dRkX9");
const $218329d13193b0f0$export$eefc237c5f2aa5b9 = (doc, start, nodeSize)=>{
    const $startPos = doc.resolve(start);
    // To trigger the annotation floating toolbar for non-selectable node, we need to select inline nodes
    // Find the first inline node in the node
    let inlineNodePos = start;
    let foundInlineNode = false;
    let inlineNodeEndPos = 0;
    doc.nodesBetween($startPos.pos, $startPos.pos + nodeSize, (n, pos)=>{
        if (n.isInline) inlineNodeEndPos = pos + n.nodeSize;
        if (n.isInline && !foundInlineNode) {
            inlineNodePos = pos;
            foundInlineNode = true;
        }
        return true;
    });
    return {
        inlineNodePos: inlineNodePos,
        inlineNodeEndPos: inlineNodeEndPos
    };
};
const $218329d13193b0f0$export$2ad544f897362d62 = (doc, selectionEmpty, start)=>{
    if ((0, $dRkX9.fg)('platform_editor_maui_jira_updates')) return (0, $khZ46.getNodeSelectionForPos)(doc, start) || false;
    const node = doc.nodeAt(start);
    const nodeName = node === null || node === void 0 ? void 0 : node.type.name;
    // if mediaGroup only has a single child, we want to select the child
    if (nodeName === 'mediaGroup' && (node === null || node === void 0 ? void 0 : node.childCount) === 1) {
        const $mediaStartPos = doc.resolve(start + 1);
        return new (0, $801jp.NodeSelection)($mediaStartPos);
    }
    return new (0, $801jp.NodeSelection)(doc.resolve(start));
};
const $218329d13193b0f0$export$ca798a7e6e94638c = (tr, start)=>{
    return $218329d13193b0f0$export$2ad544f897362d62(tr.doc, tr.selection.empty, start);
};
const $218329d13193b0f0$export$cbcb4f775d907a9e = (tr, start, nodeType, api)=>{
    if ((0, $dRkX9.fg)('platform_editor_maui_jira_updates')) return (0, $khZ46.selectNodeAtPos)(tr, start, nodeType);
    if (nodeType === 'table') {
        tr = (0, $8gqHt.selectTableClosestToPos)(tr, tr.doc.resolve(start + 1));
        return tr;
    }
    const selection = $218329d13193b0f0$export$ca798a7e6e94638c(tr, start);
    if (selection) tr.setSelection(selection);
    return tr;
};
const $218329d13193b0f0$export$4b5c09668d5b4e01 = (tr, start, api)=>{
    const node = tr.doc.nodeAt(start);
    const isNodeSelection = node && (0, $801jp.NodeSelection).isSelectable(node);
    const nodeSize = node ? node.nodeSize : 1;
    let selection;
    // decisionList node is not selectable, but we want to select the whole node not just text
    // blockQuote is selectable, but we want to set cursor at the inline end Pos instead of the gap cursor as this causes jittering post drop
    if (isNodeSelection && node.type.name !== 'blockquote' || (node === null || node === void 0 ? void 0 : node.type.name) === 'decisionList') {
        selection = new (0, $ihNBw.GapCursorSelection)(tr.doc.resolve(start + node.nodeSize), (0, $id3e6.Side).RIGHT);
        tr.setSelection(selection);
        return tr;
    }
    // this is a fix for empty paragraph selection - can safely use start position as the paragraph is empty
    if ((node === null || node === void 0 ? void 0 : node.type.name) === 'paragraph' && (node === null || node === void 0 ? void 0 : node.childCount) === 0 && (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar))) {
        const selection = new (0, $801jp.TextSelection)(tr.doc.resolve(start));
        tr.setSelection(selection);
        return tr;
    }
    const { inlineNodeEndPos: inlineNodeEndPos } = $218329d13193b0f0$export$eefc237c5f2aa5b9(tr.doc, start, nodeSize);
    selection = new (0, $801jp.TextSelection)(tr.doc.resolve(inlineNodeEndPos));
    tr.setSelection(selection);
    return tr;
};
const $218329d13193b0f0$export$e89bc339b843c7b = (state, selection, handlePos)=>{
    if (selection.empty) return false;
    let nodeStart;
    const $selectionFrom = selection.$from;
    nodeStart = $selectionFrom.before($selectionFrom.sharedDepth(selection.to) + 1);
    if (nodeStart === $selectionFrom.pos) nodeStart = $selectionFrom.depth ? $selectionFrom.before() : $selectionFrom.pos;
    const $resolvedNodePos = state.doc.resolve(nodeStart);
    if ([
        'tableRow',
        'tableCell',
        'tableHeader'
    ].includes($resolvedNodePos.node().type.name)) {
        const parentNodeFindRes = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes['table'])(selection);
        const tablePos = parentNodeFindRes === null || parentNodeFindRes === void 0 ? void 0 : parentNodeFindRes.pos;
        nodeStart = typeof tablePos === 'undefined' ? nodeStart : tablePos;
    } else if ([
        'listItem'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before($218329d13193b0f0$export$3ee0594e8fdf55d5($resolvedNodePos));
    else if ([
        'taskList'
    ].includes($resolvedNodePos.node().type.name)) {
        const listdepth = $218329d13193b0f0$export$7116b8011b79af5e($resolvedNodePos);
        nodeStart = $resolvedNodePos.before(listdepth);
    } else if ([
        'blockquote'
    ].includes($resolvedNodePos.node().type.name)) nodeStart = $resolvedNodePos.before();
    return Boolean(handlePos < selection.$to.pos && handlePos >= nodeStart);
};
const $218329d13193b0f0$export$3ee0594e8fdf55d5 = (itemPos)=>{
    let depth;
    for(let i = itemPos.depth; i > 1; i -= 2){
        const node = itemPos.node(i);
        if (node.type.name === 'listItem') depth = i - 1;
        else break;
    }
    return depth;
};
const $218329d13193b0f0$export$7116b8011b79af5e = (taskListPos)=>{
    let depth;
    for(let i = taskListPos.depth; i > 0; i--){
        const node = taskListPos.node(i);
        if (node.type.name === 'taskList' || node.type.name === 'taskItem') depth = i;
        else break;
    }
    return depth;
};

});

parcelRegister("g4us8", function(module, exports) {
$parcel$export(module.exports, "getMultiSelectionIfPosInside", () => $9d5acc1720ff52ec$export$4e8a3dde481e0452);
$parcel$export(module.exports, "getSelectedSlicePosition", () => $9d5acc1720ff52ec$export$5e3fa240bc795f26);
$parcel$export(module.exports, "mapPreservedSelection", () => $9d5acc1720ff52ec$export$e21678cf246ba963);
$parcel$export(module.exports, "createPreservedSelection", () => $9d5acc1720ff52ec$export$fa43757966d274e3);
$parcel$export(module.exports, "adjustSelectionBoundsForEdgePositions", () => $9d5acc1720ff52ec$export$59e281d427887933);

var $j8e2o = parcelRequire("j8e2o");

var $6Irkk = parcelRequire("6Irkk");

var $d1RPX = parcelRequire("d1RPX");

var $801jp = parcelRequire("801jp");

var $1quqk = parcelRequire("1quqk");

var $gyNLa = parcelRequire("gyNLa");

var $7f0FC = parcelRequire("7f0FC");
const $9d5acc1720ff52ec$export$4e8a3dde481e0452 = (api, pos, tr)=>{
    var _api$blockControls, _tr$getMeta;
    const pluginState = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState();
    // With move nodes shortcut, we expand selection and move node within one transaction,
    // Hence we also look for `multiSelectDnD` in transaction meta
    const multiSelectDnD = (pluginState === null || pluginState === void 0 ? void 0 : pluginState.multiSelectDnD) ?? (tr === null || tr === void 0 || (_tr$getMeta = tr.getMeta((0, $gyNLa.key))) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.multiSelectDnD);
    if (multiSelectDnD && multiSelectDnD.anchor >= 0 && multiSelectDnD.head >= 0) {
        const multiFrom = Math.min(multiSelectDnD.anchor, multiSelectDnD.head);
        const multiTo = Math.max(multiSelectDnD.anchor, multiSelectDnD.head);
        // We subtract one as the handle position is before the node
        return pos >= multiFrom - 1 && pos < multiTo ? {
            anchor: multiSelectDnD.anchor,
            head: multiSelectDnD.head
        } : {};
    }
    return {};
};
const $9d5acc1720ff52ec$export$5e3fa240bc795f26 = (handlePos, tr, api)=>{
    const { anchor: anchor, head: head } = $9d5acc1720ff52ec$export$4e8a3dde481e0452(api, handlePos, tr);
    const inSelection = anchor !== undefined && head !== undefined;
    const from = inSelection ? Math.min(anchor || 0, head || 0) : handlePos;
    const activeNode = tr.doc.nodeAt(handlePos);
    const activeNodeEndPos = handlePos + ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.nodeSize) ?? 1);
    const to = inSelection ? Math.max(anchor || 0, head || 0) : activeNodeEndPos;
    return {
        from: from,
        to: to
    };
};
const $9d5acc1720ff52ec$export$e21678cf246ba963 = (selection, tr)=>{
    const { preservedSelectionMapping: preservedSelectionMapping } = (0, $gyNLa.getBlockControlsMeta)(tr) || {};
    const mapping = preservedSelectionMapping || tr.mapping;
    const from = mapping.map(selection.from);
    // When lastNodeMustBeParagraph inserts a trailing paragraph exactly at the end boundary
    // of a preserved block selection, keep the mapped end position on the left side of the
    // inserted paragraph so it is not included in the preserved selection.
    const shouldTrimTrailingParagraph = tr.getMeta((0, $j8e2o.INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META)) === true;
    const to = shouldTrimTrailingParagraph ? mapping.map(selection.to, -1) : mapping.map(selection.to);
    const isSelectionEmpty = from === to;
    const wasSelectionEmpty = selection.from === selection.to;
    if (isSelectionEmpty && !wasSelectionEmpty) // If selection has become empty i.e. content has been deleted, stop preserving
    return undefined;
    return $9d5acc1720ff52ec$export$fa43757966d274e3(tr.doc.resolve(from), tr.doc.resolve(to));
};
const $9d5acc1720ff52ec$var$isInsideEmptyTextblock = ($pos)=>$pos.parent.isTextblock && $pos.parent.content.size === 0;
const $9d5acc1720ff52ec$var$isAtEndOfParent = ($pos)=>$pos.parentOffset === $pos.parent.content.size;
const $9d5acc1720ff52ec$var$isAtStartOfParent = ($pos)=>$pos.parentOffset === 0;
const $9d5acc1720ff52ec$export$59e281d427887933 = ($from, $to)=>{
    const { doc: doc } = $from;
    // Walk $from forward while at end of ancestors
    let adjustedFrom = $from;
    if (!$9d5acc1720ff52ec$var$isInsideEmptyTextblock($from)) while(adjustedFrom.depth > 0 && $9d5acc1720ff52ec$var$isAtEndOfParent(adjustedFrom)){
        const nextPos = adjustedFrom.after();
        if (nextPos > doc.content.size || nextPos === adjustedFrom.pos) break;
        adjustedFrom = doc.resolve(nextPos);
    }
    // Walk $to backward while at start of ancestors
    let adjustedTo = $to;
    if (!$9d5acc1720ff52ec$var$isInsideEmptyTextblock($to)) while(adjustedTo.depth > 0 && $9d5acc1720ff52ec$var$isAtStartOfParent(adjustedTo)){
        const prevPos = adjustedTo.before();
        if (prevPos < 0 || prevPos === adjustedTo.pos) break;
        adjustedTo = doc.resolve(prevPos);
    }
    return {
        $from: adjustedFrom,
        $to: adjustedTo
    };
};
const $9d5acc1720ff52ec$export$fa43757966d274e3 = ($from, $to)=>{
    var _doc$nodeAt;
    const { doc: doc } = $from;
    const isCollapsed = $from.pos === $to.pos;
    const adjusted = isCollapsed ? {
        $from: $from,
        $to: $to
    } : $9d5acc1720ff52ec$export$59e281d427887933($from, $to);
    if (!isCollapsed && adjusted.$from.pos >= adjusted.$to.pos) return undefined;
    // expand the selection range to block boundaries, so selection always includes whole nodes
    const expanded = (0, $d1RPX.expandToBlockRange)(adjusted.$from, adjusted.$to);
    // stop preserving if selection becomes invalid
    if (expanded.$from.pos < 0 || expanded.$to.pos > doc.content.size || expanded.$from.pos >= expanded.$to.pos) return undefined;
    // If multiple blocks selected, create TextSelection from start of first node to end of last node
    if (expanded.range && (0, $6Irkk.isMultiBlockRange)(expanded.range)) return new (0, $801jp.TextSelection)(expanded.$from, expanded.$to);
    const nodeType = (_doc$nodeAt = doc.nodeAt(expanded.$from.pos)) === null || _doc$nodeAt === void 0 || (_doc$nodeAt = _doc$nodeAt.type) === null || _doc$nodeAt === void 0 ? void 0 : _doc$nodeAt.name;
    if (!nodeType) return undefined;
    if (nodeType === 'table') return (0, $1quqk.getTableSelectionClosesToPos)($from);
    return (0, $7f0FC.newGetSelection)(doc, false, expanded.$from.pos) || undefined;
};

});


parcelRegister("yOdik", function(module, exports) {
$parcel$export(module.exports, "DragHandleNestedIcon", () => $13caada1aee2a0a0$export$bd2793d885851030);
/** @jsxRuntime classic */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $jctmk = parcelRequire("jctmk");
function $13caada1aee2a0a0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $13caada1aee2a0a0$var$spanStyles = {
    name: "jpyn4z",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0"
};
const $13caada1aee2a0a0$var$svgSizeStyles = {
    name: "rrel8y",
    styles: "width:24px;height:24px"
};
const $13caada1aee2a0a0$var$svgStyles = {
    name: "1l1mozn",
    styles: "color:currentColor;overflow:hidden;pointer-events:none;vertical-align:bottom"
};
const $13caada1aee2a0a0$export$bd2793d885851030 = ()=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        "aria-hidden": true,
        css: $13caada1aee2a0a0$var$spanStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "-8 -8 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation",
        css: [
            $13caada1aee2a0a0$var$svgStyles,
            $13caada1aee2a0a0$var$svgSizeStyles
        ]
    }, /*#__PURE__*/ (0, $jctmk.jsx)("circle", {
        cx: "8",
        cy: "2.75",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $jctmk.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "1.75",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, $jctmk.jsx)("circle", {
        cx: "8",
        cy: "13.25",
        r: "1.75",
        fill: "currentColor"
    })));
};

});

parcelRegister("fghja", function(module, exports) {
$parcel$export(module.exports, "dragPreview", () => $3b1729369fa4a23a$export$3ec2e625089820fa);

var $dqFZv = parcelRequire("dqFZv");
const $3b1729369fa4a23a$var$previewStyle = {
    borderColor: "var(--ds-border, #0B120E24)",
    borderStyle: 'solid',
    borderRadius: "var(--ds-radius-small, 3px)",
    borderWidth: "var(--ds-border-width-selected, 2px)",
    backgroundColor: "var(--ds-skeleton-subtle, #17171708)"
};
const $3b1729369fa4a23a$var$getPreviewContainerDimensionsForSingle = (dom, nodeType)=>{
    let nodeContainer = dom;
    const iframeContainer = dom.querySelector('iframe');
    if (nodeType === 'embedCard') nodeContainer = dom.querySelector('.rich-media-item') || dom;
    else if (nodeType === 'extension' && iframeContainer) nodeContainer = iframeContainer;
    const nodeContainerRect = nodeContainer.getBoundingClientRect();
    return {
        width: nodeContainerRect.width,
        height: nodeContainerRect.height
    };
};
const $3b1729369fa4a23a$var$getPreviewContainerDimensions = (dragPreviewContent)=>{
    let maxWidth = 0;
    let heightSum = 0;
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const { width: width, height: height } = $3b1729369fa4a23a$var$getPreviewContainerDimensionsForSingle(element.dom, element.nodeType);
        if (width > maxWidth) maxWidth = width;
        heightSum += height;
    }
    return {
        width: maxWidth,
        height: heightSum
    };
};
const $3b1729369fa4a23a$var$createGenericPreview = ()=>{
    const generalPreview = document.createElement('div');
    // ProseMirror class is required to make sure the cloned dom is styled correctly
    generalPreview.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    generalPreview.style.border = `${$3b1729369fa4a23a$var$previewStyle.borderWidth} ${$3b1729369fa4a23a$var$previewStyle.borderStyle} ${$3b1729369fa4a23a$var$previewStyle.borderColor}`;
    generalPreview.style.borderRadius = $3b1729369fa4a23a$var$previewStyle.borderRadius;
    generalPreview.style.backgroundColor = $3b1729369fa4a23a$var$previewStyle.backgroundColor;
    generalPreview.style.height = '100%';
    generalPreview.setAttribute('data-testid', 'block-ctrl-generic-drag-preview');
    return generalPreview;
};
const $3b1729369fa4a23a$var$createContentPreviewElement = (dom, nodeType, nodeSpacing)=>{
    const contentPreviewOneElement = document.createElement('div');
    contentPreviewOneElement.classList.add('ProseMirror', 'block-ctrl-drag-preview');
    const resizer = dom.querySelector('.resizer-item');
    const clonedDom = resizer && [
        'mediaSingle',
        'table'
    ].includes(nodeType) ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    resizer.cloneNode(true) : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom.cloneNode(true);
    const browser = (0, $dqFZv.getBrowserInfo)();
    clonedDom.style.marginLeft = '0';
    clonedDom.style.marginTop = nodeSpacing ? `${nodeSpacing.top}` : '0';
    clonedDom.style.marginRight = '0';
    clonedDom.style.marginBottom = nodeSpacing ? `${nodeSpacing.bottom}` : '0';
    clonedDom.style.boxShadow = 'none';
    clonedDom.style.opacity = browser.windows ? '1' : '0.31';
    contentPreviewOneElement.appendChild(clonedDom);
    return contentPreviewOneElement;
};
const $3b1729369fa4a23a$var$isGenericPreview = (dom, nodeType)=>{
    const embedCard = dom.querySelector('.embedCardView-content-wrap');
    return nodeType === 'embedCard' || !!embedCard || nodeType === 'extension' && !!dom.querySelector('iframe');
};
const $3b1729369fa4a23a$var$createPreviewForElement = (dom, nodeType, nodeSpacing)=>{
    const shouldBeGenericPreview = $3b1729369fa4a23a$var$isGenericPreview(dom, nodeType);
    if (shouldBeGenericPreview) return $3b1729369fa4a23a$var$createGenericPreview();
    else return $3b1729369fa4a23a$var$createContentPreviewElement(dom, nodeType, nodeSpacing);
};
const $3b1729369fa4a23a$export$3ec2e625089820fa = (container, dragPreviewContent)=>{
    container.style.pointerEvents = 'none';
    if (!Array.isArray(dragPreviewContent) && typeof dragPreviewContent === 'object') dragPreviewContent = [
        dragPreviewContent
    ];
    const { width: maxWidth, height: maxHeight } = $3b1729369fa4a23a$var$getPreviewContainerDimensions(dragPreviewContent);
    container.style.width = `${maxWidth}px`;
    container.style.height = `${maxHeight}px`;
    const previewWrapperFragment = document.createDocumentFragment();
    for(let index = 0; index < dragPreviewContent.length; index++){
        const element = dragPreviewContent[index];
        const contentPreviewOneElement = $3b1729369fa4a23a$var$createPreviewForElement(element.dom, element.nodeType, element.nodeSpacing);
        previewWrapperFragment.appendChild(contentPreviewOneElement);
    }
    container.appendChild(previewWrapperFragment);
    const scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
    const scrollParentClassNames = scrollParent === null || scrollParent === void 0 ? void 0 : scrollParent.className;
    // Add the scroll parent class to the container to ensure the cloned element is styled correctly
    container.className = scrollParentClassNames || '';
    container.classList.remove('fabric-editor-popup-scroll-parent');
    // Prevents a scrollbar from showing
    container.style.overflow = 'visible';
    return ()=>container;
};

});

parcelRegister("fcDy5", function(module, exports) {
$parcel$export(module.exports, "shouldUseNestedDragHandleIcon", () => $61b27a557e75e886$export$148a39002dbd1689);
// Nested layout columns use the full block handle; other non-top-level nodes use the nested icon.
const $61b27a557e75e886$export$148a39002dbd1689 = (isTopLevelNode, isLayoutColumn)=>{
    if (isTopLevelNode) return false;
    if (isLayoutColumn) return false;
    return true;
};

});

parcelRegister("dp5ck", function(module, exports) {
$parcel$export(module.exports, "refreshAnchorName", () => $3291f31335a4f812$export$79a8e1d39d3c2449);

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $2xAfa = parcelRequire("2xAfa");

var $gyNLa = parcelRequire("gyNLa");
const $3291f31335a4f812$export$79a8e1d39d3c2449 = ({ getPos: getPos, view: view, anchorName: anchorName })=>{
    let newAnchorName = anchorName || '';
    if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) return newAnchorName;
    const pos = getPos();
    if (anchorName || pos === undefined) return newAnchorName;
    const node = view.state.doc.nodeAt(pos);
    const state = (0, $gyNLa.key).getState(view.state);
    if (state !== null && state !== void 0 && state.decorations) {
        const nodeDecs = (0, $2xAfa.findNodeDecs)(view.state, state.decorations, pos, pos + ((node === null || node === void 0 ? void 0 : node.nodeSize) ?? 0));
        const nodeDec = nodeDecs.at(0);
        if (!nodeDec) return newAnchorName;
        newAnchorName = nodeDec.spec.anchorName;
    }
    return newAnchorName;
};

});

parcelRegister("5wcYI", function(module, exports) {
$parcel$export(module.exports, "useBlockControlsVisibility", () => $e070fa46ffb22a6b$export$742141830a7bafbb);
$parcel$export(module.exports, "VisibilityWrapper", () => $e070fa46ffb22a6b$export$aef0ec05064f7676);
$parcel$export(module.exports, "VisibilityContainer", () => $e070fa46ffb22a6b$export$e7448669708130cc);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $9oAqi = parcelRequire("9oAqi");

var $014x6 = parcelRequire("014x6");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $kaRof = parcelRequire("kaRof");
function $e070fa46ffb22a6b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e070fa46ffb22a6b$var$RIGHT_CONTROL_HIDE_DELAY_MS = 150;
const $e070fa46ffb22a6b$var$baseStyles = (0, $kig2V.xcss)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out'
});
const $e070fa46ffb22a6b$var$visibleStyles = (0, $kig2V.xcss)({
    opacity: 1,
    visibility: 'visible'
});
const $e070fa46ffb22a6b$var$hiddenStyles = (0, $kig2V.xcss)({
    opacity: 0,
    visibility: 'hidden'
});
const $e070fa46ffb22a6b$var$displayContentsStyles = (0, $kig2V.xcss)({
    display: 'contents'
});
const $e070fa46ffb22a6b$var$baseStylesCSS = /*#__PURE__*/ (0, $jctmk.css)({
    transition: 'opacity 0.1s ease-in-out, visibility 0.1s ease-in-out',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    [`@container editor-area (max-width: ${0, $014x6.akEditorFullPageNarrowBreakout}px)`]: {
        opacity: 0,
        visibility: 'hidden'
    }
});
const $e070fa46ffb22a6b$var$visibleStylesCSS = {
    name: "nk3zlf",
    styles: "opacity:1;visibility:visible"
};
const $e070fa46ffb22a6b$var$hiddenStylesCSS = {
    name: "8792bh",
    styles: "opacity:0;visibility:hidden"
};
const $e070fa46ffb22a6b$var$displayContentsStylesCSS = {
    name: "49aokf",
    styles: "display:contents"
};
const $e070fa46ffb22a6b$export$742141830a7bafbb = ({ api: api, controlSide: controlSide, forceVisibleOnMouseOut: forceVisibleOnMouseOut, isPersistent: isPersistent })=>{
    const { isTypeAheadOpen: isTypeAheadOpen, isEditing: isEditing, isMouseOut: isMouseOut, hoverSide: hoverSide, editorViewMode: editorViewMode, userIntent: userIntent, isDisplayingDiff: isDisplayingDiff, rightSideControlsEnabled: rightSideControlsEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'typeAhead',
        'blockControls',
        'editorViewMode',
        'userIntent',
        'showDiff'
    ], (states)=>{
        var _states$typeAheadStat, _states$blockControls, _states$blockControls2, _states$blockControls3, _states$editorViewMod, _states$userIntentSta, _states$showDiffState, _states$blockControls4;
        return {
            isTypeAheadOpen: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.isOpen,
            isEditing: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.isEditing,
            isMouseOut: (_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.isMouseOut,
            hoverSide: (_states$blockControls3 = states.blockControlsState) === null || _states$blockControls3 === void 0 ? void 0 : _states$blockControls3.hoverSide,
            editorViewMode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode,
            userIntent: (_states$userIntentSta = states.userIntentState) === null || _states$userIntentSta === void 0 ? void 0 : _states$userIntentSta.currentUserIntent,
            isDisplayingDiff: (_states$showDiffState = states.showDiffState) === null || _states$showDiffState === void 0 ? void 0 : _states$showDiffState.isDisplayingChanges,
            rightSideControlsEnabled: (_states$blockControls4 = states.blockControlsState) === null || _states$blockControls4 === void 0 ? void 0 : _states$blockControls4.rightSideControlsEnabled
        };
    });
    const isViewMode = editorViewMode === 'view';
    // Both controls are restricted by side: the drag handle shows on the left half, the Remix button on
    // the right half (and the right margin), matching the midpoint split in handle-mouse-move.
    const shouldRestrictBySide = rightSideControlsEnabled && controlSide !== undefined && !isViewMode;
    // Only restrict by side when hoverSide is known (after mousemove). When undefined, show both
    // controls so drag handle is visible on load and for keyboard-only users.
    const sideHidden = shouldRestrictBySide && hoverSide !== undefined ? hoverSide !== controlSide : false;
    // In view mode with right-side controls, we delay hiding on isMouseOut (see below) so the right-edge
    // button stays visible when the user moves from the block toward the button (e.g. in edit/live
    // pages), avoiding flicker as the mouse crosses boundaries.
    const hideOnMouseOut = isMouseOut;
    // When forceVisibleOnMouseOut is true (e.g. drag handle focused via keyboard Shift+Ctrl+H),
    // override the mouse-out condition so the control stays visible regardless of mouse position.
    const shouldHideWhenMouseOut = forceVisibleOnMouseOut ? false : hideOnMouseOut;
    // Persistent controls (e.g. an AI suggestion icon on every qualifying node) aren't hover-driven,
    // so none of the hover/typing/mouse-out/diff-review reasons below apply to them — they're never
    // hidden by this container.
    const shouldHideImmediate = !isPersistent && (isTypeAheadOpen || isEditing || shouldHideWhenMouseOut || userIntent === 'aiStreaming' || // EDITOR-7926: hide the drag handle while a diff is on screen or a suggestion card is open.
    isDisplayingDiff || userIntent === 'reviewing' || sideHidden);
    // Delay hiding the right control in view mode to reduce flickering when moving from block
    // toward the right-edge button (avoids rapid show/hide as mouse crosses boundaries).
    const isRightControlViewMode = isViewMode && rightSideControlsEnabled && controlSide === 'right';
    // When in right-control view mode, we delay hiding so start visible; useEffect will update after delay
    const [delayedShouldHide, setDelayedShouldHide] = (0, $fc4bM.useState)(false);
    const hideTimeoutRef = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (!isRightControlViewMode) return;
        if (!shouldHideImmediate) {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            setDelayedShouldHide(false);
            return;
        }
        hideTimeoutRef.current = setTimeout(()=>{
            hideTimeoutRef.current = null;
            setDelayedShouldHide(true);
        }, $e070fa46ffb22a6b$var$RIGHT_CONTROL_HIDE_DELAY_MS);
        return ()=>{
            if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
        };
    }, [
        shouldHideImmediate,
        isRightControlViewMode
    ]);
    const shouldHide = isRightControlViewMode ? delayedShouldHide : shouldHideImmediate;
    const useCssStyles = (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    });
    return {
        shouldHide: shouldHide,
        useCssStyles: useCssStyles
    };
};
const $e070fa46ffb22a6b$export$aef0ec05064f7676 = ({ children: children, shouldHide: shouldHide, shouldUseDisplayContents: shouldUseDisplayContents, useCssStyles: useCssStyles })=>{
    if (useCssStyles) return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            $e070fa46ffb22a6b$var$baseStylesCSS,
            shouldHide ? $e070fa46ffb22a6b$var$hiddenStylesCSS : $e070fa46ffb22a6b$var$visibleStylesCSS,
            shouldUseDisplayContents && $e070fa46ffb22a6b$var$displayContentsStylesCSS
        ]
    }, children);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $e070fa46ffb22a6b$var$baseStyles,
            shouldHide ? $e070fa46ffb22a6b$var$hiddenStyles : $e070fa46ffb22a6b$var$visibleStyles,
            shouldUseDisplayContents && $e070fa46ffb22a6b$var$displayContentsStyles
        ]
    }, children);
};
const $e070fa46ffb22a6b$export$e7448669708130cc = ({ api: api, children: children, controlSide: controlSide, forceVisibleOnMouseOut: forceVisibleOnMouseOut, isPersistent: isPersistent, shouldUseDisplayContents: shouldUseDisplayContents })=>{
    const { shouldHide: shouldHide, useCssStyles: useCssStyles } = $e070fa46ffb22a6b$export$742141830a7bafbb({
        api: api,
        controlSide: controlSide,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        isPersistent: isPersistent
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)($e070fa46ffb22a6b$export$aef0ec05064f7676, {
        shouldHide: shouldHide,
        shouldUseDisplayContents: shouldUseDisplayContents,
        useCssStyles: useCssStyles
    }, children);
};

});


parcelRegister("6TMRn", function(module, exports) {
$parcel$export(module.exports, "getMatchingBlockMarks", () => $8da6748aaa4894cb$export$53f82211cca2767d);
/** True when `mark` has an equal counterpart (type + attrs) in `marks`. */ const $8da6748aaa4894cb$var$hasMatchingMark = (mark, marks)=>{
    const found = mark.type.isInSet(marks);
    return !!found && mark.eq(found);
};
const $8da6748aaa4894cb$export$53f82211cca2767d = (state, pos, supportedMarkTypes)=>{
    const resolvedPos = state.doc.resolve(pos);
    const validMarkTypes = supportedMarkTypes.filter(Boolean);
    const supportedMarks = resolvedPos.marks().filter((mark)=>validMarkTypes.includes(mark.type));
    if (supportedMarks.length === 0) return [];
    const { nodeAfter: nodeAfter, nodeBefore: nodeBefore } = resolvedPos;
    const nextMarks = (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.marks) ?? [];
    const prevMarks = (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.marks) ?? [];
    const nextSupported = nextMarks.filter((m)=>validMarkTypes.includes(m.type));
    const allMatchNext = supportedMarks.every((m)=>$8da6748aaa4894cb$var$hasMatchingMark(m, nextMarks));
    // First node — no previous sibling to compare against.
    if (!nodeBefore) return nextSupported.length === supportedMarks.length && allMatchNext ? supportedMarks : [];
    // `supportedMarks` already comes from `nodeBefore` (via resolvedPos.marks()).
    // Compare counts to guard against extra supported marks on either side.
    const prevSupported = prevMarks.filter((m)=>validMarkTypes.includes(m.type));
    return prevSupported.length === nextSupported.length && allMatchNext ? supportedMarks : [];
};

});


parcelRegister("cDvgs", function(module, exports) {
$parcel$export(module.exports, "findDropTargetDecs", () => $5acc547e98dae710$export$99bd791313c07808);
$parcel$export(module.exports, "createDropTargetDecoration", () => $5acc547e98dae710$export$fc632359c395fc7);
$parcel$export(module.exports, "createLayoutDropTargetDecoration", () => $5acc547e98dae710$export$eb62fe530f14234e);
$parcel$export(module.exports, "dropTargetDecorations", () => $5acc547e98dae710$export$248c2f3619ca4fdf);

var $fc4bM = parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");

var $eUgRu = parcelRequire("eUgRu");

var $eCKpe = parcelRequire("eCKpe");

var $39oqF = parcelRequire("39oqF");

var $e8CsO = parcelRequire("e8CsO");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $GIvev = parcelRequire("GIvev");

var $fn0vE = parcelRequire("fn0vE");

var $6Ok07 = parcelRequire("6Ok07");

var $61p1X = parcelRequire("61p1X");

var $dG7TM = parcelRequire("dG7TM");

var $8MRTx = parcelRequire("8MRTx");
const $5acc547e98dae710$var$IGNORE_NODES = [
    'tableCell',
    'tableHeader',
    'tableRow',
    'layoutColumn',
    'listItem',
    'caption'
];
const $5acc547e98dae710$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
const $5acc547e98dae710$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $5acc547e98dae710$var$getParentTypesWithEndDropTarget = (0, $jiju3.default)(()=>[
        ...$5acc547e98dae710$var$PARENT_WITH_END_DROP_TARGET,
        ...(0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : [],
        'bodiedSyncBlock'
    ]);
const $5acc547e98dae710$var$shouldDescend = (node)=>{
    return ![
        'mediaSingle',
        'paragraph',
        'heading'
    ].includes(node.type.name);
};
const $5acc547e98dae710$var$getNodeMargins = (node)=>{
    if (!node) return (0, $GIvev.nodeMargins)['default'];
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $GIvev.nodeMargins)[`heading${node.attrs.level}`] || (0, $GIvev.nodeMargins)['default'];
    return (0, $GIvev.nodeMargins)[nodeTypeName] || (0, $GIvev.nodeMargins)['default'];
};
const $5acc547e98dae710$var$shouldCollapseMargin = (prevNode, nextNode)=>{
    if (((prevNode === null || prevNode === void 0 ? void 0 : prevNode.type.name) === 'mediaSingle' || (nextNode === null || nextNode === void 0 ? void 0 : nextNode.type.name) === 'mediaSingle') && (prevNode === null || prevNode === void 0 ? void 0 : prevNode.type.name) !== (nextNode === null || nextNode === void 0 ? void 0 : nextNode.type.name)) return false;
    return true;
};
const $5acc547e98dae710$var$getGapAndOffset = (prevNode, nextNode, parentNode)=>{
    if (!prevNode && nextNode) {
        // first node - adjust for bodied containers
        let offset = 0;
        if ((parentNode === null || parentNode === void 0 ? void 0 : parentNode.type.name) === 'bodiedSyncBlock') offset += 4;
        return {
            gap: 0,
            offset: offset
        };
    } else if (prevNode && !nextNode) {
        // last node - adjust for bodied containers
        let offset = 0;
        if ((parentNode === null || parentNode === void 0 ? void 0 : parentNode.type.name) === 'bodiedSyncBlock') offset -= 4;
        return {
            gap: 0,
            offset: offset
        };
    }
    const top = $5acc547e98dae710$var$getNodeMargins(nextNode).top || 4;
    const bottom = $5acc547e98dae710$var$getNodeMargins(prevNode).bottom || 4;
    const gap = $5acc547e98dae710$var$shouldCollapseMargin(prevNode, nextNode) ? Math.max(top, bottom) : top + bottom;
    let offset = top - gap / 2;
    if ((prevNode === null || prevNode === void 0 ? void 0 : prevNode.type.name) === 'mediaSingle' && (nextNode === null || nextNode === void 0 ? void 0 : nextNode.type.name) === 'mediaSingle') offset = -offset;
    else if (prevNode !== null && prevNode !== void 0 && prevNode.type.name && [
        'tableCell',
        'tableHeader'
    ].includes(prevNode === null || prevNode === void 0 ? void 0 : prevNode.type.name)) offset = 0;
    return {
        gap: gap,
        offset: offset
    };
};
const $5acc547e98dae710$export$99bd791313c07808 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === (0, $61p1X.TYPE_DROP_TARGET_DEC));
};
const $5acc547e98dae710$export$fc632359c395fc7 = (pos, props, nodeViewPortalProviderAPI, side, anchorRectCache, isSameLayout)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $eUgRu.default)();
    return (0, $16ZMX.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const { gap: gap, offset: offset } = $5acc547e98dae710$var$getGapAndOffset(props.prevNode, props.nextNode, props.parentNode);
        element.style.setProperty((0, $fn0vE.EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_OFFSET), `${offset}px`);
        element.style.setProperty((0, $fn0vE.EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_GAP), `${gap}px`);
        element.style.setProperty('display', 'block');
        nodeViewPortalProviderAPI.render(()=>(0, $fc4bM.createElement)((0, $fn0vE.DropTarget), {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache,
                isSameLayout: isSameLayout
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $61p1X.TYPE_DROP_TARGET_DEC),
        side: side,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $5acc547e98dae710$export$eb62fe530f14234e = (pos, props, nodeViewPortalProviderAPI, anchorRectCache)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $eUgRu.default)();
    return (0, $16ZMX.Decoration).widget(pos, (_, getPosUnsafe)=>{
        const getPos = ()=>{
            try {
                return getPosUnsafe();
            } catch (e) {
                return undefined;
            }
        };
        const element = document.createElement('div');
        element.setAttribute('data-blocks-drop-target-container', 'true');
        element.setAttribute('data-blocks-drop-target-key', key);
        element.style.clear = 'unset';
        const DropTargetLayoutComponent = (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? (0, $6Ok07.DropTargetLayoutNativeAnchorSupport) : (0, $6Ok07.DropTargetLayout);
        nodeViewPortalProviderAPI.render(()=>(0, $fc4bM.createElement)(DropTargetLayoutComponent, {
                ...props,
                getPos: getPos,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, {
        type: (0, $61p1X.TYPE_DROP_TARGET_DEC),
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
};
const $5acc547e98dae710$export$248c2f3619ca4fdf = (newState, api, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache, from, to)=>{
    const decs = [];
    const POS_END_OF_DOC = newState.doc.nodeSize - 2;
    const docFrom = from === undefined || from < 0 ? 0 : from;
    const docTo = to === undefined || to > POS_END_OF_DOC ? POS_END_OF_DOC : to;
    const activeNodePos = activeNode === null || activeNode === void 0 ? void 0 : activeNode.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && newState.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    anchorRectCache === null || anchorRectCache === void 0 || anchorRectCache.clear();
    const prevNodeStack = [];
    const popNodeStack = (depth)=>{
        let result;
        const toDepth = Math.max(depth, 0);
        while(prevNodeStack.length > toDepth)result = prevNodeStack.pop();
        return result;
    };
    const pushNodeStack = (node, depth)=>{
        popNodeStack(depth);
        prevNodeStack.push(node);
    };
    const isAdvancedLayoutsPreRelease2 = (0, $kaRof.editorExperiment)('advanced_layouts', true);
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = newState.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $eCKpe.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    const parentTypesWithEndDropTarget = $5acc547e98dae710$var$getParentTypesWithEndDropTarget();
    newState.doc.nodesBetween(docFrom, docTo, (node, pos, parent, index)=>{
        let depth = 0;
        // drop target deco at the end position
        let endPos;
        const $pos = newState.doc.resolve(pos);
        const isSameLayout = $activeNodePos && (0, $8MRTx.isInSameLayout)($activeNodePos, $pos);
        depth = $pos.depth;
        if (isAdvancedLayoutsPreRelease2) {
            if ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.pos) === pos && activeNode.nodeType !== 'layoutColumn') return false;
            if (node.type.name === 'layoutColumn' && (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'layoutSection' && index !== 0 && (// Not the first node
            (parent === null || parent === void 0 ? void 0 : parent.childCount) < (0, $dG7TM.maxLayoutColumnSupported)() || isSameLayout)) // Add drop target for layout columns
            decs.push($5acc547e98dae710$export$eb62fe530f14234e(pos, {
                api: api,
                parent: parent,
                formatMessage: formatMessage
            }, nodeViewPortalProviderAPI, anchorRectCache));
        }
        if (node.isInline || !parent || $5acc547e98dae710$var$DISABLE_CHILD_DROP_TARGET.includes(parent.type.name)) {
            pushNodeStack(node, depth);
            return false;
        }
        if ($5acc547e98dae710$var$IGNORE_NODES.includes(node.type.name)) {
            pushNodeStack(node, depth);
            return $5acc547e98dae710$var$shouldDescend(node); //skip over, don't consider it a valid depth
        }
        // validate all the nodes in the selection instead of just the handle node
        const selectionSlice = newState.doc.slice(selectionFrom, selectionTo, false);
        const selectionSliceChildCount = selectionSlice.content.childCount;
        let canDropSingleNode = true;
        let canDropMultipleNodes = true;
        // when there is only one node in the slice, use the same logic as when multi select is not on
        if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $8MRTx.canMoveSliceToIndex)(selectionSlice, selectionFrom, selectionTo, parent, index, $pos);
        else canDropSingleNode = !!(activePMNode && (0, $8MRTx.canMoveNodeToIndex)(parent, index, activePMNode, $pos, node));
        if (!canDropMultipleNodes || !canDropSingleNode) {
            pushNodeStack(node, depth);
            return false; //not valid pos, so nested not valid either
        }
        const parentTypeName = (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $e8CsO.getBaseNodeTypeName)(parent.type) : parent.type.name;
        if (parent.lastChild === node && !(0, $39oqF.isEmptyParagraph)(node) && parentTypesWithEndDropTarget.includes(parentTypeName)) endPos = pos + node.nodeSize;
        const previousNode = popNodeStack(depth); // created scoped variable
        // only table and layout need to render full height drop target
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes((parent === null || parent === void 0 ? void 0 : parent.type.name) || '');
        const shouldShowFullHeight = isInSupportedContainer && (parent === null || parent === void 0 ? void 0 : parent.lastChild) === node && (0, $39oqF.isEmptyParagraph)(node);
        decs.push($5acc547e98dae710$export$fc632359c395fc7(pos, {
            api: api,
            prevNode: previousNode,
            nextNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        if (endPos !== undefined) decs.push($5acc547e98dae710$export$fc632359c395fc7(endPos, {
            api: api,
            prevNode: node,
            parentNode: parent || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'remainingHeight'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache));
        pushNodeStack(node, depth);
        return depth < (0, $61p1X.NESTED_DEPTH) && $5acc547e98dae710$var$shouldDescend(node);
    });
    if (docTo === POS_END_OF_DOC) decs.push($5acc547e98dae710$export$fc632359c395fc7(POS_END_OF_DOC, {
        api: api,
        formatMessage: formatMessage,
        prevNode: newState.doc.lastChild || undefined,
        parentNode: newState.doc
    }, nodeViewPortalProviderAPI, undefined, anchorRectCache));
    return decs;
};

});
parcelRegister("fn0vE", function(module, exports) {
$parcel$export(module.exports, "EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_OFFSET", () => $f159a12bd7aefaf7$export$b172475a7115c36a);
$parcel$export(module.exports, "EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_GAP", () => $f159a12bd7aefaf7$export$d522271cd3bfae1d);
$parcel$export(module.exports, "DropTarget", () => $f159a12bd7aefaf7$export$79660a248b11010);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $9oAqi = parcelRequire("9oAqi");

var $e8CsO = parcelRequire("e8CsO");

var $bcN2K = parcelRequire("bcN2K");

var $k33Yd = parcelRequire("k33Yd");

var $c8sLM = parcelRequire("c8sLM");

var $2SWSA = parcelRequire("2SWSA");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $61p1X = parcelRequire("61p1X");

var $3xl1j = parcelRequire("3xl1j");

var $atuba = parcelRequire("atuba");

var $ec4rv = parcelRequire("ec4rv");

var $GIvev = parcelRequire("GIvev");

var $eLsNV = parcelRequire("eLsNV");
function $f159a12bd7aefaf7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f159a12bd7aefaf7$var$DEFAULT_DROP_INDICATOR_WIDTH = 760;
const $f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH = '--editor-block-controls-drop-indicator-width';
const $f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN = '--editor-block-controls-drop-target-leftMargin';
const $f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX = '--editor-block-controls-drop-target-zindex';
const $f159a12bd7aefaf7$export$b172475a7115c36a = '--editor-block-controls-drop-indicator-offset';
const $f159a12bd7aefaf7$export$d522271cd3bfae1d = '--editor-block-controls-drop-indicator-gap';
const $f159a12bd7aefaf7$var$styleDropTarget = /*#__PURE__*/ (0, $jctmk.css)({
    marginLeft: `calc(-1 * var(${$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0))`,
    paddingLeft: `var(${$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN}, 0)`,
    position: 'absolute',
    left: '0',
    display: 'block',
    zIndex: `var(${$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX}, 110)`,
    transform: `translateY(var(${$f159a12bd7aefaf7$export$b172475a7115c36a}, 0))`
});
const $f159a12bd7aefaf7$var$styleDropIndicator = /*#__PURE__*/ (0, $jctmk.css)({
    height: '100%',
    margin: '0 auto',
    position: 'relative',
    width: `var(${$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH}, 100%)`,
    display: 'none'
});
const $f159a12bd7aefaf7$var$styleDropIndicatorVisible = {
    name: "4zleql",
    styles: "display:block"
};
const $f159a12bd7aefaf7$var$nestedDropIndicatorStyle = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $f159a12bd7aefaf7$var$dropZoneStyles = {
    name: "y3ufic",
    styles: "margin:0;position:absolute;width:100%;z-index:110;min-height:4px"
};
const $f159a12bd7aefaf7$var$nestedDropZoneStyle = {
    name: "1h4fcj3",
    styles: "left:4px;right:4px;width:unset"
};
const $f159a12bd7aefaf7$var$ENABLE_DROP_ZONE = [
    'paragraph',
    'mediaSingle',
    'heading',
    'codeBlock',
    'decisionList',
    'bulletList',
    'orderedList',
    'taskList',
    'extension',
    'blockCard',
    'syncBlock'
];
// This z index is used in container like layout
const $f159a12bd7aefaf7$var$fullHeightStyleAdjustZIndexStyle = {
    name: "125wnaz",
    styles: "z-index:0"
};
const $f159a12bd7aefaf7$var$HoverZone = ({ onDragEnter: onDragEnter, onDragLeave: onDragLeave, onDrop: onDrop, node: node, pos: pos, parent: parent, editorWidth: editorWidth, anchorRectCache: anchorRectCache, position: position, isNestedDropTarget: isNestedDropTarget, dropTargetStyle: dropTargetStyle, api: api })=>{
    const ref = (0, $fc4bM.useRef)(null);
    const isRemainingheight = dropTargetStyle === 'remainingHeight';
    const anchorName = (0, $fc4bM.useMemo)(()=>{
        if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
            if (node && typeof pos === 'number') {
                const posOffset = position === 'upper' ? -node.nodeSize : 0;
                return (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(node, pos + posOffset)) || '';
            }
            return '';
        }
        return node ? (0, $61p1X.getNodeAnchor)(node) : '';
    }, [
        api,
        node,
        pos,
        position
    ]);
    const [_isActive, setActiveAnchor] = (0, $3xl1j.useActiveAnchorTracker)(anchorName);
    const isInsideBodiedSyncBlock = (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'bodiedSyncBlock';
    (0, $fc4bM.useEffect)(()=>{
        if (ref.current) return (0, $c8sLM.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                if ((!isNestedDropTarget || isInsideBodiedSyncBlock) && (0, $kaRof.editorExperiment)('advanced_layouts', true)) setActiveAnchor();
                onDragEnter();
            },
            onDragLeave: onDragLeave,
            onDrop: onDrop
        });
    }, [
        isNestedDropTarget,
        isInsideBodiedSyncBlock,
        onDragEnter,
        onDragLeave,
        onDrop,
        setActiveAnchor
    ]);
    const hoverZoneUpperStyle = (0, $fc4bM.useMemo)(()=>{
        const heightStyleOffset = `var(--editor-block-controls-drop-indicator-gap, 0)/2`;
        const transformOffset = `var(${$f159a12bd7aefaf7$export$b172475a7115c36a}, 0)`;
        const heightStyle = anchorName && $f159a12bd7aefaf7$var$ENABLE_DROP_ZONE.includes((node === null || node === void 0 ? void 0 : node.type.name) || '') ? (0, $atuba.isAnchorSupported)() ? `calc(anchor-size(${anchorName} height)/2 + ${heightStyleOffset})` : `calc(${((anchorRectCache === null || anchorRectCache === void 0 ? void 0 : anchorRectCache.getHeight(anchorName)) || 0) / 2}px + ${heightStyleOffset})` : '4px';
        const transform = position === 'upper' ? `translateY(calc(-100% + ${transformOffset}))` : `translateY(${transformOffset})`;
        return /*#__PURE__*/ (0, $jctmk.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height: heightStyle,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            transform: transform,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            maxWidth: `${editorWidth || 0}px`
        });
    }, [
        anchorName,
        anchorRectCache,
        editorWidth,
        node === null || node === void 0 ? void 0 : node.type.name,
        position
    ]);
    /**
   * 1. Above the last empty line
   * 2. Below the last element
   *
   * Both cases will take the remaining height of the the container
   */ const heightStyle = (0, $fc4bM.useMemo)(()=>{
        // only apply upper drop zone
        if (isRemainingheight && position === 'upper') {
            // previous node
            const anchorName = node ? (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(node, pos || -1)) || '' : (0, $61p1X.getNodeAnchor)(node) : '';
            let top = 'unset';
            if (anchorName) {
                const enabledDropZone = $f159a12bd7aefaf7$var$ENABLE_DROP_ZONE.includes((node === null || node === void 0 ? void 0 : node.type.name) || '');
                if ((0, $atuba.isAnchorSupported)()) top = enabledDropZone ? `calc(anchor(${anchorName} 50%))` : `calc(anchor(${anchorName} bottom) - 4px)`;
                else if (anchorRectCache) {
                    const preNodeTopPos = anchorRectCache.getTop(anchorName) || 0;
                    const prevNodeHeight = anchorRectCache.getHeight(anchorName) || 0;
                    top = enabledDropZone ? `calc(${preNodeTopPos}px + ${prevNodeHeight / 2}px)` : `calc(${preNodeTopPos}px + ${prevNodeHeight}px - 4px)`;
                } else // Should not happen
                return null;
            } else // first empty paragraph
            top = '4px';
            return /*#__PURE__*/ (0, $jctmk.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                top: top,
                bottom: '4px',
                height: 'unset',
                zIndex: 10,
                transform: 'none'
            });
        }
        return null;
    }, [
        anchorRectCache,
        api,
        isRemainingheight,
        node,
        pos,
        position
    ]);
    const isFullHeightInLayout = isRemainingheight && (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'layoutColumn';
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: `drop-target-hover-zone-${position}`,
        "data-testid": `drop-target-zone-${position}`,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $f159a12bd7aefaf7$var$dropZoneStyles,
            isNestedDropTarget && $f159a12bd7aefaf7$var$nestedDropZoneStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            hoverZoneUpperStyle,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            heightStyle,
            isFullHeightInLayout && $f159a12bd7aefaf7$var$fullHeightStyleAdjustZIndexStyle
        ]
    });
};
const $f159a12bd7aefaf7$export$79660a248b11010 = (props)=>{
    var _api$blockControls;
    const { api: api, getPos: getPos, prevNode: prevNode, nextNode: nextNode, parentNode: parentNode, formatMessage: formatMessage, anchorRectCache: anchorRectCache, dropTargetStyle: dropTargetStyle = 'default', isSameLayout: isSameLayout } = props;
    const [isDraggedOver, setIsDraggedOver] = (0, $fc4bM.useState)(false);
    const { lineLength: lineLength } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'width'
    ], (states)=>{
        var _states$widthState;
        return {
            lineLength: ((_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.lineLength) || $f159a12bd7aefaf7$var$DEFAULT_DROP_INDICATOR_WIDTH
        };
    });
    const isNestedDropTarget = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.type.name) !== 'doc';
    const { activeNode: activeNode } = (api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState()) || {};
    const onDrop = ()=>{
        if (!activeNode) return;
        const pos = getPos();
        if (activeNode && pos !== undefined) {
            var _api$core, _api$blockControls2;
            const { pos: start } = activeNode;
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.moveNode(start, pos, undefined, formatMessage));
        }
    };
    const dynamicStyle = {
        width: isNestedDropTarget ? 'unset' : '100%',
        [$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_INDICATOR_WIDTH]: isNestedDropTarget ? '100%' : `${lineLength || $f159a12bd7aefaf7$var$DEFAULT_DROP_INDICATOR_WIDTH}px`,
        [$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_LEFT_MARGIN]: isNestedDropTarget ? (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && parentNode !== null && parentNode !== void 0 && parentNode.type ? (0, $GIvev.getNestedNodeLeftPaddingMargin)((0, $e8CsO.getBaseNodeTypeName)(parentNode.type)) : (0, $GIvev.getNestedNodeLeftPaddingMargin)(parentNode === null || parentNode === void 0 ? void 0 : parentNode.type.name) : '0',
        [$f159a12bd7aefaf7$var$EDITOR_BLOCK_CONTROLS_DROP_TARGET_ZINDEX]: (0, $2SWSA.layers).navigation()
    };
    const isShowInlineDropTarget = (0, $ec4rv.shouldAllowInlineDropTarget)(isNestedDropTarget, nextNode, isSameLayout, activeNode, parentNode);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)($f159a12bd7aefaf7$var$HoverZone, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>setIsDraggedOver(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: prevNode,
        pos: getPos(),
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "upper",
        isNestedDropTarget: isNestedDropTarget,
        dropTargetStyle: dropTargetStyle,
        api: api
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $f159a12bd7aefaf7$var$styleDropTarget,
            isNestedDropTarget && $f159a12bd7aefaf7$var$nestedDropIndicatorStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyle,
        "data-testid": "block-ctrl-drop-target"
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            $f159a12bd7aefaf7$var$styleDropIndicator,
            isDraggedOver && $f159a12bd7aefaf7$var$styleDropIndicatorVisible
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $k33Yd.DropIndicator), {
        edge: "bottom"
    }))), dropTargetStyle !== 'remainingHeight' && /*#__PURE__*/ (0, $jctmk.jsx)($f159a12bd7aefaf7$var$HoverZone, {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragEnter: ()=>setIsDraggedOver(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>setIsDraggedOver(false),
        onDrop: onDrop,
        node: nextNode,
        pos: getPos(),
        parent: parentNode,
        editorWidth: lineLength,
        anchorRectCache: anchorRectCache,
        position: "lower",
        isNestedDropTarget: isNestedDropTarget,
        api: api
    }), isShowInlineDropTarget && /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $eLsNV.InlineDropTarget), {
        ...props,
        position: "left"
    }), /*#__PURE__*/ (0, $jctmk.jsx)((0, $eLsNV.InlineDropTarget), {
        ...props,
        position: "right"
    })));
};

});
parcelRegister("3xl1j", function(module, exports) {
$parcel$export(module.exports, "defaultActiveAnchorTracker", () => $bb7065167523c3d1$export$73b394ea452decfd);
$parcel$export(module.exports, "useActiveAnchorTracker", () => $bb7065167523c3d1$export$8f015ea2e0aa57d4);

var $hylEy = parcelRequire("hylEy");

var $fc4bM = parcelRequire("fc4bM");

var $kaRof = parcelRequire("kaRof");
class $bb7065167523c3d1$export$d16dfd16e2bbb367 {
    constructor(){
        this.lastActiveAnchor = '';
        this.emitter = new (0, $hylEy.EventEmitter)();
    }
    getActiveAnchor() {
        return this.lastActiveAnchor;
    }
    subscribe(anchorName, callback) {
        if (this.emitter) this.emitter.on(anchorName, callback);
    }
    unsubscribe(anchorName, callback) {
        if (this.emitter) this.emitter.removeListener(anchorName, callback);
    }
    emit(anchorName) {
        if (this.lastActiveAnchor !== anchorName && this.emitter) {
            this.emitter.emit(this.lastActiveAnchor, false);
            this.emitter.emit(anchorName, true);
            this.lastActiveAnchor = anchorName;
        }
    }
    reset() {
        if (this.emitter) {
            // To prevent any potential memory leaks,
            // we set the event emitter to null and then create a new event emitter.
            this.emitter.removeAllListeners();
            this.emitter = null;
            this.emitter = new (0, $hylEy.EventEmitter)();
        }
    }
}
const $bb7065167523c3d1$export$73b394ea452decfd = new $bb7065167523c3d1$export$d16dfd16e2bbb367();
const $bb7065167523c3d1$export$8f015ea2e0aa57d4 = (anchorName, activeAnchorTracker = $bb7065167523c3d1$export$73b394ea452decfd)=>{
    const [isActive, setIsActive] = (0, $fc4bM.useState)(false);
    const onActive = (eventIsActive)=>{
        setIsActive(eventIsActive);
    };
    (0, $fc4bM.useEffect)(()=>{
        if (activeAnchorTracker && anchorName && (0, $kaRof.editorExperiment)('advanced_layouts', true)) {
            activeAnchorTracker.subscribe(anchorName, onActive);
            if (activeAnchorTracker.getActiveAnchor() === anchorName) setIsActive(true);
            const unsubscribe = ()=>{
                activeAnchorTracker.unsubscribe(anchorName, onActive);
            };
            return unsubscribe;
        }
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    const setActive = (0, $fc4bM.useCallback)(()=>{
        activeAnchorTracker.emit(anchorName);
    }, [
        activeAnchorTracker,
        anchorName
    ]);
    return [
        isActive,
        setActive
    ];
};

});

parcelRegister("atuba", function(module, exports) {
$parcel$export(module.exports, "isAnchorSupported", () => $a573fa51d79652f7$export$2073a24f9367a16f);
$parcel$export(module.exports, "AnchorRectCache", () => $a573fa51d79652f7$export$e1d230f644ff05aa);

var $jiju3 = parcelRequire("jiju3");

var $dj84o = parcelRequire("dj84o");
const $a573fa51d79652f7$export$2073a24f9367a16f = (0, $jiju3.default)(()=>{
    // directly use CSS would cause failed SSR tests.
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --a');
    return false;
});
class $a573fa51d79652f7$export$e1d230f644ff05aa {
    clear() {
        this.isDirty = true;
        this.anchorRectMap = {};
    }
    getRects() {
        if (this.isDirty) {
            var _this$view;
            const anchorElements = ((_this$view = this.view) === null || _this$view === void 0 ? void 0 : _this$view.dom.querySelectorAll(`[${(0, $dj84o.getAnchorAttrName)()}]`)) || [];
            this.anchorRectMap = Array.from(anchorElements).reduce((prev, curr)=>{
                const anchorName = curr.getAttribute((0, $dj84o.getAnchorAttrName)());
                if (anchorName) return {
                    ...prev,
                    [anchorName]: {
                        height: curr.clientHeight,
                        top: curr.offsetTop,
                        left: curr.offsetLeft,
                        right: curr.offsetLeft + curr.clientWidth,
                        width: curr.clientWidth,
                        bottom: curr.offsetTop + curr.clientHeight
                    }
                };
                return prev;
            }, {});
            this.isDirty = false;
        }
        return this.anchorRectMap;
    }
    setEditorView(view) {
        if (this.view !== view) this.view = view;
    }
    getHeight(anchorName) {
        var _rects$anchorName;
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return (_rects$anchorName = rects[anchorName]) === null || _rects$anchorName === void 0 ? void 0 : _rects$anchorName.height;
    }
    getWidth(anchorName) {
        var _rects$anchorName2;
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return (_rects$anchorName2 = rects[anchorName]) === null || _rects$anchorName2 === void 0 ? void 0 : _rects$anchorName2.width;
    }
    getLeft(anchorName) {
        var _rects$anchorName3;
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return (_rects$anchorName3 = rects[anchorName]) === null || _rects$anchorName3 === void 0 ? void 0 : _rects$anchorName3.left;
    }
    getTop(anchorName) {
        var _rects$anchorName4;
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return (_rects$anchorName4 = rects[anchorName]) === null || _rects$anchorName4 === void 0 ? void 0 : _rects$anchorName4.top;
    }
    getRight(anchorName) {
        var _rects$anchorName5;
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return (_rects$anchorName5 = rects[anchorName]) === null || _rects$anchorName5 === void 0 ? void 0 : _rects$anchorName5.right;
    }
    getRect(anchorName) {
        if (this.isAnchorSupported) return null;
        const rects = this.getRects();
        return rects[anchorName];
    }
    constructor(){
        this.anchorRectMap = {};
        this.isAnchorSupported = $a573fa51d79652f7$export$2073a24f9367a16f();
        this.isDirty = true;
        this.view = null;
    }
}

});

parcelRegister("ec4rv", function(module, exports) {
$parcel$export(module.exports, "shouldAllowInlineDropTarget", () => $ebdb8f43cfef999f$export$9d1974d3f03f9d59);

var $39oqF = parcelRequire("39oqF");

var $kaRof = parcelRequire("kaRof");

var $etSJJ = parcelRequire("etSJJ");

var $dG7TM = parcelRequire("dG7TM");
const $ebdb8f43cfef999f$var$syncedBlockTypes = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $ebdb8f43cfef999f$export$9d1974d3f03f9d59 = (isNested, node, /**
 * Is the active node in the same layout as the target node
 */ isSameLayout = false, activeNode, parentNode)=>{
    const isInsideBodiedSyncBlock = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.type.name) === 'bodiedSyncBlock';
    if ((0, $kaRof.editorExperiment)('advanced_layouts', false) || isNested) {
        // If nested inside bodiedSyncBlock, enable inline drop target so user can drop to create a layout inside it
        if (isInsideBodiedSyncBlock) return true;
        return false;
    }
    if ((0, $etSJJ.isWrappedMedia)(node)) return false;
    if ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.nodeType) === 'layoutSection') return false;
    if ($ebdb8f43cfef999f$var$syncedBlockTypes.includes((activeNode === null || activeNode === void 0 ? void 0 : activeNode.nodeType) || '') || $ebdb8f43cfef999f$var$syncedBlockTypes.includes((node === null || node === void 0 ? void 0 : node.type.name) || '')) return false;
    if ((node === null || node === void 0 ? void 0 : node.type.name) === 'layoutSection') return node.childCount < (0, $dG7TM.maxLayoutColumnSupported)() || isSameLayout;
    return !(0, $39oqF.isEmptyParagraph)(node);
};

});
parcelRegister("etSJJ", function(module, exports) {
$parcel$export(module.exports, "isWrappedMedia", () => $f051d327b0152191$export$a5a8e8321fc18ce);
const $f051d327b0152191$export$a5a8e8321fc18ce = (node)=>{
    if ('mediaSingle' === (node === null || node === void 0 ? void 0 : node.type.name)) {
        if ([
            'wrap-right',
            'wrap-left'
        ].includes(node.attrs.layout)) return true;
    }
    return false;
};

});

parcelRegister("dG7TM", function(module, exports) {
$parcel$export(module.exports, "maxLayoutColumnSupported", () => $63784404528c8940$export$b8ad888c900fcbc2);
$parcel$export(module.exports, "MIN_LAYOUT_COLUMN", () => $63784404528c8940$export$8a51600ccf088851);

var $kaRof = parcelRequire("kaRof");
const $63784404528c8940$export$b8ad888c900fcbc2 = ()=>{
    return (0, $kaRof.editorExperiment)('advanced_layouts', true) ? 5 : 3;
};
const $63784404528c8940$export$8a51600ccf088851 = 2;

});


parcelRegister("eLsNV", function(module, exports) {
$parcel$export(module.exports, "InlineDropTarget", () => $05562415f71b4958$export$ade48236ff38648e);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $k33Yd = parcelRequire("k33Yd");

var $c8sLM = parcelRequire("c8sLM");

var $aEmSo = parcelRequire("aEmSo");

var $61p1X = parcelRequire("61p1X");

var $3xl1j = parcelRequire("3xl1j");

var $atuba = parcelRequire("atuba");

var $hpR0v = parcelRequire("hpR0v");
function $05562415f71b4958$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $05562415f71b4958$var$HOVER_ZONE_WIDTH = '--editor-blocks-inline-hover-zone-width';
const $05562415f71b4958$var$HOVER_ZONE_HEIGHT = '--editor-blocks-inline-hover-zone-height';
const $05562415f71b4958$var$HOVER_ZONE_TOP = '--editor-blocks-inline-hover-zone-top';
const $05562415f71b4958$var$HOVER_ZONE_BOTTOM = '--editor-blocks-inline-hover-zone-bottom';
const $05562415f71b4958$var$HOVER_ZONE_ANCHOR_NAME = '--editor-blocks-inline-hover-zone-anchor-name';
const $05562415f71b4958$var$hoverZoneCommonStyle = /*#__PURE__*/ (0, $jctmk.css)({
    position: 'absolute',
    // above the top and bottom drop zone as block hover zone
    zIndex: 120,
    positionAnchor: `var(${$05562415f71b4958$var$HOVER_ZONE_ANCHOR_NAME})`,
    minWidth: "var(--ds-space-100, 8px)",
    left: 0,
    right: 0,
    width: `var(${$05562415f71b4958$var$HOVER_ZONE_WIDTH})`,
    height: `var(${$05562415f71b4958$var$HOVER_ZONE_HEIGHT})`
});
const $05562415f71b4958$var$leftHoverZoneStyle = /*#__PURE__*/ (0, $jctmk.css)({
    right: `unset`,
    top: `var(${$05562415f71b4958$var$HOVER_ZONE_TOP})`,
    bottom: 'unset'
});
const $05562415f71b4958$var$rightHoverZoneStyle = /*#__PURE__*/ (0, $jctmk.css)({
    left: `unset`,
    top: 'unset',
    bottom: `var(${$05562415f71b4958$var$HOVER_ZONE_BOTTOM})`
});
// gap between node boundary and drop indicator/drop zone
const $05562415f71b4958$var$GAP = 4;
const $05562415f71b4958$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $jctmk.css)({
    height: '100%',
    position: 'absolute',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-focused, #4688EC)"}`,
    width: 0,
    left: 0
});
const $05562415f71b4958$var$dropTargetLayoutHintLeftStyle = {
    name: "go864d",
    styles: "left:unset;right:0"
};
const $05562415f71b4958$var$defaultNodeDimension = {
    width: '0',
    height: '0',
    top: 'unset',
    bottom: 'unset'
};
const $05562415f71b4958$var$getWidthOffset = (node, width, position)=>{
    if ([
        'mediaSingle',
        'table',
        'embedCard'
    ].includes(node.type.name) || // block card (without datasource) is positioned left-aligned, hence share the same logic as align-start
    node.type.name === 'blockCard' && !node.attrs.datasource) {
        const isLeftPosition = position === 'left';
        if (node.attrs.layout === 'align-start' || node.type.name === 'blockCard') return isLeftPosition ? `-0.5*(var(--ak-editor--line-length) - ${width})` : `0.5*(var(--ak-editor--line-length) - ${width})`;
        else if ((node === null || node === void 0 ? void 0 : node.attrs.layout) === 'align-end') return isLeftPosition ? `0.5*(var(--ak-editor--line-length) - ${width})` : `-0.5*(var(--ak-editor--line-length) - ${width})`;
    }
    if (node.type.name === 'bodiedExtension' || node.type.name === 'extension' || node.type.name === 'multiBodiedExtension' && (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '-12px';
};
const $05562415f71b4958$var$TABLE_NUMBERED_COLUMN_WIDTH = 42;
const $05562415f71b4958$export$ade48236ff38648e = ({ api: api, nextNode: nextNode, position: position, anchorRectCache: anchorRectCache, getPos: getPos })=>{
    const ref = (0, $fc4bM.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $fc4bM.useState)(false);
    const anchorName = (0, $fc4bM.useMemo)(()=>{
        if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) return nextNode ? (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(nextNode, getPos() ?? -1)) || '' : '';
        return nextNode ? (0, $61p1X.getNodeAnchor)(nextNode) : '';
    }, [
        api,
        getPos,
        nextNode
    ]);
    const [isActiveAnchor] = (0, $3xl1j.useActiveAnchorTracker)(anchorName);
    const isLeftPosition = position === 'left';
    const nodeDimension = (0, $fc4bM.useMemo)(()=>{
        if (!nextNode) return $05562415f71b4958$var$defaultNodeDimension;
        const nextNodePos = getPos();
        let innerContainerWidth = null;
        let targetAnchorName = anchorName;
        if ([
            'blockCard',
            'embedCard',
            'extension'
        ].includes(nextNode.type.name)) {
            if (nextNode.attrs.layout === 'wide') innerContainerWidth = `max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))`;
            else if (nextNode.attrs.layout === 'full-width') innerContainerWidth = `min(calc(100cqw - ${0, $014x6.akEditorBreakoutPadding}px), 1800px)`;
            if (nextNode.type.name === 'blockCard' && !nextNode.attrs.layout && nextNode.attrs.datasource) // block card with sourceNode and without layout has different width in full-width vs fixed-width editor
            // Hence we need to set it based on editor mode
            innerContainerWidth = 'var(--ak-editor-block-card-width)';
            if (nextNode.type.name === 'embedCard' && [
                'center',
                'align-start',
                'align-end'
            ].includes(nextNode.attrs.layout)) {
                const percentageWidth = ((parseFloat(nextNode.attrs.width) || 100) / 100).toFixed(2);
                innerContainerWidth = `calc(var(--ak-editor--line-length) * ${percentageWidth})`;
            }
        } else if (nextNode.type.name === 'table' && nextNode.firstChild) {
            const tableWidthAnchor = (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? typeof nextNodePos === 'number' ? (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1)) || '' : '' : (0, $61p1X.getNodeAnchor)(nextNode.firstChild);
            const isNumberColumnEnabled = Boolean(nextNode.attrs.isNumberColumnEnabled);
            if ((0, $atuba.isAnchorSupported)()) innerContainerWidth = isNumberColumnEnabled ? `calc(anchor-size(${tableWidthAnchor} width) + ${$05562415f71b4958$var$TABLE_NUMBERED_COLUMN_WIDTH}px)` : `anchor-size(${tableWidthAnchor} width)`;
            else {
                var _anchorRectCache$getR;
                innerContainerWidth = `${((anchorRectCache === null || anchorRectCache === void 0 || (_anchorRectCache$getR = anchorRectCache.getRect(tableWidthAnchor)) === null || _anchorRectCache$getR === void 0 ? void 0 : _anchorRectCache$getR.width) || 0) + $05562415f71b4958$var$TABLE_NUMBERED_COLUMN_WIDTH}px`;
            }
            if (nextNode.attrs.width) // when the table has horizontal scroll
            innerContainerWidth = `min(${nextNode.attrs.width}px, ${innerContainerWidth})`;
        } else if (nextNode.type.name === 'mediaSingle' && nextNode.firstChild) {
            if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                var _nextNode$firstChild;
                // check pos is a number
                if (typeof nextNodePos === 'number' && ((_nextNode$firstChild = nextNode.firstChild) === null || _nextNode$firstChild === void 0 ? void 0 : _nextNode$firstChild.type.name) === 'media') targetAnchorName = (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1)) || '';
            } else targetAnchorName = (0, $61p1X.getNodeAnchor)(nextNode.firstChild);
        }
        // Set the height target anchor name to the first or last column of the layout section so that it also works for stacked layout
        let heightTargetAnchorName = targetAnchorName;
        if (nextNode.type.name === 'layoutSection' && nextNode.firstChild && nextNode.lastChild) {
            if (isLeftPosition) {
                if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                    if (typeof nextNodePos === 'number') heightTargetAnchorName = (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(nextNode.firstChild, nextNodePos + 1)) || '';
                    else heightTargetAnchorName = '';
                } else heightTargetAnchorName = (0, $61p1X.getNodeAnchor)(nextNode.firstChild);
            } else if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                if (typeof nextNodePos === 'number') {
                    const lastNodeStartPos = nextNode.content.size - nextNode.lastChild.nodeSize;
                    heightTargetAnchorName = (api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(nextNode.lastChild, lastNodeStartPos + 1)) || '';
                } else heightTargetAnchorName = '';
            } else heightTargetAnchorName = (0, $61p1X.getNodeAnchor)(nextNode.lastChild);
        }
        if ((0, $atuba.isAnchorSupported)()) {
            const width = innerContainerWidth || `anchor-size(${targetAnchorName} width)`;
            const height = `anchor-size(${heightTargetAnchorName} height)`;
            return {
                width: width,
                height: height,
                top: 'anchor(top)',
                bottom: 'anchor(bottom)',
                widthOffset: $05562415f71b4958$var$getWidthOffset(nextNode, width, position)
            };
        }
        if (anchorRectCache) {
            const nodeRect = anchorRectCache.getRect(targetAnchorName);
            const width = innerContainerWidth || `${(nodeRect === null || nodeRect === void 0 ? void 0 : nodeRect.width) || 0}px`;
            const top = nodeRect !== null && nodeRect !== void 0 && nodeRect.top ? `${nodeRect === null || nodeRect === void 0 ? void 0 : nodeRect.top}px` : 'unset';
            const bottom = `100% - ${(nodeRect === null || nodeRect === void 0 ? void 0 : nodeRect.bottom) || 0}px + ${$05562415f71b4958$var$GAP}px`;
            let height = `${(nodeRect === null || nodeRect === void 0 ? void 0 : nodeRect.height) || 0}px`;
            if (heightTargetAnchorName !== targetAnchorName) {
                const nodeHeightRect = anchorRectCache.getRect(heightTargetAnchorName);
                height = `${(nodeHeightRect === null || nodeHeightRect === void 0 ? void 0 : nodeHeightRect.height) || 0}px + ${$05562415f71b4958$var$GAP}px`;
            }
            return {
                width: width,
                height: height,
                top: top,
                bottom: bottom,
                widthOffset: $05562415f71b4958$var$getWidthOffset(nextNode, width, position)
            };
        }
        return $05562415f71b4958$var$defaultNodeDimension;
    }, [
        nextNode,
        anchorName,
        anchorRectCache,
        getPos,
        api,
        isLeftPosition,
        position
    ]);
    const onDrop = (0, $fc4bM.useCallback)(()=>{
        var _api$blockControls;
        const { activeNode: activeNode } = (api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState()) || {};
        if (!activeNode) return;
        const toPos = getPos();
        let mappedTo;
        if (activeNode && toPos !== undefined) {
            var _api$core, _api$core2;
            const { pos: start } = activeNode;
            const moveToEnd = position === 'right';
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                var _api$blockControls2;
                api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 || _api$blockControls2.moveToLayout(start, toPos, {
                    moveToEnd: moveToEnd
                })({
                    tr: tr
                });
                const insertLayoutStep = (0, $hpR0v.getInsertLayoutStep)(tr);
                mappedTo = insertLayoutStep === null || insertLayoutStep === void 0 ? void 0 : insertLayoutStep.from;
                return tr;
            });
            api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $hpR0v.updateSelection)(tr, mappedTo, moveToEnd);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        position
    ]);
    const hoverZoneRectStyle = (0, $fc4bM.useMemo)(()=>{
        const isLayoutNode = (nextNode === null || nextNode === void 0 ? void 0 : nextNode.type.name) === 'layoutSection';
        const layoutAdjustment = isLayoutNode ? {
            width: 11,
            height: 4,
            top: 6,
            bottom: 2
        } : undefined;
        return {
            [$05562415f71b4958$var$HOVER_ZONE_WIDTH]: nodeDimension.widthOffset ? `calc((100% - ${nodeDimension.width})/2 - ${$05562415f71b4958$var$GAP}px + ${nodeDimension.widthOffset} - ${(layoutAdjustment === null || layoutAdjustment === void 0 ? void 0 : layoutAdjustment.width) || 0}px)` : `calc((100% - ${nodeDimension.width})/2 - ${$05562415f71b4958$var$GAP}px - ${(layoutAdjustment === null || layoutAdjustment === void 0 ? void 0 : layoutAdjustment.width) || 0}px)`,
            [$05562415f71b4958$var$HOVER_ZONE_HEIGHT]: `calc(${nodeDimension.height} + ${(layoutAdjustment === null || layoutAdjustment === void 0 ? void 0 : layoutAdjustment.height) || 0}px)`,
            [$05562415f71b4958$var$HOVER_ZONE_TOP]: `calc(${nodeDimension.top} + ${(layoutAdjustment === null || layoutAdjustment === void 0 ? void 0 : layoutAdjustment.top) || 0}px)`,
            [$05562415f71b4958$var$HOVER_ZONE_BOTTOM]: `calc(${nodeDimension.bottom} - ${(layoutAdjustment === null || layoutAdjustment === void 0 ? void 0 : layoutAdjustment.bottom) || 0}px)`,
            [$05562415f71b4958$var$HOVER_ZONE_ANCHOR_NAME]: anchorName
        };
    }, [
        nextNode === null || nextNode === void 0 ? void 0 : nextNode.type.name,
        nodeDimension,
        anchorName
    ]);
    const dropIndicatorPos = (0, $fc4bM.useMemo)(()=>{
        return isLeftPosition ? 'right' : 'left';
    }, [
        isLeftPosition
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (ref.current) return (0, $c8sLM.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        setIsDraggedOver
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: ref,
        "data-testid": `drop-target-hover-zone-${position}`,
        css: [
            $05562415f71b4958$var$hoverZoneCommonStyle,
            isLeftPosition ? $05562415f71b4958$var$leftHoverZoneStyle : $05562415f71b4958$var$rightHoverZoneStyle
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: hoverZoneRectStyle
    }, isDraggedOver ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $k33Yd.DropIndicator), {
        edge: dropIndicatorPos
    }) : isActiveAnchor && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: [
            $05562415f71b4958$var$dropTargetLayoutHintStyle,
            isLeftPosition && $05562415f71b4958$var$dropTargetLayoutHintLeftStyle
        ]
    }));
};

});
parcelRegister("hpR0v", function(module, exports) {
$parcel$export(module.exports, "getInsertLayoutStep", () => $369f25937c4768bc$export$fc81c36e83ce2f6b);
$parcel$export(module.exports, "updateSelection", () => $369f25937c4768bc$export$2e8776145e31b87);

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");
const $369f25937c4768bc$export$fc81c36e83ce2f6b = (tr)=>tr.steps.find((step)=>{
        var _step$slice$content$f;
        return step instanceof (0, $k2WVn.ReplaceStep) && [
            'layoutSection',
            'layoutColumn'
        ].includes(((_step$slice$content$f = step.slice.content.firstChild) === null || _step$slice$content$f === void 0 ? void 0 : _step$slice$content$f.type.name) || '');
    });
const $369f25937c4768bc$export$2e8776145e31b87 = (tr, to, insertAtRight)=>{
    var _lastNode;
    const $to = tr.doc.resolve(to);
    const toNode = $to.nodeAfter;
    let lastNode = toNode === null || toNode === void 0 ? void 0 : toNode.content.lastChild;
    if (!toNode || !lastNode) return tr;
    let offset = toNode.nodeSize;
    // drop at the start of the layoutSection or to create a new layoutSection
    if (toNode.type.name === 'layoutSection') {
        if (insertAtRight) {
            var _toNode$content$lastC;
            lastNode = (_toNode$content$lastC = toNode.content.lastChild) === null || _toNode$content$lastC === void 0 ? void 0 : _toNode$content$lastC.lastChild;
            offset = toNode.nodeSize - 1;
        } else {
            var _toNode$content$first, _toNode$content$first2;
            lastNode = (_toNode$content$first = toNode.content.firstChild) === null || _toNode$content$first === void 0 ? void 0 : _toNode$content$first.lastChild;
            offset = 1 + (((_toNode$content$first2 = toNode.content.firstChild) === null || _toNode$content$first2 === void 0 ? void 0 : _toNode$content$first2.nodeSize) || 0);
        }
    }
    if ([
        'paragraph',
        'heading'
    ].includes(((_lastNode = lastNode) === null || _lastNode === void 0 ? void 0 : _lastNode.type.name) || '')) tr.setSelection((0, $801jp.TextSelection).near(tr.doc.resolve(to + offset - 2)));
    else if (lastNode) tr.setSelection(new (0, $ihNBw.GapCursorSelection)(tr.doc.resolve(to + offset - 1), (0, $id3e6.Side).RIGHT));
    return tr;
};

});



parcelRegister("6Ok07", function(module, exports) {
$parcel$export(module.exports, "DropTargetLayout", () => $0ccc0d5a4e8b678f$export$448a3db73d1a77fe);
$parcel$export(module.exports, "DropTargetLayoutNativeAnchorSupport", () => $0ccc0d5a4e8b678f$export$2afcb78657666b75);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $k33Yd = parcelRequire("k33Yd");

var $c8sLM = parcelRequire("c8sLM");

var $aEmSo = parcelRequire("aEmSo");

var $61p1X = parcelRequire("61p1X");

var $3xl1j = parcelRequire("3xl1j");

var $atuba = parcelRequire("atuba");

var $hpR0v = parcelRequire("hpR0v");

var $dj84o = parcelRequire("dj84o");
// 8px gap + 16px on left and right
const $0ccc0d5a4e8b678f$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH = 40;
const $0ccc0d5a4e8b678f$var$dropTargetLayoutStyle = /*#__PURE__*/ (0, $jctmk.css)({
    height: '100%',
    width: `${$0ccc0d5a4e8b678f$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`,
    transform: 'translateX(-50%)',
    zIndex: 120,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center'
});
const $0ccc0d5a4e8b678f$var$dropTargetLayoutHintStyle = /*#__PURE__*/ (0, $jctmk.css)({
    height: '100%',
    position: 'relative',
    borderRight: `${"var(--ds-border-width, 1px)"} dashed ${"var(--ds-border-focused, #4688EC)"}`,
    width: 0
});
const $0ccc0d5a4e8b678f$export$448a3db73d1a77fe = (props)=>{
    var _ref$current, _api$blockControls;
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $fc4bM.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $fc4bM.useState)(false);
    const anchorName = (0, $61p1X.getNodeAnchor)(parent);
    const nextNodeAnchorName = (_ref$current = ref.current) === null || _ref$current === void 0 || (_ref$current = _ref$current.parentElement) === null || _ref$current === void 0 || (_ref$current = _ref$current.nextElementSibling) === null || _ref$current === void 0 ? void 0 : _ref$current.getAttribute((0, $dj84o.getAnchorAttrName)());
    let height = '100%';
    if (nextNodeAnchorName) {
        if ((0, $atuba.isAnchorSupported)()) height = `anchor-size(${nextNodeAnchorName} height)`;
        else if (anchorRectCache) {
            const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
            height = `${(layoutColumnRect === null || layoutColumnRect === void 0 ? void 0 : layoutColumnRect.height) || 0}px`;
        }
    }
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $jctmk.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $014x6.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $3xl1j.useActiveAnchorTracker)(anchorName);
    const { activeNode: activeNode } = (api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState()) || {};
    const onDrop = (0, $fc4bM.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            var _api$core, _api$core2;
            const { pos: from } = activeNode;
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                var _api$blockControls2;
                api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 || _api$blockControls2.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $hpR0v.getInsertLayoutStep)(tr);
                mappedTo = insertColumnStep === null || insertColumnStep === void 0 ? void 0 : insertColumnStep.from;
                return tr;
            });
            api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $hpR0v.updateSelection)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (ref.current) return (0, $c8sLM.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop
    ]);
    if ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.nodeType) === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $0ccc0d5a4e8b678f$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $k33Yd.DropIndicator), {
        edge: "right",
        gap: `-${$0ccc0d5a4e8b678f$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $0ccc0d5a4e8b678f$var$dropTargetLayoutHintStyle
    }));
};
const $0ccc0d5a4e8b678f$export$2afcb78657666b75 = (props)=>{
    var _api$blockControls3;
    const { api: api, getPos: getPos, parent: parent, anchorRectCache: anchorRectCache } = props;
    const ref = (0, $fc4bM.useRef)(null);
    const [isDraggedOver, setIsDraggedOver] = (0, $fc4bM.useState)(false);
    const anchorName = (0, $61p1X.getNodeAnchor)(parent);
    const [nextNodeAnchorName, setNextNodeAnchorName] = (0, $fc4bM.useState)(null);
    const readNextNodeAnchor = (0, $fc4bM.useCallback)(()=>{
        var _ref$current2;
        const nextElementSibling = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || (_ref$current2 = _ref$current2.parentElement) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.nextElementSibling;
        const attrName = (0, $dj84o.getAnchorAttrName)();
        const nextAnchorName = (nextElementSibling === null || nextElementSibling === void 0 ? void 0 : nextElementSibling.getAttribute(attrName)) ?? null;
        setNextNodeAnchorName((prev)=>prev === nextAnchorName ? prev : nextAnchorName);
    }, []);
    const height = (0, $fc4bM.useMemo)(()=>{
        if (nextNodeAnchorName) {
            if ((0, $atuba.isAnchorSupported)()) return `anchor-size(${nextNodeAnchorName} height)`;
            else if (anchorRectCache) {
                const layoutColumnRect = anchorRectCache.getRect(nextNodeAnchorName);
                return `${(layoutColumnRect === null || layoutColumnRect === void 0 ? void 0 : layoutColumnRect.height) || 0}px`;
            }
        }
        // Stacked mode fallback: minimal height to avoid oversized hint on first render
        return '0px';
    }, [
        nextNodeAnchorName,
        anchorRectCache
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        const raf = requestAnimationFrame(()=>{
            readNextNodeAnchor();
        });
        return ()=>cancelAnimationFrame(raf);
    }, [
        readNextNodeAnchor
    ]);
    const dropTargetStackLayoutHintStyle = /*#__PURE__*/ (0, $jctmk.css)({
        // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`@container layout-area (max-width:${(0, $014x6.layoutBreakpointWidth).MEDIUM - 1}px)`]: {
            height: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            height,
            marginTop: `${"var(--ds-space-050, 4px)"}`
        }
    });
    const [isActiveAnchor] = (0, $3xl1j.useActiveAnchorTracker)(anchorName);
    const { activeNode: activeNode } = (api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 ? void 0 : _api$blockControls3.sharedState.currentState()) || {};
    const onDrop = (0, $fc4bM.useCallback)(()=>{
        if (!activeNode) return;
        const to = getPos();
        let mappedTo;
        if (to !== undefined) {
            var _api$core3, _api$core4;
            const { pos: from } = activeNode;
            api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(({ tr: tr })=>{
                var _api$blockControls4;
                api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || (_api$blockControls4 = _api$blockControls4.commands) === null || _api$blockControls4 === void 0 || _api$blockControls4.moveToLayout(from, to)({
                    tr: tr
                });
                const insertColumnStep = (0, $hpR0v.getInsertLayoutStep)(tr);
                mappedTo = insertColumnStep === null || insertColumnStep === void 0 ? void 0 : insertColumnStep.from;
                return tr;
            });
            api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(({ tr: tr })=>{
                if (mappedTo !== undefined) (0, $hpR0v.updateSelection)(tr, mappedTo);
                return tr;
            });
        }
    }, [
        api,
        getPos,
        activeNode
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (ref.current) return (0, $c8sLM.dropTargetForElements)({
            element: ref.current,
            onDragEnter: ()=>{
                setIsDraggedOver(true);
                readNextNodeAnchor();
            },
            onDragLeave: ()=>{
                setIsDraggedOver(false);
            },
            onDrop: onDrop
        });
    }, [
        onDrop,
        readNextNodeAnchor
    ]);
    if ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.nodeType) === 'layoutSection') return null;
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $0ccc0d5a4e8b678f$var$dropTargetLayoutStyle,
            dropTargetStackLayoutHintStyle
        ],
        "data-testid": "block-ctrl-drop-indicator"
    }, isDraggedOver ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $k33Yd.DropIndicator), {
        edge: "right",
        gap: `-${$0ccc0d5a4e8b678f$var$DROP_TARGET_LAYOUT_DROP_ZONE_WIDTH}px`
    }) : (isActiveAnchor || (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "block-ctrl-drop-hint",
        css: $0ccc0d5a4e8b678f$var$dropTargetLayoutHintStyle
    }));
};

});


parcelRegister("8bDpq", function(module, exports) {
$parcel$export(module.exports, "getActiveDropTargetDecorations", () => $fa2a5a79b1719e69$export$181f339130769cb6);

var $jiju3 = parcelRequire("jiju3");

var $eCKpe = parcelRequire("eCKpe");

var $39oqF = parcelRequire("39oqF");

var $e8CsO = parcelRequire("e8CsO");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $61p1X = parcelRequire("61p1X");

var $cDvgs = parcelRequire("cDvgs");

var $5kUtT = parcelRequire("5kUtT");

var $3xl1j = parcelRequire("3xl1j");

var $dG7TM = parcelRequire("dG7TM");

var $8MRTx = parcelRequire("8MRTx");
/**
 * List of parent node types that can have child nodes
 */ const $fa2a5a79b1719e69$var$PARENT_WITH_END_DROP_TARGET = [
    'tableCell',
    'tableHeader',
    'panel',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'bodiedExtension'
];
/**
 * List of node types that does not allow drop targets at before or after the node.
 */ const $fa2a5a79b1719e69$var$NODE_WITH_NO_PARENT_POS = [
    'tableCell',
    'tableHeader',
    'layoutColumn'
];
const $fa2a5a79b1719e69$var$UNSUPPORTED_LAYOUT_CONTENT = [
    'syncBlock',
    'bodiedSyncBlock'
];
const $fa2a5a79b1719e69$var$getContainerNodeTypes = (0, $jiju3.default)(()=>[
        ...$fa2a5a79b1719e69$var$PARENT_WITH_END_DROP_TARGET,
        ...(0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? [
            'multiBodiedExtension'
        ] : [],
        'bodiedSyncBlock'
    ]);
const $fa2a5a79b1719e69$var$isContainerNode = (node)=>{
    const nodeName = (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $e8CsO.getBaseNodeTypeName)(node.type) : node.type.name;
    return $fa2a5a79b1719e69$var$getContainerNodeTypes().includes(nodeName);
};
const $fa2a5a79b1719e69$export$40c317c5c02ece25 = (state, node, parent, index, $toPos, activeNode)=>{
    // For deciding to show drop targets or not when multiple nodes are selected
    const selection = state.selection;
    const { $anchor: expandedAnchor, $head: expandedHead } = (0, $eCKpe.expandSelectionBounds)(selection.$anchor, selection.$head);
    const selectionFrom = Math.min(expandedAnchor.pos, expandedHead.pos);
    const selectionTo = Math.max(expandedAnchor.pos, expandedHead.pos);
    const activeNodePos = activeNode === null || activeNode === void 0 ? void 0 : activeNode.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const activePMNode = $activeNodePos && $activeNodePos.nodeAfter;
    const handleInsideSelection = activeNodePos !== undefined && activeNodePos >= selectionFrom && activeNodePos <= selectionTo;
    const selectionSlice = state.doc.slice(selectionFrom, selectionTo, false);
    const selectionSliceChildCount = selectionSlice.content.childCount;
    let canDropSingleNode = true;
    let canDropMultipleNodes = true;
    // when there is only one node in the slice, use the same logic as when multi select is not on
    if (selectionSliceChildCount > 1 && handleInsideSelection) canDropMultipleNodes = (0, $8MRTx.canMoveSliceToIndex)(selectionSlice, selectionFrom, selectionTo, parent, index, $toPos);
    else canDropSingleNode = !!(activePMNode && (0, $8MRTx.canMoveNodeToIndex)(parent, index, activePMNode, $toPos, node));
    if (!canDropMultipleNodes || !canDropSingleNode) return false;
    return true;
};
const $fa2a5a79b1719e69$export$181f339130769cb6 = (activeDropTargetNode, state, api, existingDecs, formatMessage, nodeViewPortalProviderAPI, activeNode, anchorRectCache)=>{
    const decsToAdd = [];
    let decsToRemove = existingDecs.filter((dec)=>!!dec);
    const activeNodePos = activeNode === null || activeNode === void 0 ? void 0 : activeNode.pos;
    const $activeNodePos = typeof activeNodePos === 'number' && state.doc.resolve(activeNodePos);
    const $toPos = state.doc.resolve(activeDropTargetNode.pos);
    const existingDecsPos = decsToRemove.map((dec)=>dec.from);
    const { parent: parent, index: index, node: node, pos: pos, before: before, after: after, depth: depth } = (0, $5kUtT.findSurroundingNodes)(state, $toPos, activeDropTargetNode.nodeTypeName);
    /**
   * If the current node is a container node, we show the drop targets
   * above the first child and below the last child.
   */ if ($fa2a5a79b1719e69$var$isContainerNode(node)) {
        const isEmptyContainer = node.childCount === 0 || node.childCount === 1 && (0, $39oqF.isEmptyParagraph)(node.firstChild);
        // can move to before first child
        const posBeforeFirstChild = pos + 1; // +1 to get the position of the first child
        if (node.firstChild && $fa2a5a79b1719e69$export$40c317c5c02ece25(state, node.firstChild, node, 0, state.doc.resolve(posBeforeFirstChild), activeNode)) {
            if (existingDecsPos.includes(posBeforeFirstChild)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posBeforeFirstChild);
            else decsToAdd.push((0, $cDvgs.createDropTargetDecoration)(posBeforeFirstChild, {
                api: api,
                prevNode: undefined,
                nextNode: node.firstChild,
                parentNode: node,
                formatMessage: formatMessage,
                dropTargetStyle: isEmptyContainer ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, 1, anchorRectCache));
        }
        // can move to after last child
        // if the node is empty, we don't show the drop target at the end of the node
        if (!isEmptyContainer) {
            const posAfterLastChild = pos + node.nodeSize - 1; // -1 to get the position after last child
            if (node.lastChild && $fa2a5a79b1719e69$export$40c317c5c02ece25(state, node.lastChild, node, node.childCount - 1, state.doc.resolve(posAfterLastChild), // -1 to get the position after last child
            activeNode)) {
                if (existingDecsPos.includes(posAfterLastChild)) // if the decoration already exists, we don't add it again.
                decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterLastChild);
                else decsToAdd.push((0, $cDvgs.createDropTargetDecoration)(posAfterLastChild, {
                    api: api,
                    prevNode: node.lastChild,
                    nextNode: undefined,
                    parentNode: node,
                    formatMessage: formatMessage,
                    dropTargetStyle: 'remainingHeight'
                }, nodeViewPortalProviderAPI, -1, anchorRectCache));
            }
        }
    }
    /**
   * Create drop target before and after the current node
   */ if (!$fa2a5a79b1719e69$var$NODE_WITH_NO_PARENT_POS.includes(node.type.name)) {
        const isSameLayout = $activeNodePos && (0, $8MRTx.isInSameLayout)($activeNodePos, $toPos);
        const isInSupportedContainer = [
            'tableCell',
            'tableHeader',
            'layoutColumn'
        ].includes((parent === null || parent === void 0 ? void 0 : parent.type.name) || '');
        const shouldShowFullHeight = isInSupportedContainer && (parent === null || parent === void 0 ? void 0 : parent.lastChild) === node && (0, $39oqF.isEmptyParagraph)(node);
        if ($fa2a5a79b1719e69$export$40c317c5c02ece25(state, node, parent, index, $toPos, activeNode)) {
            if (existingDecsPos.includes(pos)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== pos);
            else decsToAdd.push((0, $cDvgs.createDropTargetDecoration)(pos, {
                api: api,
                prevNode: before || undefined,
                nextNode: node,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
        // if the node is a container node, we show the drop target after the node
        const posAfterNode = pos + node.nodeSize;
        if ($fa2a5a79b1719e69$export$40c317c5c02ece25(state, node, parent, index + 1, state.doc.resolve(posAfterNode), activeNode)) {
            if (existingDecsPos.includes(posAfterNode)) // if the decoration already exists, we don't add it again.
            decsToRemove = decsToRemove.filter((dec)=>dec.from !== posAfterNode);
            else decsToAdd.push((0, $cDvgs.createDropTargetDecoration)(posAfterNode, {
                api: api,
                prevNode: node,
                nextNode: after || undefined,
                parentNode: parent || undefined,
                formatMessage: formatMessage,
                dropTargetStyle: shouldShowFullHeight ? 'remainingHeight' : 'default'
            }, nodeViewPortalProviderAPI, -1, anchorRectCache, isSameLayout));
        }
    }
    let rootNodeWithPos = {
        node: node,
        pos: pos
    };
    // if the current node is not a top level node, we create one for advanced layout drop targets
    if (depth > 1) {
        const root = (0, $5kUtT.findSurroundingNodes)(state, state.doc.resolve($toPos.before(2)));
        if (existingDecsPos.includes(root.pos)) // if the decoration already exists, we don't add it again.
        decsToRemove = decsToRemove.filter((dec)=>dec.from !== root.pos);
        else decsToAdd.push((0, $cDvgs.createDropTargetDecoration)(root.pos, {
            api: api,
            prevNode: root.before || undefined,
            nextNode: root.node,
            parentNode: state.doc || undefined,
            formatMessage: formatMessage,
            dropTargetStyle: 'default'
        }, nodeViewPortalProviderAPI, -1, anchorRectCache, false));
        rootNodeWithPos = {
            node: root.node,
            pos: root.pos
        };
    }
    let anchorEmitNodeWithPos = rootNodeWithPos;
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) {
        const schema = rootNodeWithPos.node.type.schema;
        const { layoutSection: layoutSection } = schema.nodes;
        const isLayoutSectionChildOfRoot = (0, $a4TQr.findChildrenByType)(rootNodeWithPos.node, layoutSection, false).length > 0;
        if (isLayoutSectionChildOfRoot) {
            // if node has layoutSection as a child, get the layoutSection node and pos
            for(let ancestorDepth = $toPos.depth; ancestorDepth >= 1; ancestorDepth--)if ($toPos.node(ancestorDepth).type.name === 'layoutSection') {
                anchorEmitNodeWithPos = {
                    node: $toPos.node(ancestorDepth),
                    pos: $toPos.before(ancestorDepth)
                };
                break;
            }
        } else anchorEmitNodeWithPos = rootNodeWithPos;
        const isSameLayout = $activeNodePos && (0, $8MRTx.isInSameLayout)($activeNodePos, state.doc.resolve(anchorEmitNodeWithPos.pos));
        const hasUnsupportedContent = $fa2a5a79b1719e69$var$UNSUPPORTED_LAYOUT_CONTENT.includes((activeNode === null || activeNode === void 0 ? void 0 : activeNode.nodeType) || '');
        if (anchorEmitNodeWithPos.node.type.name === 'layoutSection' && !hasUnsupportedContent) {
            const layoutSectionNode = anchorEmitNodeWithPos.node;
            if (layoutSectionNode.childCount < (0, $dG7TM.maxLayoutColumnSupported)() || isSameLayout) layoutSectionNode.descendants((childNode, childPos, parent, index)=>{
                if (childNode.type.name === 'layoutColumn' && (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'layoutSection' && index !== 0 // Not the first node
                ) {
                    const currentPos = anchorEmitNodeWithPos.pos + childPos + 1;
                    if (existingDecsPos.includes(currentPos)) // if the decoration already exists, we don't add it again.
                    decsToRemove = decsToRemove.filter((dec)=>dec.from !== currentPos);
                    else decsToAdd.push((0, $cDvgs.createLayoutDropTargetDecoration)(anchorEmitNodeWithPos.pos + childPos + 1, {
                        api: api,
                        parent: parent,
                        formatMessage: formatMessage
                    }, nodeViewPortalProviderAPI, anchorRectCache));
                }
                return false;
            });
        }
    }
    (0, $3xl1j.defaultActiveAnchorTracker).emit((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? api.core.actions.getAnchorIdForNode(anchorEmitNodeWithPos.node, anchorEmitNodeWithPos.pos) || '' : (0, $61p1X.getNodeAnchor)(anchorEmitNodeWithPos.node));
    return {
        decsToAdd: decsToAdd,
        decsToRemove: decsToRemove
    };
};

});
parcelRegister("5kUtT", function(module, exports) {
$parcel$export(module.exports, "findSurroundingNodes", () => $444497b625d0b414$export$2f588816c7e80081);
const $444497b625d0b414$var$IGNORE_NODES = [
    'tableRow',
    'listItem',
    'caption',
    'media'
];
const $444497b625d0b414$var$BLOCK_LEAF_NODES = [
    'blockCard',
    'rule',
    'extension',
    'syncBlock'
];
const $444497b625d0b414$var$DISABLE_CHILD_DROP_TARGET = [
    'orderedList',
    'bulletList'
];
const $444497b625d0b414$export$2f588816c7e80081 = (state, $pos, nodeType)=>{
    const depth = $pos.depth;
    // special cases like hr rule here
    if ($444497b625d0b414$var$BLOCK_LEAF_NODES.includes(nodeType || '') || $pos.pos === 0) {
        const parent = $pos.node(depth);
        const node = $pos.nodeAfter;
        const index = $pos.index();
        const before = index > 0 ? parent.child(index - 1) : null;
        const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
        return {
            pos: $pos.pos,
            node: node,
            parent: parent,
            before: before,
            after: after,
            index: index,
            depth: depth
        };
    }
    const isRootNode = depth === 1;
    const node = $pos.node(depth);
    // go through the path to find the first node that is not allow child drop target
    // From top to bottom, we check the node types at each depth
    for(let i = 1; i < depth; i++){
        const nodeType = $pos.node(i).type.name;
        if ($444497b625d0b414$var$DISABLE_CHILD_DROP_TARGET.includes(nodeType)) return $444497b625d0b414$export$2f588816c7e80081(state, state.doc.resolve($pos.before(i + 1)), nodeType);
    }
    if ($444497b625d0b414$var$IGNORE_NODES.includes(node.type.name) && !isRootNode) // If the node is an ignored node, we return the surrounding nodes of its parent
    return $444497b625d0b414$export$2f588816c7e80081(state, state.doc.resolve($pos.before(depth - 1)));
    const pos = depth > 0 ? $pos.before(depth) : 0;
    const parent = isRootNode ? state.doc : $pos.node(depth - 1);
    const index = $pos.index(depth - 1);
    const before = index > 0 ? parent.child(index - 1) : null;
    const after = index < parent.childCount - 1 ? parent.child(index + 1) : null;
    return {
        pos: pos,
        node: node,
        parent: parent,
        before: before,
        after: after,
        index: index,
        depth: depth
    };
};

});


parcelRegister("gr4E6", function(module, exports) {
$parcel$export(module.exports, "TYPE_ACTIVE_QUICK_INSERT_NODE", () => $3bcb470d52e13393$export$706c4878577996f2);
$parcel$export(module.exports, "findQuickInsertInsertButtonDecoration", () => $3bcb470d52e13393$export$a6ab3402831bd7d8);
$parcel$export(module.exports, "createActiveQuickInsertNodeDecoration", () => $3bcb470d52e13393$export$5b9210fd80ac3dfb);
$parcel$export(module.exports, "findActiveQuickInsertNodeDec", () => $3bcb470d52e13393$export$678e19285f8625bb);
$parcel$export(module.exports, "quickInsertButtonDecoration", () => $3bcb470d52e13393$export$ab399427af69a61);

var $fc4bM = parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $16ZMX = parcelRequire("16ZMX");

var $GIvev = parcelRequire("GIvev");

var $llksB = parcelRequire("llksB");

var $6TMRn = parcelRequire("6TMRn");
const $3bcb470d52e13393$var$TYPE_QUICK_INSERT = 'INSERT_BUTTON';
const $3bcb470d52e13393$export$706c4878577996f2 = 'active-quick-insert-node';
const $3bcb470d52e13393$export$a6ab3402831bd7d8 = (decorations, from, to)=>{
    return decorations.find(from, to, (spec)=>spec.type === $3bcb470d52e13393$var$TYPE_QUICK_INSERT);
};
const $3bcb470d52e13393$export$5b9210fd80ac3dfb = (pos, nodeSize)=>(0, $16ZMX.Decoration).node(pos, pos + nodeSize, {
        [(0, $GIvev.ACTIVE_QUICK_INSERT_ATTR)]: 'true'
    }, {
        type: $3bcb470d52e13393$export$706c4878577996f2
    });
const $3bcb470d52e13393$export$678e19285f8625bb = (decorations, from, to)=>decorations.find(from, to, (spec)=>spec.type === $3bcb470d52e13393$export$706c4878577996f2);
const $3bcb470d52e13393$export$ab399427af69a61 = ({ api: api, formatMessage: formatMessage, rootPos: rootPos, anchorName: anchorName, nodeType: nodeType, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache, editorState: editorState })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = (0, $eUgRu.default)();
    const cleanupCallbacks = [];
    const widgetSpec = {
        side: -2,
        type: $3bcb470d52e13393$var$TYPE_QUICK_INSERT,
        /**
     * sigh - `marks` influences the position that the widget is drawn (as described on the `side` property).
     * Exclude 'breakout' on purpose, so the widgets render at the top of the document to avoid z-index issues
     * Other block marks must be added, otherwise PM will split the DOM elements causing mutations and re-draws
     */ marks: (0, $6TMRn.getMatchingBlockMarks)(editorState, rootPos, [
            editorState.schema.marks.alignment,
            editorState.schema.marks.fontSize
        ]),
        destroy: (_)=>{
            nodeViewPortalProviderAPI.remove(key);
            cleanupCallbacks.forEach((cb)=>{
                cb();
            });
        }
    };
    return (0, $16ZMX.Decoration).widget(rootPos, (view, getPos)=>{
        const element = document.createElement('span');
        // inline decoration causes cursor disappear when focusing editor at the first line (e.g. press Tab when title is focused)
        element.style.display = 'block';
        // make sure it does not interfere with elements floating next to each other e.g. paragraph next to image with wrap-right
        element.style.clear = 'unset';
        element.contentEditable = 'false';
        element.setAttribute('data-blocks-quick-insert-container', 'true');
        element.setAttribute('data-blocks-quick-insert-button', 'true');
        element.setAttribute('data-testid', 'block-ctrl-quick-insert-button');
        nodeViewPortalProviderAPI.render(()=>(0, $fc4bM.createElement)((0, $llksB.QuickInsertWithVisibility), {
                api: api,
                getPos: getPos,
                formatMessage: formatMessage,
                view: view,
                nodeType: nodeType,
                anchorName: anchorName,
                rootAnchorName: rootAnchorName,
                rootNodeType: rootNodeType ?? nodeType,
                anchorRectCache: anchorRectCache
            }), element, key, undefined, // @portal-render-immediately
        true);
        return element;
    }, widgetSpec);
};

});
parcelRegister("llksB", function(module, exports) {
$parcel$export(module.exports, "QuickInsertWithVisibility", () => $976be041114ddc08$export$6ffb15bf86dea6dd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $6Zi52 = parcelRequire("6Zi52");

var $eUtBU = parcelRequire("eUtBU");

var $7u4Lo = parcelRequire("7u4Lo");

var $jd8X7 = parcelRequire("jd8X7");

var $9oAqi = parcelRequire("9oAqi");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $ev7OZ = parcelRequire("ev7OZ");

var $jGvkt = parcelRequire("jGvkt");

var $5a4EU = parcelRequire("5a4EU");

var $l3fZT = parcelRequire("l3fZT");

var $kig2V = parcelRequire("kig2V");

var $aEmSo = parcelRequire("aEmSo");

var $bcTS3 = parcelRequire("bcTS3");

var $61p1X = parcelRequire("61p1X");

var $iZXVC = parcelRequire("iZXVC");

var $6cjKN = parcelRequire("6cjKN");

var $GIvev = parcelRequire("GIvev");

var $dp5ck = parcelRequire("dp5ck");

var $gbHVV = parcelRequire("gbHVV");

var $dj84o = parcelRequire("dj84o");

var $exoyO = parcelRequire("exoyO");

var $5wcYI = parcelRequire("5wcYI");
function $976be041114ddc08$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $976be041114ddc08$var$TEXT_PARENT_TYPES = [
    'paragraph',
    'heading',
    'blockquote',
    'taskItem',
    'decisionItem'
];
const $976be041114ddc08$var$stickyButtonStyles = (0, $kig2V.xcss)({
    top: '0',
    position: 'sticky',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)",
    border: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.full',
    zIndex: 'card',
    outline: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    ':focus': {
        outline: `${"var(--ds-border-width-focused, 2px)"} solid ${"var(--ds-border-focused, #4688EC)"}`
    }
});
// Calculate scaled dimensions based on the base font size using CSS calc()
// Default font size is 16px, scale proportionally
// Standard: 16px -> 24px x 24px, Dense: 13px -> ~18.5px x ~18.5px
const $976be041114ddc08$var$stickyButtonDenseModeStyles = (0, $kig2V.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    height: (0, $014x6.relativeSizeToBaseFontSize)((0, $GIvev.QUICK_INSERT_HEIGHT)),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: (0, $014x6.relativeSizeToBaseFontSize)((0, $GIvev.QUICK_INSERT_WIDTH))
});
const $976be041114ddc08$var$containerStaticStyles = (0, $kig2V.xcss)({
    position: 'absolute',
    zIndex: 'card'
});
const $976be041114ddc08$var$tooltipContainerStyles = {
    name: "1hhl1l9",
    styles: "top:8px;bottom:-8px;position:sticky;display:block;z-index:card"
};
const $976be041114ddc08$var$tooltipContainerImprovedStylesStickyHeader = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-blocks-quick-insert-container]:has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    }
});
// We need this to work around adjacent breakout marks wrapping the controls widget decorations
const $976be041114ddc08$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] .pm-table-with-controls tr.sticky) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: (0, $jd8X7.tableControlsSpacing)
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '[data-prosemirror-mark-name="breakout"]:has([data-blocks-quick-insert-container]):has(~ [data-prosemirror-mark-name="fragment"] >[data-prosemirror-node-name="table"] tr.pm-table-row-native-sticky.pm-table-row-native-sticky-active) &': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        top: `${(0, $GIvev.STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER)}px`
    }
});
const $976be041114ddc08$var$getQuickInsertAnchorReference = ({ edge: edge, safeAnchorName: safeAnchorName })=>{
    if ((0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true)) return `anchor(${safeAnchorName} ${edge}, anchor(${0, $GIvev.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME} ${edge}))`;
    return `anchor(${safeAnchorName} ${edge})`;
};
const $976be041114ddc08$export$c64bb72e819f7e01 = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const { macroInteractionUpdates: macroInteractionUpdates } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>{
        var _states$featureFlagsS;
        return {
            macroInteractionUpdates: (_states$featureFlagsS = states.featureFlagsState) === null || _states$featureFlagsS === void 0 ? void 0 : _states$featureFlagsS.macroInteractionUpdates
        };
    });
    const [positionStyles, setPositionStyles] = (0, $fc4bM.useState)({
        display: 'none'
    });
    // Adapted from `src/ui/drag-handle.tsx` as positioning logic is similar
    // CHANGES - added an offset so quick insert button can be positioned beside drag handle
    // CHANGES - removed `editorExperiment('nested-dnd', true)` check and rootNodeType calculation
    // CHANGES - replace anchorName with rootAnchorName
    // CHANGES - `removed editorExperiment('advanced_layouts', true) && isLayoutColumn` checks as quick insert button will not be positioned for layout column
    const calculatePosition = (0, $fc4bM.useCallback)(()=>{
        const supportsAnchor = CSS.supports('top', `anchor(${rootAnchorName} start)`) && CSS.supports('left', `anchor(${rootAnchorName} start)`);
        const pos = getPos();
        const node = pos !== undefined ? view.state.doc.nodeAt(pos) : undefined;
        const safeAnchorName = (0, $dp5ck.refreshAnchorName)({
            getPos: getPos,
            view: view,
            anchorName: rootAnchorName
        });
        const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${safeAnchorName}"]`);
        // Defence-in-depth guard: the node decoration sets data-active-quick-insert on the
        // active root node. Check for it directly — cheap DOM attribute read, no reflow.
        if ((0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && !(dom !== null && dom !== void 0 && dom.hasAttribute((0, $GIvev.ACTIVE_QUICK_INSERT_ATTR)))) return {
            display: 'none'
        };
        const hasResizer = rootNodeType === 'table' || rootNodeType === 'mediaSingle';
        const isExtension = rootNodeType === 'extension' || rootNodeType === 'bodiedExtension' || rootNodeType === 'multiBodiedExtension' && (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true);
        const isBlockCard = rootNodeType === 'blockCard';
        const isEmbedCard = rootNodeType === 'embedCard';
        const isMacroInteractionUpdates = macroInteractionUpdates && isExtension;
        let innerContainer = null;
        if (dom) {
            if (isEmbedCard) innerContainer = dom.querySelector('.rich-media-item');
            else if (hasResizer) innerContainer = dom.querySelector('.resizer-item');
            else if (isExtension) innerContainer = dom.querySelector('.extension-container[data-layout]');
            else if (isBlockCard) //specific to datasource blockCard
            innerContainer = dom.querySelector('.datasourceView-content-inner-wrap');
        }
        const isEdgeCase = (hasResizer || isExtension || isEmbedCard || isBlockCard) && innerContainer;
        const isSticky = (0, $iZXVC.shouldBeSticky)(rootNodeType);
        const anchorStart = $976be041114ddc08$var$getQuickInsertAnchorReference({
            edge: 'start',
            safeAnchorName: safeAnchorName
        });
        const bottom = (0, $iZXVC.getControlBottomCSSValue)(safeAnchorName || anchorName, isSticky, true, false, (0, $GIvev.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME));
        if (supportsAnchor) return {
            left: isEdgeCase ? `calc(${anchorStart} + ${(0, $6cjKN.getLeftPositionForRootElement)(dom, rootNodeType, (0, $GIvev.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $GIvev.QUICK_INSERT_LEFT_OFFSET}px)` : `calc(${anchorStart} - ${(0, $GIvev.QUICK_INSERT_DIMENSIONS).width}px - ${(0, $GIvev.rootElementGap)(rootNodeType)}px + -${0, $GIvev.QUICK_INSERT_LEFT_OFFSET}px)`,
            // small text requires further tweaking to positioning, re-using existing methods to calculate to keep it unified with drag handle
            top: `calc(${anchorStart} + ${(0, $GIvev.topPositionAdjustment)(node && node.type.name === 'paragraph' ? (0, $61p1X.getNodeTypeWithLevel)(node) : rootNodeType)}px)`,
            ...bottom
        };
        // expensive, calls offsetHeight
        const nodeHeight = (0, $iZXVC.getNodeHeight)(dom, safeAnchorName || anchorName, anchorRectCache) || 0;
        const height = (0, $iZXVC.getControlHeightCSSValue)(nodeHeight, isSticky, true, "var(--ds-space-300, 24px)");
        return {
            left: isEdgeCase ? `calc(${(dom === null || dom === void 0 ? void 0 : dom.offsetLeft) || 0}px + ${(0, $6cjKN.getLeftPositionForRootElement)(dom, rootNodeType, (0, $GIvev.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $GIvev.QUICK_INSERT_LEFT_OFFSET}px)` : `calc(${(0, $6cjKN.getLeftPositionForRootElement)(dom, rootNodeType, (0, $GIvev.QUICK_INSERT_DIMENSIONS), innerContainer, isMacroInteractionUpdates)} + -${0, $GIvev.QUICK_INSERT_LEFT_OFFSET}px)`,
            top: (0, $iZXVC.getTopPosition)(dom, rootNodeType),
            ...height
        };
    }, [
        rootAnchorName,
        getPos,
        view,
        rootNodeType,
        macroInteractionUpdates,
        anchorName,
        anchorRectCache
    ]);
    (0, $fc4bM.useEffect)(()=>{
        let cleanUpTransitionListener;
        if (rootNodeType === 'extension' || rootNodeType === 'embedCard') {
            const dom = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${rootAnchorName}"]`);
            if (!dom) return;
            cleanUpTransitionListener = (0, $6Zi52.bind)(dom, {
                type: 'transitionend',
                listener: ()=>{
                    setPositionStyles(calculatePosition());
                }
            });
        }
        const calcPos = requestAnimationFrame(()=>{
            setPositionStyles(calculatePosition());
        });
        return ()=>{
            var _cleanUpTransitionLis;
            cancelAnimationFrame(calcPos);
            (_cleanUpTransitionLis = cleanUpTransitionListener) === null || _cleanUpTransitionLis === void 0 || _cleanUpTransitionLis();
        };
    }, [
        calculatePosition,
        view.dom,
        rootAnchorName,
        rootNodeType
    ]);
    const handleQuickInsert = (0, $fc4bM.useCallback)(()=>{
        var _api$quickInsert;
        // if the selection is not within the node this decoration is rendered at
        // then insert a newline and trigger quick insert
        const start = getPos();
        if (start !== undefined) {
            // if the selection is not within the node this decoration is rendered at
            // or the node is non-editable, then insert a newline and trigger quick insert
            const isSelectionInsideNode = (0, $gbHVV.isSelectionInNode)(start, view);
            if (!isSelectionInsideNode || (0, $gbHVV.isNonEditableBlock)(start, view)) api.core.actions.execute((0, $exoyO.createNewLine)(start));
            const { codeBlock: codeBlock } = view.state.schema.nodes;
            const { selection: selection } = view.state;
            const codeBlockParentNode = (0, $a4TQr.findParentNodeOfType)(codeBlock)(selection);
            if (codeBlockParentNode) // Slash command is not meant to be triggered inside code block, hence always insert slash in a new line following
            api.core.actions.execute((0, $exoyO.createNewLine)(codeBlockParentNode.pos));
            else if (isSelectionInsideNode) {
                // text or element with be deselected and the / added immediately after the paragraph
                // unless the selection is empty
                const currentSelection = view.state.selection;
                if ((0, $gbHVV.isInTextSelection)(view) && currentSelection.from !== currentSelection.to) {
                    const currentParagraphNode = (0, $a4TQr.findParentNode)((node)=>$976be041114ddc08$var$TEXT_PARENT_TYPES.includes(node.type.name))(currentSelection);
                    if (currentParagraphNode) {
                        const newPos = //if the current selection is selected from right to left, then set the selection to the start of the paragraph
                        currentSelection.anchor === currentSelection.to ? currentParagraphNode.pos : currentParagraphNode.pos + currentParagraphNode.node.nodeSize - 1;
                        api.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $801jp.TextSelection).create(view.state.selection.$from.doc, newPos));
                            return tr;
                        });
                    }
                }
                if ((0, $gbHVV.isNestedNodeSelected)(view)) {
                    // if the nested selected node is non-editable, then insert a newline below the selected node
                    if ((0, $gbHVV.isNonEditableBlock)(view.state.selection.from, view)) api.core.actions.execute((0, $exoyO.createNewLine)(view.state.selection.from));
                    else // otherwise need to force the selection to be at the start of the node, because
                    // prosemirror is keeping it as NodeSelection for nested nodes. Do this to keep it
                    // consistent NodeSelection for root level nodes.
                    api.core.actions.execute(({ tr: tr })=>{
                        (0, $exoyO.createNewLine)(view.state.selection.from)({
                            tr: tr
                        });
                        tr.setSelection((0, $801jp.TextSelection).create(tr.doc, view.state.selection.from));
                        return tr;
                    });
                }
                if (currentSelection instanceof (0, $ev7OZ.CellSelection)) {
                    // find the last inline position in the selection
                    const lastInlinePosition = (0, $801jp.TextSelection).near(view.state.selection.$to, -1);
                    lastInlinePosition && api.core.actions.execute(({ tr: tr })=>{
                        if (!(lastInlinePosition instanceof (0, $801jp.TextSelection))) {
                            // this will create a new line after the node
                            (0, $exoyO.createNewLine)(lastInlinePosition.from)({
                                tr: tr
                            });
                            // this will find the next valid text position after the node
                            tr.setSelection((0, $801jp.TextSelection).create(tr.doc, lastInlinePosition.to));
                        } else tr.setSelection(lastInlinePosition);
                        return tr;
                    });
                }
            }
        }
        (_api$quickInsert = api.quickInsert) === null || _api$quickInsert === void 0 || _api$quickInsert.actions.openTypeAhead('blockControl', true);
    }, [
        api,
        getPos,
        view
    ]);
    const handleMouseDown = (0, $fc4bM.useCallback)(()=>{
        var _api$typeAhead;
        // close typeahead if it is open, must happen in mouseDown otherwise typeAhead popup will be dismissed and text is left
        if ((_api$typeAhead = api.typeAhead) !== null && _api$typeAhead !== void 0 && _api$typeAhead.actions.isOpen(view.state)) api.typeAhead.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        api,
        view.state
    ]);
    const tooltipPressable = ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
            position: "top",
            content: /*#__PURE__*/ (0, $jctmk.jsx)((0, $eUtBU.ToolTipContent), {
                description: formatMessage((0, $7u4Lo.messages).insert)
            })
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $l3fZT.Pressable), {
            testId: "editor-quick-insert-button",
            type: "button",
            "aria-label": formatMessage((0, $7u4Lo.messages).insert),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            xcss: [
                $976be041114ddc08$var$stickyButtonStyles,
                $976be041114ddc08$var$stickyButtonDenseModeStyles
            ],
            onClick: handleQuickInsert,
            onMouseDown: handleMouseDown
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jGvkt))), {
            label: "add",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        })));
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: positionStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $976be041114ddc08$var$containerStaticStyles
        ]
    }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: [
            $976be041114ddc08$var$tooltipContainerStyles,
            $976be041114ddc08$var$tooltipContainerImprovedStylesStickyHeader,
            $976be041114ddc08$var$tooltipContainerStylesImprovedStickyHeaderWithMarksFix
        ]
    }, tooltipPressable()));
};
const $976be041114ddc08$export$6ffb15bf86dea6dd = ({ view: view, api: api, formatMessage: formatMessage, getPos: getPos, nodeType: nodeType, anchorName: anchorName, rootAnchorName: rootAnchorName, rootNodeType: rootNodeType, anchorRectCache: anchorRectCache })=>{
    const rightSideControlsEnabled = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>{
        var _states$blockControls;
        return {
            rightSideControlsEnabled: ((_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.rightSideControlsEnabled) ?? false
        };
    }).rightSideControlsEnabled;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5wcYI.VisibilityContainer), {
        api: api,
        controlSide: rightSideControlsEnabled ? 'left' : undefined
    }, /*#__PURE__*/ (0, $jctmk.jsx)($976be041114ddc08$export$c64bb72e819f7e01, {
        view: view,
        api: api,
        formatMessage: formatMessage,
        getPos: getPos,
        nodeType: nodeType,
        anchorName: anchorName,
        rootAnchorName: rootAnchorName,
        rootNodeType: rootNodeType,
        anchorRectCache: anchorRectCache
    }));
};

});
parcelRegister("6cjKN", function(module, exports) {
$parcel$export(module.exports, "getLeftPositionForRootElement", () => $4371dd902c0e978e$export$78de92b32db40bc4);

var $GIvev = parcelRequire("GIvev");
const $4371dd902c0e978e$export$78de92b32db40bc4 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    if (!innerContainer) return `${dom.offsetLeft - (0, $GIvev.rootElementGap)(nodeType) - widgetDimensions.width}px`;
    // There is a showMacroInteractionDesignUpdates prop in extension node wrapper that can add a relative span under the top level div
    // We need to adjust the left offset position of the drag handle to account for the relative span
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment - (0, $GIvev.rootElementGap)(nodeType) - widgetDimensions.width}px` : `${innerContainer.offsetLeft + leftAdjustment - innerContainer.offsetWidth / 2 - (0, $GIvev.rootElementGap)(nodeType) - widgetDimensions.width}px`;
};
const $4371dd902c0e978e$export$6efb694a25295ec1 = (dom, nodeType, widgetDimensions, innerContainer, macroInteractionUpdates)=>{
    if (!dom) return 'auto';
    const relativeSpan = macroInteractionUpdates ? dom.querySelector('span.relative') : null;
    const leftAdjustment = relativeSpan ? relativeSpan.offsetLeft : 0;
    const gap = (0, $GIvev.rootElementGap)(nodeType);
    const width = widgetDimensions.width;
    if (!innerContainer) return `${dom.offsetLeft + leftAdjustment + dom.offsetWidth - gap - width}px`;
    return getComputedStyle(innerContainer).transform === 'none' ? `${innerContainer.offsetLeft + leftAdjustment + innerContainer.offsetWidth - gap - width}px` : `${innerContainer.offsetLeft + leftAdjustment + innerContainer.offsetWidth / 2 - gap - width}px`;
};

});

parcelRegister("gbHVV", function(module, exports) {
$parcel$export(module.exports, "isNestedNodeSelected", () => $0b18f03f9a90c74d$export$714e822c87fefc18);
$parcel$export(module.exports, "isSelectionInNode", () => $0b18f03f9a90c74d$export$9aa13fc11fb69569);
$parcel$export(module.exports, "isInTextSelection", () => $0b18f03f9a90c74d$export$ec6e1e8159855f97);
$parcel$export(module.exports, "isNonEditableBlock", () => $0b18f03f9a90c74d$export$907327ee9908a2);

var $801jp = parcelRequire("801jp");
const $0b18f03f9a90c74d$export$714e822c87fefc18 = (view)=>{
    const selection = view.state.selection;
    return selection instanceof (0, $801jp.NodeSelection) && selection.$from.depth > 0;
};
const $0b18f03f9a90c74d$export$9aa13fc11fb69569 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    const endPos = start + node.nodeSize;
    const startPos = start;
    const { $from: $from, $to: $to } = view.state.selection;
    return $from.pos >= startPos && endPos >= $to.pos;
};
const $0b18f03f9a90c74d$export$ec6e1e8159855f97 = (view)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $801jp.TextSelection)) return true;
    else if (selection instanceof (0, $801jp.NodeSelection)) // check if this is a node that can appear among text
    return selection.node.isInline;
};
const $0b18f03f9a90c74d$export$907327ee9908a2 = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (node === null) return false;
    // We want to treat some elements as if they are non-editable blocks for
    // the purposes of quick insert.
    switch(node.type.name){
        // mediaSingle and mediaGroup always contain a media child node, which is
        // both a block and an atom. mediaSingle can also have a caption child node
        // which is an editable block.
        case 'mediaGroup':
        case 'mediaSingle':
            return true;
    }
    return node.isBlock && (node.isAtom || node.isLeaf);
};

});

parcelRegister("exoyO", function(module, exports) {
$parcel$export(module.exports, "createNewLine", () => $b16a86bbbe98d90c$export$3ca0fafcb5f79c56);

var $801jp = parcelRequire("801jp");
const $b16a86bbbe98d90c$export$3ca0fafcb5f79c56 = (start)=>({ tr: tr })=>{
        var _tr$doc$nodeAt;
        const nodeSize = (_tr$doc$nodeAt = tr.doc.nodeAt(start)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.nodeSize;
        if (nodeSize === undefined) return tr;
        const position = start + nodeSize;
        tr.insert(position, tr.doc.type.schema.nodes.paragraph.create());
        return tr.setSelection((0, $801jp.TextSelection).near(tr.doc.resolve(position)));
    };

});



parcelRegister("l09lv", function(module, exports) {
$parcel$export(module.exports, "handleMouseDown", () => $5e1a27392df6899a$export$b4a93e0b711d8f7);

var $gCPs3 = parcelRequire("gCPs3");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");
const $5e1a27392df6899a$export$b4a93e0b711d8f7 = (api)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        if (!view.editable) {
            const targetPos = view.posAtDOM(event.target, 0);
            // always fetch top level position for mouseDown to avoid drag handle positions being incorrect
            const rootPos = view.state.doc.resolve(targetPos).before(1);
            const rootNode = view.state.doc.nodeAt(rootPos);
            if (!rootNode) return false;
            if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                const anchorName = api === null || api === void 0 ? void 0 : api.core.actions.getAnchorIdForNode(rootNode, rootPos);
                // don't show the handles if we can't find an anchor
                if (!anchorName) return false;
                api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.blockControls.commands.showDragHandleAt(rootPos, anchorName, rootNode.type.name ?? '', undefined, rootPos, anchorName, rootNode.type.name ?? ''));
            } else api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.blockControls.commands.showDragHandleAt(rootPos, '', rootNode.type.name ?? '', undefined, rootPos, '', rootNode.type.name ?? ''));
        } else {
            const isDragHandle = event.target.closest((0, $gCPs3.DRAG_HANDLE_SELECTOR)) !== null;
            api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                api === null || api === void 0 || api.blockControls.commands.setSelectedViaDragHandle(isDragHandle)({
                    tr: tr
                });
                /**
       * When block menu is enabled, reset intent back to 'default' as editor-plugin-block-menu sets the user intent to 'blockMenuOpen', and setting here
       * causes flickering as this runs before editor-plugin-block-menu.
       */ // if target is drag handle, block menu will be opened
                if (!isDragHandle) {
                    var _api$userIntent;
                    api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('default')({
                        tr: tr
                    });
                }
                return tr;
            });
        }
        return false;
    };

});

parcelRegister("gqrsA", function(module, exports) {
$parcel$export(module.exports, "handleMouseOver", () => $212a078a129efd03$export$321c2da35903b013);

var $jiju3 = parcelRequire("jiju3");

var $d1RPX = parcelRequire("d1RPX");

var $fmnS6 = parcelRequire("fmnS6");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $dj84o = parcelRequire("dj84o");

var $2xAfa = parcelRequire("2xAfa");

var $b8Grq = parcelRequire("b8Grq");
const $212a078a129efd03$var$isEmptyNestedParagraphOrHeading = (target)=>{
    if (target instanceof HTMLHeadingElement || target instanceof HTMLParagraphElement) {
        var _target$parentElement;
        return !((_target$parentElement = target.parentElement) !== null && _target$parentElement !== void 0 && _target$parentElement.classList.contains('ProseMirror')) && target.textContent === '';
    }
    return false;
};
const $212a078a129efd03$var$getNodeSelector = (ignoreNodes, ignoreNodeDescendants)=>{
    const baseSelector = `[${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}]`;
    if (ignoreNodes.length === 0 && ignoreNodeDescendants.length === 0) return baseSelector;
    const ignoreNodeSelectorList = ignoreNodes.map((node)=>`[data-prosemirror-node-name="${node}"]`);
    const ignoreNodeDescendantsSelectorList = ignoreNodeDescendants.map((node)=>{
        if (node === 'table') // Special case for table to exclude its direct descendants
        return [
            `[data-prosemirror-node-name="tableCell"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableCell"] > *:not([data-node-anchor]) > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > [data-node-anchor]`,
            `[data-prosemirror-node-name="tableHeader"] > *:not([data-node-anchor]) > [data-node-anchor]`
        ];
        return `[data-prosemirror-node-name="${node}"] [data-node-anchor]`;
    });
    const ignoreSelector = [
        ...ignoreNodeSelectorList,
        ...ignoreNodeDescendantsSelectorList.flat(),
        '[data-prosemirror-node-inline="true"]'
    ].join(', ');
    return `${baseSelector}:not(${ignoreSelector})`;
};
const $212a078a129efd03$var$getDefaultNodeSelector = (0, $jiju3.default)(()=>{
    // we don't show handler for node nested in table
    return $212a078a129efd03$var$getNodeSelector([
        ...(0, $2xAfa.IGNORE_NODES_NEXT),
        'media'
    ], [
        ...(0, $2xAfa.IGNORE_NODE_DESCENDANTS_ADVANCED_LAYOUT),
        'table'
    ]);
});
/**
 * `panel_c1` is the nestable panel variant and renders the same DOM as `panel`, so it must
 * suppress block controls on its first child too. No-exposure check as this runs on every
 * mouseover.
 */ const $212a078a129efd03$var$isPanelNodeTypeName = (nodeTypeName)=>{
    if (nodeTypeName === 'panel') return true;
    return nodeTypeName === 'panel_c1' && (0, $3NBIB.expValEqualsNoExposure)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $dRkX9.fg)('platform_editor_controls_reliable_anchor_patch_1');
};
// Block marks (e.g. font-size) wrap paragraphs in an extra div, making parentRootElement
// the mark wrapper instead of the panel content container. When that happens, recalculate
// the index relative to the panel content so the first-child check stays accurate.
const $212a078a129efd03$var$getBlockMarkPanelIndexAdjustment = (parentRootElement, index)=>{
    if (parentRootElement.classList.contains('fabric-editor-block-mark') && parentRootElement.parentElement) return Array.from(parentRootElement.parentElement.childNodes).indexOf(parentRootElement);
    return index;
};
/**
 * If the hovered element is a paragraph adjacent to a wrapped mediaSingle/embedCard,
 * redirect to the media node so only one drag handle shows (ED-26959).
 */ const $212a078a129efd03$var$redirectParagraphToWrappedMedia = (rootElement, isNativeAnchorSupported)=>{
    const hoveredNodeType = isNativeAnchorSupported ? (0, $dj84o.getTypeNameFromDom)(rootElement) : rootElement.getAttribute('data-drag-handler-node-type');
    if (hoveredNodeType !== 'paragraph') return rootElement;
    const isWrappedMediaEmbedSibling = (sibling)=>{
        if (!sibling || !sibling.getAttribute((0, $dj84o.getAnchorAttrName)())) return false;
        const siblingType = isNativeAnchorSupported ? (0, $dj84o.getTypeNameFromDom)(sibling) : sibling.getAttribute('data-drag-handler-node-type');
        const siblingLayout = sibling.getAttribute('layout') || '';
        return (siblingType === 'mediaSingle' || siblingType === 'embedCard') && [
            'wrap-left',
            'wrap-right'
        ].includes(siblingLayout);
    };
    const prevSibling = rootElement.previousElementSibling;
    const nextSibling = rootElement.nextElementSibling;
    if (prevSibling && isWrappedMediaEmbedSibling(prevSibling)) return prevSibling;
    else if (nextSibling && isWrappedMediaEmbedSibling(nextSibling)) return nextSibling;
    return rootElement;
};
const $212a078a129efd03$export$321c2da35903b013 = (view, event, api)=>{
    var _api$blockControls, _api$editorDisabled, _api$editorViewMode, _api$userIntent, _api$showDiff, _api$blockControls2, _target$classList;
    const { isDragging: isDragging, activeNode: activeNode, isMenuOpen: isMenuOpen, menuTriggerBy: originalAnchorName, blockMenuOptions: blockMenuOptions } = (api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.sharedState.currentState()) || {};
    const { editorDisabled: editorDisabled } = (api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.sharedState.currentState()) || {
        editorDisabled: false
    };
    const editorViewMode = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode;
    const isViewMode = editorViewMode === 'view';
    const toolbarFlagsEnabled = (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    // EDITOR-7926: bail out while a diff is on screen (or a suggestion card is open) so hovering
    // doesn't dispatch showDragHandleAt and cause the drag handle to jitter over the diff.
    const currentUserIntent = api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent;
    const isDisplayingDiff = (api === null || api === void 0 || (_api$showDiff = api.showDiff) === null || _api$showDiff === void 0 || (_api$showDiff = _api$showDiff.sharedState.currentState()) === null || _api$showDiff === void 0 ? void 0 : _api$showDiff.isDisplayingChanges) ?? false;
    if (isDisplayingDiff || currentUserIntent === 'reviewing') return false;
    // We shouldn't be firing mouse over transactions when the editor is disabled,
    // except in view mode when right-side controls are enabled (show controls on block hover)
    const rightSideControlsEnabled = (api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.sharedState.currentState()) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.rightSideControlsEnabled) ?? false;
    if (editorDisabled && (!isViewMode || !rightSideControlsEnabled)) return false;
    // If the editor view is not in focus when the block menu is open, do not update the drag handle
    if (!view.hasFocus() && isMenuOpen) return false;
    // Most mouseover events don't fire during drag but some can slip through
    // when the drag begins. This prevents those.
    if (isDragging) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isNativeAnchorSupported = (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration');
    if (target !== null && target !== void 0 && (_target$classList = target.classList) !== null && _target$classList !== void 0 && _target$classList.contains('ProseMirror')) return false;
    let rootElement = target === null || target === void 0 ? void 0 : target.closest(isNativeAnchorSupported ? $212a078a129efd03$var$getDefaultNodeSelector() : `[data-drag-handler-anchor-name]`);
    // Fallback for table nodes in view mode: the table-anchor-names plugin sets data-node-anchor on
    // the first <tr> element.
    // - When platform_editor_native_anchor_with_dnd is disabled, the primary closest() uses
    //   [data-drag-handler-anchor-name] and misses table rows. Try data-node-anchor via closest().
    // - For wide/max breakout tables, hovering in the left/right margin area of the full-viewport-
    //   width breakout wrapper (ak-editor-breakout-mark) sets event.target to the wrapper div, which
    //   has no anchor attribute. Use querySelector to find the [data-node-anchor] descendant inside.
    // Both cases apply only in view mode with right-side remix controls.
    if (!rootElement && isViewMode && rightSideControlsEnabled) rootElement = (target === null || target === void 0 ? void 0 : target.closest(`[${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}]`)) ?? (target instanceof HTMLElement ? target.querySelector(`[${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}]`) : null) ?? null;
    // When hovering over the right-edge button (rendered in a portal outside the block), resolve the
    // block from the container's anchor so activeNode stays set and the button remains visible.
    if (!rootElement && rightSideControlsEnabled) {
        const rightEdgeContainer = target === null || target === void 0 ? void 0 : target.closest('[data-blocks-right-edge-button-container]');
        if (rightEdgeContainer) {
            const anchor = rightEdgeContainer.getAttribute('data-blocks-right-edge-button-anchor');
            if (anchor) rootElement = view.dom.querySelector(`[${(0, $dj84o.getAnchorAttrName)()}="${CSS.escape(anchor)}"]`);
        }
    }
    if (rootElement) {
        var _rootElement$parentEl;
        // We want to exlude handles from showing for empty paragraph and heading nodes
        if ($212a078a129efd03$var$isEmptyNestedParagraphOrHeading(rootElement)) return false;
        if (rootElement.getAttribute((0, $dj84o.getTypeNameAttrName)()) === 'media' && (0, $kaRof.editorExperiment)('advanced_layouts', true) && !isNativeAnchorSupported) {
            rootElement = rootElement.closest(`[${(0, $dj84o.getAnchorAttrName)()}][${(0, $dj84o.getTypeNameAttrName)()}="mediaSingle"]`);
            if (!rootElement) return false;
        }
        const parentElement = (_rootElement$parentEl = rootElement.parentElement) === null || _rootElement$parentEl === void 0 ? void 0 : _rootElement$parentEl.closest(`[${(0, $dj84o.getAnchorAttrName)()}]`);
        const parentElementType = isNativeAnchorSupported ? (0, $dj84o.getTypeNameFromDom)(parentElement) : parentElement === null || parentElement === void 0 ? void 0 : parentElement.getAttribute('data-drag-handler-node-type');
        if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) {
            // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
            if (parentElement && parentElementType === 'table') rootElement = parentElement;
            else if (parentElement && parentElementType === 'tableRow') {
                var _parentElement$parent;
                const grandparentElement = parentElement === null || parentElement === void 0 || (_parentElement$parent = parentElement.parentElement) === null || _parentElement$parent === void 0 ? void 0 : _parentElement$parent.closest(`[${(0, $dj84o.getAnchorAttrName)()}]`);
                const grandparentElementType = isNativeAnchorSupported ? (0, $dj84o.getTypeNameFromDom)(grandparentElement) : grandparentElement === null || grandparentElement === void 0 ? void 0 : grandparentElement.getAttribute('data-drag-handler-node-type');
                if (grandparentElement && grandparentElementType === 'table') rootElement = grandparentElement;
            }
        } else // We want to exclude handles from showing for direct descendant of table nodes (i.e. nodes in cells)
        if (parentElement && parentElementType === 'table') rootElement = parentElement;
        // A wrapped mediaSingle/embedCard and the paragraph(s) it floats next to both have
        // anchor decorations. If the hovered rootElement is a paragraph whose adjacent DOM sibling
        // is a wrapped mediaSingle/embedCard with an anchor, redirect the handle to the media node
        // so only one handle shows (ED-26959).
        // We check previousElementSibling (wrap-left: media precedes text in DOM) and
        // nextElementSibling (wrap-right: media follows text in DOM).
        // This must happen before anchorName is read so the correct node's handle is shown.
        rootElement = $212a078a129efd03$var$redirectParagraphToWrappedMedia(rootElement, isNativeAnchorSupported);
        let anchorName;
        if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
            anchorName = rootElement.getAttribute((0, $dj84o.getAnchorAttrName)());
            // don't show handles if we can't find an anchor
            if (!anchorName) return false;
        } else {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            anchorName = rootElement.getAttribute((0, $dj84o.getAnchorAttrName)());
            // Fallback for table nodes that only have data-node-anchor (not data-drag-handler-anchor-name).
            if (!anchorName) anchorName = rootElement.getAttribute((0, $dj84o.NODE_ANCHOR_ATTR_NAME)) ?? anchorName;
        }
        // No need to update handle position if its already there
        if ((activeNode === null || activeNode === void 0 ? void 0 : activeNode.anchorName) === anchorName) return false;
        const parentRootElement = rootElement.parentElement;
        let pos;
        if (parentRootElement) {
            var _parentRootElement$ch;
            const childNodes = Array.from(parentRootElement.childNodes);
            const index = childNodes.indexOf(rootElement);
            pos = view.posAtDOM(parentRootElement, index);
            const panelIndex = $212a078a129efd03$var$getBlockMarkPanelIndexAdjustment(parentRootElement, index);
            // We want to exlude handles showing for first element in a Panel, ignoring widgets like gapcursor
            const firstChildIsWidget = parentRootElement === null || parentRootElement === void 0 || (_parentRootElement$ch = parentRootElement.children[0]) === null || _parentRootElement$ch === void 0 ? void 0 : _parentRootElement$ch.classList.contains('ProseMirror-widget');
            if (parentElement && $212a078a129efd03$var$isPanelNodeTypeName(parentElementType) && !parentElement.classList.contains('ak-editor-panel__no-icon') && (panelIndex === 0 || firstChildIsWidget && panelIndex === 1)) return false;
        } else pos = view.posAtDOM(rootElement, 0);
        const targetPos = view.state.doc.resolve(pos).pos;
        let rootAnchorName;
        let rootNodeType;
        let rootPos;
        // platform_editor_controls note: enables quick insert
        if (toolbarFlagsEnabled) {
            rootPos = view.state.doc.resolve(pos).before(1);
            if (targetPos !== rootPos) {
                const rootDOM = view.nodeDOM(rootPos);
                if (rootDOM instanceof HTMLElement) {
                    rootAnchorName = rootDOM.getAttribute((0, $dj84o.getAnchorAttrName)()) ?? rootDOM.getAttribute((0, $dj84o.NODE_ANCHOR_ATTR_NAME)) ?? undefined;
                    rootNodeType = isNativeAnchorSupported ? (0, $dj84o.getTypeNameFromDom)(rootDOM) : // Fallback: breakout mark wrappers have no data-drag-handler-node-type;
                    // use data-prosemirror-node-name instead.
                    rootDOM.getAttribute('data-drag-handler-node-type') ?? (0, $dj84o.getTypeNameFromDom)(rootDOM);
                }
            }
        }
        const nodeType = isNativeAnchorSupported ? (0, $dj84o.getTypeNameFromDom)(rootElement) : // Fallback for table nodes: tr has data-prosemirror-node-name but not data-drag-handler-node-type.
        rootElement.getAttribute('data-drag-handler-node-type') ?? (0, $dj84o.getTypeNameFromDom)(rootElement);
        if (nodeType) {
            var _api$userIntent2;
            // platform_editor_controls note: enables quick insert
            if (toolbarFlagsEnabled) {
                var _selectionPreservatio;
                const preservedSelection = (_selectionPreservatio = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state)) === null || _selectionPreservatio === void 0 ? void 0 : _selectionPreservatio.preservedSelection;
                const selection = preservedSelection || view.state.selection;
                const isMultipleSelected = selection && (0, $d1RPX.isMultiBlockSelection)(selection);
                // Only execute when selection is not a multi-selection, block menu is open, and menu is opened via keyboard
                // as when it is a multi-selection, the showDragHandleAt command interfere with selection
                // sometimes makes the multi-selection not continous after block menu is opened with keyboard
                if (!(isMultipleSelected && isMenuOpen && blockMenuOptions !== null && blockMenuOptions !== void 0 && blockMenuOptions.openedViaKeyboard)) {
                    var _api$core, _api$blockControls3;
                    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 ? void 0 : _api$blockControls3.commands.showDragHandleAt(targetPos, anchorName, nodeType, undefined, rootPos ?? targetPos, rootAnchorName ?? anchorName, rootNodeType ?? nodeType));
                }
            } else {
                var _api$core2, _api$blockControls4;
                api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 ? void 0 : _api$blockControls4.commands.showDragHandleAt(targetPos, anchorName, nodeType));
            }
            if (isMenuOpen && originalAnchorName && (api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || (_api$userIntent2 = _api$userIntent2.sharedState.currentState()) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.currentUserIntent) === 'blockMenuOpen') {
                var _api$core3, _api$blockControls5;
                api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(api === null || api === void 0 || (_api$blockControls5 = api.blockControls) === null || _api$blockControls5 === void 0 ? void 0 : _api$blockControls5.commands.toggleBlockMenu());
            }
        }
    }
};

});

parcelRegister("gUxz5", function(module, exports) {
$parcel$export(module.exports, "boundKeydownHandler", () => $9220d443531d3b2b$export$2734319938f9e9db);

var $eUtBU = parcelRequire("eUtBU");

var $krxnk = parcelRequire("krxnk");

var $1O8Lw = parcelRequire("1O8Lw");

var $28S2Q = parcelRequire("28S2Q");

var $9bUoK = parcelRequire("9bUoK");
function $9220d443531d3b2b$var$keymapList(api, formatMessage) {
    const keymapList = {};
    if (api) {
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.showElementDragHandle).common, (state, dispatch, view)=>{
            (0, $9bUoK.showDragHandleAtSelection)(api)(state, dispatch, view);
            //we always want to handle this shortcut to prevent default browser special char insert when option + alphabetical key is used
            return true;
        }, keymapList);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.dragToMoveUp).common, (0, $28S2Q.moveNodeViaShortcut)(api, (0, $krxnk.DIRECTION).UP, formatMessage), keymapList);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.dragToMoveDown).common, (0, $28S2Q.moveNodeViaShortcut)(api, (0, $krxnk.DIRECTION).DOWN, formatMessage), keymapList);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.dragToMoveLeft).common, (0, $28S2Q.moveNodeViaShortcut)(api, (0, $krxnk.DIRECTION).LEFT, formatMessage), keymapList);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.dragToMoveRight).common, (0, $28S2Q.moveNodeViaShortcut)(api, (0, $krxnk.DIRECTION).RIGHT, formatMessage), keymapList);
    }
    return keymapList;
}
const $9220d443531d3b2b$export$2734319938f9e9db = (api, formatMessage)=>(0, $1O8Lw.keydownHandler)($9220d443531d3b2b$var$keymapList(api, formatMessage));

});
parcelRegister("28S2Q", function(module, exports) {
$parcel$export(module.exports, "moveNodeViaShortcut", () => $17c0b389a89272da$export$3438b98b9a6e008b);
$parcel$export(module.exports, "moveNode", () => $17c0b389a89272da$export$83751492c88cf2ca);

var $3LeME = parcelRequire("3LeME");

var $hIUTz = parcelRequire("hIUTz");

var $7u4Lo = parcelRequire("7u4Lo");

var $eCKpe = parcelRequire("eCKpe");

var $ihNBw = parcelRequire("ihNBw");

var $hhFDR = parcelRequire("hhFDR");

var $krxnk = parcelRequire("krxnk");

var $39oqF = parcelRequire("39oqF");

var $e8CsO = parcelRequire("e8CsO");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $a4TQr = parcelRequire("a4TQr");

var $5n2u9 = parcelRequire("5n2u9");
var $auYrv = parcelRequire("auYrv");
var $kD3Xq = parcelRequire("kD3Xq");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $gyNLa = parcelRequire("gyNLa");

var $3TAWV = parcelRequire("3TAWV");

var $dStWQ = parcelRequire("dStWQ");

var $7MVJk = parcelRequire("7MVJk");

var $7f0FC = parcelRequire("7f0FC");

var $k6Ywe = parcelRequire("k6Ywe");

var $g4us8 = parcelRequire("g4us8");

var $hpR0v = parcelRequire("hpR0v");

var $8MRTx = parcelRequire("8MRTx");

var $kVX7L = parcelRequire("kVX7L");
/**
 * This function transforms the slice to move
 * @param nodeCopy The slice contains the node to be moved
 * @param destType The type of the destiation node
 * @returns transformed slice or null if unable to
 */ function $17c0b389a89272da$var$transformSourceSlice(nodeCopy, destType) {
    const srcNode = nodeCopy.content.firstChild;
    const schema = srcNode === null || srcNode === void 0 ? void 0 : srcNode.type.schema;
    if (!schema) return nodeCopy;
    const { doc: doc, layoutColumn: layoutColumn } = schema.nodes;
    const destTypeInTable = (0, $8MRTx.isInsideTable)(destType);
    const destTypeInDocOrLayoutCol = [
        doc,
        layoutColumn
    ].includes(destType);
    // Only run transformation loop if destination may need node conversions:
    // - Table destinations may need expand → nestedExpand
    // - Doc/layoutColumn destinations may need nestedExpand → expand
    // - When panel_c1 experiment is on:
    // - Expand/table/bodied extension destinations may need panel_c1 → panel downgrade
    // - Doc/layoutColumn destinations may need panel → panel_c1 upgrade
    const needsTransformCheck = destTypeInTable || destTypeInDocOrLayoutCol || (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true);
    if (!needsTransformCheck) return nodeCopy;
    let containsExpand = false;
    let containsNestedExpand = false;
    // Track variant nodes (e.g. panel_c1) and their base forms (e.g. panel).
    // Uses getBaseNodeTypeName to auto-detect variants — new variants only need
    // to be added to variantToBaseNameMap, no changes needed in the detection loop.
    let variantType = null;
    let baseOfVariantType = null;
    for(let i = 0; i < nodeCopy.content.childCount; i++){
        const node = nodeCopy.content.child(i);
        if (node.type === schema.nodes.expand) containsExpand = true;
        else if (node.type === schema.nodes.nestedExpand) containsNestedExpand = true;
        if ((0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
            const baseName = (0, $e8CsO.getBaseNodeTypeName)(node.type);
            if (baseName !== node.type.name) variantType = node.type.name;
            else if (schema.nodes[`${baseName}_c1`]) baseOfVariantType = node.type.name;
        }
        if (containsExpand && containsNestedExpand && (variantType || baseOfVariantType)) break;
    }
    if (containsExpand && destTypeInTable) return (0, $8MRTx.transformSliceExpandToNestedExpand)(nodeCopy);
    else if (containsNestedExpand && destTypeInDocOrLayoutCol) return (0, $hhFDR.transformSliceNestedExpandToExpand)(nodeCopy, schema);
    // Downgrade variant → base (e.g. panel_c1 → panel) when dest doesn't support the variant
    if (variantType && schema.nodes[variantType]) {
        const destParent = destType.createAndFill();
        if (destParent && !(0, $e8CsO.isNodeTypeValidChildOf)(variantType, destParent, schema)) {
            const baseName = (0, $e8CsO.getBaseNodeTypeName)(schema.nodes[variantType]);
            return (0, $8MRTx.transformSliceNodeType)(nodeCopy, schema, variantType, baseName);
        }
    }
    // Upgrade base → variant (e.g. panel → panel_c1) when dest supports the variant
    if (baseOfVariantType) {
        const variantName = `${baseOfVariantType}_c1`;
        if (schema.nodes[variantName]) {
            const destParent = destType.createAndFill();
            if (destParent && (0, $e8CsO.isNodeTypeValidChildOf)(variantName, destParent, schema)) return (0, $8MRTx.transformSliceNodeType)(nodeCopy, schema, baseOfVariantType, variantName);
        }
    }
    return nodeCopy;
}
const $17c0b389a89272da$var$nodesSupportDragLayoutColumnInto = [
    'tableCell',
    'tableHeader',
    'panel',
    'expand',
    'nestedExpand'
];
const $17c0b389a89272da$var$isDragLayoutColumnIntoSupportedNodes = ($from, $to)=>{
    var _$from$nodeAfter;
    const isTopLevel = $to.depth === 0;
    const toParentTypeName = (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $e8CsO.getBaseNodeTypeName)($to.parent.type) : $to.parent.type.name;
    const isDragIntoNodes = $17c0b389a89272da$var$nodesSupportDragLayoutColumnInto.includes(toParentTypeName);
    const supportedCondition = isDragIntoNodes || isTopLevel;
    return ((_$from$nodeAfter = $from.nodeAfter) === null || _$from$nodeAfter === void 0 ? void 0 : _$from$nodeAfter.type.name) === 'layoutColumn' && $from.parent.type.name === 'layoutSection' && supportedCondition;
};
/**
 *
 * @returns the start position of a node if the node can be moved, otherwise -1
 */ const $17c0b389a89272da$var$getCurrentNodePos = (state)=>{
    const { selection: selection } = state;
    let currentNodePos = -1;
    // There are 3 cases when a node can be moved
    const focusedHandle = $17c0b389a89272da$var$getFocusedHandle(state);
    if (focusedHandle) // 1. drag handle of the node is focused
    currentNodePos = focusedHandle.pos;
    else if ((0, $auYrv.isInTable)(state)) {
        if ((0, $kD3Xq.isTableSelected)(selection)) {
            var _findTable;
            // We only move table node if it's fully selected
            // to avoid shortcut collision with table drag and drop
            currentNodePos = ((_findTable = (0, $5n2u9.findTable)(selection)) === null || _findTable === void 0 ? void 0 : _findTable.pos) ?? currentNodePos;
        }
    } else if (!(state.selection instanceof (0, $ihNBw.GapCursorSelection))) {
        // 2. caret cursor is inside the node
        // 3. the start of the selection is inside the node
        currentNodePos = selection.$from.before(1);
        if (selection.$from.depth > 0) currentNodePos = (0, $7MVJk.getNestedNodePosition)({
            selection: selection,
            schema: state.schema,
            resolve: state.doc.resolve.bind(state.doc)
        });
    }
    return currentNodePos;
};
const $17c0b389a89272da$var$getFocusedHandle = (state)=>{
    var _activeNode$handleOpt;
    const { activeNode: activeNode } = (0, $gyNLa.key).getState(state) || {};
    return activeNode && (_activeNode$handleOpt = activeNode.handleOptions) !== null && _activeNode$handleOpt !== void 0 && _activeNode$handleOpt.isFocused ? activeNode : undefined;
};
const $17c0b389a89272da$export$3438b98b9a6e008b = (api, direction, formatMessage)=>{
    return (state)=>{
        const { selection: selection } = state;
        const isParentNodeOfTypeLayout = !!(0, $a4TQr.findParentNodeOfType)([
            state.schema.nodes.layoutSection
        ])(state.selection);
        const expandedSelection = (0, $eCKpe.expandSelectionBounds)(selection.$anchor, selection.$head);
        const expandedAnchor = expandedSelection.$anchor.pos;
        const expandedHead = expandedSelection.$head.pos;
        let hoistedPos;
        const from = Math.min(expandedAnchor, expandedHead);
        // Nodes like lists nest within themselves, we need to find the top most position
        if (isParentNodeOfTypeLayout) {
            const LAYOUT_COL_DEPTH = 3;
            hoistedPos = state.doc.resolve(from).before(LAYOUT_COL_DEPTH);
        }
        const table = (0, $kD3Xq.isTableSelected)(selection) ? (0, $5n2u9.findTable)(selection) : undefined;
        let currentNodePos;
        if (table) currentNodePos = table.pos;
        else if (!$17c0b389a89272da$var$getFocusedHandle(state) && !selection.empty) currentNodePos = hoistedPos ?? from;
        else currentNodePos = $17c0b389a89272da$var$getCurrentNodePos(state);
        if (currentNodePos > -1) {
            var _state$doc$nodeAt;
            const $currentNodePos = state.doc.resolve(currentNodePos);
            let nodeAfterPos;
            if (table) nodeAfterPos = table.pos + table.node.nodeSize;
            else if (!$17c0b389a89272da$var$getFocusedHandle(state)) nodeAfterPos = Math.max(expandedAnchor, expandedHead);
            else nodeAfterPos = $currentNodePos.posAtIndex($currentNodePos.index() + 1);
            const isTopLevelNode = $currentNodePos.depth === 0;
            let moveToPos = -1;
            const isLayoutColumnSelected = selection instanceof (0, $801jp.NodeSelection) && selection.node.type.name === 'layoutColumn';
            if (direction === (0, $krxnk.DIRECTION).LEFT) {
                if (isTopLevelNode && (0, $kaRof.editorExperiment)('advanced_layouts', true)) {
                    var _api$core, _api$core2;
                    const nodeBefore = $currentNodePos.nodeBefore;
                    if (nodeBefore) moveToPos = currentNodePos - nodeBefore.nodeSize;
                    if (moveToPos < 0) return false;
                    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                        var _api$blockControls;
                        api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 || _api$blockControls.moveToLayout(currentNodePos, moveToPos, {
                            moveToEnd: true,
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $hpR0v.getInsertLayoutStep)(tr);
                        const mappedTo = insertColumnStep === null || insertColumnStep === void 0 ? void 0 : insertColumnStep.from;
                        (0, $hpR0v.updateSelection)(tr, mappedTo, true);
                        return tr;
                    });
                    api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    var _$currentNodePos$node, _api$core3, _api$blockControls2;
                    moveToPos = selection.from - (((_$currentNodePos$node = $currentNodePos.nodeBefore) === null || _$currentNodePos$node === void 0 ? void 0 : _$currentNodePos$node.nodeSize) || 1);
                    api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || (_api$blockControls2 = _api$blockControls2.commands) === null || _api$blockControls2 === void 0 ? void 0 : _api$blockControls2.moveToLayout(currentNodePos, moveToPos, {
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    // get the previous layoutSection node
                    const index = $currentNodePos.index($currentNodePos.depth - 1);
                    const grandParent = $currentNodePos.node($currentNodePos.depth - 1);
                    const previousNode = grandParent ? grandParent.maybeChild(index - 1) : null;
                    moveToPos = $currentNodePos.start() - ((previousNode === null || previousNode === void 0 ? void 0 : previousNode.nodeSize) || 1);
                }
            } else if (direction === (0, $krxnk.DIRECTION).RIGHT) {
                if (isTopLevelNode && (0, $kaRof.editorExperiment)('advanced_layouts', true)) {
                    var _api$core4, _api$core5;
                    const endOfDoc = $currentNodePos.end();
                    moveToPos = $currentNodePos.posAtIndex($currentNodePos.index() + 1);
                    if (moveToPos >= endOfDoc) return false;
                    api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(({ tr: tr })=>{
                        var _api$blockControls3;
                        api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || (_api$blockControls3 = _api$blockControls3.commands) === null || _api$blockControls3 === void 0 || _api$blockControls3.moveToLayout(currentNodePos, moveToPos, {
                            moveNodeAtCursorPos: true
                        })({
                            tr: tr
                        });
                        const insertColumnStep = (0, $hpR0v.getInsertLayoutStep)(tr);
                        const mappedTo = insertColumnStep === null || insertColumnStep === void 0 ? void 0 : insertColumnStep.from;
                        (0, $hpR0v.updateSelection)(tr, mappedTo);
                        return tr;
                    });
                    api === null || api === void 0 || (_api$core5 = api.core) === null || _api$core5 === void 0 || _api$core5.actions.focus();
                    return true;
                } else if (isLayoutColumnSelected) {
                    var _api$core6, _api$blockControls4;
                    const index = $currentNodePos.index($currentNodePos.depth);
                    const parent = $currentNodePos.node($currentNodePos.depth);
                    // get the next layoutColumn node
                    const nextNode = parent ? parent.maybeChild(index + 1) : null;
                    // if the current node is the last node, don't do anything
                    if (index >= parent.childCount - 1) // prevent event propagation to avoid moving the cursor and still select the node
                    return true;
                    const moveToEnd = index === parent.childCount - 2;
                    moveToPos = moveToEnd ? $currentNodePos.before() : selection.to + ((nextNode === null || nextNode === void 0 ? void 0 : nextNode.nodeSize) || 1);
                    api === null || api === void 0 || (_api$core6 = api.core) === null || _api$core6 === void 0 || _api$core6.actions.execute(api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || (_api$blockControls4 = _api$blockControls4.commands) === null || _api$blockControls4 === void 0 ? void 0 : _api$blockControls4.moveToLayout(currentNodePos, moveToPos, {
                        moveToEnd: moveToEnd,
                        selectMovedNode: true
                    }));
                    return true;
                } else {
                    if ($currentNodePos.depth < 2 || !isParentNodeOfTypeLayout) return false;
                    moveToPos = $currentNodePos.after($currentNodePos.depth) + 1;
                }
            } else if (direction === (0, $krxnk.DIRECTION).UP) {
                if (isLayoutColumnSelected) moveToPos = $currentNodePos.start() - 1;
                else moveToPos = (0, $kVX7L.getPosWhenMoveNodeUp)($currentNodePos, currentNodePos);
            } else {
                const endOfDoc = $currentNodePos.end();
                if (nodeAfterPos > endOfDoc) return false;
                if (isLayoutColumnSelected) moveToPos = state.selection.$from.end() + 1;
                else moveToPos = (0, $kVX7L.getPosWhenMoveNodeDown)({
                    $currentNodePos: $currentNodePos,
                    nodeAfterPos: nodeAfterPos,
                    tr: state.tr
                });
            }
            const nodeType = (_state$doc$nodeAt = state.doc.nodeAt(currentNodePos)) === null || _state$doc$nodeAt === void 0 ? void 0 : _state$doc$nodeAt.type.name;
            let shouldMoveNode = false;
            if (moveToPos > -1) {
                const isDestDepthSameAsSource = $currentNodePos.depth === state.doc.resolve(moveToPos).depth;
                const isSourceLayoutColumn = nodeType === 'layoutColumn';
                shouldMoveNode = isDestDepthSameAsSource || isSourceLayoutColumn;
            }
            const { $anchor: $newAnchor, $head: $newHead } = (0, $eCKpe.expandSelectionBounds)($currentNodePos, selection.$to);
            if (shouldMoveNode) {
                var _api$core7;
                api === null || api === void 0 || (_api$core7 = api.core) === null || _api$core7 === void 0 || _api$core7.actions.execute(({ tr: tr })=>{
                    api === null || api === void 0 || api.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    $17c0b389a89272da$export$83751492c88cf2ca(api)(currentNodePos, moveToPos, (0, $3LeME.INPUT_METHOD).SHORTCUT, formatMessage)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            } else {
                var _api$core8;
                api === null || api === void 0 || (_api$core8 = api.core) === null || _api$core8 === void 0 || _api$core8.actions.execute(({ tr: tr })=>{
                    api === null || api === void 0 || api.blockControls.commands.setMultiSelectPositions($newAnchor.pos, $newHead.pos)({
                        tr: tr
                    });
                    tr.scrollIntoView();
                    return tr;
                });
                return true;
            }
        }
        return false;
    };
};
const $17c0b389a89272da$export$83751492c88cf2ca = (api)=>(start, to, inputMethod = (0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, formatMessage)=>({ tr: tr })=>{
            var _api$blockControls$sh, _convertedNodeSlice, _api$accessibilityUti;
            if (!api || start < 0 || to < 0) return tr;
            const handleNode = tr.doc.nodeAt(start);
            if (!handleNode) return tr;
            const wasCollapsedHeading = (0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings') && (0, $dStWQ.isCollapsedHeading)(api, start);
            let sliceFrom = start;
            let sliceTo;
            let sourceNodeTypes, hasSelectedMultipleNodes;
            if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                var _api$metrics;
                api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.setContentMoved()({
                    tr: tr
                });
            }
            const preservedSelection = api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.preservedSelection;
            if (preservedSelection) {
                const $from = tr.doc.resolve(Math.min(start, preservedSelection.from));
                const expandedRange = $from.blockRange(preservedSelection.$to);
                sliceFrom = expandedRange ? expandedRange.start : preservedSelection.from;
                sliceTo = expandedRange ? expandedRange.end : preservedSelection.to;
                const attributes = (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            } else {
                const slicePosition = (0, $g4us8.getSelectedSlicePosition)(start, tr, api);
                sliceFrom = slicePosition.from;
                sliceTo = slicePosition.to;
                const attributes = (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, sliceFrom, sliceTo);
                hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                sourceNodeTypes = attributes.nodeTypes;
            }
            const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
            const $to = tr.doc.resolve(to);
            const $handlePos = tr.doc.resolve(start);
            const nodeCopy = tr.doc.slice(sliceFrom, sliceTo, false); // cut the content
            const destNode = $to.node();
            const destType = destNode.type;
            const destParent = $to.node($to.depth);
            const sourceNode = $handlePos.nodeAfter;
            //TODO: ED-26959 - Does this need to be updated with new selection logic above? ^
            // Move a layout column to top level, or table cell, or panel, or expand, only moves the content into them
            if (sourceNode && $17c0b389a89272da$var$isDragLayoutColumnIntoSupportedNodes($handlePos, $to)) {
                // need update after we support single column layout.
                const layoutColumnContent = sourceNode.content;
                let fragment;
                // if drop into table, and layout column contains expand, transform it to nestedExpand
                if ([
                    'tableCell',
                    'tableHeader'
                ].includes($to.parent.type.name)) {
                    const contentContainsExpand = (0, $a4TQr.findChildrenByType)(sourceNode, expand).length > 0;
                    fragment = contentContainsExpand ? (0, $8MRTx.transformFragmentExpandToNestedExpand)((0, $7H6Cr.Fragment).from(layoutColumnContent)) : (0, $7H6Cr.Fragment).from(layoutColumnContent);
                    if (!fragment) return tr;
                } else fragment = (0, $7H6Cr.Fragment).from(layoutColumnContent);
                (0, $k6Ywe.removeFromSource)(tr, $handlePos, $handlePos.pos + sourceNode.nodeSize);
                const mappedTo = tr.mapping.map(to);
                tr.insert(mappedTo, fragment).setSelection((0, $801jp.Selection).near(tr.doc.resolve(mappedTo))).scrollIntoView();
                return tr;
            }
            if (!(0, $8MRTx.canMoveNodeToIndex)(destParent, $to.index(), $handlePos.node().child($handlePos.index()), $to)) return tr;
            let convertedNodeSlice = $17c0b389a89272da$var$transformSourceSlice(nodeCopy, destType);
            let convertedNode = (_convertedNodeSlice = convertedNodeSlice) === null || _convertedNodeSlice === void 0 ? void 0 : _convertedNodeSlice.content;
            if (!convertedNode) return tr;
            // Currently we don't support breakout mark for children nodes of bodiedSyncBlock node
            // Hence strip out the mark for now
            if (destNode.type.name === 'bodiedSyncBlock') {
                var _convertedNodeSlice2;
                const nodes = [];
                (_convertedNodeSlice2 = convertedNodeSlice) === null || _convertedNodeSlice2 === void 0 || _convertedNodeSlice2.content.forEach((node)=>{
                    nodes.push(node.mark(node.marks.filter((mark)=>mark.type.name !== 'breakout')));
                });
                convertedNodeSlice = new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(nodes), 0, 0);
                convertedNode = convertedNodeSlice.content;
            }
            // delete the content from the original position
            tr.delete(sliceFrom, sliceTo);
            const mappedTo = tr.mapping.map(to);
            const isDestNestedLoneEmptyParagraph = destParent.type.name !== 'doc' && destParent.childCount === 1 && (0, $39oqF.isEmptyParagraph)($to.nodeAfter);
            if (convertedNodeSlice && isDestNestedLoneEmptyParagraph) // if only a single empty paragraph within container, replace it
            tr.replace(mappedTo, mappedTo + 1, convertedNodeSlice);
            else // otherwise just insert the content at the new position
            tr.insert(mappedTo, convertedNode);
            const sliceSize = sliceTo - sliceFrom;
            if (inputMethod === (0, $3LeME.INPUT_METHOD).DRAG_AND_DROP) tr = (0, $7f0FC.setCursorPositionAtMovedNode)(tr, mappedTo, api);
            else if (preservedSelection) {
                const currMeta = tr.getMeta((0, $gyNLa.key));
                const nodeMovedOffset = mappedTo - sliceFrom;
                tr.setMeta((0, $gyNLa.key), {
                    ...currMeta,
                    preservedSelectionMapping: new (0, $k2WVn.Mapping)([
                        new (0, $k2WVn.StepMap)([
                            0,
                            0,
                            nodeMovedOffset
                        ])
                    ])
                });
            } else tr = (api === null || api === void 0 ? void 0 : api.blockControls.commands.setMultiSelectPositions(mappedTo, mappedTo + sliceSize)({
                tr: tr
            })) ?? tr;
            const currMeta = tr.getMeta((0, $gyNLa.key));
            tr.setMeta((0, $gyNLa.key), {
                ...currMeta,
                nodeMoved: true
            });
            if (// when move node via block menu, we need to keep the focus on block menu popup, so don't move focus to editor in this scenario
            inputMethod !== (0, $3LeME.INPUT_METHOD).BLOCK_MENU) api === null || api === void 0 || api.core.actions.focus();
            const $mappedTo = tr.doc.resolve(mappedTo);
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings')) (0, $dStWQ.updateCollapsedHeadingAfterMove)({
                api: api,
                destinationPos: mappedTo,
                isNested: $mappedTo.parent.type.name !== 'doc',
                tr: tr,
                wasCollapsed: wasCollapsedHeading
            });
            const expandAncestor = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($to, [
                expand,
                nestedExpand
            ]);
            if (expandAncestor) {
                const wasExpandExpanded = (0, $hIUTz.expandedState).get(expandAncestor.node);
                const updatedExpandAncestor = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($mappedTo, [
                    expand,
                    nestedExpand
                ]);
                if (wasExpandExpanded !== undefined && updatedExpandAncestor) (0, $hIUTz.expandedState).set(updatedExpandAncestor.node, wasExpandExpanded);
            }
            if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) (0, $3TAWV.attachMoveNodeAnalytics)(tr, inputMethod, $handlePos.depth, sourceNodeTypes, $mappedTo === null || $mappedTo === void 0 ? void 0 : $mappedTo.depth, $mappedTo === null || $mappedTo === void 0 ? void 0 : $mappedTo.parent.type.name, $handlePos.sameParent($mappedTo), api, hasSelectedMultipleNodes);
            else {
                var _api$analytics;
                api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    action: (0, $3LeME.ACTION).MOVED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                    attributes: {
                        nodeDepth: $handlePos.depth,
                        nodeTypes: sourceNodeTypes,
                        destinationNodeDepth: $mappedTo === null || $mappedTo === void 0 ? void 0 : $mappedTo.depth,
                        destinationNodeType: $mappedTo === null || $mappedTo === void 0 ? void 0 : $mappedTo.parent.type.name,
                        inputMethod: inputMethod,
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    }
                })(tr);
            }
            const movedMessage = to > sliceFrom ? (0, $7u4Lo.messages).movedDown : (0, $7u4Lo.messages).movedup;
            api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 || _api$accessibilityUti.actions.ariaNotify(formatMessage ? formatMessage(movedMessage) : movedMessage.defaultMessage, {
                priority: 'important'
            });
            return tr;
        };

});
parcelRegister("dStWQ", function(module, exports) {
$parcel$export(module.exports, "isCollapsedHeading", () => $6468c2dfc5d9bda4$export$2cc0ed669795e688);
$parcel$export(module.exports, "prepareCollapsedHeadingSelection", () => $6468c2dfc5d9bda4$export$4b8c7e87a2c4e54b);
$parcel$export(module.exports, "updateCollapsedHeadingAfterMove", () => $6468c2dfc5d9bda4$export$94408caa6f98c4e6);
const $6468c2dfc5d9bda4$export$4743a08233429483 = (api, headingPos)=>{
    var _api$blockCollapse;
    const sectionEnd = api === null || api === void 0 || (_api$blockCollapse = api.blockCollapse) === null || _api$blockCollapse === void 0 || (_api$blockCollapse = _api$blockCollapse.sharedState.currentState()) === null || _api$blockCollapse === void 0 ? void 0 : _api$blockCollapse.collapsedSectionEnds.get(headingPos);
    return sectionEnd === undefined ? undefined : {
        from: headingPos,
        to: sectionEnd
    };
};
const $6468c2dfc5d9bda4$export$2cc0ed669795e688 = (api, headingPos)=>{
    var _api$blockCollapse2;
    return (api === null || api === void 0 || (_api$blockCollapse2 = api.blockCollapse) === null || _api$blockCollapse2 === void 0 || (_api$blockCollapse2 = _api$blockCollapse2.sharedState.currentState()) === null || _api$blockCollapse2 === void 0 ? void 0 : _api$blockCollapse2.collapsedSectionEnds.has(headingPos)) ?? false;
};
const $6468c2dfc5d9bda4$export$4b8c7e87a2c4e54b = ({ api: api, expand: expand, headingPos: headingPos, tr: tr })=>{
    var _api$blockControls;
    const range = $6468c2dfc5d9bda4$export$4743a08233429483(api, headingPos);
    if (!range) return false;
    if (expand) {
        var _api$blockCollapse3;
        api === null || api === void 0 || (_api$blockCollapse3 = api.blockCollapse) === null || _api$blockCollapse3 === void 0 || _api$blockCollapse3.commands.expandHeading(headingPos)({
            tr: tr
        });
    }
    api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || _api$blockControls.commands.setMultiSelectPositions(range.from, range.to)({
        tr: tr
    });
    return true;
};
const $6468c2dfc5d9bda4$export$94408caa6f98c4e6 = ({ api: api, destinationPos: destinationPos, isNested: isNested, tr: tr, wasCollapsed: wasCollapsed })=>{
    var _api$blockCollapse5;
    if (!wasCollapsed) return;
    if (isNested) {
        var _api$blockCollapse4;
        api === null || api === void 0 || (_api$blockCollapse4 = api.blockCollapse) === null || _api$blockCollapse4 === void 0 || _api$blockCollapse4.commands.expandHeading(destinationPos)({
            tr: tr
        });
        return;
    }
    api === null || api === void 0 || (_api$blockCollapse5 = api.blockCollapse) === null || _api$blockCollapse5 === void 0 || _api$blockCollapse5.commands.collapseHeadingsAtPositions([
        destinationPos
    ])({
        tr: tr
    });
};

});

parcelRegister("7MVJk", function(module, exports) {
$parcel$export(module.exports, "getNestedNodePosition", () => $f80f4a97c64d3184$export$35954ff4e514ba11);
$parcel$export(module.exports, "getNestedNodeStartingPosition", () => $f80f4a97c64d3184$export$ac406f4d57a10c33);

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");
const $f80f4a97c64d3184$export$35954ff4e514ba11 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $801jp.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const parentNodeOfSpecificTypes = (0, $a4TQr.findParentNodeOfType)([
            schema.nodes.bulletList,
            schema.nodes.orderedList,
            schema.nodes.blockquote,
            schema.nodes.taskList,
            schema.nodes.decisionList
        ])(selection);
        if (parentNodeOfSpecificTypes) {
            const parentNodeType = parentNodeOfSpecificTypes.node.type.name;
            nestedNodePos = [
                'bulletList',
                'orderedList'
            ].includes(parentNodeType) ? $pos.before($pos.depth - 1) : [
                'blockquote',
                'taskList',
                'decisionList'
            ].includes(parentNodeType) ? $pos.before() : nestedNodePos;
        }
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $f80f4a97c64d3184$export$ac406f4d57a10c33 = ({ selection: selection, schema: schema, resolve: resolve })=>{
    let nestedNodePos = selection.$from.before(1);
    if (selection instanceof (0, $801jp.TextSelection)) {
        nestedNodePos = selection.$from.before();
        const $pos = resolve(nestedNodePos);
        if ($pos.depth < 1) return nestedNodePos;
        const { bulletList: bulletList, orderedList: orderedList, taskList: taskList, decisionList: decisionList, caption: caption } = schema.nodes;
        const isInList = (0, $a4TQr.findParentNodeOfType)([
            bulletList,
            orderedList,
            taskList
        ])(selection);
        const isInNodeWithoutDragHandle = (0, $a4TQr.findParentNodeOfType)([
            caption,
            decisionList
        ])(selection);
        if (isInList) // Only show drag handle at outermost list parent
        nestedNodePos = $f80f4a97c64d3184$var$getOutermostListPos($pos, resolve);
        else if (isInNodeWithoutDragHandle) // return the position of their parent if there should be no drag handle before the node
        nestedNodePos = $pos.before();
    } else nestedNodePos = selection.$from.pos;
    return nestedNodePos;
};
const $f80f4a97c64d3184$var$getOutermostListPos = ($pos, resolve)=>{
    if ($pos.depth === 0) return $pos.pos;
    const parentPos = $pos.before();
    const parentNode = $pos.parent;
    if (parentNode && [
        'bulletList',
        'listItem',
        'orderedList',
        'taskList',
        'taskItem'
    ].includes(parentNode.type.name)) return $f80f4a97c64d3184$var$getOutermostListPos(resolve(parentPos), resolve);
    return $pos.pos;
};

});

parcelRegister("k6Ywe", function(module, exports) {
$parcel$export(module.exports, "removeFromSource", () => $f294db8d02aa5577$export$29bd206d467fd44);

var $7H6Cr = parcelRequire("7H6Cr");

var $a4TQr = parcelRequire("a4TQr");

var $kaRof = parcelRequire("kaRof");

var $a4O7t = parcelRequire("a4O7t");

var $dG7TM = parcelRequire("dG7TM");

var $8lDZx = parcelRequire("8lDZx");
const $f294db8d02aa5577$export$29bd206d467fd44 = (tr, $from, to)=>{
    const sourceContent = tr.doc.slice($from.pos, to).content;
    const isLayoutColumn = (0, $a4O7t.isFragmentOfType)(sourceContent, 'layoutColumn');
    /**
   * This logic is used to handle the case when a user tries to delete a layout column
   * that contains only 2 child node, and single column layouts are not enabled.
   * In this case, we delete the layout column and replace it with its content.
   */ if (isLayoutColumn && !(0, $kaRof.editorExperiment)('single_column_layouts', true)) {
        const sourceParent = $from.parent;
        if (sourceParent.childCount === (0, $dG7TM.MIN_LAYOUT_COLUMN)) {
            // Only delete the layout content, but keep the layout column itself
            // This logic should be remove when we clean up the code for single column layouts.
            // since this step has no effect on the layout column, because the parent node is removed in the later step.
            tr.delete($from.pos + 1, to - 1);
            // This check should be remove when clean up the code for single column layouts.
            // since it has been checked in the previous step.
            if (sourceParent.childCount === 2) {
                var _$from$parent$lastChi, _$from$parent$firstCh;
                const layoutContentFragment = $from.parentOffset === 0 ? (0, $7H6Cr.Fragment).from((_$from$parent$lastChi = $from.parent.lastChild) === null || _$from$parent$lastChi === void 0 ? void 0 : _$from$parent$lastChi.content) : (0, $7H6Cr.Fragment).from((_$from$parent$firstCh = $from.parent.firstChild) === null || _$from$parent$firstCh === void 0 ? void 0 : _$from$parent$firstCh.content);
                const parent = (0, $a4TQr.findParentNodeClosestToPos)($from, (node)=>{
                    return node.type.name === 'layoutSection';
                });
                if (parent && layoutContentFragment) {
                    var _tr$doc$resolve$nodeA;
                    const layoutSectionPos = tr.mapping.map(parent.pos);
                    // get the updated layout node size
                    const layoutSectionNodeSize = ((_tr$doc$resolve$nodeA = tr.doc.resolve(layoutSectionPos).nodeAfter) === null || _tr$doc$resolve$nodeA === void 0 ? void 0 : _tr$doc$resolve$nodeA.nodeSize) || 0;
                    tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment);
                }
            }
            return tr;
        } else (0, $8lDZx.updateColumnWidths)(tr, $from.parent, $from.before($from.depth), sourceParent.childCount - 1);
    }
    tr.delete($from.pos, to);
    return tr;
};

});
parcelRegister("a4O7t", function(module, exports) {
$parcel$export(module.exports, "isFragmentOfType", () => $a0c353619f0dc634$export$2b4dd9f6b8f819da);
$parcel$export(module.exports, "containsNodeOfType", () => $a0c353619f0dc634$export$8cb5c38ddf4d519f);
const $a0c353619f0dc634$export$2b4dd9f6b8f819da = (fragment, type)=>{
    var _fragment$firstChild;
    return fragment.childCount === 1 && ((_fragment$firstChild = fragment.firstChild) === null || _fragment$firstChild === void 0 ? void 0 : _fragment$firstChild.type.name) === type;
};
const $a0c353619f0dc634$export$8cb5c38ddf4d519f = (fragment, type)=>{
    for(let i = 0; i < fragment.childCount; i++){
        const child = fragment.child(i);
        if (child.type.name === type) return true;
    }
    return false;
};

});

parcelRegister("8lDZx", function(module, exports) {
$parcel$export(module.exports, "updateColumnWidths", () => $82df6a63a021c878$export$6688b13ec132acdf);

var $GIvev = parcelRequire("GIvev");
const $82df6a63a021c878$export$6688b13ec132acdf = (tr, layoutNode, layoutNodePos, childCount)=>{
    const newColumnWidth = (0, $GIvev.DEFAULT_COLUMN_DISTRIBUTIONS)[childCount];
    if (newColumnWidth) layoutNode.content.forEach((node, offset)=>{
        if (node.type.name === 'layoutColumn') tr.setNodeAttribute(layoutNodePos + offset + 1, 'width', newColumnWidth);
    });
    return {
        newColumnWidth: newColumnWidth,
        tr: tr
    };
};

});


parcelRegister("kVX7L", function(module, exports) {
$parcel$export(module.exports, "getNodeBoundsFromSelection", () => $44f0ef4f2445ae80$export$c57c553e4ac98a48);
$parcel$export(module.exports, "getPosWhenMoveNodeUp", () => $44f0ef4f2445ae80$export$6e259a78a1c38d78);
$parcel$export(module.exports, "getPosWhenMoveNodeDown", () => $44f0ef4f2445ae80$export$3545fa32cdadf3ca);
$parcel$export(module.exports, "canMoveNodeUpOrDown", () => $44f0ef4f2445ae80$export$cc4db90b9d5a445a);

var $801jp = parcelRequire("801jp");

var $5n2u9 = parcelRequire("5n2u9");
var $kD3Xq = parcelRequire("kD3Xq");

var $g4us8 = parcelRequire("g4us8");
const $44f0ef4f2445ae80$export$c57c553e4ac98a48 = (selection)=>{
    // Special case: if a table is selected, we want to move the entire table node
    const tableInfo = (0, $5n2u9.findTable)(selection);
    if (tableInfo && (0, $kD3Xq.isTableSelected)(selection)) {
        const tablePos = tableInfo.pos;
        const tableTo = tablePos + tableInfo.node.nodeSize;
        return {
            from: tablePos,
            to: tableTo
        };
    }
    // Special case: if a media node (file) is selected, we need to get the parent mediaGroup
    // This handles the case where clicking on a file creates a NodeSelection of the media node
    // but we want to move the entire mediaGroup that wraps it
    if (selection instanceof (0, $801jp.NodeSelection) && selection.node.type.name === 'media' && selection.node.attrs.type === 'file') {
        // The media node is wrapped in a mediaGroup, so we need to get the parent position
        const mediaGroupPos = selection.$from.pos - 1;
        const mediaGroupNode = selection.$from.doc.nodeAt(mediaGroupPos);
        if (mediaGroupNode && mediaGroupNode.type.name === 'mediaGroup') return {
            from: mediaGroupPos,
            to: mediaGroupPos + mediaGroupNode.nodeSize
        };
    }
    // Use createPreservedSelection to get properly expanded block boundaries
    const preservedSelection = (0, $g4us8.createPreservedSelection)(selection.$from, selection.$to);
    if (!preservedSelection) return undefined;
    return {
        from: preservedSelection.from,
        to: preservedSelection.to
    };
};
const $44f0ef4f2445ae80$export$6e259a78a1c38d78 = ($currentNodePos, currentNodePos)=>{
    const nodeIndex = $currentNodePos.index();
    const nodeBefore = $currentNodePos.depth > 1 && nodeIndex === 0 ? $currentNodePos.node($currentNodePos.depth) : $currentNodePos.nodeBefore;
    if ((nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type.name) === 'layoutColumn') return -1;
    return nodeBefore ? currentNodePos - nodeBefore.nodeSize : -1;
};
const $44f0ef4f2445ae80$export$3545fa32cdadf3ca = ({ $currentNodePos: $currentNodePos, nodeAfterPos: nodeAfterPos, tr: tr })=>{
    const endOfDoc = $currentNodePos.end();
    if (nodeAfterPos > endOfDoc) return -1;
    const nodeAfter = tr.doc.nodeAt(nodeAfterPos);
    const nodeAtCurrentPos = tr.doc.nodeAt($currentNodePos.pos);
    // if move empty line down to another empty line, move to the position of the next empty line
    if ((nodeAtCurrentPos === null || nodeAtCurrentPos === void 0 ? void 0 : nodeAtCurrentPos.content.size) === 0 && nodeAtCurrentPos.type.name !== 'extension' && (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.content.size) === 0 && nodeAfter.type.name !== 'extension') return nodeAfterPos;
    // if not the last node, move to the end of the next node
    return nodeAfter ? nodeAfterPos + nodeAfter.nodeSize : -1;
};
const $44f0ef4f2445ae80$export$c6093962982030d2 = ({ currentNodePos: currentNodePos, moveToPos: moveToPos, tr: tr })=>{
    // only move the node if the destination is at the same depth, not support moving a nested node to a parent node
    return moveToPos > -1 && tr.doc.resolve(currentNodePos).depth === tr.doc.resolve(moveToPos).depth;
};
const $44f0ef4f2445ae80$export$cc4db90b9d5a445a = (tr)=>{
    const nodeBounds = $44f0ef4f2445ae80$export$c57c553e4ac98a48(tr.selection);
    if (!nodeBounds || nodeBounds.from <= -1) return {
        moveUp: false,
        moveDown: false
    };
    const currentNodePos = nodeBounds.from;
    const $currentNodePos = tr.doc.resolve(currentNodePos);
    const nodeAfterPos = nodeBounds.to;
    const moveUpPos = $44f0ef4f2445ae80$export$6e259a78a1c38d78($currentNodePos, currentNodePos);
    const moveDownPos = $44f0ef4f2445ae80$export$3545fa32cdadf3ca({
        $currentNodePos: $currentNodePos,
        nodeAfterPos: nodeAfterPos,
        tr: tr
    });
    return {
        moveUp: $44f0ef4f2445ae80$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveUpPos,
            tr: tr
        }),
        moveDown: $44f0ef4f2445ae80$export$c6093962982030d2({
            currentNodePos: currentNodePos,
            moveToPos: moveDownPos,
            tr: tr
        })
    };
};

});


parcelRegister("9bUoK", function(module, exports) {
$parcel$export(module.exports, "showDragHandleAtSelection", () => $d73a03a050dd44e6$export$c78ece06e89c3c69);

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $2xAfa = parcelRequire("2xAfa");

var $61p1X = parcelRequire("61p1X");

var $gyNLa = parcelRequire("gyNLa");

var $7MVJk = parcelRequire("7MVJk");

var $dj84o = parcelRequire("dj84o");
const $d73a03a050dd44e6$var$findParentPosForHandle = (state)=>{
    var _activeNode$handleOpt;
    const { selection: { $from: $from } } = state;
    const { activeNode: activeNode } = (0, $gyNLa.key).getState(state) || {};
    // if a node handle is already focused, return the parent pos of that node (with focused handle)
    if (activeNode && (_activeNode$handleOpt = activeNode.handleOptions) !== null && _activeNode$handleOpt !== void 0 && _activeNode$handleOpt.isFocused) {
        const $activeNodePos = state.doc.resolve(activeNode.pos);
        // if the handle is at the top level already, do nothing
        if ($activeNodePos.depth === 0) return undefined;
        return $activeNodePos.before();
    }
    // if we are in second level of nested node, we should focus the node at level 1
    if ($from.depth <= 1) return $from.before(1);
    // if we are inside a table, we should focus the table's handle
    const parentTableNode = (0, $a4TQr.findParentNodeOfType)([
        state.schema.nodes.table
    ])(state.selection);
    if (parentTableNode) return parentTableNode.pos;
    // else find closest parent node
    return (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? // With native anchor enabled, all nodes have anchor name attribute despite no drag handle support, e.g. listItem, caption,
    // as opposed to old approach, node decoration is only added to the node that have drag handle,
    // hence, we need to return the exact position of the node that can have drag handle
    (0, $7MVJk.getNestedNodeStartingPosition)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    }) : (0, $7MVJk.getNestedNodePosition)({
        selection: state.selection,
        schema: state.schema,
        resolve: state.doc.resolve.bind(state.doc)
    });
};
const $d73a03a050dd44e6$var$findNextAnchorDecoration = (state)=>{
    const decorations = (0, $gyNLa.getDecorations)(state);
    if (!decorations) return undefined;
    const nextHandleNodePos = $d73a03a050dd44e6$var$findParentPosForHandle(state);
    if (nextHandleNodePos === undefined) return undefined;
    const nextHandleNode = state.doc.nodeAt(nextHandleNodePos);
    let nodeDecorations = nextHandleNode && (0, $2xAfa.findNodeDecs)(state, decorations, nextHandleNodePos, nextHandleNodePos + nextHandleNode.nodeSize);
    if (!nodeDecorations || nodeDecorations.length === 0) return undefined;
    // ensure the decoration covers the position of the look up node
    nodeDecorations = nodeDecorations.filter((decoration)=>{
        return decoration.from <= nextHandleNodePos;
    });
    if (nodeDecorations.length === 0) return undefined;
    // sort the decorations by the position of the node
    // so we can find the closest decoration to the node
    nodeDecorations.sort((a, b)=>{
        if (a.from === b.from) return a.to - b.to;
        return b.from - a.from;
    });
    // return the closest decoration to the node
    return nodeDecorations[0];
};
const $d73a03a050dd44e6$var$findNextAnchorNode = (view)=>{
    const nextHandleNodePos = $d73a03a050dd44e6$var$findParentPosForHandle(view.state);
    if (nextHandleNodePos === undefined) return undefined;
    const dom = view.nodeDOM(nextHandleNodePos);
    if (!(dom instanceof HTMLElement)) return undefined;
    const nodeDOM = dom.closest(`[${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}]`);
    if (!nodeDOM) return undefined;
    const nodeType = nodeDOM === null || nodeDOM === void 0 ? void 0 : nodeDOM.getAttribute((0, $dj84o.NODE_NODE_TYPE_ATTR_NAME));
    const anchorName = nodeDOM === null || nodeDOM === void 0 ? void 0 : nodeDOM.getAttribute((0, $dj84o.NODE_ANCHOR_ATTR_NAME));
    if (nodeType && anchorName) return {
        pos: nextHandleNodePos,
        nodeType: nodeType,
        anchorName: anchorName
    };
};
const $d73a03a050dd44e6$export$c78ece06e89c3c69 = (api)=>(state, _, view)=>{
        if (api && (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const pos = $d73a03a050dd44e6$var$findParentPosForHandle(state);
            const node = pos === undefined ? undefined : state.doc.nodeAt(pos);
            const anchorName = node && pos !== undefined ? api.core.actions.getAnchorIdForNode(node, pos) : undefined;
            if (!node || pos === undefined || !anchorName) return false;
            return api.core.actions.execute(api.blockControls.commands.showDragHandleAt(pos, anchorName, (0, $61p1X.getNodeTypeWithLevel)(node), {
                isFocused: true
            }));
        }
        if (view && (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
            const anchorNode = $d73a03a050dd44e6$var$findNextAnchorNode(view);
            if (api && anchorNode) {
                const { pos: pos, anchorName: anchorName, nodeType: nodeType } = anchorNode;
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(pos, anchorName, nodeType, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        } else {
            const decoration = $d73a03a050dd44e6$var$findNextAnchorDecoration(state);
            if (api && decoration) {
                api.core.actions.execute(api.blockControls.commands.showDragHandleAt(decoration.from, decoration.spec.anchorName, decoration.spec.nodeTypeWithLevel, {
                    isFocused: true
                }));
                return true;
            }
            return false;
        }
    };

});


parcelRegister("fAWS2", function(module, exports) {
$parcel$export(module.exports, "getTrMetadata", () => $19bae689af3f6429$export$5a67a4a1d2fbf068);

var $k2WVn = parcelRequire("k2WVn");

var $bcN2K = parcelRequire("bcN2K");
const $19bae689af3f6429$export$3e44da64b47beb51 = (s)=>{
    const content = s.slice.content.firstChild;
    return s.from === s.to && s.slice.content.childCount === 1 && !!content && !!content.text;
};
const $19bae689af3f6429$export$84cb963246195c8 = (s)=>{
    const content = s.slice.content;
    return s.to === s.from + 1 && content.size === 0;
};
/**
 * Check if content being replaced is replaced with another of the same size
 * This can occur on empty docs and 'backspace' is pressed, the paragraph node is re-drawn
 * @param s
 * @returns True if content being replaced is replaced with another of the same size
 */ const $19bae689af3f6429$var$isStepContentReplacedWithAnotherOfSameSize = (s)=>{
    if (s instanceof (0, $k2WVn.ReplaceAroundStep)) {
        const replacedContentSize = s.to - s.from;
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
            const insertedContentSize = s.slice.size + (s.gapTo - s.gapFrom);
            return insertedContentSize === replacedContentSize;
        }
        return s.slice.content.size === replacedContentSize;
    }
    return false;
};
const $19bae689af3f6429$export$5a67a4a1d2fbf068 = (tr, flags)=>{
    let from;
    let to;
    let numReplaceSteps = 0;
    let isAllText = true;
    let isReplacedWithSameSize = false;
    tr.steps.forEach((s)=>{
        if (s instanceof (0, $k2WVn.ReplaceStep) || s instanceof (0, $k2WVn.ReplaceAroundStep)) {
            if (s instanceof (0, $k2WVn.ReplaceAroundStep) || s instanceof (0, $k2WVn.ReplaceStep) && !$19bae689af3f6429$export$3e44da64b47beb51(s) && !$19bae689af3f6429$export$84cb963246195c8(s)) isAllText = false;
            // Fixes drag handle and quick insert button overlap issues
            if (flags.toolbarFlagsEnabled) // platform_editor_controls note: fixes drag handle and quick insert button overlap issues
            isReplacedWithSameSize = $19bae689af3f6429$var$isStepContentReplacedWithAnotherOfSameSize(s);
            const mappedTo = tr.mapping.map(s.to);
            let $to = s.from + s.slice.size;
            $to = $to > mappedTo ? $to : mappedTo;
            from = from === undefined || from > s.from ? s.from : from;
            to = to === undefined || to < $to ? $to : to;
            numReplaceSteps++;
        }
    });
    if (from === undefined) from = 0;
    if (to === undefined || to > tr.doc.nodeSize - 2) to = tr.doc.nodeSize - 2;
    return {
        from: from,
        to: to,
        numReplaceSteps: numReplaceSteps,
        isAllText: isAllText,
        isReplacedWithSameSize: isReplacedWithSameSize
    };
};

});



parcelRegister("l4e2l", function(module, exports) {
$parcel$export(module.exports, "moveNodeWithBlockMenu", () => $21acebad4774648e$export$86c511a177340b22);

var $3LeME = parcelRequire("3LeME");

var $krxnk = parcelRequire("krxnk");

var $gyNLa = parcelRequire("gyNLa");

var $g4us8 = parcelRequire("g4us8");

var $28S2Q = parcelRequire("28S2Q");

var $kVX7L = parcelRequire("kVX7L");
const $21acebad4774648e$var$getSelectionToIndex = (fromIndex, $to, depth)=>{
    const toIndex = $to.index(depth);
    const toIndexAfter = $to.indexAfter(depth);
    // If $to is at the start of a node (indexAfter === index), don't include that node
    // This occurs when the preserved selection is outside of inline positions at node boundaries
    if (toIndexAfter === toIndex && toIndex > fromIndex) return toIndex - 1;
    return toIndex;
};
const $21acebad4774648e$export$86c511a177340b22 = (api, direction)=>{
    return ({ tr: tr })=>{
        var _api$blockControls$sh;
        const preservedSelection = api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.preservedSelection;
        const selection = preservedSelection ?? tr.selection;
        // Use getNodeBoundsFromSelection to get the proper block boundaries
        const nodeBounds = (0, $kVX7L.getNodeBoundsFromSelection)(selection);
        if (!nodeBounds) return tr;
        const currentNodePos = nodeBounds.from;
        const { $from: $from, $to: $to } = selection;
        const depth = tr.doc.resolve(currentNodePos).depth;
        const fromIndex = $from.index(depth);
        let trAfterNodeMove = tr;
        if (direction === (0, $krxnk.DIRECTION).UP) {
            if (fromIndex > 0) {
                const moveToPos = $from.posAtIndex(fromIndex - 1, depth);
                trAfterNodeMove = (0, $28S2Q.moveNode)(api)(currentNodePos, moveToPos, (0, $3LeME.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        } else {
            // selectionToIndex is the index of the last node in the selection
            const selectionToIndex = $21acebad4774648e$var$getSelectionToIndex(fromIndex, $to, depth);
            // Adding 2 so we jump over the next node to the position after it
            const moveToIndex = selectionToIndex + 2;
            if (moveToIndex <= $to.node(depth).childCount) {
                const moveToPos = $to.posAtIndex(moveToIndex, depth);
                trAfterNodeMove = (0, $28S2Q.moveNode)(api)(currentNodePos, moveToPos, (0, $3LeME.INPUT_METHOD).BLOCK_MENU)({
                    tr: tr
                }) || tr;
            }
        }
        // map selection
        const mappedSelection = (0, $g4us8.mapPreservedSelection)(selection, trAfterNodeMove);
        if (mappedSelection) trAfterNodeMove.setSelection(mappedSelection);
        //recalculate canMoveUp and canMoveDown
        const { moveUp: moveUp, moveDown: moveDown } = (0, $kVX7L.canMoveNodeUpOrDown)(trAfterNodeMove);
        const currentMeta = trAfterNodeMove.getMeta((0, $gyNLa.key));
        const newMeta = {
            ...currentMeta,
            toggleMenu: {
                moveUp: moveUp,
                moveDown: moveDown
            }
        };
        return trAfterNodeMove.setMeta((0, $gyNLa.key), newMeta);
    };
};

});

parcelRegister("1Qyd4", function(module, exports) {
$parcel$export(module.exports, "moveToLayout", () => $4cae1c5e27b499d5$export$6e686efeb3f3578c);

var $3LeME = parcelRequire("3LeME");

var $kFIjS = parcelRequire("kFIjS");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $3TAWV = parcelRequire("3TAWV");

var $a4O7t = parcelRequire("a4O7t");

var $dStWQ = parcelRequire("dStWQ");

var $dG7TM = parcelRequire("dG7TM");

var $k6Ywe = parcelRequire("k6Ywe");

var $g4us8 = parcelRequire("g4us8");

var $8MRTx = parcelRequire("8MRTx");

var $GIvev = parcelRequire("GIvev");
const $4cae1c5e27b499d5$var$createNewLayout = (schema, layoutContents)=>{
    if (layoutContents.length === 0 || layoutContents.length > (0, $dG7TM.maxLayoutColumnSupported)()) return null;
    const width = (0, $GIvev.DEFAULT_COLUMN_DISTRIBUTIONS)[layoutContents.length];
    if (!width) return null;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = schema.nodes || {};
    try {
        const layoutContent = (0, $7H6Cr.Fragment).fromArray(layoutContents.map((layoutContent)=>{
            return layoutColumn.createChecked({
                width: width
            }, layoutContent);
        }));
        const layoutSectionNode = layoutSection.createChecked(undefined, layoutContent);
        return layoutSectionNode;
    } catch (error) {
        (0, $kFIjS.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    return null;
};
const $4cae1c5e27b499d5$var$moveToExistingLayout = (toLayout, toLayoutPos, sourceContent, from, to, tr, $originalFrom, $originalTo, api, selectMovedNode)=>{
    const isSameLayout = (0, $8MRTx.isInSameLayout)($originalFrom, $originalTo);
    const sourceContentEndPos = from + sourceContent.size;
    const attributes = (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, from, sourceContentEndPos);
    const { nodeTypes: sourceNodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
    if (isSameLayout) {
        // reorder columns
        tr.delete(from, sourceContentEndPos);
        const mappedTo = tr.mapping.map(to);
        tr.insert(mappedTo, sourceContent);
        if (selectMovedNode) tr.setSelection(new (0, $801jp.NodeSelection)(tr.doc.resolve(mappedTo))).scrollIntoView();
        (0, $3TAWV.attachMoveNodeAnalytics)(tr, (0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, sourceNodeTypes, 1, 'layoutSection', true, api, hasSelectedMultipleNodes);
    } else if (toLayout.childCount < (0, $dG7TM.maxLayoutColumnSupported)()) {
        (0, $k6Ywe.removeFromSource)(tr, tr.doc.resolve(from), sourceContentEndPos);
        $4cae1c5e27b499d5$var$insertToDestinationNoWidthUpdate(tr, tr.mapping.map(to), sourceContent);
        (0, $3TAWV.attachMoveNodeAnalytics)(tr, (0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, $originalFrom.depth, sourceNodeTypes, 1, 'layoutSection', false, api, hasSelectedMultipleNodes);
    }
    return tr;
};
/**
 * This function is similar to insertToDestination
 * But without update width step, mainly rely on the append transaction from layout.
 * @param tr
 * @param to
 * @param sourceNode
 * @returns
 */ const $4cae1c5e27b499d5$var$insertToDestinationNoWidthUpdate = (tr, to, sourceContent)=>{
    const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
    let content = null;
    try {
        var _sourceFragment$first;
        const sourceFragment = sourceContent;
        content = layoutColumn.createChecked({
            width: 0
        }, (0, $a4O7t.isFragmentOfType)(sourceFragment, 'layoutColumn') ? (_sourceFragment$first = sourceFragment.firstChild) === null || _sourceFragment$first === void 0 ? void 0 : _sourceFragment$first.content : sourceFragment);
    } catch (error) {
        (0, $kFIjS.logException)(error, {
            location: 'editor-plugin-block-controls/move-to-layout'
        });
    }
    if (content) tr.insert(to, content);
    return tr;
};
/**
 * Check if the node at `from` can be moved to node at `to` to create/expand a layout.
 * Returns the source and destination nodes and positions if it's a valid move, otherwise, undefined
 */ const $4cae1c5e27b499d5$var$canMoveToLayout = (api, from, to, tr, moveNodeAtCursorPos)=>{
    if (from === to) return;
    const { layoutSection: layoutSection, layoutColumn: layoutColumn, doc: doc, bodiedSyncBlock: bodiedSyncBlock } = tr.doc.type.schema.nodes || {};
    // layout plugin does not exist
    if (!layoutSection || !layoutColumn) return;
    const $to = tr.doc.resolve(to);
    const allowedParentTypes = [
        doc,
        layoutSection
    ];
    if (bodiedSyncBlock) allowedParentTypes.push(bodiedSyncBlock);
    // drop at invalid position, not top level, or not a layout column
    if (!$to.nodeAfter || !allowedParentTypes.includes($to.parent.type)) return;
    const $from = tr.doc.resolve(from);
    // invalid from position or dragging a layout
    if (!$from.nodeAfter || $from.nodeAfter.type === layoutSection) return;
    let sourceContent = $from.nodeAfter;
    let sourceFrom = from;
    let sourceTo = from + sourceContent.nodeSize;
    if (!moveNodeAtCursorPos) {
        const { anchor: anchor, head: head } = (0, $g4us8.getMultiSelectionIfPosInside)(api, from);
        if (anchor !== undefined && head !== undefined) {
            sourceFrom = Math.min(anchor, head);
            sourceTo = Math.max(anchor, head);
            sourceContent = tr.doc.slice(sourceFrom, sourceTo).content;
            // TODO: ED-26959 - this might become expensive for large content, consider removing it if check has been done beforehand
            if ((0, $a4O7t.containsNodeOfType)(sourceContent, 'layoutSection')) return;
        } else sourceContent = (0, $7H6Cr.Fragment).from($from.nodeAfter);
    }
    const toNode = $to.nodeAfter;
    return {
        toNode: toNode,
        $to: $to,
        sourceContent: sourceContent,
        $sourceFrom: tr.doc.resolve(sourceFrom),
        sourceTo: sourceTo
    };
};
const $4cae1c5e27b499d5$var$removeBreakoutMarks = (tr, $from, to)=>{
    let fromContentWithoutBreakout = null;
    const { breakout: breakout } = tr.doc.type.schema.marks || {};
    tr.doc.nodesBetween($from.pos, to, (node, pos, parent)=>{
        // should never remove breakout from previous layoutSection
        if (node.type.name === 'layoutSection') return false;
        // breakout doesn't exist on nested nodes
        if ((parent === null || parent === void 0 ? void 0 : parent.type.name) === 'doc' && node.marks.some((m)=>m.type === breakout)) tr.removeNodeMark(pos, breakout);
        // descending is not needed as  breakout doesn't exist on nested nodes
        return false;
    });
    // resolve again the source content after node updated (remove breakout marks)
    fromContentWithoutBreakout = tr.doc.slice($from.pos, to).content;
    return fromContentWithoutBreakout;
};
const $4cae1c5e27b499d5$var$getBreakoutModeAndWidth = (content, breakout)=>{
    const findBreakoutMark = (node)=>node.marks.find((m)=>m.type === breakout);
    const extractBreakoutAttributes = (mark)=>mark ? {
            breakoutMode: mark.attrs.mode,
            breakoutWidth: mark.attrs.width
        } : null;
    if (content instanceof (0, $7H6Cr.Node)) return extractBreakoutAttributes(findBreakoutMark(content));
    else if (content instanceof (0, $7H6Cr.Fragment)) // Find the first breakout mode in the fragment
    for(let i = 0; i < content.childCount; i++){
        const child = content.child(i);
        const breakoutMark = findBreakoutMark(child);
        if (breakoutMark) return extractBreakoutAttributes(breakoutMark);
    }
    return null;
};
const $4cae1c5e27b499d5$export$6e686efeb3f3578c = (api)=>(from, to, options)=>({ tr: tr })=>{
            if (!api) return tr;
            const canMove = $4cae1c5e27b499d5$var$canMoveToLayout(api, from, to, tr, options === null || options === void 0 ? void 0 : options.moveNodeAtCursorPos);
            if (!canMove) return tr;
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings') && (0, $dStWQ.isCollapsedHeading)(api, from)) {
                var _api$blockCollapse;
                (_api$blockCollapse = api.blockCollapse) === null || _api$blockCollapse === void 0 || _api$blockCollapse.commands.expandHeading(from)({
                    tr: tr
                });
            }
            const { toNode: toNode, $to: $to, sourceContent: sourceContent, $sourceFrom: $sourceFrom, sourceTo: sourceTo } = canMove;
            const { layoutSection: layoutSection, layoutColumn: layoutColumn } = tr.doc.type.schema.nodes || {};
            const { breakout: breakout } = tr.doc.type.schema.marks || {};
            // get breakout mode from destination node,
            // if not found, get from source node,
            const { breakoutMode: breakoutMode, breakoutWidth: breakoutWidth } = $4cae1c5e27b499d5$var$getBreakoutModeAndWidth(toNode, breakout) || $4cae1c5e27b499d5$var$getBreakoutModeAndWidth(sourceContent, breakout) || {};
            // we don't want to remove marks when moving/re-ordering layoutSection
            const shouldRemoveMarks = $sourceFrom.node().type !== layoutSection;
            const fromContentBeforeBreakoutMarksRemoved = tr.doc.slice($sourceFrom.pos, sourceTo).content;
            // remove breakout from source content
            let fromContentWithoutBreakout = shouldRemoveMarks ? $4cae1c5e27b499d5$var$removeBreakoutMarks(tr, $sourceFrom, sourceTo) : fromContentBeforeBreakoutMarksRemoved;
            if (!fromContentWithoutBreakout) return tr;
            if ((0, $dRkX9.fg)('platform_editor_ease_of_use_metrics')) {
                var _api$metrics;
                api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.setContentMoved()({
                    tr: tr
                });
            }
            if (toNode.type === layoutSection) {
                const toPos = options !== null && options !== void 0 && options.moveToEnd ? to + toNode.nodeSize - 1 : to + 1;
                return $4cae1c5e27b499d5$var$moveToExistingLayout(toNode, to, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options === null || options === void 0 ? void 0 : options.selectMovedNode);
            } else if (toNode.type === layoutColumn) {
                const toLayout = $to.parent;
                const toLayoutPos = to - $to.parentOffset - 1;
                const toPos = options !== null && options !== void 0 && options.moveToEnd ? to + toNode.nodeSize : to;
                return $4cae1c5e27b499d5$var$moveToExistingLayout(toLayout, toLayoutPos, fromContentWithoutBreakout, $sourceFrom.pos, toPos, tr, $sourceFrom, $to, api, options === null || options === void 0 ? void 0 : options.selectMovedNode);
            } else {
                let toNodeWithoutBreakout = toNode;
                // remove breakout from node;
                if (breakout && $to.nodeAfter && $to.nodeAfter.marks.some((m)=>m.type === breakout)) {
                    tr.removeNodeMark(to, breakout);
                    // resolve again the source node after node updated (remove breakout marks)
                    toNodeWithoutBreakout = tr.doc.resolve(to).nodeAfter || toNode;
                }
                if ((0, $a4O7t.isFragmentOfType)(fromContentWithoutBreakout, 'layoutColumn') && fromContentWithoutBreakout.firstChild) fromContentWithoutBreakout = fromContentWithoutBreakout.firstChild.content;
                const layoutContents = options !== null && options !== void 0 && options.moveToEnd ? [
                    toNodeWithoutBreakout,
                    fromContentWithoutBreakout
                ] : [
                    fromContentWithoutBreakout,
                    toNodeWithoutBreakout
                ];
                const newLayout = $4cae1c5e27b499d5$var$createNewLayout(tr.doc.type.schema, layoutContents);
                if (newLayout) {
                    const attributes = (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, $sourceFrom.pos, sourceTo);
                    const { nodeTypes: sourceNodeTypes, hasSelectedMultipleNodes: hasSelectedMultipleNodes } = attributes;
                    tr = (0, $k6Ywe.removeFromSource)(tr, $sourceFrom, sourceTo);
                    const mappedTo = tr.mapping.map(to);
                    tr.delete(mappedTo, mappedTo + toNodeWithoutBreakout.nodeSize).insert(mappedTo, newLayout);
                    breakoutMode && tr.setNodeMarkup(mappedTo, newLayout.type, newLayout.attrs, [
                        breakout.create({
                            mode: breakoutMode,
                            width: breakoutWidth
                        })
                    ]);
                    // layout created via drag and drop will always be 2 columns
                    (0, $3TAWV.fireInsertLayoutAnalytics)(tr, api, sourceNodeTypes, hasSelectedMultipleNodes, 2);
                }
                return tr;
            }
        };

});

parcelRegister("9aPvW", function(module, exports) {
$parcel$export(module.exports, "firstNodeDecPlugin", () => $4c8132031f6850ea$export$4a529dfc67d1b47b);

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $16ZMX = parcelRequire("16ZMX");
const $4c8132031f6850ea$export$fd198b85b7fd4b80 = new (0, $801jp.PluginKey)('firstNodeDec');
const $4c8132031f6850ea$var$createFirstNodeDecSet = (state)=>{
    const firstNode = state.doc.firstChild;
    if (!firstNode) return (0, $16ZMX.DecorationSet).empty;
    const firstNodeDecoration = (0, $16ZMX.Decoration).node(0, firstNode.nodeSize, {
        style: 'margin-top: 0;',
        class: 'first-node-in-document'
    });
    return (0, $16ZMX.DecorationSet).create(state.doc, [
        firstNodeDecoration
    ]);
};
const $4c8132031f6850ea$export$4a529dfc67d1b47b = ()=>new (0, $1y7gE.SafePlugin)({
        key: $4c8132031f6850ea$export$fd198b85b7fd4b80,
        state: {
            init (_, state) {
                return $4c8132031f6850ea$var$createFirstNodeDecSet(state);
            },
            apply (tr, currentState, _, newState) {
                const isDocChanged = tr.docChanged && tr.steps.some((step)=>step instanceof (0, $k2WVn.ReplaceStep) || step instanceof (0, $k2WVn.ReplaceAroundStep));
                // Reapply decorations if there are any steps that modify the document
                if (isDocChanged) return $4c8132031f6850ea$var$createFirstNodeDecSet(newState);
                return currentState;
            }
        },
        props: {
            decorations (state) {
                return $4c8132031f6850ea$export$fd198b85b7fd4b80.getState(state);
            }
        }
    });

});

parcelRegister("2MmgC", function(module, exports) {
$parcel$export(module.exports, "interactionTrackingPluginKey", () => $54506520e25819a2$export$d14f503a2a677768);
$parcel$export(module.exports, "createInteractionTrackingPlugin", () => $54506520e25819a2$export$66f3b9297f4ee65b);
$parcel$export(module.exports, "getInteractionTrackingState", () => $54506520e25819a2$export$27d80eabdcbf88a5);

var $6Zi52 = parcelRequire("6Zi52");

var $ldLrq = parcelRequire("ldLrq");

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $bKWnN = parcelRequire("bKWnN");

var $kaRof = parcelRequire("kaRof");

var $cuDOm = parcelRequire("cuDOm");

var $eSeDI = parcelRequire("eSeDI");

var $9TG4a = parcelRequire("9TG4a");
/** Elements that extend the editor hover area (block controls, right-edge button, etc.) */ const $54506520e25819a2$var$LEGACY_BLOCK_CONTROLS_HOVER_AREA_SELECTOR = '[data-blocks-right-edge-button-container], [data-blocks-drag-handle-container], [data-testid="block-ctrl-drag-handle"], [data-testid="block-ctrl-drag-handle-container"], [data-testid="block-ctrl-decorator-widget"], [data-testid="block-ctrl-quick-insert-button"]';
const $54506520e25819a2$var$getBlockControlsHoverAreaSelector = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? `[data-editor-block-controls-surface], [data-editor-block-ctrl-drag-handle], ${$54506520e25819a2$var$LEGACY_BLOCK_CONTROLS_HOVER_AREA_SELECTOR}` : $54506520e25819a2$var$LEGACY_BLOCK_CONTROLS_HOVER_AREA_SELECTOR;
const $54506520e25819a2$var$MOUSE_LEAVE_DEBOUNCE_MS = 200;
/** ClickAreaBlock overlay that wraps the editor content and covers the right margin. */ const $54506520e25819a2$var$CLICK_AREA_SELECTOR = '[data-editor-click-wrapper]';
const $54506520e25819a2$var$isMovingToBlockControlsArea = (target)=>target instanceof Element && !!target.closest($54506520e25819a2$var$getBlockControlsHoverAreaSelector());
/**
 * The right margin is covered by the ClickAreaBlock overlay, which sits outside .ak-editor-content-area.
 * Hovering there should still surface the right-side Remix button, so keep controls alive — but only on
 * the right (past the content's right edge), and not in the far-right Rovo gap. The left gutter must
 * dismiss like the experiment-off path, so it is treated as inactive.
 */ const $54506520e25819a2$var$isOverActiveClickArea = (target, clientX)=>{
    var _clickArea$querySelec, _target$ownerDocument;
    if (!(target instanceof Element)) return false;
    const clickArea = target.closest($54506520e25819a2$var$CLICK_AREA_SELECTOR);
    if (!clickArea) return false;
    const contentRight = (_clickArea$querySelec = clickArea.querySelector('.ak-editor-content-area')) === null || _clickArea$querySelec === void 0 ? void 0 : _clickArea$querySelec.getBoundingClientRect().right;
    if (contentRight !== undefined && clientX <= contentRight) return false;
    const innerWidth = ((_target$ownerDocument = target.ownerDocument.defaultView) === null || _target$ownerDocument === void 0 ? void 0 : _target$ownerDocument.innerWidth) ?? Number.POSITIVE_INFINITY;
    return clientX <= innerWidth - (0, $cuDOm.RIGHT_MARGIN_ROVO_GAP_PX);
};
const $54506520e25819a2$var$isOverTreatmentClickArea = (target, editorContentArea, clientX)=>{
    if (!(target instanceof Element) || !(editorContentArea instanceof HTMLElement)) return false;
    if (!target.closest($54506520e25819a2$var$CLICK_AREA_SELECTOR)) return false;
    return clientX > editorContentArea.getBoundingClientRect().right;
};
const $54506520e25819a2$export$d14f503a2a677768 = new (0, $801jp.PluginKey)('interactionTrackingPlugin');
const $54506520e25819a2$export$66f3b9297f4ee65b = (rightSideControlsEnabled = false, api)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $54506520e25819a2$export$d14f503a2a677768,
        state: {
            init () {
                const state = {
                    isEditing: false
                };
                if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) state.isMouseOut = false;
                return state;
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($54506520e25819a2$export$d14f503a2a677768);
                const newState = {};
                switch(meta === null || meta === void 0 ? void 0 : meta.type){
                    case 'startEditing':
                        newState.isEditing = true;
                        break;
                    case 'stopEditing':
                        newState.isEditing = false;
                        break;
                    case 'mouseLeave':
                        newState.isMouseOut = true;
                        newState.hoverSide = undefined;
                        break;
                    case 'mouseEnter':
                        newState.isMouseOut = false;
                        if (meta.side) newState.hoverSide = meta.side;
                        break;
                    case 'setHoverSide':
                        newState.hoverSide = meta.side;
                        break;
                    case 'clearHoverSide':
                        newState.hoverSide = undefined;
                        break;
                }
                return {
                    ...pluginState,
                    ...newState
                };
            }
        },
        props: {
            handleKeyDown: $eSeDI.handleKeyDown,
            handleDOMEvents: {
                mousemove: (view, event)=>(0, $9TG4a.handleMouseMove)(view, event, rightSideControlsEnabled, api)
            }
        },
        view: (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
            const editorContentArea = view.dom.closest('.ak-editor-content-area');
            let unbindMouseEnter;
            let unbindMouseLeave;
            let unbindDocumentMouseMove;
            let mouseLeaveTimeoutId = null;
            let lastMousePosition = {
                x: 0,
                y: 0
            };
            const scheduleMouseLeave = (event)=>{
                if (mouseLeaveTimeoutId) {
                    clearTimeout(mouseLeaveTimeoutId);
                    mouseLeaveTimeoutId = null;
                }
                // Preserve the existing hover targets for the control cohort.
                if (rightSideControlsEnabled && ($54506520e25819a2$var$isMovingToBlockControlsArea(event.relatedTarget) || $54506520e25819a2$var$isOverActiveClickArea(event.relatedTarget, event.clientX))) return;
                if (rightSideControlsEnabled && (0, $bcN2K.isExperimentEnabled)('cc_maui_remix_button_hover_corridor') && $54506520e25819a2$var$isOverTreatmentClickArea(event.relatedTarget, editorContentArea, event.clientX)) return;
                mouseLeaveTimeoutId = setTimeout(()=>{
                    mouseLeaveTimeoutId = null;
                    // Re-check the control cohort's existing hover targets after the debounce.
                    if (rightSideControlsEnabled && typeof document !== 'undefined') {
                        const el = document.elementFromPoint(lastMousePosition.x, lastMousePosition.y);
                        if (el && ($54506520e25819a2$var$isMovingToBlockControlsArea(el) || $54506520e25819a2$var$isOverActiveClickArea(el, lastMousePosition.x))) return;
                        if (el && (0, $bcN2K.isExperimentEnabled)('cc_maui_remix_button_hover_corridor') && $54506520e25819a2$var$isOverTreatmentClickArea(el, editorContentArea, lastMousePosition.x)) return;
                    }
                    (0, $9TG4a.handleMouseLeave)(view, rightSideControlsEnabled);
                }, $54506520e25819a2$var$MOUSE_LEAVE_DEBOUNCE_MS);
            };
            const cancelScheduledMouseLeave = ()=>{
                if (mouseLeaveTimeoutId) {
                    clearTimeout(mouseLeaveTimeoutId);
                    mouseLeaveTimeoutId = null;
                }
            };
            const handleDocumentMouseMove = (event)=>{
                lastMousePosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                // Catches block controls in portals that handleDOMEvents.mousemove misses.
                const isOverKnownHoverTarget = (editorContentArea === null || editorContentArea === void 0 ? void 0 : editorContentArea.contains(event.target)) || $54506520e25819a2$var$isMovingToBlockControlsArea(event.target);
                const overClickArea = event.target instanceof Element && !!event.target.closest($54506520e25819a2$var$CLICK_AREA_SELECTOR);
                if (isOverKnownHoverTarget || overClickArea) (0, $9TG4a.handleMouseMove)(view, event, rightSideControlsEnabled, api);
            };
            const handleTreatmentDocumentMouseMove = (event)=>{
                if ((0, $ldLrq.isBlockControlsSuppressionTarget)(event.target)) {
                    var _interactionTrackingP;
                    lastMousePosition = {
                        x: event.clientX,
                        y: event.clientY
                    };
                    cancelScheduledMouseLeave();
                    if (!((_interactionTrackingP = $54506520e25819a2$export$d14f503a2a677768.getState(view.state)) !== null && _interactionTrackingP !== void 0 && _interactionTrackingP.isMouseOut)) (0, $9TG4a.handleMouseLeave)(view, rightSideControlsEnabled);
                    return;
                }
                handleDocumentMouseMove(event);
            };
            if (editorContentArea) {
                if (rightSideControlsEnabled && typeof document !== 'undefined') {
                    // RemixButtonDecoration fires exposure when the control is visible; this
                    // mount-time split only selects the appropriate interaction listener.
                    if ((0, $bKWnN.UNSAFE_expValNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', false) === true) unbindDocumentMouseMove = (0, $6Zi52.bind)(document, {
                        type: 'mousemove',
                        listener: handleTreatmentDocumentMouseMove,
                        options: {
                            passive: true
                        }
                    });
                    else unbindDocumentMouseMove = (0, $6Zi52.bind)(document, {
                        type: 'mousemove',
                        listener: handleDocumentMouseMove,
                        options: {
                            passive: true
                        }
                    });
                }
                unbindMouseEnter = (0, $6Zi52.bind)(editorContentArea, {
                    type: 'mouseenter',
                    listener: ()=>{
                        if (rightSideControlsEnabled) cancelScheduledMouseLeave();
                        (0, $9TG4a.handleMouseEnter)(view);
                    }
                });
                unbindMouseLeave = (0, $6Zi52.bind)(editorContentArea, {
                    type: 'mouseleave',
                    listener: (event)=>{
                        const e = event;
                        lastMousePosition = {
                            x: e.clientX,
                            y: e.clientY
                        };
                        if (rightSideControlsEnabled) scheduleMouseLeave(e);
                        else (0, $9TG4a.handleMouseLeave)(view, false);
                    }
                });
            }
            return {
                destroy: ()=>{
                    var _unbindMouseEnter, _unbindMouseLeave;
                    if (rightSideControlsEnabled) {
                        var _unbindDocumentMouseM;
                        cancelScheduledMouseLeave();
                        (_unbindDocumentMouseM = unbindDocumentMouseMove) === null || _unbindDocumentMouseM === void 0 || _unbindDocumentMouseM();
                    }
                    (_unbindMouseEnter = unbindMouseEnter) === null || _unbindMouseEnter === void 0 || _unbindMouseEnter();
                    (_unbindMouseLeave = unbindMouseLeave) === null || _unbindMouseLeave === void 0 || _unbindMouseLeave();
                }
            };
        } : undefined
    });
};
const $54506520e25819a2$export$27d80eabdcbf88a5 = (state)=>{
    return $54506520e25819a2$export$d14f503a2a677768.getState(state);
};

});
parcelRegister("ldLrq", function(module, exports) {
$parcel$export(module.exports, "isBlockControlsSuppressionTarget", () => $4ea846c273173513$export$8d5d08f345eecbf1);
const $4ea846c273173513$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE = 'data-block-controls-suppression';
const $4ea846c273173513$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR = `[${$4ea846c273173513$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE}]`;
const $4ea846c273173513$export$7a4820babe675d08 = {
    [$4ea846c273173513$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE]: 'true'
};
const $4ea846c273173513$export$8d5d08f345eecbf1 = (target)=>target instanceof Element && target.closest($4ea846c273173513$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR) !== null;

});

parcelRegister("cuDOm", function(module, exports) {
$parcel$export(module.exports, "RIGHT_MARGIN_ROVO_GAP_PX", () => $272bbe0a63aace25$export$f71c1df40151e4dd);
/** Far-right margin width reserved for the Rovo button, where the Remix button must not show. */ const $272bbe0a63aace25$export$f71c1df40151e4dd = 80;

});

parcelRegister("eSeDI", function(module, exports) {
$parcel$export(module.exports, "handleKeyDown", () => $c3435fdeca2b295c$export$bab59f27a7347e45);

var $2mhhM = parcelRequire("2mhhM");

var $2MmgC = parcelRequire("2MmgC");
const $c3435fdeca2b295c$export$bab59f27a7347e45 = (view, event)=>{
    // Check if this is a keyboard shortcut (Ctrl/Cmd + key)
    const isShortcut = event.ctrlKey || event.metaKey || event.altKey;
    if (isShortcut) return false;
    // Only consider actual typing keys (not shortcuts)
    // We need to check if it's a single character key or a deletion key
    // and ensure it's not part of a shortcut
    const isTypingKey = // Single character keys (letters, numbers, symbols)
    event.key.length === 1 || event.key === 'Backspace' || event.key === 'Delete' || event.key === ' ' || event.key === 'Enter';
    if (!isTypingKey) return false;
    const state = (0, $2MmgC.getInteractionTrackingState)(view.state);
    // if user hasnt started typing yet, start timer
    if (!(state !== null && state !== void 0 && state.isEditing)) (0, $2mhhM.startEditing)(view);
    return false;
};

});
parcelRegister("2mhhM", function(module, exports) {
$parcel$export(module.exports, "stopEditing", () => $1e9ff1573977b0af$export$2e0e85f705dfca46);
$parcel$export(module.exports, "startEditing", () => $1e9ff1573977b0af$export$67bd57d439e8e4eb);
$parcel$export(module.exports, "mouseLeave", () => $1e9ff1573977b0af$export$62b9e387feb21f54);
$parcel$export(module.exports, "mouseEnter", () => $1e9ff1573977b0af$export$681e7b82bbbeba93);
$parcel$export(module.exports, "setHoverSide", () => $1e9ff1573977b0af$export$f6d493eea1569e93);
$parcel$export(module.exports, "clearHoverSide", () => $1e9ff1573977b0af$export$2ded006fde40ec1d);

var $2MmgC = parcelRequire("2MmgC");
const $1e9ff1573977b0af$export$2e0e85f705dfca46 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $2MmgC.interactionTrackingPluginKey), {
        type: 'stopEditing'
    }));
};
const $1e9ff1573977b0af$export$67bd57d439e8e4eb = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $2MmgC.interactionTrackingPluginKey), {
        type: 'startEditing'
    }));
};
const $1e9ff1573977b0af$export$62b9e387feb21f54 = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $2MmgC.interactionTrackingPluginKey), {
        type: 'mouseLeave'
    }));
};
const $1e9ff1573977b0af$export$681e7b82bbbeba93 = (view, side)=>{
    const meta = side ? {
        type: 'mouseEnter',
        side: side
    } : {
        type: 'mouseEnter'
    };
    view.dispatch(view.state.tr.setMeta((0, $2MmgC.interactionTrackingPluginKey), meta));
};
const $1e9ff1573977b0af$export$f6d493eea1569e93 = (view, side)=>{
    view.dispatch(view.state.tr.setMeta((0, $2MmgC.interactionTrackingPluginKey), {
        type: 'setHoverSide',
        side: side
    }));
};
const $1e9ff1573977b0af$export$2ded006fde40ec1d = (view)=>{
    view.dispatch(view.state.tr.setMeta((0, $2MmgC.interactionTrackingPluginKey), {
        type: 'clearHoverSide'
    }));
};

});


parcelRegister("9TG4a", function(module, exports) {
$parcel$export(module.exports, "handleMouseMove", () => $3874b02256b2445a$export$3248c033e90a4ba0);
$parcel$export(module.exports, "handleMouseLeave", () => $3874b02256b2445a$export$fcff8e67f71577c3);
$parcel$export(module.exports, "handleMouseEnter", () => $3874b02256b2445a$export$2560ef85393729a7);

var $bcN2K = parcelRequire("bcN2K");

var $3NBIB = parcelRequire("3NBIB");

var $gqrsA = parcelRequire("gqrsA");

var $2mhhM = parcelRequire("2mhhM");

var $cuDOm = parcelRequire("cuDOm");

var $2MmgC = parcelRequire("2MmgC");
/** Per-view pending hover state; avoids cross-editor singleton. */ const $3874b02256b2445a$var$pendingByView = new WeakMap();
/** Per-view RAF handle so clearPendingHoverSide cancels only that view's callback. */ const $3874b02256b2445a$var$rafIdByView = new WeakMap();
const $3874b02256b2445a$var$cancelScheduledProcessForView = (view)=>{
    const id = $3874b02256b2445a$var$rafIdByView.get(view);
    if (id !== undefined) {
        cancelAnimationFrame(id);
        $3874b02256b2445a$var$rafIdByView.delete(view);
    }
};
const $3874b02256b2445a$var$clearPendingHoverSide = (view)=>{
    $3874b02256b2445a$var$pendingByView.delete(view);
    $3874b02256b2445a$var$cancelScheduledProcessForView(view);
};
const $3874b02256b2445a$var$BLOCK_SELECTORS = '[data-node-anchor], [data-drag-handler-anchor-name]';
const $3874b02256b2445a$var$LEGACY_RIGHT_EDGE_SELECTOR = '[data-blocks-right-edge-button-container]';
const $3874b02256b2445a$var$getRightControlSelector = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? `[data-editor-block-controls-side="right"], ${$3874b02256b2445a$var$LEGACY_RIGHT_EDGE_SELECTOR}` : $3874b02256b2445a$var$LEGACY_RIGHT_EDGE_SELECTOR;
const $3874b02256b2445a$var$LEGACY_LEFT_CONTROL_SELECTOR = '[data-blocks-drag-handle-container], [data-testid="block-ctrl-drag-handle"], [data-testid="block-ctrl-drag-handle-container"], [data-testid="block-ctrl-decorator-widget"], [data-testid="block-ctrl-quick-insert-button"]';
const $3874b02256b2445a$var$getLeftControlSelector = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? `[data-editor-block-ctrl-drag-handle], ${$3874b02256b2445a$var$LEGACY_LEFT_CONTROL_SELECTOR}` : $3874b02256b2445a$var$LEGACY_LEFT_CONTROL_SELECTOR;
// Top-level blocks (no block ancestor), matched by anchor attribute so it works under both the
// legacy and native-anchor schemes.
const $3874b02256b2445a$var$getRootBlocks = (view)=>Array.from(view.dom.querySelectorAll($3874b02256b2445a$var$BLOCK_SELECTORS)).filter((el)=>{
        var _el$parentElement;
        return !((_el$parentElement = el.parentElement) !== null && _el$parentElement !== void 0 && _el$parentElement.closest($3874b02256b2445a$var$BLOCK_SELECTORS));
    });
// Find the root block whose vertical bounds contain clientY. Returns the measured rect so callers
// can reuse it without re-measuring.
const $3874b02256b2445a$var$findBlockAtY = (view, clientY)=>{
    for (const el of $3874b02256b2445a$var$getRootBlocks(view)){
        const rect = el.getBoundingClientRect();
        if (clientY >= rect.top && clientY <= rect.bottom) return {
            block: el,
            rect: rect
        };
    }
    return null;
};
const $3874b02256b2445a$var$getRightMarginBoundary = (view)=>{
    var _view$dom$ownerDocume;
    return (((_view$dom$ownerDocume = view.dom.ownerDocument.defaultView) === null || _view$dom$ownerDocume === void 0 ? void 0 : _view$dom$ownerDocume.innerWidth) ?? Number.POSITIVE_INFINITY) - (0, $cuDOm.RIGHT_MARGIN_ROVO_GAP_PX);
};
// Classify where the cursor sits in the right margin beside the block at its height, running the
// block lookup once so the caller doesn't traverse the DOM twice per mousemove.
const $3874b02256b2445a$var$classifyRightMarginPosition = (view, event)=>{
    const found = $3874b02256b2445a$var$findBlockAtY(view, event.clientY);
    if (!found) return null;
    if (event.clientX <= found.rect.right) return null;
    return event.clientX > $3874b02256b2445a$var$getRightMarginBoundary(view) && !(0, $3NBIB.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true) ? {
        type: 'gap'
    } : {
        type: 'active',
        block: found.block
    };
};
/**
 * Process hover position and set left/right side. Only invoked when right-side controls are
 * enabled; handleMouseMove returns early otherwise.
 */ const $3874b02256b2445a$var$processHoverSide = (view, api)=>{
    var _api$userIntent, _api$showDiff;
    const event = $3874b02256b2445a$var$pendingByView.get(view);
    if (!event) return;
    $3874b02256b2445a$var$pendingByView.delete(view);
    $3874b02256b2445a$var$rafIdByView.delete(view);
    const editorContentArea = view.dom.closest('.ak-editor-content-area');
    if (!(editorContentArea instanceof HTMLElement)) return;
    const state = (0, $2MmgC.getInteractionTrackingState)(view.state);
    const target = event.target instanceof HTMLElement ? event.target : null;
    // EDITOR-7926: skip hover-side tracking while a diff is on screen (or a suggestion card is open)
    // so setHoverSide/mouseEnter don't flip-flop and jitter the controls.
    const currentUserIntent = api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent;
    const isDisplayingDiff = (api === null || api === void 0 || (_api$showDiff = api.showDiff) === null || _api$showDiff === void 0 || (_api$showDiff = _api$showDiff.sharedState.currentState()) === null || _api$showDiff === void 0 ? void 0 : _api$showDiff.isDisplayingChanges) ?? false;
    if (isDisplayingDiff || currentUserIntent === 'reviewing') return;
    // When hovering over block controls directly, infer side from which control we're over.
    // This is more reliable than bounds when controls are in portals outside the editor DOM.
    const rightEdgeElement = target === null || target === void 0 ? void 0 : target.closest($3874b02256b2445a$var$getRightControlSelector());
    if (rightEdgeElement) {
        if (state !== null && state !== void 0 && state.isMouseOut && (0, $3NBIB.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true)) {
            (0, $2mhhM.mouseEnter)(view, 'right');
            return;
        }
        if ((state === null || state === void 0 ? void 0 : state.hoverSide) !== 'right') (0, $2mhhM.setHoverSide)(view, 'right');
        return;
    }
    const leftControlElement = target === null || target === void 0 ? void 0 : target.closest($3874b02256b2445a$var$getLeftControlSelector());
    if (leftControlElement) {
        if ((state === null || state === void 0 ? void 0 : state.hoverSide) !== 'left') (0, $2mhhM.setHoverSide)(view, 'left');
        return;
    }
    const closestBlock = target === null || target === void 0 ? void 0 : target.closest($3874b02256b2445a$var$BLOCK_SELECTORS);
    const blockElement = closestBlock instanceof HTMLElement ? closestBlock : null;
    // Not over a block: the cursor may be in the right margin beside content.
    const marginZone = blockElement ? null : $3874b02256b2445a$var$classifyRightMarginPosition(view, event);
    if ((marginZone === null || marginZone === void 0 ? void 0 : marginZone.type) === 'active' && api) {
        // handleMouseOver only reads event.target, so a target-only stand-in is enough here.
        (0, $gqrsA.handleMouseOver)(view, {
            target: marginZone.block
        }, api);
        // mouseenter doesn't fire over the click overlay, so clear isMouseOut here to re-show.
        if (state !== null && state !== void 0 && state.isMouseOut) {
            if ((0, $3NBIB.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true)) {
                (0, $2mhhM.mouseEnter)(view, 'right');
                return;
            }
            (0, $2mhhM.mouseEnter)(view);
        }
        if ((state === null || state === void 0 ? void 0 : state.hoverSide) !== 'right') (0, $2mhhM.setHoverSide)(view, 'right');
        return;
    }
    // Keep the existing fixed Rovo gap in the control cohort. The treatment uses explicitly marked
    // control surfaces instead, so the rest of the right margin remains hoverable.
    if ((marginZone === null || marginZone === void 0 ? void 0 : marginZone.type) === 'gap' || event.clientX > $3874b02256b2445a$var$getRightMarginBoundary(view) && (!blockElement || !(0, $3NBIB.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true))) {
        if (!(state !== null && state !== void 0 && state.isMouseOut)) {
            (0, $2mhhM.clearHoverSide)(view);
            (0, $2mhhM.mouseLeave)(view);
        }
        return;
    }
    // Over a block: fall through to the midpoint split so the left half keeps the drag handle and
    // the right half shows the Remix button.
    // Pick the side from the content midpoint, keeping the original left/right halves.
    const { left: left, right: right } = editorContentArea.getBoundingClientRect();
    const midpoint = (left + right) / 2;
    const nextHoverSide = event.clientX > midpoint ? 'right' : 'left';
    if ((state === null || state === void 0 ? void 0 : state.hoverSide) !== nextHoverSide) {
        if (state !== null && state !== void 0 && state.isMouseOut && target !== null && target !== void 0 && target.closest($3874b02256b2445a$var$BLOCK_SELECTORS) && (0, $3NBIB.expValEqualsNoExposure)('cc_maui_remix_button_hover_corridor', 'isEnabled', true)) {
            (0, $2mhhM.mouseEnter)(view, nextHoverSide);
            return;
        }
        (0, $2mhhM.setHoverSide)(view, nextHoverSide);
    }
};
const $3874b02256b2445a$export$3248c033e90a4ba0 = (view, event, rightSideControlsEnabled, api)=>{
    const state = (0, $2MmgC.getInteractionTrackingState)(view.state);
    // if user has stopped editing and moved their mouse, show block controls again
    if (state !== null && state !== void 0 && state.isEditing) (0, $2mhhM.stopEditing)(view);
    // Only track hover side when right-side controls are enabled.
    if (!rightSideControlsEnabled) return false;
    if (!(event instanceof MouseEvent)) return false;
    $3874b02256b2445a$var$pendingByView.set(view, event);
    $3874b02256b2445a$var$cancelScheduledProcessForView(view);
    const id = requestAnimationFrame(()=>{
        $3874b02256b2445a$var$processHoverSide(view, api);
    });
    $3874b02256b2445a$var$rafIdByView.set(view, id);
    return false;
};
const $3874b02256b2445a$export$fcff8e67f71577c3 = (view, rightSideControlsEnabled)=>{
    if (rightSideControlsEnabled) $3874b02256b2445a$var$clearPendingHoverSide(view);
    (0, $2mhhM.mouseLeave)(view);
    return false;
};
const $3874b02256b2445a$export$2560ef85393729a7 = (view)=>{
    (0, $2mhhM.mouseEnter)(view);
    return false;
};

});


parcelRegister("jKAmG", function(module, exports) {
$parcel$export(module.exports, "createSelectionPreservationPlugin", () => $e0e423b08109ad41$export$36720c70349457f);

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");

var $1y7gE = parcelRequire("1y7gE");

var $gCPs3 = parcelRequire("gCPs3");

var $gyNLa = parcelRequire("gyNLa");

var $g4us8 = parcelRequire("g4us8");

var $mJpT5 = parcelRequire("mJpT5");

var $b8Grq = parcelRequire("b8Grq");

var $7uueI = parcelRequire("7uueI");
const $e0e423b08109ad41$export$36720c70349457f = (api)=>()=>{
        return new (0, $1y7gE.SafePlugin)({
            key: (0, $b8Grq.selectionPreservationPluginKey),
            state: {
                init () {
                    return {
                        preservedSelection: undefined,
                        syncDomSelectionForDoc: undefined
                    };
                },
                apply (tr, pluginState) {
                    const meta = (0, $7uueI.getSelectionPreservationMeta)(tr);
                    const newState = {
                        ...pluginState
                    };
                    if ((meta === null || meta === void 0 ? void 0 : meta.type) === 'startPreserving') {
                        newState.preservedSelection = (0, $g4us8.createPreservedSelection)(tr.doc.resolve(tr.selection.from), tr.doc.resolve(tr.selection.to));
                        newState.syncDomSelectionForDoc = undefined;
                    } else if ((meta === null || meta === void 0 ? void 0 : meta.type) === 'stopPreserving') {
                        newState.preservedSelection = undefined;
                        newState.syncDomSelectionForDoc = undefined;
                    } else if (tr.docChanged) {
                        if (newState.preservedSelection) newState.preservedSelection = (0, $g4us8.mapPreservedSelection)(newState.preservedSelection, tr);
                        newState.syncDomSelectionForDoc = (0, $7uueI.hasFormatSelectionSyncMeta)(tr) ? tr.doc : undefined;
                    }
                    if (!(0, $7uueI.compareSelections)(newState.preservedSelection, pluginState.preservedSelection)) {
                        if (newState.preservedSelection) {
                            var _api$selection;
                            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.commands) === null || _api$selection === void 0 ? void 0 : _api$selection.setBlockSelection(newState.preservedSelection));
                        } else {
                            var _api$selection2;
                            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$selection2 = api.selection) === null || _api$selection2 === void 0 || (_api$selection2 = _api$selection2.commands) === null || _api$selection2 === void 0 ? void 0 : _api$selection2.clearBlockSelection());
                        }
                    }
                    return newState;
                }
            },
            appendTransaction (transactions, _oldState, newState) {
                const pluginState = (0, $b8Grq.selectionPreservationPluginKey).getState(newState);
                const preservedSel = pluginState === null || pluginState === void 0 ? void 0 : pluginState.preservedSelection;
                const stateSel = newState.selection;
                if (!preservedSel) return null;
                // Auto-stop if user explicitly changes selection
                if ((0, $7uueI.hasUserSelectionChange)(transactions)) return (0, $mJpT5.stopPreservingSelection)({
                    tr: newState.tr
                });
                const selectionUnchanged = stateSel.from === preservedSel.from && stateSel.to === preservedSel.to;
                const selectionInvalid = preservedSel.from < 0 || preservedSel.to > newState.doc.content.size;
                if (selectionUnchanged || selectionInvalid) return null;
                const newSelection = (0, $g4us8.createPreservedSelection)(newState.doc.resolve(preservedSel.from), newState.doc.resolve(preservedSel.to));
                // If selection becomes invalid, stop preserving
                if (!newSelection) return (0, $mJpT5.stopPreservingSelection)({
                    tr: newState.tr
                });
                return newState.tr.setSelection(newSelection);
            },
            view (initialView) {
                let view = initialView;
                const doc = (0, $j5N6B.getDocument)();
                let pendingFormatSelectionSyncFrame;
                if (!doc) return {
                    update () {},
                    destroy () {}
                };
                const unbindDocumentMouseDown = (0, $6Zi52.bind)(doc, {
                    type: 'mousedown',
                    listener: (e)=>{
                        if (!(e.target instanceof HTMLElement)) return;
                        const { preservedSelection: preservedSelection } = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state) || {};
                        // If there is no current preserved selection or the editor is not focused, do nothing
                        if (!preservedSelection) return;
                        const clickedDragHandle = !!e.target.closest((0, $gCPs3.DRAG_HANDLE_SELECTOR));
                        // When mouse down on a drag handle we continue preserving the selection
                        if (clickedDragHandle) return;
                        const clickedOutsideEditor = !e.target.closest('.ProseMirror');
                        // When mouse down outside the editor continue to preserve the selection
                        if (clickedOutsideEditor) return;
                        // Otherwise mouse down anywhere else in the editor stops preserving the selection
                        const tr = view.state.tr;
                        (0, $mJpT5.stopPreservingSelection)({
                            tr: tr
                        });
                        view.dispatch(tr);
                    },
                    // Use capture phase to stop preservation before appendTransaction runs,
                    // preventing unwanted selection restoration when the user clicks into the editor.
                    options: {
                        capture: true
                    }
                });
                return {
                    update (updateView, prevState) {
                        var _selectionPreservatio, _key$getState, _key$getState2;
                        view = updateView;
                        const prevPreservedSelection = (_selectionPreservatio = (0, $b8Grq.selectionPreservationPluginKey).getState(prevState)) === null || _selectionPreservatio === void 0 ? void 0 : _selectionPreservatio.preservedSelection;
                        const currPluginState = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state);
                        const currPreservedSelection = currPluginState === null || currPluginState === void 0 ? void 0 : currPluginState.preservedSelection;
                        const prevActiveNode = (_key$getState = (0, $gyNLa.key).getState(prevState)) === null || _key$getState === void 0 ? void 0 : _key$getState.activeNode;
                        const currActiveNode = (_key$getState2 = (0, $gyNLa.key).getState(view.state)) === null || _key$getState2 === void 0 ? void 0 : _key$getState2.activeNode;
                        // Sync DOM selection when the preserved selection or active node changes
                        // AND the document has changed (e.g., nodes moved)
                        // This prevents stealing focus during menu navigation while still fixing ghost highlighting
                        const hasPreservedSelection = !!currPreservedSelection;
                        const preservedSelectionChanged = !(0, $7uueI.compareSelections)(prevPreservedSelection, currPreservedSelection);
                        const activeNodeChanged = prevActiveNode !== currActiveNode;
                        const docChanged = prevState.doc !== view.state.doc;
                        const hasFormatSyncRequestForCurrentDoc = (currPluginState === null || currPluginState === void 0 ? void 0 : currPluginState.syncDomSelectionForDoc) === view.state.doc;
                        const shouldSyncDOMSelection = (hasPreservedSelection && (preservedSelectionChanged || activeNodeChanged) || hasFormatSyncRequestForCurrentDoc) && docChanged;
                        if (shouldSyncDOMSelection) {
                            const syncSelection = view.state.selection;
                            if (hasFormatSyncRequestForCurrentDoc) {
                                if (pendingFormatSelectionSyncFrame !== undefined) cancelAnimationFrame(pendingFormatSelectionSyncFrame);
                                pendingFormatSelectionSyncFrame = requestAnimationFrame(()=>{
                                    pendingFormatSelectionSyncFrame = undefined;
                                    (0, $7uueI.syncDOMSelection)(syncSelection, view, {
                                        focusEditor: true
                                    });
                                });
                            } else (0, $7uueI.syncDOMSelection)(syncSelection, view);
                        }
                    },
                    destroy () {
                        if (pendingFormatSelectionSyncFrame !== undefined) cancelAnimationFrame(pendingFormatSelectionSyncFrame);
                        unbindDocumentMouseDown();
                    }
                };
            },
            props: {
                handleKeyDown: (view, event)=>{
                    var _api$core, _api$blockControls;
                    const { preservedSelection: preservedSelection } = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state) || {};
                    // If there is no current preserved selection, do nothing
                    if (!preservedSelection) return false;
                    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.commands) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.handleKeyDownWithPreservedSelection(event));
                    // While preserving selection, if user presses delete/backspace, prevent event from being
                    // handled by ProseMirror natively so that we can apply logic using the preserved selection.
                    return [
                        'backspace',
                        'delete'
                    ].includes(event.key.toLowerCase());
                }
            }
        });
    };

});
parcelRegister("7uueI", function(module, exports) {
$parcel$export(module.exports, "hasUserSelectionChange", () => $43f2656ff7162503$export$a61ec0b8c52b12b5);
$parcel$export(module.exports, "getSelectionPreservationMeta", () => $43f2656ff7162503$export$176558ea818a3e54);
$parcel$export(module.exports, "hasFormatSelectionSyncMeta", () => $43f2656ff7162503$export$a7b6f48b0ef94ac5);
$parcel$export(module.exports, "compareSelections", () => $43f2656ff7162503$export$36518d6d9145806a);
$parcel$export(module.exports, "syncDOMSelection", () => $43f2656ff7162503$export$e6bc8ad830dbda92);

var $j5N6B = parcelRequire("j5N6B");

var $jDtWq = parcelRequire("jDtWq");

var $b8Grq = parcelRequire("b8Grq");
const $43f2656ff7162503$export$a61ec0b8c52b12b5 = (transactions)=>{
    return transactions.some((tr)=>tr.getMeta('pointer') && tr.selectionSet);
};
const $43f2656ff7162503$export$176558ea818a3e54 = (tr)=>{
    return tr.getMeta((0, $b8Grq.selectionPreservationPluginKey));
};
const $43f2656ff7162503$export$a7b6f48b0ef94ac5 = (tr)=>tr.getMeta((0, $jDtWq.FORMAT_SELECTION_SYNC_META)) === true;
const $43f2656ff7162503$export$36518d6d9145806a = (a, b)=>{
    return !a && !b || !!a && !!b && a.eq(b);
};
const $43f2656ff7162503$export$e6bc8ad830dbda92 = (selection, view, options)=>{
    try {
        if (options !== null && options !== void 0 && options.focusEditor && !view.hasFocus()) // The native browser selection is only painted while the editor owns focus.
        // Formatting toolbar interactions can move focus away before we restore the range.
        view.focus();
        const domSelection = window.getSelection();
        if (!domSelection) return;
        const doc = (0, $j5N6B.getDocument)();
        if (!doc) return;
        // Convert ProseMirror selection to DOM selection using view.domAtPos
        const anchor = view.domAtPos(selection.anchor);
        const head = view.domAtPos(selection.head);
        if (!anchor || !head) return;
        // Create a new DOM range from the ProseMirror selection
        const range = doc.createRange();
        range.setStart(anchor.node, anchor.offset);
        range.setEnd(head.node, head.offset);
        // Update the DOM selection to match ProseMirror's selection
        domSelection.removeAllRanges();
        domSelection.addRange(range);
    } catch  {
    // Silently fail if DOM selection sync fails
    // This can happen if positions are invalid or DOM hasn't updated yet
    }
};

});


parcelRegister("8BsvG", function(module, exports) {
$parcel$export(module.exports, "sparseSurfacesKey", () => $dd56fce8bdd8d680$export$124d0b9d0fc52a78);
$parcel$export(module.exports, "createSparseSurfacesPlugin", () => $dd56fce8bdd8d680$export$3540c976585d7feb);

var $1KbM4 = parcelRequire("1KbM4");

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $gyNLa = parcelRequire("gyNLa");

var $gIUJy = parcelRequire("gIUJy");

var $61og4 = parcelRequire("61og4");

var $6eyQr = parcelRequire("6eyQr");
const $dd56fce8bdd8d680$export$124d0b9d0fc52a78 = new (0, $801jp.PluginKey)('blockControlsSparseSurfaces');
const $dd56fce8bdd8d680$export$3540c976585d7feb = (api)=>new (0, $1y7gE.SafePlugin)({
        key: $dd56fce8bdd8d680$export$124d0b9d0fc52a78,
        state: {
            init: ()=>(0, $6eyQr.createInitialSparseSurfacesState)((0, $61og4.emptySparseSurfaceCandidateState)),
            apply (tr, previous, _oldState, newState) {
                return (0, $6eyQr.applySparseSurfacesTransaction)({
                    invalidation: tr.getMeta((0, $1KbM4.BLOCK_CONTROLS_SURFACE_INVALIDATION)),
                    meta: tr.getMeta($dd56fce8bdd8d680$export$124d0b9d0fc52a78),
                    newState: newState,
                    previous: previous,
                    tr: tr
                });
            }
        },
        props: {
            decorations (state) {
                var _api$limitedMode, _blockControlsKey$get, _sparseSurfacesKey$ge;
                return api !== null && api !== void 0 && (_api$limitedMode = api.limitedMode) !== null && _api$limitedMode !== void 0 && (_api$limitedMode = _api$limitedMode.sharedState.currentState()) !== null && _api$limitedMode !== void 0 && _api$limitedMode.enabled || (_blockControlsKey$get = (0, $gyNLa.key).getState(state)) !== null && _blockControlsKey$get !== void 0 && _blockControlsKey$get.isDragging ? (0, $16ZMX.DecorationSet).empty : (_sparseSurfacesKey$ge = $dd56fce8bdd8d680$export$124d0b9d0fc52a78.getState(state)) === null || _sparseSurfacesKey$ge === void 0 ? void 0 : _sparseSurfacesKey$ge.decorations;
            }
        },
        view: (view)=>(0, $gIUJy.createSparseSurfacesView)({
                api: api,
                pluginKey: $dd56fce8bdd8d680$export$124d0b9d0fc52a78,
                view: view
            })
    });

});
parcelRegister("1KbM4", function(module, exports) {
$parcel$export(module.exports, "BLOCK_CONTROLS_SURFACE_INVALIDATION", () => $4cb9f2ee925395e6$export$bc8f172a7b59f6f8);
const $4cb9f2ee925395e6$export$bc8f172a7b59f6f8 = 'blockControlsSurfaceInvalidation';
const $4cb9f2ee925395e6$export$e9d9d89287b09e8 = (tr, invalidation)=>{
    const previous = tr.getMeta($4cb9f2ee925395e6$export$bc8f172a7b59f6f8);
    return tr.setMeta($4cb9f2ee925395e6$export$bc8f172a7b59f6f8, {
        ids: [
            ...(previous === null || previous === void 0 ? void 0 : previous.ids) ?? [],
            ...invalidation.ids ?? []
        ],
        positions: [
            ...(previous === null || previous === void 0 ? void 0 : previous.positions) ?? [],
            ...invalidation.positions ?? []
        ],
        ranges: [
            ...(previous === null || previous === void 0 ? void 0 : previous.ranges) ?? [],
            ...invalidation.ranges ?? []
        ]
    });
};

});

parcelRegister("gIUJy", function(module, exports) {
$parcel$export(module.exports, "createSparseSurfacesView", () => $963e5ca304831ab3$export$4a2cabc2b98c0de5);

var $5Amf8 = parcelRequire("5Amf8");

var $2sOQK = parcelRequire("2sOQK");

var $hy51U = parcelRequire("hy51U");

var $bcN2K = parcelRequire("bcN2K");

var $L2nj7 = parcelRequire("L2nj7");

var $h6mfz = parcelRequire("h6mfz");

var $gyNLa = parcelRequire("gyNLa");

var $buNxa = parcelRequire("buNxa");

var $61og4 = parcelRequire("61og4");

var $9VSvv = parcelRequire("9VSvv");
const $963e5ca304831ab3$var$haveAnchorPositionsChanged = (positions, anchors)=>positions.length !== anchors.size || positions.some((position)=>!anchors.has(position));
const $963e5ca304831ab3$var$createLegacySparseSurfacesView = ({ api: api, pluginKey: pluginKey, view: view })=>{
    var _api$uiControlRegistr2, _api$editorDisabled, _api$editorViewMode, _api$limitedMode2, _api$showDiff, _api$userIntent;
    const win = view.dom.ownerDocument.defaultView;
    let frame;
    let visiblePositions = [];
    let registryChanged = true;
    const reconcile = ()=>{
        var _api$limitedMode;
        frame = undefined;
        const previous = pluginKey.getState(view.state);
        if (!previous || api !== null && api !== void 0 && (_api$limitedMode = api.limitedMode) !== null && _api$limitedMode !== void 0 && (_api$limitedMode = _api$limitedMode.sharedState.currentState()) !== null && _api$limitedMode !== void 0 && _api$limitedMode.enabled) return;
        const controls = (0, $gyNLa.key).getState(view.state);
        const activeNode = controls === null || controls === void 0 ? void 0 : controls.activeNode;
        const activeNodesByPosition = new Map();
        const menu = controls !== null && controls !== void 0 && controls.isMenuOpen ? controls.menuTriggerByNode : undefined;
        if (menu && controls !== null && controls !== void 0 && controls.menuTriggerBy && view.state.doc.nodeAt(menu.pos)) {
            const menuNode = {
                ...menu,
                anchorName: controls.menuTriggerBy
            };
            activeNodesByPosition.set(menu.pos, menuNode);
            activeNodesByPosition.set(menu.rootPos ?? menu.pos, menuNode);
        }
        const resolvedSurfaces = [
            (0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE),
            (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE)
        ].map((surface)=>{
            var _api$uiControlRegistr;
            return (0, $hy51U.resolveSurface)((api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents(surface)) ?? [], surface);
        });
        const candidates = (0, $61og4.reconcileSparseSurfaceCandidates)({
            activeNode: activeNode,
            activeNodesByPosition: activeNodesByPosition,
            newState: view.state,
            state: previous.candidates,
            visiblePositions: visiblePositions,
            protectedPositions: [
                ...activeNodesByPosition.keys()
            ],
            resolvedSurfaces: resolvedSurfaces,
            documentChanged: previous.documentChanged,
            invalidation: {
                ...previous.invalidation,
                all: registryChanged
            }
        });
        const visibilityChanged = registryChanged;
        registryChanged = false;
        const anchorPositions = candidates.positions;
        if (!visibilityChanged && !$963e5ca304831ab3$var$haveAnchorPositionsChanged(anchorPositions, previous.anchors) && candidates === previous.candidates && !previous.documentChanged && !previous.invalidation) return;
        const nodeIdProvider = (0, $2sOQK.getNodeIdProvider)(view);
        const { anchors: anchors, decorations: decorations } = (0, $h6mfz.createSurfaceAnchorDecorations)(view.state, anchorPositions, (node, position, previousAnchorName)=>{
            if (previousAnchorName) {
                nodeIdProvider.setIdForNode(node, previousAnchorName);
                return previousAnchorName;
            }
            return nodeIdProvider.getOrGenerateId(node, position);
        }, previous.anchors);
        view.dispatch(view.state.tr.setMeta(pluginKey, {
            reconciliation: {
                activeNodesByPosition: activeNodesByPosition,
                anchors: anchors,
                candidates: candidates,
                decorations: decorations
            },
            type: 'commitReconciliation'
        }));
    };
    const schedule = ()=>{
        if (frame === undefined && win) frame = win.requestAnimationFrame(reconcile);
    };
    const observer = (0, $9VSvv.observeSurfaceViewport)(view, (positions)=>{
        visiblePositions = positions;
        schedule();
    });
    const invalidate = ()=>{
        registryChanged = true;
        schedule();
    };
    const unsubscribe = api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 ? void 0 : _api$uiControlRegistr2.actions.subscribe(invalidate);
    const unbindGutterHover = (0, $buNxa.bindSparseGutterHover)({
        api: api,
        view: view
    });
    const unsubscribers = [
        api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$limitedMode2 = api.limitedMode) === null || _api$limitedMode2 === void 0 ? void 0 : _api$limitedMode2.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$showDiff = api.showDiff) === null || _api$showDiff === void 0 ? void 0 : _api$showDiff.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.sharedState.onChange(invalidate)
    ];
    return {
        update (currentView, previousState) {
            observer.update();
            const sparse = pluginKey.getState(currentView.state);
            const controls = (0, $gyNLa.key).getState(currentView.state);
            const previousControls = (0, $gyNLa.key).getState(previousState);
            if ((controls === null || controls === void 0 ? void 0 : controls.isDragging) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.isDragging) || (controls === null || controls === void 0 ? void 0 : controls.isResizerResizing) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.isResizerResizing)) invalidate();
            if (sparse !== null && sparse !== void 0 && sparse.documentChanged || sparse !== null && sparse !== void 0 && sparse.invalidation || (controls === null || controls === void 0 ? void 0 : controls.activeNode) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.activeNode) || (controls === null || controls === void 0 ? void 0 : controls.isMenuOpen) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.isMenuOpen) || (controls === null || controls === void 0 ? void 0 : controls.menuTriggerByNode) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.menuTriggerByNode)) schedule();
        },
        destroy () {
            if (frame !== undefined) win === null || win === void 0 || win.cancelAnimationFrame(frame);
            observer.destroy();
            unbindGutterHover === null || unbindGutterHover === void 0 || unbindGutterHover();
            unsubscribe === null || unsubscribe === void 0 || unsubscribe();
            unsubscribers.forEach((unsubscribe)=>unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe());
        }
    };
};
const $963e5ca304831ab3$export$4a2cabc2b98c0de5 = (options)=>{
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_cls_fix')) return (0, $L2nj7.createSparseSurfacesViewWithLifecycle)(options);
    else return $963e5ca304831ab3$var$createLegacySparseSurfacesView(options);
};

});
parcelRegister("L2nj7", function(module, exports) {
$parcel$export(module.exports, "createSparseSurfacesViewWithLifecycle", () => $29a8131b9aad2783$export$8c941523834ee302);

var $5Amf8 = parcelRequire("5Amf8");

var $2sOQK = parcelRequire("2sOQK");

var $hy51U = parcelRequire("hy51U");

var $h6mfz = parcelRequire("h6mfz");

var $gyNLa = parcelRequire("gyNLa");

var $buNxa = parcelRequire("buNxa");

var $61og4 = parcelRequire("61og4");

var $9VSvv = parcelRequire("9VSvv");

var $7pLRV = parcelRequire("7pLRV");

var $gl33i = parcelRequire("gl33i");

var $kNNa3 = parcelRequire("kNNa3");
const $29a8131b9aad2783$var$haveAnchorPositionsChanged = (positions, anchors)=>positions.length !== anchors.size || positions.some((position)=>!anchors.has(position));
const $29a8131b9aad2783$var$areAnchorsEqual = (a, b)=>a.size === b.size && [
        ...a
    ].every(([position, name])=>b.get(position) === name);
/** Limited mode and dragging remove every sparse anchor decoration from the document. */ const $29a8131b9aad2783$var$areSurfacesSuppressed = (api, state)=>{
    var _api$limitedMode, _blockControlsKey$get;
    return Boolean((api === null || api === void 0 || (_api$limitedMode = api.limitedMode) === null || _api$limitedMode === void 0 || (_api$limitedMode = _api$limitedMode.sharedState.currentState()) === null || _api$limitedMode === void 0 ? void 0 : _api$limitedMode.enabled) || ((_blockControlsKey$get = (0, $gyNLa.key).getState(state)) === null || _blockControlsKey$get === void 0 ? void 0 : _blockControlsKey$get.isDragging));
};
/** An open block menu keeps its trigger node, and that node's root, as active surface positions. */ const $29a8131b9aad2783$var$getMenuActiveNodes = (controls, doc)=>{
    const activeNodesByPosition = new Map();
    const menu = controls !== null && controls !== void 0 && controls.isMenuOpen ? controls.menuTriggerByNode : undefined;
    if (menu && controls !== null && controls !== void 0 && controls.menuTriggerBy && doc.nodeAt(menu.pos)) {
        const menuNode = {
            ...menu,
            anchorName: controls.menuTriggerBy
        };
        activeNodesByPosition.set(menu.pos, menuNode);
        activeNodesByPosition.set(menu.rootPos ?? menu.pos, menuNode);
    }
    return activeNodesByPosition;
};
const $29a8131b9aad2783$var$reconcileCandidates = ({ activeNode: activeNode, activeNodesByPosition: activeNodesByPosition, api: api, previous: previous, registryChanged: registryChanged, state: state, visiblePositions: visiblePositions })=>(0, $61og4.reconcileSparseSurfaceCandidates)({
        activeNode: activeNode,
        activeNodesByPosition: activeNodesByPosition,
        newState: state,
        state: previous.candidates,
        visiblePositions: visiblePositions,
        protectedPositions: [
            ...activeNodesByPosition.keys()
        ],
        resolvedSurfaces: [
            (0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE),
            (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE)
        ].map((surface)=>{
            var _api$uiControlRegistr;
            return (0, $hy51U.resolveSurface)((api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents(surface)) ?? [], surface);
        }),
        documentChanged: previous.documentChanged,
        invalidation: {
            ...previous.invalidation,
            all: registryChanged
        }
    });
/** True when the committed state already matches the candidates and no anchor awaits retirement. */ const $29a8131b9aad2783$var$isReconciled = (previous, candidates, lifecycle)=>!$29a8131b9aad2783$var$haveAnchorPositionsChanged(candidates.positions, previous.anchors) && candidates === previous.candidates && !previous.documentChanged && !previous.invalidation && !lifecycle.hasRetirableAnchors(previous.decorations);
/**
 * Builds anchor decorations for the candidate positions, keeping each node's existing anchor name
 * and any anchor a committed or pending surface still uses.
 */ const $29a8131b9aad2783$var$createReconciledDecorations = (view, previous, positions, lifecycle)=>{
    const previousAnchors = new Map(previous.decorations.find(undefined, undefined, (spec)=>spec.type === (0, $h6mfz.TYPE_SURFACE_ANCHOR_DEC)).map((decoration)=>[
            decoration.from,
            String(decoration.spec.anchorName)
        ]));
    const nodeIdProvider = (0, $2sOQK.getNodeIdProvider)(view);
    const { anchors: nextAnchors, decorations: desiredDecorations } = (0, $h6mfz.createSurfaceAnchorDecorations)(view.state, positions, (node, position, previousAnchorName)=>{
        if (previousAnchorName) {
            nodeIdProvider.setIdForNode(node, previousAnchorName);
            return previousAnchorName;
        }
        return nodeIdProvider.getOrGenerateId(node, position);
    }, previousAnchors);
    return {
        // Retiring anchors after a commit leaves the anchor map unchanged, so keep its identity.
        anchors: $29a8131b9aad2783$var$areAnchorsEqual(nextAnchors, previous.anchors) ? previous.anchors : nextAnchors,
        decorations: lifecycle.retainAnchors(view.state.doc, desiredDecorations, previous.decorations)
    };
};
const $29a8131b9aad2783$var$resolveSurfaceSnapshot = ({ activeNode: activeNode, activeNodesByPosition: activeNodesByPosition, anchors: anchors, api: api, invalidated: invalidated, positions: positions, resolvers: resolvers, state: state })=>{
    var _activeNode$handleOpt, _api$uiControlRegistr2, _api$uiControlRegistr3;
    const candidatePositions = new Set(positions);
    const input = {
        activeNode: activeNode,
        state: state,
        surfaceActiveNodes: activeNodesByPosition,
        surfaceAnchors: anchors,
        targets: (0, $7pLRV.getBlockControlsSurfaceTargets)(activeNode, positions).filter(({ position: position })=>candidatePositions.has(position))
    };
    return {
        forceVisibleOnMouseOut: Boolean(activeNode === null || activeNode === void 0 || (_activeNode$handleOpt = activeNode.handleOptions) === null || _activeNode$handleOpt === void 0 ? void 0 : _activeNode$handleOpt.isFocused),
        left: resolvers.left({
            ...input,
            components: (api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 ? void 0 : _api$uiControlRegistr2.actions.getComponents((0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE))) ?? []
        }, invalidated),
        right: resolvers.right({
            ...input,
            components: (api === null || api === void 0 || (_api$uiControlRegistr3 = api.uiControlRegistry) === null || _api$uiControlRegistr3 === void 0 ? void 0 : _api$uiControlRegistr3.actions.getComponents((0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE))) ?? []
        }, invalidated)
    };
};
/** Changes that can add or remove anchor suppression, which also invalidates control visibility. */ const $29a8131b9aad2783$var$haveSuppressionInputsChanged = (controls, previousControls)=>(controls === null || controls === void 0 ? void 0 : controls.isDragging) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.isDragging) || (controls === null || controls === void 0 ? void 0 : controls.isResizerResizing) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.isResizerResizing);
/** Changes that can move surfaces between blocks without invalidating control visibility. */ const $29a8131b9aad2783$var$haveSurfaceInputsChanged = (sparse, controls, previousControls)=>Boolean((sparse === null || sparse === void 0 ? void 0 : sparse.documentChanged) || (sparse === null || sparse === void 0 ? void 0 : sparse.invalidation)) || (controls === null || controls === void 0 ? void 0 : controls.activeNode) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.activeNode) || (controls === null || controls === void 0 ? void 0 : controls.isMenuOpen) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.isMenuOpen) || (controls === null || controls === void 0 ? void 0 : controls.menuTriggerByNode) !== (previousControls === null || previousControls === void 0 ? void 0 : previousControls.menuTriggerByNode);
const $29a8131b9aad2783$var$subscribeToInvalidation = (api, invalidate)=>{
    var _api$uiControlRegistr4, _api$editorDisabled, _api$editorViewMode, _api$limitedMode2, _api$showDiff, _api$userIntent;
    const unsubscribers = [
        api === null || api === void 0 || (_api$uiControlRegistr4 = api.uiControlRegistry) === null || _api$uiControlRegistr4 === void 0 ? void 0 : _api$uiControlRegistr4.actions.subscribe(invalidate),
        api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$limitedMode2 = api.limitedMode) === null || _api$limitedMode2 === void 0 ? void 0 : _api$limitedMode2.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$showDiff = api.showDiff) === null || _api$showDiff === void 0 ? void 0 : _api$showDiff.sharedState.onChange(invalidate),
        api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.sharedState.onChange(invalidate)
    ];
    return ()=>unsubscribers.forEach((unsubscribe)=>unsubscribe === null || unsubscribe === void 0 ? void 0 : unsubscribe());
};
const $29a8131b9aad2783$export$8c941523834ee302 = ({ api: api, pluginKey: pluginKey, view: view })=>{
    const win = view.dom.ownerDocument.defaultView;
    const lifecycle = (0, $kNNa3.getSurfaceLifecycle)(view);
    const resolvers = {
        left: (0, $gl33i.createSurfaceDescriptorResolver)('left'),
        right: (0, $gl33i.createSurfaceDescriptorResolver)('right')
    };
    let frame;
    let visiblePositions = [];
    let registryChanged = true;
    let surfaceStateChanged = false;
    const updateAvailableAnchors = ()=>{
        const sparse = pluginKey.getState(view.state);
        if (sparse) lifecycle.updateAnchors(sparse.decorations, $29a8131b9aad2783$var$areSurfacesSuppressed(api, view.state));
    };
    const reconcile = ()=>{
        var _api$limitedMode3;
        frame = undefined;
        const previous = pluginKey.getState(view.state);
        if (!previous || api !== null && api !== void 0 && (_api$limitedMode3 = api.limitedMode) !== null && _api$limitedMode3 !== void 0 && (_api$limitedMode3 = _api$limitedMode3.sharedState.currentState()) !== null && _api$limitedMode3 !== void 0 && _api$limitedMode3.enabled) return;
        const controls = (0, $gyNLa.key).getState(view.state);
        const activeNode = controls === null || controls === void 0 ? void 0 : controls.activeNode;
        const activeNodesByPosition = $29a8131b9aad2783$var$getMenuActiveNodes(controls, view.state.doc);
        const candidates = $29a8131b9aad2783$var$reconcileCandidates({
            activeNode: activeNode,
            activeNodesByPosition: activeNodesByPosition,
            api: api,
            previous: previous,
            registryChanged: registryChanged,
            state: view.state,
            visiblePositions: visiblePositions
        });
        const visibilityChanged = registryChanged;
        registryChanged = false;
        if (!surfaceStateChanged && !visibilityChanged && $29a8131b9aad2783$var$isReconciled(previous, candidates, lifecycle)) return;
        surfaceStateChanged = false;
        const { anchors: anchors, decorations: decorations } = $29a8131b9aad2783$var$createReconciledDecorations(view, previous, candidates.positions, lifecycle);
        view.dispatch(view.state.tr.setMeta(pluginKey, {
            reconciliation: {
                activeNodesByPosition: activeNodesByPosition,
                anchors: anchors,
                candidates: candidates,
                decorations: decorations
            },
            type: 'commitReconciliation'
        }));
        lifecycle.publish($29a8131b9aad2783$var$resolveSurfaceSnapshot({
            activeNode: activeNode,
            activeNodesByPosition: activeNodesByPosition,
            anchors: anchors,
            api: api,
            invalidated: visibilityChanged || Boolean(previous.invalidation),
            positions: candidates.positions,
            resolvers: resolvers,
            state: view.state
        }), anchors);
    };
    const schedule = ()=>{
        if (frame === undefined && win) frame = win.requestAnimationFrame(reconcile);
    };
    const invalidate = ()=>{
        if ($29a8131b9aad2783$var$areSurfacesSuppressed(api, view.state)) updateAvailableAnchors();
        registryChanged = true;
        schedule();
    };
    updateAvailableAnchors();
    // A committed tree may no longer need older anchors; the next reconcile retires them.
    lifecycle.setOnCommit(schedule);
    const observer = (0, $9VSvv.observeSurfaceViewport)(view, (positions)=>{
        visiblePositions = positions;
        schedule();
    });
    const unsubscribe = $29a8131b9aad2783$var$subscribeToInvalidation(api, invalidate);
    const unbindGutterHover = (0, $buNxa.bindSparseGutterHover)({
        api: api,
        view: view
    });
    return {
        update (currentView, previousState) {
            updateAvailableAnchors();
            observer.update();
            const controls = (0, $gyNLa.key).getState(currentView.state);
            const previousControls = (0, $gyNLa.key).getState(previousState);
            if ($29a8131b9aad2783$var$haveSuppressionInputsChanged(controls, previousControls)) invalidate();
            if ($29a8131b9aad2783$var$haveSurfaceInputsChanged(pluginKey.getState(currentView.state), controls, previousControls)) {
                surfaceStateChanged = true;
                schedule();
            }
        },
        destroy () {
            if (frame !== undefined) win === null || win === void 0 || win.cancelAnimationFrame(frame);
            lifecycle.destroy();
            observer.destroy();
            unbindGutterHover === null || unbindGutterHover === void 0 || unbindGutterHover();
            unsubscribe();
        }
    };
};

});
parcelRegister("h6mfz", function(module, exports) {
$parcel$export(module.exports, "TYPE_SURFACE_ANCHOR_DEC", () => $e0d92734c971da89$export$3a6e1f077fabc5a2);
$parcel$export(module.exports, "createSurfaceAnchorDecorations", () => $e0d92734c971da89$export$502fa7412f6a6bb5);

var $16ZMX = parcelRequire("16ZMX");
const $e0d92734c971da89$export$3a6e1f077fabc5a2 = 'block-controls-surface-anchor';
const $e0d92734c971da89$export$f61a1376bd53a20 = 'data-block-controls-surface-anchor';
const $e0d92734c971da89$export$189036dc6093a3a7 = 'data-block-controls-surface-node-type';
const $e0d92734c971da89$export$139252ecae10e01e = '--block-controls-surface-anchor-name';
/**
 * These node views expose the box used by the measured placement fallback rather than their
 * ProseMirror node wrapper. The marker carries the name through a custom property so sparse CSS
 * can name that inner box without adding a widget or changing the node view.
 */ const $e0d92734c971da89$var$INNER_CONTENT_NODE_TYPES = new Set([
    'blockCard',
    'bodiedExtension',
    'embedCard',
    'extension',
    'mediaSingle',
    'multiBodiedExtension',
    'table'
]);
const $e0d92734c971da89$var$getMarkerStyle = (nodeType, anchorName)=>{
    const inheritedName = `${$e0d92734c971da89$export$139252ecae10e01e}: ${anchorName};`;
    // Inner boxes get their anchor from the sparse global selector. Naming only the node wrapper
    // would position media/table/extension controls against the wrapper instead of visible content.
    return $e0d92734c971da89$var$INNER_CONTENT_NODE_TYPES.has(nodeType) ? inheritedName : `${inheritedName} anchor-name: ${anchorName};`;
};
const $e0d92734c971da89$export$502fa7412f6a6bb5 = (state, positions, resolveAnchorName, previousAnchors)=>{
    const anchors = new Map();
    const decorations = [];
    for (const position of positions){
        if (anchors.has(position)) continue;
        const node = state.doc.nodeAt(position);
        if (!(node !== null && node !== void 0 && node.isBlock)) continue;
        const anchorName = resolveAnchorName(node, position, previousAnchors === null || previousAnchors === void 0 ? void 0 : previousAnchors.get(position));
        if (!anchorName) continue;
        anchors.set(position, anchorName);
        decorations.push((0, $16ZMX.Decoration).node(position, position + node.nodeSize, {
            [$e0d92734c971da89$export$f61a1376bd53a20]: anchorName,
            [$e0d92734c971da89$export$189036dc6093a3a7]: node.type.name,
            style: $e0d92734c971da89$var$getMarkerStyle(node.type.name, anchorName)
        }, {
            type: $e0d92734c971da89$export$3a6e1f077fabc5a2,
            anchorName: anchorName,
            nodeType: node.type.name
        }));
    }
    return {
        anchors: anchors,
        decorations: (0, $16ZMX.DecorationSet).create(state.doc, decorations)
    };
};

});

parcelRegister("buNxa", function(module, exports) {
$parcel$export(module.exports, "bindSparseGutterHover", () => $498e920a7fe4ead7$export$11866942a98d0d67);

var $6Zi52 = parcelRequire("6Zi52");

var $gCPs3 = parcelRequire("gCPs3");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $3NBIB = parcelRequire("3NBIB");

var $GIvev = parcelRequire("GIvev");

var $cm2qP = parcelRequire("cm2qP");

var $2mhhM = parcelRequire("2mhhM");

var $9TG4a = parcelRequire("9TG4a");

var $2MmgC = parcelRequire("2MmgC");

var $4rYqB = parcelRequire("4rYqB");
const $498e920a7fe4ead7$var$BLOCK_SELECTOR = '[data-prosemirror-node-block="true"]';
const $498e920a7fe4ead7$var$TABLE_STRUCTURE_NODES = new Set([
    'table',
    'tableRow',
    'tableCell',
    'tableHeader'
]);
const $498e920a7fe4ead7$var$LAYOUT_SECTION_SELECTOR = '[data-prosemirror-node-name="layoutSection"]';
const $498e920a7fe4ead7$var$LAYOUT_COLUMN_SELECTOR = '[data-prosemirror-node-name="layoutColumn"]';
// `layoutColumnExtendedHoverZone` is a DRAG_HANDLE_WIDTH-tall strip centred on the column's top edge.
const $498e920a7fe4ead7$var$LAYOUT_COLUMN_STRIP_REACH = (0, $gCPs3.DRAG_HANDLE_WIDTH) / 2;
const $498e920a7fe4ead7$var$isBlockElement = (element)=>element.getAttribute('data-prosemirror-node-block') === 'true';
const $498e920a7fe4ead7$var$getVisibleLeft = (block)=>(0, $4rYqB.getVisibleBox)(block, block.getAttribute('data-prosemirror-node-name') ?? '').getBoundingClientRect().left;
const $498e920a7fe4ead7$export$59655664ee13508e = (view, hoveredElement)=>{
    if (!(hoveredElement instanceof Element)) return false;
    const owner = hoveredElement.closest(`${$498e920a7fe4ead7$var$BLOCK_SELECTOR}, ${(0, $GIvev.BLOCK_CONTROLS_SURFACE_SELECTOR)}`);
    if (owner !== null && owner !== void 0 && owner.matches((0, $GIvev.BLOCK_CONTROLS_SURFACE_SELECTOR))) return false;
    if (owner && view.dom.contains(owner)) {
        if ($498e920a7fe4ead7$var$TABLE_STRUCTURE_NODES.has(owner.getAttribute('data-prosemirror-node-name') ?? '')) return false;
        const nodeType = view.state.schema.nodes[owner.getAttribute('data-prosemirror-node-name') ?? ''];
        return !(nodeType !== null && nodeType !== void 0 && nodeType.isTextblock) && !(nodeType !== null && nodeType !== void 0 && nodeType.isLeaf);
    }
    return view.dom.contains(hoveredElement) || hoveredElement.contains(view.dom);
};
const $498e920a7fe4ead7$var$getGutterWidths = ()=>({
        topLevel: (0, $014x6.akEditorGutterPaddingDynamic)(),
        narrowTopLevel: (0, $3NBIB.expValEqualsNoExposure)('platform_editor_preview_panel_responsiveness', 'isEnabled', true) ? (0, $014x6.akEditorGutterPaddingReduced) : undefined
    });
const $498e920a7fe4ead7$var$getTopLevelGutterWidth = (api, widths)=>{
    var _api$width;
    const editorWidth = api === null || api === void 0 || (_api$width = api.width) === null || _api$width === void 0 || (_api$width = _api$width.sharedState.currentState()) === null || _api$width === void 0 ? void 0 : _api$width.width;
    return widths.narrowTopLevel !== undefined && editorWidth !== undefined && editorWidth <= (0, $014x6.akEditorFullPageNarrowBreakout) ? widths.narrowTopLevel : widths.topLevel;
};
const $498e920a7fe4ead7$var$getEditorElementAt = (view, clientX, clientY)=>{
    const element = view.dom.ownerDocument.elementFromPoint(clientX, clientY);
    return element && element !== view.dom && view.dom.contains(element) ? element : null;
};
/** The outermost block around `element` that does not contain the pointer owns that gutter. */ const $498e920a7fe4ead7$var$findGutterOwner = (view, element, pointerTarget)=>{
    let owner = null;
    for(let current = element; current && current !== view.dom;){
        if ($498e920a7fe4ead7$var$isBlockElement(current) && !current.contains(pointerTarget) && // Layout columns have a top hover strip instead of a left gutter.
        current.getAttribute('data-prosemirror-node-name') !== 'layoutColumn') owner = current;
        current = current.parentElement;
    }
    return owner;
};
const $498e920a7fe4ead7$var$findBlockBesidePointer = (view, api, event, pointerTarget, widths)=>{
    const pointerBlock = pointerTarget.closest($498e920a7fe4ead7$var$BLOCK_SELECTOR);
    const gutterWidth = pointerBlock && view.dom.contains(pointerBlock) ? (0, $GIvev.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP) : $498e920a7fe4ead7$var$getTopLevelGutterWidth(api, widths);
    const sample = $498e920a7fe4ead7$var$getEditorElementAt(view, event.clientX + gutterWidth, event.clientY);
    const owner = sample && $498e920a7fe4ead7$var$findGutterOwner(view, sample, pointerTarget);
    if (!owner) return null;
    const left = $498e920a7fe4ead7$var$getVisibleLeft(owner);
    return event.clientX < left && left - event.clientX <= gutterWidth ? owner : null;
};
const $498e920a7fe4ead7$var$findColumnBelowPointer = (view, event, pointerTarget)=>{
    if (pointerTarget.closest($498e920a7fe4ead7$var$LAYOUT_COLUMN_SELECTOR) || pointerTarget !== view.dom && !pointerTarget.closest($498e920a7fe4ead7$var$LAYOUT_SECTION_SELECTOR)) return null;
    const sample = $498e920a7fe4ead7$var$getEditorElementAt(view, event.clientX, event.clientY + $498e920a7fe4ead7$var$LAYOUT_COLUMN_STRIP_REACH);
    const column = sample === null || sample === void 0 ? void 0 : sample.closest($498e920a7fe4ead7$var$LAYOUT_COLUMN_SELECTOR);
    return column && view.dom.contains(column) && event.clientY < column.getBoundingClientRect().top ? column : null;
};
const $498e920a7fe4ead7$export$94a2205718e00e69 = (view, api)=>{
    const widths = $498e920a7fe4ead7$var$getGutterWidths();
    return (event)=>{
        if (!(event.target instanceof Element)) return null;
        return $498e920a7fe4ead7$var$findBlockBesidePointer(view, api, event, event.target, widths) ?? (view.dom.contains(event.target) ? $498e920a7fe4ead7$var$findColumnBelowPointer(view, event, event.target) : null);
    };
};
/**
 * Leaving block controls does not count as reaching a new element: a nested block's drag handle
 * overhangs the block, so leaving the handle can put the pointer on the container with no block
 * beside it, and that exit must keep the controls on the block.
 */ const $498e920a7fe4ead7$var$isLeavingBlockControls = (event)=>event.relatedTarget instanceof Element && Boolean(event.relatedTarget.closest((0, $GIvev.BLOCK_CONTROLS_SURFACE_SELECTOR)));
const $498e920a7fe4ead7$var$classifyGutterHover = (view, findGutterBlock, { event: event, reachedNewElement: reachedNewElement })=>{
    const block = findGutterBlock(event);
    if (block) return {
        kind: 'block',
        element: block
    };
    const hoveredElement = event.target;
    if (reachedNewElement && hoveredElement instanceof Element && view.dom.contains(hoveredElement)) return {
        kind: 'container',
        element: hoveredElement
    };
    return {
        kind: 'none'
    };
};
/**
 * Runs `callback` once after the next frame renders (`requestAnimationFrame`, then `setTimeout`).
 * Layout is clean then, so reading positions never forces a synchronous layout. Calls made while a
 * run is already scheduled are ignored.
 */ const $498e920a7fe4ead7$var$createAfterRenderScheduler = (win, callback)=>{
    let frame;
    let timeout;
    return {
        schedule: ()=>{
            if (frame !== undefined || timeout !== undefined) return;
            frame = win.requestAnimationFrame(()=>{
                frame = undefined;
                timeout = win.setTimeout(()=>{
                    timeout = undefined;
                    callback();
                }, 0);
            });
        },
        cancel: ()=>{
            if (frame !== undefined) {
                win.cancelAnimationFrame(frame);
                frame = undefined;
            }
            if (timeout !== undefined) {
                win.clearTimeout(timeout);
                timeout = undefined;
            }
        }
    };
};
/**
 * Keeps interaction tracking in step with gutter hover, as the legacy hover zones did. They sat
 * inside the block tree, so hovering one cleared the typing state, counted as inside the editor even
 * where the zone reached past the content area, and put the pointer on the left side of the
 * right-side controls split.
 */ const $498e920a7fe4ead7$var$createInteractionTrackingSync = (view, api, contentArea)=>{
    // Set after gutter hover calls mouseEnter for a gutter outside the content area, so that leaving
    // that gutter calls mouseLeave.
    let isHoldingMouseEnter = false;
    return (event, isOverGutter)=>{
        var _api$blockControls$sh;
        const state = (0, $2MmgC.getInteractionTrackingState)(view.state);
        const rightSideControlsEnabled = api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.rightSideControlsEnabled;
        const side = rightSideControlsEnabled ? 'left' : undefined;
        if (isOverGutter && state !== null && state !== void 0 && state.isEditing) (0, $2mhhM.stopEditing)(view);
        if (event.target instanceof Node && contentArea !== null && contentArea !== void 0 && contentArea.contains(event.target)) isHoldingMouseEnter = false;
        else if (isOverGutter && state !== null && state !== void 0 && state.isMouseOut) {
            isHoldingMouseEnter = true;
            (0, $2mhhM.mouseEnter)(view, side);
            return;
        } else if (!isOverGutter && isHoldingMouseEnter) {
            isHoldingMouseEnter = false;
            (0, $9TG4a.handleMouseLeave)(view, rightSideControlsEnabled);
            return;
        }
        if (isOverGutter && side && (state === null || state === void 0 ? void 0 : state.hoverSide) !== side) (0, $2mhhM.setHoverSide)(view, side);
    };
};
const $498e920a7fe4ead7$export$11866942a98d0d67 = ({ api: api, view: view })=>{
    const win = view.dom.ownerDocument.defaultView;
    if (!win) return undefined;
    const contentArea = view.dom.closest('.ak-editor-content-area');
    // A wide block's gutter can sit outside the padded content area. Editors without a scroll
    // container or content area still get hover, over as much of the gutter as their wrapper covers.
    const eventArea = view.dom.closest('[data-editor-scroll-container="true"]') ?? contentArea ?? view.dom.parentElement ?? view.dom;
    const findGutterBlock = $498e920a7fe4ead7$export$94a2205718e00e69(view, api);
    const syncInteractionTracking = $498e920a7fe4ead7$var$createInteractionTrackingSync(view, api, contentArea);
    let pending;
    const handlePendingPointer = ()=>{
        const pointer = pending;
        pending = undefined;
        if (!pointer || (0, $cm2qP.isSparseHoverSuppressed)(view, api)) return;
        const hover = $498e920a7fe4ead7$var$classifyGutterHover(view, findGutterBlock, pointer);
        if (hover.kind !== 'none') (0, $cm2qP.handleSparseHoverTarget)(view, hover.element, api);
        syncInteractionTracking(pointer.event, hover.kind === 'block');
    };
    const scheduler = $498e920a7fe4ead7$var$createAfterRenderScheduler(win, handlePendingPointer);
    const queueGutterEvent = (event, reachedNewElement)=>{
        var _pending;
        pending = {
            event: event,
            reachedNewElement: Boolean((_pending = pending) === null || _pending === void 0 ? void 0 : _pending.reachedNewElement) || reachedNewElement
        };
        scheduler.schedule();
    };
    // Classified on every mouseover and reused while the pointer moves within that element, so
    // movement over text costs one comparison.
    let hovered;
    const classifyHoveredElement = (element)=>{
        hovered = {
            element: element,
            isPossibleGutter: $498e920a7fe4ead7$export$59655664ee13508e(view, element)
        };
        return hovered.isPossibleGutter;
    };
    const onMouseOver = (event)=>{
        if (classifyHoveredElement(event.target)) {
            queueGutterEvent(event, !$498e920a7fe4ead7$var$isLeavingBlockControls(event));
            return;
        }
        pending = undefined;
        const hoveredElement = event.target;
        if (hoveredElement instanceof Element && view.dom.contains(hoveredElement) && !(0, $cm2qP.isSparseHoverSuppressed)(view, api)) (0, $cm2qP.handleSparseHoverTarget)(view, hoveredElement, api);
    };
    const onMouseMove = (event)=>{
        var _hovered;
        const isPossibleGutter = ((_hovered = hovered) === null || _hovered === void 0 ? void 0 : _hovered.element) === event.target ? hovered.isPossibleGutter : classifyHoveredElement(event.target);
        if (isPossibleGutter) queueGutterEvent(event, false);
    };
    const bindMouseListener = (type, listener)=>(0, $6Zi52.bind)(eventArea, {
            type: type,
            listener: (event)=>{
                if (event instanceof win.MouseEvent) listener(event);
            },
            options: {
                passive: true
            }
        });
    let unbindMouseOver;
    let unbindMouseMove;
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_cls_fix')) {
        // Match the legacy ignoreRestingPointerHover guard until the pointer first moves.
        let pointerHasMoved = false;
        unbindMouseOver = bindMouseListener('mouseover', (event)=>{
            if (!pointerHasMoved) return;
            onMouseOver(event);
        });
        unbindMouseMove = bindMouseListener('mousemove', (event)=>{
            if (!pointerHasMoved) {
                pointerHasMoved = true;
                onMouseOver(event);
            }
            onMouseMove(event);
        });
    } else {
        unbindMouseOver = bindMouseListener('mouseover', onMouseOver);
        unbindMouseMove = bindMouseListener('mousemove', onMouseMove);
    }
    return ()=>{
        unbindMouseOver();
        unbindMouseMove();
        scheduler.cancel();
        pending = undefined;
    };
};

});
parcelRegister("cm2qP", function(module, exports) {
$parcel$export(module.exports, "isSparseHoverSuppressed", () => $8f3358069cdff900$export$f77a647c534e3261);
$parcel$export(module.exports, "handleSparseHoverTarget", () => $8f3358069cdff900$export$b1a748bfb2f57570);

var $2sOQK = parcelRequire("2sOQK");

var $dRkX9 = parcelRequire("dRkX9");

var $3NBIB = parcelRequire("3NBIB");

var $61p1X = parcelRequire("61p1X");
const $8f3358069cdff900$var$OPAQUE_BLOCKS = new Set([
    'bulletList',
    'orderedList',
    'taskList',
    'decisionList',
    'mediaSingle'
]);
const $8f3358069cdff900$var$EXCLUDED_BLOCKS = new Set([
    'listItem',
    'tableRow',
    'tableCell',
    'tableHeader',
    'caption'
]);
const $8f3358069cdff900$var$TABLE_CELLS = new Set([
    'tableCell',
    'tableHeader'
]);
const $8f3358069cdff900$var$isPanelNodeTypeName = (nodeTypeName)=>nodeTypeName === 'panel' || nodeTypeName === 'panel_c1' && (0, $3NBIB.expValEqualsNoExposure)('platform_editor_controls_reliable_anchor', 'isEnabled', true) && (0, $dRkX9.fg)('platform_editor_controls_reliable_anchor_patch_1');
const $8f3358069cdff900$var$redirectParagraphToWrappedMedia = (view, $target, targetPosition)=>{
    const node = view.state.doc.nodeAt(targetPosition);
    if (!node || node.type.name !== 'paragraph') return {
        position: targetPosition,
        node: node
    };
    const index = $target.index();
    for (const siblingIndex of [
        index - 1,
        index + 1
    ]){
        if (siblingIndex < 0 || siblingIndex >= $target.parent.childCount) continue;
        const sibling = $target.parent.child(siblingIndex);
        if ((sibling.type.name === 'mediaSingle' || sibling.type.name === 'embedCard') && (sibling.attrs.layout === 'wrap-left' || sibling.attrs.layout === 'wrap-right')) return {
            position: siblingIndex < index ? targetPosition - sibling.nodeSize : targetPosition + node.nodeSize,
            node: sibling
        };
    }
    return {
        position: targetPosition,
        node: node
    };
};
const $8f3358069cdff900$export$f77a647c534e3261 = (view, api)=>{
    var _api$limitedMode, _getNodeIdProvider, _api$typeAhead, _api$editorDisabled, _api$editorViewMode, _api$showDiff, _api$userIntent;
    if (api !== null && api !== void 0 && (_api$limitedMode = api.limitedMode) !== null && _api$limitedMode !== void 0 && (_api$limitedMode = _api$limitedMode.sharedState.currentState()) !== null && _api$limitedMode !== void 0 && _api$limitedMode.enabled || (_getNodeIdProvider = (0, $2sOQK.getNodeIdProvider)(view)) !== null && _getNodeIdProvider !== void 0 && _getNodeIdProvider.isLimitedMode()) return true;
    const controls = api === null || api === void 0 ? void 0 : api.blockControls.sharedState.currentState();
    if (controls !== null && controls !== void 0 && controls.isDragging || api !== null && api !== void 0 && (_api$typeAhead = api.typeAhead) !== null && _api$typeAhead !== void 0 && (_api$typeAhead = _api$typeAhead.sharedState.currentState()) !== null && _api$typeAhead !== void 0 && _api$typeAhead.isOpen) return true;
    const editorDisabled = (api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 || (_api$editorDisabled = _api$editorDisabled.sharedState.currentState()) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.editorDisabled) ?? false;
    const editorViewMode = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode;
    if (editorDisabled && (editorViewMode !== 'view' || !(controls !== null && controls !== void 0 && controls.rightSideControlsEnabled))) return true;
    const isDisplayingDiff = (api === null || api === void 0 || (_api$showDiff = api.showDiff) === null || _api$showDiff === void 0 || (_api$showDiff = _api$showDiff.sharedState.currentState()) === null || _api$showDiff === void 0 ? void 0 : _api$showDiff.isDisplayingChanges) ?? false;
    return isDisplayingDiff || (api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'reviewing';
};
const $8f3358069cdff900$export$b1a748bfb2f57570 = (view, target, api)=>{
    var _$pos$nodeAfter, _controls$activeNode;
    if (!api || target === view.dom) return false;
    const controls = api.blockControls.sharedState.currentState();
    let position;
    try {
        position = view.posAtDOM(target, 0);
    } catch  {
        return false;
    }
    const $pos = view.state.doc.resolve(position);
    let targetPosition;
    let opaque = false;
    for(let depth = 1; depth <= $pos.depth; depth++){
        const node = $pos.node(depth);
        if (!node.isBlock || $8f3358069cdff900$var$EXCLUDED_BLOCKS.has(node.type.name)) continue;
        // Legacy hover excludes direct cell children, but can target deeper blocks inside them.
        if (!$8f3358069cdff900$var$TABLE_CELLS.has($pos.node(depth - 1).type.name)) targetPosition = $pos.before(depth);
        if ($8f3358069cdff900$var$OPAQUE_BLOCKS.has(node.type.name)) {
            opaque = true;
            break;
        }
    }
    if (!opaque && (_$pos$nodeAfter = $pos.nodeAfter) !== null && _$pos$nodeAfter !== void 0 && _$pos$nodeAfter.isBlock && !$8f3358069cdff900$var$EXCLUDED_BLOCKS.has($pos.nodeAfter.type.name) && !$8f3358069cdff900$var$TABLE_CELLS.has($pos.parent.type.name)) {
        // Browser positions over non-editable node chrome can resolve to the first editable child.
        // Keep the ancestor unless that child actually owns the hovered DOM target.
        const nodeAfterDOM = view.nodeDOM(position);
        if (nodeAfterDOM instanceof Element && nodeAfterDOM.contains(target)) targetPosition = position;
    }
    if (targetPosition === undefined) return false;
    const initialNode = view.state.doc.nodeAt(targetPosition);
    if (!initialNode) return false;
    const redirected = $8f3358069cdff900$var$redirectParagraphToWrappedMedia(view, view.state.doc.resolve(targetPosition), targetPosition);
    targetPosition = redirected.position;
    const node = redirected.node;
    if (!node || (controls === null || controls === void 0 || (_controls$activeNode = controls.activeNode) === null || _controls$activeNode === void 0 ? void 0 : _controls$activeNode.pos) === targetPosition) return false;
    const $target = view.state.doc.resolve(targetPosition);
    if ($target.depth > 0 && (node.type.name === 'paragraph' || node.type.name === 'heading') && node.content.size === 0) return false;
    const parentNode = $target.parent;
    const parentPosition = $target.depth > 0 ? $target.before($target.depth) : undefined;
    const parentDOM = parentPosition === undefined ? undefined : view.nodeDOM(parentPosition);
    if ($8f3358069cdff900$var$isPanelNodeTypeName(parentNode.type.name) && !(parentDOM instanceof HTMLElement && parentDOM.classList.contains('ak-editor-panel__no-icon')) && $target.index() === 0) return false;
    const anchors = controls === null || controls === void 0 ? void 0 : controls.surfaceAnchors;
    const anchorName = (anchors === null || anchors === void 0 ? void 0 : anchors.get(targetPosition)) ?? api.core.actions.getAnchorIdForNode(node, targetPosition);
    const rootPos = $target.depth > 0 ? $target.before(1) : targetPosition;
    const rootNode = view.state.doc.nodeAt(rootPos);
    const rootAnchorName = (anchors === null || anchors === void 0 ? void 0 : anchors.get(rootPos)) ?? (rootNode ? api.core.actions.getAnchorIdForNode(rootNode, rootPos) : undefined);
    if (!anchorName || !rootNode) return false;
    api.core.actions.execute(api.blockControls.commands.showDragHandleAt(targetPosition, anchorName, (0, $61p1X.getNodeTypeWithLevel)(node), undefined, rootPos, rootAnchorName ?? anchorName, (0, $61p1X.getNodeTypeWithLevel)(rootNode)));
    return false;
};

});

parcelRegister("4rYqB", function(module, exports) {
$parcel$export(module.exports, "getVisibleBox", () => $be64c7511197d9aa$export$494bf19deecf4553);
// Matches the anchor selectors in `ui/global-styles.tsx`. A table's `.pm-table-resizer-container`
// wraps its cells too, so only a direct child `.resizer-item` is the table's own box, not the
// resizer of media inside a cell.
const $be64c7511197d9aa$var$VISIBLE_BOX_SELECTORS = {
    table: '.pm-table-resizer-container > .resizer-item',
    mediaSingle: '.resizer-item',
    embedCard: '.rich-media-item',
    extension: '.extension-container[data-layout]',
    bodiedExtension: '.extension-container[data-layout]',
    multiBodiedExtension: '.extension-container[data-layout]',
    blockCard: '.datasourceView-content-inner-wrap'
};
const $be64c7511197d9aa$export$494bf19deecf4553 = (dom, nodeType)=>{
    const selector = $be64c7511197d9aa$var$VISIBLE_BOX_SELECTORS[nodeType];
    return selector && dom.querySelector(selector) || dom;
};

});


parcelRegister("61og4", function(module, exports) {
$parcel$export(module.exports, "emptySparseSurfaceCandidateState", () => $61904552ad2ad743$export$1d5371bf2773f5c9);
$parcel$export(module.exports, "mapSparseSurfaceCandidates", () => $61904552ad2ad743$export$e9a3c245d64fdef4);
$parcel$export(module.exports, "reconcileSparseSurfaceCandidates", () => $61904552ad2ad743$export$41f4692a5297f434);

var $5qjas = parcelRequire("5qjas");

var $cajPh = parcelRequire("cajPh");

var $hy51U = parcelRequire("hy51U");

var $iIp3q = parcelRequire("iIp3q");

var $jk7a4 = parcelRequire("jk7a4");
const $61904552ad2ad743$var$NO_ACTIVE = 'none';
const $61904552ad2ad743$var$EMPTY_CANDIDATES = new Map();
const $61904552ad2ad743$var$EMPTY_POSITIONS = [];
const $61904552ad2ad743$var$EMPTY_PROTECTED_POSITIONS = [];
const $61904552ad2ad743$export$1d5371bf2773f5c9 = {
    activeRevision: $61904552ad2ad743$var$NO_ACTIVE,
    candidates: $61904552ad2ad743$var$EMPTY_CANDIDATES,
    positions: $61904552ad2ad743$var$EMPTY_POSITIONS,
    protectedPositions: $61904552ad2ad743$var$EMPTY_PROTECTED_POSITIONS,
    visiblePositions: $61904552ad2ad743$var$EMPTY_POSITIONS
};
const $61904552ad2ad743$var$getActiveRevision = (activeNode)=>activeNode ? [
        activeNode.pos,
        activeNode.nodeType,
        activeNode.rootPos ?? activeNode.pos,
        activeNode.rootNodeType ?? ''
    ].join(':') : $61904552ad2ad743$var$NO_ACTIVE;
const $61904552ad2ad743$var$isInRange = (position, range)=>position >= range.from && position <= range.to;
const $61904552ad2ad743$var$normalizeRange = (range, contentSize)=>({
        from: Math.max(0, Math.min(contentSize, Math.min(range.from, range.to))),
        to: Math.max(0, Math.min(contentSize, Math.max(range.from, range.to)))
    });
const $61904552ad2ad743$var$getSurfaces = (resolvedSurfaces)=>resolvedSurfaces.flatMap(({ childrenMap: childrenMap, components: components, root: root })=>root && (0, $jk7a4.hasSurfaceControls)(components) ? [
            {
                childrenMap: childrenMap,
                root: root
            }
        ] : []);
const $61904552ad2ad743$var$getNodeId = (node)=>{
    var _node$attrs;
    const localId = (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId;
    return typeof localId === 'string' ? localId : undefined;
};
const $61904552ad2ad743$var$sameCandidate = (first, second)=>(first === null || first === void 0 ? void 0 : first.id) === (second === null || second === void 0 ? void 0 : second.id) && (first === null || first === void 0 ? void 0 : first.contextRevision) === (second === null || second === void 0 ? void 0 : second.contextRevision) && (first === null || first === void 0 ? void 0 : first.isPersistent) === (second === null || second === void 0 ? void 0 : second.isPersistent) && (first === null || first === void 0 ? void 0 : first.nodeRef) === (second === null || second === void 0 ? void 0 : second.nodeRef) && (first === null || first === void 0 ? void 0 : first.nodeType) === (second === null || second === void 0 ? void 0 : second.nodeType) && (first === null || first === void 0 ? void 0 : first.nodeSize) === (second === null || second === void 0 ? void 0 : second.nodeSize) && (first === null || first === void 0 ? void 0 : first.pos) === (second === null || second === void 0 ? void 0 : second.pos) && (first === null || first === void 0 ? void 0 : first.renders) === (second === null || second === void 0 ? void 0 : second.renders);
const $61904552ad2ad743$var$sameCandidateMap = (first, second)=>{
    if (first.size !== second.size) return false;
    for (const [position, candidate] of first){
        if (!$61904552ad2ad743$var$sameCandidate(candidate, second.get(position))) return false;
    }
    return true;
};
const $61904552ad2ad743$var$samePositions = (first, second)=>first.length === second.length && first.every((position, index)=>position === second[index]);
const $61904552ad2ad743$var$normalizePositions = (positions)=>Array.from(new Set(positions)).sort((first, second)=>first - second);
const $61904552ad2ad743$var$mapPositions = (positions, tr)=>$61904552ad2ad743$var$normalizePositions(positions.map((position)=>tr.docChanged ? tr.mapping.mapResult(position, 1) : {
            deleted: false,
            pos: position
        }).filter((result)=>!result.deleted).map((result)=>result.pos));
const $61904552ad2ad743$var$createSurfaceContextAtPosition = (state, position, activeNode)=>{
    const blockControlsContext = (0, $iIp3q.createBlockControlsSurfaceContextForPosition)(state, position, activeNode);
    return blockControlsContext ? (0, $cajPh.createSurfaceContext)((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT), blockControlsContext) : undefined;
};
const $61904552ad2ad743$var$willAnySurfaceRenderAt = (surfaces, state, position, activeNode)=>{
    const surfaceContext = $61904552ad2ad743$var$createSurfaceContextAtPosition(state, position, activeNode);
    return surfaces.some(({ childrenMap: childrenMap, root: root })=>(0, $hy51U.willComponentRender)(root, childrenMap, surfaceContext));
};
const $61904552ad2ad743$var$addCandidateAt = ({ candidates: candidates, position: position, state: state, surfaces: surfaces, activeNode: activeNode })=>{
    const node = state.doc.nodeAt(position);
    if (!(node !== null && node !== void 0 && node.isBlock)) {
        candidates.delete(position);
        return;
    }
    const isPersistent = $61904552ad2ad743$var$willAnySurfaceRenderAt(surfaces, state, position, undefined);
    const renders = isPersistent || activeNode !== undefined && $61904552ad2ad743$var$willAnySurfaceRenderAt(surfaces, state, position, activeNode);
    candidates.set(position, {
        contextRevision: $61904552ad2ad743$var$getActiveRevision(activeNode),
        id: $61904552ad2ad743$var$getNodeId(node),
        isPersistent: isPersistent,
        nodeRef: node,
        nodeType: node.type.name,
        nodeSize: node.nodeSize,
        renders: renders,
        pos: position
    });
};
const $61904552ad2ad743$var$isInvalidated = (candidate, position, invalidation, changedRange)=>{
    var _invalidation$ids, _invalidation$positio, _invalidation$ranges;
    if (invalidation !== null && invalidation !== void 0 && invalidation.all) return true;
    if (invalidation !== null && invalidation !== void 0 && (_invalidation$ids = invalidation.ids) !== null && _invalidation$ids !== void 0 && _invalidation$ids.some((id)=>id === candidate.id)) return true;
    if (invalidation !== null && invalidation !== void 0 && (_invalidation$positio = invalidation.positions) !== null && _invalidation$positio !== void 0 && _invalidation$positio.includes(position)) return true;
    return Boolean(changedRange && $61904552ad2ad743$var$isInRange(position, changedRange) || (invalidation === null || invalidation === void 0 || (_invalidation$ranges = invalidation.ranges) === null || _invalidation$ranges === void 0 ? void 0 : _invalidation$ranges.some((range)=>$61904552ad2ad743$var$isInRange(position, range))));
};
const $61904552ad2ad743$var$getPositions = (candidates)=>Array.from(candidates.values()).filter((candidate)=>candidate.renders).map((candidate)=>candidate.pos).sort((first, second)=>first - second);
const $61904552ad2ad743$var$mapCandidates = (state, tr, retain)=>{
    const mapped = new Map();
    for (const candidate of state.candidates.values()){
        const result = tr.docChanged ? tr.mapping.mapResult(candidate.pos, 1) : {
            deleted: false,
            pos: candidate.pos
        };
        if (!result.deleted && retain(result.pos, candidate)) mapped.set(result.pos, result.pos === candidate.pos ? candidate : {
            ...candidate,
            pos: result.pos
        });
    }
    return mapped;
};
const $61904552ad2ad743$export$e9a3c245d64fdef4 = ({ newState: newState, previousState: previousState, tr: tr })=>{
    if (!tr.docChanged) return previousState;
    const candidates = new Map();
    for (const candidate of previousState.candidates.values()){
        const result = tr.mapping.mapResult(candidate.pos, 1);
        if (!result.deleted) candidates.set(result.pos, result.pos === candidate.pos ? candidate : {
            ...candidate,
            pos: result.pos
        });
    }
    const protectedPositions = $61904552ad2ad743$var$normalizePositions(previousState.protectedPositions.map((position)=>tr.mapping.mapResult(position, 1)).filter((result)=>!result.deleted).map((result)=>result.pos));
    const visiblePositions = $61904552ad2ad743$var$mapPositions(previousState.visiblePositions, tr);
    const positions = $61904552ad2ad743$var$getPositions(candidates);
    const candidatesUnchanged = $61904552ad2ad743$var$sameCandidateMap(previousState.candidates, candidates);
    const positionsUnchanged = $61904552ad2ad743$var$samePositions(previousState.positions, positions);
    const protectedUnchanged = $61904552ad2ad743$var$samePositions(previousState.protectedPositions, protectedPositions);
    if (candidatesUnchanged && positionsUnchanged && protectedUnchanged && $61904552ad2ad743$var$samePositions(previousState.visiblePositions, visiblePositions)) return previousState;
    return {
        ...previousState,
        candidates: candidatesUnchanged ? previousState.candidates : candidates,
        positions: positionsUnchanged ? previousState.positions : positions,
        protectedPositions: protectedUnchanged ? previousState.protectedPositions : protectedPositions,
        visiblePositions: visiblePositions
    };
};
const $61904552ad2ad743$export$41f4692a5297f434 = ({ activeNodesByPosition: activeNodesByPosition, activeNode: activeNode, changedRange: changedRange, documentChanged: documentChanged = false, invalidation: invalidation, newState: newState, protectedPositions: protectedPositions, resolvedSurfaces: resolvedSurfaces, state: state, visiblePositions: visiblePositions })=>$61904552ad2ad743$export$bf8449693ad9ef92({
        activeNode: activeNode,
        meta: {
            activeNodesByPosition: activeNodesByPosition,
            changedRange: changedRange,
            documentChanged: documentChanged,
            invalidation: invalidation,
            protectedPositions: protectedPositions,
            visiblePositions: visiblePositions
        },
        newState: newState,
        previousState: state,
        resolvedSurfaces: resolvedSurfaces,
        tr: newState.tr
    });
const $61904552ad2ad743$export$bf8449693ad9ef92 = ({ activeNode: activeNode, meta: meta, newState: newState, previousState: previousState, resolvedSurfaces: resolvedSurfaces, tr: tr })=>{
    const activeRevision = $61904552ad2ad743$var$getActiveRevision(activeNode);
    const activeChanged = activeRevision !== previousState.activeRevision;
    const hasVisiblePositionsUpdate = Boolean(meta && Object.prototype.hasOwnProperty.call(meta, 'visiblePositions'));
    const visiblePositions = hasVisiblePositionsUpdate ? $61904552ad2ad743$var$normalizePositions((meta === null || meta === void 0 ? void 0 : meta.visiblePositions) ?? $61904552ad2ad743$var$EMPTY_POSITIONS) : tr.docChanged ? $61904552ad2ad743$var$mapPositions(previousState.visiblePositions, tr) : previousState.visiblePositions;
    const visiblePositionsChanged = !$61904552ad2ad743$var$samePositions(visiblePositions, previousState.visiblePositions);
    const requestedProtectedPositions = $61904552ad2ad743$var$normalizePositions((meta === null || meta === void 0 ? void 0 : meta.protectedPositions) ?? previousState.protectedPositions);
    const protectedPositions = $61904552ad2ad743$var$samePositions(previousState.protectedPositions, requestedProtectedPositions) ? previousState.protectedPositions : requestedProtectedPositions;
    const protectedSet = new Set(protectedPositions);
    if (activeNode) {
        protectedSet.add(activeNode.pos);
        protectedSet.add(activeNode.rootPos ?? activeNode.pos);
    }
    const visibleSet = new Set(visiblePositions);
    const retain = (position, candidate)=>((candidate === null || candidate === void 0 ? void 0 : candidate.isPersistent) || protectedSet.has(position) || visibleSet.has(position)) && position >= 0 && position <= newState.doc.content.size;
    const surfaces = $61904552ad2ad743$var$getSurfaces(resolvedSurfaces);
    const activeNodeAt = (position)=>{
        var _meta$activeNodesByPo;
        return (meta === null || meta === void 0 || (_meta$activeNodesByPo = meta.activeNodesByPosition) === null || _meta$activeNodesByPo === void 0 ? void 0 : _meta$activeNodesByPo.get(position)) ?? activeNode ?? undefined;
    };
    const changedRange = meta !== null && meta !== void 0 && meta.changedRange ? $61904552ad2ad743$var$normalizeRange(meta.changedRange, newState.doc.content.size) : undefined;
    const invalidation = meta === null || meta === void 0 ? void 0 : meta.invalidation;
    const documentChanged = (meta === null || meta === void 0 ? void 0 : meta.documentChanged) ?? tr.docChanged;
    const previousCandidates = $61904552ad2ad743$var$mapCandidates(previousState, tr, retain);
    const dirty = (candidate, position)=>{
        const currentNode = newState.doc.nodeAt(position);
        const currentContextRevision = $61904552ad2ad743$var$getActiveRevision(activeNodeAt(position));
        return activeChanged || candidate.contextRevision !== currentContextRevision || candidate.nodeRef !== currentNode || $61904552ad2ad743$var$isInvalidated(candidate, position, invalidation, changedRange);
    };
    if (surfaces.length === 0) {
        const noCandidates = previousCandidates.size === 0;
        if (noCandidates && previousState.positions.length === 0 && $61904552ad2ad743$var$samePositions(visiblePositions, previousState.visiblePositions) && activeRevision === previousState.activeRevision && protectedPositions === previousState.protectedPositions) return previousState;
        return {
            activeRevision: activeRevision,
            candidates: noCandidates ? previousState.candidates : $61904552ad2ad743$var$EMPTY_CANDIDATES,
            positions: $61904552ad2ad743$var$EMPTY_POSITIONS,
            protectedPositions: protectedPositions,
            visiblePositions: visiblePositions
        };
    }
    for (const [position, candidate] of previousCandidates)if (dirty(candidate, position)) {
        $61904552ad2ad743$var$addCandidateAt({
            candidates: previousCandidates,
            position: position,
            state: newState,
            surfaces: surfaces,
            activeNode: activeNodeAt(position)
        });
        const updatedCandidate = previousCandidates.get(position);
        if (updatedCandidate && !retain(position, updatedCandidate)) previousCandidates.delete(position);
    }
    // IO supplies exact visible positions. Iterate those positions directly so a long visible
    // container cannot cause a traversal of its entire nested document.
    if (visiblePositionsChanged || documentChanged || invalidation !== null && invalidation !== void 0 && invalidation.all || changedRange) {
        for (const position of visiblePositions)if (!previousCandidates.has(position)) $61904552ad2ad743$var$addCandidateAt({
            candidates: previousCandidates,
            position: position,
            state: newState,
            surfaces: surfaces,
            activeNode: activeNodeAt(position)
        });
    }
    const directPositions = new Set([
        ...protectedSet,
        ...(invalidation === null || invalidation === void 0 ? void 0 : invalidation.positions) ?? []
    ]);
    for (const position of directPositions)if (retain(position) && !previousCandidates.has(position)) $61904552ad2ad743$var$addCandidateAt({
        candidates: previousCandidates,
        position: position,
        state: newState,
        surfaces: surfaces,
        activeNode: activeNodeAt(position)
    });
    const positions = $61904552ad2ad743$var$getPositions(previousCandidates);
    if ($61904552ad2ad743$var$sameCandidateMap(previousState.candidates, previousCandidates) && $61904552ad2ad743$var$samePositions(previousState.positions, positions) && $61904552ad2ad743$var$samePositions(previousState.visiblePositions, visiblePositions) && activeRevision === previousState.activeRevision && protectedPositions === previousState.protectedPositions) return previousState;
    return {
        activeRevision: activeRevision,
        candidates: $61904552ad2ad743$var$sameCandidateMap(previousState.candidates, previousCandidates) ? previousState.candidates : previousCandidates,
        positions: $61904552ad2ad743$var$samePositions(previousState.positions, positions) ? previousState.positions : positions,
        protectedPositions: protectedPositions,
        visiblePositions: visiblePositions
    };
};

});
parcelRegister("iIp3q", function(module, exports) {
$parcel$export(module.exports, "getBlockControlsSurfaceControlSide", () => $dcce9ee5141c8bd2$export$8b0a29773089448c);
$parcel$export(module.exports, "createBlockControlsSurfaceContextForPosition", () => $dcce9ee5141c8bd2$export$4f1661252fe88f52);
const $dcce9ee5141c8bd2$export$8b0a29773089448c = (context, reliableAnchorEnabled)=>(context === null || context === void 0 ? void 0 : context.targetNode.type.name) === 'layoutColumn' || Boolean(context) && reliableAnchorEnabled && (context === null || context === void 0 ? void 0 : context.targetNode.parentType) !== 'doc' ? undefined : 'left';
const $dcce9ee5141c8bd2$var$getNodeContext = (state, pos)=>{
    const node = state.doc.nodeAt(pos);
    if (!node) return undefined;
    const $pos = state.doc.resolve(pos);
    const ancestors = [];
    for(let depth = 0; depth <= $pos.depth; depth++){
        const ancestor = $pos.node(depth);
        ancestors.push({
            depth: depth,
            pos: depth === 0 ? 0 : $pos.before(depth),
            type: {
                name: ancestor.type.name
            }
        });
    }
    return {
        ancestors: ancestors,
        depth: $pos.depth + 1,
        node: node,
        parentType: $pos.parent.type.name,
        pos: pos,
        type: {
            name: node.type.name
        }
    };
};
const $dcce9ee5141c8bd2$export$4f1661252fe88f52 = (state, targetPos, activeNode)=>{
    const targetNodeContext = $dcce9ee5141c8bd2$var$getNodeContext(state, targetPos);
    if (!targetNodeContext) return undefined;
    const activeNodeContext = activeNode ? $dcce9ee5141c8bd2$var$getNodeContext(state, activeNode.pos) : undefined;
    const rootPos = activeNode ? activeNode.rootPos ?? activeNode.pos : targetPos;
    const rootNodeContext = $dcce9ee5141c8bd2$var$getNodeContext(state, rootPos) ?? targetNodeContext;
    return {
        activeControlKey: activeNode === null || activeNode === void 0 ? void 0 : activeNode.controlKey,
        activeNode: activeNode && activeNodeContext ? {
            ...activeNodeContext,
            rootPos: rootPos,
            rootType: {
                name: activeNode.rootNodeType ?? rootNodeContext.type.name
            }
        } : undefined,
        rootNode: rootNodeContext,
        targetNode: targetNodeContext
    };
};
const $dcce9ee5141c8bd2$export$f8fa93bfcf9e5778 = (view, activeNode, target = 'root')=>{
    if (!activeNode) return undefined;
    const rootPos = activeNode.rootPos ?? activeNode.pos;
    return $dcce9ee5141c8bd2$export$4f1661252fe88f52(view.state, target === 'active' ? activeNode.pos : rootPos, activeNode);
};

});

parcelRegister("jk7a4", function(module, exports) {
$parcel$export(module.exports, "hasSurfaceControls", () => $cc012d254498868b$export$ba2ce54b2062db21);
const $cc012d254498868b$export$ba2ce54b2062db21 = (components)=>components.some((component)=>Boolean(component.component) || component.type === 'button' || component.type === 'menu' || component.type === 'menu-item' || component.type === 'nested-menu');

});


parcelRegister("9VSvv", function(module, exports) {
$parcel$export(module.exports, "observeSurfaceViewport", () => $90c391939c7bdf92$export$c4377b7ce17e217c);
const $90c391939c7bdf92$var$NODE_NAME_ATTRIBUTE = 'data-prosemirror-node-name';
const $90c391939c7bdf92$export$c4377b7ce17e217c = (view, onChange)=>{
    const win = view.dom.ownerDocument.defaultView;
    if (!win || typeof win.IntersectionObserver === 'undefined') return {
        update: ()=>{},
        destroy: ()=>{}
    };
    const targets = new Map();
    const visibleTargets = new Set();
    let previousPositions = [];
    let previousDoc = view.state.doc;
    let destroyed = false;
    const resolvePosition = (element)=>{
        try {
            const domPosition = view.posAtDOM(element, 0);
            const nodeName = element.getAttribute($90c391939c7bdf92$var$NODE_NAME_ATTRIBUTE);
            const directNode = view.state.doc.nodeAt(domPosition);
            if (directNode !== null && directNode !== void 0 && directNode.isBlock && directNode.type.name === nodeName && view.nodeDOM(domPosition) === element) return domPosition;
            const $position = view.state.doc.resolve(domPosition);
            for(let depth = $position.depth; depth > 0; depth--){
                const node = $position.node(depth);
                if (!node.isBlock || node.type.name !== nodeName) continue;
                const position = $position.before(depth);
                const nodeDOM = view.nodeDOM(position);
                if (nodeDOM === element || nodeDOM instanceof Node && (nodeDOM.contains(element) || element.contains(nodeDOM))) return position;
            }
            return undefined;
        } catch  {
            return undefined;
        }
    };
    const getVisiblePositions = ()=>{
        const positions = new Set();
        visibleTargets.forEach((element)=>{
            var _targets$get;
            const position = (_targets$get = targets.get(element)) === null || _targets$get === void 0 ? void 0 : _targets$get.position;
            if (position !== undefined) positions.add(position);
        });
        return Array.from(positions).sort((first, second)=>first - second);
    };
    const emit = ()=>{
        if (destroyed) return;
        const positions = getVisiblePositions();
        if (positions.length !== previousPositions.length || positions.some((position, index)=>position !== previousPositions[index])) {
            previousPositions = positions;
            onChange(positions);
        }
    };
    const intersectionObserver = new win.IntersectionObserver((entries)=>{
        let changed = false;
        for (const entry of entries){
            const element = entry.target;
            const target = targets.get(element);
            if (!target || !view.dom.contains(element)) continue;
            const isIntersecting = entry.isIntersecting;
            if (target.isIntersecting !== isIntersecting) {
                target.isIntersecting = isIntersecting;
                if (isIntersecting) {
                    target.position = resolvePosition(element);
                    if (target.position !== undefined) visibleTargets.add(element);
                    else target.isIntersecting = false;
                } else visibleTargets.delete(element);
                changed = true;
            }
        }
        if (changed) emit();
    }, {
        root: null,
        threshold: 0
    });
    const removeTarget = (element)=>{
        const target = targets.get(element);
        if (!target) return;
        targets.delete(element);
        visibleTargets.delete(element);
        intersectionObserver.unobserve(element);
    };
    const observeElement = (element)=>{
        var _view$state$schema$no;
        const nodeName = element.getAttribute($90c391939c7bdf92$var$NODE_NAME_ATTRIBUTE);
        if (element === view.dom || !nodeName || !((_view$state$schema$no = view.state.schema.nodes[nodeName]) !== null && _view$state$schema$no !== void 0 && _view$state$schema$no.isBlock) || !view.dom.contains(element)) return;
        if (targets.has(element)) return;
        targets.set(element, {
            isIntersecting: false
        });
        intersectionObserver.observe(element);
    };
    const observeSubtree = (node)=>{
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const element = node;
        observeElement(element);
        const descendants = element.querySelectorAll(`[${$90c391939c7bdf92$var$NODE_NAME_ATTRIBUTE}]`);
        for(let index = 0; index < descendants.length; index++)observeElement(descendants[index]);
    };
    const unobserveSubtree = (node)=>{
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        const element = node;
        removeTarget(element);
        const descendants = element.querySelectorAll(`[${$90c391939c7bdf92$var$NODE_NAME_ATTRIBUTE}]`);
        for(let index = 0; index < descendants.length; index++)removeTarget(descendants[index]);
    };
    const mutationObserver = new win.MutationObserver((records)=>{
        let removedVisibleTarget = false;
        for (const record of records){
            for(let index = 0; index < record.removedNodes.length; index++){
                const node = record.removedNodes[index];
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if (view.dom.contains(node)) continue;
                    const before = visibleTargets.size;
                    unobserveSubtree(node);
                    removedVisibleTarget || (removedVisibleTarget = before !== visibleTargets.size);
                }
            }
            for(let index = 0; index < record.addedNodes.length; index++)observeSubtree(record.addedNodes[index]);
        }
        if (removedVisibleTarget) emit();
    });
    const initialTargets = view.dom.querySelectorAll(`[${$90c391939c7bdf92$var$NODE_NAME_ATTRIBUTE}]`);
    for(let index = 0; index < initialTargets.length; index++)observeElement(initialTargets[index]);
    mutationObserver.observe(view.dom, {
        childList: true,
        subtree: true
    });
    return {
        update () {
            if (previousDoc !== view.state.doc) {
                previousDoc = view.state.doc;
                visibleTargets.forEach((element)=>{
                    const target = targets.get(element);
                    if (target) target.position = resolvePosition(element);
                });
                emit();
            }
        },
        destroy () {
            destroyed = true;
            mutationObserver.disconnect();
            intersectionObserver.disconnect();
            targets.clear();
            visibleTargets.clear();
        }
    };
};

});

parcelRegister("7pLRV", function(module, exports) {
$parcel$export(module.exports, "getBlockControlsSurfaceTargets", () => $8946143f0fe77ce5$export$b0cbe0136ad0edbb);
const $8946143f0fe77ce5$export$b0cbe0136ad0edbb = (activeNode, storedPositions)=>{
    const targetsByPosition = new Map();
    for (const position of storedPositions)targetsByPosition.set(position, {
        position: position,
        source: 'stored'
    });
    if (activeNode) {
        const rootPosition = activeNode.rootPos ?? activeNode.pos;
        targetsByPosition.set(rootPosition, {
            position: rootPosition,
            source: 'root'
        });
        if (activeNode.pos !== rootPosition) targetsByPosition.set(activeNode.pos, {
            position: activeNode.pos,
            source: 'active'
        });
    }
    return Array.from(targetsByPosition.values()).sort((first, second)=>first.position - second.position);
};

});

parcelRegister("gl33i", function(module, exports) {
$parcel$export(module.exports, "createSurfaceDescriptorResolver", () => $0b186e9018356493$export$6faadbc5f4aa827d);

var $5qjas = parcelRequire("5qjas");

var $cajPh = parcelRequire("cajPh");

var $2Z44q = parcelRequire("2Z44q");

var $iIp3q = parcelRequire("iIp3q");

var $jYKQB = parcelRequire("jYKQB");
/**
 * Resolves each target into the controls, context and anchor information needed to render a surface.
 * When a previous descriptor still matches, reuse it without rerunning component visibility
 * predicates. The caller must omit `previous` when registry or external state changes invalidate
 * those results. Targets without an anchor, a valid context or renderable components are omitted.
 */ const $0b186e9018356493$var$createDescriptors = ({ activeNode: activeNode, components: components, state: state, surfaceActiveNodes: surfaceActiveNodes, surfaceAnchors: surfaceAnchors, targets: targets }, resolveComponents, previous)=>targets.flatMap((target)=>{
        const anchorName = surfaceAnchors.get(target.position);
        if (!anchorName) return [];
        const context = (0, $iIp3q.createBlockControlsSurfaceContextForPosition)(state, target.position, (surfaceActiveNodes === null || surfaceActiveNodes === void 0 ? void 0 : surfaceActiveNodes.get(target.position)) ?? activeNode);
        if (!context) return [];
        const cached = previous === null || previous === void 0 ? void 0 : previous.get(anchorName);
        if (cached && cached.position === target.position && cached.source === target.source && (0, $jYKQB.areBlockControlsSurfaceContextsEqual)(cached.blockControlsContext, context)) return [
            cached
        ];
        const surfaceContext = (0, $cajPh.createSurfaceContext)((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT), context);
        const surfaceComponents = resolveComponents(components, surfaceContext);
        if (!surfaceComponents) return [];
        return [
            {
                ...target,
                anchorName: anchorName,
                blockControlsContext: context,
                isTopLevel: context.targetNode.parentType === 'doc',
                surfaceComponents: surfaceComponents,
                surfaceContext: surfaceContext
            }
        ];
    });
const $0b186e9018356493$export$6faadbc5f4aa827d = (side)=>{
    let descriptors = [];
    let components = [];
    return (input, invalidated)=>{
        const registryUnchanged = components.length === input.components.length && components.every((component, index)=>component === input.components[index]);
        const previous = !invalidated && registryUnchanged ? new Map(descriptors.map((descriptor)=>[
                descriptor.anchorName,
                descriptor
            ])) : undefined;
        const next = $0b186e9018356493$var$createDescriptors(input, side === 'left' ? (0, $2Z44q.getBlockControlsLeftSurfaceComponents) : (0, $2Z44q.getBlockControlsRightSurfaceComponents), previous);
        components = input.components;
        if (next.length !== descriptors.length || next.some((descriptor, index)=>descriptor !== descriptors[index])) descriptors = next;
        return descriptors;
    };
};

});
parcelRegister("2Z44q", function(module, exports) {
$parcel$export(module.exports, "BlockControlsVisibilityProvider", () => $ed7b907b78b13b5e$export$8dd25c8d0f5ed852);
$parcel$export(module.exports, "getBlockControlsLeftSurfaceComponents", () => $ed7b907b78b13b5e$export$95f4abc80abfba6);
$parcel$export(module.exports, "getBlockControlsRightSurfaceComponents", () => $ed7b907b78b13b5e$export$98af22c10f74589b);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $cajPh = parcelRequire("cajPh");

var $hy51U = parcelRequire("hy51U");

var $bcN2K = parcelRequire("bcN2K");

var $b7s2g = parcelRequire("b7s2g");

var $5wcYI = parcelRequire("5wcYI");
const $ed7b907b78b13b5e$var$BlockControlsVisibilityContext = /*#__PURE__*/ (0, $fc4bM.createContext)({
    shouldHideHoverControls: false,
    useCssStyles: false
});
const $ed7b907b78b13b5e$var$BlockControlItem = ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-editor-block-control-item": true,
        children: children
    });
const $ed7b907b78b13b5e$var$HoverBlockControlItem = ({ children: children })=>{
    const { shouldHideHoverControls: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $fc4bM.useContext)($ed7b907b78b13b5e$var$BlockControlsVisibilityContext);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($ed7b907b78b13b5e$var$BlockControlItem, {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5wcYI.VisibilityWrapper), {
            shouldHide: shouldHideHoverControls,
            useCssStyles: useCssStyles,
            children: children
        })
    });
};
const $ed7b907b78b13b5e$var$PersistentBlockControlItem = ({ children: children })=>{
    const { useCssStyles: useCssStyles } = (0, $fc4bM.useContext)($ed7b907b78b13b5e$var$BlockControlsVisibilityContext);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($ed7b907b78b13b5e$var$BlockControlItem, {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5wcYI.VisibilityWrapper), {
            shouldHide: false,
            useCssStyles: useCssStyles,
            children: children
        })
    });
};
const $ed7b907b78b13b5e$export$8dd25c8d0f5ed852 = ({ children: children, shouldHideHoverControls: shouldHideHoverControls, useCssStyles: useCssStyles })=>{
    const value = (0, $fc4bM.useMemo)(()=>({
            shouldHideHoverControls: shouldHideHoverControls,
            useCssStyles: useCssStyles
        }), [
        shouldHideHoverControls,
        useCssStyles
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($ed7b907b78b13b5e$var$BlockControlsVisibilityContext.Provider, {
        value: value,
        children: children
    });
};
const $ed7b907b78b13b5e$var$withoutVisibilityPredicate = (component)=>{
    const { isHidden: _isHidden, ...visibleComponent } = component;
    return visibleComponent;
};
const $ed7b907b78b13b5e$var$withControlVisibility = (surfaceContext, controlVisibility)=>{
    const context = surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    if (!context) return surfaceContext;
    const controlContext = (0, $cajPh.createSurfaceContext)((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT), {
        ...context,
        controlVisibility: new Map(controlVisibility)
    });
    return {
        get: (token)=>controlContext.get(token) ?? surfaceContext.get(token)
    };
};
/**
 * Replaces the shared surface group with one stable wrapper group per visible control. The wrappers
 * inherit each control's rank, so SurfaceRenderer keeps the registry order without re-evaluating
 * the controls' visibility predicates.
 */ const $ed7b907b78b13b5e$var$getBlockControlsSurfaceComponents = (components, { group: group, section: section, surface: surface }, surfaceContext)=>{
    const resolvedSurface = (0, $hy51U.resolveSurface)(components, surface);
    const groupIdentity = (0, $hy51U.getComponentIdentity)(group);
    const controls = resolvedSurface.childrenMap.get(groupIdentity) ?? [];
    const visibleControls = [];
    const controlVisibility = (0, $bcN2K.isExperimentEnabled)('platform_editor_remix_control_priority') ? new Map() : undefined;
    for (const control of controls){
        var _control$isHidden;
        const isHidden = ((_control$isHidden = control.isHidden) === null || _control$isHidden === void 0 ? void 0 : _control$isHidden.call(control, {
            surfaceContext: controlVisibility ? $ed7b907b78b13b5e$var$withControlVisibility(surfaceContext, controlVisibility) : surfaceContext
        })) ?? false;
        controlVisibility === null || controlVisibility === void 0 || controlVisibility.set(control.key, isHidden);
        if (!isHidden) visibleControls.push(control);
    }
    if (!resolvedSurface.root || visibleControls.length === 0) return undefined;
    const controlIdentities = new Set(controls.map((0, $hy51U.getComponentIdentity)));
    const visibleControlIdentities = new Set(visibleControls.map((0, $hy51U.getComponentIdentity)));
    const { persistentComponents: persistentComponents } = (0, $b7s2g.partitionComponentsByPersistence)(resolvedSurface.components.filter((component)=>{
        const identity = (0, $hy51U.getComponentIdentity)(component);
        return !controlIdentities.has(identity) || visibleControlIdentities.has(identity);
    }), surface, surfaceContext);
    const persistentIdentities = new Set(persistentComponents.map((0, $hy51U.getComponentIdentity)));
    const structuralComponents = resolvedSurface.components.filter((component)=>{
        const identity = (0, $hy51U.getComponentIdentity)(component);
        return identity !== groupIdentity && !controlIdentities.has(identity);
    }).map($ed7b907b78b13b5e$var$withoutVisibilityPredicate);
    const wrappedControls = visibleControls.flatMap((control)=>{
        var _control$parents;
        const identity = (0, $hy51U.getComponentIdentity)(control);
        const rank = ((_control$parents = control.parents) === null || _control$parents === void 0 || (_control$parents = _control$parents.find((parent)=>(0, $hy51U.getComponentIdentity)(parent) === groupIdentity)) === null || _control$parents === void 0 ? void 0 : _control$parents.rank) ?? 0;
        const wrapper = {
            component: persistentIdentities.has(identity) ? $ed7b907b78b13b5e$var$PersistentBlockControlItem : $ed7b907b78b13b5e$var$HoverBlockControlItem,
            key: `block-control-item:${identity}`,
            parents: [
                {
                    ...section,
                    rank: rank
                }
            ],
            type: 'group'
        };
        const visibleControl = {
            ...$ed7b907b78b13b5e$var$withoutVisibilityPredicate(control),
            parents: [
                {
                    key: wrapper.key,
                    rank: 0,
                    type: wrapper.type
                }
            ]
        };
        return [
            wrapper,
            visibleControl
        ];
    });
    return [
        ...structuralComponents,
        ...wrappedControls
    ];
};
const $ed7b907b78b13b5e$export$95f4abc80abfba6 = (components, surfaceContext)=>$ed7b907b78b13b5e$var$getBlockControlsSurfaceComponents(components, {
        group: (0, $5Amf8.BLOCK_CONTROLS_LEFT_GROUP),
        section: (0, $5Amf8.BLOCK_CONTROLS_LEFT_SECTION),
        surface: (0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE)
    }, surfaceContext);
const $ed7b907b78b13b5e$export$98af22c10f74589b = (components, surfaceContext)=>$ed7b907b78b13b5e$var$getBlockControlsSurfaceComponents(components, {
        group: (0, $5Amf8.BLOCK_CONTROLS_RIGHT_GROUP),
        section: (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SECTION),
        surface: (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE)
    }, surfaceContext);

});
parcelRegister("b7s2g", function(module, exports) {
$parcel$export(module.exports, "partitionComponentsByPersistence", () => $9b6d18fc0d8e12e7$export$2e1bb7d588e29ed3);

var $5qjas = parcelRequire("5qjas");

var $cajPh = parcelRequire("cajPh");

var $hy51U = parcelRequire("hy51U");
const $9b6d18fc0d8e12e7$export$2e1bb7d588e29ed3 = (components, surface, surfaceContext)=>{
    const { childrenMap: childrenMap, root: root, topLevelChildren: topLevelChildren } = (0, $hy51U.resolveSurface)(components, surface);
    if (!root || !topLevelChildren || topLevelChildren.length === 0) return {
        hoverOnlyComponents: [],
        persistentComponents: components
    };
    const context = surfaceContext === null || surfaceContext === void 0 ? void 0 : surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    const storedSurfaceContext = context ? (0, $cajPh.createSurfaceContext)((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT), {
        activeNode: undefined,
        rootNode: context.targetNode,
        targetNode: context.targetNode
    }) : undefined;
    const isLeaf = (component)=>{
        const children = childrenMap.get((0, $hy51U.getComponentIdentity)(component));
        return !children || children.length === 0;
    };
    const persistentComponents = [];
    const hoverOnlyComponents = [];
    for (const component of components){
        if (!isLeaf(component)) {
            persistentComponents.push(component);
            hoverOnlyComponents.push(component);
            continue;
        }
        if ((0, $hy51U.willComponentRender)(component, childrenMap, storedSurfaceContext)) persistentComponents.push(component);
        else hoverOnlyComponents.push(component);
    }
    return {
        hoverOnlyComponents: hoverOnlyComponents,
        persistentComponents: persistentComponents
    };
};

});


parcelRegister("jYKQB", function(module, exports) {
$parcel$export(module.exports, "areBlockControlsSurfaceContextsEqual", () => $710550544aa4e8b6$export$c049d34efaf35ee1);
/**
 * ProseMirror preserves immutable node objects for unchanged content, so node identity detects
 * content changes without a deep comparison. Position and ancestry must also match: an unchanged
 * node can move or gain a different parent, which changes the context supplied to its controls.
 * The ancestor comparison is O(depth); it never walks document children or reads DOM geometry.
 */ const $710550544aa4e8b6$var$areNodeContextsEqual = (a, b)=>{
    var _a$rootType, _b$rootType;
    return a === b || Boolean(a && b && a.node === b.node && a.pos === b.pos && a.depth === b.depth && a.parentType === b.parentType && a.type.name === b.type.name && a.rootPos === b.rootPos && ((_a$rootType = a.rootType) === null || _a$rootType === void 0 ? void 0 : _a$rootType.name) === ((_b$rootType = b.rootType) === null || _b$rootType === void 0 ? void 0 : _b$rootType.name) && a.ancestors.length === b.ancestors.length && a.ancestors.every((ancestor, index)=>{
        const other = b.ancestors[index];
        return ancestor.pos === other.pos && ancestor.depth === other.depth && ancestor.type.name === other.type.name;
    }));
};
const $710550544aa4e8b6$export$c049d34efaf35ee1 = (a, b)=>a.activeControlKey === b.activeControlKey && $710550544aa4e8b6$var$areNodeContextsEqual(a.targetNode, b.targetNode) && $710550544aa4e8b6$var$areNodeContextsEqual(a.rootNode, b.rootNode) && $710550544aa4e8b6$var$areNodeContextsEqual(a.activeNode, b.activeNode);

});


parcelRegister("kNNa3", function(module, exports) {
$parcel$export(module.exports, "getSurfaceLifecycle", () => $040a0e7aae6c802c$export$95e8cd5d6b700b20);
const $040a0e7aae6c802c$var$filterAvailable = (descriptors, available)=>descriptors.every((descriptor)=>available.has(descriptor.anchorName)) ? descriptors : descriptors.filter((descriptor)=>available.has(descriptor.anchorName));
const $040a0e7aae6c802c$var$areSameDescriptors = (a, b)=>a.length === b.length && a.every((descriptor, index)=>descriptor === b[index]);
class $040a0e7aae6c802c$export$20ebcdedbef70b17 {
    setOnCommit(onCommit) {
        this.onCommit = onCommit;
    }
    publish(snapshot, anchors) {
        var _this$published;
        if (((_this$published = this.published) === null || _this$published === void 0 ? void 0 : _this$published.left) === snapshot.left && this.published.right === snapshot.right && this.published.forceVisibleOnMouseOut === snapshot.forceVisibleOnMouseOut && this.publishedAnchors.size === anchors.size && [
            ...anchors.values()
        ].every((name)=>this.publishedAnchors.has(name))) return;
        this.publishedAnchors = new Set(anchors.values());
        const revision = ++this.revision;
        for (const name of anchors.values())this.lastUsedRevision.set(name, revision);
        this.published = {
            ...snapshot,
            revision: revision
        };
        this.updateSnapshot(true);
    }
    retainAnchors(doc, desired, previous) {
        const positions = new Set(desired.find().map((decoration)=>decoration.from));
        const retained = previous.find().filter((decoration)=>!positions.has(decoration.from) && this.isRetained(decoration.spec.anchorName));
        return retained.length ? desired.add(doc, retained) : desired;
    }
    /** Whether a reconcile would drop anchors that no committed or pending tree still uses. */ hasRetirableAnchors(decorations) {
        return decorations.find().some((decoration)=>!this.isRetained(decoration.spec.anchorName));
    }
    isRetained(name) {
        const revision = this.lastUsedRevision.get(name);
        // Keep the committed tree and every newer published tree until a later commit replaces them.
        return revision !== undefined && revision >= this.committedRevision;
    }
    /**
   * Records which anchors the browser can currently resolve. Removes surfaces for missing or
   * suppressed anchors from the snapshot synchronously, ahead of the next reconcile.
   */ updateAnchors(decorations, suppressed) {
        if (decorations === this.decorations && suppressed === this.suppressed) return;
        this.decorations = decorations;
        this.suppressed = suppressed;
        const names = new Set(decorations.find().map((decoration)=>decoration.spec.anchorName));
        this.availableAnchors = suppressed ? new Set() : names;
        for (const name of this.lastUsedRevision.keys())if (!names.has(name)) this.lastUsedRevision.delete(name);
        this.updateSnapshot(false);
    }
    /** Derives the snapshot React reads, replacing it only when the rendered surfaces change. */ updateSnapshot(published) {
        if (!this.published) return;
        const left = $040a0e7aae6c802c$var$filterAvailable(this.published.left, this.availableAnchors);
        const right = $040a0e7aae6c802c$var$filterAvailable(this.published.right, this.availableAnchors);
        if (!published && this.snapshot && $040a0e7aae6c802c$var$areSameDescriptors(left, this.snapshot.left) && $040a0e7aae6c802c$var$areSameDescriptors(right, this.snapshot.right)) return;
        this.snapshot = {
            ...this.published,
            left: left,
            right: right
        };
        this.listeners.forEach((listener)=>listener());
    }
    destroy() {
        this.availableAnchors = new Set();
        this.publishedAnchors.clear();
        this.lastUsedRevision.clear();
        this.onCommit = undefined;
        this.decorations = undefined;
        this.published = undefined;
        this.snapshot = undefined;
        this.listeners.forEach((listener)=>listener());
    }
    constructor(){
        this.committedRevision = 0;
        this.revision = 0;
        this.lastUsedRevision = new Map();
        this.listeners = new Set();
        this.availableAnchors = new Set();
        this.publishedAnchors = new Set();
        this.suppressed = false;
        this.getSnapshot = ()=>this.snapshot;
        this.subscribe = (listener)=>{
            this.listeners.add(listener);
            return ()=>this.listeners.delete(listener);
        };
        this.acknowledge = (revision)=>{
            var _this$published2, _this$onCommit;
            if (revision <= this.committedRevision || revision > (((_this$published2 = this.published) === null || _this$published2 === void 0 ? void 0 : _this$published2.revision) ?? 0)) return;
            this.committedRevision = revision;
            (_this$onCommit = this.onCommit) === null || _this$onCommit === void 0 || _this$onCommit.call(this);
        };
    }
}
const $040a0e7aae6c802c$var$lifecycles = new WeakMap();
const $040a0e7aae6c802c$export$95e8cd5d6b700b20 = (view)=>{
    let lifecycle = $040a0e7aae6c802c$var$lifecycles.get(view);
    if (!lifecycle) {
        lifecycle = new $040a0e7aae6c802c$export$20ebcdedbef70b17();
        $040a0e7aae6c802c$var$lifecycles.set(view, lifecycle);
    }
    return lifecycle;
};

});



parcelRegister("6eyQr", function(module, exports) {
$parcel$export(module.exports, "createInitialSparseSurfacesState", () => $92f23299934a744c$export$5adf3d3f9d6b07e7);
$parcel$export(module.exports, "applySparseSurfacesTransaction", () => $92f23299934a744c$export$3c564fcab2e336c4);

var $16ZMX = parcelRequire("16ZMX");

var $d5Oek = parcelRequire("d5Oek");
const $92f23299934a744c$export$5adf3d3f9d6b07e7 = (candidates)=>({
        activeNodesByPosition: new Map(),
        anchors: new Map(),
        candidates: candidates,
        decorations: (0, $16ZMX.DecorationSet).empty,
        documentChanged: false
    });
const $92f23299934a744c$var$isReconciliationCommit = (meta)=>(meta === null || meta === void 0 ? void 0 : meta.type) === 'commitReconciliation';
const $92f23299934a744c$var$commitReconciliation = (previous, meta)=>({
        ...previous,
        ...meta.reconciliation,
        documentChanged: false,
        invalidation: undefined
    });
const $92f23299934a744c$export$3c564fcab2e336c4 = (input)=>{
    if ($92f23299934a744c$var$isReconciliationCommit(input.meta)) return $92f23299934a744c$var$commitReconciliation(input.previous, input.meta);
    const pending = (0, $d5Oek.reducePendingState)({
        invalidation: input.invalidation,
        previous: input.previous,
        tr: input.tr
    });
    if ((0, $d5Oek.isUnchangedTransaction)({
        pending: pending,
        previous: input.previous,
        tr: input.tr
    })) return input.previous;
    return (0, $d5Oek.mapTransactionState)({
        newState: input.newState,
        pending: pending,
        previous: input.previous,
        tr: input.tr
    });
};

});
parcelRegister("d5Oek", function(module, exports) {
$parcel$export(module.exports, "reducePendingState", () => $1457adf13d329a02$export$64f447718bba8261);
$parcel$export(module.exports, "isUnchangedTransaction", () => $1457adf13d329a02$export$73db93f318abe217);
$parcel$export(module.exports, "mapTransactionState", () => $1457adf13d329a02$export$da547146f46337b6);

var $61og4 = parcelRequire("61og4");
const $1457adf13d329a02$var$mergeInvalidation = ({ current: current, incoming: incoming, tr: tr })=>{
    if (!current && !incoming) return undefined;
    if (!incoming && !tr.docChanged) return current;
    const ids = [
        ...(current === null || current === void 0 ? void 0 : current.ids) ?? [],
        ...(incoming === null || incoming === void 0 ? void 0 : incoming.ids) ?? []
    ];
    const positions = [
        ...((current === null || current === void 0 ? void 0 : current.positions) ?? []).map((position)=>tr.mapping.map(position, 1)),
        ...(incoming === null || incoming === void 0 ? void 0 : incoming.positions) ?? []
    ];
    const ranges = [
        ...((current === null || current === void 0 ? void 0 : current.ranges) ?? []).map(({ from: from, to: to })=>({
                from: tr.mapping.map(from, -1),
                to: tr.mapping.map(to, 1)
            })),
        ...(incoming === null || incoming === void 0 ? void 0 : incoming.ranges) ?? []
    ];
    return ids.length || positions.length || ranges.length ? {
        ids: ids,
        positions: positions,
        ranges: ranges
    } : undefined;
};
const $1457adf13d329a02$var$mapAnchors = (anchors, tr)=>{
    if (!tr.docChanged || anchors.size === 0) return anchors;
    let changed = false;
    const mappedAnchors = new Map();
    for (const [position, name] of anchors){
        const mapped = tr.mapping.mapResult(position, 1);
        if (!mapped.deleted) {
            mappedAnchors.set(mapped.pos, name);
            changed || (changed = mapped.pos !== position);
        } else changed = true;
    }
    return changed ? mappedAnchors : anchors;
};
const $1457adf13d329a02$export$64f447718bba8261 = ({ invalidation: invalidation, previous: previous, tr: tr })=>({
        invalidation: $1457adf13d329a02$var$mergeInvalidation({
            current: previous.invalidation,
            incoming: invalidation,
            tr: tr
        })
    });
const $1457adf13d329a02$export$73db93f318abe217 = ({ pending: pending, previous: previous, tr: tr })=>!tr.docChanged && pending.invalidation === previous.invalidation;
const $1457adf13d329a02$export$da547146f46337b6 = ({ newState: newState, pending: pending, previous: previous, tr: tr })=>({
        ...previous,
        anchors: $1457adf13d329a02$var$mapAnchors(previous.anchors, tr),
        candidates: tr.docChanged ? (0, $61og4.mapSparseSurfaceCandidates)({
            newState: newState,
            previousState: previous.candidates,
            tr: tr
        }) : previous.candidates,
        decorations: tr.docChanged ? previous.decorations.map(tr.mapping, tr.doc) : previous.decorations,
        documentChanged: previous.documentChanged || tr.docChanged,
        invalidation: pending.invalidation
    });

});



parcelRegister("bpuaH", function(module, exports) {
$parcel$export(module.exports, "CommittedBlockControlsSurfaces", () => $709409a566e9c87e$export$43d3d67ebe750d09);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $f9ezd = parcelRequire("f9ezd");

var $61p1X = parcelRequire("61p1X");

var $dRO13 = parcelRequire("dRO13");

var $94jZn = parcelRequire("94jZn");

var $1zv1U = parcelRequire("1zv1U");

var $kNNa3 = parcelRequire("kNNa3");

var $jn6Wy = parcelRequire("jn6Wy");
const $709409a566e9c87e$var$CommittedSurface = /*#__PURE__*/ (0, $fc4bM.memo)(({ api: api, descriptor: descriptor, side: side, forceVisibleOnMouseOut: forceVisibleOnMouseOut, measuredPlacement: measuredPlacement })=>{
    const { anchorName: anchorName, blockControlsContext: blockControlsContext, isTopLevel: isTopLevel } = descriptor;
    const nodeType = blockControlsContext.targetNode.type.name;
    const nodeTypeWithLevel = (0, $61p1X.getNodeTypeWithLevel)(blockControlsContext.targetNode.node);
    const layout = blockControlsContext.targetNode.node.attrs.layout;
    const parentNodeType = blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType;
    const anchoredPlacement = (0, $fc4bM.useMemo)(()=>{
        if (!(0, $f9ezd.isCSSAnchorSupported)()) return undefined;
        const options = {
            anchorName: anchorName,
            nodeType: nodeType,
            nodeTypeWithLevel: nodeTypeWithLevel,
            layout: layout,
            parentNodeType: parentNodeType,
            side: side
        };
        return side === 'left' && isTopLevel ? (0, $1zv1U.getAnchoredLeftGutterSurfacePlacement)(options) : (0, $1zv1U.getAnchoredSurfacePlacement)(options);
    }, [
        anchorName,
        nodeType,
        nodeTypeWithLevel,
        layout,
        parentNodeType,
        side,
        isTopLevel
    ]);
    const Surface = side === 'left' ? (0, $dRO13.BlockControlsLeftSurface) : (0, $94jZn.BlockControlsRightSurface);
    return /*#__PURE__*/ (0, $3LM7S.jsx)(Surface, {
        api: api,
        components: descriptor.surfaceComponents,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: anchoredPlacement ?? measuredPlacement,
        source: descriptor.source,
        surfaceContext: descriptor.surfaceContext
    });
});
const $709409a566e9c87e$export$43d3d67ebe750d09 = (props)=>{
    const lifecycle = (0, $kNNa3.getSurfaceLifecycle)(props.editorView);
    const snapshot = (0, $fc4bM.useSyncExternalStore)(lifecycle.subscribe, lifecycle.getSnapshot, ()=>undefined);
    const measuredPlacements = (0, $jn6Wy.useMeasuredSurfacePlacements)(props.editorView, snapshot === null || snapshot === void 0 ? void 0 : snapshot.left, snapshot === null || snapshot === void 0 ? void 0 : snapshot.right);
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (snapshot) lifecycle.acknowledge(snapshot.revision);
    }, [
        lifecycle,
        snapshot
    ]);
    if (!snapshot) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: [
            'left',
            'right'
        ].flatMap((side)=>snapshot[side].map((descriptor)=>/*#__PURE__*/ (0, $3LM7S.jsx)($709409a566e9c87e$var$CommittedSurface, {
                    api: props.api,
                    descriptor: descriptor,
                    side: side,
                    forceVisibleOnMouseOut: snapshot.forceVisibleOnMouseOut,
                    measuredPlacement: measuredPlacements.get((0, $jn6Wy.getSurfaceKey)(side, descriptor))
                }, (0, $jn6Wy.getSurfaceKey)(side, descriptor))))
    });
};

});
parcelRegister("dRO13", function(module, exports) {
$parcel$export(module.exports, "BlockControlsLeftSurface", () => $6d696a86d43f80fe$export$30145a712ffbbca);
/* block-controls-left-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $kXdsr = parcelRequire("kXdsr");

var $bcN2K = parcelRequire("bcN2K");

var $9jAlP = parcelRequire("9jAlP");

var $2Z44q = parcelRequire("2Z44q");

var $iIp3q = parcelRequire("iIp3q");

var $5wcYI = parcelRequire("5wcYI");
const $6d696a86d43f80fe$var$leftSurfaceHiddenWrapperStyles = null;
const $6d696a86d43f80fe$var$leftSurfaceOuterStyles = null;
const $6d696a86d43f80fe$var$leftSurfaceGutterStyles = {
    container: "_1f38ffwv _7cca15wb _lcxvglyw",
    row: "_1bahesu3 _lcxvglyw _w1y61wug _19vrglyw"
};
// Nested surfaces (e.g. a table inside an expand) can span the target node's full height and sit
// over controls rendered in the node's own gutter, such as the table row insert button. Let pointer
// events pass through the wrapper and row so those controls stay interactive, matching the top-level
// gutter behaviour without applying its container query sizing.
const $6d696a86d43f80fe$var$nestedSurfacePointerEventsStyles = {
    container: "_lcxvglyw",
    row: "_lcxvglyw _w1y61wug"
};
const $6d696a86d43f80fe$var$leftSurfaceRowStyles = null;
// Applied in addition to leftSurfaceRowStyles when the target node is sticky-eligible (e.g. long
// tables): the outer wrapper spans the node's full height (see `placement.height`), so the content
// can stick near the top of the viewport instead of scrolling off with the node's top edge.
// Keep in sync with STICKY_CONTROLS_TOP_MARGIN in ./consts (must be a static literal here).
const $6d696a86d43f80fe$var$leftSurfaceStickyStyles = null;
// Keep in sync with STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER in ./consts (must be a static literal here)
const $6d696a86d43f80fe$var$leftSurfaceStickyTableHeaderStyles = null;
const $6d696a86d43f80fe$var$BlockControlsLeftSurfaceContent = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    const blockControlsContext = surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    const controlSide = (0, $iIp3q.getBlockControlsSurfaceControlSide)(blockControlsContext, (0, $bcN2K.isExperimentEnabled)('platform_editor_controls_reliable_anchor'));
    const { shouldHide: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $5wcYI.useBlockControlsVisibility)({
        api: api,
        controlSide: controlSide,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut
    });
    const isSticky = placement.isSticky;
    const isTopLevel = (blockControlsContext === null || blockControlsContext === void 0 ? void 0 : blockControlsContext.targetNode.parentType) === 'doc';
    const shouldPassThroughNestedPointerEvents = !isTopLevel && (0, $bcN2K.isExperimentEnabled)('platform_editor_nested_left_surface_pointer_fix');
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-editor-block-controls-surface": true,
        "data-editor-block-controls-side": "left",
        "data-testid": source === 'stored' ? 'block-controls-left-surface-stored' : source === 'active' ? 'block-controls-left-surface-active' : 'block-controls-left-surface',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Placement is resolved per target node, from its runtime DOM geometry or from its CSS anchor.
        style: placement.style,
        className: (0, $2R2iS.default)([
            "_kqswstnw _17c61i8t _1pbyb4wl",
            isTopLevel && $6d696a86d43f80fe$var$leftSurfaceGutterStyles.container,
            shouldPassThroughNestedPointerEvents && $6d696a86d43f80fe$var$nestedSurfacePointerEventsStyles.container
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                "_zulpv77o _4cvr1h6o _1e0c1txw",
                isTopLevel && $6d696a86d43f80fe$var$leftSurfaceGutterStyles.row,
                shouldPassThroughNestedPointerEvents && $6d696a86d43f80fe$var$nestedSurfacePointerEventsStyles.row,
                isSticky && "_kqsw1if8 _154iu2gc",
                isSticky && (blockControlsContext === null || blockControlsContext === void 0 ? void 0 : blockControlsContext.targetNode.type.name) === 'table' && (0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_sticky_header_fix') && "_154i1ejb"
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Z44q.BlockControlsVisibilityProvider), {
                shouldHideHoverControls: shouldHideHoverControls,
                useCssStyles: useCssStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kXdsr.SurfaceRenderer), {
                    components: components,
                    surface: (0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE),
                    surfaceContext: surfaceContext
                })
            })
        })
    });
};
const $6d696a86d43f80fe$var$BlockControlsLeftSurfaceWrapper = ({ children: children, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    const blockControlsContext = surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    const isSticky = placement.isSticky;
    const isTopLevel = (blockControlsContext === null || blockControlsContext === void 0 ? void 0 : blockControlsContext.targetNode.parentType) === 'doc';
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-editor-block-controls-surface": true,
        "data-editor-block-controls-side": "left",
        "data-testid": source === 'stored' ? 'block-controls-left-surface-stored' : source === 'active' ? 'block-controls-left-surface-active' : 'block-controls-left-surface',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Placement is resolved per target node, from its runtime DOM geometry or from its CSS anchor.
        style: placement.style,
        className: (0, $2R2iS.default)([
            "_kqswstnw _17c61i8t _1pbyb4wl",
            isTopLevel && $6d696a86d43f80fe$var$leftSurfaceGutterStyles.container,
            "_3um015vq"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                "_zulpv77o _4cvr1h6o _1e0c1txw",
                isTopLevel && $6d696a86d43f80fe$var$leftSurfaceGutterStyles.row,
                isSticky && "_kqsw1if8 _154iu2gc",
                isSticky && (blockControlsContext === null || blockControlsContext === void 0 ? void 0 : blockControlsContext.targetNode.type.name) === 'table' && (0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_sticky_header_fix') && "_154i1ejb"
            ]),
            children: children
        })
    });
};
const $6d696a86d43f80fe$export$30145a712ffbbca = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    if (!placement) return null;
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_cls_fix')) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9jAlP.BlockControlsSurfaceWithClsFix), {
        side: "left",
        SurfaceWrapper: $6d696a86d43f80fe$var$BlockControlsLeftSurfaceWrapper,
        api: api,
        components: components,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: placement,
        source: source,
        surfaceContext: surfaceContext
    });
    else return /*#__PURE__*/ (0, $3LM7S.jsx)($6d696a86d43f80fe$var$BlockControlsLeftSurfaceContent, {
        api: api,
        components: components,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: placement,
        source: source,
        surfaceContext: surfaceContext
    });
};

});
parcelRegister("9jAlP", function(module, exports) {
$parcel$export(module.exports, "BlockControlsSurfaceWithClsFix", () => $4f913f19ada6a3e4$export$eca51cefb0510c6e);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $kXdsr = parcelRequire("kXdsr");

var $bcN2K = parcelRequire("bcN2K");

var $2Z44q = parcelRequire("2Z44q");

var $iIp3q = parcelRequire("iIp3q");

var $5wcYI = parcelRequire("5wcYI");
const $4f913f19ada6a3e4$export$eca51cefb0510c6e = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, side: side, source: source, surfaceContext: surfaceContext, SurfaceWrapper: SurfaceWrapper })=>{
    const controlSide = side === 'left' ? (0, $iIp3q.getBlockControlsSurfaceControlSide)(surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT)), (0, $bcN2K.isExperimentEnabled)('platform_editor_controls_reliable_anchor')) : 'right';
    const { shouldHide: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $5wcYI.useBlockControlsVisibility)({
        api: api,
        controlSide: controlSide,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)(SurfaceWrapper, {
        placement: placement,
        source: source,
        surfaceContext: surfaceContext,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Z44q.BlockControlsVisibilityProvider), {
            shouldHideHoverControls: shouldHideHoverControls,
            useCssStyles: useCssStyles,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kXdsr.SurfaceRenderer), {
                components: components,
                surface: side === 'left' ? (0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE) : (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE),
                surfaceContext: surfaceContext
            })
        })
    });
};

});


parcelRegister("94jZn", function(module, exports) {
$parcel$export(module.exports, "BlockControlsRightSurface", () => $06b04936b17e9631$export$bab798c3f2a2fbbd);
/* block-controls-right-surface.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $kXdsr = parcelRequire("kXdsr");

var $bcN2K = parcelRequire("bcN2K");

var $9jAlP = parcelRequire("9jAlP");

var $2Z44q = parcelRequire("2Z44q");

var $5wcYI = parcelRequire("5wcYI");
const $06b04936b17e9631$var$rightSurfaceHiddenWrapperStyles = null;
const $06b04936b17e9631$var$rightSurfaceOuterStyles = null;
const $06b04936b17e9631$var$rightSurfaceRowStyles = null;
// Applied in addition to rightSurfaceRowStyles when the target node is sticky-eligible (e.g. long
// tables): the outer wrapper spans the node's full height (see `placement.height`), so the content
// can stick near the top of the viewport instead of scrolling off with the node's top edge.
// Keep in sync with STICKY_CONTROLS_TOP_MARGIN in ./consts (must be a static literal here).
const $06b04936b17e9631$var$rightSurfaceStickyStyles = null;
// Keep in sync with STICKY_CONTROLS_TOP_MARGIN_FOR_STICKY_HEADER in ./consts (must be a static literal here)
const $06b04936b17e9631$var$rightSurfaceStickyTableHeaderStyles = null;
const $06b04936b17e9631$var$BlockControlsRightSurfaceContent = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    const blockControlsContext = surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    const { shouldHide: shouldHideHoverControls, useCssStyles: useCssStyles } = (0, $5wcYI.useBlockControlsVisibility)({
        api: api,
        controlSide: 'right',
        forceVisibleOnMouseOut: forceVisibleOnMouseOut
    });
    const isSticky = placement.isSticky;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-editor-block-controls-surface": true,
        "data-editor-block-controls-side": "right",
        "data-testid": source === 'stored' ? 'block-controls-right-surface-stored' : source === 'active' ? 'block-controls-right-surface-active' : 'block-controls-right-surface',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Placement is resolved per target node, from its runtime DOM geometry or from its CSS anchor.
        style: placement.style,
        className: (0, $2R2iS.default)([
            "_kqswstnw _17c61i8t _1pbyb4wl"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                "_zulpv77o _4cvr1h6o _1e0c1txw",
                isSticky && "_kqsw1if8 _154iu2gc",
                isSticky && (blockControlsContext === null || blockControlsContext === void 0 ? void 0 : blockControlsContext.targetNode.type.name) === 'table' && (0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_sticky_header_fix') && "_154i1ejb"
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Z44q.BlockControlsVisibilityProvider), {
                shouldHideHoverControls: shouldHideHoverControls,
                useCssStyles: useCssStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kXdsr.SurfaceRenderer), {
                    components: components,
                    surface: (0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE),
                    surfaceContext: surfaceContext
                })
            })
        })
    });
};
const $06b04936b17e9631$var$BlockControlsRightSurfaceWrapper = ({ children: children, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    const blockControlsContext = surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    const isSticky = placement.isSticky;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-editor-block-controls-surface": true,
        "data-editor-block-controls-side": "right",
        "data-testid": source === 'stored' ? 'block-controls-right-surface-stored' : source === 'active' ? 'block-controls-right-surface-active' : 'block-controls-right-surface',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Placement is resolved per target node, from its runtime DOM geometry or from its CSS anchor.
        style: placement.style,
        className: (0, $2R2iS.default)([
            "_kqswstnw _17c61i8t _1pbyb4wl",
            "_3um015vq"
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            className: (0, $2R2iS.default)([
                "_zulpv77o _4cvr1h6o _1e0c1txw",
                isSticky && "_kqsw1if8 _154iu2gc",
                isSticky && (blockControlsContext === null || blockControlsContext === void 0 ? void 0 : blockControlsContext.targetNode.type.name) === 'table' && (0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_sticky_header_fix') && "_154i1ejb"
            ]),
            children: children
        })
    });
};
const $06b04936b17e9631$export$bab798c3f2a2fbbd = ({ api: api, components: components, forceVisibleOnMouseOut: forceVisibleOnMouseOut, placement: placement, source: source, surfaceContext: surfaceContext })=>{
    if (!placement) return null;
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_controls_cls_fix')) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9jAlP.BlockControlsSurfaceWithClsFix), {
        side: "right",
        SurfaceWrapper: $06b04936b17e9631$var$BlockControlsRightSurfaceWrapper,
        api: api,
        components: components,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: placement,
        source: source,
        surfaceContext: surfaceContext
    });
    else return /*#__PURE__*/ (0, $3LM7S.jsx)($06b04936b17e9631$var$BlockControlsRightSurfaceContent, {
        api: api,
        components: components,
        forceVisibleOnMouseOut: forceVisibleOnMouseOut,
        placement: placement,
        source: source,
        surfaceContext: surfaceContext
    });
};

});

parcelRegister("1zv1U", function(module, exports) {
$parcel$export(module.exports, "getAbsoluteSurfacePlacement", () => $efccf3af4c144858$export$919e5d0c3910bbe8);
$parcel$export(module.exports, "getSurfacePlacement", () => $efccf3af4c144858$export$90170883635d4723);
$parcel$export(module.exports, "getLeftGutterSurfacePlacement", () => $efccf3af4c144858$export$54a73b8249dd22f5);
$parcel$export(module.exports, "toMeasuredSurfaceWrapperPlacement", () => $efccf3af4c144858$export$bd91f529ff2fbab1);
$parcel$export(module.exports, "getAnchoredSurfacePlacement", () => $efccf3af4c144858$export$e4284299d90b52b0);
$parcel$export(module.exports, "getAnchoredLeftGutterSurfacePlacement", () => $efccf3af4c144858$export$e428c24bc880e76b);

var $iZXVC = parcelRequire("iZXVC");

var $GIvev = parcelRequire("GIvev");
const $efccf3af4c144858$export$919e5d0c3910bbe8 = ({ offsetParentRect: offsetParentRect, offsetParentScrollLeft: offsetParentScrollLeft, offsetParentScrollTop: offsetParentScrollTop, placement: placement })=>({
        ...placement,
        left: placement.left - ((offsetParentRect === null || offsetParentRect === void 0 ? void 0 : offsetParentRect.left) ?? 0) + offsetParentScrollLeft,
        top: placement.top - ((offsetParentRect === null || offsetParentRect === void 0 ? void 0 : offsetParentRect.top) ?? 0) + offsetParentScrollTop
    });
const $efccf3af4c144858$export$90170883635d4723 = ({ layout: layout, nodeRect: nodeRect, nodeType: nodeType, nodeTypeWithLevel: nodeTypeWithLevel, parentNodeType: parentNodeType, side: side })=>{
    if (nodeType === 'layoutColumn') // nodeRect.left + width/2 === nodeRect.right - width/2 — side-independent.
    return {
        left: nodeRect.left + nodeRect.width / 2,
        top: nodeRect.top,
        transform: 'translate(-50%, -50%)'
    };
    const gap = (0, $GIvev.dragHandleGap)(nodeType, parentNodeType);
    const top = nodeRect.top + (0, $GIvev.topPositionAdjustment)(nodeTypeWithLevel, layout);
    const height = (0, $iZXVC.shouldBeSticky)(nodeType) ? nodeRect.height : undefined;
    if (side === 'right') return {
        left: nodeRect.right + gap,
        top: top,
        transform: '',
        height: height
    };
    return {
        left: nodeRect.left,
        top: top,
        transform: `translateX(calc(-100% - ${gap}px))`,
        height: height
    };
};
const $efccf3af4c144858$export$54a73b8249dd22f5 = ({ leftGutterBoundary: leftGutterBoundary, ...options })=>{
    const placement = $efccf3af4c144858$export$90170883635d4723({
        ...options,
        side: 'left'
    });
    if (options.nodeType === 'layoutColumn') return placement;
    const gap = (0, $GIvev.dragHandleGap)(options.nodeType, options.parentNodeType);
    return {
        ...placement,
        left: leftGutterBoundary,
        transform: '',
        width: Math.max(0, options.nodeRect.left - leftGutterBoundary - gap)
    };
};
const $efccf3af4c144858$export$bd91f529ff2fbab1 = (placement)=>({
        isSticky: placement.height !== undefined,
        style: {
            height: placement.height,
            left: placement.left,
            top: placement.top,
            transform: placement.transform,
            ...placement.width !== undefined ? {
                width: placement.width
            } : {}
        }
    });
/**
 * Where a surface goes when its anchor stops resolving, as the fallback argument to the block-axis
 * `anchor()` calls below.
 *
 * An anchor is invalid once its element stops generating a box e.g. (`display: none`) / removed node
 * Currently, anchor fallback is not unstable with some of the position-visibility options, so here
 * we manually set a fallback of -9999 so that it will render offscreen out of the viewport
 * without causing extra overflows
 */ const $efccf3af4c144858$var$INVALID_ANCHOR_OFFSCREEN_PX = 9999;
const $efccf3af4c144858$var$INVALID_ANCHOR_FALLBACK_TOP = `-${$efccf3af4c144858$var$INVALID_ANCHOR_OFFSCREEN_PX}px`;
const $efccf3af4c144858$var$INVALID_ANCHOR_FALLBACK_BOTTOM = `${$efccf3af4c144858$var$INVALID_ANCHOR_OFFSCREEN_PX}px`;
const $efccf3af4c144858$export$e4284299d90b52b0 = ({ anchorName: anchorName, layout: layout, nodeType: nodeType, nodeTypeWithLevel: nodeTypeWithLevel, parentNodeType: parentNodeType, side: side })=>{
    if (nodeType === 'layoutColumn') // The column's horizontal midpoint, matching the measured `nodeRect.left + width / 2` and the
    // legacy drag handle's own layout-column formula. Side-independent.
    return {
        isSticky: false,
        style: {
            left: `calc((anchor(${anchorName} left) + anchor(${anchorName} right)) / 2)`,
            positionAnchor: anchorName,
            top: `anchor(${anchorName} top, ${$efccf3af4c144858$var$INVALID_ANCHOR_FALLBACK_TOP})`,
            transform: 'translate(-50%, -50%)'
        }
    };
    const gap = (0, $GIvev.dragHandleGap)(nodeType, parentNodeType);
    const isSticky = (0, $iZXVC.shouldBeSticky)(nodeType);
    return {
        isSticky: isSticky,
        style: {
            // A sticky wrapper is stretched with `bottom` instead of a measured `height`. Pairing it
            // with the adjusted `top` keeps the box ending exactly where the node does, however far
            // the top adjustment pushed the start down and however much the node later grows.
            ...isSticky ? {
                bottom: `anchor(${anchorName} bottom, ${$efccf3af4c144858$var$INVALID_ANCHOR_FALLBACK_BOTTOM})`
            } : {},
            left: side === 'right' ? `calc(anchor(${anchorName} right) + ${gap}px)` : `anchor(${anchorName} left)`,
            positionAnchor: anchorName,
            top: `calc(anchor(${anchorName} top, ${$efccf3af4c144858$var$INVALID_ANCHOR_FALLBACK_TOP}) + ${(0, $GIvev.topPositionAdjustment)(nodeTypeWithLevel, layout)}px)`,
            // The left side grows away from the node without knowing its own width, so it pulls itself
            // back past its own box and the gap. The right side grows into the margin, so the gap is
            // already folded into `left` above.
            transform: side === 'right' ? '' : `translateX(calc(-100% - ${gap}px))`
        }
    };
};
const $efccf3af4c144858$export$e428c24bc880e76b = (options)=>{
    const placement = $efccf3af4c144858$export$e4284299d90b52b0({
        ...options,
        side: 'left'
    });
    if (options.nodeType === 'layoutColumn') return placement;
    const gap = (0, $GIvev.dragHandleGap)(options.nodeType, options.parentNodeType);
    return {
        ...placement,
        style: {
            ...placement.style,
            left: 0,
            // In a `right` inset, `anchor(... left)` resolves from the containing block's right edge
            // to the anchor's left edge. Adding the gap ends this wrapper just before the node.
            right: `calc(anchor(${options.anchorName} left) + ${gap}px)`,
            transform: ''
        }
    };
};

});

parcelRegister("jn6Wy", function(module, exports) {
$parcel$export(module.exports, "getSurfaceKey", () => $5e26583df3d8a431$export$47e0287c6d47b6aa);
$parcel$export(module.exports, "useMeasuredSurfacePlacements", () => $5e26583df3d8a431$export$84250ab4f1991b49);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");

var $f9ezd = parcelRequire("f9ezd");

var $61p1X = parcelRequire("61p1X");

var $czQPU = parcelRequire("czQPU");

var $1zv1U = parcelRequire("1zv1U");
const $5e26583df3d8a431$var$EMPTY_PLACEMENTS = new Map();
const $5e26583df3d8a431$export$47e0287c6d47b6aa = (side, descriptor)=>`${side}:${descriptor.anchorName}`;
const $5e26583df3d8a431$export$84250ab4f1991b49 = (editorView, left, right)=>{
    const [placements, setPlacements] = (0, $fc4bM.useState)($5e26583df3d8a431$var$EMPTY_PLACEMENTS);
    const animationFrameRef = (0, $fc4bM.useRef)(undefined);
    (0, $fc4bM.useLayoutEffect)(()=>{
        var _getDocument;
        // Anchor support is fixed for the session, so anchored surfaces never set measured state.
        if ((0, $f9ezd.isCSSAnchorSupported)()) return;
        const descriptors = [
            ...(left ?? []).map((descriptor)=>({
                    descriptor: descriptor,
                    side: 'left'
                })),
            ...(right ?? []).map((descriptor)=>({
                    descriptor: descriptor,
                    side: 'right'
                }))
        ];
        if (descriptors.length === 0) {
            // Clear only when there is something to clear, so an empty map does not commit a render.
            setPlacements((previous)=>previous.size > 0 ? $5e26583df3d8a431$var$EMPTY_PLACEMENTS : previous);
            return;
        }
        const measurementTargets = descriptors.flatMap(({ descriptor: descriptor, side: side })=>{
            const { blockControlsContext: blockControlsContext } = descriptor;
            const targetNodeElement = editorView.nodeDOM(blockControlsContext.targetNode.pos);
            const targetElementRoot = targetNodeElement instanceof HTMLElement ? targetNodeElement : targetNodeElement === null || targetNodeElement === void 0 ? void 0 : targetNodeElement.parentElement;
            if (!targetElementRoot) return [];
            return [
                {
                    descriptor: descriptor,
                    side: side,
                    targetElement: (0, $czQPU.getNodeContentElement)(targetElementRoot, blockControlsContext.targetNode.type.name),
                    targetElementRoot: targetElementRoot
                }
            ];
        });
        const offsetParent = editorView.dom.offsetParent;
        const isDocumentOffsetParent = !offsetParent || offsetParent === ((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body);
        const scrollingOffsetParent = offsetParent instanceof HTMLElement && !isDocumentOffsetParent ? offsetParent : undefined;
        const updatePositions = ()=>{
            animationFrameRef.current = undefined;
            const offsetParentRect = offsetParent === null || offsetParent === void 0 ? void 0 : offsetParent.getBoundingClientRect();
            const offsetParentScrollTop = (scrollingOffsetParent === null || scrollingOffsetParent === void 0 ? void 0 : scrollingOffsetParent.scrollTop) ?? window.scrollY;
            const offsetParentScrollLeft = (scrollingOffsetParent === null || scrollingOffsetParent === void 0 ? void 0 : scrollingOffsetParent.scrollLeft) ?? window.scrollX;
            const nextPlacements = new Map();
            for (const { descriptor: descriptor, side: side, targetElement: targetElement, targetElementRoot: targetElementRoot } of measurementTargets){
                if (!targetElementRoot.isConnected || !targetElement.isConnected) continue;
                const { blockControlsContext: blockControlsContext, isTopLevel: isTopLevel } = descriptor;
                const options = {
                    layout: targetElementRoot.getAttribute('layout') ?? '',
                    nodeRect: targetElement.getBoundingClientRect(),
                    nodeType: blockControlsContext.targetNode.type.name,
                    nodeTypeWithLevel: (0, $61p1X.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                    parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType
                };
                const placement = side === 'left' && isTopLevel ? (0, $1zv1U.getLeftGutterSurfacePlacement)({
                    ...options,
                    leftGutterBoundary: (offsetParentRect === null || offsetParentRect === void 0 ? void 0 : offsetParentRect.left) ?? 0
                }) : (0, $1zv1U.getSurfacePlacement)({
                    ...options,
                    side: side
                });
                nextPlacements.set($5e26583df3d8a431$export$47e0287c6d47b6aa(side, descriptor), (0, $1zv1U.toMeasuredSurfaceWrapperPlacement)((0, $1zv1U.getAbsoluteSurfacePlacement)({
                    offsetParentRect: offsetParentRect,
                    offsetParentScrollLeft: offsetParentScrollLeft,
                    offsetParentScrollTop: offsetParentScrollTop,
                    placement: placement
                })));
            }
            setPlacements(nextPlacements);
        };
        const schedulePositionUpdate = ()=>{
            if (animationFrameRef.current === undefined) animationFrameRef.current = requestAnimationFrame(updatePositions);
        };
        updatePositions();
        const resizeObserver = new ResizeObserver(schedulePositionUpdate);
        const observedElements = new Set([
            editorView.dom
        ]);
        for (const { targetElement: targetElement } of measurementTargets)observedElements.add(targetElement);
        if (offsetParent instanceof HTMLElement) observedElements.add(offsetParent);
        observedElements.forEach((element)=>resizeObserver.observe(element));
        const unbindWindowResize = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: schedulePositionUpdate
        });
        const unbindWindowScroll = (0, $6Zi52.bind)(window, {
            type: 'scroll',
            listener: schedulePositionUpdate,
            options: {
                capture: true,
                passive: true
            }
        });
        const visualViewport = window.visualViewport;
        const unbindVisualViewportResize = visualViewport ? (0, $6Zi52.bind)(visualViewport, {
            type: 'resize',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindVisualViewportScroll = visualViewport ? (0, $6Zi52.bind)(visualViewport, {
            type: 'scroll',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindTransitionEnd = (0, $6Zi52.bind)(editorView.dom, {
            type: 'transitionend',
            listener: schedulePositionUpdate,
            options: {
                capture: true
            }
        });
        return ()=>{
            if (animationFrameRef.current !== undefined) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = undefined;
            }
            resizeObserver.disconnect();
            unbindWindowResize();
            unbindWindowScroll();
            unbindVisualViewportResize === null || unbindVisualViewportResize === void 0 || unbindVisualViewportResize();
            unbindVisualViewportScroll === null || unbindVisualViewportScroll === void 0 || unbindVisualViewportScroll();
            unbindTransitionEnd();
        };
    }, [
        editorView,
        left,
        right
    ]);
    return placements;
};

});
parcelRegister("czQPU", function(module, exports) {
$parcel$export(module.exports, "getNodeContentElement", () => $e37cecde33bf9b68$export$1af8b8b0dd8d08da);

var $cxIBH = parcelRequire("cxIBH");
const $e37cecde33bf9b68$var$INNER_CONTAINER_SELECTORS = {
    blockCard: '.datasourceView-content-inner-wrap',
    bodiedExtension: '.extension-container[data-layout]',
    embedCard: '.rich-media-item',
    extension: '.extension-container[data-layout]',
    mediaSingle: `.${(0, $cxIBH.resizerItemClassName)}`,
    multiBodiedExtension: '.extension-container[data-layout]',
    table: `.${(0, $cxIBH.resizerItemClassName)}`
};
const $e37cecde33bf9b68$export$424aaf56b3266f55 = (nodeType)=>$e37cecde33bf9b68$var$INNER_CONTAINER_SELECTORS[nodeType] !== undefined;
const $e37cecde33bf9b68$export$1af8b8b0dd8d08da = (nodeElement, nodeType)=>{
    const selector = $e37cecde33bf9b68$var$INNER_CONTAINER_SELECTORS[nodeType];
    if (!selector) return nodeElement;
    return nodeElement.querySelector(selector) ?? nodeElement;
};

});



parcelRegister("khyye", function(module, exports) {
$parcel$export(module.exports, "BlockControlsLeftSurfaces", () => $66c2d7b344eec18f$export$4cff02cd9e409191);
/* block-controls-left-surfaces.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $f9ezd = parcelRequire("f9ezd");

var $9oAqi = parcelRequire("9oAqi");

var $cajPh = parcelRequire("cajPh");

var $61p1X = parcelRequire("61p1X");

var $dRO13 = parcelRequire("dRO13");

var $2Z44q = parcelRequire("2Z44q");

var $iIp3q = parcelRequire("iIp3q");

var $7pLRV = parcelRequire("7pLRV");

var $czQPU = parcelRequire("czQPU");

var $1zv1U = parcelRequire("1zv1U");
const $66c2d7b344eec18f$var$EMPTY_SURFACE_POSITIONS = [];
const $66c2d7b344eec18f$var$EMPTY_SURFACE_ANCHORS = new Map();
const $66c2d7b344eec18f$var$EMPTY_SURFACE_COMPONENTS = [];
const $66c2d7b344eec18f$var$EMPTY_MEASURED_SURFACES = [];
const $66c2d7b344eec18f$export$4cff02cd9e409191 = ({ api: api, editorView: editorView })=>{
    var _api$uiControlRegistr;
    const { activeNode: activeNode, surfaceAnchors: surfaceAnchors, surfaceActiveNodes: surfaceActiveNodes, surfaceNodePositions: surfaceNodePositions } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>{
        var _states$blockControls, _states$blockControls2, _states$blockControls3, _states$blockControls4;
        return {
            activeNode: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.activeNode,
            surfaceActiveNodes: (_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.surfaceActiveNodes,
            surfaceAnchors: ((_states$blockControls3 = states.blockControlsState) === null || _states$blockControls3 === void 0 ? void 0 : _states$blockControls3.surfaceAnchors) ?? $66c2d7b344eec18f$var$EMPTY_SURFACE_ANCHORS,
            surfaceNodePositions: ((_states$blockControls4 = states.blockControlsState) === null || _states$blockControls4 === void 0 ? void 0 : _states$blockControls4.surfaceNodePositions) ?? $66c2d7b344eec18f$var$EMPTY_SURFACE_POSITIONS
        };
    });
    const components = ((_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $5Amf8.BLOCK_CONTROLS_LEFT_SURFACE))) ?? $66c2d7b344eec18f$var$EMPTY_SURFACE_COMPONENTS;
    const targets = (0, $fc4bM.useMemo)(()=>{
        const candidates = new Set(surfaceNodePositions);
        return (0, $7pLRV.getBlockControlsSurfaceTargets)(activeNode, surfaceNodePositions).filter(({ position: position })=>candidates.has(position));
    }, [
        activeNode,
        surfaceNodePositions
    ]);
    const surfaces = (0, $fc4bM.useMemo)(()=>targets.flatMap((target)=>{
            const context = (0, $iIp3q.createBlockControlsSurfaceContextForPosition)(editorView.state, target.position, (surfaceActiveNodes === null || surfaceActiveNodes === void 0 ? void 0 : surfaceActiveNodes.get(target.position)) ?? activeNode);
            if (!context) return [];
            const surfaceContext = (0, $cajPh.createSurfaceContext)((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT), context);
            const surfaceComponents = (0, $2Z44q.getBlockControlsLeftSurfaceComponents)(components, surfaceContext);
            if (!surfaceComponents) return [];
            // The cache supplies the same anchor names used by ProseMirror decorations.
            const anchorName = (0, $f9ezd.isCSSAnchorSupported)() ? surfaceAnchors.get(target.position) : undefined;
            // Top-level controls can respond to the available left gutter without the surface
            // host knowing which controls are registered or how they adapt.
            const isTopLevel = context.targetNode.parentType === 'doc';
            return [
                {
                    ...target,
                    anchorName: anchorName,
                    blockControlsContext: context,
                    isTopLevel: isTopLevel,
                    surfaceComponents: surfaceComponents,
                    surfaceContext: surfaceContext
                }
            ];
        }), [
        activeNode,
        components,
        editorView,
        targets,
        surfaceAnchors,
        surfaceActiveNodes
    ]);
    /**
   * Placements that need no measuring, so they are derived rather than stored: every inset is an
   * `anchor()` the browser re-resolves on every layout change.
   */ const anchoredPlacements = (0, $fc4bM.useMemo)(()=>new Map(surfaces.flatMap(({ anchorName: anchorName, blockControlsContext: blockControlsContext, isTopLevel: isTopLevel, position: position })=>{
            if (!anchorName) return [];
            const options = {
                anchorName: anchorName,
                layout: blockControlsContext.targetNode.node.attrs.layout,
                nodeType: blockControlsContext.targetNode.type.name,
                nodeTypeWithLevel: (0, $61p1X.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType
            };
            const placement = isTopLevel ? (0, $1zv1U.getAnchoredLeftGutterSurfacePlacement)(options) : (0, $1zv1U.getAnchoredSurfacePlacement)({
                ...options,
                side: 'left'
            });
            return [
                [
                    position,
                    placement
                ]
            ];
        })), [
        surfaces
    ]);
    // Only the surfaces that still need measuring drive the effect below, so a document of anchored
    // blocks binds no scroll or resize listeners at all.
    //
    // The shared empty array matters: `surfaces` gets a new identity on every hover, since
    // `activeNode` is one of its dependencies. Returning a fresh `[]` would give the effect a
    // changed dependency each time and re-run it for nothing, which is the cost the anchored path
    // exists to avoid.
    const measuredSurfaces = (0, $fc4bM.useMemo)(()=>{
        const measured = surfaces.filter(({ anchorName: anchorName })=>!anchorName);
        return measured.length === 0 ? $66c2d7b344eec18f$var$EMPTY_MEASURED_SURFACES : measured;
    }, [
        surfaces
    ]);
    const [placements, setPlacements] = (0, $fc4bM.useState)(new Map());
    const animationFrameRef = (0, $fc4bM.useRef)(undefined);
    (0, $fc4bM.useLayoutEffect)(()=>{
        var _getDocument;
        if (measuredSurfaces.length === 0) {
            // Clear only when there is something to clear. Handing React a fresh Map every time would
            // fail its identity check and commit a render to replace one empty map with another.
            setPlacements((previous)=>previous.size > 0 ? new Map() : previous);
            return;
        }
        const measurementTargets = measuredSurfaces.flatMap(({ blockControlsContext: blockControlsContext, isTopLevel: isTopLevel, position: position })=>{
            const targetNodeElement = editorView.nodeDOM(blockControlsContext.targetNode.pos);
            const targetElementRoot = targetNodeElement instanceof HTMLElement ? targetNodeElement : targetNodeElement === null || targetNodeElement === void 0 ? void 0 : targetNodeElement.parentElement;
            if (!targetElementRoot) return [];
            return [
                {
                    blockControlsContext: blockControlsContext,
                    isTopLevel: isTopLevel,
                    position: position,
                    targetElement: (0, $czQPU.getNodeContentElement)(targetElementRoot, blockControlsContext.targetNode.type.name),
                    targetElementRoot: targetElementRoot
                }
            ];
        });
        const offsetParent = editorView.dom.offsetParent;
        const isDocumentOffsetParent = !offsetParent || offsetParent === ((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body);
        const scrollingOffsetParent = offsetParent instanceof HTMLElement && !isDocumentOffsetParent ? offsetParent : undefined;
        const updatePositions = ()=>{
            animationFrameRef.current = undefined;
            const offsetParentRect = offsetParent === null || offsetParent === void 0 ? void 0 : offsetParent.getBoundingClientRect();
            const offsetParentScrollTop = (scrollingOffsetParent === null || scrollingOffsetParent === void 0 ? void 0 : scrollingOffsetParent.scrollTop) ?? window.scrollY;
            const offsetParentScrollLeft = (scrollingOffsetParent === null || scrollingOffsetParent === void 0 ? void 0 : scrollingOffsetParent.scrollLeft) ?? window.scrollX;
            const nextPlacements = new Map();
            for (const { blockControlsContext: blockControlsContext, isTopLevel: isTopLevel, position: position, targetElement: targetElement, targetElementRoot: targetElementRoot } of measurementTargets){
                if (!targetElementRoot.isConnected || !targetElement.isConnected) continue;
                const options = {
                    layout: targetElementRoot.getAttribute('layout') ?? '',
                    nodeRect: targetElement.getBoundingClientRect(),
                    nodeType: blockControlsContext.targetNode.type.name,
                    nodeTypeWithLevel: (0, $61p1X.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                    parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType
                };
                const placement = isTopLevel ? (0, $1zv1U.getLeftGutterSurfacePlacement)({
                    ...options,
                    leftGutterBoundary: (offsetParentRect === null || offsetParentRect === void 0 ? void 0 : offsetParentRect.left) ?? 0
                }) : (0, $1zv1U.getSurfacePlacement)({
                    ...options,
                    side: 'left'
                });
                nextPlacements.set(position, (0, $1zv1U.toMeasuredSurfaceWrapperPlacement)((0, $1zv1U.getAbsoluteSurfacePlacement)({
                    offsetParentRect: offsetParentRect,
                    offsetParentScrollLeft: offsetParentScrollLeft,
                    offsetParentScrollTop: offsetParentScrollTop,
                    placement: placement
                })));
            }
            setPlacements(nextPlacements);
        };
        const schedulePositionUpdate = ()=>{
            if (animationFrameRef.current === undefined) animationFrameRef.current = requestAnimationFrame(updatePositions);
        };
        updatePositions();
        const resizeObserver = new ResizeObserver(schedulePositionUpdate);
        const observedElements = new Set([
            editorView.dom
        ]);
        for (const { targetElement: targetElement } of measurementTargets)observedElements.add(targetElement);
        if (offsetParent instanceof HTMLElement) observedElements.add(offsetParent);
        observedElements.forEach((element)=>resizeObserver.observe(element));
        const unbindWindowResize = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: schedulePositionUpdate
        });
        const unbindWindowScroll = (0, $6Zi52.bind)(window, {
            type: 'scroll',
            listener: schedulePositionUpdate,
            options: {
                capture: true,
                passive: true
            }
        });
        const visualViewport = window.visualViewport;
        const unbindVisualViewportResize = visualViewport ? (0, $6Zi52.bind)(visualViewport, {
            type: 'resize',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindVisualViewportScroll = visualViewport ? (0, $6Zi52.bind)(visualViewport, {
            type: 'scroll',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindTransitionEnd = (0, $6Zi52.bind)(editorView.dom, {
            type: 'transitionend',
            listener: schedulePositionUpdate,
            options: {
                capture: true
            }
        });
        return ()=>{
            if (animationFrameRef.current !== undefined) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = undefined;
            }
            resizeObserver.disconnect();
            unbindWindowResize();
            unbindWindowScroll();
            unbindVisualViewportResize === null || unbindVisualViewportResize === void 0 || unbindVisualViewportResize();
            unbindVisualViewportScroll === null || unbindVisualViewportScroll === void 0 || unbindVisualViewportScroll();
            unbindTransitionEnd();
        };
    }, [
        editorView,
        measuredSurfaces
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: surfaces.map(({ position: position, source: source, surfaceComponents: surfaceComponents, surfaceContext: surfaceContext })=>{
            var _activeNode$handleOpt;
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dRO13.BlockControlsLeftSurface), {
                api: api,
                components: surfaceComponents,
                forceVisibleOnMouseOut: Boolean(activeNode === null || activeNode === void 0 || (_activeNode$handleOpt = activeNode.handleOptions) === null || _activeNode$handleOpt === void 0 ? void 0 : _activeNode$handleOpt.isFocused),
                placement: anchoredPlacements.get(position) ?? placements.get(position),
                source: source,
                surfaceContext: surfaceContext
            }, position);
        })
    });
};

});

parcelRegister("9lAox", function(module, exports) {
$parcel$export(module.exports, "BlockControlsRightSurfaces", () => $217debcc1a04660a$export$79baf52a56f1adef);
/* block-controls-right-surfaces.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $j5N6B = parcelRequire("j5N6B");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $f9ezd = parcelRequire("f9ezd");

var $9oAqi = parcelRequire("9oAqi");

var $cajPh = parcelRequire("cajPh");

var $61p1X = parcelRequire("61p1X");

var $94jZn = parcelRequire("94jZn");

var $2Z44q = parcelRequire("2Z44q");

var $iIp3q = parcelRequire("iIp3q");

var $7pLRV = parcelRequire("7pLRV");

var $czQPU = parcelRequire("czQPU");

var $1zv1U = parcelRequire("1zv1U");
const $217debcc1a04660a$var$EMPTY_SURFACE_POSITIONS = [];
const $217debcc1a04660a$var$EMPTY_SURFACE_ANCHORS = new Map();
const $217debcc1a04660a$var$EMPTY_SURFACE_COMPONENTS = [];
const $217debcc1a04660a$var$EMPTY_MEASURED_SURFACES = [];
const $217debcc1a04660a$export$79baf52a56f1adef = ({ api: api, editorView: editorView })=>{
    var _api$uiControlRegistr;
    const { activeNode: activeNode, surfaceAnchors: surfaceAnchors, surfaceActiveNodes: surfaceActiveNodes, surfaceNodePositions: surfaceNodePositions } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>{
        var _states$blockControls, _states$blockControls2, _states$blockControls3, _states$blockControls4;
        return {
            activeNode: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.activeNode,
            surfaceActiveNodes: (_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.surfaceActiveNodes,
            surfaceAnchors: ((_states$blockControls3 = states.blockControlsState) === null || _states$blockControls3 === void 0 ? void 0 : _states$blockControls3.surfaceAnchors) ?? $217debcc1a04660a$var$EMPTY_SURFACE_ANCHORS,
            surfaceNodePositions: ((_states$blockControls4 = states.blockControlsState) === null || _states$blockControls4 === void 0 ? void 0 : _states$blockControls4.surfaceNodePositions) ?? $217debcc1a04660a$var$EMPTY_SURFACE_POSITIONS
        };
    });
    const components = ((_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $5Amf8.BLOCK_CONTROLS_RIGHT_SURFACE))) ?? $217debcc1a04660a$var$EMPTY_SURFACE_COMPONENTS;
    const targets = (0, $fc4bM.useMemo)(()=>{
        const candidates = new Set(surfaceNodePositions);
        return (0, $7pLRV.getBlockControlsSurfaceTargets)(activeNode, surfaceNodePositions).filter(({ position: position })=>candidates.has(position));
    }, [
        activeNode,
        surfaceNodePositions
    ]);
    const surfaces = (0, $fc4bM.useMemo)(()=>targets.flatMap((target)=>{
            const context = (0, $iIp3q.createBlockControlsSurfaceContextForPosition)(editorView.state, target.position, (surfaceActiveNodes === null || surfaceActiveNodes === void 0 ? void 0 : surfaceActiveNodes.get(target.position)) ?? activeNode);
            if (!context) return [];
            const surfaceContext = (0, $cajPh.createSurfaceContext)((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT), context);
            const surfaceComponents = (0, $2Z44q.getBlockControlsRightSurfaceComponents)(components, surfaceContext);
            if (!surfaceComponents) return [];
            // The cache supplies the same anchor names used by ProseMirror decorations.
            const anchorName = (0, $f9ezd.isCSSAnchorSupported)() ? surfaceAnchors.get(target.position) : undefined;
            return [
                {
                    ...target,
                    anchorName: anchorName,
                    blockControlsContext: context,
                    surfaceComponents: surfaceComponents,
                    surfaceContext: surfaceContext
                }
            ];
        }), [
        activeNode,
        components,
        editorView,
        targets,
        surfaceAnchors,
        surfaceActiveNodes
    ]);
    /**
   * Placements that need no measuring, so they are derived rather than stored: every inset is an
   * `anchor()` the browser re-resolves on every layout change.
   */ const anchoredPlacements = (0, $fc4bM.useMemo)(()=>new Map(surfaces.flatMap(({ anchorName: anchorName, blockControlsContext: blockControlsContext, position: position })=>anchorName ? [
                [
                    position,
                    (0, $1zv1U.getAnchoredSurfacePlacement)({
                        anchorName: anchorName,
                        nodeType: blockControlsContext.targetNode.type.name,
                        nodeTypeWithLevel: (0, $61p1X.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                        layout: blockControlsContext.targetNode.node.attrs.layout,
                        parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType,
                        side: 'right'
                    })
                ]
            ] : [])), [
        surfaces
    ]);
    // Only the surfaces that still need measuring drive the effect below, so a document of anchored
    // blocks binds no scroll or resize listeners at all.
    //
    // The shared empty array matters: `surfaces` gets a new identity on every hover, since
    // `activeNode` is one of its dependencies. Returning a fresh `[]` would give the effect a
    // changed dependency each time and re-run it for nothing, which is the cost the anchored path
    // exists to avoid.
    const measuredSurfaces = (0, $fc4bM.useMemo)(()=>{
        const measured = surfaces.filter(({ anchorName: anchorName })=>!anchorName);
        return measured.length === 0 ? $217debcc1a04660a$var$EMPTY_MEASURED_SURFACES : measured;
    }, [
        surfaces
    ]);
    const [placements, setPlacements] = (0, $fc4bM.useState)(new Map());
    const animationFrameRef = (0, $fc4bM.useRef)(undefined);
    (0, $fc4bM.useLayoutEffect)(()=>{
        var _getDocument;
        if (measuredSurfaces.length === 0) {
            // Clear only when there is something to clear. Handing React a fresh Map every time would
            // fail its identity check and commit a render to replace one empty map with another.
            setPlacements((previous)=>previous.size > 0 ? new Map() : previous);
            return;
        }
        const measurementTargets = measuredSurfaces.flatMap(({ blockControlsContext: blockControlsContext, position: position })=>{
            const targetNodeElement = editorView.nodeDOM(blockControlsContext.targetNode.pos);
            const targetElementRoot = targetNodeElement instanceof HTMLElement ? targetNodeElement : targetNodeElement === null || targetNodeElement === void 0 ? void 0 : targetNodeElement.parentElement;
            if (!targetElementRoot) return [];
            return [
                {
                    blockControlsContext: blockControlsContext,
                    position: position,
                    targetElement: (0, $czQPU.getNodeContentElement)(targetElementRoot, blockControlsContext.targetNode.type.name),
                    targetElementRoot: targetElementRoot
                }
            ];
        });
        const offsetParent = editorView.dom.offsetParent;
        const isDocumentOffsetParent = !offsetParent || offsetParent === ((_getDocument = (0, $j5N6B.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.body);
        const scrollingOffsetParent = offsetParent instanceof HTMLElement && !isDocumentOffsetParent ? offsetParent : undefined;
        const updatePositions = ()=>{
            animationFrameRef.current = undefined;
            const offsetParentRect = offsetParent === null || offsetParent === void 0 ? void 0 : offsetParent.getBoundingClientRect();
            const offsetParentScrollTop = (scrollingOffsetParent === null || scrollingOffsetParent === void 0 ? void 0 : scrollingOffsetParent.scrollTop) ?? window.scrollY;
            const offsetParentScrollLeft = (scrollingOffsetParent === null || scrollingOffsetParent === void 0 ? void 0 : scrollingOffsetParent.scrollLeft) ?? window.scrollX;
            const nextPlacements = new Map();
            for (const { blockControlsContext: blockControlsContext, position: position, targetElement: targetElement, targetElementRoot: targetElementRoot } of measurementTargets){
                if (!targetElementRoot.isConnected || !targetElement.isConnected) continue;
                const placement = (0, $1zv1U.getSurfacePlacement)({
                    layout: targetElementRoot.getAttribute('layout') ?? '',
                    nodeRect: targetElement.getBoundingClientRect(),
                    nodeType: blockControlsContext.targetNode.type.name,
                    nodeTypeWithLevel: (0, $61p1X.getNodeTypeWithLevel)(blockControlsContext.targetNode.node),
                    parentNodeType: blockControlsContext.targetNode.parentType === 'doc' ? undefined : blockControlsContext.targetNode.parentType,
                    side: 'right'
                });
                nextPlacements.set(position, (0, $1zv1U.toMeasuredSurfaceWrapperPlacement)((0, $1zv1U.getAbsoluteSurfacePlacement)({
                    offsetParentRect: offsetParentRect,
                    offsetParentScrollLeft: offsetParentScrollLeft,
                    offsetParentScrollTop: offsetParentScrollTop,
                    placement: placement
                })));
            }
            setPlacements(nextPlacements);
        };
        const schedulePositionUpdate = ()=>{
            if (animationFrameRef.current === undefined) animationFrameRef.current = requestAnimationFrame(updatePositions);
        };
        updatePositions();
        const resizeObserver = new ResizeObserver(schedulePositionUpdate);
        const observedElements = new Set([
            editorView.dom
        ]);
        for (const { targetElement: targetElement } of measurementTargets)observedElements.add(targetElement);
        if (offsetParent instanceof HTMLElement) observedElements.add(offsetParent);
        observedElements.forEach((element)=>resizeObserver.observe(element));
        const unbindWindowResize = (0, $6Zi52.bind)(window, {
            type: 'resize',
            listener: schedulePositionUpdate
        });
        const unbindWindowScroll = (0, $6Zi52.bind)(window, {
            type: 'scroll',
            listener: schedulePositionUpdate,
            options: {
                capture: true,
                passive: true
            }
        });
        const visualViewport = window.visualViewport;
        const unbindVisualViewportResize = visualViewport ? (0, $6Zi52.bind)(visualViewport, {
            type: 'resize',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindVisualViewportScroll = visualViewport ? (0, $6Zi52.bind)(visualViewport, {
            type: 'scroll',
            listener: schedulePositionUpdate
        }) : undefined;
        const unbindTransitionEnd = (0, $6Zi52.bind)(editorView.dom, {
            type: 'transitionend',
            listener: schedulePositionUpdate,
            options: {
                capture: true
            }
        });
        return ()=>{
            if (animationFrameRef.current !== undefined) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = undefined;
            }
            resizeObserver.disconnect();
            unbindWindowResize();
            unbindWindowScroll();
            unbindVisualViewportResize === null || unbindVisualViewportResize === void 0 || unbindVisualViewportResize();
            unbindVisualViewportScroll === null || unbindVisualViewportScroll === void 0 || unbindVisualViewportScroll();
            unbindTransitionEnd();
        };
    }, [
        editorView,
        measuredSurfaces
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: surfaces.map(({ position: position, source: source, surfaceComponents: surfaceComponents, surfaceContext: surfaceContext })=>{
            var _activeNode$handleOpt;
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $94jZn.BlockControlsRightSurface), {
                api: api,
                components: surfaceComponents,
                forceVisibleOnMouseOut: Boolean(activeNode === null || activeNode === void 0 || (_activeNode$handleOpt = activeNode.handleOptions) === null || _activeNode$handleOpt === void 0 ? void 0 : _activeNode$handleOpt.isFocused),
                placement: anchoredPlacements.get(position) ?? placements.get(position),
                source: source,
                surfaceContext: surfaceContext
            }, position);
        })
    });
};

});

parcelRegister("24uL0", function(module, exports) {
$parcel$export(module.exports, "getBlockControlsSurfaceDragHandleComponents", () => $ddd814dd9a05be43$export$88d90db17f630aa9);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5qjas = parcelRequire("5qjas");

var $5Amf8 = parcelRequire("5Amf8");

var $Sc9ef = parcelRequire("Sc9ef");
const $ddd814dd9a05be43$export$88d90db17f630aa9 = ({ api: api })=>[
        {
            component: ({ surfaceContext: surfaceContext })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $Sc9ef.BlockControlsSurfaceDragHandle), {
                    api: api,
                    surfaceContext: surfaceContext
                }),
            isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                var _api$editorViewMode;
                const context = surfaceContext === null || surfaceContext === void 0 ? void 0 : surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
                return (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view' || !(context !== null && context !== void 0 && context.activeNode) || context.targetNode.pos !== context.activeNode.pos || context.activeControlKey !== undefined && context.activeControlKey !== (0, $5Amf8.BLOCK_CONTROLS_DRAG_HANDLE).key;
            },
            ...(0, $5Amf8.BLOCK_CONTROLS_DRAG_HANDLE),
            parents: [
                {
                    ...(0, $5Amf8.BLOCK_CONTROLS_LEFT_GROUP),
                    rank: 200
                }
            ]
        }
    ];

});
parcelRegister("Sc9ef", function(module, exports) {
$parcel$export(module.exports, "BlockControlsSurfaceDragHandle", () => $b1ddf15af04e5429$export$864462199165f9e3);
/* block-controls-surface-drag-handle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $5qjas = parcelRequire("5qjas");

var $lKQmU = parcelRequire("lKQmU");

var $dqFZv = parcelRequire("dqFZv");

var $eUtBU = parcelRequire("eUtBU");

var $7u4Lo = parcelRequire("7u4Lo");

var $9oAqi = parcelRequire("9oAqi");

var $kzYZ0 = parcelRequire("kzYZ0");

var $bcN2K = parcelRequire("bcN2K");

var $bcTS3 = parcelRequire("bcTS3");

var $b8Grq = parcelRequire("b8Grq");

var $dStWQ = parcelRequire("dStWQ");

var $lE9Q7 = parcelRequire("lE9Q7");

var $7f0FC = parcelRequire("7f0FC");

var $3vskT = parcelRequire("3vskT");

var $yOdik = parcelRequire("yOdik");

var $fcDy5 = parcelRequire("fcDy5");

var $8Z9L9 = parcelRequire("8Z9L9");

var $fSKKI = parcelRequire("fSKKI");

var $dj84o = parcelRequire("dj84o");
// Keep style values co-located for Compiled while matching the legacy drag handle dimensions.
const $b1ddf15af04e5429$var$SURFACE_DRAG_HANDLE_HEIGHT = 24;
const $b1ddf15af04e5429$var$SURFACE_DRAG_HANDLE_WIDTH = 12;
const $b1ddf15af04e5429$var$SURFACE_DRAG_HANDLE_BORDER_RADIUS = 4;
const $b1ddf15af04e5429$var$SURFACE_DRAG_HANDLE_Z_INDEX = 100;
const $b1ddf15af04e5429$var$dragHandleStyles = {
    root: "_19itglyw _2rko1y44 _12ji1r31 _1qu2glyw _12y31o36 _v564k6bl _1e0c1txw _vchhusvi _2lx21bp4 _4cvr1h6o _1bah1h6o _4t3i1tcg _1bsb1crf _bfhksm61 _syazdgkc _80om1qgj _1pbyb4wl _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _cun91j28 _vbqb2sac _1ygbdfik _irr31dpa _6g80187o _1ggl5xtf _1di6fcek",
    scaled: "_4t3i1myc _1bsbx5ub",
    selected: "_bfhk15s3 _syazxl6c",
    keyboardFocused: "_1a37dfik",
    firefoxSelection: "_1p1y1j28",
    layoutColumn: "_t9ec14w8",
    iconWrapper: "_1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $b1ddf15af04e5429$var$handleIconDragStart = (event)=>{
    var _event$currentTarget$;
    if (!(0, $dqFZv.getBrowserInfo)().chrome) return;
    event.stopPropagation();
    (_event$currentTarget$ = event.currentTarget.parentElement) === null || _event$currentTarget$ === void 0 || _event$currentTarget$.dispatchEvent(new DragEvent('dragstart', {
        bubbles: true,
        cancelable: true,
        dataTransfer: event.dataTransfer
    }));
};
const $b1ddf15af04e5429$var$isSelected = (selection, pos, view)=>{
    if (typeof pos !== 'number' || !selection || !view) return false;
    return (0, $7f0FC.isHandleCorrelatedToSelection)(view.state, selection, pos);
};
const $b1ddf15af04e5429$export$864462199165f9e3 = ({ api: api, surfaceContext: surfaceContext })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const view = (0, $8Z9L9.useSurfaceEditorView)();
    const context = surfaceContext === null || surfaceContext === void 0 ? void 0 : surfaceContext.get((0, $5qjas.BLOCK_CONTROL_UI_CONTEXT));
    const activeNode = context === null || context === void 0 ? void 0 : context.activeNode;
    const pos = activeNode === null || activeNode === void 0 ? void 0 : activeNode.pos;
    const nodeType = (activeNode === null || activeNode === void 0 ? void 0 : activeNode.type.name) ?? '';
    const buttonRef = (0, $fc4bM.useRef)(null);
    const posRef = (0, $fc4bM.useRef)(pos);
    posRef.current = pos;
    const getPos = (0, $fc4bM.useCallback)(()=>posRef.current, []);
    const { activeNodeAnchorName: activeNodeAnchorName, handleOptions: handleOptions, interactionState: interactionState, selection: selection } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'blockControls',
        'interaction',
        'selection'
    ], (states)=>{
        var _states$blockControls, _states$blockControls2, _states$interactionSt, _states$selectionStat;
        return {
            activeNodeAnchorName: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 || (_states$blockControls = _states$blockControls.activeNode) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.anchorName,
            handleOptions: (_states$blockControls2 = states.blockControlsState) === null || _states$blockControls2 === void 0 || (_states$blockControls2 = _states$blockControls2.activeNode) === null || _states$blockControls2 === void 0 ? void 0 : _states$blockControls2.handleOptions,
            interactionState: (_states$interactionSt = states.interactionState) === null || _states$interactionSt === void 0 ? void 0 : _states$interactionSt.interactionState,
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
        };
    });
    const [dragHandleSelected, setDragHandleSelected] = (0, $fc4bM.useState)(false);
    (0, $fc4bM.useEffect)(()=>{
        setDragHandleSelected($b1ddf15af04e5429$var$isSelected(selection, pos, view));
    }, [
        pos,
        selection,
        view
    ]);
    const isLayoutColumn = nodeType === 'layoutColumn';
    const isTopLevelNode = (activeNode === null || activeNode === void 0 ? void 0 : activeNode.parentType) === 'doc';
    const getAnchorName = (0, $fc4bM.useCallback)(()=>{
        var _api$blockControls$sh, _dom$closest;
        const surfaceAnchor = posRef.current === undefined ? undefined : api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 || (_api$blockControls$sh = _api$blockControls$sh.surfaceAnchors) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.get(posRef.current);
        if (surfaceAnchor) return surfaceAnchor;
        if (activeNodeAnchorName) return activeNodeAnchorName;
        const currentPos = posRef.current;
        if (!view || currentPos === undefined) return '';
        const dom = view.nodeDOM(currentPos);
        if (!(dom instanceof HTMLElement)) return '';
        const anchorAttrName = (0, $dj84o.getAnchorAttrName)();
        return dom.getAttribute(anchorAttrName) ?? dom.getAttribute((0, $dj84o.NODE_ANCHOR_ATTR_NAME)) ?? ((_dom$closest = dom.closest(`[${anchorAttrName}]`)) === null || _dom$closest === void 0 ? void 0 : _dom$closest.getAttribute(anchorAttrName)) ?? '';
    }, [
        activeNodeAnchorName,
        api,
        view
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        const element = buttonRef.current;
        if (!view || !element) return;
        (0, $lKQmU.surfaceDragHandleElementStore).set(view, element);
        return ()=>(0, $lKQmU.surfaceDragHandleElementStore).release(view, element);
    }, [
        view
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!(handleOptions !== null && handleOptions !== void 0 && handleOptions.isFocused) || !buttonRef.current || !view) return;
        let animationFrameId;
        let attempts = 0;
        const focusHandle = ()=>{
            const button = buttonRef.current;
            if (!button) return;
            button.focus();
            if (button.ownerDocument.activeElement !== button && attempts < 5) {
                attempts++;
                animationFrameId = requestAnimationFrame(focusHandle);
            }
        };
        focusHandle();
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            view.focus();
        };
    }, [
        handleOptions === null || handleOptions === void 0 ? void 0 : handleOptions.isFocused,
        view
    ]);
    (0, $fSKKI.useBlockControlsSurfaceDragSource)({
        api: api,
        elementRef: buttonRef,
        getAnchorName: getAnchorName,
        getPos: getPos,
        nodeType: nodeType,
        start: pos,
        view: view
    });
    const handleMouseDown = (0, $fc4bM.useCallback)(()=>{
        var _api$core, _api$blockControls;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.commands.setSelectedViaDragHandle(true));
    }, [
        api
    ]);
    const handleClick = (0, $fc4bM.useCallback)((event)=>{
        var _api$core2;
        if (!view) return;
        const openedViaKeyboard = event.detail === 0;
        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
            var _selectionPreservatio, _api$analytics, _resolvedStartPos$nod, _api$blockControls3, _api$blockControls4;
            const startPos = getPos();
            if (startPos === undefined) return tr;
            if (nodeType === 'layoutColumn') tr.setMeta('toggleLayoutColumnMenu', (0, $3vskT.buildLayoutColumnMenuMeta)(startPos, openedViaKeyboard));
            const selection = ((_selectionPreservatio = (0, $b8Grq.selectionPreservationPluginKey).getState(view.state)) === null || _selectionPreservatio === void 0 ? void 0 : _selectionPreservatio.preservedSelection) ?? tr.selection;
            const resolvedStartPos = tr.doc.resolve(startPos);
            if (resolvedStartPos.nodeAfter) {
                var _api$blockControls2;
                api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.actions.notifyBlockHandleClick({
                    node: resolvedStartPos.nodeAfter
                });
            }
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                action: (0, $3LeME.ACTION).CLICKED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                attributes: {
                    nodeDepth: resolvedStartPos.depth,
                    nodeTypes: ((_resolvedStartPos$nod = resolvedStartPos.nodeAfter) === null || _resolvedStartPos$nod === void 0 ? void 0 : _resolvedStartPos$nod.type.name) || ''
                },
                eventType: (0, $3LeME.EVENT_TYPE).UI
            })(tr);
            (0, $lE9Q7.expandAndUpdateSelection)({
                api: api,
                isShiftPressed: event.shiftKey,
                nodeType: nodeType,
                selection: selection,
                startPos: startPos,
                tr: tr
            });
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings')) (0, $dStWQ.prepareCollapsedHeadingSelection)({
                api: api,
                expand: true,
                headingPos: startPos,
                tr: tr
            });
            api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || _api$blockControls3.commands.startPreservingSelection()({
                tr: tr
            });
            api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || _api$blockControls4.commands.toggleBlockMenu({
                anchorName: getAnchorName(),
                openedViaKeyboard: openedViaKeyboard,
                triggerByNode: {
                    nodeType: nodeType,
                    pos: startPos,
                    rootPos: (activeNode === null || activeNode === void 0 ? void 0 : activeNode.rootPos) ?? resolvedStartPos.before(1)
                }
            })({
                tr: tr
            });
            tr.setMeta('scrollIntoView', false);
            return tr;
        });
        view.focus();
    }, [
        activeNode === null || activeNode === void 0 ? void 0 : activeNode.rootPos,
        api,
        getAnchorName,
        getPos,
        nodeType,
        view
    ]);
    const label = formatMessage((0, $7u4Lo.messages).dragToMoveClickToOpen, {
        br: ' '
    });
    const helpDescriptors = (0, $fc4bM.useMemo)(()=>[
            {
                description: formatMessage((0, $7u4Lo.messages).dragToMoveClickToOpen, {
                    br: /*#__PURE__*/ (0, $3LM7S.jsx)("br", {})
                })
            }
        ], [
        formatMessage
    ]);
    const handleTooltipShow = (0, $fc4bM.useCallback)(()=>{
        var _api$accessibilityUti;
        api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 || _api$accessibilityUti.actions.ariaNotify(label, {
            priority: 'important'
        });
    }, [
        api,
        label
    ]);
    if (!view || !activeNode || pos === undefined) return null;
    const tooltipContent = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.TooltipContentWithMultipleShortcuts), {
        helpDescriptors: helpDescriptors
    });
    const browser = (0, $dqFZv.getBrowserInfo)();
    const button = /*#__PURE__*/ (0, $3LM7S.jsx)("button", {
        ref: buttonRef,
        type: "button",
        "aria-label": label,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop -- Pragmatic DnD owns this native drag source.
        onDrop: (event)=>event.stopPropagation(),
        "data-editor-block-ctrl-drag-handle": true,
        "data-blocks-drag-handle": true,
        "data-testid": "block-controls-surface-drag-handle",
        className: (0, $2R2iS.default)([
            $b1ddf15af04e5429$var$dragHandleStyles.root,
            browser.gecko && $b1ddf15af04e5429$var$dragHandleStyles.firefoxSelection,
            isLayoutColumn && $b1ddf15af04e5429$var$dragHandleStyles.layoutColumn,
            dragHandleSelected && interactionState !== 'hasNotHadInteraction' && $b1ddf15af04e5429$var$dragHandleStyles.selected,
            (handleOptions === null || handleOptions === void 0 ? void 0 : handleOptions.isFocused) && $b1ddf15af04e5429$var$dragHandleStyles.keyboardFocused,
            $b1ddf15af04e5429$var$dragHandleStyles.scaled
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            onDragStart: $b1ddf15af04e5429$var$handleIconDragStart,
            className: (0, $2R2iS.default)([
                $b1ddf15af04e5429$var$dragHandleStyles.iconWrapper
            ]),
            children: (0, $fcDy5.shouldUseNestedDragHandleIcon)(Boolean(isTopLevelNode), isLayoutColumn) ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $yOdik.DragHandleNestedIcon), {}) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kzYZ0))), {
                label: "",
                size: "small",
                spacing: "spacious"
            })
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        position: "top",
        content: tooltipContent,
        ignoreTooltipPointerEvents: true,
        onShow: handleTooltipShow,
        children: button
    });
};

});
parcelRegister("3vskT", function(module, exports) {
$parcel$export(module.exports, "buildLayoutColumnMenuMeta", () => $ba3918255b5341a7$export$c74f4d134603910f);
$parcel$export(module.exports, "getNodeSpacingForDragPreview", () => $ba3918255b5341a7$export$aedba7900cf20c7e);
$parcel$export(module.exports, "getNodeMarginsForDragPreview", () => $ba3918255b5341a7$export$8f0a13ded3f90102);

var $GIvev = parcelRequire("GIvev");
const $ba3918255b5341a7$export$c74f4d134603910f = (anchorPos, openedViaKeyboard)=>({
        anchorPos: anchorPos,
        openedViaKeyboard: openedViaKeyboard
    });
const $ba3918255b5341a7$export$aedba7900cf20c7e = (node)=>{
    if (!node) return (0, $GIvev.spacingBetweenNodesForPreview).default;
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $GIvev.spacingBetweenNodesForPreview)[`heading${node.attrs.level}`] ?? (0, $GIvev.spacingBetweenNodesForPreview).default;
    return (0, $GIvev.spacingBetweenNodesForPreview)[nodeTypeName] ?? (0, $GIvev.spacingBetweenNodesForPreview).default;
};
const $ba3918255b5341a7$export$8f0a13ded3f90102 = (node)=>{
    if (!node) return (0, $GIvev.nodeMargins).default;
    const nodeTypeName = node.type.name;
    if (nodeTypeName === 'heading') return (0, $GIvev.nodeMargins)[`heading${node.attrs.level}`] ?? (0, $GIvev.nodeMargins).default;
    return (0, $GIvev.nodeMargins)[nodeTypeName] ?? (0, $GIvev.nodeMargins).default;
};

});

parcelRegister("8Z9L9", function(module, exports) {
$parcel$export(module.exports, "SurfaceEditorViewContext", () => $ed57bdde0804ea77$export$1de8070d9a6a8efd);
$parcel$export(module.exports, "useSurfaceEditorView", () => $ed57bdde0804ea77$export$3003b66c1c752635);

var $fc4bM = parcelRequire("fc4bM");
const $ed57bdde0804ea77$export$1de8070d9a6a8efd = (0, $fc4bM.createContext)(undefined);
const $ed57bdde0804ea77$export$3003b66c1c752635 = ()=>(0, $fc4bM.useContext)($ed57bdde0804ea77$export$1de8070d9a6a8efd);

});

parcelRegister("fSKKI", function(module, exports) {
$parcel$export(module.exports, "useBlockControlsSurfaceDragSource", () => $fd2fff7e0a6342f0$export$77d6d50d8dfae206);

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $c8sLM = parcelRequire("c8sLM");

var $l2xrI = parcelRequire("l2xrI");

var $3xl1j = parcelRequire("3xl1j");

var $3TAWV = parcelRequire("3TAWV");

var $dStWQ = parcelRequire("dStWQ");

var $7f0FC = parcelRequire("7f0FC");

var $3vskT = parcelRequire("3vskT");

var $fghja = parcelRequire("fghja");
const $fd2fff7e0a6342f0$export$77d6d50d8dfae206 = ({ api: api, elementRef: elementRef, getAnchorName: getAnchorName, getPos: getPos, nodeType: nodeType, start: start, view: view })=>{
    (0, $fc4bM.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || !view) return;
        return (0, $c8sLM.draggable)({
            element: element,
            getInitialData: ()=>({
                    type: 'element',
                    start: start
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                var _api$core, _api$blockControls$sh;
                api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                    const handlePos = getPos();
                    if (typeof handlePos !== 'number') return tr;
                    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings') && (0, $dStWQ.isCollapsedHeading)(api, handlePos)) {
                        (0, $dStWQ.prepareCollapsedHeadingSelection)({
                            api: api,
                            expand: false,
                            headingPos: handlePos,
                            tr: tr
                        });
                        return tr;
                    }
                    if (!tr.selection.empty && (0, $7f0FC.isHandleCorrelatedToSelection)(view.state, tr.selection, handlePos)) {
                        var _api$blockControls;
                        api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || _api$blockControls.commands.setMultiSelectPositions()({
                            tr: tr
                        });
                    } else tr = (0, $7f0FC.selectNode)(tr, handlePos, nodeType, api);
                    return tr;
                });
                const startPos = getPos();
                const { doc: doc, selection: selection } = view.state;
                let sliceFrom = selection.from;
                let sliceTo = selection.to;
                const multiSelect = api === null || api === void 0 || (_api$blockControls$sh = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh === void 0 ? void 0 : _api$blockControls$sh.multiSelectDnD;
                if (multiSelect) {
                    sliceFrom = Math.min(multiSelect.anchor, multiSelect.head);
                    sliceTo = Math.max(multiSelect.anchor, multiSelect.head);
                }
                const expandedSlice = doc.slice(sliceFrom, sliceTo);
                const isDraggingMultipleNodes = startPos !== undefined && startPos >= sliceFrom && startPos < sliceTo && expandedSlice.content.childCount > 1;
                (0, $l2xrI.setCustomNativeDragPreview)({
                    getOffset: ()=>{
                        if (!isDraggingMultipleNodes || startPos === undefined) return {
                            x: 0,
                            y: 0
                        };
                        const domAtPos = view.domAtPos.bind(view);
                        let heightBeforeHandle = 0;
                        let nodeStart = sliceFrom;
                        let activeNodeMarginTop = 0;
                        for(let index = 0; index < expandedSlice.content.childCount; index++){
                            const node = expandedSlice.content.maybeChild(index);
                            const nodeEnd = nodeStart + ((node === null || node === void 0 ? void 0 : node.nodeSize) ?? 0);
                            if (nodeEnd <= startPos) {
                                const nodeElement = (0, $a4TQr.findDomRefAtPos)(nodeStart, domAtPos);
                                const margins = (0, $3vskT.getNodeMarginsForDragPreview)(node);
                                heightBeforeHandle += (nodeElement instanceof HTMLElement ? nodeElement.offsetHeight : 0) + margins.top + margins.bottom;
                            } else {
                                activeNodeMarginTop = (0, $3vskT.getNodeMarginsForDragPreview)(node).top;
                                break;
                            }
                            nodeStart = nodeEnd;
                        }
                        return {
                            x: 0,
                            y: heightBeforeHandle + activeNodeMarginTop
                        };
                    },
                    render: ({ container: container })=>{
                        if (!isDraggingMultipleNodes && startPos !== undefined) {
                            const dom = (0, $a4TQr.findDomRefAtPos)(startPos, view.domAtPos.bind(view));
                            return dom instanceof HTMLElement ? (0, $fghja.dragPreview)(container, {
                                dom: dom,
                                nodeType: nodeType
                            }) : undefined;
                        }
                        const previewContent = [];
                        expandedSlice.content.descendants((node, pos)=>{
                            const dom = (0, $a4TQr.findDomRefAtPos)(sliceFrom + pos, view.domAtPos.bind(view));
                            if (dom instanceof HTMLElement) previewContent.push({
                                dom: dom,
                                nodeSpacing: (0, $3vskT.getNodeSpacingForDragPreview)(node),
                                nodeType: node.type.name
                            });
                            return false;
                        });
                        return previewContent.length > 0 ? (0, $fghja.dragPreview)(container, previewContent) : undefined;
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>{
                var _api$core2;
                if (start === undefined) return;
                // This handle is outside ProseMirror, so it owns the side effects normally started by PM.
                (0, $3xl1j.defaultActiveAnchorTracker).reset();
                api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
                    var _api$blockControls$sh2, _resolvedMovingNode$n, _api$blockControls2, _api$analytics;
                    const resolvedMovingNode = tr.doc.resolve(start);
                    const multiSelect = api === null || api === void 0 || (_api$blockControls$sh2 = api.blockControls.sharedState.currentState()) === null || _api$blockControls$sh2 === void 0 ? void 0 : _api$blockControls$sh2.multiSelectDnD;
                    const attributes = multiSelect ? (0, $3TAWV.getMultiSelectAnalyticsAttributes)(tr, multiSelect.anchor, multiSelect.head) : {
                        hasSelectedMultipleNodes: false,
                        nodeTypes: (_resolvedMovingNode$n = resolvedMovingNode.nodeAfter) === null || _resolvedMovingNode$n === void 0 ? void 0 : _resolvedMovingNode$n.type.name
                    };
                    api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.commands.setNodeDragged(getPos, getAnchorName(), nodeType)({
                        tr: tr
                    });
                    tr.setMeta('scrollIntoView', false);
                    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                        action: (0, $3LeME.ACTION).DRAGGED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ELEMENT_DRAG_HANDLE,
                        attributes: {
                            hasSelectedMultipleNodes: attributes.hasSelectedMultipleNodes,
                            nodeDepth: resolvedMovingNode.depth,
                            nodeTypes: attributes.nodeTypes || ''
                        },
                        eventType: (0, $3LeME.EVENT_TYPE).UI
                    })(tr);
                    return tr;
                });
                view.focus();
            }
        });
    }, [
        api,
        elementRef,
        getAnchorName,
        getPos,
        nodeType,
        start,
        view
    ]);
};

});



parcelRegister("lmsov", function(module, exports) {
$parcel$export(module.exports, "GlobalStylesWrapper", () => $47cdb10f75df846a$export$cc5403d58ddfa812);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $jctmk = parcelRequire("jctmk");

var $gCPs3 = parcelRequire("gCPs3");

var $f9ezd = parcelRequire("f9ezd");

var $fmnS6 = parcelRequire("fmnS6");

var $9oAqi = parcelRequire("9oAqi");

var $jWgCZ = parcelRequire("jWgCZ");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $GIvev = parcelRequire("GIvev");

var $dj84o = parcelRequire("dj84o");
function $47cdb10f75df846a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * This anchor element selector disregards anchors that are solely utilized for size measurements,
 * including those within table rows and media.
 */ const $47cdb10f75df846a$var$dragHandlerAnchorSelector = '[data-drag-handler-anchor-name]:not([data-drag-handler-node-type="tableRow"], [data-drag-handler-node-type="media"])';
/**
 * Disregards anchors that can not have handles next to them, and so shouldn't have an extended hover zone
 */ const $47cdb10f75df846a$var$dragHandlerAnchorSelectorNext = `[${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"])`;
/**
 * Extended version that also excludes descendants of taskList.
 * preventing the ::after hover zone from blocking checkbox inputs in blockTaskItem nodes.
 */ const $47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion = `[${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}]:not([data-prosemirror-node-name="tableRow"], [data-prosemirror-node-name="tableCell"],  [data-prosemirror-node-name="tableHeader"], [data-prosemirror-node-name="media"], [data-prosemirror-node-inline="true"], [data-prosemirror-node-name="taskList"] [${(0, $dj84o.NODE_ANCHOR_ATTR_NAME)}])`;
const $47cdb10f75df846a$var$gutterPaddingWidth = ()=>(0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? `${(0, $014x6.akEditorGutterPaddingDynamic)()}px` : '100%';
const $47cdb10f75df846a$var$gutterPaddingLeft = ()=>(0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? `-${(0, $014x6.akEditorGutterPaddingDynamic)()}px` : '-100px';
const $47cdb10f75df846a$var$extendedHoverZone = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`.block-ctrl-drag-preview ${$47cdb10f75df846a$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $GIvev.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $GIvev.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& [data-drag-handler-anchor-depth="0"]${$47cdb10f75df846a$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $47cdb10f75df846a$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $47cdb10f75df846a$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$47cdb10f75df846a$var$dragHandlerAnchorSelector}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // hover zone for layout column should be placed near the top of the column (where drag handle is)
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
            '&& [data-drag-handler-anchor-name][data-layout-column]::after': {
                content: '""',
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                top: `${-(0, $gCPs3.DRAG_HANDLE_WIDTH) / 2}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                height: `${(0, $gCPs3.DRAG_HANDLE_WIDTH)}px`,
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        //eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-blocks-drag-handle-container="true"] + [data-drag-handler-anchor-depth="0"]::after': {
            display: 'none'
        }
    });
const $47cdb10f75df846a$var$extendedHoverZoneNext = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`.block-ctrl-drag-preview ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
            display: 'none !important'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '.ProseMirror': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                left: `-${(0, $GIvev.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                width: `${(0, $GIvev.DRAG_HANDLE_MAX_WIDTH_PLUS_GAP)}px`,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            },
            // Top level depth hover zone should extend to gutter padding area
            // we select the top level by using NOT nested anchor selector
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $dj84o.NODE_ANCHOR_ATTR_NAME}] [${0, $dj84o.NODE_ANCHOR_ATTR_NAME}])::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: $47cdb10f75df846a$var$gutterPaddingLeft(),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: $47cdb10f75df846a$var$gutterPaddingWidth(),
                height: '100%',
                cursor: 'default',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                zIndex: -1
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`&& :is(.pm-table-cell-content-wrap, .pm-table-header-content-wrap) > ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: 0,
                height: '100%',
                cursor: 'default',
                zIndex: 1
            }
        },
        // TODO: ED-23995 - this style override needs to be moved to the Rule styles after FF cleanup packages/editor/editor-common/src/styles/shared/rule.ts
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        'hr[data-drag-handler-anchor-name]': {
            overflow: 'visible'
        },
        //Hide pseudo element at top depth level. Leave for nested depths to prevent mouseover loop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`[data-blocks-drag-handle-container="true"] + ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $dj84o.NODE_ANCHOR_ATTR_NAME}] [${0, $dj84o.NODE_ANCHOR_ATTR_NAME}])::after`]: {
            display: 'none'
        }
    });
const $47cdb10f75df846a$var$layoutColumnExtendedHoverZone = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // hover zone for layout column should be placed near the top of the column (where drag handle is)
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}[data-layout-column]::after`]: {
            content: '""',
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            top: `${-(0, $gCPs3.DRAG_HANDLE_WIDTH) / 2}px`,
            left: 0,
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            height: `${(0, $gCPs3.DRAG_HANDLE_WIDTH)}px`,
            cursor: 'default',
            zIndex: 1
        }
    }
});
const $47cdb10f75df846a$var$layoutColumnWithoutHoverZone = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // when advanced_layouts is off, layout columns should not have hover zones, because there aren't any drag handles for layout columns
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}[data-layout-column]::after`]: {
            display: 'none'
        }
    }
});
const $47cdb10f75df846a$var$extendHoverZoneReduced = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$47cdb10f75df846a$var$dragHandlerAnchorSelector}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $014x6.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $014x6.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $014x6.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $47cdb10f75df846a$var$extendHoverZoneReducedNext = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`> ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}::after`]: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            [`@container editor-area (max-width: ${0, $014x6.akEditorFullPageNarrowBreakout}px)`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                left: `-${(0, $014x6.akEditorGutterPaddingReduced)}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
                width: `${(0, $014x6.akEditorGutterPaddingReduced)}px`
            }
        }
    }
});
const $47cdb10f75df846a$var$extendedDragZone = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& [data-drag-handler-anchor-depth="0"]${$47cdb10f75df846a$var$dragHandlerAnchorSelector}::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $47cdb10f75df846a$var$extendedDragZoneNext = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorWithTaskExclusion}:not([${0, $dj84o.NODE_ANCHOR_ATTR_NAME}] [${0, $dj84o.NODE_ANCHOR_ATTR_NAME}])::after`]: {
            width: 'var(--ak-editor-max-container-width)',
            left: `calc((100% - var(--ak-editor-max-container-width))/2)`
        }
    }
});
const $47cdb10f75df846a$var$paragraphWithTrailingBreakAsOnlyChild = '+ :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $47cdb10f75df846a$var$indentatedParagraphWithTrailingBreakAsOnlyChild = '+ div.fabric-editor-indentation-mark > :is(p, h1, h2, h3, h4, h5, h6) > .ProseMirror-trailingBreak:only-child';
const $47cdb10f75df846a$var$paragraphWithPlaceholder = '+ p > .placeholder-decoration';
const $47cdb10f75df846a$var$dragHandleContainer = '.ProseMirror-widget[data-blocks-drag-handle-container="true"]';
const $47cdb10f75df846a$var$dragHandleSelector = 'button[data-testid="block-ctrl-drag-handle"]';
const $47cdb10f75df846a$var$dropTargetContainer = '.ProseMirror-widget[data-blocks-drop-target-container="true"]';
const $47cdb10f75df846a$var$dividerBodiedInCustomPanelWithNoIconSelector = '[data-panel-type].ak-editor-panel__no-icon .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + hr, [data-panel-type] hr:first-child';
const $47cdb10f75df846a$var$withInlineNodeStyleSelectors = [
    `${$47cdb10f75df846a$var$dragHandleContainer}:has(${$47cdb10f75df846a$var$paragraphWithTrailingBreakAsOnlyChild}) ${$47cdb10f75df846a$var$dragHandleSelector}`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:has(${$47cdb10f75df846a$var$indentatedParagraphWithTrailingBreakAsOnlyChild}) ${$47cdb10f75df846a$var$dragHandleSelector}`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:has(${$47cdb10f75df846a$var$paragraphWithPlaceholder}) ${$47cdb10f75df846a$var$dragHandleSelector}`
].join(', ');
const $47cdb10f75df846a$var$withFormatInLayoutStyleFixSelectors = [
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + .fabric-editor-font-size > p:first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + ${$47cdb10f75df846a$var$dropTargetContainer} + .fabric-editor-indentation-mark > p:first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + ${$47cdb10f75df846a$var$dropTargetContainer} + .fabric-editor-alignment > p:first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + ${$47cdb10f75df846a$var$dropTargetContainer} + .fabric-editor-font-size > p:first-child`,
    `${$47cdb10f75df846a$var$dropTargetContainer}:first-child + .fabric-editor-alignment > p:first-child`,
    `${$47cdb10f75df846a$var$dropTargetContainer}:first-child + .fabric-editor-indentation-mark > p:first-child`,
    `${$47cdb10f75df846a$var$dropTargetContainer}:first-child + .fabric-editor-font-size > p:first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`,
    `${$47cdb10f75df846a$var$dragHandleContainer}:first-child + .fabric-editor-font-size > :is(h1, h2, h3, h4, h5, h6):first-child`
].join(', ');
/**
 * Please do not change change transform to display:none, or visibility:hidden
 * Otherwise it might break composition input for Chrome
 * https://product-fabric.atlassian.net/browse/ED-24136
 */ const $47cdb10f75df846a$var$withInlineNodeStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [$47cdb10f75df846a$var$withInlineNodeStyleSelectors]: {
        transform: 'scale(0)'
    }
});
const $47cdb10f75df846a$var$legacyBreakoutWideLayoutStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    '.ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidthSmallViewport)}px`,
        '@media (width>=1280px)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            '--ak-editor--legacy-breakout-wide-layout-width': `${(0, $014x6.akEditorCalculatedWideLayoutWidth)}px`
        }
    }
});
const $47cdb10f75df846a$var$globalDnDStyle = {
    name: "rngdgu",
    styles: ".ProseMirror{[data-layout-content]{user-drag:none;}}"
};
var $47cdb10f75df846a$var$_ref = {
    name: "e9bpdb",
    styles: ".ProseMirror-widget:first-child + *:not([data-panel-type], .code-block, [data-node-type=\"nestedExpand\"], [data-node-type=\"expand\"], [data-layout-section=\"true\"], [data-prosemirror-node-name=\"bodiedSyncBlock\"]){margin-top:0 !important;}.ProseMirror-widget:first-child + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child, .ProseMirror-widget:first-child + .ProseMirror-widget + .fabric-editor-font-size > :is(p, h1, h2, h3, h4, h5, h6):first-child{margin-top:0 !important;}"
};
const $47cdb10f75df846a$var$globalStyles = ()=>$47cdb10f75df846a$var$_ref;
const $47cdb10f75df846a$var$withDividerInPanelStyleFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$47cdb10f75df846a$var$dividerBodiedInCustomPanelWithNoIconSelector}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
// during the platform_editor_lovability_dividers clean up, consolidate this into extendedHoverZoneNext
const $47cdb10f75df846a$var$withRuleOverflowStyleFix = {
    name: "1yioy5g",
    styles: "[data-rule-node-view][data-drag-handler-anchor-name]{overflow:visible;}"
};
const $47cdb10f75df846a$var$withDeleteLinesStyleFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`p[data-drag-handler-anchor-name] ${$47cdb10f75df846a$var$dragHandleContainer}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        display: 'none !important'
    }
});
// Image dnd is broken in Firefox due to a previous fix for image caption https://product-fabric.atlassian.net/browse/ED-14034
// We could remove this fix if the previous issue is invalid
const $47cdb10f75df846a$var$withMediaSingleStyleFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    ['.ProseMirror.ua-firefox .mediaSingleView-content-wrap[data-drag-handler-node-type="mediaSingle"][data-drag-handler-anchor-name], .ProseMirror.ua-firefox [data-drag-handler-anchor-name][data-drag-handler-node-type] .mediaSingleView-content-wrap']: {
        userSelect: 'auto',
        cursor: 'pointer'
    }
});
const $47cdb10f75df846a$var$withFormatInLayoutStyleFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$47cdb10f75df846a$var$withFormatInLayoutStyleFixSelectors}`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $47cdb10f75df846a$var$headingWithIndentationInLayoutStyleFix = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
    [`${$47cdb10f75df846a$var$dragHandleContainer}:first-child + .fabric-editor-indentation-mark > :is(h1, h2, h3, h4, h5, h6):first-child`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        marginTop: '0 !important'
    }
});
const $47cdb10f75df846a$var$withRelativePosStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelector}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelector}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $jWgCZ.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $47cdb10f75df846a$var$withRelativePosStyleNext = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorNext}`]: {
            position: 'relative'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values
        [`&& ${$47cdb10f75df846a$var$dragHandlerAnchorSelectorNext}:has(> .ProseMirror-trailingBreak:only-child)::before`]: {
            // Workaround to force safari to show the cursor on blank lines even when there is no content
            // See: CONFCLOUD-80210
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            content: `"${(0, $jWgCZ.ZERO_WIDTH_SPACE)}"`
        }
    }
});
const $47cdb10f75df846a$var$withAnchorNameZindexStyle = {
    name: "okzdt4",
    styles: ".ProseMirror{&& [data-drag-handler-anchor-depth=\"0\"][data-drag-handler-anchor-name]{z-index:1;}}"
};
const $47cdb10f75df846a$var$withAnchorNameZindexStyleNext = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
        [`&& [${0, $dj84o.NODE_ANCHOR_ATTR_NAME}]:not([${0, $dj84o.NODE_ANCHOR_ATTR_NAME}] [${0, $dj84o.NODE_ANCHOR_ATTR_NAME}])`]: {
            zIndex: 1
        }
    }
});
// This style is used to define width for block card (with datasource) that does not have layout
// In full-width editor, block card has width of full-width layout
// In fixed-width editor, block card has width of wide layout
const $47cdb10f75df846a$var$blockCardWithoutLayout = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ak-editor-content-area.fabric-editor--full-width-mode .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        '--ak-editor-block-card-width': `min(calc(100cqw - ${(0, $014x6.akEditorBreakoutPadding)}px), 1800px)`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '.ak-editor-content-area .ProseMirror .ProseMirror-widget[data-blocks-drop-target-container="true"]': {
        '--ak-editor-block-card-width': 'max(var(--ak-editor--legacy-breakout-wide-layout-width), var(--ak-editor--line-length))'
    }
});
const $47cdb10f75df846a$var$nextAnchorSelector = [
    '&[data-node-anchor]',
    // adjacent sibling with anchor
    '&:not([data-node-anchor]) [data-node-anchor]:first-of-type',
    // first nested anchor inside adjacent sibling
    '&.ProseMirror-widget + [data-node-anchor]',
    // adjacent sibling with anchor (when next to a widget like gap cursor)
    '&.ProseMirror-widget + :not([data-node-anchor]) [data-node-anchor]:first-of-type' // first nested anchor inside adjacent sibling (when next to a widget like gap cursor)
].join(', ');
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $47cdb10f75df846a$var$combinedControlsFallbackAnchorNames = `${(0, $GIvev.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME)}, ${(0, $GIvev.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME)}`;
const $47cdb10f75df846a$var$dragHandlerAnchorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-decorator-widget"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$47cdb10f75df846a$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-testid="block-ctrl-quick-insert-button"] + *': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            [`${$47cdb10f75df846a$var$nextAnchorSelector}`]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
                anchorName: `var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
            }
        }
    }
});
// Applies anchor-name via node decoration attributes rather than adjacency CSS selectors.
// This is more reliable than dragHandlerAnchorStyles which depends on DOM structure.
// Only nodes decorated with data-active-drag-handle / data-active-quick-insert get anchor-name.
const $47cdb10f75df846a$var$staticControlsAnchorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // Active node can be both drag-handle and quick-insert target. Expose all three names:
        // node anchor + both control-specific fallback anchors.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-active-drag-handle][data-active-quick-insert][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `${$47cdb10f75df846a$var$combinedControlsFallbackAnchorNames}, var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-active-drag-handle][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `${(0, $GIvev.ACTIVE_DRAG_HANDLE_FALLBACK_ANCHOR_NAME)}, var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-active-quick-insert][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `${(0, $GIvev.ACTIVE_QUICK_INSERT_FALLBACK_ANCHOR_NAME)}, var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
const $47cdb10f75df846a$var$sparseSurfaceAnchorName = 'var(--block-controls-surface-anchor-name)';
// Inner node-view boxes own the visible geometry for these nodes. The root arm keeps a sparse
// marker useful when a node view has not mounted its inner box yet.
const $47cdb10f75df846a$var$sparseSurfaceAnchorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="blockCard"]:has(.datasourceView-content-inner-wrap) .datasourceView-content-inner-wrap': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="blockCard"]:not(:has(.datasourceView-content-inner-wrap))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="bodiedExtension"]:has(.extension-container[data-layout]) .extension-container[data-layout]': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="bodiedExtension"]:not(:has(.extension-container[data-layout]))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="embedCard"]:has(.rich-media-item) .rich-media-item': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="embedCard"]:not(:has(.rich-media-item))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="extension"]:has(.extension-container[data-layout]) .extension-container[data-layout]': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="extension"]:not(:has(.extension-container[data-layout]))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="mediaSingle"]:has(.resizer-item) .resizer-item': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="mediaSingle"]:not(:has(.resizer-item))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="multiBodiedExtension"]:has(.extension-container[data-layout]) .extension-container[data-layout]': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="multiBodiedExtension"]:not(:has(.extension-container[data-layout]))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // `.pm-table-resizer-container` wraps the ENTIRE table, including cell content, so a
        // nested `mediaSingle`/ embed resizer inside a cell is also a descendant of it — a plain
        // descendant selector can't tell the table's own resize handle apart from a media resizer.
        // The table's own `.resizer-item.display-handle` is a direct child of
        // `.pm-table-resizer-container`, while any nested cell content sits many levels deeper, so
        // the `>` direct child combinator is required to avoid hijacking the table's anchor-name
        // onto a nested cell's media resizer instead of the table's own resize-handle chrome.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="table"]:has(.pm-table-resizer-container > .resizer-item) .pm-table-resizer-container > .resizer-item': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-block-controls-surface-anchor][data-block-controls-surface-node-type="table"]:not(:has(.pm-table-resizer-container > .resizer-item))': {
            anchorName: $47cdb10f75df846a$var$sparseSurfaceAnchorName
        }
    }
});
// Styles applied to nodes with anchors when dragging
const $47cdb10f75df846a$var$dragAnchorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:not([data-node-anchor] [data-node-anchor])': {
            // all top level nodes with anchor
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-node-anchor]:has([data-blocks-drop-target-container]) [data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-prosemirror-node-name="media"][data-node-anchor]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        },
        // first table row to avoid multiple anchors in table
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '[data-prosemirror-node-name="table"] [data-prosemirror-node-name="tableRow"][data-node-anchor]:first-of-type': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values
            anchorName: `var(${(0, $f9ezd.ANCHOR_VARIABLE_NAME)}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});
const $47cdb10f75df846a$export$cc5403d58ddfa812 = ({ api: api })=>{
    const { isDragging: isDraggingFromState } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'blockControls'
    ], (states)=>{
        var _states$blockControls;
        return {
            isDragging: (_states$blockControls = states.blockControlsState) === null || _states$blockControls === void 0 ? void 0 : _states$blockControls.isDragging
        };
    });
    const sparseSurfacesEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration');
    const isDragging = sparseSurfacesEnabled || (0, $aEmSo.expValEquals)('platform_editor_block_controls_perf_optimization', 'isEnabled', true) ? isDraggingFromState : false;
    const shouldRenderAnchors = (0, $f9ezd.isCSSAnchorSupported)() && (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true);
    const sparseSurfaceAnchorsEnabled = Boolean((0, $f9ezd.isCSSAnchorSupported)()) && sparseSurfacesEnabled;
    const toolbarFlagsEnabled = (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $jctmk.Global), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        styles: [
            $47cdb10f75df846a$var$globalStyles(),
            $47cdb10f75df846a$var$globalDnDStyle,
            (!sparseSurfacesEnabled || isDragging) && ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $47cdb10f75df846a$var$extendedHoverZoneNext() : $47cdb10f75df846a$var$extendedHoverZone()),
            isDragging && ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $47cdb10f75df846a$var$extendedDragZoneNext : $47cdb10f75df846a$var$extendedDragZone),
            (!sparseSurfacesEnabled || isDragging) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $47cdb10f75df846a$var$extendHoverZoneReducedNext : $47cdb10f75df846a$var$extendHoverZoneReduced : undefined,
            // platform_editor_controls note: this allows drag handles to render on empty lines
            toolbarFlagsEnabled ? undefined : $47cdb10f75df846a$var$withInlineNodeStyle,
            $47cdb10f75df846a$var$withDeleteLinesStyleFix,
            $47cdb10f75df846a$var$withMediaSingleStyleFix,
            $47cdb10f75df846a$var$legacyBreakoutWideLayoutStyle,
            $47cdb10f75df846a$var$headingWithIndentationInLayoutStyleFix,
            (0, $kaRof.editorExperiment)('advanced_layouts', true) ? $47cdb10f75df846a$var$blockCardWithoutLayout : undefined,
            $47cdb10f75df846a$var$withDividerInPanelStyleFix,
            (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_dividers') && $47cdb10f75df846a$var$withRuleOverflowStyleFix,
            $47cdb10f75df846a$var$withFormatInLayoutStyleFix,
            (!sparseSurfacesEnabled || isDragging) && ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $47cdb10f75df846a$var$withRelativePosStyleNext : $47cdb10f75df846a$var$withRelativePosStyle),
            (!sparseSurfacesEnabled || isDragging) && ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $47cdb10f75df846a$var$withAnchorNameZindexStyleNext : $47cdb10f75df846a$var$withAnchorNameZindexStyle),
            (!sparseSurfacesEnabled || isDragging) && (((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) && (0, $aEmSo.expValEquals)('advanced_layouts', 'isEnabled', true) ? $47cdb10f75df846a$var$layoutColumnExtendedHoverZone : $47cdb10f75df846a$var$layoutColumnWithoutHoverZone),
            sparseSurfaceAnchorsEnabled ? isDragging ? $47cdb10f75df846a$var$dragAnchorStyles : false : (0, $aEmSo.expValEquals)('platform_editor_controls_reliable_anchor', 'isEnabled', true) ? // dragAnchorStyles sets anchor-name on ALL nodes during drag (needed for drop target positioning).
            // staticControlsAnchorStyles handles anchor-name via node decorations for non-drag state.
            // shouldRenderAnchors guards both: only apply anchor styles on browsers that support CSS anchor positioning.
            shouldRenderAnchors ? isDragging ? $47cdb10f75df846a$var$dragAnchorStyles : $47cdb10f75df846a$var$staticControlsAnchorStyles : false : shouldRenderAnchors && (isDragging ? $47cdb10f75df846a$var$dragAnchorStyles : $47cdb10f75df846a$var$dragHandlerAnchorStyles),
            sparseSurfaceAnchorsEnabled && $47cdb10f75df846a$var$sparseSurfaceAnchorStyles
        ]
    });
};

});


parcelRegister("kEN0Z", function(module, exports) {
$parcel$export(module.exports, "borderPlugin", () => $4fbbb70dbcdcfb74$export$39349c329288443f);

var $fweje = parcelRequire("fweje");
const $4fbbb70dbcdcfb74$export$39349c329288443f = ()=>({
        name: 'border',
        marks () {
            return [
                {
                    name: 'border',
                    mark: (0, $fweje.border)
                }
            ];
        }
    });

});

parcelRegister("gfGIv", function(module, exports) {
$parcel$export(module.exports, "breakoutPlugin", () => $f301caaebd5e5701$export$f56f43f1e6905418);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $g37he = parcelRequire("g37he");

var $awZwm = parcelRequire("awZwm");

var $3OPXe = parcelRequire("3OPXe");
const $f301caaebd5e5701$export$f56f43f1e6905418 = ({ config: options, api: api })=>({
        name: 'breakout',
        pmPlugins () {
            return [
                {
                    name: 'breakout-resizing',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $awZwm.createResizingPlugin)(api, getIntl, nodeViewPortalProviderAPI, options)
                }
            ];
        },
        marks () {
            return [
                {
                    name: 'breakout',
                    mark: (0, $g37he.breakout)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                breakoutNode: undefined
            };
            const resizingPluginState = (0, $awZwm.resizingPluginKey).getState(editorState);
            if (!resizingPluginState) return {
                breakoutNode: undefined,
                activeGuidelineKey: undefined
            };
            return resizingPluginState;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3OPXe.GuidelineLabel), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        }
    });

});
parcelRegister("awZwm", function(module, exports) {
$parcel$export(module.exports, "resizingPluginKey", () => $e2c8cade2801f210$export$ca33a310187a5f87);
$parcel$export(module.exports, "createResizingPlugin", () => $e2c8cade2801f210$export$522e3e76a011a0b1);

var $1Iwe1 = parcelRequire("1Iwe1");

var $1y7gE = parcelRequire("1y7gE");

var $hX75d = parcelRequire("hX75d");
var $cCxON = parcelRequire("cCxON");

var $8E9x2 = parcelRequire("8E9x2");

var $eYaXU = parcelRequire("eYaXU");

var $801jp = parcelRequire("801jp");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $7r98Q = parcelRequire("7r98Q");

var $cuBtj = parcelRequire("cuBtj");

var $9eQSI = parcelRequire("9eQSI");
const $e2c8cade2801f210$var$getInitialBreakoutWidth = (node, isFullWidthEnabled, isMaxWidthEnabled)=>{
    if (isMaxWidthEnabled) return 0, $014x6.akEditorMaxWidthLayoutWidth;
    if (isFullWidthEnabled) return 0, $014x6.akEditorFullWidthLayoutWidth;
    // extensions store their legacy size in the `layout` attr, translate it so existing
    // wide and full-width extensions keep their width. `layout` is left unchanged for rollback.
    const { layout: layout } = node.attrs;
    if ((layout === 'wide' || layout === 'full-width') && (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) return layout === 'wide' ? (0, $014x6.akEditorCalculatedWideLayoutWidth) : (0, $014x6.akEditorFullWidthLayoutWidth);
    return 0, $014x6.akEditorDefaultLayoutWidth;
};
const $e2c8cade2801f210$var$addBreakoutToResizableNode = ({ node: node, pos: pos, newState: newState, newTr: newTr, breakoutResizableNodes: breakoutResizableNodes, isFullWidthEnabled: isFullWidthEnabled, isMaxWidthEnabled: isMaxWidthEnabled })=>{
    let updatedDocChanged = false;
    let updatedTr = newTr;
    const $pos = newState.doc.resolve(pos);
    const isTopLevelNode = ($pos === null || $pos === void 0 ? void 0 : $pos.depth) === 0;
    if (breakoutResizableNodes.has(node.type) && isTopLevelNode) {
        const { breakout: breakout } = newState.schema.marks;
        const { expand: expand } = newState.schema.nodes;
        const breakoutMark = node.marks.find((mark)=>mark.type === breakout);
        const isExpand = node.type === expand;
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_exts_patch_1')) {
            // native embeds own their resize functionality
            // remove breakout marks added by any resizing normalization
            if ((0, $1Iwe1.isNativeEmbedExtension)(node)) return {
                updatedTr: breakoutMark ? newTr.setNodeMarkup(pos, node.type, node.attrs, breakout.removeFromSet(node.marks)) : newTr,
                updatedDocChanged: !!breakoutMark
            };
        }
        if (!breakoutMark) {
            const width = $e2c8cade2801f210$var$getInitialBreakoutWidth(node, isFullWidthEnabled, isMaxWidthEnabled);
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
                const marks = breakout.create({
                    width: width
                }).addToSet(node.marks);
                updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, marks);
            } else updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width
                })
            ]);
            if (isExpand) (0, $9eQSI.updateExpandedStateNew)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        } else if ((breakoutMark === null || breakoutMark === void 0 ? void 0 : breakoutMark.attrs.width) === null || (breakoutMark === null || breakoutMark === void 0 ? void 0 : breakoutMark.attrs.width) === undefined) {
            const mode = breakoutMark.attrs.mode;
            // if breakout is present on node, but page appearance is 'full width' force width to full width to maintain backwards compatibility
            const width = isMaxWidthEnabled ? (0, $014x6.akEditorMaxWidthLayoutWidth) : isFullWidthEnabled || mode === 'full-width' ? (0, $014x6.akEditorFullWidthLayoutWidth) : (0, $014x6.akEditorCalculatedWideLayoutWidth);
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
                const marks = breakout.create({
                    width: width
                }).addToSet(node.marks);
                updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, marks);
            } else updatedTr = newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    width: width,
                    mode: mode
                })
            ]);
            if (isExpand) (0, $9eQSI.updateExpandedStateNew)({
                tr: updatedTr,
                node: node,
                pos: pos,
                isLivePage: true
            });
            updatedDocChanged = true;
        }
    }
    return {
        updatedTr: updatedTr,
        updatedDocChanged: updatedDocChanged
    };
};
const $e2c8cade2801f210$export$ca33a310187a5f87 = new (0, $801jp.PluginKey)('breakout-resizing');
const $e2c8cade2801f210$var$pluginState = {
    init () {
        return {
            breakoutNode: undefined,
            activeGuidelineLabel: undefined
        };
    },
    apply (tr, pluginState) {
        const meta = tr.getMeta($e2c8cade2801f210$export$ca33a310187a5f87);
        if (meta) switch(meta.type){
            case 'UPDATE_BREAKOUT_NODE':
                return {
                    ...pluginState,
                    breakoutNode: meta.data
                };
            case 'UPDATE_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: meta.data.activeGuidelineKey
                };
            case 'CLEAR_ACTIVE_GUIDELINE_KEY':
                return {
                    ...pluginState,
                    activeGuidelineKey: undefined
                };
            case 'RESET_STATE':
                return {
                    activeGuidelineLabel: undefined,
                    breakoutNode: undefined
                };
        }
        return pluginState;
    }
};
const $e2c8cade2801f210$var$requestIdleCallbackWithFallback = (callback)=>{
    if (typeof requestIdleCallback !== 'undefined') requestIdleCallback(callback);
    else // fallback to requestAnimationFrame for Safari
    requestAnimationFrame(callback);
};
const $e2c8cade2801f210$export$522e3e76a011a0b1 = (api, getIntl, nodeViewPortalProviderAPI, options)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $e2c8cade2801f210$export$ca33a310187a5f87,
        state: $e2c8cade2801f210$var$pluginState,
        props: {
            markViews: {
                breakout: (mark, view)=>{
                    return new (0, $cuBtj.ResizingMarkView)(mark, view, api, getIntl, nodeViewPortalProviderAPI);
                }
            },
            handleKeyDown: (0, $7r98Q.handleKeyDown)(api)
        },
        view: (editorView)=>{
            var _api$editorViewMode2;
            const isPageLoadNormalizationEnabled = (0, $aEmSo.expValEquals)('platform_editor_add_breakout_marks_on_page_load', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions');
            const isRuleAndPanelResizingEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
            if (!isPageLoadNormalizationEnabled && !isRuleAndPanelResizingEnabled) return {};
            /**
       * This performs a one-time scan of the document to add breakout marks
       * to nodes that don't have them. It's designed to run only once per
       * editor instance to avoid performance issues.
       */ const normalizeBreakoutResizableNodes = ()=>{
                var _api$editorViewMode;
                if ((api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view') return;
                const isFullWidthEnabled = !((options === null || options === void 0 ? void 0 : options.allowBreakoutButton) === true);
                const isMaxWidthEnabled = (options === null || options === void 0 ? void 0 : options.appearance) === 'max';
                const { state: state } = editorView;
                const breakoutResizableNodes = (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? (0, $cCxON.getBreakoutResizableNodeTypesNew)(state.schema) : (0, $hX75d.getBreakoutResizableNodeTypes)(state.schema, isRuleAndPanelResizingEnabled);
                let newTr = state.tr;
                let hasDocChanged = false;
                // scan the document for top-level resizable nodes
                state.doc.forEach((node, pos)=>{
                    if (!breakoutResizableNodes.has(node.type)) return;
                    const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $e2c8cade2801f210$var$addBreakoutToResizableNode({
                        node: node,
                        pos: pos,
                        newState: state,
                        newTr: newTr,
                        breakoutResizableNodes: breakoutResizableNodes,
                        isFullWidthEnabled: isFullWidthEnabled,
                        isMaxWidthEnabled: isMaxWidthEnabled
                    });
                    newTr = updatedTr;
                    hasDocChanged = hasDocChanged || updatedDocChanged;
                });
                if (hasDocChanged) editorView.dispatch(newTr.setMeta('addToHistory', false));
            };
            $e2c8cade2801f210$var$requestIdleCallbackWithFallback(normalizeBreakoutResizableNodes);
            const unsubscribeFromViewMode = api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if ((nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.mode) === 'edit') $e2c8cade2801f210$var$requestIdleCallbackWithFallback(normalizeBreakoutResizableNodes);
            });
            return {
                destroy: ()=>{
                    unsubscribeFromViewMode === null || unsubscribeFromViewMode === void 0 || unsubscribeFromViewMode();
                }
            };
        },
        appendTransaction (transactions, oldState, newState) {
            var _api$editorViewMode3;
            if ((api === null || api === void 0 || (_api$editorViewMode3 = api.editorViewMode) === null || _api$editorViewMode3 === void 0 || (_api$editorViewMode3 = _api$editorViewMode3.sharedState.currentState()) === null || _api$editorViewMode3 === void 0 ? void 0 : _api$editorViewMode3.mode) === 'view') return;
            let newTr = newState.tr;
            let hasDocChanged = false;
            const isRuleAndPanelResizingEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
            const breakoutResizableNodes = (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? (0, $cCxON.getBreakoutResizableNodeTypesNew)(newState.schema) : (0, $hX75d.getBreakoutResizableNodeTypes)(newState.schema, isRuleAndPanelResizingEnabled);
            const isFullWidthEnabled = !((options === null || options === void 0 ? void 0 : options.allowBreakoutButton) === true);
            const isMaxWidthEnabled = (options === null || options === void 0 ? void 0 : options.appearance) === 'max';
            const isPageLoadNormalizationEnabled = (0, $aEmSo.expValEquals)('platform_editor_add_breakout_marks_on_page_load', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions');
            if (!isPageLoadNormalizationEnabled && !isRuleAndPanelResizingEnabled && (0, $8E9x2.isReplaceDocOperation)(transactions, oldState)) newState.doc.forEach((node, pos)=>{
                const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $e2c8cade2801f210$var$addBreakoutToResizableNode({
                    node: node,
                    pos: pos,
                    newState: newState,
                    newTr: newTr,
                    breakoutResizableNodes: breakoutResizableNodes,
                    isFullWidthEnabled: isFullWidthEnabled,
                    isMaxWidthEnabled: isMaxWidthEnabled
                });
                newTr = updatedTr;
                hasDocChanged = hasDocChanged || updatedDocChanged;
            });
            else transactions.forEach((tr)=>{
                const isAddingResizableNodes = tr.steps.some((step)=>(0, $eYaXU.stepAddsOneOf)(step, breakoutResizableNodes));
                if (isAddingResizableNodes) {
                    const changedNodes = (0, $8E9x2.getChangedNodes)(tr);
                    changedNodes.forEach(({ node: node, pos: pos })=>{
                        const { updatedTr: updatedTr, updatedDocChanged: updatedDocChanged } = $e2c8cade2801f210$var$addBreakoutToResizableNode({
                            node: node,
                            pos: pos,
                            newState: newState,
                            newTr: newTr,
                            breakoutResizableNodes: breakoutResizableNodes,
                            isFullWidthEnabled: isFullWidthEnabled,
                            isMaxWidthEnabled: isMaxWidthEnabled
                        });
                        newTr = updatedTr;
                        hasDocChanged = hasDocChanged || updatedDocChanged;
                    });
                }
            });
            if (hasDocChanged) // This transaction normalizes a newly inserted node to the editor's default breakout
            // width. It is not a user resize and must not become an undo step — in particular, a
            // source synced block can be deleted permanently before Undo reaches this normalization.
            return newTr.setMeta('addToHistory', false);
        }
    });
};

});
parcelRegister("1Iwe1", function(module, exports) {
$parcel$export(module.exports, "isNativeEmbedExtension", () => $40566a319a10d211$export$7141bd7974541e45);

var $1fO1j = parcelRequire("1fO1j");
const $40566a319a10d211$export$7141bd7974541e45 = (node)=>{
    var _node$attrs, _node$attrs2;
    return node.type.name === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === (0, $1fO1j.NATIVE_EMBED_EXTENSION_TYPE) && typeof ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === 'string' && node.attrs.extensionKey.includes((0, $1fO1j.NATIVE_EMBED_EXTENSION_KEY));
};

});

parcelRegister("7r98Q", function(module, exports) {
$parcel$export(module.exports, "handleKeyDown", () => $98598d12f5f56ab4$export$bab59f27a7347e45);

var $dqFZv = parcelRequire("dqFZv");

var $hX75d = parcelRequire("hX75d");
var $cCxON = parcelRequire("cCxON");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $7cqXX = parcelRequire("7cqXX");

var $14Wht = parcelRequire("14Wht");
const $98598d12f5f56ab4$var$KEYBOARD_RESIZE_STEP = 10;
const $98598d12f5f56ab4$var$getKeyboardResizeWidth = (currentWidth, step, api)=>{
    const containerWidth = (0, $14Wht.getResizeContainerWidth)(api);
    const resizeStartWidth = Math.min(currentWidth, containerWidth);
    return (0, $14Wht.clampWidthToResizeBounds)(resizeStartWidth + step, containerWidth);
};
const $98598d12f5f56ab4$var$getAncestorResizableNode = (view, breakoutResizableNodes)=>{
    const selection = view.state.selection;
    if (selection instanceof (0, $801jp.NodeSelection)) {
        const selectedNode = selection.node;
        if (breakoutResizableNodes.has(selectedNode.type)) return {
            node: selectedNode,
            pos: selection.$from.pos
        };
    } else if (selection instanceof (0, $801jp.TextSelection)) {
        let node = null;
        let nodePos = null;
        // only top level nodes are resizable
        const resolvedPos = view.state.doc.resolve(selection.$from.pos);
        const currentNode = resolvedPos.node(1);
        if (breakoutResizableNodes.has(currentNode.type)) {
            node = currentNode;
            nodePos = resolvedPos.before(1);
            return {
                node: node,
                pos: nodePos
            };
        }
    }
    return null;
};
const $98598d12f5f56ab4$export$bab59f27a7347e45 = (api)=>(view, event)=>{
        const browser = (0, $dqFZv.getBrowserInfo)();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        if (metaKey && event.altKey && isBracketKey) {
            const breakoutResizableNodes = (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? (0, $cCxON.getBreakoutResizableNodeTypesNew)(view.state.schema) : (0, $hX75d.getBreakoutResizableNodeTypes)(view.state.schema, (0, $aEmSo.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true));
            const result = $98598d12f5f56ab4$var$getAncestorResizableNode(view, breakoutResizableNodes);
            if (result) {
                const { node: node, pos: pos } = result;
                const breakoutMark = node === null || node === void 0 ? void 0 : node.marks.find((mark)=>mark.type.name === 'breakout');
                if (breakoutMark) {
                    const step = event.code === 'BracketRight' ? $98598d12f5f56ab4$var$KEYBOARD_RESIZE_STEP : -$98598d12f5f56ab4$var$KEYBOARD_RESIZE_STEP;
                    const newWidth = $98598d12f5f56ab4$var$getKeyboardResizeWidth(breakoutMark.attrs.width, step, api);
                    if (newWidth !== breakoutMark.attrs.width) {
                        var _api$editorViewMode;
                        const isEditMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'edit';
                        (0, $7cqXX.setBreakoutWidth)(newWidth, breakoutMark.attrs.mode, pos, isEditMode)(view.state, view.dispatch);
                        view.focus();
                    }
                    return true;
                }
            }
        }
        return false;
    };

});
parcelRegister("7cqXX", function(module, exports) {
$parcel$export(module.exports, "setBreakoutWidth", () => $cbf670b7b28cc501$export$2347aa63864fccd4);

var $2sI9z = parcelRequire("2sI9z");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $9eQSI = parcelRequire("9eQSI");
function $cbf670b7b28cc501$export$2347aa63864fccd4(width, mode, pos, isLivePage) {
    return (state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        let tr;
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) {
            const marks = state.schema.marks.breakout.create({
                width: width,
                mode: mode
            }).addToSet(node.marks);
            tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
        } else tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, [
            state.schema.marks.breakout.create({
                width: width,
                mode: mode
            })
        ]);
        if (node.type === state.schema.nodes.expand) (0, $9eQSI.updateExpandedStateNew)({
            tr: tr,
            node: node,
            pos: pos,
            isLivePage: isLivePage
        });
        else if (node.type === state.schema.nodes.codeBlock) {
            const newNode = tr.doc.nodeAt(pos);
            const oldNode = node;
            if (newNode) (0, $2sI9z.transferCodeBlockWrappedValue)(oldNode, newNode);
        }
        tr.setMeta('scrollIntoView', false);
        // keep current selection, necessary to not remove NodeSelection for keyboard resizing
        if (state.selection instanceof (0, $801jp.NodeSelection) && state.selection.node.eq(node)) tr.setSelection((0, $801jp.NodeSelection).create(tr.doc, pos));
        if (dispatch) dispatch(tr);
        return true;
    };
}

});
parcelRegister("9eQSI", function(module, exports) {
$parcel$export(module.exports, "updateExpandedStateNew", () => $24f665793564e47e$export$cc135306f1c4ff36);

var $hIUTz = parcelRequire("hIUTz");

var $aEmSo = parcelRequire("aEmSo");
const $24f665793564e47e$export$cc135306f1c4ff36 = ({ tr: tr, node: node, pos: pos, isLivePage: isLivePage })=>{
    if (isLivePage || (0, $aEmSo.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) {
        const wasExpandExpanded = (0, $hIUTz.expandedState).get(node);
        const newExpand = tr.doc.nodeAt(pos);
        if (wasExpandExpanded !== undefined && newExpand) (0, $hIUTz.expandedState).set(newExpand, wasExpandExpanded);
    }
};
const $24f665793564e47e$export$322e23ed7d99ab86 = (tr, node, isLivePage)=>{
    $24f665793564e47e$export$cc135306f1c4ff36({
        tr: tr,
        node: node.node,
        pos: node.pos,
        isLivePage: isLivePage
    });
};

});


parcelRegister("14Wht", function(module, exports) {
$parcel$export(module.exports, "WIDTHS", () => $e74405af47361bb8$export$66c2d241f2aa07a3);
$parcel$export(module.exports, "getResizeContainerWidth", () => $e74405af47361bb8$export$1a936a589e97b653);
$parcel$export(module.exports, "clampWidthToResizeBounds", () => $e74405af47361bb8$export$7568354ddf1b7e67);

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");
const $e74405af47361bb8$export$66c2d241f2aa07a3 = {
    FULL: (0, $014x6.akEditorFullWidthLayoutWidth),
    MAX: (0, $014x6.akEditorMaxLayoutWidth),
    MIN: (0, $014x6.akEditorDefaultLayoutWidth),
    WIDE: (0, $014x6.akEditorCalculatedWideLayoutWidth)
};
const $e74405af47361bb8$export$1a936a589e97b653 = (api)=>{
    var _api$width$sharedStat;
    const editorWidth = (api === null || api === void 0 || (_api$width$sharedStat = api.width.sharedState) === null || _api$width$sharedStat === void 0 || (_api$width$sharedStat = _api$width$sharedStat.currentState()) === null || _api$width$sharedStat === void 0 ? void 0 : _api$width$sharedStat.width) ?? 0;
    const padding = editorWidth <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
    return editorWidth - 2 * padding - (0, $014x6.akEditorGutterPadding);
};
const $e74405af47361bb8$export$7568354ddf1b7e67 = (proposedWidth, containerWidth)=>{
    return Math.max($e74405af47361bb8$export$66c2d241f2aa07a3.MIN, Math.min(proposedWidth, containerWidth, $e74405af47361bb8$export$66c2d241f2aa07a3.MAX));
};

});


parcelRegister("cuBtj", function(module, exports) {
$parcel$export(module.exports, "LOCAL_RESIZE_PROPERTY", () => $a2d431d0b1184dc7$export$4ce5e59f44ac1e3e);
$parcel$export(module.exports, "ResizingMarkView", () => $a2d431d0b1184dc7$export$4fb684fac6535bde);

var $NfMFQ = parcelRequire("NfMFQ");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $9rdrh = parcelRequire("9rdrh");

var $aRO2g = parcelRequire("aRO2g");
const $a2d431d0b1184dc7$export$4ce5e59f44ac1e3e = '--local-resizing-width';
const $a2d431d0b1184dc7$var$RESIZE_HANDLE_TRACK_WIDTH = '7px';
// this function delays the resizer callbacks until the mark view DOM is attached to the DOM
const $a2d431d0b1184dc7$var$scheduleResizeHandleSetup = (callback)=>{
    if (typeof window === 'undefined') return ()=>{};
    if (typeof window.requestAnimationFrame === 'function') {
        const frame = window.requestAnimationFrame(callback);
        return ()=>window.cancelAnimationFrame(frame);
    }
    const timeout = window.setTimeout(callback, 0);
    return ()=>window.clearTimeout(timeout);
};
class $a2d431d0b1184dc7$export$4fb684fac6535bde {
    /**
   * Wrap node view in a resizing mark view
   * @param {Mark} mark - The breakout mark to resize
   * @param {EditorView} view - The editor view
   * @param {ExtractInjectionAPI<BreakoutPlugin> | undefined} api - The pluginInjectionAPI
   * @param {Function} getIntl - () => IntlShape
   * @param {PortalProviderAPI} - The nodeViewPortalProviderAPI
   * @example
   * ```ts
   * ```
   */ constructor(mark, view, api, getIntl, nodeViewPortalProviderAPI){
        this.isResizingInitialised = false;
        var _api$editorViewMode, _api$editorViewMode2;
        const dom = document.createElement('div');
        const contentDOM = document.createElement('div');
        contentDOM.className = (0, $NfMFQ.BreakoutCssClassName).BREAKOUT_MARK_DOM;
        contentDOM.setAttribute('data-testid', 'ak-editor-breakout-mark-dom');
        dom.className = (0, $NfMFQ.BreakoutCssClassName).BREAKOUT_MARK;
        dom.setAttribute('data-layout', mark.attrs.mode);
        dom.setAttribute('data-testid', 'ak-editor-breakout-mark');
        const isRemoveLeftResizeHandleEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        const isResizingDividersPanelsEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true);
        const isResizingExtensionsEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions');
        // DOM styles
        // Keep a three-column grid even when the left resize handle is disabled. The empty
        // left track preserves the original content alignment without translating `contentDOM`,
        // so floating UI anchored to the node (for example block drag handles) keeps its position.
        dom.style.transform = 'none';
        dom.style.display = 'grid';
        dom.style.justifyContent = 'center';
        // contentDOM styles
        contentDOM.style.gridColumn = '2';
        contentDOM.style.zIndex = '1';
        if (mark.attrs.width) dom.style.gridTemplateColumns = isResizingDividersPanelsEnabled || isResizingExtensionsEnabled || isRemoveLeftResizeHandleEnabled ? // new code - phantom left track + content + right handle
        `${$a2d431d0b1184dc7$var$RESIZE_HANDLE_TRACK_WIDTH} max(var(--ak-editor--breakout-min-width), min(var(${$a2d431d0b1184dc7$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) ${$a2d431d0b1184dc7$var$RESIZE_HANDLE_TRACK_WIDTH}` : // old code - left handle + content + right handle
        `auto max(var(--ak-editor--breakout-min-width), min(var(${$a2d431d0b1184dc7$export$4ce5e59f44ac1e3e}, ${mark.attrs.width}px), var(--ak-editor--breakout-fallback-width))) auto`;
        else {
            if (isResizingDividersPanelsEnabled || isResizingExtensionsEnabled || isRemoveLeftResizeHandleEnabled) dom.style.gridTemplateColumns = `${$a2d431d0b1184dc7$var$RESIZE_HANDLE_TRACK_WIDTH} auto ${$a2d431d0b1184dc7$var$RESIZE_HANDLE_TRACK_WIDTH}`;
            if (mark.attrs.mode === 'wide') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$a2d431d0b1184dc7$export$4ce5e59f44ac1e3e}, var(--ak-editor--breakout-wide-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
            if (mark.attrs.mode === 'full-width') contentDOM.style.width = `max(var(--ak-editor--line-length), min(var(${$a2d431d0b1184dc7$export$4ce5e59f44ac1e3e}, var(--ak-editor--full-width-layout-width)), calc(100cqw - var(--ak-editor--breakout-full-page-guttering-padding))))`;
        }
        dom.appendChild(contentDOM);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.view = view;
        this.mark = mark;
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        const isLiveViewMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
        if (!isLiveViewMode) !(0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_forced_layout') && ((0, $dRkX9.fg)('platform_editor_lovability_resize_gracefully') || (0, $dRkX9.fg)('platform_editor_lovability_resize_exts_gracefully')) ? this.setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingDividersPanelsEnabled, isResizingExtensionsEnabled, api) : this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        this.unsubscribeToViewModeChange = api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.sharedState.onChange((sharedState)=>{
            var _sharedState$nextShar, _sharedState$prevShar;
            if (((_sharedState$nextShar = sharedState.nextSharedState) === null || _sharedState$nextShar === void 0 ? void 0 : _sharedState$nextShar.mode) !== ((_sharedState$prevShar = sharedState.prevSharedState) === null || _sharedState$prevShar === void 0 ? void 0 : _sharedState$prevShar.mode)) {
                var _sharedState$nextShar4, _sharedState$nextShar5;
                if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_forced_layout') && ((0, $dRkX9.fg)('platform_editor_lovability_resize_gracefully') || (0, $dRkX9.fg)('platform_editor_lovability_resize_exts_gracefully'))) {
                    var _sharedState$nextShar2, _sharedState$nextShar3;
                    if (((_sharedState$nextShar2 = sharedState.nextSharedState) === null || _sharedState$nextShar2 === void 0 ? void 0 : _sharedState$nextShar2.mode) === 'view') {
                        var _this$cancelScheduled;
                        (_this$cancelScheduled = this.cancelScheduledResizeHandleSetup) === null || _this$cancelScheduled === void 0 || _this$cancelScheduled.call(this);
                        this.cancelScheduledResizeHandleSetup = undefined;
                        if (this.isResizingInitialised) {
                            var _this$destroyFn;
                            (_this$destroyFn = this.destroyFn) === null || _this$destroyFn === void 0 || _this$destroyFn.call(this, true);
                            this.isResizingInitialised = false;
                        }
                    } else if (((_sharedState$nextShar3 = sharedState.nextSharedState) === null || _sharedState$nextShar3 === void 0 ? void 0 : _sharedState$nextShar3.mode) === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingDividersPanelsEnabled, isResizingExtensionsEnabled, api);
                } else if (((_sharedState$nextShar4 = sharedState.nextSharedState) === null || _sharedState$nextShar4 === void 0 ? void 0 : _sharedState$nextShar4.mode) === 'view' && this.isResizingInitialised) {
                    var _this$destroyFn2;
                    (_this$destroyFn2 = this.destroyFn) === null || _this$destroyFn2 === void 0 || _this$destroyFn2.call(this, true);
                    this.isResizingInitialised = false;
                } else if (((_sharedState$nextShar5 = sharedState.nextSharedState) === null || _sharedState$nextShar5 === void 0 ? void 0 : _sharedState$nextShar5.mode) === 'edit' && !this.isResizingInitialised) this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            }
        });
    }
    setupResizerCallbacks(dom, contentDOM, view, mark, api) {
        const callbacks = (0, $aRO2g.createResizerCallbacks)({
            dom: dom,
            view: view,
            mark: mark,
            api: api
        });
        const { leftHandle: leftHandle, rightHandle: rightHandle, destroy: destroy } = (0, $9rdrh.createPragmaticResizer)({
            target: contentDOM,
            ...callbacks,
            intl: this.intl,
            nodeViewPortalProviderAPI: this.nodeViewPortalProviderAPI
        });
        if (leftHandle) this.dom.prepend(leftHandle);
        this.dom.appendChild(rightHandle);
        this.destroyFn = destroy;
        this.isResizingInitialised = true;
    }
    setupResizerCallbacksIfSupported(dom, contentDOM, view, mark, isResizingDividersPanelsEnabled, isResizingExtensionsEnabled, api) {
        var _this$cancelScheduled2;
        // cancel any pending setup before scheduling a new one
        (_this$cancelScheduled2 = this.cancelScheduledResizeHandleSetup) === null || _this$cancelScheduled2 === void 0 || _this$cancelScheduled2.call(this);
        this.cancelScheduledResizeHandleSetup = undefined;
        // if breakout resizing is supported,
        // continue to set up the resizer callbacks
        if (isResizingDividersPanelsEnabled && isResizingExtensionsEnabled) {
            this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
            return;
        }
        // else if breakout resizing is not supported,
        // do NOT set up the resizer callbacks (yet)
        // wait for the mark view DOM to be attached to the DOM first
        this.cancelScheduledResizeHandleSetup = $a2d431d0b1184dc7$var$scheduleResizeHandleSetup(()=>{
            var _view$state$doc$nodeA;
            this.cancelScheduledResizeHandleSetup = undefined;
            if (view.isDestroyed || !dom.isConnected) return;
            const pos = view.posAtDOM(dom, 0);
            const nodeName = (_view$state$doc$nodeA = view.state.doc.nodeAt(pos)) === null || _view$state$doc$nodeA === void 0 ? void 0 : _view$state$doc$nodeA.type.name;
            // if the node is a panel or a rule but resizing is not supported, do NOT set up the resizer callbacks
            // if the node is an extension but resizing is not supported, do NOT set up the resizer callbacks
            if (nodeName && [
                'panel',
                'rule',
                'panel_c1'
            ].includes(nodeName) && !isResizingDividersPanelsEnabled || nodeName && [
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ].includes(nodeName) && !isResizingExtensionsEnabled || this.isResizingInitialised) return;
            // else, continue to set up the resizer callbacks
            this.setupResizerCallbacks(dom, contentDOM, view, mark, api);
        });
    }
    ignoreMutation() {
        return true;
    }
    destroy() {
        var _this$destroyFn3, _this$unsubscribeToVi, _this$cancelScheduled3;
        (_this$destroyFn3 = this.destroyFn) === null || _this$destroyFn3 === void 0 || _this$destroyFn3.call(this);
        (_this$unsubscribeToVi = this.unsubscribeToViewModeChange) === null || _this$unsubscribeToVi === void 0 || _this$unsubscribeToVi.call(this);
        (_this$cancelScheduled3 = this.cancelScheduledResizeHandleSetup) === null || _this$cancelScheduled3 === void 0 || _this$cancelScheduled3.call(this);
    }
}

});
parcelRegister("9rdrh", function(module, exports) {
$parcel$export(module.exports, "createPragmaticResizer", () => $5990c4e70b8e78a7$export$2023dee10a108a1);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $hqUa9 = parcelRequire("hqUa9");

var $6poP0 = parcelRequire("6poP0");

var $bcN2K = parcelRequire("bcN2K");

var $c8sLM = parcelRequire("c8sLM");

var $5rum3 = parcelRequire("5rum3");

var $4iuuQ = parcelRequire("4iuuQ");

var $aEmSo = parcelRequire("aEmSo");

var $3NBIB = parcelRequire("3NBIB");

var $bcTS3 = parcelRequire("bcTS3");
const $5990c4e70b8e78a7$var$getNodeName = (nodeName)=>{
    if (nodeName === 'layoutSection') return 'layout';
    else if (nodeName === 'codeBlock' || nodeName === 'expand') return nodeName;
    else if ((nodeName === 'rule' || nodeName === 'panel' || nodeName === 'panel_c1') && (0, $3NBIB.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true)) return nodeName;
    else if ((nodeName === 'extension' || nodeName === 'bodiedExtension' || nodeName === 'multiBodiedExtension') && (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) return nodeName;
    else return 'node';
};
/**
 * Read by `.pm-breakout-resize-tooltip-anchor`, declared in `editor-core`'s `resizerStyles.ts` and
 * its Compiled mirror. Rename in all three or the tooltip pins to the top of the rail.
 */ const $5990c4e70b8e78a7$var$tooltipAnchorTopVar = '--pm-breakout-resize-tooltip-anchor-top';
const $5990c4e70b8e78a7$export$5c0a5eee165b9845 = {
    expand: (0, $hqUa9.messages).resizeExpand,
    codeBlock: (0, $hqUa9.messages).resizeCodeBlock,
    layout: (0, $hqUa9.messages).resizeLayout,
    rule: (0, $hqUa9.messages).resizeRule,
    panel: (0, $hqUa9.messages).resizePanel,
    panel_c1: (0, $hqUa9.messages).resizePanel,
    node: (0, $hqUa9.messages).resizeElement,
    extension: (0, $hqUa9.messages).resizeExtension,
    bodiedExtension: (0, $hqUa9.messages).resizeExtension,
    multiBodiedExtension: (0, $hqUa9.messages).resizeExtension
};
/**
 * Remove during `platform_editor_use_vanilla_components` cleanup — replaced by
 * `createHandleTooltip`, which does the same job without a React tree per resize handle.
 */ const $5990c4e70b8e78a7$var$RailWithTooltip = ({ rail: rail, target: target, intl: intl })=>{
    const [nodeName, setNodeName] = (0, $fc4bM.useState)('node');
    (0, $fc4bM.useLayoutEffect)(()=>{
        const node = target.querySelector('[data-prosemirror-node-name]');
        const name = $5990c4e70b8e78a7$var$getNodeName(node === null || node === void 0 ? void 0 : node.dataset.prosemirrorNodeName);
        setNodeName(name);
    }, [
        target
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: intl.formatMessage($5990c4e70b8e78a7$export$5c0a5eee165b9845[nodeName]),
        position: "mouse",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "pm-breakout-resize-handle-rail-inside-tooltip",
            ref: (el)=>{
                if (el && rail.parentNode !== el) el.appendChild(rail);
            }
        })
    });
};
/** Identifies the vanilla tooltip for tests and debugging. */ const $5990c4e70b8e78a7$var$TOOLTIP_CLASS_NAME = 'pm-breakout-resize-tooltip';
/**
 * Classes applied to the tooltip element: the shared default look, plus our own hook. The default
 * still reaches a `[popover]` because the tooltip is painted in the top layer but stays in the DOM
 * under `.ProseMirror`.
 */ const $5990c4e70b8e78a7$var$TOOLTIP_CLASS_NAMES = `${(0, $6poP0.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$5990c4e70b8e78a7$var$TOOLTIP_CLASS_NAME}`;
/**
 * Vanilla DOM equivalent of `RailWithTooltip`, behind `platform_editor_use_vanilla_components`.
 *
 * Anchored to a point rather than to the rail, which spans the node's full height and would strand
 * the tooltip at the top of a tall node. This reproduces the control arm's `position="mouse"`,
 * which latches the cursor as the tooltip opens and does not move it afterwards — so no cursor
 * tracking is needed, just one style write per hover.
 */ const $5990c4e70b8e78a7$var$createHandleTooltip = ({ anchor: anchor, intl: intl, target: target })=>{
    // Only correct once ProseMirror has populated `contentDOM`, so callers must build on first
    // hover — earlier reads fall back to the generic 'node' label.
    const node = target.querySelector('[data-prosemirror-node-name]');
    const nodeName = $5990c4e70b8e78a7$var$getNodeName(node === null || node === void 0 ? void 0 : node.dataset.prosemirrorNodeName);
    return new (0, $6poP0.VanillaTooltip)(anchor, intl.formatMessage($5990c4e70b8e78a7$export$5c0a5eee165b9845[nodeName]), // Let the tooltip generate its own id.
    undefined, $5990c4e70b8e78a7$var$TOOLTIP_CLASS_NAMES, // Default delay, matching the ADS tooltip.
    300, // No inline styles
    undefined, // No `onShow`.
    undefined, // Below the cursor, matching the control arm's `position="mouse"`.
    'bottom');
};
const $5990c4e70b8e78a7$export$2023dee10a108a1 = ({ target: target, onDragStart: onDragStart, onDrag: onDrag, onDrop: onDrop, intl: intl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
    let state = 'default';
    const isLeftResizeHandleDisabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions') || (0, $bcN2K.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
    const createHandle = (side)=>{
        const handle = document.createElement('div');
        handle.contentEditable = 'false';
        handle.classList.add('pm-breakout-resize-handle-container');
        handle.style.gridColumn = side === 'left' ? '1' : '3';
        const rail = document.createElement('div');
        rail.classList.add('pm-breakout-resize-handle-rail');
        if (side === 'left') {
            handle.classList.add('pm-breakout-resize-handle-container--left');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-left');
        } else {
            handle.classList.add('pm-breakout-resize-handle-container--right');
            handle.setAttribute('data-testid', 'pragmatic-resizer-handle-right');
        }
        const handleHitBox = document.createElement('div');
        handleHitBox.classList.add('pm-breakout-resize-handle-hit-box');
        const thumb = document.createElement('div');
        thumb.classList.add('pm-breakout-resize-handle-thumb');
        thumb.style.pointerEvents = 'none';
        rail.appendChild(thumb);
        // Marks the point the pointer entered the rail, and anchors the tooltip there: zero height
        // so it is a point not a box, full rail width so the tooltip centres like the control arm.
        //
        // Must stay a child of `rail` — `openTooltipAt` sets `top` from the rail's `offsetY`, which
        // only lines up while the rail is the containing block. jsdom cannot catch a wrong parent.
        //
        // Not built on the control arm, which must keep byte-identical DOM.
        let tooltipAnchor;
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            // Positioned by `.pm-breakout-resize-tooltip-anchor`; only the pointer's Y is passed in.
            tooltipAnchor = document.createElement('div');
            tooltipAnchor.classList.add('pm-breakout-resize-tooltip-anchor');
            rail.appendChild(tooltipAnchor);
        }
        const tooltipContainer = document.createElement('div');
        tooltipContainer.classList.add('pm-breakout-resize-handle-rail-wrapper');
        handle.appendChild(tooltipContainer);
        handle.appendChild(handleHitBox);
        const key = crypto.randomUUID();
        const renderTooltip = ()=>nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $3LM7S.jsx)($5990c4e70b8e78a7$var$RailWithTooltip, {
                    rail: rail,
                    target: target,
                    intl: intl
                }), tooltipContainer, key);
        let vanillaTooltip;
        // Tracks whether there is anything to tear down: the tooltip mounts on first hover and so
        // may never mount at all.
        let isTooltipMounted = false;
        const mountTooltip = ()=>{
            if (isTooltipMounted) return;
            isTooltipMounted = true;
            // `tooltipAnchor` is always set when the experiment is on; the check also narrows it.
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_use_vanilla_components') && tooltipAnchor) {
                vanillaTooltip = $5990c4e70b8e78a7$var$createHandleTooltip({
                    anchor: tooltipAnchor,
                    target: target,
                    intl: intl
                });
                return;
            }
            // `RailWithTooltip`'s ref moves `rail` into the tooltip wrapper, so the DOM ends up
            // identical to the pre-mount state below.
            renderTooltip();
        };
        // React 18 registers ~130 native event listeners on every portal container (see
        // `listenToAllSupportedEvents`), and never removes them. Mounting this tooltip up front
        // costs that for every resizable node in the document — two containers per node when the
        // left handle is enabled — even though only the hovered handle can ever show a tooltip.
        //
        // Instead, park `rail` directly in the wrapper and mount the tooltip on the first
        // `mouseenter` of the node (see `registerEvents` below). The rail has `opacity: 0` until
        // the pointer is inside the node, so the pre-mount DOM is never visible, and the
        // `mouseenter` fires on the whole node — long before the pointer reaches the 7px handle.
        //
        // Parking the rail also needs `width: 100%`: without the ADS tooltip's wrappers (stretched
        // by `pragmaticResizerStylesForTooltip`) it would size to its content as a flex item.
        rail.style.width = '100%';
        tooltipContainer.appendChild(rail);
        return {
            handle: handle,
            rail: rail,
            tooltipAnchor: // Exposed so the rail's hover listeners can position and open the tooltip.
            tooltipAnchor,
            handleHitBox: handleHitBox,
            mountTooltip: mountTooltip,
            destroyTooltip: ()=>{
                // Re-read is safe: the gate is fixed for the page, so it matches what `mountTooltip`
                // saw. At cleanup, keep this body and delete the control arm below.
                if ((0, $bcN2K.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
                    // May never have mounted, and there is no portal to remove either way.
                    if (vanillaTooltip) {
                        vanillaTooltip.destroy();
                        vanillaTooltip = undefined;
                    }
                    isTooltipMounted = false;
                    return;
                }
                // The tooltip mounts on first hover, so `destroyTooltip` can be reached without
                // anything having been mounted.
                if (!isTooltipMounted) return;
                nodeViewPortalProviderAPI.remove(key);
                isTooltipMounted = false;
            }
        };
    };
    const rightHandle = createHandle('right');
    // Remove const leftHandle during 'platform_editor_lovability_resize_dividers_panels' cleanup
    const leftHandle = isLeftResizeHandleDisabled ? undefined : createHandle('left');
    const registerHandle = (handleElement, handleSide)=>{
        return (0, $c8sLM.draggable)({
            element: handleElement,
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $5rum3.disableNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage
                });
                (0, $4iuuQ.preventUnhandled).start();
            },
            getInitialData: ()=>({
                    handleSide: handleSide
                }),
            onDragStart (args) {
                state = 'resizing';
                handleElement.classList.add('pm-breakout-resize-handle-container--active');
                // The ADS tooltip hides itself on press; the vanilla one has no pointer-press
                // listener, and its anchor moves with the rail, so it would follow the drag.
                // Tearing it down hides it immediately; the next hover rebuilds it.
                if ((0, $bcN2K.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
                    rightHandle.destroyTooltip();
                    leftHandle === null || leftHandle === void 0 || leftHandle.destroyTooltip();
                }
                onDragStart(args);
            },
            onDrag: onDrag,
            onDrop (args) {
                (0, $4iuuQ.preventUnhandled).stop();
                state = 'default';
                handleElement.classList.remove('pm-breakout-resize-handle-container--active');
                onDrop(args);
            }
        });
    };
    /**
   * Parks the anchor where the pointer entered the rail, then opens the tooltip. The anchor is
   * `pointer-events: none`, so the rail's hover listeners drive it. `offsetY` is already in the
   * anchor's coordinate space, so no layout read is needed.
   *
   * Positions on enter only, matching the ADS tooltip as observed — though `Tooltip` does bind an
   * `onMouseMove`, so start here if the two arms disagree on placement.
   */ const openTooltipAt = (anchor, event)=>{
        // Only the rail bindings pass an anchor; `target` and the hit boxes do not.
        if (!anchor) return;
        anchor.style.setProperty($5990c4e70b8e78a7$var$tooltipAnchorTopVar, `${event.offsetY}px`);
        anchor.dispatchEvent(new MouseEvent('mouseenter'));
    };
    const closeTooltip = (anchor)=>{
        if (!anchor) return;
        anchor.dispatchEvent(new MouseEvent('mouseleave'));
    };
    const registerEvents = (element, hoverAnchor)=>{
        return [
            (0, $6Zi52.bind)(element, {
                type: 'mouseenter',
                listener: (event)=>{
                    // Mounted on first hover rather than up front, so a handle that is never
                    // hovered costs no portal and no listeners.
                    rightHandle.mountTooltip();
                    leftHandle === null || leftHandle === void 0 || leftHandle.mountTooltip();
                    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_use_vanilla_components')) // After the mount above, so the tooltip always exists to be opened.
                    openTooltipAt(hoverAnchor, event);
                    rightHandle.rail.style.setProperty('opacity', '1');
                    leftHandle === null || leftHandle === void 0 || leftHandle.rail.style.setProperty('opacity', '1');
                }
            }),
            (0, $6Zi52.bind)(element, {
                type: 'mouseleave',
                listener: ()=>{
                    // Ahead of the resize guard below: the ADS tooltip hides whenever the pointer
                    // leaves the rail, including part-way through a resize.
                    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_use_vanilla_components')) closeTooltip(hoverAnchor);
                    if (state === 'resizing') return;
                    rightHandle.rail.style.removeProperty('opacity');
                    leftHandle === null || leftHandle === void 0 || leftHandle.rail.style.removeProperty('opacity');
                }
            })
        ];
    };
    const unbindFns = leftHandle ? // old code - left + right
    [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(leftHandle.handleHitBox),
        ...registerEvents(rightHandle.rail, rightHandle.tooltipAnchor),
        ...registerEvents(leftHandle.rail, leftHandle.tooltipAnchor)
    ] : // new code - right only
    [
        ...registerEvents(target),
        ...registerEvents(rightHandle.handleHitBox),
        ...registerEvents(rightHandle.rail, rightHandle.tooltipAnchor)
    ];
    const handleElement = 'rail';
    const destroyFns = leftHandle ? // old code - left + right
    [
        registerHandle(rightHandle[handleElement], 'right'),
        registerHandle(leftHandle[handleElement], 'left'),
        rightHandle.destroyTooltip,
        leftHandle.destroyTooltip
    ] : // new code - right only
    [
        registerHandle(rightHandle[handleElement], 'right'),
        rightHandle.destroyTooltip
    ];
    return {
        rightHandle: rightHandle.handle,
        leftHandle: leftHandle === null || leftHandle === void 0 ? void 0 : leftHandle.handle,
        destroy: (isChangeToViewMode)=>{
            destroyFns.forEach((destroyFn)=>destroyFn());
            unbindFns.forEach((unbindFn)=>unbindFn());
            if (isChangeToViewMode) {
                var _rightHandle$handle$p, _leftHandle$handle$pa;
                (_rightHandle$handle$p = rightHandle.handle.parentElement) === null || _rightHandle$handle$p === void 0 || _rightHandle$handle$p.removeChild(rightHandle.handle);
                leftHandle === null || leftHandle === void 0 || (_leftHandle$handle$pa = leftHandle.handle.parentElement) === null || _leftHandle$handle$pa === void 0 || _leftHandle$handle$pa.removeChild(leftHandle.handle);
            }
        }
    };
};

});

parcelRegister("aRO2g", function(module, exports) {
$parcel$export(module.exports, "createResizerCallbacks", () => $b610efdb19885b81$export$d3619fd797e636fb);

var $7cqXX = parcelRequire("7cqXX");

var $e4FPa = parcelRequire("e4FPa");

var $14Wht = parcelRequire("14Wht");

var $cuBtj = parcelRequire("cuBtj");

var $awZwm = parcelRequire("awZwm");

var $7r6mU = parcelRequire("7r6mU");

var $coxi8 = parcelRequire("coxi8");
const $b610efdb19885b81$var$RESIZE_RATIO = 2;
const $b610efdb19885b81$var$SNAP_GAP = 10;
function $b610efdb19885b81$export$39e6ff87d188b0e6({ initialWidth: initialWidth, location: location, api: api, source: source }) {
    const directionMultiplier = source.data.handleSide === 'left' ? -1 : 1;
    const diffX = (location.current.input.clientX - location.initial.input.clientX) * $b610efdb19885b81$var$RESIZE_RATIO * directionMultiplier;
    const containerWidth = (0, $14Wht.getResizeContainerWidth)(api);
    // the node width may be greater than the container width so we resize using the smaller value
    const proposedWidth = Math.min(initialWidth, containerWidth) + diffX;
    const snapPoints = [
        (0, $14Wht.WIDTHS).MIN,
        (0, $14Wht.WIDTHS).WIDE,
        Math.min(containerWidth, (0, $14Wht.WIDTHS).FULL),
        Math.min(containerWidth, (0, $14Wht.WIDTHS).MAX)
    ];
    for (const snapPoint of snapPoints){
        if (snapPoint - $b610efdb19885b81$var$SNAP_GAP < proposedWidth && snapPoint + $b610efdb19885b81$var$SNAP_GAP > proposedWidth) return snapPoint;
    }
    return (0, $14Wht.clampWidthToResizeBounds)(proposedWidth, containerWidth);
}
function $b610efdb19885b81$export$d3619fd797e636fb({ dom: dom, view: view, mark: mark, api: api }) {
    let node = null;
    let guidelines = [];
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $coxi8.measureFramerate)();
    const getEditorWidth = ()=>{
        var _api$width;
        return api === null || api === void 0 || (_api$width = api.width) === null || _api$width === void 0 ? void 0 : _api$width.sharedState.currentState();
    };
    return {
        onDragStart: ()=>{
            startMeasure();
            const pos = view.posAtDOM(dom, 0);
            node = view.state.doc.nodeAt(pos);
            api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                var _api$userIntent;
                (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                tr.setMeta('is-resizer-resizing', true);
                tr.setMeta((0, $awZwm.resizingPluginKey), {
                    type: 'UPDATE_BREAKOUT_NODE',
                    data: {
                        node: node,
                        pos: pos,
                        start: pos,
                        depth: 0
                    }
                });
                return tr;
            });
        },
        onDrag: ({ location: location, source: source })=>{
            var _node, _api$guideline, _api$breakout$sharedS;
            countFrames();
            const initialWidth = mark.attrs.width;
            const newWidth = $b610efdb19885b81$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            guidelines = (0, $e4FPa.getGuidelines)(true, newWidth, getEditorWidth, (_node = node) === null || _node === void 0 ? void 0 : _node.type);
            api === null || api === void 0 || (_api$guideline = api.guideline) === null || _api$guideline === void 0 || (_api$guideline = _api$guideline.actions) === null || _api$guideline === void 0 || _api$guideline.displayGuideline(view)({
                guidelines: guidelines
            });
            const activeGuideline = guidelines.find((guideline)=>guideline.active && !guideline.key.startsWith('grid'));
            if (activeGuideline) api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $awZwm.resizingPluginKey), {
                    type: 'UPDATE_ACTIVE_GUIDELINE_KEY',
                    data: {
                        activeGuidelineKey: activeGuideline.key
                    }
                });
                return tr;
            });
            if (!activeGuideline && api !== null && api !== void 0 && (_api$breakout$sharedS = api.breakout.sharedState.currentState()) !== null && _api$breakout$sharedS !== void 0 && _api$breakout$sharedS.activeGuidelineKey) api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                tr.setMeta((0, $awZwm.resizingPluginKey), {
                    type: 'CLEAR_ACTIVE_GUIDELINE_KEY'
                });
                return tr;
            });
            // dom is used for width calculations
            dom.style.setProperty((0, $cuBtj.LOCAL_RESIZE_PROPERTY), `${newWidth}px`);
        },
        onDrop ({ location: location, source: source }) {
            var _api$guideline2, _api$editorViewMode;
            let payloads = [];
            const frameRateSamples = endMeasure();
            payloads = (0, $7r6mU.generateResizeFrameRatePayloads)({
                docSize: view.state.doc.nodeSize,
                frameRateSamples: (0, $coxi8.reduceResizeFrameRateSamples)(frameRateSamples),
                originalNode: node
            });
            const isResizedToFullWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('full_width') && guideline.active);
            const isResizedToMaxWidth = !!guidelines.find((guideline)=>guideline.key.startsWith('max_width') && guideline.active);
            guidelines = (0, $e4FPa.getGuidelines)(false, 0, getEditorWidth);
            api === null || api === void 0 || (_api$guideline2 = api.guideline) === null || _api$guideline2 === void 0 || (_api$guideline2 = _api$guideline2.actions) === null || _api$guideline2 === void 0 || _api$guideline2.displayGuideline(view)({
                guidelines: guidelines
            });
            const pos = view.posAtDOM(dom, 0);
            const mode = mark.attrs.mode;
            const initialWidth = mark.attrs.width;
            let newWidth = isResizedToFullWidth ? (0, $14Wht.WIDTHS).FULL : $b610efdb19885b81$export$39e6ff87d188b0e6({
                initialWidth: initialWidth,
                location: location,
                api: api,
                source: source
            });
            if (isResizedToMaxWidth) newWidth = (0, $14Wht.WIDTHS).MAX;
            const isEditMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'edit';
            (0, $7cqXX.setBreakoutWidth)(newWidth, mode, pos, isEditMode)(view.state, view.dispatch);
            dom.style.removeProperty((0, $cuBtj.LOCAL_RESIZE_PROPERTY));
            if (node) {
                const resizedPayload = (0, $7r6mU.generateResizedEventPayload)({
                    node: node,
                    prevWidth: initialWidth,
                    newWidth: newWidth
                });
                payloads.push(resizedPayload);
            }
            api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                var _api$userIntent2;
                (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || _api$userIntent2.commands.setCurrentUserIntent('default')({
                    tr: tr
                });
                payloads.forEach((payload)=>{
                    var _api$analytics;
                    (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
                });
                tr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
                tr.setMeta((0, $awZwm.resizingPluginKey), {
                    type: 'RESET_STATE'
                });
                return tr;
            });
        }
    };
}

});
parcelRegister("e4FPa", function(module, exports) {
$parcel$export(module.exports, "getGuidelines", () => $1023fb3ba70e8272$export$47dec483f7d48a59);

var $jiju3 = parcelRequire("jiju3");

var $35HTp = parcelRequire("35HTp");

var $cxIBH = parcelRequire("cxIBH");

var $aR1mf = parcelRequire("aR1mf");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");
const $1023fb3ba70e8272$var$WIDTHS = {
    MIN: (0, $014x6.akEditorDefaultLayoutWidth),
    WIDE: (0, $014x6.akEditorCalculatedWideLayoutWidth),
    FULL: (0, $014x6.akEditorFullWidthLayoutWidth),
    MAX: (0, $014x6.akEditorMaxLayoutWidth)
};
const $1023fb3ba70e8272$export$dd27ecfadfde9946 = {
    lineLengthLeft: 'grid_left',
    lineLengthRight: 'grid_right',
    wideLeft: 'wide_left',
    wideRight: 'wide_right',
    fullWidthLeft: 'full_width_left',
    fullWidthRight: 'full_width_right',
    maxWidthLeft: 'max_width_left',
    maxWidthRight: 'max_width_right'
};
const $1023fb3ba70e8272$var$SYNC_BLOCK_PADDING = 19;
const $1023fb3ba70e8272$var$EXTENSION_WRAPPER_PADDING = 20;
const $1023fb3ba70e8272$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $1023fb3ba70e8272$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
const $1023fb3ba70e8272$export$47dec483f7d48a59 = (0, $jiju3.default)((isResizing, newWidth, getEditorWidth, nodeType)=>{
    const guidelines = [];
    if (!isResizing) return guidelines;
    let innerPaddingOffset = 0;
    if (nodeType) switch(nodeType.name){
        case 'expand':
            innerPaddingOffset = (0, $aR1mf.EXPAND_CONTAINER_PADDING) + (0, $cxIBH.resizerHandleThumbWidth) + $1023fb3ba70e8272$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'layoutSection':
            innerPaddingOffset = (0, $35HTp.LAYOUT_COLUMN_PADDING) + $1023fb3ba70e8272$var$AK_NESTED_DND_GUTTER_OFFSET;
            break;
        case 'bodiedSyncBlock':
        case 'syncBlock':
            innerPaddingOffset = $1023fb3ba70e8272$var$SYNC_BLOCK_PADDING;
            break;
        case 'extension':
        case 'multiBodiedExtension':
        case 'bodiedExtension':
            innerPaddingOffset = $1023fb3ba70e8272$var$EXTENSION_WRAPPER_PADDING;
            break;
        default:
            break;
    }
    const { width: width } = getEditorWidth() || {};
    const padding = width && width <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
    const fullWidth = width ? Math.min($1023fb3ba70e8272$var$WIDTHS.FULL, width - 2 * padding - (0, $014x6.akEditorGutterPadding)) : undefined;
    const maxWidth = width ? Math.min($1023fb3ba70e8272$var$WIDTHS.MAX, width - 2 * padding - (0, $014x6.akEditorGutterPadding)) : undefined;
    guidelines.push({
        key: $1023fb3ba70e8272$export$dd27ecfadfde9946.lineLengthLeft,
        position: {
            x: -$1023fb3ba70e8272$var$roundToNearest($1023fb3ba70e8272$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $1023fb3ba70e8272$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $1023fb3ba70e8272$export$dd27ecfadfde9946.lineLengthRight,
        position: {
            x: $1023fb3ba70e8272$var$roundToNearest($1023fb3ba70e8272$var$WIDTHS.MIN / 2 + innerPaddingOffset)
        },
        active: newWidth === $1023fb3ba70e8272$var$WIDTHS.MIN
    });
    guidelines.push({
        key: $1023fb3ba70e8272$export$dd27ecfadfde9946.wideLeft,
        position: {
            x: -$1023fb3ba70e8272$var$roundToNearest($1023fb3ba70e8272$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $1023fb3ba70e8272$var$WIDTHS.WIDE
    });
    guidelines.push({
        key: $1023fb3ba70e8272$export$dd27ecfadfde9946.wideRight,
        position: {
            x: $1023fb3ba70e8272$var$roundToNearest($1023fb3ba70e8272$var$WIDTHS.WIDE / 2 + innerPaddingOffset)
        },
        active: newWidth === $1023fb3ba70e8272$var$WIDTHS.WIDE
    });
    if (fullWidth) {
        guidelines.push({
            key: $1023fb3ba70e8272$export$dd27ecfadfde9946.fullWidthLeft,
            position: {
                x: -$1023fb3ba70e8272$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
        guidelines.push({
            key: $1023fb3ba70e8272$export$dd27ecfadfde9946.fullWidthRight,
            position: {
                x: $1023fb3ba70e8272$var$roundToNearest(fullWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === fullWidth
        });
    }
    if (maxWidth) {
        guidelines.push({
            key: $1023fb3ba70e8272$export$dd27ecfadfde9946.maxWidthLeft,
            position: {
                x: -$1023fb3ba70e8272$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
        guidelines.push({
            key: $1023fb3ba70e8272$export$dd27ecfadfde9946.maxWidthRight,
            position: {
                x: $1023fb3ba70e8272$var$roundToNearest(maxWidth / 2 + innerPaddingOffset)
            },
            active: newWidth === maxWidth
        });
    }
    return guidelines;
});

});
parcelRegister("aR1mf", function(module, exports) {
$parcel$export(module.exports, "EXPAND_CONTAINER_PADDING", () => $39a5e803618ea50b$export$6065600df915db53);
const $39a5e803618ea50b$export$6065600df915db53 = 8;

});


parcelRegister("7r6mU", function(module, exports) {
$parcel$export(module.exports, "generateResizeFrameRatePayloads", () => $da9a15227b03183e$export$29574a7e6ffc8eb4);
$parcel$export(module.exports, "generateResizedEventPayload", () => $da9a15227b03183e$export$6b143296f4c6108b);

var $3LeME = parcelRequire("3LeME");
const $da9a15227b03183e$export$29574a7e6ffc8eb4 = (props)=>{
    return props.frameRateSamples.map((frameRateSample, index)=>({
            action: (0, $3LeME.ACTION).RESIZED_PERF_SAMPLING,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                nodeType: props.originalNode.type.name,
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $da9a15227b03183e$export$6b143296f4c6108b = ({ node: node, prevWidth: prevWidth, newWidth: newWidth })=>{
    return {
        action: (0, $3LeME.ACTION).RESIZED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        attributes: {
            nodeType: node.type.name,
            prevWidth: prevWidth,
            newWidth: newWidth
        }
    };
};

});

parcelRegister("coxi8", function(module, exports) {
$parcel$export(module.exports, "reduceResizeFrameRateSamples", () => $6469d98fac7d2efa$export$52625746d6329c8a);
$parcel$export(module.exports, "measureFramerate", () => $6469d98fac7d2efa$export$499e6cf908107611);
/**
 * Measure the FPS of a resizing component.
 *
 * This is a simplified version of the `useMeasureFramerate` hook from `editor-plugin-table`.
 * (packages/editor/editor-plugin-table/src/pm-plugins/utils/analytics.ts)
 */ const $6469d98fac7d2efa$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $6469d98fac7d2efa$export$499e6cf908107611 = (config)=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config || {};
    let frameCount = 0;
    let lastTime = 0;
    let timeoutId;
    let frameRateSamples = [];
    const startMeasure = ()=>{
        frameCount = 0;
        lastTime = performance.now();
    };
    /**
   * Returns an array of frame rate samples as integers.
   * @returns {number[]} An array of frame rate samples as integers.
   * @example
   * const samples = endMeasure(); // [60, 58, 62]
   */ const endMeasure = ()=>{
        const samples = frameRateSamples;
        frameRateSamples = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount / (deltaTime / 1000));
            frameRateSamples.push(frameRate);
        }
        frameCount = 0;
        lastTime = 0;
    };
    /**
   * Counts the number of frames that occur within a given time period. Intended to be called
   * inside a `requestAnimationFrame` callback.
   * @example
   * const animate = () => {
   *   countFrames();
   *   requestAnimationFrame(animate);
   * };
   */ const countFrames = ()=>{
        if (frameRateSamples.length >= maxSamples && timeoutId) {
            clearTimeout(timeoutId);
            return;
        }
        /**
     * Allows us to keep counting frames even if `startMeasure` is not called
     */ if (lastTime === 0) lastTime = performance.now();
        frameCount++;
        if (timeoutId) clearTimeout(timeoutId);
        if (performance.now() - lastTime > sampleRateMs) sampleFrameRate();
        else timeoutId = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};

});




parcelRegister("3OPXe", function(module, exports) {
$parcel$export(module.exports, "GuidelineLabel", () => $915976d81445997d$export$ee321e647107007d);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dXHAJ = parcelRequire("dXHAJ");

var $ctKot = parcelRequire("ctKot");

var $jnzAA = parcelRequire("jnzAA");

var $a4TQr = parcelRequire("a4TQr");
const $915976d81445997d$var$GUIDELINE_KEY_TO_LAYOUT = {
    wide_left: 'wide',
    wide_right: 'wide',
    full_width_left: 'full-width',
    full_width_right: 'full-width',
    max_width_left: 'max',
    max_width_right: 'max'
};
const $915976d81445997d$export$ee321e647107007d = ({ api: api, editorView: editorView, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const breakoutNode = (0, $jnzAA.useSharedPluginStateSelector)(api, 'breakout.breakoutNode');
    const activeGuidelineKey = (0, $jnzAA.useSharedPluginStateSelector)(api, 'breakout.activeGuidelineKey');
    if (!breakoutNode || !activeGuidelineKey) return null;
    const element = (0, $a4TQr.findDomRefAtPos)(breakoutNode.pos, editorView.domAtPos.bind(editorView));
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dXHAJ.default), {
        target: element && element instanceof HTMLElement ? element : undefined,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ],
        alignY: "bottom",
        alignX: "center",
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        stick: true,
        forcePlacement: true,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ctKot.ResizerBreakoutModeLabel), {
            layout: $915976d81445997d$var$GUIDELINE_KEY_TO_LAYOUT[activeGuidelineKey]
        })
    });
};

});
parcelRegister("ctKot", function(module, exports) {
$parcel$export(module.exports, "ResizerBreakoutModeLabel", () => $ac48ebaef67d2864$export$46c20f09a5d207e4);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");

var $hqUa9 = parcelRequire("hqUa9");
const $ac48ebaef67d2864$var$fullWidthLabelWrapperStyles = (0, $kig2V.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $ac48ebaef67d2864$var$fullWidthLabelStyles = (0, $kig2V.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $ac48ebaef67d2864$export$46c20f09a5d207e4 = ({ layout: breakoutLayout })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const message = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        switch(breakoutLayout){
            case 'max':
                return formatMessage((0, $hqUa9.messages).maxWidthLabel);
            case 'full-width':
                return formatMessage((0, $hqUa9.messages).fullWidthLabel);
            case 'wide':
                return formatMessage((0, $hqUa9.messages).wideWidthLabel);
            default:
                return null;
        }
    }, [
        breakoutLayout,
        formatMessage
    ]);
    return message && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        testId: "resizer-breakout-mode-label",
        xcss: $ac48ebaef67d2864$var$fullWidthLabelWrapperStyles,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lgMZ2.Inline), {
            xcss: $ac48ebaef67d2864$var$fullWidthLabelStyles,
            children: message
        })
    });
};

});



parcelRegister("iPzV8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdad46908e333de1$export$2e2bcd8739ae039);

var $3y4dy = parcelRequire("3y4dy");

var $121TJ = parcelRequire("121TJ");

var $aMNjw = parcelRequire("aMNjw");
const $fdad46908e333de1$var$captionPlugin = ({ api: api })=>{
    return {
        name: 'caption',
        nodes () {
            return [
                {
                    name: 'caption',
                    node: (0, $3y4dy.caption)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'caption',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>(0, $aMNjw.default)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, getIntl())
                },
                {
                    name: 'captionKeymap',
                    plugin: (0, $121TJ.captionKeymap)
                }
            ];
        }
    };
};
var $fdad46908e333de1$export$2e2bcd8739ae039 = $fdad46908e333de1$var$captionPlugin;

});
parcelRegister("121TJ", function(module, exports) {
$parcel$export(module.exports, "captionKeymap", () => $5cec1589fccb68d8$export$317bc7037b2c3692);

var $eUtBU = parcelRequire("eUtBU");

var $ihNBw = parcelRequire("ihNBw");

var $1CiIv = parcelRequire("1CiIv");

var $1O8Lw = parcelRequire("1O8Lw");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");
function $5cec1589fccb68d8$export$317bc7037b2c3692() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.moveDown).common, $5cec1589fccb68d8$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.enter).common, $5cec1589fccb68d8$var$createNewParagraphBelowCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.moveDown).common, $5cec1589fccb68d8$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.enter).common, $5cec1589fccb68d8$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.moveUp).common, $5cec1589fccb68d8$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.shiftTab).common, $5cec1589fccb68d8$var$selectParentMediaSingle, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.tab).common, $5cec1589fccb68d8$var$getOutOfCaption, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.moveLeft).common, $5cec1589fccb68d8$var$gapCursorSelectLeftParentMediaSingle, list);
    return (0, $1O8Lw.keymap)(list);
}
const $5cec1589fccb68d8$var$createNewParagraphBelowCaption = (state, dispatch)=>{
    const caption = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) return (0, $1CiIv.createNewParagraphBelow)(state, dispatch);
    return false;
};
const $5cec1589fccb68d8$var$getOutOfCaption = (state, dispatch)=>{
    const caption = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        if (dispatch) {
            const tr = state.tr.setSelection((0, $801jp.Selection).near(state.tr.doc.resolve(caption.pos + caption.node.nodeSize)));
            dispatch(tr);
        }
        return true;
    }
    return false;
};
const $5cec1589fccb68d8$var$selectParentMediaSingle = (state, dispatch)=>{
    if ((0, $a4TQr.findParentNodeOfType)(state.schema.nodes.caption)(state.selection)) {
        const mediaSingleParent = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent) {
            if (dispatch) {
                const tr = state.tr.setSelection((0, $801jp.Selection).near(state.tr.doc.resolve(mediaSingleParent.pos)));
                dispatch(tr);
            }
            return true;
        }
    }
    return false;
};
const $5cec1589fccb68d8$var$gapCursorSelectLeftParentMediaSingle = (state, dispatch)=>{
    const caption = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.caption)(state.selection);
    if (caption) {
        const mediaSingleParent = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.mediaSingle)(state.selection);
        if (mediaSingleParent && state.selection.empty && state.tr.doc.resolve(state.selection.from).parentOffset === 0) {
            const gapCursorSelection = (0, $ihNBw.GapCursorSelection).findFrom(state.tr.doc.resolve(mediaSingleParent.pos), 0, false);
            if (gapCursorSelection) {
                if (dispatch) {
                    const tr = state.tr.setSelection(gapCursorSelection);
                    dispatch(tr);
                }
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("aMNjw", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a84a1b781e20440$export$2e2bcd8739ae039);

var $3LeME = parcelRequire("3LeME");

var $1y7gE = parcelRequire("1y7gE");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $lav6T = parcelRequire("lav6T");

var $9lNJg = parcelRequire("9lNJg");

var $hjhKW = parcelRequire("hjhKW");
const $7a84a1b781e20440$var$fireAnalytics = (tr, action, analyticsApi)=>{
    analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent({
        action: action,
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).MEDIA_SINGLE,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).CAPTION
    })(tr);
};
var $7a84a1b781e20440$export$2e2bcd8739ae039 = (portalProviderAPI, eventDispatcher, providerFactory, dispatch, pluginInjectionApi, intl)=>{
    var _pluginInjectionApi$a;
    const analyticsApi = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions;
    return new (0, $1y7gE.SafePlugin)({
        appendTransaction (transactions, oldState, newState) {
            // only run for transactions that change selection
            if (!transactions.find((tr)=>tr.selectionSet)) return;
            const newSelection = !newState.selection.eq(oldState.selection);
            const findCaption = (0, $a4TQr.findParentNodeOfType)(oldState.schema.nodes.caption);
            const oldSelectionCaption = findCaption(oldState.selection);
            const { tr: tr } = newState;
            // if selecting away from caption, or selecting a different caption
            if (newSelection && oldSelectionCaption) {
                if (oldSelectionCaption.node.childCount === 0) {
                    tr.delete(oldSelectionCaption.start - 1, oldSelectionCaption.start);
                    tr.setMeta('scrollIntoView', false);
                    $7a84a1b781e20440$var$fireAnalytics(tr, (0, $3LeME.ACTION).DELETED, analyticsApi);
                    return tr;
                } else {
                    $7a84a1b781e20440$var$fireAnalytics(tr, (0, $3LeME.ACTION).EDITED, analyticsApi);
                    return tr;
                }
            }
        },
        key: (0, $hjhKW.pluginKey),
        props: {
            nodeViews: {
                caption: (0, $bcN2K.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (0, $9lNJg.captionNodeView)() : (0, $lav6T.default)(portalProviderAPI, eventDispatcher, pluginInjectionApi, intl)
            }
        }
    });
};

});
parcelRegister("lav6T", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b2a33c5657a5a71$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $j5N6B = parcelRequire("j5N6B");

var $1nTtI = parcelRequire("1nTtI");

var $eVKpX = parcelRequire("eVKpX");

var $58I5S = parcelRequire("58I5S");

var $8ntg1 = parcelRequire("8ntg1");

var $bcN2K = parcelRequire("bcN2K");
class $2b2a33c5657a5a71$export$77884ce9af78bb82 extends (0, $8ntg1.SelectionBasedNodeView) {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, pluginInjectionApi, intl){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate), this.selected = this.insideSelection();
        this.pluginInjectionApi = pluginInjectionApi;
        this.intl = intl;
        this.handleEditorDisabledChanged();
    }
    createDomRef() {
        const domRef = ((0, $j5N6B.getDocument)() ?? document).createElement('figcaption');
        domRef.setAttribute('data-caption', 'true');
        return domRef;
    }
    getContentDOM() {
        var _this$pluginInjection;
        const dom = ((0, $j5N6B.getDocument)() ?? document).createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'caption-wrapper';
        dom.setAttribute('contenteditable', (_this$pluginInjection = this.pluginInjectionApi) !== null && _this$pluginInjection !== void 0 && (_this$pluginInjection = _this$pluginInjection.editorDisabled) !== null && _this$pluginInjection !== void 0 && (_this$pluginInjection = _this$pluginInjection.sharedState.currentState()) !== null && _this$pluginInjection !== void 0 && _this$pluginInjection.editorDisabled ? 'false' : 'true');
        return {
            dom: dom
        };
    }
    // ED-24114: We need to ignore mutations that are not related to the caption node
    // since these mutations can cause an infinite loop in React 18 when using createRoot
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    handleEditorDisabledChanged() {
        var _this$pluginInjection2;
        if ((_this$pluginInjection2 = this.pluginInjectionApi) !== null && _this$pluginInjection2 !== void 0 && _this$pluginInjection2.editorDisabled) this.cleanupEditorDisabledListener = this.pluginInjectionApi.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    render(_props, forwardRef) {
        const children = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1nTtI.default), {
            selected: this.insideSelection(),
            hasContent: this.node.content.childCount > 0,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $58I5S.NodeViewContentHole), {
                ref: forwardRef
            })
        });
        if (!this.intl || !(0, $eVKpX.isSSR)()) return children;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fcCIH.Provider), {
            value: this.intl,
            children: children
        });
    }
    viewShouldUpdate(nextNode) {
        if (this.node.childCount !== nextNode.childCount) return true;
        const newSelected = this.insideSelection();
        const selectedStateChange = this.selected !== newSelected;
        this.selected = newSelected;
        return selectedStateChange;
    }
    destroy() {
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) super.destroy();
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
}
function $2b2a33c5657a5a71$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, pluginInjectionApi, intl) {
    return (node, view, getPos)=>{
        return new $2b2a33c5657a5a71$export$77884ce9af78bb82(node, view, getPos, portalProviderAPI, eventDispatcher, {}, undefined, undefined, pluginInjectionApi, intl).init();
    };
}

});

parcelRegister("9lNJg", function(module, exports) {
$parcel$export(module.exports, "captionNodeView", () => $8fef5eb1c80297cf$export$f551073b73ccec19);

var $7H6Cr = parcelRequire("7H6Cr");
/**
 * DOM spec for the caption node view.
 */ function $8fef5eb1c80297cf$var$toDOM(node) {
    return [
        'figcaption',
        {
            'data-caption': 'true',
            'data-media-caption': 'true',
            'data-testid': 'media-caption',
            ...node.attrs.localId ? {
                'data-local-id': node.attrs.localId
            } : {}
        },
        [
            'div',
            {
                class: 'captionView-content-wrap'
            },
            0
        ]
    ];
}
function $8fef5eb1c80297cf$var$createCaptionDOM(node) {
    return (0, $7H6Cr.DOMSerializer).renderSpec(document, $8fef5eb1c80297cf$var$toDOM(node));
}
class $8fef5eb1c80297cf$export$77884ce9af78bb82 {
    constructor(node){
        this.node = node;
        const { dom: dom, contentDOM: contentDOM } = $8fef5eb1c80297cf$var$createCaptionDOM(node);
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
    update(node, _decorations, _innerDecorations) {
        if (node.type !== this.node.type) return false;
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
}
function $8fef5eb1c80297cf$export$f551073b73ccec19() {
    return (node)=>{
        return new $8fef5eb1c80297cf$export$77884ce9af78bb82(node);
    };
}

});

parcelRegister("hjhKW", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $c79b3a0de7d2ea84$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $c79b3a0de7d2ea84$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('caption');

});



parcelRegister("hIsCp", function(module, exports) {
$parcel$export(module.exports, "SortOrder", () => $05cf6938cba19654$export$7ae723045d45777a);
var $05cf6938cba19654$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    return SortOrder;
}({});

});

parcelRegister("egZer", function(module, exports) {
$parcel$export(module.exports, "AddColumnStep", () => $3252588a829c75c3$export$7f589f68a74fcd15);

var $jiju3 = parcelRequire("jiju3");

var $k2WVn = parcelRequire("k2WVn");

var $hQvY8 = parcelRequire("hQvY8");

var $bDdLn = parcelRequire("bDdLn");

var $deO2S = parcelRequire("deO2S");

var $K59F4 = parcelRequire("K59F4");

var $4okm5 = parcelRequire("4okm5");

var $4Yequ = parcelRequire("4Yequ");
const $3252588a829c75c3$var$ADD_COLUMN_STEP = 'ak-add-column';
function $3252588a829c75c3$var$printColumnInfo(columnInfo) {
    const cellsFrom = [];
    for (const cellInfo of columnInfo.values())cellsFrom.push(cellInfo.from);
    return `[${cellsFrom.join(',')}]`;
}
function $3252588a829c75c3$var$createColumnInfo(cellsInfo) {
    return new Map(cellsInfo.map((cellInfo)=>[
            cellInfo.from,
            cellInfo
        ]));
}
const $3252588a829c75c3$var$getTableRectAndColumnFactory = (doc, pos, columnInfo)=>{
    return (0, $jiju3.default)(()=>{
        const rect = (0, $4okm5.getTableRectFromDoc)(doc, pos);
        const column = (0, $K59F4.findColumn)(columnInfo, rect);
        if (column === null) throw new Error('no column');
        return {
            rect: rect,
            column: column
        };
    });
};
class $3252588a829c75c3$export$7f589f68a74fcd15 extends (0, $hQvY8.Step) {
    constructor(tablePos, addColumnStepInfo, isDelete = false){
        super();
        this.tablePos = tablePos;
        this.isDelete = isDelete;
        this.sideEffectsHandler = new (0, $4Yequ.SideEffectsHandler)(addColumnStepInfo.sideEffects);
        this.columnInfo = $3252588a829c75c3$var$createColumnInfo(addColumnStepInfo.cells);
    }
    /**
   * Detect the column based on all the cells step in column info.
   * Recreate columnInfo based on the current document. We might need to add new cells added by insert row or unmerge cells.
   * If isDelete
   *    Decrease colspan if one row has merged cell
   *    Remove all the cells using columnInfo.cellStep[].from
   * else
   *    Increase colspan if one row had merged cell
   *    Add all new cells at columnInfo.cellStep[].from,
   *      if there is columnInfo.cellStep[].newCell use it
   *      else create an empty cell
   *
   * @param doc Current document
   */ apply(doc) {
        const { tablePos: tablePos } = this;
        // Create transform base on the doc
        const tr = new (0, $k2WVn.Transform)(doc);
        if (this.sideEffectsHandler.table.handleAddTable(tr, this.isDelete)) return (0, $k2WVn.StepResult).ok(tr.doc);
        let tableRect;
        try {
            tableRect = (0, $4okm5.getTableRectFromDoc)(doc, tablePos);
        } catch (e) {
            return (0, $k2WVn.StepResult).fail(e.message);
        }
        const column = (0, $K59F4.findColumn)(this.columnInfo, tableRect);
        if (column === null) return (0, $k2WVn.StepResult).fail(`No column for this cells "${$3252588a829c75c3$var$printColumnInfo(this.columnInfo)}" in table at position "${tablePos}".`);
        if (this.sideEffectsHandler.table.handleRemoveTable(tr, this.tablePos, tableRect, column, this.isDelete)) return (0, $k2WVn.StepResult).ok(tr.doc);
        this.columnInfo = this.applyCellSteps(tr, tableRect, column, this.isDelete);
        // Return the document modified.
        return (0, $k2WVn.StepResult).ok(tr.doc);
    }
    /**
   * Update tablePos with the new position. If tablePos doesnt exist any more remove the step
   * Update all the cellStep inside columnInfo. If cellStep.from position gets deleted removed it from column info
   * if cellStep.length === 0 remove the step
   * Create a new step with all the position updated
   * @param mapping
   */ map(mapping) {
        const tablePosResult = mapping.mapResult(this.tablePos);
        if (tablePosResult.deleted) // If table was deleted remove the step
        return null;
        const cellSteps = [];
        for (const oldCellStep of this.columnInfo.values()){
            const fromResult = mapping.mapResult(oldCellStep.from);
            const toResult = mapping.mapResult(oldCellStep.to);
            if (fromResult.deleted && toResult.deleted) continue;
            const cellStep = {
                ...oldCellStep,
                from: fromResult.pos,
                to: toResult.pos
            };
            if (oldCellStep.mergeWith !== undefined) cellStep.mergeWith = mapping.map(oldCellStep.mergeWith);
            cellSteps.push(cellStep);
        }
        if (cellSteps.length === 0) return null;
        const sideEffects = this.sideEffectsHandler.map(mapping);
        return new $3252588a829c75c3$export$7f589f68a74fcd15(tablePosResult.pos, {
            cells: cellSteps,
            sideEffects: sideEffects
        }, this.isDelete);
    }
    /**
   * if isDelete
   *    Get the original cell node at columnInfo.cellStep[].from to columnInfo.cellStep[].to
   *    Create a copy of the node
   *    Create a new cellStep with the same positions but with the clone node as a content
   *    return new step inverted
   * else
   *    Remove the content from each columnInfo.cellStep[].content
   *    return new step inverted
   * @param originalDoc
   */ invert(originalDoc) {
        const stepMap = this.getMap();
        // Memoize function to be called only on delete scenarios
        const getTableRectAndColumn = $3252588a829c75c3$var$getTableRectAndColumnFactory(originalDoc, this.tablePos, this.columnInfo);
        // This is needed because the real pos of the cell in the generated document is affected by the previous operations.
        const newCellSteps = Array.from(this.columnInfo.values(), (oldCellStep)=>{
            const newCellStep = (0, $bDdLn.invertCellStep)(originalDoc, getTableRectAndColumn, oldCellStep, this.isDelete, stepMap);
            return newCellStep;
        });
        const sideEffects = this.sideEffectsHandler.invert(originalDoc, this.isDelete, stepMap);
        return new $3252588a829c75c3$export$7f589f68a74fcd15(this.tablePos, {
            cells: newCellSteps,
            sideEffects: sideEffects
        }, !this.isDelete);
    }
    /**
   * StepMap is created based on columnInfo.
   * ColumnInfo is created on constructor and once is applied (the document could have new cells that weren't part of the original set)
   * if isDelete
   *    Create range array based on cell info where each range is [cellStep.from, cellStep.from - cellStep.to, 0]
   * else
   *    Create range array base on cell info where each range is [cellStep.from, 0, cellStep.content ? cellStep.content.nodeSize : defaultEmptyCellNodeSize]
   *
   * Ranges in ProseMirror are represented by each 3 elements in an array.
   * As [pos, currentSize, newSize, pos2, currentSize2, newSize2] where:
   * pos: Position in the document
   * currentSize: Represent the affected range, this will be pos + currentSize
   * newSize: Represent the new values, pos + newSize
   */ getMap() {
        const tableMap = this.sideEffectsHandler.getTableMap(this.isDelete);
        if (tableMap) return tableMap;
        let ranges = [];
        for (const cellStep of this.columnInfo.values())ranges.push(...(0, $bDdLn.getMapFromCellStep)(cellStep, this.isDelete));
        ranges = this.sideEffectsHandler.rows.addRowRanges(ranges, this.isDelete);
        // If no steps, I create am empty stepMap
        return new (0, $k2WVn.StepMap)(ranges);
    }
    /**
   * Try to merge this step with another one, to be applied directly
   * after it. Returns the merged step when possible, null if the
   * steps can't be merged.
   */ merge(_other) {
        // We cannot merge add column step at the moment
        return null;
    }
    /**
   * Create a JSON-serializeable representation of this step. When
   * defining this for a custom subclass, make sure the result object
   * includes the step type's [JSON id](#transform.Step^jsonID) under
   * the `stepType` property.
   */ toJSON() {
        const addColumnStepJson = {
            stepType: $3252588a829c75c3$var$ADD_COLUMN_STEP,
            tablePos: this.tablePos,
            cells: Array.from(this.columnInfo.values(), (cellStep)=>{
                const cellStepJson = {
                    from: cellStep.from,
                    to: cellStep.to
                };
                if (cellStep.mergeWith !== undefined) cellStepJson.mergeWith = cellStep.mergeWith;
                if (cellStep.newCell !== undefined) cellStepJson.newCell = cellStep.newCell.toJSON();
                return cellStepJson;
            }),
            isDelete: this.isDelete
        };
        const sideEffectsJSON = this.sideEffectsHandler.toJSON();
        if (sideEffectsJSON) addColumnStepJson.sideEffects = sideEffectsJSON;
        return addColumnStepJson;
    }
    /**
   * Deserialize a step from its JSON representation. Will call
   * through to the step class' own implementation of this method.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static fromJSON(schema, json) {
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: Add validation. Return null if it is invalid. Check in review if this is necessary
        const cells = json.cells.map((cellsJson)=>{
            const cell = {
                ...cellsJson,
                newCell: cellsJson.newCell ? schema.nodeFromJSON(cellsJson.newCell) : undefined
            };
            return cell;
        });
        let sideEffects;
        if (json.sideEffects) sideEffects = (0, $4Yequ.SideEffectsHandler).fromJSON(schema, json.sideEffects);
        return new $3252588a829c75c3$export$7f589f68a74fcd15(json.tablePos, {
            cells: cells,
            sideEffects: sideEffects
        }, json.isDelete);
    }
    static create(doc, tablePos, column, isDelete = false) {
        const tableRect = (0, $4okm5.getTableRectFromDoc)(doc, tablePos);
        // By default add column will rely on default behaviour (add empty cell).
        // There is no need to add content
        const cells = [];
        const iter = (0, $deO2S.cellsAtColumn)(tableRect, column);
        let next = iter.next();
        while(!next.done){
            const cell = next.value;
            cells.push((0, $bDdLn.createCellStep)(cell, column, isDelete));
            let skipRows = 0;
            if (cell.attrs && cell.attrs.rowspan) skipRows = cell.attrs.rowspan - 1;
            next = iter.next(skipRows);
        }
        return new $3252588a829c75c3$export$7f589f68a74fcd15(tablePos, {
            cells: cells
        }, isDelete);
    }
    applyCellSteps(tr, tableRect, column, isDelete) {
        const newColumnInfo = new Map();
        const rowsHandler = this.sideEffectsHandler.rows.start(this.isDelete);
        const iter = (0, $deO2S.cellsAtColumn)(tableRect, column);
        let next = iter.next();
        // Iterate for all the cells in the current document
        while(!next.done){
            const cell = next.value;
            const previousCellStep = this.columnInfo.get(cell.from);
            const newCellStep = (0, $bDdLn.createCellStep)(cell, column, isDelete, previousCellStep);
            // If is the last cell in the row and doesnt have colspan I need to remove the whole row.
            const removeRowResult = rowsHandler.handle(tr, tableRect, cell.row, column, cell);
            if (removeRowResult.handled) {
                next = iter.next(removeRowResult.skipRows);
                continue;
            }
            // Apply the step, to the pseudo document, get rows to skip, and the cellstep (might be modified, for example, a merge cell that remove the cell instead)
            const { skipRows: skipRows, cellStep: cellStep } = (0, $bDdLn.applyCellStep)(tr, tableRect, cell, newCellStep, isDelete, column);
            // Store the new cell step. This could be an existing one or a new cell.
            newColumnInfo.set(newCellStep.from, cellStep);
            next = iter.next(skipRows);
        }
        rowsHandler.end(tr, tableRect, column);
        return newColumnInfo;
    }
}
(0, $hQvY8.Step).jsonID($3252588a829c75c3$var$ADD_COLUMN_STEP, $3252588a829c75c3$export$7f589f68a74fcd15);

});
parcelRegister("bDdLn", function(module, exports) {
$parcel$export(module.exports, "applyCellStep", () => $4c3d5e9d789ba43d$export$1e67a55385d21834);
$parcel$export(module.exports, "getMapFromCellStep", () => $4c3d5e9d789ba43d$export$13a5db78deedf2bc);
$parcel$export(module.exports, "invertCellStep", () => $4c3d5e9d789ba43d$export$1238fc51d97634a);
$parcel$export(module.exports, "createCellStep", () => $4c3d5e9d789ba43d$export$e2625d4b6ce2d04b);

var $j0lNH = parcelRequire("j0lNH");
var $9fk2x = parcelRequire("9fk2x");
const $4c3d5e9d789ba43d$var$EmptyCellNodeSize = 4;
function $4c3d5e9d789ba43d$var$calculateRowsToSkip(attrs) {
    if (attrs && attrs.rowspan) return attrs.rowspan - 1;
    return 0;
}
function $4c3d5e9d789ba43d$export$1e67a55385d21834(tr, tableRect, cell, cellStep, isDelete, column) {
    // Apply the merge actions,
    if (cellStep.mergeWith !== undefined) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.mergeWith));
        const columns = column - tableRect.map.colCount(cellStep.mergeWith - tableRect.tableStart);
        const cellAttrs = isDelete ? (0, $9fk2x.removeColSpan)(cellNode.attrs, columns) : (0, $j0lNH.addColSpan)(cellNode.attrs, columns);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (cellAttrs.colspan > 0) {
            // When colspan is 0 should remove the cell
            tr.setNodeMarkup(tr.mapping.map(cellStep.mergeWith), undefined, cellAttrs);
            return {
                tr: tr,
                skipRows: $4c3d5e9d789ba43d$var$calculateRowsToSkip(cellAttrs),
                cellStep: cellStep
            };
        }
        // When the new colspan is 0, I need to change the operation to a delete operation
        // Update cellStep with the proper data
        cellStep.from = cellStep.mergeWith;
        cellStep.to = cellStep.from + cellNode.nodeSize;
        cellStep.mergeWith = undefined;
    }
    let skipRows = 0;
    // Modify temporary document
    if (isDelete) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const cellNode = tr.doc.nodeAt(tr.mapping.map(cellStep.from));
        skipRows = $4c3d5e9d789ba43d$var$calculateRowsToSkip(cellNode.attrs);
        tr.delete(tr.mapping.map(cellStep.from), tr.mapping.map(cellStep.to));
    } else if (cellStep.newCell) {
        tr.insert(tr.mapping.map(cellStep.from), cellStep.newCell);
        skipRows = $4c3d5e9d789ba43d$var$calculateRowsToSkip(cellStep.newCell.attrs);
    } else // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    tr.insert(tr.mapping.map(cellStep.from), cell.type.createAndFill());
    return {
        tr: tr,
        skipRows: skipRows,
        cellStep: cellStep
    };
}
function $4c3d5e9d789ba43d$export$13a5db78deedf2bc(cellStep, isDelete) {
    if (cellStep.mergeWith !== undefined) return [
        cellStep.mergeWith,
        1,
        1
    ];
    if (isDelete) return [
        cellStep.from,
        cellStep.to - cellStep.from,
        0
    ];
    else {
        if (cellStep.newCell) return [
            cellStep.from,
            0,
            cellStep.newCell.nodeSize
        ];
        return [
            cellStep.from,
            0,
            $4c3d5e9d789ba43d$var$EmptyCellNodeSize
        ];
    }
}
/**
 * Helper to calculate the offset of the inverted cells.
 * When you delete consecutive rows in a single step, the position in the generated document
 *  are skipped by the all the changes except your own. (StepMap.map is not valid)
 * @param map
 * @param cellStep
 * @param isDelete
 */ function $4c3d5e9d789ba43d$var$getOffset(map, cellStep, isDelete) {
    if (isDelete) return map.map(cellStep.from) - cellStep.from;
    const [, oldSize, newSize] = $4c3d5e9d789ba43d$export$13a5db78deedf2bc(cellStep, isDelete);
    return map.map(cellStep.from) - cellStep.from - (newSize - oldSize);
}
function $4c3d5e9d789ba43d$export$1238fc51d97634a(doc, getTableRectAndColumn, cellStep, isDelete, stepMap) {
    /**
   * We need a correct map when a cell is added
   * We need the normal map position minus the size of the cell you added it. Why?
   * Having a table 3x3 and we add a new column at 2 creates this ranges
   * [
   *  10, 0, 4,
   *  20, 0, 4,
   *  30, 0, 4,
   *  ]
   *  Where:
   *    * [10, 20, 30] are the original cell positions where we add the cells
   *    * [0, 0, 0] are the old size. We are adding new cells, so it's always zero
   *    * [4, 4, 4] are the new size. In this case, we are adding empty cell and has size 4, this will be different for prefill cells.
   *  In the document generated the cells that I want to delete (if I invert this step) are [10, 24, 38]
   *  this is calculated in the given way
   *    * Map the position using this step mapping function, this will return the cell in the next column
   *    * Remove the diff (4 - 0 in this case) of the current position.
   *  For a delete action this not happen, it will always return the right value
   */ const offset = $4c3d5e9d789ba43d$var$getOffset(stepMap, cellStep, isDelete);
    const newCellStepInfo = {
        ...cellStep,
        // Map the position to position of the generated document
        from: cellStep.from + offset,
        to: cellStep.to + offset
    };
    if (cellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = cellStep.mergeWith + offset;
    if (isDelete) {
        // Add the removed cell as the new cell of the inverted step
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const removedCell = doc.nodeAt(cellStep.from);
        newCellStepInfo.newCell = removedCell.copy(removedCell.content);
        // When we delete a column we can end in a position that doesnt represent the right column.
        // This only happens on merged cell that ends in the deleted column.
        // We need to remap this position to the "next" cell (AKA cellStep.to)
        const { column: column, rect: rect } = getTableRectAndColumn();
        if (column < rect.map.width) {
            const isAtTheEnd = rect.map.colCount(cellStep.from - rect.tableStart) + removedCell.attrs.colspan - 1 === column;
            if (cellStep.mergeWith !== undefined && isAtTheEnd) {
                newCellStepInfo.mergeWith = newCellStepInfo.from;
                newCellStepInfo.from = newCellStepInfo.to;
            }
        }
    }
    return newCellStepInfo;
}
function $4c3d5e9d789ba43d$export$e2625d4b6ce2d04b(cell, column, isDelete, previousCellStep) {
    const newCellStepInfo = {
        from: cell.from,
        to: cell.to
    };
    if (cell.hasMergedCells) // Check what column has to merge
    {
        if (column !== cell.col || isDelete) newCellStepInfo.mergeWith = cell.from;
    }
    if (previousCellStep) {
        if (previousCellStep.mergeWith !== undefined) newCellStepInfo.mergeWith = previousCellStep.mergeWith;
        if (previousCellStep.newCell) newCellStepInfo.newCell = previousCellStep.newCell;
    }
    return newCellStepInfo;
}

});
parcelRegister("j0lNH", function(module, exports) {
$parcel$export(module.exports, "addColSpan", () => $f29180fcd04246cb$export$147ee78a1321ac36);

var $cPlLC = parcelRequire("cPlLC");
function $f29180fcd04246cb$export$147ee78a1321ac36(attrs, pos, n = 1) {
    (0, $cPlLC.assertColspan)(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});
parcelRegister("cPlLC", function(module, exports) {
$parcel$export(module.exports, "assertColspan", () => $2ca2eb3ecd6a2e31$export$6fccdf7cee1b5201);
function $2ca2eb3ecd6a2e31$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}

});



parcelRegister("deO2S", function(module, exports) {
$parcel$export(module.exports, "cellsAtColumn", () => $7b7eee23d676c33c$export$7ca27240fa9450d9);

var $eTtPM = parcelRequire("eTtPM");

var $9HFsx = parcelRequire("9HFsx");

var $aK3Wh = parcelRequire("aK3Wh");
function* $7b7eee23d676c33c$export$7ca27240fa9450d9(rect, col) {
    const { map: map, tableStart: tableStart, table: table } = rect;
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $eTtPM.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = (0, $aK3Wh.getCellIndex)(rect.map, row, col);
        let pos = map.map[index];
        // We only consider to has merged cell to the first cell in a rowspan.
        const hasMergedCells = (0, $aK3Wh.hasMergedColumns)(rect.map, row, col) && (0, $aK3Wh.isRootRow)(rect.map, row, col);
        // If this position falls inside a col-spanning cell
        const type = refColumn == null ? (0, $9HFsx.tableNodeTypes)(table.type.schema).cell : // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table.nodeAt(map.map[index + refColumn]).type;
        if (!hasMergedCells) pos = map.positionAt(row, col, table);
        const cell = table.nodeAt(pos);
        const cellInfo = {
            from: tableStart + pos,
            to: tableStart + pos,
            row: row,
            col: hasMergedCells ? map.colCount(pos) : col,
            type: type,
            hasMergedCells: hasMergedCells
        };
        if (cell) {
            cellInfo.attrs = cell.attrs;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            cellInfo.to = tableStart + pos + cell.nodeSize;
        }
        // We let the consumer to pass the rows that we want to skip
        const skippedRows = yield cellInfo;
        if (skippedRows && skippedRows > 0) row += skippedRows;
    }
}

});
parcelRegister("eTtPM", function(module, exports) {
$parcel$export(module.exports, "columnIsHeader", () => $fbe1367a5a2cb19a$export$c71ebdbebc3fa79b);

var $9HFsx = parcelRequire("9HFsx");
function $fbe1367a5a2cb19a$export$c71ebdbebc3fa79b(map, table, col) {
    const headerCell = (0, $9HFsx.tableNodeTypes)(table.type.schema).header_cell;
    for(let row = 0; row < map.height; row++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}

});

parcelRegister("aK3Wh", function(module, exports) {
$parcel$export(module.exports, "getCellIndex", () => $3ff37db35ac3fe71$export$858eb3bd69719bea);
$parcel$export(module.exports, "hasMergedColumns", () => $3ff37db35ac3fe71$export$9854dd07bd861449);
$parcel$export(module.exports, "isRootRow", () => $3ff37db35ac3fe71$export$8575677d782d45d2);
const $3ff37db35ac3fe71$export$858eb3bd69719bea = (map, row, col)=>{
    return row * map.width + col;
};
function $3ff37db35ac3fe71$export$9854dd07bd861449(map, row, col) {
    const index = $3ff37db35ac3fe71$export$858eb3bd69719bea(map, row, col);
    return col > 0 && map.map[index - 1] === map.map[index] || col < map.width - 1 && map.map[index + 1] === map.map[index];
}
function $3ff37db35ac3fe71$export$b17f150b6103459c(map, row, col) {
    const index = $3ff37db35ac3fe71$export$858eb3bd69719bea(map, row, col);
    return row > 0 && map.map[index - map.width] !== map.map[index] || row < map.height - 1 && map.map[index + map.width] === map.map[index];
}
function $3ff37db35ac3fe71$export$8575677d782d45d2(map, row, col) {
    const index = $3ff37db35ac3fe71$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - map.width] !== map.map[index] : true;
}
function $3ff37db35ac3fe71$export$d119febc0282b034(map, row, col) {
    const index = $3ff37db35ac3fe71$export$858eb3bd69719bea(map, row, col);
    return row > 0 ? map.map[index - 1] !== map.map[index] : true;
}

});


parcelRegister("K59F4", function(module, exports) {
$parcel$export(module.exports, "findColumn", () => $cb103d16b576e19e$export$718b3d71c384ca05);
function $cb103d16b576e19e$export$718b3d71c384ca05(columnInfo, rect) {
    /**
   * Algorithm explained
   * Given a table like this:
   *    | 5  | 10      |
   *    | 15      | 20 |
   *    | 25 | 30 | 35 |
   * Represented by a table map like this:
   *   rect.map = [5, 10, 10,
   *              15, 15, 20,
   *              25, 30, 35]
   * And a have this inputs:
   *   columnInfo[].from = [10, 15, 30]
   *
   * Algorithm:
   *    * Initial state
   *      start = 0;
   *      end = 2 (rect.width - 1 === 3 - 1)
   *    * Iterate until find first cell position
   *      start = 1
   *      end = 2 (min(start column + colspan - 1, start column + end column))
   *    * Iterate until find second cell position
   *      start = 1
   *      end = 1
   *    * Start === end return 1
   */ // Initial range (start and end column) to search for each row
    let [start, end] = [
        0,
        rect.map.width - 1
    ];
    const iter = columnInfo.values();
    let next = iter.next();
    // Iterate for each row
    for(let row = 0; row < rect.map.height; row++){
        if (next.done) break;
        // Iterate for the column. Starting with the current start range
        for(let col = start; col <= end; col++){
            const i = row * rect.map.width + col;
            const cell = rect.map.map[i];
            const cellInfo = next.value.from - rect.tableStart;
            // When cell is found update range with the new values
            if (cell === cellInfo) {
                start = col; // Start column will be the current column
                // Try to find the end column. End column will be different that start when has merged cells.
                const endIndex = end - start + i;
                for(let j = i; j <= endIndex; j++){
                    if (rect.map.map[j] !== cell) break;
                    // merged columns
                    end = start + j - i; // Update the end column with the new position
                }
                if (start === end) // We found the right column only when start and end columns are the same.
                return start;
                next = iter.next();
                break;
            }
            // Sometimes I want to find a column at the end of the table (It doesn't exist, but we can add a new cell there).
            // This is represented by the end position of the last cell in the column.
            // In this case return, table width
            if (col === rect.map.width - 1) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const cellNode = rect.table.nodeAt(cell);
                if (cell + cellNode.nodeSize === cellInfo) return rect.map.width;
            }
        }
    }
    return null;
}

});

parcelRegister("4okm5", function(module, exports) {
$parcel$export(module.exports, "getTableRectFromDoc", () => $19934ade81e5c68a$export$7a7f743a3e044584);

var $dpooP = parcelRequire("dpooP");
function $19934ade81e5c68a$export$7a7f743a3e044584(doc, tablePos) {
    const table = doc.nodeAt(tablePos);
    // Check for table existence
    if (!table || table.type.name !== 'table') throw new Error(`No table at position "${tablePos}".`);
    // Create transform base on the doc
    const map = (0, $dpooP.TableMap).get(table);
    const $table = doc.resolve(tablePos);
    // Nested tables start position might differ from the original position
    const start = $table.start($table.depth + 1);
    return {
        map: map,
        table: table,
        tableStart: start,
        // Default to zero
        bottom: 0,
        left: 0,
        right: 0,
        top: 0
    };
}

});

parcelRegister("4Yequ", function(module, exports) {
$parcel$export(module.exports, "SideEffectsHandler", () => $1f000ffb4d227994$export$2e0f8a284a2635ac);

var $kcSfI = parcelRequire("kcSfI");

var $kTsAa = parcelRequire("kTsAa");
class $1f000ffb4d227994$export$2e0f8a284a2635ac {
    constructor(sideEffects){
        this.table = new (0, $kTsAa.TableSideEffectHandler)(sideEffects && sideEffects.table);
        this.rows = new (0, $kcSfI.RowsSideEffectHandler)(sideEffects && sideEffects.rows);
    }
    getTableMap(isDelete) {
        return this.table.getTableMap(isDelete);
    }
    map(mapping) {
        const sideEffects = {};
        const tableSideEffect = this.table.map(mapping);
        const rowsSideEffect = this.rows.map(mapping);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    invert(originalDoc, isDelete, map) {
        const sideEffects = {};
        const tableSideEffect = this.table.invert(originalDoc);
        if (tableSideEffect) sideEffects.table = tableSideEffect;
        const rowsSideEffect = this.rows.invert(originalDoc, isDelete, map);
        if (rowsSideEffect) sideEffects.rows = rowsSideEffect;
        return sideEffects;
    }
    toJSON() {
        const tableSideEffectJson = this.table.toJSON();
        const rowsSideEffectJson = this.rows.toJSON();
        if (!tableSideEffectJson && !rowsSideEffectJson) return;
        const sideEffectsJSON = {};
        if (tableSideEffectJson) sideEffectsJSON.table = tableSideEffectJson;
        if (rowsSideEffectJson) sideEffectsJSON.rows = rowsSideEffectJson;
        return sideEffectsJSON;
    }
    static fromJSON(schema, json) {
        const sideEffects = {};
        if (json.table) sideEffects.table = (0, $kTsAa.TableSideEffectHandler).fromJSON(schema, json.table);
        if (json.rows) sideEffects.rows = (0, $kcSfI.RowsSideEffectHandler).fromJSON(schema, json.rows);
        return sideEffects;
    }
}

});
parcelRegister("kcSfI", function(module, exports) {
$parcel$export(module.exports, "RowsSideEffectHandler", () => $9fcdb8ff26cc5c7f$export$6a87112aa04a9486);

var $aK3Wh = parcelRequire("aK3Wh");
function $9fcdb8ff26cc5c7f$var$mergedRanges(first, second) {
    const newRanges = [];
    const firstLength = first.length;
    const secondLength = second.length;
    let i = 0;
    let j = 0;
    while(i < firstLength && j < secondLength)if (first[i] < second[j]) {
        newRanges.push(first[i], first[i + 1], first[i + 2]);
        i += 3;
    } else {
        newRanges.push(second[j], second[j + 1], second[j + 2]);
        j += 3;
    }
    if (i < firstLength) newRanges.push(...first.slice(i));
    if (j < secondLength) newRanges.push(...second.slice(i));
    return newRanges;
}
function $9fcdb8ff26cc5c7f$var$increaseRowSpan(tr, rect, row) {
    const { map: map, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        const mappedPos = tr.mapping.map(pos + tableStart);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const attrs = tr.doc.nodeAt(mappedPos).attrs;
        tr.setNodeMarkup(mappedPos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    }
}
function $9fcdb8ff26cc5c7f$var$decreaseRowspan(tr, rect, row, colToRemove) {
    let skipRows = 0;
    const { map: map, table: table, tableStart: tableStart } = rect;
    for(let col = 0; col < map.width; col++){
        const index = row * map.width + col;
        const pos = map.map[index];
        if (row > 0 && pos === map.map[index - map.width]) {
            // If this cell starts in the row above, simply reduce its rowspan
            const mappedPos = tr.mapping.map(pos + tableStart);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const attrs = tr.doc.nodeAt(mappedPos).attrs;
            tr.setNodeMarkup(mappedPos, undefined, {
                ...attrs,
                rowspan: attrs.rowspan - 1
            });
            col += attrs.colspan - 1;
        } else if (col === colToRemove) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        skipRows = table.nodeAt(pos).attrs.rowspan - 1;
    }
    return skipRows;
}
function $9fcdb8ff26cc5c7f$var$isLastCellInRow(rect, row, col) {
    const rowNode = rect.table.child(row);
    if (!rowNode) return false;
    return rowNode.childCount === 1 && !(0, $aK3Wh.hasMergedColumns)(rect.map, row, col);
}
function $9fcdb8ff26cc5c7f$var$removeRowWithLastCell(tr, rect, row, _col) {
    // Get row pos
    let from = rect.tableStart;
    for(let i = 0; i < row; i++)from += rect.table.child(i).nodeSize;
    const rowNode = rect.table.child(row);
    const to = from + rowNode.nodeSize;
    // Create sideEffect and delete the row
    // We store original row position before modifications
    tr.delete(tr.mapping.map(from), tr.mapping.map(to));
    // Change rowspan of all cells except current col and get the rows to skip
    const skipRows = $9fcdb8ff26cc5c7f$var$decreaseRowspan(tr, rect, row, _col);
    return {
        skipRows: skipRows,
        row: {
            from: from,
            to: to,
            rowNode: rowNode.copy(rowNode.content)
        }
    };
}
function $9fcdb8ff26cc5c7f$var$addRow(tr, rect, prevRow, rowSideEffect) {
    const cellNode = rowSideEffect.rowNode.child(0);
    tr.insert(tr.mapping.map(rowSideEffect.from), rowSideEffect.rowNode);
    $9fcdb8ff26cc5c7f$var$increaseRowSpan(tr, rect, prevRow);
    return cellNode.attrs.rowspan - 1;
}
class $9fcdb8ff26cc5c7f$export$6a87112aa04a9486 {
    constructor(rowsSideEffect){
        this.deleteHandler = ()=>{
            const newRows = [];
            return {
                handle: (tr, rect, row, col, _cell)=>{
                    if (!$9fcdb8ff26cc5c7f$var$isLastCellInRow(rect, row, col)) return {
                        handled: false
                    };
                    const { row: rowSideEffect, skipRows: skipRows } = $9fcdb8ff26cc5c7f$var$removeRowWithLastCell(tr, rect, row, col);
                    newRows.push(rowSideEffect);
                    return {
                        handled: true,
                        skipRows: skipRows
                    };
                },
                end: ()=>{
                    if (newRows.length > 0) this.rows = newRows;
                    else this.rows = undefined;
                }
            };
        };
        this.addHandler = ()=>{
            let lastCellFrom = 0;
            let i = 0;
            return {
                handle: (tr, rect, row, _col, cell)=>{
                    // // If not sideEffects stored return;
                    if (!this.rows || i >= this.rows.length) return {
                        handled: false
                    };
                    // Next row to add;
                    let skipRows;
                    let nextRow;
                    while(// Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    (nextRow = this.rows[i]) && nextRow.from > lastCellFrom && nextRow.from < cell.from){
                        // I am in between of the previous and next row in the table;
                        skipRows = $9fcdb8ff26cc5c7f$var$addRow(tr, rect, row - 1, nextRow);
                        i++;
                    }
                    lastCellFrom = cell.from;
                    if (!skipRows || skipRows === 0) return {
                        handled: false
                    };
                    return {
                        handled: true,
                        skipRows: skipRows - 1
                    };
                },
                end: (tr, rect, _col)=>{
                    if (!this.rows || i >= this.rows.length) return;
                    // Add rows at the end of the table
                    let nextRow;
                    // Ignored via go/ees005
                    // eslint-disable-next-line no-cond-assign
                    while(nextRow = this.rows[i]){
                        $9fcdb8ff26cc5c7f$var$addRow(tr, rect, rect.map.height - 1, nextRow);
                        i++;
                    }
                }
            };
        };
        this.rows = rowsSideEffect;
    }
    start(isDelete) {
        if (isDelete) return this.deleteHandler();
        return this.addHandler();
    }
    addRowRanges(ranges, isDelete) {
        if (!this.rows) return ranges;
        const rowRanges = [];
        for (const row of this.rows){
            const { from: from, to: to } = row;
            if (isDelete) rowRanges.push(from, to - from, 0);
            else rowRanges.push(from, 0, to - from);
        }
        // Merged ranges
        return $9fcdb8ff26cc5c7f$var$mergedRanges(ranges, rowRanges);
    }
    map(_mapping) {
        return [];
    }
    invert(_originalDoc, isDelete, map) {
        if (!this.rows) return;
        const invertedRows = [];
        for (const row of this.rows)if (isDelete) {
            // Moving from delete to add keep the inverted rows + offset
            const offset = map.map(row.from) - row.from;
            invertedRows.push({
                ...row,
                from: row.from + offset,
                to: row.from + offset
            });
        }
        return invertedRows;
    }
    toJSON() {
        if (!this.rows) return;
        const rowsInJson = [];
        for (const row of this.rows)rowsInJson.push({
            from: row.from,
            to: row.to,
            rowNode: row.rowNode.toJSON()
        });
        return rowsInJson;
    }
    static fromJSON(schema, json) {
        const rowSideEffects = [];
        for (const row of json)rowSideEffects.push({
            from: row.from,
            to: row.to,
            rowNode: schema.nodeFromJSON(row.rowNode)
        });
        return rowSideEffects;
    }
}

});

parcelRegister("kTsAa", function(module, exports) {
$parcel$export(module.exports, "TableSideEffectHandler", () => $ddc35a5276fed56f$export$9d510b823609a5ac);

var $k2WVn = parcelRequire("k2WVn");
class $ddc35a5276fed56f$export$9d510b823609a5ac {
    constructor(tableSideEffect){
        if (tableSideEffect) this.table = tableSideEffect;
    }
    addTableSideEffect(from, to, node) {
        this.table = {
            from: from,
            to: to,
            node: node
        };
    }
    handleAddTable(tr, isDelete) {
        if (isDelete || !this.table) return false;
        tr.insert(this.table.from, this.table.node);
        return true;
    }
    handleRemoveTable(tr, tablePos, tableRect, column, isDelete) {
        if (isDelete && tableRect.map.width === 1 && column === 0) {
            // Add side effect
            this.addTableSideEffect(tablePos, tablePos + tableRect.table.nodeSize, tableRect.table.copy(tableRect.table.content));
            tr.delete(tablePos, tablePos + tableRect.table.nodeSize);
            return true;
        }
        return false;
    }
    getTableMap(isDelete) {
        if (!this.table) return;
        const { from: from, to: to } = this.table;
        if (isDelete) return new (0, $k2WVn.StepMap)([
            from,
            to - from,
            0
        ]);
        return new (0, $k2WVn.StepMap)([
            from,
            0,
            to - from
        ]);
    }
    map(mapping) {
        if (!this.table) return;
        return {
            from: mapping.map(this.table.from),
            to: mapping.map(this.table.to),
            node: this.table.node
        };
    }
    invert(doc) {
        if (!this.table) return;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const tableNode = doc.nodeAt(this.table.from);
        return {
            from: this.table.from,
            to: this.table.from + tableNode.nodeSize,
            node: tableNode.copy(tableNode.content)
        };
    }
    toJSON() {
        if (!this.table) return;
        return {
            from: this.table.from,
            to: this.table.to,
            node: this.table.node.toJSON()
        };
    }
    static fromJSON(schema, json) {
        return {
            from: json.from,
            to: json.to,
            node: schema.nodeFromJSON(json.node)
        };
    }
}

});



parcelRegister("jAL7t", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $92f6d94e758f3483$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "contextPanelPlugin", () => $92f6d94e758f3483$export$773ed6f43b4b1d8f);

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $gmAv8 = parcelRequire("gmAv8");
const $92f6d94e758f3483$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('contextPanelPluginKey');
function $92f6d94e758f3483$var$contextPanelPluginFactory(contextPanels, dispatch) {
    return new (0, $1y7gE.SafePlugin)({
        key: $92f6d94e758f3483$export$18d4026d1ea86bb1,
        state: {
            init (_config, state) {
                return {
                    handlers: contextPanels,
                    contents: contextPanels.map((panelContent)=>panelContent(state))
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                let newPluginState = pluginState;
                const meta = tr.getMeta($92f6d94e758f3483$export$18d4026d1ea86bb1);
                if (tr.docChanged || tr.selectionSet || meta && meta.changed) {
                    const newContents = pluginState.handlers.map((panelContent)=>panelContent(newState));
                    const contentsLengthChanged = newContents.length !== newPluginState.contents.length;
                    const contentChanged = newContents.some((node, index)=>newPluginState.contents[index] !== node);
                    if (contentsLengthChanged || contentChanged) newPluginState = {
                        ...newPluginState,
                        contents: newContents
                    };
                }
                if (newPluginState !== pluginState) dispatch($92f6d94e758f3483$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        }
    });
}
const $92f6d94e758f3483$export$773ed6f43b4b1d8f = ({ config: config })=>({
        name: 'contextPanel',
        actions: {
            applyChange: (0, $gmAv8.applyChange),
            showPanel: config !== null && config !== void 0 && config.objectSideBar.showPanel ? (panel, behavior, panelWidth)=>config.objectSideBar.showPanel(panel, behavior, panelWidth) : undefined,
            closePanel: config !== null && config !== void 0 && config.objectSideBar.closePanel ? ()=>config.objectSideBar.closePanel() : undefined,
            closePanelById: config !== null && config !== void 0 && config.objectSideBar.closePanelById ? (id)=>config.objectSideBar.closePanelById(id) : undefined
        },
        getSharedState (state) {
            if (!state) return undefined;
            const { contents: contents } = $92f6d94e758f3483$export$18d4026d1ea86bb1.getState(state) ?? {};
            return {
                contents: contents
            };
        },
        pmPlugins (contextPanels = []) {
            return [
                {
                    name: 'contextPanel',
                    plugin: ({ dispatch: dispatch })=>$92f6d94e758f3483$var$contextPanelPluginFactory(contextPanels.filter(Boolean), dispatch)
                }
            ];
        }
    });

});
parcelRegister("gmAv8", function(module, exports) {
$parcel$export(module.exports, "applyChange", () => $659b2c96428f1887$export$6fbe08f3dbfbccb2);

var $jAL7t = parcelRequire("jAL7t");
const $659b2c96428f1887$export$6fbe08f3dbfbccb2 = (tr)=>tr.setMeta((0, $jAL7t.pluginKey), {
        changed: true
    });

});


parcelRegister("gGoAS", function(module, exports) {
$parcel$export(module.exports, "customAutoformatPlugin", () => $4729b717afb958d6$export$aa4fc86248a63de6);

var $1y7gE = parcelRequire("1y7gE");

var $1O8Lw = parcelRequire("1O8Lw");

var $izh7u = parcelRequire("izh7u");

var $8zr1d = parcelRequire("8zr1d");

var $ht0nP = parcelRequire("ht0nP");

var $kITSl = parcelRequire("kITSl");
const $4729b717afb958d6$export$ad324b5166a7fb7 = ({ providerFactory: providerFactory }, options, api)=>{
    const rules = [];
    return new (0, $1y7gE.SafePlugin)({
        state: {
            init () {
                return {
                    resolving: [],
                    matches: [],
                    autoformattingProvider: undefined
                };
            },
            apply (tr, prevPluginState) {
                if (!prevPluginState) return prevPluginState;
                // remap positions
                const remappedPluginState = {
                    ...prevPluginState,
                    resolving: prevPluginState.resolving.map((candidate)=>({
                            ...candidate,
                            start: tr.mapping.map(candidate.start),
                            end: tr.mapping.map(candidate.end, -1)
                        }))
                };
                const meta = tr.getMeta((0, $kITSl.pluginKey));
                if (!meta) return remappedPluginState;
                return (0, $ht0nP.default)(remappedPluginState, meta);
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                (0, $8zr1d.triggerInputRule)(view, rules, from, to, text);
                return false;
            },
            handleKeyDown: (0, $1O8Lw.keydownHandler)({
                Enter: (_state, _dispatch, view)=>{
                    if (view) (0, $8zr1d.triggerInputRule)(view, rules, view.state.selection.from, view.state.selection.to, '');
                    return false;
                }
            })
        },
        view () {
            const handleProvider = (name, provider)=>{
                if (name !== 'autoformattingProvider' || !provider) return;
                provider.then(async (autoformattingProvider)=>{
                    const ruleset = await autoformattingProvider.getRules();
                    Object.keys(ruleset).forEach((rule)=>{
                        const inputRule = {
                            /**
               * On Shift + Enter, after the first word an Object Replacement Character (/ufffc) is added.
               * We still want to match strings that start with an Object Replacement Character.
               */ // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchTyping: new RegExp('(\\s+|^|\\ufffc)' + rule + '(\\s|,|\\.)$'),
                            // Ignored via go/ees005
                            // eslint-disable-next-line require-unicode-regexp
                            matchEnter: new RegExp('(\\s+|^)' + rule + '()$'),
                            handler: (0, $izh7u.buildHandler)(rule, ruleset[rule])
                        };
                        rules.push(inputRule);
                    });
                });
            };
            if (options !== null && options !== void 0 && options.autoformattingProvider) handleProvider('autoformattingProvider', options.autoformattingProvider);
            return {
                update (view) {
                    const currentState = (0, $kITSl.getPluginState)(view.state);
                    if (!currentState) return;
                    // make replacements in document for finished autoformats
                    if (currentState.matches) (0, $izh7u.completeReplacements)(view, currentState);
                }
            };
        },
        key: (0, $kITSl.pluginKey)
    });
};
const $4729b717afb958d6$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return (0, $kITSl.autoformatAction)(tr, {
            action: 'setProvider',
            provider: provider
        });
    };
const $4729b717afb958d6$export$aa4fc86248a63de6 = ({ api: api, config: options })=>{
    let previousProvider;
    if (options !== null && options !== void 0 && options.autoformattingProvider) options.autoformattingProvider.then((provider)=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>$4729b717afb958d6$export$1572b3eade6662f9(provider)(tr));
    });
    return {
        name: 'customAutoformat',
        pmPlugins () {
            return [
                {
                    name: 'customAutoformat',
                    plugin: (pmPluginFactoryParams)=>{
                        return $4729b717afb958d6$export$ad324b5166a7fb7(pmPluginFactoryParams, options, api);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return;
            const { autoformattingProvider: autoformattingProvider } = (0, $kITSl.getPluginState)(editorState) ?? {};
            return {
                autoformattingProvider: autoformattingProvider
            };
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousProvider === provider || (options === null || options === void 0 ? void 0 : options.autoformattingProvider) === providerPromise) return false;
                previousProvider = provider;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>$4729b717afb958d6$export$1572b3eade6662f9(provider)(tr))) ?? false;
            }
        }
    };
};

});
parcelRegister("izh7u", function(module, exports) {
$parcel$export(module.exports, "buildHandler", () => $0bed5fa7c4a9e156$export$c95e7d405e6ed1df);
$parcel$export(module.exports, "completeReplacements", () => $0bed5fa7c4a9e156$export$e9a01ad76956fe83);

var $7KgZE = parcelRequire("7KgZE");

var $aWQ8n = parcelRequire("aWQ8n");

var $kITSl = parcelRequire("kITSl");
const $0bed5fa7c4a9e156$export$c95e7d405e6ed1df = (_regex, handler)=>{
    return async (view, match, start, end)=>{
        const replacementPromise = handler(match.slice(1, match.length - 1));
        // queue the position and match pair so that we can remap across transactions
        // while we wait for the replacmentPromise to resolve
        view.dispatch((0, $kITSl.autoformatAction)(view.state.tr, {
            action: 'matched',
            match: match,
            start: start,
            end: end
        }));
        // ask the provider to give us an ADF node to replace the text with
        const replacementData = await replacementPromise;
        const replacementNode = (0, $7KgZE.processRawValue)(view.state.schema, replacementData);
        view.dispatch((0, $kITSl.autoformatAction)(view.state.tr, {
            action: 'resolved',
            matchString: match[0],
            replacement: replacementNode
        }));
        return replacementData;
    };
};
const $0bed5fa7c4a9e156$export$44515d004ac96c3b = (docText, match)=>{
    const REPLACEMENT_CHARACTER = '\ufffc';
    const docTextStartChar = docText[0];
    const docTextEndSlice = docText.slice(1);
    const matchStartChar = match[0][0];
    const matchEndSlice = match[0].slice(1);
    const slicesMatch = docTextEndSlice === matchEndSlice;
    const isAlternator = docTextStartChar === '|';
    const isObjReplaceChar = matchStartChar === REPLACEMENT_CHARACTER;
    return slicesMatch && isAlternator && isObjReplaceChar;
};
const $0bed5fa7c4a9e156$export$e9a01ad76956fe83 = (view, state)=>{
    const { inlineCard: inlineCard } = view.state.schema.nodes;
    state.matches.forEach((completedMatch)=>{
        const matchingRequests = state.resolving.filter((candidate)=>candidate.match[0] === completedMatch.matchString);
        let tr = view.state.tr;
        matchingRequests.forEach((request)=>{
            const { match: match, start: start, end: end } = request;
            const { replacement: replacement } = completedMatch;
            const prefix = match[1];
            const suffix = match[match.length - 1];
            const matchEndPos = end + suffix.length;
            // only permit inlineCard as replacement target for now
            if (!replacement || replacement.type !== inlineCard && !replacement.isText) return;
            // get the current document text, adding # or | if we cross node boundaries
            const docText = view.state.doc.textBetween(start, matchEndPos, '#', '|');
            const canAutoformatAfterSoftbreak = $0bed5fa7c4a9e156$export$44515d004ac96c3b(docText, match);
            // only replace if text still remains the same as when typed at the start
            if (docText === match[0] || canAutoformatAfterSoftbreak) tr = tr.replaceWith(tr.mapping.map(start + prefix.length), tr.mapping.map(end, -1), replacement);
        });
        // clear this match from plugin state now that we've processed it
        tr = (0, $kITSl.autoformatAction)(tr, {
            action: 'finish',
            matchString: completedMatch.matchString
        });
        // and dispatch the replacement, closing history for cmd+z to allow undo separately
        view.dispatch((0, $aWQ8n.closeHistory)(tr));
    });
};

});
parcelRegister("kITSl", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $d1c1ca6704c5dc22$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getPluginState", () => $d1c1ca6704c5dc22$export$f05434c51e3762e);
$parcel$export(module.exports, "autoformatAction", () => $d1c1ca6704c5dc22$export$c921af6adf4fd3e2);

var $801jp = parcelRequire("801jp");
const $d1c1ca6704c5dc22$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('customAutoformatPlugin');
const $d1c1ca6704c5dc22$export$f05434c51e3762e = (editorState)=>$d1c1ca6704c5dc22$export$18d4026d1ea86bb1.getState(editorState);
const $d1c1ca6704c5dc22$export$c921af6adf4fd3e2 = (tr, action)=>{
    return tr.setMeta($d1c1ca6704c5dc22$export$18d4026d1ea86bb1, action);
};

});


parcelRegister("8zr1d", function(module, exports) {
$parcel$export(module.exports, "triggerInputRule", () => $3a45436d505edc3a$export$2b7343a2464fe84e);
const $3a45436d505edc3a$var$MAX_MATCH = 500;
const $3a45436d505edc3a$export$2b7343a2464fe84e = (view, rules, from, to, text)=>{
    const { state: state } = view;
    const $from = state.doc.resolve(from);
    if ($from.parent.type.spec.code) return false;
    const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - $3a45436d505edc3a$var$MAX_MATCH), $from.parentOffset, undefined, '\ufffc') + text;
    // loop through rules trying to find one that matches
    for(let i = 0; i < rules.length; i++){
        let match;
        if (text.length) match = rules[i].matchTyping.exec(textBefore);
        else match = rules[i].matchEnter.exec(textBefore);
        if (match) {
            // kick off the handler
            const pos = from - (match[0].length - text.length);
            rules[i].handler(view, match, pos, to);
            return true;
        }
    }
    return false;
};

});

parcelRegister("ht0nP", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdb112031c453083$export$2e2bcd8739ae039);

var $2PSNu = parcelRequire("2PSNu");
const $fdb112031c453083$var$reduce = (state, action)=>{
    switch(action.action){
        case 'matched':
            return (0, $2PSNu.matched)(state, action);
        case 'resolved':
            return (0, $2PSNu.resolved)(state, action);
        case 'finish':
            return (0, $2PSNu.finish)(state, action);
        case 'setProvider':
            return (0, $2PSNu.setProvider)(state, action);
        default:
            return state;
    }
};
var $fdb112031c453083$export$2e2bcd8739ae039 = $fdb112031c453083$var$reduce;

});
parcelRegister("2PSNu", function(module, exports) {
$parcel$export(module.exports, "matched", () => $1e259fd4b6fc3cc7$export$b373f08cf72033a1);
$parcel$export(module.exports, "resolved", () => $1e259fd4b6fc3cc7$export$d06d16b20ced9190);
$parcel$export(module.exports, "finish", () => $1e259fd4b6fc3cc7$export$5953b28951b32649);
$parcel$export(module.exports, "setProvider", () => $1e259fd4b6fc3cc7$export$1572b3eade6662f9);
const $1e259fd4b6fc3cc7$export$b373f08cf72033a1 = (state, action)=>({
        ...state,
        resolving: [
            ...state.resolving,
            {
                start: action.start,
                end: action.end,
                match: action.match
            }
        ]
    });
const $1e259fd4b6fc3cc7$export$d06d16b20ced9190 = (state, action)=>({
        ...state,
        matches: [
            ...state.matches,
            {
                replacement: action.replacement,
                matchString: action.matchString
            }
        ]
    });
const $1e259fd4b6fc3cc7$export$5953b28951b32649 = (state, action)=>{
    return {
        ...state,
        resolving: state.resolving.filter((resolving)=>resolving.match[0] !== action.matchString),
        matches: state.matches.filter((matching)=>matching.matchString !== action.matchString)
    };
};
const $1e259fd4b6fc3cc7$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        autoformattingProvider: action.provider
    };
};

});



parcelRegister("leV0O", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2356adfcd431b7b$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $ieUrC = parcelRequire("ieUrC");

var $1dOrX = parcelRequire("1dOrX");

var $3LeME = parcelRequire("3LeME");

var $7vlqQ = parcelRequire("7vlqQ");

var $eUtBU = parcelRequire("eUtBU");

var $RYyF2 = parcelRequire("RYyF2");

var $cT0LQ = parcelRequire("cT0LQ");

var $khldo = parcelRequire("khldo");

var $4uff1 = parcelRequire("4uff1");

var $9Q4ru = parcelRequire("9Q4ru");

var $a4TQr = parcelRequire("a4TQr");

var $3UAb3 = parcelRequire("3UAb3");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $7ymzg = parcelRequire("7ymzg");

var $7jrkM = parcelRequire("7jrkM");

var $eCE9b = parcelRequire("eCE9b");

var $8A5oa = parcelRequire("8A5oa");

var $d95H3 = parcelRequire("d95H3");

var $5twHi = parcelRequire("5twHi");

const $a2356adfcd431b7b$var$loadDatePicker = ()=>(parcelRequire("7IBJu")).then((mod)=>mod.default);

const $a2356adfcd431b7b$var$DatePickerLazy = (0, $ieUrC.lazy)(()=>(parcelRequire("7IBJu")).then((mod)=>mod.default), {
    moduleId: "../platform/packages/editor/editor-plugin-date/src/ui/DatePicker/index.tsx"
});
const $a2356adfcd431b7b$var$DatePickerLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: $a2356adfcd431b7b$var$loadDatePicker,
    loading: ()=>null
});
const $a2356adfcd431b7b$var$DatePicker = (props)=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ieUrC.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($a2356adfcd431b7b$var$DatePickerLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3LM7S.jsx)($a2356adfcd431b7b$var$DatePickerLoadable, {
        ...props
    });
$a2356adfcd431b7b$var$DatePicker.preload = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $a2356adfcd431b7b$var$DatePickerLazy.preload() : $a2356adfcd431b7b$var$DatePickerLoadable.preload();
function $a2356adfcd431b7b$var$getDateNode(editorView, showDatePickerAt) {
    if (!editorView) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $a4TQr.findDomRefAtPos)(showDatePickerAt, domAtPos);
    // Resolves ED-23702 for when the date is wrapped in an inline comment
    const dateNode = element !== null && element !== void 0 && element.classList.contains((0, $khldo.DateSharedCssClassName).DATE_CONTAINER) ? element : element === null || element === void 0 ? void 0 : element.querySelector(`.${(0, $khldo.DateSharedCssClassName).DATE_CONTAINER}`);
    return dateNode || element;
}
function $a2356adfcd431b7b$var$ContentComponent({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi, weekStartDay: weekStartDay }) {
    const { editorDisabledState: editorDisabledState, dateState: dateState } = (0, $4uff1.useSharedPluginState)(dependencyApi, [
        'date',
        'editorDisabled'
    ]);
    if (!(dateState !== null && dateState !== void 0 && dateState.showDatePickerAt) || editorDisabledState !== null && editorDisabledState !== void 0 && editorDisabledState.editorDisabled) return null;
    const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput } = dateState;
    const dateNode = $a2356adfcd431b7b$var$getDateNode(editorView, showDatePickerAt);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($a2356adfcd431b7b$var$DatePicker, {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: dateNode,
        isNew: isNew,
        autoFocus: focusDateInput,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDelete: ()=>{
            var _dependencyApi$core;
            if (!editorView) return;
            dependencyApi === null || dependencyApi === void 0 || (_dependencyApi$core = dependencyApi.core) === null || _dependencyApi$core === void 0 || _dependencyApi$core.actions.execute((0, $7jrkM.deleteDateCommand)(dependencyApi));
            editorView === null || editorView === void 0 || editorView.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSelect: (date, commitMethod)=>{
            var _dependencyApi$core2;
            // Undefined means couldn't parse date, null means invalid (out of bounds) date
            if (date === undefined || date === null) return;
            if (!editorView) return;
            dependencyApi === null || dependencyApi === void 0 || (_dependencyApi$core2 = dependencyApi.core) === null || _dependencyApi$core2 === void 0 || _dependencyApi$core2.actions.execute((0, $7jrkM.insertDateCommand)(dependencyApi)({
                date: date,
                commitMethod: commitMethod
            }));
            editorView === null || editorView === void 0 || editorView.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onTextChanged: (date)=>{
            var _dependencyApi$core3;
            dependencyApi === null || dependencyApi === void 0 || (_dependencyApi$core3 = dependencyApi.core) === null || _dependencyApi$core3 === void 0 || _dependencyApi$core3.actions.execute((0, $7jrkM.insertDateCommand)(dependencyApi)({
                date: date,
                enterPressed: false
            }));
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        closeDatePicker: ()=>{
            if (!editorView) return;
            (0, $7ymzg.closeDatePicker)()(editorView.state, editorView.dispatch);
            editorView === null || editorView === void 0 || editorView.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        closeDatePickerWithAnalytics: ({ date: date })=>{
            if (!editorView) return;
            (0, $7ymzg.closeDatePickerWithAnalytics)({
                date: date
            })(editorView.state, editorView.dispatch);
            editorView.focus();
        },
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        weekStartDay: weekStartDay
    }, showDatePickerAt);
}
const $a2356adfcd431b7b$var$datePlugin = ({ config: config = {}, api: api })=>{
    const isRegisteredSlashCommandEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $5twHi.getDateQuickInsertComponents)({
            api: api
        }));
    }
    return {
        name: 'date',
        getSharedState (editorState) {
            if (!editorState) return {
                showDatePickerAt: null,
                isNew: false,
                focusDateInput: false,
                isInitialised: true
            };
            const { showDatePickerAt: showDatePickerAt, isNew: isNew, focusDateInput: focusDateInput, isInitialised: isInitialised } = (0, $d95H3.pluginKey).getState(editorState) || {};
            return {
                showDatePickerAt: showDatePickerAt,
                isNew: !!isNew,
                focusDateInput: !!focusDateInput,
                isInitialised: !!isInitialised
            };
        },
        commands: {
            insertDate: (0, $7jrkM.insertDateCommand)(api),
            deleteDate: (0, $7jrkM.deleteDateCommand)(api)
        },
        nodes () {
            return [
                {
                    name: 'date',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $1dOrX.dateWithLocalId) : (0, $1dOrX.date)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'date',
                    plugin: (pmPluginFactoryParams)=>{
                        $a2356adfcd431b7b$var$DatePicker.preload();
                        return (0, $8A5oa.default)(pmPluginFactoryParams);
                    }
                },
                {
                    name: 'dateKeymap',
                    plugin: ()=>{
                        $a2356adfcd431b7b$var$DatePicker.preload();
                        return (0, $eCE9b.default)();
                    }
                }
            ];
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $3LM7S.jsx)($a2356adfcd431b7b$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                weekStartDay: config.weekStartDay
            });
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'date',
                            title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).date),
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).dateDescription),
                            priority: 800,
                            keywords: [
                                'calendar',
                                'day',
                                'time',
                                'today',
                                '/'
                            ],
                            keyshortcut: '//',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconDate), {}),
                            action (insert, state, source) {
                                var _api$analytics, _api$analytics$attach;
                                const tr = (0, $7ymzg.createDate)(true)(state);
                                api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || (_api$analytics$attach = _api$analytics.attachAnalyticsEvent) === null || _api$analytics$attach === void 0 || _api$analytics$attach.call(_api$analytics, {
                                    action: (0, $3LeME.ACTION).INSERTED,
                                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).DATE,
                                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                                    attributes: {
                                        inputMethod: source ?? (0, $3LeME.INPUT_METHOD).QUICK_INSERT
                                    }
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>{
                    var _api$editorViewMode;
                    return (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
                };
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    var _api$analytics2, _api$annotation;
                    if (!(api !== null && api !== void 0 && api.annotation)) return true;
                    if (api !== null && api !== void 0 && (_api$analytics2 = api.analytics) !== null && _api$analytics2 !== void 0 && _api$analytics2.actions) {
                        var _api$analytics3;
                        api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || (_api$analytics3 = _api$analytics3.actions) === null || _api$analytics3 === void 0 || _api$analytics3.fireAnalyticsEvent({
                            action: (0, $3LeME.ACTION).CLICKED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                            eventType: (0, $3LeME.EVENT_TYPE).UI,
                            attributes: {
                                source: 'highlightActionsMenu',
                                pageMode: 'edit',
                                sourceNode: 'date'
                            }
                        });
                    }
                    const command = (_api$annotation = api.annotation) === null || _api$annotation === void 0 || (_api$annotation = _api$annotation.actions) === null || _api$annotation === void 0 ? void 0 : _api$annotation.setInlineCommentDraftState(true, (0, $3LeME.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Date floating toolbar',
                    nodeType: [
                        state.schema.nodes.date
                    ],
                    getDomRef: (editorView)=>{
                        const dateState = (0, $d95H3.pluginKey).getState(state);
                        const datePosition = dateState === null || dateState === void 0 ? void 0 : dateState.showDatePickerAt;
                        if (!datePosition) return undefined;
                        const domAtPos = editorView.domAtPos.bind(editorView);
                        const domRef = (0, $a4TQr.findDomRefAtPos)(datePosition, domAtPos);
                        const isHTMLElement = (element)=>{
                            return element instanceof HTMLElement;
                        };
                        if (isHTMLElement(domRef)) return domRef;
                        return undefined;
                    },
                    onPositionCalculated: (0, $9Q4ru.calculateToolbarPositionAboveSelection)('Date floating toolbar'),
                    items: (node)=>{
                        var _api$annotation2;
                        const annotationState = api === null || api === void 0 || (_api$annotation2 = api.annotation) === null || _api$annotation2 === void 0 ? void 0 : _api$annotation2.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && (annotationState === null || annotationState === void 0 ? void 0 : annotationState.annotations[mark.attrs.id]) === false);
                        const showAnnotation = annotationState && annotationState.isVisible && isViewMode() && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark;
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-date-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($3UAb3))),
                                title: intl.formatMessage((0, $RYyF2.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
                                    description: intl.formatMessage((0, $RYyF2.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
var $a2356adfcd431b7b$export$2e2bcd8739ae039 = $a2356adfcd431b7b$var$datePlugin;

});
parcelRegister("7ymzg", function(module, exports) {
$parcel$export(module.exports, "createDate", () => $01a89b6706516579$export$e029667a62135fd0);
$parcel$export(module.exports, "createDateAtTransaction", () => $01a89b6706516579$export$1a697965b9ed5436);
$parcel$export(module.exports, "focusDateInput", () => $01a89b6706516579$export$ba69c8aeb784b528);
$parcel$export(module.exports, "setDatePickerAt", () => $01a89b6706516579$export$70b286c4fa24838);
$parcel$export(module.exports, "closeDatePicker", () => $01a89b6706516579$export$a903d799de0e4474);
$parcel$export(module.exports, "closeDatePickerWithAnalytics", () => $01a89b6706516579$export$7c3e79dfb4962626);
$parcel$export(module.exports, "openDatePicker", () => $01a89b6706516579$export$621a48d450e82cf);

var $3LeME = parcelRequire("3LeME");

var $f1MDe = parcelRequire("f1MDe");

var $gR9lL = parcelRequire("gR9lL");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $34ULg = parcelRequire("34ULg");

var $d95H3 = parcelRequire("d95H3");
const $01a89b6706516579$export$e029667a62135fd0 = (isQuickInsertAction)=>(state)=>{
        const tr = state.tr;
        const annotationMarksForPos = (0, $f1MDe.getAnnotationMarksForPos)(tr.selection.$head);
        const dateNode = state.schema.nodes.date.createChecked({
            timestamp: (0, $gR9lL.todayTimestampInUTC)()
        }, null, annotationMarksForPos);
        const fragment = (0, $7H6Cr.Fragment).fromArray([
            dateNode,
            state.schema.text(' ', annotationMarksForPos)
        ]);
        const insertable = (0, $a4TQr.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $801jp.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $801jp.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $801jp.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return tr.setMeta((0, $d95H3.pluginKey), newPluginState);
    };
const $01a89b6706516579$export$1a697965b9ed5436 = (isQuickInsertAction)=>(tr)=>{
        const schema = tr.doc.type.schema;
        const annotationMarksForPos = (0, $f1MDe.getAnnotationMarksForPos)(tr.selection.$head);
        const dateNode = schema.nodes.date.createChecked({
            timestamp: (0, $gR9lL.todayTimestampInUTC)()
        }, null, annotationMarksForPos);
        const fragment = (0, $7H6Cr.Fragment).fromArray([
            dateNode,
            schema.text(' ', annotationMarksForPos)
        ]);
        const insertable = (0, $a4TQr.canInsert)(tr.selection.$from, fragment);
        if (!insertable) {
            const parentSelection = (0, $801jp.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
            tr.insert(parentSelection.to, fragment).setSelection((0, $801jp.NodeSelection).create(tr.doc, parentSelection.to + 1));
        } else tr.insert(tr.selection.from, fragment).setSelection((0, $801jp.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
        const newPluginState = {
            isQuickInsertAction: isQuickInsertAction,
            showDatePickerAt: tr.selection.from,
            isNew: true,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return tr.setMeta((0, $d95H3.pluginKey), newPluginState);
    };
const $01a89b6706516579$export$ba69c8aeb784b528 = ()=>(state, dispatch)=>{
        const pluginState = (0, $d95H3.pluginKey).getState(state);
        if (!pluginState || pluginState.showDatePickerAt === null) return false;
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $d95H3.pluginKey), {
            focusDateInput: true
        });
        dispatch(tr);
        return true;
    };
const $01a89b6706516579$export$70b286c4fa24838 = (showDatePickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $d95H3.pluginKey), {
            showDatePickerAt: showDatePickerAt
        }));
        return true;
    };
const $01a89b6706516579$export$a903d799de0e4474 = ()=>(state, dispatch)=>{
        const { showDatePickerAt: showDatePickerAt } = (0, $d95H3.pluginKey).getState(state) || {};
        if (!dispatch) return false;
        const tr = showDatePickerAt ? state.tr.setMeta((0, $d95H3.pluginKey), {
            showDatePickerAt: null,
            isNew: false
        }).setSelection((0, $801jp.Selection).near(state.tr.doc.resolve(showDatePickerAt + 2))) : state.tr.setMeta((0, $d95H3.pluginKey), {
            isNew: false
        });
        dispatch(tr);
        return false;
    };
const $01a89b6706516579$export$7c3e79dfb4962626 = ({ date: date, pluginInjectionApi: pluginInjectionApi })=>{
    var _pluginInjectionApi$a;
    pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 || (_pluginInjectionApi$a = _pluginInjectionApi$a.actions) === null || _pluginInjectionApi$a === void 0 || _pluginInjectionApi$a.attachAnalyticsEvent({
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        action: (0, $3LeME.ACTION).COMMITTED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DATE,
        attributes: {
            commitMethod: (0, $3LeME.INPUT_METHOD).BLUR,
            isValid: date !== undefined,
            isToday: (0, $34ULg.isToday)(date)
        }
    });
    return $01a89b6706516579$export$a903d799de0e4474();
};
const $01a89b6706516579$export$621a48d450e82cf = ()=>(state, dispatch)=>{
        const { $from: $from } = state.selection;
        const node = state.doc.nodeAt($from.pos);
        if (node && node.type.name === state.schema.nodes.date.name) {
            const showDatePickerAt = $from.pos;
            if (dispatch) dispatch(state.tr.setMeta((0, $d95H3.pluginKey), {
                showDatePickerAt: showDatePickerAt
            }).setSelection((0, $801jp.NodeSelection).create(state.doc, showDatePickerAt)));
        }
        return false;
    };

});
parcelRegister("34ULg", function(module, exports) {
$parcel$export(module.exports, "isDatePossiblyValid", () => $22cdf02110864a51$export$6e7fa6d67147cb9e);
$parcel$export(module.exports, "findDateSegmentByPosition", () => $22cdf02110864a51$export$ff5a653e9ab9c0bc);
$parcel$export(module.exports, "adjustDate", () => $22cdf02110864a51$export$6c4de3b0bb035f06);
$parcel$export(module.exports, "isToday", () => $22cdf02110864a51$export$629b0a497aa65267);
$parcel$export(module.exports, "getDFLocale", () => $22cdf02110864a51$export$1f30ec7fd3ecab15);

var $l9NHW = parcelRequire("l9NHW");

var $cyTA8 = parcelRequire("cyTA8");

var $2lbzP = parcelRequire("2lbzP");

var $4to69 = parcelRequire("4to69");

var $ggTei = parcelRequire("ggTei");
function $22cdf02110864a51$var$isDigit(c) {
    if (c === undefined) return false;
    return c >= '0' && c <= '9';
}
/**
 * Check if cursor is in first segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $22cdf02110864a51$var$isCursorInFirstDateSegment(cursorPos, date) {
    let posCounter = cursorPos - 1;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter >= 0 && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$22cdf02110864a51$var$isDigit(c)) isAdjacent = false;
        posCounter -= 1;
    }
    return isAdjacent;
}
/**
 * Check if cursor is in last segment of a date.
 * @param cursorPos Cursor pos, with 0 referring to the left of first char
 * @param date Date string in any locale
 */ function $22cdf02110864a51$var$isCursorInLastDateSegment(cursorPos, date) {
    let posCounter = cursorPos;
    let isAdjacent = true;
    // The date without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedDate = date.replace(/[^0-9]+$/g, '');
    while(posCounter < strippedDate.length && isAdjacent){
        const c = strippedDate[posCounter];
        if (!$22cdf02110864a51$var$isDigit(c)) isAdjacent = false;
        posCounter += 1;
    }
    return isAdjacent;
}
function $22cdf02110864a51$export$6e7fa6d67147cb9e(date) {
    for (const c of date){
        const isNumber = c >= '0' && c <= '9';
        const isValidPunctuation = '. ,/-'.indexOf(c) !== -1;
        if (!(isNumber || isValidPunctuation)) return false;
    }
    return true;
}
function $22cdf02110864a51$export$ff5a653e9ab9c0bc(position, date, locale) {
    if (position > date.length) return undefined;
    const placeholder = $22cdf02110864a51$export$a785060aa48542fa(locale);
    if (!placeholder) return undefined;
    // The placeholder without any non-digit characters on the end
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const strippedPlaceholder = placeholder.replace(/[^ymd]+$/g, '');
    const keyToSegment = {
        d: 'day',
        m: 'month',
        y: 'year'
    };
    const firstSegment = keyToSegment[strippedPlaceholder[0]];
    const lastSegment = keyToSegment[strippedPlaceholder[strippedPlaceholder.length - 1]];
    const allPossibleSegments = [
        'day',
        'month',
        'year'
    ];
    const middleSegment = allPossibleSegments.filter((s)=>s !== firstSegment && s !== lastSegment)[0];
    if ($22cdf02110864a51$var$isCursorInFirstDateSegment(position, date)) return firstSegment;
    if ($22cdf02110864a51$var$isCursorInLastDateSegment(position, date)) return lastSegment;
    return middleSegment;
}
function $22cdf02110864a51$export$a785060aa48542fa(locale) {
    const uniqueDateType = {
        day: 7,
        month: 1,
        year: 1992
    };
    const localisedDateString = (0, $ggTei.formatDateType)(uniqueDateType, locale);
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const shortDateFormat = localisedDateString.replace(/\d+/g, (str)=>{
        if (!str) return '';
        // Ignored via go/ees005
        // eslint-disable-next-line no-var
        var num = parseInt(str);
        switch(num % 100){
            case 92:
                // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                return str.replace(/.{1}/g, 'y');
            case 1:
                return str.length === 1 ? 'm' : 'mm';
            case 7:
                return str.length === 1 ? 'd' : 'dd';
        }
        return '';
    });
    return shortDateFormat;
}
function $22cdf02110864a51$export$6c4de3b0bb035f06(date, activeSegment, adjustment) {
    const originalDate = (0, $ggTei.dateTypeToDate)(date);
    const newDate = activeSegment === 'day' ? (0, $l9NHW.default)(originalDate, adjustment) : activeSegment === 'month' ? (0, $cyTA8.default)(originalDate, adjustment) : (0, $2lbzP.default)(originalDate, adjustment);
    return (0, $ggTei.dateToDateType)(newDate);
}
function $22cdf02110864a51$export$629b0a497aa65267(date) {
    const today = new Date();
    return date !== undefined && today.getDate() === date.day && date.month === today.getMonth() + 1 && date.year === today.getFullYear();
}
function $22cdf02110864a51$export$1f30ec7fd3ecab15(localeString) {
    let dfLocaleString = localeString;
    const [lang, region] = localeString.split('-');
    if (region) {
        if (lang.toLocaleLowerCase() === region.toLocaleLowerCase()) dfLocaleString = lang;
        else dfLocaleString = `${lang}${region}`;
    }
    return $4to69[dfLocaleString];
}

});
parcelRegister("2lbzP", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b4685dad71b769a$export$2e2bcd8739ae039);

var $1Cu8A = parcelRequire("1Cu8A");

var $cyTA8 = parcelRequire("cyTA8");

var $3mokv = parcelRequire("3mokv");
function $1b4685dad71b769a$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3mokv.default)(2, arguments);
    var amount = (0, $1Cu8A.default)(dirtyAmount);
    return (0, $cyTA8.default)(dirtyDate, amount * 12);
}

});

parcelRegister("4to69", function(module, exports) {
$parcel$export(module.exports, "af", () => (parcelRequire("f1wgL")).default);
$parcel$export(module.exports, "ar", () => (parcelRequire("j5Zhv")).default);
$parcel$export(module.exports, "arDZ", () => (parcelRequire("4LE9y")).default);
$parcel$export(module.exports, "arEG", () => (parcelRequire("jciNY")).default);
$parcel$export(module.exports, "arMA", () => (parcelRequire("2jLBG")).default);
$parcel$export(module.exports, "arSA", () => (parcelRequire("3ET3K")).default);
$parcel$export(module.exports, "arTN", () => (parcelRequire("1Qaa9")).default);
$parcel$export(module.exports, "az", () => (parcelRequire("erTXW")).default);
$parcel$export(module.exports, "be", () => (parcelRequire("5ZVu7")).default);
$parcel$export(module.exports, "beTarask", () => (parcelRequire("hxDC9")).default);
$parcel$export(module.exports, "bg", () => (parcelRequire("ghgUV")).default);
$parcel$export(module.exports, "bn", () => (parcelRequire("hASGv")).default);
$parcel$export(module.exports, "bs", () => (parcelRequire("17pme")).default);
$parcel$export(module.exports, "ca", () => (parcelRequire("eEhbM")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("88nZz")).default);
$parcel$export(module.exports, "cy", () => (parcelRequire("3UDQB")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("eLqcu")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("anB32")).default);
$parcel$export(module.exports, "deAT", () => (parcelRequire("aSqUy")).default);
$parcel$export(module.exports, "el", () => (parcelRequire("fz78E")).default);
$parcel$export(module.exports, "enAU", () => (parcelRequire("frnym")).default);
$parcel$export(module.exports, "enCA", () => (parcelRequire("1UQEO")).default);
$parcel$export(module.exports, "enGB", () => (parcelRequire("kasdO")).default);
$parcel$export(module.exports, "enIE", () => (parcelRequire("j628G")).default);
$parcel$export(module.exports, "enIN", () => (parcelRequire("99uil")).default);
$parcel$export(module.exports, "enNZ", () => (parcelRequire("9TFY4")).default);
$parcel$export(module.exports, "enUS", () => (parcelRequire("1I9Ga")).default);
$parcel$export(module.exports, "enZA", () => (parcelRequire("j75ov")).default);
$parcel$export(module.exports, "eo", () => (parcelRequire("6UJtN")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("aA59Q")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("fwir9")).default);
$parcel$export(module.exports, "eu", () => (parcelRequire("6ZYNO")).default);
$parcel$export(module.exports, "faIR", () => (parcelRequire("8GUaw")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("7MpTG")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("bPhCV")).default);
$parcel$export(module.exports, "frCA", () => (parcelRequire("3DNgk")).default);
$parcel$export(module.exports, "frCH", () => (parcelRequire("QREsG")).default);
$parcel$export(module.exports, "fy", () => (parcelRequire("czCAW")).default);
$parcel$export(module.exports, "gd", () => (parcelRequire("dLpe9")).default);
$parcel$export(module.exports, "gl", () => (parcelRequire("jouRp")).default);
$parcel$export(module.exports, "gu", () => (parcelRequire("ej0gB")).default);
$parcel$export(module.exports, "he", () => (parcelRequire("avOr6")).default);
$parcel$export(module.exports, "hi", () => (parcelRequire("gb2D1")).default);
$parcel$export(module.exports, "hr", () => (parcelRequire("ld1Cx")).default);
$parcel$export(module.exports, "ht", () => (parcelRequire("cN6IN")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("QQXxB")).default);
$parcel$export(module.exports, "hy", () => (parcelRequire("2JBTq")).default);
$parcel$export(module.exports, "id", () => (parcelRequire("dYqHL")).default);
$parcel$export(module.exports, "is", () => (parcelRequire("jPBT1")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("ejBXU")).default);
$parcel$export(module.exports, "itCH", () => (parcelRequire("3vVJt")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("9MXAM")).default);
$parcel$export(module.exports, "jaHira", () => (parcelRequire("h1e29")).default);
$parcel$export(module.exports, "ka", () => (parcelRequire("lit0q")).default);
$parcel$export(module.exports, "kk", () => (parcelRequire("irh1Y")).default);
$parcel$export(module.exports, "km", () => (parcelRequire("h1PQB")).default);
$parcel$export(module.exports, "kn", () => (parcelRequire("e66Gp")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("ftOhr")).default);
$parcel$export(module.exports, "lb", () => (parcelRequire("ksnpw")).default);
$parcel$export(module.exports, "lt", () => (parcelRequire("3o0d9")).default);
$parcel$export(module.exports, "lv", () => (parcelRequire("iKYwd")).default);
$parcel$export(module.exports, "mk", () => (parcelRequire("j7Ixm")).default);
$parcel$export(module.exports, "mn", () => (parcelRequire("bKZJW")).default);
$parcel$export(module.exports, "ms", () => (parcelRequire("iuD6w")).default);
$parcel$export(module.exports, "mt", () => (parcelRequire("6uHC7")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("hQOQW")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("ljuVT")).default);
$parcel$export(module.exports, "nlBE", () => (parcelRequire("2OZXk")).default);
$parcel$export(module.exports, "nn", () => (parcelRequire("js8X1")).default);
$parcel$export(module.exports, "oc", () => (parcelRequire("1BdZC")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("gIJv1")).default);
$parcel$export(module.exports, "pt", () => (parcelRequire("6QbV1")).default);
$parcel$export(module.exports, "ptBR", () => (parcelRequire("9bcHL")).default);
$parcel$export(module.exports, "ro", () => (parcelRequire("6oDYY")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("ko9yy")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("juYbe")).default);
$parcel$export(module.exports, "sl", () => (parcelRequire("lVRfM")).default);
$parcel$export(module.exports, "sq", () => (parcelRequire("f8Eyy")).default);
$parcel$export(module.exports, "sr", () => (parcelRequire("k6cG1")).default);
$parcel$export(module.exports, "srLatn", () => (parcelRequire("fzxMA")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("bBvvF")).default);
$parcel$export(module.exports, "ta", () => (parcelRequire("19svK")).default);
$parcel$export(module.exports, "te", () => (parcelRequire("bjnRf")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("afnbu")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("3Gnx1")).default);
$parcel$export(module.exports, "ug", () => (parcelRequire("duCtQ")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("hYfH6")).default);
$parcel$export(module.exports, "uz", () => (parcelRequire("l5Ec0")).default);
$parcel$export(module.exports, "uzCyrl", () => (parcelRequire("3aRmk")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("ebB1q")).default);
$parcel$export(module.exports, "zhCN", () => (parcelRequire("4968X")).default);
$parcel$export(module.exports, "zhHK", () => (parcelRequire("oSXfJ")).default);
$parcel$export(module.exports, "zhTW", () => (parcelRequire("cxmiN")).default);
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

var $f1wgL = parcelRequire("f1wgL");

var $j5Zhv = parcelRequire("j5Zhv");

var $4LE9y = parcelRequire("4LE9y");

var $jciNY = parcelRequire("jciNY");

var $2jLBG = parcelRequire("2jLBG");

var $3ET3K = parcelRequire("3ET3K");

var $1Qaa9 = parcelRequire("1Qaa9");

var $erTXW = parcelRequire("erTXW");

var $5ZVu7 = parcelRequire("5ZVu7");

var $hxDC9 = parcelRequire("hxDC9");

var $ghgUV = parcelRequire("ghgUV");

var $hASGv = parcelRequire("hASGv");

var $17pme = parcelRequire("17pme");

var $eEhbM = parcelRequire("eEhbM");

var $88nZz = parcelRequire("88nZz");

var $3UDQB = parcelRequire("3UDQB");

var $eLqcu = parcelRequire("eLqcu");

var $anB32 = parcelRequire("anB32");

var $aSqUy = parcelRequire("aSqUy");

var $fz78E = parcelRequire("fz78E");

var $frnym = parcelRequire("frnym");

var $1UQEO = parcelRequire("1UQEO");

var $kasdO = parcelRequire("kasdO");

var $j628G = parcelRequire("j628G");

var $99uil = parcelRequire("99uil");

var $9TFY4 = parcelRequire("9TFY4");

var $1I9Ga = parcelRequire("1I9Ga");

var $j75ov = parcelRequire("j75ov");

var $6UJtN = parcelRequire("6UJtN");

var $aA59Q = parcelRequire("aA59Q");

var $fwir9 = parcelRequire("fwir9");

var $6ZYNO = parcelRequire("6ZYNO");

var $8GUaw = parcelRequire("8GUaw");

var $7MpTG = parcelRequire("7MpTG");

var $bPhCV = parcelRequire("bPhCV");

var $3DNgk = parcelRequire("3DNgk");

var $QREsG = parcelRequire("QREsG");

var $czCAW = parcelRequire("czCAW");

var $dLpe9 = parcelRequire("dLpe9");

var $jouRp = parcelRequire("jouRp");

var $ej0gB = parcelRequire("ej0gB");

var $avOr6 = parcelRequire("avOr6");

var $gb2D1 = parcelRequire("gb2D1");

var $ld1Cx = parcelRequire("ld1Cx");

var $cN6IN = parcelRequire("cN6IN");

var $QQXxB = parcelRequire("QQXxB");

var $2JBTq = parcelRequire("2JBTq");

var $dYqHL = parcelRequire("dYqHL");

var $jPBT1 = parcelRequire("jPBT1");

var $ejBXU = parcelRequire("ejBXU");

var $3vVJt = parcelRequire("3vVJt");

var $9MXAM = parcelRequire("9MXAM");

var $h1e29 = parcelRequire("h1e29");

var $lit0q = parcelRequire("lit0q");

var $irh1Y = parcelRequire("irh1Y");

var $h1PQB = parcelRequire("h1PQB");

var $e66Gp = parcelRequire("e66Gp");

var $ftOhr = parcelRequire("ftOhr");

var $ksnpw = parcelRequire("ksnpw");

var $3o0d9 = parcelRequire("3o0d9");

var $iKYwd = parcelRequire("iKYwd");

var $j7Ixm = parcelRequire("j7Ixm");

var $bKZJW = parcelRequire("bKZJW");

var $iuD6w = parcelRequire("iuD6w");

var $6uHC7 = parcelRequire("6uHC7");

var $hQOQW = parcelRequire("hQOQW");

var $ljuVT = parcelRequire("ljuVT");

var $2OZXk = parcelRequire("2OZXk");

var $js8X1 = parcelRequire("js8X1");

var $1BdZC = parcelRequire("1BdZC");

var $gIJv1 = parcelRequire("gIJv1");

var $6QbV1 = parcelRequire("6QbV1");

var $9bcHL = parcelRequire("9bcHL");

var $6oDYY = parcelRequire("6oDYY");

var $ko9yy = parcelRequire("ko9yy");

var $juYbe = parcelRequire("juYbe");

var $lVRfM = parcelRequire("lVRfM");

var $f8Eyy = parcelRequire("f8Eyy");

var $k6cG1 = parcelRequire("k6cG1");

var $fzxMA = parcelRequire("fzxMA");

var $bBvvF = parcelRequire("bBvvF");

var $19svK = parcelRequire("19svK");

var $bjnRf = parcelRequire("bjnRf");

var $afnbu = parcelRequire("afnbu");

var $3Gnx1 = parcelRequire("3Gnx1");

var $duCtQ = parcelRequire("duCtQ");

var $hYfH6 = parcelRequire("hYfH6");

var $l5Ec0 = parcelRequire("l5Ec0");

var $3aRmk = parcelRequire("3aRmk");

var $ebB1q = parcelRequire("ebB1q");

var $4968X = parcelRequire("4968X");

var $oSXfJ = parcelRequire("oSXfJ");

var $cxmiN = parcelRequire("cxmiN");

});
parcelRegister("f1wgL", function(module, exports) {
$parcel$export(module.exports, "default", () => $aefffb0c22a667a6$export$2e2bcd8739ae039);

var $6ZCvB = parcelRequire("6ZCvB");

var $dDAeO = parcelRequire("dDAeO");

var $ikZ4L = parcelRequire("ikZ4L");

var $7yPuz = parcelRequire("7yPuz");

var $OomSJ = parcelRequire("OomSJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var $aefffb0c22a667a6$var$locale = {
    code: 'af',
    formatDistance: (0, $6ZCvB.default),
    formatLong: (0, $dDAeO.default),
    formatRelative: (0, $ikZ4L.default),
    localize: (0, $7yPuz.default),
    match: (0, $OomSJ.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $aefffb0c22a667a6$export$2e2bcd8739ae039 = $aefffb0c22a667a6$var$locale;

});
parcelRegister("6ZCvB", function(module, exports) {
$parcel$export(module.exports, "default", () => $51764f9eb16d40c0$export$2e2bcd8739ae039);
var $51764f9eb16d40c0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var $51764f9eb16d40c0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $51764f9eb16d40c0$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
var $51764f9eb16d40c0$export$2e2bcd8739ae039 = $51764f9eb16d40c0$var$formatDistance;

});

parcelRegister("dDAeO", function(module, exports) {
$parcel$export(module.exports, "default", () => $9edb06f707014f49$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $9edb06f707014f49$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $9edb06f707014f49$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $9edb06f707014f49$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9edb06f707014f49$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $9edb06f707014f49$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $9edb06f707014f49$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $9edb06f707014f49$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9edb06f707014f49$export$2e2bcd8739ae039 = $9edb06f707014f49$var$formatLong;

});

parcelRegister("ikZ4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $d599789fdf48f857$export$2e2bcd8739ae039);
var $d599789fdf48f857$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $d599789fdf48f857$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d599789fdf48f857$var$formatRelativeLocale[token];
};
var $d599789fdf48f857$export$2e2bcd8739ae039 = $d599789fdf48f857$var$formatRelative;

});

parcelRegister("7yPuz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5813a69e8012c7ae$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $5813a69e8012c7ae$var$eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $5813a69e8012c7ae$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var $5813a69e8012c7ae$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $5813a69e8012c7ae$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var $5813a69e8012c7ae$var$dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var $5813a69e8012c7ae$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var $5813a69e8012c7ae$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var $5813a69e8012c7ae$var$localize = {
    ordinalNumber: $5813a69e8012c7ae$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5813a69e8012c7ae$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5813a69e8012c7ae$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5813a69e8012c7ae$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5813a69e8012c7ae$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5813a69e8012c7ae$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5813a69e8012c7ae$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5813a69e8012c7ae$export$2e2bcd8739ae039 = $5813a69e8012c7ae$var$localize;

});

parcelRegister("OomSJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0977929d85f0dcea$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $0977929d85f0dcea$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var $0977929d85f0dcea$var$parseOrdinalNumberPattern = /\d+/i;
var $0977929d85f0dcea$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var $0977929d85f0dcea$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $0977929d85f0dcea$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var $0977929d85f0dcea$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0977929d85f0dcea$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var $0977929d85f0dcea$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var $0977929d85f0dcea$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var $0977929d85f0dcea$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var $0977929d85f0dcea$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var $0977929d85f0dcea$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var $0977929d85f0dcea$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $0977929d85f0dcea$var$matchOrdinalNumberPattern,
        parsePattern: $0977929d85f0dcea$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $0977929d85f0dcea$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0977929d85f0dcea$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $0977929d85f0dcea$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0977929d85f0dcea$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $0977929d85f0dcea$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0977929d85f0dcea$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $0977929d85f0dcea$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0977929d85f0dcea$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $0977929d85f0dcea$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0977929d85f0dcea$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0977929d85f0dcea$export$2e2bcd8739ae039 = $0977929d85f0dcea$var$match;

});


parcelRegister("j5Zhv", function(module, exports) {
$parcel$export(module.exports, "default", () => $de6e0524322324d7$export$2e2bcd8739ae039);

var $aU3VE = parcelRequire("aU3VE");

var $d8zOt = parcelRequire("d8zOt");

var $jkIAw = parcelRequire("jkIAw");

var $4w1xY = parcelRequire("4w1xY");

var $l6fiI = parcelRequire("l6fiI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $de6e0524322324d7$var$locale = {
    code: 'ar',
    formatDistance: (0, $aU3VE.default),
    formatLong: (0, $d8zOt.default),
    formatRelative: (0, $jkIAw.default),
    localize: (0, $4w1xY.default),
    match: (0, $l6fiI.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $de6e0524322324d7$export$2e2bcd8739ae039 = $de6e0524322324d7$var$locale;

});
parcelRegister("aU3VE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f022e8a431bbdd8$export$2e2bcd8739ae039);
var $7f022e8a431bbdd8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var $7f022e8a431bbdd8$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $7f022e8a431bbdd8$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $7f022e8a431bbdd8$export$2e2bcd8739ae039 = $7f022e8a431bbdd8$var$formatDistance;

});

parcelRegister("d8zOt", function(module, exports) {
$parcel$export(module.exports, "default", () => $9907cd751d13b79e$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $9907cd751d13b79e$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $9907cd751d13b79e$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $9907cd751d13b79e$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9907cd751d13b79e$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $9907cd751d13b79e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $9907cd751d13b79e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $9907cd751d13b79e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9907cd751d13b79e$export$2e2bcd8739ae039 = $9907cd751d13b79e$var$formatLong;

});

parcelRegister("jkIAw", function(module, exports) {
$parcel$export(module.exports, "default", () => $e13278d874d231b3$export$2e2bcd8739ae039);
var $e13278d874d231b3$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $e13278d874d231b3$var$formatRelative = function formatRelative(token) {
    return $e13278d874d231b3$var$formatRelativeLocale[token];
};
var $e13278d874d231b3$export$2e2bcd8739ae039 = $e13278d874d231b3$var$formatRelative;

});

parcelRegister("4w1xY", function(module, exports) {
$parcel$export(module.exports, "default", () => $349b59caf4c9abbf$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $349b59caf4c9abbf$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $349b59caf4c9abbf$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $349b59caf4c9abbf$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $349b59caf4c9abbf$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $349b59caf4c9abbf$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $349b59caf4c9abbf$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $349b59caf4c9abbf$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $349b59caf4c9abbf$var$localize = {
    ordinalNumber: $349b59caf4c9abbf$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $349b59caf4c9abbf$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $349b59caf4c9abbf$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $349b59caf4c9abbf$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $349b59caf4c9abbf$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $349b59caf4c9abbf$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $349b59caf4c9abbf$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $349b59caf4c9abbf$export$2e2bcd8739ae039 = $349b59caf4c9abbf$var$localize;

});

parcelRegister("l6fiI", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5c606f0a9020882$export$2e2bcd8739ae039);

var $59jA4 = parcelRequire("59jA4");

var $ckS9b = parcelRequire("ckS9b");
var $f5c606f0a9020882$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $f5c606f0a9020882$var$parseOrdinalNumberPattern = /\d+/i;
var $f5c606f0a9020882$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $f5c606f0a9020882$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $f5c606f0a9020882$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $f5c606f0a9020882$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f5c606f0a9020882$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $f5c606f0a9020882$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $f5c606f0a9020882$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $f5c606f0a9020882$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $f5c606f0a9020882$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var $f5c606f0a9020882$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var $f5c606f0a9020882$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $f5c606f0a9020882$var$matchOrdinalNumberPattern,
        parsePattern: $f5c606f0a9020882$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $f5c606f0a9020882$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f5c606f0a9020882$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $f5c606f0a9020882$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f5c606f0a9020882$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $f5c606f0a9020882$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f5c606f0a9020882$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $f5c606f0a9020882$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f5c606f0a9020882$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $f5c606f0a9020882$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f5c606f0a9020882$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f5c606f0a9020882$export$2e2bcd8739ae039 = $f5c606f0a9020882$var$match;

});


parcelRegister("jciNY", function(module, exports) {
$parcel$export(module.exports, "default", () => $df9db99cb6aa8733$export$2e2bcd8739ae039);

var $5bu2o = parcelRequire("5bu2o");

var $6OYV5 = parcelRequire("6OYV5");

var $eV3YV = parcelRequire("eV3YV");

var $75AHJ = parcelRequire("75AHJ");

var $8UylJ = parcelRequire("8UylJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var $df9db99cb6aa8733$var$locale = {
    code: 'ar-EG',
    formatDistance: (0, $5bu2o.default),
    formatLong: (0, $6OYV5.default),
    formatRelative: (0, $eV3YV.default),
    localize: (0, $75AHJ.default),
    match: (0, $8UylJ.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $df9db99cb6aa8733$export$2e2bcd8739ae039 = $df9db99cb6aa8733$var$locale;

});
parcelRegister("5bu2o", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c6547a67aa00e17$export$2e2bcd8739ae039);
var $3c6547a67aa00e17$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var $3c6547a67aa00e17$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3c6547a67aa00e17$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
var $3c6547a67aa00e17$export$2e2bcd8739ae039 = $3c6547a67aa00e17$var$formatDistance;

});

parcelRegister("6OYV5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f76ab003cdb3f29$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $4f76ab003cdb3f29$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var $4f76ab003cdb3f29$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $4f76ab003cdb3f29$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $4f76ab003cdb3f29$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $4f76ab003cdb3f29$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $4f76ab003cdb3f29$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $4f76ab003cdb3f29$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4f76ab003cdb3f29$export$2e2bcd8739ae039 = $4f76ab003cdb3f29$var$formatLong;

});

parcelRegister("eV3YV", function(module, exports) {
$parcel$export(module.exports, "default", () => $adc97a3ac42dab8d$export$2e2bcd8739ae039);
var $adc97a3ac42dab8d$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var $adc97a3ac42dab8d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $adc97a3ac42dab8d$var$formatRelativeLocale[token];
};
var $adc97a3ac42dab8d$export$2e2bcd8739ae039 = $adc97a3ac42dab8d$var$formatRelative;

});

parcelRegister("75AHJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0154fdd1a0a58d66$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $0154fdd1a0a58d66$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $0154fdd1a0a58d66$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $0154fdd1a0a58d66$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $0154fdd1a0a58d66$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $0154fdd1a0a58d66$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $0154fdd1a0a58d66$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $0154fdd1a0a58d66$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $0154fdd1a0a58d66$var$localize = {
    ordinalNumber: $0154fdd1a0a58d66$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $0154fdd1a0a58d66$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $0154fdd1a0a58d66$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $0154fdd1a0a58d66$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $0154fdd1a0a58d66$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $0154fdd1a0a58d66$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $0154fdd1a0a58d66$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0154fdd1a0a58d66$export$2e2bcd8739ae039 = $0154fdd1a0a58d66$var$localize;

});

parcelRegister("8UylJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $67ce32c8e699035f$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $67ce32c8e699035f$var$matchOrdinalNumberPattern = /^(\d+)/;
var $67ce32c8e699035f$var$parseOrdinalNumberPattern = /\d+/i;
var $67ce32c8e699035f$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var $67ce32c8e699035f$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var $67ce32c8e699035f$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var $67ce32c8e699035f$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var $67ce32c8e699035f$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $67ce32c8e699035f$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var $67ce32c8e699035f$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var $67ce32c8e699035f$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var $67ce32c8e699035f$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var $67ce32c8e699035f$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var $67ce32c8e699035f$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $67ce32c8e699035f$var$matchOrdinalNumberPattern,
        parsePattern: $67ce32c8e699035f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $67ce32c8e699035f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67ce32c8e699035f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $67ce32c8e699035f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67ce32c8e699035f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $67ce32c8e699035f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67ce32c8e699035f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $67ce32c8e699035f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $67ce32c8e699035f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $67ce32c8e699035f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $67ce32c8e699035f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $67ce32c8e699035f$export$2e2bcd8739ae039 = $67ce32c8e699035f$var$match;

});


parcelRegister("2jLBG", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b0248d30a96c666$export$2e2bcd8739ae039);

var $41R8d = parcelRequire("41R8d");

var $bAynz = parcelRequire("bAynz");

var $j6swN = parcelRequire("j6swN");

var $bOb4z = parcelRequire("bOb4z");

var $jX33C = parcelRequire("jX33C");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var $1b0248d30a96c666$var$locale = {
    code: 'ar-MA',
    formatDistance: (0, $41R8d.default),
    formatLong: (0, $bAynz.default),
    formatRelative: (0, $j6swN.default),
    localize: (0, $bOb4z.default),
    match: (0, $jX33C.default),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $1b0248d30a96c666$export$2e2bcd8739ae039 = $1b0248d30a96c666$var$locale;

});
parcelRegister("41R8d", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ef0783abae0fc27$export$2e2bcd8739ae039);
var $2ef0783abae0fc27$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $2ef0783abae0fc27$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $2ef0783abae0fc27$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $2ef0783abae0fc27$export$2e2bcd8739ae039 = $2ef0783abae0fc27$var$formatDistance;

});

parcelRegister("bAynz", function(module, exports) {
$parcel$export(module.exports, "default", () => $86fdb97bda00fac8$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $86fdb97bda00fac8$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $86fdb97bda00fac8$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $86fdb97bda00fac8$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $86fdb97bda00fac8$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $86fdb97bda00fac8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $86fdb97bda00fac8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $86fdb97bda00fac8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $86fdb97bda00fac8$export$2e2bcd8739ae039 = $86fdb97bda00fac8$var$formatLong;

});

parcelRegister("j6swN", function(module, exports) {
$parcel$export(module.exports, "default", () => $de84b4ec6816547f$export$2e2bcd8739ae039);
var $de84b4ec6816547f$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $de84b4ec6816547f$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $de84b4ec6816547f$var$formatRelativeLocale[token];
};
var $de84b4ec6816547f$export$2e2bcd8739ae039 = $de84b4ec6816547f$var$formatRelative;

});

parcelRegister("bOb4z", function(module, exports) {
$parcel$export(module.exports, "default", () => $898cf40a4a08528f$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $898cf40a4a08528f$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $898cf40a4a08528f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $898cf40a4a08528f$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var $898cf40a4a08528f$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $898cf40a4a08528f$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $898cf40a4a08528f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $898cf40a4a08528f$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $898cf40a4a08528f$var$localize = {
    ordinalNumber: $898cf40a4a08528f$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $898cf40a4a08528f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $898cf40a4a08528f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $898cf40a4a08528f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $898cf40a4a08528f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $898cf40a4a08528f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $898cf40a4a08528f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $898cf40a4a08528f$export$2e2bcd8739ae039 = $898cf40a4a08528f$var$localize;

});

parcelRegister("jX33C", function(module, exports) {
$parcel$export(module.exports, "default", () => $e865e629f1d8f0ca$export$2e2bcd8739ae039);

var $59jA4 = parcelRequire("59jA4");

var $ckS9b = parcelRequire("ckS9b");
var $e865e629f1d8f0ca$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $e865e629f1d8f0ca$var$parseOrdinalNumberPattern = /\d+/i;
var $e865e629f1d8f0ca$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $e865e629f1d8f0ca$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $e865e629f1d8f0ca$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $e865e629f1d8f0ca$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e865e629f1d8f0ca$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var $e865e629f1d8f0ca$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $e865e629f1d8f0ca$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $e865e629f1d8f0ca$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $e865e629f1d8f0ca$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $e865e629f1d8f0ca$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $e865e629f1d8f0ca$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $e865e629f1d8f0ca$var$matchOrdinalNumberPattern,
        parsePattern: $e865e629f1d8f0ca$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $e865e629f1d8f0ca$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e865e629f1d8f0ca$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $e865e629f1d8f0ca$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e865e629f1d8f0ca$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $e865e629f1d8f0ca$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e865e629f1d8f0ca$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $e865e629f1d8f0ca$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e865e629f1d8f0ca$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $e865e629f1d8f0ca$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e865e629f1d8f0ca$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e865e629f1d8f0ca$export$2e2bcd8739ae039 = $e865e629f1d8f0ca$var$match;

});


parcelRegister("3ET3K", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a9fd1329564dda9$export$2e2bcd8739ae039);

var $3v0gK = parcelRequire("3v0gK");

var $8UdkC = parcelRequire("8UdkC");

var $2Ca2a = parcelRequire("2Ca2a");

var $b4QqK = parcelRequire("b4QqK");

var $ps2Pe = parcelRequire("ps2Pe");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var $2a9fd1329564dda9$var$locale = {
    code: 'ar-SA',
    formatDistance: (0, $3v0gK.default),
    formatLong: (0, $8UdkC.default),
    formatRelative: (0, $2Ca2a.default),
    localize: (0, $b4QqK.default),
    match: (0, $ps2Pe.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2a9fd1329564dda9$export$2e2bcd8739ae039 = $2a9fd1329564dda9$var$locale;

});
parcelRegister("3v0gK", function(module, exports) {
$parcel$export(module.exports, "default", () => $28c479cd2974768b$export$2e2bcd8739ae039);
var $28c479cd2974768b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $28c479cd2974768b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $28c479cd2974768b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $28c479cd2974768b$export$2e2bcd8739ae039 = $28c479cd2974768b$var$formatDistance;

});

parcelRegister("8UdkC", function(module, exports) {
$parcel$export(module.exports, "default", () => $67bde512baed1a4f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $67bde512baed1a4f$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $67bde512baed1a4f$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $67bde512baed1a4f$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $67bde512baed1a4f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $67bde512baed1a4f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $67bde512baed1a4f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $67bde512baed1a4f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $67bde512baed1a4f$export$2e2bcd8739ae039 = $67bde512baed1a4f$var$formatLong;

});

parcelRegister("2Ca2a", function(module, exports) {
$parcel$export(module.exports, "default", () => $1e76e9e73569f766$export$2e2bcd8739ae039);
var $1e76e9e73569f766$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var $1e76e9e73569f766$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1e76e9e73569f766$var$formatRelativeLocale[token];
};
var $1e76e9e73569f766$export$2e2bcd8739ae039 = $1e76e9e73569f766$var$formatRelative;

});

parcelRegister("b4QqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $8108bd0a0664f5ea$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $8108bd0a0664f5ea$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $8108bd0a0664f5ea$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $8108bd0a0664f5ea$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $8108bd0a0664f5ea$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $8108bd0a0664f5ea$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $8108bd0a0664f5ea$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $8108bd0a0664f5ea$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $8108bd0a0664f5ea$var$localize = {
    ordinalNumber: $8108bd0a0664f5ea$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $8108bd0a0664f5ea$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $8108bd0a0664f5ea$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $8108bd0a0664f5ea$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $8108bd0a0664f5ea$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $8108bd0a0664f5ea$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8108bd0a0664f5ea$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8108bd0a0664f5ea$export$2e2bcd8739ae039 = $8108bd0a0664f5ea$var$localize;

});

parcelRegister("ps2Pe", function(module, exports) {
$parcel$export(module.exports, "default", () => $04c816fb3f6d5baf$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $04c816fb3f6d5baf$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $04c816fb3f6d5baf$var$parseOrdinalNumberPattern = /\d+/i;
var $04c816fb3f6d5baf$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $04c816fb3f6d5baf$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $04c816fb3f6d5baf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $04c816fb3f6d5baf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $04c816fb3f6d5baf$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var $04c816fb3f6d5baf$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $04c816fb3f6d5baf$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $04c816fb3f6d5baf$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $04c816fb3f6d5baf$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $04c816fb3f6d5baf$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $04c816fb3f6d5baf$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $04c816fb3f6d5baf$var$matchOrdinalNumberPattern,
        parsePattern: $04c816fb3f6d5baf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $04c816fb3f6d5baf$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $04c816fb3f6d5baf$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $04c816fb3f6d5baf$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $04c816fb3f6d5baf$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $04c816fb3f6d5baf$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $04c816fb3f6d5baf$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $04c816fb3f6d5baf$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $04c816fb3f6d5baf$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $04c816fb3f6d5baf$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $04c816fb3f6d5baf$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $04c816fb3f6d5baf$export$2e2bcd8739ae039 = $04c816fb3f6d5baf$var$match;

});


parcelRegister("1Qaa9", function(module, exports) {
$parcel$export(module.exports, "default", () => $157287e54af2129f$export$2e2bcd8739ae039);

var $7UR0u = parcelRequire("7UR0u");

var $8EyHP = parcelRequire("8EyHP");

var $3asiM = parcelRequire("3asiM");

var $7TX2q = parcelRequire("7TX2q");

var $3seHX = parcelRequire("3seHX");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $157287e54af2129f$var$locale = {
    code: 'ar-TN',
    formatDistance: (0, $7UR0u.default),
    formatLong: (0, $8EyHP.default),
    formatRelative: (0, $3asiM.default),
    localize: (0, $7TX2q.default),
    match: (0, $3seHX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $157287e54af2129f$export$2e2bcd8739ae039 = $157287e54af2129f$var$locale;

});
parcelRegister("7UR0u", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c36e1713a058c5f$export$2e2bcd8739ae039);
var $5c36e1713a058c5f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var $5c36e1713a058c5f$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $5c36e1713a058c5f$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
var $5c36e1713a058c5f$export$2e2bcd8739ae039 = $5c36e1713a058c5f$var$formatDistance;

});

parcelRegister("8EyHP", function(module, exports) {
$parcel$export(module.exports, "default", () => $64ccfb026de961c5$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $64ccfb026de961c5$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $64ccfb026de961c5$var$timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $64ccfb026de961c5$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $64ccfb026de961c5$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $64ccfb026de961c5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $64ccfb026de961c5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $64ccfb026de961c5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $64ccfb026de961c5$export$2e2bcd8739ae039 = $64ccfb026de961c5$var$formatLong;

});

parcelRegister("3asiM", function(module, exports) {
$parcel$export(module.exports, "default", () => $24e842732b0bc136$export$2e2bcd8739ae039);
var $24e842732b0bc136$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var $24e842732b0bc136$var$formatRelative = function formatRelative(token) {
    return $24e842732b0bc136$var$formatRelativeLocale[token];
};
var $24e842732b0bc136$export$2e2bcd8739ae039 = $24e842732b0bc136$var$formatRelative;

});

parcelRegister("7TX2q", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c0b77383c66788c$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $5c0b77383c66788c$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $5c0b77383c66788c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $5c0b77383c66788c$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $5c0b77383c66788c$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $5c0b77383c66788c$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $5c0b77383c66788c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $5c0b77383c66788c$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $5c0b77383c66788c$var$localize = {
    ordinalNumber: $5c0b77383c66788c$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5c0b77383c66788c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5c0b77383c66788c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5c0b77383c66788c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5c0b77383c66788c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5c0b77383c66788c$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5c0b77383c66788c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5c0b77383c66788c$export$2e2bcd8739ae039 = $5c0b77383c66788c$var$localize;

});

parcelRegister("3seHX", function(module, exports) {
$parcel$export(module.exports, "default", () => $283f6557717e4d82$export$2e2bcd8739ae039);

var $59jA4 = parcelRequire("59jA4");

var $ckS9b = parcelRequire("ckS9b");
var $283f6557717e4d82$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $283f6557717e4d82$var$parseOrdinalNumberPattern = /\d+/i;
var $283f6557717e4d82$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $283f6557717e4d82$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $283f6557717e4d82$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $283f6557717e4d82$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $283f6557717e4d82$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $283f6557717e4d82$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $283f6557717e4d82$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $283f6557717e4d82$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $283f6557717e4d82$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var $283f6557717e4d82$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var $283f6557717e4d82$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $283f6557717e4d82$var$matchOrdinalNumberPattern,
        parsePattern: $283f6557717e4d82$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $283f6557717e4d82$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $283f6557717e4d82$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $283f6557717e4d82$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $283f6557717e4d82$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $283f6557717e4d82$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $283f6557717e4d82$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $283f6557717e4d82$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $283f6557717e4d82$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $283f6557717e4d82$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $283f6557717e4d82$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $283f6557717e4d82$export$2e2bcd8739ae039 = $283f6557717e4d82$var$match;

});


parcelRegister("erTXW", function(module, exports) {
$parcel$export(module.exports, "default", () => $a84effeff5347745$export$2e2bcd8739ae039);

var $1VIot = parcelRequire("1VIot");

var $iJn0x = parcelRequire("iJn0x");

var $jR1Ff = parcelRequire("jR1Ff");

var $7dbKL = parcelRequire("7dbKL");

var $er1Ca = parcelRequire("er1Ca");
/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var $a84effeff5347745$var$locale = {
    code: 'az',
    formatDistance: (0, $1VIot.default),
    formatLong: (0, $iJn0x.default),
    formatRelative: (0, $jR1Ff.default),
    localize: (0, $7dbKL.default),
    match: (0, $er1Ca.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $a84effeff5347745$export$2e2bcd8739ae039 = $a84effeff5347745$var$locale;

});
parcelRegister("1VIot", function(module, exports) {
$parcel$export(module.exports, "default", () => $167d8cffe1c89e50$export$2e2bcd8739ae039);
var $167d8cffe1c89e50$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var $167d8cffe1c89e50$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $167d8cffe1c89e50$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
var $167d8cffe1c89e50$export$2e2bcd8739ae039 = $167d8cffe1c89e50$var$formatDistance;

});

parcelRegister("iJn0x", function(module, exports) {
$parcel$export(module.exports, "default", () => $da2e46ce3d61b3e9$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $da2e46ce3d61b3e9$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var $da2e46ce3d61b3e9$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $da2e46ce3d61b3e9$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $da2e46ce3d61b3e9$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $da2e46ce3d61b3e9$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $da2e46ce3d61b3e9$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $da2e46ce3d61b3e9$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $da2e46ce3d61b3e9$export$2e2bcd8739ae039 = $da2e46ce3d61b3e9$var$formatLong;

});

parcelRegister("jR1Ff", function(module, exports) {
$parcel$export(module.exports, "default", () => $e744420f197c0eb3$export$2e2bcd8739ae039);
var $e744420f197c0eb3$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var $e744420f197c0eb3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e744420f197c0eb3$var$formatRelativeLocale[token];
};
var $e744420f197c0eb3$export$2e2bcd8739ae039 = $e744420f197c0eb3$var$formatRelative;

});

parcelRegister("7dbKL", function(module, exports) {
$parcel$export(module.exports, "default", () => $5402dd42efb1ab71$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $5402dd42efb1ab71$var$eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var $5402dd42efb1ab71$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var $5402dd42efb1ab71$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $5402dd42efb1ab71$var$dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var $5402dd42efb1ab71$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $5402dd42efb1ab71$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $5402dd42efb1ab71$var$suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var $5402dd42efb1ab71$var$getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if ($5402dd42efb1ab71$var$suffixes[a]) return $5402dd42efb1ab71$var$suffixes[a];
    else if ($5402dd42efb1ab71$var$suffixes[b]) return $5402dd42efb1ab71$var$suffixes[b];
    else if (c !== null) return $5402dd42efb1ab71$var$suffixes[c];
    return '';
};
var $5402dd42efb1ab71$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = $5402dd42efb1ab71$var$getSuffix(number);
    return number + suffix;
};
var $5402dd42efb1ab71$var$localize = {
    ordinalNumber: $5402dd42efb1ab71$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5402dd42efb1ab71$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5402dd42efb1ab71$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5402dd42efb1ab71$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5402dd42efb1ab71$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5402dd42efb1ab71$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5402dd42efb1ab71$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5402dd42efb1ab71$export$2e2bcd8739ae039 = $5402dd42efb1ab71$var$localize;

});

parcelRegister("er1Ca", function(module, exports) {
$parcel$export(module.exports, "default", () => $a824d6ecc84fa54d$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $a824d6ecc84fa54d$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var $a824d6ecc84fa54d$var$parseOrdinalNumberPattern = /\d+/i;
var $a824d6ecc84fa54d$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var $a824d6ecc84fa54d$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var $a824d6ecc84fa54d$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var $a824d6ecc84fa54d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $a824d6ecc84fa54d$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var $a824d6ecc84fa54d$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var $a824d6ecc84fa54d$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var $a824d6ecc84fa54d$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var $a824d6ecc84fa54d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var $a824d6ecc84fa54d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var $a824d6ecc84fa54d$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $a824d6ecc84fa54d$var$matchOrdinalNumberPattern,
        parsePattern: $a824d6ecc84fa54d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $a824d6ecc84fa54d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a824d6ecc84fa54d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $a824d6ecc84fa54d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a824d6ecc84fa54d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $a824d6ecc84fa54d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a824d6ecc84fa54d$var$parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $a824d6ecc84fa54d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $a824d6ecc84fa54d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $a824d6ecc84fa54d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $a824d6ecc84fa54d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $a824d6ecc84fa54d$export$2e2bcd8739ae039 = $a824d6ecc84fa54d$var$match;

});


parcelRegister("5ZVu7", function(module, exports) {
$parcel$export(module.exports, "default", () => $45df3d8d3097a3b9$export$2e2bcd8739ae039);

var $iqCEG = parcelRequire("iqCEG");

var $h6a3q = parcelRequire("h6a3q");

var $el5gq = parcelRequire("el5gq");

var $3QNpw = parcelRequire("3QNpw");

var $2MJmr = parcelRequire("2MJmr");
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var $45df3d8d3097a3b9$var$locale = {
    code: 'be',
    formatDistance: (0, $iqCEG.default),
    formatLong: (0, $h6a3q.default),
    formatRelative: (0, $el5gq.default),
    localize: (0, $3QNpw.default),
    match: (0, $2MJmr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $45df3d8d3097a3b9$export$2e2bcd8739ae039 = $45df3d8d3097a3b9$var$locale;

});
parcelRegister("iqCEG", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6a8a3d69efbf552$export$2e2bcd8739ae039);
function $d6a8a3d69efbf552$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $d6a8a3d69efbf552$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $d6a8a3d69efbf552$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $d6a8a3d69efbf552$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $d6a8a3d69efbf552$var$declension(scheme.past, count);
                else return $d6a8a3d69efbf552$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $d6a8a3d69efbf552$var$declension(scheme.regular, count);
    };
}
var $d6a8a3d69efbf552$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $d6a8a3d69efbf552$var$formatDistanceLocale = {
    lessThanXSeconds: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $d6a8a3d69efbf552$var$halfAMinute,
    lessThanXMinutes: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $d6a8a3d69efbf552$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $d6a8a3d69efbf552$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $d6a8a3d69efbf552$var$formatDistanceLocale[token](count, options);
};
var $d6a8a3d69efbf552$export$2e2bcd8739ae039 = $d6a8a3d69efbf552$var$formatDistance;

});

parcelRegister("h6a3q", function(module, exports) {
$parcel$export(module.exports, "default", () => $c72acbcae6b31cf2$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $c72acbcae6b31cf2$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $c72acbcae6b31cf2$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $c72acbcae6b31cf2$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $c72acbcae6b31cf2$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $c72acbcae6b31cf2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $c72acbcae6b31cf2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $c72acbcae6b31cf2$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $c72acbcae6b31cf2$export$2e2bcd8739ae039 = $c72acbcae6b31cf2$var$formatLong;

});

parcelRegister("el5gq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7071c2a09a74cec$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $kKrt2 = parcelRequire("kKrt2");
var $a7071c2a09a74cec$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $a7071c2a09a74cec$var$lastWeek(day) {
    var weekday = $a7071c2a09a74cec$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $a7071c2a09a74cec$var$thisWeek(day) {
    var weekday = $a7071c2a09a74cec$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $a7071c2a09a74cec$var$nextWeek(day) {
    var weekday = $a7071c2a09a74cec$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $a7071c2a09a74cec$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $a7071c2a09a74cec$var$thisWeek(day);
    else return $a7071c2a09a74cec$var$lastWeek(day);
};
var $a7071c2a09a74cec$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $a7071c2a09a74cec$var$thisWeek(day);
    else return $a7071c2a09a74cec$var$nextWeek(day);
};
var $a7071c2a09a74cec$var$formatRelativeLocale = {
    lastWeek: $a7071c2a09a74cec$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $a7071c2a09a74cec$var$nextWeekFormat,
    other: 'P'
};
var $a7071c2a09a74cec$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $a7071c2a09a74cec$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $a7071c2a09a74cec$export$2e2bcd8739ae039 = $a7071c2a09a74cec$var$formatRelative;

});

parcelRegister("3QNpw", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cdc8e567a9dd657$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $2cdc8e567a9dd657$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $2cdc8e567a9dd657$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $2cdc8e567a9dd657$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $2cdc8e567a9dd657$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $2cdc8e567a9dd657$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $2cdc8e567a9dd657$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $2cdc8e567a9dd657$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $2cdc8e567a9dd657$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $2cdc8e567a9dd657$var$localize = {
    ordinalNumber: $2cdc8e567a9dd657$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $2cdc8e567a9dd657$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $2cdc8e567a9dd657$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $2cdc8e567a9dd657$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $2cdc8e567a9dd657$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $2cdc8e567a9dd657$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $2cdc8e567a9dd657$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $2cdc8e567a9dd657$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $2cdc8e567a9dd657$export$2e2bcd8739ae039 = $2cdc8e567a9dd657$var$localize;

});

parcelRegister("2MJmr", function(module, exports) {
$parcel$export(module.exports, "default", () => $2073403788404ccb$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $2073403788404ccb$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $2073403788404ccb$var$parseOrdinalNumberPattern = /\d+/i;
var $2073403788404ccb$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $2073403788404ccb$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $2073403788404ccb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $2073403788404ccb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2073403788404ccb$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var $2073403788404ccb$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $2073403788404ccb$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $2073403788404ccb$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $2073403788404ccb$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $2073403788404ccb$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $2073403788404ccb$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $2073403788404ccb$var$matchOrdinalNumberPattern,
        parsePattern: $2073403788404ccb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $2073403788404ccb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2073403788404ccb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $2073403788404ccb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2073403788404ccb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $2073403788404ccb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2073403788404ccb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $2073403788404ccb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2073403788404ccb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $2073403788404ccb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2073403788404ccb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2073403788404ccb$export$2e2bcd8739ae039 = $2073403788404ccb$var$match;

});


parcelRegister("hxDC9", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc543f504f73af82$export$2e2bcd8739ae039);

var $kwPef = parcelRequire("kwPef");

var $eYzyR = parcelRequire("eYzyR");

var $1LCya = parcelRequire("1LCya");

var $lbBuT = parcelRequire("lbBuT");

var $lre4L = parcelRequire("lre4L");
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var $cc543f504f73af82$var$locale = {
    code: 'be-tarask',
    formatDistance: (0, $kwPef.default),
    formatLong: (0, $eYzyR.default),
    formatRelative: (0, $1LCya.default),
    localize: (0, $lbBuT.default),
    match: (0, $lre4L.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $cc543f504f73af82$export$2e2bcd8739ae039 = $cc543f504f73af82$var$locale;

});
parcelRegister("kwPef", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef1e88c118a8fa9d$export$2e2bcd8739ae039);
function $ef1e88c118a8fa9d$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $ef1e88c118a8fa9d$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $ef1e88c118a8fa9d$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $ef1e88c118a8fa9d$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $ef1e88c118a8fa9d$var$declension(scheme.past, count);
                else return $ef1e88c118a8fa9d$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $ef1e88c118a8fa9d$var$declension(scheme.regular, count);
    };
}
var $ef1e88c118a8fa9d$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $ef1e88c118a8fa9d$var$formatDistanceLocale = {
    lessThanXSeconds: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $ef1e88c118a8fa9d$var$halfAMinute,
    lessThanXMinutes: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $ef1e88c118a8fa9d$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $ef1e88c118a8fa9d$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $ef1e88c118a8fa9d$var$formatDistanceLocale[token](count, options);
};
var $ef1e88c118a8fa9d$export$2e2bcd8739ae039 = $ef1e88c118a8fa9d$var$formatDistance;

});

parcelRegister("eYzyR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae7240ff92f5ea32$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $ae7240ff92f5ea32$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $ae7240ff92f5ea32$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $ae7240ff92f5ea32$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $ae7240ff92f5ea32$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $ae7240ff92f5ea32$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $ae7240ff92f5ea32$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $ae7240ff92f5ea32$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $ae7240ff92f5ea32$export$2e2bcd8739ae039 = $ae7240ff92f5ea32$var$formatLong;

});

parcelRegister("1LCya", function(module, exports) {
$parcel$export(module.exports, "default", () => $1498157ade513461$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $kKrt2 = parcelRequire("kKrt2");
var $1498157ade513461$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $1498157ade513461$var$lastWeek(day) {
    var weekday = $1498157ade513461$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $1498157ade513461$var$thisWeek(day) {
    var weekday = $1498157ade513461$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $1498157ade513461$var$nextWeek(day) {
    var weekday = $1498157ade513461$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $1498157ade513461$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $1498157ade513461$var$thisWeek(day);
    else return $1498157ade513461$var$lastWeek(day);
};
var $1498157ade513461$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $1498157ade513461$var$thisWeek(day);
    else return $1498157ade513461$var$nextWeek(day);
};
var $1498157ade513461$var$formatRelativeLocale = {
    lastWeek: $1498157ade513461$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $1498157ade513461$var$nextWeekFormat,
    other: 'P'
};
var $1498157ade513461$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $1498157ade513461$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $1498157ade513461$export$2e2bcd8739ae039 = $1498157ade513461$var$formatRelative;

});

parcelRegister("lbBuT", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6c7b6394e595ae9$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $f6c7b6394e595ae9$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $f6c7b6394e595ae9$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $f6c7b6394e595ae9$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $f6c7b6394e595ae9$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $f6c7b6394e595ae9$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $f6c7b6394e595ae9$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $f6c7b6394e595ae9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $f6c7b6394e595ae9$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $f6c7b6394e595ae9$var$localize = {
    ordinalNumber: $f6c7b6394e595ae9$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $f6c7b6394e595ae9$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $f6c7b6394e595ae9$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $f6c7b6394e595ae9$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $f6c7b6394e595ae9$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $f6c7b6394e595ae9$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $f6c7b6394e595ae9$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $f6c7b6394e595ae9$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f6c7b6394e595ae9$export$2e2bcd8739ae039 = $f6c7b6394e595ae9$var$localize;

});

parcelRegister("lre4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9b709beca8be64d$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $f9b709beca8be64d$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $f9b709beca8be64d$var$parseOrdinalNumberPattern = /\d+/i;
var $f9b709beca8be64d$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $f9b709beca8be64d$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $f9b709beca8be64d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $f9b709beca8be64d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f9b709beca8be64d$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var $f9b709beca8be64d$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $f9b709beca8be64d$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $f9b709beca8be64d$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $f9b709beca8be64d$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $f9b709beca8be64d$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $f9b709beca8be64d$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $f9b709beca8be64d$var$matchOrdinalNumberPattern,
        parsePattern: $f9b709beca8be64d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $f9b709beca8be64d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9b709beca8be64d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $f9b709beca8be64d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9b709beca8be64d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $f9b709beca8be64d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9b709beca8be64d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $f9b709beca8be64d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9b709beca8be64d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $f9b709beca8be64d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f9b709beca8be64d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f9b709beca8be64d$export$2e2bcd8739ae039 = $f9b709beca8be64d$var$match;

});


parcelRegister("ghgUV", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd9b5b4a76145f88$export$2e2bcd8739ae039);

var $6zMw5 = parcelRequire("6zMw5");

var $iWPXR = parcelRequire("iWPXR");

var $gl3iP = parcelRequire("gl3iP");

var $cp5hj = parcelRequire("cp5hj");

var $8c2qA = parcelRequire("8c2qA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var $bd9b5b4a76145f88$var$locale = {
    code: 'bg',
    formatDistance: (0, $6zMw5.default),
    formatLong: (0, $iWPXR.default),
    formatRelative: (0, $gl3iP.default),
    localize: (0, $cp5hj.default),
    match: (0, $8c2qA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $bd9b5b4a76145f88$export$2e2bcd8739ae039 = $bd9b5b4a76145f88$var$locale;

});
parcelRegister("6zMw5", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c9ba55547b5d664$export$2e2bcd8739ae039);
var $4c9ba55547b5d664$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $4c9ba55547b5d664$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4c9ba55547b5d664$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
var $4c9ba55547b5d664$export$2e2bcd8739ae039 = $4c9ba55547b5d664$var$formatDistance;

});

parcelRegister("iWPXR", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcb5f3d522aae90f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $dcb5f3d522aae90f$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $dcb5f3d522aae90f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $dcb5f3d522aae90f$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $dcb5f3d522aae90f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $dcb5f3d522aae90f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $dcb5f3d522aae90f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $dcb5f3d522aae90f$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $dcb5f3d522aae90f$export$2e2bcd8739ae039 = $dcb5f3d522aae90f$var$formatLong;

});

parcelRegister("gl3iP", function(module, exports) {
$parcel$export(module.exports, "default", () => $be512b6041aec264$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $kKrt2 = parcelRequire("kKrt2");
// Adapted from the `ru` translation
var $be512b6041aec264$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $be512b6041aec264$var$lastWeek(day) {
    var weekday = $be512b6041aec264$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $be512b6041aec264$var$thisWeek(day) {
    var weekday = $be512b6041aec264$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $be512b6041aec264$var$nextWeek(day) {
    var weekday = $be512b6041aec264$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var $be512b6041aec264$var$lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $be512b6041aec264$var$thisWeek(day);
    else return $be512b6041aec264$var$lastWeek(day);
};
var $be512b6041aec264$var$nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $be512b6041aec264$var$thisWeek(day);
    else return $be512b6041aec264$var$nextWeek(day);
};
var $be512b6041aec264$var$formatRelativeLocale = {
    lastWeek: $be512b6041aec264$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $be512b6041aec264$var$nextWeekFormatToken,
    other: 'P'
};
var $be512b6041aec264$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $be512b6041aec264$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $be512b6041aec264$export$2e2bcd8739ae039 = $be512b6041aec264$var$formatRelative;

});

parcelRegister("cp5hj", function(module, exports) {
$parcel$export(module.exports, "default", () => $907be9f7fa47c941$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $907be9f7fa47c941$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $907be9f7fa47c941$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var $907be9f7fa47c941$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $907be9f7fa47c941$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var $907be9f7fa47c941$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $907be9f7fa47c941$var$isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function $907be9f7fa47c941$var$isNeuter(unit) {
    return unit === 'quarter';
}
function $907be9f7fa47c941$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = $907be9f7fa47c941$var$isNeuter(unit) ? neuter : $907be9f7fa47c941$var$isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var $907be9f7fa47c941$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return $907be9f7fa47c941$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $907be9f7fa47c941$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $907be9f7fa47c941$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $907be9f7fa47c941$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $907be9f7fa47c941$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $907be9f7fa47c941$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $907be9f7fa47c941$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var $907be9f7fa47c941$var$localize = {
    ordinalNumber: $907be9f7fa47c941$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $907be9f7fa47c941$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $907be9f7fa47c941$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $907be9f7fa47c941$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $907be9f7fa47c941$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $907be9f7fa47c941$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $907be9f7fa47c941$export$2e2bcd8739ae039 = $907be9f7fa47c941$var$localize;

});

parcelRegister("8c2qA", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f7153d8ec52aebe$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $5f7153d8ec52aebe$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var $5f7153d8ec52aebe$var$parseOrdinalNumberPattern = /\d+/i;
var $5f7153d8ec52aebe$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var $5f7153d8ec52aebe$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $5f7153d8ec52aebe$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var $5f7153d8ec52aebe$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5f7153d8ec52aebe$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var $5f7153d8ec52aebe$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var $5f7153d8ec52aebe$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var $5f7153d8ec52aebe$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $5f7153d8ec52aebe$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var $5f7153d8ec52aebe$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var $5f7153d8ec52aebe$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $5f7153d8ec52aebe$var$matchOrdinalNumberPattern,
        parsePattern: $5f7153d8ec52aebe$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $5f7153d8ec52aebe$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f7153d8ec52aebe$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $5f7153d8ec52aebe$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f7153d8ec52aebe$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $5f7153d8ec52aebe$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f7153d8ec52aebe$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $5f7153d8ec52aebe$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5f7153d8ec52aebe$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $5f7153d8ec52aebe$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5f7153d8ec52aebe$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5f7153d8ec52aebe$export$2e2bcd8739ae039 = $5f7153d8ec52aebe$var$match;

});


parcelRegister("hASGv", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccf037ac40a00440$export$2e2bcd8739ae039);

var $loh82 = parcelRequire("loh82");

var $8apq6 = parcelRequire("8apq6");

var $04f4H = parcelRequire("04f4H");

var $j9moL = parcelRequire("j9moL");

var $ijBSw = parcelRequire("ijBSw");
/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var $ccf037ac40a00440$var$locale = {
    code: 'bn',
    formatDistance: (0, $loh82.default),
    formatLong: (0, $8apq6.default),
    formatRelative: (0, $04f4H.default),
    localize: (0, $j9moL.default),
    match: (0, $ijBSw.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $ccf037ac40a00440$export$2e2bcd8739ae039 = $ccf037ac40a00440$var$locale;

});
parcelRegister("loh82", function(module, exports) {
$parcel$export(module.exports, "default", () => $f9292041c3628085$export$2e2bcd8739ae039);

var $j9moL = parcelRequire("j9moL");
var $f9292041c3628085$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var $f9292041c3628085$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f9292041c3628085$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $j9moL.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
var $f9292041c3628085$export$2e2bcd8739ae039 = $f9292041c3628085$var$formatDistance;

});
parcelRegister("j9moL", function(module, exports) {
$parcel$export(module.exports, "numberToLocale", () => $df103b74eac9e5a6$export$3e1d599946644f03);
$parcel$export(module.exports, "default", () => $df103b74eac9e5a6$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $df103b74eac9e5a6$var$numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var $df103b74eac9e5a6$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var $df103b74eac9e5a6$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var $df103b74eac9e5a6$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var $df103b74eac9e5a6$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var $df103b74eac9e5a6$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var $df103b74eac9e5a6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $df103b74eac9e5a6$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var $df103b74eac9e5a6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = $df103b74eac9e5a6$export$3e1d599946644f03(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return $df103b74eac9e5a6$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function $df103b74eac9e5a6$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $df103b74eac9e5a6$var$numberValues.locale[match];
    });
}
var $df103b74eac9e5a6$var$localize = {
    ordinalNumber: $df103b74eac9e5a6$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $df103b74eac9e5a6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $df103b74eac9e5a6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $df103b74eac9e5a6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $df103b74eac9e5a6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $df103b74eac9e5a6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $df103b74eac9e5a6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $df103b74eac9e5a6$export$2e2bcd8739ae039 = $df103b74eac9e5a6$var$localize;

});


parcelRegister("8apq6", function(module, exports) {
$parcel$export(module.exports, "default", () => $5f22f9cb94d91b57$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $5f22f9cb94d91b57$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $5f22f9cb94d91b57$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $5f22f9cb94d91b57$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $5f22f9cb94d91b57$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $5f22f9cb94d91b57$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $5f22f9cb94d91b57$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $5f22f9cb94d91b57$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5f22f9cb94d91b57$export$2e2bcd8739ae039 = $5f22f9cb94d91b57$var$formatLong;

});

parcelRegister("04f4H", function(module, exports) {
$parcel$export(module.exports, "default", () => $00cc1160e70f9d85$export$2e2bcd8739ae039);
var $00cc1160e70f9d85$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var $00cc1160e70f9d85$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $00cc1160e70f9d85$var$formatRelativeLocale[token];
};
var $00cc1160e70f9d85$export$2e2bcd8739ae039 = $00cc1160e70f9d85$var$formatRelative;

});

parcelRegister("ijBSw", function(module, exports) {
$parcel$export(module.exports, "default", () => $d557622f9355c347$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $d557622f9355c347$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var $d557622f9355c347$var$parseOrdinalNumberPattern = /\d+/i;
var $d557622f9355c347$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var $d557622f9355c347$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var $d557622f9355c347$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var $d557622f9355c347$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var $d557622f9355c347$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var $d557622f9355c347$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var $d557622f9355c347$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var $d557622f9355c347$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var $d557622f9355c347$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var $d557622f9355c347$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var $d557622f9355c347$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $d557622f9355c347$var$matchOrdinalNumberPattern,
        parsePattern: $d557622f9355c347$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $d557622f9355c347$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d557622f9355c347$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $d557622f9355c347$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d557622f9355c347$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $d557622f9355c347$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d557622f9355c347$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $d557622f9355c347$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d557622f9355c347$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $d557622f9355c347$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d557622f9355c347$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d557622f9355c347$export$2e2bcd8739ae039 = $d557622f9355c347$var$match;

});


parcelRegister("17pme", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d0a1d5b1b84e047$export$2e2bcd8739ae039);

var $axQgY = parcelRequire("axQgY");

var $iM0cG = parcelRequire("iM0cG");

var $j6kDq = parcelRequire("j6kDq");

var $99dcU = parcelRequire("99dcU");

var $c4Yjh = parcelRequire("c4Yjh");
/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var $0d0a1d5b1b84e047$var$locale = {
    code: 'bs',
    formatDistance: (0, $axQgY.default),
    formatLong: (0, $iM0cG.default),
    formatRelative: (0, $j6kDq.default),
    localize: (0, $99dcU.default),
    match: (0, $c4Yjh.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0d0a1d5b1b84e047$export$2e2bcd8739ae039 = $0d0a1d5b1b84e047$var$locale;

});
parcelRegister("axQgY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ad588be8ad11122$export$2e2bcd8739ae039);
var $7ad588be8ad11122$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $7ad588be8ad11122$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7ad588be8ad11122$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $7ad588be8ad11122$export$2e2bcd8739ae039 = $7ad588be8ad11122$var$formatDistance;

});

parcelRegister("iM0cG", function(module, exports) {
$parcel$export(module.exports, "default", () => $daacde20c9daf56f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $daacde20c9daf56f$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $daacde20c9daf56f$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $daacde20c9daf56f$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $daacde20c9daf56f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $daacde20c9daf56f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $daacde20c9daf56f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $daacde20c9daf56f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $daacde20c9daf56f$export$2e2bcd8739ae039 = $daacde20c9daf56f$var$formatLong;

});

parcelRegister("j6kDq", function(module, exports) {
$parcel$export(module.exports, "default", () => $de7e95861432f563$export$2e2bcd8739ae039);
var $de7e95861432f563$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $de7e95861432f563$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $de7e95861432f563$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $de7e95861432f563$export$2e2bcd8739ae039 = $de7e95861432f563$var$formatRelative;

});

parcelRegister("99dcU", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a8f32fce63d5318$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $6a8f32fce63d5318$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var $6a8f32fce63d5318$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $6a8f32fce63d5318$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $6a8f32fce63d5318$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $6a8f32fce63d5318$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $6a8f32fce63d5318$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $6a8f32fce63d5318$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $6a8f32fce63d5318$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var $6a8f32fce63d5318$var$localize = {
    ordinalNumber: $6a8f32fce63d5318$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $6a8f32fce63d5318$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $6a8f32fce63d5318$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $6a8f32fce63d5318$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $6a8f32fce63d5318$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $6a8f32fce63d5318$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $6a8f32fce63d5318$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6a8f32fce63d5318$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6a8f32fce63d5318$export$2e2bcd8739ae039 = $6a8f32fce63d5318$var$localize;

});

parcelRegister("c4Yjh", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb4a4124cbfeae9$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $8cb4a4124cbfeae9$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $8cb4a4124cbfeae9$var$parseOrdinalNumberPattern = /\d+/i;
var $8cb4a4124cbfeae9$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var $8cb4a4124cbfeae9$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $8cb4a4124cbfeae9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $8cb4a4124cbfeae9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8cb4a4124cbfeae9$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $8cb4a4124cbfeae9$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $8cb4a4124cbfeae9$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $8cb4a4124cbfeae9$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $8cb4a4124cbfeae9$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var $8cb4a4124cbfeae9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $8cb4a4124cbfeae9$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $8cb4a4124cbfeae9$var$matchOrdinalNumberPattern,
        parsePattern: $8cb4a4124cbfeae9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $8cb4a4124cbfeae9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8cb4a4124cbfeae9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $8cb4a4124cbfeae9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8cb4a4124cbfeae9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $8cb4a4124cbfeae9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8cb4a4124cbfeae9$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $8cb4a4124cbfeae9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8cb4a4124cbfeae9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $8cb4a4124cbfeae9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8cb4a4124cbfeae9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8cb4a4124cbfeae9$export$2e2bcd8739ae039 = $8cb4a4124cbfeae9$var$match;

});


parcelRegister("eEhbM", function(module, exports) {
$parcel$export(module.exports, "default", () => $aaa2227f4ff5e00c$export$2e2bcd8739ae039);

var $cEVLQ = parcelRequire("cEVLQ");

var $gTXvy = parcelRequire("gTXvy");

var $iZLsj = parcelRequire("iZLsj");

var $6qdfw = parcelRequire("6qdfw");

var $jTlBA = parcelRequire("jTlBA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var $aaa2227f4ff5e00c$var$locale = {
    code: 'ca',
    formatDistance: (0, $cEVLQ.default),
    formatLong: (0, $gTXvy.default),
    formatRelative: (0, $iZLsj.default),
    localize: (0, $6qdfw.default),
    match: (0, $jTlBA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $aaa2227f4ff5e00c$export$2e2bcd8739ae039 // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
 = $aaa2227f4ff5e00c$var$locale;

});
parcelRegister("cEVLQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9376088219f831a3$export$2e2bcd8739ae039);
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var $9376088219f831a3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var $9376088219f831a3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9376088219f831a3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
var $9376088219f831a3$export$2e2bcd8739ae039 = $9376088219f831a3$var$formatDistance;

});

parcelRegister("gTXvy", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4dff1704bb0a4ef$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $c4dff1704bb0a4ef$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $c4dff1704bb0a4ef$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c4dff1704bb0a4ef$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c4dff1704bb0a4ef$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $c4dff1704bb0a4ef$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $c4dff1704bb0a4ef$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $c4dff1704bb0a4ef$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c4dff1704bb0a4ef$export$2e2bcd8739ae039 = $c4dff1704bb0a4ef$var$formatLong;

});

parcelRegister("iZLsj", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd42bc2e8fbaa538$export$2e2bcd8739ae039);
var $dd42bc2e8fbaa538$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $dd42bc2e8fbaa538$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var $dd42bc2e8fbaa538$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $dd42bc2e8fbaa538$var$formatRelativeLocalePlural[token];
    return $dd42bc2e8fbaa538$var$formatRelativeLocale[token];
};
var $dd42bc2e8fbaa538$export$2e2bcd8739ae039 = $dd42bc2e8fbaa538$var$formatRelative;

});

parcelRegister("6qdfw", function(module, exports) {
$parcel$export(module.exports, "default", () => $4acf72d66f3e2811$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $4acf72d66f3e2811$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var $4acf72d66f3e2811$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $4acf72d66f3e2811$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var $4acf72d66f3e2811$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var $4acf72d66f3e2811$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var $4acf72d66f3e2811$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var $4acf72d66f3e2811$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var $4acf72d66f3e2811$var$localize = {
    ordinalNumber: $4acf72d66f3e2811$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $4acf72d66f3e2811$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $4acf72d66f3e2811$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $4acf72d66f3e2811$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $4acf72d66f3e2811$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $4acf72d66f3e2811$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4acf72d66f3e2811$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4acf72d66f3e2811$export$2e2bcd8739ae039 = $4acf72d66f3e2811$var$localize;

});

parcelRegister("jTlBA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7b3e9ba820c19f3$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $e7b3e9ba820c19f3$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var $e7b3e9ba820c19f3$var$parseOrdinalNumberPattern = /\d+/i;
var $e7b3e9ba820c19f3$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var $e7b3e9ba820c19f3$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var $e7b3e9ba820c19f3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var $e7b3e9ba820c19f3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e7b3e9ba820c19f3$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var $e7b3e9ba820c19f3$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var $e7b3e9ba820c19f3$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var $e7b3e9ba820c19f3$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var $e7b3e9ba820c19f3$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var $e7b3e9ba820c19f3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var $e7b3e9ba820c19f3$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $e7b3e9ba820c19f3$var$matchOrdinalNumberPattern,
        parsePattern: $e7b3e9ba820c19f3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $e7b3e9ba820c19f3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e7b3e9ba820c19f3$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $e7b3e9ba820c19f3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e7b3e9ba820c19f3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $e7b3e9ba820c19f3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e7b3e9ba820c19f3$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $e7b3e9ba820c19f3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e7b3e9ba820c19f3$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $e7b3e9ba820c19f3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e7b3e9ba820c19f3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e7b3e9ba820c19f3$export$2e2bcd8739ae039 = $e7b3e9ba820c19f3$var$match;

});


parcelRegister("3UDQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d9582efe7469982$export$2e2bcd8739ae039);

var $6BP5f = parcelRequire("6BP5f");

var $5M6oF = parcelRequire("5M6oF");

var $bFX7A = parcelRequire("bFX7A");

var $c3959 = parcelRequire("c3959");

var $fxpBU = parcelRequire("fxpBU");
/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var $2d9582efe7469982$var$locale = {
    code: 'cy',
    formatDistance: (0, $6BP5f.default),
    formatLong: (0, $5M6oF.default),
    formatRelative: (0, $bFX7A.default),
    localize: (0, $c3959.default),
    match: (0, $fxpBU.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2d9582efe7469982$export$2e2bcd8739ae039 = $2d9582efe7469982$var$locale;

});
parcelRegister("6BP5f", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cfdd2f12a3c270d$export$2e2bcd8739ae039);
var $4cfdd2f12a3c270d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var $4cfdd2f12a3c270d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4cfdd2f12a3c270d$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
var $4cfdd2f12a3c270d$export$2e2bcd8739ae039 = $4cfdd2f12a3c270d$var$formatDistance;

});

parcelRegister("5M6oF", function(module, exports) {
$parcel$export(module.exports, "default", () => $434665b708e34347$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $434665b708e34347$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $434665b708e34347$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $434665b708e34347$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $434665b708e34347$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $434665b708e34347$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $434665b708e34347$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $434665b708e34347$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $434665b708e34347$export$2e2bcd8739ae039 = $434665b708e34347$var$formatLong;

});

parcelRegister("bFX7A", function(module, exports) {
$parcel$export(module.exports, "default", () => $88016256a57bc5b7$export$2e2bcd8739ae039);
var $88016256a57bc5b7$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var $88016256a57bc5b7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $88016256a57bc5b7$var$formatRelativeLocale[token];
};
var $88016256a57bc5b7$export$2e2bcd8739ae039 = $88016256a57bc5b7$var$formatRelative;

});

parcelRegister("c3959", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c5ccf61cdd50a6a$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $8c5ccf61cdd50a6a$var$eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var $8c5ccf61cdd50a6a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $8c5ccf61cdd50a6a$var$monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var $8c5ccf61cdd50a6a$var$dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var $8c5ccf61cdd50a6a$var$dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var $8c5ccf61cdd50a6a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var $8c5ccf61cdd50a6a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var $8c5ccf61cdd50a6a$var$localize = {
    ordinalNumber: $8c5ccf61cdd50a6a$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $8c5ccf61cdd50a6a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $8c5ccf61cdd50a6a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $8c5ccf61cdd50a6a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $8c5ccf61cdd50a6a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $8c5ccf61cdd50a6a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8c5ccf61cdd50a6a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8c5ccf61cdd50a6a$export$2e2bcd8739ae039 = $8c5ccf61cdd50a6a$var$localize;

});

parcelRegister("fxpBU", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4fdcdc6aee64aa0$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $b4fdcdc6aee64aa0$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var $b4fdcdc6aee64aa0$var$parseOrdinalNumberPattern = /\d+/i;
var $b4fdcdc6aee64aa0$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var $b4fdcdc6aee64aa0$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var $b4fdcdc6aee64aa0$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var $b4fdcdc6aee64aa0$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b4fdcdc6aee64aa0$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var $b4fdcdc6aee64aa0$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var $b4fdcdc6aee64aa0$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var $b4fdcdc6aee64aa0$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var $b4fdcdc6aee64aa0$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var $b4fdcdc6aee64aa0$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var $b4fdcdc6aee64aa0$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $b4fdcdc6aee64aa0$var$matchOrdinalNumberPattern,
        parsePattern: $b4fdcdc6aee64aa0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $b4fdcdc6aee64aa0$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b4fdcdc6aee64aa0$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $b4fdcdc6aee64aa0$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b4fdcdc6aee64aa0$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $b4fdcdc6aee64aa0$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b4fdcdc6aee64aa0$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $b4fdcdc6aee64aa0$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b4fdcdc6aee64aa0$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $b4fdcdc6aee64aa0$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b4fdcdc6aee64aa0$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b4fdcdc6aee64aa0$export$2e2bcd8739ae039 = $b4fdcdc6aee64aa0$var$match;

});


parcelRegister("aSqUy", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eb3d2837198d662$export$2e2bcd8739ae039);

var $3uagM = parcelRequire("3uagM");

var $2IZ7k = parcelRequire("2IZ7k");

var $aZDvg = parcelRequire("aZDvg");

var $7DpYM = parcelRequire("7DpYM");

var $7WVcz = parcelRequire("7WVcz");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var $7eb3d2837198d662$var$locale = {
    code: 'de-AT',
    formatDistance: (0, $3uagM.default),
    formatLong: (0, $2IZ7k.default),
    formatRelative: (0, $aZDvg.default),
    localize: (0, $7WVcz.default),
    match: (0, $7DpYM.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7eb3d2837198d662$export$2e2bcd8739ae039 = $7eb3d2837198d662$var$locale;

});
parcelRegister("7WVcz", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c9a523c4e73be91$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $5c9a523c4e73be91$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $5c9a523c4e73be91$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $5c9a523c4e73be91$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var $5c9a523c4e73be91$var$formattingMonthValues = {
    narrow: $5c9a523c4e73be91$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $5c9a523c4e73be91$var$monthValues.wide
};
var $5c9a523c4e73be91$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $5c9a523c4e73be91$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $5c9a523c4e73be91$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $5c9a523c4e73be91$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $5c9a523c4e73be91$var$localize = {
    ordinalNumber: $5c9a523c4e73be91$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5c9a523c4e73be91$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5c9a523c4e73be91$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5c9a523c4e73be91$var$monthValues,
        formattingValues: $5c9a523c4e73be91$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5c9a523c4e73be91$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5c9a523c4e73be91$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5c9a523c4e73be91$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5c9a523c4e73be91$export$2e2bcd8739ae039 = $5c9a523c4e73be91$var$localize;

});


parcelRegister("fz78E", function(module, exports) {
$parcel$export(module.exports, "default", () => $b54fa972368a1a6f$export$2e2bcd8739ae039);

var $b1FmP = parcelRequire("b1FmP");

var $iI1ej = parcelRequire("iI1ej");

var $k3Bhd = parcelRequire("k3Bhd");

var $geIDZ = parcelRequire("geIDZ");

var $7tznr = parcelRequire("7tznr");
/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var $b54fa972368a1a6f$var$locale = {
    code: 'el',
    formatDistance: (0, $b1FmP.default),
    formatLong: (0, $iI1ej.default),
    formatRelative: (0, $k3Bhd.default),
    localize: (0, $geIDZ.default),
    match: (0, $7tznr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b54fa972368a1a6f$export$2e2bcd8739ae039 = $b54fa972368a1a6f$var$locale;

});
parcelRegister("b1FmP", function(module, exports) {
$parcel$export(module.exports, "default", () => $806fe063d2b67073$export$2e2bcd8739ae039);
var $806fe063d2b67073$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var $806fe063d2b67073$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $806fe063d2b67073$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
var $806fe063d2b67073$export$2e2bcd8739ae039 = $806fe063d2b67073$var$formatDistance;

});

parcelRegister("iI1ej", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9ed4a47e5a815eb$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $d9ed4a47e5a815eb$var$dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var $d9ed4a47e5a815eb$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $d9ed4a47e5a815eb$var$dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $d9ed4a47e5a815eb$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $d9ed4a47e5a815eb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $d9ed4a47e5a815eb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $d9ed4a47e5a815eb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d9ed4a47e5a815eb$export$2e2bcd8739ae039 = $d9ed4a47e5a815eb$var$formatLong;

});

parcelRegister("k3Bhd", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9a100d61d5697bf$export$2e2bcd8739ae039);
var $e9a100d61d5697bf$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var $e9a100d61d5697bf$var$formatRelative = function formatRelative(token, date) {
    var format = $e9a100d61d5697bf$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $e9a100d61d5697bf$export$2e2bcd8739ae039 = $e9a100d61d5697bf$var$formatRelative;

});

parcelRegister("geIDZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd20957fe54954c8$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $bd20957fe54954c8$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var $bd20957fe54954c8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var $bd20957fe54954c8$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var $bd20957fe54954c8$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var $bd20957fe54954c8$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var $bd20957fe54954c8$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var $bd20957fe54954c8$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var $bd20957fe54954c8$var$localize = {
    ordinalNumber: $bd20957fe54954c8$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $bd20957fe54954c8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $bd20957fe54954c8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $bd20957fe54954c8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $bd20957fe54954c8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $bd20957fe54954c8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $bd20957fe54954c8$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $bd20957fe54954c8$export$2e2bcd8739ae039 = $bd20957fe54954c8$var$localize;

});

parcelRegister("7tznr", function(module, exports) {
$parcel$export(module.exports, "default", () => $5716aefe349afa85$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $5716aefe349afa85$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var $5716aefe349afa85$var$parseOrdinalNumberPattern = /\d+/i;
var $5716aefe349afa85$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var $5716aefe349afa85$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var $5716aefe349afa85$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var $5716aefe349afa85$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5716aefe349afa85$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var $5716aefe349afa85$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var $5716aefe349afa85$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var $5716aefe349afa85$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var $5716aefe349afa85$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var $5716aefe349afa85$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var $5716aefe349afa85$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $5716aefe349afa85$var$matchOrdinalNumberPattern,
        parsePattern: $5716aefe349afa85$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $5716aefe349afa85$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5716aefe349afa85$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $5716aefe349afa85$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5716aefe349afa85$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $5716aefe349afa85$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5716aefe349afa85$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $5716aefe349afa85$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5716aefe349afa85$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $5716aefe349afa85$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5716aefe349afa85$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5716aefe349afa85$export$2e2bcd8739ae039 = $5716aefe349afa85$var$match;

});


parcelRegister("1UQEO", function(module, exports) {
$parcel$export(module.exports, "default", () => $1653de06113b893c$export$2e2bcd8739ae039);

var $g3RCZ = parcelRequire("g3RCZ");

var $hvmYR = parcelRequire("hvmYR");

var $aMpgq = parcelRequire("aMpgq");

var $1pFcj = parcelRequire("1pFcj");

var $kQa2E = parcelRequire("kQa2E");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var $1653de06113b893c$var$locale = {
    code: 'en-CA',
    formatDistance: (0, $1pFcj.default),
    formatLong: (0, $kQa2E.default),
    formatRelative: (0, $g3RCZ.default),
    localize: (0, $hvmYR.default),
    match: (0, $aMpgq.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $1653de06113b893c$export$2e2bcd8739ae039 = $1653de06113b893c$var$locale;

});
parcelRegister("1pFcj", function(module, exports) {
$parcel$export(module.exports, "default", () => $10781539e4052582$export$2e2bcd8739ae039);
var $10781539e4052582$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var $10781539e4052582$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $10781539e4052582$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $10781539e4052582$export$2e2bcd8739ae039 = $10781539e4052582$var$formatDistance;

});

parcelRegister("kQa2E", function(module, exports) {
$parcel$export(module.exports, "default", () => $f2c07415ae44cbc7$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $f2c07415ae44cbc7$var$dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var $f2c07415ae44cbc7$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f2c07415ae44cbc7$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f2c07415ae44cbc7$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $f2c07415ae44cbc7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $f2c07415ae44cbc7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $f2c07415ae44cbc7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f2c07415ae44cbc7$export$2e2bcd8739ae039 = $f2c07415ae44cbc7$var$formatLong;

});


parcelRegister("j628G", function(module, exports) {
$parcel$export(module.exports, "default", () => $de703ca0b59ac743$export$2e2bcd8739ae039);

var $95tmY = parcelRequire("95tmY");

var $g3RCZ = parcelRequire("g3RCZ");

var $hvmYR = parcelRequire("hvmYR");

var $aMpgq = parcelRequire("aMpgq");

var $dw1O0 = parcelRequire("dw1O0");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var $de703ca0b59ac743$var$locale = {
    code: 'en-IE',
    formatDistance: (0, $95tmY.default),
    formatLong: (0, $dw1O0.default),
    formatRelative: (0, $g3RCZ.default),
    localize: (0, $hvmYR.default),
    match: (0, $aMpgq.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $de703ca0b59ac743$export$2e2bcd8739ae039 = $de703ca0b59ac743$var$locale;

});

parcelRegister("99uil", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a9c744110738be4$export$2e2bcd8739ae039);

var $95tmY = parcelRequire("95tmY");

var $g3RCZ = parcelRequire("g3RCZ");

var $hvmYR = parcelRequire("hvmYR");

var $aMpgq = parcelRequire("aMpgq");

var $dLR5j = parcelRequire("dLR5j");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var $6a9c744110738be4$var$locale = {
    code: 'en-IN',
    formatDistance: (0, $95tmY.default),
    formatLong: (0, $dLR5j.default),
    formatRelative: (0, $g3RCZ.default),
    localize: (0, $hvmYR.default),
    match: (0, $aMpgq.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
var $6a9c744110738be4$export$2e2bcd8739ae039 = $6a9c744110738be4$var$locale;

});
parcelRegister("dLR5j", function(module, exports) {
$parcel$export(module.exports, "default", () => $a068d7ad86e7c242$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $a068d7ad86e7c242$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var $a068d7ad86e7c242$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $a068d7ad86e7c242$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a068d7ad86e7c242$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $a068d7ad86e7c242$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $a068d7ad86e7c242$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $a068d7ad86e7c242$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a068d7ad86e7c242$export$2e2bcd8739ae039 = $a068d7ad86e7c242$var$formatLong;

});


parcelRegister("9TFY4", function(module, exports) {
$parcel$export(module.exports, "default", () => $7349ce0a3317f8fd$export$2e2bcd8739ae039);

var $95tmY = parcelRequire("95tmY");

var $g3RCZ = parcelRequire("g3RCZ");

var $hvmYR = parcelRequire("hvmYR");

var $aMpgq = parcelRequire("aMpgq");

var $Rs6r6 = parcelRequire("Rs6r6");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var $7349ce0a3317f8fd$var$locale = {
    code: 'en-NZ',
    formatDistance: (0, $95tmY.default),
    formatLong: (0, $Rs6r6.default),
    formatRelative: (0, $g3RCZ.default),
    localize: (0, $hvmYR.default),
    match: (0, $aMpgq.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7349ce0a3317f8fd$export$2e2bcd8739ae039 = $7349ce0a3317f8fd$var$locale;

});
parcelRegister("Rs6r6", function(module, exports) {
$parcel$export(module.exports, "default", () => $0a0abffbefc4ad57$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $0a0abffbefc4ad57$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $0a0abffbefc4ad57$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $0a0abffbefc4ad57$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $0a0abffbefc4ad57$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $0a0abffbefc4ad57$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $0a0abffbefc4ad57$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $0a0abffbefc4ad57$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $0a0abffbefc4ad57$export$2e2bcd8739ae039 = $0a0abffbefc4ad57$var$formatLong;

});


parcelRegister("j75ov", function(module, exports) {
$parcel$export(module.exports, "default", () => $dea2daf356e38875$export$2e2bcd8739ae039);

var $95tmY = parcelRequire("95tmY");

var $g3RCZ = parcelRequire("g3RCZ");

var $hvmYR = parcelRequire("hvmYR");

var $aMpgq = parcelRequire("aMpgq");

var $emgu5 = parcelRequire("emgu5");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var $dea2daf356e38875$var$locale = {
    code: 'en-ZA',
    formatDistance: (0, $95tmY.default),
    formatLong: (0, $emgu5.default),
    formatRelative: (0, $g3RCZ.default),
    localize: (0, $hvmYR.default),
    match: (0, $aMpgq.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
var $dea2daf356e38875$export$2e2bcd8739ae039 = $dea2daf356e38875$var$locale;

});
parcelRegister("emgu5", function(module, exports) {
$parcel$export(module.exports, "default", () => $a73fe8367b26b053$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $a73fe8367b26b053$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var $a73fe8367b26b053$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $a73fe8367b26b053$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a73fe8367b26b053$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $a73fe8367b26b053$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $a73fe8367b26b053$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $a73fe8367b26b053$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a73fe8367b26b053$export$2e2bcd8739ae039 = $a73fe8367b26b053$var$formatLong;

});


parcelRegister("6UJtN", function(module, exports) {
$parcel$export(module.exports, "default", () => $508b4054ebfc1b47$export$2e2bcd8739ae039);

var $l6egD = parcelRequire("l6egD");

var $8z2E2 = parcelRequire("8z2E2");

var $gDJbR = parcelRequire("gDJbR");

var $b857Q = parcelRequire("b857Q");

var $5NzsJ = parcelRequire("5NzsJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var $508b4054ebfc1b47$var$locale = {
    code: 'eo',
    formatDistance: (0, $l6egD.default),
    formatLong: (0, $8z2E2.default),
    formatRelative: (0, $gDJbR.default),
    localize: (0, $b857Q.default),
    match: (0, $5NzsJ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $508b4054ebfc1b47$export$2e2bcd8739ae039 = $508b4054ebfc1b47$var$locale;

});
parcelRegister("l6egD", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5c539b2df6e15b5$export$2e2bcd8739ae039);
var $f5c539b2df6e15b5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var $f5c539b2df6e15b5$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f5c539b2df6e15b5$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
var $f5c539b2df6e15b5$export$2e2bcd8739ae039 = $f5c539b2df6e15b5$var$formatDistance;

});

parcelRegister("8z2E2", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c3a4d109cc0f49$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $63c3a4d109cc0f49$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var $63c3a4d109cc0f49$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $63c3a4d109cc0f49$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $63c3a4d109cc0f49$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $63c3a4d109cc0f49$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $63c3a4d109cc0f49$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $63c3a4d109cc0f49$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $63c3a4d109cc0f49$export$2e2bcd8739ae039 = $63c3a4d109cc0f49$var$formatLong;

});

parcelRegister("gDJbR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1d357b6d1f18b18$export$2e2bcd8739ae039);
var $c1d357b6d1f18b18$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var $c1d357b6d1f18b18$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c1d357b6d1f18b18$var$formatRelativeLocale[token];
};
var $c1d357b6d1f18b18$export$2e2bcd8739ae039 = $c1d357b6d1f18b18$var$formatRelative;

});

parcelRegister("b857Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $81a46ae6a2388f7c$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $81a46ae6a2388f7c$var$eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var $81a46ae6a2388f7c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var $81a46ae6a2388f7c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var $81a46ae6a2388f7c$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var $81a46ae6a2388f7c$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var $81a46ae6a2388f7c$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var $81a46ae6a2388f7c$var$localize = {
    ordinalNumber: $81a46ae6a2388f7c$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $81a46ae6a2388f7c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $81a46ae6a2388f7c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $81a46ae6a2388f7c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $81a46ae6a2388f7c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $81a46ae6a2388f7c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $81a46ae6a2388f7c$export$2e2bcd8739ae039 = $81a46ae6a2388f7c$var$localize;

});

parcelRegister("5NzsJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $438d09768eb69d84$export$2e2bcd8739ae039);

var $59jA4 = parcelRequire("59jA4");

var $ckS9b = parcelRequire("ckS9b");
var $438d09768eb69d84$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var $438d09768eb69d84$var$parseOrdinalNumberPattern = /\d+/i;
var $438d09768eb69d84$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var $438d09768eb69d84$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var $438d09768eb69d84$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var $438d09768eb69d84$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $438d09768eb69d84$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var $438d09768eb69d84$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $438d09768eb69d84$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var $438d09768eb69d84$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var $438d09768eb69d84$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var $438d09768eb69d84$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $438d09768eb69d84$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $438d09768eb69d84$var$matchOrdinalNumberPattern,
        parsePattern: $438d09768eb69d84$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $438d09768eb69d84$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $438d09768eb69d84$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $438d09768eb69d84$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $438d09768eb69d84$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $438d09768eb69d84$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $438d09768eb69d84$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $438d09768eb69d84$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $438d09768eb69d84$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $438d09768eb69d84$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $438d09768eb69d84$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $438d09768eb69d84$export$2e2bcd8739ae039 = $438d09768eb69d84$var$match;

});


parcelRegister("6ZYNO", function(module, exports) {
$parcel$export(module.exports, "default", () => $51879ab26c3c5caf$export$2e2bcd8739ae039);

var $7bPTj = parcelRequire("7bPTj");

var $6Mb5w = parcelRequire("6Mb5w");

var $2i2kY = parcelRequire("2i2kY");

var $5XMnH = parcelRequire("5XMnH");

var $bOXwV = parcelRequire("bOXwV");
/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var $51879ab26c3c5caf$var$locale = {
    code: 'eu',
    formatDistance: (0, $7bPTj.default),
    formatLong: (0, $6Mb5w.default),
    formatRelative: (0, $2i2kY.default),
    localize: (0, $5XMnH.default),
    match: (0, $bOXwV.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $51879ab26c3c5caf$export$2e2bcd8739ae039 = $51879ab26c3c5caf$var$locale;

});
parcelRegister("7bPTj", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c1cff51c9cb062$export$2e2bcd8739ae039);
var $53c1cff51c9cb062$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var $53c1cff51c9cb062$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $53c1cff51c9cb062$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
var $53c1cff51c9cb062$export$2e2bcd8739ae039 = $53c1cff51c9cb062$var$formatDistance;

});

parcelRegister("6Mb5w", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eefd39e8261facf$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $4eefd39e8261facf$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var $4eefd39e8261facf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4eefd39e8261facf$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $4eefd39e8261facf$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $4eefd39e8261facf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $4eefd39e8261facf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $4eefd39e8261facf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4eefd39e8261facf$export$2e2bcd8739ae039 = $4eefd39e8261facf$var$formatLong;

});

parcelRegister("2i2kY", function(module, exports) {
$parcel$export(module.exports, "default", () => $1aaf135e8c03b424$export$2e2bcd8739ae039);
var $1aaf135e8c03b424$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $1aaf135e8c03b424$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var $1aaf135e8c03b424$var$formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return $1aaf135e8c03b424$var$formatRelativeLocalePlural[token];
    return $1aaf135e8c03b424$var$formatRelativeLocale[token];
};
var $1aaf135e8c03b424$export$2e2bcd8739ae039 = $1aaf135e8c03b424$var$formatRelative;

});

parcelRegister("5XMnH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4577fdebf58ca1b4$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $4577fdebf58ca1b4$var$eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var $4577fdebf58ca1b4$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var $4577fdebf58ca1b4$var$monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var $4577fdebf58ca1b4$var$dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var $4577fdebf58ca1b4$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var $4577fdebf58ca1b4$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var $4577fdebf58ca1b4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $4577fdebf58ca1b4$var$localize = {
    ordinalNumber: $4577fdebf58ca1b4$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $4577fdebf58ca1b4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $4577fdebf58ca1b4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $4577fdebf58ca1b4$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $4577fdebf58ca1b4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $4577fdebf58ca1b4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $4577fdebf58ca1b4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $4577fdebf58ca1b4$export$2e2bcd8739ae039 = $4577fdebf58ca1b4$var$localize;

});

parcelRegister("bOXwV", function(module, exports) {
$parcel$export(module.exports, "default", () => $89b28aa7f40478fa$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $89b28aa7f40478fa$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var $89b28aa7f40478fa$var$parseOrdinalNumberPattern = /\d+/i;
var $89b28aa7f40478fa$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var $89b28aa7f40478fa$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var $89b28aa7f40478fa$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var $89b28aa7f40478fa$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $89b28aa7f40478fa$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var $89b28aa7f40478fa$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var $89b28aa7f40478fa$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var $89b28aa7f40478fa$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var $89b28aa7f40478fa$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var $89b28aa7f40478fa$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var $89b28aa7f40478fa$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $89b28aa7f40478fa$var$matchOrdinalNumberPattern,
        parsePattern: $89b28aa7f40478fa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $89b28aa7f40478fa$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89b28aa7f40478fa$var$parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $89b28aa7f40478fa$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89b28aa7f40478fa$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $89b28aa7f40478fa$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89b28aa7f40478fa$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $89b28aa7f40478fa$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $89b28aa7f40478fa$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $89b28aa7f40478fa$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $89b28aa7f40478fa$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $89b28aa7f40478fa$export$2e2bcd8739ae039 = $89b28aa7f40478fa$var$match;

});


parcelRegister("8GUaw", function(module, exports) {
$parcel$export(module.exports, "default", () => $653dd0eb7d8d4d5b$export$2e2bcd8739ae039);

var $ff3it = parcelRequire("ff3it");

var $9x8Nw = parcelRequire("9x8Nw");

var $3Ll6S = parcelRequire("3Ll6S");

var $7JXS4 = parcelRequire("7JXS4");

var $6cCqZ = parcelRequire("6cCqZ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var $653dd0eb7d8d4d5b$var$locale = {
    code: 'fa-IR',
    formatDistance: (0, $ff3it.default),
    formatLong: (0, $9x8Nw.default),
    formatRelative: (0, $3Ll6S.default),
    localize: (0, $7JXS4.default),
    match: (0, $6cCqZ.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $653dd0eb7d8d4d5b$export$2e2bcd8739ae039 = $653dd0eb7d8d4d5b$var$locale;

});
parcelRegister("ff3it", function(module, exports) {
$parcel$export(module.exports, "default", () => $b18ad071294305e6$export$2e2bcd8739ae039);
var $b18ad071294305e6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var $b18ad071294305e6$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b18ad071294305e6$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
var $b18ad071294305e6$export$2e2bcd8739ae039 = $b18ad071294305e6$var$formatDistance;

});

parcelRegister("9x8Nw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f0e0525e85f2be7$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $6f0e0525e85f2be7$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var $6f0e0525e85f2be7$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $6f0e0525e85f2be7$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $6f0e0525e85f2be7$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $6f0e0525e85f2be7$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $6f0e0525e85f2be7$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $6f0e0525e85f2be7$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6f0e0525e85f2be7$export$2e2bcd8739ae039 = $6f0e0525e85f2be7$var$formatLong;

});

parcelRegister("3Ll6S", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bd622dacb675eae$export$2e2bcd8739ae039);
var $2bd622dacb675eae$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var $2bd622dacb675eae$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2bd622dacb675eae$var$formatRelativeLocale[token];
};
var $2bd622dacb675eae$export$2e2bcd8739ae039 = $2bd622dacb675eae$var$formatRelative;

});

parcelRegister("7JXS4", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a2b2d87b31ad0ba$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $5a2b2d87b31ad0ba$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var $5a2b2d87b31ad0ba$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $5a2b2d87b31ad0ba$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var $5a2b2d87b31ad0ba$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var $5a2b2d87b31ad0ba$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $5a2b2d87b31ad0ba$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $5a2b2d87b31ad0ba$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $5a2b2d87b31ad0ba$var$localize = {
    ordinalNumber: $5a2b2d87b31ad0ba$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5a2b2d87b31ad0ba$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5a2b2d87b31ad0ba$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5a2b2d87b31ad0ba$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5a2b2d87b31ad0ba$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5a2b2d87b31ad0ba$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5a2b2d87b31ad0ba$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5a2b2d87b31ad0ba$export$2e2bcd8739ae039 = $5a2b2d87b31ad0ba$var$localize;

});

parcelRegister("6cCqZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $4841ad4c70a3f6af$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $4841ad4c70a3f6af$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $4841ad4c70a3f6af$var$parseOrdinalNumberPattern = /\d+/i;
var $4841ad4c70a3f6af$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var $4841ad4c70a3f6af$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $4841ad4c70a3f6af$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var $4841ad4c70a3f6af$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4841ad4c70a3f6af$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var $4841ad4c70a3f6af$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var $4841ad4c70a3f6af$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var $4841ad4c70a3f6af$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var $4841ad4c70a3f6af$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var $4841ad4c70a3f6af$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var $4841ad4c70a3f6af$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $4841ad4c70a3f6af$var$matchOrdinalNumberPattern,
        parsePattern: $4841ad4c70a3f6af$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $4841ad4c70a3f6af$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4841ad4c70a3f6af$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $4841ad4c70a3f6af$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4841ad4c70a3f6af$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $4841ad4c70a3f6af$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4841ad4c70a3f6af$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $4841ad4c70a3f6af$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4841ad4c70a3f6af$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $4841ad4c70a3f6af$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4841ad4c70a3f6af$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4841ad4c70a3f6af$export$2e2bcd8739ae039 = $4841ad4c70a3f6af$var$match;

});


parcelRegister("3DNgk", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a6b3a194ebf6786$export$2e2bcd8739ae039);
// Same as fr

var $ffefM = parcelRequire("ffefM");

var $gFMCk = parcelRequire("gFMCk");

var $eAopk = parcelRequire("eAopk");

var $kxywE = parcelRequire("kxywE");

var $c76DZ = parcelRequire("c76DZ");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var $2a6b3a194ebf6786$var$locale = {
    code: 'fr-CA',
    formatDistance: (0, $ffefM.default),
    formatLong: (0, $c76DZ.default),
    formatRelative: (0, $gFMCk.default),
    localize: (0, $eAopk.default),
    match: (0, $kxywE.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2a6b3a194ebf6786$export$2e2bcd8739ae039 = $2a6b3a194ebf6786$var$locale;

});
parcelRegister("c76DZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d1b4ad795cb0f0f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $8d1b4ad795cb0f0f$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var $8d1b4ad795cb0f0f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $8d1b4ad795cb0f0f$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $8d1b4ad795cb0f0f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $8d1b4ad795cb0f0f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $8d1b4ad795cb0f0f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $8d1b4ad795cb0f0f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $8d1b4ad795cb0f0f$export$2e2bcd8739ae039 = $8d1b4ad795cb0f0f$var$formatLong;

});


parcelRegister("QREsG", function(module, exports) {
$parcel$export(module.exports, "default", () => $09ee7988e316e944$export$2e2bcd8739ae039);
// Same as fr

var $ffefM = parcelRequire("ffefM");

var $eAopk = parcelRequire("eAopk");

var $kxywE = parcelRequire("kxywE");

var $gCdEr = parcelRequire("gCdEr");

var $gflpF = parcelRequire("gflpF");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $09ee7988e316e944$var$locale = {
    code: 'fr-CH',
    formatDistance: (0, $ffefM.default),
    formatLong: (0, $gCdEr.default),
    formatRelative: (0, $gflpF.default),
    localize: (0, $eAopk.default),
    match: (0, $kxywE.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $09ee7988e316e944$export$2e2bcd8739ae039 = $09ee7988e316e944$var$locale;

});
parcelRegister("gCdEr", function(module, exports) {
$parcel$export(module.exports, "default", () => $c18ac8ce9ebaee3f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $c18ac8ce9ebaee3f$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $c18ac8ce9ebaee3f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $c18ac8ce9ebaee3f$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c18ac8ce9ebaee3f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $c18ac8ce9ebaee3f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $c18ac8ce9ebaee3f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $c18ac8ce9ebaee3f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c18ac8ce9ebaee3f$export$2e2bcd8739ae039 = $c18ac8ce9ebaee3f$var$formatLong;

});

parcelRegister("gflpF", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd3ea83e36f14ec6$export$2e2bcd8739ae039);
var $bd3ea83e36f14ec6$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var $bd3ea83e36f14ec6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bd3ea83e36f14ec6$var$formatRelativeLocale[token];
};
var $bd3ea83e36f14ec6$export$2e2bcd8739ae039 = $bd3ea83e36f14ec6$var$formatRelative;

});


parcelRegister("czCAW", function(module, exports) {
$parcel$export(module.exports, "default", () => $9276b10ca5cc9262$export$2e2bcd8739ae039);

var $g7iQk = parcelRequire("g7iQk");

var $3A9pB = parcelRequire("3A9pB");

var $l0hH8 = parcelRequire("l0hH8");

var $M89F6 = parcelRequire("M89F6");

var $luPfD = parcelRequire("luPfD");
/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var $9276b10ca5cc9262$var$locale = {
    code: 'fy',
    formatDistance: (0, $g7iQk.default),
    formatLong: (0, $3A9pB.default),
    formatRelative: (0, $l0hH8.default),
    localize: (0, $M89F6.default),
    match: (0, $luPfD.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9276b10ca5cc9262$export$2e2bcd8739ae039 = $9276b10ca5cc9262$var$locale;

});
parcelRegister("g7iQk", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbbbea9de9e14bab$export$2e2bcd8739ae039);
var $bbbbea9de9e14bab$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var $bbbbea9de9e14bab$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bbbbea9de9e14bab$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
var $bbbbea9de9e14bab$export$2e2bcd8739ae039 = $bbbbea9de9e14bab$var$formatDistance;

});

parcelRegister("3A9pB", function(module, exports) {
$parcel$export(module.exports, "default", () => $29bc08ebb17434e3$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $29bc08ebb17434e3$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $29bc08ebb17434e3$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $29bc08ebb17434e3$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $29bc08ebb17434e3$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $29bc08ebb17434e3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $29bc08ebb17434e3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $29bc08ebb17434e3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $29bc08ebb17434e3$export$2e2bcd8739ae039 = $29bc08ebb17434e3$var$formatLong;

});

parcelRegister("l0hH8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f4a752e211ea3e86$export$2e2bcd8739ae039);
var $f4a752e211ea3e86$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $f4a752e211ea3e86$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f4a752e211ea3e86$var$formatRelativeLocale[token];
};
var $f4a752e211ea3e86$export$2e2bcd8739ae039 = $f4a752e211ea3e86$var$formatRelative;

});

parcelRegister("M89F6", function(module, exports) {
$parcel$export(module.exports, "default", () => $090acf30bc047dee$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $090acf30bc047dee$var$eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var $090acf30bc047dee$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var $090acf30bc047dee$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var $090acf30bc047dee$var$dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var $090acf30bc047dee$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var $090acf30bc047dee$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $090acf30bc047dee$var$localize = {
    ordinalNumber: $090acf30bc047dee$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $090acf30bc047dee$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $090acf30bc047dee$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $090acf30bc047dee$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $090acf30bc047dee$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $090acf30bc047dee$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $090acf30bc047dee$export$2e2bcd8739ae039 = $090acf30bc047dee$var$localize;

});

parcelRegister("luPfD", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa6427bffc57f787$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $fa6427bffc57f787$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $fa6427bffc57f787$var$parseOrdinalNumberPattern = /\d+/i;
var $fa6427bffc57f787$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var $fa6427bffc57f787$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var $fa6427bffc57f787$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var $fa6427bffc57f787$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fa6427bffc57f787$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var $fa6427bffc57f787$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var $fa6427bffc57f787$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var $fa6427bffc57f787$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var $fa6427bffc57f787$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var $fa6427bffc57f787$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var $fa6427bffc57f787$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $fa6427bffc57f787$var$matchOrdinalNumberPattern,
        parsePattern: $fa6427bffc57f787$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $fa6427bffc57f787$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa6427bffc57f787$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $fa6427bffc57f787$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa6427bffc57f787$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $fa6427bffc57f787$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa6427bffc57f787$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $fa6427bffc57f787$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fa6427bffc57f787$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $fa6427bffc57f787$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $fa6427bffc57f787$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fa6427bffc57f787$export$2e2bcd8739ae039 = $fa6427bffc57f787$var$match;

});


parcelRegister("dLpe9", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0533bc20c8b61b0$export$2e2bcd8739ae039);

var $djBKP = parcelRequire("djBKP");

var $b97jt = parcelRequire("b97jt");

var $lMjw8 = parcelRequire("lMjw8");

var $etyI1 = parcelRequire("etyI1");

var $2ODzt = parcelRequire("2ODzt");
/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var $a0533bc20c8b61b0$var$locale = {
    code: 'gd',
    formatDistance: (0, $djBKP.default),
    formatLong: (0, $b97jt.default),
    formatRelative: (0, $lMjw8.default),
    localize: (0, $etyI1.default),
    match: (0, $2ODzt.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $a0533bc20c8b61b0$export$2e2bcd8739ae039 = $a0533bc20c8b61b0$var$locale;

});
parcelRegister("djBKP", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1a55f1c27b3dac$export$2e2bcd8739ae039);
var $9b1a55f1c27b3dac$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var $9b1a55f1c27b3dac$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9b1a55f1c27b3dac$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
var $9b1a55f1c27b3dac$export$2e2bcd8739ae039 = $9b1a55f1c27b3dac$var$formatDistance;

});

parcelRegister("b97jt", function(module, exports) {
$parcel$export(module.exports, "default", () => $81d6352efe6f0b91$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $81d6352efe6f0b91$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $81d6352efe6f0b91$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $81d6352efe6f0b91$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $81d6352efe6f0b91$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $81d6352efe6f0b91$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $81d6352efe6f0b91$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $81d6352efe6f0b91$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $81d6352efe6f0b91$export$2e2bcd8739ae039 = $81d6352efe6f0b91$var$formatLong;

});

parcelRegister("lMjw8", function(module, exports) {
$parcel$export(module.exports, "default", () => $fdad3861c6ab0c4e$export$2e2bcd8739ae039);
var $fdad3861c6ab0c4e$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var $fdad3861c6ab0c4e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $fdad3861c6ab0c4e$var$formatRelativeLocale[token];
};
var $fdad3861c6ab0c4e$export$2e2bcd8739ae039 = $fdad3861c6ab0c4e$var$formatRelative;

});

parcelRegister("etyI1", function(module, exports) {
$parcel$export(module.exports, "default", () => $a89eb297e77d8e97$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $a89eb297e77d8e97$var$eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var $a89eb297e77d8e97$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $a89eb297e77d8e97$var$monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var $a89eb297e77d8e97$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var $a89eb297e77d8e97$var$dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var $a89eb297e77d8e97$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var $a89eb297e77d8e97$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var $a89eb297e77d8e97$var$localize = {
    ordinalNumber: $a89eb297e77d8e97$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $a89eb297e77d8e97$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $a89eb297e77d8e97$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $a89eb297e77d8e97$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $a89eb297e77d8e97$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $a89eb297e77d8e97$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a89eb297e77d8e97$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a89eb297e77d8e97$export$2e2bcd8739ae039 = $a89eb297e77d8e97$var$localize;

});

parcelRegister("2ODzt", function(module, exports) {
$parcel$export(module.exports, "default", () => $20cef244fbdd69ed$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $20cef244fbdd69ed$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var $20cef244fbdd69ed$var$parseOrdinalNumberPattern = /\d+/i;
var $20cef244fbdd69ed$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var $20cef244fbdd69ed$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $20cef244fbdd69ed$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var $20cef244fbdd69ed$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $20cef244fbdd69ed$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var $20cef244fbdd69ed$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var $20cef244fbdd69ed$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var $20cef244fbdd69ed$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var $20cef244fbdd69ed$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var $20cef244fbdd69ed$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var $20cef244fbdd69ed$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $20cef244fbdd69ed$var$matchOrdinalNumberPattern,
        parsePattern: $20cef244fbdd69ed$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $20cef244fbdd69ed$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $20cef244fbdd69ed$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $20cef244fbdd69ed$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $20cef244fbdd69ed$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $20cef244fbdd69ed$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $20cef244fbdd69ed$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $20cef244fbdd69ed$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $20cef244fbdd69ed$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $20cef244fbdd69ed$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $20cef244fbdd69ed$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $20cef244fbdd69ed$export$2e2bcd8739ae039 = $20cef244fbdd69ed$var$match;

});


parcelRegister("jouRp", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1e8326e23551200$export$2e2bcd8739ae039);

var $6wJkY = parcelRequire("6wJkY");

var $jZ6OO = parcelRequire("jZ6OO");

var $bgXn9 = parcelRequire("bgXn9");

var $3nTuE = parcelRequire("3nTuE");

var $btjrw = parcelRequire("btjrw");
/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var $e1e8326e23551200$var$locale = {
    code: 'gl',
    formatDistance: (0, $6wJkY.default),
    formatLong: (0, $jZ6OO.default),
    formatRelative: (0, $bgXn9.default),
    localize: (0, $3nTuE.default),
    match: (0, $btjrw.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $e1e8326e23551200$export$2e2bcd8739ae039 = $e1e8326e23551200$var$locale;

});
parcelRegister("6wJkY", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c08e642679acd6c$export$2e2bcd8739ae039);
var $4c08e642679acd6c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var $4c08e642679acd6c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4c08e642679acd6c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
var $4c08e642679acd6c$export$2e2bcd8739ae039 = $4c08e642679acd6c$var$formatDistance;

});

parcelRegister("jZ6OO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8c900d99b16e3b6$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $e8c900d99b16e3b6$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $e8c900d99b16e3b6$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e8c900d99b16e3b6$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e8c900d99b16e3b6$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $e8c900d99b16e3b6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $e8c900d99b16e3b6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $e8c900d99b16e3b6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e8c900d99b16e3b6$export$2e2bcd8739ae039 = $e8c900d99b16e3b6$var$formatLong;

});

parcelRegister("bgXn9", function(module, exports) {
$parcel$export(module.exports, "default", () => $834f3e70e345b8d6$export$2e2bcd8739ae039);
var $834f3e70e345b8d6$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var $834f3e70e345b8d6$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var $834f3e70e345b8d6$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $834f3e70e345b8d6$var$formatRelativeLocalePlural[token];
    return $834f3e70e345b8d6$var$formatRelativeLocale[token];
};
var $834f3e70e345b8d6$export$2e2bcd8739ae039 = $834f3e70e345b8d6$var$formatRelative;

});

parcelRegister("3nTuE", function(module, exports) {
$parcel$export(module.exports, "default", () => $276e90edc1ad9201$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $276e90edc1ad9201$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var $276e90edc1ad9201$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $276e90edc1ad9201$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var $276e90edc1ad9201$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var $276e90edc1ad9201$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var $276e90edc1ad9201$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var $276e90edc1ad9201$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $276e90edc1ad9201$var$localize = {
    ordinalNumber: $276e90edc1ad9201$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $276e90edc1ad9201$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $276e90edc1ad9201$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $276e90edc1ad9201$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $276e90edc1ad9201$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $276e90edc1ad9201$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $276e90edc1ad9201$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $276e90edc1ad9201$export$2e2bcd8739ae039 = $276e90edc1ad9201$var$localize;

});

parcelRegister("btjrw", function(module, exports) {
$parcel$export(module.exports, "default", () => $85a17c16bf9492be$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $85a17c16bf9492be$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $85a17c16bf9492be$var$parseOrdinalNumberPattern = /\d+/i;
var $85a17c16bf9492be$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var $85a17c16bf9492be$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var $85a17c16bf9492be$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $85a17c16bf9492be$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $85a17c16bf9492be$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var $85a17c16bf9492be$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var $85a17c16bf9492be$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var $85a17c16bf9492be$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var $85a17c16bf9492be$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var $85a17c16bf9492be$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var $85a17c16bf9492be$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $85a17c16bf9492be$var$matchOrdinalNumberPattern,
        parsePattern: $85a17c16bf9492be$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $85a17c16bf9492be$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $85a17c16bf9492be$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $85a17c16bf9492be$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $85a17c16bf9492be$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $85a17c16bf9492be$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $85a17c16bf9492be$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $85a17c16bf9492be$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $85a17c16bf9492be$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $85a17c16bf9492be$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $85a17c16bf9492be$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $85a17c16bf9492be$export$2e2bcd8739ae039 = $85a17c16bf9492be$var$match;

});


parcelRegister("ej0gB", function(module, exports) {
$parcel$export(module.exports, "default", () => $a6a30c054b47f5bb$export$2e2bcd8739ae039);

var $jtMlu = parcelRequire("jtMlu");

var $fKiqm = parcelRequire("fKiqm");

var $1R08O = parcelRequire("1R08O");

var $hoYeH = parcelRequire("hoYeH");

var $iWhCh = parcelRequire("iWhCh");
/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var $a6a30c054b47f5bb$var$locale = {
    code: 'gu',
    formatDistance: (0, $jtMlu.default),
    formatLong: (0, $fKiqm.default),
    formatRelative: (0, $1R08O.default),
    localize: (0, $hoYeH.default),
    match: (0, $iWhCh.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $a6a30c054b47f5bb$export$2e2bcd8739ae039 = $a6a30c054b47f5bb$var$locale;

});
parcelRegister("jtMlu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2e63a35106adc35$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $e2e63a35106adc35$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var $e2e63a35106adc35$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e2e63a35106adc35$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
var $e2e63a35106adc35$export$2e2bcd8739ae039 = $e2e63a35106adc35$var$formatDistance;

});

parcelRegister("fKiqm", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7697187e9929f81$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $b7697187e9929f81$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var $b7697187e9929f81$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var $b7697187e9929f81$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var $b7697187e9929f81$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $b7697187e9929f81$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $b7697187e9929f81$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $b7697187e9929f81$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $b7697187e9929f81$export$2e2bcd8739ae039 = $b7697187e9929f81$var$formatLong;

});

parcelRegister("1R08O", function(module, exports) {
$parcel$export(module.exports, "default", () => $159ad9b0fc770e71$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $159ad9b0fc770e71$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var $159ad9b0fc770e71$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $159ad9b0fc770e71$var$formatRelativeLocale[token];
};
var $159ad9b0fc770e71$export$2e2bcd8739ae039 = $159ad9b0fc770e71$var$formatRelative;

});

parcelRegister("hoYeH", function(module, exports) {
$parcel$export(module.exports, "default", () => $cab3673565a8bdd0$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
// #1621 - #1630
var $cab3673565a8bdd0$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var $cab3673565a8bdd0$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var $cab3673565a8bdd0$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var $cab3673565a8bdd0$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var $cab3673565a8bdd0$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $cab3673565a8bdd0$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $cab3673565a8bdd0$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $cab3673565a8bdd0$var$localize = {
    ordinalNumber: $cab3673565a8bdd0$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $cab3673565a8bdd0$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $cab3673565a8bdd0$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $cab3673565a8bdd0$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $cab3673565a8bdd0$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $cab3673565a8bdd0$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cab3673565a8bdd0$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cab3673565a8bdd0$export$2e2bcd8739ae039 = $cab3673565a8bdd0$var$localize;

});

parcelRegister("iWhCh", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc9b4f0a156aeaa5$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $dc9b4f0a156aeaa5$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var $dc9b4f0a156aeaa5$var$parseOrdinalNumberPattern = /\d+/i;
var $dc9b4f0a156aeaa5$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var $dc9b4f0a156aeaa5$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var $dc9b4f0a156aeaa5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var $dc9b4f0a156aeaa5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $dc9b4f0a156aeaa5$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var $dc9b4f0a156aeaa5$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var $dc9b4f0a156aeaa5$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var $dc9b4f0a156aeaa5$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var $dc9b4f0a156aeaa5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var $dc9b4f0a156aeaa5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var $dc9b4f0a156aeaa5$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $dc9b4f0a156aeaa5$var$matchOrdinalNumberPattern,
        parsePattern: $dc9b4f0a156aeaa5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $dc9b4f0a156aeaa5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc9b4f0a156aeaa5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $dc9b4f0a156aeaa5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc9b4f0a156aeaa5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $dc9b4f0a156aeaa5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc9b4f0a156aeaa5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $dc9b4f0a156aeaa5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dc9b4f0a156aeaa5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $dc9b4f0a156aeaa5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $dc9b4f0a156aeaa5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dc9b4f0a156aeaa5$export$2e2bcd8739ae039 = $dc9b4f0a156aeaa5$var$match;

});


parcelRegister("avOr6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a73ec378766bb97$export$2e2bcd8739ae039);

var $eXYyE = parcelRequire("eXYyE");

var $as8ed = parcelRequire("as8ed");

var $dxGAT = parcelRequire("dxGAT");

var $lex3k = parcelRequire("lex3k");

var $jtW9W = parcelRequire("jtW9W");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var $7a73ec378766bb97$var$locale = {
    code: 'he',
    formatDistance: (0, $eXYyE.default),
    formatLong: (0, $as8ed.default),
    formatRelative: (0, $dxGAT.default),
    localize: (0, $lex3k.default),
    match: (0, $jtW9W.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $7a73ec378766bb97$export$2e2bcd8739ae039 = $7a73ec378766bb97$var$locale;

});
parcelRegister("eXYyE", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae558ce990d968e1$export$2e2bcd8739ae039);
var $ae558ce990d968e1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var $ae558ce990d968e1$var$formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = $ae558ce990d968e1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
var $ae558ce990d968e1$export$2e2bcd8739ae039 = $ae558ce990d968e1$var$formatDistance;

});

parcelRegister("as8ed", function(module, exports) {
$parcel$export(module.exports, "default", () => $79c2e6e154a58c46$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $79c2e6e154a58c46$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var $79c2e6e154a58c46$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $79c2e6e154a58c46$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $79c2e6e154a58c46$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $79c2e6e154a58c46$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $79c2e6e154a58c46$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $79c2e6e154a58c46$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $79c2e6e154a58c46$export$2e2bcd8739ae039 = $79c2e6e154a58c46$var$formatLong;

});

parcelRegister("dxGAT", function(module, exports) {
$parcel$export(module.exports, "default", () => $9dbf65bdf36cd517$export$2e2bcd8739ae039);
var $9dbf65bdf36cd517$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var $9dbf65bdf36cd517$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9dbf65bdf36cd517$var$formatRelativeLocale[token];
};
var $9dbf65bdf36cd517$export$2e2bcd8739ae039 = $9dbf65bdf36cd517$var$formatRelative;

});

parcelRegister("lex3k", function(module, exports) {
$parcel$export(module.exports, "default", () => $f7548b5f58405fb3$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $f7548b5f58405fb3$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var $f7548b5f58405fb3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var $f7548b5f58405fb3$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var $f7548b5f58405fb3$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var $f7548b5f58405fb3$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var $f7548b5f58405fb3$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var $f7548b5f58405fb3$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var $f7548b5f58405fb3$var$localize = {
    ordinalNumber: $f7548b5f58405fb3$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $f7548b5f58405fb3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $f7548b5f58405fb3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $f7548b5f58405fb3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $f7548b5f58405fb3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $f7548b5f58405fb3$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f7548b5f58405fb3$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f7548b5f58405fb3$export$2e2bcd8739ae039 = $f7548b5f58405fb3$var$localize;

});

parcelRegister("jtW9W", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2edd6f8d31a4146$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $e2edd6f8d31a4146$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var $e2edd6f8d31a4146$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var $e2edd6f8d31a4146$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var $e2edd6f8d31a4146$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var $e2edd6f8d31a4146$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var $e2edd6f8d31a4146$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e2edd6f8d31a4146$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var $e2edd6f8d31a4146$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var $e2edd6f8d31a4146$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var $e2edd6f8d31a4146$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var $e2edd6f8d31a4146$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var $e2edd6f8d31a4146$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var $e2edd6f8d31a4146$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var $e2edd6f8d31a4146$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $e2edd6f8d31a4146$var$matchOrdinalNumberPattern,
        parsePattern: $e2edd6f8d31a4146$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? $e2edd6f8d31a4146$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $e2edd6f8d31a4146$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2edd6f8d31a4146$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $e2edd6f8d31a4146$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2edd6f8d31a4146$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $e2edd6f8d31a4146$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2edd6f8d31a4146$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $e2edd6f8d31a4146$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2edd6f8d31a4146$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $e2edd6f8d31a4146$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e2edd6f8d31a4146$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e2edd6f8d31a4146$export$2e2bcd8739ae039 = $e2edd6f8d31a4146$var$match;

});


parcelRegister("gb2D1", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc6fb6595cfe4aff$export$2e2bcd8739ae039);

var $2Ujhq = parcelRequire("2Ujhq");

var $iNCXI = parcelRequire("iNCXI");

var $1Lj8k = parcelRequire("1Lj8k");

var $iVhE1 = parcelRequire("iVhE1");

var $4DVAR = parcelRequire("4DVAR");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var $bc6fb6595cfe4aff$var$locale = {
    code: 'hi',
    formatDistance: (0, $2Ujhq.default),
    formatLong: (0, $iNCXI.default),
    formatRelative: (0, $1Lj8k.default),
    localize: (0, $iVhE1.default),
    match: (0, $4DVAR.default),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $bc6fb6595cfe4aff$export$2e2bcd8739ae039 = $bc6fb6595cfe4aff$var$locale;

});
parcelRegister("2Ujhq", function(module, exports) {
$parcel$export(module.exports, "default", () => $21dfc4583d8f60f7$export$2e2bcd8739ae039);

var $iVhE1 = parcelRequire("iVhE1");
var $21dfc4583d8f60f7$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var $21dfc4583d8f60f7$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $21dfc4583d8f60f7$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, $iVhE1.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
var $21dfc4583d8f60f7$export$2e2bcd8739ae039 = $21dfc4583d8f60f7$var$formatDistance;

});
parcelRegister("iVhE1", function(module, exports) {
$parcel$export(module.exports, "numberToLocale", () => $dc6b3caf386a0de5$export$3e1d599946644f03);
$parcel$export(module.exports, "localeToNumber", () => $dc6b3caf386a0de5$export$b431cabd737c2a);
$parcel$export(module.exports, "default", () => $dc6b3caf386a0de5$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $dc6b3caf386a0de5$var$numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var $dc6b3caf386a0de5$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var $dc6b3caf386a0de5$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var $dc6b3caf386a0de5$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var $dc6b3caf386a0de5$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var $dc6b3caf386a0de5$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $dc6b3caf386a0de5$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $dc6b3caf386a0de5$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return $dc6b3caf386a0de5$export$3e1d599946644f03(number);
};
function $dc6b3caf386a0de5$export$b431cabd737c2a(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $dc6b3caf386a0de5$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $dc6b3caf386a0de5$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $dc6b3caf386a0de5$var$numberValues.locale[match];
    });
}
var $dc6b3caf386a0de5$var$localize = {
    ordinalNumber: $dc6b3caf386a0de5$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $dc6b3caf386a0de5$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $dc6b3caf386a0de5$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $dc6b3caf386a0de5$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $dc6b3caf386a0de5$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $dc6b3caf386a0de5$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $dc6b3caf386a0de5$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $dc6b3caf386a0de5$export$2e2bcd8739ae039 = $dc6b3caf386a0de5$var$localize;

});


parcelRegister("iNCXI", function(module, exports) {
$parcel$export(module.exports, "default", () => $dafb06a74bc60d6a$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $dafb06a74bc60d6a$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var $dafb06a74bc60d6a$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var $dafb06a74bc60d6a$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var $dafb06a74bc60d6a$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $dafb06a74bc60d6a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $dafb06a74bc60d6a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $dafb06a74bc60d6a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $dafb06a74bc60d6a$export$2e2bcd8739ae039 = $dafb06a74bc60d6a$var$formatLong;

});

parcelRegister("1Lj8k", function(module, exports) {
$parcel$export(module.exports, "default", () => $148905b6f4d8aba5$export$2e2bcd8739ae039);
var $148905b6f4d8aba5$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var $148905b6f4d8aba5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $148905b6f4d8aba5$var$formatRelativeLocale[token];
};
var $148905b6f4d8aba5$export$2e2bcd8739ae039 = $148905b6f4d8aba5$var$formatRelative;

});

parcelRegister("4DVAR", function(module, exports) {
$parcel$export(module.exports, "default", () => $36177acb228b5029$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");

var $iVhE1 = parcelRequire("iVhE1");
var $36177acb228b5029$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $36177acb228b5029$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $36177acb228b5029$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var $36177acb228b5029$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $36177acb228b5029$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var $36177acb228b5029$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $36177acb228b5029$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var $36177acb228b5029$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var $36177acb228b5029$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var $36177acb228b5029$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var $36177acb228b5029$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var $36177acb228b5029$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var $36177acb228b5029$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $36177acb228b5029$var$matchOrdinalNumberPattern,
        parsePattern: $36177acb228b5029$var$parseOrdinalNumberPattern,
        valueCallback: (0, $iVhE1.localeToNumber)
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $36177acb228b5029$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36177acb228b5029$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $36177acb228b5029$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36177acb228b5029$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $36177acb228b5029$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36177acb228b5029$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $36177acb228b5029$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $36177acb228b5029$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $36177acb228b5029$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $36177acb228b5029$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $36177acb228b5029$export$2e2bcd8739ae039 = $36177acb228b5029$var$match;

});


parcelRegister("ld1Cx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f70c11b5f320e1e7$export$2e2bcd8739ae039);

var $dUX2j = parcelRequire("dUX2j");

var $gqyqR = parcelRequire("gqyqR");

var $iNMWw = parcelRequire("iNMWw");

var $jnuaZ = parcelRequire("jnuaZ");

var $8XXIX = parcelRequire("8XXIX");
/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var $f70c11b5f320e1e7$var$locale = {
    code: 'hr',
    formatDistance: (0, $dUX2j.default),
    formatLong: (0, $gqyqR.default),
    formatRelative: (0, $iNMWw.default),
    localize: (0, $jnuaZ.default),
    match: (0, $8XXIX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f70c11b5f320e1e7$export$2e2bcd8739ae039 = $f70c11b5f320e1e7$var$locale;

});
parcelRegister("dUX2j", function(module, exports) {
$parcel$export(module.exports, "default", () => $a21e4cb5c5dfae62$export$2e2bcd8739ae039);
var $a21e4cb5c5dfae62$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $a21e4cb5c5dfae62$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a21e4cb5c5dfae62$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
var $a21e4cb5c5dfae62$export$2e2bcd8739ae039 = $a21e4cb5c5dfae62$var$formatDistance;

});

parcelRegister("gqyqR", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf59c88f2c129feb$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $bf59c88f2c129feb$var$dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var $bf59c88f2c129feb$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $bf59c88f2c129feb$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $bf59c88f2c129feb$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $bf59c88f2c129feb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $bf59c88f2c129feb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $bf59c88f2c129feb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $bf59c88f2c129feb$export$2e2bcd8739ae039 = $bf59c88f2c129feb$var$formatLong;

});

parcelRegister("iNMWw", function(module, exports) {
$parcel$export(module.exports, "default", () => $db02c4a8de30f8e2$export$2e2bcd8739ae039);
var $db02c4a8de30f8e2$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $db02c4a8de30f8e2$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $db02c4a8de30f8e2$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $db02c4a8de30f8e2$export$2e2bcd8739ae039 = $db02c4a8de30f8e2$var$formatRelative;

});

parcelRegister("jnuaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1b792a9d6c35a0f$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $e1b792a9d6c35a0f$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var $e1b792a9d6c35a0f$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $e1b792a9d6c35a0f$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var $e1b792a9d6c35a0f$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var $e1b792a9d6c35a0f$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $e1b792a9d6c35a0f$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $e1b792a9d6c35a0f$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $e1b792a9d6c35a0f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $e1b792a9d6c35a0f$var$localize = {
    ordinalNumber: $e1b792a9d6c35a0f$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $e1b792a9d6c35a0f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $e1b792a9d6c35a0f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $e1b792a9d6c35a0f$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $e1b792a9d6c35a0f$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $e1b792a9d6c35a0f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $e1b792a9d6c35a0f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e1b792a9d6c35a0f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e1b792a9d6c35a0f$export$2e2bcd8739ae039 = $e1b792a9d6c35a0f$var$localize;

});

parcelRegister("8XXIX", function(module, exports) {
$parcel$export(module.exports, "default", () => $6872295f412deee6$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $6872295f412deee6$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $6872295f412deee6$var$parseOrdinalNumberPattern = /\d+/i;
var $6872295f412deee6$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var $6872295f412deee6$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $6872295f412deee6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $6872295f412deee6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6872295f412deee6$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var $6872295f412deee6$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var $6872295f412deee6$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $6872295f412deee6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $6872295f412deee6$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var $6872295f412deee6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var $6872295f412deee6$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $6872295f412deee6$var$matchOrdinalNumberPattern,
        parsePattern: $6872295f412deee6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $6872295f412deee6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6872295f412deee6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $6872295f412deee6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6872295f412deee6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $6872295f412deee6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6872295f412deee6$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $6872295f412deee6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6872295f412deee6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $6872295f412deee6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6872295f412deee6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6872295f412deee6$export$2e2bcd8739ae039 = $6872295f412deee6$var$match;

});


parcelRegister("cN6IN", function(module, exports) {
$parcel$export(module.exports, "default", () => $94ff4662e89c14be$export$2e2bcd8739ae039);

var $9bwNg = parcelRequire("9bwNg");

var $d2laf = parcelRequire("d2laf");

var $jLBsv = parcelRequire("jLBsv");

var $fyJNM = parcelRequire("fyJNM");

var $53DMj = parcelRequire("53DMj");
/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var $94ff4662e89c14be$var$locale = {
    code: 'ht',
    formatDistance: (0, $9bwNg.default),
    formatLong: (0, $d2laf.default),
    formatRelative: (0, $jLBsv.default),
    localize: (0, $fyJNM.default),
    match: (0, $53DMj.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $94ff4662e89c14be$export$2e2bcd8739ae039 = $94ff4662e89c14be$var$locale;

});
parcelRegister("9bwNg", function(module, exports) {
$parcel$export(module.exports, "default", () => $6afe943c759379b8$export$2e2bcd8739ae039);
var $6afe943c759379b8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var $6afe943c759379b8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6afe943c759379b8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
var $6afe943c759379b8$export$2e2bcd8739ae039 = $6afe943c759379b8$var$formatDistance;

});

parcelRegister("d2laf", function(module, exports) {
$parcel$export(module.exports, "default", () => $97dbe10e8cd9305d$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $97dbe10e8cd9305d$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $97dbe10e8cd9305d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $97dbe10e8cd9305d$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $97dbe10e8cd9305d$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $97dbe10e8cd9305d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $97dbe10e8cd9305d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $97dbe10e8cd9305d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $97dbe10e8cd9305d$export$2e2bcd8739ae039 = $97dbe10e8cd9305d$var$formatLong;

});

parcelRegister("jLBsv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e63f769e0f2d0ed1$export$2e2bcd8739ae039);
var $e63f769e0f2d0ed1$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var $e63f769e0f2d0ed1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e63f769e0f2d0ed1$var$formatRelativeLocale[token];
};
var $e63f769e0f2d0ed1$export$2e2bcd8739ae039 = $e63f769e0f2d0ed1$var$formatRelative;

});

parcelRegister("fyJNM", function(module, exports) {
$parcel$export(module.exports, "default", () => $b53d8f4c1bce30d1$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $b53d8f4c1bce30d1$var$eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var $b53d8f4c1bce30d1$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var $b53d8f4c1bce30d1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var $b53d8f4c1bce30d1$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var $b53d8f4c1bce30d1$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var $b53d8f4c1bce30d1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var $b53d8f4c1bce30d1$var$localize = {
    ordinalNumber: $b53d8f4c1bce30d1$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $b53d8f4c1bce30d1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $b53d8f4c1bce30d1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $b53d8f4c1bce30d1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $b53d8f4c1bce30d1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $b53d8f4c1bce30d1$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $b53d8f4c1bce30d1$export$2e2bcd8739ae039 = $b53d8f4c1bce30d1$var$localize;

});

parcelRegister("53DMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3aec16ab6d33fbf8$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $3aec16ab6d33fbf8$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var $3aec16ab6d33fbf8$var$parseOrdinalNumberPattern = /\d+/i;
var $3aec16ab6d33fbf8$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var $3aec16ab6d33fbf8$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $3aec16ab6d33fbf8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var $3aec16ab6d33fbf8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3aec16ab6d33fbf8$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var $3aec16ab6d33fbf8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $3aec16ab6d33fbf8$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var $3aec16ab6d33fbf8$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var $3aec16ab6d33fbf8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var $3aec16ab6d33fbf8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var $3aec16ab6d33fbf8$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $3aec16ab6d33fbf8$var$matchOrdinalNumberPattern,
        parsePattern: $3aec16ab6d33fbf8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $3aec16ab6d33fbf8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3aec16ab6d33fbf8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $3aec16ab6d33fbf8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3aec16ab6d33fbf8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $3aec16ab6d33fbf8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3aec16ab6d33fbf8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $3aec16ab6d33fbf8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3aec16ab6d33fbf8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $3aec16ab6d33fbf8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3aec16ab6d33fbf8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3aec16ab6d33fbf8$export$2e2bcd8739ae039 = $3aec16ab6d33fbf8$var$match;

});


parcelRegister("2JBTq", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fdd2d77a5dfc74c$export$2e2bcd8739ae039);

var $627NW = parcelRequire("627NW");

var $k47Xr = parcelRequire("k47Xr");

var $iisGl = parcelRequire("iisGl");

var $7fD8Y = parcelRequire("7fD8Y");

var $gVOh3 = parcelRequire("gVOh3");
/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var $1fdd2d77a5dfc74c$var$locale = {
    code: 'hy',
    formatDistance: (0, $627NW.default),
    formatLong: (0, $k47Xr.default),
    formatRelative: (0, $iisGl.default),
    localize: (0, $7fD8Y.default),
    match: (0, $gVOh3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $1fdd2d77a5dfc74c$export$2e2bcd8739ae039 = $1fdd2d77a5dfc74c$var$locale;

});
parcelRegister("627NW", function(module, exports) {
$parcel$export(module.exports, "default", () => $4648fbd00cfe1e84$export$2e2bcd8739ae039);
var $4648fbd00cfe1e84$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var $4648fbd00cfe1e84$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4648fbd00cfe1e84$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
var $4648fbd00cfe1e84$export$2e2bcd8739ae039 = $4648fbd00cfe1e84$var$formatDistance;

});

parcelRegister("k47Xr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ba5a95bfda188f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $e9ba5a95bfda188f$var$dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var $e9ba5a95bfda188f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $e9ba5a95bfda188f$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $e9ba5a95bfda188f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $e9ba5a95bfda188f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $e9ba5a95bfda188f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $e9ba5a95bfda188f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $e9ba5a95bfda188f$export$2e2bcd8739ae039 = $e9ba5a95bfda188f$var$formatLong;

});

parcelRegister("iisGl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d520281522dea7e9$export$2e2bcd8739ae039);
var $d520281522dea7e9$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var $d520281522dea7e9$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d520281522dea7e9$var$formatRelativeLocale[token];
};
var $d520281522dea7e9$export$2e2bcd8739ae039 = $d520281522dea7e9$var$formatRelative;

});

parcelRegister("7fD8Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $54784c4078451930$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $54784c4078451930$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var $54784c4078451930$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var $54784c4078451930$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var $54784c4078451930$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var $54784c4078451930$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var $54784c4078451930$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var $54784c4078451930$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var $54784c4078451930$var$localize = {
    ordinalNumber: $54784c4078451930$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $54784c4078451930$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $54784c4078451930$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $54784c4078451930$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $54784c4078451930$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $54784c4078451930$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $54784c4078451930$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $54784c4078451930$export$2e2bcd8739ae039 = $54784c4078451930$var$localize;

});

parcelRegister("gVOh3", function(module, exports) {
$parcel$export(module.exports, "default", () => $c538f79ab2550a83$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $c538f79ab2550a83$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var $c538f79ab2550a83$var$parseOrdinalNumberPattern = /\d+/i;
var $c538f79ab2550a83$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var $c538f79ab2550a83$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var $c538f79ab2550a83$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var $c538f79ab2550a83$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c538f79ab2550a83$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var $c538f79ab2550a83$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var $c538f79ab2550a83$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var $c538f79ab2550a83$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var $c538f79ab2550a83$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var $c538f79ab2550a83$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var $c538f79ab2550a83$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $c538f79ab2550a83$var$matchOrdinalNumberPattern,
        parsePattern: $c538f79ab2550a83$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $c538f79ab2550a83$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c538f79ab2550a83$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $c538f79ab2550a83$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c538f79ab2550a83$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $c538f79ab2550a83$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c538f79ab2550a83$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $c538f79ab2550a83$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c538f79ab2550a83$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $c538f79ab2550a83$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c538f79ab2550a83$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c538f79ab2550a83$export$2e2bcd8739ae039 = $c538f79ab2550a83$var$match;

});


parcelRegister("dYqHL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2c5980149f82670$export$2e2bcd8739ae039);

var $bwt3L = parcelRequire("bwt3L");

var $hdR2f = parcelRequire("hdR2f");

var $1FU0K = parcelRequire("1FU0K");

var $dmGFE = parcelRequire("dmGFE");

var $38Ubd = parcelRequire("38Ubd");
/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var $a2c5980149f82670$var$locale = {
    code: 'id',
    formatDistance: (0, $bwt3L.default),
    formatLong: (0, $hdR2f.default),
    formatRelative: (0, $1FU0K.default),
    localize: (0, $dmGFE.default),
    match: (0, $38Ubd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $a2c5980149f82670$export$2e2bcd8739ae039 = $a2c5980149f82670$var$locale;

});
parcelRegister("bwt3L", function(module, exports) {
$parcel$export(module.exports, "default", () => $863939839dd21efc$export$2e2bcd8739ae039);
var $863939839dd21efc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $863939839dd21efc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $863939839dd21efc$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $863939839dd21efc$export$2e2bcd8739ae039 = $863939839dd21efc$var$formatDistance;

});

parcelRegister("hdR2f", function(module, exports) {
$parcel$export(module.exports, "default", () => $c89cca450ddb15c4$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $c89cca450ddb15c4$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $c89cca450ddb15c4$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $c89cca450ddb15c4$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c89cca450ddb15c4$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $c89cca450ddb15c4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $c89cca450ddb15c4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $c89cca450ddb15c4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c89cca450ddb15c4$export$2e2bcd8739ae039 = $c89cca450ddb15c4$var$formatLong;

});

parcelRegister("1FU0K", function(module, exports) {
$parcel$export(module.exports, "default", () => $1385116efc486462$export$2e2bcd8739ae039);
var $1385116efc486462$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var $1385116efc486462$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $1385116efc486462$var$formatRelativeLocale[token];
};
var $1385116efc486462$export$2e2bcd8739ae039 = $1385116efc486462$var$formatRelative;

});

parcelRegister("dmGFE", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bae6df3bf5f0430$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
// https://www.unicode.org/cldr/charts/32/summary/id.html
var $9bae6df3bf5f0430$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var $9bae6df3bf5f0430$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9bae6df3bf5f0430$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var $9bae6df3bf5f0430$var$dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var $9bae6df3bf5f0430$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $9bae6df3bf5f0430$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var $9bae6df3bf5f0430$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var $9bae6df3bf5f0430$var$localize = {
    ordinalNumber: $9bae6df3bf5f0430$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $9bae6df3bf5f0430$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $9bae6df3bf5f0430$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $9bae6df3bf5f0430$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $9bae6df3bf5f0430$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $9bae6df3bf5f0430$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9bae6df3bf5f0430$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9bae6df3bf5f0430$export$2e2bcd8739ae039 = $9bae6df3bf5f0430$var$localize;

});

parcelRegister("38Ubd", function(module, exports) {
$parcel$export(module.exports, "default", () => $249db29853dd1dd6$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $249db29853dd1dd6$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $249db29853dd1dd6$var$parseOrdinalNumberPattern = /\d+/i;
var $249db29853dd1dd6$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var $249db29853dd1dd6$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var $249db29853dd1dd6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var $249db29853dd1dd6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $249db29853dd1dd6$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var $249db29853dd1dd6$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $249db29853dd1dd6$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var $249db29853dd1dd6$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $249db29853dd1dd6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var $249db29853dd1dd6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var $249db29853dd1dd6$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $249db29853dd1dd6$var$matchOrdinalNumberPattern,
        parsePattern: $249db29853dd1dd6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $249db29853dd1dd6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $249db29853dd1dd6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $249db29853dd1dd6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $249db29853dd1dd6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $249db29853dd1dd6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $249db29853dd1dd6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $249db29853dd1dd6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $249db29853dd1dd6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $249db29853dd1dd6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $249db29853dd1dd6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $249db29853dd1dd6$export$2e2bcd8739ae039 = $249db29853dd1dd6$var$match;

});


parcelRegister("3vVJt", function(module, exports) {
$parcel$export(module.exports, "default", () => $28f10ccbc41af2df$export$2e2bcd8739ae039);

var $baH0b = parcelRequire("baH0b");

var $lSEtd = parcelRequire("lSEtd");

var $5bVJd = parcelRequire("5bVJd");

var $jebNs = parcelRequire("jebNs");

var $ktXYI = parcelRequire("ktXYI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var $28f10ccbc41af2df$var$locale = {
    code: 'it-CH',
    formatDistance: (0, $baH0b.default),
    formatLong: (0, $ktXYI.default),
    formatRelative: (0, $lSEtd.default),
    localize: (0, $5bVJd.default),
    match: (0, $jebNs.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $28f10ccbc41af2df$export$2e2bcd8739ae039 = $28f10ccbc41af2df$var$locale;

});
parcelRegister("ktXYI", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee950a806d3aef6d$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $ee950a806d3aef6d$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $ee950a806d3aef6d$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ee950a806d3aef6d$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ee950a806d3aef6d$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $ee950a806d3aef6d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $ee950a806d3aef6d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $ee950a806d3aef6d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ee950a806d3aef6d$export$2e2bcd8739ae039 = $ee950a806d3aef6d$var$formatLong;

});


parcelRegister("h1e29", function(module, exports) {
$parcel$export(module.exports, "default", () => $c63d6a74ee69f2fc$export$2e2bcd8739ae039);

var $a1exi = parcelRequire("a1exi");

var $47PAm = parcelRequire("47PAm");

var $55XoM = parcelRequire("55XoM");

var $5Geex = parcelRequire("5Geex");

var $fpyw3 = parcelRequire("fpyw3");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var $c63d6a74ee69f2fc$var$locale = {
    code: 'ja-Hira',
    formatDistance: (0, $a1exi.default),
    formatLong: (0, $47PAm.default),
    formatRelative: (0, $55XoM.default),
    localize: (0, $5Geex.default),
    match: (0, $fpyw3.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $c63d6a74ee69f2fc$export$2e2bcd8739ae039 = $c63d6a74ee69f2fc$var$locale;

});
parcelRegister("a1exi", function(module, exports) {
$parcel$export(module.exports, "default", () => $74b545e95be14013$export$2e2bcd8739ae039);
var $74b545e95be14013$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var $74b545e95be14013$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $74b545e95be14013$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
var $74b545e95be14013$export$2e2bcd8739ae039 = $74b545e95be14013$var$formatDistance;

});

parcelRegister("47PAm", function(module, exports) {
$parcel$export(module.exports, "default", () => $300fd4a7a7e9280d$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $300fd4a7a7e9280d$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $300fd4a7a7e9280d$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $300fd4a7a7e9280d$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $300fd4a7a7e9280d$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $300fd4a7a7e9280d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $300fd4a7a7e9280d$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $300fd4a7a7e9280d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $300fd4a7a7e9280d$export$2e2bcd8739ae039 = $300fd4a7a7e9280d$var$formatLong;

});

parcelRegister("55XoM", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b5b7eb3afd9a4f2$export$2e2bcd8739ae039);
var $3b5b7eb3afd9a4f2$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var $3b5b7eb3afd9a4f2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3b5b7eb3afd9a4f2$var$formatRelativeLocale[token];
};
var $3b5b7eb3afd9a4f2$export$2e2bcd8739ae039 = $3b5b7eb3afd9a4f2$var$formatRelative;

});

parcelRegister("5Geex", function(module, exports) {
$parcel$export(module.exports, "default", () => $422bea74c3c7fb0d$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $422bea74c3c7fb0d$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var $422bea74c3c7fb0d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var $422bea74c3c7fb0d$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var $422bea74c3c7fb0d$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var $422bea74c3c7fb0d$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $422bea74c3c7fb0d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $422bea74c3c7fb0d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var $422bea74c3c7fb0d$var$localize = {
    ordinalNumber: $422bea74c3c7fb0d$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $422bea74c3c7fb0d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $422bea74c3c7fb0d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $422bea74c3c7fb0d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $422bea74c3c7fb0d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $422bea74c3c7fb0d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $422bea74c3c7fb0d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $422bea74c3c7fb0d$export$2e2bcd8739ae039 = $422bea74c3c7fb0d$var$localize;

});

parcelRegister("fpyw3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b383f6fede87e320$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $b383f6fede87e320$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var $b383f6fede87e320$var$parseOrdinalNumberPattern = /\d+/i;
var $b383f6fede87e320$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var $b383f6fede87e320$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var $b383f6fede87e320$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var $b383f6fede87e320$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $b383f6fede87e320$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var $b383f6fede87e320$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $b383f6fede87e320$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var $b383f6fede87e320$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var $b383f6fede87e320$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var $b383f6fede87e320$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var $b383f6fede87e320$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $b383f6fede87e320$var$matchOrdinalNumberPattern,
        parsePattern: $b383f6fede87e320$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $b383f6fede87e320$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b383f6fede87e320$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $b383f6fede87e320$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b383f6fede87e320$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $b383f6fede87e320$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b383f6fede87e320$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $b383f6fede87e320$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b383f6fede87e320$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $b383f6fede87e320$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b383f6fede87e320$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b383f6fede87e320$export$2e2bcd8739ae039 = $b383f6fede87e320$var$match;

});


parcelRegister("lit0q", function(module, exports) {
$parcel$export(module.exports, "default", () => $f811c75ae3fd20d1$export$2e2bcd8739ae039);

var $flqwy = parcelRequire("flqwy");

var $lbLmC = parcelRequire("lbLmC");

var $8geA3 = parcelRequire("8geA3");

var $55g39 = parcelRequire("55g39");

var $1L11T = parcelRequire("1L11T");
/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var $f811c75ae3fd20d1$var$locale = {
    code: 'ka',
    formatDistance: (0, $flqwy.default),
    formatLong: (0, $lbLmC.default),
    formatRelative: (0, $8geA3.default),
    localize: (0, $55g39.default),
    match: (0, $1L11T.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f811c75ae3fd20d1$export$2e2bcd8739ae039 = $f811c75ae3fd20d1$var$locale;

});
parcelRegister("flqwy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2bd644d74585482$export$2e2bcd8739ae039);
var $b2bd644d74585482$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var $b2bd644d74585482$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b2bd644d74585482$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
var $b2bd644d74585482$export$2e2bcd8739ae039 = $b2bd644d74585482$var$formatDistance;

});

parcelRegister("lbLmC", function(module, exports) {
$parcel$export(module.exports, "default", () => $f6cf5d81678aaee2$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $f6cf5d81678aaee2$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var $f6cf5d81678aaee2$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $f6cf5d81678aaee2$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $f6cf5d81678aaee2$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $f6cf5d81678aaee2$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $f6cf5d81678aaee2$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $f6cf5d81678aaee2$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f6cf5d81678aaee2$export$2e2bcd8739ae039 = $f6cf5d81678aaee2$var$formatLong;

});

parcelRegister("8geA3", function(module, exports) {
$parcel$export(module.exports, "default", () => $603b20b964a12d6d$export$2e2bcd8739ae039);
var $603b20b964a12d6d$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var $603b20b964a12d6d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $603b20b964a12d6d$var$formatRelativeLocale[token];
};
var $603b20b964a12d6d$export$2e2bcd8739ae039 = $603b20b964a12d6d$var$formatRelative;

});

parcelRegister("55g39", function(module, exports) {
$parcel$export(module.exports, "default", () => $3b39de8ac23f5a7f$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $3b39de8ac23f5a7f$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var $3b39de8ac23f5a7f$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $3b39de8ac23f5a7f$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var $3b39de8ac23f5a7f$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var $3b39de8ac23f5a7f$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var $3b39de8ac23f5a7f$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var $3b39de8ac23f5a7f$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var $3b39de8ac23f5a7f$var$localize = {
    ordinalNumber: $3b39de8ac23f5a7f$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $3b39de8ac23f5a7f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $3b39de8ac23f5a7f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $3b39de8ac23f5a7f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $3b39de8ac23f5a7f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $3b39de8ac23f5a7f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $3b39de8ac23f5a7f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $3b39de8ac23f5a7f$export$2e2bcd8739ae039 = $3b39de8ac23f5a7f$var$localize;

});

parcelRegister("1L11T", function(module, exports) {
$parcel$export(module.exports, "default", () => $147afaaf1afae990$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $147afaaf1afae990$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var $147afaaf1afae990$var$parseOrdinalNumberPattern = /\d+/i;
var $147afaaf1afae990$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var $147afaaf1afae990$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var $147afaaf1afae990$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var $147afaaf1afae990$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $147afaaf1afae990$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var $147afaaf1afae990$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var $147afaaf1afae990$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var $147afaaf1afae990$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var $147afaaf1afae990$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var $147afaaf1afae990$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var $147afaaf1afae990$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $147afaaf1afae990$var$matchOrdinalNumberPattern,
        parsePattern: $147afaaf1afae990$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $147afaaf1afae990$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $147afaaf1afae990$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $147afaaf1afae990$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $147afaaf1afae990$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $147afaaf1afae990$var$matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $147afaaf1afae990$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $147afaaf1afae990$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $147afaaf1afae990$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $147afaaf1afae990$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $147afaaf1afae990$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $147afaaf1afae990$export$2e2bcd8739ae039 = $147afaaf1afae990$var$match;

});


parcelRegister("irh1Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6c7f591715437a8$export$2e2bcd8739ae039);

var $bvZ36 = parcelRequire("bvZ36");

var $a12Yl = parcelRequire("a12Yl");

var $2Njpa = parcelRequire("2Njpa");

var $fNPaG = parcelRequire("fNPaG");

var $jptuC = parcelRequire("jptuC");
/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var $d6c7f591715437a8$var$locale = {
    code: 'kk',
    formatDistance: (0, $bvZ36.default),
    formatLong: (0, $a12Yl.default),
    formatRelative: (0, $2Njpa.default),
    localize: (0, $fNPaG.default),
    match: (0, $jptuC.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $d6c7f591715437a8$export$2e2bcd8739ae039 = $d6c7f591715437a8$var$locale;

});
parcelRegister("bvZ36", function(module, exports) {
$parcel$export(module.exports, "default", () => $8621f208d08caf39$export$2e2bcd8739ae039);
var $8621f208d08caf39$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $8621f208d08caf39$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var $8621f208d08caf39$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $8621f208d08caf39$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $8621f208d08caf39$var$declension(tokenValue.future, count);
            else return $8621f208d08caf39$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $8621f208d08caf39$var$declension(tokenValue.past, count);
            else return $8621f208d08caf39$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $8621f208d08caf39$var$declension(tokenValue.regular, count);
};
var $8621f208d08caf39$export$2e2bcd8739ae039 = $8621f208d08caf39$var$formatDistance;

});

parcelRegister("a12Yl", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ac4d9830e7db3e$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $74ac4d9830e7db3e$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var $74ac4d9830e7db3e$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $74ac4d9830e7db3e$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $74ac4d9830e7db3e$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $74ac4d9830e7db3e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $74ac4d9830e7db3e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $74ac4d9830e7db3e$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $74ac4d9830e7db3e$export$2e2bcd8739ae039 = $74ac4d9830e7db3e$var$formatLong;

});

parcelRegister("2Njpa", function(module, exports) {
$parcel$export(module.exports, "default", () => $208f35ceefdddfa1$export$2e2bcd8739ae039);

var $kKrt2 = parcelRequire("kKrt2");
var $208f35ceefdddfa1$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $208f35ceefdddfa1$var$_lastWeek(day) {
    var weekday = $208f35ceefdddfa1$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $208f35ceefdddfa1$var$thisWeek(day) {
    var weekday = $208f35ceefdddfa1$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $208f35ceefdddfa1$var$_nextWeek(day) {
    var weekday = $208f35ceefdddfa1$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var $208f35ceefdddfa1$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $kKrt2.default)(date, baseDate, options)) return $208f35ceefdddfa1$var$thisWeek(day);
        else return $208f35ceefdddfa1$var$_lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $kKrt2.default)(date, baseDate, options)) return $208f35ceefdddfa1$var$thisWeek(day);
        else return $208f35ceefdddfa1$var$_nextWeek(day);
    },
    other: 'P'
};
var $208f35ceefdddfa1$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $208f35ceefdddfa1$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $208f35ceefdddfa1$export$2e2bcd8739ae039 = $208f35ceefdddfa1$var$formatRelative;

});

parcelRegister("fNPaG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b813202da7fda1e8$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $b813202da7fda1e8$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var $b813202da7fda1e8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $b813202da7fda1e8$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $b813202da7fda1e8$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $b813202da7fda1e8$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var $b813202da7fda1e8$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var $b813202da7fda1e8$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var $b813202da7fda1e8$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var $b813202da7fda1e8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = $b813202da7fda1e8$var$suffixes[number] || $b813202da7fda1e8$var$suffixes[mod10] || b && $b813202da7fda1e8$var$suffixes[b] || '';
    return number + suffix;
};
var $b813202da7fda1e8$var$localize = {
    ordinalNumber: $b813202da7fda1e8$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $b813202da7fda1e8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $b813202da7fda1e8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $b813202da7fda1e8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $b813202da7fda1e8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $b813202da7fda1e8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $b813202da7fda1e8$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $b813202da7fda1e8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b813202da7fda1e8$export$2e2bcd8739ae039 = $b813202da7fda1e8$var$localize;

});

parcelRegister("jptuC", function(module, exports) {
$parcel$export(module.exports, "default", () => $e2173ac7b33e089a$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $e2173ac7b33e089a$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var $e2173ac7b33e089a$var$parseOrdinalNumberPattern = /\d+/i;
var $e2173ac7b33e089a$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var $e2173ac7b33e089a$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var $e2173ac7b33e089a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var $e2173ac7b33e089a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e2173ac7b33e089a$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var $e2173ac7b33e089a$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var $e2173ac7b33e089a$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var $e2173ac7b33e089a$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var $e2173ac7b33e089a$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var $e2173ac7b33e089a$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var $e2173ac7b33e089a$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $e2173ac7b33e089a$var$matchOrdinalNumberPattern,
        parsePattern: $e2173ac7b33e089a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $e2173ac7b33e089a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2173ac7b33e089a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $e2173ac7b33e089a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2173ac7b33e089a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $e2173ac7b33e089a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2173ac7b33e089a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $e2173ac7b33e089a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2173ac7b33e089a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $e2173ac7b33e089a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e2173ac7b33e089a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e2173ac7b33e089a$export$2e2bcd8739ae039 = $e2173ac7b33e089a$var$match;

});


parcelRegister("h1PQB", function(module, exports) {
$parcel$export(module.exports, "default", () => $c65abf758908ba27$export$2e2bcd8739ae039);

var $bFpzr = parcelRequire("bFpzr");

var $3nemj = parcelRequire("3nemj");

var $46Fh3 = parcelRequire("46Fh3");

var $5yrBy = parcelRequire("5yrBy");

var $cfwcx = parcelRequire("cfwcx");
/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var $c65abf758908ba27$var$locale = {
    code: 'km',
    formatDistance: (0, $bFpzr.default),
    formatLong: (0, $3nemj.default),
    formatRelative: (0, $46Fh3.default),
    localize: (0, $5yrBy.default),
    match: (0, $cfwcx.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $c65abf758908ba27$export$2e2bcd8739ae039 = $c65abf758908ba27$var$locale;

});
parcelRegister("bFpzr", function(module, exports) {
$parcel$export(module.exports, "default", () => $87e75bd9e9ebde66$export$2e2bcd8739ae039);
var $87e75bd9e9ebde66$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var $87e75bd9e9ebde66$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $87e75bd9e9ebde66$var$formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
var $87e75bd9e9ebde66$export$2e2bcd8739ae039 = $87e75bd9e9ebde66$var$formatDistance;

});

parcelRegister("3nemj", function(module, exports) {
$parcel$export(module.exports, "default", () => $274ea879ee8e2684$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $274ea879ee8e2684$var$dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $274ea879ee8e2684$var$timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $274ea879ee8e2684$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $274ea879ee8e2684$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $274ea879ee8e2684$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $274ea879ee8e2684$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $274ea879ee8e2684$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $274ea879ee8e2684$export$2e2bcd8739ae039 = $274ea879ee8e2684$var$formatLong;

});

parcelRegister("46Fh3", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fd7bd2567953038$export$2e2bcd8739ae039);
var $2fd7bd2567953038$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var $2fd7bd2567953038$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2fd7bd2567953038$var$formatRelativeLocale[token];
};
var $2fd7bd2567953038$export$2e2bcd8739ae039 = $2fd7bd2567953038$var$formatRelative;

});

parcelRegister("5yrBy", function(module, exports) {
$parcel$export(module.exports, "default", () => $40b58a76678f0928$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $40b58a76678f0928$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var $40b58a76678f0928$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var $40b58a76678f0928$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var $40b58a76678f0928$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var $40b58a76678f0928$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $40b58a76678f0928$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $40b58a76678f0928$var$ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var $40b58a76678f0928$var$localize = {
    ordinalNumber: $40b58a76678f0928$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $40b58a76678f0928$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $40b58a76678f0928$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $40b58a76678f0928$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $40b58a76678f0928$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $40b58a76678f0928$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $40b58a76678f0928$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $40b58a76678f0928$export$2e2bcd8739ae039 = $40b58a76678f0928$var$localize;

});

parcelRegister("cfwcx", function(module, exports) {
$parcel$export(module.exports, "default", () => $8eafdd40985686a3$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $8eafdd40985686a3$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $8eafdd40985686a3$var$parseOrdinalNumberPattern = /\d+/i;
var $8eafdd40985686a3$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var $8eafdd40985686a3$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var $8eafdd40985686a3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var $8eafdd40985686a3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8eafdd40985686a3$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var $8eafdd40985686a3$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var $8eafdd40985686a3$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var $8eafdd40985686a3$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var $8eafdd40985686a3$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var $8eafdd40985686a3$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var $8eafdd40985686a3$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $8eafdd40985686a3$var$matchOrdinalNumberPattern,
        parsePattern: $8eafdd40985686a3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $8eafdd40985686a3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8eafdd40985686a3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $8eafdd40985686a3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8eafdd40985686a3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $8eafdd40985686a3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8eafdd40985686a3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $8eafdd40985686a3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8eafdd40985686a3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $8eafdd40985686a3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8eafdd40985686a3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8eafdd40985686a3$export$2e2bcd8739ae039 = $8eafdd40985686a3$var$match;

});


parcelRegister("e66Gp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a436cf54f3c620d9$export$2e2bcd8739ae039);

var $g1tEQ = parcelRequire("g1tEQ");

var $bj6NC = parcelRequire("bj6NC");

var $hxf1H = parcelRequire("hxf1H");

var $amTu4 = parcelRequire("amTu4");

var $5Eo6k = parcelRequire("5Eo6k");
/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var $a436cf54f3c620d9$var$locale = {
    code: 'kn',
    formatDistance: (0, $g1tEQ.default),
    formatLong: (0, $bj6NC.default),
    formatRelative: (0, $hxf1H.default),
    localize: (0, $amTu4.default),
    match: (0, $5Eo6k.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $a436cf54f3c620d9$export$2e2bcd8739ae039 = $a436cf54f3c620d9$var$locale;

});
parcelRegister("g1tEQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $baa3bebc65b704e3$export$2e2bcd8739ae039);
// note: no implementation for weeks
var $baa3bebc65b704e3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $baa3bebc65b704e3$var$getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var $baa3bebc65b704e3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $baa3bebc65b704e3$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $baa3bebc65b704e3$var$getResultByTense(tokenValue.one, options);
    else result = $baa3bebc65b704e3$var$getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
var $baa3bebc65b704e3$export$2e2bcd8739ae039 = $baa3bebc65b704e3$var$formatDistance;

});

parcelRegister("bj6NC", function(module, exports) {
$parcel$export(module.exports, "default", () => $83b6be46d1d71833$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $83b6be46d1d71833$var$dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var $83b6be46d1d71833$var$timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var $83b6be46d1d71833$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var $83b6be46d1d71833$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $83b6be46d1d71833$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $83b6be46d1d71833$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $83b6be46d1d71833$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $83b6be46d1d71833$export$2e2bcd8739ae039 = $83b6be46d1d71833$var$formatLong;

});

parcelRegister("hxf1H", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc412ca6f3372f89$export$2e2bcd8739ae039);
var $cc412ca6f3372f89$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var $cc412ca6f3372f89$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $cc412ca6f3372f89$var$formatRelativeLocale[token];
};
var $cc412ca6f3372f89$export$2e2bcd8739ae039 = $cc412ca6f3372f89$var$formatRelative;

});

parcelRegister("amTu4", function(module, exports) {
$parcel$export(module.exports, "default", () => $78c6ff6ca46d0364$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $78c6ff6ca46d0364$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var $78c6ff6ca46d0364$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var $78c6ff6ca46d0364$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var $78c6ff6ca46d0364$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var $78c6ff6ca46d0364$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $78c6ff6ca46d0364$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $78c6ff6ca46d0364$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var $78c6ff6ca46d0364$var$localize = {
    ordinalNumber: $78c6ff6ca46d0364$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $78c6ff6ca46d0364$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $78c6ff6ca46d0364$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $78c6ff6ca46d0364$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $78c6ff6ca46d0364$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $78c6ff6ca46d0364$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $78c6ff6ca46d0364$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $78c6ff6ca46d0364$export$2e2bcd8739ae039 = $78c6ff6ca46d0364$var$localize;

});

parcelRegister("5Eo6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $41d3621f9564e413$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $41d3621f9564e413$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var $41d3621f9564e413$var$parseOrdinalNumberPattern = /\d+/i;
var $41d3621f9564e413$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var $41d3621f9564e413$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var $41d3621f9564e413$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var $41d3621f9564e413$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $41d3621f9564e413$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var $41d3621f9564e413$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var $41d3621f9564e413$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var $41d3621f9564e413$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var $41d3621f9564e413$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var $41d3621f9564e413$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var $41d3621f9564e413$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $41d3621f9564e413$var$matchOrdinalNumberPattern,
        parsePattern: $41d3621f9564e413$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $41d3621f9564e413$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $41d3621f9564e413$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $41d3621f9564e413$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $41d3621f9564e413$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $41d3621f9564e413$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $41d3621f9564e413$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $41d3621f9564e413$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $41d3621f9564e413$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $41d3621f9564e413$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $41d3621f9564e413$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $41d3621f9564e413$export$2e2bcd8739ae039 = $41d3621f9564e413$var$match;

});


parcelRegister("ksnpw", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee489504899442fc$export$2e2bcd8739ae039);

var $4nIzO = parcelRequire("4nIzO");

var $2jSAg = parcelRequire("2jSAg");

var $jlkvy = parcelRequire("jlkvy");

var $pYuf4 = parcelRequire("pYuf4");

var $8dr3H = parcelRequire("8dr3H");
/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var $ee489504899442fc$var$locale = {
    code: 'lb',
    formatDistance: (0, $4nIzO.default),
    formatLong: (0, $2jSAg.default),
    formatRelative: (0, $jlkvy.default),
    localize: (0, $pYuf4.default),
    match: (0, $8dr3H.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ee489504899442fc$export$2e2bcd8739ae039 = $ee489504899442fc$var$locale;

});
parcelRegister("4nIzO", function(module, exports) {
$parcel$export(module.exports, "default", () => $330be35f2f5ae549$export$2e2bcd8739ae039);
var $330be35f2f5ae549$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var $330be35f2f5ae549$var$EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var $330be35f2f5ae549$var$VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var $330be35f2f5ae549$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var $330be35f2f5ae549$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $330be35f2f5ae549$var$isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if ($330be35f2f5ae549$var$VOWELS.indexOf(firstLetter) != -1 || $330be35f2f5ae549$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && $330be35f2f5ae549$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $330be35f2f5ae549$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var $330be35f2f5ae549$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $330be35f2f5ae549$var$formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + ($330be35f2f5ae549$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + ($330be35f2f5ae549$var$isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
var $330be35f2f5ae549$export$2e2bcd8739ae039 = $330be35f2f5ae549$var$formatDistance;

});

parcelRegister("2jSAg", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b07b255b0e80d3f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $1b07b255b0e80d3f$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var $1b07b255b0e80d3f$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $1b07b255b0e80d3f$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $1b07b255b0e80d3f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $1b07b255b0e80d3f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $1b07b255b0e80d3f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $1b07b255b0e80d3f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1b07b255b0e80d3f$export$2e2bcd8739ae039 = $1b07b255b0e80d3f$var$formatLong;

});

parcelRegister("jlkvy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e14fe2ec98bf3b52$export$2e2bcd8739ae039);
var $e14fe2ec98bf3b52$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $e14fe2ec98bf3b52$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $e14fe2ec98bf3b52$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $e14fe2ec98bf3b52$export$2e2bcd8739ae039 = $e14fe2ec98bf3b52$var$formatRelative;

});

parcelRegister("pYuf4", function(module, exports) {
$parcel$export(module.exports, "default", () => $04e14153e118116e$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $04e14153e118116e$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var $04e14153e118116e$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var $04e14153e118116e$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var $04e14153e118116e$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var $04e14153e118116e$var$dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var $04e14153e118116e$var$formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var $04e14153e118116e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $04e14153e118116e$var$localize = {
    ordinalNumber: $04e14153e118116e$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $04e14153e118116e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $04e14153e118116e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $04e14153e118116e$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $04e14153e118116e$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $04e14153e118116e$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $04e14153e118116e$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $04e14153e118116e$export$2e2bcd8739ae039 = $04e14153e118116e$var$localize;

});

parcelRegister("8dr3H", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fb486e976951497$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $5fb486e976951497$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $5fb486e976951497$var$parseOrdinalNumberPattern = /\d+/i;
var $5fb486e976951497$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var $5fb486e976951497$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $5fb486e976951497$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $5fb486e976951497$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5fb486e976951497$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var $5fb486e976951497$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $5fb486e976951497$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var $5fb486e976951497$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $5fb486e976951497$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var $5fb486e976951497$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var $5fb486e976951497$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $5fb486e976951497$var$matchOrdinalNumberPattern,
        parsePattern: $5fb486e976951497$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $5fb486e976951497$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5fb486e976951497$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $5fb486e976951497$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5fb486e976951497$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $5fb486e976951497$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5fb486e976951497$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $5fb486e976951497$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5fb486e976951497$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $5fb486e976951497$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5fb486e976951497$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5fb486e976951497$export$2e2bcd8739ae039 = $5fb486e976951497$var$match;

});


parcelRegister("3o0d9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2773c6efcad55067$export$2e2bcd8739ae039);

var $79m5f = parcelRequire("79m5f");

var $i3Io9 = parcelRequire("i3Io9");

var $fkZoc = parcelRequire("fkZoc");

var $1XJEa = parcelRequire("1XJEa");

var $bVljF = parcelRequire("bVljF");
/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var $2773c6efcad55067$var$locale = {
    code: 'lt',
    formatDistance: (0, $79m5f.default),
    formatLong: (0, $i3Io9.default),
    formatRelative: (0, $fkZoc.default),
    localize: (0, $1XJEa.default),
    match: (0, $bVljF.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2773c6efcad55067$export$2e2bcd8739ae039 = $2773c6efcad55067$var$locale;

});
parcelRegister("79m5f", function(module, exports) {
$parcel$export(module.exports, "default", () => $534a8107beed0b0a$export$2e2bcd8739ae039);
var $534a8107beed0b0a$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var $534a8107beed0b0a$var$translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var $534a8107beed0b0a$var$translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? $534a8107beed0b0a$var$forms(key)[0] : isFuture ? $534a8107beed0b0a$var$forms(key)[1] : $534a8107beed0b0a$var$forms(key)[2];
};
var $534a8107beed0b0a$var$translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + $534a8107beed0b0a$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($534a8107beed0b0a$var$special(number) ? $534a8107beed0b0a$var$forms(key)[1] : $534a8107beed0b0a$var$forms(key)[0]);
    else {
        if (isFuture) return result + $534a8107beed0b0a$var$forms(key)[1];
        else return result + ($534a8107beed0b0a$var$special(number) ? $534a8107beed0b0a$var$forms(key)[1] : $534a8107beed0b0a$var$forms(key)[2]);
    }
};
function $534a8107beed0b0a$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $534a8107beed0b0a$var$forms(key) {
    return $534a8107beed0b0a$var$translations[key].split('_');
}
var $534a8107beed0b0a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $534a8107beed0b0a$var$translateSeconds,
        other: $534a8107beed0b0a$var$translate
    },
    xSeconds: {
        one: $534a8107beed0b0a$var$translateSeconds,
        other: $534a8107beed0b0a$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    xMinutes: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    aboutXHours: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    xHours: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    xDays: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    aboutXWeeks: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    xWeeks: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    aboutXMonths: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    xMonths: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    aboutXYears: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    xYears: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    overXYears: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    },
    almostXYears: {
        one: $534a8107beed0b0a$var$translateSingular,
        other: $534a8107beed0b0a$var$translate
    }
};
var $534a8107beed0b0a$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = $534a8107beed0b0a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = $534a8107beed0b0a$var$translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
var $534a8107beed0b0a$export$2e2bcd8739ae039 = $534a8107beed0b0a$var$formatDistance;

});

parcelRegister("i3Io9", function(module, exports) {
$parcel$export(module.exports, "default", () => $d25af07784f9da7a$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $d25af07784f9da7a$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var $d25af07784f9da7a$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $d25af07784f9da7a$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d25af07784f9da7a$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $d25af07784f9da7a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $d25af07784f9da7a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $d25af07784f9da7a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d25af07784f9da7a$export$2e2bcd8739ae039 = $d25af07784f9da7a$var$formatLong;

});

parcelRegister("fkZoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $b2a857e87eb9f02d$export$2e2bcd8739ae039);
var $b2a857e87eb9f02d$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var $b2a857e87eb9f02d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b2a857e87eb9f02d$var$formatRelativeLocale[token];
};
var $b2a857e87eb9f02d$export$2e2bcd8739ae039 = $b2a857e87eb9f02d$var$formatRelative;

});

parcelRegister("1XJEa", function(module, exports) {
$parcel$export(module.exports, "default", () => $16deb5a683dbcf41$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $16deb5a683dbcf41$var$eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var $16deb5a683dbcf41$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $16deb5a683dbcf41$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var $16deb5a683dbcf41$var$monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var $16deb5a683dbcf41$var$formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var $16deb5a683dbcf41$var$dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var $16deb5a683dbcf41$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var $16deb5a683dbcf41$var$dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $16deb5a683dbcf41$var$formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var $16deb5a683dbcf41$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var $16deb5a683dbcf41$var$localize = {
    ordinalNumber: $16deb5a683dbcf41$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $16deb5a683dbcf41$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $16deb5a683dbcf41$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $16deb5a683dbcf41$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $16deb5a683dbcf41$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $16deb5a683dbcf41$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $16deb5a683dbcf41$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $16deb5a683dbcf41$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $16deb5a683dbcf41$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $16deb5a683dbcf41$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $16deb5a683dbcf41$export$2e2bcd8739ae039 = $16deb5a683dbcf41$var$localize;

});

parcelRegister("bVljF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ae58d8ed346c1c3$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $8ae58d8ed346c1c3$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var $8ae58d8ed346c1c3$var$parseOrdinalNumberPattern = /\d+/i;
var $8ae58d8ed346c1c3$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var $8ae58d8ed346c1c3$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var $8ae58d8ed346c1c3$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var $8ae58d8ed346c1c3$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var $8ae58d8ed346c1c3$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var $8ae58d8ed346c1c3$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var $8ae58d8ed346c1c3$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var $8ae58d8ed346c1c3$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var $8ae58d8ed346c1c3$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var $8ae58d8ed346c1c3$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var $8ae58d8ed346c1c3$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $8ae58d8ed346c1c3$var$matchOrdinalNumberPattern,
        parsePattern: $8ae58d8ed346c1c3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $8ae58d8ed346c1c3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8ae58d8ed346c1c3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $8ae58d8ed346c1c3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8ae58d8ed346c1c3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $8ae58d8ed346c1c3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8ae58d8ed346c1c3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $8ae58d8ed346c1c3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8ae58d8ed346c1c3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $8ae58d8ed346c1c3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8ae58d8ed346c1c3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8ae58d8ed346c1c3$export$2e2bcd8739ae039 = $8ae58d8ed346c1c3$var$match;

});


parcelRegister("iKYwd", function(module, exports) {
$parcel$export(module.exports, "default", () => $da7b779af656f8d8$export$2e2bcd8739ae039);

var $6nmg3 = parcelRequire("6nmg3");

var $5jDlT = parcelRequire("5jDlT");

var $gPc5L = parcelRequire("gPc5L");

var $jIMmM = parcelRequire("jIMmM");

var $iXtxh = parcelRequire("iXtxh");
/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var $da7b779af656f8d8$var$locale = {
    code: 'lv',
    formatDistance: (0, $6nmg3.default),
    formatLong: (0, $5jDlT.default),
    formatRelative: (0, $gPc5L.default),
    localize: (0, $jIMmM.default),
    match: (0, $iXtxh.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $da7b779af656f8d8$export$2e2bcd8739ae039 = $da7b779af656f8d8$var$locale;

});
parcelRegister("6nmg3", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a462800446b9254$export$2e2bcd8739ae039);
function $4a462800446b9254$var$buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var $4a462800446b9254$var$formatDistanceLocale = {
    lessThanXSeconds: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: $4a462800446b9254$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var $4a462800446b9254$var$formatDistance = function formatDistance(token, count, options) {
    var result = $4a462800446b9254$var$formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
var $4a462800446b9254$export$2e2bcd8739ae039 = $4a462800446b9254$var$formatDistance;

});

parcelRegister("5jDlT", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ded40954ca2c1e4$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $3ded40954ca2c1e4$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var $3ded40954ca2c1e4$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $3ded40954ca2c1e4$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $3ded40954ca2c1e4$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $3ded40954ca2c1e4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $3ded40954ca2c1e4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $3ded40954ca2c1e4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3ded40954ca2c1e4$export$2e2bcd8739ae039 = $3ded40954ca2c1e4$var$formatLong;

});

parcelRegister("gPc5L", function(module, exports) {
$parcel$export(module.exports, "default", () => $c3fac9f958fa2c1e$export$2e2bcd8739ae039);

var $kKrt2 = parcelRequire("kKrt2");
var $c3fac9f958fa2c1e$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var $c3fac9f958fa2c1e$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, $kKrt2.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $c3fac9f958fa2c1e$var$weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, $kKrt2.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $c3fac9f958fa2c1e$var$weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var $c3fac9f958fa2c1e$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $c3fac9f958fa2c1e$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $c3fac9f958fa2c1e$export$2e2bcd8739ae039 = $c3fac9f958fa2c1e$var$formatRelative;

});

parcelRegister("jIMmM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5b7a4ef8912af87$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $e5b7a4ef8912af87$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var $e5b7a4ef8912af87$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var $e5b7a4ef8912af87$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var $e5b7a4ef8912af87$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var $e5b7a4ef8912af87$var$formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var $e5b7a4ef8912af87$var$dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var $e5b7a4ef8912af87$var$formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var $e5b7a4ef8912af87$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var $e5b7a4ef8912af87$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var $e5b7a4ef8912af87$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $e5b7a4ef8912af87$var$localize = {
    ordinalNumber: $e5b7a4ef8912af87$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $e5b7a4ef8912af87$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $e5b7a4ef8912af87$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $e5b7a4ef8912af87$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $e5b7a4ef8912af87$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $e5b7a4ef8912af87$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $e5b7a4ef8912af87$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $e5b7a4ef8912af87$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $e5b7a4ef8912af87$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e5b7a4ef8912af87$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e5b7a4ef8912af87$export$2e2bcd8739ae039 = $e5b7a4ef8912af87$var$localize;

});

parcelRegister("iXtxh", function(module, exports) {
$parcel$export(module.exports, "default", () => $dcd4a5e239284829$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $dcd4a5e239284829$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $dcd4a5e239284829$var$parseOrdinalNumberPattern = /\d+/i;
var $dcd4a5e239284829$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var $dcd4a5e239284829$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var $dcd4a5e239284829$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var $dcd4a5e239284829$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var $dcd4a5e239284829$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var $dcd4a5e239284829$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $dcd4a5e239284829$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var $dcd4a5e239284829$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var $dcd4a5e239284829$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var $dcd4a5e239284829$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $dcd4a5e239284829$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $dcd4a5e239284829$var$matchOrdinalNumberPattern,
        parsePattern: $dcd4a5e239284829$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $dcd4a5e239284829$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcd4a5e239284829$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $dcd4a5e239284829$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcd4a5e239284829$var$parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $dcd4a5e239284829$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcd4a5e239284829$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $dcd4a5e239284829$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcd4a5e239284829$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $dcd4a5e239284829$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $dcd4a5e239284829$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $dcd4a5e239284829$export$2e2bcd8739ae039 = $dcd4a5e239284829$var$match;

});


parcelRegister("j7Ixm", function(module, exports) {
$parcel$export(module.exports, "default", () => $dec137e3db8f65a4$export$2e2bcd8739ae039);

var $loxc8 = parcelRequire("loxc8");

var $3WBZ4 = parcelRequire("3WBZ4");

var $6ojuF = parcelRequire("6ojuF");

var $d7OWh = parcelRequire("d7OWh");

var $04WJA = parcelRequire("04WJA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var $dec137e3db8f65a4$var$locale = {
    code: 'mk',
    formatDistance: (0, $loxc8.default),
    formatLong: (0, $3WBZ4.default),
    formatRelative: (0, $6ojuF.default),
    localize: (0, $d7OWh.default),
    match: (0, $04WJA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $dec137e3db8f65a4$export$2e2bcd8739ae039 = $dec137e3db8f65a4$var$locale;

});
parcelRegister("loxc8", function(module, exports) {
$parcel$export(module.exports, "default", () => $f93596a2b6dd235e$export$2e2bcd8739ae039);
var $f93596a2b6dd235e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $f93596a2b6dd235e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f93596a2b6dd235e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
var $f93596a2b6dd235e$export$2e2bcd8739ae039 = $f93596a2b6dd235e$var$formatDistance;

});

parcelRegister("3WBZ4", function(module, exports) {
$parcel$export(module.exports, "default", () => $2df440b5f61ea6cb$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $2df440b5f61ea6cb$var$dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $2df440b5f61ea6cb$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var $2df440b5f61ea6cb$var$dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var $2df440b5f61ea6cb$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $2df440b5f61ea6cb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $2df440b5f61ea6cb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $2df440b5f61ea6cb$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $2df440b5f61ea6cb$export$2e2bcd8739ae039 = $2df440b5f61ea6cb$var$formatLong;

});

parcelRegister("6ojuF", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a741afb0383dd19$export$2e2bcd8739ae039);

var $kKrt2 = parcelRequire("kKrt2");
var $4a741afb0383dd19$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $4a741afb0383dd19$var$_lastWeek(day) {
    var weekday = $4a741afb0383dd19$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $4a741afb0383dd19$var$thisWeek(day) {
    var weekday = $4a741afb0383dd19$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $4a741afb0383dd19$var$_nextWeek(day) {
    var weekday = $4a741afb0383dd19$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var $4a741afb0383dd19$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $kKrt2.default)(date, baseDate, options)) return $4a741afb0383dd19$var$thisWeek(day);
        else return $4a741afb0383dd19$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $kKrt2.default)(date, baseDate, options)) return $4a741afb0383dd19$var$thisWeek(day);
        else return $4a741afb0383dd19$var$_nextWeek(day);
    },
    other: 'P'
};
var $4a741afb0383dd19$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $4a741afb0383dd19$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $4a741afb0383dd19$export$2e2bcd8739ae039 = $4a741afb0383dd19$var$formatRelative;

});

parcelRegister("d7OWh", function(module, exports) {
$parcel$export(module.exports, "default", () => $98e3713e82d31059$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $98e3713e82d31059$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $98e3713e82d31059$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $98e3713e82d31059$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $98e3713e82d31059$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var $98e3713e82d31059$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var $98e3713e82d31059$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var $98e3713e82d31059$var$localize = {
    ordinalNumber: $98e3713e82d31059$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $98e3713e82d31059$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $98e3713e82d31059$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $98e3713e82d31059$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $98e3713e82d31059$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $98e3713e82d31059$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $98e3713e82d31059$export$2e2bcd8739ae039 = $98e3713e82d31059$var$localize;

});

parcelRegister("04WJA", function(module, exports) {
$parcel$export(module.exports, "default", () => $00edef4117e1af97$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $00edef4117e1af97$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var $00edef4117e1af97$var$parseOrdinalNumberPattern = /\d+/i;
var $00edef4117e1af97$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var $00edef4117e1af97$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $00edef4117e1af97$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var $00edef4117e1af97$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $00edef4117e1af97$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var $00edef4117e1af97$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var $00edef4117e1af97$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var $00edef4117e1af97$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $00edef4117e1af97$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var $00edef4117e1af97$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var $00edef4117e1af97$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $00edef4117e1af97$var$matchOrdinalNumberPattern,
        parsePattern: $00edef4117e1af97$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $00edef4117e1af97$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00edef4117e1af97$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $00edef4117e1af97$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00edef4117e1af97$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $00edef4117e1af97$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00edef4117e1af97$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $00edef4117e1af97$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $00edef4117e1af97$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $00edef4117e1af97$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $00edef4117e1af97$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $00edef4117e1af97$export$2e2bcd8739ae039 = $00edef4117e1af97$var$match;

});


parcelRegister("bKZJW", function(module, exports) {
$parcel$export(module.exports, "default", () => $88f3e1da3b3b7711$export$2e2bcd8739ae039);

var $7JaJE = parcelRequire("7JaJE");

var $kwMqK = parcelRequire("kwMqK");

var $kpo13 = parcelRequire("kpo13");

var $hsqGR = parcelRequire("hsqGR");

var $3g2AU = parcelRequire("3g2AU");
/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var $88f3e1da3b3b7711$var$locale = {
    code: 'mn',
    formatDistance: (0, $7JaJE.default),
    formatLong: (0, $kwMqK.default),
    formatRelative: (0, $kpo13.default),
    localize: (0, $hsqGR.default),
    match: (0, $3g2AU.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $88f3e1da3b3b7711$export$2e2bcd8739ae039 = $88f3e1da3b3b7711$var$locale;

});
parcelRegister("7JaJE", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a05102ecbadd7dd$export$2e2bcd8739ae039);
var $5a05102ecbadd7dd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var $5a05102ecbadd7dd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5a05102ecbadd7dd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
var $5a05102ecbadd7dd$export$2e2bcd8739ae039 = $5a05102ecbadd7dd$var$formatDistance;

});

parcelRegister("kwMqK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef1c5d1900ec85dc$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $ef1c5d1900ec85dc$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var $ef1c5d1900ec85dc$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $ef1c5d1900ec85dc$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $ef1c5d1900ec85dc$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $ef1c5d1900ec85dc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $ef1c5d1900ec85dc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $ef1c5d1900ec85dc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ef1c5d1900ec85dc$export$2e2bcd8739ae039 = $ef1c5d1900ec85dc$var$formatLong;

});

parcelRegister("kpo13", function(module, exports) {
$parcel$export(module.exports, "default", () => $edb8c58cb3245a8b$export$2e2bcd8739ae039);
var $edb8c58cb3245a8b$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var $edb8c58cb3245a8b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $edb8c58cb3245a8b$var$formatRelativeLocale[token];
};
var $edb8c58cb3245a8b$export$2e2bcd8739ae039 = $edb8c58cb3245a8b$var$formatRelative;

});

parcelRegister("hsqGR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cb59c1528f28be2e$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $cb59c1528f28be2e$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var $cb59c1528f28be2e$var$quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $cb59c1528f28be2e$var$monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $cb59c1528f28be2e$var$formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $cb59c1528f28be2e$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var $cb59c1528f28be2e$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var $cb59c1528f28be2e$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var $cb59c1528f28be2e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $cb59c1528f28be2e$var$localize = {
    ordinalNumber: $cb59c1528f28be2e$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $cb59c1528f28be2e$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $cb59c1528f28be2e$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $cb59c1528f28be2e$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $cb59c1528f28be2e$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $cb59c1528f28be2e$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $cb59c1528f28be2e$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $cb59c1528f28be2e$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $cb59c1528f28be2e$export$2e2bcd8739ae039 = $cb59c1528f28be2e$var$localize;

});

parcelRegister("3g2AU", function(module, exports) {
$parcel$export(module.exports, "default", () => $25f4e0df5c025d18$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $25f4e0df5c025d18$var$matchOrdinalNumberPattern = /\d+/i;
var $25f4e0df5c025d18$var$parseOrdinalNumberPattern = /\d+/i;
var $25f4e0df5c025d18$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var $25f4e0df5c025d18$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var $25f4e0df5c025d18$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var $25f4e0df5c025d18$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var $25f4e0df5c025d18$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var $25f4e0df5c025d18$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var $25f4e0df5c025d18$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var $25f4e0df5c025d18$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var $25f4e0df5c025d18$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var $25f4e0df5c025d18$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var $25f4e0df5c025d18$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $25f4e0df5c025d18$var$matchOrdinalNumberPattern,
        parsePattern: $25f4e0df5c025d18$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $25f4e0df5c025d18$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $25f4e0df5c025d18$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $25f4e0df5c025d18$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $25f4e0df5c025d18$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $25f4e0df5c025d18$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $25f4e0df5c025d18$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $25f4e0df5c025d18$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $25f4e0df5c025d18$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $25f4e0df5c025d18$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $25f4e0df5c025d18$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $25f4e0df5c025d18$export$2e2bcd8739ae039 = $25f4e0df5c025d18$var$match;

});


parcelRegister("iuD6w", function(module, exports) {
$parcel$export(module.exports, "default", () => $d7695ca114eb27ea$export$2e2bcd8739ae039);

var $c6Hs6 = parcelRequire("c6Hs6");

var $ktPDU = parcelRequire("ktPDU");

var $dk1Nj = parcelRequire("dk1Nj");

var $8eIGM = parcelRequire("8eIGM");

var $jAqwm = parcelRequire("jAqwm");
/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var $d7695ca114eb27ea$var$locale = {
    code: 'ms',
    formatDistance: (0, $c6Hs6.default),
    formatLong: (0, $ktPDU.default),
    formatRelative: (0, $dk1Nj.default),
    localize: (0, $8eIGM.default),
    match: (0, $jAqwm.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $d7695ca114eb27ea$export$2e2bcd8739ae039 = $d7695ca114eb27ea$var$locale;

});
parcelRegister("c6Hs6", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d07c050726e0bf3$export$2e2bcd8739ae039);
var $8d07c050726e0bf3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var $8d07c050726e0bf3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8d07c050726e0bf3$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
var $8d07c050726e0bf3$export$2e2bcd8739ae039 = $8d07c050726e0bf3$var$formatDistance;

});

parcelRegister("ktPDU", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee8e933973ae9159$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $ee8e933973ae9159$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var $ee8e933973ae9159$var$timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var $ee8e933973ae9159$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ee8e933973ae9159$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $ee8e933973ae9159$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $ee8e933973ae9159$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $ee8e933973ae9159$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ee8e933973ae9159$export$2e2bcd8739ae039 = $ee8e933973ae9159$var$formatLong;

});

parcelRegister("dk1Nj", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b2e88f50cb41c91$export$2e2bcd8739ae039);
var $9b2e88f50cb41c91$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var $9b2e88f50cb41c91$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9b2e88f50cb41c91$var$formatRelativeLocale[token];
};
var $9b2e88f50cb41c91$export$2e2bcd8739ae039 = $9b2e88f50cb41c91$var$formatRelative;

});

parcelRegister("8eIGM", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ff24bd89dd9ed83$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
// https://www.unicode.org/cldr/charts/32/summary/ms.html
var $5ff24bd89dd9ed83$var$eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var $5ff24bd89dd9ed83$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $5ff24bd89dd9ed83$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var $5ff24bd89dd9ed83$var$dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var $5ff24bd89dd9ed83$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $5ff24bd89dd9ed83$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var $5ff24bd89dd9ed83$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var $5ff24bd89dd9ed83$var$localize = {
    ordinalNumber: $5ff24bd89dd9ed83$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5ff24bd89dd9ed83$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5ff24bd89dd9ed83$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5ff24bd89dd9ed83$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5ff24bd89dd9ed83$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5ff24bd89dd9ed83$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5ff24bd89dd9ed83$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5ff24bd89dd9ed83$export$2e2bcd8739ae039 = $5ff24bd89dd9ed83$var$localize;

});

parcelRegister("jAqwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $e425f3a17c78240f$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $e425f3a17c78240f$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $e425f3a17c78240f$var$parseOrdinalNumberPattern = /petama|\d+/i;
var $e425f3a17c78240f$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var $e425f3a17c78240f$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var $e425f3a17c78240f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var $e425f3a17c78240f$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var $e425f3a17c78240f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var $e425f3a17c78240f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $e425f3a17c78240f$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var $e425f3a17c78240f$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $e425f3a17c78240f$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var $e425f3a17c78240f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var $e425f3a17c78240f$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $e425f3a17c78240f$var$matchOrdinalNumberPattern,
        parsePattern: $e425f3a17c78240f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $e425f3a17c78240f$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e425f3a17c78240f$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $e425f3a17c78240f$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e425f3a17c78240f$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $e425f3a17c78240f$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e425f3a17c78240f$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $e425f3a17c78240f$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e425f3a17c78240f$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $e425f3a17c78240f$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e425f3a17c78240f$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e425f3a17c78240f$export$2e2bcd8739ae039 = $e425f3a17c78240f$var$match;

});


parcelRegister("6uHC7", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ba76034f20c170b$export$2e2bcd8739ae039);

var $k7OL5 = parcelRequire("k7OL5");

var $6uar3 = parcelRequire("6uar3");

var $3gpwG = parcelRequire("3gpwG");

var $kDvTE = parcelRequire("kDvTE");

var $1MP7e = parcelRequire("1MP7e");
/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var $4ba76034f20c170b$var$locale = {
    code: 'mt',
    formatDistance: (0, $k7OL5.default),
    formatLong: (0, $6uar3.default),
    formatRelative: (0, $3gpwG.default),
    localize: (0, $kDvTE.default),
    match: (0, $1MP7e.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4ba76034f20c170b$export$2e2bcd8739ae039 = $4ba76034f20c170b$var$locale;

});
parcelRegister("k7OL5", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea6bd5b144b2809f$export$2e2bcd8739ae039);
var $ea6bd5b144b2809f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var $ea6bd5b144b2809f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ea6bd5b144b2809f$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
var $ea6bd5b144b2809f$export$2e2bcd8739ae039 = $ea6bd5b144b2809f$var$formatDistance;

});

parcelRegister("6uar3", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b8da3a4a191ea67$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $4b8da3a4a191ea67$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $4b8da3a4a191ea67$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4b8da3a4a191ea67$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $4b8da3a4a191ea67$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $4b8da3a4a191ea67$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $4b8da3a4a191ea67$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $4b8da3a4a191ea67$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4b8da3a4a191ea67$export$2e2bcd8739ae039 = $4b8da3a4a191ea67$var$formatLong;

});

parcelRegister("3gpwG", function(module, exports) {
$parcel$export(module.exports, "default", () => $2606aab2973a9d47$export$2e2bcd8739ae039);
var $2606aab2973a9d47$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var $2606aab2973a9d47$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2606aab2973a9d47$var$formatRelativeLocale[token];
};
var $2606aab2973a9d47$export$2e2bcd8739ae039 = $2606aab2973a9d47$var$formatRelative;

});

parcelRegister("kDvTE", function(module, exports) {
$parcel$export(module.exports, "default", () => $f060312dac339c0b$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $f060312dac339c0b$var$eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var $f060312dac339c0b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var $f060312dac339c0b$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var $f060312dac339c0b$var$dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var $f060312dac339c0b$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var $f060312dac339c0b$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var $f060312dac339c0b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $f060312dac339c0b$var$localize = {
    ordinalNumber: $f060312dac339c0b$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $f060312dac339c0b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $f060312dac339c0b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $f060312dac339c0b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $f060312dac339c0b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $f060312dac339c0b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f060312dac339c0b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f060312dac339c0b$export$2e2bcd8739ae039 = $f060312dac339c0b$var$localize;

});

parcelRegister("1MP7e", function(module, exports) {
$parcel$export(module.exports, "default", () => $14d1eca6fba881d8$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $14d1eca6fba881d8$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $14d1eca6fba881d8$var$parseOrdinalNumberPattern = /\d+/i;
var $14d1eca6fba881d8$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var $14d1eca6fba881d8$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var $14d1eca6fba881d8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var $14d1eca6fba881d8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $14d1eca6fba881d8$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var $14d1eca6fba881d8$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $14d1eca6fba881d8$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var $14d1eca6fba881d8$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var $14d1eca6fba881d8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var $14d1eca6fba881d8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var $14d1eca6fba881d8$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $14d1eca6fba881d8$var$matchOrdinalNumberPattern,
        parsePattern: $14d1eca6fba881d8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $14d1eca6fba881d8$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $14d1eca6fba881d8$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $14d1eca6fba881d8$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $14d1eca6fba881d8$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $14d1eca6fba881d8$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $14d1eca6fba881d8$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $14d1eca6fba881d8$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $14d1eca6fba881d8$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $14d1eca6fba881d8$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $14d1eca6fba881d8$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $14d1eca6fba881d8$export$2e2bcd8739ae039 = $14d1eca6fba881d8$var$match;

});


parcelRegister("2OZXk", function(module, exports) {
$parcel$export(module.exports, "default", () => $20e04f7407b9e60d$export$2e2bcd8739ae039);

var $3L67T = parcelRequire("3L67T");

var $eFEEv = parcelRequire("eFEEv");

var $4PV15 = parcelRequire("4PV15");

var $eCDBg = parcelRequire("eCDBg");

var $aEdWE = parcelRequire("aEdWE");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $20e04f7407b9e60d$var$locale = {
    code: 'nl-BE',
    formatDistance: (0, $3L67T.default),
    formatLong: (0, $eFEEv.default),
    formatRelative: (0, $4PV15.default),
    localize: (0, $eCDBg.default),
    match: (0, $aEdWE.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $20e04f7407b9e60d$export$2e2bcd8739ae039 = $20e04f7407b9e60d$var$locale;

});
parcelRegister("3L67T", function(module, exports) {
$parcel$export(module.exports, "default", () => $2bca837500347b74$export$2e2bcd8739ae039);
var $2bca837500347b74$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $2bca837500347b74$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2bca837500347b74$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $2bca837500347b74$export$2e2bcd8739ae039 = $2bca837500347b74$var$formatDistance;

});

parcelRegister("eFEEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $aae46db85067c8a4$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $aae46db85067c8a4$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var $aae46db85067c8a4$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aae46db85067c8a4$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $aae46db85067c8a4$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $aae46db85067c8a4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $aae46db85067c8a4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $aae46db85067c8a4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aae46db85067c8a4$export$2e2bcd8739ae039 = $aae46db85067c8a4$var$formatLong;

});

parcelRegister("4PV15", function(module, exports) {
$parcel$export(module.exports, "default", () => $3858271fa212b9b3$export$2e2bcd8739ae039);
var $3858271fa212b9b3$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $3858271fa212b9b3$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3858271fa212b9b3$var$formatRelativeLocale[token];
};
var $3858271fa212b9b3$export$2e2bcd8739ae039 = $3858271fa212b9b3$var$formatRelative;

});

parcelRegister("eCDBg", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa535505e812c83c$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $aa535505e812c83c$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $aa535505e812c83c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $aa535505e812c83c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $aa535505e812c83c$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $aa535505e812c83c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $aa535505e812c83c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $aa535505e812c83c$var$localize = {
    ordinalNumber: $aa535505e812c83c$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $aa535505e812c83c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $aa535505e812c83c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $aa535505e812c83c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $aa535505e812c83c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $aa535505e812c83c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $aa535505e812c83c$export$2e2bcd8739ae039 = $aa535505e812c83c$var$localize;

});

parcelRegister("aEdWE", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c0874ffe1af42f3$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $7c0874ffe1af42f3$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $7c0874ffe1af42f3$var$parseOrdinalNumberPattern = /\d+/i;
var $7c0874ffe1af42f3$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $7c0874ffe1af42f3$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $7c0874ffe1af42f3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $7c0874ffe1af42f3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7c0874ffe1af42f3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $7c0874ffe1af42f3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $7c0874ffe1af42f3$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $7c0874ffe1af42f3$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $7c0874ffe1af42f3$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $7c0874ffe1af42f3$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $7c0874ffe1af42f3$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $7c0874ffe1af42f3$var$matchOrdinalNumberPattern,
        parsePattern: $7c0874ffe1af42f3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $7c0874ffe1af42f3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c0874ffe1af42f3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $7c0874ffe1af42f3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c0874ffe1af42f3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $7c0874ffe1af42f3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c0874ffe1af42f3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $7c0874ffe1af42f3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7c0874ffe1af42f3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $7c0874ffe1af42f3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7c0874ffe1af42f3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7c0874ffe1af42f3$export$2e2bcd8739ae039 = $7c0874ffe1af42f3$var$match;

});


parcelRegister("js8X1", function(module, exports) {
$parcel$export(module.exports, "default", () => $e297934c025e2339$export$2e2bcd8739ae039);

var $jwahO = parcelRequire("jwahO");

var $a8UV2 = parcelRequire("a8UV2");

var $4LB0Y = parcelRequire("4LB0Y");

var $9UmnA = parcelRequire("9UmnA");

var $65uEu = parcelRequire("65uEu");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var $e297934c025e2339$var$locale = {
    code: 'nn',
    formatDistance: (0, $jwahO.default),
    formatLong: (0, $a8UV2.default),
    formatRelative: (0, $4LB0Y.default),
    localize: (0, $9UmnA.default),
    match: (0, $65uEu.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e297934c025e2339$export$2e2bcd8739ae039 = $e297934c025e2339$var$locale;

});
parcelRegister("jwahO", function(module, exports) {
$parcel$export(module.exports, "default", () => $e358fc205a19cdaa$export$2e2bcd8739ae039);
var $e358fc205a19cdaa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $e358fc205a19cdaa$var$wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var $e358fc205a19cdaa$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e358fc205a19cdaa$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $e358fc205a19cdaa$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
var $e358fc205a19cdaa$export$2e2bcd8739ae039 = $e358fc205a19cdaa$var$formatDistance;

});

parcelRegister("a8UV2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7626cdaaa5f6123f$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $7626cdaaa5f6123f$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $7626cdaaa5f6123f$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7626cdaaa5f6123f$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7626cdaaa5f6123f$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $7626cdaaa5f6123f$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $7626cdaaa5f6123f$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $7626cdaaa5f6123f$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7626cdaaa5f6123f$export$2e2bcd8739ae039 = $7626cdaaa5f6123f$var$formatLong;

});

parcelRegister("4LB0Y", function(module, exports) {
$parcel$export(module.exports, "default", () => $3788438e74c5e55c$export$2e2bcd8739ae039);
var $3788438e74c5e55c$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $3788438e74c5e55c$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3788438e74c5e55c$var$formatRelativeLocale[token];
};
var $3788438e74c5e55c$export$2e2bcd8739ae039 = $3788438e74c5e55c$var$formatRelative;

});

parcelRegister("9UmnA", function(module, exports) {
$parcel$export(module.exports, "default", () => $736ab4165b30e0bc$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $736ab4165b30e0bc$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $736ab4165b30e0bc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $736ab4165b30e0bc$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $736ab4165b30e0bc$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var $736ab4165b30e0bc$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var $736ab4165b30e0bc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $736ab4165b30e0bc$var$localize = {
    ordinalNumber: $736ab4165b30e0bc$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $736ab4165b30e0bc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $736ab4165b30e0bc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $736ab4165b30e0bc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $736ab4165b30e0bc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $736ab4165b30e0bc$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $736ab4165b30e0bc$export$2e2bcd8739ae039 = $736ab4165b30e0bc$var$localize;

});

parcelRegister("65uEu", function(module, exports) {
$parcel$export(module.exports, "default", () => $46eafc94139b732d$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $46eafc94139b732d$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $46eafc94139b732d$var$parseOrdinalNumberPattern = /\d+/i;
var $46eafc94139b732d$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $46eafc94139b732d$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $46eafc94139b732d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $46eafc94139b732d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $46eafc94139b732d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $46eafc94139b732d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $46eafc94139b732d$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var $46eafc94139b732d$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $46eafc94139b732d$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var $46eafc94139b732d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $46eafc94139b732d$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $46eafc94139b732d$var$matchOrdinalNumberPattern,
        parsePattern: $46eafc94139b732d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $46eafc94139b732d$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $46eafc94139b732d$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $46eafc94139b732d$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $46eafc94139b732d$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $46eafc94139b732d$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $46eafc94139b732d$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $46eafc94139b732d$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $46eafc94139b732d$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $46eafc94139b732d$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $46eafc94139b732d$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $46eafc94139b732d$export$2e2bcd8739ae039 = $46eafc94139b732d$var$match;

});


parcelRegister("1BdZC", function(module, exports) {
$parcel$export(module.exports, "default", () => $12a419d4d2cbe405$export$2e2bcd8739ae039);

var $4ccQ3 = parcelRequire("4ccQ3");

var $6SxMK = parcelRequire("6SxMK");

var $l3h7S = parcelRequire("l3h7S");

var $7KD7o = parcelRequire("7KD7o");

var $5u9G7 = parcelRequire("5u9G7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var $12a419d4d2cbe405$var$locale = {
    code: 'oc',
    formatDistance: (0, $4ccQ3.default),
    formatLong: (0, $6SxMK.default),
    formatRelative: (0, $l3h7S.default),
    localize: (0, $7KD7o.default),
    match: (0, $5u9G7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $12a419d4d2cbe405$export$2e2bcd8739ae039 = $12a419d4d2cbe405$var$locale;

});
parcelRegister("4ccQ3", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e23de194eae49c$export$2e2bcd8739ae039);
var $30e23de194eae49c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var $30e23de194eae49c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $30e23de194eae49c$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
var $30e23de194eae49c$export$2e2bcd8739ae039 = $30e23de194eae49c$var$formatDistance;

});

parcelRegister("6SxMK", function(module, exports) {
$parcel$export(module.exports, "default", () => $5021fe4282c51fdf$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $5021fe4282c51fdf$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $5021fe4282c51fdf$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $5021fe4282c51fdf$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $5021fe4282c51fdf$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $5021fe4282c51fdf$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $5021fe4282c51fdf$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $5021fe4282c51fdf$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $5021fe4282c51fdf$export$2e2bcd8739ae039 = $5021fe4282c51fdf$var$formatLong;

});

parcelRegister("l3h7S", function(module, exports) {
$parcel$export(module.exports, "default", () => $f53729af1334931b$export$2e2bcd8739ae039);
var $f53729af1334931b$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var $f53729af1334931b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f53729af1334931b$var$formatRelativeLocale[token];
};
var $f53729af1334931b$export$2e2bcd8739ae039 = $f53729af1334931b$var$formatRelative;

});

parcelRegister("7KD7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a4b2c54f1bb5879$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $5a4b2c54f1bb5879$var$eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var $5a4b2c54f1bb5879$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var $5a4b2c54f1bb5879$var$monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var $5a4b2c54f1bb5879$var$dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var $5a4b2c54f1bb5879$var$dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var $5a4b2c54f1bb5879$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var $5a4b2c54f1bb5879$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var $5a4b2c54f1bb5879$var$localize = {
    ordinalNumber: $5a4b2c54f1bb5879$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $5a4b2c54f1bb5879$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $5a4b2c54f1bb5879$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $5a4b2c54f1bb5879$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $5a4b2c54f1bb5879$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $5a4b2c54f1bb5879$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $5a4b2c54f1bb5879$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $5a4b2c54f1bb5879$export$2e2bcd8739ae039 = $5a4b2c54f1bb5879$var$localize;

});

parcelRegister("5u9G7", function(module, exports) {
$parcel$export(module.exports, "default", () => $3fe74303463b1d83$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $3fe74303463b1d83$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var $3fe74303463b1d83$var$parseOrdinalNumberPattern = /\d+/i;
var $3fe74303463b1d83$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var $3fe74303463b1d83$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var $3fe74303463b1d83$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var $3fe74303463b1d83$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3fe74303463b1d83$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var $3fe74303463b1d83$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $3fe74303463b1d83$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var $3fe74303463b1d83$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var $3fe74303463b1d83$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var $3fe74303463b1d83$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var $3fe74303463b1d83$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $3fe74303463b1d83$var$matchOrdinalNumberPattern,
        parsePattern: $3fe74303463b1d83$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $3fe74303463b1d83$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3fe74303463b1d83$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $3fe74303463b1d83$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3fe74303463b1d83$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $3fe74303463b1d83$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3fe74303463b1d83$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $3fe74303463b1d83$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3fe74303463b1d83$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $3fe74303463b1d83$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3fe74303463b1d83$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3fe74303463b1d83$export$2e2bcd8739ae039 = $3fe74303463b1d83$var$match;

});


parcelRegister("lVRfM", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff783ae39ebfe246$export$2e2bcd8739ae039);

var $2pjRR = parcelRequire("2pjRR");

var $ayAcl = parcelRequire("ayAcl");

var $jE3uL = parcelRequire("jE3uL");

var $i8JYU = parcelRequire("i8JYU");

var $jZw0y = parcelRequire("jZw0y");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var $ff783ae39ebfe246$var$locale = {
    code: 'sl',
    formatDistance: (0, $2pjRR.default),
    formatLong: (0, $ayAcl.default),
    formatRelative: (0, $jE3uL.default),
    localize: (0, $i8JYU.default),
    match: (0, $jZw0y.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ff783ae39ebfe246$export$2e2bcd8739ae039 = $ff783ae39ebfe246$var$locale;

});
parcelRegister("2pjRR", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c0d53e86f481c8e$export$2e2bcd8739ae039);
function $1c0d53e86f481c8e$var$isPluralType(val) {
    return val.one !== undefined;
}
var $1c0d53e86f481c8e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function $1c0d53e86f481c8e$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var $1c0d53e86f481c8e$var$formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = $1c0d53e86f481c8e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = $1c0d53e86f481c8e$var$getFormFromCount(count);
        if ($1c0d53e86f481c8e$var$isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
var $1c0d53e86f481c8e$export$2e2bcd8739ae039 = $1c0d53e86f481c8e$var$formatDistance;

});

parcelRegister("ayAcl", function(module, exports) {
$parcel$export(module.exports, "default", () => $7af9288ae6177409$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $7af9288ae6177409$var$dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var $7af9288ae6177409$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7af9288ae6177409$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7af9288ae6177409$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $7af9288ae6177409$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $7af9288ae6177409$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $7af9288ae6177409$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7af9288ae6177409$export$2e2bcd8739ae039 = $7af9288ae6177409$var$formatLong;

});

parcelRegister("jE3uL", function(module, exports) {
$parcel$export(module.exports, "default", () => $e4d476d277916c1a$export$2e2bcd8739ae039);
var $e4d476d277916c1a$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var $e4d476d277916c1a$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $e4d476d277916c1a$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $e4d476d277916c1a$export$2e2bcd8739ae039 = $e4d476d277916c1a$var$formatRelative;

});

parcelRegister("i8JYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d34ca44f154bef4d$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $d34ca44f154bef4d$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var $d34ca44f154bef4d$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var $d34ca44f154bef4d$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $d34ca44f154bef4d$var$dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var $d34ca44f154bef4d$var$dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var $d34ca44f154bef4d$var$formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var $d34ca44f154bef4d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $d34ca44f154bef4d$var$localize = {
    ordinalNumber: $d34ca44f154bef4d$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $d34ca44f154bef4d$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $d34ca44f154bef4d$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $d34ca44f154bef4d$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $d34ca44f154bef4d$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $d34ca44f154bef4d$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $d34ca44f154bef4d$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $d34ca44f154bef4d$export$2e2bcd8739ae039 = $d34ca44f154bef4d$var$localize;

});

parcelRegister("jZw0y", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8dc8aedde6f35d9$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $e8dc8aedde6f35d9$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $e8dc8aedde6f35d9$var$parseOrdinalNumberPattern = /\d+/i;
var $e8dc8aedde6f35d9$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var $e8dc8aedde6f35d9$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var $e8dc8aedde6f35d9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var $e8dc8aedde6f35d9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e8dc8aedde6f35d9$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var $e8dc8aedde6f35d9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e8dc8aedde6f35d9$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var $e8dc8aedde6f35d9$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var $e8dc8aedde6f35d9$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var $e8dc8aedde6f35d9$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var $e8dc8aedde6f35d9$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $e8dc8aedde6f35d9$var$matchOrdinalNumberPattern,
        parsePattern: $e8dc8aedde6f35d9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $e8dc8aedde6f35d9$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e8dc8aedde6f35d9$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $e8dc8aedde6f35d9$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e8dc8aedde6f35d9$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $e8dc8aedde6f35d9$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e8dc8aedde6f35d9$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $e8dc8aedde6f35d9$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $e8dc8aedde6f35d9$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $e8dc8aedde6f35d9$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $e8dc8aedde6f35d9$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $e8dc8aedde6f35d9$export$2e2bcd8739ae039 = $e8dc8aedde6f35d9$var$match;

});


parcelRegister("f8Eyy", function(module, exports) {
$parcel$export(module.exports, "default", () => $b057100549efef24$export$2e2bcd8739ae039);

var $j3nBn = parcelRequire("j3nBn");

var $iU28C = parcelRequire("iU28C");

var $89tyw = parcelRequire("89tyw");

var $eHod0 = parcelRequire("eHod0");

var $9OwCK = parcelRequire("9OwCK");
/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var $b057100549efef24$var$locale = {
    code: 'sq',
    formatDistance: (0, $j3nBn.default),
    formatLong: (0, $iU28C.default),
    formatRelative: (0, $89tyw.default),
    localize: (0, $eHod0.default),
    match: (0, $9OwCK.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b057100549efef24$export$2e2bcd8739ae039 = $b057100549efef24$var$locale;

});
parcelRegister("j3nBn", function(module, exports) {
$parcel$export(module.exports, "default", () => $ddf09af30bdd7046$export$2e2bcd8739ae039);
var $ddf09af30bdd7046$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var $ddf09af30bdd7046$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ddf09af30bdd7046$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
var $ddf09af30bdd7046$export$2e2bcd8739ae039 = $ddf09af30bdd7046$var$formatDistance;

});

parcelRegister("iU28C", function(module, exports) {
$parcel$export(module.exports, "default", () => $dc2f1d8b6139b802$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $dc2f1d8b6139b802$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $dc2f1d8b6139b802$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $dc2f1d8b6139b802$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $dc2f1d8b6139b802$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $dc2f1d8b6139b802$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $dc2f1d8b6139b802$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $dc2f1d8b6139b802$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $dc2f1d8b6139b802$export$2e2bcd8739ae039 = $dc2f1d8b6139b802$var$formatLong;

});

parcelRegister("89tyw", function(module, exports) {
$parcel$export(module.exports, "default", () => $5ef6172c08077799$export$2e2bcd8739ae039);
var $5ef6172c08077799$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $5ef6172c08077799$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5ef6172c08077799$var$formatRelativeLocale[token];
};
var $5ef6172c08077799$export$2e2bcd8739ae039 = $5ef6172c08077799$var$formatRelative;

});

parcelRegister("eHod0", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab37dc32085d7834$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $ab37dc32085d7834$var$eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var $ab37dc32085d7834$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $ab37dc32085d7834$var$monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var $ab37dc32085d7834$var$dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var $ab37dc32085d7834$var$dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var $ab37dc32085d7834$var$formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var $ab37dc32085d7834$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var $ab37dc32085d7834$var$localize = {
    ordinalNumber: $ab37dc32085d7834$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $ab37dc32085d7834$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $ab37dc32085d7834$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $ab37dc32085d7834$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $ab37dc32085d7834$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $ab37dc32085d7834$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $ab37dc32085d7834$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $ab37dc32085d7834$export$2e2bcd8739ae039 = $ab37dc32085d7834$var$localize;

});

parcelRegister("9OwCK", function(module, exports) {
$parcel$export(module.exports, "default", () => $725216fc6c9b73b1$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $725216fc6c9b73b1$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var $725216fc6c9b73b1$var$parseOrdinalNumberPattern = /\d+/i;
var $725216fc6c9b73b1$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var $725216fc6c9b73b1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var $725216fc6c9b73b1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var $725216fc6c9b73b1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $725216fc6c9b73b1$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var $725216fc6c9b73b1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var $725216fc6c9b73b1$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var $725216fc6c9b73b1$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var $725216fc6c9b73b1$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var $725216fc6c9b73b1$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var $725216fc6c9b73b1$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $725216fc6c9b73b1$var$matchOrdinalNumberPattern,
        parsePattern: $725216fc6c9b73b1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $725216fc6c9b73b1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $725216fc6c9b73b1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $725216fc6c9b73b1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $725216fc6c9b73b1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $725216fc6c9b73b1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $725216fc6c9b73b1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $725216fc6c9b73b1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $725216fc6c9b73b1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $725216fc6c9b73b1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $725216fc6c9b73b1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $725216fc6c9b73b1$export$2e2bcd8739ae039 = $725216fc6c9b73b1$var$match;

});


parcelRegister("k6cG1", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea1e3382d9f9c9e7$export$2e2bcd8739ae039);

var $cWqyn = parcelRequire("cWqyn");

var $bPn3b = parcelRequire("bPn3b");

var $76aNp = parcelRequire("76aNp");

var $3hlsu = parcelRequire("3hlsu");

var $1jZuH = parcelRequire("1jZuH");
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $ea1e3382d9f9c9e7$var$locale = {
    code: 'sr',
    formatDistance: (0, $cWqyn.default),
    formatLong: (0, $bPn3b.default),
    formatRelative: (0, $76aNp.default),
    localize: (0, $3hlsu.default),
    match: (0, $1jZuH.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ea1e3382d9f9c9e7$export$2e2bcd8739ae039 = $ea1e3382d9f9c9e7$var$locale;

});
parcelRegister("cWqyn", function(module, exports) {
$parcel$export(module.exports, "default", () => $96bf7fc1a72377dd$export$2e2bcd8739ae039);
var $96bf7fc1a72377dd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var $96bf7fc1a72377dd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $96bf7fc1a72377dd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
var $96bf7fc1a72377dd$export$2e2bcd8739ae039 = $96bf7fc1a72377dd$var$formatDistance;

});

parcelRegister("bPn3b", function(module, exports) {
$parcel$export(module.exports, "default", () => $89c6566f07eb1f4a$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $89c6566f07eb1f4a$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $89c6566f07eb1f4a$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $89c6566f07eb1f4a$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $89c6566f07eb1f4a$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $89c6566f07eb1f4a$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $89c6566f07eb1f4a$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $89c6566f07eb1f4a$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $89c6566f07eb1f4a$export$2e2bcd8739ae039 = $89c6566f07eb1f4a$var$formatLong;

});

parcelRegister("76aNp", function(module, exports) {
$parcel$export(module.exports, "default", () => $52b177c7e3edccab$export$2e2bcd8739ae039);
var $52b177c7e3edccab$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var $52b177c7e3edccab$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $52b177c7e3edccab$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $52b177c7e3edccab$export$2e2bcd8739ae039 = $52b177c7e3edccab$var$formatRelative;

});

parcelRegister("3hlsu", function(module, exports) {
$parcel$export(module.exports, "default", () => $26339ad47b47dc62$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $26339ad47b47dc62$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var $26339ad47b47dc62$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $26339ad47b47dc62$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $26339ad47b47dc62$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $26339ad47b47dc62$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $26339ad47b47dc62$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $26339ad47b47dc62$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $26339ad47b47dc62$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $26339ad47b47dc62$var$localize = {
    ordinalNumber: $26339ad47b47dc62$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $26339ad47b47dc62$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $26339ad47b47dc62$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $26339ad47b47dc62$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $26339ad47b47dc62$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $26339ad47b47dc62$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $26339ad47b47dc62$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $26339ad47b47dc62$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $26339ad47b47dc62$export$2e2bcd8739ae039 = $26339ad47b47dc62$var$localize;

});

parcelRegister("1jZuH", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f674445c578c783$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $0f674445c578c783$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $0f674445c578c783$var$parseOrdinalNumberPattern = /\d+/i;
var $0f674445c578c783$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var $0f674445c578c783$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var $0f674445c578c783$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var $0f674445c578c783$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0f674445c578c783$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var $0f674445c578c783$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $0f674445c578c783$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var $0f674445c578c783$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var $0f674445c578c783$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var $0f674445c578c783$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var $0f674445c578c783$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $0f674445c578c783$var$matchOrdinalNumberPattern,
        parsePattern: $0f674445c578c783$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $0f674445c578c783$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f674445c578c783$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $0f674445c578c783$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f674445c578c783$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $0f674445c578c783$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f674445c578c783$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $0f674445c578c783$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $0f674445c578c783$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $0f674445c578c783$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $0f674445c578c783$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $0f674445c578c783$export$2e2bcd8739ae039 = $0f674445c578c783$var$match;

});


parcelRegister("fzxMA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b564546c24bda5e6$export$2e2bcd8739ae039);

var $5Nfhm = parcelRequire("5Nfhm");

var $6AyyV = parcelRequire("6AyyV");

var $NDAlO = parcelRequire("NDAlO");

var $9jahe = parcelRequire("9jahe");

var $l430v = parcelRequire("l430v");
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $b564546c24bda5e6$var$locale = {
    code: 'sr-Latn',
    formatDistance: (0, $5Nfhm.default),
    formatLong: (0, $6AyyV.default),
    formatRelative: (0, $NDAlO.default),
    localize: (0, $9jahe.default),
    match: (0, $l430v.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b564546c24bda5e6$export$2e2bcd8739ae039 = $b564546c24bda5e6$var$locale;

});
parcelRegister("5Nfhm", function(module, exports) {
$parcel$export(module.exports, "default", () => $437d61733107512d$export$2e2bcd8739ae039);
var $437d61733107512d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var $437d61733107512d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $437d61733107512d$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
var $437d61733107512d$export$2e2bcd8739ae039 = $437d61733107512d$var$formatDistance;

});

parcelRegister("6AyyV", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cc0ea3dab7f8571$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $4cc0ea3dab7f8571$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var $4cc0ea3dab7f8571$var$timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $4cc0ea3dab7f8571$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $4cc0ea3dab7f8571$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $4cc0ea3dab7f8571$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $4cc0ea3dab7f8571$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $4cc0ea3dab7f8571$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $4cc0ea3dab7f8571$export$2e2bcd8739ae039 = $4cc0ea3dab7f8571$var$formatLong;

});

parcelRegister("NDAlO", function(module, exports) {
$parcel$export(module.exports, "default", () => $09534888c7d54aa8$export$2e2bcd8739ae039);
var $09534888c7d54aa8$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var $09534888c7d54aa8$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $09534888c7d54aa8$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $09534888c7d54aa8$export$2e2bcd8739ae039 = $09534888c7d54aa8$var$formatRelative;

});

parcelRegister("9jahe", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c6ddc2f256b29e7$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $6c6ddc2f256b29e7$var$eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var $6c6ddc2f256b29e7$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $6c6ddc2f256b29e7$var$monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $6c6ddc2f256b29e7$var$formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var $6c6ddc2f256b29e7$var$dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var $6c6ddc2f256b29e7$var$formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $6c6ddc2f256b29e7$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $6c6ddc2f256b29e7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $6c6ddc2f256b29e7$var$localize = {
    ordinalNumber: $6c6ddc2f256b29e7$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $6c6ddc2f256b29e7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $6c6ddc2f256b29e7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $6c6ddc2f256b29e7$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $6c6ddc2f256b29e7$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $6c6ddc2f256b29e7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $6c6ddc2f256b29e7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $6c6ddc2f256b29e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $6c6ddc2f256b29e7$export$2e2bcd8739ae039 = $6c6ddc2f256b29e7$var$localize;

});

parcelRegister("l430v", function(module, exports) {
$parcel$export(module.exports, "default", () => $f55c4dd7b62fa914$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $f55c4dd7b62fa914$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $f55c4dd7b62fa914$var$parseOrdinalNumberPattern = /\d+/i;
var $f55c4dd7b62fa914$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var $f55c4dd7b62fa914$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $f55c4dd7b62fa914$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $f55c4dd7b62fa914$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f55c4dd7b62fa914$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $f55c4dd7b62fa914$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f55c4dd7b62fa914$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $f55c4dd7b62fa914$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $f55c4dd7b62fa914$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var $f55c4dd7b62fa914$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $f55c4dd7b62fa914$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $f55c4dd7b62fa914$var$matchOrdinalNumberPattern,
        parsePattern: $f55c4dd7b62fa914$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $f55c4dd7b62fa914$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f55c4dd7b62fa914$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $f55c4dd7b62fa914$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f55c4dd7b62fa914$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $f55c4dd7b62fa914$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f55c4dd7b62fa914$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $f55c4dd7b62fa914$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f55c4dd7b62fa914$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $f55c4dd7b62fa914$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f55c4dd7b62fa914$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f55c4dd7b62fa914$export$2e2bcd8739ae039 = $f55c4dd7b62fa914$var$match;

});


parcelRegister("19svK", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d6cbf696e3c941b$export$2e2bcd8739ae039);

var $3NwHf = parcelRequire("3NwHf");

var $lL6e7 = parcelRequire("lL6e7");

var $1JM5K = parcelRequire("1JM5K");

var $aZSWi = parcelRequire("aZSWi");

var $ckjeX = parcelRequire("ckjeX");
/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var $0d6cbf696e3c941b$var$locale = {
    code: 'ta',
    formatDistance: (0, $3NwHf.default),
    formatLong: (0, $lL6e7.default),
    formatRelative: (0, $1JM5K.default),
    localize: (0, $aZSWi.default),
    match: (0, $ckjeX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0d6cbf696e3c941b$export$2e2bcd8739ae039 = $0d6cbf696e3c941b$var$locale;

});
parcelRegister("3NwHf", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c3f4f8f0225486e$export$2e2bcd8739ae039);
function $2c3f4f8f0225486e$var$isPluralType(val) {
    return val.one !== undefined;
}
var $2c3f4f8f0225486e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var $2c3f4f8f0225486e$var$formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = $2c3f4f8f0225486e$var$formatDistanceLocale[token];
    if (!$2c3f4f8f0225486e$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
var $2c3f4f8f0225486e$export$2e2bcd8739ae039 = $2c3f4f8f0225486e$var$formatDistance;

});

parcelRegister("lL6e7", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd72d13f253131c4$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
// CLDR #1846 - #1849
var $fd72d13f253131c4$var$dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var $fd72d13f253131c4$var$timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $fd72d13f253131c4$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $fd72d13f253131c4$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $fd72d13f253131c4$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $fd72d13f253131c4$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $fd72d13f253131c4$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fd72d13f253131c4$export$2e2bcd8739ae039 = $fd72d13f253131c4$var$formatLong;

});

parcelRegister("1JM5K", function(module, exports) {
$parcel$export(module.exports, "default", () => $143f4c700e858995$export$2e2bcd8739ae039);
var $143f4c700e858995$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var $143f4c700e858995$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $143f4c700e858995$var$formatRelativeLocale[token];
};
var $143f4c700e858995$export$2e2bcd8739ae039 = $143f4c700e858995$var$formatRelative;

});

parcelRegister("aZSWi", function(module, exports) {
$parcel$export(module.exports, "default", () => $801a37aaaadec83f$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $801a37aaaadec83f$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var $801a37aaaadec83f$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var $801a37aaaadec83f$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var $801a37aaaadec83f$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var $801a37aaaadec83f$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var $801a37aaaadec83f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var $801a37aaaadec83f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $801a37aaaadec83f$var$localize = {
    ordinalNumber: $801a37aaaadec83f$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $801a37aaaadec83f$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $801a37aaaadec83f$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $801a37aaaadec83f$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $801a37aaaadec83f$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $801a37aaaadec83f$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $801a37aaaadec83f$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $801a37aaaadec83f$export$2e2bcd8739ae039 = $801a37aaaadec83f$var$localize;

});

parcelRegister("ckjeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8f9646ffe36ec2f7$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $8f9646ffe36ec2f7$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var $8f9646ffe36ec2f7$var$parseOrdinalNumberPattern = /\d+/i;
var $8f9646ffe36ec2f7$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var $8f9646ffe36ec2f7$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var $8f9646ffe36ec2f7$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var $8f9646ffe36ec2f7$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var $8f9646ffe36ec2f7$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var $8f9646ffe36ec2f7$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var $8f9646ffe36ec2f7$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var $8f9646ffe36ec2f7$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var $8f9646ffe36ec2f7$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var $8f9646ffe36ec2f7$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var $8f9646ffe36ec2f7$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $8f9646ffe36ec2f7$var$matchOrdinalNumberPattern,
        parsePattern: $8f9646ffe36ec2f7$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $8f9646ffe36ec2f7$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f9646ffe36ec2f7$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $8f9646ffe36ec2f7$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f9646ffe36ec2f7$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $8f9646ffe36ec2f7$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f9646ffe36ec2f7$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $8f9646ffe36ec2f7$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8f9646ffe36ec2f7$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $8f9646ffe36ec2f7$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8f9646ffe36ec2f7$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8f9646ffe36ec2f7$export$2e2bcd8739ae039 = $8f9646ffe36ec2f7$var$match;

});


parcelRegister("bjnRf", function(module, exports) {
$parcel$export(module.exports, "default", () => $83c3f9b88430bc72$export$2e2bcd8739ae039);

var $2HhaA = parcelRequire("2HhaA");

var $aSTO2 = parcelRequire("aSTO2");

var $18sEf = parcelRequire("18sEf");

var $bxnLL = parcelRequire("bxnLL");

var $iCKaO = parcelRequire("iCKaO");
/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var $83c3f9b88430bc72$var$locale = {
    code: 'te',
    formatDistance: (0, $2HhaA.default),
    formatLong: (0, $aSTO2.default),
    formatRelative: (0, $18sEf.default),
    localize: (0, $bxnLL.default),
    match: (0, $iCKaO.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $83c3f9b88430bc72$export$2e2bcd8739ae039 = $83c3f9b88430bc72$var$locale;

});
parcelRegister("2HhaA", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f6cea742305a530$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $1f6cea742305a530$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var $1f6cea742305a530$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $1f6cea742305a530$var$formatDistanceLocale[token].withPreposition : $1f6cea742305a530$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
var $1f6cea742305a530$export$2e2bcd8739ae039 = $1f6cea742305a530$var$formatDistance;

});

parcelRegister("aSTO2", function(module, exports) {
$parcel$export(module.exports, "default", () => $7eca3c6e3283e4e1$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
// CLDR #1807 - #1811
var $7eca3c6e3283e4e1$var$dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var $7eca3c6e3283e4e1$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var $7eca3c6e3283e4e1$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7eca3c6e3283e4e1$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $7eca3c6e3283e4e1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $7eca3c6e3283e4e1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $7eca3c6e3283e4e1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7eca3c6e3283e4e1$export$2e2bcd8739ae039 = $7eca3c6e3283e4e1$var$formatLong;

});

parcelRegister("18sEf", function(module, exports) {
$parcel$export(module.exports, "default", () => $0d3cc2b83558cfa2$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $0d3cc2b83558cfa2$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var $0d3cc2b83558cfa2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0d3cc2b83558cfa2$var$formatRelativeLocale[token];
};
var $0d3cc2b83558cfa2$export$2e2bcd8739ae039 = $0d3cc2b83558cfa2$var$formatRelative;

});

parcelRegister("bxnLL", function(module, exports) {
$parcel$export(module.exports, "default", () => $866536e4fff06df1$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var $866536e4fff06df1$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var $866536e4fff06df1$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var $866536e4fff06df1$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var $866536e4fff06df1$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var $866536e4fff06df1$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $866536e4fff06df1$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $866536e4fff06df1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var $866536e4fff06df1$var$localize = {
    ordinalNumber: $866536e4fff06df1$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $866536e4fff06df1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $866536e4fff06df1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $866536e4fff06df1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $866536e4fff06df1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $866536e4fff06df1$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $866536e4fff06df1$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $866536e4fff06df1$export$2e2bcd8739ae039 = $866536e4fff06df1$var$localize;

});

parcelRegister("iCKaO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8ef97ae47eaf5aa$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $d8ef97ae47eaf5aa$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var $d8ef97ae47eaf5aa$var$parseOrdinalNumberPattern = /\d+/i;
var $d8ef97ae47eaf5aa$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var $d8ef97ae47eaf5aa$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var $d8ef97ae47eaf5aa$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var $d8ef97ae47eaf5aa$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d8ef97ae47eaf5aa$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var $d8ef97ae47eaf5aa$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var $d8ef97ae47eaf5aa$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var $d8ef97ae47eaf5aa$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var $d8ef97ae47eaf5aa$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var $d8ef97ae47eaf5aa$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var $d8ef97ae47eaf5aa$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $d8ef97ae47eaf5aa$var$matchOrdinalNumberPattern,
        parsePattern: $d8ef97ae47eaf5aa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $d8ef97ae47eaf5aa$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8ef97ae47eaf5aa$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $d8ef97ae47eaf5aa$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8ef97ae47eaf5aa$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $d8ef97ae47eaf5aa$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8ef97ae47eaf5aa$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $d8ef97ae47eaf5aa$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d8ef97ae47eaf5aa$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $d8ef97ae47eaf5aa$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $d8ef97ae47eaf5aa$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d8ef97ae47eaf5aa$export$2e2bcd8739ae039 = $d8ef97ae47eaf5aa$var$match;

});


parcelRegister("afnbu", function(module, exports) {
$parcel$export(module.exports, "default", () => $775d4a02d41a0d43$export$2e2bcd8739ae039);

var $joSYf = parcelRequire("joSYf");

var $ar85g = parcelRequire("ar85g");

var $1SI7o = parcelRequire("1SI7o");

var $bMwSV = parcelRequire("bMwSV");

var $gypPu = parcelRequire("gypPu");
/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var $775d4a02d41a0d43$var$locale = {
    code: 'th',
    formatDistance: (0, $joSYf.default),
    formatLong: (0, $ar85g.default),
    formatRelative: (0, $1SI7o.default),
    localize: (0, $bMwSV.default),
    match: (0, $gypPu.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $775d4a02d41a0d43$export$2e2bcd8739ae039 = $775d4a02d41a0d43$var$locale;

});
parcelRegister("joSYf", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1fae640c334887e$export$2e2bcd8739ae039);
var $e1fae640c334887e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var $e1fae640c334887e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e1fae640c334887e$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
var $e1fae640c334887e$export$2e2bcd8739ae039 = $e1fae640c334887e$var$formatDistance;

});

parcelRegister("ar85g", function(module, exports) {
$parcel$export(module.exports, "default", () => $7992b245b8a2701d$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $7992b245b8a2701d$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $7992b245b8a2701d$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var $7992b245b8a2701d$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7992b245b8a2701d$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $7992b245b8a2701d$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $7992b245b8a2701d$var$timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $7992b245b8a2701d$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7992b245b8a2701d$export$2e2bcd8739ae039 = $7992b245b8a2701d$var$formatLong;

});

parcelRegister("1SI7o", function(module, exports) {
$parcel$export(module.exports, "default", () => $15ed0e93add7348b$export$2e2bcd8739ae039);
var $15ed0e93add7348b$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var $15ed0e93add7348b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $15ed0e93add7348b$var$formatRelativeLocale[token];
};
var $15ed0e93add7348b$export$2e2bcd8739ae039 = $15ed0e93add7348b$var$formatRelative;

});

parcelRegister("bMwSV", function(module, exports) {
$parcel$export(module.exports, "default", () => $893dafae8a27b3df$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $893dafae8a27b3df$var$eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var $893dafae8a27b3df$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var $893dafae8a27b3df$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var $893dafae8a27b3df$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var $893dafae8a27b3df$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $893dafae8a27b3df$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $893dafae8a27b3df$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $893dafae8a27b3df$var$localize = {
    ordinalNumber: $893dafae8a27b3df$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $893dafae8a27b3df$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $893dafae8a27b3df$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $893dafae8a27b3df$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $893dafae8a27b3df$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $893dafae8a27b3df$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $893dafae8a27b3df$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $893dafae8a27b3df$export$2e2bcd8739ae039 = $893dafae8a27b3df$var$localize;

});

parcelRegister("gypPu", function(module, exports) {
$parcel$export(module.exports, "default", () => $c0d3db7fc53774c1$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $c0d3db7fc53774c1$var$matchOrdinalNumberPattern = /^\d+/i;
var $c0d3db7fc53774c1$var$parseOrdinalNumberPattern = /\d+/i;
var $c0d3db7fc53774c1$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var $c0d3db7fc53774c1$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var $c0d3db7fc53774c1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var $c0d3db7fc53774c1$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var $c0d3db7fc53774c1$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var $c0d3db7fc53774c1$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var $c0d3db7fc53774c1$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var $c0d3db7fc53774c1$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var $c0d3db7fc53774c1$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var $c0d3db7fc53774c1$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var $c0d3db7fc53774c1$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $c0d3db7fc53774c1$var$matchOrdinalNumberPattern,
        parsePattern: $c0d3db7fc53774c1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $c0d3db7fc53774c1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c0d3db7fc53774c1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $c0d3db7fc53774c1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c0d3db7fc53774c1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $c0d3db7fc53774c1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c0d3db7fc53774c1$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $c0d3db7fc53774c1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c0d3db7fc53774c1$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $c0d3db7fc53774c1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $c0d3db7fc53774c1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c0d3db7fc53774c1$export$2e2bcd8739ae039 = $c0d3db7fc53774c1$var$match;

});


parcelRegister("duCtQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9d2bed1c98b7a057$export$2e2bcd8739ae039);

var $f6sut = parcelRequire("f6sut");

var $0Dnme = parcelRequire("0Dnme");

var $a316r = parcelRequire("a316r");

var $5XK1H = parcelRequire("5XK1H");

var $ayMQz = parcelRequire("ayMQz");
/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var $9d2bed1c98b7a057$var$locale = {
    code: 'ug',
    formatDistance: (0, $f6sut.default),
    formatLong: (0, $0Dnme.default),
    formatRelative: (0, $a316r.default),
    localize: (0, $5XK1H.default),
    match: (0, $ayMQz.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $9d2bed1c98b7a057$export$2e2bcd8739ae039 = $9d2bed1c98b7a057$var$locale;

});
parcelRegister("f6sut", function(module, exports) {
$parcel$export(module.exports, "default", () => $afed842b5f0eed57$export$2e2bcd8739ae039);
var $afed842b5f0eed57$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var $afed842b5f0eed57$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $afed842b5f0eed57$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
var $afed842b5f0eed57$export$2e2bcd8739ae039 = $afed842b5f0eed57$var$formatDistance;

});

parcelRegister("0Dnme", function(module, exports) {
$parcel$export(module.exports, "default", () => $001e8b67268b5b15$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $001e8b67268b5b15$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $001e8b67268b5b15$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $001e8b67268b5b15$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $001e8b67268b5b15$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $001e8b67268b5b15$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $001e8b67268b5b15$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $001e8b67268b5b15$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $001e8b67268b5b15$export$2e2bcd8739ae039 = $001e8b67268b5b15$var$formatLong;

});

parcelRegister("a316r", function(module, exports) {
$parcel$export(module.exports, "default", () => $750b0a311a2cc076$export$2e2bcd8739ae039);
var $750b0a311a2cc076$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var $750b0a311a2cc076$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $750b0a311a2cc076$var$formatRelativeLocale[token];
};
var $750b0a311a2cc076$export$2e2bcd8739ae039 = $750b0a311a2cc076$var$formatRelative;

});

parcelRegister("5XK1H", function(module, exports) {
$parcel$export(module.exports, "default", () => $45762a4cf47bfcfc$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $45762a4cf47bfcfc$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var $45762a4cf47bfcfc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $45762a4cf47bfcfc$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var $45762a4cf47bfcfc$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var $45762a4cf47bfcfc$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var $45762a4cf47bfcfc$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var $45762a4cf47bfcfc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $45762a4cf47bfcfc$var$localize = {
    ordinalNumber: $45762a4cf47bfcfc$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $45762a4cf47bfcfc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $45762a4cf47bfcfc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $45762a4cf47bfcfc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $45762a4cf47bfcfc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $45762a4cf47bfcfc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $45762a4cf47bfcfc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $45762a4cf47bfcfc$export$2e2bcd8739ae039 = $45762a4cf47bfcfc$var$localize;

});

parcelRegister("ayMQz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7b02f853b0aa2f4e$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $7b02f853b0aa2f4e$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $7b02f853b0aa2f4e$var$parseOrdinalNumberPattern = /\d+/i;
var $7b02f853b0aa2f4e$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var $7b02f853b0aa2f4e$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var $7b02f853b0aa2f4e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var $7b02f853b0aa2f4e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7b02f853b0aa2f4e$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var $7b02f853b0aa2f4e$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var $7b02f853b0aa2f4e$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var $7b02f853b0aa2f4e$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var $7b02f853b0aa2f4e$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var $7b02f853b0aa2f4e$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var $7b02f853b0aa2f4e$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $7b02f853b0aa2f4e$var$matchOrdinalNumberPattern,
        parsePattern: $7b02f853b0aa2f4e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $7b02f853b0aa2f4e$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7b02f853b0aa2f4e$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $7b02f853b0aa2f4e$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7b02f853b0aa2f4e$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $7b02f853b0aa2f4e$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7b02f853b0aa2f4e$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $7b02f853b0aa2f4e$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7b02f853b0aa2f4e$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $7b02f853b0aa2f4e$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $7b02f853b0aa2f4e$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7b02f853b0aa2f4e$export$2e2bcd8739ae039 = $7b02f853b0aa2f4e$var$match;

});


parcelRegister("hYfH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d15436cd2517f7d2$export$2e2bcd8739ae039);

var $eiq7A = parcelRequire("eiq7A");

var $efBjh = parcelRequire("efBjh");

var $beBqQ = parcelRequire("beBqQ");

var $ZCn4v = parcelRequire("ZCn4v");

var $lka5h = parcelRequire("lka5h");
/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $d15436cd2517f7d2$var$locale = {
    code: 'uk',
    formatDistance: (0, $eiq7A.default),
    formatLong: (0, $efBjh.default),
    formatRelative: (0, $beBqQ.default),
    localize: (0, $ZCn4v.default),
    match: (0, $lka5h.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $d15436cd2517f7d2$export$2e2bcd8739ae039 = $d15436cd2517f7d2$var$locale;

});
parcelRegister("eiq7A", function(module, exports) {
$parcel$export(module.exports, "default", () => $a687024e2971caed$export$2e2bcd8739ae039);
function $a687024e2971caed$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $a687024e2971caed$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $a687024e2971caed$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $a687024e2971caed$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $a687024e2971caed$var$declension(scheme.past, count);
                else return $a687024e2971caed$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $a687024e2971caed$var$declension(scheme.regular, count);
    };
}
var $a687024e2971caed$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var $a687024e2971caed$var$formatDistanceLocale = {
    lessThanXSeconds: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $a687024e2971caed$var$halfAtMinute,
    lessThanXMinutes: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $a687024e2971caed$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var $a687024e2971caed$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $a687024e2971caed$var$formatDistanceLocale[token](count, options);
};
var $a687024e2971caed$export$2e2bcd8739ae039 = $a687024e2971caed$var$formatDistance;

});

parcelRegister("efBjh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5ff68600987fc05$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $a5ff68600987fc05$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var $a5ff68600987fc05$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $a5ff68600987fc05$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $a5ff68600987fc05$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $a5ff68600987fc05$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $a5ff68600987fc05$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $a5ff68600987fc05$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $a5ff68600987fc05$export$2e2bcd8739ae039 = $a5ff68600987fc05$var$formatLong;

});

parcelRegister("beBqQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $82de09bdc87c1ae7$export$2e2bcd8739ae039);

var $a3cTc = parcelRequire("a3cTc");

var $kKrt2 = parcelRequire("kKrt2");
var $82de09bdc87c1ae7$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $82de09bdc87c1ae7$var$lastWeek(day) {
    var weekday = $82de09bdc87c1ae7$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $82de09bdc87c1ae7$var$thisWeek(day) {
    var weekday = $82de09bdc87c1ae7$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $82de09bdc87c1ae7$var$nextWeek(day) {
    var weekday = $82de09bdc87c1ae7$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var $82de09bdc87c1ae7$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $82de09bdc87c1ae7$var$thisWeek(day);
    else return $82de09bdc87c1ae7$var$lastWeek(day);
};
var $82de09bdc87c1ae7$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $a3cTc.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $kKrt2.default)(date, baseDate, options)) return $82de09bdc87c1ae7$var$thisWeek(day);
    else return $82de09bdc87c1ae7$var$nextWeek(day);
};
var $82de09bdc87c1ae7$var$formatRelativeLocale = {
    lastWeek: $82de09bdc87c1ae7$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $82de09bdc87c1ae7$var$nextWeekFormat,
    other: 'P'
};
var $82de09bdc87c1ae7$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $82de09bdc87c1ae7$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $82de09bdc87c1ae7$export$2e2bcd8739ae039 = $82de09bdc87c1ae7$var$formatRelative;

});

parcelRegister("ZCn4v", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b9376535b2b3c9c$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $0b9376535b2b3c9c$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var $0b9376535b2b3c9c$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $0b9376535b2b3c9c$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var $0b9376535b2b3c9c$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var $0b9376535b2b3c9c$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $0b9376535b2b3c9c$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var $0b9376535b2b3c9c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var $0b9376535b2b3c9c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var $0b9376535b2b3c9c$var$localize = {
    ordinalNumber: $0b9376535b2b3c9c$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $0b9376535b2b3c9c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $0b9376535b2b3c9c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $0b9376535b2b3c9c$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $0b9376535b2b3c9c$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $0b9376535b2b3c9c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $0b9376535b2b3c9c$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $0b9376535b2b3c9c$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $0b9376535b2b3c9c$export$2e2bcd8739ae039 = $0b9376535b2b3c9c$var$localize;

});

parcelRegister("lka5h", function(module, exports) {
$parcel$export(module.exports, "default", () => $f86349b8aa453819$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $f86349b8aa453819$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $f86349b8aa453819$var$parseOrdinalNumberPattern = /\d+/i;
var $f86349b8aa453819$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $f86349b8aa453819$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $f86349b8aa453819$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $f86349b8aa453819$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f86349b8aa453819$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $f86349b8aa453819$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $f86349b8aa453819$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $f86349b8aa453819$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $f86349b8aa453819$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $f86349b8aa453819$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $f86349b8aa453819$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $f86349b8aa453819$var$matchOrdinalNumberPattern,
        parsePattern: $f86349b8aa453819$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $f86349b8aa453819$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f86349b8aa453819$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $f86349b8aa453819$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f86349b8aa453819$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $f86349b8aa453819$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f86349b8aa453819$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $f86349b8aa453819$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f86349b8aa453819$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $f86349b8aa453819$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f86349b8aa453819$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f86349b8aa453819$export$2e2bcd8739ae039 = $f86349b8aa453819$var$match;

});


parcelRegister("l5Ec0", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5a93e00db01ea4a$export$2e2bcd8739ae039);

var $anDre = parcelRequire("anDre");

var $jvhaX = parcelRequire("jvhaX");

var $bG1Bl = parcelRequire("bG1Bl");

var $kKU3g = parcelRequire("kKU3g");

var $kGBbZ = parcelRequire("kGBbZ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var $f5a93e00db01ea4a$var$locale = {
    code: 'uz',
    formatDistance: (0, $anDre.default),
    formatLong: (0, $jvhaX.default),
    formatRelative: (0, $bG1Bl.default),
    localize: (0, $kKU3g.default),
    match: (0, $kGBbZ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f5a93e00db01ea4a$export$2e2bcd8739ae039 = $f5a93e00db01ea4a$var$locale;

});
parcelRegister("anDre", function(module, exports) {
$parcel$export(module.exports, "default", () => $78eaa4f42137796b$export$2e2bcd8739ae039);
var $78eaa4f42137796b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var $78eaa4f42137796b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $78eaa4f42137796b$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
var $78eaa4f42137796b$export$2e2bcd8739ae039 = $78eaa4f42137796b$var$formatDistance;

});

parcelRegister("jvhaX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e32e3c4c0bdf088e$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $e32e3c4c0bdf088e$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $e32e3c4c0bdf088e$var$timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var $e32e3c4c0bdf088e$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $e32e3c4c0bdf088e$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $e32e3c4c0bdf088e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $e32e3c4c0bdf088e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $e32e3c4c0bdf088e$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $e32e3c4c0bdf088e$export$2e2bcd8739ae039 = $e32e3c4c0bdf088e$var$formatLong;

});

parcelRegister("bG1Bl", function(module, exports) {
$parcel$export(module.exports, "default", () => $8804dbf7b555a064$export$2e2bcd8739ae039);
var $8804dbf7b555a064$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var $8804dbf7b555a064$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $8804dbf7b555a064$var$formatRelativeLocale[token];
};
var $8804dbf7b555a064$export$2e2bcd8739ae039 = $8804dbf7b555a064$var$formatRelative;

});

parcelRegister("kKU3g", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1c3953b4cfee374$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $f1c3953b4cfee374$var$eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var $f1c3953b4cfee374$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f1c3953b4cfee374$var$monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var $f1c3953b4cfee374$var$dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var $f1c3953b4cfee374$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $f1c3953b4cfee374$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var $f1c3953b4cfee374$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $f1c3953b4cfee374$var$localize = {
    ordinalNumber: $f1c3953b4cfee374$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $f1c3953b4cfee374$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $f1c3953b4cfee374$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $f1c3953b4cfee374$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $f1c3953b4cfee374$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $f1c3953b4cfee374$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $f1c3953b4cfee374$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $f1c3953b4cfee374$export$2e2bcd8739ae039 = $f1c3953b4cfee374$var$localize;

});

parcelRegister("kGBbZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $f0f494820432e627$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $f0f494820432e627$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var $f0f494820432e627$var$parseOrdinalNumberPattern = /\d+/i;
var $f0f494820432e627$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var $f0f494820432e627$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $f0f494820432e627$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var $f0f494820432e627$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f0f494820432e627$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var $f0f494820432e627$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f0f494820432e627$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var $f0f494820432e627$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var $f0f494820432e627$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var $f0f494820432e627$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var $f0f494820432e627$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $f0f494820432e627$var$matchOrdinalNumberPattern,
        parsePattern: $f0f494820432e627$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $f0f494820432e627$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f0f494820432e627$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $f0f494820432e627$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f0f494820432e627$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $f0f494820432e627$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f0f494820432e627$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $f0f494820432e627$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $f0f494820432e627$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $f0f494820432e627$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $f0f494820432e627$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $f0f494820432e627$export$2e2bcd8739ae039 = $f0f494820432e627$var$match;

});


parcelRegister("3aRmk", function(module, exports) {
$parcel$export(module.exports, "default", () => $24fbb24309d61b52$export$2e2bcd8739ae039);

var $fe4xd = parcelRequire("fe4xd");

var $jh17U = parcelRequire("jh17U");

var $avF80 = parcelRequire("avF80");

var $hXpYF = parcelRequire("hXpYF");

var $6KpTv = parcelRequire("6KpTv");
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var $24fbb24309d61b52$var$locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, $fe4xd.default),
    formatLong: (0, $jh17U.default),
    formatRelative: (0, $avF80.default),
    localize: (0, $hXpYF.default),
    match: (0, $6KpTv.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $24fbb24309d61b52$export$2e2bcd8739ae039 = $24fbb24309d61b52$var$locale;

});
parcelRegister("fe4xd", function(module, exports) {
$parcel$export(module.exports, "default", () => $b15bae54a474e187$export$2e2bcd8739ae039);
var $b15bae54a474e187$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var $b15bae54a474e187$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b15bae54a474e187$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
var $b15bae54a474e187$export$2e2bcd8739ae039 = $b15bae54a474e187$var$formatDistance;

});

parcelRegister("jh17U", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0807a928ef778ea$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $e0807a928ef778ea$var$dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var $e0807a928ef778ea$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $e0807a928ef778ea$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $e0807a928ef778ea$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $e0807a928ef778ea$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $e0807a928ef778ea$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $e0807a928ef778ea$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $e0807a928ef778ea$export$2e2bcd8739ae039 = $e0807a928ef778ea$var$formatLong;

});

parcelRegister("avF80", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a6cb3d7a62e5d27$export$2e2bcd8739ae039);
var $7a6cb3d7a62e5d27$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var $7a6cb3d7a62e5d27$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7a6cb3d7a62e5d27$var$formatRelativeLocale[token];
};
var $7a6cb3d7a62e5d27$export$2e2bcd8739ae039 = $7a6cb3d7a62e5d27$var$formatRelative;

});

parcelRegister("hXpYF", function(module, exports) {
$parcel$export(module.exports, "default", () => $d12c18f5caa361ef$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $d12c18f5caa361ef$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var $d12c18f5caa361ef$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var $d12c18f5caa361ef$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var $d12c18f5caa361ef$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var $d12c18f5caa361ef$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $d12c18f5caa361ef$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $d12c18f5caa361ef$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $d12c18f5caa361ef$var$localize = {
    ordinalNumber: $d12c18f5caa361ef$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $d12c18f5caa361ef$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $d12c18f5caa361ef$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $d12c18f5caa361ef$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $d12c18f5caa361ef$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $d12c18f5caa361ef$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $d12c18f5caa361ef$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
var $d12c18f5caa361ef$export$2e2bcd8739ae039 = $d12c18f5caa361ef$var$localize;

});

parcelRegister("6KpTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e9b2004be2c4713$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $4e9b2004be2c4713$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var $4e9b2004be2c4713$var$parseOrdinalNumberPattern = /\d+/i;
var $4e9b2004be2c4713$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var $4e9b2004be2c4713$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var $4e9b2004be2c4713$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var $4e9b2004be2c4713$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4e9b2004be2c4713$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var $4e9b2004be2c4713$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $4e9b2004be2c4713$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var $4e9b2004be2c4713$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var $4e9b2004be2c4713$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var $4e9b2004be2c4713$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var $4e9b2004be2c4713$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $4e9b2004be2c4713$var$matchOrdinalNumberPattern,
        parsePattern: $4e9b2004be2c4713$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $4e9b2004be2c4713$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4e9b2004be2c4713$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $4e9b2004be2c4713$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4e9b2004be2c4713$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $4e9b2004be2c4713$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4e9b2004be2c4713$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $4e9b2004be2c4713$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4e9b2004be2c4713$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $4e9b2004be2c4713$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4e9b2004be2c4713$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4e9b2004be2c4713$export$2e2bcd8739ae039 = $4e9b2004be2c4713$var$match;

});


parcelRegister("ebB1q", function(module, exports) {
$parcel$export(module.exports, "default", () => $a53ecf8fdec65e59$export$2e2bcd8739ae039);

var $aVQ05 = parcelRequire("aVQ05");

var $9bKjo = parcelRequire("9bKjo");

var $8d23F = parcelRequire("8d23F");

var $4yA33 = parcelRequire("4yA33");

var $bVWew = parcelRequire("bVWew");
/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var $a53ecf8fdec65e59$var$locale = {
    code: 'vi',
    formatDistance: (0, $aVQ05.default),
    formatLong: (0, $9bKjo.default),
    formatRelative: (0, $8d23F.default),
    localize: (0, $4yA33.default),
    match: (0, $bVWew.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
var $a53ecf8fdec65e59$export$2e2bcd8739ae039 = $a53ecf8fdec65e59$var$locale;

});
parcelRegister("aVQ05", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f5790734055a074$export$2e2bcd8739ae039);
var $7f5790734055a074$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var $7f5790734055a074$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7f5790734055a074$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
var $7f5790734055a074$export$2e2bcd8739ae039 = $7f5790734055a074$var$formatDistance;

});

parcelRegister("9bKjo", function(module, exports) {
$parcel$export(module.exports, "default", () => $6b0910adf091b5a0$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $6b0910adf091b5a0$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var $6b0910adf091b5a0$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6b0910adf091b5a0$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $6b0910adf091b5a0$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $6b0910adf091b5a0$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $6b0910adf091b5a0$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $6b0910adf091b5a0$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6b0910adf091b5a0$export$2e2bcd8739ae039 = $6b0910adf091b5a0$var$formatLong;

});

parcelRegister("8d23F", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fa1225463cc7254$export$2e2bcd8739ae039);
var $5fa1225463cc7254$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var $5fa1225463cc7254$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5fa1225463cc7254$var$formatRelativeLocale[token];
};
var $5fa1225463cc7254$export$2e2bcd8739ae039 = $5fa1225463cc7254$var$formatRelative;

});

parcelRegister("4yA33", function(module, exports) {
$parcel$export(module.exports, "default", () => $35164cda057c79c4$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var $35164cda057c79c4$var$eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var $35164cda057c79c4$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var $35164cda057c79c4$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $35164cda057c79c4$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var $35164cda057c79c4$var$formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var $35164cda057c79c4$var$dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var $35164cda057c79c4$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var $35164cda057c79c4$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var $35164cda057c79c4$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var $35164cda057c79c4$var$localize = {
    ordinalNumber: $35164cda057c79c4$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $35164cda057c79c4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $35164cda057c79c4$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $35164cda057c79c4$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $35164cda057c79c4$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $35164cda057c79c4$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $35164cda057c79c4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $35164cda057c79c4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $35164cda057c79c4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $35164cda057c79c4$export$2e2bcd8739ae039 = $35164cda057c79c4$var$localize;

});

parcelRegister("bVWew", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b02308295046c63$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $8b02308295046c63$var$matchOrdinalNumberPattern = /^(\d+)/i;
var $8b02308295046c63$var$parseOrdinalNumberPattern = /\d+/i;
var $8b02308295046c63$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var $8b02308295046c63$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var $8b02308295046c63$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var $8b02308295046c63$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var $8b02308295046c63$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var $8b02308295046c63$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var $8b02308295046c63$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var $8b02308295046c63$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var $8b02308295046c63$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var $8b02308295046c63$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var $8b02308295046c63$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $8b02308295046c63$var$matchOrdinalNumberPattern,
        parsePattern: $8b02308295046c63$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $8b02308295046c63$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b02308295046c63$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $8b02308295046c63$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b02308295046c63$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $8b02308295046c63$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b02308295046c63$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $8b02308295046c63$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b02308295046c63$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $8b02308295046c63$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b02308295046c63$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8b02308295046c63$export$2e2bcd8739ae039 = $8b02308295046c63$var$match;

});


parcelRegister("oSXfJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $04acdedcc1430908$export$2e2bcd8739ae039);

var $2V508 = parcelRequire("2V508");

var $d9p0z = parcelRequire("d9p0z");

var $9h80E = parcelRequire("9h80E");

var $jX3nn = parcelRequire("jX3nn");

var $fYsxD = parcelRequire("fYsxD");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var $04acdedcc1430908$var$locale = {
    code: 'zh-HK',
    formatDistance: (0, $2V508.default),
    formatLong: (0, $d9p0z.default),
    formatRelative: (0, $9h80E.default),
    localize: (0, $jX3nn.default),
    match: (0, $fYsxD.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $04acdedcc1430908$export$2e2bcd8739ae039 = $04acdedcc1430908$var$locale;

});
parcelRegister("2V508", function(module, exports) {
$parcel$export(module.exports, "default", () => $2204c8c24dcf45c4$export$2e2bcd8739ae039);
var $2204c8c24dcf45c4$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $2204c8c24dcf45c4$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2204c8c24dcf45c4$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $2204c8c24dcf45c4$export$2e2bcd8739ae039 = $2204c8c24dcf45c4$var$formatDistance;

});

parcelRegister("d9p0z", function(module, exports) {
$parcel$export(module.exports, "default", () => $992f83bf46ed02a5$export$2e2bcd8739ae039);

var $hqkXT = parcelRequire("hqkXT");
var $992f83bf46ed02a5$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $992f83bf46ed02a5$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $992f83bf46ed02a5$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $992f83bf46ed02a5$var$formatLong = {
    date: (0, $hqkXT.default)({
        formats: $992f83bf46ed02a5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $hqkXT.default)({
        formats: $992f83bf46ed02a5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $hqkXT.default)({
        formats: $992f83bf46ed02a5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $992f83bf46ed02a5$export$2e2bcd8739ae039 = $992f83bf46ed02a5$var$formatLong;

});

parcelRegister("9h80E", function(module, exports) {
$parcel$export(module.exports, "default", () => $6c0bea1607611cb2$export$2e2bcd8739ae039);
var $6c0bea1607611cb2$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $6c0bea1607611cb2$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6c0bea1607611cb2$var$formatRelativeLocale[token];
};
var $6c0bea1607611cb2$export$2e2bcd8739ae039 = $6c0bea1607611cb2$var$formatRelative;

});

parcelRegister("jX3nn", function(module, exports) {
$parcel$export(module.exports, "default", () => $e866256ee3849ed4$export$2e2bcd8739ae039);

var $afp2T = parcelRequire("afp2T");
var $e866256ee3849ed4$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $e866256ee3849ed4$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $e866256ee3849ed4$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $e866256ee3849ed4$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $e866256ee3849ed4$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $e866256ee3849ed4$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $e866256ee3849ed4$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $e866256ee3849ed4$var$localize = {
    ordinalNumber: $e866256ee3849ed4$var$ordinalNumber,
    era: (0, $afp2T.default)({
        values: $e866256ee3849ed4$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $afp2T.default)({
        values: $e866256ee3849ed4$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $afp2T.default)({
        values: $e866256ee3849ed4$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $afp2T.default)({
        values: $e866256ee3849ed4$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $afp2T.default)({
        values: $e866256ee3849ed4$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e866256ee3849ed4$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e866256ee3849ed4$export$2e2bcd8739ae039 = $e866256ee3849ed4$var$localize;

});

parcelRegister("fYsxD", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba12995c77d296e3$export$2e2bcd8739ae039);

var $ckS9b = parcelRequire("ckS9b");

var $59jA4 = parcelRequire("59jA4");
var $ba12995c77d296e3$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $ba12995c77d296e3$var$parseOrdinalNumberPattern = /\d+/i;
var $ba12995c77d296e3$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $ba12995c77d296e3$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $ba12995c77d296e3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var $ba12995c77d296e3$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $ba12995c77d296e3$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $ba12995c77d296e3$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $ba12995c77d296e3$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $ba12995c77d296e3$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $ba12995c77d296e3$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $ba12995c77d296e3$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $ba12995c77d296e3$var$match = {
    ordinalNumber: (0, $59jA4.default)({
        matchPattern: $ba12995c77d296e3$var$matchOrdinalNumberPattern,
        parsePattern: $ba12995c77d296e3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $ckS9b.default)({
        matchPatterns: $ba12995c77d296e3$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba12995c77d296e3$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $ckS9b.default)({
        matchPatterns: $ba12995c77d296e3$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba12995c77d296e3$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $ckS9b.default)({
        matchPatterns: $ba12995c77d296e3$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba12995c77d296e3$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $ckS9b.default)({
        matchPatterns: $ba12995c77d296e3$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $ba12995c77d296e3$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $ckS9b.default)({
        matchPatterns: $ba12995c77d296e3$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $ba12995c77d296e3$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $ba12995c77d296e3$export$2e2bcd8739ae039 = $ba12995c77d296e3$var$match;

});



parcelRegister("ggTei", function(module, exports) {
$parcel$export(module.exports, "parseDateType", () => $7799215fc13b607b$export$9f54bd296c9b15c8);
$parcel$export(module.exports, "formatDateType", () => $7799215fc13b607b$export$c1b0befbc45d5daf);
$parcel$export(module.exports, "dateTypeToDate", () => $7799215fc13b607b$export$2071e1c033c380c7);
$parcel$export(module.exports, "dateToDateType", () => $7799215fc13b607b$export$e657ff381fe1e42a);

var $gn6xt = parcelRequire("gn6xt");
function $7799215fc13b607b$export$9f54bd296c9b15c8(dateString, locale) {
    try {
        const l10n = (0, $gn6xt.createLocalizationProvider)(locale);
        const date = l10n.parseDate(dateString);
        // If date is invalid
        if (isNaN(date.getTime())) return null;
        const year = date.getFullYear();
        if (year < 1000 || year > 9999) return null;
        const dateObj = {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: year
        };
        return dateObj;
    } catch (e) {
        return null;
    }
}
function $7799215fc13b607b$export$c1b0befbc45d5daf(date, locale) {
    const { day: day, month: month, year: year } = date;
    const l10n = (0, $gn6xt.createLocalizationProvider)(locale);
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return l10n.formatDate(dateObj);
}
function $7799215fc13b607b$export$2071e1c033c380c7(date) {
    const { day: day, month: month, year: year } = date;
    // The JS Date api represents month as a number between 0-11 :)
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
    const dateObj = new Date(year, month - 1, day);
    return dateObj;
}
function $7799215fc13b607b$export$e657ff381fe1e42a(date) {
    const dateObj = {
        day: date.getDate(),
        // The JS Date api represents month as a number between 0-11 :)
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date
        month: date.getMonth() + 1,
        year: date.getFullYear()
    };
    return dateObj;
}

});


parcelRegister("d95H3", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $b8c66051680d7270$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $b8c66051680d7270$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('datePlugin');

});


parcelRegister("7jrkM", function(module, exports) {
$parcel$export(module.exports, "deleteDateCommand", () => $2ac9d54d2c9aaf4e$export$8993b403eaf979d2);
$parcel$export(module.exports, "insertDateCommand", () => $2ac9d54d2c9aaf4e$export$b606a931fa97541b);

var $3LeME = parcelRequire("3LeME");

var $gR9lL = parcelRequire("gR9lL");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $34ULg = parcelRequire("34ULg");

var $d95H3 = parcelRequire("d95H3");
const $2ac9d54d2c9aaf4e$export$8993b403eaf979d2 = (pluginInjectionApi)=>({ tr: tr })=>{
        var _pluginInjectionApi$d;
        const { showDatePickerAt: showDatePickerAt } = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d = pluginInjectionApi.date) === null || _pluginInjectionApi$d === void 0 ? void 0 : _pluginInjectionApi$d.sharedState.currentState()) ?? {};
        if (!showDatePickerAt) return tr;
        tr.delete(showDatePickerAt, showDatePickerAt + 1).setMeta((0, $d95H3.pluginKey), {
            showDatePickerAt: null,
            isNew: false
        });
        return tr;
    };
const $2ac9d54d2c9aaf4e$export$b606a931fa97541b = (pluginInjectionApi)=>({ date: date, inputMethod: inputMethod, commitMethod: commitMethod, enterPressed: enterPressed = true })=>({ tr: tr })=>{
            var _pluginInjectionApi$d2;
            const { schema: schema } = tr.doc.type;
            let timestamp;
            if (date) timestamp = Date.UTC(date.year, date.month - 1, date.day).toString();
            else timestamp = (0, $gR9lL.todayTimestampInUTC)();
            if (inputMethod) {
                var _pluginInjectionApi$a;
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 || (_pluginInjectionApi$a = _pluginInjectionApi$a.actions) === null || _pluginInjectionApi$a === void 0 || _pluginInjectionApi$a.attachAnalyticsEvent({
                    action: (0, $3LeME.ACTION).INSERTED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).DATE,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod
                    }
                })(tr);
            }
            if (commitMethod) {
                var _pluginInjectionApi$a2;
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 || (_pluginInjectionApi$a2 = _pluginInjectionApi$a2.actions) === null || _pluginInjectionApi$a2 === void 0 || _pluginInjectionApi$a2.attachAnalyticsEvent({
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    action: (0, $3LeME.ACTION).COMMITTED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DATE,
                    attributes: {
                        commitMethod: commitMethod,
                        isValid: date !== undefined,
                        isToday: (0, $34ULg.isToday)(date)
                    }
                })(tr);
            }
            const { showDatePickerAt: showDatePickerAt } = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d2 = pluginInjectionApi.date) === null || _pluginInjectionApi$d2 === void 0 ? void 0 : _pluginInjectionApi$d2.sharedState.currentState()) ?? {};
            if (!showDatePickerAt) {
                const dateNode = schema.nodes.date.createChecked({
                    timestamp: timestamp
                });
                const textNode = schema.text(' ');
                const fragment = (0, $7H6Cr.Fragment).fromArray([
                    dateNode,
                    textNode
                ]);
                const { from: from, to: to } = tr.selection;
                const insertable = (0, $a4TQr.canInsert)(tr.selection.$from, fragment);
                if (!insertable) {
                    const parentSelection = (0, $801jp.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
                    tr.insert(parentSelection.to, fragment).setSelection((0, $801jp.NodeSelection).create(tr.doc, parentSelection.to + 1));
                } else tr.replaceWith(from, to, fragment).setSelection((0, $801jp.NodeSelection).create(tr.doc, from));
                if (tr.docChanged) tr.scrollIntoView().setMeta((0, $d95H3.pluginKey), {
                    isNew: true
                });
                return tr;
            }
            if (tr.doc.nodeAt(showDatePickerAt)) {
                if (enterPressed) // Setting selection to outside the date node causes showDatePickerAt
                // to be set to null by the PM plugin (onSelectionChanged), which will
                // immediately close the datepicker once a valid date is typed in.
                // Adding this check forces it to stay open until the user presses Enter.
                tr = tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(showDatePickerAt + 2)));
                tr = tr.setNodeMarkup(showDatePickerAt, schema.nodes.date, {
                    timestamp: timestamp
                }).setMeta((0, $d95H3.pluginKey), {
                    isNew: false
                }).scrollIntoView();
                if (!enterPressed) tr = tr.setSelection((0, $801jp.NodeSelection).create(tr.doc, showDatePickerAt));
            }
            return tr;
        };

});

parcelRegister("eCE9b", function(module, exports) {
$parcel$export(module.exports, "default", () => $80489e9525864913$export$2e2bcd8739ae039);

var $1tkqg = parcelRequire("1tkqg");

var $eUtBU = parcelRequire("eUtBU");

var $801jp = parcelRequire("801jp");

var $7ymzg = parcelRequire("7ymzg");

var $8A5oa = parcelRequire("8A5oa");
function $80489e9525864913$export$e832373cff8dec22() {
    const list = {};
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.enter).common, (state, dispatch)=>{
        const datePlugin = (0, $8A5oa.getPluginState)(state);
        const isDateNode = state.selection instanceof (0, $801jp.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (!datePlugin.showDatePickerAt) {
            (0, $7ymzg.openDatePicker)()(state, dispatch);
            return true;
        }
        (0, $7ymzg.closeDatePicker)()(state, dispatch);
        return true;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.tab).common, (state, dispatch)=>{
        const datePlugin = (0, $8A5oa.getPluginState)(state);
        const isDateNode = state.selection instanceof (0, $801jp.NodeSelection) ? state.selection.node.type === state.schema.nodes.date : false;
        if (!isDateNode) return false;
        if (datePlugin.showDatePickerAt) {
            (0, $7ymzg.focusDateInput)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $1tkqg.keymap)(list);
}
var $80489e9525864913$export$2e2bcd8739ae039 = $80489e9525864913$export$e832373cff8dec22;

});
parcelRegister("8A5oa", function(module, exports) {
$parcel$export(module.exports, "getPluginState", () => $d1f8dc037ccd2a2f$export$f05434c51e3762e);
$parcel$export(module.exports, "default", () => $d1f8dc037ccd2a2f$export$2e2bcd8739ae039);

var $1y7gE = parcelRequire("1y7gE");

var $92jIL = parcelRequire("92jIL");

var $bF0wY = parcelRequire("bF0wY");

var $d95H3 = parcelRequire("d95H3");

var $aE4bo = parcelRequire("aE4bo");
const $d1f8dc037ccd2a2f$var$dest = (0, $92jIL.pluginFactory)((0, $d95H3.pluginKey), (0, $aE4bo.reducer), {
    mapping: $aE4bo.mapping,
    onSelectionChanged: $aE4bo.onSelectionChanged
});
const $d1f8dc037ccd2a2f$var$createPluginState = $d1f8dc037ccd2a2f$var$dest.createPluginState;
const $d1f8dc037ccd2a2f$export$f05434c51e3762e = $d1f8dc037ccd2a2f$var$dest.getPluginState;
const $d1f8dc037ccd2a2f$var$createPlugin = (pmPluginFactoryParams)=>{
    const { dispatch: dispatch } = pmPluginFactoryParams;
    const newPluginState = {
        showDatePickerAt: null,
        isNew: false,
        isDateEmpty: false,
        focusDateInput: false,
        isInitialised: true
    };
    return new (0, $1y7gE.SafePlugin)({
        state: $d1f8dc037ccd2a2f$var$createPluginState(dispatch, newPluginState),
        key: (0, $d95H3.pluginKey),
        props: {
            nodeViews: {
                date: (node, view, getPos, decorations)=>{
                    return new (0, $bF0wY.DateNodeView)(node, view, getPos, pmPluginFactoryParams.getIntl(), decorations);
                }
            }
        }
    });
};
var $d1f8dc037ccd2a2f$export$2e2bcd8739ae039 = $d1f8dc037ccd2a2f$var$createPlugin;

});
parcelRegister("bF0wY", function(module, exports) {
$parcel$export(module.exports, "DateNodeView", () => $4cfe9601cb2e7c3c$export$9e959fa2f3aa27d3);

var $7H6Cr = parcelRequire("7H6Cr");

var $7ymzg = parcelRequire("7ymzg");

var $imaaz = parcelRequire("imaaz");
class $4cfe9601cb2e7c3c$export$9e959fa2f3aa27d3 {
    /**
   *
   * @param node
   * @param view
   * @param getPos
   * @param intl
   * @param decorations
   * @example
   */ constructor(node, view, getPos, intl, decorations){
        this.parentTaskState = '';
        this.node = node;
        this.intl = intl;
        this.view = view;
        this.getPos = getPos;
        const spec = (0, $imaaz.dateToDOM)(node, this.view.state, this.getPos, this.intl);
        const { dom: dom } = (0, $7H6Cr.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom.addEventListener('click', (event)=>{
            event.stopImmediatePropagation();
            const { state: state, dispatch: dispatch } = this.view;
            (0, $7ymzg.setDatePickerAt)(state.selection.from)(state, dispatch);
        });
        this.parentTaskState = $4cfe9601cb2e7c3c$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
    }
    /**
   *
   * @param node
   * @param decorations
   * @example
   */ update(node, decorations) {
        // we're only interested in two scenarios to trigger a DOM update:
        // 		1. the date value (timestamp) has changed
        // 		2. A wrapping taskitem state (if present) has changed
        // in all other cases, we tell prosemirror to ignore DOM updates
        // if new changes are added to the DOM structure, they will need to be
        // coded here
        const hasDateChanged = node.attrs.timestamp !== this.node.attrs.timestamp;
        const parentTaskState = $4cfe9601cb2e7c3c$export$9e959fa2f3aa27d3.getParentTaskState(decorations);
        const parentTaskStateChanged = parentTaskState !== this.parentTaskState;
        // update local state after comparisons ...
        this.parentTaskState = parentTaskState;
        this.node = node;
        const skipProseMirrorDomUpdate = !hasDateChanged && !parentTaskStateChanged;
        return skipProseMirrorDomUpdate;
    }
    static getParentTaskState(decorations) {
        var _parentTaskDecoration;
        const parentTaskDecoration = decorations.find((d)=>{
            return d.spec.dataTaskNodeCheckState !== undefined;
        });
        return (parentTaskDecoration === null || parentTaskDecoration === void 0 || (_parentTaskDecoration = parentTaskDecoration.spec) === null || _parentTaskDecoration === void 0 ? void 0 : _parentTaskDecoration.dataTaskNodeCheckState) ?? '';
    }
}

});
parcelRegister("imaaz", function(module, exports) {
$parcel$export(module.exports, "dateToDOM", () => $7990b850c7ae45ed$export$3bf4edf3398258cf);

var $hzT1C = parcelRequire("hzT1C");

var $dqFZv = parcelRequire("dqFZv");

var $kqiw5 = parcelRequire("kqiw5");

var $gR9lL = parcelRequire("gR9lL");

var $jWgCZ = parcelRequire("jWgCZ");

var $dRkX9 = parcelRequire("dRkX9");

var $ioyil = parcelRequire("ioyil");
let $7990b850c7ae45ed$var$intlRef;
const $7990b850c7ae45ed$export$dfa8d249b3ff4cf7 = (node)=>{
    $7990b850c7ae45ed$var$intlRef = $7990b850c7ae45ed$var$intlRef || (0, $hzT1C.createIntl)({
        locale: document.documentElement.lang || 'en-US'
    });
    const timestamp = node.attrs.timestamp;
    const displayString = (0, $gR9lL.timestampToString)(timestamp, $7990b850c7ae45ed$var$intlRef);
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        'aria-busy': 'true'
    };
    const attrs = {
        style: (0, $kqiw5.convertToInlineCss)({
            // Taken from @atlaskit/date Component
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            color: "var(--ds-text, #292A2E)",
            borderRadius: "var(--ds-radius-small, 4px)",
            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
            margin: '0 1px'
        })
    };
    return [
        'span',
        wrapperAttrs,
        [
            'span',
            attrs,
            displayString
        ]
    ];
};
const $7990b850c7ae45ed$export$3bf4edf3398258cf = (node, state, getPos, intl)=>{
    const timestamp = node.attrs.timestamp;
    const pos = getPos === null || getPos === void 0 ? void 0 : getPos();
    const { displayString: displayString, color: color } = (0, $ioyil.getDateInformation)(timestamp, intl, state, pos);
    const nodeWrapperAttrs = {
        contenteditable: 'false',
        timestamp: timestamp,
        class: 'dateView-content-wrap inlineNodeView',
        'data-prosemirror-content-type': 'node',
        'data-prosemirror-node-name': 'date',
        'data-prosemirror-node-inline': 'true',
        'data-node-type': 'date',
        'data-timestamp': timestamp,
        draggable: 'true'
    };
    if ((0, $dRkX9.fg)('platform_editor_adf_with_localid')) nodeWrapperAttrs['data-local-id'] = node.attrs.localId;
    const wrapperAttrs = {
        class: 'date-lozenger-container',
        'data-node-type': 'date',
        'data-timestamp': timestamp
    };
    const attrs = {
        class: !color ? '' : `date-node-color-${color}`,
        style: `white-space: unset`
    };
    return [
        'span',
        nodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $jWgCZ.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            wrapperAttrs,
            [
                'span',
                attrs,
                displayString
            ]
        ],
        (0, $dqFZv.getBrowserInfo)().android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $jWgCZ.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};

});
parcelRegister("ioyil", function(module, exports) {
$parcel$export(module.exports, "getDateInformation", () => $8795e5af0db3b117$export$55a93796ef2674d);

var $gR9lL = parcelRequire("gR9lL");

var $a4TQr = parcelRequire("a4TQr");
const $8795e5af0db3b117$export$55a93796ef2674d = (timestamp, intl, state, pos)=>{
    if (!state) return {
        color: undefined,
        displayString: (0, $gR9lL.timestampToString)(timestamp, intl)
    };
    const { doc: doc, selection: selection } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    // We fall back to selection.$from even though it does not cover all use cases
    // eg. upon Editor init, selection is at the start, not at the Date node
    const $nodePos = typeof pos === 'number' ? doc.resolve(pos) : selection.$from;
    const parent = $nodePos.parent;
    let withinIncompleteTask = parent.type === taskItem && parent.attrs.state !== 'DONE';
    // If there is blockTaskItem in the schema and it's not nested in an incomplete task item,
    // check if it's nested in an incomplete block task item
    if (blockTaskItem && !withinIncompleteTask) {
        const blockTaskItemParent = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($nodePos, blockTaskItem);
        // If nested in a blockTaskItem that is incomplete
        if (blockTaskItemParent) withinIncompleteTask = blockTaskItemParent.node.attrs.state !== 'DONE';
    }
    const color = withinIncompleteTask && (0, $gR9lL.isPastDate)(timestamp) ? 'red' : undefined;
    const displayString = withinIncompleteTask ? (0, $gR9lL.timestampToTaskContext)(timestamp, intl) : (0, $gR9lL.timestampToString)(timestamp, intl);
    return {
        displayString: displayString,
        color: color
    };
};

});



parcelRegister("aE4bo", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $1fb7adf859b0f865$export$1650419e431d3ba3);
$parcel$export(module.exports, "mapping", () => $1fb7adf859b0f865$export$83e1f26587c4acd2);
$parcel$export(module.exports, "onSelectionChanged", () => $1fb7adf859b0f865$export$8a0edcfd4a8a0397);

var $801jp = parcelRequire("801jp");
function $1fb7adf859b0f865$export$1650419e431d3ba3(pluginState, meta) {
    // If the same nodeview is clicked twice, calendar should close
    if (meta.showDatePickerAt === pluginState.showDatePickerAt) return {
        ...pluginState,
        showDatePickerAt: null
    };
    const { showDatePickerAt: showDatePickerAt, isNew: isNew } = pluginState;
    const { showDatePickerAt: showDatePickerAtMeta } = meta;
    // If date picker position has changed, it is no longer new
    if (showDatePickerAt && showDatePickerAtMeta && showDatePickerAt !== showDatePickerAtMeta && isNew) return {
        ...pluginState,
        ...meta,
        isNew: false
    };
    return {
        ...pluginState,
        ...meta
    };
}
function $1fb7adf859b0f865$export$83e1f26587c4acd2(tr, pluginState) {
    if (!pluginState.showDatePickerAt) return pluginState;
    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.showDatePickerAt);
    return {
        showDatePickerAt: deleted ? null : pos,
        isNew: pluginState.isNew,
        isDateEmpty: pluginState.isDateEmpty,
        focusDateInput: pluginState.focusDateInput,
        isInitialised: pluginState.isInitialised
    };
}
function $1fb7adf859b0f865$export$8a0edcfd4a8a0397(tr, pluginState) {
    if (tr.docChanged && $1fb7adf859b0f865$var$isDateNodeSelection(tr.selection)) return {
        ...pluginState,
        isQuickInsertAction: false,
        showDatePickerAt: tr.selection.from
    };
    else if (!$1fb7adf859b0f865$var$isDateNodeSelection(tr.selection) && !pluginState.isQuickInsertAction) {
        if (pluginState.showDatePickerAt) return {
            showDatePickerAt: null,
            isNew: false,
            isDateEmpty: false,
            focusDateInput: false,
            isInitialised: true
        };
        return pluginState;
    }
    return pluginState;
}
const $1fb7adf859b0f865$var$isDateNodeSelection = (selection)=>{
    if (selection instanceof (0, $801jp.NodeSelection)) {
        const nodeTypeName = selection.node.type.name;
        return nodeTypeName === 'date';
    }
    return false;
};

});



parcelRegister("5twHi", function(module, exports) {
$parcel$export(module.exports, "getDateQuickInsertComponents", () => $e11461eb50afb4a3$export$e10c9b6465ac6d4a);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cT0LQ = parcelRequire("cT0LQ");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $3EuFg = parcelRequire("3EuFg");
const $e11461eb50afb4a3$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNK.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJO.png'
};
const $e11461eb50afb4a3$export$e10c9b6465ac6d4a = ({ api: api })=>[
        {
            key: (0, $hI3gt.DATE_MENU_ITEM).key,
            type: (0, $hI3gt.DATE_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $hI3gt.STRUCTURE_SECTION).key,
                    type: (0, $hI3gt.STRUCTURE_SECTION).type,
                    rank: (0, $4jXgF.STRUCTURE_SECTION_RANK)[(0, $hI3gt.DATE_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).dateDescription),
                    keywords: [
                        'calendar',
                        'day',
                        'time',
                        'today',
                        '/'
                    ],
                    shortcut: '//',
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).date)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $3EuFg.DateQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $e11461eb50afb4a3$var$previewImageUrls
                })
        }
    ];

});
parcelRegister("3EuFg", function(module, exports) {
$parcel$export(module.exports, "DateQuickInsertMenuItem", () => $0609dd852aac21a4$export$972b9154c8ac4509);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $3M4Vk = parcelRequire("3M4Vk");

var $7MNh1 = parcelRequire("7MNh1");

var $7ymzg = parcelRequire("7ymzg");
const $0609dd852aac21a4$export$972b9154c8ac4509 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const preview = (0, $fc4bM.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $3M4Vk.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $fc4bM.useCallback)(({ insert: insert, source: source })=>{
        var _api$analytics, _api$analytics$attach;
        const tr = (0, $7ymzg.createDateAtTransaction)(true)(insert(undefined));
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || (_api$analytics$attach = _api$analytics.attachAnalyticsEvent) === null || _api$analytics$attach === void 0 || _api$analytics$attach.call(_api$analytics, {
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).DATE,
            attributes: {
                inputMethod: source ?? (0, $3LeME.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).dateDescription),
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7MNh1))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: "//",
        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).date)
    });
};

});


parcelRegister("7IBJu", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("cs6V2"),
    $9dnsd("9GJkG")
]).then(()=>parcelRequire('e7nsb'));

});
parcelRegister("9dnsd", function(module, exports) {
"use strict";

function $6b57856c7829fee2$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5WWY2")).resolve(id));
}
module.exports = $6b57856c7829fee2$var$load;

});
parcelRegister("5WWY2", function(module, exports) {
$parcel$export(module.exports, "register", () => $45501c3954b19655$export$6503ec6e8aabbaf, (v) => $45501c3954b19655$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $45501c3954b19655$export$f7ad0328861e2f03, (v) => $45501c3954b19655$export$f7ad0328861e2f03 = v);
var $45501c3954b19655$export$6503ec6e8aabbaf;
var $45501c3954b19655$export$f7ad0328861e2f03;
"use strict";
var $45501c3954b19655$var$mapping = new Map();
function $45501c3954b19655$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$45501c3954b19655$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $45501c3954b19655$var$resolve(id) {
    var resolved = $45501c3954b19655$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$45501c3954b19655$export$6503ec6e8aabbaf = $45501c3954b19655$var$register;
$45501c3954b19655$export$f7ad0328861e2f03 = $45501c3954b19655$var$resolve;

});




parcelRegister("kUy3d", function(module, exports) {
$parcel$export(module.exports, "expandPlugin", () => $37d3eb933742f186$export$a4a90f0c2a6f7a01);

var $aEmSo = parcelRequire("aEmSo");

var $gZeX6 = parcelRequire("gZeX6");

var $2ZKgI = parcelRequire("2ZKgI");
const $37d3eb933742f186$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    if (options !== null && options !== void 0 && options.__livePage) return (0, $2ZKgI.expandPlugin)({
        config: options,
        api: api
    });
    else {
        if ((0, $aEmSo.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) return (0, $2ZKgI.expandPlugin)({
            config: options,
            api: api
        });
        else return (0, $gZeX6.expandPlugin)({
            config: options,
            api: api
        });
    }
};

});
parcelRegister("gZeX6", function(module, exports) {
$parcel$export(module.exports, "expandPlugin", () => $b7496d9aabc371a1$export$a4a90f0c2a6f7a01);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $l5yqo = parcelRequire("l5yqo");

var $flh6x = parcelRequire("flh6x");

var $3LeME = parcelRequire("3LeME");

var $7vlqQ = parcelRequire("7vlqQ");

var $bMe57 = parcelRequire("bMe57");

var $c2wgC = parcelRequire("c2wgC");

var $cT0LQ = parcelRequire("cT0LQ");

var $hDZNR = parcelRequire("hDZNR");

var $bcN2K = parcelRequire("bcN2K");

var $hIUTz = parcelRequire("hIUTz");

var $8jk8H = parcelRequire("8jk8H");

var $hUKcO = parcelRequire("hUKcO");

var $gDcAJ = parcelRequire("gDcAJ");

var $3gx45 = parcelRequire("3gx45");

var $85b34 = parcelRequire("85b34");

var $jkG8w = parcelRequire("jkG8w");
const $b7496d9aabc371a1$var$EXPAND_NODE_NAME = 'expand';
const $b7496d9aabc371a1$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    var _api$blockMenu, _api$analytics, _api$analytics2;
    const isRegisteredSlashCommandEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command');
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $bMe57.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $bMe57.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $c2wgC.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $bMe57.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $8jk8H.createExpandBlockMenuItem)(api),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($b7496d9aabc371a1$var$EXPAND_NODE_NAME));
            }
        }
    ]);
    if (isRegisteredSlashCommandEnabled && options.allowInsertion === true) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $hUKcO.getExpandQuickInsertComponents)({
            api: api,
            isLegacy: true
        }));
    }
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $l5yqo.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $flh6x.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $gDcAJ.insertExpand)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions),
            insertExpandWithInputMethod: (0, $gDcAJ.insertExpandWithInputMethod)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $gDcAJ.toggleExpandWithMatch)(selection),
            toggleExpandRange: $hIUTz.toggleExpandRange
        },
        getSharedState () {
            return {
                allowInsertion: (options === null || options === void 0 ? void 0 : options.allowInsertion) ?? true
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $85b34.createPlugin)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $3gx45.expandKeymap)(api, {
                            __livePage: options.__livePage
                        })
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $jkG8w.getToolbarConfig)(api),
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    if (options && options.allowInsertion !== true) return [];
                    return [
                        {
                            id: 'expand',
                            title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expand),
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expandDescription),
                            keywords: [
                                'accordion',
                                'collapse'
                            ],
                            priority: 600,
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconExpand), {}),
                            action (insert, state) {
                                var _api$analytics3;
                                const node = (0, $gDcAJ.createExpandNode)(state);
                                if (!node) return false;
                                const tr = state.selection.empty ? insert(node) : (0, $hDZNR.createWrapSelectionTransaction)({
                                    state: state,
                                    type: node.type
                                });
                                api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || _api$analytics3.actions.attachAnalyticsEvent({
                                    action: (0, $3LeME.ACTION).INSERTED,
                                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $3LeME.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $3LeME.ACTION_SUBJECT_ID).EXPAND,
                                    attributes: {
                                        inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ];
                }
            }
        }
    };
};

});
parcelRegister("8jk8H", function(module, exports) {
$parcel$export(module.exports, "createExpandBlockMenuItem", () => $bf548567afcf042e$export$43e1eed033b6f3d3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $7otWv = parcelRequire("7otWv");

var $ji6wl = parcelRequire("ji6wl");
const $bf548567afcf042e$var$NODE_NAME = 'expand';
const $bf548567afcf042e$var$ExpandBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $3LeME.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.expand, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $bf548567afcf042e$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ji6wl))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expand)
    });
};
const $bf548567afcf042e$export$43e1eed033b6f3d3 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $3LM7S.jsx)($bf548567afcf042e$var$ExpandBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});
parcelRegister("ji6wl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cd8c6d9a48eb8c2ec1d5a30fec88d6dd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0b4c1a563eab387$var$_react = $e0b4c1a563eab387$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e0b4c1a563eab387$var$_iconNew = $e0b4c1a563eab387$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e0b4c1a563eab387$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ExpandElement".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/expand-element
 * Usage guidance:
 * Reserved for inserting expand elements in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0b4c1a563eab387$var$ExpandElementIcon = (props)=>/*#__PURE__*/ $e0b4c1a563eab387$var$_react.default.createElement($e0b4c1a563eab387$var$_iconNew.default, Object.assign({
        name: "ExpandElementIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h12v1.5H3a.5.5 0 0 0-.5.5v12H1z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.48 8.42 4.61 5.67l1.04-1.08L8 6.84l2.36-2.25 1.04 1.08-2.87 2.75a.75.75 0 0 1-1.04 0M15 12H4.5v-1.5H15zm0 3H4.5v-1.5H15z" clip-rule="evenodd"/>`
    }, props));
$e0b4c1a563eab387$var$ExpandElementIcon.displayName = 'ExpandElementIcon';
var $e0b4c1a563eab387$var$_default = module.exports.default = $e0b4c1a563eab387$var$ExpandElementIcon;

});


parcelRegister("hUKcO", function(module, exports) {
$parcel$export(module.exports, "getExpandQuickInsertComponents", () => $2f3d926418abdf6e$export$1d1b9ecd50e3e86c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cT0LQ = parcelRequire("cT0LQ");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $fe2EB = parcelRequire("fe2EB");
const $2f3d926418abdf6e$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKK.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH5.png'
};
const $2f3d926418abdf6e$export$1d1b9ecd50e3e86c = ({ api: api, isLegacy: isLegacy })=>[
        {
            key: (0, $hI3gt.EXPAND_MENU_ITEM).key,
            type: (0, $hI3gt.EXPAND_MENU_ITEM).type,
            parents: [
                {
                    ...(0, $hI3gt.STRUCTURE_SECTION),
                    rank: (0, $4jXgF.STRUCTURE_SECTION_RANK)[(0, $hI3gt.EXPAND_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expandDescription),
                    keywords: [
                        'accordion',
                        'collapse'
                    ],
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expand)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fe2EB.ExpandQuickInsertMenuItem), {
                    api: api,
                    isLegacy: isLegacy,
                    previewImageUrls: $2f3d926418abdf6e$var$previewImageUrls
                })
        }
    ];

});
parcelRegister("fe2EB", function(module, exports) {
$parcel$export(module.exports, "ExpandQuickInsertMenuItem", () => $330924da3e046817$export$cedec9fb8118a90);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $3M4Vk = parcelRequire("3M4Vk");

var $9oAqi = parcelRequire("9oAqi");

var $hDZNR = parcelRequire("hDZNR");

var $ji6wl = parcelRequire("ji6wl");

var $dRkX9 = parcelRequire("dRkX9");

var $gDcAJ = parcelRequire("gDcAJ");

var $sjpTk = parcelRequire("sjpTk");
const $330924da3e046817$export$cedec9fb8118a90 = ({ api: api, isLegacy: isLegacy, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const preview = (0, $fc4bM.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $3M4Vk.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const { editorDisabled: editorDisabled, mode: mode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'editorDisabled',
        'editorViewMode'
    ], (states)=>{
        var _states$editorDisable, _states$editorViewMod;
        return {
            editorDisabled: (_states$editorDisable = states.editorDisabledState) === null || _states$editorDisable === void 0 ? void 0 : _states$editorDisable.editorDisabled,
            mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
        };
    });
    const onSelect = (0, $fc4bM.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        var _api$analytics;
        const { state: state } = editorView;
        const node = isLegacy ? (0, $gDcAJ.createExpandNode)(state) : (0, $sjpTk.createExpandNode)(state, undefined, !!(api !== null && api !== void 0 && api.localId));
        if (!node) return false;
        const tr = state.selection.empty ? insert(node) : isLegacy || !(0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $hDZNR.createWrapSelectionTransaction)({
            state: state,
            type: node.type
        }) : (0, $sjpTk.wrapSelectionAndSetExpandedState)(state, node);
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $3LeME.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $3LeME.ACTION_SUBJECT_ID).EXPAND,
            attributes: {
                inputMethod: isLegacy ? (0, $3LeME.INPUT_METHOD).QUICK_INSERT : source
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api,
        isLegacy
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expandDescription),
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ji6wl))), {
            label: ""
        }),
        isDisabled: editorDisabled || mode === 'view',
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expand)
    });
};

});
parcelRegister("gDcAJ", function(module, exports) {
$parcel$export(module.exports, "setExpandRef", () => $512c9b935bfbc7d5$export$491ffa7e89016e5c);
$parcel$export(module.exports, "deleteExpandAtPos", () => $512c9b935bfbc7d5$export$ea222cb41be5bea0);
$parcel$export(module.exports, "deleteExpand", () => $512c9b935bfbc7d5$export$20123cb2952020ea);
$parcel$export(module.exports, "updateExpandTitle", () => $512c9b935bfbc7d5$export$87b459c5dfcbe773);
$parcel$export(module.exports, "toggleExpandExpanded", () => $512c9b935bfbc7d5$export$d94025373e8029d4);
$parcel$export(module.exports, "createExpandNode", () => $512c9b935bfbc7d5$export$b7c6a6a1365fc215);
$parcel$export(module.exports, "insertExpandWithInputMethod", () => $512c9b935bfbc7d5$export$4782944d4b10fd76);
$parcel$export(module.exports, "insertExpand", () => $512c9b935bfbc7d5$export$982de01464f3ba33);
$parcel$export(module.exports, "focusTitle", () => $512c9b935bfbc7d5$export$ec60d41a1ae79321);
$parcel$export(module.exports, "setSelectionInsideExpand", () => $512c9b935bfbc7d5$export$289c5ebc50d962d9);
$parcel$export(module.exports, "focusIcon", () => $512c9b935bfbc7d5$export$2837c3a55abaa285);
$parcel$export(module.exports, "toggleExpandWithMatch", () => $512c9b935bfbc7d5$export$6f1dc7179cebfcb1);

var $10F96 = parcelRequire("10F96");

var $3LeME = parcelRequire("3LeME");

var $1H8qk = parcelRequire("1H8qk");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $45eKC = parcelRequire("45eKC");

var $ebpUR = parcelRequire("ebpUR");

var $hDZNR = parcelRequire("hDZNR");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $5n2u9 = parcelRequire("5n2u9");

var $7IFYd = parcelRequire("7IFYd");

var $9IgeA = parcelRequire("9IgeA");
const $512c9b935bfbc7d5$export$491ffa7e89016e5c = (ref)=>(0, $9IgeA.createCommand)({
        type: 'SET_EXPAND_REF',
        data: {
            ref: ref
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $512c9b935bfbc7d5$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $3LeME.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $3LeME.ACTION_SUBJECT).EXPAND : (0, $3LeME.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $3LeME.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $801jp.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $512c9b935bfbc7d5$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $ebpUR.findExpand)(state);
        if (!expandNode) return false;
        return $512c9b935bfbc7d5$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $512c9b935bfbc7d5$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            if (__livePage) tr.step(new (0, $10F96.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                title: title
            }, node.marks);
            dispatch(tr);
        }
        return true;
    };
const $512c9b935bfbc7d5$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, nodeType: nodeType, __livePage: __livePage })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            const isExpandedNext = !node.attrs.__expanded;
            if (__livePage) tr.step(new (0, $10F96.SetAttrsStep)(pos, {
                ...node.attrs,
                __expanded: isExpandedNext
            }));
            else tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                __expanded: isExpandedNext
            }, node.marks);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (__livePage ? isExpandedNext === true : isExpandedNext === false && (0, $ebpUR.findExpand)(state)) tr.setSelection(new (0, $ihNBw.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $id3e6.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $3LeME.ACTION).TOGGLE_EXPAND,
                actionSubject: nodeType === state.schema.nodes.expand ? (0, $3LeME.ACTION_SUBJECT).EXPAND : (0, $3LeME.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $1H8qk.PLATFORMS).WEB,
                    mode: (0, $1H8qk.MODE).EDITOR,
                    expanded: __livePage ? !isExpandedNext : isExpandedNext
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
            // `isRemote` meta prevents this step from being
            // sync'd between sessions in synchrony collab edit
            tr.setMeta('isRemote', true);
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $512c9b935bfbc7d5$export$b7c6a6a1365fc215 = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const isSelectionInTable = !!(0, $5n2u9.findTable)(state.selection);
    const isSelectionInExpand = (0, $7IFYd.isNestedInExpand)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    return expandType.createAndFill({});
};
const $512c9b935bfbc7d5$export$4782944d4b10fd76 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $512c9b935bfbc7d5$export$b7c6a6a1365fc215(state);
            if (!expandNode) return false;
            const tr = state.selection.empty ? (0, $a4TQr.safeInsert)(expandNode)(state.tr).scrollIntoView() : (0, $hDZNR.createWrapSelectionTransaction)({
                state: state,
                type: expandNode.type
            });
            const payload = {
                action: (0, $3LeME.ACTION).INSERTED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (expandNode === null || expandNode === void 0 ? void 0 : expandNode.type) === state.schema.nodes.expand ? (0, $3LeME.ACTION_SUBJECT_ID).EXPAND : (0, $3LeME.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
            if (dispatch && expandNode) {
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $512c9b935bfbc7d5$export$982de01464f3ba33 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        return $512c9b935bfbc7d5$export$4782944d4b10fd76(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $512c9b935bfbc7d5$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const expandWrapper = (0, $7IFYd.getExpandWrapper)(editorView, pos);
            if (expandWrapper) {
                $512c9b935bfbc7d5$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $512c9b935bfbc7d5$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        const iconContainer = expand.querySelector(`.${(0, $45eKC.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView === null || editorView === void 0 || editorView.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $512c9b935bfbc7d5$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $801jp.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $512c9b935bfbc7d5$export$6f1dc7179cebfcb1 = (_selection)=>({ tr: _tr })=>{
        // this action exists so that we can keep the plugin types consistent across the
        // the legacy expand plugin and the single player expand plugin until
        // we will remove the legacy expand plugin
        return null;
    };

});
parcelRegister("ebpUR", function(module, exports) {
$parcel$export(module.exports, "findExpand", () => $5824c8e4008fbd86$export$fd7bf9c73fdd6f30);

var $a4TQr = parcelRequire("a4TQr");
const $5824c8e4008fbd86$export$fd7bf9c73fdd6f30 = (state, selection)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $a4TQr.findSelectedNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection) || (0, $a4TQr.findParentNodeOfType)([
        expand,
        nestedExpand
    ])(selection || state.selection);
};

});

parcelRegister("7IFYd", function(module, exports) {
$parcel$export(module.exports, "isNestedInExpand", () => $10369c2111f1a182$export$62b7afc61dbab067);
$parcel$export(module.exports, "getExpandWrapper", () => $10369c2111f1a182$export$41eae0df603dc01f);
$parcel$export(module.exports, "getExpandTitleInput", () => $10369c2111f1a182$export$4f5d6f53605ae186);

var $a4TQr = parcelRequire("a4TQr");
const $10369c2111f1a182$export$62b7afc61dbab067 = (state)=>(0, $a4TQr.hasParentNode)((node)=>node.type === state.schema.nodes.expand || node.type === state.schema.nodes.nestedExpand)(state.selection);
const $10369c2111f1a182$export$41eae0df603dc01f = (editorView, pos)=>editorView.domAtPos(pos).node.parentElement;
const $10369c2111f1a182$export$4f5d6f53605ae186 = (editorView, pos)=>{
    var _getExpandWrapper;
    return ((_getExpandWrapper = $10369c2111f1a182$export$41eae0df603dc01f(editorView, pos)) === null || _getExpandWrapper === void 0 ? void 0 : _getExpandWrapper.querySelector('input')) ?? null;
};

});

parcelRegister("9IgeA", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $ce3433fe2d6f699a$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $ce3433fe2d6f699a$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $ce3433fe2d6f699a$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $ce3433fe2d6f699a$export$f05434c51e3762e);

var $92jIL = parcelRequire("92jIL");

var $801jp = parcelRequire("801jp");

var $7Zm6Z = parcelRequire("7Zm6Z");
const $ce3433fe2d6f699a$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('expandPlugin');
const $ce3433fe2d6f699a$var$dest = (0, $92jIL.pluginFactory)($ce3433fe2d6f699a$export$18d4026d1ea86bb1, (0, $7Zm6Z.default));
const $ce3433fe2d6f699a$export$656c7661095efe2e = $ce3433fe2d6f699a$var$dest.createPluginState;
const $ce3433fe2d6f699a$export$8d4021544bdece00 = $ce3433fe2d6f699a$var$dest.createCommand;
const $ce3433fe2d6f699a$export$f05434c51e3762e = $ce3433fe2d6f699a$var$dest.getPluginState;

});
parcelRegister("7Zm6Z", function(module, exports) {
$parcel$export(module.exports, "default", () => $d346079a4c03df6a$export$2e2bcd8739ae039);
var $d346079a4c03df6a$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'SET_EXPAND_REF':
            return {
                ...pluginState,
                expandRef: action.data.ref
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("sjpTk", function(module, exports) {
$parcel$export(module.exports, "createExpandNode", () => $ea6315344ab268f2$export$b7c6a6a1365fc215);
$parcel$export(module.exports, "wrapSelectionAndSetExpandedState", () => $ea6315344ab268f2$export$b07fdfa9172394f4);
$parcel$export(module.exports, "insertExpandWithInputMethod", () => $ea6315344ab268f2$export$4782944d4b10fd76);
$parcel$export(module.exports, "insertExpand", () => $ea6315344ab268f2$export$982de01464f3ba33);
$parcel$export(module.exports, "deleteExpand", () => $ea6315344ab268f2$export$20123cb2952020ea);
$parcel$export(module.exports, "setSelectionInsideExpand", () => $ea6315344ab268f2$export$289c5ebc50d962d9);
$parcel$export(module.exports, "toggleExpandExpanded", () => $ea6315344ab268f2$export$d94025373e8029d4);
$parcel$export(module.exports, "updateExpandTitle", () => $ea6315344ab268f2$export$87b459c5dfcbe773);
$parcel$export(module.exports, "focusTitle", () => $ea6315344ab268f2$export$ec60d41a1ae79321);
$parcel$export(module.exports, "focusIcon", () => $ea6315344ab268f2$export$2837c3a55abaa285);
$parcel$export(module.exports, "toggleExpandWithMatch", () => $ea6315344ab268f2$export$6f1dc7179cebfcb1);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eUgRu = parcelRequire("eUgRu");

var $10F96 = parcelRequire("10F96");

var $3LeME = parcelRequire("3LeME");

var $1H8qk = parcelRequire("1H8qk");

var $hIUTz = parcelRequire("hIUTz");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $45eKC = parcelRequire("45eKC");

var $ebpUR = parcelRequire("ebpUR");

var $hDZNR = parcelRequire("hDZNR");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $5n2u9 = parcelRequire("5n2u9");

var $dRkX9 = parcelRequire("dRkX9");

var $7IFYd = parcelRequire("7IFYd");
const $ea6315344ab268f2$export$b7c6a6a1365fc215 = (state, setExpandedState = true, addLocalId)=>{
    const { expand: expand, nestedExpand: nestedExpand, paragraph: paragraph } = state.schema.nodes;
    const isSelectionInTable = !!(0, $5n2u9.findTable)(state.selection);
    const isSelectionInExpand = (0, $7IFYd.isNestedInExpand)(state);
    const expandType = isSelectionInTable || isSelectionInExpand ? nestedExpand : expand;
    const expandNode = (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? expandType.createAndFill(addLocalId ? {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        localId: (0, $eUgRu.default)()
    } : {}, // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    paragraph.createAndFill(addLocalId ? {
        localId: (0, $eUgRu.default)()
    } : {})) : expandType.createAndFill({});
    if (setExpandedState) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hIUTz.expandedState).set(expandNode, true);
    return expandNode;
};
const $ea6315344ab268f2$export$b07fdfa9172394f4 = (state, node)=>{
    const tr = (0, $hDZNR.createWrapSelectionTransaction)({
        state: state,
        type: node.type,
        nodeAttributes: node.attrs
    });
    const wrapperNode = (0, $a4TQr.findParentNodeOfType)(node.type)(tr.selection);
    if (wrapperNode) (0, $hIUTz.expandedState).set(wrapperNode.node, true);
    return tr;
};
const $ea6315344ab268f2$export$4782944d4b10fd76 = (api)=>(inputMethod)=>(state, dispatch)=>{
            const expandNode = $ea6315344ab268f2$export$b7c6a6a1365fc215(state, false, !!(api !== null && api !== void 0 && api.localId));
            if (!expandNode) return false;
            let tr;
            if (state.selection.empty) {
                tr = (0, $a4TQr.safeInsert)(expandNode)(state.tr).scrollIntoView();
                (0, $hIUTz.expandedState).set(expandNode, true);
            } else {
                tr = (0, $hDZNR.createWrapSelectionTransaction)({
                    state: state,
                    type: expandNode.type,
                    ...(0, $dRkX9.fg)('platform_editor_adf_with_localid') && {
                        nodeAttributes: expandNode.attrs
                    }
                });
                const wrapperNode = (0, $a4TQr.findParentNodeOfType)(expandNode.type)(tr.selection);
                if (wrapperNode) (0, $hIUTz.expandedState).set(wrapperNode.node, true);
            }
            const payload = {
                action: (0, $3LeME.ACTION).INSERTED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (expandNode === null || expandNode === void 0 ? void 0 : expandNode.type) === state.schema.nodes.expand ? (0, $3LeME.ACTION_SUBJECT_ID).EXPAND : (0, $3LeME.ACTION_SUBJECT_ID).NESTED_EXPAND,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
            if (dispatch) {
                var _api$analytics;
                api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent(payload)(tr);
                dispatch(tr);
            }
            return true;
        };
const $ea6315344ab268f2$export$982de01464f3ba33 = (api)=>(state, dispatch)=>{
        return $ea6315344ab268f2$export$4782944d4b10fd76(api)((0, $3LeME.INPUT_METHOD).INSERT_MENU)(state, dispatch);
    };
const $ea6315344ab268f2$export$20123cb2952020ea = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const expandNode = (0, $ebpUR.findExpand)(state);
        if (!expandNode) return false;
        return $ea6315344ab268f2$export$ea222cb41be5bea0(editorAnalyticsAPI)(expandNode.pos, expandNode.node)(state, dispatch);
    };
const $ea6315344ab268f2$export$ea222cb41be5bea0 = (editorAnalyticsAPI)=>(expandNodePos, expandNode)=>(state, dispatch)=>{
            if (!expandNode || isNaN(expandNodePos)) return false;
            const payload = {
                action: (0, $3LeME.ACTION).DELETED,
                actionSubject: expandNode.type === state.schema.nodes.expand ? (0, $3LeME.ACTION_SUBJECT).EXPAND : (0, $3LeME.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    inputMethod: (0, $3LeME.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
            if (expandNode && dispatch) {
                const { tr: tr } = state;
                tr.delete(expandNodePos, expandNodePos + expandNode.nodeSize);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
                if (expandNode.type === state.schema.nodes.nestedExpand) {
                    const resolvedPos = tr.doc.resolve(expandNodePos + 1);
                    if (resolvedPos) tr.setSelection((0, $801jp.Selection).near(resolvedPos, -1));
                }
                dispatch(tr);
            }
            return true;
        };
const $ea6315344ab268f2$export$289c5ebc50d962d9 = (expandPos)=>(_state, dispatch, editorView)=>{
        if (editorView) {
            if (!editorView.hasFocus()) editorView.focus();
            const sel = (0, $801jp.Selection).findFrom(editorView.state.doc.resolve(expandPos), 1, true);
            if (sel && dispatch) dispatch(editorView.state.tr.setSelection(sel));
            return true;
        }
        return false;
    };
const $ea6315344ab268f2$export$d94025373e8029d4 = ({ editorAnalyticsAPI: editorAnalyticsAPI, pos: pos, node: node })=>(state, dispatch)=>{
        if (node && dispatch) {
            const { tr: tr } = state;
            const expanded = (0, $hIUTz.expandedState).get(node) ?? false;
            const isExpandedNext = !expanded;
            (0, $hIUTz.expandedState).set(node, isExpandedNext);
            // If we're going to collapse the expand and our cursor is currently inside
            // Move to a right gap cursor, if the toolbar is interacted (or an API),
            // it will insert below rather than inside (which will be invisible).
            if (isExpandedNext === true) tr.setSelection(new (0, $ihNBw.GapCursorSelection)(tr.doc.resolve(pos + node.nodeSize), (0, $id3e6.Side).RIGHT));
            // log when people open/close expands
            // TODO: ED-8523 - make platform/mode global attributes?
            const payload = {
                action: (0, $3LeME.ACTION).TOGGLE_EXPAND,
                actionSubject: node.type === state.schema.nodes.expand ? (0, $3LeME.ACTION_SUBJECT).EXPAND : (0, $3LeME.ACTION_SUBJECT).NESTED_EXPAND,
                attributes: {
                    platform: (0, $1H8qk.PLATFORMS).WEB,
                    mode: (0, $1H8qk.MODE).EDITOR,
                    expanded: isExpandedNext
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
            tr.setMeta('scrollIntoView', false);
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    };
const $ea6315344ab268f2$export$87b459c5dfcbe773 = ({ title: title, nodeType: nodeType, pos: pos })=>(state, dispatch)=>{
        const node = state.doc.nodeAt(pos);
        if (node && node.type === nodeType && dispatch) {
            const { tr: tr } = state;
            tr.step(new (0, $10F96.SetAttrsStep)(pos, {
                ...node.attrs,
                title: title
            }));
            dispatch(tr);
        }
        return true;
    };
const $ea6315344ab268f2$export$ec60d41a1ae79321 = (pos)=>(state, dispatch, editorView)=>{
        if (editorView) {
            const expandWrapper = (0, $7IFYd.getExpandWrapper)(editorView, pos);
            if (expandWrapper) {
                $ea6315344ab268f2$export$289c5ebc50d962d9(pos)(state, dispatch, editorView);
                const input = expandWrapper.querySelector('input');
                if (input) {
                    input.focus();
                    return true;
                }
            }
        }
        return false;
    };
const $ea6315344ab268f2$export$2837c3a55abaa285 = (expand)=>(state, dispatch, editorView)=>{
        if (!(expand instanceof HTMLElement)) return false;
        const iconContainer = expand.querySelector(`.${(0, $45eKC.expandClassNames).iconContainer}`);
        if (iconContainer && iconContainer.focus) {
            const { tr: tr } = state;
            const pos = state.selection.from;
            tr.setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve(pos)));
            if (dispatch) dispatch(tr);
            editorView === null || editorView === void 0 || editorView.dom.blur();
            iconContainer.focus();
            return true;
        }
        return false;
    };
const $ea6315344ab268f2$export$6f1dc7179cebfcb1 = (selection)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        // if match is inside a nested expand, open the nested expand
        const nestedExpandNode = (0, $a4TQr.findParentNodeOfType)(nestedExpand)(selection);
        if (nestedExpandNode) {
            const expanded = (0, $hIUTz.expandedState).get(nestedExpandNode.node) ?? false;
            if (!expanded) (0, $hIUTz.expandedState).set(nestedExpandNode.node, true);
        }
        // if match is (also) inside an expand, open the expand
        const expandNode = (0, $a4TQr.findParentNodeOfType)(expand)(selection);
        if (expandNode) {
            const expanded = (0, $hIUTz.expandedState).get(expandNode.node) ?? false;
            if (!expanded) (0, $hIUTz.expandedState).set(expandNode.node, true);
        }
        return tr;
    };

});



parcelRegister("3gx45", function(module, exports) {
$parcel$export(module.exports, "expandKeymap", () => $b61917be232a3a19$export$e4ebafd8ecd98be0);

var $hIUTz = parcelRequire("hIUTz");

var $eUtBU = parcelRequire("eUtBU");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $apbCm = parcelRequire("apbCm");

var $ebpUR = parcelRequire("ebpUR");

var $39oqF = parcelRequire("39oqF");
var $13Ncu = parcelRequire("13Ncu");

var $1O8Lw = parcelRequire("1O8Lw");

var $801jp = parcelRequire("801jp");

var $auYrv = parcelRequire("auYrv");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $hNYkR = parcelRequire("hNYkR");

var $gDcAJ = parcelRequire("gDcAJ");
const $b61917be232a3a19$var$isExpandNode = (node)=>{
    return (node === null || node === void 0 ? void 0 : node.type.name) === 'expand' || (node === null || node === void 0 ? void 0 : node.type.name) === 'nestedExpand';
};
const $b61917be232a3a19$var$isExpandSelected = (selection)=>selection instanceof (0, $801jp.NodeSelection) && $b61917be232a3a19$var$isExpandNode(selection.node);
function $b61917be232a3a19$export$e4ebafd8ecd98be0(api, options) {
    const list = {};
    const isCollapsed = (expandNode)=>options.__livePage ? expandNode.attrs.__expanded : !expandNode.attrs.__expanded;
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveRight).common, (state, dispatch, editorView)=>{
        var _api$selection;
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = (api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 ? void 0 : _api$selection.sharedState.currentState()) || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($b61917be232a3a19$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $apbCm.RelativeSelectionPos).Start) return (0, $gDcAJ.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveLeft).common, (state, dispatch, editorView)=>{
        var _api$selection2;
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = (api === null || api === void 0 || (_api$selection2 = api.selection) === null || _api$selection2 === void 0 ? void 0 : _api$selection2.sharedState.currentState()) || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($b61917be232a3a19$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $apbCm.RelativeSelectionPos).End)) return (0, $gDcAJ.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($b61917be232a3a19$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $gDcAJ.focusIcon)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $801jp.TextSelection) && !(0, $auYrv.isInTable)(state)) {
                const expand = (0, $ebpUR.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $gDcAJ.focusIcon)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $ihNBw.GapCursorSelection) && selection.side === (0, $id3e6.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (options.__livePage ? nodeBefore.attrs.__expanded : !nodeBefore.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $gDcAJ.focusTitle)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $ebpUR.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $13Ncu.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $gDcAJ.focusTitle)(expand.start)(state, dispatch, editorView);
            const sel = (0, $801jp.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $ebpUR.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if (options.__livePage ? expandBefore.node.attrs.__expanded : !expandBefore.node.attrs.__expanded) return (0, $gDcAJ.focusTitle)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $ihNBw.GapCursorSelection) && selection.side === (0, $id3e6.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (options.__livePage ? nodeAfter.attrs.__expanded : !nodeAfter.attrs.__expanded)) {
            const { $from: $from } = selection;
            return (0, $gDcAJ.focusTitle)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $aEmSo.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $hIUTz.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $gDcAJ.focusTitle)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $gDcAJ.focusTitle)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $ebpUR.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $801jp.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $ebpUR.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && isCollapsed(expandBefore.node)) {
                if ((0, $dRkX9.fg)('platform_editor_expand_delete_empty_line') && (0, $hNYkR.deleteEmptyLineAfterCollapsedExpand)({
                    focusTitle: $gDcAJ.focusTitle,
                    isCollapsed: isCollapsed
                })(state, dispatch, editorView)) return true;
                return (0, $gDcAJ.focusTitle)(expandBefore.start)(state, dispatch, editorView);
            }
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$b61917be232a3a19$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $801jp.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $39oqF.isEmptyNode)(state.schema)(expandNode.node) && dispatch) {
            var _api$analytics;
            return (0, $gDcAJ.deleteExpand)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(state, dispatch);
        }
        return false;
    }, list);
    return (0, $1O8Lw.keymap)(list);
}

});
parcelRegister("hNYkR", function(module, exports) {
$parcel$export(module.exports, "deleteEmptyLineAfterCollapsedExpand", () => $c804a5f3d2e4d212$export$76e690b7ec440b84);

var $801jp = parcelRequire("801jp");

var $7IFYd = parcelRequire("7IFYd");
/**
 * The empty paragraph holding the caret, when its previous sibling is a collapsed expand or nested
 * expand and it is not the last child of its container. The last child is kept so there is always a
 * line to type in after the expand.
 */ const $c804a5f3d2e4d212$var$getEmptyLineAfterCollapsedExpand = (state, isCollapsed)=>{
    const { $from: $from } = state.selection;
    const { paragraph: paragraph, expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    const textblock = $from.parent;
    if (textblock.type !== paragraph || textblock.content.size > 0) return undefined;
    const container = $from.node(-1);
    const index = $from.index(-1);
    const isLastChild = index === container.childCount - 1;
    if (index === 0 || isLastChild) return undefined;
    const previousSibling = container.child(index - 1);
    const isExpand = previousSibling.type === expand || previousSibling.type === nestedExpand;
    if (!isExpand || !isCollapsed(previousSibling)) return undefined;
    const lineStart = $from.before();
    return {
        expandContentStart: lineStart - previousSibling.nodeSize + 1,
        lineStart: lineStart,
        lineEnd: $from.after()
    };
};
const $c804a5f3d2e4d212$export$76e690b7ec440b84 = ({ focusTitle: focusTitle, isCollapsed: isCollapsed })=>(state, dispatch, editorView)=>{
        if (!editorView || !state.selection.empty) return false;
        const emptyLine = $c804a5f3d2e4d212$var$getEmptyLineAfterCollapsedExpand(state, isCollapsed);
        if (!emptyLine) return false;
        const titleInput = (0, $7IFYd.getExpandTitleInput)(editorView, emptyLine.expandContentStart);
        if (!titleInput) return false;
        if (!dispatch) return true;
        const tr = state.tr.delete(emptyLine.lineStart, emptyLine.lineEnd);
        const selectionInsideExpand = (0, $801jp.Selection).findFrom(tr.doc.resolve(emptyLine.expandContentStart), 1, true);
        if (selectionInsideExpand) tr.setSelection(selectionInsideExpand);
        dispatch(tr);
        const titleInputAfterDelete = (0, $7IFYd.getExpandTitleInput)(editorView, emptyLine.expandContentStart);
        if (!(titleInputAfterDelete !== null && titleInputAfterDelete !== void 0 && titleInputAfterDelete.isConnected)) {
            focusTitle(emptyLine.expandContentStart)(editorView.state, dispatch, editorView);
            return true;
        }
        titleInputAfterDelete.focus();
        const titleEnd = titleInputAfterDelete.value.length;
        titleInputAfterDelete.setSelectionRange(titleEnd, titleEnd);
        return true;
    };

});


parcelRegister("85b34", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $d6b02be4864f0db3$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $6bnr9 = parcelRequire("6bnr9");

var $45eKC = parcelRequire("45eKC");

var $ebpUR = parcelRequire("ebpUR");
var $cecv2 = parcelRequire("cecv2");
var $hhFDR = parcelRequire("hhFDR");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $gDcAJ = parcelRequire("gDcAJ");

var $4mXIr = parcelRequire("4mXIr");

var $9IgeA = parcelRequire("9IgeA");
function $d6b02be4864f0db3$export$366b6d00a7e2683b(element, className) {
    var _element$classList;
    return Boolean(element === null || element === void 0 || (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.contains(className));
}
const $d6b02be4864f0db3$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const state = (0, $9IgeA.createPluginState)(dispatch, {});
    const isMobile = false;
    return new (0, $1y7gE.SafePlugin)({
        state: state,
        key: (0, $9IgeA.pluginKey),
        props: {
            nodeViews: {
                expand: (0, $4mXIr.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $4mXIr.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $d6b02be4864f0db3$export$366b6d00a7e2683b(event.target, (0, $45eKC.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $d6b02be4864f0db3$export$366b6d00a7e2683b(event.target, (0, $45eKC.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $d6b02be4864f0db3$export$366b6d00a7e2683b(document.activeElement, (0, $45eKC.expandClassNames).titleInput);
            },
            handleClickOn: (0, $6bnr9.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $45eKC.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, _moved) {
                return $d6b02be4864f0db3$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            // Preserve title editing against selection changes unless explicitly allowed.
            if ($d6b02be4864f0db3$export$366b6d00a7e2683b(document.activeElement, (0, $45eKC.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric) && !((0, $bcN2K.isExperimentEnabled)('platform_editor_remix_reliability_improvements') && tr.getMeta('allowSelectionChangeWhileExpandTitleFocused') === true)) return false;
            return true;
        },
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            return {
                update: (view)=>{
                    const { state: state, dispatch: dispatch } = view;
                    const node = (0, $ebpUR.findExpand)(state);
                    if (node) {
                        const expandRef = (0, $a4TQr.findDomRefAtPos)(node.pos, domAtPos);
                        if ((0, $9IgeA.getPluginState)(state).expandRef !== expandRef) (0, $gDcAJ.setExpandRef)(expandRef)(state, dispatch);
                    }
                }
            };
        }
    });
};
function $d6b02be4864f0db3$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $cecv2.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $hhFDR.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}

});
parcelRegister("cecv2", function(module, exports) {
$parcel$export(module.exports, "transformSliceExpandToNestedExpand", () => $921ba47450ba3c71$export$447e90e618548243);

var $7H6Cr = parcelRequire("7H6Cr");

var $c5vAC = parcelRequire("c5vAC");
const $921ba47450ba3c71$export$447e90e618548243 = (slice)=>{
    const children = [];
    try {
        (0, $c5vAC.mapChildren)(slice.content, (currentNode)=>{
            const { expand: expand, nestedExpand: nestedExpand } = currentNode.type.schema.nodes;
            if (currentNode.type === expand) {
                const nestedExpandNode = nestedExpand.createChecked(currentNode.attrs, currentNode.content, currentNode.marks);
                if (nestedExpandNode) children.push(nestedExpandNode);
            } else children.push(currentNode);
        });
    } catch (e) {
        // Will throw error if unable to convert expand to nested expand.
        // Example: expand containing a table being converted to nested expand containing table.
        return null;
    }
    return new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("4mXIr", function(module, exports) {
$parcel$export(module.exports, "default", () => $26efd5c4e957baf0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $hLBpb = parcelRequire("hLBpb");

var $5Amf8 = parcelRequire("5Amf8");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $apbCm = parcelRequire("apbCm");

var $45eKC = parcelRequire("45eKC");

var $62lW6 = parcelRequire("62lW6");

var $39oqF = parcelRequire("39oqF");

var $i5qTg = parcelRequire("i5qTg");

var $hCON4 = parcelRequire("hCON4");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $2IyCM = parcelRequire("2IyCM");

var $8KYsz = parcelRequire("8KYsz");

var $aEmSo = parcelRequire("aEmSo");

var $apws3 = parcelRequire("apws3");

var $gDcAJ = parcelRequire("gDcAJ");

var $hWTGb = parcelRequire("hWTGb");
function $26efd5c4e957baf0$var$buildExpandClassName(type, expanded) {
    return `${(0, $45eKC.expandClassNames).prefix} ${(0, $45eKC.expandClassNames).type(type)} ${expanded ? (0, $45eKC.expandClassNames).expanded : ''}`;
}
function $26efd5c4e957baf0$export$4bb8383fcf1d1fef(title, intl) {
    const safeTitle = title.trim() || (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyAriaLabelUntitled)) || (0, $62lW6.messages).expandBodyAriaLabelUntitled.defaultMessage;
    return (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyAriaLabel, {
        title: safeTitle
    })) || (0, $62lW6.messages).expandBodyAriaLabel.defaultMessage.replace('{title}', safeTitle);
}
const $26efd5c4e957baf0$var$toDOM = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $26efd5c4e957baf0$var$buildExpandClassName(node.type.name, __livePage ? !node.attrs.__expanded : node.attrs.__expanded),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $dRkX9.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $45eKC.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $45eKC.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $45eKC.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $45eKC.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $62lW6.messages).expandArialabel) || (0, $62lW6.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && intl.formatMessage((0, $62lW6.messages).expandPlaceholderText) || (0, $62lW6.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            (0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps') ? 'section' : 'div',
            {
                // prettier-ignore
                class: `${(0, $45eKC.expandClassNames).content} ${(__livePage ? !node.attrs.__expanded : node.attrs.__expanded) ? '' : (0, $45eKC.expandClassNames).contentCollapsed}`,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined,
                ...!((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps')) && {
                    role: 'textbox',
                    'aria-multiline': 'true',
                    'aria-label': intl && intl.formatMessage((0, $62lW6.messages).expandBodyAriaLabelOriginal) || (0, $62lW6.messages).expandBodyAriaLabelOriginal.defaultMessage
                },
                ...((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps')) && {
                    'aria-label': $26efd5c4e957baf0$export$4bb8383fcf1d1fef(node.attrs.title ?? '', intl),
                    'aria-description': (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyAriaDescription)) || (0, $62lW6.messages).expandBodyAriaDescription.defaultMessage,
                    'aria-roledescription': (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyRoleDescription)) ?? (0, $62lW6.messages).expandBodyRoleDescription.defaultMessage
                }
            },
            0
        ]
    ];
class $26efd5c4e957baf0$export$e6a0ba759c3724b0 {
    constructor(node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $apbCm.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $gDcAJ.setSelectionInsideExpand)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $hLBpb.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            const { state: state, dispatch: dispatch } = this.view;
            if ((0, $hCON4.closestElement)(target, `.${(0, $45eKC.expandClassNames).icon}`)) {
                var _this$api2;
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $gDcAJ.toggleExpandExpanded)({
                    editorAnalyticsAPI: (_this$api2 = this.api) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.analytics) === null || _this$api2 === void 0 ? void 0 : _this$api2.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $gDcAJ.updateExpandTitle)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            var _this$api3;
            this.decorationCleanup = (_this$api3 = this.api) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.selectionMarker) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.actions) === null || _this$api3 === void 0 ? void 0 : _this$api3.hideDecoration();
        };
        this.handleBlur = ()=>{
            var _this$decorationClean;
            (_this$decorationClean = this.decorationCleanup) === null || _this$decorationClean === void 0 || _this$decorationClean.call(this);
        };
        this.handleTitleKeydown = (event)=>{
            // Handle Ctrl+Shift+H to select the expand node for drag handle
            // Note: If changing this implementation in legacyExpand, please also update the implementation in singlePlayerExpand
            if ((0, $aEmSo.expValEquals)('platform_editor_dnd_accessibility_fixes_expand', 'isEnabled', true) && (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'H' || event.key === 'h')) {
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') {
                    // Blur the input first to remove focus from the title
                    if (this.input) this.input.blur();
                    // Use requestAnimationFrame to ensure blur completes before setting selection
                    requestAnimationFrame(()=>{
                        var _this$api4;
                        const { state: state } = this.view;
                        this.view.focus();
                        (_this$api4 = this.api) === null || _this$api4 === void 0 || _this$api4.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $801jp.NodeSelection).create(state.doc, pos));
                            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                                var _this$api5;
                                const command = (_this$api5 = this.api) === null || _this$api5 === void 0 || (_this$api5 = _this$api5.blockControls) === null || _this$api5 === void 0 ? void 0 : _this$api5.commands.showControlAtPosition(pos, (0, $5Amf8.BLOCK_CONTROLS_DRAG_HANDLE), {
                                    isFocused: true
                                });
                                if (command) return command({
                                    tr: tr
                                });
                                return null;
                            }
                            const node = state.doc.nodeAt(pos);
                            if (node) {
                                const dom = this.view.nodeDOM(pos);
                                if (dom instanceof HTMLElement) {
                                    const anchorName = dom.getAttribute('data-node-anchor');
                                    if (anchorName) {
                                        var _this$api6;
                                        const command = (_this$api6 = this.api) === null || _this$api6 === void 0 || (_this$api6 = _this$api6.blockControls) === null || _this$api6 === void 0 ? void 0 : _this$api6.commands.showDragHandleAt(pos, anchorName, node.type.name, {
                                            isFocused: true
                                        });
                                        if (command) return command({
                                            tr: tr
                                        });
                                    }
                                }
                            }
                            return null;
                        });
                    });
                }
                return;
            }
            const keyName_result = (0, $hLBpb.keyName)(event);
            switch(keyName_result){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $aEmSo.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteExpand(event);
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                key: event.key,
                code: event.code,
                metaKey: event.metaKey,
                ctrlKey: event.ctrlKey,
                altKey: event.altKey
            }));
        };
        this.deleteExpand = (_event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            const { state: state } = this.view;
            const expandNode = this.node;
            if (expandNode && (0, $39oqF.isEmptyNode)(state.schema)(expandNode)) {
                var _this$api7;
                (0, $gDcAJ.deleteExpandAtPos)((_this$api7 = this.api) === null || _this$api7 === void 0 || (_this$api7 = _this$api7.analytics) === null || _this$api7 === void 0 ? void 0 : _this$api7.actions)(pos, expandNode)(state, this.view.dispatch);
            }
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                var _this$api8;
                const { state: state, dispatch: dispatch } = this.view;
                (0, $gDcAJ.toggleExpandExpanded)({
                    editorAnalyticsAPI: (_this$api8 = this.api) === null || _this$api8 === void 0 || (_this$api8 = _this$api8.analytics) === null || _this$api8 === void 0 ? void 0 : _this$api8.actions,
                    pos: pos,
                    nodeType: this.node.type,
                    __livePage: this.__livePage
                })(state, dispatch);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $801jp.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            if (this.__livePage) return this.node.attrs.__expanded;
            return !this.node.attrs.__expanded;
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $ihNBw.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $id3e6.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $801jp.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $ihNBw.GapCursorSelection)(state.doc.resolve(pos), (0, $id3e6.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $apbCm.RelativeSelectionPos).End,
                    selection: (0, $801jp.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                var _this$api9;
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = ((_this$api9 = this.api) === null || _this$api9 === void 0 || (_this$api9 = _this$api9.selection) === null || _this$api9 === void 0 ? void 0 : _this$api9.sharedState.currentState()) || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if ((selectionSharedState === null || selectionSharedState === void 0 ? void 0 : selectionSharedState.selectionRelativeToNode) === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $ihNBw.GapCursorSelection)(state.doc.resolve(pos), (0, $id3e6.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $apbCm.RelativeSelectionPos).Start,
                        selection: (0, $801jp.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $8KYsz.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $2IyCM.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = this.__livePage ? !node.attrs.__expanded : node.attrs.__expanded;
            if (this.api && this.api.editorDisabled) {
                var _this$api$editorDisab;
                return !((_this$api$editorDisab = this.api.editorDisabled.sharedState.currentState()) !== null && _this$api$editorDisab !== void 0 && _this$api$editorDisab.editorDisabled) && contentEditable;
            }
            return contentEditable;
        };
        var _api$editorDisabled;
        this.intl = getIntl();
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, $26efd5c4e957baf0$var$toDOM(node, this.__livePage, this.intl, api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 || (_api$editorDisabled = _api$editorDisabled.sharedState.currentState()) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.editorDisabled));
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).titleContainer}`);
        this.content = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).content}`);
        (0, $i5qTg.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $i5qTg.estimateExpandIntrinsicHeight)(this.node, !this.isCollapsed())
            }));
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, $eUgRu.default)();
        this.renderIcon(this.intl);
        this.initHandlers();
    }
    initHandlers() {
        var _this$api;
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.addEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.addEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.addEventListener('focus', this.handleFocus);
        if (this.icon) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if ((_this$api = this.api) !== null && _this$api !== void 0 && _this$api.editorDisabled) this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            const editorDisabled = sharedState.nextSharedState.editorDisabled;
            if (this.input) {
                if (editorDisabled) this.input.setAttribute('readonly', 'true');
                else this.input.removeAttribute('readonly');
            }
            if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
            this.updateDisplayStyle(this.node);
        });
    }
    renderIcon(intl, node) {
        if (!this.icon) return;
        const { __expanded: __expanded } = node && node.attrs || this.node.attrs;
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_icon_vanilla')) {
            (0, $apws3.renderExpandButton)(this.icon, {
                intl: intl,
                allowInteractiveExpand: this.allowInteractiveExpand,
                expanded: this.__livePage ? !__expanded : __expanded
            });
            return;
        }
        this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $hWTGb.ExpandIconButton), {
                intl: intl,
                allowInteractiveExpand: this.allowInteractiveExpand,
                expanded: this.__livePage ? !__expanded : __expanded
            }), this.icon, this.renderKey);
    }
    updateDisplayStyle(node) {
        const isCollapsed = this.__livePage ? node.attrs.__expanded : !node.attrs.__expanded;
        if (this.content) {
            if (isCollapsed) this.content.classList.add((0, $45eKC.expandClassNames).contentCollapsed);
            else this.content.classList.remove((0, $45eKC.expandClassNames).contentCollapsed);
        }
        // Collapsed vs expanded changes the reserved height, so re-apply the intrinsic-size estimate.
        if (this.dom) (0, $i5qTg.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $i5qTg.estimateExpandIntrinsicHeight)(node, !isCollapsed)
            }));
    }
    isLimitedModeEnabled() {
        var _this$api0;
        // Read from `this.view.state` via the exposed plugin key rather than the shared state's
        // `enabled`, which reads a stale `false` during initial EditorView construction (the injection
        // API's editor state isn't wired up yet).
        //
        // Reads the plugin's derived `enabled`, so this covers every reason limited mode can be on.
        return Boolean((_this$api0 = this.api) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.limitedMode) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.sharedState.currentState()) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.limitedModePluginKey) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.getState(this.view.state)) === null || _this$api0 === void 0 ? void 0 : _this$api0.enabled);
    }
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $hCON4.closestElement)(target, `.${(0, $45eKC.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // Re-apply in case limited mode flipped from disabled→enabled after the document loaded
            // (the flip is transaction-driven, so this update() fires once it becomes enabled).
            const isCollapsed = this.__livePage ? node.attrs.__expanded : !node.attrs.__expanded;
            (0, $i5qTg.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                    height: (0, $i5qTg.estimateExpandIntrinsicHeight)(node, !isCollapsed)
                }));
            if (this.node.attrs.__expanded !== node.attrs.__expanded) {
                // Instead of re-rendering the view on an expand toggle
                // we toggle a class name to hide the content and animate the chevron.
                if (this.dom) {
                    this.dom.classList.toggle((0, $45eKC.expandClassNames).expanded);
                    this.renderIcon(this.intl, node);
                }
                if (this.content) // Disallow interaction/selection inside when collapsed.
                this.content.setAttribute('contenteditable', this.getContentEditable(node) ? 'true' : 'false');
                this.updateDisplayStyle(node);
            }
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps')) {
                if (this.node.attrs.title !== node.attrs.title && this.content) this.content.setAttribute('aria-label', $26efd5c4e957baf0$export$4bb8383fcf1d1fef(node.attrs.title ?? '', this.intl));
            }
            this.node = node;
            return true;
        }
        return false;
    }
    destroy() {
        var _this$decorationClean2;
        if (this.dom) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('click', this.handleClick);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.dom.removeEventListener('input', this.handleInput);
        }
        if (this.input) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('keydown', this.handleTitleKeydown);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('blur', this.handleBlur);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.input.removeEventListener('focus', this.handleInputFocus);
        }
        if (this.titleContainer) // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        if (this.icon) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.icon.removeEventListener('keydown', this.handleIconKeyDown);
            if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_expand_icon_vanilla')) this.nodeViewPortalProviderAPI.remove(this.renderKey);
        }
        (_this$decorationClean2 = this.decorationCleanup) === null || _this$decorationClean2 === void 0 || _this$decorationClean2.call(this);
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        // @ts-ignore - [unblock prosemirror bump] reset non optional prop to undefined to clear reference
        this.dom = undefined;
        this.contentDOM = undefined;
        this.icon = undefined;
        this.input = undefined;
        this.titleContainer = undefined;
        this.content = undefined;
        this.cleanUpEditorDisabledOnChange = undefined;
    }
}
function $26efd5c4e957baf0$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>{
        var _api$selection;
        return new $26efd5c4e957baf0$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.actions) === null || _api$selection === void 0 ? void 0 : _api$selection.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
    };
}

});
parcelRegister("apws3", function(module, exports) {
$parcel$export(module.exports, "renderExpandButton", () => $f7f3c308c293a12e$export$dde15965bbee9f3e);

var $45eKC = parcelRequire("45eKC");

var $62lW6 = parcelRequire("62lW6");
function $f7f3c308c293a12e$export$dde15965bbee9f3e(container, { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl }) {
    let button = container.querySelector(`.${(0, $45eKC.expandClassNames).iconButton}`);
    if (!button) {
        const doc = container.ownerDocument;
        button = doc.createElement('button');
        button.type = 'button';
        // Confluence comment navigation and focusIcon locate and click iconContainer.
        // Dropping that class broke revealing comments inside collapsed expands in ED-29205.
        button.className = `${(0, $45eKC.expandClassNames).iconButton} ${(0, $45eKC.expandClassNames).iconContainer}`;
        const svg = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('class', (0, $45eKC.expandClassNames).iconSvg);
        svg.setAttribute('width', '12');
        svg.setAttribute('height', '12');
        svg.setAttribute('viewBox', '0 0 16 16');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');
        const path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('fill', 'currentColor');
        // The ADS small ChevronRightIcon, matching the existing React control.
        path.setAttribute('d', 'm6.03 1.47 6 6a.75.75 0 0 1 .052 1.004l-.052.056-6 6-1.06-1.06L10.44 8 4.97 2.53z');
        svg.appendChild(path);
        button.appendChild(svg);
        container.appendChild(button);
    }
    const message = expanded ? (0, $62lW6.messages).collapseNode : (0, $62lW6.messages).expandNode;
    const label = (intl === null || intl === void 0 ? void 0 : intl.formatMessage(message)) ?? message.defaultMessage;
    button.setAttribute('aria-label', label);
    button.setAttribute('aria-expanded', String(expanded));
    button.disabled = !allowInteractiveExpand;
    if (allowInteractiveExpand) button.title = label;
    else button.removeAttribute('title');
}

});

parcelRegister("hWTGb", function(module, exports) {
$parcel$export(module.exports, "ExpandIconButton", () => $815af1551cb75912$export$e20de71cd82a9fe9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $k7lry = parcelRequire("k7lry");

var $45eKC = parcelRequire("45eKC");

var $62lW6 = parcelRequire("62lW6");

var $014x6 = parcelRequire("014x6");

var $1ZqY6 = parcelRequire("1ZqY6");

var $bcTS3 = parcelRequire("bcTS3");
const $815af1551cb75912$export$9a7250d72c34c156 = (WrapperComponent)=>{
    return class WithSortableColumn extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
        constructor(props){
            super(props);
        }
        render() {
            const { label: label } = this.props;
            return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
                content: label,
                position: "top",
                tag: (0, $62lW6.ExpandLayoutWrapperWithRef)
            }, /*#__PURE__*/ (0, $jctmk.jsx)(WrapperComponent, this.props)));
        }
    };
};
const $815af1551cb75912$export$aa86be27b687b166 = (props)=>{
    const { allowInteractiveExpand: allowInteractiveExpand, expanded: expanded, intl: intl } = props;
    const useTheme = (0, $fc4bM.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $014x6.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const label = expanded ? (0, $62lW6.messages).collapseNode : (0, $62lW6.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $k7lry.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $45eKC.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": expanded,
        isDisabled: !allowInteractiveExpand
    });
};
const $815af1551cb75912$var$ButtonWithTooltip = $815af1551cb75912$export$9a7250d72c34c156($815af1551cb75912$export$aa86be27b687b166);
const $815af1551cb75912$var$ButtonWithoutTooltip = $815af1551cb75912$export$aa86be27b687b166;
const $815af1551cb75912$export$e20de71cd82a9fe9 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $62lW6.messages).collapseNode : (0, $62lW6.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($815af1551cb75912$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $62lW6.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $jctmk.jsx)($815af1551cb75912$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

});



parcelRegister("jkG8w", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $b6fb5e9f448e0ab2$export$86ce8f8241c20a3);

var $3uluy = parcelRequire("3uluy");

var $Admw7 = parcelRequire("Admw7");

var $gDcAJ = parcelRequire("gDcAJ");

var $9IgeA = parcelRequire("9IgeA");
const $b6fb5e9f448e0ab2$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        var _api$decorations, _api$analytics;
        const { hoverDecoration: hoverDecoration } = (api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions) ?? {};
        const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
        // JST-1060364: We are observing this crashing the editor where the `expandPlugin` doesn't exist
        // in the editor (resulting in `Cannot destructure property 'expandRef' of ...`).
        // For now let's add a null check to ensure we don't crash while we investigate further.
        const { expandRef: expandRef } = (0, $9IgeA.getPluginState)(state) ?? {};
        if (expandRef) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: ()=>expandRef,
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($Admw7))),
                        onClick: (0, $gDcAJ.deleteExpand)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $3uluy.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };

});


parcelRegister("2ZKgI", function(module, exports) {
$parcel$export(module.exports, "expandPlugin", () => $d3fb532d5e244068$export$a4a90f0c2a6f7a01);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $l5yqo = parcelRequire("l5yqo");

var $flh6x = parcelRequire("flh6x");

var $3LeME = parcelRequire("3LeME");

var $7vlqQ = parcelRequire("7vlqQ");

var $bMe57 = parcelRequire("bMe57");

var $c2wgC = parcelRequire("c2wgC");

var $cT0LQ = parcelRequire("cT0LQ");

var $hDZNR = parcelRequire("hDZNR");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $hIUTz = parcelRequire("hIUTz");

var $8jk8H = parcelRequire("8jk8H");

var $hUKcO = parcelRequire("hUKcO");

var $sjpTk = parcelRequire("sjpTk");

var $c6BhY = parcelRequire("c6BhY");

var $1Sw9b = parcelRequire("1Sw9b");

var $kmVVs = parcelRequire("kmVVs");
const $d3fb532d5e244068$var$EXPAND_NODE_NAME = 'expand';
const $d3fb532d5e244068$export$a4a90f0c2a6f7a01 = ({ config: options = {}, api: api })=>{
    var _api$blockMenu;
    const isRegisteredSlashCommandEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command');
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $bMe57.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $bMe57.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $c2wgC.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $bMe57.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]
            },
            component: (0, $8jk8H.createExpandBlockMenuItem)(api),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($d3fb532d5e244068$var$EXPAND_NODE_NAME));
            }
        }
    ]);
    if (isRegisteredSlashCommandEnabled && options.allowInsertion === true) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $hUKcO.getExpandQuickInsertComponents)({
            api: api,
            isLegacy: false
        }));
    }
    return {
        name: 'expand',
        nodes () {
            return [
                {
                    name: 'expand',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $l5yqo.expandWithNestedExpandLocalId) : (0, $l5yqo.expandWithNestedExpand)
                },
                {
                    name: 'nestedExpand',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $flh6x.nestedExpandWithLocalId) : (0, $flh6x.nestedExpand)
                }
            ];
        },
        actions: {
            insertExpand: (0, $sjpTk.insertExpand)(api),
            insertExpandWithInputMethod: (0, $sjpTk.insertExpandWithInputMethod)(api)
        },
        commands: {
            toggleExpandWithMatch: (selection)=>(0, $sjpTk.toggleExpandWithMatch)(selection),
            toggleExpandRange: $hIUTz.toggleExpandRange
        },
        getSharedState () {
            return {
                allowInsertion: (options === null || options === void 0 ? void 0 : options.allowInsertion) ?? true
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'expand',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $1Sw9b.createPlugin)(dispatch, getIntl, options.appearance, options.useLongPressSelection, api, nodeViewPortalProviderAPI, options.allowInteractiveExpand ?? true, options.__livePage);
                    }
                },
                {
                    name: 'expandKeymap',
                    plugin: ()=>(0, $c6BhY.expandKeymap)(api)
                }
            ];
        },
        pluginsOptions: {
            floatingToolbar: (0, $kmVVs.getToolbarConfig)(api),
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    if (options && options.allowInsertion !== true) return [];
                    return [
                        {
                            id: 'expand',
                            title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expand),
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).expandDescription),
                            keywords: [
                                'accordion',
                                'collapse'
                            ],
                            priority: 600,
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconExpand), {}),
                            action (insert, state, source) {
                                var _api$analytics;
                                const node = (0, $sjpTk.createExpandNode)(state, undefined, !!(api !== null && api !== void 0 && api.localId));
                                if (!node) return false;
                                const tr = state.selection.empty ? insert(node) : (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $sjpTk.wrapSelectionAndSetExpandedState)(state, node) : (0, $hDZNR.createWrapSelectionTransaction)({
                                    state: state,
                                    type: node.type
                                });
                                api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                                    action: (0, $3LeME.ACTION).INSERTED,
                                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: node.type === state.schema.nodes.nestedExpand ? (0, $3LeME.ACTION_SUBJECT_ID).NESTED_EXPAND : (0, $3LeME.ACTION_SUBJECT_ID).EXPAND,
                                    attributes: {
                                        inputMethod: source ?? (0, $3LeME.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ];
                }
            }
        }
    };
};

});
parcelRegister("c6BhY", function(module, exports) {
$parcel$export(module.exports, "expandKeymap", () => $23f8a26f92b15e78$export$e4ebafd8ecd98be0);

var $hIUTz = parcelRequire("hIUTz");

var $eUtBU = parcelRequire("eUtBU");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $apbCm = parcelRequire("apbCm");

var $ebpUR = parcelRequire("ebpUR");

var $39oqF = parcelRequire("39oqF");
var $13Ncu = parcelRequire("13Ncu");

var $1O8Lw = parcelRequire("1O8Lw");

var $801jp = parcelRequire("801jp");

var $auYrv = parcelRequire("auYrv");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $hNYkR = parcelRequire("hNYkR");

var $sjpTk = parcelRequire("sjpTk");
const $23f8a26f92b15e78$var$isExpandNode = (node)=>{
    return (node === null || node === void 0 ? void 0 : node.type.name) === 'expand' || (node === null || node === void 0 ? void 0 : node.type.name) === 'nestedExpand';
};
const $23f8a26f92b15e78$var$isExpandSelected = (selection)=>selection instanceof (0, $801jp.NodeSelection) && $23f8a26f92b15e78$var$isExpandNode(selection.node);
function $23f8a26f92b15e78$export$e4ebafd8ecd98be0(api) {
    const list = {};
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveRight).common, (state, dispatch, editorView)=>{
        var _api$selection;
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = (api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 ? void 0 : _api$selection.sharedState.currentState()) || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($23f8a26f92b15e78$var$isExpandSelected(selection) && selectionRelativeToNode === (0, $apbCm.RelativeSelectionPos).Start) return (0, $sjpTk.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveLeft).common, (state, dispatch, editorView)=>{
        var _api$selection2;
        if (!editorView) return false;
        const { selection: selection } = state;
        const selectionSharedState = (api === null || api === void 0 || (_api$selection2 = api.selection) === null || _api$selection2 === void 0 ? void 0 : _api$selection2.sharedState.currentState()) || {};
        const { selectionRelativeToNode: selectionRelativeToNode } = selectionSharedState;
        if ($23f8a26f92b15e78$var$isExpandSelected(selection) && (selectionRelativeToNode === undefined || selectionRelativeToNode === (0, $apbCm.RelativeSelectionPos).End)) return (0, $sjpTk.focusTitle)(selection.from + 1)(state, dispatch, editorView);
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.tab).common, (state, dispatch, editorView)=>{
        if (editorView && editorView.dom instanceof HTMLElement) {
            const { from: from } = state.selection;
            // if the node selected is an expand
            if ($23f8a26f92b15e78$var$isExpandSelected(state.selection)) {
                const expand = editorView.nodeDOM(from);
                if (!expand) return false;
                return (0, $sjpTk.focusIcon)(expand)(state, dispatch, editorView);
            } else if (state.selection instanceof (0, $801jp.TextSelection) && !(0, $auYrv.isInTable)(state)) {
                const expand = (0, $ebpUR.findExpand)(state);
                if (expand) {
                    const expandNode = editorView.nodeDOM(expand.pos);
                    if (expandNode) return (0, $sjpTk.focusIcon)(expandNode)(state, dispatch, editorView);
                }
            }
        }
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveUp).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { selection: selection, schema: schema } = state;
        const { nodeBefore: nodeBefore } = selection.$from;
        if (selection instanceof (0, $ihNBw.GapCursorSelection) && selection.side === (0, $id3e6.Side).RIGHT && nodeBefore && (nodeBefore.type === schema.nodes.expand || nodeBefore.type === schema.nodes.nestedExpand) && (0, $hIUTz.isExpandCollapsed)(nodeBefore)) {
            const { $from: $from } = selection;
            return (0, $sjpTk.focusTitle)(Math.max($from.pos - 1, 0))(state, dispatch, editorView);
        }
        const { $from: $from } = state.selection;
        if (editorView.endOfTextblock('up')) {
            const expand = (0, $ebpUR.findExpand)(state);
            // Moving UP in a table should move the cursor to the row above
            // however when an expand is in a table cell to the left of the
            // current table cell, arrow UP moves the cursor to the left
            // see ED-15425
            if ((0, $13Ncu.isPositionNearTableRow)($from, schema, 'before') && !expand) return false;
            const prevCursorPos = Math.max($from.pos - $from.parentOffset - 1, 0);
            // move cursor from expand's content to its title
            if (expand && expand.start === prevCursorPos) return (0, $sjpTk.focusTitle)(expand.start)(state, dispatch, editorView);
            const sel = (0, $801jp.Selection).findFrom(state.doc.resolve(prevCursorPos), -1);
            const expandBefore = (0, $ebpUR.findExpand)(state, sel);
            if (sel && expandBefore) {
                // moving cursor from outside of an expand to the title when it is collapsed
                if ((0, $hIUTz.isExpandCollapsed)(expandBefore.node)) return (0, $sjpTk.focusTitle)(expandBefore.start)(state, dispatch, editorView);
                else if (dispatch) dispatch(state.tr.setSelection(sel));
                return true;
            }
        }
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveDown).common, (state, dispatch, editorView)=>{
        if (!editorView) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const { selection: selection } = state;
        const { nodeAfter: nodeAfter } = selection.$from;
        if (selection instanceof (0, $ihNBw.GapCursorSelection) && selection.side === (0, $id3e6.Side).LEFT && nodeAfter && (nodeAfter.type === expand || nodeAfter.type === nestedExpand) && (0, $hIUTz.isExpandCollapsed)(nodeAfter)) {
            const { $from: $from } = selection;
            return (0, $sjpTk.focusTitle)($from.pos + 1)(state, dispatch, editorView);
        }
        if ((0, $aEmSo.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) {
            const nextExpandPos = (0, $hIUTz.getNextNodeExpandPos)(editorView, selection);
            if (nextExpandPos !== undefined) return (0, $sjpTk.focusTitle)(nextExpandPos)(state, dispatch, editorView);
        }
        if (editorView.endOfTextblock('down')) {
            const { $from: $from } = state.selection;
            if ($from.depth === 0) return false;
            const $after = state.doc.resolve($from.after());
            if ($after.nodeAfter && ($after.nodeAfter.type === expand || $after.nodeAfter.type === nestedExpand)) return (0, $sjpTk.focusTitle)($after.pos + 1)(state, dispatch, editorView);
        }
        return false;
    }, list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.backspace).common, (state, dispatch, editorView)=>{
        const { selection: selection } = state;
        const { $from: $from } = selection;
        if (!editorView || !selection.empty) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        const expandNode = (0, $ebpUR.findExpand)(state);
        if (!expandNode) {
            // @see ED-7977
            const sel = (0, $801jp.Selection).findFrom(state.doc.resolve(Math.max(selection.$from.pos - 1, 0)), -1);
            const expandBefore = (0, $ebpUR.findExpand)(state, sel);
            if (expandBefore && (expandBefore.node.type === expand || expandBefore.node.type === nestedExpand) && (0, $hIUTz.isExpandCollapsed)(expandBefore.node)) {
                if ((0, $dRkX9.fg)('platform_editor_expand_delete_empty_line') && (0, $hNYkR.deleteEmptyLineAfterCollapsedExpand)({
                    focusTitle: $sjpTk.focusTitle,
                    isCollapsed: (0, $hIUTz.isExpandCollapsed)
                })(state, dispatch, editorView)) return true;
                return (0, $sjpTk.focusTitle)(expandBefore.start)(state, dispatch, editorView);
            }
            return false;
        }
        const parentNode = state.doc.nodeAt($from.before(Math.max($from.depth - 1, 1)));
        // ED-10012 catch cases where the expand has another node nested within it and
        // the backspace should be applied only to the inner node instead of the expand
        if (parentNode && !$23f8a26f92b15e78$var$isExpandNode(parentNode)) return false;
        const textSel = (0, $801jp.Selection).findFrom(state.doc.resolve(expandNode.pos), 1, true);
        if (textSel && selection.$from.pos === textSel.$from.pos && (0, $39oqF.isEmptyNode)(state.schema)(expandNode.node) && dispatch) {
            var _api$analytics;
            return (0, $sjpTk.deleteExpand)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(state, dispatch);
        }
        return false;
    }, list);
    return (0, $1O8Lw.keymap)(list);
}

});

parcelRegister("1Sw9b", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $b5887eef49d8c22f$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $6bnr9 = parcelRequire("6bnr9");

var $45eKC = parcelRequire("45eKC");

var $cecv2 = parcelRequire("cecv2");
var $hhFDR = parcelRequire("hhFDR");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $hIUTz = parcelRequire("hIUTz");

var $45IZ2 = parcelRequire("45IZ2");
const $b5887eef49d8c22f$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('expandPlugin');
function $b5887eef49d8c22f$export$366b6d00a7e2683b(element, className) {
    var _element$classList;
    return Boolean(element === null || element === void 0 || (_element$classList = element.classList) === null || _element$classList === void 0 ? void 0 : _element$classList.contains(className));
}
const $b5887eef49d8c22f$export$ae829ec7b2625219 = (dispatch, getIntl, appearance = 'full-page', useLongPressSelection = false, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false)=>{
    const isMobile = false;
    return new (0, $1y7gE.SafePlugin)({
        key: $b5887eef49d8c22f$export$18d4026d1ea86bb1,
        state: {
            init () {
                return (0, $16ZMX.DecorationSet).empty;
            },
            apply (tr, decorationSet) {
                const meta = tr.getMeta((0, $hIUTz.TOGGLE_EXPAND_RANGE_META_KEY));
                if (meta && meta.positions.length > 0) {
                    // Add node decorations for each expand node that was toggled.
                    // ExpandNodeView.update() uses these decorations to detect it needs to
                    // visually open or close, even when expandedState was set before the
                    // transaction replaced the node objects.
                    // We do NOT map or carry forward existing decorations — we start fresh
                    // each time the meta is present.
                    const decorations = meta.positions.map((pos)=>{
                        var _tr$doc$nodeAt;
                        return (0, $16ZMX.Decoration).node(pos, pos + (((_tr$doc$nodeAt = tr.doc.nodeAt(pos)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.nodeSize) ?? 0), {}, {
                            forceExpandOpen: meta.open
                        });
                    });
                    return (0, $16ZMX.DecorationSet).create(tr.doc, decorations);
                }
                // Map existing decorations through document changes.
                // They will be naturally cleared when they no longer match any node
                // (e.g. if the expand is deleted), or on the next toggleExpandRange call.
                return decorationSet.map(tr.mapping, tr.doc);
            }
        },
        props: {
            decorations (state) {
                return $b5887eef49d8c22f$export$18d4026d1ea86bb1.getState(state);
            },
            nodeViews: {
                expand: (0, $45IZ2.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                }),
                nestedExpand: (0, $45IZ2.default)({
                    getIntl: getIntl,
                    isMobile: isMobile,
                    api: api,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                    allowInteractiveExpand: allowInteractiveExpand,
                    __livePage: __livePage
                })
            },
            handleKeyDown (_view, event) {
                return $b5887eef49d8c22f$export$366b6d00a7e2683b(event.target, (0, $45eKC.expandClassNames).titleContainer);
            },
            handleKeyPress (_view, event) {
                return $b5887eef49d8c22f$export$366b6d00a7e2683b(event.target, (0, $45eKC.expandClassNames).titleContainer);
            },
            handleScrollToSelection () {
                return $b5887eef49d8c22f$export$366b6d00a7e2683b(document.activeElement, (0, $45eKC.expandClassNames).titleInput);
            },
            handleClickOn: (0, $6bnr9.createSelectionClickHandler)([
                'expand',
                'nestedExpand'
            ], (target)=>target.classList.contains((0, $45eKC.expandClassNames).prefix), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDrop (view, event, slice, _moved) {
                return $b5887eef49d8c22f$export$5a8d0c1bf9e6992c(view, event, slice);
            }
        },
        // @see ED-8027 to follow up on this work-around
        filterTransaction (tr) {
            // Preserve title editing against selection changes unless explicitly allowed.
            if ($b5887eef49d8c22f$export$366b6d00a7e2683b(document.activeElement, (0, $45eKC.expandClassNames).titleInput) && tr.selectionSet && (!tr.steps.length || tr.isGeneric) && !((0, $bcN2K.isExperimentEnabled)('platform_editor_remix_reliability_improvements') && tr.getMeta('allowSelectionChangeWhileExpandTitleFocused') === true)) return false;
            return true;
        }
    });
};
function $b5887eef49d8c22f$export$5a8d0c1bf9e6992c(view, event, slice) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    const { selection: selection } = state;
    const { from: from, to: to } = selection;
    let sliceContainsExpand = false;
    let sliceContainsNestedExpand = false;
    slice.content.forEach((node)=>{
        if (node.type === state.schema.nodes.expand) sliceContainsExpand = true;
        else if (node.type === state.schema.nodes.nestedExpand) sliceContainsNestedExpand = true;
    });
    // Check if the contents of the dragged slice contain a nested expand node or expand node.
    // Also not handling expands with nested expands for now.
    if (!sliceContainsExpand && !sliceContainsNestedExpand || sliceContainsExpand && sliceContainsNestedExpand) return false;
    const dropPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!dropPos) return false;
    const resolvedPos = state.doc.resolve(dropPos.pos);
    const dropLocationNodeType = resolvedPos.node().type;
    const dropLocationParentNodeType = resolvedPos.depth > 0 ? resolvedPos.node(resolvedPos.depth - 1).type : dropLocationNodeType;
    const nodesWithNestedExpandSupport = [
        state.schema.nodes.expand,
        state.schema.nodes.tableHeader,
        state.schema.nodes.tableCell
    ];
    const isNodeAtDropPosInsideNodesWithNestedExpandSupport = nodesWithNestedExpandSupport.includes(dropLocationNodeType) || nodesWithNestedExpandSupport.includes(dropLocationParentNodeType);
    const isNodeBeingDroppedInsideNestedExpand = dropLocationNodeType === state.schema.nodes.nestedExpand || dropLocationParentNodeType === state.schema.nodes.nestedExpand;
    let updatedSlice = slice;
    if (sliceContainsExpand && isNodeAtDropPosInsideNodesWithNestedExpandSupport) updatedSlice = (0, $cecv2.transformSliceExpandToNestedExpand)(slice);
    else if (sliceContainsNestedExpand && !isNodeAtDropPosInsideNodesWithNestedExpandSupport && !isNodeBeingDroppedInsideNestedExpand) updatedSlice = (0, $hhFDR.transformSliceNestedExpandToExpand)(slice, state.schema);
    if (!updatedSlice || updatedSlice.eq(slice)) return false;
    // The drop position will be affected when the original slice is deleted from the document.
    let updatedDropPos = dropPos.pos > from ? dropPos.pos - updatedSlice.content.size : dropPos.pos;
    // Adjust the drop position to place the slice before the node at the position the cursor is pointing at, except when the drop location is the document node.
    // Otherwise causes weird behaviour with tables & quotes, splits them apart. Only do this for nested expand slice transformed to expand.
    if (dropLocationNodeType !== state.schema.nodes.doc && !sliceContainsExpand) updatedDropPos = updatedDropPos - 1;
    tr.delete(from, to);
    tr.insert(updatedDropPos, updatedSlice.content);
    dispatch(tr);
    return true;
}

});
parcelRegister("45IZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $22662b5288d19a28$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $eUgRu = parcelRequire("eUgRu");

var $hLBpb = parcelRequire("hLBpb");

var $5Amf8 = parcelRequire("5Amf8");

var $hIUTz = parcelRequire("hIUTz");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $apbCm = parcelRequire("apbCm");

var $45eKC = parcelRequire("45eKC");

var $39oqF = parcelRequire("39oqF");

var $i5qTg = parcelRequire("i5qTg");

var $hCON4 = parcelRequire("hCON4");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $2IyCM = parcelRequire("2IyCM");

var $8KYsz = parcelRequire("8KYsz");

var $aEmSo = parcelRequire("aEmSo");

var $apws3 = parcelRequire("apws3");

var $sjpTk = parcelRequire("sjpTk");

var $94WYL = parcelRequire("94WYL");

var $rxygm = parcelRequire("rxygm");

var $4ejVi = parcelRequire("4ejVi");
class $22662b5288d19a28$export$e6a0ba759c3724b0 {
    constructor(node, view, getPos, getIntl, isMobile, selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand = true, __livePage = false, cleanUpEditorDisabledOnChange, isExpanded = {
        expanded: false
    }){
        this.selectNearNode = selectNearNode;
        this.__livePage = __livePage;
        this.cleanUpEditorDisabledOnChange = cleanUpEditorDisabledOnChange;
        this.isExpanded = isExpanded;
        this.allowInteractiveExpand = true;
        this.isMobile = false;
        this.focusTitle = ()=>{
            if (this.input) {
                const { state: state, dispatch: dispatch } = this.view;
                if (this.selectNearNode) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $apbCm.RelativeSelectionPos).Start
                    })(state);
                    if (dispatch) dispatch(tr);
                }
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $sjpTk.setSelectionInsideExpand)(pos)(state, dispatch, this.view);
                this.input.focus();
            }
        };
        this.handleIconKeyDown = (event)=>{
            switch((0, $hLBpb.keyName)(event)){
                case 'Tab':
                    event.preventDefault();
                    this.focusTitle();
                    break;
                case 'Enter':
                    event.preventDefault();
                    this.handleClick(event);
                    break;
            }
        };
        this.handleClick = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if ((0, $hCON4.closestElement)(target, `.${(0, $45eKC.expandClassNames).icon}`)) {
                var _this$api2;
                if (!this.allowInteractiveExpand) return;
                event.stopPropagation();
                // We blur the editorView, to prevent any keyboard showing on mobile
                // When we're interacting with the expand toggle
                if (this.view.dom instanceof HTMLElement) this.view.dom.blur();
                (0, $sjpTk.toggleExpandExpanded)({
                    editorAnalyticsAPI: (_this$api2 = this.api) === null || _this$api2 === void 0 || (_this$api2 = _this$api2.analytics) === null || _this$api2 === void 0 ? void 0 : _this$api2.actions,
                    pos: pos,
                    node: this.node
                })(this.view.state, this.view.dispatch);
                this.updateExpandToggleIcon(this.node);
                this.updateDisplayStyle(this.node);
                return;
            }
            if (target === this.input) {
                event.stopPropagation();
                this.focusTitle();
                return;
            }
        };
        this.handleInput = (event)=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const target = event.target;
            if (target === this.input) {
                event.stopPropagation();
                const { state: state, dispatch: dispatch } = this.view;
                (0, $sjpTk.updateExpandTitle)({
                    title: target.value,
                    pos: pos,
                    nodeType: this.node.type
                })(state, dispatch);
            }
        };
        this.handleFocus = (event)=>{
            event.stopImmediatePropagation();
        };
        this.handleInputFocus = ()=>{
            var _this$api3;
            this.decorationCleanup = (_this$api3 = this.api) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.selectionMarker) === null || _this$api3 === void 0 || (_this$api3 = _this$api3.actions) === null || _this$api3 === void 0 ? void 0 : _this$api3.hideDecoration();
        };
        this.handleBlur = ()=>{
            var _this$decorationClean;
            (_this$decorationClean = this.decorationCleanup) === null || _this$decorationClean === void 0 || _this$decorationClean.call(this);
        };
        this.handleTitleKeydown = (event)=>{
            // Handle Ctrl+Shift+H to select the expand node for drag handle
            // Note: If changing this implementation in singlePlayer expand, please also update the implementation in legacyExpand
            if ((0, $aEmSo.expValEquals)('platform_editor_dnd_accessibility_fixes_expand', 'isEnabled', true) && (event.ctrlKey || event.metaKey) && event.shiftKey && (event.key === 'H' || event.key === 'h')) {
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') {
                    // Blur the input first to remove focus from the title
                    if (this.input) this.input.blur();
                    // Use requestAnimationFrame to ensure blur completes before setting selection
                    requestAnimationFrame(()=>{
                        var _this$api4;
                        const { state: state } = this.view;
                        this.view.focus();
                        (_this$api4 = this.api) === null || _this$api4 === void 0 || _this$api4.core.actions.execute(({ tr: tr })=>{
                            tr.setSelection((0, $801jp.NodeSelection).create(state.doc, pos));
                            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration')) {
                                var _this$api5;
                                const command = (_this$api5 = this.api) === null || _this$api5 === void 0 || (_this$api5 = _this$api5.blockControls) === null || _this$api5 === void 0 ? void 0 : _this$api5.commands.showControlAtPosition(pos, (0, $5Amf8.BLOCK_CONTROLS_DRAG_HANDLE), {
                                    isFocused: true
                                });
                                if (command) return command({
                                    tr: tr
                                });
                                return null;
                            }
                            const node = state.doc.nodeAt(pos);
                            if (node) {
                                const dom = this.view.nodeDOM(pos);
                                if (dom instanceof HTMLElement) {
                                    const anchorName = (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) ? dom.getAttribute('data-node-anchor') : dom.getAttribute('data-drag-handler-anchor-name');
                                    if (anchorName) {
                                        var _this$api6;
                                        const command = (_this$api6 = this.api) === null || _this$api6 === void 0 || (_this$api6 = _this$api6.blockControls) === null || _this$api6 === void 0 ? void 0 : _this$api6.commands.showDragHandleAt(pos, anchorName, node.type.name, {
                                            isFocused: true
                                        });
                                        if (command) return command({
                                            tr: tr
                                        });
                                    }
                                }
                            }
                            return null;
                        });
                    });
                }
                return;
            }
            switch((0, $hLBpb.keyName)(event)){
                case 'Enter':
                    this.toggleExpand();
                    break;
                case 'Tab':
                case 'ArrowDown':
                    this.moveToOutsideOfTitle(event);
                    break;
                case 'ArrowRight':
                    this.handleArrowRightFromTitle(event);
                    break;
                case 'ArrowLeft':
                    this.handleArrowLeftFromTitle(event);
                    break;
                case 'ArrowUp':
                    if ((0, $aEmSo.expValEquals)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) this.moveToPreviousLine(event);
                    else this.setLeftGapCursor(event);
                    break;
                case 'Backspace':
                    this.deleteEmptyExpand();
                    break;
            }
            // 'Ctrl-y', 'Mod-Shift-z');
            if (event.ctrlKey && event.key === 'y' || (event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'z') {
                this.handleRedoFromTitle(event);
                return;
            }
            // 'Mod-z'
            if ((event.ctrlKey || event.metaKey) && event.key === 'z') {
                this.handleUndoFromTitle(event);
                return;
            }
            if ((event.ctrlKey || event.metaKey) && event.altKey && (event.code === 'BracketLeft' || event.code === 'BracketRight')) this.view.dispatchEvent(new KeyboardEvent('keydown', {
                key: event.key,
                code: event.code,
                metaKey: event.metaKey,
                ctrlKey: event.ctrlKey,
                altKey: event.altKey
            }));
        };
        this.deleteEmptyExpand = ()=>{
            const { state: state } = this.view;
            const expandNode = this.node;
            if (!this.input) return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart !== selectionEnd || selectionStart !== 0) return;
            if (expandNode && (0, $39oqF.isEmptyNode)(state.schema)(expandNode)) {
                var _this$api7;
                (0, $sjpTk.deleteExpand)((_this$api7 = this.api) === null || _this$api7 === void 0 || (_this$api7 = _this$api7.analytics) === null || _this$api7 === void 0 ? void 0 : _this$api7.actions)(state, this.view.dispatch);
            }
        };
        this.toggleExpand = ()=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            if (this.allowInteractiveExpand) {
                var _this$api8;
                const { state: state, dispatch: dispatch } = this.view;
                (0, $sjpTk.toggleExpandExpanded)({
                    editorAnalyticsAPI: (_this$api8 = this.api) === null || _this$api8 === void 0 || (_this$api8 = _this$api8.analytics) === null || _this$api8 === void 0 ? void 0 : _this$api8.actions,
                    pos: pos,
                    node: this.node
                })(state, dispatch);
                this.updateExpandToggleIcon(this.node);
                this.updateDisplayStyle(this.node);
            }
        };
        this.moveToOutsideOfTitle = (event)=>{
            event.preventDefault();
            const { state: state, dispatch: dispatch } = this.view;
            const expandPos = this.getPos();
            if (typeof expandPos !== 'number') return;
            let pos = expandPos;
            if (this.isCollapsed()) pos = expandPos + this.node.nodeSize;
            const resolvedPos = state.doc.resolve(pos);
            if (!resolvedPos) return;
            if (this.isCollapsed() && resolvedPos.nodeAfter && [
                'expand',
                'nestedExpand'
            ].indexOf(resolvedPos.nodeAfter.type.name) > -1) return this.setRightGapCursor(event);
            const sel = (0, $801jp.Selection).findFrom(resolvedPos, 1, true);
            if (sel) {
                // If the input has focus, ProseMirror doesn't
                // Give PM focus back before changing our selection
                this.view.focus();
                dispatch(state.tr.setSelection(sel));
            }
        };
        this.isCollapsed = ()=>{
            return !(0, $hIUTz.expandedState).get(this.node);
        };
        this.setRightGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            const selectionStartExists = selectionStart !== null && selectionStart !== undefined;
            const selectionEndExists = selectionEnd !== null && selectionEnd !== undefined;
            const selectionStartInsideTitle = selectionStartExists && selectionStart >= 0 && selectionStart <= value.length;
            const selectionEndInsideTitle = selectionEndExists && selectionEnd >= 0 && selectionEnd <= value.length;
            if (selectionStartInsideTitle && selectionEndInsideTitle) {
                const { state: state, dispatch: dispatch } = this.view;
                event.preventDefault();
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $ihNBw.GapCursorSelection)(state.doc.resolve(this.node.nodeSize + pos), (0, $id3e6.Side).RIGHT)));
            }
        };
        this.moveToPreviousLine = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                const resolvedPos = state.doc.resolve(pos);
                if (!resolvedPos) return;
                if (resolvedPos.pos === 0) {
                    this.setLeftGapCursor(event);
                    return;
                }
                const sel = (0, $801jp.Selection).findFrom(resolvedPos, -1);
                if (sel) {
                    this.view.focus();
                    dispatch(state.tr.setSelection(sel));
                }
            }
        };
        this.setLeftGapCursor = (event)=>{
            if (!this.input) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                dispatch(state.tr.setSelection(new (0, $ihNBw.GapCursorSelection)(state.doc.resolve(pos), (0, $id3e6.Side).LEFT)));
            }
        };
        this.handleArrowRightFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === value.length) {
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const tr = this.selectNearNode({
                    selectionRelativeToNode: (0, $apbCm.RelativeSelectionPos).End,
                    selection: (0, $801jp.NodeSelection).create(state.doc, pos)
                })(state);
                if (dispatch) dispatch(tr);
            }
        };
        this.handleArrowLeftFromTitle = (event)=>{
            if (!this.input || !this.selectNearNode) return;
            const pos = this.getPos();
            if (typeof pos !== 'number') return;
            const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.input;
            if (selectionStart === selectionEnd && selectionStart === 0) {
                var _this$api9;
                event.preventDefault();
                const { state: state, dispatch: dispatch } = this.view;
                this.view.focus();
                const selectionSharedState = ((_this$api9 = this.api) === null || _this$api9 === void 0 || (_this$api9 = _this$api9.selection) === null || _this$api9 === void 0 ? void 0 : _this$api9.sharedState.currentState()) || {};
                // selectionRelativeToNode is undefined when user clicked to select node, then hit left to get focus in title
                // This is a special case where we want to bypass node selection and jump straight to gap cursor
                if ((selectionSharedState === null || selectionSharedState === void 0 ? void 0 : selectionSharedState.selectionRelativeToNode) === undefined) {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: undefined,
                        selection: new (0, $ihNBw.GapCursorSelection)(state.doc.resolve(pos), (0, $id3e6.Side).LEFT)
                    })(state);
                    if (dispatch) dispatch(tr);
                } else {
                    const tr = this.selectNearNode({
                        selectionRelativeToNode: (0, $apbCm.RelativeSelectionPos).Start,
                        selection: (0, $801jp.NodeSelection).create(state.doc, pos)
                    })(state);
                    if (dispatch) dispatch(tr);
                }
            }
        };
        this.handleUndoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $8KYsz.undo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.handleRedoFromTitle = (event)=>{
            const { state: state, dispatch: dispatch } = this.view;
            (0, $2IyCM.redo)(state, dispatch);
            event.preventDefault();
            return;
        };
        this.getContentEditable = (node)=>{
            const contentEditable = !(0, $hIUTz.isExpandCollapsed)(node);
            if (this.api && this.api.editorDisabled) {
                var _this$api$editorDisab;
                return !((_this$api$editorDisab = this.api.editorDisabled.sharedState.currentState()) !== null && _this$api$editorDisab !== void 0 && _this$api$editorDisab.editorDisabled) && contentEditable;
            }
            return contentEditable;
        };
        this.renderIcon = (icon, expanded)=>{
            if (!icon) return;
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_icon_vanilla')) {
                (0, $apws3.renderExpandButton)(icon, {
                    intl: this.intl,
                    allowInteractiveExpand: this.allowInteractiveExpand,
                    expanded: expanded
                });
                return;
            }
            this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $94WYL.ExpandButton), {
                    intl: this.intl,
                    allowInteractiveExpand: this.allowInteractiveExpand,
                    expanded: expanded
                }), icon, this.renderKey);
        };
        var _api$editorDisabled, _this$api;
        this.intl = getIntl();
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.allowInteractiveExpand = allowInteractiveExpand;
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        this.isExpanded.expanded = (0, $hIUTz.expandedState).get(node) ?? false;
        this.isExpanded.localId = node.attrs.localId;
        const editorDisabled = api === null || api === void 0 || (_api$editorDisabled = api.editorDisabled) === null || _api$editorDisabled === void 0 || (_api$editorDisabled = _api$editorDisabled.sharedState.currentState()) === null || _api$editorDisabled === void 0 ? void 0 : _api$editorDisabled.editorDisabled;
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, (0, $rxygm.toDOM)(node, this.__livePage, this.intl, editorDisabled, !editorDisabled && !(0, $hIUTz.isExpandCollapsed)(node)));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        this.isMobile = isMobile;
        this.api = api;
        this.icon = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).icon}`);
        this.input = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).titleInput}`);
        this.titleContainer = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).titleContainer}`);
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.renderKey = (0, $eUgRu.default)();
        this.content = this.dom.querySelector(`.${(0, $45eKC.expandClassNames).content}`);
        if (!(0, $hIUTz.expandedState).has(this.node)) (0, $hIUTz.expandedState).set(this.node, false);
        (0, $i5qTg.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $i5qTg.estimateExpandIntrinsicHeight)(this.node, !(0, $hIUTz.isExpandCollapsed)(this.node))
            }));
        this.renderIcon(this.icon, !(0, $hIUTz.isExpandCollapsed)(this.node));
        if (!this.input || !this.titleContainer || !this.icon) return;
        // Add event listeners
        /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners*/ this.dom.addEventListener('click', this.handleClick);
        this.dom.addEventListener('input', this.handleInput);
        this.input.addEventListener('keydown', this.handleTitleKeydown);
        this.input.addEventListener('blur', this.handleBlur);
        this.input.addEventListener('focus', this.handleInputFocus);
        // If the user interacts in our title bar (either toggle or input)
        // Prevent ProseMirror from getting a focus event (causes weird selection issues).
        this.titleContainer.addEventListener('focus', this.handleFocus);
        this.icon.addEventListener('keydown', this.handleIconKeyDown);
        if ((_this$api = this.api) !== null && _this$api !== void 0 && _this$api.editorDisabled) {
            if ((0, $bcN2K.isExperimentEnabled)('cc_editor_limited_mode_perf_improvements')) {
                if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
                this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
                    const editorDisabled = sharedState.nextSharedState.editorDisabled;
                    if (this.input) {
                        if (editorDisabled) this.input.setAttribute('readonly', 'true');
                        else this.input.removeAttribute('readonly');
                    }
                    const nextContentEditableValue = this.getContentEditable(this.node) ? 'true' : 'false';
                    if (this.content && this.content.getAttribute('contenteditable') !== nextContentEditableValue) this.content.setAttribute('contenteditable', nextContentEditableValue);
                });
            } else this.cleanUpEditorDisabledOnChange = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
                const editorDisabled = sharedState.nextSharedState.editorDisabled;
                if (this.input) {
                    if (editorDisabled) this.input.setAttribute('readonly', 'true');
                    else this.input.removeAttribute('readonly');
                }
                if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
            });
        }
    }
    stopEvent(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const target = event.target;
        return target === this.input || target === this.icon || !!(0, $hCON4.closestElement)(target, `.${(0, $45eKC.expandClassNames).icon}`);
    }
    ignoreMutation(mutationRecord) {
        // ME-1931: Mobile relies on composition which creates dom mutations. If we ignore them, prosemirror
        // does not recognise the changes and reverts them.
        if (this.isMobile && (mutationRecord.type === 'characterData' || mutationRecord.type === 'childList')) return false;
        if (mutationRecord.type === 'selection') return false;
        return true;
    }
    update(node, _decorations) {
        if (this.node.type === node.type) {
            // During a collab session the title doesn't sync with other users
            // since we're intentionally being less aggressive about re-rendering.
            // We also apply a rAF to avoid abrupt continuous replacement of the title.
            window.requestAnimationFrame(()=>{
                if (this.input && this.node.attrs.title !== this.input.value) this.input.value = this.node.attrs.title;
            });
            // Sync up the aria-label with the current expand title.
            if (((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps')) && this.node.attrs.title !== node.attrs.title && this.content) this.content.setAttribute('aria-label', (0, $rxygm.getExpandBodyAriaLabel)(node.attrs.title ?? '', this.intl));
            // This checks if the node has been replaced with a different version
            // and updates the state of the new node to match the old one
            // Eg. typing in a node changes it to a new node so it must be updated
            // in the expandedState weak map
            if (this.node !== node) {
                const wasExpanded = (0, $hIUTz.expandedState).get(this.node);
                if (wasExpanded) (0, $hIUTz.expandedState).set(node, wasExpanded);
            }
            this.node = node;
            // Re-apply in case limited mode flipped from disabled→enabled after the document loaded
            // (the flip is transaction-driven, so this update() fires once it becomes enabled).
            (0, $i5qTg.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                    height: (0, $i5qTg.estimateExpandIntrinsicHeight)(this.node, !(0, $hIUTz.isExpandCollapsed)(this.node))
                }));
            const currentExpanded = (0, $hIUTz.expandedState).get(node) ?? false;
            const hasChanged = this.isExpanded.expanded !== currentExpanded && this.isExpanded.localId === node.attrs.localId;
            if (hasChanged) {
                this.updateExpandToggleIcon(node);
                this.updateDisplayStyle(node);
            }
            return true;
        }
        return false;
    }
    updateExpandToggleIcon(node) {
        const expanded = (0, $hIUTz.expandedState).get(node) ? (0, $hIUTz.expandedState).get(node) : false;
        if (this.dom && expanded !== undefined) {
            const classes = this.dom.className.split(' ');
            // find & replace styles might be applied to the expand title and we need to keep them
            const findReplaceDecorationsApplied = classes.filter((className)=>(0, $4ejVi.findReplaceExpandDecorations).includes(className)).join(' ');
            this.dom.className = findReplaceDecorationsApplied ? (0, $rxygm.buildExpandClassName)(node.type.name, expanded) + ` ${findReplaceDecorationsApplied}` : (0, $rxygm.buildExpandClassName)(node.type.name, expanded);
            // Re-render the icon to update the aria-expanded attribute
            this.renderIcon(this.icon ?? null, (0, $hIUTz.expandedState).get(node) ?? false);
        }
        this.updateExpandBodyContentEditable();
        this.isExpanded = {
            expanded: expanded ?? false,
            localId: node.attrs.localId
        };
    }
    isLimitedModeEnabled() {
        var _this$api0;
        // Read from `this.view.state` via the exposed plugin key rather than the shared state's
        // `enabled`, which reads a stale `false` during initial EditorView construction (the injection
        // API's editor state isn't wired up yet).
        //
        // Reads the plugin's derived `enabled`, so this covers every reason limited mode can be on.
        return Boolean((_this$api0 = this.api) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.limitedMode) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.sharedState.currentState()) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.limitedModePluginKey) === null || _this$api0 === void 0 || (_this$api0 = _this$api0.getState(this.view.state)) === null || _this$api0 === void 0 ? void 0 : _this$api0.enabled);
    }
    updateDisplayStyle(node) {
        if (this.content) {
            if ((0, $hIUTz.isExpandCollapsed)(node)) this.content.classList.add((0, $45eKC.expandClassNames).contentCollapsed);
            else this.content.classList.remove((0, $45eKC.expandClassNames).contentCollapsed);
        }
        // Collapsed vs expanded changes the reserved height, so re-apply the intrinsic-size estimate.
        (0, $i5qTg.applyContentVisibility)(this.dom, this.isLimitedModeEnabled(), ()=>({
                height: (0, $i5qTg.estimateExpandIntrinsicHeight)(node, !(0, $hIUTz.isExpandCollapsed)(node))
            }));
    }
    updateExpandBodyContentEditable() {
        // Disallow interaction/selection inside expand body when collapsed.
        if (this.content) this.content.setAttribute('contenteditable', this.getContentEditable(this.node) ? 'true' : 'false');
    }
    destroy() {
        var _this$decorationClean2;
        if (!this.dom || !this.input || !this.titleContainer || !this.icon) return;
        this.dom.removeEventListener('click', this.handleClick);
        this.dom.removeEventListener('input', this.handleInput);
        this.input.removeEventListener('keydown', this.handleTitleKeydown);
        this.input.removeEventListener('blur', this.handleBlur);
        this.input.removeEventListener('focus', this.handleInputFocus);
        this.titleContainer.removeEventListener('focus', this.handleFocus);
        this.icon.removeEventListener('keydown', this.handleIconKeyDown);
        (_this$decorationClean2 = this.decorationCleanup) === null || _this$decorationClean2 === void 0 || _this$decorationClean2.call(this);
        if (this.cleanUpEditorDisabledOnChange) this.cleanUpEditorDisabledOnChange();
        if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_expand_icon_vanilla')) this.nodeViewPortalProviderAPI.remove(this.renderKey);
    }
}
function $22662b5288d19a28$export$2e2bcd8739ae039({ getIntl: getIntl, isMobile: isMobile, api: api, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, allowInteractiveExpand: allowInteractiveExpand = true, __livePage: __livePage }) {
    return (node, view, getPos)=>{
        var _api$selection;
        return new $22662b5288d19a28$export$e6a0ba759c3724b0(node, view, getPos, getIntl, isMobile, api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 || (_api$selection = _api$selection.actions) === null || _api$selection === void 0 ? void 0 : _api$selection.selectNearNode, api, nodeViewPortalProviderAPI, allowInteractiveExpand, __livePage);
    };
}

});
parcelRegister("94WYL", function(module, exports) {
$parcel$export(module.exports, "ExpandButton", () => $59842f758a64c973$export$5663c8f5aeb8c1c4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $k7lry = parcelRequire("k7lry");

var $45eKC = parcelRequire("45eKC");

var $62lW6 = parcelRequire("62lW6");

var $014x6 = parcelRequire("014x6");

var $1ZqY6 = parcelRequire("1ZqY6");

var $bcTS3 = parcelRequire("bcTS3");
function $59842f758a64c973$var$withTooltip(Component) {
    return function WithTooltip(props) {
        return(// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
        /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
            content: props.label,
            position: "top",
            tag: (0, $62lW6.ExpandLayoutWrapperWithRef)
        }, /*#__PURE__*/ (0, $jctmk.jsx)(Component, props)));
    };
}
const $59842f758a64c973$export$aca20190620a52ea = (props)=>{
    const useTheme = (0, $fc4bM.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (currentTheme, themeProps)=>{
        const { buttonStyles: buttonStyles, ...rest } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                height: '100%',
                '& svg': {
                    transform: props.expanded ? 'transform: rotate(90deg);' : 'transform: rotate(0deg);',
                    transition: `transform 0.2s ${0, $014x6.akEditorSwoopCubicBezier};`
                }
            },
            ...rest
        };
    }, [
        props
    ]);
    const { intl: intl, expanded: expanded } = props;
    const label = expanded ? (0, $62lW6.messages).collapseNode : (0, $62lW6.messages).expandNode;
    const labelIntl = intl ? intl.formatMessage(label) : label.defaultMessage;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $k7lry.default), {
        appearance: "subtle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $45eKC.expandClassNames).iconContainer,
        iconBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6))), {
            label: '',
            size: "small"
        }),
        shouldFitContainer: true,
        theme: useTheme,
        "aria-label": labelIntl,
        "aria-expanded": props.expanded,
        isDisabled: !props.allowInteractiveExpand
    });
};
const $59842f758a64c973$var$ButtonWithTooltip = $59842f758a64c973$var$withTooltip($59842f758a64c973$export$aca20190620a52ea);
const $59842f758a64c973$var$ButtonWithoutTooltip = $59842f758a64c973$export$aca20190620a52ea;
const $59842f758a64c973$export$5663c8f5aeb8c1c4 = (props)=>{
    const { expanded: expanded, intl: intl } = props;
    const message = expanded ? (0, $62lW6.messages).collapseNode : (0, $62lW6.messages).expandNode;
    const label = intl && intl.formatMessage(message) || message.defaultMessage;
    // check to ensure device supports any-hover
    const supportsAnyHover = !!window.matchMedia ? window.matchMedia('(any-hover: hover)').matches !== window.matchMedia('(any-hover: none)').matches : false;
    const hoverEventCheck = supportsAnyHover ? window.matchMedia('(any-hover: hover)').matches : true;
    // hoverEventCheck is to disable tooltips for mobile to prevent incorrect hover state causing issues on iOS
    if (props.allowInteractiveExpand && hoverEventCheck) // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $jctmk.jsx)($59842f758a64c973$var$ButtonWithTooltip, {
        label: label,
        ...props
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $62lW6.expandLayoutWrapperStyle)
    }, /*#__PURE__*/ (0, $jctmk.jsx)($59842f758a64c973$var$ButtonWithoutTooltip, {
        label: label,
        ...props
    })));
};

});

parcelRegister("rxygm", function(module, exports) {
$parcel$export(module.exports, "buildExpandClassName", () => $51fa8ee6518b2c1c$export$f7373e0b2eb22549);
$parcel$export(module.exports, "getExpandBodyAriaLabel", () => $51fa8ee6518b2c1c$export$4bb8383fcf1d1fef);
$parcel$export(module.exports, "toDOM", () => $51fa8ee6518b2c1c$export$289411c5a7970646);

var $hIUTz = parcelRequire("hIUTz");

var $45eKC = parcelRequire("45eKC");

var $62lW6 = parcelRequire("62lW6");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");
const $51fa8ee6518b2c1c$export$f7373e0b2eb22549 = (type, expanded)=>{
    return `${(0, $45eKC.expandClassNames).prefix} ${(0, $45eKC.expandClassNames).type(type)} ${expanded ? (0, $45eKC.expandClassNames).expanded : ''}`;
};
const $51fa8ee6518b2c1c$export$4bb8383fcf1d1fef = (title, intl)=>{
    const safeTitle = title.trim() || (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyAriaLabelUntitled)) || (0, $62lW6.messages).expandBodyAriaLabelUntitled.defaultMessage;
    return (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyAriaLabel, {
        title: safeTitle
    })) || (0, $62lW6.messages).expandBodyAriaLabel.defaultMessage.replace('{title}', safeTitle);
};
const $51fa8ee6518b2c1c$export$289411c5a7970646 = (node, __livePage, intl, titleReadOnly, contentEditable)=>[
        'div',
        {
            // prettier-ignore
            'class': $51fa8ee6518b2c1c$export$f7373e0b2eb22549(node.type.name, (0, $hIUTz.expandedState).get(node) ?? false),
            'data-node-type': node.type.name,
            'data-title': node.attrs.title,
            ...(0, $dRkX9.fg)('platform_editor_adf_with_localid') && {
                'data-local-id': node.attrs.localId
            }
        },
        [
            'div',
            {
                // prettier-ignore
                'class': (0, $45eKC.expandClassNames).titleContainer,
                contenteditable: 'false',
                // Element gains access to focus events.
                // This is needed to prevent PM gaining access
                // on interacting with our controls.
                tabindex: '-1'
            },
            // prettier-ignore
            [
                'div',
                {
                    'class': (0, $45eKC.expandClassNames).icon,
                    style: `display: flex; width: ${"var(--ds-space-300, 24px)"}; height: ${"var(--ds-space-300, 24px)"}`
                }
            ],
            [
                'div',
                {
                    // prettier-ignore
                    'class': (0, $45eKC.expandClassNames).inputContainer
                },
                [
                    'input',
                    {
                        // prettier-ignore
                        'class': (0, $45eKC.expandClassNames).titleInput,
                        'aria-label': intl && intl.formatMessage((0, $62lW6.messages).expandArialabel) || (0, $62lW6.messages).expandArialabel.defaultMessage,
                        value: node.attrs.title,
                        placeholder: intl && typeof intl.formatMessage === 'function' && intl.formatMessage((0, $62lW6.messages).expandPlaceholderText) || (0, $62lW6.messages).expandPlaceholderText.defaultMessage,
                        type: 'text',
                        readonly: titleReadOnly ? 'true' : undefined
                    }
                ]
            ]
        ],
        [
            (0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps') ? 'section' : 'div',
            {
                // prettier-ignore
                class: `${(0, $45eKC.expandClassNames).content} ${(0, $hIUTz.expandedState).get(node) ? '' : (0, $45eKC.expandClassNames).contentCollapsed}`,
                contenteditable: contentEditable !== undefined ? contentEditable ? 'true' : 'false' : undefined,
                ...!((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps')) && {
                    role: 'textbox',
                    'aria-multiline': 'true',
                    'aria-label': intl && intl.formatMessage((0, $62lW6.messages).expandBodyAriaLabelOriginal) || (0, $62lW6.messages).expandBodyAriaLabelOriginal.defaultMessage
                },
                ...((0, $bcN2K.isExperimentEnabled)('platform_editor_expand_content_a11y_2') || (0, $dRkX9.fg)('platform_editor_expand_content_a11y_other_apps')) && {
                    'aria-label': $51fa8ee6518b2c1c$export$4bb8383fcf1d1fef(node.attrs.title ?? '', intl),
                    'aria-description': (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyAriaDescription)) || (0, $62lW6.messages).expandBodyAriaDescription.defaultMessage,
                    'aria-roledescription': (intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $62lW6.messages).expandBodyRoleDescription)) ?? (0, $62lW6.messages).expandBodyRoleDescription.defaultMessage
                }
            },
            0
        ]
    ];

});

parcelRegister("4ejVi", function(module, exports) {
$parcel$export(module.exports, "findSelectedParentExpandNode", () => $e2757882bfc6274d$export$60784e18d5db1cae);
$parcel$export(module.exports, "findReplaceExpandDecorations", () => $e2757882bfc6274d$export$ce3a0b3822605e07);

var $hIUTz = parcelRequire("hIUTz");

var $a4TQr = parcelRequire("a4TQr");
// from platform/packages/editor/editor-plugin-find-replace/src/ui/styles.ts
const $e2757882bfc6274d$var$darkModeSearchMatchClass = 'search-match-dark';
const $e2757882bfc6274d$var$searchMatchExpandTitleClass = 'search-match-expand-title';
const $e2757882bfc6274d$var$selectedSearchMatchClass = 'selected-search-match';
const $e2757882bfc6274d$export$60784e18d5db1cae = (state)=>{
    const nestedOrParentExpand = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.nestedExpand)(state.selection) || (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
    // If it's nested expand, we should check if its parent expand is collapsed.
    // If the parent expand is collapsed, the nested expand is not visible,
    // so it could not be selected.
    // In this case, we return the parent expand node instead of the nested expand node.
    if ((nestedOrParentExpand === null || nestedOrParentExpand === void 0 ? void 0 : nestedOrParentExpand.node.type) === state.schema.nodes.nestedExpand) {
        const parentExpand = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.expand)(state.selection);
        if (parentExpand && (0, $hIUTz.isExpandCollapsed)(parentExpand.node)) return parentExpand;
    }
    return nestedOrParentExpand;
};
const $e2757882bfc6274d$export$ce3a0b3822605e07 = [
    $e2757882bfc6274d$var$darkModeSearchMatchClass,
    $e2757882bfc6274d$var$searchMatchExpandTitleClass,
    $e2757882bfc6274d$var$selectedSearchMatchClass
];

});



parcelRegister("kmVVs", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $2e5621d3b23a30c8$export$86ce8f8241c20a3);

var $3uluy = parcelRequire("3uluy");

var $a4TQr = parcelRequire("a4TQr");

var $Admw7 = parcelRequire("Admw7");

var $sjpTk = parcelRequire("sjpTk");

var $4ejVi = parcelRequire("4ejVi");
const $2e5621d3b23a30c8$export$86ce8f8241c20a3 = (api)=>(state, { formatMessage: formatMessage })=>{
        var _api$decorations, _api$analytics;
        const { hoverDecoration: hoverDecoration } = (api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions) ?? {};
        const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
        const selectedExpandNode = (0, $4ejVi.findSelectedParentExpandNode)(state);
        if (selectedExpandNode) {
            const { nestedExpand: nestedExpand, expand: expand } = state.schema.nodes;
            return {
                title: 'Expand toolbar',
                getDomRef: (view)=>// Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    (0, $a4TQr.findDomRefAtPos)(selectedExpandNode.pos, view.domAtPos.bind(view)),
                nodeType: [
                    nestedExpand,
                    expand
                ],
                offset: [
                    0,
                    6
                ],
                items: [
                    {
                        type: 'copy-button',
                        items: [
                            {
                                state: state,
                                formatMessage: formatMessage,
                                nodeType: [
                                    nestedExpand,
                                    expand
                                ]
                            }
                        ]
                    },
                    {
                        type: 'separator'
                    },
                    {
                        id: 'editor.expand.delete',
                        type: 'button',
                        appearance: 'danger',
                        focusEditoronEnter: true,
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($Admw7))),
                        onClick: (0, $sjpTk.deleteExpand)(editorAnalyticsAPI),
                        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], true),
                        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], false),
                        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], true),
                        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration([
                            nestedExpand,
                            expand
                        ], false),
                        title: formatMessage((0, $3uluy.default).remove),
                        tabIndex: null
                    }
                ]
            };
        }
        return;
    };

});



parcelRegister("1cPUW", function(module, exports) {
$parcel$export(module.exports, "extensionPlugin", () => $91146fa734519541$export$feb99ebbc74a9193);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $eUgRu = parcelRequire("eUgRu");

var $iglh1 = parcelRequire("iglh1");

var $608PD = parcelRequire("608PD");

var $jXulL = parcelRequire("jXulL");

var $1y7gE = parcelRequire("1y7gE");

var $dRkX9 = parcelRequire("dRkX9");

var $1FRDO = parcelRequire("1FRDO");

var $5Edew = parcelRequire("5Edew");

var $gpw0O = parcelRequire("gpw0O");

var $cqK8o = parcelRequire("cqK8o");

var $kaj3r = parcelRequire("kaj3r");

var $g4M4j = parcelRequire("g4M4j");

var $8TbB8 = parcelRequire("8TbB8");

var $5ujGm = parcelRequire("5ujGm");

var $dPjti = parcelRequire("dPjti");

var $jqo51 = parcelRequire("jqo51");

var $9WASI = parcelRequire("9WASI");

var $aLKBL = parcelRequire("aLKBL");

var $40e3d = parcelRequire("40e3d");

var $eZJFp = parcelRequire("eZJFp");
const $91146fa734519541$export$feb99ebbc74a9193 = ({ config: options = {}, api: api })=>{
    var _api$featureFlags, _api$contextPanel, _api$analytics2, _api$analytics3, _api$contextPanel4;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const configPanelId = `${(0, $aLKBL.CONFIG_PANEL_ID)}-${(0, $eUgRu.default)()}`;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    //Note: This is a hack to get the editor view reference in the plugin. Copied from table plugin.
    //This is needed to get the current selection in the editor
    const editorViewRef = {
        current: null
    };
    const extensionLoadingHandlers = {};
    const showContextPanel = api === null || api === void 0 || (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 || (_api$contextPanel = _api$contextPanel.actions) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.showPanel;
    return {
        name: 'extension',
        nodes () {
            const extensionNodes = [
                {
                    name: 'extension',
                    node: (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') ? (0, $iglh1.extensionWithAnnotationStage0) : (0, $iglh1.extension)
                },
                {
                    name: 'bodiedExtension',
                    node: (0, $dPjti.bodiedExtensionSpecWithFixedToDOM)()
                },
                {
                    name: 'inlineExtension',
                    node: (0, $608PD.inlineExtension)
                },
                {
                    name: 'extensionFrame',
                    node: (0, $jXulL.extensionFrame)
                },
                {
                    name: 'multiBodiedExtension',
                    node: (0, $jXulL.multiBodiedExtension)
                }
            ];
            return extensionNodes;
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $5ujGm.pluginKey).getState(state);
            return {
                showContextPanel: pluginState === null || pluginState === void 0 ? void 0 : pluginState.showContextPanel,
                extensionProvider: pluginState === null || pluginState === void 0 ? void 0 : pluginState.extensionProvider,
                processParametersAfter: pluginState === null || pluginState === void 0 ? void 0 : pluginState.processParametersAfter
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'extension',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory, portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const extensionHandlers = options.extensionHandlers || {};
                        return (0, $8TbB8.createPlugin)(dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, api, options.useLongPressSelection, {
                            appearance: options.appearance,
                            getExtensionHeight: options.getExtensionHeight,
                            allowAIGeneratedContentMotion: options.allowAIGeneratedContentMotion
                        }, featureFlags, options === null || options === void 0 ? void 0 : options.__rendererExtensionOptions, getIntl());
                    }
                },
                {
                    name: 'extensionKeymap',
                    plugin: ()=>{
                        var _api$contextPanel2;
                        return (0, $cqK8o.default)(api === null || api === void 0 || (_api$contextPanel2 = api.contextPanel) === null || _api$contextPanel2 === void 0 ? void 0 : _api$contextPanel2.actions.applyChange);
                    }
                },
                {
                    name: 'extensionUniqueId',
                    plugin: ()=>(0, $9WASI.createPlugin)()
                },
                {
                    name: 'extensionEditorViewRef',
                    plugin: ()=>{
                        return new (0, $1y7gE.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                },
                {
                    name: 'macro',
                    plugin: ({ dispatch: dispatch, providerFactory: providerFactory })=>(0, $g4M4j.createPlugin)(dispatch, providerFactory)
                }
            ];
        },
        actions: {
            api: ()=>{
                var _api$contextPanel3, _api$analytics;
                return (0, $gpw0O.createExtensionAPI)({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    editorView: editorViewRef.current,
                    applyChange: api === null || api === void 0 || (_api$contextPanel3 = api.contextPanel) === null || _api$contextPanel3 === void 0 ? void 0 : _api$contextPanel3.actions.applyChange,
                    editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions
                });
            },
            getExtensionLoadingHandlers: ()=>extensionLoadingHandlers,
            insertMacroFromMacroBrowser: (0, $kaj3r.insertMacroFromMacroBrowser)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions),
            insertOrReplaceExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $1FRDO.insertOrReplaceExtension)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            insertOrReplaceBodiedExtension: ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size, tr: tr })=>(0, $1FRDO.insertOrReplaceBodiedExtension)({
                    editorView: editorView,
                    action: action,
                    attrs: attrs,
                    content: content,
                    position: position,
                    size: size,
                    tr: tr
                }),
            editSelectedExtension: (0, $1FRDO.createEditSelectedExtensionAction)({
                editorViewRef: editorViewRef,
                editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions,
                applyChangeToContextPanel: api === null || api === void 0 || (_api$contextPanel4 = api.contextPanel) === null || _api$contextPanel4 === void 0 ? void 0 : _api$contextPanel4.actions.applyChange
            }),
            registerExtensionLoadingHandler: ({ extensionType: extensionType, handler: handler })=>{
                extensionLoadingHandlers[extensionType] = handler;
                return ()=>{
                    if (extensionLoadingHandlers[extensionType] === handler) delete extensionLoadingHandlers[extensionType];
                };
            },
            runMacroAutoConvert: $kaj3r.runMacroAutoConvert,
            forceAutoSave: $5Edew.forceAutoSave
        },
        pluginsOptions: {
            floatingToolbar: (0, $jqo51.getToolbarConfig)({
                breakoutEnabled: options.breakoutEnabled,
                copyEnabled: options.copyEnabled,
                deleteEnabled: options.deleteEnabled,
                extensionApi: api,
                getUnsupportedContent: options.getUnsupportedContent
            }),
            contextPanel: !showContextPanel ? (0, $40e3d.getContextPanel)(()=>editorViewRef.current ?? undefined)(api, featureFlags) : undefined
        },
        usePluginHook: showContextPanel ? ({ editorView: editorView })=>{
            (0, $eZJFp.useConfigPanelPluginHook)({
                api: api,
                configPanelId: configPanelId,
                editorView: editorView
            });
        } : undefined
    };
};

});
parcelRegister("1FRDO", function(module, exports) {
$parcel$export(module.exports, "buildExtensionNode", () => $00bd7450d10ca736$export$5e06148a47ef53c2);
$parcel$export(module.exports, "editExtension", () => $00bd7450d10ca736$export$f45ebaf24963f4bb);
$parcel$export(module.exports, "createEditSelectedExtensionAction", () => $00bd7450d10ca736$export$1efb7858e16078f5);
$parcel$export(module.exports, "insertOrReplaceExtension", () => $00bd7450d10ca736$export$f151d046c10e64b5);
$parcel$export(module.exports, "insertOrReplaceBodiedExtension", () => $00bd7450d10ca736$export$8ee156b55126996c);

var $3LeME = parcelRequire("3LeME");

var $itGnS = parcelRequire("itGnS");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $gpw0O = parcelRequire("gpw0O");

var $5vS9r = parcelRequire("5vS9r");

var $83R7C = parcelRequire("83R7C");
const $00bd7450d10ca736$export$5e06148a47ef53c2 = (type, schema, attrs, content, marks)=>{
    switch(type){
        case 'extension':
            return schema.nodes.extension.createChecked(attrs, content, marks);
        case 'inlineExtension':
            return schema.nodes.inlineExtension.createChecked(attrs, content, marks);
        case 'bodiedExtension':
            return schema.nodes.bodiedExtension.create(attrs, content, marks);
        case 'multiBodiedExtension':
            return schema.nodes.multiBodiedExtension.create(attrs, content, marks);
    }
};
const $00bd7450d10ca736$export$60b0a40d996019c8 = (editorAnalyticsAPI)=>(type, newAttrs, content, marks, shouldScrollIntoView)=>(_state, _dispatch, view)=>{
            if (!view) throw Error('EditorView is required to perform node update!');
            // NOTE: `state` and `dispatch` are stale at this point so we need to grab
            // the latest one from `view` @see HOT-93986
            const { state: state, dispatch: dispatch } = view;
            const newNode = $00bd7450d10ca736$export$5e06148a47ef53c2(type, state.schema, newAttrs, content, marks);
            if (!newNode) return false;
            const { selection: selection, schema: schema } = state;
            const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
            const isBodiedExtensionSelected = !!(0, $a4TQr.findSelectedNodeOfType)([
                bodiedExtension
            ])(selection);
            const isMultiBodiedExtensionSelected = !!(0, $a4TQr.findSelectedNodeOfType)([
                multiBodiedExtension
            ])(selection);
            const extensionState = (0, $5vS9r.getPluginState)(state);
            const updateSelectionsByNodeType = (nodeType)=>{
                // Bodied/MultiBodied extensions can trigger an update when the cursor is inside which means that there is no node selected.
                // To work around that we replace the parent and create a text selection instead of new node selection
                tr = (0, $a4TQr.replaceParentNodeOfType)(nodeType, newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $801jp.TextSelection).create(tr.doc, state.selection.anchor));
            };
            let targetSelectionSource = (0, $itGnS.TARGET_SELECTION_SOURCE).CURRENT_SELECTION;
            let action = (0, $3LeME.ACTION).UPDATED;
            let { tr: tr } = state;
            // When it's a bodiedExtension but not selected
            if (newNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
            else if (newNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
            else if ((0, $a4TQr.findSelectedNodeOfType)([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ])(selection)) {
                tr = (0, $a4TQr.replaceSelectedNode)(newNode)(tr);
                // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                tr.setSelection((0, $801jp.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
            } else if (extensionState.element) {
                const pos = view.posAtDOM(extensionState.element, -1);
                if (pos > -1) {
                    tr = tr.replaceWith(pos, pos + (content.size || 0) + 1, newNode);
                    tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(pos)));
                    targetSelectionSource = (0, $itGnS.TARGET_SELECTION_SOURCE).HTML_ELEMENT;
                } else action = (0, $3LeME.ACTION).ERRORED;
            }
            // Only scroll if we have anything to update, best to avoid surprise scroll
            if (dispatch && tr.docChanged) {
                const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = newNode.attrs;
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: action,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
                    actionSubjectId: newNode.type.name,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                        // This error was introduced after upgrading to TypeScript 5
                        inputMethod: (0, $3LeME.INPUT_METHOD).CONFIG_PANEL,
                        extensionType: extensionType,
                        extensionKey: extensionKey,
                        layout: layout,
                        localId: localId,
                        selection: tr.selection.toJSON(),
                        targetSelectionSource: targetSelectionSource
                    }
                })(tr);
                dispatch(shouldScrollIntoView ? tr.scrollIntoView() : tr);
            }
            return true;
        };
const $00bd7450d10ca736$var$updateExtensionParams = (editorAnalyticsAPI)=>(updateExtension, node, actions)=>async (state, dispatch, view)=>{
            const { attrs: attrs, type: type, content: content, marks: marks } = node.node;
            if (!state.schema.nodes[type.name]) return false;
            const { parameters: parameters } = attrs;
            try {
                const newParameters = await updateExtension(parameters, actions);
                if (newParameters) {
                    const newAttrs = {
                        ...attrs,
                        parameters: {
                            ...parameters,
                            ...newParameters
                        }
                    };
                    if (type.name === 'multiBodiedExtension') newAttrs.parameters.macroParams = {
                        ...parameters.macroParams,
                        ...newParameters === null || newParameters === void 0 ? void 0 : newParameters.macroParams
                    };
                    return $00bd7450d10ca736$export$60b0a40d996019c8(editorAnalyticsAPI)(type.name, newAttrs, content, marks, true)(state, dispatch, view);
                }
            } catch  {}
            return true;
        };
const $00bd7450d10ca736$export$f45ebaf24963f4bb = (macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)=>(state, dispatch, view)=>{
        if (!view) return false;
        const { localId: localId } = (0, $5vS9r.getPluginState)(state);
        const nodeWithPos = (0, $83R7C.findExtensionWithLocalId)(state, localId);
        if (!nodeWithPos) return false;
        const editInLegacyMacroBrowser = (0, $gpw0O.getEditInLegacyMacroBrowser)({
            view: view,
            macroProvider: macroProvider || undefined,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
        if (updateExtension) updateExtension.then((updateMethod)=>{
            if (updateMethod && view) {
                const actions = (0, $gpw0O.createExtensionAPI)({
                    editorView: view,
                    editInLegacyMacroBrowser: editInLegacyMacroBrowser,
                    applyChange: applyChangeToContextPanel,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
                $00bd7450d10ca736$var$updateExtensionParams(editorAnalyticsAPI)(updateMethod, nodeWithPos, actions)(state, dispatch, view);
                return;
            }
            if (!updateMethod && macroProvider) {
                editInLegacyMacroBrowser();
                return;
            }
        });
        else {
            if (!macroProvider) return false;
            editInLegacyMacroBrowser();
        }
        return true;
    };
const $00bd7450d10ca736$export$1efb7858e16078f5 = ({ editorViewRef: editorViewRef, editorAnalyticsAPI: editorAnalyticsAPI, applyChangeToContextPanel: applyChangeToContextPanel })=>()=>{
        const { current: view } = editorViewRef;
        if (!view) return false;
        const { updateExtension: updateExtension } = (0, $5vS9r.getPluginState)(view.state);
        return $00bd7450d10ca736$export$f45ebaf24963f4bb(null, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(view.state, view.dispatch, view);
    };
const $00bd7450d10ca736$export$f151d046c10e64b5 = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('extension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};
const $00bd7450d10ca736$export$8ee156b55126996c = ({ editorView: editorView, action: action, attrs: attrs, content: content, position: position, size: size = 0, tr: tr })=>{
    const newNode = editorView.state.schema.node('bodiedExtension', attrs, content);
    if (action === 'insert') {
        tr = editorView.state.tr.insert(position, newNode);
        return tr;
    } else {
        tr.replaceWith(position, position + size, newNode);
        return tr;
    }
};

});
parcelRegister("itGnS", function(module, exports) {
$parcel$export(module.exports, "TARGET_SELECTION_SOURCE", () => $5f247ffd7d99410b$export$b9401faa25e39d87);
var $5f247ffd7d99410b$export$bbbdd76b3dbe0ab9 = /*#__PURE__*/ function(GAP_CURSOR_POSITION) {
    GAP_CURSOR_POSITION["LEFT"] = "left";
    GAP_CURSOR_POSITION["RIGHT"] = "right";
    return GAP_CURSOR_POSITION;
}({});
var $5f247ffd7d99410b$export$b9401faa25e39d87 = /*#__PURE__*/ function(TARGET_SELECTION_SOURCE) {
    TARGET_SELECTION_SOURCE["CURRENT_SELECTION"] = "currentSelection";
    TARGET_SELECTION_SOURCE["HTML_ELEMENT"] = "htmlElement";
    return TARGET_SELECTION_SOURCE;
}({});

});

parcelRegister("gpw0O", function(module, exports) {
$parcel$export(module.exports, "getEditInLegacyMacroBrowser", () => $432b423165462e0d$export$5c24840493a9fa44);
$parcel$export(module.exports, "createExtensionAPI", () => $432b423165462e0d$export$5c70dcf0377b6800);

var $77DyS = parcelRequire("77DyS");

var $3LeME = parcelRequire("3LeME");

var $ju7Hl = parcelRequire("ju7Hl");

var $cu8Jp = parcelRequire("cu8Jp");

var $f7AYl = parcelRequire("f7AYl");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $aEmSo = parcelRequire("aEmSo");

var $5Edew = parcelRequire("5Edew");

var $kaj3r = parcelRequire("kaj3r");

var $5JOt5 = parcelRequire("5JOt5");

var $83R7C = parcelRequire("83R7C");
const $432b423165462e0d$export$5c24840493a9fa44 = ({ view: view, macroProvider: macroProvider, editorAnalyticsAPI: editorAnalyticsAPI })=>{
    return ()=>{
        if (!view) throw new Error(`Missing view. Can't update without EditorView`);
        if (!macroProvider) throw new Error(`Missing macroProvider. Can't use the macro browser for updates`);
        const nodeWithPos = (0, $83R7C.getSelectedExtension)(view.state, true);
        if (!nodeWithPos) throw new Error(`Missing nodeWithPos. Can't determine position of node`);
        (0, $kaj3r.insertMacroFromMacroBrowser)(editorAnalyticsAPI)(macroProvider, nodeWithPos.node, true)(view);
    };
};
const $432b423165462e0d$var$extensionAPICallPayload = (functionName)=>({
        action: (0, $3LeME.ACTION).INVOKED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION_API,
        attributes: {
            functionName: functionName
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    });
const $432b423165462e0d$export$5c70dcf0377b6800 = (options)=>{
    const { editorView: { state: { schema: schema } }, editorAnalyticsAPI: editorAnalyticsAPI } = options;
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $77DyS.validator)(nodes, marks, {
        allowPrivateAttributes: true,
        stage0: true
    });
    /**
   * Finds the node and its position by `localId`. Throws if the node could not be found.
   *
   * @returns {NodeWithPos}
   */ const ensureNodePosByLocalId = (localId, { opName: opName })=>{
        // Be extra cautious since 3rd party devs can use regular JS without type safety
        if (typeof localId !== 'string' || localId === '') throw new Error(`${opName}(): Invalid localId '${localId}'.`);
        // Find the node + position matching the given ID
        const { editorView: { state: state } } = options;
        const nodePos = (0, $83R7C.findNodePosWithLocalId)(state, localId);
        if (!nodePos) throw new Error(`${opName}(): Could not find node with ID '${localId}'.`);
        return nodePos;
    };
    const doc = {
        insertAfter: (localId, adf, opt)=>{
            try {
                validate(adf);
            } catch (e) {
                throw new Error(`insertAfter(): Invalid ADF given.`);
            }
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'insertAfter'
            });
            const { editorView: editorView } = options;
            const { dispatch: dispatch, state: state } = editorView;
            // Validate the given ADF
            const { tr: tr, schema: schema } = state;
            const nodeType = schema.nodes[adf.type];
            if (!nodeType) throw new Error(`insertAfter(): Invalid ADF type '${adf.type}'.`);
            const fragment = (0, $7H6Cr.Fragment).fromJSON(schema, adf.content);
            const marks = (adf.marks || []).map((markEntity)=>(0, $7H6Cr.Mark).fromJSON(schema, markEntity));
            const newNode = nodeType === null || nodeType === void 0 ? void 0 : nodeType.createChecked(adf.attrs, fragment, marks);
            if (!newNode) throw new Error('insertAfter(): Could not create a node for given ADFEntity.');
            const insertPosition = nodePos.pos + nodePos.node.nodeSize;
            tr.insert(insertPosition, newNode);
            // Validate if the document is valid at this point
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAfter(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $432b423165462e0d$var$extensionAPICallPayload('insertAfter');
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(apiCallPayload)(tr);
            // Analytics - tracking node types added
            const nodesAdded = [
                newNode
            ];
            newNode.descendants((node)=>{
                nodesAdded.push(node);
                return true;
            });
            nodesAdded.forEach((node)=>{
                const { extensionKey: extensionKey, extensionType: extensionType } = node.attrs;
                const dataConsumerMark = (0, $83R7C.getDataConsumerMark)(node);
                const stringIds = (dataConsumerMark === null || dataConsumerMark === void 0 ? void 0 : dataConsumerMark.attrs.sources.map((sourceId)=>sourceId)) || [];
                const hasReferentiality = !!dataConsumerMark;
                const nodeTypesReferenced = hasReferentiality ? (0, $83R7C.getNodeTypesReferenced)(stringIds, state) : undefined;
                // fire off analytics for this ADF
                const payload = {
                    action: (0, $3LeME.ACTION).INSERTED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                    attributes: {
                        nodeType: node.type.name,
                        inputMethod: (0, $3LeME.INPUT_METHOD).EXTENSION_API,
                        hasReferentiality: hasReferentiality,
                        nodeTypesReferenced: nodeTypesReferenced,
                        layout: node.attrs.layout,
                        extensionType: extensionType,
                        extensionKey: extensionKey
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                };
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
            });
            if (opt) {
                if (opt.allowSelectionToNewNode) tr.setSelection(new (0, $801jp.NodeSelection)(tr.doc.resolve(insertPosition)));
                else if (opt.allowSelectionNearNewNode) tr.setSelection((0, $801jp.TextSelection).near(tr.doc.resolve(insertPosition)));
            }
            dispatch(tr);
        },
        insertAtSelection: (adf)=>{
            try {
                validate(adf);
            } catch  {
                throw new Error(`insertAtSelection(): Invalid ADF given.`);
            }
            const { dispatch: dispatch, state: state } = options.editorView;
            const newNode = state.schema.nodeFromJSON(adf);
            const tr = state.tr.replaceSelectionWith(newNode).scrollIntoView();
            try {
                tr.doc.check();
            } catch (err) {
                throw new Error(`insertAtSelection(): The given ADFEntity cannot replace the current selection.\n${err}`);
            }
            const apiCallPayload = $432b423165462e0d$var$extensionAPICallPayload('insertAtSelection');
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(apiCallPayload)(tr);
            dispatch(tr);
        },
        scrollTo: (localId)=>{
            const nodePos = ensureNodePosByLocalId(localId, {
                opName: 'scrollTo'
            });
            // Analytics - tracking the api call
            const apiCallPayload = $432b423165462e0d$var$extensionAPICallPayload('scrollTo');
            const { editorView: { dispatch: dispatch, state: state } } = options;
            let { tr: tr } = state;
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(apiCallPayload)(tr);
            tr = (0, $a4TQr.setTextSelection)(nodePos.pos)(tr);
            let useScrollIntoView = true;
            if (nodePos.node.type.name === 'table' && (0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) {
                const tableDOM = options.editorView.nodeDOM(nodePos.pos);
                if (tableDOM instanceof HTMLElement) {
                    tableDOM.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth'
                    });
                    useScrollIntoView = false;
                }
            }
            if (useScrollIntoView) tr.scrollIntoView();
            dispatch(tr);
        },
        update: (localId, mutationCallback, opts)=>{
            var _changedValues$marks;
            const { node: node, pos: pos } = ensureNodePosByLocalId(localId, {
                opName: 'update'
            });
            const { editorView: { dispatch: dispatch, state: state } } = options;
            const { tr: tr, schema: schema } = state;
            const changedValues = mutationCallback({
                type: node.type.name,
                content: (0, $cu8Jp.nodeToJSON)(node).content,
                attrs: node.attrs,
                marks: node.marks.map((pmMark)=>({
                        type: pmMark.type.name,
                        attrs: pmMark.attrs
                    }))
            });
            const ensureValidMark = (mark)=>{
                if (typeof mark !== 'object' || Array.isArray(mark)) throw new Error(`update(): Invalid mark given.`);
                const { parent: parent } = state.doc.resolve(pos);
                // Ensure that the given mark is present in the schema
                const markType = schema.marks[mark.type];
                if (!markType) throw new Error(`update(): Invalid ADF mark type '${mark.type}'.`);
                if (!parent.type.allowsMarkType(markType)) throw new Error(`update(): Parent of type '${parent.type.name}' does not allow marks of type '${mark.type}'.`);
                return {
                    mark: markType,
                    attrs: mark.attrs
                };
            };
            const newMarks = changedValues.hasOwnProperty('marks') ? (_changedValues$marks = changedValues.marks) === null || _changedValues$marks === void 0 ? void 0 : _changedValues$marks.map(ensureValidMark).map(({ mark: mark, attrs: attrs })=>mark.create(attrs)) : node.marks;
            const newContent = changedValues.hasOwnProperty('content') ? (0, $7H6Cr.Fragment).fromJSON(schema, changedValues.content) : node.content;
            let newType = node.type;
            if (changedValues.hasOwnProperty('type') && changedValues.type !== node.type.name) newType = changedValues.type ? schema.nodes[changedValues.type] : undefined;
            if (!newType) throw new Error(`update(): Invalid ADF node type '${changedValues.type}'.`);
            let newAttrs = changedValues.hasOwnProperty('attrs') ? changedValues.attrs : node.attrs;
            if (node.type.name === 'multiBodiedExtension') {
                var _changedValues$attrs, _node$attrs$parameter, _changedValues$attrs2;
                newAttrs = {
                    ...node.attrs,
                    ...changedValues.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(_changedValues$attrs = changedValues.attrs) === null || _changedValues$attrs === void 0 ? void 0 : _changedValues$attrs.parameters,
                        macroParams: {
                            ...(_node$attrs$parameter = node.attrs.parameters) === null || _node$attrs$parameter === void 0 ? void 0 : _node$attrs$parameter.macroParams,
                            ...(_changedValues$attrs2 = changedValues.attrs) === null || _changedValues$attrs2 === void 0 || (_changedValues$attrs2 = _changedValues$attrs2.parameters) === null || _changedValues$attrs2 === void 0 ? void 0 : _changedValues$attrs2.macroParams
                        }
                    }
                };
            // console.log('newAttrs', newAttrs);
            }
            // Validate if the new attributes, content and marks result in a valid node and adf.
            try {
                const newNode = newType.createChecked(newAttrs, newContent, newMarks);
                const newNodeAdf = new (0, $f7AYl.JSONTransformer)().encodeNode(newNode);
                validate(newNodeAdf);
                if (newType === node.type) tr.replaceWith(pos, pos + node.nodeSize, newNode);
                else {
                    tr.replaceRangeWith(pos, pos + node.nodeSize, newNode);
                    if (node.isBlock && newNode.isInline) (0, $ju7Hl.autoJoinTr)(tr, [
                        'paragraph'
                    ]);
                    tr.doc.check();
                }
                // Keep selection if content does not change
                if (newType === node.type && newContent === node.content) tr.setSelection((0, $801jp.Selection).fromJSON(tr.doc, state.selection.toJSON()));
            } catch (err) {
                throw new Error(`update(): The given ADFEntity cannot be inserted in the current position.\n${err}`);
            }
            // Analytics - tracking the api call
            const apiCallPayload = $432b423165462e0d$var$extensionAPICallPayload('update');
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(apiCallPayload)(tr);
            if (typeof (opts === null || opts === void 0 ? void 0 : opts.addToHistory) === 'boolean') tr.setMeta('addToHistory', opts.addToHistory);
            if (typeof (opts === null || opts === void 0 ? void 0 : opts.scrollIntoView) === 'boolean') tr.setMeta('scrollIntoView', opts.scrollIntoView);
            dispatch(tr);
        }
    };
    return {
        editInContextPanel: (transformBefore, transformAfter)=>{
            const { editorView: editorView } = options;
            (0, $5Edew.setEditingContextToContextPanel)(transformBefore, transformAfter, options.applyChange)(editorView.state, editorView.dispatch, editorView);
        },
        _editInLegacyMacroBrowser: ()=>{
            const { editorView: editorView } = options;
            let editInLegacy = options.editInLegacyMacroBrowser;
            if (!editInLegacy) {
                const macroState = (0, $5JOt5.pluginKey).getState(editorView.state);
                editInLegacy = $432b423165462e0d$export$5c24840493a9fa44({
                    view: options.editorView,
                    macroProvider: (macroState === null || macroState === void 0 ? void 0 : macroState.macroProvider) || undefined,
                    editorAnalyticsAPI: editorAnalyticsAPI
                });
            }
            editInLegacy();
        },
        getNodeWithPosByLocalId: (localId)=>{
            return ensureNodePosByLocalId(localId, {
                opName: 'getNodeWithPosByLocalId'
            });
        },
        doc: doc
    };
};

});
parcelRegister("5Edew", function(module, exports) {
$parcel$export(module.exports, "updateState", () => $433e085c764f9701$export$4971331372cec95a);
$parcel$export(module.exports, "setEditingContextToContextPanel", () => $433e085c764f9701$export$845f8c516a847983);
$parcel$export(module.exports, "clearEditingContext", () => $433e085c764f9701$export$81748740fe20ba64);
$parcel$export(module.exports, "forceAutoSave", () => $433e085c764f9701$export$265d048971b3d878);
$parcel$export(module.exports, "updateExtensionLayout", () => $433e085c764f9701$export$612be0ec35a64e3b);
$parcel$export(module.exports, "removeExtension", () => $433e085c764f9701$export$366c74c25333cf63);
$parcel$export(module.exports, "removeDescendantNodes", () => $433e085c764f9701$export$fa79c3ccfdddfece);

var $3LeME = parcelRequire("3LeME");

var $itGnS = parcelRequire("itGnS");

var $2qSeE = parcelRequire("2qSeE");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $5vS9r = parcelRequire("5vS9r");

var $83R7C = parcelRequire("83R7C");
function $433e085c764f9701$export$4971331372cec95a(state) {
    return (0, $5vS9r.createCommand)({
        type: 'UPDATE_STATE',
        data: state
    });
}
function $433e085c764f9701$export$845f8c516a847983(processParametersBefore, processParametersAfter, applyChangeToContextPanel) {
    return (0, $5vS9r.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: true,
            processParametersBefore: processParametersBefore,
            processParametersAfter: processParametersAfter
        }
    }, applyChangeToContextPanel);
}
const $433e085c764f9701$export$81748740fe20ba64 = (applyChangeToContextPanel)=>(0, $5vS9r.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            showContextPanel: false,
            processParametersBefore: undefined,
            processParametersAfter: undefined
        }
    }, applyChangeToContextPanel);
const $433e085c764f9701$export$265d048971b3d878 = (applyChangeToContextPanel)=>(resolve, reject)=>(0, $5vS9r.createCommand)({
            type: 'UPDATE_STATE',
            data: {
                autoSaveResolve: resolve,
                autoSaveReject: reject
            }
        }, applyChangeToContextPanel);
const $433e085c764f9701$export$612be0ec35a64e3b = (layout, analyticsApi)=>(0, $5vS9r.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            layout: layout
        }
    }, (tr, state)=>{
        const selectedExtension = (0, $83R7C.getSelectedExtension)(state, true);
        if (selectedExtension) {
            const trWithNewNodeMarkup = tr.setNodeMarkup(selectedExtension.pos, undefined, {
                ...selectedExtension.node.attrs,
                layout: layout
            });
            trWithNewNodeMarkup.setMeta('scrollIntoView', false);
            if (analyticsApi) analyticsApi.attachAnalyticsEvent({
                action: (0, $3LeME.ACTION).UPDATED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    extensionType: selectedExtension.node.attrs.extensionType,
                    extensionKey: selectedExtension.node.attrs.extensionKey,
                    localId: selectedExtension.node.attrs.localId,
                    layout: layout,
                    selection: tr.selection.toJSON(),
                    targetSelectionSource: (0, $itGnS.TARGET_SELECTION_SOURCE).CURRENT_SELECTION
                }
            })(tr);
            return trWithNewNodeMarkup;
        }
        return tr;
    });
const $433e085c764f9701$export$366c74c25333cf63 = (editorAnalyticsAPI, inputMethod)=>(0, $5vS9r.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        if ((0, $83R7C.getSelectedExtension)(state)) return $433e085c764f9701$export$8bdb85550181fac8(state, tr, editorAnalyticsAPI, inputMethod);
        else return $433e085c764f9701$export$a5879ac679bfa06d(state, tr, editorAnalyticsAPI, inputMethod);
    });
const $433e085c764f9701$export$fa79c3ccfdddfece = (sourceNode)=>(0, $5vS9r.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $2qSeE.removeConnectedNodes)(state, sourceNode) : tr;
    });
const $433e085c764f9701$export$8bdb85550181fac8 = (state, tr, analyticsApi, inputMethod)=>{
    if (state.selection instanceof (0, $801jp.NodeSelection)) {
        const node = state.selection.node;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).DELETED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $a4TQr.removeSelectedNode)(tr);
};
const $433e085c764f9701$export$a5879ac679bfa06d = (state, tr, analyticsApi, inputMethod)=>{
    let nodeType = state.schema.nodes.bodiedExtension;
    const maybeMBENode = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.multiBodiedExtension)(state.selection);
    if (maybeMBENode) {
        nodeType = state.schema.nodes.multiBodiedExtension;
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).DELETED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: maybeMBENode.node.attrs.extensionType,
                extensionKey: maybeMBENode.node.attrs.extensionKey,
                localId: maybeMBENode.node.attrs.localId,
                currentFramesCount: maybeMBENode.node.content.childCount,
                inputMethod: inputMethod
            }
        })(tr);
    }
    const bodiedExtensionNode = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
    if (bodiedExtensionNode) {
        if (analyticsApi) analyticsApi.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).DELETED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION_BODIED,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: bodiedExtensionNode.node.attrs.extensionType,
                extensionKey: bodiedExtensionNode.node.attrs.extensionKey,
                localId: bodiedExtensionNode.node.attrs.localId,
                inputMethod: inputMethod
            }
        })(tr);
    }
    return (0, $a4TQr.removeParentNodeOfType)(nodeType)(tr);
};

});
parcelRegister("5vS9r", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $147d9a3b3aa2418c$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $147d9a3b3aa2418c$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $147d9a3b3aa2418c$export$f05434c51e3762e);

var $92jIL = parcelRequire("92jIL");

var $5ujGm = parcelRequire("5ujGm");

var $gbsO9 = parcelRequire("gbsO9");
const $147d9a3b3aa2418c$var$factory = (0, $92jIL.pluginFactory)((0, $5ujGm.pluginKey), (0, $gbsO9.default), {
    mapping (tr, state) {
        const { positions: previousPositions } = state;
        if (!previousPositions) return state;
        const positions = {
            ...previousPositions
        };
        // eslint-disable-next-line guard-for-in
        for(const key in positions)positions[key] = tr.mapping.map(positions[key]);
        return {
            ...state,
            positions: positions
        };
    }
});
const $147d9a3b3aa2418c$export$656c7661095efe2e = $147d9a3b3aa2418c$var$factory.createPluginState;
const $147d9a3b3aa2418c$export$8d4021544bdece00 = $147d9a3b3aa2418c$var$factory.createCommand;
const $147d9a3b3aa2418c$export$f05434c51e3762e = $147d9a3b3aa2418c$var$factory.getPluginState;

});
parcelRegister("5ujGm", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $87560102ef38b9f3$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $87560102ef38b9f3$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('extensionPlugin');

});

parcelRegister("gbsO9", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5904ece6a248b85$export$2e2bcd8739ae039);
function $b5904ece6a248b85$export$2e2bcd8739ae039(pluginState, action) {
    switch(action.type){
        case 'UPDATE_STATE':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
}

});


parcelRegister("83R7C", function(module, exports) {
$parcel$export(module.exports, "getSelectedExtension", () => $99130f88ac9b1051$export$cdb701fa2b3c99df);
$parcel$export(module.exports, "findExtensionWithLocalId", () => $99130f88ac9b1051$export$b003700b6d25caa7);
$parcel$export(module.exports, "getSelectedDomElement", () => $99130f88ac9b1051$export$f1c79f28529bfc9a);
$parcel$export(module.exports, "getDataConsumerMark", () => $99130f88ac9b1051$export$cd9967958db163fc);
$parcel$export(module.exports, "getNodeTypesReferenced", () => $99130f88ac9b1051$export$1004a88e790d2d21);
$parcel$export(module.exports, "findNodePosWithLocalId", () => $99130f88ac9b1051$export$bb057d1dfc5c8b1b);
$parcel$export(module.exports, "copyUnsupportedContentToClipboard", () => $99130f88ac9b1051$export$9defe25170de6263);
$parcel$export(module.exports, "onCopyFailed", () => $99130f88ac9b1051$export$67e8f2a5d4f25de0);

var $3LeME = parcelRequire("3LeME");

var $ff9Tr = parcelRequire("ff9Tr");

var $hCON4 = parcelRequire("hCON4");

var $gC2vY = parcelRequire("gC2vY");

var $f7AYl = parcelRequire("f7AYl");

var $a4TQr = parcelRequire("a4TQr");

var $fbyw0 = parcelRequire("fbyw0");
const $99130f88ac9b1051$export$cdb701fa2b3c99df = (state, searchParent = false)=>{
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    return (0, $a4TQr.findSelectedNodeOfType)(nodeTypes)(state.selection) || searchParent && (0, $a4TQr.findParentNodeOfType)(nodeTypes)(state.selection) || undefined;
};
const $99130f88ac9b1051$export$b003700b6d25caa7 = (state, localId)=>{
    const selectedExtension = $99130f88ac9b1051$export$cdb701fa2b3c99df(state, true);
    if (!localId) return selectedExtension;
    if (selectedExtension && selectedExtension.node.attrs.localId === localId) return selectedExtension;
    const { inlineExtension: inlineExtension, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = state.schema.nodes;
    const nodeTypes = [
        extension,
        bodiedExtension,
        inlineExtension,
        multiBodiedExtension
    ];
    let matched;
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.includes(node.type) && node.attrs.localId === localId) matched = {
            node: node,
            pos: pos
        };
    });
    return matched;
};
const $99130f88ac9b1051$export$f1c79f28529bfc9a = (schema, domAtPos, selectedExtensionNode)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const selectedExtensionDomNode = (0, $a4TQr.findDomRefAtPos)(selectedExtensionNode.pos, domAtPos);
    const isContentExtension = selectedExtensionNode.node.type !== schema.nodes.bodiedExtension;
    return(// Content extension can be nested in bodied-extension, the following check is necessary for that case
    (isContentExtension // Search down
     ? selectedExtensionDomNode.querySelector('.extension-container') // Try searching up and then down
     : (0, $hCON4.closestElement)(selectedExtensionDomNode, '.extension-container') || selectedExtensionDomNode.querySelector('.extension-container')) || selectedExtensionDomNode);
};
const $99130f88ac9b1051$export$cd9967958db163fc = (newNode)=>{
    var _newNode$marks;
    return (_newNode$marks = newNode.marks) === null || _newNode$marks === void 0 ? void 0 : _newNode$marks.find((mark)=>mark.type.name === 'dataConsumer');
};
const $99130f88ac9b1051$export$1004a88e790d2d21 = (ids, state)=>{
    return (0, $gC2vY.findNodePosByLocalIds)(state, ids, {
        includeDocNode: true
    }).map(({ node: node })=>node.type.name);
};
const $99130f88ac9b1051$export$bb057d1dfc5c8b1b = (state, localId)=>{
    const nodes = (0, $gC2vY.findNodePosByLocalIds)(state, [
        localId
    ]);
    return nodes.length >= 1 ? nodes[0] : undefined;
};
/**
 * Converts a ProseMirror node to its text representation.
 * Handles text nodes with marks (links) and inline nodes (status, mention, emoji).
 * Returns the content for this node, with a trailing separator for text blocks.
 */ const $99130f88ac9b1051$var$convertNodeToText = (node, mentionSet, parent, locale)=>{
    if (node.isInline) {
        const schema = node.type.schema;
        let finalText = '';
        if (node.isText) {
            finalText = node.text || '';
            if (node.marks.length > 0) {
                for (const mark of node.marks)// if it's link, include the href in the text
                if (mark.type === schema.marks.link) {
                    const href = mark.attrs.href;
                    const text = node.text || '';
                    // If the text differs from the href, include both
                    if (text && text !== href) finalText = `${text} ${href}`;
                    else finalText = href;
                }
            }
        } else switch(node.type){
            case schema.nodes.status:
                finalText = node.attrs.text || '';
                break;
            case schema.nodes.mention:
                mentionSet.add(node.attrs.id);
                finalText = `@${node.attrs.id}`;
                break;
            case schema.nodes.emoji:
                finalText = node.attrs.shortName || '';
                break;
            case schema.nodes.date:
                const timestamp = new Date(Number(node.attrs.timestamp));
                finalText = !isNaN(timestamp.getTime()) ? timestamp.toLocaleDateString(locale ?? 'en-US') : String(node.attrs.timestamp);
                break;
            default:
                finalText = node.textContent;
                break;
        }
        if (parent && parent.isTextblock && node === parent.lastChild && parent.childCount > 0) finalText += '\n\n';
        return finalText;
    }
    return '';
};
/**
 * Resolves mention IDs to their display names and replaces them in the text.
 * Returns the text with resolved mentions, or the original text if the provider is unavailable.
 */ const $99130f88ac9b1051$var$resolveMentionsInText = async (text, mentionSet, api)=>{
    var _api$mention;
    const mentionProvider = api === null || api === void 0 || (_api$mention = api.mention) === null || _api$mention === void 0 || (_api$mention = _api$mention.sharedState) === null || _api$mention === void 0 || (_api$mention = _api$mention.currentState()) === null || _api$mention === void 0 ? void 0 : _api$mention.mentionProvider;
    if (!mentionProvider || !(0, $fbyw0.isResolvingMentionProvider)(mentionProvider)) return text;
    let resolvedText = text;
    for (const id of mentionSet){
        const mention = await mentionProvider.resolveMentionName(id);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        resolvedText = resolvedText.replace(`@${id}`, `@${mention.name}` || "@\u2026");
    }
    return resolvedText;
};
const $99130f88ac9b1051$export$9defe25170de6263 = async ({ locale: locale, schema: schema, unsupportedContent: unsupportedContent, api: api })=>{
    try {
        if (!unsupportedContent) throw new Error('No nested content found');
        if (unsupportedContent.type !== 'doc') unsupportedContent = {
            version: 1,
            type: 'doc',
            content: [
                unsupportedContent
            ]
        };
        const transformer = new (0, $f7AYl.JSONTransformer)(schema);
        const pmNode = transformer.parse(unsupportedContent);
        let text = '';
        const mentionSet = new Set();
        pmNode.nodesBetween(0, pmNode.content.size, (node, _pos, parent)=>{
            text += $99130f88ac9b1051$var$convertNodeToText(node, mentionSet, parent, locale);
        });
        // Trim leading/trailing whitespace from the collected text
        text = text.trim();
        text = await $99130f88ac9b1051$var$resolveMentionsInText(text, mentionSet, api);
        (0, $ff9Tr.copyToClipboard)(text);
    } catch (error) {
        throw error instanceof Error ? error : new Error('Failed to copy content');
    }
};
const $99130f88ac9b1051$export$67e8f2a5d4f25de0 = ({ error: error, extensionApi: extensionApi, state: state })=>{
    var _extensionApi$analyti;
    const nodeWithPos = $99130f88ac9b1051$export$cdb701fa2b3c99df(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    extensionApi === null || extensionApi === void 0 || (_extensionApi$analyti = extensionApi.analytics) === null || _extensionApi$analyti === void 0 || _extensionApi$analyti.actions.fireAnalyticsEvent({
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
        action: (0, $3LeME.ACTION).COPY_FAILED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
        actionSubjectId: node.type.name,
        attributes: {
            extensionKey: extensionKey,
            extensionType: extensionType,
            errorMessage: error.message,
            errorStack: error.stack
        }
    });
};

});


parcelRegister("kaj3r", function(module, exports) {
$parcel$export(module.exports, "insertMacroFromMacroBrowser", () => $92e027fdb94460d4$export$4ec44b2939e261e2);
$parcel$export(module.exports, "runMacroAutoConvert", () => $92e027fdb94460d4$export$774dc72aee79b8eb);
$parcel$export(module.exports, "setMacroProvider", () => $92e027fdb94460d4$export$e45aff648def0591);

var $4XPI9 = parcelRequire("4XPI9");

var $3LeME = parcelRequire("3LeME");

var $itGnS = parcelRequire("itGnS");

var $ThXkz = parcelRequire("ThXkz");

var $1jvzH = parcelRequire("1jvzH");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $5vS9r = parcelRequire("5vS9r");

var $5JOt5 = parcelRequire("5JOt5");
const $92e027fdb94460d4$export$4ec44b2939e261e2 = (editorAnalyticsAPI)=>(macroProvider, macroNode, isEditing)=>async (view)=>{
            if (!macroProvider) return false;
            // opens MacroBrowser for editing "macroNode" if passed in
            const newMacro = await macroProvider.openMacroBrowser(macroNode);
            if (newMacro && macroNode) {
                const { state: state, dispatch: dispatch } = view;
                const currentLayout = macroNode && macroNode.attrs.layout || 'default';
                const node = $92e027fdb94460d4$export$87074dfcaea41da3(newMacro, state, {
                    layout: currentLayout
                });
                if (!node) return false;
                const { selection: selection, schema: schema } = state;
                const { extension: extension, inlineExtension: inlineExtension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const updateSelectionsByNodeType = (nodeType)=>{
                    // `isEditing` is `false` when we are inserting from insert-block toolbar
                    tr = isEditing ? (0, $a4TQr.replaceParentNodeOfType)(nodeType, node)(tr) : (0, $a4TQr.safeInsert)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $801jp.TextSelection).create(tr.doc, state.selection.anchor));
                };
                const extensionState = (0, $5vS9r.getPluginState)(state);
                let targetSelectionSource = (0, $itGnS.TARGET_SELECTION_SOURCE).CURRENT_SELECTION;
                let { tr: tr } = state;
                const isBodiedExtensionSelected = !!(0, $a4TQr.findSelectedNodeOfType)([
                    bodiedExtension
                ])(selection);
                const isMultiBodiedExtensionSelected = !!(0, $a4TQr.findSelectedNodeOfType)([
                    multiBodiedExtension
                ])(selection);
                // When it's a bodiedExtension but not selected
                if (macroNode.type === bodiedExtension && !isBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.bodiedExtension);
                else if (macroNode.type === multiBodiedExtension && !isMultiBodiedExtensionSelected) updateSelectionsByNodeType(state.schema.nodes.multiBodiedExtension);
                else if ((0, $a4TQr.findSelectedNodeOfType)([
                    extension,
                    bodiedExtension,
                    inlineExtension,
                    multiBodiedExtension
                ])(selection)) {
                    tr = (0, $a4TQr.replaceSelectedNode)(node)(tr);
                    // Replacing selected node doesn't update the selection. `selection.node` still returns the old node
                    tr.setSelection((0, $801jp.NodeSelection).create(tr.doc, tr.mapping.map(state.selection.anchor)));
                } else if (extensionState.element) {
                    const pos = view.posAtDOM(extensionState.element, -1);
                    if (pos > -1) {
                        tr = tr.replaceWith(pos, pos + macroNode.nodeSize, node);
                        tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(pos)));
                        targetSelectionSource = (0, $itGnS.TARGET_SELECTION_SOURCE).HTML_ELEMENT;
                    }
                }
                // Only scroll if we have anything to update, best to avoid surprise scroll
                if (dispatch && tr.docChanged) {
                    const { extensionType: extensionType, extensionKey: extensionKey, layout: layout, localId: localId } = macroNode.attrs;
                    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                        action: (0, $3LeME.ACTION).UPDATED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).EXTENSION,
                        actionSubjectId: macroNode.type.name,
                        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                        attributes: {
                            // @ts-expect-error - Type is not assignable to parameter of type 'AnalyticsEventPayload'
                            // This error was introduced after upgrading to TypeScript 5
                            inputMethod: isEditing ? (0, $3LeME.INPUT_METHOD).MACRO_BROWSER : (0, $3LeME.INPUT_METHOD).TOOLBAR,
                            extensionType: extensionType,
                            extensionKey: extensionKey,
                            layout: layout,
                            localId: localId,
                            selection: tr.selection.toJSON(),
                            targetSelectionSource: targetSelectionSource
                        }
                    })(tr);
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            return false;
        };
const $92e027fdb94460d4$export$87074dfcaea41da3 = (macro, state, optionalAttrs)=>{
    if (!macro || !state) return null;
    const { schema: schema } = state;
    const { type: type, attrs: attrs } = (0, $1jvzH.getValidNode)(macro, schema);
    let node = null;
    if (type === 'extension') node = schema.nodes.extension.create({
        ...attrs,
        ...optionalAttrs
    });
    else if (type === 'bodiedExtension') node = schema.nodes.bodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    else if (type === 'inlineExtension') node = schema.nodes.inlineExtension.create(attrs);
    else if (type === 'multiBodiedExtension') node = schema.nodes.multiBodiedExtension.create({
        ...attrs,
        ...optionalAttrs
    }, schema.nodeFromJSON(macro).content);
    return node && (0, $ThXkz.normaliseNestedLayout)(state, node);
};
const $92e027fdb94460d4$export$774dc72aee79b8eb = (state, text)=>{
    const macroPluginState = (0, $5JOt5.pluginKey).getState(state);
    const macroProvider = macroPluginState && macroPluginState.macroProvider;
    if (!macroProvider || !macroProvider.autoConvert) return null;
    const macroAttributes = macroProvider.autoConvert(text);
    if (!macroAttributes) return null;
    // decides which kind of macro to render (inline|bodied|bodyless)
    return $92e027fdb94460d4$export$87074dfcaea41da3(macroAttributes, state);
};
const $92e027fdb94460d4$export$e45aff648def0591 = (provider)=>async (view)=>{
        let resolvedProvider;
        try {
            resolvedProvider = await provider;
            (0, (/*@__PURE__*/$parcel$interopDefault($4XPI9)))(resolvedProvider && resolvedProvider.openMacroBrowser, `MacroProvider promise did not resolve to a valid instance of MacroProvider - ${resolvedProvider}`);
        } catch (err) {
            resolvedProvider = null;
        }
        view.dispatch(view.state.tr.setMeta((0, $5JOt5.pluginKey), {
            macroProvider: resolvedProvider
        }));
        return true;
    };

});
parcelRegister("5JOt5", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $1eebffc93a01cf25$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $1eebffc93a01cf25$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('macroPlugin');

});




parcelRegister("cqK8o", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5c1e6a76d1c6272$export$2e2bcd8739ae039);

var $eUtBU = parcelRequire("eUtBU");

var $1O8Lw = parcelRequire("1O8Lw");

var $5Edew = parcelRequire("5Edew");

var $5vS9r = parcelRequire("5vS9r");
function $a5c1e6a76d1c6272$export$2e2bcd8739ae039(applyChange) {
    const list = {};
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.escape).common, (state, dispatch)=>{
        const extensionState = (0, $5vS9r.getPluginState)(state);
        if (!extensionState.showContextPanel) return false;
        return (0, $5Edew.clearEditingContext)(applyChange)(state, dispatch);
    }, list);
    return (0, $1O8Lw.keymap)(list);
}

});

parcelRegister("g4M4j", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $44f1f5a835cc9176$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $kaj3r = parcelRequire("kaj3r");

var $5JOt5 = parcelRequire("5JOt5");
const $44f1f5a835cc9176$export$ae829ec7b2625219 = (dispatch, providerFactory)=>new (0, $1y7gE.SafePlugin)({
        state: {
            init: ()=>({
                    macroProvider: null
                }),
            apply (tr, state) {
                const meta = tr.getMeta((0, $5JOt5.pluginKey));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    dispatch((0, $5JOt5.pluginKey), newState);
                    return newState;
                }
                return state;
            }
        },
        key: (0, $5JOt5.pluginKey),
        view: (view)=>{
            const handleProvider = (_name, provider)=>provider && (0, $kaj3r.setMacroProvider)(provider)(view);
            // make sure editable DOM node is mounted
            if (view.dom.parentNode) providerFactory.subscribe('macroProvider', handleProvider);
            return {
                destroy () {
                    providerFactory.unsubscribe('macroProvider', handleProvider);
                }
            };
        }
    });

});

parcelRegister("8TbB8", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $a4ea967aac20bce2$export$ae829ec7b2625219);

var $5U5Wt = parcelRequire("5U5Wt");

var $1y7gE = parcelRequire("1y7gE");

var $6bnr9 = parcelRequire("6bnr9");
var $a5ELK = parcelRequire("a5ELK");
var $jCQEY = parcelRequire("jCQEY");

var $ihNBw = parcelRequire("ihNBw");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $5Edew = parcelRequire("5Edew");

var $4qr1p = parcelRequire("4qr1p");

var $5vS9r = parcelRequire("5vS9r");

var $5ujGm = parcelRequire("5ujGm");

var $UNL2s = parcelRequire("UNL2s");

var $83R7C = parcelRequire("83R7C");
const $a4ea967aac20bce2$var$shouldShowEditButton = (extensionHandler, extensionProvider)=>{
    const usesLegacyMacroBrowser = !extensionHandler && !extensionProvider || typeof extensionHandler === 'function';
    const usesModernUpdateMethod = typeof extensionHandler === 'object' && typeof extensionHandler.update === 'function';
    if (usesLegacyMacroBrowser || usesModernUpdateMethod) return true;
    return false;
};
const $a4ea967aac20bce2$var$getUpdateExtensionPromise = async (view, extensionHandler, extensionProvider)=>{
    if (extensionHandler && typeof extensionHandler === 'object') // Old API with the `update` function
    return extensionHandler.update;
    else if (extensionProvider) {
        // New API with or without the `update` function, we don't know at this point
        const updateMethod = await (0, $UNL2s.updateEditButton)(view, extensionProvider);
        if (updateMethod) return updateMethod;
    }
    throw new Error('No update method available');
};
const $a4ea967aac20bce2$export$21b8c38408ff6d69 = (view, api)=>async (name, provider)=>{
        if (name === 'extensionProvider' && provider) try {
            const extensionProvider = await provider;
            (0, $5Edew.updateState)({
                extensionProvider: extensionProvider
            })(view.state, view.dispatch);
            await (0, $UNL2s.updateEditButton)(view, extensionProvider);
            try {
                var _api$blockMenu;
                const manifests = await extensionProvider.getExtensions();
                api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuTransforms((0, $4qr1p.buildExtensionBlockTransforms)(manifests));
            } catch  {
            // Transform registration remains unavailable when manifests cannot be loaded.
            }
        } catch  {
            (0, $5Edew.updateState)({
                extensionProvider: undefined
            })(view.state, view.dispatch);
        }
    };
const $a4ea967aac20bce2$export$3c1d0d79a942e731 = ({ view: view, prevState: prevState, domAtPos: domAtPos, extensionHandlers: extensionHandlers, applyChange: applyChange })=>{
    const { state: state, dispatch: dispatch } = view;
    const { element: element, localId: localId, extensionProvider: extensionProvider, showContextPanel: showContextPanel, showEditButton: showEditButton } = (0, $5vS9r.getPluginState)(state);
    // This fetches the selected extension node, either by keyboard selection or click for all types of extensions
    const selectedExtension = (0, $83R7C.getSelectedExtension)(state, true);
    if (!selectedExtension) {
        if (showContextPanel) (0, $5Edew.clearEditingContext)(applyChange)(state, dispatch);
        return;
    }
    const { node: node } = selectedExtension;
    const newElement = (0, $83R7C.getSelectedDomElement)(state.schema, domAtPos, selectedExtension);
    // In some cases, showEditButton can be stale and the edit button doesn't show - @see ED-15285
    // To be safe, we update the showEditButton state here
    const shouldUpdateEditButton = !showEditButton && extensionProvider && element === newElement && !(0, $83R7C.getSelectedExtension)(prevState, true);
    const isNewNodeSelected = node.attrs.localId ? localId !== node.attrs.localId : // This is the current assumption and it's wrong but we are keeping it
    // as fallback in case we need to turn off `allowLocalIdGeneration`
    element !== newElement;
    if (isNewNodeSelected || shouldUpdateEditButton) {
        if (showContextPanel) {
            (0, $5Edew.clearEditingContext)(applyChange)(state, dispatch);
            return;
        }
        const { extensionType: extensionType } = node.attrs;
        const extensionHandler = extensionHandlers[extensionType];
        // showEditButton might change async based on results from extension providers
        const showEditButton = $a4ea967aac20bce2$var$shouldShowEditButton(extensionHandler, extensionProvider);
        const updateExtension = $a4ea967aac20bce2$var$getUpdateExtensionPromise(view, extensionHandler, extensionProvider).catch(()=>{
        // do nothing;
        });
        (0, $5Edew.updateState)({
            localId: node.attrs.localId,
            showContextPanel: false,
            element: newElement,
            showEditButton: showEditButton,
            // Default to showing synchronously; the manifest-driven value (if any)
            // is resolved asynchronously via updateEditButton for provider-based
            // extensions.
            showCopyButton: true,
            updateExtension: updateExtension
        })(state, dispatch);
    } else if (element !== newElement) (0, $5Edew.updateState)({
        element: newElement
    })(state, dispatch);
    return true;
};
const $a4ea967aac20bce2$export$ae829ec7b2625219 = (dispatch, providerFactory, extensionHandlers, extensionLoadingHandlers, portalProviderAPI, eventDispatcher, pluginInjectionApi, useLongPressSelection = false, options = {}, featureFlags, __rendererExtensionOptions, intl)=>{
    const state = (0, $5vS9r.createPluginState)(dispatch, {
        showEditButton: false,
        showCopyButton: true,
        showContextPanel: false
    });
    const extensionNodeViewOptions = {
        appearance: options.appearance,
        getExtensionHeight: options.getExtensionHeight,
        allowAIGeneratedContentMotion: options.allowAIGeneratedContentMotion
    };
    const macroInteractionDesignFeatureFlags = {
        showMacroInteractionDesignUpdates: (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.macroInteractionUpdates) ?? false
    };
    const showLivePagesBodiedMacrosRendererView = __rendererExtensionOptions === null || __rendererExtensionOptions === void 0 ? void 0 : __rendererExtensionOptions.isAllowedToUseRendererView;
    return new (0, $1y7gE.SafePlugin)({
        state: state,
        view: (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const extensionProviderHandler = $a4ea967aac20bce2$export$21b8c38408ff6d69(editorView, pluginInjectionApi);
            providerFactory.subscribe('extensionProvider', extensionProviderHandler);
            return {
                update: (view, prevState)=>{
                    var _pluginInjectionApi$c;
                    $a4ea967aac20bce2$export$3c1d0d79a942e731({
                        view: view,
                        prevState: prevState,
                        domAtPos: domAtPos,
                        extensionHandlers: extensionHandlers,
                        applyChange: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.contextPanel) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.actions.applyChange
                    });
                },
                destroy: ()=>{
                    providerFactory.unsubscribe('extensionProvider', extensionProviderHandler);
                }
            };
        },
        key: (0, $5ujGm.pluginKey),
        props: {
            handleDOMEvents: {
                /**
         * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty.
         * This code is to handle the case where the selection starts inside or on the node and the user is trying to shift + arrow.
         * For other part of the solution see code in: packages/editor/editor-core/src/plugins/selection/pm-plugins/events/keydown.ts
         */ keydown: (view, event)=>{
                    if (event instanceof KeyboardEvent && event.shiftKey && [
                        'ArrowUp',
                        'ArrowDown',
                        'ArrowLeft',
                        'ArrowRight'
                    ].includes(event.key)) {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { bodiedExtension: bodiedExtension } = schema.nodes;
                        if (selection instanceof (0, $801jp.TextSelection) || selection instanceof (0, $801jp.NodeSelection)) {
                            const maybeBodiedExtension = selection instanceof (0, $801jp.TextSelection) ? (0, $a4TQr.findParentNodeOfTypeClosestToPos)($head, bodiedExtension) : (0, $a4TQr.findSelectedNodeOfType)(bodiedExtension)(selection);
                            if (maybeBodiedExtension) {
                                const end = maybeBodiedExtension.pos + maybeBodiedExtension.node.nodeSize;
                                if (event.key === 'ArrowUp' || event.key === 'ArrowLeft' && (0, $jCQEY.isSelectionAtStartOfNode)($head, maybeBodiedExtension === null || maybeBodiedExtension === void 0 ? void 0 : maybeBodiedExtension.node)) {
                                    const anchor = end + 1;
                                    // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
                                    const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
                                    const head = maybeBodiedExtension.pos + headOffset;
                                    const newSelection = (0, $801jp.TextSelection).create(doc, Math.max(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                                if (event.key === 'ArrowDown' || event.key === 'ArrowRight' && (0, $a5ELK.isSelectionAtEndOfNode)($head, maybeBodiedExtension === null || maybeBodiedExtension === void 0 ? void 0 : maybeBodiedExtension.node)) {
                                    const anchor = maybeBodiedExtension.pos - 1;
                                    const head = end + 1;
                                    const newSelection = (0, $801jp.TextSelection).create(doc, Math.min(anchor, selection.anchor), head);
                                    view.dispatch(tr.setSelection(newSelection));
                                    return true;
                                }
                            }
                        }
                    }
                    // Handle non shift key case for MBE
                    if (event instanceof KeyboardEvent && !event.shiftKey && event.key === 'ArrowLeft') {
                        const { schema: schema, selection: selection, selection: { $head: $head }, doc: doc, tr: tr } = view.state;
                        const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame, paragraph: paragraph } = schema.nodes;
                        if (selection instanceof (0, $ihNBw.GapCursorSelection) || selection instanceof (0, $801jp.TextSelection) && $head.parent.type === paragraph) {
                            const maybeMultiBodiedExtension = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($head, multiBodiedExtension);
                            if (maybeMultiBodiedExtension) {
                                var _tr$doc$nodeAt;
                                /* In case of gap cursor, we need to decrement the position by 1 as we need to check the node at previous position
                 * In case of text selection, we need to decrement the position by 2 as we need to jump back twice, once from text node and then its parent paragraph node
                 */ const previousPositionDecrement = selection instanceof (0, $ihNBw.GapCursorSelection) ? 1 : 2;
                                if (((_tr$doc$nodeAt = tr.doc.nodeAt($head.pos - previousPositionDecrement)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.type) === extensionFrame) {
                                    const newSelection = (0, $801jp.TextSelection).create(doc, tr.doc.resolve($head.pos - previousPositionDecrement).start($head.depth - previousPositionDecrement));
                                    view.dispatch(tr.setSelection(newSelection));
                                }
                            }
                        }
                    }
                    return false;
                }
            },
            nodeViews: {
                // WARNING: referentiality-plugin also creates these nodeviews
                extension: (0, $5U5Wt.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl),
                // WARNING: referentiality-plugin also creates these nodeviews
                bodiedExtension: (0, $5U5Wt.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, __rendererExtensionOptions === null || __rendererExtensionOptions === void 0 ? void 0 : __rendererExtensionOptions.showUpdated1PBodiedExtensionUI, __rendererExtensionOptions === null || __rendererExtensionOptions === void 0 ? void 0 : __rendererExtensionOptions.rendererExtensionHandlers, intl),
                // WARNING: referentiality-plugin also creates these nodeviews
                inlineExtension: (0, $5U5Wt.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl),
                multiBodiedExtension: (0, $5U5Wt.default)(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, undefined, undefined, undefined, intl)
            },
            createSelectionBetween: function(view, anchor, head) {
                const { schema: schema, doc: doc } = view.state;
                const { multiBodiedExtension: multiBodiedExtension } = schema.nodes;
                const isAnchorInMBE = (0, $a4TQr.findParentNodeOfTypeClosestToPos)(anchor, multiBodiedExtension);
                const isHeadInMBE = (0, $a4TQr.findParentNodeOfTypeClosestToPos)(head, multiBodiedExtension);
                if (isAnchorInMBE !== undefined && isHeadInMBE === undefined) {
                    // Anchor is in MBE, where user started selecting within MBE and then moved outside
                    const newSelection = (0, $801jp.TextSelection).create(doc, isAnchorInMBE.pos < head.pos ? isAnchorInMBE.pos : isAnchorInMBE.pos + isAnchorInMBE.node.nodeSize, // isAnchorInMBE.pos < head.pos represents downwards selection
                    head.pos);
                    return newSelection;
                }
                if (isAnchorInMBE === undefined && isHeadInMBE !== undefined) {
                    // Head is in MBE, where user started selecting outside MBE and then moved inside
                    const newSelection = (0, $801jp.TextSelection).create(doc, anchor.pos, isHeadInMBE.pos < anchor.pos ? isHeadInMBE.pos : isHeadInMBE.pos + isHeadInMBE.node.nodeSize // isHeadInMBE.pos < anchor.pos represents upwards selection
                    );
                    return newSelection;
                }
                return null;
            },
            handleClickOn: (0, $6bnr9.createSelectionClickHandler)([
                'extension',
                'bodiedExtension',
                'multiBodiedExtension'
            ], (target)=>!target.closest('.extension-non-editable-area') && (!target.closest('.extension-content') || !!target.closest('.extension-container')), // It's to enable nested extensions selection
            {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};

});
parcelRegister("5U5Wt", function(module, exports) {
$parcel$export(module.exports, "default", () => $efd92a23fddb0221$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
parcelRequire("lADe1");
var $hieIn = parcelRequire("hieIn");

var $eVKpX = parcelRequire("eVKpX");

var $5237J = parcelRequire("5237J");

var $ftKdO = parcelRequire("ftKdO");

var $8NZLW = parcelRequire("8NZLW");

var $1Iwe1 = parcelRequire("1Iwe1");

var $3Pyg2 = parcelRequire("3Pyg2");
/**
 * Allowlists of extension keys + layout
 * Currently, only toc with default layout allows to skip React render.
 * Extensions NOT in this list always follow the normal React render path.
 */ const $efd92a23fddb0221$var$ssrHydrationExtensionAllowlist = [
    'toc'
];
const $efd92a23fddb0221$var$ssrHydrationLayoutAllowlist = [
    'default'
];
const $efd92a23fddb0221$var$isSSRHydrationEligible = (node)=>{
    if (node.type.name !== 'extension') return false;
    const { extensionKey: extensionKey, layout: layout } = node.attrs ?? {};
    if (!$efd92a23fddb0221$var$ssrHydrationExtensionAllowlist.includes(extensionKey)) return false;
    // Treat a missing layout attr as `default` (the schema default).
    const effectiveLayout = layout ?? 'default';
    return $efd92a23fddb0221$var$ssrHydrationLayoutAllowlist.includes(effectiveLayout);
};
/**
 * Per-(EditorView, extensionKey + localId) record of which extension identities
 * have already had their initial-hydration init pass. SSR DOM reuse is only valid
 * the very first time an ExtensionNode init runs for a given identity in a given
 * editor — that is the only moment a real SSR-rendered element for that identity
 * can exist in the editor DOM.
 *
 * After the first init, any element matching the SSR selector is the previous
 * node view's React-rendered domRef that ProseMirror has not yet detached (e.g.
 * during DnD / layout resize, where ProseMirror constructs the new node view
 * BEFORE destroying the old one). Reusing it as if it were SSR DOM causes the
 * new node view to skip React rendering and leaves the extension invisible
 * (EDITOR-6613).
 */ const $efd92a23fddb0221$var$consumedHydrationIdentitiesByEditor = new WeakMap();
const $efd92a23fddb0221$var$getHydrationIdentityKey = (extensionKey, localId)=>{
    if (typeof extensionKey !== 'string' || typeof localId !== 'string') return null;
    if (extensionKey === '' || localId === '') return null;
    return `${extensionKey}::${localId}`;
};
const $efd92a23fddb0221$var$hasHydrationIdentityBeenConsumed = (view, identityKey)=>{
    const consumed = $efd92a23fddb0221$var$consumedHydrationIdentitiesByEditor.get(view);
    return consumed ? consumed.has(identityKey) : false;
};
const $efd92a23fddb0221$var$markHydrationIdentityAsConsumed = (view, identityKey)=>{
    let consumed = $efd92a23fddb0221$var$consumedHydrationIdentitiesByEditor.get(view);
    if (!consumed) {
        consumed = new Set();
        $efd92a23fddb0221$var$consumedHydrationIdentitiesByEditor.set(view, consumed);
    }
    consumed.add(identityKey);
};
class $efd92a23fddb0221$export$456a23774b90f061 extends (0, $5237J.default) {
    ignoreMutation(mutation) {
        // Extensions can perform async operations that will change the DOM.
        // To avoid having their tree rebuilt, we need to ignore the mutation
        // for atom based extensions if its not a layout, we need to give
        // children a chance to recalc
        return this.node.type.isAtom || mutation.type !== 'selection' && mutation.attributeName !== 'data-layout';
    }
    /** See {@link consumedHydrationIdentitiesByEditor}. Null when attrs are missing → SSR reuse skipped. */ getHydrationIdentityKey() {
        var _this$node$attrs, _this$node$attrs2;
        return $efd92a23fddb0221$var$getHydrationIdentityKey((_this$node$attrs = this.node.attrs) === null || _this$node$attrs === void 0 ? void 0 : _this$node$attrs.extensionKey, (_this$node$attrs2 = this.node.attrs) === null || _this$node$attrs2 === void 0 ? void 0 : _this$node$attrs2.localId);
    }
    /** True only for the first ExtensionNode of this identity in this editor. See {@link consumedHydrationIdentitiesByEditor}. */ isInInitialHydrationWindow() {
        const identityKey = this.getHydrationIdentityKey();
        if (identityKey === null) return false;
        return !$efd92a23fddb0221$var$hasHydrationIdentityBeenConsumed(this.view, identityKey);
    }
    // Reserve height by setting a minimum height for the extension node view element
    createDomRef() {
        // SSR DOM reuse takes precedence over preset height — when eligible, adopt the
        // server-rendered element directly so React hydration is deferred until update().
        if (!(0, $eVKpX.isSSR)() && $efd92a23fddb0221$var$isSSRHydrationEligible(this.node) && this.isInInitialHydrationWindow()) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                this.didReuseSsrDom = true;
                return ssrElement;
            }
        }
        if (!(0, $dRkX9.fg)('confluence_connect_macro_preset_height')) return super.createDomRef();
        if (!this.node.isInline) {
            var _this$reactComponentP, _this$reactComponentP2;
            const htmlElement = document.createElement('div');
            const extensionHeight = (_this$reactComponentP = this.reactComponentProps) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.extensionNodeViewOptions) === null || _this$reactComponentP === void 0 || (_this$reactComponentP2 = _this$reactComponentP.getExtensionHeight) === null || _this$reactComponentP2 === void 0 ? void 0 : _this$reactComponentP2.call(_this$reactComponentP, this.node);
            if (extensionHeight) {
                const minHeight = extensionHeight.endsWith('px') && (0, $dRkX9.fg)('confluence_forge_early_render_reserve_height') ? extensionHeight : `${extensionHeight}px`;
                htmlElement.style.setProperty('min-height', minHeight);
            }
            return htmlElement;
        }
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    /**
   * Attempts to find an existing SSR'd DOM element for this extension node by extensionKey and localId
   * which should uniquely identify the
   * extension node within the editor content.
   *
   * @returns The SSR'd element if found, otherwise null
   */ findSSRElement() {
        if (this.cachedSsrElement !== undefined) return this.cachedSsrElement || null;
        const extensionKey = this.node.attrs.extensionKey;
        const localId = this.node.attrs.localId;
        const editorDom = this.view.dom;
        if (extensionKey && localId) {
            const selector = `[extensionkey="${extensionKey}"][localid="${localId}"]`;
            const element = editorDom.querySelector(selector);
            if (element && element instanceof HTMLElement) {
                // A server-rendered element is only worth adopting if React actually rendered into it.
                // The SSR pass renders each node view through an isolated `renderToStaticMarkup`; when
                // that render throws, the portal provider swallows the error and leaves the container
                // empty. Adopting an empty element and skipping the React portal leaves the extension
                // invisible until the next `update()`, which for an untouched node only happens on user
                // interaction (HOT-306707). Treat an empty element as "no SSR DOM" so the node view takes
                // the normal React render path instead.
                if (!element.querySelector('[data-testid="extension-node-wrapper"]')) {
                    this.cachedSsrElement = null;
                    return null;
                }
                this.cachedSsrElement = element;
                return element;
            }
        }
        this.cachedSsrElement = null;
        return null;
    }
    /** Skip React Portal render on first init when reusing SSR DOM. See {@link consumedHydrationIdentitiesByEditor}. */ init() {
        const isEligibleForSsrReuse = !(0, $eVKpX.isSSR)() && $efd92a23fddb0221$var$isSSRHydrationEligible(this.node);
        if (isEligibleForSsrReuse && this.isInInitialHydrationWindow()) {
            const ssrElement = this.findSSRElement();
            const shouldSkipInitRender = ssrElement !== null;
            super.init(shouldSkipInitRender);
            const identityKey = this.getHydrationIdentityKey();
            if (identityKey !== null) // Close the hydration window — see {@link consumedHydrationIdentitiesByEditor}.
            $efd92a23fddb0221$var$markHydrationIdentityAsConsumed(this.view, identityKey);
        } else super.init();
        return this;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // Remove extensionNodeWrapper aka span.relative if we previously reused SSR DOM
        // control is back to React afterwards
        if (this.didReuseSsrDom) {
            const ssrElement = this.findSSRElement();
            if (ssrElement) {
                const extensionNodeWrapper = ssrElement.querySelector('[data-testid="extension-node-wrapper"]');
                if (extensionNodeWrapper) extensionNodeWrapper.remove();
                this.didReuseSsrDom = false;
            }
        }
        return super.update(node, decorations, _innerDecorations, validUpdate);
    }
    /**
   * Prevents ProseMirror from handling events that belong to the extension's React UI.
   *
   * For multibodied extensions: the node consists of a React app (e.g. tab bar) that controls
   * frames, and the editable frames themselves. Events inside frames must reach ProseMirror
   * for normal editing; events in the surrounding React app (buttons, navigation) are stopped
   * so ProseMirror doesn't create a NodeSelection on the entire node.
   *
   * For other extensions: input/textarea events are stopped so users can interact
   * with form elements inside the extension body without the editor intercepting them.
   */ stopEvent(event) {
        if (this.node.type.name === 'multiBodiedExtension') {
            const target = event.target;
            if (target instanceof Element) {
                if (target.closest('[data-multibodiedextension-frames]')) return false;
                return !!target.closest('[data-multiBodiedExtension-container]');
            }
            return false;
        }
        return event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement;
    }
    getContentDOM() {
        var _this$reactComponentP3;
        if (this.node.isInline) return;
        if (this.didReuseSsrDom) return;
        const contentDomWrapper = document.createElement('div');
        contentDomWrapper.className = `${this.node.type.name}-content-dom-wrapper`;
        const isBodiedExtension = this.node.type.name === 'bodiedExtension';
        const showMacroInteractionDesignUpdates = (_this$reactComponentP3 = this.reactComponentProps) === null || _this$reactComponentP3 === void 0 || (_this$reactComponentP3 = _this$reactComponentP3.macroInteractionDesignFeatureFlags) === null || _this$reactComponentP3 === void 0 ? void 0 : _this$reactComponentP3.showMacroInteractionDesignUpdates;
        if (isBodiedExtension && showMacroInteractionDesignUpdates) {
            // Create outer wrapper to hold space for the lozenge
            const outerWrapper = document.createElement('div');
            outerWrapper.className = `${this.node.type.name}-content-outer-wrapper`;
            // Create inner wrapper to position inner content
            const innerWrapper = document.createElement('div');
            innerWrapper.className = `${this.node.type.name}-content-inner-wrapper`;
            innerWrapper.appendChild(contentDomWrapper);
            outerWrapper.appendChild(innerWrapper);
            return {
                dom: outerWrapper,
                contentDOM: contentDomWrapper
            };
        }
        return {
            dom: contentDomWrapper
        };
    }
    render(props, forwardRef) {
        // While sitting on SSR DOM, skip the React portal — see {@link didReuseSsrDom}.
        if (this.didReuseSsrDom) return null;
        return /*#__PURE__*/ (0, $3LM7S.jsx)($efd92a23fddb0221$var$ExtensionNodeRender, {
            // EditorView is mutable; expose selection changes to invalidate compiled renders.
            selection: (0, $hieIn.isReactCompilerActivePlatform)() ? this.view.state.selection : undefined,
            editorView: this.view,
            eventDispatcher: this.eventDispatcher,
            forwardRef: forwardRef,
            // The getPos arg is always a function when used with nodes
            // the version of the types we use has a union with the type
            // for marks.
            // This has been fixed in later versions of the definitly typed
            // types (and also in prosmirror-views inbuilt types).
            // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57384
            getPos: this.getPos,
            node: this.node,
            renderProps: props
        });
    }
    constructor(...args){
        super(...args), /** True between SSR DOM adoption in `createDomRef` and the SSR→React handoff in `update`. */ this.didReuseSsrDom = false;
    }
}
/**
 * Wraps the extension in its node wrapper. A component rather than part of the node view's `render`,
 * so `contentReady` can be React state: the extension reports its content ready from inside the
 * wrapper, and the wrapper animates the node in once it has.
 */ function $efd92a23fddb0221$var$ExtensionNodeRender({ selection: selection, editorView: editorView, eventDispatcher: eventDispatcher, forwardRef: forwardRef, getPos: getPos, node: node, renderProps: renderProps }) {
    var _renderProps$extensio, _renderProps$extensio2;
    const [contentReady, setContentReady] = (0, $fc4bM.useState)(false);
    const onContentReady = (0, $fc4bM.useCallback)(()=>setContentReady(true), []);
    // Only native embeds animate in; every other extension type renders as it does without the
    // option, so nothing waits on a signal it does not send.
    const generatedContentMotion = !!((_renderProps$extensio = renderProps.extensionNodeViewOptions) !== null && _renderProps$extensio !== void 0 && _renderProps$extensio.allowAIGeneratedContentMotion) && (0, $1Iwe1.isNativeEmbedExtension)(node);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8NZLW.ExtensionNodeWrapper), {
        intl: renderProps.intl,
        nodeType: node.type.name,
        macroInteractionDesignFeatureFlags: renderProps.macroInteractionDesignFeatureFlags,
        generatedContentMotion: generatedContentMotion,
        contentReady: contentReady,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ftKdO.Extension), {
            selection: selection,
            editorView: editorView,
            node: node,
            eventDispatcher: eventDispatcher,
            getPos: getPos,
            providerFactory: renderProps.providerFactory,
            handleContentDOMRef: forwardRef,
            extensionHandlers: renderProps.extensionHandlers,
            extensionLoadingHandlers: renderProps.extensionLoadingHandlers,
            editorAppearance: (_renderProps$extensio2 = renderProps.extensionNodeViewOptions) === null || _renderProps$extensio2 === void 0 ? void 0 : _renderProps$extensio2.appearance,
            pluginInjectionApi: renderProps.pluginInjectionApi,
            macroInteractionDesignFeatureFlags: renderProps.macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: renderProps.showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: renderProps.showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: renderProps.rendererExtensionHandlers,
            onContentReady: generatedContentMotion ? onContentReady : undefined
        })
    });
}
function $efd92a23fddb0221$export$2e2bcd8739ae039(portalProviderAPI, eventDispatcher, providerFactory, extensionHandlers, extensionLoadingHandlers, extensionNodeViewOptions, pluginInjectionApi, macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers, intl) {
    return (node, view, getPos)=>{
        const renderProps = {
            providerFactory: providerFactory,
            extensionHandlers: extensionHandlers,
            extensionLoadingHandlers: extensionLoadingHandlers,
            extensionNodeViewOptions: extensionNodeViewOptions,
            pluginInjectionApi: pluginInjectionApi,
            macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
            showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
            showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
            rendererExtensionHandlers: rendererExtensionHandlers,
            intl: intl
        };
        const createExtensionNode = (currentNode)=>new $efd92a23fddb0221$export$456a23774b90f061(currentNode, view, getPos, portalProviderAPI, eventDispatcher, renderProps);
        if (!(0, $eVKpX.isSSR)() && (0, $dRkX9.fg)('cc_maui_annotations_on_extensions')) return (0, $3Pyg2.preserveRemixNodeView)({
            node: node,
            view: view,
            getPos: getPos,
            renderProps: renderProps,
            rendererKind: $efd92a23fddb0221$export$456a23774b90f061,
            createExtensionNode: createExtensionNode
        });
        return createExtensionNode(node).init();
    };
}

});
parcelRegister("lADe1", function(module, exports) {
$parcel$export(module.exports, "isReactCompilerActivePlatform", () => (parcelRequire("hieIn")).isReactCompilerActivePlatform);

var $hieIn = parcelRequire("hieIn");

});
parcelRegister("hieIn", function(module, exports) {
$parcel$export(module.exports, "isReactCompilerActivePlatform", () => $d6bf1978d26476e9$export$4d143603f9782455);

var $k2M4v = parcelRequire("k2M4v");
// The React Compiler calls this once per compiled function, when its module first runs.
let $d6bf1978d26476e9$var$cachedIsActive;
let $d6bf1978d26476e9$var$shouldCacheIsActive;
// expVal from @atlaskit/platform-feature-experiments would import @atlaskit/react-ufo, which is
// itself compiled with this gating function.
function $d6bf1978d26476e9$var$isExperimentEnabled(experimentName) {
    return Boolean((0, $k2M4v.default).getExperimentValue(experimentName, 'isEnabled', false));
}
function $d6bf1978d26476e9$export$4d143603f9782455() {
    if ($d6bf1978d26476e9$var$cachedIsActive !== undefined) return $d6bf1978d26476e9$var$cachedIsActive;
    const isActive = $d6bf1978d26476e9$var$isExperimentEnabled('confluence_enable_react-compiler-runtime-platform');
    // Before Statsig initialises, getExperimentValue returns the default, which must not be cached.
    if ($d6bf1978d26476e9$var$shouldCacheIsActive === undefined && (0, $k2M4v.default).initializeCompleted()) $d6bf1978d26476e9$var$shouldCacheIsActive = $d6bf1978d26476e9$var$isExperimentEnabled('confluence_cache_react_compiler_fg');
    if ($d6bf1978d26476e9$var$shouldCacheIsActive) $d6bf1978d26476e9$var$cachedIsActive = isActive;
    return isActive;
}

});


parcelRegister("ftKdO", function(module, exports) {
$parcel$export(module.exports, "Extension", () => $8af608eddf51b5ef$export$eeddbf09bb970356);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $lSYBN = parcelRequire("lSYBN");
var $75FAm = parcelRequire("75FAm");

var $fvYRh = parcelRequire("fvYRh");
class $8af608eddf51b5ef$export$eeddbf09bb970356 extends (0, $fc4bM.Component) {
    static #_ = this.displayName = 'Extension';
    constructor(props){
        super(props), this.renderWithProvider = ({ extensionProvider: extensionProvider })=>{
            var _pluginInjectionApi$e;
            const { node: node, getPos: getPos, selection: selection, editorView: editorView, handleContentDOMRef: handleContentDOMRef, extensionHandlers: extensionHandlers, extensionLoadingHandlers: extensionLoadingHandlers, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, rendererExtensionHandlers: rendererExtensionHandlers, onContentReady: onContentReady } = this.props;
            // Extensions are not yet using the new plugin architecture, and the use of the pluginInjectionApi
            // is not type safe in editor-common.
            // @ts-ignore
            const currentState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.editorViewMode) === null || _pluginInjectionApi$e === void 0 || (_pluginInjectionApi$e = _pluginInjectionApi$e.sharedState) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.currentState();
            const { contentMode: contentMode, mode: mode } = currentState || {};
            const isLivePageViewMode = contentMode === 'live-view' || mode === 'view';
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fvYRh.ExtensionComponent), {
                selection: selection,
                editorView: editorView,
                node: node,
                getPos: getPos,
                references: references,
                extensionProvider: extensionProvider,
                handleContentDOMRef: handleContentDOMRef,
                extensionHandlers: extensionHandlers,
                extensionLoadingHandlers: extensionLoadingHandlers,
                editorAppearance: editorAppearance,
                pluginInjectionApi: pluginInjectionApi,
                eventDispatcher: eventDispatcher,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                rendererExtensionHandlers: rendererExtensionHandlers,
                isLivePageViewMode: isLivePageViewMode,
                onContentReady: onContentReady
            });
        };
        this.providerFactory = props.providerFactory || new (0, $lSYBN.default)();
    }
    componentWillUnmount() {
        if (!this.props.providerFactory) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $75FAm.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- there seems to be an existing bug where the Extension component can't be resized if this is memoised because it doesn't rerender so this can't be memoised without a larger refactor
            providers: [
                'extensionProvider'
            ],
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
}

});
parcelRegister("fvYRh", function(module, exports) {
$parcel$export(module.exports, "ExtensionComponent", () => $a6384ca1c5e6727c$export$908ff786c04d5297);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jiju3 = parcelRequire("jiju3");

var $801jp = parcelRequire("801jp");

var $dRkX9 = parcelRequire("dRkX9");

var $iVHNS = parcelRequire("iVHNS");

var $8oPL3 = parcelRequire("8oPL3");
var $cu8Jp = parcelRequire("cu8Jp");

var $dKb7z = parcelRequire("dKb7z");

var $iOyj3 = parcelRequire("iOyj3");

var $721eg = parcelRequire("721eg");

var $6cEFf = parcelRequire("6cEFf");
const $a6384ca1c5e6727c$var$getBodiedExtensionContent = (node)=>{
    const bodiedExtensionContent = [];
    node.content.forEach((childNode)=>{
        bodiedExtensionContent.push((0, $cu8Jp.nodeToJSON)(childNode));
    });
    return !!bodiedExtensionContent.length ? bodiedExtensionContent : node.attrs.text;
};
const $a6384ca1c5e6727c$export$908ff786c04d5297 = (props)=>{
    const { extensionProvider: extensionProviderResolver, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, node: node, ...restProps } = props;
    const [extensionProvider, setExtensionProvider] = (0, $fc4bM.useState)(undefined);
    const [showBodiedExtensionRendererView, setShowBodiedExtensionRendererView] = (0, $fc4bM.useState)(!!(showLivePagesBodiedMacrosRendererView !== null && showLivePagesBodiedMacrosRendererView !== void 0 && showLivePagesBodiedMacrosRendererView((0, $cu8Jp.nodeToJSON)(node))) && !(0, $iOyj3.isEmptyBodiedMacro)(node));
    const mountedRef = (0, $fc4bM.useRef)(true);
    (0, $fc4bM.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        extensionProviderResolver === null || extensionProviderResolver === void 0 || extensionProviderResolver.then((provider)=>{
            if (mountedRef.current) setExtensionProvider(provider);
        });
    }, [
        extensionProviderResolver
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($a6384ca1c5e6727c$var$ExtensionComponentInner, {
        ...restProps,
        extensionProvider: extensionProvider,
        node: node,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    });
};
class $a6384ca1c5e6727c$var$ExtensionComponentInner extends (0, $fc4bM.Component) {
    componentDidMount() {
        this.resolveConfigureAffordanceIfNeeded();
    }
    componentDidUpdate() {
        this.parsePrivateNodePropsIfNeeded();
        this.resolveConfigureAffordanceIfNeeded();
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    render() {
        var _this$state$_privateP2;
        const { node: node, handleContentDOMRef: handleContentDOMRef, editorView: editorView, references: references, editorAppearance: editorAppearance, pluginInjectionApi: pluginInjectionApi, getPos: getPos, eventDispatcher: eventDispatcher, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, extensionProvider: extensionProvider, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, isLivePageViewMode: isLivePageViewMode } = this.props;
        const { selection: selection } = editorView.state;
        const selectedNode = selection instanceof (0, $801jp.NodeSelection) && selection.node;
        const position = typeof getPos === 'function' && getPos();
        const resolvedPosition = position && editorView.state.doc.resolve(position);
        const isNodeNested = !!(resolvedPosition && resolvedPosition.depth > 0);
        if (node.type.name === 'multiBodiedExtension') {
            var _this$state$_privateP;
            const allowBodiedOverride = (_this$state$_privateP = this.state._privateProps) === null || _this$state$_privateP === void 0 ? void 0 : _this$state$_privateP.__allowBodiedOverride;
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6cEFf.default), {
                node: node,
                editorView: editorView,
                getPos: getPos,
                handleContentDOMRef: handleContentDOMRef,
                tryExtensionHandler: this.tryExtensionHandler.bind(this),
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi,
                editorAppearance: editorAppearance,
                macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                isNodeSelected: selectedNode === node,
                isNodeHovered: this.state.isNodeHovered,
                isNodeNested: isNodeNested,
                setIsNodeHovered: this.setIsNodeHovered,
                isLivePageViewMode: isLivePageViewMode,
                allowBodiedOverride: allowBodiedOverride,
                hideConfigureLabel: this.state.hideConfigureLabel
            });
        }
        const extensionHandlerResult = this.tryExtensionHandler(undefined);
        switch(node.type.name){
            case 'extension':
            case 'bodiedExtension':
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dKb7z.default), {
                    node: node,
                    getPos: this.props.getPos,
                    references: references,
                    extensionProvider: extensionProvider,
                    handleContentDOMRef: handleContentDOMRef,
                    view: editorView,
                    editorAppearance: editorAppearance,
                    hideConfigureLabel: this.state.hideConfigureLabel,
                    hideFrame: (_this$state$_privateP2 = this.state._privateProps) === null || _this$state$_privateP2 === void 0 ? void 0 : _this$state$_privateP2.__hideFrame,
                    pluginInjectionApi: pluginInjectionApi,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    isNodeNested: isNodeNested,
                    showLivePagesBodiedMacrosRendererView: !!(showLivePagesBodiedMacrosRendererView !== null && showLivePagesBodiedMacrosRendererView !== void 0 && showLivePagesBodiedMacrosRendererView((0, $cu8Jp.nodeToJSON)(node))),
                    showUpdatedLivePages1PBodiedExtensionUI: !!(showUpdatedLivePages1PBodiedExtensionUI !== null && showUpdatedLivePages1PBodiedExtensionUI !== void 0 && showUpdatedLivePages1PBodiedExtensionUI((0, $cu8Jp.nodeToJSON)(node))),
                    showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                    setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                    isLivePageViewMode: isLivePageViewMode,
                    children: extensionHandlerResult
                });
            case 'inlineExtension':
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $721eg.default), {
                    node: node,
                    macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags,
                    isNodeSelected: selectedNode === node,
                    pluginInjectionApi: pluginInjectionApi,
                    isLivePageViewMode: isLivePageViewMode,
                    hideConfigureLabel: this.state.hideConfigureLabel,
                    children: extensionHandlerResult
                });
            default:
                return null;
        }
    }
    tryExtensionHandler(actions) {
        const { node: node } = this.props;
        try {
            const extensionContent = this.handleExtension(node, actions);
            if (extensionContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(extensionContent)) return extensionContent;
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Provided extension handler has thrown an error\n', e);
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        return null;
    }
    constructor(...args){
        super(...args), this.privatePropsParsed = false, this.configureAffordanceResolved = false, this.isUnmounted = false, this.state = {}, // memoized to avoid rerender on extension state changes
        this.getNodeRenderer = (0, $jiju3.default)((0, $iVHNS.getNodeRenderer)), this.getExtensionModuleNodePrivateProps = (0, $jiju3.default)((0, $iVHNS.getExtensionModuleNodePrivateProps)), this.setIsNodeHovered = (isHovered)=>{
            // Don't want to show hover interactions for live page view mode
            if (!this.props.isLivePageViewMode) this.setState({
                isNodeHovered: isHovered
            });
        }, /**
   * Parses any private nodes once an extension provider is available.
   *
   * We do this separately from resolving a node renderer component since the
   * private props come from extension provider, rather than an extension
   * handler which only handles `render`/component concerns.
   */ this.parsePrivateNodePropsIfNeeded = async ()=>{
            if (this.privatePropsParsed || !this.props.extensionProvider) return;
            this.privatePropsParsed = true;
            const { extensionType: extensionType, extensionKey: extensionKey } = this.props.node.attrs;
            /**
     * getExtensionModuleNodePrivateProps can throw if there are issues in the
     * manifest
     */ try {
                const privateProps = await this.getExtensionModuleNodePrivateProps(this.props.extensionProvider, extensionType, extensionKey);
                this.setState({
                    _privateProps: privateProps
                });
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error('Provided extension handler has thrown an error\n', e);
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        }, /**
   * Decides whether the "Configure {name}" lozenge label should be hidden for this node.
   *
   * Mirrors how the floating toolbar decides to show its edit button (see
   * `shouldShowEditButton` and `updateEditButton` in `editor-plugin-extension`):
   * - a legacy function handler is configurable via the macro browser;
   * - an object handler is configurable only if it defines `update`;
   * - otherwise the node module from the extension provider decides via its optional `update`.
   * Nodes with no way to be configured get no Configure affordance. Anything we cannot
   * resolve keeps the label, which is the pre-existing behaviour.
   *
   * The result is resolved once per node and held in state rather than derived on each render
   * because the provider path is asynchronous: `getExtensionModuleNode` goes through
   * `extensionProvider.getExtension`, which returns a Promise. Deriving the synchronous handler
   * branches in render while the provider branch stays async would let the same node flip
   * between answers, and would re-run the manifest lookup on every hover re-render. One
   * resolution keeps the label stable and cheap.
   */ this.resolveConfigureAffordanceIfNeeded = async ()=>{
            if (this.configureAffordanceResolved || !(0, $dRkX9.fg)('platform_editor_hide_configure_lozenge_non_configurable')) return;
            const { extensionHandlers: extensionHandlers, extensionProvider: extensionProvider, node: node } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
            const extensionHandler = extensionHandlers === null || extensionHandlers === void 0 ? void 0 : extensionHandlers[extensionType];
            if (typeof extensionHandler === 'function') {
                // Legacy macro browser: configurable, keep the label.
                this.configureAffordanceResolved = true;
                return;
            }
            if (extensionHandler && typeof extensionHandler === 'object') {
                this.configureAffordanceResolved = true;
                if (typeof extensionHandler.update !== 'function') this.setState({
                    hideConfigureLabel: true
                });
                return;
            }
            if (!extensionProvider) // No handler and no provider yet. The provider usually arrives asynchronously, so try
            // again from componentDidUpdate. If none ever arrives this is the legacy macro browser
            // path, which is configurable, so leaving the label is correct.
            return;
            this.configureAffordanceResolved = true;
            try {
                const extensionModuleNode = await (0, $iVHNS.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
                if (this.isUnmounted) return;
                if (typeof (extensionModuleNode === null || extensionModuleNode === void 0 ? void 0 : extensionModuleNode.update) !== 'function') this.setState({
                    hideConfigureLabel: true
                });
            } catch (e) {
            // Manifest lookups can throw (unknown extension, malformed manifest). Keep the label,
            // which matches the toolbar failing silently and keeping its default. Not logged here on
            // purpose: parsePrivateNodePropsIfNeeded runs the same lookup for the same node and already
            // console.errors the failure, so a second log would double up per unknown extension.
            }
        }, this.handleExtension = (pmNode, actions)=>{
            var _pmNode$marks;
            const { extensionHandlers: extensionHandlers, extensionLoadingHandlers: extensionLoadingHandlers, editorView: editorView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, rendererExtensionHandlers: rendererExtensionHandlers, onContentReady: onContentReady } = this.props;
            const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, text: text } = pmNode.attrs;
            const isBodiedExtension = pmNode.type.name === 'bodiedExtension';
            const { selection: selection } = editorView.state;
            const isSelected = selection instanceof (0, $801jp.NodeSelection) && selection.node === pmNode;
            if (isBodiedExtension && !showBodiedExtensionRendererView) return;
            const fragmentLocalId = pmNode === null || pmNode === void 0 || (_pmNode$marks = pmNode.marks) === null || _pmNode$marks === void 0 || (_pmNode$marks = _pmNode$marks.find((m)=>m.type.name === 'fragment')) === null || _pmNode$marks === void 0 || (_pmNode$marks = _pmNode$marks.attrs) === null || _pmNode$marks === void 0 ? void 0 : _pmNode$marks.localId;
            const content = isBodiedExtension ? $a6384ca1c5e6727c$var$getBodiedExtensionContent(pmNode) : text;
            const node = {
                type: pmNode.type.name,
                extensionType: extensionType,
                extensionKey: extensionKey,
                parameters: parameters,
                content: content,
                localId: pmNode.attrs.localId,
                fragmentLocalId: fragmentLocalId
            };
            if (isBodiedExtension) {
                const rendererExtensionHandler = rendererExtensionHandlers === null || rendererExtensionHandlers === void 0 ? void 0 : rendererExtensionHandlers[extensionType];
                // Forge bodied extensions don't get rendererExtensionHandlers passed in and use extensionHandlerFromProvider from the below logic instead
                if (rendererExtensionHandler) return (0, $8oPL3.getExtensionRenderer)(rendererExtensionHandler)(node, (0, $cu8Jp.toJSON)(editorView.state.doc));
            }
            let result;
            const loadingFallback = extensionLoadingHandlers !== null && extensionLoadingHandlers !== void 0 && extensionLoadingHandlers[extensionType] ? (0, $8oPL3.getExtensionRenderer)(extensionLoadingHandlers[extensionType])(node, editorView.state.doc, actions) : undefined;
            if (extensionHandlers && extensionHandlers[extensionType]) {
                const render = (0, $8oPL3.getExtensionRenderer)(extensionHandlers[extensionType]);
                result = render(node, editorView.state.doc, actions);
            }
            if (!result) {
                const extensionHandlerFromProvider = this.props.extensionProvider && this.getNodeRenderer(this.props.extensionProvider, extensionType, extensionKey);
                if (extensionHandlerFromProvider) {
                    const NodeRenderer = extensionHandlerFromProvider;
                    if (node.type === 'multiBodiedExtension') return /*#__PURE__*/ (0, $3LM7S.jsx)(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        actions: actions,
                        loadingFallback: loadingFallback
                    });
                    return /*#__PURE__*/ (0, $3LM7S.jsx)(NodeRenderer, {
                        node: node,
                        references: this.props.references,
                        isSelected: isSelected,
                        loadingFallback: loadingFallback,
                        onContentReady: onContentReady,
                        showUnknownMacroPlaceholder: true
                    });
                }
            }
            return result ?? loadingFallback;
        };
    }
}

});
parcelRegister("dKb7z", function(module, exports) {
$parcel$export(module.exports, "default", () => $02442c9e5543552f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jyPR0 = parcelRequire("jyPR0");

var $jiju3 = parcelRequire("jiju3");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $9oAqi = parcelRequire("9oAqi");

var $58I5S = parcelRequire("58I5S");

var $1r7H5 = parcelRequire("1r7H5");

var $9JwwP = parcelRequire("9JwwP");

var $lVHvZ = parcelRequire("lVHvZ");

var $gL1iz = parcelRequire("gL1iz");

var $gW2ks = parcelRequire("gW2ks");

var $502oy = parcelRequire("502oy");

var $iOyj3 = parcelRequire("iOyj3");

var $9F1RF = parcelRequire("9F1RF");
function $02442c9e5543552f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $02442c9e5543552f$var$hoverStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $02442c9e5543552f$var$containerStyle = {
    name: "nhejpy",
    styles: "container-type:inline-size"
};
// Keep these checks in sync with the extensionScrollInlineShadowStyles @supports condition in
// editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx.
const $02442c9e5543552f$var$isCssScrollTimelineSupported = (0, $jiju3.default)((browserCSS)=>{
    if (!browserCSS || typeof browserCSS.supports !== 'function') return false;
    return browserCSS.supports('animation-timeline', '--test-timeline') && browserCSS.supports('scroll-timeline-name', '--test-timeline') && browserCSS.supports('timeline-scope', '--test-timeline') && browserCSS.supports('animation-range', '0% 101%');
});
function $02442c9e5543552f$var$ExtensionWithPluginState(props) {
    var _node$attrs, _node$marks;
    const { node: node, handleContentDOMRef: handleContentDOMRef, children: children, widthState: widthState, handleRef: handleRef, shadowClassNames: shadowClassNames, hideFrame: hideFrame, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, hideConfigureLabel: hideConfigureLabel } = props;
    const [container, setContainer] = (0, $fc4bM.useState)(null);
    const handleContainerRef = (0, $fc4bM.useCallback)((element)=>{
        handleRef === null || handleRef === void 0 || handleRef(element);
        if ((0, $dRkX9.fg)('cc_maui_annotations_on_extensions')) setContainer(element);
    }, [
        handleRef
    ]);
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const isLegacyContentMacroExtension = (extensionNode)=>{
        var _extensionNode$attrs, _extensionNode$attrs2;
        return extensionNode.type.name === 'extension' && ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === 'com.atlassian.confluence.migration' && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === 'legacy-content';
    };
    const showLegacyContentHeader = (0, $dRkX9.fg)('platform_editor_legacy_content_macro_visual_update') && isLegacyContentMacroExtension(node);
    const hasBody = [
        'bodiedExtension',
        'multiBodiedExtension'
    ].includes(node.type.name);
    const hasChildren = !!children;
    const removeBorder = showMacroInteractionDesignUpdates || !!(hideFrame && !hasBody);
    // Some native bodied macros (e.g Content properties) have this param to hide in view mode
    // which we want to also hide in live page view mode too
    const macroParamHiddenValue = node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 || (_node$attrs = _node$attrs.parameters) === null || _node$attrs === void 0 || (_node$attrs = _node$attrs.macroParams) === null || _node$attrs === void 0 || (_node$attrs = _node$attrs.hidden) === null || _node$attrs === void 0 ? void 0 : _node$attrs.value;
    const shouldHideInLivePageViewMode = isLivePageViewMode && macroParamHiddenValue === 'true'; // it is stored as a string
    const { getPos: getPos, view: view } = props;
    const isTopLevelNode = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        const pos = typeof getPos === 'function' ? getPos() : undefined;
        return typeof pos !== 'undefined' && !isNaN(pos) && view.state.doc.resolve(pos).depth === 0;
    }, [
        view,
        getPos
    ]);
    const layout = node.attrs.layout;
    const shouldBreakout = (0, $lVHvZ.shouldExtensionBreakout)({
        layout: layout,
        isTopLevelNode: isTopLevelNode,
        editorAppearance: editorAppearance,
        hasBreakoutMark: (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.some((mark)=>mark.type.name === 'breakout')
    });
    // We don't want to show border for non-empty 1p bodied extensions in live pages
    const show1PBodiedExtensionBorder = showUpdatedLivePages1PBodiedExtensionUI ? (0, $iOyj3.isEmptyBodiedMacro)(node) : true;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('extension-container', 'block', shadowClassNames, {
        'with-overlay': !hasBody && !showMacroInteractionDesignUpdates,
        'with-bodied-border': showMacroInteractionDesignUpdates && (hasBody || isLegacyContentMacroExtension(node)) && !showBodiedExtensionRendererView && show1PBodiedExtensionBorder,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'without-frame': removeBorder,
        [(0, $9F1RF.widerLayoutClassName)]: shouldBreakout
    });
    const overflowClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('extension-overflow-wrapper', {
        'extension-scroll-inline-shadow': (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') && !hasBody && node.attrs.extensionType !== 'com.atlassian.ai-blocks',
        'with-body': hasBody,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested && !showBodiedExtensionRendererView,
        // Adding extra padding for renderer view so users can have a touch target to click on the extension
        'with-padding-styles': showMacroInteractionDesignUpdates && showBodiedExtensionRendererView
    });
    const headerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))({
        'with-children': hasChildren,
        'without-frame': removeBorder
    });
    const newContentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))({
        'with-padding-styles': showMacroInteractionDesignUpdates,
        'with-bodied-padding-styles': hasBody && showMacroInteractionDesignUpdates
    });
    const contentClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('extension-content', 'block', {
        'remove-border': showMacroInteractionDesignUpdates,
        'hide-content': showBodiedExtensionRendererView
    });
    let customContainerStyles = {
        width: '100%'
    };
    let newContentStyles = {};
    if (shouldBreakout) {
        // type is destructured so that breakout styles does not include it
        const { type: _type, ...breakoutStyles } = (0, $9JwwP.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateWidth: widthState.width,
            widthStateLineLength: widthState.lineLength
        });
        newContentStyles = {
            ...breakoutStyles
        };
        customContainerStyles = breakoutStyles;
    }
    newContentStyles = {
        ...newContentStyles,
        ...(0, $9F1RF.contentWrapper)
    };
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, !showLegacyContentHeader && showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $jctmk.jsx)((0, $gW2ks.default), {
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: hasBody || isLegacyContentMacroExtension(node),
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi,
        hideConfigureLabel: hideConfigureLabel
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "extension-container",
        ref: handleContainerRef,
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $9F1RF.wrapperStyleInheritedCursor),
            showMacroInteractionDesignUpdates && !isLivePageViewMode && $02442c9e5543552f$var$hoverStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "extension-overflow-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: overflowClassNames,
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9F1RF.overflowWrapperStyles),
            $02442c9e5543552f$var$containerStyle
        ]
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        className: 'extension-overlay',
        css: (0, $502oy.overlay)
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $9F1RF.header),
        contentEditable: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: headerClassNames
    }, !removeBorder && /*#__PURE__*/ (0, $jctmk.jsx)((0, $gW2ks.default), {
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi,
        hideConfigureLabel: hideConfigureLabel
    }), children), hasBody && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: newContentStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: newContentClassNames,
        "data-testid": "extension-new-content"
    }, !shouldHideInLivePageViewMode && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "extension-content",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $9F1RF.extensionContent),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: contentClassNames
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $58I5S.NodeViewContentHole), {
        ref: handleContentDOMRef
    })))), (0, $dRkX9.fg)('cc_maui_annotations_on_extensions') && node.type.name === 'extension' && container && (pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.annotation) && /*#__PURE__*/ (0, $jctmk.jsx)((0, $gL1iz.ExtensionCommentBadge), {
        api: pluginInjectionApi,
        node: node,
        getPos: getPos,
        editorView: view,
        container: container
    })));
}
const $02442c9e5543552f$var$Extension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { lineLength: lineLength, width: width } = (0, $9oAqi.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        var _states$widthState, _states$widthState2;
        return {
            width: ((_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width) ?? 0,
            lineLength: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.lineLength
        };
    });
    const memoizedWidthState = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>({
            width: width ?? 0,
            lineLength: lineLength
        }), [
        width,
        lineLength
    ]);
    const widthState = (0, $bcN2K.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedWidthState : {
        width: width ?? 0,
        lineLength: lineLength
    };
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $jctmk.jsx)($02442c9e5543552f$var$ExtensionWithPluginState, {
        widthState: widthState,
        ...props
    });
};
const $02442c9e5543552f$var$_default_1 = (0, $1r7H5.default)($02442c9e5543552f$var$Extension, {
    overflowSelector: '.extension-overflow-wrapper',
    isDisabled: ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') && $02442c9e5543552f$var$isCssScrollTimelineSupported(globalThis.CSS)
});
var $02442c9e5543552f$export$2e2bcd8739ae039 = $02442c9e5543552f$var$_default_1;

});
parcelRegister("lVHvZ", function(module, exports) {
$parcel$export(module.exports, "shouldExtensionBreakout", () => $fcf1cd369cf98957$export$85b54d274949f309);

var $bcN2K = parcelRequire("bcN2K");
const $fcf1cd369cf98957$var$breakoutLayouts = new Set([
    'full-width',
    'wide'
]);
const $fcf1cd369cf98957$var$shouldRespectBreakoutForAppearance = (appearance)=>{
    if (!appearance) return true;
    if (appearance === 'full-width') return false;
    if (appearance === 'max') return false;
    return true;
};
const $fcf1cd369cf98957$export$85b54d274949f309 = ({ layout: layout, isTopLevelNode: isTopLevelNode = true, editorAppearance: editorAppearance, hasBreakoutMark: hasBreakoutMark = false })=>{
    // the breakout mark wrapper owns the width, so the legacy layout must not size the node too
    if (hasBreakoutMark && (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) return false;
    if (!layout || !$fcf1cd369cf98957$var$breakoutLayouts.has(layout)) return false;
    if (!isTopLevelNode) return false;
    return $fcf1cd369cf98957$var$shouldRespectBreakoutForAppearance(editorAppearance);
};

});

parcelRegister("gL1iz", function(module, exports) {
$parcel$export(module.exports, "ExtensionCommentBadge", () => $03eedda48996e666$export$1b19fbf46f8a1bdf);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $7tbCp = parcelRequire("7tbCp");

var $efOj7 = parcelRequire("efOj7");

var $9oAqi = parcelRequire("9oAqi");

var $hN6uZ = parcelRequire("hN6uZ");
const $03eedda48996e666$export$1b19fbf46f8a1bdf = ({ api: api, editorView: editorView, node: node, getPos: getPos, container: container })=>{
    var _api$annotation4;
    const { annotationState: annotationState } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], (states)=>({
            annotationState: states.annotationState
        }));
    const drafting = Boolean((annotationState === null || annotationState === void 0 ? void 0 : annotationState.isDrafting) && node.attrs.localId && node.attrs.localId === annotationState.targetNodeId);
    const hasOpenDraft = Boolean(annotationState === null || annotationState === void 0 ? void 0 : annotationState.isDrafting);
    const unresolvedIds = (0, $fc4bM.useMemo)(()=>node.marks.filter((mark)=>mark.type.name === 'annotation' && (annotationState === null || annotationState === void 0 ? void 0 : annotationState.annotations[mark.attrs.id]) === false).map((mark)=>mark.attrs.id), [
        node.marks,
        annotationState === null || annotationState === void 0 ? void 0 : annotationState.annotations
    ]);
    const onClick = (0, $fc4bM.useCallback)(async (event)=>{
        var _api$annotation, _api$annotation2;
        event.preventDefault();
        event.stopPropagation();
        if (drafting) return;
        if (hasOpenDraft && !await (api === null || api === void 0 || (_api$annotation = api.annotation) === null || _api$annotation === void 0 ? void 0 : _api$annotation.actions.requestCloseInlineComment())) return;
        // Resolve the current position after the asynchronous discard confirmation.
        const pos = getPos();
        if (typeof pos !== 'number' || !Number.isFinite(pos) || pos < 0 || pos >= editorView.state.doc.content.size) return;
        const currentNode = editorView.state.doc.nodeAt(pos);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) === node.type && currentNode.attrs.localId === node.attrs.localId && api !== null && api !== void 0 && (_api$annotation2 = api.annotation) !== null && _api$annotation2 !== void 0 && _api$annotation2.actions.isBlockNodeSupported(currentNode)) {
            var _api$annotation3;
            api === null || api === void 0 || (_api$annotation3 = api.annotation) === null || _api$annotation3 === void 0 || _api$annotation3.actions.showCommentForBlockNode(currentNode, (0, $7tbCp.VIEW_METHOD).BADGE)(editorView.state, editorView.dispatch);
        }
    }, [
        api,
        editorView,
        node,
        getPos,
        drafting,
        hasOpenDraft
    ]);
    if (!(annotationState !== null && annotationState !== void 0 && annotationState.isVisible) || node.type.name !== 'extension' || !(api !== null && api !== void 0 && (_api$annotation4 = api.annotation) !== null && _api$annotation4 !== void 0 && _api$annotation4.actions.isBlockNodeSupported(node))) return null;
    if (!drafting && !unresolvedIds.length) return null;
    const active = drafting || !annotationState.isInlineCommentViewClosed && annotationState.selectedAnnotations.some(({ id: id })=>unresolvedIds.includes(id));
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $efOj7.BlockNodeBadges), {
        element: container,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hN6uZ.CommentBadgeNext), {
            onClick: onClick,
            status: active ? 'active' : 'default'
        })
    });
};

});

parcelRegister("gW2ks", function(module, exports) {
$parcel$export(module.exports, "default", () => $de0685839291b84e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $aGOGh = parcelRequire("aGOGh");

var $502oy = parcelRequire("502oy");

var $7GQ8o = parcelRequire("7GQ8o");
class $de0685839291b84e$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    render() {
        const { node: node, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = this.props;
        const imageData = (0, $aGOGh.getExtensionLozengeData)({
            node: node,
            type: 'image'
        });
        if (!showMacroInteractionDesignUpdates && imageData && node.type.name !== 'extension') return this.renderImage(imageData);
        const iconData = (0, $aGOGh.getExtensionLozengeData)({
            node: node,
            type: 'icon'
        });
        return this.renderFallback(iconData);
    }
    constructor(...args){
        super(...args), this.renderImage = (lozengeData)=>{
            const { extensionKey: extensionKey } = this.props.node.attrs;
            const { url: url, ...rest } = lozengeData;
            // eslint-disable-next-line react/jsx-props-no-spreading, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            return /*#__PURE__*/ (0, $jctmk.jsx)("img", {
                css: (0, $502oy.styledImage),
                src: url,
                ...rest,
                alt: extensionKey
            });
        }, this.renderFallback = (lozengeData)=>{
            const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi } = this.props;
            const { parameters: parameters, extensionKey: extensionKey } = this.props.node.attrs;
            const { name: name } = this.props.node.type;
            const params = parameters && parameters.macroParams;
            const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey;
            return /*#__PURE__*/ (0, $jctmk.jsx)((0, $7GQ8o.LozengeComponent), {
                isNodeHovered: isNodeHovered,
                isNodeNested: isNodeNested,
                showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
                extensionName: name,
                hideConfigureLabel: this.props.hideConfigureLabel,
                lozengeData: lozengeData,
                params: params,
                title: title,
                renderImage: this.renderImage,
                customContainerStyles: customContainerStyles,
                setIsNodeHovered: setIsNodeHovered,
                isBodiedMacro: isBodiedMacro,
                showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
                showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
                showBodiedExtensionRendererView: showBodiedExtensionRendererView,
                setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView,
                pluginInjectionApi: pluginInjectionApi
            });
        };
    }
}

});
parcelRegister("502oy", function(module, exports) {
$parcel$export(module.exports, "wrapperDefault", () => $4146b03e7049a478$export$2c23939c304dcbb6);
$parcel$export(module.exports, "overlay", () => $4146b03e7049a478$export$29dd17c7f3c81c36);
$parcel$export(module.exports, "placeholderFallback", () => $4146b03e7049a478$export$f61e107d01719381);
$parcel$export(module.exports, "placeholderFallbackParams", () => $4146b03e7049a478$export$baa8de7b590bf812);
$parcel$export(module.exports, "styledImage", () => $4146b03e7049a478$export$83cb1da155637959);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
function $4146b03e7049a478$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4146b03e7049a478$export$2c23939c304dcbb6 = {
    name: "1st3gh2",
    styles: "background:var(--ds-background-neutral, #0515240F);border-radius:var(--ds-radius-small, 3px);position:relative;vertical-align:middle;&.with-overlay{.extension-overlay{background:var(--ds-background-neutral-hovered, #0B120E24);color:transparent;}&:hover .extension-overlay{opacity:1;}}"
};
const $4146b03e7049a478$export$29dd17c7f3c81c36 = {
    name: "7geot",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;top:0;left:0"
};
const $4146b03e7049a478$export$f61e107d01719381 = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'inline-flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > img': {
        margin: `0 ${"var(--ds-space-050, 4px)"}`
    },
    /* TODO: fix in develop: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E */ /* stylelint-disable-next-line */ label: 'placeholder-fallback'
});
const $4146b03e7049a478$export$baa8de7b590bf812 = {
    name: "147iacu",
    styles: "display:inline-block;max-width:200px;margin-left:var(--ds-space-050, 4px);color:var(--ds-text-subtlest, #6B6E76);text-overflow:ellipsis;white-space:nowrap;overflow:hidden"
};
const $4146b03e7049a478$export$83cb1da155637959 = {
    name: "1ib9bih-lozenge-image",
    styles: "max-height:16px;max-width:16px;label:lozenge-image"
};

});

parcelRegister("7GQ8o", function(module, exports) {
$parcel$export(module.exports, "LozengeComponent", () => $de7bcba0f41491cc$export$14bad8182dc08b5a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $3dgbz = parcelRequire("3dgbz");

var $502oy = parcelRequire("502oy");

var $4uz5P = parcelRequire("4uz5P");

var $hBCS0 = parcelRequire("hBCS0");
const $de7bcba0f41491cc$export$91a15f1424900d33 = 24;
const $de7bcba0f41491cc$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $de7bcba0f41491cc$export$14bad8182dc08b5a = ({ lozengeData: lozengeData, extensionName: extensionName, title: title, params: params, renderImage: renderImage, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates, customContainerStyles: customContainerStyles, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView, pluginInjectionApi: pluginInjectionApi, hideConfigureLabel: hideConfigureLabel })=>{
    const capitalizedTitle = $de7bcba0f41491cc$var$capitalizeFirstLetter(title);
    if (showMacroInteractionDesignUpdates) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $hBCS0.ExtensionLabel), {
        text: capitalizedTitle,
        extensionName: extensionName,
        hideConfigureLabel: hideConfigureLabel,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        customContainerStyles: customContainerStyles,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: isBodiedMacro,
        showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView,
        showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        pluginInjectionApi: pluginInjectionApi
    }), showLivePagesBodiedMacrosRendererView && isBodiedMacro && /*#__PURE__*/ (0, $jctmk.jsx)((0, $4uz5P.EditToggle), {
        isNodeHovered: isNodeHovered,
        setIsNodeHovered: setIsNodeHovered,
        customContainerStyles: customContainerStyles,
        showBodiedExtensionRendererView: showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView
    }));
    const isBlockExtension = extensionName === 'extension';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "lozenge-fallback",
        css: (0, $502oy.placeholderFallback)
    }, lozengeData && !isBlockExtension ? renderImage({
        height: $de7bcba0f41491cc$export$91a15f1424900d33,
        width: $de7bcba0f41491cc$export$91a15f1424900d33,
        ...lozengeData
    }) : /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dgbz))), {
        label: title
    }), /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        className: "extension-title"
    }, capitalizedTitle), params && !isBlockExtension && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        css: (0, $502oy.placeholderFallbackParams)
    }, Object.keys(params).map((key)=>key && ` | ${key} = ${params[key].value}`))));
};

});
parcelRegister("4uz5P", function(module, exports) {
$parcel$export(module.exports, "EditToggle", () => $ae112df460142ef3$export$2ada5dce8cd41705);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $8p5Cv = parcelRequire("8p5Cv");
var $gpjDl = parcelRequire("gpjDl");

var $jaqgn = parcelRequire("jaqgn");

var $5BrPA = parcelRequire("5BrPA");

var $1JdzP = parcelRequire("1JdzP");

var $kig2V = parcelRequire("kig2V");

var $aEmSo = parcelRequire("aEmSo");
function $ae112df460142ef3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ae112df460142ef3$var$buttonContainerStyles = {
    name: "cy6p8l",
    styles: "opacity:0;line-height:1;position:absolute;width:max-content;top:-28px;display:inline-flex;justify-content:flex-end;color:var(--ds-text-subtle, #505258)"
};
const $ae112df460142ef3$var$buttonStyles = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
    minHeight: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-radius-small, 4px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    paddingRight: "var(--ds-space-150, 12px)",
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    '&:hover': {
        backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
    },
    outlineColor: "var(--ds-border-focused, #4688EC)",
    border: 'none',
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    color: "var(--ds-text-subtle, #505258)"
});
const $ae112df460142ef3$var$iconStyles = (0, $kig2V.xcss)({
    marginRight: 'space.075'
});
const $ae112df460142ef3$var$i18n = (0, $8p5Cv.defineMessages)({
    doneEditing: {
        id: 'editor-common-extensibility-extension-lozenge-editToggle.done.editing',
        defaultMessage: 'Done editing',
        description: 'Text in button when on click switches back to view mode of a macro'
    },
    makeEdits: {
        id: 'editor-common-extensibility-extension-lozenge-editToggle.make.edits',
        defaultMessage: 'Make edits',
        description: 'Text in button when on click switches back to edit mode of a macro'
    }
});
const $ae112df460142ef3$export$2ada5dce8cd41705 = ({ customContainerStyles: customContainerStyles, setIsNodeHovered: setIsNodeHovered, showBodiedExtensionRendererView: showBodiedExtensionRendererView, setShowBodiedExtensionRendererView: setShowBodiedExtensionRendererView })=>{
    const intl = (0, $gpjDl.default)();
    const text = showBodiedExtensionRendererView ? intl.formatMessage($ae112df460142ef3$var$i18n.makeEdits) : intl.formatMessage($ae112df460142ef3$var$i18n.doneEditing);
    const icon = showBodiedExtensionRendererView ? /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5BrPA))), {
        testId: "edit-icon",
        label: ""
    }) : /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jaqgn))), {
        testId: "check-mark-icon",
        label: ""
    });
    const handleClick = (0, $fc4bM.useCallback)(()=>{
        setShowBodiedExtensionRendererView === null || setShowBodiedExtensionRendererView === void 0 || setShowBodiedExtensionRendererView(!showBodiedExtensionRendererView);
    }, [
        showBodiedExtensionRendererView,
        setShowBodiedExtensionRendererView
    ]);
    const handleKeyDown = (0, $fc4bM.useCallback)((event)=>{
        if (event.key === 'Enter') handleClick();
    }, [
        handleClick
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "extension-edit-toggle-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: [
            $ae112df460142ef3$var$buttonContainerStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle-container",
        onMouseOver: ()=>setIsNodeHovered === null || setIsNodeHovered === void 0 ? void 0 : setIsNodeHovered(true),
        // @atlassian/a11y/mouse-events-have-key-events: keyboard focus is already handled by the
        // inner <button>'s onFocus/onBlur. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>setIsNodeHovered === null || setIsNodeHovered === void 0 ? void 0 : setIsNodeHovered(false),
        onBlur: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $jctmk.jsx)("button", {
        type: "button",
        "data-testid": "edit-toggle",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $ae112df460142ef3$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-edit-toggle",
        onClick: handleClick,
        onKeyDown: handleKeyDown,
        onFocus: ()=>setIsNodeHovered === null || setIsNodeHovered === void 0 ? void 0 : setIsNodeHovered(true),
        onBlur: ()=>setIsNodeHovered === null || setIsNodeHovered === void 0 ? void 0 : setIsNodeHovered(false)
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $1JdzP.Flex), {
        as: "span",
        xcss: $ae112df460142ef3$var$iconStyles
    }, icon), text));
};

});

parcelRegister("hBCS0", function(module, exports) {
$parcel$export(module.exports, "ExtensionLabel", () => $6b51c0ccc0e028f2$export$addedb5f7f03bdb1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jyPR0 = parcelRequire("jyPR0");

var $8p5Cv = parcelRequire("8p5Cv");
var $fd880 = parcelRequire("fd880");

var $fBqpc = parcelRequire("fBqpc");

var $bcN2K = parcelRequire("bcN2K");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $aEmSo = parcelRequire("aEmSo");

var $bcTS3 = parcelRequire("bcTS3");
function $6b51c0ccc0e028f2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b51c0ccc0e028f2$var$containerStyles = {
    name: "1xnw70r",
    styles: "text-align:left;z-index:1;position:relative;&.bodied{margin-top:var(--ds-space-300, 24px);}"
};
const $6b51c0ccc0e028f2$var$showLabelStyles = {
    name: "3ix1vd",
    styles: "opacity:1"
};
const $6b51c0ccc0e028f2$var$hideLabelStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $6b51c0ccc0e028f2$var$labelStyles = /*#__PURE__*/ (0, $jctmk.css)({
    opacity: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    display: 'inline-flex',
    justifyContent: 'left',
    position: 'absolute',
    width: 'max-content',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
    top: '-28px',
    // When updating this value, make sure to also update the value in EditToggle.tsx, buttonContainerStyles
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.show-label': {
        cursor: 'pointer',
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.nested': {
        // Need to add indent if the node is nested since we removed previous indentation styles to make it fit properly
        // in the nested component
        marginLeft: "var(--ds-space-150, 12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.inline': {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '-27px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-background': {
        background: "var(--ds-surface, #FFFFFF)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    minHeight: "var(--ds-space-300, 24px)",
    alignItems: 'center',
    borderRadius: "var(--ds-radius-small, 3px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    paddingRight: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, #505258)",
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-left-margin': {
        marginLeft: "var(--ds-space-negative-150, -12px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-nested-left-margin': {
        marginLeft: 0
    },
    font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-macro-live-page-styles': {
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $6b51c0ccc0e028f2$var$spacerStyles = (0, $kig2V.xcss)({
    height: 'space.200',
    position: 'absolute',
    width: '100%'
});
const $6b51c0ccc0e028f2$var$iconStyles = {
    name: "1s9vzwe",
    styles: "margin-left:var(--ds-space-075, 6px);&.hide-icon{display:none;}"
};
const $6b51c0ccc0e028f2$var$bodiedMacroIconStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $6b51c0ccc0e028f2$var$i18n = (0, $8p5Cv.defineMessages)({
    configure: {
        id: 'editor-common-extensibility.macro.button.configure',
        defaultMessage: 'Configure {macroName}',
        description: 'Text in tooltip that tells user they can configure the specific macro.'
    }
});
const $6b51c0ccc0e028f2$export$addedb5f7f03bdb1 = ({ text: text, extensionName: extensionName, customContainerStyles: customContainerStyles, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, isBodiedMacro: isBodiedMacro, hideConfigureLabel: hideConfigureLabel, showUpdatedLivePages1PBodiedExtensionUI: showUpdatedLivePages1PBodiedExtensionUI, showLivePagesBodiedMacrosRendererView: showLivePagesBodiedMacrosRendererView, showBodiedExtensionRendererView: showBodiedExtensionRendererView, pluginInjectionApi: _pluginInjectionApi })=>{
    const isInlineExtension = extensionName === 'inlineExtension';
    const showDefaultBodiedStyles = isBodiedMacro;
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))({
        bodied: isBodiedMacro
    });
    const labelClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('extension-label', {
        nested: isNodeNested,
        inline: isInlineExtension,
        bodied: isBodiedMacro,
        'bodied-border': showDefaultBodiedStyles,
        'bodied-background': showDefaultBodiedStyles,
        'with-bodied-macro-live-page-styles': isBodiedMacro && showLivePagesBodiedMacrosRendererView,
        'always-hide-label': isBodiedMacro && showBodiedExtensionRendererView,
        // Need this separate class since we don't ever want to show the label during view mode
        'remove-left-margin': !isBodiedMacro && !isInlineExtension && !isNodeNested,
        'remove-nested-left-margin': isNodeNested && !isBodiedMacro && !isInlineExtension
    });
    const iconClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))({
        'extension-icon': true
    });
    const memoizedTooltipValues = (0, $fc4bM.useMemo)(()=>({
            macroName: text
        }), [
        text
    ]);
    const tooltipValues = (0, $bcN2K.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedTooltipValues : {
        macroName: text
    };
    return(// eslint-disable-next-line @atlassian/a11y/no-static-element-interactions, @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        css: $6b51c0ccc0e028f2$var$containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: customContainerStyles,
        onMouseOver: ()=>{
            setIsNodeHovered === null || setIsNodeHovered === void 0 || setIsNodeHovered(true);
        },
        // @atlassian/a11y/mouse-events-have-key-events: label visibility on keyboard focus is already
        // handled via the .ak-editor-selected-node CSS class applied by ProseMirror on node selection.
        // No-ops here satisfy the rule.
        onFocus: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>{
            setIsNodeHovered === null || setIsNodeHovered === void 0 || setIsNodeHovered(false);
        },
        onBlur: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        "data-testid": "new-lozenge-container",
        contentEditable: false
    }, !hideConfigureLabel && /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, $jctmk.jsx)((0, $fd880.default), {
            ...$6b51c0ccc0e028f2$var$i18n.configure,
            values: tooltipValues
        }),
        position: "top"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $jctmk.jsx)("span", {
            "data-testid": "new-lozenge-button",
            ...tooltipProps,
            css: [
                $6b51c0ccc0e028f2$var$labelStyles,
                !showLivePagesBodiedMacrosRendererView && $6b51c0ccc0e028f2$var$showLabelStyles,
                (!isBodiedMacro || showUpdatedLivePages1PBodiedExtensionUI) && $6b51c0ccc0e028f2$var$hideLabelStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: labelClassNames
        }, text, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
            css: [
                $6b51c0ccc0e028f2$var$iconStyles,
                isBodiedMacro && $6b51c0ccc0e028f2$var$bodiedMacroIconStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: iconClassNames,
            "data-testid": "config-icon"
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBqpc))), {
            label: ""
        })))), /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
        xcss: $6b51c0ccc0e028f2$var$spacerStyles
    })));
};

});



parcelRegister("iOyj3", function(module, exports) {
$parcel$export(module.exports, "isEmptyBodiedMacro", () => $9654b3a87961088d$export$d01da3229dfc693b);
const $9654b3a87961088d$export$d01da3229dfc693b = (node)=>{
    var _node$content, _firstGrandChildNode$;
    if (node.type.name !== 'bodiedExtension') return false;
    const firstChildNode = node === null || node === void 0 || (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.firstChild;
    const firstGrandChildNode = firstChildNode === null || firstChildNode === void 0 ? void 0 : firstChildNode.firstChild;
    // If firstChildNode?.childCount > 1 means there is content along with the placeholder.
    const isEmptyWithPlacholder = (firstGrandChildNode === null || firstGrandChildNode === void 0 || (_firstGrandChildNode$ = firstGrandChildNode.type) === null || _firstGrandChildNode$ === void 0 ? void 0 : _firstGrandChildNode$.name) === 'placeholder' && (firstChildNode === null || firstChildNode === void 0 ? void 0 : firstChildNode.childCount) === 1;
    const isEmptyWithNoContent = !firstGrandChildNode && node.childCount === 1;
    return isEmptyWithPlacholder || isEmptyWithNoContent;
};

});

parcelRegister("9F1RF", function(module, exports) {
$parcel$export(module.exports, "widerLayoutClassName", () => $2fb79e2d31fb82d4$export$c51f29288b3ec9db);
$parcel$export(module.exports, "wrapperStyleInheritedCursor", () => $2fb79e2d31fb82d4$export$ebf956b2dea5bd2e);
$parcel$export(module.exports, "header", () => $2fb79e2d31fb82d4$export$38e42c68cf43b5d4);
$parcel$export(module.exports, "extensionContent", () => $2fb79e2d31fb82d4$export$16dcf8c62f81d973);
$parcel$export(module.exports, "contentWrapper", () => $2fb79e2d31fb82d4$export$2a82ddc22e8c7fbb);
$parcel$export(module.exports, "overflowWrapperStyles", () => $2fb79e2d31fb82d4$export$2ab74686abf0084);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $502oy = parcelRequire("502oy");
const $2fb79e2d31fb82d4$export$c51f29288b3ec9db = 'wider-layout';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $2fb79e2d31fb82d4$var$wrapperStyleWithoutCursor = /*#__PURE__*/ (0, $jctmk.css)((0, $502oy.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        background: 'transparent'
    },
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.extension-overflow-wrapper:not(.with-body)': {
        overflowX: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`,
        padding: `0 ${"var(--ds-space-250, 20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.legacy-content': {
        borderRadius: `0 0 ${"var(--ds-radius-small, 3px)"} ${"var(--ds-radius-small, 3px)"}`
    }
});
const $2fb79e2d31fb82d4$export$ebf956b2dea5bd2e = /*#__PURE__*/ (0, $jctmk.css)($2fb79e2d31fb82d4$var$wrapperStyleWithoutCursor, ".extension-overflow-wrapper:has(.extension-editable-area){cursor:inherit;}.extension-overflow-wrapper:not(:has(.extension-editable-area)){cursor:pointer;}");
const $2fb79e2d31fb82d4$export$38e42c68cf43b5d4 = /*#__PURE__*/ (0, $jctmk.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"} 0px`,
    verticalAlign: 'middle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&.with-children:not(.without-frame)': {
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.without-frame': {
        padding: 0
    }
});
const $2fb79e2d31fb82d4$export$a7db06668cad9adb = /*#__PURE__*/ (0, $jctmk.css)({
    padding: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $2fb79e2d31fb82d4$export$16dcf8c62f81d973 = /*#__PURE__*/ (0, $jctmk.css)({
    boxSizing: 'border-box',
    paddingTop: "var(--ds-space-100, 8px)",
    paddingBottom: "var(--ds-space-100, 8px)",
    background: "var(--ds-surface, #FFFFFF)",
    border: `1px solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'initial',
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-border': {
        border: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.hide-content': {
        display: 'none'
    }
});
const $2fb79e2d31fb82d4$export$2a82ddc22e8c7fbb = /*#__PURE__*/ (0, $jctmk.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
    display: 'flex',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-bodied-padding-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` // account for upcoming editor elements drag & drop feature
    }
});
const $2fb79e2d31fb82d4$export$2ab74686abf0084 = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        margin: `0 ${"var(--ds-space-negative-250, -20px)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-styles': {
        padding: "var(--ds-space-100, 8px)"
    }
});

});


parcelRegister("721eg", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8df44aeba87aa71$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jyPR0 = parcelRequire("jyPR0");

var $014x6 = parcelRequire("014x6");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $9oAqi = parcelRequire("9oAqi");

var $iYGtj = parcelRequire("iYGtj");

var $gW2ks = parcelRequire("gW2ks");

var $502oy = parcelRequire("502oy");

var $4fIEF = parcelRequire("4fIEF");
function $d8df44aeba87aa71$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8df44aeba87aa71$var$inlineWrapperStyles = {
    name: "m3p6m2",
    styles: "max-width:100%;tr &{max-width:inherit;}.rich-media-item{max-width:100%;}"
};
const $d8df44aeba87aa71$var$flowingInlineWrapperStyles = {
    name: "cxkc3s",
    styles: "&:has([data-inline-extension-layout=\"flow\"]){background:transparent;box-shadow:none;display:inline;margin:0;vertical-align:baseline;}&:has([data-inline-extension-layout=\"flow\"])::after, &:has([data-inline-extension-layout=\"flow\"])::before{display:none;}&:has([data-inline-extension-layout=\"flow\"]) > .extension-overlay{display:none;}"
};
const $d8df44aeba87aa71$var$hoverStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $d8df44aeba87aa71$var$MemoizedWidthContextProvider = ({ rendererContainerWidth: rendererContainerWidth, children: children })=>{
    const widthContextValue = (0, $fc4bM.useMemo)(()=>(0, $iYGtj.createWidthContext)(rendererContainerWidth), [
        rendererContainerWidth
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $iYGtj.WidthContext).Provider, {
        value: widthContextValue
    }, children);
};
const $d8df44aeba87aa71$var$LegacyWidthContextProvider = ({ rendererContainerWidth: rendererContainerWidth, children: children })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $iYGtj.WidthContext).Provider, {
        value: (0, $iYGtj.createWidthContext)(rendererContainerWidth)
    }, children);
};
const $d8df44aeba87aa71$var$InlineExtension = (props)=>{
    const { node: node, pluginInjectionApi: pluginInjectionApi, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, children: children, isNodeHovered: isNodeHovered, setIsNodeHovered: setIsNodeHovered, isLivePageViewMode: isLivePageViewMode, hideConfigureLabel: hideConfigureLabel } = props;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const shouldUseFlowingInlineWrapper = (0, $dRkX9.fg)('rovo_skill_tag_label_wrapping');
    const { width: width } = (0, $9oAqi.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        var _states$widthState;
        return {
            width: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width
        };
    });
    const hasChildren = !!children;
    const classNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('extension-container', 'inline', {
        'with-overlay': !showMacroInteractionDesignUpdates,
        'with-children': hasChildren,
        'with-danger-overlay': showMacroInteractionDesignUpdates
    });
    let rendererContainerWidth = 0;
    if ((0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    })) {
        if (width) {
            const padding = width > (0, $014x6.akEditorFullPageNarrowBreakout) ? (0, $014x6.akEditorGutterPaddingDynamic)() : (0, $014x6.akEditorGutterPaddingReduced);
            rendererContainerWidth = width - padding * 2;
        }
    } else rendererContainerWidth = width ? width - (0, $014x6.akEditorGutterPaddingDynamic)() * 2 : 0;
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const inlineExtensionInternal = /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, showMacroInteractionDesignUpdates && !isLivePageViewMode && /*#__PURE__*/ (0, $jctmk.jsx)((0, $gW2ks.default), {
        node: node,
        isNodeHovered: isNodeHovered,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        setIsNodeHovered: setIsNodeHovered,
        pluginInjectionApi: pluginInjectionApi,
        hideConfigureLabel: hideConfigureLabel
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        "data-testid": "inline-extension-wrapper",
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $4fIEF.wrapperStyle),
            $d8df44aeba87aa71$var$inlineWrapperStyles,
            showMacroInteractionDesignUpdates && !isLivePageViewMode && $d8df44aeba87aa71$var$hoverStyles,
            shouldUseFlowingInlineWrapper && $d8df44aeba87aa71$var$flowingInlineWrapperStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also accessible via keyboard selection.
        // No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $502oy.overlay),
        className: "extension-overlay"
    }), children ? children : /*#__PURE__*/ (0, $jctmk.jsx)((0, $gW2ks.default), {
        node: node,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates,
        pluginInjectionApi: pluginInjectionApi,
        hideConfigureLabel: hideConfigureLabel
    })));
    return (0, $aEmSo.expValEquals)('enghealth-53346_fix_redaction_marker_editor', 'isEnabled', true) ? /*#__PURE__*/ (0, $jctmk.jsx)($d8df44aeba87aa71$var$MemoizedWidthContextProvider, {
        rendererContainerWidth: rendererContainerWidth
    }, inlineExtensionInternal) : /*#__PURE__*/ (0, $jctmk.jsx)($d8df44aeba87aa71$var$LegacyWidthContextProvider, {
        rendererContainerWidth: rendererContainerWidth
    }, inlineExtensionInternal);
};
var $d8df44aeba87aa71$export$2e2bcd8739ae039 = $d8df44aeba87aa71$var$InlineExtension;

});
parcelRegister("4fIEF", function(module, exports) {
$parcel$export(module.exports, "wrapperStyle", () => $6e7290584c8f41e1$export$c4d4f06a25de97f);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $502oy = parcelRequire("502oy");
const $6e7290584c8f41e1$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $jctmk.css)((0, $502oy.wrapperDefault), {
    cursor: 'pointer',
    display: 'inline-flex',
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> img': {
        borderRadius: "var(--ds-radius-small, 3px)"
    },
    '&::after, &::before': {
        verticalAlign: 'text-top',
        display: 'inline-block',
        content: "''"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-children': {
        padding: 0,
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});

});


parcelRegister("6cEFf", function(module, exports) {
$parcel$export(module.exports, "default", () => $26c7c4d156a6764f$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $6Zi52 = parcelRequire("6Zi52");

var $jyPR0 = parcelRequire("jyPR0");

var $gpjDl = parcelRequire("gpjDl");

var $3dgbz = parcelRequire("3dgbz");

var $aEmSo = parcelRequire("aEmSo");

var $9oAqi = parcelRequire("9oAqi");

var $2ewu1 = parcelRequire("2ewu1");

var $jblYO = parcelRequire("jblYO");

var $9JwwP = parcelRequire("9JwwP");
var $aGOGh = parcelRequire("aGOGh");

var $gW2ks = parcelRequire("gW2ks");

var $iRCIO = parcelRequire("iRCIO");

var $lVHvZ = parcelRequire("lVHvZ");

var $iv8UL = parcelRequire("iv8UL");

var $he5xk = parcelRequire("he5xk");
function $26c7c4d156a6764f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $26c7c4d156a6764f$var$getFramesActiveFrameStyles = (activeChildIndex, showMacroInteractionDesignUpdates)=>{
    const activeFrameSelector = `& > .multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1})`;
    return /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [activeFrameSelector]: /*#__PURE__*/ (0, $jctmk.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $jblYO.sharedMultiBodiedExtensionStyles).extensionFrameContent, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        showMacroInteractionDesignUpdates && (0, $jblYO.removeMarginsAndBorder))
    });
};
// Renders a visual placeholder when the active frame contains a single empty paragraph.
const $26c7c4d156a6764f$var$getEmptyFramePlaceholderStyles = (activeChildIndex, placeholderText)=>{
    const activeFramePlaceholderSelector = `& > .multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true']:nth-of-type(${activeChildIndex + 1}) > p:only-child:has(> .ProseMirror-trailingBreak:only-child)::before`;
    return /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        [activeFramePlaceholderSelector]: {
            color: "var(--ds-text-subtlest, #6B6E76)",
            // JSON.stringify produces a quoted and escaped CSS string.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            content: placeholderText,
            pointerEvents: 'none',
            position: 'absolute'
        }
    });
};
const $26c7c4d156a6764f$var$imageStyles = {
    name: "yadgg9",
    styles: "max-height:24px;max-width:24px"
};
const $26c7c4d156a6764f$var$hoverStyles = /*#__PURE__*/ (0, $jctmk.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    }
});
const $26c7c4d156a6764f$var$hoverStylesOld = /*#__PURE__*/ (0, $jctmk.css)({
    '&:hover': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    }
});
const $26c7c4d156a6764f$var$MultiBodiedExtensionFrames = ({ activeChildIndex: activeChildIndex, articleRef: articleRef, emptyFramePlaceholderText: emptyFramePlaceholderText, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("article", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--frames",
        css: [
            /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ $26c7c4d156a6764f$var$getFramesActiveFrameStyles(activeChildIndex, showMacroInteractionDesignUpdates),
            $26c7c4d156a6764f$var$getEmptyFramePlaceholderStyles(activeChildIndex, emptyFramePlaceholderText)
        ],
        "data-testid": "multiBodiedExtension--frames",
        "data-multibodiedextension-frames": true,
        ref: articleRef
    });
};
const $26c7c4d156a6764f$var$isSelectionInsideNode = (selection, node, getPos)=>{
    const nodeStartPosition = getPos();
    if (typeof nodeStartPosition !== 'number' || !selection) return false;
    const nodeEndPosition = nodeStartPosition + node.nodeSize;
    /*
  	selection starts within MBE ||
  	selection ends within MBE ||
  	selection includes MBE
  */ return nodeStartPosition < selection.from && selection.from < nodeEndPosition || nodeStartPosition < selection.to && selection.to < nodeEndPosition || nodeStartPosition >= selection.from && selection.to >= nodeEndPosition;
};
const $26c7c4d156a6764f$var$useIsSelectionInsideNode = (editorView, node, getPos, enabled)=>{
    const nodeRef = (0, $fc4bM.useRef)(node);
    const [isSelectionInside, setIsSelectionInside] = (0, $fc4bM.useState)(()=>enabled && $26c7c4d156a6764f$var$isSelectionInsideNode(editorView.state.selection, node, getPos));
    nodeRef.current = node;
    (0, $fc4bM.useEffect)(()=>{
        if (!enabled) return;
        let animationFrameId;
        const updateSelectionInsideNode = ()=>{
            setIsSelectionInside($26c7c4d156a6764f$var$isSelectionInsideNode(editorView.state.selection, nodeRef.current, getPos));
        };
        const scheduleUpdateSelectionInsideNode = ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            animationFrameId = requestAnimationFrame(updateSelectionInsideNode);
        };
        const ownerDocument = editorView.dom.ownerDocument;
        const unbindSelectionChange = (0, $6Zi52.bind)(ownerDocument, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'selectionchange'
        });
        const unbindKeyUp = (0, $6Zi52.bind)(editorView.dom, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'keyup'
        });
        const unbindMouseUp = (0, $6Zi52.bind)(editorView.dom, {
            listener: scheduleUpdateSelectionInsideNode,
            type: 'mouseup'
        });
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            unbindSelectionChange();
            unbindKeyUp();
            unbindMouseUp();
        };
    }, [
        editorView,
        getPos,
        enabled
    ]);
    return enabled && isSelectionInside;
};
// Similar to the one in platform/packages/editor/editor-common/src/extensibility/Extension/Lozenge.tsx
const $26c7c4d156a6764f$var$getWrapperTitleContent = (imageData, title, showMacroInteractionDesignUpdates)=>{
    if (showMacroInteractionDesignUpdates) return null;
    if (imageData) {
        const { url: url, ...rest } = imageData;
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            className: "extension-title"
        }, /*#__PURE__*/ (0, $jctmk.jsx)("img", {
            css: $26c7c4d156a6764f$var$imageStyles,
            src: url,
            ...rest,
            alt: title
        }), title));
    }
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "extension-title",
        "data-testid": 'multiBodiedExtension-default-lozenge'
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3dgbz))), {
        label: title
    }), title);
};
const $26c7c4d156a6764f$var$MultiBodiedExtensionWithWidth = ({ node: node, handleContentDOMRef: handleContentDOMRef, getPos: getPos, tryExtensionHandler: tryExtensionHandler, editorView: editorView, eventDispatcher: eventDispatcher, widthState: widthState, editorAppearance: editorAppearance, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, isNodeSelected: isNodeSelected, isNodeHovered: isNodeHovered, isNodeNested: isNodeNested, setIsNodeHovered: setIsNodeHovered, pluginInjectionApi: pluginInjectionApi, isLivePageViewMode: isLivePageViewMode, allowBodiedOverride: allowBodiedOverride = false, hideConfigureLabel: hideConfigureLabel })=>{
    var _node$marks;
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    const { parameters: parameters, extensionKey: extensionKey } = node.attrs;
    const title = parameters && parameters.extensionTitle || parameters && parameters.macroMetadata && parameters.macroMetadata.title || extensionKey || node.type.name;
    const imageData = (0, $aGOGh.getExtensionLozengeData)({
        node: node,
        type: 'image'
    });
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const [activeChildIndex, setActiveChildIndex] = (0, $fc4bM.useState)(0);
    // Adding to avoid aliasing `this` for the callbacks
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((index)=>{
        if (typeof index !== 'number') {
            setActiveChildIndex(0);
            throw new Error('Index is not valid');
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const articleRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((node)=>{
        return handleContentDOMRef(node);
    }, [
        handleContentDOMRef
    ]);
    const emptyFramePlaceholderText = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>JSON.stringify(formatMessage((0, $2ewu1.placeholderTextMessages).multiBodiedExtensionEmptyFramePlaceholderText)), [
        formatMessage
    ]);
    const childrenContainer = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        return /*#__PURE__*/ (0, $jctmk.jsx)($26c7c4d156a6764f$var$MultiBodiedExtensionFrames, {
            activeChildIndex: activeChildIndex,
            articleRef: articleRef,
            emptyFramePlaceholderText: emptyFramePlaceholderText,
            showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates
        });
    }, [
        activeChildIndex,
        articleRef,
        emptyFramePlaceholderText,
        showMacroInteractionDesignUpdates
    ]);
    const actions = (0, $iv8UL.useMultiBodiedExtensionActions)({
        updateActiveChild: updateActiveChild,
        editorView: editorView,
        getPos: getPos,
        node: node,
        eventDispatcher: eventDispatcher,
        allowBodiedOverride: allowBodiedOverride,
        childrenContainer: childrenContainer
    });
    const extensionHandlerResult = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        return tryExtensionHandler(actions);
    }, [
        tryExtensionHandler,
        actions
    ]);
    const layout = node.attrs.layout;
    const shouldBreakout = (0, $lVHvZ.shouldExtensionBreakout)({
        layout: layout,
        editorAppearance: editorAppearance,
        isTopLevelNode: true,
        hasBreakoutMark: (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.some((mark)=>mark.type.name === 'breakout')
    });
    let mbeWrapperStyles = {};
    if (shouldBreakout) {
        const { ...breakoutStyles } = (0, $9JwwP.calculateBreakoutStyles)({
            mode: node.attrs.layout,
            widthStateLineLength: widthState === null || widthState === void 0 ? void 0 : widthState.lineLength,
            widthStateWidth: widthState === null || widthState === void 0 ? void 0 : widthState.width
        });
        mbeWrapperStyles = breakoutStyles;
    }
    const shouldUseUpdatedChrome = (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true);
    const isSelectionInsideMultiBodiedExtension = $26c7c4d156a6764f$var$useIsSelectionInsideNode(editorView, node, getPos, shouldUseUpdatedChrome && !isLivePageViewMode);
    const isMultiBodiedExtensionActive = isNodeSelected || isSelectionInsideMultiBodiedExtension;
    const shouldShowChromeOnInteraction = isNodeHovered || isMultiBodiedExtensionActive;
    const shouldShowMultiBodiedExtensionChrome = shouldUseUpdatedChrome ? !isLivePageViewMode && shouldShowChromeOnInteraction : true;
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('multiBodiedExtension--wrapper', 'extension-container', 'block', {
        'with-border': showMacroInteractionDesignUpdates && shouldShowMultiBodiedExtensionChrome,
        'with-selected-border': showMacroInteractionDesignUpdates && shouldUseUpdatedChrome && !isLivePageViewMode && isNodeSelected,
        'with-danger-overlay': showMacroInteractionDesignUpdates,
        'with-padding-background-styles': showMacroInteractionDesignUpdates,
        'with-margin-styles': showMacroInteractionDesignUpdates && !isNodeNested
    });
    const containerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('multiBodiedExtension--container', {
        'remove-padding': showMacroInteractionDesignUpdates
    });
    const bodyContainerClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('multiBodiedExtension--body-container');
    const navigationClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('multiBodiedExtension--navigation', {
        'remove-margins': showMacroInteractionDesignUpdates,
        'remove-border': showMacroInteractionDesignUpdates
    });
    const overlayClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))('multiBodiedExtension--overlay', {
        'with-margin': showMacroInteractionDesignUpdates
    });
    const handleMouseEvent = (didHover)=>{
        if (setIsNodeHovered) setIsNodeHovered(didHover);
    };
    const shouldRenderExtensionLozenge = showMacroInteractionDesignUpdates && !isLivePageViewMode && !shouldUseUpdatedChrome;
    const shouldRenderFloatingLabel = showMacroInteractionDesignUpdates && !isLivePageViewMode && shouldUseUpdatedChrome && shouldShowChromeOnInteraction;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, shouldRenderExtensionLozenge && /*#__PURE__*/ (0, $jctmk.jsx)((0, $gW2ks.default), {
        node: node,
        showMacroInteractionDesignUpdates: true,
        customContainerStyles: mbeWrapperStyles,
        isNodeHovered: isNodeHovered,
        isNodeNested: isNodeNested,
        setIsNodeHovered: setIsNodeHovered,
        isBodiedMacro: true,
        pluginInjectionApi: pluginInjectionApi,
        hideConfigureLabel: hideConfigureLabel
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassNames,
        css: [
            /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ shouldUseUpdatedChrome ? (0, $he5xk.mbeExtensionWrapperCSSStyles) : (0, $he5xk.mbeExtensionWrapperCSSStylesOld),
            /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage */ showMacroInteractionDesignUpdates && !isLivePageViewMode && (shouldUseUpdatedChrome ? $26c7c4d156a6764f$var$hoverStyles : $26c7c4d156a6764f$var$hoverStylesOld)
        ],
        "data-testid": "multiBodiedExtension--wrapper-editor",
        "data-layout": node.attrs.layout,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mbeWrapperStyles,
        onMouseEnter: ()=>handleMouseEvent(true),
        // @atlassian/a11y/mouse-events-have-key-events: hover border is also applied via .ak-editor-selected-node
        // CSS on keyboard selection. No-ops here satisfy the rule without duplicating state updates.
        onFocus: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onMouseLeave: ()=>handleMouseEvent(false),
        onBlur: (0, $aEmSo.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, shouldRenderFloatingLabel && /*#__PURE__*/ (0, $jctmk.jsx)((0, $iRCIO.ExtensionFloatingLabel), {
        title: title,
        isSelected: isNodeSelected,
        testId: "multiBodiedExtension-floating-label"
    }), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: shouldUseUpdatedChrome ? (0, $he5xk.overlayStyles) : (0, $he5xk.overlayStylesOld),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: overlayClassNames,
        "data-testid": "multiBodiedExtension--overlay"
    }), $26c7c4d156a6764f$var$getWrapperTitleContent(imageData, title, showMacroInteractionDesignUpdates), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: containerClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $jblYO.sharedMultiBodiedExtensionStyles).mbeExtensionContainer,
        "data-testid": "multiBodiedExtension--container",
        "data-multiBodiedExtension-container": true,
        "data-active-child-index": activeChildIndex
    }, allowBodiedOverride ? /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: bodyContainerClassNames,
        "data-testid": "multiBodiedExtension--body-container"
    }, extensionHandlerResult) : /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)("nav", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: navigationClassNames,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $jblYO.sharedMultiBodiedExtensionStyles).mbeNavigation,
        "data-testid": "multiBodiedExtension-navigation"
    }, extensionHandlerResult), childrenContainer))));
};
const $26c7c4d156a6764f$var$MultiBodiedExtension = (props)=>{
    const { pluginInjectionApi: pluginInjectionApi } = props;
    const { width: width, lineLength: lineLength } = (0, $9oAqi.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width'
    ], (states)=>{
        var _states$widthState, _states$widthState2;
        return {
            width: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width,
            lineLength: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.lineLength
        };
    });
    // Ignored via go/ees005
    return /*#__PURE__*/ (0, $jctmk.jsx)($26c7c4d156a6764f$var$MultiBodiedExtensionWithWidth, {
        widthState: width === undefined ? undefined : {
            width: width,
            lineLength: lineLength
        },
        ...props
    });
};
var $26c7c4d156a6764f$export$2e2bcd8739ae039 = $26c7c4d156a6764f$var$MultiBodiedExtension;

});
parcelRegister("jblYO", function(module, exports) {
$parcel$export(module.exports, "removeMarginsAndBorder", () => $3a43a7fb75a84182$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $3a43a7fb75a84182$export$9c7196ca47f67390);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $aEmSo = parcelRequire("aEmSo");
function $3a43a7fb75a84182$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $3a43a7fb75a84182$var$mbeExtensionContainerOld = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
// Wraps the navigation bar and extensionFrames when Native Tabs can insert block-control
// widget decorations before frame content.
const $3a43a7fb75a84182$var$mbeExtensionContainerNew = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(.ProseMirror-widget):first-of-type, [data-extension-frame='true'] > .ProseMirror-widget + :not(.ProseMirror-widget):first-of-type": {
            marginTop: 0
        }
    }
});
const $3a43a7fb75a84182$var$mbeNavigation = {
    name: "1a47qx2",
    styles: "border-top-left-radius:var(--ds-radius-small, 3px);border-top-right-radius:var(--ds-radius-small, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, #FFFFFF);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $3a43a7fb75a84182$var$extensionFrameContent = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $3a43a7fb75a84182$var$extensionFrameContentOld = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    display: 'block !important',
    minHeight: '100px',
    background: 'transparent',
    borderBottomLeftRadius: "var(--ds-radius-small, 3px)",
    borderBottomRightRadius: "var(--ds-radius-small, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $3a43a7fb75a84182$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $3a43a7fb75a84182$export$9c7196ca47f67390 = {
    mbeNavigation: $3a43a7fb75a84182$var$mbeNavigation,
    get mbeExtensionContainer () {
        return (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? $3a43a7fb75a84182$var$mbeExtensionContainerNew : $3a43a7fb75a84182$var$mbeExtensionContainerOld;
    },
    get extensionFrameContent () {
        if (!(0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return $3a43a7fb75a84182$var$extensionFrameContentOld;
        return $3a43a7fb75a84182$var$extensionFrameContent;
    }
};

});

parcelRegister("iRCIO", function(module, exports) {
$parcel$export(module.exports, "ExtensionFloatingLabel", () => $02dfe75c76bd3f0d$export$ed2d946cb95ebda6);
/* ExtensionFloatingLabel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dRkX9 = parcelRequire("dRkX9");

var $k8Adr = parcelRequire("k8Adr");
const $02dfe75c76bd3f0d$var$floatingLabelStyles = {
    base: "_2rkofajl _zulp1b66 _4cvr1h6o _bfhkvuon _16qsglyw _1e0c1txw _1bah1h6o _p12f11ux _tzy4kb7n _19bvu2gc _u5f3u2gc _kqswstnw _1xi2utpp _154i14id _3um0ewfl _1pbycs5v",
    selected: "_bfhk19i6 _n3td1b66 _ca0q1b66 _154id439",
    selectedOld: "_bfhk15s3 _n3td1b66 _ca0q1b66 _154id439"
};
const $02dfe75c76bd3f0d$export$ed2d946cb95ebda6 = ({ isSelected: isSelected, testId: testId, title: title })=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        contentEditable: false,
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            $02dfe75c76bd3f0d$var$floatingLabelStyles.base,
            isSelected && (0, $dRkX9.fg)('platform-dst-tokens-finesse') && $02dfe75c76bd3f0d$var$floatingLabelStyles.selected,
            isSelected && !(0, $dRkX9.fg)('platform-dst-tokens-finesse') && $02dfe75c76bd3f0d$var$floatingLabelStyles.selectedOld
        ]),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            maxLines: 1,
            size: "small",
            color: isSelected ? 'color.text.selected' : 'color.text.subtle',
            children: title
        })
    });

});

parcelRegister("iv8UL", function(module, exports) {
$parcel$export(module.exports, "useMultiBodiedExtensionActions", () => $acd628d98dfabc0a$export$3c7139d93ecb4f1f);

var $fc4bM = parcelRequire("fc4bM");

var $801jp = parcelRequire("801jp");

var $aEmSo = parcelRequire("aEmSo");

var $3LeME = parcelRequire("3LeME");

var $55sGm = parcelRequire("55sGm");
const $acd628d98dfabc0a$export$3c7139d93ecb4f1f = ({ updateActiveChild: updateActiveChild, editorView: editorView, getPos: getPos, node: node, eventDispatcher: eventDispatcher, allowBodiedOverride: allowBodiedOverride, childrenContainer: childrenContainer })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        return {
            changeActive (index, options) {
                var _possiblyMbeNode$type;
                const { state: state, dispatch: dispatch } = editorView;
                const updateActiveChildResult = updateActiveChild(index);
                if (eventDispatcher) (0, $55sGm.sendMBEAnalyticsEvent)((0, $3LeME.ACTION).CHANGE_ACTIVE, node, eventDispatcher);
                const selection = (options === null || options === void 0 ? void 0 : options.selection) ?? 'none';
                const pos = getPos();
                if (typeof pos !== 'number') return updateActiveChildResult;
                const possiblyMbeNode = state.doc.nodeAt(pos);
                if (possiblyMbeNode && (possiblyMbeNode === null || possiblyMbeNode === void 0 || (_possiblyMbeNode$type = possiblyMbeNode.type) === null || _possiblyMbeNode$type === void 0 ? void 0 : _possiblyMbeNode$type.name) === 'multiBodiedExtension' && possiblyMbeNode !== null && possiblyMbeNode !== void 0 && possiblyMbeNode.content) {
                    var _possiblyMbeNode$cont;
                    if (index < 0 || index >= (possiblyMbeNode === null || possiblyMbeNode === void 0 || (_possiblyMbeNode$cont = possiblyMbeNode.content) === null || _possiblyMbeNode$cont === void 0 ? void 0 : _possiblyMbeNode$cont.childCount)) {
                        var _possiblyMbeNode$cont2;
                        throw new Error(`Index out of bounds: valid range is 0-${(possiblyMbeNode === null || possiblyMbeNode === void 0 || (_possiblyMbeNode$cont2 = possiblyMbeNode.content) === null || _possiblyMbeNode$cont2 === void 0 ? void 0 : _possiblyMbeNode$cont2.childCount) - 1} inclusive`);
                    }
                    let desiredPos = pos;
                    for(let i = 0; i < index && i < (possiblyMbeNode === null || possiblyMbeNode === void 0 || (_possiblyMbeNode$cont3 = possiblyMbeNode.content) === null || _possiblyMbeNode$cont3 === void 0 ? void 0 : _possiblyMbeNode$cont3.childCount); i++){
                        var _possiblyMbeNode$cont3, _possiblyMbeNode$cont4;
                        desiredPos += (possiblyMbeNode === null || possiblyMbeNode === void 0 || (_possiblyMbeNode$cont4 = possiblyMbeNode.content) === null || _possiblyMbeNode$cont4 === void 0 || (_possiblyMbeNode$cont4 = _possiblyMbeNode$cont4.child(i)) === null || _possiblyMbeNode$cont4 === void 0 ? void 0 : _possiblyMbeNode$cont4.nodeSize) || 0;
                    }
                    const targetFrame = possiblyMbeNode.content.child(index);
                    if (selection === 'end') {
                        dispatch(state.tr.setSelection((0, $801jp.TextSelection).near(state.doc.resolve(desiredPos + targetFrame.nodeSize), -1)));
                        editorView.focus();
                    } else {
                        // for 'start' and 'none' selection place a
                        // collapsed cursor at the start of the target frame so the ProseMirror
                        // selection always points into the active tab. This prevents stale
                        // selections from persisting across tab switches (which causes paste to
                        // land in the wrong tab).
                        // 'none' intentionally skips editorView.focus() so DOM focus can
                        // remain on the tab button for keyboard navigation.
                        dispatch(state.tr.setSelection((0, $801jp.TextSelection).near(state.doc.resolve(desiredPos + 1))));
                        if (selection === 'start') editorView.focus();
                    }
                }
                return updateActiveChildResult;
            },
            addChild () {
                const { state: state, dispatch: dispatch } = editorView;
                const p = state.schema.nodes.paragraph.createAndFill({});
                if (!p) throw new Error('Could not create paragraph');
                const frame = state.schema.nodes.extensionFrame.createAndFill({}, [
                    p
                ]);
                const pos = getPos();
                if (typeof pos !== 'number' || !frame) throw new Error('Could not create frame or position not valid');
                const insertAt = Math.min((pos || 1) + node.content.size, state.doc.content.size);
                const tr = state.tr.insert(insertAt, frame);
                tr.setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve(insertAt + 1)));
                dispatch(tr);
                if (eventDispatcher) (0, $55sGm.sendMBEAnalyticsEvent)((0, $3LeME.ACTION).ADD_CHILD, node, eventDispatcher);
                return true;
            },
            getChildrenCount () {
                return node.content.childCount;
            },
            removeChild (index) {
                const pos = getPos();
                // Ignored via go/ees007
                // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                // TODO: Add child index validation here, don't trust this data
                if (typeof pos !== 'number' || typeof index !== 'number') throw new Error('Position or index not valid');
                const { state: state, dispatch: dispatch } = editorView;
                if (node.content.childCount === 1) {
                    const tr = state.tr;
                    tr.deleteRange(pos, pos + node.content.size);
                    dispatch(tr);
                    return true;
                }
                const $pos = state.doc.resolve(pos);
                const $startNodePos = state.doc.resolve($pos.start($pos.depth + 1));
                const startFramePosition = $startNodePos.posAtIndex(index);
                const maybeFrameNode = state.doc.nodeAt(startFramePosition);
                if (!maybeFrameNode) throw new Error('Could not find frame node');
                const endFramePosition = maybeFrameNode.content.size + startFramePosition;
                const tr = state.tr;
                tr.deleteRange(startFramePosition, endFramePosition);
                dispatch(tr);
                if (eventDispatcher) (0, $55sGm.sendMBEAnalyticsEvent)((0, $3LeME.ACTION).REMOVE_CHILD, node, eventDispatcher);
                return true;
            },
            reorderChildren (fromIndex, toIndex) {
                const pos = getPos();
                if (typeof pos !== 'number' || typeof fromIndex !== 'number' || typeof toIndex !== 'number') throw new Error('Position or index not valid');
                if (fromIndex === toIndex) return true;
                const { state: state, dispatch: dispatch } = editorView;
                // Use current node from state (not stale closure)
                const currentNode = state.doc.nodeAt(pos);
                if (!currentNode) throw new Error('Could not find extension node');
                const $pos = state.doc.resolve(pos);
                const $startNodePos = state.doc.resolve($pos.start($pos.depth + 1));
                // Collect all current frame nodes
                const frames = [];
                currentNode.content.forEach((child)=>{
                    frames.push(child);
                });
                if (fromIndex >= frames.length || toIndex >= frames.length) throw new Error('Index out of bounds');
                // Reorder the frames array in memory
                const [removed] = frames.splice(fromIndex, 1);
                frames.splice(toIndex, 0, removed);
                // Atomically replace the entire MBE content with reordered frames
                const tr = state.tr;
                const containerStart = $startNodePos.pos;
                const containerEnd = containerStart + currentNode.content.size;
                tr.replaceWith(containerStart, containerEnd, frames);
                dispatch(tr);
                return true;
            },
            updateParameters (parameters, analyticsChangedParam) {
                const { state: state, dispatch: dispatch } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') throw new Error('Position not valid');
                // We are retaining node.attrs to keep the node type and extension key
                // and only updating the parameters coming in from the user
                // parameters will contain only macroParams information
                const updatedParameters = {
                    ...node.attrs,
                    parameters: {
                        ...node.attrs.parameters,
                        ...(0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? {
                            ...parameters
                        } : {
                            macroParams: parameters
                        }
                    }
                };
                const tr = state.tr.setNodeMarkup(pos, null, updatedParameters);
                dispatch(tr);
                if (eventDispatcher) (0, $55sGm.sendMBEAnalyticsEvent)((0, $3LeME.ACTION).UPDATE_PARAMETERS, node, eventDispatcher, analyticsChangedParam && (0, $aEmSo.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true) ? {
                    changedParams: analyticsChangedParam
                } : undefined);
                return true;
            },
            getChildren () {
                var _state$doc$nodeAt;
                const { state: state } = editorView;
                const pos = getPos();
                if (typeof pos !== 'number') return [];
                const children = (_state$doc$nodeAt = state.doc.nodeAt(pos)) === null || _state$doc$nodeAt === void 0 ? void 0 : _state$doc$nodeAt.content;
                if (eventDispatcher) (0, $55sGm.sendMBEAnalyticsEvent)((0, $3LeME.ACTION).GET_CHILDREN, node, eventDispatcher);
                return children ? children.toJSON() : [];
            },
            getChildrenContainer () {
                if (!allowBodiedOverride) throw new Error('Could not provide children container');
                if (eventDispatcher) (0, $55sGm.sendMBEAnalyticsEvent)((0, $3LeME.ACTION).GET_CHILDREN_CONTAINER, node, eventDispatcher);
                return childrenContainer;
            }
        };
    }, [
        node,
        editorView,
        getPos,
        updateActiveChild,
        eventDispatcher,
        allowBodiedOverride,
        childrenContainer
    ]);
    return actions;
};

});
parcelRegister("55sGm", function(module, exports) {
$parcel$export(module.exports, "sendMBEAnalyticsEvent", () => $b6fc491670c7324e$export$c39676f5ca8bcb0e);

var $3LeME = parcelRequire("3LeME");

var $jeOdp = parcelRequire("jeOdp");

var $ik3vI = parcelRequire("ik3vI");
const $b6fc491670c7324e$export$c39676f5ca8bcb0e = (action, node, eventDispatcher, attributes)=>{
    const analyticsDispatch = (0, $jeOdp.createDispatch)(eventDispatcher);
    analyticsDispatch((0, $ik3vI.analyticsEventKey), {
        payload: {
            action: action,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).MULTI_BODIED_EXTENSION,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey,
                localId: node.attrs.localId,
                currentFramesCount: node.content.childCount,
                ...attributes
            }
        }
    });
};

});


parcelRegister("he5xk", function(module, exports) {
$parcel$export(module.exports, "mbeExtensionWrapperCSSStyles", () => $64ff76c820dc4c47$export$4226a1fc882c4ef9);
$parcel$export(module.exports, "mbeExtensionWrapperCSSStylesOld", () => $64ff76c820dc4c47$export$6bb53a1c4e28a730);
$parcel$export(module.exports, "overlayStyles", () => $64ff76c820dc4c47$export$9b0df2896b2eff02);
$parcel$export(module.exports, "overlayStylesOld", () => $64ff76c820dc4c47$export$85f4d1340338a338);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $502oy = parcelRequire("502oy");
function $64ff76c820dc4c47$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $64ff76c820dc4c47$export$4226a1fc882c4ef9 = /*#__PURE__*/ (0, $jctmk.css)((0, $502oy.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: "var(--ds-space-300, 24px)",
        marginLeft: "var(--ds-space-negative-250, -20px)",
        marginRight: "var(--ds-space-negative-250, -20px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-selected-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-focused, #4688EC)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $64ff76c820dc4c47$export$6bb53a1c4e28a730 = /*#__PURE__*/ (0, $jctmk.css)((0, $502oy.wrapperDefault), {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-margin-styles': {
        marginTop: 0,
        marginLeft: "var(--ds-space-negative-150, -12px)",
        marginRight: "var(--ds-space-negative-150, -12px)"
    },
    cursor: 'pointer',
    marginTop: "var(--ds-space-250, 20px)",
    marginBottom: "var(--ds-space-200, 16px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extension-title': {
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        lineHeight: '16px !important',
        marginBottom: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-050, 4px)"} !important`,
        marginRight: "var(--ds-space-100, 8px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingTop: `${"var(--ds-space-100, 8px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-hover-border': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.with-padding-background-styles': {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}`,
        background: 'transparent'
    }
});
const $64ff76c820dc4c47$export$9b0df2896b2eff02 = {
    name: "1ir4r0n",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin-top:var(--ds-space-negative-100, -8px);margin-left:var(--ds-space-negative-250, -20px);}"
};
const $64ff76c820dc4c47$export$85f4d1340338a338 = {
    name: "1jgeuox",
    styles: "border-radius:var(--ds-radius-small, 3px);position:absolute;width:100%;height:100%;opacity:0;pointer-events:none;transition:opacity 0.3s;z-index:1;&.with-margin{margin:var(--ds-space-negative-100, -8px);}"
};

});




parcelRegister("8NZLW", function(module, exports) {
$parcel$export(module.exports, "ExtensionNodeWrapper", () => $25d1cc9836b17329$export$f97fc055ac075140);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jyPR0 = parcelRequire("jyPR0");

var $jWgCZ = parcelRequire("jWgCZ");

var $3sWv4 = parcelRequire("3sWv4");

var $b4LIt = parcelRequire("b4LIt");
function $25d1cc9836b17329$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $25d1cc9836b17329$var$styles = {
    name: "4s3kp2",
    styles: "&.inline-extension{display:inline-block;}&.relative{position:relative;}"
};
// Mirrored by the reveal span in `GeneratedContentReveal`; keep the two in step.
const $25d1cc9836b17329$var$hoverStyles = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-container, :has(.extension-edit-toggle-container:hover) .extension-container': {
        boxShadow: `0 0 0 1px ${"var(--ds-border-input, #8C8F97)"}`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-container:hover) .extension-label, :has(.extension-edit-toggle-container:hover) .extension-label, .extension-label:hover': {
        opacity: 1,
        backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
        boxShadow: 'none',
        cursor: 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.always-hide-label': {
            opacity: 0,
            cursor: 'auto'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '&.with-bodied-macro-live-page-styles': {
            backgroundColor: "var(--ds-background-input, #FFFFFF)",
            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-icon, :has(.extension-container:hover) .extension-icon, :has(.extension-edit-toggle-container:hover) .extension-icon': {
        display: 'inline'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':has(.extension-label:hover) .extension-edit-toggle-container, :has(.extension-container:hover) .extension-edit-toggle-container, .extension-edit-toggle-container:hover': {
        opacity: 1
    }
});
const $25d1cc9836b17329$export$f97fc055ac075140 = ({ children: children, nodeType: nodeType, macroInteractionDesignFeatureFlags: macroInteractionDesignFeatureFlags, generatedContentMotion: generatedContentMotion = false, contentReady: contentReady = false, intl: intl })=>{
    const { showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates } = macroInteractionDesignFeatureFlags || {};
    // Fixed for the node view's lifetime: switching would remount the subtree and reload the embed.
    if (generatedContentMotion) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $b4LIt.GeneratedContentReveal), {
        contentReady: contentReady,
        intl: intl,
        showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates
    }, children);
    const wrapperClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))({
        'inline-extension': nodeType === 'inlineExtension' && showMacroInteractionDesignUpdates,
        relative: showMacroInteractionDesignUpdates
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $3sWv4.ExtensionSSRReactContextsProvider), {
        intl: intl
    }, /*#__PURE__*/ (0, $jctmk.jsx)("span", {
        "data-testid": "extension-node-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: wrapperClassNames,
        css: [
            $25d1cc9836b17329$var$styles,
            $25d1cc9836b17329$var$hoverStyles
        ]
    }, children, nodeType === 'inlineExtension' && (0, $jWgCZ.ZERO_WIDTH_SPACE)));
};

});
parcelRegister("3sWv4", function(module, exports) {
$parcel$export(module.exports, "ExtensionSSRReactContextsProvider", () => $d493f138d91ef86b$export$36cc1c5797436ac4);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $eVKpX = parcelRequire("eVKpX");
function $d493f138d91ef86b$export$36cc1c5797436ac4({ children: children, intl: intl }) {
    if (!(0, $eVKpX.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fcCIH.Provider), {
        value: intl,
        children: children
    });
}

});

parcelRegister("b4LIt", function(module, exports) {
$parcel$export(module.exports, "GeneratedContentReveal", () => $b6f32f741a499c35$export$98147b50e053fbe9);
/* GeneratedContentReveal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $3sWv4 = parcelRequire("3sWv4");
/*
 * Animates a native embed into the document once it has loaded.
 *
 * 1. `collapsed` — clipped to zero height and `inert`. The embed loads behind it, full size but
 *    unseen, with its own loading overlay hidden.
 * 2. The extension reports its content ready through `contentReady`.
 * 3. `revealing` — the node animates open to its content height (150ms).
 * 4. The embed fades in (150ms), delayed so it follows the opening instead of overlapping it.
 * 5. `open` — on `animationend`, when the content first becomes visible, `inert` is dropped.
 *
 * Failure paths: never settles → `READY_TIMEOUT_MS` opens it and the embed's overlay reappears;
 * fails with no frame → still settles and opens; no `animationend` → `REVEAL_TIMEOUT_MS`. Reduced
 * motion runs the same steps with zero-length animations, so `animationend` still fires.
 *
 * Renders the wrapper span itself, in place of the default one in `ExtensionNodeWrapper`, so the
 * reveal styles sit on the element editor-core reaches through `> span >` chains from the node view
 * root. It therefore carries the default span's `relative` class and hover chrome as well.
 */ /** Long, because a MAUI app has to boot and render first. Reaching it means the signal is broken. */ const $b6f32f741a499c35$var$READY_TIMEOUT_MS = 30000;
/** For when no `animationend` arrives. Must exceed the reveal. */ const $b6f32f741a499c35$var$REVEAL_TIMEOUT_MS = 1000;
const $b6f32f741a499c35$var$relativeStyles = null;
// Mirrors the default span's hover chrome in `ExtensionNodeWrapper`; keep the two in step.
const $b6f32f741a499c35$var$hoverStyles = null;
const $b6f32f741a499c35$var$openHeight = null;
// `display: block` because `overflow` and `height` do not apply to an inline span.
const $b6f32f741a499c35$var$clippedStyles = null;
/**
 * Shut, and with the embed's own loading overlay hidden, so only one loading state shows. Only while
 * closed: once open the embed shows its own progress again, which a node opened by the fail-safe
 * timeout needs. Hiding the overlay here keeps `data-native-embed-loading` set, which is the signal
 * the reveal waits on.
 */ const $b6f32f741a499c35$var$collapsedStyles = null;
const $b6f32f741a499c35$var$revealingStyles = null;
// Two selectors because MAUI renders a bare iframe and others nest theirs in the card wrapper; the
// second excludes that nested case so the same content is not faded twice.
const $b6f32f741a499c35$var$embedContentEnteringStyles = null;
const $b6f32f741a499c35$export$98147b50e053fbe9 = ({ children: children, contentReady: contentReady, intl: intl, showMacroInteractionDesignUpdates: showMacroInteractionDesignUpdates })=>{
    // Held in state so the effect below runs once the span exists.
    const [wrapperElement, setWrapperElement] = (0, $fc4bM.useState)(null);
    const [readyTimedOut, setReadyTimedOut] = (0, $fc4bM.useState)(false);
    const [opened, setOpened] = (0, $fc4bM.useState)(false);
    // Derived, so the two ways a node opens need no ordering between them.
    const state = opened ? 'open' : contentReady || readyTimedOut ? 'revealing' : 'collapsed';
    // One timer, set on mount, so the deadline never moves.
    (0, $fc4bM.useEffect)(()=>{
        const timer = setTimeout(()=>setReadyTimedOut(true), $b6f32f741a499c35$var$READY_TIMEOUT_MS);
        return ()=>clearTimeout(timer);
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        if (state !== 'revealing') return;
        const timer = setTimeout(()=>setOpened(true), $b6f32f741a499c35$var$REVEAL_TIMEOUT_MS);
        return ()=>clearTimeout(timer);
    }, [
        state
    ]);
    // Clipped content, and content waiting out the fade's delay, are invisible but still focusable.
    // Set as an attribute because `inert` is absent from the React 18 JSX types.
    (0, $fc4bM.useEffect)(()=>{
        wrapperElement === null || wrapperElement === void 0 || wrapperElement.toggleAttribute('inert', state !== 'open');
    }, [
        state,
        wrapperElement
    ]);
    const onAnimationEnd = (0, $fc4bM.useCallback)((event)=>{
        // The extension's own content animates too, and those events bubble.
        if (event.target === event.currentTarget) setOpened(true);
    }, []);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3sWv4.ExtensionSSRReactContextsProvider), {
        intl: intl,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            "data-testid": "extension-node-wrapper",
            "data-extension-reveal": state,
            ref: setWrapperElement,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- the block controls and the SSR cleanup find the wrapper by `span.relative`
            className: (0, $2R2iS.default)([
                "_1tr2ynbm _xajsynbm _1tmrkb7n _bcikkb7n _2z44kb7n _dmn9ysee _1ghxysee _okd3ysee _1er3glyw _d1oeglyw _15k3glyw _1ql7tlke _1nuetlke _decvtlke _1fdfidpf _1pfgidpf _y7o7idpf _mi5m1wug _1si41wug _17sh1wug _x3ro1j9a _1i8c1j9a _1a2e1j9a _26lx1tsb _ks721tsb _jl0d1tsb _1qac1nu9 _54r11nu9 _1vs61nu9 _10pdkb7n _1kr5kb7n _10t9kb7n",
                showMacroInteractionDesignUpdates && "_kqswh2mm",
                state !== 'open' && "_1reo15vq _18m915vq _1e0c1ule",
                state === 'collapsed' && "_4t3iidpf _114yglyw",
                state === 'revealing' && "",
                state === 'revealing' && "_tw1z1t97 _j7hq180b _5sag1ign _1pglindk _2hwzru3m",
                state !== 'collapsed' && "_10i01bym _9sz11bym _147a1ign _lwlp1ign _lbjpindk _17w9indk _1p7l1ign _1jbo1ign _pjh31hrf _gp9p1hrf _dxfxru3m _log5ru3m _1pz3ru3m _9hrrru3m",
                showMacroInteractionDesignUpdates ? 'relative' : undefined
            ]),
            onAnimationEnd: onAnimationEnd,
            children: children
        })
    });
};

});


parcelRegister("3Pyg2", function(module, exports) {
$parcel$export(module.exports, "preserveRemixNodeView", () => $e19e2a5b7aebb330$export$f1e589cf4bd8f46);

var $bcN2K = parcelRequire("bcN2K");

var $ltxzX = parcelRequire("ltxzX");

var $dGkUS = parcelRequire("dGkUS");
const $e19e2a5b7aebb330$var$editors = new WeakMap();
/** Only block Remix embeds with a stable identity can participate in the handoff. */ const $e19e2a5b7aebb330$var$isRemixNodeForPreservation = (node)=>node.type.name === 'extension' && node.attrs.extensionKey === (0, $ltxzX.NATIVE_EMBED_MAUI_EXTENSION_KEY) && typeof node.attrs.localId === 'string' && node.attrs.localId.length > 0;
const $e19e2a5b7aebb330$var$sameChart = (left, right)=>left.mark(left.marks.filter((mark)=>mark.type.name !== 'annotation')).eq(right.mark(right.marks.filter((mark)=>mark.type.name !== 'annotation')));
function $e19e2a5b7aebb330$export$f1e589cf4bd8f46({ node: node, view: view, getPos: getPos, renderProps: renderProps, rendererKind: rendererKind, createExtensionNode: createExtensionNode }) {
    if (!$e19e2a5b7aebb330$var$isRemixNodeForPreservation(node)) return createExtensionNode(node).init();
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_preserve_smart_card_embeds')) return (0, $dGkUS.preserveNodeView)({
        node: node,
        view: view,
        getPos: getPos,
        renderProps: renderProps,
        rendererKind: rendererKind,
        createNodeView: createExtensionNode,
        isSameNode: $e19e2a5b7aebb330$var$sameChart,
        canUpdateNode: (previous, next)=>previous.type === next.type && previous.attrs.localId === next.attrs.localId && previous.attrs.extensionKey === next.attrs.extensionKey
    });
    const ownerDocument = view.dom.ownerDocument;
    const slot = ownerDocument.createElement('div');
    if (!view.dom.isConnected || typeof getPos !== 'function' || typeof slot.moveBefore !== 'function') return createExtensionNode(node).init();
    const owner = {
        getPos: getPos,
        destroyed: false
    };
    let entries = $e19e2a5b7aebb330$var$editors.get(view);
    if (!entries) {
        entries = new Set();
        $e19e2a5b7aebb330$var$editors.set(view, entries);
    }
    const registry = entries;
    let entry;
    let latestNode = node;
    let latestDecorations = [];
    let latestInnerDecorations;
    // Construction can precede the old slot's destroy(). Defer portal adoption until
    // both hooks have run; no rendering opportunity occurs between these microtasks.
    queueMicrotask(()=>{
        if (owner.destroyed || view.isDestroyed || !slot.isConnected) return;
        entry = Array.from(registry).find((existing)=>existing.owner.destroyed && existing.rendererKind === rendererKind && $e19e2a5b7aebb330$var$sameChart(existing.inner.node, latestNode));
        if (entry) {
            var _slot$moveBefore, _entry$parking;
            entry.owner = owner;
            entry.inner.reactComponentProps = renderProps;
            (_slot$moveBefore = slot.moveBefore) === null || _slot$moveBefore === void 0 || _slot$moveBefore.call(slot, entry.inner.dom, null);
            (_entry$parking = entry.parking) === null || _entry$parking === void 0 || _entry$parking.remove();
            entry.parking = undefined;
            if (!entry.inner.update(latestNode, latestDecorations, latestInnerDecorations)) {
                // A matching chart is normally accepted, but honour the NodeView contract
                // if a renderer rejects it. Remove the old portal before creating a replacement.
                registry.delete(entry);
                const dom = entry.inner.dom;
                entry.inner.destroy();
                dom.remove();
                entry = undefined;
            }
        }
        if (!entry) {
            // Construct only after the old slot has had a chance to park its portal.
            const inner = createExtensionNode(latestNode);
            const retained = {
                inner: inner,
                owner: owner,
                rendererKind: rendererKind
            };
            entry = retained;
            inner.getPos = ()=>retained.owner.destroyed ? undefined : retained.owner.getPos();
            inner.init();
            slot.appendChild(inner.dom);
            registry.add(retained);
        }
    });
    return {
        dom: slot,
        // The retained extension is an atom: ProseMirror must not manage the portal's children.
        update (next, decorations, innerDecorations) {
            if (next.type !== node.type || next.attrs.localId !== node.attrs.localId || next.attrs.extensionKey !== node.attrs.extensionKey) return false;
            latestNode = next;
            latestDecorations = decorations;
            latestInnerDecorations = innerDecorations;
            return entry ? entry.inner.update(next, decorations, innerDecorations) : true;
        },
        stopEvent: (event)=>{
            var _entry;
            return ((_entry = entry) === null || _entry === void 0 ? void 0 : _entry.inner.stopEvent(event)) ?? false;
        },
        ignoreMutation: (mutation)=>{
            var _entry2;
            return ((_entry2 = entry) === null || _entry2 === void 0 ? void 0 : _entry2.inner.ignoreMutation(mutation)) ?? mutation.type !== 'selection';
        },
        destroy () {
            owner.destroyed = true;
            if (!entry) return;
            const retained = entry;
            if (retained.inner.dom.isConnected) {
                var _parking$moveBefore;
                const parking = ownerDocument.createElement('div');
                // Transient, outside the editable document and inaccessible while awaiting handoff.
                parking.hidden = true;
                ownerDocument.body.appendChild(parking);
                (_parking$moveBefore = parking.moveBefore) === null || _parking$moveBefore === void 0 || _parking$moveBefore.call(parking, retained.inner.dom, null);
                retained.parking = parking;
            }
            // Give constructors queued after destroy() a chance to claim the portal first.
            queueMicrotask(()=>queueMicrotask(()=>{
                    if (retained.owner === owner && registry.delete(retained)) {
                        var _retained$parking;
                        const dom = retained.inner.dom;
                        retained.inner.destroy();
                        dom.remove();
                        (_retained$parking = retained.parking) === null || _retained$parking === void 0 || _retained$parking.remove();
                    }
                }));
        }
    };
}

});
parcelRegister("ltxzX", function(module, exports) {
$parcel$export(module.exports, "NATIVE_EMBED_MAUI_EXTENSION_KEY", () => $7e5e53267e0cf215$export$f2daa8b97265b2bb);

var $1fO1j = parcelRequire("1fO1j");
const $7e5e53267e0cf215$export$f2daa8b97265b2bb = `${(0, $1fO1j.NATIVE_EMBED_EXTENSION_KEY)}:maui`;

});



parcelRegister("4qr1p", function(module, exports) {
$parcel$export(module.exports, "buildExtensionBlockTransforms", () => $42e76bd3d0e14a60$export$f01d446fba239e5a);
const $42e76bd3d0e14a60$export$f01d446fba239e5a = (manifests)=>{
    const transforms = [];
    for (const manifest of manifests){
        for (const nodeModule of Object.values(manifest.modules.nodes ?? {}))if (nodeModule.blockTransform) transforms.push(nodeModule.blockTransform);
    }
    return transforms;
};

});

parcelRegister("UNL2s", function(module, exports) {
$parcel$export(module.exports, "updateEditButton", () => $f52e6b69af9b18c7$export$1e25f457f2ade11e);

var $iVHNS = parcelRequire("iVHNS");

var $5Edew = parcelRequire("5Edew");

var $83R7C = parcelRequire("83R7C");
const $f52e6b69af9b18c7$var$maybeGetExtensionModuleNode = async (view, extensionProvider)=>{
    const nodeWithPos = (0, $83R7C.getSelectedExtension)(view.state, true);
    if (!nodeWithPos) throw new Error('There is no selection');
    const { extensionType: extensionType, extensionKey: extensionKey } = nodeWithPos.node.attrs;
    const extensionModuleNode = await (0, $iVHNS.getExtensionModuleNode)(extensionProvider, extensionType, extensionKey);
    const newNodeWithPos = (0, $83R7C.getSelectedExtension)(view.state, true);
    if (newNodeWithPos && newNodeWithPos.node.attrs.extensionType === extensionType && newNodeWithPos.node.attrs.extensionKey === extensionKey && newNodeWithPos.pos === nodeWithPos.pos && extensionModuleNode) return extensionModuleNode;
};
const $f52e6b69af9b18c7$export$1e25f457f2ade11e = async (view, extensionProvider)=>{
    try {
        const extensionModuleNode = await $f52e6b69af9b18c7$var$maybeGetExtensionModuleNode(view, extensionProvider);
        const updateMethod = extensionModuleNode === null || extensionModuleNode === void 0 ? void 0 : extensionModuleNode.update;
        (0, $5Edew.updateState)({
            showEditButton: !!updateMethod,
            showCopyButton: !(extensionModuleNode !== null && extensionModuleNode !== void 0 && extensionModuleNode.hideCopyButton),
            updateExtension: updateMethod && Promise.resolve(updateMethod) || undefined
        })(view.state, view.dispatch);
        return updateMethod;
    } catch  {
    // this exception is not important for this case, fail silently
    }
};

});


parcelRegister("dPjti", function(module, exports) {
$parcel$export(module.exports, "bodiedExtensionSpecWithFixedToDOM", () => $19a5090e21ccca79$export$1a85854d3d541a64);

var $eC92i = parcelRequire("eC92i");

var $kqiw5 = parcelRequire("kqiw5");
const $19a5090e21ccca79$var$capitalizeFirstLetter = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $19a5090e21ccca79$export$1a85854d3d541a64 = ()=>{
    return {
        ...(0, $eC92i.bodiedExtension),
        toDOM: (node)=>{
            const attrs = {
                'data-node-type': 'bodied-extension',
                'data-extension-type': node.attrs.extensionType,
                'data-extension-key': node.attrs.extensionKey,
                'data-text': node.attrs.text,
                'data-parameters': JSON.stringify(node.attrs.parameters),
                'data-layout': node.attrs.layout,
                'data-local-id:': node.attrs.localId,
                style: (0, $kqiw5.convertToInlineCss)({
                    position: 'relative',
                    marginTop: "var(--ds-space-300, 24px)"
                })
            };
            const title = node.attrs && node.attrs.extensionTitle || node.attrs && node.attrs.macroMetadata && node.attrs.macroMetadata.title || node.attrs.extensionKey;
            return [
                'div',
                attrs,
                [
                    'span',
                    {
                        // Styles based on `packages/editor/editor-common/src/extensibility/Extension/Lozenge/ExtensionLabel.tsx`
                        style: (0, $kqiw5.convertToInlineCss)({
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            fontSize: '14px',
                            padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`,
                            color: "var(--ds-text-subtle, #505258)",
                            borderTopLeftRadius: "var(--ds-radius-small, 4px)",
                            borderTopRightRadius: "var(--ds-radius-small, 4px)",
                            lineHeight: 1,
                            position: 'absolute',
                            top: '-19px'
                        }),
                        // If we put this below inside the span then we serialise the label (which causes the label to be
                        // be copied to the clipboard causing copy-paste issues).
                        // So instead we use a pseudo-element to add the title to this class
                        'data-bodied-extension-label': $19a5090e21ccca79$var$capitalizeFirstLetter(title),
                        class: 'bodied-extension-to-dom-label'
                    }
                ],
                [
                    'div',
                    {
                        style: (0, $kqiw5.convertToInlineCss)({
                            padding: "var(--ds-space-200, 16px)",
                            marginLeft: "var(--ds-space-negative-150, -12px)",
                            marginRight: "var(--ds-space-negative-150, -12px)",
                            boxShadow: `0 0 0 1px ${"var(--ds-border, #0B120E24)"}`,
                            borderRadius: "var(--ds-radius-small, 4px)"
                        })
                    },
                    0
                ]
            ];
        }
    };
};

});

parcelRegister("jqo51", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $d7d4a5ff6e23d9f9$export$86ce8f8241c20a3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $5knpG = parcelRequire("5knpG");

var $1fO1j = parcelRequire("1fO1j");

var $1OjU8 = parcelRequire("1OjU8");

var $3uluy = parcelRequire("3uluy");

var $2DjPx = parcelRequire("2DjPx");

var $fmnS6 = parcelRequire("fmnS6");

var $8P6Kl = parcelRequire("8P6Kl");

var $2qSeE = parcelRequire("2qSeE");

var $a4TQr = parcelRequire("a4TQr");

var $aRPz6 = parcelRequire("aRPz6");

var $gOZz1 = parcelRequire("gOZz1");

var $Admw7 = parcelRequire("Admw7");

var $5BrPA = parcelRequire("5BrPA");

var $g0VQ6 = parcelRequire("g0VQ6");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $1FRDO = parcelRequire("1FRDO");

var $5Edew = parcelRequire("5Edew");

var $5JOt5 = parcelRequire("5JOt5");

var $5vS9r = parcelRequire("5vS9r");

var $83R7C = parcelRequire("83R7C");
// non-bodied extensions nested inside panels, blockquotes and lists do not support layouts
const $d7d4a5ff6e23d9f9$var$isNestedNBM = (state, selectedExtNode)=>{
    const { schema: { nodes: nodes }, selection: selection } = state;
    const { extension: extension, panel: panel, blockquote: blockquote, listItem: listItem, panel_c1: panel_c1 } = nodes;
    if (!selectedExtNode) return false;
    const parentNodeTypes = (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        blockquote,
        listItem
    ] : [
        panel,
        blockquote,
        listItem
    ];
    return selectedExtNode.node.type === extension && (0, $a4TQr.hasParentNodeOfType)(parentNodeTypes.filter(Boolean))(selection);
};
const $d7d4a5ff6e23d9f9$var$isLayoutSupported = (state, selectedExtNode)=>{
    const { schema: { nodes: { bodiedExtension: bodiedExtension, extension: extension, layoutSection: layoutSection, table: table, expand: expand, multiBodiedExtension: multiBodiedExtension } }, selection: selection } = state;
    if (!selectedExtNode) return false;
    // Skip agent-managed-block extension until it supports the layout controls in its custom node
    const extensionKey = selectedExtNode.node.attrs.extensionKey;
    if ((0, $1fO1j.AGENT_MANAGED_EXTENSION_KEY) === extensionKey) return false;
    const isMultiBodiedExtension = selectedExtNode.node.type === multiBodiedExtension;
    const isNonEmbeddedBodiedExtension = selectedExtNode.node.type === bodiedExtension && !(0, $a4TQr.hasParentNodeOfType)([
        multiBodiedExtension
    ].filter(Boolean))(selection);
    const isNonEmbeddedExtension = selectedExtNode.node.type === extension && !(0, $a4TQr.hasParentNodeOfType)([
        bodiedExtension,
        table,
        expand,
        multiBodiedExtension
    ].filter(Boolean))(selection);
    // if selection belongs to layout supported extension category
    // and not inside a layoutSection
    return !!((isMultiBodiedExtension || isNonEmbeddedBodiedExtension || isNonEmbeddedExtension) && !(0, $a4TQr.hasParentNodeOfType)([
        layoutSection
    ])(selection));
};
const $d7d4a5ff6e23d9f9$var$breakoutButtonListOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $83R7C.getSelectedExtension)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (nodeWithPos && breakoutEnabled && $d7d4a5ff6e23d9f9$var$isLayoutSupported(state, nodeWithPos) && !$d7d4a5ff6e23d9f9$var$isNestedNBM(state, nodeWithPos)) {
        const { layout: layout } = nodeWithPos.node.attrs;
        return [
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRPz6))), {
                        label: formatMessage((0, $3uluy.default).layoutFixedWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($aRPz6))),
                onClick: (0, $5Edew.updateExtensionLayout)('default', editorAnalyticsAPI),
                selected: layout === 'default',
                title: formatMessage((0, $3uluy.default).layoutFixedWidth),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gOZz1))), {
                        label: formatMessage((0, $3uluy.default).layoutWide),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gOZz1))),
                onClick: (0, $5Edew.updateExtensionLayout)('wide', editorAnalyticsAPI),
                selected: layout === 'wide',
                title: formatMessage((0, $3uluy.default).layoutWide),
                tabIndex: null
            },
            {
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VQ6))), {
                        label: formatMessage((0, $3uluy.default).layoutFullWidth),
                        spacing: "spacious"
                    }),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($g0VQ6))),
                onClick: (0, $5Edew.updateExtensionLayout)('full-width', editorAnalyticsAPI),
                selected: layout === 'full-width',
                title: formatMessage((0, $3uluy.default).layoutFullWidth),
                tabIndex: null
            }
        ];
    }
    return [];
};
const $d7d4a5ff6e23d9f9$var$breakoutDropdownOptions = (state, formatMessage, breakoutEnabled, editorAnalyticsAPI)=>{
    const nodeWithPos = (0, $83R7C.getSelectedExtension)(state, true);
    // we should only return breakout options when breakouts are enabled and the node supports them
    if (!nodeWithPos || !breakoutEnabled || !$d7d4a5ff6e23d9f9$var$isLayoutSupported(state, nodeWithPos) || $d7d4a5ff6e23d9f9$var$isNestedNBM(state, nodeWithPos)) return [];
    const { layout: layout } = nodeWithPos.node.attrs;
    let title = '';
    let IconComponent;
    switch(layout){
        case 'wide':
            title = formatMessage((0, $3uluy.default).layoutStateWide);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($gOZz1)));
            break;
        case 'full-width':
            title = formatMessage((0, $3uluy.default).layoutStateFullWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($g0VQ6)));
            break;
        case 'default':
        default:
            title = formatMessage((0, $3uluy.default).layoutStateFixedWidth);
            IconComponent = (0, (/*@__PURE__*/$parcel$interopDefault($aRPz6)));
            break;
    }
    const options = [
        {
            id: 'editor.extensions.width.default',
            title: formatMessage((0, $3uluy.default).layoutFixedWidth),
            onClick: (0, $5Edew.updateExtensionLayout)('default', editorAnalyticsAPI),
            selected: layout === 'default',
            icon: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aRPz6))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $3uluy.default).layoutFixedWidth)
            })
        },
        {
            id: 'editor.extensions.width.wide',
            title: formatMessage((0, $3uluy.default).layoutWide),
            onClick: (0, $5Edew.updateExtensionLayout)('wide', editorAnalyticsAPI),
            selected: layout === 'wide',
            icon: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gOZz1))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $3uluy.default).layoutWide)
            })
        },
        {
            id: 'editor.extensions.width.full-width',
            title: formatMessage((0, $3uluy.default).layoutFullWidth),
            onClick: (0, $5Edew.updateExtensionLayout)('full-width', editorAnalyticsAPI),
            selected: layout === 'full-width',
            icon: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g0VQ6))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $3uluy.default).layoutFullWidth)
            })
        }
    ];
    return [
        {
            id: 'extensions-width-options-toolbar-item',
            testId: 'extensions-width-options-toolbar-dropdown',
            type: 'dropdown',
            options: options,
            title: title,
            iconBefore: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)(IconComponent, {
                    color: "currentColor",
                    spacing: "spacious",
                    label: title
                })
        }
    ];
};
const $d7d4a5ff6e23d9f9$var$breakoutOptions = (state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, api)=>{
    return (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar)) ? $d7d4a5ff6e23d9f9$var$breakoutDropdownOptions(state, formatMessage, breakoutEnabled, editorAnalyticsAPI) : $d7d4a5ff6e23d9f9$var$breakoutButtonListOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI);
};
const $d7d4a5ff6e23d9f9$var$editButton = (formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, isDisabled = false, api)=>{
    if (!extensionState.showEditButton) return [];
    const toolbarFlagsEnabled = (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    const editButtonItems = [
        {
            id: 'editor.extension.edit',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5BrPA))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($5BrPA))),
            testId: 'extension-toolbar-edit-button',
            // Taking the latest `updateExtension` from plugin state to avoid race condition @see ED-8501
            onClick: (state, dispatch, view)=>{
                const macroState = (0, $5JOt5.pluginKey).getState(state);
                const { updateExtension: updateExtension } = (0, $5vS9r.getPluginState)(state);
                (0, $1FRDO.editExtension)(macroState && macroState.macroProvider, applyChangeToContextPanel, editorAnalyticsAPI, updateExtension)(state, dispatch, view);
                return true;
            },
            title: formatMessage((0, $1OjU8.messages).edit),
            tabIndex: null,
            focusEditoronEnter: true,
            disabled: isDisabled,
            isRadioButton: false
        }
    ];
    if (toolbarFlagsEnabled) editButtonItems.push({
        type: 'separator',
        fullHeight: true
    });
    return editButtonItems;
};
/**
 * Calculates the position for the toolbar when dealing with nested extensions
 * @param editorView
 * @param nextPos
 * @param state
 * @param extensionNode
 * @example
 */ const $d7d4a5ff6e23d9f9$var$calculateToolbarPosition = (editorView, nextPos, state, extensionNode)=>{
    const { state: { schema: schema, selection: selection } } = editorView;
    const possibleMbeParent = (0, $a4TQr.findParentNodeOfType)(schema.nodes.extensionFrame)(selection);
    // We only want to use calculated position in case of a bodiedExtension present inside an MBE node
    const isBodiedExtensionInsideMBE = possibleMbeParent && (extensionNode === null || extensionNode === void 0 ? void 0 : extensionNode.node.type.name) === 'bodiedExtension';
    let scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
    if (!extensionNode) return nextPos;
    const isInsideEditableExtensionArea = !!editorView.dom.closest('.extension-editable-area');
    if (!isBodiedExtensionInsideMBE && !isInsideEditableExtensionArea) return nextPos;
    if (isInsideEditableExtensionArea && scrollWrapper.parentElement) // The editable extension area may have its own scroll wrapper, so we want to keep searching up the tree for the page level scroll wrapper.
    scrollWrapper = scrollWrapper.parentElement.closest('.fabric-editor-popup-scroll-parent') || scrollWrapper;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const nestedBodiedExtensionDomElement = editorView.nodeDOM(extensionNode.pos);
    const nestedBodiedExtensionRect = nestedBodiedExtensionDomElement === null || nestedBodiedExtensionDomElement === void 0 ? void 0 : nestedBodiedExtensionDomElement.getBoundingClientRect();
    const wrapperBounds = scrollWrapper.getBoundingClientRect();
    const toolbarTopPos = nestedBodiedExtensionRect.bottom - wrapperBounds.top + scrollWrapper.scrollTop + (0, $2DjPx.BODIED_EXT_MBE_MARGIN_TOP);
    return {
        top: toolbarTopPos,
        left: nextPos.left
    };
};
const $d7d4a5ff6e23d9f9$export$7652656d91146fb9 = ({ formatMessage: formatMessage, extensionApi: extensionApi, extensionProvider: extensionProvider, getUnsupportedContent: getUnsupportedContent, state: state, locale: locale })=>{
    if (!extensionProvider) return;
    const nodeWithPos = (0, $83R7C.getSelectedExtension)(state, true);
    if (!nodeWithPos) return;
    const { node: node } = nodeWithPos;
    const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
    const extensionParams = {
        type: node.type.name,
        extensionKey: extensionKey,
        extensionType: extensionType,
        parameters: node.attrs.parameters,
        content: node.content,
        localId: node.attrs.localId
    };
    const adf = getUnsupportedContent === null || getUnsupportedContent === void 0 ? void 0 : getUnsupportedContent(extensionParams);
    if (!adf) return;
    // this command copies the text content of the unsupported content extension to the clipboard
    return (editorState)=>{
        var _extensionApi$analyti;
        extensionApi === null || extensionApi === void 0 || (_extensionApi$analyti = extensionApi.analytics) === null || _extensionApi$analyti === void 0 || _extensionApi$analyti.actions.fireAnalyticsEvent({
            action: (0, $3LeME.ACTION).CLICKED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).COPY_BUTTON,
            eventType: (0, $3LeME.EVENT_TYPE).UI,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).EXTENSION,
            attributes: {
                extensionDynamicType: node.type.name,
                extensionType: node.attrs.extensionType,
                extensionKey: node.attrs.extensionKey
            }
        });
        (0, $83R7C.copyUnsupportedContentToClipboard)({
            locale: locale,
            unsupportedContent: adf,
            schema: state.schema,
            api: extensionApi
        }).then(()=>{
            var _extensionApi$copyBut;
            extensionApi === null || extensionApi === void 0 || (_extensionApi$copyBut = extensionApi.copyButton) === null || _extensionApi$copyBut === void 0 || _extensionApi$copyBut.actions.afterCopy(formatMessage((0, $3uluy.default).copiedToClipboard));
        }).catch((error)=>{
            (0, $83R7C.onCopyFailed)({
                error: error,
                extensionApi: extensionApi,
                state: editorState
            });
        });
        return true;
    };
};
const $d7d4a5ff6e23d9f9$export$86ce8f8241c20a3 = ({ breakoutEnabled: breakoutEnabled = true, copyEnabled: copyEnabled = true, deleteEnabled: deleteEnabled = true, extensionApi: extensionApi, getUnsupportedContent: getUnsupportedContent })=>(state, intl)=>{
        var _extensionApi$decorat, _extensionApi$context, _extensionApi$analyti2, _extensionApi$connect;
        const { formatMessage: formatMessage, locale: locale } = intl;
        const extensionState = (0, $5vS9r.getPluginState)(state);
        if (!extensionState || extensionState.showContextPanel || !extensionState.element) return;
        const { extensionProvider: extensionProvider } = extensionState;
        const hoverDecoration = extensionApi === null || extensionApi === void 0 || (_extensionApi$decorat = extensionApi.decorations) === null || _extensionApi$decorat === void 0 ? void 0 : _extensionApi$decorat.actions.hoverDecoration;
        const applyChangeToContextPanel = extensionApi === null || extensionApi === void 0 || (_extensionApi$context = extensionApi.contextPanel) === null || _extensionApi$context === void 0 ? void 0 : _extensionApi$context.actions.applyChange;
        const editorAnalyticsAPI = extensionApi === null || extensionApi === void 0 || (_extensionApi$analyti2 = extensionApi.analytics) === null || _extensionApi$analyti2 === void 0 ? void 0 : _extensionApi$analyti2.actions;
        const nodeType = [
            state.schema.nodes.extension,
            state.schema.nodes.inlineExtension,
            state.schema.nodes.bodiedExtension,
            state.schema.nodes.multiBodiedExtension
        ];
        const editButtonItems = $d7d4a5ff6e23d9f9$var$editButton(formatMessage, extensionState, applyChangeToContextPanel, editorAnalyticsAPI, (0, $5knpG.isOfflineMode)(extensionApi === null || extensionApi === void 0 || (_extensionApi$connect = extensionApi.connectivity) === null || _extensionApi$connect === void 0 || (_extensionApi$connect = _extensionApi$connect.sharedState) === null || _extensionApi$connect === void 0 || (_extensionApi$connect = _extensionApi$connect.currentState()) === null || _extensionApi$connect === void 0 ? void 0 : _extensionApi$connect.mode), extensionApi);
        // extensions are sized with the breakout resizer instead
        const breakoutItems = (0, $bcN2K.isExperimentEnabled)('platform_editor_lovability_resize_extensions') ? [] : $d7d4a5ff6e23d9f9$var$breakoutOptions(state, formatMessage, extensionState, breakoutEnabled, editorAnalyticsAPI, extensionApi);
        const extensionObj = (0, $83R7C.getSelectedExtension)(state, true);
        // If this is a native-embed extension, skip providing a toolbar config to allow
        // the native-embed plugin to provide a custom toolbar config.
        if ((extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node.attrs.extensionType) === (0, $1fO1j.NATIVE_EMBED_EXTENSION_TYPE) && extensionObj !== null && extensionObj !== void 0 && extensionObj.node.attrs.extensionKey.includes((0, $1fO1j.NATIVE_EMBED_EXTENSION_KEY))) return;
        // Check if we need to show confirm dialog for delete button
        let confirmDialog;
        if ((0, $2qSeE.isReferencedSource)(state, extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node)) confirmDialog = ()=>{
            const localSourceName = formatMessage((0, $1OjU8.messages).unnamedSource);
            return {
                title: formatMessage((0, $1OjU8.messages).deleteElementTitle),
                okButtonLabel: formatMessage((0, $1OjU8.messages).confirmDeleteLinkedModalOKButton),
                message: formatMessage((0, $1OjU8.messages).confirmDeleteLinkedModalMessage, {
                    nodeName: (0, $8P6Kl.getNodeName)(state, extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node) || localSourceName
                }),
                isReferentialityDialog: true,
                getChildrenInfo: ()=>(0, $2qSeE.getChildrenInfo)(state, extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node),
                checkboxLabel: formatMessage((0, $1OjU8.messages).confirmModalCheckboxLabel),
                onConfirm: (isChecked = false)=>$d7d4a5ff6e23d9f9$var$clickWithCheckboxHandler(isChecked, extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node)
            };
        };
        // Hide the copy button when the host disables it for every extension
        // (`copyEnabled`), when the extension's manifest node opts out via
        // `hideCopyButton` (e.g. redactions), or for the legacy content macro.
        //
        const shouldHideCopyButton = !copyEnabled || !extensionState.showCopyButton && (0, $dRkX9.fg)('platform_editor_extension_hide_copy_button') || (extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node.attrs.extensionType) === 'com.atlassian.confluence.migration' && (extensionObj === null || extensionObj === void 0 ? void 0 : extensionObj.node.attrs.extensionKey) === 'legacy-content';
        const shouldHideDeleteButton = !deleteEnabled;
        // With both trailing actions gone the toolbar ends after the breakout
        // options, so the divider that used to introduce them would be an orphan.
        const hasTrailingActions = !shouldHideCopyButton || !shouldHideDeleteButton;
        return {
            title: 'Extension floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getDomRef: ()=>extensionState.element.parentElement || undefined,
            nodeType: nodeType,
            onPositionCalculated: (editorView, nextPos)=>$d7d4a5ff6e23d9f9$var$calculateToolbarPosition(editorView, nextPos, state, extensionObj),
            items: [
                ...editButtonItems,
                ...breakoutItems,
                {
                    type: 'separator',
                    hidden: editButtonItems.length === 0 && breakoutItems.length === 0 || !hasTrailingActions
                },
                {
                    type: 'extensions-placeholder',
                    separator: 'end'
                },
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onClick: $d7d4a5ff6e23d9f9$export$7652656d91146fb9({
                                formatMessage: formatMessage,
                                extensionApi: extensionApi,
                                extensionProvider: extensionProvider,
                                getUnsupportedContent: getUnsupportedContent,
                                state: state,
                                locale: locale
                            })
                        }
                    ],
                    ...shouldHideCopyButton && {
                        hidden: shouldHideCopyButton
                    }
                },
                // Hide this separator when either neighbour is hidden, otherwise it
                // renders as an orphaned divider before or after the delete button.
                {
                    type: 'separator',
                    hidden: shouldHideCopyButton || shouldHideDeleteButton
                },
                {
                    ...shouldHideDeleteButton && {
                        hidden: true
                    },
                    id: 'editor.extension.delete',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($Admw7))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($Admw7))),
                    appearance: 'danger',
                    onClick: (0, $5Edew.removeExtension)(editorAnalyticsAPI, (0, $3LeME.INPUT_METHOD).FLOATING_TB),
                    onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
                    onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
                    onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
                    onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
                    focusEditoronEnter: true,
                    title: formatMessage((0, $3uluy.default).remove),
                    tabIndex: null,
                    confirmDialog: confirmDialog
                }
            ],
            scrollable: true
        };
    };
const $d7d4a5ff6e23d9f9$var$clickWithCheckboxHandler = (isChecked, node)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) (0, $5Edew.removeExtension)()(state, dispatch);
        else (0, $5Edew.removeDescendantNodes)(node)(state, dispatch);
        return true;
    };

});

parcelRegister("9WASI", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $3ec9e9299bc0af75$export$ae829ec7b2625219);

var $10F96 = parcelRequire("10F96");

var $1FHzN = parcelRequire("1FHzN");

var $1y7gE = parcelRequire("1y7gE");

var $eYaXU = parcelRequire("eYaXU");

var $801jp = parcelRequire("801jp");
const $3ec9e9299bc0af75$var$pluginKey = new (0, $801jp.PluginKey)('extensionUniqueIdPlugin');
const $3ec9e9299bc0af75$export$ae829ec7b2625219 = ()=>new (0, $1y7gE.SafePlugin)({
        appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            const selectionBookmark = tr.selection.getBookmark();
            let modified = false;
            const { extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension, multiBodiedExtension: multiBodiedExtension } = newState.schema.nodes;
            const extensionTypes = new Set([
                extension,
                bodiedExtension,
                inlineExtension,
                multiBodiedExtension
            ]);
            const idsObserved = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                const isAddingExtension = transaction.steps.some((step)=>{
                    var _step$attrs;
                    return (0, $eYaXU.stepAddsOneOf)(step, extensionTypes) || // There are instances where the localId will be reset to null on publish due to extension
                    // not existing in the Storage format (eg. Legacy Content Extensions) or not having a localId
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    step instanceof (0, $10F96.SetAttrsStep) && // @ts-expect-error Bad ProseMirror step types
                    ((_step$attrs = step.attrs) === null || _step$attrs === void 0 ? void 0 : _step$attrs.localId) === null;
                });
                if (isAddingExtension) // Can't simply look at changed nodes, as we could be adding an extension
                newState.doc.descendants((node, pos)=>{
                    const localId = node.attrs.localId;
                    // Dealing with an extension - make sure it's a unique ID
                    if (!!node.type && extensionTypes.has(node.type)) {
                        if (localId && !idsObserved.has(localId)) idsObserved.add(localId);
                        else if (!localId || idsObserved.has(localId)) {
                            modified = true;
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                localId: (0, $1FHzN.uuid).generate()
                            });
                        }
                        /**
             * If it's a multiBodiedExtension or bodiedExtension, we'll need to keep digging;
             * since we can have more extension nodes within the contents of that
             */ if ([
                            multiBodiedExtension,
                            bodiedExtension
                        ].includes(node.type)) return true;
                        return false;
                    }
                    /**
           * Otherwise continue traversing, we can encounter extensions nested in
           * expands/bodiedExtensions
           */ return true;
                });
            });
            if (modified) // We want to restore to the original selection but w/o applying the mapping
            // @see https://github.com/ProseMirror/prosemirror/issues/645
            return tr.setSelection(selectionBookmark.resolve(tr.doc));
            return;
        },
        key: $3ec9e9299bc0af75$var$pluginKey
    });

});

parcelRegister("aLKBL", function(module, exports) {
$parcel$export(module.exports, "ALLOWED_LOGGED_MACRO_PARAMS", () => $48b387479d890505$export$2a99ab8c82908148);
$parcel$export(module.exports, "ALLOWED_PARAM_TYPES", () => $48b387479d890505$export$d17c9f402b8c93c8);
$parcel$export(module.exports, "CONFIG_PANEL_WIDTH", () => $48b387479d890505$export$57e7dbe0bbfe09b5);
$parcel$export(module.exports, "CONFIG_PANEL_ID", () => $48b387479d890505$export$cb69418acbe13bc2);
// Allowlist of { macroKey: parameterName[] } for analytics logging
const $48b387479d890505$export$2a99ab8c82908148 = {
    children: [
        'all',
        'first',
        'depth',
        'style',
        'excerptType',
        'sort',
        'reverse'
    ],
    'recently-updated': [
        'width',
        'types',
        'max',
        'theme',
        'showProfilePic',
        'hideHeading'
    ],
    excerpt: [
        'hidden'
    ]
};
const $48b387479d890505$export$d17c9f402b8c93c8 = [
    'enum',
    'number',
    'boolean'
];
const $48b387479d890505$export$57e7dbe0bbfe09b5 = 320;
const $48b387479d890505$export$cb69418acbe13bc2 = 'extensions-panel';

});

parcelRegister("40e3d", function(module, exports) {
$parcel$export(module.exports, "getContextPanel", () => $261217e2130b18ac$export$7c8c60c0acb92731);
$parcel$export(module.exports, "onChangeAction", () => $261217e2130b18ac$export$2f221d4ebb46923c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $1fO1j = parcelRequire("1fO1j");

var $ihNBw = parcelRequire("ihNBw");

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $1FRDO = parcelRequire("1FRDO");

var $5Edew = parcelRequire("5Edew");

var $5vS9r = parcelRequire("5vS9r");

var $83R7C = parcelRequire("83R7C");

var $bvqke = parcelRequire("bvqke");

var $7sUHN = parcelRequire("7sUHN");
const $261217e2130b18ac$var$areParametersEqual = (firstParameters, secondParameters)=>{
    if (typeof firstParameters === 'object' && typeof secondParameters === 'object' && firstParameters !== null && secondParameters !== null) {
        const firstKeys = Object.keys(firstParameters);
        const secondKeys = Object.keys(secondParameters);
        return firstKeys.length === secondKeys.length && firstKeys.every((key)=>firstParameters[key] === secondParameters[key]);
    }
    return firstParameters === secondParameters;
};
const $261217e2130b18ac$export$3c0bb68e76442a1e = (selectionToDuplicate, doc)=>{
    if (selectionToDuplicate instanceof (0, $801jp.NodeSelection)) return (0, $801jp.NodeSelection).create(doc, selectionToDuplicate.from);
    else if (selectionToDuplicate instanceof (0, $801jp.TextSelection)) return (0, $801jp.TextSelection).create(doc, selectionToDuplicate.from, selectionToDuplicate.to);
    else if (selectionToDuplicate instanceof (0, $ihNBw.GapCursorSelection)) return new (0, $ihNBw.GapCursorSelection)(doc.resolve(selectionToDuplicate.from), selectionToDuplicate.side);
    else if (selectionToDuplicate instanceof (0, $ev7OZ.CellSelection)) return new (0, $ev7OZ.CellSelection)(doc.resolve(selectionToDuplicate.$anchorCell.pos), doc.resolve(selectionToDuplicate.$headCell.pos));
};
const $261217e2130b18ac$export$7c8c60c0acb92731 = (getEditorView)=>(api, featureFlags)=>(state)=>{
            var _api$contextPanel;
            const nodeWithPos = (0, $83R7C.getSelectedExtension)(state, true);
            const applyChange = api === null || api === void 0 || (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.actions.applyChange;
            // Adding checks to bail out early
            if (!nodeWithPos) return;
            const extensionState = (0, $5vS9r.getPluginState)(state);
            const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersBefore: processParametersBefore, processParametersAfter: processParametersAfter } = extensionState;
            if (extensionState && showContextPanel && extensionProvider && processParametersAfter) {
                const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
                const [extKey, nodeKey] = (0, $1fO1j.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
                const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7sUHN.SaveIndicator), {
                    duration: 5000,
                    visible: true,
                    children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                        const editorView = getEditorView === null || getEditorView === void 0 ? void 0 : getEditorView();
                        if (!editorView) return null;
                        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bvqke.default), {
                            api: api,
                            showHeader: true,
                            closeOnEsc: true,
                            extensionType: extensionType,
                            extensionKey: extKey,
                            nodeKey: nodeKey,
                            extensionParameters: parameters,
                            parameters: configParams,
                            extensionProvider: extensionProvider,
                            autoSaveTrigger: autoSaveResolve,
                            autoSaveReject: autoSaveReject,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onChange: async (updatedParameters)=>{
                                await $261217e2130b18ac$export$2f221d4ebb46923c(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                                onSaveEnded();
                                if (autoSaveResolve) autoSaveResolve();
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onCancel: async ()=>{
                                try {
                                    await new Promise((resolve, reject)=>{
                                        (0, $5Edew.forceAutoSave)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
                                    });
                                } catch (e) {
                                    // Even if the save failed, we should proceed with closing the panel
                                    // eslint-disable-next-line no-console
                                    console.error(`Autosave failed with error`, e);
                                }
                                (0, $5Edew.clearEditingContext)(applyChange)(editorView.state, editorView.dispatch);
                            },
                            featureFlags: featureFlags
                        });
                    }
                });
            }
        };
async function $261217e2130b18ac$export$2f221d4ebb46923c(editorView, updatedParameters = {}, oldParameters = {}, nodeWithPos, onSaving) {
    // WARNING: editorView.state stales quickly, do not unpack
    const { processParametersAfter: processParametersAfter, processParametersBefore: processParametersBefore } = (0, $5vS9r.getPluginState)(editorView.state);
    if (!processParametersAfter) return;
    const unwrappedOldParameters = processParametersBefore ? processParametersBefore(oldParameters) : oldParameters;
    if ($261217e2130b18ac$var$areParametersEqual(unwrappedOldParameters, updatedParameters)) return;
    if (onSaving) onSaving();
    const key = Date.now();
    const { positions: previousPositions } = (0, $5vS9r.getPluginState)(editorView.state);
    await (0, $5Edew.updateState)({
        positions: {
            ...previousPositions,
            [key]: nodeWithPos.pos
        }
    })(editorView.state, editorView.dispatch);
    // WARNING: after this, editorView.state may have changed
    const newParameters = await processParametersAfter(updatedParameters);
    const { positions: positions } = (0, $5vS9r.getPluginState)(editorView.state);
    if (!positions) return;
    if (!(key in positions)) return;
    const { node: node } = nodeWithPos;
    const newNode = (0, $1FRDO.buildExtensionNode)(nodeWithPos.node.toJSON().type, editorView.state.schema, {
        ...node.attrs,
        parameters: {
            ...oldParameters,
            ...newParameters
        }
    }, node.content, node.marks);
    if (!newNode) return;
    const positionUpdated = positions[key];
    const transaction = editorView.state.tr.replaceWith(positionUpdated, positionUpdated + newNode.nodeSize, newNode);
    // Ensure we preserve the selection, tr.replaceWith causes it to be lost in some cases
    // when replacing the node
    const { selection: prevSelection } = editorView.state;
    if (!prevSelection.eq(transaction.selection)) {
        const selection = $261217e2130b18ac$export$3c0bb68e76442a1e(prevSelection, transaction.doc);
        if (selection) transaction.setSelection(selection);
    }
    const positionsLess = {
        ...(0, $5vS9r.getPluginState)(editorView.state).positions
    };
    delete positionsLess[key];
    await (0, $5Edew.updateState)({
        positions: positionsLess
    })(editorView.state, editorView.dispatch);
    editorView.dispatch(transaction);
}

});
parcelRegister("bvqke", function(module, exports) {
$parcel$export(module.exports, "default", () => $a836fc9159e09d43$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $ieUrC = parcelRequire("ieUrC");

var $bcN2K = parcelRequire("bcN2K");

var $dKART = parcelRequire("dKART");

const $a836fc9159e09d43$var$loadConfigPanel = ()=>(parcelRequire("fDxSY")).then((module)=>module.default);

const $a836fc9159e09d43$var$ConfigPanelLazy = (0, $ieUrC.lazy)(()=>(parcelRequire("fDxSY")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-plugin-extension/src/ui/ConfigPanel/ConfigPanelFieldsLoader.tsx"
});
const $a836fc9159e09d43$var$ConfigPanelLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: $a836fc9159e09d43$var$loadConfigPanel,
    loading: (0, $dKART.default)
});
const $a836fc9159e09d43$var$_default_1 = (props)=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ieUrC.LazySuspense), {
        fallback: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dKART.default), {}),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($a836fc9159e09d43$var$ConfigPanelLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $3LM7S.jsx)($a836fc9159e09d43$var$ConfigPanelLoadable, {
        ...props
    });
$a836fc9159e09d43$var$_default_1.preload = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $a836fc9159e09d43$var$ConfigPanelLazy.preload() : $a836fc9159e09d43$var$ConfigPanelLoadable.preload();
var $a836fc9159e09d43$export$2e2bcd8739ae039 = $a836fc9159e09d43$var$_default_1;

});
parcelRegister("dKART", function(module, exports) {
$parcel$export(module.exports, "default", () => $96b8793ce36b97aa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $1OjU8 = parcelRequire("1OjU8");

var $dtvmL = parcelRequire("dtvmL");

var $hculA = parcelRequire("hculA");
function $96b8793ce36b97aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $96b8793ce36b97aa$var$spinnerWrapperStyles = {
    name: "kcqyy5",
    styles: "display:flex;justify-content:center;margin-top:var(--ds-space-800, 64px)"
};
const $96b8793ce36b97aa$var$errorWrapperStyles = {
    name: "1siebwf",
    styles: "margin-top:var(--ds-space-400, 32px)"
};
const $96b8793ce36b97aa$var$LoadingStateWithErrorHandling = (0, $fcCIH.default)((props)=>{
    if (props.error) return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $96b8793ce36b97aa$var$errorWrapperStyles,
        "data-testid": "ConfigPanelLoadingError"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $dtvmL.default), {
        appearance: "error"
    }, props.intl.formatMessage((0, $1OjU8.messages).panelLoadingError)));
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $96b8793ce36b97aa$var$spinnerWrapperStyles,
        "data-testid": "ConfigPanelLoading"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $hculA.default), {
        size: "small",
        interactionName: "config-panel-spinner"
    }));
});
const $96b8793ce36b97aa$var$LoadingState = (props)=>$96b8793ce36b97aa$var$LoadingStateWithErrorHandling(props);
var $96b8793ce36b97aa$export$2e2bcd8739ae039 = $96b8793ce36b97aa$var$LoadingState;

});

parcelRegister("fDxSY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("6142a"),
    $9dnsd("fUarJ"),
    $9dnsd("cs6V2"),
    $9dnsd("kHZSd"),
    $9dnsd("6wm2n")
]).then(()=>parcelRequire('7KMJ5'));

});


parcelRegister("7sUHN", function(module, exports) {
$parcel$export(module.exports, "SaveIndicator", () => $f5c4c4481a6c9934$export$7ceebdb305e167df);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fd880 = parcelRequire("fd880");

var $1OjU8 = parcelRequire("1OjU8");

var $fBVBf = parcelRequire("fBVBf");

var $5a4EU = parcelRequire("5a4EU");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");
function $f5c4c4481a6c9934$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f5c4c4481a6c9934$var$noop = ()=>{};
const $f5c4c4481a6c9934$var$saveIndicatorWrapperStyles = {
    name: "zl1inp",
    styles: "display:flex;justify-content:center"
};
const $f5c4c4481a6c9934$var$saveIndicatorContentStyles = /*#__PURE__*/ (0, $jctmk.css)({
    position: 'fixed',
    width: '256px',
    bottom: "var(--ds-space-250, 20px)",
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    background: "var(--ds-surface-overlay, #FFFFFF)",
    /* E300 */ boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    borderRadius: "var(--ds-radius-xxlarge, 16px)"
});
const $f5c4c4481a6c9934$var$saveIndicatorTextStyles = (0, $kig2V.xcss)({
    paddingLeft: 'space.075'
});
const $f5c4c4481a6c9934$export$7ceebdb305e167df = ({ children: children, duration: duration, visible: visible = true })=>{
    const [saving, setSaving] = (0, $fc4bM.useState)(false);
    const shown = (0, $fc4bM.useRef)(false);
    const onSaveStarted = (0, $fc4bM.useCallback)(()=>{
        if (!shown.current) {
            setSaving(true);
            shown.current = true;
        }
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        if (saving) {
            const handleId = setTimeout(()=>{
                setSaving(false);
            }, duration);
            return ()=>clearTimeout(handleId);
        }
    }, [
        saving,
        duration
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)("div", null, children({
        onSaveStarted: onSaveStarted,
        onSaveEnded: $f5c4c4481a6c9934$var$noop
    })), visible && saving && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $f5c4c4481a6c9934$var$saveIndicatorWrapperStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $f5c4c4481a6c9934$var$saveIndicatorContentStyles,
        "data-testid": "save-indicator-content"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fBVBf))), {
        label: "Saving",
        color: "var(--ds-icon-success, #6A9A23)",
        spacing: "none"
    }), /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
        xcss: $f5c4c4481a6c9934$var$saveIndicatorTextStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $4T8rw.Text), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $fd880.default), (0, $1OjU8.messages).saveIndicator))))));
};

});


parcelRegister("eZJFp", function(module, exports) {
$parcel$export(module.exports, "useConfigPanelPluginHook", () => $1f60aa162af7983f$export$781dfcd068e3a2e0);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $1fO1j = parcelRequire("1fO1j");

var $9oAqi = parcelRequire("9oAqi");

var $dBtOK = parcelRequire("dBtOK");

var $5Edew = parcelRequire("5Edew");

var $5vS9r = parcelRequire("5vS9r");

var $83R7C = parcelRequire("83R7C");

var $bvqke = parcelRequire("bvqke");

var $aLKBL = parcelRequire("aLKBL");

var $euoH1 = parcelRequire("euoH1");

var $iyafl = parcelRequire("iyafl");

var $40e3d = parcelRequire("40e3d");

var $7sUHN = parcelRequire("7sUHN");
const $1f60aa162af7983f$var$selector = (states)=>{
    var _states$extensionStat, _states$extensionStat2, _states$extensionStat3;
    return {
        showContextPanel: (_states$extensionStat = states.extensionState) === null || _states$extensionStat === void 0 ? void 0 : _states$extensionStat.showContextPanel,
        extensionProvider: (_states$extensionStat2 = states.extensionState) === null || _states$extensionStat2 === void 0 ? void 0 : _states$extensionStat2.extensionProvider,
        processParametersAfter: (_states$extensionStat3 = states.extensionState) === null || _states$extensionStat3 === void 0 ? void 0 : _states$extensionStat3.processParametersAfter
    };
};
function $1f60aa162af7983f$export$781dfcd068e3a2e0({ editorView: editorView, configPanelId: configPanelId, api: api }) {
    const editorState = editorView.state;
    const { showContextPanel: showContextPanel, extensionProvider: extensionProvider, processParametersAfter: processParametersAfter } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'extension'
    ], $1f60aa162af7983f$var$selector);
    (0, $fc4bM.useEffect)(()=>{
        const nodeWithPos = (0, $83R7C.getSelectedExtension)(editorState, true);
        // Adding checks to bail out early
        if (!nodeWithPos) {
            $1f60aa162af7983f$export$2a2eb89a1c258b39(configPanelId, api);
            return;
        }
        if (showContextPanel && extensionProvider && processParametersAfter) $1f60aa162af7983f$export$e4eb3d5da2de4919({
            api: api,
            configPanelId: configPanelId,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        else $1f60aa162af7983f$export$2a2eb89a1c258b39(configPanelId, api);
    }, [
        api,
        configPanelId,
        editorState,
        editorView,
        showContextPanel,
        extensionProvider,
        processParametersAfter
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            $1f60aa162af7983f$export$2a2eb89a1c258b39(configPanelId, api);
        };
    }, [
        api,
        configPanelId
    ]);
}
function $1f60aa162af7983f$export$2a2eb89a1c258b39(configPanelId, api) {
    var _api$contextPanel;
    const closePanelById = api === null || api === void 0 || (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 || (_api$contextPanel = _api$contextPanel.actions) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.closePanelById;
    if (closePanelById) closePanelById(configPanelId);
}
function $1f60aa162af7983f$export$e4eb3d5da2de4919({ api: api, configPanelId: configPanelId, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos }) {
    var _api$contextPanel2;
    const showContextPanel = api === null || api === void 0 || (_api$contextPanel2 = api.contextPanel) === null || _api$contextPanel2 === void 0 || (_api$contextPanel2 = _api$contextPanel2.actions) === null || _api$contextPanel2 === void 0 ? void 0 : _api$contextPanel2.showPanel;
    if (showContextPanel) {
        const nodeAttrs = nodeWithPos === null || nodeWithPos === void 0 ? void 0 : nodeWithPos.node.attrs;
        const extensionType = nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.extensionType;
        const extensionKey = nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.extensionKey;
        /**
     * Loading extension manifest fails when using
     * 	extensionKey directly from nodeAttrs.
     * Always get extensionKey from getExtensionKeyAndNodeKey to load
     * 	extension manifest successfully.
     */ const [extKey, _] = (0, $1fO1j.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
        const HeadeIconWrapper = ()=>{
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iyafl.default), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const HeaderAfterIconElementWrapper = ()=>{
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $euoH1.default), {
                extensionProvider: extensionProvider,
                extensionKey: extKey,
                extensionType: extensionType
            });
        };
        const BodyComponent = $1f60aa162af7983f$export$768c11fa806367e7({
            api: api,
            editorView: editorView,
            extensionProvider: extensionProvider,
            nodeWithPos: nodeWithPos
        });
        showContextPanel({
            id: configPanelId,
            headerComponentElements: {
                HeaderIcon: HeadeIconWrapper,
                HeaderAfterIconElement: HeaderAfterIconElementWrapper
            },
            BodyComponent: BodyComponent,
            closeOptions: {
                canClosePanel: async ()=>{
                    // When navigating away from the editor, the editorView is destroyed.
                    if (editorView.isDestroyed) return true;
                    const extensionState = (0, $5vS9r.getPluginState)(editorView.state);
                    /**
           * 	If context panel is open, then first update extension plugin state.
           * 	Updating extension plugin state will trigger useEffect in useConfigPanelPluginHook,
           * 		which will call hideConfigPanel.
           */ if (extensionState !== null && extensionState !== void 0 && extensionState.showContextPanel) {
                        await $1f60aa162af7983f$export$237eef05f48e1226({
                            api: api,
                            editorView: editorView
                        });
                        return false;
                    }
                    // Return true if extension plugin state has been updated and hideConfigPanel has been called.
                    return true;
                }
            }
        }, 'push', (0, $aLKBL.CONFIG_PANEL_WIDTH));
    }
}
async function $1f60aa162af7983f$export$237eef05f48e1226({ api: api, editorView: editorView }) {
    var _api$contextPanel3;
    const applyChange = api === null || api === void 0 || (_api$contextPanel3 = api.contextPanel) === null || _api$contextPanel3 === void 0 ? void 0 : _api$contextPanel3.actions.applyChange;
    // Even if the save failed, we should proceed with closing the panel
    (0, $5Edew.clearEditingContext)(applyChange)(editorView.state, editorView.dispatch);
    try {
        await new Promise((resolve, reject)=>{
            (0, $5Edew.forceAutoSave)(applyChange)(resolve, reject)(editorView.state, editorView.dispatch);
        });
    } catch (e) {
        // Even if the save failed, we should proceed with closing the panel
        // eslint-disable-next-line no-console
        console.error(`Autosave failed with error`, e);
    }
}
const $1f60aa162af7983f$export$768c11fa806367e7 = ({ api: api, editorView: editorView, extensionProvider: extensionProvider, nodeWithPos: nodeWithPos })=>{
    var _api$featureFlags;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const editorState = editorView.state;
    const extensionState = (0, $5vS9r.getPluginState)(editorState);
    const { autoSaveResolve: autoSaveResolve, autoSaveReject: autoSaveReject, processParametersBefore: processParametersBefore } = extensionState;
    const { extensionType: extensionType, extensionKey: extensionKey, parameters: parameters } = nodeWithPos.node.attrs;
    const [extKey, nodeKey] = (0, $1fO1j.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const configParams = processParametersBefore ? processParametersBefore(parameters || {}) : parameters;
    return ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
            padding: "space.200",
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7sUHN.SaveIndicator), {
                duration: 5000,
                visible: true,
                children: ({ onSaveStarted: onSaveStarted, onSaveEnded: onSaveEnded })=>{
                    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bvqke.default), {
                        api: api,
                        showHeader: true,
                        closeOnEsc: true,
                        extensionType: extensionType,
                        extensionKey: extKey,
                        nodeKey: nodeKey,
                        extensionParameters: parameters,
                        parameters: configParams,
                        extensionProvider: extensionProvider,
                        autoSaveTrigger: autoSaveResolve,
                        autoSaveReject: autoSaveReject,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: async (updatedParameters)=>{
                            await (0, $40e3d.onChangeAction)(editorView, updatedParameters, parameters, nodeWithPos, onSaveStarted);
                            onSaveEnded();
                            if (autoSaveResolve) autoSaveResolve();
                        },
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onCancel: ()=>$1f60aa162af7983f$export$237eef05f48e1226({
                                api: api,
                                editorView: editorView
                            }),
                        featureFlags: featureFlags,
                        usingObjectSidebarPanel: true
                    });
                }
            })
        });
};

});
parcelRegister("euoH1", function(module, exports) {
$parcel$export(module.exports, "default", () => $77c980b21d20bb09$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5a4EU = parcelRequire("5a4EU");

var $1JdzP = parcelRequire("1JdzP");

var $kig2V = parcelRequire("kig2V");

var $9CmsK = parcelRequire("9CmsK");
const $77c980b21d20bb09$var$itemBodyStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    margin: 'space.200',
    flexGrow: 3
});
const $77c980b21d20bb09$var$itemTextStyles = (0, $kig2V.xcss)({
    maxWidth: '100%',
    whiteSpace: 'initial'
});
const $77c980b21d20bb09$var$summaryStyles = (0, $kig2V.xcss)({
    font: 'font.body.small',
    color: 'color.text.subtlest',
    marginTop: 'space.050',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
function $77c980b21d20bb09$var$HeaderAfterIconElement({ extensionManifest: extensionManifest }) {
    const title = extensionManifest.title;
    const summary = extensionManifest.summary;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        xcss: $77c980b21d20bb09$var$itemBodyStyles,
        children: summary ? /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5a4EU.Box), {
            xcss: $77c980b21d20bb09$var$itemTextStyles,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    id: "context-panel-title",
                    "data-testid": "context-panel-title",
                    children: title
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
                    xcss: $77c980b21d20bb09$var$summaryStyles,
                    children: summary
                })
            ]
        }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1JdzP.Flex), {
            direction: "column",
            alignItems: "center",
            testId: "context-panel-title",
            children: title
        })
    });
}
const $77c980b21d20bb09$var$_default_1 = (0, $9CmsK.withExtensionManifest)($77c980b21d20bb09$var$HeaderAfterIconElement);
var $77c980b21d20bb09$export$2e2bcd8739ae039 = $77c980b21d20bb09$var$_default_1;

});
parcelRegister("9CmsK", function(module, exports) {
$parcel$export(module.exports, "withExtensionManifest", () => $414bb2e8803665cc$export$7dd73e517d9d8a3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $6zJg9 = parcelRequire("6zJg9");
function $414bb2e8803665cc$export$7dd73e517d9d8a3(WrappedComponent) {
    return function WithExtensionManifest(props) {
        const { extensionKey: extensionKey, extensionProvider: extensionProvider, extensionType: extensionType, ...restProps } = props;
        const [extensionManifest] = (0, $6zJg9.useStateFromPromise)(()=>extensionProvider.getExtension(extensionType, extensionKey), [
            extensionProvider,
            extensionType,
            extensionKey
        ]);
        return extensionManifest ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $3LM7S.jsx)(WrappedComponent, {
            extensionManifest: extensionManifest,
            ...restProps
        }) : null;
    };
}

});
parcelRegister("6zJg9", function(module, exports) {
$parcel$export(module.exports, "useStateFromPromise", () => $fa748efd768f97c2$export$4960a9d54b2095bb);

var $fc4bM = parcelRequire("fc4bM");

var $1tDKj = parcelRequire("1tDKj");
function $fa748efd768f97c2$export$4960a9d54b2095bb(callback, deps, initialValue) {
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $fc4bM.useCallback)(callback, deps);
    const [value, setValue] = (0, $fc4bM.useState)(initialValue);
    (0, $1tDKj.useAbortableEffect)((signal)=>{
        Promise.resolve(fn()).then((result)=>{
            if (signal.aborted) return;
            setValue(result);
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        ...deps
    ]);
    return [
        value,
        setValue
    ];
}

});
parcelRegister("1tDKj", function(module, exports) {
$parcel$export(module.exports, "useAbortableEffect", () => $c29805b5b7a08a31$export$daf4e774a28efe06);

var $fc4bM = parcelRequire("fc4bM");
const $c29805b5b7a08a31$var$safeError = (message)=>{
    // eslint-disable-next-line no-console
    console.error(message);
};
const $c29805b5b7a08a31$var$createAbortController = ()=>{
    if (typeof AbortController === 'undefined') $c29805b5b7a08a31$var$safeError('Missing AbortController');
    return new AbortController();
};
function $c29805b5b7a08a31$export$daf4e774a28efe06(callback, deps) {
    const abortController = (0, $fc4bM.useMemo)(()=>$c29805b5b7a08a31$var$createAbortController(), // eslint-disable-next-line react-hooks/exhaustive-deps
    deps);
    const abort = (0, $fc4bM.useCallback)(()=>abortController.abort(), [
        abortController
    ]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fn = (0, $fc4bM.useCallback)(callback, deps);
    (0, $fc4bM.useEffect)(()=>{
        const teardown = fn(abortController.signal);
        return ()=>{
            if (typeof teardown === 'function') teardown();
            abort();
        };
    }, [
        abortController,
        abort,
        fn,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        ...deps
    ]);
}

});




parcelRegister("iyafl", function(module, exports) {
$parcel$export(module.exports, "default", () => $b05cc5f509d85acc$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $9CmsK = parcelRequire("9CmsK");
const $b05cc5f509d85acc$var$iconWidth = '40px';
const $b05cc5f509d85acc$var$itemIconStyles = (0, $kig2V.xcss)({
    width: $b05cc5f509d85acc$var$iconWidth,
    height: $b05cc5f509d85acc$var$iconWidth,
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
function $b05cc5f509d85acc$var$HeaderIcon({ extensionManifest: extensionManifest }) {
    const icon = extensionManifest.icons['48'];
    const title = extensionManifest.title;
    const ResolvedIcon = (0, $fc4bM.useMemo)(()=>{
        return /*#__PURE__*/ (0, $fc4bM.lazy)(()=>icon().then((Cmp)=>{
                if ('default' in Cmp) return Cmp;
                return {
                    default: Cmp
                };
            }));
    }, [
        icon
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        xcss: $b05cc5f509d85acc$var$itemIconStyles,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)(ResolvedIcon, {
                label: title
            })
        })
    });
}
const $b05cc5f509d85acc$var$_default_1 = (0, $9CmsK.withExtensionManifest)($b05cc5f509d85acc$var$HeaderIcon);
var $b05cc5f509d85acc$export$2e2bcd8739ae039 = $b05cc5f509d85acc$var$_default_1;

});



parcelRegister("fNb8m", function(module, exports) {
$parcel$export(module.exports, "findReplacePlugin", () => $2565b93712b30b18$export$e5ceda4aabe9bb08);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $1y7gE = parcelRequire("1y7gE");

var $l8sw8 = parcelRequire("l8sw8");

var $bKWnN = parcelRequire("bKWnN");

var $kaRof = parcelRequire("kaRof");

var $jB8vP = parcelRequire("jB8vP");

var $5MAgC = parcelRequire("5MAgC");

var $arGD1 = parcelRequire("arGD1");

var $kngxQ = parcelRequire("kngxQ");

var $7AqtG = parcelRequire("7AqtG");

var $40ZQK = parcelRequire("40ZQK");

var $ir1il = parcelRequire("ir1il");
const $2565b93712b30b18$export$e5ceda4aabe9bb08 = ({ config: props, api: api })=>{
    var _api$primaryToolbar;
    const editorViewRef = {
        current: null
    };
    const toolbarButtonRegisteredExternally = {
        current: false
    };
    const primaryToolbarComponent = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
        if (!editorView) return null;
        const isButtonHidden = toolbarSize < (0, $l8sw8.ToolbarSize).XL;
        if (props !== null && props !== void 0 && props.twoLineEditorToolbar) return null;
        else if (toolbarButtonRegisteredExternally.current && (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) return null;
        else return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ir1il.default), {
            popupsBoundariesElement: popupsBoundariesElement,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            containerElement: containerElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            takeFullWidth: props === null || props === void 0 ? void 0 : props.takeFullWidth,
            api: api,
            isButtonHidden: isButtonHidden
        });
    };
    api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
        name: 'findReplace',
        component: primaryToolbarComponent
    });
    return {
        name: 'findReplace',
        pmPlugins () {
            const plugins = [
                {
                    name: 'findReplace',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $kngxQ.createPlugin)(dispatch, getIntl, api)
                },
                {
                    name: 'findReplaceKeymap',
                    plugin: ()=>{
                        var _api$analytics;
                        return (0, $arGD1.default)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api === null || api === void 0 ? void 0 : api.editorViewMode);
                    }
                }
            ];
            if (api !== null && api !== void 0 && api.editorViewMode && (0, $bKWnN.UNSAFE_expValNoExposure)('platform_editor_collapsible_headings', 'isEnabled', false)) plugins.push({
                name: 'findReplaceViewModeShortcut',
                plugin: ()=>(0, $40ZQK.viewModeShortcutPlugin)(api)
            });
            if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'findReplaceEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $1y7gE.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $7AqtG.findReplacePluginKey).getState(editorState) || undefined;
        },
        actions: {
            registerToolbarButton: ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
                toolbarButtonRegisteredExternally.current = (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1');
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ir1il.default), {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    editorView: editorView,
                    containerElement: containerElement,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    api: api
                });
            },
            activateFindReplace: (triggerMethod)=>{
                var _api$analytics2;
                if (!editorViewRef.current) return false;
                const { state: state, dispatch: dispatch } = editorViewRef.current;
                if (api !== null && api !== void 0 && (_api$analytics2 = api.analytics) !== null && _api$analytics2 !== void 0 && _api$analytics2.actions) {
                    var _api$analytics3;
                    (0, $5MAgC.activateWithAnalytics)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, api === null || api === void 0 ? void 0 : api.editorViewMode)({
                        triggerMethod: triggerMethod || (0, $3LeME.TRIGGER_METHOD).EXTERNAL
                    })(state, dispatch);
                } else (0, $jB8vP.activate)()(state, dispatch);
                return true;
            }
        },
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined,
        contentComponent: (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
            if (toolbarButtonRegisteredExternally.current || !editorView) return null;
            const popupsMountPointEl = popupsMountPoint || // eslint-disable-next-line @atlaskit/editor/no-as-casting
            (wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.querySelector("[data-editor-container='true']"));
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ir1il.default), {
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPointEl,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined,
                isToolbarReducedSpacing: false,
                editorView: editorView,
                containerElement: containerElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                takeFullWidth: props === null || props === void 0 ? void 0 : props.takeFullWidth,
                api: api,
                doesNotHaveButton: true
            });
        } : undefined
    };
};

});
parcelRegister("jB8vP", function(module, exports) {
$parcel$export(module.exports, "activate", () => $3379d40de0691dac$export$234c45b355edd85b);
$parcel$export(module.exports, "find", () => $3379d40de0691dac$export$71aa6c912b956294);
$parcel$export(module.exports, "findNext", () => $3379d40de0691dac$export$ebdf538520f8717);
$parcel$export(module.exports, "findPrevious", () => $3379d40de0691dac$export$eef4841c27f82c55);
$parcel$export(module.exports, "replace", () => $3379d40de0691dac$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "replaceAll", () => $3379d40de0691dac$export$b8b3234b4edfc4c2);
$parcel$export(module.exports, "cancelSearch", () => $3379d40de0691dac$export$58f3f9b95b84be3c);
$parcel$export(module.exports, "blur", () => $3379d40de0691dac$export$2cc7ff91bcacba5e);
$parcel$export(module.exports, "toggleMatchCase", () => $3379d40de0691dac$export$4e987d48fa8a04d7);

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $7iyqH = parcelRequire("7iyqH");

var $frhqo = parcelRequire("frhqo");

var $cM5jl = parcelRequire("cM5jl");

var $hMQPe = parcelRequire("hMQPe");

var $j6kgt = parcelRequire("j6kgt");
const $3379d40de0691dac$export$234c45b355edd85b = ()=>(0, $frhqo.createCommand)((state)=>{
        const { selection: selection } = state;
        let findText;
        let matches;
        let index;
        // if user has selected text and hit cmd-f, set that as the keyword
        if (selection instanceof (0, $801jp.TextSelection) && !selection.empty) {
            findText = (0, $cM5jl.getSelectedText)(selection);
            const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $frhqo.getPluginState)(state);
            matches = (0, $cM5jl.findMatches)({
                content: state.doc,
                searchText: findText,
                shouldMatchCase: shouldMatchCase,
                getIntl: getIntl,
                api: api
            });
            index = (0, $cM5jl.findClosestMatch)(selection.from, matches);
        }
        return {
            type: (0, $7iyqH.FindReplaceActionTypes).ACTIVATE,
            findText: findText,
            matches: matches,
            index: index
        };
    });
const $3379d40de0691dac$export$71aa6c912b956294 = (editorView, containerElement, keyword)=>(0, $j6kgt.withScrollIntoView)((0, $frhqo.createCommand)((state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $frhqo.getPluginState)(state);
        const matches = keyword !== undefined ? (0, $cM5jl.findMatches)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        const index = (0, $cM5jl.findClosestMatch)(selection.from, matches);
        // we can't just apply all the decorations to highlight the search results at once
        // as if there are a lot ProseMirror cries :'(
        (0, $hMQPe.default).applyAllSearchDecorations(editorView, containerElement, (decorations)=>$3379d40de0691dac$export$e17d1d1acde229e1(decorations)(editorView.state, editorView.dispatch), (decorations)=>$3379d40de0691dac$export$f9e1c8eeab9872dc(decorations)(editorView.state, editorView.dispatch));
        return {
            type: (0, $7iyqH.FindReplaceActionTypes).FIND,
            findText: keyword || '',
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { selection: selection } = state;
        const { shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = (0, $frhqo.getPluginState)(state);
        const matches = keyword !== undefined ? (0, $cM5jl.findMatches)({
            content: state.doc,
            searchText: keyword,
            shouldMatchCase: shouldMatchCase,
            getIntl: getIntl,
            api: api
        }) : [];
        if (matches.length > 0) {
            var _api$expand;
            const index = (0, $cM5jl.findClosestMatch)(selection.from, matches);
            const newSelection = (0, $cM5jl.getSelectionForMatch)(tr.selection, tr.doc, index, matches);
            api === null || api === void 0 || (_api$expand = api.expand) === null || _api$expand === void 0 || _api$expand.commands.toggleExpandWithMatch(newSelection)({
                tr: tr
            });
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings')) {
                var _api$blockCollapse;
                api === null || api === void 0 || (_api$blockCollapse = api.blockCollapse) === null || _api$blockCollapse === void 0 || _api$blockCollapse.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
                    tr: tr
                });
            }
            return tr.setSelection(newSelection);
        }
        return tr;
    }));
const $3379d40de0691dac$export$ebdf538520f8717 = (editorView)=>(0, $j6kgt.withScrollIntoView)((0, $frhqo.createCommand)((state)=>$3379d40de0691dac$var$findInDirection(state, 'next'), (tr, state)=>{
        var _api$expand2;
        const { matches: matches, index: index, api: api } = (0, $frhqo.getPluginState)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find next operation should look for the first match forward starting
        // from the current cursor position)
        let searchIndex = (0, $cM5jl.findSearchIndex)(state.selection.from, matches);
        if (searchIndex === index) // cursor has not moved, so we just want to find the next in matches array
        searchIndex = (0, $cM5jl.nextIndex)(searchIndex, matches.length);
        const newSelection = (0, $cM5jl.getSelectionForMatch)(tr.selection, tr.doc, searchIndex, matches);
        api === null || api === void 0 || (_api$expand2 = api.expand) === null || _api$expand2 === void 0 || _api$expand2.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings')) {
            var _api$blockCollapse2;
            api === null || api === void 0 || (_api$blockCollapse2 = api.blockCollapse) === null || _api$blockCollapse2 === void 0 || _api$blockCollapse2.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
                tr: tr
            });
        }
        return tr.setSelection(newSelection);
    }));
const $3379d40de0691dac$export$eef4841c27f82c55 = (editorView)=>(0, $j6kgt.withScrollIntoView)((0, $frhqo.createCommand)((state)=>$3379d40de0691dac$var$findInDirection(state, 'previous'), (tr, state)=>{
        var _api$expand3;
        const { matches: matches, api: api } = (0, $frhqo.getPluginState)(state);
        // can't use index from plugin state because if the cursor has moved, it will still be the
        // OLD index (the find prev operation should look for the first match backward starting
        // from the current cursor position)
        const searchIndex = (0, $cM5jl.findSearchIndex)(state.selection.from, matches, true);
        const newSelection = (0, $cM5jl.getSelectionForMatch)(tr.selection, tr.doc, searchIndex, matches);
        api === null || api === void 0 || (_api$expand3 = api.expand) === null || _api$expand3 === void 0 || _api$expand3.commands.toggleExpandWithMatch(newSelection)({
            tr: tr
        });
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings')) {
            var _api$blockCollapse3;
            api === null || api === void 0 || (_api$blockCollapse3 = api.blockCollapse) === null || _api$blockCollapse3 === void 0 || _api$blockCollapse3.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
                tr: tr
            });
        }
        return tr.setSelection(newSelection);
    }));
const $3379d40de0691dac$var$findInDirection = (state, dir)=>{
    const pluginState = (0, $frhqo.getPluginState)(state);
    const { matches: matches, findText: findText } = pluginState;
    let { decorationSet: decorationSet, index: index } = pluginState;
    if (findText) {
        const searchIndex = (0, $cM5jl.findSearchIndex)(state.selection.from, matches, dir === 'previous');
        // compare index from plugin state and index of first match forward from cursor position
        if (index === searchIndex) // normal case, cycling through matches
        index = dir === 'next' ? (0, $cM5jl.nextIndex)(index, matches.length) : (0, $cM5jl.prevIndex)(index, matches.length);
        else // cursor has moved
        index = searchIndex;
        decorationSet = $3379d40de0691dac$var$updateSelectedHighlight(state, index);
    }
    return {
        type: dir === 'next' ? (0, $7iyqH.FindReplaceActionTypes).FIND_NEXT : (0, $7iyqH.FindReplaceActionTypes).FIND_PREVIOUS,
        index: index,
        decorationSet: decorationSet
    };
};
const $3379d40de0691dac$export$77ad94ebf1c2b9ed = (replaceText)=>(0, $j6kgt.withScrollIntoView)((0, $frhqo.createCommand)((state)=>{
        const pluginState = (0, $frhqo.getPluginState)(state);
        const { findText: findText, matches: matches } = pluginState;
        let { decorationSet: decorationSet, index: index } = pluginState;
        decorationSet = $3379d40de0691dac$var$updateSelectedHighlight(state, (0, $cM5jl.nextIndex)(index, matches.length));
        if (replaceText.toLowerCase().indexOf(findText.toLowerCase()) === -1) {
            decorationSet = (0, $cM5jl.removeMatchesFromSet)(decorationSet, [
                matches[index]
            ], state.doc);
            matches.splice(index, 1);
            if (index > matches.length - 1) index = 0;
        } else index = (0, $cM5jl.nextIndex)(index, matches.length);
        return {
            type: (0, $7iyqH.FindReplaceActionTypes).REPLACE,
            replaceText: replaceText,
            decorationSet: decorationSet,
            matches: matches,
            index: index
        };
    }, (tr, state)=>{
        const { matches: matches, index: index, findText: findText, api: api } = (0, $frhqo.getPluginState)(state);
        if (matches[index]) {
            if (!matches[index].canReplace) return tr;
            const { start: start, end: end } = matches[index];
            const newIndex = (0, $cM5jl.nextIndex)(index, matches.length);
            tr.insertText(replaceText, start, end);
            const newSelection = (0, $cM5jl.getSelectionForMatch)(tr.selection, tr.doc, newIndex, matches, newIndex === 0 ? 0 : replaceText.length - findText.length);
            tr.setSelection(newSelection);
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_collapsible_headings')) {
                var _api$blockCollapse4;
                api === null || api === void 0 || (_api$blockCollapse4 = api.blockCollapse) === null || _api$blockCollapse4 === void 0 || _api$blockCollapse4.commands.expandHeadingsContainingRange(newSelection.from, newSelection.to)({
                    tr: tr
                });
            }
        }
        return tr;
    }));
const $3379d40de0691dac$export$b8b3234b4edfc4c2 = (replaceText)=>(0, $frhqo.createCommand)({
        type: (0, $7iyqH.FindReplaceActionTypes).REPLACE_ALL,
        replaceText: replaceText,
        decorationSet: (0, $16ZMX.DecorationSet).empty,
        matches: [],
        index: 0
    }, (tr, state)=>{
        const pluginState = (0, $frhqo.getPluginState)(state);
        pluginState.matches.forEach((match)=>{
            if (!match.canReplace) return tr;
            tr.insertText(replaceText, tr.mapping.map(match.start), tr.mapping.map(match.end));
        });
        tr.setMeta('scrollIntoView', false);
        return tr;
    });
const $3379d40de0691dac$export$e17d1d1acde229e1 = (decorations)=>(0, $frhqo.createCommand)((state)=>{
        const { decorationSet: decorationSet } = (0, $frhqo.getPluginState)(state);
        return {
            type: (0, $7iyqH.FindReplaceActionTypes).UPDATE_DECORATIONS,
            decorationSet: decorationSet.add(state.doc, decorations)
        };
    });
const $3379d40de0691dac$export$f9e1c8eeab9872dc = (decorations)=>(0, $frhqo.createCommand)((state)=>{
        const { decorationSet: decorationSet } = (0, $frhqo.getPluginState)(state);
        return {
            type: (0, $7iyqH.FindReplaceActionTypes).UPDATE_DECORATIONS,
            decorationSet: (0, $cM5jl.removeDecorationsFromSet)(decorationSet, decorations, state.doc)
        };
    });
const $3379d40de0691dac$export$58f3f9b95b84be3c = ()=>(0, $frhqo.createCommand)(()=>{
        (0, $hMQPe.default).stop();
        return {
            type: (0, $7iyqH.FindReplaceActionTypes).CANCEL
        };
    });
const $3379d40de0691dac$export$2cc7ff91bcacba5e = ()=>(0, $frhqo.createCommand)({
        type: (0, $7iyqH.FindReplaceActionTypes).BLUR
    });
const $3379d40de0691dac$export$4e987d48fa8a04d7 = ()=>(0, $frhqo.createCommand)({
        type: (0, $7iyqH.FindReplaceActionTypes).TOGGLE_MATCH_CASE
    });
const $3379d40de0691dac$var$updateSelectedHighlight = (state, nextSelectedIndex)=>{
    const { index: index, matches: matches } = (0, $frhqo.getPluginState)(state);
    let { decorationSet: decorationSet } = (0, $frhqo.getPluginState)(state);
    const currentSelectedMatch = matches[index];
    const nextSelectedMatch = matches[nextSelectedIndex];
    if (index === nextSelectedIndex) return decorationSet;
    const currentSelectedDecoration = (0, $cM5jl.findDecorationFromMatch)(decorationSet, currentSelectedMatch);
    const nextSelectedDecoration = (0, $cM5jl.findDecorationFromMatch)(decorationSet, nextSelectedMatch);
    // Update decorations so the current selected match becomes a normal match
    // and the next selected gets the selected styling
    const decorationsToRemove = [];
    if (currentSelectedDecoration) decorationsToRemove.push(currentSelectedDecoration);
    if (nextSelectedDecoration) decorationsToRemove.push(nextSelectedDecoration);
    if (decorationsToRemove.length > 0) {
        // removeDecorationsFromSet depends on decorations being pre-sorted
        decorationsToRemove.sort((a, b)=>a.from < b.from ? -1 : 1);
        decorationSet = (0, $cM5jl.removeDecorationsFromSet)(decorationSet, decorationsToRemove, state.doc);
    }
    if (currentSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $cM5jl.createDecoration)(currentSelectedMatch)
    ]);
    if (nextSelectedMatch) decorationSet = decorationSet.add(state.doc, [
        (0, $cM5jl.createDecoration)(nextSelectedMatch, true)
    ]);
    return decorationSet;
};

});
parcelRegister("7iyqH", function(module, exports) {
$parcel$export(module.exports, "FindReplaceActionTypes", () => $f8ce0b0bf3fa57a9$export$29dff82773c5f10f);
var $f8ce0b0bf3fa57a9$export$29dff82773c5f10f = /*#__PURE__*/ function(FindReplaceActionTypes) {
    FindReplaceActionTypes["ACTIVATE"] = "ACTIVATE";
    FindReplaceActionTypes["FIND"] = "FIND";
    FindReplaceActionTypes["UPDATE_DECORATIONS"] = "UPDATE_DECORATIONS";
    FindReplaceActionTypes["FIND_NEXT"] = "FIND_NEXT";
    FindReplaceActionTypes["FIND_PREVIOUS"] = "FIND_PREVIOUS";
    FindReplaceActionTypes["REPLACE"] = "REPLACE";
    FindReplaceActionTypes["REPLACE_ALL"] = "REPLACE_ALL";
    FindReplaceActionTypes["CANCEL"] = "CANCEL";
    FindReplaceActionTypes["BLUR"] = "BLUR";
    FindReplaceActionTypes["TOGGLE_MATCH_CASE"] = "TOGGLE_MATCH_CASE";
    return FindReplaceActionTypes;
}({});

});

parcelRegister("frhqo", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $630759e5e7206712$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $630759e5e7206712$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $630759e5e7206712$export$656c7661095efe2e);

var $hG5QM = parcelRequire("hG5QM");

var $92jIL = parcelRequire("92jIL");

var $16ZMX = parcelRequire("16ZMX");

var $kngxQ = parcelRequire("kngxQ");

var $7AqtG = parcelRequire("7AqtG");

var $3mrAc = parcelRequire("3mrAc");

var $cM5jl = parcelRequire("cM5jl");
const $630759e5e7206712$var$handleDocChanged = (tr, pluginState)=>{
    var _api$expand;
    const { isActive: isActive, findText: findText } = pluginState;
    if (!isActive || !findText) return pluginState;
    if (!tr.steps.find((0, $hG5QM.stepHasSlice))) return pluginState;
    const { index: index, decorationSet: initialDecorationSet, matches: matches, shouldMatchCase: shouldMatchCase, getIntl: getIntl, api: api } = pluginState;
    let decorationSet = initialDecorationSet;
    const newMatches = (0, $cM5jl.findMatches)({
        content: tr.doc,
        searchText: findText,
        shouldMatchCase: shouldMatchCase,
        getIntl: getIntl,
        api: api
    });
    decorationSet = decorationSet.map(tr.mapping, tr.doc);
    const numDecorations = decorationSet.find().length;
    const mappedMatches = matches.map((match)=>({
            start: tr.mapping.map(match.start),
            end: tr.mapping.map(match.end),
            canReplace: match.canReplace,
            nodeType: match.nodeType
        }));
    let matchesToAdd = [];
    let matchesToDelete = [];
    if (newMatches.length > 0 && numDecorations === 0) matchesToAdd = newMatches;
    else if (newMatches.length === 0 && numDecorations > 0) decorationSet = (0, $16ZMX.DecorationSet).empty;
    else if (newMatches.length > 0 || numDecorations > 0) // go through tr steps and find any new matches from user adding content or
    // any dead matches from user deleting content
    tr.steps.forEach((step)=>{
        if ((0, $hG5QM.stepHasSlice)(step)) {
            // add all matches that are between the affected positions and don't already have
            // corresponding decorations
            matchesToAdd = [
                ...matchesToAdd,
                ...newMatches.filter((match)=>(0, $cM5jl.isMatchAffectedByStep)(match, step, tr) && !(0, $cM5jl.findDecorationFromMatch)(decorationSet, match))
            ];
            // delete any matches that are missing from the newMatches array and have a
            // corresponding decoration
            matchesToDelete = [
                ...matchesToDelete,
                ...(0, $cM5jl.findUniqueItemsIn)(mappedMatches.filter((match)=>(0, $cM5jl.isMatchAffectedByStep)(match, step, tr) && !!(0, $cM5jl.findDecorationFromMatch)(decorationSet, match)), newMatches, (firstMatch, secondMatch)=>firstMatch.start === secondMatch.start && firstMatch.end === secondMatch.end)
            ];
        }
    });
    // update decorations if matches changed following document update
    if (matchesToDelete.length > 0) {
        const decorationsToDelete = matchesToDelete.reduce((decorations, match)=>[
                ...decorations,
                ...decorationSet.find(match.start, match.end)
            ], []);
        decorationSet = (0, $cM5jl.removeDecorationsFromSet)(decorationSet, decorationsToDelete, tr.doc);
    }
    if (matchesToAdd.length > 0) decorationSet = decorationSet.add(tr.doc, (0, $cM5jl.createDecorations)(tr.selection.from, matchesToAdd));
    // update selected match if it has changed
    let newIndex = index;
    const selectedMatch = mappedMatches[index];
    if (selectedMatch) newIndex = newMatches.findIndex((match)=>match.start === selectedMatch.start);
    if (newIndex === undefined || newIndex === -1) newIndex = (0, $cM5jl.findClosestMatch)(tr.selection.from, newMatches);
    const newSelectedMatch = newMatches[newIndex];
    decorationSet = (0, $cM5jl.removeMatchesFromSet)(decorationSet, [
        selectedMatch,
        newSelectedMatch
    ], tr.doc);
    if (newSelectedMatch) decorationSet = decorationSet.add(tr.doc, (0, $cM5jl.createDecorations)(0, [
        newSelectedMatch
    ]));
    const newSelection = (0, $cM5jl.getSelectionForMatch)(tr.selection, tr.doc, newIndex, newMatches);
    api === null || api === void 0 || (_api$expand = api.expand) === null || _api$expand === void 0 || _api$expand.commands.toggleExpandWithMatch(newSelection)({
        tr: tr
    });
    return {
        ...pluginState,
        matches: newMatches,
        index: newIndex,
        decorationSet: decorationSet
    };
};
const $630759e5e7206712$var$dest = (0, $92jIL.pluginFactory)((0, $7AqtG.findReplacePluginKey), (0, $3mrAc.default)(()=>(0, $kngxQ.initialState)), {
    onDocChanged: $630759e5e7206712$var$handleDocChanged
});
const $630759e5e7206712$export$8d4021544bdece00 = $630759e5e7206712$var$dest.createCommand;
const $630759e5e7206712$export$f05434c51e3762e = $630759e5e7206712$var$dest.getPluginState;
const $630759e5e7206712$export$656c7661095efe2e = $630759e5e7206712$var$dest.createPluginState;

});
parcelRegister("kngxQ", function(module, exports) {
$parcel$export(module.exports, "initialState", () => $4ca1b32fa3808135$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "createPlugin", () => $4ca1b32fa3808135$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $16ZMX = parcelRequire("16ZMX");

var $frhqo = parcelRequire("frhqo");

var $7AqtG = parcelRequire("7AqtG");
const $4ca1b32fa3808135$export$d4c72bab9d6cc13a = {
    isActive: false,
    shouldFocus: false,
    findText: '',
    replaceText: '',
    index: 0,
    matches: [],
    decorationSet: (0, $16ZMX.DecorationSet).empty,
    shouldMatchCase: false
};
const $4ca1b32fa3808135$export$ae829ec7b2625219 = (dispatch, getIntl, api)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: (0, $7AqtG.findReplacePluginKey),
        state: (0, $frhqo.createPluginState)(dispatch, ()=>({
                ...$4ca1b32fa3808135$export$d4c72bab9d6cc13a,
                getIntl: getIntl,
                api: api
            })),
        props: {
            decorations (state) {
                const { isActive: isActive, findText: findText, decorationSet: decorationSet } = (0, $frhqo.getPluginState)(state);
                if (isActive && findText) return decorationSet;
            }
        }
    });
};

});
parcelRegister("7AqtG", function(module, exports) {
$parcel$export(module.exports, "findReplacePluginKey", () => $2bb0968039578d39$export$e7697da71e34f0a6);

var $801jp = parcelRequire("801jp");
const $2bb0968039578d39$export$e7697da71e34f0a6 = new (0, $801jp.PluginKey)('findReplace');

});


parcelRegister("3mrAc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3724b2c0a6c58610$export$2e2bcd8739ae039);

var $7iyqH = parcelRequire("7iyqH");
const $3724b2c0a6c58610$var$reducer = (getInitialState)=>(state, action)=>{
        switch(action.type){
            case (0, $7iyqH.FindReplaceActionTypes).ACTIVATE:
            case (0, $7iyqH.FindReplaceActionTypes).FIND:
                return {
                    ...state,
                    isActive: true,
                    shouldFocus: action.type === (0, $7iyqH.FindReplaceActionTypes).ACTIVATE,
                    findText: action.findText !== undefined ? action.findText : state.findText,
                    matches: action.matches || state.matches,
                    index: action.index !== undefined ? action.index : state.index
                };
            case (0, $7iyqH.FindReplaceActionTypes).UPDATE_DECORATIONS:
                return {
                    ...state,
                    decorationSet: action.decorationSet
                };
            case (0, $7iyqH.FindReplaceActionTypes).FIND_NEXT:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $7iyqH.FindReplaceActionTypes).FIND_PREVIOUS:
                return {
                    ...state,
                    index: action.index,
                    decorationSet: action.decorationSet
                };
            case (0, $7iyqH.FindReplaceActionTypes).REPLACE:
            case (0, $7iyqH.FindReplaceActionTypes).REPLACE_ALL:
                return {
                    ...state,
                    replaceText: action.replaceText,
                    decorationSet: action.decorationSet,
                    matches: action.matches,
                    index: action.index
                };
            case (0, $7iyqH.FindReplaceActionTypes).CANCEL:
                const { getIntl: getIntl, api: api } = state;
                return {
                    ...getInitialState(),
                    getIntl: getIntl,
                    api: api
                };
            case (0, $7iyqH.FindReplaceActionTypes).BLUR:
                return {
                    ...state,
                    shouldFocus: false
                };
            case (0, $7iyqH.FindReplaceActionTypes).TOGGLE_MATCH_CASE:
                return {
                    ...state,
                    shouldMatchCase: !state.shouldMatchCase
                };
            default:
                return state;
        }
    };
var $3724b2c0a6c58610$export$2e2bcd8739ae039 = $3724b2c0a6c58610$var$reducer;

});

parcelRegister("cM5jl", function(module, exports) {
$parcel$export(module.exports, "getSelectedText", () => $2317a463b7756354$export$93850515e4be65a3);
$parcel$export(module.exports, "createDecorations", () => $2317a463b7756354$export$2393fad6cd7faeee);
$parcel$export(module.exports, "createDecoration", () => $2317a463b7756354$export$83df86cadabd260);
$parcel$export(module.exports, "findMatches", () => $2317a463b7756354$export$f4585c00f32d9257);
$parcel$export(module.exports, "findClosestMatch", () => $2317a463b7756354$export$6df7393992287695);
$parcel$export(module.exports, "findSearchIndex", () => $2317a463b7756354$export$1b7f6169b65103e3);
$parcel$export(module.exports, "nextIndex", () => $2317a463b7756354$export$7db462fe6be63e0);
$parcel$export(module.exports, "prevIndex", () => $2317a463b7756354$export$9041fedbf960fcef);
$parcel$export(module.exports, "getSelectionForMatch", () => $2317a463b7756354$export$91f639c3a212feb2);
$parcel$export(module.exports, "findDecorationFromMatch", () => $2317a463b7756354$export$e2521c2c8f72064b);
$parcel$export(module.exports, "removeDecorationsFromSet", () => $2317a463b7756354$export$ede9cf72df9a3d38);
$parcel$export(module.exports, "removeMatchesFromSet", () => $2317a463b7756354$export$b5b5304233807f24);
$parcel$export(module.exports, "isMatchAffectedByStep", () => $2317a463b7756354$export$7d11bfeb87290a13);
$parcel$export(module.exports, "findUniqueItemsIn", () => $2317a463b7756354$export$bb98a54aeaa7e0c0);

var $jyPR0 = parcelRequire("jyPR0");

var $gR9lL = parcelRequire("gR9lL");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $22VWa = parcelRequire("22VWa");

var $fbyw0 = parcelRequire("fbyw0");

var $cQ4LZ = parcelRequire("cQ4LZ");

var $bcN2K = parcelRequire("bcN2K");

var $hvzwL = parcelRequire("hvzwL");

var $7Vh6m = parcelRequire("7Vh6m");
function $2317a463b7756354$export$4391514644a718d(nodes) {
    let result = '';
    for (const node of nodes){
        var _node$attrs;
        if ((node.type === 'expand' || node.type === 'nestedExpand') && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.title) result += node.attrs.title;
        if (node.text != null) // Inline text node — concatenate directly (text already carries its own whitespace)
        result += node.text;
        else if (node.content) {
            // Block-level node — add a space separator to prevent false matches across block boundaries
            if (result.length > 0) result += ' ';
            result += $2317a463b7756354$export$4391514644a718d(node.content);
        }
    }
    return result;
}
function $2317a463b7756354$export$93850515e4be65a3(selection) {
    let text = '';
    const selectedContent = selection.content().content;
    for(let i = 0; i < selectedContent.childCount; i++)text += selectedContent.child(i).textContent;
    return text;
}
const $2317a463b7756354$export$2393fad6cd7faeee = (selectedIndex, matches)=>matches.map(({ start: start, end: end, canReplace: canReplace, nodeType: nodeType }, i)=>$2317a463b7756354$export$83df86cadabd260({
            start: start,
            end: end,
            canReplace: canReplace,
            nodeType: nodeType
        }, i === selectedIndex));
const $2317a463b7756354$var$isElement = (nodeType)=>[
        'blockCard',
        'embedCard',
        'inlineCard',
        'status',
        'mention',
        'date',
        'syncBlock'
    ].includes(nodeType || '');
const $2317a463b7756354$var$isExpandTitle = (match)=>[
        'expand',
        'nestedExpand'
    ].includes(match.nodeType || '') && !match.canReplace;
const $2317a463b7756354$export$83df86cadabd260 = (match, isSelected)=>{
    const { start: start, end: end, nodeType: nodeType } = match;
    const { colorMode: colorMode } = (0, $hvzwL.getGlobalTheme)();
    if ($2317a463b7756354$var$isElement(nodeType)) {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $7Vh6m.blockSearchMatchClass), {
            [(0, $7Vh6m.selectedBlockSearchMatchClass)]: isSelected,
            [(0, $7Vh6m.darkModeSearchMatchClass)]: colorMode === 'dark'
        });
        return (0, $16ZMX.Decoration).node(start, end, {
            class: className
        });
    }
    if ($2317a463b7756354$var$isExpandTitle(match)) {
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $7Vh6m.searchMatchExpandTitleClass), {
            [(0, $7Vh6m.selectedSearchMatchClass)]: isSelected,
            [(0, $7Vh6m.darkModeSearchMatchClass)]: colorMode === 'dark'
        });
        return (0, $16ZMX.Decoration).node(start, end, {
            class: className
        });
    }
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $7Vh6m.searchMatchTextClass), {
        [(0, $7Vh6m.selectedSearchMatchClass)]: isSelected,
        [(0, $7Vh6m.darkModeSearchMatchClass)]: colorMode === 'dark'
    });
    return (0, $16ZMX.Decoration).inline(start, end, {
        class: className
    });
};
function $2317a463b7756354$export$f4585c00f32d9257({ content: content, searchText: searchText, shouldMatchCase: shouldMatchCase, contentIndex: contentIndex = 0, getIntl: getIntl, api: api }) {
    const matches = [];
    const searchTextLength = searchText.length;
    let textGrouping = null;
    const collectTextMatch = (textGrouping)=>{
        if (!textGrouping) return;
        let { text: text } = textGrouping;
        const { pos: relativePos } = textGrouping;
        const pos = contentIndex + relativePos;
        if (!shouldMatchCase) {
            searchText = searchText.toLowerCase();
            text = text.toLowerCase();
        }
        let index = text.indexOf(searchText);
        while(index !== -1){
            // Find the next substring from the end of the first, so that they don't overlap
            const end = index + searchTextLength;
            // Add the substring index to the position of the node
            matches.push({
                start: pos + index,
                end: pos + end,
                canReplace: true,
                nodeType: 'text'
            });
            index = text.indexOf(searchText, end);
        }
    };
    const collectNodeMatch = (textGrouping, node)=>{
        if (!textGrouping) return;
        const { pos: pos } = textGrouping;
        let { text: text } = textGrouping;
        if (node.type.name === 'status' && shouldMatchCase) text = text.toUpperCase();
        else if (!shouldMatchCase) {
            text = text.toLowerCase();
            searchText = searchText.toLowerCase();
        }
        const index = text.indexOf(searchText);
        if (index !== -1) matches.push({
            start: pos,
            end: pos + node.nodeSize,
            canReplace: false,
            nodeType: node.type.name
        });
    };
    // Cache to avoid repeated O(n) url lookups
    let registeredCardsByUrl = null;
    const collectCardTitleMatch = (node, pos)=>{
        var _registeredCardsByUrl, _api$card2;
        // Populate cache
        if (!registeredCardsByUrl && (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_forced_layout_2')) {
            registeredCardsByUrl = new Map();
            for (const card of Object.values((api === null || api === void 0 || (_api$card = api.card) === null || _api$card === void 0 || (_api$card = _api$card.actions) === null || _api$card === void 0 || (_api$card$getCardRegi = _api$card.getCardRegistrations) === null || _api$card$getCardRegi === void 0 ? void 0 : _api$card$getCardRegi.call(_api$card)) ?? {})){
                var _api$card, _api$card$getCardRegi;
                if (card.getPos() !== undefined) registeredCardsByUrl.set(card.url, card);
            }
        }
        const relevantCard = (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') ? (_registeredCardsByUrl = registeredCardsByUrl) === null || _registeredCardsByUrl === void 0 ? void 0 : _registeredCardsByUrl.get(node.attrs.url) : api === null || api === void 0 || (_api$card2 = api.card) === null || _api$card2 === void 0 || (_api$card2 = _api$card2.sharedState.currentState()) === null || _api$card2 === void 0 || (_api$card2 = _api$card2.cards) === null || _api$card2 === void 0 ? void 0 : _api$card2.find((card)=>card.url === node.attrs.url);
        if (relevantCard) {
            if (relevantCard.title) collectNodeMatch({
                text: relevantCard.title,
                pos: pos
            }, node);
            else if (node.type.name === 'inlineCard') // when there is no title, e.g. in an error case like unauthorized
            // the link card just shows the entire url as the title in inline card
            collectNodeMatch({
                text: node.attrs.url,
                pos: pos
            }, node);
        }
    };
    if (searchTextLength > 0) {
        content.descendants((node, pos)=>{
            if (node.isText) {
                if (textGrouping === null) textGrouping = {
                    text: node.text,
                    pos: pos
                };
                else textGrouping.text += node.text;
            } else {
                collectTextMatch(textGrouping);
                textGrouping = null;
                switch(node.type.name){
                    case 'status':
                        collectNodeMatch({
                            text: node.attrs.text,
                            pos: pos
                        }, node);
                        break;
                    case 'date':
                        collectNodeMatch({
                            text: (0, $gR9lL.timestampToString)(node.attrs.timestamp, getIntl ? getIntl() : null),
                            pos: pos
                        }, node);
                        break;
                    case 'expand':
                    case 'nestedExpand':
                        collectNodeMatch({
                            text: node.attrs.title,
                            pos: pos
                        }, node);
                        break;
                    case 'mention':
                        let text;
                        if (node.attrs.text) text = node.attrs.text;
                        else {
                            var _api$mention;
                            // the text may be sanitised from the node for privacy reasons
                            // so we need to use the mentionProvider to resolve it
                            const mentionProvider = api === null || api === void 0 || (_api$mention = api.mention) === null || _api$mention === void 0 || (_api$mention = _api$mention.sharedState.currentState()) === null || _api$mention === void 0 ? void 0 : _api$mention.mentionProvider;
                            if ((0, $fbyw0.isResolvingMentionProvider)(mentionProvider)) {
                                const nameDetail = mentionProvider.resolveMentionName(node.attrs.id);
                                if ((0, $22VWa.isPromise)(nameDetail)) text = '@...';
                                else if (nameDetail.status === (0, $cQ4LZ.MentionNameStatus).OK) text = `@${nameDetail.name || ''}`;
                                else text = '@_|unknown|_';
                            }
                        }
                        if (text) collectNodeMatch({
                            text: text,
                            pos: pos
                        }, node);
                        break;
                    case 'inlineCard':
                    case 'blockCard':
                    case 'embedCard':
                        collectCardTitleMatch(node, pos);
                        break;
                    case 'syncBlock':
                        {
                            var _api$syncedBlock, _instance$data;
                            const syncBlockStore = api === null || api === void 0 || (_api$syncedBlock = api.syncedBlock) === null || _api$syncedBlock === void 0 || (_api$syncedBlock = _api$syncedBlock.sharedState.currentState()) === null || _api$syncedBlock === void 0 ? void 0 : _api$syncedBlock.syncBlockStore;
                            const instance = syncBlockStore === null || syncBlockStore === void 0 ? void 0 : syncBlockStore.referenceManager.getFromCache(node.attrs.resourceId);
                            const adfContent = instance === null || instance === void 0 || (_instance$data = instance.data) === null || _instance$data === void 0 ? void 0 : _instance$data.content;
                            if (adfContent && adfContent.length > 0) {
                                const text = $2317a463b7756354$export$4391514644a718d(adfContent);
                                if (text) collectNodeMatch({
                                    text: text,
                                    pos: pos
                                }, node);
                            }
                            break;
                        }
                    default:
                        break;
                }
            }
        });
        // if there's a dangling text grouping and no non-text node to trigger collectTextMatch, manually collectTextMatch
        if (textGrouping) collectTextMatch(textGrouping);
    }
    return matches;
}
function $2317a463b7756354$export$6df7393992287695(selectionPos, matches) {
    const forwardMatchIndex = matches.findIndex((match)=>match.start >= selectionPos);
    if (forwardMatchIndex === -1) // if there are no forward matches, it must be the last match
    return matches.length > 0 ? matches.length - 1 : 0;
    if (forwardMatchIndex === 0) return forwardMatchIndex;
    const backwardMatchIndex = forwardMatchIndex - 1;
    const forwardMatchPos = matches[forwardMatchIndex].start;
    const backwardMatchPos = matches[backwardMatchIndex].start;
    if (forwardMatchPos - selectionPos < selectionPos - backwardMatchPos) return forwardMatchIndex;
    return backwardMatchIndex;
}
function $2317a463b7756354$export$1b7f6169b65103e3(selectionPos, matches, backward = false) {
    if (backward) {
        let matchIndex = matches.findIndex((match)=>match.start >= selectionPos) - 1;
        if (matchIndex < 0) matchIndex = matches.length - 1; // wrap around from the end
        return matchIndex;
    }
    return Math.max(matches.findIndex((match)=>match.start >= selectionPos), 0);
}
const $2317a463b7756354$export$7db462fe6be63e0 = (currentIndex, total)=>(currentIndex + 1) % total;
const $2317a463b7756354$export$9041fedbf960fcef = (currentIndex, total)=>(currentIndex - 1 + total) % total;
const $2317a463b7756354$var$isSyncBlock = (match)=>match.nodeType === 'syncBlock';
const $2317a463b7756354$export$91f639c3a212feb2 = (selection, doc, index, matches, offset = 0)=>{
    if (matches[index]) {
        if ($2317a463b7756354$var$isExpandTitle(matches[index]) || $2317a463b7756354$var$isSyncBlock(matches[index])) return (0, $801jp.NodeSelection).create(doc, matches[index].start);
        return (0, $801jp.TextSelection).create(doc, matches[index].start + offset);
    }
    return selection;
};
const $2317a463b7756354$export$e2521c2c8f72064b = (decorationSet, match)=>{
    if (!match) return;
    const decorations = decorationSet.find(match.start, match.end);
    return decorations.length ? decorations.find(// decorationSet.find() returns any decorations that touch the specifided
    // positions, but we want to be stricter
    (decoration)=>decoration.from === match.start && decoration.to === match.end) : undefined;
};
const $2317a463b7756354$export$ede9cf72df9a3d38 = (decorationSet, decorationsToRemove, doc)=>{
    const prevDecorations = decorationSet.find();
    // it is essential that we copy the decorations otherwise in some rare cases
    // prosemirror-view will update our decorationsToRemove array to contain nulls
    // instead of Decorations which ruins our check for lost decorations below
    decorationSet = decorationSet.remove(decorationsToRemove.map((decoration)=>// copy exists but isn't on the type definition
        decoration.copy(decoration.from, decoration.to)));
    const newDecorations = decorationSet.find();
    // there is a bug in prosemirror-view where it can't cope with deleting inline
    // decorations from a set in some cases (where there are multiple levels of nested
    // children arrays), and it deletes more decorations than it should
    const lostDecorations = $2317a463b7756354$export$3d30681780612963(decorationsToRemove, prevDecorations, newDecorations);
    if (lostDecorations.length > 0) decorationSet = decorationSet.add(doc, lostDecorations);
    return decorationSet;
};
const $2317a463b7756354$export$b5b5304233807f24 = (decorationSet, matches, doc)=>{
    const decorationsToRemove = matches.filter((match)=>!!match).map((match)=>$2317a463b7756354$export$e2521c2c8f72064b(decorationSet, match));
    decorationsToRemove.forEach((decoration)=>{
        if (decoration) decorationSet = $2317a463b7756354$export$ede9cf72df9a3d38(decorationSet, [
            decoration
        ], doc);
    });
    return decorationSet;
};
const $2317a463b7756354$export$3d30681780612963 = (decorationsToRemove, prevDecorations, newDecorations)=>{
    let lostDecorations = [];
    if (prevDecorations.length - decorationsToRemove.length > newDecorations.length) {
        const position = decorationsToRemove.length > 0 ? decorationsToRemove[0].from : 0;
        const prevDecorationsStartIdx = $2317a463b7756354$export$7e4c53b0062d9305(prevDecorations, position);
        const newDecorationsStartIdx = $2317a463b7756354$export$7e4c53b0062d9305(newDecorations, position);
        const startIdx = Math.min(prevDecorationsStartIdx, newDecorationsStartIdx);
        const prevDecorationsToCheck = prevDecorations.slice(startIdx);
        const newDecorationsToCheck = newDecorations.slice(startIdx);
        const uniqueInPrev = [];
        const numToFind = prevDecorationsToCheck.length - newDecorationsToCheck.length;
        let foundAll = false;
        let newDecorationsIdxOffset = 0;
        for(let i = 0; i < prevDecorationsToCheck.length; i++){
            const prevDecoration = prevDecorationsToCheck[i];
            // this was a legit removal, skip and continue
            if (decorationsToRemove.find((decoration)=>decoration.from === prevDecoration.from)) {
                newDecorationsIdxOffset -= 1;
                continue;
            }
            let j = i + newDecorationsIdxOffset;
            // this is a lost decoration
            if (j >= newDecorationsToCheck.length) {
                uniqueInPrev.push(prevDecoration);
                if (uniqueInPrev.length === numToFind) foundAll = true;
            }
            for(; j < newDecorationsToCheck.length; j++){
                const newDecoration = newDecorationsToCheck[j];
                // decoration found in both arrays, skip and continue
                if (prevDecoration.from === newDecoration.from) break;
                // this is a lost decoration
                if (newDecoration.from > prevDecoration.from || j === newDecorationsToCheck.length - 1) {
                    uniqueInPrev.push(prevDecoration);
                    newDecorationsIdxOffset -= 1;
                    if (uniqueInPrev.length === numToFind) foundAll = true;
                    break;
                }
            }
            if (foundAll) break;
        }
        // make sure we ignore any that we wanted to delete
        lostDecorations = uniqueInPrev.filter((decoration)=>!decorationsToRemove.find((decorationToRemove)=>decoration.from === decorationToRemove.from));
    }
    return lostDecorations;
};
const $2317a463b7756354$export$7e4c53b0062d9305 = (items, position)=>{
    // jump in batches to cope with arrays with thousands of decorations
    const increment = 100;
    let index = 0;
    for(let i = items.length - 1; i >= 0; i -= increment){
        if (items[i].from < position) {
            // now we have found the 100 range, we can narrow it down to exact index
            index = i;
            for(let j = i; j <= items.length - 1; j++){
                if (items[j].from <= position) index = j;
                else break;
            }
            break;
        }
        if (i < 100 && i > 0) i = 100;
    }
    return index;
};
const $2317a463b7756354$export$7d11bfeb87290a13 = (match, step, tr)=>{
    const { from: from, to: to, slice: slice } = step;
    const sliceSize = slice.content.size;
    return from + sliceSize >= match.start && to - sliceSize <= match.end || tr.mapping.map(from) + sliceSize >= match.start && tr.mapping.map(to) - sliceSize <= match.end;
};
function $2317a463b7756354$export$bb98a54aeaa7e0c0(findIn, checkWith, comparator) {
    return findIn.filter((firstItem)=>checkWith.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === -1);
}

});
parcelRegister("7Vh6m", function(module, exports) {
$parcel$export(module.exports, "searchMatchTextClass", () => $c7f4687541635019$export$a19ecadc9ecc39b1);
$parcel$export(module.exports, "selectedSearchMatchClass", () => $c7f4687541635019$export$bf208a338b2a2f1f);
$parcel$export(module.exports, "blockSearchMatchClass", () => $c7f4687541635019$export$bb09fa712812841f);
$parcel$export(module.exports, "selectedBlockSearchMatchClass", () => $c7f4687541635019$export$99146b4c1ad5837a);
$parcel$export(module.exports, "darkModeSearchMatchClass", () => $c7f4687541635019$export$6cc90c491f952538);
$parcel$export(module.exports, "searchMatchExpandTitleClass", () => $c7f4687541635019$export$2414358ab66f419a);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $c7f4687541635019$export$cec6db4af40340f0 = 'search-match';
const $c7f4687541635019$export$a19ecadc9ecc39b1 = 'search-match-text';
const $c7f4687541635019$export$bf208a338b2a2f1f = 'selected-search-match';
const $c7f4687541635019$export$bb09fa712812841f = 'search-match-block';
const $c7f4687541635019$export$99146b4c1ad5837a = 'search-match-block-selected';
const $c7f4687541635019$export$6cc90c491f952538 = 'search-match-dark';
const $c7f4687541635019$export$2414358ab66f419a = 'search-match-expand-title';

});



parcelRegister("hMQPe", function(module, exports) {
$parcel$export(module.exports, "default", () => $2119d86a1a4f59ea$export$2e2bcd8739ae039);

var $frhqo = parcelRequire("frhqo");

var $cM5jl = parcelRequire("cM5jl");
// max number of decorations to apply at once
const $2119d86a1a4f59ea$var$batchIncrement = 100;
// position range to apply decorations between before alternating above or below viewport
const $2119d86a1a4f59ea$var$posIncrement = 2000;
/**
 * Provides support for applying search match highlight decorations in batches
 */ class $2119d86a1a4f59ea$var$BatchDecorations {
    stop() {
        if (this.rafId) cancelAnimationFrame(this.rafId);
    }
    /**
   * Applies the decorations needed for the current search results
   * It does so async, splitting them up into batches to help with performance
   */ async applyAllSearchDecorations(editorView, containerElement, addDecorations, removeDecorations) {
        this.stop();
        this.addDecorations = addDecorations;
        this.removeDecorations = removeDecorations;
        if (!containerElement) return;
        const pmElement = containerElement.querySelector('.ProseMirror');
        if (!pmElement) return;
        const positions = this.calcDecorationPositions(editorView, containerElement, pmElement);
        const { startPos: startPos, endPos: endPos, viewportStartPos: viewportStartPos, viewportEndPos: viewportEndPos } = positions;
        let dir = 0;
        let before = viewportStartPos;
        let after = viewportEndPos - $2119d86a1a4f59ea$var$posIncrement;
        await this.updateDecorationsBetween(editorView, viewportStartPos, viewportEndPos);
        while(before > startPos || after < endPos)if (dir++ % 2 === 0 && before > startPos || after >= endPos) {
            const diff = before - startPos;
            before = Math.max(before - $2119d86a1a4f59ea$var$posIncrement, startPos);
            await this.updateDecorationsBetween(editorView, before, before + Math.min(diff, $2119d86a1a4f59ea$var$posIncrement));
        } else {
            after = Math.min(after + $2119d86a1a4f59ea$var$posIncrement, endPos);
            await this.updateDecorationsBetween(editorView, after, Math.min(after + $2119d86a1a4f59ea$var$posIncrement, endPos));
        }
    }
    async updateDecorationsBetween(editorView, startPos, endPos) {
        await this.removeDecorationsBetween(editorView, startPos, endPos);
        await this.addDecorationsBetween(editorView, startPos, endPos);
    }
    async addDecorationsBetween(editorView, startPos, endPos) {
        const { selection: selection } = editorView.state;
        const { matches: matches, decorationSet: decorationSet } = (0, $frhqo.getPluginState)(editorView.state);
        if (matches.length === 0) return;
        const matchesBetween = matches.filter((m)=>m.start >= startPos && (endPos === undefined || m.start < endPos));
        const selectionMatch = matches.find((match)=>match.start >= selection.from);
        const selectionIndex = matchesBetween.findIndex((match)=>match === selectionMatch);
        return await this.batchRequests((counter)=>{
            const matchesToDecorate = matchesBetween.slice(counter, counter + $2119d86a1a4f59ea$var$batchIncrement);
            if (matchesToDecorate.length === 0) return false;
            let useSelectionIndex = selectionIndex >= counter && selectionIndex < counter + $2119d86a1a4f59ea$var$batchIncrement;
            if (selectionMatch && useSelectionIndex) {
                const selectionMatchDecoration = (0, $cM5jl.findDecorationFromMatch)(decorationSet, selectionMatch);
                if (selectionMatchDecoration) {
                    matchesToDecorate.splice(selectionIndex % $2119d86a1a4f59ea$var$batchIncrement, 1);
                    useSelectionIndex = false;
                }
            }
            if (this.addDecorations) this.addDecorations((0, $cM5jl.createDecorations)(useSelectionIndex ? selectionIndex % $2119d86a1a4f59ea$var$batchIncrement : -1, matchesToDecorate));
        }, {
            increment: $2119d86a1a4f59ea$var$batchIncrement,
            until: matchesBetween.length
        });
    }
    async removeDecorationsBetween(editorView, startPos, endPos) {
        const { decorationSet: decorationSet } = (0, $frhqo.getPluginState)(editorView.state);
        const decorations = decorationSet.find(startPos, endPos);
        if (decorations.length === 0) return;
        return await this.batchRequests((counter)=>{
            let decorationsToRemove = decorations.slice(counter, counter + $2119d86a1a4f59ea$var$batchIncrement);
            if (decorationsToRemove.length === 0) return false;
            // only get those decorations whose from >= startPos
            for(let i = 0; i < decorationsToRemove.length; i++){
                if (decorationsToRemove[i].from >= startPos) break;
                decorationsToRemove = decorationsToRemove.slice(1);
            }
            if (this.removeDecorations) this.removeDecorations(decorationsToRemove);
        }, {
            increment: $2119d86a1a4f59ea$var$batchIncrement,
            until: decorations.length
        });
    }
    /**
   * Calculates Prosemirror start and end positions we want to apply the decorations
   * between
   * Also calculates the positions the are the start and end of the user's viewport
   * so we can apply decorations there first and work outwards
   */ calcDecorationPositions(editorView, containerElement, pmElement) {
        const containerRect = containerElement.getBoundingClientRect();
        const pmRect = pmElement.getBoundingClientRect();
        const viewportStartPos = this.getStartPos(editorView, 0, pmRect.left);
        const viewportEndPos = this.getEndPos(editorView, containerRect.top + containerRect.height, pmRect.left);
        return {
            viewportStartPos: viewportStartPos,
            viewportEndPos: viewportEndPos,
            startPos: 0,
            endPos: editorView.state.doc.nodeSize
        };
    }
    getStartPos(editorView, y, x) {
        const startPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return startPos ? startPos.pos : 0;
    }
    getEndPos(editorView, y, x) {
        const maxPos = editorView.state.doc.nodeSize;
        const endPos = editorView.posAtCoords({
            top: y,
            left: x
        });
        return endPos ? endPos.pos : maxPos;
    }
    /**
   * Util to batch function calls by animation frames
   * A counter will start at 0 and increment by provided value until reaches limit
   * Passed in fn receives the counter as a param, return false to skip waiting
   * for the animation frame for the next call
   */ batchRequests(fn, opts) {
        let counter = 0;
        const { increment: increment, until: until } = opts;
        return new Promise((resolve)=>{
            const batchedFn = ()=>{
                let result = fn(counter);
                while(result === false && counter < until){
                    counter += increment;
                    result = fn(counter);
                }
                if (counter < until) {
                    counter += increment;
                    this.rafId = requestAnimationFrame(batchedFn);
                } else {
                    this.rafId = undefined;
                    resolve();
                }
            };
            this.rafId = requestAnimationFrame(batchedFn);
        });
    }
}
const $2119d86a1a4f59ea$var$batchDecorations = new $2119d86a1a4f59ea$var$BatchDecorations();
var $2119d86a1a4f59ea$export$2e2bcd8739ae039 = $2119d86a1a4f59ea$var$batchDecorations;

});

parcelRegister("j6kgt", function(module, exports) {
$parcel$export(module.exports, "withScrollIntoView", () => $833065a817cb0d1e$export$b252ecff1878cab7);
const $833065a817cb0d1e$export$b252ecff1878cab7 = (command)=>(state, dispatch, view)=>command(state, (tr)=>{
            if (view) {
                let targetPos = tr.selection.anchor;
                let coords = view.coordsAtPos(targetPos);
                // If element is not visible (coords are invalid), try parent nodes
                if (coords.top === coords.bottom || coords.top === 0) {
                    const $pos = tr.selection.$anchor;
                    let depth = $pos.depth;
                    while(depth > 0 && (coords.top === coords.bottom || coords.top === 0)){
                        targetPos = $pos.before(depth);
                        coords = view.coordsAtPos(targetPos);
                        depth--;
                    }
                }
                // Find the closest scrollable parent element
                let scrollParent = view.dom;
                while(scrollParent && scrollParent !== document.documentElement){
                    const style = window.getComputedStyle(scrollParent);
                    const overflowY = style.overflowY;
                    const overflowX = style.overflowX;
                    const isScrollable = (overflowY === 'auto' || overflowY === 'scroll' || overflowX === 'auto' || overflowX === 'scroll') && (scrollParent.scrollHeight > scrollParent.clientHeight || scrollParent.scrollWidth > scrollParent.clientWidth);
                    if (isScrollable) break;
                    scrollParent = scrollParent.parentElement;
                }
                // Scroll to center the content
                if (scrollParent && scrollParent !== document.documentElement) {
                    const parentRect = scrollParent.getBoundingClientRect();
                    const scrollTop = scrollParent.scrollTop + coords.top - parentRect.top - parentRect.height / 2 + (coords.bottom - coords.top) / 2;
                    scrollParent.scrollTo({
                        top: scrollTop,
                        behavior: 'smooth'
                    });
                }
            } else tr.scrollIntoView();
            if (dispatch) dispatch(tr);
        }, view);

});


parcelRegister("5MAgC", function(module, exports) {
$parcel$export(module.exports, "activateWithAnalytics", () => $6f9e4dac30698224$export$f4a2dfcbc300db1a);
$parcel$export(module.exports, "findWithAnalytics", () => $6f9e4dac30698224$export$a1f845c5f9c28dec);
$parcel$export(module.exports, "findNextWithAnalytics", () => $6f9e4dac30698224$export$da0da8f66917d4cd);
$parcel$export(module.exports, "findPrevWithAnalytics", () => $6f9e4dac30698224$export$67b10f9d7f5c44e1);
$parcel$export(module.exports, "replaceWithAnalytics", () => $6f9e4dac30698224$export$95c81501036a7f64);
$parcel$export(module.exports, "replaceAllWithAnalytics", () => $6f9e4dac30698224$export$99b6462294b19fcd);
$parcel$export(module.exports, "cancelSearchWithAnalytics", () => $6f9e4dac30698224$export$330be886194dc3c6);

var $3LeME = parcelRequire("3LeME");

var $8VpI3 = parcelRequire("8VpI3");

var $801jp = parcelRequire("801jp");

var $jB8vP = parcelRequire("jB8vP");
const $6f9e4dac30698224$export$f4a2dfcbc300db1a = (editorAnalyticsAPI, editorViewModeAPI)=>({ triggerMethod: triggerMethod })=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, (state)=>{
            var _editorViewModeAPI$sh;
            return {
                eventType: (0, $3LeME.EVENT_TYPE).UI,
                action: (0, $3LeME.ACTION).ACTIVATED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
                attributes: {
                    inputMethod: state.selection instanceof (0, $801jp.TextSelection) && !state.selection.empty ? (0, $3LeME.INPUT_METHOD).PREFILL : (0, $3LeME.INPUT_METHOD).KEYBOARD,
                    triggerMethod: triggerMethod,
                    editorViewMode: (editorViewModeAPI === null || editorViewModeAPI === void 0 || (_editorViewModeAPI$sh = editorViewModeAPI.sharedState.currentState()) === null || _editorViewModeAPI$sh === void 0 ? void 0 : _editorViewModeAPI$sh.mode) ?? 'edit'
                }
            };
        })((0, $jB8vP.activate)());
const $6f9e4dac30698224$export$a1f845c5f9c28dec = (editorAnalyticsAPI)=>({ editorView: editorView, containerElement: containerElement, keyword: keyword })=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: (0, $3LeME.ACTION).FIND_PERFORMED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TEXT
        })((0, $jB8vP.find)(editorView, containerElement, keyword));
const $6f9e4dac30698224$export$da0da8f66917d4cd = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>{
        return (0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: (0, $3LeME.ACTION).FIND_NEXT_PERFORMED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $jB8vP.findNext)(editorView));
    };
const $6f9e4dac30698224$export$67b10f9d7f5c44e1 = (editorAnalyticsAPI, editorView)=>({ triggerMethod: triggerMethod })=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: (0, $3LeME.ACTION).FIND_PREV_PERFORMED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $jB8vP.findPrevious)(editorView));
const $6f9e4dac30698224$export$95c81501036a7f64 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod, replaceText: replaceText })=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: (0, $3LeME.ACTION).REPLACED_ONE,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TEXT,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $jB8vP.replace)(replaceText));
const $6f9e4dac30698224$export$99b6462294b19fcd = (editorAnalyticsAPI)=>({ replaceText: replaceText })=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: (0, $3LeME.ACTION).REPLACED_ALL,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TEXT
        })((0, $jB8vP.replaceAll)(replaceText));
const $6f9e4dac30698224$export$330be886194dc3c6 = (editorAnalyticsAPI)=>({ triggerMethod: triggerMethod })=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            eventType: (0, $3LeME.EVENT_TYPE).UI,
            action: (0, $3LeME.ACTION).DEACTIVATED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).FIND_REPLACE_DIALOG,
            attributes: {
                triggerMethod: triggerMethod
            }
        })((0, $jB8vP.cancelSearch)());

});

parcelRegister("arGD1", function(module, exports) {
$parcel$export(module.exports, "default", () => $484fea3073164df8$export$2e2bcd8739ae039);

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $1O8Lw = parcelRequire("1O8Lw");

var $5MAgC = parcelRequire("5MAgC");
const $484fea3073164df8$var$activateFindReplace = (editorAnalyticsAPI, editorViewModeAPI)=>(state, dispatch)=>{
        (0, $5MAgC.activateWithAnalytics)(editorAnalyticsAPI, editorViewModeAPI)({
            triggerMethod: (0, $3LeME.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $484fea3073164df8$var$keymapPlugin = (editorAnalyticsAPI, editorViewModeAPI)=>{
    const list = {};
    if ((0, $eUtBU.find).common) (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.find).common, $484fea3073164df8$var$activateFindReplace(editorAnalyticsAPI, editorViewModeAPI), list);
    return (0, $1O8Lw.keymap)(list);
};
var $484fea3073164df8$export$2e2bcd8739ae039 = $484fea3073164df8$var$keymapPlugin;

});

parcelRegister("40ZQK", function(module, exports) {
$parcel$export(module.exports, "viewModeShortcutPlugin", () => $2028cc91515dcc1a$export$6a234c24ec1250da);

var $6Zi52 = parcelRequire("6Zi52");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $1y7gE = parcelRequire("1y7gE");

var $1O8Lw = parcelRequire("1O8Lw");

var $5MAgC = parcelRequire("5MAgC");
/**
 * Whether the event came from a field the user is typing into. `Mod-f` belongs to
 * that field, not to us.
 */ const $2028cc91515dcc1a$var$isFromTextEntry = (event)=>{
    const target = event.target;
    return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLElement && target.isContentEditable;
};
const $2028cc91515dcc1a$var$activateInViewMode = (api)=>(state, dispatch)=>{
        var _api$editorViewMode, _api$analytics;
        // In edit mode `./keymap.ts` already handles `Mod-f`. Handling it here as well
        // would activate the dialog twice from a single keypress.
        if ((api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) !== 'view') return false;
        (0, $5MAgC.activateWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api === null || api === void 0 ? void 0 : api.editorViewMode)({
            triggerMethod: (0, $3LeME.TRIGGER_METHOD).SHORTCUT
        })(state, dispatch);
        return true;
    };
const $2028cc91515dcc1a$export$6a234c24ec1250da = (api)=>{
    const bindings = {};
    if ((0, $eUtBU.find).common) (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.find).common, $2028cc91515dcc1a$var$activateInViewMode(api), bindings);
    const handleKeydown = (0, $1O8Lw.keydownHandler)(bindings);
    return new (0, $1y7gE.SafePlugin)({
        view: (view)=>{
            const unbind = (0, $6Zi52.bind)(view.root, {
                type: 'keydown',
                listener: (event)=>{
                    // `view.root` is `Document | ShadowRoot`, so the binding widens the event.
                    if (!(event instanceof KeyboardEvent) || $2028cc91515dcc1a$var$isFromTextEntry(event)) return;
                    if (handleKeydown(view, event)) // Without this the browser find bar opens on top of our dialog.
                    event.preventDefault();
                }
            });
            return {
                destroy: unbind
            };
        }
    });
};

});

parcelRegister("ir1il", function(module, exports) {
$parcel$export(module.exports, "default", () => $059bb5e734eb52bd$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $9oAqi = parcelRequire("9oAqi");

var $bKWnN = parcelRequire("bKWnN");

var $dhdSE = parcelRequire("dhdSE");

var $jB8vP = parcelRequire("jB8vP");

var $5MAgC = parcelRequire("5MAgC");

var $7YoLh = parcelRequire("7YoLh");

var $aLKuZ = parcelRequire("aLKuZ");
// light implementation of useSharedPluginState(). This is due to findreplace
// being the only plugin that previously used WithPluginState with
// debounce=false. That was implemented because of text sync issues
// between editor & findreplace dialog.
// To address under ENGHEALTH-5853
const $059bb5e734eb52bd$var$useSharedPluginStateNoDebounce = (api)=>{
    var _api$findReplace;
    const [state, setState] = (0, $fc4bM.useState)(api === null || api === void 0 || (_api$findReplace = api.findReplace) === null || _api$findReplace === void 0 ? void 0 : _api$findReplace.sharedState.currentState());
    (0, $fc4bM.useLayoutEffect)(()=>{
        var _api$findReplace2;
        const unsub = api === null || api === void 0 || (_api$findReplace2 = api.findReplace) === null || _api$findReplace2 === void 0 ? void 0 : _api$findReplace2.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            setState(nextSharedState);
        });
        return ()=>{
            unsub === null || unsub === void 0 || unsub();
        };
    }, [
        api
    ]);
    return {
        findReplaceState: state
    };
};
const $059bb5e734eb52bd$var$useEditorViewMode = (0, $dhdSE.conditionalHooksFactory)(()=>(0, $bKWnN.UNSAFE_expValNoExposure)('platform_editor_collapsible_headings', 'isEnabled', false), (api)=>(0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>{
        var _states$editorViewMod;
        return (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode;
    }), ()=>undefined);
const $059bb5e734eb52bd$var$FindReplaceToolbarButtonWithState = ({ popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView, containerElement: containerElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, takeFullWidth: takeFullWidth, api: api, isButtonHidden: isButtonHidden, doesNotHaveButton: doesNotHaveButton })=>{
    var _api$analytics, _matches$index;
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const { findReplaceState: findReplaceState } = $059bb5e734eb52bd$var$useSharedPluginStateNoDebounce(api);
    const editorViewMode = $059bb5e734eb52bd$var$useEditorViewMode(api);
    const allowReplace = editorViewMode !== 'view';
    const shouldMatchCase = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.shouldMatchCase;
    const isActive = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.isActive;
    const findText = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.findText;
    const replaceText = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.replaceText;
    const index = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.index;
    const matches = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.matches;
    const shouldFocus = findReplaceState === null || findReplaceState === void 0 ? void 0 : findReplaceState.shouldFocus;
    if (!editorView) return null;
    // we need the editor to be in focus for scrollIntoView() to work
    // so we focus it while we run the command, then put focus back into
    // whatever element was previously focused in find replace component
    const runWithEditorFocused = (fn)=>{
        const activeElement = document.activeElement;
        editorView.focus();
        fn();
        activeElement === null || activeElement === void 0 || activeElement.focus();
    };
    const dispatchCommand = (cmd)=>{
        const { state: state, dispatch: dispatch } = editorView;
        cmd(state, dispatch, editorView);
    };
    const handleActivate = ()=>{
        runWithEditorFocused(()=>dispatchCommand((0, $5MAgC.activateWithAnalytics)(editorAnalyticsAPI, api === null || api === void 0 ? void 0 : api.editorViewMode)({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).TOOLBAR
            })));
    };
    const handleFind = (keyword)=>{
        runWithEditorFocused(()=>dispatchCommand((0, $5MAgC.findWithAnalytics)(editorAnalyticsAPI)({
                editorView: editorView,
                containerElement: containerElement,
                keyword: keyword
            })));
    };
    const handleFindNext = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $5MAgC.findNextWithAnalytics)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleFindPrev = ({ triggerMethod: triggerMethod })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $5MAgC.findPrevWithAnalytics)(editorAnalyticsAPI, editorView)({
                triggerMethod: triggerMethod
            })));
    };
    const handleReplace = ({ triggerMethod: triggerMethod, replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $5MAgC.replaceWithAnalytics)(editorAnalyticsAPI)({
                triggerMethod: triggerMethod,
                replaceText: replaceText
            })));
    };
    const handleReplaceAll = ({ replaceText: replaceText })=>{
        runWithEditorFocused(()=>dispatchCommand((0, $5MAgC.replaceAllWithAnalytics)(editorAnalyticsAPI)({
                replaceText: replaceText
            })));
    };
    const handleFindBlur = ()=>{
        dispatchCommand((0, $jB8vP.blur)());
    };
    const handleCancel = ({ triggerMethod: triggerMethod })=>{
        dispatchCommand((0, $5MAgC.cancelSearchWithAnalytics)(editorAnalyticsAPI)({
            triggerMethod: triggerMethod
        }));
        editorView.focus();
    };
    const handleToggleMatchCase = ()=>{
        dispatchCommand((0, $jB8vP.toggleMatchCase)());
    };
    if (shouldMatchCase === undefined || isActive === undefined || findText === undefined || replaceText === undefined || index === undefined || matches === undefined || shouldFocus === undefined) return null;
    const DropDownComponent = doesNotHaveButton ? (0, $7YoLh.default) : (0, $aLKuZ.default);
    return /*#__PURE__*/ (0, $3LM7S.jsx)(DropDownComponent, {
        shouldMatchCase: shouldMatchCase,
        onToggleMatchCase: handleToggleMatchCase,
        isActive: isActive,
        findText: findText,
        index: index,
        numMatches: matches.length,
        isReplaceable: (_matches$index = matches[index]) === null || _matches$index === void 0 ? void 0 : _matches$index.canReplace,
        numReplaceable: // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        matches.filter((match)=>match.canReplace === true).length,
        replaceText: replaceText,
        shouldFocus: shouldFocus,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: !!isToolbarReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onFindBlur: handleFindBlur,
        onCancel: handleCancel,
        onActivate: handleActivate,
        onFind: handleFind,
        onFindNext: handleFindNext,
        onFindPrev: handleFindPrev,
        onReplace: handleReplace,
        onReplaceAll: handleReplaceAll,
        takeFullWidth: !!takeFullWidth,
        isButtonHidden: isButtonHidden,
        allowReplace: allowReplace
    });
};
const $059bb5e734eb52bd$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo($059bb5e734eb52bd$var$FindReplaceToolbarButtonWithState);
var $059bb5e734eb52bd$export$2e2bcd8739ae039 = $059bb5e734eb52bd$var$_default_1;

});
parcelRegister("7YoLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $328e49c18cc5b11a$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $3LeME = parcelRequire("3LeME");

var $4mSGa = parcelRequire("4mSGa");

var $2B5bx = parcelRequire("2B5bx");

var $014x6 = parcelRequire("014x6");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $6wtjv = parcelRequire("6wtjv");
const $328e49c18cc5b11a$var$findReplaceWrapperStyles = (0, $kig2V.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
// Magic number taken from ../FindReplaceToolbarButton.tsx
const $328e49c18cc5b11a$var$dropdownWidthNewDesign = 382;
const $328e49c18cc5b11a$var$FindReplaceDropdown = (props)=>{
    const { findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, popupsMountPoint: popupsMountPoint, numReplaceable: numReplaceable, onCancel: onCancel } = props;
    if (!popupsMountPoint) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2B5bx.default), {
        target: popupsMountPoint,
        mountTo: popupsMountPoint,
        forcePlacement: true,
        alignX: 'right',
        alignY: 'start',
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            4,
            0
        ],
        isOpen: isActive,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        handleEscapeKeydown: ()=>{
            if (isActive) onCancel({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).KEYBOARD
            });
        },
        fitWidth: $328e49c18cc5b11a$var$dropdownWidthNewDesign,
        zIndex: (0, $014x6.akEditorFloatingPanelZIndex),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $4mSGa.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: true
        },
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
            xcss: $328e49c18cc5b11a$var$findReplaceWrapperStyles,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6wtjv.default), {
                findText: findText,
                replaceText: replaceText,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                count: {
                    index: index,
                    total: numMatches,
                    totalReplaceable: numReplaceable
                },
                ...props
            })
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $328e49c18cc5b11a$var$_default_1 = (0, $fcCIH.default)($328e49c18cc5b11a$var$FindReplaceDropdown);
var $328e49c18cc5b11a$export$2e2bcd8739ae039 = $328e49c18cc5b11a$var$_default_1;

});
parcelRegister("6wtjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2256da23b5a1974$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $9inWc = parcelRequire("9inWc");

var $1WosJ = parcelRequire("1WosJ");

var $kIY39 = parcelRequire("kIY39");

var $9AURd = parcelRequire("9AURd");
// Magic number taken from ./FindReplaceToolbarButton.tsx
const $c2256da23b5a1974$var$dropdownWidth = 382;
// Without replace the find row is the widest row, so the popup would size to it and
// change width as the match counter appears. Pin it to the width the dropdown reserves.
const $c2256da23b5a1974$var$findOnlyWidthStyles = /*#__PURE__*/ (0, $jctmk.css)({
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$c2256da23b5a1974$var$dropdownWidth}px`,
    maxWidth: '100%'
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c2256da23b5a1974$var$FindReplace extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    constructor(props){
        super(props), this.findTextfield = null, this.replaceTextfield = null, this.state = {
            findTyped: false
        }, this.setFindTyped = (value)=>{
            this.setState({
                findTyped: value
            });
        }, this.setFindTextfieldRef = (findTextfieldRef)=>{
            this.findTextfield = findTextfieldRef.current;
        }, this.setReplaceTextfieldRef = (replaceTextfieldRef)=>{
            this.replaceTextfield = replaceTextfieldRef.current;
        }, this.setFocusToFind = ()=>{
            if (this.findTextfield) this.findTextfield.focus();
        }, this.setFocusToReplace = ()=>{
            if (this.replaceTextfield) this.replaceTextfield.focus();
        };
        this.modalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef();
    }
    render() {
        const { findText: findText, count: count, isReplaceable: isReplaceable, shouldFocus: shouldFocus, onFind: onFind, onFindBlur: onFindBlur, onFindNext: onFindNext, onFindPrev: onFindPrev, onCancel: onCancel, replaceText: replaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, dispatchAnalyticsEvent: dispatchAnalyticsEvent, allowMatchCase: allowMatchCase, shouldMatchCase: shouldMatchCase, onToggleMatchCase: onToggleMatchCase, intl: intl, allowReplace: allowReplace = true } = this.props;
        const focusToolbarButton = this.props.focusToolbarButton || (()=>{});
        return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            role: 'dialog',
            "aria-label": intl === null || intl === void 0 ? void 0 : intl.formatMessage(allowReplace ? (0, $9inWc.findReplaceMessages).findReplaceDialogAriaLabel : (0, $9inWc.findReplaceMessages).findDialogAriaLabel),
            "aria-modal": false,
            ref: this.modalRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $9AURd.wrapperStyles),
                (0, $9AURd.wrapperPaddingStyles),
                !allowReplace && $c2256da23b5a1974$var$findOnlyWidthStyles
            ]
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $1WosJ.default), {
            allowMatchCase: allowMatchCase,
            shouldMatchCase: shouldMatchCase,
            onToggleMatchCase: onToggleMatchCase,
            findText: findText,
            count: count,
            shouldFocus: shouldFocus,
            onFind: onFind,
            onFindBlur: onFindBlur,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            onFindTextfieldRefSet: this.setFindTextfieldRef,
            onCancel: onCancel,
            onArrowDown: this.setFocusToReplace,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped
        }), allowReplace && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("hr", {
            role: "presentation",
            css: (0, $9AURd.ruleStyles),
            id: "replace-hr-element"
        }), /*#__PURE__*/ (0, $jctmk.jsx)((0, $kIY39.default), {
            allowReplace: allowReplace,
            canReplace: !!isReplaceable,
            replaceText: replaceText,
            onReplace: onReplace,
            onReplaceAll: onReplaceAll,
            onReplaceTextfieldRefSet: this.setReplaceTextfieldRef,
            onArrowUp: this.setFocusToFind,
            onCancel: onCancel,
            count: count,
            onFindPrev: onFindPrev,
            onFindNext: onFindNext,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            findTyped: this.state.findTyped,
            setFindTyped: this.setFindTyped,
            focusToolbarButton: focusToolbarButton
        }));
    }
}
var $c2256da23b5a1974$export$2e2bcd8739ae039 = $c2256da23b5a1974$var$FindReplace;

});
parcelRegister("9inWc", function(module, exports) {
$parcel$export(module.exports, "findReplaceMessages", () => $5c6fdb1335bd1903$export$b46a930e1a386b2e);

var $8p5Cv = parcelRequire("8p5Cv");
const $5c6fdb1335bd1903$export$b46a930e1a386b2e = (0, $8p5Cv.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    findReplaceDialogAriaLabel: {
        id: 'fabric.editor.findReplaceDialogAriaLabel',
        defaultMessage: 'Find and Replace',
        description: 'Aria label for the "Find and Replace" dialog'
    },
    findDialogAriaLabel: {
        id: 'fabric.editor.findDialogAriaLabel',
        defaultMessage: 'Find',
        description: 'Aria label for the "Find" dialog, used where the dialog offers find without replace'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Status message shown after a find-and-replace operation completes. The placeholder {numberOfMatches} is the count of replaced matches and controls the plural form (one vs. other).'
    }
});

});

parcelRegister("1WosJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d096b98445b9c16d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $53bjB = parcelRequire("53bjB");

var $PIUl3 = parcelRequire("PIUl3");

var $fcCIH = parcelRequire("fcCIH");

var $3LeME = parcelRequire("3LeME");

var $9inWc = parcelRequire("9inWc");

var $c4WgE = parcelRequire("c4WgE");

var $dgft8 = parcelRequire("dgft8");

var $aEtFp = parcelRequire("aEtFp");

var $iShqg = parcelRequire("iShqg");

var $9AURd = parcelRequire("9AURd");
const $d096b98445b9c16d$export$c7a15a679416091a = 100;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d096b98445b9c16d$var$Find extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    constructor(props){
        super(props), this.findTextfieldRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.isComposing = false, this.syncFindText = (onSynced)=>{
            var _this$state2;
            // If the external prop findText changes and we aren't in a composition we should update to
            // use the external prop value.
            //
            // An example of where this may happen is when a find occurs through the user selecting some text
            // and pressing Mod-f.
            if (!this.isComposing && this.props.findText !== ((_this$state2 = this.state) === null || _this$state2 === void 0 ? void 0 : _this$state2.localFindText)) this.updateFindValue(this.props.findText || '', onSynced);
        }, this.focusFindTextfield = ()=>{
            const input = this.findTextfieldRef.current;
            if (this.props.shouldFocus && input) input.select();
        }, this.handleFindChange = (event)=>{
            this.updateFindValue(event.target.value);
        }, // debounce (vs throttle) to not block typing inside find input while onFind runs
        this.debouncedFind = (0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))((value)=>{
            this.props.onFind(value);
        }, $d096b98445b9c16d$export$c7a15a679416091a), this.updateFindValue = (value, onSynced)=>{
            this.setState({
                localFindText: value
            }, ()=>{
                if (this.isComposing) return;
                onSynced && onSynced();
                this.debouncedFind(value);
            });
            this.props.setFindTyped(true);
        }, // throtlle between animation frames gives better experience on Enter compared to arbitrary value
        // it adjusts based on performance (and document size)
        this.handleFindKeyDownThrottled = (0, $PIUl3.default)((event)=>{
            if (event.key === 'Enter') {
                if (event.shiftKey) this.props.onFindPrev({
                    triggerMethod: (0, $3LeME.TRIGGER_METHOD).KEYBOARD
                });
                else this.props.onFindNext({
                    triggerMethod: (0, $3LeME.TRIGGER_METHOD).KEYBOARD
                });
            } else if (event.key === 'ArrowDown') // we want to move focus between find & replace texfields when user hits up/down arrows
            this.props.onArrowDown();
        }), this.handleFindKeyDown = (event)=>{
            if (this.isComposing) return;
            event.persist();
            this.handleFindKeyDownThrottled(event);
        }, this.handleFindKeyUp = ()=>{
            this.handleFindKeyDownThrottled.cancel();
        }, this.handleFindNextClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindNext({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON
            });
        }, this.handleFindPrevClick = ()=>{
            if (this.isComposing) return;
            this.props.onFindPrev({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON
            });
        }, this.handleCompositionStart = ()=>{
            this.isComposing = true;
            this.debouncedFind.cancel();
        }, this.handleCompositionEnd = (event)=>{
            this.isComposing = false;
            // type for React.CompositionEvent doesn't set type for target correctly
            this.updateFindValue(event.target.value);
        }, this.clearSearch = ()=>{
            this.props.onCancel({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON
            });
        }, this.handleMatchCaseClick = ()=>{
            if (this.props.onToggleMatchCase) {
                this.props.onToggleMatchCase();
                this.props.onFind(this.props.findText);
            }
        }, this.matchCaseIconEle = (iconProps)=>{
            return /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dgft8))), {
                label: iconProps.label,
                size: "small"
            });
        };
        const { intl: { formatMessage: formatMessage } } = props;
        this.find = formatMessage((0, $9inWc.findReplaceMessages).find);
        this.noResultsFound = formatMessage((0, $9inWc.findReplaceMessages).noResultsFound);
        this.matchCase = formatMessage((0, $9inWc.findReplaceMessages).matchCase);
        // We locally manage the value of the input inside this component in order to support compositions.
        // This requires some additional work inside componentDidUpdate to ensure we support changes that
        // occur to this value which do not originate from this component.
        this.state = {
            localFindText: ''
        };
    }
    componentDidMount() {
        this.props.onFindTextfieldRefSet(this.findTextfieldRef);
        // focus initially on dialog mount if there is no find text provided
        if (!this.props.findText) // Wait for findTextfieldRef to become available then focus
        setTimeout(()=>{
            this.focusFindTextfield();
        }, 100);
        this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentDidUpdate(prevProps) {
        var _this$state;
        // focus on update if find text did not change
        if (this.props.findText === ((_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.localFindText)) this.focusFindTextfield();
        if (this.props.findText !== prevProps.findText && this.props.shouldFocus) this.syncFindText(()=>{
            // focus after input is synced if find text provided
            if (this.props.findText) this.focusFindTextfield();
        });
    }
    componentWillUnmount() {
        this.debouncedFind.cancel();
        this.handleFindKeyDownThrottled.cancel();
    }
    render() {
        const { findText: findText, count: count, shouldMatchCase: shouldMatchCase, intl: { formatMessage: formatMessage } } = this.props;
        const resultsCount = formatMessage((0, $9inWc.findReplaceMessages).resultsCount, {
            selectedMatchPosition: count.index + 1,
            totalResultsCount: count.total
        });
        const elemAfterInput = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: (0, $9AURd.afterInputSection)
        }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            "aria-live": "polite"
        }, findText && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("span", {
            "data-testid": "textfield-count",
            css: [
                (0, $9AURd.countStyles),
                (0, $9AURd.countStylesAlternateStyles)
            ]
        }, count.total === 0 ? this.noResultsFound : resultsCount)), /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: (0, $9AURd.matchCaseSection)
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $iShqg.FindReplaceTooltipButton), {
            title: this.matchCase,
            appearance: "default",
            icon: this.matchCaseIconEle,
            iconLabel: this.matchCase,
            onClick: this.handleMatchCaseClick,
            isPressed: shouldMatchCase
        })));
        return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: [
                (0, $9AURd.sectionWrapperStyles),
                (0, $9AURd.sectionWrapperStylesAlternate)
            ]
        }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: (0, $9AURd.textFieldWrapper)
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $c4WgE.Label), {
            htmlFor: "find-text-field"
        }, this.find), /*#__PURE__*/ (0, $jctmk.jsx)((0, $aEtFp.default), {
            name: "find",
            id: "find-text-field",
            testId: "find-field",
            appearance: "standard",
            value: this.state.localFindText,
            ref: this.findTextfieldRef,
            autoComplete: "off",
            onChange: this.handleFindChange,
            onKeyDown: this.handleFindKeyDown,
            onKeyUp: this.handleFindKeyUp,
            onBlur: this.props.onFindBlur,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            elemAfterInput: elemAfterInput
        }))));
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $d096b98445b9c16d$var$_default_1 = (0, $fcCIH.default)($d096b98445b9c16d$var$Find);
var $d096b98445b9c16d$export$2e2bcd8739ae039 = $d096b98445b9c16d$var$_default_1;

});
parcelRegister("dgft8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d1ae50d8cf3e612b44e567e4a30eb2df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9a78c4c5e5e6fbca$var$_react = $9a78c4c5e5e6fbca$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $9a78c4c5e5e6fbca$var$_iconNew = $9a78c4c5e5e6fbca$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $9a78c4c5e5e6fbca$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLetterCase".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-letter-case
 * Usage guidance:
 * Reserved for letter casing and text-transform
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9a78c4c5e5e6fbca$var$TextLetterCaseIcon = (props)=>/*#__PURE__*/ $9a78c4c5e5e6fbca$var$_react.default.createElement($9a78c4c5e5e6fbca$var$_iconNew.default, Object.assign({
        name: "TextLetterCaseIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 13h-1.5v-.38a3.1 3.1 0 0 1-1.87.63c-1.95 0-3.37-1.78-3.37-3.75s1.42-3.75 3.38-3.75c.71 0 1.35.24 1.88.63v-.63H16zm-3.37-5.75c-.94 0-1.87.91-1.87 2.25s.93 2.25 1.88 2.25 1.86-.91 1.86-2.25-.93-2.25-1.87-2.25M5.71 3.51 8.92 13H7.33l-.84-2.5H2.51L1.67 13H.09l3.2-9.49.17-.51h2.08zM3.02 9h2.96L4.5 4.61z" clip-rule="evenodd"/>`
    }, props));
$9a78c4c5e5e6fbca$var$TextLetterCaseIcon.displayName = 'TextLetterCaseIcon';
var $9a78c4c5e5e6fbca$var$_default = module.exports.default = $9a78c4c5e5e6fbca$var$TextLetterCaseIcon;

});

parcelRegister("iShqg", function(module, exports) {
$parcel$export(module.exports, "FindReplaceTooltipButton", () => $d0b18ccf7e7ec001$export$d7a26608845e3a06);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fRCnG = parcelRequire("fRCnG");

var $eUtBU = parcelRequire("eUtBU");

var $bcTS3 = parcelRequire("bcTS3");
class $d0b18ccf7e7ec001$export$d7a26608845e3a06 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    static #_ = this.defaultProps = {
        keymapDescription: 'no-keymap',
        appearance: 'subtle'
    };
    render() {
        const { title: title, icon: Icon, iconSize: iconSize, keymapDescription: keymapDescription, disabled: disabled, isPressed: isPressed, appearance: appearance } = this.props;
        const pressedProps = {
            ...typeof isPressed === 'boolean' && {
                'aria-pressed': isPressed
            }
        };
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
                description: title,
                keymap: (0, $eUtBU.findKeymapByDescription)(keymapDescription)
            }),
            hideTooltipOnClick: true,
            position: 'top',
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fRCnG.default), {
                id: "afterInputSection",
                label: title,
                appearance: appearance,
                testId: title,
                ref: this.buttonRef,
                // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                icon: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
                        ...iconProps,
                        size: iconSize
                    }),
                isDisabled: disabled,
                onClick: this.handleClick,
                isSelected: isPressed,
                ...pressedProps
            })
        });
    }
    constructor(...args){
        super(...args), this.buttonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.handleClick = ()=>{
            this.props.onClick(this.buttonRef);
        };
    }
}

});

parcelRegister("9AURd", function(module, exports) {
$parcel$export(module.exports, "ruleStyles", () => $30d4362693675cad$export$2413e968422424ec);
$parcel$export(module.exports, "wrapperStyles", () => $30d4362693675cad$export$491e6397d7c1480b);
$parcel$export(module.exports, "wrapperPaddingStyles", () => $30d4362693675cad$export$263284dac1af2f8a);
$parcel$export(module.exports, "sectionWrapperStyles", () => $30d4362693675cad$export$4fcc6c669daa3229);
$parcel$export(module.exports, "sectionWrapperStylesAlternate", () => $30d4362693675cad$export$1c21208bb1fdf473);
$parcel$export(module.exports, "textFieldWrapper", () => $30d4362693675cad$export$7910eaff0a3df2fc);
$parcel$export(module.exports, "afterInputSection", () => $30d4362693675cad$export$d449744ea6979b42);
$parcel$export(module.exports, "matchCaseSection", () => $30d4362693675cad$export$24f07703e9463557);
$parcel$export(module.exports, "countStyles", () => $30d4362693675cad$export$1e2581329286cf31);
$parcel$export(module.exports, "countStylesAlternateStyles", () => $30d4362693675cad$export$3fc34436808d2893);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @repo/internal/styles/no-exported-styles */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $014x6 = parcelRequire("014x6");
function $30d4362693675cad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $30d4362693675cad$var$fontSize = 14;
const $30d4362693675cad$export$2413e968422424ec = /*#__PURE__*/ (0, $jctmk.css)({
    width: '100%',
    border: 'none',
    backgroundColor: `${"var(--ds-border, #0B120E24)"}`,
    margin: `${"var(--ds-space-050, 4px)"} 0px`,
    height: '1px',
    borderRadius: "var(--ds-border-width, 1px)"
});
const $30d4362693675cad$export$491e6397d7c1480b = /*#__PURE__*/ (0, $jctmk.css)({
    display: 'flex',
    flexDirection: 'column',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '> *:not(#replace-hr-element)': {
        margin: `0px ${"var(--ds-space-050, 4px)"}`
    }
});
const $30d4362693675cad$export$263284dac1af2f8a = /*#__PURE__*/ (0, $jctmk.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $30d4362693675cad$export$4fcc6c669daa3229 = {
    name: "7ag069",
    styles: "display:flex;& > *{display:inline-flex;height:32px;flex:0 0 auto;}& > [data-ds--text-field--container]{display:flex;flex:1 1 auto;}"
};
const $30d4362693675cad$export$1c21208bb1fdf473 = {
    name: "14m6ydf",
    styles: "display:flex;padding:var(--ds-space-100, 8px);& > *{height:unset;}"
};
const $30d4362693675cad$export$b80151ecaea7abf0 = /*#__PURE__*/ (0, $jctmk.css)({
    justifyContent: 'space-between',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $014x6.relativeFontSizeToBase16)(14)
});
const $30d4362693675cad$export$7910eaff0a3df2fc = /*#__PURE__*/ (0, $jctmk.css)({
    flex: '1 100%',
    flexWrap: 'wrap',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '#find-text-field, #replace-text-field': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${36 / $30d4362693675cad$var$fontSize}em`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    label: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $014x6.relativeFontSizeToBase16)(14),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: '16px'
    }
});
const $30d4362693675cad$export$d449744ea6979b42 = {
    name: "pxta9y",
    styles: "display:flex;flex:0 0 auto;align-items:center"
};
const $30d4362693675cad$export$24f07703e9463557 = {
    name: "1v69wxd",
    styles: "padding-right:var(--ds-space-100, 8px);button{width:20px;height:20px;}"
};
const $30d4362693675cad$export$df58af0590d04217 = /*#__PURE__*/ (0, $jctmk.css)({
    padding: `0px ${"var(--ds-space-025, 2px)"}`
});
const $30d4362693675cad$export$1e2581329286cf31 = /*#__PURE__*/ (0, $jctmk.css)({
    color: `${"var(--ds-text-subtlest, #6B6E76)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
    fontSize: `${(0, $014x6.relativeFontSizeToBase16)(12)}`,
    flex: '0 0 auto',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: "var(--ds-space-050, 4px)",
    marginRight: "var(--ds-space-100, 8px)"
});
const $30d4362693675cad$export$3fc34436808d2893 = {
    name: "1bc3mbb",
    styles: "display:inline-flex;height:32px"
};
const $30d4362693675cad$export$72d821739cf2fba2 = {
    name: "1h3rtzg",
    styles: "align-items:center"
};
const $30d4362693675cad$export$3321a5b8c800c311 = /*#__PURE__*/ (0, $jctmk.css)({
    order: '0',
    marginInline: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
});
const $30d4362693675cad$export$34fb77e33ae94982 = {
    name: "1r7keks",
    styles: "order:1"
};

});


parcelRegister("kIY39", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4785c88bf93745e$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $5dzEI = parcelRequire("5dzEI");

var $3LeME = parcelRequire("3LeME");

var $9inWc = parcelRequire("9inWc");

var $93O7D = parcelRequire("93O7D");

var $13zmE = parcelRequire("13zmE");

var $f69ft = parcelRequire("f69ft");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $4T8rw = parcelRequire("4T8rw");

var $kig2V = parcelRequire("kig2V");

var $aEtFp = parcelRequire("aEtFp");

var $iShqg = parcelRequire("iShqg");
const $b4785c88bf93745e$var$SPACE_REGEX = / /u;
const $b4785c88bf93745e$var$replaceContainerStyles = (0, $kig2V.xcss)({
    padding: 'space.100'
});
const $b4785c88bf93745e$var$replaceWithLabelStyle = (0, $kig2V.xcss)({
    paddingBottom: 'space.050'
});
const $b4785c88bf93745e$var$actionButtonContainerStyles = (0, $kig2V.xcss)({
    paddingTop: 'space.200'
});
// Without the replace field above it, the button row needs no separating space.
const $b4785c88bf93745e$var$findOnlyActionButtonContainerStyles = (0, $kig2V.xcss)({
    paddingTop: 'space.0'
});
const $b4785c88bf93745e$var$actionButtonParentInlineStyles = (0, $kig2V.xcss)({
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
    flexWrap: 'wrap',
    gap: 'space.075'
});
const $b4785c88bf93745e$var$actionButtonInlineStyles = (0, $kig2V.xcss)({
    gap: 'space.075'
});
const $b4785c88bf93745e$var$closeButtonInlineStyles = (0, $kig2V.xcss)({
    marginRight: 'auto'
});
const $b4785c88bf93745e$var$Replace = ({ allowReplace: allowReplace = true, canReplace: canReplace, replaceText: initialReplaceText, onReplace: onReplace, onReplaceAll: onReplaceAll, onReplaceTextfieldRefSet: onReplaceTextfieldRefSet, onArrowUp: onArrowUp, onCancel: onCancel, count: count, onFindNext: onFindNext, onFindPrev: onFindPrev, dispatchAnalyticsEvent: dispatchAnalyticsEvent, setFindTyped: setFindTyped, findTyped: findTyped, focusToolbarButton: focusToolbarButton, intl: { formatMessage: formatMessage } })=>{
    const [replaceText, setReplaceText] = (0, $fc4bM.useState)(initialReplaceText || '');
    const [isComposing, setIsComposing] = (0, $fc4bM.useState)(false);
    const [isHelperMessageVisible, setIsHelperMessageVisible] = (0, $fc4bM.useState)(false);
    const [fakeSuccessReplacementMessageUpdate, setFakeSuccessReplacementMessageUpdate] = (0, $fc4bM.useState)(false);
    const [replaceCount, setReplaceCount] = (0, $fc4bM.useState)(0);
    const replaceTextfieldRef = (0, $fc4bM.useRef)(null);
    const successReplacementMessageRef = (0, $fc4bM.useRef)(null);
    const replaceWith = formatMessage((0, $9inWc.findReplaceMessages).replaceWith);
    const replaceAll = formatMessage((0, $9inWc.findReplaceMessages).replaceAll);
    const findPrevious = formatMessage((0, $9inWc.findReplaceMessages).findPrevious);
    const closeFindReplaceDialog = formatMessage((0, $9inWc.findReplaceMessages).closeFindReplaceDialog);
    (0, $fc4bM.useEffect)(()=>{
        onReplaceTextfieldRefSet(replaceTextfieldRef);
    }, [
        onReplaceTextfieldRefSet
    ]);
    (0, $fc4bM.useEffect)(()=>{
        setReplaceText(initialReplaceText || '');
    }, [
        initialReplaceText
    ]);
    const skipWhileComposing = (fn)=>{
        if (!isComposing) fn();
    };
    const triggerSuccessReplacementMessageUpdate = (currentReplaceCount)=>{
        if (replaceCount === currentReplaceCount) setFakeSuccessReplacementMessageUpdate(!fakeSuccessReplacementMessageUpdate);
        if (successReplacementMessageRef.current) {
            const ariaLiveRegion = successReplacementMessageRef.current.querySelector('[aria-live="polite"]');
            ariaLiveRegion === null || ariaLiveRegion === void 0 || ariaLiveRegion.removeAttribute('aria-live');
            ariaLiveRegion === null || ariaLiveRegion === void 0 || ariaLiveRegion.setAttribute('aria-live', 'polite');
        }
    };
    const handleReplaceClick = ()=>skipWhileComposing(()=>{
            onReplace({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON,
                replaceText: replaceText
            });
            triggerSuccessReplacementMessageUpdate(1);
            setIsHelperMessageVisible(true);
            setReplaceCount(1);
            setFindTyped(false);
        });
    const handleReplaceChange = (event)=>skipWhileComposing(()=>{
            updateReplaceValue(event.target.value);
        });
    const updateReplaceValue = (text)=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            action: (0, $3LeME.ACTION).CHANGED_REPLACEMENT_TEXT,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).FIND_REPLACE_DIALOG
        });
        setReplaceText(text);
    };
    const handleReplaceKeyDown = (event)=>skipWhileComposing(()=>{
            if (event.key === 'Enter') onReplace({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).KEYBOARD,
                replaceText: replaceText
            });
            else if (event.key === 'ArrowUp') onArrowUp();
        });
    const handleReplaceAllClick = ()=>skipWhileComposing(()=>{
            onReplaceAll({
                replaceText: replaceText
            });
            setIsHelperMessageVisible(true);
            if (count.totalReplaceable) {
                triggerSuccessReplacementMessageUpdate(count.totalReplaceable);
                setReplaceCount(count.totalReplaceable);
            } else {
                triggerSuccessReplacementMessageUpdate(count.total);
                setReplaceCount(count.total);
            }
            setFindTyped(false);
        });
    const handleCompositionStart = ()=>{
        setIsComposing(true);
    };
    const handleCompositionEnd = (event)=>{
        setIsComposing(false);
        // type for React.CompositionEvent doesn't set type for target correctly
        updateReplaceValue(event.target.value);
    };
    const clearSearch = ()=>{
        onCancel({
            triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON
        });
        focusToolbarButton();
    };
    const handleFindNextClick = ()=>{
        if (!isComposing) onFindNext({
            triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON
        });
    };
    const handleFindPrevClick = ()=>{
        if (!isComposing) onFindPrev({
            triggerMethod: (0, $3LeME.TRIGGER_METHOD).BUTTON
        });
    };
    const resultsReplace = formatMessage((0, $9inWc.findReplaceMessages).replaceSuccess, {
        numberOfMatches: replaceCount
    });
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5a4EU.Box), {
        xcss: $b4785c88bf93745e$var$replaceContainerStyles,
        children: [
            allowReplace && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
                        xcss: $b4785c88bf93745e$var$replaceWithLabelStyle,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4T8rw.Text), {
                            id: "replace-text-field-label",
                            size: "medium",
                            weight: "bold",
                            color: "color.text.subtle",
                            children: replaceWith
                        })
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $aEtFp.default), {
                        name: "replace",
                        "aria-labelledby": "replace-text-field-label",
                        testId: "replace-field",
                        appearance: "standard",
                        defaultValue: replaceText,
                        ref: replaceTextfieldRef,
                        autoComplete: "off",
                        onChange: handleReplaceChange,
                        onKeyDown: handleReplaceKeyDown,
                        onCompositionStart: handleCompositionStart,
                        onCompositionEnd: handleCompositionEnd
                    }),
                    isHelperMessageVisible && !findTyped && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        ref: successReplacementMessageRef,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $93O7D.ValidMessage), {
                            testId: "message-success-replacement",
                            children: fakeSuccessReplacementMessageUpdate ? resultsReplace.replace($b4785c88bf93745e$var$SPACE_REGEX, '\u00a0') : resultsReplace
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
                xcss: allowReplace ? $b4785c88bf93745e$var$actionButtonContainerStyles : $b4785c88bf93745e$var$findOnlyActionButtonContainerStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $lgMZ2.Inline), {
                    xcss: $b4785c88bf93745e$var$actionButtonParentInlineStyles,
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $lgMZ2.Inline), {
                            xcss: $b4785c88bf93745e$var$actionButtonInlineStyles,
                            children: [
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iShqg.FindReplaceTooltipButton), {
                                    title: formatMessage((0, $9inWc.findReplaceMessages).findNext),
                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: formatMessage((0, $9inWc.findReplaceMessages).findNext),
                                    keymapDescription: 'Enter',
                                    onClick: handleFindNextClick,
                                    disabled: count.total <= 1
                                }),
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iShqg.FindReplaceTooltipButton), {
                                    title: findPrevious,
                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f69ft))), {
                                            label: iconProps.label,
                                            size: "small"
                                        }),
                                    iconLabel: findPrevious,
                                    keymapDescription: 'Shift Enter',
                                    onClick: handleFindPrevClick,
                                    disabled: count.total <= 1
                                }),
                                allowReplace && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                                            testId: 'Replace',
                                            id: "replace-button",
                                            onClick: handleReplaceClick,
                                            isDisabled: !canReplace,
                                            children: formatMessage((0, $9inWc.findReplaceMessages).replace)
                                        }),
                                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                                            appearance: "primary",
                                            testId: replaceAll,
                                            id: "replaceAll-button",
                                            onClick: handleReplaceAllClick,
                                            isDisabled: count.totalReplaceable === 0,
                                            children: replaceAll
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lgMZ2.Inline), {
                            xcss: $b4785c88bf93745e$var$closeButtonInlineStyles,
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                                appearance: "subtle",
                                testId: closeFindReplaceDialog,
                                onClick: clearSearch,
                                children: closeFindReplaceDialog
                            })
                        })
                    ]
                })
            })
        ]
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $b4785c88bf93745e$var$_default_1 = (0, $fcCIH.default)($b4785c88bf93745e$var$Replace);
var $b4785c88bf93745e$export$2e2bcd8739ae039 = $b4785c88bf93745e$var$_default_1;

});



parcelRegister("aLKuZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $095f1d592fb6401b$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $3LeME = parcelRequire("3LeME");

var $96Lo5 = parcelRequire("96Lo5");

var $eUtBU = parcelRequire("eUtBU");

var $9inWc = parcelRequire("9inWc");

var $4mSGa = parcelRequire("4mSGa");

var $2B5bx = parcelRequire("2B5bx");

var $7h5CJ = parcelRequire("7h5CJ");

var $014x6 = parcelRequire("014x6");

var $8K7DG = parcelRequire("8K7DG");

var $6wtjv = parcelRequire("6wtjv");
function $095f1d592fb6401b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $095f1d592fb6401b$var$toolbarButtonWrapper = /*#__PURE__*/ (0, $jctmk.css)("display:flex;flex:1 1 auto;flex-grow:0;justify-content:flex-end;align-items:center;padding:0 var(--ds-space-100, 8px);@media (max-width: ", (0, $014x6.akEditorMobileMaxWidth), "px){justify-content:center;padding:0;}");
const $095f1d592fb6401b$var$TriggerButtonWrapper = ({ isButtonHidden: isButtonHidden, children: children })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $jctmk.css)({
            display: isButtonHidden ? 'none' : 'block'
        })
    }, children);
};
const $095f1d592fb6401b$var$toolbarButtonWrapperFullWidth = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $095f1d592fb6401b$var$toolbarButtonWrapperHidden = {
    name: "n1rao0",
    styles: "flex-grow:0;padding:0"
};
const $095f1d592fb6401b$var$wrapper = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $095f1d592fb6401b$var$dropdownWidthNewDesign = 382;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $095f1d592fb6401b$var$FindReplaceToolbarButton extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).PureComponent {
    render() {
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, findText: findText, replaceText: replaceText, isActive: isActive, index: index, numMatches: numMatches, numReplaceable: numReplaceable, intl: { formatMessage: formatMessage }, takeFullWidth: takeFullWidth, isButtonHidden: isButtonHidden = false } = this.props;
        const title = formatMessage((0, $9inWc.findReplaceMessages).findReplaceToolbarButton);
        const stackBelowOtherEditorFloatingPanels = (0, $014x6.akEditorFloatingPanelZIndex) - 1;
        const keymap = (0, $eUtBU.findKeymapByDescription)('Find');
        return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: [
                $095f1d592fb6401b$var$toolbarButtonWrapper,
                takeFullWidth && $095f1d592fb6401b$var$toolbarButtonWrapperFullWidth,
                isButtonHidden && $095f1d592fb6401b$var$toolbarButtonWrapperHidden
            ]
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $2B5bx.default), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isActive,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEscapeKeydown: ()=>{
                if (isActive) {
                    this.props.onCancel({
                        triggerMethod: (0, $3LeME.TRIGGER_METHOD).KEYBOARD
                    });
                    if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
                    this.setState({
                        openedByClick: false
                    });
                }
            },
            fitWidth: $095f1d592fb6401b$var$dropdownWidthNewDesign,
            zIndex: stackBelowOtherEditorFloatingPanels,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $4mSGa.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: true
            },
            trigger: /*#__PURE__*/ (0, $jctmk.jsx)($095f1d592fb6401b$var$TriggerButtonWrapper, {
                isButtonHidden: isButtonHidden
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $7h5CJ.default), {
                buttonId: (0, $96Lo5.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE,
                testId: `editor-toolbar__${(0, $96Lo5.TOOLBAR_ACTION_SUBJECT_ID).FIND_REPLACE}`,
                spacing: isReducedSpacing ? 'none' : 'default',
                selected: isActive,
                title: /*#__PURE__*/ (0, $jctmk.jsx)((0, $eUtBU.ToolTipContent), {
                    description: title,
                    keymap: keymap
                }),
                iconBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8K7DG))), {
                    label: title,
                    spacing: "spacious"
                }),
                onClick: this.toggleOpen,
                "aria-expanded": isActive,
                "aria-haspopup": true,
                "aria-label": keymap ? (0, $eUtBU.tooltip)(keymap, title) : title,
                "aria-keyshortcuts": (0, $eUtBU.getAriaKeyshortcuts)(keymap),
                ref: this.toolbarButtonRef
            }))
        }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: $095f1d592fb6401b$var$wrapper
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $6wtjv.default), {
            findText: findText,
            replaceText: replaceText,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            count: {
                index: index,
                total: numMatches,
                totalReplaceable: numReplaceable
            },
            focusToolbarButton: this.focusToolbarButton,
            ...this.props
        }))));
    }
    constructor(...args){
        super(...args), this.state = {
            openedByClick: false
        }, this.toggleOpen = ()=>{
            if (this.props.isActive) this.props.onCancel({
                triggerMethod: (0, $3LeME.TRIGGER_METHOD).TOOLBAR
            });
            else {
                this.setState({
                    openedByClick: true
                });
                this.props.onActivate();
            }
        }, this.focusToolbarButton = ()=>{
            if (this.state.openedByClick && this.toolbarButtonRef.current) this.toolbarButtonRef.current.focus();
            this.setState({
                openedByClick: false
            });
        }, this.toolbarButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef();
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $095f1d592fb6401b$var$_default_1 = (0, $fcCIH.default)($095f1d592fb6401b$var$FindReplaceToolbarButton);
var $095f1d592fb6401b$export$2e2bcd8739ae039 = $095f1d592fb6401b$var$_default_1;

});



parcelRegister("8W6hw", function(module, exports) {
$parcel$export(module.exports, "fragmentPlugin", () => $3b7e9c87f7a20320$export$36fc1707093eff41);

var $ipVDa = parcelRequire("ipVDa");

var $01d2B = parcelRequire("01d2B");
const $3b7e9c87f7a20320$export$36fc1707093eff41 = ()=>({
        name: 'fragmentPlugin',
        marks () {
            return [
                {
                    name: 'fragment',
                    mark: (0, $ipVDa.fragment)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'fragmentMarkConsistency',
                    plugin: ({ dispatch: dispatch })=>(0, $01d2B.createPlugin)(dispatch)
                }
            ];
        }
    });

});
parcelRegister("01d2B", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $ab3360ec9dfc5f73$export$ae829ec7b2625219);
/**
 * This plugin ensures that certain nodes (such as tables, and various extension ones)
 * have a unique `localId` attribute value for `fragment` marks.
 * It also ensures the preservation of these IDs when nodes are being cut-and-pasted
 * around the document.
 *
 * The implementation has been _heavily_ borrowed from
 * - packages/editor/editor-core/src/plugins/table/pm-plugins/table-local-id.ts
 */ 
var $1FHzN = parcelRequire("1FHzN");

var $1y7gE = parcelRequire("1y7gE");

var $8E9x2 = parcelRequire("8E9x2");

var $801jp = parcelRequire("801jp");
const $ab3360ec9dfc5f73$var$pluginKey = new (0, $801jp.PluginKey)('fragmentMarkConsistencyPlugin');
const $ab3360ec9dfc5f73$var$getNodesSupportingFragmentMark = (schema)=>{
    const { table: table, extension: extension, bodiedExtension: bodiedExtension, inlineExtension: inlineExtension } = schema.nodes;
    return [
        table,
        extension,
        bodiedExtension,
        inlineExtension
    ];
};
const $ab3360ec9dfc5f73$export$ae829ec7b2625219 = (dispatch)=>new (0, $1y7gE.SafePlugin)({
        key: $ab3360ec9dfc5f73$var$pluginKey,
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { fragment: fragment } = newState.schema.marks;
            const supportedNodeTypes = $ab3360ec9dfc5f73$var$getNodesSupportingFragmentMark(newState.schema);
            const addedSupportedNodes = new Set();
            const addedSupportedNodesPos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                const changedNodes = (0, $8E9x2.getChangedNodes)(transaction);
                for (const { node: node } of changedNodes){
                    if (!supportedNodeTypes.includes(node.type)) continue;
                    addedSupportedNodes.add(node);
                }
            });
            if (!addedSupportedNodes.size) return;
            // Get existing fragment marks localIds on the page
            newState.doc.descendants((node, pos)=>{
                if (addedSupportedNodes.has(node)) {
                    addedSupportedNodesPos.set(node, pos);
                    return true;
                }
                if (!supportedNodeTypes.includes(node.type)) return true;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) // continue traversing
                return true;
                localIds.add(existingFragmentMark.attrs.localId);
                return true;
            });
            // If an added node has localId that collides with existing node, generate new localId
            for (const node of addedSupportedNodes){
                const pos = addedSupportedNodesPos.get(node);
                if (pos === undefined) continue;
                const existingFragmentMark = node.marks.find((mark)=>mark.type === fragment);
                if (!existingFragmentMark) continue;
                if (localIds.has(existingFragmentMark.attrs.localId)) {
                    tr.setNodeMarkup(pos, undefined, node.attrs, node.marks.map((mark)=>{
                        if (mark.type !== fragment) return mark;
                        const fragmentMark = fragment.create({
                            ...mark.attrs,
                            localId: (0, $1FHzN.uuid).generate(),
                            name: null
                        });
                        return fragmentMark;
                    }));
                    modified = true;
                }
            }
            if (modified) return tr;
            return;
        }
    });

});


parcelRegister("8gEFI", function(module, exports) {
$parcel$export(module.exports, "helpDialogPlugin", () => $5092dc55e4f700ae$export$b3faa25d392107e4);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $eVKpX = parcelRequire("eVKpX");

var $eUtBU = parcelRequire("eUtBU");

var $cT0LQ = parcelRequire("cT0LQ");

var $kaFRI = parcelRequire("kaFRI");

var $k9SQA = parcelRequire("k9SQA");

var $cAckk = parcelRequire("cAckk");

var $jpAVp = parcelRequire("jpAVp");

var $a4Dxf = parcelRequire("a4Dxf");

var $6m97x = parcelRequire("6m97x");

var $jrFZj = parcelRequire("jrFZj");
/**
 * Normalise the caller-supplied config into a single, predictable shape.
 * – Boolean → "image uploads on/off", AI always off
 * – Object  → pick the two feature flags with sane defaults (both false)
 */ function $5092dc55e4f700ae$var$parseFeatureConfig(config) {
    if (typeof config === 'boolean') return {
        imageUploadProviderExists: config,
        aiEnabled: false
    };
    // Object path – ensure we never return undefined
    const { imageUploadProviderExists: imageUploadProviderExists = false, aiEnabled: aiEnabled = false } = config ?? {};
    return {
        imageUploadProviderExists: imageUploadProviderExists,
        aiEnabled: aiEnabled
    };
}
const $5092dc55e4f700ae$export$b3faa25d392107e4 = ({ config: config, api: api })=>{
    const { imageUploadProviderExists: imageUploadProviderExists, aiEnabled: aiEnabled } = $5092dc55e4f700ae$var$parseFeatureConfig(config);
    return {
        name: 'helpDialog',
        pmPlugins () {
            return [
                {
                    name: 'helpDialog',
                    plugin: ({ dispatch: dispatch })=>(0, $a4Dxf.createPlugin)(dispatch, imageUploadProviderExists, aiEnabled)
                },
                {
                    name: 'helpDialogKeymap',
                    plugin: ()=>{
                        var _api$analytics;
                        return (0, $jpAVp.keymapPlugin)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
                    }
                }
            ];
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'helpdialog',
                        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).help),
                        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).helpDescription),
                        keywords: [
                            '?'
                        ],
                        priority: 4000,
                        keyshortcut: (0, $eUtBU.tooltip)((0, $eUtBU.openHelp)),
                        icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kaFRI))), {
                                label: "",
                                color: "currentColor",
                                spacing: "spacious"
                            }),
                        action (insert) {
                            var _api$analytics2;
                            const tr = insert('');
                            (0, $cAckk.openHelpCommand)(tr);
                            api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent({
                                action: (0, $3LeME.ACTION).HELP_OPENED,
                                actionSubject: (0, $3LeME.ACTION_SUBJECT).HELP,
                                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).HELP_QUICK_INSERT,
                                attributes: {
                                    inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $3LeME.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        },
        contentComponent ({ editorView: editorView }) {
            if (!editorView || (0, $eVKpX.isSSR)()) return null;
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jrFZj.HelpDialogLoader), {
                pluginInjectionApi: api,
                editorView: editorView,
                quickInsertEnabled: !!(api !== null && api !== void 0 && api.quickInsert)
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $6m97x.pluginKey).getState(editorState) || null;
        },
        actions: {
            openHelp: ()=>{
                return api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>(0, $k9SQA.openHelpAction)(tr));
            },
            closeHelp: ()=>{
                return api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>(0, $k9SQA.closeHelpAction)(tr));
            }
        }
    };
};

});
parcelRegister("k9SQA", function(module, exports) {
$parcel$export(module.exports, "openHelpAction", () => $aa240b98acf9ca60$export$2dac2f8389fd3a8c);
$parcel$export(module.exports, "closeHelpAction", () => $aa240b98acf9ca60$export$c54ba5c26d7768da);

var $6m97x = parcelRequire("6m97x");
const $aa240b98acf9ca60$export$2dac2f8389fd3a8c = (tr)=>{
    return tr.setMeta((0, $6m97x.pluginKey), true);
};
const $aa240b98acf9ca60$export$c54ba5c26d7768da = (tr)=>{
    return tr.setMeta((0, $6m97x.pluginKey), false);
};

});
parcelRegister("6m97x", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $53fe9217b7c94763$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $53fe9217b7c94763$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('helpDialogPlugin');

});


parcelRegister("cAckk", function(module, exports) {
$parcel$export(module.exports, "openHelpCommand", () => $753a796a0cd35fbb$export$e7832c5f11de3579);
$parcel$export(module.exports, "closeHelpCommand", () => $753a796a0cd35fbb$export$fd5f4180482ea9ed);

var $6m97x = parcelRequire("6m97x");
const $753a796a0cd35fbb$export$e7832c5f11de3579 = (tr, dispatch)=>{
    tr = tr.setMeta((0, $6m97x.pluginKey), true);
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
const $753a796a0cd35fbb$export$fd5f4180482ea9ed = (tr, dispatch)=>{
    tr = tr.setMeta((0, $6m97x.pluginKey), false);
    dispatch(tr);
};

});

parcelRegister("jpAVp", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $f7683faa04152adb$export$e832373cff8dec22);

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $1O8Lw = parcelRequire("1O8Lw");

var $cAckk = parcelRequire("cAckk");

var $6m97x = parcelRequire("6m97x");
const $f7683faa04152adb$export$e832373cff8dec22 = (editorAnalyticsAPI)=>{
    const list = {};
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.openHelp).common, (state, dispatch)=>{
        const { tr: tr } = state;
        const isVisible = tr.getMeta((0, $6m97x.pluginKey));
        if (!isVisible) {
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $3LeME.ACTION).CLICKED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).BUTTON_HELP,
                attributes: {
                    inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
                },
                eventType: (0, $3LeME.EVENT_TYPE).UI
            })(tr);
            (0, $cAckk.openHelpCommand)(tr, dispatch);
        }
        return true;
    }, list);
    return (0, $1O8Lw.keymap)(list);
};

});

parcelRegister("a4Dxf", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $419816ece2fed907$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $6m97x = parcelRequire("6m97x");
function $419816ece2fed907$export$ae829ec7b2625219(dispatch, imageEnabled, aiEnabled) {
    return new (0, $1y7gE.SafePlugin)({
        key: (0, $6m97x.pluginKey),
        state: {
            init () {
                return {
                    isVisible: false,
                    imageEnabled: imageEnabled,
                    aiEnabled: aiEnabled
                };
            },
            apply (tr, _value, state) {
                const isVisible = tr.getMeta((0, $6m97x.pluginKey));
                const currentState = (0, $6m97x.pluginKey).getState(state);
                if (isVisible !== undefined && isVisible !== currentState.isVisible) {
                    const newState = {
                        ...currentState,
                        isVisible: isVisible
                    };
                    dispatch((0, $6m97x.pluginKey), newState);
                    return newState;
                }
                return currentState;
            }
        }
    });
}

});

parcelRegister("jrFZj", function(module, exports) {
$parcel$export(module.exports, "HelpDialogLoader", () => $63a017d9a24e2681$export$e97fc21b7bb6adc7);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $ieUrC = parcelRequire("ieUrC");

var $bcN2K = parcelRequire("bcN2K");

const $63a017d9a24e2681$var$HelpDialogLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("k4txP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $63a017d9a24e2681$var$HelpDialogLazy = (0, $ieUrC.lazyForPaint)(()=>(parcelRequire("k4txP")).then((mod)=>mod.default), {
    moduleId: "../platform/packages/editor/editor-plugin-help-dialog/src/ui/index.tsx"
});
const $63a017d9a24e2681$export$e97fc21b7bb6adc7 = (props)=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ieUrC.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($63a017d9a24e2681$var$HelpDialogLazy, {
            ...props
        })
    }) : /* eslint-disable-next-line react/jsx-props-no-spreading -- forward the loader props to the dialog */ /*#__PURE__*/ (0, $3LM7S.jsx)($63a017d9a24e2681$var$HelpDialogLoadable, {
        ...props
    });
$63a017d9a24e2681$export$e97fc21b7bb6adc7.preload = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $63a017d9a24e2681$var$HelpDialogLazy.preload() : $63a017d9a24e2681$var$HelpDialogLoadable.preload();

});
parcelRegister("k4txP", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("2iUdx").then(()=>parcelRequire('dqhRd'));

});



parcelRegister("lqHJB", function(module, exports) {
$parcel$export(module.exports, "messages", () => $dfde93866a281e5e$export$defe85febe8b728c);

var $8p5Cv = parcelRequire("8p5Cv");
const $dfde93866a281e5e$export$defe85febe8b728c = (0, $8p5Cv.defineMessages)({
    tableScrollRegion: {
        id: 'fabric.editor.tableScrollRegion',
        defaultMessage: 'Table scroll region',
        description: 'Label for the scrollable region of a table, used for accessibility purposes.'
    },
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'The text is shown as a menu item in the table options dropdown when the user wants to collapse a table by wrapping it inside an expand element.'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip text shown when hovering over the table width resize handle. Indicates users can drag to adjust the table width.'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table columns to delete them. The message adapts for singular or plural columns.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Label for the table context menu item that inserts a new empty row directly above the currently selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Label for the table context menu item that inserts a new empty row directly below the currently selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Label for the table menu item that moves the selected column(s) one position to the left. The placeholder {0} is the number of columns being moved and controls the plural form.'
    },
    moveColumnLeftHelpDialogLabel: {
        id: 'fabric.editor.moveColumnLeftHelpDialogLabel',
        defaultMessage: 'Move column left',
        description: 'Description of a keymap that moves one column or multiple columns left, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Label for the table menu item that moves the selected column(s) one position to the right. The placeholder {0} is the number of columns being moved and controls the plural form.'
    },
    moveColumnRightHelpDialogLabel: {
        id: 'fabric.editor.moveColumnRightHelpDialogLabel',
        defaultMessage: 'Move column right',
        description: 'Description of a keymap that moves one column or multiple columns right, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Label for the table menu item that moves the selected row(s) one position upward. The placeholder {0} is the number of rows being moved and controls the plural form.'
    },
    moveRowUpHelpDialogLabel: {
        id: 'fabric.editor.moveRowUpHelpDialogLabel',
        defaultMessage: 'Move row up',
        description: 'Description of a keymap that moves one row or multiple rows up, this is in the help dialog and can be simpler than the puralisation version'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Label for the table menu item that moves the selected row(s) one position downward. The placeholder {0} is the number of rows being moved and controls the plural form.'
    },
    moveRowDownHelpDialogLabel: {
        id: 'fabric.editor.moveRowDownHelpDialogLabel',
        defaultMessage: 'Move row down',
        description: 'Description of a keymap that moves one row or multiple rows down, this is in the help dialog and can be simpler than the puralisation version'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'The text is shown as a menu item or button when the user selects one or more table rows to delete them. The message adapts for singular or plural rows.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    numberedRows: {
        id: 'fabrid.editor.numberedRows',
        defaultMessage: 'Numbered rows',
        description: 'The text is shown as a label for a toggle option in the table options menu that adds a number to each row except the header row.'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    rowSelected: {
        id: 'fabric.editor.rowSelected',
        defaultMessage: 'Row {index} of {total} selected',
        description: 'Assistive message following the selection of a row'
    },
    rowMovedUp: {
        id: 'fabric.editor.rowMovedUp',
        defaultMessage: 'Row moved up to {index} of {total}',
        description: 'Assistive message following the upward movement of a row'
    },
    rowMovedDown: {
        id: 'fabric.editor.rowMovedDown',
        defaultMessage: 'Row moved down to {index} of {total}',
        description: 'Assistive message following the downward movement of a row'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    columnSelected: {
        id: 'fabric.editor.columnSelected',
        defaultMessage: 'Column {index} of {total} selected',
        description: 'Assistive message following the selection of a column'
    },
    columnMovedLeft: {
        id: 'fabric.editor.columnMovedLeft',
        defaultMessage: 'Column moved left to {index} of {total}',
        description: 'Assistive message following the left movement of a column'
    },
    columnMovedRight: {
        id: 'fabric.editor.columnMovedRight',
        defaultMessage: 'Column moved right to {index} of {total}',
        description: 'Assistive message following the right movement of a column'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'Text prefix shown at the start of a confirmation dialog message when the user is about to delete a linked element in the editor.'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'The text is shown as a checkbox label in a confirmation dialog when the user is about to delete an element that has connected extensions.'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    cellAlignment: {
        id: 'fabric.editor.table.cellAlignment',
        defaultMessage: 'Alignment',
        description: 'Label for a nested menu that aligns content vertically inside a table cell.'
    },
    cellAlignmentTop: {
        id: 'fabric.editor.table.cellAlignmentTop',
        defaultMessage: 'Top',
        description: 'Label for an option that aligns table cell content to the top.'
    },
    cellAlignmentMiddle: {
        id: 'fabric.editor.table.cellAlignmentMiddle',
        defaultMessage: 'Middle',
        description: 'Label for an option that aligns table cell content to the middle.'
    },
    cellAlignmentBottom: {
        id: 'fabric.editor.table.cellAlignmentBottom',
        defaultMessage: 'Bottom',
        description: 'Label for an option that aligns table cell content to the bottom.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'The text is shown as a menu item in the cell options menu when the user selects multiple table cells to merge them into a single cell.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'The text is shown as a menu item in the cell options menu when the user wants to split a previously merged table cell back into individual cells.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Label for the table column menu item that sorts the column alphabetically in ascending (A to Z) order.'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Label for the table column menu item that sorts the column alphabetically in descending (Z to A) order.'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Label for the table column menu item that sorts numerical or date column values in increasing order.'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Label for the table column menu item that sorts numerical or date column values in decreasing order.'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    canNotSortTableNoIcon: {
        id: 'fabric.editor.canNotSortTableNoIcon',
        defaultMessage: `You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    canNotMoveColumnLeftWithMergedCells: {
        id: 'editor-common.messages.table.canNotMoveColumnLeftWithMergedCells',
        defaultMessage: `You can't move a column left with merged cells`,
        description: `Explains why the move column left option is unavailable`
    },
    canNotMoveColumnRightWithMergedCells: {
        id: 'editor-common.messages.table.canNotMoveColumnRightWithMergedCells',
        defaultMessage: `You can't move a column right with merged cells`,
        description: `Explains why the move column right option is unavailable`
    },
    canNotMoveRowDownWithMergedCells: {
        id: 'editor-common.messages.table.canNotMoveRowDownWithMergedCells',
        defaultMessage: `You can't move a row down with merged cells`,
        description: `Explains why the move row down option is unavailable`
    },
    canNotMoveRowUpWithMergedCells: {
        id: 'editor-common.messages.table.canNotMoveRowUpWithMergedCells',
        defaultMessage: `You can't move a row up with merged cells`,
        description: `Explains why the move row up option is unavailable`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    fitToContent: {
        id: 'fabric.editor.fitToContent',
        defaultMessage: `Fit to content`,
        description: `Resize table columns to fit their content`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    dragHandleZone: {
        id: 'fabric.editor.dragHandleZone',
        defaultMessage: 'Activate drag handle zone',
        description: 'The drag handle zone to trigger the drag handle to move the row/column within the table.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Label for the button in the table toolbar that switches the table to full-width display mode, expanding it to fill the page width.'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the center of the page.'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a menu item in the table alignment options menu when the user wants to align the table to the left side of the page.'
    }
});

});

parcelRegister("a2Dck", function(module, exports) {
$parcel$export(module.exports, "selectIntoLayoutSection", () => $4dd341de630051fd$export$abf76f127fb6937c);
$parcel$export(module.exports, "layoutPlugin", () => $4dd341de630051fd$export$2229806460c545ea);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2KlGf = parcelRequire("2KlGf");

var $9XvY7 = parcelRequire("9XvY7");

var $3LeME = parcelRequire("3LeME");

var $7vlqQ = parcelRequire("7vlqQ");

var $bMe57 = parcelRequire("bMe57");

var $c2wgC = parcelRequire("c2wgC");

var $cT0LQ = parcelRequire("cT0LQ");

var $csQ9c = parcelRequire("csQ9c");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $3sx0g = parcelRequire("3sx0g");

var $femcY = parcelRequire("femcY");

var $ksiVK = parcelRequire("ksiVK");

var $8WbPO = parcelRequire("8WbPO");

var $bQi3l = parcelRequire("bQi3l");

var $3PyFo = parcelRequire("3PyFo");

var $4qNQh = parcelRequire("4qNQh");

var $8bJhK = parcelRequire("8bJhK");

var $fxGwF = parcelRequire("fxGwF");

var $h965D = parcelRequire("h965D");

var $jBrrU = parcelRequire("jBrrU");
const $4dd341de630051fd$var$LAYOUT_SECTION_NODE_NAME = 'layoutSection';
const $4dd341de630051fd$export$abf76f127fb6937c = (tr)=>{
    var _nodeWithPos$node$fir;
    if (!(0, $kaRof.editorExperiment)('single_column_layouts', true)) return tr;
    const { layoutSection: layoutSection, paragraph: paragraph } = tr.doc.type.schema.nodes;
    const nodeWithPos = (0, $a4TQr.findParentNode)((node)=>node.type === layoutSection)(tr.selection);
    if (!nodeWithPos || !nodeWithPos.node || nodeWithPos.node.type.name !== 'layoutSection' || ((_nodeWithPos$node$fir = nodeWithPos.node.firstChild) === null || _nodeWithPos$node$fir === void 0 || (_nodeWithPos$node$fir = _nodeWithPos$node$fir.firstChild) === null || _nodeWithPos$node$fir === void 0 ? void 0 : _nodeWithPos$node$fir.type) !== paragraph) return tr;
    // set text selection at the beginning of the layout section
    // will set the selection to the first column
    tr.setSelection((0, $801jp.TextSelection).create(tr.doc, nodeWithPos.pos));
    return tr;
};
const $4dd341de630051fd$export$2229806460c545ea = ({ config: options = {}, api: api })=>{
    var _api$blockMenu, _api$uiControlRegistr, _api$analytics2;
    const isAdvancedLayoutEnabled = (0, $kaRof.editorExperiment)('advanced_layouts', true);
    const allowAdvancedSingleColumnLayout = isAdvancedLayoutEnabled && (0, $kaRof.editorExperiment)('single_column_layouts', true, {
        exposure: true
    });
    const isRegisteredSlashCommandEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command') && isAdvancedLayoutEnabled;
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $bMe57.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $bMe57.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $c2wgC.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $bMe57.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]
            },
            component: (0, $4qNQh.createLayoutBlockMenuItem)(api),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($4dd341de630051fd$var$LAYOUT_SECTION_NODE_NAME));
            }
        }
    ]);
    api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $fxGwF.getLayoutColumnMenuComponents)({
        api: api
    }));
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr2;
        api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 || _api$uiControlRegistr2.actions.register((0, $h965D.getLayoutQuickInsertComponents)({
            api: api
        }));
    }
    return {
        name: 'layout',
        nodes () {
            return [
                {
                    name: 'layoutSection',
                    node: (0, $kaRof.editorExperiment)('advanced_layouts', true) ? (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $2KlGf.layoutSectionWithSingleColumnLocalId) : (0, $2KlGf.layoutSectionWithSingleColumn) : (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $2KlGf.layoutSectionWithLocalId) : (0, $2KlGf.layoutSection)
                },
                {
                    name: 'layoutColumn',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $9XvY7.layoutColumnWithLocalId) : (0, $9XvY7.layoutColumn)
                }
            ];
        },
        pmPlugins () {
            const isViewMode = ()=>{
                var _api$editorViewMode;
                return (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
            };
            const plugins = [
                {
                    name: 'layout',
                    plugin: ()=>{
                        var _api$analytics;
                        return (0, $ksiVK.default)(options, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, isViewMode);
                    }
                }
            ];
            plugins.push({
                name: 'layoutKeymap',
                plugin: ()=>(0, $femcY.default)({
                        api: api
                    })
            });
            if ((options.editorAppearance === 'full-page' || options.editorAppearance === 'full-width' || options.editorAppearance === 'max') && api && (0, $kaRof.editorExperiment)('advanced_layouts', true)) plugins.push({
                name: 'layoutResizing',
                plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>(0, $bQi3l.default)(options, api, portalProviderAPI, eventDispatcher, getIntl())
            });
            return plugins;
        },
        actions: {
            insertLayoutColumns: (0, $3sx0g.insertLayoutColumnsWithAnalytics)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                const layoutState = (0, $8WbPO.pluginKey).getState(state);
                if (!layoutState) return undefined;
                const { pos: pos, allowBreakout: allowBreakout, addSidebarLayouts: addSidebarLayouts, allowSingleColumnLayout: allowSingleColumnLayout, isResizing: isResizing } = layoutState;
                const shouldHideToolbar = isResizing && (0, $kaRof.editorExperiment)('single_column_layouts', true);
                if (pos !== null && !shouldHideToolbar) return (0, $jBrrU.buildToolbar)(state, intl, pos, allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api);
                return undefined;
            },
            quickInsert: isRegisteredSlashCommandEnabled ? undefined : ({ formatMessage: formatMessage })=>{
                const withInsertLayoutAnalytics = (tr, columnCount)=>{
                    var _api$analytics3;
                    api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || (_api$analytics3 = _api$analytics3.actions) === null || _api$analytics3 === void 0 || _api$analytics3.attachAnalyticsEvent({
                        action: (0, $3LeME.ACTION).INSERTED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT,
                        attributes: {
                            inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT,
                            columnCount: columnCount
                        },
                        eventType: (0, $3LeME.EVENT_TYPE).TRACK
                    })(tr);
                    return tr;
                };
                if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) {
                    const createAdvancedColumnLayoutOption = ({ columnCount: columnCount, descriptionColumnCount: descriptionColumnCount, icon: Icon, id: id, keyword: keyword, title: title })=>({
                            id: id,
                            title: title,
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
                                numberOfColumns: descriptionColumnCount
                            }),
                            keywords: [
                                'layout',
                                'column',
                                'section',
                                'col',
                                keyword
                            ],
                            priority: 1100,
                            icon: Icon,
                            action (insert, state) {
                                const tr = insert((0, $3sx0g.createMultiColumnLayoutSection)(state, columnCount));
                                withInsertLayoutAnalytics(tr, columnCount);
                                $4dd341de630051fd$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        });
                    const advancedSingleColumnOption = allowAdvancedSingleColumnLayout ? [
                        {
                            id: 'onecolumnlayout',
                            title: formatMessage((0, $csQ9c.toolbarMessages).singleColumnAdvancedLayout),
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).singleColumnsDescriptionAdvancedLayout),
                            keywords: [
                                'layout',
                                'column',
                                'section',
                                'col',
                                'single column'
                            ],
                            priority: 1100,
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconOneColumnLayout), {}),
                            action (insert, state) {
                                const tr = insert((0, $3sx0g.createMultiColumnLayoutSection)(state, 1));
                                withInsertLayoutAnalytics(tr, 1);
                                $4dd341de630051fd$export$abf76f127fb6937c(tr);
                                return tr;
                            }
                        }
                    ] : [];
                    return [
                        createAdvancedColumnLayoutOption({
                            columnCount: 2,
                            descriptionColumnCount: 'two',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconTwoColumnLayout), {}),
                            id: 'twocolumnslayout',
                            keyword: 'two column',
                            title: formatMessage((0, $csQ9c.toolbarMessages).twoColumnsAdvancedLayout)
                        }),
                        ...advancedSingleColumnOption,
                        createAdvancedColumnLayoutOption({
                            columnCount: 3,
                            descriptionColumnCount: 'three',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconThreeColumnLayout), {}),
                            id: 'threecolumnslayout',
                            keyword: 'three column',
                            title: formatMessage((0, $csQ9c.toolbarMessages).threeColumnsAdvancedLayout)
                        }),
                        createAdvancedColumnLayoutOption({
                            columnCount: 4,
                            descriptionColumnCount: 'four',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconFourColumnLayout), {}),
                            id: 'fourcolumnslayout',
                            keyword: 'four column',
                            title: formatMessage((0, $csQ9c.toolbarMessages).fourColumns)
                        }),
                        createAdvancedColumnLayoutOption({
                            columnCount: 5,
                            descriptionColumnCount: 'five',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconFiveColumnLayout), {}),
                            id: 'fivecolumnslayout',
                            keyword: 'five column',
                            title: formatMessage((0, $csQ9c.toolbarMessages).fiveColumns)
                        })
                    ];
                } else return [
                    {
                        id: 'layout',
                        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).columns),
                        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).columnsDescription),
                        keywords: [
                            'column',
                            'section'
                        ],
                        priority: 1100,
                        icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconLayout), {}),
                        action (insert, state) {
                            var _api$analytics4;
                            const tr = insert((0, $3sx0g.createDefaultLayoutSection)(state));
                            api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 || (_api$analytics4 = _api$analytics4.actions) === null || _api$analytics4 === void 0 || _api$analytics4.attachAnalyticsEvent({
                                action: (0, $3LeME.ACTION).INSERTED,
                                actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT,
                                attributes: {
                                    inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $3LeME.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                children: [
                    (0, $kaRof.editorExperiment)('advanced_layouts', true) ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3PyFo.GlobalStylesWrapper), {}) : null,
                    editorView ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8bJhK.LayoutColumnMenu), {
                        api: api,
                        editorView: editorView,
                        mountTo: popupsMountPoint,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement
                    }) : null
                ]
            });
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $8WbPO.pluginKey).getState(editorState);
        },
        commands: {
            deleteLayoutColumn: (options)=>{
                var _api$analytics5;
                return (0, $3sx0g.deleteLayoutColumn)(options, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions, api);
            },
            distributeLayoutColumns: (options)=>{
                var _api$analytics6;
                return (0, $3sx0g.distributeLayoutColumns)(api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions, api)(options);
            },
            insertLayoutColumn: (options)=>{
                var _api$analytics7;
                return (0, $3sx0g.insertLayoutColumn)(options, api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 ? void 0 : _api$analytics7.actions, api);
            },
            setLayoutColumnDangerPreview: $3sx0g.setLayoutColumnDangerPreview,
            setLayoutColumnValign: (options)=>{
                var _api$analytics8;
                return (0, $3sx0g.setLayoutColumnValign)(options, api === null || api === void 0 || (_api$analytics8 = api.analytics) === null || _api$analytics8 === void 0 ? void 0 : _api$analytics8.actions, api);
            },
            toggleLayoutColumnMenu: $3sx0g.toggleLayoutColumnMenu
        }
    };
};

});
parcelRegister("csQ9c", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $78c0576afc47f3ca$export$81b075fd34c2f0bb);

var $8p5Cv = parcelRequire("8p5Cv");
const $78c0576afc47f3ca$export$81b075fd34c2f0bb = (0, $8p5Cv.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'The text is shown as a label on a toolbar button when the user selects a single column layout option in the editor.'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Label for the toolbar button that applies a two equal-width columns layout to the selected content.'
    },
    singleColumnAdvancedLayout: {
        id: 'fabric.editor.singleColumns',
        defaultMessage: '1 column layout',
        description: 'Label for the toolbar button that applies a single-column layout to the selected content in the advanced layout options.'
    },
    twoColumnsAdvancedLayout: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: '2 column layout',
        description: 'Label for the advanced layout toolbar button that applies a two equal-width columns layout.'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    threeColumnsAdvancedLayout: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: '3 column layout',
        description: 'Layout with three columns of equal width'
    },
    fourColumns: {
        id: 'fabric.editor.fourColumns',
        defaultMessage: '4 column layout',
        description: 'Label for the advanced layout toolbar button that applies a four equal-width columns layout.'
    },
    fiveColumns: {
        id: 'fabric.editor.fiveColumns',
        defaultMessage: '5 column layout',
        description: 'Label for the advanced layout toolbar button that applies a five equal-width columns layout.'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    threeColumnsWithLeftSidebars: {
        id: 'fabric.editor.threeColumnsWithLeftSidebars',
        defaultMessage: 'Three columns with left sidebar layout',
        description: 'Layout with 3 columns laid out as 25% - 25% - 50%'
    },
    threeColumnsWithRightSidebars: {
        id: 'fabric.editor.threeColumnsWithRightSidebars',
        defaultMessage: 'Three columns with right sidebar layout',
        description: 'Layout with 3 columns laid out as 50% - 25% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    },
    layoutPlaceholder: {
        id: 'fabric.editor.layout.placeholder',
        defaultMessage: 'Add content',
        description: 'Placeholder text shown inside an empty layout column, prompting the user to add content.'
    },
    controlslayoutPlaceholder: {
        id: 'fabric.editor.layout.controls.placeholder',
        defaultMessage: '/ to insert',
        description: 'Placeholder text shown inside an empty layout column when controls are active, instructing the user to type / to open the insert menu.'
    },
    columnOption: {
        id: 'fabric.editor.layout.columnOption',
        defaultMessage: '{count, plural, one {{count} Column} other {{count} Columns}}',
        description: 'The text is shown as a label for a layout column option in the editor toolbar. It displays the number of columns, for example "1 Column" or "3 Columns".'
    },
    resizeLayout: {
        id: 'fabric.editor.layout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'The text is shown as a label on a button or handle when the user can resize the layout columns in the editor.'
    },
    distributeColumns: {
        id: 'fabric.editor.layout.distributeColumns',
        defaultMessage: 'Distribute columns',
        description: 'The text is shown as a label for an option that distributes layout columns evenly.'
    },
    addColumnLeft: {
        id: 'fabric.editor.layout.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'The text is shown as a label for an option that adds a layout column to the left of the selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.layout.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'The text is shown as a label for an option that adds a layout column to the right of the selected column.'
    },
    insertColumnLeft: {
        id: 'fabric.editor.layout.insertColumnLeft',
        defaultMessage: 'Insert column left',
        description: 'The text is shown as a label for an option that inserts a layout column to the left of the selected column.'
    },
    insertColumnRight: {
        id: 'fabric.editor.layout.insertColumnRight',
        defaultMessage: 'Insert column right',
        description: 'The text is shown as a label for an option that inserts a layout column to the right of the selected column.'
    },
    alignColumn: {
        id: 'fabric.editor.layout.alignColumn',
        defaultMessage: 'Alignment',
        description: 'The text is shown as a label for a nested menu that aligns content vertically inside a layout column.'
    },
    alignColumnTop: {
        id: 'fabric.editor.layout.alignColumnTop',
        defaultMessage: 'Top',
        description: 'The text is shown as a label for an option that aligns layout column content to the top.'
    },
    alignColumnMiddle: {
        id: 'fabric.editor.layout.alignColumnMiddle',
        defaultMessage: 'Center',
        description: 'The text is shown as a label for an option that aligns layout column content to the middle.'
    },
    alignColumnBottom: {
        id: 'fabric.editor.layout.alignColumnBottom',
        defaultMessage: 'Bottom',
        description: 'The text is shown as a label for an option that aligns layout column content to the bottom.'
    },
    deleteColumn: {
        id: 'fabric.editor.layout.deleteColumn',
        defaultMessage: '{count, plural, one {Delete column} other {Delete columns}}',
        description: 'The text is shown as a label for an option that deletes the selected layout column or columns and their content.'
    }
});

});

parcelRegister("3sx0g", function(module, exports) {
$parcel$export(module.exports, "getPresetLayout", () => $c93d96d58a0f6754$export$e406155610be725b);
$parcel$export(module.exports, "getSelectedLayout", () => $c93d96d58a0f6754$export$4cb9903a94908763);
$parcel$export(module.exports, "createMultiColumnLayoutSection", () => $c93d96d58a0f6754$export$af0aef1ee58dfcf);
$parcel$export(module.exports, "createDefaultLayoutSection", () => $c93d96d58a0f6754$export$24df8f7ba30643b8);
$parcel$export(module.exports, "insertLayoutColumnsWithAnalytics", () => $c93d96d58a0f6754$export$3517c001098bb0a9);
$parcel$export(module.exports, "setPresetLayout", () => $c93d96d58a0f6754$export$6bb7269b95fae539);
$parcel$export(module.exports, "fixColumnSizes", () => $c93d96d58a0f6754$export$ea5c48c44d467c6);
$parcel$export(module.exports, "fixColumnStructure", () => $c93d96d58a0f6754$export$35e1f731e4a1d52);
$parcel$export(module.exports, "deleteActiveLayoutNode", () => $c93d96d58a0f6754$export$7472487719e2c16f);
$parcel$export(module.exports, "LAYOUT_COLUMN_INSERT_META", () => $c93d96d58a0f6754$export$7304947c445e7dbb);
$parcel$export(module.exports, "getEffectiveMaxLayoutColumns", () => $c93d96d58a0f6754$export$1e9b718436507bc8);
$parcel$export(module.exports, "insertLayoutColumn", () => $c93d96d58a0f6754$export$7dcaf37842fa555e);
$parcel$export(module.exports, "setLayoutColumnValign", () => $c93d96d58a0f6754$export$4bf533320bf88c4);
$parcel$export(module.exports, "distributeLayoutColumns", () => $c93d96d58a0f6754$export$3155fb5f705eeef0);
$parcel$export(module.exports, "toggleLayoutColumnMenu", () => $c93d96d58a0f6754$export$f9a5c2c84987525d);
$parcel$export(module.exports, "setLayoutColumnDangerPreview", () => $c93d96d58a0f6754$export$21f559cd4fbd479);
$parcel$export(module.exports, "deleteLayoutColumn", () => $c93d96d58a0f6754$export$b3b830a5fba26889);

var $3LeME = parcelRequire("3LeME");

var $202gv = parcelRequire("202gv");

var $lxmuZ = parcelRequire("lxmuZ");
var $ljn7y = parcelRequire("ljn7y");

var $c5vAC = parcelRequire("c5vAC");

var $8VpI3 = parcelRequire("8VpI3");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $a4TQr = parcelRequire("a4TQr");

var $kaRof = parcelRequire("kaRof");

var $irlwb = parcelRequire("irlwb");

var $8WbPO = parcelRequire("8WbPO");

var $i3vVH = parcelRequire("i3vVH");

var $cv1v0 = parcelRequire("cv1v0");
const $c93d96d58a0f6754$export$6ff908759d68cbdd = [
    'single'
];
const $c93d96d58a0f6754$export$51fa5742354f60f2 = [
    'two_equal',
    'two_left_sidebar',
    'two_right_sidebar'
];
const $c93d96d58a0f6754$export$5a58dccaee34776e = [
    'three_equal',
    'three_with_sidebars'
];
const $c93d96d58a0f6754$var$getWidthsForPreset = (presetLayout)=>{
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
        case 'three_left_sidebars':
            return [
                25,
                25,
                50
            ];
        case 'three_right_sidebars':
            return [
                50,
                25,
                25
            ];
        case 'four_equal':
            return [
                25,
                25,
                25,
                25
            ];
        case 'five_equal':
            return [
                20,
                20,
                20,
                20,
                20
            ];
    }
    switch(presetLayout){
        case 'single':
            return [
                100
            ];
        case 'two_equal':
            return [
                50,
                50
            ];
        case 'three_equal':
            return [
                33.33,
                33.33,
                33.33
            ];
        case 'two_left_sidebar':
            return [
                33.33,
                66.66
            ];
        case 'two_right_sidebar':
            return [
                66.66,
                33.33
            ];
        case 'three_with_sidebars':
            return [
                25,
                50,
                25
            ];
    }
    return [];
};
const $c93d96d58a0f6754$var$isValidLayoutWidthDistributions = (layoutSection)=>{
    let totalWidth = 0;
    let hasInvalidWidth = false;
    (0, $c5vAC.mapChildren)(layoutSection, (column)=>column.attrs.width).forEach((width)=>{
        if (typeof width === 'number' && isFinite(width) && width > 0 && width <= 100) totalWidth += width;
        else hasInvalidWidth = true;
    });
    return !hasInvalidWidth && Math.round(totalWidth) === 100;
};
const $c93d96d58a0f6754$export$e406155610be725b = (section)=>{
    const widths = (0, $c5vAC.mapChildren)(section, (column)=>column.attrs.width).join(',');
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) {
        switch(widths){
            case '100':
                return 'single';
            case '33.33,33.33,33.33':
                return 'three_equal';
            case '25,50,25':
                return 'three_with_sidebars';
            case '50,25,25':
                return 'three_right_sidebars';
            case '25,25,50':
                return 'three_left_sidebars';
            case '50,50':
                return 'two_equal';
            case '33.33,66.66':
                return 'two_left_sidebar';
            case '66.66,33.33':
                return 'two_right_sidebar';
            case '25,25,25,25':
                return 'four_equal';
            case '20,20,20,20,20':
                return 'five_equal';
        }
        return;
    }
    switch(widths){
        case '100':
            return 'single';
        case '33.33,33.33,33.33':
            return 'three_equal';
        case '25,50,25':
            return 'three_with_sidebars';
        case '50,50':
            return 'two_equal';
        case '33.33,66.66':
            return 'two_left_sidebar';
        case '66.66,33.33':
            return 'two_right_sidebar';
    }
    return;
};
const $c93d96d58a0f6754$var$isLayoutOutOfSync = (node, presetLayout)=>{
    return node.childCount !== $c93d96d58a0f6754$var$getWidthsForPreset(presetLayout).length;
};
const $c93d96d58a0f6754$export$4cb9903a94908763 = (maybeLayoutSection, current)=>{
    if (maybeLayoutSection && $c93d96d58a0f6754$var$isLayoutOutOfSync(maybeLayoutSection, current) && (0, $kaRof.editorExperiment)('advanced_layouts', true)) return $c93d96d58a0f6754$var$getDefaultPresetLayout(maybeLayoutSection);
    if (maybeLayoutSection && $c93d96d58a0f6754$export$e406155610be725b(maybeLayoutSection)) return $c93d96d58a0f6754$export$e406155610be725b(maybeLayoutSection) || current;
    return current;
};
const $c93d96d58a0f6754$export$af0aef1ee58dfcf = (state, numberOfColumns = 2)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    const columns = (0, $7H6Cr.Fragment).fromArray(Array.from({
        length: numberOfColumns
    }, ()=>layoutColumn.createAndFill({
            width: (0, $irlwb.EVEN_DISTRIBUTED_COL_WIDTHS)[numberOfColumns]
        })));
    return layoutSection.createAndFill(undefined, columns);
};
const $c93d96d58a0f6754$export$24df8f7ba30643b8 = (state)=>{
    const { layoutSection: layoutSection, layoutColumn: layoutColumn } = state.schema.nodes;
    // create a 50-50 layout by default
    const columns = (0, $7H6Cr.Fragment).fromArray([
        layoutColumn.createAndFill({
            width: 50
        }),
        layoutColumn.createAndFill({
            width: 50
        })
    ]);
    return layoutSection.createAndFill(undefined, columns);
};
const $c93d96d58a0f6754$export$924bd0d32fb42cf0 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $a4TQr.safeInsert)($c93d96d58a0f6754$export$24df8f7ba30643b8(state))(state.tr));
    return true;
};
const $c93d96d58a0f6754$export$3517c001098bb0a9 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $8VpI3.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                inputMethod: inputMethod,
                columnCount: 2
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })((state, dispatch)=>{
            if (dispatch) dispatch((0, $a4TQr.safeInsert)($c93d96d58a0f6754$export$24df8f7ba30643b8(state))(state.tr));
            return true;
        });
/**
 * Add a column to the right of existing layout
 */ function $c93d96d58a0f6754$var$addColumn(schema, pos) {
    if ((0, $kaRof.editorExperiment)('advanced_layouts', false)) return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill());
    };
    return (tr)=>{
        tr.replaceWith(tr.mapping.map(pos), tr.mapping.map(pos), schema.nodes.layoutColumn.createAndFill(undefined));
    };
}
function $c93d96d58a0f6754$var$removeLastColumnInLayout(column, columnPos, insideRightEdgePos) {
    return (tr)=>{
        // check if the column only contains a paragraph with a placeholder text
        // if so, remove the whole column, otherwise just remove the paragraph
        if ((0, $ljn7y.isEmptyDocument)(column)) {
            const fromPos = (0, $kaRof.editorExperiment)('single_column_layouts', true) ? columnPos : columnPos - 1;
            tr.replaceRange(tr.mapping.map(fromPos), tr.mapping.map(insideRightEdgePos), (0, $7H6Cr.Slice).empty);
        } else tr.replaceRange(tr.mapping.map(columnPos - 1), tr.mapping.map(columnPos + 1), (0, $7H6Cr.Slice).empty);
    };
}
const $c93d96d58a0f6754$var$fromTwoColsToThree = $c93d96d58a0f6754$var$addColumn;
const $c93d96d58a0f6754$var$fromOneColToTwo = $c93d96d58a0f6754$var$addColumn;
const $c93d96d58a0f6754$var$fromTwoColsToOne = $c93d96d58a0f6754$var$removeLastColumnInLayout;
const $c93d96d58a0f6754$var$fromThreeColsToTwo = $c93d96d58a0f6754$var$removeLastColumnInLayout;
const $c93d96d58a0f6754$var$fromOneColToThree = (schema, pos)=>{
    return (tr)=>{
        $c93d96d58a0f6754$var$addColumn(schema, pos)(tr);
        $c93d96d58a0f6754$var$addColumn(schema, pos)(tr);
    };
};
const $c93d96d58a0f6754$var$fromThreeColstoOne = (node, tr, insideRightEdgePos)=>{
    const thirdColumn = node.content.child(2);
    $c93d96d58a0f6754$var$fromThreeColsToTwo(thirdColumn, insideRightEdgePos - thirdColumn.nodeSize, insideRightEdgePos)(tr);
    const secondColumn = node.content.child(1);
    $c93d96d58a0f6754$var$fromTwoColsToOne(secondColumn, insideRightEdgePos - thirdColumn.nodeSize - secondColumn.nodeSize, insideRightEdgePos)(tr);
};
const $c93d96d58a0f6754$var$increaseColumns = (schema, pos, newColumnsNumber = 1)=>{
    return (tr)=>{
        for(let i = 0; i < newColumnsNumber; i++)$c93d96d58a0f6754$var$addColumn(schema, pos)(tr);
    };
};
const $c93d96d58a0f6754$var$decreaseColumns = (node, insideRightEdgePos, columnsNumberToRemove = 1)=>{
    return (tr)=>{
        let endPos = insideRightEdgePos;
        let lastColumn = node.content.lastChild;
        for(let i = 0; i < columnsNumberToRemove; i++){
            var _lastColumn;
            lastColumn && $c93d96d58a0f6754$var$removeLastColumnInLayout(lastColumn, endPos - lastColumn.nodeSize, endPos)(tr);
            endPos -= ((_lastColumn = lastColumn) === null || _lastColumn === void 0 ? void 0 : _lastColumn.nodeSize) || 0;
            lastColumn = node.content.child(node.childCount - i - 2);
        }
    };
};
/**
 * Handles switching from 2 -> 3 cols, or 3 -> 2 cols
 * Switching from 2 -> 3 just adds a new one at the end
 * Switching from 3 -> 2 moves all the content of the third col inside the second before
 * removing it
 */ function $c93d96d58a0f6754$var$forceColumnStructure(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    // 3 columns -> 2 columns
    if ($c93d96d58a0f6754$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 3) {
        const thirdColumn = node.content.child(2);
        const columnPos = insideRightEdgeOfLayoutSection - thirdColumn.nodeSize;
        $c93d96d58a0f6754$var$fromThreeColsToTwo(thirdColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 2 columns -> 3 columns
    } else if ($c93d96d58a0f6754$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 2) $c93d96d58a0f6754$var$fromTwoColsToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($c93d96d58a0f6754$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 2) {
        const secondColumn = node.content.child(1);
        const columnPos = insideRightEdgeOfLayoutSection - secondColumn.nodeSize;
        $c93d96d58a0f6754$var$fromTwoColsToOne(secondColumn, columnPos, insideRightEdgeOfLayoutSection)(tr);
    // 3 columns -> 1 column
    } else if ($c93d96d58a0f6754$export$6ff908759d68cbdd.indexOf(presetLayout) >= 0 && numCols === 3) $c93d96d58a0f6754$var$fromThreeColstoOne(node, tr, insideRightEdgeOfLayoutSection);
    else if ($c93d96d58a0f6754$export$51fa5742354f60f2.indexOf(presetLayout) >= 0 && numCols === 1) $c93d96d58a0f6754$var$fromOneColToTwo(state.schema, insideRightEdgeOfLayoutSection)(tr);
    else if ($c93d96d58a0f6754$export$5a58dccaee34776e.indexOf(presetLayout) >= 0 && numCols === 1) $c93d96d58a0f6754$var$fromOneColToThree(state.schema, insideRightEdgeOfLayoutSection)(tr);
    return tr;
}
function $c93d96d58a0f6754$var$forceColumnStructureNew(state, node, pos, presetLayout) {
    const tr = state.tr;
    const insideRightEdgeOfLayoutSection = pos + node.nodeSize - 1;
    const numCols = node.childCount;
    const columnChange = $c93d96d58a0f6754$var$getWidthsForPreset(presetLayout).length - numCols;
    if (columnChange > 0) $c93d96d58a0f6754$var$increaseColumns(state.schema, insideRightEdgeOfLayoutSection, columnChange)(tr);
    else if (columnChange < 0) $c93d96d58a0f6754$var$decreaseColumns(node, insideRightEdgeOfLayoutSection, -columnChange)(tr);
    return tr;
}
function $c93d96d58a0f6754$var$columnWidth(node, schema, widths) {
    const { layoutColumn: layoutColumn } = schema.nodes;
    const truncatedWidths = widths.map((w)=>Number(w.toFixed(2)));
    return (0, $c5vAC.flatmap)(node.content, (column, idx)=>{
        if (column.type === layoutColumn) return layoutColumn.create({
            ...column.attrs,
            width: truncatedWidths[idx]
        }, column.content, column.marks);
        else return column;
    });
}
function $c93d96d58a0f6754$var$forceColumnWidths(state, tr, pos, presetLayout) {
    const node = tr.doc.nodeAt(pos);
    if (!node) return tr;
    return tr.replaceWith(pos + 1, pos + node.nodeSize - 1, $c93d96d58a0f6754$var$columnWidth(node, state.schema, $c93d96d58a0f6754$var$getWidthsForPreset(presetLayout)));
}
function $c93d96d58a0f6754$export$e91cd6bb1b715717(state, node, pos, presetLayout) {
    const forceColumnStructureFn = (0, $kaRof.editorExperiment)('advanced_layouts', true) ? $c93d96d58a0f6754$var$forceColumnStructureNew : $c93d96d58a0f6754$var$forceColumnStructure;
    let tr = forceColumnStructureFn(state, node, pos, presetLayout);
    // save the selection here, since forcing column widths causes a change over the
    // entire layoutSection, which remaps selection to the end. not remapping here
    // is safe because the structure is no longer changing.
    const selection = tr.selection;
    tr = $c93d96d58a0f6754$var$forceColumnWidths(state, tr, pos, presetLayout);
    const selectionPos$ = tr.doc.resolve(selection.$from.pos);
    return tr.setSelection(state.selection instanceof (0, $801jp.NodeSelection) ? new (0, $801jp.NodeSelection)(selectionPos$) : new (0, $801jp.TextSelection)(selectionPos$));
}
const $c93d96d58a0f6754$export$6bb7269b95fae539 = (editorAnalyticsAPI)=>(layout)=>(state, dispatch)=>{
            const { pos: pos, selectedLayout: selectedLayout } = (0, $8WbPO.pluginKey).getState(state);
            if (pos === null) return false;
            const node = state.doc.nodeAt(pos);
            if (!node) return false;
            if (selectedLayout === layout && node.childCount > 1) return false;
            const tr = $c93d96d58a0f6754$export$e91cd6bb1b715717(state, node, pos, layout);
            if (tr) {
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $3LeME.ACTION).CHANGED_LAYOUT,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        previousLayout: $c93d96d58a0f6754$var$formatLayoutName(selectedLayout),
                        newLayout: $c93d96d58a0f6754$var$formatLayoutName(layout)
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(tr);
                tr.setMeta('scrollIntoView', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $c93d96d58a0f6754$var$layoutNeedChanges(node) {
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) // Custom widths that sum to 100% are valid and should not be forced back to presets.
    return !$c93d96d58a0f6754$var$isValidLayoutWidthDistributions(node);
    return !$c93d96d58a0f6754$export$e406155610be725b(node);
}
const $c93d96d58a0f6754$var$getDefaultPresetLayout = (layoutNode)=>{
    const layoutColumnCount = layoutNode.childCount;
    if (layoutColumnCount <= 1) return 'single';
    switch(layoutColumnCount){
        case 1:
            return 'single';
        case 2:
            return 'two_equal';
        case 3:
            return 'three_equal';
        case 4:
            return 'four_equal';
        case 5:
            return 'five_equal';
        default:
            return 'five_equal';
    }
};
function $c93d96d58a0f6754$var$getLayoutChange(node, pos, schema) {
    if (node.type === schema.nodes.layoutSection) {
        if (!$c93d96d58a0f6754$var$layoutNeedChanges(node)) return;
        const presetLayout = (0, $kaRof.editorExperiment)('advanced_layouts', true) ? $c93d96d58a0f6754$var$getDefaultPresetLayout(node) : node.childCount === 2 ? 'two_equal' : node.childCount === 3 ? 'three_equal' : 'single';
        const fixedColumns = $c93d96d58a0f6754$var$columnWidth(node, schema, $c93d96d58a0f6754$var$getWidthsForPreset(presetLayout));
        return {
            from: pos + 1,
            to: pos + node.nodeSize - 1,
            slice: new (0, $7H6Cr.Slice)(fixedColumns, 0, 0)
        };
    }
}
const $c93d96d58a0f6754$export$ea5c48c44d467c6 = (changedTr, state)=>{
    const { layoutSection: layoutSection } = state.schema.nodes;
    let change;
    const range = (0, $lxmuZ.getStepRange)(changedTr);
    if (!range) return undefined;
    changedTr.doc.nodesBetween(range.from, range.to, (node, pos)=>{
        if (node.type !== layoutSection) return true; // Check all internal nodes expect for layout section
        // Node is a section
        if ($c93d96d58a0f6754$var$layoutNeedChanges(node)) change = $c93d96d58a0f6754$var$getLayoutChange(node, pos, state.schema);
        return false; // We dont go deep, We dont accept nested layouts
    });
    // Hack to prevent: https://product-fabric.atlassian.net/browse/ED-7523
    // By default prosemirror try to recreate the node with the default attributes
    // The default attribute is invalid adf though. when this happen the node after
    // current position is a layout section
    const $pos = changedTr.doc.resolve(range.to);
    if ($pos.depth > 0) {
        // 'range.to' position could resolve to doc, in this ResolvedPos.after will throws
        const pos = $pos.after();
        const node = changedTr.doc.nodeAt(pos);
        if (node && node.type === layoutSection && $c93d96d58a0f6754$var$layoutNeedChanges(node)) change = $c93d96d58a0f6754$var$getLayoutChange(node, pos, state.schema);
    }
    return change;
};
const $c93d96d58a0f6754$export$35e1f731e4a1d52 = (state)=>{
    const { pos: pos, selectedLayout: selectedLayout } = (0, $8WbPO.pluginKey).getState(state);
    if (pos !== null && selectedLayout) {
        const node = state.doc.nodeAt(pos);
        if (node) {
            if (node.childCount !== $c93d96d58a0f6754$var$getWidthsForPreset(selectedLayout).length) {
                // Valid custom widths may use a different column count from the selected preset.
                if ((0, $kaRof.editorExperiment)('advanced_layouts', true) && $c93d96d58a0f6754$var$isValidLayoutWidthDistributions(node)) return;
                return $c93d96d58a0f6754$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
            }
            if (!$c93d96d58a0f6754$var$isValidLayoutWidthDistributions(node) && (0, $kaRof.editorExperiment)('advanced_layouts', true)) return $c93d96d58a0f6754$export$e91cd6bb1b715717(state, node, pos, selectedLayout);
        }
    }
    return;
};
const $c93d96d58a0f6754$export$7472487719e2c16f = (editorAnalyticsAPI, inputMethod)=>(state, dispatch)=>{
        const { pos: pos, selectedLayout: selectedLayout } = (0, $8WbPO.pluginKey).getState(state);
        if (pos !== null) {
            const node = state.doc.nodeAt(pos);
            if (dispatch) {
                const tr = state.tr.delete(pos, pos + node.nodeSize);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $3LeME.ACTION).DELETED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).LAYOUT,
                    attributes: {
                        layout: $c93d96d58a0f6754$var$formatLayoutName(selectedLayout),
                        inputMethod: inputMethod
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(tr);
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $c93d96d58a0f6754$var$formatLayoutName = (layout)=>{
    if ((0, $kaRof.editorExperiment)('advanced_layouts', true)) switch(layout){
        case 'single':
            return (0, $202gv.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $202gv.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $202gv.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $202gv.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $202gv.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $202gv.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
        case 'four_equal':
            return (0, $202gv.LAYOUT_TYPE).FOUR_COLS_EQUAL;
        case 'five_equal':
            return (0, $202gv.LAYOUT_TYPE).FIVE_COLS_EQUAL;
    }
    switch(layout){
        case 'single':
            return (0, $202gv.LAYOUT_TYPE).SINGLE_COL;
        case 'two_equal':
            return (0, $202gv.LAYOUT_TYPE).TWO_COLS_EQUAL;
        case 'three_equal':
            return (0, $202gv.LAYOUT_TYPE).THREE_COLS_EQUAL;
        case 'two_left_sidebar':
            return (0, $202gv.LAYOUT_TYPE).LEFT_SIDEBAR;
        case 'two_right_sidebar':
            return (0, $202gv.LAYOUT_TYPE).RIGHT_SIDEBAR;
        case 'three_with_sidebars':
            return (0, $202gv.LAYOUT_TYPE).THREE_WITH_SIDEBARS;
    }
};
const $c93d96d58a0f6754$export$7304947c445e7dbb = 'layoutColumnInsert';
const $c93d96d58a0f6754$var$getPreviousLayoutColumnValign = (selectedLayoutColumns)=>{
    var _selectedLayoutColumn;
    const firstValign = (0, $cv1v0.getLayoutColumnValign)((_selectedLayoutColumn = selectedLayoutColumns[0]) === null || _selectedLayoutColumn === void 0 ? void 0 : _selectedLayoutColumn.node);
    const hasMixedValign = selectedLayoutColumns.some(({ node: node })=>(0, $cv1v0.getLayoutColumnValign)(node) !== firstValign);
    return hasMixedValign ? 'mixed' : firstValign ?? (0, $irlwb.DEFAULT_LAYOUT_COLUMN_VALIGN);
};
const $c93d96d58a0f6754$var$hasLayoutColumnContent = (node)=>!(0, $ljn7y.isEmptyDocument)(node);
/**
 * Remaps a selection through a position mapping, preserving its type. Used after replacing a
 * layout section's contents so the selection stays in its column instead of being mapped out
 * of the layout. Returns `undefined` if no valid selection can be derived (NodeSelection
 * whose node is no longer selectable falls back to a nearby caret).
 */ const $c93d96d58a0f6754$var$remapSelectionThroughMapping = (selection, mapping, doc)=>{
    const docSize = doc.content.size;
    const clamp = (pos)=>Math.min(Math.max(pos, 0), docSize);
    if (selection instanceof (0, $801jp.NodeSelection)) {
        const mappedPos = clamp(mapping.map(selection.from));
        const nodeAtPos = doc.nodeAt(mappedPos);
        if (nodeAtPos && (0, $801jp.NodeSelection).isSelectable(nodeAtPos)) return (0, $801jp.NodeSelection).create(doc, mappedPos);
        return (0, $801jp.TextSelection).findFrom(doc.resolve(mappedPos), 1, true) ?? undefined;
    }
    if (selection instanceof (0, $801jp.TextSelection)) {
        const mappedFrom = clamp(mapping.map(selection.from));
        const mappedTo = clamp(mapping.map(selection.to));
        try {
            return (0, $801jp.TextSelection).create(doc, mappedFrom, mappedTo);
        } catch  {
            return undefined;
        }
    }
    return undefined;
};
const $c93d96d58a0f6754$var$mapLayoutColumnPreservedSelection = (tr, api)=>{
    const insertMeta = tr.getMeta($c93d96d58a0f6754$export$7304947c445e7dbb);
    if (insertMeta) {
        var _api$blockControls;
        const mapping = insertMeta.side === 'left' ? new (0, $k2WVn.Mapping)([
            new (0, $k2WVn.StepMap)([
                insertMeta.insertedColumnPos,
                0,
                insertMeta.insertedColumnNodeSize
            ])
        ]) : new (0, $k2WVn.Mapping)();
        api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || _api$blockControls.commands.mapPreservedSelection(mapping)({
            tr: tr
        });
        return;
    }
    // Width and alignment updates should keep original layout column selection unchanged.
    if (tr.getMeta('scrollIntoView') === false && tr.docChanged) {
        var _api$blockControls2;
        api === null || api === void 0 || (_api$blockControls2 = api.blockControls) === null || _api$blockControls2 === void 0 || _api$blockControls2.commands.mapPreservedSelection(new (0, $k2WVn.Mapping)())({
            tr: tr
        });
    }
};
function $c93d96d58a0f6754$export$1e9b718436507bc8() {
    return (0, $kaRof.editorExperiment)('advanced_layouts', true) ? (0, $irlwb.MAX_LAYOUT_COLUMNS) : (0, $irlwb.MAX_STANDARD_LAYOUT_COLUMNS);
}
const $c93d96d58a0f6754$var$insertLayoutColumnAt = (side, editorAnalyticsAPI, inputMethod = (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $cv1v0.getLayoutColumnsFromContentSelection)(tr.selection);
        if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length === 0) return null;
        const { layoutSectionNode: layoutSectionNode, layoutSectionPos: layoutSectionPos, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
        const selectedColumnIndex = side === 'left' ? startIndex : endIndex;
        const selectedColumnCount = selectedLayoutColumns.length;
        if (layoutSectionNode.childCount >= $c93d96d58a0f6754$export$1e9b718436507bc8()) return null;
        const insertIndex = side === 'left' ? selectedColumnIndex : selectedColumnIndex + 1;
        const existingWidths = (0, $c5vAC.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
        const redistributedWidths = (0, $i3vVH.redistributeProportionally)(existingWidths, insertIndex, $c93d96d58a0f6754$export$1e9b718436507bc8(), (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT));
        if (redistributedWidths === existingWidths) return null;
        const { layoutColumn: layoutColumn } = tr.doc.type.schema.nodes;
        const newColumn = layoutColumn.createAndFill({
            width: redistributedWidths[insertIndex]
        });
        if (!newColumn) return null;
        const updatedColumns = [];
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index === insertIndex) updatedColumns.push(newColumn);
            updatedColumns.push(column);
        });
        if (insertIndex === layoutSectionNode.childCount) updatedColumns.push(newColumn);
        const updatedLayoutSectionNode = layoutSectionNode.copy((0, $7H6Cr.Fragment).fromArray(updatedColumns));
        let insertedColumnOffset = 0;
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index < insertIndex) insertedColumnOffset += column.nodeSize;
        });
        const insertedColumnPos = layoutSectionPos + 1 + insertedColumnOffset;
        tr.setMeta($c93d96d58a0f6754$export$7304947c445e7dbb, {
            insertedColumnNodeSize: newColumn.nodeSize,
            insertedColumnPos: insertedColumnPos,
            side: side
        });
        // Capture the selection before the section content is replaced (the replace below maps
        // it out of the layout by default). The menu path restores its own preserved selection
        // afterwards, so this restoration only matters for the cursor-in-column case.
        const originalSelection = tr.selection;
        tr.replaceWith(layoutSectionPos + 1, layoutSectionPos + layoutSectionNode.nodeSize - 1, $c93d96d58a0f6754$var$columnWidth(updatedLayoutSectionNode, tr.doc.type.schema, redistributedWidths));
        // Inserting left shifts positions at/after the new column right by its size; inserting
        // right leaves them unchanged. Remap the original selection through that mapping.
        const insertMapping = side === 'left' ? new (0, $k2WVn.Mapping)([
            new (0, $k2WVn.StepMap)([
                insertedColumnPos,
                0,
                newColumn.nodeSize
            ])
        ]) : new (0, $k2WVn.Mapping)();
        const restoredSelection = $c93d96d58a0f6754$var$remapSelectionThroughMapping(originalSelection, insertMapping, tr.doc);
        if (restoredSelection) tr.setSelection(restoredSelection);
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
            attributes: {
                endIndex: endIndex,
                inputMethod: inputMethod,
                newColumnCount: redistributedWidths.length,
                previousColumnCount: layoutSectionNode.childCount,
                selectedCount: selectedColumnCount,
                side: side,
                startIndex: startIndex
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })(tr);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $c93d96d58a0f6754$export$7dcaf37842fa555e = ({ side: side, inputMethod: inputMethod = (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU }, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        const result = $c93d96d58a0f6754$var$insertLayoutColumnAt(side, editorAnalyticsAPI, inputMethod)({
            tr: tr
        });
        if (result) $c93d96d58a0f6754$var$mapLayoutColumnPreservedSelection(tr, api);
        return result;
    };
const $c93d96d58a0f6754$export$4bf533320bf88c4 = ({ valign: valign, inputMethod: inputMethod = (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU }, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $cv1v0.getSelectedLayoutColumnsFromSelection)(tr.selection);
        if (!selectedLayoutColumnsResult) return null;
        const { layoutSectionNode: layoutSectionNode, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
        const previousValign = $c93d96d58a0f6754$var$getPreviousLayoutColumnValign(selectedLayoutColumns);
        const columnsToUpdate = selectedLayoutColumns.filter(({ node: node })=>(0, $cv1v0.getLayoutColumnValign)(node) !== valign);
        if (columnsToUpdate.length === 0) return null;
        const updatedColumnCount = columnsToUpdate.length;
        columnsToUpdate.forEach(({ node: node, pos: pos })=>{
            tr.setNodeMarkup(pos, node.type, {
                ...node.attrs,
                valign: valign
            });
        });
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).UPDATED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
            attributes: {
                columnCount: layoutSectionNode.childCount,
                endIndex: endIndex,
                inputMethod: inputMethod,
                previousValign: previousValign,
                selectedCount: selectedLayoutColumns.length,
                startIndex: startIndex,
                updatedCount: updatedColumnCount,
                valign: valign
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })(tr);
        tr.setMeta('scrollIntoView', false);
        $c93d96d58a0f6754$var$mapLayoutColumnPreservedSelection(tr, api);
        return tr;
    };
const $c93d96d58a0f6754$export$3155fb5f705eeef0 = (editorAnalyticsAPI, api)=>({ inputMethod: inputMethod = (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU, target: target = 'selectedColumns' } = {})=>({ tr: tr })=>{
            const selectedLayoutColumnsResult = target === 'allColumns' ? (0, $cv1v0.getAllLayoutColumnsFromSelection)(tr.selection) : (0, $cv1v0.getSelectedLayoutColumnsFromSelection)(tr.selection);
            if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length < 2) return null;
            const { layoutSectionNode: layoutSectionNode, startIndex: startIndex, endIndex: endIndex, selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult;
            const existingWidths = (0, $c5vAC.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
            const selectedWidths = selectedLayoutColumns.map(({ node: node })=>node.attrs.width);
            const distribution = (0, $i3vVH.calculateDistribution)(selectedWidths);
            if (!distribution) return null;
            const { selectedTotal: selectedTotal, equalWidth: equalWidth } = distribution;
            if ((0, $i3vVH.isDistributedUniformly)(selectedWidths, distribution)) return null;
            // Build new widths array: selected columns get equal share, unselected unchanged.
            // Assign rounded (2dp) equal widths to all selected cols except the last, which absorbs
            // the rounding remainder so the sum of selected widths equals selectedTotal exactly.
            let assignedToSelected = 0;
            let selectedAssignedCount = 0;
            const newWidths = existingWidths.map((w, idx)=>{
                if (idx < startIndex || idx > endIndex) return w;
                selectedAssignedCount += 1;
                if (selectedAssignedCount < selectedLayoutColumns.length) {
                    assignedToSelected += equalWidth;
                    return equalWidth;
                }
                // Last selected column: absorb the remainder to avoid drift
                return Number((selectedTotal - assignedToSelected).toFixed(2));
            });
            // Apply widths via setNodeMarkup per selected column — keeps nodes in place (preserves identity, marks, decorations)
            selectedLayoutColumns.forEach(({ node: node, pos: pos }, i)=>{
                const colIdx = startIndex + i;
                tr.setNodeMarkup(pos, node.type, {
                    ...node.attrs,
                    width: newWidths[colIdx]
                });
            });
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $3LeME.ACTION).UPDATED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
                attributes: {
                    columnCount: layoutSectionNode.childCount,
                    endIndex: endIndex,
                    inputMethod: inputMethod,
                    selectedCount: selectedLayoutColumns.length,
                    startIndex: startIndex,
                    target: target
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            })(tr);
            tr.setMeta('scrollIntoView', false);
            $c93d96d58a0f6754$var$mapLayoutColumnPreservedSelection(tr, api);
            return tr;
        };
const $c93d96d58a0f6754$export$f9a5c2c84987525d = (options)=>({ tr: tr })=>{
        tr.setMeta('toggleLayoutColumnMenu', options);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $c93d96d58a0f6754$export$21f559cd4fbd479 = (show)=>({ tr: tr })=>{
        const selectedLayoutColumnsResult = (0, $cv1v0.getSelectedLayoutColumnsFromSelection)(tr.selection);
        const positions = show ? (selectedLayoutColumnsResult === null || selectedLayoutColumnsResult === void 0 ? void 0 : selectedLayoutColumnsResult.selectedLayoutColumns.map(({ pos: pos })=>pos)) ?? [] : null;
        tr.setMeta('layoutColumnDangerPreview', positions);
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        return tr;
    };
const $c93d96d58a0f6754$export$b3b830a5fba26889 = ({ inputMethod: inputMethod = (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU } = {}, editorAnalyticsAPI, api)=>({ tr: tr })=>{
        var _api$blockControls4;
        // Only delete columns that are explicitly selected (a column NodeSelection or a selection
        // fully containing columns). This stops a bare caret inside a column — including inside
        // nested content such as a table — from deleting the whole column via the delete shortcut.
        const selectedLayoutColumnsResult = (0, $cv1v0.getSelectedLayoutColumnsFromSelection)(tr.selection);
        if (!selectedLayoutColumnsResult || selectedLayoutColumnsResult.selectedLayoutColumns.length === 0) return null;
        const { layoutSectionNode: layoutSectionNode, layoutSectionPos: layoutSectionPos, selectedLayoutColumns: selectedLayoutColumns, startIndex: startIndex, endIndex: endIndex } = selectedLayoutColumnsResult;
        const hadContent = selectedLayoutColumns.some(({ node: node })=>$c93d96d58a0f6754$var$hasLayoutColumnContent(node));
        const emitDeleteColumnAnalytics = (newColumnCount)=>{
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $3LeME.ACTION).DELETED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
                attributes: {
                    endIndex: endIndex,
                    hadContent: hadContent,
                    inputMethod: inputMethod,
                    newColumnCount: newColumnCount,
                    previousColumnCount: layoutSectionNode.childCount,
                    selectedCount: selectedLayoutColumns.length,
                    startIndex: startIndex
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            })(tr);
        };
        // If all columns are selected, remove the entire layoutSection
        if (selectedLayoutColumns.length === layoutSectionNode.childCount) {
            var _api$blockControls3;
            tr.delete(layoutSectionPos, layoutSectionPos + layoutSectionNode.nodeSize);
            emitDeleteColumnAnalytics(0);
            tr.setMeta('scrollIntoView', false);
            api === null || api === void 0 || (_api$blockControls3 = api.blockControls) === null || _api$blockControls3 === void 0 || _api$blockControls3.commands.stopPreservingSelection()({
                tr: tr
            });
            return tr;
        }
        // Build new column list without the selected columns
        const remainingColumns = [];
        layoutSectionNode.forEach((column, _offset, index)=>{
            if (index < startIndex || index > endIndex) remainingColumns.push(column);
        });
        // Redistribute widths proportionally among remaining columns using shared utility
        const existingWidths = (0, $c5vAC.mapChildren)(layoutSectionNode, (column)=>column.attrs.width);
        const redistributed = selectedLayoutColumns.map((_, i)=>startIndex + i)// Delete highest indices first so lower original indices still point at the same columns
        // as each redistribution step shrinks the widths array.
        .reverse().reduce((widths, selectedIndex)=>(0, $i3vVH.redistributeAfterDeletion)(widths, selectedIndex, (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT)), existingWidths);
        const updatedLayoutSectionNode = layoutSectionNode.copy((0, $7H6Cr.Fragment).fromArray(remainingColumns));
        // A text selection can fully contain columns. Restore its caret in a remaining column;
        // block controls own the landing for a column NodeSelection.
        const hadTextSelection = tr.selection instanceof (0, $801jp.TextSelection);
        tr.replaceWith(layoutSectionPos + 1, layoutSectionPos + layoutSectionNode.nodeSize - 1, $c93d96d58a0f6754$var$columnWidth(updatedLayoutSectionNode, tr.doc.type.schema, redistributed));
        // Keep a text selection within the layout after the selected columns are removed.
        const remainingColumnCount = remainingColumns.length;
        if (hadTextSelection && remainingColumnCount > 0) {
            const targetColumnIndex = Math.min(startIndex, remainingColumnCount - 1);
            const updatedSectionNode = tr.doc.nodeAt(layoutSectionPos);
            if (updatedSectionNode) {
                let columnOffset = 1;
                for(let columnIndex = 0; columnIndex < targetColumnIndex; columnIndex++)columnOffset += updatedSectionNode.child(columnIndex).nodeSize;
                // +1 to land inside the column's first child rather than on the column boundary.
                const caretPos = layoutSectionPos + columnOffset + 1;
                if (caretPos >= 0 && caretPos <= tr.doc.content.size) {
                    const caretSelection = (0, $801jp.TextSelection).findFrom(tr.doc.resolve(caretPos), 1, true);
                    if (caretSelection) tr.setSelection(caretSelection);
                }
            }
        }
        emitDeleteColumnAnalytics(redistributed.length);
        tr.setMeta('scrollIntoView', false);
        api === null || api === void 0 || (_api$blockControls4 = api.blockControls) === null || _api$blockControls4 === void 0 || _api$blockControls4.commands.stopPreservingSelection()({
            tr: tr
        });
        return tr;
    };

});
parcelRegister("irlwb", function(module, exports) {
$parcel$export(module.exports, "MAX_STANDARD_LAYOUT_COLUMNS", () => $7a3399451356a020$export$2583e740deddd6d);
$parcel$export(module.exports, "MAX_LAYOUT_COLUMNS", () => $7a3399451356a020$export$92f9af977c85ea46);
$parcel$export(module.exports, "MIN_LAYOUT_COLUMN_WIDTH_PERCENT", () => $7a3399451356a020$export$a9683f74b118e94b);
$parcel$export(module.exports, "DEFAULT_LAYOUT_COLUMN_VALIGN", () => $7a3399451356a020$export$f501538bec3afd75);
$parcel$export(module.exports, "EVEN_DISTRIBUTED_COL_WIDTHS", () => $7a3399451356a020$export$faa6744ce57d263b);
const $7a3399451356a020$export$2583e740deddd6d = 3;
const $7a3399451356a020$export$92f9af977c85ea46 = 5;
const $7a3399451356a020$export$a9683f74b118e94b = 5;
const $7a3399451356a020$export$f501538bec3afd75 = 'top';
const $7a3399451356a020$export$faa6744ce57d263b = {
    1: 100,
    2: 50,
    3: 33.33,
    4: 25,
    5: 20
};

});

parcelRegister("8WbPO", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $5879411b95d1f062$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $5879411b95d1f062$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('layout');

});

parcelRegister("i3vVH", function(module, exports) {
$parcel$export(module.exports, "calculateDistribution", () => $15ca9b15d13c9d7d$export$e260f2e2ca90998a);
$parcel$export(module.exports, "isDistributedUniformly", () => $15ca9b15d13c9d7d$export$3cbb23b573ffb2e9);
$parcel$export(module.exports, "redistributeAfterDeletion", () => $15ca9b15d13c9d7d$export$7a23b11013fe122c);
$parcel$export(module.exports, "redistributeProportionally", () => $15ca9b15d13c9d7d$export$3d07e1109dd4c8ac);
const $15ca9b15d13c9d7d$var$roundLayoutColumnWidth = (width)=>Number(width.toFixed(2));
const $15ca9b15d13c9d7d$var$sumWidths = (widths)=>widths.reduce((sum, width)=>sum + width, 0);
const $15ca9b15d13c9d7d$var$normaliseWidthsTotal = (widths, totalWidth, minWidth)=>{
    const roundedWidths = widths.map($15ca9b15d13c9d7d$var$roundLayoutColumnWidth);
    const remainder = $15ca9b15d13c9d7d$var$roundLayoutColumnWidth(totalWidth - $15ca9b15d13c9d7d$var$sumWidths(roundedWidths));
    if (remainder === 0 || roundedWidths.length === 0) return roundedWidths;
    let adjustmentIndex = 0;
    roundedWidths.forEach((width, index)=>{
        if (width > roundedWidths[adjustmentIndex]) adjustmentIndex = index;
    });
    const adjustedWidth = $15ca9b15d13c9d7d$var$roundLayoutColumnWidth(roundedWidths[adjustmentIndex] + remainder);
    if (adjustedWidth < minWidth) return roundedWidths;
    return roundedWidths.map((width, index)=>index === adjustmentIndex ? adjustedWidth : width);
};
const $15ca9b15d13c9d7d$var$isValidWidth = (width)=>Number.isFinite(width) && width > 0;
const $15ca9b15d13c9d7d$var$redistributeWithMinimumWidth = ({ minWidth: minWidth, totalWidth: totalWidth, weights: weights })=>{
    if (weights.length * minWidth > totalWidth) return;
    const widths = Array(weights.length).fill(0);
    const clampedIndexes = new Set();
    let remainingWidth = totalWidth;
    let remainingWeight = $15ca9b15d13c9d7d$var$sumWidths(weights);
    while(clampedIndexes.size < weights.length){
        const remainingWidthForPass = remainingWidth;
        const remainingWeightForPass = remainingWeight;
        const indexesToClamp = [];
        weights.forEach((weight, index)=>{
            if (clampedIndexes.has(index)) return;
            const proportionalWidth = remainingWeightForPass > 0 ? weight / remainingWeightForPass * remainingWidthForPass : 0;
            if (proportionalWidth < minWidth) indexesToClamp.push(index);
        });
        if (indexesToClamp.length === 0) break;
        indexesToClamp.forEach((index)=>{
            widths[index] = minWidth;
            clampedIndexes.add(index);
            remainingWidth -= minWidth;
            remainingWeight -= weights[index];
        });
    }
    weights.forEach((weight, index)=>{
        if (!clampedIndexes.has(index)) widths[index] = remainingWeight > 0 ? weight / remainingWeight * remainingWidth : minWidth;
    });
    return widths;
};
const $15ca9b15d13c9d7d$export$e260f2e2ca90998a = (selectedWidths)=>{
    const count = selectedWidths.length;
    if (count < 2) return undefined;
    const selectedTotal = $15ca9b15d13c9d7d$var$sumWidths(selectedWidths);
    const equalWidth = $15ca9b15d13c9d7d$var$roundLayoutColumnWidth(selectedTotal / count);
    return {
        selectedTotal: selectedTotal,
        equalWidth: equalWidth
    };
};
function $15ca9b15d13c9d7d$export$3cbb23b573ffb2e9(selectedWidths, distribution = $15ca9b15d13c9d7d$export$e260f2e2ca90998a(selectedWidths)) {
    if (!distribution || selectedWidths.length < 2) return false;
    const { selectedTotal: selectedTotal, equalWidth: equalWidth } = distribution;
    const lastColWidth = $15ca9b15d13c9d7d$var$roundLayoutColumnWidth(selectedTotal - equalWidth * (selectedWidths.length - 1));
    return selectedWidths.slice(0, -1).every((width)=>width === equalWidth) && selectedWidths[selectedWidths.length - 1] === lastColWidth;
}
const $15ca9b15d13c9d7d$export$7a23b11013fe122c = (currentWidths, removeIndex, minWidth)=>{
    if (currentWidths.length === 0 || removeIndex < 0 || removeIndex >= currentWidths.length || !$15ca9b15d13c9d7d$var$isValidWidth(minWidth)) return currentWidths;
    if (currentWidths.some((width)=>!$15ca9b15d13c9d7d$var$isValidWidth(width))) return currentWidths.filter((_, i)=>i !== removeIndex);
    const remainingWidths = currentWidths.filter((_, i)=>i !== removeIndex);
    if (remainingWidths.length === 0) return remainingWidths;
    const currentTotalWidth = $15ca9b15d13c9d7d$var$sumWidths(currentWidths);
    const targetTotalWidth = Math.round(currentTotalWidth) === 100 ? 100 : currentTotalWidth;
    const redistributed = $15ca9b15d13c9d7d$var$redistributeWithMinimumWidth({
        weights: remainingWidths,
        totalWidth: targetTotalWidth,
        minWidth: minWidth
    });
    if (!redistributed) {
        const equalWidth = $15ca9b15d13c9d7d$var$roundLayoutColumnWidth(targetTotalWidth / remainingWidths.length);
        return $15ca9b15d13c9d7d$var$normaliseWidthsTotal(Array(remainingWidths.length).fill(equalWidth), targetTotalWidth, minWidth);
    }
    return $15ca9b15d13c9d7d$var$normaliseWidthsTotal(redistributed, targetTotalWidth, minWidth);
};
const $15ca9b15d13c9d7d$export$3d07e1109dd4c8ac = (currentWidths, insertIndex, maxColumns, minWidth)=>{
    if (currentWidths.length === 0 || !Number.isInteger(maxColumns) || maxColumns <= 0 || currentWidths.length >= maxColumns || insertIndex < 0 || insertIndex > currentWidths.length || !$15ca9b15d13c9d7d$var$isValidWidth(minWidth) || currentWidths.some((width)=>!$15ca9b15d13c9d7d$var$isValidWidth(width))) return currentWidths;
    const currentTotalWidth = $15ca9b15d13c9d7d$var$sumWidths(currentWidths);
    if (!$15ca9b15d13c9d7d$var$isValidWidth(currentTotalWidth)) return currentWidths;
    const targetTotalWidth = Math.round(currentTotalWidth) === 100 ? 100 : currentTotalWidth;
    const newColumnWidth = Math.max(minWidth, $15ca9b15d13c9d7d$var$roundLayoutColumnWidth(targetTotalWidth / (currentWidths.length + 1)));
    const existingColumnsTotalWidth = targetTotalWidth - newColumnWidth;
    if (existingColumnsTotalWidth < currentWidths.length * minWidth) return currentWidths;
    const redistributedExistingWidths = $15ca9b15d13c9d7d$var$redistributeWithMinimumWidth({
        weights: currentWidths,
        totalWidth: existingColumnsTotalWidth,
        minWidth: minWidth
    });
    if (!redistributedExistingWidths) return currentWidths;
    const nextWidths = [
        ...redistributedExistingWidths
    ];
    nextWidths.splice(insertIndex, 0, newColumnWidth);
    return $15ca9b15d13c9d7d$var$normaliseWidthsTotal(nextWidths, targetTotalWidth, minWidth);
};

});

parcelRegister("cv1v0", function(module, exports) {
$parcel$export(module.exports, "getSelectedLayoutColumnsFromSelection", () => $69c15d57da5552bb$export$d9c5d9ac81e1479b);
$parcel$export(module.exports, "getLayoutColumnsFromContentSelection", () => $69c15d57da5552bb$export$1ba40f8dfd76f1b5);
$parcel$export(module.exports, "getAllLayoutColumnsFromSelection", () => $69c15d57da5552bb$export$1f0e4d47b1eb0108);
$parcel$export(module.exports, "getLayoutColumnValign", () => $69c15d57da5552bb$export$3645821254ad9933);
$parcel$export(module.exports, "getLayoutColumnMenuAnchorPos", () => $69c15d57da5552bb$export$22b40f2459c71fe8);

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $irlwb = parcelRequire("irlwb");
const $69c15d57da5552bb$var$findLayoutSectionFromSelection = (selection)=>{
    const { layoutSection: layoutSection } = selection.$from.doc.type.schema.nodes;
    // NodeSelection on the layoutSection node itself
    if (selection instanceof (0, $801jp.NodeSelection) && selection.node.type === layoutSection) return {
        node: selection.node,
        pos: selection.from
    };
    return (0, $a4TQr.findParentNodeOfType)(layoutSection)(selection);
};
const $69c15d57da5552bb$var$findLayoutColumnsFromLayoutSection = (layoutSectionNode, layoutSectionPos = 0)=>{
    return (0, $a4TQr.findChildrenByType)(layoutSectionNode, layoutSectionNode.type.schema.nodes.layoutColumn).map(({ node: node, pos: pos })=>({
            node: node,
            pos: pos + layoutSectionPos + 1
        }));
};
const $69c15d57da5552bb$var$getSelectedLayoutColumns = (selection, isColumnSelected)=>{
    const layoutSection = $69c15d57da5552bb$var$findLayoutSectionFromSelection(selection);
    if (!layoutSection) return undefined;
    const { node: layoutSectionNode, pos: layoutSectionPos } = layoutSection;
    const allLayoutColumns = $69c15d57da5552bb$var$findLayoutColumnsFromLayoutSection(layoutSectionNode, layoutSectionPos);
    if (!allLayoutColumns.length) return undefined;
    let startIndex = -1;
    let endIndex = -1;
    const selectedLayoutColumns = allLayoutColumns.filter((column, index)=>{
        if (isColumnSelected(column, index)) {
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            return true;
        }
        return false;
    });
    return {
        layoutSectionNode: layoutSectionNode,
        layoutSectionPos: layoutSectionPos,
        selectedLayoutColumns: selectedLayoutColumns,
        startIndex: startIndex,
        endIndex: endIndex
    };
};
const $69c15d57da5552bb$export$d9c5d9ac81e1479b = (selection)=>{
    return $69c15d57da5552bb$var$getSelectedLayoutColumns(selection, ({ node: node, pos: pos })=>{
        // NodeSelection on a layout column is clearly selected.
        if (selection instanceof (0, $801jp.NodeSelection) && selection.node === node) return true;
        // For TextSelection, only count columns that are fully contained within the selection
        // (not partial text selections inside a column).
        const nodeEndPos = pos + node.nodeSize;
        return !selection.empty && selection.from <= pos && selection.to >= nodeEndPos;
    });
};
const $69c15d57da5552bb$export$1ba40f8dfd76f1b5 = (selection)=>{
    return $69c15d57da5552bb$var$getSelectedLayoutColumns(selection, ({ node: node, pos: pos })=>{
        if (selection instanceof (0, $801jp.NodeSelection) && selection.node === node) return true;
        const nodeEndPos = pos + node.nodeSize;
        return selection.empty ? selection.from > pos && selection.from < nodeEndPos : selection.from < nodeEndPos && selection.to > pos;
    });
};
const $69c15d57da5552bb$export$1f0e4d47b1eb0108 = (selection)=>{
    const layoutSection = $69c15d57da5552bb$var$findLayoutSectionFromSelection(selection);
    if (!layoutSection) return undefined;
    const layoutColumns = $69c15d57da5552bb$var$findLayoutColumnsFromLayoutSection(layoutSection.node, layoutSection.pos);
    if (!(layoutColumns !== null && layoutColumns !== void 0 && layoutColumns.length)) return undefined;
    return {
        layoutSectionNode: layoutSection.node,
        layoutSectionPos: layoutSection.pos,
        selectedLayoutColumns: layoutColumns,
        startIndex: 0,
        endIndex: layoutColumns.length - 1
    };
};
const $69c15d57da5552bb$export$3645821254ad9933 = (layoutColumn)=>layoutColumn ? layoutColumn.attrs.valign ?? (0, $irlwb.DEFAULT_LAYOUT_COLUMN_VALIGN) : undefined;
const $69c15d57da5552bb$export$22b40f2459c71fe8 = (selection, anchorPosFromHandle)=>{
    var _selectedLayoutColumn;
    const selectedLayoutColumns = $69c15d57da5552bb$export$d9c5d9ac81e1479b(selection);
    if (!selectedLayoutColumns) return undefined;
    const clickedSelectedColumn = selectedLayoutColumns.selectedLayoutColumns.find(({ pos: pos })=>pos === anchorPosFromHandle);
    return (clickedSelectedColumn === null || clickedSelectedColumn === void 0 ? void 0 : clickedSelectedColumn.pos) ?? ((_selectedLayoutColumn = selectedLayoutColumns.selectedLayoutColumns[0]) === null || _selectedLayoutColumn === void 0 ? void 0 : _selectedLayoutColumn.pos);
};

});


parcelRegister("femcY", function(module, exports) {
$parcel$export(module.exports, "default", () => $db9e6f9aeeb64468$export$2e2bcd8739ae039);

var $3LeME = parcelRequire("3LeME");

var $1tkqg = parcelRequire("1tkqg");

var $eUtBU = parcelRequire("eUtBU");

var $3sx0g = parcelRequire("3sx0g");
const $db9e6f9aeeb64468$var$bindLayoutColumnShortcut = (shortcut, command, list)=>{
    if (!shortcut) return;
    (0, $eUtBU.bindKeymapWithEditorCommand)(shortcut, command, list);
};
/**
 * Creates shortcut handlers for layout column actions.
 */ function $db9e6f9aeeb64468$var$keymapPlugin({ api: api }) {
    var _api$analytics, _api$analytics2, _api$analytics3, _api$analytics4, _api$analytics5;
    const list = {};
    $db9e6f9aeeb64468$var$bindLayoutColumnShortcut((0, $eUtBU.addColumnBefore).common, (0, $3sx0g.insertLayoutColumn)({
        side: 'left',
        inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
    }, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api), list);
    $db9e6f9aeeb64468$var$bindLayoutColumnShortcut((0, $eUtBU.addColumnBeforeVO).common, (0, $3sx0g.insertLayoutColumn)({
        side: 'left',
        inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
    }, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions, api), list);
    $db9e6f9aeeb64468$var$bindLayoutColumnShortcut((0, $eUtBU.addColumnAfter).common, (0, $3sx0g.insertLayoutColumn)({
        side: 'right',
        inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
    }, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, api), list);
    $db9e6f9aeeb64468$var$bindLayoutColumnShortcut((0, $eUtBU.addColumnAfterVO).common, (0, $3sx0g.insertLayoutColumn)({
        side: 'right',
        inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
    }, api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, api), list);
    $db9e6f9aeeb64468$var$bindLayoutColumnShortcut((0, $eUtBU.deleteColumn).common, (0, $3sx0g.deleteLayoutColumn)({
        inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
    }, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions, api), list);
    return (0, $1tkqg.keymap)(list);
}
var $db9e6f9aeeb64468$export$2e2bcd8739ae039 = $db9e6f9aeeb64468$var$keymapPlugin;

});

parcelRegister("ksiVK", function(module, exports) {
$parcel$export(module.exports, "default", () => $127c75add808a6c9$export$2e2bcd8739ae039);

var $3LeME = parcelRequire("3LeME");

var $1y7gE = parcelRequire("1y7gE");

var $6bnr9 = parcelRequire("6bnr9");
var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $5mojd = parcelRequire("5mojd");
var $39oqF = parcelRequire("39oqF");

var $1O8Lw = parcelRequire("1O8Lw");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $16ZMX = parcelRequire("16ZMX");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $3sx0g = parcelRequire("3sx0g");

var $7F4Wu = parcelRequire("7F4Wu");

var $irlwb = parcelRequire("irlwb");

var $8WbPO = parcelRequire("8WbPO");

var $bQi3l = parcelRequire("bQi3l");

var $cDiab = parcelRequire("cDiab");

var $cv1v0 = parcelRequire("cv1v0");
const $127c75add808a6c9$export$cfaf3f619f4fde4d = 'two_equal';
/**
 * Shared blank-space gap cursor placement, used by both `handleClick` and `handleClickOn`
 * (the latter catches clicks on atomic node views that stop propagation before `handleClick`).
 * Returns `true` when it placed a selection and consumed the click, else `false`.
 */ const $127c75add808a6c9$var$applyBlankSpaceGapCursor = (view, event)=>{
    if (!(0, $kaRof.editorExperiment)('advanced_layouts', true)) return false;
    const gapTarget = (0, $cDiab.getGapCursorTargetForBlankSpaceClick)(view, event);
    if (gapTarget === undefined) return false;
    const $pos = view.state.doc.resolve(gapTarget.pos);
    // A paragraph child takes a TextSelection (caret at the edge) rather than a gap cursor.
    const isParagraphTarget = (0, $cDiab.isParagraphBlankSpaceTarget)(view, gapTarget);
    const nextSelection = isParagraphTarget ? (0, $801jp.TextSelection).near($pos, gapTarget.side === 'left' ? 1 : -1) : new (0, $ihNBw.GapCursorSelection)($pos, gapTarget.side === 'left' ? (0, $id3e6.Side).LEFT : (0, $id3e6.Side).RIGHT);
    // Idempotency guard: `mousedown` already placed this selection, but the browser still
    // fires `mouseup`, so `handleClick`/`handleClickOn` re-run for the same click. Consume it
    // without re-dispatching (which would add a redundant undo entry).
    if (view.state.selection.eq(nextSelection)) return true;
    view.dispatch(view.state.tr.setSelection(nextSelection).scrollIntoView());
    return true;
};
const $127c75add808a6c9$var$isWholeSelectionInsideLayoutColumn = (state)=>{
    // Since findParentNodeOfType doesn't check if selection.to shares the parent, we do this check ourselves
    const fromParent = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
    if (fromParent) {
        const isToPosInsideSameLayoutColumn = state.selection.from < fromParent.pos + fromParent.node.nodeSize;
        return isToPosInsideSameLayoutColumn;
    }
    return false;
};
const $127c75add808a6c9$var$moveCursorToNextColumn = (state, dispatch)=>{
    const { selection: selection } = state;
    const { schema: { nodes: { layoutColumn: layoutColumn, layoutSection: layoutSection } } } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const section = (0, $a4TQr.findParentNodeOfType)(layoutSection)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const column = (0, $a4TQr.findParentNodeOfType)(layoutColumn)(selection);
    if (column.node !== section.node.lastChild) {
        const $nextColumn = state.doc.resolve(column.pos + column.node.nodeSize);
        const shiftedSelection = (0, $801jp.TextSelection).findFrom($nextColumn, 1);
        if (dispatch) dispatch(state.tr.setSelection(shiftedSelection));
    }
    return true;
};
const $127c75add808a6c9$var$EMPTY_LAYOUT_COLUMN_CLASS = 'pm-layout-column-empty';
const $127c75add808a6c9$var$EMPTY_LAYOUT_COLUMN_NODE_SIZE = 4;
const $127c75add808a6c9$var$getNodeDecorations = (pos, node)=>{
    const decorations = [
        (0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selected'
        })
    ];
    if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') && (0, $bcN2K.isExperimentEnabled)('platform_editor_improve_inp_batch_2')) node.forEach((column, columnOffset)=>{
        if (column.type.name !== 'layoutColumn' || column.childCount !== 1 || column.nodeSize > $127c75add808a6c9$var$EMPTY_LAYOUT_COLUMN_NODE_SIZE) return;
        const paragraph = column.firstChild;
        if (!paragraph || paragraph.marks.length > 0 || !(0, $39oqF.isEmptyParagraph)(paragraph)) return;
        const paragraphPos = pos + columnOffset + 2;
        decorations.push((0, $16ZMX.Decoration).node(paragraphPos, paragraphPos + paragraph.nodeSize, {
            class: $127c75add808a6c9$var$EMPTY_LAYOUT_COLUMN_CLASS
        }));
    });
    return decorations;
};
const $127c75add808a6c9$var$getDangerPreviewDecorations = (state, positions)=>(positions === null || positions === void 0 ? void 0 : positions.flatMap((pos)=>{
        const node = state.doc.nodeAt(pos);
        if (!node) return [];
        return [
            (0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, {
                class: 'layout-column-danger-preview'
            })
        ];
    })) ?? [];
const $127c75add808a6c9$var$getInitialPluginState = (options, state)=>{
    const maybeLayoutSection = (0, $cDiab.getMaybeLayoutSection)(state);
    const allowBreakout = options.allowBreakout || false;
    const addSidebarLayouts = options.UNSAFE_addSidebarLayouts || false;
    const allowSingleColumnLayout = options.UNSAFE_allowSingleColumnLayout || false;
    const pos = maybeLayoutSection ? maybeLayoutSection.pos : null;
    const selectedLayout = (0, $3sx0g.getSelectedLayout)(maybeLayoutSection && maybeLayoutSection.node, $127c75add808a6c9$export$cfaf3f619f4fde4d);
    return {
        pos: pos,
        allowBreakout: allowBreakout,
        addSidebarLayouts: addSidebarLayouts,
        selectedLayout: selectedLayout,
        allowSingleColumnLayout: allowSingleColumnLayout,
        isResizing: false,
        isLayoutColumnMenuOpen: false,
        layoutColumnMenuOpenedViaKeyboard: false,
        layoutColumnMenuAnchorPos: undefined,
        dangerPreviewLayoutColumnPositions: undefined
    };
};
const $127c75add808a6c9$var$fireLayoutColumnMenuOpenedAnalytics = (editorAnalyticsAPI, state, openedViaKeyboard)=>{
    const selectedLayoutColumnsResult = (0, $cv1v0.getSelectedLayoutColumnsFromSelection)(state.selection);
    if (!selectedLayoutColumnsResult) return;
    const { layoutSectionNode: layoutSectionNode, selectedLayoutColumns: selectedLayoutColumns, startIndex: startIndex, endIndex: endIndex } = selectedLayoutColumnsResult;
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent({
        action: (0, $3LeME.ACTION).OPENED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).LAYOUT_COLUMN_MENU,
        attributes: {
            columnCount: layoutSectionNode.childCount,
            endIndex: endIndex,
            inputMethod: openedViaKeyboard ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE,
            selectedCount: selectedLayoutColumns.length,
            startIndex: startIndex
        },
        eventType: (0, $3LeME.EVENT_TYPE).UI
    });
};
const $127c75add808a6c9$var$reduceLayoutColumnMenuState = (pluginState, action)=>{
    switch(action.type){
        case 'toggleLayoutColumnMenu':
            {
                const { anchorPos: anchorPos, isOpen: isOpen, openedViaKeyboard: openedViaKeyboard } = action.meta;
                // `isOpen` provided: use directly (legacy). Omitted: toggle off only when re-clicking
                // the already-open column; otherwise open for the clicked column.
                const isSameColumnAsOpenMenu = pluginState.isLayoutColumnMenuOpen && anchorPos !== undefined && anchorPos === pluginState.layoutColumnMenuAnchorPos;
                const nextIsOpen = isOpen ?? !isSameColumnAsOpenMenu;
                return {
                    ...pluginState,
                    isLayoutColumnMenuOpen: nextIsOpen,
                    layoutColumnMenuOpenedViaKeyboard: nextIsOpen ? openedViaKeyboard ?? false : false,
                    layoutColumnMenuAnchorPos: nextIsOpen ? anchorPos : undefined,
                    dangerPreviewLayoutColumnPositions: nextIsOpen ? pluginState.dangerPreviewLayoutColumnPositions : undefined
                };
            }
        case 'setDangerPreview':
            return {
                ...pluginState,
                dangerPreviewLayoutColumnPositions: action.positions
            };
        case 'clearDangerPreview':
            return {
                ...pluginState,
                dangerPreviewLayoutColumnPositions: undefined
            };
        case 'setResizeState':
            return {
                ...pluginState,
                isResizing: action.isResizing
            };
        case 'syncSelectionState':
            {
                const maybeLayoutSection = (0, $cDiab.getMaybeLayoutSection)(action.state);
                return {
                    ...pluginState,
                    pos: maybeLayoutSection ? maybeLayoutSection.pos : null,
                    selectedLayout: (0, $3sx0g.getSelectedLayout)(maybeLayoutSection && maybeLayoutSection.node, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    pluginState.selectedLayout)
                };
            }
    }
};
// To prevent a single-column layout,
// if a user attempts to delete a layout column and
// we will force remove the content instead.
// There are some edge cases where user can delete a layout column
// see packages/editor/editor-plugin-layout-tests/src/__tests__/unit/delete.ts
const $127c75add808a6c9$var$handleDeleteLayoutColumn = (state, dispatch)=>{
    const sel = state.selection;
    if (sel instanceof (0, $801jp.NodeSelection) && sel.node.type.name === 'layoutColumn' && sel.$from.parent.type.name === 'layoutSection' && sel.$from.parent.childCount === 2 && dispatch && (0, $kaRof.editorExperiment)('advanced_layouts', true) && !(0, $kaRof.editorExperiment)('single_column_layouts', true)) {
        var _sel$$from$parent$las, _sel$$from$parent$fir;
        const tr = state.tr;
        const layoutContentFragment = sel.$from.parentOffset === 0 ? (0, $7H6Cr.Fragment).from((_sel$$from$parent$las = sel.$from.parent.lastChild) === null || _sel$$from$parent$las === void 0 ? void 0 : _sel$$from$parent$las.content) : (0, $7H6Cr.Fragment).from((_sel$$from$parent$fir = sel.$from.parent.firstChild) === null || _sel$$from$parent$fir === void 0 ? void 0 : _sel$$from$parent$fir.content);
        const parent = (0, $a4TQr.findParentNodeClosestToPos)(sel.$from, (node)=>{
            return node.type.name === 'layoutSection';
        });
        if (parent) {
            const layoutSectionPos = tr.mapping.map(parent.pos);
            const layoutSectionNodeSize = parent.node.nodeSize;
            dispatch(state.tr.replaceWith(layoutSectionPos, layoutSectionPos + layoutSectionNodeSize, layoutContentFragment));
            return true;
        }
        return false;
    }
    return false;
};
var $127c75add808a6c9$export$2e2bcd8739ae039 = (options, editorAnalyticsAPI, isViewMode = ()=>false)=>{
    // Store a reference to the EditorView so widget decorations can dispatch transactions
    let editorViewRef;
    return new (0, $1y7gE.SafePlugin)({
        key: (0, $8WbPO.pluginKey),
        view (view) {
            editorViewRef = view;
            return {
                update (updatedView) {
                    editorViewRef = updatedView;
                },
                destroy () {
                    editorViewRef = undefined;
                }
            };
        },
        state: {
            init: (_, state)=>$127c75add808a6c9$var$getInitialPluginState(options, state),
            apply: (tr, pluginState, oldState, newState)=>{
                var _pluginKey$getState;
                let nextPluginState = pluginState;
                const columnMenuMeta = tr.getMeta('toggleLayoutColumnMenu');
                const dangerPreviewMeta = tr.getMeta('layoutColumnDangerPreview');
                if (columnMenuMeta) {
                    const wasLayoutColumnMenuOpen = nextPluginState.isLayoutColumnMenuOpen;
                    nextPluginState = $127c75add808a6c9$var$reduceLayoutColumnMenuState(nextPluginState, {
                        meta: columnMenuMeta,
                        type: 'toggleLayoutColumnMenu'
                    });
                    if (!wasLayoutColumnMenuOpen && nextPluginState.isLayoutColumnMenuOpen) $127c75add808a6c9$var$fireLayoutColumnMenuOpenedAnalytics(editorAnalyticsAPI, newState, columnMenuMeta.openedViaKeyboard);
                }
                if (tr.getMeta('layoutColumnDangerPreview') !== undefined) nextPluginState = $127c75add808a6c9$var$reduceLayoutColumnMenuState(nextPluginState, {
                    positions: dangerPreviewMeta ?? undefined,
                    type: 'setDangerPreview'
                });
                if (tr.docChanged) nextPluginState = $127c75add808a6c9$var$reduceLayoutColumnMenuState(nextPluginState, {
                    type: 'clearDangerPreview'
                });
                const isResizing = (0, $kaRof.editorExperiment)('single_column_layouts', true) ? tr.getMeta('is-resizer-resizing') ?? ((_pluginKey$getState = (0, $8WbPO.pluginKey).getState(oldState)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.isResizing) : false;
                nextPluginState = $127c75add808a6c9$var$reduceLayoutColumnMenuState(nextPluginState, {
                    isResizing: isResizing,
                    type: 'setResizeState'
                });
                if (tr.docChanged || tr.selectionSet) return $127c75add808a6c9$var$reduceLayoutColumnMenuState(nextPluginState, {
                    state: newState,
                    type: 'syncSelectionState'
                });
                return nextPluginState;
            }
        },
        props: {
            decorations (state) {
                const layoutState = (0, $8WbPO.pluginKey).getState(state);
                const isLayoutResizingPluginAvailable = (0, $bQi3l.pluginKey).get(state) !== undefined;
                if ((0, $kaRof.editorExperiment)('advanced_layouts', true) && isLayoutResizingPluginAvailable && !(isViewMode() && (0, $bcN2K.isExperimentEnabled)('platform_editor_disable_view_layout_resize'))) {
                    const dividerDecorations = (0, $7F4Wu.getColumnDividerDecorations)(state, editorViewRef, editorAnalyticsAPI);
                    const selectedDecorations = layoutState.pos !== null ? $127c75add808a6c9$var$getNodeDecorations(layoutState.pos, state.doc.nodeAt(layoutState.pos)) : [];
                    const dangerPreviewDecorations = $127c75add808a6c9$var$getDangerPreviewDecorations(state, layoutState.dangerPreviewLayoutColumnPositions);
                    const allDecorations = [
                        ...selectedDecorations,
                        ...dividerDecorations,
                        ...dangerPreviewDecorations
                    ];
                    if (allDecorations.length > 0) return (0, $16ZMX.DecorationSet).create(state.doc, allDecorations);
                    return undefined;
                }
                const dangerPreviewDecorations = $127c75add808a6c9$var$getDangerPreviewDecorations(state, layoutState.dangerPreviewLayoutColumnPositions);
                if (layoutState.pos !== null || dangerPreviewDecorations.length > 0) {
                    const selectedDecorations = layoutState.pos !== null ? $127c75add808a6c9$var$getNodeDecorations(layoutState.pos, state.doc.nodeAt(layoutState.pos)) : [];
                    return (0, $16ZMX.DecorationSet).create(state.doc, [
                        ...selectedDecorations,
                        ...dangerPreviewDecorations
                    ]);
                }
                return undefined;
            },
            handleKeyDown: (0, $1O8Lw.keydownHandler)({
                Tab: (0, $5mojd.filter)($127c75add808a6c9$var$isWholeSelectionInsideLayoutColumn, $127c75add808a6c9$var$moveCursorToNextColumn),
                'Mod-Backspace': $127c75add808a6c9$var$handleDeleteLayoutColumn,
                'Mod-Delete': $127c75add808a6c9$var$handleDeleteLayoutColumn,
                Backspace: $127c75add808a6c9$var$handleDeleteLayoutColumn,
                Delete: $127c75add808a6c9$var$handleDeleteLayoutColumn
            }),
            handleDOMEvents: {
                // Place the gap cursor on `mousedown` (not `mouseup`) so the caret never flashes
                // inside a nested editable child first.
                mousedown (view, event) {
                    const target = event.target;
                    if (target !== null && target !== void 0 && target.hasAttribute('data-layout-section')) return false;
                    if ($127c75add808a6c9$var$applyBlankSpaceGapCursor(view, event)) {
                        event.preventDefault();
                        // `preventDefault()` blocks the editor focus that makes the gap cursor blink,
                        // so restore it here. The `handleClick`/`handleClickOn` paths don't need this.
                        if (!view.hasFocus()) view.focus();
                        return true;
                    }
                    return false;
                }
            },
            handleClickOn: (()=>{
                const selectionClickHandler = (0, $6bnr9.createSelectionClickHandler)([
                    'layoutColumn'
                ], (target)=>target.hasAttribute('data-layout-section') || target.hasAttribute('data-layout-column'), {
                    useLongPressSelection: options.useLongPressSelection || false,
                    getNodeSelectionPos: (state, nodePos)=>state.doc.resolve(nodePos).before()
                });
                return (view, pos, node, nodePos, event, direct)=>{
                    // Fallback for clicks on an atomic node view that the mousedown hook missed.
                    const target = event.target;
                    if (!(target !== null && target !== void 0 && target.hasAttribute('data-layout-section')) && $127c75add808a6c9$var$applyBlankSpaceGapCursor(view, event)) return true;
                    return selectionClickHandler(view, pos, node, nodePos, event, direct);
                };
            })(),
            handleClick (view, _pos, event) {
                // Fallback for clicks the mousedown interceptor missed.
                const target = event.target;
                if (target !== null && target !== void 0 && target.hasAttribute('data-layout-section')) return false;
                return $127c75add808a6c9$var$applyBlankSpaceGapCursor(view, event);
            }
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            const changes = [];
            transactions.forEach((prevTr)=>{
                // remap change segments across the transaction set
                changes.forEach((change)=>{
                    return {
                        from: prevTr.mapping.map(change.from),
                        to: prevTr.mapping.map(change.to),
                        slice: change.slice
                    };
                });
                // don't consider transactions that don't mutate
                if (!prevTr.docChanged) return;
                // Skip fixing column sizes for column resize drag transactions
                if (prevTr.getMeta('layoutColumnResize')) return;
                // Layout column insert actions already recalculate column widths and need their own
                // selection mapping; avoid a follow-up normalisation transaction that can remap it.
                if (prevTr.getMeta((0, $3sx0g.LAYOUT_COLUMN_INSERT_META))) return;
                const change = (0, $3sx0g.fixColumnSizes)(prevTr, newState);
                if (change) changes.push(change);
            });
            if ((0, $kaRof.editorExperiment)('advanced_layouts', true) && changes.length === 1) {
                var _change$slice$content, _change$slice$content2;
                const change = changes[0];
                // When editorExperiment('single_column_layouts', true) is on
                // delete can create a single column layout
                // otherwise we replace the single column layout with its content
                if (!(0, $kaRof.editorExperiment)('single_column_layouts', true) && change.slice.content.childCount === 1 && ((_change$slice$content = change.slice.content.firstChild) === null || _change$slice$content === void 0 ? void 0 : _change$slice$content.type.name) === 'layoutColumn' && ((_change$slice$content2 = change.slice.content.firstChild) === null || _change$slice$content2 === void 0 ? void 0 : _change$slice$content2.attrs.width) === (0, $irlwb.EVEN_DISTRIBUTED_COL_WIDTHS)[1]) {
                    const tr = newState.tr;
                    const { content: content } = change.slice.content.firstChild;
                    tr.replaceWith(change.from - 1, change.to, content);
                    return tr;
                }
            }
            if (changes.length) {
                let tr = newState.tr;
                const selection = newState.selection.toJSON();
                changes.forEach((change)=>{
                    tr.replaceRange(change.from, change.to, change.slice);
                });
                // selecting and deleting across columns in 3 col layouts can remove
                // a layoutColumn so we fix the structure here
                tr = (0, $3sx0g.fixColumnStructure)(newState) || tr;
                if (tr.docChanged) {
                    tr.setSelection((0, $801jp.Selection).fromJSON(tr.doc, selection));
                    return tr;
                }
            }
            return;
        }
    });
};

});
parcelRegister("7F4Wu", function(module, exports) {
$parcel$export(module.exports, "getColumnDividerDecorations", () => $edf4ce4ba8ffc1cc$export$b54a43c7f9b448fd);

var $6Zi52 = parcelRequire("6Zi52");

var $3LeME = parcelRequire("3LeME");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $irlwb = parcelRequire("irlwb");
/**
 * Re-creates a selection at the same positions against the resized document. A resize only
 * changes width attrs (not node count, order, or size), so the original positions are still
 * valid. Returns `undefined` if no valid selection can be made.
 */ const $edf4ce4ba8ffc1cc$var$remapResizeSelection = (selection, doc)=>{
    const docSize = doc.content.size;
    const clamp = (pos)=>Math.min(Math.max(pos, 0), docSize);
    if (selection instanceof (0, $801jp.NodeSelection)) {
        const pos = clamp(selection.from);
        const nodeAtPos = doc.nodeAt(pos);
        if (nodeAtPos && (0, $801jp.NodeSelection).isSelectable(nodeAtPos)) return (0, $801jp.NodeSelection).create(doc, pos);
        return (0, $801jp.TextSelection).findFrom(doc.resolve(pos), 1, true) ?? undefined;
    }
    if (selection instanceof (0, $801jp.TextSelection)) try {
        return (0, $801jp.TextSelection).create(doc, clamp(selection.from), clamp(selection.to));
    } catch  {
        return undefined;
    }
    return undefined;
};
// Class names for the column resize divider widget — must stay in sync with layout.ts in editor-core
const $edf4ce4ba8ffc1cc$var$layoutColumnDividerClassName = 'layout-column-divider';
const $edf4ce4ba8ffc1cc$var$layoutColumnDividerRailClassName = 'layout-column-divider-rail';
const $edf4ce4ba8ffc1cc$var$layoutColumnDividerThumbClassName = 'layout-column-divider-thumb';
// Module-level drag state so it survives widget DOM recreation during transactions.
let $edf4ce4ba8ffc1cc$var$dragState = null;
/**
 * Dispatches a single undoable ProseMirror transaction to commit the final
 * column widths after a drag completes.
 */ const $edf4ce4ba8ffc1cc$var$dispatchColumnWidths = (view, sectionPos, leftColIndex, leftWidth, rightWidth, editorAnalyticsAPI)=>{
    const { state: state } = view;
    const sectionNode = state.doc.nodeAt(sectionPos);
    if (!sectionNode) return;
    const { layoutColumn: layoutColumn } = state.schema.nodes;
    const tr = state.tr;
    const newColumns = [];
    sectionNode.forEach((child, _offset, index)=>{
        if (child.type === layoutColumn) {
            let newWidth = child.attrs.width;
            if (index === leftColIndex) newWidth = Number(leftWidth.toFixed(2));
            else if (index === leftColIndex + 1) newWidth = Number(rightWidth.toFixed(2));
            newColumns.push(layoutColumn.create({
                ...child.attrs,
                width: newWidth
            }, child.content, child.marks));
        } else newColumns.push(child);
    });
    // Capture the selection before the replace below, which otherwise maps the caret out of
    // the layout to the following paragraph. Restored at the same positions afterwards.
    const selectionBeforeResize = state.selection;
    tr.replaceWith(sectionPos + 1, sectionPos + sectionNode.nodeSize - 1, (0, $7H6Cr.Fragment).from(newColumns));
    tr.setMeta('layoutColumnResize', true);
    tr.setMeta('scrollIntoView', false);
    if (selectionBeforeResize) {
        const restoredSelection = $edf4ce4ba8ffc1cc$var$remapResizeSelection(selectionBeforeResize, tr.doc);
        if (restoredSelection) tr.setSelection(restoredSelection);
    }
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: (0, $3LeME.ACTION).DRAGGED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT_COLUMN,
        attributes: {
            columnCount: sectionNode.childCount,
            leftColumnIndex: leftColIndex,
            leftColumnWidth: Number(leftWidth.toFixed(2)),
            rightColumnWidth: Number(rightWidth.toFixed(2)),
            inputMethod: (0, $3LeME.INPUT_METHOD).DRAG
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    })(tr);
    view.dispatch(tr);
};
/**
 * Calculates new column widths from the current mouse X position during drag.
 * Uses the columns-only width cached at mousedown — no layout reflow.
 *
 * The denominator is `columnsWidth` (the total flex container width minus
 * divider widgets and flex gaps) so that a 1 px mouse movement corresponds
 * to the exact same visual shift in the column boundary, eliminating the
 * few-pixel drift that occurred when using the full section width.
 */ const $edf4ce4ba8ffc1cc$var$calcDragWidths = (clientX)=>{
    if (!$edf4ce4ba8ffc1cc$var$dragState) return null;
    const { columnsWidth: columnsWidth } = $edf4ce4ba8ffc1cc$var$dragState;
    if (columnsWidth === 0) return null;
    const deltaX = clientX - $edf4ce4ba8ffc1cc$var$dragState.startX;
    const combinedWidth = $edf4ce4ba8ffc1cc$var$dragState.startLeftWidth + $edf4ce4ba8ffc1cc$var$dragState.startRightWidth;
    const deltaPercent = deltaX / columnsWidth * 100;
    let leftWidth = $edf4ce4ba8ffc1cc$var$dragState.startLeftWidth + deltaPercent;
    let rightWidth = $edf4ce4ba8ffc1cc$var$dragState.startRightWidth - deltaPercent;
    if (leftWidth < (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT)) {
        leftWidth = (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT);
        rightWidth = combinedWidth - (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT);
    } else if (rightWidth < (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT)) {
        rightWidth = (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT);
        leftWidth = combinedWidth - (0, $irlwb.MIN_LAYOUT_COLUMN_WIDTH_PERCENT);
    }
    return {
        leftWidth: leftWidth,
        rightWidth: rightWidth
    };
};
const $edf4ce4ba8ffc1cc$var$onDragMouseMove = (e)=>{
    if (!$edf4ce4ba8ffc1cc$var$dragState) return;
    // If the mouse button was released outside the window (e.g. over browser chrome
    // or an iframe), we won't receive a mouseup on ownerDoc. Detect this by checking
    // whether any button is still held — if not, treat it as a drag end.
    if (e.buttons === 0) {
        $edf4ce4ba8ffc1cc$var$onDragEnd(e.clientX);
        return;
    }
    // Always capture the latest clientX so the rAF callback uses the most recent
    // mouse position. Previously, intermediate positions were dropped when an rAF
    // was already scheduled, causing the column boundary to lag behind the cursor.
    $edf4ce4ba8ffc1cc$var$dragState.lastClientX = e.clientX;
    // If a paint frame is already scheduled it will pick up lastClientX — no need
    // to schedule another one.
    if ($edf4ce4ba8ffc1cc$var$dragState.rafId !== null) return;
    $edf4ce4ba8ffc1cc$var$dragState.rafId = requestAnimationFrame(()=>{
        if (!$edf4ce4ba8ffc1cc$var$dragState) return;
        $edf4ce4ba8ffc1cc$var$dragState.rafId = null;
        const widths = $edf4ce4ba8ffc1cc$var$calcDragWidths($edf4ce4ba8ffc1cc$var$dragState.lastClientX);
        if (!widths) return;
        // Write flex-basis directly onto the column elements' inline styles for immediate
        // visual feedback. This beats PM's own inline flex-basis value without dispatching
        // any PM transaction — keeping drag completely off the ProseMirror render path.
        // The LayoutColumnView.ignoreMutation implementation ensures PM's MutationObserver
        // does not revert these style changes mid-drag.
        $edf4ce4ba8ffc1cc$var$dragState.hasDragged = true;
        $edf4ce4ba8ffc1cc$var$dragState.leftColEl.style.flexBasis = `${widths.leftWidth}%`;
        $edf4ce4ba8ffc1cc$var$dragState.rightColEl.style.flexBasis = `${widths.rightWidth}%`;
    });
};
/**
 * Shared teardown for all drag-end paths (mouseup, missed mouseup detected via
 * e.buttons===0 on mousemove, window blur, and visibilitychange). Commits the
 * final column widths if a real drag occurred.
 */ const $edf4ce4ba8ffc1cc$var$onDragEnd = (clientX)=>{
    if (!$edf4ce4ba8ffc1cc$var$dragState) return;
    const { view: view, sectionPos: sectionPos, leftColIndex: leftColIndex, leftColEl: leftColEl, rightColEl: rightColEl, hasDragged: hasDragged, rafId: rafId, startLeftWidth: startLeftWidth, startRightWidth: startRightWidth, unbindListeners: unbindListeners, editorAnalyticsAPI: editorAnalyticsAPI } = $edf4ce4ba8ffc1cc$var$dragState;
    unbindListeners();
    // Cancel any pending rAF so a stale frame doesn't write styles after teardown.
    if (rafId !== null) cancelAnimationFrame(rafId);
    const ownerDoc = view.dom.ownerDocument;
    ownerDoc.body.style.userSelect = '';
    ownerDoc.body.style.cursor = '';
    const widths = $edf4ce4ba8ffc1cc$var$calcDragWidths(clientX);
    $edf4ce4ba8ffc1cc$var$dragState = null;
    if (!hasDragged) // The user clicked without dragging — no flex-basis overrides were written,
    // so there is nothing to clean up and no transaction to dispatch.
    return;
    // Clear the drag-time flex-basis overrides. The PM transaction below will
    // write the committed widths back into the node attrs and re-render the DOM.
    leftColEl.style.flexBasis = '';
    rightColEl.style.flexBasis = '';
    if (widths && (widths.leftWidth !== startLeftWidth || widths.rightWidth !== startRightWidth)) $edf4ce4ba8ffc1cc$var$dispatchColumnWidths(view, sectionPos, leftColIndex, widths.leftWidth, widths.rightWidth, editorAnalyticsAPI);
};
const $edf4ce4ba8ffc1cc$var$onDragMouseUp = (e)=>{
    $edf4ce4ba8ffc1cc$var$onDragEnd(e.clientX);
};
/**
 * Called when the window loses focus (blur) or the tab becomes hidden
 * (visibilitychange). In either case the user can't be dragging anymore,
 * so we commit the drag at the last known mouse position.
 */ const $edf4ce4ba8ffc1cc$var$onDragCancel = ()=>{
    if (!$edf4ce4ba8ffc1cc$var$dragState) return;
    // Commit at the last captured mouse position rather than startX, so the
    // columns stay where the user last saw them.
    $edf4ce4ba8ffc1cc$var$onDragEnd($edf4ce4ba8ffc1cc$var$dragState.lastClientX);
};
/**
 * Resolves the layout section a divider sits in and which pair of columns it separates.
 *
 * This is derived from the widget's own live position, which ProseMirror keeps up to date. That is
 * what lets the decoration key omit the section position: the key previously embedded it, so
 * inserting a single character above a layout changed the key of every divider below and forced
 * ProseMirror to destroy and rebuild all of them.
 */ const $edf4ce4ba8ffc1cc$var$resolveDividerTarget = (view, getPos)=>{
    const pos = getPos();
    if (pos === undefined) return null;
    // The widget is anchored at the position of the column it precedes, which resolves to a
    // position directly inside the layout section.
    const $pos = view.state.doc.resolve(pos);
    const colIndex = $pos.index();
    if ($pos.parent.type !== view.state.schema.nodes.layoutSection || colIndex < 1) return null;
    return {
        sectionNode: $pos.parent,
        sectionPos: $pos.before(),
        leftColIndex: colIndex - 1
    };
};
/**
 * Creates a column divider widget DOM element with drag-to-resize interaction for
 * the adjacent layout columns. During drag, flex-basis is mutated directly on the
 * column DOM elements for zero-overhead visual feedback (no PM transactions).
 * A single undoable PM transaction is dispatched on mouseup to commit the final widths.
 */ const $edf4ce4ba8ffc1cc$var$createColumnDividerWidget = (view, getPos, editorAnalyticsAPI)=>{
    const ownerDoc = view.dom.ownerDocument;
    // Outer container: wide transparent hit area for easy grabbing, zero flex footprint
    const divider = ownerDoc.createElement('div');
    divider.classList.add($edf4ce4ba8ffc1cc$var$layoutColumnDividerClassName);
    divider.contentEditable = 'false';
    // Rail: styled via layoutColumnDividerStyles in layout.ts
    const rail = ownerDoc.createElement('div');
    rail.classList.add($edf4ce4ba8ffc1cc$var$layoutColumnDividerRailClassName);
    divider.appendChild(rail);
    // Thumb: styled via layoutColumnDividerStyles in layout.ts
    const thumb = ownerDoc.createElement('div');
    thumb.classList.add($edf4ce4ba8ffc1cc$var$layoutColumnDividerThumbClassName);
    rail.appendChild(thumb);
    const unbindMouseDown = (0, $6Zi52.bind)(divider, {
        type: 'mousedown',
        listener: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            const resolved = $edf4ce4ba8ffc1cc$var$resolveDividerTarget(view, getPos);
            if (!resolved) return;
            const { sectionNode: sectionNode, leftColIndex: leftColIndex, sectionPos: resolvedSectionPos } = resolved;
            // Get the initial widths of the two adjacent columns
            let leftCol = null;
            let rightCol = null;
            sectionNode.forEach((child, _offset, index)=>{
                if (index === leftColIndex) leftCol = child;
                if (index === leftColIndex + 1) rightCol = child;
            });
            if (!leftCol || !rightCol) return;
            const sectionElement = divider.closest('[data-layout-section]');
            if (!(sectionElement instanceof HTMLElement)) return;
            // Capture the two adjacent column DOM elements upfront so mousemove can
            // mutate their flex-basis directly without any PM transaction overhead.
            // Query by data-layout-column-index (stamped by LayoutColumnView) rather than
            // relying on positional order of [data-layout-column] elements, which would
            // break if the DOM structure or ordering ever changes.
            const leftColEl = sectionElement.querySelector(`[data-layout-column-index="${leftColIndex}"]`);
            const rightColEl = sectionElement.querySelector(`[data-layout-column-index="${leftColIndex + 1}"]`);
            if (!leftColEl || !rightColEl) return;
            const unbindMove = (0, $6Zi52.bind)(ownerDoc, {
                type: 'mousemove',
                listener: $edf4ce4ba8ffc1cc$var$onDragMouseMove
            });
            const unbindUp = (0, $6Zi52.bind)(ownerDoc, {
                type: 'mouseup',
                listener: $edf4ce4ba8ffc1cc$var$onDragMouseUp
            });
            // If the user releases the mouse outside the browser window (e.g. over the
            // OS desktop) and then brings the cursor back, we won't get a mouseup on
            // ownerDoc. Listening on window for blur and on the document for
            // visibilitychange catches tab switches and window focus loss respectively.
            const unbindBlur = (0, $6Zi52.bind)(ownerDoc.defaultView ?? window, {
                type: 'blur',
                listener: $edf4ce4ba8ffc1cc$var$onDragCancel
            });
            const unbindVisibility = (0, $6Zi52.bind)(ownerDoc, {
                type: 'visibilitychange',
                listener: $edf4ce4ba8ffc1cc$var$onDragCancel
            });
            // Compute the width available to columns only (excluding divider widgets and
            // flex gaps). Using this as the denominator ensures that a 1 px mouse delta
            // translates to the exact pixel shift on the column boundary.
            const sectionRect = sectionElement.getBoundingClientRect();
            const dividers = sectionElement.querySelectorAll(`.${$edf4ce4ba8ffc1cc$var$layoutColumnDividerClassName}`);
            let dividersWidth = 0;
            dividers.forEach((d)=>{
                dividersWidth += d.getBoundingClientRect().width;
            });
            // Account for CSS gap between flex children. The gap is applied between
            // every pair of direct children (columns + divider widgets).
            const computedGap = parseFloat(getComputedStyle(sectionElement).gap || '0');
            const childCount = sectionElement.children.length;
            const totalGap = childCount > 1 ? computedGap * (childCount - 1) : 0;
            const columnsWidth = sectionRect.width - dividersWidth - totalGap;
            $edf4ce4ba8ffc1cc$var$dragState = {
                editorAnalyticsAPI: editorAnalyticsAPI,
                hasDragged: false,
                lastClientX: e.clientX,
                rafId: null,
                view: view,
                sectionPos: resolvedSectionPos,
                leftColIndex: leftColIndex,
                leftColEl: leftColEl,
                rightColEl: rightColEl,
                startX: e.clientX,
                startLeftWidth: leftCol.attrs.width,
                startRightWidth: rightCol.attrs.width,
                columnsWidth: columnsWidth,
                sectionElement: sectionElement,
                unbindListeners: ()=>{
                    unbindMove();
                    unbindUp();
                    unbindBlur();
                    unbindVisibility();
                }
            };
            ownerDoc.body.style.userSelect = 'none';
            ownerDoc.body.style.cursor = 'col-resize';
        }
    });
    return {
        target: divider,
        destroy: unbindMouseDown
    };
};
const $edf4ce4ba8ffc1cc$export$b54a43c7f9b448fd = (state, view, editorAnalyticsAPI)=>{
    const decorations = [];
    if (!view) return decorations;
    const { layoutSection: layoutSection, bodiedSyncBlock: bodiedSyncBlock } = state.schema.nodes;
    let sectionIndex = 0;
    state.doc.descendants((node, pos)=>{
        if (node.type === layoutSection) {
            // This layout's ordinal in the document, used below as a position-independent key.
            const sectionOrdinal = sectionIndex++;
            // Walk through layout column children and add dividers between them
            node.forEach((_, offset, index)=>{
                // Add a divider widget BEFORE every column except the first
                if (index > 0) {
                    const widgetPos = pos + offset + 1; // position at the start of this column
                    // Keyed by the layout's ordinal rather than its position, so an edit elsewhere in
                    // the document doesn't invalidate it. A position-derived key changed on every
                    // keystroke above a layout, making the regenerated DecorationSet compare unequal
                    // and forcing ProseMirror to destroy and rebuild every divider below the edit. The
                    // widget resolves its own section from `getPos` (see `resolveDividerTarget`), so it
                    // stays correct wherever it ends up.
                    //
                    // `toDOM` must also stay lazy: most of the `Decoration`s returned here are matched
                    // by key against the previous set and discarded without ever being rendered.
                    // Building the widget eagerly would create three elements and bind a `mousedown`
                    // listener per divider per call, and the discarded ones never receive `destroy`.
                    let unbindMouseDown;
                    decorations.push((0, $16ZMX.Decoration).widget(widgetPos, (widgetView, getPos)=>{
                        const { target: target, destroy: destroy } = $edf4ce4ba8ffc1cc$var$createColumnDividerWidget(widgetView, getPos, editorAnalyticsAPI);
                        unbindMouseDown = destroy;
                        return target;
                    }, {
                        side: -1,
                        // place before the position
                        key: `layout-col-divider-${sectionOrdinal}-${index}`,
                        ignoreSelection: true,
                        destroy: ()=>{
                            var _unbindMouseDown;
                            (_unbindMouseDown = unbindMouseDown) === null || _unbindMouseDown === void 0 || _unbindMouseDown();
                            unbindMouseDown = undefined;
                        }
                    }));
                }
            });
            return false; // don't descend into children
        }
        // A `layoutSection` is only valid as a direct child of `doc` or `bodiedSyncBlock`, so there
        // is nothing to find anywhere else. The unrestricted walk visited every node in the
        // document — every table cell, list item and text node — on every `decorations(state)` read.
        return node.type === bodiedSyncBlock;
    });
    return decorations;
};

});

parcelRegister("bQi3l", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $bab00aaee724d69c$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "default", () => $bab00aaee724d69c$export$2e2bcd8739ae039);

var $eVKpX = parcelRequire("eVKpX");

var $1y7gE = parcelRequire("1y7gE");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $bcN2K = parcelRequire("bcN2K");

var $cN6Qu = parcelRequire("cN6Qu");

var $i0ISB = parcelRequire("i0ISB");
const $bab00aaee724d69c$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('layoutResizingPlugin');
/**
 * Minimal node view for layoutColumn that delegates all DOM serialization to the
 * NodeSpec's own toDOM, but overrides ignoreMutation to suppress style attribute
 * mutations from ProseMirror's MutationObserver.
 *
 * This is necessary so that direct inline style mutations during column drag
 * (e.g. setting flex-basis to give real-time visual feedback without dispatching
 * PM transactions) are not "corrected" back by ProseMirror's DOM reconciliation.
 */ const $bab00aaee724d69c$var$isLayoutElementLike = (element)=>{
    if ((0, $eVKpX.isSSR)()) {
        // In SSR environments, `HTMLElement` is undefined globally so a plain
        // `instanceof HTMLElement` check is always `false`. That makes the
        // `DOMSerializer.renderSpec(...)` result get rejected by the guard below and
        // the NodeView falls back to a bare `<div>`, losing every schema-defined
        // attribute (`data-layout-column`, `style="flex-basis:..."`,
        // `data-column-width`, plus the inner `<div data-layout-content="true">`
        // wrapper) and breaking the layout's flex sizing in SSR output.
        //
        // To unblock SSR without changing CSR semantics, we gate the check:
        // - In SSR, use a duck-typed check that mirrors `safe-plugin`'s `isHTMLElement`.
        // - Everywhere else, keep the original `instanceof HTMLElement` check exactly
        //   as it was so we don't accidentally widen acceptance in CSR.
        if (element === null || element === undefined) return false;
        return typeof element === 'object' && 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    return element instanceof HTMLElement;
};
class $bab00aaee724d69c$var$LayoutColumnView {
    constructor(node, view, getPos){
        // Use the NodeSpec's own toDOM to produce the correct DOM structure and attributes.
        const nodeType = view.state.schema.nodes[node.type.name];
        // Fallback: create a plain div so PM always has a valid DOM node to work with.
        // This path should never be reached in practice — layoutColumn always has a toDOM.
        if (!nodeType.spec.toDOM) {
            const fallbackDiv = document.createElement('div');
            this.dom = fallbackDiv;
            this.contentDOM = fallbackDiv;
            return;
        }
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, nodeType.spec.toDOM(node));
        if (!$bab00aaee724d69c$var$isLayoutElementLike(dom) || !$bab00aaee724d69c$var$isLayoutElementLike(contentDOM)) {
            const fallbackDiv = document.createElement('div');
            this.dom = fallbackDiv;
            this.contentDOM = fallbackDiv;
            return;
        }
        this.dom = dom;
        this.contentDOM = contentDOM;
        // Stamp the column's index within its parent section onto the DOM element so that
        // column-resize-divider can query columns by index rather than relying on positional
        // order of [data-layout-column] elements (which could break if the DOM structure changes).
        const pos = getPos();
        if (pos !== undefined) {
            const $pos = view.state.doc.resolve(pos);
            this.dom.setAttribute('data-layout-column-index', String($pos.index()));
        }
    }
    ignoreMutation(mutation) {
        // Ignore style attribute mutations — these are direct DOM writes during column drag
        // (setting flex-basis for real-time resize feedback). Without this, PM's
        // MutationObserver would immediately revert our style changes.
        return mutation.type === 'attributes' && mutation.attributeName === 'style';
    }
}
var $bab00aaee724d69c$export$2e2bcd8739ae039 = (options, pluginInjectionApi, portalProviderAPI, eventDispatcher, intl)=>new (0, $1y7gE.SafePlugin)({
        key: $bab00aaee724d69c$export$18d4026d1ea86bb1,
        props: {
            nodeViews: {
                layoutSection: (node, view, getPos)=>{
                    // The vanilla view renders no React, so it cannot mount the
                    // <LayoutBreakoutResizer> that LayoutSectionView.render() used to return.
                    // That resizer is redundant now that breakout resizing is handled by the
                    // pragmatic resizer in editor-plugin-breakout.
                    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1')) return new (0, $i0ISB.LayoutSectionView)(node);
                    return new (0, $cN6Qu.LayoutSectionView)({
                        node: node,
                        view: view,
                        getPos: getPos,
                        portalProviderAPI: portalProviderAPI,
                        eventDispatcher: eventDispatcher,
                        pluginInjectionApi: pluginInjectionApi,
                        options: options,
                        intl: intl
                    }).init();
                },
                layoutColumn: (node, view, getPos)=>new $bab00aaee724d69c$var$LayoutColumnView(node, view, getPos)
            }
        }
    });

});
parcelRegister("cN6Qu", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionView", () => $6bace50bec15a311$export$8bfc7bdc15be731c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $eVKpX = parcelRequire("eVKpX");

var $5237J = parcelRequire("5237J");
var $58I5S = parcelRequire("58I5S");

var $cmn9q = parcelRequire("cmn9q");

var $7H6Cr = parcelRequire("7H6Cr");

var $dRkX9 = parcelRequire("dRkX9");

var $g4cRP = parcelRequire("g4cRP");

var $33S4L = parcelRequire("33S4L");
const $6bace50bec15a311$var$toDOM = (node)=>[
        'div',
        {
            class: 'layout-section-container'
        },
        [
            'div',
            {
                'data-layout-section': true,
                ...(0, $dRkX9.fg)('platform_editor_adf_with_localid') && {
                    'data-local-id': node.attrs.localId
                }
            },
            0
        ]
    ];
class $6bace50bec15a311$export$8bfc7bdc15be731c extends (0, $5237J.default) {
    /**
   * constructor
   * @param props
   * @param props.node
   * @param props.view
   * @param props.getPos
   * @param props.portalProviderAPI
   * @param props.eventDispatcher
   * @param props.pluginInjectionApi
   * @param props.options
   * @param props.intl
   * @example
   */ constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        this.isEmpty = (0, $33S4L.isEmptyLayout)(this.node);
        this.options = props.options;
        this.intl = props.intl;
    }
    /**
   * getContentDOM
   * @example
   * @returns
   */ getContentDOM() {
        // Build the layout DOM via the schema's toDOM spec. This is the same
        // path used in both CSR and SSR — the only SSR-specific concern is
        // re-attaching `contentDOM` (= the `[data-layout-section]` element)
        // after the portal's renderToStaticMarkup + innerHTML write detaches
        // it. We handle that by stamping `data-ssr-content-dom-ref` on the
        // outer container so `ReactNodeView.init()` can find a re-attach
        // target inside `domRef` after the portal write.
        const { dom: container, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, $6bace50bec15a311$var$toDOM(this.node));
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.layoutDOM = container.querySelector('[data-layout-section]');
        this.layoutDOM.setAttribute('data-column-rule-style', this.node.attrs.columnRuleStyle);
        this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        if ((0, $dRkX9.fg)('platform_editor_adf_with_localid')) this.layoutDOM.setAttribute('data-local-id', this.node.attrs.localId);
        // SSR streaming re-attach note:
        // In SSR, `init()` appends `container` into `domRef`; the portal's
        // renderToStaticMarkup + innerHTML write then wipes `domRef`,
        // detaching the entire subtree (with PM-serialized children inside
        // `[data-layout-section]`). React's `render()` emits a
        // `<NodeViewContentHole/>` placeholder inside `domRef`; the SSR
        // re-attach logic in `init()` finds it via `[data-ssr-content-dom-ref]`
        // and calls `_handleRef`, which appends `contentDOMWrapper` (the
        // detached `container`) back inside the placeholder. The end result
        // is `domRef > NodeViewContentHole > layout-section-container >
        // [data-layout-section] > [data-layout-column] children` — the
        // layout DOM contract is preserved.
        return {
            dom: container,
            contentDOM: contentDOM
        };
    }
    /**
   * setDomAttrs
   * @param node
   * @param element
   * @example
   */ setDomAttrs(node, _element) {
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle);
    }
    /**
   * render
   * @param props
   * @param forwardRef
   * @example
   * @returns
   */ render(props, forwardRef) {
        this.isEmpty = (0, $33S4L.isEmptyLayout)(this.node);
        if (this.layoutDOM) this.layoutDOM.setAttribute('data-empty-layout', Boolean(this.isEmpty).toString());
        // SSR streaming path: render only a `<NodeViewContentHole/>` placeholder
        // so ReactNodeView.init()'s SSR re-attach logic can find the marker
        // (`data-ssr-content-dom-ref`) and re-append the detached
        // contentDOMWrapper — which is the FULL layout structure
        // (`layout-section-container > [data-layout-section] > children`) built
        // in `getContentDOM` via DOMSerializer.renderSpec. This avoids
        // duplicating layout structure between getContentDOM and render(), which
        // previously caused an extra wrapping div between `[data-layout-section]`
        // and the `[data-layout-column]` children and broke the flex layout.
        //
        // The BreakoutResizer is intentionally omitted in SSR — it relies on
        // browser-only APIs and contributes no useful static markup. The
        // LayoutSSRReactContextsProvider wraps the placeholder to inject the
        // editor's IntlShape, defending against any descendants that call
        // `useIntl()` during renderToStaticMarkup.
        if ((0, $eVKpX.isSSR)()) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $g4cRP.LayoutSSRReactContextsProvider), {
            intl: this.intl,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $58I5S.NodeViewContentHole), {
                ref: forwardRef
            })
        });
        return null;
    }
    /**
   * ignoreMutation
   * @param mutation
   * @example
   * @returns
   */ ignoreMutation(mutation) {
        return (0, $cmn9q.ignoreResizerMutations)(mutation);
    }
}

});
parcelRegister("cmn9q", function(module, exports) {
$parcel$export(module.exports, "ignoreResizerMutations", () => $f45caaa70000cc63$export$256eed97177e990e);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $3LeME = parcelRequire("3LeME");

var $35HTp = parcelRequire("35HTp");

var $dqFZv = parcelRequire("dqFZv");

var $2Gsu9 = parcelRequire("2Gsu9");

var $ctKot = parcelRequire("ctKot");

var $jULmE = parcelRequire("jULmE");
const $f45caaa70000cc63$var$breakoutSupportedNodes = [
    'layoutSection',
    'expand',
    'codeBlock'
];
const $f45caaa70000cc63$var$getHandleStyle = (node, hidden)=>{
    const layoutMarginOffset = 12;
    if (hidden) return {
        left: {
            display: 'none'
        },
        right: {
            display: 'none'
        }
    };
    switch(node){
        case 'codeBlock':
            return {
                left: {
                    left: '-12px'
                },
                right: {
                    right: '-12px'
                }
            };
        // expand and layout section elements have a negative margin applied
        default:
            const handleOffset = (0, $35HTp.LAYOUT_SECTION_MARGIN) * 2 + layoutMarginOffset;
            return {
                left: {
                    left: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                },
                right: {
                    right: `-${handleOffset}px`,
                    height: 'calc(100% - 8px)',
                    bottom: '0px',
                    top: 'unset'
                }
            };
    }
};
const $f45caaa70000cc63$export$256eed97177e990e = (mutation)=>{
    if (mutation.target instanceof Element) return mutation.target.classList.contains('resizer-item') || mutation.type === 'attributes' && mutation.attributeName === 'style';
    return mutation.type === 'attributes' && mutation.attributeName === 'style';
};
const $f45caaa70000cc63$var$resizingStyles = {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'grid'
};
// Apply grid to stop drag handles rendering inside .resizer-item affecting its height
const $f45caaa70000cc63$var$defaultStyles = {
    display: 'grid'
};
const $f45caaa70000cc63$var$RESIZE_STEP_VALUE = 10;
const $f45caaa70000cc63$var$RESIZER_ENABLE_HANDLES = {
    left: true,
    right: true
};
/**
 * BreakoutResizer is a common component used to resize nodes that support the 'Breakout' mark, so it requires
 * correct ADF support.
 *
 * use experiment platform_editor_advanced_layouts
 * @param root0
 * @param root0.editorView
 * @param root0.nodeType
 * @param root0.getPos
 * @param root0.getRef
 * @param root0.disabled
 * @param root0.getEditorWidth
 * @param root0.parentRef
 * @param root0.displayGuidelines
 * @param root0.editorAnalyticsApi
 * @param root0.displayGapCursor
 * @param root0.onResizeStart
 * @param root0.dynamicFullWidthGuidelineOffset
 * @param root0.hidden Hide the resizer handles without outright unrendering them
 * @returns BreakoutResizer component
 * @example
 */ const $f45caaa70000cc63$export$d6c278682f48fbc4 = ({ editorView: editorView, nodeType: nodeType, getPos: getPos, getRef: getRef, disabled: disabled, getEditorWidth: getEditorWidth, parentRef: parentRef, displayGuidelines: displayGuidelines, editorAnalyticsApi: editorAnalyticsApi, displayGapCursor: displayGapCursor, onResizeStart: onResizeStart, dynamicFullWidthGuidelineOffset: dynamicFullWidthGuidelineOffset, hidden: hidden = false })=>{
    const [{ minWidth: minWidth, maxWidth: maxWidth, isResizing: isResizing }, setResizingState] = (0, $fc4bM.useState)({
        minWidth: undefined,
        maxWidth: undefined,
        isResizing: false
    });
    const areResizeMetaKeysPressed = (0, $fc4bM.useRef)(false);
    const resizerRef = (0, $fc4bM.useRef)(null);
    const { snaps: snaps, currentLayout: currentLayout, guidelines: guidelines, setCurrentWidth: setCurrentWidth } = (0, $jULmE.useBreakoutGuidelines)(getEditorWidth, isResizing && (0, $kaRof.editorExperiment)('single_column_layouts', true), dynamicFullWidthGuidelineOffset);
    const browser = (0, $dqFZv.getBrowserInfo)();
    (0, $fc4bM.useEffect)(()=>{
        if (displayGuidelines) displayGuidelines(guidelines || []);
    }, [
        displayGuidelines,
        guidelines
    ]);
    // Relying on re-renders caused by selection changes inside/around node
    const isSelectionInNode = (0, $fc4bM.useMemo)(()=>{
        const pos = getPos();
        if (pos === undefined) return false;
        const node = editorView.state.doc.nodeAt(pos);
        if (node === null) return false;
        const endPos = pos + node.nodeSize;
        const startPos = pos;
        const { $from: $from, $to: $to } = editorView.state.selection;
        return $from.pos >= startPos && endPos >= $to.pos;
    }, [
        editorView.state.doc,
        editorView.state.selection,
        getPos
    ]);
    const handleResizeStart = (0, $fc4bM.useCallback)(()=>{
        onResizeStart === null || onResizeStart === void 0 || onResizeStart();
        let newMinWidth;
        let newMaxWidth;
        const widthState = getEditorWidth();
        const { dispatch: dispatch, state: state } = editorView;
        displayGapCursor(false);
        if (widthState !== undefined && widthState.lineLength !== undefined && widthState.width !== undefined) {
            const padding = widthState.width <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
            newMaxWidth = Math.min(widthState.width - padding * 2 - (0, $014x6.akEditorGutterPadding), (0, $014x6.akEditorFullWidthLayoutWidth));
            newMinWidth = Math.min(widthState.lineLength, (0, $014x6.akEditorDefaultLayoutWidth), newMaxWidth);
        }
        setResizingState({
            isResizing: true,
            minWidth: newMinWidth,
            maxWidth: newMaxWidth
        });
        dispatch(state.tr.setMeta('is-resizer-resizing', true));
    }, [
        onResizeStart,
        getEditorWidth,
        editorView,
        displayGapCursor
    ]);
    const handleResize = (0, $fc4bM.useCallback)((originalState, delta)=>{
        if ((0, $kaRof.editorExperiment)('single_column_layouts', true)) {
            const newWidth = originalState.width + delta.width;
            setCurrentWidth(newWidth);
        }
    }, [
        setCurrentWidth
    ]);
    const handleResizeStop = (0, $fc4bM.useCallback)((originalState, delta)=>{
        const newWidth = originalState.width + delta.width;
        const pos = getPos();
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        const { breakout: breakout } = state.schema.marks;
        const node = state.doc.nodeAt(pos);
        const newTr = state.tr;
        if (node && $f45caaa70000cc63$var$breakoutSupportedNodes.includes(node.type.name)) {
            if (currentLayout && [
                'wide',
                'full-width'
            ].includes(currentLayout) && (0, $kaRof.editorExperiment)('single_column_layouts', true)) newTr.setNodeMarkup(pos, node.type, node.attrs, [
                breakout.create({
                    mode: currentLayout,
                    width: null
                })
            ]);
            else {
                const newBreakoutWidth = Math.max(newWidth, (0, $014x6.akEditorDefaultLayoutWidth));
                newTr.setNodeMarkup(pos, node.type, node.attrs, [
                    breakout.create({
                        width: newBreakoutWidth
                    })
                ]);
                const breakoutResizePayload = {
                    action: (0, $3LeME.ACTION).RESIZED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).ELEMENT,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeType: node.type.name,
                        prevWidth: originalState.width,
                        newWidth: newBreakoutWidth
                    }
                };
                editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent(breakoutResizePayload)(newTr);
            }
        }
        newTr.setMeta('is-resizer-resizing', false).setMeta('scrollIntoView', false);
        displayGapCursor(true);
        dispatch(newTr);
        setResizingState({
            isResizing: false,
            minWidth: undefined,
            maxWidth: undefined
        });
        setCurrentWidth(null);
    }, [
        getPos,
        editorView,
        displayGapCursor,
        setCurrentWidth,
        currentLayout,
        editorAnalyticsApi
    ]);
    const handleEscape = (0, $fc4bM.useCallback)(()=>{
        editorView === null || editorView === void 0 || editorView.focus();
    }, [
        editorView
    ]);
    const handleLayoutSizeChangeOnKeypress = (0, $fc4bM.useCallback)((step)=>{
        if (!parentRef) return;
        const resizerItem = parentRef.closest('.resizer-item');
        if (!(resizerItem instanceof HTMLElement)) return;
        const newWidth = resizerItem.offsetWidth + step;
        if (maxWidth && newWidth > maxWidth || minWidth && newWidth < minWidth) return;
        handleResizeStop({
            width: resizerItem.offsetWidth,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        handleResizeStop,
        maxWidth,
        minWidth,
        parentRef
    ]);
    const resizeHandleKeyDownHandler = (0, $fc4bM.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleLayoutSizeChangeOnKeypress(event.code === 'BracketRight' ? $f45caaa70000cc63$var$RESIZE_STEP_VALUE : -$f45caaa70000cc63$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleLayoutSizeChangeOnKeypress,
        browser
    ]);
    const resizeHandleKeyUpHandler = (0, $fc4bM.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    const resizerGlobalKeyDownHandler = (0, $fc4bM.useCallback)((event)=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        const isTargetResizeHandle = event.target instanceof HTMLElement && event.target.classList.contains('resizer-handle-thumb');
        if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR' || isTargetResizeHandle && (event.altKey || metaKey || event.shiftKey)) {
            event.preventDefault();
            if (!resizeHandleThumbEl) return;
            resizeHandleThumbEl.focus();
            resizeHandleThumbEl.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'nearest'
            });
        }
    }, [
        resizerRef,
        browser
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (!resizerRef.current || !editorView) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        if (!resizeHandleThumbEl) return;
        const editorViewDom = editorView.dom;
        const unbindEditorViewDom = (0, $6Zi52.bind)(editorViewDom, {
            type: 'keydown',
            listener: resizerGlobalKeyDownHandler
        });
        const unbindResizeHandle = (0, $6Zi52.bindAll)(resizeHandleThumbEl, [
            {
                type: 'keydown',
                listener: resizeHandleKeyDownHandler
            },
            {
                type: 'keyup',
                listener: resizeHandleKeyUpHandler
            }
        ]);
        return ()=>{
            unbindEditorViewDom();
            unbindResizeHandle();
        };
    }, [
        editorView,
        resizerGlobalKeyDownHandler,
        resizeHandleKeyDownHandler,
        resizeHandleKeyUpHandler
    ]);
    if (disabled) return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": "breakout-resizer-editor-view-wrapper",
        ref: (ref)=>getRef && getRef(ref)
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Gsu9.default), {
        ref: resizerRef,
        enable: (0, $bcN2K.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $f45caaa70000cc63$var$RESIZER_ENABLE_HANDLES : {
            left: true,
            right: true
        },
        snap: snaps || undefined,
        snapGap: (0, $jULmE.SNAP_GAP),
        handleStyles: $f45caaa70000cc63$var$getHandleStyle(nodeType, hidden),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: isResizing ? $f45caaa70000cc63$var$resizingStyles : $f45caaa70000cc63$var$defaultStyles,
        handleResizeStart: handleResizeStart,
        handleResizeStop: handleResizeStop,
        handleResize: handleResize,
        childrenDOMRef: getRef,
        resizeRatio: 2,
        isHandleVisible: isSelectionInNode,
        handleSize: "clamped",
        handleHighlight: "full-height",
        handlePositioning: "adjacent",
        handleAlignmentMethod: "sticky",
        labelComponent: currentLayout && (0, $kaRof.editorExperiment)('single_column_layouts', true) && [
            'full-width',
            'wide'
        ].includes(currentLayout || '') && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ctKot.ResizerBreakoutModeLabel), {
            layout: currentLayout
        })
    });
};

});
parcelRegister("jULmE", function(module, exports) {
$parcel$export(module.exports, "SNAP_GAP", () => $d488b7dd07dd0460$export$6cdb476c834bc60);
$parcel$export(module.exports, "useBreakoutGuidelines", () => $d488b7dd07dd0460$export$54a1e15ba45852e2);

var $fc4bM = parcelRequire("fc4bM");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");
const $d488b7dd07dd0460$export$6cdb476c834bc60 = 8;
const $d488b7dd07dd0460$var$GUIDELINE_KEYS = {
    lineLength: 'grid',
    wide: 'wide',
    fullWidth: 'full_width'
};
const $d488b7dd07dd0460$var$CURRENT_LAYOUT_KEYS = {
    lineLength: 'center',
    wide: 'wide',
    fullWidth: 'full-width'
};
const $d488b7dd07dd0460$var$roundToNearest = (value, interval = 0.5)=>Math.round(value / interval) * interval;
function $d488b7dd07dd0460$export$54a1e15ba45852e2(getEditorWidth, isResizing, dynamicFullWidthGuidelineOffset = 0) {
    const widthState = getEditorWidth();
    const { lineLength: lineLength, wide: wide, fullWidth: fullWidth } = (0, $fc4bM.useMemo)(()=>{
        if (!isResizing) return {};
        const { width: width, lineLength: lineLength } = widthState || {};
        const wideCalWithRatio = lineLength ? Math.round(lineLength * (0, $014x6.breakoutWideScaleRatio)) : undefined;
        // When page is full width, lineLength from widthState can be much wider than 760.
        // But the lineLength variable here is being used like a const 760.
        // when the page is full width, the calculation of wide is wrong.
        // Actuall the wide is the wide breakout point, which is
        const wide = (0, $kaRof.editorExperiment)('single_column_layouts', true) ? (0, $014x6.akEditorCalculatedWideLayoutWidth) : wideCalWithRatio;
        const padding = width && width <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
        const layoutCalculatedWidth = width ? width - (padding + dynamicFullWidthGuidelineOffset) * 2 : undefined;
        const fullWidth = width && layoutCalculatedWidth ? Math.min(layoutCalculatedWidth, (0, $014x6.akEditorFullWidthLayoutWidth)) : undefined;
        return {
            wide: wide,
            fullWidth: fullWidth,
            // When page is full width, lineLength from widthState can be much wider than 760.
            // But the lineLength variable here is being used like a const 760.
            lineLength: (0, $kaRof.editorExperiment)('single_column_layouts', true) ? (0, $014x6.akEditorDefaultLayoutWidth) : lineLength
        };
    }, [
        widthState,
        isResizing,
        dynamicFullWidthGuidelineOffset
    ]);
    // calculate snapping width
    const defaultSnappingWidths = (0, $fc4bM.useMemo)(()=>{
        if (!fullWidth || !wide || !lineLength || fullWidth <= ((0, $kaRof.editorExperiment)('single_column_layouts', true) ? (0, $014x6.akEditorDefaultLayoutWidth) : lineLength)) return null;
        if (fullWidth - wide > $d488b7dd07dd0460$export$6cdb476c834bc60) return {
            lineLength: lineLength,
            wide: wide,
            fullWidth: fullWidth
        };
        if (fullWidth <= wide && fullWidth - lineLength > $d488b7dd07dd0460$export$6cdb476c834bc60) return {
            lineLength: lineLength,
            fullWidth: fullWidth
        };
        return null;
    }, [
        fullWidth,
        lineLength,
        wide
    ]);
    const snaps = (0, $fc4bM.useMemo)(()=>{
        if (!isResizing || !defaultSnappingWidths) return null;
        return {
            x: Object.values(defaultSnappingWidths)
        };
    }, [
        defaultSnappingWidths,
        isResizing
    ]);
    // calculate guidelines, and calculate which lines are active
    const [currentLayout, setCurrentLayout] = (0, $fc4bM.useState)(null);
    const guidelines = (0, $fc4bM.useMemo)(()=>{
        const guidelines = [];
        if (!defaultSnappingWidths) return guidelines;
        Object.entries(defaultSnappingWidths).map(([key, value])=>{
            if (value) {
                guidelines.push({
                    key: `${$d488b7dd07dd0460$var$GUIDELINE_KEYS[key]}_left`,
                    position: {
                        x: -$d488b7dd07dd0460$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $d488b7dd07dd0460$var$CURRENT_LAYOUT_KEYS[key]
                });
                guidelines.push({
                    key: `${$d488b7dd07dd0460$var$GUIDELINE_KEYS[key]}_right`,
                    position: {
                        x: $d488b7dd07dd0460$var$roundToNearest(value / 2)
                    },
                    active: currentLayout === $d488b7dd07dd0460$var$CURRENT_LAYOUT_KEYS[key]
                });
            }
        });
        return guidelines;
    }, [
        defaultSnappingWidths,
        currentLayout
    ]);
    const setCurrentWidth = (0, $fc4bM.useCallback)((newWidth)=>{
        if (typeof newWidth !== 'number') {
            setCurrentLayout(null);
            return;
        }
        if (lineLength && Math.abs(newWidth - lineLength) < $d488b7dd07dd0460$export$6cdb476c834bc60 / 2) setCurrentLayout('center');
        else if (wide && Math.abs(newWidth - wide) < $d488b7dd07dd0460$export$6cdb476c834bc60 / 2) setCurrentLayout('wide');
        else if (fullWidth && // we only allow snap from one side, so we don't use Math.abs here
        (fullWidth + (0, $014x6.akEditorGutterPadding) - newWidth < $d488b7dd07dd0460$export$6cdb476c834bc60 / 2 || newWidth >= fullWidth)) setCurrentLayout('full-width');
        else setCurrentLayout(null);
    }, [
        lineLength,
        wide,
        fullWidth
    ]);
    return {
        snaps: snaps,
        currentLayout: currentLayout,
        guidelines: guidelines,
        setCurrentWidth: setCurrentWidth
    };
}

});


parcelRegister("g4cRP", function(module, exports) {
$parcel$export(module.exports, "LayoutSSRReactContextsProvider", () => $75656149d2122e18$export$f101bb1d69aeca23);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $eVKpX = parcelRequire("eVKpX");
function $75656149d2122e18$export$f101bb1d69aeca23({ children: children, intl: intl }) {
    if (!(0, $eVKpX.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fcCIH.Provider), {
        value: intl,
        children: children
    });
}

});

parcelRegister("33S4L", function(module, exports) {
$parcel$export(module.exports, "isEmptyLayout", () => $cdd3970f306901b7$export$9c5c526818396ae1);

var $39oqF = parcelRequire("39oqF");
const $cdd3970f306901b7$export$9c5c526818396ae1 = (node)=>{
    if (!node) return false;
    // fast check
    // each column should have size 2 from layoutcolumn and 2 from empty paragraph
    if (node.content.size / node.childCount !== 4) return false;
    let isEmpty = true;
    node.content.forEach((maybelayoutColumn)=>{
        if (maybelayoutColumn.type.name !== 'layoutColumn' || maybelayoutColumn.childCount > 1 || !(0, $39oqF.isEmptyParagraph)(maybelayoutColumn.firstChild)) isEmpty = false;
    });
    return isEmpty;
};

});


parcelRegister("i0ISB", function(module, exports) {
$parcel$export(module.exports, "LayoutSectionView", () => $95903e405f3c48ad$export$8bfc7bdc15be731c);

var $cmn9q = parcelRequire("cmn9q");

var $7H6Cr = parcelRequire("7H6Cr");

var $dRkX9 = parcelRequire("dRkX9");

var $33S4L = parcelRequire("33S4L");
const $95903e405f3c48ad$var$toDOM = (node, isEmpty)=>[
        'div',
        {
            class: 'layoutSectionView-content-wrap'
        },
        [
            'div',
            {
                class: 'layout-section-container'
            },
            [
                'div',
                {
                    'data-layout-section': true,
                    // `?? ''` keeps unset attributes out of the DOM as `"null"`, which adf-schema's`parseDOM`
                    // reads back as a truthy string.
                    'data-column-rule-style': node.attrs.columnRuleStyle ?? '',
                    'data-empty-layout': String(isEmpty),
                    ...(0, $dRkX9.fg)('platform_editor_adf_with_localid') && {
                        'data-local-id': node.attrs.localId ?? ''
                    }
                },
                0
            ]
        ]
    ];
class $95903e405f3c48ad$export$8bfc7bdc15be731c {
    constructor(node){
        const isEmpty = (0, $33S4L.isEmptyLayout)(node);
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, $95903e405f3c48ad$var$toDOM(node, isEmpty));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.node = node;
        this.isEmpty = isEmpty;
    }
    update(node) {
        if (node.attrs.columnRuleStyle !== this.node.attrs.columnRuleStyle) this.contentDOM.setAttribute('data-column-rule-style', node.attrs.columnRuleStyle ?? '');
        // Cache isEmpty so update() does not call isEmptyLayout on the previous node.
        const isEmpty = (0, $33S4L.isEmptyLayout)(node);
        if (isEmpty !== this.isEmpty) {
            this.contentDOM.setAttribute('data-empty-layout', String(isEmpty));
            this.isEmpty = isEmpty;
        }
        if ((0, $dRkX9.fg)('platform_editor_adf_with_localid') && node.attrs.localId !== this.node.attrs.localId) this.contentDOM.setAttribute('data-local-id', node.attrs.localId ?? '');
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        return (0, $cmn9q.ignoreResizerMutations)(mutation);
    }
}

});


parcelRegister("cDiab", function(module, exports) {
$parcel$export(module.exports, "getMaybeLayoutSection", () => $f0edf049dfdbf2e5$export$9adba9ade368b431);
$parcel$export(module.exports, "getGapCursorTargetForBlankSpaceClick", () => $f0edf049dfdbf2e5$export$a03ac666480b47d9);
$parcel$export(module.exports, "isParagraphBlankSpaceTarget", () => $f0edf049dfdbf2e5$export$8c1438c11cd047f3);

var $ihNBw = parcelRequire("ihNBw");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $kaRof = parcelRequire("kaRof");
const $f0edf049dfdbf2e5$export$9adba9ade368b431 = (state)=>{
    const { schema: { nodes: { layoutSection: layoutSection, layoutColumn: layoutColumn } }, selection: selection } = state;
    const isLayoutColumn = (0, $kaRof.editorExperiment)('advanced_layouts', true) && (0, $a4TQr.findSelectedNodeOfType)([
        layoutColumn
    ])(selection);
    // When selection is on layoutColumn, we want to hide floating toolbar, hence don't return layoutSection node here
    return isLayoutColumn ? undefined : (0, $a4TQr.findParentNodeOfType)(layoutSection)(selection) || (0, $a4TQr.findSelectedNodeOfType)([
        layoutSection
    ])(selection);
};
/**
 * The depth of the layout column inside the layout section.
 * As per the current implementation, the layout column ALWAYS has a depth of 1.
 */ const $f0edf049dfdbf2e5$var$LAYOUT_COLUMN_DEPTH = 1;
const $f0edf049dfdbf2e5$export$c13dbc07830c6c42 = (view, posOfLayout, childIndex = 0)=>{
    var _$maybeLayoutSection$;
    const $maybeLayoutSection = view.state.doc.resolve(posOfLayout);
    if (((_$maybeLayoutSection$ = $maybeLayoutSection.nodeAfter) === null || _$maybeLayoutSection$ === void 0 ? void 0 : _$maybeLayoutSection$.type.name) === 'layoutSection') {
        var _layoutSectionNode$fi;
        const layoutSectionNode = $maybeLayoutSection.nodeAfter;
        // check if the childIndex is valid
        if (childIndex < 0 || childIndex >= layoutSectionNode.childCount) return;
        const childPos = $maybeLayoutSection.posAtIndex(childIndex, $f0edf049dfdbf2e5$var$LAYOUT_COLUMN_DEPTH);
        const tr = view.state.tr;
        const $selectionPos = tr.doc.resolve(childPos);
        if (((_layoutSectionNode$fi = layoutSectionNode.firstChild) === null || _layoutSectionNode$fi === void 0 ? void 0 : _layoutSectionNode$fi.type.name) === 'paragraph') view.dispatch(tr.setSelection((0, $801jp.TextSelection).near($selectionPos)));
        else view.dispatch(tr.setSelection((0, $ihNBw.GapCursorSelection).near($selectionPos)));
        return tr;
    }
};
/**
 * These node views can fill a layout column while leaving visually blank space that ProseMirror
 * cannot map to a document position. Interactive atomic nodes must receive clicks normally.
 */ const $f0edf049dfdbf2e5$var$supportsBlankSpaceGapCursorFallback = (node)=>(node === null || node === void 0 ? void 0 : node.type.name) === 'mediaSingle' || (node === null || node === void 0 ? void 0 : node.type.name) === 'expand';
const $f0edf049dfdbf2e5$export$a03ac666480b47d9 = (view, event)=>{
    var _columnNode$attrs;
    // Resolve the column from the DOM target so it works even when posAtCoords returns null
    // (nothing rendered at the clicked Y).
    const target = event.target;
    const columnEl = target === null || target === void 0 ? void 0 : target.closest('[data-layout-column]');
    if (!columnEl) return undefined;
    let columnStartPos;
    try {
        columnStartPos = view.posAtDOM(columnEl, 0);
    } catch  {
        return undefined;
    }
    // posAtDOM resolves at varying depths, so walk up to find the layoutColumn.
    const $columnStart = view.state.doc.resolve(columnStartPos);
    let depth = -1;
    for(let d = $columnStart.depth; d >= 0; d--)if ($columnStart.node(d).type.name === 'layoutColumn') {
        depth = d;
        break;
    }
    if (depth < 0) return undefined;
    const columnNode = $columnStart.node(depth);
    if (columnNode.childCount === 0) return undefined;
    const columnContentStart = $columnStart.start(depth);
    const columnEndPos = $columnStart.end(depth);
    const getChildDom = (nodePos)=>{
        try {
            const dom = view.nodeDOM(nodePos);
            return dom instanceof Element ? dom : null;
        } catch  {
            return null;
        }
    };
    const valign = (_columnNode$attrs = columnNode.attrs) === null || _columnNode$attrs === void 0 ? void 0 : _columnNode$attrs.valign;
    const isNonTopAligned = valign && valign !== 'top';
    // Use the column rect (not child rects) for above/below detection: it stays stable as
    // gap-cursor widgets shift child DOM positions between repeated clicks.
    const columnRect = columnEl.getBoundingClientRect();
    // Click ABOVE the first child (only for middle/bottom-aligned columns).
    const firstChildPos = columnContentStart;
    const firstChildDom = getChildDom(firstChildPos);
    if (isNonTopAligned && firstChildDom) {
        const rect = firstChildDom.getBoundingClientRect();
        if (event.clientY < rect.top && event.clientY >= columnRect.top) return {
            pos: firstChildPos,
            side: 'left'
        };
    }
    // Click BELOW the last child (for any column alignment).
    const lastChild = columnNode.lastChild;
    const lastChildEndPos = columnEndPos;
    const lastChildStartPos = lastChild ? lastChildEndPos - lastChild.nodeSize : columnContentStart;
    const lastChildDom = lastChild ? getChildDom(lastChildStartPos) : null;
    if (lastChild && lastChildDom) {
        const rect = lastChildDom.getBoundingClientRect();
        if (event.clientY > rect.bottom && event.clientY <= columnRect.bottom) return {
            pos: lastChildEndPos,
            side: 'right'
        };
    }
    // Fallback: click lands ON a single atomic child that fills the column (mediaSingle/expand),
    // so the above/below checks never fired.
    if (columnNode.childCount === 1) {
        const onlyChild = columnNode.firstChild;
        const shouldHandleAtomicChild = $f0edf049dfdbf2e5$var$supportsBlankSpaceGapCursorFallback(onlyChild);
        if (onlyChild && shouldHandleAtomicChild) {
            // A caption is editable content inside a mediaSingle, not blank layout space. The
            // image bounds below intentionally exclude the caption so clicks beside the image
            // can place a gap cursor; bail out before that check when the click is on a caption.
            const target = event.target;
            if (target !== null && target !== void 0 && target.closest('[data-caption]')) return undefined;
            // Bail when the click is on the child's own content. For media the wrapper is full-width
            // so test against the <img> rect; resolve it only for a direct mediaSingle child (else
            // getContentRect could grab an image nested in an expand and break its toggle).
            const contentRect = onlyChild.type.name === 'mediaSingle' ? $f0edf049dfdbf2e5$var$getContentRect(firstChildDom) : null;
            if (contentRect) {
                const insideImage = event.clientX >= contentRect.left && event.clientX <= contentRect.right && event.clientY >= contentRect.top && event.clientY <= contentRect.bottom;
                if (insideImage) return undefined;
            } else {
                // Other atomics: bail when posAtCoords resolves strictly inside the node range.
                let coordPos = null;
                try {
                    coordPos = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                } catch  {
                    coordPos = null;
                }
                if (coordPos && coordPos.pos > firstChildPos && coordPos.pos < lastChildEndPos) return undefined;
            }
            // Fire when the child DOM is resolvable, or when it's null (media not yet loaded) but
            // the click target is the column itself (no node view intercepted it).
            const targetEl = event.target;
            const targetIsColumn = targetEl === columnEl;
            const shouldUseFallback = firstChildDom !== null || targetIsColumn;
            if (shouldUseFallback) {
                const side = $f0edf049dfdbf2e5$var$getGapCursorSideForBlankSpaceClick(firstChildDom, columnRect, event.clientX, event.clientY);
                return side === 'left' ? {
                    pos: firstChildPos,
                    side: 'left'
                } : {
                    pos: lastChildEndPos,
                    side: 'right'
                };
            }
        }
    }
    return undefined;
};
/**
 * The tight `<img>` content rect (or `null`). The outer wrapper often fills the whole column
 * width, so the `<img>` rect is needed to tell "beside the image" from "on the image".
 */ const $f0edf049dfdbf2e5$var$getContentRect = (firstChildDom)=>{
    const img = firstChildDom === null || firstChildDom === void 0 ? void 0 : firstChildDom.querySelector('img');
    return img ? img.getBoundingClientRect() : null;
};
/**
 * Which side of an atomic child a blank-space click belongs to. Prefers the tight content (image)
 * rect when available — using its midpoint so it's direction-agnostic (handles RTL right-aligned
 * images) — otherwise falls back to the column's vertical midpoint.
 */ const $f0edf049dfdbf2e5$var$getGapCursorSideForBlankSpaceClick = (firstChildDom, columnRect, clientX, clientY)=>{
    const contentRect = $f0edf049dfdbf2e5$var$getContentRect(firstChildDom);
    if (contentRect) {
        if (clientY < contentRect.top) return 'left';
        if (clientY > contentRect.bottom) return 'right';
        if (clientX < (contentRect.left + contentRect.right) / 2) return 'left';
        return 'right';
    }
    const columnMidY = columnRect.top + columnRect.height / 2;
    return clientY < columnMidY ? 'left' : 'right';
};
const $f0edf049dfdbf2e5$export$8c1438c11cd047f3 = (view, gapTarget)=>{
    const { pos: pos, side: side } = gapTarget;
    const { doc: doc } = view.state;
    try {
        const $pos = doc.resolve(pos);
        const childNode = side === 'left' ? $pos.nodeAfter : $pos.nodeBefore;
        return (childNode === null || childNode === void 0 ? void 0 : childNode.type.name) === 'paragraph';
    } catch  {
        return false;
    }
};

});


parcelRegister("3PyFo", function(module, exports) {
$parcel$export(module.exports, "GlobalStylesWrapper", () => $5feaa15fc3c49a8d$export$cc5403d58ddfa812);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $gpjDl = parcelRequire("gpjDl");

var $csQ9c = parcelRequire("csQ9c");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");
const $5feaa15fc3c49a8d$var$PLACEHOLDER_SELECTOR = '.ProseMirror-focused .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)';
const $5feaa15fc3c49a8d$var$PLACEHOLDER_SELECTOR_NEXT = '.ProseMirror-focused .pm-layout-column-empty';
const $5feaa15fc3c49a8d$var$layoutColumnDangerPreviewStyle = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '.ProseMirror [data-layout-column].layout-column-danger-preview': {
        backgroundColor: "var(--ds-blanket-danger, #EF5C4814)",
        boxShadow: `inset 0 0 0 1px ${"var(--ds-border-danger, #E2483D)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::before': {
            visibility: 'hidden'
        }
    }
});
const $5feaa15fc3c49a8d$var$getPlaceholderStyle = (message)=>{
    if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) {
        const placeholderSelector = (0, $bcN2K.isExperimentEnabled)('platform_editor_improve_inp_batch_2') ? $5feaa15fc3c49a8d$var$PLACEHOLDER_SELECTOR_NEXT : $5feaa15fc3c49a8d$var$PLACEHOLDER_SELECTOR;
        return /*#__PURE__*/ (0, $jctmk.css)({
            // when paragraph is the only child, and it only has a trailingBreak.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [placeholderSelector]: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                '&::before': {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                    content: `"${message}"`,
                    position: 'absolute',
                    color: "var(--ds-text-subtlest, #6B6E76)",
                    pointerEvents: 'none'
                }
            }
        });
    }
    return /*#__PURE__*/ (0, $jctmk.css)({
        // when paragraph is the only child, and it only has a trailingBreak.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '.ProseMirror .layoutSectionView-content-wrap.selected [data-layout-column] > [data-layout-content] > p:only-child:has(.ProseMirror-trailingBreak:only-child)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
                content: `"${message}"`,
                position: 'absolute',
                color: "var(--ds-text-disabled, #080F214A)",
                font: "var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                marginTop: "var(--ds-space-050, 4px)",
                pointerEvents: 'none'
            }
        }
    });
};
const $5feaa15fc3c49a8d$export$cc5403d58ddfa812 = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const placeholderStyle = (0, $fc4bM.useMemo)(()=>{
        const placeholderText = (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $csQ9c.toolbarMessages).controlslayoutPlaceholder : (0, $csQ9c.toolbarMessages).layoutPlaceholder;
        return $5feaa15fc3c49a8d$var$getPlaceholderStyle(formatMessage(placeholderText));
    }, [
        formatMessage
    ]);
    const globalStyles = (0, $fc4bM.useMemo)(()=>[
            placeholderStyle,
            $5feaa15fc3c49a8d$var$layoutColumnDangerPreviewStyle
        ], [
        placeholderStyle
    ]);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $jctmk.Global), {
        styles: globalStyles
    });
};

});

parcelRegister("4qNQh", function(module, exports) {
$parcel$export(module.exports, "createLayoutBlockMenuItem", () => $19a0fecdcce988f2$export$83047c2fe2258f8);
/* LayoutBlockMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $j8Vl1 = parcelRequire("j8Vl1");

var $7otWv = parcelRequire("7otWv");

var $f4Ysc = parcelRequire("f4Ysc");
const $19a0fecdcce988f2$var$styles = {
    svgOverflow: "_1wrmewfl _172sewfl"
};
const $19a0fecdcce988f2$var$NODE_NAME = 'layoutSection';
const $19a0fecdcce988f2$var$LayoutBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $3LeME.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.layoutSection, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $19a0fecdcce988f2$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
            className: (0, $2R2iS.default)([
                $19a0fecdcce988f2$var$styles.svgOverflow
            ]),
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4Ysc))), {
                label: "",
                size: "small"
            })
        }),
        children: formatMessage((0, $j8Vl1.messages).layout)
    });
};
const $19a0fecdcce988f2$export$83047c2fe2258f8 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $3LM7S.jsx)($19a0fecdcce988f2$var$LayoutBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("8bJhK", function(module, exports) {
$parcel$export(module.exports, "LayoutColumnMenu", () => $0f8396a7d535500f$export$7050b81bb37a7c70);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $lKQmU = parcelRequire("lKQmU");

var $dXHAJ = parcelRequire("dXHAJ");

var $gCPs3 = parcelRequire("gCPs3");

var $3kq7i = parcelRequire("3kq7i");

var $4mSGa = parcelRequire("4mSGa");

var $8F4kC = parcelRequire("8F4kC");

var $6ySyj = parcelRequire("6ySyj");

var $9oAqi = parcelRequire("9oAqi");

var $014x6 = parcelRequire("014x6");

var $pFkjB = parcelRequire("pFkjB");

var $kXdsr = parcelRequire("kXdsr");

var $bcN2K = parcelRequire("bcN2K");

var $cv1v0 = parcelRequire("cv1v0");

var $fxGwF = parcelRequire("fxGwF");

var $lkQZZ = parcelRequire("lkQZZ");
const $0f8396a7d535500f$var$PopupWithListeners = (0, $8F4kC.default)((0, $dXHAJ.default));
const $0f8396a7d535500f$var$TOOLBAR_MENU_SELECTOR = '[data-toolbar-component="menu"]';
const $0f8396a7d535500f$var$NESTED_DROPDOWN_MENU_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
const $0f8396a7d535500f$var$LAYOUT_COLUMN_MENU_POPUP_OFFSET_BELOW = [
    0,
    2
];
/**
 * Returns the drag handle button for the selected layout column.
 */ const $0f8396a7d535500f$var$getLayoutColumnMenuTarget = (editorView, selection, anchorPosFromHandle)=>{
    var _columnDomRef$parentE;
    const anchorPos = selection && (0, $cv1v0.getLayoutColumnMenuAnchorPos)(selection, anchorPosFromHandle);
    if (anchorPos === undefined) return null;
    const columnDomRef = editorView.nodeDOM(anchorPos);
    if (!(columnDomRef instanceof HTMLElement)) return null;
    const dragHandleContainer = (_columnDomRef$parentE = columnDomRef.parentElement) === null || _columnDomRef$parentE === void 0 ? void 0 : _columnDomRef$parentE.querySelector(':scope > [data-blocks-drag-handle-container]');
    return dragHandleContainer === null || dragHandleContainer === void 0 ? void 0 : dragHandleContainer.querySelector((0, $gCPs3.DRAG_HANDLE_SELECTOR));
};
const $0f8396a7d535500f$var$focusTrap = {
    initialFocus: undefined
};
const $0f8396a7d535500f$export$7050b81bb37a7c70 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(function LayoutColumnMenu({ api: api, editorView: editorView, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement }) {
    var _api$uiControlRegistr;
    const { isLayoutColumnMenuOpen: isLayoutColumnMenuOpen, layoutColumnMenuAnchorPos: layoutColumnMenuAnchorPos, openedViaKeyboard: openedViaKeyboard, selection: selection } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'layout',
        'selection'
    ], (states)=>{
        var _states$layoutState, _states$layoutState2, _states$layoutState3, _states$selectionStat;
        return {
            isLayoutColumnMenuOpen: ((_states$layoutState = states.layoutState) === null || _states$layoutState === void 0 ? void 0 : _states$layoutState.isLayoutColumnMenuOpen) ?? false,
            layoutColumnMenuAnchorPos: (_states$layoutState2 = states.layoutState) === null || _states$layoutState2 === void 0 ? void 0 : _states$layoutState2.layoutColumnMenuAnchorPos,
            openedViaKeyboard: ((_states$layoutState3 = states.layoutState) === null || _states$layoutState3 === void 0 ? void 0 : _states$layoutState3.layoutColumnMenuOpenedViaKeyboard) ?? false,
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
        };
    });
    const closeLayoutColumnMenu = (0, $fc4bM.useCallback)(()=>{
        var _api$core, _api$layout;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 ? void 0 : _api$layout.commands.toggleLayoutColumnMenu({
            isOpen: false
        }));
    }, [
        api
    ]);
    const handleClickOutside = (0, $fc4bM.useCallback)((event)=>{
        if (event.target instanceof Element && (event.target.closest($0f8396a7d535500f$var$TOOLBAR_MENU_SELECTOR) || event.target.closest($0f8396a7d535500f$var$NESTED_DROPDOWN_MENU_SELECTOR))) return;
        // Clicking a drag handle should let the drag handle's own click handler
        // update selection/menu state. Treating it as a generic outside click
        // races that transaction and can immediately close the layout column menu.
        if (event.target instanceof Element && event.target.closest((0, $gCPs3.DRAG_HANDLE_SELECTOR))) return;
        closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const handleSetIsOpen = (0, $fc4bM.useCallback)((isOpen)=>{
        if (!isOpen) closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const handleArrowKeyNavigationClose = (0, $fc4bM.useCallback)((event)=>{
        event.preventDefault();
        closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu
    ]);
    const shouldDisableArrowKeyNavigation = (0, $fc4bM.useCallback)((event)=>{
        if (event.key !== 'ArrowUp' && event.key !== 'ArrowDown') return false;
        const target = event.target;
        if (!(target instanceof HTMLElement)) return false;
        return target.closest($0f8396a7d535500f$var$NESTED_DROPDOWN_MENU_SELECTOR) !== null;
    }, []);
    const menuWrapperRef = (0, $fc4bM.useRef)(null);
    const handleMenuKeyDown = (0, $fc4bM.useCallback)((event)=>{
        // Keep menu keyboard events scoped to the menu while preserving Escape and
        // ArrowUp/ArrowDown handling from Popup and ArrowKeyNavigationProvider.
        if (event.key !== 'Escape' && event.key !== 'ArrowUp' && event.key !== 'ArrowDown') event.stopPropagation();
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        const menuWrapper = menuWrapperRef.current;
        if (!isLayoutColumnMenuOpen || !menuWrapper) return;
        return (0, $6Zi52.bind)(menuWrapper, {
            type: 'keydown',
            listener: handleMenuKeyDown
        });
    }, [
        handleMenuKeyDown,
        isLayoutColumnMenuOpen
    ]);
    const components = (api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $lkQZZ.LAYOUT_COLUMN_MENU).key)) ?? [];
    const hasValidMenuSelection = !(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') || selection !== undefined && (0, $cv1v0.getLayoutColumnMenuAnchorPos)(selection, layoutColumnMenuAnchorPos) !== undefined;
    const legacyTarget = (0, $fc4bM.useMemo)(()=>isLayoutColumnMenuOpen && !(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? $0f8396a7d535500f$var$getLayoutColumnMenuTarget(editorView, selection, layoutColumnMenuAnchorPos) : null, [
        editorView,
        isLayoutColumnMenuOpen,
        layoutColumnMenuAnchorPos,
        selection
    ]);
    const surfaceTargetRef = (0, $fc4bM.useRef)(null);
    const surfaceAnchorPosRef = (0, $fc4bM.useRef)(undefined);
    if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') || !isLayoutColumnMenuOpen) {
        surfaceTargetRef.current = null;
        surfaceAnchorPosRef.current = undefined;
    } else if (!surfaceTargetRef.current || surfaceAnchorPosRef.current !== layoutColumnMenuAnchorPos) {
        surfaceTargetRef.current = (0, $lKQmU.surfaceDragHandleElementStore).get(editorView) ?? surfaceTargetRef.current;
        surfaceAnchorPosRef.current = layoutColumnMenuAnchorPos;
    }
    const target = (0, $bcN2K.isExperimentEnabled)('platform_editor_block_control_migration') ? surfaceTargetRef.current : legacyTarget;
    const hasValidTarget = target instanceof HTMLElement;
    (0, $fc4bM.useEffect)(()=>{
        if (isLayoutColumnMenuOpen && (!hasValidMenuSelection || !hasValidTarget || components.length === 0)) closeLayoutColumnMenu();
    }, [
        closeLayoutColumnMenu,
        components.length,
        hasValidMenuSelection,
        hasValidTarget,
        isLayoutColumnMenuOpen
    ]);
    if (!isLayoutColumnMenuOpen || !hasValidMenuSelection || components.length === 0 || !hasValidTarget) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)($0f8396a7d535500f$var$PopupWithListeners, {
        target: target,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        zIndex: (0, $014x6.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        preventOverflow: true,
        stick: true,
        offset: $0f8396a7d535500f$var$LAYOUT_COLUMN_MENU_POPUP_OFFSET_BELOW,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: closeLayoutColumnMenu,
        focusTrap: openedViaKeyboard ? $0f8396a7d535500f$var$focusTrap : undefined,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            ref: menuWrapperRef,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6ySyj.UserIntentPopupWrapper), {
                api: api,
                userIntent: "layoutColumnMenuPopupOpen",
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $pFkjB.ToolbarDropdownMenuProvider), {
                    isOpen: isLayoutColumnMenuOpen,
                    setIsOpen: handleSetIsOpen,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3kq7i.ArrowKeyNavigationProvider), {
                        type: (0, $4mSGa.ArrowKeyNavigationType).MENU,
                        handleClose: handleArrowKeyNavigationClose,
                        disableArrowKeyNavigation: shouldDisableArrowKeyNavigation,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kXdsr.SurfaceRenderer), {
                            components: components,
                            fallbacks: (0, $fxGwF.LAYOUT_COLUMN_MENU_FALLBACKS),
                            surface: (0, $lkQZZ.LAYOUT_COLUMN_MENU)
                        })
                    })
                })
            })
        })
    });
});

});
parcelRegister("fxGwF", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_COLUMN_MENU_FALLBACKS", () => $1ddda8a95c83617c$export$ebf2330b4a9986ef);
$parcel$export(module.exports, "getLayoutColumnMenuComponents", () => $1ddda8a95c83617c$export$dd3a9dfb7a54acb6);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $csQ9c = parcelRequire("csQ9c");

var $dogcz = parcelRequire("dogcz");

var $l4q07 = parcelRequire("l4q07");

var $1aNCd = parcelRequire("1aNCd");

var $2wScG = parcelRequire("2wScG");

var $4vnh9 = parcelRequire("4vnh9");

var $9FyDS = parcelRequire("9FyDS");

var $lkQZZ = parcelRequire("lkQZZ");

var $lVenG = parcelRequire("lVenG");

var $3L1sw = parcelRequire("3L1sw");
const $1ddda8a95c83617c$var$LayoutColumnMenuContainer = ({ children: children })=>{
    const setOutsideClickTargetRef = (0, $fc4bM.useContext)((0, $dogcz.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1aNCd.ToolbarMenuContainer), {
        ref: setOutsideClickTargetRef,
        children: children
    });
};
const $1ddda8a95c83617c$export$ebf2330b4a9986ef = {
    'menu-section': ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
            children: children
        })
};
const $1ddda8a95c83617c$export$dd3a9dfb7a54acb6 = ({ api: api })=>{
    return [
        {
            ...(0, $lkQZZ.LAYOUT_COLUMN_MENU),
            component: $1ddda8a95c83617c$var$LayoutColumnMenuContainer
        },
        {
            ...(0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_MENU),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_MENU_RANK)[(0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.INSERT_COLUMN_LEFT_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $9FyDS.InsertColumnDropdownItem), {
                    api: api,
                    side: "left"
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION_RANK)[(0, $lkQZZ.INSERT_COLUMN_LEFT_MENU_ITEM).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.INSERT_COLUMN_RIGHT_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $9FyDS.InsertColumnDropdownItem), {
                    api: api,
                    side: "right"
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION_RANK)[(0, $lkQZZ.INSERT_COLUMN_RIGHT_MENU_ITEM).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.DISTRIBUTE_COLUMNS_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $4vnh9.DistributeColumnsDropdownItem), {
                    api: api
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION_RANK)[(0, $lkQZZ.DISTRIBUTE_COLUMNS_MENU_ITEM).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.VERTICAL_ALIGN_MENU),
            component: ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $3L1sw.VerticalAlignNestedMenu), {
                    api: api,
                    children: children
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_MENU_SECTION_RANK)[(0, $lkQZZ.VERTICAL_ALIGN_MENU).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.LAYOUT_COLUMN_VERTICAL_ALIGN_MENU_SECTION),
            parents: [
                {
                    ...(0, $lkQZZ.VERTICAL_ALIGN_MENU),
                    rank: (0, $lkQZZ.VERTICAL_ALIGN_MENU_RANK)[(0, $lkQZZ.LAYOUT_COLUMN_VERTICAL_ALIGN_MENU_SECTION).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.VERTICAL_ALIGN_TOP_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $lVenG.VerticalAlignDropdownItem), {
                    api: api,
                    label: (0, $csQ9c.toolbarMessages).alignColumnTop,
                    value: "top"
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_VERTICAL_ALIGN_MENU_SECTION),
                    rank: (0, $lkQZZ.VERTICAL_ALIGN_MENU_SECTION_RANK)[(0, $lkQZZ.VERTICAL_ALIGN_TOP_MENU_ITEM).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.VERTICAL_ALIGN_MIDDLE_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $lVenG.VerticalAlignDropdownItem), {
                    api: api,
                    label: (0, $csQ9c.toolbarMessages).alignColumnMiddle,
                    value: "middle"
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_VERTICAL_ALIGN_MENU_SECTION),
                    rank: (0, $lkQZZ.VERTICAL_ALIGN_MENU_SECTION_RANK)[(0, $lkQZZ.VERTICAL_ALIGN_MIDDLE_MENU_ITEM).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.VERTICAL_ALIGN_BOTTOM_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $lVenG.VerticalAlignDropdownItem), {
                    api: api,
                    label: (0, $csQ9c.toolbarMessages).alignColumnBottom,
                    value: "bottom"
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_VERTICAL_ALIGN_MENU_SECTION),
                    rank: (0, $lkQZZ.VERTICAL_ALIGN_MENU_SECTION_RANK)[(0, $lkQZZ.VERTICAL_ALIGN_BOTTOM_MENU_ITEM).key]
                }
            ]
        },
        // --- Danger section (Delete column) ---
        {
            ...(0, $lkQZZ.LAYOUT_COLUMN_DANGER_SECTION),
            component: ({ children: children })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_MENU),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_MENU_RANK)[(0, $lkQZZ.LAYOUT_COLUMN_DANGER_SECTION).key]
                }
            ]
        },
        {
            ...(0, $lkQZZ.DELETE_COLUMN_MENU_ITEM),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $2wScG.DeleteColumnDropdownItem), {
                    api: api
                }),
            parents: [
                {
                    ...(0, $lkQZZ.LAYOUT_COLUMN_DANGER_SECTION),
                    rank: (0, $lkQZZ.LAYOUT_COLUMN_DANGER_SECTION_RANK)[(0, $lkQZZ.DELETE_COLUMN_MENU_ITEM).key]
                }
            ]
        }
    ];
};

});
parcelRegister("2wScG", function(module, exports) {
$parcel$export(module.exports, "DeleteColumnDropdownItem", () => $c77c36505d2e04cb$export$5829d448eda3ac0f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $csQ9c = parcelRequire("csQ9c");

var $Admw7 = parcelRequire("Admw7");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $2Px9J = parcelRequire("2Px9J");
const $c77c36505d2e04cb$export$5829d448eda3ac0f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedLayoutColumns = (0, $2Px9J.useSelectedLayoutColumns)(api);
    const setDangerPreview = (0, $fc4bM.useCallback)((show)=>{
        var _api$core, _api$layout;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 ? void 0 : _api$layout.commands.setLayoutColumnDangerPreview(show));
    }, [
        api
    ]);
    const showDangerPreview = (0, $fc4bM.useCallback)(()=>{
        setDangerPreview(true);
    }, [
        setDangerPreview
    ]);
    const hideDangerPreview = (0, $fc4bM.useCallback)(()=>{
        setDangerPreview(false);
    }, [
        setDangerPreview
    ]);
    const onClick = (0, $fc4bM.useCallback)(()=>{
        var _api$layout2, _api$core2;
        const deleteCommand = api === null || api === void 0 || (_api$layout2 = api.layout) === null || _api$layout2 === void 0 ? void 0 : _api$layout2.commands.deleteLayoutColumn({
            inputMethod: (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU
        });
        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute((props)=>{
            var _api$layout3;
            const tr = deleteCommand === null || deleteCommand === void 0 ? void 0 : deleteCommand(props);
            if (!tr) return tr ?? null;
            api === null || api === void 0 || (_api$layout3 = api.layout) === null || _api$layout3 === void 0 || _api$layout3.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    if (selectedLayoutColumns === undefined) return null;
    const selectedColumnCount = selectedLayoutColumns.selectedLayoutColumns.length;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        ariaKeyshortcuts: (0, $eUtBU.getAriaKeyshortcuts)((0, $eUtBU.deleteColumn)),
        onClick: onClick,
        onFocus: showDangerPreview,
        onMouseEnter: showDangerPreview,
        onBlur: hideDangerPreview,
        onMouseLeave: hideDangerPreview,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Admw7))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.deleteColumn)) ?? ''
        }),
        children: formatMessage((0, $csQ9c.toolbarMessages).deleteColumn, {
            count: selectedColumnCount
        })
    });
};

});
parcelRegister("2Px9J", function(module, exports) {
$parcel$export(module.exports, "useSelectedLayoutColumns", () => $75e56266e7325a64$export$b5775257132e9ca7);

var $9oAqi = parcelRequire("9oAqi");

var $cv1v0 = parcelRequire("cv1v0");
const $75e56266e7325a64$export$b5775257132e9ca7 = (api)=>(0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], ({ selectionState: selectionState })=>{
        const selectedLayoutColumns = (selectionState === null || selectionState === void 0 ? void 0 : selectionState.selection) && (0, $cv1v0.getSelectedLayoutColumnsFromSelection)(selectionState.selection);
        return selectedLayoutColumns !== null && selectedLayoutColumns !== void 0 && selectedLayoutColumns.selectedLayoutColumns.length ? selectedLayoutColumns : undefined;
    });

});


parcelRegister("4vnh9", function(module, exports) {
$parcel$export(module.exports, "DistributeColumnsDropdownItem", () => $1d70208b0ba50ea6$export$38f325b1b0b6a59f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $csQ9c = parcelRequire("csQ9c");

var $5m5hr = parcelRequire("5m5hr");

var $7otWv = parcelRequire("7otWv");

var $i3vVH = parcelRequire("i3vVH");

var $2Px9J = parcelRequire("2Px9J");
const $1d70208b0ba50ea6$export$38f325b1b0b6a59f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedLayoutColumnsResult = (0, $2Px9J.useSelectedLayoutColumns)(api);
    const { selectedLayoutColumns: selectedLayoutColumns } = selectedLayoutColumnsResult ?? {};
    const handleClick = (0, $fc4bM.useCallback)(()=>{
        var _api$core;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute((props)=>{
            var _api$layout, _api$layout2;
            const tr = api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 ? void 0 : _api$layout.commands.distributeLayoutColumns({
                inputMethod: (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU
            })(props);
            if (!tr) return null;
            const closedTr = api === null || api === void 0 || (_api$layout2 = api.layout) === null || _api$layout2 === void 0 ? void 0 : _api$layout2.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return closedTr ?? tr;
        });
    }, [
        api
    ]);
    const isAlreadyUniform = (0, $fc4bM.useMemo)(()=>{
        if (!selectedLayoutColumns || selectedLayoutColumns.length < 2) return false;
        const selectedWidths = selectedLayoutColumns.map((col)=>col.node.attrs.width);
        return (0, $i3vVH.isDistributedUniformly)(selectedWidths);
    }, [
        selectedLayoutColumns
    ]);
    if (selectedLayoutColumns === undefined || selectedLayoutColumns.length < 2) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        isDisabled: isAlreadyUniform,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5m5hr))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $csQ9c.toolbarMessages).distributeColumns)
    });
};

});

parcelRegister("9FyDS", function(module, exports) {
$parcel$export(module.exports, "InsertColumnDropdownItem", () => $7aa9912aa3d522f0$export$81334f287bddf48);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $csQ9c = parcelRequire("csQ9c");

var $3foDq = parcelRequire("3foDq");

var $hWLCD = parcelRequire("hWLCD");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $3sx0g = parcelRequire("3sx0g");

var $2Px9J = parcelRequire("2Px9J");
const $7aa9912aa3d522f0$var$INSERT_COLUMN_OPTIONS = {
    left: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3foDq))),
        label: (0, $csQ9c.toolbarMessages).addColumnLeft,
        side: 'left'
    },
    right: {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hWLCD))),
        label: (0, $csQ9c.toolbarMessages).addColumnRight,
        side: 'right'
    }
};
const $7aa9912aa3d522f0$export$81334f287bddf48 = ({ api: api, side: side })=>{
    var _selectedLayoutColumn;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { Icon: Icon, label: label } = $7aa9912aa3d522f0$var$INSERT_COLUMN_OPTIONS[side];
    const shortcut = side === 'left' ? (0, $eUtBU.addColumnBefore) : (0, $eUtBU.addColumnAfter);
    const selectedLayoutColumns = (0, $2Px9J.useSelectedLayoutColumns)(api);
    const columnCount = (selectedLayoutColumns === null || selectedLayoutColumns === void 0 || (_selectedLayoutColumn = selectedLayoutColumns.layoutSectionNode) === null || _selectedLayoutColumn === void 0 ? void 0 : _selectedLayoutColumn.childCount) ?? 0;
    const maxColumnCount = (0, $3sx0g.getEffectiveMaxLayoutColumns)();
    const canInsertColumn = selectedLayoutColumns !== undefined && columnCount < maxColumnCount;
    const onClick = (0, $fc4bM.useCallback)(()=>{
        var _api$layout, _api$core;
        const insertCommand = api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 ? void 0 : _api$layout.commands.insertLayoutColumn({
            side: side,
            inputMethod: (0, $3LeME.INPUT_METHOD).LAYOUT_COLUMN_MENU
        });
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute((props)=>{
            var _api$layout2;
            const tr = insertCommand === null || insertCommand === void 0 ? void 0 : insertCommand(props);
            if (!tr) return tr ?? null;
            api === null || api === void 0 || (_api$layout2 = api.layout) === null || _api$layout2 === void 0 || _api$layout2.commands.toggleLayoutColumnMenu({
                isOpen: false
            })({
                tr: tr
            });
            return tr;
        });
    }, [
        api,
        side
    ]);
    if (!canInsertColumn) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        ariaKeyshortcuts: (0, $eUtBU.getAriaKeyshortcuts)(shortcut),
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)(shortcut) ?? ''
        }),
        onClick: onClick,
        children: formatMessage(label)
    });
};

});

parcelRegister("lkQZZ", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_COLUMN_MENU", () => $37c598027ff536ba$export$9d94e89ca7612d27);
$parcel$export(module.exports, "LAYOUT_COLUMN_MENU_SECTION", () => $37c598027ff536ba$export$eb99a60802d2824d);
$parcel$export(module.exports, "LAYOUT_COLUMN_VERTICAL_ALIGN_MENU_SECTION", () => $37c598027ff536ba$export$75dfb738e6f28040);
$parcel$export(module.exports, "LAYOUT_COLUMN_DANGER_SECTION", () => $37c598027ff536ba$export$4586103d528537d);
$parcel$export(module.exports, "LAYOUT_COLUMN_MENU_RANK", () => $37c598027ff536ba$export$5a7b98ab4e990db4);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU", () => $37c598027ff536ba$export$b015955eb6c647e8);
$parcel$export(module.exports, "INSERT_COLUMN_LEFT_MENU_ITEM", () => $37c598027ff536ba$export$3e4da34ad142735a);
$parcel$export(module.exports, "INSERT_COLUMN_RIGHT_MENU_ITEM", () => $37c598027ff536ba$export$167d9b289da7ec90);
$parcel$export(module.exports, "DISTRIBUTE_COLUMNS_MENU_ITEM", () => $37c598027ff536ba$export$3497442ae78aae72);
$parcel$export(module.exports, "VERTICAL_ALIGN_TOP_MENU_ITEM", () => $37c598027ff536ba$export$e9b3f7442c87b29e);
$parcel$export(module.exports, "VERTICAL_ALIGN_MIDDLE_MENU_ITEM", () => $37c598027ff536ba$export$1031423c8b45d874);
$parcel$export(module.exports, "VERTICAL_ALIGN_BOTTOM_MENU_ITEM", () => $37c598027ff536ba$export$afcf8724bfd1844e);
$parcel$export(module.exports, "DELETE_COLUMN_MENU_ITEM", () => $37c598027ff536ba$export$d75dc9d2c2174014);
$parcel$export(module.exports, "LAYOUT_COLUMN_MENU_SECTION_RANK", () => $37c598027ff536ba$export$c1497fcad4589239);
$parcel$export(module.exports, "LAYOUT_COLUMN_DANGER_SECTION_RANK", () => $37c598027ff536ba$export$179c00b952ce20ad);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU_RANK", () => $37c598027ff536ba$export$3094a3221df5ea5d);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU_SECTION_RANK", () => $37c598027ff536ba$export$9767915495221593);
const $37c598027ff536ba$export$9d94e89ca7612d27 = {
    type: 'menu',
    key: 'layout-column-menu'
};
const $37c598027ff536ba$export$eb99a60802d2824d = {
    type: 'menu-section',
    key: 'layout-column-menu-section'
};
const $37c598027ff536ba$export$75dfb738e6f28040 = {
    type: 'menu-section',
    key: 'layout-column-vertical-align-menu-section'
};
const $37c598027ff536ba$export$4586103d528537d = {
    type: 'menu-section',
    key: 'layout-column-danger-section'
};
const $37c598027ff536ba$export$5a7b98ab4e990db4 = {
    [$37c598027ff536ba$export$eb99a60802d2824d.key]: 100,
    [$37c598027ff536ba$export$4586103d528537d.key]: 200
};
const $37c598027ff536ba$export$b015955eb6c647e8 = {
    type: 'nested-menu',
    key: 'layout-column-menu-vertical-align-menu'
};
const $37c598027ff536ba$export$3e4da34ad142735a = {
    type: 'menu-item',
    key: 'layout-column-menu-insert-left-item'
};
const $37c598027ff536ba$export$167d9b289da7ec90 = {
    type: 'menu-item',
    key: 'layout-column-menu-insert-right-item'
};
const $37c598027ff536ba$export$3497442ae78aae72 = {
    type: 'menu-item',
    key: 'layout-column-menu-distribute-columns-item'
};
const $37c598027ff536ba$export$e9b3f7442c87b29e = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-top-item'
};
const $37c598027ff536ba$export$1031423c8b45d874 = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-middle-item'
};
const $37c598027ff536ba$export$afcf8724bfd1844e = {
    type: 'menu-item',
    key: 'layout-column-menu-vertical-align-bottom-item'
};
const $37c598027ff536ba$export$d75dc9d2c2174014 = {
    type: 'menu-item',
    key: 'layout-column-menu-delete-item'
};
const $37c598027ff536ba$export$c1497fcad4589239 = {
    [$37c598027ff536ba$export$b015955eb6c647e8.key]: 100,
    [$37c598027ff536ba$export$3e4da34ad142735a.key]: 200,
    [$37c598027ff536ba$export$167d9b289da7ec90.key]: 300,
    [$37c598027ff536ba$export$3497442ae78aae72.key]: 400
};
const $37c598027ff536ba$export$179c00b952ce20ad = {
    [$37c598027ff536ba$export$d75dc9d2c2174014.key]: 100
};
const $37c598027ff536ba$export$3094a3221df5ea5d = {
    [$37c598027ff536ba$export$75dfb738e6f28040.key]: 100
};
const $37c598027ff536ba$export$9767915495221593 = {
    [$37c598027ff536ba$export$e9b3f7442c87b29e.key]: 100,
    [$37c598027ff536ba$export$1031423c8b45d874.key]: 200,
    [$37c598027ff536ba$export$afcf8724bfd1844e.key]: 300
};

});

parcelRegister("lVenG", function(module, exports) {
$parcel$export(module.exports, "VerticalAlignDropdownItem", () => $529604fd329af0ab$export$d49b4cfa8d7eb46c);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $7otWv = parcelRequire("7otWv");

var $cv1v0 = parcelRequire("cv1v0");

var $2Px9J = parcelRequire("2Px9J");

var $cWIhg = parcelRequire("cWIhg");
const $529604fd329af0ab$export$d49b4cfa8d7eb46c = ({ api: api, label: label, value: value })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedLayoutColumns = (0, $2Px9J.useSelectedLayoutColumns)(api);
    const isSelected = (selectedLayoutColumns === null || selectedLayoutColumns === void 0 ? void 0 : selectedLayoutColumns.selectedLayoutColumns.every(({ node: node })=>(0, $cv1v0.getLayoutColumnValign)(node) === value)) ?? false;
    const Icon = (0, $cWIhg.VERTICAL_ALIGN_ICONS)[value];
    const onClick = (0, $fc4bM.useCallback)(()=>{
        var _api$core, _api$layout;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 ? void 0 : _api$layout.commands.setLayoutColumnValign({
            valign: value
        }));
    }, [
        api,
        value
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            label: "",
            size: "small"
        }),
        isSelected: isSelected,
        onClick: onClick,
        role: "menuitemradio",
        children: formatMessage(label)
    });
};

});
parcelRegister("cWIhg", function(module, exports) {
$parcel$export(module.exports, "VERTICAL_ALIGN_ICONS", () => $bc7d811c329f1c8a$export$ca3f839074508470);
// Disable no-re-export here, this is a useful mapping file for icon lookup used in multiple places
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $jwcFt = parcelRequire("jwcFt");

var $1i5T8 = parcelRequire("1i5T8");

var $9wVRW = parcelRequire("9wVRW");
const $bc7d811c329f1c8a$export$ca3f839074508470 = {
    top: (0, (/*@__PURE__*/$parcel$interopDefault($9wVRW))),
    middle: (0, (/*@__PURE__*/$parcel$interopDefault($1i5T8))),
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($jwcFt)))
};

});
parcelRegister("jwcFt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a829b6c6e688233b5d890c6d5a26dc8e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e35ad510e48c6265$var$_react = $e35ad510e48c6265$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $e35ad510e48c6265$var$_iconNew = $e35ad510e48c6265$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $e35ad510e48c6265$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionBottom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-bottom
 * Usage guidance:
 * Bottom-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e35ad510e48c6265$var$AlignPositionBottomIcon = (props)=>/*#__PURE__*/ $e35ad510e48c6265$var$_react.default.createElement($e35ad510e48c6265$var$_iconNew.default, Object.assign({
        name: "AlignPositionBottomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 8M3.5 8A.75.75 0 1 1 2 8a.75.75 0 0 1 1.5 0m7 0A.75.75 0 1 1 9 8a.75.75 0 0 1 1.5 0M7 1.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0M14 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 14 8m0-6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/><path fill="currentcolor" fill-rule="evenodd" d="M0 13.5h16V15H0z" clip-rule="evenodd"/>`
    }, props));
$e35ad510e48c6265$var$AlignPositionBottomIcon.displayName = 'AlignPositionBottomIcon';
var $e35ad510e48c6265$var$_default = module.exports.default = $e35ad510e48c6265$var$AlignPositionBottomIcon;

});

parcelRegister("9wVRW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e93684b2c3a77ed06120440aa6a347b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f03fdc94acd06f7$var$_react = $6f03fdc94acd06f7$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $6f03fdc94acd06f7$var$_iconNew = $6f03fdc94acd06f7$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $6f03fdc94acd06f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignPositionTop".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-position-top
 * Usage guidance:
 * Top-aligned text position within sticky notes in Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f03fdc94acd06f7$var$AlignPositionTopIcon = (props)=>/*#__PURE__*/ $6f03fdc94acd06f7$var$_react.default.createElement($6f03fdc94acd06f7$var$_iconNew.default, Object.assign({
        name: "AlignPositionTopIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1h16v1.5H0z" clip-rule="evenodd"/><path fill="currentcolor" d="M7 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 7 8M3.5 8A.75.75 0 1 1 2 8a.75.75 0 0 1 1.5 0m7 0A.75.75 0 1 1 9 8a.75.75 0 0 1 1.5 0M14 8a.75.75 0 1 1-1.5 0A.75.75 0 0 1 14 8m-7 6.25a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m7 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m3.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0"/>`
    }, props));
$6f03fdc94acd06f7$var$AlignPositionTopIcon.displayName = 'AlignPositionTopIcon';
var $6f03fdc94acd06f7$var$_default = module.exports.default = $6f03fdc94acd06f7$var$AlignPositionTopIcon;

});



parcelRegister("3L1sw", function(module, exports) {
$parcel$export(module.exports, "VerticalAlignNestedMenu", () => $67f72e1aad3d1b04$export$711d24ebe8961c4c);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $csQ9c = parcelRequire("csQ9c");

var $ar15H = parcelRequire("ar15H");

var $i6Zpo = parcelRequire("i6Zpo");

var $cv1v0 = parcelRequire("cv1v0");

var $2Px9J = parcelRequire("2Px9J");

var $cWIhg = parcelRequire("cWIhg");
const $67f72e1aad3d1b04$export$711d24ebe8961c4c = ({ api: api, children: children })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedLayoutColumns = (0, $2Px9J.useSelectedLayoutColumns)(api);
    const currentValign = (0, $fc4bM.useMemo)(()=>{
        const selectedColumns = selectedLayoutColumns === null || selectedLayoutColumns === void 0 ? void 0 : selectedLayoutColumns.selectedLayoutColumns;
        const firstColumn = selectedColumns === null || selectedColumns === void 0 ? void 0 : selectedColumns[0];
        const firstValign = (0, $cv1v0.getLayoutColumnValign)(firstColumn === null || firstColumn === void 0 ? void 0 : firstColumn.node);
        if (!firstValign || !(selectedColumns !== null && selectedColumns !== void 0 && selectedColumns.every(({ node: node })=>(0, $cv1v0.getLayoutColumnValign)(node) === firstValign))) return undefined;
        return firstValign;
    }, [
        selectedLayoutColumns
    ]);
    const TriggerIcon = currentValign ? (0, $cWIhg.VERTICAL_ALIGN_ICONS)[currentValign] : (0, $cWIhg.VERTICAL_ALIGN_ICONS).middle;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i6Zpo.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)(TriggerIcon, {
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ar15H.NestedDropdownRightIcon), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $csQ9c.toolbarMessages).alignColumn),
        children: children
    });
};

});
parcelRegister("ar15H", function(module, exports) {
$parcel$export(module.exports, "NestedDropdownRightIcon", () => $c9336595913b6d53$export$e350497c7f50f900);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $1ZqY6 = parcelRequire("1ZqY6");
const $c9336595913b6d53$export$e350497c7f50f900 = ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1ZqY6))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });

});




parcelRegister("h965D", function(module, exports) {
$parcel$export(module.exports, "getLayoutQuickInsertComponents", () => $f0be5983a8cac136$export$ab30cc6fee54f4aa);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cT0LQ = parcelRequire("cT0LQ");

var $csQ9c = parcelRequire("csQ9c");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $407IR = parcelRequire("407IR");
const $f0be5983a8cac136$var$layoutItems = [
    {
        columnCount: 2,
        description: (0, $cT0LQ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $hI3gt.TWO_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'two column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMM.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJY.png'
        },
        title: (0, $csQ9c.toolbarMessages).twoColumnsAdvancedLayout
    },
    {
        columnCount: 3,
        description: (0, $cT0LQ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $hI3gt.THREE_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'three column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNM.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK3.png'
        },
        title: (0, $csQ9c.toolbarMessages).threeColumnsAdvancedLayout
    },
    {
        columnCount: 4,
        description: (0, $cT0LQ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $hI3gt.FOUR_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'four column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNI.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK5.png'
        },
        title: (0, $csQ9c.toolbarMessages).fourColumns
    },
    {
        columnCount: 5,
        description: (0, $cT0LQ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout,
        item: (0, $hI3gt.FIVE_COLUMNS_LAYOUT_MENU_ITEM),
        keyword: 'five column',
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNO.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJV.png'
        },
        title: (0, $csQ9c.toolbarMessages).fiveColumns
    }
];
const $f0be5983a8cac136$export$ab30cc6fee54f4aa = ({ api: api })=>$f0be5983a8cac136$var$layoutItems.map(({ columnCount: columnCount, description: description, item: item, keyword: keyword, previewImageUrls: previewImageUrls, title: title })=>({
            key: item.key,
            type: item.type,
            parents: [
                {
                    key: (0, $hI3gt.STRUCTURE_SECTION).key,
                    type: (0, $hI3gt.STRUCTURE_SECTION).type,
                    rank: (0, $4jXgF.STRUCTURE_SECTION_RANK)[item.key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage(description, {
                        numberOfColumns: columnCount
                    }),
                    keywords: [
                        'layout',
                        'column',
                        'section',
                        'col',
                        keyword
                    ],
                    title: formatMessage(title)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $407IR.LayoutQuickInsertMenuItem), {
                    api: api,
                    columnCount: columnCount,
                    previewImageUrls: previewImageUrls,
                    title: title
                })
        }));

});
parcelRegister("407IR", function(module, exports) {
$parcel$export(module.exports, "LayoutQuickInsertMenuItem", () => $74de00a43774d18e$export$dfc1bab297c2a456);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $3M4Vk = parcelRequire("3M4Vk");

var $d7yEt = parcelRequire("d7yEt");

var $CyKNv = parcelRequire("CyKNv");

var $5xh1u = parcelRequire("5xh1u");

var $f4Ysc = parcelRequire("f4Ysc");

var $a2Dck = parcelRequire("a2Dck");

var $3sx0g = parcelRequire("3sx0g");
const $74de00a43774d18e$var$icons = {
    2: (0, (/*@__PURE__*/$parcel$interopDefault($f4Ysc))),
    3: (0, (/*@__PURE__*/$parcel$interopDefault($5xh1u))),
    4: (0, (/*@__PURE__*/$parcel$interopDefault($CyKNv))),
    5: (0, (/*@__PURE__*/$parcel$interopDefault($d7yEt)))
};
const $74de00a43774d18e$export$dfc1bab297c2a456 = ({ api: api, columnCount: columnCount, previewImageUrls: previewImageUrls, title: title })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const preview = (0, $fc4bM.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $3M4Vk.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const Icon = $74de00a43774d18e$var$icons[columnCount];
    const onSelect = (0, $fc4bM.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        var _api$analytics;
        const tr = insert((0, $3sx0g.createMultiColumnLayoutSection)(editorView.state, columnCount));
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).LAYOUT,
            attributes: {
                columnCount: columnCount,
                inputMethod: source
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })(tr);
        (0, $a2Dck.selectIntoLayoutSection)(tr);
        return tr;
    }, [
        api,
        columnCount
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).columnsDescriptionAdvancedLayout, {
            numberOfColumns: columnCount
        }),
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage(title)
    });
};

});
parcelRegister("d7yEt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::81306de5aadced8b72071db543605b61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98d6ceee068c3397$var$_react = $98d6ceee068c3397$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $98d6ceee068c3397$var$_iconNew = $98d6ceee068c3397$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $98d6ceee068c3397$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFiveColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-five-columns
 * Usage guidance:
 * Reserved for 5 column layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98d6ceee068c3397$var$LayoutFiveColumnsIcon = (props)=>/*#__PURE__*/ $98d6ceee068c3397$var$_react.default.createElement($98d6ceee068c3397$var$_iconNew.default, Object.assign({
        name: "LayoutFiveColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 4.25 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0A.75.75 0 0 1 7.75 1h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75zm3.5 0a.75.75 0 0 1 .75-.75h.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$98d6ceee068c3397$var$LayoutFiveColumnsIcon.displayName = 'LayoutFiveColumnsIcon';
var $98d6ceee068c3397$var$_default = module.exports.default = $98d6ceee068c3397$var$LayoutFiveColumnsIcon;

});

parcelRegister("CyKNv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8c46fa49e336ada32e735b81e4aa5434>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $073e821ae2eab9b0$var$_react = $073e821ae2eab9b0$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $073e821ae2eab9b0$var$_iconNew = $073e821ae2eab9b0$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $073e821ae2eab9b0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutFourColumns".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-four-columns
 * Usage guidance:
 * Reserved for 4 columns layout option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $073e821ae2eab9b0$var$LayoutFourColumnsIcon = (props)=>/*#__PURE__*/ $073e821ae2eab9b0$var$_react.default.createElement($073e821ae2eab9b0$var$_iconNew.default, Object.assign({
        name: "LayoutFourColumnsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 1.75A.75.75 0 0 1 .75 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H.75a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75H6.5a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H5.125a.75.75 0 0 1-.75-.75zm4.375 0A.75.75 0 0 1 9.5 1h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75H9.5a.75.75 0 0 1-.75-.75zm4.375 0a.75.75 0 0 1 .75-.75h1.375a.75.75 0 0 1 .75.75v12.5a.75.75 0 0 1-.75.75h-1.375a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$073e821ae2eab9b0$var$LayoutFourColumnsIcon.displayName = 'LayoutFourColumnsIcon';
var $073e821ae2eab9b0$var$_default = module.exports.default = $073e821ae2eab9b0$var$LayoutFourColumnsIcon;

});



parcelRegister("jBrrU", function(module, exports) {
$parcel$export(module.exports, "buildToolbar", () => $71bc5a01fd42bb68$export$6dd6ab35df8f7f86);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $3uluy = parcelRequire("3uluy");

var $csQ9c = parcelRequire("csQ9c");

var $fmnS6 = parcelRequire("fmnS6");

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $eGgZF = parcelRequire("eGgZF");

var $Admw7 = parcelRequire("Admw7");

var $f9Uoo = parcelRequire("f9Uoo");

var $5xh1u = parcelRequire("5xh1u");

var $ewmvX = parcelRequire("ewmvX");

var $f4Ysc = parcelRequire("f4Ysc");

var $iu5bQ = parcelRequire("iu5bQ");

var $gtxSA = parcelRequire("gtxSA");

var $5m5hr = parcelRequire("5m5hr");

var $kaRof = parcelRequire("kaRof");

var $3sx0g = parcelRequire("3sx0g");

var $i3vVH = parcelRequire("i3vVH");

var $lHCYP = parcelRequire("lHCYP");

var $bXpnT = parcelRequire("bXpnT");

var $7VQhW = parcelRequire("7VQhW");
const $71bc5a01fd42bb68$var$LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoEquals',
        type: 'two_equal',
        title: (0, $csQ9c.toolbarMessages).twoColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f4Ysc)))
    },
    {
        id: 'editor.layout.threeEquals',
        type: 'three_equal',
        title: (0, $csQ9c.toolbarMessages).threeColumns,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5xh1u)))
    }
];
const $71bc5a01fd42bb68$var$LAYOUT_TYPES_WITH_SINGLE_COL = [
    {
        id: 'editor.layout.singeLayout',
        type: 'single',
        title: (0, $csQ9c.toolbarMessages).singleColumn,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f9Uoo)))
    },
    ...$71bc5a01fd42bb68$var$LAYOUT_TYPES
];
const $71bc5a01fd42bb68$var$SIDEBAR_LAYOUT_TYPES = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $csQ9c.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtxSA)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $csQ9c.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iu5bQ)))
    },
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $csQ9c.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ewmvX)))
    }
];
const $71bc5a01fd42bb68$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.twoRightSidebar',
        type: 'two_right_sidebar',
        title: (0, $csQ9c.toolbarMessages).rightSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gtxSA)))
    },
    {
        id: 'editor.layout.twoLeftSidebar',
        type: 'two_left_sidebar',
        title: (0, $csQ9c.toolbarMessages).leftSidebar,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iu5bQ)))
    }
];
const $71bc5a01fd42bb68$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION = [
    {
        id: 'editor.layout.threeWithSidebars',
        type: 'three_with_sidebars',
        title: (0, $csQ9c.toolbarMessages).threeColumnsWithSidebars,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ewmvX)))
    },
    {
        id: 'editor.layout.threeRightSidebars',
        type: 'three_right_sidebars',
        title: (0, $csQ9c.toolbarMessages).threeColumnsWithRightSidebars,
        icon: (0, $7VQhW.LayoutThreeWithRightSidebarsIcon),
        iconFallback: (0, $7VQhW.LayoutThreeWithRightSidebarsIcon)
    },
    {
        id: 'editor.layout.threeLeftSidebars',
        type: 'three_left_sidebars',
        title: (0, $csQ9c.toolbarMessages).threeColumnsWithLeftSidebars,
        icon: (0, $bXpnT.LayoutThreeWithLeftSidebarsIcon),
        iconFallback: (0, $bXpnT.LayoutThreeWithLeftSidebarsIcon)
    }
];
const $71bc5a01fd42bb68$var$buildLayoutButton = (intl, item, currentLayout, editorAnalyticsAPI)=>({
        id: item.id,
        type: 'button',
        icon: item.icon,
        iconFallback: item.iconFallback,
        testId: item.title.id ? `${item.title.id}` : undefined,
        title: intl.formatMessage(item.title),
        onClick: (0, $3sx0g.setPresetLayout)(editorAnalyticsAPI)(item.type),
        selected: !!currentLayout && currentLayout === item.type,
        tabIndex: null
    });
const $71bc5a01fd42bb68$export$cbec87ad92a1069a = 'Layout floating controls';
const $71bc5a01fd42bb68$var$iconPlaceholder = /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4Ysc))), {
    label: ""
}); // TODO: ED-25466 - Replace with proper icon
const $71bc5a01fd42bb68$var$getLayoutColumnsIcons = (colCount)=>{
    if (!(0, $kaRof.editorExperiment)('single_column_layouts', true) && !(0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) return undefined;
    switch(colCount){
        case 1:
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f9Uoo))), {
                label: ""
            });
        case 2:
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f4Ysc))), {
                label: ""
            });
        case 3:
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5xh1u))), {
                label: ""
            });
        case 4:
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lHCYP.EditorLayoutFourColumnsIcon), {});
        case 5:
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lHCYP.EditorLayoutFiveColumnsIcon), {});
        default:
            return undefined;
    }
};
const $71bc5a01fd42bb68$var$getLayoutColumnWidths = (node)=>{
    return node.children.map((child)=>child.attrs.width);
};
const $71bc5a01fd42bb68$var$getAdvancedLayoutItems = ({ addSidebarLayouts: addSidebarLayouts, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, node: node, nodeType: nodeType, separator: separator, deleteButton: deleteButton, currentLayout: currentLayout, allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout })=>{
    const numberOfColumns = node.content.childCount || 2;
    const distributionOptions = numberOfColumns === 2 ? $71bc5a01fd42bb68$var$LAYOUT_WITH_TWO_COL_DISTRIBUTION : numberOfColumns === 3 ? $71bc5a01fd42bb68$var$LAYOUT_WITH_THREE_COL_DISTRIBUTION : [];
    const columnOptions = [
        {
            title: intl.formatMessage((0, $csQ9c.toolbarMessages).columnOption, {
                count: 2
            }),
            //'2-columns',
            icon: $71bc5a01fd42bb68$var$getLayoutColumnsIcons(2) || $71bc5a01fd42bb68$var$iconPlaceholder,
            onClick: (0, $3sx0g.setPresetLayout)(editorAnalyticsAPI)('two_equal'),
            selected: numberOfColumns === 2
        },
        {
            title: intl.formatMessage((0, $csQ9c.toolbarMessages).columnOption, {
                count: 3
            }),
            //'3-columns'
            icon: $71bc5a01fd42bb68$var$getLayoutColumnsIcons(3) || $71bc5a01fd42bb68$var$iconPlaceholder,
            onClick: (0, $3sx0g.setPresetLayout)(editorAnalyticsAPI)('three_equal'),
            selected: numberOfColumns === 3
        },
        {
            title: intl.formatMessage((0, $csQ9c.toolbarMessages).columnOption, {
                count: 4
            }),
            //'4-columns'
            icon: $71bc5a01fd42bb68$var$getLayoutColumnsIcons(4) || $71bc5a01fd42bb68$var$iconPlaceholder,
            onClick: (0, $3sx0g.setPresetLayout)(editorAnalyticsAPI)('four_equal'),
            selected: numberOfColumns === 4
        },
        {
            title: intl.formatMessage((0, $csQ9c.toolbarMessages).columnOption, {
                count: 5
            }),
            //'5-columns'
            icon: $71bc5a01fd42bb68$var$getLayoutColumnsIcons(5) || $71bc5a01fd42bb68$var$iconPlaceholder,
            onClick: (0, $3sx0g.setPresetLayout)(editorAnalyticsAPI)('five_equal'),
            selected: numberOfColumns === 5
        }
    ];
    const dropdownOptions = [
        ...allowAdvancedSingleColumnLayout ? [
            {
                title: intl.formatMessage((0, $csQ9c.toolbarMessages).columnOption, {
                    count: 1
                }),
                //'1-columns',
                icon: $71bc5a01fd42bb68$var$getLayoutColumnsIcons(1) || $71bc5a01fd42bb68$var$iconPlaceholder,
                onClick: (0, $3sx0g.setPresetLayout)(editorAnalyticsAPI)('single'),
                selected: numberOfColumns === 1
            }
        ] : [],
        ...columnOptions
    ];
    const distributeColumnsButton = numberOfColumns > 1 ? {
        disabled: (0, $i3vVH.isDistributedUniformly)($71bc5a01fd42bb68$var$getLayoutColumnWidths(node)),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5m5hr))),
        onClick: (editorState, dispatch)=>{
            const tr = (0, $3sx0g.distributeLayoutColumns)(editorAnalyticsAPI)({
                inputMethod: (0, $3LeME.INPUT_METHOD).FLOATING_TB,
                target: 'allColumns'
            })({
                tr: editorState.tr
            });
            if (!tr) return false;
            dispatch === null || dispatch === void 0 || dispatch(tr);
            return true;
        },
        testId: 'layout-distribute-columns',
        title: intl.formatMessage((0, $csQ9c.toolbarMessages).distributeColumns),
        type: 'button'
    } : undefined;
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage((0, $csQ9c.toolbarMessages).columnOption, {
                count: numberOfColumns
            }),
            //`${numberOfColumns}-columns`,
            options: dropdownOptions,
            showSelected: true,
            testId: 'column-options-button'
        },
        ...distributionOptions.length > 0 || distributeColumnsButton ? [
            separator
        ] : [],
        ...addSidebarLayouts ? distributionOptions.map((i)=>$71bc5a01fd42bb68$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : [],
        ...distributeColumnsButton ? [
            distributeColumnsButton
        ] : []
    ];
};
const $71bc5a01fd42bb68$var$fullHeightSeparator = {
    type: 'separator',
    fullHeight: true
};
const $71bc5a01fd42bb68$export$6dd6ab35df8f7f86 = (state, intl, pos, _allowBreakout, addSidebarLayouts, allowSingleColumnLayout, allowAdvancedSingleColumnLayout, api)=>{
    var _api$decorations, _api$analytics;
    const { hoverDecoration: hoverDecoration } = (api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions) ?? {};
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const node = state.doc.nodeAt(pos);
    const toolbarFlagsEnabled = (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    if (node) {
        const currentLayout = (0, $3sx0g.getPresetLayout)(node);
        const separator = {
            type: 'separator'
        };
        const nodeType = state.schema.nodes.layoutSection;
        const deleteButton = {
            id: 'editor.layout.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($Admw7))),
            testId: (0, $3uluy.default).remove.id,
            title: intl.formatMessage((0, $3uluy.default).remove),
            onClick: (0, $3sx0g.deleteActiveLayoutNode)(editorAnalyticsAPI, (0, $3LeME.INPUT_METHOD).FLOATING_TB),
            onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
            onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
            onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
            onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
            tabIndex: null
        };
        const copyButton = {
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: nodeType
                }
            ]
        };
        const layoutTypes = allowSingleColumnLayout ? $71bc5a01fd42bb68$var$LAYOUT_TYPES_WITH_SINGLE_COL : $71bc5a01fd42bb68$var$LAYOUT_TYPES;
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className),
                onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'layout-overflow-dropdown-trigger';
        const overflowMenu = {
            type: 'overflow-dropdown',
            testId: testId,
            options: [
                {
                    title: intl.formatMessage((0, $3uluy.default).copyToClipboard),
                    onClick: ()=>{
                        var _api$core, _api$floatingToolbar;
                        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$floatingToolbar = api.floatingToolbar) === null || _api$floatingToolbar === void 0 ? void 0 : _api$floatingToolbar.commands.copyNode(nodeType, (0, $3LeME.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGgZF))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $014x6.akEditorSelectedNodeClassName))
                },
                {
                    title: intl.formatMessage((0, $3uluy.default).delete),
                    onClick: (0, $3sx0g.deleteActiveLayoutNode)(editorAnalyticsAPI, (0, $3LeME.INPUT_METHOD).FLOATING_TB),
                    icon: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Admw7))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        };
        return {
            title: $71bc5a01fd42bb68$export$cbec87ad92a1069a,
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $a4TQr.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            groupLabel: intl.formatMessage((0, $csQ9c.toolbarMessages).floatingToolbarRadioGroupAriaLabel),
            items: [
                ...(0, $kaRof.editorExperiment)('advanced_layouts', true) ? $71bc5a01fd42bb68$var$getAdvancedLayoutItems({
                    addSidebarLayouts: addSidebarLayouts,
                    intl: intl,
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    nodeType: nodeType,
                    node: node,
                    separator: separator,
                    deleteButton: deleteButton,
                    currentLayout: currentLayout,
                    allowAdvancedSingleColumnLayout: allowAdvancedSingleColumnLayout
                }) : [
                    ...layoutTypes.map((i)=>$71bc5a01fd42bb68$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)),
                    ...addSidebarLayouts ? $71bc5a01fd42bb68$var$SIDEBAR_LAYOUT_TYPES.map((i)=>$71bc5a01fd42bb68$var$buildLayoutButton(intl, i, currentLayout, editorAnalyticsAPI)) : []
                ],
                ...toolbarFlagsEnabled ? [
                    $71bc5a01fd42bb68$var$fullHeightSeparator,
                    overflowMenu
                ] : [
                    separator,
                    copyButton,
                    separator,
                    deleteButton
                ]
            ],
            scrollable: true
        };
    }
    return;
};

});
parcelRegister("lHCYP", function(module, exports) {
$parcel$export(module.exports, "EditorLayoutFiveColumnsIcon", () => $4a244773d1c2dacd$export$3cfd1ab6a9856e7e);
$parcel$export(module.exports, "EditorLayoutFourColumnsIcon", () => $4a244773d1c2dacd$export$38b01bd15f6a5487);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $jctmk = parcelRequire("jctmk");

var $d7yEt = parcelRequire("d7yEt");

var $CyKNv = parcelRequire("CyKNv");
function $4a244773d1c2dacd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a244773d1c2dacd$var$wrapperStyle = {
    name: "dzd8y1",
    styles: "padding:0 4px"
};
const $4a244773d1c2dacd$var$Wrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: $4a244773d1c2dacd$var$wrapperStyle
    }, children);
};
const $4a244773d1c2dacd$export$3cfd1ab6a9856e7e = ()=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)($4a244773d1c2dacd$var$Wrapper, null, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d7yEt))), {
        label: ""
    }));
};
const $4a244773d1c2dacd$export$38b01bd15f6a5487 = ()=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)($4a244773d1c2dacd$var$Wrapper, null, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($CyKNv))), {
        label: ""
    }));
};

});

parcelRegister("bXpnT", function(module, exports) {
$parcel$export(module.exports, "LayoutThreeWithLeftSidebarsIcon", () => $146ad4939781ef59$export$4518caee70c71b2e);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3icQn = parcelRequire("3icQn");
const $146ad4939781ef59$export$4518caee70c71b2e = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3icQn))), {
        ...props
    });
};

});
parcelRegister("3icQn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e16d8836cf8baac0ddc7210e13dc4175>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $265d040bc6f7c0ec$var$_react = $265d040bc6f7c0ec$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $265d040bc6f7c0ec$var$_iconNew = $265d040bc6f7c0ec$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $265d040bc6f7c0ec$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-three-columns-sidebars-left
 * Usage guidance:
 * Reserved for 3 column layout with 2 sidebars on left option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $265d040bc6f7c0ec$var$LayoutThreeColumnsSidebarsLeftIcon = (props)=>/*#__PURE__*/ $265d040bc6f7c0ec$var$_react.default.createElement($265d040bc6f7c0ec$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C.615 15 0 14.384 0 13.625zm1.5.125v11H2v-11zM5 2.375C5 1.615 5.616 1 6.375 1h.75c.76 0 1.375.616 1.375 1.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75C5.615 15 5 14.384 5 13.625zm1.5.125v11H7v-11zm3.5-.125C10 1.615 10.616 1 11.375 1h3.25C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-3.25c-.76 0-1.375-.616-1.375-1.375zm1.5.125v11h3v-11z" clip-rule="evenodd"/>`
    }, props));
$265d040bc6f7c0ec$var$LayoutThreeColumnsSidebarsLeftIcon.displayName = 'LayoutThreeColumnsSidebarsLeftIcon';
var $265d040bc6f7c0ec$var$_default = module.exports.default = $265d040bc6f7c0ec$var$LayoutThreeColumnsSidebarsLeftIcon;

});


parcelRegister("7VQhW", function(module, exports) {
$parcel$export(module.exports, "LayoutThreeWithRightSidebarsIcon", () => $b7447e00723555ec$export$36efe6f2091df089);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $8Aopl = parcelRequire("8Aopl");
const $b7447e00723555ec$export$36efe6f2091df089 = (props)=>{
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Aopl))), {
        ...props
    });
};

});
parcelRegister("8Aopl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20762fd7ff8385df45415d0e63afaff2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $64049e6c20b7fda8$var$_react = $64049e6c20b7fda8$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $64049e6c20b7fda8$var$_iconNew = $64049e6c20b7fda8$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $64049e6c20b7fda8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutThreeColumnsSidebarsRight".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/layout-three-columns-sidebars-right
 * Usage guidance:
 * Reserved for 3 column layout with 2 sidebars on right option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $64049e6c20b7fda8$var$LayoutThreeColumnsSidebarsRightIcon = (props)=>/*#__PURE__*/ $64049e6c20b7fda8$var$_react.default.createElement($64049e6c20b7fda8$var$_iconNew.default, Object.assign({
        name: "LayoutThreeColumnsSidebarsRightIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 2.375C0 1.615.616 1 1.375 1h3.25C5.385 1 6 1.616 6 2.375v11.25C6 14.385 5.384 15 4.625 15h-3.25C.615 15 0 14.384 0 13.625zm1.5.125v11h3v-11zm6-.125C7.5 1.615 8.116 1 8.875 1h.75C10.385 1 11 1.616 11 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM9 2.5v11h.5v-11zm3.5-.125c0-.76.616-1.375 1.375-1.375h.75C15.385 1 16 1.616 16 2.375v11.25c0 .76-.616 1.375-1.375 1.375h-.75c-.76 0-1.375-.616-1.375-1.375zM14 2.5v11h.5v-11z" clip-rule="evenodd"/>`
    }, props));
$64049e6c20b7fda8$var$LayoutThreeColumnsSidebarsRightIcon.displayName = 'LayoutThreeColumnsSidebarsRightIcon';
var $64049e6c20b7fda8$var$_default = module.exports.default = $64049e6c20b7fda8$var$LayoutThreeColumnsSidebarsRightIcon;

});




parcelRegister("aTtZB", function(module, exports) {
$parcel$export(module.exports, "mediaInsertPlugin", () => $57e561be1d684ee6$export$922c51f87f6fe974);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $7vlqQ = parcelRequire("7vlqQ");

var $8cRGu = parcelRequire("8cRGu");

var $cT0LQ = parcelRequire("cT0LQ");

var $bcN2K = parcelRequire("bcN2K");

var $5leCE = parcelRequire("5leCE");

var $c9uaU = parcelRequire("c9uaU");

var $dU4Pz = parcelRequire("dU4Pz");

var $fnh9N = parcelRequire("fnh9N");

var $gintA = parcelRequire("gintA");
const $57e561be1d684ee6$var$getInitialMediaInsertTab = (registeredTabs, isOnlyExternalLinks)=>{
    const initialBuiltInTab = isOnlyExternalLinks ? (0, $3LeME.MEDIA_INSERT_TAB).LINK : (0, $3LeME.MEDIA_INSERT_TAB).UPLOAD;
    const initialBuiltInRank = isOnlyExternalLinks ? (0, $8cRGu.MEDIA_INSERT_TAB_RANK)[(0, $3LeME.MEDIA_INSERT_TAB).LINK] : (0, $8cRGu.MEDIA_INSERT_TAB_RANK)[(0, $3LeME.MEDIA_INSERT_TAB).UPLOAD];
    const firstRegisteredTab = registeredTabs.reduce((firstTab, tab)=>!firstTab || (tab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK)) < (firstTab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK)) ? tab : firstTab, undefined);
    if (firstRegisteredTab && (firstRegisteredTab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK)) < initialBuiltInRank) return firstRegisteredTab.key;
    return initialBuiltInTab;
};
/**
 * Per-editor-instance registry of insert tabs registered via
 * `actions.registerInsertTab(...)`. Idempotent on `key` so that re-registering
 * the same tab (e.g. on plugin re-init in dev / StrictMode) replaces rather
 * than duplicates.
 */ const $57e561be1d684ee6$var$createInsertTabRegistry = ()=>{
    const tabs = [];
    return {
        register: (tab)=>{
            const existingIndex = tabs.findIndex((t)=>t.key === tab.key);
            if (existingIndex >= 0) tabs[existingIndex] = tab;
            else tabs.push(tab);
        },
        getAll: ()=>tabs
    };
};
const $57e561be1d684ee6$export$922c51f87f6fe974 = ({ api: api, config: config })=>{
    const insertTabRegistry = $57e561be1d684ee6$var$createInsertTabRegistry();
    const isRegisteredSlashCommandEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $gintA.getMediaInsertQuickInsertComponents)({
            api: api,
            config: config
        }));
    }
    return {
        name: 'mediaInsert',
        pmPlugins () {
            return [
                {
                    name: 'mediaInsert',
                    plugin: ()=>(0, $c9uaU.createPlugin)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isOpen: false
            };
            const { isOpen: isOpen, mountInfo: mountInfo } = (0, $dU4Pz.pluginKey).getState(editorState) || {};
            return {
                isOpen: isOpen,
                mountInfo: mountInfo
            };
        },
        commands: {
            showMediaInsertPopup: (mountInfo)=>({ tr: tr })=>(0, $5leCE.showMediaInsertPopup)(tr, mountInfo)
        },
        actions: {
            registerInsertTab: (tab)=>insertTabRegistry.register(tab),
            getInsertTabs: ()=>insertTabRegistry.getAll()
        },
        contentComponent: ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
            if (!editorView) return null;
            const insertMediaSingle = ({ mediaState: mediaState, inputMethod: inputMethod })=>{
                const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName, collection: collection } = mediaState;
                const { width: width, height: height } = dimensions || {
                    height: undefined,
                    width: undefined
                };
                const scaledWidth = width && Math.round(width / scaleFactor);
                const node = editorView.state.schema.nodes.media.create({
                    id: id,
                    type: 'file',
                    collection: collection,
                    contextId: contextId,
                    width: scaledWidth,
                    height: height && Math.round(height / scaleFactor),
                    alt: fileName,
                    __fileMimeType: mediaState.fileMimeType
                });
                return (api === null || api === void 0 ? void 0 : api.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, (0, $3LeME.INSERT_MEDIA_VIA).EXTERNAL_UPLOAD)) ?? false;
            };
            const insertExternalMediaSingle = ({ url: url, alt: alt, inputMethod: inputMethod })=>{
                const node = editorView.state.schema.nodes.media.create({
                    type: 'external',
                    url: url,
                    alt: alt,
                    __external: true
                });
                return (api === null || api === void 0 ? void 0 : api.media.actions.insertMediaAsMediaSingle(editorView, node, inputMethod, (0, $3LeME.INSERT_MEDIA_VIA).EXTERNAL_URL)) ?? false;
            };
            const insertFile = ({ mediaState: mediaState, inputMethod: inputMethod, onMediaStateChanged: onMediaStateChanged })=>{
                var _api$media$sharedStat;
                const collection = mediaState.collection;
                return collection !== undefined ? (api === null || api === void 0 || (_api$media$sharedStat = api.media.sharedState.currentState()) === null || _api$media$sharedStat === void 0 ? void 0 : _api$media$sharedStat.insertFile(mediaState, onMediaStateChanged, inputMethod, (0, $3LeME.INSERT_MEDIA_VIA).LOCAL_UPLOAD)) ?? false : false;
            };
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fnh9N.MediaInsertPicker), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                closeMediaInsertPicker: ()=>editorView.dispatch((0, $5leCE.closeMediaInsertPicker)(editorView.state.tr)),
                insertMediaSingle: insertMediaSingle,
                insertExternalMediaSingle: insertExternalMediaSingle,
                insertFile: insertFile,
                isOnlyExternalLinks: config === null || config === void 0 ? void 0 : config.isOnlyExternalLinks,
                customizedUrlValidation: config === null || config === void 0 ? void 0 : config.customizedUrlValidation,
                customizedHelperMessage: config === null || config === void 0 ? void 0 : config.customizedHelperMessage
            });
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'media-insert',
                        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconImages), {}),
                        isDisabledOffline: true,
                        action (insert) {
                            var _api$analytics;
                            // Insert empty string to remove the typeahead raw text
                            // close the quick insert immediately
                            const tr = insert('');
                            api === null || api === void 0 || api.mediaInsert.commands.showMediaInsertPopup()({
                                tr: tr
                            });
                            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
                                action: (0, $3LeME.ACTION).OPENED,
                                actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
                                attributes: {
                                    inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT,
                                    openedTab: $57e561be1d684ee6$var$getInitialMediaInsertTab(insertTabRegistry.getAll(), config === null || config === void 0 ? void 0 : config.isOnlyExternalLinks)
                                },
                                eventType: (0, $3LeME.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("8cRGu", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MEDIA_INSERT_TAB_RANK", () => $5ceb174b37387e31$export$13d374d75602a37);
$parcel$export(module.exports, "MEDIA_INSERT_TAB_RANK", () => $5ceb174b37387e31$export$927178b3f8e1674);

var $3LeME = parcelRequire("3LeME");
const $5ceb174b37387e31$export$13d374d75602a37 = 0;
const $5ceb174b37387e31$export$927178b3f8e1674 = {
    [(0, $3LeME.MEDIA_INSERT_TAB).UPLOAD]: 100,
    [(0, $3LeME.MEDIA_INSERT_TAB).LINK]: 200,
    [(0, $3LeME.MEDIA_INSERT_TAB).CREATE]: 300
};

});

parcelRegister("5leCE", function(module, exports) {
$parcel$export(module.exports, "ACTION_OPEN_POPUP", () => $6ac2ca2ca6af592c$export$f766031ad28e12e3);
$parcel$export(module.exports, "ACTION_CLOSE_POPUP", () => $6ac2ca2ca6af592c$export$1be3e111c71a5c61);
$parcel$export(module.exports, "showMediaInsertPopup", () => $6ac2ca2ca6af592c$export$3e81af3e1bf8bdd1);
$parcel$export(module.exports, "closeMediaInsertPicker", () => $6ac2ca2ca6af592c$export$e89adf8af9d31a9f);

var $dU4Pz = parcelRequire("dU4Pz");
const $6ac2ca2ca6af592c$export$f766031ad28e12e3 = 'OPEN_POPUP';
const $6ac2ca2ca6af592c$export$1be3e111c71a5c61 = 'CLOSE_POPUP';
const $6ac2ca2ca6af592c$var$setPopupMeta = ({ type: type, tr: tr, mountInfo: mountInfo })=>tr.setMeta((0, $dU4Pz.pluginKey), {
        type: type,
        mountInfo: mountInfo
    });
const $6ac2ca2ca6af592c$export$3e81af3e1bf8bdd1 = (tr, mountInfo)=>{
    return $6ac2ca2ca6af592c$var$setPopupMeta({
        type: $6ac2ca2ca6af592c$export$f766031ad28e12e3,
        mountInfo: mountInfo,
        tr: tr
    });
};
const $6ac2ca2ca6af592c$export$e89adf8af9d31a9f = (tr)=>{
    return $6ac2ca2ca6af592c$var$setPopupMeta({
        type: $6ac2ca2ca6af592c$export$1be3e111c71a5c61,
        tr: tr
    });
};

});
parcelRegister("dU4Pz", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $a708d6041dc95710$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $a708d6041dc95710$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('mediaInsertPlugin');

});


parcelRegister("c9uaU", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $4ee37322eb083b34$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $5leCE = parcelRequire("5leCE");

var $dU4Pz = parcelRequire("dU4Pz");
const $4ee37322eb083b34$export$ae829ec7b2625219 = ()=>{
    return new (0, $1y7gE.SafePlugin)({
        state: {
            init () {
                return {
                    isOpen: false,
                    mountInfo: undefined
                };
            },
            apply (tr, mediaInsertPluginState) {
                const meta = tr.getMeta((0, $dU4Pz.pluginKey));
                switch(meta === null || meta === void 0 ? void 0 : meta.type){
                    case 0, $5leCE.ACTION_OPEN_POPUP:
                        return {
                            isOpen: true,
                            mountInfo: meta.mountInfo
                        };
                    case 0, $5leCE.ACTION_CLOSE_POPUP:
                        return {
                            isOpen: false
                        };
                    default:
                        return mediaInsertPluginState;
                }
            }
        },
        key: (0, $dU4Pz.pluginKey)
    });
};

});

parcelRegister("fnh9N", function(module, exports) {
$parcel$export(module.exports, "MediaInsertPicker", () => $94df4ceb77d52309$export$6a978a6c0eb24e84);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $jmJEY = parcelRequire("jmJEY");

var $8cRGu = parcelRequire("8cRGu");

var $9WMKr = parcelRequire("9WMKr");

var $dXHAJ = parcelRequire("dXHAJ");

var $bgJhV = parcelRequire("bgJhV");

var $9oAqi = parcelRequire("9oAqi");

var $1SSHL = parcelRequire("1SSHL");

var $014x6 = parcelRequire("014x6");

var $dBtOK = parcelRequire("dBtOK");

var $ipCDL = parcelRequire("ipCDL");

var $k8Adr = parcelRequire("k8Adr");

var $kleHf = parcelRequire("kleHf");

var $8c1Xm = parcelRequire("8c1Xm");

var $aje6x = parcelRequire("aje6x");

var $6wtC0 = parcelRequire("6wtC0");

var $3NBIB = parcelRequire("3NBIB");

var $lJz52 = parcelRequire("lJz52");

var $kDy0A = parcelRequire("kDy0A");

var $kA50k = parcelRequire("kA50k");

var $8ZksJ = parcelRequire("8ZksJ");

var $4HYvY = parcelRequire("4HYvY");
const $94df4ceb77d52309$var$PopupWithListeners = (0, $1SSHL.default)((0, $dXHAJ.default));
const $94df4ceb77d52309$var$MEDIA_INSERT_PICKER_ANALYTICS_SOURCE = 'MediaInsertPicker';
const $94df4ceb77d52309$var$EMPTY_REGISTERED_TABS = [];
const $94df4ceb77d52309$var$getMediaInsertPickerTabSource = (selectedTab)=>`${$94df4ceb77d52309$var$MEDIA_INSERT_PICKER_ANALYTICS_SOURCE} - ${selectedTab}`;
const $94df4ceb77d52309$var$getNextTabIndexForKey = (currentTabIndex, tabCount, key)=>{
    if (key === 'Home') return 0;
    if (key === 'End') return tabCount - 1;
    if (key === 'ArrowRight') return currentTabIndex === tabCount - 1 ? 0 : currentTabIndex + 1;
    if (key === 'ArrowLeft') return currentTabIndex === 0 ? tabCount - 1 : currentTabIndex - 1;
    return undefined;
};
const $94df4ceb77d52309$var$TabWithAnalytics = ({ children: children, onSelectTabForAnalytics: onSelectTabForAnalytics, selectedTabIndex: selectedTabIndex, tabCount: tabCount })=>{
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $aje6x.default)();
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        onSelectTabForAnalytics(selectedTabIndex);
        onClick();
    }, [
        onClick,
        onSelectTabForAnalytics,
        selectedTabIndex
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        const nextTabIndex = $94df4ceb77d52309$var$getNextTabIndexForKey(selectedTabIndex, tabCount, event.key);
        if (nextTabIndex !== undefined) onSelectTabForAnalytics(nextTabIndex);
        onKeyDown(event);
    }, [
        onKeyDown,
        onSelectTabForAnalytics,
        selectedTabIndex,
        tabCount
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ipCDL.Focusable), {
        as: "div",
        isInset: true,
        onClick: handleClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: handleKeyDown,
        role: role,
        tabIndex: tabIndex,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            weight: "medium",
            color: "inherit",
            maxLines: 1,
            children: children
        })
    });
};
/**
 * A custom TabPanel that is non-focusable.
 */ const $94df4ceb77d52309$var$CustomTabPanel = ({ children: children, disablePaddingBlockEnd: disablePaddingBlockEnd = false })=>{
    const tabPanelAttributes = (0, $6wtC0.default)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        paddingBlockEnd: disablePaddingBlockEnd ? 'space.0' : 'space.150',
        ...tabPanelAttributes,
        tabIndex: -1,
        children: children
    });
};
const $94df4ceb77d52309$export$6a978a6c0eb24e84 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, closeMediaInsertPicker: closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, insertFile: insertFile, isOnlyExternalLinks: isOnlyExternalLinks = false, customizedUrlValidation: customizedUrlValidation, customizedHelperMessage: customizedHelperMessage })=>{
    var _api$mediaInsert, _api$mediaInsert$getI;
    // Tabs registered by other plugins via `api.mediaInsert.actions.registerInsertTab(...)`.
    // Read once per render; the registry is mutated only at plugin setup time so this is stable
    // for the lifetime of an editor instance.
    const registeredTabs = (api === null || api === void 0 || (_api$mediaInsert = api.mediaInsert) === null || _api$mediaInsert === void 0 || (_api$mediaInsert = _api$mediaInsert.actions) === null || _api$mediaInsert === void 0 || (_api$mediaInsert$getI = _api$mediaInsert.getInsertTabs) === null || _api$mediaInsert$getI === void 0 ? void 0 : _api$mediaInsert$getI.call(_api$mediaInsert)) ?? $94df4ceb77d52309$var$EMPTY_REGISTERED_TABS;
    const { mediaProvider: mediaProvider, isOpen: isOpen, mountInfo: mountInfo } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'media',
        'mediaInsert'
    ], (states)=>{
        var _states$mediaState, _states$mediaInsertSt, _states$mediaInsertSt2;
        return {
            mediaProvider: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaProvider,
            isOpen: (_states$mediaInsertSt = states.mediaInsertState) === null || _states$mediaInsertSt === void 0 ? void 0 : _states$mediaInsertSt.isOpen,
            mountInfo: (_states$mediaInsertSt2 = states.mediaInsertState) === null || _states$mediaInsertSt2 === void 0 ? void 0 : _states$mediaInsertSt2.mountInfo
        };
    });
    let targetRef;
    let mountPoint;
    if (mountInfo) {
        targetRef = mountInfo.ref;
        mountPoint = mountInfo.mountPoint;
    } else {
        var _api$analytics;
        // If targetRef is undefined, target the selection in the editor
        targetRef = (0, $jmJEY.getDomRefFromSelection)(editorView, (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
        mountPoint = popupsMountPoint;
    }
    const focusButton = (0, $lJz52.useFocus)({
        target: targetRef ?? editorView
    });
    const focusEditor = (0, $lJz52.useFocus)({
        target: editorView
    });
    // returnFocusRef stores which function we call on unmount: focusButton | focusEditor
    // Needs to be a ref so we can instantly toggle it before unmounting triggers the focus trap
    const returnFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(focusEditor);
    // When inserting media, close picker and focus editor.
    const closeAndFocusEditor = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        returnFocusRef.current = focusEditor;
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        focusEditor
    ]);
    // When cancelling, close picker and return focus to button.
    const closeAndReturnFocusToButton = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        returnFocusRef.current = focusButton;
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        focusButton
    ]);
    // Return focus on unmount to whichever element `returnFocusRef` currently points at.
    const returnFocusOnUnmount = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        returnFocusRef.current();
    }, []);
    const intl = (0, $gpjDl.default)();
    const { autofocusRef: autofocusRef, onPositionCalculated: onPositionCalculated } = (0, $kDy0A.useUnholyAutofocus)();
    const orderedTabs = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        const tabs = [];
        let tieBreaker = 0;
        if (!isOnlyExternalLinks) tabs.push({
            key: (0, $3LeME.MEDIA_INSERT_TAB).UPLOAD,
            rank: (0, $8cRGu.MEDIA_INSERT_TAB_RANK)[(0, $3LeME.MEDIA_INSERT_TAB).UPLOAD],
            tieBreaker: tieBreaker++,
            type: 'upload'
        });
        tabs.push({
            key: (0, $3LeME.MEDIA_INSERT_TAB).LINK,
            rank: (0, $8cRGu.MEDIA_INSERT_TAB_RANK)[(0, $3LeME.MEDIA_INSERT_TAB).LINK],
            tieBreaker: tieBreaker++,
            type: 'link'
        });
        registeredTabs.forEach((registeredTab)=>{
            tabs.push({
                key: registeredTab.key,
                rank: registeredTab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK),
                registeredTab: registeredTab,
                tieBreaker: tieBreaker++,
                type: 'registered'
            });
        });
        return tabs.sort((a, b)=>a.rank - b.rank || a.tieBreaker - b.tieBreaker);
    }, [
        isOnlyExternalLinks,
        registeredTabs
    ]);
    const tabCount = orderedTabs.length;
    const getTabAnalyticsMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((selectedTabIndex)=>{
        const selectedTab = orderedTabs[selectedTabIndex];
        if (selectedTab) return {
            selectedTab: selectedTab.key,
            selectedTabIndex: selectedTabIndex
        };
        return {
            selectedTab: 'unknown',
            selectedTabIndex: selectedTabIndex
        };
    }, [
        orderedTabs
    ]);
    const selectedTabAnalyticsMetadataRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(getTabAnalyticsMetadata(0));
    const tabsAnalyticsContext = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>({
            get source () {
                return $94df4ceb77d52309$var$getMediaInsertPickerTabSource(selectedTabAnalyticsMetadataRef.current.selectedTab);
            }
        }), []);
    const setSelectedTabAnalyticsMetadata = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((selectedTabIndex)=>{
        selectedTabAnalyticsMetadataRef.current = getTabAnalyticsMetadata(selectedTabIndex);
    }, [
        getTabAnalyticsMetadata
    ]);
    const hasDispatchedInitialTabViewedEventRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    // Atlaskit Tabs only calls `onChange` after the user changes tabs, so the
    // initially opened tab needs its viewed analytics event dispatched from an
    // effect. The ref keeps this to once per picker open without setting state.
    (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useEffect(()=>{
        if (!isOpen) {
            hasDispatchedInitialTabViewedEventRef.current = false;
            return;
        }
        if (!mediaProvider || !dispatchAnalyticsEvent || hasDispatchedInitialTabViewedEventRef.current) return;
        const selectedTabMetadata = getTabAnalyticsMetadata(0);
        selectedTabAnalyticsMetadataRef.current = selectedTabMetadata;
        const payload = {
            action: (0, $3LeME.ACTION).VIEWED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
            eventType: (0, $3LeME.EVENT_TYPE).UI,
            attributes: {
                selectedTab: selectedTabMetadata.selectedTab,
                selectedTabIndex: selectedTabMetadata.selectedTabIndex
            }
        };
        dispatchAnalyticsEvent(payload);
        hasDispatchedInitialTabViewedEventRef.current = true;
    }, [
        dispatchAnalyticsEvent,
        getTabAnalyticsMetadata,
        isOpen,
        mediaProvider
    ]);
    const handleTabChange = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((selectedTabIndex, analyticsEvent)=>{
        const selectedTabMetadata = getTabAnalyticsMetadata(selectedTabIndex);
        selectedTabAnalyticsMetadataRef.current = selectedTabMetadata;
        analyticsEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    selectedTab: selectedTabMetadata.selectedTab,
                    selectedTabIndex: selectedTabIndex
                }
            })).fire();
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $3LeME.ACTION).VIEWED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $3LeME.EVENT_TYPE).UI,
                attributes: {
                    selectedTab: selectedTabMetadata.selectedTab,
                    selectedTabIndex: selectedTabIndex
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }, [
        dispatchAnalyticsEvent,
        getTabAnalyticsMetadata
    ]);
    if (!isOpen || !mediaProvider) return null;
    const handleClose = (exitMethod)=>(event)=>{
            // Same as AIImageGenerationPopup: react-select can detach the option
            // before `click` fires, so withOuterListeners treats it as outside.
            if (exitMethod === (0, $3LeME.INPUT_METHOD).MOUSE && event.target instanceof Node && !event.target.isConnected) return;
            event.preventDefault();
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $3LeME.ACTION).CLOSED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $3LeME.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: exitMethod
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            closeAndReturnFocusToButton();
        };
    const fileTabTitle = (0, $3NBIB.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? intl.formatMessage((0, $9WMKr.mediaInsertMessages).uploadTabTitle) : intl.formatMessage((0, $9WMKr.mediaInsertMessages).fileTabTitle);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($94df4ceb77d52309$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage((0, $9WMKr.mediaInsertMessages).mediaPickerPopupAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        target: targetRef,
        zIndex: (0, $014x6.akEditorFloatingDialogZIndex),
        fitHeight: 390,
        fitWidth: 340,
        mountTo: mountPoint,
        onUnmount: returnFocusOnUnmount,
        boundariesElement: popupsBoundariesElement,
        handleClickOutside: handleClose((0, $3LeME.INPUT_METHOD).MOUSE),
        handleEscapeKeydown: handleClose((0, $3LeME.INPUT_METHOD).KEYBOARD),
        scrollableElement: popupsScrollableElement,
        preventOverflow: true,
        onPositionCalculated: onPositionCalculated,
        focusTrap: true,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bgJhV.PlainOutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $4HYvY.MediaInsertWrapper), {
                    ref: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $8c1Xm.default), {
                        id: "media-insert-tab-navigation",
                        analyticsContext: tabsAnalyticsContext,
                        onChange: handleTabChange,
                        children: [
                            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                                paddingBlockEnd: "space.150",
                                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kleHf.default), {
                                    children: orderedTabs.map((tab, index)=>/*#__PURE__*/ (0, $3LM7S.jsx)($94df4ceb77d52309$var$TabWithAnalytics, {
                                            onSelectTabForAnalytics: setSelectedTabAnalyticsMetadata,
                                            selectedTabIndex: index,
                                            tabCount: tabCount,
                                            children: tab.type === 'registered' ? tab.registeredTab.label : tab.type === 'upload' ? fileTabTitle : intl.formatMessage((0, $9WMKr.mediaInsertMessages).linkTabTitle)
                                        }, tab.key))
                                })
                            }),
                            orderedTabs.map((tab)=>{
                                if (tab.type === 'registered') {
                                    const TabComponent = tab.registeredTab.component;
                                    return /*#__PURE__*/ (0, $3LM7S.jsx)($94df4ceb77d52309$var$CustomTabPanel, {
                                        disablePaddingBlockEnd: true,
                                        children: /*#__PURE__*/ (0, $3LM7S.jsx)(TabComponent, {
                                            closeMediaInsertPicker: closeAndFocusEditor,
                                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                            insertMediaSingle: insertMediaSingle,
                                            mediaProvider: mediaProvider
                                        })
                                    }, tab.key);
                                }
                                if (tab.type === 'upload') return /*#__PURE__*/ (0, $3LM7S.jsx)($94df4ceb77d52309$var$CustomTabPanel, {
                                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kA50k.LocalMedia), {
                                        ref: autofocusRef,
                                        mediaProvider: mediaProvider,
                                        closeMediaInsertPicker: closeAndFocusEditor,
                                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                        insertFile: insertFile
                                    })
                                }, tab.key);
                                return /*#__PURE__*/ (0, $3LM7S.jsx)($94df4ceb77d52309$var$CustomTabPanel, {
                                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8ZksJ.MediaFromURL), {
                                        mediaProvider: mediaProvider,
                                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                        closeMediaInsertPicker: closeAndFocusEditor,
                                        cancelMediaInsertPicker: closeAndReturnFocusToButton,
                                        insertMediaSingle: insertMediaSingle,
                                        insertExternalMediaSingle: insertExternalMediaSingle,
                                        isOnlyExternalLinks: isOnlyExternalLinks,
                                        customizedUrlValidation: customizedUrlValidation,
                                        customizedHelperMessage: customizedHelperMessage
                                    })
                                }, tab.key);
                            })
                        ]
                    })
                })
        })
    });
};

});
parcelRegister("lJz52", function(module, exports) {
$parcel$export(module.exports, "useFocus", () => $d3844751569359a1$export$f8168d8dd8fd66e6);

var $fc4bM = parcelRequire("fc4bM");
const $d3844751569359a1$export$f8168d8dd8fd66e6 = ({ target: target })=>{
    const focus = (0, $fc4bM.useCallback)(()=>{
        // Use setTimeout to run this async after any DOM updates in same callback
        setTimeout(()=>target.focus(), 0);
    }, [
        target
    ]);
    return focus;
};

});

parcelRegister("kDy0A", function(module, exports) {
$parcel$export(module.exports, "useUnholyAutofocus", () => $9339c5bc7dd2e53a$export$51343998e6e270fe);

var $fc4bM = parcelRequire("fc4bM");
const $9339c5bc7dd2e53a$export$51343998e6e270fe = ()=>{
    const autofocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const positionRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((position)=>{
        if (positionRef.current === null) // Initial position is _always incorrect, so the first time this is set
        // we're going to ignore it.
        positionRef.current = position;
        else if (positionRef.current !== position) {
            var _autofocusRef$current;
            // If it isn't the first position and it has changed, we're likely in
            // the actual position we want. We'll call focus and update the position.
            (_autofocusRef$current = autofocusRef.current) === null || _autofocusRef$current === void 0 || _autofocusRef$current.focus();
            positionRef.current = position;
        }
        // Important to return this as the popup uses the returned position
        return position;
    }, [
        autofocusRef
    ]);
    /**
   * If we don't clear the ref, then reopening the media picker will
   * not correctly focus the button.
   *
   * WARNING: If the component re-renders the ref will be cleared and
   * the button will be focused again.
   *
   * This is a trade-off, we prefer that the button is correctly focused
   * if the media picker is re-opened, rather than re-focusing the button
   * if the component re-renders/ the browser window is resized.
   *
   * This is a temporary solution until we can find a better way to do it.
   */ (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            positionRef.current = null;
        };
    });
    return {
        autofocusRef: autofocusRef,
        onPositionCalculated: onPositionCalculated
    };
};

});

parcelRegister("kA50k", function(module, exports) {
$parcel$export(module.exports, "LocalMedia", () => $f0f16290b6eaa605$export$72542eb1d24a31e0);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $5dzEI = parcelRequire("5dzEI");

var $3LeME = parcelRequire("3LeME");

var $9WMKr = parcelRequire("9WMKr");

var $8jQcJ = parcelRequire("8jQcJ");

var $7VjhB = parcelRequire("7VjhB");

var $cJzRi = parcelRequire("cJzRi");

var $dtvmL = parcelRequire("dtvmL");

var $3NBIB = parcelRequire("3NBIB");

var $1mXXs = parcelRequire("1mXXs");
const $f0f16290b6eaa605$var$INITIAL_UPLOAD_STATE = Object.freeze({
    isOpen: false,
    error: null
});
const $f0f16290b6eaa605$var$uploadReducer = (state, action)=>{
    switch(action.type){
        case 'open':
            return {
                ...$f0f16290b6eaa605$var$INITIAL_UPLOAD_STATE,
                isOpen: true
            };
        case 'close':
            // This is the only case where we don't reset state. This is because
            // onClose gets called for cancel _and_ upload, so we don't want to
            // reset any loading or error states that may have occured
            return {
                ...state,
                isOpen: false
            };
        case 'error':
            return {
                ...$f0f16290b6eaa605$var$INITIAL_UPLOAD_STATE,
                error: action.error
            };
        case 'reset':
            return $f0f16290b6eaa605$var$INITIAL_UPLOAD_STATE;
    }
};
const $f0f16290b6eaa605$var$isImagePreview = (preview)=>{
    return 'dimensions' in preview;
};
const $f0f16290b6eaa605$export$72542eb1d24a31e0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, insertFile: insertFile }, ref)=>{
    const intl = (0, $gpjDl.default)();
    const strings = {
        upload: intl.formatMessage((0, $9WMKr.mediaInsertMessages).upload),
        chooseFile: intl.formatMessage((0, $9WMKr.mediaInsertMessages).chooseFile),
        networkError: intl.formatMessage((0, $9WMKr.mediaInsertMessages).localFileNetworkErrorMessage),
        genericError: intl.formatMessage((0, $9WMKr.mediaInsertMessages).localFileErrorMessage)
    };
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $1mXXs.useAnalyticsEvents)(dispatchAnalyticsEvent);
    const [uploadState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useReducer($f0f16290b6eaa605$var$uploadReducer, $f0f16290b6eaa605$var$INITIAL_UPLOAD_STATE);
    const erroredFileIds = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(new Set())[0];
    // This is a bit horrendous. Fundementally though, `insertFile` takes a
    // callback that can ask for us to add listeners to any and all of the
    // `Browser` events for each file uplaoded. We add a track those in a
    // ref, call the CBs so the media-plugin can do it's thing, and then
    // remove all listeners `onEnd`.
    const eventSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef({});
    const onStateChanged = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((fileId)=>(cb)=>{
            var _eventSubscribers$cur;
            eventSubscribers.current = {
                ...eventSubscribers.current,
                [fileId]: [
                    ...((_eventSubscribers$cur = eventSubscribers.current) === null || _eventSubscribers$cur === void 0 ? void 0 : _eventSubscribers$cur[fileId]) ?? [],
                    cb
                ]
            };
        }, []);
    const onPreviewUpdate = ({ file: file, preview: preview })=>{
        var _mediaProvider$upload;
        onUploadSuccessAnalytics('local');
        const isErroredFile = erroredFileIds.has(file.id);
        const { dimensions: dimensions, scaleFactor: scaleFactor } = $f0f16290b6eaa605$var$isImagePreview(preview) ? preview : {
            dimensions: undefined,
            scaleFactor: undefined
        };
        const mediaState = {
            id: file.id,
            collection: (_mediaProvider$upload = mediaProvider.uploadParams) === null || _mediaProvider$upload === void 0 ? void 0 : _mediaProvider$upload.collection,
            fileMimeType: file.type,
            fileSize: file.size,
            fileName: file.name,
            dimensions: dimensions,
            scaleFactor: scaleFactor,
            status: isErroredFile ? 'error' : undefined
        };
        insertFile({
            mediaState: mediaState,
            inputMethod: (0, $3LeME.INPUT_METHOD).MEDIA_PICKER,
            onMediaStateChanged: onStateChanged(file.id)
        });
        closeMediaInsertPicker();
        // Probably not needed but I guess it _could_ fail to close for some reason
        dispatch({
            type: 'reset'
        });
    };
    const { uploadParams: uploadParams, uploadMediaClientConfig: uploadMediaClientConfig } = mediaProvider;
    const onEnd = (0, $fc4bM.useCallback)((payload)=>{
        var _eventSubscribers$cur2, _eventSubscribers$cur3;
        (_eventSubscribers$cur2 = eventSubscribers.current) === null || _eventSubscribers$cur2 === void 0 || (_eventSubscribers$cur2 = _eventSubscribers$cur2[payload.file.id]) === null || _eventSubscribers$cur2 === void 0 || _eventSubscribers$cur2.forEach((cb)=>cb({
                id: payload.file.id,
                status: 'ready'
            }));
        (_eventSubscribers$cur3 = eventSubscribers.current) === null || _eventSubscribers$cur3 === void 0 || delete _eventSubscribers$cur3[payload.file.id];
    }, []);
    const onError = (0, $fc4bM.useCallback)(({ error: error, fileId: fileId })=>{
        var _eventSubscribers$cur4, _eventSubscribers$cur5;
        // Dispatch the error events
        onUploadFailureAnalytics(error.name, 'local');
        dispatch({
            type: 'error',
            error: error.name
        });
        // Update the status of the errored file
        erroredFileIds.add(fileId);
        // Update and remove listeners
        (_eventSubscribers$cur4 = eventSubscribers.current) === null || _eventSubscribers$cur4 === void 0 || (_eventSubscribers$cur4 = _eventSubscribers$cur4[fileId]) === null || _eventSubscribers$cur4 === void 0 || _eventSubscribers$cur4.forEach((cb)=>cb({
                id: fileId,
                status: 'error',
                error: error
            }));
        (_eventSubscribers$cur5 = eventSubscribers.current) === null || _eventSubscribers$cur5 === void 0 || delete _eventSubscribers$cur5[fileId];
    }, [
        erroredFileIds,
        onUploadFailureAnalytics
    ]);
    const buttonText = (0, $3NBIB.expValEqualsNoExposure)('cc_page_experiences_editor_image_generation', 'isEnabled', true) ? strings.chooseFile : strings.upload;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
        grow: "fill",
        space: "space.200",
        children: [
            uploadState.error && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dtvmL.default), {
                appearance: "error",
                children: uploadState.error === 'upload_fail' ? strings.networkError : strings.genericError
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                id: "local-media-upload-button",
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                iconBefore: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8jQcJ))), {
                        label: ""
                    }),
                ref: ref,
                shouldFitContainer: true,
                isDisabled: !uploadMediaClientConfig || !uploadParams,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: ()=>{
                    onUploadButtonClickedAnalytics();
                    dispatch({
                        type: 'open'
                    });
                },
                children: buttonText
            }),
            uploadMediaClientConfig && uploadParams && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7VjhB.BrowserLoader), {
                isOpen: uploadState.isOpen,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                config: {
                    uploadParams: uploadParams,
                    multiple: true
                },
                mediaClientConfig: uploadMediaClientConfig,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onUploadsStart: ()=>onUploadCommencedAnalytics('local'),
                onPreviewUpdate: onPreviewUpdate,
                onEnd: onEnd,
                // NOTE: this will fire for some errors like network failures, but not
                // for others like empty files. Those have their own feedback toast
                // owned by media.
                onError: onError,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClose: ()=>{
                    erroredFileIds.clear();
                    dispatch({
                        type: 'close'
                    });
                }
            })
        ]
    });
});

});
parcelRegister("1mXXs", function(module, exports) {
$parcel$export(module.exports, "useAnalyticsEvents", () => $3afe6c7a7ee3ae9d$export$5bf35293e545f20c);

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");
function $3afe6c7a7ee3ae9d$export$5bf35293e545f20c(dispatchAnalyticsEvent) {
    const onUploadButtonClickedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).CLICKED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $3LeME.EVENT_TYPE).UI
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadCommencedAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).UPLOAD_COMMENCED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadSuccessAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((mediaUploadSource)=>{
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).UPLOAD_SUCCEEDED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    const onUploadFailureAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((reason, mediaUploadSource)=>{
        dispatchAnalyticsEvent === null || dispatchAnalyticsEvent === void 0 || dispatchAnalyticsEvent({
            action: (0, $3LeME.ACTION).UPLOAD_FAILED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).MEDIA,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).UPLOAD_MEDIA,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                reason: reason,
                mediaUploadSource: mediaUploadSource
            }
        });
    }, [
        dispatchAnalyticsEvent
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>({
            onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics,
            onUploadCommencedAnalytics: onUploadCommencedAnalytics,
            onUploadSuccessAnalytics: onUploadSuccessAnalytics,
            onUploadFailureAnalytics: onUploadFailureAnalytics
        }), [
        onUploadButtonClickedAnalytics,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
}

});


parcelRegister("8ZksJ", function(module, exports) {
$parcel$export(module.exports, "MediaFromURL", () => $36fc8882d21f46de$export$903b9b47fa175337);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $9ISAz = parcelRequire("9ISAz");

var $lHYHS = parcelRequire("lHYHS");

var $5dzEI = parcelRequire("5dzEI");

var $3LeME = parcelRequire("3LeME");

var $9WMKr = parcelRequire("9WMKr");

var $2xHR5 = parcelRequire("2xHR5");

var $gPQv9 = parcelRequire("gPQv9");

var $e8E8t = parcelRequire("e8E8t");

var $e2QOk = parcelRequire("e2QOk");

var $ecwhF = parcelRequire("ecwhF");

var $11sVc = parcelRequire("11sVc");

var $5uAqu = parcelRequire("5uAqu");

var $bLScU = parcelRequire("bLScU");

var $5a4EU = parcelRequire("5a4EU");

var $1JdzP = parcelRequire("1JdzP");

var $lgMZ2 = parcelRequire("lgMZ2");

var $7yidP = parcelRequire("7yidP");

var $kig2V = parcelRequire("kig2V");

var $dtvmL = parcelRequire("dtvmL");

var $aEtFp = parcelRequire("aEtFp");

var $hVfvc = parcelRequire("hVfvc");

var $1mXXs = parcelRequire("1mXXs");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $36fc8882d21f46de$var$WHITESPACE_REGEX = /\s/;
const $36fc8882d21f46de$var$PreviewBoxStyles = (0, $kig2V.xcss)({
    borderWidth: 'border.width',
    borderStyle: 'dashed',
    borderColor: 'color.border',
    borderRadius: 'radius.small',
    height: '200px'
});
const $36fc8882d21f46de$var$PreviewImageStyles = (0, $kig2V.xcss)({
    height: '200px'
});
const $36fc8882d21f46de$var$FormStyles = (0, $kig2V.xcss)({
    flexGrow: 1
});
const $36fc8882d21f46de$var$INITIAL_PREVIEW_STATE = Object.freeze({
    isLoading: false,
    error: null,
    warning: null,
    previewInfo: null
});
const $36fc8882d21f46de$var$isValidInput = (value, customizedUrlValidation)=>{
    if (customizedUrlValidation) return customizedUrlValidation(value);
    return $36fc8882d21f46de$export$bef94a5618bf18bf(value);
};
const $36fc8882d21f46de$var$MAX_URL_LENGTH = 2048;
const $36fc8882d21f46de$export$bef94a5618bf18bf = (value)=>{
    try {
        // Check for spaces and length first to avoid the expensive URL parsing
        if ($36fc8882d21f46de$var$WHITESPACE_REGEX.test(value) || value.length > $36fc8882d21f46de$var$MAX_URL_LENGTH) return false;
        new URL(value);
    } catch  {
        return false;
    }
    return (0, $9ISAz.isSafeUrl)(value);
};
const $36fc8882d21f46de$var$previewStateReducer = (state, action)=>{
    switch(action.type){
        case 'loading':
            return {
                ...$36fc8882d21f46de$var$INITIAL_PREVIEW_STATE,
                isLoading: true
            };
        case 'error':
            return {
                ...$36fc8882d21f46de$var$INITIAL_PREVIEW_STATE,
                error: action.error
            };
        case 'warning':
            return {
                ...$36fc8882d21f46de$var$INITIAL_PREVIEW_STATE,
                warning: action.warning
            };
        case 'success':
            return {
                ...$36fc8882d21f46de$var$INITIAL_PREVIEW_STATE,
                previewInfo: action.payload
            };
        case 'reset':
            return $36fc8882d21f46de$var$INITIAL_PREVIEW_STATE;
        default:
            return state;
    }
};
function $36fc8882d21f46de$export$903b9b47fa175337({ mediaProvider: mediaProvider, dispatchAnalyticsEvent: dispatchAnalyticsEvent, closeMediaInsertPicker: closeMediaInsertPicker, cancelMediaInsertPicker: cancelMediaInsertPicker = closeMediaInsertPicker, insertMediaSingle: insertMediaSingle, insertExternalMediaSingle: insertExternalMediaSingle, isOnlyExternalLinks: isOnlyExternalLinks, customizedUrlValidation: customizedUrlValidation, customizedHelperMessage: customizedHelperMessage }) {
    const intl = (0, $gpjDl.default)();
    const strings = {
        loadPreview: intl.formatMessage((0, $9WMKr.mediaInsertMessages).loadPreview),
        insert: intl.formatMessage((0, $9WMKr.mediaInsertMessages).insert),
        pasteLinkToUpload: intl.formatMessage((0, $9WMKr.mediaInsertMessages).pasteLinkToUpload),
        cancel: intl.formatMessage((0, $9WMKr.mediaInsertMessages).cancel),
        errorMessage: intl.formatMessage((0, $9WMKr.mediaInsertMessages).fromUrlErrorMessage),
        warning: intl.formatMessage((0, $9WMKr.mediaInsertMessages).fromUrlWarning),
        invalidUrl: intl.formatMessage((0, $9WMKr.mediaInsertMessages).invalidUrlErrorMessage)
    };
    const [previewState, dispatch] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useReducer($36fc8882d21f46de$var$previewStateReducer, $36fc8882d21f46de$var$INITIAL_PREVIEW_STATE);
    const [input, setInput] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState('');
    const pasteFlag = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(false);
    const { onUploadButtonClickedAnalytics: onUploadButtonClickedAnalytics, onUploadCommencedAnalytics: onUploadCommencedAnalytics, onUploadSuccessAnalytics: onUploadSuccessAnalytics, onUploadFailureAnalytics: onUploadFailureAnalytics } = (0, $1mXXs.useAnalyticsEvents)(dispatchAnalyticsEvent);
    const uploadExternalMedia = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(async (url)=>{
        onUploadButtonClickedAnalytics();
        dispatch({
            type: 'loading'
        });
        const { uploadMediaClientConfig: uploadMediaClientConfig, uploadParams: uploadParams } = mediaProvider;
        if (!uploadMediaClientConfig) return;
        const mediaClient = (0, $bLScU.getMediaClient)(uploadMediaClientConfig);
        const collection = uploadParams === null || uploadParams === void 0 ? void 0 : uploadParams.collection;
        onUploadCommencedAnalytics('url');
        try {
            const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions, mimeType: mimeType } = await mediaClient.file.uploadExternal(url, collection);
            onUploadSuccessAnalytics('url');
            dispatch({
                type: 'success',
                payload: {
                    id: uploadableFileUpfrontIds.id,
                    collection: collection,
                    dimensions: dimensions,
                    occurrenceKey: uploadableFileUpfrontIds.occurrenceKey,
                    fileMimeType: mimeType
                }
            });
        } catch (e) {
            // eslint-disable-line no-unused-vars
            if (typeof e === 'string' && e === 'Could not download remote file') {
                // TODO: ED-26962 - Make sure this gets good unit test coverage with the actual media plugin.
                // This hard coded error message could be changed at any
                // point and we need a unit test to break to stop people changing it.
                onUploadFailureAnalytics(e, 'url');
                dispatch({
                    type: 'warning',
                    warning: e,
                    url: url
                });
            } else if (e instanceof Error) {
                const message = 'Image preview fetch failed';
                onUploadFailureAnalytics(message, 'url');
                dispatch({
                    type: 'error',
                    error: message
                });
            } else {
                onUploadFailureAnalytics('Unknown error', 'url');
                dispatch({
                    type: 'error',
                    error: 'Unknown error'
                });
            }
        }
    }, [
        onUploadButtonClickedAnalytics,
        mediaProvider,
        onUploadCommencedAnalytics,
        onUploadSuccessAnalytics,
        onUploadFailureAnalytics
    ]);
    const onURLChange = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((e)=>{
        const url = e.currentTarget.value;
        dispatch({
            type: 'reset'
        });
        setInput(url);
        if (!$36fc8882d21f46de$var$isValidInput(url, customizedUrlValidation)) return;
        if (pasteFlag.current) {
            pasteFlag.current = false;
            if (!isOnlyExternalLinks) uploadExternalMedia(url);
        }
    }, [
        uploadExternalMedia,
        isOnlyExternalLinks,
        customizedUrlValidation
    ]);
    const onPaste = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((e, inputUrl)=>{
        // Note: this is a little weird, but the paste event will always be
        // fired before the change event when pasting. We don't really want to
        // duplicate logic by handling pastes separately to changes, so we're
        // just noting paste occurred to then be handled in the onURLChange fn
        // above. The one exception to this is where paste inputs exactly what was
        // already in the input, in which case we want to ignore it.
        if (e.clipboardData.getData('text') !== inputUrl) pasteFlag.current = true;
    }, []);
    const onInsert = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        if (previewState.previewInfo) insertMediaSingle({
            mediaState: previewState.previewInfo,
            inputMethod: (0, $3LeME.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertMediaSingle,
        previewState.previewInfo
    ]);
    const onExternalInsert = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((url)=>{
        if (previewState.warning || isOnlyExternalLinks) insertExternalMediaSingle({
            url: url,
            alt: '',
            inputMethod: (0, $3LeME.INPUT_METHOD).MEDIA_PICKER
        });
        closeMediaInsertPicker();
    }, [
        closeMediaInsertPicker,
        insertExternalMediaSingle,
        previewState.warning,
        isOnlyExternalLinks
    ]);
    const onInputKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        if (event && event.key === 'Esc') {
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $3LeME.ACTION).CLOSED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    eventType: (0, $3LeME.EVENT_TYPE).UI,
                    attributes: {
                        exitMethod: (0, $3LeME.INPUT_METHOD).KEYBOARD
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
            cancelMediaInsertPicker();
        }
    }, [
        dispatchAnalyticsEvent,
        cancelMediaInsertPicker
    ]);
    const onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $3LeME.ACTION).CANCELLED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
                actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
                eventType: (0, $3LeME.EVENT_TYPE).UI
            };
            dispatchAnalyticsEvent(payload);
        }
        cancelMediaInsertPicker();
    }, [
        cancelMediaInsertPicker,
        dispatchAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e8E8t.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSubmit: ({ inputUrl: inputUrl }, form)=>{
            // This can be triggered from an enter key event on the input even when
            // the button is disabled, so we explicitly do nothing when in loading
            // state.
            if (previewState.isLoading || form.getState().invalid) return;
            if (previewState.previewInfo) return onInsert();
            if (previewState.warning || isOnlyExternalLinks) return onExternalInsert(inputUrl);
            return uploadExternalMedia(inputUrl);
        },
        children: ({ formProps: formProps })=>// Ignored via go/ees005
            // eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
                xcss: $36fc8882d21f46de$var$FormStyles,
                children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $7yidP.Stack), {
                    space: "space.150",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gPQv9.default), {
                            isRequired: true,
                            name: "inputUrl",
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            validate: (value)=>value && $36fc8882d21f46de$var$isValidInput(value, customizedUrlValidation) ? undefined : strings.invalidUrl,
                            children: ({ fieldProps: { value: value, onChange: onChange, ...rest }, error: error, meta: meta })=>/*#__PURE__*/ (0, $3LM7S.jsxs)((0, $7yidP.Stack), {
                                    space: "space.150",
                                    grow: "fill",
                                    children: [
                                        /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $5a4EU.Box), {
                                            children: [
                                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $aEtFp.default), {
                                                    ...rest,
                                                    value: value,
                                                    "aria-label": strings.pasteLinkToUpload,
                                                    placeholder: strings.pasteLinkToUpload,
                                                    maxLength: $36fc8882d21f46de$var$MAX_URL_LENGTH,
                                                    onKeyPress: onInputKeyPress,
                                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                    onPaste: (event)=>onPaste(event, value),
                                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                    onChange: (value)=>{
                                                        onURLChange(value);
                                                        onChange(value);
                                                    },
                                                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                    onKeyDown: (e)=>{
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            formProps.onSubmit();
                                                        }
                                                    }
                                                }),
                                                customizedHelperMessage && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fc4bM.Fragment), {
                                                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ecwhF.HelperMessage), {
                                                        children: customizedHelperMessage
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $11sVc.MessageWrapper), {
                                                    children: error && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2xHR5.ErrorMessage), {
                                                        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
                                                            as: "span",
                                                            children: error
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        !previewState.previewInfo && !previewState.error && !previewState.warning && !isOnlyExternalLinks && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1JdzP.Flex), {
                                            xcss: $36fc8882d21f46de$var$PreviewBoxStyles,
                                            alignItems: "center",
                                            justifyContent: "center",
                                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                                                type: "button",
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                onClick: ()=>formProps.onSubmit(),
                                                isLoading: previewState.isLoading,
                                                isDisabled: !!error || !meta.dirty,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                iconBefore: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5uAqu))), {
                                                        label: ""
                                                    }),
                                                children: strings.loadPreview
                                            })
                                        })
                                    ]
                                })
                        }),
                        previewState.previewInfo && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lgMZ2.Inline), {
                            alignInline: "center",
                            alignBlock: "center",
                            xcss: $36fc8882d21f46de$var$PreviewImageStyles,
                            space: "space.200",
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hVfvc.MediaCard), {
                                attrs: previewState.previewInfo,
                                mediaProvider: mediaProvider
                            })
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $11sVc.MessageWrapper), {
                            children: [
                                previewState.error && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dtvmL.default), {
                                    appearance: "error",
                                    children: strings.errorMessage
                                }),
                                previewState.warning && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dtvmL.default), {
                                    appearance: "warning",
                                    children: strings.warning
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e2QOk.FormFooter), {
                            children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $lHYHS.default), {
                                children: [
                                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                                        appearance: "subtle",
                                        onClick: onCancel,
                                        children: strings.cancel
                                    }),
                                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5dzEI.default), {
                                        type: "button",
                                        appearance: "primary",
                                        isDisabled: isOnlyExternalLinks ? !input || !$36fc8882d21f46de$var$isValidInput(input, customizedUrlValidation) : !previewState.previewInfo && !previewState.warning,
                                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                        onClick: ()=>formProps.onSubmit(),
                                        children: strings.insert
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
    });
}

});
parcelRegister("hVfvc", function(module, exports) {
$parcel$export(module.exports, "MediaCard", () => $eb2ecfc933f2592a$export$a6543a2e3828db2c);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $9WMKr = parcelRequire("9WMKr");

var $af3Ca = parcelRequire("af3Ca");

var $kYtcy = parcelRequire("kYtcy");
const $eb2ecfc933f2592a$var$maxDimensions = {
    width: '100%',
    height: '100%'
};
const $eb2ecfc933f2592a$export$a6543a2e3828db2c = ({ attrs: attrs, mediaProvider: mediaProvider })=>{
    const intl = (0, $gpjDl.default)();
    const mediaAlt = intl.formatMessage((0, $9WMKr.mediaInsertMessages).mediaAlt);
    const dimensions = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        return {
            width: attrs.dimensions.width,
            height: attrs.dimensions.height
        };
    }, [
        attrs.dimensions.width,
        attrs.dimensions.height
    ]);
    const identifier = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>({
            id: attrs.id,
            mediaItemType: 'file',
            collectionName: attrs.collection
        }), [
        attrs.collection,
        attrs.id
    ]);
    if (!mediaProvider) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kYtcy.CardLoading), {
        dimensions: dimensions,
        interactionName: "editor-media-insert-card-loading"
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $af3Ca.default), {
        mediaClientConfig: mediaProvider.viewMediaClientConfig,
        resizeMode: "stretchy-fit",
        dimensions: $eb2ecfc933f2592a$var$maxDimensions,
        originalDimensions: dimensions,
        identifier: identifier,
        alt: mediaAlt,
        disableOverlay: true
    });
};

});


parcelRegister("4HYvY", function(module, exports) {
$parcel$export(module.exports, "MediaInsertWrapper", () => $7ce6cb9775aa6cb5$export$d01f0fa2ebc904b8);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");
const $7ce6cb9775aa6cb5$var$styles = (0, $kig2V.xcss)({
    /* Reset inherited styles from toolbar */ whiteSpace: 'initial',
    textAlign: 'initial',
    boxShadow: 'elevation.shadow.overflow',
    width: '340px',
    padding: 'space.200',
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface.overlay'
});
const $7ce6cb9775aa6cb5$export$d01f0fa2ebc904b8 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        ref: ref,
        xcss: $7ce6cb9775aa6cb5$var$styles,
        children: children
    });
});

});


parcelRegister("gintA", function(module, exports) {
$parcel$export(module.exports, "getMediaInsertQuickInsertComponents", () => $1b04a9115e31156f$export$e827073d6ee684ab);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cT0LQ = parcelRequire("cT0LQ");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $c7QdG = parcelRequire("c7QdG");
const $1b04a9115e31156f$export$e827073d6ee684ab = ({ api: api, config: config })=>[
        {
            key: (0, $hI3gt.MEDIA_INSERT_MENU_ITEM).key,
            type: (0, $hI3gt.MEDIA_INSERT_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $hI3gt.MEDIA_SECTION).key,
                    type: (0, $hI3gt.MEDIA_SECTION).type,
                    rank: (0, $4jXgF.MEDIA_SECTION_RANK)[(0, $hI3gt.MEDIA_INSERT_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).mediaFilesDescription),
                    keywords: [
                        'attachment',
                        'gif',
                        'media',
                        'picture',
                        'image',
                        'video',
                        'file'
                    ],
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).mediaFiles)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $c7QdG.MediaInsertQuickInsertMenuItem), {
                    api: api,
                    config: config
                })
        }
    ];

});
parcelRegister("c7QdG", function(module, exports) {
$parcel$export(module.exports, "MediaInsertQuickInsertMenuItem", () => $9637ae32099984d3$export$46d7e70231827582);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $8cRGu = parcelRequire("8cRGu");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $3M4Vk = parcelRequire("3M4Vk");

var $6P7OL = parcelRequire("6P7OL");

var $64IAh = parcelRequire("64IAh");
const $9637ae32099984d3$var$previewImageUrls = {
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK4.png',
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNH.png'
};
const $9637ae32099984d3$export$46d7e70231827582 = ({ api: api, config: config })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isOffline: isOffline } = (0, $6P7OL.useQuickInsertContext)();
    const preview = (0, $fc4bM.useMemo)(()=>({
            image: $9637ae32099984d3$var$previewImageUrls,
            attribution: {
                name: formatMessage((0, $3M4Vk.messages).previewAttributionAtlassian)
            }
        }), [
        formatMessage
    ]);
    const onSelect = (0, $fc4bM.useCallback)(({ insert: insert })=>{
        var _api$mediaInsert, _api$mediaInsert2, _api$analytics;
        const tr = insert('');
        api === null || api === void 0 || (_api$mediaInsert = api.mediaInsert) === null || _api$mediaInsert === void 0 || _api$mediaInsert.commands.showMediaInsertPopup()({
            tr: tr
        });
        const initialBuiltInTab = config !== null && config !== void 0 && config.isOnlyExternalLinks ? (0, $3LeME.MEDIA_INSERT_TAB).LINK : (0, $3LeME.MEDIA_INSERT_TAB).UPLOAD;
        const initialBuiltInRank = config !== null && config !== void 0 && config.isOnlyExternalLinks ? (0, $8cRGu.MEDIA_INSERT_TAB_RANK)[(0, $3LeME.MEDIA_INSERT_TAB).LINK] : (0, $8cRGu.MEDIA_INSERT_TAB_RANK)[(0, $3LeME.MEDIA_INSERT_TAB).UPLOAD];
        const firstRegisteredTab = api === null || api === void 0 || (_api$mediaInsert2 = api.mediaInsert) === null || _api$mediaInsert2 === void 0 ? void 0 : _api$mediaInsert2.actions.getInsertTabs().reduce((firstTab, tab)=>!firstTab || (tab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK)) < (firstTab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK)) ? tab : firstTab, undefined);
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).OPENED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).PICKER,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PICKER_MEDIA,
            attributes: {
                inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT,
                openedTab: firstRegisteredTab && (firstRegisteredTab.rank ?? (0, $8cRGu.DEFAULT_MEDIA_INSERT_TAB_RANK)) < initialBuiltInRank ? firstRegisteredTab.key : initialBuiltInTab
            },
            eventType: (0, $3LeME.EVENT_TYPE).UI
        })(tr);
        return tr;
    }, [
        api,
        config
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).mediaFilesDescription),
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64IAh))), {
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).mediaFiles)
    });
};

});



parcelRegister("fWue6", function(module, exports) {
$parcel$export(module.exports, "default", () => $c37cdc7206a756dd$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gITKe = parcelRequire("gITKe");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $1y7gE = parcelRequire("1y7gE");

var $9oAqi = parcelRequire("9oAqi");

var $39oqF = parcelRequire("39oqF");

var $801jp = parcelRequire("801jp");

var $fUD4v = parcelRequire("fUD4v");

var $bcN2K = parcelRequire("bcN2K");

var $1UrwT = parcelRequire("1UrwT");

var $iqSsJ = parcelRequire("iqSsJ");

var $2Q1dV = parcelRequire("2Q1dV");

var $3ucjP = parcelRequire("3ucjP");

var $fI3iV = parcelRequire("fI3iV");

var $9jXdB = parcelRequire("9jXdB");

var $aSaKj = parcelRequire("aSaKj");
const $c37cdc7206a756dd$var$getOpenTypeAhead = (trigger, api)=>{
    var _api$typeAhead, _api$typeAhead2;
    const typeAheadHandler = api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 || (_api$typeAhead = _api$typeAhead.actions) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.findHandlerByTrigger(trigger);
    if (!typeAheadHandler || !typeAheadHandler.id) return null;
    return api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 || (_api$typeAhead2 = _api$typeAhead2.actions) === null || _api$typeAhead2 === void 0 ? void 0 : _api$typeAhead2.openAtTransaction({
        triggerHandler: typeAheadHandler,
        inputMethod: (0, $3LeME.INPUT_METHOD).KEYBOARD
    });
};
function $c37cdc7206a756dd$export$ae829ec7b2625219(dispatch, options, api) {
    const allowInserting = !!options.allowInserting;
    return new (0, $1y7gE.SafePlugin)({
        key: (0, $3ucjP.pluginKey),
        state: {
            init: ()=>({
                    showInsertPanelAt: null,
                    allowInserting: allowInserting
                }),
            apply: (tr, state)=>{
                const meta = tr.getMeta((0, $3ucjP.pluginKey));
                if (meta && meta.showInsertPanelAt !== undefined) {
                    const newState = {
                        showInsertPanelAt: meta.showInsertPanelAt,
                        allowInserting: allowInserting
                    };
                    dispatch((0, $3ucjP.pluginKey), newState);
                    return newState;
                } else if (state.showInsertPanelAt) {
                    const newState = {
                        showInsertPanelAt: tr.mapping.map(state.showInsertPanelAt),
                        allowInserting: allowInserting
                    };
                    dispatch((0, $3ucjP.pluginKey), newState);
                    return newState;
                }
                return state;
            }
        },
        appendTransaction (transactions, oldState, newState) {
            if (transactions.some((txn)=>txn.docChanged)) {
                const didPlaceholderExistBeforeTxn = oldState.selection.$head.nodeAfter === newState.selection.$head.nodeAfter;
                const adjacentNode = newState.selection.$head.nodeAfter;
                const adjacentNodePos = newState.selection.$head.pos;
                const placeholderNodeType = newState.schema.nodes.placeholder;
                if (adjacentNode && adjacentNode.type === placeholderNodeType && didPlaceholderExistBeforeTxn) {
                    var _$newHead$nodeBefore;
                    const { $head: $newHead } = newState.selection;
                    const { $head: $oldHead } = oldState.selection;
                    // Check that cursor has moved forward in the document **and** that there is content before the cursor
                    const cursorMoved = $oldHead.pos < $newHead.pos;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const nodeBeforeHasContent = !(0, $39oqF.isNodeEmpty)($newHead.nodeBefore);
                    const nodeBeforeIsInline = (_$newHead$nodeBefore = $newHead.nodeBefore) === null || _$newHead$nodeBefore === void 0 ? void 0 : _$newHead$nodeBefore.type.isInline;
                    if (cursorMoved && (nodeBeforeHasContent || nodeBeforeIsInline)) {
                        const { $from: $from, $to: $to } = (0, $801jp.NodeSelection).create(newState.doc, adjacentNodePos);
                        return newState.tr.deleteRange($from.pos, $to.pos);
                    }
                }
            }
            // Handle Fake Text Cursor for Floating Toolbar
            if (!(0, $3ucjP.pluginKey).getState(oldState).showInsertPanelAt && (0, $3ucjP.pluginKey).getState(newState).showInsertPanelAt) return newState.tr.setSelection(new (0, $iqSsJ.FakeTextCursorSelection)(newState.selection.$from));
            if ((0, $3ucjP.pluginKey).getState(oldState).showInsertPanelAt && !(0, $3ucjP.pluginKey).getState(newState).showInsertPanelAt) {
                if (newState.selection instanceof (0, $iqSsJ.FakeTextCursorSelection)) return newState.tr.setSelection(new (0, $801jp.TextSelection)(newState.selection.$from));
            }
            return;
        },
        props: {
            decorations: (0, $iqSsJ.drawFakeTextCursor),
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    const { state: state } = view;
                    if (event instanceof InputEvent && !event.isComposing && event.inputType === 'insertText' && (0, $fI3iV.isSelectionAtPlaceholder)(view.state.selection)) {
                        event.stopPropagation();
                        event.preventDefault();
                        const startNodePosition = state.selection.from;
                        const content = event.data || '';
                        const tr = view.state.tr;
                        tr.delete(startNodePosition, startNodePosition + 1);
                        const openTypeAhead = $c37cdc7206a756dd$var$getOpenTypeAhead(content, api);
                        if (openTypeAhead) openTypeAhead(tr);
                        else tr.insertText(content);
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            },
            nodeViews: {
                placeholder: (node, view, getPos)=>new (0, $2Q1dV.PlaceholderTextNodeView)(node, view, getPos)
            }
        }
    });
}
function $c37cdc7206a756dd$var$ContentComponent({ editorView: editorView, dependencyApi: dependencyApi, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
    const { showInsertPanelAt: showInsertPanelAt } = (0, $9oAqi.useSharedPluginStateWithSelector)(dependencyApi, [
        'placeholderText'
    ], (states)=>{
        var _states$placeholderTe;
        return {
            showInsertPanelAt: (_states$placeholderTe = states.placeholderTextState) === null || _states$placeholderTe === void 0 ? void 0 : _states$placeholderTe.showInsertPanelAt
        };
    });
    const insertPlaceholderText = (value)=>(0, $1UrwT.insertPlaceholderTextAtSelection)(value)(editorView.state, editorView.dispatch);
    const hidePlaceholderToolbar = ()=>(0, $1UrwT.hidePlaceholderFloatingToolbar)(editorView.state, editorView.dispatch);
    const getNodeFromPos = (pos)=>editorView.domAtPos(pos).node;
    const getFixedCoordinatesFromPos = (pos)=>editorView.coordsAtPos(pos);
    const setFocusInEditor = ()=>editorView.focus();
    if (showInsertPanelAt) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9jXdB.default), {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorViewDOM: editorView.dom,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        getFixedCoordinatesFromPos: getFixedCoordinatesFromPos,
        getNodeFromPos: getNodeFromPos,
        hidePlaceholderFloatingToolbar: hidePlaceholderToolbar,
        showInsertPanelAt: showInsertPanelAt,
        insertPlaceholder: insertPlaceholderText,
        setFocusInEditor: setFocusInEditor
    });
    return null;
}
const $c37cdc7206a756dd$var$basePlaceholderTextPlugin = ({ api: api, config: options })=>({
        name: 'placeholderText',
        nodes () {
            return [
                {
                    name: 'placeholder',
                    node: (0, $gITKe.placeholder)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholderText',
                    plugin: ({ dispatch: dispatch })=>$c37cdc7206a756dd$export$ae829ec7b2625219(dispatch, options, api)
                }
            ];
        },
        actions: {
            showPlaceholderFloatingToolbar: $1UrwT.showPlaceholderFloatingToolbar
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { showInsertPanelAt: showInsertPanelAt, allowInserting: allowInserting } = (0, $3ucjP.pluginKey).getState(editorState) || {
                showInsertPanelAt: null
            };
            return {
                showInsertPanelAt: showInsertPanelAt,
                allowInserting: !!allowInserting
            };
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $3LM7S.jsx)($c37cdc7206a756dd$var$ContentComponent, {
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                dependencyApi: api
            });
        }
    });
const $c37cdc7206a756dd$var$decorateWithPluginOptions = (plugin, options, api)=>{
    if (!options.allowInserting || (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command')) return plugin;
    plugin.pluginsOptions = {
        quickInsert: ({ formatMessage: formatMessage })=>[
                {
                    id: 'placeholderText',
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).placeholderText),
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).placeholderTextDescription),
                    priority: 1400,
                    keywords: [
                        'placeholder'
                    ],
                    icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUD4v))), {
                            label: ""
                        }),
                    action (insert, state) {
                        var _api$analytics;
                        const tr = state.tr;
                        tr.setMeta((0, $3ucjP.pluginKey), {
                            showInsertPanelAt: tr.selection.anchor
                        });
                        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                            action: (0, $3LeME.ACTION).INSERTED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
                            attributes: {
                                inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT
                            },
                            eventType: (0, $3LeME.EVENT_TYPE).TRACK
                        })(tr);
                        return tr;
                    }
                }
            ]
    };
    return plugin;
};
const $c37cdc7206a756dd$var$placeholderTextPlugin = ({ config: options = {}, api: api })=>{
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command') && options.allowInserting) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $aSaKj.getPlaceholderTextQuickInsertComponents)({
            api: api
        }));
    }
    return $c37cdc7206a756dd$var$decorateWithPluginOptions($c37cdc7206a756dd$var$basePlaceholderTextPlugin({
        config: options,
        api: api
    }), options, api);
};
var $c37cdc7206a756dd$export$2e2bcd8739ae039 = $c37cdc7206a756dd$var$placeholderTextPlugin;

});
parcelRegister("1UrwT", function(module, exports) {
$parcel$export(module.exports, "showPlaceholderFloatingToolbar", () => $dd73cfb4b3e351f1$export$cf72668e5bda227e);
$parcel$export(module.exports, "insertPlaceholderTextAtSelection", () => $dd73cfb4b3e351f1$export$478f9b36a44ad411);
$parcel$export(module.exports, "hidePlaceholderFloatingToolbar", () => $dd73cfb4b3e351f1$export$722fce80225bc19b);

var $3ucjP = parcelRequire("3ucjP");
const $dd73cfb4b3e351f1$export$cf72668e5bda227e = (state, dispatch)=>{
    const tr = state.tr;
    if (!state.selection.empty) tr.deleteSelection();
    tr.setMeta((0, $3ucjP.pluginKey), {
        showInsertPanelAt: tr.selection.anchor
    });
    tr.scrollIntoView();
    dispatch(tr);
    return true;
};
const $dd73cfb4b3e351f1$export$478f9b36a44ad411 = (value)=>(state, dispatch)=>{
        dispatch(state.tr.replaceSelectionWith(state.schema.nodes.placeholder.createChecked({
            text: value
        })).setMeta((0, $3ucjP.pluginKey), {
            showInsertPanelAt: null
        }).scrollIntoView());
        return true;
    };
const $dd73cfb4b3e351f1$export$722fce80225bc19b = (state, dispatch)=>{
    dispatch(state.tr.setMeta((0, $3ucjP.pluginKey), {
        showInsertPanelAt: null
    }));
    return true;
};

});
parcelRegister("3ucjP", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $1b218b9f05f6704f$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $1b218b9f05f6704f$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('placeholderTextPlugin');

});


parcelRegister("iqSsJ", function(module, exports) {
$parcel$export(module.exports, "FakeTextCursorSelection", () => $b644fae9aa00f862$export$37936ceed0f40761);
$parcel$export(module.exports, "drawFakeTextCursor", () => $b644fae9aa00f862$export$e3d497d0280bbada);

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");
class $b644fae9aa00f862$export$9f5092f54ccc15c6 {
    constructor(pos){
        this.pos = undefined;
        this.visible = false;
        this.pos = pos;
    }
    map(mapping) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return new $b644fae9aa00f862$export$9f5092f54ccc15c6(mapping.map(this.pos));
    }
    resolve(doc) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const $pos = doc.resolve(this.pos);
        return (0, $801jp.Selection).near($pos);
    }
}
class $b644fae9aa00f862$export$37936ceed0f40761 extends (0, $801jp.Selection) {
    constructor($pos){
        super($pos, $pos);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.$head.pos));
        return new $b644fae9aa00f862$export$37936ceed0f40761($pos);
    }
    static content() {
        return (0, $7H6Cr.Slice).empty;
    }
    eq(other) {
        return other instanceof $b644fae9aa00f862$export$37936ceed0f40761 && other.head === this.head;
    }
    toJSON() {
        return {
            type: 'Cursor',
            pos: this.head
        };
    }
    static fromJSON(doc, json) {
        return new $b644fae9aa00f862$export$37936ceed0f40761(doc.resolve(json.pos));
    }
    getBookmark() {
        return new $b644fae9aa00f862$export$9f5092f54ccc15c6(this.anchor);
    }
}
(0, $801jp.Selection).jsonID('fake-text-cursor', $b644fae9aa00f862$export$37936ceed0f40761);
const $b644fae9aa00f862$export$b8cf92335d1aa4be = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection.empty) {
        const { selection: { $from: $from } } = state;
        dispatch(state.tr.setSelection(new $b644fae9aa00f862$export$37936ceed0f40761($from)));
    }
};
const $b644fae9aa00f862$export$b0a69583d8930ac5 = (state, dispatch)=>{
    if (state.selection instanceof $b644fae9aa00f862$export$37936ceed0f40761) {
        const { $from: $from } = state.selection;
        dispatch(state.tr.setSelection(new (0, $801jp.TextSelection)($from)));
    }
};
const $b644fae9aa00f862$export$e3d497d0280bbada = (state)=>{
    if (!(state.selection instanceof $b644fae9aa00f862$export$37936ceed0f40761)) return null;
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $16ZMX.DecorationSet).create(state.doc, [
        (0, $16ZMX.Decoration).widget(state.selection.head, node, {
            key: 'Cursor'
        })
    ]);
};

});

parcelRegister("2Q1dV", function(module, exports) {
$parcel$export(module.exports, "PlaceholderTextNodeView", () => $7a1f77d833bfe7f3$export$442d0baedc2512a6);

var $dqFZv = parcelRequire("dqFZv");

var $jWgCZ = parcelRequire("jWgCZ");

var $801jp = parcelRequire("801jp");
const $7a1f77d833bfe7f3$var$serializePlaceholderNode = (node)=>{
    const element = document.createElement('span');
    const browser = (0, $dqFZv.getBrowserInfo)();
    element.classList.add('pm-placeholder');
    // the inline node api test suite requires the following class name
    element.classList.add('placeholderView-content-wrap');
    element.innerText = (0, $jWgCZ.ZERO_WIDTH_SPACE);
    const elementChildren = document.createElement('span');
    elementChildren.classList.add('pm-placeholder__text');
    elementChildren.dataset.placeholder = node.attrs.text;
    elementChildren.setAttribute('contenteditable', 'false');
    element.appendChild(elementChildren);
    if (browser.safari) element.appendChild(document.createTextNode((0, $jWgCZ.ZERO_WIDTH_SPACE)));
    else element.appendChild(document.createElement('wbr'));
    return element;
};
class $7a1f77d833bfe7f3$export$442d0baedc2512a6 {
    constructor(node, view, getPos){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.dom = $7a1f77d833bfe7f3$var$serializePlaceholderNode(this.node);
        this.getPos = getPos;
    }
    stopEvent(e) {
        if (e.type === 'mousedown' && typeof this.getPos === 'function') {
            e.preventDefault();
            const { view: view } = this;
            const startNodePosition = this.getPos();
            if (typeof startNodePosition !== 'number') return false;
            const tr = view.state.tr;
            tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(startNodePosition)));
            view.dispatch(tr);
            if (!view.hasFocus()) window.requestAnimationFrame(()=>{
                view.focus();
            });
            return true;
        }
        return false;
    }
    ignoreMutation(record) {
        if (typeof this.getPos !== 'function' || record.type !== 'selection') return true;
        const { view: view, node: node } = this;
        const placeholderStartPosition = this.getPos();
        if (typeof placeholderStartPosition !== 'number') return false;
        const placeholderEndPosition = placeholderStartPosition + node.nodeSize;
        const selection = view.state.selection;
        // when the selection is set right after the placeholder.
        // we should let ProseMirror deal with this edge-case
        if (selection.from === placeholderEndPosition) return false;
        const isSelectionAtPlaceholder = selection.from === placeholderStartPosition;
        const isSelectionAfterlaceholder = selection.from > placeholderEndPosition;
        if (isSelectionAtPlaceholder || isSelectionAfterlaceholder) {
            const tr = view.state.tr;
            tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(placeholderEndPosition)));
            view.dispatch(tr);
            return true;
        }
        return true;
    }
}

});

parcelRegister("fI3iV", function(module, exports) {
$parcel$export(module.exports, "isSelectionAtPlaceholder", () => $fad6e1f55c939b74$export$fcfa1d7f51efd169);

var $801jp = parcelRequire("801jp");
const $fad6e1f55c939b74$export$fcfa1d7f51efd169 = (selection)=>{
    if (!(selection instanceof (0, $801jp.TextSelection)) || !selection.$cursor) return false;
    const node = selection.$cursor.doc.nodeAt(selection.$cursor.pos);
    return (node === null || node === void 0 ? void 0 : node.type.name) === 'placeholder';
};

});

parcelRegister("9jXdB", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5a3f2f3d50f7ca1$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $2ewu1 = parcelRequire("2ewu1");

var $3hgwy = parcelRequire("3hgwy");

var $9bM4L = parcelRequire("9bM4L");

var $5MXLn = parcelRequire("5MXLn");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e5a3f2f3d50f7ca1$var$PlaceholderFloatingToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    render() {
        const { getNodeFromPos: getNodeFromPos, showInsertPanelAt: showInsertPanelAt, editorViewDOM: editorViewDOM, popupsMountPoint: popupsMountPoint, getFixedCoordinatesFromPos: getFixedCoordinatesFromPos, popupsBoundariesElement: popupsBoundariesElement, intl: { formatMessage: formatMessage } } = this.props;
        const target = getNodeFromPos(showInsertPanelAt);
        const offsetParent = (0, $5MXLn.getOffsetParent)(editorViewDOM, popupsMountPoint);
        const getFixedCoordinates = ()=>getFixedCoordinatesFromPos(showInsertPanelAt);
        const handlePositionCalculated = (0, $5MXLn.handlePositionCalculatedWith)(offsetParent, target, getFixedCoordinates);
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9bM4L.default), {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            target: (0, $5MXLn.getNearestNonTextNode)(target),
            onPositionCalculated: handlePositionCalculated,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            fitHeight: 32,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                12
            ],
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3hgwy.default), {
                placeholder: formatMessage((0, $2ewu1.placeholderTextMessages).placeholderTextPlaceholder),
                onSubmit: this.handleSubmit,
                onBlur: this.handleBlur,
                autoFocus: true,
                width: 300
            })
        });
    }
    constructor(...args){
        super(...args), this.handleSubmit = (value)=>{
            if (value) {
                this.props.insertPlaceholder(value);
                this.props.setFocusInEditor();
            } else this.props.hidePlaceholderFloatingToolbar();
        }, this.handleBlur = ()=>{
            this.props.hidePlaceholderFloatingToolbar();
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $e5a3f2f3d50f7ca1$var$_default_1 = (0, $fcCIH.default)($e5a3f2f3d50f7ca1$var$PlaceholderFloatingToolbar);
var $e5a3f2f3d50f7ca1$export$2e2bcd8739ae039 = $e5a3f2f3d50f7ca1$var$_default_1;

});
parcelRegister("9bM4L", function(module, exports) {
$parcel$export(module.exports, "default", () => $ebd7f60615af483d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $dXHAJ = parcelRequire("dXHAJ");

var $UuBMT = parcelRequire("UuBMT");
function $ebd7f60615af483d$export$2e2bcd8739ae039({ children: children, target: target, offset: offset, fitWidth: fitWidth, fitHeight: fitHeight = 40, onPositionCalculated: onPositionCalculated, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, className: className, absoluteOffset: absoluteOffset, alignX: alignX, alignY: alignY, zIndex: zIndex }) {
    if (!target) return null;
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $dXHAJ.default), {
        absoluteOffset: absoluteOffset,
        alignX: alignX,
        alignY: alignY,
        target: target,
        zIndex: zIndex,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        offset: offset,
        fitWidth: fitWidth,
        fitHeight: fitHeight,
        onPositionCalculated: onPositionCalculated
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $UuBMT.container)(fitHeight),
        "data-testid": "popup-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children));
}

});
parcelRegister("UuBMT", function(module, exports) {
$parcel$export(module.exports, "container", () => $9e243264a212aeaf$export$34e0f9847d4c02dd);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");
const $9e243264a212aeaf$export$34e0f9847d4c02dd = (height)=>/*#__PURE__*/ (0, $jctmk.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
        backgroundColor: "var(--ds-background-input, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: height ? `${height}px` : undefined
    });

});


parcelRegister("5MXLn", function(module, exports) {
$parcel$export(module.exports, "getOffsetParent", () => $cd8ef7498092cbc7$export$5055c4a13011779);
$parcel$export(module.exports, "getNearestNonTextNode", () => $cd8ef7498092cbc7$export$dcb2d1671e2c93d4);
$parcel$export(module.exports, "handlePositionCalculatedWith", () => $cd8ef7498092cbc7$export$499dde0ed160b17d);
const $cd8ef7498092cbc7$var$getCursorHeightFrom = (node)=>parseFloat(window.getComputedStyle(node, undefined).lineHeight || '');
const $cd8ef7498092cbc7$export$5055c4a13011779 = (editorViewDom, popupsMountPoint)=>popupsMountPoint ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    popupsMountPoint.offsetParent : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    editorViewDom.offsetParent;
const $cd8ef7498092cbc7$export$dcb2d1671e2c93d4 = (node)=>// Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    node.nodeType === Node.TEXT_NODE ? node.parentNode : node;
/**
 * We need to translate the co-ordinates because `coordsAtPos` returns co-ordinates
 * relative to `window`. And, also need to adjust the cursor container height.
 * (0, 0)
 * +--------------------- [window] ---------------------+
 * |   (left, top) +-------- [Offset Parent] --------+  |
 * | {coordsAtPos} | [Cursor]   <- cursorHeight      |  |
 * |               | [FloatingToolbar]               |  |
 */ const $cd8ef7498092cbc7$var$convertFixedCoordinatesToAbsolutePositioning = (coordinates, offsetParent, cursorHeight)=>{
    const { left: offsetParentLeft, top: offsetParentTop, height: offsetParentHeight } = offsetParent.getBoundingClientRect();
    return {
        left: (coordinates.left ?? 0) - offsetParentLeft,
        right: (coordinates.right ?? 0) - offsetParentLeft,
        top: (coordinates.top ?? 0) - (offsetParentTop - cursorHeight) + offsetParent.scrollTop,
        bottom: offsetParentHeight - ((coordinates.top ?? 0) - (offsetParentTop - cursorHeight) - offsetParent.scrollTop)
    };
};
const $cd8ef7498092cbc7$export$499dde0ed160b17d = (offsetParent, node, getCurrentFixedCoordinates)=>(position)=>{
        if (!offsetParent) return position;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const target = $cd8ef7498092cbc7$export$dcb2d1671e2c93d4(node);
        const cursorHeight = $cd8ef7498092cbc7$var$getCursorHeightFrom(target);
        const fixedCoordinates = getCurrentFixedCoordinates();
        const absoluteCoordinates = $cd8ef7498092cbc7$var$convertFixedCoordinatesToAbsolutePositioning(fixedCoordinates, offsetParent, cursorHeight);
        return {
            left: position.left ? absoluteCoordinates.left : undefined,
            right: position.right ? absoluteCoordinates.right : undefined,
            top: position.top ? absoluteCoordinates.top : undefined,
            bottom: position.bottom ? absoluteCoordinates.bottom : undefined
        };
    };

});


parcelRegister("aSaKj", function(module, exports) {
$parcel$export(module.exports, "getPlaceholderTextQuickInsertComponents", () => $99839fcffd714d16$export$45d515f9e642ad8b);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cT0LQ = parcelRequire("cT0LQ");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $hZXhb = parcelRequire("hZXhb");
const $99839fcffd714d16$export$45d515f9e642ad8b = ({ api: api })=>[
        {
            key: (0, $hI3gt.PLACEHOLDER_TEXT_MENU_ITEM).key,
            type: (0, $hI3gt.PLACEHOLDER_TEXT_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $hI3gt.TEXT_FORMATTING_SECTION).key,
                    type: (0, $hI3gt.TEXT_FORMATTING_SECTION).type,
                    rank: (0, $4jXgF.TEXT_FORMATTING_SECTION_RANK)[(0, $hI3gt.PLACEHOLDER_TEXT_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).placeholderTextDescription),
                    keywords: [
                        'placeholder'
                    ],
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).placeholderText)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $hZXhb.PlaceholderTextQuickInsertMenuItem), {
                    api: api
                })
        }
    ];

});
parcelRegister("hZXhb", function(module, exports) {
$parcel$export(module.exports, "PlaceholderTextQuickInsertMenuItem", () => $14331b25a07f023c$export$b5e4dc02b34314b8);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $fUD4v = parcelRequire("fUD4v");

var $3ucjP = parcelRequire("3ucjP");
const $14331b25a07f023c$export$b5e4dc02b34314b8 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const onSelect = (0, $fc4bM.useCallback)(({ editorView: editorView })=>{
        var _api$analytics;
        const tr = editorView.state.tr;
        tr.setMeta((0, $3ucjP.pluginKey), {
            showInsertPanelAt: tr.selection.anchor
        });
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
            action: (0, $3LeME.ACTION).INSERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).PLACEHOLDER_TEXT,
            attributes: {
                inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fUD4v))), {
            label: ""
        }),
        onSelect: onSelect,
        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).placeholderText)
    });
};

});



parcelRegister("9HDR3", function(module, exports) {
$parcel$export(module.exports, "default", () => $922e4f3af59e4fb5$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $63Q5S = parcelRequire("63Q5S");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $dqFZv = parcelRequire("dqFZv");

var $42nnk = parcelRequire("42nnk");

var $eUtBU = parcelRequire("eUtBU");

var $cT0LQ = parcelRequire("cT0LQ");

var $5DGsr = parcelRequire("5DGsr");
var $89pmn = parcelRequire("89pmn");

var $cTbwC = parcelRequire("cTbwC");

var $1y7gE = parcelRequire("1y7gE");

var $9oAqi = parcelRequire("9oAqi");

var $a4TQr = parcelRequire("a4TQr");

var $4Pdzq = parcelRequire("4Pdzq");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $6Waiv = parcelRequire("6Waiv");

var $d5kki = parcelRequire("d5kki");

var $2QInN = parcelRequire("2QInN");

var $jEslx = parcelRequire("jEslx");

var $d9DFt = parcelRequire("d9DFt");

var $f3xW3 = parcelRequire("f3xW3");

var $a1g0P = parcelRequire("a1g0P");

var $eU2qH = parcelRequire("eU2qH");

var $cbJui = parcelRequire("cbJui");

var $4OlZB = parcelRequire("4OlZB");

var $iXpZM = parcelRequire("iXpZM");

var $4dyXt = parcelRequire("4dyXt");

var $dfb9x = parcelRequire("dfb9x");

var $by4QE = parcelRequire("by4QE");

var $fkY0k = parcelRequire("fkY0k");

var $AGA3t = parcelRequire("AGA3t");

var $lh6cf = parcelRequire("lh6cf");

var $2LcYo = parcelRequire("2LcYo");

var $iUkHD = parcelRequire("iUkHD");

var $6ixVH = parcelRequire("6ixVH");

var $6xtYM = parcelRequire("6xtYM");

var $ivUuF = parcelRequire("ivUuF");

var $lcU8V = parcelRequire("lcU8V");

var $8aCba = parcelRequire("8aCba");

var $cD6dM = parcelRequire("cD6dM");

var $4Bf8g = parcelRequire("4Bf8g");

var $l1ZbO = parcelRequire("l1ZbO");

var $fuhDl = parcelRequire("fuhDl");

var $kYtNC = parcelRequire("kYtNC");

var $5afEq = parcelRequire("5afEq");

var $659mW = parcelRequire("659mW");

var $7a5j7 = parcelRequire("7a5j7");
const $922e4f3af59e4fb5$var$defaultGetEditorFeatureFlags = ()=>({});
// we want to calculate all the table widths (which causes reflows) after the editor has finished loading to mitigate performance impact
const $922e4f3af59e4fb5$var$TABLE_WIDTH_INFO_TIMEOUT = 10000;
/**
 * Table plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $922e4f3af59e4fb5$var$tablePlugin = ({ config: config, api: api })=>{
    var _api$analytics, _options$getEditorFea;
    const editorViewRef = {
        current: null
    };
    const options = {
        ...config,
        tableOptions: (config === null || config === void 0 ? void 0 : config.tableOptions) ?? {},
        isTableScalingEnabled: true
    };
    const defaultGetEditorContainerWidth = ()=>{
        var _api$width, _document;
        return (api === null || api === void 0 || (_api$width = api.width) === null || _api$width === void 0 ? void 0 : _api$width.sharedState.currentState()) ?? {
            width: ((_document = document) === null || _document === void 0 || (_document = _document.body) === null || _document === void 0 ? void 0 : _document.offsetWidth) ?? 500
        };
    };
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const isTableFixedColumnWidthsOptionEnabled = options === null || options === void 0 ? void 0 : options.allowFixedColumnWidthOption;
    const shouldUseIncreasedScalingPercent = (options === null || options === void 0 ? void 0 : options.isTableScalingEnabled) && (isTableFixedColumnWidthsOptionEnabled || (options === null || options === void 0 ? void 0 : options.isCommentEditor));
    const isTableSelectorEnabled = // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    !(options !== null && options !== void 0 && options.isChromelessEditor) && !(options !== null && options !== void 0 && options.isCommentEditor) && (options === null || options === void 0 || (_options$getEditorFea = options.getEditorFeatureFlags) === null || _options$getEditorFea === void 0 ? void 0 : _options$getEditorFea.call(options).tableSelector) && (0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1');
    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $659mW.getTableMenuComponents)({
            api: api
        }));
    }
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command')) {
        var _api$uiControlRegistr2;
        api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 || _api$uiControlRegistr2.actions.register((0, $5afEq.getTableQuickInsertComponents)({
            api: api,
            isTableSelectorEnabled: isTableSelectorEnabled,
            options: options
        }));
    }
    return {
        name: 'table',
        // Use getSharedState to store fullWidthEnabled and wasFullWidthModeEnabled to guarantee access
        // to most up to date values - passing to createPluginState will not re-initialise the state
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const tablePluginState = (0, $4dyXt.pluginKey).getState(editorState);
            const tableResizingPluginState = (0, $6xtYM.getPluginState)(editorState);
            const tableWidthResizingPluginState = (0, $8aCba.pluginKey).getState(editorState);
            const stickyHeadersState = (0, $fkY0k.pluginKey).getState(editorState);
            const stickyHeader = stickyHeadersState ? (0, $AGA3t.findStickyHeaderForTable)(stickyHeadersState, tablePluginState === null || tablePluginState === void 0 ? void 0 : tablePluginState.tablePos) : undefined;
            const dragAndDropState = (0, $eU2qH.pluginKey).getState(editorState);
            const sizeSelectorPluginState = (0, $lcU8V.pluginKey).getState(editorState);
            const editorContentAreaHeightPluginState = (0, $cbJui.pluginKey).getState(editorState);
            const sharedStateInternal = {
                isFullWidthModeEnabled: !!(options !== null && options !== void 0 && options.fullWidthEnabled),
                wasFullWidthModeEnabled: !!(options !== null && options !== void 0 && options.wasFullWidthEnabled),
                isMaxWidthModeEnabled: !!(options !== null && options !== void 0 && options.maxWidthEnabled),
                wasMaxWidthModeEnabled: !!(options !== null && options !== void 0 && options.wasMaxWidthEnabled),
                isHeaderRowEnabled: tablePluginState.isHeaderRowEnabled,
                isHeaderColumnEnabled: tablePluginState.isHeaderColumnEnabled,
                isNumberColumnEnabled: tablePluginState.isNumberColumnEnabled,
                isCommentEditor: tablePluginState.isCommentEditor,
                isTableScalingEnabled: tablePluginState.isTableScalingEnabled,
                isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
                ordering: tablePluginState.ordering,
                isResizing: !!(tableResizingPluginState !== null && tableResizingPluginState !== void 0 && tableResizingPluginState.dragging || tableWidthResizingPluginState !== null && tableWidthResizingPluginState !== void 0 && tableWidthResizingPluginState.resizing),
                isTableResizing: tableWidthResizingPluginState === null || tableWidthResizingPluginState === void 0 ? void 0 : tableWidthResizingPluginState.resizing,
                isInDanger: tablePluginState.isInDanger,
                hoveredRows: tablePluginState.hoveredRows,
                hoveredColumns: tablePluginState.hoveredColumns,
                hoveredCell: tablePluginState.hoveredCell,
                isTableHovered: tablePluginState.isTableHovered,
                isWholeTableInDanger: tablePluginState.isWholeTableInDanger,
                // IMPORTANT: Need to continue to pass tableNode to control re-renders
                // TableComponent listens for node attribute changes to update colgroups
                tableNode: tablePluginState.tableNode,
                widthToWidest: tablePluginState.widthToWidest,
                resizingTableLocalId: tableWidthResizingPluginState === null || tableWidthResizingPluginState === void 0 ? void 0 : tableWidthResizingPluginState.tableLocalId,
                tableRef: (tablePluginState === null || tablePluginState === void 0 ? void 0 : tablePluginState.tableRef) ?? undefined,
                resizingTableRef: (tableWidthResizingPluginState === null || tableWidthResizingPluginState === void 0 ? void 0 : tableWidthResizingPluginState.tableRef) ?? undefined,
                tablePos: tablePluginState.tablePos,
                targetCellPosition: tablePluginState.targetCellPosition,
                isContextualMenuOpen: tablePluginState.isContextualMenuOpen,
                pluginConfig: tablePluginState.pluginConfig,
                insertColumnButtonIndex: tablePluginState.insertColumnButtonIndex,
                insertRowButtonIndex: tablePluginState.insertRowButtonIndex,
                tableWrapperTarget: tablePluginState.tableWrapperTarget,
                isCellMenuOpenByKeyboard: tablePluginState.isCellMenuOpenByKeyboard,
                activeTableMenu: tablePluginState.activeTableMenu,
                stickyHeader: stickyHeader,
                dragMenuDirection: dragAndDropState === null || dragAndDropState === void 0 ? void 0 : dragAndDropState.dragMenuDirection,
                dragMenuIndex: dragAndDropState === null || dragAndDropState === void 0 ? void 0 : dragAndDropState.dragMenuIndex,
                isDragMenuOpen: dragAndDropState === null || dragAndDropState === void 0 ? void 0 : dragAndDropState.isDragMenuOpen,
                isSizeSelectorOpen: sizeSelectorPluginState === null || sizeSelectorPluginState === void 0 ? void 0 : sizeSelectorPluginState.isSelectorOpen,
                sizeSelectorTargetRef: sizeSelectorPluginState === null || sizeSelectorPluginState === void 0 ? void 0 : sizeSelectorPluginState.targetRef,
                editorContentAreaHeight: editorContentAreaHeightPluginState === null || editorContentAreaHeightPluginState === void 0 ? void 0 : editorContentAreaHeightPluginState.height
            };
            return sharedStateInternal;
        },
        actions: {
            insertTable: (analyticsPayload)=>(state, dispatch)=>{
                    var _options$tableOptions;
                    if (options !== null && options !== void 0 && (_options$tableOptions = options.tableOptions) !== null && _options$tableOptions !== void 0 && _options$tableOptions.allowNestedTables) return (0, $cTbwC.editorCommandToPMCommand)((0, $jEslx.insertTableWithNestingSupport)({
                        isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
                        isTableAlignmentEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableAlignment,
                        isFullWidthModeEnabled: options === null || options === void 0 ? void 0 : options.fullWidthEnabled,
                        isMaxWidthModeEnabled: options === null || options === void 0 ? void 0 : options.maxWidthEnabled,
                        isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
                        isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor,
                        isTableResizingEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing
                    }, api, analyticsPayload))(state, dispatch);
                    else {
                        var _api$contentInsertion;
                        const node = (0, $l1ZbO.createTableWithWidth)({
                            isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
                            isTableAlignmentEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableAlignment,
                            isFullWidthModeEnabled: options === null || options === void 0 ? void 0 : options.fullWidthEnabled,
                            isMaxWidthModeEnabled: options === null || options === void 0 ? void 0 : options.maxWidthEnabled,
                            isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
                            isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor,
                            isTableResizingEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing
                        })(state.schema);
                        return (api === null || api === void 0 || (_api$contentInsertion = api.contentInsertion) === null || _api$contentInsertion === void 0 || (_api$contentInsertion = _api$contentInsertion.actions) === null || _api$contentInsertion === void 0 ? void 0 : _api$contentInsertion.insert({
                            state: state,
                            dispatch: dispatch,
                            node: node,
                            options: {
                                selectNodeInserted: false,
                                analyticsPayload: {
                                    ...analyticsPayload,
                                    attributes: {
                                        ...analyticsPayload.attributes,
                                        localId: node.attrs.localId
                                    }
                                }
                            }
                        })) ?? false;
                    }
                }
        },
        commands: {
            insertTableWithSize: (rowsCount, colsCount, inputMethod)=>(0, $jEslx.insertTableWithNestingSupport)({
                    isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
                    isTableAlignmentEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableAlignment,
                    isFullWidthModeEnabled: options === null || options === void 0 ? void 0 : options.fullWidthEnabled,
                    isMaxWidthModeEnabled: options === null || options === void 0 ? void 0 : options.maxWidthEnabled,
                    isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
                    isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor,
                    isTableResizingEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing,
                    createTableProps: {
                        rowsCount: rowsCount,
                        colsCount: colsCount
                    }
                }, api, {
                    action: (0, $3LeME.ACTION).INSERTED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod ?? (0, $3LeME.INPUT_METHOD).PICKER,
                        totalRowCount: rowsCount,
                        totalColumnCount: colsCount
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })
        },
        nodes () {
            var _options$tableOptions2;
            const { allowColumnResizing: allowColumnResizing } = (0, $d9DFt.pluginConfig)(options === null || options === void 0 ? void 0 : options.tableOptions);
            // TODO: ED-25901 - We need to move this into a plugin config option so we don't accidentally enable nested nodes in Jira
            const isNestingSupported = Boolean(options === null || options === void 0 || (_options$tableOptions2 = options.tableOptions) === null || _options$tableOptions2 === void 0 ? void 0 : _options$tableOptions2.allowNestedTables);
            const isTableScalingEnabled = options === null || options === void 0 ? void 0 : options.isTableScalingEnabled;
            const isCommentEditor = options === null || options === void 0 ? void 0 : options.isCommentEditor;
            const isChromelessEditor = options === null || options === void 0 ? void 0 : options.isChromelessEditor;
            return isNestingSupported ? [
                {
                    name: 'table',
                    node: (0, $6Waiv.tableNodeSpecWithFixedToDOM)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $63Q5S.tableHeaderWithNestedTableWithLocalId) : (0, $63Q5S.tableHeaderWithNestedTable)
                },
                {
                    name: 'tableRow',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $63Q5S.tableRowWithNestedTableWithLocalId) : (0, $63Q5S.tableRowWithNestedTable)
                },
                {
                    name: 'tableCell',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $63Q5S.tableCellWithNestedTableWithLocalId) : (0, $63Q5S.tableCellWithNestedTable)
                }
            ] : [
                {
                    name: 'table',
                    node: (0, $6Waiv.tableNodeSpecWithFixedToDOM)({
                        allowColumnResizing: Boolean(allowColumnResizing),
                        tableResizingEnabled: Boolean(options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing),
                        getEditorContainerWidth: defaultGetEditorContainerWidth,
                        isNestingSupported: isNestingSupported,
                        isTableScalingEnabled: isTableScalingEnabled,
                        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                        isCommentEditor: isCommentEditor,
                        isChromelessEditor: isChromelessEditor
                    })
                },
                {
                    name: 'tableHeader',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $63Q5S.tableHeaderWithLocalId) : (0, $63Q5S.tableHeader)
                },
                {
                    name: 'tableRow',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $63Q5S.tableRowWithLocalId) : (0, $63Q5S.tableRow)
                },
                {
                    name: 'tableCell',
                    node: (0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $63Q5S.tableCellWithLocalId) : (0, $63Q5S.tableCell)
                }
            ];
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'table',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, portalProviderAPI: portalProviderAPI, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, eventDispatcher: eventDispatcher, getIntl: getIntl })=>{
                        const { fullWidthEnabled: fullWidthEnabled, wasFullWidthEnabled: wasFullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, __livePage: __livePage } = options || {};
                        return (0, $iXpZM.createPlugin)(dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, (0, $d9DFt.pluginConfig)(tableOptions), defaultGetEditorContainerWidth, getEditorFeatureFlags || $922e4f3af59e4fb5$var$defaultGetEditorFeatureFlags, getIntl, fullWidthEnabled, wasFullWidthEnabled, editorAnalyticsAPI, api, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableFixedColumnWidthsOptionEnabled, __livePage);
                    }
                },
                {
                    name: 'tablePMColResizing',
                    plugin: ({ dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { fullWidthEnabled: fullWidthEnabled, tableOptions: tableOptions, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled } = options || {};
                        const { allowColumnResizing: allowColumnResizing } = (0, $d9DFt.pluginConfig)(tableOptions);
                        return allowColumnResizing ? (0, $6ixVH.createPlugin)(dispatch, {
                            lastColumnResizable: !fullWidthEnabled
                        }, defaultGetEditorContainerWidth, getEditorFeatureFlags || $922e4f3af59e4fb5$var$defaultGetEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled || false, !!(options !== null && options !== void 0 && options.isCommentEditor)) : undefined;
                    }
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>(0, $f3xW3.createPlugin)()
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing backspace events inside tables
                {
                    name: 'tableKeymap',
                    plugin: ({ getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        const { isTableScalingEnabled: isTableScalingEnabled = false, fullWidthEnabled: fullWidthEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, tableOptions: tableOptions } = options || {};
                        return (0, $4OlZB.keymapPlugin)(defaultGetEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.allowTableAlignment, fullWidthEnabled, api, getIntl, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, tableOptions === null || tableOptions === void 0 ? void 0 : tableOptions.allowTableResizing);
                    }
                },
                {
                    name: 'tableSelectionKeymap',
                    plugin: ({ getIntl: getIntl })=>(0, $ivUuF.tableSelectionKeymapPlugin)(api, getIntl)
                },
                {
                    name: 'tableEditing',
                    plugin: ()=>{
                        return (0, $4Pdzq.tableEditing)({
                            reportFixedTable: ({ tr: tr, reason: reason })=>{
                                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                                    action: (0, $8d4kB.TABLE_ACTION).FIXED,
                                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                                    actionSubjectId: null,
                                    attributes: {
                                        reason: reason
                                    },
                                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                                })(tr);
                            }
                        });
                    }
                },
                {
                    name: 'tableStickyHeaders',
                    plugin: ({ dispatch: dispatch })=>options && options.tableOptions.stickyHeaders ? (0, $by4QE.createPlugin)(dispatch, ()=>[]) : undefined
                },
                {
                    name: 'tableDragAndDrop',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $a1g0P.createPlugin)(dispatch, editorAnalyticsAPI, options === null || options === void 0 ? void 0 : options.isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options.isCommentEditor, api);
                    }
                },
                {
                    name: 'tableViewModeSort',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return api !== null && api !== void 0 && api.editorViewMode ? (0, $fuhDl.createPlugin)(api, nodeViewPortalProviderAPI) : undefined;
                    }
                },
                {
                    name: 'tableLocalId',
                    plugin: ({ dispatch: dispatch })=>!(0, $dRkX9.fg)('platform_editor_adf_with_localid') ? (0, $iUkHD.createPlugin)(dispatch) : undefined
                },
                {
                    name: 'tableWidth',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch })=>options !== null && options !== void 0 && options.tableOptions.allowTableResizing ? (0, $8aCba.createPlugin)(dispatch, dispatchAnalyticsEvent, options.fullWidthEnabled ?? false, options.maxWidthEnabled ?? false, options.isTableScalingEnabled ?? false, options.tableOptions.allowTableResizing ?? false, options.isCommentEditor ?? false) : undefined
                },
                {
                    name: 'tableWidthInCommentFix',
                    plugin: ({ dispatch: dispatch })=>options !== null && options !== void 0 && options.tableOptions.allowTableResizing && options !== null && options !== void 0 && options.isCommentEditor ? (0, $cD6dM.createPlugin)(dispatch, options.tableOptions.allowTableAlignment ?? false) : undefined
                },
                // TODO: ED-26961 - should be deprecated and eventually replaced with 'tableAnalyticsPlugin'
                {
                    name: 'tableOverflowAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $lh6cf.createPlugin)(dispatch, dispatchAnalyticsEvent, (options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing) ?? false)
                },
                {
                    name: 'tableAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $2QInN.createPlugin)(dispatch, dispatchAnalyticsEvent)
                },
                {
                    name: 'tableGetEditorViewReferencePlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                        return new (0, $1y7gE.SafePlugin)({
                            view: (editorView)=>{
                                editorViewRef.current = editorView;
                                let rafID;
                                let ricID;
                                // send statistics about the widths of the tables on the page for alerting
                                // only send this event once, after the editorView is first initialised
                                const setTimeoutID = setTimeout(()=>{
                                    const requestIdleCallbackFn = ()=>{
                                        var _api$width$sharedStat;
                                        const editorWidth = api === null || api === void 0 || (_api$width$sharedStat = api.width.sharedState.currentState()) === null || _api$width$sharedStat === void 0 ? void 0 : _api$width$sharedStat.width;
                                        if (editorViewRef.current) {
                                            if (editorWidth) {
                                                const payload = (0, $4Bf8g.getWidthInfoPayload)(editorViewRef.current, editorWidth);
                                                if (payload) dispatchAnalyticsEvent(payload);
                                            }
                                            const payloadHeight = (0, $4Bf8g.getHeightInfoPayload)(editorViewRef.current);
                                            if (payloadHeight) dispatchAnalyticsEvent(payloadHeight);
                                        }
                                    };
                                    if (window && typeof window.requestIdleCallback === 'function') ricID = window.requestIdleCallback(requestIdleCallbackFn);
                                    else if (window && typeof window.requestAnimationFrame === 'function') // requestIdleCallback is not supported in safari, fallback to requestAnimationFrame
                                    rafID = window.requestAnimationFrame(requestIdleCallbackFn);
                                }, $922e4f3af59e4fb5$var$TABLE_WIDTH_INFO_TIMEOUT);
                                return {
                                    destroy: ()=>{
                                        editorViewRef.current = null;
                                        if (setTimeoutID) clearTimeout(setTimeoutID);
                                        if (rafID) window.cancelAnimationFrame(rafID);
                                        if (ricID) window.cancelIdleCallback(ricID);
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'tableSizeSelectorPlugin',
                    plugin: ({ dispatch: dispatch })=>isTableSelectorEnabled ? (0, $lcU8V.createPlugin)(dispatch) : undefined
                },
                {
                    name: 'editorContentAreaHeightPlugin',
                    plugin: ()=>(0, $cbJui.createPlugin)()
                }
            ];
            if (!(0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) plugins.push({
                name: 'tableAnchorNames',
                plugin: ()=>(0, $2LcYo.createPlugin)()
            });
            if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) plugins.push({
                name: 'tableActiveCellHighlight',
                plugin: ()=>(0, $d5kki.createPlugin)(api)
            });
            const browser = (0, $dqFZv.getBrowserInfo)();
            // Workaround for table element breaking issue caused by composition event with an inputType of deleteCompositionText.
            // https://github.com/ProseMirror/prosemirror/issues/934
            if (browser.safari) plugins.push({
                name: 'tableSafariDeleteCompositionTextIssueWorkaround',
                plugin: ()=>{
                    return (0, $dfb9x.createPlugin)();
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kYtNC.ContentComponent), {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: $922e4f3af59e4fb5$var$defaultGetEditorFeatureFlags,
                isTableSelectorEnabled: isTableSelectorEnabled
            });
        },
        pluginsOptions: {
            ...(0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command') ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'table',
                            title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).table),
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).tableDescription),
                            keywords: [
                                'cell',
                                'table'
                            ],
                            priority: 600,
                            keyshortcut: (0, $eUtBU.tooltip)((0, $eUtBU.toggleTable)),
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $42nnk.IconTable), {}),
                            action (insert, state) {
                                var _api$table, _options$tableOptions3, _tr$selection$$from$n;
                                // Keep this legacy path aligned with insertTableFromQuickInsert during rollout.
                                if (isTableSelectorEnabled) {
                                    const tr = insert('');
                                    tr.setMeta((0, $lcU8V.pluginKey), {
                                        isSelectorOpen: true
                                    });
                                    return tr;
                                }
                                // see comment on tablesPlugin.getSharedState on usage
                                const tableState = api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 ? void 0 : _api$table.sharedState.currentState();
                                const tableNodeProps = {
                                    isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
                                    isTableAlignmentEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableAlignment,
                                    isFullWidthModeEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isFullWidthModeEnabled,
                                    isMaxWidthModeEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isMaxWidthModeEnabled,
                                    isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
                                    isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor,
                                    isTableResizingEnabled: options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing
                                };
                                let tableNode = (0, $l1ZbO.createTableWithWidth)(tableNodeProps)(state.schema);
                                let { tr: tr } = state;
                                // If the cursor is inside a table
                                if ((0, $a4TQr.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) && options !== null && options !== void 0 && (_options$tableOptions3 = options.tableOptions) !== null && _options$tableOptions3 !== void 0 && _options$tableOptions3.allowNestedTables) {
                                    // If trying to nest deeper than one level, we insert the table after the top table
                                    if ((0, $5DGsr.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1) {
                                        // Nesting is too deep insert table after the top parent table
                                        const positionAfterTopTable = (0, $89pmn.getPositionAfterTopParentNodeOfType)(state.schema.nodes.table)(state.selection.$from);
                                        tr = (0, $a4TQr.safeInsert)(tableNode, positionAfterTopTable)(tr);
                                        tr.scrollIntoView();
                                    } else {
                                        // Table can be nested in parent table
                                        tableNode = (0, $l1ZbO.createTableWithWidth)({
                                            ...tableNodeProps,
                                            isNestedTable: true
                                        })(state.schema);
                                        tr = insert(tableNode);
                                    }
                                } else tr = insert(tableNode);
                                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                                    action: (0, $3LeME.ACTION).INSERTED,
                                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE,
                                    attributes: {
                                        inputMethod: (0, $3LeME.INPUT_METHOD).QUICK_INSERT,
                                        localId: tableNode.attrs.localId,
                                        ...(0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                                            parentNode: (_tr$selection$$from$n = tr.selection.$from.node(-1)) === null || _tr$selection$$from$n === void 0 ? void 0 : _tr$selection$$from$n.type.name
                                        } : {}
                                    },
                                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            floatingToolbar: (0, $7a5j7.getToolbarConfig)(defaultGetEditorContainerWidth, api, editorAnalyticsAPI, ()=>editorViewRef.current, options, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $d9DFt.pluginConfig)(options === null || options === void 0 ? void 0 : options.tableOptions))
        },
        usePluginHook ({ editorView: editorView }) {
            const { mode: mode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
                'editorViewMode'
            ], (states)=>{
                var _states$editorViewMod;
                return {
                    mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
                };
            });
            (0, $fc4bM.useEffect)(()=>{
                const { state: state, dispatch: dispatch } = editorView;
                const tr = state.tr;
                tr.setMeta('viewModeState', mode);
                if (dispatch) dispatch(tr);
            }, [
                editorView,
                mode
            ]);
        }
    };
};
var $922e4f3af59e4fb5$export$2e2bcd8739ae039 = $922e4f3af59e4fb5$var$tablePlugin;

});
parcelRegister("42nnk", function(module, exports) {
$parcel$export(module.exports, "IconTable", () => $4ab3dc237f31deeb$export$84f497075f5b07be);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $ieUrC = parcelRequire("ieUrC");

var $bcN2K = parcelRequire("bcN2K");









const $4ab3dc237f31deeb$var$loadIconTable = ()=>(parcelRequire("ltZD1")).then((module)=>module.default);

const $4ab3dc237f31deeb$var$IconTableLazy = (0, $ieUrC.lazy)(()=>(parcelRequire("ltZD1")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/icons/shared/table.tsx"
});
$4ab3dc237f31deeb$var$IconTableLazy.displayName = 'lazy(IconTable)';
const $4ab3dc237f31deeb$var$IconTableLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: $4ab3dc237f31deeb$var$loadIconTable,
    loading: ()=>null
});
const $4ab3dc237f31deeb$export$84f497075f5b07be = (props)=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ieUrC.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)($4ab3dc237f31deeb$var$IconTableLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $3LM7S.jsx)($4ab3dc237f31deeb$var$IconTableLoadable, {
        ...props
    });
$4ab3dc237f31deeb$export$84f497075f5b07be.preload = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $4ab3dc237f31deeb$var$IconTableLazy.preload() : $4ab3dc237f31deeb$var$IconTableLoadable.preload();

});
parcelRegister("ltZD1", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kjNuO").then(()=>parcelRequire('gdGjP'));

});


parcelRegister("4Pdzq", function(module, exports) {
$parcel$export(module.exports, "tableEditing", () => $55f82ec0439f2819$export$e382fe3f780a6548);

var $801jp = parcelRequire("801jp");

var $a2cQJ = parcelRequire("a2cQJ");

var $j3wWN = parcelRequire("j3wWN");

var $6dtlv = parcelRequire("6dtlv");

var $44KzZ = parcelRequire("44KzZ");

var $7YR4Y = parcelRequire("7YR4Y");

var $loeS1 = parcelRequire("loeS1");

var $eh0eG = parcelRequire("eh0eG");

var $eqzvq = parcelRequire("eqzvq");
function $55f82ec0439f2819$export$e382fe3f780a6548({ allowTableNodeSelection: allowTableNodeSelection = false, reportFixedTable: reportFixedTable } = {}) {
    return new (0, $801jp.Plugin)({
        key: (0, $eqzvq.tableEditingKey),
        // This piece of state is used to remember when a mouse-drag
        // cell-selection is happening, so that it can continue even as
        // transactions (which might move its anchor cell) come in.
        state: {
            init () {
                return null;
            },
            apply (unsafeTr, cur) {
                const tr = unsafeTr;
                const set = tr.getMeta((0, $eqzvq.tableEditingKey));
                if (set != null) return set === -1 ? null : set;
                if (cur == null || !tr.docChanged) return cur;
                const { deleted: deleted, pos: pos } = tr.mapping.mapResult(cur);
                return deleted ? null : pos;
            }
        },
        props: {
            decorations: (0, $j3wWN.drawCellSelection),
            handleDOMEvents: {
                mousedown: (view, event)=>{
                    (0, $7YR4Y.handleMouseDown)(view, event);
                }
            },
            createSelectionBetween (view) {
                if ((0, $eqzvq.tableEditingKey).getState(view.state) != null) return view.state.selection;
                return null;
            },
            handleTripleClick: $loeS1.handleTripleClick,
            handleKeyDown: $eh0eG.handleKeyDown,
            handlePaste: $a2cQJ.handlePaste
        },
        appendTransaction (_, oldState, state) {
            return (0, $44KzZ.normalizeSelection)(state, (0, $6dtlv.fixTables)(state, oldState, reportFixedTable), allowTableNodeSelection);
        }
    });
}

});
parcelRegister("j3wWN", function(module, exports) {
$parcel$export(module.exports, "drawCellSelection", () => $a912ad1e72cfa402$export$938a078fa3e1d420);

var $16ZMX = parcelRequire("16ZMX");

var $ev7OZ = parcelRequire("ev7OZ");
function $a912ad1e72cfa402$export$938a078fa3e1d420(state) {
    if (!(state.selection instanceof (0, $ev7OZ.CellSelection))) return null;
    const cells = [];
    state.selection.forEachCell((node, pos)=>{
        cells.push((0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, {
            class: 'selectedCell'
        }));
    });
    return (0, $16ZMX.DecorationSet).create(state.doc, cells);
}

});

parcelRegister("6dtlv", function(module, exports) {
$parcel$export(module.exports, "fixTables", () => $f3680a114bb29fb4$export$d6d48849d9121a1);

var $3APNV = parcelRequire("3APNV");

var $4OhZt = parcelRequire("4OhZt");
function $f3680a114bb29fb4$export$d6d48849d9121a1(state, oldState, reportFixedTable) {
    let tr;
    const check = (node, pos)=>{
        if (node.type.spec.tableRole === 'table') tr = (0, $4OhZt.fixTable)(state, node, pos, tr, reportFixedTable);
    };
    if (!oldState) state.doc.descendants(check);
    else if (oldState.doc !== state.doc) (0, $3APNV.changedDescendants)(oldState.doc, state.doc, 0, check);
    return tr;
}

});
parcelRegister("3APNV", function(module, exports) {
$parcel$export(module.exports, "changedDescendants", () => $a1595011673af91b$export$1d23e2adc8552128);
function $a1595011673af91b$export$1d23e2adc8552128(old, cur, offsetStart, f) {
    let offset = offsetStart;
    const oldSize = old.childCount;
    const curSize = cur.childCount;
    // eslint-disable-next-line no-labels
    outer: for(let i = 0, j = 0; i < curSize; i++){
        const child = cur.child(i);
        for(let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++)if (old.child(scan) === child) {
            j = scan + 1;
            offset += child.nodeSize;
            continue outer;
        }
        f(child, offset);
        if (j < oldSize && old.child(j).sameMarkup(child)) $a1595011673af91b$export$1d23e2adc8552128(old.child(j), child, offset + 1, f);
        else child.nodesBetween(0, child.content.size, f, offset + 1);
        offset += child.nodeSize;
    }
}

});

parcelRegister("4OhZt", function(module, exports) {
$parcel$export(module.exports, "fixTable", () => $ab34ff93b3324e3f$export$26dfac117c7732d8);

var $eqzvq = parcelRequire("eqzvq");

var $dpooP = parcelRequire("dpooP");

var $9fk2x = parcelRequire("9fk2x");

var $9HFsx = parcelRequire("9HFsx");
function $ab34ff93b3324e3f$export$26dfac117c7732d8(state, table, tablePos, transaction, reportFixedTable) {
    let tr = transaction;
    const map = (0, $dpooP.TableMap).get(table);
    if (!map.problems) return tr;
    if (!tr) tr = state.tr;
    // Track which rows we must add cells to, so that we can adjust that
    // when fixing collisions.
    const mustAdd = [];
    for(let i = 0; i < map.height; i++)mustAdd.push(0);
    for(let i = 0; i < map.problems.length; i++){
        const prob = map.problems[i];
        if (reportFixedTable) reportFixedTable({
            state: state,
            tr: tr,
            reason: prob.type || 'unknown'
        });
        if (prob.type === (0, $dpooP.TableProblemTypes).COLLISION) {
            const collision = prob;
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            for(let j = 0; j < cell.attrs.rowspan; j++)mustAdd[collision.row + j] += collision.n;
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, (0, $9fk2x.removeColSpan)(cell.attrs, cell.attrs.colspan - collision.n, collision.n));
        } else if (prob.type === (0, $dpooP.TableProblemTypes).MISSING) {
            const missing = prob;
            mustAdd[missing.row] += missing.n;
        } else if (prob.type === (0, $dpooP.TableProblemTypes).OVERLONG_ROWSPAN) {
            const overlong = prob;
            const cell = table.nodeAt(overlong.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + overlong.pos), undefined, {
                ...cell.attrs,
                rowspan: cell.attrs.rowspan - overlong.n
            });
        } else if (prob.type === (0, $dpooP.TableProblemTypes).COLWIDTH_MISMATCH) {
            const cell = table.nodeAt(prob.pos);
            if (!cell) throw new Error(`fixTable: unable to find cell at pos ${prob.pos}`);
            tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), undefined, {
                ...cell.attrs,
                colwidth: prob.colwidth
            });
        }
    }
    let first;
    let last;
    for(let i = 0; i < mustAdd.length; i++)if (mustAdd[i]) {
        if (first == null) first = i;
        last = i;
    }
    // Add the necessary cells, using a heuristic for whether to add the
    // cells at the start or end of the rows (if it looks like a 'bite'
    // was taken out of the table, add cells at the start of the row
    // after the bite. Otherwise add them at the end).
    for(let i = 0, pos = tablePos + 1; i < map.height; i++){
        const row = table.child(i);
        const end = pos + row.nodeSize;
        const add = mustAdd[i];
        if (add > 0) {
            let tableNodeType = 'cell';
            if (row.firstChild) tableNodeType = row.firstChild.type.spec.tableRole;
            const nodes = [];
            for(let j = 0; j < add; j++)// Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            nodes.push((0, $9HFsx.tableNodeTypes)(state.schema)[tableNodeType].createAndFill());
            const side = (i === 0 || first === i - 1) && last === i ? pos + 1 : end - 1;
            tr.insert(tr.mapping.map(side), nodes);
        }
        pos = end;
    }
    return tr.setMeta((0, $eqzvq.fixTablesKey), {
        fixTables: true
    });
}

});
parcelRegister("eqzvq", function(module, exports) {
$parcel$export(module.exports, "tableEditingKey", () => $fe63648cb862694f$export$8dc63188bf2e0962);
$parcel$export(module.exports, "fixTablesKey", () => $fe63648cb862694f$export$9731ba46aee163cb);

var $801jp = parcelRequire("801jp");
const $fe63648cb862694f$export$8dc63188bf2e0962 = new (0, $801jp.PluginKey)('selectingCells');
const $fe63648cb862694f$export$9731ba46aee163cb = new (0, $801jp.PluginKey)('fix-tables');

});



parcelRegister("44KzZ", function(module, exports) {
$parcel$export(module.exports, "normalizeSelection", () => $019520a5751856d8$export$64b8795b15903d8d);

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $019520a5751856d8$var$ROW_OR_TABLE_ROLE_REGEX = /row|table/;
function $019520a5751856d8$export$64b8795b15903d8d(state, transaction, allowTableNodeSelection) {
    let tr = transaction;
    const sel = (tr || state).selection;
    const { doc: doc } = tr || state;
    let normalize;
    let role;
    if (sel instanceof (0, $801jp.NodeSelection)) role = sel.node.type.spec.tableRole;
    if (sel instanceof (0, $801jp.NodeSelection) && role) {
        if (role === 'cell' || role === 'header_cell') normalize = (0, $ev7OZ.CellSelection).create(doc, sel.from);
        else if (role === 'row') {
            const $cell = doc.resolve(sel.from + 1);
            normalize = (0, $ev7OZ.CellSelection).rowSelection($cell, $cell);
        } else if (!allowTableNodeSelection) {
            const map = (0, $dpooP.TableMap).get(sel.node);
            const start = sel.from + 1;
            const lastCell = start + map.map[map.width * map.height - 1];
            normalize = (0, $ev7OZ.CellSelection).create(doc, start + 1, lastCell);
        }
    } else if (sel instanceof (0, $801jp.TextSelection) && $019520a5751856d8$var$isCellBoundarySelection(sel)) normalize = (0, $801jp.TextSelection).create(doc, sel.from);
    else if (sel instanceof (0, $801jp.TextSelection) && $019520a5751856d8$var$isTextSelectionAcrossSameTableCells(sel)) normalize = (0, $801jp.TextSelection).create(doc, sel.$from.start(), sel.$from.end());
    if (normalize) (tr || (tr = state.tr)).setSelection(normalize);
    return tr;
}
function $019520a5751856d8$var$isCellBoundarySelection({ $from: $from, $to: $to }) {
    if ($from.pos === $to.pos || $from.pos < $from.pos - 6) return false;
     // Cheap elimination
    let afterFrom = $from.pos;
    let beforeTo = $to.pos;
    let { depth: depth } = $from;
    for(; depth >= 0; depth--, afterFrom++){
        if ($from.after(depth + 1) < $from.end(depth)) break;
    }
    for(let d = $to.depth; d >= 0; d--, beforeTo--){
        if ($to.before(d + 1) > $to.start(d)) break;
    }
    return afterFrom === beforeTo && $019520a5751856d8$var$ROW_OR_TABLE_ROLE_REGEX.test($from.node(depth).type.spec.tableRole);
}
function $019520a5751856d8$var$isTextSelectionAcrossSameTableCells({ $from: $from, $to: $to }) {
    let fromCellBoundaryNode;
    let toCellBoundaryNode;
    let fromCellTableNode;
    let toCellTableNode;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') fromCellBoundaryNode = node;
        if (node.type.name === 'table') {
            fromCellTableNode = node;
            break;
        }
    }
    for(let i = $to.depth; i > 0; i--){
        const node = $to.node(i);
        if (node.type.spec.tableRole === 'cell' || node.type.spec.tableRole === 'header_cell') toCellBoundaryNode = node;
        if (node.type.name === 'table') {
            toCellTableNode = node;
            break;
        }
    }
    return fromCellBoundaryNode !== undefined && toCellBoundaryNode !== undefined && fromCellBoundaryNode !== toCellBoundaryNode && toCellTableNode === fromCellTableNode && $to.parentOffset === 0;
}

});

parcelRegister("7YR4Y", function(module, exports) {
$parcel$export(module.exports, "handleMouseDown", () => $4be35d147053c9ad$export$b4a93e0b711d8f7);
// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $ev7OZ = parcelRequire("ev7OZ");

var $5JFXS = parcelRequire("5JFXS");

var $gNVxw = parcelRequire("gNVxw");

var $9CB3n = parcelRequire("9CB3n");

var $eqzvq = parcelRequire("eqzvq");
function $4be35d147053c9ad$var$domInCell(view, inputDom) {
    let dom = inputDom;
    for(; dom && dom !== view.dom; dom = dom.parentNode){
        if (dom.nodeName === 'TD' || dom.nodeName === 'TH') return dom;
    }
    return null;
}
function $4be35d147053c9ad$var$cellUnderMouse(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return null;
    return (0, $gNVxw.cellAround)(view.state.doc.resolve(mousePos.pos));
}
function $4be35d147053c9ad$var$isInsideNestedTable(view, event) {
    const mousePos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (!mousePos) return false;
    const pos = view.state.doc.resolve(mousePos.pos);
    const table = (0, $5JFXS.findTableClosestToPos)(pos);
    if (!table) return false;
    const parent = view.state.doc.resolve(table.pos).parent;
    const nodeTypes = view.state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
}
function $4be35d147053c9ad$export$b4a93e0b711d8f7(view, event) {
    const startEvent = event;
    // Prevent right clicks from making a cell selection https://product-fabric.atlassian.net/browse/ED-12527
    if (startEvent.ctrlKey || startEvent.metaKey || startEvent.button === 2 // right mouse click
    ) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const startDOMCell = $4be35d147053c9ad$var$domInCell(view, startEvent.target);
    const $anchor = (0, $gNVxw.cellAround)(view.state.selection.$anchor);
    if (startEvent.shiftKey && view.state.selection instanceof (0, $ev7OZ.CellSelection)) {
        const targetElement = event.target instanceof HTMLElement || event.target instanceof SVGElement ? event.target : null;
        const isDragHandleElement = !!targetElement && !!targetElement.closest('button.pm-table-drag-handle-button-container, button.pm-table-drag-handle-button-clickable-zone');
        if (isDragHandleElement) return false;
        setCellSelection(view.state.selection.$anchorCell, startEvent);
        startEvent.preventDefault();
    } else if (startEvent.shiftKey && startDOMCell && $anchor !== null && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $4be35d147053c9ad$var$cellUnderMouse(view, startEvent).pos !== $anchor.pos) {
        // Adding to a selection that starts in another cell (causing a
        // cell selection to be created).
        setCellSelection($anchor, startEvent);
        startEvent.preventDefault();
    } else if (!startDOMCell) // Not in a cell, let the default behavior happen.
    return false;
    // Create and dispatch a cell selection between the given anchor and
    // the position under the mouse.
    function setCellSelection($selectionAnchor, event) {
        let $head = $4be35d147053c9ad$var$cellUnderMouse(view, event);
        const starting = (0, $eqzvq.tableEditingKey).getState(view.state) == null;
        if (!$head || !(0, $9CB3n.inSameTable)($selectionAnchor, $head)) {
            if (starting) $head = $selectionAnchor;
            else return false;
        }
        const selection = new (0, $ev7OZ.CellSelection)($selectionAnchor, $head);
        if (starting || !view.state.selection.eq(selection)) {
            const tr = view.state.tr.setSelection(selection);
            if (starting) tr.setMeta((0, $eqzvq.tableEditingKey), $selectionAnchor.pos);
            view.dispatch(tr);
        }
    }
    // Stop listening to mouse motion events.
    function stop() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mouseup', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('dragstart', stop);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        view.root.removeEventListener('mousemove', move);
        if ((0, $eqzvq.tableEditingKey).getState(view.state) != null) view.dispatch(view.state.tr.setMeta((0, $eqzvq.tableEditingKey), -1));
    }
    function move(event) {
        const anchor = (0, $eqzvq.tableEditingKey).getState(view.state);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const currDOMCell = $4be35d147053c9ad$var$domInCell(view, event.target);
        const isCurrCellInsideNestedTable = $4be35d147053c9ad$var$isInsideNestedTable(view, event);
        const isStartCellInsideNestedTable = $4be35d147053c9ad$var$isInsideNestedTable(view, startEvent);
        const isBothCellsInSameTable = isCurrCellInsideNestedTable === isStartCellInsideNestedTable;
        let $moveAnchor;
        if (anchor != null) // Continuing an existing cross-cell selection
        $moveAnchor = view.state.doc.resolve(anchor);
        else if (currDOMCell !== startDOMCell && isBothCellsInSameTable) {
            // Moving out of the initial cell -- start a new cell selection
            $moveAnchor = $4be35d147053c9ad$var$cellUnderMouse(view, startEvent);
            if (!$moveAnchor) {
                stop();
                return;
            }
        }
        if ($moveAnchor) setCellSelection($moveAnchor, event);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mouseup', stop);
    // eslint-disable-next-line @atlaskit/design-system/no-direct-use-of-web-platform-drag-and-drop, @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('dragstart', stop);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    view.root.addEventListener('mousemove', move);
    return false;
}

});

parcelRegister("loeS1", function(module, exports) {
$parcel$export(module.exports, "handleTripleClick", () => $bf12229e867e94a2$export$f17e34274dd6fcf5);
// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $ev7OZ = parcelRequire("ev7OZ");

var $gNVxw = parcelRequire("gNVxw");
function $bf12229e867e94a2$export$f17e34274dd6fcf5(view, pos) {
    const { doc: doc } = view.state;
    const $cell = (0, $gNVxw.cellAround)(doc.resolve(pos));
    if (!$cell) return false;
    view.dispatch(view.state.tr.setSelection(new (0, $ev7OZ.CellSelection)($cell)));
    return true;
}

});

parcelRegister("eh0eG", function(module, exports) {
$parcel$export(module.exports, "handleKeyDown", () => $e50daa891f71570e$export$bab59f27a7347e45);
// This file defines a number of helpers for wiring up user input to
// table-related functionality.

var $1O8Lw = parcelRequire("1O8Lw");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $9HFsx = parcelRequire("9HFsx");

var $82clP = parcelRequire("82clP");
const $e50daa891f71570e$export$bab59f27a7347e45 = (0, $1O8Lw.keydownHandler)({
    ArrowLeft: $e50daa891f71570e$var$arrow('horiz', -1),
    ArrowRight: $e50daa891f71570e$var$arrow('horiz', 1),
    ArrowUp: $e50daa891f71570e$var$arrow('vert', -1),
    ArrowDown: $e50daa891f71570e$var$arrow('vert', 1),
    'Shift-ArrowLeft': $e50daa891f71570e$var$shiftArrow('horiz', -1),
    'Shift-ArrowRight': $e50daa891f71570e$var$shiftArrow('horiz', 1),
    'Shift-ArrowUp': $e50daa891f71570e$var$shiftArrow('vert', -1),
    'Shift-ArrowDown': $e50daa891f71570e$var$shiftArrow('vert', 1),
    Backspace: $e50daa891f71570e$var$deleteCellSelection,
    'Mod-Backspace': $e50daa891f71570e$var$deleteCellSelection,
    Delete: $e50daa891f71570e$var$deleteCellSelection,
    'Mod-Delete': $e50daa891f71570e$var$deleteCellSelection
});
function $e50daa891f71570e$var$maybeSetSelection(state, dispatch, selection) {
    if (selection.eq(state.selection)) return false;
    if (dispatch) dispatch(state.tr.setSelection(selection).scrollIntoView());
    return true;
}
function $e50daa891f71570e$var$arrow(axis, dir) {
    return (state, dispatch, view)=>{
        if (dispatch) {
            const sel = state.selection;
            if (sel instanceof (0, $ev7OZ.CellSelection)) return $e50daa891f71570e$var$maybeSetSelection(state, dispatch, (0, $801jp.Selection).near(sel.$headCell, dir));
            if (axis !== 'horiz' && !sel.empty) return false;
            const end = view ? $e50daa891f71570e$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            if (axis === 'horiz') return $e50daa891f71570e$var$maybeSetSelection(state, dispatch, (0, $801jp.Selection).near(state.doc.resolve(sel.head + dir), dir));
            const $cell = state.doc.resolve(end);
            const $next = (0, $82clP.nextCell)($cell, axis, dir);
            let newSel;
            if ($next) newSel = (0, $801jp.Selection).near($next, 1);
            else if (dir < 0) newSel = (0, $801jp.Selection).near(state.doc.resolve($cell.before(-1)), -1);
            else newSel = (0, $801jp.Selection).near(state.doc.resolve($cell.after(-1)), 1);
            return $e50daa891f71570e$var$maybeSetSelection(state, dispatch, newSel);
        }
        return true;
    };
}
function $e50daa891f71570e$var$shiftArrow(axis, dir) {
    return (state, dispatch, view)=>{
        let sel = state.selection;
        if (!(sel instanceof (0, $ev7OZ.CellSelection))) {
            var _maybeTableCell$paren;
            const end = view ? $e50daa891f71570e$var$atEndOfCell(view, axis, dir) : null;
            if (end === null) return false;
            const { selection: { $head: $head, $anchor: $anchor } } = state;
            const maybeTableCell = $head.blockRange($anchor);
            // Make sure the selection is coming from the same cell
            const sameCell = [
                'tableCell',
                'tableHeader'
            ].includes((maybeTableCell === null || maybeTableCell === void 0 || (_maybeTableCell$paren = maybeTableCell.parent) === null || _maybeTableCell$paren === void 0 ? void 0 : _maybeTableCell$paren.type.name) || '');
            if (!sameCell) return false;
            sel = new (0, $ev7OZ.CellSelection)(state.doc.resolve(end));
        }
        const $head = (0, $82clP.nextCell)(sel.$headCell, axis, dir);
        if (!$head) return false;
        if (dispatch) return $e50daa891f71570e$var$maybeSetSelection(state, dispatch, new (0, $ev7OZ.CellSelection)(sel.$anchorCell, $head));
        return true;
    };
}
function $e50daa891f71570e$var$deleteCellSelection(state, dispatch) {
    const sel = state.selection;
    if (!(sel instanceof (0, $ev7OZ.CellSelection))) return false;
    if (dispatch) {
        const { tr: tr } = state;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const baseContent = (0, $9HFsx.tableNodeTypes)(state.schema).cell.createAndFill().content;
        sel.forEachCell((cell, pos)=>{
            if (!cell.content.eq(baseContent)) tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new (0, $7H6Cr.Slice)(baseContent, 0, 0));
        });
        if (tr.docChanged) dispatch(tr);
    }
    return true;
}
// Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)
function $e50daa891f71570e$var$atEndOfCell(view, axis, dir) {
    if (!(view.state.selection instanceof (0, $801jp.TextSelection))) return null;
    const { $head: $head } = view.state.selection;
    for(let d = $head.depth - 1; d >= 0; d--){
        const parent = $head.node(d);
        const index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
        if (index !== (dir < 0 ? 0 : parent.childCount)) return null;
        if (parent.type.spec.tableRole === 'cell' || parent.type.spec.tableRole === 'header_cell') {
            const cellPos = $head.before(d);
            const dirStr = // eslint-disable-next-line no-nested-ternary
            axis === 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
            return view.endOfTextblock(dirStr) ? cellPos : null;
        }
    }
    return null;
}

});
parcelRegister("82clP", function(module, exports) {
$parcel$export(module.exports, "nextCell", () => $2036c2ad91e670ed$export$172699367bb25225);

var $dpooP = parcelRequire("dpooP");
function $2036c2ad91e670ed$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $dpooP.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});



parcelRegister("6Waiv", function(module, exports) {
$parcel$export(module.exports, "tableNodeSpecWithFixedToDOM", () => $71d142932da12337$export$477bb32cbededd65);

var $jyPR0 = parcelRequire("jyPR0");

var $gWPic = parcelRequire("gWPic");

var $63Q5S = parcelRequire("63Q5S");

var $kqiw5 = parcelRequire("kqiw5");

var $bzCw0 = parcelRequire("bzCw0");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $7Xzpg = parcelRequire("7Xzpg");

var $eyG1M = parcelRequire("eyG1M");

var $7SttP = parcelRequire("7SttP");

var $h3r8b = parcelRequire("h3r8b");

var $YREXK = parcelRequire("YREXK");

var $5Yp1l = parcelRequire("5Yp1l");
const $71d142932da12337$export$477bb32cbededd65 = (config)=>{
    const tableNode = config.isNestingSupported ? (0, $63Q5S.tableWithNestedTable) : (0, $63Q5S.table);
    return {
        ...tableNode,
        toDOM: (node)=>{
            const isFullPageEditor = !config.isChromelessEditor && !config.isCommentEditor;
            const isInContentMode = (0, $bzCw0.isTableInContentMode)({
                tableNode: node,
                isSupported: (0, $h3r8b.isContentModeSupported)({
                    allowColumnResizing: config.allowColumnResizing,
                    allowTableResizing: config.tableResizingEnabled,
                    isFullPageEditor: isFullPageEditor
                }),
                isTableNested: config.isNested
            });
            const alignmentStyle = Object.entries((0, $5Yp1l.getAlignmentStyle)(node.attrs.layout)).map(([k, v])=>`${(0, (/*@__PURE__*/$parcel$interopDefault($gWPic)))(k)}: ${(0, (/*@__PURE__*/$parcel$interopDefault($gWPic)))(v)}`).join(';');
            const tableMinWidth = (0, $7Xzpg.getResizerMinWidth)(node);
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-ssr-placeholder': `table-${node.attrs.localId}`,
                'data-ssr-placeholder-replace': `table-${node.attrs.localId}`,
                'data-table-display-mode': node.attrs.displayMode
            };
            if (isInContentMode) attrs['data-initial-width-mode'] = 'content';
            // This would be used for table scaling in colgroup CSS
            // cqw, or px is well supported
            const resizableTableWidth = isFullPageEditor ? (0, $7SttP.getTableResizerContainerForFullPageWidthInCSS)(node, config.isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
            let colgroup = '';
            if (config.allowColumnResizing) colgroup = [
                'colgroup',
                {},
                ...(0, $7Xzpg.generateColgroupFromNode)(node, config.isCommentEditor, config.isChromelessEditor, config.isNested, config.isTableScalingEnabled, config.shouldUseIncreasedScalingPercent)
            ];
            const overflowShadows = (0, $bcN2K.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') ? [
                [
                    'div',
                    {
                        contenteditable: 'false',
                        'aria-hidden': 'true',
                        'data-vc-nvs': 'true',
                        'data-table-overflow-shadow': 'start'
                    }
                ],
                [
                    'div',
                    {
                        contenteditable: 'false',
                        'aria-hidden': 'true',
                        'data-vc-nvs': 'true',
                        'data-table-overflow-shadow': 'end'
                    }
                ]
            ] : [];
            const roundedTableCornerMasks = (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? [
                [
                    'div',
                    {
                        contenteditable: 'false',
                        'aria-hidden': 'true',
                        class: (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK,
                        'data-corner': 'left'
                    }
                ],
                [
                    'div',
                    {
                        contenteditable: 'false',
                        'aria-hidden': 'true',
                        class: (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK,
                        'data-corner': 'right'
                    }
                ]
            ] : [];
            const tableContainerDiv = [
                'div',
                {
                    class: 'pm-table-container',
                    'data-number-column': node.attrs.isNumberColumnEnabled,
                    'data-layout': node.attrs.layout,
                    'data-testid': 'table-container'
                },
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-top',
                        'data-testid': 'sticky-sentinel-top'
                    }
                ],
                [
                    'div',
                    {
                        class: 'pm-table-row-controls-wrapper'
                    },
                    [
                        'div'
                    ]
                ],
                [
                    'div',
                    {
                        class: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, {
                            [(0, $YREXK.TableCssClassName).TABLE_SCROLL_INLINE_SHADOW]: (0, $bcN2K.isExperimentEnabled)('platform_editor_table_css_overflow_shadow')
                        })
                    },
                    ...roundedTableCornerMasks,
                    [
                        'table',
                        attrs,
                        colgroup,
                        [
                            'tbody',
                            0
                        ]
                    ]
                ],
                ...overflowShadows,
                [
                    'div',
                    {
                        class: 'pm-table-sticky-sentinel-bottom',
                        'data-testid': 'sticky-sentinel-bottom'
                    }
                ],
                [
                    'div',
                    {
                        contenteditable: 'false',
                        class: 'pm-table-left-border',
                        'data-with-numbered-table': node.attrs.isNumberColumnEnabled,
                        'data-testid': 'table-left-border'
                    }
                ],
                [
                    'div',
                    {
                        contenteditable: 'false',
                        class: 'pm-table-right-border',
                        'data-testid': 'table-right-border'
                    }
                ]
            ];
            if (!config.tableResizingEnabled || config.isNested) return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true',
                    style: (0, $kqiw5.convertToInlineCss)({
                        '--ak-editor-table-width': resizableTableWidth
                    })
                },
                tableContainerDiv
            ];
            const tableResizingDiv = [
                'div',
                {
                    'data-testid': 'table-alignment-container',
                    style: alignmentStyle
                },
                [
                    'div',
                    {
                        class: 'pm-table-resizer-container',
                        style: (0, $kqiw5.convertToInlineCss)({
                            '--ak-editor-table-gutter-padding': config.isTableScalingEnabled ? 'calc(var(--ak-editor--large-gutter-padding) * 2)' : 'calc(var(--ak-editor--large-gutter-padding) * 2 - var(--ak-editor-resizer-handle-spacing))',
                            '--ak-editor-table-width': isInContentMode ? 'max-content' : resizableTableWidth,
                            width: `var(--ak-editor-table-width)`
                        })
                    },
                    [
                        'div',
                        {
                            class: 'resizer-item display-handle',
                            style: (0, $kqiw5.convertToInlineCss)({
                                position: 'relative',
                                userSelect: 'auto',
                                boxSizing: 'border-box',
                                '--ak-editor-table-max-width': `${(0, $eyG1M.TABLE_MAX_WIDTH)}px`,
                                '--ak-editor-table-min-width': `${tableMinWidth}px`,
                                minWidth: 'var(--ak-editor-table-min-width)',
                                maxWidth: (0, $7SttP.getTableResizerContainerMaxWidthInCSS)(config.isCommentEditor, config.isChromelessEditor, config.isTableScalingEnabled),
                                width: isInContentMode ? 'auto' : (0, $7SttP.getTableResizerItemWidthInCSS)(node, config.isCommentEditor, config.isChromelessEditor)
                            })
                        },
                        [
                            'span',
                            {
                                class: 'resizer-hover-zone'
                            },
                            tableContainerDiv
                        ]
                    ]
                ]
            ];
            return [
                'div',
                {
                    class: 'tableView-content-wrap',
                    'data-prosemirror-initial-toDOM-render': 'true'
                },
                tableResizingDiv
            ];
        }
    };
};

});
parcelRegister("7Xzpg", function(module, exports) {
$parcel$export(module.exports, "getColWidthFix", () => $c6c527ee08ff8d2d$export$66302252070a658d);
$parcel$export(module.exports, "generateColgroupFromNode", () => $c6c527ee08ff8d2d$export$465034143db788da);
$parcel$export(module.exports, "insertColgroupFromNode", () => $c6c527ee08ff8d2d$export$ae5d9647f2a0891c);
$parcel$export(module.exports, "hasTableBeenResized", () => $c6c527ee08ff8d2d$export$8c07f44cea64e3c7);
$parcel$export(module.exports, "hasTableColumnBeenResized", () => $c6c527ee08ff8d2d$export$b44a013e4f554514);
$parcel$export(module.exports, "isMinCellWidthTable", () => $c6c527ee08ff8d2d$export$2878318085bf6dbf);
$parcel$export(module.exports, "getColgroupChildrenLength", () => $c6c527ee08ff8d2d$export$dc24345db4290451);
$parcel$export(module.exports, "getResizerMinWidth", () => $c6c527ee08ff8d2d$export$e7ee55be67771d90);

var $jd8X7 = parcelRequire("jd8X7");

var $cjjgo = parcelRequire("cjjgo");

var $ePYW1 = parcelRequire("ePYW1");

var $7H6Cr = parcelRequire("7H6Cr");

var $014x6 = parcelRequire("014x6");

var $dpooP = parcelRequire("dpooP");

var $eyG1M = parcelRequire("eyG1M");

var $7SttP = parcelRequire("7SttP");
const $c6c527ee08ff8d2d$export$66302252070a658d = (colwidth, tableColumnCount)=>colwidth - 1 / tableColumnCount;
const $c6c527ee08ff8d2d$var$generateColStyle = (fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, hasTableBeenResized)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $eyG1M.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $eyG1M.MAX_SCALING_PERCENT);
    const maxScaledRatio = 1 - maxScalingPercent;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // for nested tables, or chromeless editor, which used non resizable table container
    if (isNested || isChromelessEditor) {
        if (hasTableBeenResized) return `width: max(${fixedColWidth}px, ${0, $jd8X7.tableCellMinWidth}px)`;
        return `width: ${0, $jd8X7.tableCellMinWidth}px`;
    }
    if (isFullPageEditor || !isFullPageEditor && isTableHasWidth) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $014x6.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth}px * ${maxScaledRatio}), calc(${fixedColWidth} * ${scaledPercent}), ${0, $jd8X7.tableCellMinWidth}px)`;
    }
    // table resized to full-width in comment editor
    // it doesn't have a width attribute, and cols has been resized
    if (hasTableBeenResized) {
        const scaledPercent = isNumberColumnEnabled ? `calc(calc(var(--ak-editor-table-width) - ${0, $014x6.akEditorTableNumberColumnWidth}px - 1px)/${tableWidth})` : `calc(calc(var(--ak-editor-table-width) - 1px)/${tableWidth})`;
        return `width: max(calc(${fixedColWidth} * ${scaledPercent}), ${0, $jd8X7.tableCellMinWidth}px)`;
    }
    return `width: ${0, $jd8X7.tableCellMinWidth}px`;
};
const $c6c527ee08ff8d2d$export$465034143db788da = (table, isCommentEditor, isChromelessEditor, isNested, isTableScalingEnabled, shouldUseIncreasedScalingPercent)=>{
    const cols = [];
    const map = (0, $dpooP.TableMap).get(table);
    const isTableHasWidth = !!table.attrs.width;
    const isNumberColumnEnabled = table.attrs.isNumberColumnEnabled || false;
    const isFullPageEditor = !isChromelessEditor && !isCommentEditor;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        // if the table has been resized
        if (Array.isArray(cell.attrs.colwidth)) cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
            // existing logic for calculating the width of the column
            const fixedColWidth = $c6c527ee08ff8d2d$export$66302252070a658d(width, map.width);
            const tableWidth = isFullPageEditor || !isFullPageEditor && isTableHasWidth ? (0, $7SttP.getTableContainerElementWidth)(table) : (0, $ePYW1.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
            if (isTableScalingEnabled) cols.push([
                'col',
                {
                    style: $c6c527ee08ff8d2d$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth, true)
                }
            ]);
            else cols.push([
                'col',
                {
                    style: `width: max(${fixedColWidth}px, ${(0, $jd8X7.tableCellMinWidth)}px)`
                }
            ]);
        });
        else if (!isTableScalingEnabled) cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $jd8X7.tableCellMinWidth)}px;`
                }
            ]));
        else // columns has not been resized, so distribute the width evenly
        cols.push(...Array.from({
            length: colspan
        }, (_)=>{
            const tableWidth = (0, $7SttP.getTableContainerElementWidth)(table);
            const columnWidth = tableWidth / map.width || 0;
            const fixedColWidth = $c6c527ee08ff8d2d$export$66302252070a658d(columnWidth, map.width || 0);
            return [
                'col',
                {
                    style: $c6c527ee08ff8d2d$var$generateColStyle(fixedColWidth, tableWidth, isCommentEditor, isChromelessEditor, isNested, shouldUseIncreasedScalingPercent, isNumberColumnEnabled, isTableHasWidth)
                }
            ];
        }));
    });
    return cols;
};
const $c6c527ee08ff8d2d$export$6628e11a2af8bd40 = (table, tableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor)=>{
    const cols = [];
    const map = (0, $dpooP.TableMap).get(table);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    table.content.firstChild.content.forEach((cell)=>{
        const colspan = cell.attrs.colspan || 1;
        if (Array.isArray(cell.attrs.colwidth)) {
            // We slice here to guard against our colwidth array having more entries
            // Than the we actually span. We'll patch the document at a later point.
            if (tableRef) {
                var _table$attrs;
                // if we have tableRef here, isTableScalingEnabled is true
                let scalePercent = 1;
                if (isCommentOrChromelessEditor && !((_table$attrs = table.attrs) !== null && _table$attrs !== void 0 && _table$attrs.width)) scalePercent = (0, $7SttP.getScalingPercentForTableWithoutWidth)(table, tableRef);
                else scalePercent = (0, $7SttP.getTableScalingPercent)(table, tableRef, shouldUseIncreasedScalingPercent);
                cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                    // existing logic for calculating the width of the column
                    const fixedColWidth = $c6c527ee08ff8d2d$export$66302252070a658d(width, map.width);
                    const scaledWidth = fixedColWidth * scalePercent;
                    const finalWidth = Math.max(scaledWidth, (0, $jd8X7.tableCellMinWidth));
                    cols.push([
                        'col',
                        {
                            style: `width: ${finalWidth}px;`
                        }
                    ]);
                });
            } else cell.attrs.colwidth.slice(0, colspan).forEach((width)=>{
                cols.push([
                    'col',
                    {
                        style: `width: ${$c6c527ee08ff8d2d$export$66302252070a658d(width ? Math.max(width, (0, $jd8X7.tableCellMinWidth)) : (0, $jd8X7.tableCellMinWidth), map.width)}px;`
                    }
                ]);
            });
        } else // When we have merged cells on the first row (firstChild),
        // We want to ensure we're creating the appropriate amount of
        // cols the table still has.
        cols.push(...Array.from({
            length: colspan
        }, (_)=>[
                'col',
                {
                    style: `width: ${(0, $jd8X7.tableCellMinWidth)}px;`
                }
            ]));
    });
    return cols;
};
const $c6c527ee08ff8d2d$export$ae5d9647f2a0891c = (tableRef, table, isTableScalingEnabled = false, shouldRemove = true, shouldUseIncreasedScalingPercent = false, isCommentOrChromelessEditor = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let colgroup = tableRef === null || tableRef === void 0 ? void 0 : tableRef.querySelector('colgroup');
    if (colgroup && shouldRemove) tableRef === null || tableRef === void 0 || tableRef.removeChild(colgroup);
    colgroup = $c6c527ee08ff8d2d$var$renderColgroupFromNode(table, isTableScalingEnabled ? tableRef ?? undefined : undefined, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor);
    if (shouldRemove) tableRef === null || tableRef === void 0 || tableRef.insertBefore(colgroup, tableRef === null || tableRef === void 0 ? void 0 : tableRef.firstChild);
    return colgroup.children;
};
const $c6c527ee08ff8d2d$export$8c07f44cea64e3c7 = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return !!(0, $cjjgo.getFragmentBackingArray)(table.content.firstChild.content).find((cell)=>cell.attrs.colwidth);
};
const $c6c527ee08ff8d2d$export$b44a013e4f554514 = $c6c527ee08ff8d2d$export$8c07f44cea64e3c7;
const $c6c527ee08ff8d2d$export$2878318085bf6dbf = (table)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cellArray = (0, $cjjgo.getFragmentBackingArray)(table.content.firstChild.content);
    const isTableMinCellWidth = cellArray.every((cell)=>{
        return cell.attrs.colwidth && cell.attrs.colwidth[0] === (0, $jd8X7.tableCellMinWidth) || cell.attrs.colwidth === null;
    });
    return isTableMinCellWidth;
};
function $c6c527ee08ff8d2d$var$renderColgroupFromNode(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor) {
    const rendered = (0, $7H6Cr.DOMSerializer).renderSpec(document, [
        'colgroup',
        {},
        ...$c6c527ee08ff8d2d$export$6628e11a2af8bd40(table, maybeTableRef, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor)
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    return rendered.dom;
}
const $c6c527ee08ff8d2d$export$dc24345db4290451 = (table)=>{
    const map = (0, $dpooP.TableMap).get(table);
    return map.width;
};
const $c6c527ee08ff8d2d$export$e7ee55be67771d90 = (node)=>{
    const currentColumnCount = $c6c527ee08ff8d2d$export$dc24345db4290451(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $eyG1M.COLUMN_MIN_WIDTH);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};

});
parcelRegister("eyG1M", function(module, exports) {
$parcel$export(module.exports, "COLUMN_MIN_WIDTH", () => $a7486cd3adeec4f5$export$dd66abdcfb4bb2cf);
$parcel$export(module.exports, "TABLE_FULL_WIDTH", () => $a7486cd3adeec4f5$export$bffd6819c009a916);
$parcel$export(module.exports, "TABLE_MAX_WIDTH", () => $a7486cd3adeec4f5$export$8a91b25da594a758);
$parcel$export(module.exports, "FULL_WIDTH_EDITOR_CONTENT_WIDTH", () => $a7486cd3adeec4f5$export$b5e6eff3efdc4860);
$parcel$export(module.exports, "MAX_SCALING_PERCENT", () => $a7486cd3adeec4f5$export$e8dbf55270553cd3);
$parcel$export(module.exports, "MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION", () => $a7486cd3adeec4f5$export$2e7c88a39ad490e6);
$parcel$export(module.exports, "TABLE_EDITOR_MARGIN", () => $a7486cd3adeec4f5$export$7c8bcfa1d3f9af23);
$parcel$export(module.exports, "TABLE_OFFSET_IN_COMMENT_EDITOR", () => $a7486cd3adeec4f5$export$c332ba2dd5aa2199);
$parcel$export(module.exports, "RESIZE_HANDLE_SPACING", () => $a7486cd3adeec4f5$export$a823f6a7493b3d06);
const $a7486cd3adeec4f5$export$dd66abdcfb4bb2cf = 48;
const $a7486cd3adeec4f5$export$bffd6819c009a916 = 1800;
const $a7486cd3adeec4f5$export$8a91b25da594a758 = 4000;
const $a7486cd3adeec4f5$export$b5e6eff3efdc4860 = 1800;
const $a7486cd3adeec4f5$export$e8dbf55270553cd3 = 0.3;
const $a7486cd3adeec4f5$export$2e7c88a39ad490e6 = 0.4;
const $a7486cd3adeec4f5$export$7c8bcfa1d3f9af23 = 76;
const $a7486cd3adeec4f5$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING = 20;
const $a7486cd3adeec4f5$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN = 12;
const $a7486cd3adeec4f5$export$c332ba2dd5aa2199 = 2 * ($a7486cd3adeec4f5$var$COMMENT_AK_EDITOR_CONTENT_AREA_PADDING + $a7486cd3adeec4f5$var$COMMENT_PM_TABLE_RESIZING_PLUGIN_MARGIN);
const $a7486cd3adeec4f5$export$a823f6a7493b3d06 = 12;

});

parcelRegister("7SttP", function(module, exports) {
$parcel$export(module.exports, "getLayoutSize", () => $d868d8364fb61054$export$7bde9ac1d5d663fc);
$parcel$export(module.exports, "pointsAtCell", () => $d868d8364fb61054$export$3c89e45c7dff9619);
$parcel$export(module.exports, "currentColWidth", () => $d868d8364fb61054$export$8f862fd911e06936);
$parcel$export(module.exports, "getTableMaxWidth", () => $d868d8364fb61054$export$8bfbafe1083a527d);
$parcel$export(module.exports, "getTableElementWidth", () => $d868d8364fb61054$export$44361276769f7eff);
$parcel$export(module.exports, "getTableContainerElementWidth", () => $d868d8364fb61054$export$a34136fcfaec1907);
$parcel$export(module.exports, "getTableResizerContainerMaxWidthInCSS", () => $d868d8364fb61054$export$817f7cd897b65634);
$parcel$export(module.exports, "getTableResizerItemWidthInCSS", () => $d868d8364fb61054$export$7d968ec824de6aa6);
$parcel$export(module.exports, "getTableResizerContainerForFullPageWidthInCSS", () => $d868d8364fb61054$export$30421da09613cb3d);
$parcel$export(module.exports, "getTableScalingPercent", () => $d868d8364fb61054$export$b2c142721a99201b);
$parcel$export(module.exports, "getScalingPercentForTableWithoutWidth", () => $d868d8364fb61054$export$4e884677f8e54bba);
$parcel$export(module.exports, "getStaticTableScalingPercent", () => $d868d8364fb61054$export$f9c5ace2959c7a33);

var $k5JVX = parcelRequire("k5JVX");

var $83t9n = parcelRequire("83t9n");

var $ePYW1 = parcelRequire("ePYW1");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");

var $7Xzpg = parcelRequire("7Xzpg");

var $eyG1M = parcelRequire("eyG1M");
function $d868d8364fb61054$export$7bde9ac1d5d663fc(tableLayout, containerWidth = 0, options) {
    const { isFullWidthModeEnabled: isFullWidthModeEnabled } = options;
    if (isFullWidthModeEnabled) {
        let padding = (0, $014x6.akEditorGutterPaddingDynamic)();
        if (containerWidth <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        })) padding = (0, $014x6.akEditorGutterPaddingReduced);
        return containerWidth ? Math.min(containerWidth - padding * 2, (0, $014x6.akEditorFullWidthLayoutWidth)) : (0, $014x6.akEditorFullWidthLayoutWidth);
    }
    const calculatedTableWidth = (0, $83t9n.calcTableWidth)(tableLayout, containerWidth, true);
    if (calculatedTableWidth !== 'inherit') return calculatedTableWidth;
    return (0, $k5JVX.layoutToWidth)[tableLayout] || containerWidth;
}
function $d868d8364fb61054$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $d868d8364fb61054$export$8f862fd911e06936(view, cellPos, { colspan: colspan, colwidth: colwidth }) {
    const width = colwidth && colwidth[colwidth.length - 1];
    if (width) return width;
    // Not fixed, read current width from DOM
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
    let parts = colspan || 0;
    if (colwidth) {
        for(let i = 0; i < (colspan || 0); i++)if (colwidth[i]) {
            domWidth -= colwidth[i];
            parts--;
        }
    }
    return domWidth / parts;
}
const $d868d8364fb61054$export$8bfbafe1083a527d = ({ table: table, tableStart: tableStart, state: state, layout: layout, getEditorContainerWidth: getEditorContainerWidth })=>{
    const containerWidth = getEditorContainerWidth();
    const parentWidth = (0, $k5JVX.getParentNodeWidth)(tableStart, state, containerWidth);
    let maxWidth = parentWidth || table.attrs.width || $d868d8364fb61054$export$7bde9ac1d5d663fc(layout, containerWidth.width, {});
    if (table.attrs.isNumberColumnEnabled) maxWidth -= (0, $014x6.akEditorTableNumberColumnWidth);
    return maxWidth;
};
const $d868d8364fb61054$export$44361276769f7eff = (table)=>{
    if ((0, $7Xzpg.hasTableBeenResized)(table)) // TODO: ED-26961 - is there a scenario where ADF columns are SMALLER than container width?
    return (0, $ePYW1.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
    return $d868d8364fb61054$export$a34136fcfaec1907(table);
};
const $d868d8364fb61054$export$a34136fcfaec1907 = (table)=>{
    return (0, $k5JVX.getTableContainerWidth)(table);
};
const $d868d8364fb61054$export$817f7cd897b65634 = (isCommentEditor, isChromelessEditor, isTableScalingEnabled)=>{
    const maxResizerWidthForNonCommentEditor = isTableScalingEnabled ? `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${0, $eyG1M.TABLE_MAX_WIDTH}px)` : `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${0, $eyG1M.TABLE_MAX_WIDTH}px)`;
    return isCommentEditor || isChromelessEditor ? '100%' : maxResizerWidthForNonCommentEditor;
};
const $d868d8364fb61054$export$708cde710ed0df70 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = (0, $k5JVX.getTableContainerWidth)(node);
    if (!node.attrs.width && (isCommentEditor || isChromelessEditor)) // width undefined would make .resizer-item width to be `auto`
    return undefined;
    return tableWidthAttribute;
};
const $d868d8364fb61054$export$7d968ec824de6aa6 = (node, isCommentEditor, isChromelessEditor)=>{
    const tableWidthAttribute = $d868d8364fb61054$export$708cde710ed0df70(node, isCommentEditor, isChromelessEditor);
    return tableWidthAttribute ? `${tableWidthAttribute}px` : 'auto';
};
const $d868d8364fb61054$export$30421da09613cb3d = (node, isTableScalingEnabled)=>{
    const tableWidth = $d868d8364fb61054$export$a34136fcfaec1907(node);
    // for full page appearance
    if (isTableScalingEnabled) return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2)), ${tableWidth}px)`;
    return `min(calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2) - var(--ak-editor--resizer-handle-spacing)), ${tableWidth}px)`;
};
const $d868d8364fb61054$export$b2c142721a99201b = (table, tableRef, shouldUseIncreasedScalingPercent)=>{
    var _tableRef$parentEleme;
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $eyG1M.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $eyG1M.MAX_SCALING_PERCENT);
    const tableWidth = $d868d8364fb61054$export$a34136fcfaec1907(table);
    const renderWidth = (tableRef === null || tableRef === void 0 || (_tableRef$parentEleme = tableRef.parentElement) === null || _tableRef$parentEleme === void 0 ? void 0 : _tableRef$parentEleme.clientWidth) || tableWidth;
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (renderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};
const $d868d8364fb61054$export$4e884677f8e54bba = (table, tableRef)=>{
    // are table columns resized
    if ((0, $7Xzpg.hasTableColumnBeenResized)(table)) {
        var _tableRef$parentEleme2;
        const tableWidth = (0, $ePYW1.calcTableColumnWidths)(table).reduce((sum, width)=>sum + width, 0);
        const renderWidth = (tableRef === null || tableRef === void 0 || (_tableRef$parentEleme2 = tableRef.parentElement) === null || _tableRef$parentEleme2 === void 0 ? void 0 : _tableRef$parentEleme2.clientWidth) || tableWidth;
        // minus 1 here to avoid any 1px scroll in Firefox
        return (renderWidth - 1) / tableWidth;
    }
    // When table cols are not resized and table width is not set,
    // tableWidth is equal to renderWidth
    return 1;
};
const $d868d8364fb61054$export$f9c5ace2959c7a33 = (table, tableRenderWidth, shouldUseIncreasedScalingPercent)=>{
    const maxScalingPercent = shouldUseIncreasedScalingPercent ? (0, $eyG1M.MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION) : (0, $eyG1M.MAX_SCALING_PERCENT);
    const tableWidth = $d868d8364fb61054$export$a34136fcfaec1907(table);
    // minus 1 here to avoid any 1px scroll in Firefox
    let scalePercent = (tableRenderWidth - 1) / tableWidth;
    scalePercent = Math.max(scalePercent, 1 - maxScalingPercent);
    return Math.min(scalePercent, 1);
};

});
parcelRegister("83t9n", function(module, exports) {
$parcel$export(module.exports, "calcTableWidth", () => $ace8497d498e5c21$export$d7ece4d8beb06815);

var $014x6 = parcelRequire("014x6");
const $ace8497d498e5c21$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $014x6.akEditorBreakoutPadding) : 0), (0, $014x6.akEditorFullWidthLayoutWidth)) : (0, $014x6.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $014x6.akEditorBreakoutPadding) : 0), (0, $014x6.akEditorWideLayoutWidth));
            return 0, $014x6.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});



parcelRegister("h3r8b", function(module, exports) {
$parcel$export(module.exports, "isContentModeSupported", () => $ccd4de8fb56faa96$export$e217d2a535d6ae45);
const $ccd4de8fb56faa96$export$e217d2a535d6ae45 = ({ allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isFullPageEditor: isFullPageEditor })=>{
    return allowColumnResizing && allowTableResizing && isFullPageEditor;
};

});

parcelRegister("YREXK", function(module, exports) {
$parcel$export(module.exports, "RESIZE_HANDLE_AREA_DECORATION_GAP", () => $0765404beb22cc7f$export$1a38c7157d718094);
$parcel$export(module.exports, "TableDecorations", () => $0765404beb22cc7f$export$fe8f2ca19399400e);
$parcel$export(module.exports, "TableCssClassName", () => $0765404beb22cc7f$export$19a8a7a6488b1b9f);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $63Q5S = parcelRequire("63Q5S");

var $8aFCM = parcelRequire("8aFCM");
const $0765404beb22cc7f$export$1a38c7157d718094 = 30;
var $0765404beb22cc7f$export$fe8f2ca19399400e = /*#__PURE__*/ function(TableDecorations) {
    /** Classic controls */ TableDecorations["ALL_CONTROLS_HOVER"] = "CONTROLS_HOVER";
    TableDecorations["ROW_CONTROLS_HOVER"] = "ROW_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_HOVER"] = "COLUMN_CONTROLS_HOVER";
    TableDecorations["TABLE_CONTROLS_HOVER"] = "TABLE_CONTROLS_HOVER";
    TableDecorations["CELL_CONTROLS_HOVER"] = "CELL_CONTROLS_HOVER";
    TableDecorations["COLUMN_CONTROLS_DECORATIONS"] = "COLUMN_CONTROLS_DECORATIONS";
    TableDecorations["COLUMN_DROP_TARGET_DECORATIONS"] = "COLUMN_DROP_TARGET_DECORATIONS";
    TableDecorations["COLUMN_SELECTED"] = "COLUMN_SELECTED";
    TableDecorations["COLUMN_RESIZING_HANDLE"] = "COLUMN_RESIZING_HANDLE";
    TableDecorations["COLUMN_RESIZING_HANDLE_WIDGET"] = "COLUMN_RESIZING_HANDLE_WIDGET";
    TableDecorations["COLUMN_RESIZING_HANDLE_LINE"] = "COLUMN_RESIZING_HANDLE_LINE";
    TableDecorations["COLUMN_INSERT_LINE"] = "COLUMN_INSERT_LINE";
    TableDecorations["ROW_INSERT_LINE"] = "ROW_INSERT_LINE";
    return TableDecorations;
}({});
const $0765404beb22cc7f$export$19a8a7a6488b1b9f = {
    ...(0, $8aFCM.TableSharedCssClassName),
    /** Classic controls */ COLUMN_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-column-controls`,
    COLUMN_CONTROLS_DECORATIONS: `${(0, $63Q5S.tablePrefixSelector)}-column-controls-decoration`,
    COLUMN_SELECTED: `${(0, $63Q5S.tablePrefixSelector)}-column__selected`,
    ROW_CONTROLS_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-row-controls-wrapper`,
    ROW_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-row-controls`,
    ROW_CONTROLS_INNER: `${(0, $63Q5S.tablePrefixSelector)}-row-controls__inner`,
    ROW_CONTROLS_BUTTON_WRAP: `${(0, $63Q5S.tablePrefixSelector)}-row-controls__button-wrap`,
    ROW_CONTROLS_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-row-controls__button`,
    CONTROLS_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-controls__button`,
    CONTROLS_BUTTON_ICON: `${(0, $63Q5S.tablePrefixSelector)}-controls__button-icon`,
    CONTROLS_INSERT_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-button`,
    CONTROLS_INSERT_BUTTON_INNER: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-button-inner`,
    CONTROLS_INSERT_BUTTON_WRAP: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-button-wrap`,
    CONTROLS_INSERT_LINE: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-line`,
    CONTROLS_BUTTON_OVERLAY: `${(0, $63Q5S.tablePrefixSelector)}-controls__button-overlay`,
    DRAG_CONTROLS_INSERT_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-controls__drag-insert-button`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER: `${(0, $63Q5S.tablePrefixSelector)}-controls__drag-insert-button-inner`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-controls__drag-insert-button-inner-column`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW: `${(0, $63Q5S.tablePrefixSelector)}-controls__drag-insert-button-inner-row`,
    DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS: `${(0, $63Q5S.tablePrefixSelector)}-controls__drag-insert-button-inner-row-chromeless`,
    DRAG_CONTROLS_INSERT_BUTTON_WRAP: `${(0, $63Q5S.tablePrefixSelector)}-controls__drag-insert-button-wrap`,
    CONTROLS_INSERT_MARKER: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-marker`,
    CONTROLS_INSERT_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-column`,
    CONTROLS_INSERT_ROW: `${(0, $63Q5S.tablePrefixSelector)}-controls__insert-row`,
    CONTROLS_DELETE_BUTTON_WRAP: `${(0, $63Q5S.tablePrefixSelector)}-controls__delete-button-wrap`,
    CONTROLS_DELETE_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-controls__delete-button`,
    CONTROLS_FLOATING_BUTTON_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-controls-floating__button-column`,
    CONTROLS_FLOATING_BUTTON_ROW: `${(0, $63Q5S.tablePrefixSelector)}-controls-floating__button-row`,
    CORNER_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-corner-controls`,
    CORNER_CONTROLS_INSERT_ROW_MARKER: `${(0, $63Q5S.tablePrefixSelector)}-corner-controls__insert-row-marker`,
    CORNER_CONTROLS_INSERT_COLUMN_MARKER: `${(0, $63Q5S.tablePrefixSelector)}-corner-controls__insert-column-marker`,
    CONTROLS_CORNER_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-corner-button`,
    /** drag and drop controls */ DRAG_ROW_CONTROLS_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-drag-row-controls-wrapper`,
    DRAG_ROW_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-drag-row-controls`,
    DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-drag-row-floating-insert-dot-wrapper`,
    DRAG_ROW_FLOATING_INSERT_DOT: `${(0, $63Q5S.tablePrefixSelector)}-drag-row-floating-insert-dot`,
    DRAG_ROW_FLOATING_DRAG_HANDLE: `${(0, $63Q5S.tablePrefixSelector)}-drag-row-floating-drag-handle`,
    DRAG_COLUMN_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-drag-column-controls`,
    DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-drag-columns-floating-insert-dot-wrapper`,
    DRAG_COLUMN_FLOATING_INSERT_DOT: `${(0, $63Q5S.tablePrefixSelector)}-drag-columns-floating-insert-dot`,
    DRAG_COLUMN_CONTROLS_WRAPPER: `${(0, $63Q5S.tablePrefixSelector)}-col-controls-wrapper`,
    DRAG_COLUMN_DROP_TARGET_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-col-drop-target-controls`,
    DRAG_COLUMN_CONTROLS_INNER: `${(0, $63Q5S.tablePrefixSelector)}-col-controls__inner`,
    DRAG_HANDLE_BUTTON_CONTAINER: `${(0, $63Q5S.tablePrefixSelector)}-drag-handle-button-container`,
    DRAG_HANDLE_BUTTON_CLICKABLE_ZONE: `${(0, $63Q5S.tablePrefixSelector)}-drag-handle-button-clickable-zone`,
    DRAG_CORNER_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-drag-corner-button`,
    DRAG_CORNER_BUTTON_INNER: `${(0, $63Q5S.tablePrefixSelector)}-drag-corner-button-inner`,
    /** nested tables classes */ NESTED_TABLE_WITH_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-nested-table-with-controls`,
    /** disabled classes */ DRAG_HANDLE_DISABLED: `${(0, $63Q5S.tablePrefixSelector)}-drag-handle-disabled`,
    /** minimised handle class */ DRAG_HANDLE_MINIMISED: `${(0, $63Q5S.tablePrefixSelector)}-drag-handle-minimised`,
    DRAG_SUBMENU: `${(0, $63Q5S.tablePrefixSelector)}-drag-submenu`,
    DRAG_SUBMENU_ICON: `${(0, $63Q5S.tablePrefixSelector)}-drag-submenu-icon`,
    /** Other classes */ NUMBERED_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-numbered-column`,
    NUMBERED_COLUMN_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-numbered-column__button`,
    NUMBERED_COLUMN_BUTTON_DISABLED: `${(0, $63Q5S.tablePrefixSelector)}-numbered-column__button-disabled`,
    HOVERED_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-hovered-column`,
    HOVERED_ROW: `${(0, $63Q5S.tablePrefixSelector)}-hovered-row`,
    HOVERED_TABLE: `${(0, $63Q5S.tablePrefixSelector)}-hovered-table`,
    HOVERED_NO_HIGHLIGHT: `${(0, $63Q5S.tablePrefixSelector)}-hovered-no-highlight`,
    HOVERED_CELL: `${(0, $63Q5S.tablePrefixSelector)}-hovered-cell`,
    HOVERED_CELL_IN_DANGER: 'danger',
    HOVERED_CELL_ACTIVE: 'active',
    HOVERED_CELL_WARNING: `${(0, $63Q5S.tablePrefixSelector)}-hovered-cell__warning`,
    HOVERED_DELETE_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-hovered-delete-button`,
    WITH_CONTROLS: `${(0, $63Q5S.tablePrefixSelector)}-with-controls`,
    RESIZING_PLUGIN: `${(0, $63Q5S.tablePrefixSelector)}-resizing-plugin`,
    RESIZE_CURSOR: `${(0, $63Q5S.tablePrefixSelector)}-resize-cursor`,
    IS_RESIZING: `${(0, $63Q5S.tablePrefixSelector)}-is-resizing`,
    RESIZE_HANDLE_DECORATION: `${(0, $63Q5S.tablePrefixSelector)}-resize-decoration`,
    CONTEXTUAL_SUBMENU: `${(0, $63Q5S.tablePrefixSelector)}-contextual-submenu`,
    CONTEXTUAL_MENU_BUTTON_WRAP: `${(0, $63Q5S.tablePrefixSelector)}-contextual-menu-button-wrap`,
    CONTEXTUAL_MENU_BUTTON: `${(0, $63Q5S.tablePrefixSelector)}-contextual-menu-button`,
    CONTEXTUAL_MENU_BUTTON_FIXED: `${(0, $63Q5S.tablePrefixSelector)}-contextual-menu-button-fixed`,
    CONTEXTUAL_MENU_ICON_SMALL: `${(0, $63Q5S.tablePrefixSelector)}-contextual-submenu-icon-small`,
    // come from prosemirror-table
    SELECTED_CELL: 'selectedCell',
    // defined in ReactNodeView based on PM node name
    NODEVIEW_WRAPPER: 'tableView-content-wrap',
    TABLE_SELECTED: `${(0, $63Q5S.tablePrefixSelector)}-table__selected`,
    TABLE_CELL: (0, $63Q5S.tableCellSelector),
    TABLE_CORNER_MASK: `${(0, $63Q5S.tablePrefixSelector)}-corner-mask`,
    TABLE_HEADER_CELL: (0, $63Q5S.tableHeaderSelector),
    TABLE_STICKY: `${(0, $63Q5S.tablePrefixSelector)}-sticky`,
    TABLE_CHROMELESS: `${(0, $63Q5S.tablePrefixSelector)}-chromeless`,
    TOP_LEFT_CELL: 'table > tbody > tr:nth-child(2) > td:nth-child(1)',
    WITH_COLUMN_INSERT_LINE: `${(0, $63Q5S.tablePrefixSelector)}-column-insert-line`,
    WITH_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Q5S.tablePrefixSelector)}-column-insert-line__inactive`,
    WITH_FIRST_COLUMN_INSERT_LINE: `${(0, $63Q5S.tablePrefixSelector)}-first-column-insert-line`,
    WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Q5S.tablePrefixSelector)}-first-column-insert-line__inactive`,
    WITH_LAST_COLUMN_INSERT_LINE: `${(0, $63Q5S.tablePrefixSelector)}-last-column-insert-line`,
    WITH_LAST_COLUMN_INSERT_LINE_INACTIVE: `${(0, $63Q5S.tablePrefixSelector)}-last-column-insert-line__inactive`,
    WITH_RESIZE_LINE: `${(0, $63Q5S.tablePrefixSelector)}-column-resize-line`,
    WITH_RESIZE_LINE_LAST_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-column-resize-line-last-column`,
    WITH_DRAG_RESIZE_LINE: `${(0, $63Q5S.tablePrefixSelector)}-drag-column-resize-line`,
    WITH_DRAG_RESIZE_LINE_LAST_COLUMN: `${(0, $63Q5S.tablePrefixSelector)}-drag-column-resize-line-last-column`,
    WITH_ROW_INSERT_LINE: `${(0, $63Q5S.tablePrefixSelector)}-row-insert-line`,
    WITH_ROW_INSERT_LINE_INACTIVE: `${(0, $63Q5S.tablePrefixSelector)}-row-insert-line__inactive`,
    WITH_LAST_ROW_INSERT_LINE: `${(0, $63Q5S.tablePrefixSelector)}-last-row-insert-line`,
    WITH_LAST_ROW_INSERT_LINE_INACTIVE: `${(0, $63Q5S.tablePrefixSelector)}-last-row-insert-line__inactive`,
    NATIVE_STICKY: `${(0, $63Q5S.tablePrefixSelector)}-row-native-sticky`,
    NATIVE_STICKY_ACTIVE: `${(0, $63Q5S.tablePrefixSelector)}-row-native-sticky-active`,
    NO_OVERFLOW: `${(0, $63Q5S.tablePrefixSelector)}-no-overflow`,
    ACTIVE_CURSOR_CELL: `${(0, $63Q5S.tablePrefixSelector)}-active-cursor-cell`
};

});

parcelRegister("5Yp1l", function(module, exports) {
$parcel$export(module.exports, "getAlignmentStyle", () => $d15ba627a50de3e5$export$b4e2cb644a5e9e7e);

var $1YIoS = parcelRequire("1YIoS");
const $d15ba627a50de3e5$var$centerAlignStyle = {
    display: 'flex',
    justifyContent: 'center'
};
const $d15ba627a50de3e5$var$leftAlignStyle = {
    display: 'flex',
    justifyContent: 'flex-start'
};
const $d15ba627a50de3e5$export$b4e2cb644a5e9e7e = (alignment)=>alignment === (0, $1YIoS.ALIGN_START) ? $d15ba627a50de3e5$var$leftAlignStyle : $d15ba627a50de3e5$var$centerAlignStyle;

});
parcelRegister("1YIoS", function(module, exports) {
$parcel$export(module.exports, "ALIGN_START", () => $bbdc0b5cce73f7eb$export$2cbc54593c64b1f2);
$parcel$export(module.exports, "ALIGN_CENTER", () => $bbdc0b5cce73f7eb$export$3ea9e188ab01c845);
$parcel$export(module.exports, "normaliseAlignment", () => $bbdc0b5cce73f7eb$export$2e10df95acfe6933);
$parcel$export(module.exports, "shouldChangeAlignmentToCenterResized", () => $bbdc0b5cce73f7eb$export$8dcb9bda5f25db3a);

var $eyG1M = parcelRequire("eyG1M");
const $bbdc0b5cce73f7eb$export$2cbc54593c64b1f2 = 'align-start';
const $bbdc0b5cce73f7eb$export$3ea9e188ab01c845 = 'center';
const $bbdc0b5cce73f7eb$export$2e10df95acfe6933 = (layout)=>layout === $bbdc0b5cce73f7eb$export$3ea9e188ab01c845 || layout === $bbdc0b5cce73f7eb$export$2cbc54593c64b1f2 ? layout : $bbdc0b5cce73f7eb$export$3ea9e188ab01c845;
const $bbdc0b5cce73f7eb$export$8dcb9bda5f25db3a = (isTableAlignmentEnabled, tableNode, lineLength, updatedTableWidth)=>Boolean(isTableAlignmentEnabled && tableNode && tableNode.attrs.layout === $bbdc0b5cce73f7eb$export$2cbc54593c64b1f2 && lineLength && updatedTableWidth > lineLength && lineLength < (0, $eyG1M.FULL_WIDTH_EDITOR_CONTENT_WIDTH));

});



parcelRegister("d5kki", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $6e8b611e5811b7a5$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $ev7OZ = parcelRequire("ev7OZ");

var $6AHSo = parcelRequire("6AHSo");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $YREXK = parcelRequire("YREXK");
const $6e8b611e5811b7a5$var$EMPTY_STATE = {
    cellPos: -1,
    decorationSet: (0, $16ZMX.DecorationSet).empty
};
const $6e8b611e5811b7a5$export$88e8c90fa17a6a30 = new (0, $801jp.PluginKey)('tableActiveCellHighlight');
/**
 * Returns the position of the cell containing the cursor, or -1 if the cursor
 * is not in a table cell or the selection is a CellSelection.
 */ const $6e8b611e5811b7a5$var$getActiveCellPos = (state)=>{
    if (state.selection instanceof (0, $ev7OZ.CellSelection)) return -1;
    try {
        const cell = (0, $6AHSo.findCellClosestToPos)(state.selection.$from);
        return cell ? cell.pos : -1;
    } catch  {
        return -1;
    }
};
/** Builds the decoration state highlighting the cell at `cellPos`. */ const $6e8b611e5811b7a5$var$buildState = (cellPos, state)=>{
    if (cellPos === -1) return $6e8b611e5811b7a5$var$EMPTY_STATE;
    try {
        const cell = state.doc.nodeAt(cellPos);
        if (!cell) return $6e8b611e5811b7a5$var$EMPTY_STATE;
        const decoration = (0, $16ZMX.Decoration).node(cellPos, cellPos + cell.nodeSize, {
            class: (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL
        });
        return {
            cellPos: cellPos,
            decorationSet: (0, $16ZMX.DecorationSet).create(state.doc, [
                decoration
            ])
        };
    } catch  {
        return $6e8b611e5811b7a5$var$EMPTY_STATE;
    }
};
/** Keep the highlight on the whole active cell after document edits. */ const $6e8b611e5811b7a5$var$mapOrRebuildActiveCellHighlight = (tr, prev, newState, nextCellPos)=>{
    const decorationSet = prev.decorationSet.map(tr.mapping, newState.doc);
    const decorations = decorationSet.find();
    const cell = nextCellPos === -1 ? null : newState.doc.nodeAt(nextCellPos);
    if (cell && decorations.length === 1 && decorations[0].from === nextCellPos && decorations[0].to === nextCellPos + cell.nodeSize) return {
        cellPos: nextCellPos,
        decorationSet: decorationSet,
        hasHadInteraction: true
    };
    return {
        ...$6e8b611e5811b7a5$var$buildState(nextCellPos, newState),
        hasHadInteraction: true
    };
};
const $6e8b611e5811b7a5$var$hasHadInteraction = (api)=>{
    var _api$interaction$shar;
    // The interaction plugin is optional - when absent, default to treating the editor as
    // interacted.
    if (!(api !== null && api !== void 0 && api.interaction)) return true;
    return ((_api$interaction$shar = api.interaction.sharedState.currentState()) === null || _api$interaction$shar === void 0 ? void 0 : _api$interaction$shar.interactionState) !== 'hasNotHadInteraction';
};
/** Stays hidden until the first interaction. */ const $6e8b611e5811b7a5$var$createStateField = (api)=>({
        init: (_config, state)=>{
            const interacted = $6e8b611e5811b7a5$var$hasHadInteraction(api);
            return {
                ...interacted ? $6e8b611e5811b7a5$var$buildState($6e8b611e5811b7a5$var$getActiveCellPos(state), state) : $6e8b611e5811b7a5$var$EMPTY_STATE,
                hasHadInteraction: interacted
            };
        },
        apply: (tr, prev, _oldState, newState)=>{
            const interacted = $6e8b611e5811b7a5$var$hasHadInteraction(api);
            // Keep the highlight hidden until the first interaction has happened.
            if (!interacted) return prev;
            // `true` only on the single transaction that crosses from "no interaction"
            // to "interacted" — the meta-only transaction that reveals the highlight.
            const isFirstInteraction = !prev.hasHadInteraction;
            if (!tr.docChanged && !tr.selectionSet && !isFirstInteraction) // Doc, selection and interaction are all unchanged — nothing to do.
            return prev;
            const nextCellPos = $6e8b611e5811b7a5$var$getActiveCellPos(newState);
            if (tr.docChanged && (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_perf_patch')) return $6e8b611e5811b7a5$var$mapOrRebuildActiveCellHighlight(tr, prev, newState, nextCellPos);
            if (nextCellPos === prev.cellPos && !isFirstInteraction) return prev;
            return {
                ...$6e8b611e5811b7a5$var$buildState(nextCellPos, newState),
                hasHadInteraction: true
            };
        }
    });
const $6e8b611e5811b7a5$export$ae829ec7b2625219 = (api)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $6e8b611e5811b7a5$export$88e8c90fa17a6a30,
        state: $6e8b611e5811b7a5$var$createStateField(api),
        props: {
            decorations: (state)=>{
                var _activeCellHighlightP;
                return ((_activeCellHighlightP = $6e8b611e5811b7a5$export$88e8c90fa17a6a30.getState(state)) === null || _activeCellHighlightP === void 0 ? void 0 : _activeCellHighlightP.decorationSet) ?? (0, $16ZMX.DecorationSet).empty;
            }
        }
    });
};

});
parcelRegister("6AHSo", function(module, exports) {
$parcel$export(module.exports, "findCellClosestToPos", () => $3ecf8f68376c9b27$export$3ac56532a0bf4018);

var $a4TQr = parcelRequire("a4TQr");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $3ecf8f68376c9b27$var$CELL_ROLE_REGEX = /cell/i;
const $3ecf8f68376c9b27$export$3ac56532a0bf4018 = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && $3ecf8f68376c9b27$var$CELL_ROLE_REGEX.test(node.type.spec.tableRole);
    return (0, $a4TQr.findParentNodeClosestToPos)($pos, predicate);
};

});


parcelRegister("2QInN", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $69a8d517f590b45d$export$ae829ec7b2625219);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $1y7gE = parcelRequire("1y7gE");

var $8L6TV = parcelRequire("8L6TV");

var $4Ckj5 = parcelRequire("4Ckj5");

var $iluY5 = parcelRequire("iluY5");

var $cbtJX = parcelRequire("cbtJX");

var $h60LU = parcelRequire("h60LU");
const $69a8d517f590b45d$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent)=>new (0, $1y7gE.SafePlugin)({
        key: (0, $cbtJX.pluginKey),
        state: (0, $iluY5.createPluginState)(dispatch, (0, $h60LU.defaultState)),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>{
                var _tr$getMeta;
                return (_tr$getMeta = tr.getMeta((0, $cbtJX.pluginKey))) === null || _tr$getMeta === void 0 || (_tr$getMeta = _tr$getMeta.data) === null || _tr$getMeta === void 0 || (_tr$getMeta = _tr$getMeta.currentActions) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.includes('pasted');
            });
            if (tr) {
                var _tr$getMeta2;
                const newTr = newState.tr;
                dispatchAnalyticsEvent({
                    action: (0, $8d4kB.TABLE_ACTION).ROW_OR_COLUMN_MOVED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        type: (_tr$getMeta2 = tr.getMeta((0, $cbtJX.pluginKey))) === null || _tr$getMeta2 === void 0 || (_tr$getMeta2 = _tr$getMeta2.data) === null || _tr$getMeta2 === void 0 ? void 0 : _tr$getMeta2.type
                    }
                });
                return (0, $4Ckj5.resetRowOrColumnMovedTransform)()(newTr);
            }
            return undefined;
        },
        props: {
            handlePaste: ({ state: state, dispatch: dispatch }, event, slice)=>{
                const { schema: schema } = state;
                const type = (0, $8L6TV.getTableElementMoveTypeBySlice)(slice, state);
                // if the selection wasn't in the first cell of a row or column, don't count it
                if (!type || !(0, $8L6TV.isInsideFirstCellOfRowOrColumn)(state.selection, type)) return;
                const count = (0, $8L6TV.countCellsInSlice)(slice, schema, type);
                (0, $4Ckj5.updateRowOrColumnMoved)({
                    numberOfCells: count,
                    type: type
                }, 'pasted')(state, dispatch);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                const { schema: schema } = state;
                const type = (0, $8L6TV.getTableSelectionType)(state.selection);
                const count = (0, $8L6TV.countCellsInSlice)(slice, schema, type);
                (0, $4Ckj5.updateRowOrColumnMoved)({
                    numberOfCells: count,
                    type: type
                }, 'copyOrCut')(state, dispatch);
                return slice;
            }
        }
    });

});
parcelRegister("8L6TV", function(module, exports) {
$parcel$export(module.exports, "setEditorFocus", () => $fd728d15af94912d$export$f516ed9c5f43abfc);
$parcel$export(module.exports, "setTableRef", () => $fd728d15af94912d$export$79b661cbf50c3490);
$parcel$export(module.exports, "transformSliceRemoveCellBackgroundColor", () => $fd728d15af94912d$export$f4e57bcfd514085d);
$parcel$export(module.exports, "transformSliceToFixDarkModeDefaultBackgroundColor", () => $fd728d15af94912d$export$80a571fa7de8754d);
$parcel$export(module.exports, "transformSliceToAddTableHeaders", () => $fd728d15af94912d$export$bb3294affcb5059f);
$parcel$export(module.exports, "transformSliceToRemoveColumnsWidths", () => $fd728d15af94912d$export$8fcd87e05a98248e);
$parcel$export(module.exports, "countCellsInSlice", () => $fd728d15af94912d$export$6dfa233a4abfaf9);
$parcel$export(module.exports, "getTableSelectionType", () => $fd728d15af94912d$export$e5b37491e59cd9d);
$parcel$export(module.exports, "getTableElementMoveTypeBySlice", () => $fd728d15af94912d$export$1798097ddb0b05de);
$parcel$export(module.exports, "isInsideFirstCellOfRowOrColumn", () => $fd728d15af94912d$export$950c7c2913136ae5);
$parcel$export(module.exports, "deleteTable", () => $fd728d15af94912d$export$4882f04e79ed0a80);
$parcel$export(module.exports, "deleteTableIfSelected", () => $fd728d15af94912d$export$a853c8f1dbe33b1f);
$parcel$export(module.exports, "moveCursorBackward", () => $fd728d15af94912d$export$f49961c90342f4db);
$parcel$export(module.exports, "setMultipleCellAttrs", () => $fd728d15af94912d$export$91116982335533cf);
$parcel$export(module.exports, "setMultipleCellAttrsEditorCommand", () => $fd728d15af94912d$export$95deba1419fe5dbe);
$parcel$export(module.exports, "selectColumn", () => $fd728d15af94912d$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectColumns", () => $fd728d15af94912d$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectRow", () => $fd728d15af94912d$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectRows", () => $fd728d15af94912d$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "showInsertColumnButton", () => $fd728d15af94912d$export$72433e6f15f8aeaa);
$parcel$export(module.exports, "showInsertRowButton", () => $fd728d15af94912d$export$6ed6a4eb343cf21);
$parcel$export(module.exports, "hideInsertColumnOrRowButton", () => $fd728d15af94912d$export$27d9631a056c3f39);
$parcel$export(module.exports, "addResizeHandleDecorations", () => $fd728d15af94912d$export$cc6f44d67305c400);
$parcel$export(module.exports, "updateResizeHandleDecorations", () => $fd728d15af94912d$export$31eed8673ceee613);
$parcel$export(module.exports, "removeResizeHandleDecorations", () => $fd728d15af94912d$export$99c5230572e6696d);
$parcel$export(module.exports, "autoSizeTable", () => $fd728d15af94912d$export$d6e5d8afaa172954);
$parcel$export(module.exports, "addBoldInEmptyHeaderCells", () => $fd728d15af94912d$export$bf5ab08a5036bda8);
$parcel$export(module.exports, "updateWidthToWidest", () => $fd728d15af94912d$export$833849b68219cbcc);
$parcel$export(module.exports, "setTableAlignment", () => $fd728d15af94912d$export$e0cd4746386d78b5);
$parcel$export(module.exports, "setTableAlignmentWithTableContentWithPos", () => $fd728d15af94912d$export$2880e63de92f5116);
$parcel$export(module.exports, "setFocusToCellMenu", () => $fd728d15af94912d$export$a6e5155a1ac72366);

var $3ZJj6 = parcelRequire("3ZJj6");

var $k5JVX = parcelRequire("k5JVX");

var $6cm8v = parcelRequire("6cm8v");

var $hCON4 = parcelRequire("hCON4");

var $cu8Jp = parcelRequire("cu8Jp");

var $c5vAC = parcelRequire("c5vAC");

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $6AHSo = parcelRequire("6AHSo");
var $5n2u9 = parcelRequire("5n2u9");
var $kD3Xq = parcelRequire("kD3Xq");

var $2rErm = parcelRequire("2rErm");

var $99qNq = parcelRequire("99qNq");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");

var $h65Gv = parcelRequire("h65Gv");

var $403GK = parcelRequire("403GK");

var $2mhIH = parcelRequire("2mhIH");

var $2gwLg = parcelRequire("2gwLg");

var $bcN2K = parcelRequire("bcN2K");

var $YREXK = parcelRequire("YREXK");

var $f3xW3 = parcelRequire("f3xW3");

var $7uENW = parcelRequire("7uENW");

var $4GJqd = parcelRequire("4GJqd");

var $1uBzh = parcelRequire("1uBzh");

var $ijKnh = parcelRequire("ijKnh");

var $4WYVI = parcelRequire("4WYVI");

var $28qg3 = parcelRequire("28qg3");
const $fd728d15af94912d$var$DARK_MODE_CELL_COLOR = '#1f1f21';
const $fd728d15af94912d$var$DARK_MODE_HEADER_COLOR = '#303134';
const $fd728d15af94912d$var$selectColumnWithMergedEdgeRows = (tr, column, expand)=>{
    var _getCellsInColumn;
    const transformedTr = (0, $403GK.selectColumn)(column, expand)(tr);
    if (expand) return transformedTr;
    const selectableCells = (_getCellsInColumn = (0, $2rErm.getCellsInColumn)(column)(tr.selection)) === null || _getCellsInColumn === void 0 ? void 0 : _getCellsInColumn.filter(({ node: node })=>node.attrs.colspan === 1);
    const firstCell = selectableCells === null || selectableCells === void 0 ? void 0 : selectableCells[0];
    const lastCell = selectableCells === null || selectableCells === void 0 ? void 0 : selectableCells[selectableCells.length - 1];
    if (!firstCell || !lastCell) return transformedTr;
    return transformedTr.setSelection(new (0, $ev7OZ.CellSelection)(transformedTr.doc.resolve(lastCell.pos), transformedTr.doc.resolve(firstCell.pos)));
};
const $fd728d15af94912d$export$f516ed9c5f43abfc = (editorHasFocus)=>(0, $4GJqd.createCommand)((state)=>{
        const pluginState = (0, $4GJqd.getPluginState)(state);
        if (pluginState.editorHasFocus === editorHasFocus && (0, $bcN2K.isExperimentEnabled)('platform_editor_improve_inp')) return false;
        return {
            type: 'SET_EDITOR_FOCUS',
            data: {
                editorHasFocus: editorHasFocus
            }
        };
    });
const $fd728d15af94912d$export$79b661cbf50c3490 = (ref)=>(0, $4GJqd.createCommand)((state)=>{
        const tableRef = ref;
        const foundTable = (0, $5n2u9.findTable)(state.selection);
        const tableNode = ref && foundTable ? foundTable.node : undefined;
        const tablePos = ref && foundTable ? foundTable.pos : undefined;
        const tableWrapperTarget = (0, $hCON4.closestElement)(tableRef, `.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`) || undefined;
        return {
            type: 'SET_TABLE_REF',
            data: {
                tableRef: tableRef,
                tableNode: tableNode,
                tablePos: tablePos,
                tableWrapperTarget: tableWrapperTarget,
                isNumberColumnEnabled: (0, $4WYVI.checkIfNumberColumnEnabled)(state.selection),
                isHeaderRowEnabled: (0, $4WYVI.checkIfHeaderRowEnabled)(state.selection),
                isHeaderColumnEnabled: (0, $4WYVI.checkIfHeaderColumnEnabled)(state.selection),
                resizeHandleRowIndex: undefined,
                resizeHandleColumnIndex: undefined
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$c8d277469ceb354b = (name, value)=>(state, dispatch)=>{
        const { tr: tr, selection: selection } = state;
        if (selection instanceof (0, $ev7OZ.CellSelection)) {
            let updated = false;
            selection.forEachCell((cell, pos)=>{
                if (cell.attrs[name] !== value) {
                    tr.setNodeMarkup(pos, cell.type, {
                        ...cell.attrs,
                        [name]: value
                    });
                    updated = true;
                }
            });
            if (updated) {
                if (dispatch) dispatch(tr);
                return true;
            }
        } else {
            const cell = (0, $2mhIH.selectionCell)(state.selection);
            if (cell) {
                if (dispatch) {
                    var _cell$nodeAfter, _cell$nodeAfter2;
                    dispatch(tr.setNodeMarkup(cell.pos, (_cell$nodeAfter = cell.nodeAfter) === null || _cell$nodeAfter === void 0 ? void 0 : _cell$nodeAfter.type, {
                        ...(_cell$nodeAfter2 = cell.nodeAfter) === null || _cell$nodeAfter2 === void 0 ? void 0 : _cell$nodeAfter2.attrs,
                        [name]: value
                    }));
                }
                return true;
            }
        }
        return false;
    };
const $fd728d15af94912d$export$7f2d94cd70b8a5ce = (command)=>(state, dispatch, view)=>{
        const { selection: selection, schema: { nodes: { tableHeader: tableHeader } } } = state;
        if (selection instanceof (0, $801jp.TextSelection)) {
            const cell = (0, $6AHSo.findCellClosestToPos)(selection.$from);
            if (cell && cell.node.type !== tableHeader) return command(state, dispatch, view);
        }
        if (selection instanceof (0, $ev7OZ.CellSelection)) {
            const rect = (0, $l5gi8.getSelectionRect)(selection);
            if (!(0, $4WYVI.checkIfHeaderRowEnabled)(selection) || rect && rect.top > 0) return command(state, dispatch, view);
        }
        return false;
    };
const $fd728d15af94912d$export$f4e57bcfd514085d = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $c5vAC.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $fd728d15af94912d$export$80a571fa7de8754d = (slice, schema)=>{
    // the background attr in adf should always store the light mode value of the background color
    // and tables which have been created without a background color set will have background as undefined
    // in the undefined case, when pasting from renderer, we get a background color which is the dark mode color
    // we need to convert it back to undefined, otherwise it will be interpreted as a light mode value and be inverted
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $c5vAC.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            const cellAttrs = {
                ...maybeCell.attrs
            };
            if (maybeCell.type === tableCell && cellAttrs.background === $fd728d15af94912d$var$DARK_MODE_CELL_COLOR || maybeCell.type === tableHeader && cellAttrs.background === $fd728d15af94912d$var$DARK_MODE_HEADER_COLOR) cellAttrs.background = undefined;
            return maybeCell.type.createChecked(cellAttrs, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $fd728d15af94912d$export$bb3294affcb5059f = (slice, schema)=>{
    const { table: table, tableHeader: tableHeader, tableRow: tableRow } = schema.nodes;
    return (0, $c5vAC.mapSlice)(slice, (maybeTable)=>{
        if (maybeTable.type === table) {
            const firstRow = maybeTable.firstChild;
            if (firstRow) {
                const headerCols = [];
                firstRow.forEach((oldCol)=>{
                    headerCols.push(tableHeader.createChecked(oldCol.attrs, oldCol.content, oldCol.marks));
                });
                const headerRow = tableRow.createChecked(firstRow.attrs, headerCols, firstRow.marks);
                return maybeTable.copy(maybeTable.content.replaceChild(0, headerRow));
            }
        }
        return maybeTable;
    });
};
const $fd728d15af94912d$export$8fcd87e05a98248e = (slice, schema)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    return (0, $c5vAC.mapSlice)(slice, (maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            if (!maybeCell.attrs.colwidth) return maybeCell;
            return maybeCell.type.createChecked({
                ...maybeCell.attrs,
                colwidth: undefined
            }, maybeCell.content, maybeCell.marks);
        }
        return maybeCell;
    });
};
const $fd728d15af94912d$export$6dfa233a4abfaf9 = (slice, schema, type)=>{
    const { tableHeader: tableHeader, tableCell: tableCell } = schema.nodes;
    let count = 0;
    if (!type) return count;
    slice.content.descendants((maybeCell)=>{
        if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
            count += type === 'row' ? maybeCell.attrs.colspan : maybeCell.attrs.rowspan;
            return false;
        }
    });
    return count;
};
const $fd728d15af94912d$export$e5b37491e59cd9d = (selection)=>{
    if (selection instanceof (0, $ev7OZ.CellSelection)) return selection.isRowSelection() ? 'row' : selection.isColSelection() ? 'column' : undefined;
};
const $fd728d15af94912d$export$1798097ddb0b05de = (slice, state)=>{
    const { schema: { nodes: { tableRow: tableRow, table: table } } } = state;
    const currentTable = (0, $5n2u9.findTable)(state.tr.selection);
    // check if copied slice is a table or table row
    if (!slice.content.firstChild || slice.content.firstChild.type !== table && slice.content.firstChild.type !== tableRow || !currentTable) return undefined;
    // if the slice only contains one table row, assume it's a row
    if (slice.content.childCount === 1 && slice.content.firstChild.type === tableRow) return 'row';
    // `TableMap.get` can throw if the content is invalid - in which case we should just
    // return undefined
    try {
        const map = (0, $dpooP.TableMap).get(currentTable.node);
        const slicedMap = (0, $dpooP.TableMap).get(slice.content.firstChild);
        return map.width === slicedMap.width ? 'row' : map.height === slicedMap.height ? 'column' : undefined;
    } catch  {
        return undefined;
    }
};
const $fd728d15af94912d$export$950c7c2913136ae5 = (selection, type)=>{
    const table = (0, $5n2u9.findTable)(selection);
    if (!table || !type) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const map = (0, $dpooP.TableMap).get(table.node);
    const cell = (0, $6AHSo.findCellClosestToPos)(selection.$anchor);
    if (!cell) return false;
    const pos = cell.pos - table.pos - 1;
    // cell positions in table map always start at 1, as they're offsets not positions
    const index = map.map.findIndex((value)=>value === pos);
    return type === 'row' ? index % map.width === 0 : index < map.width;
};
const $fd728d15af94912d$export$4882f04e79ed0a80 = (state, dispatch)=>{
    if (dispatch) dispatch((0, $h65Gv.removeTable)(state.tr));
    return true;
};
const $fd728d15af94912d$export$a853c8f1dbe33b1f = (state, dispatch)=>{
    if ((0, $kD3Xq.isTableSelected)(state.selection)) return $fd728d15af94912d$export$4882f04e79ed0a80(state, dispatch);
    return false;
};
const $fd728d15af94912d$export$a2b81d7877a7a370 = (schema)=>(tr)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $5n2u9.findTable)(tr.selection);
        const map = (0, $dpooP.TableMap).get(table.node);
        for(let i = 0; i < map.width; i++){
            const cell = table.node.child(0).child(i);
            tr.setNodeMarkup(table.start + map.map[i], schema.nodes.tableHeader, cell.attrs);
        }
        return tr;
    };
const $fd728d15af94912d$export$f49961c90342f4db = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    // if cursor is in the middle of a text node, do nothing
    if (!$cursor || $cursor.parentOffset > 0) return false;
    // find the node before the cursor
    let before;
    let cut;
    if (!(0, $4WYVI.isIsolating)($cursor.parent)) for(let i = $cursor.depth - 1; !before && i >= 0; i--){
        if ($cursor.index(i) > 0) {
            cut = $cursor.before(i + 1);
            before = $cursor.node(i).child($cursor.index(i) - 1);
        }
        if ((0, $4WYVI.isIsolating)($cursor.node(i))) break;
    }
    // if the node before is not a table node - do nothing
    if (!before || before.type !== state.schema.nodes.table) return false;
    /*
     ensure we're just at a top level paragraph
     otherwise, perform regular backspace behaviour
    */ const grandparent = $cursor.node($cursor.depth - 1);
    if ($cursor.parent.type !== state.schema.nodes.paragraph || grandparent && grandparent.type !== state.schema.nodes.doc) return false;
    const { tr: tr } = state;
    const lastCellPos = (cut || 0) - 4;
    // need to move cursor inside the table to be able to calculate table's offset
    tr.setSelection(new (0, $801jp.TextSelection)(state.doc.resolve(lastCellPos)));
    const { $from: $from } = tr.selection;
    const start = $from.start(-1);
    const pos = start + $from.parent.nodeSize - 1;
    // move cursor to the last cell
    // it doesn't join node before (last cell) with node after (content after the cursor)
    // due to ridiculous amount of PM code that would have been required to overwrite
    tr.setSelection(new (0, $801jp.TextSelection)(state.doc.resolve(pos)));
    // if we are inside an empty paragraph not at the end of the doc we delete it
    const cursorNode = $cursor.node();
    const docEnd = state.doc.content.size;
    const paragraphWrapStart = $cursor.pos - 1;
    const paragraphWrapEnd = $cursor.pos + 1;
    if (cursorNode.content.size === 0 && $cursor.pos + 1 !== docEnd) tr.delete(paragraphWrapStart, paragraphWrapEnd);
    if (dispatch) dispatch(tr);
    return true;
};
const $fd728d15af94912d$export$91116982335533cf = (attrs, editorView)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(state);
        if ((0, $2HFfw.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $2gwLg.setCellAttrs)((0, $6AHSo.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $6AHSo.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $2gwLg.setCellAttrs)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) {
            if (dispatch) {
                editorView === null || editorView === void 0 || editorView.focus();
                dispatch(tr);
            }
            return true;
        }
        return false;
    };
const $fd728d15af94912d$export$95deba1419fe5dbe = (attrs, targetCellPosition)=>({ tr: tr })=>{
        let cursorPos;
        if ((0, $2HFfw.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_cell, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                (0, $2gwLg.setCellAttrs)((0, $6AHSo.findCellClosestToPos)($pos), attrs)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (typeof targetCellPosition === 'number') {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $6AHSo.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            (0, $2gwLg.setCellAttrs)(cell, attrs)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos !== undefined) return tr;
        return null;
    };
const $fd728d15af94912d$export$c2e8772deb1607ea = (column, expand, triggeredByKeyboard = false)=>(0, $4GJqd.createCommand)((state)=>{
        const cells = (0, $2rErm.getCellsInColumn)(column)(state.tr.selection);
        if (!cells || !cells.length || typeof cells[0].pos !== 'number') return false;
        const selectionTransaction = $fd728d15af94912d$var$selectColumnWithMergedEdgeRows(state.tr, column, expand);
        const decorations = (0, $ijKnh.createColumnSelectedDecoration)(selectionTransaction);
        const decorationSet = (0, $28qg3.updatePluginStateDecorations)(state, decorations, (0, $YREXK.TableDecorations).COLUMN_SELECTED);
        const targetCellPosition = cells[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        const selectionTransaction = $fd728d15af94912d$var$selectColumnWithMergedEdgeRows(tr, column, expand);
        return selectionTransaction.setMeta('addToHistory', false).setMeta('selectedColumnViaKeyboard', triggeredByKeyboard);
    });
const $fd728d15af94912d$export$41a42e79fbe56d35 = (columnIndexes)=>(0, $4GJqd.createCommand)((state)=>{
        if (!columnIndexes) return false;
        const cells = columnIndexes.map((column)=>(0, $2rErm.getCellsInColumn)(column)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const decorations = (0, $ijKnh.createColumnSelectedDecoration)((0, $403GK.selectColumns)(columnIndexes)(state.tr));
        const decorationSet = (0, $28qg3.updatePluginStateDecorations)(state, decorations, (0, $YREXK.TableDecorations).COLUMN_SELECTED);
        const cellsInFirstColumn = (0, $2rErm.getCellsInColumn)(Math.min(...columnIndexes))(state.tr.selection);
        if (!cellsInFirstColumn || cellsInFirstColumn.length === 0) return false;
        const targetCellPosition = cellsInFirstColumn[0].pos;
        return {
            type: 'SELECT_COLUMN',
            data: {
                targetCellPosition: targetCellPosition,
                decorationSet: decorationSet
            }
        };
    }, (tr)=>{
        return (0, $403GK.selectColumns)(columnIndexes)(tr).setMeta('addToHistory', false);
    });
const $fd728d15af94912d$export$e247ed8cec4832f4 = (row, expand, triggeredByKeyboard = false)=>(0, $4GJqd.createCommand)((state)=>{
        let targetCellPosition;
        const cells = (0, $99qNq.getCellsInRow)(row)(state.tr.selection);
        if (cells && cells.length) targetCellPosition = cells[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $403GK.selectRow)(row, expand)(tr).setMeta('addToHistory', false).setMeta('selectedRowViaKeyboard', triggeredByKeyboard));
const $fd728d15af94912d$export$b5ba3b60192c7a8d = (rowIndexes)=>(0, $4GJqd.createCommand)((state)=>{
        if (rowIndexes.length === 0) return false;
        const cells = rowIndexes.map((row)=>(0, $99qNq.getCellsInRow)(row)(state.tr.selection)).flat();
        if (!cells || !cells.length || cells.some((cell)=>cell && typeof cell.pos !== 'number')) return false;
        const cellsInFirstRow = (0, $99qNq.getCellsInRow)(Math.min(...rowIndexes))(state.tr.selection);
        if (!cellsInFirstRow || cellsInFirstRow.length === 0) return false;
        const targetCellPosition = cellsInFirstRow[0].pos;
        return {
            type: 'SET_TARGET_CELL_POSITION',
            data: {
                targetCellPosition: targetCellPosition
            }
        };
    }, (tr)=>(0, $403GK.selectRows)(rowIndexes)(tr).setMeta('addToHistory', false));
const $fd728d15af94912d$export$72433e6f15f8aeaa = (columnIndex)=>(0, $4GJqd.createCommand)((_)=>columnIndex > -1 ? {
            type: 'SHOW_INSERT_COLUMN_BUTTON',
            data: {
                insertColumnButtonIndex: columnIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$6ed6a4eb343cf21 = (rowIndex)=>(0, $4GJqd.createCommand)((_)=>rowIndex > -1 ? {
            type: 'SHOW_INSERT_ROW_BUTTON',
            data: {
                insertRowButtonIndex: rowIndex
            }
        } : false, (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$27d9631a056c3f39 = ()=>(0, $4GJqd.createCommand)({
        type: 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON'
    }, (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$cc6f44d67305c400 = (rowIndex, columnIndex, includeTooltip, nodeViewPortalProviderAPI, isKeyboardResize)=>(0, $4GJqd.createCommand)((state)=>{
        const tableNode = (0, $5n2u9.findTable)(state.selection);
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $4GJqd.getPluginState)(state);
        if (!tableNode || !allowColumnResizing) return false;
        return {
            type: 'ADD_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $7uENW.buildColumnResizingDecorations)(rowIndex, columnIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $f3xW3.getDecorations)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip,
                isKeyboardResize: isKeyboardResize || false
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$31eed8673ceee613 = (nodeViewPortalProviderAPI, rowIndex, columnIndex, includeTooltip)=>(0, $4GJqd.createCommand)((state)=>{
        const tableNode = (0, $5n2u9.findTable)(state.selection);
        const { resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip, pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $4GJqd.getPluginState)(state);
        if (!tableNode || !allowColumnResizing) return false;
        const resolvedRowIndex = rowIndex ?? resizeHandleRowIndex;
        const resolvedColumnIndex = columnIndex ?? resizeHandleColumnIndex;
        const resolvedIncludeTooltip = includeTooltip ?? resizeHandleIncludeTooltip;
        if (resolvedRowIndex === undefined || resolvedColumnIndex === undefined || resolvedIncludeTooltip === undefined) return false;
        return {
            type: 'UPDATE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $7uENW.buildColumnResizingDecorations)(resolvedRowIndex, resolvedColumnIndex, resolvedIncludeTooltip, getIntl, nodeViewPortalProviderAPI)({
                    tr: state.tr,
                    decorationSet: (0, $f3xW3.getDecorations)(state)
                }),
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: includeTooltip
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$99c5230572e6696d = ()=>(0, $4GJqd.createCommand)((state)=>({
            type: 'REMOVE_RESIZE_HANDLE_DECORATIONS',
            data: {
                decorationSet: (0, $7uENW.clearColumnResizingDecorations)()({
                    tr: state.tr,
                    decorationSet: (0, $f3xW3.getDecorations)(state)
                })
            }
        }), (tr)=>tr.setMeta('addToHistory', false));
const $fd728d15af94912d$export$d6e5d8afaa172954 = (view, node, table, basePos, opts)=>{
    if (typeof basePos !== 'number') return false;
    view.dispatch((0, $1uBzh.fixAutoSizedTable)(view, node, table, basePos, opts));
    return true;
};
const $fd728d15af94912d$export$bf5ab08a5036bda8 = (tableCellHeader)=>(state, dispatch)=>{
        const { tr: tr } = state;
        if (// Avoid infinite loop when the current selection is not a TextSelection
        (0, $6cm8v.isTextSelection)(tr.selection) && tr.selection.$cursor && // When storedMark is null that means this is the initial state
        // if the user press to remove the mark storedMark will be an empty array
        // and we shouldn't apply the strong mark
        tr.storedMarks == null && // Check if the current node is a direct child from paragraph
        tr.selection.$from.depth === tableCellHeader.depth + 1 && // this logic is applied only for empty paragraph
        tableCellHeader.node.nodeSize === 4 && (0, $cu8Jp.isParagraph)(tableCellHeader.node.firstChild, state.schema)) {
            const { strong: strong } = state.schema.marks;
            tr.setStoredMarks([
                strong === null || strong === void 0 ? void 0 : strong.create()
            ]).setMeta('addToHistory', false);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $fd728d15af94912d$export$833849b68219cbcc = (widthToWidest)=>(0, $4GJqd.createCommand)((state)=>{
        const { widthToWidest: prevWidthToWidest } = (0, $4GJqd.getPluginState)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(widthToWidest, prevWidthToWidest)) return false;
        return {
            type: 'UPDATE_TABLE_WIDTH_TO_WIDEST',
            data: {
                widthToWidest: {
                    ...prevWidthToWidest,
                    ...widthToWidest
                }
            }
        };
    });
const $fd728d15af94912d$export$e0cd4746386d78b5 = (newAlignment, isCommentEditor)=>({ tr: tr })=>{
        const tableObject = (0, $5n2u9.findTable)(tr.selection);
        if (!tableObject) return null;
        const nextTableAttrs = {
            ...tableObject.node.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        // If table width is not set in the Comment editor, it means that the table width is inherited from the editor and is "full width".
        // In that case when switching between alignment options in the Comment editor we should keep the table width unset.
        if (!tableObject.node.attrs.width && !isCommentEditor) {
            const tableWidth = (0, $k5JVX.getTableContainerWidth)(tableObject.node);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableObject.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $fd728d15af94912d$export$2880e63de92f5116 = (newAlignment, tableNodeWithPos)=>({ tr: tr })=>{
        const table = tableNodeWithPos.node;
        const nextTableAttrs = {
            ...table.attrs,
            layout: newAlignment
        };
        // table uses old breakout values in layout attribute to determine width
        // but that information is lost when alignment changes, so we need to ensure we retain that info
        if (!table.attrs.width) {
            const tableWidth = (0, $k5JVX.getTableContainerWidth)(table);
            nextTableAttrs.width = tableWidth;
        }
        tr.setNodeMarkup(tableNodeWithPos.pos, undefined, nextTableAttrs).setMeta('scrollIntoView', false);
        return tr;
    };
const $fd728d15af94912d$export$a6e5155a1ac72366 = (isCellMenuOpenByKeyboard = true, originalTr)=>(0, $4GJqd.createCommand)(()=>{
        return {
            type: 'SET_CELL_MENU_OPEN',
            data: {
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }
        };
    }, (tr)=>(originalTr || tr).setMeta('addToHistory', false));

});
parcelRegister("2rErm", function(module, exports) {
$parcel$export(module.exports, "getCellsInColumn", () => $760b06996ffd5a5f$export$c14b77638b178c5d);

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");
const $760b06996ffd5a5f$export$c14b77638b178c5d = (columnIndexes)=>(selection)=>{
        const table = (0, $5n2u9.findTable)(selection);
        if (!table) return;
        const map = (0, $dpooP.TableMap).get(table.node);
        const indexes = Array.isArray(columnIndexes) ? columnIndexes : [
            columnIndexes
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.width - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: index,
                right: index + 1,
                top: 0,
                bottom: map.height
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };

});

parcelRegister("99qNq", function(module, exports) {
$parcel$export(module.exports, "getCellsInRow", () => $e0cca444f303bdb3$export$a804b6b4ce22aa92);

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");
const $e0cca444f303bdb3$export$a804b6b4ce22aa92 = (rowIndex)=>(selection)=>{
        const table = (0, $5n2u9.findTable)(selection);
        if (!table) return;
        const map = (0, $dpooP.TableMap).get(table.node);
        const indexes = Array.isArray(rowIndex) ? rowIndex : [
            rowIndex
        ];
        return indexes.filter((index)=>index >= 0 && index <= map.height - 1).reduce((acc, index)=>{
            const cells = map.cellsInRect({
                left: 0,
                right: map.width,
                top: index,
                bottom: index + 1
            });
            return acc.concat(cells.map((nodePos)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const node = table.node.nodeAt(nodePos);
                const pos = nodePos + table.start;
                return {
                    pos: pos,
                    start: pos + 1,
                    node: node,
                    depth: table.depth + 2
                };
            }));
        }, []);
    };

});

parcelRegister("l5gi8", function(module, exports) {
$parcel$export(module.exports, "getSelectionRect", () => $e60d89eaf289df63$export$aa946c0ed562e2ed);

var $dpooP = parcelRequire("dpooP");

var $2HFfw = parcelRequire("2HFfw");
const $e60d89eaf289df63$export$aa946c0ed562e2ed = (selection)=>{
    if (!(0, $2HFfw.isSelectionType)(selection, 'cell')) return;
    const start = selection.$anchorCell.start(-1);
    const map = (0, $dpooP.TableMap).get(selection.$anchorCell.node(-1));
    return map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start);
};

});

parcelRegister("h65Gv", function(module, exports) {
$parcel$export(module.exports, "removeTable", () => $4a4b8eed32bab855$export$5b4a0d6329b35552);

var $dXesv = parcelRequire("dXesv");
const $4a4b8eed32bab855$export$5b4a0d6329b35552 = (tr)=>{
    const { $from: $from } = tr.selection;
    for(let depth = $from.depth; depth > 0; depth--){
        const node = $from.node(depth);
        if (node.type.spec.tableRole === 'table') return (0, $dXesv.cloneTr)(tr.delete($from.before(depth), $from.after(depth)));
    }
    return tr;
};

});

parcelRegister("403GK", function(module, exports) {
$parcel$export(module.exports, "selectColumn", () => $969c897d6838ada3$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectRow", () => $969c897d6838ada3$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectRows", () => $969c897d6838ada3$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "selectColumns", () => $969c897d6838ada3$export$41a42e79fbe56d35);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $dXesv = parcelRequire("dXesv");

var $6AHSo = parcelRequire("6AHSo");

var $5n2u9 = parcelRequire("5n2u9");



const $969c897d6838ada3$var$select = (type)=>(index, expand)=>(tr)=>{
            const table = (0, $5n2u9.findTable)(tr.selection);
            const isRowSelection = type === 'row';
            const prevSelection = tr.selection;
            const isPrevRowSelection = !!prevSelection.$anchorCell && !!prevSelection.$headCell;
            if (table) {
                const map = (0, $dpooP.TableMap).get(table.node);
                // Check if the index is valid
                if (index >= 0 && index < (isRowSelection ? map.height : map.width)) {
                    let left = isRowSelection ? 0 : index;
                    let top = isRowSelection ? index : 0;
                    let right = isRowSelection ? map.width : index + 1;
                    let bottom = isRowSelection ? index + 1 : map.height;
                    let cellsInFirstRow = [];
                    if (expand) {
                        const cell = (0, $6AHSo.findCellClosestToPos)(tr.selection.$from);
                        if (!cell) return tr;
                        const selRect = map.findCell(cell.pos - table.start);
                        if (isRowSelection) {
                            top = Math.min(top, selRect.top);
                            bottom = Math.max(bottom, selRect.bottom);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: right,
                                bottom: top + 1
                            });
                            const targetRowCells = map.cellsInRect({
                                left: left,
                                top: index,
                                right: right,
                                bottom: index + 1
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $dXesv.cloneTr)(tr.setSelection(new (0, $ev7OZ.CellSelection)($anchor, $head)));
                            }
                        } else {
                            left = Math.min(left, selRect.left);
                            right = Math.max(right, selRect.right);
                            cellsInFirstRow = map.cellsInRect({
                                left: left,
                                top: top,
                                right: left + 1,
                                bottom: bottom
                            });
                            const targetRowCells = map.cellsInRect({
                                left: index,
                                top: top,
                                right: index + 1,
                                bottom: bottom
                            });
                            const isBackwardSelection = targetRowCells[0] < prevSelection.$head.pos - table.start;
                            if (isBackwardSelection && isPrevRowSelection) {
                                const head = table.start + cellsInFirstRow[0];
                                const anchor = prevSelection.$anchorCell.pos;
                                const $head = tr.doc.resolve(head);
                                const $anchor = tr.doc.resolve(anchor);
                                return (0, $dXesv.cloneTr)(tr.setSelection(new (0, $ev7OZ.CellSelection)($anchor, $head)));
                            }
                        }
                    }
                    cellsInFirstRow = map.cellsInRect({
                        left: left,
                        top: top,
                        right: isRowSelection ? right : left + 1,
                        bottom: isRowSelection ? top + 1 : bottom
                    });
                    const cellsInLastRow = bottom - top === 1 ? cellsInFirstRow : map.cellsInRect({
                        left: isRowSelection ? left : right - 1,
                        top: isRowSelection ? bottom - 1 : top,
                        right: right,
                        bottom: bottom
                    });
                    const head = table.start + cellsInFirstRow[0];
                    const anchor = table.start + cellsInLastRow[cellsInLastRow.length - 1];
                    const $head = tr.doc.resolve(head);
                    const $anchor = tr.doc.resolve(anchor);
                    return (0, $dXesv.cloneTr)(tr.setSelection(new (0, $ev7OZ.CellSelection)($anchor, $head)));
                }
            }
            return tr;
        };
const $969c897d6838ada3$export$c2e8772deb1607ea = $969c897d6838ada3$var$select('column');
const $969c897d6838ada3$export$e247ed8cec4832f4 = $969c897d6838ada3$var$select('row');
const $969c897d6838ada3$var$selectRowsOrColumns = (type)=>(indexes)=>(tr)=>{
            const table = (0, $5n2u9.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $dpooP.TableMap).get(table.node);
            if (!indexes || indexes.length <= 0 || type === 'rows' && Math.max(...indexes) > map.height || type === 'columns' && Math.max(...indexes) > map.width || Math.min(...indexes) < 0) return tr;
            const startCellRect = map.cellsInRect({
                left: type === 'rows' ? 0 : Math.min(...indexes),
                top: type === 'rows' ? Math.min(...indexes) : 0,
                right: type === 'rows' ? map.width : Math.min(...indexes) + 1,
                bottom: type === 'rows' ? Math.min(...indexes) + 1 : 1
            });
            const endCellRect = map.cellsInRect({
                left: type === 'rows' ? map.width - 1 : Math.max(...indexes),
                top: type === 'rows' ? Math.max(...indexes) : map.height - 1,
                right: type === 'rows' ? map.width : Math.max(...indexes) + 1,
                bottom: type === 'rows' ? Math.max(...indexes) + 1 : map.height
            });
            const head = table.start + startCellRect[0];
            const anchor = table.start + endCellRect[endCellRect.length - 1];
            const $head = tr.doc.resolve(head);
            const $anchor = tr.doc.resolve(anchor);
            return (0, $dXesv.cloneTr)(tr.setSelection(new (0, $ev7OZ.CellSelection)($anchor, $head)));
        };
const $969c897d6838ada3$export$b5ba3b60192c7a8d = $969c897d6838ada3$var$selectRowsOrColumns('rows');
const $969c897d6838ada3$export$41a42e79fbe56d35 = $969c897d6838ada3$var$selectRowsOrColumns('columns');

});

parcelRegister("2gwLg", function(module, exports) {
$parcel$export(module.exports, "setCellAttrs", () => $1a2e60ef99cf9f24$export$aa21d3b96c1c378c);

var $dXesv = parcelRequire("dXesv");
const $1a2e60ef99cf9f24$export$aa21d3b96c1c378c = (cell, attrs)=>(tr)=>{
        if (cell) {
            tr.setNodeMarkup(cell.pos, undefined, Object.assign({}, cell.node.attrs, attrs));
            return (0, $dXesv.cloneTr)(tr);
        }
        return tr;
    };

});

parcelRegister("f3xW3", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $730dbcba864d3098$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "getDecorations", () => $730dbcba864d3098$export$968abecb43309c32);
$parcel$export(module.exports, "createPlugin", () => $730dbcba864d3098$export$ae829ec7b2625219);

var $aybRd = parcelRequire("aybRd");

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $ev7OZ = parcelRequire("ev7OZ");

var $5n2u9 = parcelRequire("5n2u9");

var $4dyXt = parcelRequire("4dyXt");

var $8aCba = parcelRequire("8aCba");

var $2yOeu = parcelRequire("2yOeu");
const $730dbcba864d3098$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableDecorationsPlugin');
const $730dbcba864d3098$export$968abecb43309c32 = (state)=>$730dbcba864d3098$export$18d4026d1ea86bb1.getState(state);
const $730dbcba864d3098$export$a9962e3214ca2ff7 = (tr, decorationSet, oldState, newState)=>{
    var _tableWidthPluginKey$, _tableWidthPluginKey$2;
    const isResizing = (_tableWidthPluginKey$ = (0, $8aCba.pluginKey).getState(newState)) === null || _tableWidthPluginKey$ === void 0 ? void 0 : _tableWidthPluginKey$.resizing;
    const wasResizing = (_tableWidthPluginKey$2 = (0, $8aCba.pluginKey).getState(oldState)) === null || _tableWidthPluginKey$2 === void 0 ? void 0 : _tableWidthPluginKey$2.resizing;
    const { isInDanger: isInDanger, isTableHovered: isTableHovered } = (0, $4dyXt.pluginKey).getState(newState) || {};
    const changedResizing = isResizing !== wasResizing;
    // Remove column controls when resizing and don't add column decoration controls when DnD enabled
    if (isResizing) return (0, $16ZMX.DecorationSet).empty;
    else if (tr.docChanged || tr.selection instanceof (0, $ev7OZ.CellSelection) || changedResizing) return (0, $2yOeu.buildColumnControlsDecorations)({
        decorationSet: decorationSet,
        tr: tr
    });
    else if (tr.selectionSet) {
        var _findTable, _findTable2;
        const isTransactionFromMouseClick = !tr.docChanged && tr.selectionSet && tr.getMeta('pointer');
        if (isTransactionFromMouseClick || oldState.selection instanceof (0, $ev7OZ.CellSelection)) return (0, $2yOeu.maybeUpdateColumnControlsSelectedDecoration)({
            decorationSet: decorationSet,
            tr: tr
        });
        // We're exiting a table with an existing decorations so we should clean it up
        if ((isInDanger || isTableHovered) && (!(0, $aybRd.insideTable)(newState) || ((_findTable = (0, $5n2u9.findTable)(newState.selection)) === null || _findTable === void 0 ? void 0 : _findTable.node) !== ((_findTable2 = (0, $5n2u9.findTable)(oldState.selection)) === null || _findTable2 === void 0 ? void 0 : _findTable2.node))) return (0, $2yOeu.buildColumnControlsDecorations)({
            decorationSet: decorationSet,
            tr: tr
        });
    }
    return decorationSet;
};
const $730dbcba864d3098$export$ae829ec7b2625219 = ()=>{
    return new (0, $1y7gE.SafePlugin)({
        state: {
            init: ()=>(0, $16ZMX.DecorationSet).empty,
            apply: (tr, decorationSet, oldState, newState)=>{
                let pluginState = decorationSet;
                // main table plugin --->
                const meta = tr.getMeta((0, $4dyXt.pluginKey));
                if (meta && meta.data && meta.data.decorationSet) pluginState = meta.data.decorationSet;
                if (tr.docChanged || tr.selectionSet || tr.getMeta((0, $8aCba.pluginKey))) {
                    pluginState = pluginState.map(tr.mapping, tr.doc);
                    return $730dbcba864d3098$export$a9962e3214ca2ff7(tr, pluginState, oldState, newState);
                }
                return pluginState;
            }
        },
        key: $730dbcba864d3098$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$730dbcba864d3098$export$968abecb43309c32(state)
        }
    });
};

});
parcelRegister("4dyXt", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $71bd437e94be166c$export$18d4026d1ea86bb1);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $801jp = parcelRequire("801jp");
const $71bd437e94be166c$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tablePlugin');

});

parcelRegister("8aCba", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $3221579dadb78f89$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $3221579dadb78f89$export$ae829ec7b2625219);
/**
 * A plugin for handle table custom widths
 * Has login to scan the document, add width value to table's width attribute when necessary
 * Also holds resizing state to hide / show table controls
 */ 
var $10F96 = parcelRequire("10F96");

var $1y7gE = parcelRequire("1y7gE");

var $bzCw0 = parcelRequire("bzCw0");

var $8E9x2 = parcelRequire("8E9x2");

var $801jp = parcelRequire("801jp");

var $014x6 = parcelRequire("014x6");

var $eyG1M = parcelRequire("eyG1M");

var $1YIoS = parcelRequire("1YIoS");

var $h3r8b = parcelRequire("h3r8b");
const $3221579dadb78f89$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableWidthPlugin');
const $3221579dadb78f89$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, fullWidthEnabled, maxWidthEnabled, isTableScalingEnabled, isTableAlignmentEnabled, isCommentEditor)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $3221579dadb78f89$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($3221579dadb78f89$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($3221579dadb78f89$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            // When document first load in Confluence, initially it is an empty document
            // and Collab service triggers a transaction to replace the empty document with the real document that should be rendered.
            // what we need to do is to add width attr to all tables in the real document
            // isReplaceDocumentOperation is checking if the transaction is the one that replace the empty document with the real document
            const isReplaceDocumentOperation = (0, $8E9x2.isReplaceDocOperation)(transactions, oldState);
            const referentialityTr = transactions.find((tr)=>tr.getMeta('referentialityTableInserted'));
            const shouldPatchTableWidth = fullWidthEnabled && isTableScalingEnabled;
            const shouldPatchTableAlignment = fullWidthEnabled && isTableAlignmentEnabled;
            if (!isReplaceDocumentOperation && (!shouldPatchTableWidth && !shouldPatchTableAlignment || !referentialityTr)) return null;
            const { table: table } = newState.schema.nodes;
            const tr = newState.tr;
            if (isReplaceDocumentOperation && !isCommentEditor) newState.doc.forEach((node, offset)=>{
                if ((0, $bzCw0.isTableInContentMode)({
                    tableNode: node,
                    isSupported: (0, $h3r8b.isContentModeSupported)({
                        allowColumnResizing: true,
                        allowTableResizing: true,
                        isFullPageEditor: true
                    }),
                    isTableNested: false
                })) return;
                if (node.type === table) {
                    const width = node.attrs.width;
                    const layout = node.attrs.layout;
                    if (!width && layout) {
                        let tableWidthCal;
                        if (maxWidthEnabled) tableWidthCal = (0, $014x6.akEditorMaxWidthLayoutWidth);
                        else if (fullWidthEnabled) tableWidthCal = (0, $014x6.akEditorFullWidthLayoutWidth);
                        else switch(layout){
                            case 'wide':
                                tableWidthCal = (0, $014x6.akEditorWideLayoutWidth);
                                break;
                            case 'full-width':
                                tableWidthCal = (0, $014x6.akEditorFullWidthLayoutWidth);
                                break;
                            // when in fix-width appearance, no need to assign value to table width attr
                            // as when table is created, width attr is null by default, table rendered using layout attr
                            default:
                                tableWidthCal = (0, $014x6.akEditorDefaultLayoutWidth);
                                break;
                        }
                        const { width: _width, ...rest } = node.attrs;
                        if (tableWidthCal) tr.step(new (0, $10F96.SetAttrsStep)(offset, {
                            width: tableWidthCal,
                            ...rest
                        }));
                    }
                }
            });
            if (referentialityTr) referentialityTr.steps.forEach((step)=>{
                step.getMap().forEach((_, __, newStart, newEnd)=>{
                    newState.doc.nodesBetween(newStart, newEnd, (node, pos)=>{
                        if (node.type === table) {
                            if (shouldPatchTableWidth && node.attrs.width !== (0, $eyG1M.TABLE_MAX_WIDTH)) tr.setNodeAttribute(pos, 'width', (0, $eyG1M.TABLE_MAX_WIDTH));
                            if (shouldPatchTableAlignment) tr.setNodeAttribute(pos, 'layout', (0, $1YIoS.ALIGN_START));
                        }
                    });
                });
            });
            return tr;
        }
    });
};

});

parcelRegister("2yOeu", function(module, exports) {
$parcel$export(module.exports, "maybeUpdateColumnControlsSelectedDecoration", () => $692685fc32d7f04a$export$cbb3730335eda2fb);
$parcel$export(module.exports, "buildColumnControlsDecorations", () => $692685fc32d7f04a$export$967c329e5e466f2);

var $ev7OZ = parcelRequire("ev7OZ");

var $YREXK = parcelRequire("YREXK");

var $ijKnh = parcelRequire("ijKnh");

var $2x46H = parcelRequire("2x46H");
const $692685fc32d7f04a$var$isColumnSelected = (tr)=>tr.selection instanceof (0, $ev7OZ.CellSelection) && tr.selection.isColSelection();
// @see: https://product-fabric.atlassian.net/browse/ED-3796
const $692685fc32d7f04a$var$removeControlsHoverDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $ijKnh.findControlsHoverDecoration)(decorationSet));
const $692685fc32d7f04a$var$maybeUpdateColumnSelectedDecoration = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$692685fc32d7f04a$var$isColumnSelected(tr)) return decorationSet;
    return (0, $ijKnh.updateDecorations)(tr.doc, decorationSet, (0, $ijKnh.createColumnSelectedDecoration)(tr), (0, $YREXK.TableDecorations).COLUMN_SELECTED);
};
// @see: https://product-fabric.atlassian.net/browse/ED-7304
const $692685fc32d7f04a$var$removeColumnControlsSelectedDecoration = ({ decorationSet: decorationSet })=>decorationSet.remove((0, $ijKnh.findColumnControlSelectedDecoration)(decorationSet));
const $692685fc32d7f04a$var$hasColumnSelectedDecorations = (decorationSet)=>!!(0, $ijKnh.findColumnControlSelectedDecoration)(decorationSet).length;
const $692685fc32d7f04a$export$cbb3730335eda2fb = ({ decorationSet: decorationSet, tr: tr })=>{
    if (!$692685fc32d7f04a$var$hasColumnSelectedDecorations(decorationSet)) return decorationSet;
    return $692685fc32d7f04a$var$removeColumnControlsSelectedDecoration({
        decorationSet: decorationSet,
        tr: tr
    });
};
const $692685fc32d7f04a$export$967c329e5e466f2 = ({ decorationSet: decorationSet, tr: tr })=>{
    return (0, $2x46H.composeDecorations)([
        $692685fc32d7f04a$var$removeColumnControlsSelectedDecoration,
        $692685fc32d7f04a$var$removeControlsHoverDecoration,
        $692685fc32d7f04a$var$maybeUpdateColumnSelectedDecoration
    ])({
        decorationSet: decorationSet,
        tr: tr
    });
};

});
parcelRegister("ijKnh", function(module, exports) {
$parcel$export(module.exports, "findColumnControlSelectedDecoration", () => $77f851c2f3536d7d$export$8042b574593bd713);
$parcel$export(module.exports, "findControlsHoverDecoration", () => $77f851c2f3536d7d$export$6577d2f7fe84e45c);
$parcel$export(module.exports, "createCellHoverDecoration", () => $77f851c2f3536d7d$export$e1f7dd2d4ed6c778);
$parcel$export(module.exports, "createControlsHoverDecoration", () => $77f851c2f3536d7d$export$ecf836094c108a0);
$parcel$export(module.exports, "createColumnSelectedDecoration", () => $77f851c2f3536d7d$export$9bd7e7efc13bb839);
$parcel$export(module.exports, "updateDecorations", () => $77f851c2f3536d7d$export$77a59c867f92cbc7);
$parcel$export(module.exports, "createResizeHandleDecoration", () => $77f851c2f3536d7d$export$dab489ad285db87);
$parcel$export(module.exports, "createColumnLineResize", () => $77f851c2f3536d7d$export$c1faae7fcf0653ce);
$parcel$export(module.exports, "createColumnInsertLine", () => $77f851c2f3536d7d$export$6012cbb334f87faa);
$parcel$export(module.exports, "createRowInsertLine", () => $77f851c2f3536d7d$export$c47f6da2c2a0ebc8);

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $eUgRu = parcelRequire("eUgRu");

var $5IDy4 = parcelRequire("5IDy4");

var $16ZMX = parcelRequire("16ZMX");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $99qNq = parcelRequire("99qNq");

var $l5gi8 = parcelRequire("l5gi8");

var $YREXK = parcelRequire("YREXK");

var $8XYsN = parcelRequire("8XYsN");
const $77f851c2f3536d7d$var$filterDecorationByKey = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $77f851c2f3536d7d$export$8042b574593bd713 = (decorationSet)=>$77f851c2f3536d7d$var$filterDecorationByKey((0, $YREXK.TableDecorations).COLUMN_SELECTED, decorationSet);
const $77f851c2f3536d7d$export$6577d2f7fe84e45c = (decorationSet)=>$77f851c2f3536d7d$var$filterDecorationByKey((0, $YREXK.TableDecorations).ALL_CONTROLS_HOVER, decorationSet);
const $77f851c2f3536d7d$export$e1f7dd2d4ed6c778 = (cells)=>cells.map((cell)=>(0, $16ZMX.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: (0, $YREXK.TableCssClassName).HOVERED_CELL_WARNING
        }, {
            key: (0, $YREXK.TableDecorations).CELL_CONTROLS_HOVER
        }));
const $77f851c2f3536d7d$export$ecf836094c108a0 = (cells, type, tr, hoveredIndexes, danger, selected)=>{
    const table = (0, $5n2u9.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    const [min, max] = cells.reduce(([min, max], cell)=>{
        if (min === null || cell.pos < min) min = cell.pos;
        if (max === null || cell.pos > max) max = cell.pos;
        return [
            min,
            max
        ];
    }, [
        null,
        null
    ]);
    if (min === null || max === null) return [];
    let updatedCells = cells.map((x)=>x.pos);
    // ED-15246 fixed trello card table overflow issue
    // If columns / rows have been merged the hovered selection is different to the actual selection
    // So If the table cells are in danger we want to create a "rectangle" selection
    // to match the "clicked" selection
    if (danger && type !== 'table') {
        const { selection: selection } = tr;
        const table = (0, $5n2u9.findTable)(selection);
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        if (table && rect) updatedCells = map.cellsInRect(rect).map((x)=>x + table.start);
    }
    return updatedCells.map((pos)=>{
        const cell = tr.doc.nodeAt(pos);
        const classes = [
            (0, $YREXK.TableCssClassName).HOVERED_CELL
        ];
        if (danger) classes.push((0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER);
        if (selected) classes.push((0, $YREXK.TableCssClassName).SELECTED_CELL);
        if (type === 'column' || type === 'row') {
            classes.pop();
            classes.push((0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT);
        }
        let key;
        switch(type){
            case 'row':
                key = (0, $YREXK.TableDecorations).ROW_CONTROLS_HOVER;
                break;
            case 'column':
                key = (0, $YREXK.TableDecorations).COLUMN_CONTROLS_HOVER;
                break;
            default:
                key = (0, $YREXK.TableDecorations).TABLE_CONTROLS_HOVER;
                break;
        }
        return (0, $16ZMX.Decoration).node(pos, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + cell.nodeSize, {
            class: classes.join(' ')
        }, {
            key: key
        });
    });
};
const $77f851c2f3536d7d$export$9bd7e7efc13bb839 = (tr)=>{
    const { selection: selection, doc: doc } = tr;
    const table = (0, $5n2u9.findTable)(selection);
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!table || !rect) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    const cellPositions = map.cellsInRect(rect);
    return cellPositions.map((pos, index)=>{
        const cell = doc.nodeAt(pos + table.start);
        return (0, $16ZMX.Decoration).node(pos + table.start, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        pos + table.start + cell.nodeSize, {
            class: (0, $YREXK.TableCssClassName).COLUMN_SELECTED
        }, {
            key: `${(0, $YREXK.TableDecorations).COLUMN_SELECTED}_${index}`
        });
    });
};
const $77f851c2f3536d7d$export$fbcaf99fd4d31ced = (selection)=>{
    const cells = (0, $99qNq.getCellsInRow)(0)(selection) || [];
    let index = 0;
    return cells.map((cell)=>{
        const colspan = cell.node.attrs.colspan || 1;
        // It's important these values are scoped locally as the widget callback could be executed anytime in the future
        // and we want to avoid value leak
        const startIndex = index;
        const endIndex = startIndex + colspan;
        // The next cell start index will commence from the current cell end index.
        index = endIndex;
        return (0, $16ZMX.Decoration).widget(cell.pos + 1, ()=>{
            const element = document.createElement('div');
            element.classList.add((0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS);
            element.dataset.startIndex = `${startIndex}`;
            element.dataset.endIndex = `${endIndex}`;
            return element;
        }, {
            key: `${(0, $YREXK.TableDecorations).COLUMN_CONTROLS_DECORATIONS}_${endIndex}`,
            // this decoration should be the first one, even before gap cursor.
            side: -100
        });
    });
};
const $77f851c2f3536d7d$export$77a59c867f92cbc7 = (node, decorationSet, decorations, key)=>{
    const filteredDecorations = $77f851c2f3536d7d$var$filterDecorationByKey(key, decorationSet);
    const decorationSetFiltered = decorationSet.remove(filteredDecorations);
    return decorationSetFiltered.add(node, decorations);
};
const $77f851c2f3536d7d$var$makeArray = (n)=>Array.from(Array(n).keys());
const $77f851c2f3536d7d$export$dab489ad285db87 = (tr, rowIndexTarget, columnEndIndexTarget, includeTooltip = false, getIntl, nodeViewPortalProviderAPI)=>{
    const table = (0, $5n2u9.findTable)(tr.selection);
    if (!table || !table.node) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    if (!map.width) return [];
    const createResizerHandleDecoration = (cellColumnPositioning, columnIndex, rowIndex, cellPos, cellNode)=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationRenderKey = (0, $eUgRu.default)();
        const position = cellPos + cellNode.nodeSize - 1;
        return (0, $16ZMX.Decoration).widget(position, ()=>{
            const element = document.createElement('div');
            nodeViewPortalProviderAPI.render(()=>(0, $fc4bM.createElement)((0, $fcCIH.Provider), {
                    value: getIntl()
                }, (0, $fc4bM.createElement)((0, $8XYsN.ColumnResizeWidget), {
                    startIndex: cellColumnPositioning.left,
                    endIndex: cellColumnPositioning.right,
                    includeTooltip: includeTooltip
                })), element, decorationRenderKey);
            return element;
        }, {
            key: `${(0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_WIDGET}_${rowIndex}_${columnIndex}_${includeTooltip ? 'with' : 'no'}-tooltip`,
            destroy: (_node)=>{
                nodeViewPortalProviderAPI.remove(decorationRenderKey);
            }
        });
    };
    const resizeHandleCellDecorations = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const seen = {};
        if (rowIndex !== rowIndexTarget) continue;
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const cellPosition = map.map[map.width * rowIndex + columnIndex];
            if (seen[cellPosition]) continue;
            seen[cellPosition] = true;
            const cellPos = table.start + cellPosition;
            const cell = tr.doc.nodeAt(cellPos);
            if (!cell) continue;
            const colspan = cell.attrs.colspan || 1;
            const startIndex = columnIndex;
            const endIndex = colspan + startIndex;
            if (endIndex !== columnEndIndexTarget.right) continue;
            const resizerHandleDec = createResizerHandleDecoration({
                left: startIndex,
                right: endIndex
            }, columnIndex, rowIndex, cellPos, cell);
            resizeHandleCellDecorations.push(resizerHandleDec);
        }
    }
    return resizeHandleCellDecorations;
};
const $77f851c2f3536d7d$export$c1faae7fcf0653ce = (selection, cellColumnPositioning)=>{
    const table = (0, $5n2u9.findTable)(selection);
    if (!table || cellColumnPositioning.right === null) return [];
    let columnIndex = cellColumnPositioning.right;
    const map = (0, $dpooP.TableMap).get(table.node);
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    const decorationClassName = isLastColumn ? (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN : (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE;
    const cellPositions = $77f851c2f3536d7d$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $16ZMX.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_LINE}_${cellColumnPositioning.right}_${index}`
        });
    }).filter((0, $5IDy4.nonNullable));
};
const $77f851c2f3536d7d$export$6012cbb334f87faa = (columnIndex, selection, hasMergedCells)=>{
    const table = (0, $5n2u9.findTable)(selection);
    if (!table) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    const isFirstColumn = columnIndex === 0;
    const isLastColumn = columnIndex === map.width;
    if (isLastColumn) columnIndex -= 1;
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isFirstColumn ? (0, $YREXK.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE : isLastColumn ? (0, $YREXK.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE : (0, $YREXK.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE;
    else decorationClassName = isFirstColumn ? (0, $YREXK.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE : isLastColumn ? (0, $YREXK.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE : (0, $YREXK.TableCssClassName).WITH_COLUMN_INSERT_LINE;
    const cellPositions = $77f851c2f3536d7d$var$makeArray(map.height).map((rowIndex)=>map.map[map.width * rowIndex + columnIndex]).filter((cellPosition, rowIndex)=>{
        if (isLastColumn) return true; // If is the last column no filter applied
        const nextPosition = map.map[map.width * rowIndex + columnIndex - 1];
        return cellPosition !== nextPosition; // Removed it if next position is merged
    });
    const cells = cellPositions.map((pos)=>({
            pos: pos + table.start,
            node: table.node.nodeAt(pos)
        }));
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $16ZMX.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $YREXK.TableDecorations).COLUMN_INSERT_LINE}_${index}`
        });
    }).filter((0, $5IDy4.nonNullable));
};
const $77f851c2f3536d7d$export$c47f6da2c2a0ebc8 = (rowIndex, selection, hasMergedCells)=>{
    const table = (0, $5n2u9.findTable)(selection);
    if (!table) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    const isLastRow = rowIndex === map.height;
    if (isLastRow) rowIndex -= 1;
    const cells = (0, $99qNq.getCellsInRow)(rowIndex)(selection);
    if (!cells) return [];
    let decorationClassName;
    if (hasMergedCells) decorationClassName = isLastRow ? (0, $YREXK.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE : (0, $YREXK.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE;
    else decorationClassName = isLastRow ? (0, $YREXK.TableCssClassName).WITH_LAST_ROW_INSERT_LINE : (0, $YREXK.TableCssClassName).WITH_ROW_INSERT_LINE;
    return cells.map((cell, index)=>{
        if (!cell || !cell.node) return;
        return (0, $16ZMX.Decoration).node(cell.pos, cell.pos + cell.node.nodeSize, {
            class: decorationClassName
        }, {
            key: `${(0, $YREXK.TableDecorations).ROW_INSERT_LINE}_${index}`
        });
    }).filter((0, $5IDy4.nonNullable));
};

});
parcelRegister("8XYsN", function(module, exports) {
$parcel$export(module.exports, "ColumnResizeWidget", () => $ae4e4f2b279d1908$export$e84bed3a1e3da852);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $jctmk = parcelRequire("jctmk");

var $gpjDl = parcelRequire("gpjDl");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $bcTS3 = parcelRequire("bcTS3");

var $YREXK = parcelRequire("YREXK");
const $ae4e4f2b279d1908$export$e84bed3a1e3da852 = ({ startIndex: startIndex, endIndex: endIndex, includeTooltip: includeTooltip })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    if (!includeTooltip) return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION,
        "data-start-index": startIndex,
        "data-end-index": endIndex
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, $jctmk.jsx)((0, $eUtBU.ToolTipContent), {
            description: formatMessage((0, $lqHJB.messages).adjustColumns),
            keymap: (0, $eUtBU.startColumnResizing)
        }),
        hideTooltipOnClick: true,
        hideTooltipOnMouseDown: true,
        position: "mouse",
        mousePosition: "auto-start"
    }, (tooltipProps)=>/*#__PURE__*/ (0, $jctmk.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION,
            "data-start-index": startIndex,
            "data-end-index": endIndex,
            ...tooltipProps
        }));
};

});


parcelRegister("2x46H", function(module, exports) {
$parcel$export(module.exports, "composeDecorations", () => $e8a189a153658bfc$export$c3909dd6d9555879);
const $e8a189a153658bfc$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr
            }), decorationSet);

});



parcelRegister("7uENW", function(module, exports) {
$parcel$export(module.exports, "buildColumnResizingDecorations", () => $1f812250b265f12b$export$aa1fe977609f5606);
$parcel$export(module.exports, "clearColumnResizingDecorations", () => $1f812250b265f12b$export$a590d16867e1babd);

var $YREXK = parcelRequire("YREXK");

var $ijKnh = parcelRequire("ijKnh");

var $2x46H = parcelRequire("2x46H");
const $1f812250b265f12b$var$updateColumnResizeHandle = (columnResizesDecorations)=>({ decorationSet: decorationSet, tr: tr })=>(0, $ijKnh.updateDecorations)(tr.doc, decorationSet, columnResizesDecorations, (0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_WIDGET);
const $1f812250b265f12b$export$aa1fe977609f5606 = (rowEndIndex, columnEndIndex, includeTooltip, getIntl, nodeViewPortalProviderAPI)=>({ tr: tr, decorationSet: decorationSet })=>{
        const columnResizesDecorations = columnEndIndex < 0 ? [] : (0, $ijKnh.createResizeHandleDecoration)(tr, rowEndIndex, {
            right: columnEndIndex
        }, includeTooltip, getIntl, nodeViewPortalProviderAPI);
        return (0, $2x46H.composeDecorations)([
            $1f812250b265f12b$var$updateColumnResizeHandle(columnResizesDecorations)
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };
const $1f812250b265f12b$export$a590d16867e1babd = ()=>({ tr: tr, decorationSet: decorationSet })=>{
        return (0, $2x46H.composeDecorations)([
            $1f812250b265f12b$var$updateColumnResizeHandle([])
        ])({
            decorationSet: decorationSet,
            tr: tr
        });
    };

});

parcelRegister("4GJqd", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $184c1befd03db57e$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $184c1befd03db57e$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $184c1befd03db57e$export$f05434c51e3762e);

var $92jIL = parcelRequire("92jIL");

var $h21tV = parcelRequire("h21tV");

var $4dyXt = parcelRequire("4dyXt");

var $jyK2r = parcelRequire("jyK2r");
const $184c1befd03db57e$var$dest = (0, $92jIL.pluginFactory)((0, $4dyXt.pluginKey), (0, $jyK2r.default), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let updatedTargetCell = {};
            if (pluginState.targetCellPosition) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.targetCellPosition);
                updatedTargetCell = {
                    targetCellPosition: deleted ? undefined : pos
                };
            }
            let updatedTablePos = {};
            if (pluginState.tablePos) {
                const { pos: pos, deleted: deleted } = tr.mapping.mapResult(pluginState.tablePos, -1);
                updatedTablePos = {
                    tablePos: deleted ? undefined : pos
                };
            }
            return {
                ...pluginState,
                ...updatedTargetCell,
                ...updatedTablePos
            };
        }
        return pluginState;
    },
    onDocChanged: (0, $h21tV.handleDocOrSelectionChanged),
    onSelectionChanged: (0, $h21tV.handleDocOrSelectionChanged)
});
const $184c1befd03db57e$export$656c7661095efe2e = $184c1befd03db57e$var$dest.createPluginState;
const $184c1befd03db57e$export$8d4021544bdece00 = $184c1befd03db57e$var$dest.createCommand;
const $184c1befd03db57e$export$f05434c51e3762e = $184c1befd03db57e$var$dest.getPluginState;

});
parcelRegister("h21tV", function(module, exports) {
$parcel$export(module.exports, "handleDocOrSelectionChanged", () => $c18ba34d75d9f411$export$a9962e3214ca2ff7);
// #region Imports

var $25zoa = parcelRequire("25zoa");

var $8n8t3 = parcelRequire("8n8t3");

var $a4TQr = parcelRequire("a4TQr");

var $ev7OZ = parcelRequire("ev7OZ");

var $5n2u9 = parcelRequire("5n2u9");

var $aEmSo = parcelRequire("aEmSo");

var $b7w2R = parcelRequire("b7w2R");

var $gQDgk = parcelRequire("gQDgk");

var $7XZJw = parcelRequire("7XZJw");

var $4WYVI = parcelRequire("4WYVI");
const $c18ba34d75d9f411$var$nextTableSorting = (tr, table)=>{
    const tableSortStep = tr.steps.find((step)=>step instanceof (0, $25zoa.TableSortStep));
    return tableSortStep && table && table.pos === tableSortStep.pos ? tableSortStep.next : undefined;
};
const $c18ba34d75d9f411$var$nextResizeHandleColumnIndex = (tr, resizeHandleColumnIndex)=>{
    if (tr.getMeta((0, $gQDgk.pluginKey))) return undefined;
    return resizeHandleColumnIndex;
};
const $c18ba34d75d9f411$var$shouldCloseLegacyContextualMenu = ({ pluginState: pluginState, targetCellPositionChanged: targetCellPositionChanged, tr: tr })=>Boolean(pluginState.isContextualMenuOpen && (targetCellPositionChanged || tr.selectionSet && !(tr.selection instanceof (0, $ev7OZ.CellSelection))));
const $c18ba34d75d9f411$var$updateTargetCellPosition = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            var _pluginState$activeTa, _pluginState$activeTa2;
            let targetCellPosition;
            if (tableNode) {
                const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
                const cell = (0, $a4TQr.findParentNodeOfType)([
                    tableCell,
                    tableHeader
                ])(tr.selection);
                targetCellPosition = cell ? cell.pos : undefined;
            }
            const hasTargetCellChanged = pluginState.targetCellPosition !== targetCellPosition;
            const hasActiveTableMenu = pluginState.activeTableMenu != null && pluginState.activeTableMenu.type !== 'none';
            const isActiveDragMenu = ((_pluginState$activeTa = pluginState.activeTableMenu) === null || _pluginState$activeTa === void 0 ? void 0 : _pluginState$activeTa.type) === 'row' || ((_pluginState$activeTa2 = pluginState.activeTableMenu) === null || _pluginState$activeTa2 === void 0 ? void 0 : _pluginState$activeTa2.type) === 'column';
            const shouldPreserveActiveDragMenu = isActiveDragMenu && tr.selection instanceof (0, $ev7OZ.CellSelection);
            const shouldCloseMenu = hasActiveTableMenu && tr.selectionSet && (!tableNode || !(tr.selection instanceof (0, $ev7OZ.CellSelection)) || hasTargetCellChanged && !shouldPreserveActiveDragMenu);
            if (!hasTargetCellChanged && !shouldCloseMenu) return pluginState;
            // Cell menus are anchored to a specific cell and close when that target changes. Row and
            // column menus are anchored to the selected-range drag handle, so keep them open while a
            // CellSelection expands and let the handle re-render at the updated range.
            return {
                ...pluginState,
                targetCellPosition: targetCellPosition,
                activeTableMenu: shouldCloseMenu ? {
                    type: 'none'
                } : pluginState.activeTableMenu
            };
        }
        if (!tableNode) return {
            ...pluginState,
            targetCellPosition: undefined
        };
        const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
        const cell = (0, $a4TQr.findParentNodeOfType)([
            tableCell,
            tableHeader
        ])(tr.selection);
        const targetCellPosition = cell ? cell.pos : undefined;
        const targetCellPositionChanged = pluginState.targetCellPosition !== targetCellPosition;
        const closeContextualMenu = $c18ba34d75d9f411$var$shouldCloseLegacyContextualMenu({
            pluginState: pluginState,
            targetCellPositionChanged: targetCellPositionChanged,
            tr: tr
        });
        if (!targetCellPositionChanged && !closeContextualMenu) return pluginState;
        // Close the legacy contextual menu when moving cells because the cell background
        // color submenu can otherwise remain open against the previous cell selection.
        return {
            ...pluginState,
            ...closeContextualMenu ? {
                isContextualMenuOpen: false
            } : {},
            targetCellPosition: targetCellPosition
        };
    };
const $c18ba34d75d9f411$var$updateTableNodePluginState = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        if (!tableNode || (0, $8n8t3.isTextInput)(tr)) return pluginState;
        return {
            ...pluginState,
            ...(0, $b7w2R.defaultTableSelection),
            tableNode: tableNode,
            ordering: $c18ba34d75d9f411$var$nextTableSorting(tr, table),
            resizeHandleColumnIndex: $c18ba34d75d9f411$var$nextResizeHandleColumnIndex(tr, pluginState.resizeHandleColumnIndex),
            isNumberColumnEnabled: (0, $4WYVI.checkIfNumberColumnEnabled)(tr.selection),
            isHeaderColumnEnabled: (0, $4WYVI.checkIfHeaderColumnEnabled)(tr.selection),
            isHeaderRowEnabled: (0, $4WYVI.checkIfHeaderRowEnabled)(tr.selection)
        };
    };
const $c18ba34d75d9f411$var$updateCollapseHandler = ({ tr: tr, table: table })=>(pluginState)=>{
        const tableNode = table && table.node;
        const schema = tr.doc.type.schema;
        const allowCollapse = pluginState.pluginConfig.allowCollapse;
        const isExpandInSchema = schema.nodes.expand !== undefined;
        const isCollapseEnabled = allowCollapse && isExpandInSchema;
        /**
   * If we don't have focus, or collapse isn't allowed, or a table node doesn't
   * exist, we don't need to waste extra checks below
   */ if (!pluginState.editorHasFocus || !isCollapseEnabled || !tableNode) return pluginState;
        const expandNodeType = schema.nodes.expand;
        const isTableCollapsed = expandNodeType && !!(0, $a4TQr.findParentNodeOfType)(expandNodeType)(tr.selection);
        const trCanBeCollapsed = (0, $7XZJw.isTableCollapsible)(tr).tableIsCollapsible;
        // We're focused on a table + we're not inside an expand
        const canCollapseTable = !!pluginState.tableNode && // is it already collapsed?
        !isTableCollapsed && !!trCanBeCollapsed;
        if (pluginState.isTableCollapsed !== isTableCollapsed || pluginState.canCollapseTable !== canCollapseTable) return {
            ...pluginState,
            isTableCollapsed: isTableCollapsed,
            canCollapseTable: canCollapseTable
        };
        return pluginState;
    };
const $c18ba34d75d9f411$var$buildPluginState = (builders)=>(props)=>(pluginState)=>{
            if (!props.table) {
                if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
                    const shouldClearTargetCellPosition = pluginState.targetCellPosition !== undefined;
                    const hasActiveTableMenu = pluginState.activeTableMenu != null && pluginState.activeTableMenu.type !== 'none';
                    if (!shouldClearTargetCellPosition && !hasActiveTableMenu) return pluginState;
                    return {
                        ...pluginState,
                        targetCellPosition: undefined,
                        activeTableMenu: hasActiveTableMenu ? {
                            type: 'none'
                        } : pluginState.activeTableMenu
                    };
                }
                return pluginState.targetCellPosition ? {
                    ...pluginState,
                    targetCellPosition: undefined
                } : pluginState;
            }
            return builders.reduce((_pluginState, transform)=>transform(props)(_pluginState), pluginState);
        };
const $c18ba34d75d9f411$export$a9962e3214ca2ff7 = (tr, pluginState)=>$c18ba34d75d9f411$var$buildPluginState([
        $c18ba34d75d9f411$var$updateTargetCellPosition,
        $c18ba34d75d9f411$var$updateTableNodePluginState,
        $c18ba34d75d9f411$var$updateCollapseHandler
    ])({
        tr: tr,
        table: (0, $5n2u9.findTable)(tr.selection)
    })(pluginState);

});
parcelRegister("b7w2R", function(module, exports) {
$parcel$export(module.exports, "defaultTableSelection", () => $d245b8b6d51d84bb$export$af473ce758096273);
$parcel$export(module.exports, "defaultHoveredCell", () => $d245b8b6d51d84bb$export$4c0699e9a8272521);
const $d245b8b6d51d84bb$export$af473ce758096273 = {
    hoveredColumns: [],
    hoveredRows: []
};
const $d245b8b6d51d84bb$export$4c0699e9a8272521 = {
    hoveredCell: {
        rowIndex: undefined,
        colIndex: undefined
    }
};

});

parcelRegister("gQDgk", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $bf94f195c5f5fc9a$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $bf94f195c5f5fc9a$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableFlexiColumnResizing');

});

parcelRegister("7XZJw", function(module, exports) {
$parcel$export(module.exports, "isTableCollapsible", () => $ebfbd63ece3c8b05$export$34840b5e3787a37c);
$parcel$export(module.exports, "collapseSelectedTable", () => $ebfbd63ece3c8b05$export$436c9f28d887a0c3);

var $7H6Cr = parcelRequire("7H6Cr");

var $k2WVn = parcelRequire("k2WVn");

var $5n2u9 = parcelRequire("5n2u9");
const $ebfbd63ece3c8b05$var$bail = ()=>({
        tableIsCollapsible: false
    });
const $ebfbd63ece3c8b05$export$34840b5e3787a37c = (tr)=>{
    const selection = tr.selection;
    const schema = tr.doc.type.schema;
    const nodePos = (0, $5n2u9.findTable)(selection);
    if (!nodePos) return $ebfbd63ece3c8b05$var$bail();
    const expand = schema.nodes.expand;
    const { node: node, pos: pos } = nodePos;
    const $pos = tr.doc.resolve(pos);
    const range = new (0, $7H6Cr.NodeRange)($pos, tr.doc.resolve(pos + node.nodeSize), $pos.depth);
    if (!range) return $ebfbd63ece3c8b05$var$bail();
    const canWrap = (0, $k2WVn.findWrapping)(range, expand);
    if (canWrap === null) return $ebfbd63ece3c8b05$var$bail();
    return {
        tableIsCollapsible: true,
        range: range,
        /**
     * Do we ever want to deal with the result of `findWrapping`? Probably not,
     * but we have it anyway.
     */ findWrappingRes: canWrap
    };
};
const $ebfbd63ece3c8b05$export$436c9f28d887a0c3 = (tr)=>{
    const canCollapse = $ebfbd63ece3c8b05$export$34840b5e3787a37c(tr);
    const expand = tr.doc.type.schema.nodes.expand;
    if (!canCollapse.range || !canCollapse.tableIsCollapsible) return undefined;
    /**
   * TODO: add attrs: { __expanded: false } when
   * - it is working with new collab (CEMS-1204)
   * - synchrony is no longer used
   *
   *   (via confluence-frontend, "this feature" referencing allowInteractiveExpand)
   *   `we can NEVER allow this feature to be enabled for the synchrony-powered editor
   */ tr.wrap(canCollapse.range, [
        {
            type: expand
        }
    ]).setMeta('scrollIntoView', true);
    return tr;
};

});

parcelRegister("4WYVI", function(module, exports) {
$parcel$export(module.exports, "isIsolating", () => $c7fa7d668e0938f5$export$b75dc620676872cc);
$parcel$export(module.exports, "containsHeaderColumn", () => $c7fa7d668e0938f5$export$a21ded6c12f16fdf);
$parcel$export(module.exports, "containsHeaderRow", () => $c7fa7d668e0938f5$export$86a810659e2d575);
$parcel$export(module.exports, "checkIfHeaderColumnEnabled", () => $c7fa7d668e0938f5$export$653b4f383b39a1d0);
$parcel$export(module.exports, "checkIfHeaderRowEnabled", () => $c7fa7d668e0938f5$export$b8efdc0183f04d59);
$parcel$export(module.exports, "checkIfNumberColumnEnabled", () => $c7fa7d668e0938f5$export$101f2696d8127fe0);
$parcel$export(module.exports, "getTableWidth", () => $c7fa7d668e0938f5$export$4910020ffe58186f);
$parcel$export(module.exports, "tablesHaveDifferentColumnWidths", () => $c7fa7d668e0938f5$export$8f2a10e9b102ac33);
$parcel$export(module.exports, "tablesHaveDifferentNoOfColumns", () => $c7fa7d668e0938f5$export$bc84d95d2dfa63bf);
$parcel$export(module.exports, "tablesHaveDifferentNoOfRows", () => $c7fa7d668e0938f5$export$8fe872ff9fc9b477);
$parcel$export(module.exports, "isTableNested", () => $c7fa7d668e0938f5$export$d4302a800316ebd6);
$parcel$export(module.exports, "isTableNestedInMoreThanOneNode", () => $c7fa7d668e0938f5$export$e31912a493829c23);
$parcel$export(module.exports, "isTableNestedUnderBodiedSyncBlock", () => $c7fa7d668e0938f5$export$ffa7c963c6f2f204);
$parcel$export(module.exports, "getTableRowIndex", () => $c7fa7d668e0938f5$export$731bc72b43be7f40);
$parcel$export(module.exports, "supportedHeaderRow", () => $c7fa7d668e0938f5$export$4af45fdaadf67b18);

var $c5vAC = parcelRequire("c5vAC");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $aEmSo = parcelRequire("aEmSo");
const $c7fa7d668e0938f5$export$b75dc620676872cc = (node)=>{
    return !!node.type.spec.isolating;
};
const $c7fa7d668e0938f5$export$a21ded6c12f16fdf = (table)=>{
    const map = (0, $dpooP.TableMap).get(table);
    // Get cell positions for first column.
    const cellPositions = map.cellsInRect({
        left: 0,
        top: 0,
        right: 1,
        bottom: map.height
    });
    for(let i = 0; i < cellPositions.length; i++)try {
        const cell = table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    } catch  {
        return false;
    }
    return true;
};
const $c7fa7d668e0938f5$export$86a810659e2d575 = (table)=>{
    const map = (0, $dpooP.TableMap).get(table);
    for(let i = 0; i < map.width; i++){
        const cell = table.nodeAt(map.map[i]);
        if (cell && cell.type !== table.type.schema.nodes.tableHeader) return false;
    }
    return true;
};
const $c7fa7d668e0938f5$export$653b4f383b39a1d0 = (selection)=>$c7fa7d668e0938f5$var$filterNearSelection(selection, (0, $5n2u9.findTable), $c7fa7d668e0938f5$export$a21ded6c12f16fdf, false);
const $c7fa7d668e0938f5$export$b8efdc0183f04d59 = (selection)=>$c7fa7d668e0938f5$var$filterNearSelection(selection, (0, $5n2u9.findTable), $c7fa7d668e0938f5$export$86a810659e2d575, false);
const $c7fa7d668e0938f5$export$101f2696d8127fe0 = (selection)=>$c7fa7d668e0938f5$var$filterNearSelection(selection, (0, $5n2u9.findTable), (table)=>!!table.attrs.isNumberColumnEnabled, false);
const $c7fa7d668e0938f5$export$4910020ffe58186f = (node)=>{
    return $c7fa7d668e0938f5$var$getTableWidths(node).reduce((acc, current)=>acc + current, 0);
};
const $c7fa7d668e0938f5$export$8f2a10e9b102ac33 = (currentTable, previousTable)=>{
    const currentTableWidths = $c7fa7d668e0938f5$var$getTableWidths(currentTable);
    const previousTableWidths = $c7fa7d668e0938f5$var$getTableWidths(previousTable);
    if (currentTableWidths.length !== previousTableWidths.length) return true;
    const sameWidths = currentTableWidths.every((value, index)=>{
        return value === previousTableWidths[index];
    });
    return sameWidths === false;
};
const $c7fa7d668e0938f5$export$bc84d95d2dfa63bf = (currentTable, previousTable)=>{
    const prevMap = (0, $dpooP.TableMap).get(previousTable);
    const currentMap = (0, $dpooP.TableMap).get(currentTable);
    return prevMap.width !== currentMap.width;
};
const $c7fa7d668e0938f5$export$8fe872ff9fc9b477 = (currentTable, previousTable)=>{
    const prevMap = (0, $dpooP.TableMap).get(previousTable);
    const currentMap = (0, $dpooP.TableMap).get(currentTable);
    return prevMap.height !== currentMap.height;
};
function $c7fa7d668e0938f5$var$filterNearSelection(selection, findNode, predicate, defaultValue) {
    const found = findNode(selection);
    if (!found) return defaultValue;
    return predicate(found.node, found.pos);
}
function $c7fa7d668e0938f5$var$getTableWidths(node) {
    if (!node.content.firstChild) return [];
    const tableWidths = [];
    node.content.firstChild.content.forEach((cell)=>{
        if (Array.isArray(cell.attrs.colwidth)) {
            const colspan = cell.attrs.colspan || 1;
            tableWidths.push(...cell.attrs.colwidth.slice(0, colspan));
        }
    });
    return tableWidths;
}
const $c7fa7d668e0938f5$export$d4302a800316ebd6 = (state, tablePos = 0)=>{
    const $tablePos = state.doc.resolve(tablePos);
    return $tablePos.depth > 0;
};
const $c7fa7d668e0938f5$export$e31912a493829c23 = (state, tablePos = 0)=>{
    return state.doc.resolve(tablePos).depth > 2;
};
const $c7fa7d668e0938f5$export$ffa7c963c6f2f204 = (state, tablePos)=>{
    const bodiedSyncBlock = state.schema.nodes.bodiedSyncBlock;
    if (!bodiedSyncBlock) return false;
    const $pos = state.doc.resolve(tablePos);
    for(let d = $pos.depth; d > 0; d--){
        if ($pos.node(d).type === bodiedSyncBlock) return true;
    }
    return false;
};
const $c7fa7d668e0938f5$var$anyChildCellMergedAcrossRow = (node)=>(0, $c5vAC.mapChildren)(node, (child)=>child.attrs.rowspan || 0).some((rowspan)=>rowspan > 1);
const $c7fa7d668e0938f5$var$anyChildCellMergedAcrossColumn = (node)=>(0, $c5vAC.mapChildren)(node, (child)=>child.attrs.colspan || 0).some((colspan)=>colspan > 1);
const $c7fa7d668e0938f5$export$731bc72b43be7f40 = (view, getPos)=>{
    try {
        const pos = getPos();
        return pos === undefined ? 0 : view.state.doc.resolve(pos).index();
    } catch  {
        return 0;
    }
};
const $c7fa7d668e0938f5$export$4af45fdaadf67b18 = (node, rowIndex = 0)=>{
    if (rowIndex !== 0) return false;
    const allHeaders = (0, $c5vAC.mapChildren)(node, (child)=>child.type.name === 'tableHeader').every(Boolean);
    if ((0, $aEmSo.expValEquals)('platform_editor_fix_sticky_header_malfunction', 'isEnabled', true)) {
        const someMergedAcrossRow = $c7fa7d668e0938f5$var$anyChildCellMergedAcrossRow(node);
        // Only apply the colspan check to non-first rows (rowIndex > 0) when the fix is enabled.
        const isFirstStickyRowExempt = (0, $aEmSo.expValEquals)('platform_editor_fix_sticky_header_row', 'isEnabled', true) && rowIndex === 0;
        const someMergedAcrossColumn = isFirstStickyRowExempt ? false : $c7fa7d668e0938f5$var$anyChildCellMergedAcrossColumn(node);
        return allHeaders && !someMergedAcrossRow && !someMergedAcrossColumn;
    }
    const someMerged = $c7fa7d668e0938f5$var$anyChildCellMergedAcrossRow(node);
    return allHeaders && !someMerged;
};

});


parcelRegister("jyK2r", function(module, exports) {
$parcel$export(module.exports, "default", () => $85b737ff5e615c68$export$2e2bcd8739ae039);

var $b7w2R = parcelRequire("b7w2R");
var $85b737ff5e615c68$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'TOGGLE_HEADER_COLUMN':
            return {
                ...pluginState,
                isHeaderColumnEnabled: !pluginState.isHeaderColumnEnabled
            };
        case 'TOGGLE_HEADER_ROW':
            return {
                ...pluginState,
                isHeaderRowEnabled: !pluginState.isHeaderRowEnabled
            };
        case 'CLEAR_HOVER_SELECTION':
            return {
                ...pluginState,
                ...action.data,
                ...(0, $b7w2R.defaultTableSelection)
            };
        case 'SELECT_COLUMN':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'SET_TARGET_CELL_POSITION':
            return {
                ...pluginState,
                ...action.data,
                isContextualMenuOpen: false
            };
        case 'TOGGLE_CONTEXTUAL_MENU':
            return {
                ...pluginState,
                isContextualMenuOpen: !pluginState.isContextualMenuOpen
            };
        case 'SET_ACTIVE_TABLE_MENU':
            return {
                ...pluginState,
                ...action.data
            };
        case 'SHOW_INSERT_ROW_BUTTON':
            if (action.data.insertRowButtonIndex === pluginState.insertRowButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertColumnButtonIndex: undefined // We need to assure that column is not shown
            };
        case 'SHOW_INSERT_COLUMN_BUTTON':
            if (action.data.insertColumnButtonIndex === pluginState.insertColumnButtonIndex) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                insertRowButtonIndex: undefined // We need to assure that row is not shown
            };
        case 'HIDE_INSERT_COLUMN_OR_ROW_BUTTON':
            if (pluginState.insertRowButtonIndex !== undefined || pluginState.insertColumnButtonIndex !== undefined) return {
                ...pluginState,
                insertRowButtonIndex: undefined,
                insertColumnButtonIndex: undefined
            };
            return pluginState;
        case 'HIDE_RESIZE_HANDLE_LINE':
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined
            };
        case 'START_KEYBOARD_COLUMN_RESIZE':
        case 'ADD_RESIZE_HANDLE_DECORATIONS':
            if (action.data.resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex && action.data.resizeHandleRowIndex === pluginState.resizeHandleRowIndex && action.data.resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip && action.data.isKeyboardResize === pluginState.isKeyboardResize) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                isResizeHandleWidgetAdded: true
            };
        case 'UPDATE_RESIZE_HANDLE_DECORATIONS':
            const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex, resizeHandleIncludeTooltip: resizeHandleIncludeTooltip } = action.data;
            if ((resizeHandleColumnIndex === pluginState.resizeHandleColumnIndex || !Number.isFinite(resizeHandleColumnIndex)) && (resizeHandleRowIndex === pluginState.resizeHandleRowIndex || !Number.isFinite(resizeHandleRowIndex)) && (resizeHandleIncludeTooltip === pluginState.resizeHandleIncludeTooltip || resizeHandleIncludeTooltip === undefined)) return pluginState;
            return {
                ...pluginState,
                resizeHandleColumnIndex: resizeHandleColumnIndex ?? pluginState.resizeHandleColumnIndex,
                resizeHandleRowIndex: resizeHandleRowIndex ?? pluginState.resizeHandleRowIndex,
                resizeHandleIncludeTooltip: resizeHandleIncludeTooltip ?? pluginState.resizeHandleIncludeTooltip
            };
        case 'STOP_KEYBOARD_COLUMN_RESIZE':
        case 'REMOVE_RESIZE_HANDLE_DECORATIONS':
            if (!pluginState.isResizeHandleWidgetAdded) return pluginState;
            return {
                ...pluginState,
                ...action.data,
                resizeHandleColumnIndex: undefined,
                resizeHandleRowIndex: undefined,
                isResizeHandleWidgetAdded: false,
                isKeyboardResize: undefined
            };
        case 'UPDATE_TABLE_WIDTH_TO_WIDEST':
        case 'SET_TABLE_REF':
        case 'HOVER_ROWS':
        case 'HOVER_COLUMNS':
        case 'HOVER_TABLE':
        case 'TABLE_HOVERED':
        case 'HOVER_MERGED_CELLS':
        case 'HOVER_CELL':
        case 'SHOW_RESIZE_HANDLE_LINE':
        case 'SET_EDITOR_FOCUS':
        case 'SET_CELL_MENU_OPEN':
            return {
                ...pluginState,
                ...action.data
            };
        default:
            return pluginState;
    }
};

});


parcelRegister("1uBzh", function(module, exports) {
$parcel$export(module.exports, "fixTables", () => $a7401fa672d4f999$export$d6d48849d9121a1);
$parcel$export(module.exports, "fixAutoSizedTable", () => $a7401fa672d4f999$export$8d491ebb055c561d);

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $7m0jn = parcelRequire("7m0jn");

var $7WOBF = parcelRequire("7WOBF");

var $7SttP = parcelRequire("7SttP");

var $lpTvl = parcelRequire("lpTvl");
const $a7401fa672d4f999$var$validateTableCellNodeAttrs = ({ colspan: colspan, rowspan: rowspan, tableLocalId: tableLocalId }, reportInvalidTableCellSpanAttrs)=>{
    if (colspan && colspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'colspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: colspan
    });
    if (rowspan && rowspan < 0) reportInvalidTableCellSpanAttrs({
        nodeType: 'tableCell',
        attribute: 'rowspan',
        reason: 'negative value',
        tableLocalId: tableLocalId,
        spanValue: rowspan
    });
    return;
};
const $a7401fa672d4f999$export$2867dc958552ea31 = (node, basePos, tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr = (0, $lpTvl.replaceCells)(tr, node, basePos, (cell)=>{
        const { colwidth: colwidth, colspan: colspan, rowspan: rowspan } = cell.attrs;
        if (reportInvalidTableCellSpanAttrs) $a7401fa672d4f999$var$validateTableCellNodeAttrs({
            colspan: colspan,
            rowspan: rowspan,
            tableLocalId: node.attrs.localId
        }, reportInvalidTableCellSpanAttrs);
        if (colwidth && colwidth.length > colspan) {
            hasProblems = true;
            return cell.type.createChecked({
                ...cell.attrs,
                colwidth: colwidth.slice(0, colspan)
            }, cell.content, cell.marks);
        }
        return cell;
    });
    if (hasProblems) return true;
    return false;
};
const $a7401fa672d4f999$export$d6d48849d9121a1 = (tr, reportInvalidTableCellSpanAttrs)=>{
    let hasProblems = false;
    tr.doc.descendants((node, pos)=>{
        if (node.type.name === 'table') // in the unlikely event of having to fix multiple tables at the same time
        hasProblems = $a7401fa672d4f999$export$2867dc958552ea31(node, tr.mapping.map(pos), tr, reportInvalidTableCellSpanAttrs);
    });
    if (hasProblems) return tr;
};
const $a7401fa672d4f999$export$8d491ebb055c561d = (view, tableNode, tableRef, tablePos, opts)=>{
    let { tr: tr } = view.state;
    const domAtPos = view.domAtPos.bind(view);
    const tableStart = tablePos + 1;
    const colWidths = $a7401fa672d4f999$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    const tableLayout = $a7401fa672d4f999$var$getLayoutBasedOnWidth(totalContentWidth);
    const maxLayoutSize = (0, $7SttP.getLayoutSize)(tableLayout, opts.containerWidth, {});
    // Content width will generally not meet the constraints of the layout
    // whether it be below or above, so we scale our columns widths
    // to meet these requirements
    let scale = 1;
    if (totalContentWidth !== maxLayoutSize) scale = maxLayoutSize / totalContentWidth;
    const scaledColumnWidths = colWidths.map((width)=>Math.floor(width * scale));
    tr = (0, $lpTvl.replaceCells)(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = scaledColumnWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    // clear autosizing on the table node
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        layout: tableLayout,
        __autoSize: false
    }).setMeta('addToHistory', false);
};
const $a7401fa672d4f999$var$getLayoutBasedOnWidth = (totalWidth)=>{
    if (totalWidth > (0, $014x6.akEditorWideLayoutWidth)) return 'full-width';
    else if (totalWidth > (0, $014x6.akEditorDefaultLayoutWidth) && totalWidth < (0, $014x6.akEditorWideLayoutWidth)) return 'wide';
    else return 'default';
};
function $a7401fa672d4f999$var$parseDOMColumnWidths(domAtPos, tableNode, tableStart, tableRef) {
    const row = tableRef.querySelector('tr');
    if (!row) return [];
    const cols = [];
    for(let col = 0; col < row.childElementCount; col++){
        const currentCol = row.children[col];
        const colspan = Number(currentCol.getAttribute('colspan') || 1);
        for(let span = 0; span < colspan; span++){
            const colIdx = col + span;
            const cells = (0, $7m0jn.getCellsRefsInColumn)(colIdx, tableNode, tableStart, domAtPos);
            const colWidth = (0, $7m0jn.calculateColumnWidth)(cells, (_, col)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                return (0, $7WOBF.contentWidth)(col, tableRef).width;
            });
            cols[colIdx] = Math.max(colWidth, (0, $jd8X7.tableCellMinWidth));
        }
    }
    return cols;
}

});
parcelRegister("7m0jn", function(module, exports) {
$parcel$export(module.exports, "getColumnStateFromDOM", () => $d0174a02a1f1de24$export$5c09bfb77c404ce);
$parcel$export(module.exports, "calculateColumnWidth", () => $d0174a02a1f1de24$export$8c54458430be6d1d);
$parcel$export(module.exports, "getFreeSpace", () => $d0174a02a1f1de24$export$529a1befd331574);
$parcel$export(module.exports, "getCellsRefsInColumn", () => $d0174a02a1f1de24$export$43e8ce817a8e5c42);

var $jd8X7 = parcelRequire("jd8X7");

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $7WOBF = parcelRequire("7WOBF");

var $gqP3S = parcelRequire("gqP3S");
const $d0174a02a1f1de24$export$5c09bfb77c404ce = (cells, index, minWidth)=>{
    const width = $d0174a02a1f1de24$export$8c54458430be6d1d(cells, $d0174a02a1f1de24$var$calculateColumnWidthCallback);
    const minColumnWidth = width < minWidth ? // for newly created column (where width < minWidth) we set minWidth = tableNewColumnMinWidth (140px atm)
    (0, $jd8X7.tableNewColumnMinWidth) : $d0174a02a1f1de24$export$8c54458430be6d1d(cells, $d0174a02a1f1de24$var$calculateColumnMinWidthCallback(minWidth));
    return {
        index: index,
        width: width < minWidth ? (0, $jd8X7.tableNewColumnMinWidth) : width,
        minWidth: minColumnWidth
    };
};
const $d0174a02a1f1de24$export$529a1befd331574 = (state)=>{
    return Math.max(state.width - state.minWidth, 0);
};
const $d0174a02a1f1de24$export$43e8ce817a8e5c42 = (columnIndex, table, tableStart, domAtPos)=>{
    const map = (0, $dpooP.TableMap).get(table);
    const cellsPositions = map.cellsInRect({
        left: columnIndex,
        right: columnIndex + 1,
        top: 0,
        bottom: map.height
    });
    const cells = [];
    cellsPositions.forEach((pos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const col = (0, $a4TQr.findDomRefAtPos)(pos + tableStart, domAtPos);
        if (col) cells.push(col);
    });
    return cells;
};
const $d0174a02a1f1de24$export$8c54458430be6d1d = (cells, calculateColumnWidthCb)=>{
    let maxColWidth = 0;
    let colSpanWidth = 0;
    cells.forEach((cellRef)=>{
        const css = getComputedStyle(cellRef);
        const colspan = Number(cellRef.getAttribute('colspan') || 1);
        if (colspan > 1) {
            colSpanWidth = calculateColumnWidthCb(css, cellRef, colspan);
            return;
        }
        if (css) {
            const colWidth = calculateColumnWidthCb(css, cellRef, colspan);
            maxColWidth = Math.max(colWidth, maxColWidth);
        }
    });
    return maxColWidth || colSpanWidth;
};
const $d0174a02a1f1de24$export$8a19622c99267fdf = (amount, css)=>amount + (0, $gqP3S.unitToNumber)(css.paddingLeft) + (0, $gqP3S.unitToNumber)(css.paddingRight);
function $d0174a02a1f1de24$var$calculateColumnWidthCallback(css) {
    return (0, $gqP3S.unitToNumber)(css.width);
}
function $d0174a02a1f1de24$var$calculateColumnMinWidthCallback(minColumnWidth) {
    return (css, cellRef, colSpan)=>{
        if (colSpan && colSpan > 1) return (0, $gqP3S.unitToNumber)(css.width);
        const { minWidth: minContentWidth } = (0, $7WOBF.contentWidth)(cellRef, cellRef);
        // Override the min width, if there is content that can't collapse
        // Past a certain width.
        return Math.max($d0174a02a1f1de24$export$8a19622c99267fdf(minContentWidth, css), minContentWidth, minColumnWidth);
    };
}

});
parcelRegister("7WOBF", function(module, exports) {
$parcel$export(module.exports, "contentWidth", () => $f9757a1a02d7d23b$export$698d25a635a3873a);

var $gqP3S = parcelRequire("gqP3S");
function $f9757a1a02d7d23b$export$698d25a635a3873a(elem, container, colWidths = [], canvas = document.createElement('canvas')) {
    return $f9757a1a02d7d23b$var$calcContentWidth(elem, container || elem, canvas, colWidths);
}
function $f9757a1a02d7d23b$var$calcContentWidth(elem, container, canvas, colWidths) {
    const flowWidths = [];
    let curWidth = 0;
    for(let i = 0; i < elem.childNodes.length; i++){
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const child = elem.childNodes[i];
        if (child.nodeType === Node.COMMENT_NODE) continue;
        if (child.nodeType === Node.TEXT_NODE) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const parent = child.parentNode;
            const parentStyle = getComputedStyle(parent);
            let contentLength = 0;
            if (parent.nodeName === 'CODE' || parent.nodeName === 'PRE') contentLength = $f9757a1a02d7d23b$var$handlePreText(canvas, parent, child.textContent, parentStyle.font);
            else contentLength = $f9757a1a02d7d23b$var$measureText(canvas, child.textContent, parentStyle.font);
            const left = parent.offsetLeft - container.offsetLeft;
            flowWidths.push(curWidth);
            curWidth += contentLength + left;
            // If the text isn't meant to wrap, we should set that as a hard limit.
            if (parentStyle.whiteSpace === 'nowrap') // + 3 is for date offset plus cursor
            // TODO: ED-26961 - There should be a programmatic way to get this.
            colWidths.push(parent.offsetWidth + 3);
        } else {
            // TODO: ED-26961 - doesn't quite work right with spacing
            const style = getComputedStyle(child);
            if (style.minWidth && style.minWidth.endsWith('px') && style.minWidth !== '0px') colWidths.push((0, $gqP3S.unitToNumber)(style.minWidth));
            const { width: width } = $f9757a1a02d7d23b$export$698d25a635a3873a(child, container, colWidths, canvas);
            if (style.display && style.display.indexOf('inline') > -1) // is inline element, add to curWidth
            curWidth += width;
            else {
                // block element, reset curWidth
                flowWidths.push(curWidth);
                curWidth = width;
            }
        }
    }
    flowWidths.push(curWidth);
    return {
        minWidth: colWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0),
        width: flowWidths.reduce((oldMax, width)=>Math.max(width, oldMax), 0)
    };
}
function $f9757a1a02d7d23b$var$measureText(canvas, text, font) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return 0;
    if (font) ctx.font = font;
    return Math.round(ctx.measureText(text || '').width);
}
function $f9757a1a02d7d23b$var$handlePreText(canvas, node, textContent, font) {
    let parent = node;
    if (node.nodeName === 'CODE') // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlaskit/editor/no-as-casting
    parent = node.parentNode;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const computedStyle = getComputedStyle(parent);
    if (textContent && computedStyle.whiteSpace === 'pre') // If white space is pre grab the longest line in the block.
    return textContent.split('\n').reduce((acc, current)=>Math.max($f9757a1a02d7d23b$var$measureText(canvas, current, font), acc), 0);
    return $f9757a1a02d7d23b$var$measureText(canvas, textContent, font);
}

});
parcelRegister("gqP3S", function(module, exports) {
$parcel$export(module.exports, "unitToNumber", () => $b9856b3d20f5d3dd$export$d486eb5767febcd9);
const $b9856b3d20f5d3dd$export$d486eb5767febcd9 = (unit)=>unit ? parseInt(unit, 10) : 0;

});



parcelRegister("lpTvl", function(module, exports) {
$parcel$export(module.exports, "replaceCells", () => $a89c96f993747ef4$export$ce28ec4a9ddaeb6d);
$parcel$export(module.exports, "updateCellsMarkup", () => $a89c96f993747ef4$export$97482f1a2b86c59e);
const $a89c96f993747ef4$export$ce28ec4a9ddaeb6d = (tr, table, tablePos, modifyCell)=>{
    const rows = [];
    let modifiedCells = 0;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        const cells = [];
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            // TODO: ED-26961 - The rowIndex and colIndex are not accurate in a merged cell scenario
            // e.g. table with 5 columns might have only one cell in a row, colIndex will be 1, where it should be 4
            const node = modifyCell(cell, rowIndex, colIndex);
            if (node.sameMarkup(cell) === false) modifiedCells++;
            cells.push(node);
        }
        if (cells.length) rows.push(row.type.createChecked(row.attrs, cells, row.marks));
    }
    // Check if the table has changed before replacing.
    // If no cells are modified our counter will be zero.
    if (rows.length && modifiedCells !== 0) {
        const newTable = table.type.createChecked(table.attrs, rows, table.marks);
        return tr.replaceWith(tablePos, tablePos + table.nodeSize, newTable);
    }
    return tr;
};
const $a89c96f993747ef4$export$97482f1a2b86c59e = (tr, table, tablePos, modifyCell)=>{
    let rowOffset = tablePos + 1;
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const row = table.child(rowIndex);
        let cellOffset = rowOffset + 1;
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            const modified = modifyCell(cell, rowIndex, colIndex);
            if (!modified.sameMarkup(cell)) tr.setNodeMarkup(cellOffset, modified.type, modified.attrs, modified.marks);
            cellOffset += cell.nodeSize;
        }
        rowOffset += row.nodeSize;
    }
    return tr;
};

});


parcelRegister("28qg3", function(module, exports) {
$parcel$export(module.exports, "updatePluginStateDecorations", () => $3471c830c1539a6b$export$884c674a282996e7);

var $f3xW3 = parcelRequire("f3xW3");

var $ijKnh = parcelRequire("ijKnh");
const $3471c830c1539a6b$export$884c674a282996e7 = (state, decorations, key)=>(0, $ijKnh.updateDecorations)(state.doc, (0, $f3xW3.getDecorations)(state), decorations, key);

});


parcelRegister("4Ckj5", function(module, exports) {
$parcel$export(module.exports, "updateRowOrColumnMoved", () => $8ca12e26402b1ec3$export$7edd58207362eb7c);
$parcel$export(module.exports, "resetRowOrColumnMovedTransform", () => $8ca12e26402b1ec3$export$39ebe85f9f5fbe7e);
$parcel$export(module.exports, "updateRowOrColumnMovedTransform", () => $8ca12e26402b1ec3$export$800a77929fdae774);
// eslint-disable-next-line import/order

var $jrCmZ = parcelRequire("jrCmZ");

var $iluY5 = parcelRequire("iluY5");

var $cbtJX = parcelRequire("cbtJX");

var $fFjFT = parcelRequire("fFjFT");
const $8ca12e26402b1ec3$export$7edd58207362eb7c = (nextState, nextAction)=>(0, $iluY5.createCommand)((state)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $iluY5.getPluginState)(state);
        const data = (0, $fFjFT.getMovedPayload)(nextState, nextAction, rowOrColumnMoved);
        return {
            type: (0, $jrCmZ.AnalyticPluginTypes).UpdateRowOrColumnMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $8ca12e26402b1ec3$export$39ebe85f9f5fbe7e = ()=>(tr)=>{
        const payload = {
            type: (0, $jrCmZ.AnalyticPluginTypes).RemoveRowOrColumnMovedAction
        };
        return tr.setMeta((0, $cbtJX.pluginKey), payload);
    };
const $8ca12e26402b1ec3$export$800a77929fdae774 = (nextState, nextAction)=>(state, tr)=>{
        const { rowOrColumnMoved: rowOrColumnMoved } = (0, $iluY5.getPluginState)(state);
        const data = (0, $fFjFT.getMovedPayload)(nextState, nextAction, rowOrColumnMoved);
        const payload = {
            type: (0, $jrCmZ.AnalyticPluginTypes).UpdateRowOrColumnMovedAction,
            data: data
        };
        return tr.setMeta((0, $cbtJX.pluginKey), payload);
    };

});
parcelRegister("jrCmZ", function(module, exports) {
$parcel$export(module.exports, "AnalyticPluginTypes", () => $17b5278e70e6e5aa$export$4e6e4e454d4dbb37);
var $17b5278e70e6e5aa$export$4e6e4e454d4dbb37 = /*#__PURE__*/ function(AnalyticPluginTypes) {
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateOverflowTriggerNameAction"] = 0] = "UpdateOverflowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAction"] = 1] = "UpdateRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveRowOrColumnMovedAction"] = 2] = "RemoveRowOrColumnMovedAction";
    AnalyticPluginTypes[AnalyticPluginTypes["RemoveOverFlowTriggerNameAction"] = 3] = "RemoveOverFlowTriggerNameAction";
    AnalyticPluginTypes[AnalyticPluginTypes["UpdateRowOrColumnMovedAndOverflowTrigger"] = 4] = "UpdateRowOrColumnMovedAndOverflowTrigger";
    return AnalyticPluginTypes;
}({});

});

parcelRegister("iluY5", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $cabc483a235e2212$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $cabc483a235e2212$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $cabc483a235e2212$export$f05434c51e3762e);

var $92jIL = parcelRequire("92jIL");

var $cbtJX = parcelRequire("cbtJX");

var $1OHz6 = parcelRequire("1OHz6");
const $cabc483a235e2212$var$dest = (0, $92jIL.pluginFactory)((0, $cbtJX.pluginKey), (0, $1OHz6.reducer));
const $cabc483a235e2212$export$656c7661095efe2e = $cabc483a235e2212$var$dest.createPluginState;
const $cabc483a235e2212$export$8d4021544bdece00 = $cabc483a235e2212$var$dest.createCommand;
const $cabc483a235e2212$export$f05434c51e3762e = $cabc483a235e2212$var$dest.getPluginState;

});
parcelRegister("cbtJX", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $0c823f685e8535a3$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $0c823f685e8535a3$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableAnalyticPlugin');

});

parcelRegister("1OHz6", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $5786c1847153d8a1$export$1650419e431d3ba3);

var $jrCmZ = parcelRequire("jrCmZ");

var $h60LU = parcelRequire("h60LU");
const $5786c1847153d8a1$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $jrCmZ.AnalyticPluginTypes).UpdateRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: {
                    ...state.rowOrColumnMoved,
                    ...action.data
                }
            };
        case (0, $jrCmZ.AnalyticPluginTypes).RemoveRowOrColumnMovedAction:
            return {
                ...state,
                rowOrColumnMoved: (0, $h60LU.defaultState).rowOrColumnMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("h60LU", function(module, exports) {
$parcel$export(module.exports, "defaultState", () => $6343bacc3dbb86ac$export$49d5fc8cba920a0);
const $6343bacc3dbb86ac$export$49d5fc8cba920a0 = {
    rowOrColumnMoved: {
        type: undefined,
        numberOfCells: undefined,
        currentActions: []
    }
};

});



parcelRegister("fFjFT", function(module, exports) {
$parcel$export(module.exports, "getMovedPayload", () => $25bc2c488e1b2705$export$245979e0371ee049);

var $h60LU = parcelRequire("h60LU");
const $25bc2c488e1b2705$var$getNextActionType = (nextState, nextAction, prevState)=>{
    if (nextAction === 'pasted') {
        if (prevState && prevState.currentActions.includes('copyOrCut') && prevState.currentActions.includes('addRowOrColumn') && prevState.numberOfCells === nextState.numberOfCells && prevState.type === nextState.type) return 'pasted';
        return 'none';
    }
    return nextAction;
};
const $25bc2c488e1b2705$export$245979e0371ee049 = (nextState, nextAction, prevState)=>{
    const nextActionType = $25bc2c488e1b2705$var$getNextActionType(nextState, nextAction, prevState);
    if (nextActionType === 'none') return (0, $h60LU.defaultState).rowOrColumnMoved;
    // a new workflow has started in the opposite axis (e.g. inserted a row, but copied a column) remove old state
    if (prevState.type !== nextState.type) return {
        currentActions: [
            nextActionType
        ],
        numberOfCells: nextState === null || nextState === void 0 ? void 0 : nextState.numberOfCells,
        type: nextState.type
    };
    return {
        currentActions: prevState.currentActions.includes(nextActionType) ? prevState.currentActions : [
            ...prevState.currentActions,
            nextActionType
        ],
        numberOfCells: (nextState === null || nextState === void 0 ? void 0 : nextState.numberOfCells) || prevState.numberOfCells,
        type: nextState === null || nextState === void 0 ? void 0 : nextState.type
    };
};

});



parcelRegister("jEslx", function(module, exports) {
$parcel$export(module.exports, "addColumnBefore", () => $f5219b6565f37b95$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addColumnAfter", () => $f5219b6565f37b95$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "insertColumn", () => $f5219b6565f37b95$export$35ae1d3df4b27cf0);
$parcel$export(module.exports, "insertRow", () => $f5219b6565f37b95$export$5a4e94bbc04b5f2);
$parcel$export(module.exports, "insertTableWithNestingSupport", () => $f5219b6565f37b95$export$b57b177fe1ab7f1f);
// #region Imports

var $egZer = parcelRequire("egZer");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $5DGsr = parcelRequire("5DGsr");
var $89pmn = parcelRequire("89pmn");
var $knIPH = parcelRequire("knIPH");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $8UCV4 = parcelRequire("8UCV4");

var $jR4eO = parcelRequire("jR4eO");

var $iwwun = parcelRequire("iwwun");

var $aEmSo = parcelRequire("aEmSo");

var $4Ckj5 = parcelRequire("4Ckj5");

var $lh6cf = parcelRequire("lh6cf");

var $04vvT = parcelRequire("04vvT");

var $l1ZbO = parcelRequire("l1ZbO");

var $eaKZu = parcelRequire("eaKZu");

var $4WYVI = parcelRequire("4WYVI");

var $eEepd = parcelRequire("eEepd");
function $f5219b6565f37b95$var$addColumnAtCustomStep(column) {
    return (tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (table) return tr.step((0, $egZer.AddColumnStep).create(tr.doc, table.pos, column));
        return tr;
    };
}
function $f5219b6565f37b95$export$93d48be6ee61745(api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor) {
    return (column, allowAddColumnCustomStep = false, view)=>{
        return (tr)=>{
            let updatedTr = tr;
            if (allowAddColumnCustomStep) updatedTr = $f5219b6565f37b95$var$addColumnAtCustomStep(column)(updatedTr);
            else updatedTr = (0, $8UCV4.addColumnAt)(column)(updatedTr);
            const table = (0, $5n2u9.findTable)(updatedTr.selection);
            if (table) // [ED-8288] Update colwidths manually to avoid multiple dispatch in TableComponent
            updatedTr = (0, $04vvT.rescaleColumns)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
            if (view) updatedTr = (0, $4Ckj5.updateRowOrColumnMovedTransform)({
                type: 'column'
            }, 'addRowOrColumn')(view.state, updatedTr);
            updatedTr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
                name: (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).ADDED_COLUMN
            });
            return updatedTr;
        };
    };
}
const $f5219b6565f37b95$export$717d5ccb817cdecc = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const table = (0, $5n2u9.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $iwwun.selectedRect)(state);
            dispatch($f5219b6565f37b95$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.left, (0, $eaKZu.getAllowAddColumnCustomStep)(state), view)(state.tr));
        }
        return true;
    };
const $f5219b6565f37b95$export$bf95f7b7d259c19f = (api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(state, dispatch, view)=>{
        const table = (0, $5n2u9.findTable)(state.selection);
        if (!table) return false;
        if (dispatch) {
            const rect = (0, $iwwun.selectedRect)(state);
            dispatch($f5219b6565f37b95$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(rect.right, (0, $eaKZu.getAllowAddColumnCustomStep)(state), view)(state.tr));
        }
        return true;
    };
const $f5219b6565f37b95$export$35ae1d3df4b27cf0 = (api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)=>(column)=>(state, dispatch, view)=>{
            const tr = $f5219b6565f37b95$export$93d48be6ee61745(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(column, (0, $eaKZu.getAllowAddColumnCustomStep)(state), view)(state.tr);
            const table = (0, $5n2u9.findTable)(tr.selection);
            if (!table) return false;
            // move the cursor to the newly created column
            const pos = (0, $dpooP.TableMap).get(table.node).positionAt(0, column, table.node);
            if (dispatch) dispatch(tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(table.start + pos))));
            return true;
        };
const $f5219b6565f37b95$export$5a4e94bbc04b5f2 = (row, moveCursorToTheNewRow)=>(state, dispatch)=>{
        // Don't clone the header row
        const headerRowEnabled = (0, $4WYVI.checkIfHeaderRowEnabled)(state.selection);
        const clonePreviousRow = headerRowEnabled && row > 1 || !headerRowEnabled && row > 0;
        // When the table have header row
        // we should not add row on the position zero
        if (row === 0 && headerRowEnabled) return false;
        const tr = clonePreviousRow ? (0, $eEepd.copyPreviousRow)(state.schema)(row)(state.tr) : (0, $jR4eO.addRowAt)(row, undefined)(state.tr);
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return false;
        if (dispatch) {
            const { selection: selection } = state;
            if (moveCursorToTheNewRow) {
                // move the cursor to the newly created row
                const pos = (0, $dpooP.TableMap).get(table.node).positionAt(row, 0, table.node);
                tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(table.start + pos)));
            } else tr.setSelection(selection.map(tr.doc, tr.mapping));
            (0, $4Ckj5.updateRowOrColumnMovedTransform)({
                type: 'row'
            }, 'addRowOrColumn')(state, tr);
            dispatch(tr);
        }
        return true;
    };
const $f5219b6565f37b95$export$33bbb3ec7652e187 = (isTableScalingEnabled, isTableAlignmentEnabled, isFullWidthModeEnabled, isMaxWidthModeEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor, isTableResizingEnabled)=>(state, dispatch)=>{
        const table = (0, $l1ZbO.createTableWithWidth)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled
        })(state.schema);
        if (dispatch) {
            const tr = (0, $a4TQr.safeInsert)(table)(state.tr).scrollIntoView();
            if (editorAnalyticsAPI) {
                var _state$selection$$fro;
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $3LeME.ACTION).INSERTED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT,
                        ...(0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                            parentNode: (_state$selection$$fro = state.selection.$from.node(-1)) === null || _state$selection$$fro === void 0 ? void 0 : _state$selection$$fro.type.name
                        } : {}
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(tr);
            }
            dispatch(tr);
        }
        return true;
    };
const $f5219b6565f37b95$export$505b7f2cb88dd074 = (isFullWidthModeEnabled, isMaxWidthModeEnabled, isTableScalingEnabled, isTableAlignmentEnabled, editorAnalyticsAPI, isCommentEditor, isChromelessEditor)=>(rowsCount, colsCount, inputMethod)=>{
        return ({ tr: tr })=>{
            const tableNode = (0, $l1ZbO.createTableWithWidth)({
                isTableScalingEnabled: isTableScalingEnabled,
                isFullWidthModeEnabled: isFullWidthModeEnabled,
                isMaxWidthModeEnabled: isMaxWidthModeEnabled,
                isTableAlignmentEnabled: isTableAlignmentEnabled,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                createTableProps: {
                    rowsCount: rowsCount,
                    colsCount: colsCount
                }
            })(tr.doc.type.schema);
            const newTr = (0, $a4TQr.safeInsert)(tableNode)(tr).scrollIntoView();
            if (inputMethod) {
                var _tr$selection$$from$n;
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $3LeME.ACTION).INSERTED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod,
                        totalRowCount: rowsCount,
                        totalColumnCount: colsCount,
                        ...(0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                            parentNode: (_tr$selection$$from$n = tr.selection.$from.node(-1)) === null || _tr$selection$$from$n === void 0 ? void 0 : _tr$selection$$from$n.type.name
                        } : {}
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(newTr);
            }
            return newTr;
        };
    };
const $f5219b6565f37b95$export$b57b177fe1ab7f1f = ({ isTableScalingEnabled: isTableScalingEnabled = false, isTableAlignmentEnabled: isTableAlignmentEnabled = false, isFullWidthModeEnabled: isFullWidthModeEnabled = false, isMaxWidthModeEnabled: isMaxWidthModeEnabled = false, isCommentEditor: isCommentEditor = false, isChromelessEditor: isChromelessEditor = false, isTableResizingEnabled: isTableResizingEnabled = false, createTableProps: createTableProps = {} }, api, analyticsPayload)=>({ tr: tr })=>{
        var _api$contentInsertion, _tr$selection$$from$n2;
        const { schema: schema } = tr.doc.type;
        // If the cursor is inside a table
        let insertAt;
        let isNestedTable = false;
        if ((0, $a4TQr.hasParentNodeOfType)(schema.nodes.table)(tr.selection) && (0, $knIPH.isNestedTablesSupported)(schema)) {
            // If trying to nest deeper than one level, we insert the table after the top table
            if ((0, $5DGsr.getParentOfTypeCount)(schema.nodes.table)(tr.selection.$from) > 1) {
                const positionAfterTopTable = (0, $89pmn.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(tr.selection.$from);
                if (!positionAfterTopTable) return tr;
                insertAt = (0, $801jp.TextSelection).create(tr.doc, positionAfterTopTable);
            } else // Table can be nested in parent table
            isNestedTable = true;
        }
        const node = (0, $l1ZbO.createTableWithWidth)({
            isTableScalingEnabled: isTableScalingEnabled,
            isTableAlignmentEnabled: isTableAlignmentEnabled,
            isFullWidthModeEnabled: isFullWidthModeEnabled,
            isMaxWidthModeEnabled: isMaxWidthModeEnabled,
            isCommentEditor: isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            isTableResizingEnabled: isTableResizingEnabled,
            isNestedTable: isNestedTable,
            createTableProps: createTableProps
        })(schema);
        api === null || api === void 0 || (_api$contentInsertion = api.contentInsertion) === null || _api$contentInsertion === void 0 || (_api$contentInsertion = _api$contentInsertion.commands) === null || _api$contentInsertion === void 0 || _api$contentInsertion.insert({
            node: node,
            options: {
                selectNodeInserted: false,
                analyticsPayload: analyticsPayload ? {
                    ...analyticsPayload,
                    attributes: {
                        ...analyticsPayload.attributes,
                        localId: node.attrs.localId,
                        ...(0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                            parentNode: (_tr$selection$$from$n2 = tr.selection.$from.node(-1)) === null || _tr$selection$$from$n2 === void 0 ? void 0 : _tr$selection$$from$n2.type.name
                        } : {}
                    }
                } : undefined,
                insertAt: insertAt
            }
        })({
            tr: tr
        });
        return tr;
    };

});
parcelRegister("8UCV4", function(module, exports) {
$parcel$export(module.exports, "addColumnAt", () => $a85cdfac6128622f$export$93d48be6ee61745);

var $dpooP = parcelRequire("dpooP");

var $8f0ye = parcelRequire("8f0ye");

var $dXesv = parcelRequire("dXesv");

var $5n2u9 = parcelRequire("5n2u9");
const $a85cdfac6128622f$export$93d48be6ee61745 = (columnIndex)=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (table) {
            const map = (0, $dpooP.TableMap).get(table.node);
            if (columnIndex >= 0 && columnIndex <= map.width) return (0, $dXesv.cloneTr)((0, $8f0ye.addColumn)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, columnIndex));
        }
        return tr;
    };

});
parcelRegister("8f0ye", function(module, exports) {
$parcel$export(module.exports, "addColumn", () => $48b66cf74d210a1c$export$9e26b0bcc810b84c);

var $j0lNH = parcelRequire("j0lNH");

var $cPlLC = parcelRequire("cPlLC");

var $eTtPM = parcelRequire("eTtPM");

var $9HFsx = parcelRequire("9HFsx");
function $48b66cf74d210a1c$export$9e26b0bcc810b84c(tr, { map: map, tableStart: tableStart, table: table }, col) {
    let refColumn = col > 0 ? -1 : 0;
    if ((0, $eTtPM.columnIsHeader)(map, table, col + refColumn)) refColumn = col === 0 || col === map.width ? null : 0;
    for(let row = 0; row < map.height; row++){
        const index = row * map.width + col;
        // If this position falls inside a col-spanning cell
        if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
            const pos = map.map[index];
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`addColumn: invalid cell for pos ${pos}`);
            const attributes = cell.attrs;
            (0, $cPlLC.assertColspan)(attributes);
            tr.setNodeMarkup(tr.mapping.map(tableStart + pos), undefined, (0, $j0lNH.addColSpan)(attributes, col - map.colCount(pos)));
            // Skip ahead if rowspan > 1
            row += attributes.rowspan - 1;
        } else {
            let type;
            let attrs = {};
            if (refColumn === null) type = (0, $9HFsx.tableNodeTypes)(table.type.schema).cell;
            else {
                const mappedPos = map.map[index + refColumn];
                const cell = table.nodeAt(mappedPos);
                if (!cell) throw new Error(`addColumn: invalid node at mapped pos ${mappedPos}`);
                type = cell.type;
                if (cell.attrs.background) attrs = {
                    background: cell.attrs.background
                };
            }
            const pos = map.positionAt(row, col, table);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs));
        }
    }
    return tr;
}

});


parcelRegister("jR4eO", function(module, exports) {
$parcel$export(module.exports, "addRowAt", () => $10ba6088c380a99f$export$643f25d380b0167d);

var $dpooP = parcelRequire("dpooP");

var $gPXN6 = parcelRequire("gPXN6");

var $gkJDo = parcelRequire("gkJDo");

var $dXesv = parcelRequire("dXesv");

var $5n2u9 = parcelRequire("5n2u9");
const $10ba6088c380a99f$export$643f25d380b0167d = (rowIndex, clonePreviousRow)=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (table) {
            const map = (0, $dpooP.TableMap).get(table.node);
            const cloneRowIndex = rowIndex - 1;
            if (clonePreviousRow && cloneRowIndex >= 0) return (0, $dXesv.cloneTr)((0, $gkJDo.cloneRowAt)(cloneRowIndex)(tr));
            if (rowIndex >= 0 && rowIndex <= map.height) return (0, $dXesv.cloneTr)((0, $gPXN6.addRow)(tr, {
                map: map,
                tableStart: table.start,
                table: table.node
            }, rowIndex));
        }
        return tr;
    };

});
parcelRegister("gPXN6", function(module, exports) {
$parcel$export(module.exports, "addRow", () => $ff5ccd3753938297$export$40ed00dbc18f8b2f);

var $9HFsx = parcelRequire("9HFsx");
function $ff5ccd3753938297$var$rowIsHeader(map, table, row) {
    const headerCell = (0, $9HFsx.tableNodeTypes)(table.type.schema).header_cell;
    for(let col = 0; col < map.width; col++){
        const cell = table.nodeAt(map.map[col + row * map.width]);
        if (cell && cell.type !== headerCell) return false;
    }
    return true;
}
function $ff5ccd3753938297$export$40ed00dbc18f8b2f(tr, { map: map, tableStart: tableStart, table: table }, row) {
    let rowPos = tableStart;
    for(let i = 0; i < row; i++)rowPos += table.child(i).nodeSize;
    const cells = [];
    let refRow = row > 0 ? -1 : 0;
    if ($ff5ccd3753938297$var$rowIsHeader(map, table, row + refRow)) refRow = row === 0 || row === map.height ? null : 0;
    for(let col = 0, index = map.width * row; col < map.width; col++, index++)// Covered by a rowspan cell
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
        const pos = map.map[index];
        const node = table.nodeAt(pos);
        if (!node) throw new Error(`addRow: node not found at pos ${pos}`);
        const { attrs: attrs } = node;
        tr.setNodeMarkup(tableStart + pos, undefined, {
            ...attrs,
            rowspan: attrs.rowspan + 1
        });
        col += attrs.colspan - 1;
    } else {
        let type;
        let attrs = {};
        if (refRow == null) type = (0, $9HFsx.tableNodeTypes)(table.type.schema).cell;
        else {
            const mappedPos = map.map[index + refRow * map.width];
            const cell = table.nodeAt(mappedPos);
            if (!cell) throw new Error(`addRow: invalid node at mapped pos ${mappedPos}`);
            type = cell.type;
            if (cell.attrs.background) attrs = {
                background: cell.attrs.background
            };
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        cells.push(type.createAndFill(attrs));
    }
    const rowType = (0, $9HFsx.tableNodeTypes)(table.type.schema).row;
    const rowCells = rowType.create(null, cells);
    tr.insert(rowPos, rowCells);
    return tr;
}

});

parcelRegister("gkJDo", function(module, exports) {
$parcel$export(module.exports, "cloneRowAt", () => $1499511af70976e2$export$46bec710cf196d80);

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $99qNq = parcelRequire("99qNq");

var $2gwLg = parcelRequire("2gwLg");

var $9HFsx = parcelRequire("9HFsx");
const $1499511af70976e2$var$filterCellsInRow = (rowIndex, predicate)=>(tr)=>{
        const foundCells = [];
        const cells = (0, $99qNq.getCellsInRow)(rowIndex)(tr.selection);
        if (cells) {
            for(let j = cells.length - 1; j >= 0; j--)if (predicate(cells[j], tr)) foundCells.push(cells[j]);
        }
        return foundCells;
    };
const $1499511af70976e2$export$46bec710cf196d80 = (rowIndex)=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (table) {
            const map = (0, $dpooP.TableMap).get(table.node);
            if (rowIndex >= 0 && rowIndex <= map.height) {
                const tableNode = table.node;
                const tableNodes = (0, $9HFsx.tableNodeTypes)(tableNode.type.schema);
                let rowPos = table.start;
                for(let i = 0; i < rowIndex + 1; i++)rowPos += tableNode.child(i).nodeSize;
                const cloneRow = tableNode.child(rowIndex);
                // Re-create the same nodes with same attrs, dropping the node content.
                const cells = [];
                let rowWidth = 0;
                cloneRow.forEach((cell)=>{
                    // If we're copying a row with rowspan somewhere, we dont want to copy that cell
                    // We'll increment its span below.
                    if (cell.attrs.rowspan === 1) {
                        rowWidth += cell.attrs.colspan;
                        const node = tableNodes[cell.type.spec.tableRole].createAndFill(cell.attrs, [], cell.marks);
                        if (node) cells.push(node);
                    }
                });
                // If a higher row spans past our clone row, bump the higher row to cover this new row too.
                if (rowWidth < map.width) {
                    const rowSpanCells = [];
                    for(let i = rowIndex; i >= 0; i--){
                        const foundCells = $1499511af70976e2$var$filterCellsInRow(i, (cell, _tr)=>{
                            const rowspan = cell.node.attrs.rowspan;
                            const spanRange = i + rowspan;
                            return rowspan > 1 && spanRange > rowIndex;
                        })(tr);
                        rowSpanCells.push(...foundCells);
                    }
                    if (rowSpanCells.length) rowSpanCells.forEach((cell)=>{
                        tr = (0, $2gwLg.setCellAttrs)(cell, {
                            rowspan: cell.node.attrs.rowspan + 1
                        })(tr);
                    });
                }
                return (0, $a4TQr.safeInsert)(tableNodes.row.create(cloneRow.attrs, cells), rowPos)(tr);
            }
        }
        return tr;
    };

});


parcelRegister("lh6cf", function(module, exports) {
$parcel$export(module.exports, "META_KEYS", () => $f34451f2b89a6253$export$210bf30466b5bcc8);
$parcel$export(module.exports, "createPlugin", () => $f34451f2b89a6253$export$ae829ec7b2625219);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");
const $f34451f2b89a6253$var$pluginKey = new (0, $801jp.PluginKey)('tableOverflowAnalyticsPlugin');
const $f34451f2b89a6253$export$210bf30466b5bcc8 = {
    OVERFLOW_TRIGGER: 'tableOverflowTrigger',
    OVERFLOW_STATE_CHANGED: 'tableOverflowStateChanged'
};
const $f34451f2b89a6253$export$ae829ec7b2625219 = (dispatch, dispatchAnalyticsEvent, tableResizingEnabled)=>new (0, $1y7gE.SafePlugin)({
        key: $f34451f2b89a6253$var$pluginKey,
        state: {
            init () {
                return {
                    lastTrigger: undefined
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($f34451f2b89a6253$export$210bf30466b5bcc8.OVERFLOW_TRIGGER);
                const newState = {
                    ...pluginState
                };
                if (meta) {
                    newState.lastTrigger = {
                        ...meta
                    };
                    dispatch($f34451f2b89a6253$var$pluginKey, newState);
                    return newState;
                }
                return pluginState;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            var _newPluginState$lastT;
            const newPluginState = $f34451f2b89a6253$var$pluginKey.getState(newState);
            let hasAnalyticsBeenDispatched = false;
            const lastTriggerName = (newPluginState === null || newPluginState === void 0 || (_newPluginState$lastT = newPluginState.lastTrigger) === null || _newPluginState$lastT === void 0 ? void 0 : _newPluginState$lastT.name) || // NOTE: We assume that we know and can correctly differentiate
            // between all triggers of table overflow state change.
            // The only trigger we can't identify is viewport width change.
            // However, since there is still a chance that there are other triggers we didn't think of,
            // all these unknown triggers and viwport width change trigger are captured as EXTERNAL.
            (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).EXTERNAL;
            transactions.forEach((tr)=>{
                const payload = tr.getMeta($f34451f2b89a6253$export$210bf30466b5bcc8.OVERFLOW_STATE_CHANGED);
                if (payload) {
                    dispatchAnalyticsEvent({
                        action: (0, $8d4kB.TABLE_ACTION).OVERFLOW_CHANGED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                        attributes: {
                            editorWidth: payload.editorWidth,
                            parentWidth: payload.parentWidth,
                            isOverflowing: payload.isOverflowing,
                            wasOverflowing: payload.wasOverflowing,
                            width: payload.width,
                            tableResizingEnabled: tableResizingEnabled,
                            trigger: lastTriggerName
                        }
                    });
                    hasAnalyticsBeenDispatched = true;
                }
            });
            if (hasAnalyticsBeenDispatched) {
                const tr = newState.tr;
                return tr.setMeta($f34451f2b89a6253$export$210bf30466b5bcc8.OVERFLOW_TRIGGER, {});
            }
            return undefined;
        }
    });

});

parcelRegister("04vvT", function(module, exports) {
$parcel$export(module.exports, "updateColumnWidths", () => $2c196303ff0dada3$export$6688b13ec132acdf);
$parcel$export(module.exports, "rescaleColumns", () => $2c196303ff0dada3$export$81edad89dedd3529);

var $jd8X7 = parcelRequire("jd8X7");

var $k2WVn = parcelRequire("k2WVn");

var $dpooP = parcelRequire("dpooP");

var $7Xzpg = parcelRequire("7Xzpg");

var $7SttP = parcelRequire("7SttP");

var $26jxM = parcelRequire("26jxM");

var $9xQxI = parcelRequire("9xQxI");
const $2c196303ff0dada3$export$6688b13ec132acdf = (resizeState, table, start, api)=>(tr)=>{
        const map = (0, $dpooP.TableMap).get(table);
        const updatedCellsAttrs = {};
        const steps = [];
        // calculating new attributes for each cell
        for(let columnIndex = 0; columnIndex < map.width; columnIndex++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            let { width: width } = resizeState.cols[columnIndex];
            if (resizeState.isScaled) // Ensure that the width is an integer if the table has been scaled
            width = Math.floor(width);
            const mapIndex = rowIndex * map.width + columnIndex;
            const cellPos = map.map[mapIndex];
            const attrs = updatedCellsAttrs[cellPos] || {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                ...table.nodeAt(cellPos).attrs
            };
            const colspan = attrs.colspan || 1;
            if (attrs.colwidth && attrs.colwidth.length > colspan) attrs.colwidth = attrs.colwidth.slice(0, colspan);
            // Rowspanning cell that has already been handled
            if (rowIndex && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
            const colspanIndex = colspan === 1 ? 0 : columnIndex - map.colCount(cellPos);
            if (attrs.colwidth && attrs.colwidth[colspanIndex] === width) continue;
            let colwidths = attrs.colwidth ? attrs.colwidth.slice() : Array.from({
                length: colspan
            }, (_)=>0);
            colwidths[colspanIndex] = width;
            if (colwidths.length > colspan) colwidths = colwidths.slice(0, colspan);
            updatedCellsAttrs[cellPos] = {
                ...attrs,
                colwidth: colwidths.includes(0) ? undefined : colwidths
            };
        }
        // updating all cells with new attributes
        const seen = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++)for(let columnIndex = 0; columnIndex < map.width; columnIndex++){
            const mapIndex = rowIndex * map.width + columnIndex;
            const pos = map.map[mapIndex];
            const cell = table.nodeAt(pos);
            if (!seen[pos] && cell) {
                if (updatedCellsAttrs[pos]) steps.push(new (0, $k2WVn.AttrStep)(pos + start, 'colwidth', updatedCellsAttrs[pos].colwidth === undefined ? null : updatedCellsAttrs[pos].colwidth));
                seen[pos] = true;
            }
        }
        if (api !== null && api !== void 0 && api.batchAttributeUpdates) {
            const batchStep = api.batchAttributeUpdates.actions.batchSteps({
                steps: steps,
                doc: tr.doc
            });
            tr.step(batchStep);
        } else steps.forEach((s)=>{
            tr.step(s);
        });
        return tr;
    };
const $2c196303ff0dada3$export$81edad89dedd3529 = (isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, api, isCommentEditor = false)=>(table, view)=>(tr)=>{
            if (!view) return tr;
            const newTable = tr.doc.nodeAt(table.pos);
            const domAtPos = view.domAtPos.bind(view);
            const maybeTable = domAtPos(table.start).node;
            const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
            const tableRef = maybeTableElement === null || maybeTableElement === void 0 ? void 0 : maybeTableElement.closest('table');
            if (!tableRef || !newTable) return tr;
            const isResized = (0, $7Xzpg.hasTableBeenResized)(table.node);
            let previousTableInfo = {
                width: 0,
                possibleMaxWidth: 0,
                isResized: isResized
            };
            const tableDepth = view.state.doc.resolve(table.pos).depth;
            let shouldScale = isTableScalingEnabled && tableDepth === 0;
            if (shouldScale && isTableFixedColumnWidthsOptionEnabled) shouldScale = newTable.attrs.displayMode !== 'fixed';
            if (shouldScale) previousTableInfo = {
                width: (0, $7SttP.getTableElementWidth)(table.node),
                possibleMaxWidth: (0, $7SttP.getTableContainerElementWidth)(table.node),
                isResized: isResized
            };
            else {
                var _tableRef$parentEleme;
                previousTableInfo = {
                    // when table is resized the tableRef client width will be 1px larger than colGroup, which is used in calculations
                    width: isResized ? tableRef.clientWidth - 1 : tableRef.clientWidth,
                    /** the is the width the table can reach before overflowing */ possibleMaxWidth: (tableRef === null || tableRef === void 0 || (_tableRef$parentEleme = tableRef.parentElement) === null || _tableRef$parentEleme === void 0 ? void 0 : _tableRef$parentEleme.clientWidth) || 0,
                    isResized: isResized
                };
            }
            // determine the new table, based on new width
            const newTableInfo = {
                noOfColumns: (0, $dpooP.TableMap).get(newTable).width
            };
            if (!newTableInfo.noOfColumns || newTableInfo.noOfColumns <= 0) return tr;
            const averageColumnWidth = previousTableInfo.width / newTableInfo.noOfColumns;
            // If the table has not been resized (i.e. all columns will have the same width) and every column width is bigger than the minimum column width
            // we skip updating the size of columns here.
            if (!previousTableInfo.isResized && averageColumnWidth > (0, $jd8X7.tableCellMinWidth)) return tr;
            const wasTableInOverflow = previousTableInfo.width > previousTableInfo.possibleMaxWidth;
            // If the table has not been resized, and each column width is smaller than the minimum column width
            // Or if the table has been resized, but each column width is either 48px or null
            // we update the table to have 48px for each column
            if (!previousTableInfo.isResized && averageColumnWidth <= (0, $jd8X7.tableCellMinWidth) || previousTableInfo.isResized && (0, $7Xzpg.isMinCellWidthTable)(table.node)) {
                const widths = new Array(newTableInfo.noOfColumns).fill((0, $jd8X7.tableCellMinWidth));
                const cols = widths.map((_, index)=>({
                        width: (0, $jd8X7.tableCellMinWidth),
                        minWidth: (0, $jd8X7.tableCellMinWidth),
                        index: index
                    }));
                const minWidthResizeState = {
                    cols: cols,
                    widths: widths,
                    maxSize: previousTableInfo.possibleMaxWidth,
                    tableWidth: previousTableInfo.width,
                    overflow: wasTableInOverflow
                };
                return $2c196303ff0dada3$export$6688b13ec132acdf(minWidthResizeState, table.node, table.start, api)(tr);
            }
            let resizeState = (0, $26jxM.getResizeState)({
                minWidth: (0, $jd8X7.tableCellMinWidth),
                table: table.node,
                start: table.start,
                tableRef: tableRef,
                domAtPos: domAtPos,
                maxSize: previousTableInfo.possibleMaxWidth,
                isTableScalingEnabled: shouldScale,
                shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                isCommentEditor: isCommentEditor
            });
            // Two scenarios that require scaling:
            //   1. If the new table width will result in the table going into overflow
            //      we resize the cells to avoid it (e.g. adding a column)
            //   2. If the new table width will be shorter than the parent width, scale columns to fit parent
            if (!wasTableInOverflow && resizeState.overflow || resizeState.tableWidth < resizeState.maxSize) resizeState = (0, $9xQxI.scaleTableTo)(resizeState, previousTableInfo.possibleMaxWidth);
            return $2c196303ff0dada3$export$6688b13ec132acdf(resizeState, table.node, table.start, api)(tr);
        };

});
parcelRegister("26jxM", function(module, exports) {
$parcel$export(module.exports, "getResizeState", () => $eac187aa400a0f4b$export$38f73cf370cfaafc);
$parcel$export(module.exports, "updateColgroup", () => $eac187aa400a0f4b$export$23e0010f5fd8981);
$parcel$export(module.exports, "getTotalWidth", () => $eac187aa400a0f4b$export$fbc5c7e5991c30a8);
$parcel$export(module.exports, "adjustColumnsWidths", () => $eac187aa400a0f4b$export$b07f5f5f9c98720a);
$parcel$export(module.exports, "evenAllColumnsWidths", () => $eac187aa400a0f4b$export$aa593d179f012fe1);
$parcel$export(module.exports, "bulkColumnsResize", () => $eac187aa400a0f4b$export$7d703099c5579705);
$parcel$export(module.exports, "getNewResizeStateFromSelectedColumns", () => $eac187aa400a0f4b$export$8490eb29eba3007d);

var $k5JVX = parcelRequire("k5JVX");

var $jd8X7 = parcelRequire("jd8X7");

var $ePYW1 = parcelRequire("ePYW1");

var $4Bf8g = parcelRequire("4Bf8g");

var $7Xzpg = parcelRequire("7Xzpg");

var $7m0jn = parcelRequire("7m0jn");

var $7JtQD = parcelRequire("7JtQD");

var $7SttP = parcelRequire("7SttP");
const $eac187aa400a0f4b$export$38f73cf370cfaafc = ({ minWidth: minWidth, maxSize: maxSize, table: table, tableRef: tableRef, start: start, domAtPos: domAtPos, isTableScalingEnabled: isTableScalingEnabled = false, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent = false, isCommentEditor: isCommentEditor = false })=>{
    var _table$attrs;
    if (isTableScalingEnabled && !isCommentEditor || isTableScalingEnabled && isCommentEditor && (_table$attrs = table.attrs) !== null && _table$attrs !== void 0 && _table$attrs.width) {
        const scalePercent = (0, $7SttP.getTableScalingPercent)(table, tableRef, shouldUseIncreasedScalingPercent);
        minWidth = Math.ceil(minWidth / scalePercent);
    }
    if ((0, $7Xzpg.hasTableBeenResized)(table)) {
        // If the table has been resized, we can use the column widths from the table node
        const cols = (0, $ePYW1.calcTableColumnWidths)(table).map((width, index)=>({
                width: width === 0 ? (0, $jd8X7.tableNewColumnMinWidth) : width,
                minWidth: width === 0 ? (0, $jd8X7.tableNewColumnMinWidth) : minWidth,
                index: index
            }));
        const widths = cols.map((col)=>col.width);
        const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
        const overflow = tableWidth > maxSize;
        return {
            cols: cols,
            widths: widths,
            maxSize: maxSize,
            tableWidth: tableWidth,
            overflow: overflow,
            isScaled: isTableScalingEnabled
        };
    }
    const shouldReinsertColgroup = !isTableScalingEnabled;
    // Getting the resize state from DOM
    const colgroupChildren = (0, $7Xzpg.insertColgroupFromNode)(tableRef, table, isTableScalingEnabled, shouldReinsertColgroup, // don't reinsert colgroup when preserving table width - this causes widths to jump
    shouldUseIncreasedScalingPercent, isCommentEditor);
    const cols = Array.from(colgroupChildren).map((_, index)=>{
        // If the table hasn't been resized and we have a table width attribute, we can use it
        // to calculate the widths of the columns
        if (isTableScalingEnabled) {
            var _table$attrs2;
            // isCommentEditor when table cols were not resized,
            // we want to use tableRef.parentElement.clientWidth, which is the same as maxSize
            const tableNodeWidth = isCommentEditor && !((_table$attrs2 = table.attrs) !== null && _table$attrs2 !== void 0 && _table$attrs2.width) ? maxSize : (0, $k5JVX.getTableContainerWidth)(table);
            return {
                index: index,
                width: tableNodeWidth / colgroupChildren.length,
                minWidth: minWidth
            };
        }
        const cellsRefs = (0, $7m0jn.getCellsRefsInColumn)(index, table, start, domAtPos);
        return (0, $7m0jn.getColumnStateFromDOM)(cellsRefs, index, minWidth);
    });
    const widths = cols.map((col)=>col.width);
    const tableWidth = widths.reduce((sum, width)=>sum + width, 0);
    const overflow = tableWidth > maxSize;
    return {
        cols: cols,
        widths: widths,
        maxSize: maxSize,
        tableWidth: tableWidth,
        overflow: overflow,
        isScaled: isTableScalingEnabled
    };
};
const $eac187aa400a0f4b$export$23e0010f5fd8981 = (state, tableRef, tableNode, isTableScalingEnabled, scalePercent)=>{
    const cols = tableRef === null || tableRef === void 0 ? void 0 : tableRef.querySelectorAll(':scope > colgroup > col');
    const columnsCount = cols === null || cols === void 0 ? void 0 : cols.length;
    /**
      updateColgroup will update whole table scale when click the column resize handle, this behavior will affect when table overflowed, when now resize handle been dragged and extend to make table overflowed, table will show overflow. This need to be confirmed because it conflict with how isTableScalingEnabled work.
      We don't want to scale the table when resizing columns, only when viewpoint shrinks the table.
      We need to remove !isColumnResizing if we handled auto scale table when mouseUp event.
      * */ if (isTableScalingEnabled && tableNode) state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        const fixedColWidth = (0, $7Xzpg.getColWidthFix)(column.width, columnsCount ?? 0);
        const scaledWidth = fixedColWidth * (scalePercent || 1);
        const finalWidth = Math.max(scaledWidth, (0, $jd8X7.tableCellMinWidth));
        // we aren't handling the remaining pixels here when the 48px min width is reached
        if (cols !== null && cols !== void 0 && cols[i]) cols[i].style.width = `${finalWidth}px`;
    });
    else state.cols.filter((column)=>column && !!column.width) // if width is 0, we dont want to apply that.
    .forEach((column, i)=>{
        if (cols !== null && cols !== void 0 && cols[i]) cols[i].style.width = `${(0, $7Xzpg.getColWidthFix)(column.width, columnsCount ?? 0)}px`;
    });
    // colgroup has updated, reflect new widths in sticky header
    (0, $7JtQD.syncStickyRowToTable)(tableRef);
};
const $eac187aa400a0f4b$export$fbc5c7e5991c30a8 = ({ cols: cols })=>{
    return cols.reduce((totalWidth, col)=>totalWidth + col.width, 0);
};
const $eac187aa400a0f4b$export$b07f5f5f9c98720a = (resizeState, maxSize)=>{
    const totalWidth = $eac187aa400a0f4b$export$fbc5c7e5991c30a8(resizeState);
    const diff = maxSize - totalWidth;
    if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $jd8X7.tableCellMinWidth)) {
        let updated = false;
        return {
            ...resizeState,
            cols: resizeState.cols.map((col)=>{
                if (!updated && col.width + diff > col.minWidth) {
                    updated = true;
                    return {
                        ...col,
                        width: col.width + diff
                    };
                }
                return col;
            })
        };
    }
    return resizeState;
};
const $eac187aa400a0f4b$export$aa593d179f012fe1 = (resizeState)=>{
    const maxSize = $eac187aa400a0f4b$export$fbc5c7e5991c30a8(resizeState);
    const evenWidth = Math.floor(maxSize / resizeState.cols.length);
    const cols = resizeState.cols.map((col)=>({
            ...col,
            width: evenWidth
        }));
    return $eac187aa400a0f4b$export$b07f5f5f9c98720a({
        ...resizeState,
        cols: cols
    }, maxSize);
};
const $eac187aa400a0f4b$var$getSpace = (columns, start, end)=>columns.slice(start, end).map((col)=>col.width).reduce((sum, width)=>sum + width, 0);
const $eac187aa400a0f4b$var$evenSelectedColumnsWidths = (resizeState, rect)=>{
    const cols = resizeState.cols;
    const selectedSpace = $eac187aa400a0f4b$var$getSpace(cols, rect.left, rect.right);
    const allSpace = $eac187aa400a0f4b$var$getSpace(cols, 0, cols.length);
    const allWidth = allSpace / cols.length;
    const width = selectedSpace / (rect.right - rect.left);
    // Result equals even distribution of all columns -
    // unset widths of all columns
    if (allWidth === width) return {
        ...resizeState,
        widths: cols.map(()=>width),
        cols: resizeState.cols.map((col)=>({
                ...col,
                width: 0
            }))
    };
    return {
        ...resizeState,
        widths: cols.map((col, i)=>i >= rect.left && i < rect.right ? width : col.width),
        cols: cols.map((col, i)=>({
                ...col,
                width: i >= rect.left && i < rect.right ? width : col.width
            }))
    };
};
const $eac187aa400a0f4b$export$7d703099c5579705 = (resizeState, columnsIndexes, sourceColumnIndex)=>{
    const currentTableWidth = $eac187aa400a0f4b$export$fbc5c7e5991c30a8(resizeState);
    const colIndex = columnsIndexes.indexOf(sourceColumnIndex) > -1 ? sourceColumnIndex : sourceColumnIndex + 1;
    const sourceCol = resizeState.cols[colIndex];
    const seenColumns = {};
    const widthsDiffs = [];
    const cols = resizeState.cols.map((col)=>{
        if (columnsIndexes.indexOf(col.index) > -1) {
            const diff = col.width - sourceCol.width;
            if (diff !== 0) widthsDiffs.push(diff);
            return {
                ...col,
                width: sourceCol.width
            };
        }
        return col;
    });
    let newState = {
        ...resizeState,
        cols: cols.map((col)=>{
            if (columnsIndexes.indexOf(col.index) > -1 || // take from prev columns only if dragging the first handle to the left
            columnsIndexes.indexOf(sourceColumnIndex) > -1 && col.index < colIndex) return col;
            while(widthsDiffs.length){
                const diff = widthsDiffs.shift() || 0;
                const column = seenColumns[col.index] || col;
                const maybeWidth = column.width + diff;
                if (maybeWidth > column.minWidth) seenColumns[column.index] = {
                    ...column,
                    width: maybeWidth
                };
                else {
                    widthsDiffs.push(maybeWidth - column.minWidth);
                    seenColumns[column.index] = {
                        ...column,
                        width: column.minWidth
                    };
                    break;
                }
            }
            return seenColumns[col.index] || col;
        })
    };
    // minimum possible table widths at the current layout
    const minTableWidth = resizeState.maxSize;
    // new table widths after bulk resize
    const newTotalWidth = $eac187aa400a0f4b$export$fbc5c7e5991c30a8(newState);
    // when all columns are selected, what do we do when sum of columns widths is lower than min possible table widths?
    if (columnsIndexes.length === resizeState.cols.length && newTotalWidth < minTableWidth) {
        // table is not in overflow -> normal resize of a single column
        if (currentTableWidth === minTableWidth) return resizeState;
        else {
            const columnWidth = Math.floor((minTableWidth - sourceCol.width) / (newState.cols.length - 1));
            newState = {
                ...resizeState,
                cols: newState.cols.map((col)=>{
                    if (col.index === sourceCol.index) return col;
                    return {
                        ...col,
                        width: columnWidth
                    };
                })
            };
        }
    }
    // fixes total table widths by adding missing pixels to columns widths here and there
    return $eac187aa400a0f4b$export$b07f5f5f9c98720a(newState, resizeState.maxSize);
};
// Get the layout
const $eac187aa400a0f4b$var$normaliseTableLayout = (input)=>{
    switch(input){
        case 'wide':
            return input;
        case 'full-width':
            return input;
        default:
            return 'default';
    }
};
const $eac187aa400a0f4b$export$8490eb29eba3007d = (rect, state, domAtPos, getEditorContainerWidth, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>{
    // Fail early so that we don't do complex calculations for no reason
    const numColumnsSelected = rect.right - rect.left;
    if (numColumnsSelected <= 1) return;
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount, table: table } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
    if (!table) return;
    // Fail early so that we don't do complex calculations for no reason
    if (!(0, $7Xzpg.hasTableBeenResized)(table.node)) return;
    const maybeTable = domAtPos(table.start).node;
    const maybeTableElement = maybeTable instanceof HTMLElement ? maybeTable : null;
    const tableRef = maybeTableElement === null || maybeTableElement === void 0 ? void 0 : maybeTableElement.closest('table');
    if (!tableRef) return;
    const layout = $eac187aa400a0f4b$var$normaliseTableLayout(tableRef === null || tableRef === void 0 ? void 0 : tableRef.dataset.layout);
    const maxSize = (0, $7SttP.getTableMaxWidth)({
        table: table.node,
        tableStart: table.start,
        state: state,
        layout: layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = table.node.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        isTableScalingEnabledOnCurrentTable = true;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = $eac187aa400a0f4b$export$38f73cf370cfaafc({
        minWidth: (0, $jd8X7.tableCellMinWidth),
        maxSize: maxSize,
        table: table.node,
        tableRef: tableRef,
        start: table.start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    const newResizeState = $eac187aa400a0f4b$var$evenSelectedColumnsWidths(resizeState, rect);
    const widthsBefore = resizeState.widths;
    const widthsAfter = newResizeState.widths;
    const changed = resizeState.widths.some((widthBefore, index)=>widthBefore !== widthsAfter[index]);
    return {
        resizeState: newResizeState,
        table: table,
        changed: changed,
        attributes: {
            position: rect.left,
            count: rect.right - rect.left,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount,
            widthsBefore: widthsBefore,
            widthsAfter: widthsAfter
        }
    };
};

});
parcelRegister("4Bf8g", function(module, exports) {
$parcel$export(module.exports, "getSelectedTableInfo", () => $124184238ec3b27e$export$d2cf64960b17e12e);
$parcel$export(module.exports, "getSelectedCellInfo", () => $124184238ec3b27e$export$277d5394a2608229);
$parcel$export(module.exports, "withEditorAnalyticsAPI", () => $124184238ec3b27e$export$c27221be174b6703);
$parcel$export(module.exports, "generateResizedPayload", () => $124184238ec3b27e$export$a12b1eaff522a2d1);
$parcel$export(module.exports, "generateResizeFrameRatePayloads", () => $124184238ec3b27e$export$29574a7e6ffc8eb4);
$parcel$export(module.exports, "useMeasureFramerate", () => $124184238ec3b27e$export$9642a56c1e8805cc);
$parcel$export(module.exports, "getWidthInfoPayload", () => $124184238ec3b27e$export$208d2421b73f3f86);
$parcel$export(module.exports, "getHeightInfoPayload", () => $124184238ec3b27e$export$34e5b28c67455a81);

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $ik3vI = parcelRequire("ik3vI");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $l5gi8 = parcelRequire("l5gi8");

var $7Xzpg = parcelRequire("7Xzpg");

var $4WYVI = parcelRequire("4WYVI");
function $124184238ec3b27e$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $5n2u9.findTable)(selection);
    if (table) {
        map = (0, $dpooP.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}
function $124184238ec3b27e$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = $124184238ec3b27e$export$d2cf64960b17e12e(selection);
    if (table && map) {
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}
const $124184238ec3b27e$export$c27221be174b6703 = (payload)=>(editorAnalyticsAPI)=>{
        return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                    const dynamicPayload = payload instanceof Function ? payload(state) : payload;
                    if (dynamicPayload) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(dynamicPayload)(tr);
                    if (dispatch) dispatch(tr);
                    return true;
                }, view);
    };
const $124184238ec3b27e$export$a12b1eaff522a2d1 = (props)=>{
    const tableMap = (0, $dpooP.TableMap).get(props.resizedNode);
    return {
        action: (0, $8d4kB.TABLE_ACTION).RESIZED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        attributes: {
            newWidth: props.resizedNode.attrs.width,
            prevWidth: props.originalNode.attrs.width ?? null,
            nodeSize: props.resizedNode.nodeSize,
            totalTableWidth: (0, $7Xzpg.hasTableBeenResized)(props.resizedNode) ? (0, $4WYVI.getTableWidth)(props.resizedNode) : null,
            totalRowCount: tableMap.height,
            totalColumnCount: tableMap.width
        }
    };
};
const $124184238ec3b27e$export$52625746d6329c8a = (frameRateSamples)=>{
    if (frameRateSamples.length > 1) {
        const frameRateSum = frameRateSamples.reduce((sum, frameRate, index)=>{
            if (index === 0) return sum;
            else return sum + frameRate;
        }, 0);
        const averageFrameRate = Math.round(frameRateSum / (frameRateSamples.length - 1));
        return [
            frameRateSamples[0],
            averageFrameRate
        ];
    } else return frameRateSamples;
};
const $124184238ec3b27e$export$29574a7e6ffc8eb4 = (props)=>{
    const reducedResizeFrameRateSamples = $124184238ec3b27e$export$52625746d6329c8a(props.frameRateSamples);
    return reducedResizeFrameRateSamples.map((frameRateSample, index)=>({
            action: (0, $8d4kB.TABLE_ACTION).RESIZE_PERF_SAMPLING,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
            attributes: {
                frameRate: frameRateSample,
                nodeSize: props.originalNode.nodeSize,
                docSize: props.docSize,
                isInitialSample: index === 0
            }
        }));
};
const $124184238ec3b27e$export$9642a56c1e8805cc = (config = {})=>{
    const { maxSamples: maxSamples = 10, minFrames: minFrames = 5, minTimeMs: minTimeMs = 500, sampleRateMs: sampleRateMs = 1000, timeoutMs: timeoutMs = 200 } = config;
    const frameCount = (0, $fc4bM.useRef)(0);
    const lastTime = (0, $fc4bM.useRef)(0);
    const timeoutId = (0, $fc4bM.useRef)();
    const frameRateSamples = (0, $fc4bM.useRef)([]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
        };
    }, []);
    const startMeasure = ()=>{
        frameCount.current = 0;
        lastTime.current = performance.now();
    };
    /**
   * Returns an array of frame rate samples as integers.
   */ const endMeasure = ()=>{
        const samples = frameRateSamples.current;
        frameRateSamples.current = [];
        return samples;
    };
    const sampleFrameRate = (delay = 0)=>{
        const currentTime = performance.now();
        const deltaTime = currentTime - lastTime.current - delay;
        const isValidSample = deltaTime > minTimeMs && frameCount.current >= minFrames;
        if (isValidSample) {
            const frameRate = Math.round(frameCount.current / (deltaTime / 1000));
            frameRateSamples.current.push(frameRate);
        }
        frameCount.current = 0;
        lastTime.current = 0;
    };
    /**
   * Counts the number of frames that occur within a given time period. Intended to be called
   * inside a `requestAnimationFrame` callback.
   */ const countFrames = ()=>{
        if (frameRateSamples.current.length >= maxSamples && timeoutId.current) {
            clearTimeout(timeoutId.current);
            return;
        }
        /**
     * Allows us to keep counting frames even if `startMeasure` is not called
     */ if (lastTime.current === 0) lastTime.current = performance.now();
        frameCount.current++;
        if (timeoutId.current) clearTimeout(timeoutId.current);
        if (performance.now() - lastTime.current > sampleRateMs) sampleFrameRate();
        else timeoutId.current = setTimeout(()=>sampleFrameRate(timeoutMs), timeoutMs);
    };
    return {
        startMeasure: startMeasure,
        endMeasure: endMeasure,
        countFrames: countFrames
    };
};
const $124184238ec3b27e$var$tableContainerNodes = new Set([
    'layoutSection',
    'layoutColumn',
    'expand',
    'nestedExpand',
    'extension',
    'bodiedExtension',
    'multiBodiedExtension',
    'extensionFrame',
    'table',
    'tableCell',
    'tableHeader',
    'tableRow'
]);
const $124184238ec3b27e$export$208d2421b73f3f86 = (editorView, editorWidth)=>{
    const tablesInfo = [];
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$124184238ec3b27e$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            var _domAtPos$node;
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = (_domAtPos$node = domAtPos.node) === null || _domAtPos$node === void 0 ? void 0 : _domAtPos$node.parentElement;
            const isNestedTable = (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'tableCell' || (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                tableWidth: table.scrollWidth,
                isNestedTable: isNestedTable,
                hasScrollbar: table.parentElement ? (table === null || table === void 0 ? void 0 : table.parentElement.clientWidth) < table.scrollWidth : false
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableWidth = Math.max(...tablesInfo.map((table)=>table.tableWidth));
    return {
        action: (0, $8d4kB.TABLE_ACTION).TABLE_WIDTH_INFO,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        attributes: {
            editorWidth: editorWidth,
            editorWidthBreakpoint: (0, $ik3vI.getBreakpointKey)(editorWidth),
            hasTableWithScrollbar: tablesInfo.some((table)=>table.hasScrollbar),
            hasTableWiderThanEditor: maxTableWidth > editorWidth,
            maxTableWidthBreakpoint: (0, $ik3vI.getBreakpointKey)(maxTableWidth),
            tableWidthInfo: tablesInfo,
            mode: 'editor'
        },
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
    };
};
const $124184238ec3b27e$export$34e5b28c67455a81 = (editorView)=>{
    const tablesInfo = [];
    const editorPopupScrollParent = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
    // don't send the event if the editor scroll parent is not available
    if (!editorPopupScrollParent) return undefined;
    const editorScrollParentClientHeight = editorPopupScrollParent.clientHeight;
    const isEditorScrollable = editorPopupScrollParent.scrollHeight > editorScrollParentClientHeight;
    editorView.state.doc.nodesBetween(0, editorView.state.doc.content.size, (node, pos, parent)=>{
        if (!$124184238ec3b27e$var$tableContainerNodes.has(node.type.name)) return false;
        if (node.type.name === 'table') {
            var _domAtPos$node2;
            const domAtPos = editorView.domAtPos(pos + 1);
            const table = (_domAtPos$node2 = domAtPos.node) === null || _domAtPos$node2 === void 0 ? void 0 : _domAtPos$node2.parentElement;
            const isNestedTable = (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'tableCell' || (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'tableHeader';
            if (table instanceof HTMLTableElement) tablesInfo.push({
                isNestedTable: isNestedTable,
                tableHeight: table.scrollHeight
            });
        }
    });
    // only send the event if there are tables on the page
    if (tablesInfo.length === 0) return undefined;
    const maxTableHeight = Math.max(...tablesInfo.map((table)=>table.tableHeight));
    return {
        action: (0, $8d4kB.TABLE_ACTION).TABLE_EDITOR_HEIGHT_INFO,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        attributes: {
            editorScrollParentClientHeight: editorScrollParentClientHeight,
            isEditorScrollable: isEditorScrollable,
            maxTableToEditorHeightRatio: maxTableHeight / editorScrollParentClientHeight,
            tableHeightInfo: tablesInfo
        },
        eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL
    };
};

});

parcelRegister("7JtQD", function(module, exports) {
$parcel$export(module.exports, "updateControls", () => $44b2a2b7ddaf2458$export$13c259c17cfd51f5);
$parcel$export(module.exports, "syncStickyRowToTable", () => $44b2a2b7ddaf2458$export$43080b9794565cc4);
$parcel$export(module.exports, "isClickNear", () => $44b2a2b7ddaf2458$export$f76d638a91295d45);
$parcel$export(module.exports, "getResizeCellPos", () => $44b2a2b7ddaf2458$export$3658aa65e79e3104);
$parcel$export(module.exports, "updateStickyMargins", () => $44b2a2b7ddaf2458$export$ec6da316e37a54bf);
$parcel$export(module.exports, "syncStickyCornerMasks", () => $44b2a2b7ddaf2458$export$324b8139ca20d6a6);
$parcel$export(module.exports, "clearStickyCornerMaskPositions", () => $44b2a2b7ddaf2458$export$b6a476e1427b061);

var $jd8X7 = parcelRequire("jd8X7");

var $i8LxW = parcelRequire("i8LxW");
var $g2vOy = parcelRequire("g2vOy");

var $hCON4 = parcelRequire("hCON4");

var $aEmSo = parcelRequire("aEmSo");

var $YREXK = parcelRequire("YREXK");

var $4GJqd = parcelRequire("4GJqd");

var $fQCvF = parcelRequire("fQCvF");

var $eEepd = parcelRequire("eEepd");
const $44b2a2b7ddaf2458$export$13c259c17cfd51f5 = ()=>(state)=>{
        const { tableRef: tableRef } = (0, $4GJqd.getPluginState)(state);
        if (!tableRef) return;
        const tr = tableRef.querySelector('tr');
        if (!tr) return;
        const wrapper = tableRef.parentElement;
        if (!(wrapper && wrapper.parentElement)) return;
        const rowControls = wrapper.parentElement.querySelectorAll(`.${(0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP}`);
        const numberedRows = wrapper.parentElement.querySelectorAll((0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON);
        $44b2a2b7ddaf2458$export$43080b9794565cc4(tableRef);
        const rowHeights = (0, $eEepd.getRowHeights)(tableRef);
        // update rows controls height on resize
        for(let i = 0, count = rowControls.length; i < count; i++){
            const height = rowHeights[i];
            if (height) {
                rowControls[i].style.height = `${height}px`;
                if (numberedRows.length) numberedRows[i].style.height = `${height}px`;
            }
        }
    };
const $44b2a2b7ddaf2458$export$f76d638a91295d45 = (event, click)=>{
    const dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
};
const $44b2a2b7ddaf2458$export$3658aa65e79e3104 = (view, event)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    if (!(0, $i8LxW.containsClassName)(target, (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION)) return null;
    const tableCell = (0, $hCON4.closestElement)(target, 'td, th');
    if (!tableCell) return null;
    const cellStartPosition = view.posAtDOM(tableCell, 0);
    return cellStartPosition - 1;
};
const $44b2a2b7ddaf2458$export$ec6da316e37a54bf = (table)=>{
    const row = table.querySelector('tr.sticky');
    if (!row) {
        table.style.marginTop = '';
        return;
    }
    const paddingTop = (0, $g2vOy.parsePx)(window.getComputedStyle(row).paddingTop || '') || 0;
    const firstRowHeight = row.getBoundingClientRect().height - paddingTop - (0, $jd8X7.tableCellBorderWidth);
    table.style.marginTop = `${(0, $jd8X7.tableMarginTop) + firstRowHeight}px`;
};
const $44b2a2b7ddaf2458$var$applyColWidthsToStickyRow = (colGroup, headerRow)=>{
    // sync column widths for the sticky row
    const newCols = (0, $fQCvF.colWidthsForRow)(headerRow);
    if (newCols) headerRow.style.gridTemplateColumns = newCols;
};
const $44b2a2b7ddaf2458$export$43080b9794565cc4 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    if (!headerRow) return;
    $44b2a2b7ddaf2458$var$applyColWidthsToStickyRow(tableRef.querySelector('colgroup'), headerRow);
    $44b2a2b7ddaf2458$var$applyTableWidthToStickyRow(tableRef, headerRow);
};
const $44b2a2b7ddaf2458$var$applyTableWidthToStickyRow = (tableRef, headerRow)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const tbody = tableRef.querySelector('tbody');
    const wrapper = tableRef.parentElement;
    if (tbody && wrapper) {
        // when resizing in Chrome, clientWidth will give us 759px
        // but toggling the sticky class will reset it to 760px.
        //
        // both elements in the dom + inspector will
        // be the same width but at layout will be different..
        const newWidth = Math.min(tbody.offsetWidth + 1, wrapper.offsetWidth);
        headerRow.style.width = `${newWidth}px`;
        headerRow.scrollLeft = wrapper.scrollLeft;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) $44b2a2b7ddaf2458$var$syncCornerMasksToStickyRow(tableRef, headerRow, wrapper);
    }
};
const $44b2a2b7ddaf2458$export$324b8139ca20d6a6 = (tableRef)=>{
    if (!tableRef) return;
    const headerRow = tableRef.querySelector('tr[data-header-row]');
    const wrapper = tableRef.parentElement;
    if (!headerRow || !wrapper) return;
    $44b2a2b7ddaf2458$var$syncCornerMasksToStickyRow(tableRef, headerRow, wrapper);
};
const $44b2a2b7ddaf2458$export$b6a476e1427b061 = (tableRef)=>{
    const wrapper = tableRef === null || tableRef === void 0 ? void 0 : tableRef.parentElement;
    if (!wrapper) return;
    wrapper.querySelectorAll(`.${(0, $YREXK.TableCssClassName).TABLE_CORNER_MASK}`).forEach((mask)=>{
        mask.style.removeProperty('left');
    });
};
const $44b2a2b7ddaf2458$var$syncCornerMasksToStickyRow = (tableRef, headerRow, wrapper)=>{
    const cornerMasks = wrapper.querySelectorAll(`.${(0, $YREXK.TableCssClassName).TABLE_CORNER_MASK}`);
    if (!cornerMasks.length) return;
    const isLegacySticky = tableRef.classList.contains((0, $YREXK.TableCssClassName).TABLE_STICKY) && headerRow.classList.contains('sticky');
    if (!isLegacySticky) {
        $44b2a2b7ddaf2458$export$b6a476e1427b061(tableRef);
        return;
    }
    const stickyRowRect = headerRow.getBoundingClientRect();
    cornerMasks.forEach((mask)=>{
        const corner = mask.dataset.corner;
        const left = corner === 'right' ? stickyRowRect.right - 11 : stickyRowRect.left - 1;
        mask.style.left = `${left}px`;
    });
};

});
parcelRegister("fQCvF", function(module, exports) {
$parcel$export(module.exports, "getColumnsWidths", () => $4576868a86155c44$export$79aef9e007571c);
$parcel$export(module.exports, "getColumnsWidthsWithMergedCells", () => $4576868a86155c44$export$cf5a0e252f1598f1);
$parcel$export(module.exports, "colWidthsForRow", () => $4576868a86155c44$export$d231dfb66a75f6c1);
$parcel$export(module.exports, "getColumnIndexByMousePosition", () => $4576868a86155c44$export$b8d525853cd49bde);
$parcel$export(module.exports, "convertHTMLCellIndexToColumnIndex", () => $4576868a86155c44$export$b53a50910add7502);
$parcel$export(module.exports, "getColumnIndexMappedToColumnIndexInFirstRow", () => $4576868a86155c44$export$ffa56ed053ef832e);

var $hCON4 = parcelRequire("hCON4");

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $l5gi8 = parcelRequire("l5gi8");

var $4Tw3G = parcelRequire("4Tw3G");
const $4576868a86155c44$export$79aef9e007571c = (view)=>{
    const { selection: selection } = view.state;
    let widths = [];
    const table = (0, $5n2u9.findTable)(selection);
    if (table) {
        const map = (0, $dpooP.TableMap).get(table.node);
        const domAtPos = view.domAtPos.bind(view);
        // When there is no cell we need to fill it with undefined
        widths = Array.from({
            length: map.width
        });
        for(let i = 0; i < map.width; i++)if (!map.isCellMergedTopLeft(0, i)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(map.map[i]);
            const pos = map.map[i] + table.start;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const cellRef = (0, $a4TQr.findDomRefAtPos)(pos, domAtPos);
            const rect = cellRef.getBoundingClientRect();
            widths[i] = (rect ? rect.width : cellRef.offsetWidth) + 1;
            i += node.attrs.colspan - 1;
        }
    }
    return widths;
};
const $4576868a86155c44$export$e4820f63cd163896 = (totalWidth, columnCount, ratios)=>{
    const evenSplit = ()=>new Array(columnCount).fill(totalWidth / columnCount);
    if (!ratios || ratios.length !== columnCount) return evenSplit();
    const total = ratios.reduce((sum, ratio)=>sum + (ratio > 0 ? ratio : 0), 0);
    if (total <= 0) return evenSplit();
    return ratios.map((ratio)=>totalWidth * ((ratio > 0 ? ratio : 0) / total));
};
const $4576868a86155c44$export$cf5a0e252f1598f1 = (view)=>{
    const { selection: selection } = view.state;
    const table = (0, $5n2u9.findTable)(selection);
    if (!table) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    const domAtPos = view.domAtPos.bind(view);
    const widths = Array.from({
        length: map.width
    });
    for(let i = 0; i < map.width; i++){
        if (map.isCellMergedTopLeft(0, i)) continue;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(map.map[i]);
        const pos = map.map[i] + table.start;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const cellRef = (0, $a4TQr.findDomRefAtPos)(pos, domAtPos);
        const rect = cellRef.getBoundingClientRect();
        const measuredWidth = (rect ? rect.width : cellRef.offsetWidth) + 1;
        const colspan = node.attrs.colspan ?? 1;
        if (colspan <= 1) {
            widths[i] = measuredWidth;
            continue;
        }
        const colwidth = Array.isArray(node.attrs.colwidth) ? node.attrs.colwidth : undefined;
        const perColumnWidths = $4576868a86155c44$export$e4820f63cd163896(measuredWidth, colspan, colwidth);
        for(let span = 0; span < colspan && i + span < map.width; span++)widths[i + span] = perColumnWidths[span];
        i += colspan - 1;
    }
    return widths;
};
const $4576868a86155c44$export$bedfed4734d37a07 = (columnsWidths, selection)=>{
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!rect) return null;
    let width = 0;
    let offset = 0;
    // find the columns before the selection
    for(let i = 0; i < rect.left; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) offset += colWidth - 1;
    }
    // these are the selected columns widths
    const indexes = [];
    for(let i = rect.left; i < rect.right; i++){
        const colWidth = columnsWidths[i];
        if (colWidth) {
            width += colWidth;
            indexes.push(i);
        }
    }
    const left = offset + width / 2 - (0, $4Tw3G.tableDeleteButtonSize) / 2;
    return {
        left: left,
        indexes: indexes
    };
};
// give a row colspan and a colwidths
// and map to a row's colwidths
const $4576868a86155c44$var$mapTableColwidthsToRow = (rowColSpans, tableColWidths)=>{
    let curColIdx = 0;
    const colWidths = [];
    rowColSpans.forEach((cellColSpan)=>{
        const colWidth = tableColWidths.slice(curColIdx, curColIdx + cellColSpan).reduce((acc, val)=>acc + val, 0);
        curColIdx += cellColSpan;
        colWidths.push(colWidth);
    });
    return colWidths;
};
const $4576868a86155c44$var$getRelativeDomCellWidths = ({ width: width, colspan: colspan, colwidth: colwidth })=>{
    // For cells with colSpan 1
    // or
    // for cells in a table with unchanged column widths,
    // these are identified by the lack of colwidth data attribute,
    // return equally partitioned total cell width in DOM for each cell.
    if (colspan === 1 || !colwidth) return new Array(colspan).fill(width / colspan);
    // For cells that have colSpan > 1 and
    // are part of a table with resized columns
    // return the current total DOM width of the cell multiplied
    // by the percentage of the each individual cell's size.
    // The cell size percentage is calculated using individual colwidth of the cell,
    // from data-colwidth attribute on the cell,
    // divided by the total width of the cells from colwidths for merged cells.
    // Ex:
    // colwidth = ‘201,102’
    // Total colWidth = 303
    // returned cellWidths = [303 * (201/303), 303 * (102/303)]
    // For merged cells we get back colwidth as `201,102`
    const cellColWidths = colwidth.split(',').map((colwidth)=>Number(colwidth));
    const totalCalculatedCellWidth = cellColWidths.reduce((acc, cellColWidth)=>acc + cellColWidth, 0);
    return cellColWidths.map((cellColWidth)=>width * (cellColWidth / totalCalculatedCellWidth));
};
const $4576868a86155c44$export$d231dfb66a75f6c1 = (tr, { useColwidthRatios: useColwidthRatios = false } = {})=>{
    // get the colspans
    const rowColSpans = (0, $hCON4.maphElem)(tr, (cell)=>Number(cell.getAttribute('colspan') || 1 /* default to span of 1 */ ));
    // Chrome has trouble aligning borders with auto tables
    // and the rest of the page grid. tables with defined
    // column widths align fine.
    //
    // eg a 4x25% table might end up as 189px 190px 190px 190px
    //
    // prefer copying the widths via the DOM
    // or inferring from the next row if one exists
    const copyTarget = tr.nextElementSibling || tr;
    if (copyTarget) {
        // either from the first row while it's still in the table
        const cellInfos = (0, $hCON4.maphElem)(copyTarget, (cell)=>({
                width: cell.getBoundingClientRect().width,
                colspan: Number(cell.getAttribute('colspan') || 1),
                colwidth: cell.dataset.colwidth
            }));
        // reverse engineer cell widths from table widths
        const domBasedCellWidths = [];
        cellInfos.map((cell)=>{
            domBasedCellWidths.push(...useColwidthRatios ? $4576868a86155c44$var$getRelativeDomCellWidths(cell) : new Array(cell.colspan).fill(cell.width / cell.colspan));
        });
        if (cellInfos.reduce((acc, cell)=>acc + cell.width, 0) !== 0) {
            const newWidths = $4576868a86155c44$var$mapTableColwidthsToRow(rowColSpans, domBasedCellWidths);
            return newWidths.map((px)=>`${px}px`).join(' ');
        }
    }
    // as a fallback, just calculate a %, and hope that
    // it aligns perfectly in the user's browser
    const visualColCount = rowColSpans.reduce((acc, val)=>acc + val, 0);
    const pctWidths = rowColSpans.map((cellColSpan)=>cellColSpan / visualColCount * 100);
    return pctWidths.map((pct)=>`${pct}%`).join(' ');
};
const $4576868a86155c44$export$b8d525853cd49bde = (cellElement, mouseEvent, columnIndexRange)=>{
    var _cellElement$dataset$;
    const { startIndex: startIndex, endIndex: endIndex } = columnIndexRange;
    const columnCount = endIndex - startIndex;
    if (columnCount <= 0) return undefined;
    const cellRect = cellElement.getBoundingClientRect();
    if (mouseEvent.clientX < cellRect.left || mouseEvent.clientX >= cellRect.right) return undefined;
    // Read DOM ratios here to avoid resolving the ProseMirror node on this mouse-move path.
    const ratios = (_cellElement$dataset$ = cellElement.dataset.colwidth) === null || _cellElement$dataset$ === void 0 ? void 0 : _cellElement$dataset$.split(',').map(Number).filter((value)=>!Number.isNaN(value));
    const perColumnWidths = $4576868a86155c44$export$e4820f63cd163896(cellRect.width, columnCount, ratios);
    const offsetFromLeft = mouseEvent.clientX - cellRect.left;
    let cumulativeWidth = 0;
    for(let column = 0; column < columnCount; column++){
        cumulativeWidth += perColumnWidths[column];
        if (offsetFromLeft < cumulativeWidth) return startIndex + column;
    }
    return endIndex - 1;
};
const $4576868a86155c44$export$b53a50910add7502 = (htmlColIndex, htmlRowIndex, tableMap)=>{
    // Same numbers (positions) in tableMap.map array mean that there are merged cells.
    // Cells can be merged across columns. So we need to check if the cell on the left and current cell have the same value.
    // Cells can be merged acroll rows. So we need to check if the cell above has the same value as current cell.
    // When cell has the same value as the cell above it or the cell to the left of it, html cellIndex won't count it a separete column.
    const width = tableMap.width;
    const map = tableMap.map;
    let htmlColCount = 0;
    if (htmlRowIndex === 0) for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    else for(let colIndex = 0; colIndex < width; colIndex++){
        const currentCellMapIndex = htmlRowIndex * width + colIndex;
        const cellAboveMapIndex = (htmlRowIndex - 1) * width + colIndex;
        if (colIndex > 0) {
            if (map[currentCellMapIndex] !== map[currentCellMapIndex - 1] && map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        } else if (map[currentCellMapIndex] !== map[cellAboveMapIndex]) htmlColCount++;
        if (htmlColCount - 1 === htmlColIndex) return colIndex;
    }
    return 0;
};
const $4576868a86155c44$export$ffa56ed053ef832e = (convertedColIndex, htmlRowIndex, tableMap)=>{
    const width = tableMap.width;
    const map = tableMap.map;
    const mapColIndexToFistRowColIndex = [];
    let htmlColCounFirstRow = 0;
    let colSpan = 0;
    if (htmlRowIndex === 0) return convertedColIndex;
    for(let colIndex = 0; colIndex < width; colIndex++){
        if (colIndex === 0 || map[colIndex] !== map[colIndex - 1]) {
            if (colSpan > 0) {
                htmlColCounFirstRow += colSpan;
                colSpan = 0;
            }
            htmlColCounFirstRow++;
        } else if (map[colIndex] === map[colIndex - 1]) colSpan++;
        mapColIndexToFistRowColIndex[colIndex] = htmlColCounFirstRow - 1;
    }
    return mapColIndexToFistRowColIndex[convertedColIndex];
};

});
parcelRegister("4Tw3G", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundColor", () => $399d0a96a9dd541b$export$3efa753685336605);
$parcel$export(module.exports, "tableHeaderCellBackgroundColor", () => $399d0a96a9dd541b$export$95883e661e73a1d1);
$parcel$export(module.exports, "tableTextColor", () => $399d0a96a9dd541b$export$14da8da34a807702);
$parcel$export(module.exports, "tableBorderColor", () => $399d0a96a9dd541b$export$60473ec4f7c2b794);
$parcel$export(module.exports, "tableCellSelectedColor", () => $399d0a96a9dd541b$export$f26d047169b4195d);
$parcel$export(module.exports, "tableHeaderCellSelectedColor", () => $399d0a96a9dd541b$export$7c0a2e8110d12a28);
$parcel$export(module.exports, "tableToolbarSelectedColor", () => $399d0a96a9dd541b$export$8c5dd0fc35774ae1);
$parcel$export(module.exports, "tableBorderSelectedColor", () => $399d0a96a9dd541b$export$9bf0891aaaf2fecb);
$parcel$export(module.exports, "tableCellSelectedDeleteIconColor", () => $399d0a96a9dd541b$export$a699493d7d7580c3);
$parcel$export(module.exports, "tableCellSelectedDeleteIconBackground", () => $399d0a96a9dd541b$export$cd5e5900c9fa42dc);
$parcel$export(module.exports, "tableCellDeleteColor", () => $399d0a96a9dd541b$export$3c2a828febe9d506);
$parcel$export(module.exports, "tableBorderDeleteColor", () => $399d0a96a9dd541b$export$870d72a5700e711d);
$parcel$export(module.exports, "tableToolbarDeleteColor", () => $399d0a96a9dd541b$export$e7bba7ffd7bf3c50);
$parcel$export(module.exports, "tableCellHoverDeleteIconColor", () => $399d0a96a9dd541b$export$6cc2aa96833a5989);
$parcel$export(module.exports, "tableCellHoverDeleteIconBackground", () => $399d0a96a9dd541b$export$9907ca2ad437ddcc);
$parcel$export(module.exports, "tableBorderRadiusSize", () => $399d0a96a9dd541b$export$371da7842ff35a5b);
$parcel$export(module.exports, "tablePadding", () => $399d0a96a9dd541b$export$e5ff276883773ffd);
$parcel$export(module.exports, "tableScrollbarOffset", () => $399d0a96a9dd541b$export$92421f8864c287b1);
$parcel$export(module.exports, "tableInsertColumnButtonSize", () => $399d0a96a9dd541b$export$6d23b13c5fcb846c);
$parcel$export(module.exports, "tableDeleteButtonSize", () => $399d0a96a9dd541b$export$cb376ed67c7ae37e);
$parcel$export(module.exports, "tableToolbarSize", () => $399d0a96a9dd541b$export$a4d60e31f4f6188b);
$parcel$export(module.exports, "tableControlsSpacing", () => $399d0a96a9dd541b$export$880976487022eb5);
$parcel$export(module.exports, "tableInsertColumnButtonOffset", () => $399d0a96a9dd541b$export$73b1242ebdcc73be);
$parcel$export(module.exports, "lineMarkerSize", () => $399d0a96a9dd541b$export$a3e71c692f2c2213);
$parcel$export(module.exports, "columnControlsDecorationHeight", () => $399d0a96a9dd541b$export$62374dd2f63076b0);
$parcel$export(module.exports, "columnControlsZIndex", () => $399d0a96a9dd541b$export$da0ccd381b1a80f);
$parcel$export(module.exports, "columnControlsSelectedZIndex", () => $399d0a96a9dd541b$export$83da30a15600a83e);
$parcel$export(module.exports, "rowControlsZIndex", () => $399d0a96a9dd541b$export$45aeeddcedd441ab);
$parcel$export(module.exports, "insertLineWidth", () => $399d0a96a9dd541b$export$cc7ed656b7dcf729);
$parcel$export(module.exports, "resizeHandlerAreaWidth", () => $399d0a96a9dd541b$export$72409f838e9c33c7);
$parcel$export(module.exports, "resizeLineWidth", () => $399d0a96a9dd541b$export$45d9825f76985b4e);
$parcel$export(module.exports, "resizeHandlerZIndex", () => $399d0a96a9dd541b$export$887c1388be90c08e);
$parcel$export(module.exports, "contextualMenuTriggerSize", () => $399d0a96a9dd541b$export$3969371f057ce1e5);
$parcel$export(module.exports, "contextualMenuDropdownWidthDnD", () => $399d0a96a9dd541b$export$42d9040c5091b076);
$parcel$export(module.exports, "stickyRowZIndex", () => $399d0a96a9dd541b$export$1279af870a198fea);
$parcel$export(module.exports, "stickyRowOffsetTop", () => $399d0a96a9dd541b$export$83c60dd0aac17107);
$parcel$export(module.exports, "stickyHeaderBorderBottomWidth", () => $399d0a96a9dd541b$export$13b0e72269a9a3aa);
$parcel$export(module.exports, "tablePopupMenuFitHeight", () => $399d0a96a9dd541b$export$3cdde837cf189e96);
$parcel$export(module.exports, "tableColumnControlsHeight", () => $399d0a96a9dd541b$export$9c3151841258b6f0);
$parcel$export(module.exports, "nativeStickyHeaderZIndex", () => $399d0a96a9dd541b$export$a13fb25a398e2fab);
$parcel$export(module.exports, "aboveNativeStickyHeaderZIndex", () => $399d0a96a9dd541b$export$471fb2a0b2f2f936);
$parcel$export(module.exports, "belowNativeStickyHeaderZIndex", () => $399d0a96a9dd541b$export$7b64f35449327c05);
$parcel$export(module.exports, "loweredNativeStickyHeaderZIndex", () => $399d0a96a9dd541b$export$a75adbf84669723);
$parcel$export(module.exports, "tableDangerOverlayZIndex", () => $399d0a96a9dd541b$export$5cc4e76d5fc88d14);
$parcel$export(module.exports, "tableContentZIndexOffset", () => $399d0a96a9dd541b$export$af05f3dfb2eb325);
$parcel$export(module.exports, "dropTargetsZIndex", () => $399d0a96a9dd541b$export$b2015400488f9243);
$parcel$export(module.exports, "TABLE_SNAP_GAP", () => $399d0a96a9dd541b$export$8f6133b6e2b4291);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_GAP", () => $399d0a96a9dd541b$export$edb1b9caf8ff5b32);
$parcel$export(module.exports, "TABLE_HIGHLIGHT_TOLERANCE", () => $399d0a96a9dd541b$export$7af5c65e392a647);
$parcel$export(module.exports, "TABLE_GUIDELINE_VISIBLE_ADJUSTMENT", () => $399d0a96a9dd541b$export$858d012f03ae70a5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_SORT_GROUP_HEIGHT", () => $399d0a96a9dd541b$export$a13bd817a2eda041);
$parcel$export(module.exports, "TABLE_DRAG_MENU_PADDING_TOP", () => $399d0a96a9dd541b$export$e0140c2b978caac5);
$parcel$export(module.exports, "TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT", () => $399d0a96a9dd541b$export$c6a9e7014cf7aedc);
$parcel$export(module.exports, "dragMenuDropdownWidth", () => $399d0a96a9dd541b$export$963fb187132ee7cf);
$parcel$export(module.exports, "dragTableInsertColumnButtonSize", () => $399d0a96a9dd541b$export$d18320cc8ee69115);
$parcel$export(module.exports, "dropTargetExtendedWidth", () => $399d0a96a9dd541b$export$6bec1f8a2aa82be8);
$parcel$export(module.exports, "dragRowControlsWidth", () => $399d0a96a9dd541b$export$c2ef52861254b274);
$parcel$export(module.exports, "colorPalletteColumns", () => $399d0a96a9dd541b$export$2c18704a8d793cdb);
$parcel$export(module.exports, "colorPaletteColumns", () => $399d0a96a9dd541b$export$587c16b31343afe4);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $YREXK = parcelRequire("YREXK");
const $399d0a96a9dd541b$export$3efa753685336605 = "var(--ds-surface, #FFFFFF)";
const $399d0a96a9dd541b$export$95883e661e73a1d1 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $399d0a96a9dd541b$export$1b578d7ab4fc0385 = "var(--ds-background-neutral-subtle, #00000000)";
const $399d0a96a9dd541b$export$14da8da34a807702 = "var(--ds-text-subtlest, #6B6E76)";
const $399d0a96a9dd541b$export$60473ec4f7c2b794 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $399d0a96a9dd541b$export$5aac4cb73ae3f2da = "var(--ds-background-neutral, #0515240F)";
const $399d0a96a9dd541b$export$f26d047169b4195d = "var(--ds-blanket-selected, #388BFF14)";
const $399d0a96a9dd541b$export$7c0a2e8110d12a28 = "var(--ds-background-selected-pressed, #8FB8F6)";
const $399d0a96a9dd541b$export$8c5dd0fc35774ae1 = "var(--ds-background-selected-pressed, #8FB8F6)";
const $399d0a96a9dd541b$export$9bf0891aaaf2fecb = "var(--ds-border-focused, #4688EC)";
const $399d0a96a9dd541b$export$a699493d7d7580c3 = "var(--ds-icon-subtle, #505258)";
const $399d0a96a9dd541b$export$cd5e5900c9fa42dc = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $399d0a96a9dd541b$export$3c2a828febe9d506 = "var(--ds-blanket-danger, #EF5C4814)";
const $399d0a96a9dd541b$export$870d72a5700e711d = "var(--ds-border-danger, #E2483D)";
const $399d0a96a9dd541b$export$e7bba7ffd7bf3c50 = "var(--ds-background-danger-pressed, #FFB8B2)";
const $399d0a96a9dd541b$export$6cc2aa96833a5989 = "var(--ds-icon-inverse, #FFFFFF)";
const $399d0a96a9dd541b$export$9907ca2ad437ddcc = "var(--ds-background-danger-bold, #C9372C)";
const $399d0a96a9dd541b$export$371da7842ff35a5b = 3;
const $399d0a96a9dd541b$export$e5ff276883773ffd = 8;
const $399d0a96a9dd541b$export$92421f8864c287b1 = 15;
const $399d0a96a9dd541b$export$cbcfa4314b903419 = 2;
const $399d0a96a9dd541b$export$6d23b13c5fcb846c = 20;
const $399d0a96a9dd541b$export$cb376ed67c7ae37e = 16;
const $399d0a96a9dd541b$export$52b432855099b8bd = 6;
const $399d0a96a9dd541b$export$a4d60e31f4f6188b = (0, $014x6.akEditorTableToolbarSize);
const $399d0a96a9dd541b$export$880976487022eb5 = (0, $jd8X7.tableMarginTop) + $399d0a96a9dd541b$export$e5ff276883773ffd - (0, $jd8X7.tableCellBorderWidth);
const $399d0a96a9dd541b$export$73b1242ebdcc73be = 3;
const $399d0a96a9dd541b$export$86dfc955b6099b88 = 32;
const $399d0a96a9dd541b$export$893fc0cfd2a0c40e = 13;
const $399d0a96a9dd541b$export$a3e71c692f2c2213 = 4;
const $399d0a96a9dd541b$export$62374dd2f63076b0 = 25;
const $399d0a96a9dd541b$export$da0ccd381b1a80f = (0, $014x6.akEditorUnitZIndex) * 10;
const $399d0a96a9dd541b$export$83da30a15600a83e = $399d0a96a9dd541b$export$da0ccd381b1a80f + 1;
const $399d0a96a9dd541b$export$45aeeddcedd441ab = (0, $014x6.akEditorUnitZIndex) * 10;
const $399d0a96a9dd541b$export$5b53cc051bf05434 = $399d0a96a9dd541b$export$83da30a15600a83e + 1;
const $399d0a96a9dd541b$export$cc7ed656b7dcf729 = 3;
const $399d0a96a9dd541b$export$72409f838e9c33c7 = (0, $YREXK.RESIZE_HANDLE_AREA_DECORATION_GAP) / 3;
const $399d0a96a9dd541b$export$45d9825f76985b4e = 2;
const $399d0a96a9dd541b$export$887c1388be90c08e = $399d0a96a9dd541b$export$da0ccd381b1a80f + (0, $014x6.akRichMediaResizeZIndex);
const $399d0a96a9dd541b$export$3969371f057ce1e5 = 16;
const $399d0a96a9dd541b$export$42d9040c5091b076 = 250;
const $399d0a96a9dd541b$export$1279af870a198fea = $399d0a96a9dd541b$export$887c1388be90c08e + 2;
const $399d0a96a9dd541b$export$83c60dd0aac17107 = 8;
const $399d0a96a9dd541b$export$13b0e72269a9a3aa = 1;
const $399d0a96a9dd541b$export$3cdde837cf189e96 = 188;
const $399d0a96a9dd541b$export$9c3151841258b6f0 = 24;
const $399d0a96a9dd541b$export$a13fb25a398e2fab = (0, $014x6.akEditorTableCellOnStickyHeaderZIndex) - 5;
const $399d0a96a9dd541b$export$471fb2a0b2f2f936 = $399d0a96a9dd541b$export$a13fb25a398e2fab + 1;
const $399d0a96a9dd541b$export$7b64f35449327c05 = $399d0a96a9dd541b$export$a13fb25a398e2fab - 1;
const $399d0a96a9dd541b$export$a75adbf84669723 = 90;
const $399d0a96a9dd541b$export$5cc4e76d5fc88d14 = (0, $014x6.akEditorUnitZIndex) * 100;
const $399d0a96a9dd541b$export$af05f3dfb2eb325 = $399d0a96a9dd541b$export$1279af870a198fea - ($399d0a96a9dd541b$export$a75adbf84669723 - (0, $014x6.akEditorUnitZIndex) * 2);
const $399d0a96a9dd541b$export$b2015400488f9243 = 14;
const $399d0a96a9dd541b$export$8f6133b6e2b4291 = 9;
const $399d0a96a9dd541b$export$edb1b9caf8ff5b32 = 10;
const $399d0a96a9dd541b$export$7af5c65e392a647 = 2;
const $399d0a96a9dd541b$export$11cf30061861ec4a = 5;
const $399d0a96a9dd541b$export$858d012f03ae70a5 = -68;
const $399d0a96a9dd541b$export$a13bd817a2eda041 = 92;
const $399d0a96a9dd541b$export$e0140c2b978caac5 = 4;
const $399d0a96a9dd541b$export$c6a9e7014cf7aedc = 6;
const $399d0a96a9dd541b$export$963fb187132ee7cf = 250;
const $399d0a96a9dd541b$export$d18320cc8ee69115 = 16;
const $399d0a96a9dd541b$export$6bec1f8a2aa82be8 = 150;
const $399d0a96a9dd541b$export$c2ef52861254b274 = 14;
const $399d0a96a9dd541b$export$2c18704a8d793cdb = 7;
const $399d0a96a9dd541b$export$587c16b31343afe4 = 10;
const $399d0a96a9dd541b$export$150cd2564fec30b7 = 8;

});


parcelRegister("eEepd", function(module, exports) {
$parcel$export(module.exports, "getRowHeights", () => $f0bc543bad552c19$export$3e5149a60ac7416b);
$parcel$export(module.exports, "getRenderedRowNumberLabels", () => $f0bc543bad552c19$export$ca0a3e8bbfd3158);
$parcel$export(module.exports, "getRowsParams", () => $f0bc543bad552c19$export$b8127ab1acaa6d46);
$parcel$export(module.exports, "getRowIndexByMousePosition", () => $f0bc543bad552c19$export$6fa6c264fb9023fb);
$parcel$export(module.exports, "copyPreviousRow", () => $f0bc543bad552c19$export$173c92a3a1ff68a7);

var $g2vOy = parcelRequire("g2vOy");

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");
var $he7e7 = parcelRequire("he7e7");

var $l5gi8 = parcelRequire("l5gi8");

var $dRkX9 = parcelRequire("dRkX9");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");
const $f0bc543bad552c19$export$3e5149a60ac7416b = (tableRef)=>{
    const heights = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        // filter out widget children (e.g. anchor widgets) of table body
        const rows = (0, $dRkX9.fg)('platform_editor_ai_show_diff_patch_2') ? Array.from(tableBody.childNodes).filter((node)=>node instanceof HTMLTableRowElement) : tableBody.childNodes;
        for(let i = 0, count = rows.length; i < count; i++){
            // remove as cast when cleaning up platform_editor_ai_show_diff_patch_2
            const row = rows[i];
            heights[i] = row.getBoundingClientRect().height + 1;
            // padding only gets applied when the container has sticky
            if (row.classList.contains('sticky') && i === 0) {
                const styles = window.getComputedStyle(row);
                const paddingTop = (0, $g2vOy.parsePx)(styles.paddingTop || '');
                heights[i] -= paddingTop ? paddingTop + 1 : 1;
            }
        }
    }
    return heights;
};
const $f0bc543bad552c19$var$getRowNumberLabel = (rowIndex, hasHeaderRow)=>{
    if (!hasHeaderRow) return rowIndex + 1;
    return rowIndex > 0 ? rowIndex : null;
};
const $f0bc543bad552c19$export$ca0a3e8bbfd3158 = (tableRef, hasHeaderRow)=>{
    const rowNumberLabels = [];
    const tableBody = tableRef.querySelector('tbody');
    if (tableBody) {
        let nextRowIndex = 0;
        const rows = Array.from(tableBody.childNodes).filter((node)=>node instanceof HTMLTableRowElement);
        for(let i = 0, count = rows.length; i < count; i++){
            const row = rows[i];
            if (row.hasAttribute('data-show-diff-table-row-replacement')) {
                rowNumberLabels.push($f0bc543bad552c19$var$getRowNumberLabel(nextRowIndex, hasHeaderRow));
                continue;
            }
            const rowIndex = nextRowIndex++;
            rowNumberLabels.push($f0bc543bad552c19$var$getRowNumberLabel(rowIndex, hasHeaderRow));
        }
    }
    return rowNumberLabels;
};
const $f0bc543bad552c19$export$b0ece9f607a8bda1 = (rowsHeights, selection, offsetTop = 0)=>{
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!rect) return null;
    let height = 0;
    let offset = offsetTop;
    // find the rows before the selection
    for(let i = 0; i < rect.top; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) offset += rowHeight - 1;
    }
    // these are the selected rows widths
    const indexes = [];
    for(let i = rect.top; i < rect.bottom; i++){
        const rowHeight = rowsHeights[i];
        if (rowHeight) {
            height += rowHeight - 1;
            indexes.push(i);
        }
    }
    const top = offset + height / 2 - (0, $4Tw3G.tableDeleteButtonSize) / 2;
    return {
        top: top,
        indexes: indexes
    };
};
const $f0bc543bad552c19$export$b8127ab1acaa6d46 = (rowsHeights)=>{
    const rows = [];
    for(let i = 0, count = rowsHeights.length; i < count; i++){
        const height = rowsHeights[i];
        if (!height) continue;
        let endIndex = rowsHeights.length;
        for(let k = i + 1, count = rowsHeights.length; k < count; k++)if (rowsHeights[k]) {
            endIndex = k;
            break;
        }
        rows.push({
            startIndex: i,
            endIndex: endIndex,
            height: height
        });
    }
    return rows;
};
const $f0bc543bad552c19$export$6fa6c264fb9023fb = (tableRef, mouseEvent, rowIndexRange)=>{
    const tableBody = tableRef.querySelector('tbody');
    if (!tableBody) return undefined;
    const rows = tableBody.children;
    const startIndex = (rowIndexRange === null || rowIndexRange === void 0 ? void 0 : rowIndexRange.startIndex) ?? 0;
    const endIndex = Math.min((rowIndexRange === null || rowIndexRange === void 0 ? void 0 : rowIndexRange.endIndex) ?? rows.length, rows.length);
    if (startIndex >= endIndex) return undefined;
    const firstRowRect = rows[startIndex].getBoundingClientRect();
    if (mouseEvent.clientY < firstRowRect.top) return undefined;
    let rowBottom = firstRowRect.bottom;
    if (mouseEvent.clientY < rowBottom) return startIndex;
    for(let rowIndex = startIndex + 1; rowIndex < endIndex; rowIndex++){
        const rowRect = rows[rowIndex].getBoundingClientRect();
        rowBottom = rowRect.bottom;
        if (mouseEvent.clientY < rowBottom) return rowIndex;
    }
    return undefined;
};
const $f0bc543bad552c19$export$8969ab96fc5961ae = (index, selection, hoveredRows = [], isInDanger, isResizing)=>{
    const classNames = [];
    if ((0, $he7e7.isRowSelected)(index)(selection) || hoveredRows.indexOf(index) > -1 && !isResizing) {
        classNames.push((0, $YREXK.TableCssClassName).HOVERED_CELL_ACTIVE);
        if (isInDanger) classNames.push((0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER);
    }
    return classNames.join(' ');
};
const $f0bc543bad552c19$export$173c92a3a1ff68a7 = (schema)=>(insertNewRowIndex)=>(tr)=>{
            const table = (0, $5n2u9.findTable)(tr.selection);
            if (!table) return tr;
            const map = (0, $dpooP.TableMap).get(table.node);
            const copyPreviousRowIndex = insertNewRowIndex - 1;
            if (insertNewRowIndex <= 0) throw Error(`Row Index less or equal 0 isn't not allowed since there is not a previous to copy`);
            if (insertNewRowIndex > map.height) return tr;
            const tableNode = table.node;
            const { nodes: { tableRow: tableRow } } = schema;
            const cellsInRow = map.cellsInRect({
                left: 0,
                right: map.width,
                top: copyPreviousRowIndex,
                bottom: copyPreviousRowIndex + 1
            });
            const offsetIndexPosition = copyPreviousRowIndex * map.width;
            const offsetNextLineIndexPosition = insertNewRowIndex * map.width;
            const cellsPositionsInOriginalRow = map.map.slice(offsetIndexPosition, offsetIndexPosition + map.width);
            const cellsPositionsInNextRow = map.map.slice(offsetNextLineIndexPosition, offsetNextLineIndexPosition + map.width);
            const cells = [];
            const fixRowspans = [];
            for(let i = 0; i < cellsPositionsInOriginalRow.length;){
                const pos = cellsPositionsInOriginalRow[i];
                const documentCellPos = pos + table.start;
                const node = tr.doc.nodeAt(documentCellPos);
                if (!node) continue;
                const attributes = {
                    ...node.attrs,
                    colspan: 1,
                    rowspan: 1
                };
                const newCell = node.type.createAndFill(attributes);
                if (!newCell) return tr;
                if (cellsPositionsInNextRow.indexOf(pos) > -1) fixRowspans.push({
                    pos: documentCellPos,
                    node: node
                });
                else if (cellsInRow.indexOf(pos) > -1) {
                    if (node.attrs.colspan > 1) {
                        const newCellWithColspanFixed = node.type.createAndFill({
                            ...attributes,
                            colspan: node.attrs.colspan
                        });
                        if (!newCellWithColspanFixed) return tr;
                        cells.push(newCellWithColspanFixed);
                        i = i + node.attrs.colspan;
                        continue;
                    }
                    cells.push(newCell);
                } else cells.push(newCell);
                i++;
            }
            fixRowspans.forEach((cell)=>{
                tr.setNodeMarkup(cell.pos, undefined, {
                    ...cell.node.attrs,
                    rowspan: cell.node.attrs.rowspan + 1
                });
            });
            const cloneRow = tableNode.child(copyPreviousRowIndex);
            let rowPos = table.start;
            for(let i = 0; i < insertNewRowIndex; i++)rowPos += tableNode.child(i).nodeSize;
            return (0, $a4TQr.safeInsert)(tableRow.createChecked(cloneRow.attrs, cells, cloneRow.marks), rowPos)(tr);
        };

});
parcelRegister("he7e7", function(module, exports) {
$parcel$export(module.exports, "isRowSelected", () => $e56494997e3ac9ee$export$710e11cf672b86c);

var $dpooP = parcelRequire("dpooP");

var $4UJOR = parcelRequire("4UJOR");

var $2HFfw = parcelRequire("2HFfw");
const $e56494997e3ac9ee$export$710e11cf672b86c = (rowIndex)=>(selection)=>{
        if ((0, $2HFfw.isSelectionType)(selection, 'cell')) {
            const map = (0, $dpooP.TableMap).get(selection.$anchorCell.node(-1));
            return (0, $4UJOR.isRectSelected)({
                left: 0,
                right: map.width,
                top: rowIndex,
                bottom: rowIndex + 1
            })(selection);
        }
        return false;
    };

});




parcelRegister("9xQxI", function(module, exports) {
$parcel$export(module.exports, "scaleTableTo", () => $7e008de5aca065b7$export$5de2ae9923ce5a0);
$parcel$export(module.exports, "previewScaleTable", () => $7e008de5aca065b7$export$2d57109fc9066ba2);
$parcel$export(module.exports, "scaleTable", () => $7e008de5aca065b7$export$edcf1a404e75ce35);

var $k5JVX = parcelRequire("k5JVX");

var $gOOOo = parcelRequire("gOOOo");

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $04vvT = parcelRequire("04vvT");

var $4WYVI = parcelRequire("4WYVI");

var $7SttP = parcelRequire("7SttP");

var $5403f = parcelRequire("5403f");

var $26jxM = parcelRequire("26jxM");

var $7Xzpg = parcelRequire("7Xzpg");

var $7JtQD = parcelRequire("7JtQD");
// Base function to trigger the actual scale on a table node.
// Will only resize/scale if a table has been previously resized.
const $7e008de5aca065b7$var$scale = (tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const { node: node, containerWidth: containerWidth, previousContainerWidth: previousContainerWidth, prevNode: prevNode, start: start, layoutChanged: layoutChanged, isTableResizingEnabled: isTableResizingEnabled } = options;
    const maxSize = isTableResizingEnabled ? (0, $k5JVX.getTableContainerWidth)(node) : (0, $7SttP.getLayoutSize)(node.attrs.layout, containerWidth, {});
    const prevTableWidth = (0, $4WYVI.getTableWidth)(prevNode);
    const previousMaxSize = isTableResizingEnabled ? (0, $k5JVX.getTableContainerWidth)(node) : (0, $7SttP.getLayoutSize)(prevNode.attrs.layout, previousContainerWidth, {});
    let newWidth = maxSize;
    // adjust table width if layout is updated
    const hasOverflow = prevTableWidth > previousMaxSize;
    if (layoutChanged && hasOverflow) {
        // No keep overflow if the old content can be in the new size
        const canFitInNewSize = prevTableWidth < maxSize;
        if (canFitInNewSize) newWidth = maxSize;
        else {
            // Keep the same scale.
            const overflowScale = prevTableWidth / previousMaxSize;
            newWidth = Math.floor(newWidth * overflowScale);
        }
    }
    if (node.attrs.isNumberColumnEnabled) newWidth -= (0, $014x6.akEditorTableNumberColumnWidth);
    const resizeState = (0, $26jxM.getResizeState)({
        minWidth: (0, $jd8X7.tableCellMinWidth),
        maxSize: maxSize,
        table: node,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    return $7e008de5aca065b7$export$5de2ae9923ce5a0(resizeState, newWidth);
};
const $7e008de5aca065b7$var$scaleWithParent = (tableRef, parentWidth, table, start, domAtPos, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>{
    const resizeState = (0, $26jxM.getResizeState)({
        minWidth: (0, $jd8X7.tableCellMinWidth),
        maxSize: parentWidth,
        table: table,
        tableRef: tableRef,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor
    });
    if (table.attrs.isNumberColumnEnabled) parentWidth -= (0, $014x6.akEditorTableNumberColumnWidth);
    return $7e008de5aca065b7$export$5de2ae9923ce5a0(resizeState, Math.floor(parentWidth));
};
function $7e008de5aca065b7$export$5de2ae9923ce5a0(state, maxSize) {
    const scaleFactor = maxSize / (0, $26jxM.getTotalWidth)(state);
    let newState = {
        ...state,
        maxSize: maxSize,
        cols: state.cols.map((col)=>{
            const { minWidth: minWidth, width: width } = col;
            let newColWidth = Math.floor(width * scaleFactor);
            if (newColWidth < minWidth) newColWidth = minWidth;
            return {
                ...col,
                width: newColWidth
            };
        })
    };
    const newTotalWidth = (0, $26jxM.getTotalWidth)(newState);
    if (newTotalWidth > maxSize) newState = (0, $5403f.reduceSpace)(newState, newTotalWidth - maxSize);
    return (0, $26jxM.adjustColumnsWidths)(newState, maxSize);
}
const $7e008de5aca065b7$export$2d57109fc9066ba2 = (tableRef, options, domAtPos, isTableScalingEnabled = false, allowFixedColumnWidthOption = false, isCommentOrChromelessEditor = false)=>{
    const { node: node, start: start, parentWidth: parentWidth } = options;
    if (!tableRef) return;
    if (parentWidth) {
        const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
        const width = isNumberColumnEnabled ? parentWidth - (0, $014x6.akEditorTableNumberColumnWidth) : parentWidth;
        tableRef.style.width = `${width}px`;
    }
    let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && allowFixedColumnWidthOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = isTableScalingEnabled && node.attrs.displayMode !== 'fixed';
    // If the table hasn't been resize, the colgroup 48px width values will gracefully scale down.
    // If we are scaling the table down with isTableScalingEnabled, the colgroup widths may be scaled to a value that is not 48px.
    if (!(0, $7Xzpg.hasTableBeenResized)(node) && !isTableScalingEnabledOnCurrentTable) {
        (0, $7JtQD.syncStickyRowToTable)(tableRef);
        return;
    }
    const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentOrChromelessEditor;
    const resizeState = parentWidth ? $7e008de5aca065b7$var$scaleWithParent(tableRef, parentWidth, node, start, domAtPos, false, // Here isTableScalingEnabled = false
    shouldUseIncreasedScalingPercent) : $7e008de5aca065b7$var$scale(tableRef, options, domAtPos, false, shouldUseIncreasedScalingPercent);
    if (resizeState) (0, $26jxM.updateColgroup)(resizeState, tableRef, node, false, 1);
};
const $7e008de5aca065b7$export$edcf1a404e75ce35 = (tableRef, options, domAtPos, api, isTableScalingEnabledOnCurrentTable = false, shouldUseIncreasedScalingPercent = false, isCommentOrChromelessEditor = false)=>(tr)=>{
        if (!tableRef) return tr;
        const { node: node, start: start, parentWidth: parentWidth, layoutChanged: layoutChanged } = options;
        // If a table has not been resized yet, columns should be auto.
        if ((0, $7Xzpg.hasTableBeenResized)(node) === false) {
            // If its not a re-sized table, we still want to re-create cols
            // To force reflow of columns upon delete.
            if (!isTableScalingEnabledOnCurrentTable) {
                const isTableScalingEnabled = false;
                (0, $7Xzpg.insertColgroupFromNode)(tableRef, node, isTableScalingEnabled, undefined, shouldUseIncreasedScalingPercent, isCommentOrChromelessEditor);
            }
            tr.setMeta('scrollIntoView', false);
            return tr;
        }
        let resizeState;
        if (parentWidth) {
            var _tableRef$closest;
            // When the table is nested inside a bodiedSyncBlock, the table's outer transparent
            // left/right borders (1px total under `border-collapse: collapse`) cause the
            // table's outer width to exceed the colgroup width by 1px. Subtract 1px from the
            // parentWidth here so that the scaled colgroup fits within the sync-block
            // container without overflowing.
            const isNestedInBodiedSyncBlock = !!((_tableRef$closest = tableRef.closest) !== null && _tableRef$closest !== void 0 && _tableRef$closest.call(tableRef, `.${(0, $gOOOo.BodiedSyncBlockSharedCssClassName).content}`));
            const BORDER_COLLAPSE_WIDTH_PX = 1;
            const adjustedParentWidth = isNestedInBodiedSyncBlock ? parentWidth - BORDER_COLLAPSE_WIDTH_PX : parentWidth;
            resizeState = $7e008de5aca065b7$var$scaleWithParent(tableRef, adjustedParentWidth, node, start, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        } else resizeState = $7e008de5aca065b7$var$scale(tableRef, options, domAtPos, isTableScalingEnabledOnCurrentTable, shouldUseIncreasedScalingPercent);
        if (resizeState) {
            tr = (0, $04vvT.updateColumnWidths)(resizeState, node, start, api)(tr);
            if (tr.docChanged) {
                tr.setMeta('scrollIntoView', false);
                // TODO: ED-8995 - We need to do this check to reduce the number of race conditions when working with tables.
                // This metadata is been used in the sendTransaction function in the Collab plugin
                /* Added !layoutChanged check here to solve unnecessary scroll bar after publish when click on breakout button multiple times and publish
             scaleTable is only called once every time a breakout button is clicked, so it is safe not to add the meta 'scaleTable' to the tr.
             Leaving the tr.setMeta('scaleTable', true) here for race conditions that we aren't aware of.
           */ !layoutChanged && tr.setMeta('scaleTable', true);
                return tr;
            }
        }
        return tr;
    };

});
parcelRegister("5403f", function(module, exports) {
$parcel$export(module.exports, "growColumn", () => $bf8f1fb83e39331b$export$276e2d0f37ca319a);
$parcel$export(module.exports, "shrinkColumn", () => $bf8f1fb83e39331b$export$99e30963fc7d1a1e);
$parcel$export(module.exports, "reduceSpace", () => $bf8f1fb83e39331b$export$827dd2d6fa38543e);

var $7m0jn = parcelRequire("7m0jn");

var $26jxM = parcelRequire("26jxM");
const $bf8f1fb83e39331b$export$276e2d0f37ca319a = (state, colIndex, amount, selectedColumns)=>{
    // can't grow if columns don't exist or it's the last column
    if (!state.cols[colIndex] || !state.cols[colIndex + 1]) return state;
    const res = $bf8f1fb83e39331b$var$moveSpaceFrom(state, colIndex + 1, colIndex, amount);
    const remaining = amount - res.amount;
    let newState = res.state;
    if (remaining > 0) newState = $bf8f1fb83e39331b$var$stackSpace(newState, colIndex, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $26jxM.bulkColumnsResize)(newState, selectedColumns, colIndex);
    return newState;
};
const $bf8f1fb83e39331b$export$99e30963fc7d1a1e = (state, colIndex, amount, selectedColumns)=>{
    // can't shrink if columns don't exist
    if (!state.cols[colIndex]) return state;
    // try to shrink dragging column by giving from the column to the right first
    const res = $bf8f1fb83e39331b$var$moveSpaceFrom(state, colIndex, colIndex + 1, -amount);
    let newState = res.state;
    const isOverflownTable = (0, $26jxM.getTotalWidth)(newState) > newState.maxSize;
    const isLastColumn = !newState.cols[colIndex + 1];
    // stop resizing the last column once table is not overflown
    if (isLastColumn && !isOverflownTable) return newState;
    const remaining = amount + res.amount;
    if (remaining < 0) newState = $bf8f1fb83e39331b$var$stackSpace(newState, colIndex + 1, remaining).state;
    if (selectedColumns && selectedColumns.length > 1) return (0, $26jxM.bulkColumnsResize)(newState, selectedColumns, colIndex);
    return newState;
};
function $bf8f1fb83e39331b$export$827dd2d6fa38543e(state, amount, ignoreCols = []) {
    let remaining = amount;
    // keep trying to resolve resize request until we run out of free space,
    // or nothing to resize
    while(remaining > 0){
        // filter candidates only with free space
        const candidates = state.cols.filter((column)=>{
            return (0, $7m0jn.getFreeSpace)(column) && ignoreCols.indexOf(column.index) === -1;
        });
        if (candidates.length === 0) break;
        const requestedResize = Math.floor(remaining / candidates.length);
        if (requestedResize === 0) break;
        candidates.forEach((candidate)=>{
            let newWidth = candidate.width - requestedResize;
            if (newWidth < candidate.minWidth) {
                // If the new requested width is less than our min
                // Calc what width we didn't use, we'll try extract that
                // from other cols.
                const remainder = candidate.minWidth - newWidth;
                newWidth = candidate.minWidth;
                remaining = remaining - requestedResize + remainder;
            } else remaining -= requestedResize;
            state = {
                ...state,
                cols: [
                    ...state.cols.slice(0, candidate.index),
                    {
                        ...candidate,
                        width: newWidth
                    },
                    ...state.cols.slice(candidate.index + 1)
                ]
            };
        });
    }
    return state;
}
var $bf8f1fb83e39331b$var$ColType = /*#__PURE__*/ function(ColType) {
    ColType["SOURCE"] = "src";
    ColType["DEST"] = "dest";
    return ColType;
}($bf8f1fb83e39331b$var$ColType || {});
// TODO: ED-26961 - should handle when destIdx:
// - is beyond the range, and then not give it back
function $bf8f1fb83e39331b$var$moveSpaceFrom(state, srcIdx, destIdx, amount, useFreeSpace = true) {
    const srcCol = state.cols[srcIdx];
    const destCol = state.cols[destIdx];
    if (useFreeSpace) {
        const freeSpace = (0, $7m0jn.getFreeSpace)(srcCol);
        // if taking more than source column's free space, only take that much
        if ($bf8f1fb83e39331b$var$amountFor("dest")(amount) > freeSpace) amount = amount > 0 ? freeSpace : -freeSpace;
    }
    // if the source column shrinks past its min size, don't give the space away
    if ($bf8f1fb83e39331b$var$amountFor("src")(amount) < 0 && $bf8f1fb83e39331b$var$widthFor("src")(amount, srcCol, destCol) < srcCol.minWidth) amount = srcCol.width - srcCol.minWidth;
    const newDest = destCol ? {
        ...destCol,
        width: $bf8f1fb83e39331b$var$widthFor("dest")(amount, srcCol, destCol)
    } : undefined;
    if (!newDest && $bf8f1fb83e39331b$var$amountFor("src")(amount) < 0) {
        // non-zero-sum game, ensure that we're not removing more than the total table width either
        const totalWidth = (0, $26jxM.getTotalWidth)(state);
        if (totalWidth - srcCol.width + $bf8f1fb83e39331b$var$widthFor("src")(amount, srcCol, destCol) < state.maxSize) // would shrink table below max width, stop it
        amount = state.maxSize - (totalWidth - srcCol.width) - srcCol.width - 1;
    }
    const newSrc = {
        ...srcCol,
        width: $bf8f1fb83e39331b$var$widthFor("src")(amount, srcCol, destCol)
    };
    const newCols = state.cols.map((existingCol, idx)=>idx === srcIdx ? newSrc : idx === destIdx ? newDest : existingCol).filter(Boolean);
    return {
        state: {
            ...state,
            cols: newCols
        },
        amount: amount
    };
}
function $bf8f1fb83e39331b$var$stackSpace(state, destIdx, amount) {
    let candidates = $bf8f1fb83e39331b$var$getCandidates(state, destIdx, amount);
    while(candidates.length && amount){
        // search for most (or least) free space in candidates
        const candidateIdx = $bf8f1fb83e39331b$var$findNextFreeColumn(candidates, amount);
        if (candidateIdx === -1) {
            // stack to the right -> growing the dragging column and go overflow
            if (amount > 0) return {
                state: {
                    ...state,
                    cols: [
                        ...state.cols.slice(0, destIdx),
                        {
                            ...state.cols[destIdx],
                            width: state.cols[destIdx].width + amount
                        },
                        ...state.cols.slice(destIdx + 1)
                    ]
                },
                remaining: amount
            };
            break;
        }
        const column = candidates.find((col)=>col.index === candidateIdx);
        if (!column || (0, $7m0jn.getFreeSpace)(column) <= 0) break;
        const res = $bf8f1fb83e39331b$var$moveSpaceFrom(state, column.index, destIdx, amount);
        state = res.state;
        amount -= res.amount;
        candidates = candidates.filter((col)=>col.index !== candidateIdx);
    }
    return {
        state: state,
        remaining: amount
    };
}
function $bf8f1fb83e39331b$var$findNextFreeColumn(columns, amount) {
    if (columns.length === 0) return -1;
    const direction = amount < 0 ? 'left' : 'right';
    if (direction === 'left') columns = columns.slice().reverse();
    let freeIndex = -1;
    columns.forEach((column)=>{
        if ((0, $7m0jn.getFreeSpace)(column) && freeIndex === -1) freeIndex = column.index;
    });
    if (freeIndex === -1) return -1;
    return freeIndex;
}
function $bf8f1fb83e39331b$var$amountFor(colType) {
    return (amount)=>colType === "src" ? amount > 0 ? -amount : amount : amount < 0 ? -amount : amount;
}
function $bf8f1fb83e39331b$var$widthFor(colType) {
    return (amount, srcCol, destCol)=>(colType === "src" ? srcCol : destCol).width + $bf8f1fb83e39331b$var$amountFor(colType)(amount);
}
function $bf8f1fb83e39331b$var$getCandidates(state, destIdx, amount) {
    const candidates = state.cols;
    // only consider rows after the selected column in the direction of resize
    return amount < 0 ? candidates.slice(0, destIdx) : candidates.slice(destIdx + 1);
}
function $bf8f1fb83e39331b$export$a2e757ac5c4f573f(resizeState, colIndex, resizeAmount) {
    const updatedCols = resizeState.cols.map((col, index)=>{
        if (index === colIndex) {
            const newWidth = Math.max(col.width + resizeAmount, col.minWidth);
            return {
                ...col,
                width: newWidth
            };
        }
        return col;
    });
    return {
        ...resizeState,
        tableWidth: updatedCols.reduce((acc, col)=>acc + col.width, 0),
        cols: updatedCols
    };
}

});



parcelRegister("l1ZbO", function(module, exports) {
$parcel$export(module.exports, "createTableWithWidth", () => $e8188168fbba3c52$export$5003ecb973fc11c2);

var $9KukJ = parcelRequire("9KukJ");

var $eyG1M = parcelRequire("eyG1M");
const $e8188168fbba3c52$var$NESTED_TABLE_DEFAULT_ROWS = 2;
const $e8188168fbba3c52$var$NESTED_TABLE_DEFAULT_COLS = 2;
const $e8188168fbba3c52$export$5003ecb973fc11c2 = ({ isTableScalingEnabled: isTableScalingEnabled, isTableAlignmentEnabled: isTableAlignmentEnabled, isFullWidthModeEnabled: isFullWidthModeEnabled, isMaxWidthModeEnabled: isMaxWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, isTableResizingEnabled: isTableResizingEnabled, isNestedTable: isNestedTable, createTableProps: createTableProps })=>(schema)=>{
        const attrsOverrides = {};
        if (isNestedTable) {
            attrsOverrides.rowsCount = createTableProps !== null && createTableProps !== void 0 && createTableProps.rowsCount ? createTableProps === null || createTableProps === void 0 ? void 0 : createTableProps.rowsCount : $e8188168fbba3c52$var$NESTED_TABLE_DEFAULT_ROWS;
            attrsOverrides.colsCount = createTableProps !== null && createTableProps !== void 0 && createTableProps.colsCount ? createTableProps === null || createTableProps === void 0 ? void 0 : createTableProps.colsCount : $e8188168fbba3c52$var$NESTED_TABLE_DEFAULT_COLS;
        }
        if (isTableScalingEnabled && !isCommentEditor) {
            if (isMaxWidthModeEnabled) attrsOverrides.tableWidth = (0, $eyG1M.TABLE_MAX_WIDTH);
            else if (isFullWidthModeEnabled) attrsOverrides.tableWidth = (0, $eyG1M.TABLE_FULL_WIDTH);
        }
        if (isTableAlignmentEnabled && (isFullWidthModeEnabled || isMaxWidthModeEnabled || isCommentEditor)) attrsOverrides.layout = 'align-start';
        if (isCommentEditor && isTableResizingEnabled || isChromelessEditor) attrsOverrides.tableWidth = 'inherit';
        return (0, $9KukJ.createTable)({
            schema: schema,
            ...createTableProps,
            ...attrsOverrides
        });
    };

});
parcelRegister("9KukJ", function(module, exports) {
$parcel$export(module.exports, "createTable", () => $f0aebfc5a0aa166b$export$33bbb3ec7652e187);

var $9HFsx = parcelRequire("9HFsx");

var $8uRHy = parcelRequire("8uRHy");
const $f0aebfc5a0aa166b$var$createCell = (cellType, cellContent)=>{
    if (cellContent) return cellType.createChecked(null, cellContent);
    return cellType.createAndFill();
};
const $f0aebfc5a0aa166b$export$33bbb3ec7652e187 = ({ schema: schema, rowsCount: rowsCount = 3, colsCount: colsCount = 3, withHeaderRow: withHeaderRow = true, cellContent: cellContent, tableWidth: tableWidth, layout: // default to undefined so PM will use default value defined in schema
layout })=>{
    const { cell: tableCell, header_cell: tableHeader, row: tableRow, table: table } = (0, $9HFsx.tableNodeTypes)(schema);
    const cells = [];
    const headerCells = [];
    for(let i = 0; i < colsCount; i++){
        const cell = $f0aebfc5a0aa166b$var$createCell(tableCell, cellContent);
        if (cell) cells.push(cell);
        if (withHeaderRow) {
            const headerCell = $f0aebfc5a0aa166b$var$createCell(tableHeader, cellContent);
            if (headerCell) headerCells.push(headerCell);
        }
    }
    const rows = [];
    for(let i = 0; i < rowsCount; i++)rows.push(tableRow.createChecked(null, withHeaderRow && i === 0 ? headerCells : cells));
    const width = tableWidth === 'inherit' ? undefined : tableWidth === undefined ? 760 : tableWidth;
    return table.createChecked({
        localId: (0, $8uRHy.uuid).generate(),
        width: width,
        layout: layout
    }, rows);
};

});
parcelRegister("8uRHy", function(module, exports) {
$parcel$export(module.exports, "uuid", () => $8f85f6735e356e15$export$31b40729666a4ae0);
/**
 * Direct copy from adf-schema to kill circular dependency without pulling into
 * a new package
 */ /* eslint-disable no-bitwise */ const $8f85f6735e356e15$export$1c3aefb711c3a4cc = ()=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $8f85f6735e356e15$var$staticValue = false;
const $8f85f6735e356e15$export$31b40729666a4ae0 = {
    setStatic (value) {
        $8f85f6735e356e15$var$staticValue = value;
    },
    generate () {
        return $8f85f6735e356e15$var$staticValue || $8f85f6735e356e15$export$1c3aefb711c3a4cc();
    }
};

});



parcelRegister("eaKZu", function(module, exports) {
$parcel$export(module.exports, "getAllowAddColumnCustomStep", () => $5f1cf5b7355ec390$export$f8ddfdc64e14a808);

var $4GJqd = parcelRequire("4GJqd");
function $5f1cf5b7355ec390$export$f8ddfdc64e14a808(state) {
    const tablePluginState = (0, $4GJqd.getPluginState)(state);
    return Boolean(tablePluginState) && Boolean(tablePluginState.pluginConfig.allowAddColumnWithCustomStep);
}

});


parcelRegister("d9DFt", function(module, exports) {
$parcel$export(module.exports, "pluginConfig", () => $83f8ddac7fcdcec4$export$c23fbabe48bd9130);
const $83f8ddac7fcdcec4$export$c23fbabe48bd9130 = (config = {})=>{
    return config.advanced ? {
        allowBackgroundColor: true,
        allowColumnResizing: true,
        allowHeaderColumn: true,
        allowHeaderRow: true,
        allowMergeCells: true,
        allowNumberColumn: true,
        permittedLayouts: 'all',
        allowControls: true,
        ...config
    } : config;
};

});

parcelRegister("a1g0P", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $9ac1c8a458e1f98f$export$ae829ec7b2625219);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $1y7gE = parcelRequire("1y7gE");

var $16ZMX = parcelRequire("16ZMX");

var $ev7OZ = parcelRequire("ev7OZ");

var $kk4Aa = parcelRequire("kk4Aa");

var $99qNq = parcelRequire("99qNq");

var $4eT7o = parcelRequire("4eT7o");

var $2LIY4 = parcelRequire("2LIY4");

var $c8sLM = parcelRequire("c8sLM");

var $gXHCV = parcelRequire("gXHCV");

var $aEmSo = parcelRequire("aEmSo");

var $gzpzh = parcelRequire("gzpzh");

var $4GJqd = parcelRequire("4GJqd");

var $4dyXt = parcelRequire("4dyXt");

var $7Xzpg = parcelRequire("7Xzpg");

var $6lkZH = parcelRequire("6lkZH");

var $1l6nN = parcelRequire("1l6nN");

var $fmUHX = parcelRequire("fmUHX");

var $ecxo1 = parcelRequire("ecxo1");

var $cwJ2b = parcelRequire("cwJ2b");

var $jH0fQ = parcelRequire("jH0fQ");

var $HfCkc = parcelRequire("HfCkc");

var $eU2qH = parcelRequire("eU2qH");

var $fo4aC = parcelRequire("fo4aC");
const $9ac1c8a458e1f98f$var$destroyFn = (editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)=>{
    const editorPageScrollContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    const rowAutoScrollers = editorPageScrollContainer ? [
        (0, $c8sLM.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type } = source.data;
                return type === 'table-row';
            },
            onDragStart () {
                var _insm$session;
                (_insm$session = (0, $4eT7o.insm).session) === null || _insm$session === void 0 || _insm$session.startFeature('tableDragAndDrop');
                // auto scroller doesn't work when scroll-behavior: smooth is set, this monitor temporarily removes it via inline styles
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', 'unset');
            },
            onDrop () {
                var _insm$session2;
                (_insm$session2 = (0, $4eT7o.insm).session) === null || _insm$session2 === void 0 || _insm$session2.endFeature('tableDragAndDrop');
                // 'null' will remove the inline style
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorPageScrollContainer.style.setProperty('scroll-behavior', null);
            }
        }),
        (0, $2LIY4.autoScrollForElements)({
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            element: editorPageScrollContainer,
            canScroll: ({ source: source })=>{
                const { type: type } = source.data;
                return type === 'table-row';
            }
        })
    ] : [];
    return (0, $gXHCV.combine)(...rowAutoScrollers, (0, $c8sLM.monitorForElements)({
        canMonitor ({ source: source }) {
            const { type: type, localId: localId, indexes: indexes } = source.data;
            // First; Perform any quick checks so we can abort early.
            if (!indexes || !localId || !(type === 'table-row' || type === 'table-column')) return false;
            const { tableNode: tableNode } = (0, $4GJqd.getPluginState)(editorView.state);
            // If the draggable localId is the same as the current selected table localId then we will allow the monitor
            // watch for changes
            return localId === (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId);
        },
        onDragStart: ()=>{
            var _insm$session3;
            (_insm$session3 = (0, $4eT7o.insm).session) === null || _insm$session3 === void 0 || _insm$session3.startFeature('tableDragAndDrop');
            if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
                var _api$userIntent;
                (0, $gzpzh.closeActiveTableMenu)(api, {
                    skipUserIntent: true
                })({
                    tr: tr
                });
                api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('dragging')({
                    tr: tr
                });
                return tr;
            });
            else {
                var _api$userIntent2;
                (0, $ecxo1.toggleDragMenu)(false)(editorView.state, editorView.dispatch);
                api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.commands.setCurrentUserIntent('dragging'));
            }
        },
        onDrag (event) {
            var _api$userIntent3;
            const data = (0, $fo4aC.getDraggableDataFromEvent)(event);
            // If no data can be found then it's most like we do not want to perform any drag actions
            if (!data) {
                (0, $ecxo1.clearDropTarget)()(editorView.state, editorView.dispatch);
                return;
            }
            // TODO: ED-26961 - as we drag an element around we are going to want to update the state to acurately reflect the current
            // insert location as to where the draggable will most likely be go. For example;
            const { sourceType: sourceType, targetAdjustedIndex: targetAdjustedIndex } = data;
            const dropTargetType = sourceType === 'table-row' ? (0, $jH0fQ.DropTargetType).ROW : (0, $jH0fQ.DropTargetType).COLUMN;
            const hasMergedCells = (0, $1l6nN.hasMergedCellsInBetween)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], dropTargetType)(editorView.state.selection);
            (0, $ecxo1.setDropTarget)(dropTargetType, targetAdjustedIndex, hasMergedCells)(editorView.state, editorView.dispatch);
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent3 = api.userIntent) === null || _api$userIntent3 === void 0 ? void 0 : _api$userIntent3.commands.setCurrentUserIntent('dragging'));
        },
        onDrop (event) {
            var _api$userIntent4;
            const data = (0, $fo4aC.getDraggableDataFromEvent)(event);
            // On Drop we need to update the table main plugin hoveredCell value with the current row/col that the mouse is
            // over. This is so the drag handles update their positions to correctly align with the users mouse. Unfortunately
            // at this point in time and during the drag opertation, the drop targets are eating all the mouse events so
            // it's not possible to know what row/col the mouse is over (via mouse events). This attempts to locate the nearest cell and
            // then tries to update the main table hoveredCell value by piggy-backing the transaction onto the command
            // triggered by this on drop event.
            const { hoveredCell: hoveredCell } = (0, $4GJqd.getPluginState)(editorView.state);
            const cell = (0, $6lkZH.findNearestCellIndexToPoint)(event.location.current.input.clientX, event.location.current.input.clientY);
            const tr = editorView.state.tr;
            const action = {
                type: 'HOVER_CELL',
                data: {
                    hoveredCell: {
                        rowIndex: (cell === null || cell === void 0 ? void 0 : cell.row) ?? hoveredCell.rowIndex,
                        colIndex: (cell === null || cell === void 0 ? void 0 : cell.col) ?? hoveredCell.colIndex
                    }
                }
            };
            tr.setMeta((0, $4dyXt.pluginKey), action);
            if ((api === null || api === void 0 || (_api$userIntent4 = api.userIntent) === null || _api$userIntent4 === void 0 || (_api$userIntent4 = _api$userIntent4.sharedState.currentState()) === null || _api$userIntent4 === void 0 ? void 0 : _api$userIntent4.currentUserIntent) === 'dragging') {
                var _api$userIntent5;
                api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent5 = api.userIntent) === null || _api$userIntent5 === void 0 ? void 0 : _api$userIntent5.commands.setCurrentUserIntent('default'));
            }
            // If no data can be found then it's most like we do not want to perform any drop action
            if (!data) {
                var _insm$session4, _event$source, _event$source2;
                // If we're able to determine the source type of the dropped element then we should report to analytics that
                // the drop event was cancelled. Otherwise we will cancel silently.
                (_insm$session4 = (0, $4eT7o.insm).session) === null || _insm$session4 === void 0 || _insm$session4.endFeature('tableDragAndDrop');
                if ((event === null || event === void 0 || (_event$source = event.source) === null || _event$source === void 0 || (_event$source = _event$source.data) === null || _event$source === void 0 ? void 0 : _event$source.type) === 'table-row' || (event === null || event === void 0 || (_event$source2 = event.source) === null || _event$source2 === void 0 || (_event$source2 = _event$source2.data) === null || _event$source2 === void 0 ? void 0 : _event$source2.type) === 'table-column') {
                    var _event$source$data;
                    return (0, $cwJ2b.clearDropTargetWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, event.source.data.type, (_event$source$data = event.source.data) === null || _event$source$data === void 0 ? void 0 : _event$source$data.indexes, (0, $8d4kB.TABLE_STATUS).CANCELLED, tr)(editorView.state, editorView.dispatch);
                }
                return (0, $ecxo1.clearDropTarget)(tr)(editorView.state, editorView.dispatch);
            }
            const { sourceType: sourceType, sourceIndexes: sourceIndexes, targetIndex: targetIndex, targetAdjustedIndex: targetAdjustedIndex, targetDirection: targetDirection, direction: direction, behaviour: behaviour } = data;
            // When we drop on a target we will know the targets row/col index for certain,
            if (sourceType === 'table-row') action.data.hoveredCell.rowIndex = targetIndex;
            else action.data.hoveredCell.colIndex = targetIndex;
            // If the drop target index contains merged cells then we should not allow the drop to occur.
            if ((0, $1l6nN.hasMergedCellsInBetween)([
                targetAdjustedIndex - 1,
                targetAdjustedIndex
            ], sourceType === 'table-row' ? (0, $jH0fQ.DropTargetType).ROW : (0, $jH0fQ.DropTargetType).COLUMN)(editorView.state.selection)) {
                var _insm$session5;
                (0, $cwJ2b.clearDropTargetWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, // This event is mrked as invalid because the user is attempting to drop an element in an area which has merged cells.
                (0, $8d4kB.TABLE_STATUS).INVALID, tr)(editorView.state, editorView.dispatch);
                (_insm$session5 = (0, $4eT7o.insm).session) === null || _insm$session5 === void 0 || _insm$session5.endFeature('tableDragAndDrop');
                return;
            }
            requestAnimationFrame(()=>{
                var _insm$session6;
                if (behaviour === 'clone') (0, $cwJ2b.cloneSourceWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetIndex, targetDirection, tr)(editorView.state, editorView.dispatch);
                else (0, $cwJ2b.moveSourceWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).DRAG_AND_DROP, sourceType, sourceIndexes, targetAdjustedIndex + (direction === 1 ? -1 : 0), tr)(editorView.state, editorView.dispatch);
                // force a colgroup update here, otherwise dropped columns don't have
                // the correct width immediately after the drop
                if (sourceType === 'table-column') {
                    const { tableRef: tableRef, tableNode: tableNode } = (0, $4GJqd.getPluginState)(editorView.state);
                    if (tableRef && tableNode) {
                        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
                        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
                        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = tableNode.attrs.displayMode !== 'fixed';
                        if (isTableScalingEnabled && isCommentEditor) isTableScalingEnabledOnCurrentTable = true;
                        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
                        (0, $7Xzpg.insertColgroupFromNode)(tableRef, tableNode, isTableScalingEnabledOnCurrentTable, undefined, shouldUseIncreasedScalingPercent, isCommentEditor);
                    }
                }
                editorView.focus();
                (_insm$session6 = (0, $4eT7o.insm).session) === null || _insm$session6 === void 0 || _insm$session6.endFeature('tableDragAndDrop');
            });
        }
    }));
};
const $9ac1c8a458e1f98f$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, api)=>{
    return new (0, $1y7gE.SafePlugin)({
        state: (0, $HfCkc.createPluginState)(dispatch, ()=>({
                decorationSet: (0, $16ZMX.DecorationSet).empty,
                dropTargetType: (0, $jH0fQ.DropTargetType).NONE,
                dropTargetIndex: 0,
                isDragMenuOpen: false,
                dragMenuIndex: 0,
                isDragging: false,
                isKeyboardModeActive: false
            })),
        key: (0, $eU2qH.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const { targetCellPosition: oldTargetCellPosition } = (0, $4GJqd.getPluginState)(oldState);
            const { targetCellPosition: newTargetCellPosition } = (0, $4GJqd.getPluginState)(newState);
            const { isDragMenuOpen: isDragMenuOpen = false, dragMenuIndex: dragMenuIndex } = (0, $HfCkc.getPluginState)(newState);
            transactions.forEach((transaction)=>{
                if (transaction.getMeta('selectedRowViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-row');
                    if (button) button.focus();
                }
                if (transaction.getMeta('selectedColumnViaKeyboard')) {
                    const button = document.querySelector('#drag-handle-button-column');
                    if (button) button.focus();
                }
            });
            // What's happening here? you asked... In a nutshell;
            // If the target cell position changes while the drag menu is open then we want to close the drag menu if it has been opened.
            // This will stop the drag menu from moving around the screen to different row/cols. Too achieve this we need
            // to check if the new target cell position is pointed at a different cell than what the drag menu was opened on.
            if (oldTargetCellPosition !== newTargetCellPosition) {
                if (isDragMenuOpen) {
                    const tr = newState.tr;
                    const action = {
                        type: (0, $fmUHX.DragAndDropActionType).TOGGLE_DRAG_MENU,
                        data: {
                            isDragMenuOpen: false,
                            direction: undefined
                        }
                    };
                    if (newTargetCellPosition !== undefined) {
                        const cells = (0, $99qNq.getCellsInRow)(dragMenuIndex)(tr.selection);
                        // TODO: ED-20673 - check if it is a cell selection,
                        // when true, a drag handle is clicked and isDragMenuOpen is true here
                        // should not close the drag menu.
                        const isCellSelection = tr.selection instanceof (0, $ev7OZ.CellSelection);
                        if (cells && cells.length && cells[0].node !== tr.doc.nodeAt(newTargetCellPosition) && !isCellSelection) return tr.setMeta((0, $eU2qH.pluginKey), action);
                         // else NOP
                    } else return tr.setMeta((0, $eU2qH.pluginKey), action);
                }
            }
        },
        view: (editorView)=>{
            return {
                destroy: $9ac1c8a458e1f98f$var$destroyFn(editorView, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, api)
            };
        },
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = (0, $HfCkc.getPluginState)(state);
                return decorationSet;
            },
            handleKeyDown: (view, event)=>{
                var _ref;
                const { state: { tr: tr } } = view;
                const keysToTrapWhen = [
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft',
                    'ArrowRight'
                ];
                /** fix for NCS spam update where the user is holding down the move column / row keyboard shortcut
         * if the user is holding down shortcut (ctrl + shift + alt + arrowKey), we want to move the selection only once
         * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
         */ // Do early check for the keys we want to trap here so we can abort early
                if (event.ctrlKey && event.shiftKey && event.altKey) {
                    const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $kk4Aa.getSelectedCellInfo)(tr.selection);
                    const isRowOrColumnSelected = horizontalCells === totalColumnCount || verticalCells === totalRowCount;
                    if (isRowOrColumnSelected && keysToTrapWhen.includes(event.key) && event.repeat) return true;
                }
                const isDragHandleFocused = [
                    'drag-handle-button-row',
                    'drag-handle-button-column'
                ].includes((_ref = event.target || null) === null || _ref === void 0 ? void 0 : _ref.id);
                const keysToTrap = [
                    'Enter',
                    ' '
                ];
                const { isDragMenuOpen: isDragMenuOpen = false } = (0, $HfCkc.getPluginState)(view.state);
                // drag handle is focused, and user presses any key return them back to editing
                if (isDragHandleFocused && !isDragMenuOpen && !keysToTrap.includes(event.key)) {
                    view.dom.focus();
                    return true;
                }
                if (isDragHandleFocused && keysToTrap.includes(event.key) || isDragMenuOpen && keysToTrapWhen.includes(event.key)) return true;
            }
        }
    });
};

});
parcelRegister("kk4Aa", function(module, exports) {
$parcel$export(module.exports, "getSelectedCellInfo", () => $2861ca62e3e2f701$export$277d5394a2608229);

var $95fXi = parcelRequire("95fXi");

var $l5gi8 = parcelRequire("l5gi8");
function $2861ca62e3e2f701$export$277d5394a2608229(selection) {
    let horizontalCells = 1;
    let verticalCells = 1;
    let totalCells = 1;
    const { table: table, map: map, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $95fXi.getSelectedTableInfo)(selection);
    if (table && map) {
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        if (rect) {
            totalCells = map.cellsInRect(rect).length;
            horizontalCells = rect.right - rect.left;
            verticalCells = rect.bottom - rect.top;
        }
    }
    return {
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount,
        horizontalCells: horizontalCells,
        verticalCells: verticalCells,
        totalCells: totalCells
    };
}

});

parcelRegister("gzpzh", function(module, exports) {
$parcel$export(module.exports, "closeActiveTableMenu", () => $a819fcd7f6a2a244$export$68481d8823bb24fb);
$parcel$export(module.exports, "toggleActiveTableMenu", () => $a819fcd7f6a2a244$export$5744ca63af11af1a);

var $4dyXt = parcelRequire("4dyXt");

var $2q9QJ = parcelRequire("2q9QJ");
const $a819fcd7f6a2a244$var$applyMenuUserIntent = (tr, api, nextActiveTableMenu)=>{
    var _api$userIntent2;
    if (nextActiveTableMenu.type === 'row' || nextActiveTableMenu.type === 'column') {
        var _api$userIntent;
        api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('tableDragMenuPopupOpen')({
            tr: tr
        });
        return;
    }
    api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || _api$userIntent2.commands.setCurrentUserIntent((0, $2q9QJ.isFullRowOrColumnSelected)(tr.selection) ? 'dragHandleSelected' : 'default')({
        tr: tr
    });
};
const $a819fcd7f6a2a244$export$68481d8823bb24fb = (api, options)=>({ tr: tr })=>{
        const nextActiveTableMenu = {
            type: 'none'
        };
        tr.setMeta((0, $4dyXt.pluginKey), {
            type: 'SET_ACTIVE_TABLE_MENU',
            data: {
                activeTableMenu: nextActiveTableMenu
            }
        });
        if (!(options !== null && options !== void 0 && options.skipUserIntent)) $a819fcd7f6a2a244$var$applyMenuUserIntent(tr, api, nextActiveTableMenu);
        if (!tr.docChanged) tr.setMeta('addToHistory', false);
        return tr;
    };
const $a819fcd7f6a2a244$var$isSameActiveTableMenu = (current, next)=>{
    if (!current || current.type !== next.type) return false;
    if (current.type === 'row' || current.type === 'column') return next.type === current.type && current.index === next.index;
    return true;
};
const $a819fcd7f6a2a244$export$5744ca63af11af1a = (activeTableMenu, currentActiveTableMenu, api)=>({ tr: tr })=>{
        const nextActiveTableMenu = $a819fcd7f6a2a244$var$isSameActiveTableMenu(currentActiveTableMenu, activeTableMenu) ? {
            type: 'none'
        } : activeTableMenu;
        tr.setMeta((0, $4dyXt.pluginKey), {
            type: 'SET_ACTIVE_TABLE_MENU',
            data: {
                activeTableMenu: nextActiveTableMenu
            }
        });
        $a819fcd7f6a2a244$var$applyMenuUserIntent(tr, api, nextActiveTableMenu);
        tr.setMeta('addToHistory', false);
        return tr;
    };

});
parcelRegister("2q9QJ", function(module, exports) {
$parcel$export(module.exports, "getSelectedColumnIndexes", () => $22ef354414e770e7$export$915a77877be361e9);
$parcel$export(module.exports, "getSelectedRowIndexes", () => $22ef354414e770e7$export$d023456f91fdf995);
$parcel$export(module.exports, "isColumnSelectionWithMergedFirstRow", () => $22ef354414e770e7$export$dcbd781e48a8c658);
$parcel$export(module.exports, "isColumnSelectionWithMergedLastRow", () => $22ef354414e770e7$export$3d0ce64cd294a195);
$parcel$export(module.exports, "isRowSelectionWithMergedFirstColumn", () => $22ef354414e770e7$export$8e35aa0e81c25478);
$parcel$export(module.exports, "isFullRowOrColumnSelected", () => $22ef354414e770e7$export$3a10391c7abbe1c8);

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $5JFXS = parcelRequire("5JFXS");

var $l5gi8 = parcelRequire("l5gi8");
const $22ef354414e770e7$export$915a77877be361e9 = (selectionRect)=>{
    const columnIndexes = [];
    for(let i = selectionRect.left; i < selectionRect.right; i++)columnIndexes.push(i);
    return columnIndexes;
};
const $22ef354414e770e7$export$d023456f91fdf995 = (selectionRect)=>{
    const rowIndexes = [];
    for(let i = selectionRect.top; i < selectionRect.bottom; i++)rowIndexes.push(i);
    return rowIndexes;
};
const $22ef354414e770e7$export$dcbd781e48a8c658 = (selection)=>{
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!rect) return false;
    const table = (0, $5JFXS.findTableClosestToPos)(selection.$anchorCell);
    if (!table) return false;
    const map = (0, $dpooP.TableMap).get(table.node);
    if (rect.bottom !== map.height || rect.top === 0) return false;
    for(let col = rect.left; col < rect.right; col++){
        const topCellRect = map.findCell(map.map[col]);
        const isHorizontallyMerged = topCellRect.right - topCellRect.left > 1;
        const bridgesGapAboveSelection = topCellRect.bottom >= rect.top;
        if (!isHorizontallyMerged || !bridgesGapAboveSelection) return false;
    }
    return true;
};
const $22ef354414e770e7$export$3d0ce64cd294a195 = (selection)=>{
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!rect) return false;
    const table = (0, $5JFXS.findTableClosestToPos)(selection.$anchorCell);
    if (!table) return false;
    const map = (0, $dpooP.TableMap).get(table.node);
    if (rect.top !== 0 || rect.bottom === map.height) return false;
    for(let col = rect.left; col < rect.right; col++){
        const bottomCellRect = map.findCell(map.map[(map.height - 1) * map.width + col]);
        const isHorizontallyMerged = bottomCellRect.right - bottomCellRect.left > 1;
        const bridgesGapBelowSelection = bottomCellRect.top <= rect.bottom;
        if (!isHorizontallyMerged || !bridgesGapBelowSelection) return false;
    }
    return true;
};
const $22ef354414e770e7$export$8e35aa0e81c25478 = (selection)=>{
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!rect) return false;
    const table = (0, $5JFXS.findTableClosestToPos)(selection.$anchorCell);
    if (!table) return false;
    const map = (0, $dpooP.TableMap).get(table.node);
    if (rect.right !== map.width || rect.left === 0) return false;
    for(let row = rect.top; row < rect.bottom; row++){
        const leftCellRect = map.findCell(map.map[row * map.width]);
        const isVerticallyMerged = leftCellRect.bottom - leftCellRect.top > 1;
        const bridgesGapLeftOfSelection = leftCellRect.right >= rect.left;
        if (!isVerticallyMerged || !bridgesGapLeftOfSelection) return false;
    }
    return true;
};
const $22ef354414e770e7$export$3a10391c7abbe1c8 = (selection)=>{
    if (!(selection instanceof (0, $ev7OZ.CellSelection))) return false;
    return selection.isRowSelection() || selection.isColSelection() || $22ef354414e770e7$export$8e35aa0e81c25478(selection) || $22ef354414e770e7$export$dcbd781e48a8c658(selection) || $22ef354414e770e7$export$3d0ce64cd294a195(selection);
};

});


parcelRegister("6lkZH", function(module, exports) {
$parcel$export(module.exports, "isCell", () => $336781efe45e6d09$export$835df158d20ae2f0);
$parcel$export(module.exports, "isCornerButton", () => $336781efe45e6d09$export$94cf9243187b20f0);
$parcel$export(module.exports, "isInsertRowButton", () => $336781efe45e6d09$export$7a8d111d40fb198c);
$parcel$export(module.exports, "getColumnOrRowIndex", () => $336781efe45e6d09$export$e5e82c478fd9ea3);
$parcel$export(module.exports, "getIndexAttributeSourceElement", () => $336781efe45e6d09$export$a1261fc41ec5bc0f);
$parcel$export(module.exports, "isColumnControlsDecorations", () => $336781efe45e6d09$export$14eb53395cc0cf57);
$parcel$export(module.exports, "isRowControlsButton", () => $336781efe45e6d09$export$edad492f0c70264f);
$parcel$export(module.exports, "isResizeHandleDecoration", () => $336781efe45e6d09$export$4cf9002f70d2d324);
$parcel$export(module.exports, "isTableControlsButton", () => $336781efe45e6d09$export$b4f0758743701ac9);
$parcel$export(module.exports, "isTableContainerOrWrapper", () => $336781efe45e6d09$export$2b59104f44ee317b);
$parcel$export(module.exports, "isDragRowFloatingInsertDot", () => $336781efe45e6d09$export$b2ae534578c0ae33);
$parcel$export(module.exports, "isDragColumnFloatingInsertDot", () => $336781efe45e6d09$export$666ae3fd07127e7f);
$parcel$export(module.exports, "isDragCornerButton", () => $336781efe45e6d09$export$571c943db7bc729c);
$parcel$export(module.exports, "isTableDragHandleButton", () => $336781efe45e6d09$export$75641d19d3ee2fef);
$parcel$export(module.exports, "getMousePositionHorizontalRelativeByElement", () => $336781efe45e6d09$export$3dde6150a2e2df0a);
$parcel$export(module.exports, "getMousePositionVerticalRelativeByElement", () => $336781efe45e6d09$export$3bf5911758d564a4);
$parcel$export(module.exports, "hasResizeHandler", () => $336781efe45e6d09$export$80e4fcc9d7220616);
$parcel$export(module.exports, "getTree", () => $336781efe45e6d09$export$b76263aac816aadb);
$parcel$export(module.exports, "getTop", () => $336781efe45e6d09$export$449115d164fc37c3);
$parcel$export(module.exports, "findNearestCellIndexToPoint", () => $336781efe45e6d09$export$fe489db90f7f492a);
$parcel$export(module.exports, "areAllRectsZero", () => $336781efe45e6d09$export$732358707dcc2511);

var $i8LxW = parcelRequire("i8LxW");

var $hCON4 = parcelRequire("hCON4");

var $YREXK = parcelRequire("YREXK");
const $336781efe45e6d09$export$835df158d20ae2f0 = (node)=>{
    return Boolean(node && ([
        'TH',
        'TD'
    ].indexOf(node.tagName) > -1 || !!(0, $hCON4.closestElement)(node, `.${(0, $YREXK.TableCssClassName).TABLE_HEADER_CELL}`) || !!(0, $hCON4.closestElement)(node, `.${(0, $YREXK.TableCssClassName).TABLE_CELL}`)));
};
const $336781efe45e6d09$export$94cf9243187b20f0 = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON);
const $336781efe45e6d09$export$7a8d111d40fb198c = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).CONTROLS_INSERT_ROW) || (0, $hCON4.closestElement)(node, `.${(0, $YREXK.TableCssClassName).CONTROLS_INSERT_ROW}`) || (0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).CONTROLS_BUTTON_OVERLAY) && (0, $hCON4.closestElement)(node, `.${(0, $YREXK.TableCssClassName).ROW_CONTROLS}`);
const $336781efe45e6d09$export$e5e82c478fd9ea3 = (target)=>[
        parseInt(target.getAttribute('data-start-index') || '-1', 10),
        parseInt(target.getAttribute('data-end-index') || '-1', 10)
    ];
const $336781efe45e6d09$export$a1261fc41ec5bc0f = (target)=>{
    if (target.hasAttribute('data-start-index')) return target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const closestWithIndex = target.closest('[data-start-index]');
    return closestWithIndex ?? target;
};
const $336781efe45e6d09$export$14eb53395cc0cf57 = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS);
const $336781efe45e6d09$export$edad492f0c70264f = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON) || (0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON);
const $336781efe45e6d09$export$4cf9002f70d2d324 = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION);
const $336781efe45e6d09$export$b4f0758743701ac9 = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).CONTROLS_BUTTON) || (0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP);
const $336781efe45e6d09$export$2b59104f44ee317b = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).TABLE_CONTAINER) || (0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER);
const $336781efe45e6d09$export$b2ae534578c0ae33 = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER);
const $336781efe45e6d09$export$666ae3fd07127e7f = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER);
const $336781efe45e6d09$export$571c943db7bc729c = (node)=>(0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).DRAG_CORNER_BUTTON) || (0, $i8LxW.containsClassName)(node, (0, $YREXK.TableCssClassName).DRAG_CORNER_BUTTON_INNER);
const $336781efe45e6d09$export$75641d19d3ee2fef = (target)=>target instanceof HTMLElement && Boolean(target.closest(`.${(0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER}`));
const $336781efe45e6d09$export$3dde6150a2e2df0a = (mouseEvent, offsetX, gapInPixels)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const width = element.clientWidth; // reflow
        const x = !Number.isNaN(offsetX) ? offsetX : mouseEvent.offsetX; // reflow
        if (width <= 0) return null;
        if (!gapInPixels) return x / width > 0.5 ? 'right' : 'left';
        else {
            if (x <= gapInPixels) return 'left';
            else if (x >= width - gapInPixels) return 'right';
        }
    }
    return null;
};
const $336781efe45e6d09$export$3bf5911758d564a4 = (mouseEvent)=>{
    const element = mouseEvent.target;
    if (element instanceof HTMLElement) {
        const elementRect = element.getBoundingClientRect();
        if (elementRect.height <= 0) return null;
        const y = mouseEvent.clientY - elementRect.top;
        return y / elementRect.height > 0.5 ? 'bottom' : 'top';
    }
    return null;
};
const $336781efe45e6d09$export$80e4fcc9d7220616 = ({ columnEndIndexTarget: columnEndIndexTarget, target: target })=>{
    const tableElement = (0, $hCON4.closestElement)(target, 'table');
    if (!tableElement) return false;
    const query = [
        `.${(0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION}`,
        `[data-end-index="${columnEndIndexTarget}"]`
    ];
    const decorationElement = tableElement.querySelectorAll(query.join(''));
    if (!decorationElement || decorationElement.length === 0) return false;
    return true;
};
const $336781efe45e6d09$export$b76263aac816aadb = (tr)=>{
    // pm renders into tbody, owned by react
    const tbody = tr.parentElement;
    if (!tbody) return null;
    // rendered by react
    const table = tbody.parentElement;
    if (!table) return null;
    // rendered by react
    const wrapper = table.parentElement;
    if (!wrapper) return null;
    return {
        wrapper: wrapper,
        table: table
    };
};
const $336781efe45e6d09$export$449115d164fc37c3 = (element)=>{
    var _element$getBoundingC;
    if (!element || element instanceof Window) return 0;
    return (element === null || element === void 0 || (_element$getBoundingC = element.getBoundingClientRect) === null || _element$getBoundingC === void 0 || (_element$getBoundingC = _element$getBoundingC.call(element)) === null || _element$getBoundingC === void 0 ? void 0 : _element$getBoundingC.top) ?? 0;
};
const $336781efe45e6d09$export$fe489db90f7f492a = (x, y)=>{
    const elements = document.elementsFromPoint(x, y);
    const cell = elements.find((el)=>el.nodeName.toUpperCase() === 'TD' || el.nodeName.toUpperCase() === 'TH');
    const row = (cell === null || cell === void 0 ? void 0 : cell.parentElement) ?? undefined;
    if (!Number.isFinite(row === null || row === void 0 ? void 0 : row.rowIndex) || !Number.isFinite(cell === null || cell === void 0 ? void 0 : cell.cellIndex)) return undefined;
    return {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        row: row.rowIndex,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        col: cell.cellIndex
    };
};
const $336781efe45e6d09$export$732358707dcc2511 = (entry)=>{
    const rects = [
        entry.boundingClientRect,
        entry.rootBounds,
        entry.intersectionRect
    ];
    return rects.every((rect)=>rect && rect.width === 0 && rect.height === 0 && rect.top === 0 && rect.left === 0 && rect.bottom === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0);
};

});

parcelRegister("1l6nN", function(module, exports) {
$parcel$export(module.exports, "hasMergedCellsInBetween", () => $fd238abbceb0c877$export$6e6c0cf88a287d8);
$parcel$export(module.exports, "hasMergedCellsWithColumnNextToColumnIndex", () => $fd238abbceb0c877$export$834c4ba4fe64e8f2);
$parcel$export(module.exports, "hasMergedCellsWithRowNextToRowIndex", () => $fd238abbceb0c877$export$7ef37f297601e698);
$parcel$export(module.exports, "hasMergedCellsInSelection", () => $fd238abbceb0c877$export$e4c313e419348ae7);
$parcel$export(module.exports, "findDuplicatePosition", () => $fd238abbceb0c877$export$1d4a5608e72f1096);

var $5n2u9 = parcelRequire("5n2u9");

var $dpooP = parcelRequire("dpooP");
const $fd238abbceb0c877$var$getRect = (index, type, map)=>{
    if (type === 'column') {
        const x = Math.max(Math.min(index, map.width - 1), 0); // clamped index
        return {
            left: x,
            right: x === index ? x + 1 : x,
            top: 0,
            bottom: map.height
        };
    } else {
        const y = Math.max(Math.min(index, map.height - 1), 0); // clamped index
        return {
            left: 0,
            right: map.width,
            top: y,
            bottom: y === index ? y + 1 : y
        };
    }
};
const $fd238abbceb0c877$export$6e6c0cf88a287d8 = (indexes, type)=>(selection)=>{
        const table = (0, $5n2u9.findTable)(selection);
        if (!table) return false;
        const map = (0, $dpooP.TableMap).get(table.node);
        const cellPositions = new Set();
        const mergedCells = new Set();
        map.map.forEach((value)=>{
            if (cellPositions.has(value)) mergedCells.add(value);
            else cellPositions.add(value);
        });
        if (!mergedCells.size) return false;
        const getMergedCellsInRect = (index, type)=>{
            const rect = $fd238abbceb0c877$var$getRect(index, type, map);
            const isValidRectangle = rect.left < rect.right && rect.top < rect.bottom;
            if (!isValidRectangle) return [];
            const cells = map.cellsInRect(rect);
            let allCellsInRect = [];
            if (type === 'column') allCellsInRect = map.map.filter((_, key)=>key % map.width === index);
            else allCellsInRect = map.map.filter((_, key)=>Math.floor(key / map.width) === index);
            const mergedCell = allCellsInRect.filter((nodePos)=>{
                return !cells.includes(nodePos) // cell exists in Rect but not show in the map.cellsInRect list => merged cell
                 ? true : mergedCells.has(nodePos); // cell includes in mergedCells => merged cell
            });
            return [
                ...new Set(mergedCell)
            ];
        };
        const mergedCellsInRectArr = indexes.map((index)=>getMergedCellsInRect(index, type));
        // Currently only support 2 indexes, but we can extend this to support more indexes in the future.
        return mergedCellsInRectArr[0].some((cell)=>mergedCellsInRectArr[1].includes(cell));
    };
const $fd238abbceb0c877$export$834c4ba4fe64e8f2 = (colIndex, selection)=>{
    const table = (0, $5n2u9.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $dpooP.TableMap).get(table.node);
    const { width: width } = tableMap;
    if (width <= 1) return false;
    if (colIndex < 0 || colIndex > width - 1) return false;
    const { map: map } = tableMap;
    // j is an index in the tableMap.map array. tableMap.map is a flat array.
    // Each item of this array contains a number.
    // The number represents the position of the corresponding cell in the tableMap. It exists for each cell.
    // If there are merged cells, their positions will be represented by the same number.
    const isFirstColumn = colIndex === 0;
    const isLastColumn = colIndex === width - 1;
    for(let j = colIndex; j < map.length; j += width){
        if (!isFirstColumn && map[j] === map[j - 1] || // compare with a cell in the column on the left
        !isLastColumn && map[j] === map[j + 1] // compare with a cell in the column on the right
        ) return true;
    }
    return false;
};
const $fd238abbceb0c877$export$7ef37f297601e698 = (rowIndex, selection)=>{
    const table = (0, $5n2u9.findTable)(selection);
    if (!table) return false;
    const tableMap = (0, $dpooP.TableMap).get(table.node);
    const { height: height } = tableMap;
    if (height <= 1) return false;
    if (rowIndex < 0 || rowIndex > height - 1) return false;
    const { map: map, width: width } = tableMap; // map is a flat array representing position of each cell in the table.
    const indexOfFirstCellInTheRow = rowIndex * width;
    const indexOfLastCellInTheRow = indexOfFirstCellInTheRow + width - 1;
    const isFirstRow = rowIndex === 0;
    const isLastRow = rowIndex === height - 1;
    // j is an index of a cell in a row
    for(let j = indexOfFirstCellInTheRow; j <= indexOfLastCellInTheRow; j++){
        if (!isFirstRow && map[j] === map[j - width] || // compare with a cell in the row above
        !isLastRow && map[j] === map[j + width] // compare with a cell in the row below
        ) return true;
    }
    return false;
};
const $fd238abbceb0c877$export$e4c313e419348ae7 = (indexes, type)=>(selection)=>{
        const table = (0, $5n2u9.findTable)(selection);
        if (!table) return false;
        const map = (0, $dpooP.TableMap).get(table.node);
        if (!map.hasMergedCells()) return false;
        return $fd238abbceb0c877$export$9af117e01db30223(indexes, map, type);
    };
const $fd238abbceb0c877$export$9af117e01db30223 = (indexes, tableMap, direction)=>{
    const { mapByRow: mapByRow, mapByColumn: mapByColumn } = tableMap;
    const map = 'row' === direction ? mapByRow : mapByColumn;
    const lengthLimiter = direction === 'row' ? tableMap.width : tableMap.height;
    const minIndex = Math.min(...indexes);
    const maxIndex = Math.max(...indexes);
    let isTopSideHaveMergedCells = false;
    let isBottomSideHaveMergedCells = false;
    /**
    * this is to check if the cell position from last focused table is overflow. since if you selection from a cell in 6th row and 7th column cell in a 7x8 table to 3x3 table, the cell position will be overflow because new table dont have this cell at all.
    TODO: ED-22335 this should better called only when hover over the drag handle.
   */ const isOldMinIndex = !map[minIndex - 1] || !map[minIndex];
    const isOldMaxIndex = !map[maxIndex + 1] || !map[maxIndex];
    if (minIndex > 0 && !isOldMinIndex) {
        const prevSelectionSet = map[minIndex - 1];
        const minSelectionSet = map[minIndex];
        for(let i = 0; i < lengthLimiter; i++)if (prevSelectionSet[i] === minSelectionSet[i]) {
            isTopSideHaveMergedCells = true;
            break;
        }
    }
    if (maxIndex < map.length - 1 && !isOldMaxIndex) {
        const afterSelectionSet = map[maxIndex + 1];
        const maxSelectionSet = map[maxIndex];
        for(let i = 0; i < lengthLimiter; i++)if (afterSelectionSet[i] === maxSelectionSet[i]) {
            isBottomSideHaveMergedCells = true;
            break;
        }
    }
    return isTopSideHaveMergedCells || isBottomSideHaveMergedCells;
};
const $fd238abbceb0c877$export$1d4a5608e72f1096 = (array)=>{
    if (!array) return [];
    return array.filter((item, index)=>array.indexOf(item) !== index);
};

});

parcelRegister("fmUHX", function(module, exports) {
$parcel$export(module.exports, "DragAndDropActionType", () => $3716f4d226868c87$export$b6bb967ba58ec81c);
const $3716f4d226868c87$export$b6bb967ba58ec81c = {
    SET_DROP_TARGET: 'SET_DROP_TARGET',
    CLEAR_DROP_TARGET: 'CLEAR_DROP_TARGET',
    TOGGLE_DRAG_MENU: 'TOGGLE_DRAG_MENU'
};

});

parcelRegister("ecxo1", function(module, exports) {
$parcel$export(module.exports, "setDropTarget", () => $3d7fa9147f999bd3$export$a54c991ec4a21b4a);
$parcel$export(module.exports, "clearDropTarget", () => $3d7fa9147f999bd3$export$e74dec9e818a8c0b);
$parcel$export(module.exports, "moveSource", () => $3d7fa9147f999bd3$export$1326c72b3102f66d);
$parcel$export(module.exports, "toggleDragMenu", () => $3d7fa9147f999bd3$export$8a902a12acc69924);
$parcel$export(module.exports, "cloneSource", () => $3d7fa9147f999bd3$export$88277f1015e99c8a);
// eslint-disable-next-line import/order

var $16ZMX = parcelRequire("16ZMX");

var $imbtb = parcelRequire("imbtb");

var $j9703 = parcelRequire("j9703");

var $lvjfs = parcelRequire("lvjfs");

var $hWmsp = parcelRequire("hWmsp");

var $YREXK = parcelRequire("YREXK");

var $ijKnh = parcelRequire("ijKnh");

var $fmUHX = parcelRequire("fmUHX");

var $jH0fQ = parcelRequire("jH0fQ");

var $HfCkc = parcelRequire("HfCkc");

var $eU2qH = parcelRequire("eU2qH");
// TODO: ED-26961 - This command is a placeholder example. Please replace this if required.
const $3d7fa9147f999bd3$var$getDecorations = (state)=>{
    var _pluginKey$getState;
    return ((_pluginKey$getState = (0, $eU2qH.pluginKey).getState(state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.decorationSet) || (0, $16ZMX.DecorationSet).empty;
};
const $3d7fa9147f999bd3$var$updatePluginStateDecorations = (state, decorations, key)=>(0, $ijKnh.updateDecorations)(state.doc, $3d7fa9147f999bd3$var$getDecorations(state), decorations, key);
const $3d7fa9147f999bd3$export$a54c991ec4a21b4a = (type, index, hasMergedCells, tr)=>(0, $HfCkc.createCommand)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $HfCkc.getPluginState)(state);
        if (dropTargetType === type && dropTargetIndex === index) return false;
        let decorationSet = (0, $16ZMX.DecorationSet).empty;
        if (type === 'column') decorationSet = $3d7fa9147f999bd3$var$updatePluginStateDecorations(state, (0, $ijKnh.createColumnInsertLine)(index, state.selection, hasMergedCells), (0, $YREXK.TableDecorations).COLUMN_INSERT_LINE);
        else if (type === 'row') decorationSet = $3d7fa9147f999bd3$var$updatePluginStateDecorations(state, (0, $ijKnh.createRowInsertLine)(index, state.selection, hasMergedCells), (0, $YREXK.TableDecorations).ROW_INSERT_LINE);
        return {
            type: (0, $fmUHX.DragAndDropActionType).SET_DROP_TARGET,
            data: {
                decorationSet: decorationSet,
                type: type,
                index: index
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $3d7fa9147f999bd3$export$e74dec9e818a8c0b = (tr)=>(0, $HfCkc.createCommand)((state)=>{
        const { dropTargetType: dropTargetType, dropTargetIndex: dropTargetIndex } = (0, $HfCkc.getPluginState)(state);
        if (dropTargetType === (0, $jH0fQ.DropTargetType).NONE && dropTargetIndex === 0) return false;
        return {
            type: (0, $fmUHX.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $16ZMX.DecorationSet).empty
            }
        };
    }, (originalTr)=>(tr || originalTr).setMeta('addToHistory', false));
const $3d7fa9147f999bd3$export$1326c72b3102f66d = (sourceType, sourceIndexes, targetIndex, tr)=>(0, $HfCkc.createCommand)((state)=>{
        return {
            type: (0, $fmUHX.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $16ZMX.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        if (sourceIndexes.includes(targetIndex)) return nextTr.setMeta('addToHistory', false);
        const move = sourceType === 'table-row' ? (0, $hWmsp.moveRow) : (0, $lvjfs.moveColumn);
        return move(state, sourceIndexes, targetIndex, {
            selectAfterMove: true
        })(nextTr);
    });
const $3d7fa9147f999bd3$export$8a902a12acc69924 = (isDragMenuOpen, direction, index, trigger = 'mouse')=>(0, $HfCkc.createCommand)((state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $HfCkc.getPluginState)(state);
        if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return false;
        let updatedMenuOpenState;
        if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
        else // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should remain open.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
        else updatedMenuOpenState = !previousOpenState;
        return {
            type: (0, $fmUHX.DragAndDropActionType).TOGGLE_DRAG_MENU,
            data: {
                isDragMenuOpen: updatedMenuOpenState,
                direction: direction ?? previousDragMenuDirection,
                index: index ?? previousDragMenuIndex,
                isKeyboardModeActive: updatedMenuOpenState && trigger === 'keyboard'
            }
        };
    }, (tr)=>{
        return tr.setMeta('addToHistory', false);
    });
const $3d7fa9147f999bd3$export$88277f1015e99c8a = (sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>(0, $HfCkc.createCommand)((state)=>{
        return {
            type: (0, $fmUHX.DragAndDropActionType).CLEAR_DROP_TARGET,
            data: {
                decorationSet: (0, $16ZMX.DecorationSet).empty
            }
        };
    }, (originalTr, state)=>{
        const nextTr = tr || originalTr;
        const clone = sourceType === 'table-row' ? (0, $j9703.cloneRow) : (0, $imbtb.cloneColumn);
        return clone(state, sourceIndexes, targetIndex, targetDirection, {
            selectAfterClone: true
        })(nextTr);
    });

});
parcelRegister("imbtb", function(module, exports) {
$parcel$export(module.exports, "cloneColumn", () => $f62f077ba4fd97e7$export$799175205f855ccd);

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $kkedq = parcelRequire("kkedq");

var $dXesv = parcelRequire("dXesv");

var $5n2u9 = parcelRequire("5n2u9");

var $gEMyR = parcelRequire("gEMyR");

var $dWa93 = parcelRequire("dWa93");

var $9HFsx = parcelRequire("9HFsx");
function $f62f077ba4fd97e7$var$normalizeDirection(targetDirection, options) {
    const override = ((options === null || options === void 0 ? void 0 : options.direction) ?? 0) < 0 ? 'start' : 'end';
    return options !== null && options !== void 0 && options.tryToFit && !!(options !== null && options !== void 0 && options.direction) ? override : targetDirection;
}
const $f62f077ba4fd97e7$export$799175205f855ccd = (state, originColumnIndex, targetColumnIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $dpooP.TableMap).get(table.node);
        const originalColumnRanges = (0, $gEMyR.getSelectionRangeInColumn)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $gEMyR.getSelectionRangeInColumn)(targetColumnIndex)(tr);
        const indexesOriginColumn = (originalColumnRanges === null || originalColumnRanges === void 0 ? void 0 : originalColumnRanges.indexes) ?? [];
        const indexesTargetColumn = (targetColumnRanges === null || targetColumnRanges === void 0 ? void 0 : targetColumnRanges.indexes) ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $dWa93.isValidReorder)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $9HFsx.tableNodeTypes)(state.schema);
        const direction = $f62f077ba4fd97e7$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $kkedq.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
        const createContentNode = $f62f077ba4fd97e7$var$createContentNodeFactory(table);
        const newTr = (0, $dXesv.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $f62f077ba4fd97e7$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            return newTr.insert(insertPos, row.map(({ node: node }, x)=>$f62f077ba4fd97e7$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0 && direction === 'start', types)));
        });
        if (options.selectAfterClone) {
            const offset = direction === 'end' ? 1 : 0;
            const selectionRange = (0, $gEMyR.getSelectionRangeInColumn)(actualTargetIndex + offset, actualTargetIndex + offset + indexesOriginColumn.length - 1)(newTr);
            if (selectionRange) newTr.setSelection(new (0, $ev7OZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $f62f077ba4fd97e7$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $f62f077ba4fd97e7$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $f62f077ba4fd97e7$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}

});
parcelRegister("kkedq", function(module, exports) {
$parcel$export(module.exports, "determineTableHeaderStateFromTableNode", () => $429edab140e1daa5$export$9206f249edb43d1b);
function $429edab140e1daa5$export$9206f249edb43d1b(table, tableMap, types) {
    // We only really need to check the nth (last) cell in the row/col if it's a header, since we only support a single full row/col header on the top & left
    // of a table. We can assume that if the nth (last) cell is also a header then the entire row/col is a header.
    // Be careful though! when checking the 1st cell as it shares its header state with both row/cols.
    // This means we won't be able to reliably identify header state on tables smaller than 2x2, however we can make a best guess.
    // This is a 3 bit mask;
    // bit: 0 = Identifies if the cell at (0, 0) (row, col - 0-based) is a header cell or not
    // bit: 1 = Identifies if the cell at (0, n) is a header cell or not
    // bit: 2 = Identifies if the cell at (n, 0) is a header cell or not
    let mask = 0;
    // At minimum we should have 1 cell in the table.
    const topLeftCell = table.nodeAt(tableMap.map[0]);
    // If this cell is a header that could indicate
    mask |= topLeftCell && topLeftCell.type === types.header_cell ? 1 : 0;
    if (tableMap.width > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width - 1]);
        // If the cell at (0, n) is a header then we set the bit flag to indicate row headers are enabled, otherwise if it's
        // not then we will set the col headers enabled flag (and vice versa in the branch below) only if the cell at (0,0)
        // was a header cell.
        mask |= cell && cell.type === types.header_cell ? 2 : 4 * (mask & 1);
    }
    if (tableMap.height > 1) {
        const cell = table.nodeAt(tableMap.map[tableMap.width * (tableMap.height - 1)]);
        mask |= cell && cell.type === types.header_cell ? 4 : 2 * (mask & 1);
    }
    return {
        rowHeaderEnabled: mask === 7 || mask === 3,
        columnHeaderEnabled: mask === 7 || mask === 5
    };
}

});

parcelRegister("gEMyR", function(module, exports) {
$parcel$export(module.exports, "getSelectionRangeInColumn", () => $422a433fcee2790d$export$7032a6f0de5ecc29);

var $2rErm = parcelRequire("2rErm");

var $99qNq = parcelRequire("99qNq");
const $422a433fcee2790d$export$7032a6f0de5ecc29 = (startColIndex, endColIndex = startColIndex)=>(tr)=>{
        let startIndex = startColIndex;
        let endIndex = endColIndex;
        // looking for selection start column (startIndex)
        for(let i = startColIndex; i >= 0; i--){
            const cells = (0, $2rErm.getCellsInColumn)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end column (endIndex)
        for(let i = startColIndex; i <= endIndex; i++){
            const cells = (0, $2rErm.getCellsInColumn)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.colspan + i - 1;
                if (cell.node.attrs.colspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out columns without cells (where all rows have colspan > 1 in the same column)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $2rErm.getCellsInColumn)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedColumnCells = (0, $2rErm.getCellsInColumn)(startIndex)(tr.selection);
        const firstRowCells = (0, $99qNq.getCellsInRow)(0)(tr.selection);
        if (!firstSelectedColumnCells || !firstRowCells) return;
        const $anchor = tr.doc.resolve(firstSelectedColumnCells[firstSelectedColumnCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const columnCells = (0, $2rErm.getCellsInColumn)(i)(tr.selection);
            if (columnCells && columnCells.length) {
                for(let j = firstRowCells.length - 1; j >= 0; j--)if (firstRowCells[j].pos === columnCells[0].pos) {
                    headCell = columnCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };

});

parcelRegister("dWa93", function(module, exports) {
$parcel$export(module.exports, "isValidReorder", () => $06ec840e210450d4$export$fd791265d075eb03);
const $06ec840e210450d4$export$fd791265d075eb03 = (originIndex, targetIndex, targets, type)=>{
    const direction = originIndex > targetIndex ? -1 : 1;
    const errorMessage = `Target position is invalid, you can't move the ${type} ${originIndex} to ${targetIndex}, the target can't be split. You could use tryToFit option.`;
    if (direction === 1) {
        if (targets.slice(0, targets.length - 1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    } else {
        if (targets.slice(1).indexOf(targetIndex) !== -1) throw new Error(errorMessage);
    }
    return true;
};

});


parcelRegister("j9703", function(module, exports) {
$parcel$export(module.exports, "cloneRow", () => $c820fa219efd5d79$export$94fc9bbbd60f961f);

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $kkedq = parcelRequire("kkedq");

var $dXesv = parcelRequire("dXesv");

var $5n2u9 = parcelRequire("5n2u9");

var $cxdfe = parcelRequire("cxdfe");

var $dWa93 = parcelRequire("dWa93");

var $9HFsx = parcelRequire("9HFsx");
function $c820fa219efd5d79$var$normalizeDirection(targetDirection, options) {
    const override = ((options === null || options === void 0 ? void 0 : options.direction) ?? 0) < 0 ? 'start' : 'end';
    return options !== null && options !== void 0 && options.tryToFit && !!(options !== null && options !== void 0 && options.direction) ? override : targetDirection;
}
const $c820fa219efd5d79$export$94fc9bbbd60f961f = (state, originRowIndex, targetRowIndex, targetDirection, options = {
    tryToFit: false,
    direction: 0,
    selectAfterClone: false
})=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        const tableMap = (0, $dpooP.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $cxdfe.getSelectionRangeInRow)(originMin, originMax)(tr);
        const targetRowRanges = (0, $cxdfe.getSelectionRangeInRow)(targetRowIndex)(tr);
        const indexesOriginRow = (originalRowRanges === null || originalRowRanges === void 0 ? void 0 : originalRowRanges.indexes) || [];
        const indexesTargetRow = (targetRowRanges === null || targetRowRanges === void 0 ? void 0 : targetRowRanges.indexes) || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $dWa93.isValidReorder)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $9HFsx.tableNodeTypes)(state.schema);
        const direction = $c820fa219efd5d79$var$normalizeDirection(targetDirection, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes !== null && originNodes !== void 0 && originNodes.length && targetNode) {
            const newTr = (0, $dXesv.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $kkedq.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
            if (rowHeaderEnabled && actualTargetIndex === 0 && direction === 'start') {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$c820fa219efd5d79$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0 && direction === 'start', columnHeaderEnabled, types)));
            if (options.selectAfterClone) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $cxdfe.getSelectionRangeInRow)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $ev7OZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $c820fa219efd5d79$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}

});
parcelRegister("cxdfe", function(module, exports) {
$parcel$export(module.exports, "getSelectionRangeInRow", () => $d73edaf9f92aa9af$export$550d44f4e6042645);

var $2rErm = parcelRequire("2rErm");

var $99qNq = parcelRequire("99qNq");
const $d73edaf9f92aa9af$export$550d44f4e6042645 = (startRowIndex, endRowIndex = startRowIndex)=>(tr)=>{
        let startIndex = startRowIndex;
        let endIndex = endRowIndex;
        // looking for selection start row (startIndex)
        for(let i = startRowIndex; i >= 0; i--){
            const cells = (0, $99qNq.getCellsInRow)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (maybeEndIndex >= startIndex) startIndex = i;
                if (maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // looking for selection end row (endIndex)
        for(let i = startRowIndex; i <= endIndex; i++){
            const cells = (0, $99qNq.getCellsInRow)(i)(tr.selection);
            if (cells) cells.forEach((cell)=>{
                const maybeEndIndex = cell.node.attrs.rowspan + i - 1;
                if (cell.node.attrs.rowspan > 1 && maybeEndIndex > endIndex) endIndex = maybeEndIndex;
            });
        }
        // filter out rows without cells (where all columns have rowspan > 1 in the same row)
        const indexes = [];
        for(let i = startIndex; i <= endIndex; i++){
            const maybeCells = (0, $99qNq.getCellsInRow)(i)(tr.selection);
            if (maybeCells && maybeCells.length) indexes.push(i);
        }
        startIndex = indexes[0];
        endIndex = indexes[indexes.length - 1];
        const firstSelectedRowCells = (0, $99qNq.getCellsInRow)(startIndex)(tr.selection);
        const firstColumnCells = (0, $2rErm.getCellsInColumn)(0)(tr.selection);
        if (!firstSelectedRowCells || !firstColumnCells) return;
        const $anchor = tr.doc.resolve(firstSelectedRowCells[firstSelectedRowCells.length - 1].pos);
        let headCell;
        for(let i = endIndex; i >= startIndex; i--){
            const rowCells = (0, $99qNq.getCellsInRow)(i)(tr.selection);
            if (rowCells && rowCells.length) {
                for(let j = firstColumnCells.length - 1; j >= 0; j--)if (firstColumnCells[j].pos === rowCells[0].pos) {
                    headCell = rowCells[0];
                    break;
                }
                if (headCell) break;
            }
        }
        if (!headCell) return;
        const $head = tr.doc.resolve(headCell.pos);
        return {
            $anchor: $anchor,
            $head: $head,
            indexes: indexes
        };
    };

});


parcelRegister("lvjfs", function(module, exports) {
$parcel$export(module.exports, "moveColumn", () => $2622c78f7bb704ff$export$d1fbe0eb3fc9219);

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $kkedq = parcelRequire("kkedq");

var $dXesv = parcelRequire("dXesv");

var $5n2u9 = parcelRequire("5n2u9");

var $gEMyR = parcelRequire("gEMyR");

var $dWa93 = parcelRequire("dWa93");

var $boVd1 = parcelRequire("boVd1");

var $9HFsx = parcelRequire("9HFsx");
const $2622c78f7bb704ff$export$d1fbe0eb3fc9219 = (state, originColumnIndex, targetColumnIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since this supports moving both a single & multiple cols in a single action.
        if (!Array.isArray(originColumnIndex)) originColumnIndex = [
            originColumnIndex
        ];
        const tableMap = (0, $dpooP.TableMap).get(table.node);
        const originalColumnRanges = (0, $gEMyR.getSelectionRangeInColumn)(Math.min(...originColumnIndex), Math.max(...originColumnIndex))(tr);
        const targetColumnRanges = (0, $gEMyR.getSelectionRangeInColumn)(targetColumnIndex)(tr);
        const indexesOriginColumn = (originalColumnRanges === null || originalColumnRanges === void 0 ? void 0 : originalColumnRanges.indexes) ?? [];
        const indexesTargetColumn = (targetColumnRanges === null || targetColumnRanges === void 0 ? void 0 : targetColumnRanges.indexes) ?? [];
        const min = indexesOriginColumn[0];
        const max = indexesOriginColumn[indexesOriginColumn.length - 1];
        if (indexesOriginColumn.includes(targetColumnIndex)) return tr;
        if (!options.tryToFit && indexesTargetColumn.length > 1) (0, $dWa93.isValidReorder)(originColumnIndex[0], targetColumnIndex, indexesTargetColumn, 'column');
        const types = (0, $9HFsx.tableNodeTypes)(state.schema);
        const direction = (0, $boVd1.normalizeDirection)(min, targetColumnIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetColumn);
        const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $kkedq.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
        const createContentNode = $2622c78f7bb704ff$var$createContentNodeFactory(table);
        const newTr = (0, $dXesv.cloneTr)(tr);
        const origins = [];
        for(let y = 0; y < tableMap.height; y++){
            origins.push([]);
            for(let x = min; x <= max; x++){
                if (tableMap.isCellMergedTopLeft(y, x)) continue;
                const nodePos = tableMap.map[y * tableMap.width + x];
                origins[y].push(createContentNode(nodePos));
            }
            if (columnHeaderEnabled && (min === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a col is moved in/out of the header position. If the header col option
                // is enabled then;
                // When a col is moved out, the col will be converted to a normal col and the col to the right will become the header.
                // When a col is moved in, the old col header needs to be made normal, and the incoming col needs to be made a header.
                // This section only manages what happens to the other col, not the one being moved.
                const nearHeaderCol = min === 0 ? max + 1 : actualTargetIndex;
                const nodePos = tableMap.map[y * tableMap.width + nearHeaderCol];
                const { pos: pos, node: node } = createContentNode(nodePos);
                newTr.setNodeMarkup(pos, actualTargetIndex !== 0 || rowHeaderEnabled && y === 0 ? types.header_cell : types.cell, node.attrs);
            }
        }
        origins.forEach((row, y)=>{
            if (!row.length) // If the origin has no cells to be moved then we can skip moving for this row. This can occur when a cell above rowspans
            // into the current row.
            return;
            // The actual target index needs to be translated per row, this is because row/col spans can affect the amount of
            // cells each row contains.
            const rowTargetPosition = $2622c78f7bb704ff$var$translateTargetPosition(y, actualTargetIndex, tableMap);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const node = table.node.nodeAt(rowTargetPosition);
            const pos = table.start + rowTargetPosition;
            const insertPos = direction === 'end' || tableMap.isCellMergedTopLeft(y, actualTargetIndex) ? newTr.mapping.map(pos + node.nodeSize, 1) : newTr.mapping.map(pos, -1);
            newTr.insert(insertPos, row.map(({ node: node }, x)=>$2622c78f7bb704ff$var$normalizeCellNode(node, rowHeaderEnabled && y === 0, columnHeaderEnabled && actualTargetIndex === 0 && x === 0, types)));
            // NOTE: only consecutive cells can be moved, this means we can simplify the delete op into a single step which
            // deletes the range of cells.
            const first = row[0];
            const last = row[row.length - 1];
            return newTr.delete(newTr.mapping.map(first.pos, 1), newTr.mapping.map(last.pos + last.node.nodeSize, -1));
        });
        if (options.selectAfterMove) {
            const n = indexesOriginColumn.length - 1;
            const selectionRange = (0, $gEMyR.getSelectionRangeInColumn)(actualTargetIndex - (direction === 'end' ? n : 0), actualTargetIndex + (direction === 'start' ? n : 0))(newTr);
            if (selectionRange) newTr.setSelection(new (0, $ev7OZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
        }
        return newTr;
    };
function $2622c78f7bb704ff$var$normalizeCellNode(cellNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const newTargetType = rowHeaderEnabled || columnHeaderEnabled ? types.header_cell : types.cell;
    return cellNode.type !== newTargetType ? newTargetType.create(cellNode.attrs, cellNode.content, cellNode.marks) : cellNode;
}
function $2622c78f7bb704ff$var$createContentNodeFactory(table) {
    return (nodePos)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const node = table.node.nodeAt(nodePos);
        const pos = nodePos + table.start;
        return {
            pos: pos,
            start: pos + 1,
            node: node,
            depth: table.depth + 2
        };
    };
}
function $2622c78f7bb704ff$var$translateTargetPosition(row, startIndex, tableMap) {
    if (tableMap.isCellMergedTopLeft(row, startIndex)) {
        // find the closet unmerged position to the left of the target. We scan left first because merged cells will actually
        // reduce the amount of cells in a row.
        for(let x = startIndex - 1; x >= 0; x--){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
        // If no index found then we need to look to the right, this can occur when the first cell in the row is merged.
        for(let x = startIndex + 1; x < tableMap.width; x++){
            if (!tableMap.isCellMergedTopLeft(row, x)) return tableMap.map[row * tableMap.width + x];
        }
    }
    return tableMap.map[row * tableMap.width + startIndex];
}

});
parcelRegister("boVd1", function(module, exports) {
$parcel$export(module.exports, "normalizeDirection", () => $8970f32198193baa$export$3d9c15b8c24b72f5);
function $8970f32198193baa$export$3d9c15b8c24b72f5(origin, target, options) {
    const dir = origin < target ? 'end' : 'start';
    const override = ((options === null || options === void 0 ? void 0 : options.direction) ?? 0) < 0 ? 'start' : 'end';
    return options !== null && options !== void 0 && options.tryToFit && !!(options !== null && options !== void 0 && options.direction) ? override : dir;
}

});


parcelRegister("hWmsp", function(module, exports) {
$parcel$export(module.exports, "moveRow", () => $3363c14e13d06d52$export$fbe24096ca2da576);

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $kkedq = parcelRequire("kkedq");

var $dXesv = parcelRequire("dXesv");

var $5n2u9 = parcelRequire("5n2u9");

var $cxdfe = parcelRequire("cxdfe");

var $dWa93 = parcelRequire("dWa93");

var $boVd1 = parcelRequire("boVd1");

var $9HFsx = parcelRequire("9HFsx");
const $3363c14e13d06d52$export$fbe24096ca2da576 = (state, originRowIndex, targetRowIndex, options = {
    tryToFit: false,
    direction: 0,
    selectAfterMove: false
})=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        // normalize the origin index to an array since move row support moving both a single & multiple rows in a single action.
        if (!Array.isArray(originRowIndex)) originRowIndex = [
            originRowIndex
        ];
        if (originRowIndex.includes(targetRowIndex)) return tr;
        const tableMap = (0, $dpooP.TableMap).get(table.node);
        const [originMin, originMax] = originRowIndex.reduce(([min, max], cur)=>[
                Math.min(min, cur),
                Math.max(max, cur)
            ], [
            Number.MAX_SAFE_INTEGER,
            Number.MIN_SAFE_INTEGER
        ]);
        const originalRowRanges = (0, $cxdfe.getSelectionRangeInRow)(originMin, originMax)(tr);
        const targetRowRanges = (0, $cxdfe.getSelectionRangeInRow)(targetRowIndex)(tr);
        const indexesOriginRow = (originalRowRanges === null || originalRowRanges === void 0 ? void 0 : originalRowRanges.indexes) || [];
        const indexesTargetRow = (targetRowRanges === null || targetRowRanges === void 0 ? void 0 : targetRowRanges.indexes) || [];
        if (originMin < 0 || originMin === Number.MAX_SAFE_INTEGER || originMax >= tableMap.height || originMax === Number.MIN_SAFE_INTEGER || // The target index cannot be within the origin bounds
        targetRowIndex >= originMin && targetRowIndex <= originMax) return tr;
        if (!options.tryToFit && indexesTargetRow.length > 1) (0, $dWa93.isValidReorder)(originMin, targetRowIndex, indexesTargetRow, 'row');
        const types = (0, $9HFsx.tableNodeTypes)(state.schema);
        const direction = (0, $boVd1.normalizeDirection)(originMin, targetRowIndex, options);
        const actualTargetIndex = Math[direction === 'start' ? 'min' : 'max'](...indexesTargetRow);
        const originPositions = indexesOriginRow.map((index)=>tableMap.positionAt(index, 0, table.node) + table.pos);
        const originNodes = originPositions.reduce((acc, pos)=>{
            const node = tr.doc.nodeAt(tr.mapping.map(pos));
            if (node) return [
                ...acc,
                {
                    pos: pos,
                    node: node
                }
            ];
            return acc;
        }, []);
        const targetPos = tableMap.positionAt(actualTargetIndex, 0, table.node) + table.pos;
        const targetNode = tr.doc.nodeAt(tr.mapping.map(targetPos));
        if (originNodes !== null && originNodes !== void 0 && originNodes.length && targetNode) {
            const newTr = (0, $dXesv.cloneTr)(tr);
            const { rowHeaderEnabled: rowHeaderEnabled, columnHeaderEnabled: columnHeaderEnabled } = (0, $kkedq.determineTableHeaderStateFromTableNode)(table.node, tableMap, types);
            if (rowHeaderEnabled && (originMin === 0 || actualTargetIndex === 0)) {
                // This block is handling the situation where a row is moved in/out of the header position. If the header row option
                // is enabled then;
                // When a row is moved out, the row will be converted to a normal row and the row below it will become the header.
                // When a row is moved in, the old row header needs to be made normal, and the incoming row needs to be made a header.
                // This section only manages what happens to the other row, no the one being moved.
                const nearHeaderPos = tableMap.positionAt(originMin === 0 ? originMax + 1 : actualTargetIndex, 0, table.node) + table.pos;
                const nearHeaderNode = newTr.doc.nodeAt(newTr.mapping.map(nearHeaderPos));
                if (nearHeaderNode) nearHeaderNode.forEach((node, offset, index)=>{
                    const start = newTr.mapping.map(nearHeaderPos + 1 + offset);
                    newTr.setNodeMarkup(start, actualTargetIndex !== 0 || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell, node.attrs);
                });
            }
            const insertPos = direction === 'end' ? newTr.mapping.map(targetPos + targetNode.nodeSize, 1) : newTr.mapping.map(targetPos, -1);
            newTr.insert(insertPos, originNodes.map(({ node: node }, index)=>$3363c14e13d06d52$var$normalizeRowNode(node, rowHeaderEnabled && actualTargetIndex === 0 && index === 0, columnHeaderEnabled, types)));
            // IMPORTANT: We need to perform the selection between the insert/delete. This is because the delete could cause
            // the current selection to be pushed out of the table resulting in an invalid selection range outside of the table
            if (options.selectAfterMove) {
                const offset = direction === 'end' ? 1 : 0;
                const selectionRange = (0, $cxdfe.getSelectionRangeInRow)(actualTargetIndex + offset, actualTargetIndex + offset + originNodes.length - 1)(newTr);
                if (selectionRange) newTr.setSelection(new (0, $ev7OZ.CellSelection)(selectionRange.$anchor, selectionRange.$head));
            }
            originNodes.forEach(({ pos: pos, node: node })=>{
                newTr.delete(newTr.mapping.map(pos, 1), newTr.mapping.map(pos + node.nodeSize, -1));
            });
            return newTr;
        }
        return tr;
    };
/**
 * This ensures the row node cell type correctly reflect what they should be.
 * @returns A copy of the rowNode
 */ function $3363c14e13d06d52$var$normalizeRowNode(rowNode, rowHeaderEnabled, columnHeaderEnabled, types) {
    const content = [];
    rowNode.forEach((node, _offset, index)=>{
        const newTargetType = rowHeaderEnabled || columnHeaderEnabled && index === 0 ? types.header_cell : types.cell;
        content.push(node.type !== newTargetType ? newTargetType.create(node.attrs, node.content, node.marks) : node);
    });
    return rowNode.type.create(rowNode.attrs, content, rowNode.marks);
}

});

parcelRegister("jH0fQ", function(module, exports) {
$parcel$export(module.exports, "DropTargetType", () => $0b6de0c22080e743$export$9377432e002bc2da);
// oxlint-disable-next-line eslint/no-redeclare
const $0b6de0c22080e743$export$9377432e002bc2da = {
    NONE: 'none',
    ROW: 'row',
    COLUMN: 'column'
};

});

parcelRegister("HfCkc", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $ecf64dc167a26be8$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $ecf64dc167a26be8$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $ecf64dc167a26be8$export$f05434c51e3762e);

var $92jIL = parcelRequire("92jIL");

var $4dyXt = parcelRequire("4dyXt");

var $eU2qH = parcelRequire("eU2qH");

var $bqiCg = parcelRequire("bqiCg");
const $ecf64dc167a26be8$var$dest = (0, $92jIL.pluginFactory)((0, $eU2qH.pluginKey), (0, $bqiCg.default), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let decorationSet = pluginState.decorationSet;
            const meta = tr.getMeta((0, $4dyXt.pluginKey));
            if (meta && meta.data && meta.data.decorationSet) decorationSet = meta.data.decorationSet;
            if (decorationSet) decorationSet = decorationSet.map(tr.mapping, tr.doc);
            return {
                ...pluginState,
                decorationSet: decorationSet
            };
        }
        return pluginState;
    }
});
const $ecf64dc167a26be8$export$656c7661095efe2e = $ecf64dc167a26be8$var$dest.createPluginState;
const $ecf64dc167a26be8$export$8d4021544bdece00 = $ecf64dc167a26be8$var$dest.createCommand;
const $ecf64dc167a26be8$export$f05434c51e3762e = $ecf64dc167a26be8$var$dest.getPluginState;

});
parcelRegister("eU2qH", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $0f1312e011861cbb$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $0f1312e011861cbb$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('dragAndDropPlugin');

});

parcelRegister("bqiCg", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e85118496dc28ec$export$2e2bcd8739ae039);

var $fmUHX = parcelRequire("fmUHX");

var $jH0fQ = parcelRequire("jH0fQ");
var $8e85118496dc28ec$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case (0, $fmUHX.DragAndDropActionType).SET_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: action.data.type,
                dropTargetIndex: action.data.index,
                isDragging: true
            };
        case (0, $fmUHX.DragAndDropActionType).CLEAR_DROP_TARGET:
            return {
                ...pluginState,
                decorationSet: action.data.decorationSet,
                dropTargetType: (0, $jH0fQ.DropTargetType).NONE,
                dropTargetIndex: 0,
                isDragging: false
            };
        case (0, $fmUHX.DragAndDropActionType).TOGGLE_DRAG_MENU:
            return {
                ...pluginState,
                isDragMenuOpen: action.data.isDragMenuOpen,
                dragMenuDirection: action.data.direction,
                dragMenuIndex: action.data.index,
                isKeyboardModeActive: action.data.isKeyboardModeActive
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("cwJ2b", function(module, exports) {
$parcel$export(module.exports, "clearDropTargetWithAnalytics", () => $cfebbd7dc6b24a7a$export$fbaa62c9a250295d);
$parcel$export(module.exports, "moveSourceWithAnalytics", () => $cfebbd7dc6b24a7a$export$137f4de350aca2d8);
$parcel$export(module.exports, "moveSourceWithAnalyticsViaShortcut", () => $cfebbd7dc6b24a7a$export$a01080da268c1d9d);
$parcel$export(module.exports, "cloneSourceWithAnalytics", () => $cfebbd7dc6b24a7a$export$e432b518ff8f345a);
$parcel$export(module.exports, "toggleDragMenuWithAnalytics", () => $cfebbd7dc6b24a7a$export$ade80ff7f1fbb779);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $lqHJB = parcelRequire("lqHJB");

var $ev7OZ = parcelRequire("ev7OZ");

var $elHd5 = parcelRequire("elHd5");

var $l5gi8 = parcelRequire("l5gi8");

var $4Bf8g = parcelRequire("4Bf8g");

var $6CvZ7 = parcelRequire("6CvZ7");

var $2q9QJ = parcelRequire("2q9QJ");

var $ecxo1 = parcelRequire("ecxo1");

var $HfCkc = parcelRequire("HfCkc");
const $cfebbd7dc6b24a7a$export$fbaa62c9a250295d = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, status, tr)=>{
        return (0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $8d4kB.TABLE_ACTION).MOVED_ROW : (0, $8d4kB.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: (sourceIndexes === null || sourceIndexes === void 0 ? void 0 : sourceIndexes.length) ?? 0,
                    distance: 0,
                    status: status,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $ecxo1.clearDropTarget)(tr)(state, dispatch);
            return true;
        });
    };
const $cfebbd7dc6b24a7a$export$137f4de350aca2d8 = (editorAnalyticsAPI, ariaNotify, getIntl)=>(inputMethod, sourceType, sourceIndexes, targetIndex, tr)=>{
        return (0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $8d4kB.TABLE_ACTION).MOVED_ROW : (0, $8d4kB.TABLE_ACTION).MOVED_COLUMN,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $8d4kB.TABLE_STATUS).CANCELLED : (0, $8d4kB.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) {
                (0, $ecxo1.moveSource)(sourceType, sourceIndexes, targetIndex, tr)(state, dispatch);
                // Only considering single row/column movement for screen reader as only single row/column selection is supported via keyboard atm.
                if ((inputMethod === (0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU || (0, $3LeME.INPUT_METHOD).SHORTCUT) && sourceIndexes.length === 1 && ariaNotify && getIntl) {
                    const direction = sourceIndexes[0] > targetIndex ? -1 : 1; // -1 for left/up , 1 for right/down
                    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
                    ariaNotify(getIntl().formatMessage(sourceType === 'table-row' ? direction > 0 ? (0, $lqHJB.messages).rowMovedDown : (0, $lqHJB.messages).rowMovedUp : direction > 0 ? (0, $lqHJB.messages).columnMovedRight : (0, $lqHJB.messages).columnMovedLeft, {
                        index: targetIndex + 1,
                        total: sourceType === 'table-row' ? totalRowCount : totalColumnCount
                    }), {
                        priority: 'important'
                    });
                }
            }
            return true;
        });
    };
const $cfebbd7dc6b24a7a$export$a01080da268c1d9d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(sourceType, direction)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $ev7OZ.CellSelection);
            const selectionRect = isCellSelection ? (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);
            if (!selectionRect) return false;
            const isRow = sourceType === 'table-row';
            const selectedIndexes = isRow ? (0, $2q9QJ.getSelectedRowIndexes)(selectionRect) : (0, $2q9QJ.getSelectedColumnIndexes)(selectionRect);
            if (selectedIndexes.length === 0) return false;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
            if (!(0, $6CvZ7.canMove)(sourceType, direction, isRow ? totalRowCount : totalColumnCount, selection, selectionRect)) return false;
            const targetIndex = (0, $6CvZ7.getTargetIndex)(selectedIndexes, direction);
            return $cfebbd7dc6b24a7a$export$137f4de350aca2d8(editorAnalyticsAPI, ariaNotify, getIntl)((0, $3LeME.INPUT_METHOD).SHORTCUT, sourceType, selectedIndexes, targetIndex)(state, dispatch);
        };
const $cfebbd7dc6b24a7a$export$e432b518ff8f345a = (editorAnalyticsAPI)=>(inputMethod, sourceType, sourceIndexes, targetIndex, targetDirection, tr)=>{
        return (0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const direction = sourceIndexes[0] > targetIndex ? -1 : 1;
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
            return {
                action: sourceType === 'table-row' ? (0, $8d4kB.TABLE_ACTION).CLONED_ROW : (0, $8d4kB.TABLE_ACTION).CLONED_COLUMN,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    count: sourceIndexes.length,
                    // This identifies the total amount of row/cols the move operation covered. The distance covered should be a representaion
                    // of the minimum distance. This will account for large selection being moved causing a large distance travelled value.
                    distance: Math.min(...sourceIndexes.map((v)=>Math.abs(targetIndex - v))) * direction,
                    // If a drop doesn't actually change anything then we're going to mark the event as cancelled.
                    status: sourceIndexes.includes(targetIndex) ? (0, $8d4kB.TABLE_STATUS).CANCELLED : (0, $8d4kB.TABLE_STATUS).SUCCESS,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $ecxo1.cloneSource)(sourceType, sourceIndexes, targetIndex, targetDirection, tr)(state, dispatch);
            return true;
        });
    };
const $cfebbd7dc6b24a7a$export$ade80ff7f1fbb779 = (editorAnalyticsAPI)=>(isDragMenuOpen, direction, index, trigger = 'mouse')=>{
        return (0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
            const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $HfCkc.getPluginState)(state);
            if (previousOpenState === isDragMenuOpen && previousDragMenuDirection === direction && previousDragMenuIndex === index) return undefined;
            let updatedMenuOpenState;
            if (isDragMenuOpen !== undefined) updatedMenuOpenState = isDragMenuOpen;
            else // menu open but menu direction changed, means user clicked on drag handle of different row/column
            // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
            // 2 scenarios above , menu should remain open.
            if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) updatedMenuOpenState = true;
            else updatedMenuOpenState = !previousOpenState;
            if (updatedMenuOpenState) // We only want to fire analytics when the menu is opened
            return {
                action: (0, $8d4kB.TABLE_ACTION).DRAG_MENU_OPENED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: trigger === 'keyboard' ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE,
                    direction: direction ?? previousDragMenuDirection ?? 'column'
                }
            };
            return undefined;
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $ecxo1.toggleDragMenu)(isDragMenuOpen, direction, index, trigger)(state, dispatch);
            return true;
        });
    };

});
parcelRegister("elHd5", function(module, exports) {
$parcel$export(module.exports, "findCellRectClosestToPos", () => $1c684eaca36ccbaf$export$68680ae223aebfa7);

var $dpooP = parcelRequire("dpooP");

var $6AHSo = parcelRequire("6AHSo");

var $5JFXS = parcelRequire("5JFXS");
const $1c684eaca36ccbaf$export$68680ae223aebfa7 = ($pos)=>{
    const cell = (0, $6AHSo.findCellClosestToPos)($pos);
    if (cell) {
        const table = (0, $5JFXS.findTableClosestToPos)($pos);
        if (table) {
            const map = (0, $dpooP.TableMap).get(table.node);
            const cellPos = cell.pos - table.start;
            return map.rectBetween(cellPos, cellPos);
        }
    }
};

});

parcelRegister("6CvZ7", function(module, exports) {
$parcel$export(module.exports, "getTargetIndex", () => $e3d78797a122648b$export$79db8995cf046b43);
$parcel$export(module.exports, "canMove", () => $e3d78797a122648b$export$a4ef2b0c3fa55ad2);
$parcel$export(module.exports, "getDragMenuConfig", () => $e3d78797a122648b$export$25f919d23e41e94d);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $hIsCp = parcelRequire("hIsCp");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $4jmqR = parcelRequire("4jmqR");

var $hSoIi = parcelRequire("hSoIi");

var $8SESw = parcelRequire("8SESw");

var $3foDq = parcelRequire("3foDq");

var $hWLCD = parcelRequire("hWLCD");

var $iGIja = parcelRequire("iGIja");

var $7T6wF = parcelRequire("7T6wF");

var $cZ3rn = parcelRequire("cZ3rn");

var $5m5hr = parcelRequire("5m5hr");

var $9czSm = parcelRequire("9czSm");

var $1YIVu = parcelRequire("1YIVu");

var $emJZF = parcelRequire("emJZF");

var $2dUrS = parcelRequire("2dUrS");

var $dGstS = parcelRequire("dGstS");

var $aEmSo = parcelRequire("aEmSo");

var $7a5j7 = parcelRequire("7a5j7");

var $kfljr = parcelRequire("kfljr");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $26jxM = parcelRequire("26jxM");

var $1l6nN = parcelRequire("1l6nN");

var $2q9QJ = parcelRequire("2q9QJ");
const $e3d78797a122648b$export$79db8995cf046b43 = (selectedIndexes, direction)=>Math[direction < 0 ? 'min' : 'max'](...selectedIndexes) + direction;
const $e3d78797a122648b$export$a4ef2b0c3fa55ad2 = (sourceType, direction, totalItemsOfSourceTypeCount, selection, selectionRect)=>{
    if (!selectionRect) return false;
    const isRow = sourceType === 'table-row';
    const selectedIndexes = isRow ? (0, $2q9QJ.getSelectedRowIndexes)(selectionRect) : (0, $2q9QJ.getSelectedColumnIndexes)(selectionRect);
    const targetIndex = $e3d78797a122648b$export$79db8995cf046b43(selectedIndexes, direction);
    const isValidTargetIndex = targetIndex >= 0 && targetIndex < totalItemsOfSourceTypeCount;
    if (!isValidTargetIndex) return false;
    // We can't move column when target has merged cells with other columns
    // We can't move row when target has merged cells with other rows
    const hasMergedCellsInTarget = isRow ? (0, $1l6nN.hasMergedCellsWithRowNextToRowIndex)(targetIndex, selection) : (0, $1l6nN.hasMergedCellsWithColumnNextToColumnIndex)(targetIndex, selection);
    if (hasMergedCellsInTarget) return false;
    // We can't move if selection in the source is not a rectangle
    if ((0, $1l6nN.hasMergedCellsInSelection)(selectedIndexes, isRow ? 'row' : 'column')(selection)) return false;
    return true;
};
const $e3d78797a122648b$var$isDistributeColumnsEnabled = (state)=>{
    const rect = (0, $7a5j7.getClosestSelectionRect)(state);
    if (rect) {
        const selectedColIndexes = (0, $2q9QJ.getSelectedColumnIndexes)(rect);
        return selectedColIndexes.length > 1;
    }
    return false;
};
const $e3d78797a122648b$var$defaultSelectionRect = {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
};
const $e3d78797a122648b$export$25f919d23e41e94d = (direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, isHeaderRowRequired, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, ariaNotifyPlugin, isCommentEditor = false, isColumnSortingEnabled = true)=>{
    const { selection: selection } = editorView.state;
    const { getIntl: getIntl } = (0, $4GJqd.getPluginState)(editorView.state);
    const addOptions = direction === 'row' ? [
        {
            label: 'above',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9czSm))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $eUtBU.addRowBefore)
        },
        {
            label: 'below',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YIVu))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $eUtBU.addRowAfter)
        }
    ] : [
        {
            label: 'left',
            offset: 0,
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3foDq))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $eUtBU.addColumnBefore)
        },
        {
            label: 'right',
            offset: 1,
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWLCD))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $eUtBU.addColumnAfter)
        }
    ];
    const isNewKeymapExperiment = (0, $aEmSo.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
    const moveOptions = direction === 'row' ? [
        {
            label: 'up',
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGstS))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $eUtBU.moveRowUp) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $eUtBU.moveRowUpOld),
            canMove: $e3d78797a122648b$export$a4ef2b0c3fa55ad2('table-row', -1, (tableMap === null || tableMap === void 0 ? void 0 : tableMap.height) ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $2q9QJ.getSelectedRowIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.top - 1
        },
        {
            label: 'down',
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2dUrS))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $eUtBU.moveRowDown) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $eUtBU.moveRowDownOld),
            canMove: $e3d78797a122648b$export$a4ef2b0c3fa55ad2('table-row', 1, (tableMap === null || tableMap === void 0 ? void 0 : tableMap.height) ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $2q9QJ.getSelectedRowIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.bottom
        }
    ] : [
        {
            label: 'left',
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7T6wF))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $eUtBU.moveColumnLeft) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $eUtBU.moveColumnLeftOld),
            canMove: $e3d78797a122648b$export$a4ef2b0c3fa55ad2('table-column', -1, (tableMap === null || tableMap === void 0 ? void 0 : tableMap.width) ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $2q9QJ.getSelectedColumnIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.left - 1
        },
        {
            label: 'right',
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cZ3rn))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: isNewKeymapExperiment ? (0, $eUtBU.moveColumnRight) : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $eUtBU.moveColumnRightOld),
            canMove: $e3d78797a122648b$export$a4ef2b0c3fa55ad2('table-column', 1, (tableMap === null || tableMap === void 0 ? void 0 : tableMap.width) ?? 0, selection, selectionRect),
            getOriginIndexes: (0, $2q9QJ.getSelectedColumnIndexes),
            getTargetIndex: (selectionRect)=>selectionRect.right
        }
    ];
    const sortOptions = direction === 'column' ? [
        {
            label: 'increasing',
            order: (0, $hIsCp.SortOrder).ASC,
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jmqR))), {
                    spacing: 'spacious',
                    label: ''
                })
        },
        {
            label: 'decreasing',
            order: (0, $hIsCp.SortOrder).DESC,
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hSoIi))), {
                    spacing: 'spacious',
                    label: ''
                })
        }
    ] : [];
    const sortConfigs = sortOptions.map(({ label: label, order: order, icon: icon })=>({
            id: `sort_column_${order}`,
            title: `Sort ${label}`,
            disabled: hasMergedCellsInTable,
            icon: icon,
            onClick: (state, dispatch)=>{
                (0, $kfljr.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, index ?? 0, order)(state, dispatch);
                return true;
            }
        }));
    const restConfigs = [
        ...addOptions.map(({ label: label, offset: offset, icon: icon, keymap: keymap })=>({
                id: `add_${direction}_${label}`,
                title: `Add ${direction} ${label}`,
                icon: icon,
                onClick: (state, dispatch)=>{
                    if (direction === 'row') (0, $kfljr.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, {
                        index: (index ?? 0) + offset,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    else (0, $kfljr.insertColumnWithAnalytics)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, (index ?? 0) + offset)(state, dispatch, editorView);
                    return true;
                },
                keymap: keymap && (0, $eUtBU.tooltip)(keymap)
            })),
        direction === 'column' ? {
            id: 'distribute_columns',
            title: 'Distribute columns',
            disabled: !$e3d78797a122648b$var$isDistributeColumnsEnabled(editorView.state),
            onClick: (state, dispatch)=>{
                const selectionRect = (0, $7a5j7.getClosestSelectionRect)(state);
                if (selectionRect) {
                    const newResizeState = (0, $26jxM.getNewResizeStateFromSelectedColumns)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                    if (newResizeState) {
                        (0, $kfljr.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(state, dispatch);
                        return true;
                    }
                    return false;
                }
                return false;
            },
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5m5hr))), {
                    spacing: 'spacious',
                    label: ''
                })
        } : undefined,
        {
            id: 'clear_cells',
            title: 'Clear cells',
            onClick: (state, dispatch)=>{
                (0, $kfljr.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(state, dispatch);
                return true;
            },
            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8SESw))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: (0, $eUtBU.tooltip)((0, $eUtBU.backspace))
        },
        {
            id: `delete_${direction}`,
            title: `Delete ${direction}`,
            onClick: (state, dispatch)=>{
                if (direction === 'row') (0, $kfljr.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $e3d78797a122648b$var$defaultSelectionRect, !!isHeaderRowRequired)(state, dispatch);
                else (0, $kfljr.deleteColumnsWithAnalytics)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect ?? $e3d78797a122648b$var$defaultSelectionRect)(state, dispatch, editorView);
                return true;
            },
            icon: direction === 'row' ? ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($emJZF))), {
                    spacing: 'spacious',
                    label: ''
                }) : ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGIja))), {
                    spacing: 'spacious',
                    label: ''
                }),
            keymap: direction === 'row' ? (0, $eUtBU.tooltip)((0, $eUtBU.deleteRow)) : (0, $eUtBU.tooltip)((0, $eUtBU.deleteColumn))
        },
        ...moveOptions.map(({ label: label, canMove: canMove, icon: icon, keymap: keymap, getOriginIndexes: getOriginIndexes, getTargetIndex: getTargetIndex })=>({
                id: `move_${direction}_${label}`,
                title: `Move ${direction} ${label}`,
                disabled: !canMove,
                icon: icon,
                onClick: (_state, _dispatch)=>{
                    if (canMove) {
                        requestAnimationFrame(()=>{
                            (0, $cwJ2b.moveSourceWithAnalytics)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, `table-${direction}`, // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getOriginIndexes(selectionRect), // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            getTargetIndex(selectionRect))(editorView.state, editorView.dispatch);
                        });
                        return true;
                    }
                    return false;
                },
                keymap: keymap && (0, $eUtBU.tooltip)(keymap)
            }))
    ];
    const allConfigs = [
        ...restConfigs
    ];
    if (isColumnSortingEnabled) allConfigs.unshift(...sortConfigs);
    return allConfigs.filter(Boolean);
};

});
parcelRegister("7a5j7", function(module, exports) {
$parcel$export(module.exports, "getClosestSelectionRect", () => $0e03790ca64f13e9$export$e3ff63a8559e7571);
$parcel$export(module.exports, "getToolbarConfig", () => $0e03790ca64f13e9$export$86ce8f8241c20a3);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $3ZJj6 = parcelRequire("3ZJj6");

var $jiju3 = parcelRequire("jiju3");

var $hIsCp = parcelRequire("hIsCp");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $6Bl92 = parcelRequire("6Bl92");

var $eUtBU = parcelRequire("eUtBU");

var $3uluy = parcelRequire("3uluy");

var $lqHJB = parcelRequire("lqHJB");

var $knIPH = parcelRequire("knIPH");
var $4tUqV = parcelRequire("4tUqV");

var $k5JVX = parcelRequire("k5JVX");

var $fmnS6 = parcelRequire("fmnS6");

var $3D4hV = parcelRequire("3D4hV");

var $4oU9q = parcelRequire("4oU9q");

var $j5HMs = parcelRequire("j5HMs");

var $8P6Kl = parcelRequire("8P6Kl");

var $hCON4 = parcelRequire("hCON4");

var $2qSeE = parcelRequire("2qSeE");

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $ksttc = parcelRequire("ksttc");

var $1pRtZ = parcelRequire("1pRtZ");

var $dpooP = parcelRequire("dpooP");

var $elHd5 = parcelRequire("elHd5");
var $5n2u9 = parcelRequire("5n2u9");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");

var $5N0Vg = parcelRequire("5N0Vg");

var $gBMlX = parcelRequire("gBMlX");

var $4qPnd = parcelRequire("4qPnd");

var $eGgZF = parcelRequire("eGgZF");

var $fBqpc = parcelRequire("fBqpc");

var $Admw7 = parcelRequire("Admw7");

var $16zRT = parcelRequire("16zRT");

var $5m5hr = parcelRequire("5m5hr");

var $bcN2K = parcelRequire("bcN2K");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $EwLhB = parcelRequire("EwLhB");
var $lFzKY = parcelRequire("lFzKY");

var $kfljr = parcelRequire("kfljr");

var $HfCkc = parcelRequire("HfCkc");

var $4GJqd = parcelRequire("4GJqd");

var $gQDgk = parcelRequire("gQDgk");

var $7SttP = parcelRequire("7SttP");

var $26jxM = parcelRequire("26jxM");

var $8aCba = parcelRequire("8aCba");

var $fPwP3 = parcelRequire("fPwP3");

var $1YIoS = parcelRequire("1YIoS");

var $4WYVI = parcelRequire("4WYVI");

var $2q9QJ = parcelRequire("2q9QJ");

var $jo7Pl = parcelRequire("jo7Pl");

var $75I44 = parcelRequire("75I44");

var $h3r8b = parcelRequire("h3r8b");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $iVTiG = parcelRequire("iVTiG");
const $0e03790ca64f13e9$export$aea1bbb5471be38f = (config, state, { formatMessage: formatMessage }, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown = false, areTableColumnWidthsFixed = false)=>{
    const optionItem = 'item-checkbox';
    const options = [
        {
            id: 'editor.table.lockColumnWidths',
            title: formatMessage((0, $lqHJB.messages).lockColumnWidths),
            onClick: (0, $kfljr.toggleFixedColumnWidthsOptionAnalytics)(editorAnalyticsAPI, (0, $3LeME.INPUT_METHOD).FLOATING_TB),
            selected: areTableColumnWidthsFixed,
            hidden: !isTableScalingWithFixedColumnWidthsOptionShown,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerRow',
            title: formatMessage((0, $lqHJB.messages).headerRow),
            onClick: (0, $kfljr.toggleHeaderRowWithAnalytics)(editorAnalyticsAPI),
            selected: state.isHeaderRowEnabled,
            hidden: !config.allowHeaderRow,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.headerColumn',
            title: formatMessage((0, $lqHJB.messages).headerColumn),
            onClick: (0, $kfljr.toggleHeaderColumnWithAnalytics)(editorAnalyticsAPI),
            selected: state.isHeaderColumnEnabled,
            hidden: !config.allowHeaderColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.numberedColumn',
            title: formatMessage((0, $lqHJB.messages).numberedRows),
            onClick: (0, $kfljr.toggleNumberColumnWithAnalytics)(editorAnalyticsAPI),
            selected: state.isNumberColumnEnabled,
            hidden: !config.allowNumberColumn,
            domItemOptions: {
                type: optionItem
            }
        },
        {
            id: 'editor.table.collapseTable',
            title: formatMessage((0, $lqHJB.messages).collapseTable),
            onClick: (0, $kfljr.wrapTableInExpandWithAnalytics)(editorAnalyticsAPI),
            selected: !!state.isTableCollapsed,
            disabled: !state.canCollapseTable,
            hidden: !config.allowCollapse,
            domItemOptions: {
                type: optionItem
            }
        }
    ];
    const tableOptionsDropdownWidth = isTableScalingWithFixedColumnWidthsOptionShown ? 192 : undefined;
    return {
        id: 'editor.table.tableOptions',
        type: 'dropdown',
        testId: 'table_options',
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($fBqpc))),
        title: formatMessage((0, $lqHJB.messages).tableOptions),
        hidden: options.every((option)=>option.hidden),
        options: options,
        dropdownWidth: tableOptionsDropdownWidth
    };
};
const $0e03790ca64f13e9$export$99943093c6d7192b = (editorState, editorView, initialSelectionRect, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    var _pluginState$pluginCo, _pluginState$pluginCo2;
    const { top: top, bottom: bottom, right: right, left: left } = initialSelectionRect;
    const numberOfColumns = right - left;
    const numberOfRows = bottom - top;
    const pluginState = (0, $4GJqd.getPluginState)(editorState);
    const options = [
        {
            id: 'editor.table.insertColumn',
            title: formatMessage((0, $lqHJB.messages).insertColumn),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $0e03790ca64f13e9$export$e3ff63a8559e7571(state);
                const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.right;
                if (index) (0, $kfljr.insertColumnWithAnalytics)(api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).FLOATING_TB, index)(state, dispatch, view);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                css: (0, $ksttc.shortcutStyle)
            }, (0, $eUtBU.tooltip)((0, $eUtBU.addColumnAfter)))
        },
        {
            id: 'editor.table.insertRow',
            title: formatMessage((0, $lqHJB.messages).insertRow),
            onClick: (state, dispatch)=>{
                const selectionRect = $0e03790ca64f13e9$export$e3ff63a8559e7571(state);
                const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.bottom;
                if (index) (0, $kfljr.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB, {
                    index: index,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            },
            selected: false,
            disabled: false,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                css: (0, $ksttc.shortcutStyle)
            }, (0, $eUtBU.tooltip)((0, $eUtBU.addRowAfter)))
        },
        {
            id: 'editor.table.removeColumns',
            title: formatMessage((0, $lqHJB.messages).removeColumns, {
                0: numberOfColumns
            }),
            onClick: (state, dispatch, view)=>{
                const selectionRect = $0e03790ca64f13e9$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $kfljr.deleteColumnsWithAnalytics)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).FLOATING_TB, selectionRect)(state, dispatch, view);
                return true;
            },
            onFocus: $0e03790ca64f13e9$var$highlightColumnsHandler,
            onBlur: (0, $EwLhB.clearHoverSelection)(),
            onMouseOver: $0e03790ca64f13e9$var$highlightColumnsHandler,
            onMouseLeave: (0, $EwLhB.clearHoverSelection)(),
            selected: false,
            disabled: false
        },
        {
            id: 'editor.table.removeRows',
            title: formatMessage((0, $lqHJB.messages).removeRows, {
                0: numberOfRows
            }),
            onClick: (state, dispatch)=>{
                const selectionRect = $0e03790ca64f13e9$export$e3ff63a8559e7571(state);
                if (selectionRect) (0, $kfljr.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB, selectionRect, false)(state, dispatch);
                return true;
            },
            onFocus: $0e03790ca64f13e9$var$highlightRowsHandler,
            onBlur: (0, $EwLhB.clearHoverSelection)(),
            onMouseOver: $0e03790ca64f13e9$var$highlightRowsHandler,
            onMouseLeave: (0, $EwLhB.clearHoverSelection)(),
            selected: false,
            disabled: false
        }
    ];
    if (pluginState.pluginConfig.allowMergeCells) options.push({
        id: 'editor.table.mergeCells',
        title: formatMessage((0, $lqHJB.messages).mergeCells),
        onClick: (0, $kfljr.mergeCellsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $fPwP3.canMergeCells)(editorState.tr)
    }, {
        id: 'editor.table.splitCell',
        title: formatMessage((0, $lqHJB.messages).splitCell),
        onClick: (0, $kfljr.splitCellWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB),
        selected: false,
        disabled: !(0, $5N0Vg.splitCell)(editorState)
    });
    if (pluginState !== null && pluginState !== void 0 && (_pluginState$pluginCo = pluginState.pluginConfig) !== null && _pluginState$pluginCo !== void 0 && _pluginState$pluginCo.allowDistributeColumns) {
        const distributeColumnWidths = (state, dispatch, view)=>{
            if (view) {
                const resizeState = (0, $26jxM.getNewResizeStateFromSelectedColumns)(initialSelectionRect, state, view.domAtPos.bind(view), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
                if (resizeState) {
                    (0, $kfljr.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $3LeME.INPUT_METHOD).FLOATING_TB, resizeState)(state, dispatch);
                    return true;
                }
            }
            return false;
        };
        options.push({
            id: 'editor.table.distributeColumns',
            title: formatMessage((0, $lqHJB.messages).distributeColumns),
            onClick: distributeColumnWidths,
            selected: false,
            disabled: false
        });
    }
    if (pluginState !== null && pluginState !== void 0 && (_pluginState$pluginCo2 = pluginState.pluginConfig) !== null && _pluginState$pluginCo2 !== void 0 && _pluginState$pluginCo2.allowColumnSorting) {
        const hasMergedCellsInTable = (0, $jo7Pl.getMergedCellsPositions)(editorState.tr).length > 0;
        const warning = hasMergedCellsInTable ? formatMessage((0, $lqHJB.messages).canNotSortTable) : undefined;
        options.push({
            id: 'editor.table.sortColumnAsc',
            title: formatMessage((0, $lqHJB.messages).sortColumnASC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $jo7Pl.getMergedCellsPositions)(state.tr).length !== 0) {
                    (0, $EwLhB.hoverMergedCells)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $EwLhB.clearHoverSelection)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $kfljr.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $hIsCp.SortOrder).ASC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
        options.push({
            id: 'editor.table.sortColumnDesc',
            title: formatMessage((0, $lqHJB.messages).sortColumnDESC),
            onMouseOver: (state, dispatch)=>{
                if ((0, $jo7Pl.getMergedCellsPositions)(state.tr).length !== 0) {
                    (0, $EwLhB.hoverMergedCells)()(state, dispatch);
                    return true;
                }
                return false;
            },
            onMouseOut: (state, dispatch)=>{
                (0, $EwLhB.clearHoverSelection)()(state, dispatch);
                return true;
            },
            onClick: (state, dispatch)=>{
                (0, $kfljr.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB, initialSelectionRect.left, (0, $hIsCp.SortOrder).DESC)(state, dispatch);
                return true;
            },
            selected: false,
            disabled: hasMergedCellsInTable,
            tooltip: warning
        });
    }
    options.push({
        id: 'editor.table.clearCells',
        title: formatMessage((0, $lqHJB.messages).clearCells, {
            0: Math.max(numberOfColumns, numberOfRows)
        }),
        onClick: (state, dispatch)=>{
            const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(state);
            (0, $kfljr.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB, targetCellPosition)(state, dispatch);
            return true;
        },
        selected: false,
        disabled: false,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: (0, $ksttc.shortcutStyle)
        }, (0, $eUtBU.tooltip)((0, $eUtBU.backspace)))
    });
    return {
        id: 'editor.table.cellOptions',
        testId: 'cell_options',
        type: 'dropdown',
        title: formatMessage((0, $lqHJB.messages).cellOptions),
        options: options,
        // Increased dropdown item width to prevent labels from being truncated
        dropdownWidth: 230,
        showSelected: false
    };
};
const $0e03790ca64f13e9$export$e3ff63a8559e7571 = (state)=>{
    const selection = state.selection;
    return (0, $2HFfw.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);
};
const $0e03790ca64f13e9$var$getClosestSelectionOrTableRect = (state)=>{
    const selection = state.selection;
    const tableObject = (0, $5n2u9.findTable)(state.selection);
    if (!tableObject) return;
    const map = (0, $dpooP.TableMap).get(tableObject.node);
    const tableRect = new (0, $1pRtZ.Rect)(0, 0, map.width, map.height);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, $2HFfw.isSelectionType)(selection, 'cell') ? (0, $l5gi8.getSelectionRect)(selection) : tableRect;
};
// Memoize the expensive DOM queries (querySelector, closestElement) separately
// Cache key is the parent DOM node reference - stays same when typing in same cell
const $0e03790ca64f13e9$var$getTableWrapperFromParentImpl = (parent)=>{
    if (!parent) return undefined;
    // These are the expensive DOM operations
    const tableRef = // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    parent.querySelector('table') || undefined;
    if (!tableRef) return undefined;
    return (0, $hCON4.closestElement)(tableRef, `.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`) || undefined;
};
let $0e03790ca64f13e9$var$cachedTableWrapperParent;
let $0e03790ca64f13e9$var$cachedTableWrapperEditorRoot;
let $0e03790ca64f13e9$var$cachedTableWrapper;
const $0e03790ca64f13e9$var$getCachedTableWrapperFromParent = (parent, editorView)=>{
    var _cachedTableWrapper;
    const editorRoot = editorView.dom;
    if (parent && parent === $0e03790ca64f13e9$var$cachedTableWrapperParent && editorRoot === $0e03790ca64f13e9$var$cachedTableWrapperEditorRoot && (_cachedTableWrapper = $0e03790ca64f13e9$var$cachedTableWrapper) !== null && _cachedTableWrapper !== void 0 && _cachedTableWrapper.isConnected && editorRoot.isConnected && editorRoot.contains(parent) && editorRoot.contains($0e03790ca64f13e9$var$cachedTableWrapper) && parent.contains($0e03790ca64f13e9$var$cachedTableWrapper) && $0e03790ca64f13e9$var$cachedTableWrapper.querySelector('table')) return $0e03790ca64f13e9$var$cachedTableWrapper;
    $0e03790ca64f13e9$var$cachedTableWrapperParent = parent;
    $0e03790ca64f13e9$var$cachedTableWrapperEditorRoot = editorRoot;
    $0e03790ca64f13e9$var$cachedTableWrapper = undefined;
    if (!parent || !parent.isConnected || !editorRoot.isConnected || !editorRoot.contains(parent)) return undefined;
    if (!(parent instanceof HTMLElement)) return undefined;
    const tableWrapper = $0e03790ca64f13e9$var$getTableWrapperFromParentImpl(parent);
    if (tableWrapper !== null && tableWrapper !== void 0 && tableWrapper.isConnected && editorRoot.contains(tableWrapper) && parent.contains(tableWrapper)) $0e03790ca64f13e9$var$cachedTableWrapper = tableWrapper;
    return $0e03790ca64f13e9$var$cachedTableWrapper;
};
// Remove this function when cleaning up `platform_editor_table_toolbar_position_fix`
// Create memoized version ONCE - reused across all calls
const $0e03790ca64f13e9$var$getMemoizedTableWrapperFromParent = (0, $jiju3.default)($0e03790ca64f13e9$var$getTableWrapperFromParentImpl);
const $0e03790ca64f13e9$export$86ce8f8241c20a3 = (getEditorContainerWidth, api, editorAnalyticsAPI, getEditorView, options, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>(config)=>(state, intl)=>{
            const tableObject = (0, $5n2u9.findTable)(state.selection);
            const pluginState = (0, $4GJqd.getPluginState)(state);
            const resizeState = (0, $gQDgk.pluginKey).getState(state);
            const tableWidthState = (0, $8aCba.pluginKey).getState(state);
            const isTableScalingEnabled = (options === null || options === void 0 ? void 0 : options.isTableScalingEnabled) || false;
            const nodeType = state.schema.nodes.table;
            const toolbarTitle = 'Table floating controls';
            const areAnyNewToolbarFlagsEnabled = (0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
            if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) {
                var _api$editorViewMode;
                const { isDragMenuOpen: isDragHandleMenuOpened = false, isDragging: isTableRowOrColumnDragged = false } = (0, $HfCkc.getPluginState)(state);
                const isTableOrColumnResizing = !!(resizeState !== null && resizeState !== void 0 && resizeState.dragging || tableWidthState !== null && tableWidthState !== void 0 && tableWidthState.resizing);
                const isTableMenuOpened = pluginState.isContextualMenuOpen || isDragHandleMenuOpened;
                const isTableState = isTableRowOrColumnDragged || isTableOrColumnResizing || isTableMenuOpened;
                const isViewMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
                // Note: when focus is in codeblocks, pluginState.editorHasFocus is false, so the codeblocks toolbar
                // won't be suppressed.
                const shouldSuppressAllToolbars = isTableState && pluginState.editorHasFocus && !isViewMode;
                if (shouldSuppressAllToolbars) return {
                    title: toolbarTitle,
                    items: [],
                    nodeType: nodeType
                };
            }
            // We don't want to show floating toolbar while resizing the table
            const isWidthResizing = tableWidthState === null || tableWidthState === void 0 ? void 0 : tableWidthState.resizing;
            if (tableObject && pluginState.editorHasFocus && !isWidthResizing) {
                var _api$limitedMode, _api$editorViewMode2, _api$extension, _api$extension2;
                const isNested = pluginState.tablePos && (0, $4WYVI.isTableNested)(state, pluginState.tablePos);
                const isTableScalingWithFixedColumnWidthsOptionShown = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && !isNested;
                const areTableColumWidthsFixed = tableObject.node.attrs.displayMode === 'fixed';
                const editorView = getEditorView();
                const getDomRef = (editorView)=>{
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $a4TQr.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    return (0, $bcN2K.isExperimentEnabled)('platform_editor_table_toolbar_position_fix') ? $0e03790ca64f13e9$var$getCachedTableWrapperFromParent(parent, editorView) : $0e03790ca64f13e9$var$getMemoizedTableWrapperFromParent(parent);
                };
                const menu = $0e03790ca64f13e9$export$aea1bbb5471be38f(config, pluginState, intl, editorAnalyticsAPI, isTableScalingWithFixedColumnWidthsOptionShown, areTableColumWidthsFixed);
                const alignmentMenu = config.allowTableAlignment && !isNested ? $0e03790ca64f13e9$var$getAlignmentOptionsConfig(state, intl, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, options === null || options === void 0 ? void 0 : options.fullWidthEnabled, options === null || options === void 0 ? void 0 : options.isCommentEditor) : [];
                const isLimitedModeEnabled = (api === null || api === void 0 || (_api$limitedMode = api.limitedMode) === null || _api$limitedMode === void 0 || (_api$limitedMode = _api$limitedMode.sharedState.currentState()) === null || _api$limitedMode === void 0 ? void 0 : _api$limitedMode.enabled) ?? false;
                const columnSettingsItems = $0e03790ca64f13e9$var$getColumnSettingItems(state, editorView, intl, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, options === null || options === void 0 ? void 0 : options.isCommentEditor, isLimitedModeEnabled);
                const colorPicker = !areAnyNewToolbarFlagsEnabled ? $0e03790ca64f13e9$var$getColorPicker(state, menu, intl, editorAnalyticsAPI, getEditorView) : [];
                const fitToContentButton = (0, $h3r8b.isContentModeSupported)({
                    allowColumnResizing: !!pluginState.pluginConfig.allowColumnResizing,
                    allowTableResizing: !!pluginState.pluginConfig.allowTableResizing,
                    isFullPageEditor: !pluginState.isChromelessEditor && !pluginState.isCommentEditor
                }) && !isNested && (api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 || (_api$editorViewMode2 = _api$editorViewMode2.sharedState.currentState()) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.mode) !== 'view' && (0, $aEmSo.expValEquals)('platform_editor_table_fit_to_content_on_demand', 'isEnabled', true) ? [
                    {
                        id: 'editor.table.fitToContent',
                        type: 'button',
                        title: intl.formatMessage((0, $lqHJB.messages).fitToContent),
                        icon: ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($16zRT))), {
                                spacing: 'spacious',
                                label: ''
                            }),
                        onClick: (_state, _dispatch, view)=>{
                            if (view) (0, $75I44.applyMeasuredWidthToSelectedTable)(view, api ?? undefined);
                            return true;
                        }
                    }
                ] : [];
                // Check if we need to show confirm dialog for delete button
                let confirmDialog;
                if ((0, $2qSeE.isReferencedSource)(state, tableObject.node)) {
                    const localSourceName = intl.formatMessage((0, $lqHJB.messages).unnamedSource);
                    confirmDialog = ()=>({
                            title: intl.formatMessage((0, $lqHJB.messages).deleteElementTitle),
                            okButtonLabel: intl.formatMessage((0, $lqHJB.messages).confirmDeleteLinkedModalOKButton),
                            message: intl.formatMessage((0, $lqHJB.messages).confirmDeleteLinkedModalMessage, {
                                nodeName: (0, $8P6Kl.getNodeName)(state, tableObject.node) || localSourceName
                            }),
                            messagePrefix: intl.formatMessage((0, $lqHJB.messages).confirmDeleteLinkedModalMessagePrefix),
                            isReferentialityDialog: true,
                            getChildrenInfo: ()=>(0, $2qSeE.getChildrenInfo)(state, tableObject.node),
                            checkboxLabel: intl.formatMessage((0, $lqHJB.messages).confirmModalCheckboxLabel),
                            onConfirm: (isChecked = false)=>$0e03790ca64f13e9$var$clickWithCheckboxHandler(isChecked, tableObject.node)
                        });
                }
                const deleteButton = {
                    id: 'editor.table.delete',
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($Admw7))),
                    onClick: (0, $kfljr.deleteTableWithAnalytics)(editorAnalyticsAPI),
                    disabled: !!resizeState && !!resizeState.dragging,
                    onMouseEnter: (0, $EwLhB.hoverTable)(true),
                    onFocus: (0, $EwLhB.hoverTable)(true),
                    onBlur: (0, $EwLhB.clearHoverSelection)(),
                    onMouseLeave: (0, $EwLhB.clearHoverSelection)(),
                    title: intl.formatMessage((0, $3uluy.default).remove),
                    focusEditoronEnter: true,
                    confirmDialog: confirmDialog
                };
                const copyButton = {
                    type: 'copy-button',
                    supportsViewMode: true,
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: nodeType,
                            onMouseEnter: (0, $EwLhB.hoverTable)(false, true),
                            onMouseLeave: (0, $EwLhB.clearHoverSelection)(),
                            onFocus: (0, $EwLhB.hoverTable)(false, true),
                            onBlur: (0, $EwLhB.clearHoverSelection)()
                        }
                    ]
                };
                const isNestedTable = (0, $knIPH.isNestedTablesSupported)(state.schema) && (0, $4tUqV.isSelectionTableNestedInTable)(state);
                const hoverTableProps = (isInDanger, isSelected)=>({
                        onMouseEnter: (0, $EwLhB.hoverTable)(isInDanger, isSelected),
                        onMouseLeave: (0, $EwLhB.clearHoverSelection)(),
                        onFocus: (0, $EwLhB.hoverTable)(isInDanger, isSelected),
                        onBlur: (0, $EwLhB.clearHoverSelection)()
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const overflowDropdownTestId = 'table-overflow-dropdown-trigger';
                const extensionState = api === null || api === void 0 || (_api$extension = api.extension) === null || _api$extension === void 0 || (_api$extension = _api$extension.sharedState) === null || _api$extension === void 0 ? void 0 : _api$extension.currentState();
                const extensionApi = api === null || api === void 0 || (_api$extension2 = api.extension) === null || _api$extension2 === void 0 ? void 0 : _api$extension2.actions.api();
                return {
                    title: toolbarTitle,
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    offset: [
                        0,
                        18
                    ],
                    absoluteOffset: {
                        top: -6
                    },
                    zIndex: (0, $014x6.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        menu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $0e03790ca64f13e9$var$separator(menu.hidden)
                        ] : [],
                        ...alignmentMenu,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            $0e03790ca64f13e9$var$separator(alignmentMenu.length === 0)
                        ] : [],
                        ...columnSettingsItems,
                        ...fitToContentButton,
                        ...colorPicker,
                        ...!areAnyNewToolbarFlagsEnabled ? [
                            {
                                type: 'extensions-placeholder',
                                separator: 'end'
                            },
                            copyButton,
                            {
                                type: 'separator'
                            },
                            deleteButton
                        ] : [
                            areAnyNewToolbarFlagsEnabled && {
                                type: 'separator',
                                fullHeight: true
                            },
                            {
                                type: 'overflow-dropdown',
                                testId: overflowDropdownTestId,
                                dropdownWidth: 220,
                                options: [
                                    {
                                        type: 'custom',
                                        fallback: [],
                                        render: (editorView, dropdownOptions)=>{
                                            if (!editorView) return null;
                                            if (!extensionApi || !(extensionState !== null && extensionState !== void 0 && extensionState.extensionProvider)) return null;
                                            return /*#__PURE__*/ (0, $jctmk.jsx)((0, $6Bl92.DropdownMenuExtensionItems), {
                                                node: tableObject.node,
                                                editorView: editorView,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                extension: {
                                                    extensionProvider: extensionState !== null && extensionState !== void 0 && extensionState.extensionProvider ? Promise.resolve(extensionState.extensionProvider) : undefined,
                                                    extensionApi: extensionApi
                                                },
                                                dropdownOptions: dropdownOptions,
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                disabled: (key)=>{
                                                    return isNestedTable && [
                                                        'referentiality:connections',
                                                        'chart:insert-chart'
                                                    ].includes(key);
                                                },
                                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                                            });
                                        }
                                    },
                                    ...extensionApi && extensionState !== null && extensionState !== void 0 && extensionState.extensionProvider && !areAnyNewToolbarFlagsEnabled ? [
                                        {
                                            type: 'separator'
                                        }
                                    ] : [],
                                    {
                                        title: intl.formatMessage((0, $3uluy.default).copyToClipboard),
                                        onClick: ()=>{
                                            var _api$core, _api$floatingToolbar;
                                            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$floatingToolbar = api.floatingToolbar) === null || _api$floatingToolbar === void 0 ? void 0 : _api$floatingToolbar.commands.copyNode(nodeType, (0, $3LeME.INPUT_METHOD).FLOATING_TB));
                                            return true;
                                        },
                                        icon: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGgZF))), {
                                            label: intl.formatMessage((0, $3uluy.default).copyToClipboard)
                                        }),
                                        ...hoverTableProps(false, true)
                                    },
                                    {
                                        title: intl.formatMessage((0, $3uluy.default).delete),
                                        onClick: (0, $kfljr.deleteTableWithAnalytics)(editorAnalyticsAPI),
                                        icon: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Admw7))), {
                                            label: intl.formatMessage((0, $3uluy.default).delete)
                                        }),
                                        ...hoverTableProps(true),
                                        confirmDialog: confirmDialog
                                    }
                                ]
                            }
                        ]
                    ],
                    scrollable: true
                };
            }
            return;
        };
const $0e03790ca64f13e9$var$separator = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};
const $0e03790ca64f13e9$var$getDistributeConfig = (getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false)=>(state, dispatch, editorView)=>{
        const selectionOrTableRect = $0e03790ca64f13e9$var$getClosestSelectionOrTableRect(state);
        if (!editorView || !selectionOrTableRect) return false;
        const newResizeStateWithAnalytics = (0, $26jxM.getNewResizeStateFromSelectedColumns)(selectionOrTableRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (newResizeStateWithAnalytics) {
            (0, $kfljr.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, api)((0, $3LeME.INPUT_METHOD).FLOATING_TB, newResizeStateWithAnalytics)(state, dispatch);
            return true;
        }
        return false;
    };
// this create the button group for distribute column and also fixed column width
// fixed column button should be in this function call in the future
const $0e03790ca64f13e9$var$getColumnSettingItems = (editorState, editorView, { formatMessage: formatMessage }, getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, isCommentEditor = false, isLimitedModeEnabled = false)=>{
    var _pluginState$pluginCo3;
    const pluginState = (0, $4GJqd.getPluginState)(editorState);
    const items = [];
    if (!editorView) return [];
    if (pluginState !== null && pluginState !== void 0 && (_pluginState$pluginCo3 = pluginState.pluginConfig) !== null && _pluginState$pluginCo3 !== void 0 && _pluginState$pluginCo3.allowDistributeColumns) items.push({
        id: 'editor.table.distributeColumns',
        type: 'button',
        title: formatMessage((0, $lqHJB.messages).distributeColumns),
        icon: ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5m5hr))), {
                spacing: 'spacious',
                label: ''
            }),
        onClick: (state, dispatch, view)=>$0e03790ca64f13e9$var$getDistributeConfig(getEditorContainerWidth, api, editorAnalyticsAPI, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor)(state, dispatch, view),
        disabled: false
    });
    if (items.length !== 0 && !(0, $fmnS6.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar))) items.push({
        type: 'separator'
    });
    return items;
};
const $0e03790ca64f13e9$var$getColorPicker = (state, menu, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorView)=>{
    var _node$attrs;
    const { targetCellPosition: targetCellPosition, pluginConfig: pluginConfig } = (0, $4GJqd.getPluginState)(state);
    if (!pluginConfig.allowBackgroundColor) return [];
    const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : undefined;
    const currentBackground = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.background) || '#ffffff';
    const isMoreColorsEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const activePalette = isMoreColorsEnabled ? (0, $3D4hV.default) : (0, $4oU9q.default);
    const defaultPalette = activePalette.find((item)=>item.value === currentBackground) || {
        // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
        label: 'Custom',
        value: currentBackground,
        border: (0, $j5HMs.DEFAULT_BORDER_COLOR)
    };
    return [
        {
            id: 'editor.table.colorPicker',
            title: formatMessage((0, $lqHJB.messages).cellBackground),
            type: 'select',
            isAriaExpanded: true,
            selectType: 'color',
            cols: isMoreColorsEnabled ? (0, $4Tw3G.colorPaletteColumns) : (0, $4Tw3G.colorPalletteColumns),
            defaultValue: defaultPalette,
            options: activePalette,
            returnEscToButton: true,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onChange: (option)=>(0, $kfljr.setColorWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).FLOATING_TB, option.value, getEditorView())
        },
        $0e03790ca64f13e9$var$separator(menu.hidden)
    ];
};
const $0e03790ca64f13e9$var$clickWithCheckboxHandler = (isChecked, node, editorAnalyticsAPI)=>(state, dispatch)=>{
        if (!node) return false;
        if (!isChecked) return (0, $kfljr.deleteTableWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
        else (0, $lFzKY.removeDescendantNodes)(node)(state, dispatch);
        return true;
    };
const $0e03790ca64f13e9$var$highlightRowsHandler = (state, dispatch)=>{
    const selectionRect = $0e03790ca64f13e9$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $EwLhB.hoverRows)((0, $2q9QJ.getSelectedRowIndexes)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $0e03790ca64f13e9$var$highlightColumnsHandler = (state, dispatch)=>{
    const selectionRect = $0e03790ca64f13e9$export$e3ff63a8559e7571(state);
    if (selectionRect) {
        (0, $EwLhB.hoverColumns)((0, $2q9QJ.getSelectedColumnIndexes)(selectionRect), true)(state, dispatch);
        return true;
    }
    return false;
};
const $0e03790ca64f13e9$var$getAlignmentOptionsConfig = (editorState, { formatMessage: formatMessage }, editorAnalyticsAPI, getEditorContainerWidth, editorView, shouldUseIncreasedScalingPercent, areAnyNewToolbarFlagsEnabled, isFullWidthEditor, isCommentEditor)=>{
    const tableObject = (0, $5n2u9.findTable)(editorState.selection);
    if (!tableObject) return [];
    const alignmentIcons = [
        {
            id: 'editor.table.alignLeft',
            value: 'align-start',
            icon: ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4qPnd))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-start-icon"
                })
        },
        {
            id: 'editor.table.alignCenter',
            value: 'center',
            icon: ()=>/*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gBMlX))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "table-align-center-icon"
                })
        }
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const layoutToMessages = {
        center: (0, $lqHJB.messages).alignTableCenter,
        'align-start': (0, $lqHJB.messages).alignTableLeft
    };
    const alignmentButtons = alignmentIcons.map((alignmentIcon)=>{
        const { id: id, value: value, icon: icon } = alignmentIcon;
        const currentLayout = tableObject.node.attrs.layout;
        const shouldDisableLayoutOption = $0e03790ca64f13e9$var$getMemoizedIsLayoutOptionDisabled(tableObject.node, getEditorContainerWidth, editorView !== null, shouldUseIncreasedScalingPercent, isFullWidthEditor);
        return {
            id: id,
            type: 'button',
            icon: icon,
            title: formatMessage(layoutToMessages[value]),
            selected: (0, $1YIoS.normaliseAlignment)(currentLayout) === value,
            onClick: (0, $kfljr.setTableAlignmentWithAnalytics)(editorAnalyticsAPI, isCommentEditor || false)(value, currentLayout, (0, $3LeME.INPUT_METHOD).FLOATING_TB, (0, $8d4kB.CHANGE_ALIGNMENT_REASON).TOOLBAR_OPTION_CHANGED),
            ...shouldDisableLayoutOption && {
                disabled: value !== 'center'
            }
        };
    });
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $jctmk.jsx)((0, $iVTiG.FloatingAlignmentButtons), {
                alignmentButtons: alignmentButtons,
                ...props,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 74,
        height: 32
    };
    const selectedAlignmentIcon = $0e03790ca64f13e9$var$getSelectedAlignmentIcon(alignmentIcons, tableObject.node);
    const alignmentToolbarItem = [
        {
            id: 'table-layout',
            testId: 'table-layout-dropdown',
            type: 'dropdown',
            options: alignmentItemOptions,
            title: formatMessage((0, $lqHJB.messages).tableAlignmentOptions),
            icon: selectedAlignmentIcon === null || selectedAlignmentIcon === void 0 ? void 0 : selectedAlignmentIcon.icon
        }
    ];
    return alignmentToolbarItem;
};
const $0e03790ca64f13e9$var$getSelectedAlignmentIcon = (alignmentIcons, selectedNode)=>{
    const selectedAlignment = selectedNode.attrs.layout;
    return alignmentIcons.find((icon)=>icon.value === (0, $1YIoS.normaliseAlignment)(selectedAlignment));
};
const $0e03790ca64f13e9$var$isLayoutOptionDisabledImpl = (selectedNode, getEditorContainerWidth, hasEditorView, shouldUseIncreasedScalingPercent, isFullWidthEditor)=>{
    const { lineLength: lineLength } = getEditorContainerWidth();
    let tableContainerWidth = (0, $k5JVX.getTableContainerWidth)(selectedNode);
    // table may be scaled, use the scale percent to calculate the table width
    if (hasEditorView) {
        const tableWrapperWidth = tableContainerWidth;
        const scalePercent = (0, $7SttP.getStaticTableScalingPercent)(selectedNode, tableWrapperWidth, shouldUseIncreasedScalingPercent);
        tableContainerWidth = tableContainerWidth * scalePercent;
    }
    // If fixed-width editor, we disable 'left-alignment' when table width is 760px.
    // tableContainerWidth +1 here because tableContainerWidth is 759 in fixed-width editor
    if (selectedNode && !isFullWidthEditor && lineLength && tableContainerWidth + 1 >= lineLength) return true;
    return false;
};
const $0e03790ca64f13e9$var$getMemoizedIsLayoutOptionDisabled = (0, $jiju3.default)($0e03790ca64f13e9$var$isLayoutOptionDisabledImpl, ([prevNode, ...prevRest], [nextNode, ...nextRest])=>{
    // Only node needs special comparison (attrs only), rest use reference equality
    const nodeEqual = (0, (/*@__PURE__*/$parcel$interopDefault($3ZJj6)))(prevNode.attrs, nextNode.attrs);
    const restEqual = prevRest.every((val, idx)=>val === nextRest[idx]);
    return nodeEqual && restEqual;
});

});
parcelRegister("6Bl92", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuExtensionItems", () => $3c9fd1a1d7ca5f0b$export$24b801b186044441);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $ieUrC = parcelRequire("ieUrC");

var $bcN2K = parcelRequire("bcN2K");

var $fUAwU = parcelRequire("fUAwU");

var $cu8Jp = parcelRequire("cu8Jp");

var $y0Izr = parcelRequire("y0Izr");

var $atWuZ = parcelRequire("atWuZ");
const $3c9fd1a1d7ca5f0b$var$noop = ()=>null;
const $3c9fd1a1d7ca5f0b$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $3c9fd1a1d7ca5f0b$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $3c9fd1a1d7ca5f0b$var$noop;
    const maybeIcon = await getIcon();
    return $3c9fd1a1d7ca5f0b$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $3c9fd1a1d7ca5f0b$var$convertExtensionToDropdownMenuItem = ({ item: item, disabled: disabled, node: node, extension: extension, IconComponent: IconComponent })=>{
    let title = '';
    if (item.label) title = item.label;
    else if (typeof item.tooltip === 'string') title = item.tooltip;
    else if (item.ariaLabel) title = item.ariaLabel;
    item.disabled = (disabled === null || disabled === void 0 ? void 0 : disabled(item.key)) || false;
    const getIcon = ()=>{
        const label = item.label || '';
        return IconComponent ? /*#__PURE__*/ (0, $3LM7S.jsx)(IconComponent, {
            label: label
        }) : undefined;
    };
    return {
        title: title,
        icon: getIcon(),
        disabled: item.disabled,
        onClick: ()=>{
            if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
            const targetNodeAdf = (0, $cu8Jp.nodeToJSON)(node);
            extension.extensionApi && item.action(targetNodeAdf, extension.extensionApi);
            return true;
        }
    };
};
const $3c9fd1a1d7ca5f0b$var$DropdownMenuExtensionItem = ({ item: item, editorView: editorView, disabled: disabled, node: node, extension: extension, dropdownOptions: dropdownOptions })=>{
    // Use ref to keep icon component stable across renders
    const iconRef = (0, $fc4bM.useRef)(null);
    if (!iconRef.current && item.icon) {
        const loadIcon = ()=>$3c9fd1a1d7ca5f0b$var$resolveExtensionIcon(item.icon);
        const IconLazy = (0, $ieUrC.lazy)(()=>$3c9fd1a1d7ca5f0b$var$resolveExtensionIcon(item.icon), {});
        IconLazy.displayName = 'lazy(ExtensionIcon)';
        const IconLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
            loader: loadIcon,
            loading: $3c9fd1a1d7ca5f0b$var$noop
        });
        const Icon = (props)=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ieUrC.LazySuspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)(IconLazy, {
                    ...props
                })
            }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
            /*#__PURE__*/ (0, $3LM7S.jsx)(IconLoadable, {
                ...props
            });
        Icon.preload = ()=>(0, $bcN2K.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? IconLazy.preload() : IconLoadable.preload();
        iconRef.current = Icon;
    }
    const dropdownItem = $3c9fd1a1d7ca5f0b$var$convertExtensionToDropdownMenuItem({
        item: item,
        disabled: disabled,
        node: node,
        extension: extension,
        IconComponent: iconRef.current
    });
    if (!dropdownItem) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $y0Izr.DropdownMenuItem), {
        item: dropdownItem,
        editorView: editorView,
        hide: dropdownOptions.hide,
        dispatchCommand: dropdownOptions.dispatchCommand,
        showSelected: dropdownOptions.showSelected,
        intl: dropdownOptions.intl
    }, item.key);
};
const $3c9fd1a1d7ca5f0b$export$24b801b186044441 = (props)=>{
    const { node: node, editorView: editorView, extension: extension, disabled: disabled, dropdownOptions: dropdownOptions, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $fc4bM.useState)([]);
    (0, $fc4bM.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extension.extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    }, [
        extension.extensionProvider
    ]);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>(0, $cu8Jp.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (!extension.extensionApi) return [];
        return (0, $fUAwU.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extension.extensionApi);
    }, [
        extensions,
        nodeAdf,
        extension.extensionApi
    ]);
    if (!extensionItems.length || !dropdownOptions) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            extensionItems.map((item, _idx)=>{
                if (!('key' in item)) return null;
                return /*#__PURE__*/ (0, $3LM7S.jsx)($3c9fd1a1d7ca5f0b$var$DropdownMenuExtensionItem, {
                    item: item,
                    editorView: editorView,
                    disabled: disabled,
                    node: node,
                    extension: extension,
                    dropdownOptions: dropdownOptions
                }, item.key);
            }),
            areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $atWuZ.DropdownSeparator), {})
        ]
    });
};

});

parcelRegister("3D4hV", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc2ebc71f1ea1709$export$2e2bcd8739ae039);

var $63Q5S = parcelRequire("63Q5S");

var $24ud9 = parcelRequire("24ud9");

var $iMGC6 = parcelRequire("iMGC6");
/**
 * Expanded 10-column (30-entry) UI palette that adds lime, orange, and magenta columns
 * and updates the bold row to use `subtler.hovered` design tokens.
 * This is a superset of the default {@link cellBackgroundColorPalette}.
 */ const $fc2ebc71f1ea1709$var$cellBackgroundColorPaletteNew = [];
(0, $63Q5S.tableBackgroundColorPaletteNew).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $24ud9.default)((0, $iMGC6.default), key);
    $fc2ebc71f1ea1709$var$cellBackgroundColorPaletteNew.push({
        value: color,
        label: label,
        border: (0, $63Q5S.tableBackgroundBorderColor),
        message: message
    });
});
var $fc2ebc71f1ea1709$export$2e2bcd8739ae039 = $fc2ebc71f1ea1709$var$cellBackgroundColorPaletteNew;

});

parcelRegister("5N0Vg", function(module, exports) {
$parcel$export(module.exports, "splitCell", () => $6d8deaaa09372097$export$74933b5979945879);

var $hG9gR = parcelRequire("hG9gR");

var $9HFsx = parcelRequire("9HFsx");
const $6d8deaaa09372097$export$74933b5979945879 = (state, dispatch)=>{
    const nodeTypes = (0, $9HFsx.tableNodeTypes)(state.schema);
    return (0, $hG9gR.splitCellWithType)(({ node: node })=>{
        return nodeTypes[node.type.spec.tableRole];
    })(state, dispatch);
};

});
parcelRegister("hG9gR", function(module, exports) {
$parcel$export(module.exports, "splitCellWithType", () => $dc0ddc4044ccc228$export$8c441a625fd4d770);

var $7H6Cr = parcelRequire("7H6Cr");

var $ev7OZ = parcelRequire("ev7OZ");

var $gNVxw = parcelRequire("gNVxw");

var $4iGxE = parcelRequire("4iGxE");

var $iwwun = parcelRequire("iwwun");
function $dc0ddc4044ccc228$export$8c441a625fd4d770(getCellType) {
    return (state, dispatch)=>{
        const sel = state.selection;
        let cellNode, cellPos;
        if (!(sel instanceof (0, $ev7OZ.CellSelection))) {
            cellNode = (0, $4iGxE.cellWrapping)(sel.$from);
            if (!cellNode) return false;
            const cellNodeAround = (0, $gNVxw.cellAround)(sel.$from);
            cellPos = cellNodeAround && cellNodeAround.pos;
        } else {
            if (sel.$anchorCell.pos !== sel.$headCell.pos) return false;
            cellNode = sel.$anchorCell.nodeAfter;
            cellPos = sel.$anchorCell.pos;
        }
        if (cellNode && cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;
        if (cellNode && dispatch) {
            let cellAttrs = cellNode.attrs;
            const attrs = [];
            const colwidth = cellAttrs.colwidth;
            if (cellAttrs.rowspan && cellAttrs.rowspan > 1) cellAttrs = {
                ...cellAttrs,
                rowspan: 1
            };
            if (cellAttrs.colspan && cellAttrs.colspan > 1) cellAttrs = {
                ...cellAttrs,
                colspan: 1
            };
            const rect = (0, $iwwun.selectedRect)(state);
            const tr = state.tr;
            for(let i = 0; i < rect.right - rect.left; i++)attrs.push(colwidth ? {
                ...cellAttrs,
                colwidth: colwidth && colwidth[i] ? [
                    colwidth[i]
                ] : null
            } : cellAttrs);
            let lastCell = null;
            for(let row = rect.top; row < rect.bottom; row++){
                let pos = rect.map.positionAt(row, rect.left, rect.table);
                if (row === rect.top) pos += cellNode.nodeSize;
                for(let col = rect.left, i = 0; col < rect.right; col++, i++){
                    if (col === rect.left && row === rect.top) continue;
                    const cellType = getCellType({
                        node: cellNode,
                        row: row,
                        col: col
                    }).createAndFill(attrs[i]);
                    if (cellType) tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType);
                }
            }
            if (typeof cellPos === 'number') tr.setNodeMarkup(cellPos, getCellType({
                node: cellNode,
                row: rect.top,
                col: rect.left
            }), attrs[0]);
            const $lastCellPosition = lastCell && tr.doc.resolve(lastCell);
            if (sel instanceof (0, $ev7OZ.CellSelection) && $lastCellPosition instanceof (0, $7H6Cr.ResolvedPos)) {
                const cellSelection = new (0, $ev7OZ.CellSelection)(tr.doc.resolve(sel.$anchorCell.pos), $lastCellPosition);
                tr.setSelection(cellSelection);
            }
            dispatch(tr);
        }
        return true;
    };
}

});
parcelRegister("4iGxE", function(module, exports) {
$parcel$export(module.exports, "cellWrapping", () => $24b462d08fe32b38$export$603245c099db0b11);
function $24b462d08fe32b38$export$603245c099db0b11($pos) {
    for(let d = $pos.depth; d > 0; d--){
        // Sometimes the cell can be in the same depth.
        const role = $pos.node(d).type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.node(d);
    }
    return null;
}

});



parcelRegister("EwLhB", function(module, exports) {
$parcel$export(module.exports, "hoverMergedCells", () => $7f9453c8604163f6$export$59dcdc44819c7e7c);
$parcel$export(module.exports, "hoverColumns", () => $7f9453c8604163f6$export$4cf548f2efac0afe);
$parcel$export(module.exports, "hoverRows", () => $7f9453c8604163f6$export$ab63d99b591b89);
$parcel$export(module.exports, "hoverTable", () => $7f9453c8604163f6$export$41c571b711ba06e);
$parcel$export(module.exports, "clearHoverSelection", () => $7f9453c8604163f6$export$d4bebf197f3770e4);
$parcel$export(module.exports, "showResizeHandleLine", () => $7f9453c8604163f6$export$9b72d13d82d16e72);
$parcel$export(module.exports, "hideResizeHandleLine", () => $7f9453c8604163f6$export$5ad4eed96dbaffaf);
$parcel$export(module.exports, "setTableHovered", () => $7f9453c8604163f6$export$f217071b524cec4f);
$parcel$export(module.exports, "hoverCell", () => $7f9453c8604163f6$export$1d614a0f0fe37c44);
// eslint-disable-next-line import/order

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $2rErm = parcelRequire("2rErm");

var $99qNq = parcelRequire("99qNq");

var $YREXK = parcelRequire("YREXK");

var $4GJqd = parcelRequire("4GJqd");

var $ijKnh = parcelRequire("ijKnh");

var $jo7Pl = parcelRequire("jo7Pl");

var $28qg3 = parcelRequire("28qg3");
const $7f9453c8604163f6$var$makeArray = (n)=>Array.from(Array(n).keys());
const $7f9453c8604163f6$export$59dcdc44819c7e7c = ()=>(0, $4GJqd.createCommand)((state)=>{
        const mergedCellsPositions = (0, $jo7Pl.getMergedCellsPositions)(state.tr);
        if (!mergedCellsPositions.length) return false;
        const table = (0, $5n2u9.findTable)(state.tr.selection);
        if (!table) return false;
        const mergedCells = mergedCellsPositions.map((pos)=>({
                pos: pos + table.start,
                start: pos + table.start + 1,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                node: table.node.nodeAt(pos)
            }));
        const decorations = (0, $ijKnh.createCellHoverDecoration)(mergedCells);
        return {
            type: 'HOVER_MERGED_CELLS',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, decorations, (0, $YREXK.TableDecorations).CELL_CONTROLS_HOVER)
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7f9453c8604163f6$export$4cf548f2efac0afe = (hoveredColumns, isInDanger)=>(0, $4GJqd.createCommand)((state)=>{
        const cells = (0, $2rErm.getCellsInColumn)(hoveredColumns)(state.tr.selection);
        if (!cells) return false;
        const decorations = (0, $ijKnh.createControlsHoverDecoration)(cells, 'column', state.tr, hoveredColumns, isInDanger);
        return {
            type: 'HOVER_COLUMNS',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, decorations, (0, $YREXK.TableDecorations).COLUMN_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7f9453c8604163f6$export$ab63d99b591b89 = (hoveredRows, isInDanger)=>(0, $4GJqd.createCommand)((state)=>{
        const cells = (0, $99qNq.getCellsInRow)(hoveredRows)(state.selection);
        if (!cells) return false;
        const decorations = (0, $ijKnh.createControlsHoverDecoration)(cells, 'row', state.tr, hoveredRows, isInDanger);
        return {
            type: 'HOVER_ROWS',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, decorations, (0, $YREXK.TableDecorations).ROW_CONTROLS_HOVER),
                hoveredRows: hoveredRows,
                isInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7f9453c8604163f6$export$41c571b711ba06e = (isInDanger, isSelected)=>(0, $4GJqd.createCommand)((state)=>{
        const table = (0, $5n2u9.findTable)(state.selection);
        if (!table) return false;
        const map = (0, $dpooP.TableMap).get(table.node);
        const hoveredColumns = $7f9453c8604163f6$var$makeArray(map.width);
        const hoveredRows = $7f9453c8604163f6$var$makeArray(map.height);
        const cells = (0, $99qNq.getCellsInRow)(hoveredRows)(state.selection);
        if (!cells) return false;
        const decorations = (0, $ijKnh.createControlsHoverDecoration)(cells, 'table', state.tr, [], isInDanger, isSelected);
        return {
            type: 'HOVER_TABLE',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, decorations, (0, $YREXK.TableDecorations).TABLE_CONTROLS_HOVER),
                hoveredColumns: hoveredColumns,
                hoveredRows: hoveredRows,
                isInDanger: isInDanger,
                isWholeTableInDanger: isInDanger
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7f9453c8604163f6$export$d4bebf197f3770e4 = ()=>(0, $4GJqd.createCommand)((state)=>({
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, [], (0, $YREXK.TableDecorations).ALL_CONTROLS_HOVER),
                isInDanger: false,
                isWholeTableInDanger: false
            }
        }));
const $7f9453c8604163f6$export$9b72d13d82d16e72 = (cellColumnPositioning)=>(0, $4GJqd.createCommand)((state)=>{
        return {
            type: 'SHOW_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, (0, $ijKnh.createColumnLineResize)(state.selection, cellColumnPositioning), (0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_LINE)
            }
        };
    });
const $7f9453c8604163f6$export$5ad4eed96dbaffaf = ()=>(0, $4GJqd.createCommand)((state)=>({
            type: 'HIDE_RESIZE_HANDLE_LINE',
            data: {
                decorationSet: (0, $28qg3.updatePluginStateDecorations)(state, [], (0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_LINE)
            }
        }));
const $7f9453c8604163f6$export$f217071b524cec4f = (hovered)=>(0, $4GJqd.createCommand)(()=>{
        return {
            type: 'TABLE_HOVERED',
            data: {
                isTableHovered: hovered
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $7f9453c8604163f6$export$1d614a0f0fe37c44 = (rowIndex, colIndex)=>(0, $4GJqd.createCommand)((state)=>{
        const { hoveredCell: prevHoveredCell } = (0, $4GJqd.getPluginState)(state);
        // If no arguments have been passed then the intention it to reset the hover cell data
        const clear = rowIndex === undefined && colIndex === undefined;
        const nextRowIndex = clear ? undefined : rowIndex ?? prevHoveredCell.rowIndex;
        const nextColIndex = clear ? undefined : colIndex ?? prevHoveredCell.colIndex;
        if (nextRowIndex === prevHoveredCell.rowIndex && nextColIndex === prevHoveredCell.colIndex) return false;
        return {
            type: 'HOVER_CELL',
            data: {
                hoveredCell: {
                    rowIndex: nextRowIndex,
                    colIndex: nextColIndex
                }
            }
        };
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("jo7Pl", function(module, exports) {
$parcel$export(module.exports, "getMergedCellsPositions", () => $b137630d1a0d2454$export$ffded79ba5549697);
$parcel$export(module.exports, "getAssistiveMessage", () => $b137630d1a0d2454$export$cea95ea93d5f9224);

var $lqHJB = parcelRequire("lqHJB");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");
const $b137630d1a0d2454$export$ffded79ba5549697 = (tr)=>{
    const table = (0, $5n2u9.findTable)(tr.selection);
    if (!table) return [];
    const map = (0, $dpooP.TableMap).get(table.node);
    const cellPositions = new Set();
    const mergedCells = [];
    map.map.forEach((value)=>{
        if (cellPositions.has(value)) mergedCells.push(value);
        else cellPositions.add(value);
    });
    return mergedCells;
};
const $b137630d1a0d2454$export$cea95ea93d5f9224 = (prevTableNode, currentTableNode, intl)=>{
    const { formatMessage: formatMessage } = intl;
    const prevTableMap = (0, $dpooP.TableMap).get(prevTableNode);
    const currentTableMap = (0, $dpooP.TableMap).get(currentTableNode);
    if (currentTableMap.width !== prevTableMap.width) {
        const diff = Math.abs(currentTableMap.width - prevTableMap.width);
        if (currentTableMap.width > prevTableMap.width) return formatMessage((0, $lqHJB.messages).columnsAreInserted, {
            count: diff
        });
        if (currentTableMap.width < prevTableMap.width) return formatMessage((0, $lqHJB.messages).columnsAreRemoved, {
            count: diff
        });
    }
    if (currentTableMap.height !== prevTableMap.height) {
        const diff = Math.abs(currentTableMap.height - prevTableMap.height);
        if (currentTableMap.height > prevTableMap.height) return formatMessage((0, $lqHJB.messages).rowsAreInserted, {
            count: diff
        });
        if (currentTableMap.height < prevTableMap.height) return formatMessage((0, $lqHJB.messages).rowsAreRemoved, {
            count: diff
        });
    }
    return '';
};

});


parcelRegister("lFzKY", function(module, exports) {
$parcel$export(module.exports, "removeDescendantNodes", () => $9429921a8abb7264$export$fa79c3ccfdddfece);
// eslint-disable-next-line import/order

var $2qSeE = parcelRequire("2qSeE");

var $4GJqd = parcelRequire("4GJqd");
const $9429921a8abb7264$export$fa79c3ccfdddfece = (sourceNode)=>(0, $4GJqd.createCommand)({
        type: 'UPDATE_STATE',
        data: {
            element: undefined
        }
    }, (tr, state)=>{
        return sourceNode ? (0, $2qSeE.removeConnectedNodes)(state, sourceNode) : tr;
    });

});

parcelRegister("kfljr", function(module, exports) {
$parcel$export(module.exports, "emptyMultipleCellsWithAnalytics", () => $b4ef46d2693c649c$export$67e5a2aa802b5be1);
$parcel$export(module.exports, "mergeCellsWithAnalytics", () => $b4ef46d2693c649c$export$96680f9d22153cab);
$parcel$export(module.exports, "splitCellWithAnalytics", () => $b4ef46d2693c649c$export$e30671f873d3125c);
$parcel$export(module.exports, "setColorWithAnalytics", () => $b4ef46d2693c649c$export$d0cc02883d6bbba);
$parcel$export(module.exports, "setCellVerticalAlignmentWithAnalytics", () => $b4ef46d2693c649c$export$816bc15c63933c5f);
$parcel$export(module.exports, "addRowAroundSelection", () => $b4ef46d2693c649c$export$4df69ad9d7ac565d);
$parcel$export(module.exports, "insertRowWithAnalytics", () => $b4ef46d2693c649c$export$e45f3a1f9c021052);
$parcel$export(module.exports, "changeColumnWidthByStepWithAnalytics", () => $b4ef46d2693c649c$export$e75fc938db126e1a);
$parcel$export(module.exports, "insertColumnWithAnalytics", () => $b4ef46d2693c649c$export$fc693eab55df8b35);
$parcel$export(module.exports, "deleteRowsWithAnalytics", () => $b4ef46d2693c649c$export$ad9854279980efbe);
$parcel$export(module.exports, "deleteColumnsWithAnalytics", () => $b4ef46d2693c649c$export$4c11b948fab97510);
$parcel$export(module.exports, "deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut", () => $b4ef46d2693c649c$export$a5b48d8f68e0fbd);
$parcel$export(module.exports, "deleteTableWithAnalytics", () => $b4ef46d2693c649c$export$3e2fb93914330b82);
$parcel$export(module.exports, "deleteTableIfSelectedWithAnalytics", () => $b4ef46d2693c649c$export$253ebd9c41cefd54);
$parcel$export(module.exports, "toggleHeaderRowWithAnalytics", () => $b4ef46d2693c649c$export$2e66edaa488e7a1d);
$parcel$export(module.exports, "toggleHeaderColumnWithAnalytics", () => $b4ef46d2693c649c$export$9fd5a66fcada8ad2);
$parcel$export(module.exports, "toggleNumberColumnWithAnalytics", () => $b4ef46d2693c649c$export$9e4b8d27ecc9c55);
$parcel$export(module.exports, "sortColumnWithAnalytics", () => $b4ef46d2693c649c$export$1be9cb7a554871e3);
$parcel$export(module.exports, "distributeColumnsWidthsWithAnalytics", () => $b4ef46d2693c649c$export$9bca7816a0c95373);
$parcel$export(module.exports, "wrapTableInExpandWithAnalytics", () => $b4ef46d2693c649c$export$70cd1c3ffea1a5d0);
$parcel$export(module.exports, "toggleFixedColumnWidthsOptionAnalytics", () => $b4ef46d2693c649c$export$ebf85a007abbf908);
$parcel$export(module.exports, "setTableAlignmentWithAnalytics", () => $b4ef46d2693c649c$export$5d8dfbdf832abbae);
$parcel$export(module.exports, "setTableAlignmentWithTableContentWithPosWithAnalytics", () => $b4ef46d2693c649c$export$58691b745e97f79d);

var $63Q5S = parcelRequire("63Q5S");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $cTbwC = parcelRequire("cTbwC");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $6AHSo = parcelRequire("6AHSo");
var $elHd5 = parcelRequire("elHd5");

var $l5gi8 = parcelRequire("l5gi8");

var $4GJqd = parcelRequire("4GJqd");

var $khYTo = parcelRequire("khYTo");

var $gCkVm = parcelRequire("gCkVm");

var $fPwP3 = parcelRequire("fPwP3");

var $4Bf8g = parcelRequire("4Bf8g");

var $4WYVI = parcelRequire("4WYVI");

var $fXgtc = parcelRequire("fXgtc");

var $3HCtZ = parcelRequire("3HCtZ");

var $hVZWA = parcelRequire("hVZWA");

var $eCvtY = parcelRequire("eCvtY");

var $hLBK7 = parcelRequire("hLBK7");

var $jEslx = parcelRequire("jEslx");

var $8L6TV = parcelRequire("8L6TV");

var $Qalab = parcelRequire("Qalab");

var $khBKG = parcelRequire("khBKG");

var $3Gwyn = parcelRequire("3Gwyn");
const $b4ef46d2693c649c$export$67e5a2aa802b5be1 = (editorAnalyticsAPI)=>(inputMethod, targetCellPosition)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedCellInfo)(selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).CLEARED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $fXgtc.clearMultipleCells)(targetCellPosition));
const $b4ef46d2693c649c$export$96680f9d22153cab = (editorAnalyticsAPI)=>(inputMethod)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedCellInfo)(selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).MERGED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $fPwP3.mergeCells)(state.tr));
            return true;
        });
const $b4ef46d2693c649c$export$e30671f873d3125c = (editorAnalyticsAPI)=>(inputMethod)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedCellInfo)(selection);
            const cell = (0, $6AHSo.findCellClosestToPos)(selection.$anchor);
            if (cell) {
                const { rowspan: verticalCells, colspan: horizontalCells } = cell.node.attrs;
                return {
                    action: (0, $8d4kB.TABLE_ACTION).SPLIT,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: horizontalCells * verticalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                };
            }
            return;
        })(editorAnalyticsAPI)((0, $khBKG.splitCell));
const $b4ef46d2693c649c$export$d0cc02883d6bbba = (editorAnalyticsAPI)=>(inputMethod, cellColor, editorView)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedCellInfo)(selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).COLORED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    cellColor: ((0, $63Q5S.tableBackgroundColorNameByHex).get(cellColor.toLowerCase()) || cellColor).toLowerCase(),
                    horizontalCells: horizontalCells,
                    verticalCells: verticalCells,
                    totalCells: totalCells,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $8L6TV.setMultipleCellAttrs)({
            background: cellColor
        }, editorView));
const $b4ef46d2693c649c$var$getNormalizedCellValign = (valign)=>valign ?? 'top';
const $b4ef46d2693c649c$var$getCellVerticalAlignmentAnalyticsInfo = (selection, valign, targetCellPosition)=>{
    const selectedValigns = [];
    if (selection instanceof (0, $ev7OZ.CellSelection)) selection.forEachCell((cell)=>{
        selectedValigns.push($b4ef46d2693c649c$var$getNormalizedCellValign(cell.attrs.valign));
    });
    else if (typeof targetCellPosition === 'number') {
        const cell = selection.$from.doc.nodeAt(targetCellPosition);
        if (cell) selectedValigns.push($b4ef46d2693c649c$var$getNormalizedCellValign(cell.attrs.valign));
    }
    if (selectedValigns.length === 0) return undefined;
    const [firstValign] = selectedValigns;
    const previousValign = selectedValigns.every((selectedValign)=>selectedValign === firstValign) ? firstValign : 'mixed';
    const updatedCount = selectedValigns.filter((selectedValign)=>selectedValign !== valign).length;
    return {
        previousValign: previousValign,
        updatedCount: updatedCount
    };
};
const $b4ef46d2693c649c$export$816bc15c63933c5f = (editorAnalyticsAPI)=>(inputMethod, valign, targetCellPosition)=>({ tr: tr })=>{
            const analyticsInfo = $b4ef46d2693c649c$var$getCellVerticalAlignmentAnalyticsInfo(tr.selection, valign, targetCellPosition);
            const result = (0, $8L6TV.setMultipleCellAttrsEditorCommand)({
                valign: valign
            }, targetCellPosition)({
                tr: tr
            });
            if (result && analyticsInfo) {
                const { horizontalCells: horizontalCells, verticalCells: verticalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedCellInfo)(tr.selection);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $8d4kB.TABLE_ACTION).CHANGED_CELL_VERTICAL_ALIGNMENT,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        inputMethod: inputMethod,
                        previousValign: analyticsInfo.previousValign,
                        valign: valign,
                        updatedCount: analyticsInfo.updatedCount,
                        horizontalCells: horizontalCells,
                        verticalCells: verticalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(tr);
            }
            return result;
        };
const $b4ef46d2693c649c$export$4df69ad9d7ac565d = (editorAnalyticsAPI)=>(side)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const isCellSelection = selection instanceof (0, $ev7OZ.CellSelection);
            const rect = isCellSelection ? (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);
            if (!rect) return false;
            const position = isCellSelection && side === 'TOP' ? rect.top : rect.bottom - 1;
            const offset = side === 'BOTTOM' ? 1 : 0;
            return $b4ef46d2693c649c$export$e45f3a1f9c021052(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).SHORTCUT, {
                index: position + offset,
                moveCursorToInsertedRow: false
            })(state, dispatch);
        };
const $b4ef46d2693c649c$export$e45f3a1f9c021052 = (editorAnalyticsAPI)=>(inputMethod, options)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).ADDED_ROW,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: options.index,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $jEslx.insertRow)(options.index, options.moveCursorToInsertedRow));
const $b4ef46d2693c649c$export$e75fc938db126e1a = (editorAnalyticsAPI, api)=>(stepSize, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor, inputMethod, ariaNotify, getIntl)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
            const { hoveredCell: { colIndex: colIndex } } = (0, $4GJqd.getPluginState)(state);
            return {
                action: (0, $8d4kB.TABLE_ACTION).COLUMN_RESIZED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    colIndex: colIndex,
                    resizedDelta: stepSize,
                    isLastColumn: colIndex === totalColumnCount - 1,
                    tableWidth: table === null || table === void 0 ? void 0 : table.node.attrs.width,
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                }
            };
        })(editorAnalyticsAPI)((0, $hVZWA.changeColumnWidthByStep)({
            stepSize: stepSize,
            getEditorContainerWidth: getEditorContainerWidth,
            isTableScalingEnabled: isTableScalingEnabled,
            isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled,
            isCommentEditor: isCommentEditor,
            ariaNotify: ariaNotify,
            getIntl: getIntl,
            api: api
        }));
const $b4ef46d2693c649c$export$fc693eab55df8b35 = (api, editorAnalyticsAPI, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, position)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).ADDED_COLUMN,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: position,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $jEslx.insertColumn)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(position));
const $b4ef46d2693c649c$export$ad9854279980efbe = (editorAnalyticsAPI)=>(inputMethod, rect, isHeaderRowRequired)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).DELETED_ROW,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.top,
                    count: rect.bottom - rect.top,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) dispatch((0, $gCkVm.deleteRows)(rect, isHeaderRowRequired)(state.tr));
            return true;
        });
const $b4ef46d2693c649c$export$4c11b948fab97510 = (editorAnalyticsAPI, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(inputMethod, rect)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).DELETED_COLUMN,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    position: rect.left,
                    count: rect.right - rect.left,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $eCvtY.deleteColumnsCommand)(rect, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor));
const $b4ef46d2693c649c$export$a5b48d8f68e0fbd = (editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const isCellSelection = selection instanceof (0, $ev7OZ.CellSelection);
        if (!isCellSelection) return false;
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        if (!rect) return false;
        const selectionType = (0, $8L6TV.getTableSelectionType)(selection);
        if (selectionType === 'row') {
            const { pluginConfig: pluginConfig } = (0, $4GJqd.getPluginState)(state);
            const isHeaderRowRequired = pluginConfig.isHeaderRowRequired || false;
            return $b4ef46d2693c649c$export$ad9854279980efbe(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).SHORTCUT, rect, isHeaderRowRequired)(state, dispatch);
        } else if (selectionType === 'column') return $b4ef46d2693c649c$export$4c11b948fab97510(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)((0, $3LeME.INPUT_METHOD).SHORTCUT, rect)(state, dispatch);
        else return false;
    };
const $b4ef46d2693c649c$var$getTableDeletedAnalytics = (selection, inputMethod)=>{
    const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(selection);
    return {
        action: (0, $8d4kB.TABLE_ACTION).DELETED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        attributes: {
            inputMethod: inputMethod,
            totalRowCount: totalRowCount,
            totalColumnCount: totalColumnCount
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    };
};
const $b4ef46d2693c649c$export$3e2fb93914330b82 = (editorAnalyticsAPI)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>$b4ef46d2693c649c$var$getTableDeletedAnalytics(selection, (0, $3LeME.INPUT_METHOD).FLOATING_TB))(editorAnalyticsAPI)((0, $8L6TV.deleteTable));
const $b4ef46d2693c649c$export$253ebd9c41cefd54 = (editorAnalyticsAPI)=>(inputMethod)=>(0, $4Bf8g.withEditorAnalyticsAPI)(({ selection: selection })=>$b4ef46d2693c649c$var$getTableDeletedAnalytics(selection, inputMethod))(editorAnalyticsAPI)((0, $8L6TV.deleteTableIfSelected));
const $b4ef46d2693c649c$export$2e66edaa488e7a1d = (editorAnalyticsAPI)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
        const { isHeaderRowEnabled: isHeaderRowEnabled } = (0, $4GJqd.getPluginState)(state);
        return {
            action: (0, $8d4kB.TABLE_ACTION).TOGGLED_HEADER_ROW,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderRowEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $3Gwyn.toggleHeaderRow));
const $b4ef46d2693c649c$export$9fd5a66fcada8ad2 = (editorAnalyticsAPI)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
        const { isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $4GJqd.getPluginState)(state);
        return {
            action: (0, $8d4kB.TABLE_ACTION).TOGGLED_HEADER_COLUMN,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !isHeaderColumnEnabled,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $3Gwyn.toggleHeaderColumn));
const $b4ef46d2693c649c$export$9e4b8d27ecc9c55 = (editorAnalyticsAPI)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
        return {
            action: (0, $8d4kB.TABLE_ACTION).TOGGLED_NUMBER_COLUMN,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                newState: !(0, $4WYVI.checkIfNumberColumnEnabled)(state.selection),
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $3Gwyn.toggleNumberColumn));
const $b4ef46d2693c649c$export$1be9cb7a554871e3 = (editorAnalyticsAPI)=>(inputMethod, columnIndex, sortOrder)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).SORTED_COLUMN,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                attributes: {
                    inputMethod: inputMethod,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    position: columnIndex,
                    sortOrder: sortOrder,
                    mode: 'editor'
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((0, $Qalab.sortByColumn)(columnIndex, sortOrder));
const $b4ef46d2693c649c$export$9bca7816a0c95373 = (editorAnalyticsAPI, api)=>(inputMethod, { resizeState: resizeState, table: table, attributes: attributes })=>{
        return (0, $4Bf8g.withEditorAnalyticsAPI)(()=>{
            return {
                action: (0, $8d4kB.TABLE_ACTION).DISTRIBUTED_COLUMNS_WIDTHS,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                attributes: {
                    inputMethod: inputMethod,
                    ...attributes
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            };
        })(editorAnalyticsAPI)((state, dispatch)=>{
            if (dispatch) (0, $khYTo.distributeColumnsWidths)(resizeState, table, api)(state, dispatch);
            return true;
        });
    };
const $b4ef46d2693c649c$export$70cd1c3ffea1a5d0 = (editorAnalyticsAPI)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
        return {
            action: (0, $8d4kB.TABLE_ACTION).COLLAPSED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            attributes: {
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $3HCtZ.wrapTableInExpand));
const $b4ef46d2693c649c$export$ebf85a007abbf908 = (editorAnalyticsAPI, inputMethod)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
        const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
        let previousDisplayMode;
        let newDisplayMode;
        switch(table === null || table === void 0 ? void 0 : table.node.attrs.displayMode){
            case 'fixed':
                previousDisplayMode = (0, $8d4kB.TABLE_DISPLAY_MODE).FIXED;
                newDisplayMode = (0, $8d4kB.TABLE_DISPLAY_MODE).DEFAULT;
                break;
            case 'default':
                previousDisplayMode = (0, $8d4kB.TABLE_DISPLAY_MODE).DEFAULT;
                newDisplayMode = (0, $8d4kB.TABLE_DISPLAY_MODE).FIXED;
                break;
            case null:
            default:
                previousDisplayMode = (0, $8d4kB.TABLE_DISPLAY_MODE).INITIAL;
                newDisplayMode = (0, $8d4kB.TABLE_DISPLAY_MODE).FIXED;
        }
        return {
            action: (0, $8d4kB.TABLE_ACTION).CHANGED_DISPLAY_MODE,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            attributes: {
                inputMethod: inputMethod,
                previousDisplayMode: previousDisplayMode,
                newDisplayMode: newDisplayMode,
                tableWidth: table === null || table === void 0 ? void 0 : table.node.attrs.width,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount
            },
            eventType: (0, $3LeME.EVENT_TYPE).TRACK
        };
    })(editorAnalyticsAPI)((0, $cTbwC.editorCommandToPMCommand)((0, $hLBK7.setTableDisplayMode)));
const $b4ef46d2693c649c$export$5d8dfbdf832abbae = (editorAnalyticsAPI, isCommentEditor)=>(newAlignment, previousAlignment, inputMethod, reason)=>(0, $4Bf8g.withEditorAnalyticsAPI)((state)=>{
            const { table: table, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
            return {
                action: (0, $8d4kB.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: {
                    tableWidth: table === null || table === void 0 ? void 0 : table.node.attrs.width,
                    newAlignment: newAlignment,
                    previousAlignment: previousAlignment === 'center' || previousAlignment === 'align-start' ? previousAlignment : null,
                    totalRowCount: totalRowCount,
                    totalColumnCount: totalColumnCount,
                    inputMethod: inputMethod,
                    reason: reason
                }
            };
        })(editorAnalyticsAPI)((0, $cTbwC.editorCommandToPMCommand)((0, $8L6TV.setTableAlignment)(newAlignment, isCommentEditor)));
const $b4ef46d2693c649c$export$58691b745e97f79d = (editorAnalyticsAPI)=>(newAlignment, previousAlignment, tableNodeWithPos, inputMethod, reason)=>(0, $4Bf8g.withEditorAnalyticsAPI)(()=>{
            const map = (0, $dpooP.TableMap).get(tableNodeWithPos.node);
            const totalRowCount = map.height;
            const totalColumnCount = map.width;
            const attributes = {
                tableWidth: tableNodeWithPos.node.attrs.width,
                newAlignment: newAlignment,
                previousAlignment: previousAlignment,
                totalRowCount: totalRowCount,
                totalColumnCount: totalColumnCount,
                inputMethod: inputMethod,
                reason: reason
            };
            return {
                action: (0, $8d4kB.TABLE_ACTION).CHANGED_ALIGNMENT,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                actionSubjectId: null,
                eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                attributes: attributes
            };
        })(editorAnalyticsAPI)((0, $cTbwC.editorCommandToPMCommand)((0, $8L6TV.setTableAlignmentWithTableContentWithPos)(newAlignment, tableNodeWithPos)));

});
parcelRegister("khYTo", function(module, exports) {
$parcel$export(module.exports, "evenColumns", () => $9f71a4f67630c2a0$export$c955b9a736441250);
$parcel$export(module.exports, "distributeColumnsWidths", () => $9f71a4f67630c2a0$export$e8f15c4883bd4cb9);
$parcel$export(module.exports, "stopResizing", () => $9f71a4f67630c2a0$export$d1301521f1f26547);
$parcel$export(module.exports, "setResizeHandlePos", () => $9f71a4f67630c2a0$export$4d14ce8b526952e5);
$parcel$export(module.exports, "setDragging", () => $9f71a4f67630c2a0$export$e747fb9908ce65b7);

var $8d4kB = parcelRequire("8d4kB");

var $kD3Xq = parcelRequire("kD3Xq");

var $lh6cf = parcelRequire("lh6cf");

var $04vvT = parcelRequire("04vvT");

var $6xtYM = parcelRequire("6xtYM");

var $7JtQD = parcelRequire("7JtQD");

var $26jxM = parcelRequire("26jxM");
const $9f71a4f67630c2a0$export$c955b9a736441250 = ({ resizeState: resizeState, table: table, start: start, event: event, api: api })=>(state, dispatch)=>{
        if (!(0, $kD3Xq.isTableSelected)(state.selection)) return false;
        // double click detection logic
        // Note: ProseMirror's handleDoubleClick doesn't quite work with DOM mousedown event handler
        const { lastClick: lastClick } = (0, $6xtYM.getPluginState)(state);
        const now = Date.now();
        if (lastClick && now - lastClick.time < 500 && (0, $7JtQD.isClickNear)(event, lastClick)) {
            const newState = (0, $26jxM.evenAllColumnsWidths)(resizeState);
            $9f71a4f67630c2a0$var$setLastClick(null, (tr)=>(0, $04vvT.updateColumnWidths)(newState, table, start, api)(tr))(state, dispatch);
            return true;
        }
        $9f71a4f67630c2a0$var$setLastClick({
            x: event.clientX,
            y: event.clientY,
            time: now
        })(state, dispatch);
        return false;
    };
const $9f71a4f67630c2a0$export$e8f15c4883bd4cb9 = (newResizeState, table, api)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $04vvT.updateColumnWidths)(newResizeState, table.node, table.start, api)(state.tr);
            tr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
                name: (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).DISTRIBUTED_COLUMNS
            });
            $9f71a4f67630c2a0$export$d1301521f1f26547(tr)(state, dispatch);
        }
        return true;
    };
const $9f71a4f67630c2a0$export$4d14ce8b526952e5 = (resizeHandlePos)=>(0, $6xtYM.createCommand)({
        type: 'SET_RESIZE_HANDLE_POSITION',
        data: {
            resizeHandlePos: resizeHandlePos
        }
    });
const $9f71a4f67630c2a0$export$d1301521f1f26547 = (tr)=>(0, $6xtYM.createCommand)({
        type: 'STOP_RESIZING'
    }, (originalTr)=>(tr || originalTr).setMeta('scrollIntoView', false).setMeta('is-resizer-resizing', false));
const $9f71a4f67630c2a0$export$e747fb9908ce65b7 = (dragging, tr)=>(0, $6xtYM.createCommand)({
        type: 'SET_DRAGGING',
        data: {
            dragging: dragging
        }
    }, (originalTr)=>(tr || originalTr).setMeta('is-resizer-resizing', true));
const $9f71a4f67630c2a0$var$setLastClick = (lastClick, transform)=>(0, $6xtYM.createCommand)({
        type: 'SET_LAST_CLICK',
        data: {
            lastClick: lastClick
        }
    }, transform);

});
parcelRegister("6xtYM", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $fb5a06916aba26aa$export$8d4021544bdece00);
$parcel$export(module.exports, "createPluginState", () => $fb5a06916aba26aa$export$656c7661095efe2e);
$parcel$export(module.exports, "getPluginState", () => $fb5a06916aba26aa$export$f05434c51e3762e);
// eslint-disable-next-line import/order

var $92jIL = parcelRequire("92jIL");

var $gQDgk = parcelRequire("gQDgk");

var $5VcuM = parcelRequire("5VcuM");
function $fb5a06916aba26aa$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.resizeHandlePos !== null) return {
        ...pluginState,
        resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    };
    return pluginState;
}
const $fb5a06916aba26aa$var$factory = (0, $92jIL.pluginFactory)((0, $gQDgk.pluginKey), (0, $5VcuM.default), {
    mapping: $fb5a06916aba26aa$var$mapping
});
const $fb5a06916aba26aa$export$8d4021544bdece00 = $fb5a06916aba26aa$var$factory.createCommand;
const $fb5a06916aba26aa$export$656c7661095efe2e = $fb5a06916aba26aa$var$factory.createPluginState;
const $fb5a06916aba26aa$export$f05434c51e3762e = $fb5a06916aba26aa$var$factory.getPluginState;

});
parcelRegister("5VcuM", function(module, exports) {
$parcel$export(module.exports, "default", () => $f027505244f41d12$export$2e2bcd8739ae039);
var $f027505244f41d12$export$2e2bcd8739ae039 = (pluginState, action)=>{
    switch(action.type){
        case 'STOP_RESIZING':
            return {
                ...pluginState,
                resizeHandlePos: null,
                dragging: null
            };
        case 'SET_RESIZE_HANDLE_POSITION':
            return {
                ...pluginState,
                resizeHandlePos: action.data.resizeHandlePos
            };
        case 'SET_DRAGGING':
            return {
                ...pluginState,
                dragging: action.data.dragging
            };
        case 'SET_LAST_CLICK':
            const { lastClick: lastClick } = action.data;
            return {
                ...pluginState,
                lastClick: lastClick,
                resizeHandlePos: lastClick ? pluginState.resizeHandlePos : null
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("gCkVm", function(module, exports) {
$parcel$export(module.exports, "deleteRows", () => $3e09ff0700e7361c$export$88b7a0bb8d808bf6);

var $801jp = parcelRequire("801jp");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $4dyXt = parcelRequire("4dyXt");

var $fPwP3 = parcelRequire("fPwP3");
const $3e09ff0700e7361c$export$88b7a0bb8d808bf6 = (rect, isHeaderRowRequired = false)=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        const rowsToDelete = [];
        const map = (0, $dpooP.TableMap).get(table.node);
        for(let i = rect.top; i < rect.bottom; i++)// skip header row if its required
        if (isHeaderRowRequired) {
            const cell = table.node.nodeAt(map.map[i * map.width]);
            if (cell && cell.type !== cell.type.schema.nodes.tableHeader) rowsToDelete.push(i);
        } else rowsToDelete.push(i);
        if (!rowsToDelete.length) return tr;
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInRow = map.cellsInRect({
                    left: 0,
                    top: rowIndex,
                    right: map.width,
                    bottom: rowIndex + 1
                });
                if (rowsToDelete.indexOf(rowIndex) === -1 && !seen[cellPos]) {
                    // decrement rowspans for row-spanning cells that overlap deleted rows
                    if (cellsInRow.indexOf(cellPos) > -1) {
                        let overlappingRows = 0;
                        rowsToDelete.forEach((rowIndexToDelete)=>{
                            if (rowIndex < rowIndexToDelete && cell.attrs.rowspan + rowIndex - 1 >= rowIndexToDelete) overlappingRows += 1;
                        });
                        if (overlappingRows > 0) {
                            const newCell = cell.type.createChecked({
                                ...cell.attrs,
                                rowspan: cell.attrs.rowspan - overlappingRows
                            }, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a row-spanning cell, we need to add missing cells to rows below
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInRow.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = (0, $fPwP3.mergeEmptyColumns)(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $3e09ff0700e7361c$var$getNextCursorPos(newTable, rowsToDelete);
        // If we delete a row we should also clean up the hover selection
        tr.setMeta((0, $4dyXt.pluginKey), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor before the deleted rows if possible, otherwise - to the first row
        .setSelection((0, $801jp.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $3e09ff0700e7361c$var$getNextCursorPos(table, deletedRows) {
    const minRow = Math.min(...deletedRows);
    const nextRowWithCursor = minRow > 0 ? minRow - 1 : 0;
    const map = (0, $dpooP.TableMap).get(table);
    return map.map[nextRowWithCursor * map.width];
}

});
parcelRegister("fPwP3", function(module, exports) {
$parcel$export(module.exports, "mergeCells", () => $b664967145fef442$export$124b0cee26577176);
$parcel$export(module.exports, "canMergeCells", () => $b664967145fef442$export$9df87bad3fce982f);
$parcel$export(module.exports, "mergeEmptyColumns", () => $b664967145fef442$export$84575ef2cffee22a);
$parcel$export(module.exports, "canMergeCellSelection", () => $b664967145fef442$export$61c1a939609d5bfa);

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $l5gi8 = parcelRequire("l5gi8");
function $b664967145fef442$export$124b0cee26577176(tr) {
    const { selection: selection } = tr;
    if (!(selection instanceof (0, $ev7OZ.CellSelection)) || !$b664967145fef442$export$9df87bad3fce982f(tr)) return tr;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $5n2u9.findTable)(selection);
    const map = (0, $dpooP.TableMap).get(table.node);
    const seen = [];
    const selectedCells = map.cellsInRect(rect);
    let mergedCellPos;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const row = table.node.child(rowIndex);
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = table.node.nodeAt(cellPos);
            if (!cell || seen.indexOf(cellPos) > -1) continue;
            seen.push(cellPos);
            // merged cell
            if (colIndex === rect.left && rowIndex === rect.top) {
                mergedCellPos = cellPos;
                // merge content of the selected cells, dropping empty cells
                let content = $b664967145fef442$var$isEmptyCell(cell) ? (0, $7H6Cr.Fragment).empty : cell.content;
                const seenContent = [
                    mergedCellPos
                ];
                for(let i = rect.top; i < rect.bottom; i++)for(let j = rect.left; j < rect.right; j++){
                    const pos = map.map[i * map.width + j];
                    if (seenContent.indexOf(pos) === -1) {
                        seenContent.push(pos);
                        const copyCell = table.node.nodeAt(pos);
                        if (copyCell && !$b664967145fef442$var$isEmptyCell(copyCell)) content = content.append(copyCell.content);
                    }
                }
                const rowspan = rect.bottom - rect.top;
                if (rowspan < 1) return tr;
                // update colspan and rowspan of the merged cell to span the selection
                const attrs = $b664967145fef442$var$addColSpan({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.attrs.colspan, rect.right - rect.left - cell.attrs.colspan);
                const newCell = content === (0, $7H6Cr.Fragment).empty ? cell.type.createAndFill(attrs, content, cell.marks) : cell.type.createChecked(attrs, content, cell.marks);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                rowCells.push(newCell);
            } else if (selectedCells.indexOf(cellPos) === -1) // if its one of the selected cells, but not the merged cell, we get rid of it
            // otherwise we keep the cell
            rowCells.push(cell);
        }
        if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        else // empty row, we need to fix rowspans for rows above the current one
        for(let i = rows.length - 1; i >= 0; i--){
            const prevRow = rows[i];
            const cells = [];
            let rowChanged = false;
            for(let j = 0; j < prevRow.childCount; j++){
                const cell = prevRow.child(j);
                const { rowspan: rowspan } = cell.attrs;
                if (rowspan && rowspan + i - 1 >= rows.length) {
                    rowChanged = true;
                    if (rowspan < 2) return tr;
                    cells.push(cell.type.createChecked({
                        ...cell.attrs,
                        rowspan: rowspan - 1
                    }, cell.content, cell.marks));
                } else cells.push(cell);
            }
            if (rowChanged) rows[i] = row.type.createChecked(prevRow.attrs, cells, prevRow.marks);
        }
    }
    // empty tables? cancel merging like nothing happened
    if (!rows.length) return tr;
    const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
    const fixedTable = $b664967145fef442$export$84575ef2cffee22a(newTable);
    if (fixedTable === null) return tr;
    return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable).setSelection((0, $801jp.Selection).near(tr.doc.resolve((mergedCellPos || 0) + table.start)));
}
function $b664967145fef442$export$61c1a939609d5bfa(selection) {
    if (!(selection instanceof (0, $ev7OZ.CellSelection)) || selection.$anchorCell.pos === selection.$headCell.pos) return false;
    const rect = (0, $l5gi8.getSelectionRect)(selection);
    if (!rect) return false;
    const table = selection.$anchorCell.node(-1);
    const map = (0, $dpooP.TableMap).get(table);
    if ($b664967145fef442$var$cellsOverlapRectangle(map, rect)) return false;
    return true;
}
function $b664967145fef442$export$9df87bad3fce982f(tr) {
    return $b664967145fef442$export$61c1a939609d5bfa(tr.selection);
}
function $b664967145fef442$var$isEmptyCell(cell) {
    const { content: content } = cell;
    return content.childCount === 1 && content.firstChild && content.firstChild.isTextblock && content.firstChild.childCount === 0;
}
function $b664967145fef442$var$addColSpan(attrs, pos, span = 1) {
    const newAttrs = {
        ...attrs,
        colspan: (attrs.colspan || 1) + span
    };
    if (newAttrs.colwidth) {
        newAttrs.colwidth = newAttrs.colwidth.slice();
        for(let i = 0; i < span; i++)newAttrs.colwidth.splice(pos, 0, 0);
    }
    return newAttrs;
}
function $b664967145fef442$var$cellsOverlapRectangle({ width: width, height: height, map: map }, rect) {
    let indexTop = rect.top * width + rect.left;
    let indexLeft = indexTop;
    let indexBottom = (rect.bottom - 1) * width + rect.left;
    let indexRight = indexTop + (rect.right - rect.left - 1);
    for(let i = rect.top; i < rect.bottom; i++){
        if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) return true;
        indexLeft += width;
        indexRight += width;
    }
    for(let i = rect.left; i < rect.right; i++){
        if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) return true;
        indexTop++;
        indexBottom++;
    }
    return false;
}
// returns an array of numbers, each number indicates the minimum colSpan in each column
function $b664967145fef442$var$getEmptyColumnIndexes(table) {
    const map = (0, $dpooP.TableMap).get(table);
    const emptyColumnIndexes = new Set();
    // Loop throuh each column
    for(let colIndex = 0; colIndex < map.width; colIndex++){
        // Get the cells in each row for this column
        const cellPositions = map.cellsInRect({
            left: colIndex,
            right: colIndex + 1,
            top: 0,
            bottom: map.height
        });
        // If no cells exist in that column it is empty
        if (!cellPositions.length) emptyColumnIndexes.add(colIndex);
    }
    return emptyColumnIndexes;
}
function $b664967145fef442$export$84575ef2cffee22a(table) {
    const rows = [];
    const map = (0, $dpooP.TableMap).get(table);
    const emptyColumnIndexes = $b664967145fef442$var$getEmptyColumnIndexes(table);
    // We don't need to remove any so return early.
    if (emptyColumnIndexes.size === 0) return table;
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellsByCols = {};
        // Work backwards so that calculating colwidths is easier with Array.slice
        for(let colIndex = map.width - 1; colIndex >= 0; colIndex--){
            const cellPos = map.map[colIndex + rowIndex * map.width];
            const rect = map.findCell(cellPos);
            let cell = cellsByCols[rect.left] || table.nodeAt(cellPos);
            if (rect.top !== rowIndex) continue;
            // If this column is empty, we want to decrement the colspan of its corresponding
            // cell as this column is being "merged"
            if (emptyColumnIndexes.has(colIndex)) {
                const { colspan: colspan, colwidth: colwidth } = cell.attrs;
                if (colspan > 1) cell = cell.type.createChecked({
                    ...cell.attrs,
                    colspan: colspan - 1,
                    colwidth: colwidth ? colwidth.slice(0, colspan) : null
                }, cell.content, cell.marks);
            }
            cellsByCols[rect.left] = cell;
        }
        const rowCells = Object.values(cellsByCols);
        const row = table.child(rowIndex);
        if (row) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}

});


parcelRegister("fXgtc", function(module, exports) {
$parcel$export(module.exports, "clearMultipleCells", () => $9f4948d9ddc38d1c$export$5d68db27bfdddb78);

var $801jp = parcelRequire("801jp");

var $6AHSo = parcelRequire("6AHSo");

var $bsQpd = parcelRequire("bsQpd");

var $2HFfw = parcelRequire("2HFfw");
const $9f4948d9ddc38d1c$export$5d68db27bfdddb78 = (targetCellPosition)=>(state, dispatch)=>{
        let cursorPos;
        let { tr: tr } = state;
        if ((0, $2HFfw.isSelectionType)(tr.selection, 'cell')) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const selection = tr.selection;
            selection.forEachCell((_node, pos)=>{
                const $pos = tr.doc.resolve(tr.mapping.map(pos + 1));
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                tr = (0, $bsQpd.emptyCell)((0, $6AHSo.findCellClosestToPos)($pos), state.schema)(tr);
            });
            cursorPos = selection.$headCell.pos;
        } else if (targetCellPosition) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $6AHSo.findCellClosestToPos)(tr.doc.resolve(targetCellPosition + 1));
            tr = (0, $bsQpd.emptyCell)(cell, state.schema)(tr);
            cursorPos = cell.pos;
        }
        if (tr.docChanged && cursorPos) {
            const $pos = tr.doc.resolve(tr.mapping.map(cursorPos));
            const textSelection = (0, $801jp.Selection).findFrom($pos, 1, true);
            if (textSelection) tr.setSelection(textSelection);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("bsQpd", function(module, exports) {
$parcel$export(module.exports, "emptyCell", () => $c6de18f6bd6ba5e1$export$1a1df84fec87e1b5);

var $dXesv = parcelRequire("dXesv");

var $9HFsx = parcelRequire("9HFsx");
const $c6de18f6bd6ba5e1$export$1a1df84fec87e1b5 = (cell, schema)=>(tr)=>{
        if (cell) {
            const node = (0, $9HFsx.tableNodeTypes)(schema).cell.createAndFill();
            if (node && !cell.node.content.eq(node.content)) {
                tr.replaceWith(cell.pos + 1, cell.pos + cell.node.nodeSize, node.content);
                return (0, $dXesv.cloneTr)(tr);
            }
        }
        return tr;
    };

});


parcelRegister("3HCtZ", function(module, exports) {
$parcel$export(module.exports, "wrapTableInExpand", () => $8f542b9527d756bf$export$8afb7fb379a7ebd1);

var $7XZJw = parcelRequire("7XZJw");
const $8f542b9527d756bf$export$8afb7fb379a7ebd1 = (state, dispatch)=>{
    const collapseTr = (0, $7XZJw.collapseSelectedTable)(state.tr);
    if (!collapseTr) return false;
    if (dispatch) dispatch(collapseTr);
    return true;
};

});

parcelRegister("hVZWA", function(module, exports) {
$parcel$export(module.exports, "initiateKeyboardColumnResizing", () => $b5be0815b6f67593$export$833f46f974daec36);
$parcel$export(module.exports, "activateNextResizeArea", () => $b5be0815b6f67593$export$44cde2b92e1bbc4a);
$parcel$export(module.exports, "changeColumnWidthByStep", () => $b5be0815b6f67593$export$4627714f08bcfd8);
$parcel$export(module.exports, "stopKeyboardColumnResizing", () => $b5be0815b6f67593$export$b77825ff607efdbb);

var $lqHJB = parcelRequire("lqHJB");

var $jd8X7 = parcelRequire("jd8X7");

var $dpooP = parcelRequire("dpooP");

var $6AHSo = parcelRequire("6AHSo");
var $elHd5 = parcelRequire("elHd5");
var $5JFXS = parcelRequire("5JFXS");
var $82clP = parcelRequire("82clP");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");

var $YREXK = parcelRequire("YREXK");

var $f3xW3 = parcelRequire("f3xW3");

var $7uENW = parcelRequire("7uENW");

var $4GJqd = parcelRequire("4GJqd");

var $6xtYM = parcelRequire("6xtYM");

var $gQDgk = parcelRequire("gQDgk");

var $7JtQD = parcelRequire("7JtQD");

var $7SttP = parcelRequire("7SttP");

var $9ug8S = parcelRequire("9ug8S");

var $26jxM = parcelRequire("26jxM");

var $04vvT = parcelRequire("04vvT");

var $ijKnh = parcelRequire("ijKnh");

var $2q9QJ = parcelRequire("2q9QJ");
const $b5be0815b6f67593$var$getTablePluginCommand = (actionPayload, originalTr)=>{
    return (0, $4GJqd.createCommand)(()=>actionPayload, (tr)=>(originalTr || tr).setMeta('addToHistory', false));
};
const $b5be0815b6f67593$var$updateResizeHandleAndStatePosition = (rowIndex, columnIndex, nextResizeHandlePos, nodeViewPortalProviderAPI)=>(state, dispatch)=>{
        let customTr = state.tr;
        const { pluginConfig: { allowColumnResizing: allowColumnResizing }, getIntl: getIntl } = (0, $4GJqd.getPluginState)(state);
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        if (!allowColumnResizing) return false;
        const decorationsWithWidget = (0, $7uENW.buildColumnResizingDecorations)(rowIndex, columnIndex, true, getIntl, nodeViewPortalProviderAPI)({
            tr: customTr,
            decorationSet: (0, $f3xW3.getDecorations)(state)
        });
        const decorationsWithWidgetAndHandle = (0, $ijKnh.updateDecorations)(customTr.doc, decorationsWithWidget, (0, $ijKnh.createColumnLineResize)(state.selection, {
            right: columnIndex
        }), (0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_LINE);
        $b5be0815b6f67593$var$getTablePluginCommand({
            type: 'START_KEYBOARD_COLUMN_RESIZE',
            data: {
                resizeHandleRowIndex: rowIndex,
                resizeHandleColumnIndex: columnIndex,
                resizeHandleIncludeTooltip: true,
                isKeyboardResize: true,
                decorationSet: decorationsWithWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        customTr.setMeta((0, $gQDgk.pluginKey), {
            type: 'SET_RESIZE_HANDLE_POSITION',
            data: {
                resizeHandlePos: nextResizeHandlePos
            }
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };
const $b5be0815b6f67593$export$833f46f974daec36 = ({ ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { selection: selection } = state;
        const selectionRect = (0, $2HFfw.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);
        const cell = (0, $6AHSo.findCellClosestToPos)(selection.$from);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).startedColumnResize), {
            priority: 'important'
        });
        if (selectionRect && cell && view) return $b5be0815b6f67593$var$updateResizeHandleAndStatePosition(selectionRect.top, selectionRect.right, cell.pos, nodeViewPortalProviderAPI)(state, dispatch);
        return false;
    };
const $b5be0815b6f67593$export$44cde2b92e1bbc4a = ({ direction: direction, ariaNotify: ariaNotify, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(state, dispatch, view)=>{
        const { resizeHandlePos: resizeHandlePos } = (0, $6xtYM.getPluginState)(state) || {};
        // If No resizing has initiated, skip to regular handler
        if (!resizeHandlePos) return false;
        const { selection: selection } = state;
        const cell = (0, $6AHSo.findCellClosestToPos)(selection.$from);
        if (!cell) // cursor position may be changed by mouse to be outside of table;
        return false;
        const $currentCell = state.doc.resolve(resizeHandlePos);
        if (!$currentCell) return false;
        const tableNode = $currentCell.node(-1);
        const closestTable = (0, $5JFXS.findTableClosestToPos)($currentCell);
        const tableMap = (0, $dpooP.TableMap).get(tableNode);
        if (!tableNode || !closestTable || !tableMap) return false;
        const currentCellRect = tableMap.findCell($currentCell.pos - $currentCell.start(-1));
        const $nextCell = (0, $82clP.nextCell)($currentCell, 'horiz', direction);
        if (ariaNotify && getIntl) {
            if (direction === 1) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).focusedOtherResize, {
                direction: 'right'
            }), {
                priority: 'important'
            });
            if (direction === -1) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).focusedOtherResize, {
                direction: 'left'
            }), {
                priority: 'important'
            });
        }
        if ($nextCell) {
            // we are somewhere in between the side columns of the table
            const offset = $nextCell.pos - $nextCell.start(-1);
            const rectForNextCell = tableMap.findCell(offset);
            return $b5be0815b6f67593$var$updateResizeHandleAndStatePosition(rectForNextCell.top, rectForNextCell.right, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
        } else {
            // current position is in the one of the side columns of the table(left or right)
            if (currentCellRect.left === 0) {
                const lastCellInCurrentRow = tableMap.positionAt(currentCellRect.top, tableMap.width - 1, tableNode) + closestTable.start;
                const $lastCell = state.doc.resolve(lastCellInCurrentRow);
                return $b5be0815b6f67593$var$updateResizeHandleAndStatePosition(currentCellRect.top, tableMap.width, $lastCell.pos, nodeViewPortalProviderAPI)(state, dispatch, view);
            } else if (tableMap.width === currentCellRect.right) {
                const firsCellInCurrentRow = tableMap.positionAt(currentCellRect.top, 0, tableNode) + closestTable.start;
                const $nextCell = state.doc.resolve(firsCellInCurrentRow);
                return $b5be0815b6f67593$var$updateResizeHandleAndStatePosition(currentCellRect.top, 1, $nextCell.pos, nodeViewPortalProviderAPI)(state, dispatch);
            }
        }
        return false;
    };
const $b5be0815b6f67593$export$4627714f08bcfd8 = ({ stepSize: stepSize, getEditorContainerWidth: getEditorContainerWidth, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isCommentEditor: isCommentEditor, ariaNotify: ariaNotify, api: api, getIntl: getIntl })=>(state, dispatch, view)=>{
        var _originalTable$attrs;
        let customTr = state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const { resizeHandlePos: resizeHandlePos } = (0, $6xtYM.getPluginState)(state);
        const cell = (0, $6AHSo.findCellClosestToPos)(state.selection.$from);
        if (!view || !resizeHandlePos || !cell) return false;
        const $cell = state.doc.resolve(resizeHandlePos);
        const tableStartPosition = $cell.start(-1);
        const originalTable = $cell.node(-1);
        const map = (0, $dpooP.TableMap).get(originalTable);
        const domAtPos = view.domAtPos.bind(view);
        const colIndex = map.colCount($cell.pos - tableStartPosition) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
        let dom = null;
        const domAtPosition = domAtPos(tableStartPosition);
        dom = domAtPosition.node instanceof HTMLTableElement ? domAtPosition.node : null;
        if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
        const cellAttrs = cell === null || cell === void 0 ? void 0 : cell.node.attrs;
        const width = (0, $7SttP.currentColWidth)(view, cell === null || cell === void 0 ? void 0 : cell.pos, cellAttrs);
        (0, $6xtYM.createCommand)({
            type: 'SET_DRAGGING',
            data: {
                dragging: {
                    startX: 0,
                    startWidth: width
                }
            }
        })(state, fakeDispatch);
        const maxSize = (0, $7SttP.getTableMaxWidth)({
            table: originalTable,
            tableStart: tableStartPosition,
            state: state,
            layout: originalTable.attrs.layout,
            getEditorContainerWidth: getEditorContainerWidth
        });
        let isTableScalingEnabledOnCurrentTable = isTableScalingEnabled;
        const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) isTableScalingEnabledOnCurrentTable = originalTable.attrs.displayMode !== 'fixed';
        let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
        if (isTableScalingEnabled && isCommentEditor) {
            isTableScalingEnabledOnCurrentTable = true;
            shouldUseIncreasedScalingPercent = true;
        }
        const initialResizeState = (0, $26jxM.getResizeState)({
            minWidth: (0, $jd8X7.tableCellMinWidth),
            maxSize: maxSize,
            table: originalTable,
            tableRef: dom,
            start: tableStartPosition,
            domAtPos: domAtPos,
            isTableScalingEnabled: isTableScalingEnabledOnCurrentTable,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: isCommentEditor
        });
        (0, $7JtQD.updateControls)()(state);
        const selectionRect = (0, $l5gi8.getSelectionRect)(state.selection);
        const selectedColumns = selectionRect ? (0, $2q9QJ.getSelectedColumnIndexes)(selectionRect) : [];
        // only selected (or selected - 1) columns should be distributed
        const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !((_originalTable$attrs = originalTable.attrs) !== null && _originalTable$attrs !== void 0 && _originalTable$attrs.width) ? (0, $7SttP.getScalingPercentForTableWithoutWidth)(originalTable, dom) : (0, $7SttP.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
        const newResizeState = (0, $9ug8S.resizeColumn)(initialResizeState, colIndex, stepSize, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, isTableScalingEnabled, scalePercent);
        customTr = (0, $04vvT.updateColumnWidths)(newResizeState, originalTable, tableStartPosition, api)(customTr);
        if (dispatch) dispatch(customTr);
        if (ariaNotify && getIntl) {
            ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).changedColumnWidth, {
                width: Math.floor(newResizeState.cols[colIndex].width)
            }));
            if (newResizeState.cols.length === colIndex + 1) {
                if (newResizeState.overflow === true) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).columnResizeLast), {
                    priority: 'important'
                });
                if (newResizeState.overflow === false) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).columnResizeOverflow), {
                    priority: 'important'
                });
            }
        }
        return true;
    };
const $b5be0815b6f67593$export$b77825ff607efdbb = ({ ariaNotify: ariaNotify, getIntl: getIntl, originalTr: originalTr })=>(state, dispatch)=>{
        let customTr = originalTr || state.tr;
        const fakeDispatch = (tr)=>{
            customTr = tr;
        };
        const decorationWithoutWidget = (0, $7uENW.clearColumnResizingDecorations)()({
            tr: customTr,
            decorationSet: (0, $f3xW3.getDecorations)(state)
        });
        const decorationWithoutWidgetAndHandle = (0, $ijKnh.updateDecorations)(customTr.doc, decorationWithoutWidget, [], (0, $YREXK.TableDecorations).COLUMN_RESIZING_HANDLE_LINE);
        $b5be0815b6f67593$var$getTablePluginCommand({
            type: 'STOP_KEYBOARD_COLUMN_RESIZE',
            data: {
                decorationSet: decorationWithoutWidgetAndHandle
            }
        }, customTr)(state, fakeDispatch);
        (0, $6xtYM.createCommand)({
            type: 'STOP_RESIZING'
        }, ()=>customTr.setMeta('scrollIntoView', false))(state, fakeDispatch);
        if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).columnResizeStop), {
            priority: 'important'
        });
        if (dispatch) {
            dispatch(customTr);
            return true;
        }
        return false;
    };

});
parcelRegister("9ug8S", function(module, exports) {
$parcel$export(module.exports, "resizeColumn", () => $578a6c178b808a1d$export$7f7e69ee7fe25ed6);
// Resize a given column by an amount from the current state

var $5403f = parcelRequire("5403f");

var $26jxM = parcelRequire("26jxM");
const $578a6c178b808a1d$export$7f7e69ee7fe25ed6 = (resizeState, colIndex, amount, tableRef, tableNode, selectedColumns, isTableScalingEnabled = false, scalePercent = 1)=>{
    let resizeAmount = amount;
    if (isTableScalingEnabled) resizeAmount = amount / scalePercent;
    const newState = resizeAmount > 0 ? (0, $5403f.growColumn)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeAmount < 0 ? (0, $5403f.shrinkColumn)(resizeState, colIndex, resizeAmount, selectedColumns) : resizeState;
    (0, $26jxM.updateColgroup)(newState, tableRef, tableNode, isTableScalingEnabled, scalePercent);
    return newState;
};

});


parcelRegister("eCvtY", function(module, exports) {
$parcel$export(module.exports, "deleteColumnsCommand", () => $ea104e168db9cd6b$export$136e266e21963ad8);

var $4dyXt = parcelRequire("4dyXt");

var $7gr04 = parcelRequire("7gr04");

var $eaKZu = parcelRequire("eaKZu");
const $ea104e168db9cd6b$export$136e266e21963ad8 = (rect, api, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(state, dispatch, view)=>{
        const tr = (0, $7gr04.deleteColumns)(rect, (0, $eaKZu.getAllowAddColumnCustomStep)(state), api, view, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)(state.tr);
        // If we delete a column we should also clean up the hover selection
        tr.setMeta((0, $4dyXt.pluginKey), {
            type: 'CLEAR_HOVER_SELECTION',
            data: {
                isInDanger: false,
                isWholeTableInDanger: false
            }
        });
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("7gr04", function(module, exports) {
$parcel$export(module.exports, "deleteColumns", () => $a0338fd9de0e2ecb$export$9dbd3595d5638a0b);

var $egZer = parcelRequire("egZer");

var $8d4kB = parcelRequire("8d4kB");

var $801jp = parcelRequire("801jp");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $lh6cf = parcelRequire("lh6cf");

var $04vvT = parcelRequire("04vvT");

var $80BEX = parcelRequire("80BEX");
const $a0338fd9de0e2ecb$var$deleteColumnsCustomStep = (rect)=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        // Need to split all the merge in the ranges (this is the current behaviour)
        // Maybe is better to split only the last column?
        // TODO: ED-26961 - After talking with Roto about this behaviour, he likes when we dont split the columns, I am keeping this for consistency of the current implementation.
        (0, $80BEX.splitCellsInColumns)(tr, table.pos, rect.left, rect.right);
        // Delete the columns
        const mapStart = tr.mapping.maps.length;
        const originalDoc = tr.doc;
        const deletedColumns = [];
        for(let i = rect.left; i < rect.right; i++){
            const step = (0, $egZer.AddColumnStep).create(originalDoc, table.pos, i, true);
            deletedColumns.push(i);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tr.step(step.map(tr.mapping.slice(mapStart)));
        }
        const tablePosResult = tr.mapping.mapResult(table.pos);
        if (tablePosResult.deleted) {
            const pos = Math.min(tablePosResult.pos, tr.doc.nodeSize - 1);
            tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(pos)));
        } else {
            const newTable = tr.doc.nodeAt(tablePosResult.pos);
            if (newTable) {
                const cursorPos = $a0338fd9de0e2ecb$var$getNextCursorPos(newTable, deletedColumns);
                tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
            }
        }
        return tr;
    };
const $a0338fd9de0e2ecb$var$deleteColumnsLegacy = (rect)=>(tr)=>{
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table) return tr;
        const columnsToDelete = [];
        for(let i = rect.left; i < rect.right; i++)columnsToDelete.push(i);
        if (!columnsToDelete.length) return tr;
        const map = (0, $dpooP.TableMap).get(table.node);
        const rows = [];
        const seen = {};
        const deletedCells = {};
        for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
            const rowCells = [];
            const row = table.node.child(rowIndex);
            for(let colIndex = 0; colIndex < map.width; colIndex++){
                const cellPos = map.map[rowIndex * map.width + colIndex];
                const cell = table.node.nodeAt(cellPos);
                if (!cell) continue;
                const cellsInColumn = map.cellsInRect({
                    left: colIndex,
                    top: 0,
                    right: colIndex + 1,
                    bottom: map.height
                });
                if (columnsToDelete.indexOf(colIndex) === -1) {
                    // decrement colspans for col-spanning cells that overlap deleted columns
                    if (cellsInColumn.indexOf(cellPos) > -1 && !seen[cellPos]) {
                        let overlappingCols = 0;
                        columnsToDelete.forEach((colIndexToDelete)=>{
                            if (colIndex < colIndexToDelete && cell.attrs.colspan + colIndex - 1 >= colIndexToDelete) overlappingCols += 1;
                        });
                        if (overlappingCols > 0) {
                            const attrs = {
                                ...cell.attrs,
                                colspan: cell.attrs.colspan - overlappingCols
                            };
                            if (cell.attrs.colwidth) {
                                const minColIndex = Math.min(...columnsToDelete);
                                const pos = minColIndex > 0 ? minColIndex - map.colCount(cellPos) : 0;
                                const colwidth = cell.attrs.colwidth.slice() || [];
                                colwidth.splice(pos, overlappingCols);
                                attrs.colwidth = colwidth;
                            }
                            const newCell = cell.type.createChecked(attrs, cell.content, cell.marks);
                            rowCells.push(newCell);
                            seen[cellPos] = true;
                            continue;
                        }
                    } else if (deletedCells[cellPos]) {
                        // if we're removing a col-spanning cell, we need to add missing cells to columns to the right
                        const attrs = {
                            ...cell.attrs,
                            colspan: 1,
                            rowspan: 1
                        };
                        if (cell.attrs.colwidth) {
                            const pos = colIndex > 0 ? colIndex - map.colCount(cellPos) : 0;
                            attrs.colwidth = cell.attrs.colwidth.slice().splice(pos, 1);
                        }
                        const newCell = cell.type.createChecked(attrs, cell.type.schema.nodes.paragraph.createChecked(), cell.marks);
                        rowCells.push(newCell);
                        continue;
                    }
                    // normal cells that we want to keep
                    if (!seen[cellPos]) {
                        seen[cellPos] = true;
                        rowCells.push(cell);
                    }
                } else if (cellsInColumn.indexOf(cellPos) > -1) deletedCells[cellPos] = true;
            }
            if (rowCells.length) rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
        if (!rows.length) return tr;
        const newTable = table.node.type.createChecked(table.node.attrs, rows, table.node.marks);
        const fixedTable = $a0338fd9de0e2ecb$var$fixRowSpans(newTable);
        if (fixedTable === null) return tr;
        const cursorPos = $a0338fd9de0e2ecb$var$getNextCursorPos(newTable, columnsToDelete);
        return tr.replaceWith(table.pos, table.pos + table.node.nodeSize, fixedTable)// move cursor to the left of the deleted columns if possible, otherwise - to the first column
        .setSelection((0, $801jp.Selection).near(tr.doc.resolve(table.pos + cursorPos)));
    };
function $a0338fd9de0e2ecb$var$getNextCursorPos(table, deletedColumns) {
    const minColumn = Math.min(...deletedColumns);
    const nextColumnWithCursor = minColumn > 0 ? minColumn - 1 : 0;
    const map = (0, $dpooP.TableMap).get(table);
    return map.map[nextColumnWithCursor];
}
// returns an array of numbers, each number indicates the minimum rowSpan in each row
function $a0338fd9de0e2ecb$var$getMinRowSpans(table) {
    const minRowSpans = [];
    for(let rowIndex = 0; rowIndex < table.childCount; rowIndex++){
        const rowSpans = [];
        const row = table.child(rowIndex);
        for(let colIndex = 0; colIndex < row.childCount; colIndex++){
            const cell = row.child(colIndex);
            rowSpans.push(cell.attrs.rowspan);
        }
        minRowSpans[rowIndex] = Math.min(...rowSpans);
    }
    return minRowSpans;
}
function $a0338fd9de0e2ecb$var$fixRowSpans(table) {
    const map = (0, $dpooP.TableMap).get(table);
    const minRowSpans = $a0338fd9de0e2ecb$var$getMinRowSpans(table);
    if (!minRowSpans.some((rowspan)=>rowspan > 1)) return table;
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = table.child(rowIndex);
        if (minRowSpans[rowIndex] === 1) rows.push(row);
        else {
            const rowCells = [];
            for(let colIndex = 0; colIndex < row.childCount; colIndex++){
                const cell = row.child(colIndex);
                const rowspan = cell.attrs.rowspan - minRowSpans[rowIndex] + 1;
                if (rowspan < 1) return null;
                const newCell = cell.type.createChecked({
                    ...cell.attrs,
                    rowspan: rowspan
                }, cell.content, cell.marks);
                rowCells.push(newCell);
            }
            rows.push(row.type.createChecked(row.attrs, rowCells, row.marks));
        }
    }
    if (!rows.length) return null;
    return table.type.createChecked(table.attrs, rows, table.marks);
}
const $a0338fd9de0e2ecb$export$9dbd3595d5638a0b = (rect, allowCustomStep, api, view, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false, isCommentEditor = false)=>(tr)=>{
        let updatedTr = tr;
        updatedTr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).DELETED_COLUMN
        });
        if (allowCustomStep) updatedTr = $a0338fd9de0e2ecb$var$deleteColumnsCustomStep(rect)(updatedTr);
        else updatedTr = $a0338fd9de0e2ecb$var$deleteColumnsLegacy(rect)(updatedTr);
        const table = (0, $5n2u9.findTable)(updatedTr.selection);
        if (table) updatedTr = (0, $04vvT.rescaleColumns)(isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, api, isCommentEditor)(table, view)(updatedTr);
        return updatedTr;
    };

});
parcelRegister("80BEX", function(module, exports) {
$parcel$export(module.exports, "splitCellsInColumns", () => $e0fb9ee92f80d4fc$export$e526e68a5eecfb66);

var $dpooP = parcelRequire("dpooP");
function $e0fb9ee92f80d4fc$export$e526e68a5eecfb66(tr, tablePos, columnStart, columnEnd) {
    const mapStart = tr.mapping.maps.length;
    const table = tr.doc.nodeAt(tablePos);
    if (!table) return tr;
    const tableStart = tr.doc.resolve(tablePos).start(1);
    const map = (0, $dpooP.TableMap).get(table);
    for(let column = columnStart; column < columnEnd; column++)for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const cellIndex = rowIndex * map.width + column;
        const cellPos = map.map[cellIndex];
        // Check if the cell is contained by another by another row/column
        const hasMergedCellsBefore = column > 0 && map.map[cellIndex - 1] === cellPos || rowIndex > 0 && map.map[(rowIndex - 1) * map.width + column] === cellPos;
        // Check if the cell contains another row/column
        const hasMergedCellsAfter = column < map.width - 1 && map.map[cellIndex + 1] === cellPos || rowIndex < map.height - 1 && map.map[(rowIndex + 1) * map.width + column] === cellPos;
        if (!hasMergedCellsBefore && hasMergedCellsAfter) {
            // Is a merged cell that start in this row/column
            const cellNode = table.nodeAt(cellPos);
            if (!cellNode) continue;
            const { colwidth: colwidth, colspan: colspan = 1, rowspan: rowspan = 1 } = cellNode.attrs;
            let mapping = tr.mapping.slice(mapStart);
            // Update current node with the simple colspan
            const baseAttrs = {
                ...cellNode.attrs,
                colspan: 1,
                rowspan: 1
            };
            // Add the new cells
            for(let cellRowIndex = rowIndex; cellRowIndex < rowIndex + rowspan; cellRowIndex++)for(let i = 0; i < colspan; i++){
                const mapping = tr.mapping.slice(mapStart);
                const cellPos = map.positionAt(cellRowIndex, column + i, table);
                tr.insert(mapping.map(cellPos + tableStart), // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                cellNode.type.createAndFill({
                    ...baseAttrs,
                    colwidth: colwidth ? [
                        colwidth[i]
                    ] : undefined
                }));
            }
            // Delete the original cell
            mapping = tr.mapping.slice(mapStart);
            tr.delete(mapping.map(cellPos + tableStart), mapping.map(cellPos + tableStart + cellNode.nodeSize));
            // Skip rows based on rowspan
            if (rowspan && rowspan > 1) rowIndex += rowspan - 1;
        }
    }
    return tr;
}

});



parcelRegister("hLBK7", function(module, exports) {
$parcel$export(module.exports, "setTableDisplayMode", () => $43139b6f3350a1b1$export$6ed6a850e47b73cc);

var $5n2u9 = parcelRequire("5n2u9");
const $43139b6f3350a1b1$export$6ed6a850e47b73cc = ({ tr: tr })=>{
    const table = (0, $5n2u9.findTable)(tr.selection);
    if (!table) return null;
    const { displayMode: displayMode } = table.node.attrs;
    tr.setNodeMarkup(table.pos, tr.doc.type.schema.nodes.table, {
        ...table.node.attrs,
        displayMode: !displayMode || displayMode === 'default' ? 'fixed' : 'default'
    });
    return tr.setMeta('scrollIntoView', false);
};

});

parcelRegister("Qalab", function(module, exports) {
$parcel$export(module.exports, "sortByColumn", () => $97b114bea3940f92$export$53e8d4c581cfe158);

var $hIsCp = parcelRequire("hIsCp");

var $25zoa = parcelRequire("25zoa");

var $jtrdr = parcelRequire("jtrdr");

var $801jp = parcelRequire("801jp");

var $dpooP = parcelRequire("dpooP");

var $9fuiW = parcelRequire("9fuiW");
var $25329 = parcelRequire("25329");
var $elHd5 = parcelRequire("elHd5");
var $5n2u9 = parcelRequire("5n2u9");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");

var $4GJqd = parcelRequire("4GJqd");
const $97b114bea3940f92$var$createGetInlineCardTextFromStore = (attrs)=>{
    const { data: data } = attrs;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (data && (data.name || data.title)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return data.name || data.title;
    const { url: cardUrl } = attrs;
    return cardUrl;
};
const $97b114bea3940f92$export$53e8d4c581cfe158 = (columnIndex, order = (0, $hIsCp.SortOrder).DESC)=>(0, $4GJqd.createCommand)(()=>({
            type: 'SORT_TABLE',
            data: {
                ordering: {
                    columnIndex: columnIndex,
                    order: order
                }
            }
        }), (tr, state)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const table = (0, $5n2u9.findTable)(tr.selection);
        if (!table || !table.node) return tr;
        const selectionRect = (0, $2HFfw.isSelectionType)(tr.selection, 'cell') ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $l5gi8.getSelectionRect)(tr.selection) : (0, $elHd5.findCellRectClosestToPos)(tr.selection.$from);
        if (!selectionRect) return tr;
        const tablePluginState = (0, $4GJqd.getPluginState)(state);
        const tableArray = (0, $25329.convertTableNodeToArrayOfRows)(table.node);
        let headerRow;
        if (tablePluginState.isHeaderRowEnabled) headerRow = tableArray.shift();
        const compareNodesInOrder = (0, $jtrdr.createCompareNodes)({
            getInlineCardTextFromStore: $97b114bea3940f92$var$createGetInlineCardTextFromStore
        }, order);
        const sortedTable = tableArray.sort((rowA, rowB)=>compareNodesInOrder(rowA[columnIndex], rowB[columnIndex]));
        if (headerRow) sortedTable.unshift(headerRow);
        const newTableNode = (0, $9fuiW.convertArrayOfRowsToTableNode)(table.node, sortedTable);
        tr.replaceWith(table.pos, table.pos + table.node.nodeSize, newTableNode);
        const pos = (0, $dpooP.TableMap).get(table.node).positionAt(selectionRect.top, columnIndex, table.node);
        const prev = tablePluginState.ordering;
        const next = {
            columnIndex: columnIndex,
            order: order
        };
        tr.step(new (0, $25zoa.TableSortStep)(table.pos, prev, next));
        return tr.setSelection((0, $801jp.Selection).near(tr.doc.resolve(table.start + pos)));
    });

});
parcelRegister("9fuiW", function(module, exports) {
$parcel$export(module.exports, "convertArrayOfRowsToTableNode", () => $b3d560ca7104f29b$export$5c8f3870f9ad667);

var $dpooP = parcelRequire("dpooP");
const $b3d560ca7104f29b$export$5c8f3870f9ad667 = (tableNode, arrayOfNodes)=>{
    const rowsPM = [];
    const map = (0, $dpooP.TableMap).get(tableNode);
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const row = tableNode.child(rowIndex);
        const rowCells = [];
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            if (!arrayOfNodes[rowIndex][colIndex]) continue;
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = arrayOfNodes[rowIndex][colIndex];
            const oldCell = tableNode.nodeAt(cellPos);
            if (!cell || !oldCell) continue;
            const newCell = oldCell.type.createChecked(Object.assign({}, cell.attrs), cell.content, cell.marks);
            rowCells.push(newCell);
        }
        rowsPM.push(row.type.createChecked(row.attrs, rowCells, row.marks));
    }
    const newTable = tableNode.type.createChecked(tableNode.attrs, rowsPM, tableNode.marks);
    return newTable;
};

});

parcelRegister("25329", function(module, exports) {
$parcel$export(module.exports, "convertTableNodeToArrayOfRows", () => $b02b7a8bac79413d$export$63019a088e9d8f5f);

var $dpooP = parcelRequire("dpooP");
const $b02b7a8bac79413d$export$63019a088e9d8f5f = (tableNode)=>{
    const map = (0, $dpooP.TableMap).get(tableNode);
    const rows = [];
    for(let rowIndex = 0; rowIndex < map.height; rowIndex++){
        const rowCells = [];
        const seen = {};
        for(let colIndex = 0; colIndex < map.width; colIndex++){
            const cellPos = map.map[rowIndex * map.width + colIndex];
            const cell = tableNode.nodeAt(cellPos);
            const rect = map.findCell(cellPos);
            if (!cell || seen[cellPos] || rect.top !== rowIndex) {
                rowCells.push(null);
                continue;
            }
            seen[cellPos] = true;
            rowCells.push(cell);
        }
        rows.push(rowCells);
    }
    return rows;
};

});


parcelRegister("khBKG", function(module, exports) {
$parcel$export(module.exports, "canSplitCellSelection", () => $d83657d4ea676e14$export$3983d6b165b9fd4d);
$parcel$export(module.exports, "splitCell", () => $d83657d4ea676e14$export$74933b5979945879);

var $ev7OZ = parcelRequire("ev7OZ");

var $4iGxE = parcelRequire("4iGxE");

var $hG9gR = parcelRequire("hG9gR");

var $4GJqd = parcelRequire("4GJqd");
const $d83657d4ea676e14$export$3983d6b165b9fd4d = (selection)=>{
    let cellNode;
    if (!(selection instanceof (0, $ev7OZ.CellSelection))) {
        cellNode = (0, $4iGxE.cellWrapping)(selection.$from);
        if (!cellNode) return false;
    } else {
        if (selection.$anchorCell.pos !== selection.$headCell.pos) return false;
        cellNode = selection.$anchorCell.nodeAfter;
    }
    return Boolean(cellNode && (cellNode.attrs.colspan !== 1 || cellNode.attrs.rowspan !== 1));
};
const $d83657d4ea676e14$export$74933b5979945879 = (state, dispatch)=>{
    const tableState = (0, $4GJqd.getPluginState)(state);
    const { tableHeader: tableHeader, tableCell: tableCell } = state.schema.nodes;
    if (dispatch) return (0, $hG9gR.splitCellWithType)(({ row: row, col: col })=>{
        if (row === 0 && tableState.isHeaderRowEnabled || col === 0 && tableState.isHeaderColumnEnabled) return tableHeader;
        return tableCell;
    })(state, dispatch);
    return true;
};

});

parcelRegister("3Gwyn", function(module, exports) {
$parcel$export(module.exports, "toggleHeaderRow", () => $b8574baa26236104$export$2155c86bec6ad614);
$parcel$export(module.exports, "toggleHeaderColumn", () => $b8574baa26236104$export$cb41f2462444ad87);
$parcel$export(module.exports, "toggleNumberColumn", () => $b8574baa26236104$export$67d4f89bd3067fa2);
$parcel$export(module.exports, "toggleContextualMenu", () => $b8574baa26236104$export$458dbe7d48b81d0a);
//#region Imports

var $8d4kB = parcelRequire("8d4kB");

var $5n2u9 = parcelRequire("5n2u9");

var $1B2Sj = parcelRequire("1B2Sj");

var $4GJqd = parcelRequire("4GJqd");

var $lh6cf = parcelRequire("lh6cf");
const $b8574baa26236104$export$5ba3b70e6a8fb9d8 = (currentLayout)=>{
    switch(currentLayout){
        case 'default':
            return 'wide';
        case 'wide':
            return 'full-width';
        case 'full-width':
            return 'default';
        default:
            return 'default';
    }
};
const $b8574baa26236104$export$2155c86bec6ad614 = (state, dispatch)=>(0, $1B2Sj.toggleHeader)('row')(state, (tr)=>(0, $4GJqd.createCommand)({
            type: 'TOGGLE_HEADER_ROW'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $b8574baa26236104$export$cb41f2462444ad87 = (state, dispatch)=>(0, $1B2Sj.toggleHeader)('column')(state, (tr)=>(0, $4GJqd.createCommand)({
            type: 'TOGGLE_HEADER_COLUMN'
        }, ()=>tr.setMeta('scrollIntoView', false))(state, dispatch));
const $b8574baa26236104$export$67d4f89bd3067fa2 = (state, dispatch)=>{
    const { tr: tr } = state;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { node: node, pos: pos } = (0, $5n2u9.findTable)(state.selection);
    const isNumberedColumnEnabled = node.attrs.isNumberColumnEnabled;
    tr.setNodeMarkup(pos, state.schema.nodes.table, {
        ...node.attrs,
        isNumberColumnEnabled: !isNumberedColumnEnabled
    });
    tr.setMeta('scrollIntoView', false);
    const tableOverflowChangeTriggerName = isNumberedColumnEnabled ? (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).DISABLED_NUMBERED_COLUMN : (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).ENABLED_NUMBERED_COLUMN;
    tr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
        name: tableOverflowChangeTriggerName
    });
    if (dispatch) dispatch(tr);
    return true;
};
const $b8574baa26236104$export$2e89b565e66d3fda = (state, dispatch)=>{
    const table = (0, $5n2u9.findTable)(state.selection);
    if (!table) return false;
    const layout = $b8574baa26236104$export$5ba3b70e6a8fb9d8(table.node.attrs.layout);
    return (0, $4GJqd.createCommand)({
        type: 'SET_TABLE_LAYOUT',
        data: {
            layout: layout
        }
    }, (tr)=>{
        tr.setNodeMarkup(table.pos, state.schema.nodes.table, {
            ...table.node.attrs,
            layout: layout
        });
        tr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        return tr.setMeta('scrollIntoView', false);
    })(state, dispatch);
};
const $b8574baa26236104$export$458dbe7d48b81d0a = ()=>(0, $4GJqd.createCommand)({
        type: 'TOGGLE_CONTEXTUAL_MENU'
    }, (tr)=>tr.setMeta('addToHistory', false)); // #endregion

});
parcelRegister("1B2Sj", function(module, exports) {
$parcel$export(module.exports, "toggleHeader", () => $41f8cb3af131e022$export$dee0ccd8d8f5a56e);

var $1pRtZ = parcelRequire("1pRtZ");

var $k3Ypn = parcelRequire("k3Ypn");

var $auYrv = parcelRequire("auYrv");

var $iwwun = parcelRequire("iwwun");

var $9HFsx = parcelRequire("9HFsx");
function $41f8cb3af131e022$export$dee0ccd8d8f5a56e(type) {
    return function(state, dispatch) {
        if (!(0, $auYrv.isInTable)(state)) return false;
        if (dispatch) {
            const types = (0, $9HFsx.tableNodeTypes)(state.schema);
            const rect = (0, $iwwun.selectedRect)(state), tr = state.tr;
            const isHeaderRowEnabled = (0, $k3Ypn.isHeaderEnabledByType)('row', rect, types);
            const isHeaderColumnEnabled = (0, $k3Ypn.isHeaderEnabledByType)('column', rect, types);
            const isHeaderEnabled = type === 'column' ? isHeaderRowEnabled : type === 'row' ? isHeaderColumnEnabled : false;
            const selectionStartsAt = isHeaderEnabled ? 1 : 0;
            const cellsRect = type === 'column' ? new (0, $1pRtZ.Rect)(0, selectionStartsAt, 1, rect.map.height) : type === 'row' ? new (0, $1pRtZ.Rect)(selectionStartsAt, 0, rect.map.width, 1) : rect;
            let newType;
            if (type === 'column') newType = isHeaderColumnEnabled ? types.cell : types.header_cell;
            else if (type === 'row') newType = isHeaderRowEnabled ? types.cell : types.header_cell;
            else newType = types.cell;
            rect.map.cellsInRect(cellsRect).forEach((relativeCellPos)=>{
                const cellPos = relativeCellPos + rect.tableStart;
                const cell = tr.doc.nodeAt(cellPos);
                if (cell) tr.setNodeMarkup(cellPos, newType, cell.attrs);
            });
            dispatch(tr);
        }
        return true;
    };
}

});



parcelRegister("75I44", function(module, exports) {
$parcel$export(module.exports, "applyMeasuredWidthToSelectedTable", () => $ec7874e8e8c40519$export$b4b4c38f004e5aad);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $5n2u9 = parcelRequire("5n2u9");

var $kOsPQ = parcelRequire("kOsPQ");

var $3yjcH = parcelRequire("3yjcH");
const $ec7874e8e8c40519$export$b4b4c38f004e5aad = (view, api)=>{
    var _api$width, _api$analytics, _api$width2;
    const tableObject = (0, $5n2u9.findTable)(view.state.selection);
    if (!tableObject) return;
    const { node: node, pos: pos } = tableObject;
    const tableState = api === null || api === void 0 ? void 0 : api.table.sharedState.currentState();
    if (!(tableState !== null && tableState !== void 0 && tableState.tableRef)) return;
    const editorContainerWidth = api === null || api === void 0 || (_api$width = api.width) === null || _api$width === void 0 || (_api$width = _api$width.sharedState.currentState()) === null || _api$width === void 0 ? void 0 : _api$width.width;
    const measurement = (0, $3yjcH.measureTableWithAutoLayout)(tableState.tableRef, editorContainerWidth);
    const tr = (0, $kOsPQ.applyTableMeasurement)(view.state.tr, node, measurement, pos);
    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
        action: (0, $8d4kB.TABLE_ACTION).FIT_TO_CONTENT_ON_DEMAND,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
        actionSubjectId: null,
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        attributes: {
            editorContainerWidth: (api === null || api === void 0 || (_api$width2 = api.width) === null || _api$width2 === void 0 || (_api$width2 = _api$width2.sharedState.currentState()) === null || _api$width2 === void 0 ? void 0 : _api$width2.width) ?? 0,
            tableWidth: measurement.tableWidth,
            totalColumnCount: measurement.colWidths.length
        }
    })(tr);
    view.dispatch(tr);
};

});
parcelRegister("kOsPQ", function(module, exports) {
$parcel$export(module.exports, "getTableMeasurement", () => $5fd2be6c983c7c28$export$d87d6ab7a18b29eb);
$parcel$export(module.exports, "applyTableMeasurement", () => $5fd2be6c983c7c28$export$e55d81380f623ba1);

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $lpTvl = parcelRequire("lpTvl");
const $5fd2be6c983c7c28$export$558c1c356b7f2033 = (contentWidth)=>{
    const maxEditorWidth = (0, $014x6.akEditorMaxLayoutWidth);
    return Math.min(maxEditorWidth, contentWidth);
};
const $5fd2be6c983c7c28$var$tableWidth = $5fd2be6c983c7c28$export$558c1c356b7f2033;
const $5fd2be6c983c7c28$export$d87d6ab7a18b29eb = (tableRef)=>{
    const colWidths = $5fd2be6c983c7c28$var$getRenderedColgroupColumnWidths(tableRef);
    const totalContentWidth = colWidths.reduce((acc, current)=>acc + current, 0);
    return {
        colWidths: colWidths,
        tableWidth: $5fd2be6c983c7c28$var$tableWidth(totalContentWidth)
    };
};
const $5fd2be6c983c7c28$export$e55d81380f623ba1 = (tr, tableNode, { colWidths: colWidths, tableWidth: tableWidth }, tablePos)=>{
    tr = (0, $lpTvl.updateCellsMarkup)(tr, tableNode, tablePos, (cell, _rowIndex, colIndex)=>{
        const newColWidths = colWidths.slice(colIndex, colIndex + cell.attrs.colspan);
        return cell.type.createChecked({
            ...cell.attrs,
            colwidth: newColWidths.length ? newColWidths : null
        }, cell.content, cell.marks);
    });
    return tr.setNodeMarkup(tablePos, undefined, {
        ...tableNode.attrs,
        width: tableWidth
    });
};
function $5fd2be6c983c7c28$var$getRenderedColgroupColumnWidths(tableRef) {
    const cols = Array.from(tableRef.querySelectorAll(':scope > colgroup > col'));
    return cols.map((col)=>{
        const width = col.getBoundingClientRect().width;
        return Math.max(Math.round(width), (0, $jd8X7.tableCellMinWidth));
    });
}

});

parcelRegister("3yjcH", function(module, exports) {
$parcel$export(module.exports, "measureTableWithAutoLayout", () => $a515a05311d979c2$export$b4d02699ba1d276b);

var $8aFCM = parcelRequire("8aFCM");

var $leYmr = parcelRequire("leYmr");
const $a515a05311d979c2$export$b4d02699ba1d276b = (tableRef, editorContainerWidth)=>{
    const cols = Array.from(tableRef.querySelectorAll(':scope > colgroup > col'));
    const contentWrap = tableRef.closest(`.${(0, $8aFCM.TableSharedCssClassName).TABLE_VIEW_CONTENT_WRAP}`);
    const resizerContainer = contentWrap === null || contentWrap === void 0 ? void 0 : contentWrap.querySelector(`.${(0, $8aFCM.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
    const resizerItem = resizerContainer === null || resizerContainer === void 0 ? void 0 : resizerContainer.querySelector('.resizer-item.display-handle');
    const prevTableWidth = tableRef.style.width;
    const prevTableLayout = tableRef.style.tableLayout;
    const prevColWidths = cols.map((col)=>col.style.width);
    const prevResizerItemWidth = resizerItem === null || resizerItem === void 0 ? void 0 : resizerItem.style.width;
    tableRef.style.width = '';
    tableRef.style.tableLayout = 'auto';
    cols.forEach((col)=>col.style.width = '');
    const hadTableSticky = tableRef.classList.contains((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY);
    const prevTableMarginTop = tableRef.style.marginTop;
    if (hadTableSticky) tableRef.classList.remove((0, $8aFCM.TableSharedCssClassName).TABLE_NATIVE_STICKY);
    if (prevTableMarginTop) tableRef.style.marginTop = '';
    const stickyRows = Array.from(tableRef.querySelectorAll(`tr.sticky, tr.${(0, $8aFCM.TableSharedCssClassName).TABLE_NATIVE_STICKY}`));
    const prevStickyRowState = stickyRows.map((row)=>({
            row: row,
            hadSticky: row.classList.contains('sticky'),
            hadNative: row.classList.contains((0, $8aFCM.TableSharedCssClassName).TABLE_NATIVE_STICKY),
            width: row.style.width,
            top: row.style.top,
            position: row.style.position,
            gridTemplateColumns: row.style.gridTemplateColumns
        }));
    stickyRows.forEach((row)=>{
        row.classList.remove('sticky');
        row.classList.remove((0, $8aFCM.TableSharedCssClassName).TABLE_NATIVE_STICKY);
        row.style.width = '';
        row.style.top = '';
        row.style.position = '';
        row.style.gridTemplateColumns = '';
    });
    try {
        return (0, $leYmr.runSmartAdjust)(tableRef, resizerContainer, resizerItem, editorContainerWidth);
    } finally{
        tableRef.style.width = prevTableWidth;
        tableRef.style.tableLayout = prevTableLayout;
        cols.forEach((col, i)=>col.style.width = prevColWidths[i]);
        if (hadTableSticky) tableRef.classList.add((0, $8aFCM.TableSharedCssClassName).TABLE_STICKY);
        if (prevTableMarginTop) tableRef.style.marginTop = prevTableMarginTop;
        prevStickyRowState.forEach((state)=>{
            if (state.hadSticky) state.row.classList.add('sticky');
            if (state.hadNative) state.row.classList.add((0, $8aFCM.TableSharedCssClassName).TABLE_NATIVE_STICKY);
            if (state.width) state.row.style.width = state.width;
            if (state.top) state.row.style.top = state.top;
            if (state.position) state.row.style.position = state.position;
            if (state.gridTemplateColumns) state.row.style.gridTemplateColumns = state.gridTemplateColumns;
        });
        (0, $leYmr.restoreResizerContainer)(resizerContainer);
        if (resizerItem) resizerItem.style.width = prevResizerItemWidth ?? '';
    }
};

});
parcelRegister("leYmr", function(module, exports) {
$parcel$export(module.exports, "restoreResizerContainer", () => $30be97f44533fe23$export$a3fd5033d86b5b8b);
$parcel$export(module.exports, "runSmartAdjust", () => $30be97f44533fe23$export$426be2b82c7d51bf);

var $kOsPQ = parcelRequire("kOsPQ");

var $l3TPf = parcelRequire("l3TPf");
const $30be97f44533fe23$var$measureWithIntrinsicWidth = (tableRef, resizerContainer, resizerItem)=>{
    if (resizerContainer) {
        resizerContainer.style.width = 'var(--ak-editor-table-width)';
        resizerContainer.style.setProperty('--ak-editor-table-width', 'max-content');
    }
    if (resizerItem) resizerItem.style.width = 'max-content';
    const prevTableWidth = tableRef.style.width;
    const prevTableMaxWidth = tableRef.style.maxWidth;
    const prevTableMinWidth = tableRef.style.minWidth;
    tableRef.style.setProperty('width', 'max-content', 'important');
    tableRef.style.setProperty('max-width', 'none', 'important');
    tableRef.style.setProperty('min-width', '0', 'important');
    try {
        return (0, $kOsPQ.getTableMeasurement)(tableRef);
    } finally{
        tableRef.style.width = prevTableWidth;
        tableRef.style.maxWidth = prevTableMaxWidth;
        tableRef.style.minWidth = prevTableMinWidth;
    }
};
const $30be97f44533fe23$export$a3fd5033d86b5b8b = (resizerContainer)=>{
    if (!resizerContainer) return;
    resizerContainer.style.width = 'var(--ak-editor-table-width)';
    resizerContainer.style.removeProperty('--ak-editor-table-width');
};
const $30be97f44533fe23$export$426be2b82c7d51bf = (tableRef, resizerContainer, resizerItem, editorContainerWidthFromApi)=>{
    const preferredMeasurement = $30be97f44533fe23$var$measureWithIntrinsicWidth(tableRef, resizerContainer, resizerItem);
    const desiredWidths = preferredMeasurement.colWidths;
    const editorContainerWidth = editorContainerWidthFromApi ?? (0, $l3TPf.sumWidths)(desiredWidths);
    const colWidths = (0, $l3TPf.distributeByEvenShareRatio)(desiredWidths, editorContainerWidth);
    return {
        ...preferredMeasurement,
        colWidths: colWidths,
        tableWidth: (0, $l3TPf.sumWidths)(colWidths)
    };
};

});
parcelRegister("l3TPf", function(module, exports) {
$parcel$export(module.exports, "sumWidths", () => $887f9a2f00d2c43a$export$71ab12c987afd8bc);
$parcel$export(module.exports, "distributeByEvenShareRatio", () => $887f9a2f00d2c43a$export$30e7a6d6466e87d1);

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $i1YIp = parcelRequire("i1YIp");
const $887f9a2f00d2c43a$export$71ab12c987afd8bc = (widths)=>widths.reduce((sum, width)=>sum + width, 0);
// 2px absorbs sub-pixel rounding in `getRenderedColgroupColumnWidths`.
const $887f9a2f00d2c43a$var$SUB_PIXEL_ROUNDING_ALLOWANCE = 2;
const $887f9a2f00d2c43a$export$30e7a6d6466e87d1 = (desiredWidths, editorContainerWidth)=>{
    if (desiredWidths.length === 0 || !isFinite(editorContainerWidth) || editorContainerWidth <= 0) return desiredWidths;
    const usableWidth = Math.max(editorContainerWidth - (0, $014x6.akEditorGutterPaddingDynamic)() * 2, (0, $jd8X7.tableCellMinWidth) * desiredWidths.length);
    const evenShare = usableWidth / desiredWidths.length;
    const ceiling = (0, $i1YIp.EVEN_SHARE_RATIO).MAX * evenShare;
    const isCompactColumn = (width)=>width <= ceiling;
    const desiredCeil = desiredWidths.map((desired)=>Math.max((0, $jd8X7.tableCellMinWidth), Math.ceil(desired) + $887f9a2f00d2c43a$var$SUB_PIXEL_ROUNDING_ALLOWANCE));
    const capped = desiredCeil.map((desired)=>isCompactColumn(desired) ? desired : Math.min(ceiling, desired));
    const sum = $887f9a2f00d2c43a$export$71ab12c987afd8bc(capped);
    // Underflow: grow non-protected ceiling-hitters into the leftover, up to their desired.
    if (sum < usableWidth) {
        const leftover = usableWidth - sum;
        const growthHeadroom = capped.map((width, index)=>!isCompactColumn(desiredCeil[index]) && width >= ceiling ? Math.max(desiredCeil[index] - width, 0) : 0);
        const totalHeadroom = $887f9a2f00d2c43a$export$71ab12c987afd8bc(growthHeadroom);
        if (totalHeadroom > 0) {
            const totalGrowth = Math.min(leftover, totalHeadroom);
            return capped.map((width, index)=>{
                const headroom = growthHeadroom[index];
                if (headroom <= 0) return width;
                return width + headroom / totalHeadroom * totalGrowth;
            });
        }
        return capped;
    }
    if (sum === usableWidth) return capped;
    // Overflow: reclaim from non-protected ceiling-hitters only.
    const overage = sum - usableWidth;
    const slacks = capped.map((width, index)=>!isCompactColumn(desiredCeil[index]) && width >= ceiling ? Math.max(width - (0, $jd8X7.tableCellMinWidth), 0) : 0);
    const totalSlack = $887f9a2f00d2c43a$export$71ab12c987afd8bc(slacks);
    if (totalSlack <= 0) return capped;
    return capped.map((width, index)=>{
        const slack = slacks[index];
        if (slack <= 0) return width;
        const share = slack / totalSlack * Math.min(overage, totalSlack);
        return Math.max(width - share, (0, $jd8X7.tableCellMinWidth));
    });
};

});
parcelRegister("i1YIp", function(module, exports) {
$parcel$export(module.exports, "EVEN_SHARE_RATIO", () => $afd7c215a736ff44$export$3b36a7fc0215f73d);
/** Each column's max width is `MAX × (usableWidth / numCols)`. */ const $afd7c215a736ff44$export$3b36a7fc0215f73d = {
    MAX: 2
};

});





parcelRegister("iVTiG", function(module, exports) {
$parcel$export(module.exports, "FloatingAlignmentButtons", () => $2c3ba0c47e92025b$export$a6e8f537af71668f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $jctmk = parcelRequire("jctmk");

var $lHYHS = parcelRequire("lHYHS");

var $5sFwQ = parcelRequire("5sFwQ");

var $3mWcp = parcelRequire("3mWcp");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");
const $2c3ba0c47e92025b$var$containerStyles = (0, $kig2V.xcss)({
    marginLeft: 'space.100'
});
const $2c3ba0c47e92025b$export$a6e8f537af71668f = ({ alignmentButtons: alignmentButtons, dispatchCommand: dispatchCommand, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
        xcss: $2c3ba0c47e92025b$var$containerStyles
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $lHYHS.default), null, alignmentButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $jctmk.jsx)((0, $3mWcp.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $jctmk.jsx)((0, $5sFwQ.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $jctmk.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};

});




parcelRegister("fo4aC", function(module, exports) {
$parcel$export(module.exports, "getDraggableDataFromEvent", () => $cc5c17f781314492$export$6d440138302b6316);

var $iIA9h = parcelRequire("iIA9h");

var $6ypSG = parcelRequire("6ypSG");
const $cc5c17f781314492$export$6d440138302b6316 = ({ location: location, source: source })=>{
    const destination = location.current.dropTargets.at(0);
    // If no target exists at the current location, then the current draggable is not over a target or the target doesn't support
    // the current draggable.
    if (!destination) return undefined;
    // This is the draggable elements data
    const { indexes: sourceIndexes, type: sourceType, localId: sourceLocalId } = source.data;
    // This is the drop target's data
    const { targetIndex: targetIndex, type: targetType, localId: targetLocalId } = destination.data;
    // Some basic check to abort early with...
    if (!sourceIndexes || targetIndex < 0 || // abort if the type of the draggable is different to the target, for eg. rows cannot be dropped onto column targets.
    sourceType !== targetType || // abort if the draggable is coming from a different table that the target is on.
    sourceLocalId !== targetLocalId) return undefined;
    const targetClosestEdge = (0, $iIA9h.extractClosestEdge)(destination.data) ?? (targetType === 'table-row' ? 'top' : 'left');
    // NOTE: By default we always insert row/cols at the target index to the top/left (retrospectively of row/cols).
    // This introduces an offset in the event the drop occured closer to the bottom/right of the target. We want
    // the new target index to be 1 index higher.
    const targetOffset = targetClosestEdge === 'right' || targetClosestEdge === 'bottom' ? 1 : 0;
    // if the min index is greater then the target index, the then the direction of the DnD is decreasing
    // if the target is within the min/max index then we can assume that no direction exists so it will be 0.
    const srcMin = Math.min(...sourceIndexes);
    const srcMax = Math.max(...sourceIndexes);
    const direction = targetIndex >= srcMin && targetIndex <= srcMax ? 0 : srcMin >= targetIndex ? -1 : 1;
    return {
        sourceType: sourceType,
        sourceLocalId: sourceLocalId,
        sourceIndexes: sourceIndexes,
        targetType: targetType,
        targetLocalId: targetLocalId,
        targetIndex: targetIndex,
        targetAdjustedIndex: targetIndex + targetOffset,
        targetClosestEdge: targetClosestEdge,
        targetDirection: targetClosestEdge === 'top' || targetClosestEdge === 'left' ? 'start' : 'end',
        direction: direction,
        behaviour: (0, $6ypSG.getDragBehaviour)(location.current.input)
    };
};

});
parcelRegister("6ypSG", function(module, exports) {
$parcel$export(module.exports, "getDragBehaviour", () => $44c03f28d9e81069$export$b95259a1f587c41);

var $dqFZv = parcelRequire("dqFZv");
const $44c03f28d9e81069$export$b95259a1f587c41 = ({ altKey: altKey, ctrlKey: ctrlKey })=>{
    const browser = (0, $dqFZv.getBrowserInfo)();
    const isCloneModifierKeyPressed = browser.mac ? altKey : ctrlKey;
    return isCloneModifierKeyPressed ? 'clone' : 'move';
};

});



parcelRegister("cbJui", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $ff090fe8192358d8$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "INITIAL_STATIC_VIEWPORT_HEIGHT", () => $ff090fe8192358d8$export$4d09e1a8cc78d53);
$parcel$export(module.exports, "createPlugin", () => $ff090fe8192358d8$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");
const $ff090fe8192358d8$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('editorContentAreaHeightPlugin');
const $ff090fe8192358d8$export$4d09e1a8cc78d53 = 1200;
const $ff090fe8192358d8$export$e591924e2463f32f = '.ak-editor-content-area-region';
const $ff090fe8192358d8$export$ae829ec7b2625219 = ()=>new (0, $1y7gE.SafePlugin)({
        key: $ff090fe8192358d8$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    height: $ff090fe8192358d8$export$4d09e1a8cc78d53
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($ff090fe8192358d8$export$18d4026d1ea86bb1);
                if (meta) return {
                    ...pluginState,
                    ...meta
                };
                return pluginState;
            }
        },
        view: (view)=>{
            const editorContentAreaEl = view.dom.closest($ff090fe8192358d8$export$e591924e2463f32f);
            let resizeObserver;
            if (editorContentAreaEl) {
                resizeObserver = new ResizeObserver((entries)=>{
                    for (const entry of entries){
                        const height = entry.contentRect.height;
                        const tr = view.state.tr.setMeta($ff090fe8192358d8$export$18d4026d1ea86bb1, {
                            height: height,
                            isObserved: true
                        });
                        view.dispatch(tr);
                    }
                });
                resizeObserver.observe(editorContentAreaEl);
            }
            return {
                destroy () {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) === null || _resizeObserver === void 0 || _resizeObserver.disconnect();
                }
            };
        }
    });

});

parcelRegister("4OlZB", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $f58910fc4bfc9dd1$export$e832373cff8dec22);

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $cTbwC = parcelRequire("cTbwC");

var $jGkle = parcelRequire("jGkle");

var $1O8Lw = parcelRequire("1O8Lw");

var $aEmSo = parcelRequire("aEmSo");

var $cwJ2b = parcelRequire("cwJ2b");

var $8ViBq = parcelRequire("8ViBq");
var $8L6TV = parcelRequire("8L6TV");

var $hVZWA = parcelRequire("hVZWA");

var $kfljr = parcelRequire("kfljr");

var $8ViBq = parcelRequire("8ViBq");

var $jEslx = parcelRequire("jEslx");
function $f58910fc4bfc9dd1$export$e832373cff8dec22(getEditorContainerWidth, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled = false, isTableAlignmentEnabled = false, isFullWidthEnabled, pluginInjectionApi, getIntl, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, isTableResizingEnabled) {
    var _pluginInjectionApi$a;
    const list = {};
    const ariaNotifyPlugin = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.accessibilityUtils) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions.ariaNotify;
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.nextCell).common, (0, $8ViBq.goToNextCell)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(1), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.previousCell).common, (0, $8ViBq.goToNextCell)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)(-1), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.toggleTable).common, (0, $cTbwC.editorCommandToPMCommand)((0, $jEslx.insertTableWithNestingSupport)({
        isTableScalingEnabled: isTableScalingEnabled,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: !!isFullWidthEnabled,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableResizingEnabled: isTableResizingEnabled
    }, api, {
        action: (0, $3LeME.ACTION).INSERTED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE,
        attributes: {
            inputMethod: (0, $3LeME.INPUT_METHOD).SHORTCUT
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    })), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.backspace).common, (0, $jGkle.chainCommands)((0, $kfljr.deleteTableIfSelectedWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).KEYBOARD), (0, $kfljr.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).KEYBOARD)), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.backspace).common, (0, $8L6TV.moveCursorBackward), list);
    // Add row/column shortcuts
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addRowBefore).common, (0, $kfljr.addRowAroundSelection)(editorAnalyticsAPI)('TOP'), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addRowAfter).common, (0, $kfljr.addRowAroundSelection)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addColumnBefore).common, (0, $jEslx.addColumnBefore)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addColumnAfter).common, (0, $jEslx.addColumnAfter)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addRowBeforeVO).common, (0, $kfljr.addRowAroundSelection)(editorAnalyticsAPI)('TOP'), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addRowAfterVO).common, (0, $kfljr.addRowAroundSelection)(editorAnalyticsAPI)('BOTTOM'), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addColumnBeforeVO).common, (0, $jEslx.addColumnBefore)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.addColumnAfterVO).common, (0, $jEslx.addColumnAfter)(api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    if ((0, $eUtBU.moveRowDown).common && (0, $eUtBU.moveRowUp).common && (0, $eUtBU.moveColumnLeft).common && (0, $eUtBU.moveColumnRight).common) {
        const isNewKeyMapExperiment = (0, $aEmSo.expValEquals)('editor-a11y-fy26-keyboard-move-row-column', 'isEnabled', true);
        // Move row/column shortcuts
        /**
     * NOTE: If the keyboard shortcut for moving rows or columns is changed, we need to update the handleKeyDown function
     * in packages/editor/editor-plugin-table/src/pm-plugins/drag-and-drop/plugin.ts
     * to make sure the logic for holding the shortcut keys is valid
     * See ticket ED-22154 https://product-fabric.atlassian.net/browse/ED-22154
     */ (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $eUtBU.moveRowDown).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.moveRowDownOld).common, (0, $cwJ2b.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', 1), list);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $eUtBU.moveRowUp).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.moveRowUpOld).common, (0, $cwJ2b.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-row', -1), list);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $eUtBU.moveColumnLeft).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.moveColumnLeftOld).common, (0, $cwJ2b.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', -1), list);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        isNewKeyMapExperiment ? (0, $eUtBU.moveColumnRight).common : // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.moveColumnRightOld).common, (0, $cwJ2b.moveSourceWithAnalyticsViaShortcut)(editorAnalyticsAPI, ariaNotifyPlugin, getIntl)('table-column', 1), list);
        // Delete row/column shortcuts
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.deleteColumn).common, (0, $kfljr.deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
        (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $eUtBU.deleteRow).common, (0, $kfljr.deleteSelectedRowsOrColumnsWithAnalyticsViaShortcut)(editorAnalyticsAPI, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent), list);
    }
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.startColumnResizing).common, (0, $hVZWA.initiateKeyboardColumnResizing)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveRight).common, (0, $hVZWA.activateNextResizeArea)({
        direction: 1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveLeft).common, (0, $hVZWA.activateNextResizeArea)({
        direction: -1,
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
    }), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveDown).common, (0, $8ViBq.goToNextCellVertical)(1), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.moveUp).common, (0, $8ViBq.goToNextCellVertical)(-1), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.decreaseMediaSize).common, (0, $kfljr.changeColumnWidthByStepWithAnalytics)(editorAnalyticsAPI, api)(-10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $3LeME.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.increaseMediaSize).common, (0, $kfljr.changeColumnWidthByStepWithAnalytics)(editorAnalyticsAPI, api)(10, getEditorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, !!isCommentEditor, (0, $3LeME.INPUT_METHOD).SHORTCUT, ariaNotifyPlugin, getIntl), list);
    (0, $eUtBU.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.escape).common, (0, $hVZWA.stopKeyboardColumnResizing)({
        ariaNotify: ariaNotifyPlugin,
        getIntl: getIntl
    }), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.focusToContextMenuTrigger).common, (0, $8L6TV.setFocusToCellMenu)(), list);
    return (0, $1O8Lw.keymap)(list);
}
var $f58910fc4bfc9dd1$export$2e2bcd8739ae039 = $f58910fc4bfc9dd1$export$e832373cff8dec22;

});
parcelRegister("8ViBq", function(module, exports) {
$parcel$export(module.exports, "goToNextCell", () => $67fec654785ab68f$export$78a7cb7971e0752d);
$parcel$export(module.exports, "goToNextCellVertical", () => $67fec654785ab68f$export$24bf4ae22c7b6454);

var $3LeME = parcelRequire("3LeME");

var $4tUqV = parcelRequire("4tUqV");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $6AHSo = parcelRequire("6AHSo");
var $5n2u9 = parcelRequire("5n2u9");
var $5JFXS = parcelRequire("5JFXS");
var $kD3Xq = parcelRequire("kD3Xq");

var $iJnuE = parcelRequire("iJnuE");

var $4GJqd = parcelRequire("4GJqd");

var $hVZWA = parcelRequire("hVZWA");

var $kfljr = parcelRequire("kfljr");
const $67fec654785ab68f$var$TAB_FORWARD_DIRECTION = 1;
const $67fec654785ab68f$var$TAB_BACKWARD_DIRECTION = -1;
const $67fec654785ab68f$export$78a7cb7971e0752d = (editorAnalyticsAPI, ariaNotify, getIntl)=>(direction)=>(state, dispatch, view)=>{
            var _getPluginState;
            const table = (0, $5n2u9.findTable)(state.selection);
            if (!table) return false;
            const isColumnResizing = (_getPluginState = (0, $4GJqd.getPluginState)(state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.isKeyboardResize;
            if (isColumnResizing) {
                (0, $hVZWA.stopKeyboardColumnResizing)({
                    ariaNotify: ariaNotify,
                    getIntl: getIntl
                })(state, dispatch, view);
                return true;
            }
            const map = (0, $dpooP.TableMap).get(table.node);
            const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const cell = (0, $a4TQr.findParentNodeOfType)([
                tableCell,
                tableHeader
            ])(state.selection);
            const firstCellPos = map.positionAt(0, 0, table.node) + table.start;
            const lastCellPos = map.positionAt(map.height - 1, map.width - 1, table.node) + table.start;
            // When tabbing backwards at first cell (top left), insert row at the start of table
            if (firstCellPos === cell.pos && direction === $67fec654785ab68f$var$TAB_BACKWARD_DIRECTION) {
                (0, $kfljr.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).KEYBOARD, {
                    index: 0,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            // When tabbing forwards at last cell (bottom right), insert row at the end of table
            if (lastCellPos === cell.pos && direction === $67fec654785ab68f$var$TAB_FORWARD_DIRECTION) {
                (0, $kfljr.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).KEYBOARD, {
                    index: map.height,
                    moveCursorToInsertedRow: true
                })(state, dispatch);
                return true;
            }
            if (dispatch) return (0, $iJnuE.goToNextCell)(direction)(state, dispatch);
            return true;
        };
const $67fec654785ab68f$export$24bf4ae22c7b6454 = (direction)=>(state, dispatch)=>{
        const { selection: selection } = state;
        const nestedTableSelection = (0, $4tUqV.isSelectionTableNestedInTable)(state);
        if (!(selection instanceof (0, $801jp.NodeSelection)) && !nestedTableSelection) return false; // Let ProseMirror handle other selection types
        let table = (0, $5n2u9.findTable)(selection);
        let cell = (0, $6AHSo.findCellClosestToPos)(state.doc.resolve(selection.from));
        let selectionPos = selection.from;
        // Handle when we have nested table fully selected
        if (table && nestedTableSelection && (0, $kD3Xq.isTableSelected)(selection)) {
            const parentTablePos = table.pos;
            table = (0, $5JFXS.findTableClosestToPos)(state.doc.resolve(parentTablePos));
            cell = (0, $6AHSo.findCellClosestToPos)(state.doc.resolve(parentTablePos));
            selectionPos = parentTablePos;
        }
        if (!table || !cell || !cell.pos) return false;
        const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
        // Let ProseMirror handle movement within the cell if content exists above/below
        if ($67fec654785ab68f$var$cellHasContentInDirection(cell.node, cell.pos, selectionPos, direction)) return false;
        // Move to the next cell vertically
        const map = (0, $dpooP.TableMap).get(table.node);
        const nextCellPos = map.nextCell(cell.pos - table.start, 'vert', direction);
        if (dispatch && nextCellPos) {
            var _$nextCell$nodeAfter, _$nextCell$nodeAfter2;
            const nextCellStart = table.start + nextCellPos;
            const $nextCell = state.doc.resolve(nextCellStart);
            if ((_$nextCell$nodeAfter = $nextCell.nodeAfter) !== null && _$nextCell$nodeAfter !== void 0 && _$nextCell$nodeAfter.type && [
                tableCell,
                tableHeader
            ].includes((_$nextCell$nodeAfter2 = $nextCell.nodeAfter) === null || _$nextCell$nodeAfter2 === void 0 ? void 0 : _$nextCell$nodeAfter2.type)) {
                const contentPos = $67fec654785ab68f$var$getTargetPositionInNextCell($nextCell.nodeAfter, nextCellStart, direction);
                dispatch(state.tr.setSelection((0, $801jp.TextSelection).create(state.doc, contentPos)));
                return true;
            }
            return false;
        }
        return false; // No next cell found
    };
function $67fec654785ab68f$var$cellHasContentInDirection(cellNode, cellPos, selectionPos, direction) {
    let hasContent = false;
    cellNode.content.forEach((node, offset)=>{
        const nodeStart = cellPos + 1 + offset;
        const nodeEnd = nodeStart + node.nodeSize;
        if (direction === 1 && nodeStart > selectionPos && node.isBlock) hasContent = true; // Content below
        else if (direction === -1 && nodeEnd <= selectionPos && node.isBlock) hasContent = true; // Content above
    });
    return hasContent;
}
function $67fec654785ab68f$var$getTargetPositionInNextCell(cellNode, nextCellStart, direction) {
    let contentPos = nextCellStart + 1; // Default: just inside the cell
    if (cellNode.content.size > 0) {
        if (direction === 1) {
            const firstChild = cellNode.firstChild;
            if (firstChild && firstChild.isBlock) contentPos = nextCellStart + 1 + (firstChild.isLeaf ? 0 : 1); // Down: Start of first block
        } else if (direction === -1) {
            let lastBlock;
            let lastOffset = 0;
            cellNode.content.forEach((node, offset)=>{
                if (node.isBlock) {
                    lastBlock = node;
                    lastOffset = offset;
                }
            });
            if (lastBlock) contentPos = nextCellStart + 1 + lastOffset + (lastBlock.isLeaf ? 0 : lastBlock.nodeSize - 1);
        }
    }
    return contentPos;
}

});
parcelRegister("iJnuE", function(module, exports) {
$parcel$export(module.exports, "goToNextCell", () => $25a7c4de74a40cd2$export$78a7cb7971e0752d);

var $801jp = parcelRequire("801jp");

var $auYrv = parcelRequire("auYrv");

var $2mhIH = parcelRequire("2mhIH");
function $25a7c4de74a40cd2$var$moveCellForward($pos) {
    const nextNodeSize = $pos.nodeAfter ? $pos.nodeAfter.nodeSize : 0;
    return $pos.node(0).resolve($pos.pos + nextNodeSize);
}
function $25a7c4de74a40cd2$export$78a7cb7971e0752d(direction) {
    return function(state, dispatch) {
        if (!(0, $auYrv.isInTable)(state)) return false;
        const cellSelection = (0, $2mhIH.selectionCell)(state.selection);
        if (!cellSelection) return false;
        const cell = $25a7c4de74a40cd2$var$findNextCell(cellSelection, direction);
        if (cell === undefined) return false;
        if (dispatch) {
            const $cell = state.doc.resolve(cell);
            dispatch(state.tr.setSelection((0, $801jp.TextSelection).between($cell, $25a7c4de74a40cd2$var$moveCellForward($cell))).scrollIntoView());
        }
        return true;
    };
}
function $25a7c4de74a40cd2$var$findNextCell($cell, direction) {
    if (direction === -1) {
        const before = $cell.nodeBefore;
        if (before) return $cell.pos - before.nodeSize;
        for(let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--){
            const rowNode = $cell.node(-1).child(row);
            if (rowNode.childCount && rowNode.lastChild) return rowEnd - 1 - rowNode.lastChild.nodeSize;
            rowEnd -= rowNode.nodeSize;
        }
    } else {
        if ($cell.index() < $cell.parent.childCount - 1 && $cell.nodeAfter) return $cell.pos + $cell.nodeAfter.nodeSize;
        let table = $cell.node(-1);
        // table is the parent table, not the nested table
        if ($cell.node(-4) && $cell.node(-4).type.name === 'table') table = $cell.node(-4);
        for(let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++){
            const rowNode = table.child(row);
            if (rowNode.childCount) return rowStart + 1;
            rowStart += rowNode.nodeSize;
        }
    }
}

});



parcelRegister("iXpZM", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $55cf39022ff185e8$export$ae829ec7b2625219);

var $6Zi52 = parcelRequire("6Zi52");

var $3LeME = parcelRequire("3LeME");

var $dqFZv = parcelRequire("dqFZv");

var $aybRd = parcelRequire("aybRd");

var $knIPH = parcelRequire("knIPH");

var $1y7gE = parcelRequire("1y7gE");

var $cGAz2 = parcelRequire("cGAz2");
var $aoDHb = parcelRequire("aoDHb");

var $hUTaU = parcelRequire("hUTaU");

var $dwQms = parcelRequire("dwQms");

var $hCON4 = parcelRequire("hCON4");

var $a4TQr = parcelRequire("a4TQr");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $elvtA = parcelRequire("elvtA");

var $f3xW3 = parcelRequire("f3xW3");

var $YREXK = parcelRequire("YREXK");

var $x2FuQ = parcelRequire("x2FuQ");

var $8L6TV = parcelRequire("8L6TV");
var $EwLhB = parcelRequire("EwLhB");

var $hVZWA = parcelRequire("hVZWA");

var $8L6TV = parcelRequire("8L6TV");

var $b7w2R = parcelRequire("b7w2R");

var $4GJqd = parcelRequire("4GJqd");

var $4dyXt = parcelRequire("4dyXt");

var $1uBzh = parcelRequire("1uBzh");

var $7PTkn = parcelRequire("7PTkn");

var $ijKnh = parcelRequire("ijKnh");

var $brCnW = parcelRequire("brCnW");

var $duvJJ = parcelRequire("duvJJ");

var $h3r8b = parcelRequire("h3r8b");
const $55cf39022ff185e8$export$ae829ec7b2625219 = (dispatchAnalyticsEvent, dispatch, portalProviderAPI, nodeViewPortalProviderAPI, eventDispatcher, pluginConfig, getEditorContainerWidth, getEditorFeatureFlags, getIntl, fullWidthModeEnabled, previousFullWidthModeEnabled, editorAnalyticsAPI, pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption, __livePage)=>{
    var _accessibilityUtils;
    const state = (0, $4GJqd.createPluginState)(dispatch, {
        pluginConfig: pluginConfig,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        isTableHovered: false,
        insertColumnButtonIndex: undefined,
        insertRowButtonIndex: undefined,
        isFullWidthModeEnabled: fullWidthModeEnabled,
        wasFullWidthModeEnabled: previousFullWidthModeEnabled,
        isHeaderRowEnabled: !!pluginConfig.allowHeaderRow,
        isHeaderColumnEnabled: false,
        isTableScalingEnabled: isTableScalingEnabled,
        activeTableMenu: {
            type: 'none'
        },
        ...(0, $b7w2R.defaultHoveredCell),
        ...(0, $b7w2R.defaultTableSelection),
        getIntl: getIntl
    });
    // Used to prevent invalid table cell spans being reported more than once per editor/document
    const invalidTableIds = [];
    let editorViewRef = null;
    const ariaNotifyPlugin = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_accessibilityUtils = pluginInjectionApi.accessibilityUtils) === null || _accessibilityUtils === void 0 ? void 0 : _accessibilityUtils.actions.ariaNotify;
    const getCurrentEditorState = ()=>{
        const editorView = editorViewRef;
        if (!editorView) return null;
        return editorView.state;
    };
    const intl = getIntl();
    const getNodeView = ()=>{
        return {
            table: (0, $elvtA.tableView)({
                portalProviderAPI: portalProviderAPI,
                eventDispatcher: eventDispatcher,
                getEditorContainerWidth: getEditorContainerWidth,
                getEditorFeatureFlags: getEditorFeatureFlags,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                isCommentEditor: isCommentEditor,
                isChromelessEditor: isChromelessEditor,
                allowFixedColumnWidthOption: allowFixedColumnWidthOption,
                intl: intl
            }),
            tableRow: (0, $elvtA.tableRowView)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            }),
            tableCell: (0, $elvtA.tableCellView)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            }),
            tableHeader: (0, $elvtA.tableHeaderView)({
                eventDispatcher: eventDispatcher,
                pluginInjectionApi: pluginInjectionApi
            })
        };
    };
    const nodeViews = getNodeView();
    return new (0, $1y7gE.SafePlugin)({
        state: state,
        key: (0, $4dyXt.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            function reportInvalidTableCellSpanAttrs(invalidNodeAttr) {
                if (invalidTableIds.find((id)=>id === invalidNodeAttr.tableLocalId)) return;
                invalidTableIds.push(invalidNodeAttr.tableLocalId);
                dispatchAnalyticsEvent({
                    action: (0, $3LeME.ACTION).INVALID_DOCUMENT_ENCOUNTERED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).EDITOR,
                    eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        nodeType: invalidNodeAttr.nodeType,
                        reason: `${invalidNodeAttr.attribute}: ${invalidNodeAttr.reason}`,
                        tableLocalId: invalidNodeAttr.tableLocalId,
                        spanValue: invalidNodeAttr.spanValue
                    }
                });
            }
            if (tr) {
                const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
                // "fixTables" removes empty rows as we don't allow that in schema
                const updatedTr = (0, $x2FuQ.handleCut)(tr, oldState, newState, pluginInjectionApi, editorAnalyticsAPI, editorViewRef || undefined, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent);
                return (0, $1uBzh.fixTables)(updatedTr) || updatedTr;
            }
            if (transactions.find((tr)=>tr.docChanged)) return (0, $1uBzh.fixTables)(newState.tr, reportInvalidTableCellSpanAttrs);
        },
        view: (editorView)=>{
            var _pluginInjectionApi$e;
            const domAtPos = editorView.domAtPos.bind(editorView);
            editorViewRef = editorView;
            let hasMeasuredContentModeTables = false;
            let focusListenerBinding = null;
            if (!__livePage && (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.editorViewMode) === null || _pluginInjectionApi$e === void 0 || (_pluginInjectionApi$e = _pluginInjectionApi$e.sharedState.currentState()) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.mode) !== 'view' && (0, $h3r8b.isContentModeSupported)({
                allowColumnResizing: !!pluginConfig.allowColumnResizing,
                allowTableResizing: !!pluginConfig.allowTableResizing,
                isFullPageEditor: !isChromelessEditor && !isCommentEditor
            })) focusListenerBinding = (0, $6Zi52.bind)(editorView.dom, {
                type: 'focus',
                listener: ()=>{
                    if (hasMeasuredContentModeTables) return;
                    hasMeasuredContentModeTables = true;
                    (0, $duvJJ.applyMeasuredWidthToAllTables)(editorView, pluginInjectionApi);
                },
                options: {
                    once: true
                }
            });
            return {
                update: (view, prevState)=>{
                    var _pluginInjectionApi$e2, _pluginInjectionApi$i;
                    const { state: state, dispatch: dispatch } = view;
                    const { selection: selection } = state;
                    const pluginState = (0, $4GJqd.getPluginState)(state);
                    let tableRef;
                    const parent = (0, $a4TQr.findParentDomRefOfType)(state.schema.nodes.table, domAtPos)(selection);
                    const shouldSetTableRef = parent && (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e2 = pluginInjectionApi.editorViewMode) === null || _pluginInjectionApi$e2 === void 0 || (_pluginInjectionApi$e2 = _pluginInjectionApi$e2.sharedState.currentState()) === null || _pluginInjectionApi$e2 === void 0 ? void 0 : _pluginInjectionApi$e2.mode) !== 'view' && (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$i = pluginInjectionApi.interaction) === null || _pluginInjectionApi$i === void 0 || (_pluginInjectionApi$i = _pluginInjectionApi$i.sharedState.currentState()) === null || _pluginInjectionApi$i === void 0 ? void 0 : _pluginInjectionApi$i.interactionState) !== 'hasNotHadInteraction';
                    if (shouldSetTableRef) tableRef = // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    parent.querySelector('table') || undefined;
                    if (pluginState.editorHasFocus) {
                        const tableNode = (0, $5n2u9.findTable)(state.selection);
                        // when keyboard cursor leaves the table we need to stop column resizing
                        const pluginPrevState = (0, $4GJqd.getPluginState)(prevState);
                        const isStopKeyboardColumResizing = pluginPrevState.isResizeHandleWidgetAdded && pluginPrevState.isKeyboardResize;
                        if (isStopKeyboardColumResizing) {
                            const isTableNodesDifferent = (pluginPrevState === null || pluginPrevState === void 0 ? void 0 : pluginPrevState.tableNode) !== (tableNode === null || tableNode === void 0 ? void 0 : tableNode.node);
                            if (pluginPrevState !== null && pluginPrevState !== void 0 && pluginPrevState.tableNode && tableNode && isTableNodesDifferent) {
                                const oldRowsNumber = (0, $dpooP.TableMap).get(pluginPrevState.tableNode).height;
                                const newRowsNumber = (0, $dpooP.TableMap).get(tableNode.node).height;
                                if (oldRowsNumber !== newRowsNumber || // Add/delete row
                                tableNode.node.attrs.localId !== pluginPrevState.tableNode.attrs.localId) // Jump to another table
                                (0, $hVZWA.stopKeyboardColumnResizing)({
                                    ariaNotify: ariaNotifyPlugin,
                                    getIntl: getIntl
                                })(state, dispatch);
                            } else if (!tableNode) // selection outside of table
                            (0, $hVZWA.stopKeyboardColumnResizing)({
                                ariaNotify: ariaNotifyPlugin,
                                getIntl: getIntl
                            })(state, dispatch);
                        }
                    }
                    if (pluginState.tableRef !== tableRef) (0, $8L6TV.setTableRef)(tableRef)(state, dispatch);
                    if (pluginState.editorHasFocus && pluginState.tableRef) {
                        const { $cursor: $cursor } = state.selection;
                        if ($cursor) {
                            // Only update bold when it's a cursor
                            const tableCellHeader = (0, $a4TQr.findParentNodeOfType)(state.schema.nodes.tableHeader)(state.selection);
                            if (tableCellHeader) (0, $8L6TV.addBoldInEmptyHeaderCells)(tableCellHeader)(state, dispatch);
                        }
                    } else if (pluginState.isResizeHandleWidgetAdded) (0, $8L6TV.removeResizeHandleDecorations)()(state, dispatch);
                },
                destroy: ()=>{
                    focusListenerBinding && focusListenerBinding();
                }
            };
        },
        props: {
            transformPasted (slice) {
                const editorState = getCurrentEditorState();
                if (!editorState) return slice;
                const { schema: schema } = editorState;
                // if we're pasting to outside a table or outside a table
                // header, ensure that we apply any table headers to the first
                // row of content we see, if required
                if (!(0, $aybRd.insideTable)(editorState) && (0, $brCnW.isHeaderRowRequired)(editorState)) slice = (0, $8L6TV.transformSliceToAddTableHeaders)(slice, schema);
                // This fixes pasting a table with default layout into comment editor
                // table lose width and expand to full width
                if (!(0, $aybRd.insideTable)(editorState) && isCommentEditor && pluginConfig.allowTableAlignment && isTableScalingEnabled) slice = (0, $brCnW.transformSliceTableLayoutDefaultToCenter)(slice, schema);
                slice = (0, $brCnW.transformSliceToFixHardBreakProblemOnCopyFromCell)(slice, schema);
                // We do this separately, so it also applies to drag/drop events
                // This needs to go before `transformSliceToRemoveOpenExpand`
                slice = (0, $dwQms.transformSliceToRemoveOpenLayoutNodes)(slice, schema);
                // If a partial paste of expand, paste only the content
                // This needs to go before `transformSliceToRemoveOpenTable`
                slice = (0, $cGAz2.transformSliceToRemoveOpenExpand)(slice, schema);
                // transformSliceToRemoveOpenTable() transforms based on the depth of the root node, assuming that the tables will be at the root
                // Bodied extensions will contribute to the depth of the table selection so we need to remove them first
                /** If a partial paste of bodied extension, paste only text */ slice = (0, $hUTaU.transformSliceToRemoveOpenBodiedExtension)(slice, schema);
                /** If a partial paste of table, paste only table's content */ slice = (0, $brCnW.transformSliceToRemoveOpenTable)(slice, schema);
                /** If a partial paste of multi bodied extension, paste only children */ slice = (0, $hUTaU.transformSliceToRemoveOpenMultiBodiedExtension)(slice, schema);
                slice = (0, $brCnW.transformSliceToCorrectEmptyTableCells)(slice, schema);
                if (!pluginConfig.allowColumnResizing) slice = (0, $8L6TV.transformSliceToRemoveColumnsWidths)(slice, schema);
                // If we don't allow background on cells, we need to remove it
                // from the paste slice
                if (!pluginConfig.allowBackgroundColor) slice = (0, $8L6TV.transformSliceRemoveCellBackgroundColor)(slice, schema);
                else slice = (0, $8L6TV.transformSliceToFixDarkModeDefaultBackgroundColor)(slice, schema);
                slice = (0, $aoDHb.transformSliceToRemoveOpenNestedExpand)(slice, schema);
                if ((0, $knIPH.isNestedTablesSupported)(schema)) slice = (0, $brCnW.transformSliceToRemoveNestedTables)(slice, schema, editorState.selection);
                return slice;
            },
            handleClick: ({ state: state, dispatch: dispatch }, _pos, event)=>{
                const decorationSet = (0, $f3xW3.pluginKey).getState(state);
                const browser = (0, $dqFZv.getBrowserInfo)();
                if ((0, $ijKnh.findControlsHoverDecoration)(decorationSet).length) (0, $EwLhB.clearHoverSelection)()(state, dispatch);
                // ED-6069: workaround for Chrome given a regression introduced in prosemirror-view@1.6.8
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/commit/33fe4a8b01584f6b4103c279033dcd33e8047b95
                if (browser.chrome && event.target) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const targetClassList = event.target.classList;
                    if (targetClassList.contains((0, $YREXK.TableCssClassName).CONTROLS_BUTTON) || targetClassList.contains((0, $YREXK.TableCssClassName).CONTEXTUAL_MENU_BUTTON) || targetClassList.contains((0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE) || targetClassList.contains((0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER)) return true;
                }
                return false;
            },
            handleScrollToSelection: (view)=>{
                // when typing into a sticky header cell, we don't want to scroll
                // back to the top of the table if the user has already scrolled down
                const { tableHeader: tableHeader } = view.state.schema.nodes;
                const domRef = (0, $a4TQr.findParentDomRefOfType)(tableHeader, view.domAtPos.bind(view))(view.state.selection);
                const maybeTr = (0, $hCON4.closestElement)(domRef, 'tr');
                return maybeTr ? maybeTr.classList.contains('sticky') : false;
            },
            handleTextInput: (view, _from, _to, text)=>{
                const { state: state, dispatch: dispatch } = view;
                const { isKeyboardResize: isKeyboardResize } = (0, $4GJqd.getPluginState)(state);
                if (isKeyboardResize) {
                    (0, $hVZWA.stopKeyboardColumnResizing)({
                        ariaNotify: ariaNotifyPlugin,
                        getIntl: getIntl
                    })(state, dispatch);
                    return false;
                }
                const tr = (0, $7PTkn.replaceSelectedTable)(state, text, (0, $3LeME.INPUT_METHOD).KEYBOARD, editorAnalyticsAPI);
                if (tr.selectionSet) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            nodeViews: nodeViews,
            handleDOMEvents: {
                focus: (0, $x2FuQ.handleFocus),
                blur: (0, $x2FuQ.handleBlur),
                mousedown: (0, $x2FuQ.withCellTracking)((view, event)=>(0, $x2FuQ.handleMouseDown)(view, event, pluginInjectionApi)),
                mouseleave: (0, $x2FuQ.handleMouseLeave),
                mousemove: (0, $x2FuQ.whenTableInFocus)((0, $x2FuQ.handleMouseMove)(nodeViewPortalProviderAPI), pluginInjectionApi),
                mouseenter: (0, $x2FuQ.handleMouseEnter),
                mouseup: (0, $x2FuQ.whenTableInFocus)((0, $x2FuQ.handleMouseUp)),
                click: (0, $x2FuQ.withCellTracking)((0, $x2FuQ.whenTableInFocus)((0, $x2FuQ.handleClick)))
            },
            handleTripleClick: $x2FuQ.handleTripleClick
        }
    });
};

});
parcelRegister("cGAz2", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveOpenExpand", () => $92751d591a633c99$export$6d57e15bdf5e650f);

var $7H6Cr = parcelRequire("7H6Cr");
const $92751d591a633c99$export$6d57e15bdf5e650f = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.expand) return new (0, $7H6Cr.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};

});

parcelRegister("aoDHb", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveOpenNestedExpand", () => $5e4478877b1b3c6b$export$74dbe7cb6b933cde);

var $7H6Cr = parcelRequire("7H6Cr");
const $5e4478877b1b3c6b$export$74dbe7cb6b933cde = (slice, schema)=>{
    if (slice.openStart > 1 && slice.openEnd > 1 && slice.content.childCount === 1 && slice.content.firstChild && slice.content.firstChild.type === schema.nodes.nestedExpand) return new (0, $7H6Cr.Slice)(slice.content.firstChild.content, slice.openStart - 1, slice.openEnd - 1);
    return slice;
};

});

parcelRegister("dwQms", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveOpenLayoutNodes", () => $9e6be58346ec0e86$export$82cc8566682e5cf4);

var $7H6Cr = parcelRequire("7H6Cr");

var $c5vAC = parcelRequire("c5vAC");

const $9e6be58346ec0e86$var$isLayoutNode = (node)=>node.type === node.type.schema.nodes.layoutSection || node.type === node.type.schema.nodes.layoutColumn;
function $9e6be58346ec0e86$export$5fc4db161d3fef1f(maybeLayoutSection) {
    const fragment = (0, $c5vAC.mapFragment)((0, $7H6Cr.Fragment).from(maybeLayoutSection), (node)=>{
        return $9e6be58346ec0e86$var$isLayoutNode(node) ? node.content : node;
    });
    const nodes = [];
    fragment.forEach((i)=>nodes.push(i));
    return nodes;
}
function $9e6be58346ec0e86$export$238984649a055433(node, i) {
    return i === 0 ? $9e6be58346ec0e86$export$5fc4db161d3fef1f(node) : node;
}
function $9e6be58346ec0e86$export$38d10d1907db60ca(node, i, fragment) {
    return i === fragment.childCount - 1 ? $9e6be58346ec0e86$export$5fc4db161d3fef1f(node) : node;
}
function $9e6be58346ec0e86$export$82cc8566682e5cf4(slice, schema) {
    // Case 1: A slice entirely within a single layoutSection
    if (slice.openStart && slice.openEnd && slice.content.childCount === 1) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const maybeLayoutSection = slice.content.firstChild;
        if (maybeLayoutSection.type === schema.nodes.layoutSection) return new (0, $7H6Cr.Slice)((0, $c5vAC.flatmap)(slice.content, $9e6be58346ec0e86$export$238984649a055433), // '-2' here because we've removed the layoutSection/layoutColumn; reducing the open depth.
        slice.openStart - 2, slice.openEnd - 2);
    }
    // Case 2: A slice starting inside a layoutSection and finishing outside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openStart && slice.content.firstChild.type === schema.nodes.layoutSection) slice = new (0, $7H6Cr.Slice)((0, $c5vAC.flatmap)(slice.content, $9e6be58346ec0e86$export$238984649a055433), slice.openStart - 2, slice.openEnd);
    // Case 3: A slice starting outside a layoutSection and finishing inside
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (slice.openEnd && slice.content.lastChild.type === schema.nodes.layoutSection) slice = new (0, $7H6Cr.Slice)((0, $c5vAC.flatmap)(slice.content, $9e6be58346ec0e86$export$38d10d1907db60ca), slice.openStart, slice.openEnd - 2);
    // Case 2 & 3 also handles a slice starting in one layoutSection & finishing in a different layoutSection
    return slice;
}

});

parcelRegister("elvtA", function(module, exports) {
$parcel$export(module.exports, "tableView", () => $3bc4264ced52c686$export$58b58f8ab97e94ed);
$parcel$export(module.exports, "tableCellView", () => $3bc4264ced52c686$export$cb505927d54cfbe6);
$parcel$export(module.exports, "tableHeaderView", () => $3bc4264ced52c686$export$182d82ed34901998);
$parcel$export(module.exports, "tableRowView", () => $3bc4264ced52c686$export$2b8a69d954e9d30);

var $gOVfD = parcelRequire("gOVfD");

var $lXQ6g = parcelRequire("lXQ6g");

var $93rwv = parcelRequire("93rwv");

var $6jRUe = parcelRequire("6jRUe");

var $h6dLY = parcelRequire("h6dLY");
const $3bc4264ced52c686$export$58b58f8ab97e94ed = (options)=>{
    return (node, view, getPos)=>{
        return (0, $lXQ6g.createTableView)(node, view, getPos, options.portalProviderAPI, options.eventDispatcher, options.getEditorContainerWidth, options.getEditorFeatureFlags, options.dispatchAnalyticsEvent, options.pluginInjectionApi, options.isCommentEditor, options.isChromelessEditor, options === null || options === void 0 ? void 0 : options.allowFixedColumnWidthOption, options.intl);
    };
};
const $3bc4264ced52c686$export$cb505927d54cfbe6 = (options)=>{
    return (node, view, getPos)=>{
        var _options$pluginInject;
        return new (0, $93rwv.default)(node, view, getPos, options.eventDispatcher, (_options$pluginInject = options.pluginInjectionApi) === null || _options$pluginInject === void 0 || (_options$pluginInject = _options$pluginInject.analytics) === null || _options$pluginInject === void 0 ? void 0 : _options$pluginInject.actions);
    };
};
const $3bc4264ced52c686$export$182d82ed34901998 = (options)=>{
    return (node, view, getPos)=>{
        var _options$pluginInject2;
        return new (0, $93rwv.default)(node, view, getPos, options.eventDispatcher, (_options$pluginInject2 = options.pluginInjectionApi) === null || _options$pluginInject2 === void 0 || (_options$pluginInject2 = _options$pluginInject2.analytics) === null || _options$pluginInject2 === void 0 ? void 0 : _options$pluginInject2.actions);
    };
};
const $3bc4264ced52c686$export$2b8a69d954e9d30 = (options)=>{
    return (node, view, getPos)=>{
        if ((0, $gOVfD.isNativeStickySupported)()) return new (0, $h6dLY.default)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
        else return new (0, $6jRUe.default)(node, view, getPos, options.eventDispatcher, options.pluginInjectionApi);
    };
};

});
parcelRegister("gOVfD", function(module, exports) {
$parcel$export(module.exports, "isNativeStickySupported", () => $010c68de4c3d03f0$export$2ee7329d46115d8f);

var $jiju3 = parcelRequire("jiju3");

var $dqFZv = parcelRequire("dqFZv");
const $010c68de4c3d03f0$export$2073a24f9367a16f = (0, $jiju3.default)(()=>{
    if (window.CSS && window.CSS.supports) return window.CSS.supports('anchor-name: --anchor');
    return false;
});
const $010c68de4c3d03f0$export$2ee7329d46115d8f = ()=>{
    const safariVersion = (0, $dqFZv.getBrowserInfo)().safari_version;
    const isBrowserSafari = !Number.isNaN(safariVersion);
    return(// Safari has a bug with position: sticky and content editable, so we don't support it
    !isBrowserSafari && $010c68de4c3d03f0$export$2073a24f9367a16f());
};

});

parcelRegister("lXQ6g", function(module, exports) {
$parcel$export(module.exports, "createTableView", () => $a85f1813eea3eaa1$export$f0e1dd383a612bf9);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $k5JVX = parcelRequire("k5JVX");

var $5237J = parcelRequire("5237J");

var $bzCw0 = parcelRequire("bzCw0");

var $i5qTg = parcelRequire("i5qTg");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $014x6 = parcelRequire("014x6");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $aEmSo = parcelRequire("aEmSo");

var $d9DFt = parcelRequire("d9DFt");

var $4GJqd = parcelRequire("4GJqd");

var $8aCba = parcelRequire("8aCba");

var $4WYVI = parcelRequire("4WYVI");

var $h3r8b = parcelRequire("h3r8b");

var $dZKRP = parcelRequire("dZKRP");

var $6GRh1 = parcelRequire("6GRh1");

var $iVMHB = parcelRequire("iVMHB");

var $6Waiv = parcelRequire("6Waiv");
const $a85f1813eea3eaa1$var$tableAttributes = (node)=>{
    return {
        'data-number-column': node.attrs.isNumberColumnEnabled,
        'data-layout': node.attrs.layout,
        'data-autosize': node.attrs.__autoSize,
        'data-table-local-id': node.attrs.localId || '',
        'data-table-width': node.attrs.width || 'inherit',
        'data-table-display-mode': node.attrs.displayMode
    };
};
const $a85f1813eea3eaa1$var$getInlineWidth = (node, options, state, pos, allowTableResizing)=>{
    if (!node.attrs.width && options !== null && options !== void 0 && options.isChromelessEditor || !node.attrs.width && options !== null && options !== void 0 && options.isCommentEditor && allowTableResizing) return;
    // provide a width for tables when custom table width is supported
    // this is to ensure 'responsive' tables (colgroup widths are undefined) become fixed to
    // support screen size adjustments
    const shouldHaveInlineWidth = allowTableResizing && !(0, $4WYVI.isTableNested)(state, pos);
    let widthValue = (0, $k5JVX.getTableContainerWidth)(node);
    if (node.attrs.isNumberColumnEnabled) widthValue -= (0, $014x6.akEditorTableNumberColumnWidth);
    return shouldHaveInlineWidth ? widthValue : undefined;
};
const $a85f1813eea3eaa1$var$handleInlineTableWidth = (table, width)=>{
    if (!table || !width) return;
    table.style.setProperty('width', `${width}px`);
};
class $a85f1813eea3eaa1$export$2e2bcd8739ae039 extends (0, $5237J.default) {
    constructor(props){
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props, undefined, undefined, // @portal-render-immediately
        true), this.isNestedTable = false, this.getNode = ()=>{
            return this.node;
        }, this.hasHoveredRows = false;
        this.getPos = props.getPos;
        this.eventDispatcher = props.eventDispatcher;
        this.options = props.options;
        this.getEditorFeatureFlags = props.getEditorFeatureFlags;
        this.intl = props.intl;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) this.roundedTableEdges = new (0, $dZKRP.RoundedTableEdges)(()=>this.table, props.node);
        this.handleRef = (node)=>this._handleTableRef(node);
    }
    getContentDOM() {
        var _this$reactComponentP, _this$reactComponentP2, _this$reactComponentP3, _this$reactComponentP4;
        const isNested = (0, $4WYVI.isTableNested)(this.view.state, this.getPos());
        const tableDOMStructure = (0, $6Waiv.tableNodeSpecWithFixedToDOM)({
            allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
            tableResizingEnabled: !!this.reactComponentProps.allowTableResizing,
            getEditorContainerWidth: this.reactComponentProps.getEditorContainerWidth,
            isTableScalingEnabled: (_this$reactComponentP = this.reactComponentProps.options) === null || _this$reactComponentP === void 0 ? void 0 : _this$reactComponentP.isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: (_this$reactComponentP2 = this.reactComponentProps.options) === null || _this$reactComponentP2 === void 0 ? void 0 : _this$reactComponentP2.shouldUseIncreasedScalingPercent,
            isCommentEditor: (_this$reactComponentP3 = this.reactComponentProps.options) === null || _this$reactComponentP3 === void 0 ? void 0 : _this$reactComponentP3.isCommentEditor,
            isChromelessEditor: (_this$reactComponentP4 = this.reactComponentProps.options) === null || _this$reactComponentP4 === void 0 ? void 0 : _this$reactComponentP4.isChromelessEditor,
            isNested: isNested
        }).toDOM(this.node);
        const rendered = (0, $7H6Cr.DOMSerializer).renderSpec(document, tableDOMStructure);
        if (rendered.dom) {
            var _this$reactComponentP5, _this$options, _this$options2;
            const tableElement = rendered.dom.querySelector('table');
            this.table = tableElement ? tableElement : rendered.dom;
            this.renderedDOM = rendered.dom;
            this.isNestedTable = isNested;
            this.updateContentVisibility();
            const allowFixedColumnWidthOption = ((_this$reactComponentP5 = this.reactComponentProps) === null || _this$reactComponentP5 === void 0 ? void 0 : _this$reactComponentP5.allowFixedColumnWidthOption) || false;
            if (!((_this$options = this.options) !== null && _this$options !== void 0 && _this$options.isTableScalingEnabled) || (_this$options2 = this.options) !== null && _this$options2 !== void 0 && _this$options2.isTableScalingEnabled && allowFixedColumnWidthOption && this.node.attrs.displayMode === 'fixed') {
                const tableInlineWidth = $a85f1813eea3eaa1$var$getInlineWidth(this.node, this.reactComponentProps.options, this.reactComponentProps.view.state, this.reactComponentProps.getPos(), this.reactComponentProps.allowTableResizing);
                if (tableInlineWidth) $a85f1813eea3eaa1$var$handleInlineTableWidth(this.table, tableInlineWidth);
            }
        }
        return rendered;
    }
    /**
   * Handles moving the table from ProseMirror's DOM structure into a React-rendered table node.
   * Temporarily disables mutation observers (except for selection changes) during the move,
   * preserves selection state, and restores it afterwards if mutations occurred and cursor
   * wasn't at start of node. This prevents duplicate tables and maintains editor state during
   * the DOM manipulation.
   */ _handleTableRef(node) {
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // Only proceed if we have both a node and table, and the table isn't already inside the node
        if (node && this.table && !node.contains(this.table)) {
            // Patch to prevent selection collapsing when moving the table down with ctrl + shift + down
            const selectionBeforeMove = this.view.state.selection;
            const shouldPreserveCellSelection = selectionBeforeMove instanceof (0, $ev7OZ.CellSelection);
            // Store the current ignoreMutation handler so we can restore it later
            oldIgnoreMutation = this.ignoreMutation;
            // Set up a temporary mutation handler that:
            // - Ignores all DOM mutations except selection changes
            // - Tracks when mutations have been ignored via mutationsIgnored flag
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation || shouldPreserveCellSelection && this.view.state.selection.eq(selectionBeforeMove);
            };
            // Store the current selection state if there is a visible selection
            // This lets us restore it after DOM changes
            const { selection: selection } = this.view.state;
            const tablePos = this.getPos();
            if (selection.empty && tablePos && (0, $801jp.TextSelection).near(this.view.state.doc.resolve(tablePos)).from === selection.from) selectionBookmark = this.view.state.selection.getBookmark();
            if (this.dom) {
                this.dom.setAttribute('data-ssr-placeholder', `table-nodeview-${this.node.attrs.localId}`);
                this.dom.setAttribute('data-ssr-placeholder-replace', `table-nodeview-${this.node.attrs.localId}`);
            }
            // Remove the ProseMirror table DOM structure to avoid duplication, as it's replaced with the React table node.
            // In SSR the portal renders via `container.innerHTML = html` (portal/common.tsx), which detaches
            // `renderedDOM` from `dom` before this runs; require it to still be a child so `removeChild` doesn't throw
            // `NotFoundError` (which would make EditorSSRRenderer fall back to the position-blind schema toDOM and lose
            // nested detection).
            if (this.dom && this.renderedDOM && this.renderedDOM.parentNode === this.dom) this.dom.removeChild(this.renderedDOM);
            // Move the table from the ProseMirror table structure into the React rendered table node.
            node.appendChild(this.table);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    var _TextSelection$findFr;
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    /**
           * This handles a very specific case only -> insertion by the user of a new
           * table
           * Since it's behind a RAF it's possible the user has clicked elsewhere or
           * it affects collaborative users (which selection changes shouldn't ever)
           *
           * This ensures that the selectionBookmark *before* is inside the first
           * position in the table and that after it is the text position directly
           * before the table
           * Ideally we want to remove this RAF entirely but that would require removing
           * the DOM manipulation and is a more complex effort
           */ if (!resolvedSelection.eq(this.view.state.selection) && resolvedSelection.empty && // Ensure that the *next* valid text position matches the first position
                    // in the table
                    (_TextSelection$findFr = (0, $801jp.TextSelection).findFrom(this.view.state.doc.resolve(this.view.state.selection.from + 1), 1, true)) !== null && _TextSelection$findFr !== void 0 && _TextSelection$findFr.eq(resolvedSelection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'TableNodeView:_handleTableRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    setDomAttrs(node) {
        var _this$reactComponentP6, _this$reactComponentP7, _this$reactComponentP8, _this$options3, _this$options4;
        if (!this.table) return; // width / attribute application to actual table will happen later when table is set
        const attrs = $a85f1813eea3eaa1$var$tableAttributes(node);
        // render table with content-mode attribute which removes all width constraints from the table
        // fire exposure here
        if ((0, $bzCw0.isTableInContentMode)({
            tableNode: node,
            isSupported: (0, $h3r8b.isContentModeSupported)({
                allowColumnResizing: !!this.reactComponentProps.allowColumnResizing,
                allowTableResizing: !!this.reactComponentProps.allowTableResizing,
                isFullPageEditor: !((_this$reactComponentP6 = this.reactComponentProps.options) !== null && _this$reactComponentP6 !== void 0 && _this$reactComponentP6.isCommentEditor) && !((_this$reactComponentP7 = this.reactComponentProps.options) !== null && _this$reactComponentP7 !== void 0 && _this$reactComponentP7.isChromelessEditor)
            }),
            isTableNested: (0, $4WYVI.isTableNested)(this.view.state, this.getPos())
        })) attrs['data-initial-width-mode'] = 'content';
        Object.keys(attrs).forEach((attr)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.table.setAttribute(attr, attrs[attr]);
        });
        const isTableFixedColumnWidthsOptionEnabled = ((_this$reactComponentP8 = this.reactComponentProps) === null || _this$reactComponentP8 === void 0 ? void 0 : _this$reactComponentP8.allowFixedColumnWidthOption) || false;
        // Preserve Table Width cannot have inline width set on the table
        if (!((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.isTableScalingEnabled) || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled && node.attrs.displayMode === 'fixed') {
            var _tableWidthPluginKey$;
            // handle inline style when table been resized
            const tableInlineWidth = $a85f1813eea3eaa1$var$getInlineWidth(node, this.reactComponentProps.options, this.view.state, this.getPos(), this.reactComponentProps.allowTableResizing);
            const isTableResizing = (_tableWidthPluginKey$ = (0, $8aCba.pluginKey).getState(this.view.state)) === null || _tableWidthPluginKey$ === void 0 ? void 0 : _tableWidthPluginKey$.resizing;
            if (!isTableResizing && tableInlineWidth) $a85f1813eea3eaa1$var$handleInlineTableWidth(this.table, tableInlineWidth);
        }
    }
    updateContentVisibility() {
        var _this$reactComponentP9, _limitedMode$sharedSt;
        if (this.isNestedTable || !this.table) return;
        // Read limited mode from the nodeView's own `this.view.state` via the plugin key exposed on
        // the (already-typed) shared state, NOT `currentState().enabled`: during initial EditorView
        // construction the injection API's editor state is undefined, so `.enabled` reads a stale false.
        //
        // Reads the plugin's derived `enabled`, so this covers every reason limited mode can be on.
        const limitedMode = (_this$reactComponentP9 = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP9 === void 0 ? void 0 : _this$reactComponentP9.limitedMode;
        const enabled = Boolean(limitedMode === null || limitedMode === void 0 || (_limitedMode$sharedSt = limitedMode.sharedState.currentState()) === null || _limitedMode$sharedSt === void 0 || (_limitedMode$sharedSt = _limitedMode$sharedSt.limitedModePluginKey) === null || _limitedMode$sharedSt === void 0 || (_limitedMode$sharedSt = _limitedMode$sharedSt.getState(this.view.state)) === null || _limitedMode$sharedSt === void 0 ? void 0 : _limitedMode$sharedSt.enabled);
        const applied = (0, $i5qTg.applyContentVisibility)(this.table, enabled, ()=>({
                // The `<table>` is content-sized (`display: table`), so it needs an explicit intrinsic
                // width or it collapses to 0 wide while contained. `getTableContainerWidth` covers
                // wide/full-width tables; explicit inline widths (resizable tables) simply override it.
                width: (0, $k5JVX.getTableContainerWidth)(this.node),
                height: (0, $i5qTg.estimateTableIntrinsicHeight)(this.node)
            }));
        // Marker for the shared table CSS: when content-visibility (→ contain: paint) is actually
        // applied, it pulls the `::after` outer-border overlay from `inset: -0.5px` to `inset: 0` so
        // paint clipping doesn't shave the border. Keyed off the real applied style so it stays in
        // sync with the gate inside applyContentVisibility.
        this.table.toggleAttribute('data-content-visibility', applied);
    }
    update(node, decorations, innerDecorations, validUpdate) {
        const didUpdate = super.update(node, decorations, innerDecorations, validUpdate);
        // Keep the rounded-corner edge attrs in sync with structural changes (rows/columns
        // added, removed, merged, or reordered via drag-and-drop) that the cells themselves
        // can miss.
        if (didUpdate) this.updateContentVisibility();
        if (didUpdate && (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
            var _this$roundedTableEdg;
            (_this$roundedTableEdg = this.roundedTableEdges) === null || _this$roundedTableEdg === void 0 || _this$roundedTableEdg.handleUpdate(node);
        }
        return didUpdate;
    }
    render(props, forwardRef) {
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iVMHB.TableSSRReactContextsProvider), {
            intl: this.intl,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6GRh1.TableComponentWithSharedState), {
                forwardRef: forwardRef,
                getNode: this.getNode,
                view: props.view,
                options: props.options,
                eventDispatcher: props.eventDispatcher,
                api: props.pluginInjectionApi,
                allowColumnResizing: props.allowColumnResizing,
                allowTableAlignment: props.allowTableAlignment,
                allowTableResizing: props.allowTableResizing,
                allowControls: props.allowControls,
                getPos: props.getPos,
                getEditorFeatureFlags: props.getEditorFeatureFlags,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                allowFixedColumnWidthOption: props.allowFixedColumnWidthOption
            })
        });
    }
    viewShouldUpdate(nextNode) {
        const { hoveredRows: hoveredRows } = (0, $4GJqd.getPluginState)(this.view.state);
        const hoveredRowsChanged = !!(hoveredRows !== null && hoveredRows !== void 0 && hoveredRows.length) !== this.hasHoveredRows;
        if (nextNode.attrs.isNumberColumnEnabled && hoveredRowsChanged) {
            this.hasHoveredRows = !!(hoveredRows !== null && hoveredRows !== void 0 && hoveredRows.length);
            return true;
        }
        const node = this.getNode();
        if (typeof node.attrs !== typeof nextNode.attrs) return true;
        if ((0, $4WYVI.tablesHaveDifferentColumnWidths)(node, nextNode)) return true;
        const attrKeys = Object.keys(node.attrs);
        const nextAttrKeys = Object.keys(nextNode.attrs);
        if (attrKeys.length !== nextAttrKeys.length) return true;
        const tableMap = (0, $dpooP.TableMap).get(node);
        const nextTableMap = (0, $dpooP.TableMap).get(nextNode);
        if (tableMap.width !== nextTableMap.width) return true;
        return attrKeys.some((key)=>{
            return node.attrs[key] !== nextNode.attrs[key];
        });
    }
    ignoreMutation(mutation) {
        const { type: type, target: { nodeName: nodeName, firstChild: firstChild } } = mutation;
        if (type === 'selection' && (nodeName === null || nodeName === void 0 ? void 0 : nodeName.toUpperCase()) === 'DIV' && (firstChild === null || firstChild === void 0 ? void 0 : firstChild.nodeName.toUpperCase()) === 'TABLE') return false;
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        var _this$eventDispatcher;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) {
            var _this$roundedTableEdg2;
            (_this$roundedTableEdg2 = this.roundedTableEdges) === null || _this$roundedTableEdg2 === void 0 || _this$roundedTableEdg2.destroy();
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        (_this$eventDispatcher = this.eventDispatcher) === null || _this$eventDispatcher === void 0 || _this$eventDispatcher.emit('TABLE_DELETED', this.node);
        super.destroy();
    }
}
const $a85f1813eea3eaa1$export$f0e1dd383a612bf9 = (node, view, getPos, portalProviderAPI, eventDispatcher, getEditorContainerWidth, getEditorFeatureFlags, dispatchAnalyticsEvent, pluginInjectionApi, isCommentEditor, isChromelessEditor, allowFixedColumnWidthOption, intl)=>{
    var _pluginInjectionApi$t;
    const { pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled // same as options.isTableScalingEnabled
     } = (0, $4GJqd.getPluginState)(view.state);
    // Use shared state for isFullWidthModeEnabled and wasFullWidthModeEnabled for most up-to-date values
    const tableState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$t = pluginInjectionApi.table) === null || _pluginInjectionApi$t === void 0 ? void 0 : _pluginInjectionApi$t.sharedState.currentState();
    const { allowColumnResizing: allowColumnResizing, allowControls: allowControls, allowTableResizing: allowTableResizing, allowTableAlignment: allowTableAlignment } = (0, $d9DFt.pluginConfig)(pluginConfig);
    const isTableFixedColumnWidthsOptionEnabled = allowFixedColumnWidthOption || false;
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
    return new $a85f1813eea3eaa1$export$2e2bcd8739ae039({
        node: node,
        view: view,
        allowColumnResizing: allowColumnResizing,
        allowTableResizing: allowTableResizing,
        allowTableAlignment: allowTableAlignment,
        allowControls: allowControls,
        portalProviderAPI: portalProviderAPI,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        options: {
            isFullWidthModeEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.wasFullWidthModeEnabled,
            isTableScalingEnabled: isTableScalingEnabled,
            isCommentEditor: // same as options.isTableScalingEnabled
            isCommentEditor,
            isChromelessEditor: isChromelessEditor,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent
        },
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        intl: intl
    }).init();
};

});
parcelRegister("dZKRP", function(module, exports) {
$parcel$export(module.exports, "getRoundedTableCellEdgeState", () => $48630c3d8d2362c9$export$614887001658b490);
$parcel$export(module.exports, "RoundedTableEdges", () => $48630c3d8d2362c9$export$45ddc54457529def);

var $dpooP = parcelRequire("dpooP");
const $48630c3d8d2362c9$var$roundedTableCellEdgeStateCache = new WeakMap();
const $48630c3d8d2362c9$var$addEdgeState = (edgeStates, offset, edge)=>{
    let edgeState = edgeStates.get(offset);
    if (!edgeState) {
        edgeState = {
            reachesTop: false,
            reachesBottom: false,
            reachesLeft: false,
            reachesRight: false
        };
        edgeStates.set(offset, edgeState);
    }
    edgeState[edge] = true;
};
const $48630c3d8d2362c9$export$614887001658b490 = (tableNode, cellOffset)=>{
    let edgeStates = $48630c3d8d2362c9$var$roundedTableCellEdgeStateCache.get(tableNode);
    if (!edgeStates) {
        const { width: width, height: height, map: map } = (0, $dpooP.TableMap).get(tableNode);
        edgeStates = new Map();
        for(let column = 0; column < width; column++){
            $48630c3d8d2362c9$var$addEdgeState(edgeStates, map[column], 'reachesTop');
            $48630c3d8d2362c9$var$addEdgeState(edgeStates, map[(height - 1) * width + column], 'reachesBottom');
        }
        for(let row = 0; row < height; row++){
            $48630c3d8d2362c9$var$addEdgeState(edgeStates, map[row * width], 'reachesLeft');
            $48630c3d8d2362c9$var$addEdgeState(edgeStates, map[row * width + width - 1], 'reachesRight');
        }
        $48630c3d8d2362c9$var$roundedTableCellEdgeStateCache.set(tableNode, edgeStates);
    }
    return edgeStates.get(cellOffset);
};
const $48630c3d8d2362c9$var$setDataAttr = (cell, attr, value)=>{
    const hasAttr = cell.hasAttribute(attr);
    if (value && !hasAttr) cell.setAttribute(attr, 'true');
    else if (!value && hasAttr) cell.removeAttribute(attr);
};
/**
 * Refreshes the `data-reaches-{top,bottom,left,right}` attributes used by CSS to round
 * the table's corner cells (including merged cells that span to an edge).
 *
 * Edge membership is derived directly from the table map's border rows/columns: a cell
 * reaches an edge iff its offset appears in the corresponding border slice (this naturally
 * accounts for rowspan/colspan cells, whose offset is repeated across every grid slot they
 * cover). This is O(cells) overall, versus O(cells^2) when calling findCell per cell.
 */ const $48630c3d8d2362c9$var$refreshRoundedTableEdgeAttrs = (table, tableNode)=>{
    try {
        const tableMap = (0, $dpooP.TableMap).get(tableNode);
        const { width: width, height: height, map: map } = tableMap;
        const cells = Array.from(table.rows).flatMap((row)=>Array.from(row.cells));
        const cellOffsets = Array.from(new Set(map));
        const topOffsets = new Set();
        const bottomOffsets = new Set();
        const leftOffsets = new Set();
        const rightOffsets = new Set();
        for(let col = 0; col < width; col++){
            topOffsets.add(map[col]);
            bottomOffsets.add(map[(height - 1) * width + col]);
        }
        for(let row = 0; row < height; row++){
            leftOffsets.add(map[row * width]);
            rightOffsets.add(map[row * width + width - 1]);
        }
        cellOffsets.forEach((cellOffset, cellIndex)=>{
            const cell = cells[cellIndex];
            if (!cell) return;
            $48630c3d8d2362c9$var$setDataAttr(cell, 'data-reaches-top', topOffsets.has(cellOffset));
            $48630c3d8d2362c9$var$setDataAttr(cell, 'data-reaches-bottom', bottomOffsets.has(cellOffset));
            $48630c3d8d2362c9$var$setDataAttr(cell, 'data-reaches-left', leftOffsets.has(cellOffset));
            $48630c3d8d2362c9$var$setDataAttr(cell, 'data-reaches-right', rightOffsets.has(cellOffset));
        });
    } catch  {
    // Table structure can be transient while ProseMirror normalises transactions.
    // Keep existing edge attrs if the current shape cannot be mapped safely.
    }
};
/**
 * Builds a lightweight signature of the cells sitting on the table's four borders, using
 * their immutable ProseMirror node references. Top and bottom rows are visited in full;
 * interior rows contribute only their first and last cells, making this O(rows + columns).
 */ const $48630c3d8d2362c9$var$getPerimeterTableEdgeSignature = (tableNode)=>{
    const edgeCells = [];
    const lastRowIndex = tableNode.childCount - 1;
    tableNode.forEach((row, _rowOffset, rowIndex)=>{
        if (rowIndex === 0 || rowIndex === lastRowIndex) {
            row.forEach((cell)=>{
                edgeCells.push(cell);
            });
            return;
        }
        if (row.firstChild) edgeCells.push(row.firstChild);
        if (row.childCount > 1 && row.lastChild) edgeCells.push(row.lastChild);
    });
    return edgeCells;
};
const $48630c3d8d2362c9$var$tableEdgeSignaturesDiffer = (prev, next)=>{
    if (!prev || prev.length !== next.length) return true;
    for(let i = 0; i < prev.length; i++){
        if (prev[i] !== next[i]) return true;
    }
    return false;
};
class $48630c3d8d2362c9$export$45ddc54457529def {
    constructor(getTableElement, node){
        this.getTableElement = getTableElement;
        // Baseline the edge signature so the first content edit doesn't trigger a spurious
        // refresh — the cells set their own edge attrs on construction.
        this.prevSignature = $48630c3d8d2362c9$var$getPerimeterTableEdgeSignature(node);
    }
    /**
   * Call from the node view's `update()` after `super.update()`. When the border signature
   * changes it schedules a refresh of the edge attrs on the next animation frame.
   */ handleUpdate(node) {
        const nextSignature = $48630c3d8d2362c9$var$getPerimeterTableEdgeSignature(node);
        const edgesChanged = $48630c3d8d2362c9$var$tableEdgeSignaturesDiffer(this.prevSignature, nextSignature);
        this.prevSignature = nextSignature;
        if (edgesChanged) this.scheduleRefresh(node);
    }
    /** Call from the node view's `destroy()` to cancel any pending refresh. */ destroy() {
        if (this.refreshHandle !== undefined) {
            cancelAnimationFrame(this.refreshHandle);
            this.refreshHandle = undefined;
        }
    }
    // The refresh runs on the next animation frame because ReactNodeView.update() schedules the
    // table's React render via the portal provider. If we read `table.rows` synchronously, we'd
    // still see the previous DOM.
    scheduleRefresh(node) {
        if (this.refreshHandle !== undefined) cancelAnimationFrame(this.refreshHandle);
        this.refreshHandle = requestAnimationFrame(()=>{
            this.refreshHandle = undefined;
            const table = this.getTableElement();
            if (table instanceof HTMLTableElement) $48630c3d8d2362c9$var$refreshRoundedTableEdgeAttrs(table, node);
        });
    }
}

});

parcelRegister("6GRh1", function(module, exports) {
$parcel$export(module.exports, "TableComponentWithSharedState", () => $f4bc0fbe1b25d53b$export$b6d58ec6836e4dcf);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9oAqi = parcelRequire("9oAqi");

var $5n2u9 = parcelRequire("5n2u9");

var $bcN2K = parcelRequire("bcN2K");

var $dRmYC = parcelRequire("dRmYC");
const $f4bc0fbe1b25d53b$var$getSelectionWithinTable = (selection, tableNode)=>{
    const found = selection && (0, $5n2u9.findTable)(selection);
    return found && found.node === tableNode ? selection : undefined;
};
const $f4bc0fbe1b25d53b$export$b6d58ec6836e4dcf = ({ view: view, options: options, getNode: getNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, api: api, getEditorFeatureFlags: getEditorFeatureFlags, eventDispatcher: eventDispatcher, allowColumnResizing: allowColumnResizing, allowControls: allowControls, getPos: getPos, forwardRef: forwardRef, allowTableAlignment: allowTableAlignment, allowTableResizing: allowTableResizing, allowFixedColumnWidthOption: allowFixedColumnWidthOption })=>{
    const { isTableResizing: isTableResizing, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isResizing: isResizing, isInDanger: isInDanger, hoveredCell: hoveredCell, hoveredRows: hoveredRows, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger, interaction: interaction, isFullscreen: isFullscreen, lineLength: lineLength, mode: mode, selection: selection, width: width, limitedModeEnabled: limitedModeEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'table',
        'width',
        'media',
        'selection',
        'editorViewMode',
        'interaction',
        'limitedMode'
    ], (states)=>{
        var _states$tableState, _states$tableState2, _states$tableState3, _states$tableState4, _states$tableState5, _states$tableState6, _states$tableState7, _states$tableState8, _states$tableState9, _states$tableState0, _states$tableState1, _states$mediaState, _states$selectionStat, _states$selectionStat2, _states$editorViewMod, _states$widthState, _states$widthState2, _states$interactionSt, _states$limitedModeSt;
        return {
            // tableState
            isTableResizing: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.isTableResizing,
            isHeaderColumnEnabled: (_states$tableState2 = states.tableState) === null || _states$tableState2 === void 0 ? void 0 : _states$tableState2.isHeaderColumnEnabled,
            isHeaderRowEnabled: (_states$tableState3 = states.tableState) === null || _states$tableState3 === void 0 ? void 0 : _states$tableState3.isHeaderRowEnabled,
            ordering: (_states$tableState4 = states.tableState) === null || _states$tableState4 === void 0 ? void 0 : _states$tableState4.ordering,
            isResizing: (_states$tableState5 = states.tableState) === null || _states$tableState5 === void 0 ? void 0 : _states$tableState5.isResizing,
            isInDanger: (_states$tableState6 = states.tableState) === null || _states$tableState6 === void 0 ? void 0 : _states$tableState6.isInDanger,
            hoveredCell: (_states$tableState7 = states.tableState) === null || _states$tableState7 === void 0 ? void 0 : _states$tableState7.hoveredCell,
            hoveredRows: (_states$tableState8 = states.tableState) === null || _states$tableState8 === void 0 ? void 0 : _states$tableState8.hoveredRows,
            isTableHovered: (_states$tableState9 = states.tableState) === null || _states$tableState9 === void 0 ? void 0 : _states$tableState9.isTableHovered,
            isWholeTableInDanger: (_states$tableState0 = states.tableState) === null || _states$tableState0 === void 0 ? void 0 : _states$tableState0.isWholeTableInDanger,
            // Required so that table control re-renders
            targetCellPosition: (_states$tableState1 = states.tableState) === null || _states$tableState1 === void 0 ? void 0 : _states$tableState1.targetCellPosition,
            // mediaState
            isFullscreen: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.isFullscreen,
            // selectionState
            selection: (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? $f4bc0fbe1b25d53b$var$getSelectionWithinTable((_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection, getNode()) : (_states$selectionStat2 = states.selectionState) === null || _states$selectionStat2 === void 0 ? void 0 : _states$selectionStat2.selection,
            // editorViewModeState
            mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode,
            // widthState
            width: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width,
            lineLength: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.lineLength,
            // interactionState
            interaction: (_states$interactionSt = states.interactionState) === null || _states$interactionSt === void 0 ? void 0 : _states$interactionSt.interactionState,
            // limitedModeState — selected (rather than read once) so sticky headers stop when limited
            // mode latches mid-session, not only when it was already on as the table mounted.
            limitedModeEnabled: (_states$limitedModeSt = states.limitedModeState) === null || _states$limitedModeSt === void 0 ? void 0 : _states$limitedModeSt.enabled
        };
    });
    const isLivePageViewMode = mode === 'view';
    /**
   *  ED-19810
   *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
   *  directly to confluence since this bug is now in production.
   */ let currentTablePos;
    try {
        currentTablePos = getPos ? getPos() : undefined;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        currentTablePos = undefined;
    }
    const selectedTable = (0, $5n2u9.findTable)(view.state.selection);
    const tablePos = selectedTable && selectedTable.start - 1;
    const tableActive = typeof currentTablePos === 'number' && typeof tablePos === 'number' && currentTablePos === tablePos && !isTableResizing;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dRmYC.default), {
        view: view,
        allowColumnResizing: allowColumnResizing,
        eventDispatcher: eventDispatcher,
        getPos: getPos,
        isMediaFullscreen: isFullscreen,
        options: options,
        allowControls: allowControls,
        isDragAndDropEnabled: !isLivePageViewMode,
        isHeaderRowEnabled: isHeaderRowEnabled ?? false,
        isHeaderColumnEnabled: isHeaderColumnEnabled ?? false,
        isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
        allowTableAlignment: allowTableAlignment,
        allowTableResizing: allowTableResizing,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        tableActive: tableActive && !isLivePageViewMode && interaction !== 'hasNotHadInteraction',
        ordering: ordering,
        isResizing: isResizing,
        getNode: getNode,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        containerWidth: {
            width: width ?? 0,
            lineLength: lineLength
        },
        contentDOM: forwardRef,
        getEditorFeatureFlags: getEditorFeatureFlags,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: api,
        isInDanger: !!isInDanger,
        hoveredRows: hoveredRows,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        isWholeTableInDanger: isWholeTableInDanger,
        selection: selection,
        limitedMode: limitedModeEnabled
    });
};

});
parcelRegister("dRmYC", function(module, exports) {
$parcel$export(module.exports, "default", () => $803c4b07a11d00db$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jyPR0 = parcelRequire("jyPR0");

var $PIUl3 = parcelRequire("PIUl3");

var $fcCIH = parcelRequire("fcCIH");

var $dqFZv = parcelRequire("dqFZv");

var $7OckW = parcelRequire("7OckW");

var $5DGsr = parcelRequire("5DGsr");

var $7cwGc = parcelRequire("7cwGc");

var $k5JVX = parcelRequire("k5JVX");

var $58I5S = parcelRequire("58I5S");

var $bzCw0 = parcelRequire("bzCw0");

var $1rALr = parcelRequire("1rALr");

var $014x6 = parcelRequire("014x6");

var $kD3Xq = parcelRequire("kD3Xq");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $gXHCV = parcelRequire("gXHCV");

var $aEmSo = parcelRequire("aEmSo");

var $8L6TV = parcelRequire("8L6TV");
var $EwLhB = parcelRequire("EwLhB");

var $2RRfm = parcelRequire("2RRfm");

var $fkY0k = parcelRequire("fkY0k");

var $AGA3t = parcelRequire("AGA3t");

var $7Xzpg = parcelRequire("7Xzpg");

var $eyG1M = parcelRequire("eyG1M");

var $7JtQD = parcelRequire("7JtQD");

var $7SttP = parcelRequire("7SttP");

var $26jxM = parcelRequire("26jxM");

var $9xQxI = parcelRequire("9xQxI");

var $4WYVI = parcelRequire("4WYVI");

var $jo7Pl = parcelRequire("jo7Pl");

var $h3r8b = parcelRequire("h3r8b");

var $YREXK = parcelRequire("YREXK");

var $x2FuQ = parcelRequire("x2FuQ");

var $jP7eZ = parcelRequire("jP7eZ");

var $lrMIT = parcelRequire("lrMIT");

var $3UDgX = parcelRequire("3UDgX");

var $iPXmN = parcelRequire("iPXmN");

var $9ALWB = parcelRequire("9ALWB");
// Prevent unnecessary parentWidth updates when table is nested inside of a node that is nested itself.
const $803c4b07a11d00db$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD = 2;
const $803c4b07a11d00db$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD = 20;
const $803c4b07a11d00db$var$MEASURED_COLUMN_WIDTH = /^[\d.]+px$/u;
// eslint-disable-next-line @repo/internal/react/no-class-components
class $803c4b07a11d00db$var$TableComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static #_ = this.displayName = 'TableComponent';
    constructor(props){
        super(props), this.state = {
            parentWidth: undefined,
            tableWrapperWidth: undefined,
            tableWrapperHeight: undefined,
            windowResized: false
        }, this.handleMouseOut = (event)=>{
            if (!(0, $x2FuQ.isTableInFocus)(this.props.view)) return false;
            return (0, $x2FuQ.handleMouseOut)(this.props.view, event);
        }, this.handleMouseOver = (event)=>{
            if (!(0, $x2FuQ.isTableInFocus)(this.props.view)) return false;
            return (0, $x2FuQ.withCellTracking)((0, $x2FuQ.handleMouseOver))(this.props.view, event);
        }, this.handleMouseEnter = ()=>{
            const node = this.props.getNode();
            const pos = this.props.getPos();
            const tr = this.props.view.state.tr;
            const tableId = node.attrs.localId;
            tr.setMeta('mouseEnterTable', [
                tableId,
                node,
                pos
            ]);
            this.props.view.dispatch(tr);
        }, this.lastSetTableRef = null, this.setWrapperRef = (elem)=>{
            this.wrapper = elem;
            if (!elem) return;
            this.props.contentDOM(elem);
            const tableElement = elem.querySelector('table');
            if (tableElement !== this.table) {
                this.table = tableElement;
                this.observeTable(this.table);
            }
        }, this.onStickyState = (state)=>{
            const pos = this.props.getPos();
            if (!(0, $1rALr.isValidPosition)(pos, this.props.view.state)) return;
            const stickyHeader = (0, $AGA3t.findStickyHeaderForTable)(state, pos);
            if (stickyHeader !== this.state.stickyHeader) this.setState({
                stickyHeader: stickyHeader
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.prevTableState = null, this.handleScroll = (event)=>{
            if (!this.wrapper || event.target !== this.wrapper) return;
            if (this.stickyScrollbar) this.stickyScrollbar.scrollLeft(this.wrapper.scrollLeft);
            if (this.table) {
                // sync sticky header row to table scroll
                const headers = this.table.querySelectorAll('tr[data-header-row]');
                for(let i = 0; i < headers.length; i++){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const header = headers[i];
                    header.scrollLeft = this.wrapper.scrollLeft;
                    header.style.marginRight = '2px';
                }
                if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) (0, $7JtQD.syncStickyCornerMasks)(this.table);
            }
            // force update to for table controls to re-align
            this.forceUpdate();
        }, this.handleTableResizing = ()=>{
            const { getNode: getNode, containerWidth: containerWidth, options: options, allowTableResizing: allowTableResizing } = this.props;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const prevNode = this.node;
            const node = getNode();
            const prevAttrs = prevNode.attrs;
            const tablePos = this.props.getPos();
            const isNested = (0, $4WYVI.isTableNested)(this.props.view.state, tablePos);
            let parentWidth = this.getParentNodeWidth();
            const useMeasuredWidthForBodiedSyncBlock = isNested && typeof tablePos === 'number' && (0, $4WYVI.isTableNestedUnderBodiedSyncBlock)(this.props.view.state, tablePos);
            if (useMeasuredWidthForBodiedSyncBlock) {
                // Prefer the live DOM measurement (`clientWidth`) over the ResizeObserver-cached
                // value (`wrapperWidth`) because clientWidth is synchronous and more up-to-date
                // at the time this handler runs. Fall back to `wrapperWidth` if the wrapper ref
                // is not yet available.
                // The clientWidth > 0 since DOM clientWidth is 0 before layout
                // The > 1 guard for wrapperWidth was intentional to filter out the degenerate value of 1 that ResizeObserver reports during element unmounting.
                let measuredWrapperWidth;
                if (this.wrapper && this.wrapper.clientWidth > 0) measuredWrapperWidth = this.wrapper.clientWidth;
                else if (this.wrapperWidth && this.wrapperWidth > 1) measuredWrapperWidth = this.wrapperWidth;
                if (measuredWrapperWidth !== undefined) // Override the default parentWidth so that scaleTable uses the real
                // available width inside the sync-block rather than the full editor width.
                parentWidth = measuredWrapperWidth;
            }
            if (!useMeasuredWidthForBodiedSyncBlock && isNested && (0, $4WYVI.isTableNestedInMoreThanOneNode)(this.props.view.state, tablePos)) {
                const resizeObsWrapperWidth = this.wrapperWidth || 0;
                const wrapperWidthDiffBetweenRerenders = Math.abs(resizeObsWrapperWidth - (this.state.parentWidth || 0));
                const isOusideOfThreshold = wrapperWidthDiffBetweenRerenders <= $803c4b07a11d00db$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLD || wrapperWidthDiffBetweenRerenders > $803c4b07a11d00db$var$NESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MAX_THRESHOLD;
                // 1. Check isOusideOfThreshold is added to prevent undersired state update.
                // When table is nested in the extenstion and the table column is being resized,
                // space available within extension can change and cause undesirable state update.
                // MIN_THRESNESTED_TABLE_IN_NESTED_PARENT_WIDTH_DIFF_MIN_THRESHOLDHOLD value is required
                // as the resizeObsWrapperWidth can differ between page reloads by 2px.
                // 2. Check resizeObsWrapperWidth > 1 is added to prevent parentWidth update when table unmounts.
                // When a is nested table in a nested expand and the expand collabses, the table unmounts and
                // resizeObsWrapperWidth becomes 1.
                parentWidth = isOusideOfThreshold && resizeObsWrapperWidth > 1 ? resizeObsWrapperWidth : this.state.parentWidth;
            }
            const parentWidthChanged = parentWidth && parentWidth !== this.state.parentWidth;
            const layoutSize = this.tableNodeLayoutSize(node, containerWidth.width, options);
            const hasNumberedColumnChanged = prevAttrs.isNumberColumnEnabled !== node.attrs.isNumberColumnEnabled;
            const noOfColumnsChanged = (0, $4WYVI.tablesHaveDifferentNoOfColumns)(node, prevNode);
            if (// We need to react if our parent changes
            // Scales the cols widths relative to the new parent width.
            parentWidthChanged || // Enabling / disabling this feature reduces or adds size to the table.
            hasNumberedColumnChanged || // This last check is also to cater for dynamic text sizing changing the 'default' layout width
            // Usually happens on window resize.
            layoutSize !== this.layoutSize || noOfColumnsChanged) {
                const shouldScaleTable = (!allowTableResizing || allowTableResizing && isNested) && !hasNumberedColumnChanged && !noOfColumnsChanged;
                // If column has been inserted/deleted avoid multi dispatch
                if (shouldScaleTable) this.scaleTable({
                    parentWidth: parentWidth
                }, hasNumberedColumnChanged);
                // only when table resizing is enabled and toggle numbered column to run scaleTable
                if (allowTableResizing && hasNumberedColumnChanged) {
                    if (!(0, $7Xzpg.hasTableBeenResized)(prevNode)) this.scaleTable({
                        parentWidth: node.attrs.width
                    }, true);
                }
                this.updateParentWidth(parentWidth);
            }
            this.node = node;
            this.containerWidth = containerWidth;
            this.layoutSize = layoutSize;
        }, // Function gets called when table is nested.
        this.scaleTable = (scaleOptions, isUserTriggered = false)=>{
            var _this$props$pluginInj2;
            if ((0, $dRkX9.fg)('platform_editor_table_view_mode_scaling_fix') && ((_this$props$pluginInj2 = this.props.pluginInjectionApi) === null || _this$props$pluginInj2 === void 0 || (_this$props$pluginInj2 = _this$props$pluginInj2.editorViewMode) === null || _this$props$pluginInj2 === void 0 || (_this$props$pluginInj2 = _this$props$pluginInj2.sharedState.currentState()) === null || _this$props$pluginInj2 === void 0 ? void 0 : _this$props$pluginInj2.mode) === 'view') return;
            const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth, options: options } = this.props;
            const node = getNode();
            const { state: state, dispatch: dispatch } = view;
            const pos = getPos();
            if (typeof pos !== 'number' || !(0, $1rALr.isValidPosition)(pos, state)) return;
            const domAtPos = view.domAtPos.bind(view);
            const { width: width } = containerWidth;
            this.scaleTableDebounced.cancel();
            const tr = (0, $9xQxI.scaleTable)(this.table, {
                ...scaleOptions,
                node: node,
                prevNode: this.node || node,
                start: pos + 1,
                containerWidth: width,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                previousContainerWidth: this.containerWidth.width || width,
                ...options
            }, domAtPos, this.props.pluginInjectionApi, false, // isTableScalingEnabled doesn't change the behavior of nested tables
            false // shouldUseIncreasedScalingPercent set to false for nested tables
            )(state.tr);
            if (!isUserTriggered) {
                (0, $7OckW.tintDirtyTransaction)(tr);
                // Avoid adding this transaction separately to the history as these are automatic updates
                // as a consequence of another action
                tr.setMeta('addToHistory', false);
            }
            dispatch(tr);
        }, this.handleAutoSize = ()=>{
            if (this.table) {
                const { view: view, getNode: getNode, getPos: getPos, containerWidth: containerWidth } = this.props;
                const node = getNode();
                const pos = getPos();
                if (!(0, $1rALr.isValidPosition)(pos, view.state)) return;
                (0, $8L6TV.autoSizeTable)(view, node, this.table, pos, {
                    containerWidth: containerWidth.width
                });
            }
        }, this.handleWindowResize = ()=>{
            const { getNode: getNode, containerWidth: containerWidth } = this.props;
            const node = getNode();
            const layoutSize = this.tableNodeLayoutSize(node);
            if (containerWidth.width > layoutSize) return;
            const parentWidth = this.getParentNodeWidth();
            this.scaleTableDebounced({
                parentWidth: parentWidth
            });
        }, // This is a new handler for window resize events that sets the windowResized state immediately
        // This is needed to update colgroup on window resize, to enforce the table scaling
        this.handleWindowResizeNew = ()=>{
            // Set resizing to true immediately
            if (!this.state.windowResized) this.setState({
                windowResized: true
            });
        }, this.getParentNodeWidth = ()=>{
            const { getPos: getPos, containerWidth: containerWidth, options: options, view: { state: state } } = this.props;
            const pos = getPos();
            if (!(0, $1rALr.isValidPosition)(pos, state)) return;
            const parentNodeWith = (0, $k5JVX.getParentNodeWidth)(pos, state, containerWidth, options && options.isFullWidthModeEnabled);
            return parentNodeWith;
        }, this.updateParentWidth = (width)=>{
            this.setState({
                parentWidth: width
            });
        }, this.tableNodeLayoutSize = (node, containerWidth, options)=>(0, $7SttP.getLayoutSize)(node.attrs.layout, containerWidth || this.props.containerWidth.width, options || this.props.options || {}), /**
   * Full-page tables scale with their container through CSS `calc()` column widths. Once a
   * colgroup has been rewritten with measured px widths (column resize, collab, column add or
   * delete, window resize), CSS can no longer scale it and the colgroup must be updated in JS.
   */ this.hasMeasuredColumnWidths = ()=>{
            var _this$table8;
            const firstColumn = (_this$table8 = this.table) === null || _this$table8 === void 0 ? void 0 : _this$table8.querySelector(':scope > colgroup > col');
            return !!firstColumn && $803c4b07a11d00db$var$MEASURED_COLUMN_WIDTH.test(firstColumn.style.width);
        }, this.shouldUpdateColgroup = (params)=>{
            var _this$props$options13, _this$props$options14;
            const { isWindowResized: isWindowResized, isWidthChanged: isWidthChanged, isTableWidthChanged: isTableWidthChanged, isColumnsDistributed: isColumnsDistributed, isTableResizedFullWidth: isTableResizedFullWidth, isTableDisplayModeChanged: isTableDisplayModeChanged, isNumberColumnChanged: isNumberColumnChanged, isNumberOfColumnsChanged: isNumberOfColumnsChanged, isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged } = params;
            const isFullPageEditor = !((_this$props$options13 = this.props.options) !== null && _this$props$options13 !== void 0 && _this$props$options13.isCommentEditor) && !((_this$props$options14 = this.props.options) !== null && _this$props$options14 !== void 0 && _this$props$options14.isChromelessEditor);
            if (isFullPageEditor) return !!isWindowResized || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
            return isWidthChanged || isTableWidthChanged || isColumnsDistributed || !!isTableResizedFullWidth || isTableDisplayModeChanged || isNumberColumnChanged || isNumberOfColumnsChanged || !!isFullWidthModeAndLineLengthChanged;
        }, this.scaleTableDebounced = (0, $PIUl3.default)(this.scaleTable), this.handleTableResizingDebounced = (0, $PIUl3.default)(this.handleTableResizing), this.handleScrollDebounced = (0, $PIUl3.default)(this.handleScroll), this.handleAutoSizeDebounced = (0, $PIUl3.default)(this.handleAutoSize), this.handleWindowResizeDebounced = (0, $PIUl3.default)(this.handleWindowResize), this.handleWindowResizeNewDebounced = (0, $PIUl3.default)(this.handleWindowResizeNew);
        const { options: options, containerWidth: containerWidth, getNode: getNode } = props;
        this.node = getNode();
        this.containerWidth = containerWidth;
        const tablePos = props.getPos();
        this.isNestedInTable = tablePos ? (0, $5DGsr.getParentOfTypeCount)(props.view.state.schema.nodes.table)(props.view.state.doc.resolve(tablePos)) > 0 : false;
        if (!this.updateColGroupFromFullWidthChange) this.updateColGroupFromFullWidthChange = (options === null || options === void 0 ? void 0 : options.isFullWidthModeEnabled) && !(options !== null && options !== void 0 && options.wasFullWidthModeEnabled);
        // store table size using previous full-width mode so can detect if it has changed.
        const isFullWidthModeEnabled = options ? options.wasFullWidthModeEnabled : false;
        this.layoutSize = this.tableNodeLayoutSize(this.node, containerWidth.width, {
            isFullWidthModeEnabled: isFullWidthModeEnabled
        });
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const entry of entries)this.setState((prev)=>{
                var _entry$contentRect, _entry$contentRect2;
                return (prev === null || prev === void 0 ? void 0 : prev.tableWrapperWidth) === ((_entry$contentRect = entry.contentRect) === null || _entry$contentRect === void 0 ? void 0 : _entry$contentRect.width) && (prev === null || prev === void 0 ? void 0 : prev.tableWrapperHeight) === ((_entry$contentRect2 = entry.contentRect) === null || _entry$contentRect2 === void 0 ? void 0 : _entry$contentRect2.height) ? prev : {
                    ...prev,
                    tableWrapperWidth: entry.contentRect.width,
                    tableWrapperHeight: entry.contentRect.height
                };
            });
        });
    }
    componentDidMount() {
        const { observe: observe } = (0, $7cwGc.nodeVisibilityManager)(this.props.view.dom);
        if (this.table) {
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.table,
                onFirstVisible: ()=>{
                    this.initialiseEventListenersAfterMount();
                    // force width calculation - missed resize event under firefox when
                    // table is nested within bodied extension
                    if (this.wrapper) {
                        var _this$wrapper;
                        this.wrapperWidth = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.clientWidth;
                    }
                }
            });
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeNewDebounced);
        }
        this.dispatchTableRefUpdate();
    }
    initialiseEventListenersAfterMount() {
        var _this$table, _this$table2, _this$table3;
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, isDragAndDropEnabled: isDragAndDropEnabled, getNode: getNode } = this.props;
        const browser = (0, $dqFZv.getBrowserInfo)();
        const isIE11 = browser.ie_version === 11;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this === null || this === void 0 || (_this$table = this.table) === null || _this$table === void 0 || _this$table.addEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this === null || this === void 0 || (_this$table2 = this.table) === null || _this$table2 === void 0 || _this$table2.addEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this === null || this === void 0 || (_this$table3 = this.table) === null || _this$table3 === void 0 || _this$table3.addEventListener('mouseover', this.handleMouseOver);
        if (this.wrapper) {
            this.wrapperReisizeObserver = new ResizeObserver((entries)=>{
                for (const entry of entries){
                    var _entry$contentRect3;
                    this.wrapperWidth = (_entry$contentRect3 = entry.contentRect) === null || _entry$contentRect3 === void 0 ? void 0 : _entry$contentRect3.width;
                }
            });
            this.wrapperReisizeObserver.observe(this.wrapper);
        }
        if (allowColumnResizing && this.wrapper && !isIE11) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.wrapper.addEventListener('scroll', this.handleScrollDebounced, {
                passive: true
            });
            if (this.table && !this.isNestedInTable) this.stickyScrollbar = new (0, $9ALWB.TableStickyScrollbar)(this.wrapper, this.props.view);
            if (isDragAndDropEnabled) this.dragAndDropCleanupFn = (0, $gXHCV.combine)(...(0, $2RRfm.autoScrollerFactory)({
                tableWrapper: this.wrapper,
                getNode: getNode
            }));
        }
        if (allowColumnResizing) {
            /**
       * We no longer use `containerWidth` as a variable to determine an update for table resizing (avoids unnecessary updates).
       * Instead we use the resize event to only trigger updates when necessary.
       */ if (!allowTableResizing) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', this.handleWindowResizeDebounced);
            this.handleTableResizingDebounced();
        }
        const currentStickyState = (0, $fkY0k.pluginKey).getState(this.props.view.state);
        if (currentStickyState) this.onStickyState(currentStickyState);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.on((0, $fkY0k.pluginKey).key, this.onStickyState);
    }
    componentWillUnmount() {
        var _this$resizeObserver, _this$wrapperReisizeO, _this$table4, _this$table5, _this$table6;
        const { allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, eventDispatcher: eventDispatcher, view: view, isInDanger: isInDanger, isDragAndDropEnabled: isDragAndDropEnabled } = this.props;
        const browser = (0, $dqFZv.getBrowserInfo)();
        const isIE11 = browser.ie_version === 11;
        if (this.wrapper && !isIE11) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.wrapper.removeEventListener('scroll', this.handleScrollDebounced);
        if (isDragAndDropEnabled && this.dragAndDropCleanupFn) this.dragAndDropCleanupFn();
        if (this.nodeVisibilityObserverCleanupFn) this.nodeVisibilityObserverCleanupFn();
        (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 || _this$resizeObserver.disconnect();
        (_this$wrapperReisizeO = this.wrapperReisizeObserver) === null || _this$wrapperReisizeO === void 0 || _this$wrapperReisizeO.disconnect();
        if (this.stickyScrollbar) this.stickyScrollbar.dispose();
        this.handleScrollDebounced.cancel();
        this.scaleTableDebounced.cancel();
        this.handleTableResizingDebounced.cancel();
        this.handleAutoSizeDebounced.cancel();
        if (!allowTableResizing) this.handleWindowResizeDebounced.cancel();
        this.handleWindowResizeNewDebounced.cancel();
        if (isInDanger) (0, $EwLhB.clearHoverSelection)()(view.state, view.dispatch);
        if (!allowTableResizing && allowColumnResizing) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeDebounced);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.handleWindowResizeNewDebounced);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this === null || this === void 0 || (_this$table4 = this.table) === null || _this$table4 === void 0 || _this$table4.removeEventListener('mouseenter', this.handleMouseEnter);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this === null || this === void 0 || (_this$table5 = this.table) === null || _this$table5 === void 0 || _this$table5.removeEventListener('mouseout', this.handleMouseOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this === null || this === void 0 || (_this$table6 = this.table) === null || _this$table6 === void 0 || _this$table6.removeEventListener('mouseover', this.handleMouseOver);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventDispatcher.off((0, $fkY0k.pluginKey).key, this.onStickyState);
        if (this.initialOverflowCaptureTimerId) clearTimeout(this.initialOverflowCaptureTimerId);
    }
    // Should be called only when table node width is reset to undefined in Comment Editor
    // Maybe replaced by handleColgroupUpdates as we implement new table's support in Comment Editor.
    removeInlineTableWidth() {
        const { isResizing: isResizing, getNode: getNode, view: view, getPos: getPos } = this.props;
        if (!this.table) return;
        const tableNode = getNode();
        const newTableWidth = tableNode.attrs.width;
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        if (!isResizing && newTableWidth === null) this.table.style.width = '';
    }
    handleColgroupUpdates(force = false) {
        var _this$containerWidth, _this$containerWidth2;
        const { getNode: getNode, containerWidth: containerWidth, isResizing: isResizing, view: view, getPos: getPos, options: options } = this.props;
        if (!this.table) return;
        // Remove any widths styles after resizing preview is completed
        this.table.style.width = '';
        const tableNode = getNode();
        const start = getPos() || 0;
        const depth = view.state.doc.resolve(start).depth;
        if (depth !== 0) return;
        let tableNodeWidth = (0, $k5JVX.getTableContainerWidth)(tableNode);
        const isTableResizedFullWidth = tableNodeWidth === 1800 && this.wasResizing && !isResizing;
        // Needed for undo / redo
        const isTableWidthChanged = tableNodeWidth !== this.tableNodeWidth;
        const tableRenderWidth = options !== null && options !== void 0 && options.isCommentEditor ? containerWidth.width - ((0, $eyG1M.TABLE_OFFSET_IN_COMMENT_EDITOR) + 1 // should be the same as this.table.parentElement?.clientWidth - 1, subtract 1 to avoid overflow
        ) : containerWidth.width - (0, $eyG1M.TABLE_EDITOR_MARGIN);
        tableNodeWidth = options !== null && options !== void 0 && options.isCommentEditor && !tableNode.attrs.width ? tableRenderWidth : tableNodeWidth;
        const isTableSquashed = tableRenderWidth < tableNodeWidth;
        const isNumberColumnChanged = tableNode.attrs.isNumberColumnEnabled !== this.node.attrs.isNumberColumnEnabled;
        const isNumberOfColumnsChanged = (0, $4WYVI.tablesHaveDifferentNoOfColumns)(tableNode, this.node);
        const { width: containerWidthValue, lineLength: containerLineLength } = containerWidth;
        const isLineLengthChanged = ((_this$containerWidth = this.containerWidth) === null || _this$containerWidth === void 0 ? void 0 : _this$containerWidth.lineLength) !== containerLineLength;
        const isFullWidthModeAndLineLengthChanged = this.updateColGroupFromFullWidthChange && isLineLengthChanged;
        const previousContainerWidth = (_this$containerWidth2 = this.containerWidth) === null || _this$containerWidth2 === void 0 ? void 0 : _this$containerWidth2.width;
        const isFullPageEditor = !(options !== null && options !== void 0 && options.isCommentEditor) && !(options !== null && options !== void 0 && options.isChromelessEditor);
        const isContainerResized = (0, $dRkX9.fg)('platform_editor_table_scale_on_container_resize') && isFullPageEditor && !!previousContainerWidth && previousContainerWidth !== containerWidthValue && this.hasMeasuredColumnWidths();
        const isWindowOrContainerResized = this.state.windowResized || isContainerResized;
        const maybeScale = isTableSquashed || isTableWidthChanged || isTableResizedFullWidth && !(options !== null && options !== void 0 && options.isCommentEditor) || isNumberColumnChanged || isNumberOfColumnsChanged || isWindowOrContainerResized;
        if (force || maybeScale || isFullWidthModeAndLineLengthChanged) {
            var _this$containerWidth3, _this$props, _this$props$options, _this$props$options2, _this$props$options3;
            const isWidthChanged = ((_this$containerWidth3 = this.containerWidth) === null || _this$containerWidth3 === void 0 ? void 0 : _this$containerWidth3.width) !== containerWidthValue;
            const wasTableResized = (0, $7Xzpg.hasTableBeenResized)(this.node);
            const isTableResized = (0, $7Xzpg.hasTableBeenResized)(tableNode);
            const isColumnsDistributed = wasTableResized && !isTableResized;
            const isTableDisplayModeChanged = this.node.attrs.displayMode !== tableNode.attrs.displayMode;
            const shouldUpdateColgroup = this.shouldUpdateColgroup({
                isWindowResized: isWindowOrContainerResized,
                isWidthChanged: isWidthChanged,
                isTableWidthChanged: isTableWidthChanged,
                isColumnsDistributed: isColumnsDistributed,
                isTableResizedFullWidth: isTableResizedFullWidth,
                isTableDisplayModeChanged: isTableDisplayModeChanged,
                isNumberColumnChanged: isNumberColumnChanged,
                isNumberOfColumnsChanged: isNumberOfColumnsChanged,
                isFullWidthModeAndLineLengthChanged: isFullWidthModeAndLineLengthChanged,
                isTableResized: isTableResized
            });
            const tableWithFixedColumnWidthsOption = ((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.allowFixedColumnWidthOption) || false;
            const isTableScalingWithFixedColumnWidthsOptionEnabled = !!((_this$props$options = this.props.options) !== null && _this$props$options !== void 0 && _this$props$options.isTableScalingEnabled) && tableWithFixedColumnWidthsOption;
            const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!((_this$props$options2 = this.props.options) !== null && _this$props$options2 !== void 0 && _this$props$options2.isTableScalingEnabled) && !!((_this$props$options3 = this.props.options) !== null && _this$props$options3 !== void 0 && _this$props$options3.isCommentEditor);
            if (force || !isResizing && shouldUpdateColgroup) {
                var _this$props$options4, _this$props$options5, _this$props$options6, _this$props$options7;
                const resizeState = (0, $26jxM.getResizeState)({
                    minWidth: (0, $eyG1M.COLUMN_MIN_WIDTH),
                    // When numbered column enabled, we need to subtract the width of the numbered column
                    maxSize: tableNode.attrs.isNumberColumnEnabled ? tableRenderWidth - (0, $014x6.akEditorTableNumberColumnWidth) : tableRenderWidth,
                    table: tableNode,
                    tableRef: this.table,
                    start: start,
                    domAtPos: view.domAtPos.bind(view),
                    isTableScalingEnabled: true,
                    shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
                    isCommentEditor: !!((_this$props$options4 = this.props.options) !== null && _this$props$options4 !== void 0 && _this$props$options4.isCommentEditor)
                });
                let shouldScaleOnColgroupUpdate = false;
                if ((_this$props$options5 = this.props.options) !== null && _this$props$options5 !== void 0 && _this$props$options5.isTableScalingEnabled && !tableWithFixedColumnWidthsOption) shouldScaleOnColgroupUpdate = true;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled && tableNode.attrs.displayMode !== 'fixed') shouldScaleOnColgroupUpdate = true;
                if ((_this$props$options6 = this.props.options) !== null && _this$props$options6 !== void 0 && _this$props$options6.isTableScalingEnabled && (_this$props$options7 = this.props.options) !== null && _this$props$options7 !== void 0 && _this$props$options7.isCommentEditor) shouldScaleOnColgroupUpdate = true;
                let scalePercent = 1;
                requestAnimationFrame(()=>{
                    var _this$props$options8, _this$props$options9;
                    // Scaling percent has to be calculated inside requestAnimationFrame, otherwise
                    // renderWidth calculated as `tableRef?.parentElement?.clientWidth`
                    // inside of getTableScalingPercent returns 0.
                    if (!((_this$props$options8 = this.props.options) !== null && _this$props$options8 !== void 0 && _this$props$options8.isCommentEditor) || (_this$props$options9 = this.props.options) !== null && _this$props$options9 !== void 0 && _this$props$options9.isCommentEditor && tableNode.attrs.width) scalePercent = (0, $7SttP.getTableScalingPercent)(tableNode, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, shouldUseIncreasedScalingPercent);
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    scalePercent = (0, $7SttP.getScalingPercentForTableWithoutWidth)(tableNode, this.table);
                    // Request animation frame required for Firefox
                    (0, $26jxM.updateColgroup)(resizeState, // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.table, tableNode, shouldScaleOnColgroupUpdate, scalePercent);
                });
            }
        }
        if (isFullWidthModeAndLineLengthChanged) this.updateColGroupFromFullWidthChange = false;
        this.tableNodeWidth = tableNodeWidth;
        this.wasResizing = isResizing;
        this.containerWidth = containerWidth;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    componentDidUpdate(_, prevState) {
        var _this$props$options0, _this$props$options1;
        const { getNode: getNode, isMediaFullscreen: isMediaFullscreen, allowColumnResizing: allowColumnResizing, allowTableResizing: allowTableResizing, isResizing: isResizing, options: options, isTableScalingEnabled: isTableScalingEnabled, getPos: // we could use options.isTableScalingEnabled here
        getPos, allowFixedColumnWidthOption: allowFixedColumnWidthOption } = this.props;
        let shouldScale = false;
        let shouldHandleColgroupUpdates = false;
        const tableWithFixedColumnWidthsOption = allowFixedColumnWidthOption || false;
        if (isTableScalingEnabled && !tableWithFixedColumnWidthsOption) {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        const isTableScalingWithFixedColumnWidthsOptionEnabled = !!isTableScalingEnabled && tableWithFixedColumnWidthsOption;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || !!isTableScalingEnabled && !!((_this$props$options0 = this.props.options) !== null && _this$props$options0 !== void 0 && _this$props$options0.isCommentEditor);
        if (isTableScalingWithFixedColumnWidthsOptionEnabled && getNode().attrs.displayMode !== 'fixed') {
            shouldScale = true;
            shouldHandleColgroupUpdates = true;
        }
        if (shouldHandleColgroupUpdates) this.handleColgroupUpdates();
        if ((_this$props$options1 = this.props.options) !== null && _this$props$options1 !== void 0 && _this$props$options1.isCommentEditor && allowTableResizing && !(options !== null && options !== void 0 && options.isTableScalingEnabled)) this.removeInlineTableWidth();
        const currentTable = getNode();
        const previousTable = this.node;
        const isNoOfColumnsChanged = (0, $4WYVI.tablesHaveDifferentNoOfColumns)(currentTable, previousTable);
        const isNoOfRowsChanged = (0, $4WYVI.tablesHaveDifferentNoOfRows)(currentTable, previousTable);
        if (isNoOfColumnsChanged || isNoOfRowsChanged) {
            var _this$props$pluginInj;
            (_this$props$pluginInj = this.props.pluginInjectionApi) === null || _this$props$pluginInj === void 0 || (_this$props$pluginInj = _this$props$pluginInj.accessibilityUtils) === null || _this$props$pluginInj === void 0 || _this$props$pluginInj.actions.ariaNotify((0, $jo7Pl.getAssistiveMessage)(previousTable, currentTable, this.props.intl), {
                priority: 'important'
            });
        }
        if (currentTable.attrs.__autoSize) // Wait for next tick to handle auto sizing, gives the browser time to do layout calc etc.
        this.handleAutoSizeDebounced();
        else if (allowColumnResizing && this.table && !isMediaFullscreen) {
            // If col widths (e.g. via collab) or number of columns (e.g. delete a column) have changed,
            // re-draw colgroup.
            if ((0, $4WYVI.tablesHaveDifferentColumnWidths)(currentTable, previousTable) || isNoOfColumnsChanged) {
                const { view: view } = this.props;
                const shouldRecreateResizeCols = !allowTableResizing || !isResizing || isNoOfColumnsChanged && isResizing;
                if (shouldRecreateResizeCols) {
                    var _this$table7, _this$props$options10, _this$props$options11;
                    const start = getPos() || 0;
                    const depth = view.state.doc.resolve(start).depth;
                    shouldScale = depth === 0 && shouldScale;
                    (0, $7Xzpg.insertColgroupFromNode)(this.table, currentTable, shouldScale, undefined, shouldUseIncreasedScalingPercent, options === null || options === void 0 ? void 0 : options.isCommentEditor);
                    // Deferred from setDomAttrs — remove only once colgroup is updated and table has left content mode.
                    if ((_this$table7 = this.table) !== null && _this$table7 !== void 0 && _this$table7.hasAttribute('data-initial-width-mode') && !(0, $bzCw0.isTableInContentMode)({
                        tableNode: currentTable,
                        isSupported: (0, $h3r8b.isContentModeSupported)({
                            allowColumnResizing: !!allowColumnResizing,
                            allowTableResizing: !!allowTableResizing,
                            isFullPageEditor: !((_this$props$options10 = this.props.options) !== null && _this$props$options10 !== void 0 && _this$props$options10.isCommentEditor) && !((_this$props$options11 = this.props.options) !== null && _this$props$options11 !== void 0 && _this$props$options11.isChromelessEditor)
                        }),
                        isTableNested: (0, $4WYVI.isTableNested)(view.state, getPos())
                    })) this.table.removeAttribute('data-initial-width-mode');
                }
                (0, $7JtQD.updateControls)()(view.state);
            }
            this.handleTableResizingDebounced();
        }
        this.dispatchTableRefUpdate();
    }
    dispatchTableRefUpdate() {
        if (this.table && this.table !== this.lastSetTableRef && this.props.tableActive && this.props.view) {
            this.lastSetTableRef = this.table;
            (0, $8L6TV.setTableRef)(this.table)(this.props.view.state, this.props.view.dispatch);
        }
    }
    observeTable(table) {
        if (table) {
            var _this$resizeObserver2;
            (_this$resizeObserver2 = this.resizeObserver) === null || _this$resizeObserver2 === void 0 || _this$resizeObserver2.observe(table);
        }
    }
    render() {
        var _this$props$options12;
        const { view: view, getNode: getNode, isResizing: isResizing, allowControls: allowControls = true, isHeaderRowEnabled: isHeaderRowEnabled, ordering: ordering, isHeaderColumnEnabled: isHeaderColumnEnabled, tableActive: tableActive, containerWidth: containerWidth, options: options, getPos: getPos, pluginInjectionApi: pluginInjectionApi, isDragAndDropEnabled: isDragAndDropEnabled, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, allowTableResizing: // here we can use options.isTableScalingEnabled
        allowTableResizing, allowTableAlignment: allowTableAlignment, selection: selection, isInDanger: isInDanger, hoveredRows: hoveredRows, hoveredCell: hoveredCell, isTableHovered: isTableHovered, isWholeTableInDanger: isWholeTableInDanger } = this.props;
        const node = getNode();
        const tableRef = this.table || undefined;
        const headerRow = tableRef ? tableRef.querySelector('tr[data-header-row]') : undefined;
        const hasHeaderRow = (0, $4WYVI.containsHeaderRow)(node);
        const rowControls = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lrMIT.default), {
            editorView: view,
            tableRef: tableRef,
            tableNode: node,
            tableActive: tableActive,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isInDanger: isInDanger,
            isResizing: isResizing,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            isHeaderRowEnabled: isHeaderRowEnabled,
            isDragAndDropEnabled: isDragAndDropEnabled,
            ordering: ordering,
            isHeaderColumnEnabled: isHeaderColumnEnabled,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` and `tableHeight` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            tableWrapperWidth: this.state.tableWrapperWidth,
            api: pluginInjectionApi,
            isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor
        });
        const tableContainerWidth = (0, $k5JVX.getTableContainerWidth)(node);
        const colControls = isDragAndDropEnabled ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jP7eZ.default), {
            editorView: view,
            tableRef: tableRef,
            getNode: getNode,
            tableActive: tableActive,
            isInDanger: isInDanger,
            hoveredRows: hoveredRows,
            hoveredCell: hoveredCell,
            isTableHovered: isTableHovered,
            isResizing: isResizing,
            ordering: ordering,
            hasHeaderRow: hasHeaderRow,
            // pass `selection` to control re-render
            selection: view.state.selection,
            headerRowHeight: headerRow ? headerRow.offsetHeight : undefined,
            stickyHeader: !this.props.limitedMode ? this.state.stickyHeader : undefined,
            getEditorFeatureFlags: getEditorFeatureFlags,
            tableContainerWidth: tableContainerWidth,
            isNumberColumnEnabled: node.attrs.isNumberColumnEnabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            getScrollOffset: ()=>{
                var _this$wrapper2;
                return ((_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.scrollLeft) || 0;
            },
            tableWrapperHeight: this.state.tableWrapperHeight,
            api: pluginInjectionApi,
            isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor
        }) : null;
        /**
     *  ED-19838
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  before CR6 lands in production
     */ let tablePos;
        try {
            tablePos = getPos ? getPos() : undefined;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {
            tablePos = undefined;
        }
        const isNested = (0, $4WYVI.isTableNested)(view.state, tablePos);
        const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
        const shouldUseIncreasedScalingPercent = !!isTableScalingEnabled && (tableWithFixedColumnWidthsOption || !!((_this$props$options12 = this.props.options) !== null && _this$props$options12 !== void 0 && _this$props$options12.isCommentEditor));
        return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $iPXmN.TableContainer), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $YREXK.TableCssClassName).TABLE_CONTAINER, {
                [(0, $YREXK.TableCssClassName).WITH_CONTROLS]: allowControls && tableActive,
                [(0, $YREXK.TableCssClassName).TABLE_STICKY]: !this.props.limitedMode && this.state.stickyHeader && hasHeaderRow,
                [(0, $YREXK.TableCssClassName).HOVERED_DELETE_BUTTON]: isInDanger,
                [(0, $YREXK.TableCssClassName).TABLE_SELECTED]: (0, $kD3Xq.isTableSelected)(selection ?? view.state.selection),
                [(0, $YREXK.TableCssClassName).NESTED_TABLE_WITH_CONTROLS]: tableActive && allowControls && this.isNestedInTable
            }),
            editorView: view,
            getPos: getPos,
            node: node,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            tableRef: tableRef,
            containerWidth: containerWidth,
            isNested: isNested,
            pluginInjectionApi: pluginInjectionApi,
            tableWrapperHeight: this.state.tableWrapperHeight,
            isTableResizingEnabled: allowTableResizing,
            isResizing: isResizing,
            isTableScalingEnabled: isTableScalingEnabled,
            allowFixedColumnWidthOption: tableWithFixedColumnWidthsOption,
            isWholeTableInDanger: isWholeTableInDanger,
            isTableAlignmentEnabled: allowTableAlignment,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
            isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP,
                    "data-testid": "sticky-sentinel-top"
                }),
                !this.isNestedInTable && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP,
                    "data-testid": "sticky-scrollbar-sentinel-top"
                }),
                allowControls && rowControls,
                isDragAndDropEnabled && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3UDgX.ExternalDropTargets), {
                    editorView: view,
                    node: node,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    getScrollOffset: ()=>{
                        var _this$wrapper3;
                        return ((_this$wrapper3 = this.wrapper) === null || _this$wrapper3 === void 0 ? void 0 : _this$wrapper3.scrollLeft) || 0;
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    getTableWrapperWidth: ()=>{
                        var _this$wrapper4;
                        return ((_this$wrapper4 = this.wrapper) === null || _this$wrapper4 === void 0 ? void 0 : _this$wrapper4.clientWidth) || 760;
                    }
                }),
                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $58I5S.NodeViewContentHole), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- existing table wrapper class required for legacy styling hooks
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, {
                        [(0, $YREXK.TableCssClassName).TABLE_SCROLL_INLINE_SHADOW]: (0, $bcN2K.isExperimentEnabled)('platform_editor_table_css_overflow_shadow')
                    }),
                    ref: this.setWrapperRef,
                    children: [
                        (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                    contentEditable: false,
                                    "aria-hidden": "true",
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK,
                                    "data-corner": "left"
                                }),
                                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                    contentEditable: false,
                                    "aria-hidden": "true",
                                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                    className: (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK,
                                    "data-corner": "right"
                                })
                            ]
                        }),
                        allowControls && colControls
                    ]
                }),
                (0, $bcN2K.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') && /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            contentEditable: false,
                            "aria-hidden": "true",
                            "data-vc-nvs": "true",
                            "data-table-overflow-shadow": "start"
                        }),
                        /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            contentEditable: false,
                            "aria-hidden": "true",
                            "data-vc-nvs": "true",
                            "data-table-overflow-shadow": "end"
                        })
                    ]
                }),
                !this.isNestedInTable ? /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER,
                    "data-vc-nvs": "true",
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: "var(--ds-space-250, 20px)",
                        // MAX_BROWSER_SCROLLBAR_HEIGHT
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        display: 'none',
                        // prevent unwanted scroll during table resize without removing scrollbar container from the dom
                        width: isResizing ? "var(--ds-space-0, 0px)" : '100%'
                    },
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        style: {
                            width: tableRef === null || tableRef === void 0 ? void 0 : tableRef.clientWidth,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            height: '100%'
                        },
                        "data-vc-nvs": "true"
                    })
                }) : /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    style: {
                        width: tableRef === null || tableRef === void 0 ? void 0 : tableRef.clientWidth,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        height: '100%'
                    },
                    "data-vc-nvs": "true"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM,
                    "data-testid": "sticky-sentinel-bottom"
                }),
                !this.isNestedInTable && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM,
                    "data-testid": "sticky-scrollbar-sentinel-bottom"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_LEFT_BORDER,
                    "data-with-numbered-table": node.attrs.isNumberColumnEnabled,
                    "data-testid": "table-left-border"
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    contentEditable: false,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).TABLE_RIGHT_BORDER,
                    "data-testid": "table-right-border"
                })
            ]
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $803c4b07a11d00db$var$_default_1 = (0, $fcCIH.default)($803c4b07a11d00db$var$TableComponent);
var $803c4b07a11d00db$export$2e2bcd8739ae039 = $803c4b07a11d00db$var$_default_1;

});
parcelRegister("2RRfm", function(module, exports) {
$parcel$export(module.exports, "autoScrollerFactory", () => $f3f84f660c15200c$export$aed4bc7b473fc217);

var $2LIY4 = parcelRequire("2LIY4");

var $4BoSe = parcelRequire("4BoSe");

var $4Tw3G = parcelRequire("4Tw3G");
const $f3f84f660c15200c$export$aed4bc7b473fc217 = ({ tableWrapper: tableWrapper, getNode: getNode })=>{
    return [
        (0, $2LIY4.autoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === (node === null || node === void 0 ? void 0 : node.attrs.localId) && type === 'table-column';
            }
        }),
        (0, $4BoSe.unsafeOverflowAutoScrollForElements)({
            element: tableWrapper,
            canScroll: ({ source: source })=>{
                const { localId: localId, type: type } = source.data;
                const node = getNode();
                return localId === (node === null || node === void 0 ? void 0 : node.attrs.localId) && type === 'table-column';
            },
            getOverflow: ()=>({
                    forTopEdge: {
                        top: (0, $4Tw3G.dropTargetExtendedWidth),
                        right: (0, $4Tw3G.dropTargetExtendedWidth),
                        left: (0, $4Tw3G.dropTargetExtendedWidth)
                    },
                    forRightEdge: {
                        right: (0, $4Tw3G.dropTargetExtendedWidth),
                        top: (0, $4Tw3G.dropTargetExtendedWidth),
                        bottom: (0, $4Tw3G.dropTargetExtendedWidth)
                    },
                    forLeftEdge: {
                        top: (0, $4Tw3G.dropTargetExtendedWidth),
                        left: (0, $4Tw3G.dropTargetExtendedWidth),
                        bottom: (0, $4Tw3G.dropTargetExtendedWidth)
                    }
                })
        })
    ];
};

});
parcelRegister("4BoSe", function(module, exports) {
$parcel$export(module.exports, "unsafeOverflowAutoScrollForElements", () => $d371ca8f1b29c5e6$export$b6fc2123c6c7faac);

var $c8sLM = parcelRequire("c8sLM");

var $bin8j = parcelRequire("bin8j");
const $d371ca8f1b29c5e6$var$api = (0, $bin8j.makeApi)({
    monitor: (0, $c8sLM.monitorForElements)
});
const $d371ca8f1b29c5e6$export$b6fc2123c6c7faac = $d371ca8f1b29c5e6$var$api.unsafeOverflowAutoScroll;

});
parcelRegister("bin8j", function(module, exports) {
$parcel$export(module.exports, "makeApi", () => $165e0fc822877f46$export$b8fa21320a811083);

var $kv7Jx = parcelRequire("kv7Jx");

var $7akOB = parcelRequire("7akOB");
function $165e0fc822877f46$export$b8fa21320a811083({ monitor: monitor }) {
    const ledger = new Map();
    function unsafeOverflowAutoScroll(args) {
        ledger.set(args.element, args);
        return ()=>ledger.delete(args.element);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $7akOB.tryOverflowScrollElements)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            entries: Array.from(ledger).map(([_, args])=>args),
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame
        });
    }
    // scheduler is never cleaned up
    (0, $kv7Jx.getScheduler)(monitor).onFrame(onFrame);
    return {
        unsafeOverflowAutoScroll: unsafeOverflowAutoScroll
    };
}

});
parcelRegister("7akOB", function(module, exports) {
$parcel$export(module.exports, "tryOverflowScrollElements", () => $805675723dbd801f$export$10dd8807a40dbd8b);

var $nWc1y = parcelRequire("nWc1y");

var $kqzNu = parcelRequire("kqzNu");
function $805675723dbd801f$export$10dd8807a40dbd8b({ input: input, source: source, entries: entries, timeSinceLastFrame: timeSinceLastFrame, underUsersPointer: underUsersPointer }) {
    // For now we are auto scrolling any element that wants to.
    // Otherwise it's hard to know what should scroll first as we might
    // be scrolling elements that have no hierarchical relationship
    for (const entry of entries){
        var _entry$getConfigurati, _entry$getAllowedAxis;
        // "overflow" scrolling not relevant when directly over the element
        // "over element" scrolling is responsible for scrolling when over an element
        // 1. If we are over the element, then we want to exit and let the "overflow" scroller take over
        // 2. The overflow hitbox area for an edge actually stretches over the element
        //    This check is used to "mask" or "cut out" the element hitbox from the overflow hitbox
        if (entry.element.contains(underUsersPointer)) continue;
        const feedback = {
            input: input,
            source: source,
            element: entry.element
        };
        // Scrolling not allowed for this entity
        // Note: not marking engagement if an entity is opting out of scrolling
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        const config = (0, $nWc1y.getInternalConfig)((_entry$getConfigurati = entry.getConfiguration) === null || _entry$getConfigurati === void 0 ? void 0 : _entry$getConfigurati.call(entry, feedback));
        const allowedAxis = ((_entry$getAllowedAxis = entry.getAllowedAxis) === null || _entry$getAllowedAxis === void 0 ? void 0 : _entry$getAllowedAxis.call(entry, feedback)) ?? 'all';
        const scrollBy = (0, $kqzNu.getScrollBy)({
            entry: entry,
            input: input,
            timeSinceLastFrame: timeSinceLastFrame,
            allowedAxis: allowedAxis,
            config: config
        });
        if (scrollBy) entry.element.scrollBy(scrollBy);
    }
}

});
parcelRegister("kqzNu", function(module, exports) {
$parcel$export(module.exports, "getScrollBy", () => $3b46df9364f1d330$export$6cfa6dfe6898b98f);

var $56BVo = parcelRequire("56BVo");

var $7wmcN = parcelRequire("7wmcN");

var $cpqiM = parcelRequire("cpqiM");

var $dSZY0 = parcelRequire("dSZY0");

var $63ccs = parcelRequire("63ccs");

var $j1OiA = parcelRequire("j1OiA");

var $a1D6P = parcelRequire("a1D6P");
// Distance dampening is enabled when we are inside the edge
// In order to match "over element" scrolling
function $3b46df9364f1d330$var$getIsDistanceDampeningEnabled(value) {
    return value.type === 'inside-of-edge';
}
function $3b46df9364f1d330$var$getSpacingFromProvided(value) {
    return {
        top: (value === null || value === void 0 ? void 0 : value.top) ?? 0,
        right: (value === null || value === void 0 ? void 0 : value.right) ?? 0,
        bottom: (value === null || value === void 0 ? void 0 : value.bottom) ?? 0,
        left: (value === null || value === void 0 ? void 0 : value.left) ?? 0
    };
}
function $3b46df9364f1d330$var$getHitboxSpacing(provided) {
    return {
        top: $3b46df9364f1d330$var$getSpacingFromProvided(provided.forTopEdge),
        right: $3b46df9364f1d330$var$getSpacingFromProvided(provided.forRightEdge),
        bottom: $3b46df9364f1d330$var$getSpacingFromProvided(provided.forBottomEdge),
        left: $3b46df9364f1d330$var$getSpacingFromProvided(provided.forLeftEdge)
    };
}
function $3b46df9364f1d330$export$6cfa6dfe6898b98f({ entry: entry, timeSinceLastFrame: timeSinceLastFrame, input: input, config: config, allowedAxis: allowedAxis }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // 🔥
    // For each registered item we need to do `getBoundingClientRect()` which is not great
    // Why?
    // 1. The hitbox can extend outside of an elements bounds
    // 2. We want overflow scrolling to start before the user has entered the bounds of the element
    //     Otherwise we could search upwards in the DOM from the `elementFromPoint`
    const clientRect = entry.element.getBoundingClientRect();
    const overflow = $3b46df9364f1d330$var$getHitboxSpacing(entry.getOverflow());
    const inHitboxForEdge = (0, $7wmcN.edges).map((edge)=>{
        const { insideOfEdge: insideOfEdge, outsideOfEdge: outsideOfEdge } = (0, $a1D6P.getHitbox)[edge]({
            clientRect: clientRect,
            overflow: overflow,
            config: config
        });
        /** Note:
     * Intentionally _not_ doing an explicit check to
     * see if `client` is with within the `overElementHitbox`.
     *
     * **Why?**
     *
     * 1. 🥱 Redundant
     * This check is already achieved by `element.contains(underUsersPointer)`
     *
     * 2. 📐 Overlap on boundaries
     * Two elements can share the same `{x,y}` points on shared edges.
     * It's not clear which of the two will be picked by
     * `const underUsersPointer = document.elementFromPoint(x,y)`
     * The edge of an "outside" element, can have shared `{x,y}`
     * values along the edge of an "inside element".
     * So when `underUsersPointer` is the "outer" element, the `client`
     * point might actually be also within the "inner" element.
     * We are exclusively relying on `underUsersPointer` make the decision
     * on what we are "over" so we should not be doing "over element" hitbox
     * testing here.
     * https://twitter.com/alexandereardon/status/1721758766507638996
     *
     *
     * 3. 🐞 Chrome bug
     * `document.elementFromPoint(x, y)` can return an element that does not contain `{x,y}`,
     * In these cases, `isWithin({client, clientRect: overElementHitbox})` can return `false`.
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1500073
     */ if ((0, $j1OiA.isWithin)({
            client: client,
            clientRect: outsideOfEdge
        })) return {
            edge: edge,
            hitbox: outsideOfEdge,
            type: 'outside-of-edge'
        };
        if ((0, $j1OiA.isWithin)({
            client: client,
            clientRect: insideOfEdge
        })) return {
            edge: edge,
            hitbox: insideOfEdge,
            type: 'inside-of-edge'
        };
        return false;
    }).filter((value)=>Boolean(value));
    if (!inHitboxForEdge.length) return null;
    // Even if no edges are scrollable, we are marking the element
    // as being engaged with to start applying time dampening
    const engagement = (0, $cpqiM.markAndGetEngagement)(entry.element);
    // Note: changing the allowed axis during a drag will not
    // reset time dampening. It was decided it would be too
    // complex to implement initially, and we can add it
    // later if needed.
    const scrollableEdges = inHitboxForEdge.filter((value)=>(0, $63ccs.isAxisAllowed)((0, $7wmcN.edgeAxisLookup)[value.edge], allowedAxis) && (0, $56BVo.canScrollOnEdge)[value.edge](entry.element));
    // Nothing can be scrolled
    if (!scrollableEdges.length) return null;
    const lookup = new Map(scrollableEdges.map((value)=>[
            value.edge,
            value
        ]));
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = lookup.get('left');
        if (leftEdge) return (0, $dSZY0.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $3b46df9364f1d330$var$getIsDistanceDampeningEnabled(leftEdge),
            hitbox: leftEdge.hitbox,
            edge: 'left',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const rightEdge = lookup.get('right');
        if (rightEdge) return (0, $dSZY0.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $3b46df9364f1d330$var$getIsDistanceDampeningEnabled(rightEdge),
            hitbox: rightEdge.hitbox,
            edge: 'right',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = lookup.get('bottom');
        if (bottomEdge) return (0, $dSZY0.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $3b46df9364f1d330$var$getIsDistanceDampeningEnabled(bottomEdge),
            hitbox: bottomEdge.hitbox,
            edge: 'bottom',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        const topEdge = lookup.get('top');
        if (topEdge) return (0, $dSZY0.getScrollChange)({
            client: client,
            isDistanceDampeningEnabled: $3b46df9364f1d330$var$getIsDistanceDampeningEnabled(topEdge),
            hitbox: topEdge.hitbox,
            edge: 'top',
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}

});
parcelRegister("a1D6P", function(module, exports) {
$parcel$export(module.exports, "getHitbox", () => $407c051ff0cc7b1b$export$b220adcde0a1c5fd);

var $dMJSc = parcelRequire("dMJSc");

var $hcWYt = parcelRequire("hcWYt");
function $407c051ff0cc7b1b$var$makeGetHitbox({ axis: axis, side: side }) {
    return function hitbox({ clientRect: clientRect, overflow: overflow, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $dMJSc.axisLookup)[axis];
        const edge = mainAxis[side];
        const spacingForEdge = overflow[edge];
        const overElementHitbox = (0, $hcWYt.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        // Same as the over element hitbox,
        // but we are stretching out on the cross axis (if needed)
        const insideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: overElementHitbox[mainAxis.point],
            [mainAxis.size]: overElementHitbox[mainAxis.size],
            // pull the cross axis backwards
            [crossAxis.point]: overElementHitbox[crossAxis.point] - spacingForEdge[crossAxis.start],
            // grow the cross axis
            [crossAxis.size]: overElementHitbox[crossAxis.size] + spacingForEdge[crossAxis.start] + spacingForEdge[crossAxis.end]
        });
        // Note: this will be "cut out" by the "overElementHitbox"
        const outsideOfEdge = DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? // begin from before the start edge and growing forward
            clientRect[mainAxis.point] - spacingForEdge[mainAxis.start] : // begin from on the end edge and go outwards
            clientRect[mainAxis.end],
            [crossAxis.point]: clientRect[crossAxis.point] - spacingForEdge[crossAxis.start],
            [mainAxis.size]: side === 'start' ? spacingForEdge[mainAxis.start] : spacingForEdge[mainAxis.end],
            [crossAxis.size]: spacingForEdge[crossAxis.start] + clientRect[crossAxis.size] + spacingForEdge[crossAxis.end]
        });
        return {
            insideOfEdge: insideOfEdge,
            outsideOfEdge: outsideOfEdge
        };
    };
}
const $407c051ff0cc7b1b$export$b220adcde0a1c5fd = {
    top: $407c051ff0cc7b1b$var$makeGetHitbox({
        axis: 'vertical',
        side: 'start'
    }),
    right: $407c051ff0cc7b1b$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'end'
    }),
    bottom: $407c051ff0cc7b1b$var$makeGetHitbox({
        axis: 'vertical',
        side: 'end'
    }),
    left: $407c051ff0cc7b1b$var$makeGetHitbox({
        axis: 'horizontal',
        side: 'start'
    })
};

});






parcelRegister("fkY0k", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $fdbf6d68bd165307$export$18d4026d1ea86bb1);

var $801jp = parcelRequire("801jp");
const $fdbf6d68bd165307$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('stickyHeadersPlugin');

});

parcelRegister("AGA3t", function(module, exports) {
$parcel$export(module.exports, "findStickyHeaderForTable", () => $aa8b3aa6b81318b6$export$91d61a242b14c7fb);
const $aa8b3aa6b81318b6$export$91d61a242b14c7fb = (state, tablePos)=>{
    if (!state || tablePos === undefined) return undefined;
    const rowInfo = state.find((rowInfo)=>rowInfo.pos === tablePos + 1);
    if (!rowInfo) return undefined;
    return rowInfo.sticky ? rowInfo : undefined;
};

});

parcelRegister("x2FuQ", function(module, exports) {
$parcel$export(module.exports, "handleBlur", () => $a669b14cad072e99$export$27d5d91e7417534c);
$parcel$export(module.exports, "handleFocus", () => $a669b14cad072e99$export$185584c64f36588);
$parcel$export(module.exports, "handleClick", () => $a669b14cad072e99$export$b981489921ee18cd);
$parcel$export(module.exports, "handleMouseOver", () => $a669b14cad072e99$export$321c2da35903b013);
$parcel$export(module.exports, "handleMouseUp", () => $a669b14cad072e99$export$88f4dbb0cd0ffc84);
$parcel$export(module.exports, "handleMouseDown", () => $a669b14cad072e99$export$b4a93e0b711d8f7);
$parcel$export(module.exports, "handleMouseOut", () => $a669b14cad072e99$export$72517da01e0ce829);
$parcel$export(module.exports, "handleMouseEnter", () => $a669b14cad072e99$export$2560ef85393729a7);
$parcel$export(module.exports, "handleMouseLeave", () => $a669b14cad072e99$export$fcff8e67f71577c3);
$parcel$export(module.exports, "isTableInFocus", () => $a669b14cad072e99$export$42d5d9cc7457d81e);
$parcel$export(module.exports, "handleMouseMove", () => $a669b14cad072e99$export$3248c033e90a4ba0);
$parcel$export(module.exports, "handleTripleClick", () => $a669b14cad072e99$export$f17e34274dd6fcf5);
$parcel$export(module.exports, "handleCut", () => $a669b14cad072e99$export$1c3f791fb2a5168);
$parcel$export(module.exports, "whenTableInFocus", () => $a669b14cad072e99$export$82a75cb550f27e28);
$parcel$export(module.exports, "withCellTracking", () => $a669b14cad072e99$export$87e6a6bf8341824f);

var $PIUl3 = parcelRequire("PIUl3");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $dqFZv = parcelRequire("dqFZv");

var $5DGsr = parcelRequire("5DGsr");

var $i3jVx = parcelRequire("i3jVx");
var $e61LF = parcelRequire("e61LF");
var $8svEG = parcelRequire("8svEG");

var $hCON4 = parcelRequire("hCON4");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $gNVxw = parcelRequire("gNVxw");
var $elHd5 = parcelRequire("elHd5");
var $5n2u9 = parcelRequire("5n2u9");

var $l5gi8 = parcelRequire("l5gi8");

var $h65Gv = parcelRequire("h65Gv");

var $aEmSo = parcelRequire("aEmSo");

var $8L6TV = parcelRequire("8L6TV");
var $EwLhB = parcelRequire("EwLhB");

var $HfCkc = parcelRequire("HfCkc");

var $4GJqd = parcelRequire("4GJqd");

var $6xtYM = parcelRequire("6xtYM");

var $7gr04 = parcelRequire("7gr04");

var $gCkVm = parcelRequire("gCkVm");

var $4Bf8g = parcelRequire("4Bf8g");

var $fQCvF = parcelRequire("fQCvF");

var $6lkZH = parcelRequire("6lkZH");

var $eaKZu = parcelRequire("eaKZu");

var $eEepd = parcelRequire("eEepd");

var $YREXK = parcelRequire("YREXK");

var $hkEC0 = parcelRequire("hkEC0");
const $a669b14cad072e99$var$isFocusingCalendar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.getAttribute('aria-label') === 'calendar';
const $a669b14cad072e99$var$isFocusingModal = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="dialog"]');
const $a669b14cad072e99$var$isFocusingFloatingToolbar = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('[role="toolbar"]');
const $a669b14cad072e99$var$isFocusingDragHandles = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.getAttribute('draggable') === 'true';
const $a669b14cad072e99$var$isFocusingDragHandlesClickableZone = (event)=>event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && event.relatedTarget.closest('button') && event.relatedTarget.classList.contains((0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE);
const $a669b14cad072e99$var$isFocusingTableMenu = (event)=>(0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) && event instanceof FocusEvent && event.relatedTarget instanceof HTMLElement && Boolean(event.relatedTarget.closest((0, $hkEC0.TABLE_MENU_SELECTOR)));
const $a669b14cad072e99$export$27d5d91e7417534c = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    // IE version check for ED-4665
    // Calendar focus check for ED-10466
    if ((0, $dqFZv.getBrowserInfo)().ie_version !== 11 && !$a669b14cad072e99$var$isFocusingCalendar(event) && !$a669b14cad072e99$var$isFocusingModal(event) && !$a669b14cad072e99$var$isFocusingFloatingToolbar(event) && !$a669b14cad072e99$var$isFocusingDragHandles(event) && !$a669b14cad072e99$var$isFocusingDragHandlesClickableZone(event) && !$a669b14cad072e99$var$isFocusingTableMenu(event)) (0, $8L6TV.setEditorFocus)(false)(state, dispatch);
    event.preventDefault();
    return false;
};
const $a669b14cad072e99$export$185584c64f36588 = (view, event)=>{
    const { state: state, dispatch: dispatch } = view;
    (0, $8L6TV.setEditorFocus)(true)(state, dispatch);
    event.preventDefault();
    return false;
};
const $a669b14cad072e99$export$b981489921ee18cd = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const element = event.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const table = (0, $5n2u9.findTable)(view.state.selection);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    if (event instanceof MouseEvent && (0, $6lkZH.isColumnControlsDecorations)(element)) {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const [startIndex] = (0, $6lkZH.getColumnOrRowIndex)(element);
        const { state: state, dispatch: dispatch } = view;
        return (0, $8L6TV.selectColumn)(startIndex, event.shiftKey)(state, dispatch);
    }
    const matchfn = element.matches ? element.matches : element.msMatchesSelector;
    // check if the table cell with an image is clicked and its not the image itself
    if (!table || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    !(0, $i3jVx.isElementInTableCell)(element) || !matchfn || matchfn.call(element, 'table .image, table p, table .image div')) return false;
    const map = (0, $dpooP.TableMap).get(table.node);
    /** Getting the offset of current item clicked */ // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const colElement = (0, $hCON4.closestElement)(element, 'td') || // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $hCON4.closestElement)(element, 'th');
    const colIndex = colElement && colElement.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $hCON4.closestElement)(element, 'tr');
    const rowIndex = rowElement && rowElement.rowIndex;
    const cellIndex = map.width * rowIndex + colIndex;
    const { dispatch: dispatch, state: { tr: tr, schema: { nodes: { paragraph: paragraph } } } } = view;
    const cellPos = map.map[cellIndex];
    if (isNaN(cellPos) || cellPos === undefined || typeof cellPos !== 'number') return false;
    const editorElement = table.node.nodeAt(cellPos);
    /** Only if the last item is media group, insert a paragraph */ if ((0, $e61LF.isLastItemMediaGroup)(editorElement)) {
        const posInTable = map.map[cellIndex] + editorElement.nodeSize;
        tr.insert(posInTable + table.pos, paragraph.create());
        dispatch(tr);
        (0, $8svEG.setNodeSelection)(view, posInTable + table.pos);
    }
    return true;
};
const $a669b14cad072e99$export$321c2da35903b013 = (view, mouseEvent)=>{
    if (!(mouseEvent.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const target = mouseEvent.target;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $4GJqd.getPluginState)(state);
    if ((0, $6lkZH.isInsertRowButton)(target)) {
        const [startIndex, endIndex] = (0, $6lkZH.getColumnOrRowIndex)(target);
        const positionRow = (0, $6lkZH.getMousePositionVerticalRelativeByElement)(mouseEvent) === 'bottom' ? endIndex : startIndex;
        return (0, $8L6TV.showInsertRowButton)(positionRow)(state, dispatch);
    }
    if ((0, $6lkZH.isColumnControlsDecorations)(target)) {
        const [startIndex] = (0, $6lkZH.getColumnOrRowIndex)(target);
        const { state: state, dispatch: dispatch } = view;
        return (0, $EwLhB.hoverColumns)([
            startIndex
        ], false)(state, dispatch);
    }
    const isNestedTable = (0, $5DGsr.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1;
    if (isNestedTable) {
        // if the table is nested inside a table, we only call hideInsertColumnOrRowButton if the table nearest to the mouse target is NOT the parent table
        const nearestTable = (0, $hCON4.closestElement)(target, 'table');
        const nestedTable = (0, $a4TQr.findParentNodeOfTypeClosestToPos)(state.doc.resolve(state.selection.from), [
            state.schema.nodes.table
        ]);
        const parentTable = (0, $a4TQr.findParentNodeOfTypeClosestToPos)(state.doc.resolve((nestedTable === null || nestedTable === void 0 ? void 0 : nestedTable.pos) || 0), [
            state.schema.nodes.table
        ]);
        if ((nearestTable === null || nearestTable === void 0 ? void 0 : nearestTable.dataset.tableLocalId) !== (parentTable === null || parentTable === void 0 ? void 0 : parentTable.node.attrs.localId) && ((0, $6lkZH.isCell)(target) || (0, $6lkZH.isCornerButton)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $8L6TV.hideInsertColumnOrRowButton)()(state, dispatch);
    } else if (((0, $6lkZH.isCell)(target) || (0, $6lkZH.isCornerButton)(target)) && (typeof insertColumnButtonIndex === 'number' || typeof insertRowButtonIndex === 'number')) return (0, $8L6TV.hideInsertColumnOrRowButton)()(state, dispatch);
    if ((0, $6lkZH.isResizeHandleDecoration)(target)) {
        const [startIndex, endIndex] = (0, $6lkZH.getColumnOrRowIndex)(target);
        return (0, $EwLhB.showResizeHandleLine)({
            left: startIndex,
            right: endIndex
        })(state, dispatch);
    }
    if (!isTableHovered) return (0, $EwLhB.setTableHovered)(true)(state, dispatch);
    return false;
};
const $a669b14cad072e99$export$88f4dbb0cd0ffc84 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, tableNode: tableNode, tableRef: tableRef } = (0, $4GJqd.getPluginState)(state);
    if (insertColumnButtonIndex !== undefined && tableRef && tableRef.parentElement && tableNode) {
        const { width: width } = (0, $dpooP.TableMap).get(tableNode);
        const newInsertColumnButtonIndex = insertColumnButtonIndex + 1;
        if (width === newInsertColumnButtonIndex) {
            const tableWidth = tableRef.clientWidth;
            tableRef.parentElement.scrollTo(tableWidth, 0);
            return (0, $8L6TV.showInsertColumnButton)(newInsertColumnButtonIndex)(state, dispatch);
        }
    }
    return false;
};
const $a669b14cad072e99$var$resetDragHandleSelectedIntentOnMouseDown = (event, api)=>{
    var _api$userIntent;
    if ((0, $6lkZH.isTableDragHandleButton)(event.target)) return;
    if ((api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'dragHandleSelected') {
        var _api$core, _api$userIntent2;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.commands.setCurrentUserIntent('default'));
    }
};
const $a669b14cad072e99$export$b4a93e0b711d8f7 = (_view, event, api)=>{
    const isControl = !!(event.target && event.target instanceof HTMLElement && ((0, $6lkZH.isTableContainerOrWrapper)(event.target) || (0, $6lkZH.isColumnControlsDecorations)(event.target) || (0, $6lkZH.isRowControlsButton)(event.target) || (0, $6lkZH.isDragCornerButton)(event.target)));
    if (isControl) event.preventDefault();
    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) $a669b14cad072e99$var$resetDragHandleSelectedIntentOnMouseDown(event, api);
    return isControl;
};
const $a669b14cad072e99$export$72517da01e0ce829 = (view, mouseEvent)=>{
    if (!(mouseEvent instanceof MouseEvent) || !(mouseEvent.target instanceof HTMLElement)) return false;
    const target = mouseEvent.target;
    if ((0, $6lkZH.isColumnControlsDecorations)(target)) {
        const { state: state, dispatch: dispatch } = view;
        return (0, $EwLhB.clearHoverSelection)()(state, dispatch);
    }
    const relatedTarget = mouseEvent.relatedTarget;
    // In case the user is moving between cell at the same column
    // we don't need to hide the resize handle decoration
    if ((0, $6lkZH.isResizeHandleDecoration)(target) && !(0, $6lkZH.isResizeHandleDecoration)(relatedTarget)) {
        const { state: state, dispatch: dispatch } = view;
        const { isKeyboardResize: isKeyboardResize } = (0, $4GJqd.getPluginState)(state);
        if (isKeyboardResize) // no need to hide decoration if column resizing started by keyboard
        return false;
        return (0, $EwLhB.hideResizeHandleLine)()(state, dispatch);
    }
    return false;
};
const $a669b14cad072e99$export$2560ef85393729a7 = (view, mouseEvent)=>{
    const { state: state, dispatch: dispatch } = view;
    const { isTableHovered: isTableHovered } = (0, $4GJqd.getPluginState)(state);
    if (!isTableHovered) return (0, $EwLhB.setTableHovered)(true)(state, dispatch);
    return false;
};
const $a669b14cad072e99$export$fcff8e67f71577c3 = (view, event)=>{
    if (!(event.target instanceof HTMLElement)) return false;
    const { state: state, dispatch: dispatch } = view;
    const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isTableHovered: isTableHovered } = (0, $4GJqd.getPluginState)(state);
    if (isTableHovered) {
        const { isDragMenuOpen: isDragMenuOpen = false } = (0, $HfCkc.getPluginState)(state);
        !isDragMenuOpen && (0, $EwLhB.setTableHovered)(false)(state, dispatch);
        return true;
    }
    // If this table doesn't have focus then we want to skip everything after this.
    if (!$a669b14cad072e99$export$42d5d9cc7457d81e(view)) return false;
    const target = event.target;
    if ((0, $6lkZH.isTableControlsButton)(target)) return true;
    if ((typeof insertColumnButtonIndex !== 'undefined' || typeof insertRowButtonIndex !== 'undefined') && (0, $8L6TV.hideInsertColumnOrRowButton)()(state, dispatch)) return true;
    return false;
};
// IMPORTANT: The mouse move handler has been setup with RAF schedule to avoid Reflows which will occur as some methods
// need to access the mouse event offset position and also the target clientWidth vallue.
const $a669b14cad072e99$var$handleMouseMoveDebounce = (nodeViewPortalProviderAPI)=>(0, $PIUl3.default)((view, event, offsetX)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        const element = event.target;
        const isTableMenuUpdatesEnabled = (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true);
        // Spanned cells need mouse-position-based hover indexes; normal cells already report them.
        if (isTableMenuUpdatesEnabled) {
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const tableCell = (0, $i3jVx.isElementInTableCell)(element);
            if (tableCell && (tableCell.rowSpan > 1 || tableCell.colSpan > 1)) {
                const dragDropState = (0, $HfCkc.getPluginState)(view.state);
                if (dragDropState && !dragDropState.isDragging) $a669b14cad072e99$var$trackCellLocation(view, event);
            }
        }
        if ((0, $6lkZH.isColumnControlsDecorations)(element) || (0, $6lkZH.isDragColumnFloatingInsertDot)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertColumnButtonIndex: insertColumnButtonIndex } = (0, $4GJqd.getPluginState)(state);
            const indexSourceElement = isTableMenuUpdatesEnabled ? (0, $6lkZH.getIndexAttributeSourceElement)(element) : element;
            const [startIndex, endIndex] = (0, $6lkZH.getColumnOrRowIndex)(indexSourceElement);
            const positionColumn = (0, $6lkZH.getMousePositionHorizontalRelativeByElement)(event, offsetX, undefined) === 'right' ? endIndex : startIndex;
            if (positionColumn !== insertColumnButtonIndex) return (0, $8L6TV.showInsertColumnButton)(positionColumn)(state, dispatch);
        }
        if ((0, $6lkZH.isRowControlsButton)(element) || (0, $6lkZH.isDragRowFloatingInsertDot)(element)) {
            const { state: state, dispatch: dispatch } = view;
            const { insertRowButtonIndex: insertRowButtonIndex } = (0, $4GJqd.getPluginState)(state);
            const indexSourceElement = isTableMenuUpdatesEnabled ? (0, $6lkZH.getIndexAttributeSourceElement)(element) : element;
            const [startIndex, endIndex] = (0, $6lkZH.getColumnOrRowIndex)(indexSourceElement);
            const positionRow = (0, $6lkZH.getMousePositionVerticalRelativeByElement)(event) === 'bottom' ? endIndex : startIndex;
            if (positionRow !== insertRowButtonIndex) return (0, $8L6TV.showInsertRowButton)(positionRow)(state, dispatch);
        }
        if (!(0, $6lkZH.isResizeHandleDecoration)(element) && (0, $6lkZH.isCell)(element)) {
            const positionColumn = (0, $6lkZH.getMousePositionHorizontalRelativeByElement)(event, offsetX, (0, $YREXK.RESIZE_HANDLE_AREA_DECORATION_GAP));
            if (positionColumn !== null) {
                const { state: state, dispatch: dispatch } = view;
                const { resizeHandleColumnIndex: resizeHandleColumnIndex, resizeHandleRowIndex: resizeHandleRowIndex } = (0, $4GJqd.getPluginState)(state);
                const isKeyboardResize = (0, $4GJqd.getPluginState)(state).isKeyboardResize;
                const tableCell = (0, $hCON4.closestElement)(element, 'td, th');
                const cellStartPosition = view.posAtDOM(tableCell, 0);
                const rect = (0, $elHd5.findCellRectClosestToPos)(state.doc.resolve(cellStartPosition));
                if (rect) {
                    const columnEndIndexTarget = positionColumn === 'left' ? rect.left : rect.right;
                    const rowIndexTarget = rect.top;
                    if ((columnEndIndexTarget !== resizeHandleColumnIndex || rowIndexTarget !== resizeHandleRowIndex || !(0, $6lkZH.hasResizeHandler)({
                        target: element,
                        columnEndIndexTarget: columnEndIndexTarget
                    })) && !isKeyboardResize // if initiated by keyboard don't need to react on hover for other resize sliders
                    ) return (0, $8L6TV.addResizeHandleDecorations)(rowIndexTarget, columnEndIndexTarget, true, nodeViewPortalProviderAPI)(state, dispatch);
                }
            }
        }
        return false;
    });
const $a669b14cad072e99$export$3248c033e90a4ba0 = (nodeViewPortalProviderAPI)=>(view, event)=>{
        if (!(event.target instanceof HTMLElement)) return false;
        // NOTE: When accessing offsetX in gecko from a deferred callback, it will return 0. However it will be non-zero if accessed
        // within the scope of it's initial mouse move handler. Also Chrome does return the correct value, however it could trigger
        // a reflow. So for now this will just grab the offsetX value immediately for gecko and chrome will calculate later
        // in the deferred callback handler.
        // Bug Tracking: https://bugzilla.mozilla.org/show_bug.cgi?id=1882903
        $a669b14cad072e99$var$handleMouseMoveDebounce(nodeViewPortalProviderAPI)(view, event, (0, $dqFZv.getBrowserInfo)().gecko ? event.offsetX : NaN);
        return false;
    };
function $a669b14cad072e99$export$f17e34274dd6fcf5(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const $cellPos = (0, $gNVxw.cellAround)(state.doc.resolve(pos));
    if (!$cellPos) return false;
    const cell = state.doc.nodeAt($cellPos.pos);
    if (cell) {
        const selFrom = (0, $801jp.Selection).findFrom($cellPos, 1, true);
        const selTo = (0, $801jp.Selection).findFrom(state.doc.resolve($cellPos.pos + cell.nodeSize), -1, true);
        if (selFrom && selTo) {
            dispatch(state.tr.setSelection(new (0, $801jp.TextSelection)(selFrom.$from, selTo.$to)));
            return true;
        }
    }
    return false;
}
const $a669b14cad072e99$export$1c3f791fb2a5168 = (oldTr, oldState, newState, api, editorAnalyticsAPI, editorView, isTableScalingEnabled = false, isTableFixedColumnWidthsOptionEnabled = false, shouldUseIncreasedScalingPercent = false)=>{
    const oldSelection = oldState.tr.selection;
    let { tr: tr } = newState;
    if (oldSelection instanceof (0, $ev7OZ.CellSelection)) {
        const $anchorCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$anchorCell.pos));
        const $headCell = oldTr.doc.resolve(oldTr.mapping.map(oldSelection.$headCell.pos));
        const cellSelection = new (0, $ev7OZ.CellSelection)($anchorCell, $headCell);
        tr.setSelection(cellSelection);
        if (tr.selection instanceof (0, $ev7OZ.CellSelection)) {
            const rect = (0, $l5gi8.getSelectionRect)(cellSelection);
            if (rect) {
                const { verticalCells: verticalCells, horizontalCells: horizontalCells, totalCells: totalCells, totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedCellInfo)(tr.selection);
                // Reassigning to make it more obvious and consistent
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $8d4kB.TABLE_ACTION).CUT,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    attributes: {
                        verticalCells: verticalCells,
                        horizontalCells: horizontalCells,
                        totalCells: totalCells,
                        totalRowCount: totalRowCount,
                        totalColumnCount: totalColumnCount
                    },
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(tr);
                // Need this check again since we are overriding the tr in previous statement
                if (tr.selection instanceof (0, $ev7OZ.CellSelection)) {
                    const isTableSelected = tr.selection.isRowSelection() && tr.selection.isColSelection();
                    if (isTableSelected) tr = (0, $h65Gv.removeTable)(tr);
                    else if (tr.selection.isRowSelection()) {
                        const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $4GJqd.getPluginState)(newState);
                        tr = (0, $gCkVm.deleteRows)(rect, isHeaderRowRequired)(tr);
                    } else if (tr.selection.isColSelection()) tr = (0, $7gr04.deleteColumns)(rect, (0, $eaKZu.getAllowAddColumnCustomStep)(oldState), api, editorView, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent)(tr);
                }
            }
        }
    }
    return tr;
};
const $a669b14cad072e99$export$42d5d9cc7457d81e = (view)=>{
    var _getPluginState, _getResizePluginState;
    return !!((_getPluginState = (0, $4GJqd.getPluginState)(view.state)) !== null && _getPluginState !== void 0 && _getPluginState.tableNode) && !((_getResizePluginState = (0, $6xtYM.getPluginState)(view.state)) !== null && _getResizePluginState !== void 0 && _getResizePluginState.dragging);
};
const $a669b14cad072e99$export$82a75cb550f27e28 = (eventHandler, pluginInjectionApi)=>(view, mouseEvent)=>{
        var _pluginInjectionApi$e;
        if (!$a669b14cad072e99$export$42d5d9cc7457d81e(view)) return false;
        const isViewMode = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.editorViewMode) === null || _pluginInjectionApi$e === void 0 || (_pluginInjectionApi$e = _pluginInjectionApi$e.sharedState.currentState()) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.mode) === 'view';
        /**
   * Table cannot be in focus if we are in view mode.
   * This will prevent an infinite flow of adding and removing
   * resize handle decorations in view mode that causes unpredictable
   * selections.
   */ if (isViewMode) return false;
        return eventHandler(view, mouseEvent);
    };
const $a669b14cad072e99$var$trackCellLocation = (view, mouseEvent)=>{
    var _tableElement$dataset;
    const isTableMenuUpdatesEnabled = (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true);
    const target = mouseEvent.target;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const maybeTableCell = (0, $i3jVx.isElementInTableCell)(target);
    const { tableNode: tableNode, tableRef: tableRef } = (0, $4GJqd.getPluginState)(view.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const tableElement = (0, $hCON4.closestElement)(target, 'table');
    // hover will only trigger if target localId is the same with selected localId
    if (tableElement !== null && tableElement !== void 0 && (_tableElement$dataset = tableElement.dataset) !== null && _tableElement$dataset !== void 0 && _tableElement$dataset.tableLocalId && tableElement.dataset.tableLocalId !== (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId)) return;
    if (!maybeTableCell || !tableRef) return;
    const htmlColIndex = maybeTableCell.cellIndex;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const rowElement = (0, $hCON4.closestElement)(target, 'tr');
    const htmlRowIndex = rowElement && rowElement.rowIndex;
    const rowIndex = maybeTableCell.rowSpan > 1 && mouseEvent instanceof MouseEvent && isTableMenuUpdatesEnabled ? (0, $eEepd.getRowIndexByMousePosition)(tableRef, mouseEvent, {
        startIndex: htmlRowIndex,
        endIndex: htmlRowIndex + maybeTableCell.rowSpan
    }) ?? htmlRowIndex : htmlRowIndex;
    const tableMap = tableNode && (0, $dpooP.TableMap).get(tableNode);
    let colIndex = htmlColIndex;
    if (tableMap) {
        const convertedColIndex = (0, $fQCvF.convertHTMLCellIndexToColumnIndex)(htmlColIndex, htmlRowIndex, tableMap);
        if (isTableMenuUpdatesEnabled) {
            // New behaviour: the column controls grid renders one track per visual column
            // (`getColumnsWidthsWithMergedCells`), so the hover index must be the visual column
            // index — not the first-row-cell index. Mapping to the first-row cell would collapse
            // every column under a merged first-row cell to the same index, leaving the drag handle
            // stuck when hovering cells in other rows. For a colspanned cell, refine the converted
            // (left-most) visual column to the exact visual column under the pointer.
            colIndex = convertedColIndex;
            if (maybeTableCell.colSpan > 1 && mouseEvent instanceof MouseEvent) colIndex = (0, $fQCvF.getColumnIndexByMousePosition)(maybeTableCell, mouseEvent, {
                startIndex: convertedColIndex,
                endIndex: convertedColIndex + maybeTableCell.colSpan
            }) ?? convertedColIndex;
        } else // Old behaviour: the legacy grid renders one track per first-row cell, so snap to the
        // first-row column index (a merged first-row cell collapses to a single column track).
        colIndex = (0, $fQCvF.getColumnIndexMappedToColumnIndexInFirstRow)(convertedColIndex, htmlRowIndex, tableMap);
    }
    (0, $EwLhB.hoverCell)(rowIndex, colIndex)(view.state, view.dispatch);
};
const $a669b14cad072e99$export$87e6a6bf8341824f = (eventHandler)=>(view, mouseEvent)=>{
        if ((0, $HfCkc.getPluginState)(view.state) && !(0, $HfCkc.getPluginState)(view.state).isDragging) $a669b14cad072e99$var$trackCellLocation(view, mouseEvent);
        return eventHandler(view, mouseEvent);
    };

});
parcelRegister("hkEC0", function(module, exports) {
$parcel$export(module.exports, "TABLE_MENU_WIDTH", () => $711d85abd251cbd6$export$f8597a393fbbbffb);
$parcel$export(module.exports, "TABLE_MENU_SELECTOR", () => $711d85abd251cbd6$export$2e13b7512b2d6fe8);
$parcel$export(module.exports, "TABLE_ROW", () => $711d85abd251cbd6$export$1aad44a7533f8ad8);
$parcel$export(module.exports, "TABLE_COLUMN", () => $711d85abd251cbd6$export$2f97b0848614fec9);
const $711d85abd251cbd6$export$f8597a393fbbbffb = 280;
const $711d85abd251cbd6$export$2e13b7512b2d6fe8 = '[data-testid="column-handle-menu"], [data-testid="row-handle-menu"], [data-toolbar-component="menu"], [data-toolbar-nested-dropdown-menu]';
const $711d85abd251cbd6$export$1aad44a7533f8ad8 = 'table-row';
const $711d85abd251cbd6$export$2f97b0848614fec9 = 'table-column';

});


parcelRegister("jP7eZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d2ea1ee25292235c$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $c8sLM = parcelRequire("c8sLM");

var $aEmSo = parcelRequire("aEmSo");

var $fQCvF = parcelRequire("fQCvF");

var $4WYVI = parcelRequire("4WYVI");

var $eEepd = parcelRequire("eEepd");

var $gOVfD = parcelRequire("gOVfD");

var $YREXK = parcelRequire("YREXK");

var $7I69H = parcelRequire("7I69H");

var $7iMZj = parcelRequire("7iMZj");
const $d2ea1ee25292235c$var$TableFloatingColumnControls = ({ editorView: editorView, tableRef: tableRef, getNode: getNode, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredCell: hoveredCell, isResizing: isResizing, stickyHeader: stickyHeader, selection: selection, isInDanger: isInDanger, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, getScrollOffset: getScrollOffset, tableWrapperHeight: tableWrapperHeight, api: api, isChromelessEditor: isChromelessEditor })=>{
    const [isDragging, setIsDragging] = (0, $fc4bM.useState)(false);
    const containerRef = (0, $fc4bM.useRef)(null);
    const node = getNode();
    const currentNodeLocalId = node === null || node === void 0 ? void 0 : node.attrs.localId;
    const hasHeaderColumn = (0, $4WYVI.containsHeaderColumn)(node);
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    (0, $fc4bM.useEffect)(()=>{
        return (0, $c8sLM.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                return type === 'table-column' && !!(indexes !== null && indexes !== void 0 && indexes.length) && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView,
        currentNodeLocalId
    ]);
    const rowHeights = (0, $fc4bM.useMemo)(()=>{
        // NOTE: we don't care so much as to what tableHeight is, we only care that it changed and is a sane value.
        if (tableRef && !!tableWrapperHeight) return (0, $eEepd.getRowHeights)(tableRef);
        return [
            0
        ];
    }, [
        tableRef,
        tableWrapperHeight
    ]);
    if (!tableRef || !tableActive || isResizing) return null;
    const colWidths = (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? (0, $fQCvF.getColumnsWidthsWithMergedCells)(editorView) : (0, $fQCvF.getColumnsWidths)(editorView);
    if (stickyTop) {
        var _containerRef$current;
        const columnControlTopOffsetFromParent = '-12px';
        containerRef === null || containerRef === void 0 || (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || _containerRef$current.style.setProperty('top', columnControlTopOffsetFromParent);
    } else {
        var _containerRef$current2;
        containerRef === null || containerRef === void 0 || (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 || _containerRef$current2.style.removeProperty('top');
    }
    let anchorStyles = {};
    if ((0, $gOVfD.isNativeStickySupported)()) {
        var _tableRef$querySelect, _tableRef$querySelect2;
        const rowAnchorName = (_tableRef$querySelect = tableRef.querySelector('tr')) === null || _tableRef$querySelect === void 0 ? void 0 : _tableRef$querySelect.style.getPropertyValue('anchor-name');
        // cast here is due to CSSProperties missing valid positionAnchor property
        anchorStyles = {
            /* We need to default to checking the anchor style because there may be a conflict with the block controls
       plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
       */ positionAnchor: rowAnchorName === '' ? (_tableRef$querySelect2 = tableRef.querySelector('tr')) === null || _tableRef$querySelect2 === void 0 ? void 0 : _tableRef$querySelect2.dataset.nodeAnchor : rowAnchorName
        };
    }
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        ref: containerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER + (isChromelessEditor ? ' ' + (0, $YREXK.TableCssClassName).TABLE_CHROMELESS : ''),
        "data-testid": "table-floating-column-controls-wrapper",
        // anchor name is determined dynamically so can't use static styles
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: anchorStyles,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7I69H.ColumnControls), {
                editorView: editorView,
                hoveredCell: hoveredCell,
                tableRef: tableRef,
                tableActive: tableActive,
                isTableHovered: isTableHovered,
                stickyTop: tableActive ? stickyTop : undefined,
                localId: currentNodeLocalId,
                isInDanger: isInDanger,
                rowHeights: rowHeights,
                colWidths: colWidths,
                hasHeaderColumn: hasHeaderColumn,
                tableContainerWidth: tableContainerWidth,
                isNumberColumnEnabled: isNumberColumnEnabled,
                isDragging: isDragging,
                getScrollOffset: getScrollOffset,
                api: api
            }),
            isDragging && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7iMZj.ColumnDropTargets), {
                tableRef: tableRef,
                isHeaderSticky: (stickyHeader === null || stickyHeader === void 0 ? void 0 : stickyHeader.sticky) && hasHeaderRow,
                tableHeight: tableWrapperHeight,
                localId: currentNodeLocalId,
                colWidths: colWidths,
                getScrollOffset: getScrollOffset
            })
        ]
    });
};
var $d2ea1ee25292235c$export$2e2bcd8739ae039 = $d2ea1ee25292235c$var$TableFloatingColumnControls;

});
parcelRegister("7I69H", function(module, exports) {
$parcel$export(module.exports, "ColumnControls", () => $a9ceb25842c6521f$export$a71b12ee0b179860);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $jd8X7 = parcelRequire("jd8X7");

var $9oAqi = parcelRequire("9oAqi");

var $014x6 = parcelRequire("014x6");

var $ev7OZ = parcelRequire("ev7OZ");

var $l5gi8 = parcelRequire("l5gi8");

var $aEmSo = parcelRequire("aEmSo");

var $EwLhB = parcelRequire("EwLhB");
var $8L6TV = parcelRequire("8L6TV");
var $gzpzh = parcelRequire("gzpzh");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $eEepd = parcelRequire("eEepd");

var $2q9QJ = parcelRequire("2q9QJ");

var $YREXK = parcelRequire("YREXK");

var $1y1ip = parcelRequire("1y1ip");
const $a9ceb25842c6521f$var$getSelectedColumns = (selection)=>{
    if (!(selection instanceof (0, $ev7OZ.CellSelection))) return [];
    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        const isColumnSelection = selection.isColSelection() || (0, $2q9QJ.isColumnSelectionWithMergedFirstRow)(selection) || (0, $2q9QJ.isColumnSelectionWithMergedLastRow)(selection);
        if (!isColumnSelection) return [];
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        return rect ? (0, $2q9QJ.getSelectedColumnIndexes)(rect) : [];
    }
    // Old behaviour: only standard column selections are recognised.
    if (selection.isColSelection()) {
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $2q9QJ.getSelectedColumnIndexes)(rect);
    }
    return [];
};
const $a9ceb25842c6521f$export$a71b12ee0b179860 = ({ editorView: editorView, tableActive: tableActive, tableRef: tableRef, hoveredCell: hoveredCell, stickyTop: stickyTop, localId: localId, isInDanger: isInDanger, rowHeights: rowHeights, colWidths: colWidths, isTableHovered: isTableHovered, tableContainerWidth: tableContainerWidth, isNumberColumnEnabled: isNumberColumnEnabled, isDragging: isDragging, getScrollOffset: getScrollOffset, api: api })=>{
    const columnControlsRef = (0, $fc4bM.useRef)(null);
    const { activeTableMenu: activeTableMenu, selection: selection } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'selection',
        'table'
    ], (states)=>{
        var _states$tableState, _states$selectionStat;
        return {
            activeTableMenu: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.activeTableMenu,
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
        };
    });
    const widths = (colWidths === null || colWidths === void 0 ? void 0 : colWidths.map((width)=>// when there is sticky header, a `margin-right: -1px` applied to `tr.sticky th` so it causes colWidths to be 1px wider
        // we need to reduce the width by 1px to avoid misalignment of column controls.
        width ? stickyTop ? `${width - 2}px` : `${width - 1}px` : '0px').join(' ')) ?? '0px';
    // TODO: ED-26961 - reusing getRowsParams here because it's generic enough to work for columns -> rename
    const columnParams = (0, $eEepd.getRowsParams)(colWidths ?? []);
    const colIndex = hoveredCell === null || hoveredCell === void 0 ? void 0 : hoveredCell.colIndex;
    const selectedColIndexes = $a9ceb25842c6521f$var$getSelectedColumns(selection || editorView.state.selection);
    const renderedSelectedColIndexes = (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'column' ? [
        activeTableMenu.index
    ] : selectedColIndexes;
    const firstRow = tableRef.querySelector('tr');
    const hasHeaderRow = firstRow ? firstRow.getAttribute('data-header-row') : false;
    const rowControlStickyTop = 45;
    const marginTop = hasHeaderRow && stickyTop !== undefined ? rowControlStickyTop ?? 0 : 0;
    const handleClick = (0, $fc4bM.useCallback)((event)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const isClickOutsideSelectedCols = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.length >= 1 && !selectedColIndexes.includes(colIndex);
        if (!selectedColIndexes || selectedColIndexes.length === 0 || isClickOutsideSelectedCols) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $8L6TV.selectColumn)(colIndex, event.shiftKey)(state, dispatch);
        if (selectedColIndexes.length > 1 && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedColIndexes.includes(colIndex) && !event.shiftKey) (0, $8L6TV.selectColumns)(selectedColIndexes)(state, dispatch);
    }, [
        colIndex,
        selectedColIndexes,
        editorView
    ]);
    const handleMouseOver = (0, $fc4bM.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $EwLhB.hoverColumns)([
            colIndex
        ])(state, dispatch);
    }, [
        colIndex,
        editorView
    ]);
    const handleMouseMove = (0, $fc4bM.useCallback)((e)=>{
        const isParentDragControls = e.nativeEvent.target.closest(`.${(0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS}`);
        const colIndex = e.nativeEvent.target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !colIndex) return;
        // update hovered cell location
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the column drag handle then we're technically
        // also hovering over row 0 index. And vice-versa with rows. This means we don't need to worry about knowing the
        // current row index. We can just force it to 0.
        (0, $EwLhB.hoverCell)(0, Number(colIndex))(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseOut = (0, $fc4bM.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $EwLhB.clearHoverSelection)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const toggleDragMenuHandler = (0, $fc4bM.useCallback)((trigger, event, handleIndex)=>{
        var _api$analytics2;
        if (event !== null && event !== void 0 && event.shiftKey) return;
        const { state: state, dispatch: dispatch } = editorView;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            // Use the clicked handle index because `hoveredCell` can point at a merged cell's first column.
            const targetColIndex = handleIndex ?? colIndex;
            if (targetColIndex !== undefined && api) {
                const { activeTableMenu: currentActiveTableMenu } = (0, $4GJqd.getPluginState)(state);
                const isSameActiveMenu = (currentActiveTableMenu === null || currentActiveTableMenu === void 0 ? void 0 : currentActiveTableMenu.type) === 'column' && currentActiveTableMenu.index === targetColIndex;
                api.core.actions.execute(({ tr: tr })=>{
                    if (!isSameActiveMenu) {
                        var _api$analytics;
                        (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
                            action: (0, $8d4kB.TABLE_ACTION).DRAG_MENU_OPENED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                            actionSubjectId: null,
                            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                            attributes: {
                                inputMethod: trigger === 'keyboard' ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE,
                                direction: 'column'
                            }
                        })(tr);
                    }
                    (0, $gzpzh.toggleActiveTableMenu)({
                        type: 'column',
                        index: targetColIndex,
                        openedBy: trigger
                    }, currentActiveTableMenu, api)({
                        tr: tr
                    });
                    return tr;
                });
            }
            return;
        }
        (0, $cwJ2b.toggleDragMenuWithAnalytics)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)(undefined, 'column', colIndex, trigger)(state, dispatch);
    }, [
        editorView,
        colIndex,
        api
    ]);
    const colIndexes = (0, $fc4bM.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            colIndex
        ];
    }, [
        colIndex
    ]);
    if (stickyTop && columnControlsRef.current) columnControlsRef.current.scrollLeft = (getScrollOffset === null || getScrollOffset === void 0 ? void 0 : getScrollOffset()) ?? 0;
    const generateHandleByType = (type, appearance, gridColumn, indexes)=>{
        const isHover = type === 'hover';
        const isPlaceholder = appearance === 'placeholder';
        const previewHeight = (rowHeights === null || rowHeights === void 0 ? void 0 : rowHeights.reduce((sum, cur)=>sum + cur, 0)) ?? 0;
        const previewWidth = (colWidths === null || colWidths === void 0 ? void 0 : colWidths.reduce((sum, v, i)=>sum + (v ?? (0, $jd8X7.tableCellMinWidth)) * (indexes.includes(i) ? 1 : 0), 0)) ?? (0, $jd8X7.tableCellMinWidth);
        return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            contentEditable: false,
            style: {
                gridColumn: gridColumn,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridRow: '1',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                justifyContent: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                alignItems: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: 'fit-content',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                placeSelf: 'center',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                zIndex: 99,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                pointerEvents: isPlaceholder ? 'none' : undefined
            },
            "data-testid": `table-floating-column-${isHover ? colIndex : isPlaceholder ? appearance : renderedSelectedColIndexes[0]}-drag-handle`,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1y1ip.DragHandle), {
                api: api,
                isDragMenuTarget: !isHover,
                direction: "column",
                tableLocalId: localId || '',
                indexes: indexes,
                hoveredCell: hoveredCell,
                previewWidth: previewWidth,
                forceDefaultHandle: !isHover,
                previewHeight: previewHeight,
                appearance: appearance,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                onBlur: handleMouseOut,
                onFocus: handleMouseOver,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const columnHandles = ()=>{
        const handles = [];
        const isColumnSelected = renderedSelectedColIndexes.length > 0;
        const isEntireTableSelected = (colWidths || []).length > renderedSelectedColIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isColumnSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        handles.push(generateHandleByType('selected', selectedAppearance, // always position placeholder in first column to avoid overflow issues
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${renderedSelectedColIndexes[0] + 1} / span ${renderedSelectedColIndexes.length}`, renderedSelectedColIndexes));
        if (hoveredCell && isTableHovered && colIndex !== undefined && !renderedSelectedColIndexes.includes(colIndex)) handles.push(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        generateHandleByType('hover', 'default', `${colIndex + 1} / span 1`, colIndexes));
        return handles;
    };
    const containerWidth = isNumberColumnEnabled && tableContainerWidth ? tableContainerWidth - (0, $014x6.akEditorTableNumberColumnWidth) : tableContainerWidth;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS,
        onMouseMove: handleMouseMove,
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
            ref: columnControlsRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls",
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridTemplateColumns: widths,
                marginTop: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginTop,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                width: stickyTop ? containerWidth : undefined,
                overflowX: stickyTop ? 'hidden' : 'visible',
                pointerEvents: isDragging ? 'none' : undefined
            },
            children: [
                columnParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>/*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                        style: {
                            gridColumn: `${startIndex + 1} / span 1`
                        },
                        "data-start-index": startIndex,
                        "data-end-index": endIndex,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER,
                        contentEditable: false,
                        children: [
                            index === 0 && /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: {
                                    left: '0',
                                    right: 'auto'
                                }
                            }),
                            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                style: columnParams.length - 1 === index ? {
                                    right: '0'
                                } : {}
                            })
                        ]
                    }, index)),
                columnHandles()
            ]
        })
    });
};

});
parcelRegister("1y1ip", function(module, exports) {
$parcel$export(module.exports, "DragHandle", () => $699d4b3d333462e8$export$a0c24614540b0efb);
/* eslint-disable @atlaskit/design-system/no-html-button */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $jyPR0 = parcelRequire("jyPR0");

var $fcCIH = parcelRequire("fcCIH");

var $dqFZv = parcelRequire("dqFZv");

var $lqHJB = parcelRequire("lqHJB");

var $801jp = parcelRequire("801jp");

var $5n2u9 = parcelRequire("5n2u9");

var $dpooP = parcelRequire("dpooP");

var $c8sLM = parcelRequire("c8sLM");

var $l2xrI = parcelRequire("l2xrI");

var $aEmSo = parcelRequire("aEmSo");

var $gzpzh = parcelRequire("gzpzh");

var $HfCkc = parcelRequire("HfCkc");

var $1l6nN = parcelRequire("1l6nN");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $du2bK = parcelRequire("du2bK");

var $6G4uT = parcelRequire("6G4uT");
const $699d4b3d333462e8$var$DragHandleComponent = ({ api: api, isDragMenuTarget: isDragMenuTarget, tableLocalId: tableLocalId, direction: direction = 'row', appearance: appearance = 'default', indexes: indexes, forceDefaultHandle: forceDefaultHandle = false, previewWidth: previewWidth, previewHeight: previewHeight, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, toggleDragMenu: toggleDragMenu, hoveredCell: hoveredCell, onClick: onClick, editorView: editorView, intl: { formatMessage: formatMessage } })=>{
    const dragHandleDivRef = (0, $fc4bM.useRef)(null);
    const [previewContainer, setPreviewContainer] = (0, $fc4bM.useState)(null);
    const { state: state, state: { selection: selection } } = editorView;
    const { isDragMenuOpen: isDragMenuOpen = false } = (0, $HfCkc.getPluginState)(state);
    const [isHovered, setIsHovered] = (0, $fc4bM.useState)(false);
    const isRow = direction === 'row';
    const isColumn = direction === 'column';
    const hasMergedCells = (0, $fc4bM.useMemo)(()=>{
        const table = (0, $5n2u9.findTable)(selection);
        if (!table) return false;
        const map = (0, $dpooP.TableMap).get(table === null || table === void 0 ? void 0 : table.node);
        if (!map.hasMergedCells() || indexes.length < 1) return false;
        const { mapByColumn: mapByColumn, mapByRow: mapByRow } = map;
        // this handle when hover to first column or row which has merged cells.
        if (hoveredCell && hoveredCell.rowIndex !== undefined && hoveredCell.colIndex !== undefined && selection instanceof (0, $801jp.TextSelection)) {
            const { rowIndex: rowIndex, colIndex: colIndex } = hoveredCell;
            const mergedPositionInRow = (0, $1l6nN.findDuplicatePosition)(mapByRow[rowIndex]);
            const mergedPositionInCol = (0, $1l6nN.findDuplicatePosition)(mapByColumn[colIndex]);
            const hasMergedCellsInFirstRowOrColumn = direction === 'column' ? mergedPositionInRow.includes(mapByRow[0][colIndex]) : mergedPositionInCol.includes(mapByColumn[0][rowIndex]);
            const isHoveredOnFirstRowOrColumn = direction === 'column' ? hoveredCell.rowIndex === 0 && hasMergedCellsInFirstRowOrColumn : hoveredCell.colIndex === 0 && hasMergedCellsInFirstRowOrColumn;
            if (isHoveredOnFirstRowOrColumn) {
                const mergedSizes = direction === 'column' ? mapByRow[0].filter((el)=>el === mapByRow[0][colIndex]).length : mapByColumn[0].filter((el)=>el === mapByColumn[0][rowIndex]).length;
                const mergedSelection = (0, $1l6nN.hasMergedCellsInSelection)(direction === 'column' ? [
                    colIndex,
                    colIndex + mergedSizes - 1
                ] : [
                    rowIndex,
                    rowIndex + mergedSizes - 1
                ], direction)(selection);
                return mergedSelection;
            }
        }
        return (0, $1l6nN.hasMergedCellsInSelection)(indexes, direction)(selection);
    }, [
        indexes,
        selection,
        direction,
        hoveredCell
    ]);
    const handleIconProps = {
        forceDefaultHandle: forceDefaultHandle,
        isHandleHovered: isHovered,
        hasMergedCells: hasMergedCells
    };
    (0, $fc4bM.useEffect)(()=>{
        const dragHandleDivRefCurrent = dragHandleDivRef.current;
        const browser = (0, $dqFZv.getBrowserInfo)();
        if (dragHandleDivRefCurrent) return (0, $c8sLM.draggable)({
            element: dragHandleDivRefCurrent,
            canDrag: ()=>{
                return !hasMergedCells;
            },
            getInitialData () {
                return {
                    localId: tableLocalId,
                    type: `table-${direction}`,
                    indexes: indexes
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $l2xrI.setCustomNativeDragPreview)({
                    getOffset: ({ container: container })=>{
                        const rect = container.getBoundingClientRect();
                        if (browser.safari) // See: https://product-fabric.atlassian.net/browse/ED-21442
                        // We need to ensure that the preview is not overlaying screen content when the snapshot is taken, otherwise
                        // safari will composite the screen text elements into the bitmap snapshot. The container is a wrapper which is already
                        // positioned fixed at top/left 0.
                        // IMPORTANT: we must not exceed more then the width of the container off-screen otherwise not preview will
                        // be generated.
                        container.style.left = `-${rect.width - 0.0001}px`;
                        if (isRow) return {
                            x: 12,
                            y: rect.height / 2
                        };
                        else return {
                            x: rect.width / 2 + 4,
                            y: 12
                        };
                    },
                    render: function render({ container: container }) {
                        setPreviewContainer(container);
                        return ()=>setPreviewContainer(null);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        });
    }, [
        tableLocalId,
        direction,
        indexes,
        isRow,
        editorView.state.selection,
        hasMergedCells
    ]);
    const showDragMenuAnchorId = isRow ? 'drag-handle-button-row' : 'drag-handle-button-column';
    const browser = (0, $dqFZv.getBrowserInfo)();
    // Clicking the drag handle's clickable zone is a plain row/column selection (not the menu
    // trigger), so the selection toolbar should appear. The floating menu defers closing for clicks
    // inside the drag controls, so we close it here and reset the user intent to 'default' (in the
    // same transaction) so the toolbar is shown.
    const closeActiveDragMenuAndShowToolbar = (0, $fc4bM.useCallback)(()=>{
        var _api$table, _api$core;
        if (!api) return;
        const activeTableMenu = (_api$table = api.table) === null || _api$table === void 0 || (_api$table = _api$table.sharedState.currentState()) === null || _api$table === void 0 ? void 0 : _api$table.activeTableMenu;
        const isActiveTableMenuOpen = (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'row' || (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'column';
        if (!isActiveTableMenuOpen) return;
        (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
            var _api$userIntent;
            (0, $gzpzh.closeActiveTableMenu)(api, {
                skipUserIntent: true
            })({
                tr: tr
            });
            (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || _api$userIntent.commands.setCurrentUserIntent('default')({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    const keepActiveDragMenuOrHideToolbar = (0, $fc4bM.useCallback)(()=>{
        var _api$table2, _api$core2;
        if (!api) return;
        const activeTableMenu = (_api$table2 = api.table) === null || _api$table2 === void 0 || (_api$table2 = _api$table2.sharedState.currentState()) === null || _api$table2 === void 0 ? void 0 : _api$table2.activeTableMenu;
        const isActiveTableMenuOpen = (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'row' || (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'column';
        (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>{
            var _api$userIntent2;
            (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || _api$userIntent2.commands.setCurrentUserIntent(isActiveTableMenuOpen ? 'tableDragMenuPopupOpen' : 'dragHandleSelected')({
                tr: tr
            });
            return tr;
        });
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("button", {
                type: "button",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE,
                "data-testid": "table-drag-handle-clickable-zone-button",
                style: {
                    height: isRow ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $4Tw3G.dragTableInsertColumnButtonSize}px)` : `${"var(--ds-space-200, 16px)"}`,
                    // 16px here because it's the size of drag handle button's large side
                    width: isRow ? `${"var(--ds-space-200, 16px)"}` // 16px here because it's the size of drag handle button's large side
                     : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    `calc(100% - ${0, $4Tw3G.dragTableInsertColumnButtonSize}px)`,
                    left: isRow ? `${"var(--ds-space-050, 4px)"}` : undefined,
                    bottom: isColumn ? `${"var(--ds-space-0, 0px)"}` : undefined,
                    alignSelf: isColumn ? 'none' : 'center',
                    zIndex: isColumn ? '-1' : 'auto',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    pointerEvents: 'auto'
                },
                onMouseUp: (e)=>{
                    // should toggle menu if current drag menu open.
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) // New menu: close the open row/column menu (and show the selection toolbar).
                    closeActiveDragMenuAndShowToolbar();
                    else if (isDragMenuOpen) toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                "aria-label": formatMessage((0, $lqHJB.messages).dragHandleZone)
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("button", {
                type: "button",
                id: isDragMenuTarget ? showDragMenuAnchorId : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, appearance, {
                    [(0, $YREXK.TableCssClassName).DRAG_HANDLE_DISABLED]: hasMergedCells
                }),
                ref: dragHandleDivRef,
                style: {
                    transform: isColumn ? 'none' : 'rotate(90deg)',
                    alignSelf: isColumn ? 'none' : 'center'
                },
                "data-testid": "table-drag-handle-button",
                "aria-label": formatMessage(isRow ? (0, $lqHJB.messages).rowDragHandle : (0, $lqHJB.messages).columnDragHandle),
                "aria-expanded": isDragMenuOpen && isDragMenuTarget ? 'true' : 'false',
                "aria-haspopup": "menu",
                onMouseOver: (e)=>{
                    setIsHovered(true);
                    onMouseOver && onMouseOver(e);
                },
                onMouseOut: (e)=>{
                    setIsHovered(false);
                    onMouseOut && onMouseOut(e);
                },
                onFocus: onFocus,
                onBlur: onBlur,
                onMouseUp: (e)=>{
                    // return focus to editor so copying table selections whilst still works, i cannot call e.preventDefault in a mousemove event as this stops dragstart events from firing
                    // -> this is bad for a11y but is the current standard new copy/paste keyboard shortcuts should be introduced instead
                    editorView.focus();
                    if (e.shiftKey) {
                        keepActiveDragMenuOrHideToolbar();
                        return;
                    }
                    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) toggleDragMenu && toggleDragMenu('mouse', e, indexes[0]);
                    else toggleDragMenu && toggleDragMenu('mouse', e);
                },
                onClick: onClick,
                onKeyDown: (e)=>{
                    if (e.key === 'Enter' || e.key === ' ') {
                        if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) toggleDragMenu && toggleDragMenu('keyboard', undefined, indexes[0]);
                        else toggleDragMenu && toggleDragMenu('keyboard');
                    }
                },
                children: appearance !== 'placeholder' ? //  cannot block pointer events in Firefox as it breaks Dragging functionality
                browser.gecko ? // Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6G4uT.HandleIconComponent), {
                    ...handleIconProps
                }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    style: {
                        pointerEvents: 'none'
                    },
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6G4uT.HandleIconComponent), {
                        ...handleIconProps
                    })
                }) : null
            }),
            previewContainer && previewWidth !== undefined && previewHeight !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bTkYf))).createPortal(/*#__PURE__*/ (0, $3LM7S.jsx)((0, $du2bK.DragPreview), {
                direction: direction,
                width: previewWidth,
                height: previewHeight
            }), previewContainer)
        ]
    });
};
const $699d4b3d333462e8$export$a0c24614540b0efb = (0, $fcCIH.default)($699d4b3d333462e8$var$DragHandleComponent);

});
parcelRegister("du2bK", function(module, exports) {
$parcel$export(module.exports, "DragPreview", () => $ee7e06d897b696ae$export$905ab40ac2179daa);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $dhRZd = parcelRequire("dhRZd");
const $ee7e06d897b696ae$var$boxStyles = (0, $kig2V.xcss)({
    borderColor: 'color.border.focused',
    borderStyle: 'solid',
    borderRadius: 'radius.small',
    borderWidth: 'border.width.focused',
    backgroundColor: 'color.blanket.selected'
});
const $ee7e06d897b696ae$export$905ab40ac2179daa = ({ direction: direction, width: width, height: height })=>{
    const marginLeft = direction === 'row' ? -14 : width / 2 - 14;
    const marginTop = direction === 'row' ? height / 2 - 14 : -10;
    const transform = direction === 'row' ? 'rotate(90deg)' : 'none';
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        xcss: $ee7e06d897b696ae$var$boxStyles,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        style: {
            width: `${width}px`,
            height: `${height}px`
        },
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dhRZd.DragInMotionIcon), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `${marginLeft}px`,
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: `${marginTop}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                transform: transform
            }
        })
    });
};

});
parcelRegister("dhRZd", function(module, exports) {
$parcel$export(module.exports, "DragInMotionIcon", () => $bcda67ad7e5087ee$export$227151c7eab30def);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $bcda67ad7e5087ee$export$227151c7eab30def = ({ style: style })=>/*#__PURE__*/ (0, $3LM7S.jsxs)("svg", {
        width: "28",
        height: "20",
        viewBox: "0 0 28 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                fill: "var(--ds-background-accent-blue-subtle, #669DF1)"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                x: "9",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                x: "13",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                x: "17",
                y: "6",
                width: "2",
                height: "8",
                rx: "1",
                fill: "var(--ds-border-inverse, #FFFFFF)"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                x: "1",
                y: "1",
                width: "26",
                height: "18",
                rx: "5",
                stroke: "var(--ds-border-inverse, #FFFFFF)",
                strokeWidth: "2"
            })
        ]
    });

});


parcelRegister("6G4uT", function(module, exports) {
$parcel$export(module.exports, "HandleIconComponent", () => $9a01e86050cbdd34$export$8749e1cb5c52435f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $4z77n = parcelRequire("4z77n");

var $2ptjU = parcelRequire("2ptjU");

var $h59kS = parcelRequire("h59kS");
const $9a01e86050cbdd34$export$8749e1cb5c52435f = (props)=>{
    const { forceDefaultHandle: forceDefaultHandle, isHandleHovered: isHandleHovered, hasMergedCells: hasMergedCells } = props;
    if (isHandleHovered || forceDefaultHandle) return hasMergedCells ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $4z77n.DragHandleDisabledIcon), {}) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2ptjU.DragHandleIcon), {});
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $h59kS.MinimisedHandleIcon), {});
};

});
parcelRegister("4z77n", function(module, exports) {
$parcel$export(module.exports, "DragHandleDisabledIcon", () => $41d1b6b53389411c$export$b005cb3a0f2a5647);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $41d1b6b53389411c$export$b005cb3a0f2a5647 = ({ style: style })=>/*#__PURE__*/ (0, $3LM7S.jsxs)("svg", {
        width: "24",
        height: "16",
        viewBox: "0 0 24 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "drag-icon-disabled",
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                        x: "7",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                        x: "11",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                        x: "15",
                        y: "4",
                        width: "2",
                        height: "8",
                        rx: "1"
                    })
                ]
            })
        ]
    });

});

parcelRegister("2ptjU", function(module, exports) {
$parcel$export(module.exports, "DragHandleIcon", () => $3f2dbe3334460286$export$7d3bc85820ac4455);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");
const $3f2dbe3334460286$export$7d3bc85820ac4455 = ()=>/*#__PURE__*/ (0, $3LM7S.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "16",
        fill: "none",
        "data-testid": "drag-icon-enabled",
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
                width: "24",
                height: "16",
                rx: "4"
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)("g", {
                children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                    d: "M9 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM9 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM17 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 10a1 1 0 1 0-2 0 1 1 0 0 0 2 0ZM13 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z"
                })
            })
        ]
    });

});

parcelRegister("h59kS", function(module, exports) {
$parcel$export(module.exports, "MinimisedHandleIcon", () => $f4ff89b58d6ca2d9$export$e32dc8bb64018ca1);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $YREXK = parcelRequire("YREXK");
const $f4ff89b58d6ca2d9$export$e32dc8bb64018ca1 = ()=>/*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "5",
        fill: "none",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("rect", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).DRAG_HANDLE_MINIMISED,
            width: "24",
            height: "5",
            rx: "3"
        })
    });

});




parcelRegister("7iMZj", function(module, exports) {
$parcel$export(module.exports, "ColumnDropTargets", () => $99fa737228b7af1d$export$9878f6beafc50edd);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $YREXK = parcelRequire("YREXK");

var $fIoi4 = parcelRequire("fIoi4");
const $99fa737228b7af1d$export$9878f6beafc50edd = ({ tableRef: tableRef, tableHeight: tableHeight, localId: localId, colWidths: colWidths, isHeaderSticky: isHeaderSticky, getScrollOffset: getScrollOffset })=>{
    const dropTargetRef = (0, $fc4bM.useRef)(null);
    if (!tableRef) return null;
    if (isHeaderSticky && dropTargetRef.current) dropTargetRef.current.style.marginLeft = `-${(getScrollOffset === null || getScrollOffset === void 0 ? void 0 : getScrollOffset()) ?? 0}px`;
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS,
        contentEditable: false,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER,
            "data-testid": "table-floating-column-controls-drop-targets",
            children: colWidths === null || colWidths === void 0 ? void 0 : colWidths.map((width, index)=>{
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fIoi4.ColumnDropTarget), {
                    index: index,
                    localId: localId,
                    width: width,
                    height: tableHeight,
                    marginTop: 0
                }, index);
            })
        })
    });
};

});
parcelRegister("fIoi4", function(module, exports) {
$parcel$export(module.exports, "ColumnDropTarget", () => $7159084a348ffe3b$export$e8a325e09c5453d5);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $ar7hH = parcelRequire("ar7hH");

var $c8sLM = parcelRequire("c8sLM");

var $6ypSG = parcelRequire("6ypSG");
const $7159084a348ffe3b$export$e8a325e09c5453d5 = ({ index: index, localId: localId, width: width, height: height, marginTop: marginTop })=>{
    const dropTargetRef = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $c8sLM.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                var _data$indexes, _data$indexes2;
                const data = source.data;
                const behaviour = (0, $6ypSG.getDragBehaviour)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? ((_data$indexes = data.indexes) === null || _data$indexes === void 0 ? void 0 : _data$indexes.indexOf(index)) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-column' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!((_data$indexes2 = data.indexes) !== null && _data$indexes2 !== void 0 && _data$indexes2.length) && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $6ypSG.getDragBehaviour)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                var _srcData$indexes;
                const data = {
                    localId: localId,
                    type: 'table-column',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $6ypSG.getDragBehaviour)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? (_srcData$indexes = srcData.indexes) === null || _srcData$indexes === void 0 ? void 0 : _srcData$indexes.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'left',
                    'right'
                ]) : [
                    'left',
                    'right'
                ];
                return (0, $ar7hH.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: dropTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            width: width && `${width - 1}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            height: height && `${height}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            marginTop: marginTop && `${marginTop}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexShrink: 0
        },
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-column-controls-drop-target"
    });
};

});



parcelRegister("lrMIT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a07674455ce4e434$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $dqFZv = parcelRequire("dqFZv");

var $EwLhB = parcelRequire("EwLhB");
var $8L6TV = parcelRequire("8L6TV");

var $YREXK = parcelRequire("YREXK");

var $lVtgK = parcelRequire("lVtgK");

var $jERbE = parcelRequire("jERbE");
const $a07674455ce4e434$export$1e425115e5c75aac = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, isInDanger: isInDanger, isResizing: isResizing, isNumberColumnEnabled: isNumberColumnEnabled, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, hasHeaderRow: hasHeaderRow, hoveredRows: hoveredRows, stickyHeader: stickyHeader, hoveredCell: hoveredCell, isTableHovered: isTableHovered, tableWrapperWidth: tableWrapperWidth, api: api, isChromelessEditor: isChromelessEditor })=>{
    const _selectRow = (0, $fc4bM.useCallback)((row, expand)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $dqFZv.getBrowserInfo)();
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $8L6TV.selectRow)(row, expand)(state, dispatch);
    }, [
        editorView
    ]);
    const _selectRows = (0, $fc4bM.useCallback)((rowIndexes)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const browser = (0, $dqFZv.getBrowserInfo)();
        if (browser.ie_version === 11) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        editorView.dom.blur();
        (0, $8L6TV.selectRows)(rowIndexes)(state, dispatch);
    }, [
        editorView
    ]);
    const _hoverRows = (0, $fc4bM.useCallback)((rows, danger)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $EwLhB.hoverRows)(rows, danger)(state, dispatch);
    }, [
        editorView
    ]);
    // re-use across numbered columns and row controls
    const updateCellHoverLocation = (0, $fc4bM.useCallback)((rowIndex)=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (tableActive) // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
        // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
        // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
        // current column index. We can just force it to 0.
        (0, $EwLhB.hoverCell)(rowIndex, 0)(state, dispatch);
    }, [
        editorView,
        tableActive
    ]);
    if (!tableRef) return null;
    const stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
    const wrapperClassName = isDragAndDropEnabled ? isChromelessEditor ? (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER + ' ' + (0, $YREXK.TableCssClassName).TABLE_CHROMELESS : (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER;
    return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: wrapperClassName
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        role: "none",
        onMouseDown: (e)=>!isDragAndDropEnabled && e.preventDefault()
    }, isNumberColumnEnabled ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $lVtgK.default), {
        editorView: editorView,
        hoverRows: _hoverRows,
        tableRef: tableRef,
        tableActive: tableActive,
        hoveredRows: hoveredRows,
        hasHeaderRow: hasHeaderRow,
        isInDanger: isInDanger,
        isResizing: isResizing,
        selectRow: _selectRow,
        updateCellHoverLocation: updateCellHoverLocation,
        stickyTop: stickyTop,
        isDragAndDropEnabled: isDragAndDropEnabled
    }) : null, tableActive && /*#__PURE__*/ (0, $jctmk.jsx)((0, $fc4bM.Fragment), null, /*#__PURE__*/ (0, $jctmk.jsx)((0, $jERbE.DragControlsWithSelection), {
        tableRef: tableRef,
        tableNode: tableNode,
        hoveredCell: hoveredCell,
        isTableHovered: isTableHovered,
        editorView: editorView,
        tableActive: tableActive,
        isInDanger: isInDanger,
        isResizing: isResizing,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tableWidth: tableWrapperWidth,
        hoverRows: _hoverRows,
        selectRow: _selectRow,
        selectRows: _selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api
    }))));
};
var $a07674455ce4e434$export$2e2bcd8739ae039 = $a07674455ce4e434$export$1e425115e5c75aac;

});
parcelRegister("lVtgK", function(module, exports) {
$parcel$export(module.exports, "default", () => $c95397c0d733cdeb$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jyPR0 = parcelRequire("jyPR0");

var $eVKpX = parcelRequire("eVKpX");

var $he7e7 = parcelRequire("he7e7");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $eEepd = parcelRequire("eEepd");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");
class $c95397c0d733cdeb$export$2e2bcd8739ae039 extends (0, $fc4bM.Component) {
    render() {
        const { tableRef: tableRef, hasHeaderRow: hasHeaderRow, isDragAndDropEnabled: isDragAndDropEnabled, tableActive: tableActive, updateCellHoverLocation: updateCellHoverLocation } = this.props;
        const rowHeights = (0, $eEepd.getRowHeights)(tableRef);
        const renderedRowNumberLabels = (0, $dRkX9.fg)('platform_editor_ai_show_diff_patch_2') ? (0, $eEepd.getRenderedRowNumberLabels)(tableRef, hasHeaderRow) : undefined;
        const getMarginTop = ()=>{
            if (!hasHeaderRow || this.props.stickyTop === undefined) return undefined;
            // with platform_editor_table_q4_loveability enabled, table controls have margin-top of 1px applied. Offset this here.
            return rowHeights[0] + 1;
        };
        if ((0, $eVKpX.isSSR)()) return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? getMarginTop() : hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: isDragAndDropEnabled && tableActive && !(0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `1px solid ${0, $4Tw3G.tableBorderColor}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'hidden' // Ensure the column is not visible during SSR
            },
            contentEditable: false
        });
        return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).NUMBERED_COLUMN,
            style: {
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginTop: (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? getMarginTop() : hasHeaderRow && this.props.stickyTop !== undefined ? rowHeights[0] : undefined,
                borderLeft: isDragAndDropEnabled && tableActive && !(0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `1px solid ${0, $4Tw3G.tableBorderColor}` : undefined,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                visibility: 'visible'
            },
            contentEditable: false,
            children: rowHeights.map((rowHeight, index)=>{
                const rowNumberLabel = (0, $dRkX9.fg)('platform_editor_ai_show_diff_patch_2') ? renderedRowNumberLabels === null || renderedRowNumberLabels === void 0 ? void 0 : renderedRowNumberLabels[index] : hasHeaderRow ? index > 0 ? index : null : index + 1;
                return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: this.getClassNames(index, true),
                    "data-index": index,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: this.getCellStyles(index, rowHeight),
                    onFocus: ()=>updateCellHoverLocation(index),
                    onMouseOver: ()=>updateCellHoverLocation(index),
                    children: rowNumberLabel
                }, `wrapper-${index}`);
            })
        });
    }
    constructor(...args){
        super(...args), this.getCellStyles = (index, rowHeight)=>{
            const { stickyTop: stickyTop, hasHeaderRow: hasHeaderRow } = this.props;
            if (stickyTop && hasHeaderRow && index === 0) {
                const topOffset = 0;
                return {
                    height: rowHeight,
                    top: `${topOffset}px`
                };
            }
            return {
                height: rowHeight
            };
        }, this.getClassNames = (index, isButtonDisabled = false)=>{
            const { hoveredRows: hoveredRows, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, tableActive: tableActive } = this.props;
            const isActive = (0, $he7e7.isRowSelected)(index)(editorView.state.selection) || (hoveredRows || []).indexOf(index) !== -1 && !isResizing;
            return (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, {
                [(0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED]: isButtonDisabled,
                [(0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER]: tableActive && isActive && isInDanger,
                [(0, $YREXK.TableCssClassName).HOVERED_CELL_ACTIVE]: tableActive && isActive
            });
        };
    }
}

});

parcelRegister("jERbE", function(module, exports) {
$parcel$export(module.exports, "DragControlsWithSelection", () => $34e0b40c5bc64c7c$export$8bade456cc132de4);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $9oAqi = parcelRequire("9oAqi");

var $ev7OZ = parcelRequire("ev7OZ");

var $l5gi8 = parcelRequire("l5gi8");

var $c8sLM = parcelRequire("c8sLM");

var $aEmSo = parcelRequire("aEmSo");

var $EwLhB = parcelRequire("EwLhB");
var $gzpzh = parcelRequire("gzpzh");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $eEepd = parcelRequire("eEepd");

var $2q9QJ = parcelRequire("2q9QJ");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $1y1ip = parcelRequire("1y1ip");

var $3t0Wu = parcelRequire("3t0Wu");
const $34e0b40c5bc64c7c$var$getSelectedRows = (selection)=>{
    if (!(selection instanceof (0, $ev7OZ.CellSelection))) return [];
    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        // New behaviour: also treat a row selection that sits to the right of a merged first-column
        // cell as a full row selection.
        if (!selection.isRowSelection() && !(0, $2q9QJ.isRowSelectionWithMergedFirstColumn)(selection)) return [];
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        return rect ? (0, $2q9QJ.getSelectedRowIndexes)(rect) : [];
    }
    // Old behaviour: only standard row selections are recognised.
    if (selection.isRowSelection()) {
        const rect = (0, $l5gi8.getSelectionRect)(selection);
        if (!rect) return [];
        return (0, $2q9QJ.getSelectedRowIndexes)(rect);
    }
    return [];
};
const $34e0b40c5bc64c7c$export$350d0cf1f91b53f4 = ({ tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, hoveredCell: hoveredCell, tableActive: tableActive, editorView: editorView, isInDanger: isInDanger, isResizing: isResizing, isTableHovered: isTableHovered, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api, selection: selection })=>{
    var _tableNode$attrs;
    const [isDragging, setIsDragging] = (0, $fc4bM.useState)(false);
    const rowHeights = (0, $eEepd.getRowHeights)(tableRef);
    const rowsParams = (0, $eEepd.getRowsParams)(rowHeights);
    const heights = rowHeights.map((height)=>`${height - 1}px`).join(' ');
    const selectedRowIndexes = $34e0b40c5bc64c7c$var$getSelectedRows(selection ?? editorView.state.selection);
    const currentNodeLocalId = (tableNode === null || tableNode === void 0 || (_tableNode$attrs = tableNode.attrs) === null || _tableNode$attrs === void 0 ? void 0 : _tableNode$attrs.localId) ?? '';
    (0, $fc4bM.useEffect)(()=>{
        return (0, $c8sLM.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, localId: localId, indexes: indexes } = source.data;
                if (!indexes || !localId || type !== 'table-row') return false;
                const { tableNode: tableNode } = (0, $4GJqd.getPluginState)(editorView.state);
                // If the draggable localId is the same as the current selected table localId then we will allow the monitor
                // watch for changes
                return localId === (tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId);
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        editorView
    ]);
    const toggleDragMenuHandler = (0, $fc4bM.useCallback)((trigger, event, handleIndex)=>{
        var _api$analytics2;
        if (event !== null && event !== void 0 && event.shiftKey) return;
        // Use the clicked handle index because `hoveredCell` can point at a merged cell's first row.
        const rowIndex = handleIndex ?? (hoveredCell === null || hoveredCell === void 0 ? void 0 : hoveredCell.rowIndex);
        if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if (rowIndex !== undefined && api) {
                const { activeTableMenu: currentActiveTableMenu } = (0, $4GJqd.getPluginState)(editorView.state);
                const isSameActiveMenu = (currentActiveTableMenu === null || currentActiveTableMenu === void 0 ? void 0 : currentActiveTableMenu.type) === 'row' && currentActiveTableMenu.index === rowIndex;
                api.core.actions.execute(({ tr: tr })=>{
                    if (!isSameActiveMenu) {
                        var _api$analytics;
                        (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
                            action: (0, $8d4kB.TABLE_ACTION).DRAG_MENU_OPENED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                            actionSubjectId: null,
                            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                            attributes: {
                                inputMethod: trigger === 'keyboard' ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE,
                                direction: 'row'
                            }
                        })(tr);
                    }
                    (0, $gzpzh.toggleActiveTableMenu)({
                        type: 'row',
                        index: rowIndex,
                        openedBy: trigger
                    }, currentActiveTableMenu, api)({
                        tr: tr
                    });
                    return tr;
                });
            }
            return;
        }
        (0, $cwJ2b.toggleDragMenuWithAnalytics)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)(undefined, 'row', rowIndex, trigger)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        hoveredCell === null || hoveredCell === void 0 ? void 0 : hoveredCell.rowIndex,
        api
    ]);
    const rowIndex = hoveredCell === null || hoveredCell === void 0 ? void 0 : hoveredCell.rowIndex;
    const handleMouseOut = (0, $fc4bM.useCallback)(()=>{
        if (tableActive) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $EwLhB.clearHoverSelection)()(state, dispatch);
        }
    }, [
        editorView,
        tableActive
    ]);
    const handleMouseMove = (0, $fc4bM.useCallback)((e)=>{
        const target = e.nativeEvent.target instanceof Element ? e.nativeEvent.target : null;
        const isParentDragControls = target === null || target === void 0 ? void 0 : target.closest(`.${(0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS}`);
        const rowIndex = target === null || target === void 0 ? void 0 : target.getAttribute('data-start-index');
        // avoid updating if event target is not related
        if (!isParentDragControls || !rowIndex) return;
        updateCellHoverLocation(Number(rowIndex));
    }, [
        updateCellHoverLocation
    ]);
    const rowIndexes = (0, $fc4bM.useMemo)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return [
            rowIndex
        ];
    }, [
        rowIndex
    ]);
    const handleMouseOver = (0, $fc4bM.useCallback)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        hoverRows([
            rowIndex
        ]);
    }, [
        hoverRows,
        rowIndex
    ]);
    const handleClick = (0, $fc4bM.useCallback)((e)=>{
        const isClickOutsideSelectedRows = // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectedRowIndexes.length >= 1 && !selectedRowIndexes.includes(rowIndex);
        if (!selectedRowIndexes || selectedRowIndexes.length === 0 || isClickOutsideSelectedRows) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        selectRow(rowIndex, e.shiftKey);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if (selectedRowIndexes.length > 1 && selectedRowIndexes.includes(rowIndex) && !e.shiftKey) selectRows(selectedRowIndexes);
    }, [
        rowIndex,
        selectRow,
        selectRows,
        selectedRowIndexes
    ]);
    const generateHandleByType = (type, appearance, gridRow, indexes)=>{
        const isHover = type === 'hover';
        const previewHeight = rowHeights.reduce((sum, v, i)=>sum + v * (indexes.includes(i) ? 1 : 0), 0);
        return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            style: {
                gridRow: gridRow,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                gridColumn: '2',
                // DragHandle uses `transform: rotate(90)`, which doesn't affect its parent (this div) causing the width of this element to be the true height of the drag handle
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: '9px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: '100%',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'relative',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                right: '-0.5px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                pointerEvents: 'none'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_DRAG_HANDLE,
            "data-testid": `table-floating-row-${isHover ? rowIndex : selectedRowIndexes[0]}-drag-handle`,
            "data-row-index": rowIndex,
            "data-selected-row-index": selectedRowIndexes[0],
            "data-handle-appearance": appearance,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1y1ip.DragHandle), {
                api: api,
                isDragMenuTarget: !isHover,
                direction: "row",
                tableLocalId: currentNodeLocalId,
                indexes: indexes,
                forceDefaultHandle: !isHover,
                previewWidth: tableWidth,
                previewHeight: previewHeight,
                appearance: appearance,
                hoveredCell: hoveredCell,
                onClick: handleClick,
                onMouseOver: handleMouseOver,
                onMouseOut: handleMouseOut,
                onBlur: handleMouseOut,
                onFocus: handleMouseOver,
                toggleDragMenu: toggleDragMenuHandler,
                editorView: editorView
            })
        }, type);
    };
    const rowHandles = ()=>{
        const handles = [];
        const isRowSelected = selectedRowIndexes.length > 0;
        const isEntireTableSelected = rowHeights.length > selectedRowIndexes.length;
        if (!tableActive) return null;
        const selectedAppearance = isRowSelected && isEntireTableSelected ? isInDanger ? 'danger' : 'selected' : 'placeholder';
        // placeholder / selected need to always render at least one handle
        // so it can be focused via keyboard shortcuts
        const selectedGridRow = (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? // New behaviour: always position the placeholder in the first row to avoid an invalid
        // `NaN / span 0` grid placement (which makes the handle disappear) when no rows are selected.
        selectedAppearance === 'placeholder' ? '1 / span 1' : `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}` : // Old behaviour.
        `${selectedRowIndexes[0] + 1} / span ${selectedRowIndexes.length}`;
        handles.push(generateHandleByType('selected', selectedAppearance, selectedGridRow, selectedRowIndexes));
        if (hoveredCell && isTableHovered && rowIndex !== undefined && !selectedRowIndexes.includes(rowIndex) && rowIndex < rowHeights.length) handles.push(generateHandleByType('hover', 'default', `${rowIndex + 1} / span 1`, rowIndexes));
        return handles;
    };
    if (isResizing) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS,
        style: {
            gridTemplateRows: heights,
            gridTemplateColumns: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${0, $4Tw3G.dropTargetExtendedWidth}px ${0, $4Tw3G.dragRowControlsWidth}px ${tableWidth}px` : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            `0px ${0, $4Tw3G.dragRowControlsWidth}px 0px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
            left: isDragging ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `-${(0, $4Tw3G.dropTargetExtendedWidth) + 2}px` : "var(--ds-space-negative-025, -2px)"
        },
        onMouseMove: handleMouseMove,
        contentEditable: false,
        children: [
            rowsParams.map(({ startIndex: startIndex, endIndex: endIndex }, index)=>// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $fc4bM.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                            style: {
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '2'
                            },
                            "data-start-index": startIndex,
                            "data-end-index": endIndex,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER,
                            contentEditable: false,
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                className: (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT
                            })
                        }, `insert-dot-${index}`),
                        isDragging && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3t0Wu.default), {
                            index: index,
                            localId: currentNodeLocalId,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                gridColumn: '1 / span 3',
                                gridRow: `${index + 1} / span 1`,
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                height: '100%',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                pointerEvents: 'auto',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                position: 'relative',
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                                left: "var(--ds-space-negative-100, -8px)"
                            }
                        }, `drop-target-${index}`)
                    ]
                }, index)),
            rowHandles()
        ]
    });
};
const $34e0b40c5bc64c7c$export$8bade456cc132de4 = ({ editorView: editorView, tableRef: tableRef, tableNode: tableNode, tableWidth: tableWidth, tableActive: tableActive, hoveredCell: hoveredCell, isInDanger: isInDanger, isTableHovered: isTableHovered, isResizing: isResizing, hoverRows: hoverRows, selectRow: selectRow, selectRows: selectRows, updateCellHoverLocation: updateCellHoverLocation, api: api })=>{
    const { selection: selection } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'selection'
    ], (states)=>{
        var _states$selectionStat;
        return {
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
        };
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($34e0b40c5bc64c7c$export$350d0cf1f91b53f4, {
        editorView: editorView,
        tableRef: tableRef,
        tableNode: tableNode,
        tableWidth: tableWidth,
        tableActive: tableActive,
        hoveredCell: hoveredCell,
        isInDanger: isInDanger,
        isTableHovered: isTableHovered,
        isResizing: isResizing,
        hoverRows: hoverRows,
        selectRow: selectRow,
        selectRows: selectRows,
        updateCellHoverLocation: updateCellHoverLocation,
        api: api,
        selection: selection
    });
};

});
parcelRegister("3t0Wu", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9c13e1aabdc7151$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $ar7hH = parcelRequire("ar7hH");

var $c8sLM = parcelRequire("c8sLM");

var $6ypSG = parcelRequire("6ypSG");
const $a9c13e1aabdc7151$var$RowDropTarget = ({ index: index, localId: localId, style: style })=>{
    const dropTargetRef = (0, $fc4bM.useRef)(null);
    (0, $fc4bM.useEffect)(()=>{
        if (!dropTargetRef.current) return;
        return (0, $c8sLM.dropTargetForElements)({
            element: dropTargetRef.current,
            canDrop ({ source: source, input: input }) {
                var _data$indexes, _data$indexes2;
                const data = source.data;
                const behaviour = (0, $6ypSG.getDragBehaviour)(input);
                // A move drop is limited too where it can go, however a clone can drop can go anywhere.
                const isDropValid = behaviour === 'move' ? ((_data$indexes = data.indexes) === null || _data$indexes === void 0 ? void 0 : _data$indexes.indexOf(index)) === -1 : behaviour === 'clone';
                return(// Only draggables of row type can be dropped on this target
                data.type === 'table-row' && // Only draggables which came from the same table can be dropped on this target
                data.localId === localId && // Only draggables which DO NOT include this drop targets index can be dropped
                !!((_data$indexes2 = data.indexes) !== null && _data$indexes2 !== void 0 && _data$indexes2.length) && isDropValid);
            },
            getDropEffect: ({ input: input })=>(0, $6ypSG.getDragBehaviour)(input) === 'clone' ? 'copy' : 'move',
            getIsSticky: ()=>true,
            getData ({ source: source, input: input, element: element }) {
                var _srcData$indexes;
                const data = {
                    localId: localId,
                    type: 'table-row',
                    targetIndex: index
                };
                const srcData = source.data;
                const behaviour = (0, $6ypSG.getDragBehaviour)(input);
                // During a move op there's no point in allowing edges to be dropped on which result in no change/move to occur.
                const allowedEdges = behaviour === 'move' ? (_srcData$indexes = srcData.indexes) === null || _srcData$indexes === void 0 ? void 0 : _srcData$indexes.reduce((acc, v)=>{
                    if (v - index === -1) acc.shift();
                    if (v - index === 1) acc.pop();
                    return acc;
                }, [
                    'top',
                    'bottom'
                ]) : [
                    'top',
                    'bottom'
                ];
                return (0, $ar7hH.attachClosestEdge)(data, {
                    input: input,
                    element: element,
                    allowedEdges: allowedEdges
                });
            }
        });
    }, [
        index,
        localId
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: dropTargetRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-drop-target-index": index,
        "data-drop-target-localid": localId,
        "data-testid": "table-floating-row-controls-drop-target"
    });
};
var $a9c13e1aabdc7151$export$2e2bcd8739ae039 = $a9c13e1aabdc7151$var$RowDropTarget;

});



parcelRegister("3UDgX", function(module, exports) {
$parcel$export(module.exports, "ExternalDropTargets", () => $0646f67a8e60739b$export$1041cb8214100cd2);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jd8X7 = parcelRequire("jd8X7");

var $c8sLM = parcelRequire("c8sLM");

var $fQCvF = parcelRequire("fQCvF");

var $4Tw3G = parcelRequire("4Tw3G");

var $fIoi4 = parcelRequire("fIoi4");
const $0646f67a8e60739b$export$1041cb8214100cd2 = ({ editorView: editorView, node: node, getScrollOffset: getScrollOffset, getTableWrapperWidth: getTableWrapperWidth })=>{
    const [isDragging, setIsDragging] = (0, $fc4bM.useState)(false);
    const currentNodeLocalId = node === null || node === void 0 ? void 0 : node.attrs.localId;
    (0, $fc4bM.useEffect)(()=>{
        return (0, $c8sLM.monitorForElements)({
            canMonitor ({ source: source }) {
                const { type: type, indexes: indexes, localId: localId } = source.data;
                return type === 'table-column' && !!(indexes !== null && indexes !== void 0 && indexes.length) && localId === currentNodeLocalId;
            },
            onDragStart () {
                setIsDragging(true);
            },
            onDrop () {
                setIsDragging(false);
            }
        });
    }, [
        currentNodeLocalId,
        editorView
    ]);
    if (!isDragging) return null;
    const colWidths = (0, $fQCvF.getColumnsWidths)(editorView);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        style: {
            width: getTableWrapperWidth(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            top: `-${(0, $4Tw3G.dropTargetExtendedWidth) - (0, $jd8X7.tableMarginTop)}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            pointerEvents: 'auto',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            zIndex: `${(0, $4Tw3G.dropTargetsZIndex)}`
        },
        "data-testid": "table-floating-column-extended-drop-targets",
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'flex',
                // move drop targets based on table wrapper scroll
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                marginLeft: `-${getScrollOffset()}px`
            },
            children: colWidths === null || colWidths === void 0 ? void 0 : colWidths.map((width, index)=>{
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fIoi4.ColumnDropTarget), {
                    index: index,
                    localId: currentNodeLocalId,
                    width: width,
                    height: (0, $4Tw3G.dropTargetExtendedWidth),
                    marginTop: 0
                }, index);
            })
        })
    });
};

});

parcelRegister("iPXmN", function(module, exports) {
$parcel$export(module.exports, "TableContainer", () => $0738176e01c4ee3d$export$f2c3aea42b2a048f);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $jyPR0 = parcelRequire("jyPR0");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $k5JVX = parcelRequire("k5JVX");

var $9oAqi = parcelRequire("9oAqi");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");

var $kfljr = parcelRequire("kfljr");

var $eyG1M = parcelRequire("eyG1M");

var $7SttP = parcelRequire("7SttP");

var $1YIoS = parcelRequire("1YIoS");

var $YREXK = parcelRequire("YREXK");

var $5Yp1l = parcelRequire("5Yp1l");

var $1AG2j = parcelRequire("1AG2j");
const $0738176e01c4ee3d$var$InnerContainer = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ className: className, style: style, node: node, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-number-column": node.attrs.isNumberColumnEnabled,
        "data-layout": node.attrs.layout,
        "data-testid": "table-container",
        children: children
    });
});
const $0738176e01c4ee3d$var$AlignmentTableContainer = ({ node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    const alignment = node.attrs.layout !== (0, $1YIoS.ALIGN_START) ? (0, $1YIoS.ALIGN_CENTER) : (0, $1YIoS.ALIGN_START);
    const { isFullWidthModeEnabled: isFullWidthModeEnabled, wasFullWidthModeEnabled: wasFullWidthModeEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], (states)=>{
        var _states$tableState, _states$tableState2;
        return {
            isFullWidthModeEnabled: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.isFullWidthModeEnabled,
            wasFullWidthModeEnabled: (_states$tableState2 = states.tableState) === null || _states$tableState2 === void 0 ? void 0 : _states$tableState2.wasFullWidthModeEnabled
        };
    });
    (0, $fc4bM.useEffect)(()=>{
        if (editorView && getPos) {
            const { state: state, dispatch: dispatch } = editorView;
            if (wasFullWidthModeEnabled && isFullWidthModeEnabled !== undefined && !isFullWidthModeEnabled && alignment !== (0, $1YIoS.ALIGN_CENTER) && node.attrs.width > (0, $014x6.akEditorDefaultLayoutWidth)) {
                var _pluginInjectionApi$a;
                const pos = getPos && getPos();
                if (typeof pos !== 'number') return;
                (0, $kfljr.setTableAlignmentWithTableContentWithPosWithAnalytics)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)((0, $1YIoS.ALIGN_CENTER), alignment, {
                    pos: pos,
                    node: node
                }, (0, $3LeME.INPUT_METHOD).AUTO, (0, $8d4kB.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorView,
        isFullWidthModeEnabled,
        wasFullWidthModeEnabled,
        node
    ]);
    const style = (0, $fc4bM.useMemo)(()=>{
        return (0, $5Yp1l.getAlignmentStyle)(alignment);
    }, [
        alignment
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        children: children
    });
};
const $0738176e01c4ee3d$var$AlignmentTableContainerWrapper = ({ isTableAlignmentEnabled: isTableAlignmentEnabled, node: node, children: children, pluginInjectionApi: pluginInjectionApi, getPos: getPos, editorView: editorView })=>{
    if (!isTableAlignmentEnabled) return /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        "data-testid": "table-alignment-container",
        "data-ssr-placeholder": `table-${node.attrs.localId}`,
        "data-ssr-placeholder-replace": `table-${node.attrs.localId}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        children: children
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)($0738176e01c4ee3d$var$AlignmentTableContainer, {
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: children
    });
};
const $0738176e01c4ee3d$var$selector = (states)=>({
        tableState: states.tableState,
        editorViewModeState: states.editorViewModeState
    });
const $0738176e01c4ee3d$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
};
const $0738176e01c4ee3d$export$7063e69b8a954175 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ children: children, className: className, node: node, containerWidth: containerWidth, lineLength: lineLength, editorView: editorView, getPos: getPos, tableRef: tableRef, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, tableWrapperHeight: tableWrapperHeight, isWholeTableInDanger: isWholeTableInDanger, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    const containerRef = (0, $fc4bM.useRef)(null);
    const tableWidthRef = (0, $fc4bM.useRef)((0, $014x6.akEditorDefaultLayoutWidth));
    const [resizing, setIsResizing] = (0, $fc4bM.useState)(false);
    const { tableState: tableState, editorViewModeState: editorViewModeState } = (0, $9oAqi.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table',
        'editorViewMode'
    ], $0738176e01c4ee3d$var$selector);
    const isFullWidthModeEnabled = tableState === null || tableState === void 0 ? void 0 : tableState.isFullWidthModeEnabled;
    const isMaxWidthModeEnabled = tableState === null || tableState === void 0 ? void 0 : tableState.isMaxWidthModeEnabled;
    const mode = editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode;
    // If the editor is in max width mode and the table has no width, use the max width value rather than the default table value
    const tableWidth = isMaxWidthModeEnabled && !node.attrs.width ? (0, $eyG1M.TABLE_MAX_WIDTH) : (0, $k5JVX.getTableContainerWidth)(node);
    const updateContainerHeight = (0, $fc4bM.useCallback)((height)=>{
        var _containerRef$current;
        // current StickyHeader State is not stable to be fetch.
        // we need to update stickyHeader plugin to make sure state can be
        //    consistently fetch and refactor below
        const stickyHeaders = (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.getElementsByClassName('pm-table-sticky');
        if (!stickyHeaders || stickyHeaders.length < 1) // when starting to drag, we need to keep the original space,
        // -- When sticky header not appear, margin top(24px) and margin bottom(16px), should be 40px,
        //    1px is border width but collapse make it 0.5.
        // -- When sticky header appear, we should add first row height but reduce
        //    collapsed border
        return typeof height === 'number' ? `${height + 40.5}px` : 'auto';
        else {
            var _containerRef$current2;
            const stickyHeaderHeight = ((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.getElementsByTagName('th')[0].getBoundingClientRect().height) || 0;
            return typeof height === 'number' ? `${height + stickyHeaderHeight + 39.5}px` : 'auto';
        }
    }, []);
    const onResizeStart = (0, $fc4bM.useCallback)(()=>{
        setIsResizing(true);
    }, []);
    const onResizeStop = (0, $fc4bM.useCallback)(()=>{
        setIsResizing(false);
    }, []);
    const updateWidth = (0, $fc4bM.useCallback)((width)=>{
        if (!containerRef.current) return;
        // make sure during resizing
        // the pm-table-resizer-container width is the same as its child div resizer-item
        // otherwise when resize table from wider to narrower , pm-table-resizer-container stays wider
        // and cause the fabric-editor-popup-scroll-parent to overflow
        if (containerRef.current.style.width !== `${width}px`) containerRef.current.style.width = `${width}px`;
    }, []);
    const displayGuideline = (0, $fc4bM.useCallback)((guidelines)=>{
        var _pluginInjectionApi$g;
        return (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$g = pluginInjectionApi.guideline) === null || _pluginInjectionApi$g === void 0 || (_pluginInjectionApi$g = _pluginInjectionApi$g.actions) === null || _pluginInjectionApi$g === void 0 ? void 0 : _pluginInjectionApi$g.displayGuideline(editorView)({
            guidelines: guidelines
        })) ?? false;
    }, [
        pluginInjectionApi,
        editorView
    ]);
    const attachAnalyticsEvent = (0, $fc4bM.useCallback)((payload)=>{
        var _pluginInjectionApi$a2;
        return pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions.attachAnalyticsEvent(payload);
    }, [
        pluginInjectionApi
    ]);
    const displayGapCursor = (0, $fc4bM.useCallback)((toggle)=>{
        var _pluginInjectionApi$c, _pluginInjectionApi$s;
        return (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.core) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$s = pluginInjectionApi.selection) === null || _pluginInjectionApi$s === void 0 ? void 0 : _pluginInjectionApi$s.commands.displayGapCursor(toggle))) ?? false;
    }, [
        pluginInjectionApi
    ]);
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const { width: width, maxResizerWidth: maxResizerWidth } = (0, $fc4bM.useMemo)(()=>{
        let responsiveContainerWidth = 0;
        const padding = $0738176e01c4ee3d$var$getPadding(containerWidth);
        // When Full width or Max width editor enabled, a Mac OS user can change "ak-editor-content-area" width by
        // updating Settings -> Appearance -> Show scroll bars from "When scrolling" to "Always". It causes
        // issues when viwport width is less than full/max width Editor's width. To detect avoid them
        // we need to use lineLength to defined responsiveWidth instead of containerWidth
        // (which does not get updated when Mac setting changes) in Full-width/Max-width editor.
        if (isFullWidthModeEnabled || isMaxWidthModeEnabled) {
            // When: Show scroll bars -> containerWidth = akEditorGutterPadding * 2 + lineLength;
            // When: Always -> containerWidth = akEditorGutterPadding * 2 + lineLength + scrollbarWidth;
            // scrollbarWidth can vary. Values can be 14, 15, 16 and up to 20px;
            // lineLength is undefined on first paint → width: NaN → wrapper expands to page
            // width. rAF col-sizing then runs before the number-column padding and
            // the final shrink, so column widths are locked in wrong.
            // If the value isn't finite we fall back to gutterWidth for that first frame.
            if (isTableScalingEnabled && Number.isFinite(lineLength) && lineLength !== undefined) responsiveContainerWidth = lineLength;
            else responsiveContainerWidth = containerWidth - padding * 2 - (0, $eyG1M.RESIZE_HANDLE_SPACING);
        } else if (isCommentEditor) responsiveContainerWidth = containerWidth - (0, $eyG1M.TABLE_OFFSET_IN_COMMENT_EDITOR);
        else if (isChromelessEditor) // there's no padding included in chromeless appearance, so we need to reduce table
        // width to ensure all controls are visible.
        // use lineLength as the value is updated by scrollbar visibility changes
        responsiveContainerWidth = Number.isFinite(lineLength) && lineLength !== undefined ? lineLength : containerWidth - (0, $eyG1M.RESIZE_HANDLE_SPACING);
        else // 76 is currently an accepted padding value considering the spacing for resizer handle
        // containerWidth = width of a DIV with test id="ak-editor-fp-content-area". It is a parent of
        // a DIV with className="ak-editor-content-area". This DIV has padding left and padding right.
        // padding left = padding right = akEditorGutterPadding = 32
        responsiveContainerWidth = isTableScalingEnabled ? containerWidth - padding * 2 : containerWidth - padding * 2 - (0, $eyG1M.RESIZE_HANDLE_SPACING);
        // Fix for HOT-119925: Ensure table width is properly constrained and responsive
        // For wide tables, ensure they don't exceed container width and can be scrolled
        const calculatedWidth = !node.attrs.width && !isFullPageAppearance ? responsiveContainerWidth : Math.min(tableWidth, responsiveContainerWidth);
        // Ensure minimum width for usability while respecting container constraints
        const width = Math.max(calculatedWidth, Math.min(responsiveContainerWidth * 0.5, 300));
        const maxResizerWidth = !isFullPageAppearance ? responsiveContainerWidth : Math.min(responsiveContainerWidth, (0, $eyG1M.TABLE_MAX_WIDTH));
        return {
            width: width,
            maxResizerWidth: maxResizerWidth
        };
    }, [
        containerWidth,
        isCommentEditor,
        isChromelessEditor,
        isFullWidthModeEnabled,
        isMaxWidthModeEnabled,
        isFullPageAppearance,
        isTableScalingEnabled,
        lineLength,
        node.attrs.width,
        tableWidth
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!isResizing) tableWidthRef.current = width;
    }, [
        width,
        isResizing
    ]);
    // CSS Solution for table resizer container width
    const tableResizerContainerWidth = (0, $fc4bM.useMemo)(()=>{
        return (0, $7SttP.getTableResizerContainerForFullPageWidthInCSS)(node, isTableScalingEnabled);
    }, [
        node,
        isTableScalingEnabled
    ]);
    // CSS Solution for table resizer max width
    const tableResizerMaxWidth = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
        const nonResizingMaxWidth = isFullPageAppearance ? (0, $7SttP.getTableResizerContainerMaxWidthInCSS)(isCommentEditor, isChromelessEditor, isTableScalingEnabled) : maxResizerWidth;
        // isResizing is needed, otherwise we can't resize table.
        // when not resizing, maxWidth is calculated based on the container width via CSS
        return !isResizing ? nonResizingMaxWidth : maxResizerWidth;
    }, [
        isCommentEditor,
        isChromelessEditor,
        isTableScalingEnabled,
        isResizing,
        maxResizerWidth
    ]);
    // TODO: EDITOR-1679 - Add support for lineLength being undefined at runtime.
    const tableResizerProps = {
        width: // The `width` is used for .resizer-item in <TableResizer>, and it has to be a number
        // So we can't use min(var(--ak-editor-table-width), ${tableWidth}px) here
        // We still have to use JS to calculate width
        width,
        maxWidth: tableResizerMaxWidth,
        containerWidth: containerWidth,
        // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- To be fixed in EDITOR-1679
        lineLength: lineLength,
        updateWidth: updateWidth,
        editorView: editorView,
        getPos: getPos,
        node: node,
        tableRef: tableRef,
        displayGuideline: displayGuideline,
        attachAnalyticsEvent: attachAnalyticsEvent,
        displayGapCursor: displayGapCursor,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        isFullWidthModeEnabled: isFullWidthModeEnabled,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        pluginInjectionApi: pluginInjectionApi,
        onResizeStart: onResizeStart,
        onResizeStop: onResizeStop,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor
    };
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $3LM7S.jsx)($0738176e01c4ee3d$var$AlignmentTableContainerWrapper, {
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        node: node,
        pluginInjectionApi: pluginInjectionApi,
        getPos: getPos,
        editorView: editorView,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                '--ak-editor-table-gutter-padding': 'calc(var(--ak-editor--large-gutter-padding) * 2)',
                '--ak-editor-table-width': isFullPageAppearance ? tableResizerContainerWidth : `${tableWidthRef.current}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                width: 'var(--ak-editor-table-width)',
                height: resizing ? updateContainerHeight(tableWrapperHeight ?? 'auto') : 'auto',
                position: isLivePageViewMode ? 'relative' : 'unset'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).TABLE_RESIZER_CONTAINER,
            ref: containerRef,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1AG2j.TableResizer), {
                ...tableResizerProps,
                disabled: isLivePageViewMode,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)($0738176e01c4ee3d$var$InnerContainer, {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: className,
                    node: node,
                    children: children
                })
            })
        })
    });
});
const $0738176e01c4ee3d$export$f2c3aea42b2a048f = ({ children: children, node: node, className: className, containerWidth: { width: editorWidth, lineLength: lineLength }, editorView: editorView, getPos: getPos, tableRef: tableRef, isNested: isNested, tableWrapperHeight: tableWrapperHeight, isResizing: isResizing, pluginInjectionApi: pluginInjectionApi, isWholeTableInDanger: isWholeTableInDanger, isTableResizingEnabled: isTableResizingEnabled, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor })=>{
    if (isTableResizingEnabled && !isNested) return /*#__PURE__*/ (0, $3LM7S.jsx)($0738176e01c4ee3d$export$7063e69b8a954175, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        node: node,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerWidth: editorWidth,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        lineLength: lineLength,
        editorView: editorView,
        getPos: getPos,
        tableRef: tableRef,
        tableWrapperHeight: tableWrapperHeight,
        isResizing: isResizing,
        pluginInjectionApi: pluginInjectionApi,
        isTableScalingEnabled: isTableScalingEnabled,
        allowFixedColumnWidthOption: allowFixedColumnWidthOption,
        isWholeTableInDanger: isWholeTableInDanger,
        isTableAlignmentEnabled: isTableAlignmentEnabled,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor,
        isChromelessEditor: isChromelessEditor,
        children: children
    });
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const resizableTableWidth = isFullPageAppearance ? (0, $7SttP.getTableResizerContainerForFullPageWidthInCSS)(node, isTableScalingEnabled) : `calc(100cqw - calc(var(--ak-editor--large-gutter-padding) * 2))`;
    return /*#__PURE__*/ (0, $3LM7S.jsx)($0738176e01c4ee3d$var$InnerContainer, {
        node: node,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))(className, {
            'less-padding': editorWidth < (0, $014x6.akEditorMobileBreakoutPoint) && !isNested && !isChromelessEditor
        }),
        style: // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: 'inherit',
            marginLeft: isChromelessEditor ? 18 : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--ak-editor-table-width': resizableTableWidth
        },
        children: children
    });
};

});
parcelRegister("1AG2j", function(module, exports) {
$parcel$export(module.exports, "TableResizer", () => $7d2611ed50d6e4f3$export$65233f8d64070eeb);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $PIUl3 = parcelRequire("PIUl3");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $dqFZv = parcelRequire("dqFZv");

var $2Ebrz = parcelRequire("2Ebrz");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $kFIjS = parcelRequire("kFIjS");

var $2Gsu9 = parcelRequire("2Gsu9");

var $jnzAA = parcelRequire("jnzAA");

var $9oAqi = parcelRequire("9oAqi");

var $jGkle = parcelRequire("jGkle");

var $014x6 = parcelRequire("014x6");

var $5n2u9 = parcelRequire("5n2u9");

var $4eT7o = parcelRequire("4eT7o");

var $kaRof = parcelRequire("kaRof");

var $kfljr = parcelRequire("kfljr");

var $8L6TV = parcelRequire("8L6TV");

var $lh6cf = parcelRequire("lh6cf");

var $7Xzpg = parcelRequire("7Xzpg");

var $eyG1M = parcelRequire("eyG1M");

var $9xQxI = parcelRequire("9xQxI");

var $8aCba = parcelRequire("8aCba");

var $1YIoS = parcelRequire("1YIoS");

var $4Bf8g = parcelRequire("4Bf8g");

var $6Mhdl = parcelRequire("6Mhdl");

var $7tq4H = parcelRequire("7tq4H");

var $4Tw3G = parcelRequire("4Tw3G");
const $7d2611ed50d6e4f3$var$RESIZE_STEP_VALUE = 10;
const $7d2611ed50d6e4f3$var$handles = {
    right: true
};
const $7d2611ed50d6e4f3$var$handleStyles = {
    right: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        right: '-14px',
        marginTop: "var(--ds-space-150, 12px)"
    }
};
const $7d2611ed50d6e4f3$var$getResizerHandleHeight = (tableRef)=>{
    const tableHeight = (tableRef === null || tableRef === void 0 ? void 0 : tableRef.clientHeight) ?? 0;
    /*
  - One row table height (minimum possible table height) ~ 45px
  - Two row table height ~ 90px
  - Three row table height ~ 134px
  	In the if below we need to use:
  - > 46 because the height of the table can be a float number like 45.44.
  - < 96 is the height of large resize handle.
   */ if (tableHeight >= 96) return 'large';
    if (tableHeight > 46) return 'medium';
    return 'small';
};
const $7d2611ed50d6e4f3$var$getResizerMinWidth = (node)=>{
    const currentColumnCount = (0, $7Xzpg.getColgroupChildrenLength)(node);
    const minColumnWidth = Math.min(3, currentColumnCount) * (0, $eyG1M.COLUMN_MIN_WIDTH);
    // add an extra pixel as the scale table logic will scale columns to be tableContainerWidth - 1
    // the table can't scale past its min-width, so instead restrict table container min width to avoid that situation
    return minColumnWidth + 1;
};
const $7d2611ed50d6e4f3$var$getPadding = (containerWidth)=>{
    return containerWidth <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
};
const $7d2611ed50d6e4f3$var$getTableMaxWidth = (containerWidth, lineLength, isCommentEditor, isChromelessEditor)=>{
    if (isCommentEditor) return Math.floor(containerWidth - (0, $eyG1M.TABLE_OFFSET_IN_COMMENT_EDITOR));
    else if (isChromelessEditor) return Number.isFinite(lineLength) && lineLength !== undefined ? lineLength : Math.floor(containerWidth - (0, $eyG1M.RESIZE_HANDLE_SPACING));
    else return 0, $eyG1M.TABLE_MAX_WIDTH;
};
/**
 * When guidelines are outside the viewport, filter them out, do not show
 * So the guideline container won't make the fabric-editor-popup-scroll-parent overflow
 * @param guidelines
 * @param containerWidth editorWidth
 * @param lineLength
 * @param isTableScalingEnabled
 * @param isFullWidthModeEnabled
 */ const $7d2611ed50d6e4f3$var$getVisibleGuidelines = (guidelines, containerWidth, lineLength, isTableScalingEnabled, isFullWidthModeEnabled)=>{
    let guidelineVisibleAdjustment = (0, $4Tw3G.TABLE_GUIDELINE_VISIBLE_ADJUSTMENT);
    if (isTableScalingEnabled) {
        // Notes:
        // Example: containerWidth = 1244, lineLength = 1180 (used for when editor full width mode is enabled)
        // Full width/dynamic x coordinate can be float number.
        // Ex: guideline.position.x can be 590.5. So 590.5 * 2 = 1181 (not 1180).
        // For PTW we need to ensure that dynamic guideline never gets excluded: 1181 should be > width + guidelineVisibleAdjustment
        // guidelineVisibleAdjustment is set as a negative value, so we making it positive and adding + 1
        const preserve_table_widths_adjustment = -1 * (0, $6Mhdl.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET) + 1;
        const padding = $7d2611ed50d6e4f3$var$getPadding(containerWidth);
        guidelineVisibleAdjustment = isFullWidthModeEnabled ? preserve_table_widths_adjustment // guidelineVisibleAdjustment = -2, if lineLength = 1180, 1181 < 1180 + 2 is true.
         : -2 * padding + preserve_table_widths_adjustment; // guidelineVisibleAdjustment = -62, if containerWidth is 1244, 1181 < 1244 - 62 = 1182 is true.
    }
    const width = isTableScalingEnabled && isFullWidthModeEnabled ? lineLength : containerWidth;
    return guidelines.filter((guideline)=>{
        return guideline.position && guideline.position.x !== undefined && typeof guideline.position.x === 'number' && Math.abs(guideline.position.x * 2) < width + guidelineVisibleAdjustment;
    });
};
const $7d2611ed50d6e4f3$var$selector = (states)=>{
    var _states$tableState;
    return {
        widthToWidest: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.widthToWidest
    };
};
const $7d2611ed50d6e4f3$export$65233f8d64070eeb = ({ children: children, width: width, maxWidth: maxWidth, containerWidth: containerWidth, lineLength: lineLength, updateWidth: updateWidth, onResizeStop: onResizeStop, onResizeStart: onResizeStart, editorView: editorView, getPos: getPos, node: node, tableRef: tableRef, displayGuideline: displayGuideline, attachAnalyticsEvent: attachAnalyticsEvent, displayGapCursor: displayGapCursor, isTableScalingEnabled: isTableScalingEnabled, allowFixedColumnWidthOption: allowFixedColumnWidthOption, isTableAlignmentEnabled: isTableAlignmentEnabled, isWholeTableInDanger: isWholeTableInDanger, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, pluginInjectionApi: pluginInjectionApi, isFullWidthModeEnabled: isFullWidthModeEnabled, isCommentEditor: isCommentEditor, isChromelessEditor: isChromelessEditor, disabled: disabled })=>{
    var _editorView$state, _pluginInjectionApi$a2, _pluginInjectionApi$u2;
    const currentGap = (0, $fc4bM.useRef)(0);
    // track resizing state - use ref over state to avoid re-render
    const isResizing = (0, $fc4bM.useRef)(false);
    const areResizeMetaKeysPressed = (0, $fc4bM.useRef)(false);
    const resizerRef = (0, $fc4bM.useRef)(null);
    const interactionState = (0, $jnzAA.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const { widthToWidest: widthToWidest } = (0, $9oAqi.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'table'
    ], $7d2611ed50d6e4f3$var$selector);
    // used to reposition tooltip when table is resizing via keyboard
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef();
    const [snappingEnabled, setSnappingEnabled] = (0, $fc4bM.useState)(false);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const isFullPageAppearance = !isCommentEditor && !isChromelessEditor;
    const currentSelection = (_editorView$state = editorView.state) === null || _editorView$state === void 0 ? void 0 : _editorView$state.selection;
    const tableFromSelection = (0, $fc4bM.useMemo)(()=>{
        return (0, $5n2u9.findTable)(currentSelection);
    }, [
        currentSelection
    ]);
    const tableFromSelectionPosition = tableFromSelection === null || tableFromSelection === void 0 ? void 0 : tableFromSelection.pos;
    const isTableSelected = (0, $fc4bM.useMemo)(()=>{
        // Avoid call getPos if there is no table in the current selection,
        if (typeof tableFromSelectionPosition !== 'number') return false;
        if (interactionState === 'hasNotHadInteraction') return false;
        let currentNodePosition;
        try {
            // The React Table and the ProseMirror can endup out-of-sync
            // ProseMirror always assume the DOM is not managed by other framework
            currentNodePosition = getPos();
        } catch (e) {
            (0, $kFIjS.logException)(e, {
                location: 'editor-plugin-table/table-resizer'
            });
            return false;
        }
        return tableFromSelectionPosition === currentNodePosition;
    }, [
        tableFromSelectionPosition,
        interactionState,
        getPos
    ]);
    const resizerMinWidth = $7d2611ed50d6e4f3$var$getResizerMinWidth(node);
    const handleSize = $7d2611ed50d6e4f3$var$getResizerHandleHeight(tableRef);
    const { startMeasure: startMeasure, endMeasure: endMeasure, countFrames: countFrames } = (0, $4Bf8g.useMeasureFramerate)();
    const excludeGuidelineConfig = (0, $fc4bM.useMemo)(()=>({
            innerGuidelines: !!isTableAlignmentEnabled,
            breakoutPoints: !!(isTableAlignmentEnabled && isFullWidthModeEnabled)
        }), [
        isFullWidthModeEnabled,
        isTableAlignmentEnabled
    ]);
    const updateActiveGuidelines = (0, $fc4bM.useCallback)(({ gap: gap, keys: keys })=>{
        if (gap !== currentGap.current) {
            currentGap.current = gap;
            const visibleGuidelines = $7d2611ed50d6e4f3$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $6Mhdl.defaultGuidelinesForPreserveTable)((0, $6Mhdl.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), isFullWidthModeEnabled ? lineLength + 2 * $7d2611ed50d6e4f3$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $6Mhdl.defaultGuidelines), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
            displayGuideline((0, $2Ebrz.getGuidelinesWithHighlights)(gap, (0, $4Tw3G.TABLE_SNAP_GAP), keys, visibleGuidelines));
        }
    }, [
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        displayGuideline,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const guidelineSnaps = (0, $fc4bM.useMemo)(()=>snappingEnabled ? {
            x: isTableScalingEnabled ? (0, $7tq4H.defaultTablePreserveSnappingWidths)((0, $7tq4H.PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET), // was hardcoded to 0, using PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
            isFullWidthModeEnabled ? lineLength + 2 * $7d2611ed50d6e4f3$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $7tq4H.defaultSnappingWidths)
        } : undefined, [
        snappingEnabled,
        isTableScalingEnabled,
        excludeGuidelineConfig,
        containerWidth,
        lineLength,
        isFullWidthModeEnabled
    ]);
    const switchToCenterAlignment = (0, $fc4bM.useCallback)((pos, node, newWidth, state, dispatch)=>{
        if ((0, $1YIoS.shouldChangeAlignmentToCenterResized)(isTableAlignmentEnabled, node, lineLength, newWidth) && isResizing.current) {
            var _pluginInjectionApi$a;
            const tableNodeWithPos = {
                pos: pos,
                node: node
            };
            (0, $kfljr.setTableAlignmentWithTableContentWithPosWithAnalytics)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)((0, $1YIoS.ALIGN_CENTER), (0, $1YIoS.ALIGN_START), tableNodeWithPos, (0, $3LeME.INPUT_METHOD).AUTO, (0, $8d4kB.CHANGE_ALIGNMENT_REASON).EDITOR_APPEARANCE_CHANGED)(state, dispatch);
            return true;
        }
        return false;
    }, [
        isTableAlignmentEnabled,
        lineLength,
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions
    ]);
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            // only bring back the cursor if this table was deleted - i.e. if a user was resizing, then another
            // deleted this table
            if (isResizing.current) {
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                displayGapCursor(true);
                displayGuideline([]);
                tr.setMeta((0, $8aCba.pluginKey), {
                    resizing: false,
                    tableLocalId: '',
                    tableRef: null
                });
                dispatch(tr);
            }
        };
    }, [
        editorView,
        displayGuideline,
        displayGapCursor
    ]);
    const handleResizeStart = (0, $fc4bM.useCallback)(()=>{
        var _insm$session, _pluginInjectionApi$u;
        (_insm$session = (0, $4eT7o.insm).session) === null || _insm$session === void 0 || _insm$session.startFeature('tableResize');
        startMeasure();
        isResizing.current = true;
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        displayGapCursor(false);
        tr.setMeta((0, $8aCba.pluginKey), {
            resizing: true,
            tableLocalId: node.attrs.localId,
            tableRef: tableRef
        });
        tr.setMeta('is-resizer-resizing', true);
        tr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
            name: (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED
        });
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$u = pluginInjectionApi.userIntent) === null || _pluginInjectionApi$u === void 0 || _pluginInjectionApi$u.commands.setCurrentUserIntent('resizing')({
            tr: tr
        });
        dispatch(tr);
        const visibleGuidelines = $7d2611ed50d6e4f3$var$getVisibleGuidelines(isTableScalingEnabled ? (0, $6Mhdl.defaultGuidelinesForPreserveTable)((0, $6Mhdl.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), isFullWidthModeEnabled ? lineLength + 2 * $7d2611ed50d6e4f3$var$getPadding(containerWidth) : containerWidth, excludeGuidelineConfig) : (0, $6Mhdl.defaultGuidelines), containerWidth, lineLength, Boolean(isTableScalingEnabled), Boolean(isFullWidthModeEnabled));
        setSnappingEnabled(displayGuideline(visibleGuidelines));
        if (onResizeStart) onResizeStart();
    }, [
        startMeasure,
        editorView,
        displayGapCursor,
        node.attrs.localId,
        tableRef,
        isTableScalingEnabled,
        isFullWidthModeEnabled,
        lineLength,
        containerWidth,
        excludeGuidelineConfig,
        displayGuideline,
        onResizeStart,
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$u2 = pluginInjectionApi.userIntent) === null || _pluginInjectionApi$u2 === void 0 ? void 0 : _pluginInjectionApi$u2.commands
    ]);
    const handleResize = (0, $fc4bM.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (originalState, delta)=>{
        var _node$attrs;
        countFrames();
        const newWidth = originalState.width + delta.width;
        let pos;
        try {
            pos = getPos();
        } catch  {
            return;
        }
        if (typeof pos !== 'number') return;
        const editorContainerWidth = isFullWidthModeEnabled ? lineLength + 2 * $7d2611ed50d6e4f3$var$getPadding(containerWidth) : containerWidth;
        const closestSnap = isFullPageAppearance && (0, $7tq4H.findClosestSnap)(newWidth, isTableScalingEnabled ? (0, $7tq4H.defaultTablePreserveSnappingWidths)((0, $7tq4H.PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig) : (0, $7tq4H.defaultSnappingWidths), isTableScalingEnabled ? (0, $6Mhdl.defaultGuidelinesForPreserveTable)((0, $6Mhdl.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig) : (0, $6Mhdl.defaultGuidelines), (0, $4Tw3G.TABLE_HIGHLIGHT_GAP), (0, $4Tw3G.TABLE_HIGHLIGHT_TOLERANCE));
        closestSnap && updateActiveGuidelines(closestSnap);
        // When snapping to the full width guideline, resize the table to be 1800px
        const { state: state, dispatch: dispatch } = editorView;
        const currentTableNodeLocalId = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) ?? '';
        const fullWidthGuideline = (0, $6Mhdl.defaultGuidelinesForPreserveTable)((0, $6Mhdl.PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET), editorContainerWidth, excludeGuidelineConfig).filter((guideline)=>guideline.isFullWidth)[0];
        const isFullWidthGuidelineActive = closestSnap && fullWidthGuideline && closestSnap.keys.includes(fullWidthGuideline.key);
        const tableMaxWidth = $7d2611ed50d6e4f3$var$getTableMaxWidth(containerWidth, lineLength, isCommentEditor, isChromelessEditor);
        const shouldUpdateWidthToWidest = !isFullPageAppearance ? tableMaxWidth <= newWidth : !!isTableScalingEnabled && isFullWidthGuidelineActive;
        const previewParentWidth = !isFullPageAppearance && shouldUpdateWidthToWidest ? tableMaxWidth : newWidth;
        (0, $9xQxI.previewScaleTable)(tableRef, {
            node: node,
            prevNode: node,
            start: pos + 1,
            parentWidth: previewParentWidth
        }, editorView.domAtPos.bind(editorView), isTableScalingEnabled, allowFixedColumnWidthOption, !isFullPageAppearance);
        (0, $jGkle.chainCommands)((state, dispatch)=>{
            return switchToCenterAlignment(pos, node, newWidth, state, dispatch);
        }, (0, $8L6TV.updateWidthToWidest)({
            [currentTableNodeLocalId]: shouldUpdateWidthToWidest
        }))(state, dispatch);
        updateWidth(shouldUpdateWidthToWidest ? tableMaxWidth : newWidth);
        return newWidth;
    }, [
        countFrames,
        isCommentEditor,
        isChromelessEditor,
        isFullPageAppearance,
        isTableScalingEnabled,
        allowFixedColumnWidthOption,
        isFullWidthModeEnabled,
        excludeGuidelineConfig,
        tableRef,
        node,
        editorView,
        updateActiveGuidelines,
        containerWidth,
        lineLength,
        updateWidth,
        getPos,
        switchToCenterAlignment
    ]);
    const scheduleResize = (0, $fc4bM.useMemo)(()=>(0, $PIUl3.default)(handleResize), [
        handleResize
    ]);
    const handleResizeStop = (0, $fc4bM.useCallback)((originalState, delta)=>{
        var _node$attrs2, _pluginInjectionApi$u3, _insm$session2;
        isResizing.current = false;
        let newWidth = originalState.width + delta.width;
        const originalNewWidth = newWidth;
        const { state: state, dispatch: dispatch } = editorView;
        const pos = getPos();
        const currentTableNodeLocalId = (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) ?? '';
        const tableMaxWidth = !isFullPageAppearance ? undefined // Table's full-width in comment appearance inherit the width of the Editor/Renderer
         : (0, $eyG1M.TABLE_MAX_WIDTH);
        newWidth = widthToWidest && currentTableNodeLocalId && widthToWidest[currentTableNodeLocalId] ? tableMaxWidth : newWidth;
        let tr = state.tr.setMeta((0, $8aCba.pluginKey), {
            resizing: false,
            tableLocalId: '',
            tableRef: null
        });
        tr.setMeta('is-resizer-resizing', false);
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$u3 = pluginInjectionApi.userIntent) === null || _pluginInjectionApi$u3 === void 0 || _pluginInjectionApi$u3.commands.setCurrentUserIntent('default')({
            tr: tr
        });
        const frameRateSamples = endMeasure();
        if (frameRateSamples.length > 0) {
            const resizeFrameRatePayloads = (0, $4Bf8g.generateResizeFrameRatePayloads)({
                docSize: state.doc.nodeSize,
                frameRateSamples: frameRateSamples,
                originalNode: node
            });
            resizeFrameRatePayloads.forEach((payload)=>{
                var _attachAnalyticsEvent;
                (_attachAnalyticsEvent = attachAnalyticsEvent(payload)) === null || _attachAnalyticsEvent === void 0 || _attachAnalyticsEvent(tr);
            });
        }
        if (typeof pos === 'number') {
            var _attachAnalyticsEvent2;
            tr = tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                width: newWidth,
                layout: node.attrs.layout !== (0, $1YIoS.ALIGN_START) && node.attrs.layout !== (0, $1YIoS.ALIGN_CENTER) ? (0, $1YIoS.ALIGN_CENTER) : node.attrs.layout
            });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const newNode = tr.doc.nodeAt(pos);
            tr = (0, $9xQxI.scaleTable)(tableRef, {
                node: newNode,
                prevNode: node,
                start: pos + 1,
                // We use originalNewWidth in comment and chromeless editors, because
                // newWidth can be undefined when table is resized to 'full-width'
                // scaleTable function needs number value to work correctly.
                parentWidth: !isFullPageAppearance ? originalNewWidth : newWidth
            }, editorView.domAtPos.bind(editorView), pluginInjectionApi, isTableScalingEnabled, shouldUseIncreasedScalingPercent || false, !isFullPageAppearance)(tr);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const scaledNode = tr.doc.nodeAt(pos);
            (_attachAnalyticsEvent2 = attachAnalyticsEvent((0, $4Bf8g.generateResizedPayload)({
                originalNode: node,
                resizedNode: scaledNode
            }))) === null || _attachAnalyticsEvent2 === void 0 || _attachAnalyticsEvent2(tr);
        }
        displayGapCursor(true);
        dispatch(tr);
        if (delta.width < 0 && newWidth !== undefined) {
            var _pluginInjectionApi$a3;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.accessibilityUtils) === null || _pluginInjectionApi$a3 === void 0 || _pluginInjectionApi$a3.actions.ariaNotify(formatMessage((0, $lqHJB.messages).tableSizeDecreaseScreenReaderInformation, {
                newWidth: newWidth
            }));
        } else if (delta.width > 0 && newWidth !== undefined) {
            var _pluginInjectionApi$a4;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.accessibilityUtils) === null || _pluginInjectionApi$a4 === void 0 || _pluginInjectionApi$a4.actions.ariaNotify(formatMessage((0, $lqHJB.messages).tableSizeIncreaseScreenReaderInformation, {
                newWidth: newWidth
            }));
        }
        // Hide guidelines when resizing stops
        displayGuideline([]);
        newWidth !== undefined && updateWidth(newWidth);
        scheduleResize.cancel();
        if (onResizeStop) onResizeStop();
        (_insm$session2 = (0, $4eT7o.insm).session) === null || _insm$session2 === void 0 || _insm$session2.endFeature('tableResize');
        return newWidth;
    }, [
        editorView,
        getPos,
        node,
        widthToWidest,
        endMeasure,
        displayGapCursor,
        displayGuideline,
        updateWidth,
        scheduleResize,
        onResizeStop,
        pluginInjectionApi,
        attachAnalyticsEvent,
        tableRef,
        isTableScalingEnabled,
        shouldUseIncreasedScalingPercent,
        formatMessage,
        isFullPageAppearance
    ]);
    const handleTableSizeChangeOnKeypress = (0, $fc4bM.useCallback)((step)=>{
        const newWidth = width + step;
        if (newWidth < resizerMinWidth) return;
        handleResizeStop({
            width: width,
            x: 0,
            y: 0,
            height: 0
        }, {
            width: step,
            height: 0
        });
    }, [
        width,
        handleResizeStop,
        resizerMinWidth
    ]);
    const handleEscape = (0, $fc4bM.useCallback)(()=>{
        editorView === null || editorView === void 0 || editorView.focus();
    }, [
        editorView
    ]);
    const handleKeyDown = (0, $fc4bM.useCallback)((event)=>{
        const isBracketKey = event.code === 'BracketRight' || event.code === 'BracketLeft';
        const browser = (0, $dqFZv.getBrowserInfo)();
        const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
        if (event.altKey || metaKey || event.shiftKey) areResizeMetaKeysPressed.current = true;
        if (event.altKey && metaKey) {
            if (isBracketKey) {
                event.preventDefault();
                handleTableSizeChangeOnKeypress(event.code === 'BracketRight' ? $7d2611ed50d6e4f3$var$RESIZE_STEP_VALUE : -$7d2611ed50d6e4f3$var$RESIZE_STEP_VALUE);
            }
        } else if (!areResizeMetaKeysPressed.current) handleEscape();
    }, [
        handleEscape,
        handleTableSizeChangeOnKeypress
    ]);
    const handleKeyUp = (0, $fc4bM.useCallback)((event)=>{
        if (event.altKey || event.metaKey) areResizeMetaKeysPressed.current = false;
        return;
    }, [
        areResizeMetaKeysPressed
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        if (!resizerRef.current) return;
        const resizeHandleThumbEl = resizerRef.current.getResizerThumbEl();
        const globalKeyDownHandler = (event)=>{
            const browser = (0, $dqFZv.getBrowserInfo)();
            const metaKey = browser.mac ? event.metaKey : event.ctrlKey;
            if (!isTableSelected) return;
            if (event.altKey && event.shiftKey && metaKey && event.code === 'KeyR') {
                event.preventDefault();
                if (!resizeHandleThumbEl) return;
                resizeHandleThumbEl.focus();
                resizeHandleThumbEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        const editorViewDom = editorView === null || editorView === void 0 ? void 0 : editorView.dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom === null || editorViewDom === void 0 || editorViewDom.addEventListener('keydown', globalKeyDownHandler);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl === null || resizeHandleThumbEl === void 0 || resizeHandleThumbEl.addEventListener('keydown', handleKeyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        resizeHandleThumbEl === null || resizeHandleThumbEl === void 0 || resizeHandleThumbEl.addEventListener('keyup', handleKeyUp);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom === null || editorViewDom === void 0 || editorViewDom.removeEventListener('keydown', globalKeyDownHandler);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl === null || resizeHandleThumbEl === void 0 || resizeHandleThumbEl.removeEventListener('keydown', handleKeyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            resizeHandleThumbEl === null || resizeHandleThumbEl === void 0 || resizeHandleThumbEl.removeEventListener('keyup', handleKeyUp);
        };
    }, [
        resizerRef,
        editorView,
        handleResizeStop,
        isTableSelected,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $fc4bM.useLayoutEffect)(()=>{
        var _updateTooltip$curren;
        (_updateTooltip$curren = updateTooltip.current) === null || _updateTooltip$curren === void 0 || _updateTooltip$curren.call(updateTooltip);
    }, [
        width
    ]);
    const resizeRatio = !isTableAlignmentEnabled || isTableAlignmentEnabled && (0, $1YIoS.normaliseAlignment)(node.attrs.layout) === (0, $1YIoS.ALIGN_CENTER) ? 2 : 1;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3LM7S.Fragment), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $2Gsu9.default), {
            ref: resizerRef,
            enable: disabled ? {} : $7d2611ed50d6e4f3$var$handles,
            width: width,
            handleAlignmentMethod: "sticky",
            handleSize: handleSize,
            handleStyles: $7d2611ed50d6e4f3$var$handleStyles,
            handleResizeStart: handleResizeStart,
            handleResize: scheduleResize,
            handleResizeStop: handleResizeStop,
            resizeRatio: resizeRatio,
            minWidth: resizerMinWidth,
            maxWidth: maxWidth,
            snapGap: (0, $4Tw3G.TABLE_SNAP_GAP),
            snap: guidelineSnaps,
            handlePositioning: "adjacent",
            isHandleVisible: isTableSelected,
            needExtendedResizeZone: true,
            appearance: isTableSelected && isWholeTableInDanger ? 'danger' : undefined,
            handleHighlight: "shadow",
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleTooltipContent: ({ update: update })=>{
                updateTooltip.current = update;
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
                    description: formatMessage((0, $lqHJB.messages).resizeTable),
                    keymap: (0, $eUtBU.focusTableResizer)
                });
            },
            "data-vc-nvs": "true",
            children: children
        })
    });
};

});
parcelRegister("6Mhdl", function(module, exports) {
$parcel$export(module.exports, "defaultGuidelines", () => $10359a13e1ed38cf$export$71ea7e0a71c6d202);
$parcel$export(module.exports, "PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET", () => $10359a13e1ed38cf$export$d25f7f8989bf9598);
$parcel$export(module.exports, "defaultGuidelinesForPreserveTable", () => $10359a13e1ed38cf$export$be2db36e9da53e09);

var $fMWmB = parcelRequire("fMWmB");

var $7tq4H = parcelRequire("7tq4H");
const $10359a13e1ed38cf$export$71ea7e0a71c6d202 = (0, $fMWmB.createFixedGuidelinesFromLengths)([
    0,
    ...(0, $7tq4H.calculateDefaultSnappings)(-1)
]);
const $10359a13e1ed38cf$export$d25f7f8989bf9598 = -1;
const $10359a13e1ed38cf$export$be2db36e9da53e09 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const lengths = (0, $7tq4H.calculateDefaultTablePreserveSnappings)(lengthOffset, // was hardcoded to -1 here, created PRESERVE_TABLE_GUIDELINES_LENGTH_OFFSET instead.
    editorContainerWidth, exclude);
    return (0, $fMWmB.createFixedGuidelinesFromLengths)(lengths, undefined, true);
};

});
parcelRegister("fMWmB", function(module, exports) {
$parcel$export(module.exports, "createFixedGuidelinesFromLengths", () => $05ceeb90886aabf0$export$24448ad8894709b4);

var $7MSyM = parcelRequire("7MSyM");
const $05ceeb90886aabf0$export$24448ad8894709b4 = (lengths, key = 'guide', hasFullWidthGuide = false)=>{
    return (0, $7MSyM.createGuidesFromLengths)(lengths, hasFullWidthGuide).reduce((acc, { left: left, right: right, length: length, isFullWidth: isFullWidth })=>{
        if (length === 0) return [
            ...acc,
            {
                key: `${key}-${length}-centre`,
                position: {
                    x: left
                }
            }
        ];
        else return [
            ...acc,
            {
                key: `${key}-${length}-left`,
                position: {
                    x: left
                }
            },
            {
                key: `${key}-${length}-right`,
                position: {
                    x: right
                },
                ...isFullWidth ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};

});
parcelRegister("7MSyM", function(module, exports) {
$parcel$export(module.exports, "createGuidesFromLengths", () => $9d3de1a55c708444$export$192a1a4af16beb38);
const $9d3de1a55c708444$export$192a1a4af16beb38 = (lengths, hasFullWidthGuide = false)=>{
    return Array.from(new Set(lengths)).reduce((acc, length, index)=>{
        const h = length * 0.5;
        if (length === 0) return [
            ...acc,
            {
                left: 0,
                right: 0,
                length: length
            }
        ];
        if (!h || !Number.isFinite(length)) // Filter out nonsensical values, null, undefined, NaN, empty string
        return acc;
        return [
            ...acc,
            {
                left: -h,
                right: h,
                length: length,
                // Assumes the full width guide is always the last length in the array
                ...hasFullWidthGuide && index === lengths.length - 1 ? {
                    isFullWidth: true
                } : {}
            }
        ];
    }, []);
};

});


parcelRegister("7tq4H", function(module, exports) {
$parcel$export(module.exports, "calculateDefaultSnappings", () => $6e3d91654cf9cc0f$export$c4ddb11be0806484);
$parcel$export(module.exports, "calculateDefaultTablePreserveSnappings", () => $6e3d91654cf9cc0f$export$7542cd96381664c2);
$parcel$export(module.exports, "defaultSnappingWidths", () => $6e3d91654cf9cc0f$export$c5e672719c546336);
$parcel$export(module.exports, "PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET", () => $6e3d91654cf9cc0f$export$b2f61428a1609695);
$parcel$export(module.exports, "defaultTablePreserveSnappingWidths", () => $6e3d91654cf9cc0f$export$461c50a158de0369);
$parcel$export(module.exports, "findClosestSnap", () => $6e3d91654cf9cc0f$export$5ea7b9558ea477a);

var $8JG6f = parcelRequire("8JG6f");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");
const $6e3d91654cf9cc0f$var$numberOfLanesInDefaultLayoutWidth = 12;
const $6e3d91654cf9cc0f$var$calculateSubSnappingWidths = (totalLanes, totalWidth)=>new Array(Math.round(totalLanes / 2) - 1).fill(totalWidth / totalLanes).map((v, i)=>v * (i + 1) * 2);
const $6e3d91654cf9cc0f$export$c4ddb11be0806484 = (lengthOffset = 0)=>[
        ...$6e3d91654cf9cc0f$var$calculateSubSnappingWidths($6e3d91654cf9cc0f$var$numberOfLanesInDefaultLayoutWidth, (0, $014x6.akEditorDefaultLayoutWidth) + lengthOffset),
        (0, $014x6.akEditorDefaultLayoutWidth) + lengthOffset,
        (0, $014x6.akEditorCalculatedWideLayoutWidth) + lengthOffset,
        (0, $014x6.akEditorFullWidthLayoutWidth) + lengthOffset
    ];
const $6e3d91654cf9cc0f$var$getPadding = (editorContainerWidth)=>{
    return editorContainerWidth <= (0, $014x6.akEditorFullPageNarrowBreakout) && (0, $kaRof.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $014x6.akEditorGutterPaddingReduced) : (0, $014x6.akEditorGutterPaddingDynamic)();
};
const $6e3d91654cf9cc0f$export$7542cd96381664c2 = (lengthOffset = 0, editorContainerWidth = (0, $014x6.akEditorFullWidthLayoutWidth), exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $6e3d91654cf9cc0f$var$getPadding(editorContainerWidth);
    const dynamicFullWidthLine = editorContainerWidth - padding * 2 >= (0, $014x6.akEditorFullWidthLayoutWidth) ? (0, $014x6.akEditorFullWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const dynamicMaxWidthLine = editorContainerWidth - padding * 2 >= (0, $014x6.akEditorMaxWidthLayoutWidth) ? (0, $014x6.akEditorMaxWidthLayoutWidth) : editorContainerWidth - padding * 2;
    const guides = [
        dynamicFullWidthLine - lengthOffset
    ];
    guides.push(dynamicMaxWidthLine - lengthOffset);
    if (!exclude.breakoutPoints) guides.unshift((0, $014x6.akEditorDefaultLayoutWidth) + lengthOffset, (0, $014x6.akEditorCalculatedWideLayoutWidth) + lengthOffset);
    if (!exclude.innerGuidelines) guides.unshift(0, ...$6e3d91654cf9cc0f$var$calculateSubSnappingWidths($6e3d91654cf9cc0f$var$numberOfLanesInDefaultLayoutWidth, (0, $014x6.akEditorDefaultLayoutWidth) + lengthOffset));
    return guides;
};
const $6e3d91654cf9cc0f$export$c5e672719c546336 = $6e3d91654cf9cc0f$export$c4ddb11be0806484();
const $6e3d91654cf9cc0f$export$b2f61428a1609695 = 0;
const $6e3d91654cf9cc0f$export$461c50a158de0369 = (lengthOffset, editorContainerWidth, exclude = {
    innerGuidelines: false,
    breakoutPoints: false
})=>{
    const padding = $6e3d91654cf9cc0f$var$getPadding(editorContainerWidth);
    return editorContainerWidth - padding * 2 > (0, $014x6.akEditorFullWidthLayoutWidth) ? $6e3d91654cf9cc0f$export$c4ddb11be0806484() : $6e3d91654cf9cc0f$export$7542cd96381664c2(lengthOffset, editorContainerWidth, exclude); // lengthOffset was hardcoded 0 here, created PRESERVE_TABLE_SNAPPING_LENGTH_OFFSET instead.
};
const $6e3d91654cf9cc0f$export$5ea7b9558ea477a = (currentWidth, snapWidths, guidelines, snapGap = 0, tolerance = 0)=>{
    const closestGapIndex = snapWidths.reduce((prev, curr, index)=>Math.abs(curr - currentWidth) < Math.abs(snapWidths[prev] - currentWidth) ? index : prev, 0);
    const gap = Math.abs(snapWidths[closestGapIndex] - currentWidth);
    if (gap < snapGap) {
        const snappingWidth = Math.round(snapWidths[closestGapIndex]);
        const guidelineKeys = guidelines.reduce((acc, guideline)=>{
            // NOTE: The snap points are based on the guidelines, however their formatted as a length value whereas the guidelines
            // are point based. The point base x coords are calculated by halving the lengths. This means we can convert the
            // point base position to length by simply multiplying by 2.
            const length = Math.round(Math.abs((0, $8JG6f.isVerticalPosition)(guideline.position) ? guideline.position.x : guideline.position.y) * 2);
            if (snappingWidth >= length - tolerance && snappingWidth <= length + tolerance) acc.push(guideline.key);
            return acc;
        }, []);
        return {
            gap: gap,
            keys: guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};

});




parcelRegister("9ALWB", function(module, exports) {
$parcel$export(module.exports, "TableStickyScrollbar", () => $746b60e1c1defa4a$export$8c072780619cfc83);

var $8kZ6E = parcelRequire("8kZ6E");

var $dRkX9 = parcelRequire("dRkX9");

var $YREXK = parcelRequire("YREXK");
class $746b60e1c1defa4a$export$8c072780619cfc83 {
    constructor(wrapper, view){
        this.sentinels = {};
        this.handleScroll = (event)=>{
            if (!this.stickyScrollbarContainerElement || !this.wrapper || event.target !== this.stickyScrollbarContainerElement) return;
            const left = this.stickyScrollbarContainerElement.scrollLeft;
            if ((0, $dRkX9.fg)('platform_editor_ai_suggestion_table_scroll_fix')) {
                // Ignore positions copied from the table so their scroll events cannot interrupt it.
                if (left === this.mirroredScrollLeft) return;
                this.mirroredScrollLeft = undefined;
            }
            this.wrapper.scrollLeft = left;
        };
        this.wrapper = wrapper;
        this.view = view;
        requestAnimationFrame(()=>{
            this.init();
        });
    }
    dispose() {
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.removeEventListener('scroll', this.handleScroll);
        this.deleteIntersectionObserver();
    }
    scrollLeft(left) {
        if (this.stickyScrollbarContainerElement) {
            this.stickyScrollbarContainerElement.scrollLeft = left;
            if ((0, $dRkX9.fg)('platform_editor_ai_suggestion_table_scroll_fix')) this.mirroredScrollLeft = this.stickyScrollbarContainerElement.scrollLeft;
        }
    }
    init() {
        var _this$wrapper$parentE;
        if (!this.wrapper) return;
        this.stickyScrollbarContainerElement = (_this$wrapper$parentE = this.wrapper.parentElement) === null || _this$wrapper$parentE === void 0 ? void 0 : _this$wrapper$parentE.querySelector(`.${(0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER}`);
        if (this.stickyScrollbarContainerElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.stickyScrollbarContainerElement.addEventListener('scroll', this.handleScroll, {
            passive: true
        });
        this.createIntersectionObserver();
    }
    createIntersectionObserver() {
        var _this$wrapper, _this$wrapper2;
        this.editorScrollableElement = // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $8kZ6E.findOverflowScrollParent)(this.view.dom) || window.document;
        if (!this.editorScrollableElement || !this.wrapper) return;
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            if (!this.stickyScrollbarContainerElement) return;
            entries.forEach((entry)=>{
                var _entry$rootBounds;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const target = entry.target;
                // if the rootBounds has 0 height, e.g. confluence preview mode, we do nothing.
                if (((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.height) === 0) return;
                if (target.classList.contains((0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM)) this.sentinelBottomCallback(entry);
                if (target.classList.contains((0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) this.sentinelTopCallback(entry);
            });
        }, {
            root: this.editorScrollableElement
        });
        // Multiple bottom sentinels may be found if there are nested tables. We need to make sure we get the last one which will belong to the parent table.
        const bottomSentinels = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 || (_this$wrapper = _this$wrapper.parentElement) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.getElementsByClassName((0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM);
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.bottom = bottomSentinels === null || bottomSentinels === void 0 ? void 0 : bottomSentinels.item(bottomSentinels.length - 1);
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.sentinels.top = (_this$wrapper2 = this.wrapper) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.parentElement) === null || _this$wrapper2 === void 0 || (_this$wrapper2 = _this$wrapper2.getElementsByClassName((0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP)) === null || _this$wrapper2 === void 0 ? void 0 : _this$wrapper2.item(0);
        [
            this.sentinels.bottom,
            this.sentinels.top
        ].forEach((el)=>{
            if (el !== null && this.intersectionObserver) this.intersectionObserver.observe(el);
        });
    }
    deleteIntersectionObserver() {
        if (this.intersectionObserver) {
            if (this.sentinels.bottom) this.intersectionObserver.unobserve(this.sentinels.bottom);
            this.intersectionObserver.disconnect();
        }
    }
    sentinelBottomCallback(entry) {
        var _entry$rootBounds2, _entry$rootBounds3;
        const sentinelIsAboveScrollArea = entry.boundingClientRect.top < (((_entry$rootBounds2 = entry.rootBounds) === null || _entry$rootBounds2 === void 0 ? void 0 : _entry$rootBounds2.top) || 0) || // When editorScrollableElement is the root document or inside modal,
        // so the boundingClientRect.top will never be less than the rootBounds.top,
        // so we need to check if the boundingClientRect.top is less than 20% of the rootBounds.height
        // to determine if the bottom sentinel is above the scroll area
        entry.boundingClientRect.top < (((_entry$rootBounds3 = entry.rootBounds) === null || _entry$rootBounds3 === void 0 ? void 0 : _entry$rootBounds3.height) || 0) * 0.2;
        this.bottomSentinelState = sentinelIsAboveScrollArea ? 'above' : entry.isIntersecting ? 'visible' : 'below';
        this.toggle();
    }
    sentinelTopCallback(entry) {
        var _entry$rootBounds4;
        const sentinelIsBelowScrollArea = (((_entry$rootBounds4 = entry.rootBounds) === null || _entry$rootBounds4 === void 0 ? void 0 : _entry$rootBounds4.bottom) || 0) < entry.boundingClientRect.top;
        this.topSentinelState = sentinelIsBelowScrollArea ? 'below' : entry.isIntersecting ? 'visible' : 'above';
        this.toggle();
    }
    toggle() {
        if ((this.topSentinelState === 'visible' || this.topSentinelState === 'above') && this.bottomSentinelState === 'below') this.show();
        else this.hide();
    }
    hide() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'none') this.stickyScrollbarContainerElement.style.display = 'none';
    }
    show() {
        if (this.stickyScrollbarContainerElement && this.stickyScrollbarContainerElement.style.display !== 'block') this.stickyScrollbarContainerElement.style.display = 'block';
    }
}

});



parcelRegister("iVMHB", function(module, exports) {
$parcel$export(module.exports, "TableSSRReactContextsProvider", () => $16528dcb4a35177b$export$6fd84272d0edd48f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $eVKpX = parcelRequire("eVKpX");
function $16528dcb4a35177b$export$6fd84272d0edd48f({ children: children, intl: intl }) {
    if (!(0, $eVKpX.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $fcCIH.Provider), {
        value: intl,
        children: children
    });
}

});


parcelRegister("93rwv", function(module, exports) {
$parcel$export(module.exports, "default", () => $11a95b2691d9d232$export$2e2bcd8739ae039);

var $63Q5S = parcelRequire("63Q5S");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $aEmSo = parcelRequire("aEmSo");

var $dZKRP = parcelRequire("dZKRP");

var $1U3XY = parcelRequire("1U3XY");
const $11a95b2691d9d232$var$DEFAULT_COL_SPAN = 1;
const $11a95b2691d9d232$var$DEFAULT_ROW_SPAN = 1;
/**
 * For performance reasons we do this in the background - it shouldn't block the main thread
 */ function $11a95b2691d9d232$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $11a95b2691d9d232$var$cssVariablePattern = /^VAR\(--.*\)$/;
const $11a95b2691d9d232$var$getCellDomAttrsForTableMenuUpdates = (node)=>{
    const attrs = (0, $63Q5S.getCellDomAttrs)(node);
    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) && node.attrs.valign) attrs['data-valign'] = node.attrs.valign;
    return attrs;
};
class $11a95b2691d9d232$export$2e2bcd8739ae039 extends (0, $1U3XY.default) {
    constructor(node, view, getPos, eventDispatcher, editorAnalyticsAPI){
        super(node, view, getPos, eventDispatcher), this.destroy = ()=>{
            if (this.delayHandle && typeof window !== 'undefined') {
                var _window, _window$cancelIdleCal, _window2, _window2$cancelAnimat;
                // eslint-disable-next-line compat/compat
                (_window = window) === null || _window === void 0 || (_window$cancelIdleCal = _window.cancelIdleCallback) === null || _window$cancelIdleCal === void 0 || _window$cancelIdleCal.call(_window, this.delayHandle);
                (_window2 = window) === null || _window2 === void 0 || (_window2$cancelAnimat = _window2.cancelAnimationFrame) === null || _window2$cancelAnimat === void 0 || _window2$cancelAnimat.call(_window2, this.delayHandle);
            }
        };
        if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) this.updateTableEdgeAttrs();
        // CONFCLOUD-78239: Previously we had a bug which tried to invert the heading colour of a table
        // Obviously design tokens can't be inverted and so it would result in `VAR(--DS-BACKGROUND-ACCENT-GRAY-SUBTLEST, #F4F5F7)`
        // which is not a valid CSS variable.
        //
        // We should follow-up and remove this in TODO-xx in 6 months once we're confident
        // that this has fixed most of the cases in the wild.
        //
        // This is a workaround to fix those cases on the fly. Note it is super specific on purpose
        // so that it just fixes the heading token (other tokens should be unaffected)
        // At some point in the future
        if ($11a95b2691d9d232$var$cssVariablePattern.test(node.attrs.background)) this.delayHandle = $11a95b2691d9d232$var$delayUntilIdle(()=>{
            const pos = getPos();
            if (pos) {
                const tr = view.state.tr;
                tr.setNodeAttribute(pos, 'background', node.attrs.background.toLowerCase())// Ensures dispatch does not contribute to undo history (otherwise user requires multiple undo's to revert table)
                .setMeta('addToHistory', false);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $8d4kB.TABLE_ACTION).TABLE_CELL_BACKGROUND_FIXED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    actionSubjectId: null,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK
                })(tr);
                view.dispatch(tr);
            }
        });
    }
    update(node) {
        const didUpdate = this.updateNodeView(node);
        if (didUpdate) this.node = node;
        return didUpdate;
    }
    ignoreMutation(mutation) {
        var _mutation$attributeNa;
        // `data-reaches-*` are presentation-only attrs written imperatively for the rounded-corner
        // masks. Ignore them so ProseMirror doesn't rebuild the table (and drop the header row's
        // sticky class) on every column insert.
        if (mutation.type === 'attributes' && (_mutation$attributeNa = mutation.attributeName) !== null && _mutation$attributeNa !== void 0 && _mutation$attributeNa.startsWith('data-reaches-') && (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) return true;
        return false;
    }
    /**
   * Detects whether this cell visually reaches the bottom or right edge of the table
   * (accounting for rowspan/colspan) and sets data attributes so CSS can apply
   * rounded corners and transparent borders to merged cells that span to the table edges.
   */ updateTableEdgeAttrs() {
        const pos = this.getPos();
        if (pos === undefined) return;
        try {
            const resolvedPos = this.view.state.doc.resolve(pos);
            // Cell → row → table: depth-1 is the table, depth is the row
            const tableDepth = resolvedPos.depth - 1;
            const rowDepth = resolvedPos.depth;
            if (tableDepth < 0 || rowDepth < 0) return;
            const tableNode = resolvedPos.node(tableDepth);
            if (tableNode.type.name !== 'table') return;
            const cellStartInTable = pos - resolvedPos.start(tableDepth);
            const edgeState = (0, $dZKRP.getRoundedTableCellEdgeState)(tableNode, cellStartInTable);
            if (!edgeState) return;
            this.setDataAttr('data-reaches-top', edgeState.reachesTop);
            this.setDataAttr('data-reaches-bottom', edgeState.reachesBottom);
            this.setDataAttr('data-reaches-left', edgeState.reachesLeft);
            this.setDataAttr('data-reaches-right', edgeState.reachesRight);
        } catch  {
        // Position may be stale during document mutations; silently ignore.
        }
    }
    setDataAttr(attr, value) {
        const hasAttr = this.dom.hasAttribute(attr);
        if (value && !hasAttr) this.dom.setAttribute(attr, 'true');
        else if (!value && hasAttr) this.dom.removeAttribute(attr);
    }
    updateNodeView(node) {
        if (this.node.type !== node.type) return false;
        const attrs = $11a95b2691d9d232$var$getCellDomAttrsForTableMenuUpdates(this.node);
        const nextAttrs = $11a95b2691d9d232$var$getCellDomAttrsForTableMenuUpdates(node);
        const { colspan: colspan, rowspan: rowspan } = (0, $63Q5S.getCellAttrs)(this.dom);
        // need to rerender when colspan/rowspan in dom are different from the node attrs
        // this can happen when undoing merge cells
        if (colspan !== (node.attrs.colspan || $11a95b2691d9d232$var$DEFAULT_COL_SPAN) || rowspan !== (node.attrs.rowspan || $11a95b2691d9d232$var$DEFAULT_ROW_SPAN)) return false;
        // added + changed attributes
        const addedAttrs = Object.entries(nextAttrs).filter(([key, value])=>attrs[key] !== value);
        const removedAttrs = Object.keys(attrs).filter((key)=>!nextAttrs.hasOwnProperty(key));
        if (addedAttrs.length || removedAttrs.length) {
            addedAttrs.forEach(([key, value])=>this.dom.setAttribute(key, value || ''));
            removedAttrs.forEach((key)=>this.dom.removeAttribute(key));
            return true;
        }
        // Return true to not re-render this node view
        if (this.node.sameMarkup(node)) return true;
        return false;
    }
}

});
parcelRegister("1U3XY", function(module, exports) {
$parcel$export(module.exports, "default", () => $827d3122668ad5a5$export$2e2bcd8739ae039);

var $7H6Cr = parcelRequire("7H6Cr");
class $827d3122668ad5a5$export$2e2bcd8739ae039 {
    /**
   * @constructor
   */ constructor(node, view, getPos, eventDispatcher){
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.eventDispatcher = eventDispatcher;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node));
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}

});


parcelRegister("6jRUe", function(module, exports) {
$parcel$export(module.exports, "default", () => $17349f549bf7b4b5$export$2e2bcd8739ae039);

var $53bjB = parcelRequire("53bjB");

var $030TE = parcelRequire("030TE");

var $5DGsr = parcelRequire("5DGsr");

var $7cwGc = parcelRequire("7cwGc");

var $8kZ6E = parcelRequire("8kZ6E");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $4GJqd = parcelRequire("4GJqd");

var $4dyXt = parcelRequire("4dyXt");

var $3mliA = parcelRequire("3mliA");

var $7JtQD = parcelRequire("7JtQD");

var $6lkZH = parcelRequire("6lkZH");

var $4WYVI = parcelRequire("4WYVI");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $izDjd = parcelRequire("izDjd");

var $1U3XY = parcelRequire("1U3XY");
// limit scroll event calls
const $17349f549bf7b4b5$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $17349f549bf7b4b5$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $17349f549bf7b4b5$export$2e2bcd8739ae039 extends (0, $1U3XY.default) {
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher), this.cleanup = ()=>{
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $6lkZH.getTree)(this.dom);
                if (tree) this.makeRowHeaderNotSticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
        }, this.colControlsOffset = 0, this.focused = false, this.focusOnlyUpdateGuard = new (0, $izDjd.FocusOnlyUpdateGuard)(), this.topPosEditorElement = 0, this.sentinels = {}, this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        }, this.listening = false, this.padding = 0, this.top = 0, /**
   * Methods
   */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $17349f549bf7b4b5$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT), // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($030TE)))(()=>{
            if (this.isSticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $17349f549bf7b4b5$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT), this.onWidthPluginEvent = ()=>this.updateStickyHeaderWidth(), this.onTablePluginEvent = (state)=>this.onTablePluginState(state), this.onScrollEnd = ()=>this.refireIntersectionObservers();
        this.isSticky = false;
        const { pluginConfig: pluginConfig } = (0, $4GJqd.getPluginState)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        // Sticky headers are the only thing limited mode turns off here, so there is nothing to read
        // or subscribe to when they were never enabled for this editor.
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
            var _api$limitedMode, _limitedMode$currentS;
            const limitedMode = this.isStickyHeaderEnabled ? api === null || api === void 0 || (_api$limitedMode = api.limitedMode) === null || _api$limitedMode === void 0 ? void 0 : _api$limitedMode.sharedState : undefined;
            if (limitedMode !== null && limitedMode !== void 0 && (_limitedMode$currentS = limitedMode.currentState()) !== null && _limitedMode$currentS !== void 0 && _limitedMode$currentS.enabled) this.isStickyHeaderEnabled = false;
            else this.limitedModeUnsubscribe = limitedMode === null || limitedMode === void 0 ? void 0 : limitedMode.onChange(({ nextSharedState: nextSharedState })=>{
                var _this$limitedModeUnsu;
                if (!(nextSharedState !== null && nextSharedState !== void 0 && nextSharedState.enabled)) return;
                // Order matters: cleanup() short-circuits unless sticky headers are still marked enabled.
                this.cleanup();
                this.isStickyHeaderEnabled = false;
                // Limited mode never turns back off, so this listener has done its job.
                (_this$limitedModeUnsu = this.limitedModeUnsubscribe) === null || _this$limitedModeUnsu === void 0 || _this$limitedModeUnsu.call(this);
                this.limitedModeUnsubscribe = undefined;
            });
        } else {
            var _api$limitedMode2;
            if (api !== null && api !== void 0 && (_api$limitedMode2 = api.limitedMode) !== null && _api$limitedMode2 !== void 0 && (_api$limitedMode2 = _api$limitedMode2.sharedState.currentState()) !== null && _api$limitedMode2 !== void 0 && (_api$limitedMode2 = _api$limitedMode2.limitedModePluginKey.getState(view.state)) !== null && _api$limitedMode2 !== void 0 && _api$limitedMode2.documentSizeBreachesThreshold) {
                this.isStickyHeaderEnabled = false;
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('limited-mode-activated', this.cleanup);
            }
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        let rowIndex = 0;
        try {
            // We cannot trust that the value from getPos will be defined
            // https://discuss.prosemirror.net/t/getpos-is-undefined-in-nodeview-constructor/1246/4
            // There are also scenarios where the value it brings back does not tally with the current doc
            // E.g. when AI streaming brings in new content, this position brings back incorrect values that cannot be resolved
            if (pos) {
                const $pos = view.state.doc.resolve(pos);
                this.isInNestedTable = (0, $5DGsr.getParentOfTypeCount)(view.state.schema.nodes.table)($pos) > 1;
            }
        } catch  {
        // Intentionally swallowed — getPos can return stale positions during AI streaming
        }
        rowIndex = (0, $4WYVI.getTableRowIndex)(view, getPos);
        this.isHeaderRow = (0, $4WYVI.supportedHeaderRow)(node, rowIndex);
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $7cwGc.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
    }
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const rowIndex = (0, $4WYVI.getTableRowIndex)(this.view, this.getPos);
        const newNodeIsHeaderRow = (0, $4WYVI.supportedHeaderRow)(node, rowIndex);
        if (this.isHeaderRow !== newNodeIsHeaderRow) return false; // re-create nodeview
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $7JtQD.syncStickyRowToTable)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            this.unsubscribe();
            if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $6lkZH.getTree)(this.dom);
            if (tree) this.makeRowHeaderNotSticky(tree.table, true);
            this.emitOff(true);
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            var _this$nodeVisibilityO;
            (_this$nodeVisibilityO = this.nodeVisibilityObserverCleanupFn) === null || _this$nodeVisibilityO === void 0 || _this$nodeVisibilityO.call(this);
            this.nodeVisibilityObserverCleanupFn = undefined;
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
            var _this$limitedModeUnsu2;
            (_this$limitedModeUnsu2 = this.limitedModeUnsubscribe) === null || _this$limitedModeUnsu2 === void 0 || _this$limitedModeUnsu2.call(this);
            this.limitedModeUnsubscribe = undefined;
        } else // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        this.focusOnlyUpdateGuard.reset();
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $8kZ6E.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $6lkZH.getTop)(this.editorScrollableElement);
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            this.eventDispatcher.on('widthPlugin', this.onWidthPluginEvent);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.on((0, $4dyXt.pluginKey).key, this.onTablePluginEvent);
        } else {
            this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.on((0, $4dyXt.pluginKey).key, this.onTablePluginState.bind(this));
        }
        this.listening = true;
        const scrollHandler = (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? this.headerRowMouseScroll : this.headerRowMouseScroll.bind(this);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', scrollHandler, {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', scrollHandler, {
            passive: true
        });
    }
    unsubscribe() {
        this.focusOnlyUpdateGuard.reset();
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            var _this$editorScrollabl;
            this.eventDispatcher.off('widthPlugin', this.onWidthPluginEvent);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.off((0, $4dyXt.pluginKey).key, this.onTablePluginEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            (_this$editorScrollabl = this.editorScrollableElement) === null || _this$editorScrollabl === void 0 || _this$editorScrollabl.removeEventListener('scrollend', this.onScrollEnd);
        } else {
            this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.off((0, $4dyXt.pluginKey).key, this.onTablePluginState);
        }
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>{
                var _getTree;
                return (_getTree = (0, $6lkZH.getTree)(this.dom)) === null || _getTree === void 0 ? void 0 : _getTree.wrapper.closest(`.${(0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER}`);
            };
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            var _this$tableContainerO;
                            observeStickySentinels();
                            (_this$tableContainerO = this.tableContainerObserver) === null || _this$tableContainerO === void 0 || _this$tableContainerO.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $6lkZH.getTree)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                var _this$editorScrollabl2;
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === ((_this$editorScrollabl2 = this.editorScrollableElement) === null || _this$editorScrollabl2 === void 0 ? void 0 : _this$editorScrollabl2.className)) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $4Tw3G.stickyHeaderBorderBottomWidth)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $4Tw3G.tableScrollbarOffset) + (0, $4Tw3G.stickyRowOffsetTop) + newHeight}px`;
                        (0, $7JtQD.updateStickyMargins)(table);
                    }
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            var _this$editorScrollabl3, _this$editorScrollabl4;
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = (_this$editorScrollabl3 = this.editorScrollableElement) === null || _this$editorScrollabl3 === void 0 || (_this$editorScrollabl4 = _this$editorScrollabl3.getBoundingClientRect) === null || _this$editorScrollabl4 === void 0 ? void 0 : _this$editorScrollabl4.call(_this$editorScrollabl3);
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshStickyState() {
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        const shouldStick = this.shouldSticky();
        if (this.isSticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowSticky(tree, rootRect === null || rootRect === void 0 ? void 0 : rootRect.top);
            } else this.makeRowHeaderNotSticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') try {
                // getPos can return stale positions during AI streaming which cannot be resolved
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    var _findParentNodeCloses;
                    const isInsideLayout = (_findParentNodeCloses = (0, $a4TQr.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })) === null || _findParentNodeCloses === void 0 ? void 0 : _findParentNodeCloses.node;
                    if (isInsideLayout) return false;
                }
            } catch  {
                // getPos can return stale positions during AI streaming — fall back to non-sticky
                return false;
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
      # Overview
        I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
        The format of the states are;    {top|bottom}:{in|above|below}
        ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
         For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
        above and out of the viewport
         This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
       # States
        top:in / bottom:in - NOT sticky
        top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:in / bottom:below - NOT sticky
        top:above / bottom:in - STICKY
        top:above / bottom:above - NOT sticky
        top:above / bottom:below - STICKY
        top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
        top:below / bottom:below - NOT sticky
       # Summary
        The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
        is in or below it.
      */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        if (this.focusOnlyUpdateGuard.skipIfFocusOnly(state)) return;
        const tableRef = state.tableRef;
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (!tree) return;
        this.focusOnlyUpdateGuard.markProcessed(state);
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotSticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer === null || tableContainer === void 0 ? void 0 : tableContainer.parentElement;
        if (tableContentWrapper) {
            if (isCurrentTableSelected) this.colControlsOffset = (0, $4Tw3G.tableControlsSpacing);
            else this.colControlsOffset = 0;
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $7JtQD.syncStickyRowToTable)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (!tree) return;
        (0, $7JtQD.syncStickyRowToTable)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isSticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    makeHeaderRowSticky(tree, scrollTop) {
        var _tbody$firstChild;
        // If header row height is more than 50% of viewport height don't do this
        if (this.isSticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody === null || tbody === void 0 || (_tbody$firstChild = tbody.firstChild) === null || _tbody$firstChild === void 0 ? void 0 : _tbody$firstChild.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $6lkZH.getTop)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isSticky) {
            var _this$editorScrollabl5;
            (0, $7JtQD.syncStickyRowToTable)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $YREXK.TableCssClassName).TABLE_STICKY);
            this.isSticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            (_this$editorScrollabl5 = this.editorScrollableElement) === null || _this$editorScrollabl5 === void 0 || _this$editorScrollabl5.addEventListener('scrollend', (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? this.onScrollEnd : this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $7JtQD.updateStickyMargins)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotSticky(table, isEditorDestroyed = false) {
        if (!this.isSticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) (0, $7JtQD.clearStickyCornerMaskPositions)(table);
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $YREXK.TableCssClassName).TABLE_STICKY);
        this.isSticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $4Tw3G.tableControlsSpacing);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $6lkZH.getTop)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $3mliA.updateStickyState)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $3mliA.updateStickyState)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
}

});
parcelRegister("3mliA", function(module, exports) {
$parcel$export(module.exports, "updateStickyState", () => $56c53e4c2161bfa3$export$dd348cf8bfd51272);
// eslint-disable-next-line import/order

var $3Mjnn = parcelRequire("3Mjnn");
const $56c53e4c2161bfa3$export$dd348cf8bfd51272 = (rowState)=>(0, $3Mjnn.createCommand)({
        name: 'UPDATE',
        state: rowState
    }, (tr)=>tr.setMeta('addToHistory', false));
const $56c53e4c2161bfa3$export$98af81c5504c750e = (pos)=>(0, $3Mjnn.createCommand)({
        name: 'REMOVE',
        pos: pos
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("3Mjnn", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $228142d9c9b0ef59$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $228142d9c9b0ef59$export$8d4021544bdece00);

var $92jIL = parcelRequire("92jIL");

var $fkY0k = parcelRequire("fkY0k");
const $228142d9c9b0ef59$var$reducer = (pluginState, action)=>{
    if (action.name === 'UPDATE') {
        let updated = false;
        const updatedState = pluginState.map((oldTableState)=>{
            const replace = oldTableState.pos === action.state.pos;
            if (replace) updated = true;
            return replace ? action.state : oldTableState;
        });
        if (!updated) // new, add it
        updatedState.push(action.state);
        return updatedState;
    } else if (action.name === 'REMOVE') return pluginState.filter((rowState)=>rowState.pos !== action.pos);
    return pluginState;
};
const $228142d9c9b0ef59$var$dest = (0, $92jIL.pluginFactory)((0, $fkY0k.pluginKey), $228142d9c9b0ef59$var$reducer, {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) return pluginState.map((rowInfo)=>{
            const remapped = tr.mapping.mapResult(rowInfo.pos);
            return remapped ? {
                ...rowInfo,
                pos: remapped.pos
            } : undefined;
        }).filter((f)=>f !== undefined);
        return pluginState;
    }
});
const $228142d9c9b0ef59$export$656c7661095efe2e = $228142d9c9b0ef59$var$dest.createPluginState;
const $228142d9c9b0ef59$export$8d4021544bdece00 = $228142d9c9b0ef59$var$dest.createCommand;

});


parcelRegister("izDjd", function(module, exports) {
$parcel$export(module.exports, "FocusOnlyUpdateGuard", () => $ee37a18629b04fbf$export$4124286c1598f96);

var $bcN2K = parcelRequire("bcN2K");
const $ee37a18629b04fbf$export$7382be4c14e93ee7 = (previousValue, currentValue, ignoredKey)=>{
    const previousKeys = Object.keys(previousValue);
    const currentKeys = Object.keys(currentValue);
    return previousKeys.length === currentKeys.length && currentKeys.every((key)=>key === ignoredKey || Object.prototype.hasOwnProperty.call(previousValue, key) && Object.is(previousValue[key], currentValue[key]));
};
const $ee37a18629b04fbf$export$657c984e7f802f32 = (previousState, currentState)=>previousState.editorHasFocus !== currentState.editorHasFocus && $ee37a18629b04fbf$export$7382be4c14e93ee7(previousState, currentState, 'editorHasFocus');
class $ee37a18629b04fbf$export$4124286c1598f96 {
    /** Returns true and records the state when this is a skippable focus-only update. */ skipIfFocusOnly(state) {
        const lastProcessedState = this.lastProcessedState;
        if (lastProcessedState !== undefined && $ee37a18629b04fbf$export$657c984e7f802f32(lastProcessedState, state) && (0, $bcN2K.isExperimentEnabled)('platform_editor_improve_inp')) {
            this.lastProcessedState = state;
            return true;
        }
        return false;
    }
    markProcessed(state) {
        this.lastProcessedState = state;
    }
    reset() {
        this.lastProcessedState = undefined;
    }
}

});


parcelRegister("h6dLY", function(module, exports) {
$parcel$export(module.exports, "default", () => $74c394e2bf1fca9d$export$2e2bcd8739ae039);

var $53bjB = parcelRequire("53bjB");

var $030TE = parcelRequire("030TE");

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $5DGsr = parcelRequire("5DGsr");

var $7cwGc = parcelRequire("7cwGc");

var $8kZ6E = parcelRequire("8kZ6E");

var $jd8X7 = parcelRequire("jd8X7");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $cbJui = parcelRequire("cbJui");

var $4GJqd = parcelRequire("4GJqd");

var $4dyXt = parcelRequire("4dyXt");

var $3mliA = parcelRequire("3mliA");

var $7JtQD = parcelRequire("7JtQD");

var $6lkZH = parcelRequire("6lkZH");

var $4WYVI = parcelRequire("4WYVI");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $izDjd = parcelRequire("izDjd");

var $1U3XY = parcelRequire("1U3XY");
// limit scroll event calls
const $74c394e2bf1fca9d$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT = 200;
// timeout for resetting the scroll class - if it's too long then users won't be able to click on the header cells,
// if too short it would trigger too many dom updates.
const $74c394e2bf1fca9d$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT = 400;
class $74c394e2bf1fca9d$export$2e2bcd8739ae039 extends (0, $1U3XY.default) {
    constructor(node, view, getPos, eventDispatcher, api){
        super(node, view, getPos, eventDispatcher), this.cleanup = ()=>{
            var _this$onEditorContent;
            if (this.isStickyHeaderEnabled) {
                this.unsubscribe();
                this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
                const tree = (0, $6lkZH.getTree)(this.dom);
                if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
                this.emitOff(false);
            }
            if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
            (_this$onEditorContent = this.onEditorContentAreaHeightChange) === null || _this$onEditorContent === void 0 || _this$onEditorContent.call(this);
        }, this.colControlsOffset = 0, this.focused = false, this.focusOnlyUpdateGuard = new (0, $izDjd.FocusOnlyUpdateGuard)(), this.topPosEditorElement = 0, this.sentinels = {}, this.sentinelData = {
            top: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            },
            bottom: {
                isIntersecting: false,
                boundingClientRect: null,
                rootBounds: null
            }
        }, this.listening = false, this.padding = 0, this.top = 0, this.hasScrolledSinceLoad = false, this.disableNativeSticky = false, this.isSingleRowTable = false, /**
   * Methods
   */ this.headerRowMouseScrollEnd = (0, (/*@__PURE__*/$parcel$interopDefault($53bjB)))(()=>{
            this.dom.classList.remove('no-pointer-events');
        }, $74c394e2bf1fca9d$var$HEADER_ROW_SCROLL_RESET_DEBOUNCE_TIMEOUT), // When the header is sticky, the header row is set to position: fixed
        // This prevents mouse wheel scrolling on the scroll-parent div when user's mouse is hovering the header row.
        // This fix sets pointer-events: none on the header row briefly to avoid this behaviour
        this.headerRowMouseScroll = (0, (/*@__PURE__*/$parcel$interopDefault($030TE)))(()=>{
            if (this.isLegacySticky) {
                this.dom.classList.add('no-pointer-events');
                this.headerRowMouseScrollEnd();
            }
        }, $74c394e2bf1fca9d$var$HEADER_ROW_SCROLL_THROTTLE_TIMEOUT), this.onWidthPluginEvent = ()=>this.updateStickyHeaderWidth(), this.onTablePluginEvent = (state)=>this.onTablePluginState(state), this.onScrollEnd = ()=>this.refireIntersectionObservers(), this.toggleDisableNativeSticky = (headerHeight, viewportHeight)=>{
            if (!this.disableNativeSticky && headerHeight > viewportHeight * 0.5) {
                this.disableNativeSticky = true;
                if (this.isNativeSticky === undefined) this.dom.classList.remove((0, $YREXK.TableCssClassName).NATIVE_STICKY);
            }
            if (this.disableNativeSticky && headerHeight <= viewportHeight * 0.5) this.disableNativeSticky = false;
        };
        const rowIndex = (0, $4WYVI.getTableRowIndex)(view, getPos);
        this.isHeaderRow = (0, $4WYVI.supportedHeaderRow)(node, rowIndex);
        if (this.isHeaderRow) this.isSingleRowTable = this.checkIsSingleRowTable();
        this.isLegacySticky = false;
        const { pluginConfig: pluginConfig } = (0, $4GJqd.getPluginState)(view.state);
        this.isStickyHeaderEnabled = !!pluginConfig.stickyHeaders;
        this.api = api;
        // Sticky headers are the only thing limited mode turns off here, so there is nothing to read
        // or subscribe to when they were never enabled for this editor.
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
            var _api$limitedMode, _limitedMode$currentS;
            const limitedMode = this.isStickyHeaderEnabled ? api === null || api === void 0 || (_api$limitedMode = api.limitedMode) === null || _api$limitedMode === void 0 ? void 0 : _api$limitedMode.sharedState : undefined;
            if (limitedMode !== null && limitedMode !== void 0 && (_limitedMode$currentS = limitedMode.currentState()) !== null && _limitedMode$currentS !== void 0 && _limitedMode$currentS.enabled) this.isStickyHeaderEnabled = false;
            else this.limitedModeUnsubscribe = limitedMode === null || limitedMode === void 0 ? void 0 : limitedMode.onChange(({ nextSharedState: nextSharedState })=>{
                var _this$limitedModeUnsu;
                if (!(nextSharedState !== null && nextSharedState !== void 0 && nextSharedState.enabled)) return;
                // Order matters: cleanup() short-circuits unless sticky headers are still marked enabled.
                this.cleanup();
                this.isStickyHeaderEnabled = false;
                // Limited mode never turns back off, so this listener has done its job.
                (_this$limitedModeUnsu = this.limitedModeUnsubscribe) === null || _this$limitedModeUnsu === void 0 || _this$limitedModeUnsu.call(this);
                this.limitedModeUnsubscribe = undefined;
            });
        } else {
            var _api$limitedMode2;
            if (api !== null && api !== void 0 && (_api$limitedMode2 = api.limitedMode) !== null && _api$limitedMode2 !== void 0 && (_api$limitedMode2 = _api$limitedMode2.sharedState.currentState()) !== null && _api$limitedMode2 !== void 0 && (_api$limitedMode2 = _api$limitedMode2.limitedModePluginKey.getState(view.state)) !== null && _api$limitedMode2 !== void 0 && _api$limitedMode2.documentSizeBreachesThreshold) {
                this.isStickyHeaderEnabled = false;
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                document.addEventListener('limited-mode-activated', this.cleanup);
            }
        }
        const pos = this.getPos();
        this.isInNestedTable = false;
        try {
            // We cannot trust that the value from getPos will be defined
            // https://discuss.prosemirror.net/t/getpos-is-undefined-in-nodeview-constructor/1246/4
            // There are also scenarios where the value it brings back does not tally with the current doc
            // E.g. when AI streaming brings in new content, this position brings back incorrect values that cannot be resolved
            if (pos) this.isInNestedTable = (0, $5DGsr.getParentOfTypeCount)(view.state.schema.nodes.table)(view.state.doc.resolve(pos)) > 1;
        } catch  {
        // Intentionally swallowed — getPos can return stale positions during AI streaming
        }
        if (this.isHeaderRow) {
            this.dom.setAttribute('data-vc-nvs', 'true');
            const { observe: observe } = (0, $7cwGc.nodeVisibilityManager)(view.dom);
            this.nodeVisibilityObserverCleanupFn = observe({
                element: this.contentDOM,
                onFirstVisible: ()=>{
                    this.subscribeWhenRowVisible();
                }
            });
        }
        if (this.isHeaderRow && this.isStickyHeaderEnabled) {
            var _api$table;
            this.onEditorContentAreaHeightChange = api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 ? void 0 : _api$table.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (nextSharedState !== null && nextSharedState !== void 0 && nextSharedState.editorContentAreaHeight && (nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.editorContentAreaHeight) !== this.editorContentAreaHeight) {
                    this.editorContentAreaHeight = nextSharedState.editorContentAreaHeight;
                    this.toggleDisableNativeSticky(this.stickyRowHeight ?? 0, nextSharedState.editorContentAreaHeight);
                }
            });
        }
    }
    subscribeWhenRowVisible() {
        if (this.listening) return;
        this.dom.setAttribute('data-header-row', 'true');
        if (this.isStickyHeaderEnabled) this.subscribe();
    }
    /**
   * Methods: Nodeview Lifecycle
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    update(node, ..._args) {
        if (this.isHeaderRow) this.updateSingleRowTableStickyHeaderState();
        // do nothing if nodes were identical
        if (node === this.node) return true;
        // see if we're changing into a header row or
        // changing away from one
        const rowIndex = (0, $4WYVI.getTableRowIndex)(this.view, this.getPos);
        const newNodeIsHeaderRow = (0, $4WYVI.supportedHeaderRow)(node, rowIndex);
        if (this.isHeaderRow !== newNodeIsHeaderRow) {
            if (!newNodeIsHeaderRow && this.isHeaderRow) {
                var _this$dom$closest;
                (_this$dom$closest = this.dom.closest(`.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`)) === null || _this$dom$closest === void 0 || _this$dom$closest.classList.remove((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW);
            }
            return false; // re-create nodeview
        }
        // node is different but no need to re-create nodeview
        this.node = node;
        // don't do anything if we're just a regular tr
        if (!this.isHeaderRow) return true;
        // something changed, sync widths
        if (this.isStickyHeaderEnabled) {
            const tbody = this.dom.parentElement;
            const table = tbody && tbody.parentElement;
            (0, $7JtQD.syncStickyRowToTable)(table);
        }
        return true;
    }
    destroy() {
        if (this.isStickyHeaderEnabled) {
            var _this$nodeVisibilityO;
            this.unsubscribe();
            this.overflowObserver && this.overflowObserver.disconnect();
            this.overflowObserverEntries = undefined;
            this.stickyStateObserver && this.stickyStateObserver.disconnect();
            (_this$nodeVisibilityO = this.nodeVisibilityObserver) === null || _this$nodeVisibilityO === void 0 || _this$nodeVisibilityO.disconnect();
            if (!(0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) this.nodeVisibilityObserverCleanupFn && this.nodeVisibilityObserverCleanupFn();
            const tree = (0, $6lkZH.getTree)(this.dom);
            if (tree) this.makeRowHeaderNotLegacySticky(tree.table, true);
            this.emitOff(true);
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            var _this$nodeVisibilityO2, _this$onEditorContent2;
            (_this$nodeVisibilityO2 = this.nodeVisibilityObserverCleanupFn) === null || _this$nodeVisibilityO2 === void 0 || _this$nodeVisibilityO2.call(this);
            this.nodeVisibilityObserverCleanupFn = undefined;
            (_this$onEditorContent2 = this.onEditorContentAreaHeightChange) === null || _this$onEditorContent2 === void 0 || _this$onEditorContent2.call(this);
            this.onEditorContentAreaHeightChange = undefined;
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_dynamic_limited_mode')) {
            var _this$limitedModeUnsu2;
            (_this$limitedModeUnsu2 = this.limitedModeUnsubscribe) === null || _this$limitedModeUnsu2 === void 0 || _this$limitedModeUnsu2.call(this);
            this.limitedModeUnsubscribe = undefined;
        } else // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('limited-mode-activated', this.cleanup);
        if (this.tableContainerObserver) this.tableContainerObserver.disconnect();
    }
    ignoreMutation(mutationRecord) {
        /* tableRows are not directly editable by the user
     * so it should be safe to ignore mutations that we cause
     * by updating styles and classnames on this DOM element
     *
     * Update: should not ignore mutations for row selection to avoid known issue with table selection highlight in firefox
     * Related bug report: https://bugzilla.mozilla.org/show_bug.cgi?id=1289673
     * */ const isTableSelection = mutationRecord.type === 'selection' && mutationRecord.target.nodeName === 'TR';
        /**
     * Update: should not ignore mutations when an node is added, as this interferes with
     * prosemirrors handling of some language inputs in Safari (ie. Pinyin, Hiragana).
     *
     * In paticular, when a composition occurs at the start of the first node inside a table cell, if the resulting mutation
     * from the composition end is ignored than prosemirror will end up with; invalid table markup nesting and a misplaced
     * selection and insertion.
     */ const isNodeInsertion = mutationRecord.type === 'childList' && mutationRecord.target.nodeName === 'TR' && mutationRecord.addedNodes.length;
        if (isTableSelection || isNodeInsertion) return false;
        return true;
    }
    subscribe() {
        this.focusOnlyUpdateGuard.reset();
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorScrollableElement = (0, $8kZ6E.findOverflowScrollParent)(this.view.dom) || window;
        if (this.editorScrollableElement) {
            this.initObservers();
            this.topPosEditorElement = (0, $6lkZH.getTop)(this.editorScrollableElement);
            this.scrollListener = ()=>{
                if (this.hasScrolledSinceLoad) return;
                this.hasScrolledSinceLoad = true;
                if (!this.overflowObserver) return;
                // Re-check intersection state now that scrolling has occurred
                const entries = this.overflowObserverEntries ?? this.overflowObserver.takeRecords();
                this.overflowObserverEntries = undefined;
                /** NOTE: This logic is duplicated in the overflowObserver callback
         *  to avoid conflicting with a follow up refactor where this will
         *  be cleaned up.
         */ entries.forEach((entry)=>{
                    if (this.updateSingleRowTableStickyHeaderState()) return;
                    const tableWrapper = this.dom.closest(`.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`);
                    if (tableWrapper && tableWrapper instanceof HTMLElement && !(0, $6lkZH.areAllRectsZero)(entry)) {
                        if (entry.isIntersecting) {
                            tableWrapper.classList.add((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                            this.dom.classList.add((0, $YREXK.TableCssClassName).NATIVE_STICKY);
                            this.isNativeSticky = true;
                        } else {
                            tableWrapper.classList.remove((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                            this.dom.classList.remove((0, $YREXK.TableCssClassName).NATIVE_STICKY);
                            this.isNativeSticky = false;
                        }
                        this.refreshLegacyStickyState();
                    }
                });
            };
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement.addEventListener('scroll', this.scrollListener, {
                passive: true,
                once: true
            });
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            this.eventDispatcher.on('widthPlugin', this.onWidthPluginEvent);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.on((0, $4dyXt.pluginKey).key, this.onTablePluginEvent);
        } else {
            this.eventDispatcher.on('widthPlugin', this.updateStickyHeaderWidth.bind(this));
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.on((0, $4dyXt.pluginKey).key, this.onTablePluginState.bind(this));
        }
        this.listening = true;
        const scrollHandler = (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? this.headerRowMouseScroll : this.headerRowMouseScroll.bind(this);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('wheel', scrollHandler, {
            passive: true
        });
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.addEventListener('touchmove', scrollHandler, {
            passive: true
        });
    }
    unsubscribe() {
        this.focusOnlyUpdateGuard.reset();
        if (!this.listening) return;
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            // ED-16211 Once intersection observer is disconnected, we need to remove the isObserved from the sentinels
            // Otherwise when newer intersection observer is created it will not observe because it thinks its already being observed
            [
                this.sentinels.top,
                this.sentinels.bottom
            ].forEach((el)=>{
                if (el) delete el.dataset.isObserved;
            });
        }
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.scrollListener && this.editorScrollableElement) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            this.editorScrollableElement.removeEventListener('scroll', this.scrollListener);
            this.scrollListener = undefined;
        }
        if ((0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            var _this$editorScrollabl;
            this.eventDispatcher.off('widthPlugin', this.onWidthPluginEvent);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.off((0, $4dyXt.pluginKey).key, this.onTablePluginEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            (_this$editorScrollabl = this.editorScrollableElement) === null || _this$editorScrollabl === void 0 || _this$editorScrollabl.removeEventListener('scrollend', this.onScrollEnd);
        } else {
            this.eventDispatcher.off('widthPlugin', this.updateStickyHeaderWidth);
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.eventDispatcher.off((0, $4dyXt.pluginKey).key, this.onTablePluginState);
        }
        this.listening = false;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('wheel', this.headerRowMouseScroll);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.dom.removeEventListener('touchmove', this.headerRowMouseScroll);
    }
    initOverflowObserver() {
        const tableWrapper = this.dom.closest(`.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`);
        if (!tableWrapper) return;
        const options = {
            root: tableWrapper,
            threshold: 1
        };
        this.overflowObserver = new IntersectionObserver((entries, observer)=>{
            entries.forEach((entry)=>{
                var _this$api;
                if (!(observer.root instanceof HTMLElement)) return;
                if (this.updateSingleRowTableStickyHeaderState()) return;
                // Only apply classes if page has scrolled since load
                if (!this.hasScrolledSinceLoad) {
                    this.overflowObserverEntries = entries;
                    return;
                }
                if (entry.isIntersecting) {
                    observer.root.classList.add((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                    if (!this.disableNativeSticky) this.dom.classList.add((0, $YREXK.TableCssClassName).NATIVE_STICKY);
                    this.isNativeSticky = true;
                } else {
                    observer.root.classList.remove((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW);
                    this.dom.classList.remove((0, $YREXK.TableCssClassName).NATIVE_STICKY);
                    this.isNativeSticky = false;
                }
                this.refreshLegacyStickyState();
                (_this$api = this.api) === null || _this$api === void 0 || (_this$api = _this$api.analytics) === null || _this$api === void 0 || (_this$api = _this$api.actions) === null || _this$api === void 0 || _this$api.fireAnalyticsEvent({
                    action: (0, $8d4kB.TABLE_ACTION).STICKY_HEADER_METHOD_TOGGLED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE_STICKY_HEADER,
                    eventType: (0, $3LeME.EVENT_TYPE).UI,
                    attributes: {
                        nativeStickyHeaderEnabled: entry.isIntersecting
                    }
                });
            });
        }, options);
    }
    /**
   * This observer is used to track the 'stuck' state of the header row.
   * This roughly mimics `(at)container scroll-state(stuck: top)` in CSS,
   * but with full browser support.
   */ initStickyStateObserver() {
        if (!this.editorScrollableElement || !(this.editorScrollableElement instanceof Element)) return;
        const options = {
            root: this.editorScrollableElement,
            rootMargin: `-${(0, $jd8X7.tableMarginTop) + 1}px 0px 0px 0px`,
            threshold: 1
        };
        this.stickyStateObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _entry$rootBounds;
                if (this.updateSingleRowTableStickyHeaderState()) return;
                const tableContainer = this.dom.closest(`.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER}`);
                if (entry.intersectionRect.top === ((_entry$rootBounds = entry.rootBounds) === null || _entry$rootBounds === void 0 ? void 0 : _entry$rootBounds.top) && !this.disableNativeSticky) {
                    this.dom.classList.add((0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) tableContainer.dataset.tableHeaderIsStuck = 'true';
                } else {
                    this.dom.classList.remove((0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE);
                    if (tableContainer && tableContainer instanceof HTMLElement) delete tableContainer.dataset.tableHeaderIsStuck;
                }
            });
        }, options);
    }
    // initialize intersection observer to track if table is within scroll area
    initObservers() {
        if (!this.dom || this.dom.dataset.isObserved) return;
        this.dom.dataset.isObserved = 'true';
        this.createIntersectionObserver();
        this.createResizeObserver();
        if (!this.intersectionObserver || !this.resizeObserver) return;
        if (this.isHeaderRow && !this.isInNestedTable) {
            var _this$stickyStateObse;
            if ((0, $aEmSo.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true)) this.dom.style.setProperty('anchor-name', this.dom.getAttribute('data-node-anchor') ?? '');
            this.initOverflowObserver();
            this.initNodeVisibilityObserver();
            const closestTable = this.dom.closest('table');
            if (closestTable) {
                var _this$overflowObserve, _this$nodeVisibilityO3;
                (_this$overflowObserve = this.overflowObserver) === null || _this$overflowObserve === void 0 || _this$overflowObserve.observe(closestTable);
                (_this$nodeVisibilityO3 = this.nodeVisibilityObserver) === null || _this$nodeVisibilityO3 === void 0 || _this$nodeVisibilityO3.observe(closestTable);
            }
            this.initStickyStateObserver();
            (_this$stickyStateObse = this.stickyStateObserver) === null || _this$stickyStateObse === void 0 || _this$stickyStateObse.observe(this.dom);
        }
        this.resizeObserver.observe(this.dom);
        if (this.editorScrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.resizeObserver.observe(this.editorScrollableElement);
        window.requestAnimationFrame(()=>{
            const getTableContainer = ()=>{
                var _getTree;
                return (_getTree = (0, $6lkZH.getTree)(this.dom)) === null || _getTree === void 0 ? void 0 : _getTree.wrapper.closest(`.${(0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER}`);
            };
            // we expect tree to be defined after animation frame
            let tableContainer = getTableContainer();
            if (tableContainer) {
                const getSentinelTop = ()=>tableContainer && // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    tableContainer.getElementsByClassName((0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP).item(0);
                const getSentinelBottom = ()=>{
                    // Multiple bottom sentinels may be found if there are nested tables.
                    // We need to make sure we get the last one which will belong to the parent table.
                    const bottomSentinels = tableContainer && tableContainer.getElementsByClassName((0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM);
                    return(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    bottomSentinels && bottomSentinels.item(bottomSentinels.length - 1));
                };
                const sentinelsInDom = ()=>getSentinelTop() !== null && getSentinelBottom() !== null;
                const observeStickySentinels = ()=>{
                    this.sentinels.top = getSentinelTop();
                    this.sentinels.bottom = getSentinelBottom();
                    [
                        this.sentinels.top,
                        this.sentinels.bottom
                    ].forEach((el)=>{
                        // skip if already observed for another row on this table
                        if (el && !el.dataset.isObserved) {
                            el.dataset.isObserved = 'true';
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.intersectionObserver.observe(el);
                        }
                    });
                };
                const isInitialProsemirrorToDomRender = tableContainer.hasAttribute('data-prosemirror-initial-toDOM-render');
                // Sentinels may be in the DOM but they're part of the prosemirror placeholder structure which is replaced with the fully rendered React node.
                if (sentinelsInDom() && !isInitialProsemirrorToDomRender) // great - DOM ready, observe as normal
                observeStickySentinels();
                else {
                    // concurrent loading issue - here TableRow is too eager trying to
                    // observe sentinels before they are in the DOM, use MutationObserver
                    // to wait for sentinels to be added to the parent Table node DOM
                    // then attach the IntersectionObserver
                    this.tableContainerObserver = new MutationObserver(()=>{
                        // Check if the tableContainer is still connected to the DOM. It can become disconnected when the placholder
                        // prosemirror node is replaced with the fully rendered React node (see _handleTableRef).
                        if (!tableContainer || !tableContainer.isConnected) tableContainer = getTableContainer();
                        if (sentinelsInDom()) {
                            var _this$tableContainerO;
                            observeStickySentinels();
                            (_this$tableContainerO = this.tableContainerObserver) === null || _this$tableContainerO === void 0 || _this$tableContainerO.disconnect();
                        }
                    });
                    const mutatingNode = tableContainer;
                    if (mutatingNode && this.tableContainerObserver) this.tableContainerObserver.observe(mutatingNode, {
                        subtree: true,
                        childList: true
                    });
                }
            }
        });
    }
    // initialise intersection observer to track whether table is in scroll area
    initNodeVisibilityObserver() {
        this.nodeVisibilityObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (this.updateSingleRowTableStickyHeaderState()) return;
                if (!this.isNativeSticky) return;
                if (entry.intersectionRatio !== 0 && entry.intersectionRatio !== 1) return;
                if (this.disableNativeSticky === true) this.dom.classList.remove((0, $YREXK.TableCssClassName).NATIVE_STICKY);
                if (this.disableNativeSticky === false) this.dom.classList.add((0, $YREXK.TableCssClassName).NATIVE_STICKY);
            });
        }, {
            threshold: [
                0,
                0.05,
                0.95,
                1
            ]
        });
    }
    // updating bottom sentinel position if sticky header height changes
    // to allocate for new header height
    createResizeObserver() {
        this.resizeObserver = new ResizeObserver((entries)=>{
            const tree = (0, $6lkZH.getTree)(this.dom);
            if (!tree) return;
            const { table: table } = tree;
            entries.forEach((entry)=>{
                var _this$editorScrollabl2;
                // On resize of the parent scroll element we need to adjust the width
                // of the sticky header
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (entry.target.className === ((_this$editorScrollabl2 = this.editorScrollableElement) === null || _this$editorScrollabl2 === void 0 ? void 0 : _this$editorScrollabl2.className)) this.updateStickyHeaderWidth();
                else {
                    const newHeight = entry.contentRect ? entry.contentRect.height : // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    entry.target.offsetHeight;
                    if (this.sentinels.bottom && // When the table header is sticky, it would be taller by a 1px (border-bottom),
                    // So we adding this check to allow a 1px difference.
                    Math.abs(newHeight - (this.stickyRowHeight || 0)) > (0, $4Tw3G.stickyHeaderBorderBottomWidth)) {
                        this.stickyRowHeight = newHeight;
                        this.sentinels.bottom.style.bottom = `${(0, $4Tw3G.tableScrollbarOffset) + (0, $4Tw3G.stickyRowOffsetTop) + newHeight}px`;
                        (0, $7JtQD.updateStickyMargins)(table);
                    }
                    const viewportHeight = this.editorContentAreaHeight ?? (0, $cbJui.INITIAL_STATIC_VIEWPORT_HEIGHT);
                    this.toggleDisableNativeSticky(newHeight, viewportHeight);
                }
            });
        });
    }
    createIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries, _)=>{
            var _this$editorScrollabl3, _this$editorScrollabl4;
            // IMPORTANT: please try and avoid using entry.rootBounds it's terribly inconsistent. For example; sometimes it may return
            // 0 height. In safari it will multiply all values by the window scale factor, however chrome & firfox won't.
            // This is why i just get the scroll view bounding rect here and use it, and fallback to the entry.rootBounds if needed.
            const rootBounds = (_this$editorScrollabl3 = this.editorScrollableElement) === null || _this$editorScrollabl3 === void 0 || (_this$editorScrollabl4 = _this$editorScrollabl3.getBoundingClientRect) === null || _this$editorScrollabl4 === void 0 ? void 0 : _this$editorScrollabl4.call(_this$editorScrollabl3);
            entries.forEach((entry)=>{
                const { target: target, isIntersecting: isIntersecting, boundingClientRect: boundingClientRect } = entry;
                // This observer only every looks at the top/bottom sentinels, we can assume if it's not one then it's the other.
                const targetKey = target.classList.contains((0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP) ? 'top' : 'bottom';
                // Cache the latest sentinel information
                this.sentinelData[targetKey] = {
                    isIntersecting: isIntersecting,
                    boundingClientRect: boundingClientRect,
                    rootBounds: rootBounds ?? entry.rootBounds
                };
                // Keep the other sentinels rootBounds in sync with this latest one
                this.sentinelData[targetKey === 'top' ? 'bottom' : targetKey].rootBounds = rootBounds ?? entry.rootBounds;
            });
            this.refreshLegacyStickyState();
        }, {
            threshold: 0,
            root: this.editorScrollableElement
        });
    }
    refreshLegacyStickyState() {
        if (this.updateSingleRowTableStickyHeaderState()) return;
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (!tree) return;
        const { table: table } = tree;
        if (this.isNativeSticky) {
            this.makeRowHeaderNotLegacySticky(table);
            return;
        }
        const shouldStick = this.shouldSticky();
        if (this.isLegacySticky !== shouldStick) {
            if (shouldStick) {
                // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
                const rootRect = this.sentinelData.top.rootBounds ?? this.sentinelData.bottom.rootBounds;
                this.makeHeaderRowLegacySticky(tree, rootRect === null || rootRect === void 0 ? void 0 : rootRect.top);
            } else this.makeRowHeaderNotLegacySticky(table);
        }
    }
    shouldSticky() {
        if (// is Safari
        navigator.userAgent.includes('AppleWebKit') && !navigator.userAgent.includes('Chrome')) {
            const pos = this.getPos();
            if (typeof pos === 'number') try {
                // getPos can return stale positions during AI streaming which cannot be resolved
                const $tableRowPos = this.view.state.doc.resolve(pos);
                // layout -> layout column -> table -> table row
                if ($tableRowPos.depth >= 3) {
                    var _findParentNodeCloses;
                    const isInsideLayout = (_findParentNodeCloses = (0, $a4TQr.findParentNodeClosestToPos)($tableRowPos, (node)=>{
                        return node.type.name === 'layoutColumn';
                    })) === null || _findParentNodeCloses === void 0 ? void 0 : _findParentNodeCloses.node;
                    if (isInsideLayout) return false;
                }
            } catch  {
                // getPos can return stale positions during AI streaming — fall back to non-sticky
                return false;
            }
        }
        return this.isHeaderSticky();
    }
    isHeaderSticky() {
        /*
    # Overview
     I'm going to list all the view states associated with the sentinels and when they should trigger sticky headers.
     The format of the states are;    {top|bottom}:{in|above|below}
     ie sentinel:view-position -- both "above" and "below" are equal to out of the viewport
      For example; "top:in" means top sentinel is within the viewport. "bottom:above" means the bottom sentinel is
     above and out of the viewport
      This will hopefully simplify things and make it easier to determine when sticky should/shouldn't be triggered.
    # States
     top:in / bottom:in - NOT sticky
     top:in / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:in / bottom:below - NOT sticky
     top:above / bottom:in - STICKY
     top:above / bottom:above - NOT sticky
     top:above / bottom:below - STICKY
     top:below / bottom:in - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:above - NOT sticky - NOTE: This is an inversion clause
     top:below / bottom:below - NOT sticky
    # Summary
     The only time the header should be sticky is when the top sentinel is above the view and the bottom sentinel
     is in or below it.
    */ const { top: sentinelTop, bottom: sentinelBottom } = this.sentinelData;
        // The rootRect is kept in sync across sentinels so it doesn't matter which one we use.
        const rootBounds = sentinelTop.rootBounds ?? sentinelBottom.rootBounds;
        if (!rootBounds || !sentinelTop.boundingClientRect || !sentinelBottom.boundingClientRect) return false;
        // Normalize the sentinels to y points
        // Since the sentinels are actually rects 1px high we want make sure we normalise the inner most values closest to the table.
        const sentinelTopY = sentinelTop.boundingClientRect.bottom;
        const sentinelBottomY = sentinelBottom.boundingClientRect.top;
        // If header row height is more than 50% of viewport height don't do this
        const isRowHeaderTooLarge = this.stickyRowHeight && this.stickyRowHeight > window.innerHeight * 0.5;
        const isTopSentinelAboveScrollArea = !sentinelTop.isIntersecting && sentinelTopY <= rootBounds.top;
        const isBottomSentinelInOrBelowScrollArea = sentinelBottom.isIntersecting || sentinelBottomY > rootBounds.bottom;
        // This makes sure that the top sentinel is actually above the bottom sentinel, and that they havn't inverted.
        const isTopSentinelAboveBottomSentinel = sentinelTopY < sentinelBottomY;
        return isTopSentinelAboveScrollArea && isBottomSentinelInOrBelowScrollArea && isTopSentinelAboveBottomSentinel && !isRowHeaderTooLarge;
    }
    /* receive external events */ onTablePluginState(state) {
        if (this.focusOnlyUpdateGuard.skipIfFocusOnly(state)) return;
        const tableRef = state.tableRef;
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (!tree) return;
        this.focusOnlyUpdateGuard.markProcessed(state);
        // when header rows are toggled off - mark sentinels as unobserved
        if (!state.isHeaderRowEnabled) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el) delete el.dataset.isObserved;
        });
        const isCurrentTableSelected = tableRef === tree.table;
        // If current table selected and header row is toggled off, turn off sticky header
        if (isCurrentTableSelected && !state.isHeaderRowEnabled && tree) this.makeRowHeaderNotLegacySticky(tree.table);
        this.focused = isCurrentTableSelected;
        const { wrapper: wrapper } = tree;
        const tableContainer = wrapper.parentElement;
        const tableContentWrapper = tableContainer === null || tableContainer === void 0 ? void 0 : tableContainer.parentElement;
        if (tableContentWrapper) {
            if (isCurrentTableSelected) this.colControlsOffset = (0, $4Tw3G.tableControlsSpacing);
            else this.colControlsOffset = 0;
        }
        // run after table style changes have been committed
        setTimeout(()=>{
            (0, $7JtQD.syncStickyRowToTable)(tree.table);
        }, 0);
    }
    updateStickyHeaderWidth() {
        // table width might have changed, sync that back to sticky row
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (!tree) return;
        (0, $7JtQD.syncStickyRowToTable)(tree.table);
    }
    /**
   * Manually refire the intersection observers.
   * Useful when the header may have detached from the table.
   */ refireIntersectionObservers() {
        if (this.isLegacySticky) [
            this.sentinels.top,
            this.sentinels.bottom
        ].forEach((el)=>{
            if (el && this.intersectionObserver) {
                this.intersectionObserver.unobserve(el);
                this.intersectionObserver.observe(el);
            }
        });
    }
    checkIsSingleRowTable() {
        const pos = this.getPos();
        if (typeof pos !== 'number') return false;
        try {
            var _findParentNodeCloses2;
            const $tableRowPos = this.view.state.doc.resolve(pos);
            const tableNode = (_findParentNodeCloses2 = (0, $a4TQr.findParentNodeClosestToPos)($tableRowPos, (node)=>node.type === this.view.state.schema.nodes.table)) === null || _findParentNodeCloses2 === void 0 ? void 0 : _findParentNodeCloses2.node;
            return (tableNode === null || tableNode === void 0 ? void 0 : tableNode.childCount) === 1;
        } catch  {
            // getPos can return stale positions during AI streaming. Preserve the original sticky
            // header behaviour when the containing table cannot be determined.
            return false;
        }
    }
    updateSingleRowTableStickyHeaderState() {
        const wasSingleRowTable = this.isSingleRowTable;
        this.isSingleRowTable = this.checkIsSingleRowTable();
        if (this.isSingleRowTable) this.removeSingleRowTableStickyHeaderState();
        else if (wasSingleRowTable) this.refireNativeStickyObservers();
        return this.isSingleRowTable;
    }
    removeSingleRowTableStickyHeaderState() {
        this.dom.classList.remove((0, $YREXK.TableCssClassName).NATIVE_STICKY, (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE);
        this.isNativeSticky = false;
        const tableWrapper = this.dom.closest(`.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`);
        tableWrapper === null || tableWrapper === void 0 || tableWrapper.classList.remove((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW);
        const tableContainer = this.dom.closest(`.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER}`);
        if (tableContainer instanceof HTMLElement) delete tableContainer.dataset.tableHeaderIsStuck;
        const tree = (0, $6lkZH.getTree)(this.dom);
        if (tree) this.makeRowHeaderNotLegacySticky(tree.table);
    }
    refireNativeStickyObservers() {
        var _this$stickyStateObse2, _this$stickyStateObse3;
        const table = this.dom.closest('table');
        if (table) {
            var _this$overflowObserve2, _this$overflowObserve3, _this$nodeVisibilityO4, _this$nodeVisibilityO5;
            (_this$overflowObserve2 = this.overflowObserver) === null || _this$overflowObserve2 === void 0 || _this$overflowObserve2.unobserve(table);
            (_this$overflowObserve3 = this.overflowObserver) === null || _this$overflowObserve3 === void 0 || _this$overflowObserve3.observe(table);
            (_this$nodeVisibilityO4 = this.nodeVisibilityObserver) === null || _this$nodeVisibilityO4 === void 0 || _this$nodeVisibilityO4.unobserve(table);
            (_this$nodeVisibilityO5 = this.nodeVisibilityObserver) === null || _this$nodeVisibilityO5 === void 0 || _this$nodeVisibilityO5.observe(table);
        }
        (_this$stickyStateObse2 = this.stickyStateObserver) === null || _this$stickyStateObse2 === void 0 || _this$stickyStateObse2.unobserve(this.dom);
        (_this$stickyStateObse3 = this.stickyStateObserver) === null || _this$stickyStateObse3 === void 0 || _this$stickyStateObse3.observe(this.dom);
    }
    makeHeaderRowLegacySticky(tree, scrollTop) {
        var _tbody$firstChild;
        // If header row height is more than 50% of viewport height don't do this
        if (this.isLegacySticky || this.stickyRowHeight && this.stickyRowHeight > window.innerHeight / 2 || this.isInNestedTable) return;
        const { table: table, wrapper: wrapper } = tree;
        // TODO: ED-16035 - Make sure sticky header is only applied to first row
        const tbody = this.dom.parentElement;
        const isFirstHeader = tbody === null || tbody === void 0 || (_tbody$firstChild = tbody.firstChild) === null || _tbody$firstChild === void 0 ? void 0 : _tbody$firstChild.isEqualNode(this.dom);
        if (!isFirstHeader) return;
        const currentTableTop = this.getCurrentTableTop(tree);
        if (!scrollTop) scrollTop = (0, $6lkZH.getTop)(this.editorScrollableElement);
        const domTop = currentTableTop > 0 ? scrollTop : scrollTop + currentTableTop;
        if (!this.isLegacySticky) {
            var _this$editorScrollabl5;
            (0, $7JtQD.syncStickyRowToTable)(table);
            this.dom.classList.add('sticky');
            table.classList.add((0, $YREXK.TableCssClassName).TABLE_STICKY);
            this.isLegacySticky = true;
            /**
       * The logic below is not desirable, but acts as a fail safe for scenarios where the sticky header
       * detaches from the table. This typically happens during a fast scroll by the user which causes
       * the intersection observer logic to not fire as expected.
       */ // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            (_this$editorScrollabl5 = this.editorScrollableElement) === null || _this$editorScrollabl5 === void 0 || _this$editorScrollabl5.addEventListener('scrollend', (0, $bcN2K.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? this.onScrollEnd : this.refireIntersectionObservers, {
                passive: true,
                once: true
            });
            const fastScrollThresholdMs = 500;
            setTimeout(()=>{
                this.refireIntersectionObservers();
            }, fastScrollThresholdMs);
        }
        this.dom.style.top = `0px`;
        (0, $7JtQD.updateStickyMargins)(table);
        this.dom.scrollLeft = wrapper.scrollLeft;
        this.emitOn(domTop, this.colControlsOffset);
    }
    makeRowHeaderNotLegacySticky(table, isEditorDestroyed = false) {
        if (!this.isLegacySticky || !table || !this.dom) return;
        this.dom.style.removeProperty('width');
        if ((0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true)) (0, $7JtQD.clearStickyCornerMaskPositions)(table);
        this.dom.classList.remove('sticky');
        table.classList.remove((0, $YREXK.TableCssClassName).TABLE_STICKY);
        this.isLegacySticky = false;
        this.dom.style.top = '';
        table.style.removeProperty('margin-top');
        this.emitOff(isEditorDestroyed);
    }
    getWrapperoffset(inverse = false) {
        const focusValue = inverse ? !this.focused : this.focused;
        return focusValue ? 0 : (0, $4Tw3G.tableControlsSpacing);
    }
    getWrapperRefTop(wrapper) {
        return Math.round((0, $6lkZH.getTop)(wrapper)) + this.getWrapperoffset();
    }
    getScrolledTableTop(wrapper) {
        return this.getWrapperRefTop(wrapper) - this.topPosEditorElement;
    }
    getCurrentTableTop(tree) {
        return this.getScrolledTableTop(tree.wrapper) + tree.table.clientHeight;
    }
    /* emit external events */ emitOn(top, padding) {
        if (top === this.top && padding === this.padding) return;
        this.top = top;
        this.padding = padding;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (Number.isFinite(pos)) (0, $3mliA.updateStickyState)({
            pos: pos,
            top: top,
            sticky: true,
            padding: padding
        })(this.view.state, this.view.dispatch, this.view);
    }
    emitOff(isEditorDestroyed) {
        if (this.top === 0 && this.padding === 0) return;
        this.top = 0;
        this.padding = 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const pos = this.getPos();
        if (!isEditorDestroyed && Number.isFinite(pos)) (0, $3mliA.updateStickyState)({
            pos: pos,
            sticky: false,
            top: this.top,
            padding: this.padding
        })(this.view.state, this.view.dispatch, this.view);
    }
}

});


parcelRegister("7PTkn", function(module, exports) {
$parcel$export(module.exports, "replaceSelectedTable", () => $f95b5b4e580791df$export$ea73b328547c6ad5);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $5n2u9 = parcelRequire("5n2u9");
var $kD3Xq = parcelRequire("kD3Xq");

var $4Bf8g = parcelRequire("4Bf8g");
const $f95b5b4e580791df$export$ea73b328547c6ad5 = (state, content, inputMethod, editorAnalyticsAPI)=>{
    if ((0, $kD3Xq.isTableSelected)(state.selection)) {
        const table = (0, $5n2u9.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $801jp.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $4Bf8g.getSelectedTableInfo)(state.selection);
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $8d4kB.TABLE_ACTION).REPLACED,
                actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                attributes: {
                    totalColumnCount: totalColumnCount,
                    totalRowCount: totalRowCount,
                    inputMethod: inputMethod
                },
                eventType: (0, $3LeME.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("brCnW", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveNestedTables", () => $9ea72d2f9f58c9f6$export$8bc9a7cde47c4f8e);
$parcel$export(module.exports, "transformSliceToFixHardBreakProblemOnCopyFromCell", () => $9ea72d2f9f58c9f6$export$fc3230cbfe498044);
$parcel$export(module.exports, "transformSliceToRemoveOpenTable", () => $9ea72d2f9f58c9f6$export$7932630df6a9b5d9);
$parcel$export(module.exports, "transformSliceToCorrectEmptyTableCells", () => $9ea72d2f9f58c9f6$export$5354b8e5d3b01769);
$parcel$export(module.exports, "isHeaderRowRequired", () => $9ea72d2f9f58c9f6$export$cbabf4b236642ebb);
$parcel$export(module.exports, "transformSliceTableLayoutDefaultToCenter", () => $9ea72d2f9f58c9f6$export$4e98c990eb0fdba6);

var $5DGsr = parcelRequire("5DGsr");

var $c5vAC = parcelRequire("c5vAC");

var $7H6Cr = parcelRequire("7H6Cr");

var $a4TQr = parcelRequire("a4TQr");

var $ev7OZ = parcelRequire("ev7OZ");

var $dRkX9 = parcelRequire("dRkX9");

var $4GJqd = parcelRequire("4GJqd");
const $9ea72d2f9f58c9f6$export$c2e425c24c996f14 = (maybeTable)=>{
    const { schema: schema } = maybeTable.type;
    if (maybeTable.type === schema.nodes.table) {
        const content = [];
        const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
        maybeTable.descendants((maybeCell)=>{
            if (maybeCell.type === tableCell || maybeCell.type === tableHeader) {
                content.push(...(0, $a4TQr.flatten)(maybeCell, false).map((child)=>child.node));
                return false;
            }
            return true;
        });
        return content;
    }
    return maybeTable;
};
// Flattens nested tables after a given nesting depth
// If this looks familiar, it's a heavily modified version of `mapFragment` which has been
// adjusted to support tracking nesting depth. This wasn't possible by using `mapFragment` directly
const $9ea72d2f9f58c9f6$var$unwrapNestedTables = (content, schema, unwrapNestDepth, currentNestDepth = 0)=>{
    const flattenNested = (node, tableDepth)=>{
        if (node.type === schema.nodes.table) {
            if (tableDepth >= unwrapNestDepth) return $9ea72d2f9f58c9f6$export$c2e425c24c996f14(node);
            return node;
        }
        return node;
    };
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? flattenNested(node, currentNestDepth) : flattenNested(node.copy((0, $7H6Cr.Fragment).fromArray($9ea72d2f9f58c9f6$var$unwrapNestedTables(node.content, schema, unwrapNestDepth, node.type === schema.nodes.table ? currentNestDepth + 1 : currentNestDepth))), currentNestDepth);
        if (transformed) {
            if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return children;
};
const $9ea72d2f9f58c9f6$export$152b5a96986a7396 = (node, i)=>{
    return i === 0 ? $9ea72d2f9f58c9f6$export$c2e425c24c996f14(node) : node;
};
const $9ea72d2f9f58c9f6$export$791e770947b65d04 = (node, i, fragment)=>{
    return i === fragment.childCount - 1 ? $9ea72d2f9f58c9f6$export$c2e425c24c996f14(node) : node;
};
const $9ea72d2f9f58c9f6$export$8bc9a7cde47c4f8e = (slice, schema, selection)=>{
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    let openEnd = slice.openEnd;
    const newFragment = (0, $c5vAC.flatmap)(slice.content, (node, i, fragment)=>{
        var _slice$content$firstC, _slice$content$lastCh;
        // We allow default nesting of 2 to support
        // two levels of nesting in nodes that support table nesting already such as layoutSection and expands
        let allowedTableNesting = 2;
        const isCellSelection = selection instanceof (0, $ev7OZ.CellSelection);
        const isPasteInTable = (0, $a4TQr.hasParentNodeOfType)([
            table,
            tableCell,
            tableHeader
        ])(selection);
        const isPasteInNestedTable = (0, $5DGsr.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1;
        const isPasteFullTableInsideEmptyCellEnabled = (0, $dRkX9.fg)('platform_editor_paste_full_table_inside_empty_cell');
        // Pasted content only contains a table and no other content
        const isCellPaste = isPasteInTable && slice.content.childCount === 1 && ((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type) === table && (!isPasteFullTableInsideEmptyCellEnabled || slice.openStart !== 0 && slice.openEnd !== 0);
        // however if pasted content is a table, allow just one level
        if (node.type === schema.nodes.table) {
            allowedTableNesting = 1;
            // if paste is inside a table, allow no further nesting
            if (isPasteInTable) allowedTableNesting = 0;
            // unless we are pasting inside a nested table, then bounce back to 1 level
            // because editor-plugin-paste will lift the table to the parent table (just below it)
            if (isPasteInNestedTable) allowedTableNesting = 1;
            // paste of table cells into a table cell - content is spread across multiple cells
            // by editor-tables so needs to be treated a little differently
            if (isCellPaste || isCellSelection) {
                allowedTableNesting = 1;
                if (isPasteInNestedTable) allowedTableNesting = 0;
            }
        }
        // Prevent invalid openEnd after pasting tables with a selection that ends inside a nested table cell.
        // If the slice ends with a selection that ends inside a nested table, and we paste inside a table we
        // need to adjust the openEnd because it is no longer correct. If we don't, Prosemirror fires an exception
        // because it iterates to a non-existent depth and the transform will not be applied
        if (slice.openEnd >= 7 && // depth of a nested table cell
        slice.content.childCount > 1 && ((_slice$content$lastCh = slice.content.lastChild) === null || _slice$content$lastCh === void 0 ? void 0 : _slice$content$lastCh.type) === table && isPasteInTable) // re-point the slice's openEnd to non-nested table cell depth
        openEnd = 4;
        if (isCellSelection && !isCellPaste) // if pasting into a cell selection, we need to flatten the parent table as well
        return $9ea72d2f9f58c9f6$var$unwrapNestedTables((0, $7H6Cr.Fragment).fromArray([
            node
        ]), schema, allowedTableNesting);
        else {
            // after we've worked out what the allowed nesting depth is, unwrap nested tables
            const newChildren = $9ea72d2f9f58c9f6$var$unwrapNestedTables(node.content, schema, allowedTableNesting);
            return node.copy((0, $7H6Cr.Fragment).fromArray(newChildren));
        }
    });
    return new (0, $7H6Cr.Slice)(newFragment, slice.openStart, openEnd);
};
const $9ea72d2f9f58c9f6$export$fc3230cbfe498044 = (slice, schema)=>{
    const { paragraph: paragraph, table: table, hardBreak: hardBreak } = schema.nodes;
    const emptyParagraphNode = paragraph.createAndFill();
    const hardBreakNode = hardBreak === null || hardBreak === void 0 ? void 0 : hardBreak.createAndFill();
    const paragraphNodeSize = emptyParagraphNode ? emptyParagraphNode.nodeSize : 0;
    const hardBreakNodeSize = hardBreakNode ? hardBreakNode.nodeSize : 0;
    const paragraphWithHardBreakSize = paragraphNodeSize + hardBreakNodeSize;
    if (slice.content.childCount === 2 && slice.content.firstChild && slice.content.lastChild && slice.content.firstChild.type === table && slice.content.lastChild.type === paragraph && slice.content.lastChild.nodeSize === paragraphWithHardBreakSize) {
        const nodes = $9ea72d2f9f58c9f6$export$c2e425c24c996f14(slice.content.firstChild);
        if (nodes instanceof Array) return new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).from(// keep only the content and discard the hardBreak
        nodes[0]), slice.openStart, slice.openEnd);
    }
    return slice;
};
const $9ea72d2f9f58c9f6$var$isNodeSingleCellTable = (node, schema)=>{
    var _node$firstChild, _node$firstChild$firs, _node$firstChild$firs2;
    return node.childCount === 1 && ((_node$firstChild = node.firstChild) === null || _node$firstChild === void 0 ? void 0 : _node$firstChild.type) === schema.nodes.tableRow && node.firstChild.childCount === 1 && (((_node$firstChild$firs = node.firstChild.firstChild) === null || _node$firstChild$firs === void 0 ? void 0 : _node$firstChild$firs.type) === schema.nodes.tableCell || ((_node$firstChild$firs2 = node.firstChild.firstChild) === null || _node$firstChild$firs2 === void 0 ? void 0 : _node$firstChild$firs2.type) === schema.nodes.tableHeader);
};
const $9ea72d2f9f58c9f6$var$isFragmentSingleCellTable = (fragment, schema)=>{
    return fragment.childCount === 1 && fragment.firstChild !== null && $9ea72d2f9f58c9f6$var$isNodeSingleCellTable(fragment.firstChild, schema);
};
const $9ea72d2f9f58c9f6$var$containsNonTableBlockChildren = (fragment, schema)=>{
    let containsNonTableBlock = false;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    fragment.forEach((node)=>{
        if (node.isBlock && ![
            table,
            tableCell,
            tableHeader
        ].includes(node.type)) containsNonTableBlock = true;
    });
    return containsNonTableBlock;
};
const $9ea72d2f9f58c9f6$export$7932630df6a9b5d9 = (slice, schema)=>{
    var _slice$content$firstC4;
    // Case 1: A slice of a block selection inside a nested table
    // Prosemirror wraps nested block selections in their respective tables
    // We are using `safeInsert` to paste nested tables, so we do not want to preserve this wrapping
    // slice starts and ends inside a nested table at the same depth
    if (slice.openStart >= 7 && slice.openEnd >= 7) {
        let cleaned = slice;
        let descendedDepth = 0;
        const tableDepthDecrement = 2;
        // if the slice is a single cell table and contains cells with single cell tables, descend into it until we find textblock children
        if ($9ea72d2f9f58c9f6$var$isFragmentSingleCellTable(slice.content, schema)) {
            var _slice$content$firstC2;
            (_slice$content$firstC2 = slice.content.firstChild) === null || _slice$content$firstC2 === void 0 || _slice$content$firstC2.descendants((node)=>{
                if ($9ea72d2f9f58c9f6$var$isNodeSingleCellTable(node, schema)) descendedDepth += tableDepthDecrement;
                else if (node.type === schema.nodes.table) return false;
                else if ($9ea72d2f9f58c9f6$var$containsNonTableBlockChildren(node.content, schema)) {
                    descendedDepth += tableDepthDecrement;
                    // create a new slice with the content of non-table block children and the depth of the nested tables subtracted
                    cleaned = new (0, $7H6Cr.Slice)(node.content, slice.openStart - descendedDepth - tableDepthDecrement, slice.openEnd - descendedDepth - tableDepthDecrement);
                    return false;
                }
            });
        }
        if (!cleaned.eq(slice)) return cleaned;
    }
    // Case 2: A slice entirely within a single CELL
    if (// starts and ends inside of a cell
    slice.openStart >= 4 && slice.openEnd >= 4 && // slice is a table node
    slice.content.childCount === 1 && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    slice.content.firstChild.type === schema.nodes.table) {
        var _slice$content$firstC3;
        // we're removing the table, tableRow and tableCell reducing the open depth by 3
        const depthDecrement = 3;
        // prosemirror-view has a bug that it duplicates table entry when selecting multiple paragraphs in a table cell.
        // https://github.com/ProseMirror/prosemirror/issues/1270
        // The structure becomes
        // table(genuine) > tableRow(genuine) > table(duplicated) > tableRow(duplicated) > tableCell/tableHeader(genuine) > contents(genuine)
        // As we are removing wrapping table anyway, we keep duplicated table and tableRow for simplicity
        let cleaned = slice;
        if (((_slice$content$firstC3 = slice.content.firstChild) === null || _slice$content$firstC3 === void 0 || (_slice$content$firstC3 = _slice$content$firstC3.content) === null || _slice$content$firstC3 === void 0 || (_slice$content$firstC3 = _slice$content$firstC3.firstChild) === null || _slice$content$firstC3 === void 0 || (_slice$content$firstC3 = _slice$content$firstC3.content) === null || _slice$content$firstC3 === void 0 || (_slice$content$firstC3 = _slice$content$firstC3.firstChild) === null || _slice$content$firstC3 === void 0 ? void 0 : _slice$content$firstC3.type) === schema.nodes.table) cleaned = new (0, $7H6Cr.Slice)(slice.content.firstChild.content.firstChild.content, slice.openStart - 2, slice.openEnd - 2);
        return new (0, $7H6Cr.Slice)((0, $c5vAC.flatmap)(cleaned.content, $9ea72d2f9f58c9f6$export$c2e425c24c996f14), cleaned.openStart - depthDecrement, cleaned.openEnd - depthDecrement);
    }
    // Case 3: A slice starting within a CELL and ending outside the table
    if (// starts inside of a cell but ends outside of the starting table
    slice.openStart >= 4 && // slice starts from a table node (and spans across more than one node)
    slice.content.childCount > 1 && ((_slice$content$firstC4 = slice.content.firstChild) === null || _slice$content$firstC4 === void 0 ? void 0 : _slice$content$firstC4.type) === schema.nodes.table) // repoint the slice's cutting depth so that cell content where the slice starts
    // does not get lifted out of the cell on paste
    return new (0, $7H6Cr.Slice)(slice.content, 1, slice.openEnd);
    return slice;
};
const $9ea72d2f9f58c9f6$export$5354b8e5d3b01769 = (slice, schema)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    return (0, $c5vAC.mapSlice)(slice, (node)=>{
        if (node && (node.type === tableCell || node.type === tableHeader) && !node.content.childCount) return node.type.createAndFill(node.attrs) || node;
        return node;
    });
};
function $9ea72d2f9f58c9f6$export$cbabf4b236642ebb(state) {
    const tableState = (0, $4GJqd.getPluginState)(state);
    return tableState && tableState.pluginConfig.isHeaderRowRequired;
}
const $9ea72d2f9f58c9f6$export$4e98c990eb0fdba6 = (slice, schema)=>{
    const { table: table } = schema.nodes;
    const children = [];
    (0, $c5vAC.mapChildren)(slice.content, (node)=>{
        if (node.type === table && node.attrs.layout === 'default') children.push(table.createChecked({
            ...node.attrs,
            layout: 'center'
        }, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("duvJJ", function(module, exports) {
$parcel$export(module.exports, "applyMeasuredWidthToAllTables", () => $acf368e4a65779c5$export$a6fbfadef1c3fa2e);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $8aFCM = parcelRequire("8aFCM");

var $bzCw0 = parcelRequire("bzCw0");

var $kOsPQ = parcelRequire("kOsPQ");
const $acf368e4a65779c5$export$a6fbfadef1c3fa2e = (view, pluginInjectionApi)=>{
    const { state: { doc: doc, schema: schema } } = view;
    let tr = view.state.tr;
    const { table: table } = schema.nodes;
    let modified = false;
    const measuredTables = [];
    // modify only top-level tables
    doc.forEach((node, offset)=>{
        if (node.type !== table || !(0, $bzCw0.isTableInContentMode)({
            tableNode: node,
            isSupported: true,
            isTableNested: false
        })) return;
        const domNode = view.domAtPos(offset + 1).node;
        const tableWrapper = domNode instanceof HTMLElement ? domNode.closest(`.${(0, $8aFCM.TableSharedCssClassName).TABLE_VIEW_CONTENT_WRAP}`) : null;
        const tableRef = tableWrapper === null || tableWrapper === void 0 ? void 0 : tableWrapper.querySelector('table');
        if (!tableRef) return;
        measuredTables.push({
            node: node,
            offset: offset,
            measurement: (0, $kOsPQ.getTableMeasurement)(tableRef)
        });
    });
    measuredTables.forEach(({ node: node, offset: offset, measurement: measurement })=>{
        tr = (0, $kOsPQ.applyTableMeasurement)(tr, node, measurement, offset);
        modified = true;
    });
    if (modified) {
        var _pluginInjectionApi$a, _pluginInjectionApi$w;
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 || (_pluginInjectionApi$a = _pluginInjectionApi$a.actions) === null || _pluginInjectionApi$a === void 0 || _pluginInjectionApi$a.attachAnalyticsEvent({
            action: (0, $8d4kB.TABLE_ACTION).FIT_TO_CONTENT_AUTO_CONVERTED,
            actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
            actionSubjectId: null,
            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
            attributes: {
                editorContainerWidth: (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$w = pluginInjectionApi.width) === null || _pluginInjectionApi$w === void 0 || (_pluginInjectionApi$w = _pluginInjectionApi$w.sharedState.currentState()) === null || _pluginInjectionApi$w === void 0 ? void 0 : _pluginInjectionApi$w.width) ?? 0,
                totalTablesResized: measuredTables.length,
                measurements: measuredTables.map(({ measurement: measurement })=>({
                        tableWidth: measurement.tableWidth,
                        totalColumnCount: measurement.colWidths.length
                    }))
            }
        })(tr);
        view.dispatch(tr.setMeta('addToHistory', false));
    }
};

});


parcelRegister("dfb9x", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $2a1ea1cb05cffdc4$export$ae829ec7b2625219);
/**
 * Fix an issue that composition text replacement in Safari removes empty nodes during text composition text deletion.
 * https://github.com/ProseMirror/prosemirror/issues/934
 * We will remove this plugin when Webkit fix the problem itself.
 */ 
var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");
const $2a1ea1cb05cffdc4$var$tableSafariDeleteCompositionTextIssueWorkaroundKey = new (0, $801jp.PluginKey)('tableSafariDeleteCompositionTextIssueWorkaround');
const $2a1ea1cb05cffdc4$export$ae829ec7b2625219 = ()=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $2a1ea1cb05cffdc4$var$tableSafariDeleteCompositionTextIssueWorkaroundKey,
        state: {
            init: ()=>({
                    renderSpan: false,
                    decorations: (0, $16ZMX.DecorationSet).empty
                }),
            apply: (tr, value)=>{
                const renderSpan = tr.getMeta($2a1ea1cb05cffdc4$var$tableSafariDeleteCompositionTextIssueWorkaroundKey);
                if (typeof renderSpan === 'undefined') return value;
                let decorations;
                if (renderSpan) {
                    // Find position of the first text node in case it has multiple text nodes created by Japanese IME
                    const { $from: $from } = tr.selection;
                    const pos = $from.before($from.depth);
                    const spanDecoration = (0, $16ZMX.Decoration).widget(pos, ()=>{
                        const spanElement = document.createElement('span');
                        return spanElement;
                    });
                    decorations = (0, $16ZMX.DecorationSet).create(tr.doc, [
                        spanDecoration
                    ]);
                } else decorations = (0, $16ZMX.DecorationSet).empty;
                return {
                    renderSpan: renderSpan,
                    decorations: decorations
                };
            }
        },
        props: {
            decorations: (state)=>{
                var _tableSafariDeleteCom;
                return (_tableSafariDeleteCom = $2a1ea1cb05cffdc4$var$tableSafariDeleteCompositionTextIssueWorkaroundKey.getState(state)) === null || _tableSafariDeleteCom === void 0 ? void 0 : _tableSafariDeleteCom.decorations;
            },
            handleDOMEvents: {
                beforeinput: (view, event)=>{
                    if ((event === null || event === void 0 ? void 0 : event.inputType) !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection || selection.rangeCount <= 0 || selection.type !== 'Range') return false;
                    const range = selection.getRangeAt(0);
                    const { startContainer: startContainer, endContainer: endContainer, endOffset: endOffset, startOffset: startOffset } = range;
                    /**
           * On Safari when composition text is deleted, it deletes any empty elements it finds up the dom tree. Prosemirror can sometimes be confused by this
           * and will think that we meant to delete those elements. This fix forces the resulting node to not be empty.
           * The condition here checks to see if the entire text node is about to be swapped inside of an element
           */ if (startContainer.nodeType === Node.TEXT_NODE && startContainer === endContainer && startOffset === 0 && endOffset === startContainer.length) {
                        const { tr: tr } = view.state;
                        tr.setMeta($2a1ea1cb05cffdc4$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, true);
                        view.dispatch(tr);
                    }
                    return false;
                },
                input: (view, event)=>{
                    if ((event === null || event === void 0 ? void 0 : event.inputType) !== 'deleteCompositionText') return false;
                    const selection = window.getSelection();
                    if (!selection) return false;
                    const { tr: tr } = view.state;
                    tr.setMeta($2a1ea1cb05cffdc4$var$tableSafariDeleteCompositionTextIssueWorkaroundKey, false);
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });
};

});

parcelRegister("by4QE", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $25313cd884a63c78$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $fkY0k = parcelRequire("fkY0k");

var $3Mjnn = parcelRequire("3Mjnn");
const $25313cd884a63c78$export$ae829ec7b2625219 = (dispatch, initialState = ()=>[])=>{
    return new (0, $1y7gE.SafePlugin)({
        state: (0, $3Mjnn.createPluginState)(dispatch, initialState),
        key: (0, $fkY0k.pluginKey)
    });
};

});

parcelRegister("2LcYo", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $8e42e6e411441795$export$ae829ec7b2625219);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid

var $eUgRu = parcelRequire("eUgRu");

var $1y7gE = parcelRequire("1y7gE");

var $f9ezd = parcelRequire("f9ezd");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");
class $8e42e6e411441795$var$ObjHash {
    static #_ = this.cache = new WeakMap();
    static getForNode(node) {
        if (this.cache.has(node)) return this.cache.get(node) || '';
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid
        const uniqueId = (0, $eUgRu.default)();
        this.cache.set(node, uniqueId);
        return uniqueId;
    }
}
const $8e42e6e411441795$var$getNodeAnchor = (node)=>{
    const handleId = $8e42e6e411441795$var$ObjHash.getForNode(node);
    return `--table-${node.type.name}-${handleId}`;
};
const $8e42e6e411441795$var$createTableAnchorDecorations = (state)=>{
    const decs = [];
    let headerRowId;
    state.doc.nodesBetween(0, state.doc.content.size, (node, pos, parent, index)=>{
        var _parent$attrs;
        const isTableHeader = node.type.name === 'tableHeader';
        const isTableRow = node.type.name === 'tableRow';
        const isParentTableHeaderRow = (parent === null || parent === void 0 ? void 0 : parent.type.name) === 'tableRow' && headerRowId && (parent === null || parent === void 0 || (_parent$attrs = parent.attrs) === null || _parent$attrs === void 0 ? void 0 : _parent$attrs.localId) === headerRowId;
        const shouldAddDecorationToHeader = isParentTableHeaderRow && isTableHeader;
        const isFirstRow = isTableRow && index === 0;
        if (isFirstRow) headerRowId = node.attrs.localId;
        // only apply to header cells and the first row of a table, for performance reasons
        if (isFirstRow || shouldAddDecorationToHeader) {
            const anchorName = $8e42e6e411441795$var$getNodeAnchor(node);
            const shouldAddAnchorNameInDecoration = !(0, $f9ezd.isCSSAttrAnchorSupported)() && (0, $f9ezd.isCSSAnchorSupported)();
            const attributes = {
                'data-node-anchor': anchorName,
                style: `anchor-name: ${anchorName};`
            };
            decs.push((0, $16ZMX.Decoration).node(pos, pos + node.nodeSize, shouldAddAnchorNameInDecoration ? attributes : {
                'data-node-anchor': anchorName
            }));
        }
        // only decend if there is a possible table row or table header node after the current node, for performance reasons
        return !(isTableHeader || isParentTableHeaderRow);
    });
    return (0, $16ZMX.DecorationSet).create(state.doc, decs);
};
const $8e42e6e411441795$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableAnchorNamesPlugin');
const $8e42e6e411441795$export$ae829ec7b2625219 = ()=>{
    return new (0, $1y7gE.SafePlugin)({
        state: {
            init: (_config, state)=>{
                return $8e42e6e411441795$var$createTableAnchorDecorations(state);
            },
            apply: (tr, decorationSet, _, newState)=>{
                if (tr.docChanged) return $8e42e6e411441795$var$createTableAnchorDecorations(newState);
                return decorationSet;
            }
        },
        key: $8e42e6e411441795$export$18d4026d1ea86bb1,
        props: {
            decorations: (state)=>$8e42e6e411441795$export$18d4026d1ea86bb1.getState(state) || (0, $16ZMX.DecorationSet).empty
        }
    });
};

});

parcelRegister("iUkHD", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $9968af40057354d0$export$ae829ec7b2625219);
/**
 * A plugin for ensuring tables always have unique local IDs, and to
 * preserve/not regenerate them when they are being cut and paste around the
 * document.
 *
 * More broadly, this plugin should be generalised so it can solve this ‘unique
 * id’ problem across the codebase for any node, but for now this will live on
 * its own solving only for tables.
 *
 * TODO: https://product-fabric.atlassian.net/browse/ED-12714
 *
 */ 
var $PIUl3 = parcelRequire("PIUl3");

var $1FHzN = parcelRequire("1FHzN");

var $1y7gE = parcelRequire("1y7gE");

var $hG5QM = parcelRequire("hG5QM");

var $801jp = parcelRequire("801jp");
const $9968af40057354d0$var$pluginKey = new (0, $801jp.PluginKey)('tableLocalIdPlugin');
const $9968af40057354d0$var$getPluginState = (state)=>state && $9968af40057354d0$var$pluginKey.getState(state);
/**
 * Ensures uniqueness of `localId`s on tables being created or edited
 */ const $9968af40057354d0$export$ae829ec7b2625219 = (dispatch)=>new (0, $1y7gE.SafePlugin)({
        key: $9968af40057354d0$var$pluginKey,
        state: {
            init () {
                return {
                    parsedForLocalIds: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($9968af40057354d0$var$pluginKey);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($9968af40057354d0$var$pluginKey, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                /**
       * Utilise the update cycle for _one_ scan through an initial doc
       * to ensure existing tables without IDs get them when this plugin is
       * enabled.
       *
       * This entire block can be skipped if we simply remove the `checkIsAddingTable`
       * check in appendTransaction, but that comes with 2 cons:
       *
       * 1. require a transaction before we actually add the local IDs
       * 2. ever slightly more unncessary checks
       *
       * Finally, this never happens in practice when utilising this in
       * confluence, as the collab/synchrony initialisation process will
       * trigger a transaction which adds tables, and thus this plugin will
       * add/dedupe the necessary IDs. But general usage of the editor
       * without collab should still solve for IDs.
       */ update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $9968af40057354d0$var$getPluginState(state);
                    if (!pluginState) return;
                    const parsed = pluginState.parsedForLocalIds;
                    if (parsed) return;
                    const { table: table } = state.schema.nodes;
                    (0, $PIUl3.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableIdWasAdded = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const localId = node.attrs.localId;
                            if (isTable && !localId) {
                                tableIdWasAdded = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    localId: (0, $1FHzN.uuid).generate()
                                });
                                return false;
                            }
                            /**
             * Otherwise continue traversing, we can encounter tables nested in
             * expands/bodiedExtensions
             */ return true;
                        });
                        if (tableIdWasAdded) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($9968af40057354d0$var$pluginKey, {
                        parsedForLocalIds: true
                    }));
                }
            };
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let modified = false;
            const tr = newState.tr;
            const { table: table } = newState.schema.nodes;
            const addedTableNodes = new Set();
            const addedTableNodePos = new Map();
            const localIds = new Set();
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Don't interfere with cut as it clashes with fixTables & we don't need
                // to handle any extra cut cases in this plugin
                const uiEvent = transaction.getMeta('uiEvent');
                if (uiEvent === 'cut') return;
                /** Get the tables we are adding and their position */ for (const step of transaction.steps){
                    if (!(0, $hG5QM.stepHasSlice)(step)) continue;
                    step.slice.content.descendants((node)=>{
                        if (node.type === table) addedTableNodes.add(node);
                        return true;
                    });
                }
            });
            if (!addedTableNodes.size) return;
            // Get the existing localIds on the page
            newState.doc.descendants((node, pos)=>{
                // Skip if this is position of added table
                if (addedTableNodes.has(node)) {
                    addedTableNodePos.set(node, pos);
                    return false;
                }
                if (node.type !== table) return true;
                localIds.add(node.attrs.localId);
                // can't have table within a table
                return false;
            });
            // If the added nodes have duplicate id, generate a new one
            for (const node of addedTableNodes)if (!node.attrs.localId || localIds.has(node.attrs.localId)) {
                const pos = addedTableNodePos.get(node);
                if (pos === undefined) continue;
                tr.setNodeMarkup(pos, undefined, {
                    ...node.attrs,
                    localId: (0, $1FHzN.uuid).generate()
                });
                modified = true;
            }
            if (modified) return tr;
            return;
        }
    });

});

parcelRegister("6ixVH", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $a8c9745b48fd7b58$export$ae829ec7b2625219);

var $jyPR0 = parcelRequire("jyPR0");

var $1y7gE = parcelRequire("1y7gE");

var $YREXK = parcelRequire("YREXK");

var $4GJqd = parcelRequire("4GJqd");

var $khYTo = parcelRequire("khYTo");

var $jgAuO = parcelRequire("jgAuO");

var $6xtYM = parcelRequire("6xtYM");

var $gQDgk = parcelRequire("gQDgk");

var $7JtQD = parcelRequire("7JtQD");
function $a8c9745b48fd7b58$export$ae829ec7b2625219(dispatch, { lastColumnResizable: lastColumnResizable = true }, getEditorContainerWidth, getEditorFeatureFlags, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isTableScalingEnabled, isCommentEditor) {
    return new (0, $1y7gE.SafePlugin)({
        key: (0, $gQDgk.pluginKey),
        state: (0, $6xtYM.createPluginState)(dispatch, {
            lastColumnResizable: lastColumnResizable,
            resizeHandlePos: null,
            dragging: null,
            lastClick: null
        }),
        props: {
            attributes (state) {
                const pluginState = (0, $6xtYM.getPluginState)(state);
                return {
                    class: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))({
                        [(0, $YREXK.TableCssClassName).RESIZE_CURSOR]: pluginState.resizeHandlePos !== null,
                        [(0, $YREXK.TableCssClassName).IS_RESIZING]: !!pluginState.dragging
                    })
                };
            },
            handleDOMEvents: {
                mousedown (view, event) {
                    const { state: state } = view;
                    const resizeHandlePos = // we're setting `resizeHandlePos` via command in unit tests
                    (0, $6xtYM.getPluginState)(state).resizeHandlePos || (0, $7JtQD.getResizeCellPos)(view, event);
                    const { dragging: dragging } = (0, $6xtYM.getPluginState)(state);
                    let isColumnKeyboardResizeStarted = false;
                    /*
          	We need to start listening mouse events if column resize started from keyboard.
          	This will allow continue resizing via mouse
          */ const { isKeyboardResize: isKeyboardResize } = (0, $4GJqd.getPluginState)(state);
                    if (isKeyboardResize) isColumnKeyboardResizeStarted = isKeyboardResize;
                    if (resizeHandlePos !== null && (!dragging || isColumnKeyboardResizeStarted)) {
                        if ((0, $jgAuO.handleMouseDown)(view, event, resizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled || false, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)) {
                            const { state: state, dispatch: dispatch } = view;
                            return (0, $khYTo.setResizeHandlePos)(resizeHandlePos)(state, dispatch);
                        }
                    }
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("jgAuO", function(module, exports) {
$parcel$export(module.exports, "handleMouseDown", () => $4864ee69a98268c0$export$b4a93e0b711d8f7);

var $3LeME = parcelRequire("3LeME");

var $8d4kB = parcelRequire("8d4kB");

var $jd8X7 = parcelRequire("jd8X7");

var $dpooP = parcelRequire("dpooP");

var $l5gi8 = parcelRequire("l5gi8");

var $4eT7o = parcelRequire("4eT7o");

var $hVZWA = parcelRequire("hVZWA");

var $8L6TV = parcelRequire("8L6TV");

var $4GJqd = parcelRequire("4GJqd");

var $lh6cf = parcelRequire("lh6cf");

var $04vvT = parcelRequire("04vvT");

var $4WYVI = parcelRequire("4WYVI");

var $2q9QJ = parcelRequire("2q9QJ");

var $khYTo = parcelRequire("khYTo");

var $6xtYM = parcelRequire("6xtYM");

var $eyG1M = parcelRequire("eyG1M");

var $7JtQD = parcelRequire("7JtQD");

var $7SttP = parcelRequire("7SttP");

var $9ug8S = parcelRequire("9ug8S");

var $26jxM = parcelRequire("26jxM");
const $4864ee69a98268c0$export$b4a93e0b711d8f7 = (view, event, localResizeHandlePos, getEditorContainerWidth, getEditorFeatureFlags, isTableScalingEnabled, api, nodeViewPortalProviderAPI, editorAnalyticsAPI, isCommentEditor)=>{
    var _insm$session, _originalTable$attrs;
    const { state: state, dispatch: dispatch } = view;
    const editorDisabled = !view.editable;
    const domAtPos = view.domAtPos.bind(view);
    const { width: editorWidth } = getEditorContainerWidth();
    if (editorDisabled || localResizeHandlePos === null || !(0, $7SttP.pointsAtCell)(state.doc.resolve(localResizeHandlePos))) return false;
    const { isKeyboardResize: isKeyboardResize } = (0, $4GJqd.getPluginState)(state);
    event.preventDefault();
    (_insm$session = (0, $4eT7o.insm).session) === null || _insm$session === void 0 || _insm$session.startFeature('tableColumnResize');
    const tr = view.state.tr;
    tr.setMeta((0, $lh6cf.META_KEYS).OVERFLOW_TRIGGER, {
        name: (0, $8d4kB.TABLE_OVERFLOW_CHANGE_TRIGGER).RESIZED_COLUMN
    });
    dispatch(tr);
    const mouseDownTime = event.timeStamp;
    const cell = state.doc.nodeAt(localResizeHandlePos);
    const $cell = state.doc.resolve(localResizeHandlePos);
    const originalTable = $cell.node(-1);
    const start = $cell.start(-1);
    const tablePos = state.doc.resolve(start).start(-1);
    const tableDepth = state.doc.resolve(tablePos).depth;
    let dom = domAtPos(start).node;
    if (dom && dom.nodeName !== 'TABLE') dom = dom.closest('table');
    let maxSize = 0;
    if (isTableScalingEnabled && isCommentEditor && !((_originalTable$attrs = originalTable.attrs) !== null && _originalTable$attrs !== void 0 && _originalTable$attrs.width)) maxSize = editorWidth - (0, $eyG1M.TABLE_OFFSET_IN_COMMENT_EDITOR);
    else maxSize = (0, $7SttP.getTableMaxWidth)({
        table: originalTable,
        tableStart: start,
        state: state,
        layout: originalTable.attrs.layout,
        getEditorContainerWidth: getEditorContainerWidth
    });
    let shouldScale = tableDepth === 0 && isTableScalingEnabled;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags();
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && tableWithFixedColumnWidthsOption;
    if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
    let shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled;
    if (isTableScalingEnabled && isCommentEditor) {
        shouldScale = tableDepth === 0;
        shouldUseIncreasedScalingPercent = true;
    }
    const resizeState = (0, $26jxM.getResizeState)({
        minWidth: (0, $jd8X7.tableCellMinWidth),
        maxSize: maxSize,
        table: originalTable,
        tableRef: dom,
        start: start,
        domAtPos: domAtPos,
        isTableScalingEnabled: shouldScale,
        shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
        isCommentEditor: isCommentEditor || false
    });
    if ((0, $khYTo.evenColumns)({
        resizeState: resizeState,
        table: originalTable,
        start: start,
        event: event,
        api: api
    })(state, dispatch)) {
        finish(event);
        return true;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const width = (0, $7SttP.currentColWidth)(view, localResizeHandlePos, cell.attrs);
    (0, $khYTo.setDragging)({
        startX: event.clientX,
        startWidth: width
    })(state, dispatch);
    // When we start resizing a column we need to ensure the underlying tooltip is removed from the decoration to avoid
    // unnecessary tooltips being displayed during drag.
    (0, $8L6TV.updateResizeHandleDecorations)(nodeViewPortalProviderAPI, undefined, undefined, false)(state, dispatch);
    function finish(event) {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mouseup', finish);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('mousemove', move);
        const { clientX: clientX } = event;
        const { state: state, dispatch: dispatch } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $6xtYM.getPluginState)(state);
        const { isTableHovered: isTableHovered } = (0, $4GJqd.getPluginState)(state);
        if (resizeHandlePos === null) {
            var _insm$session2;
            (_insm$session2 = (0, $4eT7o.insm).session) === null || _insm$session2 === void 0 || _insm$session2.endFeature('tableColumnResize');
            return (0, $khYTo.stopResizing)()(state, dispatch);
        }
        if (!(0, $7SttP.pointsAtCell)(state.doc.resolve(resizeHandlePos))) {
            var _insm$session3;
            (_insm$session3 = (0, $4eT7o.insm).session) === null || _insm$session3 === void 0 || _insm$session3.endFeature('tableColumnResize');
            return;
        }
        // resizeHandlePos could be remapped via a collab change.
        // Fetch a fresh reference of the table.
        const $cell = state.doc.resolve(resizeHandlePos);
        const start = $cell.start(-1);
        const table = $cell.node(-1);
        const tablePos = state.doc.resolve(start).start(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        // If we let go in the same place we started, don't need to do anything.
        if (dragging && clientX === dragging.startX) {
            var _insm$session4;
            (_insm$session4 = (0, $4eT7o.insm).session) === null || _insm$session4 === void 0 || _insm$session4.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
         *  or mouse pointer leaves the table but mouse button still pressed
         */ return (0, $hVZWA.stopKeyboardColumnResizing)({})(state, dispatch, view);
            else return (0, $khYTo.stopResizing)()(state, dispatch);
        }
        let { tr: tr } = state;
        if (dragging) {
            var _insm$session5;
            const { startX: startX } = dragging;
            // If the dimensions of the table have changed through a remote modification by another
            // person for example don't persist the new column widths as we couldn't reliably remap them
            // For example, if a table col is deleted
            // There may be a more elegant solution to this, to avoid a jarring experience. This used to
            // be an equality check but that caused issues when a nested table would change (eg. when it
            // dynamically updates its width on resize)
            if (!(0, $4WYVI.tablesHaveDifferentNoOfColumns)(originalTable, table)) {
                var _table$attrs;
                const map = (0, $dpooP.TableMap).get(table);
                const colIndex = map.colCount($cell.pos - start) + ($cell.nodeAfter ? $cell.nodeAfter.attrs.colspan : 1) - 1;
                const selectionRect = (0, $l5gi8.getSelectionRect)(state.selection);
                const selectedColumns = selectionRect ? (0, $2q9QJ.getSelectedColumnIndexes)(selectionRect) : [];
                // only selected (or selected - 1) columns should be distributed
                const resizingSelectedColumns = selectedColumns.indexOf(colIndex) > -1 || selectedColumns.indexOf(colIndex + 1) > -1;
                let shouldScale = tableDepth === 0 && isTableScalingEnabled;
                if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
                const resizedDelta = clientX - startX;
                const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && !!isCommentEditor;
                const scalePercent = isTableScalingEnabled && isCommentEditor && !((_table$attrs = table.attrs) !== null && _table$attrs !== void 0 && _table$attrs.width) ? (0, $7SttP.getScalingPercentForTableWithoutWidth)(originalTable, dom) : (0, $7SttP.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
                const newResizeState = (0, $9ug8S.resizeColumn)(resizeState, colIndex, resizedDelta, dom, originalTable, resizingSelectedColumns ? selectedColumns : undefined, shouldScale, scalePercent);
                tr = (0, $04vvT.updateColumnWidths)(newResizeState, table, start, api)(tr);
                if (colIndex === map.width - 1) {
                    const mouseUpTime = event.timeStamp;
                    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                        action: (0, $8d4kB.TABLE_ACTION).ATTEMPTED_TABLE_WIDTH_CHANGE,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                        actionSubjectId: null,
                        attributes: {
                            type: 'table-border',
                            position: 'right',
                            duration: mouseUpTime - mouseDownTime,
                            delta: Math.abs(resizedDelta)
                        },
                        eventType: (0, $3LeME.EVENT_TYPE).UI
                    })(tr);
                }
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $8d4kB.TABLE_ACTION).COLUMN_RESIZED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).TABLE,
                    eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                    attributes: {
                        colIndex: colIndex,
                        resizedDelta: resizedDelta,
                        isLastColumn: colIndex === map.width - 1,
                        tableWidth: table.attrs.width,
                        inputMethod: (0, $3LeME.INPUT_METHOD).MOUSE,
                        totalRowCount: map.height,
                        totalColumnCount: map.width
                    }
                })(tr);
            }
            (_insm$session5 = (0, $4eT7o.insm).session) === null || _insm$session5 === void 0 || _insm$session5.endFeature('tableColumnResize');
            if (isKeyboardResize || !isTableHovered) /** if column resize had started via keyboard but continued by mouse
         *  or mouse pointer leaves the table but mouse button still pressed
         */ return (0, $hVZWA.stopKeyboardColumnResizing)({
                originalTr: tr
            })(state, dispatch, view);
            else return (0, $khYTo.stopResizing)(tr)(state, dispatch);
        }
    }
    function move(event) {
        var _table$attrs2;
        const { clientX: clientX, which: which } = event;
        const { state: state } = view;
        const { dragging: dragging, resizeHandlePos: resizeHandlePos } = (0, $6xtYM.getPluginState)(state);
        const { isTableHovered: isTableHovered } = (0, $4GJqd.getPluginState)(state);
        const tablePos = state.doc.resolve(start).start(-1);
        if (!which || !dragging || resizeHandlePos === null || !(0, $7SttP.pointsAtCell)(state.doc.resolve(resizeHandlePos)) || !isTableHovered) return finish(event);
        const $cell = state.doc.resolve(resizeHandlePos);
        const table = $cell.node(-1);
        const tableDepth = state.doc.resolve(tablePos).depth;
        const map = (0, $dpooP.TableMap).get(table);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const colIndex = map.colCount($cell.pos - $cell.start(-1)) + $cell.nodeAfter.attrs.colspan - 1;
        let shouldScale = tableDepth === 0 && isTableScalingEnabled;
        const shouldUseIncreasedScalingPercent = isTableScalingWithFixedColumnWidthsOptionEnabled || isTableScalingEnabled && isCommentEditor;
        if (isTableScalingWithFixedColumnWidthsOptionEnabled) shouldScale = shouldScale && originalTable.attrs.displayMode !== 'fixed';
        const resizedDelta = clientX - dragging.startX;
        const scalePercent = isTableScalingEnabled && isCommentEditor && !((_table$attrs2 = table.attrs) !== null && _table$attrs2 !== void 0 && _table$attrs2.width) ? (0, $7SttP.getScalingPercentForTableWithoutWidth)(table, dom) : (0, $7SttP.getTableScalingPercent)(originalTable, dom, shouldUseIncreasedScalingPercent);
        (0, $9ug8S.resizeColumn)(resizeState, colIndex, resizedDelta, dom, table, undefined, shouldScale, scalePercent);
        (0, $7JtQD.updateControls)()(state);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mouseup', finish);
    // Ignored via go/ees005
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    window.addEventListener('mousemove', move);
    return true;
};

});


parcelRegister("ivUuF", function(module, exports) {
$parcel$export(module.exports, "tableSelectionKeymapPlugin", () => $6279b6487866ab6c$export$21439b5bf6b9c77f);

var $eUtBU = parcelRequire("eUtBU");

var $1O8Lw = parcelRequire("1O8Lw");

var $iLDsi = parcelRequire("iLDsi");
function $6279b6487866ab6c$export$21439b5bf6b9c77f(pluginInjectionApi, getIntl) {
    var _pluginInjectionApi$a;
    const list = {};
    const editorSelectionAPI = pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.selection;
    const ariaNotifyPlugin = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.accessibilityUtils) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions.ariaNotify;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.moveRight).common, (0, $iLDsi.arrowRightFromTable)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.moveLeft).common, (0, $iLDsi.arrowLeftFromTable)(editorSelectionAPI)(), list);
    (0, $eUtBU.bindKeymapArrayWithCommand)((0, $eUtBU.selectColumn), (0, $iLDsi.selectColumns)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    (0, $eUtBU.bindKeymapArrayWithCommand)((0, $eUtBU.selectRow), (0, $iLDsi.selectRows)(editorSelectionAPI, ariaNotifyPlugin, getIntl)(true), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.shiftArrowUp).common, (0, $iLDsi.shiftArrowUpFromTable)(editorSelectionAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $eUtBU.bindKeymapWithCommand)((0, $eUtBU.selectTable).common, (0, $iLDsi.modASelectTable)(editorSelectionAPI)(), list);
    return (0, $1O8Lw.keymap)(list);
}

});
parcelRegister("iLDsi", function(module, exports) {
$parcel$export(module.exports, "arrowLeftFromTable", () => $2bf98c5c379ce197$export$2c7e1bbc14ebf0ec);
$parcel$export(module.exports, "arrowRightFromTable", () => $2bf98c5c379ce197$export$2e5835b1a25e33b);
$parcel$export(module.exports, "selectColumns", () => $2bf98c5c379ce197$export$41a42e79fbe56d35);
$parcel$export(module.exports, "selectRows", () => $2bf98c5c379ce197$export$b5ba3b60192c7a8d);
$parcel$export(module.exports, "shiftArrowUpFromTable", () => $2bf98c5c379ce197$export$ef446fa0355915f);
$parcel$export(module.exports, "modASelectTable", () => $2bf98c5c379ce197$export$1de5b4cd2a72d822);

var $lqHJB = parcelRequire("lqHJB");

var $a5ELK = parcelRequire("a5ELK");
var $jCQEY = parcelRequire("jCQEY");
var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $apbCm = parcelRequire("apbCm");

var $801jp = parcelRequire("801jp");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $gNVxw = parcelRequire("gNVxw");
var $5n2u9 = parcelRequire("5n2u9");
var $ii3Kf = parcelRequire("ii3Kf");
var $he7e7 = parcelRequire("he7e7");
var $kD3Xq = parcelRequire("kD3Xq");

var $iwwun = parcelRequire("iwwun");

var $7a5j7 = parcelRequire("7a5j7");

var $4GJqd = parcelRequire("4GJqd");

var $8L6TV = parcelRequire("8L6TV");
var $2bf98c5c379ce197$var$TableSelectionDirection = /*#__PURE__*/ function(TableSelectionDirection) {
    TableSelectionDirection["TopToBottom"] = "TopToBottom";
    TableSelectionDirection["BottomToTop"] = "BottomToTop";
    return TableSelectionDirection;
}($2bf98c5c379ce197$var$TableSelectionDirection || {});
const $2bf98c5c379ce197$export$2c7e1bbc14ebf0ec = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $ev7OZ.CellSelection)) return $2bf98c5c379ce197$var$arrowLeftFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $ihNBw.GapCursorSelection)) return $2bf98c5c379ce197$var$arrowLeftFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $801jp.TextSelection)) return $2bf98c5c379ce197$var$arrowLeftFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $2bf98c5c379ce197$export$2e5835b1a25e33b = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection instanceof (0, $ev7OZ.CellSelection)) return $2bf98c5c379ce197$var$arrowRightFromCellSelection(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $ihNBw.GapCursorSelection)) return $2bf98c5c379ce197$var$arrowRightFromGapCursor(editorSelectionAPI)(selection)(state, dispatch);
            else if (selection instanceof (0, $801jp.TextSelection)) return $2bf98c5c379ce197$var$arrowRightFromText(editorSelectionAPI)(selection)(state, dispatch);
            return false;
        };
const $2bf98c5c379ce197$var$arrowLeftFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $kD3Xq.isTableSelected)(state.selection) && editorSelectionAPI) {
                const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                if ((selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectionRelativeToNode) === (0, $apbCm.RelativeSelectionPos).Start) // we have full table cell selection and want to set gap cursor selection before table
                return $2bf98c5c379ce197$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                else if ((selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectionRelativeToNode) === (0, $apbCm.RelativeSelectionPos).End) // we have full table cell selection and want to set selection at end of last cell
                return $2bf98c5c379ce197$var$setSelectionAtEndOfLastCell(editorSelectionAPI)(selection)(state, dispatch);
                else if ((selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectionRelativeToNode) === undefined) // we have full table cell selection and want to set selection at start of first cell
                return $2bf98c5c379ce197$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection, (0, $apbCm.RelativeSelectionPos).Before)(state, dispatch);
            }
            return false;
        };
const $2bf98c5c379ce197$var$arrowRightFromCellSelection = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            if ((0, $kD3Xq.isTableSelected)(state.selection) && editorSelectionAPI) {
                const { selectionRelativeToNode: selectionRelativeToNode } = editorSelectionAPI.sharedState.currentState() || {};
                if (selectionRelativeToNode === (0, $apbCm.RelativeSelectionPos).Start) // we have full table cell selection and want to set selection at start of first cell
                return $2bf98c5c379ce197$var$setSelectionAtStartOfFirstCell(editorSelectionAPI)(selection)(state, dispatch);
                else if (selectionRelativeToNode === (0, $apbCm.RelativeSelectionPos).End || selectionRelativeToNode === undefined) // we have full table cell selection and want to set gap cursor selection after table
                return $2bf98c5c379ce197$var$setGapCursorAfterTable(editorSelectionAPI)()(state, dispatch);
            }
            return false;
        };
const $2bf98c5c379ce197$export$41a42e79fbe56d35 = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $5n2u9.findTable)(selection);
            const rect = (0, $iwwun.selectedRect)(state);
            if (table && (0, $he7e7.isRowSelected)(rect.top)(selection)) return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectColumnCommand = (0, $8L6TV.selectColumn)(rect.left, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $dpooP.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).columnSelected, {
                    index: rect.left + 1,
                    total: map.width
                }), {
                    priority: 'important'
                });
                return selectColumnCommand;
            }
            return false;
        };
const $2bf98c5c379ce197$export$b5ba3b60192c7a8d = (editorSelectionAPI, ariaNotify, getIntl)=>(triggeredByKeyboard = false)=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $5n2u9.findTable)(selection);
            const rect = (0, $iwwun.selectedRect)(state);
            if (table && (0, $ii3Kf.isColumnSelected)(rect.left)(selection)) return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            if (table && rect) {
                const selectRowCommand = (0, $8L6TV.selectRow)(rect.top, undefined, triggeredByKeyboard)(state, dispatch);
                const map = (0, $dpooP.TableMap).get(table.node);
                if (ariaNotify && getIntl) ariaNotify(getIntl().formatMessage((0, $lqHJB.messages).rowSelected, {
                    index: rect.top + 1,
                    total: map.height
                }), {
                    priority: 'important'
                });
                return selectRowCommand;
            }
            return false;
        };
const $2bf98c5c379ce197$var$arrowLeftFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { $from: $from, from: from, side: side } = selection;
            if (side === (0, $id3e6.Side).RIGHT) {
                if ($from.nodeBefore && $from.nodeBefore.type.name === 'table') // we have a gap cursor after a table node and want to set a full table cell selection
                return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeBefore,
                    startPos: doc.resolve(from - 1).start($from.depth + 1),
                    dir: "TopToBottom"
                })(state, dispatch);
            } else if (side === (0, $id3e6.Side).LEFT) {
                const table = (0, $5n2u9.findTable)(selection);
                if (table && $2bf98c5c379ce197$var$isSelectionAtStartOfTable($from, selection) && editorSelectionAPI) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if ((selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectionRelativeToNode) === (0, $apbCm.RelativeSelectionPos).Before) // we have a gap cursor at start of first table cell and want to set a gap cursor selection before table
                    return $2bf98c5c379ce197$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a gap cursor at start of first table cell and want to set a full table cell selection
                    return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$arrowRightFromGapCursor = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const { $from: $from, from: from, $to: $to, side: side } = selection;
            if (side === (0, $id3e6.Side).LEFT) {
                if ($from.nodeAfter && $from.nodeAfter.type.name === 'table') // we have a gap cursor before a table node and want to set a full table cell selection
                return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                    node: $from.nodeAfter,
                    startPos: from + 1,
                    dir: "BottomToTop"
                })(state, dispatch);
            } else if (side === (0, $id3e6.Side).RIGHT) {
                const table = (0, $5n2u9.findTable)(selection);
                if (table && $2bf98c5c379ce197$var$isSelectionAtEndOfTable($to, selection)) // we have a gap cursor at end of last table cell and want to set a full table cell selection
                return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
const $2bf98c5c379ce197$var$arrowLeftFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $5n2u9.findTable)(selection);
            if (table) {
                const { $from: $from } = selection;
                const columResizePluginState = (0, $4GJqd.getPluginState)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState === null || columResizePluginState === void 0 ? void 0 : columResizePluginState.isKeyboardResize);
                if ($2bf98c5c379ce197$var$isSelectionAtStartOfTable($from, selection) && $from.parent.type.name === 'paragraph' && $from.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                editorSelectionAPI && !isColumnResizing) {
                    const selectionState = editorSelectionAPI.sharedState.currentState() || {};
                    if ((selectionState === null || selectionState === void 0 ? void 0 : selectionState.selectionRelativeToNode) === (0, $apbCm.RelativeSelectionPos).Before) // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set gap cursor selection before table
                    return $2bf98c5c379ce197$var$setGapCursorBeforeTable(editorSelectionAPI)()(state, dispatch);
                    else // we have a text selection at start of first table cell, directly inside a top level paragraph,
                    // and want to set a full table cell selection
                    return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                        node: table.node,
                        startPos: table.start,
                        dir: "BottomToTop"
                    })(state, dispatch);
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$arrowRightFromText = (editorSelectionAPI)=>(selection)=>(state, dispatch)=>{
            const table = (0, $5n2u9.findTable)(selection);
            if (table) {
                const { $to: $to } = selection;
                const columResizePluginState = (0, $4GJqd.getPluginState)(state) || {};
                const isColumnResizing = Boolean(columResizePluginState === null || columResizePluginState === void 0 ? void 0 : columResizePluginState.isKeyboardResize);
                if ($2bf98c5c379ce197$var$isSelectionAtEndOfTable($to, selection) && $to.parent.type.name === 'paragraph' && $to.depth === table.depth + 3 && // + 3 for: row, cell & paragraph nodes
                !isColumnResizing) // we have a text selection at end of last table cell, directly inside a top level paragraph,
                // and want to set a full table cell selection
                return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                    node: table.node,
                    startPos: table.start,
                    dir: "TopToBottom"
                })(state, dispatch);
            }
            return false;
        };
/**
 * sets a cell selection over the table cell in which the selection is inside of
 */ const $2bf98c5c379ce197$var$selectTableCell = (state, dispatch)=>{
    const $cell = (0, $gNVxw.cellAround)(state.selection.$from);
    if (!$cell) return false;
    if (dispatch) {
        dispatch(state.tr.setSelection(new (0, $ev7OZ.CellSelection)($cell)));
        return true;
    }
    return false;
};
/**
 * Sets a cell selection over all the cells in the table node
 * We use this instead of selectTable from prosemirror-utils so we can control which
 * cell is the anchor and which is the head, and also so we can set the relative selection
 * pos in the selection plugin
 */ const $2bf98c5c379ce197$var$selectFullTable = (editorSelectionAPI)=>({ node: node, startPos: startPos, dir: dir })=>(state, dispatch)=>{
            const { doc: doc } = state;
            const { map: map } = (0, $dpooP.TableMap).get(node);
            const $firstCell = doc.resolve(startPos + map[0]);
            const $lastCell = doc.resolve(startPos + map[map.length - 1]);
            let fullTableSelection;
            let selectionRelativeToNode;
            if (dir === "TopToBottom") {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $ev7OZ.CellSelection)($firstCell, $lastCell);
                selectionRelativeToNode = (0, $apbCm.RelativeSelectionPos).End;
            } else {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fullTableSelection = new (0, $ev7OZ.CellSelection)($lastCell, $firstCell);
                selectionRelativeToNode = (0, $apbCm.RelativeSelectionPos).Start;
            }
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: fullTableSelection
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$setSelectionAtStartOfFirstCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
            const $firstPosInsideCell = state.doc.resolve($firstCell.pos + 1);
            // check if first pos should have a gap cursor, otherwise find closest text selection
            const selectionAtStartOfCell = (0, $ihNBw.GapCursorSelection).valid($firstPosInsideCell) ? new (0, $ihNBw.GapCursorSelection)($firstPosInsideCell, (0, $id3e6.Side).LEFT) : (0, $801jp.Selection).findFrom($firstPosInsideCell, 1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtStartOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$setSelectionAtEndOfLastCell = (editorSelectionAPI)=>(selection, selectionRelativeToNode)=>(state, dispatch)=>{
            const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
            const $lastCell = $anchorCell.pos > $headCell.pos ? $anchorCell : $headCell;
            const lastPosInsideCell = $lastCell.pos + ($lastCell.nodeAfter ? $lastCell.nodeAfter.content.size : 0) + 1;
            const $lastPosInsideCell = state.doc.resolve(lastPosInsideCell);
            // check if last pos should have a gap cursor, otherwise find closest text selection
            const selectionAtEndOfCell = (0, $ihNBw.GapCursorSelection).valid($lastPosInsideCell) ? new (0, $ihNBw.GapCursorSelection)($lastPosInsideCell, (0, $id3e6.Side).RIGHT) : (0, $801jp.Selection).findFrom($lastPosInsideCell, -1);
            if (editorSelectionAPI) {
                const tr = editorSelectionAPI.actions.selectNearNode({
                    selectionRelativeToNode: selectionRelativeToNode,
                    selection: selectionAtEndOfCell
                })(state);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$setGapCursorBeforeTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $5n2u9.findTable)(state.selection);
            if (table) {
                const $beforeTablePos = state.doc.resolve(table.pos);
                if ((0, $ihNBw.GapCursorSelection).valid($beforeTablePos)) {
                    const selectionBeforeTable = new (0, $ihNBw.GapCursorSelection)($beforeTablePos, (0, $id3e6.Side).LEFT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionBeforeTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$setGapCursorAfterTable = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const table = (0, $5n2u9.findTable)(state.selection);
            if (table) {
                const $afterTablePos = state.doc.resolve(table.pos + table.node.nodeSize);
                if ((0, $ihNBw.GapCursorSelection).valid($afterTablePos)) {
                    const selectionAfterTable = new (0, $ihNBw.GapCursorSelection)($afterTablePos, (0, $id3e6.Side).RIGHT);
                    if (editorSelectionAPI) {
                        const tr = editorSelectionAPI.actions.selectNearNode({
                            selectionRelativeToNode: undefined,
                            selection: selectionAfterTable
                        })(state);
                        if (dispatch) {
                            dispatch(tr);
                            return true;
                        }
                    }
                    return false;
                }
            }
            return false;
        };
const $2bf98c5c379ce197$var$isSelectionAtStartOfTable = ($pos, selection)=>{
    var _findTable;
    return (0, $jCQEY.isSelectionAtStartOfNode)($pos, (_findTable = (0, $5n2u9.findTable)(selection)) === null || _findTable === void 0 ? void 0 : _findTable.node);
};
const $2bf98c5c379ce197$var$isSelectionAtEndOfTable = ($pos, selection)=>{
    var _findTable2;
    return (0, $a5ELK.isSelectionAtEndOfNode)($pos, (_findTable2 = (0, $5n2u9.findTable)(selection)) === null || _findTable2 === void 0 ? void 0 : _findTable2.node);
};
const $2bf98c5c379ce197$export$ef446fa0355915f = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $5n2u9.findTable)(selection);
            const selectionRect = (0, $7a5j7.getClosestSelectionRect)(state);
            const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.top;
            if (table && index === 0) return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };
const $2bf98c5c379ce197$export$1de5b4cd2a72d822 = (editorSelectionAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            const table = (0, $5n2u9.findTable)(selection);
            if (!table) return false;
            const { $from: $from, $to: $to } = selection;
            const tableSelected = (0, $kD3Xq.isTableSelected)(selection);
            const isCellSelection = selection instanceof (0, $ev7OZ.CellSelection);
            // if no cells are selected
            if (!isCellSelection) return $2bf98c5c379ce197$var$selectTableCell(state, dispatch);
            else if (!tableSelected && $from.pos > table.start + 1 && $to.pos < table.start + table.node.nodeSize) return $2bf98c5c379ce197$var$selectFullTable(editorSelectionAPI)({
                node: table.node,
                startPos: table.start,
                dir: "BottomToTop"
            })(state, dispatch);
            return false;
        };

});
parcelRegister("ii3Kf", function(module, exports) {
$parcel$export(module.exports, "isColumnSelected", () => $01dfa40def9b72cd$export$8db1cdcc0c397a6d);

var $dpooP = parcelRequire("dpooP");

var $4UJOR = parcelRequire("4UJOR");

var $2HFfw = parcelRequire("2HFfw");
const $01dfa40def9b72cd$export$8db1cdcc0c397a6d = (columnIndex)=>(selection)=>{
        if ((0, $2HFfw.isSelectionType)(selection, 'cell')) {
            const map = (0, $dpooP.TableMap).get(selection.$anchorCell.node(-1));
            return (0, $4UJOR.isRectSelected)({
                left: columnIndex,
                right: columnIndex + 1,
                top: 0,
                bottom: map.height
            })(selection);
        }
        return false;
    };

});



parcelRegister("lcU8V", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $894a36d142c0cf7a$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $894a36d142c0cf7a$export$ae829ec7b2625219);

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");
const $894a36d142c0cf7a$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableSizeSelectorPlugin');
const $894a36d142c0cf7a$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $894a36d142c0cf7a$export$18d4026d1ea86bb1,
        state: {
            init: ()=>({
                    isSelectorOpen: false
                }),
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($894a36d142c0cf7a$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return currentPluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...currentPluginState,
                            ...meta
                        };
                        dispatch($894a36d142c0cf7a$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return currentPluginState;
            }
        }
    });
};

});

parcelRegister("cD6dM", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $c0140025d6419f1e$export$ae829ec7b2625219);
/*
	Existing legacy tables in Comment editor have set attributes:
	- width = 760
	- layout = 'default'.

	When "Support Table in Comment" FF is enabled, table resizing (and table alignment in Confluence comments) is turned.
	It results in (ED-24795) all exising tables being set 760px width. Instead they all should inherit width from
	the editor container until a user decided to edit their old comment and set a custom table width themselves.

	This plugin exists to fix the described issue. It ensures that once "Support Table in Comment" FF turned on,
	existing tables continue to inherit the width of editor container and are 'left-aligned' by default.
*/ 
var $PIUl3 = parcelRequire("PIUl3");

var $1y7gE = parcelRequire("1y7gE");

var $801jp = parcelRequire("801jp");

var $014x6 = parcelRequire("014x6");

var $1YIoS = parcelRequire("1YIoS");
const $c0140025d6419f1e$export$18d4026d1ea86bb1 = new (0, $801jp.PluginKey)('tableWidthInCommentFixPlugin');
const $c0140025d6419f1e$var$getPluginState = (state)=>state && $c0140025d6419f1e$export$18d4026d1ea86bb1.getState(state);
const $c0140025d6419f1e$export$ae829ec7b2625219 = (dispatch, isTableAlignmentEnabled)=>{
    return new (0, $1y7gE.SafePlugin)({
        key: $c0140025d6419f1e$export$18d4026d1ea86bb1,
        state: {
            init () {
                return {
                    documentHasLoadedOnce: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($c0140025d6419f1e$export$18d4026d1ea86bb1);
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch($c0140025d6419f1e$export$18d4026d1ea86bb1, newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view: ()=>{
            return {
                update (editorView) {
                    const { state: state } = editorView;
                    const pluginState = $c0140025d6419f1e$var$getPluginState(state);
                    if (!pluginState) return;
                    const { documentHasLoadedOnce: documentHasLoadedOnce } = pluginState;
                    if (documentHasLoadedOnce) return;
                    const { table: table } = state.schema.nodes;
                    (0, $PIUl3.default)(()=>{
                        const tr = editorView.state.tr;
                        let tableWidthAndLayoutUpdated = false;
                        editorView.state.doc.descendants((node, pos)=>{
                            const isTable = node.type === table;
                            const width = node.attrs.width;
                            const layout = node.attrs.layout;
                            if (isTable && width === (0, $014x6.akEditorDefaultLayoutWidth) && layout === 'default') {
                                tableWidthAndLayoutUpdated = true;
                                tr.setNodeMarkup(pos, undefined, {
                                    ...node.attrs,
                                    width: null,
                                    layout: isTableAlignmentEnabled ? (0, $1YIoS.ALIGN_START) : 'default'
                                });
                                return false;
                            }
                            // Returning false here because don't need to change nested tables
                            return false;
                        });
                        if (tableWidthAndLayoutUpdated) {
                            tr.setMeta('addToHistory', false);
                            editorView.dispatch(tr);
                        }
                    })();
                    editorView.dispatch(state.tr.setMeta($c0140025d6419f1e$export$18d4026d1ea86bb1, {
                        documentHasLoadedOnce: true
                    }));
                }
            };
        }
    });
};

});

parcelRegister("fuhDl", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $04e974155c2297e0$export$ae829ec7b2625219);
/**
 * This plugin allows sorting of table nodes in the Editor without modifying the underlying ProseMirror document.
 * Instead of making changes to the ProseMirror document, the plugin sorts the table rows in the DOM. This allows the sorting to be
 * visible to the user without affecting the document's content.
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $eUgRu = parcelRequire("eUgRu");

var $1y7gE = parcelRequire("1y7gE");

var $20eP6 = parcelRequire("20eP6");

var $16ZMX = parcelRequire("16ZMX");

var $dpooP = parcelRequire("dpooP");

var $jwRhl = parcelRequire("jwRhl");

var $4GJqd = parcelRequire("4GJqd");

var $4Chjr = parcelRequire("4Chjr");

var $1lsDe = parcelRequire("1lsDe");

var $PAPAk = parcelRequire("PAPAk");
const $04e974155c2297e0$export$ae829ec7b2625219 = (api, nodeViewPortalProviderAPI)=>{
    return new (0, $1y7gE.SafePlugin)({
        state: {
            init: ()=>({
                    decorations: (0, $16ZMX.DecorationSet).empty,
                    sort: {},
                    allTables: []
                }),
            apply (tr, pluginState, oldState) {
                var _api$editorViewMode;
                // TODO: ED-26961 - move this mode check to plugin creation if possible. Right now it's here because the initial state
                // does not appear correct when the plugin is created.
                const { mode: mode } = ((_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.sharedState.currentState()) || {};
                if (mode !== 'view') {
                    var _pluginState$decorati, _pluginState$decorati2;
                    const sortingDecorations = pluginState === null || pluginState === void 0 || (_pluginState$decorati = pluginState.decorations) === null || _pluginState$decorati === void 0 ? void 0 : _pluginState$decorati.find(undefined, undefined, (s)=>(s === null || s === void 0 ? void 0 : s.type) === 'sorting-decoration');
                    return {
                        ...pluginState,
                        decorations: pluginState === null || pluginState === void 0 || (_pluginState$decorati2 = pluginState.decorations) === null || _pluginState$decorati2 === void 0 ? void 0 : _pluginState$decorati2.remove(sortingDecorations)
                    };
                }
                let { decorations: decorations, sort: sort, allTables: allTables } = pluginState;
                const sortMeta = tr.getMeta('tableSortMeta');
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                const removeTableMeta = tr.getMeta('removeTable');
                let tableId = '';
                // Remove the table from the state
                if (removeTableMeta) allTables = allTables.filter(([id])=>id !== removeTableMeta);
                else tableId = hoverTableMeta === null || hoverTableMeta === void 0 ? void 0 : hoverTableMeta[0];
                sort = {
                    ...sort,
                    ...sortMeta
                };
                const isTableInState = allTables.some(([id])=>id === tableId);
                // Update the table in the state
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                /**
         * Create decorations for the sorting icons
         */ const decs = [];
                const sortingDecorations = pluginState.decorations.find(undefined, undefined, (spec)=>spec.tableId === tableId && spec.type === 'sorting-decoration');
                // TODO: ED-26961 - add support for keyboard only users
                if (hoverTableMeta && !isTableInState || sortMeta || isTableInState && !sortingDecorations.length) {
                    allTables.forEach((table)=>{
                        const [tableId, _node, pos] = table;
                        const tableNode = tr.doc.nodeAt(tr.mapping.map(pos));
                        if (!tableNode || tableNode.type.name !== 'table') return pluginState;
                        const map = (0, $dpooP.TableMap).get(tableNode);
                        const hasMergedCells = new Set(map.map).size !== map.map.length;
                        map.mapByRow[0].forEach((cell, index)=>{
                            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                            const decorationRenderKey = (0, $eUgRu.default)();
                            decs.push((0, $16ZMX.Decoration).widget(cell + pos + 2, ()=>{
                                var _sort$tableId;
                                const element = document.createElement('div');
                                element.setAttribute((0, $4Chjr.SORT_INDEX_DATA_ATTRIBUTE), `${index}`);
                                element.classList.add((0, $4Chjr.SORTING_ICON_CLASS_NAME));
                                if (hasMergedCells) element.classList.add((0, $4Chjr.IS_DISABLED_CLASS_NAME));
                                let sortOrdered;
                                if (index === ((_sort$tableId = sort[tableId]) === null || _sort$tableId === void 0 ? void 0 : _sort$tableId.index)) {
                                    var _sort$tableId2;
                                    sortOrdered = (_sort$tableId2 = sort[tableId]) === null || _sort$tableId2 === void 0 ? void 0 : _sort$tableId2.direction;
                                } else sortOrdered = (0, $20eP6.SortOrder).NO_ORDER;
                                const { getIntl: getIntl } = (0, $4GJqd.getPluginState)(oldState);
                                nodeViewPortalProviderAPI.render(()=>(0, $fc4bM.createElement)((0, $fcCIH.Provider), {
                                        value: getIntl()
                                    }, (0, $fc4bM.createElement)((0, $jwRhl.SortingIconWrapper), {
                                        isSortingAllowed: !hasMergedCells,
                                        sortOrdered: sortOrdered,
                                        onClick: ()=>{},
                                        onKeyDown: ()=>{},
                                        api: api
                                    })), element, decorationRenderKey);
                                return element;
                            }, {
                                destroy: (node)=>{
                                    nodeViewPortalProviderAPI.remove(decorationRenderKey);
                                },
                                // side: -1 ensures the widget is placed before any content at the
                                // position, making it the first direct child of the <th> element and ensuring
                                // block marks do not affect CSS styling
                                side: -1,
                                type: 'sorting-decoration',
                                tableId: tableId
                            }));
                        });
                    });
                    decorations = (0, $16ZMX.DecorationSet).create(tr.doc, decs);
                }
                /**
         * Map the decorations to the new document if there are changes
         */ if (tr.docChanged) {
                    decorations = decorations.map(tr.mapping, tr.doc);
                    allTables = allTables.map((table)=>{
                        return [
                            table[0],
                            table[1],
                            tr.mapping.map(table[2])
                        ];
                    });
                }
                return {
                    decorations: decorations,
                    sort: sort,
                    allTables: allTables
                };
            }
        },
        key: $1lsDe.tableViewModeSortPluginKey,
        appendTransaction: (trs, oldState, newState)=>{
            var _api$editorViewMode2, _key$getState;
            // return newState.tr;
            const { mode: mode } = (api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.sharedState.currentState()) || {};
            if (mode !== 'view') return newState.tr;
            let allTables = ((_key$getState = (0, $1lsDe.tableViewModeSortPluginKey).getState(newState)) === null || _key$getState === void 0 ? void 0 : _key$getState.allTables) || [];
            /**
       * If incoming changes have affected a table node, remove the sorting. This prevents the
       * table from breaking if changes like merged cells are incoming.
       */ for (const tr of trs){
                const hoverTableMeta = tr.getMeta('mouseEnterTable');
                if (hoverTableMeta) {
                    allTables = allTables.filter(([id])=>id !== hoverTableMeta[0]);
                    allTables.push(hoverTableMeta);
                }
                const isRemote = tr.getMeta('isRemote');
                const isDocChanged = tr.docChanged;
                const isChangesIncoming = isRemote && isDocChanged;
                const oldPluginState = (0, $1lsDe.tableViewModeSortPluginKey).getState(oldState);
                const newPluginState = (0, $1lsDe.tableViewModeSortPluginKey).getState(newState);
                for (const table of allTables){
                    var _oldPluginState$sort, _newPluginState$sort;
                    const [tableId, node, pos] = table;
                    const { order: oldOrder, direction: oldDirection, index: oldIndex } = (oldPluginState === null || oldPluginState === void 0 || (_oldPluginState$sort = oldPluginState.sort) === null || _oldPluginState$sort === void 0 ? void 0 : _oldPluginState$sort[tableId]) || {};
                    if (isChangesIncoming) {
                        var _maybeTableNode$attrs;
                        const maybeTableNode = tr.doc.nodeAt(pos);
                        const isTableNodeChanged = (maybeTableNode === null || maybeTableNode === void 0 || (_maybeTableNode$attrs = maybeTableNode.attrs) === null || _maybeTableNode$attrs === void 0 ? void 0 : _maybeTableNode$attrs.localId) !== tableId || !node.eq(maybeTableNode);
                        if (isTableNodeChanged) {
                            const newtr = newState.tr;
                            newtr.setMeta('tableSortMeta', {
                                [tableId]: {}
                            });
                            newtr.setMeta('removeTable', tableId);
                            // Unsort the table here
                            if (oldOrder !== undefined) {
                                const { rows: rows, tbody: tbody } = (0, $PAPAk.getTableElements)(tableId);
                                if (!rows || !tbody) return newtr;
                                const sortedOrder = [
                                    ...oldOrder
                                ].sort((a, b)=>a.value - b.value);
                                sortedOrder.forEach((index, i)=>{
                                    tbody.appendChild(rows[index.index + 1]);
                                });
                                return newtr;
                            }
                        }
                    }
                    /**
           * Sort the table if the sort order has changed
           */ const { order: newOrder, direction: newDirection, index: newIndex } = (newPluginState === null || newPluginState === void 0 || (_newPluginState$sort = newPluginState.sort) === null || _newPluginState$sort === void 0 ? void 0 : _newPluginState$sort[tableId]) || {};
                    const orderChanged = oldDirection !== newDirection || oldIndex !== newIndex;
                    if (orderChanged) {
                        if (!isRemote && newDirection !== (0, $20eP6.SortOrder).NO_ORDER) {
                            const { rows: rows, tbody: tbody } = (0, $PAPAk.getTableElements)(tableId);
                            if (rows && newOrder) newOrder.forEach((index, i)=>{
                                tbody === null || tbody === void 0 || tbody.appendChild(rows[index.value + 1]);
                            });
                        }
                    }
                }
            }
            return newState.tr;
        },
        props: {
            handleDOMEvents: {
                keydown: (view, event)=>{
                    // TODO: ED-26961 - fix the focus issue here, where toggling sort with a keypress loses focus
                    if (event.key === 'Enter' || event.key === ' ') {
                        var _key$getState2;
                        const pluginState = ((_key$getState2 = (0, $1lsDe.tableViewModeSortPluginKey).getState(view.state)) === null || _key$getState2 === void 0 ? void 0 : _key$getState2.sort) || {};
                        (0, $PAPAk.toggleSort)(view, event, pluginState);
                    }
                },
                click: (view, event)=>{
                    var _key$getState3;
                    const pluginState = ((_key$getState3 = (0, $1lsDe.tableViewModeSortPluginKey).getState(view.state)) === null || _key$getState3 === void 0 ? void 0 : _key$getState3.sort) || {};
                    (0, $PAPAk.toggleSort)(view, event, pluginState);
                }
            },
            decorations (state) {
                var _key$getState4;
                const decs = ((_key$getState4 = (0, $1lsDe.tableViewModeSortPluginKey).getState(state)) === null || _key$getState4 === void 0 ? void 0 : _key$getState4.decorations) || (0, $16ZMX.DecorationSet).empty;
                return decs;
            }
        }
    });
};

});
parcelRegister("jwRhl", function(module, exports) {
$parcel$export(module.exports, "SortingIconWrapper", () => $793b92fbbf484e94$export$25fb1502cf13990c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $jBiFR = parcelRequire("jBiFR");

var $9oAqi = parcelRequire("9oAqi");
const $793b92fbbf484e94$export$25fb1502cf13990c = (props)=>{
    const { mode: mode } = (0, $9oAqi.useSharedPluginStateWithSelector)(props.api, [
        'editorViewMode'
    ], (states)=>{
        var _states$editorViewMod;
        return {
            mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
        };
    });
    if (mode === 'edit') return null;
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jBiFR.default), {
        ...props
    });
};

});

parcelRegister("4Chjr", function(module, exports) {
$parcel$export(module.exports, "SORTING_ICON_CLASS_NAME", () => $9e09c63f883584ec$export$b61cb5d3425147f);
$parcel$export(module.exports, "IS_DISABLED_CLASS_NAME", () => $9e09c63f883584ec$export$fb5c0ba8f0806db1);
$parcel$export(module.exports, "SORT_INDEX_DATA_ATTRIBUTE", () => $9e09c63f883584ec$export$665a01df2c44393a);
const $9e09c63f883584ec$export$b61cb5d3425147f = 'view-mode-sorting-icon';
const $9e09c63f883584ec$export$fb5c0ba8f0806db1 = 'is-disabled';
const $9e09c63f883584ec$export$665a01df2c44393a = 'data-sort-index';

});

parcelRegister("1lsDe", function(module, exports) {
$parcel$export(module.exports, "tableViewModeSortPluginKey", () => $4fdbd1d3d396201b$export$994e077cfffa9ab4);

var $801jp = parcelRequire("801jp");
const $4fdbd1d3d396201b$export$994e077cfffa9ab4 = new (0, $801jp.PluginKey)('tableViewModeSortPlugin');

});

parcelRegister("PAPAk", function(module, exports) {
$parcel$export(module.exports, "toggleSort", () => $6cb689a9887c016b$export$e9466f5bf01e21a7);
$parcel$export(module.exports, "getTableElements", () => $6cb689a9887c016b$export$8bb6f5de29aeee1e);

var $20eP6 = parcelRequire("20eP6");

var $vmDrV = parcelRequire("vmDrV");

var $jtrdr = parcelRequire("jtrdr");

var $4Chjr = parcelRequire("4Chjr");
const $6cb689a9887c016b$export$f81e43e57018b033 = (oldOrder, tableElement)=>{
    const tbody = tableElement.querySelector(`:scope > tbody`);
    const rows = tableElement.querySelectorAll(`:scope > tbody > tr`);
    const sortedOrder = [
        ...oldOrder
    ].sort((a, b)=>a.value - b.value);
    sortedOrder.forEach((item)=>{
        tbody === null || tbody === void 0 || tbody.appendChild(rows[item.index + 1]);
    });
};
const $6cb689a9887c016b$var$getSortOrderFromTable = (tableNode, sortIndex, direction)=>{
    const tableArray = (0, $vmDrV.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    tableArray.shift(); // remove header row
    // Keep track of the origin row index
    const tableArrayWithIndex = tableArray.map((node, index)=>({
            node: node,
            originalIndex: index
        }));
    const compareNodesInOrder = (0, $jtrdr.createCompareNodes)({
        // TODO: ED-26961 - add inline card support
        getInlineCardTextFromStore () {
            return null;
        }
    }, direction);
    const order = tableArrayWithIndex.sort((a, b)=>{
        return compareNodesInOrder(a.node[sortIndex], b.node[sortIndex]);
    }).map((tableRow, index)=>({
            value: tableRow.originalIndex,
            index: index
        }));
    return [
        // Ensures the first tr is always first in the order
        {
            value: -1,
            index: -1
        },
        ...order
    ];
};
const $6cb689a9887c016b$export$e9466f5bf01e21a7 = (view, event, pluginState)=>{
    var _target$closest, _tableNode$type;
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;
    const widget = target.closest(`.${(0, $4Chjr.SORTING_ICON_CLASS_NAME)}`);
    if (widget !== null && widget !== void 0 && widget.classList.contains((0, $4Chjr.IS_DISABLED_CLASS_NAME)) || !widget) return;
    const dataSortIndex = target === null || target === void 0 || (_target$closest = target.closest('.ProseMirror-widget')) === null || _target$closest === void 0 ? void 0 : _target$closest.getAttribute((0, $4Chjr.SORT_INDEX_DATA_ATTRIBUTE));
    const tr = view.state.tr;
    const tableElement = target.closest('table');
    if (!tableElement || !dataSortIndex) return;
    const tablePos = view.posAtDOM(tableElement, 0);
    const tableNode = view.state.doc.nodeAt(tablePos - 1);
    const tableId = tableNode === null || tableNode === void 0 ? void 0 : tableNode.attrs.localId;
    if (!tableId || !tableNode || (tableNode === null || tableNode === void 0 || (_tableNode$type = tableNode.type) === null || _tableNode$type === void 0 ? void 0 : _tableNode$type.name) !== 'table') return;
    const { index: index, direction: initialDirection, order: oldOrder } = (pluginState === null || pluginState === void 0 ? void 0 : pluginState[tableId]) || {};
    let direction = initialDirection;
    // Unsort if there was already a sort
    if (direction !== (0, $20eP6.SortOrder).NO_ORDER && oldOrder !== undefined) $6cb689a9887c016b$export$f81e43e57018b033(oldOrder, tableElement);
    const sortIndex = parseInt(dataSortIndex);
    if (sortIndex === index) switch(direction){
        case (0, $20eP6.SortOrder).NO_ORDER:
            direction = (0, $20eP6.SortOrder).ASC;
            break;
        case (0, $20eP6.SortOrder).ASC:
            direction = (0, $20eP6.SortOrder).DESC;
            break;
        case (0, $20eP6.SortOrder).DESC:
            direction = (0, $20eP6.SortOrder).NO_ORDER;
            break;
    }
    else direction = (0, $20eP6.SortOrder).ASC; // default direction when a new index is clicked
    const order = $6cb689a9887c016b$var$getSortOrderFromTable(tableNode, sortIndex, direction);
    if (direction === (0, $20eP6.SortOrder).NO_ORDER) tr.setMeta('tableSortMeta', {
        [tableId]: {}
    });
    else tr.setMeta('tableSortMeta', {
        [tableId]: {
            index: sortIndex,
            direction: direction,
            order: order,
            tableElement: tableElement
        }
    });
    view.dispatch(tr);
};
const $6cb689a9887c016b$export$8bb6f5de29aeee1e = (tableId)=>{
    const tableElement = document.querySelector(`table[data-table-local-id="${tableId}"]`);
    const tbody = tableElement === null || tableElement === void 0 ? void 0 : tableElement.querySelector(':scope > tbody');
    const rows = tableElement === null || tableElement === void 0 ? void 0 : tableElement.querySelectorAll(':scope > tbody > tr');
    return {
        tbody: tbody,
        rows: rows
    };
};

});


parcelRegister("kYtNC", function(module, exports) {
$parcel$export(module.exports, "ContentComponent", () => $68fb48d451fed490$export$2dda1e4a1d1f6a81);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $3LeME = parcelRequire("3LeME");

var $bFfDp = parcelRequire("bFfDp");

var $jmJEY = parcelRequire("jmJEY");

var $ctKot = parcelRequire("ctKot");

var $9oAqi = parcelRequire("9oAqi");

var $014x6 = parcelRequire("014x6");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $llmZk = parcelRequire("llmZk");

var $7bj8F = parcelRequire("7bj8F");

var $5SonH = parcelRequire("5SonH");

var $8TCO2 = parcelRequire("8TCO2");

var $e2Waz = parcelRequire("e2Waz");

var $iZvMJ = parcelRequire("iZvMJ");

var $9dGzO = parcelRequire("9dGzO");

var $8xaQS = parcelRequire("8xaQS");

var $8qPMo = parcelRequire("8qPMo");
const $68fb48d451fed490$var$selector = (states)=>{
    var _states$tableState, _states$tableState2, _states$tableState3, _states$tableState4, _states$tableState5, _states$tableState6, _states$tableState7, _states$tableState8, _states$tableState9, _states$tableState0, _states$tableState1, _states$tableState10, _states$tableState11, _states$tableState12, _states$tableState13, _states$tableState14, _states$tableState15, _states$tableState16, _states$tableState17, _states$tableState18, _states$tableState19, _states$tableState20, _states$tableState21, _states$tableState22, _states$tableState23;
    return {
        resizingTableLocalId: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.resizingTableLocalId,
        resizingTableRef: (_states$tableState2 = states.tableState) === null || _states$tableState2 === void 0 ? void 0 : _states$tableState2.resizingTableRef,
        isTableResizing: (_states$tableState3 = states.tableState) === null || _states$tableState3 === void 0 ? void 0 : _states$tableState3.isTableResizing,
        isResizing: (_states$tableState4 = states.tableState) === null || _states$tableState4 === void 0 ? void 0 : _states$tableState4.isResizing,
        widthToWidest: (_states$tableState5 = states.tableState) === null || _states$tableState5 === void 0 ? void 0 : _states$tableState5.widthToWidest,
        tableNode: (_states$tableState6 = states.tableState) === null || _states$tableState6 === void 0 ? void 0 : _states$tableState6.tableNode,
        targetCellPosition: (_states$tableState7 = states.tableState) === null || _states$tableState7 === void 0 ? void 0 : _states$tableState7.targetCellPosition,
        isContextualMenuOpen: (_states$tableState8 = states.tableState) === null || _states$tableState8 === void 0 ? void 0 : _states$tableState8.isContextualMenuOpen,
        tableRef: (_states$tableState9 = states.tableState) === null || _states$tableState9 === void 0 ? void 0 : _states$tableState9.tableRef,
        pluginConfig: (_states$tableState0 = states.tableState) === null || _states$tableState0 === void 0 ? void 0 : _states$tableState0.pluginConfig,
        insertColumnButtonIndex: (_states$tableState1 = states.tableState) === null || _states$tableState1 === void 0 ? void 0 : _states$tableState1.insertColumnButtonIndex,
        insertRowButtonIndex: (_states$tableState10 = states.tableState) === null || _states$tableState10 === void 0 ? void 0 : _states$tableState10.insertRowButtonIndex,
        isHeaderColumnEnabled: (_states$tableState11 = states.tableState) === null || _states$tableState11 === void 0 ? void 0 : _states$tableState11.isHeaderColumnEnabled,
        isHeaderRowEnabled: (_states$tableState12 = states.tableState) === null || _states$tableState12 === void 0 ? void 0 : _states$tableState12.isHeaderRowEnabled,
        tableWrapperTarget: (_states$tableState13 = states.tableState) === null || _states$tableState13 === void 0 ? void 0 : _states$tableState13.tableWrapperTarget,
        isCellMenuOpenByKeyboard: (_states$tableState14 = states.tableState) === null || _states$tableState14 === void 0 ? void 0 : _states$tableState14.isCellMenuOpenByKeyboard,
        stickyHeader: (_states$tableState15 = states.tableState) === null || _states$tableState15 === void 0 ? void 0 : _states$tableState15.stickyHeader,
        dragMenuDirection: (_states$tableState16 = states.tableState) === null || _states$tableState16 === void 0 ? void 0 : _states$tableState16.dragMenuDirection,
        dragMenuIndex: (_states$tableState17 = states.tableState) === null || _states$tableState17 === void 0 ? void 0 : _states$tableState17.dragMenuIndex,
        isDragMenuOpen: (_states$tableState18 = states.tableState) === null || _states$tableState18 === void 0 ? void 0 : _states$tableState18.isDragMenuOpen,
        isSizeSelectorOpen: (_states$tableState19 = states.tableState) === null || _states$tableState19 === void 0 ? void 0 : _states$tableState19.isSizeSelectorOpen,
        sizeSelectorTargetRef: (_states$tableState20 = states.tableState) === null || _states$tableState20 === void 0 ? void 0 : _states$tableState20.sizeSelectorTargetRef,
        // IMPORTANT: hovered states are used by FloatingDragMenu component to render popup in the correct location
        hoveredRows: (_states$tableState21 = states.tableState) === null || _states$tableState21 === void 0 ? void 0 : _states$tableState21.hoveredRows,
        hoveredColumns: (_states$tableState22 = states.tableState) === null || _states$tableState22 === void 0 ? void 0 : _states$tableState22.hoveredColumns,
        hoveredCell: (_states$tableState23 = states.tableState) === null || _states$tableState23 === void 0 ? void 0 : _states$tableState23.hoveredCell
    };
};
const $68fb48d451fed490$var$ContentComponentInternal = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    var _api$analytics, _api$accessibilityUti, _api$analytics2;
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const ariaNotifyPlugin = api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 ? void 0 : _api$accessibilityUti.actions.ariaNotify;
    const { resizingTableLocalId: resizingTableLocalId, resizingTableRef: resizingTableRef, isTableResizing: isTableResizing, isResizing: isResizing, widthToWidest: widthToWidest, tableNode: tableNode, targetCellPosition: targetCellPosition, isContextualMenuOpen: isContextualMenuOpen, tableRef: tableRef, pluginConfig: pluginConfig, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, isHeaderColumnEnabled: isHeaderColumnEnabled, isHeaderRowEnabled: isHeaderRowEnabled, tableWrapperTarget: tableWrapperTarget, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, stickyHeader: stickyHeader, dragMenuDirection: dragMenuDirection, dragMenuIndex: dragMenuIndex, isDragMenuOpen: isDragMenuOpen, isSizeSelectorOpen: isSizeSelectorOpen, sizeSelectorTargetRef: sizeSelectorTargetRef } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'table'
    ], $68fb48d451fed490$var$selector);
    const { allowControls: allowControls } = pluginConfig ?? {};
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            targetCellPosition && (tableRef || isCellMenuOpenByKeyboard) && !isResizing && options && options.allowContextualMenu && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $llmZk.default), {
                api: api,
                isNumberColumnEnabled: tableNode && tableNode.attrs.isNumberColumnEnabled,
                editorView: editorView,
                tableNode: tableNode,
                mountPoint: popupsMountPoint,
                targetCellPosition: targetCellPosition,
                scrollableElement: popupsScrollableElement,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                isContextualMenuOpen: isContextualMenuOpen,
                stickyHeader: stickyHeader,
                tableWrapper: tableWrapperTarget,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard
            }),
            allowControls && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8TCO2.default), {
                tableNode: tableNode,
                tableRef: tableRef,
                insertColumnButtonIndex: insertColumnButtonIndex,
                insertRowButtonIndex: insertRowButtonIndex,
                isHeaderColumnEnabled: isHeaderColumnEnabled,
                isHeaderRowEnabled: isHeaderRowEnabled,
                isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                hasStickyHeaders: stickyHeader && stickyHeader.sticky,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: (options === null || options === void 0 ? void 0 : options.getEditorFeatureFlags) || defaultGetEditorFeatureFlags,
                isChromelessEditor: options === null || options === void 0 ? void 0 : options.isChromelessEditor,
                api: api,
                isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor
            }),
            (options === null || options === void 0 ? void 0 : options.allowContextualMenu) && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7bj8F.default), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                isOpen: Boolean(isContextualMenuOpen) && !isResizing,
                pluginConfig: pluginConfig,
                editorAnalyticsAPI: editorAnalyticsAPI,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                getEditorFeatureFlags: (options === null || options === void 0 ? void 0 : options.getEditorFeatureFlags) || defaultGetEditorFeatureFlags,
                isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
                isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
                api: api,
                isDragMenuOpen: isDragMenuOpen
            }),
            (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e2Waz.default), {
                api: api,
                boundariesElement: popupsBoundariesElement,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                stickyHeaders: stickyHeader,
                tableWrapper: tableWrapperTarget,
                targetCellPosition: targetCellPosition
            }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5SonH.default), {
                editorView: editorView,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                tableRef: tableRef,
                tableNode: tableNode,
                targetCellPosition: targetCellPosition,
                direction: dragMenuDirection,
                index: dragMenuIndex,
                isOpen: !!isDragMenuOpen && !isResizing,
                getEditorContainerWidth: defaultGetEditorContainerWidth,
                editorAnalyticsAPI: editorAnalyticsAPI,
                stickyHeaders: stickyHeader,
                pluginConfig: pluginConfig,
                isTableScalingEnabled: options === null || options === void 0 ? void 0 : options.isTableScalingEnabled,
                getEditorFeatureFlags: (options === null || options === void 0 ? void 0 : options.getEditorFeatureFlags) || defaultGetEditorFeatureFlags,
                ariaNotifyPlugin: ariaNotifyPlugin,
                api: api,
                isCommentEditor: options === null || options === void 0 ? void 0 : options.isCommentEditor,
                tableWrapper: tableWrapperTarget
            }),
            ((options === null || options === void 0 ? void 0 : options.isTableScalingEnabled) || (options === null || options === void 0 ? void 0 : options.tableOptions.allowTableResizing) && options.isCommentEditor) && isTableResizing && widthToWidest && resizingTableLocalId && resizingTableRef && widthToWidest[resizingTableLocalId] && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $iZvMJ.FloatingToolbarLabel), {
                target: resizingTableRef,
                content: (0, $kaRof.editorExperiment)('single_column_layouts', true) ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ctKot.ResizerBreakoutModeLabel), {
                    layout: "full-width"
                }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8qPMo.FullWidthDisplay), {}),
                alignX: 'center',
                alignY: 'bottom',
                stick: true,
                forcePlacement: true,
                zIndex: (0, $014x6.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    10
                ]
            }),
            isTableSelectorEnabled && isSizeSelectorOpen && /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8xaQS.SizeSelector), {
                api: api,
                isOpenedByKeyboard: false,
                popupsMountPoint: popupsMountPoint,
                target: sizeSelectorTargetRef ?? (0, $jmJEY.getDomRefFromSelection)(editorView, (0, $3LeME.ACTION_SUBJECT_ID).PICKER_TABLE_SIZE, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions),
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            })
        ]
    });
};
const $68fb48d451fed490$export$2dda1e4a1d1f6a81 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, options: options, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isTableSelectorEnabled: isTableSelectorEnabled, defaultGetEditorContainerWidth: defaultGetEditorContainerWidth, defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags })=>{
    var _api$featureFlags;
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $bFfDp.ErrorBoundary), {
        component: (0, $3LeME.ACTION_SUBJECT).TABLES_PLUGIN,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9dGzO.GlobalStylesWrapper), {
                featureFlags: api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState(),
                api: api
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)($68fb48d451fed490$var$ContentComponentInternal, {
                api: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                options: options,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                isTableSelectorEnabled: isTableSelectorEnabled,
                defaultGetEditorContainerWidth: defaultGetEditorContainerWidth,
                defaultGetEditorFeatureFlags: defaultGetEditorFeatureFlags
            })
        ]
    });
};

});
parcelRegister("llmZk", function(module, exports) {
$parcel$export(module.exports, "default", () => $7123e064e83834d2$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $3LeME = parcelRequire("3LeME");

var $bFfDp = parcelRequire("bFfDp");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $dXHAJ = parcelRequire("dXHAJ");

var $7h5CJ = parcelRequire("7h5CJ");

var $9oAqi = parcelRequire("9oAqi");

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $13zmE = parcelRequire("13zmE");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $gzpzh = parcelRequire("gzpzh");
var $3Gwyn = parcelRequire("3Gwyn");

var $4GJqd = parcelRequire("4GJqd");

var $gOVfD = parcelRequire("gOVfD");

var $YREXK = parcelRequire("YREXK");

var $a9lM0 = parcelRequire("a9lM0");

var $8lWMG = parcelRequire("8lWMG");

var $ektGI = parcelRequire("ektGI");
const $7123e064e83834d2$var$BUTTON_OFFSET = 3;
const $7123e064e83834d2$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX = 2;
const $7123e064e83834d2$var$anchorStyles = /*#__PURE__*/ (0, $jctmk.css)({
    position: 'absolute',
    positionVisibility: 'anchors-visible',
    zIndex: $7123e064e83834d2$var$CONTEXTUAL_MENU_BUTTON_Z_INDEX
});
const $7123e064e83834d2$var$FloatingContextualButtonInner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    const { api: api, editorView: editorView, isContextualMenuOpen: isContextualMenuOpen, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, intl: { formatMessage: formatMessage } } = props; //  : Props & WrappedComponentProps
    const { activeTableMenu: activeTableMenu } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            activeTableMenu: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.activeTableMenu
        };
    });
    const isCellMenuOpen = (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'cell' : isContextualMenuOpen;
    const handleClick = ()=>{
        const { state: state, dispatch: dispatch } = editorView;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if (!api) return;
            const { activeTableMenu: currentActiveTableMenu } = (0, $4GJqd.getPluginState)(state);
            api.core.actions.execute(({ tr: tr })=>{
                (0, $gzpzh.toggleActiveTableMenu)({
                    type: 'cell',
                    openedBy: 'mouse'
                }, currentActiveTableMenu, api)({
                    tr: tr
                });
                return tr;
            });
            return;
        }
        // Clicking outside the dropdown handles toggling the menu closed
        // (otherwise these two toggles combat each other).
        // In the event a user clicks the chevron button again
        // That will count as clicking outside the dropdown and
        // will be toggled appropriately
        if (!isContextualMenuOpen) (0, $3Gwyn.toggleContextualMenu)()(state, dispatch);
    };
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $a4TQr.findDomRefAtPos)(targetCellPosition, domAtPos);
    (0, $fc4bM.useEffect)(()=>{
        if (isCellMenuOpenByKeyboard && !isCellMenuOpen) {
            const { state: state, dispatch: dispatch } = editorView;
            // open the menu when the keyboard shortcut is pressed
            if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
                if (!api) return;
                const { activeTableMenu: currentActiveTableMenu } = (0, $4GJqd.getPluginState)(state);
                api.core.actions.execute(({ tr: tr })=>{
                    (0, $gzpzh.toggleActiveTableMenu)({
                        type: 'cell',
                        openedBy: 'keyboard'
                    }, currentActiveTableMenu, api)({
                        tr: tr
                    });
                    return tr;
                });
                return;
            }
            (0, $3Gwyn.toggleContextualMenu)()(state, dispatch);
        }
    }, [
        isCellMenuOpenByKeyboard,
        isCellMenuOpen,
        editorView,
        api
    ]);
    if (!targetCellRef || !(targetCellRef instanceof HTMLElement)) return null;
    const labelCellOptions = formatMessage((0, $lqHJB.messages).cellOptions);
    const button = /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $ektGI.tableFloatingCellButtonStyles)(),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isCellMenuOpen && (0, $ektGI.tableFloatingCellButtonSelectedStyles)()
        ]
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $7h5CJ.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $YREXK.TableCssClassName).CONTEXTUAL_MENU_BUTTON,
        selected: isCellMenuOpen,
        title: labelCellOptions,
        keymap: (0, $eUtBU.focusToContextMenuTrigger),
        onClick: handleClick,
        iconBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($13zmE))), {
            label: "",
            color: "currentColor",
            size: "small"
        }),
        "aria-label": labelCellOptions,
        "aria-expanded": isCellMenuOpen,
        // Stable anchor used by the Post Office changeboarding spotlight
        // (cc-editor-table-cell-menu-changes) to target the cell options button.
        testId: (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? 'pm-table-contextual-menu-button' : undefined
    }));
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    const parentStickyNative = targetCellRef.parentElement && (tableWrapper === null || tableWrapper === void 0 ? void 0 : tableWrapper.classList.contains((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW));
    if (parentStickyNative && targetCellRef.nodeName === 'TH' && (0, $gOVfD.isNativeStickySupported)()) {
        var _targetCellRef$parent;
        /* We need to default to checking the anchor style because there may be a conflict with the block controls
     plugin not using the data attribute value and setting the `anchor-name` style property independently of the data attribute.
     */ let rowAnchorName = (_targetCellRef$parent = targetCellRef.parentElement) === null || _targetCellRef$parent === void 0 ? void 0 : _targetCellRef$parent.style.getPropertyValue('anchor-name');
        let colAnchorName = targetCellRef.style.getPropertyValue('anchor-name');
        if (rowAnchorName === '') {
            var _targetCellRef$parent2;
            rowAnchorName = (_targetCellRef$parent2 = targetCellRef.parentElement) === null || _targetCellRef$parent2 === void 0 ? void 0 : _targetCellRef$parent2.dataset.nodeAnchor;
        }
        if (colAnchorName === '') colAnchorName = targetCellRef === null || targetCellRef === void 0 ? void 0 : targetCellRef.dataset.nodeAnchor;
        if (rowAnchorName && colAnchorName) return /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: $7123e064e83834d2$var$anchorStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                top: `calc(${$7123e064e83834d2$var$BUTTON_OFFSET}px + anchor(${rowAnchorName} top))`,
                right: `calc(${$7123e064e83834d2$var$BUTTON_OFFSET}px + anchor(${colAnchorName} right))`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                positionAnchor: colAnchorName,
                // The native sticky header row paints above the default z-index, hiding the button.
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- z-index depends on runtime experiments
                ...(0, $bcN2K.isExperimentEnabled)('platform_editor_table_cell_menu_btn_zindex') && {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    zIndex: (0, $a9lM0.getTableZIndexes)().headerButton
                }
            },
            "data-testid": "table-cell-options-anchor-wrapper"
        }, button);
    }
    if (stickyHeader && parentSticky && tableWrapper) return /*#__PURE__*/ (0, $jctmk.jsx)((0, $8lWMG.default), {
        offset: $7123e064e83834d2$var$BUTTON_OFFSET,
        stickyHeader: stickyHeader,
        tableWrapper: tableWrapper,
        targetCellPosition: targetCellPosition,
        targetCellRef: targetCellRef,
        mountTo: tableWrapper,
        isContextualMenuOpen: isCellMenuOpen
    }, button);
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $dXHAJ.default), {
        alignX: "right",
        alignY: "start",
        target: targetCellRef,
        mountTo: tableWrapper || mountPoint,
        boundariesElement: targetCellRef,
        scrollableElement: scrollableElement,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            $7123e064e83834d2$var$BUTTON_OFFSET,
            -$7123e064e83834d2$var$BUTTON_OFFSET
        ],
        forcePlacement: true,
        allowOutOfBounds: true,
        zIndex: (0, $014x6.akEditorSmallZIndex)
    }, button);
});
const $7123e064e83834d2$var$FloatingContextualButton = (0, $fcCIH.default)($7123e064e83834d2$var$FloatingContextualButtonInner);
function $7123e064e83834d2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $bFfDp.ErrorBoundary), {
        component: (0, $3LeME.ACTION_SUBJECT).FLOATING_CONTEXTUAL_BUTTON,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        fallbackComponent: null
    }, /*#__PURE__*/ (0, $jctmk.jsx)($7123e064e83834d2$var$FloatingContextualButton, props));
}

});
parcelRegister("a9lM0", function(module, exports) {
$parcel$export(module.exports, "getTableZIndexes", () => $5f576dc7bee2819d$export$c12a1c78ef287c66);

var $014x6 = parcelRequire("014x6");

var $bcN2K = parcelRequire("bcN2K");

var $4Tw3G = parcelRequire("4Tw3G");
const $5f576dc7bee2819d$export$c12a1c78ef287c66 = ()=>{
    if ((0, $bcN2K.isExperimentEnabled)('platform_editor_sticky_headers_zindex')) return {
        header: (0, $4Tw3G.loweredNativeStickyHeaderZIndex),
        aboveHeader: (0, $4Tw3G.loweredNativeStickyHeaderZIndex) + (0, $014x6.akEditorUnitZIndex),
        belowHeader: (0, $4Tw3G.loweredNativeStickyHeaderZIndex) - (0, $014x6.akEditorUnitZIndex),
        headerButton: (0, $4Tw3G.loweredNativeStickyHeaderZIndex) + ((0, $014x6.akEditorTableCellOnStickyHeaderZIndex) - (0, $4Tw3G.nativeStickyHeaderZIndex)),
        mask: (0, $4Tw3G.stickyRowZIndex) - (0, $4Tw3G.tableContentZIndexOffset),
        resizeHandle: (0, $4Tw3G.resizeHandlerZIndex) - (0, $4Tw3G.tableContentZIndexOffset),
        dangerOverlay: (0, $4Tw3G.tableDangerOverlayZIndex) - (0, $4Tw3G.tableContentZIndexOffset),
        mediaResizeHandle: (0, $014x6.akRichMediaResizeZIndex) - (0, $4Tw3G.tableContentZIndexOffset)
    };
    return {
        header: (0, $4Tw3G.nativeStickyHeaderZIndex),
        aboveHeader: (0, $4Tw3G.aboveNativeStickyHeaderZIndex),
        belowHeader: (0, $4Tw3G.belowNativeStickyHeaderZIndex),
        headerButton: (0, $014x6.akEditorTableCellOnStickyHeaderZIndex),
        mask: (0, $4Tw3G.stickyRowZIndex),
        resizeHandle: (0, $4Tw3G.resizeHandlerZIndex),
        dangerOverlay: (0, $4Tw3G.tableDangerOverlayZIndex),
        mediaResizeHandle: (0, $014x6.akRichMediaResizeZIndex)
    };
};

});

parcelRegister("8lWMG", function(module, exports) {
$parcel$export(module.exports, "default", () => $69ce55387414a9ed$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $PIUl3 = parcelRequire("PIUl3");

var $YREXK = parcelRequire("YREXK");

var $93QoQ = parcelRequire("93QoQ");

var $a9lM0 = parcelRequire("a9lM0");
const $69ce55387414a9ed$var$BUTTON_WIDTH = 20;
const $69ce55387414a9ed$export$ed0fda2c59cbba0f = ({ buttonWidth: buttonWidth, cellRectLeft: cellRectLeft, cellRefWidth: cellRefWidth, offset: offset })=>{
    return cellRectLeft + cellRefWidth - buttonWidth - offset;
};
const $69ce55387414a9ed$export$b2a1e556154bddb = (tableWrapper, fixedButtonRefCurrent)=>{
    const tableWrapperRect = tableWrapper.getBoundingClientRect();
    const fixedButtonRect = fixedButtonRefCurrent.getBoundingClientRect();
    const scrollLeft = tableWrapper.scrollLeft;
    return fixedButtonRect.left - tableWrapperRect.left + scrollLeft;
};
const $69ce55387414a9ed$export$c947181980f67d40 = ({ children: children, isContextualMenuOpen: isContextualMenuOpen, mountTo: mountTo, offset: offset, stickyHeader: stickyHeader, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition, targetCellRef: targetCellRef })=>{
    const fixedButtonRef = (0, $fc4bM.useRef)(null);
    const observerTargetRef = (0, $fc4bM.useRef)(null);
    // Using refs here rather than state to prevent heaps of renders on scroll
    const scrollDataRef = (0, $fc4bM.useRef)(0);
    const leftPosDataRef = (0, $fc4bM.useRef)(0);
    (0, $fc4bM.useEffect)(()=>{
        const observerTargetRefCurrent = observerTargetRef.current;
        const fixedButtonRefCurrent = fixedButtonRef.current;
        if (fixedButtonRefCurrent && observerTargetRefCurrent) {
            scrollDataRef.current = tableWrapper.scrollLeft;
            leftPosDataRef.current = 0;
            // Hide the button initially in case there's a flash of the button being
            // outside the table before the Intersection Observer fires
            fixedButtonRefCurrent.style.visibility = 'hidden';
            const margin = $69ce55387414a9ed$export$b2a1e556154bddb(tableWrapper, fixedButtonRefCurrent);
            // Much more simple and predictable to add this margin to the observer target
            // rather than using it to calculate the rootMargin values
            observerTargetRefCurrent.style.marginLeft = `${margin}px`;
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) fixedButtonRefCurrent.style.visibility = 'visible';
                    else fixedButtonRefCurrent.style.visibility = 'hidden';
                });
            }, {
                root: tableWrapper,
                rootMargin: `0px ${(0, $93QoQ.insertColumnButtonOffset)}px 0px 0px`,
                threshold: 1
            });
            const handleScroll = (0, $PIUl3.default)((event)=>{
                if (fixedButtonRef.current) {
                    const delta = event.target.scrollLeft - scrollDataRef.current;
                    const style = `translateX(${leftPosDataRef.current - delta}px)`;
                    fixedButtonRef.current.style.transform = style;
                    scrollDataRef.current = event.target.scrollLeft;
                    leftPosDataRef.current = leftPosDataRef.current - delta;
                }
            });
            observer.observe(observerTargetRefCurrent);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            tableWrapper.addEventListener('scroll', handleScroll);
            return ()=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                tableWrapper.removeEventListener('scroll', handleScroll);
                fixedButtonRefCurrent.style.transform = '';
                observer.unobserve(observerTargetRefCurrent);
            };
        }
    }, [
        fixedButtonRef,
        observerTargetRef,
        tableWrapper,
        targetCellPosition,
        targetCellRef,
        isContextualMenuOpen
    ]);
    const fixedButtonTop = 0;
    const containerLeft = (0, $fc4bM.useMemo)(()=>{
        const container = targetCellRef.closest('[data-editor-container="true"]');
        return (container === null || container === void 0 ? void 0 : container.getBoundingClientRect().left) || 0;
    }, [
        targetCellRef
    ]);
    const left = (0, $fc4bM.useMemo)(()=>{
        const targetCellRect = targetCellRef.getBoundingClientRect();
        const baseLeft = $69ce55387414a9ed$export$ed0fda2c59cbba0f({
            buttonWidth: $69ce55387414a9ed$var$BUTTON_WIDTH,
            cellRectLeft: targetCellRect.left,
            cellRefWidth: targetCellRef.clientWidth,
            offset: offset
        });
        return baseLeft - containerLeft;
    }, [
        containerLeft,
        targetCellRef,
        offset
    ]);
    // Using a portal here to ensure wrapperRef has the tableWrapper as an
    // ancestor. This is required to make the Intersection Observer work.
    return /*#__PURE__*/ (0, $bTkYf.createPortal)(// Using observerTargetRef here for our Intersection Observer. There is issues
    // getting the observer to work just using the fixedButtonRef, possible due
    // to using position fixed on this Element, or possibly due to its position
    // being changed on scroll.
    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        ref: observerTargetRef,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: "var(--ds-space-0, 0px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: "var(--ds-space-250, 20px)",
            // BUTTON_WIDTH
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
        },
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            ref: fixedButtonRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'fixed',
                // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                top: fixedButtonTop + stickyHeader.padding + offset * 2,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: (0, $a9lM0.getTableZIndexes)().headerButton,
                left: // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                left,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                width: "var(--ds-space-250, 20px)",
                // BUTTON_WIDTH
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                height: "var(--ds-space-250, 20px)" // BUTTON_WIDTH
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $YREXK.TableCssClassName).CONTEXTUAL_MENU_BUTTON_FIXED,
            children: children
        })
    }), mountTo);
};
var $69ce55387414a9ed$export$2e2bcd8739ae039 = $69ce55387414a9ed$export$c947181980f67d40;

});
parcelRegister("93QoQ", function(module, exports) {
$parcel$export(module.exports, "insertColumnButtonOffset", () => $bd231bb118265248$export$af45328890cf2a82);
$parcel$export(module.exports, "tableStyles", () => $bd231bb118265248$export$e938d6f191645a3e);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $dqFZv = parcelRequire("dqFZv");

var $8aFCM = parcelRequire("8aFCM");

var $gCPs3 = parcelRequire("gCPs3");

var $f9ezd = parcelRequire("f9ezd");

var $jd8X7 = parcelRequire("jd8X7");

var $81vYS = parcelRequire("81vYS");

var $014x6 = parcelRequire("014x6");

var $014x6 = parcelRequire("014x6");

var $i0eJN = parcelRequire("i0eJN");

var $jt312 = parcelRequire("jt312");

var $dt39E = parcelRequire("dt39E");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $4Chjr = parcelRequire("4Chjr");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $l2HOR = parcelRequire("l2HOR");

var $a9lM0 = parcelRequire("a9lM0");

var $5gjFA = parcelRequire("5gjFA");
const $bd231bb118265248$var$cornerControlHeight = (0, $4Tw3G.tableToolbarSize) + 1;
const $bd231bb118265248$export$af45328890cf2a82 = (0, $4Tw3G.tableInsertColumnButtonSize) / 2;
const $bd231bb118265248$export$cc4d06b9af7cea87 = 44;
// Shared styling for numbered column buttons in selected state
const $bd231bb118265248$var$numberedColumnButtonSelectedStyles = `
	border-bottom: 1px solid ${(0, $4Tw3G.tableBorderSelectedColor)};
	border-color: ${(0, $4Tw3G.tableBorderSelectedColor)};
	background-color: ${(0, $4Tw3G.tableToolbarSelectedColor)};
	position: relative;
	z-index: ${(0, $014x6.akEditorUnitZIndex)};
	color: ${"var(--ds-text-selected, #1868DB)"};
`;
const $bd231bb118265248$var$rangeSelectionStyles = `
.${(0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $014x6.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $dt39E.getSelectionStyles)([
    (0, $jt312.SelectionStyle).Blanket,
    (0, $jt312.SelectionStyle).Border
])}

    // The non-break space /00a0 in :after selector caused a table scroll issue when pressing Cmd+A to select table
    // This line is to override the content of :after selector from the shared getSelectionStyles
    &::after {
      content: '';
    }
  }
}
`;
// Q4 path: node selection is painted by roundedTableSelectedNodeStyles() (the .selectedCell model),
// so getSelectionStyles is omitted here and only native text-selection hiding is kept.
const $bd231bb118265248$var$rangeSelectionStylesForRoundedTable = `
.${(0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $014x6.akEditorSelectedNodeClassName)} table tbody tr {
  th,td {
    ${(0, $dt39E.hideNativeBrowserTextSelectionStyles)}
  }
}
`;
const $bd231bb118265248$var$rangeSelectionStylesForFakeBorders = `
.${(0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $014x6.akEditorSelectedNodeClassName)} .${(0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER},
.${(0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER}.${(0, $014x6.akEditorSelectedNodeClassName)} .${(0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER} {
	  background: ${(0, $014x6.akEditorSelectedBorderColor)};
}
`;
// Once platform-dst-tokens-finesse is cleaned up, apply these styles unconditionally.
// Keep this scoped to cell selection so actual focus rings, danger states, and table controls
// continue to use their existing semantic colours.
const $bd231bb118265248$var$selectedCellBorderStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr{", !(0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `
		> td.${(0, $YREXK.TableCssClassName).TABLE_CELL}.${(0, $YREXK.TableCssClassName).SELECTED_CELL}:not(.${(0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER}),
		> th.${(0, $YREXK.TableCssClassName).TABLE_HEADER_CELL}.${(0, $YREXK.TableCssClassName).SELECTED_CELL}:not(.${(0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER}) {
			border-color: ${"var(--ds-border-selected, #1868DB)"};
		}` : '', ">td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ".", (0, $YREXK.TableCssClassName).SELECTED_CELL, ":not(.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ")::after,>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).SELECTED_CELL, ":not(.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ")::after,>td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ".", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "::after,>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "::after{border-color:var(--ds-border-selected, #1868DB);}}");
const $bd231bb118265248$var$sentinelStyles = `.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP}, > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
    top: ${(0, $4Tw3G.columnControlsDecorationHeight)}px;
  }
  > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      bottom: ${(0, $4Tw3G.tableScrollbarOffset) + (0, $4Tw3G.stickyRowOffsetTop) + (0, $4Tw3G.tablePadding) * 2 + 23}px;
  }
  &.${(0, $YREXK.TableCssClassName).WITH_CONTROLS} {
    > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_TOP} {
      top: 0px;
    }
    > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SENTINEL_BOTTOM} {
      margin-bottom: ${(0, $4Tw3G.columnControlsDecorationHeight)}px;
    }
  }
}`;
const $bd231bb118265248$var$stickyScrollbarSentinelStyles = `.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
 > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM},
 > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    position: absolute;
    width: 100%;
    height: 1px;
    margin-top: -1px;
    // need this to avoid sentinel being focused via keyboard
    // this still allows it to be detected by intersection observer
    visibility: hidden;
  }
  > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_TOP} {
    top: ${(0, $4Tw3G.columnControlsDecorationHeight) + $bd231bb118265248$export$cc4d06b9af7cea87 * 3}px;
  }
  > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM} {
    bottom: ${(0, $014x6.MAX_BROWSER_SCROLLBAR_HEIGHT)}px;
  }
}`;
const $bd231bb118265248$var$stickyScrollbarContainerStyles = `.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
  > .${(0, $YREXK.TableCssClassName).TABLE_STICKY_SCROLLBAR_CONTAINER} {
    width: 100%;
    display: none;
    overflow-x: auto;
    position: sticky;
    bottom: 0;
    z-index: 1;
  }
}`;
const $bd231bb118265248$var$stickyScrollbarStyles = `${$bd231bb118265248$var$stickyScrollbarContainerStyles} ${$bd231bb118265248$var$stickyScrollbarSentinelStyles}`;
const $bd231bb118265248$var$breakoutWidthStyling = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)(">*:not([data-mark-type='fragment']) .", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}>[data-mark-type='fragment'] * .", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, " .", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "{margin-left:unset!important;width:100%!important;}");
};
const $bd231bb118265248$var$viewModeSortStyles = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)("th{.", (0, $4Chjr.SORTING_ICON_CLASS_NAME), "{+p{margin-top:0!important;}}>.", (0, $4Chjr.SORTING_ICON_CLASS_NAME), "{&:has(.is-active){.", (0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}>.", (0, $4Chjr.SORTING_ICON_CLASS_NAME), "{.", (0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:0;&:focus{opacity:1;}}}&:hover:not(:has(.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ":hover)){>.", (0, $4Chjr.SORTING_ICON_CLASS_NAME), "{.", (0, $81vYS.SORTABLE_COLUMN_ICON_CLASSNAME), "{opacity:1;}}}}");
};
const $bd231bb118265248$var$tableBorderStyles = ()=>{
    return `border-color: ${0, $4Tw3G.tableBorderDeleteColor}`;
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $bd231bb118265248$var$tableStickyHeaderColumnControlsDecorationsStyle = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{z-index:0;left:-1px;}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left:1px solid ", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " tr:first-of-type th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $YREXK.TableCssClassName).HOVERED_COLUMN, "{.", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{left:0;}}}");
};
const $bd231bb118265248$var$tableStickyHeaderFirefoxFixStyle = ()=>{
    const browser = (0, $dqFZv.getBrowserInfo)();
    /*
  This is MAGIC!
  This fixes a bug which occurs in firefox when the first row becomes sticky.
  see https://product-fabric.atlassian.net/browse/ED-19177
   */ if (browser.gecko) return /*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody::before{content:'';}");
};
const $bd231bb118265248$var$baseTableStylesWithoutSharedStyle = (props)=>/*#__PURE__*/ (0, $jctmk.css)((0, $5gjFA.columnControlsLineMarker)(), ";", (0, $5gjFA.hoveredDeleteButton)(), ";", (0, $5gjFA.hoveredCell)(), ";", (0, $5gjFA.hoveredWarningCell), ";", (0, $5gjFA.insertLine)(), ";", (0, $5gjFA.resizeHandle)(), ";", // Only block getSelectionStyles when our replacement (gated by q4) owns the
    // decoration, so node selection is never left unstyled.
    (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $bd231bb118265248$var$rangeSelectionStylesForRoundedTable : $bd231bb118265248$var$rangeSelectionStyles, ";", $bd231bb118265248$var$rangeSelectionStylesForFakeBorders, ";", $bd231bb118265248$var$viewModeSortStyles(), ";", (0, $bcN2K.isExperimentEnabled)('platform_editor_sticky_headers_zindex') ? `.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			--ak-editor-table-resize-handle-z-index: ${(0, $a9lM0.getTableZIndexes)().mediaResizeHandle};
		}` : '', " ", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `
		.ak-editor-panel:not([data-panel-type="custom"]) .${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			${0, $014x6.akEditorTableContainerBg}: ${"var(--ds-background-accent-blue-subtlest, #E9F2FE)"};
		}
		.ak-editor-panel[data-panel-type="note"] .${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			${0, $014x6.akEditorTableContainerBg}: ${"var(--ds-background-accent-purple-subtlest, #F8EEFE)"};
		}
		.ak-editor-panel[data-panel-type="tip"] .${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			${0, $014x6.akEditorTableContainerBg}: ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"};
		}
		.ak-editor-panel[data-panel-type="warning"] .${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			${0, $014x6.akEditorTableContainerBg}: ${"var(--ds-background-accent-yellow-subtlest, #FEF7C8)"};
		}
		.ak-editor-panel[data-panel-type="error"] .${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			${0, $014x6.akEditorTableContainerBg}: ${"var(--ds-background-accent-red-subtlest, #FFECEB)"};
		}
		.ak-editor-panel[data-panel-type="success"] .${(0, $YREXK.TableCssClassName).TABLE_CONTAINER} {
			${0, $014x6.akEditorTableContainerBg}: ${"var(--ds-background-accent-green-subtlest, #DCFFF1)"};
		}
	` : '', " ", $bd231bb118265248$var$tableAnchorStyles, ";.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, "{td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ",th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "{position:relative;overflow:visible;}td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "{background-color:", (0, $4Tw3G.tableCellBackgroundColor), ";&::after{height:100%;content:'';border-left:1px solid ", (0, $4Tw3G.tableBorderColor), ";border-bottom:1px solid ", (0, $4Tw3G.tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}}.", (0, $YREXK.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN, "{", (0, $5gjFA.insertColumnButtonWrapper)(), ";}.", (0, $YREXK.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW, "{", (0, $5gjFA.insertRowButtonWrapper)(), ";}", (0, $5gjFA.dragInsertButtonWrapper)(), " ", (0, $5gjFA.dragCornerControlButton)(), (0, $5gjFA.DeleteButton)(), ".", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">.", props.isDragAndDropEnabled ? (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $4Tw3G.stickyRowOffsetTop), "px;width:", (0, $014x6.akEditorTableNumberColumnWidth), "px;position:fixed!important;z-index:", (0, $014x6.akEditorStickyHeaderZIndex), "!important;box-shadow:0px -", (0, $4Tw3G.stickyRowOffsetTop), "px ", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";border-right:0 none;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `
			width: ${(0, $014x6.akEditorTableNumberColumnWidth) + 1}px;
			border-left: 1px solid ${0, $4Tw3G.tableBorderColor};

			/* Keep the new fixed left border in sync with the selected/danger states,
			   which would otherwise leave it the default colour (.active recolours the
			   rest of the border) or drop it entirely (delete-hover sets border-left: 0). */
			&.active {
				border-left-color: ${0, $4Tw3G.tableBorderSelectedColor};
			}
			&.${(0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER} {
				border-left: 1px solid ${0, $4Tw3G.tableBorderDeleteColor};
			}
			` : '', ";}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, ".sticky{position:fixed!important;z-index:", (0, $014x6.akEditorSmallZIndex), "!important;background:", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";width:", (0, $4Tw3G.tableToolbarSize), "px;height:", (0, $4Tw3G.tableToolbarSize), "px;}.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, ".sticky .", (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-bottom:0px none;border-right:0px none;height:", (0, $4Tw3G.tableToolbarSize), "px;width:", (0, $4Tw3G.tableToolbarSize), "px;}", $bd231bb118265248$var$tableStickyHeaderColumnControlsDecorationsStyle(), " ", $bd231bb118265248$var$tableStickyHeaderFirefoxFixStyle(), " .", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).ROW_CONTROLS, " .", (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".sticky{position:fixed!important;z-index:", (0, $014x6.akEditorStickyHeaderZIndex), "!important;display:flex;border-left:", (0, $4Tw3G.tableToolbarSize), "px solid ", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";margin-left:-", (0, $4Tw3G.tableToolbarSize), "px;}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " col:first-of-type{border-right:1px solid ", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";}tr.sticky{padding-top:", (0, $4Tw3G.stickyRowOffsetTop), "px;position:fixed;display:grid;z-index:", (0, $a9lM0.getTableZIndexes)().header, ";overflow-y:visible;overflow-x:hidden;grid-auto-flow:column;background:", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";box-sizing:content-box;box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);margin-left:-1px;&.no-pointer-events{pointer-events:none;}}.tableView-content-wrap:has(.tableView-content-wrap):has(\n\t\t\t.", (0, $YREXK.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, "\n\t\t){padding-left:unset;}.tableView-content-wrap:has(.", (0, $YREXK.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, "){padding-left:15px;}tr.sticky th{border-bottom:", (0, $4Tw3G.stickyHeaderBorderBottomWidth), "px solid ", (0, $4Tw3G.tableBorderColor), ";margin-right:-1px;}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " tr.sticky>th:last-child{border-right-width:1px;}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " tr.sticky>th:first-of-type{margin-left:0px;}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " tr.sticky::after{content:' ';width:", $bd231bb118265248$export$af45328890cf2a82 + 1, "px;}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).TABLE_STICKY, ":has(tr.sticky)::before{content:' ';position:sticky;pointer-events:none;top:0;float:left;transform:translateX(calc(-1 * (", (0, $gCPs3.DRAG_HANDLE_WIDTH), "px + var(--ds-space-150, 12px))));margin-bottom:calc(\n\t\t\t-1 * (var(--ds-space-400, 32px) - 1px + var(--ds-space-200, 16px) + var(--ds-space-300, 24px))\n\t\t);height:calc(var(--ds-space-400, 32px) - 1px + var(--ds-space-200, 16px) + var(--ds-space-300, 24px));width:calc(", (0, $gCPs3.DRAG_HANDLE_WIDTH), "px + var(--ds-space-150, 12px));background:linear-gradient(\n\t\t\tto bottom,\n\t\t\t", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", "\n\t\t\t\t90%,\n\t\t\ttransparent\n\t\t);z-index:", (0, $4Tw3G.rowControlsZIndex) + 5, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).TABLE_STICKY, "[data-number-column='true']:has(tr.sticky)::before{transform:translateX(\n\t\t\tcalc(\n\t\t\t\t-1 * (", (0, $gCPs3.DRAG_HANDLE_WIDTH), "px + var(--ds-space-150, 12px) + ", (0, $014x6.akEditorTableNumberColumnWidth), "px)\n\t\t\t)\n\t\t);}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .sticky+tr{min-height:0px;}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).TABLE_STICKY, "{tr.sticky td.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, ",tr.sticky th.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, "{.", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $4Tw3G.resizeHandlerAreaWidth) - (0, $4Tw3G.resizeLineWidth)) / 2 + 1, "px;}}tr.sticky td.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",tr.sticky th.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, ".", (0, $YREXK.TableCssClassName).SELECTED_CELL, "{.", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{right:", ((0, $4Tw3G.resizeHandlerAreaWidth) - (0, $4Tw3G.resizeLineWidth)) / 2, "px;}}}tr.sticky .", (0, $YREXK.TableCssClassName).HOVERED_CELL, ",tr.sticky .", (0, $YREXK.TableCssClassName).SELECTED_CELL, "{z-index:1;}tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, "{position:sticky;top:", (0, $jd8X7.tableMarginTop), "px;z-index:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $014x6.akEditorSmallZIndex) : `calc(${(0, $a9lM0.getTableZIndexes)().header})`, ";box-shadow:inset -1px 1px ", (0, $4Tw3G.tableBorderColor), ",inset 1px -1px ", (0, $4Tw3G.tableBorderColor), ";&.", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, "{", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `z-index: ${(0, $a9lM0.getTableZIndexes)().header};` : '', " box-shadow:inset -1px 1px ", (0, $4Tw3G.tableBorderColor), ",inset 1px -1px ", (0, $4Tw3G.tableBorderColor), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "::after{height:100%;content:'';border-left:1px solid ", (0, $4Tw3G.tableBorderColor), ";border-bottom:1px solid ", (0, $4Tw3G.tableBorderColor), ";position:absolute;right:0px;top:0px;bottom:0;width:100%;display:inline-block;pointer-events:none;}}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ":has(tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ")::before{content:' ';display:block;top:0;box-sizing:border-box;width:100%;height:0;margin-bottom:-", (0, $jd8X7.tableMarginTop), "px;position:sticky;border-top:", (0, $jd8X7.tableMarginTop), "px solid transparent;z-index:", (0, $a9lM0.getTableZIndexes)().mask, ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ":has(tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ")::before{border-top:", (0, $jd8X7.tableMarginTop), "px solid ", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";}", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_patch_8') ? `
	/* Borders floor to device pixels at fractional zoom; overlap the sticky row by 1px to avoid a seam. */
	.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}:has(tr.${(0, $YREXK.TableCssClassName).NATIVE_STICKY})::before {
		border-top: none;
		height: ${(0, $jd8X7.tableMarginTop) + 1}px;
		margin-bottom: -${(0, $jd8X7.tableMarginTop) + 1}px;
		background: transparent;
	}

	.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}:has(tr.${(0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE})::before {
		border-top: none;
		background: ${(0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)"};
	}
	` : '', ".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ":has(.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS, "{top:", (0, $4Tw3G.tableColumnControlsHeight), "px;z-index:", (0, $a9lM0.getTableZIndexes)().aboveHeader, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ":has(> .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{margin-top:0;}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-table-header-is-stuck='true']:has(.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, ")>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS, "{z-index:", (0, $a9lM0.getTableZIndexes)().belowHeader, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ":has(.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ")>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ">div>.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, "{top:", (0, $4Tw3G.tableColumnControlsHeight), "px;}.pm-table-wrapper:has([data-number-column='true'] tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ")::before{margin-left:-", (0, $014x6.akEditorTableNumberColumnWidth), "px;width:calc(100% + ", (0, $014x6.akEditorTableNumberColumnWidth), "px);}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).WITH_CONTROLS, "[data-table-header-is-stuck='true'] .", (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_DRAG_HANDLE, ":is([data-row-index='0'], [data-selected-row-index='0']:not([data-handle-appearance='default'])){visibility:hidden;}.", (0, $YREXK.TableCssClassName).WITH_CONTROLS, " tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, "{top:", (0, $jd8X7.tableMarginTop), "px;}.", (0, $YREXK.TableCssClassName).WITH_CONTROLS, " tr.sticky{padding-top:", (0, $4Tw3G.tableControlsSpacing), "px;}.", (0, $YREXK.TableCssClassName).WITH_CONTROLS, ".", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{margin-top:", (0, $4Tw3G.tableControlsSpacing), "px;}.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, ".sticky{border-top:", (0, $4Tw3G.tableControlsSpacing) - (0, $4Tw3G.tableToolbarSize), "px solid ", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";}", $bd231bb118265248$var$sentinelStyles, " ", $bd231bb118265248$var$stickyScrollbarStyles, " .less-padding{padding:0 ", (0, $4Tw3G.tablePadding), "px;.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ",.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, "{padding:0 ", (0, $4Tw3G.tablePadding), "px;&::after{right:6px!important;}}.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, ".", (0, $YREXK.TableCssClassName).TABLE_CHROMELESS, "{left:-4px;}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{padding:0 ", (0, $4Tw3G.tablePadding), "px;}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, ".", (0, $YREXK.TableCssClassName).TABLE_CHROMELESS, "{left:-8px;}&.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $014x6.akEditorTableNumberColumnWidth) + (0, $4Tw3G.tablePadding) - 1, "px;}.", (0, $8aFCM.TableSharedCssClassName).TABLE_LEFT_BORDER, "{left:8px;}.", (0, $8aFCM.TableSharedCssClassName).TABLE_RIGHT_BORDER, "{right:8px;}}>.", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, "{/**\n       * Prevent margins collapsing, aids with placing the gap-cursor correctly\n       * @see https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Box_Model/Mastering_margin_collapsing\n       *\n       * TODO: Enable this, many tests will fail!\n       * border-top: 1px solid transparent;\n       */}", $bd231bb118265248$var$breakoutWidthStyling(), " ", (0, $5gjFA.columnControlsDecoration)(), ";", (0, $5gjFA.rowControlsWrapperDotStyle)(), ";.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, "{width:", (0, $4Tw3G.tableToolbarSize) + 1, "px;height:", $bd231bb118265248$var$cornerControlHeight, "px;display:none;.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{position:relative;", (0, $5gjFA.InsertMarker)(`
          left: -11px;
          top: 9px;
        `), ";}}.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, ".sticky{.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS_INSERT_ROW_MARKER, "{display:none!important;}}.", (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON, "{position:absolute;top:0;width:", (0, $4Tw3G.tableToolbarSize) + 1, "px;height:", (0, $4Tw3G.tableToolbarSize) + 1, "px;border:1px solid ", (0, $4Tw3G.tableBorderColor), ";border-radius:0;border-top-left-radius:", (0, $4Tw3G.tableBorderRadiusSize), "px;background:", (0, $4Tw3G.tableHeaderCellBackgroundColor), ";box-sizing:border-box;padding:0;:focus{outline:none;}}.active .", (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON, "{border-color:", (0, $4Tw3G.tableBorderSelectedColor), ";background:", (0, $4Tw3G.tableToolbarSelectedColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, ",.", (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON, "{width:", (0, $014x6.akEditorTableToolbarSize) + (0, $014x6.akEditorTableNumberColumnWidth) + 1, "px;}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS, " .", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON, "{border-right-width:0;}}:not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON, ":hover{border-color:", (0, $4Tw3G.tableBorderSelectedColor), ";background:", (0, $4Tw3G.tableToolbarSelectedColor), ";cursor:pointer;}:not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).CONTROLS_CORNER_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "{border-color:", (0, $4Tw3G.tableBorderDeleteColor), ";background:", (0, $4Tw3G.tableToolbarDeleteColor), ";}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS, "{width:", (0, $4Tw3G.tableToolbarSize), "px;box-sizing:border-box;display:none;position:relative;", (0, $5gjFA.InsertMarker)(`
        bottom: -1px;
        left: -11px;
      `), ";", (0, $5gjFA.HeaderButton)(`
        border-bottom: 1px solid ${(0, $4Tw3G.tableBorderColor)};
        border-right: 0px;
        border-radius: 0;
        height: 100%;
        width: ${(0, $4Tw3G.tableToolbarSize)}px;

        .${(0, $YREXK.TableCssClassName).CONTROLS_BUTTON_OVERLAY} {
          position: absolute;
          width: 30px;
          height: 50%;
          right: 0;
          bottom: 0;
        }
        .${(0, $YREXK.TableCssClassName).CONTROLS_BUTTON_OVERLAY}:first-of-type {
          top: 0;
        }
      `), ";.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_INNER, "{display:flex;flex-direction:column;}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":last-child>button{border-bottom-left-radius:", (0, $4Tw3G.tableBorderRadiusSize), "px;}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, "{position:relative;margin-top:-1px;}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ":hover,.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON_WRAP, ".active,.", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON, ":hover{z-index:", (0, $014x6.akEditorUnitZIndex), ";}}.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS, "{display:grid;align-items:center;position:absolute;z-index:", (0, $4Tw3G.rowControlsZIndex) + 4, ";.", (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;align-self:end;height:100%;width:18px;}.", (0, $YREXK.TableCssClassName).DRAG_ROW_FLOATING_INSERT_DOT, "{position:absolute;bottom:-3px;left:2px;background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);height:4px;width:4px;border-radius:50%;pointer-events:none;}}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS, "{.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{height:", (0, $4Tw3G.tableColumnControlsHeight), "px;position:absolute;top:var(--ds-space-negative-150, -12px);z-index:", (0, $a9lM0.getTableZIndexes)().resizeHandle, ";}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT_WRAPPER, "{position:absolute;height:", (0, $4Tw3G.tableColumnControlsHeight), "px;width:100%;}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_FLOATING_INSERT_DOT, "{background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);height:4px;width:4px;border-radius:50%;position:absolute;right:-2px;}}.", (0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CLICKABLE_ZONE, "{background:none;border:none;outline:none;position:absolute;margin:0;padding:0;display:flex;align-items:center;cursor:pointer;:focus{outline:none;}}.", (0, $YREXK.TableCssClassName).DRAG_HANDLE_BUTTON_CONTAINER, "{cursor:grab;pointer-events:auto;line-height:0;padding:0;border-radius:6px;width:max-content;border:2px solid var(--ds-surface, #FFFFFF);display:flex;justify-content:center;align-items:center;background:transparent;outline:none;&.placeholder{background-color:transparent;border:2px solid transparent;}&.", (0, $YREXK.TableCssClassName).DRAG_HANDLE_DISABLED, "{cursor:pointer;& svg{&>rect.", (0, $YREXK.TableCssClassName).DRAG_HANDLE_MINIMISED, "{fill:var(--ds-background-accent-gray-subtler, #DDDEE1);}&>rect{fill:var(--ds-background-accent-gray-subtlest, #F0F1F2);}&>g>rect{fill:var(--ds-icon-disabled, #080F214A);}}}&:not(.", (0, $YREXK.TableCssClassName).DRAG_HANDLE_DISABLED, "){& svg{rect{fill:var(--ds-background-accent-gray-subtler, #DDDEE1);}g{fill:var(--ds-icon-subtle, #505258);}}&:hover{svg{rect{fill:var(--ds-background-accent-blue-subtle, #669DF1);}g{fill:var(--ds-icon-inverse, #FFFFFF);}}}&:active{cursor:grabbing;}&.selected{:focus{outline:2px solid var(--ds-border-focused, #4688EC);outline-offset:1px;}&:active{outline:none;}svg{rect{fill:var(--ds-background-accent-blue-subtle, #669DF1);}g{fill:var(--ds-icon-inverse, #FFFFFF);}}}&.danger{svg{rect{fill:var(--ds-background-accent-red-subtler-pressed, #FD9891);}g{fill:var(--ds-border-inverse, #FFFFFF);}}}}}", (0, $5gjFA.floatingColumnControls)(), " :not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).ROW_CONTROLS, "{", (0, $5gjFA.HeaderButtonHover)(), " ", (0, $5gjFA.HeaderButtonDanger)(), ";}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, "{position:relative;float:right;margin-left:", (0, $014x6.akEditorTableToolbarSize), "px;top:", props.isDragAndDropEnabled ? 0 : (0, $014x6.akEditorTableToolbarSize), "px;width:", (0, $014x6.akEditorTableNumberColumnWidth) + 1, "px;box-sizing:border-box;}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border:1px solid ", (0, $4Tw3G.tableBorderColor), ";box-sizing:border-box;margin-top:-1px;padding-bottom:2px;padding:", (0, $014x6.relativeSizeToBaseFontSize)(10), " 2px;text-align:center;font-size:", (0, $014x6.relativeSizeToBaseFontSize)(14), ";background-color:", (0, $4Tw3G.tableHeaderCellBackgroundColor), ";color:", (0, $4Tw3G.tableTextColor), ";border-color:", (0, $4Tw3G.tableBorderColor), ";:first-child:not(style),style:first-child+*{margin-top:0;}:last-child{border-bottom:1px solid ", (0, $4Tw3G.tableBorderColor), ";}}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">.", props.isDragAndDropEnabled ? (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER : (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, "{.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, ":first-of-type::after{content:'';display:block;height:33px;width:100%;background-color:var(--ds-surface, #FFFFFF);position:absolute;top:-34px;left:-1px;}}.", (0, $YREXK.TableCssClassName).WITH_CONTROLS, "{.", (0, $YREXK.TableCssClassName).CORNER_CONTROLS, ",.", (0, $YREXK.TableCssClassName).ROW_CONTROLS, "{display:block;}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, "{padding-left:0px;.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:0 none;}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{", $bd231bb118265248$var$numberedColumnButtonSelectedStyles, ";}}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "{.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left:1px solid ", (0, $4Tw3G.tableBorderColor), ";}}}.", (0, $014x6.akEditorSelectedNodeClassName), "{.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, "{.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{", $bd231bb118265248$var$numberedColumnButtonSelectedStyles, " ", (0, $dt39E.hideNativeBrowserTextSelectionStyles), ";}}}:not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).WITH_CONTROLS, "{.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "){cursor:pointer;}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":not(.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON_DISABLED, "):hover{", $bd231bb118265248$var$numberedColumnButtonSelectedStyles, ";}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "{background-color:", (0, $4Tw3G.tableToolbarDeleteColor), ";border:1px solid ", (0, $4Tw3G.tableBorderDeleteColor), ";border-left:0;color:var(--ds-text-danger, #AE2E24);position:relative;z-index:", (0, $014x6.akEditorUnitZIndex), ";}}.tableView-content-wrap.danger{:not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).WITH_CONTROLS, "{.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{background-color:", (0, $4Tw3G.tableToolbarDeleteColor), ";border:1px solid ", (0, $4Tw3G.tableBorderDeleteColor), ";border-left:0;color:var(--ds-text-danger, #AE2E24);position:relative;z-index:", (0, $014x6.akEditorUnitZIndex), ";}}}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{table-layout:fixed;white-space:normal;border-top:none;margin-right:-1px;position:relative;>tbody>tr{white-space:pre-wrap;}.", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "+*{margin-top:0;}th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ">.fabric-editor-block-mark{>h1:first-of-type,>h2:first-of-type,>h3:first-of-type,>h4:first-of-type,>h5:first-of-type,>h6:first-of-type{margin-top:0;}}.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "{position:relative;}.", (0, $YREXK.TableCssClassName).SELECTED_CELL, "::after,.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{z-index:", (0, $014x6.akEditorSmallZIndex), ";position:absolute;content:'';left:0;right:0;top:0;bottom:0;width:100%;pointer-events:none;}.", (0, $YREXK.TableCssClassName).SELECTED_CELL, "{", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $4Tw3G.tableBorderSelectedColor};`, ";}.", (0, $YREXK.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $4Tw3G.tableCellSelectedColor), ";z-index:", (0, $014x6.akEditorSmallZIndex), ";}th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ",td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "{", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell border colors are handled by the ::after overlay in rounded mode. */  : `border-left-color: ${0, $4Tw3G.tableBorderDeleteColor};
			border-top-color: ${0, $4Tw3G.tableBorderDeleteColor};`, " &::after{height:100%;width:100%;border:1px solid ", (0, $4Tw3G.tableBorderDeleteColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $a9lM0.getTableZIndexes)().dangerOverlay, ";display:inline-block;pointer-events:none;background:", (0, $4Tw3G.tableCellDeleteColor), ";}}td.", (0, $YREXK.TableCssClassName).HOVERED_CELL, ",td.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL, "{&::after{height:100%;width:100%;border:1px solid ", (0, $4Tw3G.tableBorderSelectedColor), ";content:'';position:absolute;left:-1px;top:-1px;bottom:0;z-index:", (0, $014x6.akEditorSmallZIndex), ";display:inline-block;pointer-events:none;}&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $bd231bb118265248$var$tableBorderStyles(), ";z-index:", (0, $a9lM0.getTableZIndexes)().dangerOverlay, ";background:", (0, $4Tw3G.tableCellDeleteColor), ";}&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{", $bd231bb118265248$var$tableBorderStyles(), ";z-index:", (0, $a9lM0.getTableZIndexes)().dangerOverlay, ";background:", (0, $4Tw3G.tableCellDeleteColor), ";}}}", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $l2HOR.roundedTableOverrides)() : '', ".", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "{position:absolute;margin-top:", (0, $jd8X7.tableMarginTop), "px;left:-", (0, $4Tw3G.tableToolbarSize) + 1, "px;}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, "{position:absolute;", props.isDragAndDropEnabled ? `
			margin-top: ${0, $jd8X7.tableMarginTop}px;
			top: 0;
			left: -${(0, $4Tw3G.tableToolbarSize) + 1}px;
		` : `
			/* top of corner control is table margin top - corner control height + 1 pixel of table border. */
			top: ${(0, $jd8X7.tableMarginTop) - $bd231bb118265248$var$cornerControlHeight + 1}px;
			margin-top: 0;
			left: -${0, $4Tw3G.tableToolbarSize}px;
		`, ";}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;top:", (0, $jd8X7.tableMarginTop), "px;}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, ">.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{width:calc(anchor-size(width) + 2px);height:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_patch_8') ? (0, $jd8X7.tableMarginTop) - 1 : (0, $jd8X7.tableMarginTop), "px;background:", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";top:unset;position:fixed;position-area:top center;position-visibility:anchors-visible;z-index:", (0, $a9lM0.getTableZIndexes)().aboveHeader, ";", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_patch_8') ? `
		/* Transparent bottom 1px so the sticky header row's top border stays visible. */
		padding-bottom: 1px;
		background-clip: content-box;
		/* Chrome can fall back to start alignment after zoom, covering the header. */
		align-self: unsafe end;` : `
		/* Leave a 1px gap so the sticky header row's top border stays visible. */
		translate: 0 -1px;` : ``, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, ">.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "::before{content:'';position:relative;display:inline-block;margin-left:-", (0, $014x6.akEditorTableNumberColumnWidth) + (0, $4Tw3G.dragRowControlsWidth), "px;width:", (0, $014x6.akEditorTableNumberColumnWidth) + (0, $4Tw3G.dragRowControlsWidth), "px;height:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_patch_8') ? (0, $jd8X7.tableMarginTop) - 1 : (0, $jd8X7.tableMarginTop), "px;background:", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";z-index:", (0, $a9lM0.getTableZIndexes)().belowHeader, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th:first-of-type::before{content:'';position:absolute;display:inline-block;box-sizing:border-box;left:0;width:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `${0, $014x6.akEditorTableNumberColumnWidth}px` : `${(0, $014x6.akEditorTableNumberColumnWidth) - 1}px`, ";height:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? 'calc(100% + 2px)' : '100%', ";margin-left:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `-${(0, $014x6.akEditorTableNumberColumnWidth) + 1}px` : `-${0, $014x6.akEditorTableNumberColumnWidth}px`, ";", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? // Anchor the mask with an explicit `top` so `vertical-align` (data-valign) on the cell
    // doesn't shift it; the calc reproduces the previous top-aligned offset.
    `top: calc(${"var(--ds-space-100, 8px)"} - ${(0, $4Tw3G.stickyRowOffsetTop) + 1}px);` : `margin-top: -${0, $4Tw3G.stickyRowOffsetTop}px;`, " outline:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? 'none' : `0.5px solid ${0, $4Tw3G.tableBorderColor}`, ";border-left:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `1px solid ${0, $4Tw3G.tableBorderColor}` : 'none', ";", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `border-bottom: 1px solid ${0, $4Tw3G.tableBorderColor};` : ``, " background:var(--ds-background-accent-gray-subtlest, #F0F1F2);border-top:1px solid ", (0, $4Tw3G.tableBorderColor), ";}.ak-editor-selected-node .", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"]:not(.", (0, $YREXK.TableCssClassName).TABLE_SELECTED, ") .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th:first-of-type{&::before{outline:none;border-left-color:", (0, $4Tw3G.tableBorderSelectedColor), ";", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `border-bottom-color: ${0, $4Tw3G.tableBorderSelectedColor};` : '', " border-top-color:", (0, $4Tw3G.tableBorderSelectedColor), ";background:", (0, $4Tw3G.tableHeaderCellSelectedColor), ";}}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"].", (0, $YREXK.TableCssClassName).TABLE_SELECTED, " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ":not(.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "):first-of-type::before,.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ":not(.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ", .", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, "):first-of-type::before{outline:none;border-left-color:", (0, $4Tw3G.tableBorderSelectedColor), ";", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? `border-bottom-color: ${0, $4Tw3G.tableBorderSelectedColor}` : '', ";border-top-color:", (0, $4Tw3G.tableBorderSelectedColor), ";background:", (0, $4Tw3G.tableHeaderCellSelectedColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ":first-of-type::before,.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ":not(.", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, "):first-of-type::before{outline:none;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? // Recolour the corner edges to the delete border and composite the translucent danger
    // fill over the mask's gray so it matches the adjacent cells instead of reading as transparent.
    `border-left: 1px solid ${0, $4Tw3G.tableBorderDeleteColor};
						border-top: 1px solid ${0, $4Tw3G.tableBorderDeleteColor};
						border-bottom: 1px solid ${0, $4Tw3G.tableBorderDeleteColor};
						background-color: ${"var(--ds-background-accent-gray-subtlest, #F0F1F2)"};
						background-image: linear-gradient(${0, $4Tw3G.tableCellDeleteColor}, ${0, $4Tw3G.tableCellDeleteColor});` : `border-left: unset;
					border-top: unset;
					background: ${0, $4Tw3G.tableCellDeleteColor};`, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"].", (0, $YREXK.TableCssClassName).TABLE_SELECTED, ".", (0, $YREXK.TableCssClassName).HOVERED_DELETE_BUTTON, " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th:first-of-type::before,.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"].", (0, $YREXK.TableCssClassName).HOVERED_DELETE_BUTTON, " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr:first-of-type th.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ":not(.", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, "):first-of-type::before{outline:none;border-left-color:", (0, $4Tw3G.tableBorderDeleteColor), ";border-top-color:", (0, $4Tw3G.tableBorderDeleteColor), ";background:", (0, $4Tw3G.tableCellDeleteColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column=\"true\"] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, " th:first-of-type::before{box-shadow:0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f);}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, ":not(.", (0, $YREXK.TableCssClassName).NESTED_TABLE_WITH_CONTROLS, " *){margin-top:", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && (0, $bcN2K.isExperimentEnabled)('platform_editor_table_q4_patch_8') ? (0, $jd8X7.tableMarginTop) - 1 : (0, $jd8X7.tableMarginTop), "px!important;}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:fixed;z-index:", (0, $a9lM0.getTableZIndexes)().aboveHeader, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).WITH_CONTROLS, ":has(tr.sticky) .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{box-shadow:0 -5px 0 1px ", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "{.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_WRAPPER, "{position:absolute;z-index:", (0, $014x6.akEditorUnitZIndex), ";}}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, "{padding-bottom:0px;overflow:auto;overflow-y:hidden;position:relative;}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, "{overflow:visible;}", (0, $dRkX9.fg)('platform-dst-tokens-finesse') ? $bd231bb118265248$var$selectedCellBorderStyles() : '', ";");
const $bd231bb118265248$export$9989b31b7900261c = (props)=>/*#__PURE__*/ (0, $jctmk.css)((0, $jd8X7.tableSharedStyle)(), ";", $bd231bb118265248$var$baseTableStylesWithoutSharedStyle(props), ";");
const $bd231bb118265248$export$e938d6f191645a3e = (props)=>/*#__PURE__*/ (0, $jctmk.css)(".ProseMirror{", $bd231bb118265248$var$baseTableStylesWithoutSharedStyle(props), ";}.ProseMirror.", (0, $YREXK.TableCssClassName).IS_RESIZING, "{.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;", (0, $i0eJN.scrollbarStyles), ";}}.ProseMirror.", (0, $YREXK.TableCssClassName).RESIZE_CURSOR, "{cursor:col-resize;}");
const $bd231bb118265248$export$b0d19c9126eaec7a = /*#__PURE__*/ (0, $jctmk.css)(".ProseMirror .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:-1px;width:100%;}");
const $bd231bb118265248$export$61a2da566f69d1df = /*#__PURE__*/ (0, $jctmk.css)(".ProseMirror .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{margin-left:0;margin-right:0;", (0, $i0eJN.scrollbarStyles), ";}");
const $bd231bb118265248$var$tableAnchorStyles = /*#__PURE__*/ (0, $jctmk.css)(".pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableHeader']{anchor-name:var(", (0, $f9ezd.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}.pm-table-with-controls .pm-table-wrapper-no-overflow [data-prosemirror-node-name='tableRow']{anchor-name:var(", (0, $f9ezd.ANCHOR_VARIABLE_NAME), ", attr(data-node-anchor type(<custom-ident>)));}");

});
parcelRegister("i0eJN", function(module, exports) {
$parcel$export(module.exports, "scrollbarStyles", () => $450332c0ea5c591f$export$b2380b18b089518f);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json
const $450332c0ea5c591f$export$b2380b18b089518f = `
  -ms-overflow-style: -ms-autohiding-scrollbar;

  &::-webkit-scrollbar {
    overflow: hidden,
  }

  &::-webkit-scrollbar-corner {
    display: none;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-subtle, #00000000)"};
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: ${"var(--ds-background-neutral-bold, #292A2E)"};
    border-radius: 8px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${"var(--ds-background-neutral-bold-hovered, #3B3D42)"};
  }
`;

});

parcelRegister("jt312", function(module, exports) {
$parcel$export(module.exports, "SelectionStyle", () => $e15def0a15d1c8d6$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $e15def0a15d1c8d6$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});

parcelRegister("dt39E", function(module, exports) {
$parcel$export(module.exports, "getSelectionStyles", () => $9700839d16f4b0dd$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $9700839d16f4b0dd$export$a716852a0c5e54d5);

var $014x6 = parcelRequire("014x6");

var $jt312 = parcelRequire("jt312");
const $9700839d16f4b0dd$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$9700839d16f4b0dd$var$getSelectionStyle(selectionStyle)).concat($9700839d16f4b0dd$export$a716852a0c5e54d5).join('\n');
const $9700839d16f4b0dd$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $9700839d16f4b0dd$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $jt312.SelectionStyle).Border:
            return `
        border: ${0, $014x6.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $014x6.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $jt312.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $014x6.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $jt312.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FE)"};`;
        case (0, $jt312.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $014x6.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});

parcelRegister("l2HOR", function(module, exports) {
$parcel$export(module.exports, "roundedTableOverrides", () => $9632d17209fe3b34$export$c72b32764860aa67);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $014x6 = parcelRequire("014x6");

var $aEmSo = parcelRequire("aEmSo");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $a9lM0 = parcelRequire("a9lM0");
const $9632d17209fe3b34$var$roundedTableCellCornerStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{>tbody>tr>td[data-reaches-top][data-reaches-left],>tbody>tr>th[data-reaches-top][data-reaches-left]{border-top-left-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-top][data-reaches-right],>tbody>tr>th[data-reaches-top][data-reaches-right]{border-top-right-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-top-right-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-left],>tbody>tr>th[data-reaches-bottom][data-reaches-left]{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-right],>tbody>tr>th[data-reaches-bottom][data-reaches-right]{border-bottom-right-radius:var(--ds-radius-xlarge, 12px);&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-bottom-right-radius:var(--ds-radius-xlarge, 12px);}}}");
/**
 * Interaction-overlay corner rounding only styles (the `::after` / `::before` / hover-danger
 * pseudo-elements), split out of {@link roundedTableCellCornerStyles}.
 *
 * The base cell `border-*-radius` rules are emitted from the SSR-rendered
 * `EditorContentContainer` (see `tableRoundedCornerStyles` in editor-core) so corners are
 * rounded server-side. These overlay rules only apply during interaction (node selection
 * wash, hover-to-delete danger highlight), which require a live editorView and therefore
 * never render during SSR — so they intentionally stay in the client-only `<Global>` styles
 * to avoid shipping dead CSS in the SSR payload.
 */ const $9632d17209fe3b34$var$roundedTableCellCornerInteractionOverlayStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{>tbody>tr>td[data-reaches-top][data-reaches-left],>tbody>tr>th[data-reaches-top][data-reaches-left]{&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-top][data-reaches-right],>tbody>tr>th[data-reaches-top][data-reaches-right]{&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-top-right-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-left],>tbody>tr>th[data-reaches-bottom][data-reaches-left]{&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}}>tbody>tr>td[data-reaches-bottom][data-reaches-right],>tbody>tr>th[data-reaches-bottom][data-reaches-right]{&::after,&::before,&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,&.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-bottom-right-radius:var(--ds-radius-xlarge, 12px);}}}");
const $9632d17209fe3b34$var$roundedTableInteractionOverlayStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ".", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "::after,th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "::after{border:1px solid var(--ds-border-selected, #1868DB);box-shadow:var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f);content:'';position:absolute;top:-1px;left:-1px;right:-1px;bottom:-1px;width:auto;height:auto;z-index:", (0, $014x6.akEditorSmallZIndex), ";pointer-events:none;}td.", (0, $YREXK.TableCssClassName).HOVERED_CELL, "::after,td.", (0, $YREXK.TableCssClassName).SELECTED_CELL, "::after,th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).SELECTED_CELL, "::after,th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL, "::after,th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{left:-1px;right:-1px;top:-1px;bottom:-1px;width:auto;height:auto;}>tbody>tr>td:is(\n\t\t\t\t.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ", .", (0, $YREXK.TableCssClassName).HOVERED_CELL, ", .", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "\n\t\t\t),>tbody>tr>th:is(\n\t\t\t\t.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ", .", (0, $YREXK.TableCssClassName).HOVERED_CELL, ", .", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "\n\t\t\t){&[data-reaches-top]{border-top-color:transparent;&::after{top:-1px;bottom:-1px;border-top-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}}&[data-reaches-left]{border-left-color:transparent;&::after{border-left-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}}&[data-reaches-right]{border-right-color:transparent;&::after{border-right-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}}&[data-reaches-bottom]{border-bottom-color:transparent;&::after{border-bottom-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}}}>tbody>tr>td.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ",>tbody>tr>th.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "{&[data-reaches-top]{border-top-color:transparent;&::after{top:-1px;bottom:-1px;border-top-color:", (0, $4Tw3G.tableBorderDeleteColor), ";}}&[data-reaches-left]{border-left-color:transparent;&::after{border-left-color:", (0, $4Tw3G.tableBorderDeleteColor), ";}}&[data-reaches-right]{border-right-color:transparent;&::after{border-right-color:", (0, $4Tw3G.tableBorderDeleteColor), ";}}&[data-reaches-bottom]{border-bottom-color:transparent;&::after{border-bottom-color:", (0, $4Tw3G.tableBorderDeleteColor), ";}}}}");
const $9632d17209fe3b34$var$roundedTableSelectedNodeStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), ">.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ">.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table,.", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), ">[data-testid='table-alignment-container']>.", (0, $YREXK.TableCssClassName).TABLE_RESIZER_CONTAINER, ">.resizer-item>.resizer-hover-zone>.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ">.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{&::after{border-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}>tbody>tr>td,>tbody>tr>th{position:relative;border-color:transparent;&::after{content:'';position:absolute;left:-1px;right:-1px;top:-1px;bottom:-1px;width:auto;height:auto;border:1px solid ", (0, $4Tw3G.tableBorderSelectedColor), ";background:", (0, $4Tw3G.tableCellSelectedColor), ";z-index:", (0, $014x6.akEditorSmallZIndex), ";pointer-events:none;}}}");
const $9632d17209fe3b34$var$roundedTableNumberedColumnStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true']{>.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, ",>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, "{position:relative;border-left:0;&::before{content:'';position:absolute;top:0;left:0;bottom:0;width:100%;border-left:1px solid ", (0, $4Tw3G.tableBorderColor), ";border-top-left-radius:var(--ds-radius-xlarge, 12px);border-bottom-left-radius:var(--ds-radius-xlarge, 12px);pointer-events:none;z-index:", (0, $014x6.akEditorUnitZIndex), ";}}>.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ",>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, "{border-left-color:transparent;}>.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ",>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ",>.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_ACTIVE, ",>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_ACTIVE, ",>.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active,>.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active{border-left-color:transparent;}>.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr>th[data-reaches-top][data-reaches-left],>.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr>td[data-reaches-top][data-reaches-left]{border-top-left-radius:0;&::after{border-top-left-radius:0;}}>.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr>th[data-reaches-bottom][data-reaches-left],>.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr>td[data-reaches-bottom][data-reaches-left]{border-bottom-left-radius:0;&::after,&::before{border-bottom-left-radius:0;}}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type,.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ":first-of-type,.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_ACTIVE, ":first-of-type,.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active:first-of-type{border-top-left-radius:var(--ds-radius-xlarge, 12px);}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":last-of-type,.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ":last-of-type,.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_ACTIVE, ":last-of-type,.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".active:last-of-type{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ":first-of-type::after{border-top-left-radius:var(--ds-radius-xlarge, 12px);}.", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, ":last-of-type::after{border-bottom-left-radius:var(--ds-radius-xlarge, 12px);}>.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr th[data-reaches-top][data-reaches-left]::before{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}");
const $9632d17209fe3b34$var$roundedTableStickyHeaderCellCornerStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ",.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky{>th[data-reaches-left],>td[data-reaches-left]{border-top-left-radius:var(--ds-radius-xlarge, 12px);&::after,&::before{border-top-left-radius:var(--ds-radius-xlarge, 12px);}}>td[data-reaches-right],>th[data-reaches-right]{border-top-right-radius:var(--ds-radius-xlarge, 12px);&::after,&::before{border-top-right-radius:var(--ds-radius-xlarge, 12px);}}}.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{border-left-color:transparent;}");
const $9632d17209fe3b34$var$roundedTableStickyHeaderNumberColumnStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr th[data-reaches-top][data-reaches-left]::before,.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, " th[data-reaches-left]::before,.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW, " .", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, " th[data-reaches-left]::before{border-top-left-radius:var(--ds-radius-xlarge, 12px);border-bottom:none;}");
const $9632d17209fe3b34$var$roundedTableStickyHeaderCornerMaskStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK, "{display:none;position:sticky;top:calc(", (0, $jd8X7.tableMarginTop), "px - 1px);width:12px;height:12px;margin-bottom:-12px;background:", (0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `var(${0, $014x6.akEditorTableContainerBg}, ${"var(--ds-surface, #FFFFFF)"})` : "var(--ds-surface, #FFFFFF)", ";pointer-events:none;z-index:", (0, $a9lM0.getTableZIndexes)().header, ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "[data-number-column='true'] .", (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK, "[data-corner='left']{margin-left:-", (0, $014x6.akEditorTableNumberColumnWidth), "px;}.", (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK, "[data-corner='right']{left:calc(100% - 11px);}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ":has(> table > tbody > tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ")>.", (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK, ",.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ":has(> table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " > tbody > tr.sticky)>.", (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK, "{display:block;}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ":has(> table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, " > tbody > tr.sticky)>.", (0, $YREXK.TableCssClassName).TABLE_CORNER_MASK, "{position:fixed;top:30px;z-index:1;}");
const $9632d17209fe3b34$var$roundedTableStickyHeaderOverlayStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-top]::after,.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-top]::after{content:'';position:absolute;left:-1px;right:-1px;top:-1px;bottom:-1px;width:auto;height:auto;pointer-events:none;border-top-width:1px;border-top-style:solid;border-top-color:", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-top]:is(\n\t\t\t.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",\n\t\t\t.", (0, $YREXK.TableCssClassName).HOVERED_CELL, ",\n\t\t\t.", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "\n\t\t)::after,.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-top]:is(\n\t\t\t.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",\n\t\t\t.", (0, $YREXK.TableCssClassName).HOVERED_CELL, ",\n\t\t\t.", (0, $YREXK.TableCssClassName).ACTIVE_CURSOR_CELL, "\n\t\t)::after{border-top-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-top].", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after,.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-top].", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, "::after{border-top-color:", (0, $4Tw3G.tableBorderDeleteColor), ";}:where(.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, " > table > tbody > tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ")>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-left]::after{border-left-color:transparent;}", /*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-top]::after,.", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-top]::after{border-top-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}"), ";");
const $9632d17209fe3b34$var$roundedTableStickyHeaderShadowStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ",.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky{box-shadow:inset 0 -1px ", (0, $4Tw3G.tableBorderColor), "!important;}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, "{box-shadow:inset 0 -1px ", (0, $4Tw3G.tableBorderColor), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f)!important;}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-top],.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, ">td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-top],.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-top],.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-top]{border-top-color:", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-left],.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-left]{border-left-color:", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "[data-reaches-right],.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "[data-reaches-right]{border-right:1px solid ", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, ",.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky>td.", (0, $YREXK.TableCssClassName).TABLE_CELL, "{border-bottom:1px solid ", (0, $4Tw3G.tableBorderColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).WITH_CONTROLS, ":has(tr.sticky) .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN, " .", (0, $YREXK.TableCssClassName).NUMBERED_COLUMN_BUTTON, ":first-of-type{box-shadow:none!important;}", /*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ",.", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table.", (0, $YREXK.TableCssClassName).TABLE_STICKY, ">tbody>tr.sticky{box-shadow:inset 0 -1px ", (0, $4Tw3G.tableBorderSelectedColor), "!important;}.", (0, $YREXK.TableCssClassName).NODEVIEW_WRAPPER, ".", (0, $014x6.akEditorSelectedNodeClassName), " .", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table>tbody>tr.", (0, $YREXK.TableCssClassName).NATIVE_STICKY, ".", (0, $YREXK.TableCssClassName).NATIVE_STICKY_ACTIVE, "{box-shadow:inset 0 -1px ", (0, $4Tw3G.tableBorderSelectedColor), ",0 6px 4px -4px var(--ds-shadow-overflow-perimeter, #1E1F211f)!important;}"), ";");
const $9632d17209fe3b34$export$c72b32764860aa67 = ()=>/*#__PURE__*/ (0, $jctmk.css)(// Base corner radius is emitted from the SSR-rendered EditorContentContainer
    // (tableRoundedCornerStyles in editor-core); only the interaction overlays remain here.
    $9632d17209fe3b34$var$roundedTableCellCornerInteractionOverlayStyles(), " ", $9632d17209fe3b34$var$roundedTableInteractionOverlayStyles(), " ", $9632d17209fe3b34$var$roundedTableSelectedNodeStyles(), " ", $9632d17209fe3b34$var$roundedTableNumberedColumnStyles(), " ", $9632d17209fe3b34$var$roundedTableStickyHeaderCellCornerStyles(), " ", $9632d17209fe3b34$var$roundedTableStickyHeaderNumberColumnStyles(), " ", $9632d17209fe3b34$var$roundedTableStickyHeaderCornerMaskStyles(), " ", $9632d17209fe3b34$var$roundedTableStickyHeaderOverlayStyles(), " ", $9632d17209fe3b34$var$roundedTableStickyHeaderShadowStyles(), ";");

});

parcelRegister("5gjFA", function(module, exports) {
$parcel$export(module.exports, "InsertMarker", () => $8df155aefe493bad$export$22ce45ffbca2b768);
$parcel$export(module.exports, "HeaderButton", () => $8df155aefe493bad$export$c7c73467b57835d);
$parcel$export(module.exports, "HeaderButtonHover", () => $8df155aefe493bad$export$eb5435fbd56e8d4);
$parcel$export(module.exports, "HeaderButtonDanger", () => $8df155aefe493bad$export$7f243984d41e6570);
$parcel$export(module.exports, "dragInsertButtonWrapper", () => $8df155aefe493bad$export$cfa9a9cdd25b9d6e);
$parcel$export(module.exports, "dragCornerControlButton", () => $8df155aefe493bad$export$6134f9ac8c9f161f);
$parcel$export(module.exports, "insertColumnButtonWrapper", () => $8df155aefe493bad$export$d9daf73b486785b9);
$parcel$export(module.exports, "insertRowButtonWrapper", () => $8df155aefe493bad$export$595c9c01d7c39885);
$parcel$export(module.exports, "columnControlsLineMarker", () => $8df155aefe493bad$export$6114ba9f95ca48dc);
$parcel$export(module.exports, "DeleteButton", () => $8df155aefe493bad$export$d6f68d0fe29f8050);
$parcel$export(module.exports, "floatingColumnControls", () => $8df155aefe493bad$export$125caa90718a4ea9);
$parcel$export(module.exports, "rowControlsWrapperDotStyle", () => $8df155aefe493bad$export$a2258906ae78ec82);
$parcel$export(module.exports, "columnControlsDecoration", () => $8df155aefe493bad$export$8c8180e74f25db6a);
$parcel$export(module.exports, "hoveredDeleteButton", () => $8df155aefe493bad$export$4d63bf225990ad34);
$parcel$export(module.exports, "hoveredCell", () => $8df155aefe493bad$export$1c46f5412a5a3ae0);
$parcel$export(module.exports, "hoveredWarningCell", () => $8df155aefe493bad$export$40edb32b62e4fb85);
$parcel$export(module.exports, "resizeHandle", () => $8df155aefe493bad$export$8e36b812ea421d73);
$parcel$export(module.exports, "insertLine", () => $8df155aefe493bad$export$b9932a52fb1c7aad);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs mahual remediation */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $jd8X7 = parcelRequire("jd8X7");

var $014x6 = parcelRequire("014x6");

var $aEmSo = parcelRequire("aEmSo");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $a9lM0 = parcelRequire("a9lM0");
function $8df155aefe493bad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8df155aefe493bad$var$InsertLine = (cssString)=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_LINE, "{background:", (0, $4Tw3G.tableBorderSelectedColor), ";display:none;position:absolute;z-index:", (0, $014x6.akEditorUnitZIndex), ";", cssString, ";}");
const $8df155aefe493bad$var$Marker = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $4Tw3G.tableBorderColor),
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $4Tw3G.lineMarkerSize)}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $4Tw3G.lineMarkerSize)}px`,
        borderRadius: "var(--ds-radius-full, 9999px)",
        pointerEvents: 'none'
    });
const $8df155aefe493bad$export$22ce45ffbca2b768 = (cssString)=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_MARKER, "{", $8df155aefe493bad$var$Marker(), ";", cssString, ";}");
const $8df155aefe493bad$var$Button = (cssString)=>/*#__PURE__*/ (0, $jctmk.css)("border-radius:var(--ds-radius-small, 3px);border-width:0px;display:inline-flex;max-width:100%;text-align:center;margin:0px;padding:0px;text-decoration:none;transition:background 0.1s ease-out 0s,box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s;outline:none!important;cursor:none;>.", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON_ICON, "{display:inline-flex;max-height:100%;max-width:100%;}", cssString, ";");
const $8df155aefe493bad$export$c7c73467b57835d = (cssString)=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON, "{background:", (0, $4Tw3G.tableHeaderCellBackgroundColor), ";border:1px solid ", (0, $4Tw3G.tableBorderColor), ";display:block;box-sizing:border-box;padding:0;", cssString, ";:focus{outline:none;}}.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_BUTTON, "::after{content:' ';background-color:transparent;left:-15px;top:0;position:absolute;width:15px;height:100%;z-index:1;}.active .", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON, "{color:var(--ds-icon-inverse, #FFFFFF);background-color:", (0, $4Tw3G.tableToolbarSelectedColor), ";border-color:", (0, $4Tw3G.tableBorderSelectedColor), ";}");
const $8df155aefe493bad$export$eb5435fbd56e8d4 = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON, ":hover{color:var(--ds-icon-inverse, #FFFFFF);background-color:", (0, $4Tw3G.tableToolbarSelectedColor), ";border-color:", (0, $4Tw3G.tableBorderSelectedColor), ";cursor:pointer;}");
const $8df155aefe493bad$export$7f243984d41e6570 = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $YREXK.TableCssClassName).CONTROLS_BUTTON, "{background-color:", (0, $4Tw3G.tableToolbarDeleteColor), ";border-color:", (0, $4Tw3G.tableBorderDeleteColor), ";position:relative;z-index:", (0, $014x6.akEditorUnitZIndex), ";}");
const $8df155aefe493bad$var$InsertButton = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $014x6.akEditorUnitZIndex) + 10, ";bottom:0;}.", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER, ",.", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON, "{height:", (0, $4Tw3G.tableInsertColumnButtonSize), "px;width:", (0, $4Tw3G.tableInsertColumnButtonSize), "px;}.", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON, "{", $8df155aefe493bad$var$Button(`
      background: ${"var(--ds-surface-overlay, #FFFFFF)"};
      box-shadow: ${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"};
      color: ${"var(--ds-icon, #292A2E)"};
    `), ";}.", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_LINE, "{display:none;}&:hover .", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_LINE, "{display:flex;}");
const $8df155aefe493bad$var$InsertButtonHover = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON, ":hover{background:var(--ds-background-brand-bold, #1868DB);color:var(--ds-icon-inverse, #FFFFFF);cursor:pointer;}");
const $8df155aefe493bad$export$cfa9a9cdd25b9d6e = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, "{position:absolute;z-index:", (0, $014x6.akEditorUnitZIndex) + 10, ";}.", (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN, "{bottom:-3px;left:2px;}.", (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW, "{left:-3px;bottom:-2px;}.", (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS, "{left:6px;bottom:-2px;}.", (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, "{", $8df155aefe493bad$var$Button(`
    background: ${"var(--ds-surface-overlay, #FFFFFF)"};
    color: ${"var(--ds-icon, #292A2E)"};
    border: 1px solid ${"var(--ds-background-accent-gray-subtler, #DDDEE1)"};
    border-radius: 50%;
    height: ${(0, $4Tw3G.dragTableInsertColumnButtonSize)}px;
    width: ${(0, $4Tw3G.dragTableInsertColumnButtonSize)}px;
  `), ";}.", (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON, ":hover{background:var(--ds-background-brand-bold, #1868DB);border:1px solid var(--ds-background-brand-bold, #1868DB);color:var(--ds-icon-inverse, #FFFFFF);cursor:pointer;}");
const $8df155aefe493bad$export$6134f9ac8c9f161f = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).DRAG_CORNER_BUTTON, "{width:15px;height:15px;display:flex;justify-content:center;align-items:center;position:absolute;top:-17px;left:-5px;background-color:transparent;border:none;padding:0;outline:none;z-index:", (0, $014x6.akEditorUnitZIndex) * 99, ";&.active .", (0, $YREXK.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{background-color:var(--ds-border-selected, #1868DB);width:10px;height:10px;border-width:2px;border-radius:4px;top:3px;left:2px;}&:hover{cursor:pointer;.", (0, $YREXK.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{width:10px;height:10px;border-radius:4px;top:3px;left:2px;}}}.", (0, $YREXK.TableCssClassName).DRAG_CORNER_BUTTON_INNER, "{border:1px solid var(--ds-border-inverse, #FFFFFF);background-color:var(--ds-background-accent-gray-subtler, #DDDEE1);border-radius:2px;width:5px;height:5px;position:relative;}");
const $8df155aefe493bad$export$d9daf73b486785b9 = ()=>/*#__PURE__*/ (0, $jctmk.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8df155aefe493bad$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8df155aefe493bad$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8df155aefe493bad$var$InsertLine(`
    width: 2px;
    left: 9px;
  `));
const $8df155aefe493bad$export$595c9c01d7c39885 = ()=>/*#__PURE__*/ (0, $jctmk.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8df155aefe493bad$var$InsertButton(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8df155aefe493bad$var$InsertButtonHover(), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $8df155aefe493bad$var$InsertLine(`
    height: 2px;
    top: -11px;
	${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
    left: ${(0, $4Tw3G.tableInsertColumnButtonSize) - 1}px;
  `));
const $8df155aefe493bad$export$6114ba9f95ca48dc = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type td,.", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).WITH_CONTROLS, " table tr:first-of-type th{position:relative;}");
const $8df155aefe493bad$export$d6f68d0fe29f8050 = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, ",.", (0, $YREXK.TableCssClassName).CONTROLS_DELETE_BUTTON, "{height:", (0, $4Tw3G.tableDeleteButtonSize), "px;width:", (0, $4Tw3G.tableDeleteButtonSize), "px;}.", (0, $YREXK.TableCssClassName).CONTROLS_DELETE_BUTTON_WRAP, "{.", (0, $YREXK.TableCssClassName).CONTROLS_DELETE_BUTTON, "{", $8df155aefe493bad$var$Button(`
        background: ${(0, $4Tw3G.tableCellSelectedDeleteIconBackground)};
        color: ${(0, $4Tw3G.tableCellSelectedDeleteIconColor)};
      `), ";}}.", (0, $YREXK.TableCssClassName).CONTROLS_DELETE_BUTTON, ":hover{background:", (0, $4Tw3G.tableCellHoverDeleteIconBackground), ";color:", (0, $4Tw3G.tableCellHoverDeleteIconColor), ";cursor:pointer;}");
const $8df155aefe493bad$var$columnHeaderButton = (cssString)=>{
    return /*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: (0, $4Tw3G.tableHeaderCellBackgroundColor),
        display: 'block',
        boxSizing: 'border-box',
        padding: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        ':focus': {
            outline: 'none'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cssString);
};
const $8df155aefe493bad$var$columnHeaderButtonSelected = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        color: "var(--ds-text-inverse, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $4Tw3G.tableToolbarSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderColor: (0, $4Tw3G.tableBorderSelectedColor),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $4Tw3G.columnControlsSelectedZIndex)
    });
const $8df155aefe493bad$var$getFloatingDotOverrides = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)("tr th:last-child .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before,tr td:last-child .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::before{content:'';background-color:", (0, $4Tw3G.tableBorderColor), ";position:absolute;height:", (0, $4Tw3G.lineMarkerSize), "px;width:", (0, $4Tw3G.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:var(--ds-space-025, 2px);right:0px;}");
};
const $8df155aefe493bad$export$125caa90718a4ea9 = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).DRAG_COLUMN_DROP_TARGET_CONTROLS, "{box-sizing:border-box;position:absolute;top:0;.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:flex;flex-direction:row;}}.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS, "{box-sizing:border-box;.", (0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS_INNER, "{display:grid;justify-items:center;}}");
};
const $8df155aefe493bad$export$a2258906ae78ec82 = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)("div.", (0, $YREXK.TableCssClassName).WITH_CONTROLS, ">.", (0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS_WRAPPER, "::after{display:none;}div.", (0, $YREXK.TableCssClassName).WITH_CONTROLS, ">.", (0, $YREXK.TableCssClassName).ROW_CONTROLS_WRAPPER, "::after{content:' ';background-color:", (0, $4Tw3G.tableBorderColor), ";position:absolute;height:", (0, $4Tw3G.lineMarkerSize), "px;width:", (0, $4Tw3G.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:-", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px;right:-1px;}");
};
const $8df155aefe493bad$export$8c8180e74f25db6a = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:none;cursor:pointer;position:absolute;width:100%;left:0;top:-", (0, $4Tw3G.columnControlsDecorationHeight) + (0, $jd8X7.tableCellBorderWidth), "px;height:", (0, $4Tw3G.columnControlsDecorationHeight), "px;&::before{content:' ';background-color:", (0, $4Tw3G.tableBorderColor), ";position:absolute;height:", (0, $4Tw3G.lineMarkerSize), "px;width:", (0, $4Tw3G.lineMarkerSize), "px;border-radius:50%;pointer-events:none;top:2px;right:var(--ds-space-negative-025, -2px);}&::after{content:' ';", $8df155aefe493bad$var$columnHeaderButton(`
        border-right: ${(0, $jd8X7.tableCellBorderWidth)}px solid ${(0, $4Tw3G.tableBorderColor)};
        border-top: ${(0, $jd8X7.tableCellBorderWidth)}px solid ${(0, $4Tw3G.tableBorderColor)};
        border-bottom: ${(0, $jd8X7.tableCellBorderWidth)}px solid ${(0, $4Tw3G.tableBorderColor)};
        box-sizing: content-box;
        height: ${(0, $4Tw3G.tableToolbarSize) - 1}px;
        width: 100%;
        position: absolute;
        top: ${(0, $4Tw3G.columnControlsDecorationHeight) - (0, $4Tw3G.tableToolbarSize)}px;
        left: 0px;
        z-index: ${(0, $4Tw3G.columnControlsZIndex)};
      `), ";}}", $8df155aefe493bad$var$getFloatingDotOverrides(), " .", (0, $YREXK.TableCssClassName).WITH_CONTROLS, " .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "{display:block;}table tr:first-of-type td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $YREXK.TableCssClassName).HOVERED_TABLE, "{.", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $8df155aefe493bad$var$columnHeaderButtonSelected(), ";}&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $4Tw3G.tableToolbarDeleteColor), ";border-color:", (0, $4Tw3G.tableBorderDeleteColor), ";z-index:", (0, $a9lM0.getTableZIndexes)().dangerOverlay, ";}}}table tr:first-of-type td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, ",&.", (0, $YREXK.TableCssClassName).HOVERED_COLUMN, "{.", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $8df155aefe493bad$var$columnHeaderButtonSelected(), ";border-left:", (0, $jd8X7.tableCellBorderWidth), "px solid ", (0, $4Tw3G.tableBorderSelectedColor), ";left:-", (0, $jd8X7.tableCellBorderWidth), "px;}}}table tr:first-of-type td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ",table tr:first-of-type th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "{&.", (0, $YREXK.TableCssClassName).HOVERED_COLUMN, "{.", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $8df155aefe493bad$var$columnHeaderButtonSelected(), ";}&.", (0, $YREXK.TableCssClassName).HOVERED_CELL_IN_DANGER, " .", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{background-color:", (0, $4Tw3G.tableToolbarDeleteColor), ";border-color:", (0, $4Tw3G.tableBorderDeleteColor), ";border-left:", (0, $jd8X7.tableCellBorderWidth), "px solid ", (0, $4Tw3G.tableBorderDeleteColor), ";left:-", (0, $jd8X7.tableCellBorderWidth), "px;z-index:", (0, $a9lM0.getTableZIndexes)().dangerOverlay, ";}}}.", (0, $YREXK.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type td.", (0, $YREXK.TableCssClassName).TABLE_CELL, ",.", (0, $YREXK.TableCssClassName).TABLE_SELECTED, " table tr:first-of-type th.", (0, $YREXK.TableCssClassName).TABLE_HEADER_CELL, "{.", (0, $YREXK.TableCssClassName).COLUMN_CONTROLS_DECORATIONS, "::after{", $8df155aefe493bad$var$columnHeaderButtonSelected(), ";}}");
};
const $8df155aefe493bad$export$4d63bf225990ad34 = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ".", (0, $YREXK.TableCssClassName).HOVERED_DELETE_BUTTON, "{.", (0, $YREXK.TableCssClassName).SELECTED_CELL, ",.", (0, $YREXK.TableCssClassName).COLUMN_SELECTED, ",.", (0, $YREXK.TableCssClassName).HOVERED_CELL, "{", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $4Tw3G.tableBorderDeleteColor};`, ";}.", (0, $YREXK.TableCssClassName).SELECTED_CELL, "::after{background:", (0, $4Tw3G.tableCellDeleteColor), ";}.", (0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER, ">table{td.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $4Tw3G.tableCellDeleteColor), ";border:1px solid ", (0, $4Tw3G.tableBorderDeleteColor), ";}th.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{background-color:unset;}th.", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, "::after{background:", (0, $4Tw3G.tableCellDeleteColor), ";border:1px solid ", (0, $4Tw3G.tableBorderDeleteColor), ";}}}");
const $8df155aefe493bad$export$1c46f5412a5a3ae0 = ()=>/*#__PURE__*/ (0, $jctmk.css)(":not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $YREXK.TableCssClassName).HOVERED_DELETE_BUTTON, "){.", (0, $YREXK.TableCssClassName).HOVERED_CELL, "{position:relative;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $4Tw3G.tableBorderSelectedColor};`, ";}.", (0, $YREXK.TableCssClassName).HOVERED_CELL, ".", (0, $YREXK.TableCssClassName).HOVERED_NO_HIGHLIGHT, "{position:relative;", (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? '' /* Cell borders handled by ::after overlay in rounded mode. */  : `border: 1px solid ${0, $4Tw3G.tableBorderColor};`, ";}}");
const $8df155aefe493bad$export$40edb32b62e4fb85 = /*#__PURE__*/ (0, $jctmk.css)(":not(.", (0, $YREXK.TableCssClassName).IS_RESIZING, ") .", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, ":not(.", (0, $YREXK.TableCssClassName).HOVERED_DELETE_BUTTON, "){td.", (0, $YREXK.TableCssClassName).HOVERED_CELL_WARNING, "{background-color:var(--ds-background-warning, #FFF5DB)!important;border:1px solid var(--ds-border-warning, #E06C00);}}");
// Explicit pixel values required here to ensure correct positioning and sizes of column resize handle
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $8df155aefe493bad$var$resizeLineStyles = ()=>{
    return /*#__PURE__*/ (0, $jctmk.css)("th.", (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before,td.", (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $4Tw3G.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $4Tw3G.tableBorderSelectedColor), ";z-index:", (0, $4Tw3G.columnControlsZIndex) * 2, ";}th.", (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before,td.", (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $4Tw3G.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $4Tw3G.tableBorderSelectedColor), ";z-index:", (0, $4Tw3G.columnControlsZIndex) * 2, ";}td.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';position:absolute;left:var(--ds-space-negative-025, -2px);top:-1px;width:", (0, $4Tw3G.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $4Tw3G.tableBorderSelectedColor), ";z-index:", (0, $4Tw3G.columnControlsZIndex) * 2, ";}th.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, "::before{content:' ';left:var(--ds-space-negative-025, -2px);position:absolute;width:", (0, $4Tw3G.resizeLineWidth), "px;height:calc(100% + ", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px);background-color:", (0, $4Tw3G.tableBorderSelectedColor), ";z-index:", (0, $4Tw3G.columnControlsZIndex) * 2, ";top:-", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px;}td.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';position:absolute;right:-1px;top:-1px;width:", (0, $4Tw3G.resizeLineWidth), "px;height:calc(100% + 2px);background-color:", (0, $4Tw3G.tableBorderSelectedColor), ";z-index:", (0, $4Tw3G.columnControlsZIndex) * 2, ";}th.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE_LAST_COLUMN, "::before{content:' ';right:-1px;position:absolute;width:", (0, $4Tw3G.resizeLineWidth), "px;height:calc(100% + ", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px);background-color:", (0, $4Tw3G.tableBorderSelectedColor), ";z-index:", (0, $4Tw3G.columnControlsZIndex) * 2, ";top:-", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px;}");
};
const $8df155aefe493bad$export$8e36b812ea421d73 = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "{.", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $4Tw3G.resizeHandlerAreaWidth), "px;height:100%;top:0;right:-", (0, $4Tw3G.resizeHandlerAreaWidth) / 2, "px;cursor:col-resize;z-index:", (0, $a9lM0.getTableZIndexes)().resizeHandle, ";}tr th:last-child .", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, ",tr td:last-child .", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "{background-color:transparent;position:absolute;width:", (0, $4Tw3G.resizeHandlerAreaWidth) / 2, "px;height:100%;top:0;right:0;cursor:col-resize;z-index:", (0, $a9lM0.getTableZIndexes)().resizeHandle, ";}", $8df155aefe493bad$var$resizeLineStyles(), " table tr:first-of-type th.", (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $YREXK.TableCssClassName).WITH_DRAG_RESIZE_LINE, " .", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type th.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after,table tr:first-of-type td.", (0, $YREXK.TableCssClassName).WITH_RESIZE_LINE, " .", (0, $YREXK.TableCssClassName).RESIZE_HANDLE_DECORATION, "::after{top:-", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px;height:calc(100% + ", (0, $4Tw3G.tableToolbarSize) + (0, $jd8X7.tableCellBorderWidth), "px);}}");
// Drag and Drop: drop target insert line
const $8df155aefe493bad$var$tableCellColumnInsertLineStyles = /*#__PURE__*/ (0, $jctmk.css)({
    content: "' '",
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `calc(100% + ${(0, $jd8X7.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $4Tw3G.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $4Tw3G.columnControlsZIndex) * 2
});
const $8df155aefe493bad$var$tableCellRowInsertLineStyles = /*#__PURE__*/ (0, $jctmk.css)({
    content: "' '",
    position: 'absolute',
    left: "var(--ds-space-negative-025, -2px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: `${(0, $4Tw3G.insertLineWidth)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(100% + ${(0, $jd8X7.tableCellBorderWidth) * 2}px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $4Tw3G.columnControlsZIndex) * 2
});
const $8df155aefe493bad$var$insertLineActiveColor = /*#__PURE__*/ (0, $jctmk.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: (0, $4Tw3G.tableBorderSelectedColor)
});
const $8df155aefe493bad$var$insertLineInactiveColor = {
    name: "5t20g5",
    styles: "background-color:var(--ds-background-accent-gray-subtler, #DDDEE1)"
};
const $8df155aefe493bad$export$b9932a52fb1c7aad = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).TABLE_CONTAINER, "{td.", (0, $YREXK.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $8df155aefe493bad$var$insertLineActiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:-1px;top:-1px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $jd8X7.tableCellBorderWidth), "px;", $8df155aefe493bad$var$insertLineActiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_FIRST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:-1px;top:-", (0, $jd8X7.tableCellBorderWidth), "px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $8df155aefe493bad$var$insertLineActiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-1px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_COLUMN_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $jd8X7.tableCellBorderWidth), "px;", $8df155aefe493bad$var$insertLineActiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_COLUMN_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " left:var(--ds-space-negative-025, -2px);top:-", (0, $jd8X7.tableCellBorderWidth), "px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $8df155aefe493bad$var$insertLineActiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " right:-1px;top:-1px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $jd8X7.tableCellBorderWidth), "px;", $8df155aefe493bad$var$insertLineActiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_LAST_COLUMN_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellColumnInsertLineStyles, " right:-1px;top:-", (0, $jd8X7.tableCellBorderWidth), "px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " top:-1px;", $8df155aefe493bad$var$insertLineActiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " top:-1px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_ROW_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " top:-1px;", $8df155aefe493bad$var$insertLineActiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_ROW_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " top:-1px;", $8df155aefe493bad$var$insertLineInactiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " bottom:0;", $8df155aefe493bad$var$insertLineActiveColor, ";}td.", (0, $YREXK.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " bottom:0;", $8df155aefe493bad$var$insertLineInactiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_LAST_ROW_INSERT_LINE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " bottom:0;", $8df155aefe493bad$var$insertLineActiveColor, ";}th.", (0, $YREXK.TableCssClassName).WITH_LAST_ROW_INSERT_LINE_INACTIVE, "::before{", $8df155aefe493bad$var$tableCellRowInsertLineStyles, " bottom:0;", $8df155aefe493bad$var$insertLineInactiveColor, ";}}");

});



parcelRegister("ektGI", function(module, exports) {
$parcel$export(module.exports, "tableFloatingCellButtonStyles", () => $130966407e9ca83f$export$554a9cb1559eb2d5);
$parcel$export(module.exports, "tableFloatingCellButtonSelectedStyles", () => $130966407e9ca83f$export$cd6af2ca27c1a823);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $4Tw3G = parcelRequire("4Tw3G");
function $130966407e9ca83f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Excludes the inlined top-layer tooltip popover from the background box selector so it isn't squished.
const $130966407e9ca83f$var$topLayerTooltipCellButtonStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> div:not([popover])': {
            // Sits behind button to provide surface-color background
            background: "var(--ds-surface, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            borderRadius: (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "var(--ds-radius-small, 4px)" : "var(--ds-radius-small, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $4Tw3G.contextualMenuTriggerSize) + 2}px`,
            width: "var(--ds-space-250, 20px)",
            flexDirection: 'column'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, #0515240F)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${"var(--ds-surface, #FFFFFF)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            borderRadius: (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "var(--ds-radius-xsmall, 2px)" : '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
const $130966407e9ca83f$var$legacyCellButtonStyles = ()=>/*#__PURE__*/ (0, $jctmk.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // Sits behind button to provide surface-color background
            background: "var(--ds-surface, #FFFFFF)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            borderRadius: (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "var(--ds-radius-small, 4px)" : "var(--ds-radius-small, 3px)",
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${(0, $4Tw3G.contextualMenuTriggerSize) + 2}px`,
            width: "var(--ds-space-250, 20px)",
            flexDirection: 'column'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button': {
            background: "var(--ds-background-neutral, #0515240F)",
            flexDirection: 'column',
            margin: "var(--ds-space-025, 2px)",
            outline: `2px solid ${"var(--ds-surface, #FFFFFF)"}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            borderRadius: (0, $aEmSo.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? "var(--ds-radius-xsmall, 2px)" : '1px',
            padding: 0,
            height: 'calc(100% - 4px)',
            display: 'flex'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:hover': {
            background: "var(--ds-background-neutral-hovered, #0B120E24)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button:active': {
            background: "var(--ds-background-neutral-pressed, #080F214A)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& button > span': {
            margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&& span': {
            pointerEvents: 'none'
        }
    });
const $130966407e9ca83f$export$554a9cb1559eb2d5 = ()=>(0, $dRkX9.fg)('platform-dst-top-layer-tooltip') ? $130966407e9ca83f$var$topLayerTooltipCellButtonStyles() : $130966407e9ca83f$var$legacyCellButtonStyles();
var $130966407e9ca83f$var$_ref = {
    name: "lb8dok",
    styles: "&& button{background:var(--ds-background-selected, #E9F2FE);}&& button:hover{background:var(--ds-background-selected-hovered, #CFE1FD);}&& button:active{background:var(--ds-background-selected-pressed, #8FB8F6);}"
};
const $130966407e9ca83f$export$cd6af2ca27c1a823 = ()=>$130966407e9ca83f$var$_ref;

});


parcelRegister("7bj8F", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9ab4e133ecc7dd1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $dXHAJ = parcelRequire("dXHAJ");

var $9oAqi = parcelRequire("9oAqi");

var $a4TQr = parcelRequire("a4TQr");

var $014x6 = parcelRequire("014x6");

var $elHd5 = parcelRequire("elHd5");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");

var $aEmSo = parcelRequire("aEmSo");

var $4GJqd = parcelRequire("4GJqd");

var $4Tw3G = parcelRequire("4Tw3G");

var $lXYce = parcelRequire("lXYce");

var $c6wu6 = parcelRequire("c6wu6");

var $oaovf = parcelRequire("oaovf");
const $a9ab4e133ecc7dd1$var$FloatingContextualMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, pluginConfig: pluginConfig, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor, api: api, isDragMenuOpen: isDragMenuOpen })=>{
    const { activeTableMenu: activeTableMenu } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            activeTableMenu: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.activeTableMenu
        };
    });
    const isCellMenuOpen = (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) ? (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'cell' : isOpen;
    if (!editorView) return null;
    // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
    const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(editorView.state);
    if (!isCellMenuOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const { selection: selection } = editorView.state;
    const selectionRect = (0, $2HFfw.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);
    if (!selectionRect) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    const targetCellRef = (0, $a4TQr.findDomRefAtPos)(targetCellPosition, domAtPos);
    if (!targetCellRef) return null;
    const parentSticky = targetCellRef.parentElement && targetCellRef.parentElement.className.indexOf('sticky') > -1;
    if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
        if (!(targetCellRef instanceof HTMLElement)) return null;
        return /*#__PURE__*/ (0, $jctmk.jsx)((0, $lXYce.CellMenuPopup), {
            api: api,
            boundariesElement: boundariesElement,
            editorView: editorView,
            mountPoint: mountPoint,
            scrollableElement: scrollableElement,
            target: targetCellRef,
            zIndex: parentSticky ? (0, $014x6.akEditorFloatingDialogZIndex) : (0, $014x6.akEditorFloatingOverlapPanelZIndex)
        });
    }
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $dXHAJ.default), {
        alignX: "right",
        alignY: "top",
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetCellRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $4Tw3G.tablePopupMenuFitHeight),
        fitWidth: (0, $4Tw3G.contextualMenuDropdownWidthDnD),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        zIndex: parentSticky ? (0, $014x6.akEditorFloatingDialogZIndex) : (0, $014x6.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            -7,
            0
        ],
        stick: true
    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
        css: (0, $oaovf.tablePopupStyles)()
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $c6wu6.default), {
        editorView: editorView,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            (0, $4Tw3G.contextualMenuTriggerSize) / 2,
            -(0, $4Tw3G.contextualMenuTriggerSize)
        ],
        isOpen: isOpen,
        targetCellPosition: targetCellPosition,
        allowColumnSorting: pluginConfig && pluginConfig.allowColumnSorting,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowMergeCells: pluginConfig.allowMergeCells,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        allowBackgroundColor: pluginConfig.allowBackgroundColor,
        selectionRect: selectionRect,
        mountPoint: mountPoint,
        boundariesElement: boundariesElement,
        editorAnalyticsAPI: editorAnalyticsAPI,
        getEditorContainerWidth: getEditorContainerWidth,
        getEditorFeatureFlags: getEditorFeatureFlags,
        isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard,
        isCommentEditor: isCommentEditor,
        api: api,
        isDragMenuOpen: isDragMenuOpen
    })));
};
$a9ab4e133ecc7dd1$var$FloatingContextualMenu.displayName = 'FloatingContextualMenu';
var $a9ab4e133ecc7dd1$export$2e2bcd8739ae039 = $a9ab4e133ecc7dd1$var$FloatingContextualMenu;

});
parcelRegister("lXYce", function(module, exports) {
$parcel$export(module.exports, "CellMenuPopup", () => $ae6a486914041ba2$export$28b7d8193cac27fc);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dXHAJ = parcelRequire("dXHAJ");

var $dogcz = parcelRequire("dogcz");

var $8F4kC = parcelRequire("8F4kC");

var $6ySyj = parcelRequire("6ySyj");

var $gzpzh = parcelRequire("gzpzh");
var $8L6TV = parcelRequire("8L6TV");

var $4GJqd = parcelRequire("4GJqd");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $9VL3d = parcelRequire("9VL3d");

var $hkEC0 = parcelRequire("hkEC0");

var $e3ijL = parcelRequire("e3ijL");
const $ae6a486914041ba2$var$PopupWithListeners = (0, $8F4kC.default)((0, $dXHAJ.default));
const $ae6a486914041ba2$var$NESTED_DROPDOWN_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
const $ae6a486914041ba2$var$CELL_MENU_TRIGGER_SELECTOR = `.${(0, $YREXK.TableCssClassName).CONTEXTUAL_MENU_BUTTON}`;
const $ae6a486914041ba2$var$CELL_MENU_TRIGGER_CLEARANCE = [
    6,
    0
];
const $ae6a486914041ba2$export$28b7d8193cac27fc = ({ api: api, boundariesElement: boundariesElement, editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, target: target, zIndex: zIndex })=>{
    const popupContentRef = (0, $fc4bM.useRef)(null);
    const setOutsideClickTargetRef = (0, $fc4bM.useContext)((0, $dogcz.OutsideClickTargetRefContext));
    const handlePopupRef = (0, $fc4bM.useCallback)((el)=>{
        popupContentRef.current = el;
        setOutsideClickTargetRef === null || setOutsideClickTargetRef === void 0 || setOutsideClickTargetRef(el);
    }, [
        setOutsideClickTargetRef
    ]);
    const closeCellMenu = (0, $fc4bM.useCallback)(()=>{
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = (0, $4GJqd.getPluginState)(editorView.state);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        if (isCellMenuOpenByKeyboard) (0, $8L6TV.setFocusToCellMenu)(false)(editorView.state, editorView.dispatch);
    }, [
        api,
        editorView
    ]);
    const isEventInsideCellMenu = (0, $fc4bM.useCallback)((event)=>{
        var _popupContentRef$curr;
        const target = event.target;
        if (!(target instanceof Node)) return false;
        if ((_popupContentRef$curr = popupContentRef.current) !== null && _popupContentRef$curr !== void 0 && _popupContentRef$curr.contains(target)) return true;
        return target instanceof Element && Boolean(target.closest($ae6a486914041ba2$var$NESTED_DROPDOWN_SELECTOR) || target.closest($ae6a486914041ba2$var$CELL_MENU_TRIGGER_SELECTOR));
    }, []);
    const horizontalPlacementRef = (0, $fc4bM.useRef)(undefined);
    const handlePlacementChanged = (0, $fc4bM.useCallback)(([, horizontalPlacement])=>{
        horizontalPlacementRef.current = horizontalPlacement;
    }, []);
    const handlePositionCalculated = (0, $fc4bM.useCallback)((position)=>{
        if (horizontalPlacementRef.current !== 'left' || position.left === undefined) return position;
        return {
            ...position,
            left: position.left + target.getBoundingClientRect().width
        };
    }, [
        target
    ]);
    const handleCellMenuClickOutside = (0, $fc4bM.useCallback)((event)=>{
        var _api$table;
        if (isEventInsideCellMenu(event)) return;
        // Another table menu (e.g. a row/column drag menu) may have just been opened by this same
        // click. Its React handler runs before this document listener, so the active menu is no
        // longer 'cell' — don't clobber the newly opened menu back to 'none'.
        const activeTableMenu = api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 || (_api$table = _api$table.sharedState.currentState()) === null || _api$table === void 0 ? void 0 : _api$table.activeTableMenu;
        if ((activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) !== 'cell') return;
        closeCellMenu();
    }, [
        api,
        closeCellMenu,
        isEventInsideCellMenu
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)($ae6a486914041ba2$var$PopupWithListeners, {
        alignX: "end",
        alignY: "start",
        target: target,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitHeight: (0, $4Tw3G.tablePopupMenuFitHeight),
        fitWidth: (0, $hkEC0.TABLE_MENU_WIDTH),
        zIndex: zIndex,
        forcePlacement: true,
        preventOverflow: true,
        onPlacementChanged: handlePlacementChanged,
        onPositionCalculated: handlePositionCalculated,
        offset: $ae6a486914041ba2$var$CELL_MENU_TRIGGER_CLEARANCE,
        stick: true,
        handleClickOutside: handleCellMenuClickOutside,
        handleEscapeKeydown: closeCellMenu,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            ref: handlePopupRef,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $6ySyj.UserIntentPopupWrapper), {
                api: api,
                userIntent: "tableContextualMenuPopupOpen",
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e3ijL.TableMenu), {
                    api: api,
                    editorView: editorView,
                    surface: (0, $9VL3d.CELL_MENU)
                })
            })
        })
    });
};

});
parcelRegister("9VL3d", function(module, exports) {
$parcel$export(module.exports, "CELL_MENU", () => $13ea7e9bc41e224e$export$190f9a1b925620da);
$parcel$export(module.exports, "CELL_ACTION_SECTION", () => $13ea7e9bc41e224e$export$51b56b1bf623d0f);
$parcel$export(module.exports, "CELL_ADD_SECTION", () => $13ea7e9bc41e224e$export$263b4b5ce540189d);
$parcel$export(module.exports, "CELL_DANGER_SECTION", () => $13ea7e9bc41e224e$export$ae771163ae415c91);
$parcel$export(module.exports, "CELL_MENU_RANK", () => $13ea7e9bc41e224e$export$8770b59bbf22f751);
$parcel$export(module.exports, "MERGE_CELLS_ITEM", () => $13ea7e9bc41e224e$export$b58e7f7cb85261bb);
$parcel$export(module.exports, "SPLIT_CELL_ITEM", () => $13ea7e9bc41e224e$export$4a4b751aa9083b35);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU", () => $13ea7e9bc41e224e$export$b015955eb6c647e8);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU_SECTION", () => $13ea7e9bc41e224e$export$2ee0b7de1ba81016);
$parcel$export(module.exports, "VERTICAL_ALIGN_TOP_ITEM", () => $13ea7e9bc41e224e$export$4aeebd1c4003f0d1);
$parcel$export(module.exports, "VERTICAL_ALIGN_MIDDLE_ITEM", () => $13ea7e9bc41e224e$export$fdb9421b7fa72aa6);
$parcel$export(module.exports, "VERTICAL_ALIGN_BOTTOM_ITEM", () => $13ea7e9bc41e224e$export$3348ad90bdbb18b);
$parcel$export(module.exports, "CELL_ACTION_SECTION_RANK", () => $13ea7e9bc41e224e$export$1d60acb37b4923d4);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU_RANK", () => $13ea7e9bc41e224e$export$3094a3221df5ea5d);
$parcel$export(module.exports, "VERTICAL_ALIGN_MENU_SECTION_RANK", () => $13ea7e9bc41e224e$export$9767915495221593);
$parcel$export(module.exports, "CELL_ADD_SECTION_RANK", () => $13ea7e9bc41e224e$export$75f616c8c0c24cae);
$parcel$export(module.exports, "CELL_DANGER_SECTION_RANK", () => $13ea7e9bc41e224e$export$75f3bad3b50a6fc9);

var $2NTcm = parcelRequire("2NTcm");

var $izzuA = parcelRequire("izzuA");

var $0117J = parcelRequire("0117J");
const $13ea7e9bc41e224e$export$190f9a1b925620da = {
    type: 'menu',
    key: 'cell-contextual-menu'
};
const $13ea7e9bc41e224e$export$51b56b1bf623d0f = {
    type: 'menu-section',
    key: 'cell-action-section'
};
const $13ea7e9bc41e224e$export$263b4b5ce540189d = {
    type: 'menu-section',
    key: 'cell-add-section'
};
const $13ea7e9bc41e224e$export$ae771163ae415c91 = {
    type: 'menu-section',
    key: 'cell-danger-section'
};
const $13ea7e9bc41e224e$export$8770b59bbf22f751 = {
    [$13ea7e9bc41e224e$export$51b56b1bf623d0f.key]: 100,
    [$13ea7e9bc41e224e$export$263b4b5ce540189d.key]: 200,
    [$13ea7e9bc41e224e$export$ae771163ae415c91.key]: 300
};
const $13ea7e9bc41e224e$export$b58e7f7cb85261bb = {
    type: 'menu-item',
    key: 'merge-cells'
};
const $13ea7e9bc41e224e$export$4a4b751aa9083b35 = {
    type: 'menu-item',
    key: 'split-cell'
};
const $13ea7e9bc41e224e$export$b015955eb6c647e8 = {
    type: 'nested-menu',
    key: 'vertical-align'
};
const $13ea7e9bc41e224e$export$2ee0b7de1ba81016 = {
    type: 'menu-section',
    key: 'vertical-align-section'
};
const $13ea7e9bc41e224e$export$4aeebd1c4003f0d1 = {
    type: 'menu-item',
    key: 'vertical-align-top'
};
const $13ea7e9bc41e224e$export$fdb9421b7fa72aa6 = {
    type: 'menu-item',
    key: 'vertical-align-middle'
};
const $13ea7e9bc41e224e$export$3348ad90bdbb18b = {
    type: 'menu-item',
    key: 'vertical-align-bottom'
};
const $13ea7e9bc41e224e$export$1d60acb37b4923d4 = {
    [(0, $0117J.BACKGROUND_COLOR_ITEM).key]: 100,
    [$13ea7e9bc41e224e$export$b015955eb6c647e8.key]: 200,
    [$13ea7e9bc41e224e$export$b58e7f7cb85261bb.key]: 300,
    [$13ea7e9bc41e224e$export$4a4b751aa9083b35.key]: 400
};
const $13ea7e9bc41e224e$export$3094a3221df5ea5d = {
    [$13ea7e9bc41e224e$export$2ee0b7de1ba81016.key]: 100
};
const $13ea7e9bc41e224e$export$9767915495221593 = {
    [$13ea7e9bc41e224e$export$4aeebd1c4003f0d1.key]: 100,
    [$13ea7e9bc41e224e$export$fdb9421b7fa72aa6.key]: 200,
    [$13ea7e9bc41e224e$export$3348ad90bdbb18b.key]: 300
};
const $13ea7e9bc41e224e$export$75f616c8c0c24cae = {
    [$13ea7e9bc41e224e$export$b58e7f7cb85261bb.key]: 100,
    [$13ea7e9bc41e224e$export$4a4b751aa9083b35.key]: 200,
    [(0, $2NTcm.ADD_COLUMN_RIGHT_ITEM).key]: 300,
    [(0, $izzuA.ADD_ROW_BELOW_ITEM).key]: 400,
    [(0, $2NTcm.DISTRIBUTE_COLUMNS_ITEM).key]: 500
};
const $13ea7e9bc41e224e$export$75f3bad3b50a6fc9 = {
    [(0, $0117J.CLEAR_CELLS_ITEM).key]: 100,
    [(0, $2NTcm.DELETE_COLUMN_ITEM).key]: 200,
    [(0, $izzuA.DELETE_ROW_ITEM).key]: 300
};

});
parcelRegister("2NTcm", function(module, exports) {
$parcel$export(module.exports, "COLUMN_MENU", () => $7810c254d3b86dd2$export$f8a6b1c18fca6bfa);
$parcel$export(module.exports, "COLUMN_TOGGLE_SECTION", () => $7810c254d3b86dd2$export$868359cdd46b8e96);
$parcel$export(module.exports, "COLUMN_BACKGROUND_SECTION", () => $7810c254d3b86dd2$export$b9f73083561c9b45);
$parcel$export(module.exports, "COLUMN_SORT_SECTION", () => $7810c254d3b86dd2$export$d76bf3eb1cb3622e);
$parcel$export(module.exports, "COLUMN_ADD_SECTION", () => $7810c254d3b86dd2$export$10cac5e3b97c49c5);
$parcel$export(module.exports, "COLUMN_DANGER_SECTION", () => $7810c254d3b86dd2$export$139af6cfa83a6c0c);
$parcel$export(module.exports, "COLUMN_SECTION_RANK", () => $7810c254d3b86dd2$export$d6f0842ac421fece);
$parcel$export(module.exports, "HEADER_COLUMN_TOGGLE_ITEM", () => $7810c254d3b86dd2$export$70437eab3a41306c);
$parcel$export(module.exports, "SORT_INCREASING_ITEM", () => $7810c254d3b86dd2$export$53f931b253816d5f);
$parcel$export(module.exports, "SORT_DECREASING_ITEM", () => $7810c254d3b86dd2$export$bd9506c8b0be373c);
$parcel$export(module.exports, "ADD_COLUMN_LEFT_ITEM", () => $7810c254d3b86dd2$export$313a331094e8e40);
$parcel$export(module.exports, "ADD_COLUMN_RIGHT_ITEM", () => $7810c254d3b86dd2$export$369288a3adc8cde7);
$parcel$export(module.exports, "MOVE_COLUMN_LEFT_ITEM", () => $7810c254d3b86dd2$export$e5b0244351372e94);
$parcel$export(module.exports, "MOVE_COLUMN_RIGHT_ITEM", () => $7810c254d3b86dd2$export$49af2aec08b8ed97);
$parcel$export(module.exports, "DISTRIBUTE_COLUMNS_ITEM", () => $7810c254d3b86dd2$export$82d2c16b28fc2c87);
$parcel$export(module.exports, "DELETE_COLUMN_ITEM", () => $7810c254d3b86dd2$export$4d0f5768433488cd);
$parcel$export(module.exports, "COLUMN_TOGGLE_SECTION_RANK", () => $7810c254d3b86dd2$export$55d9aafd67ce68f);
$parcel$export(module.exports, "COLUMN_BACKGROUND_SECTION_RANK", () => $7810c254d3b86dd2$export$bc1c17ea404e1e65);
$parcel$export(module.exports, "COLUMN_SORT_SECTION_RANK", () => $7810c254d3b86dd2$export$dc7b7fa82abf029);
$parcel$export(module.exports, "COLUMN_ADD_SECTION_RANK", () => $7810c254d3b86dd2$export$16082c766842f755);
$parcel$export(module.exports, "COLUMN_DANGER_SECTION_RANK", () => $7810c254d3b86dd2$export$7549083293c6b325);

var $0117J = parcelRequire("0117J");
const $7810c254d3b86dd2$export$f8a6b1c18fca6bfa = {
    type: 'menu',
    key: 'column-handle-menu'
};
const $7810c254d3b86dd2$export$868359cdd46b8e96 = {
    type: 'menu-section',
    key: 'column-toggle-section'
};
const $7810c254d3b86dd2$export$b9f73083561c9b45 = {
    type: 'menu-section',
    key: 'column-background-section'
};
const $7810c254d3b86dd2$export$d76bf3eb1cb3622e = {
    type: 'menu-section',
    key: 'column-sort-section'
};
const $7810c254d3b86dd2$export$10cac5e3b97c49c5 = {
    type: 'menu-section',
    key: 'column-add-section'
};
const $7810c254d3b86dd2$export$139af6cfa83a6c0c = {
    type: 'menu-section',
    key: 'column-danger-section'
};
const $7810c254d3b86dd2$export$d6f0842ac421fece = {
    [$7810c254d3b86dd2$export$868359cdd46b8e96.key]: 100,
    [$7810c254d3b86dd2$export$b9f73083561c9b45.key]: 200,
    [$7810c254d3b86dd2$export$d76bf3eb1cb3622e.key]: 300,
    [$7810c254d3b86dd2$export$10cac5e3b97c49c5.key]: 400,
    [$7810c254d3b86dd2$export$139af6cfa83a6c0c.key]: 500
};
const $7810c254d3b86dd2$export$70437eab3a41306c = {
    type: 'menu-item',
    key: 'header-column-toggle'
};
const $7810c254d3b86dd2$export$53f931b253816d5f = {
    type: 'menu-item',
    key: 'sort-increasing'
};
const $7810c254d3b86dd2$export$bd9506c8b0be373c = {
    type: 'menu-item',
    key: 'sort-decreasing'
};
const $7810c254d3b86dd2$export$313a331094e8e40 = {
    type: 'menu-item',
    key: 'add-column-left'
};
const $7810c254d3b86dd2$export$369288a3adc8cde7 = {
    type: 'menu-item',
    key: 'add-column-right'
};
const $7810c254d3b86dd2$export$e5b0244351372e94 = {
    type: 'menu-item',
    key: 'move-column-left'
};
const $7810c254d3b86dd2$export$49af2aec08b8ed97 = {
    type: 'menu-item',
    key: 'move-column-right'
};
const $7810c254d3b86dd2$export$82d2c16b28fc2c87 = {
    type: 'menu-item',
    key: 'distribute-columns'
};
const $7810c254d3b86dd2$export$4d0f5768433488cd = {
    type: 'menu-item',
    key: 'delete-column'
};
const $7810c254d3b86dd2$export$55d9aafd67ce68f = {
    [$7810c254d3b86dd2$export$70437eab3a41306c.key]: 100
};
const $7810c254d3b86dd2$export$bc1c17ea404e1e65 = {
    [(0, $0117J.BACKGROUND_COLOR_ITEM).key]: 100
};
const $7810c254d3b86dd2$export$dc7b7fa82abf029 = {
    [$7810c254d3b86dd2$export$53f931b253816d5f.key]: 100,
    [$7810c254d3b86dd2$export$bd9506c8b0be373c.key]: 200
};
const $7810c254d3b86dd2$export$16082c766842f755 = {
    [$7810c254d3b86dd2$export$313a331094e8e40.key]: 100,
    [$7810c254d3b86dd2$export$369288a3adc8cde7.key]: 200,
    [$7810c254d3b86dd2$export$e5b0244351372e94.key]: 300,
    [$7810c254d3b86dd2$export$49af2aec08b8ed97.key]: 400,
    [$7810c254d3b86dd2$export$82d2c16b28fc2c87.key]: 500
};
const $7810c254d3b86dd2$export$7549083293c6b325 = {
    [(0, $0117J.CLEAR_CELLS_ITEM).key]: 100,
    [$7810c254d3b86dd2$export$4d0f5768433488cd.key]: 200
};

});
parcelRegister("0117J", function(module, exports) {
$parcel$export(module.exports, "BACKGROUND_COLOR_ITEM", () => $fa3ec6c78502313e$export$200ea9e754d6f884);
$parcel$export(module.exports, "CLEAR_CELLS_ITEM", () => $fa3ec6c78502313e$export$7c71e4184715e790);
const $fa3ec6c78502313e$export$200ea9e754d6f884 = {
    type: 'menu-item',
    key: 'background-color'
};
const $fa3ec6c78502313e$export$7c71e4184715e790 = {
    type: 'menu-item',
    key: 'clear-cells'
};

});


parcelRegister("izzuA", function(module, exports) {
$parcel$export(module.exports, "ROW_MENU", () => $c8d78b973904a1ec$export$335a830a90e5dc34);
$parcel$export(module.exports, "ROW_TOGGLE_SECTION", () => $c8d78b973904a1ec$export$87244e8119d8581c);
$parcel$export(module.exports, "ROW_BACKGROUND_SECTION", () => $c8d78b973904a1ec$export$6f08e5b4d0fb8ff6);
$parcel$export(module.exports, "ROW_ADD_SECTION", () => $c8d78b973904a1ec$export$d478a53ed2abe40f);
$parcel$export(module.exports, "ROW_DANGER_SECTION", () => $c8d78b973904a1ec$export$46ec42cba969242b);
$parcel$export(module.exports, "ROW_MENU_SECTION_RANK", () => $c8d78b973904a1ec$export$9de76c9f0172de51);
$parcel$export(module.exports, "HEADER_ROW_TOGGLE_ITEM", () => $c8d78b973904a1ec$export$f53435d29f0ad0a1);
$parcel$export(module.exports, "NUMBERED_ROWS_TOGGLE_ITEM", () => $c8d78b973904a1ec$export$6b0a072235fdd804);
$parcel$export(module.exports, "ADD_ROW_ABOVE_ITEM", () => $c8d78b973904a1ec$export$e4528482450d5f2e);
$parcel$export(module.exports, "ADD_ROW_BELOW_ITEM", () => $c8d78b973904a1ec$export$c0c87706fa348bc1);
$parcel$export(module.exports, "MOVE_ROW_UP_ITEM", () => $c8d78b973904a1ec$export$6a0b892b38736f32);
$parcel$export(module.exports, "MOVE_ROW_DOWN_ITEM", () => $c8d78b973904a1ec$export$489645ca66afd844);
$parcel$export(module.exports, "DELETE_ROW_ITEM", () => $c8d78b973904a1ec$export$fd74fd566defa85d);
$parcel$export(module.exports, "ROW_TOGGLE_SECTION_RANK", () => $c8d78b973904a1ec$export$d75534200c5cba18);
$parcel$export(module.exports, "ROW_BACKGROUND_SECTION_RANK", () => $c8d78b973904a1ec$export$2476e690f9168fc5);
$parcel$export(module.exports, "ROW_ADD_SECTION_RANK", () => $c8d78b973904a1ec$export$64075ae5fd18cb9c);
$parcel$export(module.exports, "ROW_DANGER_SECTION_RANK", () => $c8d78b973904a1ec$export$5cf4383498669284);

var $0117J = parcelRequire("0117J");
const $c8d78b973904a1ec$export$335a830a90e5dc34 = {
    type: 'menu',
    key: 'row-handle-menu'
};
const $c8d78b973904a1ec$export$87244e8119d8581c = {
    type: 'menu-section',
    key: 'row-toggle-section'
};
const $c8d78b973904a1ec$export$6f08e5b4d0fb8ff6 = {
    type: 'menu-section',
    key: 'row-background-section'
};
const $c8d78b973904a1ec$export$d478a53ed2abe40f = {
    type: 'menu-section',
    key: 'row-add-section'
};
const $c8d78b973904a1ec$export$46ec42cba969242b = {
    type: 'menu-section',
    key: 'row-danger-section'
};
const $c8d78b973904a1ec$export$9de76c9f0172de51 = {
    [$c8d78b973904a1ec$export$87244e8119d8581c.key]: 100,
    [$c8d78b973904a1ec$export$6f08e5b4d0fb8ff6.key]: 200,
    [$c8d78b973904a1ec$export$d478a53ed2abe40f.key]: 300,
    [$c8d78b973904a1ec$export$46ec42cba969242b.key]: 400
};
const $c8d78b973904a1ec$export$f53435d29f0ad0a1 = {
    type: 'menu-item',
    key: 'header-row-toggle'
};
const $c8d78b973904a1ec$export$6b0a072235fdd804 = {
    type: 'menu-item',
    key: 'numbered-rows-toggle'
};
const $c8d78b973904a1ec$export$e4528482450d5f2e = {
    type: 'menu-item',
    key: 'add-row-above'
};
const $c8d78b973904a1ec$export$c0c87706fa348bc1 = {
    type: 'menu-item',
    key: 'add-row-below'
};
const $c8d78b973904a1ec$export$6a0b892b38736f32 = {
    type: 'menu-item',
    key: 'move-row-up'
};
const $c8d78b973904a1ec$export$489645ca66afd844 = {
    type: 'menu-item',
    key: 'move-row-down'
};
const $c8d78b973904a1ec$export$fd74fd566defa85d = {
    type: 'menu-item',
    key: 'delete-row'
};
const $c8d78b973904a1ec$export$d75534200c5cba18 = {
    [$c8d78b973904a1ec$export$f53435d29f0ad0a1.key]: 100,
    [$c8d78b973904a1ec$export$6b0a072235fdd804.key]: 200
};
const $c8d78b973904a1ec$export$2476e690f9168fc5 = {
    [(0, $0117J.BACKGROUND_COLOR_ITEM).key]: 100
};
const $c8d78b973904a1ec$export$64075ae5fd18cb9c = {
    [$c8d78b973904a1ec$export$e4528482450d5f2e.key]: 100,
    [$c8d78b973904a1ec$export$c0c87706fa348bc1.key]: 200,
    [$c8d78b973904a1ec$export$6a0b892b38736f32.key]: 300,
    [$c8d78b973904a1ec$export$489645ca66afd844.key]: 400
};
const $c8d78b973904a1ec$export$5cf4383498669284 = {
    [(0, $0117J.CLEAR_CELLS_ITEM).key]: 100,
    [$c8d78b973904a1ec$export$fd74fd566defa85d.key]: 200
};

});


parcelRegister("e3ijL", function(module, exports) {
$parcel$export(module.exports, "TableMenu", () => $6aedf85b8f630fd8$export$c337ca08f09b4493);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9oAqi = parcelRequire("9oAqi");

var $dpooP = parcelRequire("dpooP");

var $l5gi8 = parcelRequire("l5gi8");

var $1aNCd = parcelRequire("1aNCd");

var $kXdsr = parcelRequire("kXdsr");

var $khBKG = parcelRequire("khBKG");

var $fPwP3 = parcelRequire("fPwP3");

var $6CvZ7 = parcelRequire("6CvZ7");

var $gB626 = parcelRequire("gB626");
const $6aedf85b8f630fd8$export$c337ca08f09b4493 = /*#__PURE__*/ (0, $fc4bM.memo)(({ api: api, editorView: editorView, surface: surface })=>{
    const components = (0, $fc4bM.useMemo)(()=>{
        var _api$uiControlRegistr;
        return (api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents(surface.key)) ?? [];
    }, [
        api,
        surface.key
    ]);
    const { tableNode: tableNode, selection: selection } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table',
        'selection'
    ], (states)=>{
        var _states$tableState, _states$selectionStat;
        return {
            tableNode: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.tableNode,
            selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
        };
    });
    const tableMenuContext = (0, $fc4bM.useMemo)(()=>{
        // rely on selection plugins state to re-render the row/column menu, but use editorView.selection
        // for cell menu state as the selection plugin won't update when text selection changes within cells
        if (!tableNode || !editorView || !selection) return undefined;
        const tableMap = (0, $dpooP.TableMap).get(tableNode);
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        const cellOps = {
            editorView: editorView,
            surface: surface,
            canMergeCells: (0, $fPwP3.canMergeCellSelection)(editorView.state.selection),
            canSplitCell: (0, $khBKG.canSplitCellSelection)(editorView.state.selection),
            hasMergedCellsInTable: tableMap.hasMergedCells()
        };
        if (!selectionRect) return cellOps;
        return {
            ...cellOps,
            canMoveRowUp: (0, $6CvZ7.canMove)('table-row', -1, tableMap.height, editorView.state.selection, selectionRect),
            canMoveRowDown: (0, $6CvZ7.canMove)('table-row', 1, tableMap.height, editorView.state.selection, selectionRect),
            canMoveColumnLeft: (0, $6CvZ7.canMove)('table-column', -1, tableMap.width, editorView.state.selection, selectionRect),
            canMoveColumnRight: (0, $6CvZ7.canMove)('table-column', 1, tableMap.width, editorView.state.selection, selectionRect),
            isFirstRow: selectionRect.top === 0,
            isLastRow: selectionRect.bottom === tableMap.height,
            selectedRowCount: selectionRect.bottom - selectionRect.top,
            isFirstColumn: selectionRect.left === 0,
            isLastColumn: selectionRect.right === tableMap.width,
            selectedColumnCount: selectionRect.right - selectionRect.left
        };
    }, [
        editorView,
        tableNode,
        selection,
        surface
    ]);
    if (components.length === 0) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gB626.TableMenuProvider), {
        value: tableMenuContext,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1aNCd.ToolbarMenuContainer), {
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $kXdsr.SurfaceRenderer), {
                surface: surface,
                components: components
            })
        })
    });
});
$6aedf85b8f630fd8$export$c337ca08f09b4493.displayName = 'TableMenu';

});
parcelRegister("gB626", function(module, exports) {
$parcel$export(module.exports, "TableMenuProvider", () => $064be6c22561cbf8$export$e9137bf957e9632f);
$parcel$export(module.exports, "useTableMenuContext", () => $064be6c22561cbf8$export$3ac6ec6862f4c02f);

var $fc4bM = parcelRequire("fc4bM");
const $064be6c22561cbf8$var$TableMenuContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createContext(undefined);
const $064be6c22561cbf8$export$e9137bf957e9632f = $064be6c22561cbf8$var$TableMenuContext.Provider;
const $064be6c22561cbf8$export$3ac6ec6862f4c02f = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext($064be6c22561cbf8$var$TableMenuContext);

});



parcelRegister("c6wu6", function(module, exports) {
$parcel$export(module.exports, "default", () => $9483e812243af3cb$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $jiju3 = parcelRequire("jiju3");

var $fcCIH = parcelRequire("fcCIH");

var $hIsCp = parcelRequire("hIsCp");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $hjMNs = parcelRequire("hjMNs");

var $3D4hV = parcelRequire("3D4hV");

var $gb4WG = parcelRequire("gb4WG");

var $4oU9q = parcelRequire("4oU9q");

var $lvSK5 = parcelRequire("lvSK5");

var $7CipI = parcelRequire("7CipI");

var $3kq7i = parcelRequire("3kq7i");

var $4mSGa = parcelRequire("4mSGa");

var $6v21D = parcelRequire("6v21D");

var $6ySyj = parcelRequire("6ySyj");

var $hCON4 = parcelRequire("hCON4");

var $5j2ZG = parcelRequire("5j2ZG");

var $ksttc = parcelRequire("ksttc");

var $5N0Vg = parcelRequire("5N0Vg");

var $bY7Ml = parcelRequire("bY7Ml");

var $8SESw = parcelRequire("8SESw");

var $cfqPz = parcelRequire("cfqPz");

var $ekgS0 = parcelRequire("ekgS0");

var $hWLCD = parcelRequire("hWLCD");

var $iGIja = parcelRequire("iGIja");

var $5m5hr = parcelRequire("5m5hr");

var $1YIVu = parcelRequire("1YIVu");

var $emJZF = parcelRequire("emJZF");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $kaRof = parcelRequire("kaRof");

var $aEmSo = parcelRequire("aEmSo");

var $EwLhB = parcelRequire("EwLhB");
var $8L6TV = parcelRequire("8L6TV");
var $3Gwyn = parcelRequire("3Gwyn");

var $kfljr = parcelRequire("kfljr");

var $4GJqd = parcelRequire("4GJqd");

var $4dyXt = parcelRequire("4dyXt");

var $26jxM = parcelRequire("26jxM");

var $fPwP3 = parcelRequire("fPwP3");

var $2q9QJ = parcelRequire("2q9QJ");

var $jo7Pl = parcelRequire("jo7Pl");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $oaovf = parcelRequire("oaovf");
const $9483e812243af3cb$var$dropdownMenuSection = {
    hasSeparator: true
};
const $9483e812243af3cb$var$elementBeforeIconStyles = (0, $kig2V.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $9483e812243af3cb$var$getArrowsList = (0, $jiju3.default)(()=>new Set(!(0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? [
        'ArrowRight',
        'ArrowLeft'
    ] : [
        'ArrowRight'
    ]));
class $9483e812243af3cb$export$f55c8e309b1cad66 extends (0, $fc4bM.Component) {
    static #_ = this.defaultProps = {
        boundariesElement: typeof document !== 'undefined' ? document.body : undefined
    };
    componentDidMount() {
        // ArrowKeyNavigationProvider in DropdownMenu expects that menu handle will stay focused
        // until user pressed ArrowDown.
        // Behavior above fails the A11Y requirement about first item in menu should be focused immediately.
        // so here is triggering componentDidUpdate inside dropdown to set focus on first element
        const { isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
        if (isCellMenuOpenByKeyboard) this.setState({
            ...this.state,
            isOpenAllowed: isCellMenuOpenByKeyboard
        });
    }
    componentDidUpdate() {
        const { isContextualMenuOpen: isContextualMenuOpen } = (0, $4GJqd.getPluginState)(this.props.editorView.state);
        if (this.props.isDragMenuOpen && isContextualMenuOpen) (0, $3Gwyn.toggleContextualMenu)()(this.props.editorView.state, this.props.editorView.dispatch);
    }
    render() {
        const { isOpen: isOpen, offset: offset, boundariesElement: boundariesElement, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, api: api } = this.props;
        const items = this.createContextMenuItems();
        let isOpenAllowed = false;
        isOpenAllowed = isCellMenuOpenByKeyboard ? this.state.isOpenAllowed : isOpen;
        return /*#__PURE__*/ (0, $jctmk.jsx)((0, $6ySyj.UserIntentPopupWrapper), {
            userIntent: "tableContextualMenuPopupOpen",
            api: api
        }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            "data-testid": "table-cell-contextual-menu",
            onMouseLeave: (0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? undefined : this.closeSubmenu,
            ref: this.dropdownMenuRef
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $6v21D.default), {
            //This needs be removed when the a11y is completely handled
            //Disabling key navigation now as it works only partially
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $4mSGa.ArrowKeyNavigationType).MENU,
                disableArrowKeyNavigation: !isCellMenuOpenByKeyboard || this.state.isSubmenuOpen
            },
            items: items,
            isOpen: isOpenAllowed,
            onOpenChange: this.handleOpenChange,
            onItemActivated: this.onMenuItemActivated,
            onMouseEnter: this.handleItemMouseEnter,
            onMouseLeave: this.handleItemMouseLeave,
            fitHeight: 188,
            fitWidth: (0, $4Tw3G.contextualMenuDropdownWidthDnD),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            shouldFocusFirstItem: ()=>{
                return Boolean(isCellMenuOpenByKeyboard);
            },
            boundariesElement: boundariesElement,
            offset: offset,
            section: $9483e812243af3cb$var$dropdownMenuSection,
            allowEnterDefaultBehavior: this.state.isSubmenuOpen
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            isSubmenuOpen: false,
            isOpenAllowed: false
        }, this.dropdownMenuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createRef(), this.handleSubMenuRef = (ref)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const dom = this.props.editorView.dom;
            const parent = (0, $hCON4.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $hCON4.closestElement)(dom, '.ak-editor-content-area');
            if (!(parent && ref)) return;
            const boundariesRect = parent.getBoundingClientRect();
            const rect = ref.getBoundingClientRect();
            if (!!this.props.mountPoint) return;
            const offsetParent = ref === null || ref === void 0 ? void 0 : ref.offsetParent;
            if (!offsetParent) return;
            const offsetParentRect = offsetParent.getBoundingClientRect();
            const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
            const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
            if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
            // if it overflows regardless of side, let it overlap with the parent menu
            if (leftOverflow > 0 && rightOverflow > 0) {
                if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
                else ref.style.left = `-${rect.width - leftOverflow}px`;
            }
        }, this.createBackgroundColorItem = ()=>{
            const { allowBackgroundColor: allowBackgroundColor, editorView: { state: state }, isOpen: isOpen, intl: { formatMessage: formatMessage }, editorView: editorView, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { isSubmenuOpen: isSubmenuOpen } = this.state;
            const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(editorView.state);
            if (allowBackgroundColor) {
                var _node$attrs, _node$attrs2;
                const node = isOpen && targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
                const background = (0, $5j2ZG.hexToEditorBackgroundPaletteColor)((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.background) || '#ffffff');
                const isMoreColorsEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
                const activePalette = isMoreColorsEnabled ? (0, $3D4hV.default) : (0, $4oU9q.default);
                const activeCols = isMoreColorsEnabled ? (0, $4Tw3G.colorPaletteColumns) : (0, $4Tw3G.colorPalletteColumns);
                const selectedRowAndColumnFromPalette = (0, $7CipI.getSelectedRowAndColumnFromPalette)(activePalette, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                background, activeCols);
                const selectedRowIndex = selectedRowAndColumnFromPalette.selectedRowIndex;
                const selectedColumnIndex = selectedRowAndColumnFromPalette.selectedColumnIndex;
                return {
                    content: formatMessage((0, $lqHJB.messages).backgroundColor),
                    value: {
                        name: 'background'
                    },
                    elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                        xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bY7Ml))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $lqHJB.messages).backgroundColor)
                    })),
                    elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                        className: (0, $hjMNs.DropdownMenuSharedCssClassName).SUBMENU
                    }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                        css: (0, $oaovf.cellColourPreviewStyles)(background),
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $YREXK.TableCssClassName).CONTEXTUAL_MENU_ICON_SMALL
                    }), isSubmenuOpen && /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $YREXK.TableCssClassName).CONTEXTUAL_SUBMENU,
                        ref: this.handleSubMenuRef
                    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $3kq7i.ArrowKeyNavigationProvider), {
                        type: (0, $4mSGa.ArrowKeyNavigationType).COLOR,
                        selectedRowIndex: selectedRowIndex || 0,
                        selectedColumnIndex: selectedColumnIndex || 0,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        handleClose: ()=>{
                            this.setState({
                                isSubmenuOpen: false
                            });
                            if (this.dropdownMenuRef && this.dropdownMenuRef.current) {
                                const focusableItems = this.dropdownMenuRef.current.querySelectorAll('div[tabindex="-1"]:not([disabled])');
                                if (focusableItems && focusableItems.length) focusableItems[0].focus();
                            }
                        },
                        isPopupPositioned: true,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        isOpenedByKeyboard: isCellMenuOpenByKeyboard
                    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $gb4WG.default), {
                        cols: activeCols,
                        onClick: this.setColor,
                        selectedColor: (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.background) || '#ffffff',
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        paletteOptions: {
                            palette: activePalette,
                            paletteColorTooltipMessages: (0, $lvSK5.backgroundPaletteTooltipMessages),
                            hexToPaletteColor: (0, $5j2ZG.hexToEditorBackgroundPaletteColor)
                        }
                    })))),
                    'aria-expanded': isSubmenuOpen
                };
            }
        }, // Used in the NewContextMenuItems object
        this.newDistributeColumnsItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            return this.createDistributeColumnsItemInternal({
                elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                    xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5m5hr))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $lqHJB.messages).distributeColumns)
                }))
            });
        }, this.createMergeSplitCellItems = ()=>{
            const { allowMergeCells: allowMergeCells, editorView: { state: state }, intl: { formatMessage: formatMessage } } = this.props;
            if (allowMergeCells) return [
                {
                    content: formatMessage((0, $lqHJB.messages).mergeCells),
                    value: {
                        name: 'merge'
                    },
                    isDisabled: !(0, $fPwP3.canMergeCells)(state.tr),
                    elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                        xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cfqPz))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $lqHJB.messages).mergeCells)
                    }))
                },
                {
                    content: formatMessage((0, $lqHJB.messages).splitCell),
                    value: {
                        name: 'split'
                    },
                    isDisabled: !(0, $5N0Vg.splitCell)(state),
                    elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                        xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ekgS0))), {
                        color: "currentColor",
                        spacing: "spacious",
                        label: formatMessage((0, $lqHJB.messages).splitCell)
                    }))
                }
            ];
            return [];
        }, this.createInsertColumnItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const content = formatMessage((0, $lqHJB.messages).addColumnRight);
            return {
                content: content,
                value: {
                    name: 'insert_column'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                    css: (0, $ksttc.shortcutStyle)
                }, (0, $eUtBU.tooltip)((0, $eUtBU.addColumnAfter))),
                elemBefore: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                    xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWLCD))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $lqHJB.messages).addColumnRight)
                })),
                'aria-label': (0, $eUtBU.tooltip)((0, $eUtBU.addColumnAfter), String(content))
            };
        }, this.createInsertRowItem = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            const content = formatMessage((0, $lqHJB.messages).addRowBelow);
            return {
                content: content,
                value: {
                    name: 'insert_row'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                    css: (0, $ksttc.shortcutStyle)
                }, (0, $eUtBU.tooltip)((0, $eUtBU.addRowAfter))),
                elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                    xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YIVu))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $lqHJB.messages).addRowBelow)
                })),
                'aria-label': (0, $eUtBU.tooltip)((0, $eUtBU.addRowAfter), String(content))
            };
        }, this.createClearCellsItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage } } = this.props;
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            const noOfRows = bottom - top;
            const content = formatMessage((0, $lqHJB.messages).clearCells, {
                0: Math.max(noOfColumns, noOfRows)
            });
            return {
                content: content,
                value: {
                    name: 'clear'
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                    css: (0, $ksttc.shortcutStyle)
                }, (0, $eUtBU.tooltip)((0, $eUtBU.backspace))),
                elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                    xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8SESw))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $lqHJB.messages).clearCells, {
                        0: Math.max(noOfColumns, noOfRows)
                    })
                })),
                'aria-label': (0, $eUtBU.tooltip)((0, $eUtBU.backspace), String(content))
            };
        }, this.createDeleteColumnItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage } } = this.props;
            const { right: right, left: left } = selectionRect;
            const noOfColumns = right - left;
            return {
                content: formatMessage((0, $lqHJB.messages).removeColumns, {
                    0: noOfColumns
                }),
                value: {
                    name: 'delete_column'
                },
                elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                    xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iGIja))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $lqHJB.messages).removeColumns, {
                        0: noOfColumns
                    })
                }))
            };
        }, this.createDeleteRowItem = ()=>{
            const { selectionRect: selectionRect, intl: { formatMessage: formatMessage } } = this.props;
            const { bottom: bottom, top: top } = selectionRect;
            const noOfRows = bottom - top;
            return {
                content: formatMessage((0, $lqHJB.messages).removeRows, {
                    0: noOfRows
                }),
                value: {
                    name: 'delete_row'
                },
                elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                    xcss: $9483e812243af3cb$var$elementBeforeIconStyles
                }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($emJZF))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: formatMessage((0, $lqHJB.messages).removeRows, {
                        0: noOfRows
                    })
                }))
            };
        }, this.createDistributeColumnsItemInternal = (partialMenuItem)=>{
            const { selectionRect: selectionRect, editorView: editorView, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, intl: { formatMessage: formatMessage } } = this.props;
            const { isTableScalingEnabled: isTableScalingEnabled = false } = (0, $4GJqd.getPluginState)(editorView.state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const newResizeState = (0, $26jxM.getNewResizeStateFromSelectedColumns)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption);
            const wouldChange = (newResizeState === null || newResizeState === void 0 ? void 0 : newResizeState.changed) ?? false;
            return {
                content: formatMessage((0, $lqHJB.messages).distributeColumns),
                value: {
                    name: 'distribute_columns'
                },
                isDisabled: !wouldChange,
                ...partialMenuItem
            };
        }, this.createContextMenuItems = ()=>{
            const backgroundColorItem = this.createBackgroundColorItem();
            const mergeSplitCellItems = this.createMergeSplitCellItems();
            const insertColumnItem = this.createInsertColumnItem();
            const insertRowItem = this.createInsertRowItem();
            const clearCellsItem = this.createClearCellsItem();
            const deleteColumnItem = this.createDeleteColumnItem();
            const deleteRowItem = this.createDeleteRowItem();
            // Group items so when table.menu.group-items FF is enabled, a divider shows under split cell, above add column
            const items = [
                {
                    items: []
                },
                {
                    items: []
                }
            ];
            backgroundColorItem && items[0].items.push(backgroundColorItem);
            items[0].items.push(...mergeSplitCellItems);
            items[1].items.push(insertColumnItem);
            items[1].items.push(insertRowItem);
            if ((0, $kaRof.editorExperiment)('platform_editor_controls', 'variant1')) items[1].items.push(this.newDistributeColumnsItem());
            items[1].items.push(clearCellsItem);
            items[1].items.push(deleteColumnItem);
            items[1].items.push(deleteRowItem);
            return items;
        }, this.onMenuItemActivated = ({ item: item })=>{
            const { editorView: editorView, selectionRect: selectionRect, editorAnalyticsAPI: editorAnalyticsAPI, getEditorContainerWidth: getEditorContainerWidth, getEditorFeatureFlags: getEditorFeatureFlags, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard, isCommentEditor: isCommentEditor } = this.props;
            // TargetCellPosition could be outdated: https://product-fabric.atlassian.net/browse/ED-8129
            const { state: state, dispatch: dispatch } = editorView;
            const { targetCellPosition: targetCellPosition, isTableScalingEnabled: isTableScalingEnabled = false } = (0, $4GJqd.getPluginState)(state);
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            // context menu opened by keyboard and any item except 'background' activated
            // or color has been chosen from color palette
            if (isCellMenuOpenByKeyboard && (item.value.name !== 'background' || item.value.name === 'background' && this.state.isSubmenuOpen)) {
                const { tr: tr } = state;
                tr.setMeta((0, $4dyXt.pluginKey), {
                    type: 'SET_CELL_MENU_OPEN',
                    data: {
                        isCellMenuOpenByKeyboard: false
                    }
                });
                dispatch(tr);
                editorView.dom.focus(); // otherwise cursor disappears from cell
            }
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || // When in comment editor, we need the scaling percent to be 40% while tableWithFixedColumnWidthsOption is not visible
            isCommentEditor);
            switch(item.value.name){
                case 'sort_column_desc':
                    (0, $kfljr.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $hIsCp.SortOrder).DESC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'sort_column_asc':
                    (0, $kfljr.sortColumnWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, selectionRect.left, (0, $hIsCp.SortOrder).ASC)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'merge':
                    (0, $kfljr.mergeCellsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'split':
                    (0, $kfljr.splitCellWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'distribute_columns':
                    const newResizeStateWithAnalytics = (0, $26jxM.getNewResizeStateFromSelectedColumns)(selectionRect, state, editorView.domAtPos.bind(editorView), getEditorContainerWidth, isTableScalingEnabled, tableWithFixedColumnWidthsOption, isCommentEditor);
                    if (newResizeStateWithAnalytics) {
                        (0, $kfljr.distributeColumnsWidthsWithAnalytics)(editorAnalyticsAPI, this.props.api)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, newResizeStateWithAnalytics)(state, dispatch);
                        this.toggleOpen();
                    }
                    break;
                case 'clear':
                    (0, $kfljr.emptyMultipleCellsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, targetCellPosition)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'insert_column':
                    (0, $kfljr.insertColumnWithAnalytics)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, selectionRect.right)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'insert_row':
                    (0, $kfljr.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, {
                        index: selectionRect.bottom,
                        moveCursorToInsertedRow: true
                    })(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'delete_column':
                    (0, $kfljr.deleteColumnsWithAnalytics)(editorAnalyticsAPI, this.props.api, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, selectionRect)(state, dispatch, editorView);
                    this.toggleOpen();
                    break;
                case 'delete_row':
                    const { pluginConfig: { isHeaderRowRequired: isHeaderRowRequired } } = (0, $4GJqd.getPluginState)(state);
                    (0, $kfljr.deleteRowsWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(state, dispatch);
                    this.toggleOpen();
                    break;
                case 'background':
                    if (!(0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) // This is called twice.
                    // 1st time when user chooses the background color item.
                    // 2nd when color has been chosen from color palette.
                    // here we are handling the 1st call relying on the isSubmenuOpen state value
                    {
                        if (isCellMenuOpenByKeyboard && !this.state.isSubmenuOpen) this.setState({
                            isSubmenuOpen: true
                        });
                    } else this.setState((prevState)=>({
                            isSubmenuOpen: !prevState.isSubmenuOpen
                        }));
                    break;
            }
        }, this.toggleOpen = ()=>{
            const { editorView: { state: state, dispatch: dispatch } } = this.props;
            if ((0, $4GJqd.getPluginState)(state).isContextualMenuOpen) (0, $3Gwyn.toggleContextualMenu)()(state, dispatch);
            this.closeSubmenu();
        }, this.handleOpenChange = (payload)=>{
            const { editorView: { state: state, dispatch: dispatch, dom: dom }, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            if (payload) {
                const { event: event } = payload;
                if (event && event instanceof KeyboardEvent) {
                    if (!this.state.isSubmenuOpen) {
                        if ($9483e812243af3cb$var$getArrowsList().has(event.key)) {
                            // preventing default behavior for avoiding cursor jump to next/previous table column
                            // when left/right arrow pressed.
                            event.preventDefault();
                            if ((0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                                this.setState({
                                    isSubmenuOpen: true
                                });
                                return;
                            }
                        }
                        (0, $3Gwyn.toggleContextualMenu)()(state, dispatch);
                        this.setState({
                            isSubmenuOpen: false
                        });
                        (0, $8L6TV.setFocusToCellMenu)(false)(state, dispatch);
                        dom.focus();
                    }
                } else {
                    // mouse click outside
                    (0, $3Gwyn.toggleContextualMenu)()(state, dispatch);
                    this.setState({
                        isSubmenuOpen: false
                    });
                    if (isCellMenuOpenByKeyboard) (0, $8L6TV.setFocusToCellMenu)(false)(state, dispatch);
                }
            }
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseEnter = ({ item: item })=>{
            const { editorView: { state: state, dispatch: dispatch }, selectionRect: selectionRect } = this.props;
            if (!(0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'background') {
                    if (!this.state.isSubmenuOpen) this.setState({
                        isSubmenuOpen: true
                    });
                }
            }
            if (item.value.name === 'delete_column') (0, $EwLhB.hoverColumns)((0, $2q9QJ.getSelectedColumnIndexes)(selectionRect), true)(state, dispatch);
            if (item.value.name === 'delete_row') (0, $EwLhB.hoverRows)((0, $2q9QJ.getSelectedRowIndexes)(selectionRect), true)(state, dispatch);
            if ([
                'sort_column_asc',
                'sort_column_desc'
            ].indexOf(item.value.name) > -1 && (0, $jo7Pl.getMergedCellsPositions)(state.tr).length !== 0) (0, $EwLhB.hoverMergedCells)()(state, dispatch);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleItemMouseLeave = ({ item: item })=>{
            const { state: state, dispatch: dispatch } = this.props.editorView;
            if (!(0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'background') this.closeSubmenu();
            }
            if ([
                'sort_column_asc',
                'sort_column_desc',
                'delete_column',
                'delete_row'
            ].indexOf(item.value.name) > -1) (0, $EwLhB.clearHoverSelection)()(state, dispatch);
        }, this.closeSubmenu = ()=>{
            if (this.state.isSubmenuOpen) this.setState({
                isSubmenuOpen: false
            });
        }, this.setColor = (color)=>{
            const { editorView: editorView, editorAnalyticsAPI: editorAnalyticsAPI, isCellMenuOpenByKeyboard: isCellMenuOpenByKeyboard } = this.props;
            const { state: state, dispatch: dispatch, dom: dom } = editorView;
            (0, $kfljr.setColorWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
            if (!(0, $aEmSo.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) this.toggleOpen();
            else {
                this.toggleOpen();
                if (isCellMenuOpenByKeyboard) {
                    (0, $8L6TV.setFocusToCellMenu)(false)(editorView.state, dispatch);
                    dom.focus();
                }
            }
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $9483e812243af3cb$var$_default_1 = (0, $fcCIH.default)($9483e812243af3cb$export$f55c8e309b1cad66);
var $9483e812243af3cb$export$2e2bcd8739ae039 = $9483e812243af3cb$var$_default_1;

});
parcelRegister("oaovf", function(module, exports) {
$parcel$export(module.exports, "cellColourPreviewStyles", () => $aac987afcc2db8fb$export$bc7b8b99ac8e8073);
$parcel$export(module.exports, "tablePopupStyles", () => $aac987afcc2db8fb$export$62225ca66ffe289c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $jctmk = parcelRequire("jctmk");

var $63Q5S = parcelRequire("63Q5S");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");
const $aac987afcc2db8fb$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $jctmk.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $aac987afcc2db8fb$export$62225ca66ffe289c = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).CONTEXTUAL_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:block;position:absolute;top:0;left:", (0, $4Tw3G.contextualMenuDropdownWidthDnD), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $YREXK.TableCssClassName).CONTEXTUAL_MENU_ICON_SMALL, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Q5S.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:var(--ds-icon, #292A2E);}}");

});



parcelRegister("5SonH", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca4a619376088b66$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $dXHAJ = parcelRequire("dXHAJ");

var $014x6 = parcelRequire("014x6");

var $ev7OZ = parcelRequire("ev7OZ");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $lsmEV = parcelRequire("lsmEV");
const $ca4a619376088b66$var$FloatingDragMenu = ({ mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, isOpen: isOpen, tableNode: tableNode, direction: direction, index: index, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, editorAnalyticsAPI: editorAnalyticsAPI, stickyHeaders: stickyHeaders, pluginConfig: pluginConfig, isTableScalingEnabled: isTableScalingEnabled, getEditorFeatureFlags: getEditorFeatureFlags, ariaNotifyPlugin: ariaNotifyPlugin, api: api, isCommentEditor: isCommentEditor, tableWrapper: tableWrapper })=>{
    if (!isOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition) return null;
    const inStickyMode = (stickyHeaders === null || stickyHeaders === void 0 ? void 0 : stickyHeaders.sticky) || (tableWrapper === null || tableWrapper === void 0 ? void 0 : tableWrapper.classList.contains((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW));
    const targetHandleRef = direction === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $ev7OZ.CellSelection))) return null;
    const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = (getEditorFeatureFlags === null || getEditorFeatureFlags === void 0 ? void 0 : getEditorFeatureFlags()) ?? {};
    const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dXHAJ.default), {
        alignX: direction === 'row' ? 'right' : undefined,
        alignY: direction === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $4Tw3G.dragMenuDropdownWidth),
        fitHeight: (0, $4Tw3G.tablePopupMenuFitHeight),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $014x6.akEditorFloatingDialogZIndex) : (0, $014x6.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        offset: direction === 'row' ? [
            -9,
            0
        ] : [
            0,
            -7
        ],
        stick: true,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lsmEV.default), {
            editorView: editorView,
            isOpen: isOpen,
            tableNode: tableNode,
            direction: direction,
            index: index,
            target: targetHandleRef || undefined,
            targetCellPosition: targetCellPosition,
            getEditorContainerWidth: getEditorContainerWidth,
            editorAnalyticsAPI: editorAnalyticsAPI,
            pluginConfig: pluginConfig,
            fitWidth: (0, $4Tw3G.dragMenuDropdownWidth),
            fitHeight: (0, $4Tw3G.tablePopupMenuFitHeight),
            mountPoint: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isTableScalingEnabled: isTableScalingEnabled,
            shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent,
            isTableFixedColumnWidthsOptionEnabled: tableWithFixedColumnWidthsOption,
            ariaNotifyPlugin: ariaNotifyPlugin,
            api: api,
            isCommentEditor: isCommentEditor || false
        })
    });
};
$ca4a619376088b66$var$FloatingDragMenu.displayName = 'FloatingDragMenu';
var $ca4a619376088b66$export$2e2bcd8739ae039 = $ca4a619376088b66$var$FloatingDragMenu;

});
parcelRegister("lsmEV", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f65092afe8311d1$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ /** @jsxFrag */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $fcCIH = parcelRequire("fcCIH");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $hjMNs = parcelRequire("hjMNs");

var $3D4hV = parcelRequire("3D4hV");

var $gb4WG = parcelRequire("gb4WG");

var $4oU9q = parcelRequire("4oU9q");

var $lvSK5 = parcelRequire("lvSK5");

var $7CipI = parcelRequire("7CipI");

var $3kq7i = parcelRequire("3kq7i");

var $4mSGa = parcelRequire("4mSGa");

var $6ySyj = parcelRequire("6ySyj");

var $hCON4 = parcelRequire("hCON4");

var $5j2ZG = parcelRequire("5j2ZG");

var $ksttc = parcelRequire("ksttc");

var $dpooP = parcelRequire("dpooP");

var $elHd5 = parcelRequire("elHd5");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");

var $bY7Ml = parcelRequire("bY7Ml");

var $5a4EU = parcelRequire("5a4EU");

var $kig2V = parcelRequire("kig2V");

var $aEmSo = parcelRequire("aEmSo");

var $ew1lT = parcelRequire("ew1lT");

var $EwLhB = parcelRequire("EwLhB");

var $kfljr = parcelRequire("kfljr");

var $ecxo1 = parcelRequire("ecxo1");

var $HfCkc = parcelRequire("HfCkc");

var $4GJqd = parcelRequire("4GJqd");

var $6CvZ7 = parcelRequire("6CvZ7");

var $4WYVI = parcelRequire("4WYVI");

var $2q9QJ = parcelRequire("2q9QJ");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $dLIF6 = parcelRequire("dLIF6");

var $iwivz = parcelRequire("iwivz");
const $6f65092afe8311d1$var$MapDragMenuOptionIdToMessage = {
    add_row_above: {
        message: (0, $lqHJB.messages).addRowAbove,
        plural: null
    },
    add_row_below: {
        message: (0, $lqHJB.messages).addRowBelow,
        plural: null
    },
    add_column_left: {
        message: (0, $lqHJB.messages).addColumnLeft,
        plural: null
    },
    add_column_right: {
        message: (0, $lqHJB.messages).addColumnRight,
        plural: null
    },
    distribute_columns: {
        message: (0, $lqHJB.messages).distributeColumns,
        plural: 'noOfCols'
    },
    clear_cells: {
        message: (0, $lqHJB.messages).clearCells,
        plural: 'noOfCells'
    },
    delete_row: {
        message: (0, $lqHJB.messages).removeRows,
        plural: 'noOfRows'
    },
    delete_column: {
        message: (0, $lqHJB.messages).removeColumns,
        plural: 'noOfCols'
    },
    move_column_left: {
        message: (0, $lqHJB.messages).moveColumnLeft,
        plural: 'noOfCols'
    },
    move_column_right: {
        message: (0, $lqHJB.messages).moveColumnRight,
        plural: 'noOfCols'
    },
    move_row_up: {
        message: (0, $lqHJB.messages).moveRowUp,
        plural: 'noOfRows'
    },
    move_row_down: {
        message: (0, $lqHJB.messages).moveRowDown,
        plural: 'noOfRows'
    },
    sort_column_asc: {
        message: (0, $lqHJB.messages).sortColumnIncreasing,
        plural: null
    },
    sort_column_desc: {
        message: (0, $lqHJB.messages).sortColumnDecreasing,
        plural: null
    }
};
const $6f65092afe8311d1$var$getGroupedDragMenuConfig = ()=>{
    const groupedDragMenuConfig = [
        [
            'add_row_above',
            'add_row_below',
            'add_column_left',
            'add_column_right',
            'distribute_columns',
            'clear_cells',
            'delete_row',
            'delete_column'
        ],
        [
            'move_column_left',
            'move_column_right',
            'move_row_up',
            'move_row_down'
        ]
    ];
    const sortColumnItems = [
        'sort_column_asc',
        'sort_column_desc'
    ];
    groupedDragMenuConfig.unshift(sortColumnItems);
    return groupedDragMenuConfig;
};
const $6f65092afe8311d1$var$elementBeforeIconStyles = (0, $kig2V.xcss)({
    marginRight: 'space.negative.075',
    display: 'flex'
});
const $6f65092afe8311d1$var$convertToDropdownItems = (dragMenuConfig, formatMessage, selectionRect)=>{
    const groupedDragMenuConfig = $6f65092afe8311d1$var$getGroupedDragMenuConfig();
    const menuItemsArr = [
        ...Array(groupedDragMenuConfig.length)
    ].map(()=>[]);
    const menuCallback = {};
    dragMenuConfig.forEach((item)=>{
        var _MapDragMenuOptionIdT;
        const menuGroupIndex = groupedDragMenuConfig.findIndex((group)=>group.includes(item.id));
        if (menuGroupIndex === -1) return;
        const isPlural = Boolean((_MapDragMenuOptionIdT = $6f65092afe8311d1$var$MapDragMenuOptionIdToMessage[item.id]) === null || _MapDragMenuOptionIdT === void 0 ? void 0 : _MapDragMenuOptionIdT.plural);
        let plural = 0;
        if (isPlural && selectionRect) {
            const { top: top, bottom: bottom, right: right, left: left } = selectionRect;
            switch($6f65092afe8311d1$var$MapDragMenuOptionIdToMessage[item.id].plural){
                case 'noOfCols':
                    plural = right - left;
                    break;
                case 'noOfRows':
                    plural = bottom - top;
                    break;
                case 'noOfCells':
                    plural = Math.max(right - left, bottom - top);
                    break;
            }
        }
        const options = isPlural ? {
            0: plural
        } : undefined;
        menuItemsArr[menuGroupIndex].push({
            key: item.id,
            content: formatMessage($6f65092afe8311d1$var$MapDragMenuOptionIdToMessage[item.id].message, options),
            value: {
                name: item.id
            },
            isDisabled: item.disabled,
            elemBefore: item.icon ? /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                xcss: $6f65092afe8311d1$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $jctmk.jsx)(item.icon, {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage($6f65092afe8311d1$var$MapDragMenuOptionIdToMessage[item.id].message, options)
            })) : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            elemAfter: item.keymap ? /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                css: (0, $ksttc.shortcutStyle)
            }, item.keymap) : undefined
        });
        item.onClick && (menuCallback[item.id] = item.onClick);
    });
    const menuItems = menuItemsArr.reduce((acc, curr)=>{
        (curr === null || curr === void 0 ? void 0 : curr.length) > 0 && acc.push({
            items: curr
        });
        return acc;
    }, []);
    return {
        menuItems: menuItems,
        menuCallback: menuCallback
    };
};
const $6f65092afe8311d1$var$DragMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo(({ direction: direction = 'row', index: index, target: target, isOpen: isOpen, editorView: editorView, tableNode: tableNode, targetCellPosition: targetCellPosition, getEditorContainerWidth: getEditorContainerWidth, api: api, editorAnalyticsAPI: editorAnalyticsAPI, pluginConfig: pluginConfig, intl: { formatMessage: formatMessage }, fitHeight: fitHeight, fitWidth: fitWidth, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, isTableScalingEnabled: isTableScalingEnabled, shouldUseIncreasedScalingPercent: shouldUseIncreasedScalingPercent, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, ariaNotifyPlugin: ariaNotifyPlugin, isCommentEditor: isCommentEditor })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { selection: selection } = state;
    const tableMap = tableNode ? (0, $dpooP.TableMap).get(tableNode) : undefined;
    const [isSubmenuOpen, setIsSubmenuOpen] = (0, $fc4bM.useState)(false);
    const { isKeyboardModeActive: isKeyboardModeActive } = (0, $HfCkc.getPluginState)(state);
    const selectionRect = (0, $2HFfw.isSelectionType)(selection, 'cell') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);
    const hasMergedCellsInTable = (tableMap === null || tableMap === void 0 ? void 0 : tableMap.hasMergedCells()) ?? false;
    const allowBackgroundColor = (pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.allowBackgroundColor) ?? false;
    const dragMenuConfig = (0, $6CvZ7.getDragMenuConfig)(direction, getEditorContainerWidth, hasMergedCellsInTable, editorView, api, tableMap, index, targetCellPosition, selectionRect, editorAnalyticsAPI, pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.isHeaderRowRequired, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, ariaNotifyPlugin, isCommentEditor, (pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.allowColumnSorting) ?? true);
    const { menuItems: menuItems, menuCallback: menuCallback } = $6f65092afe8311d1$var$convertToDropdownItems(dragMenuConfig, formatMessage, selectionRect);
    const handleSubMenuRef = (ref)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const dom = editorView.dom;
        const parent = (0, $hCON4.closestElement)(dom, '.fabric-editor-popup-scroll-parent') || (0, $hCON4.closestElement)(dom, '.ak-editor-content-area');
        if (!(parent && ref)) return;
        const boundariesRect = parent.getBoundingClientRect();
        const rect = ref.getBoundingClientRect();
        if (!!mountPoint) return;
        const offsetParent = ref === null || ref === void 0 ? void 0 : ref.offsetParent;
        if (!offsetParent) return;
        const offsetParentRect = offsetParent.getBoundingClientRect();
        const rightOverflow = offsetParentRect.right + rect.width - boundariesRect.right;
        const leftOverflow = boundariesRect.left - (offsetParentRect.left - rect.width);
        if (rightOverflow > leftOverflow) ref.style.left = `-${rect.width}px`;
        // if it overflows regardless of side, let it overlap with the parent menu
        if (leftOverflow > 0 && rightOverflow > 0) {
            if (rightOverflow < leftOverflow) ref.style.left = `${offsetParentRect.width - rightOverflow}px`;
            else ref.style.left = `-${rect.width - leftOverflow}px`;
        }
    };
    const setColor = (color)=>{
        const { state: state, dispatch: dispatch } = editorView;
        (0, $kfljr.setColorWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU, color)(state, dispatch);
        closeMenu();
        setIsSubmenuOpen(false);
    };
    const createBackgroundColorMenuItem = ()=>{
        var _node$attrs;
        const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(editorView.state);
        const node = targetCellPosition ? state.doc.nodeAt(targetCellPosition) : null;
        const background = (0, $5j2ZG.hexToEditorBackgroundPaletteColor)((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.background) || '#ffffff');
        const isMoreColorsEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
        const activePalette = isMoreColorsEnabled ? (0, $3D4hV.default) : (0, $4oU9q.default);
        const activeCols = isMoreColorsEnabled ? (0, $4Tw3G.colorPaletteColumns) : (0, $4Tw3G.colorPalletteColumns);
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $7CipI.getSelectedRowAndColumnFromPalette)(activePalette, background, activeCols);
        return {
            key: 'background',
            content: formatMessage((0, $lqHJB.messages).backgroundColor),
            value: {
                name: 'background'
            },
            elemBefore: /*#__PURE__*/ (0, $jctmk.jsx)((0, $5a4EU.Box), {
                xcss: $6f65092afe8311d1$var$elementBeforeIconStyles
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bY7Ml))), {
                color: "currentColor",
                spacing: "spacious",
                label: formatMessage((0, $lqHJB.messages).backgroundColor)
            })),
            elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $hjMNs.DropdownMenuSharedCssClassName).SUBMENU,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $iwivz.dragMenuBackgroundColorStyles)()
            }, /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $iwivz.cellColourPreviewStyles)(background),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $YREXK.TableCssClassName).DRAG_SUBMENU_ICON
            }), isSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                className: (0, $YREXK.TableCssClassName).DRAG_SUBMENU,
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $3kq7i.ArrowKeyNavigationProvider), {
                type: (0, $4mSGa.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: ()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        key: 'ArrowDown',
                        bubbles: true
                    });
                    setIsSubmenuOpen(false);
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    target === null || target === void 0 || target.focus();
                    target === null || target === void 0 || target.dispatchEvent(keyboardEvent);
                },
                isPopupPositioned: true,
                isOpenedByKeyboard: isKeyboardModeActive
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $gb4WG.default), {
                cols: activeCols,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (color)=>{
                    setColor(color);
                },
                selectedColor: background,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: activePalette,
                    paletteColorTooltipMessages: (0, $lvSK5.backgroundPaletteTooltipMessages),
                    hexToPaletteColor: (0, $5j2ZG.hexToEditorBackgroundPaletteColor)
                }
            }))))
        };
    };
    const toggleHeaderColumn = ()=>{
        (0, $kfljr.toggleHeaderColumnWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleHeaderRow = ()=>{
        (0, $kfljr.toggleHeaderRowWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const toggleRowNumbers = ()=>{
        (0, $kfljr.toggleNumberColumnWithAnalytics)(editorAnalyticsAPI)(state, dispatch);
    };
    const HeaderColumnToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: (0, $iwivz.toggleStyles)
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $ew1lT.default), {
            id: "toggle-header-column",
            label: formatMessage((0, $lqHJB.messages).headerColumn),
            onChange: toggleHeaderColumn,
            isChecked: (0, $4WYVI.checkIfHeaderColumnEnabled)(selection)
        }));
    const HeaderRowToggle = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $jctmk.jsx)("div", {
            css: (0, $iwivz.toggleStyles)
        }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $ew1lT.default), {
            id: "toggle-header-row",
            label: formatMessage((0, $lqHJB.messages).headerRow),
            onChange: toggleHeaderRow,
            isChecked: (0, $4WYVI.checkIfHeaderRowEnabled)(selection)
        }));
    const createHeaderRowColumnMenuItem = (direction)=>{
        if (direction === 'column' && (pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.advanced || pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.allowHeaderColumn)) return {
            key: 'header_column',
            content: formatMessage((0, $lqHJB.messages).headerColumn),
            value: {
                name: 'header_column'
            },
            elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)(HeaderColumnToggle, null)
        };
        if (direction === 'row' && (pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.advanced || pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.allowHeaderRow)) return {
            key: 'header_row',
            content: formatMessage((0, $lqHJB.messages).headerRow),
            value: {
                name: 'header_row'
            },
            elemAfter: /*#__PURE__*/ (0, $jctmk.jsx)(HeaderRowToggle, null)
        };
    };
    const createRowNumbersMenuItem = ()=>{
        return {
            key: 'row_numbers',
            content: formatMessage((0, $lqHJB.messages).numberedRows),
            value: {
                name: 'row_numbers'
            },
            elemAfter: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $jctmk.jsx)("div", {
                css: (0, $iwivz.toggleStyles)
            }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $ew1lT.default), {
                id: "toggle-row-numbers",
                label: formatMessage((0, $lqHJB.messages).numberedRows),
                onChange: toggleRowNumbers,
                isChecked: (0, $4WYVI.checkIfNumberColumnEnabled)(selection)
            }))
        };
    };
    /**
   * This function is to check if the menu should be closed or not.
   * As when continously clicking on tyle handle on different rows/columns,
   * should open the menu corresponding to the position of the drag handle.
   * @returns true when the menu should be closed, false otherwise
   */ const shouldCloseMenu = (state)=>{
        const { isDragMenuOpen: previousOpenState, dragMenuDirection: previousDragMenuDirection, dragMenuIndex: previousDragMenuIndex } = (0, $HfCkc.getPluginState)(state);
        // menu open but menu direction changed, means user clicked on drag handle of different row/column
        // menu open menu direction not changed, but index changed, means user clicked on drag handle of same row/column, different cells.
        // 2 scenarios above , menu should not be closed.
        if (previousOpenState === true && previousDragMenuDirection !== direction || previousOpenState === true && previousDragMenuDirection === direction && previousDragMenuIndex !== index) return false;
        else return true;
    };
    const closeMenu = (focusTarget = 'handle')=>{
        const { state: state, dispatch: dispatch } = editorView;
        if (shouldCloseMenu(state)) {
            if (target && focusTarget === 'handle') target === null || target === void 0 || target.focus();
            else editorView.focus();
            (0, $ecxo1.toggleDragMenu)(false, direction, index)(state, dispatch);
        }
    };
    const handleMenuItemActivated = ({ item: item })=>{
        var _menuCallback$item$va;
        (_menuCallback$item$va = menuCallback[item.value.name]) === null || _menuCallback$item$va === void 0 || _menuCallback$item$va.call(menuCallback, state, dispatch);
        switch(item.value.name){
            case 'background':
                setIsSubmenuOpen(!isSubmenuOpen);
                break;
            case 'header_column':
                toggleHeaderColumn();
                break;
            case 'header_row':
                toggleHeaderRow();
                break;
            case 'row_numbers':
                toggleRowNumbers();
                break;
            default:
                break;
        }
        if ([
            'header_column',
            'header_row',
            'row_numbers',
            'background'
        ].indexOf(item.value.name) <= -1) closeMenu('editor');
    };
    const handleItemMouseEnter = ({ item: item })=>{
        var _item$value$name;
        if (!selectionRect) return;
        if (item.value.name === 'background' && !isSubmenuOpen) setIsSubmenuOpen(true);
        if (!((_item$value$name = item.value.name) !== null && _item$value$name !== void 0 && _item$value$name.startsWith('delete'))) return;
        (item.value.name === 'delete_column' ? (0, $EwLhB.hoverColumns)((0, $2q9QJ.getSelectedColumnIndexes)(selectionRect), true) : (0, $EwLhB.hoverRows)((0, $2q9QJ.getSelectedRowIndexes)(selectionRect), true))(state, dispatch);
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleItemMouseLeave = ({ item: item })=>{
        if (item.value.name === 'background' && isSubmenuOpen) setIsSubmenuOpen(false);
        if ([
            'sort_column_asc',
            'sort_column_desc',
            'delete_column',
            'delete_row'
        ].indexOf(item.value.name) > -1) (0, $EwLhB.clearHoverSelection)()(state, dispatch);
    };
    (0, $fc4bM.useEffect)(()=>{
        // focus on first menu item automatically when menu renders
        // and user is using keyboard
        if (isOpen && target && isKeyboardModeActive) {
            const keyboardEvent = new KeyboardEvent('keydown', {
                key: 'ArrowDown',
                bubbles: true
            });
            target.dispatchEvent(keyboardEvent);
        }
    }, [
        isOpen,
        target,
        isKeyboardModeActive
    ]);
    if (!menuItems) return null;
    if (allowBackgroundColor) menuItems[1].items.unshift(createBackgroundColorMenuItem());
    // If first row, add toggle for Header row, default is true
    // If first column, add toggle for Header column, default is false
    if (index === 0) {
        if (pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.advanced || pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.allowHeaderColumn || pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.allowHeaderRow) {
            const headerRowColumnMenuItem = createHeaderRowColumnMenuItem(direction);
            headerRowColumnMenuItem && menuItems.push({
                items: [
                    headerRowColumnMenuItem
                ]
            });
        }
    }
    // All rows, add toggle for numbered rows, default is false
    if (direction === 'row' && (pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.advanced || pluginConfig !== null && pluginConfig !== void 0 && pluginConfig.allowNumberColumn)) index === 0 ? menuItems[menuItems.length - 1].items.push(createRowNumbersMenuItem()) : menuItems.push({
        items: [
            createRowNumbersMenuItem()
        ]
    });
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $6ySyj.UserIntentPopupWrapper), {
        api: api,
        userIntent: "tableDragMenuPopupOpen"
    }, /*#__PURE__*/ (0, $jctmk.jsx)((0, $dLIF6.DropdownMenu), {
        disableKeyboardHandling: isSubmenuOpen,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        section: {
            hasSeparator: true
        },
        items: menuItems,
        onItemActivated: handleMenuItemActivated,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        handleClose: closeMenu,
        fitHeight: fitHeight,
        fitWidth: fitWidth,
        direction: direction,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    }));
});
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $6f65092afe8311d1$var$_default_1 = (0, $fcCIH.default)($6f65092afe8311d1$var$DragMenu);
var $6f65092afe8311d1$export$2e2bcd8739ae039 = $6f65092afe8311d1$var$_default_1;

});
parcelRegister("dLIF6", function(module, exports) {
$parcel$export(module.exports, "DropdownMenu", () => $b0a120415cf5c98c$export$e44a253a59704894);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $9x7RV = parcelRequire("9x7RV");

var $dXHAJ = parcelRequire("dXHAJ");

var $3kq7i = parcelRequire("3kq7i");

var $4mSGa = parcelRequire("4mSGa");

var $6v21D = parcelRequire("6v21D");

var $dogcz = parcelRequire("dogcz");

var $8F4kC = parcelRequire("8F4kC");

var $014x6 = parcelRequire("014x6");

var $gSOfb = parcelRequire("gSOfb");

var $3rlj9 = parcelRequire("3rlj9");

var $4Tw3G = parcelRequire("4Tw3G");
const $b0a120415cf5c98c$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useContext((0, $dogcz.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $9x7RV.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $b0a120415cf5c98c$var$DropListWithOutsideListeners = (0, $8F4kC.default)($b0a120415cf5c98c$var$DropListWithOutsideClickTargetRef);
const $b0a120415cf5c98c$export$e44a253a59704894 = ({ items: items, section: section, disableKeyboardHandling: disableKeyboardHandling, onItemActivated: onItemActivated, handleClose: handleClose, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, fitWidth: fitWidth, fitHeight: fitHeight, direction: direction, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const [popupPlacement, setPopupPlacement] = (0, $fc4bM.useState)([
        'bottom',
        'left'
    ]);
    const [targetRefDiv, setTargetRefDiv] = (0, $fc4bM.useState)(null);
    const handleRef = (ref)=>{
        setTargetRefDiv(ref);
    };
    // more offsets calculation as offsets depend on the direction and updated placement here
    const offsetY = direction === 'row' ? popupPlacement[0] === 'bottom' ? -8 : -34 : 0;
    const offsetX = direction === 'column' ? popupPlacement[1] === 'left' ? 0 : -7 : 0;
    const innerMenu = ()=>{
        return /*#__PURE__*/ (0, $3LM7S.jsxs)($b0a120415cf5c98c$var$DropListWithOutsideListeners, {
            isOpen: true,
            shouldFitContainer: true,
            position: popupPlacement.join(' '),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleClickOutside: ()=>handleClose('editor'),
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEscapeKeydown: ()=>{
                if (!disableKeyboardHandling) handleClose('handle');
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleEnterKeydown: (e)=>{
                if (!disableKeyboardHandling) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            },
            targetRef: targetRefDiv,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: (0, $4Tw3G.dragMenuDropdownWidth)
                    }
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gSOfb.default), {
                    role: "menu",
                    children: items.map((group, index)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $3rlj9.default), {
                            hasSeparator: (section === null || section === void 0 ? void 0 : section.hasSeparator) && index > 0,
                            title: section === null || section === void 0 ? void 0 : section.title,
                            children: group.items.map((item)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $6v21D.DropdownMenuItem), {
                                    shouldUseDefaultRole: false,
                                    item: item,
                                    onItemActivated: onItemActivated,
                                    onMouseEnter: onMouseEnter,
                                    onMouseLeave: onMouseLeave
                                }, item.key ?? String(item.content)))
                        }, index))
                })
            ]
        });
    };
    const onClose = (0, $fc4bM.useCallback)(()=>handleClose('handle'), [
        handleClose
    ]);
    const onSelection = (0, $fc4bM.useCallback)((index)=>{
        const results = items.flatMap((item)=>'items' in item ? item.items : item);
        // onSelection is called when any focusable element is 'activated'
        // this is an issue as some menu items have toggles, which cause the index value
        // in the callback to be outside of array length.
        // The logic below normalises the index value based on the number
        // of menu items with 2 focusable elements, and adjusts the index to ensure
        // the correct menu item is sent in onItemActivated callback
        const keys = [
            'row_numbers',
            'header_row',
            'header_column'
        ];
        let doubleItemCount = 0;
        const firstIndex = results.findIndex((value)=>{
            const key = value.key;
            return key !== undefined && keys.includes(key);
        });
        if (firstIndex === -1 || index <= firstIndex) {
            onItemActivated && onItemActivated({
                item: results[index]
            });
            return;
        }
        for(let i = firstIndex; i < results.length; i += 1){
            const key = results[i].key;
            if (key !== undefined && keys.includes(key)) doubleItemCount += 1;
            if (firstIndex % 2 === 0 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
            if (firstIndex % 2 === 1 && index - doubleItemCount === i) {
                onItemActivated && onItemActivated({
                    item: results[i]
                });
                return;
            }
        }
    }, [
        items,
        onItemActivated
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
        className: "drag-dropdown-menu-wrapper",
        children: [
            /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                className: "drag-dropdown-menu-popup-ref",
                ref: handleRef
            }),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dXHAJ.default), {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                target: targetRefDiv,
                mountTo: mountPoint,
                boundariesElement: boundariesElement,
                scrollableElement: scrollableElement,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onPlacementChanged: (placement)=>{
                    setPopupPlacement(placement);
                },
                fitHeight: fitHeight,
                fitWidth: fitWidth,
                zIndex: (0, $014x6.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    offsetX,
                    offsetY
                ],
                allowOutOfBounds: true,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $3kq7i.ArrowKeyNavigationProvider), {
                    closeOnTab: !disableKeyboardHandling,
                    type: (0, $4mSGa.ArrowKeyNavigationType).MENU,
                    handleClose: onClose,
                    onSelection: onSelection,
                    // disableKeyboardHandling is linked with isSubmenuOpen in DragMenu
                    // When isSubmenuOpen is true, the background color picker palette is open, and the picker is a ColorPaletteArrowKeyNavigationProvider
                    // At the same time the MenuArrowKeyNavigationProvider are renderer too, as it is the wrapper for all other DragMenu items
                    // In this case we want the ColorPaletteArrowKeyNavigationProvider to handle the keyboard event, not the MenuArrowKeyNavigationProvider
                    // Hence set disableArrowKeyNavigation to true when disableKeyboardHandling is true
                    disableArrowKeyNavigation: disableKeyboardHandling,
                    children: innerMenu()
                })
            })
        ]
    }));
};

});

parcelRegister("iwivz", function(module, exports) {
$parcel$export(module.exports, "cellColourPreviewStyles", () => $1784157d3e9dfd9d$export$bc7b8b99ac8e8073);
$parcel$export(module.exports, "dragMenuBackgroundColorStyles", () => $1784157d3e9dfd9d$export$2a71c1910478944e);
$parcel$export(module.exports, "toggleStyles", () => $1784157d3e9dfd9d$export$4e493e7fd1e47c4d);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ 
var $jctmk = parcelRequire("jctmk");

var $63Q5S = parcelRequire("63Q5S");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");
function $1784157d3e9dfd9d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1784157d3e9dfd9d$export$bc7b8b99ac8e8073 = (selectedColor)=>/*#__PURE__*/ (0, $jctmk.css)({
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: selectedColor
        }
    });
const $1784157d3e9dfd9d$export$2a71c1910478944e = ()=>/*#__PURE__*/ (0, $jctmk.css)(".", (0, $YREXK.TableCssClassName).DRAG_SUBMENU, "{border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:block;position:absolute;top:", (0, $4Tw3G.TABLE_DRAG_MENU_PADDING_TOP) + (0, $4Tw3G.TABLE_DRAG_MENU_SORT_GROUP_HEIGHT) + (0, $4Tw3G.TABLE_DRAG_MENU_MENU_GROUP_BEFORE_HEIGHT), "px;left:", (0, $4Tw3G.dragMenuDropdownWidth), "px;padding:var(--ds-space-100, 8px);>div{padding:0;}}.", (0, $YREXK.TableCssClassName).DRAG_SUBMENU_ICON, "{display:flex;&::before{content:'';display:block;border:1px solid ", (0, $63Q5S.tableBackgroundBorderColor), ";border-radius:var(--ds-radius-small, 3px);width:14px;height:14px;}&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:14px;color:var(--ds-icon, #292A2E);}}");
const $1784157d3e9dfd9d$export$4e493e7fd1e47c4d = {
    name: "16vi1vz",
    styles: "display:flex;input[type='checkbox']{width:30px;height:14px;pointer-events:initial;cursor:pointer;}> label{margin:0px;pointer-events:none;> span{pointer-events:none;}}"
};

});



parcelRegister("8TCO2", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bda5264f9ad3bd0$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $3LeME = parcelRequire("3LeME");

var $dXHAJ = parcelRequire("dXHAJ");

var $hCON4 = parcelRequire("hCON4");

var $a4TQr = parcelRequire("a4TQr");

var $ev7OZ = parcelRequire("ev7OZ");

var $dpooP = parcelRequire("dpooP");

var $5n2u9 = parcelRequire("5n2u9");

var $bcN2K = parcelRequire("bcN2K");

var $aEmSo = parcelRequire("aEmSo");

var $kfljr = parcelRequire("kfljr");

var $4WYVI = parcelRequire("4WYVI");

var $2q9QJ = parcelRequire("2q9QJ");

var $YREXK = parcelRequire("YREXK");

var $a9lM0 = parcelRequire("a9lM0");

var $a3TGz = parcelRequire("a3TGz");

var $jaTcc = parcelRequire("jaTcc");
/**
 * Distance from the table top to the top of the row containing `cell`, summed from row heights.
 * Viewport rects cannot be used: a stuck header row is fixed to the viewport while the table scrolls.
 */ const $4bda5264f9ad3bd0$var$getRowOffsetFromTableTop = (cell, table)=>{
    const anchorRow = (0, $hCON4.closestElement)(cell, 'tr');
    if (!(table instanceof HTMLTableElement) || !anchorRow) return 0;
    let offset = 0;
    for (const row of table.rows){
        if (row === anchorRow) return offset;
        offset += row.offsetHeight;
    }
    return 0;
};
class $4bda5264f9ad3bd0$export$e2c2386b8045af89 extends (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Component {
    static #_ = this.displayName = 'FloatingInsertButton';
    constructor(props){
        super(props);
        this.insertColumn = this.insertColumn.bind(this);
        this.insertRow = this.insertRow.bind(this);
    }
    render() {
        const { tableNode: tableNode, editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex, tableRef: tableRef, mountPoint: mountPoint, boundariesElement: boundariesElement, isHeaderRowEnabled: isHeaderRowEnabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, isChromelessEditor: isChromelessEditor } = this.props;
        // ED-26961 - disable insert button for first row.
        if (insertRowButtonIndex === 0) return null;
        const type = typeof insertColumnButtonIndex !== 'undefined' ? 'column' : typeof insertRowButtonIndex !== 'undefined' ? 'row' : null;
        if (!tableNode || !tableRef || !type) return null;
        // We can't display the insert button for row index 0
        // when the header row is enabled.
        if (type === 'row' && isHeaderRowEnabled && insertRowButtonIndex === 0) return null;
        const { state: { tr: tr } } = editorView;
        if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if ((0, $2q9QJ.isFullRowOrColumnSelected)(tr.selection)) return null;
        } else {
            if (tr.selection instanceof (0, $ev7OZ.CellSelection) && (tr.selection.isColSelection() || tr.selection.isRowSelection())) return null;
        }
        const tablePos = (0, $5n2u9.findTable)(tr.selection);
        if (!tablePos) return null;
        // the tableNode props is not always latest (when you type some text in a cell, it's not updated yet)
        // we need to get the latest one by calling findTable(tr.selection)
        const cellPosition = this.getCellPosition(type, tablePos === null || tablePos === void 0 ? void 0 : tablePos.node);
        if (!cellPosition) return null;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const pos = cellPosition + tablePos.start + 1;
        let target;
        try {
            target = (0, $a4TQr.findDomRefAtPos)(pos, domAtPos);
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            if (dispatchAnalyticsEvent) {
                const payload = {
                    action: (0, $3LeME.ACTION).ERRORED,
                    actionSubject: (0, $3LeME.ACTION_SUBJECT).CONTENT_COMPONENT,
                    eventType: (0, $3LeME.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        component: (0, $3LeME.CONTENT_COMPONENT).FLOATING_INSERT_BUTTON,
                        selection: editorView.state.selection.toJSON(),
                        position: pos,
                        docSize: editorView.state.doc.nodeSize,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        error: error === null || error === void 0 ? void 0 : error.toString()
                    }
                };
                dispatchAnalyticsEvent(payload);
            }
        }
        if (!target || !(target instanceof HTMLElement)) return null;
        const targetCellRef = type === 'row' ? (0, $hCON4.closestElement)(target, 'tr') : (0, $hCON4.closestElement)(target, 'td, th');
        if (!targetCellRef) return null;
        const tableContainerWrapper = (0, $hCON4.closestElement)(targetCellRef, `.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER}`);
        const tableWrapper = (0, $hCON4.closestElement)(targetCellRef, `.${(0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER}`);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const index = type === 'column' ? insertColumnButtonIndex : insertRowButtonIndex;
        const hasNumberedColumns = (0, $4WYVI.checkIfNumberColumnEnabled)(editorView.state.selection);
        // If row 0 has a colspan, anchor to a lower row for the real column boundary (X),
        // then move back up to the table top (Y):
        //   row 0: [   colspan=2   ]
        //   row 1: [ col 1 ][ col 2 ]  ← anchor here for X
        //          ↑ button should render at row 0/table top
        let verticalOffsetCorrection = 0;
        if (type === 'column' && (0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
            if ((0, $bcN2K.isExperimentEnabled)('platform_editor_sticky_header_insert_column_exp')) verticalOffsetCorrection = $4bda5264f9ad3bd0$var$getRowOffsetFromTableTop(targetCellRef, tableRef);
            else verticalOffsetCorrection = Math.max(0, targetCellRef.getBoundingClientRect().top - tableRef.getBoundingClientRect().top);
        }
        // Insert buttons sit above the sticky header.
        // Set the layer on the Popup because its children share its stacking context.
        const zIndex = (0, $a9lM0.getTableZIndexes)().headerButton;
        return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dXHAJ.default), {
            target: targetCellRef,
            mountTo: tableContainerWrapper || mountPoint,
            boundariesElement: tableContainerWrapper || boundariesElement,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            scrollableElement: tableWrapper,
            forcePlacement: true,
            allowOutOfBounds: true,
            ...(0, $a3TGz.default)(type, index, hasNumberedColumns, tableContainerWrapper, verticalOffsetCorrection),
            zIndex: zIndex,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $jaTcc.DragAndDropInsertButton), {
                type: type,
                tableRef: tableRef,
                onMouseDown: type === 'column' ? this.insertColumn : this.insertRow,
                hasStickyHeaders: this.props.hasStickyHeaders || false,
                isChromelessEditor: isChromelessEditor
            })
        });
    }
    // Finds a row where `columnIndex` has real left/right cell boundaries.
    findRowWithUnmergedColumn(tableMap, columnIndex) {
        for(let row = 0; row < tableMap.height; row++){
            const pos = tableMap.map[row * tableMap.width + columnIndex];
            const rect = tableMap.findCell(pos);
            if (rect.left === columnIndex && rect.right === columnIndex + 1) return row;
        }
        return null;
    }
    getCellPosition(type, tableNode) {
        const { insertColumnButtonIndex: insertColumnButtonIndex, insertRowButtonIndex: insertRowButtonIndex } = this.props;
        const tableMap = (0, $dpooP.TableMap).get(tableNode);
        if (type === 'column') {
            // This condition is to make typescript happy.
            // Previously insertColumnButtonIndex - 1 would produce NaN and return null anyway.
            if (insertColumnButtonIndex === undefined) return null;
            const columnIndex = insertColumnButtonIndex === 0 ? 0 : insertColumnButtonIndex - 1;
            if (columnIndex > tableMap.width - 1) return null;
            if ((0, $aEmSo.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true)) {
                const rowWithRealColumn = this.findRowWithUnmergedColumn(tableMap, columnIndex);
                return rowWithRealColumn === null ? null : tableMap.positionAt(rowWithRealColumn, columnIndex, tableNode);
            }
            return tableMap.positionAt(0, columnIndex, tableNode);
        } else {
            // This condition is to make typescript happy.
            // Previously insertRowButtonIndex - 1 would produce NaN and return null anyway.
            if (insertRowButtonIndex === undefined) return null;
            const rowIndex = insertRowButtonIndex === 0 ? 0 : insertRowButtonIndex - 1;
            if (rowIndex > tableMap.height - 1) return null;
            return tableMap.positionAt(rowIndex, 0, tableNode);
        }
    }
    insertRow(event) {
        const { editorView: editorView, insertRowButtonIndex: insertRowButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI } = this.props;
        if (typeof insertRowButtonIndex !== 'undefined') {
            event.preventDefault();
            const { state: state, dispatch: dispatch } = editorView;
            (0, $kfljr.insertRowWithAnalytics)(editorAnalyticsAPI)((0, $3LeME.INPUT_METHOD).BUTTON, {
                index: insertRowButtonIndex,
                moveCursorToInsertedRow: true
            })(state, dispatch);
        }
    }
    insertColumn(event) {
        const { editorView: editorView, insertColumnButtonIndex: insertColumnButtonIndex, editorAnalyticsAPI: editorAnalyticsAPI, getEditorFeatureFlags: getEditorFeatureFlags, isTableScalingEnabled: isTableScalingEnabled, isCommentEditor: isCommentEditor } = this.props;
        if (typeof insertColumnButtonIndex !== 'undefined') {
            event.preventDefault();
            const { tableWithFixedColumnWidthsOption: tableWithFixedColumnWidthsOption = false } = getEditorFeatureFlags ? getEditorFeatureFlags() : {};
            const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (tableWithFixedColumnWidthsOption || isCommentEditor);
            const { state: state, dispatch: dispatch } = editorView;
            (0, $kfljr.insertColumnWithAnalytics)(this.props.api, editorAnalyticsAPI, isTableScalingEnabled, tableWithFixedColumnWidthsOption, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).BUTTON, insertColumnButtonIndex)(state, dispatch, editorView);
        }
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $4bda5264f9ad3bd0$var$_default_1 = (0, $fcCIH.default)($4bda5264f9ad3bd0$export$e2c2386b8045af89);
var $4bda5264f9ad3bd0$export$2e2bcd8739ae039 = $4bda5264f9ad3bd0$var$_default_1;

});
parcelRegister("a3TGz", function(module, exports) {
$parcel$export(module.exports, "default", () => $11e9ad5764a0895d$export$2e2bcd8739ae039);

var $014x6 = parcelRequire("014x6");

var $4Tw3G = parcelRequire("4Tw3G");
const $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_COLUMN_BUTTON = -((0, $4Tw3G.tableInsertColumnButtonSize) / 2);
const $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON = $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_COLUMN_BUTTON + (0, $014x6.akEditorTableNumberColumnWidth);
const $11e9ad5764a0895d$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG = (0, $4Tw3G.tableInsertColumnButtonOffset);
const $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG = -18;
const $11e9ad5764a0895d$var$VERTICAL_ALIGN_ROW_BUTTON = (0, $4Tw3G.tableInsertColumnButtonSize) / 2;
function $11e9ad5764a0895d$var$getRowOptions(index) {
    let defaultOptions = {
        alignX: 'left',
        alignY: 'bottom',
        offset: [
            0,
            $11e9ad5764a0895d$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    if (index === 0) defaultOptions = {
        ...defaultOptions,
        alignY: 'top',
        // The offset is the inverse the original, because is align top nop bottom.
        offset: [
            0,
            -$11e9ad5764a0895d$var$VERTICAL_ALIGN_ROW_BUTTON
        ]
    };
    return {
        ...defaultOptions,
        onPositionCalculated (position) {
            return {
                ...position,
                // Left position should be always the offset (To place in the correct position even if the table has overflow).
                left: $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_ROW_BUTTON_DRAG
            };
        }
    };
}
function $11e9ad5764a0895d$var$getColumnOptions(index, tableContainer, hasNumberedColumns, // Distance between the target cell top and table top, used when anchoring to a lower-row cell.
verticalOffsetCorrection = 0) {
    const options = {
        alignX: 'end',
        alignY: 'top',
        offset: [
            $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_COLUMN_BUTTON,
            $11e9ad5764a0895d$var$VERTICAL_ALIGN_COLUMN_BUTTON_DRAG
        ],
        // :: (position: PopupPosition) -> PopupPosition
        // Limit the InsertButton position to the table container
        // if the left position starts before it
        // we should always set the InsertButton on the start,
        // considering the offset from the first column
        onPositionCalculated (position) {
            // Move the popup upward whether the offset parent provides `top` or `bottom`.
            let verticalCorrection;
            if (verticalOffsetCorrection) {
                if (position.top !== undefined) verticalCorrection = {
                    top: position.top - verticalOffsetCorrection
                };
                else if (position.bottom !== undefined) verticalCorrection = {
                    bottom: position.bottom + verticalOffsetCorrection
                };
            }
            const { left: left } = position;
            if (!left) return {
                ...position,
                ...verticalCorrection
            };
            if (index === 0) return {
                ...position,
                ...verticalCorrection,
                left: hasNumberedColumns ? $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_NUMBERED_COLUMN_BUTTON : $11e9ad5764a0895d$var$HORIZONTAL_ALIGN_COLUMN_BUTTON
            };
            // Check if current position is greater than the available container width
            const rect = tableContainer ? tableContainer.getBoundingClientRect() : null;
            return {
                ...position,
                ...verticalCorrection,
                left: rect && left > rect.width ? rect.width : left
            };
        }
    };
    // We need to change the popup position when
    // the column index is zero
    if (index === 0) return {
        ...options,
        alignX: 'left',
        alignY: 'top'
    };
    return options;
}
function $11e9ad5764a0895d$var$getPopupOptions(direction, index, hasNumberedColumns, tableContainer, verticalOffsetCorrection = 0) {
    switch(direction){
        case 'column':
            return $11e9ad5764a0895d$var$getColumnOptions(index, tableContainer, hasNumberedColumns, verticalOffsetCorrection);
        case 'row':
            return $11e9ad5764a0895d$var$getRowOptions(index);
        default:
            return {};
    }
}
var $11e9ad5764a0895d$export$2e2bcd8739ae039 = $11e9ad5764a0895d$var$getPopupOptions;

});

parcelRegister("jaTcc", function(module, exports) {
$parcel$export(module.exports, "DragAndDropInsertButton", () => $07678e2a35a2f89f$export$5e513603d391e3de);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $jyPR0 = parcelRequire("jyPR0");

var $fcCIH = parcelRequire("fcCIH");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $jd8X7 = parcelRequire("jd8X7");

var $hCON4 = parcelRequire("hCON4");

var $014x6 = parcelRequire("014x6");

var $bcTS3 = parcelRequire("bcTS3");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");
const $07678e2a35a2f89f$var$getInsertLineHeight = (tableRef, hasStickyHeaders)=>{
    // The line gets height 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const LINE_OFFSET = 3;
    const ADDITIONAL_HEIGHT = hasStickyHeaders ? tableRef.getBoundingClientRect().top - (0, $jd8X7.tableMarginTop) * 3 - LINE_OFFSET : (0, $4Tw3G.tableToolbarSize) + LINE_OFFSET;
    return tableRef.offsetHeight + ADDITIONAL_HEIGHT;
};
const $07678e2a35a2f89f$var$getNumberColumnWidth = (tableRef)=>{
    const parent = (0, $hCON4.closestElement)(tableRef, `.${(0, $YREXK.TableCssClassName).TABLE_CONTAINER}`);
    if (parent) return parent.querySelector(`.${(0, $YREXK.TableCssClassName).NUMBERED_COLUMN}`) ? (0, $014x6.akEditorTableNumberColumnWidth) - 1 : 0;
    return 0;
};
const $07678e2a35a2f89f$var$getInsertLineWidth = (tableRef, isChromelessEditor)=>{
    // The line gets width 100% from the table,
    // but since we have an overflow on the left,
    // we should add an offset to make up for it.
    const DRAG_LINE_OFFSET = isChromelessEditor ? 14 : 6;
    const { parentElement: parentElement, offsetWidth: offsetWidth } = tableRef;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parentOffsetWidth = parentElement.offsetWidth;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { scrollLeft: scrollLeft } = parentElement;
    const diff = offsetWidth - parentOffsetWidth;
    return Math.min(offsetWidth, parentOffsetWidth - Math.max(scrollLeft - diff, 0)) + DRAG_LINE_OFFSET + $07678e2a35a2f89f$var$getNumberColumnWidth(tableRef);
};
const $07678e2a35a2f89f$var$tooltipMessageByType = (type)=>{
    return type === 'row' ? (0, $lqHJB.messages).insertRow : (0, $lqHJB.messages).insertColumn;
};
const $07678e2a35a2f89f$var$InsertButtonForDragAndDrop = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders, isChromelessEditor: isChromelessEditor })=>{
    const isRow = type === 'row';
    const content = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
            description: formatMessage(isRow ? (0, $lqHJB.messages).insertRowDrag : (0, $lqHJB.messages).insertColumnDrag),
            keymap: isRow ? (0, $eUtBU.addRowAfter) : (0, $eUtBU.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($jyPR0)))((0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER, {
                        [(0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW]: isRow && !isChromelessEditor,
                        [(0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_COLUMN]: !isRow,
                        [(0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_INNER_ROW_CHROMELESS]: isRow && isChromelessEditor
                    }),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: (0, $YREXK.TableCssClassName).CONTROLS_BUTTON_ICON,
                            width: "16",
                            height: "16",
                            viewBox: "0 0 16 16",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                                d: "M8 4C7.44771 4 7 4.44771 7 5V7H5C4.44771 7 4 7.44771 4 8C4 8.55229 4.44771 9 5 9H7V11C7 11.5523 7.44771 12 8 12C8.55229 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55229 12 8C12 7.44771 11.5523 7 11 7H9V5C9 4.44771 8.55229 4 8 4Z",
                                fill: "currentColor"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $07678e2a35a2f89f$var$getInsertLineWidth(tableRef, isChromelessEditor),
                        left: "var(--ds-space-150, 12px)"
                    } : {
                        height: $07678e2a35a2f89f$var$getInsertLineHeight(tableRef, hasStickyHeaders) - 8,
                        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                        top: '-3px'
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = isRow ? (0, $YREXK.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW : (0, $YREXK.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $YREXK.TableCssClassName).DRAG_CONTROLS_INSERT_BUTTON_WRAP} ${(0, $YREXK.TableCssClassName).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
const $07678e2a35a2f89f$export$5e513603d391e3de = (0, $fcCIH.default)($07678e2a35a2f89f$var$InsertButtonForDragAndDrop);
const $07678e2a35a2f89f$var$InsertButton = ({ onMouseDown: onMouseDown, tableRef: tableRef, type: type, intl: { formatMessage: formatMessage }, hasStickyHeaders: hasStickyHeaders })=>{
    const content = /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $eUtBU.ToolTipContent), {
            description: formatMessage($07678e2a35a2f89f$var$tooltipMessageByType(type)),
            keymap: type === 'row' ? (0, $eUtBU.addRowAfter) : (0, $eUtBU.addColumnAfter)
        }),
        position: "top",
        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    className: (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON_INNER,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("button", {
                        type: "button",
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON,
                        onMouseDown: onMouseDown,
                        "aria-label": formatMessage($07678e2a35a2f89f$var$tooltipMessageByType(type)),
                        children: /*#__PURE__*/ (0, $3LM7S.jsx)("svg", {
                            className: (0, $YREXK.TableCssClassName).CONTROLS_BUTTON_ICON,
                            children: /*#__PURE__*/ (0, $3LM7S.jsx)("path", {
                                d: "M10 4a1 1 0 0 1 1 1v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H5a1 1 0 1 1 0-2h4V5a1 1 0 0 1 1-1z",
                                fill: "currentColor",
                                fillRule: "evenodd"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $YREXK.TableCssClassName).CONTROLS_INSERT_LINE,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: type === 'row' ? {
                        width: $07678e2a35a2f89f$var$getInsertLineWidth(tableRef)
                    } : {
                        height: $07678e2a35a2f89f$var$getInsertLineHeight(tableRef, hasStickyHeaders)
                    }
                })
            ]
        })
    });
    const floatingButtonClassName = type === 'column' ? (0, $YREXK.TableCssClassName).CONTROLS_FLOATING_BUTTON_COLUMN : (0, $YREXK.TableCssClassName).CONTROLS_FLOATING_BUTTON_ROW;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
        className: floatingButtonClassName,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $YREXK.TableCssClassName).CONTROLS_INSERT_BUTTON_WRAP} ${(0, $YREXK.TableCssClassName).CONTROLS_INSERT_ROW}`,
            children: content
        })
    }));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $07678e2a35a2f89f$var$_default_1 = (0, $fcCIH.default)($07678e2a35a2f89f$var$InsertButton);
var $07678e2a35a2f89f$export$2e2bcd8739ae039 = $07678e2a35a2f89f$var$_default_1;

});


parcelRegister("e2Waz", function(module, exports) {
$parcel$export(module.exports, "default", () => $04064d5961e9ca6f$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dXHAJ = parcelRequire("dXHAJ");

var $dogcz = parcelRequire("dogcz");

var $8F4kC = parcelRequire("8F4kC");

var $9oAqi = parcelRequire("9oAqi");

var $014x6 = parcelRequire("014x6");

var $ev7OZ = parcelRequire("ev7OZ");

var $kD3Xq = parcelRequire("kD3Xq");

var $bhL7r = parcelRequire("bhL7r");

var $gzpzh = parcelRequire("gzpzh");

var $YREXK = parcelRequire("YREXK");

var $4Tw3G = parcelRequire("4Tw3G");

var $2NTcm = parcelRequire("2NTcm");

var $izzuA = parcelRequire("izzuA");

var $hkEC0 = parcelRequire("hkEC0");

var $e3ijL = parcelRequire("e3ijL");
const $04064d5961e9ca6f$var$PopupWithListeners = (0, $8F4kC.default)((0, $dXHAJ.default));
// Defer drag-handle clicks to the drag handle's own toggle/select handlers — those own
// the open/switch/close semantics for moving between rows/columns.
const $04064d5961e9ca6f$var$DRAG_HANDLE_CONTROLS_SELECTOR = `.${(0, $YREXK.TableCssClassName).DRAG_ROW_CONTROLS}, .${(0, $YREXK.TableCssClassName).DRAG_COLUMN_CONTROLS}`;
const $04064d5961e9ca6f$var$NESTED_DROPDOWN_SELECTOR = '[data-toolbar-nested-dropdown-menu]';
// Marks the menu subtree that ToolbarKeyboardNavigationProvider scopes its
// keyboard handling to. The provider only reacts to events whose target sits
// inside this selector.
const $04064d5961e9ca6f$var$TABLE_MENU_NAV_SELECTOR = '[data-table-drag-menu-nav="true"]';
const $04064d5961e9ca6f$var$TABLE_MENU_OFFSET = (0, $4Tw3G.dragTableInsertColumnButtonSize) + 4;
const $04064d5961e9ca6f$var$POPUP_OFFSET = [
    $04064d5961e9ca6f$var$TABLE_MENU_OFFSET,
    0
];
/**
 * Row and column menu for table.
 */ const $04064d5961e9ca6f$var$FloatingTableMenu = ({ api: api, boundariesElement: boundariesElement, editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, stickyHeaders: stickyHeaders, tableWrapper: tableWrapper, targetCellPosition: targetCellPosition })=>{
    const { activeTableMenu: activeTableMenu } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            activeTableMenu: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.activeTableMenu
        };
    });
    const isDragMenuOpen = (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'row' || (activeTableMenu === null || activeTableMenu === void 0 ? void 0 : activeTableMenu.type) === 'column';
    const dragMenuDirection = isDragMenuOpen ? activeTableMenu.type : undefined;
    const isOpenedByKeyboard = isDragMenuOpen && activeTableMenu.openedBy === 'keyboard';
    const popupContentRef = (0, $fc4bM.useRef)(null);
    const setOutsideClickTargetRef = (0, $fc4bM.useContext)((0, $dogcz.OutsideClickTargetRefContext));
    const navWrapperRef = (0, $fc4bM.useRef)(null);
    const handlePopupRef = (0, $fc4bM.useCallback)((el)=>{
        popupContentRef.current = el;
        setOutsideClickTargetRef === null || setOutsideClickTargetRef === void 0 || setOutsideClickTargetRef(el);
    }, [
        setOutsideClickTargetRef
    ]);
    const returnFocusToDragHandle = (0, $fc4bM.useCallback)(()=>{
        // Match legacy DragMenu's closeMenu('handle') behaviour.
        const handleId = dragMenuDirection === 'row' ? '#drag-handle-button-row' : '#drag-handle-button-column';
        const handle = document.querySelector(handleId);
        handle === null || handle === void 0 || handle.focus();
    }, [
        dragMenuDirection
    ]);
    const focusFirstMenuItem = (0, $fc4bM.useCallback)(()=>{
        const root = navWrapperRef.current;
        if (!root) return;
        const firstItem = root.querySelector('[role="menuitem"]:not([disabled]), [role="menuitemcheckbox"]:not([disabled]), [role="menuitemradio"]:not([disabled]), button:not([disabled])');
        firstItem === null || firstItem === void 0 || firstItem.focus();
    }, []);
    // Focus the first menu item when the menu opens via keyboard (Enter/Space on
    // the drag handle). Mouse-opened menus leave focus where the user clicked.
    const setNavWrapperRef = (0, $fc4bM.useCallback)((el)=>{
        navWrapperRef.current = el;
        if (el && isOpenedByKeyboard) // rAF allows the popup to finish positioning before focusing.
        requestAnimationFrame(()=>{
            focusFirstMenuItem();
        });
    }, [
        focusFirstMenuItem,
        isOpenedByKeyboard
    ]);
    const handleKeyboardFocus = (0, $fc4bM.useCallback)((_event)=>{
        focusFirstMenuItem();
    }, [
        focusFirstMenuItem
    ]);
    const handleEscape = (0, $fc4bM.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        returnFocusToDragHandle();
    }, [
        api,
        returnFocusToDragHandle
    ]);
    // Memoize the editor DOM reference so the provider doesn't re-bind listeners
    // on every render (the provider depends on `dom` in its effect's deps).
    const editorDom = (0, $fc4bM.useMemo)(()=>editorView.dom instanceof HTMLElement ? editorView.dom : undefined, [
        editorView.dom
    ]);
    // The drag menu is opened by interacting with the drag handle directly, not
    // by a global page-level shortcut.
    const isShortcutToFocusToolbar = (0, $fc4bM.useCallback)(()=>false, []);
    const handleClickOutside = (0, $fc4bM.useCallback)((event)=>{
        var _popupContentRef$curr, _api$table;
        const target = event.target;
        // Ignore clicks handled by this popup, drag handles, or nested portalled
        // dropdowns so those controls can manage their own open/close behavior.
        if (target instanceof Node && (_popupContentRef$curr = popupContentRef.current) !== null && _popupContentRef$curr !== void 0 && _popupContentRef$curr.contains(target) || target instanceof Element && (target.closest($04064d5961e9ca6f$var$DRAG_HANDLE_CONTROLS_SELECTOR) || target.closest($04064d5961e9ca6f$var$NESTED_DROPDOWN_SELECTOR))) return;
        // Another table menu (e.g. the cell menu) may have just been opened by this same click.
        // Its React handler runs before this document listener, so the active menu is no longer a
        // row/column menu — don't clobber the newly opened menu back to 'none'.
        const currentActiveTableMenu = api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 || (_api$table = _api$table.sharedState.currentState()) === null || _api$table === void 0 ? void 0 : _api$table.activeTableMenu;
        if ((currentActiveTableMenu === null || currentActiveTableMenu === void 0 ? void 0 : currentActiveTableMenu.type) !== 'row' && (currentActiveTableMenu === null || currentActiveTableMenu === void 0 ? void 0 : currentActiveTableMenu.type) !== 'column') return;
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
    }, [
        api
    ]);
    if (!isDragMenuOpen || !targetCellPosition || editorView.state.doc.nodeSize <= targetCellPosition || (0, $kD3Xq.isTableSelected)(editorView.state.selection)) return null;
    const inStickyMode = (stickyHeaders === null || stickyHeaders === void 0 ? void 0 : stickyHeaders.sticky) || (tableWrapper === null || tableWrapper === void 0 ? void 0 : tableWrapper.classList.contains((0, $YREXK.TableCssClassName).TABLE_NODE_WRAPPER_NO_OVERFLOW));
    const targetHandleRef = dragMenuDirection === 'row' ? document.querySelector('#drag-handle-button-row') : document.querySelector('#drag-handle-button-column');
    if (!targetHandleRef || !(editorView.state.selection instanceof (0, $ev7OZ.CellSelection))) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)($04064d5961e9ca6f$var$PopupWithListeners, {
        alignX: dragMenuDirection === 'row' ? 'right' : undefined,
        alignY: dragMenuDirection === 'row' ? 'start' : undefined,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        target: targetHandleRef,
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        fitWidth: (0, $hkEC0.TABLE_MENU_WIDTH),
        fitHeight: (0, $4Tw3G.tablePopupMenuFitHeight),
        // z-index value below is to ensure that this menu is above other floating menu
        // in table, but below floating dialogs like typeaheads, pickers, etc.
        // In sticky mode, we want to show the menu above the sticky header
        zIndex: inStickyMode ? (0, $014x6.akEditorFloatingDialogZIndex) : (0, $014x6.akEditorFloatingOverlapPanelZIndex),
        forcePlacement: true,
        preventOverflow: dragMenuDirection === 'row',
        offset: $04064d5961e9ca6f$var$POPUP_OFFSET,
        stick: true,
        handleClickOutside: handleClickOutside,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
            ref: handlePopupRef,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bhL7r.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: $04064d5961e9ca6f$var$TABLE_MENU_NAV_SELECTOR,
                dom: editorDom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleFocus: handleKeyboardFocus,
                handleEscape: handleEscape,
                children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    "data-table-drag-menu-nav": "true",
                    ref: setNavWrapperRef,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $e3ijL.TableMenu), {
                        api: api,
                        editorView: editorView,
                        surface: dragMenuDirection === 'row' ? (0, $izzuA.ROW_MENU) : (0, $2NTcm.COLUMN_MENU)
                    })
                })
            })
        })
    });
};
$04064d5961e9ca6f$var$FloatingTableMenu.displayName = 'FloatingTableMenu';
var $04064d5961e9ca6f$export$2e2bcd8739ae039 = $04064d5961e9ca6f$var$FloatingTableMenu;

});

parcelRegister("iZvMJ", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarLabel", () => $cce5c1f34a3cbcc0$export$a60e1be3b6001ff3);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $dXHAJ = parcelRequire("dXHAJ");
const $cce5c1f34a3cbcc0$export$a60e1be3b6001ff3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).memo((props)=>{
    const { target: target, content: content, alignX: alignX, alignY: alignY, zIndex: zIndex, forcePlacement: forcePlacement, stick: stick, offset: offset } = props;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dXHAJ.default), {
        target: target,
        alignX: alignX,
        alignY: alignY,
        zIndex: zIndex,
        stick: stick,
        forcePlacement: forcePlacement,
        offset: offset,
        children: content
    });
});

});

parcelRegister("9dGzO", function(module, exports) {
$parcel$export(module.exports, "GlobalStylesWrapper", () => $f7bf322a881ce016$export$cc5403d58ddfa812);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ /* eslint-disable @typescript-eslint/consistent-type-imports, @atlaskit/ui-styling-standard/no-global-styles, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic */ 
var $jctmk = parcelRequire("jctmk");

var $9oAqi = parcelRequire("9oAqi");

var $93QoQ = parcelRequire("93QoQ");
const $f7bf322a881ce016$export$cc5403d58ddfa812 = ({ featureFlags: featureFlags, api: api })=>{
    const { mode: mode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'editorViewMode'
    ], (states)=>{
        var _states$editorViewMod;
        return {
            mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
        };
    });
    const isLivePageViewMode = mode === 'view';
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $jctmk.Global), {
        styles: (0, $93QoQ.tableStyles)({
            featureFlags: featureFlags,
            isDragAndDropEnabled: !isLivePageViewMode
        })
    });
};

});

parcelRegister("8xaQS", function(module, exports) {
$parcel$export(module.exports, "SizeSelector", () => $a80ac4dcb0f22ee4$export$800b7d81026538f2);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $jctmk = parcelRequire("jctmk");

var $8jcNl = parcelRequire("8jcNl");

var $lcU8V = parcelRequire("lcU8V");
const $a80ac4dcb0f22ee4$var$DEFAULT_TABLE_SELECTOR_COLS = 3;
const $a80ac4dcb0f22ee4$var$DEFAULT_TABLE_SELECTOR_ROWS = 3;
const $a80ac4dcb0f22ee4$export$800b7d81026538f2 = ({ api: api, target: target, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    const closeSelectorPopup = (0, $fc4bM.useCallback)(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $lcU8V.pluginKey), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onSelection = (0, $fc4bM.useCallback)((rowsCount, colsCount)=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            api === null || api === void 0 || api.table.commands.insertTableWithSize(rowsCount, colsCount)({
                tr: tr
            });
            tr.setMeta((0, $lcU8V.pluginKey), {
                isSelectorOpen: false
            });
            return tr;
        });
    }, [
        api
    ]);
    const onUnmount = ()=>{
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $jctmk.jsx)((0, $8jcNl.TableSelectorPopup), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        defaultSize: {
            row: $a80ac4dcb0f22ee4$var$DEFAULT_TABLE_SELECTOR_ROWS,
            col: $a80ac4dcb0f22ee4$var$DEFAULT_TABLE_SELECTOR_COLS
        },
        target: target,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        popupsBoundariesElement: popupsBoundariesElement,
        isOpenedByKeyboard: true,
        handleClickOutside: closeSelectorPopup,
        handleEscapeKeydown: closeSelectorPopup
    });
};

});

parcelRegister("8qPMo", function(module, exports) {
$parcel$export(module.exports, "FullWidthDisplay", () => $5aebeed78e1c40ce$export$8bde7db5b2aba7d);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $lqHJB = parcelRequire("lqHJB");

var $5a4EU = parcelRequire("5a4EU");

var $lgMZ2 = parcelRequire("lgMZ2");

var $kig2V = parcelRequire("kig2V");
const $5aebeed78e1c40ce$var$tableFullWidthLabelWrapperStyles = (0, $kig2V.xcss)({
    height: "var(--ds-space-400, 32px)",
    display: 'flex',
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: 'radius.small',
    boxShadow: 'elevation.shadow.overlay',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    boxSizing: 'border-box',
    alignItems: 'center'
});
const $5aebeed78e1c40ce$var$tableFullWidthLabelStyles = (0, $kig2V.xcss)({
    marginLeft: 'space.100',
    marginRight: 'space.100',
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $5aebeed78e1c40ce$export$8bde7db5b2aba7d = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5a4EU.Box), {
        xcss: $5aebeed78e1c40ce$var$tableFullWidthLabelWrapperStyles,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $lgMZ2.Inline), {
            xcss: $5aebeed78e1c40ce$var$tableFullWidthLabelStyles,
            children: formatMessage((0, $lqHJB.messages).fullWidthLabel)
        })
    });
};

});


parcelRegister("5afEq", function(module, exports) {
$parcel$export(module.exports, "getTableQuickInsertComponents", () => $1818fa4d34e2c41a$export$660c08bcfbc0be86);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $eUtBU = parcelRequire("eUtBU");

var $cT0LQ = parcelRequire("cT0LQ");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $gdtCs = parcelRequire("gdtCs");
const $1818fa4d34e2c41a$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM3.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIZ.png'
};
const $1818fa4d34e2c41a$export$660c08bcfbc0be86 = ({ api: api, isTableSelectorEnabled: isTableSelectorEnabled, options: options })=>[
        {
            ...(0, $hI3gt.TABLE_MENU_ITEM),
            parents: [
                {
                    ...(0, $hI3gt.STRUCTURE_SECTION),
                    rank: (0, $4jXgF.STRUCTURE_SECTION_RANK)[(0, $hI3gt.TABLE_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).tableDescription),
                    keywords: [
                        'cell',
                        'table'
                    ],
                    shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.toggleTable)),
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).table)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $gdtCs.TableQuickInsertMenuItem), {
                    api: api,
                    isTableSelectorEnabled: isTableSelectorEnabled,
                    options: options,
                    previewImageUrls: $1818fa4d34e2c41a$var$previewImageUrls
                })
        }
    ];

});
parcelRegister("gdtCs", function(module, exports) {
$parcel$export(module.exports, "TableQuickInsertMenuItem", () => $4d628daa12070373$export$3575ce8fa80d28b5);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $eUtBU = parcelRequire("eUtBU");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $3M4Vk = parcelRequire("3M4Vk");

var $fFppY = parcelRequire("fFppY");

var $dfd1U = parcelRequire("dfd1U");
const $4d628daa12070373$export$3575ce8fa80d28b5 = ({ api: api, isTableSelectorEnabled: isTableSelectorEnabled, options: options, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const preview = (0, $fc4bM.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $3M4Vk.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $fc4bM.useCallback)(({ editorView: editorView, insert: insert, source: source })=>(0, $dfd1U.insertTableFromQuickInsert)({
            api: api,
            inputMethod: source,
            insert: insert,
            isTableSelectorEnabled: isTableSelectorEnabled,
            options: options,
            state: editorView.state
        }), [
        api,
        isTableSelectorEnabled,
        options
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).tableDescription),
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fFppY))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.toggleTable)),
        title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).table)
    });
};

});
parcelRegister("dfd1U", function(module, exports) {
$parcel$export(module.exports, "insertTableFromQuickInsert", () => $5f220493aa39cfdb$export$4c3a31864f81dace);

var $3LeME = parcelRequire("3LeME");

var $5DGsr = parcelRequire("5DGsr");
var $89pmn = parcelRequire("89pmn");

var $a4TQr = parcelRequire("a4TQr");

var $aEmSo = parcelRequire("aEmSo");

var $lcU8V = parcelRequire("lcU8V");

var $l1ZbO = parcelRequire("l1ZbO");
const $5f220493aa39cfdb$export$4c3a31864f81dace = ({ api: api, inputMethod: inputMethod, insert: insert, isTableSelectorEnabled: isTableSelectorEnabled, options: options, state: state })=>{
    var _api$table, _api$analytics, _tr$selection$$from$n;
    if (isTableSelectorEnabled) {
        const tr = insert('');
        tr.setMeta((0, $lcU8V.pluginKey), {
            isSelectorOpen: true
        });
        return tr;
    }
    const tableState = api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 ? void 0 : _api$table.sharedState.currentState();
    const tableNodeProps = {
        isTableScalingEnabled: options.isTableScalingEnabled,
        isTableAlignmentEnabled: options.tableOptions.allowTableAlignment,
        isFullWidthModeEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isFullWidthModeEnabled,
        isMaxWidthModeEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isMaxWidthModeEnabled,
        isCommentEditor: options.isCommentEditor,
        isChromelessEditor: options.isChromelessEditor,
        isTableResizingEnabled: options.tableOptions.allowTableResizing
    };
    let tableNode = (0, $l1ZbO.createTableWithWidth)(tableNodeProps)(state.schema);
    let { tr: tr } = state;
    if ((0, $a4TQr.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) && options.tableOptions.allowNestedTables) {
        if ((0, $5DGsr.getParentOfTypeCount)(state.schema.nodes.table)(state.selection.$from) > 1) {
            const positionAfterTopTable = (0, $89pmn.getPositionAfterTopParentNodeOfType)(state.schema.nodes.table)(state.selection.$from);
            tr = (0, $a4TQr.safeInsert)(tableNode, positionAfterTopTable)(tr);
            tr.scrollIntoView();
        } else {
            tableNode = (0, $l1ZbO.createTableWithWidth)({
                ...tableNodeProps,
                isNestedTable: true
            })(state.schema);
            tr = insert(tableNode);
        }
    } else tr = insert(tableNode);
    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
        action: (0, $3LeME.ACTION).INSERTED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).TABLE,
        attributes: {
            inputMethod: inputMethod,
            localId: tableNode.attrs.localId,
            ...(0, $aEmSo.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                parentNode: (_tr$selection$$from$n = tr.selection.$from.node(-1)) === null || _tr$selection$$from$n === void 0 ? void 0 : _tr$selection$$from$n.type.name
            } : {}
        },
        eventType: (0, $3LeME.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};

});



parcelRegister("659mW", function(module, exports) {
$parcel$export(module.exports, "getTableMenuComponents", () => $43420e779b18ec60$export$efabff7be90ed58a);

var $1rlnc = parcelRequire("1rlnc");

var $jtp3Q = parcelRequire("jtp3Q");

var $3rxFa = parcelRequire("3rxFa");

var $1RMdC = parcelRequire("1RMdC");
const $43420e779b18ec60$export$efabff7be90ed58a = (params)=>[
        ...(0, $3rxFa.getRowMenuComponents)(params),
        ...(0, $jtp3Q.getColumnMenuComponents)(params),
        ...(0, $1rlnc.getCellMenuComponents)(params),
        ...(0, $1RMdC.getSharedItems)(params)
    ];

});
parcelRegister("1rlnc", function(module, exports) {
$parcel$export(module.exports, "getCellMenuComponents", () => $1476b2d9c1a08670$export$2dfd78068db84eff);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $lqHJB = parcelRequire("lqHJB");

var $l4q07 = parcelRequire("l4q07");

var $jwcFt = parcelRequire("jwcFt");

var $1i5T8 = parcelRequire("1i5T8");

var $9wVRW = parcelRequire("9wVRW");

var $baXWK = parcelRequire("baXWK");

var $2O7MF = parcelRequire("2O7MF");

var $kQpAU = parcelRequire("kQpAU");

var $5VLwn = parcelRequire("5VLwn");

var $9VL3d = parcelRequire("9VL3d");
const $1476b2d9c1a08670$export$2dfd78068db84eff = ({ api: api })=>[
        // Merge/Split cells live in the Add section (alongside the shared add/distribute
        // items); the danger section also contains the shared Delete column/row items.
        // --- Menu surface ---
        {
            type: (0, $9VL3d.CELL_MENU).type,
            key: (0, $9VL3d.CELL_MENU).key
        },
        // --- Main action section (Background color, Vertical align) ---
        {
            type: (0, $9VL3d.CELL_ACTION_SECTION).type,
            key: (0, $9VL3d.CELL_ACTION_SECTION).key,
            parents: [
                {
                    type: (0, $9VL3d.CELL_MENU).type,
                    key: (0, $9VL3d.CELL_MENU).key,
                    rank: (0, $9VL3d.CELL_MENU_RANK)[(0, $9VL3d.CELL_ACTION_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    children: props.children
                })
        },
        {
            type: (0, $9VL3d.VERTICAL_ALIGN_MENU).type,
            key: (0, $9VL3d.VERTICAL_ALIGN_MENU).key,
            parents: [
                {
                    type: (0, $9VL3d.CELL_ACTION_SECTION).type,
                    key: (0, $9VL3d.CELL_ACTION_SECTION).key,
                    rank: (0, $9VL3d.CELL_ACTION_SECTION_RANK)[(0, $9VL3d.VERTICAL_ALIGN_MENU).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $5VLwn.VerticalAlignNestedMenu), {
                    children: props.children
                })
        },
        {
            type: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).type,
            key: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $9VL3d.VERTICAL_ALIGN_MENU).type,
                    key: (0, $9VL3d.VERTICAL_ALIGN_MENU).key,
                    rank: (0, $9VL3d.VERTICAL_ALIGN_MENU_RANK)[(0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    children: props.children
                })
        },
        {
            type: (0, $9VL3d.VERTICAL_ALIGN_TOP_ITEM).type,
            key: (0, $9VL3d.VERTICAL_ALIGN_TOP_ITEM).key,
            parents: [
                {
                    type: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).type,
                    key: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).key,
                    rank: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION_RANK)[(0, $9VL3d.VERTICAL_ALIGN_TOP_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $kQpAU.VerticalAlignDropdownItem), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($9wVRW))),
                    label: (0, $lqHJB.messages).cellAlignmentTop,
                    value: "top"
                })
        },
        {
            type: (0, $9VL3d.VERTICAL_ALIGN_MIDDLE_ITEM).type,
            key: (0, $9VL3d.VERTICAL_ALIGN_MIDDLE_ITEM).key,
            parents: [
                {
                    type: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).type,
                    key: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).key,
                    rank: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION_RANK)[(0, $9VL3d.VERTICAL_ALIGN_MIDDLE_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $kQpAU.VerticalAlignDropdownItem), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($1i5T8))),
                    label: (0, $lqHJB.messages).cellAlignmentMiddle,
                    value: "middle"
                })
        },
        {
            type: (0, $9VL3d.VERTICAL_ALIGN_BOTTOM_ITEM).type,
            key: (0, $9VL3d.VERTICAL_ALIGN_BOTTOM_ITEM).key,
            parents: [
                {
                    type: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).type,
                    key: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION).key,
                    rank: (0, $9VL3d.VERTICAL_ALIGN_MENU_SECTION_RANK)[(0, $9VL3d.VERTICAL_ALIGN_BOTTOM_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $kQpAU.VerticalAlignDropdownItem), {
                    api: api,
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jwcFt))),
                    label: (0, $lqHJB.messages).cellAlignmentBottom,
                    value: "bottom"
                })
        },
        // --- Add / Move section (shared Add column right / Add row below / Distribute
        // columns are registered in `../shared/getSharedItems`; Merge/Split cells below) ---
        {
            type: (0, $9VL3d.CELL_ADD_SECTION).type,
            key: (0, $9VL3d.CELL_ADD_SECTION).key,
            parents: [
                {
                    type: (0, $9VL3d.CELL_MENU).type,
                    key: (0, $9VL3d.CELL_MENU).key,
                    rank: (0, $9VL3d.CELL_MENU_RANK)[(0, $9VL3d.CELL_ADD_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        },
        {
            type: (0, $9VL3d.MERGE_CELLS_ITEM).type,
            key: (0, $9VL3d.MERGE_CELLS_ITEM).key,
            parents: [
                {
                    type: (0, $9VL3d.CELL_ADD_SECTION).type,
                    key: (0, $9VL3d.CELL_ADD_SECTION).key,
                    rank: (0, $9VL3d.CELL_ADD_SECTION_RANK)[(0, $9VL3d.MERGE_CELLS_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $baXWK.MergeCellsItem), {
                    api: api
                })
        },
        {
            type: (0, $9VL3d.SPLIT_CELL_ITEM).type,
            key: (0, $9VL3d.SPLIT_CELL_ITEM).key,
            parents: [
                {
                    type: (0, $9VL3d.CELL_ADD_SECTION).type,
                    key: (0, $9VL3d.CELL_ADD_SECTION).key,
                    rank: (0, $9VL3d.CELL_ADD_SECTION_RANK)[(0, $9VL3d.SPLIT_CELL_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $2O7MF.SplitCellItem), {
                    api: api
                })
        },
        // --- Danger section (Clear cell + shared Delete column / Delete row) ---
        {
            type: (0, $9VL3d.CELL_DANGER_SECTION).type,
            key: (0, $9VL3d.CELL_DANGER_SECTION).key,
            parents: [
                {
                    type: (0, $9VL3d.CELL_MENU).type,
                    key: (0, $9VL3d.CELL_MENU).key,
                    rank: (0, $9VL3d.CELL_MENU_RANK)[(0, $9VL3d.CELL_DANGER_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        }
    ];

});
parcelRegister("baXWK", function(module, exports) {
$parcel$export(module.exports, "MergeCellsItem", () => $dc94af2078934a48$export$860c28593c1aa9bb);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $cfqPz = parcelRequire("cfqPz");

var $7otWv = parcelRequire("7otWv");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
/**
 * Merge cells is only visible when the active selection can actually be merged
 * (multi-cell, non-overlapping).
 */ const $dc94af2078934a48$var$shouldShowMergeCells = (tableMenuContext)=>(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.canMergeCells) === true;
const $dc94af2078934a48$export$860c28593c1aa9bb = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        (0, $kfljr.mergeCellsWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!$dc94af2078934a48$var$shouldShowMergeCells(tableMenuContext)) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cfqPz))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $lqHJB.messages).mergeCells)
    });
};

});

parcelRegister("2O7MF", function(module, exports) {
$parcel$export(module.exports, "SplitCellItem", () => $a4aaa1ef867698e2$export$d79dfb0d5c37e690);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $ekgS0 = parcelRequire("ekgS0");

var $7otWv = parcelRequire("7otWv");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
/**
 * Split cell is only visible when the active selection sits in a cell whose
 * `rowspan` or `colspan` is greater than one.
 */ const $a4aaa1ef867698e2$var$shouldShowSplitCell = (tableMenuContext)=>(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.canSplitCell) === true;
const $a4aaa1ef867698e2$export$d79dfb0d5c37e690 = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        (0, $kfljr.splitCellWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).CONTEXT_MENU)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!$a4aaa1ef867698e2$var$shouldShowSplitCell(tableMenuContext)) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ekgS0))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $lqHJB.messages).splitCell)
    });
};

});

parcelRegister("kQpAU", function(module, exports) {
$parcel$export(module.exports, "VerticalAlignDropdownItem", () => $c06dd7cb245a602d$export$d49b4cfa8d7eb46c);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $7otWv = parcelRequire("7otWv");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $4GJqd = parcelRequire("4GJqd");

var $gB626 = parcelRequire("gB626");

var $6iHY1 = parcelRequire("6iHY1");
const $c06dd7cb245a602d$export$d49b4cfa8d7eb46c = ({ api: api, icon: Icon, label: label, value: value })=>{
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedValign = (0, $fc4bM.useMemo)(()=>(0, $6iHY1.getSelectedCellValign)(editorView), [
        editorView
    ]);
    const handleClick = (0, $fc4bM.useCallback)(()=>{
        if (!editorView || !api) return;
        const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(editorView.state);
        api.core.actions.execute(({ tr: tr })=>{
            var _api$analytics;
            (0, $kfljr.setCellVerticalAlignmentWithAnalytics)((_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, value, targetCellPosition)({
                tr: tr
            });
            (0, $gzpzh.closeActiveTableMenu)(api)({
                tr: tr
            });
            return tr;
        });
        api.core.actions.focus();
    }, [
        api,
        editorView,
        value
    ]);
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)(Icon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        isSelected: selectedValign === value,
        onClick: handleClick,
        role: "menuitemradio",
        children: formatMessage(label)
    });
};

});
parcelRegister("6iHY1", function(module, exports) {
$parcel$export(module.exports, "getSelectedCellValign", () => $c489730d4668a958$export$a5cc539f15f26080);

var $4GJqd = parcelRequire("4GJqd");
const $c489730d4668a958$var$getNormalizedValign = (valign)=>valign ?? 'top';
const $c489730d4668a958$export$a5cc539f15f26080 = (editorView)=>{
    if (!editorView) return 'top';
    const { state: state } = editorView;
    const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(state);
    const cell = typeof targetCellPosition === 'number' ? state.doc.nodeAt(targetCellPosition) : undefined;
    return $c489730d4668a958$var$getNormalizedValign(cell === null || cell === void 0 ? void 0 : cell.attrs.valign);
};

});


parcelRegister("5VLwn", function(module, exports) {
$parcel$export(module.exports, "VerticalAlignNestedMenu", () => $9e126e27fc2bce7b$export$711d24ebe8961c4c);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $lqHJB = parcelRequire("lqHJB");

var $ar15H = parcelRequire("ar15H");

var $i6Zpo = parcelRequire("i6Zpo");

var $jwcFt = parcelRequire("jwcFt");

var $1i5T8 = parcelRequire("1i5T8");

var $9wVRW = parcelRequire("9wVRW");

var $gB626 = parcelRequire("gB626");

var $6iHY1 = parcelRequire("6iHY1");
const $9e126e27fc2bce7b$var$getTriggerIcon = (valign)=>{
    switch(valign){
        case 'middle':
            return 0, (/*@__PURE__*/$parcel$interopDefault($1i5T8));
        case 'bottom':
            return 0, (/*@__PURE__*/$parcel$interopDefault($jwcFt));
        case 'top':
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9wVRW));
    }
};
const $9e126e27fc2bce7b$export$711d24ebe8961c4c = ({ children: children })=>{
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedValign = (0, $fc4bM.useMemo)(()=>(0, $6iHY1.getSelectedCellValign)(editorView), [
        editorView
    ]);
    const TriggerIcon = $9e126e27fc2bce7b$var$getTriggerIcon(selectedValign);
    if (!editorView) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i6Zpo.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)(TriggerIcon, {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ar15H.NestedDropdownRightIcon), {
            label: "",
            size: "small"
        }),
        text: formatMessage((0, $lqHJB.messages).cellAlignment),
        children: children
    });
};

});


parcelRegister("jtp3Q", function(module, exports) {
$parcel$export(module.exports, "getColumnMenuComponents", () => $e8d83aa4f9397ff1$export$eca8f3a6aa996ce2);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $l4q07 = parcelRequire("l4q07");

var $JHme2 = parcelRequire("JHme2");

var $fGOMh = parcelRequire("fGOMh");

var $7vfKG = parcelRequire("7vfKG");

var $jgg2v = parcelRequire("jgg2v");

var $ciXDv = parcelRequire("ciXDv");

var $9OWFw = parcelRequire("9OWFw");

var $jK2yv = parcelRequire("jK2yv");

var $gd56Y = parcelRequire("gd56Y");

var $2NTcm = parcelRequire("2NTcm");
const $e8d83aa4f9397ff1$export$eca8f3a6aa996ce2 = ({ api: api })=>[
        // AddColumnRightItem/DistributeColumnsItem/DeleteColumnItem are registered in
        // `../shared/getSharedItems` (shared with the cell menu), so they are omitted here.
        // --- Menu surface ---
        {
            type: (0, $2NTcm.COLUMN_MENU).type,
            key: (0, $2NTcm.COLUMN_MENU).key
        },
        // --- Toggle section (Header column) ---
        {
            type: (0, $2NTcm.COLUMN_TOGGLE_SECTION).type,
            key: (0, $2NTcm.COLUMN_TOGGLE_SECTION).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_MENU).type,
                    key: (0, $2NTcm.COLUMN_MENU).key,
                    rank: (0, $2NTcm.COLUMN_SECTION_RANK)[(0, $2NTcm.COLUMN_TOGGLE_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vfKG.ColumnToggleSection), {
                    api: api,
                    children: props.children
                })
        },
        {
            type: (0, $2NTcm.HEADER_COLUMN_TOGGLE_ITEM).type,
            key: (0, $2NTcm.HEADER_COLUMN_TOGGLE_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_TOGGLE_SECTION).type,
                    key: (0, $2NTcm.COLUMN_TOGGLE_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_TOGGLE_SECTION_RANK)[(0, $2NTcm.HEADER_COLUMN_TOGGLE_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $jgg2v.HeaderColumnToggleItem), {
                    api: api
                })
        },
        // --- Background color section ---
        {
            type: (0, $2NTcm.COLUMN_BACKGROUND_SECTION).type,
            key: (0, $2NTcm.COLUMN_BACKGROUND_SECTION).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_MENU).type,
                    key: (0, $2NTcm.COLUMN_MENU).key,
                    rank: (0, $2NTcm.COLUMN_SECTION_RANK)[(0, $2NTcm.COLUMN_BACKGROUND_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $fGOMh.ColumnBackgroundSection), {
                    api: api,
                    children: props.children
                })
        },
        // --- Sort section ---
        {
            type: (0, $2NTcm.COLUMN_SORT_SECTION).type,
            key: (0, $2NTcm.COLUMN_SORT_SECTION).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_MENU).type,
                    key: (0, $2NTcm.COLUMN_MENU).key,
                    rank: (0, $2NTcm.COLUMN_SECTION_RANK)[(0, $2NTcm.COLUMN_SORT_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        },
        {
            type: (0, $2NTcm.SORT_INCREASING_ITEM).type,
            key: (0, $2NTcm.SORT_INCREASING_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_SORT_SECTION).type,
                    key: (0, $2NTcm.COLUMN_SORT_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_SORT_SECTION_RANK)[(0, $2NTcm.SORT_INCREASING_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $gd56Y.SortIncreasingItem), {
                    api: api
                })
        },
        {
            type: (0, $2NTcm.SORT_DECREASING_ITEM).type,
            key: (0, $2NTcm.SORT_DECREASING_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_SORT_SECTION).type,
                    key: (0, $2NTcm.COLUMN_SORT_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_SORT_SECTION_RANK)[(0, $2NTcm.SORT_DECREASING_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $jK2yv.SortDecreasingItem), {
                    api: api
                })
        },
        // --- Add / Move section ---
        {
            type: (0, $2NTcm.COLUMN_ADD_SECTION).type,
            key: (0, $2NTcm.COLUMN_ADD_SECTION).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_MENU).type,
                    key: (0, $2NTcm.COLUMN_MENU).key,
                    rank: (0, $2NTcm.COLUMN_SECTION_RANK)[(0, $2NTcm.COLUMN_ADD_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        },
        {
            type: (0, $2NTcm.ADD_COLUMN_LEFT_ITEM).type,
            key: (0, $2NTcm.ADD_COLUMN_LEFT_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_ADD_SECTION).type,
                    key: (0, $2NTcm.COLUMN_ADD_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_ADD_SECTION_RANK)[(0, $2NTcm.ADD_COLUMN_LEFT_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $JHme2.AddColumnLeftItem), {
                    api: api
                })
        },
        {
            type: (0, $2NTcm.MOVE_COLUMN_LEFT_ITEM).type,
            key: (0, $2NTcm.MOVE_COLUMN_LEFT_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_ADD_SECTION).type,
                    key: (0, $2NTcm.COLUMN_ADD_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_ADD_SECTION_RANK)[(0, $2NTcm.MOVE_COLUMN_LEFT_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $ciXDv.MoveColumnLeftItem), {
                    api: api
                })
        },
        {
            type: (0, $2NTcm.MOVE_COLUMN_RIGHT_ITEM).type,
            key: (0, $2NTcm.MOVE_COLUMN_RIGHT_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_ADD_SECTION).type,
                    key: (0, $2NTcm.COLUMN_ADD_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_ADD_SECTION_RANK)[(0, $2NTcm.MOVE_COLUMN_RIGHT_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $9OWFw.MoveColumnRightItem), {
                    api: api
                })
        },
        // --- Danger section (Clear cells, Delete column) ---
        {
            type: (0, $2NTcm.COLUMN_DANGER_SECTION).type,
            key: (0, $2NTcm.COLUMN_DANGER_SECTION).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_MENU).type,
                    key: (0, $2NTcm.COLUMN_MENU).key,
                    rank: (0, $2NTcm.COLUMN_SECTION_RANK)[(0, $2NTcm.COLUMN_DANGER_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        }
    ];

});
parcelRegister("JHme2", function(module, exports) {
$parcel$export(module.exports, "AddColumnLeftItem", () => $19b89f3a2e76a550$export$3d6de3c2da0f12e9);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $l5gi8 = parcelRequire("l5gi8");

var $3foDq = parcelRequire("3foDq");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
const $19b89f3a2e76a550$export$3d6de3c2da0f12e9 = ({ api: api })=>{
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState === null || tableState === void 0 ? void 0 : tableState.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableScalingEnabled
        };
    });
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.left;
        if (index === undefined) return;
        const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
        (0, $kfljr.insertColumnWithAnalytics)(api, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, index)(editorView.state, editorView.dispatch, editorView);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3foDq))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.addColumnBefore)) ?? ''
        }),
        children: formatMessage((0, $lqHJB.messages).addColumnLeft)
    });
};

});

parcelRegister("fGOMh", function(module, exports) {
$parcel$export(module.exports, "ColumnBackgroundSection", () => $0184e3abb0aa8153$export$5b0d88ff04cc328c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9oAqi = parcelRequire("9oAqi");

var $l4q07 = parcelRequire("l4q07");

var $gB626 = parcelRequire("gB626");

var $jgg2v = parcelRequire("jgg2v");
const $0184e3abb0aa8153$export$5b0d88ff04cc328c = ({ api: api, children: children })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { isHeaderColumnAllowed: isHeaderColumnAllowed } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            isHeaderColumnAllowed: (_states$tableState = states.tableState) === null || _states$tableState === void 0 || (_states$tableState = _states$tableState.pluginConfig) === null || _states$tableState === void 0 ? void 0 : _states$tableState.allowHeaderColumn
        };
    });
    const hasSeparator = (0, $jgg2v.shouldShowHeaderColumnToggle)({
        isFirstColumn: tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isFirstColumn,
        isHeaderColumnAllowed: isHeaderColumnAllowed,
        selectedColumnCount: tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        children: children
    });
};

});
parcelRegister("jgg2v", function(module, exports) {
$parcel$export(module.exports, "shouldShowHeaderColumnToggle", () => $979f01fbd168eec4$export$dade01215233a7bf);
$parcel$export(module.exports, "HeaderColumnToggleItem", () => $979f01fbd168eec4$export$9d690116d46d85ce);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $7otWv = parcelRequire("7otWv");

var $ew1lT = parcelRequire("ew1lT");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
const $979f01fbd168eec4$export$dade01215233a7bf = ({ isFirstColumn: isFirstColumn, isHeaderColumnAllowed: isHeaderColumnAllowed, selectedColumnCount: selectedColumnCount })=>isHeaderColumnAllowed === true && isFirstColumn === true && selectedColumnCount === 1;
const $979f01fbd168eec4$export$9d690116d46d85ce = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { isHeaderColumnAllowed: isHeaderColumnAllowed, isHeaderColumnEnabled: isHeaderColumnEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState, _states$tableState2;
        return {
            isHeaderColumnAllowed: (_states$tableState = states.tableState) === null || _states$tableState === void 0 || (_states$tableState = _states$tableState.pluginConfig) === null || _states$tableState === void 0 ? void 0 : _states$tableState.allowHeaderColumn,
            isHeaderColumnEnabled: (_states$tableState2 = states.tableState) === null || _states$tableState2 === void 0 ? void 0 : _states$tableState2.isHeaderColumnEnabled
        };
    });
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const label = formatMessage((0, $lqHJB.messages).headerColumn);
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        (0, $kfljr.toggleHeaderColumnWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(editorView.state, editorView.dispatch);
    };
    if (!$979f01fbd168eec4$export$dade01215233a7bf({
        isFirstColumn: tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isFirstColumn,
        isHeaderColumnAllowed: isHeaderColumnAllowed,
        selectedColumnCount: tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount
    })) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ew1lT.default), {
            label: label,
            isChecked: !!isHeaderColumnEnabled,
            onChange: handleClick
        }),
        children: label
    });
};

});


parcelRegister("7vfKG", function(module, exports) {
$parcel$export(module.exports, "ColumnToggleSection", () => $1466f9ac86cfc4dc$export$e0bba57c586892e5);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9oAqi = parcelRequire("9oAqi");

var $l4q07 = parcelRequire("l4q07");

var $gB626 = parcelRequire("gB626");

var $jgg2v = parcelRequire("jgg2v");
const $1466f9ac86cfc4dc$export$e0bba57c586892e5 = ({ api: api, children: children })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { isHeaderColumnAllowed: isHeaderColumnAllowed } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            isHeaderColumnAllowed: (_states$tableState = states.tableState) === null || _states$tableState === void 0 || (_states$tableState = _states$tableState.pluginConfig) === null || _states$tableState === void 0 ? void 0 : _states$tableState.allowHeaderColumn
        };
    });
    if (!(0, $jgg2v.shouldShowHeaderColumnToggle)({
        isFirstColumn: tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isFirstColumn,
        isHeaderColumnAllowed: isHeaderColumnAllowed,
        selectedColumnCount: tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount
    })) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
        children: children
    });
};

});

parcelRegister("ciXDv", function(module, exports) {
$parcel$export(module.exports, "MoveColumnLeftItem", () => $ec28e5b2aece2f45$export$dda1f0abce68f555);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $l5gi8 = parcelRequire("l5gi8");

var $2feYn = parcelRequire("2feYn");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $7T6wF = parcelRequire("7T6wF");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");

var $gzpzh = parcelRequire("gzpzh");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $2q9QJ = parcelRequire("2q9QJ");

var $hkEC0 = parcelRequire("hkEC0");

var $gB626 = parcelRequire("gB626");
const $ec28e5b2aece2f45$var$shouldShowMoveColumnLeft = (isFirstColumn)=>!isFirstColumn;
const $ec28e5b2aece2f45$export$dda1f0abce68f555 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            tableNode: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.tableNode
        };
    });
    const selectedColumnCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount) ?? 1;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics, _api$accessibilityUti;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $cwJ2b.moveSourceWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 ? void 0 : _api$accessibilityUti.actions.ariaNotify, (0, $4GJqd.getPluginState)(editorView.state).getIntl)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $hkEC0.TABLE_COLUMN), (0, $2q9QJ.getSelectedColumnIndexes)(selectionRect), selectionRect.left - 1)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!tableNode || !$ec28e5b2aece2f45$var$shouldShowMoveColumnLeft(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isFirstColumn)) return null;
    const label = formatMessage((0, $lqHJB.messages).moveColumnLeft, {
        0: selectedColumnCount
    });
    if (!Boolean(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.canMoveColumnLeft)) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7T6wF))), {
            color: "var(--ds-text-disabled, #080F214A)",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: formatMessage((0, $lqHJB.messages).canNotMoveColumnLeftWithMergedCells),
            position: "top",
            children: (tooltipProps)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2feYn))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-icon, #292A2E)"
                    })
                })
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.disabled",
            children: label
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7T6wF))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.moveColumnLeft)) ?? ''
        }),
        children: label
    });
};

});

parcelRegister("9OWFw", function(module, exports) {
$parcel$export(module.exports, "MoveColumnRightItem", () => $321fa7cc251067a3$export$6a6c7fe03e6819e3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $l5gi8 = parcelRequire("l5gi8");

var $cZ3rn = parcelRequire("cZ3rn");

var $2feYn = parcelRequire("2feYn");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");

var $gzpzh = parcelRequire("gzpzh");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $2q9QJ = parcelRequire("2q9QJ");

var $hkEC0 = parcelRequire("hkEC0");

var $gB626 = parcelRequire("gB626");
const $321fa7cc251067a3$var$shouldShowMoveColumnRight = (isLastColumn)=>!isLastColumn;
const $321fa7cc251067a3$export$6a6c7fe03e6819e3 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            tableNode: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.tableNode
        };
    });
    const selectedColumnCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount) ?? 1;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics, _api$accessibilityUti;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $cwJ2b.moveSourceWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 ? void 0 : _api$accessibilityUti.actions.ariaNotify, (0, $4GJqd.getPluginState)(editorView.state).getIntl)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $hkEC0.TABLE_COLUMN), (0, $2q9QJ.getSelectedColumnIndexes)(selectionRect), selectionRect.right)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!tableNode || !$321fa7cc251067a3$var$shouldShowMoveColumnRight(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isLastColumn)) return null;
    const label = formatMessage((0, $lqHJB.messages).moveColumnRight, {
        0: selectedColumnCount
    });
    if (!Boolean(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.canMoveColumnRight)) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cZ3rn))), {
            color: "var(--ds-text-disabled, #080F214A)",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: formatMessage((0, $lqHJB.messages).canNotMoveColumnRightWithMergedCells),
            position: "top",
            children: (tooltipProps)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2feYn))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-icon, #292A2E)"
                    })
                })
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.disabled",
            children: label
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cZ3rn))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.moveColumnRight)) ?? ''
        }),
        children: label
    });
};

});

parcelRegister("jK2yv", function(module, exports) {
$parcel$export(module.exports, "SortDecreasingItem", () => $661029b5ff4eb6a5$export$d429b5b13299a5d2);
/* SortDecreasingItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $hIsCp = parcelRequire("hIsCp");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $l5gi8 = parcelRequire("l5gi8");

var $2feYn = parcelRequire("2feYn");

var $hSoIi = parcelRequire("hSoIi");

var $7otWv = parcelRequire("7otWv");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
const $661029b5ff4eb6a5$var$styles = {
    infoIconTrigger: "_1e0c116y _4cvr1h6o"
};
const $661029b5ff4eb6a5$export$d429b5b13299a5d2 = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const hasMergedCellsInTable = Boolean(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.hasMergedCellsInTable);
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        const columnIndex = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.left;
        if (columnIndex === undefined) return;
        (0, $kfljr.sortColumnWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, columnIndex, (0, $hIsCp.SortOrder).DESC)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    // When the table has merged cells, the item remains interactive but is rendered
    // with a disabled-looking label and leading icon, alongside an enabled info icon
    // that surfaces why sorting is unavailable.
    if (hasMergedCellsInTable) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hSoIi))), {
            label: "",
            size: "small",
            color: "var(--ds-text-disabled, #080F214A)"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: formatMessage((0, $lqHJB.messages).canNotSortTableNoIcon),
            position: "top",
            children: (tooltipProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    as: "span",
                    xcss: $661029b5ff4eb6a5$var$styles.infoIconTrigger,
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2feYn))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-icon, #292A2E)"
                    })
                })
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.disabled",
            children: formatMessage((0, $lqHJB.messages).sortColumnDecreasing)
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hSoIi))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $lqHJB.messages).sortColumnDecreasing)
    });
};

});

parcelRegister("gd56Y", function(module, exports) {
$parcel$export(module.exports, "SortIncreasingItem", () => $0aeb61a80b356a93$export$dbae1ebe00b36634);
/* SortIncreasingItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $hIsCp = parcelRequire("hIsCp");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $l5gi8 = parcelRequire("l5gi8");

var $2feYn = parcelRequire("2feYn");

var $4jmqR = parcelRequire("4jmqR");

var $7otWv = parcelRequire("7otWv");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
const $0aeb61a80b356a93$var$styles = {
    infoIconTrigger: "_1e0c116y _4cvr1h6o"
};
const $0aeb61a80b356a93$export$dbae1ebe00b36634 = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const hasMergedCellsInTable = Boolean(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.hasMergedCellsInTable);
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        const columnIndex = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.left;
        if (columnIndex === undefined) return;
        (0, $kfljr.sortColumnWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, columnIndex, (0, $hIsCp.SortOrder).ASC)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    // When the table has merged cells, the item remains interactive but is rendered
    // with a disabled-looking label and leading icon, alongside an enabled info icon
    // that surfaces why sorting is unavailable.
    if (hasMergedCellsInTable) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jmqR))), {
            label: "",
            size: "small",
            color: "var(--ds-text-disabled, #080F214A)"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: formatMessage((0, $lqHJB.messages).canNotSortTableNoIcon),
            position: "top",
            children: (tooltipProps)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                    as: "span",
                    xcss: $0aeb61a80b356a93$var$styles.infoIconTrigger,
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2feYn))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-icon, #292A2E)"
                    })
                })
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.disabled",
            children: formatMessage((0, $lqHJB.messages).sortColumnIncreasing)
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jmqR))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $lqHJB.messages).sortColumnIncreasing)
    });
};

});


parcelRegister("3rxFa", function(module, exports) {
$parcel$export(module.exports, "getRowMenuComponents", () => $c0d73708618c2453$export$c176756f533b3bad);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $l4q07 = parcelRequire("l4q07");

var $8xXGx = parcelRequire("8xXGx");

var $c9zZw = parcelRequire("c9zZw");

var $EZ48x = parcelRequire("EZ48x");

var $aIxHi = parcelRequire("aIxHi");

var $gAU7x = parcelRequire("gAU7x");

var $izzuA = parcelRequire("izzuA");
const $c0d73708618c2453$export$c176756f533b3bad = ({ api: api })=>[
        // AddRowBelowItem/DeleteRowItem are registered in `../shared/getSharedItems`
        // (shared with the cell menu), so they are omitted here.
        // --- Menu surface ---
        {
            type: (0, $izzuA.ROW_MENU).type,
            key: (0, $izzuA.ROW_MENU).key
        },
        // --- Toggle section (Header row, Numbered rows) ---
        {
            type: (0, $izzuA.ROW_TOGGLE_SECTION).type,
            key: (0, $izzuA.ROW_TOGGLE_SECTION).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_MENU).type,
                    key: (0, $izzuA.ROW_MENU).key,
                    rank: (0, $izzuA.ROW_MENU_SECTION_RANK)[(0, $izzuA.ROW_TOGGLE_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    children: props.children
                })
        },
        {
            type: (0, $izzuA.HEADER_ROW_TOGGLE_ITEM).type,
            key: (0, $izzuA.HEADER_ROW_TOGGLE_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_TOGGLE_SECTION).type,
                    key: (0, $izzuA.ROW_TOGGLE_SECTION).key,
                    rank: (0, $izzuA.ROW_TOGGLE_SECTION_RANK)[(0, $izzuA.HEADER_ROW_TOGGLE_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $c9zZw.HeaderRowToggleItem), {
                    api: api
                })
        },
        {
            type: (0, $izzuA.NUMBERED_ROWS_TOGGLE_ITEM).type,
            key: (0, $izzuA.NUMBERED_ROWS_TOGGLE_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_TOGGLE_SECTION).type,
                    key: (0, $izzuA.ROW_TOGGLE_SECTION).key,
                    rank: (0, $izzuA.ROW_TOGGLE_SECTION_RANK)[(0, $izzuA.NUMBERED_ROWS_TOGGLE_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $gAU7x.NumberedRowsToggleItem), {
                    api: api
                })
        },
        // --- Background color section ---
        {
            type: (0, $izzuA.ROW_BACKGROUND_SECTION).type,
            key: (0, $izzuA.ROW_BACKGROUND_SECTION).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_MENU).type,
                    key: (0, $izzuA.ROW_MENU).key,
                    rank: (0, $izzuA.ROW_MENU_SECTION_RANK)[(0, $izzuA.ROW_BACKGROUND_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        },
        // --- Add / Move section ---
        {
            type: (0, $izzuA.ROW_ADD_SECTION).type,
            key: (0, $izzuA.ROW_ADD_SECTION).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_MENU).type,
                    key: (0, $izzuA.ROW_MENU).key,
                    rank: (0, $izzuA.ROW_MENU_SECTION_RANK)[(0, $izzuA.ROW_ADD_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        },
        {
            type: (0, $izzuA.ADD_ROW_ABOVE_ITEM).type,
            key: (0, $izzuA.ADD_ROW_ABOVE_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_ADD_SECTION).type,
                    key: (0, $izzuA.ROW_ADD_SECTION).key,
                    rank: (0, $izzuA.ROW_ADD_SECTION_RANK)[(0, $izzuA.ADD_ROW_ABOVE_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $8xXGx.AddRowAboveItem), {
                    api: api
                })
        },
        {
            type: (0, $izzuA.MOVE_ROW_UP_ITEM).type,
            key: (0, $izzuA.MOVE_ROW_UP_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_ADD_SECTION).type,
                    key: (0, $izzuA.ROW_ADD_SECTION).key,
                    rank: (0, $izzuA.ROW_ADD_SECTION_RANK)[(0, $izzuA.MOVE_ROW_UP_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $aIxHi.MoveRowUpItem), {
                    api: api
                })
        },
        {
            type: (0, $izzuA.MOVE_ROW_DOWN_ITEM).type,
            key: (0, $izzuA.MOVE_ROW_DOWN_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_ADD_SECTION).type,
                    key: (0, $izzuA.ROW_ADD_SECTION).key,
                    rank: (0, $izzuA.ROW_ADD_SECTION_RANK)[(0, $izzuA.MOVE_ROW_DOWN_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $EZ48x.MoveRowDownItem), {
                    api: api
                })
        },
        // --- Danger section (Clear cells, Delete row) ---
        {
            type: (0, $izzuA.ROW_DANGER_SECTION).type,
            key: (0, $izzuA.ROW_DANGER_SECTION).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_MENU).type,
                    key: (0, $izzuA.ROW_MENU).key,
                    rank: (0, $izzuA.ROW_MENU_SECTION_RANK)[(0, $izzuA.ROW_DANGER_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $l4q07.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                })
        }
    ];

});
parcelRegister("8xXGx", function(module, exports) {
$parcel$export(module.exports, "AddRowAboveItem", () => $e52186586cfb877e$export$138f9370dd8b98ae);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $l5gi8 = parcelRequire("l5gi8");

var $9czSm = parcelRequire("9czSm");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
const $e52186586cfb877e$export$138f9370dd8b98ae = (props)=>{
    const { api: api } = props;
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.top;
        if (index === undefined) return;
        (0, $kfljr.insertRowWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, {
            index: index,
            moveCursorToInsertedRow: true
        })(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9czSm))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.addRowBefore)) ?? ''
        }),
        children: formatMessage((0, $lqHJB.messages).addRowAbove)
    });
};

});

parcelRegister("c9zZw", function(module, exports) {
$parcel$export(module.exports, "HeaderRowToggleItem", () => $7ea430e0c5561b73$export$9dea3bd6b52ecc8f);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $7otWv = parcelRequire("7otWv");

var $ew1lT = parcelRequire("ew1lT");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
/** Header row toggle is only visible when the first row is the entire selection. */ const $7ea430e0c5561b73$var$shouldShowHeaderRowToggle = ({ isFirstRow: isFirstRow, isHeaderRowAllowed: isHeaderRowAllowed, selectedRowCount: selectedRowCount })=>isHeaderRowAllowed === true && isFirstRow && selectedRowCount === 1;
const $7ea430e0c5561b73$export$9dea3bd6b52ecc8f = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { isHeaderRowAllowed: isHeaderRowAllowed, isHeaderRowEnabled: isHeaderRowEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState, _states$tableState2;
        return {
            isHeaderRowAllowed: (_states$tableState = states.tableState) === null || _states$tableState === void 0 || (_states$tableState = _states$tableState.pluginConfig) === null || _states$tableState === void 0 ? void 0 : _states$tableState.allowHeaderRow,
            isHeaderRowEnabled: (_states$tableState2 = states.tableState) === null || _states$tableState2 === void 0 ? void 0 : _states$tableState2.isHeaderRowEnabled
        };
    });
    const selectedRowCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedRowCount) ?? 0;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const label = formatMessage((0, $lqHJB.messages).headerRow);
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        (0, $kfljr.toggleHeaderRowWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(editorView.state, editorView.dispatch);
    };
    if (!$7ea430e0c5561b73$var$shouldShowHeaderRowToggle({
        isFirstRow: (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isFirstRow) === true,
        isHeaderRowAllowed: isHeaderRowAllowed,
        selectedRowCount: selectedRowCount
    })) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ew1lT.default), {
            label: label,
            isChecked: !!isHeaderRowEnabled,
            onChange: handleClick
        }),
        children: label
    });
};

});

parcelRegister("EZ48x", function(module, exports) {
$parcel$export(module.exports, "MoveRowDownItem", () => $4b094b38d6806ee1$export$59ceb255a30542d3);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $l5gi8 = parcelRequire("l5gi8");

var $2feYn = parcelRequire("2feYn");

var $2dUrS = parcelRequire("2dUrS");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");

var $gzpzh = parcelRequire("gzpzh");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $2q9QJ = parcelRequire("2q9QJ");

var $hkEC0 = parcelRequire("hkEC0");

var $gB626 = parcelRequire("gB626");
const $4b094b38d6806ee1$var$shouldShowMoveRowDown = (isLastRow)=>!isLastRow;
const $4b094b38d6806ee1$export$59ceb255a30542d3 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            tableNode: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.tableNode
        };
    });
    const selectedRowCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedRowCount) ?? 1;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics, _api$accessibilityUti;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $cwJ2b.moveSourceWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 ? void 0 : _api$accessibilityUti.actions.ariaNotify, (0, $4GJqd.getPluginState)(editorView.state).getIntl)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $hkEC0.TABLE_ROW), (0, $2q9QJ.getSelectedRowIndexes)(selectionRect), selectionRect.bottom)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!tableNode || !$4b094b38d6806ee1$var$shouldShowMoveRowDown(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isLastRow)) return null;
    const label = formatMessage((0, $lqHJB.messages).moveRowDown, {
        0: selectedRowCount
    });
    if (!Boolean(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.canMoveRowDown)) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2dUrS))), {
            color: "var(--ds-text-disabled, #080F214A)",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: formatMessage((0, $lqHJB.messages).canNotMoveRowDownWithMergedCells),
            position: "top",
            children: (tooltipProps)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2feYn))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-icon, #292A2E)"
                    })
                })
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.disabled",
            children: label
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2dUrS))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.moveRowDown)) ?? ''
        }),
        children: label
    });
};

});

parcelRegister("aIxHi", function(module, exports) {
$parcel$export(module.exports, "MoveRowUpItem", () => $fabfa3b51d6e8ea3$export$6cf86f5e7d0cc460);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $l5gi8 = parcelRequire("l5gi8");

var $2feYn = parcelRequire("2feYn");

var $dGstS = parcelRequire("dGstS");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $k8Adr = parcelRequire("k8Adr");

var $bcTS3 = parcelRequire("bcTS3");

var $gzpzh = parcelRequire("gzpzh");

var $cwJ2b = parcelRequire("cwJ2b");

var $4GJqd = parcelRequire("4GJqd");

var $2q9QJ = parcelRequire("2q9QJ");

var $hkEC0 = parcelRequire("hkEC0");

var $gB626 = parcelRequire("gB626");
const $fabfa3b51d6e8ea3$var$shouldShowMoveRowUp = (isFirstRow)=>!isFirstRow;
const $fabfa3b51d6e8ea3$export$6cf86f5e7d0cc460 = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { tableNode: tableNode } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            tableNode: (_states$tableState = states.tableState) === null || _states$tableState === void 0 ? void 0 : _states$tableState.tableNode
        };
    });
    const selectedRowCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedRowCount) ?? 1;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics, _api$accessibilityUti;
        if (!editorView) return;
        const selectionRect = (0, $l5gi8.getSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $cwJ2b.moveSourceWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 ? void 0 : _api$accessibilityUti.actions.ariaNotify, (0, $4GJqd.getPluginState)(editorView.state).getIntl)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, (0, $hkEC0.TABLE_ROW), (0, $2q9QJ.getSelectedRowIndexes)(selectionRect), selectionRect.top - 1)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!tableNode || !$fabfa3b51d6e8ea3$var$shouldShowMoveRowUp(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.isFirstRow)) return null;
    const label = formatMessage((0, $lqHJB.messages).moveRowUp, {
        0: selectedRowCount
    });
    if (!Boolean(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.canMoveRowUp)) return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGstS))), {
            color: "var(--ds-text-disabled, #080F214A)",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $bcTS3.default), {
            content: formatMessage((0, $lqHJB.messages).canNotMoveRowUpWithMergedCells),
            position: "top",
            children: (tooltipProps)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $3LM7S.jsx)("span", {
                    ...tooltipProps,
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2feYn))), {
                        label: "",
                        size: "small",
                        color: "var(--ds-icon, #292A2E)"
                    })
                })
        }),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $k8Adr.Text), {
            color: "color.text.disabled",
            children: label
        })
    });
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dGstS))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.moveRowUp)) ?? ''
        }),
        children: label
    });
};

});

parcelRegister("gAU7x", function(module, exports) {
$parcel$export(module.exports, "NumberedRowsToggleItem", () => $4af066c7f89b04ee$export$e0ecc089c0583a2d);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $7otWv = parcelRequire("7otWv");

var $ew1lT = parcelRequire("ew1lT");

var $kfljr = parcelRequire("kfljr");

var $gB626 = parcelRequire("gB626");
const $4af066c7f89b04ee$export$e0ecc089c0583a2d = (props)=>{
    const { api: api } = props;
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { isNumberColumnAllowed: isNumberColumnAllowed, isNumberColumnEnabled: isNumberColumnEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState, _states$tableState2;
        return {
            isNumberColumnAllowed: (_states$tableState = states.tableState) === null || _states$tableState === void 0 || (_states$tableState = _states$tableState.pluginConfig) === null || _states$tableState === void 0 ? void 0 : _states$tableState.allowNumberColumn,
            isNumberColumnEnabled: (_states$tableState2 = states.tableState) === null || _states$tableState2 === void 0 ? void 0 : _states$tableState2.isNumberColumnEnabled
        };
    });
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const label = formatMessage((0, $lqHJB.messages).numberedRows);
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        (0, $kfljr.toggleNumberColumnWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(editorView.state, editorView.dispatch);
    };
    if (!isNumberColumnAllowed) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ew1lT.default), {
            label: label,
            isChecked: !!isNumberColumnEnabled,
            onChange: handleClick
        }),
        children: label
    });
};

});


parcelRegister("1RMdC", function(module, exports) {
$parcel$export(module.exports, "getSharedItems", () => $150d12617209c975$export$58613b8ba3de644b);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $9VL3d = parcelRequire("9VL3d");

var $aTlki = parcelRequire("aTlki");

var $c4fr1 = parcelRequire("c4fr1");

var $bflDP = parcelRequire("bflDP");

var $2NTcm = parcelRequire("2NTcm");

var $52HAp = parcelRequire("52HAp");

var $7QOP4 = parcelRequire("7QOP4");

var $izzuA = parcelRequire("izzuA");

var $dPH1f = parcelRequire("dPH1f");

var $8lQND = parcelRequire("8lQND");

var $0117J = parcelRequire("0117J");
const $150d12617209c975$export$58613b8ba3de644b = ({ api: api })=>[
        // The add/delete items are registered here rather than in the row/column menu files,
        // once with an additional cell parent, so they render inside the cell menu too.
        {
            type: (0, $0117J.BACKGROUND_COLOR_ITEM).type,
            key: (0, $0117J.BACKGROUND_COLOR_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_BACKGROUND_SECTION).type,
                    key: (0, $izzuA.ROW_BACKGROUND_SECTION).key,
                    rank: (0, $izzuA.ROW_BACKGROUND_SECTION_RANK)[(0, $0117J.BACKGROUND_COLOR_ITEM).key]
                },
                {
                    type: (0, $2NTcm.COLUMN_BACKGROUND_SECTION).type,
                    key: (0, $2NTcm.COLUMN_BACKGROUND_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_BACKGROUND_SECTION_RANK)[(0, $0117J.BACKGROUND_COLOR_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_ACTION_SECTION).type,
                    key: (0, $9VL3d.CELL_ACTION_SECTION).key,
                    rank: (0, $9VL3d.CELL_ACTION_SECTION_RANK)[(0, $0117J.BACKGROUND_COLOR_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $dPH1f.BackgroundColorItem), {
                    api: api
                })
        },
        {
            type: (0, $2NTcm.ADD_COLUMN_RIGHT_ITEM).type,
            key: (0, $2NTcm.ADD_COLUMN_RIGHT_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_ADD_SECTION).type,
                    key: (0, $2NTcm.COLUMN_ADD_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_ADD_SECTION_RANK)[(0, $2NTcm.ADD_COLUMN_RIGHT_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_ADD_SECTION).type,
                    key: (0, $9VL3d.CELL_ADD_SECTION).key,
                    rank: (0, $9VL3d.CELL_ADD_SECTION_RANK)[(0, $2NTcm.ADD_COLUMN_RIGHT_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $aTlki.AddColumnRightItem), {
                    api: api
                })
        },
        {
            type: (0, $izzuA.ADD_ROW_BELOW_ITEM).type,
            key: (0, $izzuA.ADD_ROW_BELOW_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_ADD_SECTION).type,
                    key: (0, $izzuA.ROW_ADD_SECTION).key,
                    rank: (0, $izzuA.ROW_ADD_SECTION_RANK)[(0, $izzuA.ADD_ROW_BELOW_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_ADD_SECTION).type,
                    key: (0, $9VL3d.CELL_ADD_SECTION).key,
                    rank: (0, $9VL3d.CELL_ADD_SECTION_RANK)[(0, $izzuA.ADD_ROW_BELOW_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $52HAp.AddRowBelowItem), {
                    api: api
                })
        },
        {
            type: (0, $2NTcm.DISTRIBUTE_COLUMNS_ITEM).type,
            key: (0, $2NTcm.DISTRIBUTE_COLUMNS_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_ADD_SECTION).type,
                    key: (0, $2NTcm.COLUMN_ADD_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_ADD_SECTION_RANK)[(0, $2NTcm.DISTRIBUTE_COLUMNS_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_ADD_SECTION).type,
                    key: (0, $9VL3d.CELL_ADD_SECTION).key,
                    rank: (0, $9VL3d.CELL_ADD_SECTION_RANK)[(0, $2NTcm.DISTRIBUTE_COLUMNS_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $bflDP.DistributeColumnsItem), {
                    api: api
                })
        },
        {
            type: (0, $0117J.CLEAR_CELLS_ITEM).type,
            key: (0, $0117J.CLEAR_CELLS_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_DANGER_SECTION).type,
                    key: (0, $izzuA.ROW_DANGER_SECTION).key,
                    rank: (0, $izzuA.ROW_DANGER_SECTION_RANK)[(0, $0117J.CLEAR_CELLS_ITEM).key]
                },
                {
                    type: (0, $2NTcm.COLUMN_DANGER_SECTION).type,
                    key: (0, $2NTcm.COLUMN_DANGER_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_DANGER_SECTION_RANK)[(0, $0117J.CLEAR_CELLS_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_DANGER_SECTION).type,
                    key: (0, $9VL3d.CELL_DANGER_SECTION).key,
                    rank: (0, $9VL3d.CELL_DANGER_SECTION_RANK)[(0, $0117J.CLEAR_CELLS_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $8lQND.ClearCellsItem), {
                    api: api
                })
        },
        {
            type: (0, $2NTcm.DELETE_COLUMN_ITEM).type,
            key: (0, $2NTcm.DELETE_COLUMN_ITEM).key,
            parents: [
                {
                    type: (0, $2NTcm.COLUMN_DANGER_SECTION).type,
                    key: (0, $2NTcm.COLUMN_DANGER_SECTION).key,
                    rank: (0, $2NTcm.COLUMN_DANGER_SECTION_RANK)[(0, $2NTcm.DELETE_COLUMN_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_DANGER_SECTION).type,
                    key: (0, $9VL3d.CELL_DANGER_SECTION).key,
                    rank: (0, $9VL3d.CELL_DANGER_SECTION_RANK)[(0, $2NTcm.DELETE_COLUMN_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $c4fr1.DeleteColumnItem), {
                    api: api
                })
        },
        {
            type: (0, $izzuA.DELETE_ROW_ITEM).type,
            key: (0, $izzuA.DELETE_ROW_ITEM).key,
            parents: [
                {
                    type: (0, $izzuA.ROW_DANGER_SECTION).type,
                    key: (0, $izzuA.ROW_DANGER_SECTION).key,
                    rank: (0, $izzuA.ROW_DANGER_SECTION_RANK)[(0, $izzuA.DELETE_ROW_ITEM).key]
                },
                {
                    type: (0, $9VL3d.CELL_DANGER_SECTION).type,
                    key: (0, $9VL3d.CELL_DANGER_SECTION).key,
                    rank: (0, $9VL3d.CELL_DANGER_SECTION_RANK)[(0, $izzuA.DELETE_ROW_ITEM).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7QOP4.DeleteRowItem), {
                    api: api
                })
        }
    ];

});
parcelRegister("aTlki", function(module, exports) {
$parcel$export(module.exports, "AddColumnRightItem", () => $f5051a9d8ec94365$export$790a355d691039c9);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $hWLCD = parcelRequire("hWLCD");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $cfG4J = parcelRequire("cfG4J");

var $gB626 = parcelRequire("gB626");
const $f5051a9d8ec94365$export$790a355d691039c9 = ({ api: api })=>{
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState === null || tableState === void 0 ? void 0 : tableState.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableScalingEnabled
        };
    });
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.right;
        if (index === undefined) return;
        const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
        (0, $kfljr.insertColumnWithAnalytics)(api, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, index)(editorView.state, editorView.dispatch, editorView);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hWLCD))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.addColumnAfter)) ?? ''
        }),
        children: formatMessage((0, $lqHJB.messages).addColumnRight)
    });
};

});
parcelRegister("cfG4J", function(module, exports) {
$parcel$export(module.exports, "getMenuSelectionRect", () => $600b4cdc6706142f$export$7b5d5e575078343e);

var $elHd5 = parcelRequire("elHd5");

var $l5gi8 = parcelRequire("l5gi8");

var $2HFfw = parcelRequire("2HFfw");
const $600b4cdc6706142f$export$7b5d5e575078343e = (selection)=>(0, $2HFfw.isSelectionType)(selection, 'cell') ? (0, $l5gi8.getSelectionRect)(selection) : (0, $elHd5.findCellRectClosestToPos)(selection.$from);

});


parcelRegister("c4fr1", function(module, exports) {
$parcel$export(module.exports, "DeleteColumnItem", () => $61723f4429057b53$export$7840ed9912c84130);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $Admw7 = parcelRequire("Admw7");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $EwLhB = parcelRequire("EwLhB");
var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $2q9QJ = parcelRequire("2q9QJ");

var $9VL3d = parcelRequire("9VL3d");

var $cfG4J = parcelRequire("cfG4J");

var $gB626 = parcelRequire("gB626");
const $61723f4429057b53$export$7840ed9912c84130 = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const selectedColumnCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount) ?? 1;
    const shouldShowShortcut = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.surface.key) !== (0, $9VL3d.CELL_MENU).key;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState === null || tableState === void 0 ? void 0 : tableState.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableScalingEnabled
        };
    });
    const handleMouseEnter = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $EwLhB.hoverColumns)((0, $2q9QJ.getSelectedColumnIndexes)(selectionRect), true)(editorView.state, editorView.dispatch);
    };
    const handleMouseLeave = ()=>{
        if (!editorView) return;
        (0, $EwLhB.clearHoverSelection)()(editorView.state, editorView.dispatch);
    };
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        const shouldUseIncreasedScalingPercent = isTableScalingEnabled && (isTableFixedColumnWidthsOptionEnabled || isCommentEditor);
        (0, $kfljr.deleteColumnsWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, shouldUseIncreasedScalingPercent, isCommentEditor)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect)(editorView.state, editorView.dispatch, editorView);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        onBlur: handleMouseLeave,
        onMouseLeave: handleMouseLeave,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Admw7))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: shouldShowShortcut ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.deleteColumn)) ?? ''
        }) : undefined,
        children: formatMessage((0, $lqHJB.messages).removeColumns, {
            0: selectedColumnCount
        })
    });
};

});

parcelRegister("bflDP", function(module, exports) {
$parcel$export(module.exports, "DistributeColumnsItem", () => $19f6edebbc8b0146$export$b038fb9a55c447ee);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $5m5hr = parcelRequire("5m5hr");

var $7otWv = parcelRequire("7otWv");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $26jxM = parcelRequire("26jxM");

var $cfG4J = parcelRequire("cfG4J");

var $gB626 = parcelRequire("gB626");
/** Distribute columns is only visible when more than one column is selected. */ const $19f6edebbc8b0146$var$shouldShowDistributeColumns = (selectedColumnCount)=>(selectedColumnCount ?? 0) > 1;
const $19f6edebbc8b0146$export$b038fb9a55c447ee = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isCommentEditor: isCommentEditor, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled, isTableScalingEnabled: isTableScalingEnabled } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        const tableState = states.tableState;
        return {
            isCommentEditor: tableState === null || tableState === void 0 ? void 0 : tableState.isCommentEditor,
            isTableFixedColumnWidthsOptionEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableFixedColumnWidthsOptionEnabled,
            isTableScalingEnabled: tableState === null || tableState === void 0 ? void 0 : tableState.isTableScalingEnabled
        };
    });
    const handleClick = ()=>{
        var _api$width, _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        const editorContainerWidth = api === null || api === void 0 || (_api$width = api.width) === null || _api$width === void 0 ? void 0 : _api$width.sharedState.currentState();
        if (!selectionRect || !editorContainerWidth) return;
        const newResizeState = (0, $26jxM.getNewResizeStateFromSelectedColumns)(selectionRect, editorView.state, editorView.domAtPos.bind(editorView), ()=>editorContainerWidth, isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled, isCommentEditor);
        if (!newResizeState) return;
        (0, $kfljr.distributeColumnsWidthsWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, newResizeState)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    if (!$19f6edebbc8b0146$var$shouldShowDistributeColumns(tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount)) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5m5hr))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $lqHJB.messages).distributeColumns)
    });
};

});

parcelRegister("52HAp", function(module, exports) {
$parcel$export(module.exports, "AddRowBelowItem", () => $b4c5b99b5aacf8f4$export$3fc3a5ba73261067);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $1YIVu = parcelRequire("1YIVu");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $cfG4J = parcelRequire("cfG4J");

var $gB626 = parcelRequire("gB626");
const $b4c5b99b5aacf8f4$export$3fc3a5ba73261067 = (props)=>{
    const { api: api } = props;
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        const index = selectionRect === null || selectionRect === void 0 ? void 0 : selectionRect.bottom;
        if (index === undefined) return;
        (0, $kfljr.insertRowWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, {
            index: index,
            moveCursorToInsertedRow: true
        })(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1YIVu))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.addRowAfter)) ?? ''
        }),
        children: formatMessage((0, $lqHJB.messages).addRowBelow)
    });
};

});

parcelRegister("7QOP4", function(module, exports) {
$parcel$export(module.exports, "DeleteRowItem", () => $cbce2b2705fec86a$export$841535b3f254af3a);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $9oAqi = parcelRequire("9oAqi");

var $Admw7 = parcelRequire("Admw7");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $EwLhB = parcelRequire("EwLhB");
var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $2q9QJ = parcelRequire("2q9QJ");

var $9VL3d = parcelRequire("9VL3d");

var $cfG4J = parcelRequire("cfG4J");

var $gB626 = parcelRequire("gB626");
const $cbce2b2705fec86a$export$841535b3f254af3a = (props)=>{
    const { api: api } = props;
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { isHeaderRowRequired: isHeaderRowRequired } = (0, $9oAqi.useSharedPluginStateWithSelector)(api ?? undefined, [
        'table'
    ], (states)=>{
        var _states$tableState;
        return {
            isHeaderRowRequired: (_states$tableState = states.tableState) === null || _states$tableState === void 0 || (_states$tableState = _states$tableState.pluginConfig) === null || _states$tableState === void 0 ? void 0 : _states$tableState.isHeaderRowRequired
        };
    });
    const selectedRowCount = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedRowCount) ?? 1;
    const shouldShowShortcut = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.surface.key) !== (0, $9VL3d.CELL_MENU).key;
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const handleMouseEnter = ()=>{
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $EwLhB.hoverRows)((0, $2q9QJ.getSelectedRowIndexes)(selectionRect), true)(editorView.state, editorView.dispatch);
    };
    const handleMouseLeave = ()=>{
        if (!editorView) return;
        (0, $EwLhB.clearHoverSelection)()(editorView.state, editorView.dispatch);
    };
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const selectionRect = (0, $cfG4J.getMenuSelectionRect)(editorView.state.selection);
        if (!selectionRect) return;
        (0, $kfljr.deleteRowsWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, selectionRect, !!isHeaderRowRequired)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        onFocus: handleMouseEnter,
        onMouseEnter: handleMouseEnter,
        onBlur: handleMouseLeave,
        onMouseLeave: handleMouseLeave,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($Admw7))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: shouldShowShortcut ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.deleteRow)) ?? ''
        }) : undefined,
        children: formatMessage((0, $lqHJB.messages).removeRows, {
            0: selectedRowCount
        })
    });
};

});

parcelRegister("dPH1f", function(module, exports) {
$parcel$export(module.exports, "BackgroundColorItem", () => $4f323fd2405ccdf4$export$b0a2efdf78e6aed2);
/* BackgroundColorItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");

var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $lqHJB = parcelRequire("lqHJB");

var $3D4hV = parcelRequire("3D4hV");

var $gb4WG = parcelRequire("gb4WG");

var $4oU9q = parcelRequire("4oU9q");

var $lvSK5 = parcelRequire("lvSK5");

var $5j2ZG = parcelRequire("5j2ZG");

var $ar15H = parcelRequire("ar15H");

var $bY7Ml = parcelRequire("bY7Ml");

var $i6Zpo = parcelRequire("i6Zpo");

var $dBtOK = parcelRequire("dBtOK");

var $aEmSo = parcelRequire("aEmSo");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $4GJqd = parcelRequire("4GJqd");

var $4Tw3G = parcelRequire("4Tw3G");

var $gB626 = parcelRequire("gB626");
const $4f323fd2405ccdf4$var$colorPaletteStyles = {
    container: "_1rjcu2gc",
    elemAfter: "_zulp1b66 _1e0c1txw _4cvr1h6o",
    colorPreview: "_2rko12b0 _1h6d1l7x _1dqonqa1 _189ee4h9 _1bsbdlk8 _4t3idlk8 _1o9zidpf"
};
const $4f323fd2405ccdf4$export$b0a2efdf78e6aed2 = ({ api: api })=>{
    const { editorView: editorView } = (0, $gB626.useTableMenuContext)() ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { selectedColor: selectedColor, selectedColorRaw: selectedColorRaw } = (0, $fc4bM.useMemo)(()=>{
        var _node$attrs, _node$attrs2;
        if (!editorView) return {
            selectedColor: '#ffffff',
            selectedColorRaw: '#ffffff'
        };
        const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(editorView.state);
        const node = targetCellPosition ? editorView.state.doc.nodeAt(targetCellPosition) : null;
        return {
            selectedColor: (0, $5j2ZG.hexToEditorBackgroundPaletteColor)((node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.background) || '#ffffff'),
            selectedColorRaw: (node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.background) || '#ffffff'
        };
    }, [
        editorView
    ]);
    const onClick = (0, $fc4bM.useCallback)((color)=>{
        var _api$analytics;
        if (!editorView) return;
        (0, $kfljr.setColorWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, color, editorView)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    }, [
        api,
        editorView
    ]);
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const colorPreviewStyle = (0, $fc4bM.useMemo)(()=>({
            backgroundColor: selectedColor
        }), [
        selectedColor
    ]);
    const isMoreColorsEnabled = (0, $aEmSo.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const activePalette = isMoreColorsEnabled ? (0, $3D4hV.default) : (0, $4oU9q.default);
    const activeCols = isMoreColorsEnabled ? (0, $4Tw3G.colorPaletteColumns) : (0, $4Tw3G.colorPalletteColumns);
    const paletteOptions = (0, $fc4bM.useMemo)(()=>{
        return {
            palette: activePalette,
            paletteColorTooltipMessages: (0, $lvSK5.backgroundPaletteTooltipMessages),
            hexToPaletteColor: (0, $5j2ZG.hexToEditorBackgroundPaletteColor)
        };
    }, [
        activePalette
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $i6Zpo.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bY7Ml))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $dBtOK.Box), {
            xcss: $4f323fd2405ccdf4$var$colorPaletteStyles.elemAfter,
            children: [
                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    style: colorPreviewStyle,
                    className: (0, $2R2iS.default)([
                        $4f323fd2405ccdf4$var$colorPaletteStyles.colorPreview
                    ])
                }),
                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $ar15H.NestedDropdownRightIcon), {
                    label: "",
                    size: "small"
                })
            ]
        }),
        text: formatMessage((0, $lqHJB.messages).backgroundColor),
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
            xcss: $4f323fd2405ccdf4$var$colorPaletteStyles.container,
            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gb4WG.default), {
                cols: activeCols,
                onClick: onClick,
                selectedColor: selectedColorRaw,
                paletteOptions: paletteOptions
            })
        })
    });
};

});

parcelRegister("8lQND", function(module, exports) {
$parcel$export(module.exports, "ClearCellsItem", () => $1c682529a1564878$export$8b64094e7c2cc90);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $eUtBU = parcelRequire("eUtBU");

var $lqHJB = parcelRequire("lqHJB");

var $gV8E5 = parcelRequire("gV8E5");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");

var $gzpzh = parcelRequire("gzpzh");

var $kfljr = parcelRequire("kfljr");

var $4GJqd = parcelRequire("4GJqd");

var $9VL3d = parcelRequire("9VL3d");

var $gB626 = parcelRequire("gB626");
const $1c682529a1564878$export$8b64094e7c2cc90 = ({ api: api })=>{
    const tableMenuContext = (0, $gB626.useTableMenuContext)();
    const { editorView: editorView } = tableMenuContext ?? {};
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const selectedCellCount = Math.max((tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedColumnCount) ?? 1, (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.selectedRowCount) ?? 1);
    const shouldShowShortcut = (tableMenuContext === null || tableMenuContext === void 0 ? void 0 : tableMenuContext.surface.key) !== (0, $9VL3d.CELL_MENU).key || selectedCellCount > 1;
    const handleClick = ()=>{
        var _api$analytics;
        if (!editorView) return;
        const { targetCellPosition: targetCellPosition } = (0, $4GJqd.getPluginState)(editorView.state);
        (0, $kfljr.emptyMultipleCellsWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).TABLE_CONTEXT_MENU, targetCellPosition)(editorView.state, editorView.dispatch);
        api === null || api === void 0 || api.core.actions.execute((0, $gzpzh.closeActiveTableMenu)(api));
        api === null || api === void 0 || api.core.actions.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV8E5))), {
            color: "currentColor",
            label: "",
            size: "small"
        }),
        elemAfter: shouldShowShortcut ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.tooltip)((0, $eUtBU.backspace)) ?? ''
        }) : undefined,
        children: formatMessage((0, $lqHJB.messages).clearCells, {
            0: selectedCellCount
        })
    });
};

});




parcelRegister("8FKqc", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsPlugin", () => $037e129040cad5f8$export$582323d9689d93fc);
/* tasksAndDecisionsPlugin.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $jwm0O = parcelRequire("jwm0O");

var $bOVzM = parcelRequire("bOVzM");

var $cd0UN = parcelRequire("cd0UN");

var $eohEq = parcelRequire("eohEq");

var $3LeME = parcelRequire("3LeME");

var $7vlqQ = parcelRequire("7vlqQ");

var $bMe57 = parcelRequire("bMe57");

var $c2wgC = parcelRequire("c2wgC");

var $fFud1 = parcelRequire("fFud1");

var $cT0LQ = parcelRequire("cT0LQ");

var $jnzAA = parcelRequire("jnzAA");

var $a4TQr = parcelRequire("a4TQr");

var $bcN2K = parcelRequire("bcN2K");

var $2kYwg = parcelRequire("2kYwg");

var $f0WpE = parcelRequire("f0WpE");

var $8ZI3Z = parcelRequire("8ZI3Z");

var $9hOwj = parcelRequire("9hOwj");

var $7ukUt = parcelRequire("7ukUt");

var $7lYQ4 = parcelRequire("7lYQ4");

var $6V8KD = parcelRequire("6V8KD");

var $1h6Wf = parcelRequire("1h6Wf");

var $9kCZ1 = parcelRequire("9kCZ1");

var $gafoB = parcelRequire("gafoB");

var $gn0VM = parcelRequire("gn0VM");

var $lrxgy = parcelRequire("lrxgy");

var $b1B1S = parcelRequire("b1B1S");

var $hb6B4 = parcelRequire("hb6B4");
const $037e129040cad5f8$var$taskDecisionToolbarGroupStyles = null;
const $037e129040cad5f8$var$TASK_LIST_NODE_NAME = 'taskList';
const $037e129040cad5f8$var$DECISION_LIST_NODE_NAME = 'decisionList';
const $037e129040cad5f8$var$addItem = (insert, listType, schema)=>({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
        const { list: list, item: item } = (0, $8ZI3Z.getListTypes)(listType, schema);
        return insert(list.createChecked({
            localId: listLocalId
        }, item.createChecked({
            localId: itemLocalId
        })));
    };
function $037e129040cad5f8$var$ContentComponent({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi }) {
    const openRequestToEditPopupAt = (0, $jnzAA.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.openRequestToEditPopupAt');
    const hasEditPermission = (0, $jnzAA.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.hasEditPermission');
    if (!editorView || hasEditPermission || !openRequestToEditPopupAt) return null;
    const domAtPos = editorView.domAtPos.bind(editorView);
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $a4TQr.findDomRefAtPos)(openRequestToEditPopupAt, domAtPos);
    const handleOnClose = ()=>{
        (0, $2kYwg.closeRequestEditPopupAt)(editorView);
        editorView.focus();
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gafoB.RequestToEditPopup), {
        api: dependencyApi,
        editorView: editorView,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: element,
        onClose: handleOnClose
    }, openRequestToEditPopupAt);
}
const $037e129040cad5f8$export$582323d9689d93fc = ({ config: { allowNestedTasks: allowNestedTasks, consumeTabs: consumeTabs, useLongPressSelection: useLongPressSelection, hasEditPermission: hasEditPermission = true, hasRequestedEditPermission: hasRequestedEditPermission, quickInsertActionDescription: quickInsertActionDescription, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, taskPlaceholder: taskPlaceholder, allowBlockTaskItem: allowBlockTaskItem } = {}, api: api })=>{
    var _api$blockMenu, _api$analytics2, _api$analytics3, _api$analytics4;
    const getIdentifierProvider = ()=>{
        var _api$contextIdentifie;
        return api === null || api === void 0 || (_api$contextIdentifie = api.contextIdentifier) === null || _api$contextIdentifie === void 0 || (_api$contextIdentifie = _api$contextIdentifie.sharedState.currentState()) === null || _api$contextIdentifie === void 0 ? void 0 : _api$contextIdentifie.contextIdentifierProvider;
    };
    let previousTaskAndDecisionProvider;
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const isRegisteredSlashCommandEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $9kCZ1.getTasksAndDecisionsQuickInsertComponents)({
            api: api,
            quickInsertActionDescription: quickInsertActionDescription
        }));
    }
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $lrxgy.getTasksAndDecisionsToolbarComponents)({
            api: api
        }));
    }
    if (taskDecisionProvider) taskDecisionProvider.then((provider)=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>(0, $8ZI3Z.setProvider)(provider)(tr));
    });
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $bMe57.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $bMe57.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $c2wgC.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $bMe57.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]
            },
            component: ({ isSuggested: isSuggested } = {})=>{
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $gn0VM.TaskListBlockMenuItem), {
                    api: api,
                    isSuggested: isSuggested
                });
            },
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($037e129040cad5f8$var$TASK_LIST_NODE_NAME));
            }
        },
        {
            type: 'block-menu-item',
            key: (0, $bMe57.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $bMe57.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $c2wgC.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $bMe57.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]
            },
            component: ({ isSuggested: isSuggested } = {})=>{
                return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1h6Wf.DecisionListBlockMenuItem), {
                    api: api,
                    isSuggested: isSuggested
                });
            },
            isHidden: ()=>{
                var _api$blockMenu3;
                return Boolean(api === null || api === void 0 || (_api$blockMenu3 = api.blockMenu) === null || _api$blockMenu3 === void 0 ? void 0 : _api$blockMenu3.actions.isTransformOptionDisabled($037e129040cad5f8$var$DECISION_LIST_NODE_NAME));
            }
        }
    ]);
    return {
        name: 'taskDecision',
        nodes () {
            return [
                {
                    name: 'decisionList',
                    node: (0, $bOVzM.decisionList)
                },
                {
                    name: 'decisionItem',
                    node: (0, $jwm0O.decisionItem)
                },
                {
                    name: 'taskList',
                    node: (0, $eohEq.taskList)
                },
                {
                    name: 'taskItem',
                    node: (0, $cd0UN.taskItem)
                },
                ...allowBlockTaskItem ? [
                    {
                        name: 'blockTaskItem',
                        node: (0, $cd0UN.blockTaskItem)
                    }
                ] : []
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $7lYQ4.stateKey).getState(editorState);
            const indentLevel = (0, $2kYwg.getCurrentIndentLevel)(editorState.selection) || 0;
            return {
                focusedTaskItemLocalId: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.focusedTaskItemLocalId) || null,
                isInsideTask: (0, $2kYwg.isInsideTask)(editorState),
                indentDisabled: indentLevel >= (0, $fFud1.MAX_INDENTATION_LEVEL),
                outdentDisabled: indentLevel <= 0,
                // hasEditPermission is assumed to be true if pluginState.hasEditPermission is undefined
                // this allows the default plugin state to initialise as true if the extra configuration is not provided
                hasEditPermission: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.hasEditPermission) !== undefined ? pluginState === null || pluginState === void 0 ? void 0 : pluginState.hasEditPermission : true,
                requestToEditContent: pluginState === null || pluginState === void 0 ? void 0 : pluginState.requestToEditContent,
                hasRequestedEditPermission: pluginState === null || pluginState === void 0 ? void 0 : pluginState.hasRequestedEditPermission,
                taskDecisionProvider: pluginState === null || pluginState === void 0 ? void 0 : pluginState.taskDecisionProvider,
                openRequestToEditPopupAt: pluginState === null || pluginState === void 0 ? void 0 : pluginState.openRequestToEditPopupAt
            };
        },
        commands: {
            toggleTaskList: (targetType)=>{
                var _api$analytics;
                return (0, $6V8KD.toggleTaskList)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(targetType);
            },
            updateEditPermission: (hasEditPermission)=>({ tr: tr })=>tr.setMeta((0, $7lYQ4.stateKey), {
                        hasEditPermission: hasEditPermission
                    }),
            updateHasRequestedEditPermission: (hasRequestedEditPermission)=>({ tr: tr })=>tr.setMeta((0, $7lYQ4.stateKey), {
                        hasRequestedEditPermission: hasRequestedEditPermission
                    })
        },
        actions: {
            insertTaskDecision: (0, $8ZI3Z.insertTaskDecisionCommand)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions, getIdentifierProvider),
            indentTaskList: (0, $9hOwj.getIndentCommand)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions),
            outdentTaskList: (0, $9hOwj.getUnindentCommand)(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousTaskAndDecisionProvider === provider || taskDecisionProvider === providerPromise) return false;
                previousTaskAndDecisionProvider = provider;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>(0, $8ZI3Z.setProvider)(provider)(tr))) ?? false;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'tasksAndDecisions',
                    plugin: ({ portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $7ukUt.createPlugin)(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder);
                    }
                },
                {
                    name: 'tasksAndDecisionsInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>{
                        var _api$analytics5;
                        return (0, $f0WpE.default)(api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions, getIdentifierProvider)(schema, featureFlags);
                    }
                },
                {
                    name: 'tasksAndDecisionsKeyMap',
                    plugin: ({ schema: schema })=>(0, $9hOwj.default)(schema, api, allowNestedTasks, consumeTabs)
                } // Needs to be after "save-on-enter"
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                className: (0, $2R2iS.default)([
                    "_1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $b1B1S.default), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    }),
                    /*#__PURE__*/ (0, $3LM7S.jsx)((0, $hb6B4.default), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    })
                ]
            });
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $3LM7S.jsx)($037e129040cad5f8$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'action',
                            title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).action),
                            description: quickInsertActionDescription ?? formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).actionDescription),
                            priority: 100,
                            keywords: [
                                'checkbox',
                                'task',
                                'todo'
                            ],
                            keyshortcut: '[]',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconAction), {}),
                            action (insert, state, source) {
                                var _api$analytics6;
                                return (0, $8ZI3Z.insertTaskDecisionAction)(api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions, getIdentifierProvider)(state, 'taskList', source ?? (0, $3LeME.INPUT_METHOD).QUICK_INSERT, $037e129040cad5f8$var$addItem(insert, 'taskList', state.schema));
                            }
                        },
                        {
                            id: 'decision',
                            title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).decision),
                            description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).decisionDescription),
                            priority: 900,
                            keyshortcut: '<>',
                            icon: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $7vlqQ.IconDecision), {}),
                            action (insert, state, source) {
                                var _api$analytics7;
                                return (0, $8ZI3Z.insertTaskDecisionAction)(api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 ? void 0 : _api$analytics7.actions, getIdentifierProvider)(state, 'decisionList', source ?? (0, $3LeME.INPUT_METHOD).QUICK_INSERT, $037e129040cad5f8$var$addItem(insert, 'decisionList', state.schema));
                            }
                        }
                    ]
            }
        }
    };
};

});
parcelRegister("2kYwg", function(module, exports) {
$parcel$export(module.exports, "isInsideTaskOrDecisionItem", () => $81ac0f010431481a$export$c4942fd0ddcad0b);
$parcel$export(module.exports, "isActionOrDecisionList", () => $81ac0f010431481a$export$6f0e2eafb461f634);
$parcel$export(module.exports, "isActionOrDecisionItem", () => $81ac0f010431481a$export$93c6d1f260b6c095);
$parcel$export(module.exports, "isInsideTask", () => $81ac0f010431481a$export$2fad51fb9cb5e2d1);
$parcel$export(module.exports, "isInsideDecision", () => $81ac0f010431481a$export$cc187e317961fba);
$parcel$export(module.exports, "isTable", () => $81ac0f010431481a$export$567a2801b8f40ab5);
$parcel$export(module.exports, "getBlockRange", () => $81ac0f010431481a$export$f029cbac7e0ab14c);
$parcel$export(module.exports, "getCurrentIndentLevel", () => $81ac0f010431481a$export$d75a55aec79aaa5);
$parcel$export(module.exports, "getTaskItemIndex", () => $81ac0f010431481a$export$af0098af8462419f);
$parcel$export(module.exports, "walkOut", () => $81ac0f010431481a$export$cd30871533411394);
$parcel$export(module.exports, "isEmptyTaskDecision", () => $81ac0f010431481a$export$e29ace8e645e5684);
$parcel$export(module.exports, "liftBlock", () => $81ac0f010431481a$export$b4043a93b6a561c9);
$parcel$export(module.exports, "getTaskItemDataAtPos", () => $81ac0f010431481a$export$bb36b9aa75d84160);
$parcel$export(module.exports, "getTaskItemDataToFocus", () => $81ac0f010431481a$export$84c7d27d1433771f);
$parcel$export(module.exports, "focusCheckbox", () => $81ac0f010431481a$export$6ddc162ae107856);
$parcel$export(module.exports, "focusCheckboxAndUpdateSelection", () => $81ac0f010431481a$export$965155ace97a0424);
$parcel$export(module.exports, "removeCheckboxFocus", () => $81ac0f010431481a$export$6d348f0593efe546);
$parcel$export(module.exports, "openRequestEditPopupAt", () => $81ac0f010431481a$export$ccb659c518fe26ad);
$parcel$export(module.exports, "closeRequestEditPopupAt", () => $81ac0f010431481a$export$6e1436cb7b69383b);
$parcel$export(module.exports, "findFirstParentListNode", () => $81ac0f010431481a$export$cd0bf0d386a8d5a7);
$parcel$export(module.exports, "isInFirstTextblockOfBlockTaskItem", () => $81ac0f010431481a$export$2ca50ccc2f45db88);
$parcel$export(module.exports, "isInLastTextblockOfBlockTaskItem", () => $81ac0f010431481a$export$bcd44b9b102ed403);

var $ihNBw = parcelRequire("ihNBw");

var $39oqF = parcelRequire("39oqF");
var $gNFuJ = parcelRequire("gNFuJ");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $a4TQr = parcelRequire("a4TQr");

var $7lYQ4 = parcelRequire("7lYQ4");

var $5ARB6 = parcelRequire("5ARB6");

var $dLTQs = parcelRequire("dLTQs");
const $81ac0f010431481a$export$c4942fd0ddcad0b = (state)=>{
    const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    if (blockTaskItem) return Boolean((0, $a4TQr.findParentNodeOfTypeClosestToPos)(state.selection.$from, [
        decisionItem,
        taskItem,
        blockTaskItem
    ]));
    return (0, $a4TQr.hasParentNodeOfType)([
        decisionItem,
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $81ac0f010431481a$export$6f0e2eafb461f634 = (node)=>{
    const { taskList: taskList, decisionList: decisionList } = node.type.schema.nodes;
    return [
        taskList,
        decisionList
    ].indexOf(node.type) > -1;
};
const $81ac0f010431481a$export$93c6d1f260b6c095 = (node)=>{
    const { taskItem: taskItem, decisionItem: decisionItem, blockTaskItem: blockTaskItem } = node.type.schema.nodes;
    return [
        taskItem,
        decisionItem,
        blockTaskItem
    ].indexOf(node.type) > -1;
};
const $81ac0f010431481a$export$2fad51fb9cb5e2d1 = (state)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = state.schema.nodes;
    return (0, $a4TQr.hasParentNodeOfType)([
        taskItem,
        blockTaskItem
    ])(state.selection);
};
const $81ac0f010431481a$export$cc187e317961fba = (state)=>{
    const { decisionItem: decisionItem } = state.schema.nodes;
    return (0, $a4TQr.hasParentNodeOfType)([
        decisionItem
    ])(state.selection);
};
const $81ac0f010431481a$export$567a2801b8f40ab5 = (node)=>{
    if (!node) return false;
    const { table: table, tableHeader: tableHeader, tableCell: tableCell, tableRow: tableRow } = node.type.schema.nodes;
    return [
        table,
        tableHeader,
        tableCell,
        tableRow
    ].includes(node.type);
};
const $81ac0f010431481a$export$f029cbac7e0ab14c = ({ $from: $from, $to: $to })=>{
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    if (blockTaskItem) {
        const result = (0, $dLTQs.findBlockTaskItem)($from);
        if (result) {
            var _$prevNode$nodeBefore;
            const { hasParagraph: hasParagraph } = result;
            const blockTaskItemDepth = hasParagraph ? $from.depth - 1 : $from.depth;
            let blockRangeDepth = blockTaskItemDepth - 1;
            // Calculate start position of the block range
            let startPos = $from.start(blockTaskItemDepth) - 1;
            // Calculate end position and get node after the current selection
            const endPos = $to.end();
            let $after = $to.doc.resolve(endPos + 1);
            let afterNode = $after.nodeAfter;
            const lastNode = $to.node($to.depth);
            let endRangePos = $to.start() + lastNode.nodeSize;
            // Make adjustments for paragraph nodes
            if (lastNode.type === paragraph) {
                $after = $to.doc.resolve(endPos + 2);
                afterNode = $after.nodeAfter;
            } else {
                blockRangeDepth--;
                endRangePos--;
            }
            // Extend range if there's a sibling taskList
            if (afterNode && afterNode.type === taskList && $after.depth === blockTaskItemDepth - 1) endRangePos += afterNode.nodeSize;
            // Check if preceded by another taskItem/blockTaskItem
            const $prevNode = $from.doc.resolve(startPos - 1);
            const prevNodeSize = ((_$prevNode$nodeBefore = $prevNode.nodeBefore) === null || _$prevNode$nodeBefore === void 0 ? void 0 : _$prevNode$nodeBefore.nodeSize) || 0;
            const $prevNodeParent = $from.doc.resolve($prevNode.pos - prevNodeSize - 1);
            const prevNodeParent = $prevNodeParent.nodeAfter;
            if (prevNodeParent && [
                blockTaskItem,
                taskItem
            ].includes(prevNodeParent.type)) {
                blockRangeDepth = blockTaskItemDepth - 1;
                endRangePos -= 2;
                startPos += 1;
            }
            // Create and return the NodeRange
            return new (0, $7H6Cr.NodeRange)($to.doc.resolve(startPos), $to.doc.resolve(endRangePos), blockRangeDepth);
        }
    }
    let end = $to.end();
    const $after = $to.doc.resolve(end + 1);
    const after = $after.nodeAfter;
    // ensure the node after is actually just a sibling
    // $to will be inside the text, so subtract one to get the taskItem it contains in
    if (after && after.type === taskList && $after.depth === $to.depth - 1) // it was! include it in our blockRange
    end += after.nodeSize;
    return $from.blockRange($to.doc.resolve(end));
};
const $81ac0f010431481a$export$d75a55aec79aaa5 = (selection)=>{
    const { $from: $from } = selection;
    const { taskList: taskList, blockTaskItem: blockTaskItem } = $from.doc.type.schema.nodes;
    const furthestParent = (0, $39oqF.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!furthestParent) return null;
    if ((0, $a4TQr.hasParentNodeOfType)([
        blockTaskItem
    ])(selection)) {
        const blockTaskItemNode = (0, $39oqF.findFarthestParentNode)((node)=>node.type === blockTaskItem)($from);
        if (blockTaskItemNode) /**
       * If we are inside a blockTaskItem, calculate the indent level from the
       * blockTaskItemNode instead of the selection, in case the selection is
       * nested inside a blockTaskItem.
       */ return blockTaskItemNode.depth - furthestParent.depth;
    }
    return $from.depth - furthestParent.depth;
};
const $81ac0f010431481a$export$af0098af8462419f = (state)=>{
    const $pos = state.selection.$from;
    const isTaskList = (node)=>(node === null || node === void 0 ? void 0 : node.type.name) === 'taskList';
    const itemAtPos = (0, $a4TQr.findParentNodeClosestToPos)($pos, isTaskList);
    return $pos.index(itemAtPos ? itemAtPos.depth : undefined);
};
const $81ac0f010431481a$export$cd30871533411394 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && $pos.parentOffset > 0)$pos = $pos.doc.resolve($pos.pos + 1);
    return $pos;
};
const $81ac0f010431481a$export$e29ace8e645e5684 = (state)=>{
    const { selection: selection, schema: schema } = state;
    const { paragraph: paragraph, blockTaskItem: blockTaskItem, decisionItem: decisionItem, taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const isEmptyTaskOrDecisionItem = node && (node.type === taskItem || node.type === decisionItem) && node.content.size === 0;
    // Block task items must contain a single empty paragraph to be considered empty
    const isInEmptyBlockTaskItem = // If in an empty paragraph that's not at the doc level
    node.content.size === 0 && node.type === paragraph && $from.depth > 0 && // and it's parent is a blockTaskItem with only this paragraph inside it
    $from.node($from.depth - 1).type === blockTaskItem && $from.node($from.depth - 1).childCount === 1;
    return isEmptyTaskOrDecisionItem || isInEmptyBlockTaskItem;
};
const $81ac0f010431481a$export$b4043a93b6a561c9 = (tr, $from, $to)=>{
    const blockRange = $81ac0f010431481a$export$f029cbac7e0ab14c({
        $from: $from,
        $to: $to
    });
    if (!blockRange) return null;
    // ensure we can actually lift
    const target = (0, $k2WVn.liftTarget)(blockRange);
    if (typeof target !== 'number') return null;
    return tr.lift(blockRange, target).scrollIntoView();
};
function $81ac0f010431481a$export$bb36b9aa75d84160(view) {
    const { state: state } = view;
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const maybeTask = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($from, [
        taskItem,
        blockTaskItem
    ]);
    // current selection has to be inside taskitem
    if (maybeTask) return {
        pos: maybeTask === null || maybeTask === void 0 ? void 0 : maybeTask.pos,
        localId: maybeTask === null || maybeTask === void 0 ? void 0 : maybeTask.node.attrs.localId
    };
}
function $81ac0f010431481a$export$fdf2e1015111c7cb(view) {
    const { state: state } = view;
    const { schema: schema } = state;
    const $fromPos = state.selection.$from;
    // if not inside task item then return undefined;
    if (!$81ac0f010431481a$export$2fad51fb9cb5e2d1(state)) return;
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const rootTaskListData = (0, $39oqF.findFarthestParentNode)((node)=>node.type === taskList)($fromPos);
    if (rootTaskListData) {
        const rootTaskList = rootTaskListData.node;
        const rootTaskListStartPos = rootTaskListData.start;
        const allTaskItems = [];
        rootTaskList.descendants((node, pos, parent, index)=>{
            if (node.type === taskItem || blockTaskItem && node.type === blockTaskItem) allTaskItems.push({
                node: node,
                pos: pos + rootTaskListStartPos,
                index: index
            });
        });
        return allTaskItems;
    }
}
function $81ac0f010431481a$export$34f429092f5d2a8b(view, allTaskItems) {
    var _findParentNodeOfType;
    const { state: state } = view;
    const { schema: schema } = state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const $fromPos = state.selection.$from;
    const allTaskItemNodes = allTaskItems.map((nodeData)=>nodeData.node);
    const currentTaskItem = (_findParentNodeOfType = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($fromPos, [
        taskItem,
        blockTaskItem
    ])) === null || _findParentNodeOfType === void 0 ? void 0 : _findParentNodeOfType.node;
    if (currentTaskItem) {
        const currentTaskItemIndex = allTaskItemNodes.indexOf(currentTaskItem);
        return currentTaskItemIndex;
    } else return -1;
}
function $81ac0f010431481a$export$84c7d27d1433771f(view, direction) {
    const allTaskItems = $81ac0f010431481a$export$fdf2e1015111c7cb(view);
    // if not inside task item then allTaskItems will be undefined;
    if (!allTaskItems) return;
    const currentTaskItemIndex = $81ac0f010431481a$export$34f429092f5d2a8b(view, allTaskItems);
    if (direction === 'next' ? currentTaskItemIndex === allTaskItems.length - 1 : currentTaskItemIndex === 0) // checkbox of first or last task item is already focused based on direction.
    return;
    const indexOfTaskItemToFocus = direction === 'next' ? currentTaskItemIndex + 1 : currentTaskItemIndex - 1;
    const taskItemToFocus = allTaskItems[indexOfTaskItemToFocus];
    return {
        pos: taskItemToFocus.pos,
        localId: taskItemToFocus.node.attrs.localId
    };
}
function $81ac0f010431481a$export$6ddc162ae107856(view, taskItemData) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    if (taskItemData) {
        tr.setMeta((0, $7lYQ4.stateKey), {
            action: (0, $5ARB6.ACTIONS).FOCUS_BY_LOCALID,
            data: taskItemData.localId
        });
        dispatch(tr);
    }
}
function $81ac0f010431481a$export$965155ace97a0424(view, taskItemData) {
    var _doc$resolve$nodeAfte, _doc$resolve$nodeAfte2;
    const { pos: pos, localId: localId } = taskItemData;
    const { state: state, dispatch: dispatch } = view;
    const { doc: doc } = state;
    const { schema: schema } = state;
    const { extension: extension } = schema.nodes;
    const tr = state.tr;
    // if there's an extension at this position, we're in a blockTaskItem, set a gapCursor
    if (extension && ((_doc$resolve$nodeAfte = doc.resolve(pos + 1).nodeAfter) === null || _doc$resolve$nodeAfte === void 0 ? void 0 : _doc$resolve$nodeAfte.type) === extension) tr.setSelection(new (0, $ihNBw.GapCursorSelection)(doc.resolve(pos + 1)));
    else if ((_doc$resolve$nodeAfte2 = doc.resolve(pos + 1).nodeAfter) !== null && _doc$resolve$nodeAfte2 !== void 0 && _doc$resolve$nodeAfte2.isTextblock) tr.setSelection(new (0, $801jp.TextSelection)(doc.resolve(pos + 2)));
    else tr.setSelection(new (0, $801jp.TextSelection)(doc.resolve(pos + 1)));
    tr.setMeta((0, $7lYQ4.stateKey), {
        action: (0, $5ARB6.ACTIONS).FOCUS_BY_LOCALID,
        data: localId
    });
    dispatch(tr);
}
function $81ac0f010431481a$export$6d348f0593efe546(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    view.focus();
    dispatch(tr.setMeta((0, $7lYQ4.stateKey), {
        action: (0, $5ARB6.ACTIONS).FOCUS_BY_LOCALID
    }));
}
function $81ac0f010431481a$export$ccb659c518fe26ad(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $7lYQ4.stateKey), {
        action: (0, $5ARB6.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP,
        data: pos
    }));
}
function $81ac0f010431481a$export$6e1436cb7b69383b(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $7lYQ4.stateKey), {
        action: (0, $5ARB6.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP,
        data: null
    }));
}
function $81ac0f010431481a$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $gNFuJ.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $a4TQr.findParentNodeClosestToPos)($pos, (0, $gNFuJ.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
const $81ac0f010431481a$export$2ca50ccc2f45db88 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    return $from.parent.isTextblock && $from.node($from.depth - 1).type === blockTaskItem && $from.index($from.depth - 1) === 0;
};
const $81ac0f010431481a$export$bcd44b9b102ed403 = (state)=>{
    const { $from: $from } = state.selection;
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const parentNode = $from.node($from.depth - 1);
    return $from.parent.isTextblock && parentNode.type === blockTaskItem && $from.index($from.depth - 1) === parentNode.childCount - 1;
};

});
parcelRegister("7lYQ4", function(module, exports) {
$parcel$export(module.exports, "stateKey", () => $cf38c03a759cd8a0$export$77b371d6becc8882);

var $801jp = parcelRequire("801jp");
const $cf38c03a759cd8a0$export$77b371d6becc8882 = new (0, $801jp.PluginKey)('tasksAndDecisionsPlugin');

});

parcelRegister("5ARB6", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $f1cb13e9a52bb4a4$export$92a1a3b7554e9387);
var $f1cb13e9a52bb4a4$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["SET_PROVIDER"] = 0] = "SET_PROVIDER";
    ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 1] = "FOCUS_BY_LOCALID";
    ACTIONS[ACTIONS["OPEN_REQUEST_TO_EDIT_POPUP"] = 2] = "OPEN_REQUEST_TO_EDIT_POPUP";
    return ACTIONS;
}({});

});

parcelRegister("dLTQs", function(module, exports) {
$parcel$export(module.exports, "normalizeTaskItemsSelection", () => $81d5b6d7040c0f00$export$e590f1ae61640432);
$parcel$export(module.exports, "findBlockTaskItem", () => $81d5b6d7040c0f00$export$11f4e85d86397169);

var $801jp = parcelRequire("801jp");
function $81d5b6d7040c0f00$var$isTaskListNode(node) {
    return Boolean(node && node.type && 'taskList' === node.type.name);
}
const $81d5b6d7040c0f00$var$resolvePositionToStartOfTaskItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, $81d5b6d7040c0f00$var$isTaskListNode);
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $801jp.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $81d5b6d7040c0f00$var$resolvePositionToEndOfTaskItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, $81d5b6d7040c0f00$var$isTaskListNode);
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $801jp.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
const $81d5b6d7040c0f00$export$e590f1ae61640432 = (selection)=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $801jp.NodeSelection)) {
        const head = $81d5b6d7040c0f00$var$resolvePositionToStartOfTaskItem($from);
        return new (0, $801jp.TextSelection)(head, head);
    }
    const head = $81d5b6d7040c0f00$var$resolvePositionToStartOfTaskItem($from);
    const anchor = $81d5b6d7040c0f00$var$resolvePositionToEndOfTaskItem($to);
    return new (0, $801jp.TextSelection)(anchor, head);
};
const $81d5b6d7040c0f00$export$11f4e85d86397169 = ($from)=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = $from.doc.type.schema.nodes;
    const firstParent = $from.parent;
    if (firstParent.type === blockTaskItem) return {
        blockTaskItemNode: firstParent,
        hasParagraph: false
    };
    else if (firstParent.type === paragraph) {
        if ($from.depth >= 1) {
            const secondParent = $from.node($from.depth - 1);
            if (secondParent.type === blockTaskItem) return {
                blockTaskItemNode: secondParent,
                hasParagraph: true
            };
            else return false;
        } else return false;
    }
    return false;
};

});


parcelRegister("f0WpE", function(module, exports) {
$parcel$export(module.exports, "default", () => $164597dc17777e16$export$2e2bcd8739ae039);

var $3LeME = parcelRequire("3LeME");

var $1y7gE = parcelRequire("1y7gE");

var $fwOBn = parcelRequire("fwOBn");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $lT9wP = parcelRequire("lT9wP");

var $14Rdt = parcelRequire("14Rdt");

var $8ZI3Z = parcelRequire("8ZI3Z");
const $164597dc17777e16$var$createListRule = (editorAnalyticsAPI, getContextIdentifierProvider)=>(regex, listType, itemAttrs)=>{
        return (0, $fwOBn.createRule)(regex, (state, _match, start, end)=>{
            const { paragraph: paragraph } = state.schema.nodes;
            const { list: list } = (0, $8ZI3Z.getListTypes)(listType, state.schema);
            const $end = state.doc.resolve(end);
            const $endOfParent = state.doc.resolve($end.after());
            // Only allow creating list in nodes that support them.
            // Parent must be a paragraph as we don't want this applying to headings
            if ($end.parent.type !== paragraph || !(0, $a4TQr.canInsert)($endOfParent, list.createAndFill())) return null;
            const insertTr = (0, $8ZI3Z.insertTaskDecisionAction)(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, (0, $3LeME.INPUT_METHOD).FORMATTING, $164597dc17777e16$var$addItem(start, end), undefined, undefined, itemAttrs);
            return insertTr;
        });
    };
const $164597dc17777e16$var$isCursorInsideList = ($pos)=>{
    var _$pos$node;
    return ((_$pos$node = $pos.node($pos.depth - 1)) === null || _$pos$node === void 0 ? void 0 : _$pos$node.type.name) === 'listItem';
};
const $164597dc17777e16$var$processShortcutForNestedTask = (content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs)=>{
    //Extracting the content into the 'contentWithoutShortcut' from 'content' after removing the keyboard shortcut text, i.e., '[] '.
    const contentWithoutShortcut = content.cut($from.pos - $from.start(), content.size);
    tr.insert($from.after(), list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        }, contentWithoutShortcut)
    ])).setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve($from.after()))).delete($from.start(), $from.end());
};
const $164597dc17777e16$var$addItem = (start, end)=>({ tr: tr, state: state, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId, itemAttrs: itemAttrs })=>{
        const { selection: { $from: $from }, schema: schema } = state;
        const { hardBreak: hardBreak } = schema.nodes;
        const content = $from.node($from.depth).content;
        let shouldBreakNode = false;
        content.forEach((node, offset)=>{
            if (node.type === hardBreak && offset < start) shouldBreakNode = true;
        });
        if (!shouldBreakNode) {
            if ($164597dc17777e16$var$isCursorInsideList($from)) {
                $164597dc17777e16$var$processShortcutForNestedTask(content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs);
                return tr;
            }
            tr.replaceRangeWith($from.before(), $from.after(), list.create({
                localId: listLocalId
            }, [
                item.create({
                    localId: itemLocalId,
                    ...itemAttrs
                }, content)
            ])).delete(start + 1, end + 1).setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve(start + 1)));
            return tr;
        }
        const depthAdjustment = (0, $8ZI3Z.changeInDepth)($from, tr.selection.$from);
        tr.split($from.pos).setSelection(new (0, $801jp.NodeSelection)(tr.doc.resolve($from.pos + 1))).replaceSelectionWith(list.create({
            localId: listLocalId
        }, [
            item.create({
                localId: itemLocalId,
                ...itemAttrs
            }, tr.doc.nodeAt($from.pos + 1).content)
        ])).setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve($from.pos + depthAdjustment))).delete(start, end + 1);
        return tr;
    };
const $164597dc17777e16$export$568a7ed6897c4817 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(schema, featureFlags)=>{
        const rules = [];
        const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
        if (decisionList && decisionItem) rules.push($164597dc17777e16$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`(^|${(0, $lT9wP.leafNodeReplacementCharacter)})\\<\\>\\s$`), 'decisionList'));
        if (taskList && taskItem) {
            rules.push($164597dc17777e16$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $lT9wP.leafNodeReplacementCharacter)})\\[\\]\\s$`), 'taskList'));
            rules.push($164597dc17777e16$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $lT9wP.leafNodeReplacementCharacter)})\\[x\\]\\s$`), 'taskList', {
                state: 'DONE'
            }));
        }
        return new (0, $1y7gE.SafePlugin)((0, $14Rdt.createPlugin)('tasks-and-decisions', rules, {
            isBlockNodeRule: true
        }));
    };
var $164597dc17777e16$export$2e2bcd8739ae039 = $164597dc17777e16$export$568a7ed6897c4817;

});
parcelRegister("8ZI3Z", function(module, exports) {
$parcel$export(module.exports, "getListTypes", () => $00629902b2271cd4$export$c8b7fdb74eb8fe5c);
$parcel$export(module.exports, "insertTaskDecisionAction", () => $00629902b2271cd4$export$8c1bb617b1f6f2f1);
$parcel$export(module.exports, "insertTaskDecisionWithAnalytics", () => $00629902b2271cd4$export$14f75d90d7dffdab);
$parcel$export(module.exports, "insertTaskDecisionCommand", () => $00629902b2271cd4$export$d1657e7847eaa8d6);
$parcel$export(module.exports, "changeInDepth", () => $00629902b2271cd4$export$eb5c8ff5b17fd36b);
$parcel$export(module.exports, "setProvider", () => $00629902b2271cd4$export$1572b3eade6662f9);

var $1FHzN = parcelRequire("1FHzN");

var $3LeME = parcelRequire("3LeME");

var $4y9ZT = parcelRequire("4y9ZT");

var $ihNBw = parcelRequire("ihNBw");

var $ju7Hl = parcelRequire("ju7Hl");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $k2WVn = parcelRequire("k2WVn");

var $a4TQr = parcelRequire("a4TQr");

var $7lYQ4 = parcelRequire("7lYQ4");

var $5ARB6 = parcelRequire("5ARB6");
const $00629902b2271cd4$var$getContextData = (contextProvider = {})=>{
    const { objectId: objectId, containerId: containerId } = contextProvider;
    const userContext = objectId ? (0, $4y9ZT.USER_CONTEXT).EDIT : (0, $4y9ZT.USER_CONTEXT).NEW;
    return {
        objectId: objectId,
        containerId: containerId,
        userContext: userContext
    };
};
const $00629902b2271cd4$var$generateAnalyticsPayload = (listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx, listSize)=>{
    let containerId;
    let objectId;
    let userContext;
    if (contextData) ({ containerId: containerId, objectId: objectId, userContext: userContext } = contextData);
    return {
        action: (0, $3LeME.ACTION).INSERTED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: listType === 'taskList' ? (0, $3LeME.ACTION_SUBJECT_ID).ACTION : (0, $3LeME.ACTION_SUBJECT_ID).DECISION,
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            containerAri: containerId,
            objectAri: objectId,
            userContext: userContext,
            localId: itemLocalId,
            listLocalId: listLocalId,
            position: itemIdx,
            listSize: listSize
        }
    };
};
const $00629902b2271cd4$export$c8b7fdb74eb8fe5c = (listType, schema)=>{
    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (listType === 'taskList') return {
        list: taskList,
        item: taskItem
    };
    return {
        list: decisionList,
        item: decisionItem
    };
};
const $00629902b2271cd4$export$8c1bb617b1f6f2f1 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod = (0, $3LeME.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const addAndCreateList = ({ tr: tr, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId })=>$00629902b2271cd4$export$e38ac211271d1c05(tr, list, item, schema, state, listLocalId, itemLocalId, itemAttrs);
        const addToList = ({ state: state, tr: tr, item: item, itemLocalId: itemLocalId })=>{
            const { $to: $to } = state.selection;
            const endPos = $to.end($to.depth);
            const newItemParagraphPos = endPos + 2;
            return tr.split(endPos, 1, [
                {
                    type: item,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]).setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve(newItemParagraphPos)));
        };
        const addAndCreateListFn = addItem ?? addAndCreateList;
        const tr = $00629902b2271cd4$export$14f75d90d7dffdab(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addAndCreateListFn, addToList, listLocalId, itemLocalId, itemAttrs);
        if (!tr) return state.tr;
        (0, $ju7Hl.autoJoinTr)(tr, [
            'taskList',
            'decisionList'
        ]);
        return tr;
    };
const $00629902b2271cd4$export$d1657e7847eaa8d6 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(listType, inputMethod = (0, $3LeME.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId)=>(state, dispatch)=>{
            const tr = $00629902b2271cd4$export$8c1bb617b1f6f2f1(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addItem, listLocalId, itemLocalId);
            if (dispatch) dispatch(tr);
            return true;
        };
const $00629902b2271cd4$export$14f75d90d7dffdab = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod, addAndCreateList, addToList, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const { list: list, item: item } = $00629902b2271cd4$export$c8b7fdb74eb8fe5c(listType, schema);
        const { tr: tr } = state;
        const { $to: $to } = state.selection;
        const listNode = (0, $a4TQr.findParentNodeOfType)(list)(state.selection);
        const contextIdentifierProvider = getContextIdentifierProvider();
        const contextData = $00629902b2271cd4$var$getContextData(contextIdentifierProvider);
        let insertTrCreator;
        let itemIdx;
        let listSize;
        if (!listNode) {
            // Not a list - convert to one.
            itemIdx = 0;
            listSize = 1;
            insertTrCreator = addAndCreateList;
        } else if ($to.node().textContent.length >= 0) {
            listSize = listNode.node.childCount + 1;
            listLocalId = listLocalId || listNode.node.attrs.localId;
            const listItemNode = (0, $a4TQr.findParentNodeOfType)(item)(state.selection); // finds current item in list
            itemIdx = listItemNode ? state.doc.resolve(listItemNode.pos).index() + 1 : 0;
            insertTrCreator = addToList ? addToList : addAndCreateList;
        }
        listLocalId = listLocalId || (0, $1FHzN.uuid).generate();
        itemLocalId = itemLocalId || (0, $1FHzN.uuid).generate();
        if (insertTrCreator) {
            const insertTr = insertTrCreator({
                state: state,
                tr: tr,
                list: list,
                item: item,
                listLocalId: listLocalId,
                itemLocalId: itemLocalId,
                itemAttrs: itemAttrs
            });
            if (insertTr) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($00629902b2271cd4$var$generateAnalyticsPayload(listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx || 0, listSize || 0))(insertTr);
            return insertTr;
        }
        return null;
    };
const $00629902b2271cd4$export$f71b5a310965503b = (schema, selection)=>{
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, bulletList: bulletList, numberedList: numberedList } = schema.nodes;
    return (0, $a4TQr.hasParentNodeOfType)([
        blockquote,
        paragraph,
        decisionList,
        taskList
    ])(selection) && !(0, $a4TQr.hasParentNodeOfType)([
        bulletList,
        numberedList
    ])(selection);
};
const $00629902b2271cd4$export$eb5c8ff5b17fd36b = (before, after)=>after.depth - before.depth;
const $00629902b2271cd4$export$e38ac211271d1c05 = (tr, list, item, schema, state, listLocalId = (0, $1FHzN.uuid).generate(), itemLocalId = (0, $1FHzN.uuid).generate(), itemAttrs)=>{
    const { selection: selection } = state;
    const { $from: $from, $to: $to } = selection;
    if ($from.parent !== $to.parent) // ignore selections across multiple nodes
    return null;
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, decisionItem: decisionItem, taskItem: taskItem, mediaGroup: mediaGroup } = schema.nodes;
    if ($from.parent.type === mediaGroup) return null;
    const emptyList = list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        })
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof (0, $ihNBw.GapCursorSelection)) return (0, $a4TQr.safeInsert)(emptyList)(tr);
    // try to replace when selection is in nodes which support it
    if ($00629902b2271cd4$export$f71b5a310965503b(schema, selection)) {
        const { type: nodeType, childCount: childCount } = selection.$from.node();
        const newListNode = list.create({
            localId: (0, $1FHzN.uuid).generate()
        }, [
            item.create({
                localId: (0, $1FHzN.uuid).generate()
            }, $from.node($from.depth).content)
        ]);
        const hasBlockquoteParent = (0, $a4TQr.findParentNodeOfType)(blockquote)(selection);
        if (hasBlockquoteParent) {
            const liftedDepth = $from.depth - 1;
            const range = new (0, $7H6Cr.NodeRange)($from, $to, liftedDepth);
            tr.lift(range, (0, $k2WVn.liftTarget)(range));
        }
        const listParent = (0, $a4TQr.findParentNodeOfType)(taskList)(selection) || (0, $a4TQr.findParentNodeOfType)(decisionList)(selection);
        const listItem = (0, $a4TQr.findParentNodeOfType)(taskItem)(selection) || (0, $a4TQr.findParentNodeOfType)(decisionItem)(selection);
        // For a selection inside a task/decision list, we can't just simply replace the
        // node type as it will mess up lists with > 1 item
        if (listParent && listItem) {
            let start;
            let end;
            let selectionPos = selection.from;
            // if selection is in first item in list, we need to delete extra so that
            // this list isn't split
            if (listParent.node.firstChild === listItem.node) {
                start = listParent.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                if (listParent.node.childCount === 1) end = listParent.start + listParent.node.nodeSize - 1;
            } else {
                start = listItem.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                selectionPos += 2; // as we have added the new list node
            }
            tr.replaceWith(start, end, newListNode);
            tr = (0, $a4TQr.setTextSelection)(selectionPos)(tr);
            return tr;
        }
        // For a selection inside one of these node types we can just convert the node type
        const nodeTypesToReplace = [
            blockquote
        ];
        if (nodeType === paragraph && childCount > 0 || hasBlockquoteParent) // Only convert paragraphs containing content.
        // Empty paragraphs use the default flow.
        // This distinction ensures the text selection remains in the correct location.
        // We also want to replace the paragraph type when we are inside a blockQuote
        // to avoid inserting an extra taskList whilst keeping the paragraph
        nodeTypesToReplace.push(paragraph);
        let newTr = tr;
        newTr = (0, $a4TQr.replaceParentNodeOfType)(nodeTypesToReplace, newListNode)(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        const depthAdjustment = $00629902b2271cd4$export$eb5c8ff5b17fd36b($to, newTr.selection.$to);
        tr = tr.setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) return tr;
    }
    return (0, $a4TQr.safeInsert)(emptyList)(tr);
};
const $00629902b2271cd4$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $7lYQ4.stateKey), {
            action: (0, $5ARB6.ACTIONS).SET_PROVIDER,
            data: provider
        });
    };

});
parcelRegister("4y9ZT", function(module, exports) {
$parcel$export(module.exports, "USER_CONTEXT", () => $7eb4c81b31d32b89$export$f78f4c81bbd3af70);
var $7eb4c81b31d32b89$export$f78f4c81bbd3af70 = /*#__PURE__*/ function(USER_CONTEXT) {
    USER_CONTEXT["EDIT"] = "edit";
    USER_CONTEXT["NEW"] = "new";
    return USER_CONTEXT;
}({});
var $7eb4c81b31d32b89$export$5981355d1002ed79 = /*#__PURE__*/ function(LINK_STATUS) {
    LINK_STATUS["RESOLVED"] = "resolved";
    LINK_STATUS["UNRESOLVED"] = "unresolved";
    return LINK_STATUS;
}({});
var $7eb4c81b31d32b89$export$6c486891427a9a0 = /*#__PURE__*/ function(LINK_REPRESENTATION) {
    LINK_REPRESENTATION["TEXT"] = "text";
    LINK_REPRESENTATION["INLINE_CARD"] = "inlineCard";
    LINK_REPRESENTATION["BLOCK_CARD"] = "blockCard";
    LINK_REPRESENTATION["EMBED"] = "embed";
    return LINK_REPRESENTATION;
}({});
var $7eb4c81b31d32b89$export$7c9a0eeb2da3d2de = /*#__PURE__*/ function(LINK_RESOURCE) {
    LINK_RESOURCE["JIRA"] = "jiraIssue";
    LINK_RESOURCE["CONFLUENCE"] = "confluencePage";
    LINK_RESOURCE["BITBUCKET_PR"] = "bitbucketPR";
    LINK_RESOURCE["BITBUCKET_REPO"] = "bitbucketRepo";
    LINK_RESOURCE["TRELLO_CARD"] = "trelloCard";
    LINK_RESOURCE["TRELLO_BOARD"] = "trelloBoard";
    LINK_RESOURCE["STATUS_PAGE"] = "statusPage";
    LINK_RESOURCE["BOX"] = "boxFile";
    LINK_RESOURCE["DROPBOX"] = "dropboxFile";
    LINK_RESOURCE["OFFICE"] = "office";
    LINK_RESOURCE["DRIVE"] = "drive";
    LINK_RESOURCE["YOUTUBE"] = "youtubeVideo";
    LINK_RESOURCE["TWITTER"] = "twitterTweet";
    LINK_RESOURCE["OTHER"] = "other";
    return LINK_RESOURCE;
}({});
const $7eb4c81b31d32b89$export$d12fbaedaa07a497 = 'templateGallery';

});



parcelRegister("9hOwj", function(module, exports) {
$parcel$export(module.exports, "getUnindentCommand", () => $f650b4bce8d9bad4$export$d5d1010fad3453fa);
$parcel$export(module.exports, "getIndentCommand", () => $f650b4bce8d9bad4$export$b294289254b8cdac);
$parcel$export(module.exports, "default", () => $f650b4bce8d9bad4$export$2e2bcd8739ae039);

var $10F96 = parcelRequire("10F96");

var $1FHzN = parcelRequire("1FHzN");

var $3LeME = parcelRequire("3LeME");

var $kOiFe = parcelRequire("kOiFe");

var $eUtBU = parcelRequire("eUtBU");

var $5dJa8 = parcelRequire("5dJa8");

var $id3e6 = parcelRequire("id3e6");

var $ihNBw = parcelRequire("ihNBw");

var $5mojd = parcelRequire("5mojd");

var $1CiIv = parcelRequire("1CiIv");

var $8VpI3 = parcelRequire("8VpI3");

var $jGkle = parcelRequire("jGkle");

var $1O8Lw = parcelRequire("1O8Lw");

var $7H6Cr = parcelRequire("7H6Cr");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");

var $efwJc = parcelRequire("efwJc");

var $gc0AM = parcelRequire("gc0AM");

var $2kYwg = parcelRequire("2kYwg");

var $8ZI3Z = parcelRequire("8ZI3Z");

var $6V8KD = parcelRequire("6V8KD");

var $dLTQs = parcelRequire("dLTQs");
const $f650b4bce8d9bad4$var$indentationAnalytics = (curIndentLevel, direction, inputMethod)=>({
        action: (0, $3LeME.ACTION).FORMATTED,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_INDENT,
        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            previousIndentationLevel: curIndentLevel,
            newIndentLevel: direction === (0, $kOiFe.INDENT_DIRECTION).OUTDENT ? curIndentLevel - 1 : curIndentLevel + 1,
            direction: direction,
            indentType: (0, $kOiFe.INDENT_TYPE).TASK_LIST
        }
    });
const $f650b4bce8d9bad4$var$nodeAfter = ($pos)=>$pos.doc.resolve($pos.end()).nodeAfter;
const $f650b4bce8d9bad4$var$actionDecisionFollowsOrNothing = ($pos)=>{
    const after = $f650b4bce8d9bad4$var$nodeAfter($pos);
    return !after || (0, $2kYwg.isActionOrDecisionItem)(after);
};
const $f650b4bce8d9bad4$var$joinTaskDecisionFollowing = (state, dispatch)=>{
    // only run if selection is at end of text, and inside a task or decision item
    if (!(0, $1CiIv.isEmptySelectionAtEnd)(state) || !(0, $2kYwg.isInsideTaskOrDecisionItem)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $2kYwg.walkOut)(state.selection.$from);
    // if there's no taskItem or taskList following, then
    // we just do the normal behaviour
    const { taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const parentList = (0, $a4TQr.findParentNodeOfTypeClosestToPos)($next, [
        taskList,
        taskItem,
        decisionList,
        decisionItem
    ]);
    if (!parentList) {
        if ($next.parent.type === paragraph) // try to join paragraph and taskList when backspacing
        return (0, $gc0AM.joinAtCut)($next.doc.resolve($next.pos))(state, dispatch);
        // If the item we are joining is a list
        if ($next.parent.type === bulletList || $next.parent.type === orderedList) // If the list has an item
        {
            if ($next.parent.firstChild && $next.parent.firstChild.type === listItem) {
                // Place the cursor at the first listItem
                const resolvedStartPos = state.doc.resolve($next.pos + 1);
                // Unindent the first listItem.
                // As if placing your cursor just after the first dot of the list (before the text)
                // and pressing Shift-Tab.
                const tr = (0, $2kYwg.liftBlock)(state.tr, resolvedStartPos, resolvedStartPos);
                // If autoJoin not used, two ul/ol elements appear rather than one with multiple li elements
                return (0, $jGkle.autoJoin)((state, dispatch)=>{
                    if (tr) {
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    return false;
                }, [
                    'bulletList',
                    'orderedList'
                ])(state, dispatch);
            }
        }
    }
    return false;
};
const $f650b4bce8d9bad4$export$d5d1010fad3453fa = (editorAnalyticsAPI)=>(inputMethod = (0, $3LeME.INPUT_METHOD).KEYBOARD)=>(0, $5mojd.filter)((0, $2kYwg.isInsideTask), (state, dispatch)=>{
            const normalizedSelection = (0, $dLTQs.normalizeTaskItemsSelection)(state.selection);
            const curIndentLevel = (0, $2kYwg.getCurrentIndentLevel)(normalizedSelection);
            if (!curIndentLevel) return true;
            const outdentTr = (0, $efwJc.moveSelectedTaskListItems)(state.tr, -1);
            if (outdentTr) {
                (0, $8VpI3.withAnalytics)(editorAnalyticsAPI, $f650b4bce8d9bad4$var$indentationAnalytics(curIndentLevel, (0, $kOiFe.INDENT_DIRECTION).OUTDENT, inputMethod))((_state, d)=>{
                    d === null || d === void 0 || d(outdentTr);
                    return true;
                })(state, dispatch);
                return true;
            }
            return false;
        });
// if selection is decision item or first action item in table cell
// then dont consume the Tab, as table-keymap should tab to the next cell
const $f650b4bce8d9bad4$var$shouldLetTabThroughInTable = (state)=>{
    const curIndentLevel = (0, $2kYwg.getCurrentIndentLevel)(state.selection);
    const curIndex = (0, $2kYwg.getTaskItemIndex)(state);
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cell = (0, $a4TQr.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
    if ((curIndentLevel === 1 && curIndex === 0 || (0, $2kYwg.isInsideDecision)(state)) && cell) return true;
    return false;
};
const $f650b4bce8d9bad4$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $3LeME.INPUT_METHOD).KEYBOARD)=>(0, $5mojd.filter)((0, $2kYwg.isInsideTask), (state, dispatch)=>{
            const normalizedSelection = (0, $dLTQs.normalizeTaskItemsSelection)(state.selection);
            const curIndentLevel = (0, $2kYwg.getCurrentIndentLevel)(normalizedSelection);
            if (!curIndentLevel) return true;
            const indentTr = (0, $efwJc.moveSelectedTaskListItems)(state.tr, 1);
            if (indentTr) {
                (0, $8VpI3.withAnalytics)(editorAnalyticsAPI, $f650b4bce8d9bad4$var$indentationAnalytics(curIndentLevel, (0, $kOiFe.INDENT_DIRECTION).INDENT, inputMethod))((_state, d)=>{
                    d === null || d === void 0 || d(indentTr);
                    return true;
                })(state, dispatch);
                return true;
            }
            return false;
        });
const $f650b4bce8d9bad4$var$backspaceFrom = (editorAnalyticsAPI)=>($from)=>(state, dispatch)=>{
            var _nodeBefore$firstChil, _nodeBefore$firstChil2;
            const { taskList: taskList, blockTaskItem: blockTaskItem, paragraph: paragraph } = state.schema.nodes;
            // Check if selection is inside a blockTaskItem paragraph
            const resultOfFindBlockTaskItem = (0, $dLTQs.findBlockTaskItem)($from);
            const isInBlockTaskItemParagraph = resultOfFindBlockTaskItem && (resultOfFindBlockTaskItem === null || resultOfFindBlockTaskItem === void 0 ? void 0 : resultOfFindBlockTaskItem.hasParagraph);
            // Get the node before the current position
            const beforePos = isInBlockTaskItemParagraph ? $from.before() - 1 : $from.before();
            const nodeBefore = $from.doc.resolve(beforePos).nodeBefore;
            // Check if the node before is an empty task item
            const isEmptyActionOrDecisionItem = nodeBefore && (0, $2kYwg.isActionOrDecisionItem)(nodeBefore) && nodeBefore.content.size === 0;
            const isEmptyBlockTaskItem = blockTaskItem && (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) === blockTaskItem && (nodeBefore === null || nodeBefore === void 0 || (_nodeBefore$firstChil = nodeBefore.firstChild) === null || _nodeBefore$firstChil === void 0 ? void 0 : _nodeBefore$firstChil.type) === paragraph && (nodeBefore === null || nodeBefore === void 0 || (_nodeBefore$firstChil2 = nodeBefore.firstChild) === null || _nodeBefore$firstChil2 === void 0 || (_nodeBefore$firstChil2 = _nodeBefore$firstChil2.content) === null || _nodeBefore$firstChil2 === void 0 ? void 0 : _nodeBefore$firstChil2.size) === 0;
            // previous was empty, just delete backwards
            if (isEmptyActionOrDecisionItem || isEmptyBlockTaskItem) return false;
            // If nested in a taskList, unindent
            const depthFromSelectionToBlockTaskItem = isInBlockTaskItemParagraph ? 2 : 1;
            const depthFromSelectionToNestedTaskList = depthFromSelectionToBlockTaskItem + 1;
            const parentDepth = $from.depth - depthFromSelectionToNestedTaskList;
            if ($from.node(parentDepth).type === taskList) return $f650b4bce8d9bad4$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
            // If at the end of an item, unwrap contents into a paragraph
            // we achieve this by slicing the content out, and replacing
            if ($f650b4bce8d9bad4$var$actionDecisionFollowsOrNothing($from)) {
                if (dispatch) {
                    // If we are in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
                    // So we reduce the depth by 1 to get to the blockTaskItem node content
                    const taskContent = isInBlockTaskItemParagraph ? state.doc.slice($from.start($from.depth - 1), $from.end($from.depth - 1)).content : state.doc.slice($from.start(), $from.end()).content;
                    let slice;
                    try {
                        slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                        // might be end of document after
                        const tr = $f650b4bce8d9bad4$var$splitListItemWith(state.tr, slice, $from, true);
                        dispatch(tr);
                        return true;
                    } catch  {
                        // If there's an error creating a paragraph, check if we are in a blockTaskItem
                        // Block task item's can have non-text content that cannot be wrapped in a paragraph
                        // So if the selection is in a blockTaskItem, just pass the content as is
                        if (resultOfFindBlockTaskItem && resultOfFindBlockTaskItem.blockTaskItemNode) {
                            // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                            slice = Array.from(taskContent.content);
                            const tr = $f650b4bce8d9bad4$var$splitListItemWith(state.tr, slice, $from, true);
                            dispatch(tr);
                            return true;
                        }
                    }
                }
            }
            return false;
        };
const $f650b4bce8d9bad4$var$backspace = (editorAnalyticsAPI)=>(0, $5mojd.filter)((0, $1CiIv.isEmptySelectionAtStart), (0, $jGkle.autoJoin)((0, $jGkle.chainCommands)((state, dispatch)=>(0, $gc0AM.joinAtCut)(state.selection.$from)(state, dispatch), (0, $5mojd.filter)((0, $2kYwg.isInsideTaskOrDecisionItem), (state, dispatch)=>$f650b4bce8d9bad4$var$backspaceFrom(editorAnalyticsAPI)(state.selection.$from)(state, dispatch))), [
        'taskList',
        'decisionList'
    ]));
const $f650b4bce8d9bad4$var$unindentTaskOrUnwrapTaskDecisionFollowing = (state, dispatch)=>{
    var _$next$node, _$from$node, _$next$node2, _$from$node2, _$next$node3;
    const { selection: { $from: $from }, schema: { nodes: { taskList: taskList, doc: doc, paragraph: paragraph, blockTaskItem: blockTaskItem, taskItem: taskItem } }, tr: tr } = state;
    // only run if cursor is at the end of the node
    if (!(0, $1CiIv.isEmptySelectionAtEnd)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $2kYwg.walkOut)($from);
    // this is a top-level node it wont have $next.before()
    if (!$next.parent || $next.parent.type === doc) return false;
    // get resolved position of parent
    const $parentPos = $from.doc.resolve($from.start($from.depth - 1));
    const currentNode = $from.node();
    const parentNode = $parentPos.node();
    // if current position isn't an action or decision item, return false
    if (!(0, $2kYwg.isActionOrDecisionItem)(currentNode) && !(0, $2kYwg.isActionOrDecisionItem)(parentNode)) return false;
    const resultOfCurrentFindBlockTaskItem = (0, $dLTQs.findBlockTaskItem)($next);
    let isCurrentEmptyBlockTaskItem = false;
    if (resultOfCurrentFindBlockTaskItem) {
        var _blockTaskItemNode$fi;
        const { blockTaskItemNode: blockTaskItemNode } = resultOfCurrentFindBlockTaskItem;
        isCurrentEmptyBlockTaskItem = blockTaskItem && blockTaskItemNode && blockTaskItemNode.childCount === 1 && ((_blockTaskItemNode$fi = blockTaskItemNode.firstChild) === null || _blockTaskItemNode$fi === void 0 ? void 0 : _blockTaskItemNode$fi.type) === paragraph && blockTaskItemNode.firstChild.childCount === 0;
    }
    const isEmptyActionOrDecisionItem = currentNode && (0, $2kYwg.isActionOrDecisionItem)(currentNode) && currentNode.childCount === 0;
    // If empty item, use default handler
    if (isEmptyActionOrDecisionItem || isCurrentEmptyBlockTaskItem) return false;
    // Check if next node is a blockTaskItem paragraph
    const resultOfNextFindBlockTaskItem = (0, $dLTQs.findBlockTaskItem)($next);
    const isNextInBlockTaskItemParagraph = resultOfNextFindBlockTaskItem && (resultOfNextFindBlockTaskItem === null || resultOfNextFindBlockTaskItem === void 0 ? void 0 : resultOfNextFindBlockTaskItem.hasParagraph);
    // if nested, just unindent
    if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
    $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
        (0, $2kYwg.liftBlock)(tr, $next, $next);
        dispatch(tr);
        return true;
    }
    const isNextCompatibleWithBlockTaskItem = blockTaskItem && (($next === null || $next === void 0 || (_$next$node = $next.node()) === null || _$next$node === void 0 ? void 0 : _$next$node.type) === taskItem && ($from === null || $from === void 0 || (_$from$node = $from.node()) === null || _$from$node === void 0 ? void 0 : _$from$node.type) === blockTaskItem || ($next === null || $next === void 0 || (_$next$node2 = $next.node()) === null || _$next$node2 === void 0 ? void 0 : _$next$node2.type) === blockTaskItem && ($from === null || $from === void 0 || (_$from$node2 = $from.node()) === null || _$from$node2 === void 0 ? void 0 : _$from$node2.type) === taskItem || [
        taskItem,
        blockTaskItem
    ].includes($next === null || $next === void 0 || (_$next$node3 = $next.node()) === null || _$next$node3 === void 0 ? void 0 : _$next$node3.type) && resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode);
    // if next node is of same type or compatible type, remove the node wrapping and create paragraph
    if (!(0, $2kYwg.isTable)($next.nodeAfter) && (0, $2kYwg.isActionOrDecisionItem)($from.parent) || resultOfCurrentFindBlockTaskItem && resultOfCurrentFindBlockTaskItem.blockTaskItemNode && $f650b4bce8d9bad4$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type or compatible
    ($next.node().type.name === $from.node().type.name || isNextCompatibleWithBlockTaskItem)) {
        if (dispatch) {
            // If next node is in a blockTaskItem paragraph, we need to get the content of the whole blockTaskItem
            // So we reduce the depth by 1 to get to the blockTaskItem node content
            const taskContent = isNextInBlockTaskItemParagraph ? state.doc.slice($next.start($next.depth - 1), $next.end($next.depth - 1)).content : state.doc.slice($next.start(), $next.end()).content;
            let slice;
            try {
                slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                // might be end of document after
                const tr = $f650b4bce8d9bad4$var$splitListItemWith(state.tr, slice, $next, false);
                dispatch(tr);
                return true;
            } catch  {
                // If there's an error creating a paragraph, check if we are in a blockTaskItem
                // Block task item's can have non-text content that cannot be wrapped in a paragraph
                // So if the selection is in a blockTaskItem, just pass the content as is
                if (resultOfNextFindBlockTaskItem && resultOfNextFindBlockTaskItem.blockTaskItemNode) {
                    var _$next$node$firstChil;
                    // Create an array from the fragment to pass into splitListItemWith, as the `content` property is readonly
                    slice = Array.from(taskContent.content);
                    let $splitPos = $next;
                    if ((_$next$node$firstChil = $next.node().firstChild) !== null && _$next$node$firstChil !== void 0 && _$next$node$firstChil.isTextblock) // set $next to the resolved position of inside the textblock
                    $splitPos = $next.doc.resolve($next.pos + 1);
                    const tr = $f650b4bce8d9bad4$var$splitListItemWith(state.tr, slice, $splitPos, false);
                    dispatch(tr);
                    return true;
                }
            }
        }
    }
    return false;
};
const $f650b4bce8d9bad4$var$deleteForwards = (0, $jGkle.autoJoin)((0, $jGkle.chainCommands)((0, $1CiIv.deleteEmptyParagraphAndMoveBlockUp)((0, $2kYwg.isActionOrDecisionList)), $f650b4bce8d9bad4$var$joinTaskDecisionFollowing, $f650b4bce8d9bad4$var$unindentTaskOrUnwrapTaskDecisionFollowing), [
    'taskList',
    'decisionList'
]);
const $f650b4bce8d9bad4$var$deleteExtraListItem = (tr, _$from)=>{
    /*
     After we replace actionItem with empty list item if there's the anomaly of extra empty list item
     the cursor moves inside the first taskItem of splitted taskList
     so the extra list item present above the list item containing taskList & cursor
   */ const $currentFrom = tr.selection.$from;
    const listItemContainingActionList = tr.doc.resolve($currentFrom.start($currentFrom.depth - 2));
    const emptyListItem = tr.doc.resolve(listItemContainingActionList.before() - 1);
    tr.delete(emptyListItem.start(), listItemContainingActionList.pos);
};
const $f650b4bce8d9bad4$var$processNestedActionItem = (tr, $from, previousListItemPos)=>{
    const parentListNode = (0, $2kYwg.findFirstParentListNode)($from);
    const previousChildCountOfList = parentListNode === null || parentListNode === void 0 ? void 0 : parentListNode.node.childCount;
    const currentParentListNode = (0, $2kYwg.findFirstParentListNode)(tr.doc.resolve(tr.mapping.map($from.pos)));
    const currentChildCountOfList = currentParentListNode === null || currentParentListNode === void 0 ? void 0 : currentParentListNode.node.childCount;
    /*
     While replacing range with empty list item an extra list item gets created in some of the scenarios
     After splitting only one extra listItem should be created else an extra listItem is created
   */ if (previousChildCountOfList && currentChildCountOfList && previousChildCountOfList + 1 !== currentChildCountOfList) $f650b4bce8d9bad4$var$deleteExtraListItem(tr, $from);
    // Set custom selection for nested action inside lists using previosuly calculated previousListItem position
    const stableResolvedPos = tr.doc.resolve(previousListItemPos);
    tr.setSelection((0, $801jp.TextSelection).create(tr.doc, stableResolvedPos.after() + 2));
};
const $f650b4bce8d9bad4$var$splitListItemWith = (tr, content, $from, setSelection)=>{
    var _frag$firstChild;
    const origDoc = tr.doc;
    const { blockTaskItem: blockTaskItem, taskList: taskList } = tr.doc.type.schema.nodes;
    let baseDepth = $from.depth;
    let $oldAfter = origDoc.resolve($from.after());
    let textSelectionModifier = 0;
    let replaceFromModifier = 0;
    let deleteBlockModifier = 0;
    let shouldSplitBlockTaskItem = true;
    let isGapCursorSelection = false;
    let hasBlockTaskItem = false;
    if (blockTaskItem) {
        const result = (0, $dLTQs.findBlockTaskItem)($from);
        if (result) {
            const { blockTaskItemNode: blockTaskItemNode, hasParagraph: hasParagraph } = result;
            hasBlockTaskItem = !!blockTaskItemNode;
            if (blockTaskItemNode) {
                var _$oldAfter$nodeAfter, _$posPreviousSibling$;
                // If the case there is a paragraph in the block task item we need to
                // adjust some calculations
                if (hasParagraph) {
                    baseDepth = $from.depth - 1;
                    $oldAfter = origDoc.resolve($from.after(baseDepth));
                    // When we're removing the extra empty task item we need to reduce the range a bit
                    deleteBlockModifier = 1;
                } else {
                    textSelectionModifier = 1;
                    isGapCursorSelection = true;
                }
                textSelectionModifier = 1;
                const hasSiblingTaskList = ((_$oldAfter$nodeAfter = $oldAfter.nodeAfter) === null || _$oldAfter$nodeAfter === void 0 ? void 0 : _$oldAfter$nodeAfter.type) === taskList;
                if (hasSiblingTaskList) // Don't use the split command if there is a sibling taskList
                shouldSplitBlockTaskItem = false;
                const posPreviousSibling = $from.start(hasParagraph ? $from.depth - 1 : $from.depth) - 1;
                const $posPreviousSibling = tr.doc.resolve(posPreviousSibling);
                const hasPreviousTaskItem = ((_$posPreviousSibling$ = $posPreviousSibling.nodeBefore) === null || _$posPreviousSibling$ === void 0 ? void 0 : _$posPreviousSibling$.type) === blockTaskItem;
                if (hasPreviousTaskItem && hasParagraph) replaceFromModifier = 1;
            }
        }
    }
    // split just before the current item
    // we can only split if there was a list item before us
    const container = $from.node(baseDepth - 2);
    const posInList = $from.index(baseDepth - 1);
    const shouldSplit = !(!(0, $2kYwg.isActionOrDecisionList)(container) && posInList === 0) && shouldSplitBlockTaskItem;
    const frag = (0, $7H6Cr.Fragment).from(content);
    const isNestedActionInsideLists = frag.childCount === 1 && ((_frag$firstChild = frag.firstChild) === null || _frag$firstChild === void 0 ? void 0 : _frag$firstChild.type.name) === 'listItem';
    /*
   * We don't split the list item if it's nested inside lists
   * to have consistent behaviour and their resolution.
   */ if (shouldSplit && !isNestedActionInsideLists) // this only splits a node to delete it, so we probably don't need a random uuid
    // but generate one anyway for correctness
    tr = tr.split($from.pos, hasBlockTaskItem ? 0 : 1, [
        {
            type: $from.parent.type,
            attrs: {
                localId: (0, $1FHzN.uuid).generate()
            }
        }
    ]);
    /*
   * In case of nested action inside lists we explicitly set the cursor
   * We need to insert it relatively to previous doc structure
   * So we calculate the position of previous list item and save that position
   * (The cursor can be placed easily next to list item)
   */ const previousListItemPos = isNestedActionInsideLists ? $from.start(baseDepth - 2) : 0;
    tr = tr.replace(tr.mapping.map($from.start(baseDepth) - 2 + replaceFromModifier), tr.mapping.map($from.end(baseDepth) + 2), frag.size ? new (0, $7H6Cr.Slice)(frag, 0, 0) : (0, $7H6Cr.Slice).empty);
    if (setSelection && !isNestedActionInsideLists) {
        const newPos = $from.pos + 1 - ((shouldSplit ? 0 : 2) + textSelectionModifier);
        if (isGapCursorSelection) tr = tr.setSelection(new (0, $ihNBw.GapCursorSelection)(tr.doc.resolve(newPos), (0, $id3e6.Side).LEFT));
        else tr = tr.setSelection(new (0, $801jp.TextSelection)(tr.doc.resolve(newPos)));
    }
    // if different levels then we shouldn't lift
    if ($oldAfter.depth === baseDepth - 1) {
        if ($oldAfter.nodeAfter && (0, $2kYwg.isActionOrDecisionList)($oldAfter.nodeAfter)) {
            // getBlockRange expects to be inside the taskItem
            const pos = tr.mapping.map($oldAfter.pos + 2);
            const $after = tr.doc.resolve(pos);
            const blockRange = (0, $2kYwg.getBlockRange)({
                $from: $after,
                $to: tr.doc.resolve($after.after($after.depth - 1) - 1)
            });
            if (blockRange) tr = tr.lift(blockRange, blockRange.depth - 1).scrollIntoView();
            // After replacing the range there is an empty task item that
            // we need to remove.
            // We delete 1 past the range of the empty taskItem
            // otherwise we hit a bug in prosemirror-transform:
            // Cannot read property 'content' of undefined
            // If this operation was done on a blockTaskItem we
            // have a modifier for the position
            tr = tr.deleteRange(pos - 3 - deleteBlockModifier, pos - 1 - deleteBlockModifier);
        }
    }
    if (isNestedActionInsideLists) $f650b4bce8d9bad4$var$processNestedActionItem(tr, $from, previousListItemPos);
    return tr;
};
const $f650b4bce8d9bad4$var$creatParentListItemFragement = (state)=>{
    return state.schema.nodes.listItem.create({}, state.schema.nodes.paragraph.create());
};
const $f650b4bce8d9bad4$var$getCurrentBlockTaskFontSizeAttrs = (state, $from)=>{
    const { fontSize: fontSize } = state.schema.marks;
    if (!fontSize) return false;
    const result = (0, $dLTQs.findBlockTaskItem)($from);
    if (!result) return false;
    return result.hasParagraph ? (0, $5dJa8.getBlockMarkAttrs)($from.parent, fontSize) : (0, $5dJa8.getFirstParagraphBlockMarkAttrs)(result.blockTaskItemNode, fontSize);
};
const $f650b4bce8d9bad4$var$createTaskItemForCurrentTextSize = (state, attrs, fontSizeAttrs)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    if (fontSizeAttrs && blockTaskItem && paragraph && fontSize) return blockTaskItem.createChecked(attrs, paragraph.createChecked({}, undefined, [
        fontSize.create(fontSizeAttrs)
    ]));
    return taskItem.createAndFill(attrs);
};
const $f650b4bce8d9bad4$var$splitListItem = (state, dispatch)=>{
    const { tr: tr, selection: { $from: $from } } = state;
    const { listItem: listItem, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph } = state.schema.nodes;
    const currentBlockTaskFontSizeAttrs = $f650b4bce8d9bad4$var$getCurrentBlockTaskFontSizeAttrs(state, $from);
    if ($f650b4bce8d9bad4$var$actionDecisionFollowsOrNothing($from)) {
        if (dispatch) {
            // If previous node is a blockTaskItem we just want to delete the existing node and replace it with a paragraph
            const nodeBefore = state.doc.resolve($from.pos - 1).nodeBefore;
            if (blockTaskItem && (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) === blockTaskItem) {
                if ($from.parent.type === taskItem) {
                    const nodeSize = $from.parent.nodeSize;
                    tr.delete($from.pos - Math.floor(nodeSize / 2), $from.pos + Math.ceil(nodeSize / 2));
                    tr.insert($from.pos, paragraph.createChecked());
                    dispatch(tr);
                    return true;
                }
            }
            if ((0, $a4TQr.hasParentNodeOfType)(listItem)(tr.selection)) {
                // if we're inside a list item, then we pass in a fragment containing a new list item not a paragraph
                dispatch($f650b4bce8d9bad4$var$splitListItemWith(tr, $f650b4bce8d9bad4$var$creatParentListItemFragement(state), $from, true));
                return true;
            }
            const splitTr = $f650b4bce8d9bad4$var$splitListItemWith(tr, paragraph.createChecked(), $from, true);
            if (currentBlockTaskFontSizeAttrs) (0, $5dJa8.reconcileBlockMarkForParagraphAtPos)(splitTr, splitTr.selection.from, state.schema.marks.fontSize, currentBlockTaskFontSizeAttrs);
            dispatch(splitTr);
        }
        return true;
    }
    return false;
};
const $f650b4bce8d9bad4$var$enter = (editorAnalyticsAPI, getContextIdentifier)=>(0, $5mojd.filter)((0, $2kYwg.isInsideTaskOrDecisionItem), (0, $jGkle.chainCommands)((0, $5mojd.filter)((0, $2kYwg.isEmptyTaskDecision), (0, $jGkle.chainCommands)($f650b4bce8d9bad4$export$d5d1010fad3453fa(editorAnalyticsAPI)(), $f650b4bce8d9bad4$var$splitListItem)), (state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        const { decisionItem: decisionItem, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        const { $from: $from, $to: $to } = selection;
        const node = $from.node($from.depth);
        let nodeType = node && node.type;
        // Get the parent node type if the current node type is not one of the task or decision items
        // This is required to handle blockTaskItem
        if (![
            decisionItem,
            taskItem,
            blockTaskItem
        ].includes(nodeType)) {
            var _findParentNodeOfType;
            const possibleNodeType = (_findParentNodeOfType = (0, $a4TQr.findParentNodeOfType)([
                decisionItem,
                taskItem,
                blockTaskItem
            ])(selection)) === null || _findParentNodeOfType === void 0 || (_findParentNodeOfType = _findParentNodeOfType.node) === null || _findParentNodeOfType === void 0 ? void 0 : _findParentNodeOfType.type;
            if (possibleNodeType) nodeType = possibleNodeType;
        }
        const listType = [
            taskItem,
            blockTaskItem
        ].includes(nodeType) ? 'taskList' : 'decisionList';
        const addItem = ({ tr: tr, itemLocalId: itemLocalId })=>{
            // ED-8932: When cursor is at the beginning of a task item, instead of split, we insert above.
            if ($from.pos === $to.pos && $from.parentOffset === 0 && (nodeType !== blockTaskItem || !$from.parent.isTextblock || (0, $2kYwg.isInFirstTextblockOfBlockTaskItem)(state))) {
                const newTask = nodeType.createAndFill({
                    localId: itemLocalId
                });
                if (newTask) {
                    if (nodeType === blockTaskItem) {
                        const blockTaskItemNode = (0, $a4TQr.findParentNodeOfType)([
                            blockTaskItem
                        ])(selection);
                        // New task items for blockTaskItem should be taskItem
                        // We want to prevent creating new blockTaskItems as much as possible
                        const newTaskItem = taskItem.createAndFill({
                            localId: itemLocalId
                        });
                        if (!blockTaskItemNode || !newTaskItem) return tr;
                        return tr.insert(blockTaskItemNode.pos, newTaskItem);
                    }
                    // Current position will point to text node, but we want to insert above the taskItem node
                    const insertPos = $from.pos - 1;
                    tr.insert(insertPos, newTask);
                    // Place cursor on the newly inserted empty task item above
                    // when nested inside another taskList.
                    const { taskList: taskListType } = schema.nodes;
                    const parentTaskList = $from.node($from.depth - 1);
                    const grandparent = $from.depth >= 3 ? $from.node($from.depth - 2) : null;
                    if ((parentTaskList === null || parentTaskList === void 0 ? void 0 : parentTaskList.type) === taskListType && (grandparent === null || grandparent === void 0 ? void 0 : grandparent.type) === taskListType) tr.setSelection((0, $801jp.TextSelection).create(tr.doc, insertPos + 1));
                    return tr;
                }
            }
            /**
     * For blockTaskItem, must handle it differently because it can have a different depth
     */ if (nodeType === blockTaskItem) {
                var _$from$parent;
                const blockTaskItemNode = (0, $a4TQr.findParentNodeOfType)([
                    blockTaskItem
                ])(selection);
                if (!blockTaskItemNode) return tr;
                // If the selection is a gap cursor at the end of the blockTaskItem,
                // we should insert a new taskItem.
                if ((!$from.parent.isTextblock || (0, $2kYwg.isInLastTextblockOfBlockTaskItem)(state)) && $from.parentOffset === $from.parent.nodeSize - 2) {
                    const currentBlockTaskFontSizeAttrs = $f650b4bce8d9bad4$var$getCurrentBlockTaskFontSizeAttrs(state, $from);
                    const newTaskNode = $f650b4bce8d9bad4$var$createTaskItemForCurrentTextSize(state, {
                        localId: itemLocalId
                    }, currentBlockTaskFontSizeAttrs);
                    if (newTaskNode) {
                        tr.insert(blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize, newTaskNode);
                        // Move the cursor to the end of the newly inserted blockTaskItem
                        tr.setSelection((0, $801jp.TextSelection).create(tr.doc, blockTaskItemNode.pos + blockTaskItemNode.node.nodeSize + 1));
                        return tr;
                    }
                }
                // Split near the depth of the current selection
                const splitTr = tr.split($from.pos, $from !== null && $from !== void 0 && (_$from$parent = $from.parent) !== null && _$from$parent !== void 0 && _$from$parent.isTextblock ? 2 : 1, [
                    {
                        type: blockTaskItem,
                        attrs: {
                            localId: itemLocalId
                        }
                    }
                ]);
                const currentBlockTaskFontSizeAttrs = $f650b4bce8d9bad4$var$getCurrentBlockTaskFontSizeAttrs(state, $from);
                if (currentBlockTaskFontSizeAttrs) (0, $5dJa8.reconcileBlockMarkForParagraphAtPos)(splitTr, splitTr.selection.from, state.schema.marks.fontSize, currentBlockTaskFontSizeAttrs);
                return splitTr;
            }
            return tr.split($from.pos, 1, [
                {
                    type: nodeType,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]);
        };
        const insertTr = (0, $8ZI3Z.insertTaskDecisionWithAnalytics)(editorAnalyticsAPI, getContextIdentifier)(state, listType, (0, $3LeME.INPUT_METHOD).KEYBOARD, addItem);
        if (insertTr && dispatch) {
            insertTr.scrollIntoView();
            dispatch(insertTr);
        }
        return true;
    }));
const $f650b4bce8d9bad4$var$cmdOptEnter = (0, $5mojd.filter)((0, $2kYwg.isInsideTaskOrDecisionItem), (state, dispatch)=>{
    const { selection: selection, schema: schema } = state;
    const { taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const nodeType = node && node.type;
    const nodePos = $from.before($from.depth);
    if (nodeType === taskItem) {
        const tr = state.tr;
        tr.step(new (0, $10F96.SetAttrsStep)(nodePos, {
            state: node.attrs.state === 'TODO' ? 'DONE' : 'TODO',
            localId: node.attrs.localId
        }));
        if (tr && dispatch) dispatch(tr);
    }
    return true;
});
function $f650b4bce8d9bad4$export$e832373cff8dec22(_schema, api, allowNestedTasks, consumeTabs) {
    var _api$analytics4, _api$analytics5;
    const getContextIdentifier = ()=>{
        var _api$contextIdentifie;
        return api === null || api === void 0 || (_api$contextIdentifie = api.contextIdentifier) === null || _api$contextIdentifie === void 0 || (_api$contextIdentifie = _api$contextIdentifie.sharedState.currentState()) === null || _api$contextIdentifie === void 0 ? void 0 : _api$contextIdentifie.contextIdentifierProvider;
    };
    const indentHandlers = {
        'Shift-Tab': (0, $5mojd.filter)([
            (0, $2kYwg.isInsideTaskOrDecisionItem),
            (state)=>!$f650b4bce8d9bad4$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>{
            var _api$analytics;
            return $f650b4bce8d9bad4$export$d5d1010fad3453fa(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $3LeME.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs;
        }),
        Tab: (0, $5mojd.filter)([
            (0, $2kYwg.isInsideTaskOrDecisionItem),
            (state)=>!$f650b4bce8d9bad4$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>{
            var _api$analytics2;
            return $f650b4bce8d9bad4$export$b294289254b8cdac(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)((0, $3LeME.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs;
        })
    };
    const defaultHandlers = consumeTabs ? {
        'Shift-Tab': (0, $2kYwg.isInsideTaskOrDecisionItem),
        Tab: (0, $2kYwg.isInsideTaskOrDecisionItem)
    } : {};
    const toggleTaskListShortcut = (state, dispatch)=>{
        if (!state.schema.nodes.taskItem) return false;
        if (dispatch) {
            var _api$analytics3;
            const command = (0, $6V8KD.toggleTaskList)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions)();
            const tr = command({
                tr: state.tr
            });
            if (tr) {
                dispatch(tr);
                return true;
            }
        }
        return false;
    };
    const keymaps = {
        Backspace: $f650b4bce8d9bad4$var$backspace(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions),
        Delete: $f650b4bce8d9bad4$var$deleteForwards,
        'Ctrl-d': $f650b4bce8d9bad4$var$deleteForwards,
        Enter: $f650b4bce8d9bad4$var$enter(api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions, getContextIdentifier),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $eUtBU.toggleTaskItemCheckbox).common]: $f650b4bce8d9bad4$var$cmdOptEnter,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $eUtBU.toggleTaskList).common]: toggleTaskListShortcut,
        ...allowNestedTasks ? indentHandlers : defaultHandlers
    };
    return (0, $1O8Lw.keymap)(keymaps);
}
var $f650b4bce8d9bad4$export$2e2bcd8739ae039 = $f650b4bce8d9bad4$export$e832373cff8dec22;

});
parcelRegister("efwJc", function(module, exports) {
$parcel$export(module.exports, "moveSelectedTaskListItems", () => $3951a6ccd06f1569$export$6de6f04870a23f53);

var $aBiLC = parcelRequire("aBiLC");

var $d2cyu = parcelRequire("d2cyu");

var $7O3py = parcelRequire("7O3py");

var $39oqF = parcelRequire("39oqF");

var $a2RKK = parcelRequire("a2RKK");
const $3951a6ccd06f1569$var$MAX_TASK_LIST_DEPTH = 6;
function $3951a6ccd06f1569$export$6de6f04870a23f53(tr, indentDelta) {
    const { doc: doc, selection: selection } = tr;
    const { schema: schema } = doc.type;
    const { taskList: taskList } = schema.nodes;
    const { $from: $from, $to: $to } = selection;
    const rootListResult = (0, $39oqF.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!rootListResult) return null;
    const rootListStart = rootListResult.pos;
    const rootListEnd = rootListStart + rootListResult.node.nodeSize;
    const flattenResult = (0, $a2RKK.flattenTaskList)({
        doc: doc,
        rootListStart: rootListStart,
        rootListEnd: rootListEnd,
        selectionFrom: $from.pos,
        selectionTo: $to.pos,
        indentDelta: indentDelta,
        maxDepth: $3951a6ccd06f1569$var$MAX_TASK_LIST_DEPTH
    });
    if (!flattenResult) return null;
    const { items: flattenedItems, startIndex: startIndex, endIndex: endIndex } = flattenResult;
    const { fragment: fragment, contentStartOffsets: contentStartOffsets } = (0, $aBiLC.buildReplacementFragment)({
        items: flattenedItems,
        schema: schema,
        rebuildFn: (0, $a2RKK.rebuildTaskList),
        extractContentFn: (item, s)=>{
            // Extract task item content for breakout.
            // taskItem has inline content, so wrap in a paragraph.
            // blockTaskItem already has paragraph children.
            const { blockTaskItem: blockTaskItem } = s.nodes;
            if (!!blockTaskItem && item.node.type === blockTaskItem) {
                // blockTaskItem children are already paragraphs/extensions
                const children = [];
                item.node.forEach((child)=>children.push(child));
                return children;
            }
            // Regular taskItem — wrap inline content in a paragraph
            return [
                s.nodes.paragraph.create(null, item.node.content)
            ];
        }
    });
    if (fragment.size === 0) return null;
    // Narrow the replacement to the minimal changed range for collab-friendly
    // cursor preservation on unaffected list items.
    const narrowed = (0, $d2cyu.narrowReplacementRange)(tr.doc, rootListStart, rootListEnd, fragment, contentStartOffsets);
    tr.replaceWith(narrowed.start, narrowed.end, narrowed.fragment);
    const { from: from, to: to } = (0, $7O3py.computeSelectionOffsets)({
        items: flattenedItems,
        startIndex: startIndex,
        endIndex: endIndex,
        originalFrom: $from.pos,
        originalTo: $to.pos,
        contentStartOffsets: narrowed.adjustedContentStartOffsets,
        rootListStart: narrowed.start,
        docSize: tr.doc.content.size
    });
    (0, $7O3py.restoreSelection)({
        tr: tr,
        originalSelection: selection,
        from: from,
        to: to
    });
    tr.scrollIntoView();
    return tr;
}

});
parcelRegister("a2RKK", function(module, exports) {
$parcel$export(module.exports, "flattenTaskList", () => $2519e9202970b5c5$export$f41b6e46f49afc20);
$parcel$export(module.exports, "rebuildTaskList", () => $2519e9202970b5c5$export$50c9fbf449dfc27);

var $1FHzN = parcelRequire("1FHzN");
function $2519e9202970b5c5$export$f41b6e46f49afc20(options) {
    const { doc: doc, rootListStart: rootListStart, rootListEnd: rootListEnd, selectionFrom: selectionFrom, selectionTo: selectionTo, indentDelta: indentDelta, maxDepth: maxDepth } = options;
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = doc.type.schema.nodes;
    const items = [];
    let startIndex = -1;
    let endIndex = -1;
    let exceedsMaxDepth = false;
    const rootDepth = doc.resolve(rootListStart).depth;
    const isPointSelection = selectionFrom === selectionTo;
    doc.nodesBetween(rootListStart, rootListEnd, (node, pos, parent)=>{
        const isTaskItemType = node.type === taskItem || blockTaskItem != null && node.type === blockTaskItem;
        if (!isTaskItemType || parent == null || parent.type !== taskList) return true;
        const start = pos;
        const end = pos + node.nodeSize;
        const isSelected = isPointSelection ? selectionFrom >= start && selectionFrom <= end : start < selectionTo && end > selectionFrom;
        const depth = doc.resolve(pos).depth - rootDepth - 1 + (isSelected ? indentDelta : 0);
        items.push({
            node: node,
            pos: pos,
            depth: depth,
            isSelected: isSelected,
            listType: parent.type.name,
            parentListAttrs: parent.attrs
        });
        if (isSelected) {
            const index = items.length - 1;
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            if (maxDepth != null && depth >= maxDepth) exceedsMaxDepth = true;
        }
        return true;
    });
    if (items.length === 0 || startIndex === -1 || exceedsMaxDepth) return null;
    return {
        items: items,
        startIndex: startIndex,
        endIndex: endIndex
    };
}
function $2519e9202970b5c5$export$50c9fbf449dfc27(items, schema) {
    const { taskList: taskList } = schema.nodes;
    const contentStartOffsets = new Array(items.length);
    if (items.length === 0) return null;
    // Start with the root level (depth -1 represents the root taskList wrapper)
    const stack = [
        {
            depth: -1,
            children: [],
            hasSelectedItems: false,
            listAttrs: items[0].parentListAttrs,
            sourceParentAttrs: items[0].parentListAttrs
        }
    ];
    for (const item of items){
        const targetDepth = item.depth;
        // Pop stack entries strictly deeper than target, wrapping them into taskLists
        while(stack.length > 1 && stack[stack.length - 1].depth > targetDepth){
            const popped = stack.pop();
            if (!popped) break;
            const attrs = popped.listAttrs ?? {
                localId: (0, $1FHzN.uuid).generate()
            };
            const wrappedList = taskList.create(attrs, popped.children);
            stack[stack.length - 1].children.push(wrappedList);
        }
        // If the stack top is at the same depth as the target, decide whether
        // to merge into the existing entry or close it and start a new one.
        // Unselected items from different original parent taskLists get
        // separate wrappers (preserving original nesting). Selected (moved)
        // items always merge with whatever is already at the target depth,
        // since they're being placed into a new structural context.
        // However, if the current entry already contains selected (moved) items,
        // we do NOT split — the unselected sibling should join the same wrapper
        // because the selected item established the new structural context.
        if (stack.length > 1 && stack[stack.length - 1].depth === targetDepth && !item.isSelected) {
            const top = stack[stack.length - 1];
            if (top.sourceParentAttrs !== item.parentListAttrs && !top.hasSelectedItems) {
                const popped = stack.pop();
                if (!popped) break;
                const attrs = popped.listAttrs ?? {
                    localId: (0, $1FHzN.uuid).generate()
                };
                const wrappedList = taskList.create(attrs, popped.children);
                stack[stack.length - 1].children.push(wrappedList);
            }
        }
        // Push new stack entries to reach the target depth.
        // Skip intermediate entries at depth 0 — depth-0 items belong
        // directly in the root entry (depth -1), so we only need
        // intermediates for depths > 1.
        while(stack[stack.length - 1].depth < targetDepth - 1){
            const nextDepth = Math.max(stack[stack.length - 1].depth + 1, 1);
            stack.push({
                depth: nextDepth,
                children: [],
                hasSelectedItems: false,
                listAttrs: item.isSelected ? null : item.parentListAttrs,
                sourceParentAttrs: item.parentListAttrs
            });
        }
        // Add the item at the target depth
        if (targetDepth === 0) {
            // Depth 0 items go directly into the root taskList
            stack[0].children.push(item.node);
            if (item.isSelected) stack[0].hasSelectedItems = true;
        } else {
            // Ensure there's a stack entry at depth targetDepth to hold this item
            if (stack[stack.length - 1].depth < targetDepth) stack.push({
                depth: targetDepth,
                children: [],
                hasSelectedItems: false,
                listAttrs: item.isSelected ? null : item.parentListAttrs,
                sourceParentAttrs: item.parentListAttrs
            });
            stack[stack.length - 1].children.push(item.node);
            if (item.isSelected) stack[stack.length - 1].hasSelectedItems = true;
        }
    }
    // Close remaining stack entries
    while(stack.length > 1){
        const popped = stack.pop();
        if (!popped) break;
        const attrs = popped.listAttrs ?? {
            localId: (0, $1FHzN.uuid).generate()
        };
        const wrappedList = taskList.create(attrs, popped.children);
        stack[stack.length - 1].children.push(wrappedList);
    }
    // The root entry's children form the root taskList.
    // Preserve the root's original attrs when available.
    const rootChildren = stack[0].children;
    const rootAttrs = stack[0].listAttrs ?? {
        localId: (0, $1FHzN.uuid).generate()
    };
    const rootList = taskList.create(rootAttrs, rootChildren);
    // Compute contentStartOffsets by walking the rebuilt tree.
    // Each taskItem's content starts at (pos_within_root + 1) for the taskItem opening tag.
    // We add +1 for the root taskList's opening tag.
    const isTaskItemType = (node)=>{
        const { taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
        return node.type === taskItem || blockTaskItem != null && node.type === blockTaskItem;
    };
    let itemIdx = 0;
    rootList.descendants((node, pos)=>{
        if (isTaskItemType(node) && itemIdx < items.length) {
            // pos is relative to rootList content start;
            // +1 for rootList's opening tag, +1 for taskItem's opening tag
            contentStartOffsets[itemIdx] = 1 + pos + 1;
            itemIdx++;
        }
        return true;
    });
    return {
        node: rootList,
        contentStartOffsets: contentStartOffsets
    };
}

});


parcelRegister("gc0AM", function(module, exports) {
$parcel$export(module.exports, "joinAtCut", () => $3ccf28891acb15d9$export$3553eb36282f092b);

var $2ORlQ = parcelRequire("2ORlQ");

var $5dJa8 = parcelRequire("5dJa8");

var $5ViSg = parcelRequire("5ViSg");

var $k2WVn = parcelRequire("k2WVn");

var $2kYwg = parcelRequire("2kYwg");

var $bC4Dj = parcelRequire("bC4Dj");
const $3ccf28891acb15d9$export$3553eb36282f092b = ($pos)=>(state, dispatch)=>{
        const $cut = (0, $2ORlQ.findCutBefore)($pos);
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        const { fontSize: fontSize } = state.schema.marks;
        if (!$cut) return false;
        const { paragraph: paragraph } = $cut.doc.type.schema.nodes;
        // find the boundary between the taskList and paragraph
        if ($cut.nodeBefore && (0, $2kYwg.isActionOrDecisionList)($cut.nodeBefore) && $cut.nodeAfter && $cut.nodeAfter.type === paragraph) {
            // we'll find the boundary of a taskList
            // so resolve -1 to find the inside end of the last taskItem
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            // might have deeply nested taskList, keep trying to find it
            while(!(0, $2kYwg.isActionOrDecisionItem)($lastNode.parent))$lastNode = state.doc.resolve($lastNode.pos - 1);
            // grab the structure between the taskItem and the paragraph
            // note: structure = true in ReplaceAroundStep
            let slice = state.tr.doc.slice($lastNode.pos, $cut.pos);
            let from = $lastNode.pos;
            const to = $cut.pos + $cut.nodeAfter.nodeSize;
            let gapFrom = $cut.pos + 1;
            let gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
            const insert = 0;
            if (blockTaskItem) {
                if ($lastNode.parent.type === blockTaskItem) {
                    const childOfLastNode = state.doc.resolve($lastNode.pos - 1);
                    if (childOfLastNode.parent.type === paragraph) {
                        // Recalculate the slice to include the full blockTaskItem structure
                        slice = state.tr.doc.slice(childOfLastNode.pos, $cut.pos);
                        // Need to move one pos in to get to the text node of the paragraph
                        from = $lastNode.pos - 1;
                    } else {
                        // If the blockTaskItem last node is not a paragraph
                        // Expand the gap to include the paragraph being merged
                        gapFrom = $cut.pos; // To get the actual paragraph node
                        gapTo = $cut.pos + $cut.nodeAfter.nodeSize - 1;
                    }
                }
            }
            // collapse the range between end of last taskItem and after the paragraph
            // with the gap being the paragraph's content (i.e. take that content)
            //
            // we pass the structure we found earlier to join the p and taskItem nodes
            //
            // see https://prosemirror.net/docs/ref/#transform.ReplaceStep.constructor
            // see https://prosemirror.net/docs/ref/#transform.ReplaceAroundStep.constructor
            let tr = state.tr.step(new (0, $k2WVn.ReplaceAroundStep)(from, to, gapFrom, gapTo, slice, insert, true));
            if (fontSize) {
                const targetTaskListSmallTextAttrs = (0, $5dJa8.getFirstParagraphBlockMarkAttrs)($cut.nodeBefore, fontSize);
                const followingListPos = $cut.pos + $cut.nodeAfter.nodeSize;
                const followingListNode = state.doc.resolve(followingListPos).nodeAfter;
                if (followingListNode && (0, $5ViSg.isTaskList)(followingListNode.type)) {
                    const normalizedListNode = (0, $bC4Dj.normalizeNodeForTaskTextSize)(followingListNode, state.schema, targetTaskListSmallTextAttrs)[0];
                    if (normalizedListNode && normalizedListNode !== followingListNode) {
                        const mappedFollowingListPos = tr.mapping.map(followingListPos);
                        const currentFollowingListNode = tr.doc.nodeAt(mappedFollowingListPos);
                        if (currentFollowingListNode) tr = tr.replaceWith(mappedFollowingListPos, mappedFollowingListPos + currentFollowingListNode.nodeSize, normalizedListNode);
                    }
                }
            }
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("5ViSg", function(module, exports) {
$parcel$export(module.exports, "isTaskList", () => $635c68606e8545f6$export$adef7a5f125e0514);
const $635c68606e8545f6$export$adef7a5f125e0514 = (nodeType)=>{
    return nodeType.name === 'taskList';
};

});

parcelRegister("bC4Dj", function(module, exports) {
$parcel$export(module.exports, "normalizeNodeForTaskTextSize", () => $23ea600872e4ce08$export$aabf20f2ccae32df);
$parcel$export(module.exports, "tempTransformSliceToRemoveBlockTaskItem", () => $23ea600872e4ce08$export$7e04b173e2b79898);

var $1FHzN = parcelRequire("1FHzN");

var $5dJa8 = parcelRequire("5dJa8");

var $fl3FO = parcelRequire("fl3FO");
var $5ViSg = parcelRequire("5ViSg");

var $7H6Cr = parcelRequire("7H6Cr");
/**
 * Transforms a paste slice to handle blockTaskItem nodes when pasting into task items.
 *
 * Initially we do not support user creation of blockTaskItem - it is intended primarily
 * for TinyMCE migration purposes however that may change in the future.
 * This function handles the behavior to work around Prosemirror behaviour which decides
 * that blockTaskItem is the appropriate node to use here.
 *
 * @param slice - The slice being pasted
 * @param view - The editor view where the paste is occurring
 * @returns The transformed slice with blockTaskItems converted to taskItems when appropriate
 *
 * @example
 * ```typescript
 * const transformedSlice = tempTransformSliceToRemoveBlockTaskItem(pasteSlice, editorView);
 * ```
 *
 * @see {@link https://hello.atlassian.net/wiki/spaces/EDITOR/pages/5626622054/Block+elements+in+task+-+Decision+log#Can-users-create-block-task-items%3F} for reasoning
 */ const $23ea600872e4ce08$var$getTaskPasteContext = (view)=>{
    var _schema$marks;
    const { schema: schema, selection: selection } = view.state;
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    const fontSize = (_schema$marks = schema.marks) === null || _schema$marks === void 0 ? void 0 : _schema$marks.fontSize;
    const { $from: $from } = selection;
    const currentParent = $from.parent;
    const currentNode = typeof $from.node === 'function' ? $from.node() : undefined;
    if ((currentParent === null || currentParent === void 0 ? void 0 : currentParent.type) === taskItem || (currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) === taskItem) return {
        isInTaskContext: true,
        smallTextAttrs: false
    };
    if (!blockTaskItem) return {
        isInTaskContext: false,
        smallTextAttrs: false
    };
    if ((currentParent === null || currentParent === void 0 ? void 0 : currentParent.type) === blockTaskItem || (currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) === blockTaskItem) return {
        isInTaskContext: true,
        smallTextAttrs: fontSize ? (0, $5dJa8.getFirstParagraphBlockMarkAttrs)(currentParent ?? currentNode, fontSize) : false
    };
    if ((currentParent === null || currentParent === void 0 ? void 0 : currentParent.type) === paragraph && $from.depth > 0 && $from.node($from.depth - 1).type === blockTaskItem) return {
        isInTaskContext: true,
        smallTextAttrs: fontSize ? (0, $5dJa8.getBlockMarkAttrs)(currentParent, fontSize) : false
    };
    return {
        isInTaskContext: false,
        smallTextAttrs: false
    };
};
const $23ea600872e4ce08$var$convertTaskItemToBlockTaskItem = (node, schema, smallTextAttrs)=>{
    const { fontSize: fontSize } = schema.marks;
    return (0, $fl3FO.createBlockTaskItem)({
        attrs: node.attrs,
        content: node.content,
        marks: [
            fontSize.create(smallTextAttrs)
        ],
        schema: schema
    });
};
const $23ea600872e4ce08$var$addSmallTextToBlockTaskItem = (node, schema, smallTextAttrs)=>{
    const { paragraph: paragraph } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    const newContent = [];
    node.content.forEach((child)=>{
        if (child.type === paragraph) newContent.push(paragraph.createChecked(child.attrs, child.content, child.marks.filter((mark)=>mark.type !== fontSize).concat(fontSize.create(smallTextAttrs))));
        else newContent.push(child);
    });
    return node.type.create(node.attrs, newContent);
};
const $23ea600872e4ce08$var$normalizeBlockTaskItemToTaskItems = (node, schema)=>{
    const { taskItem: taskItem, blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    if (!blockTaskItem || node.type !== blockTaskItem) return [
        node
    ];
    let allChildrenAreParagraphs = true;
    node.content.forEach((child)=>{
        if (child.type !== paragraph) allChildrenAreParagraphs = false;
    });
    if (allChildrenAreParagraphs && node.childCount > 0) {
        const transformedContent = [];
        node.content.forEach((paragraphNode)=>{
            transformedContent.push(taskItem.create({
                localId: (0, $1FHzN.uuid).generate(),
                state: node.attrs.state || 'TODO'
            }, paragraphNode.content));
        });
        return transformedContent;
    }
    return [
        node
    ];
};
const $23ea600872e4ce08$var$transformSliceContent = (slice, transformNode)=>{
    const transformedContent = [];
    slice.content.forEach((node)=>{
        transformedContent.push(...transformNode(node));
    });
    if (transformedContent.length !== slice.content.childCount || transformedContent.some((node, idx)=>node !== slice.content.child(idx))) {
        const newFragment = (0, $7H6Cr.Fragment).from(transformedContent);
        return new (0, $7H6Cr.Slice)(newFragment, slice.openStart, slice.openEnd);
    }
    return slice;
};
const $23ea600872e4ce08$export$aabf20f2ccae32df = (node, schema, smallTextAttrs)=>{
    const { taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    if (!smallTextAttrs) return [
        node
    ];
    if ((0, $5ViSg.isTaskList)(node.type)) {
        const transformedChildren = [];
        node.content.forEach((child)=>{
            transformedChildren.push(...$23ea600872e4ce08$export$aabf20f2ccae32df(child, schema, smallTextAttrs));
        });
        return [
            taskList.create(node.attrs, transformedChildren)
        ];
    }
    if (blockTaskItem && fontSize) {
        if (node.type === taskItem) return [
            $23ea600872e4ce08$var$convertTaskItemToBlockTaskItem(node, schema, smallTextAttrs)
        ];
        if (node.type === blockTaskItem) return [
            $23ea600872e4ce08$var$addSmallTextToBlockTaskItem(node, schema, smallTextAttrs)
        ];
    }
    return [
        node
    ];
};
const $23ea600872e4ce08$var$normalizeNodeForTaskPaste = (node, schema, smallTextAttrs)=>{
    if (smallTextAttrs) return $23ea600872e4ce08$export$aabf20f2ccae32df(node, schema, smallTextAttrs);
    return $23ea600872e4ce08$var$normalizeBlockTaskItemToTaskItems(node, schema);
};
const $23ea600872e4ce08$export$7e04b173e2b79898 = (slice, view)=>{
    const { blockTaskItem: blockTaskItem } = view.state.schema.nodes;
    const { isInTaskContext: isInTaskContext, smallTextAttrs: smallTextAttrs } = $23ea600872e4ce08$var$getTaskPasteContext(view);
    if (!isInTaskContext || !blockTaskItem) return slice;
    return $23ea600872e4ce08$var$transformSliceContent(slice, (node)=>$23ea600872e4ce08$var$normalizeNodeForTaskPaste(node, view.state.schema, smallTextAttrs));
};

});


parcelRegister("6V8KD", function(module, exports) {
$parcel$export(module.exports, "toggleTaskList", () => $5cb06a4c076bd1ea$export$2e48e3ea1c210731);

var $1FHzN = parcelRequire("1FHzN");

var $3LeME = parcelRequire("3LeME");

var $5JLJu = parcelRequire("5JLJu");

var $7rnBM = parcelRequire("7rnBM");
var $hlZec = parcelRequire("hlZec");
var $5ViSg = parcelRequire("5ViSg");
var $1vMIc = parcelRequire("1vMIc");

var $4Gb72 = parcelRequire("4Gb72");

var $801jp = parcelRequire("801jp");

var $a4TQr = parcelRequire("a4TQr");
const $5cb06a4c076bd1ea$export$2e48e3ea1c210731 = (editorAnalyticsAPI)=>(targetType = 'paragraph')=>{
        return ({ tr: tr })=>{
            const inputMethod = (0, $3LeME.INPUT_METHOD).TOOLBAR;
            const { nodes: nodes } = tr.doc.type.schema;
            const { selection: selection } = tr;
            // Handle empty selection: insert a new task item
            const { $from: $from } = selection;
            const isEmpty = $from.parent.content.size === 0;
            if (isEmpty && nodes.taskList && nodes.taskItem) {
                // Create an empty task list with one empty task item
                const listLocalId = (0, $1FHzN.uuid).generate();
                const itemLocalId = (0, $1FHzN.uuid).generate();
                const emptyList = nodes.taskList.create({
                    localId: listLocalId
                }, [
                    nodes.taskItem.create({
                        localId: itemLocalId
                    })
                ]);
                // Insert the empty list at the current selection
                const insertTr = (0, $a4TQr.safeInsert)(emptyList)(tr);
                if (insertTr !== tr) {
                    // Fire INSERT analytics event when creating a new task list
                    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                        action: (0, $3LeME.ACTION).INSERTED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ACTION,
                        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                        attributes: {
                            inputMethod: inputMethod,
                            listLocalId: listLocalId,
                            listSize: 1,
                            localId: itemLocalId,
                            position: 0
                        }
                    })(insertTr);
                    // Set cursor inside the new task item
                    const insertPos = insertTr.selection.$from.pos;
                    return insertTr.setSelection((0, $801jp.TextSelection).near(insertTr.doc.resolve(insertPos)));
                }
            }
            const { node: node, pos: pos } = (0, $7rnBM.getFormattedNode)(tr);
            if (node !== null && pos !== null) {
                if ((0, $hlZec.isBulletOrOrderedList)(node.type)) {
                    const transformedFrom = node.type.name === 'bulletList' ? (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                    const context = {
                        sourceNode: node,
                        sourcePos: pos,
                        targetNodeType: nodes.taskList,
                        tr: tr
                    };
                    const resultTr = (0, $4Gb72.transformBetweenListTypes)(context);
                    // Fire CONVERTED analytics event when transforming a list to task list
                    if (resultTr && resultTr.docChanged) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                        action: (0, $3LeME.ACTION).CONVERTED,
                        actionSubject: (0, $3LeME.ACTION_SUBJECT).LIST,
                        actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                        eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                        attributes: {
                            ...(0, $5JLJu.getCommonListAnalyticsAttributes)(tr),
                            transformedFrom: transformedFrom,
                            inputMethod: inputMethod
                        }
                    })(resultTr);
                    return resultTr;
                }
                if ((0, $5ViSg.isTaskList)(node.type)) {
                    const context = {
                        sourceNode: node,
                        sourcePos: pos,
                        targetNodeType: nodes[targetType],
                        tr: tr
                    };
                    const resultTr = targetType === 'paragraph' ? (0, $1vMIc.transformTaskListToBlockNodes)(context) : (0, $4Gb72.transformBetweenListTypes)(context);
                    // Fire CONVERTED analytics event when transforming from task list
                    if (resultTr && resultTr.docChanged && targetType !== 'paragraph') {
                        const transformedFrom = (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
                        const targetListType = targetType === 'bulletList' ? (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $3LeME.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                            action: (0, $3LeME.ACTION).CONVERTED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).LIST,
                            actionSubjectId: targetListType,
                            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                            attributes: {
                                ...(0, $5JLJu.getCommonListAnalyticsAttributes)(tr),
                                transformedFrom: transformedFrom,
                                inputMethod: inputMethod
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
                const { $from: $from, $to: $to } = selection;
                const range = $from.blockRange($to);
                if (range) {
                    const resultTr = (0, $4Gb72.transformToTaskList)(tr, range, nodes.taskList, undefined, nodes);
                    // Fire INSERT analytics event when creating task list from selection
                    if (resultTr && resultTr.docChanged) {
                        var _listNode$attrs, _listNode$firstChild;
                        const listNode = resultTr.doc.nodeAt(range.start);
                        const listLocalIdFromNode = (listNode === null || listNode === void 0 || (_listNode$attrs = listNode.attrs) === null || _listNode$attrs === void 0 ? void 0 : _listNode$attrs.localId) ?? (0, $1FHzN.uuid).generate();
                        const listSizeFromNode = (listNode === null || listNode === void 0 ? void 0 : listNode.childCount) ?? 0;
                        const localIdFromNode = (listNode === null || listNode === void 0 || (_listNode$firstChild = listNode.firstChild) === null || _listNode$firstChild === void 0 || (_listNode$firstChild = _listNode$firstChild.attrs) === null || _listNode$firstChild === void 0 ? void 0 : _listNode$firstChild.localId) ?? (0, $1FHzN.uuid).generate();
                        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                            action: (0, $3LeME.ACTION).INSERTED,
                            actionSubject: (0, $3LeME.ACTION_SUBJECT).DOCUMENT,
                            actionSubjectId: (0, $3LeME.ACTION_SUBJECT_ID).ACTION,
                            eventType: (0, $3LeME.EVENT_TYPE).TRACK,
                            attributes: {
                                inputMethod: inputMethod,
                                listLocalId: listLocalIdFromNode,
                                listSize: listSizeFromNode,
                                localId: localIdFromNode,
                                position: 0
                            }
                        })(resultTr);
                    }
                    return resultTr;
                }
            }
            return tr;
        };
    };

});
parcelRegister("7rnBM", function(module, exports) {
$parcel$export(module.exports, "getFormattedNode", () => $94f0da2fa16916ab$export$c0b9021b626ac150);

var $a4TQr = parcelRequire("a4TQr");
const $94f0da2fa16916ab$export$c0b9021b626ac150 = (tr)=>{
    const { selection: selection } = tr;
    const { nodes: nodes } = tr.doc.type.schema;
    const isBlockTaskItemEnabled = !!nodes.blockTaskItem;
    // Find the node to format from the current selection
    let nodeToFormat;
    let nodePos = selection.from;
    // Try to find the current node from selection
    const selectedNode = (0, $a4TQr.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.expand,
        nodes.codeBlock,
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.layoutSection
    ])(selection);
    if (selectedNode) {
        nodeToFormat = selectedNode.node;
        nodePos = selectedNode.pos;
    } else {
        // Try to find parent node (including list parents)
        const parentNodeTypes = [
            nodes.blockquote,
            nodes.panel,
            nodes.expand,
            nodes.codeBlock,
            nodes.listItem,
            nodes.taskItem,
            nodes.layoutSection
        ];
        if (isBlockTaskItemEnabled) parentNodeTypes.push(nodes.blockTaskItem);
        const parentNode = (0, $a4TQr.findParentNodeOfType)(parentNodeTypes)(selection);
        if (parentNode) {
            nodeToFormat = parentNode.node;
            nodePos = parentNode.pos;
            const paragraphOrHeadingNode = (0, $a4TQr.findParentNodeOfType)([
                nodes.paragraph,
                nodes.heading
            ])(selection);
            // Special case: if we found a listItem/taskItem/blockTaskItem, check if we need the parent list instead
            if (parentNode.node.type === nodes.listItem || parentNode.node.type === nodes.taskItem || isBlockTaskItemEnabled && parentNode.node.type === nodes.blockTaskItem) {
                const listParent = (0, $a4TQr.findParentNodeOfType)([
                    nodes.bulletList,
                    nodes.orderedList,
                    nodes.taskList
                ])(selection);
                if (listParent) {
                    // For list transformations, we want the list parent, not the listItem
                    nodeToFormat = listParent.node;
                    nodePos = listParent.pos;
                }
            } else if (parentNode.node.type !== nodes.blockquote && paragraphOrHeadingNode) {
                nodeToFormat = paragraphOrHeadingNode.node;
                nodePos = paragraphOrHeadingNode.pos;
            }
        }
    }
    if (!nodeToFormat) {
        nodeToFormat = selection.$from.node();
        nodePos = selection.$from.pos;
    }
    return {
        node: nodeToFormat,
        pos: nodePos
    };
};

});

parcelRegister("hlZec", function(module, exports) {
$parcel$export(module.exports, "isBulletOrOrderedList", () => $0fdbbf0f7f096e95$export$1d7e7dcd2590e9c6);
const $0fdbbf0f7f096e95$export$1d7e7dcd2590e9c6 = (nodeType)=>{
    return nodeType.name === 'bulletList' || nodeType.name === 'orderedList';
};

});

parcelRegister("1vMIc", function(module, exports) {
$parcel$export(module.exports, "transformTaskListToBlockNodes", () => $01d3296fac97bd30$export$d9cdacbed7444a4a);

var $7H6Cr = parcelRequire("7H6Cr");

var $a4TQr = parcelRequire("a4TQr");
const $01d3296fac97bd30$export$d9cdacbed7444a4a = (context)=>{
    const { tr: tr, targetNodeType: targetNodeType, targetAttrs: targetAttrs, sourceNode: sourceNode, sourcePos: sourcePos } = context;
    const { selection: selection } = tr;
    const schema = selection.$from.doc.type.schema;
    const { blockTaskItem: blockTaskItem } = schema.nodes;
    const isBlockTaskItemEnabled = !!blockTaskItem;
    if (isBlockTaskItemEnabled) {
        const blockTaskItemsResult = (0, $a4TQr.findChildrenByType)(sourceNode, blockTaskItem);
        if (blockTaskItemsResult.length > 0 && targetNodeType === schema.nodes.paragraph) {
            // blockTaskItem content is (paragraph | extension)+
            // Extract paragraph children directly — they may carry block marks (e.g. fontSize)
            const targetNodes = [];
            for (const { node: blockItem } of blockTaskItemsResult)blockItem.forEach((child)=>{
                if (child.type === schema.nodes.paragraph) targetNodes.push(child);
            });
            if (targetNodes.length === 0) return null;
            const slice = new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).fromArray(targetNodes), 0, 0);
            const rangeStart = sourcePos !== null ? sourcePos : selection.from;
            tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
            return tr;
        }
    }
    // Original logic for regular taskItem children
    const taskItemsResult = (0, $a4TQr.findChildrenByType)(sourceNode, schema.nodes.taskItem);
    const taskItems = taskItemsResult.map((item)=>item.node);
    const taskItemFragments = taskItems.map((taskItem)=>taskItem.content);
    let targetNodes = [];
    // Convert fragments to headings if target is heading
    if (targetNodeType === schema.nodes.heading && targetAttrs) {
        // convert the fragments to headings
        const targetHeadingLevel = targetAttrs.level;
        targetNodes = taskItemFragments.map((fragment)=>schema.nodes.heading.createChecked({
                level: targetHeadingLevel
            }, fragment.content));
    }
    // Convert fragments to paragraphs if target is paragraphs
    if (targetNodeType === schema.nodes.paragraph) // convert the fragments to paragraphs
    targetNodes = taskItemFragments.map((fragment)=>schema.nodes.paragraph.createChecked({}, fragment.content));
    // Convert fragments to code block if target is code block
    if (targetNodeType === schema.nodes.codeBlock) {
        // convert the fragments to one code block
        const codeBlockContent = taskItemFragments.map((fragment)=>fragment.textBetween(0, fragment.size, '\n')).join('\n');
        targetNodes = [
            schema.nodes.codeBlock.createChecked({}, schema.text(codeBlockContent))
        ];
    }
    // Replace the task list node with the new content in the transaction
    const slice = new (0, $7H6Cr.Slice)((0, $7H6Cr.Fragment).fromArray(targetNodes), 0, 0);
    const rangeStart = sourcePos !== null ? sourcePos : selection.from;
    tr.replaceRange(rangeStart, rangeStart + sourceNode.nodeSize, slice);
    return tr;
};

});

parcelRegister("4Gb72", function(module, exports) {
$parcel$export(module.exports, "transformListRecursively", () => $a223af1c550c7a2d$export$95df50ae6315ead6);
$parcel$export(module.exports, "transformBetweenListTypes", () => $a223af1c550c7a2d$export$2f7df9065a975ace);
$parcel$export(module.exports, "transformToTaskList", () => $a223af1c550c7a2d$export$201fb3474673bbf3);

var $7H6Cr = parcelRequire("7H6Cr");

var $3ISb4 = parcelRequire("3ISb4");

var $fl3FO = parcelRequire("fl3FO");

var $hlZec = parcelRequire("hlZec");

var $5ViSg = parcelRequire("5ViSg");

var $81iBZ = parcelRequire("81iBZ");

var $6JSgs = parcelRequire("6JSgs");



const $a223af1c550c7a2d$var$getContentSupportChecker = (targetNodeType)=>{
    return (node)=>{
        try {
            return targetNodeType.validContent((0, $7H6Cr.Fragment).from(node));
        } catch  {
            return false;
        }
    };
};
const $a223af1c550c7a2d$export$95df50ae6315ead6 = (props, onhandleUnsupportedContent)=>{
    const transformedItems = [];
    const { listNode: listNode, isSourceBulletOrOrdered: isSourceBulletOrOrdered, isTargetBulletOrOrdered: isTargetBulletOrOrdered, isSourceTask: isSourceTask, isTargetTask: isTargetTask, supportedListTypes: supportedListTypes, schema: schema, targetNodeType: targetNodeType } = props;
    const { taskList: taskList, listItem: listItem, taskItem: taskItem, paragraph: paragraph, blockTaskItem: blockTaskItem } = schema.nodes;
    const isBlockTaskEnabled = !!blockTaskItem;
    /**
   * Extracts paragraph children from a blockTaskItem, preserving their marks.
   */ const extractParagraphsFromBlockTaskItem = (node)=>{
        const paragraphs = [];
        node.forEach((child)=>{
            if (child.type === paragraph) paragraphs.push(child);
        });
        return paragraphs;
    };
    listNode.forEach((child)=>{
        if (isSourceBulletOrOrdered && isTargetTask) // Convert bullet/ordered => task
        {
            if (child.type === listItem) {
                const inlineContent = [];
                const nestedTaskLists = [];
                let blockMarks = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== taskList) nestedTaskLists.push($a223af1c550c7a2d$export$95df50ae6315ead6({
                        ...props,
                        listNode: grandChild
                    }, onhandleUnsupportedContent));
                    else if (!$a223af1c550c7a2d$var$getContentSupportChecker(taskItem)(grandChild) && !grandChild.isTextblock) onhandleUnsupportedContent === null || onhandleUnsupportedContent === void 0 || onhandleUnsupportedContent(grandChild);
                    else {
                        if (isBlockTaskEnabled && grandChild.type === paragraph && grandChild.marks.length > 0) blockMarks = grandChild.marks;
                        inlineContent.push(...(0, $3ISb4.convertBlockToInlineContent)(grandChild, schema));
                    }
                });
                if (isBlockTaskEnabled && blockMarks.length > 0) transformedItems.push((0, $fl3FO.createBlockTaskItem)({
                    content: inlineContent,
                    marks: blockMarks,
                    schema: schema
                }));
                else transformedItems.push(taskItem.create(null, inlineContent.length > 0 ? inlineContent : null));
                transformedItems.push(...nestedTaskLists);
            }
        } else if (isSourceTask && isTargetBulletOrOrdered) {
            // Convert task => bullet/ordered
            if (child.type === taskItem) {
                const inlineContent = [
                    ...child.content.content
                ];
                // Transfer taskItem's block marks to the paragraph.
                // Use listItem.allowsMarkType since the paragraph will be inside a listItem
                // (which uses ParagraphWithFontSizeStage0 that allows fontSize).
                const paragraphMarks = isBlockTaskEnabled && child.marks.length > 0 ? child.marks.filter((mark)=>listItem.allowsMarkType(mark.type)) : undefined;
                const paragraphNode = paragraph.create(null, inlineContent.length > 0 ? inlineContent : null, paragraphMarks);
                transformedItems.push(listItem.create(null, [
                    paragraphNode
                ]));
            } else if (isBlockTaskEnabled && child.type === blockTaskItem) {
                // blockTaskItem wraps content in paragraphs — extract them directly,
                // preserving their fontSize marks
                const paragraphs = extractParagraphsFromBlockTaskItem(child);
                if (paragraphs.length > 0) transformedItems.push(listItem.create(null, paragraphs));
            } else if (child.type === taskList) {
                const transformedNestedList = $a223af1c550c7a2d$export$95df50ae6315ead6({
                    ...props,
                    listNode: child
                }, onhandleUnsupportedContent);
                const lastItem = transformedItems[transformedItems.length - 1];
                if ((lastItem === null || lastItem === void 0 ? void 0 : lastItem.type) === listItem) {
                    // Attach nested list to previous item
                    const updatedContent = [
                        ...lastItem.content.content,
                        transformedNestedList
                    ];
                    transformedItems[transformedItems.length - 1] = listItem.create(lastItem.attrs, updatedContent);
                } else // No previous item, flatten nested items
                transformedItems.push(...transformedNestedList.content.content);
            }
        } else if (isSourceBulletOrOrdered && isTargetBulletOrOrdered) {
            if (child.type === listItem) {
                const convertedNestedLists = [];
                child.forEach((grandChild)=>{
                    if (supportedListTypes.has(grandChild.type) && grandChild.type !== targetNodeType) {
                        const convertedNode = $a223af1c550c7a2d$export$95df50ae6315ead6({
                            ...props,
                            listNode: grandChild
                        }, onhandleUnsupportedContent);
                        convertedNestedLists.push(convertedNode);
                    } else convertedNestedLists.push(grandChild);
                });
                transformedItems.push(listItem.create(null, convertedNestedLists));
            }
        }
    });
    return targetNodeType.create(null, transformedItems);
};
const $a223af1c550c7a2d$export$2f7df9065a975ace = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const { nodes: nodes } = tr.doc.type.schema;
    const sourceListType = sourceNode.type;
    const isSourceBulletOrOrdered = (0, $hlZec.isBulletOrOrderedList)(sourceListType);
    const isTargetTask = (0, $5ViSg.isTaskList)(targetNodeType);
    const isSourceTask = (0, $5ViSg.isTaskList)(sourceListType);
    const isTargetBulletOrOrdered = (0, $hlZec.isBulletOrOrderedList)(targetNodeType);
    // Check if we need structure transformation
    const needsStructureTransform = isSourceBulletOrOrdered && isTargetTask || isSourceTask && isTargetBulletOrOrdered;
    try {
        if (!needsStructureTransform) {
            // Simple type change for same structure lists (bullet <-> ordered)
            // Apply to the main list
            tr.setNodeMarkup(sourcePos, targetNodeType);
            // Apply to nested lists
            const listStart = sourcePos;
            const listEnd = sourcePos + sourceNode.nodeSize;
            const supportedListTypesSet = (0, $81iBZ.getSupportedListTypesSet)(nodes);
            tr.doc.nodesBetween(listStart, listEnd, (node, pos, parent)=>{
                // Only process nested lists (not the root list we already handled)
                if (supportedListTypesSet.has(node.type) && pos !== sourcePos) {
                    const isNestedList = parent && (supportedListTypesSet.has(parent.type) || parent.type === nodes.listItem);
                    if (isNestedList) {
                        const shouldTransformNode = node.type === sourceListType || (0, $hlZec.isBulletOrOrderedList)(node.type) && isTargetBulletOrOrdered;
                        if (shouldTransformNode) tr.setNodeMarkup(pos, targetNodeType);
                    }
                }
                return true; // Continue traversing
            });
            return tr;
        } else return (0, $6JSgs.transformListStructure)(context);
    } catch  {
        return null;
    }
};
const $a223af1c550c7a2d$export$201fb3474673bbf3 = (tr, range, targetNodeType, targetAttrs, nodes)=>{
    try {
        const { taskItem: taskItem, paragraph: paragraph, blockTaskItem: blockTaskItem } = nodes;
        const isBlockTaskItemEnabled = !!blockTaskItem;
        const listItems = [];
        // Process each block in the range
        tr.doc.nodesBetween(range.start, range.end, (node)=>{
            if (node.isBlock) {
                const inlineContent = [
                    ...node.content.content
                ];
                if (inlineContent.length > 0) {
                    if (isBlockTaskItemEnabled && node.type === paragraph && node.marks.length > 0) listItems.push((0, $fl3FO.createBlockTaskItem)({
                        attrs: targetAttrs,
                        content: inlineContent,
                        marks: node.marks,
                        schema: tr.doc.type.schema
                    }));
                    else listItems.push(taskItem.create(targetAttrs, inlineContent));
                }
            }
            return false;
        });
        if (listItems.length === 0) return null;
        // Create the new task list
        const newList = targetNodeType.create(targetAttrs, listItems);
        // Replace the range with the new list
        tr.replaceWith(range.start, range.end, newList);
        return tr;
    } catch  {
        return null;
    }
};

});
parcelRegister("3ISb4", function(module, exports) {
$parcel$export(module.exports, "convertBlockToInlineContent", () => $71cfbb0f1c9aef0b$export$3b2ae917fa66948c);
const $71cfbb0f1c9aef0b$export$3b2ae917fa66948c = (node, schema)=>{
    const { paragraph: paragraph, hardBreak: hardBreak } = schema.nodes;
    if (node.type === paragraph) return [
        ...node.content.content
    ];
    if (node.isBlock) {
        const textContent = node.textContent;
        const lines = textContent.split('\n');
        const newText = [];
        lines.forEach((line, index)=>{
            if (line !== '') newText.push(line ? schema.text(line) : schema.text(' '));
            if (lines.length > 1 && index !== lines.length - 1) newText.push(hardBreak.create());
        });
        return newText;
    }
    return [
        node
    ];
};

});

parcelRegister("81iBZ", function(module, exports) {
$parcel$export(module.exports, "getSupportedListTypesSet", () => $3218acf1915658d9$export$3fd351b2ea86488c);

var $1Szhq = parcelRequire("1Szhq");



const $3218acf1915658d9$export$3fd351b2ea86488c = (nodes)=>{
    return new Set((0, $1Szhq.getSupportedListTypes)(nodes));
};

});
parcelRegister("1Szhq", function(module, exports) {
$parcel$export(module.exports, "getSupportedListTypes", () => $7827876c7c88b008$export$98148b07df5ff68c);
const $7827876c7c88b008$export$98148b07df5ff68c = (nodes)=>{
    return [
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList
    ].filter(Boolean);
};

});


parcelRegister("6JSgs", function(module, exports) {
$parcel$export(module.exports, "transformListStructure", () => $796d1154f65ba13b$export$f6e356fc6d93cbb1);

var $hlZec = parcelRequire("hlZec");

var $5ViSg = parcelRequire("5ViSg");

var $4Gb72 = parcelRequire("4Gb72");

var $81iBZ = parcelRequire("81iBZ");
const $796d1154f65ba13b$export$f6e356fc6d93cbb1 = (context)=>{
    const { tr: tr, sourceNode: sourceNode, sourcePos: sourcePos, targetNodeType: targetNodeType } = context;
    const nodes = tr.doc.type.schema.nodes;
    const unsupportedContent = [];
    const onhandleUnsupportedContent = (content)=>{
        unsupportedContent.push(content);
    };
    try {
        const listNode = {
            node: sourceNode,
            pos: sourcePos
        };
        const { node: sourceList, pos: listPos } = listNode;
        // const { taskList, listItem, taskItem, paragraph } = nodes;
        const isSourceBulletOrOrdered = (0, $hlZec.isBulletOrOrderedList)(sourceList.type);
        const isTargetTask = (0, $5ViSg.isTaskList)(targetNodeType);
        const isSourceTask = (0, $5ViSg.isTaskList)(sourceList.type);
        const isTargetBulletOrOrdered = (0, $hlZec.isBulletOrOrderedList)(targetNodeType);
        const supportedListTypes = (0, $81iBZ.getSupportedListTypesSet)(nodes);
        const newList = (0, $4Gb72.transformListRecursively)({
            isSourceBulletOrOrdered: isSourceBulletOrOrdered,
            isSourceTask: isSourceTask,
            isTargetBulletOrOrdered: isTargetBulletOrOrdered,
            isTargetTask: isTargetTask,
            listNode: sourceList,
            schema: tr.doc.type.schema,
            supportedListTypes: supportedListTypes,
            targetNodeType: targetNodeType
        }, onhandleUnsupportedContent);
        tr.replaceWith(listPos, listPos + sourceList.nodeSize, [
            newList,
            ...unsupportedContent
        ]);
        return tr;
    } catch  {
        return tr;
    }
};

});




parcelRegister("7ukUt", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $c136bc34fe6c8b02$export$ae829ec7b2625219);

var $10F96 = parcelRequire("10F96");

var $1FHzN = parcelRequire("1FHzN");

var $1y7gE = parcelRequire("1y7gE");

var $6bnr9 = parcelRequire("6bnr9");

var $ihNBw = parcelRequire("ihNBw");

var $lxmuZ = parcelRequire("lxmuZ");

var $801jp = parcelRequire("801jp");

var $16ZMX = parcelRequire("16ZMX");

var $iAkmW = parcelRequire("iAkmW");

var $lTGym = parcelRequire("lTGym");

var $eFxRO = parcelRequire("eFxRO");

var $2kYwg = parcelRequire("2kYwg");

var $7lYQ4 = parcelRequire("7lYQ4");

var $dlEDe = parcelRequire("dlEDe");

var $5ARB6 = parcelRequire("5ARB6");

var $bC4Dj = parcelRequire("bC4Dj");
function $c136bc34fe6c8b02$var$nodesBetweenChanged(tr, f, startPos) {
    const stepRange = (0, $lxmuZ.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $c136bc34fe6c8b02$export$ae829ec7b2625219(portalProviderAPI, eventDispatcher, dispatch, api, getIntl, useLongPressSelection = false, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder) {
    return new (0, $1y7gE.SafePlugin)({
        props: {
            nodeViews: {
                taskItem: (0, $lTGym.taskView)(api, getIntl(), taskPlaceholder),
                decisionItem: (node)=>{
                    return new (0, $iAkmW.DecisionItemNodeView)(node, getIntl());
                },
                blockTaskItem: (0, $lTGym.taskView)(api, getIntl(), taskPlaceholder)
            },
            decorations (state) {
                const pluginState = (0, $7lYQ4.stateKey).getState(state);
                if (pluginState !== null && pluginState !== void 0 && pluginState.decorations) return pluginState.decorations;
                return (0, $16ZMX.DecorationSet).empty;
            },
            handleTextInput (view, from, to, text) {
                // When a decision item is selected and the user starts typing, the entire node
                // should be replaced with what was just typed. This custom text input handler
                // is needed to implement that behaviour.
                const { state: state, dispatch: dispatch } = view;
                const { tr: tr } = state;
                if (state.selection instanceof (0, $801jp.NodeSelection) && state.selection.node.type === view.state.schema.nodes.decisionItem) {
                    state.selection.replace(tr);
                    tr.insertText(text);
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            },
            handleClickOn: (0, $6bnr9.createSelectionClickHandler)([
                'decisionItem',
                'taskItem'
            ], (target)=>target.hasAttribute('data-decision-wrapper') || target.getAttribute('aria-label') === 'Decision', {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                // When the page is lazy loaded and task item is not yet available this allows
                // our toDOM implementation to toggle the node state
                change: (0, $dlEDe.taskItemOnChange)
            },
            handleKeyDown: (view, event)=>{
                const { state: state } = view;
                const { selection: selection, schema: schema } = state;
                const { $from: $from, $to: $to } = selection;
                const parentOffset = $from.parentOffset;
                const isInTaskItem = (0, $2kYwg.isInsideTask)(state);
                const focusedTaskItemLocalId = (0, $7lYQ4.stateKey).getState(state).focusedTaskItemLocalId;
                const currentTaskItemData = (0, $2kYwg.getTaskItemDataAtPos)(view);
                const currentTaskItemFocused = focusedTaskItemLocalId === (currentTaskItemData === null || currentTaskItemData === void 0 ? void 0 : currentTaskItemData.localId);
                // if task item checkbox not focused and arrow key is not pressed
                //  then we don't want to handle event.
                if (![
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight',
                    'ArrowLeft'
                ].includes(event.key)) return false;
                // We want to handle arrow up, down and left key only
                //  when selection is inside task item and no text is selected.
                if ([
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft'
                ].includes(event.key) && (!isInTaskItem || $from.pos !== $to.pos)) return false;
                // Arrow keys are pressed and shift, ctrl or meta is pressed as well.
                //  along with arrow keys and task item checkbox is focused
                //  then first move focus to view and proceed with default event handling.
                if (event.shiftKey || event.ctrlKey || event.metaKey) {
                    currentTaskItemFocused && (0, $2kYwg.removeCheckboxFocus)(view);
                    return false;
                }
                // task item checkbox is already focused
                if (focusedTaskItemLocalId) {
                    if (event.key === 'ArrowLeft') {
                        // Move focus to view and proceed with default keyboard handler.
                        // Which will move cursor to previous position.
                        (0, $2kYwg.removeCheckboxFocus)(view);
                        return false;
                    }
                    if (event.key === 'ArrowRight') {
                        // Move focus to view and DON'T proceed with default handler.
                        // We have assumed that selection is already before first character of task item.
                        (0, $2kYwg.removeCheckboxFocus)(view);
                        return true;
                    }
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        const taskItemData = (0, $2kYwg.getTaskItemDataToFocus)(view, event.key === 'ArrowUp' ? 'previous' : 'next');
                        if (taskItemData) {
                            (0, $2kYwg.focusCheckboxAndUpdateSelection)(view, taskItemData);
                            return true;
                        } else {
                            // If any how checkbox input not found, then move focus to view
                            //  and proceed with default keyboard handler.
                            (0, $2kYwg.removeCheckboxFocus)(view);
                            return false;
                        }
                    }
                }
                // If left arrow key is pressed and cursor is at first position in task-item
                //  then focus checkbox and DON'T proceed with default keyboard handler
                if (event.key === 'ArrowLeft' && parentOffset === 0) {
                    // here we are not using focusCheckboxAndUpdateSelection() method
                    // because it is working incorretly when we are placing is inside the nested items
                    (0, $2kYwg.focusCheckbox)(view, currentTaskItemData);
                    return true;
                }
                if (event.key === 'ArrowRight') {
                    var _$from$nodeAfter;
                    // If gap cursor is just before task list then focus first task item in list.
                    if (selection instanceof (0, $ihNBw.GapCursorSelection) && selection.side === 'left' && ((_$from$nodeAfter = $from.nodeAfter) === null || _$from$nodeAfter === void 0 ? void 0 : _$from$nodeAfter.type) === schema.nodes.taskList) {
                        const taskList = $from.nodeAfter;
                        const firstTaskItemNode = taskList.child(0);
                        const taskItemPos = $from.pos + 1;
                        (0, $2kYwg.focusCheckboxAndUpdateSelection)(view, {
                            pos: taskItemPos,
                            localId: firstTaskItemNode.attrs.localId
                        });
                        return true;
                    } else if (isInTaskItem && $from.node().content.size === parentOffset) {
                        const nextTaskItemData = (0, $2kYwg.getTaskItemDataToFocus)(view, 'next');
                        if (nextTaskItemData) {
                            (0, $2kYwg.focusCheckboxAndUpdateSelection)(view, nextTaskItemData);
                            return true;
                        }
                    } else return false;
                }
            },
            transformPasted: (slice, view)=>{
                var _view$state;
                if (Boolean(view === null || view === void 0 || (_view$state = view.state) === null || _view$state === void 0 || (_view$state = _view$state.schema) === null || _view$state === void 0 || (_view$state = _view$state.nodes) === null || _view$state === void 0 ? void 0 : _view$state.blockTaskItem)) slice = (0, $bC4Dj.tempTransformSliceToRemoveBlockTaskItem)(slice, view);
                return slice;
            }
        },
        state: {
            init () {
                return {
                    insideTaskDecisionItem: false,
                    hasEditPermission: hasEditPermission,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    requestToEditContent: requestToEditContent,
                    focusedTaskItemLocalId: null,
                    taskDecisionProvider: undefined,
                    decorations: (0, $16ZMX.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const metaData = tr.getMeta((0, $7lYQ4.stateKey));
                const { action: action, data: data } = metaData ?? {
                    action: null,
                    data: null
                };
                let newPluginState = pluginState;
                // Actions
                switch(action){
                    case (0, $5ARB6.ACTIONS).FOCUS_BY_LOCALID:
                        newPluginState = (0, $eFxRO.focusTaskDecision)(newPluginState, {
                            action: (0, $5ARB6.ACTIONS).FOCUS_BY_LOCALID,
                            data: data
                        });
                        break;
                    case (0, $5ARB6.ACTIONS).SET_PROVIDER:
                        newPluginState = (0, $eFxRO.setProvider)(newPluginState, {
                            action: (0, $5ARB6.ACTIONS).SET_PROVIDER,
                            data: data
                        });
                        break;
                    case (0, $5ARB6.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP:
                        newPluginState = (0, $eFxRO.openRequestEditPopup)(newPluginState, {
                            action: (0, $5ARB6.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP,
                            data: data
                        });
                        break;
                }
                // Commands
                if (metaData && 'hasEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasEditPermission: metaData.hasEditPermission
                };
                if (metaData && 'hasRequestedEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasRequestedEditPermission: metaData.hasRequestedEditPermission
                };
                const taskItemInfo = tr.getMeta('taskItemInfo');
                let decorations = (0, $16ZMX.DecorationSet).empty;
                if (taskItemInfo) decorations = (0, $16ZMX.DecorationSet).create(tr.doc, [
                    (0, $16ZMX.Decoration).inline(taskItemInfo.from, taskItemInfo.to, {}, {
                        dataTaskNodeCheckState: taskItemInfo.checkState
                    })
                ]);
                else {
                    var _newPluginState$decor;
                    decorations = (_newPluginState$decor = newPluginState.decorations) === null || _newPluginState$decor === void 0 ? void 0 : _newPluginState$decor.map(tr.mapping, tr.doc);
                }
                const newState = {
                    ...newPluginState,
                    decorations: decorations
                };
                dispatch((0, $7lYQ4.stateKey), newState);
                return newState;
            }
        },
        key: (0, $7lYQ4.stateKey),
        /*
     * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
     * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
     * Prosemirror capability where node attributes could be generated dynamically.
     * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
     *
     * Note: we currently do not handle the edge case where two nodes may have the same localId
     */ appendTransaction: (transactions, _oldState, newState)=>{
            // Assign unique localIds to any new nodes that don't have one.
            // Runs with addToHistory: false so localId assignment is not part of the undo history.
            const tr = newState.tr;
            let modified = false;
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Adds a unique id to a node
                $c136bc34fe6c8b02$var$nodesBetweenChanged(transaction, (node, pos)=>{
                    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem, blockTaskItem: blockTaskItem } = newState.schema.nodes;
                    if (!!node.type && (node.type === decisionList || node.type === decisionItem || node.type === taskList || node.type === taskItem || blockTaskItem && node.type === blockTaskItem)) {
                        const { localId: localId, ...rest } = node.attrs;
                        if (localId === undefined || localId === null || localId === '') {
                            tr.step(new (0, $10F96.SetAttrsStep)(pos, {
                                localId: (0, $1FHzN.uuid).generate(),
                                ...rest
                            }));
                            modified = true;
                        }
                    }
                });
            });
            if (modified) return tr.setMeta('addToHistory', false);
            return;
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = (0, $7lYQ4.stateKey).getState(view.state);
                    const prevPluginState = (0, $7lYQ4.stateKey).getState(prevState);
                    if (pluginState.focusedTaskItemLocalId === prevPluginState.focusedTaskItemLocalId) return;
                    const taskItem = (0, $2kYwg.getTaskItemDataAtPos)(view);
                    if (!taskItem) return;
                    if (pluginState.focusedTaskItemLocalId === taskItem.localId) {
                        const taskElement = view.nodeDOM(taskItem.pos);
                        if (taskElement instanceof HTMLElement) {
                            var _taskElement$querySel;
                            taskElement === null || taskElement === void 0 || (_taskElement$querySel = taskElement.querySelector('input')) === null || _taskElement$querySel === void 0 || _taskElement$querySel.focus();
                        }
                    }
                }
            };
        }
    });
}

});
parcelRegister("iAkmW", function(module, exports) {
$parcel$export(module.exports, "DecisionItemNodeView", () => $ae420289b8ad386d$export$a190d28468c64715);

var $a5rmN = parcelRequire("a5rmN");

var $7H6Cr = parcelRequire("7H6Cr");

var $aEmSo = parcelRequire("aEmSo");

var $rYDHD = parcelRequire("rYDHD");
class $ae420289b8ad386d$export$a190d28468c64715 {
    /**
   * Updates the hasChildren state based on the node's child count by setting the `data-empty` attribute on the contentDOM.
   * @param node - The ProseMirror node to check for children.
   * @private
   */ updateHasChildren(node) {
        const currentlyHasChildren = node.childCount > 0;
        if (currentlyHasChildren !== this.hasChildren) {
            var _this$contentDOM;
            this.hasChildren = currentlyHasChildren;
            (_this$contentDOM = this.contentDOM) === null || _this$contentDOM === void 0 || _this$contentDOM.toggleAttribute('data-empty', !currentlyHasChildren);
            this.setIconAriaLabel(!currentlyHasChildren);
        }
        return this.hasChildren;
    }
    setIcon(dom) {
        if (!dom || !(dom instanceof HTMLElement)) return;
        const maybeIcon = dom.querySelector('[data-component="icon"] > [role="img"]');
        if (maybeIcon && maybeIcon instanceof HTMLElement) this.icon = maybeIcon;
    }
    setIconAriaLabel(isEmpty) {
        if (!this.icon || !this.intl) return;
        const ariaLabel = isEmpty ? this.intl.formatMessage((0, $a5rmN.tasksAndDecisionsMessages).undefinedDecisionAriaLabel) : this.intl.formatMessage((0, $a5rmN.tasksAndDecisionsMessages).decisionAriaLabel);
        this.icon.setAttribute('aria-label', ariaLabel);
    }
    /**
   * Creates a new DecisionItemNodeView.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @import type {IntlShape} from 'react-intl';
   * @param {PMNode} node - The ProseMirror node representing the decision item.
   * @param {IntlShape} intl - The IntlShape for internationalization, used to format the placeholder text.
   * @example
   * const decisionItemNodeView = new DecisionItemNodeView(node, getIntl());
   */ constructor(node, intl){
        this.icon = null;
        this.hasChildren = undefined;
        const spec = (0, $rYDHD.decisionItemToDOM)(node, intl);
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.setIcon(this.dom);
        this.intl = intl;
    }
    /**
   * Updates the node view when the ProseMirror node changes.
   * @import type {PMNode} from '@atlaskit/editor-prosemirror/model';
   * @param {PMNode} node - The ProseMirror node to update the view with.
   * @example
   * decisionItemNodeView.update(node);
   * @returns {boolean} - Returns true if the view was updated successfully.
   */ update(node) {
        this.updateHasChildren(node);
        return true;
    }
    /**
   * Determines whether a mutation should be ignored by ProseMirror.
   * This prevents unnecessary node view destruction during DOM changes that don't affect our content.
   * @param mutation - The DOM mutation record or selection change
   * @returns true if the mutation should be ignored, false if it should be processed
   * @example
   * // Mutation outside contentDOM will be ignored
   * const shouldIgnore = decisionItemNodeView.ignoreMutation(mutationRecord);
   */ ignoreMutation(mutation) {
        // This was discovered while implementing the platform_editor_debounce_portal_provider experiment
        // And there will only be an issue if the experiment is enabled.
        // As such, this fix is behind this experiment.
        if (!(0, $aEmSo.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true, false)) return false; // Let ProseMirror handle all mutations when experiment is disabled
        if (!this.contentDOM) return true;
        // Ignore mutations that don't target our contentDOM and aren't selection changes
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
}

});
parcelRegister("rYDHD", function(module, exports) {
$parcel$export(module.exports, "decisionItemToDOM", () => $fe62d6584ea796ba$export$e9f11508261835be);

var $a5rmN = parcelRequire("a5rmN");
/**
 * Determine if the decision item node is empty
 *
 * @param node The decision item node
 * @returns true if the decision item is empty and false otherwise
 */ const $fe62d6584ea796ba$var$isDecisionItemEmpty = (node)=>node.childCount <= 0;
/**
 * Creates a DOM element for the decision icon with an accessible aria label.
 *
 * Generates a decision icon DOM structure with an aria label that changes based on whether
 * the decision item is empty. An empty decision item receives the "undefined" aria label,
 * while non-empty decision items receive the standard "decision" aria label.
 *
 * @param node - The ProseMirror node representing the decision item
 * @param intl - The intl object used to format internationalized messages for the aria label
 * @returns A DOMOutputSpec array representing the icon element with nested SVG graphics
 */ const $fe62d6584ea796ba$var$createIconDOM = ({ node: node, intl: intl })=>{
    const ariaLabel = $fe62d6584ea796ba$var$isDecisionItemEmpty(node) ? intl.formatMessage((0, $a5rmN.tasksAndDecisionsMessages).undefinedDecisionAriaLabel) : intl.formatMessage((0, $a5rmN.tasksAndDecisionsMessages).decisionAriaLabel);
    return [
        'span',
        {
            contentEditable: false,
            'data-component': 'icon'
        },
        [
            'span',
            {
                role: 'img',
                'aria-label': ariaLabel
            },
            [
                'http://www.w3.org/2000/svg svg',
                {
                    viewBox: `0 0 24 24`,
                    role: 'presentation',
                    width: '24',
                    height: '24',
                    'data-icon-source': 'legacy'
                },
                [
                    'http://www.w3.org/2000/svg path',
                    {
                        fill: 'currentcolor',
                        'fill-rule': 'evenodd',
                        d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                    }
                ]
            ],
            [
                'http://www.w3.org/2000/svg svg',
                {
                    viewBox: `-4 -4 24 24`,
                    fill: 'none',
                    role: 'presentation',
                    width: '24',
                    height: '24',
                    'data-icon-source': 'refreshed'
                },
                [
                    'http://www.w3.org/2000/svg path',
                    {
                        fill: 'currentcolor',
                        'fill-rule': 'evenodd',
                        d: 'm13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z'
                    }
                ]
            ]
        ]
    ];
};
const $fe62d6584ea796ba$export$e9f11508261835be = (node, intl)=>{
    const contentDomDataAttrs = $fe62d6584ea796ba$var$isDecisionItemEmpty(node) ? {
        'data-empty': 'true'
    } : {};
    return [
        'li',
        {
            'data-decision-local-id': node.attrs.localId || 'local-decision',
            'data-decision-state': node.attrs.state,
            'data-prosemirror-node-name': 'decisionItem',
            class: 'decisionItemView-content-wrap'
        },
        [
            'div',
            {
                'data-testid': 'elements-decision-item',
                'data-decision-wrapper': true
            },
            $fe62d6584ea796ba$var$createIconDOM({
                node: node,
                intl: intl
            }),
            // renderPlaceholder
            [
                'span',
                {
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contentEditable: false
                },
                intl.formatMessage((0, $a5rmN.tasksAndDecisionsMessages).decisionPlaceholder)
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: 'decision-item',
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
};

});


parcelRegister("lTGym", function(module, exports) {
$parcel$export(module.exports, "taskView", () => $7d73b4283de870de$export$da2f2be53bb82f44);

var $g9cR1 = parcelRequire("g9cR1");
const $7d73b4283de870de$export$da2f2be53bb82f44 = (api, intl, placeholder)=>{
    return (node, view, getPos)=>{
        return new (0, $g9cR1.TaskItemNodeView)(node, view, getPos, {
            placeholder: placeholder,
            api: api,
            intl: intl
        });
    };
};

});
parcelRegister("g9cR1", function(module, exports) {
$parcel$export(module.exports, "TaskItemNodeView", () => $d0767b445f988ab4$export$8e651bc5e6600399);

var $6Zi52 = parcelRequire("6Zi52");

var $10F96 = parcelRequire("10F96");

var $a5rmN = parcelRequire("a5rmN");

var $7H6Cr = parcelRequire("7H6Cr");

var $2kYwg = parcelRequire("2kYwg");

var $jYy8x = parcelRequire("jYy8x");

var $dWYQz = parcelRequire("dWYQz");
class $d0767b445f988ab4$export$8e651bc5e6600399 {
    constructor(node, view, getPos, { api: api, placeholder: placeholder, intl: intl }){
        this.handleOnClick = (event)=>{
            var _this$api2;
            if (!((_this$api2 = this.api) !== null && _this$api2 !== void 0 && (_this$api2 = _this$api2.taskDecision) !== null && _this$api2 !== void 0 && (_this$api2 = _this$api2.sharedState.currentState()) !== null && _this$api2 !== void 0 && _this$api2.hasEditPermission)) {
                event.stopImmediatePropagation();
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $2kYwg.openRequestEditPopupAt)(this.view, pos);
                return;
            }
        };
        this.handleOnChange = ()=>{
            var _this$api3;
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return;
            const { localId: localId, state: state } = this.node.attrs;
            const isDone = state === 'DONE';
            const nextState = isDone ? 'TODO' : 'DONE';
            const currentTaskDecisionState = (_this$api3 = this.api) === null || _this$api3 === void 0 ? void 0 : _this$api3.taskDecision.sharedState.currentState();
            // logic is inspired from packages/elements/task-decision/src/components/ResourcedTaskItem.tsx
            const objectAri = this.getObjectAri();
            if (currentTaskDecisionState !== null && currentTaskDecisionState !== void 0 && currentTaskDecisionState.taskDecisionProvider && objectAri) currentTaskDecisionState.taskDecisionProvider.toggleTask({
                localId: localId,
                objectAri: objectAri
            }, nextState);
            // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $10F96.SetAttrsStep)(nodePos, {
                state: nextState,
                localId: localId
            }));
            tr.setMeta('scrollIntoView', false);
            const taskItemInfoMeta = {
                checkState: nextState,
                from: nodePos,
                to: nodePos + this.node.nodeSize
            };
            tr.setMeta('taskItemInfo', taskItemInfoMeta);
            this.view.dispatch(tr);
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.intl = intl;
        this.api = api;
        this.view = view;
        const domPlaceholder = placeholder ?? this.intl.formatMessage((0, $a5rmN.tasksAndDecisionsMessages).taskPlaceholder);
        const { dom: dom, contentDOM: contentDOM } = (0, $7H6Cr.DOMSerializer).renderSpec(document, (0, $jYy8x.taskItemToDom)(node, domPlaceholder, intl));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.domElement = this.dom instanceof HTMLElement ? this.dom : undefined;
        if (this.domElement) {
            this.input = this.domElement.querySelector('input[type="checkbox"]');
            this.unbindInputDom = (0, $6Zi52.bindAll)(this.input, [
                {
                    type: 'click',
                    listener: this.handleOnClick
                },
                {
                    type: 'change',
                    listener: this.handleOnChange
                }
            ]);
        }
    }
    getContextIdentifierProvider() {
        var _this$api;
        return (_this$api = this.api) === null || _this$api === void 0 || (_this$api = _this$api.contextIdentifier) === null || _this$api === void 0 || (_this$api = _this$api.sharedState.currentState()) === null || _this$api === void 0 ? void 0 : _this$api.contextIdentifierProvider;
    }
    getObjectAri() {
        const provider = this.getContextIdentifierProvider();
        if (provider) return provider.objectId;
        return undefined;
    }
    // Update the placeholder visibility based on content
    updatePlaceholder(node) {
        const currentIsContentEmpty = (0, $dWYQz.isContentEmpty)(node);
        if (currentIsContentEmpty !== this.emptyContent) {
            var _this$contentDOM;
            this.emptyContent = currentIsContentEmpty;
            (_this$contentDOM = this.contentDOM) === null || _this$contentDOM === void 0 || _this$contentDOM.toggleAttribute('data-empty', currentIsContentEmpty);
        }
    }
    update(node) {
        // Only return false if this is a completely different task
        if (this.node.attrs.localId !== node.attrs.localId) return false;
        if (node.type !== this.node.type) return false;
        const stateChanged = node.attrs.state !== this.node.attrs.state;
        // Update task checkbox state to match document state.
        // It's possible the state may have changed from a collab edit and not from a checkbox click
        // so we need to update the checkbox to match.
        if (stateChanged && this.input) this.input.checked = node.attrs.state === 'DONE';
        this.updatePlaceholder(node);
        if (this.domElement && !node.sameMarkup(this.node)) {
            this.domElement.setAttribute('data-task-state', node.attrs.state);
            this.domElement.setAttribute('data-task-local-id', node.attrs.localId);
            this.domElement.setAttribute('state', node.attrs.state);
        }
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    destroy() {
        if (this.unbindInputDom) this.unbindInputDom();
        this.contentDOM = undefined;
        this.input = undefined;
        this.emptyContent = undefined;
        this.api = undefined;
    }
}

});
parcelRegister("jYy8x", function(module, exports) {
$parcel$export(module.exports, "taskItemToDom", () => $2ed76e6fec59a717$export$640336359e1ccaeb);

var $a5rmN = parcelRequire("a5rmN");

var $iSJ2T = parcelRequire("iSJ2T");

var $dWYQz = parcelRequire("dWYQz");
const $2ed76e6fec59a717$var$getCheckBoxId = (localId)=>`task-checkbox-${localId}`;
function $2ed76e6fec59a717$export$640336359e1ccaeb(node, placeholder, intl) {
    const checked = node.attrs.state === 'DONE';
    const checkboxId = $2ed76e6fec59a717$var$getCheckBoxId(node.attrs.localId);
    const inputAttrs = {
        name: checkboxId,
        id: checkboxId,
        type: 'checkbox',
        'aria-label': intl.formatMessage(checked ? (0, $a5rmN.tasksAndDecisionsMessages).markTaskAsNotCompleted : (0, $a5rmN.tasksAndDecisionsMessages).markTaskAsCompleted)
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        'data-prosemirror-node-name': 'taskItem',
        ...node.type.name === 'blockTaskItem' ? {
            'data-task-is-block': 'true'
        } : {}
    };
    const contentDomDataAttrs = (0, $dWYQz.isContentEmpty)(node) ? {
        'data-empty': 'true'
    } : {};
    const checkboxIcons = [
        'http://www.w3.org/2000/svg svg',
        {
            width: '20',
            height: '20',
            viewBox: '2 2 20 20',
            role: 'presentation',
            'data-component': 'checkbox-icon'
        },
        [
            'http://www.w3.org/2000/svg g',
            {
                'fill-rule': 'evenodd'
            },
            [
                'http://www.w3.org/2000/svg rect',
                {
                    fill: 'currentcolor',
                    x: '5.5',
                    y: '5.5',
                    width: '13',
                    height: '13',
                    rx: '1.5'
                }
            ],
            [
                'http://www.w3.org/2000/svg path',
                {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'm16.326 9.48-1.152-.96-4.424 5.308-1.924-2.308-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z',
                    fill: 'inherit'
                }
            ]
        ]
    ];
    return [
        'div',
        {
            class: `${(0, $iSJ2T.TaskDecisionSharedCssClassName).TASK_CONTAINER}`,
            ...dataAttrs,
            state: node.attrs.state
        },
        [
            'div',
            {
                'data-component': 'task-item-main'
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    class: `${(0, $iSJ2T.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`,
                    'data-component': 'task-item-input-wrap'
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'task-item',
                        'data-task-input': true,
                        'data-testid': 'task-item-checkbox',
                        'data-component': 'task-item-input',
                        role: 'checkbox'
                    }
                ],
                checkboxIcons
            ],
            [
                'span',
                {
                    class: 'placeholder-node-view',
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contenteditable: 'false'
                },
                placeholder
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $iSJ2T.TaskDecisionSharedCssClassName).TASK_ITEM,
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
}

});
parcelRegister("dWYQz", function(module, exports) {
$parcel$export(module.exports, "isContentEmpty", () => $f78729400161b2f5$export$c0efac86beb21f01);
const $f78729400161b2f5$export$c0efac86beb21f01 = (node)=>{
    if (node.content.childCount === 0) return true;
    if (node.type.name === 'blockTaskItem') {
        var _node$content$firstCh, _node$content$firstCh2;
        return node.content.childCount === 1 && ((_node$content$firstCh = node.content.firstChild) === null || _node$content$firstCh === void 0 ? void 0 : _node$content$firstCh.type.name) === 'paragraph' && ((_node$content$firstCh2 = node.content.firstChild) === null || _node$content$firstCh2 === void 0 ? void 0 : _node$content$firstCh2.childCount) === 0;
    }
    return false;
};

});




parcelRegister("eFxRO", function(module, exports) {
$parcel$export(module.exports, "focusTaskDecision", () => $086ffc99cda63c94$export$9af39543e75ed75a);
$parcel$export(module.exports, "setProvider", () => $086ffc99cda63c94$export$1572b3eade6662f9);
$parcel$export(module.exports, "openRequestEditPopup", () => $086ffc99cda63c94$export$571ff0891839feec);
const $086ffc99cda63c94$export$9af39543e75ed75a = (state, action)=>{
    return {
        ...state,
        focusedTaskItemLocalId: action.data
    };
};
const $086ffc99cda63c94$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        taskDecisionProvider: action.data
    };
};
const $086ffc99cda63c94$export$571ff0891839feec = (state, action)=>{
    return {
        ...state,
        openRequestToEditPopupAt: action.data
    };
};

});

parcelRegister("dlEDe", function(module, exports) {
$parcel$export(module.exports, "taskItemOnChange", () => $ab0e040a595a5c72$export$4f9e52c150984a8a);
function $ab0e040a595a5c72$export$4f9e52c150984a8a(view, event) {
    var _parentNode$type;
    const { target: target } = event;
    if (!target || !(target instanceof HTMLInputElement) || target.type !== 'checkbox' || target.getAttribute('data-input-type') !== 'lazy-task-item') return;
    const pos = view.posAtDOM(target, 0);
    // Resolve the position in the current document
    const resolvedPos = view.state.doc.resolve(pos);
    // Access the parent node
    const parentNode = resolvedPos === null || resolvedPos === void 0 ? void 0 : resolvedPos.parent;
    if ((parentNode === null || parentNode === void 0 || (_parentNode$type = parentNode.type) === null || _parentNode$type === void 0 ? void 0 : _parentNode$type.name) !== 'taskItem') return;
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const tr = view.state.tr.setNodeMarkup(parentPos, null, {
        ...parentNode.attrs,
        state: target.checked ? 'DONE' : 'TODO'
    });
    view.dispatch(tr);
}

});


parcelRegister("1h6Wf", function(module, exports) {
$parcel$export(module.exports, "DecisionListBlockMenuItem", () => $de9c17c5755b36c0$export$77edd8d99970778c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $j8Vl1 = parcelRequire("j8Vl1");

var $7otWv = parcelRequire("7otWv");

var $8Pw71 = parcelRequire("8Pw71");
const $de9c17c5755b36c0$var$NODE_NAME = 'decisionList';
const $de9c17c5755b36c0$export$77edd8d99970778c = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $3LeME.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.decisionList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $de9c17c5755b36c0$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Pw71))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $j8Vl1.messages).decisionList)
    });
};

});

parcelRegister("9kCZ1", function(module, exports) {
$parcel$export(module.exports, "getTasksAndDecisionsQuickInsertComponents", () => $3dae38138b78f5f0$export$7632300852120e0c);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cT0LQ = parcelRequire("cT0LQ");

var $diu1C = parcelRequire("diu1C");

var $hI3gt = parcelRequire("hI3gt");

var $4jXgF = parcelRequire("4jXgF");

var $aeuW0 = parcelRequire("aeuW0");
const $3dae38138b78f5f0$var$taskPreviewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLK.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHI.png'
};
const $3dae38138b78f5f0$var$decisionPreviewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLY.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHM.png'
};
const $3dae38138b78f5f0$export$7632300852120e0c = ({ api: api, quickInsertActionDescription: quickInsertActionDescription })=>[
        {
            key: (0, $hI3gt.ACTION_MENU_ITEM).key,
            type: (0, $hI3gt.ACTION_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $hI3gt.STRUCTURE_SECTION).key,
                    type: (0, $hI3gt.STRUCTURE_SECTION).type,
                    rank: (0, $4jXgF.STRUCTURE_SECTION_RANK)[(0, $hI3gt.ACTION_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: quickInsertActionDescription ?? formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).actionDescription),
                    keywords: [
                        'checkbox',
                        'task',
                        'todo'
                    ],
                    shortcut: '[]',
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).action)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $aeuW0.TasksAndDecisionsQuickInsertMenuItem), {
                    api: api,
                    description: quickInsertActionDescription,
                    item: "taskList",
                    previewImageUrls: $3dae38138b78f5f0$var$taskPreviewImageUrls
                })
        },
        {
            key: (0, $hI3gt.DECISION_MENU_ITEM).key,
            type: (0, $hI3gt.DECISION_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $hI3gt.STRUCTURE_SECTION).key,
                    type: (0, $hI3gt.STRUCTURE_SECTION).type,
                    rank: (0, $4jXgF.STRUCTURE_SECTION_RANK)[(0, $hI3gt.DECISION_MENU_ITEM).key]
                }
            ],
            match: (0, $diu1C.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).decisionDescription),
                    keywords: [],
                    shortcut: '<>',
                    title: formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).decision)
                })),
            component: ()=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $aeuW0.TasksAndDecisionsQuickInsertMenuItem), {
                    api: api,
                    item: "decisionList",
                    previewImageUrls: $3dae38138b78f5f0$var$decisionPreviewImageUrls
                })
        }
    ];

});
parcelRegister("aeuW0", function(module, exports) {
$parcel$export(module.exports, "TasksAndDecisionsQuickInsertMenuItem", () => $96cd9e6f4b7619d2$export$2355f39adf48dd93);

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $cT0LQ = parcelRequire("cT0LQ");

var $5Yxyq = parcelRequire("5Yxyq");

var $3M4Vk = parcelRequire("3M4Vk");

var $9oAqi = parcelRequire("9oAqi");

var $8Pw71 = parcelRequire("8Pw71");

var $68NNn = parcelRequire("68NNn");

var $8ZI3Z = parcelRequire("8ZI3Z");
const $96cd9e6f4b7619d2$export$2355f39adf48dd93 = ({ api: api, description: description, item: item, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { contextIdentifierProvider: contextIdentifierProvider } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'contextIdentifier'
    ], (states)=>{
        var _states$contextIdenti;
        return {
            contextIdentifierProvider: (_states$contextIdenti = states.contextIdentifierState) === null || _states$contextIdenti === void 0 ? void 0 : _states$contextIdenti.contextIdentifierProvider
        };
    });
    const isAction = item === 'taskList';
    const preview = (0, $fc4bM.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $3M4Vk.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $fc4bM.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        var _api$analytics;
        const { schema: schema } = editorView.state;
        const addAndCreateList = ({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
            const { list: list, item: listItem } = (0, $8ZI3Z.getListTypes)(item, schema);
            return insert(list.createChecked({
                localId: listLocalId
            }, listItem.createChecked({
                localId: itemLocalId
            })));
        };
        return (0, $8ZI3Z.insertTaskDecisionAction)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, ()=>contextIdentifierProvider)(editorView.state, item, source ?? (0, $3LeME.INPUT_METHOD).QUICK_INSERT, addAndCreateList);
    }, [
        api,
        contextIdentifierProvider,
        item
    ]);
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $5Yxyq.QuickInsertMenuItem), {
        description: description ?? formatMessage(isAction ? (0, $cT0LQ.toolbarInsertBlockMessages).actionDescription : (0, $cT0LQ.toolbarInsertBlockMessages).decisionDescription),
        iconBefore: isAction ? /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68NNn))), {
            label: ""
        }) : /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Pw71))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: isAction ? '[]' : '<>',
        title: formatMessage(isAction ? (0, $cT0LQ.toolbarInsertBlockMessages).action : (0, $cT0LQ.toolbarInsertBlockMessages).decision)
    });
};

});


parcelRegister("gafoB", function(module, exports) {
$parcel$export(module.exports, "RequestToEditPopup", () => $daa373951c85191c$export$2dae066a4c27dc7a);
/* RequestToEditPopup.tsx generated by @compiled/babel-plugin v3.0.2 */ // import Popup from '@atlaskit/popup';

var $3LM7S = parcelRequire("3LM7S");

var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $1H8qk = parcelRequire("1H8qk");

var $a5rmN = parcelRequire("a5rmN");

var $dXHAJ = parcelRequire("dXHAJ");

var $dogcz = parcelRequire("dogcz");

var $8F4kC = parcelRequire("8F4kC");

var $jnzAA = parcelRequire("jnzAA");

var $014x6 = parcelRequire("014x6");

var $1hJdJ = parcelRequire("1hJdJ");

var $jaqgn = parcelRequire("jaqgn");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");

var $cJzRi = parcelRequire("cJzRi");
const $daa373951c85191c$var$PopupWithListeners = (0, $8F4kC.default)((0, $dXHAJ.default));
const $daa373951c85191c$var$TRYING_REQUEST_TIMEOUT = 3000;
const $daa373951c85191c$var$popupContentWrapper = null;
const $daa373951c85191c$var$wrapperStyles = null;
const $daa373951c85191c$var$wrapperBoxStyles = null;
const $daa373951c85191c$var$dotStyles = null;
const $daa373951c85191c$var$dotStylesUnbounded = null;
const $daa373951c85191c$var$pressableStyles = {
    pressableMotion: "_v564k6bl _ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1wybdlk8 _syaz1oa5 _bfhksm61 _9oik1r31 _1bnx8stv _jf4cnqa1 _1ggl5xtf _9h8h12zz"
};
const $daa373951c85191c$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $3LeME.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $3LeME.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $1H8qk.PLATFORMS).WEB,
            mode: (0, $1H8qk.MODE).EDITOR
        }
    };
};
const $daa373951c85191c$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $3LM7S.Fragment), {
        children: [
            formatMessage((0, $a5rmN.tasksAndDecisionsMessages).requestToEdit),
            /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jaqgn))), {
                label: "requested-to-edit",
                color: "var(--ds-icon-disabled, #080F214A)"
            })
        ]
    });
};
const $daa373951c85191c$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
            onClick: onClick,
            xcss: $daa373951c85191c$var$pressableStyles.pressableMotion,
            testId: "request-to-edit-popup-request-btn",
            children: formatMessage((0, $a5rmN.tasksAndDecisionsMessages).requestToEdit)
        })
    });
};
const $daa373951c85191c$export$2dae066a4c27dc7a = ({ element: element, api: api, editorView: editorView, onClose: onClose, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const hasRequestedEditPermission = (0, $jnzAA.useSharedPluginStateSelector)(api, 'taskDecision.hasRequestedEditPermission');
    const openRequestToEditPopupAt = (0, $jnzAA.useSharedPluginStateSelector)(api, 'taskDecision.openRequestToEditPopupAt');
    const [isOpen, setIsOpen] = (0, $fc4bM.useState)(!!openRequestToEditPopupAt);
    const [requested, setRequested] = (0, $fc4bM.useState)(hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $fc4bM.useState)(false);
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    (0, $fc4bM.useEffect)(()=>{
        setRequested(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!tryingRequest) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $daa373951c85191c$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const onHandleEdit = (event)=>{
        var _api$editorViewMode, _api$analytics, _api$taskDecision;
        event.stopPropagation();
        const viewMode = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode;
        if (viewMode !== 'view') return;
        const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
        setTryingRequest(true);
        const { tr: tr } = editorView.state;
        tr.setMeta('scrollIntoView', false);
        if (!(api !== null && api !== void 0 && (_api$taskDecision = api.taskDecision) !== null && _api$taskDecision !== void 0 && (_api$taskDecision = _api$taskDecision.sharedState.currentState()) !== null && _api$taskDecision !== void 0 && _api$taskDecision.hasEditPermission)) {
            var _api$taskDecision2;
            const requestToEdit = api === null || api === void 0 || (_api$taskDecision2 = api.taskDecision) === null || _api$taskDecision2 === void 0 || (_api$taskDecision2 = _api$taskDecision2.sharedState.currentState()) === null || _api$taskDecision2 === void 0 ? void 0 : _api$taskDecision2.requestToEditContent;
            if (requestToEdit) requestToEdit();
        }
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($daa373951c85191c$var$anaylyticsEventPayload((0, $3LeME.ACTION).REQUEST_TO_EDIT))(tr);
        editorView.dispatch(tr);
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent($daa373951c85191c$var$anaylyticsEventPayload((0, $3LeME.ACTION).DISMISSED));
        setIsOpen(false);
        onClose();
    };
    const onHandleCancel = (event)=>{
        // Check if the click is on task item checkbox, if so, do not close the popup
        const target = event.target;
        if (target && (element.contains(target) || element === target)) return;
        setIsOpen(false);
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $3LM7S.jsx)($daa373951c85191c$var$PopupWithListeners, {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        target: element,
        fitHeight: 148,
        handleClickOutside: onHandleCancel,
        handleEscapeKeydown: onHandleCancel,
        zIndex: (0, $014x6.akEditorFloatingDialogZIndex),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        ariaLabel: null,
        preventOverflow: true,
        focusTrap: true,
        captureClick: true,
        children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dogcz.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                    ref: setOutsideClickTargetRef,
                    className: (0, $2R2iS.default)([
                        "_2rkofajl _ca0qv77o _n3tdv77o _19bvv77o _u5f3v77o _16qs130s _bfhk1bhr"
                    ]),
                    children: /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                        className: (0, $2R2iS.default)([
                            "_1e0c1txw _2lx21bp4 _p12f1qwj _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
                        ]),
                        children: /*#__PURE__*/ (0, $3LM7S.jsxs)((0, $cJzRi.Stack), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $3LM7S.jsx)((0, $1hJdJ.default), {
                                    size: "xsmall",
                                    children: formatMessage((0, $a5rmN.tasksAndDecisionsMessages).editAccessTitle)
                                }),
                                /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                    children: formatMessage((0, $a5rmN.tasksAndDecisionsMessages).requestToEditDescription)
                                }),
                                /*#__PURE__*/ (0, $3LM7S.jsxs)("div", {
                                    className: (0, $2R2iS.default)([
                                        "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1gmx"
                                    ]),
                                    children: [
                                        tryingRequest || requested ? /*#__PURE__*/ (0, $3LM7S.jsx)($daa373951c85191c$var$RequestedMessage, {}) : /*#__PURE__*/ (0, $3LM7S.jsx)($daa373951c85191c$var$RequestToEditButton, {
                                            onClick: onHandleEdit
                                        }),
                                        /*#__PURE__*/ (0, $3LM7S.jsx)("div", {
                                            className: (0, $2R2iS.default)([
                                                "_19pku2gc _otyru2gc _18u0u2gc _2hwxu2gc _1e0c1o8l _1bsbyh40 _4t3iyh40 _bfhk16e3",
                                                "_2rko1rr0"
                                            ])
                                        }),
                                        /*#__PURE__*/ (0, $3LM7S.jsx)((0, $dBtOK.Box), {
                                            children: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $EawnW.Pressable), {
                                                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                                onClick: ()=>{
                                                    var _api$analytics2;
                                                    return onHandleDismiss(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
                                                },
                                                xcss: $daa373951c85191c$var$pressableStyles.pressableMotion,
                                                testId: "request-to-edit-popup-cancel-btn",
                                                children: formatMessage((0, $a5rmN.tasksAndDecisionsMessages).dismiss)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
        })
    });
};

});

parcelRegister("gn0VM", function(module, exports) {
$parcel$export(module.exports, "TaskListBlockMenuItem", () => $71751ccb2793e255$export$de5198967b780ae);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $3LeME = parcelRequire("3LeME");

var $a5rmN = parcelRequire("a5rmN");

var $7otWv = parcelRequire("7otWv");

var $7y0BG = parcelRequire("7y0BG");
const $71751ccb2793e255$var$NODE_NAME = 'taskList';
const $71751ccb2793e255$export$de5198967b780ae = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const onClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $3LeME.INPUT_METHOD).KEYBOARD : (0, $3LeME.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $3LeME.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.taskList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $71751ccb2793e255$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        onClick: onClick,
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7y0BG))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $a5rmN.tasksAndDecisionsMessages).taskList)
    });
};

});

parcelRegister("lrxgy", function(module, exports) {
$parcel$export(module.exports, "getTasksAndDecisionsToolbarComponents", () => $d113399b44d575dd$export$f1884d013db554cc);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $cIIZO = parcelRequire("cIIZO");

var $fdhSI = parcelRequire("fdhSI");

var $9ALHd = parcelRequire("9ALHd");
const $d113399b44d575dd$export$f1884d013db554cc = ({ api: api })=>{
    return [
        {
            type: (0, $cIIZO.TASK_LIST_MENU_ITEM).type,
            key: (0, $cIIZO.TASK_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cIIZO.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $cIIZO.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $fdhSI.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $cIIZO.TASK_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $3LM7S.jsx)((0, $9ALHd.TaskListMenuItem), {
                    api: api,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("9ALHd", function(module, exports) {
$parcel$export(module.exports, "TaskListMenuItem", () => $e343bad68e2cf51e$export$a78d1842153dea18);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $eUtBU = parcelRequire("eUtBU");

var $a5rmN = parcelRequire("a5rmN");

var $9oAqi = parcelRequire("9oAqi");

var $7y0BG = parcelRequire("7y0BG");

var $7otWv = parcelRequire("7otWv");

var $8DGYe = parcelRequire("8DGYe");
const $e343bad68e2cf51e$export$a78d1842153dea18 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $gpjDl.default)();
    const { isInsideTask: isInsideTask } = (0, $9oAqi.useSharedPluginStateWithSelector)(api, [
        'taskDecision'
    ], (states)=>{
        var _states$taskDecisionS;
        return {
            isInsideTask: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
        };
    });
    const handleClick = ()=>{
        var _api$taskDecision;
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 ? void 0 : _api$taskDecision.commands.toggleTaskList());
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7otWv.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7y0BG))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $3LM7S.jsx)((0, $8DGYe.ToolbarKeyboardShortcutHint), {
            shortcut: (0, $eUtBU.formatShortcut)((0, $eUtBU.toggleTaskList))
        }),
        isSelected: isInsideTask,
        onClick: handleClick,
        ariaKeyshortcuts: (0, $eUtBU.formatShortcut)((0, $eUtBU.toggleTaskList)),
        children: formatMessage((0, $a5rmN.tasksAndDecisionsMessages).taskList)
    });
};

});


parcelRegister("b1B1S", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee5ed544291c906c$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $96Lo5 = parcelRequire("96Lo5");

var $cT0LQ = parcelRequire("cT0LQ");

var $7h5CJ = parcelRequire("7h5CJ");

var $8Pw71 = parcelRequire("8Pw71");

var $8ZI3Z = parcelRequire("8ZI3Z");
const $ee5ed544291c906c$var$ToolbarDecision = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorView: editorView, editorAPI: editorAPI })=>{
    const label = formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).decision);
    const handleInsertDecision = ()=>{
        var _editorAPI$analytics;
        if (!editorView) return false;
        const getContextIdentifier = ()=>{
            var _editorAPI$contextIde;
            return editorAPI === null || editorAPI === void 0 || (_editorAPI$contextIde = editorAPI.contextIdentifier) === null || _editorAPI$contextIde === void 0 || (_editorAPI$contextIde = _editorAPI$contextIde.sharedState.currentState()) === null || _editorAPI$contextIde === void 0 ? void 0 : _editorAPI$contextIde.contextIdentifierProvider;
        };
        (0, $8ZI3Z.insertTaskDecisionCommand)(editorAPI === null || editorAPI === void 0 || (_editorAPI$analytics = editorAPI.analytics) === null || _editorAPI$analytics === void 0 ? void 0 : _editorAPI$analytics.actions, getContextIdentifier)('decisionList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7h5CJ.default), {
        buttonId: (0, $96Lo5.TOOLBAR_ACTION_SUBJECT_ID).DECISION_LIST,
        onClick: handleInsertDecision,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} <>`,
        "aria-keyshortcuts": "Shift+, Shift+. space",
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Pw71))), {
            label: label
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $ee5ed544291c906c$var$_default_1 = (0, $fcCIH.default)($ee5ed544291c906c$var$ToolbarDecision);
var $ee5ed544291c906c$export$2e2bcd8739ae039 = $ee5ed544291c906c$var$_default_1;

});

parcelRegister("hb6B4", function(module, exports) {
$parcel$export(module.exports, "default", () => $17cee223a56851c6$export$2e2bcd8739ae039);

var $3LM7S = parcelRequire("3LM7S");
parcelRequire("fc4bM");

var $fcCIH = parcelRequire("fcCIH");

var $96Lo5 = parcelRequire("96Lo5");

var $cT0LQ = parcelRequire("cT0LQ");

var $7h5CJ = parcelRequire("7h5CJ");

var $c5TKa = parcelRequire("c5TKa");

var $8ZI3Z = parcelRequire("8ZI3Z");
const $17cee223a56851c6$var$ToolbarTask = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorAPI: editorAPI, editorView: editorView })=>{
    const label = formatMessage((0, $cT0LQ.toolbarInsertBlockMessages).action);
    const handleInsertTask = ()=>{
        var _editorAPI$analytics;
        if (!editorView) return false;
        const getContextIdentifier = ()=>{
            var _editorAPI$contextIde;
            return editorAPI === null || editorAPI === void 0 || (_editorAPI$contextIde = editorAPI.contextIdentifier) === null || _editorAPI$contextIde === void 0 || (_editorAPI$contextIde = _editorAPI$contextIde.sharedState.currentState()) === null || _editorAPI$contextIde === void 0 ? void 0 : _editorAPI$contextIde.contextIdentifierProvider;
        };
        (0, $8ZI3Z.insertTaskDecisionCommand)(editorAPI === null || editorAPI === void 0 || (_editorAPI$analytics = editorAPI.analytics) === null || _editorAPI$analytics === void 0 ? void 0 : _editorAPI$analytics.actions, getContextIdentifier)('taskList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $3LM7S.jsx)((0, $7h5CJ.default), {
        buttonId: (0, $96Lo5.TOOLBAR_ACTION_SUBJECT_ID).TASK_LIST,
        onClick: handleInsertTask,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} []`,
        iconBefore: /*#__PURE__*/ (0, $3LM7S.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c5TKa))), {
            label: label
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $17cee223a56851c6$var$_default_1 = (0, $fcCIH.default)($17cee223a56851c6$var$ToolbarTask);
var $17cee223a56851c6$export$2e2bcd8739ae039 = $17cee223a56851c6$var$_default_1;

});


parcelRegister("lfe2F", function(module, exports) {
$parcel$export(module.exports, "ufoPlugin", () => $91018ceb18427bb8$export$e137bce9a5077ae5);

var $cQntn = parcelRequire("cQntn");
const $91018ceb18427bb8$export$e137bce9a5077ae5 = ()=>({
        name: 'ufo',
        pmPlugins () {
            const isSSR = Boolean(undefined);
            if (isSSR) // This plugin is not needed in SSR environments - and uses apis which are not available in SSR internally
            return [];
            return [
                {
                    name: 'traceUFOInteractionOnFirstInteraction',
                    plugin: (0, $cQntn.traceUFOInteractionOnFirstInteraction)
                }
            ];
        }
    });

});
parcelRegister("cQntn", function(module, exports) {
$parcel$export(module.exports, "traceUFOInteractionOnFirstInteraction", () => $893b960c3bad798d$export$abe7f7e3118e197d);

var $1y7gE = parcelRequire("1y7gE");

var $dMk6i = parcelRequire("dMk6i");

var $ljn7y = parcelRequire("ljn7y");

var $jQYQa = parcelRequire("jQYQa");
const $893b960c3bad798d$export$abe7f7e3118e197d = ()=>{
    return new (0, $1y7gE.SafePlugin)({
        view () {
            let aborted = false;
            return {
                update (view, prevState) {
                    if (aborted) // opt out of additional logic if already aborted
                    return;
                    if (!view.state.selection.eq(prevState.selection) && !(0, $dMk6i.atTheBeginningOfDoc)(view.state) && !(0, $ljn7y.isEmptyDocument)(view.state.doc)) {
                        const activeInteraction = (0, $jQYQa.getActiveInteraction)();
                        if (activeInteraction && [
                            'edit-page',
                            'live-edit'
                        ].includes(activeInteraction.ufoName)) (0, $jQYQa.abortAll)('new_interaction', `selection-changed-on-editor-element`);
                        aborted = true;
                    }
                }
            };
        }
    });
};

});



//# sourceMappingURL=shared.cbe24287.js.map
